
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire41cc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire41cc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lHU4h", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $fcd91b0c4a85487c$export$dca3b0875bd9a954; }, function (v) { return $fcd91b0c4a85487c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $fcd91b0c4a85487c$export$16fa2f45be04daa8; }, function (v) { return $fcd91b0c4a85487c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fcd91b0c4a85487c$export$ffb0004e005737fa; }, function (v) { return $fcd91b0c4a85487c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $fcd91b0c4a85487c$export$e2c29f18771995cb; }, function (v) { return $fcd91b0c4a85487c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $fcd91b0c4a85487c$export$221d75b3f55bb0bd; }, function (v) { return $fcd91b0c4a85487c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fcd91b0c4a85487c$export$5f8d39834fd61797; }, function (v) { return $fcd91b0c4a85487c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fcd91b0c4a85487c$export$74bf444e3cd11ea5; }, function (v) { return $fcd91b0c4a85487c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $fcd91b0c4a85487c$export$1ced07cd6b1985ce; }, function (v) { return $fcd91b0c4a85487c$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $fcd91b0c4a85487c$export$abd8e32b826d7ea7; }, function (v) { return $fcd91b0c4a85487c$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $fcd91b0c4a85487c$export$69a3209f1a06c04d; }, function (v) { return $fcd91b0c4a85487c$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $fcd91b0c4a85487c$export$e530037191fcd5d7; }, function (v) { return $fcd91b0c4a85487c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $fcd91b0c4a85487c$export$fd42f52fd3ae1109; }, function (v) { return $fcd91b0c4a85487c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $fcd91b0c4a85487c$export$c8a8987d4410bf2d; }, function (v) { return $fcd91b0c4a85487c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $fcd91b0c4a85487c$export$7d1e3a5e95ceca43; }, function (v) { return $fcd91b0c4a85487c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $fcd91b0c4a85487c$export$257a8862b851cb5b; }, function (v) { return $fcd91b0c4a85487c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $fcd91b0c4a85487c$export$a8257692ac88316c; }, function (v) { return $fcd91b0c4a85487c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $fcd91b0c4a85487c$export$488013bae63b21da; }, function (v) { return $fcd91b0c4a85487c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $fcd91b0c4a85487c$export$7c73462e0d25e514; }, function (v) { return $fcd91b0c4a85487c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $fcd91b0c4a85487c$export$7568632d0d33d16d; }, function (v) { return $fcd91b0c4a85487c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $fcd91b0c4a85487c$export$f93f40ac0ca7e3a8; }, function (v) { return $fcd91b0c4a85487c$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $fcd91b0c4a85487c$export$1f96ae73734a86cc; }, function (v) { return $fcd91b0c4a85487c$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $fcd91b0c4a85487c$export$9a47ced3238df325; }, function (v) { return $fcd91b0c4a85487c$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $fcd91b0c4a85487c$export$35808ee640e87ca7; }, function (v) { return $fcd91b0c4a85487c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $fcd91b0c4a85487c$export$fae74005e78b1a27; }, function (v) { return $fcd91b0c4a85487c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $fcd91b0c4a85487c$export$dc8fbce3eb94dc1e; }, function (v) { return $fcd91b0c4a85487c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $fcd91b0c4a85487c$export$6a7bc4e911dc01cf; }, function (v) { return $fcd91b0c4a85487c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $fcd91b0c4a85487c$export$6d9c69b0de29b591; }, function (v) { return $fcd91b0c4a85487c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $fcd91b0c4a85487c$export$f680877a34711e37; }, function (v) { return $fcd91b0c4a85487c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $fcd91b0c4a85487c$export$d5a552a76deda3c2; }, function (v) { return $fcd91b0c4a85487c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $fcd91b0c4a85487c$export$aaabe4eda9ed9969; }, function (v) { return $fcd91b0c4a85487c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $fcd91b0c4a85487c$export$e5c5a5f917a5871c; }, function (v) { return $fcd91b0c4a85487c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $fcd91b0c4a85487c$export$1538c33de8887b59; }, function (v) { return $fcd91b0c4a85487c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $fcd91b0c4a85487c$export$fca7f784ae7a249a; }, function (v) { return $fcd91b0c4a85487c$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $fcd91b0c4a85487c$export$13e3392192263954; }, function (v) { return $fcd91b0c4a85487c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $fcd91b0c4a85487c$export$b8f5890fc79d6aca; }, function (v) { return $fcd91b0c4a85487c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $fcd91b0c4a85487c$export$60241385465d0a34; }, function (v) { return $fcd91b0c4a85487c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $fcd91b0c4a85487c$export$306c0aa65ff9ec16; }, function (v) { return $fcd91b0c4a85487c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $fcd91b0c4a85487c$export$7b286972b8d8ccbf; }, function (v) { return $fcd91b0c4a85487c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $fcd91b0c4a85487c$export$83d89fbfd8236492; }, function (v) { return $fcd91b0c4a85487c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fcd91b0c4a85487c$export$dca3b0875bd9a954;
var $fcd91b0c4a85487c$export$16fa2f45be04daa8;
var $fcd91b0c4a85487c$export$ffb0004e005737fa;
var $fcd91b0c4a85487c$export$e2c29f18771995cb;
var $fcd91b0c4a85487c$export$221d75b3f55bb0bd;
var $fcd91b0c4a85487c$export$5f8d39834fd61797;
var $fcd91b0c4a85487c$export$74bf444e3cd11ea5;
var $fcd91b0c4a85487c$export$1ced07cd6b1985ce;
var $fcd91b0c4a85487c$export$abd8e32b826d7ea7;
var $fcd91b0c4a85487c$export$69a3209f1a06c04d;
var $fcd91b0c4a85487c$export$e530037191fcd5d7;
var $fcd91b0c4a85487c$export$fd42f52fd3ae1109;
var $fcd91b0c4a85487c$export$c8a8987d4410bf2d;
var $fcd91b0c4a85487c$export$7d1e3a5e95ceca43;
var $fcd91b0c4a85487c$export$257a8862b851cb5b;
var $fcd91b0c4a85487c$export$a8257692ac88316c;
var $fcd91b0c4a85487c$export$488013bae63b21da;
var $fcd91b0c4a85487c$export$7c73462e0d25e514;
var $fcd91b0c4a85487c$export$7568632d0d33d16d;
var $fcd91b0c4a85487c$export$f93f40ac0ca7e3a8;
var $fcd91b0c4a85487c$export$1f96ae73734a86cc;
var $fcd91b0c4a85487c$export$9a47ced3238df325;
var $fcd91b0c4a85487c$export$35808ee640e87ca7;
var $fcd91b0c4a85487c$export$fae74005e78b1a27;
var $fcd91b0c4a85487c$export$dc8fbce3eb94dc1e;
var $fcd91b0c4a85487c$export$6a7bc4e911dc01cf;
var $fcd91b0c4a85487c$export$6d9c69b0de29b591;
var $fcd91b0c4a85487c$export$f680877a34711e37;
var $fcd91b0c4a85487c$export$d5a552a76deda3c2;
var $fcd91b0c4a85487c$export$aaabe4eda9ed9969;
var $fcd91b0c4a85487c$export$e5c5a5f917a5871c;
var $fcd91b0c4a85487c$export$1538c33de8887b59;
var $fcd91b0c4a85487c$export$fca7f784ae7a249a;
var $fcd91b0c4a85487c$export$13e3392192263954;
var $fcd91b0c4a85487c$export$b8f5890fc79d6aca;
var $fcd91b0c4a85487c$export$60241385465d0a34;
var $fcd91b0c4a85487c$export$306c0aa65ff9ec16;
var $fcd91b0c4a85487c$export$7b286972b8d8ccbf;
var $fcd91b0c4a85487c$export$83d89fbfd8236492;
"use strict";
var $fcd91b0c4a85487c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $fcd91b0c4a85487c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $fcd91b0c4a85487c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $fcd91b0c4a85487c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $fcd91b0c4a85487c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $fcd91b0c4a85487c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $fcd91b0c4a85487c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $fcd91b0c4a85487c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $fcd91b0c4a85487c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $fcd91b0c4a85487c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $fcd91b0c4a85487c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $fcd91b0c4a85487c$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $fcd91b0c4a85487c$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $fcd91b0c4a85487c$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$fcd91b0c4a85487c$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $fcd91b0c4a85487c$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $fcd91b0c4a85487c$var$assign = Object.assign, $fcd91b0c4a85487c$var$emptyObject = {};
function $fcd91b0c4a85487c$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $fcd91b0c4a85487c$var$emptyObject;
    this.updater = updater || $fcd91b0c4a85487c$var$ReactNoopUpdateQueue;
}
$fcd91b0c4a85487c$var$Component.prototype.isReactComponent = {};
$fcd91b0c4a85487c$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$fcd91b0c4a85487c$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $fcd91b0c4a85487c$var$ComponentDummy() {}
$fcd91b0c4a85487c$var$ComponentDummy.prototype = $fcd91b0c4a85487c$var$Component.prototype;
function $fcd91b0c4a85487c$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $fcd91b0c4a85487c$var$emptyObject;
    this.updater = updater || $fcd91b0c4a85487c$var$ReactNoopUpdateQueue;
}
var $fcd91b0c4a85487c$var$pureComponentPrototype = $fcd91b0c4a85487c$var$PureComponent.prototype = new $fcd91b0c4a85487c$var$ComponentDummy();
$fcd91b0c4a85487c$var$pureComponentPrototype.constructor = $fcd91b0c4a85487c$var$PureComponent;
$fcd91b0c4a85487c$var$assign($fcd91b0c4a85487c$var$pureComponentPrototype, $fcd91b0c4a85487c$var$Component.prototype);
$fcd91b0c4a85487c$var$pureComponentPrototype.isPureReactComponent = !0;
var $fcd91b0c4a85487c$var$isArrayImpl = Array.isArray, $fcd91b0c4a85487c$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $fcd91b0c4a85487c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $fcd91b0c4a85487c$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $fcd91b0c4a85487c$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $fcd91b0c4a85487c$var$cloneAndReplaceKey(oldElement, newKey) {
    return $fcd91b0c4a85487c$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $fcd91b0c4a85487c$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $fcd91b0c4a85487c$var$REACT_ELEMENT_TYPE;
}
function $fcd91b0c4a85487c$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $fcd91b0c4a85487c$var$userProvidedKeyEscapeRegex = /\/+/g;
function $fcd91b0c4a85487c$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $fcd91b0c4a85487c$var$escape("" + element.key) : index.toString(36);
}
function $fcd91b0c4a85487c$var$noop$1() {}
function $fcd91b0c4a85487c$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($fcd91b0c4a85487c$var$noop$1, $fcd91b0c4a85487c$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $fcd91b0c4a85487c$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $fcd91b0c4a85487c$var$REACT_ELEMENT_TYPE:
                case $fcd91b0c4a85487c$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $fcd91b0c4a85487c$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $fcd91b0c4a85487c$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $fcd91b0c4a85487c$var$getElementKey(children, 0) : nameSoFar, $fcd91b0c4a85487c$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($fcd91b0c4a85487c$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $fcd91b0c4a85487c$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($fcd91b0c4a85487c$var$isValidElement(callback) && (callback = $fcd91b0c4a85487c$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($fcd91b0c4a85487c$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($fcd91b0c4a85487c$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $fcd91b0c4a85487c$var$getElementKey(nameSoFar, i), invokeCallback += $fcd91b0c4a85487c$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $fcd91b0c4a85487c$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $fcd91b0c4a85487c$var$getElementKey(nameSoFar, i++), invokeCallback += $fcd91b0c4a85487c$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $fcd91b0c4a85487c$var$mapIntoArray($fcd91b0c4a85487c$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $fcd91b0c4a85487c$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $fcd91b0c4a85487c$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $fcd91b0c4a85487c$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $fcd91b0c4a85487c$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $fcd91b0c4a85487c$var$noop() {}
$fcd91b0c4a85487c$export$dca3b0875bd9a954 = {
    map: $fcd91b0c4a85487c$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $fcd91b0c4a85487c$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $fcd91b0c4a85487c$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $fcd91b0c4a85487c$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$fcd91b0c4a85487c$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$fcd91b0c4a85487c$export$16fa2f45be04daa8 = $fcd91b0c4a85487c$var$Component;
$fcd91b0c4a85487c$export$ffb0004e005737fa = $fcd91b0c4a85487c$var$REACT_FRAGMENT_TYPE;
$fcd91b0c4a85487c$export$e2c29f18771995cb = $fcd91b0c4a85487c$var$REACT_PROFILER_TYPE;
$fcd91b0c4a85487c$export$221d75b3f55bb0bd = $fcd91b0c4a85487c$var$PureComponent;
$fcd91b0c4a85487c$export$5f8d39834fd61797 = $fcd91b0c4a85487c$var$REACT_STRICT_MODE_TYPE;
$fcd91b0c4a85487c$export$74bf444e3cd11ea5 = $fcd91b0c4a85487c$var$REACT_SUSPENSE_TYPE;
$fcd91b0c4a85487c$export$1ced07cd6b1985ce = $fcd91b0c4a85487c$var$ReactSharedInternals;
$fcd91b0c4a85487c$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$fcd91b0c4a85487c$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$fcd91b0c4a85487c$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $fcd91b0c4a85487c$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$fcd91b0c4a85487c$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $fcd91b0c4a85487c$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$fcd91b0c4a85487c$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $fcd91b0c4a85487c$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $fcd91b0c4a85487c$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$fcd91b0c4a85487c$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$fcd91b0c4a85487c$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $fcd91b0c4a85487c$var$ReactElement(type, key, void 0, void 0, null, props);
};
$fcd91b0c4a85487c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$fcd91b0c4a85487c$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $fcd91b0c4a85487c$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$fcd91b0c4a85487c$export$a8257692ac88316c = $fcd91b0c4a85487c$var$isValidElement;
$fcd91b0c4a85487c$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $fcd91b0c4a85487c$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $fcd91b0c4a85487c$var$lazyInitializer
    };
};
$fcd91b0c4a85487c$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $fcd91b0c4a85487c$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$fcd91b0c4a85487c$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $fcd91b0c4a85487c$var$ReactSharedInternals.T, currentTransition = {};
    $fcd91b0c4a85487c$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $fcd91b0c4a85487c$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($fcd91b0c4a85487c$var$noop, $fcd91b0c4a85487c$var$reportGlobalError);
    } catch (error) {
        $fcd91b0c4a85487c$var$reportGlobalError(error);
    } finally{
        $fcd91b0c4a85487c$var$ReactSharedInternals.T = prevTransition;
    }
};
$fcd91b0c4a85487c$export$f93f40ac0ca7e3a8 = function() {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useCacheRefresh();
};
$fcd91b0c4a85487c$export$1f96ae73734a86cc = function(usable) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.use(usable);
};
$fcd91b0c4a85487c$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$fcd91b0c4a85487c$export$35808ee640e87ca7 = function(callback, deps) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$fcd91b0c4a85487c$export$fae74005e78b1a27 = function(Context) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useContext(Context);
};
$fcd91b0c4a85487c$export$dc8fbce3eb94dc1e = function() {};
$fcd91b0c4a85487c$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$fcd91b0c4a85487c$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $fcd91b0c4a85487c$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$fcd91b0c4a85487c$export$f680877a34711e37 = function() {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useId();
};
$fcd91b0c4a85487c$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$fcd91b0c4a85487c$export$aaabe4eda9ed9969 = function(create, deps) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$fcd91b0c4a85487c$export$e5c5a5f917a5871c = function(create, deps) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$fcd91b0c4a85487c$export$1538c33de8887b59 = function(create, deps) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useMemo(create, deps);
};
$fcd91b0c4a85487c$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$fcd91b0c4a85487c$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$fcd91b0c4a85487c$export$b8f5890fc79d6aca = function(initialValue) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useRef(initialValue);
};
$fcd91b0c4a85487c$export$60241385465d0a34 = function(initialState) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useState(initialState);
};
$fcd91b0c4a85487c$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$fcd91b0c4a85487c$export$7b286972b8d8ccbf = function() {
    return $fcd91b0c4a85487c$var$ReactSharedInternals.H.useTransition();
};
$fcd91b0c4a85487c$export$83d89fbfd8236492 = "19.1.0";

});

parcelRegister("eVlbW", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $add6d3ca4f7ece3e$export$882461b6382ed46c; }, function (v) { return $add6d3ca4f7ece3e$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $add6d3ca4f7ece3e$export$757ceba2d55c277e; }, function (v) { return $add6d3ca4f7ece3e$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $add6d3ca4f7ece3e$export$83d89fbfd8236492; }, function (v) { return $add6d3ca4f7ece3e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $add6d3ca4f7ece3e$export$882461b6382ed46c;
var $add6d3ca4f7ece3e$export$757ceba2d55c277e;
var $add6d3ca4f7ece3e$export$83d89fbfd8236492;
"use strict";

var $7ZzgL = parcelRequire("7ZzgL");

var $6uYXW = parcelRequire("6uYXW");

var $6JczY = parcelRequire("6JczY");
function $add6d3ca4f7ece3e$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $add6d3ca4f7ece3e$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $add6d3ca4f7ece3e$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $add6d3ca4f7ece3e$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $add6d3ca4f7ece3e$var$assertIsMounted(fiber) {
    if ($add6d3ca4f7ece3e$var$getNearestMountedFiber(fiber) !== fiber) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(188));
}
function $add6d3ca4f7ece3e$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $add6d3ca4f7ece3e$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $add6d3ca4f7ece3e$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $add6d3ca4f7ece3e$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $add6d3ca4f7ece3e$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $add6d3ca4f7ece3e$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $add6d3ca4f7ece3e$var$assign = Object.assign, $add6d3ca4f7ece3e$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $add6d3ca4f7ece3e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $add6d3ca4f7ece3e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $add6d3ca4f7ece3e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $add6d3ca4f7ece3e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $add6d3ca4f7ece3e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $add6d3ca4f7ece3e$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $add6d3ca4f7ece3e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $add6d3ca4f7ece3e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $add6d3ca4f7ece3e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $add6d3ca4f7ece3e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $add6d3ca4f7ece3e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $add6d3ca4f7ece3e$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $add6d3ca4f7ece3e$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $add6d3ca4f7ece3e$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $add6d3ca4f7ece3e$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $add6d3ca4f7ece3e$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$add6d3ca4f7ece3e$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $add6d3ca4f7ece3e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $add6d3ca4f7ece3e$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $add6d3ca4f7ece3e$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $add6d3ca4f7ece3e$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $add6d3ca4f7ece3e$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $add6d3ca4f7ece3e$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $add6d3ca4f7ece3e$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $add6d3ca4f7ece3e$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $add6d3ca4f7ece3e$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $add6d3ca4f7ece3e$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $add6d3ca4f7ece3e$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $add6d3ca4f7ece3e$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $add6d3ca4f7ece3e$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $add6d3ca4f7ece3e$var$getComponentNameFromType(type.type) || "Memo";
        case $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $add6d3ca4f7ece3e$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $add6d3ca4f7ece3e$var$isArrayImpl = Array.isArray, $add6d3ca4f7ece3e$var$ReactSharedInternals = $6uYXW.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $add6d3ca4f7ece3e$var$ReactDOMSharedInternals = $6JczY.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $add6d3ca4f7ece3e$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $add6d3ca4f7ece3e$var$valueStack = [], $add6d3ca4f7ece3e$var$index = -1;
function $add6d3ca4f7ece3e$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $add6d3ca4f7ece3e$var$pop(cursor) {
    0 > $add6d3ca4f7ece3e$var$index || (cursor.current = $add6d3ca4f7ece3e$var$valueStack[$add6d3ca4f7ece3e$var$index], $add6d3ca4f7ece3e$var$valueStack[$add6d3ca4f7ece3e$var$index] = null, $add6d3ca4f7ece3e$var$index--);
}
function $add6d3ca4f7ece3e$var$push(cursor, value) {
    $add6d3ca4f7ece3e$var$index++;
    $add6d3ca4f7ece3e$var$valueStack[$add6d3ca4f7ece3e$var$index] = cursor.current;
    cursor.current = value;
}
var $add6d3ca4f7ece3e$var$contextStackCursor = $add6d3ca4f7ece3e$var$createCursor(null), $add6d3ca4f7ece3e$var$contextFiberStackCursor = $add6d3ca4f7ece3e$var$createCursor(null), $add6d3ca4f7ece3e$var$rootInstanceStackCursor = $add6d3ca4f7ece3e$var$createCursor(null), $add6d3ca4f7ece3e$var$hostTransitionProviderCursor = $add6d3ca4f7ece3e$var$createCursor(null);
function $add6d3ca4f7ece3e$var$pushHostContainer(fiber, nextRootInstance) {
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$rootInstanceStackCursor, nextRootInstance);
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$contextFiberStackCursor, fiber);
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $add6d3ca4f7ece3e$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $add6d3ca4f7ece3e$var$getOwnHostContext(nextRootInstance), fiber = $add6d3ca4f7ece3e$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$contextStackCursor);
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$contextStackCursor, fiber);
}
function $add6d3ca4f7ece3e$var$popHostContainer() {
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$contextStackCursor);
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$contextFiberStackCursor);
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$rootInstanceStackCursor);
}
function $add6d3ca4f7ece3e$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$hostTransitionProviderCursor, fiber);
    var context = $add6d3ca4f7ece3e$var$contextStackCursor.current;
    var JSCompiler_inline_result = $add6d3ca4f7ece3e$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$contextFiberStackCursor, fiber), $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$contextStackCursor, JSCompiler_inline_result));
}
function $add6d3ca4f7ece3e$var$popHostContext(fiber) {
    $add6d3ca4f7ece3e$var$contextFiberStackCursor.current === fiber && ($add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$contextStackCursor), $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$contextFiberStackCursor));
    $add6d3ca4f7ece3e$var$hostTransitionProviderCursor.current === fiber && ($add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$hostTransitionProviderCursor), $add6d3ca4f7ece3e$var$HostTransitionContext._currentValue = $add6d3ca4f7ece3e$var$sharedNotPendingObject);
}
var $add6d3ca4f7ece3e$var$hasOwnProperty = Object.prototype.hasOwnProperty, $add6d3ca4f7ece3e$var$scheduleCallback$3 = $7ZzgL.unstable_scheduleCallback, $add6d3ca4f7ece3e$var$cancelCallback$1 = $7ZzgL.unstable_cancelCallback, $add6d3ca4f7ece3e$var$shouldYield = $7ZzgL.unstable_shouldYield, $add6d3ca4f7ece3e$var$requestPaint = $7ZzgL.unstable_requestPaint, $add6d3ca4f7ece3e$var$now = $7ZzgL.unstable_now, $add6d3ca4f7ece3e$var$getCurrentPriorityLevel = $7ZzgL.unstable_getCurrentPriorityLevel, $add6d3ca4f7ece3e$var$ImmediatePriority = $7ZzgL.unstable_ImmediatePriority, $add6d3ca4f7ece3e$var$UserBlockingPriority = $7ZzgL.unstable_UserBlockingPriority, $add6d3ca4f7ece3e$var$NormalPriority$1 = $7ZzgL.unstable_NormalPriority, $add6d3ca4f7ece3e$var$LowPriority = $7ZzgL.unstable_LowPriority, $add6d3ca4f7ece3e$var$IdlePriority = $7ZzgL.unstable_IdlePriority, $add6d3ca4f7ece3e$var$log$1 = $7ZzgL.log, $add6d3ca4f7ece3e$var$unstable_setDisableYieldValue = $7ZzgL.unstable_setDisableYieldValue, $add6d3ca4f7ece3e$var$rendererID = null, $add6d3ca4f7ece3e$var$injectedHook = null;
function $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $add6d3ca4f7ece3e$var$log$1 && $add6d3ca4f7ece3e$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($add6d3ca4f7ece3e$var$injectedHook && "function" === typeof $add6d3ca4f7ece3e$var$injectedHook.setStrictMode) try {
        $add6d3ca4f7ece3e$var$injectedHook.setStrictMode($add6d3ca4f7ece3e$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $add6d3ca4f7ece3e$var$clz32 = Math.clz32 ? Math.clz32 : $add6d3ca4f7ece3e$var$clz32Fallback, $add6d3ca4f7ece3e$var$log = Math.log, $add6d3ca4f7ece3e$var$LN2 = Math.LN2;
function $add6d3ca4f7ece3e$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($add6d3ca4f7ece3e$var$log(x) / $add6d3ca4f7ece3e$var$LN2 | 0) | 0;
}
var $add6d3ca4f7ece3e$var$nextTransitionLane = 256, $add6d3ca4f7ece3e$var$nextRetryLane = 4194304;
function $add6d3ca4f7ece3e$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $add6d3ca4f7ece3e$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $add6d3ca4f7ece3e$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $add6d3ca4f7ece3e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $add6d3ca4f7ece3e$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $add6d3ca4f7ece3e$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $add6d3ca4f7ece3e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $add6d3ca4f7ece3e$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $add6d3ca4f7ece3e$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $add6d3ca4f7ece3e$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $add6d3ca4f7ece3e$var$claimNextTransitionLane() {
    var lane = $add6d3ca4f7ece3e$var$nextTransitionLane;
    $add6d3ca4f7ece3e$var$nextTransitionLane <<= 1;
    0 === ($add6d3ca4f7ece3e$var$nextTransitionLane & 4194048) && ($add6d3ca4f7ece3e$var$nextTransitionLane = 256);
    return lane;
}
function $add6d3ca4f7ece3e$var$claimNextRetryLane() {
    var lane = $add6d3ca4f7ece3e$var$nextRetryLane;
    $add6d3ca4f7ece3e$var$nextRetryLane <<= 1;
    0 === ($add6d3ca4f7ece3e$var$nextRetryLane & 62914560) && ($add6d3ca4f7ece3e$var$nextRetryLane = 4194304);
    return lane;
}
function $add6d3ca4f7ece3e$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $add6d3ca4f7ece3e$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $add6d3ca4f7ece3e$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $add6d3ca4f7ece3e$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $add6d3ca4f7ece3e$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $add6d3ca4f7ece3e$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $add6d3ca4f7ece3e$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $add6d3ca4f7ece3e$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $add6d3ca4f7ece3e$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $add6d3ca4f7ece3e$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $add6d3ca4f7ece3e$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $add6d3ca4f7ece3e$var$resolveUpdatePriority() {
    var updatePriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $add6d3ca4f7ece3e$var$getEventPriority(updatePriority.type);
}
function $add6d3ca4f7ece3e$var$runWithPriority(priority, fn) {
    var previousPriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
    try {
        return $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $add6d3ca4f7ece3e$var$randomKey = Math.random().toString(36).slice(2), $add6d3ca4f7ece3e$var$internalInstanceKey = "__reactFiber$" + $add6d3ca4f7ece3e$var$randomKey, $add6d3ca4f7ece3e$var$internalPropsKey = "__reactProps$" + $add6d3ca4f7ece3e$var$randomKey, $add6d3ca4f7ece3e$var$internalContainerInstanceKey = "__reactContainer$" + $add6d3ca4f7ece3e$var$randomKey, $add6d3ca4f7ece3e$var$internalEventHandlersKey = "__reactEvents$" + $add6d3ca4f7ece3e$var$randomKey, $add6d3ca4f7ece3e$var$internalEventHandlerListenersKey = "__reactListeners$" + $add6d3ca4f7ece3e$var$randomKey, $add6d3ca4f7ece3e$var$internalEventHandlesSetKey = "__reactHandles$" + $add6d3ca4f7ece3e$var$randomKey, $add6d3ca4f7ece3e$var$internalRootNodeResourcesKey = "__reactResources$" + $add6d3ca4f7ece3e$var$randomKey, $add6d3ca4f7ece3e$var$internalHoistableMarker = "__reactMarker$" + $add6d3ca4f7ece3e$var$randomKey;
function $add6d3ca4f7ece3e$var$detachDeletedInstance(node) {
    delete node[$add6d3ca4f7ece3e$var$internalInstanceKey];
    delete node[$add6d3ca4f7ece3e$var$internalPropsKey];
    delete node[$add6d3ca4f7ece3e$var$internalEventHandlersKey];
    delete node[$add6d3ca4f7ece3e$var$internalEventHandlerListenersKey];
    delete node[$add6d3ca4f7ece3e$var$internalEventHandlesSetKey];
}
function $add6d3ca4f7ece3e$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$add6d3ca4f7ece3e$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$add6d3ca4f7ece3e$var$internalContainerInstanceKey] || parentNode[$add6d3ca4f7ece3e$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $add6d3ca4f7ece3e$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$add6d3ca4f7ece3e$var$internalInstanceKey]) return parentNode;
                targetNode = $add6d3ca4f7ece3e$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $add6d3ca4f7ece3e$var$getInstanceFromNode(node) {
    if (node = node[$add6d3ca4f7ece3e$var$internalInstanceKey] || node[$add6d3ca4f7ece3e$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $add6d3ca4f7ece3e$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(33));
}
function $add6d3ca4f7ece3e$var$getResourcesFromRoot(root) {
    var resources = root[$add6d3ca4f7ece3e$var$internalRootNodeResourcesKey];
    resources || (resources = root[$add6d3ca4f7ece3e$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $add6d3ca4f7ece3e$var$markNodeAsHoistable(node) {
    node[$add6d3ca4f7ece3e$var$internalHoistableMarker] = !0;
}
var $add6d3ca4f7ece3e$var$allNativeEvents = new Set(), $add6d3ca4f7ece3e$var$registrationNameDependencies = {};
function $add6d3ca4f7ece3e$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $add6d3ca4f7ece3e$var$registerDirectEvent(registrationName, dependencies);
    $add6d3ca4f7ece3e$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $add6d3ca4f7ece3e$var$registerDirectEvent(registrationName, dependencies) {
    $add6d3ca4f7ece3e$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$add6d3ca4f7ece3e$var$allNativeEvents.add(dependencies[registrationName]);
}
var $add6d3ca4f7ece3e$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $add6d3ca4f7ece3e$var$illegalAttributeNameCache = {}, $add6d3ca4f7ece3e$var$validatedAttributeNameCache = {};
function $add6d3ca4f7ece3e$var$isAttributeNameSafe(attributeName) {
    if ($add6d3ca4f7ece3e$var$hasOwnProperty.call($add6d3ca4f7ece3e$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($add6d3ca4f7ece3e$var$hasOwnProperty.call($add6d3ca4f7ece3e$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($add6d3ca4f7ece3e$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $add6d3ca4f7ece3e$var$validatedAttributeNameCache[attributeName] = !0;
    $add6d3ca4f7ece3e$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $add6d3ca4f7ece3e$var$setValueForAttribute(node, name, value) {
    if ($add6d3ca4f7ece3e$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $add6d3ca4f7ece3e$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $add6d3ca4f7ece3e$var$prefix, $add6d3ca4f7ece3e$var$suffix;
function $add6d3ca4f7ece3e$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $add6d3ca4f7ece3e$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $add6d3ca4f7ece3e$var$prefix = match && match[1] || "";
        $add6d3ca4f7ece3e$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $add6d3ca4f7ece3e$var$prefix + name + $add6d3ca4f7ece3e$var$suffix;
}
var $add6d3ca4f7ece3e$var$reentry = !1;
function $add6d3ca4f7ece3e$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $add6d3ca4f7ece3e$var$reentry) return "";
    $add6d3ca4f7ece3e$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $add6d3ca4f7ece3e$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $add6d3ca4f7ece3e$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $add6d3ca4f7ece3e$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $add6d3ca4f7ece3e$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $add6d3ca4f7ece3e$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $add6d3ca4f7ece3e$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $add6d3ca4f7ece3e$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $add6d3ca4f7ece3e$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $add6d3ca4f7ece3e$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $add6d3ca4f7ece3e$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $add6d3ca4f7ece3e$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $add6d3ca4f7ece3e$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $add6d3ca4f7ece3e$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $add6d3ca4f7ece3e$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $add6d3ca4f7ece3e$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $add6d3ca4f7ece3e$var$trackValueOnNode(node) {
    var valueField = $add6d3ca4f7ece3e$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $add6d3ca4f7ece3e$var$track(node) {
    node._valueTracker || (node._valueTracker = $add6d3ca4f7ece3e$var$trackValueOnNode(node));
}
function $add6d3ca4f7ece3e$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $add6d3ca4f7ece3e$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $add6d3ca4f7ece3e$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $add6d3ca4f7ece3e$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $add6d3ca4f7ece3e$var$getToStringValue(value);
        } else element.value !== "" + $add6d3ca4f7ece3e$var$getToStringValue(value) && (element.value = "" + $add6d3ca4f7ece3e$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $add6d3ca4f7ece3e$var$setDefaultValue(element, type, $add6d3ca4f7ece3e$var$getToStringValue(value)) : null != defaultValue ? $add6d3ca4f7ece3e$var$setDefaultValue(element, type, $add6d3ca4f7ece3e$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $add6d3ca4f7ece3e$var$getToStringValue(name) : element.removeAttribute("name");
}
function $add6d3ca4f7ece3e$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $add6d3ca4f7ece3e$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $add6d3ca4f7ece3e$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $add6d3ca4f7ece3e$var$setDefaultValue(node, type, value) {
    "number" === type && $add6d3ca4f7ece3e$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $add6d3ca4f7ece3e$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $add6d3ca4f7ece3e$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $add6d3ca4f7ece3e$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $add6d3ca4f7ece3e$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $add6d3ca4f7ece3e$var$getToStringValue(defaultValue) : "";
}
function $add6d3ca4f7ece3e$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(92));
            if ($add6d3ca4f7ece3e$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $add6d3ca4f7ece3e$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $add6d3ca4f7ece3e$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $add6d3ca4f7ece3e$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $add6d3ca4f7ece3e$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $add6d3ca4f7ece3e$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $add6d3ca4f7ece3e$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $add6d3ca4f7ece3e$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $add6d3ca4f7ece3e$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $add6d3ca4f7ece3e$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $add6d3ca4f7ece3e$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $add6d3ca4f7ece3e$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $add6d3ca4f7ece3e$var$sanitizeURL(url) {
    return $add6d3ca4f7ece3e$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $add6d3ca4f7ece3e$var$currentReplayingEvent = null;
function $add6d3ca4f7ece3e$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $add6d3ca4f7ece3e$var$restoreTarget = null, $add6d3ca4f7ece3e$var$restoreQueue = null;
function $add6d3ca4f7ece3e$var$restoreStateOfTarget(target) {
    var internalInstance = $add6d3ca4f7ece3e$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$add6d3ca4f7ece3e$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $add6d3ca4f7ece3e$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$add6d3ca4f7ece3e$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(90));
                            $add6d3ca4f7ece3e$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $add6d3ca4f7ece3e$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $add6d3ca4f7ece3e$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $add6d3ca4f7ece3e$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $add6d3ca4f7ece3e$var$isInsideEventHandler = !1;
function $add6d3ca4f7ece3e$var$batchedUpdates$1(fn, a, b) {
    if ($add6d3ca4f7ece3e$var$isInsideEventHandler) return fn(a, b);
    $add6d3ca4f7ece3e$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($add6d3ca4f7ece3e$var$isInsideEventHandler = !1, null !== $add6d3ca4f7ece3e$var$restoreTarget || null !== $add6d3ca4f7ece3e$var$restoreQueue) {
            if ($add6d3ca4f7ece3e$var$flushSyncWork$1(), $add6d3ca4f7ece3e$var$restoreTarget && (a = $add6d3ca4f7ece3e$var$restoreTarget, fn = $add6d3ca4f7ece3e$var$restoreQueue, $add6d3ca4f7ece3e$var$restoreQueue = $add6d3ca4f7ece3e$var$restoreTarget = null, $add6d3ca4f7ece3e$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$add6d3ca4f7ece3e$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $add6d3ca4f7ece3e$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$add6d3ca4f7ece3e$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $add6d3ca4f7ece3e$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $add6d3ca4f7ece3e$var$passiveBrowserEventsSupported = !1;
if ($add6d3ca4f7ece3e$var$canUseDOM) try {
    var $add6d3ca4f7ece3e$var$options = {};
    Object.defineProperty($add6d3ca4f7ece3e$var$options, "passive", {
        get: function() {
            $add6d3ca4f7ece3e$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $add6d3ca4f7ece3e$var$options, $add6d3ca4f7ece3e$var$options);
    window.removeEventListener("test", $add6d3ca4f7ece3e$var$options, $add6d3ca4f7ece3e$var$options);
} catch (e) {
    $add6d3ca4f7ece3e$var$passiveBrowserEventsSupported = !1;
}
var $add6d3ca4f7ece3e$var$root = null, $add6d3ca4f7ece3e$var$startText = null, $add6d3ca4f7ece3e$var$fallbackText = null;
function $add6d3ca4f7ece3e$var$getData() {
    if ($add6d3ca4f7ece3e$var$fallbackText) return $add6d3ca4f7ece3e$var$fallbackText;
    var start, startValue = $add6d3ca4f7ece3e$var$startText, startLength = startValue.length, end, endValue = "value" in $add6d3ca4f7ece3e$var$root ? $add6d3ca4f7ece3e$var$root.value : $add6d3ca4f7ece3e$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $add6d3ca4f7ece3e$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $add6d3ca4f7ece3e$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $add6d3ca4f7ece3e$var$functionThatReturnsTrue() {
    return !0;
}
function $add6d3ca4f7ece3e$var$functionThatReturnsFalse() {
    return !1;
}
function $add6d3ca4f7ece3e$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $add6d3ca4f7ece3e$var$functionThatReturnsTrue : $add6d3ca4f7ece3e$var$functionThatReturnsFalse;
        this.isPropagationStopped = $add6d3ca4f7ece3e$var$functionThatReturnsFalse;
        return this;
    }
    $add6d3ca4f7ece3e$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $add6d3ca4f7ece3e$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $add6d3ca4f7ece3e$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $add6d3ca4f7ece3e$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $add6d3ca4f7ece3e$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $add6d3ca4f7ece3e$var$SyntheticEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$EventInterface), $add6d3ca4f7ece3e$var$UIEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$EventInterface, {
    view: 0,
    detail: 0
}), $add6d3ca4f7ece3e$var$SyntheticUIEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$UIEventInterface), $add6d3ca4f7ece3e$var$lastMovementX, $add6d3ca4f7ece3e$var$lastMovementY, $add6d3ca4f7ece3e$var$lastMouseEvent, $add6d3ca4f7ece3e$var$MouseEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $add6d3ca4f7ece3e$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $add6d3ca4f7ece3e$var$lastMouseEvent && ($add6d3ca4f7ece3e$var$lastMouseEvent && "mousemove" === event.type ? ($add6d3ca4f7ece3e$var$lastMovementX = event.screenX - $add6d3ca4f7ece3e$var$lastMouseEvent.screenX, $add6d3ca4f7ece3e$var$lastMovementY = event.screenY - $add6d3ca4f7ece3e$var$lastMouseEvent.screenY) : $add6d3ca4f7ece3e$var$lastMovementY = $add6d3ca4f7ece3e$var$lastMovementX = 0, $add6d3ca4f7ece3e$var$lastMouseEvent = event);
        return $add6d3ca4f7ece3e$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $add6d3ca4f7ece3e$var$lastMovementY;
    }
}), $add6d3ca4f7ece3e$var$SyntheticMouseEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$MouseEventInterface), $add6d3ca4f7ece3e$var$DragEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$MouseEventInterface, {
    dataTransfer: 0
}), $add6d3ca4f7ece3e$var$SyntheticDragEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$DragEventInterface), $add6d3ca4f7ece3e$var$FocusEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$UIEventInterface, {
    relatedTarget: 0
}), $add6d3ca4f7ece3e$var$SyntheticFocusEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$FocusEventInterface), $add6d3ca4f7ece3e$var$AnimationEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $add6d3ca4f7ece3e$var$SyntheticAnimationEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$AnimationEventInterface), $add6d3ca4f7ece3e$var$ClipboardEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $add6d3ca4f7ece3e$var$SyntheticClipboardEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$ClipboardEventInterface), $add6d3ca4f7ece3e$var$CompositionEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$EventInterface, {
    data: 0
}), $add6d3ca4f7ece3e$var$SyntheticCompositionEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$CompositionEventInterface), $add6d3ca4f7ece3e$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $add6d3ca4f7ece3e$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $add6d3ca4f7ece3e$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $add6d3ca4f7ece3e$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $add6d3ca4f7ece3e$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $add6d3ca4f7ece3e$var$getEventModifierState() {
    return $add6d3ca4f7ece3e$var$modifierStateGetter;
}
var $add6d3ca4f7ece3e$var$KeyboardEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $add6d3ca4f7ece3e$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $add6d3ca4f7ece3e$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $add6d3ca4f7ece3e$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $add6d3ca4f7ece3e$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $add6d3ca4f7ece3e$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $add6d3ca4f7ece3e$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $add6d3ca4f7ece3e$var$SyntheticKeyboardEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$KeyboardEventInterface), $add6d3ca4f7ece3e$var$PointerEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $add6d3ca4f7ece3e$var$SyntheticPointerEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$PointerEventInterface), $add6d3ca4f7ece3e$var$TouchEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $add6d3ca4f7ece3e$var$getEventModifierState
}), $add6d3ca4f7ece3e$var$SyntheticTouchEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$TouchEventInterface), $add6d3ca4f7ece3e$var$TransitionEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $add6d3ca4f7ece3e$var$SyntheticTransitionEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$TransitionEventInterface), $add6d3ca4f7ece3e$var$WheelEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $add6d3ca4f7ece3e$var$SyntheticWheelEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$WheelEventInterface), $add6d3ca4f7ece3e$var$ToggleEventInterface = $add6d3ca4f7ece3e$var$assign({}, $add6d3ca4f7ece3e$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $add6d3ca4f7ece3e$var$SyntheticToggleEvent = $add6d3ca4f7ece3e$var$createSyntheticEvent($add6d3ca4f7ece3e$var$ToggleEventInterface), $add6d3ca4f7ece3e$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $add6d3ca4f7ece3e$var$canUseCompositionEvent = $add6d3ca4f7ece3e$var$canUseDOM && "CompositionEvent" in window, $add6d3ca4f7ece3e$var$documentMode = null;
$add6d3ca4f7ece3e$var$canUseDOM && "documentMode" in document && ($add6d3ca4f7ece3e$var$documentMode = document.documentMode);
var $add6d3ca4f7ece3e$var$canUseTextInputEvent = $add6d3ca4f7ece3e$var$canUseDOM && "TextEvent" in window && !$add6d3ca4f7ece3e$var$documentMode, $add6d3ca4f7ece3e$var$useFallbackCompositionData = $add6d3ca4f7ece3e$var$canUseDOM && (!$add6d3ca4f7ece3e$var$canUseCompositionEvent || $add6d3ca4f7ece3e$var$documentMode && 8 < $add6d3ca4f7ece3e$var$documentMode && 11 >= $add6d3ca4f7ece3e$var$documentMode), $add6d3ca4f7ece3e$var$SPACEBAR_CHAR = String.fromCharCode(32), $add6d3ca4f7ece3e$var$hasSpaceKeypress = !1;
function $add6d3ca4f7ece3e$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $add6d3ca4f7ece3e$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $add6d3ca4f7ece3e$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $add6d3ca4f7ece3e$var$isComposing = !1;
function $add6d3ca4f7ece3e$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $add6d3ca4f7ece3e$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $add6d3ca4f7ece3e$var$hasSpaceKeypress = !0;
            return $add6d3ca4f7ece3e$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $add6d3ca4f7ece3e$var$SPACEBAR_CHAR && $add6d3ca4f7ece3e$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $add6d3ca4f7ece3e$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($add6d3ca4f7ece3e$var$isComposing) return "compositionend" === domEventName || !$add6d3ca4f7ece3e$var$canUseCompositionEvent && $add6d3ca4f7ece3e$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $add6d3ca4f7ece3e$var$getData(), $add6d3ca4f7ece3e$var$fallbackText = $add6d3ca4f7ece3e$var$startText = $add6d3ca4f7ece3e$var$root = null, $add6d3ca4f7ece3e$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $add6d3ca4f7ece3e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $add6d3ca4f7ece3e$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $add6d3ca4f7ece3e$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$add6d3ca4f7ece3e$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $add6d3ca4f7ece3e$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $add6d3ca4f7ece3e$var$restoreTarget ? $add6d3ca4f7ece3e$var$restoreQueue ? $add6d3ca4f7ece3e$var$restoreQueue.push(target) : $add6d3ca4f7ece3e$var$restoreQueue = [
        target
    ] : $add6d3ca4f7ece3e$var$restoreTarget = target;
    inst = $add6d3ca4f7ece3e$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $add6d3ca4f7ece3e$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $add6d3ca4f7ece3e$var$activeElement$1 = null, $add6d3ca4f7ece3e$var$activeElementInst$1 = null;
function $add6d3ca4f7ece3e$var$runEventInBatch(dispatchQueue) {
    $add6d3ca4f7ece3e$var$processDispatchQueue(dispatchQueue, 0);
}
function $add6d3ca4f7ece3e$var$getInstIfValueChanged(targetInst) {
    var targetNode = $add6d3ca4f7ece3e$var$getNodeFromInstance(targetInst);
    if ($add6d3ca4f7ece3e$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $add6d3ca4f7ece3e$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $add6d3ca4f7ece3e$var$isInputEventSupported = !1;
if ($add6d3ca4f7ece3e$var$canUseDOM) {
    var $add6d3ca4f7ece3e$var$JSCompiler_inline_result$jscomp$282;
    if ($add6d3ca4f7ece3e$var$canUseDOM) {
        var $add6d3ca4f7ece3e$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$add6d3ca4f7ece3e$var$isSupported$jscomp$inline_417) {
            var $add6d3ca4f7ece3e$var$element$jscomp$inline_418 = document.createElement("div");
            $add6d3ca4f7ece3e$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $add6d3ca4f7ece3e$var$isSupported$jscomp$inline_417 = "function" === typeof $add6d3ca4f7ece3e$var$element$jscomp$inline_418.oninput;
        }
        $add6d3ca4f7ece3e$var$JSCompiler_inline_result$jscomp$282 = $add6d3ca4f7ece3e$var$isSupported$jscomp$inline_417;
    } else $add6d3ca4f7ece3e$var$JSCompiler_inline_result$jscomp$282 = !1;
    $add6d3ca4f7ece3e$var$isInputEventSupported = $add6d3ca4f7ece3e$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $add6d3ca4f7ece3e$var$stopWatchingForValueChange() {
    $add6d3ca4f7ece3e$var$activeElement$1 && ($add6d3ca4f7ece3e$var$activeElement$1.detachEvent("onpropertychange", $add6d3ca4f7ece3e$var$handlePropertyChange), $add6d3ca4f7ece3e$var$activeElementInst$1 = $add6d3ca4f7ece3e$var$activeElement$1 = null);
}
function $add6d3ca4f7ece3e$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $add6d3ca4f7ece3e$var$getInstIfValueChanged($add6d3ca4f7ece3e$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $add6d3ca4f7ece3e$var$createAndAccumulateChangeEvent(dispatchQueue, $add6d3ca4f7ece3e$var$activeElementInst$1, nativeEvent, $add6d3ca4f7ece3e$var$getEventTarget(nativeEvent));
        $add6d3ca4f7ece3e$var$batchedUpdates$1($add6d3ca4f7ece3e$var$runEventInBatch, dispatchQueue);
    }
}
function $add6d3ca4f7ece3e$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($add6d3ca4f7ece3e$var$stopWatchingForValueChange(), $add6d3ca4f7ece3e$var$activeElement$1 = target, $add6d3ca4f7ece3e$var$activeElementInst$1 = targetInst, $add6d3ca4f7ece3e$var$activeElement$1.attachEvent("onpropertychange", $add6d3ca4f7ece3e$var$handlePropertyChange)) : "focusout" === domEventName && $add6d3ca4f7ece3e$var$stopWatchingForValueChange();
}
function $add6d3ca4f7ece3e$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $add6d3ca4f7ece3e$var$getInstIfValueChanged($add6d3ca4f7ece3e$var$activeElementInst$1);
}
function $add6d3ca4f7ece3e$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $add6d3ca4f7ece3e$var$getInstIfValueChanged(targetInst);
}
function $add6d3ca4f7ece3e$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $add6d3ca4f7ece3e$var$getInstIfValueChanged(targetInst);
}
function $add6d3ca4f7ece3e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $add6d3ca4f7ece3e$var$objectIs = "function" === typeof Object.is ? Object.is : $add6d3ca4f7ece3e$var$is;
function $add6d3ca4f7ece3e$var$shallowEqual(objA, objB) {
    if ($add6d3ca4f7ece3e$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$add6d3ca4f7ece3e$var$hasOwnProperty.call(objB, currentKey) || !$add6d3ca4f7ece3e$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $add6d3ca4f7ece3e$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $add6d3ca4f7ece3e$var$getNodeForCharacterOffset(root, offset) {
    var node = $add6d3ca4f7ece3e$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $add6d3ca4f7ece3e$var$getLeafNode(node);
    }
}
function $add6d3ca4f7ece3e$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $add6d3ca4f7ece3e$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $add6d3ca4f7ece3e$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $add6d3ca4f7ece3e$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $add6d3ca4f7ece3e$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $add6d3ca4f7ece3e$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $add6d3ca4f7ece3e$var$skipSelectionChangeEvent = $add6d3ca4f7ece3e$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $add6d3ca4f7ece3e$var$activeElement = null, $add6d3ca4f7ece3e$var$activeElementInst = null, $add6d3ca4f7ece3e$var$lastSelection = null, $add6d3ca4f7ece3e$var$mouseDown = !1;
function $add6d3ca4f7ece3e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $add6d3ca4f7ece3e$var$mouseDown || null == $add6d3ca4f7ece3e$var$activeElement || $add6d3ca4f7ece3e$var$activeElement !== $add6d3ca4f7ece3e$var$getActiveElement(doc) || (doc = $add6d3ca4f7ece3e$var$activeElement, "selectionStart" in doc && $add6d3ca4f7ece3e$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $add6d3ca4f7ece3e$var$lastSelection && $add6d3ca4f7ece3e$var$shallowEqual($add6d3ca4f7ece3e$var$lastSelection, doc) || ($add6d3ca4f7ece3e$var$lastSelection = doc, doc = $add6d3ca4f7ece3e$var$accumulateTwoPhaseListeners($add6d3ca4f7ece3e$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $add6d3ca4f7ece3e$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $add6d3ca4f7ece3e$var$activeElement)));
}
function $add6d3ca4f7ece3e$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $add6d3ca4f7ece3e$var$vendorPrefixes = {
    animationend: $add6d3ca4f7ece3e$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $add6d3ca4f7ece3e$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $add6d3ca4f7ece3e$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $add6d3ca4f7ece3e$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $add6d3ca4f7ece3e$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $add6d3ca4f7ece3e$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $add6d3ca4f7ece3e$var$makePrefixMap("Transition", "TransitionEnd")
}, $add6d3ca4f7ece3e$var$prefixedEventNames = {}, $add6d3ca4f7ece3e$var$style = {};
$add6d3ca4f7ece3e$var$canUseDOM && ($add6d3ca4f7ece3e$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $add6d3ca4f7ece3e$var$vendorPrefixes.animationend.animation, delete $add6d3ca4f7ece3e$var$vendorPrefixes.animationiteration.animation, delete $add6d3ca4f7ece3e$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $add6d3ca4f7ece3e$var$vendorPrefixes.transitionend.transition);
function $add6d3ca4f7ece3e$var$getVendorPrefixedEventName(eventName) {
    if ($add6d3ca4f7ece3e$var$prefixedEventNames[eventName]) return $add6d3ca4f7ece3e$var$prefixedEventNames[eventName];
    if (!$add6d3ca4f7ece3e$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $add6d3ca4f7ece3e$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $add6d3ca4f7ece3e$var$style) return $add6d3ca4f7ece3e$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $add6d3ca4f7ece3e$var$ANIMATION_END = $add6d3ca4f7ece3e$var$getVendorPrefixedEventName("animationend"), $add6d3ca4f7ece3e$var$ANIMATION_ITERATION = $add6d3ca4f7ece3e$var$getVendorPrefixedEventName("animationiteration"), $add6d3ca4f7ece3e$var$ANIMATION_START = $add6d3ca4f7ece3e$var$getVendorPrefixedEventName("animationstart"), $add6d3ca4f7ece3e$var$TRANSITION_RUN = $add6d3ca4f7ece3e$var$getVendorPrefixedEventName("transitionrun"), $add6d3ca4f7ece3e$var$TRANSITION_START = $add6d3ca4f7ece3e$var$getVendorPrefixedEventName("transitionstart"), $add6d3ca4f7ece3e$var$TRANSITION_CANCEL = $add6d3ca4f7ece3e$var$getVendorPrefixedEventName("transitioncancel"), $add6d3ca4f7ece3e$var$TRANSITION_END = $add6d3ca4f7ece3e$var$getVendorPrefixedEventName("transitionend"), $add6d3ca4f7ece3e$var$topLevelEventsToReactNames = new Map(), $add6d3ca4f7ece3e$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$add6d3ca4f7ece3e$var$simpleEventPluginEvents.push("scrollEnd");
function $add6d3ca4f7ece3e$var$registerSimpleEvent(domEventName, reactName) {
    $add6d3ca4f7ece3e$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $add6d3ca4f7ece3e$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $add6d3ca4f7ece3e$var$CapturedStacks = new WeakMap();
function $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $add6d3ca4f7ece3e$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $add6d3ca4f7ece3e$var$getStackByFiberInDevAndProd(source)
        };
        $add6d3ca4f7ece3e$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $add6d3ca4f7ece3e$var$getStackByFiberInDevAndProd(source)
    };
}
var $add6d3ca4f7ece3e$var$concurrentQueues = [], $add6d3ca4f7ece3e$var$concurrentQueuesIndex = 0, $add6d3ca4f7ece3e$var$concurrentlyUpdatedLanes = 0;
function $add6d3ca4f7ece3e$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $add6d3ca4f7ece3e$var$concurrentQueuesIndex, i = $add6d3ca4f7ece3e$var$concurrentlyUpdatedLanes = $add6d3ca4f7ece3e$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $add6d3ca4f7ece3e$var$concurrentQueues[i];
        $add6d3ca4f7ece3e$var$concurrentQueues[i++] = null;
        var queue = $add6d3ca4f7ece3e$var$concurrentQueues[i];
        $add6d3ca4f7ece3e$var$concurrentQueues[i++] = null;
        var update = $add6d3ca4f7ece3e$var$concurrentQueues[i];
        $add6d3ca4f7ece3e$var$concurrentQueues[i++] = null;
        var lane = $add6d3ca4f7ece3e$var$concurrentQueues[i];
        $add6d3ca4f7ece3e$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $add6d3ca4f7ece3e$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $add6d3ca4f7ece3e$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $add6d3ca4f7ece3e$var$concurrentQueues[$add6d3ca4f7ece3e$var$concurrentQueuesIndex++] = fiber;
    $add6d3ca4f7ece3e$var$concurrentQueues[$add6d3ca4f7ece3e$var$concurrentQueuesIndex++] = queue;
    $add6d3ca4f7ece3e$var$concurrentQueues[$add6d3ca4f7ece3e$var$concurrentQueuesIndex++] = update;
    $add6d3ca4f7ece3e$var$concurrentQueues[$add6d3ca4f7ece3e$var$concurrentQueuesIndex++] = lane;
    $add6d3ca4f7ece3e$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $add6d3ca4f7ece3e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $add6d3ca4f7ece3e$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $add6d3ca4f7ece3e$var$getRootForUpdatedFiber(fiber);
}
function $add6d3ca4f7ece3e$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $add6d3ca4f7ece3e$var$enqueueUpdate$1(fiber, null, null, lane);
    return $add6d3ca4f7ece3e$var$getRootForUpdatedFiber(fiber);
}
function $add6d3ca4f7ece3e$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $add6d3ca4f7ece3e$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $add6d3ca4f7ece3e$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $add6d3ca4f7ece3e$var$nestedUpdateCount) throw $add6d3ca4f7ece3e$var$nestedUpdateCount = 0, $add6d3ca4f7ece3e$var$rootWithNestedUpdates = null, Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $add6d3ca4f7ece3e$var$emptyContextObject = {};
function $add6d3ca4f7ece3e$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $add6d3ca4f7ece3e$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $add6d3ca4f7ece3e$var$FiberNode(tag, pendingProps, key, mode);
}
function $add6d3ca4f7ece3e$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $add6d3ca4f7ece3e$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $add6d3ca4f7ece3e$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $add6d3ca4f7ece3e$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $add6d3ca4f7ece3e$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $add6d3ca4f7ece3e$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $add6d3ca4f7ece3e$var$isHostHoistableType(type, pendingProps, $add6d3ca4f7ece3e$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $add6d3ca4f7ece3e$var$REACT_ACTIVITY_TYPE:
            return type = $add6d3ca4f7ece3e$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $add6d3ca4f7ece3e$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $add6d3ca4f7ece3e$var$REACT_FRAGMENT_TYPE:
            return $add6d3ca4f7ece3e$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $add6d3ca4f7ece3e$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $add6d3ca4f7ece3e$var$REACT_PROFILER_TYPE:
            return type = $add6d3ca4f7ece3e$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $add6d3ca4f7ece3e$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $add6d3ca4f7ece3e$var$REACT_SUSPENSE_TYPE:
            return type = $add6d3ca4f7ece3e$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $add6d3ca4f7ece3e$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $add6d3ca4f7ece3e$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $add6d3ca4f7ece3e$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $add6d3ca4f7ece3e$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $add6d3ca4f7ece3e$var$REACT_PROVIDER_TYPE:
                case $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $add6d3ca4f7ece3e$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $add6d3ca4f7ece3e$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $add6d3ca4f7ece3e$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $add6d3ca4f7ece3e$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $add6d3ca4f7ece3e$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $add6d3ca4f7ece3e$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $add6d3ca4f7ece3e$var$createFiberFromText(content, mode, lanes) {
    content = $add6d3ca4f7ece3e$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $add6d3ca4f7ece3e$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $add6d3ca4f7ece3e$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $add6d3ca4f7ece3e$var$forkStack = [], $add6d3ca4f7ece3e$var$forkStackIndex = 0, $add6d3ca4f7ece3e$var$treeForkProvider = null, $add6d3ca4f7ece3e$var$treeForkCount = 0, $add6d3ca4f7ece3e$var$idStack = [], $add6d3ca4f7ece3e$var$idStackIndex = 0, $add6d3ca4f7ece3e$var$treeContextProvider = null, $add6d3ca4f7ece3e$var$treeContextId = 1, $add6d3ca4f7ece3e$var$treeContextOverflow = "";
function $add6d3ca4f7ece3e$var$pushTreeFork(workInProgress, totalChildren) {
    $add6d3ca4f7ece3e$var$forkStack[$add6d3ca4f7ece3e$var$forkStackIndex++] = $add6d3ca4f7ece3e$var$treeForkCount;
    $add6d3ca4f7ece3e$var$forkStack[$add6d3ca4f7ece3e$var$forkStackIndex++] = $add6d3ca4f7ece3e$var$treeForkProvider;
    $add6d3ca4f7ece3e$var$treeForkProvider = workInProgress;
    $add6d3ca4f7ece3e$var$treeForkCount = totalChildren;
}
function $add6d3ca4f7ece3e$var$pushTreeId(workInProgress, totalChildren, index) {
    $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex++] = $add6d3ca4f7ece3e$var$treeContextId;
    $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex++] = $add6d3ca4f7ece3e$var$treeContextOverflow;
    $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex++] = $add6d3ca4f7ece3e$var$treeContextProvider;
    $add6d3ca4f7ece3e$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $add6d3ca4f7ece3e$var$treeContextId;
    workInProgress = $add6d3ca4f7ece3e$var$treeContextOverflow;
    var baseLength = 32 - $add6d3ca4f7ece3e$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $add6d3ca4f7ece3e$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $add6d3ca4f7ece3e$var$treeContextId = 1 << 32 - $add6d3ca4f7ece3e$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $add6d3ca4f7ece3e$var$treeContextOverflow = length + workInProgress;
    } else $add6d3ca4f7ece3e$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $add6d3ca4f7ece3e$var$treeContextOverflow = workInProgress;
}
function $add6d3ca4f7ece3e$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($add6d3ca4f7ece3e$var$pushTreeFork(workInProgress, 1), $add6d3ca4f7ece3e$var$pushTreeId(workInProgress, 1, 0));
}
function $add6d3ca4f7ece3e$var$popTreeContext(workInProgress) {
    for(; workInProgress === $add6d3ca4f7ece3e$var$treeForkProvider;)$add6d3ca4f7ece3e$var$treeForkProvider = $add6d3ca4f7ece3e$var$forkStack[--$add6d3ca4f7ece3e$var$forkStackIndex], $add6d3ca4f7ece3e$var$forkStack[$add6d3ca4f7ece3e$var$forkStackIndex] = null, $add6d3ca4f7ece3e$var$treeForkCount = $add6d3ca4f7ece3e$var$forkStack[--$add6d3ca4f7ece3e$var$forkStackIndex], $add6d3ca4f7ece3e$var$forkStack[$add6d3ca4f7ece3e$var$forkStackIndex] = null;
    for(; workInProgress === $add6d3ca4f7ece3e$var$treeContextProvider;)$add6d3ca4f7ece3e$var$treeContextProvider = $add6d3ca4f7ece3e$var$idStack[--$add6d3ca4f7ece3e$var$idStackIndex], $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex] = null, $add6d3ca4f7ece3e$var$treeContextOverflow = $add6d3ca4f7ece3e$var$idStack[--$add6d3ca4f7ece3e$var$idStackIndex], $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex] = null, $add6d3ca4f7ece3e$var$treeContextId = $add6d3ca4f7ece3e$var$idStack[--$add6d3ca4f7ece3e$var$idStackIndex], $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex] = null;
}
var $add6d3ca4f7ece3e$var$hydrationParentFiber = null, $add6d3ca4f7ece3e$var$nextHydratableInstance = null, $add6d3ca4f7ece3e$var$isHydrating = !1, $add6d3ca4f7ece3e$var$hydrationErrors = null, $add6d3ca4f7ece3e$var$rootOrSingletonContext = !1, $add6d3ca4f7ece3e$var$HydrationMismatchException = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(519));
function $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(fiber) {
    var error = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(418, ""));
    $add6d3ca4f7ece3e$var$queueHydrationError($add6d3ca4f7ece3e$var$createCapturedValueAtFiber(error, fiber));
    throw $add6d3ca4f7ece3e$var$HydrationMismatchException;
}
function $add6d3ca4f7ece3e$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$add6d3ca4f7ece3e$var$internalInstanceKey] = fiber;
    instance[$add6d3ca4f7ece3e$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("cancel", instance);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $add6d3ca4f7ece3e$var$mediaEventTypes.length; type++)$add6d3ca4f7ece3e$var$listenToNonDelegatedEvent($add6d3ca4f7ece3e$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("error", instance);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("invalid", instance);
            $add6d3ca4f7ece3e$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $add6d3ca4f7ece3e$var$track(instance);
            break;
        case "select":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("invalid", instance), $add6d3ca4f7ece3e$var$initTextarea(instance, props.value, props.defaultValue, props.children), $add6d3ca4f7ece3e$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $add6d3ca4f7ece3e$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("beforetoggle", instance), $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $add6d3ca4f7ece3e$var$noop$1), instance = !0) : instance = !1;
    instance || $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(fiber);
}
function $add6d3ca4f7ece3e$var$popToNextHostParent(fiber) {
    for($add6d3ca4f7ece3e$var$hydrationParentFiber = fiber.return; $add6d3ca4f7ece3e$var$hydrationParentFiber;)switch($add6d3ca4f7ece3e$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $add6d3ca4f7ece3e$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $add6d3ca4f7ece3e$var$rootOrSingletonContext = !0;
            return;
        default:
            $add6d3ca4f7ece3e$var$hydrationParentFiber = $add6d3ca4f7ece3e$var$hydrationParentFiber.return;
    }
}
function $add6d3ca4f7ece3e$var$popHydrationState(fiber) {
    if (fiber !== $add6d3ca4f7ece3e$var$hydrationParentFiber) return !1;
    if (!$add6d3ca4f7ece3e$var$isHydrating) return $add6d3ca4f7ece3e$var$popToNextHostParent(fiber), $add6d3ca4f7ece3e$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $add6d3ca4f7ece3e$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $add6d3ca4f7ece3e$var$nextHydratableInstance && $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(fiber);
    $add6d3ca4f7ece3e$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $add6d3ca4f7ece3e$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $add6d3ca4f7ece3e$var$nextHydratableInstance, $add6d3ca4f7ece3e$var$isSingletonScope(fiber.type) ? (fiber = $add6d3ca4f7ece3e$var$previousHydratableOnEnteringScopedSingleton, $add6d3ca4f7ece3e$var$previousHydratableOnEnteringScopedSingleton = null, $add6d3ca4f7ece3e$var$nextHydratableInstance = fiber) : $add6d3ca4f7ece3e$var$nextHydratableInstance = tag) : $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$hydrationParentFiber ? $add6d3ca4f7ece3e$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $add6d3ca4f7ece3e$var$resetHydrationState() {
    $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$hydrationParentFiber = null;
    $add6d3ca4f7ece3e$var$isHydrating = !1;
}
function $add6d3ca4f7ece3e$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $add6d3ca4f7ece3e$var$hydrationErrors;
    null !== queuedErrors && (null === $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors ? $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors = queuedErrors : $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors.push.apply($add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors, queuedErrors), $add6d3ca4f7ece3e$var$hydrationErrors = null);
    return queuedErrors;
}
function $add6d3ca4f7ece3e$var$queueHydrationError(error) {
    null === $add6d3ca4f7ece3e$var$hydrationErrors ? $add6d3ca4f7ece3e$var$hydrationErrors = [
        error
    ] : $add6d3ca4f7ece3e$var$hydrationErrors.push(error);
}
var $add6d3ca4f7ece3e$var$valueCursor = $add6d3ca4f7ece3e$var$createCursor(null), $add6d3ca4f7ece3e$var$currentlyRenderingFiber$1 = null, $add6d3ca4f7ece3e$var$lastContextDependency = null;
function $add6d3ca4f7ece3e$var$pushProvider(providerFiber, context, nextValue) {
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $add6d3ca4f7ece3e$var$popProvider(context) {
    context._currentValue = $add6d3ca4f7ece3e$var$valueCursor.current;
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$valueCursor);
}
function $add6d3ca4f7ece3e$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $add6d3ca4f7ece3e$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $add6d3ca4f7ece3e$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $add6d3ca4f7ece3e$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $add6d3ca4f7ece3e$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $add6d3ca4f7ece3e$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $add6d3ca4f7ece3e$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($add6d3ca4f7ece3e$var$HostTransitionContext) : current = [
                $add6d3ca4f7ece3e$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $add6d3ca4f7ece3e$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $add6d3ca4f7ece3e$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$add6d3ca4f7ece3e$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $add6d3ca4f7ece3e$var$prepareToReadContext(workInProgress) {
    $add6d3ca4f7ece3e$var$currentlyRenderingFiber$1 = workInProgress;
    $add6d3ca4f7ece3e$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $add6d3ca4f7ece3e$var$readContext(context) {
    return $add6d3ca4f7ece3e$var$readContextForConsumer($add6d3ca4f7ece3e$var$currentlyRenderingFiber$1, context);
}
function $add6d3ca4f7ece3e$var$readContextDuringReconciliation(consumer, context) {
    null === $add6d3ca4f7ece3e$var$currentlyRenderingFiber$1 && $add6d3ca4f7ece3e$var$prepareToReadContext(consumer);
    return $add6d3ca4f7ece3e$var$readContextForConsumer(consumer, context);
}
function $add6d3ca4f7ece3e$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $add6d3ca4f7ece3e$var$lastContextDependency) {
        if (null === consumer) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(308));
        $add6d3ca4f7ece3e$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $add6d3ca4f7ece3e$var$lastContextDependency = $add6d3ca4f7ece3e$var$lastContextDependency.next = context;
    return value;
}
var $add6d3ca4f7ece3e$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $add6d3ca4f7ece3e$var$scheduleCallback$2 = $7ZzgL.unstable_scheduleCallback, $add6d3ca4f7ece3e$var$NormalPriority = $7ZzgL.unstable_NormalPriority, $add6d3ca4f7ece3e$var$CacheContext = {
    $$typeof: $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $add6d3ca4f7ece3e$var$createCache() {
    return {
        controller: new $add6d3ca4f7ece3e$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $add6d3ca4f7ece3e$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $add6d3ca4f7ece3e$var$scheduleCallback$2($add6d3ca4f7ece3e$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $add6d3ca4f7ece3e$var$currentEntangledListeners = null, $add6d3ca4f7ece3e$var$currentEntangledPendingCount = 0, $add6d3ca4f7ece3e$var$currentEntangledLane = 0, $add6d3ca4f7ece3e$var$currentEntangledActionThenable = null;
function $add6d3ca4f7ece3e$var$entangleAsyncAction(transition, thenable) {
    if (null === $add6d3ca4f7ece3e$var$currentEntangledListeners) {
        var entangledListeners = $add6d3ca4f7ece3e$var$currentEntangledListeners = [];
        $add6d3ca4f7ece3e$var$currentEntangledPendingCount = 0;
        $add6d3ca4f7ece3e$var$currentEntangledLane = $add6d3ca4f7ece3e$var$requestTransitionLane();
        $add6d3ca4f7ece3e$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $add6d3ca4f7ece3e$var$currentEntangledPendingCount++;
    thenable.then($add6d3ca4f7ece3e$var$pingEngtangledActionScope, $add6d3ca4f7ece3e$var$pingEngtangledActionScope);
    return thenable;
}
function $add6d3ca4f7ece3e$var$pingEngtangledActionScope() {
    if (0 === --$add6d3ca4f7ece3e$var$currentEntangledPendingCount && null !== $add6d3ca4f7ece3e$var$currentEntangledListeners) {
        null !== $add6d3ca4f7ece3e$var$currentEntangledActionThenable && ($add6d3ca4f7ece3e$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $add6d3ca4f7ece3e$var$currentEntangledListeners;
        $add6d3ca4f7ece3e$var$currentEntangledListeners = null;
        $add6d3ca4f7ece3e$var$currentEntangledLane = 0;
        $add6d3ca4f7ece3e$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $add6d3ca4f7ece3e$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $add6d3ca4f7ece3e$var$prevOnStartTransitionFinish = $add6d3ca4f7ece3e$var$ReactSharedInternals.S;
$add6d3ca4f7ece3e$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $add6d3ca4f7ece3e$var$entangleAsyncAction(transition, returnValue);
    null !== $add6d3ca4f7ece3e$var$prevOnStartTransitionFinish && $add6d3ca4f7ece3e$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $add6d3ca4f7ece3e$var$resumedCache = $add6d3ca4f7ece3e$var$createCursor(null);
function $add6d3ca4f7ece3e$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $add6d3ca4f7ece3e$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $add6d3ca4f7ece3e$var$workInProgressRoot.pooledCache;
}
function $add6d3ca4f7ece3e$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$resumedCache, $add6d3ca4f7ece3e$var$resumedCache.current) : $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$resumedCache, prevCachePool.pool);
}
function $add6d3ca4f7ece3e$var$getSuspendedCache() {
    var cacheFromPool = $add6d3ca4f7ece3e$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $add6d3ca4f7ece3e$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $add6d3ca4f7ece3e$var$SuspenseException = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(460)), $add6d3ca4f7ece3e$var$SuspenseyCommitException = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(474)), $add6d3ca4f7ece3e$var$SuspenseActionException = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(542)), $add6d3ca4f7ece3e$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $add6d3ca4f7ece3e$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $add6d3ca4f7ece3e$var$noop$3() {}
function $add6d3ca4f7ece3e$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($add6d3ca4f7ece3e$var$noop$3, $add6d3ca4f7ece3e$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $add6d3ca4f7ece3e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($add6d3ca4f7ece3e$var$noop$3, $add6d3ca4f7ece3e$var$noop$3);
            else {
                thenableState = $add6d3ca4f7ece3e$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $add6d3ca4f7ece3e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $add6d3ca4f7ece3e$var$suspendedThenable = thenable;
            throw $add6d3ca4f7ece3e$var$SuspenseException;
    }
}
var $add6d3ca4f7ece3e$var$suspendedThenable = null;
function $add6d3ca4f7ece3e$var$getSuspendedThenable() {
    if (null === $add6d3ca4f7ece3e$var$suspendedThenable) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(459));
    var thenable = $add6d3ca4f7ece3e$var$suspendedThenable;
    $add6d3ca4f7ece3e$var$suspendedThenable = null;
    return thenable;
}
function $add6d3ca4f7ece3e$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $add6d3ca4f7ece3e$var$SuspenseException || rejectedReason === $add6d3ca4f7ece3e$var$SuspenseActionException) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(483));
}
var $add6d3ca4f7ece3e$var$hasForceUpdate = !1;
function $add6d3ca4f7ece3e$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $add6d3ca4f7ece3e$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $add6d3ca4f7ece3e$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $add6d3ca4f7ece3e$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($add6d3ca4f7ece3e$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $add6d3ca4f7ece3e$var$getRootForUpdatedFiber(fiber);
        $add6d3ca4f7ece3e$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $add6d3ca4f7ece3e$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $add6d3ca4f7ece3e$var$getRootForUpdatedFiber(fiber);
}
function $add6d3ca4f7ece3e$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $add6d3ca4f7ece3e$var$markRootEntangled(root, lane);
    }
}
function $add6d3ca4f7ece3e$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $add6d3ca4f7ece3e$var$didReadFromEntangledAsyncAction = !1;
function $add6d3ca4f7ece3e$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($add6d3ca4f7ece3e$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $add6d3ca4f7ece3e$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $add6d3ca4f7ece3e$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $add6d3ca4f7ece3e$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $add6d3ca4f7ece3e$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $add6d3ca4f7ece3e$var$currentEntangledLane && ($add6d3ca4f7ece3e$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $add6d3ca4f7ece3e$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $add6d3ca4f7ece3e$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $add6d3ca4f7ece3e$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $add6d3ca4f7ece3e$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$add6d3ca4f7ece3e$var$callCallback(callbacks[updateQueue], context);
}
var $add6d3ca4f7ece3e$var$currentTreeHiddenStackCursor = $add6d3ca4f7ece3e$var$createCursor(null), $add6d3ca4f7ece3e$var$prevEntangledRenderLanesCursor = $add6d3ca4f7ece3e$var$createCursor(0);
function $add6d3ca4f7ece3e$var$pushHiddenContext(fiber, context) {
    fiber = $add6d3ca4f7ece3e$var$entangledRenderLanes;
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$prevEntangledRenderLanesCursor, fiber);
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$currentTreeHiddenStackCursor, context);
    $add6d3ca4f7ece3e$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $add6d3ca4f7ece3e$var$reuseHiddenContextOnStack() {
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$prevEntangledRenderLanesCursor, $add6d3ca4f7ece3e$var$entangledRenderLanes);
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$currentTreeHiddenStackCursor, $add6d3ca4f7ece3e$var$currentTreeHiddenStackCursor.current);
}
function $add6d3ca4f7ece3e$var$popHiddenContext() {
    $add6d3ca4f7ece3e$var$entangledRenderLanes = $add6d3ca4f7ece3e$var$prevEntangledRenderLanesCursor.current;
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$currentTreeHiddenStackCursor);
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$prevEntangledRenderLanesCursor);
}
var $add6d3ca4f7ece3e$var$renderLanes = 0, $add6d3ca4f7ece3e$var$currentlyRenderingFiber = null, $add6d3ca4f7ece3e$var$currentHook = null, $add6d3ca4f7ece3e$var$workInProgressHook = null, $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdate = !1, $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $add6d3ca4f7ece3e$var$localIdCounter = 0, $add6d3ca4f7ece3e$var$thenableIndexCounter$1 = 0, $add6d3ca4f7ece3e$var$thenableState$1 = null, $add6d3ca4f7ece3e$var$globalClientIdCounter = 0;
function $add6d3ca4f7ece3e$var$throwInvalidHookError() {
    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(321));
}
function $add6d3ca4f7ece3e$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$add6d3ca4f7ece3e$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $add6d3ca4f7ece3e$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $add6d3ca4f7ece3e$var$renderLanes = nextRenderLanes;
    $add6d3ca4f7ece3e$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $add6d3ca4f7ece3e$var$HooksDispatcherOnMount : $add6d3ca4f7ece3e$var$HooksDispatcherOnUpdate;
    $add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $add6d3ca4f7ece3e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $add6d3ca4f7ece3e$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $add6d3ca4f7ece3e$var$finishRenderingHooks(current) {
    $add6d3ca4f7ece3e$var$ReactSharedInternals.H = $add6d3ca4f7ece3e$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $add6d3ca4f7ece3e$var$currentHook && null !== $add6d3ca4f7ece3e$var$currentHook.next;
    $add6d3ca4f7ece3e$var$renderLanes = 0;
    $add6d3ca4f7ece3e$var$workInProgressHook = $add6d3ca4f7ece3e$var$currentHook = $add6d3ca4f7ece3e$var$currentlyRenderingFiber = null;
    $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdate = !1;
    $add6d3ca4f7ece3e$var$thenableIndexCounter$1 = 0;
    $add6d3ca4f7ece3e$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(300));
    null === current || $add6d3ca4f7ece3e$var$didReceiveUpdate || (current = current.dependencies, null !== current && $add6d3ca4f7ece3e$var$checkIfContextChanged(current) && ($add6d3ca4f7ece3e$var$didReceiveUpdate = !0));
}
function $add6d3ca4f7ece3e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $add6d3ca4f7ece3e$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdateDuringThisPass && ($add6d3ca4f7ece3e$var$thenableState$1 = null);
        $add6d3ca4f7ece3e$var$thenableIndexCounter$1 = 0;
        $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $add6d3ca4f7ece3e$var$workInProgressHook = $add6d3ca4f7ece3e$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $add6d3ca4f7ece3e$var$ReactSharedInternals.H = $add6d3ca4f7ece3e$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $add6d3ca4f7ece3e$var$TransitionAwareHostComponent() {
    var dispatcher = $add6d3ca4f7ece3e$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $add6d3ca4f7ece3e$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $add6d3ca4f7ece3e$var$currentHook ? $add6d3ca4f7ece3e$var$currentHook.memoizedState : null) !== dispatcher && ($add6d3ca4f7ece3e$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $add6d3ca4f7ece3e$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $add6d3ca4f7ece3e$var$localIdCounter;
    $add6d3ca4f7ece3e$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $add6d3ca4f7ece3e$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $add6d3ca4f7ece3e$var$resetHooksOnUnwind(workInProgress) {
    if ($add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdate = !1;
    }
    $add6d3ca4f7ece3e$var$renderLanes = 0;
    $add6d3ca4f7ece3e$var$workInProgressHook = $add6d3ca4f7ece3e$var$currentHook = $add6d3ca4f7ece3e$var$currentlyRenderingFiber = null;
    $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $add6d3ca4f7ece3e$var$thenableIndexCounter$1 = $add6d3ca4f7ece3e$var$localIdCounter = 0;
    $add6d3ca4f7ece3e$var$thenableState$1 = null;
}
function $add6d3ca4f7ece3e$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $add6d3ca4f7ece3e$var$workInProgressHook ? $add6d3ca4f7ece3e$var$currentlyRenderingFiber.memoizedState = $add6d3ca4f7ece3e$var$workInProgressHook = hook : $add6d3ca4f7ece3e$var$workInProgressHook = $add6d3ca4f7ece3e$var$workInProgressHook.next = hook;
    return $add6d3ca4f7ece3e$var$workInProgressHook;
}
function $add6d3ca4f7ece3e$var$updateWorkInProgressHook() {
    if (null === $add6d3ca4f7ece3e$var$currentHook) {
        var nextCurrentHook = $add6d3ca4f7ece3e$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $add6d3ca4f7ece3e$var$currentHook.next;
    var nextWorkInProgressHook = null === $add6d3ca4f7ece3e$var$workInProgressHook ? $add6d3ca4f7ece3e$var$currentlyRenderingFiber.memoizedState : $add6d3ca4f7ece3e$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $add6d3ca4f7ece3e$var$workInProgressHook = nextWorkInProgressHook, $add6d3ca4f7ece3e$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $add6d3ca4f7ece3e$var$currentlyRenderingFiber.alternate) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(467));
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(310));
        }
        $add6d3ca4f7ece3e$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $add6d3ca4f7ece3e$var$currentHook.memoizedState,
            baseState: $add6d3ca4f7ece3e$var$currentHook.baseState,
            baseQueue: $add6d3ca4f7ece3e$var$currentHook.baseQueue,
            queue: $add6d3ca4f7ece3e$var$currentHook.queue,
            next: null
        };
        null === $add6d3ca4f7ece3e$var$workInProgressHook ? $add6d3ca4f7ece3e$var$currentlyRenderingFiber.memoizedState = $add6d3ca4f7ece3e$var$workInProgressHook = nextCurrentHook : $add6d3ca4f7ece3e$var$workInProgressHook = $add6d3ca4f7ece3e$var$workInProgressHook.next = nextCurrentHook;
    }
    return $add6d3ca4f7ece3e$var$workInProgressHook;
}
function $add6d3ca4f7ece3e$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $add6d3ca4f7ece3e$var$useThenable(thenable) {
    var index = $add6d3ca4f7ece3e$var$thenableIndexCounter$1;
    $add6d3ca4f7ece3e$var$thenableIndexCounter$1 += 1;
    null === $add6d3ca4f7ece3e$var$thenableState$1 && ($add6d3ca4f7ece3e$var$thenableState$1 = []);
    thenable = $add6d3ca4f7ece3e$var$trackUsedThenable($add6d3ca4f7ece3e$var$thenableState$1, thenable, index);
    index = $add6d3ca4f7ece3e$var$currentlyRenderingFiber;
    null === (null === $add6d3ca4f7ece3e$var$workInProgressHook ? index.memoizedState : $add6d3ca4f7ece3e$var$workInProgressHook.next) && (index = index.alternate, $add6d3ca4f7ece3e$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $add6d3ca4f7ece3e$var$HooksDispatcherOnMount : $add6d3ca4f7ece3e$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $add6d3ca4f7ece3e$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $add6d3ca4f7ece3e$var$useThenable(usable);
        if (usable.$$typeof === $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE) return $add6d3ca4f7ece3e$var$readContext(usable);
    }
    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(438, String(usable)));
}
function $add6d3ca4f7ece3e$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $add6d3ca4f7ece3e$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $add6d3ca4f7ece3e$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $add6d3ca4f7ece3e$var$createFunctionComponentUpdateQueue(), $add6d3ca4f7ece3e$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $add6d3ca4f7ece3e$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $add6d3ca4f7ece3e$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $add6d3ca4f7ece3e$var$updateReducer(reducer) {
    var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    return $add6d3ca4f7ece3e$var$updateReducerImpl(hook, $add6d3ca4f7ece3e$var$currentHook, reducer);
}
function $add6d3ca4f7ece3e$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($add6d3ca4f7ece3e$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $add6d3ca4f7ece3e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($add6d3ca4f7ece3e$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $add6d3ca4f7ece3e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $add6d3ca4f7ece3e$var$currentlyRenderingFiber.lanes |= revertLane, $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $add6d3ca4f7ece3e$var$currentlyRenderingFiber.lanes |= updateLane, $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$add6d3ca4f7ece3e$var$objectIs(pendingQueue, hook.memoizedState) && ($add6d3ca4f7ece3e$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $add6d3ca4f7ece3e$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $add6d3ca4f7ece3e$var$rerenderReducer(reducer) {
    var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $add6d3ca4f7ece3e$var$objectIs(newState, hook.memoizedState) || ($add6d3ca4f7ece3e$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $add6d3ca4f7ece3e$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $add6d3ca4f7ece3e$var$currentlyRenderingFiber, hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $add6d3ca4f7ece3e$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$add6d3ca4f7ece3e$var$objectIs(($add6d3ca4f7ece3e$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $add6d3ca4f7ece3e$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $add6d3ca4f7ece3e$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $add6d3ca4f7ece3e$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $add6d3ca4f7ece3e$var$workInProgressHook && $add6d3ca4f7ece3e$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $add6d3ca4f7ece3e$var$pushSimpleEffect(9, $add6d3ca4f7ece3e$var$createEffectInstance(), $add6d3ca4f7ece3e$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $add6d3ca4f7ece3e$var$workInProgressRoot) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($add6d3ca4f7ece3e$var$renderLanes & 124) || $add6d3ca4f7ece3e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $add6d3ca4f7ece3e$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $add6d3ca4f7ece3e$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $add6d3ca4f7ece3e$var$createFunctionComponentUpdateQueue(), $add6d3ca4f7ece3e$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $add6d3ca4f7ece3e$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $add6d3ca4f7ece3e$var$checkIfSnapshotChanged(inst) && $add6d3ca4f7ece3e$var$forceStoreRerender(fiber);
}
function $add6d3ca4f7ece3e$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $add6d3ca4f7ece3e$var$checkIfSnapshotChanged(inst) && $add6d3ca4f7ece3e$var$forceStoreRerender(fiber);
    });
}
function $add6d3ca4f7ece3e$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$add6d3ca4f7ece3e$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $add6d3ca4f7ece3e$var$forceStoreRerender(fiber) {
    var root = $add6d3ca4f7ece3e$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $add6d3ca4f7ece3e$var$mountStateImpl(initialState) {
    var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $add6d3ca4f7ece3e$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $add6d3ca4f7ece3e$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $add6d3ca4f7ece3e$var$updateReducerImpl(hook, $add6d3ca4f7ece3e$var$currentHook, "function" === typeof reducer ? reducer : $add6d3ca4f7ece3e$var$basicStateReducer);
}
function $add6d3ca4f7ece3e$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($add6d3ca4f7ece3e$var$isRenderPhaseUpdate(fiber)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $add6d3ca4f7ece3e$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $add6d3ca4f7ece3e$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $add6d3ca4f7ece3e$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $add6d3ca4f7ece3e$var$ReactSharedInternals.T, currentTransition = {};
        $add6d3ca4f7ece3e$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $add6d3ca4f7ece3e$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $add6d3ca4f7ece3e$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $add6d3ca4f7ece3e$var$onActionError(actionQueue, node, error);
        } finally{
            $add6d3ca4f7ece3e$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $add6d3ca4f7ece3e$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $add6d3ca4f7ece3e$var$onActionError(actionQueue, node, error$38);
    }
}
function $add6d3ca4f7ece3e$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $add6d3ca4f7ece3e$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $add6d3ca4f7ece3e$var$onActionError(actionQueue, node, error);
    }) : $add6d3ca4f7ece3e$var$onActionSuccess(actionQueue, node, returnValue);
}
function $add6d3ca4f7ece3e$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $add6d3ca4f7ece3e$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $add6d3ca4f7ece3e$var$runActionStateAction(actionQueue, nextState)));
}
function $add6d3ca4f7ece3e$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $add6d3ca4f7ece3e$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $add6d3ca4f7ece3e$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $add6d3ca4f7ece3e$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $add6d3ca4f7ece3e$var$mountActionState(action, initialStateProp) {
    if ($add6d3ca4f7ece3e$var$isHydrating) {
        var ssrFormState = $add6d3ca4f7ece3e$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $add6d3ca4f7ece3e$var$currentlyRenderingFiber;
                if ($add6d3ca4f7ece3e$var$isHydrating) {
                    if ($add6d3ca4f7ece3e$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $add6d3ca4f7ece3e$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $add6d3ca4f7ece3e$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $add6d3ca4f7ece3e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $add6d3ca4f7ece3e$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $add6d3ca4f7ece3e$var$dispatchSetState.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $add6d3ca4f7ece3e$var$mountStateImpl(!1);
    inRootOrSingleton = $add6d3ca4f7ece3e$var$dispatchOptimisticSetState.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $add6d3ca4f7ece3e$var$dispatchActionState.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $add6d3ca4f7ece3e$var$updateActionState(action) {
    var stateHook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    return $add6d3ca4f7ece3e$var$updateActionStateImpl(stateHook, $add6d3ca4f7ece3e$var$currentHook, action);
}
function $add6d3ca4f7ece3e$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $add6d3ca4f7ece3e$var$updateReducerImpl(stateHook, currentStateHook, $add6d3ca4f7ece3e$var$actionStateReducer)[0];
    stateHook = $add6d3ca4f7ece3e$var$updateReducer($add6d3ca4f7ece3e$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $add6d3ca4f7ece3e$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $add6d3ca4f7ece3e$var$SuspenseException) throw $add6d3ca4f7ece3e$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($add6d3ca4f7ece3e$var$currentlyRenderingFiber.flags |= 2048, $add6d3ca4f7ece3e$var$pushSimpleEffect(9, $add6d3ca4f7ece3e$var$createEffectInstance(), $add6d3ca4f7ece3e$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $add6d3ca4f7ece3e$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $add6d3ca4f7ece3e$var$rerenderActionState(action) {
    var stateHook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook(), currentStateHook = $add6d3ca4f7ece3e$var$currentHook;
    if (null !== currentStateHook) return $add6d3ca4f7ece3e$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $add6d3ca4f7ece3e$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $add6d3ca4f7ece3e$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $add6d3ca4f7ece3e$var$createFunctionComponentUpdateQueue(), $add6d3ca4f7ece3e$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $add6d3ca4f7ece3e$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $add6d3ca4f7ece3e$var$updateRef() {
    return $add6d3ca4f7ece3e$var$updateWorkInProgressHook().memoizedState;
}
function $add6d3ca4f7ece3e$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $add6d3ca4f7ece3e$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $add6d3ca4f7ece3e$var$pushSimpleEffect(1 | hookFlags, $add6d3ca4f7ece3e$var$createEffectInstance(), create, createDeps);
}
function $add6d3ca4f7ece3e$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $add6d3ca4f7ece3e$var$currentHook && null !== deps && $add6d3ca4f7ece3e$var$areHookInputsEqual(deps, $add6d3ca4f7ece3e$var$currentHook.memoizedState.deps) ? hook.memoizedState = $add6d3ca4f7ece3e$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($add6d3ca4f7ece3e$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $add6d3ca4f7ece3e$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $add6d3ca4f7ece3e$var$mountEffect(create, createDeps) {
    $add6d3ca4f7ece3e$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $add6d3ca4f7ece3e$var$updateEffect(create, createDeps) {
    $add6d3ca4f7ece3e$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $add6d3ca4f7ece3e$var$updateInsertionEffect(create, deps) {
    return $add6d3ca4f7ece3e$var$updateEffectImpl(4, 2, create, deps);
}
function $add6d3ca4f7ece3e$var$updateLayoutEffect(create, deps) {
    return $add6d3ca4f7ece3e$var$updateEffectImpl(4, 4, create, deps);
}
function $add6d3ca4f7ece3e$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $add6d3ca4f7ece3e$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $add6d3ca4f7ece3e$var$updateEffectImpl(4, 4, $add6d3ca4f7ece3e$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $add6d3ca4f7ece3e$var$mountDebugValue() {}
function $add6d3ca4f7ece3e$var$updateCallback(callback, deps) {
    var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $add6d3ca4f7ece3e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $add6d3ca4f7ece3e$var$updateMemo(nextCreate, deps) {
    var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $add6d3ca4f7ece3e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $add6d3ca4f7ece3e$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($add6d3ca4f7ece3e$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $add6d3ca4f7ece3e$var$requestDeferredLane();
    $add6d3ca4f7ece3e$var$currentlyRenderingFiber.lanes |= hook;
    $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $add6d3ca4f7ece3e$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($add6d3ca4f7ece3e$var$objectIs(value, prevValue)) return value;
    if (null !== $add6d3ca4f7ece3e$var$currentTreeHiddenStackCursor.current) return hook = $add6d3ca4f7ece3e$var$mountDeferredValueImpl(hook, value, initialValue), $add6d3ca4f7ece3e$var$objectIs(hook, prevValue) || ($add6d3ca4f7ece3e$var$didReceiveUpdate = !0), hook;
    if (0 === ($add6d3ca4f7ece3e$var$renderLanes & 42)) return $add6d3ca4f7ece3e$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $add6d3ca4f7ece3e$var$requestDeferredLane();
    $add6d3ca4f7ece3e$var$currentlyRenderingFiber.lanes |= hook;
    $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $add6d3ca4f7ece3e$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
    $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $add6d3ca4f7ece3e$var$ReactSharedInternals.T, currentTransition = {};
    $add6d3ca4f7ece3e$var$ReactSharedInternals.T = currentTransition;
    $add6d3ca4f7ece3e$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $add6d3ca4f7ece3e$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $add6d3ca4f7ece3e$var$chainThenableValue(returnValue, finishedState);
            $add6d3ca4f7ece3e$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $add6d3ca4f7ece3e$var$requestUpdateLane(fiber));
        } else $add6d3ca4f7ece3e$var$dispatchSetStateInternal(fiber, queue, finishedState, $add6d3ca4f7ece3e$var$requestUpdateLane(fiber));
    } catch (error) {
        $add6d3ca4f7ece3e$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $add6d3ca4f7ece3e$var$requestUpdateLane());
    } finally{
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = previousPriority, $add6d3ca4f7ece3e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $add6d3ca4f7ece3e$var$noop$2() {}
function $add6d3ca4f7ece3e$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(476));
    var queue = $add6d3ca4f7ece3e$var$ensureFormComponentIsStateful(formFiber).queue;
    $add6d3ca4f7ece3e$var$startTransition(formFiber, queue, pendingState, $add6d3ca4f7ece3e$var$sharedNotPendingObject, null === action ? $add6d3ca4f7ece3e$var$noop$2 : function() {
        $add6d3ca4f7ece3e$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $add6d3ca4f7ece3e$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $add6d3ca4f7ece3e$var$sharedNotPendingObject,
        baseState: $add6d3ca4f7ece3e$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $add6d3ca4f7ece3e$var$basicStateReducer,
            lastRenderedState: $add6d3ca4f7ece3e$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $add6d3ca4f7ece3e$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $add6d3ca4f7ece3e$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $add6d3ca4f7ece3e$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $add6d3ca4f7ece3e$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $add6d3ca4f7ece3e$var$requestUpdateLane());
}
function $add6d3ca4f7ece3e$var$useHostTransitionStatus() {
    return $add6d3ca4f7ece3e$var$readContext($add6d3ca4f7ece3e$var$HostTransitionContext);
}
function $add6d3ca4f7ece3e$var$updateId() {
    return $add6d3ca4f7ece3e$var$updateWorkInProgressHook().memoizedState;
}
function $add6d3ca4f7ece3e$var$updateRefresh() {
    return $add6d3ca4f7ece3e$var$updateWorkInProgressHook().memoizedState;
}
function $add6d3ca4f7ece3e$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $add6d3ca4f7ece3e$var$requestUpdateLane();
                fiber = $add6d3ca4f7ece3e$var$createUpdate(lane);
                var root$41 = $add6d3ca4f7ece3e$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(root$41, provider, lane), $add6d3ca4f7ece3e$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $add6d3ca4f7ece3e$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $add6d3ca4f7ece3e$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $add6d3ca4f7ece3e$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $add6d3ca4f7ece3e$var$isRenderPhaseUpdate(fiber) ? $add6d3ca4f7ece3e$var$enqueueRenderPhaseUpdate(queue, action) : (action = $add6d3ca4f7ece3e$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(action, fiber, lane), $add6d3ca4f7ece3e$var$entangleTransitionUpdate(action, queue, lane)));
}
function $add6d3ca4f7ece3e$var$dispatchSetState(fiber, queue, action) {
    var lane = $add6d3ca4f7ece3e$var$requestUpdateLane();
    $add6d3ca4f7ece3e$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $add6d3ca4f7ece3e$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($add6d3ca4f7ece3e$var$isRenderPhaseUpdate(fiber)) $add6d3ca4f7ece3e$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($add6d3ca4f7ece3e$var$objectIs(eagerState, currentState)) return $add6d3ca4f7ece3e$var$enqueueUpdate$1(fiber, queue, update, 0), null === $add6d3ca4f7ece3e$var$workInProgressRoot && $add6d3ca4f7ece3e$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $add6d3ca4f7ece3e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(action, fiber, lane), $add6d3ca4f7ece3e$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $add6d3ca4f7ece3e$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $add6d3ca4f7ece3e$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($add6d3ca4f7ece3e$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $add6d3ca4f7ece3e$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $add6d3ca4f7ece3e$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $add6d3ca4f7ece3e$var$currentlyRenderingFiber || null !== alternate && alternate === $add6d3ca4f7ece3e$var$currentlyRenderingFiber;
}
function $add6d3ca4f7ece3e$var$enqueueRenderPhaseUpdate(queue, update) {
    $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdateDuringThisPass = $add6d3ca4f7ece3e$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $add6d3ca4f7ece3e$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $add6d3ca4f7ece3e$var$markRootEntangled(root, lane);
    }
}
var $add6d3ca4f7ece3e$var$ContextOnlyDispatcher = {
    readContext: $add6d3ca4f7ece3e$var$readContext,
    use: $add6d3ca4f7ece3e$var$use,
    useCallback: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useContext: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useEffect: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useImperativeHandle: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useLayoutEffect: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useInsertionEffect: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useMemo: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useReducer: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useRef: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useState: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useDebugValue: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useDeferredValue: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useTransition: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useSyncExternalStore: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useId: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useHostTransitionStatus: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useFormState: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useActionState: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useOptimistic: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useMemoCache: $add6d3ca4f7ece3e$var$throwInvalidHookError,
    useCacheRefresh: $add6d3ca4f7ece3e$var$throwInvalidHookError
}, $add6d3ca4f7ece3e$var$HooksDispatcherOnMount = {
    readContext: $add6d3ca4f7ece3e$var$readContext,
    use: $add6d3ca4f7ece3e$var$use,
    useCallback: function(callback, deps) {
        $add6d3ca4f7ece3e$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $add6d3ca4f7ece3e$var$readContext,
    useEffect: $add6d3ca4f7ece3e$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $add6d3ca4f7ece3e$var$mountEffectImpl(4194308, 4, $add6d3ca4f7ece3e$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $add6d3ca4f7ece3e$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $add6d3ca4f7ece3e$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($add6d3ca4f7ece3e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $add6d3ca4f7ece3e$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $add6d3ca4f7ece3e$var$dispatchReducerAction.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $add6d3ca4f7ece3e$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $add6d3ca4f7ece3e$var$dispatchSetState.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $add6d3ca4f7ece3e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
        return $add6d3ca4f7ece3e$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $add6d3ca4f7ece3e$var$mountStateImpl(!1);
        stateHook = $add6d3ca4f7ece3e$var$startTransition.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $add6d3ca4f7ece3e$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $add6d3ca4f7ece3e$var$currentlyRenderingFiber, hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
        if ($add6d3ca4f7ece3e$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $add6d3ca4f7ece3e$var$workInProgressRoot) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(349));
            0 !== ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 124) || $add6d3ca4f7ece3e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $add6d3ca4f7ece3e$var$mountEffect($add6d3ca4f7ece3e$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $add6d3ca4f7ece3e$var$pushSimpleEffect(9, $add6d3ca4f7ece3e$var$createEffectInstance(), $add6d3ca4f7ece3e$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook(), identifierPrefix = $add6d3ca4f7ece3e$var$workInProgressRoot.identifierPrefix;
        if ($add6d3ca4f7ece3e$var$isHydrating) {
            var JSCompiler_inline_result = $add6d3ca4f7ece3e$var$treeContextOverflow;
            var idWithLeadingBit = $add6d3ca4f7ece3e$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $add6d3ca4f7ece3e$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $add6d3ca4f7ece3e$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $add6d3ca4f7ece3e$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $add6d3ca4f7ece3e$var$useHostTransitionStatus,
    useFormState: $add6d3ca4f7ece3e$var$mountActionState,
    useActionState: $add6d3ca4f7ece3e$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $add6d3ca4f7ece3e$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $add6d3ca4f7ece3e$var$dispatchOptimisticSetState.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $add6d3ca4f7ece3e$var$useMemoCache,
    useCacheRefresh: function() {
        return $add6d3ca4f7ece3e$var$mountWorkInProgressHook().memoizedState = $add6d3ca4f7ece3e$var$refreshCache.bind(null, $add6d3ca4f7ece3e$var$currentlyRenderingFiber);
    }
}, $add6d3ca4f7ece3e$var$HooksDispatcherOnUpdate = {
    readContext: $add6d3ca4f7ece3e$var$readContext,
    use: $add6d3ca4f7ece3e$var$use,
    useCallback: $add6d3ca4f7ece3e$var$updateCallback,
    useContext: $add6d3ca4f7ece3e$var$readContext,
    useEffect: $add6d3ca4f7ece3e$var$updateEffect,
    useImperativeHandle: $add6d3ca4f7ece3e$var$updateImperativeHandle,
    useInsertionEffect: $add6d3ca4f7ece3e$var$updateInsertionEffect,
    useLayoutEffect: $add6d3ca4f7ece3e$var$updateLayoutEffect,
    useMemo: $add6d3ca4f7ece3e$var$updateMemo,
    useReducer: $add6d3ca4f7ece3e$var$updateReducer,
    useRef: $add6d3ca4f7ece3e$var$updateRef,
    useState: function() {
        return $add6d3ca4f7ece3e$var$updateReducer($add6d3ca4f7ece3e$var$basicStateReducer);
    },
    useDebugValue: $add6d3ca4f7ece3e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
        return $add6d3ca4f7ece3e$var$updateDeferredValueImpl(hook, $add6d3ca4f7ece3e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $add6d3ca4f7ece3e$var$updateReducer($add6d3ca4f7ece3e$var$basicStateReducer)[0], start = $add6d3ca4f7ece3e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $add6d3ca4f7ece3e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $add6d3ca4f7ece3e$var$updateSyncExternalStore,
    useId: $add6d3ca4f7ece3e$var$updateId,
    useHostTransitionStatus: $add6d3ca4f7ece3e$var$useHostTransitionStatus,
    useFormState: $add6d3ca4f7ece3e$var$updateActionState,
    useActionState: $add6d3ca4f7ece3e$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
        return $add6d3ca4f7ece3e$var$updateOptimisticImpl(hook, $add6d3ca4f7ece3e$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $add6d3ca4f7ece3e$var$useMemoCache,
    useCacheRefresh: $add6d3ca4f7ece3e$var$updateRefresh
}, $add6d3ca4f7ece3e$var$HooksDispatcherOnRerender = {
    readContext: $add6d3ca4f7ece3e$var$readContext,
    use: $add6d3ca4f7ece3e$var$use,
    useCallback: $add6d3ca4f7ece3e$var$updateCallback,
    useContext: $add6d3ca4f7ece3e$var$readContext,
    useEffect: $add6d3ca4f7ece3e$var$updateEffect,
    useImperativeHandle: $add6d3ca4f7ece3e$var$updateImperativeHandle,
    useInsertionEffect: $add6d3ca4f7ece3e$var$updateInsertionEffect,
    useLayoutEffect: $add6d3ca4f7ece3e$var$updateLayoutEffect,
    useMemo: $add6d3ca4f7ece3e$var$updateMemo,
    useReducer: $add6d3ca4f7ece3e$var$rerenderReducer,
    useRef: $add6d3ca4f7ece3e$var$updateRef,
    useState: function() {
        return $add6d3ca4f7ece3e$var$rerenderReducer($add6d3ca4f7ece3e$var$basicStateReducer);
    },
    useDebugValue: $add6d3ca4f7ece3e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
        return null === $add6d3ca4f7ece3e$var$currentHook ? $add6d3ca4f7ece3e$var$mountDeferredValueImpl(hook, value, initialValue) : $add6d3ca4f7ece3e$var$updateDeferredValueImpl(hook, $add6d3ca4f7ece3e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $add6d3ca4f7ece3e$var$rerenderReducer($add6d3ca4f7ece3e$var$basicStateReducer)[0], start = $add6d3ca4f7ece3e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $add6d3ca4f7ece3e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $add6d3ca4f7ece3e$var$updateSyncExternalStore,
    useId: $add6d3ca4f7ece3e$var$updateId,
    useHostTransitionStatus: $add6d3ca4f7ece3e$var$useHostTransitionStatus,
    useFormState: $add6d3ca4f7ece3e$var$rerenderActionState,
    useActionState: $add6d3ca4f7ece3e$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $add6d3ca4f7ece3e$var$updateWorkInProgressHook();
        if (null !== $add6d3ca4f7ece3e$var$currentHook) return $add6d3ca4f7ece3e$var$updateOptimisticImpl(hook, $add6d3ca4f7ece3e$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $add6d3ca4f7ece3e$var$useMemoCache,
    useCacheRefresh: $add6d3ca4f7ece3e$var$updateRefresh
}, $add6d3ca4f7ece3e$var$thenableState = null, $add6d3ca4f7ece3e$var$thenableIndexCounter = 0;
function $add6d3ca4f7ece3e$var$unwrapThenable(thenable) {
    var index = $add6d3ca4f7ece3e$var$thenableIndexCounter;
    $add6d3ca4f7ece3e$var$thenableIndexCounter += 1;
    null === $add6d3ca4f7ece3e$var$thenableState && ($add6d3ca4f7ece3e$var$thenableState = []);
    return $add6d3ca4f7ece3e$var$trackUsedThenable($add6d3ca4f7ece3e$var$thenableState, thenable, index);
}
function $add6d3ca4f7ece3e$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $add6d3ca4f7ece3e$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $add6d3ca4f7ece3e$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $add6d3ca4f7ece3e$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $add6d3ca4f7ece3e$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $add6d3ca4f7ece3e$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $add6d3ca4f7ece3e$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $add6d3ca4f7ece3e$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE && $add6d3ca4f7ece3e$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $add6d3ca4f7ece3e$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $add6d3ca4f7ece3e$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $add6d3ca4f7ece3e$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $add6d3ca4f7ece3e$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $add6d3ca4f7ece3e$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $add6d3ca4f7ece3e$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $add6d3ca4f7ece3e$var$REACT_ELEMENT_TYPE:
                    return lanes = $add6d3ca4f7ece3e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $add6d3ca4f7ece3e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $add6d3ca4f7ece3e$var$REACT_PORTAL_TYPE:
                    return newChild = $add6d3ca4f7ece3e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($add6d3ca4f7ece3e$var$isArrayImpl(newChild) || $add6d3ca4f7ece3e$var$getIteratorFn(newChild)) return newChild = $add6d3ca4f7ece3e$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $add6d3ca4f7ece3e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $add6d3ca4f7ece3e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $add6d3ca4f7ece3e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $add6d3ca4f7ece3e$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $add6d3ca4f7ece3e$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($add6d3ca4f7ece3e$var$isArrayImpl(newChild) || $add6d3ca4f7ece3e$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $add6d3ca4f7ece3e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $add6d3ca4f7ece3e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $add6d3ca4f7ece3e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $add6d3ca4f7ece3e$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $add6d3ca4f7ece3e$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($add6d3ca4f7ece3e$var$isArrayImpl(newChild) || $add6d3ca4f7ece3e$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $add6d3ca4f7ece3e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $add6d3ca4f7ece3e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $add6d3ca4f7ece3e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $add6d3ca4f7ece3e$var$isHydrating && $add6d3ca4f7ece3e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $add6d3ca4f7ece3e$var$isHydrating && $add6d3ca4f7ece3e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $add6d3ca4f7ece3e$var$isHydrating && $add6d3ca4f7ece3e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $add6d3ca4f7ece3e$var$isHydrating && $add6d3ca4f7ece3e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $add6d3ca4f7ece3e$var$isHydrating && $add6d3ca4f7ece3e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $add6d3ca4f7ece3e$var$isHydrating && $add6d3ca4f7ece3e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $add6d3ca4f7ece3e$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $add6d3ca4f7ece3e$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $add6d3ca4f7ece3e$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE && $add6d3ca4f7ece3e$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $add6d3ca4f7ece3e$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $add6d3ca4f7ece3e$var$REACT_FRAGMENT_TYPE ? (lanes = $add6d3ca4f7ece3e$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $add6d3ca4f7ece3e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $add6d3ca4f7ece3e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $add6d3ca4f7ece3e$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $add6d3ca4f7ece3e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $add6d3ca4f7ece3e$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($add6d3ca4f7ece3e$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($add6d3ca4f7ece3e$var$getIteratorFn(newChild)) {
                key = $add6d3ca4f7ece3e$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $add6d3ca4f7ece3e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $add6d3ca4f7ece3e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $add6d3ca4f7ece3e$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $add6d3ca4f7ece3e$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $add6d3ca4f7ece3e$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $add6d3ca4f7ece3e$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $add6d3ca4f7ece3e$var$SuspenseException || x === $add6d3ca4f7ece3e$var$SuspenseActionException) throw x;
            var fiber = $add6d3ca4f7ece3e$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $add6d3ca4f7ece3e$var$reconcileChildFibers = $add6d3ca4f7ece3e$var$createChildReconciler(!0), $add6d3ca4f7ece3e$var$mountChildFibers = $add6d3ca4f7ece3e$var$createChildReconciler(!1), $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor = $add6d3ca4f7ece3e$var$createCursor(null), $add6d3ca4f7ece3e$var$shellBoundary = null;
function $add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseStackCursor, $add6d3ca4f7ece3e$var$suspenseStackCursor.current & 1);
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseHandlerStackCursor, handler);
    null === $add6d3ca4f7ece3e$var$shellBoundary && (null === current || null !== $add6d3ca4f7ece3e$var$currentTreeHiddenStackCursor.current ? $add6d3ca4f7ece3e$var$shellBoundary = handler : null !== current.memoizedState && ($add6d3ca4f7ece3e$var$shellBoundary = handler));
}
function $add6d3ca4f7ece3e$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseStackCursor, $add6d3ca4f7ece3e$var$suspenseStackCursor.current), $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseHandlerStackCursor, fiber), null === $add6d3ca4f7ece3e$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($add6d3ca4f7ece3e$var$shellBoundary = fiber);
        }
    } else $add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(fiber);
}
function $add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack() {
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseStackCursor, $add6d3ca4f7ece3e$var$suspenseStackCursor.current);
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseHandlerStackCursor, $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current);
}
function $add6d3ca4f7ece3e$var$popSuspenseHandler(fiber) {
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$suspenseHandlerStackCursor);
    $add6d3ca4f7ece3e$var$shellBoundary === fiber && ($add6d3ca4f7ece3e$var$shellBoundary = null);
    $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$suspenseStackCursor);
}
var $add6d3ca4f7ece3e$var$suspenseStackCursor = $add6d3ca4f7ece3e$var$createCursor(0);
function $add6d3ca4f7ece3e$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $add6d3ca4f7ece3e$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $add6d3ca4f7ece3e$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $add6d3ca4f7ece3e$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $add6d3ca4f7ece3e$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $add6d3ca4f7ece3e$var$requestUpdateLane(), update = $add6d3ca4f7ece3e$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $add6d3ca4f7ece3e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(payload, inst, lane), $add6d3ca4f7ece3e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $add6d3ca4f7ece3e$var$requestUpdateLane(), update = $add6d3ca4f7ece3e$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $add6d3ca4f7ece3e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(payload, inst, lane), $add6d3ca4f7ece3e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $add6d3ca4f7ece3e$var$requestUpdateLane(), update = $add6d3ca4f7ece3e$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $add6d3ca4f7ece3e$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(callback, inst, lane), $add6d3ca4f7ece3e$var$entangleTransitions(callback, inst, lane));
    }
};
function $add6d3ca4f7ece3e$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$add6d3ca4f7ece3e$var$shallowEqual(oldProps, newProps) || !$add6d3ca4f7ece3e$var$shallowEqual(oldState, newState) : !0;
}
function $add6d3ca4f7ece3e$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $add6d3ca4f7ece3e$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $add6d3ca4f7ece3e$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $add6d3ca4f7ece3e$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $add6d3ca4f7ece3e$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $add6d3ca4f7ece3e$var$defaultOnUncaughtError(error) {
    $add6d3ca4f7ece3e$var$reportGlobalError(error);
}
function $add6d3ca4f7ece3e$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $add6d3ca4f7ece3e$var$defaultOnRecoverableError(error) {
    $add6d3ca4f7ece3e$var$reportGlobalError(error);
}
function $add6d3ca4f7ece3e$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $add6d3ca4f7ece3e$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $add6d3ca4f7ece3e$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $add6d3ca4f7ece3e$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $add6d3ca4f7ece3e$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $add6d3ca4f7ece3e$var$createClassErrorUpdate(lane) {
    lane = $add6d3ca4f7ece3e$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $add6d3ca4f7ece3e$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $add6d3ca4f7ece3e$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $add6d3ca4f7ece3e$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed ? $add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $add6d3ca4f7ece3e$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $add6d3ca4f7ece3e$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $add6d3ca4f7ece3e$var$shellBoundary ? $add6d3ca4f7ece3e$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $add6d3ca4f7ece3e$var$workInProgressRootExitStatus && ($add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $add6d3ca4f7ece3e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $add6d3ca4f7ece3e$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $add6d3ca4f7ece3e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $add6d3ca4f7ece3e$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $add6d3ca4f7ece3e$var$attachPingListener(root, value, rootRenderLanes);
        $add6d3ca4f7ece3e$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($add6d3ca4f7ece3e$var$isHydrating) return returnFiber = $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $add6d3ca4f7ece3e$var$HydrationMismatchException && (root = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(422), {
        cause: value
    }), $add6d3ca4f7ece3e$var$queueHydrationError($add6d3ca4f7ece3e$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $add6d3ca4f7ece3e$var$HydrationMismatchException && (returnFiber = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(423), {
        cause: value
    }), $add6d3ca4f7ece3e$var$queueHydrationError($add6d3ca4f7ece3e$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $add6d3ca4f7ece3e$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $add6d3ca4f7ece3e$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $add6d3ca4f7ece3e$var$workInProgressRootExitStatus && ($add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $add6d3ca4f7ece3e$var$workInProgressRootConcurrentErrors ? $add6d3ca4f7ece3e$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $add6d3ca4f7ece3e$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $add6d3ca4f7ece3e$var$workInProgressRootExitStatus && ($add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $add6d3ca4f7ece3e$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $add6d3ca4f7ece3e$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed || !$add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $add6d3ca4f7ece3e$var$createClassErrorUpdate(rootRenderLanes), $add6d3ca4f7ece3e$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $add6d3ca4f7ece3e$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $add6d3ca4f7ece3e$var$SelectiveHydrationException = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(461)), $add6d3ca4f7ece3e$var$didReceiveUpdate = !1;
function $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $add6d3ca4f7ece3e$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $add6d3ca4f7ece3e$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $add6d3ca4f7ece3e$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $add6d3ca4f7ece3e$var$prepareToReadContext(workInProgress);
    nextProps = $add6d3ca4f7ece3e$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $add6d3ca4f7ece3e$var$checkDidRenderIdHook();
    if (null !== current && !$add6d3ca4f7ece3e$var$didReceiveUpdate) return $add6d3ca4f7ece3e$var$bailoutHooks(current, workInProgress, renderLanes), $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $add6d3ca4f7ece3e$var$isHydrating && key && $add6d3ca4f7ece3e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $add6d3ca4f7ece3e$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$add6d3ca4f7ece3e$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $add6d3ca4f7ece3e$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $add6d3ca4f7ece3e$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$add6d3ca4f7ece3e$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $add6d3ca4f7ece3e$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $add6d3ca4f7ece3e$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $add6d3ca4f7ece3e$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($add6d3ca4f7ece3e$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($add6d3ca4f7ece3e$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $add6d3ca4f7ece3e$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($add6d3ca4f7ece3e$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $add6d3ca4f7ece3e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $add6d3ca4f7ece3e$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $add6d3ca4f7ece3e$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $add6d3ca4f7ece3e$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $add6d3ca4f7ece3e$var$pushHiddenContext(workInProgress, prevState) : $add6d3ca4f7ece3e$var$reuseHiddenContextOnStack(), $add6d3ca4f7ece3e$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $add6d3ca4f7ece3e$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($add6d3ca4f7ece3e$var$pushTransition(workInProgress, prevState.cachePool), $add6d3ca4f7ece3e$var$pushHiddenContext(workInProgress, prevState), $add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $add6d3ca4f7ece3e$var$pushTransition(workInProgress, null), $add6d3ca4f7ece3e$var$reuseHiddenContextOnStack(), $add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(workInProgress));
    $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $add6d3ca4f7ece3e$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $add6d3ca4f7ece3e$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $add6d3ca4f7ece3e$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $add6d3ca4f7ece3e$var$pushTransition(workInProgress, null);
    $add6d3ca4f7ece3e$var$reuseHiddenContextOnStack();
    $add6d3ca4f7ece3e$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $add6d3ca4f7ece3e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $add6d3ca4f7ece3e$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $add6d3ca4f7ece3e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $add6d3ca4f7ece3e$var$prepareToReadContext(workInProgress);
    Component = $add6d3ca4f7ece3e$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $add6d3ca4f7ece3e$var$checkDidRenderIdHook();
    if (null !== current && !$add6d3ca4f7ece3e$var$didReceiveUpdate) return $add6d3ca4f7ece3e$var$bailoutHooks(current, workInProgress, renderLanes), $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $add6d3ca4f7ece3e$var$isHydrating && nextProps && $add6d3ca4f7ece3e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $add6d3ca4f7ece3e$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $add6d3ca4f7ece3e$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $add6d3ca4f7ece3e$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $add6d3ca4f7ece3e$var$finishRenderingHooks(current);
    Component = $add6d3ca4f7ece3e$var$checkDidRenderIdHook();
    if (null !== current && !$add6d3ca4f7ece3e$var$didReceiveUpdate) return $add6d3ca4f7ece3e$var$bailoutHooks(current, workInProgress, renderLanes), $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $add6d3ca4f7ece3e$var$isHydrating && Component && $add6d3ca4f7ece3e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $add6d3ca4f7ece3e$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $add6d3ca4f7ece3e$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $add6d3ca4f7ece3e$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $add6d3ca4f7ece3e$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $add6d3ca4f7ece3e$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $add6d3ca4f7ece3e$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $add6d3ca4f7ece3e$var$readContext(contextType) : $add6d3ca4f7ece3e$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($add6d3ca4f7ece3e$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $add6d3ca4f7ece3e$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $add6d3ca4f7ece3e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $add6d3ca4f7ece3e$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $add6d3ca4f7ece3e$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $add6d3ca4f7ece3e$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $add6d3ca4f7ece3e$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $add6d3ca4f7ece3e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $add6d3ca4f7ece3e$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $add6d3ca4f7ece3e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $add6d3ca4f7ece3e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $add6d3ca4f7ece3e$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($add6d3ca4f7ece3e$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $add6d3ca4f7ece3e$var$hasForceUpdate || $add6d3ca4f7ece3e$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $add6d3ca4f7ece3e$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $add6d3ca4f7ece3e$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $add6d3ca4f7ece3e$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $add6d3ca4f7ece3e$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $add6d3ca4f7ece3e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $add6d3ca4f7ece3e$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $add6d3ca4f7ece3e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $add6d3ca4f7ece3e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $add6d3ca4f7ece3e$var$hasForceUpdate || null !== current && null !== current.dependencies && $add6d3ca4f7ece3e$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($add6d3ca4f7ece3e$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $add6d3ca4f7ece3e$var$hasForceUpdate || $add6d3ca4f7ece3e$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $add6d3ca4f7ece3e$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $add6d3ca4f7ece3e$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $add6d3ca4f7ece3e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $add6d3ca4f7ece3e$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $add6d3ca4f7ece3e$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $add6d3ca4f7ece3e$var$resetHydrationState();
    workInProgress.flags |= 256;
    $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $add6d3ca4f7ece3e$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $add6d3ca4f7ece3e$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $add6d3ca4f7ece3e$var$getSuspendedCache()
    };
}
function $add6d3ca4f7ece3e$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $add6d3ca4f7ece3e$var$workInProgressDeferredLane);
    return current;
}
function $add6d3ca4f7ece3e$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($add6d3ca4f7ece3e$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($add6d3ca4f7ece3e$var$isHydrating) {
            showFallback ? $add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($add6d3ca4f7ece3e$var$isHydrating) {
                var nextInstance = $add6d3ca4f7ece3e$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $add6d3ca4f7ece3e$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $add6d3ca4f7ece3e$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $add6d3ca4f7ece3e$var$treeContextProvider ? {
                            id: $add6d3ca4f7ece3e$var$treeContextId,
                            overflow: $add6d3ca4f7ece3e$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $add6d3ca4f7ece3e$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $add6d3ca4f7ece3e$var$hydrationParentFiber = workInProgress, $add6d3ca4f7ece3e$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $add6d3ca4f7ece3e$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $add6d3ca4f7ece3e$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $add6d3ca4f7ece3e$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $add6d3ca4f7ece3e$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $add6d3ca4f7ece3e$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $add6d3ca4f7ece3e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $add6d3ca4f7ece3e$var$SUSPENDED_MARKER, nextProps;
        $add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $add6d3ca4f7ece3e$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $add6d3ca4f7ece3e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $add6d3ca4f7ece3e$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $add6d3ca4f7ece3e$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $add6d3ca4f7ece3e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $add6d3ca4f7ece3e$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $add6d3ca4f7ece3e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $add6d3ca4f7ece3e$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress), $add6d3ca4f7ece3e$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $add6d3ca4f7ece3e$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $add6d3ca4f7ece3e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($add6d3ca4f7ece3e$var$didReceiveUpdate || $add6d3ca4f7ece3e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $add6d3ca4f7ece3e$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $add6d3ca4f7ece3e$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $add6d3ca4f7ece3e$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $add6d3ca4f7ece3e$var$enqueueConcurrentRenderForLane(current, nextProps), $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $add6d3ca4f7ece3e$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $add6d3ca4f7ece3e$var$renderDidSuspendDelayIfPossible();
            workInProgress = $add6d3ca4f7ece3e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$getNextHydratable(nextInstance.nextSibling), $add6d3ca4f7ece3e$var$hydrationParentFiber = workInProgress, $add6d3ca4f7ece3e$var$isHydrating = !0, $add6d3ca4f7ece3e$var$hydrationErrors = null, $add6d3ca4f7ece3e$var$rootOrSingletonContext = !1, null !== current && ($add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex++] = $add6d3ca4f7ece3e$var$treeContextId, $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex++] = $add6d3ca4f7ece3e$var$treeContextOverflow, $add6d3ca4f7ece3e$var$idStack[$add6d3ca4f7ece3e$var$idStackIndex++] = $add6d3ca4f7ece3e$var$treeContextProvider, $add6d3ca4f7ece3e$var$treeContextId = current.id, $add6d3ca4f7ece3e$var$treeContextOverflow = current.overflow, $add6d3ca4f7ece3e$var$treeContextProvider = workInProgress), workInProgress = $add6d3ca4f7ece3e$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $add6d3ca4f7ece3e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $add6d3ca4f7ece3e$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $add6d3ca4f7ece3e$var$createWorkInProgress(digest, showFallback) : (showFallback = $add6d3ca4f7ece3e$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $add6d3ca4f7ece3e$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $add6d3ca4f7ece3e$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $add6d3ca4f7ece3e$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $add6d3ca4f7ece3e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $add6d3ca4f7ece3e$var$SUSPENDED_MARKER, nextProps;
    $add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $add6d3ca4f7ece3e$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $add6d3ca4f7ece3e$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $add6d3ca4f7ece3e$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $add6d3ca4f7ece3e$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $add6d3ca4f7ece3e$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $add6d3ca4f7ece3e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $add6d3ca4f7ece3e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $add6d3ca4f7ece3e$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $add6d3ca4f7ece3e$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $add6d3ca4f7ece3e$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $add6d3ca4f7ece3e$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $add6d3ca4f7ece3e$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $add6d3ca4f7ece3e$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $add6d3ca4f7ece3e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $add6d3ca4f7ece3e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $add6d3ca4f7ece3e$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $add6d3ca4f7ece3e$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $add6d3ca4f7ece3e$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $add6d3ca4f7ece3e$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $add6d3ca4f7ece3e$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($add6d3ca4f7ece3e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $add6d3ca4f7ece3e$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $add6d3ca4f7ece3e$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $add6d3ca4f7ece3e$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $add6d3ca4f7ece3e$var$checkIfContextChanged(current) ? !0 : !1;
}
function $add6d3ca4f7ece3e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $add6d3ca4f7ece3e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $add6d3ca4f7ece3e$var$pushProvider(workInProgress, $add6d3ca4f7ece3e$var$CacheContext, current.memoizedState.cache);
            $add6d3ca4f7ece3e$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $add6d3ca4f7ece3e$var$pushHostContext(workInProgress);
            break;
        case 4:
            $add6d3ca4f7ece3e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $add6d3ca4f7ece3e$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $add6d3ca4f7ece3e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $add6d3ca4f7ece3e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($add6d3ca4f7ece3e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $add6d3ca4f7ece3e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseStackCursor, $add6d3ca4f7ece3e$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $add6d3ca4f7ece3e$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $add6d3ca4f7ece3e$var$pushProvider(workInProgress, $add6d3ca4f7ece3e$var$CacheContext, current.memoizedState.cache);
    }
    return $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $add6d3ca4f7ece3e$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $add6d3ca4f7ece3e$var$didReceiveUpdate = !0;
        else {
            if (!$add6d3ca4f7ece3e$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $add6d3ca4f7ece3e$var$didReceiveUpdate = !1, $add6d3ca4f7ece3e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $add6d3ca4f7ece3e$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $add6d3ca4f7ece3e$var$didReceiveUpdate = !1, $add6d3ca4f7ece3e$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $add6d3ca4f7ece3e$var$pushTreeId(workInProgress, $add6d3ca4f7ece3e$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $add6d3ca4f7ece3e$var$shouldConstruct(lazyComponent) ? (current = $add6d3ca4f7ece3e$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $add6d3ca4f7ece3e$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $add6d3ca4f7ece3e$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $add6d3ca4f7ece3e$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $add6d3ca4f7ece3e$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $add6d3ca4f7ece3e$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $add6d3ca4f7ece3e$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $add6d3ca4f7ece3e$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $add6d3ca4f7ece3e$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $add6d3ca4f7ece3e$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $add6d3ca4f7ece3e$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $add6d3ca4f7ece3e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $add6d3ca4f7ece3e$var$cloneUpdateQueue(current, workInProgress);
                $add6d3ca4f7ece3e$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $add6d3ca4f7ece3e$var$pushProvider(workInProgress, $add6d3ca4f7ece3e$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $add6d3ca4f7ece3e$var$propagateContextChanges(workInProgress, [
                    $add6d3ca4f7ece3e$var$CacheContext
                ], renderLanes, !0);
                $add6d3ca4f7ece3e$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $add6d3ca4f7ece3e$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(424)), workInProgress);
                        $add6d3ca4f7ece3e$var$queueHydrationError(init);
                        workInProgress = $add6d3ca4f7ece3e$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$getNextHydratable(current.firstChild);
                        $add6d3ca4f7ece3e$var$hydrationParentFiber = workInProgress;
                        $add6d3ca4f7ece3e$var$isHydrating = !0;
                        $add6d3ca4f7ece3e$var$hydrationErrors = null;
                        $add6d3ca4f7ece3e$var$rootOrSingletonContext = !0;
                        renderLanes = $add6d3ca4f7ece3e$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $add6d3ca4f7ece3e$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $add6d3ca4f7ece3e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $add6d3ca4f7ece3e$var$markRef(current, workInProgress), null === current ? (renderLanes = $add6d3ca4f7ece3e$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $add6d3ca4f7ece3e$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $add6d3ca4f7ece3e$var$getOwnerDocumentFromRootContainer($add6d3ca4f7ece3e$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$add6d3ca4f7ece3e$var$internalInstanceKey] = workInProgress, lazyComponent[$add6d3ca4f7ece3e$var$internalPropsKey] = current, $add6d3ca4f7ece3e$var$setInitialProperties(lazyComponent, renderLanes, current), $add6d3ca4f7ece3e$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $add6d3ca4f7ece3e$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $add6d3ca4f7ece3e$var$pushHostContext(workInProgress), null === current && $add6d3ca4f7ece3e$var$isHydrating && (lazyComponent = workInProgress.stateNode = $add6d3ca4f7ece3e$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $add6d3ca4f7ece3e$var$rootInstanceStackCursor.current), $add6d3ca4f7ece3e$var$hydrationParentFiber = workInProgress, $add6d3ca4f7ece3e$var$rootOrSingletonContext = !0, init = $add6d3ca4f7ece3e$var$nextHydratableInstance, $add6d3ca4f7ece3e$var$isSingletonScope(workInProgress.type) ? ($add6d3ca4f7ece3e$var$previousHydratableOnEnteringScopedSingleton = init, $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$getNextHydratable(lazyComponent.firstChild)) : $add6d3ca4f7ece3e$var$nextHydratableInstance = init), $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $add6d3ca4f7ece3e$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $add6d3ca4f7ece3e$var$isHydrating) {
                if (init = lazyComponent = $add6d3ca4f7ece3e$var$nextHydratableInstance) lazyComponent = $add6d3ca4f7ece3e$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $add6d3ca4f7ece3e$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $add6d3ca4f7ece3e$var$hydrationParentFiber = workInProgress, $add6d3ca4f7ece3e$var$nextHydratableInstance = $add6d3ca4f7ece3e$var$getNextHydratable(lazyComponent.firstChild), $add6d3ca4f7ece3e$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(workInProgress);
            }
            $add6d3ca4f7ece3e$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $add6d3ca4f7ece3e$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $add6d3ca4f7ece3e$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $add6d3ca4f7ece3e$var$renderWithHooks(current, workInProgress, $add6d3ca4f7ece3e$var$TransitionAwareHostComponent, null, null, renderLanes), $add6d3ca4f7ece3e$var$HostTransitionContext._currentValue = init);
            $add6d3ca4f7ece3e$var$markRef(current, workInProgress);
            $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $add6d3ca4f7ece3e$var$isHydrating) {
                if (current = renderLanes = $add6d3ca4f7ece3e$var$nextHydratableInstance) renderLanes = $add6d3ca4f7ece3e$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $add6d3ca4f7ece3e$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $add6d3ca4f7ece3e$var$hydrationParentFiber = workInProgress, $add6d3ca4f7ece3e$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $add6d3ca4f7ece3e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $add6d3ca4f7ece3e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $add6d3ca4f7ece3e$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $add6d3ca4f7ece3e$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $add6d3ca4f7ece3e$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $add6d3ca4f7ece3e$var$prepareToReadContext(workInProgress), init = $add6d3ca4f7ece3e$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $add6d3ca4f7ece3e$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $add6d3ca4f7ece3e$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $add6d3ca4f7ece3e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $add6d3ca4f7ece3e$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $add6d3ca4f7ece3e$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $add6d3ca4f7ece3e$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $add6d3ca4f7ece3e$var$prepareToReadContext(workInProgress), lazyComponent = $add6d3ca4f7ece3e$var$readContext($add6d3ca4f7ece3e$var$CacheContext), null === current ? (init = $add6d3ca4f7ece3e$var$peekCacheFromPool(), null === init && (init = $add6d3ca4f7ece3e$var$workInProgressRoot, prevState = $add6d3ca4f7ece3e$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $add6d3ca4f7ece3e$var$initializeUpdateQueue(workInProgress), $add6d3ca4f7ece3e$var$pushProvider(workInProgress, $add6d3ca4f7ece3e$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($add6d3ca4f7ece3e$var$cloneUpdateQueue(current, workInProgress), $add6d3ca4f7ece3e$var$processUpdateQueue(workInProgress, null, null, renderLanes), $add6d3ca4f7ece3e$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $add6d3ca4f7ece3e$var$pushProvider(workInProgress, $add6d3ca4f7ece3e$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $add6d3ca4f7ece3e$var$pushProvider(workInProgress, $add6d3ca4f7ece3e$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $add6d3ca4f7ece3e$var$propagateContextChanges(workInProgress, [
                $add6d3ca4f7ece3e$var$CacheContext
            ], renderLanes, !0))), $add6d3ca4f7ece3e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $add6d3ca4f7ece3e$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $add6d3ca4f7ece3e$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$add6d3ca4f7ece3e$var$preloadResource(resource)) {
        resource = $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 4194048) === $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes ? null !== $add6d3ca4f7ece3e$var$shellBoundary : ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 62914560) !== $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes && 0 === ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 536870912) || resource !== $add6d3ca4f7ece3e$var$shellBoundary)) throw $add6d3ca4f7ece3e$var$suspendedThenable = $add6d3ca4f7ece3e$var$noopSuspenseyCommitThenable, $add6d3ca4f7ece3e$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $add6d3ca4f7ece3e$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $add6d3ca4f7ece3e$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $add6d3ca4f7ece3e$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $add6d3ca4f7ece3e$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$add6d3ca4f7ece3e$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $add6d3ca4f7ece3e$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $add6d3ca4f7ece3e$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $add6d3ca4f7ece3e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), null;
        case 1:
            return $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $add6d3ca4f7ece3e$var$popProvider($add6d3ca4f7ece3e$var$CacheContext);
            $add6d3ca4f7ece3e$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $add6d3ca4f7ece3e$var$popHydrationState(workInProgress) ? $add6d3ca4f7ece3e$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $add6d3ca4f7ece3e$var$upgradeHydrationErrorsToRecoverable());
            $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($add6d3ca4f7ece3e$var$markUpdate(workInProgress), null !== renderLanes ? ($add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), $add6d3ca4f7ece3e$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($add6d3ca4f7ece3e$var$markUpdate(workInProgress), $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), $add6d3ca4f7ece3e$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $add6d3ca4f7ece3e$var$markUpdate(workInProgress), $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $add6d3ca4f7ece3e$var$popHostContext(workInProgress);
            renderLanes = $add6d3ca4f7ece3e$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $add6d3ca4f7ece3e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(166));
                    $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $add6d3ca4f7ece3e$var$contextStackCursor.current;
                $add6d3ca4f7ece3e$var$popHydrationState(workInProgress) ? $add6d3ca4f7ece3e$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $add6d3ca4f7ece3e$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $add6d3ca4f7ece3e$var$markUpdate(workInProgress));
            }
            $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $add6d3ca4f7ece3e$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $add6d3ca4f7ece3e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(166));
                    $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $add6d3ca4f7ece3e$var$contextStackCursor.current;
                if ($add6d3ca4f7ece3e$var$popHydrationState(workInProgress)) $add6d3ca4f7ece3e$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $add6d3ca4f7ece3e$var$getOwnerDocumentFromRootContainer($add6d3ca4f7ece3e$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$add6d3ca4f7ece3e$var$internalInstanceKey] = workInProgress;
                    current[$add6d3ca4f7ece3e$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($add6d3ca4f7ece3e$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $add6d3ca4f7ece3e$var$markUpdate(workInProgress);
                }
            }
            $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $add6d3ca4f7ece3e$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(166));
                current = $add6d3ca4f7ece3e$var$rootInstanceStackCursor.current;
                if ($add6d3ca4f7ece3e$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $add6d3ca4f7ece3e$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$add6d3ca4f7ece3e$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $add6d3ca4f7ece3e$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $add6d3ca4f7ece3e$var$throwOnHydrationMismatch(workInProgress);
                } else current = $add6d3ca4f7ece3e$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$add6d3ca4f7ece3e$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $add6d3ca4f7ece3e$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(317));
                        type[$add6d3ca4f7ece3e$var$internalInstanceKey] = workInProgress;
                    } else $add6d3ca4f7ece3e$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $add6d3ca4f7ece3e$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $add6d3ca4f7ece3e$var$popSuspenseHandler(workInProgress), workInProgress;
                    $add6d3ca4f7ece3e$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $add6d3ca4f7ece3e$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $add6d3ca4f7ece3e$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $add6d3ca4f7ece3e$var$popHostContainer(), null === current && $add6d3ca4f7ece3e$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), null;
        case 10:
            return $add6d3ca4f7ece3e$var$popProvider(workInProgress.type), $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), null;
        case 19:
            $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $add6d3ca4f7ece3e$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $add6d3ca4f7ece3e$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $add6d3ca4f7ece3e$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $add6d3ca4f7ece3e$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $add6d3ca4f7ece3e$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$add6d3ca4f7ece3e$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseStackCursor, $add6d3ca4f7ece3e$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $add6d3ca4f7ece3e$var$now() > $add6d3ca4f7ece3e$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $add6d3ca4f7ece3e$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $add6d3ca4f7ece3e$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $add6d3ca4f7ece3e$var$scheduleRetryEffect(workInProgress, current), $add6d3ca4f7ece3e$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$add6d3ca4f7ece3e$var$isHydrating) return $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), null;
                    } else 2 * $add6d3ca4f7ece3e$var$now() - type.renderingStartTime > $add6d3ca4f7ece3e$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $add6d3ca4f7ece3e$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $add6d3ca4f7ece3e$var$now(), workInProgress.sibling = null, current = $add6d3ca4f7ece3e$var$suspenseStackCursor.current, $add6d3ca4f7ece3e$var$push($add6d3ca4f7ece3e$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $add6d3ca4f7ece3e$var$popSuspenseHandler(workInProgress), $add6d3ca4f7ece3e$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $add6d3ca4f7ece3e$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $add6d3ca4f7ece3e$var$popProvider($add6d3ca4f7ece3e$var$CacheContext), $add6d3ca4f7ece3e$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $add6d3ca4f7ece3e$var$unwindWork(current, workInProgress) {
    $add6d3ca4f7ece3e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $add6d3ca4f7ece3e$var$popProvider($add6d3ca4f7ece3e$var$CacheContext), $add6d3ca4f7ece3e$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $add6d3ca4f7ece3e$var$popHostContext(workInProgress), null;
        case 13:
            $add6d3ca4f7ece3e$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(340));
                $add6d3ca4f7ece3e$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$suspenseStackCursor), null;
        case 4:
            return $add6d3ca4f7ece3e$var$popHostContainer(), null;
        case 10:
            return $add6d3ca4f7ece3e$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $add6d3ca4f7ece3e$var$popSuspenseHandler(workInProgress), $add6d3ca4f7ece3e$var$popHiddenContext(), null !== current && $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $add6d3ca4f7ece3e$var$popProvider($add6d3ca4f7ece3e$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $add6d3ca4f7ece3e$var$unwindInterruptedWork(current, interruptedWork) {
    $add6d3ca4f7ece3e$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $add6d3ca4f7ece3e$var$popProvider($add6d3ca4f7ece3e$var$CacheContext);
            $add6d3ca4f7ece3e$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $add6d3ca4f7ece3e$var$popHostContext(interruptedWork);
            break;
        case 4:
            $add6d3ca4f7ece3e$var$popHostContainer();
            break;
        case 13:
            $add6d3ca4f7ece3e$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$suspenseStackCursor);
            break;
        case 10:
            $add6d3ca4f7ece3e$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $add6d3ca4f7ece3e$var$popSuspenseHandler(interruptedWork);
            $add6d3ca4f7ece3e$var$popHiddenContext();
            null !== current && $add6d3ca4f7ece3e$var$pop($add6d3ca4f7ece3e$var$resumedCache);
            break;
        case 24:
            $add6d3ca4f7ece3e$var$popProvider($add6d3ca4f7ece3e$var$CacheContext);
    }
}
function $add6d3ca4f7ece3e$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $add6d3ca4f7ece3e$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $add6d3ca4f7ece3e$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $add6d3ca4f7ece3e$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $add6d3ca4f7ece3e$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $add6d3ca4f7ece3e$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $add6d3ca4f7ece3e$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $add6d3ca4f7ece3e$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $add6d3ca4f7ece3e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $add6d3ca4f7ece3e$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $add6d3ca4f7ece3e$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $add6d3ca4f7ece3e$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $add6d3ca4f7ece3e$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$add6d3ca4f7ece3e$var$internalPropsKey] = newProps;
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $add6d3ca4f7ece3e$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $add6d3ca4f7ece3e$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $add6d3ca4f7ece3e$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $add6d3ca4f7ece3e$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $add6d3ca4f7ece3e$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $add6d3ca4f7ece3e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $add6d3ca4f7ece3e$var$noop$1));
    else if (4 !== tag && (27 === tag && $add6d3ca4f7ece3e$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($add6d3ca4f7ece3e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$add6d3ca4f7ece3e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $add6d3ca4f7ece3e$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $add6d3ca4f7ece3e$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($add6d3ca4f7ece3e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$add6d3ca4f7ece3e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $add6d3ca4f7ece3e$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $add6d3ca4f7ece3e$var$setInitialProperties(singleton, type, props);
        singleton[$add6d3ca4f7ece3e$var$internalInstanceKey] = finishedWork;
        singleton[$add6d3ca4f7ece3e$var$internalPropsKey] = props;
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden = !1, $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden = !1, $add6d3ca4f7ece3e$var$needsFormReset = !1, $add6d3ca4f7ece3e$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $add6d3ca4f7ece3e$var$nextEffect = null;
function $add6d3ca4f7ece3e$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $add6d3ca4f7ece3e$var$eventsEnabled = $add6d3ca4f7ece3e$var$_enabled;
    root = $add6d3ca4f7ece3e$var$getActiveElementDeep(root);
    if ($add6d3ca4f7ece3e$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $add6d3ca4f7ece3e$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $add6d3ca4f7ece3e$var$_enabled = !1;
    for($add6d3ca4f7ece3e$var$nextEffect = firstChild; null !== $add6d3ca4f7ece3e$var$nextEffect;)if (firstChild = $add6d3ca4f7ece3e$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $add6d3ca4f7ece3e$var$nextEffect = root;
    else for(; null !== $add6d3ca4f7ece3e$var$nextEffect;){
        firstChild = $add6d3ca4f7ece3e$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $add6d3ca4f7ece3e$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $add6d3ca4f7ece3e$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $add6d3ca4f7ece3e$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $add6d3ca4f7ece3e$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $add6d3ca4f7ece3e$var$nextEffect = root;
            break;
        }
        $add6d3ca4f7ece3e$var$nextEffect = firstChild.return;
    }
}
function $add6d3ca4f7ece3e$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $add6d3ca4f7ece3e$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $add6d3ca4f7ece3e$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $add6d3ca4f7ece3e$var$commitClassCallbacks(finishedWork);
            flags & 512 && $add6d3ca4f7ece3e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $add6d3ca4f7ece3e$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $add6d3ca4f7ece3e$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $add6d3ca4f7ece3e$var$commitHostMount(finishedWork);
            flags & 512 && $add6d3ca4f7ece3e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $add6d3ca4f7ece3e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $add6d3ca4f7ece3e$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $add6d3ca4f7ece3e$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden;
                prevProps = $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden;
                $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden = flags;
                ($add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden = prevProps;
                $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $add6d3ca4f7ece3e$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $add6d3ca4f7ece3e$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $add6d3ca4f7ece3e$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $add6d3ca4f7ece3e$var$hostParent = null, $add6d3ca4f7ece3e$var$hostParentIsContainer = !1;
function $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$add6d3ca4f7ece3e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $add6d3ca4f7ece3e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($add6d3ca4f7ece3e$var$injectedHook && "function" === typeof $add6d3ca4f7ece3e$var$injectedHook.onCommitFiberUnmount) try {
        $add6d3ca4f7ece3e$var$injectedHook.onCommitFiberUnmount($add6d3ca4f7ece3e$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || $add6d3ca4f7ece3e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || $add6d3ca4f7ece3e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $add6d3ca4f7ece3e$var$hostParent, prevHostParentIsContainer = $add6d3ca4f7ece3e$var$hostParentIsContainer;
            $add6d3ca4f7ece3e$var$isSingletonScope(deletedFiber.type) && ($add6d3ca4f7ece3e$var$hostParent = deletedFiber.stateNode, $add6d3ca4f7ece3e$var$hostParentIsContainer = !1);
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $add6d3ca4f7ece3e$var$releaseSingletonInstance(deletedFiber.stateNode);
            $add6d3ca4f7ece3e$var$hostParent = prevHostParent;
            $add6d3ca4f7ece3e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || $add6d3ca4f7ece3e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $add6d3ca4f7ece3e$var$hostParent;
            prevHostParentIsContainer = $add6d3ca4f7ece3e$var$hostParentIsContainer;
            $add6d3ca4f7ece3e$var$hostParent = null;
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $add6d3ca4f7ece3e$var$hostParent = prevHostParent;
            $add6d3ca4f7ece3e$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $add6d3ca4f7ece3e$var$hostParent) {
                if ($add6d3ca4f7ece3e$var$hostParentIsContainer) try {
                    (9 === $add6d3ca4f7ece3e$var$hostParent.nodeType ? $add6d3ca4f7ece3e$var$hostParent.body : "HTML" === $add6d3ca4f7ece3e$var$hostParent.nodeName ? $add6d3ca4f7ece3e$var$hostParent.ownerDocument.body : $add6d3ca4f7ece3e$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $add6d3ca4f7ece3e$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $add6d3ca4f7ece3e$var$hostParent && ($add6d3ca4f7ece3e$var$hostParentIsContainer ? (finishedRoot = $add6d3ca4f7ece3e$var$hostParent, $add6d3ca4f7ece3e$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $add6d3ca4f7ece3e$var$retryIfBlockedOn(finishedRoot)) : $add6d3ca4f7ece3e$var$clearSuspenseBoundary($add6d3ca4f7ece3e$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $add6d3ca4f7ece3e$var$hostParent;
            prevHostParentIsContainer = $add6d3ca4f7ece3e$var$hostParentIsContainer;
            $add6d3ca4f7ece3e$var$hostParent = deletedFiber.stateNode.containerInfo;
            $add6d3ca4f7ece3e$var$hostParentIsContainer = !0;
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $add6d3ca4f7ece3e$var$hostParent = prevHostParent;
            $add6d3ca4f7ece3e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || ($add6d3ca4f7ece3e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $add6d3ca4f7ece3e$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden = (prevHostParent = $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $add6d3ca4f7ece3e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $add6d3ca4f7ece3e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $add6d3ca4f7ece3e$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $add6d3ca4f7ece3e$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $add6d3ca4f7ece3e$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $add6d3ca4f7ece3e$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $add6d3ca4f7ece3e$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $add6d3ca4f7ece3e$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $add6d3ca4f7ece3e$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($add6d3ca4f7ece3e$var$isSingletonScope(parent.type)) {
                        $add6d3ca4f7ece3e$var$hostParent = parent.stateNode;
                        $add6d3ca4f7ece3e$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $add6d3ca4f7ece3e$var$hostParent = parent.stateNode;
                    $add6d3ca4f7ece3e$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $add6d3ca4f7ece3e$var$hostParent = parent.stateNode.containerInfo;
                    $add6d3ca4f7ece3e$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $add6d3ca4f7ece3e$var$hostParent) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(160));
        $add6d3ca4f7ece3e$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $add6d3ca4f7ece3e$var$hostParent = null;
        $add6d3ca4f7ece3e$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$add6d3ca4f7ece3e$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $add6d3ca4f7ece3e$var$currentHoistableRoot = null;
function $add6d3ca4f7ece3e$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($add6d3ca4f7ece3e$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $add6d3ca4f7ece3e$var$commitHookEffectListMount(3, finishedWork), $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || null === current || $add6d3ca4f7ece3e$var$safelyDetachRef(current, current.return));
            flags & 64 && $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $add6d3ca4f7ece3e$var$currentHoistableRoot;
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || null === current || $add6d3ca4f7ece3e$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$add6d3ca4f7ece3e$var$internalHoistableMarker] || currentResource[$add6d3ca4f7ece3e$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $add6d3ca4f7ece3e$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$add6d3ca4f7ece3e$var$internalInstanceKey] = finishedWork;
                                        $add6d3ca4f7ece3e$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $add6d3ca4f7ece3e$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $add6d3ca4f7ece3e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $add6d3ca4f7ece3e$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $add6d3ca4f7ece3e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$add6d3ca4f7ece3e$var$internalInstanceKey] = finishedWork;
                                $add6d3ca4f7ece3e$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $add6d3ca4f7ece3e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $add6d3ca4f7ece3e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $add6d3ca4f7ece3e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $add6d3ca4f7ece3e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $add6d3ca4f7ece3e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || null === current || $add6d3ca4f7ece3e$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $add6d3ca4f7ece3e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || null === current || $add6d3ca4f7ece3e$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $add6d3ca4f7ece3e$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $add6d3ca4f7ece3e$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($add6d3ca4f7ece3e$var$needsFormReset = !0);
            break;
        case 6:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $add6d3ca4f7ece3e$var$tagCaches = null;
            hoistableRoot = $add6d3ca4f7ece3e$var$currentHoistableRoot;
            $add6d3ca4f7ece3e$var$currentHoistableRoot = $add6d3ca4f7ece3e$var$getHoistableRoot(root.containerInfo);
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$currentHoistableRoot = hoistableRoot;
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $add6d3ca4f7ece3e$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $add6d3ca4f7ece3e$var$needsFormReset && ($add6d3ca4f7ece3e$var$needsFormReset = !1, $add6d3ca4f7ece3e$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $add6d3ca4f7ece3e$var$currentHoistableRoot;
            $add6d3ca4f7ece3e$var$currentHoistableRoot = $add6d3ca4f7ece3e$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            $add6d3ca4f7ece3e$var$currentHoistableRoot = flags;
            break;
        case 12:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($add6d3ca4f7ece3e$var$globalMostRecentFallbackTime = $add6d3ca4f7ece3e$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $add6d3ca4f7ece3e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden;
            $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $add6d3ca4f7ece3e$var$offscreenSubtreeIsHidden || $add6d3ca4f7ece3e$var$offscreenSubtreeWasHidden || $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $add6d3ca4f7ece3e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $add6d3ca4f7ece3e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $add6d3ca4f7ece3e$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $add6d3ca4f7ece3e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $add6d3ca4f7ece3e$var$recursivelyTraverseMutationEffects(root, finishedWork), $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork);
    }
}
function $add6d3ca4f7ece3e$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($add6d3ca4f7ece3e$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $add6d3ca4f7ece3e$var$getHostSibling(finishedWork);
                    $add6d3ca4f7ece3e$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($add6d3ca4f7ece3e$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $add6d3ca4f7ece3e$var$getHostSibling(finishedWork);
                    $add6d3ca4f7ece3e$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $add6d3ca4f7ece3e$var$getHostSibling(finishedWork);
                    $add6d3ca4f7ece3e$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $add6d3ca4f7ece3e$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $add6d3ca4f7ece3e$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $add6d3ca4f7ece3e$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$add6d3ca4f7ece3e$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $add6d3ca4f7ece3e$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $add6d3ca4f7ece3e$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $add6d3ca4f7ece3e$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $add6d3ca4f7ece3e$var$safelyDetachRef(finishedWork, finishedWork.return);
                $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $add6d3ca4f7ece3e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $add6d3ca4f7ece3e$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$add6d3ca4f7ece3e$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $add6d3ca4f7ece3e$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $add6d3ca4f7ece3e$var$commitClassCallbacks(finishedWork);
                $add6d3ca4f7ece3e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $add6d3ca4f7ece3e$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $add6d3ca4f7ece3e$var$commitHostMount(finishedWork);
                $add6d3ca4f7ece3e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $add6d3ca4f7ece3e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $add6d3ca4f7ece3e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $add6d3ca4f7ece3e$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $add6d3ca4f7ece3e$var$releaseCache(previousCache));
}
function $add6d3ca4f7ece3e$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $add6d3ca4f7ece3e$var$releaseCache(current));
}
function $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$add6d3ca4f7ece3e$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $add6d3ca4f7ece3e$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $add6d3ca4f7ece3e$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $add6d3ca4f7ece3e$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $add6d3ca4f7ece3e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $add6d3ca4f7ece3e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $add6d3ca4f7ece3e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $add6d3ca4f7ece3e$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $add6d3ca4f7ece3e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $add6d3ca4f7ece3e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $add6d3ca4f7ece3e$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $add6d3ca4f7ece3e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $add6d3ca4f7ece3e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $add6d3ca4f7ece3e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $add6d3ca4f7ece3e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $add6d3ca4f7ece3e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $add6d3ca4f7ece3e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $add6d3ca4f7ece3e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $add6d3ca4f7ece3e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $add6d3ca4f7ece3e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $add6d3ca4f7ece3e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $add6d3ca4f7ece3e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $add6d3ca4f7ece3e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $add6d3ca4f7ece3e$var$suspenseyCommitFlag = 8192;
function $add6d3ca4f7ece3e$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $add6d3ca4f7ece3e$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$add6d3ca4f7ece3e$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $add6d3ca4f7ece3e$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $add6d3ca4f7ece3e$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $add6d3ca4f7ece3e$var$suspenseyCommitFlag && null !== fiber.memoizedState && $add6d3ca4f7ece3e$var$suspendResource($add6d3ca4f7ece3e$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $add6d3ca4f7ece3e$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $add6d3ca4f7ece3e$var$currentHoistableRoot;
            $add6d3ca4f7ece3e$var$currentHoistableRoot = $add6d3ca4f7ece3e$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $add6d3ca4f7ece3e$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $add6d3ca4f7ece3e$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $add6d3ca4f7ece3e$var$suspenseyCommitFlag, $add6d3ca4f7ece3e$var$suspenseyCommitFlag = 16777216, $add6d3ca4f7ece3e$var$recursivelyAccumulateSuspenseyCommit(fiber), $add6d3ca4f7ece3e$var$suspenseyCommitFlag = previousHoistableRoot) : $add6d3ca4f7ece3e$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $add6d3ca4f7ece3e$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $add6d3ca4f7ece3e$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $add6d3ca4f7ece3e$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $add6d3ca4f7ece3e$var$nextEffect = childToDelete;
            $add6d3ca4f7ece3e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $add6d3ca4f7ece3e$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$add6d3ca4f7ece3e$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $add6d3ca4f7ece3e$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $add6d3ca4f7ece3e$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $add6d3ca4f7ece3e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $add6d3ca4f7ece3e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $add6d3ca4f7ece3e$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $add6d3ca4f7ece3e$var$nextEffect = childToDelete;
            $add6d3ca4f7ece3e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $add6d3ca4f7ece3e$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $add6d3ca4f7ece3e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $add6d3ca4f7ece3e$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $add6d3ca4f7ece3e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $add6d3ca4f7ece3e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $add6d3ca4f7ece3e$var$nextEffect;){
        var fiber = $add6d3ca4f7ece3e$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $add6d3ca4f7ece3e$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $add6d3ca4f7ece3e$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $add6d3ca4f7ece3e$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $add6d3ca4f7ece3e$var$nextEffect;){
            cache = $add6d3ca4f7ece3e$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $add6d3ca4f7ece3e$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $add6d3ca4f7ece3e$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $add6d3ca4f7ece3e$var$nextEffect = sibling;
                break a;
            }
            $add6d3ca4f7ece3e$var$nextEffect = returnFiber;
        }
    }
}
var $add6d3ca4f7ece3e$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $add6d3ca4f7ece3e$var$readContext($add6d3ca4f7ece3e$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $add6d3ca4f7ece3e$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $add6d3ca4f7ece3e$var$executionContext = 0, $add6d3ca4f7ece3e$var$workInProgressRoot = null, $add6d3ca4f7ece3e$var$workInProgress = null, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes = 0, $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0, $add6d3ca4f7ece3e$var$workInProgressThrownValue = null, $add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings = !1, $add6d3ca4f7ece3e$var$workInProgressRootIsPrerendering = !1, $add6d3ca4f7ece3e$var$workInProgressRootDidAttachPingListener = !1, $add6d3ca4f7ece3e$var$entangledRenderLanes = 0, $add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 0, $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes = 0, $add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes = 0, $add6d3ca4f7ece3e$var$workInProgressRootPingedLanes = 0, $add6d3ca4f7ece3e$var$workInProgressDeferredLane = 0, $add6d3ca4f7ece3e$var$workInProgressSuspendedRetryLanes = 0, $add6d3ca4f7ece3e$var$workInProgressRootConcurrentErrors = null, $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors = null, $add6d3ca4f7ece3e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $add6d3ca4f7ece3e$var$globalMostRecentFallbackTime = 0, $add6d3ca4f7ece3e$var$workInProgressRootRenderTargetTime = Infinity, $add6d3ca4f7ece3e$var$workInProgressTransitions = null, $add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed = null, $add6d3ca4f7ece3e$var$pendingEffectsStatus = 0, $add6d3ca4f7ece3e$var$pendingEffectsRoot = null, $add6d3ca4f7ece3e$var$pendingFinishedWork = null, $add6d3ca4f7ece3e$var$pendingEffectsLanes = 0, $add6d3ca4f7ece3e$var$pendingEffectsRemainingLanes = 0, $add6d3ca4f7ece3e$var$pendingPassiveTransitions = null, $add6d3ca4f7ece3e$var$pendingRecoverableErrors = null, $add6d3ca4f7ece3e$var$nestedUpdateCount = 0, $add6d3ca4f7ece3e$var$rootWithNestedUpdates = null;
function $add6d3ca4f7ece3e$var$requestUpdateLane() {
    if (0 !== ($add6d3ca4f7ece3e$var$executionContext & 2) && 0 !== $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes) return $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & -$add6d3ca4f7ece3e$var$workInProgressRootRenderLanes;
    if (null !== $add6d3ca4f7ece3e$var$ReactSharedInternals.T) {
        var actionScopeLane = $add6d3ca4f7ece3e$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $add6d3ca4f7ece3e$var$requestTransitionLane();
    }
    return $add6d3ca4f7ece3e$var$resolveUpdatePriority();
}
function $add6d3ca4f7ece3e$var$requestDeferredLane() {
    0 === $add6d3ca4f7ece3e$var$workInProgressDeferredLane && ($add6d3ca4f7ece3e$var$workInProgressDeferredLane = 0 === ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 536870912) || $add6d3ca4f7ece3e$var$isHydrating ? $add6d3ca4f7ece3e$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $add6d3ca4f7ece3e$var$workInProgressDeferredLane;
}
function $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $add6d3ca4f7ece3e$var$workInProgressRoot && (2 === $add6d3ca4f7ece3e$var$workInProgressSuspendedReason || 9 === $add6d3ca4f7ece3e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $add6d3ca4f7ece3e$var$prepareFreshStack(root, 0), $add6d3ca4f7ece3e$var$markRootSuspended(root, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes, $add6d3ca4f7ece3e$var$workInProgressDeferredLane, !1);
    $add6d3ca4f7ece3e$var$markRootUpdated$1(root, lane);
    if (0 === ($add6d3ca4f7ece3e$var$executionContext & 2) || root !== $add6d3ca4f7ece3e$var$workInProgressRoot) root === $add6d3ca4f7ece3e$var$workInProgressRoot && (0 === ($add6d3ca4f7ece3e$var$executionContext & 2) && ($add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $add6d3ca4f7ece3e$var$workInProgressRootExitStatus && $add6d3ca4f7ece3e$var$markRootSuspended(root, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes, $add6d3ca4f7ece3e$var$workInProgressDeferredLane, !1)), $add6d3ca4f7ece3e$var$ensureRootIsScheduled(root);
}
function $add6d3ca4f7ece3e$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($add6d3ca4f7ece3e$var$executionContext & 6)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $add6d3ca4f7ece3e$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $add6d3ca4f7ece3e$var$renderRootConcurrent(root$jscomp$0, lanes) : $add6d3ca4f7ece3e$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $add6d3ca4f7ece3e$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $add6d3ca4f7ece3e$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$add6d3ca4f7ece3e$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $add6d3ca4f7ece3e$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $add6d3ca4f7ece3e$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($add6d3ca4f7ece3e$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $add6d3ca4f7ece3e$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($add6d3ca4f7ece3e$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors;
                            $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors ? $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors.push.apply($add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $add6d3ca4f7ece3e$var$prepareFreshStack(root$jscomp$0, 0);
                $add6d3ca4f7ece3e$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $add6d3ca4f7ece3e$var$markRootSuspended(shouldTimeSlice, lanes, $add6d3ca4f7ece3e$var$workInProgressDeferredLane, !$add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $add6d3ca4f7ece3e$var$globalMostRecentFallbackTime + 300 - $add6d3ca4f7ece3e$var$now(), 10 < exitStatus)) {
                    $add6d3ca4f7ece3e$var$markRootSuspended(shouldTimeSlice, lanes, $add6d3ca4f7ece3e$var$workInProgressDeferredLane, !$add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $add6d3ca4f7ece3e$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $add6d3ca4f7ece3e$var$scheduleTimeout($add6d3ca4f7ece3e$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors, $add6d3ca4f7ece3e$var$workInProgressTransitions, $add6d3ca4f7ece3e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $add6d3ca4f7ece3e$var$workInProgressDeferredLane, $add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes, $add6d3ca4f7ece3e$var$workInProgressSuspendedRetryLanes, $add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $add6d3ca4f7ece3e$var$commitRootWhenReady(shouldTimeSlice, forceSync, $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors, $add6d3ca4f7ece3e$var$workInProgressTransitions, $add6d3ca4f7ece3e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $add6d3ca4f7ece3e$var$workInProgressDeferredLane, $add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes, $add6d3ca4f7ece3e$var$workInProgressSuspendedRetryLanes, $add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $add6d3ca4f7ece3e$var$ensureRootIsScheduled(root$jscomp$0);
}
function $add6d3ca4f7ece3e$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($add6d3ca4f7ece3e$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $add6d3ca4f7ece3e$var$noop
        }, $add6d3ca4f7ece3e$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $add6d3ca4f7ece3e$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($add6d3ca4f7ece3e$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $add6d3ca4f7ece3e$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $add6d3ca4f7ece3e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $add6d3ca4f7ece3e$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$add6d3ca4f7ece3e$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $add6d3ca4f7ece3e$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$add6d3ca4f7ece3e$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $add6d3ca4f7ece3e$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $add6d3ca4f7ece3e$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $add6d3ca4f7ece3e$var$flushSyncWork$1() {
    return 0 === ($add6d3ca4f7ece3e$var$executionContext & 6) ? ($add6d3ca4f7ece3e$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $add6d3ca4f7ece3e$var$resetWorkInProgressStack() {
    if (null !== $add6d3ca4f7ece3e$var$workInProgress) {
        if (0 === $add6d3ca4f7ece3e$var$workInProgressSuspendedReason) var interruptedWork = $add6d3ca4f7ece3e$var$workInProgress.return;
        else interruptedWork = $add6d3ca4f7ece3e$var$workInProgress, $add6d3ca4f7ece3e$var$lastContextDependency = $add6d3ca4f7ece3e$var$currentlyRenderingFiber$1 = null, $add6d3ca4f7ece3e$var$resetHooksOnUnwind(interruptedWork), $add6d3ca4f7ece3e$var$thenableState = null, $add6d3ca4f7ece3e$var$thenableIndexCounter = 0, interruptedWork = $add6d3ca4f7ece3e$var$workInProgress;
        for(; null !== interruptedWork;)$add6d3ca4f7ece3e$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $add6d3ca4f7ece3e$var$workInProgress = null;
    }
}
function $add6d3ca4f7ece3e$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $add6d3ca4f7ece3e$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $add6d3ca4f7ece3e$var$resetWorkInProgressStack();
    $add6d3ca4f7ece3e$var$workInProgressRoot = root;
    $add6d3ca4f7ece3e$var$workInProgress = timeoutHandle = $add6d3ca4f7ece3e$var$createWorkInProgress(root.current, null);
    $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes = lanes;
    $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0;
    $add6d3ca4f7ece3e$var$workInProgressThrownValue = null;
    $add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $add6d3ca4f7ece3e$var$workInProgressRootIsPrerendering = $add6d3ca4f7ece3e$var$checkIfRootIsPrerendering(root, lanes);
    $add6d3ca4f7ece3e$var$workInProgressRootDidAttachPingListener = !1;
    $add6d3ca4f7ece3e$var$workInProgressSuspendedRetryLanes = $add6d3ca4f7ece3e$var$workInProgressDeferredLane = $add6d3ca4f7ece3e$var$workInProgressRootPingedLanes = $add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes = $add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes = $add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 0;
    $add6d3ca4f7ece3e$var$workInProgressRootRecoverableErrors = $add6d3ca4f7ece3e$var$workInProgressRootConcurrentErrors = null;
    $add6d3ca4f7ece3e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $add6d3ca4f7ece3e$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $add6d3ca4f7ece3e$var$entangledRenderLanes = lanes;
    $add6d3ca4f7ece3e$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $add6d3ca4f7ece3e$var$handleThrow(root, thrownValue) {
    $add6d3ca4f7ece3e$var$currentlyRenderingFiber = null;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.H = $add6d3ca4f7ece3e$var$ContextOnlyDispatcher;
    thrownValue === $add6d3ca4f7ece3e$var$SuspenseException || thrownValue === $add6d3ca4f7ece3e$var$SuspenseActionException ? (thrownValue = $add6d3ca4f7ece3e$var$getSuspendedThenable(), $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 3) : thrownValue === $add6d3ca4f7ece3e$var$SuspenseyCommitException ? (thrownValue = $add6d3ca4f7ece3e$var$getSuspendedThenable(), $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 4) : $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = thrownValue === $add6d3ca4f7ece3e$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $add6d3ca4f7ece3e$var$workInProgressThrownValue = thrownValue;
    null === $add6d3ca4f7ece3e$var$workInProgress && ($add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 1, $add6d3ca4f7ece3e$var$logUncaughtError(root, $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $add6d3ca4f7ece3e$var$pushDispatcher() {
    var prevDispatcher = $add6d3ca4f7ece3e$var$ReactSharedInternals.H;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.H = $add6d3ca4f7ece3e$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $add6d3ca4f7ece3e$var$ContextOnlyDispatcher : prevDispatcher;
}
function $add6d3ca4f7ece3e$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $add6d3ca4f7ece3e$var$ReactSharedInternals.A;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.A = $add6d3ca4f7ece3e$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $add6d3ca4f7ece3e$var$renderDidSuspendDelayIfPossible() {
    $add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 4;
    $add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings || ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 4194048) !== $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes && null !== $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current || ($add6d3ca4f7ece3e$var$workInProgressRootIsPrerendering = !0);
    0 === ($add6d3ca4f7ece3e$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($add6d3ca4f7ece3e$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $add6d3ca4f7ece3e$var$workInProgressRoot || $add6d3ca4f7ece3e$var$markRootSuspended($add6d3ca4f7ece3e$var$workInProgressRoot, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes, $add6d3ca4f7ece3e$var$workInProgressDeferredLane, !1);
}
function $add6d3ca4f7ece3e$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $add6d3ca4f7ece3e$var$executionContext;
    $add6d3ca4f7ece3e$var$executionContext |= 2;
    var prevDispatcher = $add6d3ca4f7ece3e$var$pushDispatcher(), prevAsyncDispatcher = $add6d3ca4f7ece3e$var$pushAsyncDispatcher();
    if ($add6d3ca4f7ece3e$var$workInProgressRoot !== root || $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes !== lanes) $add6d3ca4f7ece3e$var$workInProgressTransitions = null, $add6d3ca4f7ece3e$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $add6d3ca4f7ece3e$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $add6d3ca4f7ece3e$var$workInProgressSuspendedReason && null !== $add6d3ca4f7ece3e$var$workInProgress) {
            var unitOfWork = $add6d3ca4f7ece3e$var$workInProgress, thrownValue = $add6d3ca4f7ece3e$var$workInProgressThrownValue;
            switch($add6d3ca4f7ece3e$var$workInProgressSuspendedReason){
                case 8:
                    $add6d3ca4f7ece3e$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $add6d3ca4f7ece3e$var$workInProgressSuspendedReason;
                    $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0;
                    $add6d3ca4f7ece3e$var$workInProgressThrownValue = null;
                    $add6d3ca4f7ece3e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $add6d3ca4f7ece3e$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $add6d3ca4f7ece3e$var$workInProgressSuspendedReason, $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0, $add6d3ca4f7ece3e$var$workInProgressThrownValue = null, $add6d3ca4f7ece3e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $add6d3ca4f7ece3e$var$workLoopSync();
        exitStatus = $add6d3ca4f7ece3e$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $add6d3ca4f7ece3e$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $add6d3ca4f7ece3e$var$lastContextDependency = $add6d3ca4f7ece3e$var$currentlyRenderingFiber$1 = null;
    $add6d3ca4f7ece3e$var$executionContext = prevExecutionContext;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.H = prevDispatcher;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $add6d3ca4f7ece3e$var$workInProgress && ($add6d3ca4f7ece3e$var$workInProgressRoot = null, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes = 0, $add6d3ca4f7ece3e$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $add6d3ca4f7ece3e$var$workLoopSync() {
    for(; null !== $add6d3ca4f7ece3e$var$workInProgress;)$add6d3ca4f7ece3e$var$performUnitOfWork($add6d3ca4f7ece3e$var$workInProgress);
}
function $add6d3ca4f7ece3e$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $add6d3ca4f7ece3e$var$executionContext;
    $add6d3ca4f7ece3e$var$executionContext |= 2;
    var prevDispatcher = $add6d3ca4f7ece3e$var$pushDispatcher(), prevAsyncDispatcher = $add6d3ca4f7ece3e$var$pushAsyncDispatcher();
    $add6d3ca4f7ece3e$var$workInProgressRoot !== root || $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes !== lanes ? ($add6d3ca4f7ece3e$var$workInProgressTransitions = null, $add6d3ca4f7ece3e$var$workInProgressRootRenderTargetTime = $add6d3ca4f7ece3e$var$now() + 500, $add6d3ca4f7ece3e$var$prepareFreshStack(root, lanes)) : $add6d3ca4f7ece3e$var$workInProgressRootIsPrerendering = $add6d3ca4f7ece3e$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $add6d3ca4f7ece3e$var$workInProgressSuspendedReason && null !== $add6d3ca4f7ece3e$var$workInProgress) {
            lanes = $add6d3ca4f7ece3e$var$workInProgress;
            var thrownValue = $add6d3ca4f7ece3e$var$workInProgressThrownValue;
            b: switch($add6d3ca4f7ece3e$var$workInProgressSuspendedReason){
                case 1:
                    $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0;
                    $add6d3ca4f7ece3e$var$workInProgressThrownValue = null;
                    $add6d3ca4f7ece3e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($add6d3ca4f7ece3e$var$isThenableResolved(thrownValue)) {
                        $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0;
                        $add6d3ca4f7ece3e$var$workInProgressThrownValue = null;
                        $add6d3ca4f7ece3e$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $add6d3ca4f7ece3e$var$workInProgressSuspendedReason && 9 !== $add6d3ca4f7ece3e$var$workInProgressSuspendedReason || $add6d3ca4f7ece3e$var$workInProgressRoot !== root || ($add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 7);
                        $add6d3ca4f7ece3e$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $add6d3ca4f7ece3e$var$isThenableResolved(thrownValue) ? ($add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0, $add6d3ca4f7ece3e$var$workInProgressThrownValue = null, $add6d3ca4f7ece3e$var$replaySuspendedUnitOfWork(lanes)) : ($add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0, $add6d3ca4f7ece3e$var$workInProgressThrownValue = null, $add6d3ca4f7ece3e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($add6d3ca4f7ece3e$var$workInProgress.tag){
                        case 26:
                            resource = $add6d3ca4f7ece3e$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $add6d3ca4f7ece3e$var$workInProgress;
                            if (resource ? $add6d3ca4f7ece3e$var$preloadResource(resource) : 1) {
                                $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0;
                                $add6d3ca4f7ece3e$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $add6d3ca4f7ece3e$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($add6d3ca4f7ece3e$var$workInProgress = returnFiber, $add6d3ca4f7ece3e$var$completeUnitOfWork(returnFiber)) : $add6d3ca4f7ece3e$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0;
                    $add6d3ca4f7ece3e$var$workInProgressThrownValue = null;
                    $add6d3ca4f7ece3e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $add6d3ca4f7ece3e$var$workInProgressSuspendedReason = 0;
                    $add6d3ca4f7ece3e$var$workInProgressThrownValue = null;
                    $add6d3ca4f7ece3e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $add6d3ca4f7ece3e$var$resetWorkInProgressStack();
                    $add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(462));
            }
        }
        $add6d3ca4f7ece3e$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $add6d3ca4f7ece3e$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $add6d3ca4f7ece3e$var$lastContextDependency = $add6d3ca4f7ece3e$var$currentlyRenderingFiber$1 = null;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.H = prevDispatcher;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $add6d3ca4f7ece3e$var$executionContext = prevExecutionContext;
    if (null !== $add6d3ca4f7ece3e$var$workInProgress) return 0;
    $add6d3ca4f7ece3e$var$workInProgressRoot = null;
    $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes = 0;
    $add6d3ca4f7ece3e$var$finishQueueingConcurrentUpdates();
    return $add6d3ca4f7ece3e$var$workInProgressRootExitStatus;
}
function $add6d3ca4f7ece3e$var$workLoopConcurrentByScheduler() {
    for(; null !== $add6d3ca4f7ece3e$var$workInProgress && !$add6d3ca4f7ece3e$var$shouldYield();)$add6d3ca4f7ece3e$var$performUnitOfWork($add6d3ca4f7ece3e$var$workInProgress);
}
function $add6d3ca4f7ece3e$var$performUnitOfWork(unitOfWork) {
    var next = $add6d3ca4f7ece3e$var$beginWork(unitOfWork.alternate, unitOfWork, $add6d3ca4f7ece3e$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $add6d3ca4f7ece3e$var$completeUnitOfWork(unitOfWork) : $add6d3ca4f7ece3e$var$workInProgress = next;
}
function $add6d3ca4f7ece3e$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $add6d3ca4f7ece3e$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $add6d3ca4f7ece3e$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $add6d3ca4f7ece3e$var$resetHooksOnUnwind(next);
        default:
            $add6d3ca4f7ece3e$var$unwindInterruptedWork(current, next), next = $add6d3ca4f7ece3e$var$workInProgress = $add6d3ca4f7ece3e$var$resetWorkInProgress(next, $add6d3ca4f7ece3e$var$entangledRenderLanes), next = $add6d3ca4f7ece3e$var$beginWork(current, next, $add6d3ca4f7ece3e$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $add6d3ca4f7ece3e$var$completeUnitOfWork(unitOfWork) : $add6d3ca4f7ece3e$var$workInProgress = next;
}
function $add6d3ca4f7ece3e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $add6d3ca4f7ece3e$var$lastContextDependency = $add6d3ca4f7ece3e$var$currentlyRenderingFiber$1 = null;
    $add6d3ca4f7ece3e$var$resetHooksOnUnwind(unitOfWork);
    $add6d3ca4f7ece3e$var$thenableState = null;
    $add6d3ca4f7ece3e$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($add6d3ca4f7ece3e$var$throwException(root, returnFiber, unitOfWork, thrownValue, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes)) {
            $add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 1;
            $add6d3ca4f7ece3e$var$logUncaughtError(root, $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(thrownValue, root.current));
            $add6d3ca4f7ece3e$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $add6d3ca4f7ece3e$var$workInProgress = returnFiber, error;
        $add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 1;
        $add6d3ca4f7ece3e$var$logUncaughtError(root, $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(thrownValue, root.current));
        $add6d3ca4f7ece3e$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($add6d3ca4f7ece3e$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($add6d3ca4f7ece3e$var$workInProgressRootIsPrerendering || 0 !== ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $add6d3ca4f7ece3e$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $add6d3ca4f7ece3e$var$unwindUnitOfWork(unitOfWork, root);
    } else $add6d3ca4f7ece3e$var$completeUnitOfWork(unitOfWork);
}
function $add6d3ca4f7ece3e$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $add6d3ca4f7ece3e$var$unwindUnitOfWork(completedWork, $add6d3ca4f7ece3e$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $add6d3ca4f7ece3e$var$completeWork(completedWork.alternate, completedWork, $add6d3ca4f7ece3e$var$entangledRenderLanes);
        if (null !== next) {
            $add6d3ca4f7ece3e$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $add6d3ca4f7ece3e$var$workInProgress = completedWork;
            return;
        }
        $add6d3ca4f7ece3e$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $add6d3ca4f7ece3e$var$workInProgressRootExitStatus && ($add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 5);
}
function $add6d3ca4f7ece3e$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $add6d3ca4f7ece3e$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $add6d3ca4f7ece3e$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $add6d3ca4f7ece3e$var$workInProgress = unitOfWork;
            return;
        }
        $add6d3ca4f7ece3e$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $add6d3ca4f7ece3e$var$workInProgressRootExitStatus = 6;
    $add6d3ca4f7ece3e$var$workInProgress = null;
}
function $add6d3ca4f7ece3e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $add6d3ca4f7ece3e$var$flushPendingEffects();
    while (0 !== $add6d3ca4f7ece3e$var$pendingEffectsStatus);
    if (0 !== ($add6d3ca4f7ece3e$var$executionContext & 6)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $add6d3ca4f7ece3e$var$concurrentlyUpdatedLanes;
        $add6d3ca4f7ece3e$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $add6d3ca4f7ece3e$var$workInProgressRoot && ($add6d3ca4f7ece3e$var$workInProgress = $add6d3ca4f7ece3e$var$workInProgressRoot = null, $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes = 0);
        $add6d3ca4f7ece3e$var$pendingFinishedWork = finishedWork;
        $add6d3ca4f7ece3e$var$pendingEffectsRoot = root;
        $add6d3ca4f7ece3e$var$pendingEffectsLanes = lanes;
        $add6d3ca4f7ece3e$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $add6d3ca4f7ece3e$var$pendingPassiveTransitions = transitions;
        $add6d3ca4f7ece3e$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $add6d3ca4f7ece3e$var$scheduleCallback$1($add6d3ca4f7ece3e$var$NormalPriority$1, function() {
            $add6d3ca4f7ece3e$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $add6d3ca4f7ece3e$var$ReactSharedInternals.T;
            $add6d3ca4f7ece3e$var$ReactSharedInternals.T = null;
            transitions = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
            $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $add6d3ca4f7ece3e$var$executionContext;
            $add6d3ca4f7ece3e$var$executionContext |= 4;
            try {
                $add6d3ca4f7ece3e$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $add6d3ca4f7ece3e$var$executionContext = spawnedLane, $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = transitions, $add6d3ca4f7ece3e$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $add6d3ca4f7ece3e$var$pendingEffectsStatus = 1;
        $add6d3ca4f7ece3e$var$flushMutationEffects();
        $add6d3ca4f7ece3e$var$flushLayoutEffects();
        $add6d3ca4f7ece3e$var$flushSpawnedWork();
    }
}
function $add6d3ca4f7ece3e$var$flushMutationEffects() {
    if (1 === $add6d3ca4f7ece3e$var$pendingEffectsStatus) {
        $add6d3ca4f7ece3e$var$pendingEffectsStatus = 0;
        var root = $add6d3ca4f7ece3e$var$pendingEffectsRoot, finishedWork = $add6d3ca4f7ece3e$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $add6d3ca4f7ece3e$var$ReactSharedInternals.T;
            $add6d3ca4f7ece3e$var$ReactSharedInternals.T = null;
            var previousPriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
            $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $add6d3ca4f7ece3e$var$executionContext;
            $add6d3ca4f7ece3e$var$executionContext |= 4;
            try {
                $add6d3ca4f7ece3e$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $add6d3ca4f7ece3e$var$selectionInformation, curFocusedElem = $add6d3ca4f7ece3e$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $add6d3ca4f7ece3e$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $add6d3ca4f7ece3e$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $add6d3ca4f7ece3e$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $add6d3ca4f7ece3e$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $add6d3ca4f7ece3e$var$_enabled = !!$add6d3ca4f7ece3e$var$eventsEnabled;
                $add6d3ca4f7ece3e$var$selectionInformation = $add6d3ca4f7ece3e$var$eventsEnabled = null;
            } finally{
                $add6d3ca4f7ece3e$var$executionContext = prevExecutionContext, $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = previousPriority, $add6d3ca4f7ece3e$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $add6d3ca4f7ece3e$var$pendingEffectsStatus = 2;
    }
}
function $add6d3ca4f7ece3e$var$flushLayoutEffects() {
    if (2 === $add6d3ca4f7ece3e$var$pendingEffectsStatus) {
        $add6d3ca4f7ece3e$var$pendingEffectsStatus = 0;
        var root = $add6d3ca4f7ece3e$var$pendingEffectsRoot, finishedWork = $add6d3ca4f7ece3e$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $add6d3ca4f7ece3e$var$ReactSharedInternals.T;
            $add6d3ca4f7ece3e$var$ReactSharedInternals.T = null;
            var previousPriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
            $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $add6d3ca4f7ece3e$var$executionContext;
            $add6d3ca4f7ece3e$var$executionContext |= 4;
            try {
                $add6d3ca4f7ece3e$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $add6d3ca4f7ece3e$var$executionContext = prevExecutionContext, $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = previousPriority, $add6d3ca4f7ece3e$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $add6d3ca4f7ece3e$var$pendingEffectsStatus = 3;
    }
}
function $add6d3ca4f7ece3e$var$flushSpawnedWork() {
    if (4 === $add6d3ca4f7ece3e$var$pendingEffectsStatus || 3 === $add6d3ca4f7ece3e$var$pendingEffectsStatus) {
        $add6d3ca4f7ece3e$var$pendingEffectsStatus = 0;
        $add6d3ca4f7ece3e$var$requestPaint();
        var root = $add6d3ca4f7ece3e$var$pendingEffectsRoot, finishedWork = $add6d3ca4f7ece3e$var$pendingFinishedWork, lanes = $add6d3ca4f7ece3e$var$pendingEffectsLanes, recoverableErrors = $add6d3ca4f7ece3e$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $add6d3ca4f7ece3e$var$pendingEffectsStatus = 5 : ($add6d3ca4f7ece3e$var$pendingEffectsStatus = 0, $add6d3ca4f7ece3e$var$pendingFinishedWork = $add6d3ca4f7ece3e$var$pendingEffectsRoot = null, $add6d3ca4f7ece3e$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $add6d3ca4f7ece3e$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($add6d3ca4f7ece3e$var$injectedHook && "function" === typeof $add6d3ca4f7ece3e$var$injectedHook.onCommitFiberRoot) try {
            $add6d3ca4f7ece3e$var$injectedHook.onCommitFiberRoot($add6d3ca4f7ece3e$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $add6d3ca4f7ece3e$var$ReactSharedInternals.T;
            remainingLanes = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
            $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 2;
            $add6d3ca4f7ece3e$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $add6d3ca4f7ece3e$var$ReactSharedInternals.T = finishedWork, $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($add6d3ca4f7ece3e$var$pendingEffectsLanes & 3) && $add6d3ca4f7ece3e$var$flushPendingEffects();
        $add6d3ca4f7ece3e$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $add6d3ca4f7ece3e$var$rootWithNestedUpdates ? $add6d3ca4f7ece3e$var$nestedUpdateCount++ : ($add6d3ca4f7ece3e$var$nestedUpdateCount = 0, $add6d3ca4f7ece3e$var$rootWithNestedUpdates = root) : $add6d3ca4f7ece3e$var$nestedUpdateCount = 0;
        $add6d3ca4f7ece3e$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $add6d3ca4f7ece3e$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $add6d3ca4f7ece3e$var$releaseCache(remainingLanes)));
}
function $add6d3ca4f7ece3e$var$flushPendingEffects(wasDelayedCommit) {
    $add6d3ca4f7ece3e$var$flushMutationEffects();
    $add6d3ca4f7ece3e$var$flushLayoutEffects();
    $add6d3ca4f7ece3e$var$flushSpawnedWork();
    return $add6d3ca4f7ece3e$var$flushPassiveEffects(wasDelayedCommit);
}
function $add6d3ca4f7ece3e$var$flushPassiveEffects() {
    if (5 !== $add6d3ca4f7ece3e$var$pendingEffectsStatus) return !1;
    var root = $add6d3ca4f7ece3e$var$pendingEffectsRoot, remainingLanes = $add6d3ca4f7ece3e$var$pendingEffectsRemainingLanes;
    $add6d3ca4f7ece3e$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $add6d3ca4f7ece3e$var$lanesToEventPriority($add6d3ca4f7ece3e$var$pendingEffectsLanes), prevTransition = $add6d3ca4f7ece3e$var$ReactSharedInternals.T, previousPriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
    try {
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $add6d3ca4f7ece3e$var$ReactSharedInternals.T = null;
        renderPriority = $add6d3ca4f7ece3e$var$pendingPassiveTransitions;
        $add6d3ca4f7ece3e$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $add6d3ca4f7ece3e$var$pendingEffectsRoot, lanes = $add6d3ca4f7ece3e$var$pendingEffectsLanes;
        $add6d3ca4f7ece3e$var$pendingEffectsStatus = 0;
        $add6d3ca4f7ece3e$var$pendingFinishedWork = $add6d3ca4f7ece3e$var$pendingEffectsRoot = null;
        $add6d3ca4f7ece3e$var$pendingEffectsLanes = 0;
        if (0 !== ($add6d3ca4f7ece3e$var$executionContext & 6)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(331));
        var prevExecutionContext = $add6d3ca4f7ece3e$var$executionContext;
        $add6d3ca4f7ece3e$var$executionContext |= 4;
        $add6d3ca4f7ece3e$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $add6d3ca4f7ece3e$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $add6d3ca4f7ece3e$var$executionContext = prevExecutionContext;
        $add6d3ca4f7ece3e$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($add6d3ca4f7ece3e$var$injectedHook && "function" === typeof $add6d3ca4f7ece3e$var$injectedHook.onPostCommitFiberRoot) try {
            $add6d3ca4f7ece3e$var$injectedHook.onPostCommitFiberRoot($add6d3ca4f7ece3e$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = previousPriority, $add6d3ca4f7ece3e$var$ReactSharedInternals.T = prevTransition, $add6d3ca4f7ece3e$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $add6d3ca4f7ece3e$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $add6d3ca4f7ece3e$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $add6d3ca4f7ece3e$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($add6d3ca4f7ece3e$var$markRootUpdated$1(rootFiber, 2), $add6d3ca4f7ece3e$var$ensureRootIsScheduled(rootFiber));
}
function $add6d3ca4f7ece3e$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $add6d3ca4f7ece3e$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $add6d3ca4f7ece3e$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed || !$add6d3ca4f7ece3e$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $add6d3ca4f7ece3e$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $add6d3ca4f7ece3e$var$createClassErrorUpdate(2);
                instance = $add6d3ca4f7ece3e$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($add6d3ca4f7ece3e$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $add6d3ca4f7ece3e$var$markRootUpdated$1(instance, 2), $add6d3ca4f7ece3e$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $add6d3ca4f7ece3e$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $add6d3ca4f7ece3e$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($add6d3ca4f7ece3e$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $add6d3ca4f7ece3e$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $add6d3ca4f7ece3e$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $add6d3ca4f7ece3e$var$workInProgressRoot === root && ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $add6d3ca4f7ece3e$var$workInProgressRootExitStatus || 3 === $add6d3ca4f7ece3e$var$workInProgressRootExitStatus && ($add6d3ca4f7ece3e$var$workInProgressRootRenderLanes & 62914560) === $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes && 300 > $add6d3ca4f7ece3e$var$now() - $add6d3ca4f7ece3e$var$globalMostRecentFallbackTime ? 0 === ($add6d3ca4f7ece3e$var$executionContext & 2) && $add6d3ca4f7ece3e$var$prepareFreshStack(root, 0) : $add6d3ca4f7ece3e$var$workInProgressRootPingedLanes |= pingedLanes, $add6d3ca4f7ece3e$var$workInProgressSuspendedRetryLanes === $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes && ($add6d3ca4f7ece3e$var$workInProgressSuspendedRetryLanes = 0));
    $add6d3ca4f7ece3e$var$ensureRootIsScheduled(root);
}
function $add6d3ca4f7ece3e$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $add6d3ca4f7ece3e$var$claimNextRetryLane());
    boundaryFiber = $add6d3ca4f7ece3e$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($add6d3ca4f7ece3e$var$markRootUpdated$1(boundaryFiber, retryLane), $add6d3ca4f7ece3e$var$ensureRootIsScheduled(boundaryFiber));
}
function $add6d3ca4f7ece3e$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $add6d3ca4f7ece3e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $add6d3ca4f7ece3e$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $add6d3ca4f7ece3e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $add6d3ca4f7ece3e$var$scheduleCallback$1(priorityLevel, callback) {
    return $add6d3ca4f7ece3e$var$scheduleCallback$3(priorityLevel, callback);
}
var $add6d3ca4f7ece3e$var$firstScheduledRoot = null, $add6d3ca4f7ece3e$var$lastScheduledRoot = null, $add6d3ca4f7ece3e$var$didScheduleMicrotask = !1, $add6d3ca4f7ece3e$var$mightHavePendingSyncWork = !1, $add6d3ca4f7ece3e$var$isFlushingWork = !1, $add6d3ca4f7ece3e$var$currentEventTransitionLane = 0;
function $add6d3ca4f7ece3e$var$ensureRootIsScheduled(root) {
    root !== $add6d3ca4f7ece3e$var$lastScheduledRoot && null === root.next && (null === $add6d3ca4f7ece3e$var$lastScheduledRoot ? $add6d3ca4f7ece3e$var$firstScheduledRoot = $add6d3ca4f7ece3e$var$lastScheduledRoot = root : $add6d3ca4f7ece3e$var$lastScheduledRoot = $add6d3ca4f7ece3e$var$lastScheduledRoot.next = root);
    $add6d3ca4f7ece3e$var$mightHavePendingSyncWork = !0;
    $add6d3ca4f7ece3e$var$didScheduleMicrotask || ($add6d3ca4f7ece3e$var$didScheduleMicrotask = !0, $add6d3ca4f7ece3e$var$scheduleImmediateRootScheduleTask());
}
function $add6d3ca4f7ece3e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$add6d3ca4f7ece3e$var$isFlushingWork && $add6d3ca4f7ece3e$var$mightHavePendingSyncWork) {
        $add6d3ca4f7ece3e$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $add6d3ca4f7ece3e$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $add6d3ca4f7ece3e$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $add6d3ca4f7ece3e$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $add6d3ca4f7ece3e$var$getNextLanes(root$174, root$174 === $add6d3ca4f7ece3e$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $add6d3ca4f7ece3e$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $add6d3ca4f7ece3e$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $add6d3ca4f7ece3e$var$isFlushingWork = !1;
    }
}
function $add6d3ca4f7ece3e$var$processRootScheduleInImmediateTask() {
    $add6d3ca4f7ece3e$var$processRootScheduleInMicrotask();
}
function $add6d3ca4f7ece3e$var$processRootScheduleInMicrotask() {
    $add6d3ca4f7ece3e$var$mightHavePendingSyncWork = $add6d3ca4f7ece3e$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $add6d3ca4f7ece3e$var$currentEventTransitionLane && ($add6d3ca4f7ece3e$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $add6d3ca4f7ece3e$var$currentEventTransitionLane), $add6d3ca4f7ece3e$var$currentEventTransitionLane = 0);
    for(var currentTime = $add6d3ca4f7ece3e$var$now(), prev = null, root = $add6d3ca4f7ece3e$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $add6d3ca4f7ece3e$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $add6d3ca4f7ece3e$var$firstScheduledRoot = next : prev.next = next, null === next && ($add6d3ca4f7ece3e$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $add6d3ca4f7ece3e$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $add6d3ca4f7ece3e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $add6d3ca4f7ece3e$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $add6d3ca4f7ece3e$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $add6d3ca4f7ece3e$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $add6d3ca4f7ece3e$var$workInProgressRoot;
    suspendedLanes = $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes;
    suspendedLanes = $add6d3ca4f7ece3e$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $add6d3ca4f7ece3e$var$workInProgressSuspendedReason || 9 === $add6d3ca4f7ece3e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $add6d3ca4f7ece3e$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $add6d3ca4f7ece3e$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $add6d3ca4f7ece3e$var$cancelCallback$1(pingedLanes);
        switch($add6d3ca4f7ece3e$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $add6d3ca4f7ece3e$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $add6d3ca4f7ece3e$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $add6d3ca4f7ece3e$var$IdlePriority;
                break;
            default:
                suspendedLanes = $add6d3ca4f7ece3e$var$NormalPriority$1;
        }
        pingedLanes = $add6d3ca4f7ece3e$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $add6d3ca4f7ece3e$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $add6d3ca4f7ece3e$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $add6d3ca4f7ece3e$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $add6d3ca4f7ece3e$var$pendingEffectsStatus && 5 !== $add6d3ca4f7ece3e$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($add6d3ca4f7ece3e$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $add6d3ca4f7ece3e$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $add6d3ca4f7ece3e$var$getNextLanes(root, root === $add6d3ca4f7ece3e$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $add6d3ca4f7ece3e$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $add6d3ca4f7ece3e$var$scheduleTaskForRootDuringMicrotask(root, $add6d3ca4f7ece3e$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $add6d3ca4f7ece3e$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $add6d3ca4f7ece3e$var$performSyncWorkOnRoot(root, lanes) {
    if ($add6d3ca4f7ece3e$var$flushPendingEffects()) return null;
    $add6d3ca4f7ece3e$var$performWorkOnRoot(root, lanes, !0);
}
function $add6d3ca4f7ece3e$var$scheduleImmediateRootScheduleTask() {
    $add6d3ca4f7ece3e$var$scheduleMicrotask(function() {
        0 !== ($add6d3ca4f7ece3e$var$executionContext & 6) ? $add6d3ca4f7ece3e$var$scheduleCallback$3($add6d3ca4f7ece3e$var$ImmediatePriority, $add6d3ca4f7ece3e$var$processRootScheduleInImmediateTask) : $add6d3ca4f7ece3e$var$processRootScheduleInMicrotask();
    });
}
function $add6d3ca4f7ece3e$var$requestTransitionLane() {
    0 === $add6d3ca4f7ece3e$var$currentEventTransitionLane && ($add6d3ca4f7ece3e$var$currentEventTransitionLane = $add6d3ca4f7ece3e$var$claimNextTransitionLane());
    return $add6d3ca4f7ece3e$var$currentEventTransitionLane;
}
function $add6d3ca4f7ece3e$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $add6d3ca4f7ece3e$var$sanitizeURL("" + actionProp);
}
function $add6d3ca4f7ece3e$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $add6d3ca4f7ece3e$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $add6d3ca4f7ece3e$var$coerceFormActionProp((nativeEventTarget[$add6d3ca4f7ece3e$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$add6d3ca4f7ece3e$var$internalPropsKey] || null) ? $add6d3ca4f7ece3e$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $add6d3ca4f7ece3e$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $add6d3ca4f7ece3e$var$currentEventTransitionLane) {
                                var formData = submitter ? $add6d3ca4f7ece3e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $add6d3ca4f7ece3e$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $add6d3ca4f7ece3e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $add6d3ca4f7ece3e$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $add6d3ca4f7ece3e$var$i$jscomp$inline_1528 = 0; $add6d3ca4f7ece3e$var$i$jscomp$inline_1528 < $add6d3ca4f7ece3e$var$simpleEventPluginEvents.length; $add6d3ca4f7ece3e$var$i$jscomp$inline_1528++){
    var $add6d3ca4f7ece3e$var$eventName$jscomp$inline_1529 = $add6d3ca4f7ece3e$var$simpleEventPluginEvents[$add6d3ca4f7ece3e$var$i$jscomp$inline_1528], $add6d3ca4f7ece3e$var$domEventName$jscomp$inline_1530 = $add6d3ca4f7ece3e$var$eventName$jscomp$inline_1529.toLowerCase(), $add6d3ca4f7ece3e$var$capitalizedEvent$jscomp$inline_1531 = $add6d3ca4f7ece3e$var$eventName$jscomp$inline_1529[0].toUpperCase() + $add6d3ca4f7ece3e$var$eventName$jscomp$inline_1529.slice(1);
    $add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$domEventName$jscomp$inline_1530, "on" + $add6d3ca4f7ece3e$var$capitalizedEvent$jscomp$inline_1531);
}
$add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$ANIMATION_END, "onAnimationEnd");
$add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$ANIMATION_ITERATION, "onAnimationIteration");
$add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$ANIMATION_START, "onAnimationStart");
$add6d3ca4f7ece3e$var$registerSimpleEvent("dblclick", "onDoubleClick");
$add6d3ca4f7ece3e$var$registerSimpleEvent("focusin", "onFocus");
$add6d3ca4f7ece3e$var$registerSimpleEvent("focusout", "onBlur");
$add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$TRANSITION_RUN, "onTransitionRun");
$add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$TRANSITION_START, "onTransitionStart");
$add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$TRANSITION_CANCEL, "onTransitionCancel");
$add6d3ca4f7ece3e$var$registerSimpleEvent($add6d3ca4f7ece3e$var$TRANSITION_END, "onTransitionEnd");
$add6d3ca4f7ece3e$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$add6d3ca4f7ece3e$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$add6d3ca4f7ece3e$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$add6d3ca4f7ece3e$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$add6d3ca4f7ece3e$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$add6d3ca4f7ece3e$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$add6d3ca4f7ece3e$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$add6d3ca4f7ece3e$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$add6d3ca4f7ece3e$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$add6d3ca4f7ece3e$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $add6d3ca4f7ece3e$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $add6d3ca4f7ece3e$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($add6d3ca4f7ece3e$var$mediaEventTypes));
function $add6d3ca4f7ece3e$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $add6d3ca4f7ece3e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $add6d3ca4f7ece3e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$add6d3ca4f7ece3e$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$add6d3ca4f7ece3e$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($add6d3ca4f7ece3e$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $add6d3ca4f7ece3e$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $add6d3ca4f7ece3e$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $add6d3ca4f7ece3e$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $add6d3ca4f7ece3e$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$add6d3ca4f7ece3e$var$listeningMarker]) {
        rootContainerElement[$add6d3ca4f7ece3e$var$listeningMarker] = !0;
        $add6d3ca4f7ece3e$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($add6d3ca4f7ece3e$var$nonDelegatedEvents.has(domEventName) || $add6d3ca4f7ece3e$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $add6d3ca4f7ece3e$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$add6d3ca4f7ece3e$var$listeningMarker] || (ownerDocument[$add6d3ca4f7ece3e$var$listeningMarker] = !0, $add6d3ca4f7ece3e$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $add6d3ca4f7ece3e$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($add6d3ca4f7ece3e$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $add6d3ca4f7ece3e$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $add6d3ca4f7ece3e$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $add6d3ca4f7ece3e$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$add6d3ca4f7ece3e$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $add6d3ca4f7ece3e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $add6d3ca4f7ece3e$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $add6d3ca4f7ece3e$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $add6d3ca4f7ece3e$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $add6d3ca4f7ece3e$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $add6d3ca4f7ece3e$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticTouchEvent;
                        break;
                    case $add6d3ca4f7ece3e$var$ANIMATION_END:
                    case $add6d3ca4f7ece3e$var$ANIMATION_ITERATION:
                    case $add6d3ca4f7ece3e$var$ANIMATION_START:
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticAnimationEvent;
                        break;
                    case $add6d3ca4f7ece3e$var$TRANSITION_END:
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $add6d3ca4f7ece3e$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $add6d3ca4f7ece3e$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($add6d3ca4f7ece3e$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $add6d3ca4f7ece3e$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($add6d3ca4f7ece3e$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$add6d3ca4f7ece3e$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $add6d3ca4f7ece3e$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $add6d3ca4f7ece3e$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $add6d3ca4f7ece3e$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $add6d3ca4f7ece3e$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $add6d3ca4f7ece3e$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $add6d3ca4f7ece3e$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $add6d3ca4f7ece3e$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $add6d3ca4f7ece3e$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $add6d3ca4f7ece3e$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $add6d3ca4f7ece3e$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $add6d3ca4f7ece3e$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $add6d3ca4f7ece3e$var$getParent(inCapturePhase);
                                reactEventName = $add6d3ca4f7ece3e$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $add6d3ca4f7ece3e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $add6d3ca4f7ece3e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $add6d3ca4f7ece3e$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $add6d3ca4f7ece3e$var$getTargetInstForChangeEvent;
                else if ($add6d3ca4f7ece3e$var$isTextInputElement(reactName)) {
                    if ($add6d3ca4f7ece3e$var$isInputEventSupported) getTargetInstFunc = $add6d3ca4f7ece3e$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $add6d3ca4f7ece3e$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $add6d3ca4f7ece3e$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $add6d3ca4f7ece3e$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $add6d3ca4f7ece3e$var$getTargetInstForChangeEvent) : getTargetInstFunc = $add6d3ca4f7ece3e$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $add6d3ca4f7ece3e$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $add6d3ca4f7ece3e$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $add6d3ca4f7ece3e$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($add6d3ca4f7ece3e$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $add6d3ca4f7ece3e$var$activeElement = handleEventFunc, $add6d3ca4f7ece3e$var$activeElementInst = targetInst, $add6d3ca4f7ece3e$var$lastSelection = null;
                    break;
                case "focusout":
                    $add6d3ca4f7ece3e$var$lastSelection = $add6d3ca4f7ece3e$var$activeElementInst = $add6d3ca4f7ece3e$var$activeElement = null;
                    break;
                case "mousedown":
                    $add6d3ca4f7ece3e$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $add6d3ca4f7ece3e$var$mouseDown = !1;
                    $add6d3ca4f7ece3e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($add6d3ca4f7ece3e$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $add6d3ca4f7ece3e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($add6d3ca4f7ece3e$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $add6d3ca4f7ece3e$var$isComposing ? $add6d3ca4f7ece3e$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($add6d3ca4f7ece3e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($add6d3ca4f7ece3e$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $add6d3ca4f7ece3e$var$isComposing && (fallbackData = $add6d3ca4f7ece3e$var$getData()) : ($add6d3ca4f7ece3e$var$root = nativeEventTarget, $add6d3ca4f7ece3e$var$startText = "value" in $add6d3ca4f7ece3e$var$root ? $add6d3ca4f7ece3e$var$root.value : $add6d3ca4f7ece3e$var$root.textContent, $add6d3ca4f7ece3e$var$isComposing = !0)), handleEventFunc = $add6d3ca4f7ece3e$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $add6d3ca4f7ece3e$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $add6d3ca4f7ece3e$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $add6d3ca4f7ece3e$var$canUseTextInputEvent ? $add6d3ca4f7ece3e$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $add6d3ca4f7ece3e$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $add6d3ca4f7ece3e$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $add6d3ca4f7ece3e$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $add6d3ca4f7ece3e$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $add6d3ca4f7ece3e$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $add6d3ca4f7ece3e$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $add6d3ca4f7ece3e$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $add6d3ca4f7ece3e$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($add6d3ca4f7ece3e$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $add6d3ca4f7ece3e$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($add6d3ca4f7ece3e$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $add6d3ca4f7ece3e$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $add6d3ca4f7ece3e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $add6d3ca4f7ece3e$var$getListener(target, registrationName), null != stateNode && listeners.unshift($add6d3ca4f7ece3e$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $add6d3ca4f7ece3e$var$getListener(target, registrationName), null != stateNode && listeners.push($add6d3ca4f7ece3e$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $add6d3ca4f7ece3e$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $add6d3ca4f7ece3e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $add6d3ca4f7ece3e$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($add6d3ca4f7ece3e$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($add6d3ca4f7ece3e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $add6d3ca4f7ece3e$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $add6d3ca4f7ece3e$var$normalizeMarkupForTextOrAttribute(clientText);
    return $add6d3ca4f7ece3e$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $add6d3ca4f7ece3e$var$noop$1() {}
function $add6d3ca4f7ece3e$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $add6d3ca4f7ece3e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $add6d3ca4f7ece3e$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $add6d3ca4f7ece3e$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $add6d3ca4f7ece3e$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $add6d3ca4f7ece3e$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $add6d3ca4f7ece3e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $add6d3ca4f7ece3e$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $add6d3ca4f7ece3e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $add6d3ca4f7ece3e$var$setProp(domElement, tag, "name", props.name, props, null), $add6d3ca4f7ece3e$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $add6d3ca4f7ece3e$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $add6d3ca4f7ece3e$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($add6d3ca4f7ece3e$var$setProp(domElement, tag, "encType", props.encType, props, null), $add6d3ca4f7ece3e$var$setProp(domElement, tag, "method", props.method, props, null), $add6d3ca4f7ece3e$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $add6d3ca4f7ece3e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $add6d3ca4f7ece3e$var$noop$1);
            break;
        case "onScroll":
            null != value && $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $add6d3ca4f7ece3e$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("toggle", domElement);
            $add6d3ca4f7ece3e$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $add6d3ca4f7ece3e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $add6d3ca4f7ece3e$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $add6d3ca4f7ece3e$var$aliases.get(key) || key, $add6d3ca4f7ece3e$var$setValueForAttribute(domElement, key, value);
    }
}
function $add6d3ca4f7ece3e$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $add6d3ca4f7ece3e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $add6d3ca4f7ece3e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $add6d3ca4f7ece3e$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $add6d3ca4f7ece3e$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$add6d3ca4f7ece3e$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$add6d3ca4f7ece3e$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $add6d3ca4f7ece3e$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $add6d3ca4f7ece3e$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("error", domElement);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(137, tag));
                    default:
                        $add6d3ca4f7ece3e$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $add6d3ca4f7ece3e$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $add6d3ca4f7ece3e$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $add6d3ca4f7ece3e$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $add6d3ca4f7ece3e$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $add6d3ca4f7ece3e$var$track(domElement);
            return;
        case "select":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $add6d3ca4f7ece3e$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $add6d3ca4f7ece3e$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(91));
                    break;
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $add6d3ca4f7ece3e$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $add6d3ca4f7ece3e$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("toggle", domElement);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("cancel", domElement);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $add6d3ca4f7ece3e$var$mediaEventTypes.length; hasSrc++)$add6d3ca4f7ece3e$var$listenToNonDelegatedEvent($add6d3ca4f7ece3e$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("error", domElement);
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("error", domElement), $add6d3ca4f7ece3e$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(137, tag));
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($add6d3ca4f7ece3e$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $add6d3ca4f7ece3e$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $add6d3ca4f7ece3e$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $add6d3ca4f7ece3e$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $add6d3ca4f7ece3e$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $add6d3ca4f7ece3e$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $add6d3ca4f7ece3e$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $add6d3ca4f7ece3e$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $add6d3ca4f7ece3e$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $add6d3ca4f7ece3e$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $add6d3ca4f7ece3e$var$updateOptions(domElement, !!lastProps, tag, !0) : $add6d3ca4f7ece3e$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $add6d3ca4f7ece3e$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $add6d3ca4f7ece3e$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $add6d3ca4f7ece3e$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $add6d3ca4f7ece3e$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($add6d3ca4f7ece3e$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $add6d3ca4f7ece3e$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $add6d3ca4f7ece3e$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $add6d3ca4f7ece3e$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $add6d3ca4f7ece3e$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $add6d3ca4f7ece3e$var$eventsEnabled = null, $add6d3ca4f7ece3e$var$selectionInformation = null;
function $add6d3ca4f7ece3e$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $add6d3ca4f7ece3e$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $add6d3ca4f7ece3e$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $add6d3ca4f7ece3e$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $add6d3ca4f7ece3e$var$currentPopstateTransitionEvent = null;
function $add6d3ca4f7ece3e$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $add6d3ca4f7ece3e$var$currentPopstateTransitionEvent) return !1;
        $add6d3ca4f7ece3e$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $add6d3ca4f7ece3e$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $add6d3ca4f7ece3e$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $add6d3ca4f7ece3e$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $add6d3ca4f7ece3e$var$localPromise = "function" === typeof Promise ? Promise : void 0, $add6d3ca4f7ece3e$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $add6d3ca4f7ece3e$var$localPromise ? function(callback) {
    return $add6d3ca4f7ece3e$var$localPromise.resolve(null).then(callback).catch($add6d3ca4f7ece3e$var$handleErrorInNextTick);
} : $add6d3ca4f7ece3e$var$scheduleTimeout;
function $add6d3ca4f7ece3e$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $add6d3ca4f7ece3e$var$isSingletonScope(type) {
    return "head" === type;
}
function $add6d3ca4f7ece3e$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $add6d3ca4f7ece3e$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $add6d3ca4f7ece3e$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $add6d3ca4f7ece3e$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$add6d3ca4f7ece3e$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $add6d3ca4f7ece3e$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $add6d3ca4f7ece3e$var$retryIfBlockedOn(suspenseInstance);
}
function $add6d3ca4f7ece3e$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $add6d3ca4f7ece3e$var$clearContainerSparingly(node);
                $add6d3ca4f7ece3e$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $add6d3ca4f7ece3e$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$add6d3ca4f7ece3e$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $add6d3ca4f7ece3e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $add6d3ca4f7ece3e$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $add6d3ca4f7ece3e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $add6d3ca4f7ece3e$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $add6d3ca4f7ece3e$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $add6d3ca4f7ece3e$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $add6d3ca4f7ece3e$var$previousHydratableOnEnteringScopedSingleton = null;
function $add6d3ca4f7ece3e$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $add6d3ca4f7ece3e$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $add6d3ca4f7ece3e$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(451));
    }
}
function $add6d3ca4f7ece3e$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $add6d3ca4f7ece3e$var$detachDeletedInstance(instance);
}
var $add6d3ca4f7ece3e$var$preloadPropsMap = new Map(), $add6d3ca4f7ece3e$var$preconnectsSet = new Set();
function $add6d3ca4f7ece3e$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $add6d3ca4f7ece3e$var$previousDispatcher = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.d;
$add6d3ca4f7ece3e$var$ReactDOMSharedInternals.d = {
    f: $add6d3ca4f7ece3e$var$flushSyncWork,
    r: $add6d3ca4f7ece3e$var$requestFormReset,
    D: $add6d3ca4f7ece3e$var$prefetchDNS,
    C: $add6d3ca4f7ece3e$var$preconnect,
    L: $add6d3ca4f7ece3e$var$preload,
    m: $add6d3ca4f7ece3e$var$preloadModule,
    X: $add6d3ca4f7ece3e$var$preinitScript,
    S: $add6d3ca4f7ece3e$var$preinitStyle,
    M: $add6d3ca4f7ece3e$var$preinitModuleScript
};
function $add6d3ca4f7ece3e$var$flushSyncWork() {
    var previousWasRendering = $add6d3ca4f7ece3e$var$previousDispatcher.f(), wasRendering = $add6d3ca4f7ece3e$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $add6d3ca4f7ece3e$var$requestFormReset(form) {
    var formInst = $add6d3ca4f7ece3e$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $add6d3ca4f7ece3e$var$requestFormReset$1(formInst) : $add6d3ca4f7ece3e$var$previousDispatcher.r(form);
}
var $add6d3ca4f7ece3e$var$globalDocument = "undefined" === typeof document ? null : document;
function $add6d3ca4f7ece3e$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $add6d3ca4f7ece3e$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $add6d3ca4f7ece3e$var$preconnectsSet.has(limitedEscapedHref) || ($add6d3ca4f7ece3e$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $add6d3ca4f7ece3e$var$setInitialProperties(href, "link", rel), $add6d3ca4f7ece3e$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $add6d3ca4f7ece3e$var$prefetchDNS(href) {
    $add6d3ca4f7ece3e$var$previousDispatcher.D(href);
    $add6d3ca4f7ece3e$var$preconnectAs("dns-prefetch", href, null);
}
function $add6d3ca4f7ece3e$var$preconnect(href, crossOrigin) {
    $add6d3ca4f7ece3e$var$previousDispatcher.C(href, crossOrigin);
    $add6d3ca4f7ece3e$var$preconnectAs("preconnect", href, crossOrigin);
}
function $add6d3ca4f7ece3e$var$preload(href, as, options) {
    $add6d3ca4f7ece3e$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $add6d3ca4f7ece3e$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $add6d3ca4f7ece3e$var$getStyleKey(href);
                break;
            case "script":
                key = $add6d3ca4f7ece3e$var$getScriptKey(href);
        }
        $add6d3ca4f7ece3e$var$preloadPropsMap.has(key) || (href = $add6d3ca4f7ece3e$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $add6d3ca4f7ece3e$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($add6d3ca4f7ece3e$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($add6d3ca4f7ece3e$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $add6d3ca4f7ece3e$var$setInitialProperties(as, "link", href), $add6d3ca4f7ece3e$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $add6d3ca4f7ece3e$var$preloadModule(href, options) {
    $add6d3ca4f7ece3e$var$previousDispatcher.m(href, options);
    var ownerDocument = $add6d3ca4f7ece3e$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $add6d3ca4f7ece3e$var$getScriptKey(href);
        }
        if (!$add6d3ca4f7ece3e$var$preloadPropsMap.has(key) && (href = $add6d3ca4f7ece3e$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $add6d3ca4f7ece3e$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($add6d3ca4f7ece3e$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $add6d3ca4f7ece3e$var$setInitialProperties(as, "link", href);
            $add6d3ca4f7ece3e$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $add6d3ca4f7ece3e$var$preinitStyle(href, precedence, options) {
    $add6d3ca4f7ece3e$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $add6d3ca4f7ece3e$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $add6d3ca4f7ece3e$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $add6d3ca4f7ece3e$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($add6d3ca4f7ece3e$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $add6d3ca4f7ece3e$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $add6d3ca4f7ece3e$var$preloadPropsMap.get(key)) && $add6d3ca4f7ece3e$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $add6d3ca4f7ece3e$var$markNodeAsHoistable(link);
                $add6d3ca4f7ece3e$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $add6d3ca4f7ece3e$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $add6d3ca4f7ece3e$var$preinitScript(src, options) {
    $add6d3ca4f7ece3e$var$previousDispatcher.X(src, options);
    var ownerDocument = $add6d3ca4f7ece3e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $add6d3ca4f7ece3e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $add6d3ca4f7ece3e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($add6d3ca4f7ece3e$var$getScriptSelectorFromKey(key)), resource || (src = $add6d3ca4f7ece3e$var$assign({
            src: src,
            async: !0
        }, options), (options = $add6d3ca4f7ece3e$var$preloadPropsMap.get(key)) && $add6d3ca4f7ece3e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $add6d3ca4f7ece3e$var$markNodeAsHoistable(resource), $add6d3ca4f7ece3e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $add6d3ca4f7ece3e$var$preinitModuleScript(src, options) {
    $add6d3ca4f7ece3e$var$previousDispatcher.M(src, options);
    var ownerDocument = $add6d3ca4f7ece3e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $add6d3ca4f7ece3e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $add6d3ca4f7ece3e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($add6d3ca4f7ece3e$var$getScriptSelectorFromKey(key)), resource || (src = $add6d3ca4f7ece3e$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $add6d3ca4f7ece3e$var$preloadPropsMap.get(key)) && $add6d3ca4f7ece3e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $add6d3ca4f7ece3e$var$markNodeAsHoistable(resource), $add6d3ca4f7ece3e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $add6d3ca4f7ece3e$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $add6d3ca4f7ece3e$var$rootInstanceStackCursor.current) ? $add6d3ca4f7ece3e$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $add6d3ca4f7ece3e$var$getStyleKey(pendingProps.href), pendingProps = $add6d3ca4f7ece3e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $add6d3ca4f7ece3e$var$getStyleKey(pendingProps.href);
                var styles$244 = $add6d3ca4f7ece3e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($add6d3ca4f7ece3e$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $add6d3ca4f7ece3e$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $add6d3ca4f7ece3e$var$preloadPropsMap.set(type, pendingProps), styles$244 || $add6d3ca4f7ece3e$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $add6d3ca4f7ece3e$var$getScriptKey(pendingProps), pendingProps = $add6d3ca4f7ece3e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(444, type));
    }
}
function $add6d3ca4f7ece3e$var$getStyleKey(href) {
    return 'href="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $add6d3ca4f7ece3e$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $add6d3ca4f7ece3e$var$stylesheetPropsFromRawProps(rawProps) {
    return $add6d3ca4f7ece3e$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $add6d3ca4f7ece3e$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $add6d3ca4f7ece3e$var$setInitialProperties(key, "link", preloadProps), $add6d3ca4f7ece3e$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $add6d3ca4f7ece3e$var$getScriptKey(src) {
    return '[src="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $add6d3ca4f7ece3e$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $add6d3ca4f7ece3e$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $add6d3ca4f7ece3e$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $add6d3ca4f7ece3e$var$markNodeAsHoistable(instance), instance;
            var styleProps = $add6d3ca4f7ece3e$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $add6d3ca4f7ece3e$var$markNodeAsHoistable(instance);
            $add6d3ca4f7ece3e$var$setInitialProperties(instance, "style", styleProps);
            $add6d3ca4f7ece3e$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $add6d3ca4f7ece3e$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($add6d3ca4f7ece3e$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $add6d3ca4f7ece3e$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $add6d3ca4f7ece3e$var$stylesheetPropsFromRawProps(props);
            (styleProps = $add6d3ca4f7ece3e$var$preloadPropsMap.get(styleProps)) && $add6d3ca4f7ece3e$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $add6d3ca4f7ece3e$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $add6d3ca4f7ece3e$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $add6d3ca4f7ece3e$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $add6d3ca4f7ece3e$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($add6d3ca4f7ece3e$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $add6d3ca4f7ece3e$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $add6d3ca4f7ece3e$var$preloadPropsMap.get(instance$250)) instance = $add6d3ca4f7ece3e$var$assign({}, props), $add6d3ca4f7ece3e$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $add6d3ca4f7ece3e$var$markNodeAsHoistable(styleProps);
            $add6d3ca4f7ece3e$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $add6d3ca4f7ece3e$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $add6d3ca4f7ece3e$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $add6d3ca4f7ece3e$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $add6d3ca4f7ece3e$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $add6d3ca4f7ece3e$var$tagCaches = null;
function $add6d3ca4f7ece3e$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $add6d3ca4f7ece3e$var$tagCaches) {
        var cache = new Map();
        var caches = $add6d3ca4f7ece3e$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $add6d3ca4f7ece3e$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$add6d3ca4f7ece3e$var$internalHoistableMarker] || node[$add6d3ca4f7ece3e$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $add6d3ca4f7ece3e$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $add6d3ca4f7ece3e$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $add6d3ca4f7ece3e$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $add6d3ca4f7ece3e$var$suspendedState = null;
function $add6d3ca4f7ece3e$var$noop() {}
function $add6d3ca4f7ece3e$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $add6d3ca4f7ece3e$var$suspendedState) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(475));
    var state = $add6d3ca4f7ece3e$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $add6d3ca4f7ece3e$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($add6d3ca4f7ece3e$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $add6d3ca4f7ece3e$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $add6d3ca4f7ece3e$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $add6d3ca4f7ece3e$var$stylesheetPropsFromRawProps(props);
            (key = $add6d3ca4f7ece3e$var$preloadPropsMap.get(key)) && $add6d3ca4f7ece3e$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $add6d3ca4f7ece3e$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $add6d3ca4f7ece3e$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $add6d3ca4f7ece3e$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $add6d3ca4f7ece3e$var$waitForCommitToBeReady() {
    if (null === $add6d3ca4f7ece3e$var$suspendedState) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(475));
    var state = $add6d3ca4f7ece3e$var$suspendedState;
    state.stylesheets && 0 === state.count && $add6d3ca4f7ece3e$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $add6d3ca4f7ece3e$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $add6d3ca4f7ece3e$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $add6d3ca4f7ece3e$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $add6d3ca4f7ece3e$var$precedencesByRoot = null;
function $add6d3ca4f7ece3e$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $add6d3ca4f7ece3e$var$precedencesByRoot = new Map(), resources.forEach($add6d3ca4f7ece3e$var$insertStylesheetIntoRoot, state), $add6d3ca4f7ece3e$var$precedencesByRoot = null, $add6d3ca4f7ece3e$var$onUnsuspend.call(state));
}
function $add6d3ca4f7ece3e$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $add6d3ca4f7ece3e$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $add6d3ca4f7ece3e$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $add6d3ca4f7ece3e$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $add6d3ca4f7ece3e$var$HostTransitionContext = {
    $$typeof: $add6d3ca4f7ece3e$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $add6d3ca4f7ece3e$var$sharedNotPendingObject,
    _currentValue2: $add6d3ca4f7ece3e$var$sharedNotPendingObject,
    _threadCount: 0
};
function $add6d3ca4f7ece3e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $add6d3ca4f7ece3e$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $add6d3ca4f7ece3e$var$createLaneMap(0);
    this.hiddenUpdates = $add6d3ca4f7ece3e$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $add6d3ca4f7ece3e$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $add6d3ca4f7ece3e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $add6d3ca4f7ece3e$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $add6d3ca4f7ece3e$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $add6d3ca4f7ece3e$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $add6d3ca4f7ece3e$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $add6d3ca4f7ece3e$var$emptyContextObject;
    parentComponent = $add6d3ca4f7ece3e$var$emptyContextObject;
    return parentComponent;
}
function $add6d3ca4f7ece3e$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $add6d3ca4f7ece3e$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $add6d3ca4f7ece3e$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $add6d3ca4f7ece3e$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(element, rootFiber, lane), $add6d3ca4f7ece3e$var$entangleTransitions(element, rootFiber, lane));
}
function $add6d3ca4f7ece3e$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $add6d3ca4f7ece3e$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $add6d3ca4f7ece3e$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $add6d3ca4f7ece3e$var$markRetryLaneImpl(fiber, retryLane);
}
function $add6d3ca4f7ece3e$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $add6d3ca4f7ece3e$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $add6d3ca4f7ece3e$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $add6d3ca4f7ece3e$var$_enabled = !0;
function $add6d3ca4f7ece3e$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $add6d3ca4f7ece3e$var$ReactSharedInternals.T;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.T = null;
    var previousPriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
    try {
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 2, $add6d3ca4f7ece3e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = previousPriority, $add6d3ca4f7ece3e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $add6d3ca4f7ece3e$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $add6d3ca4f7ece3e$var$ReactSharedInternals.T;
    $add6d3ca4f7ece3e$var$ReactSharedInternals.T = null;
    var previousPriority = $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p;
    try {
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = 8, $add6d3ca4f7ece3e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $add6d3ca4f7ece3e$var$ReactDOMSharedInternals.p = previousPriority, $add6d3ca4f7ece3e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $add6d3ca4f7ece3e$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($add6d3ca4f7ece3e$var$_enabled) {
        var blockedOn = $add6d3ca4f7ece3e$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $add6d3ca4f7ece3e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $add6d3ca4f7ece3e$var$return_targetInst, targetContainer), $add6d3ca4f7ece3e$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($add6d3ca4f7ece3e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($add6d3ca4f7ece3e$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $add6d3ca4f7ece3e$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $add6d3ca4f7ece3e$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $add6d3ca4f7ece3e$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $add6d3ca4f7ece3e$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $add6d3ca4f7ece3e$var$ensureRootIsScheduled(fiber);
                                0 === ($add6d3ca4f7ece3e$var$executionContext & 6) && ($add6d3ca4f7ece3e$var$workInProgressRootRenderTargetTime = $add6d3ca4f7ece3e$var$now() + 500, $add6d3ca4f7ece3e$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $add6d3ca4f7ece3e$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(root, fiber, 2), $add6d3ca4f7ece3e$var$flushSyncWork$1(), $add6d3ca4f7ece3e$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $add6d3ca4f7ece3e$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $add6d3ca4f7ece3e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $add6d3ca4f7ece3e$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $add6d3ca4f7ece3e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $add6d3ca4f7ece3e$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $add6d3ca4f7ece3e$var$getEventTarget(nativeEvent);
    return $add6d3ca4f7ece3e$var$findInstanceBlockingTarget(nativeEvent);
}
var $add6d3ca4f7ece3e$var$return_targetInst = null;
function $add6d3ca4f7ece3e$var$findInstanceBlockingTarget(targetNode) {
    $add6d3ca4f7ece3e$var$return_targetInst = null;
    targetNode = $add6d3ca4f7ece3e$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $add6d3ca4f7ece3e$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $add6d3ca4f7ece3e$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $add6d3ca4f7ece3e$var$return_targetInst = targetNode;
    return null;
}
function $add6d3ca4f7ece3e$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($add6d3ca4f7ece3e$var$getCurrentPriorityLevel()){
                case $add6d3ca4f7ece3e$var$ImmediatePriority:
                    return 2;
                case $add6d3ca4f7ece3e$var$UserBlockingPriority:
                    return 8;
                case $add6d3ca4f7ece3e$var$NormalPriority$1:
                case $add6d3ca4f7ece3e$var$LowPriority:
                    return 32;
                case $add6d3ca4f7ece3e$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $add6d3ca4f7ece3e$var$hasScheduledReplayAttempt = !1, $add6d3ca4f7ece3e$var$queuedFocus = null, $add6d3ca4f7ece3e$var$queuedDrag = null, $add6d3ca4f7ece3e$var$queuedMouse = null, $add6d3ca4f7ece3e$var$queuedPointers = new Map(), $add6d3ca4f7ece3e$var$queuedPointerCaptures = new Map(), $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets = [], $add6d3ca4f7ece3e$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $add6d3ca4f7ece3e$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $add6d3ca4f7ece3e$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $add6d3ca4f7ece3e$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $add6d3ca4f7ece3e$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $add6d3ca4f7ece3e$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $add6d3ca4f7ece3e$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $add6d3ca4f7ece3e$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $add6d3ca4f7ece3e$var$getInstanceFromNode(blockedOn), null !== blockedOn && $add6d3ca4f7ece3e$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $add6d3ca4f7ece3e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $add6d3ca4f7ece3e$var$queuedFocus = $add6d3ca4f7ece3e$var$accumulateOrCreateContinuousQueuedReplayableEvent($add6d3ca4f7ece3e$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $add6d3ca4f7ece3e$var$queuedDrag = $add6d3ca4f7ece3e$var$accumulateOrCreateContinuousQueuedReplayableEvent($add6d3ca4f7ece3e$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $add6d3ca4f7ece3e$var$queuedMouse = $add6d3ca4f7ece3e$var$accumulateOrCreateContinuousQueuedReplayableEvent($add6d3ca4f7ece3e$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $add6d3ca4f7ece3e$var$queuedPointers.set(pointerId, $add6d3ca4f7ece3e$var$accumulateOrCreateContinuousQueuedReplayableEvent($add6d3ca4f7ece3e$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $add6d3ca4f7ece3e$var$queuedPointerCaptures.set(pointerId, $add6d3ca4f7ece3e$var$accumulateOrCreateContinuousQueuedReplayableEvent($add6d3ca4f7ece3e$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $add6d3ca4f7ece3e$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $add6d3ca4f7ece3e$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $add6d3ca4f7ece3e$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $add6d3ca4f7ece3e$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $add6d3ca4f7ece3e$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $add6d3ca4f7ece3e$var$requestUpdateLane();
                            lane = $add6d3ca4f7ece3e$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $add6d3ca4f7ece3e$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $add6d3ca4f7ece3e$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $add6d3ca4f7ece3e$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $add6d3ca4f7ece3e$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $add6d3ca4f7ece3e$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $add6d3ca4f7ece3e$var$currentReplayingEvent = null;
        } else return targetContainers = $add6d3ca4f7ece3e$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $add6d3ca4f7ece3e$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $add6d3ca4f7ece3e$var$replayUnblockedEvents() {
    $add6d3ca4f7ece3e$var$hasScheduledReplayAttempt = !1;
    null !== $add6d3ca4f7ece3e$var$queuedFocus && $add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEvent($add6d3ca4f7ece3e$var$queuedFocus) && ($add6d3ca4f7ece3e$var$queuedFocus = null);
    null !== $add6d3ca4f7ece3e$var$queuedDrag && $add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEvent($add6d3ca4f7ece3e$var$queuedDrag) && ($add6d3ca4f7ece3e$var$queuedDrag = null);
    null !== $add6d3ca4f7ece3e$var$queuedMouse && $add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEvent($add6d3ca4f7ece3e$var$queuedMouse) && ($add6d3ca4f7ece3e$var$queuedMouse = null);
    $add6d3ca4f7ece3e$var$queuedPointers.forEach($add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEventInMap);
    $add6d3ca4f7ece3e$var$queuedPointerCaptures.forEach($add6d3ca4f7ece3e$var$attemptReplayContinuousQueuedEventInMap);
}
function $add6d3ca4f7ece3e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $add6d3ca4f7ece3e$var$hasScheduledReplayAttempt || ($add6d3ca4f7ece3e$var$hasScheduledReplayAttempt = !0, $7ZzgL.unstable_scheduleCallback($7ZzgL.unstable_NormalPriority, $add6d3ca4f7ece3e$var$replayUnblockedEvents)));
}
var $add6d3ca4f7ece3e$var$lastScheduledReplayQueue = null;
function $add6d3ca4f7ece3e$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $add6d3ca4f7ece3e$var$lastScheduledReplayQueue !== formReplayingQueue && ($add6d3ca4f7ece3e$var$lastScheduledReplayQueue = formReplayingQueue, $7ZzgL.unstable_scheduleCallback($7ZzgL.unstable_NormalPriority, function() {
        $add6d3ca4f7ece3e$var$lastScheduledReplayQueue === formReplayingQueue && ($add6d3ca4f7ece3e$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $add6d3ca4f7ece3e$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $add6d3ca4f7ece3e$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $add6d3ca4f7ece3e$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $add6d3ca4f7ece3e$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $add6d3ca4f7ece3e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $add6d3ca4f7ece3e$var$queuedFocus && $add6d3ca4f7ece3e$var$scheduleCallbackIfUnblocked($add6d3ca4f7ece3e$var$queuedFocus, unblocked);
    null !== $add6d3ca4f7ece3e$var$queuedDrag && $add6d3ca4f7ece3e$var$scheduleCallbackIfUnblocked($add6d3ca4f7ece3e$var$queuedDrag, unblocked);
    null !== $add6d3ca4f7ece3e$var$queuedMouse && $add6d3ca4f7ece3e$var$scheduleCallbackIfUnblocked($add6d3ca4f7ece3e$var$queuedMouse, unblocked);
    $add6d3ca4f7ece3e$var$queuedPointers.forEach(unblock);
    $add6d3ca4f7ece3e$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets.length && (i = $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$add6d3ca4f7ece3e$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$add6d3ca4f7ece3e$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $add6d3ca4f7ece3e$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$add6d3ca4f7ece3e$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $add6d3ca4f7ece3e$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $add6d3ca4f7ece3e$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $add6d3ca4f7ece3e$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$add6d3ca4f7ece3e$var$ReactDOMHydrationRoot.prototype.render = $add6d3ca4f7ece3e$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(409));
    var current = root.current, lane = $add6d3ca4f7ece3e$var$requestUpdateLane();
    $add6d3ca4f7ece3e$var$updateContainerImpl(current, lane, children, root, null, null);
};
$add6d3ca4f7ece3e$var$ReactDOMHydrationRoot.prototype.unmount = $add6d3ca4f7ece3e$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $add6d3ca4f7ece3e$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $add6d3ca4f7ece3e$var$flushSyncWork$1();
        container[$add6d3ca4f7ece3e$var$internalContainerInstanceKey] = null;
    }
};
function $add6d3ca4f7ece3e$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$add6d3ca4f7ece3e$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $add6d3ca4f7ece3e$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets[i].priority; i++);
        $add6d3ca4f7ece3e$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $add6d3ca4f7ece3e$var$attemptExplicitHydrationTarget(target);
    }
};
var $add6d3ca4f7ece3e$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $6uYXW.version;
if ("19.1.0" !== $add6d3ca4f7ece3e$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(527, $add6d3ca4f7ece3e$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$add6d3ca4f7ece3e$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $add6d3ca4f7ece3e$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $add6d3ca4f7ece3e$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $add6d3ca4f7ece3e$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $add6d3ca4f7ece3e$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $add6d3ca4f7ece3e$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$add6d3ca4f7ece3e$var$hook$jscomp$inline_2257.isDisabled && $add6d3ca4f7ece3e$var$hook$jscomp$inline_2257.supportsFiber) try {
        $add6d3ca4f7ece3e$var$rendererID = $add6d3ca4f7ece3e$var$hook$jscomp$inline_2257.inject($add6d3ca4f7ece3e$var$internals$jscomp$inline_2256), $add6d3ca4f7ece3e$var$injectedHook = $add6d3ca4f7ece3e$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$add6d3ca4f7ece3e$export$882461b6382ed46c = function(container, options) {
    if (!$add6d3ca4f7ece3e$var$isValidContainer(container)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $add6d3ca4f7ece3e$var$defaultOnUncaughtError, onCaughtError = $add6d3ca4f7ece3e$var$defaultOnCaughtError, onRecoverableError = $add6d3ca4f7ece3e$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $add6d3ca4f7ece3e$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$add6d3ca4f7ece3e$var$internalContainerInstanceKey] = options.current;
    $add6d3ca4f7ece3e$var$listenToAllSupportedEvents(container);
    return new $add6d3ca4f7ece3e$var$ReactDOMRoot(options);
};
$add6d3ca4f7ece3e$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$add6d3ca4f7ece3e$var$isValidContainer(container)) throw Error($add6d3ca4f7ece3e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $add6d3ca4f7ece3e$var$defaultOnUncaughtError, onCaughtError = $add6d3ca4f7ece3e$var$defaultOnCaughtError, onRecoverableError = $add6d3ca4f7ece3e$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $add6d3ca4f7ece3e$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $add6d3ca4f7ece3e$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $add6d3ca4f7ece3e$var$requestUpdateLane();
    isStrictMode = $add6d3ca4f7ece3e$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $add6d3ca4f7ece3e$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $add6d3ca4f7ece3e$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $add6d3ca4f7ece3e$var$markRootUpdated$1(initialChildren, options);
    $add6d3ca4f7ece3e$var$ensureRootIsScheduled(initialChildren);
    container[$add6d3ca4f7ece3e$var$internalContainerInstanceKey] = initialChildren.current;
    $add6d3ca4f7ece3e$var$listenToAllSupportedEvents(container);
    return new $add6d3ca4f7ece3e$var$ReactDOMHydrationRoot(initialChildren);
};
$add6d3ca4f7ece3e$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("7ZzgL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89sPW"));

});
parcelRegister("89sPW", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5ef5885a568f9299$export$c4744153514ff05d; }, function (v) { return $5ef5885a568f9299$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5ef5885a568f9299$export$3e506c1ccc9cc1a7; }, function (v) { return $5ef5885a568f9299$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5ef5885a568f9299$export$e26fe2ed2fa76875; }, function (v) { return $5ef5885a568f9299$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5ef5885a568f9299$export$502329bbf4b505b1; }, function (v) { return $5ef5885a568f9299$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5ef5885a568f9299$export$6e3807111c4874c4; }, function (v) { return $5ef5885a568f9299$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5ef5885a568f9299$export$c27134553091fb3a; }, function (v) { return $5ef5885a568f9299$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5ef5885a568f9299$export$33ee1acdc04fd2a2; }, function (v) { return $5ef5885a568f9299$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5ef5885a568f9299$export$b00a404bbd5edef2; }, function (v) { return $5ef5885a568f9299$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5ef5885a568f9299$export$d66a1c1c77bd778b; }, function (v) { return $5ef5885a568f9299$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5ef5885a568f9299$export$d3dfb8e4810cb555; }, function (v) { return $5ef5885a568f9299$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5ef5885a568f9299$export$72fdf0e06517287b; }, function (v) { return $5ef5885a568f9299$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5ef5885a568f9299$export$816d2913ae6b83b1; }, function (v) { return $5ef5885a568f9299$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5ef5885a568f9299$export$61bcfe829111a1d0; }, function (v) { return $5ef5885a568f9299$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5ef5885a568f9299$export$7ee8c9beb337bc3f; }, function (v) { return $5ef5885a568f9299$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5ef5885a568f9299$export$b5836b71941fa3ed; }, function (v) { return $5ef5885a568f9299$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5ef5885a568f9299$export$cf845f2c119da08a; }, function (v) { return $5ef5885a568f9299$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef5885a568f9299$export$c4744153514ff05d;
var $5ef5885a568f9299$export$3e506c1ccc9cc1a7;
var $5ef5885a568f9299$export$e26fe2ed2fa76875;
var $5ef5885a568f9299$export$502329bbf4b505b1;
var $5ef5885a568f9299$export$6e3807111c4874c4;
var $5ef5885a568f9299$export$c27134553091fb3a;
var $5ef5885a568f9299$export$33ee1acdc04fd2a2;
var $5ef5885a568f9299$export$b00a404bbd5edef2;
var $5ef5885a568f9299$export$d66a1c1c77bd778b;
var $5ef5885a568f9299$export$d3dfb8e4810cb555;
var $5ef5885a568f9299$export$72fdf0e06517287b;
var $5ef5885a568f9299$export$816d2913ae6b83b1;
var $5ef5885a568f9299$export$61bcfe829111a1d0;
var $5ef5885a568f9299$export$7ee8c9beb337bc3f;
var $5ef5885a568f9299$export$b5836b71941fa3ed;
var $5ef5885a568f9299$export$cf845f2c119da08a;
"use strict";
function $5ef5885a568f9299$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $5ef5885a568f9299$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $5ef5885a568f9299$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $5ef5885a568f9299$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $5ef5885a568f9299$var$compare(left, last)) rightIndex < length && 0 > $5ef5885a568f9299$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $5ef5885a568f9299$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $5ef5885a568f9299$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$5ef5885a568f9299$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5ef5885a568f9299$var$localPerformance = performance;
    $5ef5885a568f9299$export$c4744153514ff05d = function() {
        return $5ef5885a568f9299$var$localPerformance.now();
    };
} else {
    var $5ef5885a568f9299$var$localDate = Date, $5ef5885a568f9299$var$initialTime = $5ef5885a568f9299$var$localDate.now();
    $5ef5885a568f9299$export$c4744153514ff05d = function() {
        return $5ef5885a568f9299$var$localDate.now() - $5ef5885a568f9299$var$initialTime;
    };
}
var $5ef5885a568f9299$var$taskQueue = [], $5ef5885a568f9299$var$timerQueue = [], $5ef5885a568f9299$var$taskIdCounter = 1, $5ef5885a568f9299$var$currentTask = null, $5ef5885a568f9299$var$currentPriorityLevel = 3, $5ef5885a568f9299$var$isPerformingWork = !1, $5ef5885a568f9299$var$isHostCallbackScheduled = !1, $5ef5885a568f9299$var$isHostTimeoutScheduled = !1, $5ef5885a568f9299$var$needsPaint = !1, $5ef5885a568f9299$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $5ef5885a568f9299$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $5ef5885a568f9299$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $5ef5885a568f9299$var$advanceTimers(currentTime) {
    for(var timer = $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$timerQueue); null !== timer;){
        if (null === timer.callback) $5ef5885a568f9299$var$pop($5ef5885a568f9299$var$timerQueue);
        else if (timer.startTime <= currentTime) $5ef5885a568f9299$var$pop($5ef5885a568f9299$var$timerQueue), timer.sortIndex = timer.expirationTime, $5ef5885a568f9299$var$push($5ef5885a568f9299$var$taskQueue, timer);
        else break;
        timer = $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$timerQueue);
    }
}
function $5ef5885a568f9299$var$handleTimeout(currentTime) {
    $5ef5885a568f9299$var$isHostTimeoutScheduled = !1;
    $5ef5885a568f9299$var$advanceTimers(currentTime);
    if (!$5ef5885a568f9299$var$isHostCallbackScheduled) {
        if (null !== $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$taskQueue)) $5ef5885a568f9299$var$isHostCallbackScheduled = !0, $5ef5885a568f9299$var$isMessageLoopRunning || ($5ef5885a568f9299$var$isMessageLoopRunning = !0, $5ef5885a568f9299$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$timerQueue);
            null !== firstTimer && $5ef5885a568f9299$var$requestHostTimeout($5ef5885a568f9299$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $5ef5885a568f9299$var$isMessageLoopRunning = !1, $5ef5885a568f9299$var$taskTimeoutID = -1, $5ef5885a568f9299$var$frameInterval = 5, $5ef5885a568f9299$var$startTime = -1;
function $5ef5885a568f9299$var$shouldYieldToHost() {
    return $5ef5885a568f9299$var$needsPaint ? !0 : $5ef5885a568f9299$export$c4744153514ff05d() - $5ef5885a568f9299$var$startTime < $5ef5885a568f9299$var$frameInterval ? !1 : !0;
}
function $5ef5885a568f9299$var$performWorkUntilDeadline() {
    $5ef5885a568f9299$var$needsPaint = !1;
    if ($5ef5885a568f9299$var$isMessageLoopRunning) {
        var currentTime = $5ef5885a568f9299$export$c4744153514ff05d();
        $5ef5885a568f9299$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $5ef5885a568f9299$var$isHostCallbackScheduled = !1;
                $5ef5885a568f9299$var$isHostTimeoutScheduled && ($5ef5885a568f9299$var$isHostTimeoutScheduled = !1, $5ef5885a568f9299$var$localClearTimeout($5ef5885a568f9299$var$taskTimeoutID), $5ef5885a568f9299$var$taskTimeoutID = -1);
                $5ef5885a568f9299$var$isPerformingWork = !0;
                var previousPriorityLevel = $5ef5885a568f9299$var$currentPriorityLevel;
                try {
                    b: {
                        $5ef5885a568f9299$var$advanceTimers(currentTime);
                        for($5ef5885a568f9299$var$currentTask = $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$taskQueue); null !== $5ef5885a568f9299$var$currentTask && !($5ef5885a568f9299$var$currentTask.expirationTime > currentTime && $5ef5885a568f9299$var$shouldYieldToHost());){
                            var callback = $5ef5885a568f9299$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $5ef5885a568f9299$var$currentTask.callback = null;
                                $5ef5885a568f9299$var$currentPriorityLevel = $5ef5885a568f9299$var$currentTask.priorityLevel;
                                var continuationCallback = callback($5ef5885a568f9299$var$currentTask.expirationTime <= currentTime);
                                currentTime = $5ef5885a568f9299$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $5ef5885a568f9299$var$currentTask.callback = continuationCallback;
                                    $5ef5885a568f9299$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $5ef5885a568f9299$var$currentTask === $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$taskQueue) && $5ef5885a568f9299$var$pop($5ef5885a568f9299$var$taskQueue);
                                $5ef5885a568f9299$var$advanceTimers(currentTime);
                            } else $5ef5885a568f9299$var$pop($5ef5885a568f9299$var$taskQueue);
                            $5ef5885a568f9299$var$currentTask = $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$taskQueue);
                        }
                        if (null !== $5ef5885a568f9299$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$timerQueue);
                            null !== firstTimer && $5ef5885a568f9299$var$requestHostTimeout($5ef5885a568f9299$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $5ef5885a568f9299$var$currentTask = null, $5ef5885a568f9299$var$currentPriorityLevel = previousPriorityLevel, $5ef5885a568f9299$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $5ef5885a568f9299$var$schedulePerformWorkUntilDeadline() : $5ef5885a568f9299$var$isMessageLoopRunning = !1;
        }
    }
}
var $5ef5885a568f9299$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $5ef5885a568f9299$var$localSetImmediate) $5ef5885a568f9299$var$schedulePerformWorkUntilDeadline = function() {
    $5ef5885a568f9299$var$localSetImmediate($5ef5885a568f9299$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5ef5885a568f9299$var$channel = new MessageChannel(), $5ef5885a568f9299$var$port = $5ef5885a568f9299$var$channel.port2;
    $5ef5885a568f9299$var$channel.port1.onmessage = $5ef5885a568f9299$var$performWorkUntilDeadline;
    $5ef5885a568f9299$var$schedulePerformWorkUntilDeadline = function() {
        $5ef5885a568f9299$var$port.postMessage(null);
    };
} else $5ef5885a568f9299$var$schedulePerformWorkUntilDeadline = function() {
    $5ef5885a568f9299$var$localSetTimeout($5ef5885a568f9299$var$performWorkUntilDeadline, 0);
};
function $5ef5885a568f9299$var$requestHostTimeout(callback, ms) {
    $5ef5885a568f9299$var$taskTimeoutID = $5ef5885a568f9299$var$localSetTimeout(function() {
        callback($5ef5885a568f9299$export$c4744153514ff05d());
    }, ms);
}
$5ef5885a568f9299$export$3e506c1ccc9cc1a7 = 5;
$5ef5885a568f9299$export$e26fe2ed2fa76875 = 1;
$5ef5885a568f9299$export$502329bbf4b505b1 = 4;
$5ef5885a568f9299$export$6e3807111c4874c4 = 3;
$5ef5885a568f9299$export$c27134553091fb3a = null;
$5ef5885a568f9299$export$33ee1acdc04fd2a2 = 2;
$5ef5885a568f9299$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$5ef5885a568f9299$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5ef5885a568f9299$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$5ef5885a568f9299$export$d3dfb8e4810cb555 = function() {
    return $5ef5885a568f9299$var$currentPriorityLevel;
};
$5ef5885a568f9299$export$72fdf0e06517287b = function(eventHandler) {
    switch($5ef5885a568f9299$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $5ef5885a568f9299$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $5ef5885a568f9299$var$currentPriorityLevel;
    $5ef5885a568f9299$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5ef5885a568f9299$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5ef5885a568f9299$export$816d2913ae6b83b1 = function() {
    $5ef5885a568f9299$var$needsPaint = !0;
};
$5ef5885a568f9299$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $5ef5885a568f9299$var$currentPriorityLevel;
    $5ef5885a568f9299$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5ef5885a568f9299$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5ef5885a568f9299$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $5ef5885a568f9299$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $5ef5885a568f9299$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $5ef5885a568f9299$var$push($5ef5885a568f9299$var$timerQueue, priorityLevel), null === $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$taskQueue) && priorityLevel === $5ef5885a568f9299$var$peek($5ef5885a568f9299$var$timerQueue) && ($5ef5885a568f9299$var$isHostTimeoutScheduled ? ($5ef5885a568f9299$var$localClearTimeout($5ef5885a568f9299$var$taskTimeoutID), $5ef5885a568f9299$var$taskTimeoutID = -1) : $5ef5885a568f9299$var$isHostTimeoutScheduled = !0, $5ef5885a568f9299$var$requestHostTimeout($5ef5885a568f9299$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $5ef5885a568f9299$var$push($5ef5885a568f9299$var$taskQueue, priorityLevel), $5ef5885a568f9299$var$isHostCallbackScheduled || $5ef5885a568f9299$var$isPerformingWork || ($5ef5885a568f9299$var$isHostCallbackScheduled = !0, $5ef5885a568f9299$var$isMessageLoopRunning || ($5ef5885a568f9299$var$isMessageLoopRunning = !0, $5ef5885a568f9299$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$5ef5885a568f9299$export$b5836b71941fa3ed = $5ef5885a568f9299$var$shouldYieldToHost;
$5ef5885a568f9299$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $5ef5885a568f9299$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $5ef5885a568f9299$var$currentPriorityLevel;
        $5ef5885a568f9299$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $5ef5885a568f9299$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("6uYXW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lHU4h"));

});

parcelRegister("6JczY", function(module, exports) {
'use strict';
function $4e60b4008b7e4540$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4e60b4008b7e4540$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4e60b4008b7e4540$var$checkDCE();

module.exports = (parcelRequire("6GiRz"));

});
parcelRegister("6GiRz", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $4dd54c26ce7723ab$export$69ce8ef3fe5cead0; }, function (v) { return $4dd54c26ce7723ab$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $4dd54c26ce7723ab$export$d39a5bbd09211389; }, function (v) { return $4dd54c26ce7723ab$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4dd54c26ce7723ab$export$cd75ccfd720a3cd4; }, function (v) { return $4dd54c26ce7723ab$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $4dd54c26ce7723ab$export$a0816fa17a9e79be; }, function (v) { return $4dd54c26ce7723ab$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $4dd54c26ce7723ab$export$7292efcadded39f3; }, function (v) { return $4dd54c26ce7723ab$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $4dd54c26ce7723ab$export$da407abadb9b8f86; }, function (v) { return $4dd54c26ce7723ab$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $4dd54c26ce7723ab$export$314cfea32580671c; }, function (v) { return $4dd54c26ce7723ab$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $4dd54c26ce7723ab$export$513ccb98c53b8039; }, function (v) { return $4dd54c26ce7723ab$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $4dd54c26ce7723ab$export$dbca993bc2d264a; }, function (v) { return $4dd54c26ce7723ab$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $4dd54c26ce7723ab$export$4797a8006f0655d0; }, function (v) { return $4dd54c26ce7723ab$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4dd54c26ce7723ab$export$c78a37762a8d58e1; }, function (v) { return $4dd54c26ce7723ab$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $4dd54c26ce7723ab$export$606f11b2eb45ecc6; }, function (v) { return $4dd54c26ce7723ab$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $4dd54c26ce7723ab$export$f7e8a0bf92324b1e; }, function (v) { return $4dd54c26ce7723ab$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $4dd54c26ce7723ab$export$83d89fbfd8236492; }, function (v) { return $4dd54c26ce7723ab$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4dd54c26ce7723ab$export$69ce8ef3fe5cead0;
var $4dd54c26ce7723ab$export$d39a5bbd09211389;
var $4dd54c26ce7723ab$export$cd75ccfd720a3cd4;
var $4dd54c26ce7723ab$export$a0816fa17a9e79be;
var $4dd54c26ce7723ab$export$7292efcadded39f3;
var $4dd54c26ce7723ab$export$da407abadb9b8f86;
var $4dd54c26ce7723ab$export$314cfea32580671c;
var $4dd54c26ce7723ab$export$513ccb98c53b8039;
var $4dd54c26ce7723ab$export$dbca993bc2d264a;
var $4dd54c26ce7723ab$export$4797a8006f0655d0;
var $4dd54c26ce7723ab$export$c78a37762a8d58e1;
var $4dd54c26ce7723ab$export$606f11b2eb45ecc6;
var $4dd54c26ce7723ab$export$f7e8a0bf92324b1e;
var $4dd54c26ce7723ab$export$83d89fbfd8236492;
"use strict";

var $6uYXW = parcelRequire("6uYXW");
function $4dd54c26ce7723ab$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4dd54c26ce7723ab$var$noop() {}
var $4dd54c26ce7723ab$var$Internals = {
    d: {
        f: $4dd54c26ce7723ab$var$noop,
        r: function() {
            throw Error($4dd54c26ce7723ab$var$formatProdErrorMessage(522));
        },
        D: $4dd54c26ce7723ab$var$noop,
        C: $4dd54c26ce7723ab$var$noop,
        L: $4dd54c26ce7723ab$var$noop,
        m: $4dd54c26ce7723ab$var$noop,
        X: $4dd54c26ce7723ab$var$noop,
        S: $4dd54c26ce7723ab$var$noop,
        M: $4dd54c26ce7723ab$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4dd54c26ce7723ab$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4dd54c26ce7723ab$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4dd54c26ce7723ab$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4dd54c26ce7723ab$var$ReactSharedInternals = $6uYXW.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4dd54c26ce7723ab$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4dd54c26ce7723ab$export$69ce8ef3fe5cead0 = $4dd54c26ce7723ab$var$Internals;
$4dd54c26ce7723ab$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4dd54c26ce7723ab$var$formatProdErrorMessage(299));
    return $4dd54c26ce7723ab$var$createPortal$1(children, container, null, key);
};
$4dd54c26ce7723ab$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4dd54c26ce7723ab$var$ReactSharedInternals.T, previousUpdatePriority = $4dd54c26ce7723ab$var$Internals.p;
    try {
        if ($4dd54c26ce7723ab$var$ReactSharedInternals.T = null, $4dd54c26ce7723ab$var$Internals.p = 2, fn) return fn();
    } finally{
        $4dd54c26ce7723ab$var$ReactSharedInternals.T = previousTransition, $4dd54c26ce7723ab$var$Internals.p = previousUpdatePriority, $4dd54c26ce7723ab$var$Internals.d.f();
    }
};
$4dd54c26ce7723ab$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4dd54c26ce7723ab$var$Internals.d.C(href, options));
};
$4dd54c26ce7723ab$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4dd54c26ce7723ab$var$Internals.d.D(href);
};
$4dd54c26ce7723ab$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4dd54c26ce7723ab$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4dd54c26ce7723ab$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4dd54c26ce7723ab$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4dd54c26ce7723ab$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4dd54c26ce7723ab$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4dd54c26ce7723ab$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4dd54c26ce7723ab$var$Internals.d.M(href);
    }
};
$4dd54c26ce7723ab$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4dd54c26ce7723ab$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4dd54c26ce7723ab$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4dd54c26ce7723ab$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4dd54c26ce7723ab$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4dd54c26ce7723ab$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4dd54c26ce7723ab$var$Internals.d.m(href);
    }
};
$4dd54c26ce7723ab$export$4797a8006f0655d0 = function(form) {
    $4dd54c26ce7723ab$var$Internals.d.r(form);
};
$4dd54c26ce7723ab$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4dd54c26ce7723ab$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4dd54c26ce7723ab$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4dd54c26ce7723ab$export$f7e8a0bf92324b1e = function() {
    return $4dd54c26ce7723ab$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4dd54c26ce7723ab$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("im1V7", function(module, exports) {

$parcel$export(module.exports, "App", function () { return $bb39d134c5d70c64$export$86fbec116b87613f; });

var $4m918 = parcelRequire("4m918");

var $2jW13 = parcelRequire("2jW13");

var $6uYXW = parcelRequire("6uYXW");

var $4tZhP = parcelRequire("4tZhP");

var $b8ojz = parcelRequire("b8ojz");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $dFWfS = parcelRequire("dFWfS");

var $gfeLQ = parcelRequire("gfeLQ");

var $5Wai4 = parcelRequire("5Wai4");

var $csDxW = parcelRequire("csDxW");
// styled-components v6 dropped the automatic prop filtering v5 did: without this guard
// every prop that is not prefixed with "$" reaches the underlying HTML element.
const $bb39d134c5d70c64$var$shouldForwardProp = (prop, target)=>typeof target === "string" ? (0, $2jW13.default)(prop) : true;
function $bb39d134c5d70c64$export$86fbec116b87613f() {
    const [initialized, setInitialized] = (0, $6uYXW.useState)(false);
    const isConnected = (0, $3Ersk.useObservable)((0, $kqXxS.authenticationManager).isConnected);
    const isAuthenticated = (0, $3Ersk.useObservable)((0, $kqXxS.authenticationManager).isAuthenticated);
    const errorHandler = (0, $3Ersk.useObservable)((0, $kqXxS.errorStore).error);
    const [showErrorScreen, setShowErrorScreen] = (0, $6uYXW.useState)(false);
    (0, $6uYXW.useEffect)(()=>{
        if (!errorHandler) {
            async function initializeWebApp() {
                try {
                    if ((0, $kqXxS.webAppStartManager) && (0, $kqXxS.webAppStartManager).startApp) {
                        await (0, $kqXxS.webAppStartManager).startApp();
                        setInitialized(true);
                    } else throw new Error("webAppStartManager or webAppStartManager.startApp is undefined");
                } catch (error) {
                    setShowErrorScreen(true);
                }
            }
            initializeWebApp();
        }
    }, []);
    (0, $6uYXW.useEffect)(()=>{
        if (errorHandler && showErrorScreen) (0, $kqXxS.errorStore).error.set(null);
    }, [
        errorHandler,
        showErrorScreen
    ]);
    (0, $4tZhP.useIdleTimer)({
        // 5 minutes
        timeout: 300000,
        onIdle: ()=>handleOnIdle(),
        debounce: 5000
    });
    const handleOnIdle = async ()=>{
        if (isConnected && isAuthenticated) {
            await (0, $kqXxS.authenticationManager).logout(true, true);
            (0, $5Wai4.Modal).dismissAll();
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $jb8NR.StyleSheetManager), {
        shouldForwardProp: $bb39d134c5d70c64$var$shouldForwardProp,
        children: showErrorScreen ? /*#__PURE__*/ (0, $4m918.jsx)((0, $csDxW.ErrorScreen), {}) : initialized ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $b8ojz.BrowserRouter), {
            basename: (0, $dhPTb.Config).BASE_URL,
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)((0, $dFWfS.AppRouter), {}),
                /*#__PURE__*/ (0, $4m918.jsx)((0, $5Wai4.ModalContainer), {})
            ]
        }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $gfeLQ.BootSplash), {})
    });
}

});
parcelRegister("4m918", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lwode"));

});
parcelRegister("lwode", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $faaf5e3a8d8d6836$export$ffb0004e005737fa; }, function (v) { return $faaf5e3a8d8d6836$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $faaf5e3a8d8d6836$export$34b9dba7ce09269b; }, function (v) { return $faaf5e3a8d8d6836$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $faaf5e3a8d8d6836$export$25062201e9e25d76; }, function (v) { return $faaf5e3a8d8d6836$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $faaf5e3a8d8d6836$export$ffb0004e005737fa;
var $faaf5e3a8d8d6836$export$34b9dba7ce09269b;
var $faaf5e3a8d8d6836$export$25062201e9e25d76;
"use strict";
var $faaf5e3a8d8d6836$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $faaf5e3a8d8d6836$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $faaf5e3a8d8d6836$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $faaf5e3a8d8d6836$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$faaf5e3a8d8d6836$export$ffb0004e005737fa = $faaf5e3a8d8d6836$var$REACT_FRAGMENT_TYPE;
$faaf5e3a8d8d6836$export$34b9dba7ce09269b = $faaf5e3a8d8d6836$var$jsxProd;
$faaf5e3a8d8d6836$export$25062201e9e25d76 = $faaf5e3a8d8d6836$var$jsxProd;

});


parcelRegister("2jW13", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b0a5be5aea90fc5$export$2e2bcd8739ae039; });

var $yMure = parcelRequire("yMure");
var $1b0a5be5aea90fc5$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $1b0a5be5aea90fc5$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $yMure.default)(function(prop) {
    return $1b0a5be5aea90fc5$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("yMure", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0688ca2ea105b5ec$export$2e2bcd8739ae039; });
function $0688ca2ea105b5ec$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4tZhP", function(module, exports) {

$parcel$export(module.exports, "useIdleTimer", function () { return $3439691a546f172a$export$3e1c2ef16041091f; });

var $6uYXW = parcelRequire("6uYXW");
var $3439691a546f172a$var$dr = Object.create;
var $3439691a546f172a$var$Lt = Object.defineProperty;
var $3439691a546f172a$var$pr = Object.getOwnPropertyDescriptor;
var $3439691a546f172a$var$vr = Object.getOwnPropertyNames;
var $3439691a546f172a$var$hr = Object.getPrototypeOf, $3439691a546f172a$var$_r = Object.prototype.hasOwnProperty;
var $3439691a546f172a$var$yr = function(e, r) {
    return function() {
        return r || e((r = {
            exports: {}
        }).exports, r), r.exports;
    };
};
var $3439691a546f172a$var$gr = function(e, r, t, o) {
    if (r && typeof r == "object" || typeof r == "function") for(var n = $3439691a546f172a$var$vr(r), c = 0, s = n.length, a; c < s; c++)a = n[c], !$3439691a546f172a$var$_r.call(e, a) && a !== t && $3439691a546f172a$var$Lt(e, a, {
        get: (function(l) {
            return r[l];
        }).bind(null, a),
        enumerable: !(o = $3439691a546f172a$var$pr(r, a)) || o.enumerable
    });
    return e;
};
var $3439691a546f172a$var$wr = function(e, r, t) {
    return t = e != null ? $3439691a546f172a$var$dr($3439691a546f172a$var$hr(e)) : {}, $3439691a546f172a$var$gr(r || !e || !e.__esModule ? $3439691a546f172a$var$Lt(t, "default", {
        value: e,
        enumerable: !0
    }) : t, e);
};
var $3439691a546f172a$var$Nt = $3439691a546f172a$var$yr(function(Ue, Dt) {
    (function(e, r) {
        typeof Ue == "object" && typeof Dt != "undefined" ? r(Ue) : typeof define == "function" && define.amd ? define([
            "exports"
        ], r) : (e = typeof globalThis != "undefined" ? globalThis : e || self, r(e.fastUniqueNumbers = {}));
    })(Ue, function(e) {
        "use strict";
        var r = function(I) {
            return function(S) {
                var v = I(S);
                return S.add(v), v;
            };
        }, t = function(I) {
            return function(S, v) {
                return I.set(S, v), v;
            };
        }, o = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, n = 536870912, c = n * 2, s = function(I, S) {
            return function(v) {
                var U = S.get(v), T = U === void 0 ? v.size : U < c ? U + 1 : 0;
                if (!v.has(T)) return I(v, T);
                if (v.size < n) {
                    for(; v.has(T);)T = Math.floor(Math.random() * c);
                    return I(v, T);
                }
                if (v.size > o) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
                for(; v.has(T);)T = Math.floor(Math.random() * o);
                return I(v, T);
            };
        }, a = new WeakMap, l = t(a), d = s(l, a), u = r(d);
        e.addUniqueNumber = u, e.generateUniqueNumber = d;
    });
});
function $3439691a546f172a$var$Y(e) {
    if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $3439691a546f172a$var$je(e, r) {
    return r != null && typeof Symbol != "undefined" && r[Symbol.hasInstance] ? !!r[Symbol.hasInstance](e) : $3439691a546f172a$var$je(e, r);
}
function $3439691a546f172a$var$z(e, r) {
    if (!$3439691a546f172a$var$je(e, r)) throw new TypeError("Cannot call a class as a function");
}
function $3439691a546f172a$var$De(e, r) {
    return $3439691a546f172a$var$De = Object.setPrototypeOf || function(o, n) {
        return o.__proto__ = n, o;
    }, $3439691a546f172a$var$De(e, r);
}
function $3439691a546f172a$var$Ke(e, r) {
    if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(r && r.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), r && $3439691a546f172a$var$De(e, r);
}
function $3439691a546f172a$var$h(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3439691a546f172a$var$Qe(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = arguments[r] != null ? arguments[r] : {}, o = Object.keys(t);
        typeof Object.getOwnPropertySymbols == "function" && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(n) {
            return Object.getOwnPropertyDescriptor(t, n).enumerable;
        }))), o.forEach(function(n) {
            $3439691a546f172a$var$h(e, n, t[n]);
        });
    }
    return e;
}
function $3439691a546f172a$var$be(e) {
    return $3439691a546f172a$var$be = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $3439691a546f172a$var$be(e);
}
function $3439691a546f172a$var$Pt() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (e) {
        return !1;
    }
}
function $3439691a546f172a$var$Ne(e) {
    "@swc/helpers - typeof";
    return e && typeof Symbol != "undefined" && e.constructor === Symbol ? "symbol" : typeof e;
}
function $3439691a546f172a$var$kt(e, r) {
    return r && ($3439691a546f172a$var$Ne(r) === "object" || typeof r == "function") ? r : $3439691a546f172a$var$Y(e);
}
function $3439691a546f172a$var$Ze(e) {
    var r = $3439691a546f172a$var$Pt();
    return function() {
        var o = $3439691a546f172a$var$be(e), n;
        if (r) {
            var c = $3439691a546f172a$var$be(this).constructor;
            n = Reflect.construct(o, arguments, c);
        } else n = o.apply(this, arguments);
        return $3439691a546f172a$var$kt(this, n);
    };
}
function $3439691a546f172a$export$1b06ce49faf19067(e) {
    return (0, $6uYXW.forwardRef)(function(t, o) {
        var n = $3439691a546f172a$var$Qe({}, t), c = $3439691a546f172a$export$3e1c2ef16041091f(n);
        return typeof o == "function" ? o(c) : o && (o.current = c), (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(e, $3439691a546f172a$var$Qe({}, t, c));
    });
}
var $3439691a546f172a$var$xr = function(e) {
    "use strict";
    $3439691a546f172a$var$Ke(t, e);
    var r = $3439691a546f172a$var$Ze(t);
    function t() {
        return $3439691a546f172a$var$z(this, t), r.apply(this, arguments);
    }
    return t;
}((0, $6uYXW.Component)), $3439691a546f172a$export$c0b73c5063fae2ae = function(e) {
    "use strict";
    $3439691a546f172a$var$Ke(t, e);
    var r = $3439691a546f172a$var$Ze(t);
    function t(o) {
        $3439691a546f172a$var$z(this, t);
        var n;
        return n = r.call(this, o), n.onPresenceChange && o.setOnPresenceChange(n.onPresenceChange.bind($3439691a546f172a$var$Y(n))), n.onPrompt && o.setOnPrompt(n.onPrompt.bind($3439691a546f172a$var$Y(n))), n.onIdle && o.setOnIdle(n.onIdle.bind($3439691a546f172a$var$Y(n))), n.onActive && o.setOnActive(n.onActive.bind($3439691a546f172a$var$Y(n))), n.onAction && o.setOnAction(n.onAction.bind($3439691a546f172a$var$Y(n))), n.onMessage && o.setOnMessage(n.onMessage.bind($3439691a546f172a$var$Y(n))), n;
    }
    return t;
}($3439691a546f172a$var$xr);
function $3439691a546f172a$var$Ee(e, r) {
    (r == null || r > e.length) && (r = e.length);
    for(var t = 0, o = new Array(r); t < r; t++)o[t] = e[t];
    return o;
}
function $3439691a546f172a$var$At(e) {
    if (Array.isArray(e)) return $3439691a546f172a$var$Ee(e);
}
function $3439691a546f172a$var$Rt(e) {
    if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function $3439691a546f172a$var$Mt() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3439691a546f172a$var$Ct(e, r) {
    if (e) {
        if (typeof e == "string") return $3439691a546f172a$var$Ee(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(t);
        if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return $3439691a546f172a$var$Ee(e, r);
    }
}
function $3439691a546f172a$var$O(e) {
    return $3439691a546f172a$var$At(e) || $3439691a546f172a$var$Rt(e) || $3439691a546f172a$var$Ct(e) || $3439691a546f172a$var$Mt();
}
function $3439691a546f172a$var$jt(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
}
function $3439691a546f172a$var$ce(e, r, t) {
    return r && $3439691a546f172a$var$jt(e.prototype, r), t && $3439691a546f172a$var$jt(e, t), e;
}
var $3439691a546f172a$var$Ie = $3439691a546f172a$var$wr($3439691a546f172a$var$Nt());
var $3439691a546f172a$var$Ut = function(e) {
    return e.method !== void 0 && e.method === "call";
};
var $3439691a546f172a$var$Bt = function(e) {
    return e.error === null && typeof e.id == "number";
};
var $3439691a546f172a$var$Vt = function(e) {
    var r = new Map([
        [
            0,
            function() {}
        ]
    ]), t = new Map([
        [
            0,
            function() {}
        ]
    ]), o = new Map, n = new Worker(e);
    n.addEventListener("message", function(d) {
        var u = d.data;
        if ($3439691a546f172a$var$Ut(u)) {
            var _ = u.params, I = _.timerId, S = _.timerType;
            if (S === "interval") {
                var v = r.get(I);
                if (typeof v == "number") {
                    var U = o.get(v);
                    if (U === void 0 || U.timerId !== I || U.timerType !== S) throw new Error("The timer is in an undefined state.");
                } else if (typeof v != "undefined") v();
                else throw new Error("The timer is in an undefined state.");
            } else if (S === "timeout") {
                var T = t.get(I);
                if (typeof T == "number") {
                    var re = o.get(T);
                    if (re === void 0 || re.timerId !== I || re.timerType !== S) throw new Error("The timer is in an undefined state.");
                } else if (typeof T != "undefined") T(), t.delete(I);
                else throw new Error("The timer is in an undefined state.");
            }
        } else if ($3439691a546f172a$var$Bt(u)) {
            var X = u.id, ne = o.get(X);
            if (ne === void 0) throw new Error("The timer is in an undefined state.");
            var $ = ne.timerId, Oe = ne.timerType;
            o.delete(X), Oe === "interval" ? r.delete($) : t.delete($);
        } else {
            var oe = u.error.message;
            throw new Error(oe);
        }
    });
    var c = function(d) {
        var u = (0, $3439691a546f172a$var$Ie.generateUniqueNumber)(o);
        o.set(u, {
            timerId: d,
            timerType: "interval"
        }), r.set(d, u), n.postMessage({
            id: u,
            method: "clear",
            params: {
                timerId: d,
                timerType: "interval"
            }
        });
    }, s = function(d) {
        var u = (0, $3439691a546f172a$var$Ie.generateUniqueNumber)(o);
        o.set(u, {
            timerId: d,
            timerType: "timeout"
        }), t.set(d, u), n.postMessage({
            id: u,
            method: "clear",
            params: {
                timerId: d,
                timerType: "timeout"
            }
        });
    }, a = function(d, u) {
        var _ = (0, $3439691a546f172a$var$Ie.generateUniqueNumber)(r);
        return r.set(_, function() {
            d(), typeof r.get(_) == "function" && n.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: u,
                    now: performance.now(),
                    timerId: _,
                    timerType: "interval"
                }
            });
        }), n.postMessage({
            id: null,
            method: "set",
            params: {
                delay: u,
                now: performance.now(),
                timerId: _,
                timerType: "interval"
            }
        }), _;
    }, l = function(d, u) {
        var _ = (0, $3439691a546f172a$var$Ie.generateUniqueNumber)(t);
        return t.set(_, d), n.postMessage({
            id: null,
            method: "set",
            params: {
                delay: u,
                now: performance.now(),
                timerId: _,
                timerType: "timeout"
            }
        }), _;
    };
    return {
        clearInterval: c,
        clearTimeout: s,
        setInterval: a,
        setTimeout: l
    };
};
var $3439691a546f172a$var$Gt = function(e, r) {
    var t = null;
    return function() {
        if (t !== null) return t;
        var o = new Blob([
            r
        ], {
            type: "application/javascript; charset=utf-8"
        }), n = URL.createObjectURL(o);
        return t = e(n), setTimeout(function() {
            return URL.revokeObjectURL(n);
        }), t;
    };
};
var $3439691a546f172a$var$Ft = '(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error(\'There is no interval scheduled with the given id "\'.concat(t,\'".\'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error(\'The given type "\'.concat(i,\'" is not supported\'));(e=>{const r=t.get(e);if(void 0===r)throw new Error(\'There is no timeout scheduled with the given id "\'.concat(e,\'".\'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error(\'The given method "\'.concat(s.method,\'" is not supported\'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error(\'The given type "\'.concat(d,\'" is not supported\'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();';
var $3439691a546f172a$var$Be = $3439691a546f172a$var$Gt($3439691a546f172a$var$Vt, $3439691a546f172a$var$Ft), $3439691a546f172a$var$qt = function(e) {
    return $3439691a546f172a$var$Be().clearInterval(e);
}, $3439691a546f172a$var$Wt = function(e) {
    return $3439691a546f172a$var$Be().clearTimeout(e);
}, $3439691a546f172a$var$Yt = function(e, r) {
    return $3439691a546f172a$var$Be().setInterval(e, r);
}, $3439691a546f172a$var$zt = function(e, r) {
    return $3439691a546f172a$var$Be().setTimeout(e, r);
};
var $3439691a546f172a$var$M = (typeof window == "undefined" || typeof window == "undefined" ? "undefined" : $3439691a546f172a$var$Ne(window)) === "object";
var $3439691a546f172a$var$b = {
    setTimeout: $3439691a546f172a$var$M ? setTimeout.bind(window) : setTimeout,
    clearTimeout: $3439691a546f172a$var$M ? clearTimeout.bind(window) : clearTimeout,
    setInterval: $3439691a546f172a$var$M ? setInterval.bind(window) : setInterval,
    clearInterval: $3439691a546f172a$var$M ? clearInterval.bind(window) : clearInterval
}, $3439691a546f172a$export$427b263b93108fff = {
    setTimeout: $3439691a546f172a$var$zt,
    clearTimeout: $3439691a546f172a$var$Wt,
    setInterval: $3439691a546f172a$var$Yt,
    clearInterval: $3439691a546f172a$var$qt
};
function $3439691a546f172a$export$5ca7e2fccac21705() {
    $3439691a546f172a$var$b.setTimeout = setTimeout, $3439691a546f172a$var$b.clearTimeout = clearTimeout, $3439691a546f172a$var$b.setInterval = setInterval, $3439691a546f172a$var$b.clearInterval = clearInterval, $3439691a546f172a$export$427b263b93108fff.setTimeout = setTimeout, $3439691a546f172a$export$427b263b93108fff.clearTimeout = clearTimeout, $3439691a546f172a$export$427b263b93108fff.setInterval = setInterval, $3439691a546f172a$export$427b263b93108fff.clearInterval = clearInterval;
}
function $3439691a546f172a$var$Jt(e) {
    $3439691a546f172a$var$b.setTimeout = e.setTimeout, $3439691a546f172a$var$b.clearTimeout = e.clearTimeout, $3439691a546f172a$var$b.setInterval = e.setInterval, $3439691a546f172a$var$b.clearInterval = e.clearInterval;
}
var $3439691a546f172a$var$fe = {}, $3439691a546f172a$var$Pr = function() {
    "use strict";
    function e(r) {
        $3439691a546f172a$var$z(this, e), $3439691a546f172a$var$h(this, "name", void 0), $3439691a546f172a$var$h(this, "closed", !1), $3439691a546f172a$var$h(this, "mc", new MessageChannel), this.name = r, $3439691a546f172a$var$fe[r] = $3439691a546f172a$var$fe[r] || [], $3439691a546f172a$var$fe[r].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
    }
    return $3439691a546f172a$var$ce(e, [
        {
            key: "onStorage",
            value: function(t) {
                if (t.storageArea === window.localStorage && t.key.substring(0, this.name.length) === this.name && t.newValue !== null) {
                    var o = JSON.parse(t.newValue);
                    this.mc.port2.postMessage(o);
                }
            }
        },
        {
            key: "postMessage",
            value: function(t) {
                var o = this;
                if (this.closed) throw new Error("InvalidStateError");
                var n = JSON.stringify(t), c = "".concat(this.name, ":").concat(String(Date.now())).concat(String(Math.random()));
                window.localStorage.setItem(c, n), $3439691a546f172a$var$b.setTimeout(function() {
                    window.localStorage.removeItem(c);
                }, 500), $3439691a546f172a$var$fe[this.name].forEach(function(s) {
                    s !== o && s.mc.port2.postMessage(JSON.parse(n));
                });
            }
        },
        {
            key: "close",
            value: function() {
                if (!this.closed) {
                    this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
                    var t = $3439691a546f172a$var$fe[this.name].indexOf(this);
                    $3439691a546f172a$var$fe[this.name].splice(t, 1);
                }
            }
        },
        {
            key: "onmessage",
            get: function() {
                return this.mc.port1.onmessage;
            },
            set: function(t) {
                this.mc.port1.onmessage = t;
            }
        },
        {
            key: "onmessageerror",
            get: function() {
                return this.mc.port1.onmessageerror;
            },
            set: function(t) {
                this.mc.port1.onmessageerror = t;
            }
        },
        {
            key: "addEventListener",
            value: function(t, o) {
                return this.mc.port1.addEventListener(t, o);
            }
        },
        {
            key: "removeEventListener",
            value: function(t, o) {
                return this.mc.port1.removeEventListener(t, o);
            }
        },
        {
            key: "dispatchEvent",
            value: function(t) {
                return this.mc.port1.dispatchEvent(t);
            }
        }
    ]), e;
}(), $3439691a546f172a$var$Ht = typeof window == "undefined" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : $3439691a546f172a$var$Pr;
function $3439691a546f172a$var$Xt(e, r, t, o, n, c, s) {
    try {
        var a = e[c](s), l = a.value;
    } catch (d) {
        t(d);
        return;
    }
    a.done ? r(l) : Promise.resolve(l).then(o, n);
}
function $3439691a546f172a$var$$t(e) {
    return function() {
        var r = this, t = arguments;
        return new Promise(function(o, n) {
            var c = e.apply(r, t);
            function s(l) {
                $3439691a546f172a$var$Xt(c, o, n, s, a, "next", l);
            }
            function a(l) {
                $3439691a546f172a$var$Xt(c, o, n, s, a, "throw", l);
            }
            s(void 0);
        });
    };
}
function $3439691a546f172a$var$Ve(e, r) {
    var t = function(u) {
        return function(_) {
            return o([
                u,
                _
            ]);
        };
    }, o = function(u) {
        if (c) throw new TypeError("Generator is already executing.");
        for(; l && (l = 0, u[0] && (n = 0)), n;)try {
            if (c = 1, s && (a = u[0] & 2 ? s.return : u[0] ? s.throw || ((a = s.return) && a.call(s), 0) : s.next) && !(a = a.call(s, u[1])).done) return a;
            switch(s = 0, a && (u = [
                u[0] & 2,
                a.value
            ]), u[0]){
                case 0:
                case 1:
                    a = u;
                    break;
                case 4:
                    return n.label++, {
                        value: u[1],
                        done: !1
                    };
                case 5:
                    n.label++, s = u[1], u = [
                        0
                    ];
                    continue;
                case 7:
                    u = n.ops.pop(), n.trys.pop();
                    continue;
                default:
                    if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
                        n = 0;
                        continue;
                    }
                    if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
                        n.label = u[1];
                        break;
                    }
                    if (u[0] === 6 && n.label < a[1]) {
                        n.label = a[1], a = u;
                        break;
                    }
                    if (a && n.label < a[2]) {
                        n.label = a[2], n.ops.push(u);
                        break;
                    }
                    a[2] && n.ops.pop(), n.trys.pop();
                    continue;
            }
            u = r.call(e, n);
        } catch (_) {
            u = [
                6,
                _
            ], s = 0;
        } finally{
            c = a = 0;
        }
        if (u[0] & 5) throw u[1];
        return {
            value: u[0] ? u[1] : void 0,
            done: !0
        };
    }, n = {
        label: 0,
        sent: function() {
            if (a[0] & 1) throw a[1];
            return a[1];
        },
        trys: [],
        ops: []
    }, c, s, a, l;
    return l = {
        next: t(0),
        throw: t(1),
        return: t(2)
    }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
        return this;
    }), l;
}
function $3439691a546f172a$var$Kt() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Promise(function(r) {
        return $3439691a546f172a$var$b.setTimeout(r, e);
    });
}
function $3439691a546f172a$var$Ge() {
    return Math.random().toString(36).substring(2);
}
var $3439691a546f172a$var$m;
(function(e) {
    e[e.APPLY = 0] = "APPLY", e[e.TELL = 1] = "TELL", e[e.CLOSE = 2] = "CLOSE", e[e.REGISTER = 3] = "REGISTER", e[e.DEREGISTER = 4] = "DEREGISTER", e[e.IDLE = 5] = "IDLE", e[e.ACTIVE = 6] = "ACTIVE", e[e.PROMPT = 7] = "PROMPT", e[e.START = 8] = "START", e[e.RESET = 9] = "RESET", e[e.ACTIVATE = 10] = "ACTIVATE", e[e.PAUSE = 11] = "PAUSE", e[e.RESUME = 12] = "RESUME", e[e.MESSAGE = 13] = "MESSAGE";
})($3439691a546f172a$var$m || ($3439691a546f172a$var$m = {}));
var $3439691a546f172a$var$Qt = function() {
    "use strict";
    function e(r, t) {
        $3439691a546f172a$var$z(this, e), $3439691a546f172a$var$h(this, "options", void 0), $3439691a546f172a$var$h(this, "channel", void 0), $3439691a546f172a$var$h(this, "token", $3439691a546f172a$var$Ge()), $3439691a546f172a$var$h(this, "isLeader", !1), $3439691a546f172a$var$h(this, "isDead", !1), $3439691a546f172a$var$h(this, "isApplying", !1), $3439691a546f172a$var$h(this, "reApply", !1), $3439691a546f172a$var$h(this, "intervals", []), $3439691a546f172a$var$h(this, "listeners", []), $3439691a546f172a$var$h(this, "deferred", void 0), this.channel = r, this.options = t, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
    }
    return $3439691a546f172a$var$ce(e, [
        {
            key: "apply",
            value: function() {
                var t = this;
                return $3439691a546f172a$var$$t(function() {
                    var o, n, c;
                    return $3439691a546f172a$var$Ve(this, function(s) {
                        switch(s.label){
                            case 0:
                                if (t.isLeader) return [
                                    2,
                                    !1
                                ];
                                if (t.isDead) return [
                                    2,
                                    !1
                                ];
                                if (t.isApplying) return t.reApply = !0, [
                                    2,
                                    !1
                                ];
                                t.isApplying = !0, o = !1, n = function(a) {
                                    var l = a.data, d = l.token, u = l.action;
                                    d !== t.token && (u === $3439691a546f172a$var$m.APPLY && d > t.token && (o = !0), u === $3439691a546f172a$var$m.TELL && (o = !0));
                                }, t.channel.addEventListener("message", n), s.label = 1;
                            case 1:
                                return s.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), t.sendAction($3439691a546f172a$var$m.APPLY), [
                                    4,
                                    $3439691a546f172a$var$Kt(t.options.responseTime)
                                ];
                            case 2:
                                return s.sent(), t.channel.removeEventListener("message", n), t.isApplying = !1, o ? t.reApply ? [
                                    2,
                                    t.apply()
                                ] : [
                                    2,
                                    !1
                                ] : (t.assumeLead(), [
                                    2,
                                    !0
                                ]);
                            case 3:
                                return c = s.sent(), [
                                    2,
                                    !1
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "awaitLeadership",
            value: function() {
                var t = this;
                if (this.isLeader) return Promise.resolve();
                var o = !1, n = null;
                return new Promise(function(c) {
                    var s = function() {
                        if (!o) {
                            o = !0;
                            try {
                                $3439691a546f172a$var$b.clearInterval(n);
                            } catch (d) {}
                            var l = t.intervals.indexOf(n);
                            l >= 0 && t.intervals.splice(l, 1), t.channel.removeEventListener("message", a), c();
                        }
                    };
                    n = $3439691a546f172a$var$b.setInterval(function() {
                        t.apply().then(function() {
                            t.isLeader && s();
                        });
                    }, t.options.fallbackInterval), t.intervals.push(n);
                    var a = function(l) {
                        var d = l.data.action;
                        d === $3439691a546f172a$var$m.CLOSE && t.apply().then(function() {
                            t.isLeader && s();
                        });
                    };
                    t.channel.addEventListener("message", a);
                });
            }
        },
        {
            key: "sendAction",
            value: function(t) {
                this.channel.postMessage({
                    action: t,
                    token: this.token
                });
            }
        },
        {
            key: "assumeLead",
            value: function() {
                var t = this;
                this.isLeader = !0;
                var o = function(n) {
                    var c = n.data.action;
                    c === $3439691a546f172a$var$m.APPLY && t.sendAction($3439691a546f172a$var$m.TELL);
                };
                return this.channel.addEventListener("message", o), this.listeners.push(o), this.sendAction($3439691a546f172a$var$m.TELL);
            }
        },
        {
            key: "waitForLeadership",
            value: function() {
                return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
            }
        },
        {
            key: "close",
            value: function() {
                var t = this;
                if (!this.isDead) {
                    this.isDead = !0, this.isLeader = !1, this.sendAction($3439691a546f172a$var$m.CLOSE);
                    try {
                        this.listeners.forEach(function(o) {
                            return t.channel.removeEventListener("message", o);
                        }), this.intervals.forEach(function(o) {
                            return $3439691a546f172a$var$b.clearInterval(o);
                        });
                    } catch (o) {}
                }
            }
        }
    ]), e;
}();
var $3439691a546f172a$var$A;
(function(e) {
    e[e.PROMPTED = 0] = "PROMPTED", e[e.ACTIVE = 1] = "ACTIVE", e[e.IDLE = 2] = "IDLE";
})($3439691a546f172a$var$A || ($3439691a546f172a$var$A = {}));
var $3439691a546f172a$var$Zt = function() {
    "use strict";
    function e(r) {
        var t = this;
        $3439691a546f172a$var$z(this, e), $3439691a546f172a$var$h(this, "channel", void 0), $3439691a546f172a$var$h(this, "options", void 0), $3439691a546f172a$var$h(this, "elector", void 0), $3439691a546f172a$var$h(this, "token", $3439691a546f172a$var$Ge()), $3439691a546f172a$var$h(this, "registry", new Map), $3439691a546f172a$var$h(this, "allIdle", !1), $3439691a546f172a$var$h(this, "isLastActive", !1);
        var o = r.channelName;
        if (this.options = r, this.channel = new $3439691a546f172a$var$Ht(o), this.registry.set(this.token, $3439691a546f172a$var$A.ACTIVE), r.leaderElection) {
            var n = {
                fallbackInterval: 2e3,
                responseTime: 100
            };
            this.elector = new $3439691a546f172a$var$Qt(this.channel, n), this.elector.waitForLeadership();
        }
        this.channel.addEventListener("message", function(c) {
            var s = c.data, a = s.action, l = s.token, d = s.data;
            switch(a){
                case $3439691a546f172a$var$m.REGISTER:
                    t.registry.set(l, $3439691a546f172a$var$A.IDLE);
                    break;
                case $3439691a546f172a$var$m.DEREGISTER:
                    t.registry.delete(l);
                    break;
                case $3439691a546f172a$var$m.IDLE:
                    t.idle(l);
                    break;
                case $3439691a546f172a$var$m.ACTIVE:
                    t.active(l);
                    break;
                case $3439691a546f172a$var$m.PROMPT:
                    t.prompt(l);
                    break;
                case $3439691a546f172a$var$m.START:
                    t.start(l);
                    break;
                case $3439691a546f172a$var$m.RESET:
                    t.reset(l);
                    break;
                case $3439691a546f172a$var$m.ACTIVATE:
                    t.activate(l);
                    break;
                case $3439691a546f172a$var$m.PAUSE:
                    t.pause(l);
                    break;
                case $3439691a546f172a$var$m.RESUME:
                    t.resume(l);
                    break;
                case $3439691a546f172a$var$m.MESSAGE:
                    t.options.onMessage(d);
                    break;
            }
        }), this.send($3439691a546f172a$var$m.REGISTER);
    }
    return $3439691a546f172a$var$ce(e, [
        {
            key: "isLeader",
            get: function() {
                if (!this.elector) throw new Error('\u274C Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
                return this.elector.isLeader;
            }
        },
        {
            key: "prompt",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.registry.set(t, $3439691a546f172a$var$A.PROMPTED);
                var o = $3439691a546f172a$var$O(this.registry.values()).every(function(n) {
                    return n === $3439691a546f172a$var$A.PROMPTED;
                });
                t === this.token && this.send($3439691a546f172a$var$m.PROMPT), o && this.options.onPrompt();
            }
        },
        {
            key: "idle",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.registry.set(t, $3439691a546f172a$var$A.IDLE);
                var o = $3439691a546f172a$var$O(this.registry.values()).every(function(n) {
                    return n === $3439691a546f172a$var$A.IDLE;
                });
                t === this.token && this.send($3439691a546f172a$var$m.IDLE), !this.allIdle && o && (this.allIdle = !0, this.options.onIdle());
            }
        },
        {
            key: "active",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(t, $3439691a546f172a$var$A.ACTIVE);
                var o = $3439691a546f172a$var$O(this.registry.values()).some(function(n) {
                    return n === $3439691a546f172a$var$A.ACTIVE;
                });
                t === this.token && this.send($3439691a546f172a$var$m.ACTIVE), o && this.options.onActive(), this.isLastActive = t === this.token;
            }
        },
        {
            key: "start",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(t, $3439691a546f172a$var$A.ACTIVE), t === this.token ? this.send($3439691a546f172a$var$m.START) : this.options.start(!0), this.isLastActive = t === this.token;
            }
        },
        {
            key: "reset",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(t, $3439691a546f172a$var$A.ACTIVE), t === this.token ? this.send($3439691a546f172a$var$m.RESET) : this.options.reset(!0), this.isLastActive = t === this.token;
            }
        },
        {
            key: "activate",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(t, $3439691a546f172a$var$A.ACTIVE), t === this.token ? this.send($3439691a546f172a$var$m.ACTIVATE) : this.options.activate(!0), this.isLastActive = t === this.token;
            }
        },
        {
            key: "pause",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                t === this.token ? this.send($3439691a546f172a$var$m.PAUSE) : this.options.pause(!0);
            }
        },
        {
            key: "resume",
            value: function() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                t === this.token ? this.send($3439691a546f172a$var$m.RESUME) : this.options.resume(!0);
            }
        },
        {
            key: "message",
            value: function(t) {
                try {
                    this.channel.postMessage({
                        action: $3439691a546f172a$var$m.MESSAGE,
                        token: this.token,
                        data: t
                    });
                } catch (o) {}
            }
        },
        {
            key: "send",
            value: function(t) {
                try {
                    this.channel.postMessage({
                        action: t,
                        token: this.token
                    });
                } catch (o) {}
            }
        },
        {
            key: "close",
            value: function() {
                this.options.leaderElection && this.elector.close(), this.send($3439691a546f172a$var$m.DEREGISTER), this.channel.close();
            }
        }
    ]), e;
}();
var $3439691a546f172a$var$er = $3439691a546f172a$var$M ? document : null, $3439691a546f172a$export$1b94debb2480fd98 = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mousewheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
    "visibilitychange",
    "focus"
];
function $3439691a546f172a$var$tr(e, r) {
    var t = function() {
        for(var c = arguments.length, s = new Array(c), a = 0; a < c; a++)s[a] = arguments[a];
        o && clearTimeout(o), o = setTimeout(function() {
            e.apply(void 0, $3439691a546f172a$var$O(s)), o = null;
        }, r);
    }, o;
    return t.cancel = function() {
        clearTimeout(o);
    }, t;
}
function $3439691a546f172a$var$Fe(e, r) {
    var t = 0;
    return function() {
        for(var o = arguments.length, n = new Array(o), c = 0; c < o; c++)n[c] = arguments[c];
        var s = new Date().getTime();
        if (!(s - t < r)) return t = s, e.apply(void 0, $3439691a546f172a$var$O(n));
    };
}
var $3439691a546f172a$var$g = function() {
    return Date.now();
};
var $3439691a546f172a$var$le = 2147483647;
function $3439691a546f172a$export$3e1c2ef16041091f() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.timeout, t = r === void 0 ? 1200000 : r, o = e.promptTimeout, n = o === void 0 ? 0 : o, c = e.promptBeforeIdle, s = c === void 0 ? 0 : c, a = e.element, l = a === void 0 ? $3439691a546f172a$var$er : a, d = e.events, u = d === void 0 ? $3439691a546f172a$export$1b94debb2480fd98 : d, _ = e.timers, I = _ === void 0 ? void 0 : _, S = e.immediateEvents, v = S === void 0 ? [] : S, U = e.onPresenceChange, T = U === void 0 ? function() {} : U, re = e.onPrompt, X = re === void 0 ? function() {} : re, ne = e.onIdle, $ = ne === void 0 ? function() {} : ne, Oe = e.onActive, oe = Oe === void 0 ? function() {} : Oe, tt = e.onAction, Se = tt === void 0 ? function() {} : tt, rt = e.onMessage, me = rt === void 0 ? function() {} : rt, nt = e.debounce, de = nt === void 0 ? 0 : nt, ot = e.throttle, pe = ot === void 0 ? 0 : ot, it = e.eventsThrottle, We = it === void 0 ? 200 : it, at = e.startOnMount, ve = at === void 0 ? !0 : at, ut = e.startManually, V = ut === void 0 ? !1 : ut, st = e.stopOnIdle, Le = st === void 0 ? !1 : st, ct = e.crossTab, ie = ct === void 0 ? !1 : ct, ft = e.name, lt = ft === void 0 ? "idle-timer" : ft, mt = e.syncTimers, he = mt === void 0 ? 0 : mt, dt = e.leaderElection, pt = dt === void 0 ? !1 : dt, vt = e.disabled, B = vt === void 0 ? !1 : vt, ht = (0, $6uYXW.useRef)($3439691a546f172a$var$g()), Pe = (0, $6uYXW.useRef)($3439691a546f172a$var$g()), L = (0, $6uYXW.useRef)(null), C = (0, $6uYXW.useRef)(null), J = (0, $6uYXW.useRef)(0), _e = (0, $6uYXW.useRef)(0), G = (0, $6uYXW.useRef)(0), R = (0, $6uYXW.useRef)(0), y = (0, $6uYXW.useRef)(!1), E = (0, $6uYXW.useRef)(!1), F = (0, $6uYXW.useRef)(!1), q = (0, $6uYXW.useRef)(!0), ye = (0, $6uYXW.useRef)(!1), W = (0, $6uYXW.useRef)(null), f = (0, $6uYXW.useRef)(null), j = (0, $6uYXW.useRef)(t), K = (0, $6uYXW.useRef)(0);
    (0, $6uYXW.useEffect)(function() {
        if (n && console.warn("\u26A0\uFE0F IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."), s && n) throw new Error("\u274C Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");
        if (t >= $3439691a546f172a$var$le) throw new Error("\u274C The value for the timeout property must fit in a 32 bit signed integer, ".concat($3439691a546f172a$var$le, "."));
        if (n >= $3439691a546f172a$var$le) throw new Error("\u274C The value for the promptTimeout property must fit in a 32 bit signed integer, ".concat($3439691a546f172a$var$le, "."));
        if (s >= $3439691a546f172a$var$le) throw new Error("\u274C The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ".concat($3439691a546f172a$var$le, "."));
        if (s >= t) throw new Error("\u274C The value for the promptBeforeIdle property must be less than the timeout property, ".concat(t, "."));
        if (s ? (j.current = t - s, K.current = s) : (j.current = t, K.current = n), !q.current) {
            if (V || B) return;
            y.current && (ae.current(null, k), f.current && f.current.active()), te();
        }
    }, [
        t,
        n,
        s,
        V,
        B
    ]);
    var _t = (0, $6uYXW.useRef)(Le);
    (0, $6uYXW.useEffect)(function() {
        _t.current = Le;
    }, [
        Le
    ]);
    var yt = (0, $6uYXW.useRef)(v), ge = (0, $6uYXW.useRef)(l), Ye = (0, $6uYXW.useRef)($3439691a546f172a$var$O(new Set($3439691a546f172a$var$O(u).concat($3439691a546f172a$var$O(v))).values())), D = (0, $6uYXW.useRef)(B);
    (0, $6uYXW.useEffect)(function() {
        D.current = B, !q.current && (B ? Ce() : V || te());
    }, [
        B
    ]);
    var we = (0, $6uYXW.useRef)(T);
    (0, $6uYXW.useEffect)(function() {
        we.current = T;
    }, [
        T
    ]);
    var ke = (0, $6uYXW.useRef)(X);
    (0, $6uYXW.useEffect)(function() {
        ke.current = X;
    }, [
        X
    ]);
    var Ae = (0, $6uYXW.useRef)($);
    (0, $6uYXW.useEffect)(function() {
        Ae.current = $;
    }, [
        $
    ]);
    var ae = (0, $6uYXW.useRef)(oe);
    (0, $6uYXW.useEffect)(function() {
        ae.current = oe;
    }, [
        oe
    ]);
    var Re = (0, $6uYXW.useRef)(Se);
    (0, $6uYXW.useEffect)(function() {
        Re.current = Se;
    }, [
        Se
    ]);
    var ue = (0, $6uYXW.useRef)(me);
    (0, $6uYXW.useEffect)(function() {
        ue.current = me;
    }, [
        me
    ]);
    var Q = (0, $6uYXW.useMemo)(function() {
        var i = function(P, se) {
            return Re.current(P, se);
        };
        return de > 0 ? $3439691a546f172a$var$tr(i, de) : pe > 0 ? $3439691a546f172a$var$Fe(i, pe) : i;
    }, [
        pe,
        de
    ]), gt = (0, $6uYXW.useRef)();
    (0, $6uYXW.useEffect)(function() {
        ie && he && (gt.current = $3439691a546f172a$var$Fe(function() {
            f.current.active();
        }, he));
    }, [
        ie,
        he
    ]);
    var N = function() {
        W.current !== null && ($3439691a546f172a$var$b.clearTimeout(W.current), W.current = null);
    }, Z = function(i) {
        var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
        N(), W.current = $3439691a546f172a$var$b.setTimeout(Je, i || j.current), P && (C.current = $3439691a546f172a$var$g());
    }, wt = function(i) {
        !E.current && !y.current && (ke.current(i, k), we.current({
            type: "active",
            prompted: !0
        }, k)), R.current = 0, G.current = $3439691a546f172a$var$g(), E.current = !0, Z(K.current, !1);
    }, bt = function() {
        N(), y.current || (Ae.current(null, k), we.current({
            type: "idle"
        }, k)), y.current = !0, L.current = $3439691a546f172a$var$g(), _t.current ? ee() : E.current && (G.current = 0, E.current = !1);
    }, ze = function(i) {
        N(), (y.current || E.current) && (ae.current(i, k), we.current({
            type: "active",
            prompted: !1
        }, k)), E.current = !1, G.current = 0, y.current = !1, J.current += $3439691a546f172a$var$g() - L.current, _e.current += $3439691a546f172a$var$g() - L.current, H(), Z();
    }, Je = function(i) {
        var P = !y.current;
        if (P) {
            Q.cancel && Q.cancel();
            var se = $3439691a546f172a$var$g() - C.current, mr = j.current + K.current < se;
            if (!mr && K.current > 0 && !E.current) {
                f.current ? f.current.prompt() : wt(i);
                return;
            }
            f.current ? f.current.idle() : bt();
            return;
        }
        f.current ? f.current.active() : ze(i);
    }, He = function(i) {
        if (!ve && !C.current && (C.current = $3439691a546f172a$var$g(), ae.current(null, k)), Q(i, k), !E.current) {
            if (N(), !y.current && yt.current.includes(i.type)) {
                Je(i);
                return;
            }
            var P = $3439691a546f172a$var$g() - C.current;
            if (y.current && !Le || !y.current && P >= j.current) {
                Je(i);
                return;
            }
            F.current = !1, R.current = 0, G.current = 0, Z(), ie && he && gt.current();
        }
    }, Me = (0, $6uYXW.useRef)(He);
    (0, $6uYXW.useEffect)(function() {
        var i = ye.current;
        i && ee(), We > 0 ? Me.current = $3439691a546f172a$var$Fe(He, We) : Me.current = He, i && H();
    }, [
        We,
        pe,
        de,
        Re,
        ie,
        he
    ]);
    var H = function() {
        $3439691a546f172a$var$M && ge.current && (ye.current || (Ye.current.forEach(function(i) {
            ge.current.addEventListener(i, Me.current, {
                capture: !0,
                passive: !0
            });
        }), ye.current = !0));
    }, ee = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
        $3439691a546f172a$var$M && ge.current && (ye.current || i) && (Ye.current.forEach(function(P) {
            ge.current.removeEventListener(P, Me.current, {
                capture: !0
            });
        }), ye.current = !1);
    }, te = (0, $6uYXW.useCallback)(function(i) {
        return D.current ? !1 : (N(), H(), y.current = !1, E.current = !1, F.current = !1, R.current = 0, G.current = 0, f.current && !i && f.current.start(), Z(), !0);
    }, [
        W,
        y,
        D,
        j,
        f
    ]), Xe = (0, $6uYXW.useCallback)(function(i) {
        return D.current ? !1 : (N(), H(), Pe.current = $3439691a546f172a$var$g(), J.current += $3439691a546f172a$var$g() - L.current, _e.current += $3439691a546f172a$var$g() - L.current, J.current = 0, y.current = !1, E.current = !1, F.current = !1, R.current = 0, G.current = 0, f.current && !i && f.current.reset(), V || Z(), !0);
    }, [
        W,
        y,
        j,
        V,
        D,
        f
    ]), Tt = (0, $6uYXW.useCallback)(function(i) {
        return D.current ? !1 : (N(), H(), (y.current || E.current) && ze(), y.current = !1, E.current = !1, F.current = !1, R.current = 0, G.current = 0, Pe.current = $3439691a546f172a$var$g(), f.current && !i && f.current.activate(), Z(), !0);
    }, [
        W,
        y,
        E,
        D,
        j,
        f
    ]), Ce = (0, $6uYXW.useCallback)(function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
        return D.current || F.current ? !1 : (R.current = Et(), F.current = !0, ee(), N(), f.current && !i && f.current.pause(), !0);
    }, [
        W,
        D,
        f
    ]), $e = (0, $6uYXW.useCallback)(function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
        return D.current || !F.current ? !1 : (F.current = !1, E.current || H(), y.current || Z(R.current), G.current && (G.current = $3439691a546f172a$var$g()), f.current && !i && f.current.resume(), !0);
    }, [
        W,
        j,
        D,
        R,
        f
    ]), rr = (0, $6uYXW.useCallback)(function(i, P) {
        return f.current ? (P && ue.current(i, k), f.current.message(i)) : P && ue.current(i, k), !0;
    }, [
        me
    ]), nr = (0, $6uYXW.useCallback)(function() {
        return y.current;
    }, [
        y
    ]), or = (0, $6uYXW.useCallback)(function() {
        return E.current;
    }, [
        E
    ]), ir = (0, $6uYXW.useCallback)(function() {
        return f.current ? f.current.isLeader : null;
    }, [
        f
    ]), ar = (0, $6uYXW.useCallback)(function() {
        return f.current ? f.current.isLastActive : null;
    }, [
        f
    ]), ur = (0, $6uYXW.useCallback)(function() {
        return f.current ? f.current.token : null;
    }, [
        f
    ]), Et = (0, $6uYXW.useCallback)(function() {
        if (F.current) return R.current;
        var i = R.current ? R.current : K.current + j.current, P = C.current ? $3439691a546f172a$var$g() - C.current : 0, se = Math.floor(i - P);
        return se < 0 ? 0 : Math.abs(se);
    }, [
        j,
        K,
        E,
        R,
        C
    ]), It = (0, $6uYXW.useCallback)(function() {
        return Math.round($3439691a546f172a$var$g() - Pe.current);
    }, [
        Pe
    ]), xt = (0, $6uYXW.useCallback)(function() {
        return Math.round($3439691a546f172a$var$g() - ht.current);
    }, [
        ht
    ]), sr = (0, $6uYXW.useCallback)(function() {
        return L.current ? new Date(L.current) : null;
    }, [
        L
    ]), cr = (0, $6uYXW.useCallback)(function() {
        return C.current ? new Date(C.current) : null;
    }, [
        C
    ]), Ot = (0, $6uYXW.useCallback)(function() {
        return y.current ? Math.round($3439691a546f172a$var$g() - L.current + J.current) : Math.round(J.current);
    }, [
        L,
        J
    ]), St = (0, $6uYXW.useCallback)(function() {
        return y.current ? Math.round($3439691a546f172a$var$g() - L.current + _e.current) : Math.round(_e.current);
    }, [
        L,
        _e
    ]), fr = (0, $6uYXW.useCallback)(function() {
        var i = Math.round(It() - Ot());
        return i >= 0 ? i : 0;
    }, [
        L,
        J
    ]), lr = (0, $6uYXW.useCallback)(function() {
        var i = Math.round(xt() - St());
        return i >= 0 ? i : 0;
    }, [
        L,
        J
    ]);
    (0, $6uYXW.useEffect)(function() {
        if (de > 0 && pe > 0) throw new Error("\u274C onAction can either be throttled or debounced, not both.");
        I && $3439691a546f172a$var$Jt(I);
        var i = function() {
            f.current && f.current.close(), Q.cancel && Q.cancel(), N(), ee(!0);
        };
        return $3439691a546f172a$var$M && window.addEventListener("beforeunload", i), function() {
            $3439691a546f172a$var$M && window.removeEventListener("beforeunload", i), f.current && f.current.close(), Q.cancel && Q.cancel(), N(), ee(!0);
        };
    }, []), (0, $6uYXW.useEffect)(function() {
        f.current && f.current.close(), ie ? f.current = new $3439691a546f172a$var$Zt({
            channelName: lt,
            leaderElection: pt,
            onPrompt: function() {
                wt();
            },
            onIdle: function() {
                bt();
            },
            onActive: function() {
                ze();
            },
            onMessage: function(i) {
                ue.current(i, k);
            },
            start: te,
            reset: Xe,
            activate: Tt,
            pause: Ce,
            resume: $e
        }) : f.current = null;
    }, [
        ie,
        lt,
        pt,
        ke,
        Ae,
        ae,
        ue,
        te,
        Xe,
        Ce,
        $e
    ]), (0, $6uYXW.useEffect)(function() {
        q.current || (N(), ee(!0)), !(V || B) && (ve ? te() : H());
    }, [
        V,
        ve,
        B,
        q
    ]), (0, $6uYXW.useEffect)(function() {
        if (!q.current) {
            var i = $3439691a546f172a$var$O(new Set($3439691a546f172a$var$O(u).concat($3439691a546f172a$var$O(v))).values());
            if (ee(), Ye.current = i, ge.current = l, yt.current = v, V || B) return;
            ve ? te() : H();
        }
    }, [
        l,
        JSON.stringify(u),
        JSON.stringify(v),
        q,
        B,
        V,
        ve
    ]), (0, $6uYXW.useEffect)(function() {
        q.current && (q.current = !1);
    }, [
        q
    ]);
    var k = {
        message: rr,
        start: te,
        reset: Xe,
        activate: Tt,
        pause: Ce,
        resume: $e,
        isIdle: nr,
        isPrompted: or,
        isLeader: ir,
        isLastActiveTab: ar,
        getTabId: ur,
        getRemainingTime: Et,
        getElapsedTime: It,
        getTotalElapsedTime: xt,
        getLastIdleTime: sr,
        getLastActiveTime: cr,
        getIdleTime: Ot,
        getTotalIdleTime: St,
        getActiveTime: fr,
        getTotalActiveTime: lr,
        setOnPresenceChange: function(i) {
            T = i, we.current = i;
        },
        setOnPrompt: function(i) {
            X = i, ke.current = i;
        },
        setOnIdle: function(i) {
            $ = i, Ae.current = i;
        },
        setOnActive: function(i) {
            oe = i, ae.current = i;
        },
        setOnAction: function(i) {
            Se = i, Re.current = i;
        },
        setOnMessage: function(i) {
            me = i, ue.current = i;
        }
    };
    return k;
}
var $3439691a546f172a$export$e28ea38f1e83b132 = (0, $6uYXW.createContext)(null);
function $3439691a546f172a$export$17ce2adb9f89ccf5(e) {
    var r = $3439691a546f172a$export$3e1c2ef16041091f(e);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($3439691a546f172a$export$e28ea38f1e83b132.Provider, {
        value: r
    }, e.children);
}
var $3439691a546f172a$export$ee38aa87a63cd016 = $3439691a546f172a$export$e28ea38f1e83b132.Consumer;
function $3439691a546f172a$export$1f7d3dee7d83ab6e() {
    return (0, $6uYXW.useContext)($3439691a546f172a$export$e28ea38f1e83b132);
}

});

parcelRegister("b8ojz", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $81b34d72c503e486$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $81b34d72c503e486$export$a6c7ac8248d6e38a; });

var $NQIVp = parcelRequire("NQIVp");

var $cF9P7 = parcelRequire("cF9P7");

var $6uYXW = parcelRequire("6uYXW");

var $kJalM = parcelRequire("kJalM");



var $jqghu = parcelRequire("jqghu");

var $akkJo = parcelRequire("akkJo");

var $7mrST = parcelRequire("7mrST");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $81b34d72c503e486$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $kJalM.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $NQIVp.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $81b34d72c503e486$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $kJalM.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $NQIVp.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
var $81b34d72c503e486$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $81b34d72c503e486$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $kJalM.createLocation)(to, null, null, currentLocation) : to;
};
var $81b34d72c503e486$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $81b34d72c503e486$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).forwardRef;
if (typeof $81b34d72c503e486$var$forwardRef === "undefined") $81b34d72c503e486$var$forwardRef = $81b34d72c503e486$var$forwardRefShim;
function $81b34d72c503e486$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $81b34d72c503e486$var$LinkAnchor = $81b34d72c503e486$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $akkJo.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $jqghu.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$81b34d72c503e486$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($81b34d72c503e486$var$forwardRefShim !== $81b34d72c503e486$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $81b34d72c503e486$export$a6c7ac8248d6e38a = $81b34d72c503e486$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $81b34d72c503e486$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $akkJo.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $NQIVp.__RouterContext).Consumer, null, function(context) {
        !context && (0, $7mrST.default)(false);
        var history = context.history;
        var location = $81b34d72c503e486$var$normalizeToLocation($81b34d72c503e486$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $jqghu.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $81b34d72c503e486$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $kJalM.createPath)(context.location) === (0, $kJalM.createPath)($81b34d72c503e486$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($81b34d72c503e486$var$forwardRefShim !== $81b34d72c503e486$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(component, props);
    });
});
var $81b34d72c503e486$var$toType, $81b34d72c503e486$var$refType;
var $81b34d72c503e486$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $81b34d72c503e486$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).forwardRef;
if (typeof $81b34d72c503e486$var$forwardRef$1 === "undefined") $81b34d72c503e486$var$forwardRef$1 = $81b34d72c503e486$var$forwardRefShim$1;
function $81b34d72c503e486$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $81b34d72c503e486$export$b0d92dbee9b5b60d = $81b34d72c503e486$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $akkJo.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $NQIVp.__RouterContext).Consumer, null, function(context) {
        !context && (0, $7mrST.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $81b34d72c503e486$var$normalizeToLocation($81b34d72c503e486$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $NQIVp.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $81b34d72c503e486$var$joinClassnames(className, activeClassName);
            style = (0, $jqghu.default)({}, style, activeStyle);
        }
        var props = (0, $jqghu.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($81b34d72c503e486$var$forwardRefShim$1 !== $81b34d72c503e486$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($81b34d72c503e486$export$a6c7ac8248d6e38a, props);
    });
});
var $81b34d72c503e486$var$ariaCurrentType;

});
parcelRegister("NQIVp", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $095d798686d8c4cf$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $095d798686d8c4cf$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Redirect", function () { return $095d798686d8c4cf$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "matchPath", function () { return $095d798686d8c4cf$export$81336c211d5ff295; });
$parcel$export(module.exports, "Route", function () { return $095d798686d8c4cf$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Switch", function () { return $095d798686d8c4cf$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "useHistory", function () { return $095d798686d8c4cf$export$3420e1dc2c4a518c; });
$parcel$export(module.exports, "useLocation", function () { return $095d798686d8c4cf$export$45d76561a5302f2b; });

var $cF9P7 = parcelRequire("cF9P7");

var $6uYXW = parcelRequire("6uYXW");


var $kJalM = parcelRequire("kJalM");


var $huyGK = parcelRequire("huyGK");

var $7mrST = parcelRequire("7mrST");

var $jqghu = parcelRequire("jqghu");

var $urEcI = parcelRequire("urEcI");
parcelRequire("3jwoA");

var $akkJo = parcelRequire("akkJo");

var $9HO5c = parcelRequire("9HO5c");
// TODO: Replace with React.createContext once we can assume React 16+
var $095d798686d8c4cf$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $huyGK.default)();
    context.displayName = name;
    return context;
};
var $095d798686d8c4cf$export$c213558b66925821 = /*#__PURE__*/ $095d798686d8c4cf$var$createNamedContext("Router-History");
var $095d798686d8c4cf$export$63baa8ccbe60bb07 = /*#__PURE__*/ $095d798686d8c4cf$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $095d798686d8c4cf$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $095d798686d8c4cf$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $kJalM.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
var $095d798686d8c4cf$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $095d798686d8c4cf$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $7mrST.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $095d798686d8c4cf$var$messageType;
var $095d798686d8c4cf$var$cache = {};
var $095d798686d8c4cf$var$cacheLimit = 10000;
var $095d798686d8c4cf$var$cacheCount = 0;
function $095d798686d8c4cf$var$compilePath(path) {
    if ($095d798686d8c4cf$var$cache[path]) return $095d798686d8c4cf$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($urEcI))).compile(path);
    if ($095d798686d8c4cf$var$cacheCount < $095d798686d8c4cf$var$cacheLimit) {
        $095d798686d8c4cf$var$cache[path] = generator;
        $095d798686d8c4cf$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $095d798686d8c4cf$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $095d798686d8c4cf$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $095d798686d8c4cf$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $7mrST.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $kJalM.createLocation)(computedMatch ? typeof to === "string" ? $095d798686d8c4cf$export$82476f982757e71e(to, computedMatch.params) : (0, $jqghu.default)({}, to, {
            pathname: $095d798686d8c4cf$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $kJalM.createLocation)(prevProps.to);
                if (!(0, $kJalM.locationsAreEqual)(prevLocation, (0, $jqghu.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $095d798686d8c4cf$var$cache$1 = {};
var $095d798686d8c4cf$var$cacheLimit$1 = 10000;
var $095d798686d8c4cf$var$cacheCount$1 = 0;
function $095d798686d8c4cf$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $095d798686d8c4cf$var$cache$1[cacheKey] || ($095d798686d8c4cf$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($urEcI)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($095d798686d8c4cf$var$cacheCount$1 < $095d798686d8c4cf$var$cacheLimit$1) {
        pathCache[path] = result;
        $095d798686d8c4cf$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $095d798686d8c4cf$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $095d798686d8c4cf$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $095d798686d8c4cf$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Children.count(children) === 0;
}
function $095d798686d8c4cf$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $095d798686d8c4cf$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $7mrST.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $095d798686d8c4cf$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $jqghu.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $095d798686d8c4cf$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
function $095d798686d8c4cf$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $095d798686d8c4cf$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $jqghu.default)({}, location, {
        pathname: $095d798686d8c4cf$var$addLeadingSlash(basename) + location.pathname
    });
}
function $095d798686d8c4cf$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $095d798686d8c4cf$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $jqghu.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $095d798686d8c4cf$var$createURL(location) {
    return typeof location === "string" ? location : (0, $kJalM.createPath)(location);
}
function $095d798686d8c4cf$var$staticHandler(methodName) {
    return function() {
        (0, $7mrST.default)(false);
    };
}
function $095d798686d8c4cf$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $095d798686d8c4cf$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $095d798686d8c4cf$var$noop;
        };
        _this.handleBlock = function() {
            return $095d798686d8c4cf$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $095d798686d8c4cf$var$addBasename(basename, (0, $kJalM.createLocation)(location));
        context.url = $095d798686d8c4cf$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $akkJo.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $095d798686d8c4cf$var$addLeadingSlash(basename + $095d798686d8c4cf$var$createURL(path));
            },
            action: "POP",
            location: $095d798686d8c4cf$var$stripBasename(basename, (0, $kJalM.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $095d798686d8c4cf$var$staticHandler("go"),
            goBack: $095d798686d8c4cf$var$staticHandler("goBack"),
            goForward: $095d798686d8c4cf$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$55185c17a0fcbe46, (0, $jqghu.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $095d798686d8c4cf$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $cF9P7.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $7mrST.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $095d798686d8c4cf$export$81336c211d5ff295(location.pathname, (0, $jqghu.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $095d798686d8c4cf$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $akkJo.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($095d798686d8c4cf$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $7mrST.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Component, (0, $jqghu.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9HO5c)))(C, Component);
}
var $095d798686d8c4cf$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useContext;
function $095d798686d8c4cf$export$3420e1dc2c4a518c() {
    return $095d798686d8c4cf$var$useContext($095d798686d8c4cf$export$c213558b66925821);
}
function $095d798686d8c4cf$export$45d76561a5302f2b() {
    return $095d798686d8c4cf$var$useContext($095d798686d8c4cf$export$63baa8ccbe60bb07).location;
}
function $095d798686d8c4cf$export$99eaa27ddbbb95ef() {
    var match = $095d798686d8c4cf$var$useContext($095d798686d8c4cf$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $095d798686d8c4cf$export$632be4bb944c1bc7(path) {
    var location = $095d798686d8c4cf$export$45d76561a5302f2b();
    var match = $095d798686d8c4cf$var$useContext($095d798686d8c4cf$export$63baa8ccbe60bb07).match;
    return path ? $095d798686d8c4cf$export$81336c211d5ff295(location.pathname, path) : match;
}
var $095d798686d8c4cf$var$global, $095d798686d8c4cf$var$key, $095d798686d8c4cf$var$buildNames, $095d798686d8c4cf$var$initialBuildName, $095d798686d8c4cf$var$secondaryBuildName;

});
parcelRegister("cF9P7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9380ef1ca0dd6549$export$2e2bcd8739ae039; });

var $9om4f = parcelRequire("9om4f");
function $9380ef1ca0dd6549$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $9om4f.default)(t, o);
}

});
parcelRegister("9om4f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d677919a43528b5$export$2e2bcd8739ae039; });
function $6d677919a43528b5$export$2e2bcd8739ae039(t, e) {
    return $6d677919a43528b5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6d677919a43528b5$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("kJalM", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $f17009f60f793bb3$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $f17009f60f793bb3$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $f17009f60f793bb3$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $f17009f60f793bb3$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $f17009f60f793bb3$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $f17009f60f793bb3$export$2b76ad033c6e6d08; });

var $jqghu = parcelRequire("jqghu");

var $lK8rm = parcelRequire("lK8rm");

var $2XiIm = parcelRequire("2XiIm");


var $7mrST = parcelRequire("7mrST");
function $f17009f60f793bb3$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $f17009f60f793bb3$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $f17009f60f793bb3$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $f17009f60f793bb3$var$stripBasename(path, prefix) {
    return $f17009f60f793bb3$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $f17009f60f793bb3$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $f17009f60f793bb3$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $f17009f60f793bb3$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $f17009f60f793bb3$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $f17009f60f793bb3$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $jqghu.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $lK8rm.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $f17009f60f793bb3$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $2XiIm.default)(a.state, b.state);
}
function $f17009f60f793bb3$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $f17009f60f793bb3$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $f17009f60f793bb3$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $f17009f60f793bb3$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $f17009f60f793bb3$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $f17009f60f793bb3$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $f17009f60f793bb3$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $f17009f60f793bb3$var$PopStateEvent = 'popstate';
var $f17009f60f793bb3$var$HashChangeEvent = 'hashchange';
function $f17009f60f793bb3$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $f17009f60f793bb3$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$f17009f60f793bb3$var$canUseDOM && (0, $7mrST.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $f17009f60f793bb3$var$supportsHistory();
    var needsHashChangeListener = !$f17009f60f793bb3$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $f17009f60f793bb3$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $f17009f60f793bb3$var$stripTrailingSlash($f17009f60f793bb3$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $f17009f60f793bb3$var$stripBasename(path, basename);
        return $f17009f60f793bb3$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $f17009f60f793bb3$var$createTransitionManager();
    function setState(nextState) {
        (0, $jqghu.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($f17009f60f793bb3$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($f17009f60f793bb3$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($f17009f60f793bb3$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $f17009f60f793bb3$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $f17009f60f793bb3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $f17009f60f793bb3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($f17009f60f793bb3$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($f17009f60f793bb3$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($f17009f60f793bb3$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($f17009f60f793bb3$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $f17009f60f793bb3$var$HashChangeEvent$1 = 'hashchange';
var $f17009f60f793bb3$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $f17009f60f793bb3$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $f17009f60f793bb3$var$stripLeadingSlash,
        decodePath: $f17009f60f793bb3$var$addLeadingSlash
    },
    slash: {
        encodePath: $f17009f60f793bb3$var$addLeadingSlash,
        decodePath: $f17009f60f793bb3$var$addLeadingSlash
    }
};
function $f17009f60f793bb3$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $f17009f60f793bb3$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $f17009f60f793bb3$var$pushHashPath(path) {
    window.location.hash = path;
}
function $f17009f60f793bb3$var$replaceHashPath(path) {
    window.location.replace($f17009f60f793bb3$var$stripHash(window.location.href) + '#' + path);
}
function $f17009f60f793bb3$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$f17009f60f793bb3$var$canUseDOM && (0, $7mrST.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $f17009f60f793bb3$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $f17009f60f793bb3$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $f17009f60f793bb3$var$stripTrailingSlash($f17009f60f793bb3$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $f17009f60f793bb3$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($f17009f60f793bb3$var$getHashPath());
        if (basename) path = $f17009f60f793bb3$var$stripBasename(path, basename);
        return $f17009f60f793bb3$export$90c043f1c57770b8(path);
    }
    var transitionManager = $f17009f60f793bb3$var$createTransitionManager();
    function setState(nextState) {
        (0, $jqghu.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $f17009f60f793bb3$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $f17009f60f793bb3$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $f17009f60f793bb3$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($f17009f60f793bb3$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($f17009f60f793bb3$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $f17009f60f793bb3$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $f17009f60f793bb3$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $f17009f60f793bb3$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $f17009f60f793bb3$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $f17009f60f793bb3$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $f17009f60f793bb3$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $f17009f60f793bb3$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $f17009f60f793bb3$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $f17009f60f793bb3$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($f17009f60f793bb3$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $f17009f60f793bb3$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $f17009f60f793bb3$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $f17009f60f793bb3$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $f17009f60f793bb3$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($f17009f60f793bb3$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($f17009f60f793bb3$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($f17009f60f793bb3$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $f17009f60f793bb3$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $f17009f60f793bb3$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $f17009f60f793bb3$var$createTransitionManager();
    function setState(nextState) {
        (0, $jqghu.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $f17009f60f793bb3$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $f17009f60f793bb3$export$90c043f1c57770b8(entry, undefined, createKey()) : $f17009f60f793bb3$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $f17009f60f793bb3$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $f17009f60f793bb3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $f17009f60f793bb3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $f17009f60f793bb3$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("jqghu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e23d1322b831a5ae$export$2e2bcd8739ae039; });
function $e23d1322b831a5ae$export$2e2bcd8739ae039() {
    return $e23d1322b831a5ae$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e23d1322b831a5ae$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("lK8rm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd4470ef8092ce79$export$2e2bcd8739ae039; });
function $fd4470ef8092ce79$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $fd4470ef8092ce79$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $fd4470ef8092ce79$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $fd4470ef8092ce79$var$isAbsolute(to);
    var isFromAbs = from && $fd4470ef8092ce79$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $fd4470ef8092ce79$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $fd4470ef8092ce79$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $fd4470ef8092ce79$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $fd4470ef8092ce79$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$fd4470ef8092ce79$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $fd4470ef8092ce79$export$2e2bcd8739ae039 = $fd4470ef8092ce79$var$resolvePathname;

});

parcelRegister("2XiIm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $226f9bc14034b232$export$2e2bcd8739ae039; });
function $226f9bc14034b232$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $226f9bc14034b232$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $226f9bc14034b232$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $226f9bc14034b232$var$valueOf(a);
        var bValue = $226f9bc14034b232$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $226f9bc14034b232$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $226f9bc14034b232$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $226f9bc14034b232$export$2e2bcd8739ae039 = $226f9bc14034b232$var$valueEqual;

});

parcelRegister("7mrST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55c037c0efd0c0c1$export$2e2bcd8739ae039; });
var $55c037c0efd0c0c1$var$isProduction = true;
var $55c037c0efd0c0c1$var$prefix = 'Invariant failed';
function $55c037c0efd0c0c1$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($55c037c0efd0c0c1$var$isProduction) throw new Error($55c037c0efd0c0c1$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($55c037c0efd0c0c1$var$prefix, ": ").concat(provided) : $55c037c0efd0c0c1$var$prefix;
    throw new Error(value);
}

});


parcelRegister("huyGK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbc02571fe0dcb08$export$2e2bcd8739ae039; });

var $6uYXW = parcelRequire("6uYXW");

var $cF9P7 = parcelRequire("cF9P7");

var $k8j0a = parcelRequire("k8j0a");

var $cbc02571fe0dcb08$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $cbc02571fe0dcb08$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
function $cbc02571fe0dcb08$var$getUniqueId() {
    var key = '__global_unique_id__';
    return $cbc02571fe0dcb08$var$commonjsGlobal[key] = ($cbc02571fe0dcb08$var$commonjsGlobal[key] || 0) + 1;
}
function $cbc02571fe0dcb08$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $cbc02571fe0dcb08$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $cbc02571fe0dcb08$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $cbc02571fe0dcb08$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $cbc02571fe0dcb08$var$getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $cF9P7.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $cbc02571fe0dcb08$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($cbc02571fe0dcb08$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $cbc02571fe0dcb08$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $6uYXW.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $cF9P7.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $cbc02571fe0dcb08$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $cbc02571fe0dcb08$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $cbc02571fe0dcb08$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $6uYXW.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $cbc02571fe0dcb08$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createContext || $cbc02571fe0dcb08$var$createReactContext;
var $cbc02571fe0dcb08$export$2e2bcd8739ae039 = $cbc02571fe0dcb08$var$index;

});
parcelRegister("k8j0a", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea834b5e286ecd0d$var$ReactIs, $ea834b5e286ecd0d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("eaGJn"))();

});
parcelRegister("eaGJn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2Wl5L = parcelRequire("2Wl5L");
function $a51325578fa3d364$var$emptyFunction() {}
function $a51325578fa3d364$var$emptyFunctionWithReset() {}
$a51325578fa3d364$var$emptyFunctionWithReset.resetWarningCache = $a51325578fa3d364$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2Wl5L) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a51325578fa3d364$var$emptyFunctionWithReset,
        resetWarningCache: $a51325578fa3d364$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2Wl5L", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $22415bfad1d389c6$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $22415bfad1d389c6$var$ReactPropTypesSecret;

});




parcelRegister("urEcI", function(module, exports) {

var $3Qo3O = parcelRequire("3Qo3O");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $05b83faa3324d32e$var$pathToRegexp;
module.exports.parse = $05b83faa3324d32e$var$parse;
module.exports.compile = $05b83faa3324d32e$var$compile;
module.exports.tokensToFunction = $05b83faa3324d32e$var$tokensToFunction;
module.exports.tokensToRegExp = $05b83faa3324d32e$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $05b83faa3324d32e$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $05b83faa3324d32e$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $05b83faa3324d32e$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $05b83faa3324d32e$var$escapeGroup(pattern) : asterisk ? '.*' : $05b83faa3324d32e$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $05b83faa3324d32e$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $05b83faa3324d32e$var$escapeString(delimiter) + ']+?';
    return $05b83faa3324d32e$var$escapeString(prevText) + '|(?:(?!' + $05b83faa3324d32e$var$escapeString(prevText) + ')[^' + $05b83faa3324d32e$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $05b83faa3324d32e$var$compile(str, options) {
    return $05b83faa3324d32e$var$tokensToFunction($05b83faa3324d32e$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $05b83faa3324d32e$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $05b83faa3324d32e$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $05b83faa3324d32e$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $05b83faa3324d32e$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $05b83faa3324d32e$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($3Qo3O(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $05b83faa3324d32e$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $05b83faa3324d32e$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $05b83faa3324d32e$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $05b83faa3324d32e$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $05b83faa3324d32e$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $05b83faa3324d32e$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $05b83faa3324d32e$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $05b83faa3324d32e$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($05b83faa3324d32e$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $05b83faa3324d32e$var$flags(options));
    return $05b83faa3324d32e$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $05b83faa3324d32e$var$stringToRegexp(path, keys, options) {
    return $05b83faa3324d32e$var$tokensToRegExp($05b83faa3324d32e$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $05b83faa3324d32e$var$tokensToRegExp(tokens, keys, options) {
    if (!$3Qo3O(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $05b83faa3324d32e$var$escapeString(token);
        else {
            var prefix = $05b83faa3324d32e$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $05b83faa3324d32e$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $05b83faa3324d32e$var$attachKeys(new RegExp('^' + route, $05b83faa3324d32e$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $05b83faa3324d32e$var$pathToRegexp(path, keys, options) {
    if (!$3Qo3O(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $05b83faa3324d32e$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($3Qo3O(path)) return $05b83faa3324d32e$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $05b83faa3324d32e$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("3Qo3O", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


parcelRegister("3jwoA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aiFZX"));

});
parcelRegister("aiFZX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $77fc29d578dd0acd$export$2b8d127b894957b9; }, function (v) { return $77fc29d578dd0acd$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $77fc29d578dd0acd$export$cea3a54a6425200c; }, function (v) { return $77fc29d578dd0acd$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $77fc29d578dd0acd$export$a7c73072b1a182ae; }, function (v) { return $77fc29d578dd0acd$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $77fc29d578dd0acd$export$9f27bc3417b4524d; }, function (v) { return $77fc29d578dd0acd$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $77fc29d578dd0acd$export$db77ccec0bb4ccac; }, function (v) { return $77fc29d578dd0acd$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $77fc29d578dd0acd$export$8392c0c9d3dcbd35; }, function (v) { return $77fc29d578dd0acd$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $77fc29d578dd0acd$export$ffb0004e005737fa; }, function (v) { return $77fc29d578dd0acd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $77fc29d578dd0acd$export$b624eff549462981; }, function (v) { return $77fc29d578dd0acd$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $77fc29d578dd0acd$export$7897aa7841a5380c; }, function (v) { return $77fc29d578dd0acd$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $77fc29d578dd0acd$export$602eac185826482c; }, function (v) { return $77fc29d578dd0acd$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $77fc29d578dd0acd$export$e2c29f18771995cb; }, function (v) { return $77fc29d578dd0acd$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $77fc29d578dd0acd$export$5f8d39834fd61797; }, function (v) { return $77fc29d578dd0acd$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $77fc29d578dd0acd$export$74bf444e3cd11ea5; }, function (v) { return $77fc29d578dd0acd$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $77fc29d578dd0acd$export$92387174baf9b227; }, function (v) { return $77fc29d578dd0acd$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $77fc29d578dd0acd$export$ec112efeb987d9c6; }, function (v) { return $77fc29d578dd0acd$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $77fc29d578dd0acd$export$b706b080d889d2c9; }, function (v) { return $77fc29d578dd0acd$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $77fc29d578dd0acd$export$5be5a87408f70ddc; }, function (v) { return $77fc29d578dd0acd$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $77fc29d578dd0acd$export$45a5e7f76e0caa8d; }, function (v) { return $77fc29d578dd0acd$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $77fc29d578dd0acd$export$455c2e768291efa6; }, function (v) { return $77fc29d578dd0acd$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $77fc29d578dd0acd$export$9522e17588c12572; }, function (v) { return $77fc29d578dd0acd$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $77fc29d578dd0acd$export$2110ac352bb060b9; }, function (v) { return $77fc29d578dd0acd$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $77fc29d578dd0acd$export$56885ab8b9c456ab; }, function (v) { return $77fc29d578dd0acd$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $77fc29d578dd0acd$export$d927fcb6adf8f9de; }, function (v) { return $77fc29d578dd0acd$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $77fc29d578dd0acd$export$b82d16f27459e05a; }, function (v) { return $77fc29d578dd0acd$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $77fc29d578dd0acd$export$522c17b4f5e123e8; }, function (v) { return $77fc29d578dd0acd$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $77fc29d578dd0acd$export$1aabd8a0274ecfd6; }, function (v) { return $77fc29d578dd0acd$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $77fc29d578dd0acd$export$9b621391a187a31a; }, function (v) { return $77fc29d578dd0acd$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $77fc29d578dd0acd$export$f5bbd400c2f4426f; }, function (v) { return $77fc29d578dd0acd$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77fc29d578dd0acd$export$2b8d127b894957b9;
var $77fc29d578dd0acd$export$cea3a54a6425200c;
var $77fc29d578dd0acd$export$a7c73072b1a182ae;
var $77fc29d578dd0acd$export$9f27bc3417b4524d;
var $77fc29d578dd0acd$export$db77ccec0bb4ccac;
var $77fc29d578dd0acd$export$8392c0c9d3dcbd35;
var $77fc29d578dd0acd$export$ffb0004e005737fa;
var $77fc29d578dd0acd$export$b624eff549462981;
var $77fc29d578dd0acd$export$7897aa7841a5380c;
var $77fc29d578dd0acd$export$602eac185826482c;
var $77fc29d578dd0acd$export$e2c29f18771995cb;
var $77fc29d578dd0acd$export$5f8d39834fd61797;
var $77fc29d578dd0acd$export$74bf444e3cd11ea5;
var $77fc29d578dd0acd$export$92387174baf9b227;
var $77fc29d578dd0acd$export$ec112efeb987d9c6;
var $77fc29d578dd0acd$export$b706b080d889d2c9;
var $77fc29d578dd0acd$export$5be5a87408f70ddc;
var $77fc29d578dd0acd$export$45a5e7f76e0caa8d;
var $77fc29d578dd0acd$export$455c2e768291efa6;
var $77fc29d578dd0acd$export$9522e17588c12572;
var $77fc29d578dd0acd$export$2110ac352bb060b9;
var $77fc29d578dd0acd$export$56885ab8b9c456ab;
var $77fc29d578dd0acd$export$d927fcb6adf8f9de;
var $77fc29d578dd0acd$export$b82d16f27459e05a;
var $77fc29d578dd0acd$export$522c17b4f5e123e8;
var $77fc29d578dd0acd$export$1aabd8a0274ecfd6;
var $77fc29d578dd0acd$export$9b621391a187a31a;
var $77fc29d578dd0acd$export$f5bbd400c2f4426f;
'use strict';
var $77fc29d578dd0acd$var$b = "function" === typeof Symbol && Symbol.for, $77fc29d578dd0acd$var$c = $77fc29d578dd0acd$var$b ? Symbol.for("react.element") : 60103, $77fc29d578dd0acd$var$d = $77fc29d578dd0acd$var$b ? Symbol.for("react.portal") : 60106, $77fc29d578dd0acd$var$e = $77fc29d578dd0acd$var$b ? Symbol.for("react.fragment") : 60107, $77fc29d578dd0acd$var$f = $77fc29d578dd0acd$var$b ? Symbol.for("react.strict_mode") : 60108, $77fc29d578dd0acd$var$g = $77fc29d578dd0acd$var$b ? Symbol.for("react.profiler") : 60114, $77fc29d578dd0acd$var$h = $77fc29d578dd0acd$var$b ? Symbol.for("react.provider") : 60109, $77fc29d578dd0acd$var$k = $77fc29d578dd0acd$var$b ? Symbol.for("react.context") : 60110, $77fc29d578dd0acd$var$l = $77fc29d578dd0acd$var$b ? Symbol.for("react.async_mode") : 60111, $77fc29d578dd0acd$var$m = $77fc29d578dd0acd$var$b ? Symbol.for("react.concurrent_mode") : 60111, $77fc29d578dd0acd$var$n = $77fc29d578dd0acd$var$b ? Symbol.for("react.forward_ref") : 60112, $77fc29d578dd0acd$var$p = $77fc29d578dd0acd$var$b ? Symbol.for("react.suspense") : 60113, $77fc29d578dd0acd$var$q = $77fc29d578dd0acd$var$b ? Symbol.for("react.suspense_list") : 60120, $77fc29d578dd0acd$var$r = $77fc29d578dd0acd$var$b ? Symbol.for("react.memo") : 60115, $77fc29d578dd0acd$var$t = $77fc29d578dd0acd$var$b ? Symbol.for("react.lazy") : 60116, $77fc29d578dd0acd$var$v = $77fc29d578dd0acd$var$b ? Symbol.for("react.block") : 60121, $77fc29d578dd0acd$var$w = $77fc29d578dd0acd$var$b ? Symbol.for("react.fundamental") : 60117, $77fc29d578dd0acd$var$x = $77fc29d578dd0acd$var$b ? Symbol.for("react.responder") : 60118, $77fc29d578dd0acd$var$y = $77fc29d578dd0acd$var$b ? Symbol.for("react.scope") : 60119;
function $77fc29d578dd0acd$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $77fc29d578dd0acd$var$c:
                switch(a = a.type, a){
                    case $77fc29d578dd0acd$var$l:
                    case $77fc29d578dd0acd$var$m:
                    case $77fc29d578dd0acd$var$e:
                    case $77fc29d578dd0acd$var$g:
                    case $77fc29d578dd0acd$var$f:
                    case $77fc29d578dd0acd$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $77fc29d578dd0acd$var$k:
                            case $77fc29d578dd0acd$var$n:
                            case $77fc29d578dd0acd$var$t:
                            case $77fc29d578dd0acd$var$r:
                            case $77fc29d578dd0acd$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $77fc29d578dd0acd$var$d:
                return u;
        }
    }
}
function $77fc29d578dd0acd$var$A(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$m;
}
$77fc29d578dd0acd$export$2b8d127b894957b9 = $77fc29d578dd0acd$var$l;
$77fc29d578dd0acd$export$cea3a54a6425200c = $77fc29d578dd0acd$var$m;
$77fc29d578dd0acd$export$a7c73072b1a182ae = $77fc29d578dd0acd$var$k;
$77fc29d578dd0acd$export$9f27bc3417b4524d = $77fc29d578dd0acd$var$h;
$77fc29d578dd0acd$export$db77ccec0bb4ccac = $77fc29d578dd0acd$var$c;
$77fc29d578dd0acd$export$8392c0c9d3dcbd35 = $77fc29d578dd0acd$var$n;
$77fc29d578dd0acd$export$ffb0004e005737fa = $77fc29d578dd0acd$var$e;
$77fc29d578dd0acd$export$b624eff549462981 = $77fc29d578dd0acd$var$t;
$77fc29d578dd0acd$export$7897aa7841a5380c = $77fc29d578dd0acd$var$r;
$77fc29d578dd0acd$export$602eac185826482c = $77fc29d578dd0acd$var$d;
$77fc29d578dd0acd$export$e2c29f18771995cb = $77fc29d578dd0acd$var$g;
$77fc29d578dd0acd$export$5f8d39834fd61797 = $77fc29d578dd0acd$var$f;
$77fc29d578dd0acd$export$74bf444e3cd11ea5 = $77fc29d578dd0acd$var$p;
$77fc29d578dd0acd$export$92387174baf9b227 = function(a) {
    return $77fc29d578dd0acd$var$A(a) || $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$l;
};
$77fc29d578dd0acd$export$ec112efeb987d9c6 = $77fc29d578dd0acd$var$A;
$77fc29d578dd0acd$export$b706b080d889d2c9 = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$k;
};
$77fc29d578dd0acd$export$5be5a87408f70ddc = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$h;
};
$77fc29d578dd0acd$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $77fc29d578dd0acd$var$c;
};
$77fc29d578dd0acd$export$455c2e768291efa6 = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$n;
};
$77fc29d578dd0acd$export$9522e17588c12572 = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$e;
};
$77fc29d578dd0acd$export$2110ac352bb060b9 = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$t;
};
$77fc29d578dd0acd$export$56885ab8b9c456ab = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$r;
};
$77fc29d578dd0acd$export$d927fcb6adf8f9de = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$d;
};
$77fc29d578dd0acd$export$b82d16f27459e05a = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$g;
};
$77fc29d578dd0acd$export$522c17b4f5e123e8 = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$f;
};
$77fc29d578dd0acd$export$1aabd8a0274ecfd6 = function(a) {
    return $77fc29d578dd0acd$var$z(a) === $77fc29d578dd0acd$var$p;
};
$77fc29d578dd0acd$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $77fc29d578dd0acd$var$e || a === $77fc29d578dd0acd$var$m || a === $77fc29d578dd0acd$var$g || a === $77fc29d578dd0acd$var$f || a === $77fc29d578dd0acd$var$p || a === $77fc29d578dd0acd$var$q || "object" === typeof a && null !== a && (a.$$typeof === $77fc29d578dd0acd$var$t || a.$$typeof === $77fc29d578dd0acd$var$r || a.$$typeof === $77fc29d578dd0acd$var$h || a.$$typeof === $77fc29d578dd0acd$var$k || a.$$typeof === $77fc29d578dd0acd$var$n || a.$$typeof === $77fc29d578dd0acd$var$w || a.$$typeof === $77fc29d578dd0acd$var$x || a.$$typeof === $77fc29d578dd0acd$var$y || a.$$typeof === $77fc29d578dd0acd$var$v);
};
$77fc29d578dd0acd$export$f5bbd400c2f4426f = $77fc29d578dd0acd$var$z;

});


parcelRegister("akkJo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $784bda6e73d5efa1$export$2e2bcd8739ae039; });
function $784bda6e73d5efa1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("9HO5c", function(module, exports) {
'use strict';

var $3jwoA = parcelRequire("3jwoA");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $710efaa1358de886$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $710efaa1358de886$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $710efaa1358de886$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $710efaa1358de886$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $710efaa1358de886$var$TYPE_STATICS = {};
$710efaa1358de886$var$TYPE_STATICS[$3jwoA.ForwardRef] = $710efaa1358de886$var$FORWARD_REF_STATICS;
$710efaa1358de886$var$TYPE_STATICS[$3jwoA.Memo] = $710efaa1358de886$var$MEMO_STATICS;
function $710efaa1358de886$var$getStatics(component) {
    // React v16.11 and below
    if ($3jwoA.isMemo(component)) return $710efaa1358de886$var$MEMO_STATICS;
     // React v16.12 and above
    return $710efaa1358de886$var$TYPE_STATICS[component['$$typeof']] || $710efaa1358de886$var$REACT_STATICS;
}
var $710efaa1358de886$var$defineProperty = Object.defineProperty;
var $710efaa1358de886$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $710efaa1358de886$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $710efaa1358de886$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $710efaa1358de886$var$getPrototypeOf = Object.getPrototypeOf;
var $710efaa1358de886$var$objectPrototype = Object.prototype;
function $710efaa1358de886$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($710efaa1358de886$var$objectPrototype) {
            var inheritedComponent = $710efaa1358de886$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $710efaa1358de886$var$objectPrototype) $710efaa1358de886$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $710efaa1358de886$var$getOwnPropertyNames(sourceComponent);
        if ($710efaa1358de886$var$getOwnPropertySymbols) keys = keys.concat($710efaa1358de886$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $710efaa1358de886$var$getStatics(targetComponent);
        var sourceStatics = $710efaa1358de886$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$710efaa1358de886$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $710efaa1358de886$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $710efaa1358de886$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $710efaa1358de886$var$hoistNonReactStatics;

});



parcelRegister("jb8NR", function(module, exports) {

$parcel$export(module.exports, "StyleSheetManager", function () { return $df65df868cf712f6$export$a473771da2f0ff7c; });
$parcel$export(module.exports, "css", function () { return $df65df868cf712f6$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $df65df868cf712f6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "keyframes", function () { return $df65df868cf712f6$export$d25ddfdf17c3ad3e; });

var $es48e = parcelRequire("es48e");
parcelRequire("2jW13");

var $6uYXW = parcelRequire("6uYXW");

var $7QjWr = parcelRequire("7QjWr");

var $3PlBF = parcelRequire("3PlBF");

var $804aq = parcelRequire("804aq");
var $df65df868cf712f6$var$f = "data-styled", $df65df868cf712f6$var$m = "active", $df65df868cf712f6$var$y = "data-styled-version", $df65df868cf712f6$export$83d89fbfd8236492 = "6.1.19", $df65df868cf712f6$var$g = "/*!sc*/\n", $df65df868cf712f6$var$S = "undefined" != typeof window && "undefined" != typeof document, $df65df868cf712f6$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $df65df868cf712f6$var$b = {}, $df65df868cf712f6$var$E = /invalid hook call/i, $df65df868cf712f6$var$N = new Set, $df65df868cf712f6$var$P = function(t, n) {
    var o, s, i, a, e;
}, $df65df868cf712f6$var$_ = Object.freeze([]), $df65df868cf712f6$var$C = Object.freeze({});
function $df65df868cf712f6$var$I(e, t, n) {
    return void 0 === n && (n = $df65df868cf712f6$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $df65df868cf712f6$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $df65df868cf712f6$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $df65df868cf712f6$var$D = /(^-|-$)/g;
function $df65df868cf712f6$var$R(e) {
    return e.replace($df65df868cf712f6$var$O, "-").replace($df65df868cf712f6$var$D, "");
}
var $df65df868cf712f6$var$T = /(a)(d)/gi, $df65df868cf712f6$var$k = 52, $df65df868cf712f6$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $df65df868cf712f6$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $df65df868cf712f6$var$k; t = t / $df65df868cf712f6$var$k | 0)n = $df65df868cf712f6$var$j(t % $df65df868cf712f6$var$k) + n;
    return ($df65df868cf712f6$var$j(t % $df65df868cf712f6$var$k) + n).replace($df65df868cf712f6$var$T, "$1-$2");
}
var $df65df868cf712f6$var$V, $df65df868cf712f6$var$F = 5381, $df65df868cf712f6$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $df65df868cf712f6$var$z = function(e) {
    return $df65df868cf712f6$var$M($df65df868cf712f6$var$F, e);
};
function $df65df868cf712f6$var$$(e) {
    return $df65df868cf712f6$var$x($df65df868cf712f6$var$z(e) >>> 0);
}
function $df65df868cf712f6$var$B(e) {
    return e.displayName || e.name || "Component";
}
function $df65df868cf712f6$var$L(e) {
    return "string" == typeof e && true;
}
var $df65df868cf712f6$var$G = "function" == typeof Symbol && Symbol.for, $df65df868cf712f6$var$Y = $df65df868cf712f6$var$G ? Symbol.for("react.memo") : 60115, $df65df868cf712f6$var$W = $df65df868cf712f6$var$G ? Symbol.for("react.forward_ref") : 60112, $df65df868cf712f6$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $df65df868cf712f6$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $df65df868cf712f6$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $df65df868cf712f6$var$J = (($df65df868cf712f6$var$V = {})[$df65df868cf712f6$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $df65df868cf712f6$var$V[$df65df868cf712f6$var$Y] = $df65df868cf712f6$var$U, $df65df868cf712f6$var$V);
function $df65df868cf712f6$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $df65df868cf712f6$var$Y ? $df65df868cf712f6$var$U : "$$typeof" in e ? $df65df868cf712f6$var$J[e.$$typeof] : $df65df868cf712f6$var$q;
}
var $df65df868cf712f6$var$Z = Object.defineProperty, $df65df868cf712f6$var$K = Object.getOwnPropertyNames, $df65df868cf712f6$var$Q = Object.getOwnPropertySymbols, $df65df868cf712f6$var$ee = Object.getOwnPropertyDescriptor, $df65df868cf712f6$var$te = Object.getPrototypeOf, $df65df868cf712f6$var$ne = Object.prototype;
function $df65df868cf712f6$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($df65df868cf712f6$var$ne) {
            var o = $df65df868cf712f6$var$te(t);
            o && o !== $df65df868cf712f6$var$ne && $df65df868cf712f6$var$oe(e, o, n);
        }
        var r = $df65df868cf712f6$var$K(t);
        $df65df868cf712f6$var$Q && (r = r.concat($df65df868cf712f6$var$Q(t)));
        for(var s = $df65df868cf712f6$var$X(e), i = $df65df868cf712f6$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $df65df868cf712f6$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $df65df868cf712f6$var$ee(t, c);
                try {
                    $df65df868cf712f6$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $df65df868cf712f6$var$re(e) {
    return "function" == typeof e;
}
function $df65df868cf712f6$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $df65df868cf712f6$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $df65df868cf712f6$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $df65df868cf712f6$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $df65df868cf712f6$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$df65df868cf712f6$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $df65df868cf712f6$var$le(e[o], t[o]);
    else if ($df65df868cf712f6$var$ce(t)) for(var o in t)e[o] = $df65df868cf712f6$var$le(e[o], t[o]);
    return e;
}
function $df65df868cf712f6$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $df65df868cf712f6$var$pe = {};
function $df65df868cf712f6$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $df65df868cf712f6$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $df65df868cf712f6$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $df65df868cf712f6$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($df65df868cf712f6$var$g);
        return t;
    }, e;
}(), $df65df868cf712f6$var$me = 1073741824, $df65df868cf712f6$var$ye = new Map, $df65df868cf712f6$var$ve = new Map, $df65df868cf712f6$var$ge = 1, $df65df868cf712f6$var$Se = function(e) {
    if ($df65df868cf712f6$var$ye.has(e)) return $df65df868cf712f6$var$ye.get(e);
    for(; $df65df868cf712f6$var$ve.has($df65df868cf712f6$var$ge);)$df65df868cf712f6$var$ge++;
    var t = $df65df868cf712f6$var$ge++;
    return $df65df868cf712f6$var$ye.set(e, t), $df65df868cf712f6$var$ve.set(t, e), t;
}, $df65df868cf712f6$var$we = function(e, t) {
    $df65df868cf712f6$var$ge = t + 1, $df65df868cf712f6$var$ye.set(e, t), $df65df868cf712f6$var$ve.set(t, e);
}, $df65df868cf712f6$var$be = "style[".concat($df65df868cf712f6$var$f, "][").concat($df65df868cf712f6$var$y, '="').concat($df65df868cf712f6$export$83d89fbfd8236492, '"]'), $df65df868cf712f6$var$Ee = new RegExp("^".concat($df65df868cf712f6$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $df65df868cf712f6$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $df65df868cf712f6$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($df65df868cf712f6$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($df65df868cf712f6$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($df65df868cf712f6$var$we(u, l), $df65df868cf712f6$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $df65df868cf712f6$var$_e = function(e) {
    for(var t = document.querySelectorAll($df65df868cf712f6$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($df65df868cf712f6$var$f) !== $df65df868cf712f6$var$m && ($df65df868cf712f6$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $df65df868cf712f6$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $df65df868cf712f6$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($df65df868cf712f6$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($df65df868cf712f6$var$f, $df65df868cf712f6$var$m), o.setAttribute($df65df868cf712f6$var$y, $df65df868cf712f6$export$83d89fbfd8236492);
    var i = $df65df868cf712f6$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $df65df868cf712f6$var$Ae = function() {
    function e(e) {
        this.element = $df65df868cf712f6$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $df65df868cf712f6$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $df65df868cf712f6$var$Oe = function() {
    function e(e) {
        this.element = $df65df868cf712f6$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $df65df868cf712f6$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $df65df868cf712f6$var$Re = $df65df868cf712f6$var$S, $df65df868cf712f6$var$Te = {
    isServer: !$df65df868cf712f6$var$S,
    useCSSOMInjection: !$df65df868cf712f6$var$w
}, $df65df868cf712f6$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $df65df868cf712f6$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $es48e.__assign)((0, $es48e.__assign)({}, $df65df868cf712f6$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $df65df868cf712f6$var$S && $df65df868cf712f6$var$Re && ($df65df868cf712f6$var$Re = !1, $df65df868cf712f6$var$_e(this)), $df65df868cf712f6$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $df65df868cf712f6$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($df65df868cf712f6$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($df65df868cf712f6$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $df65df868cf712f6$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $df65df868cf712f6$var$S && $df65df868cf712f6$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $es48e.__assign)((0, $es48e.__assign)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $df65df868cf712f6$var$De(n) : t ? new $df65df868cf712f6$var$Ae(n) : new $df65df868cf712f6$var$Oe(n);
        }(this.options), new $df65df868cf712f6$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($df65df868cf712f6$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($df65df868cf712f6$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($df65df868cf712f6$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $df65df868cf712f6$var$je = /&/g, $df65df868cf712f6$var$xe = /^\s*\/\/.*$/gm;
function $df65df868cf712f6$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $df65df868cf712f6$var$Ve(e.children, t)), e;
    });
}
function $df65df868cf712f6$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $df65df868cf712f6$var$C : e, s = r.options, i = void 0 === s ? $df65df868cf712f6$var$C : s, a = r.plugins, c = void 0 === a ? $df65df868cf712f6$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $3PlBF.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace($df65df868cf712f6$var$je, n).replace(o, l));
    }), i.prefix && u.push($3PlBF.prefixer), u.push($3PlBF.stringify);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($df65df868cf712f6$var$xe, ""), l = $3PlBF.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $df65df868cf712f6$var$Ve(l, i.namespace));
        var p = [];
        return $3PlBF.serialize(l, $3PlBF.middleware(u.concat($3PlBF.rulesheet(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $df65df868cf712f6$var$he(15), $df65df868cf712f6$var$M(e, t.name);
    }, $df65df868cf712f6$var$F).toString() : "", p;
}
var $df65df868cf712f6$var$Me = new $df65df868cf712f6$var$ke, $df65df868cf712f6$var$ze = $df65df868cf712f6$var$Fe(), $df65df868cf712f6$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $df65df868cf712f6$var$Me,
    stylis: $df65df868cf712f6$var$ze
}), $df65df868cf712f6$export$91317688fc694efa = $df65df868cf712f6$export$8c190ef828af4c86.Consumer, $df65df868cf712f6$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createContext(void 0);
function $df65df868cf712f6$var$Ge() {
    return (0, $6uYXW.useContext)($df65df868cf712f6$export$8c190ef828af4c86);
}
function $df65df868cf712f6$export$a473771da2f0ff7c(e) {
    var t = (0, $6uYXW.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $df65df868cf712f6$var$Ge().styleSheet, l = (0, $6uYXW.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $6uYXW.useMemo)(function() {
        return $df65df868cf712f6$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $6uYXW.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($7QjWr)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $6uYXW.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($df65df868cf712f6$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($df65df868cf712f6$var$Le.Provider, {
        value: u
    }, e.children));
}
var $df65df868cf712f6$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $df65df868cf712f6$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $df65df868cf712f6$var$ue(this, function() {
            throw $df65df868cf712f6$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $df65df868cf712f6$var$ze), this.name + e.hash;
    }, e;
}(), $df65df868cf712f6$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $df65df868cf712f6$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $df65df868cf712f6$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $df65df868cf712f6$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $df65df868cf712f6$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$df65df868cf712f6$var$Ue(i) && (Array.isArray(i) && i.isCss || $df65df868cf712f6$var$re(i) ? r.push("".concat($df65df868cf712f6$var$He(s), ":"), i, ";") : $df65df868cf712f6$var$ce(i) ? r.push.apply(r, (0, $es48e.__spreadArray)((0, $es48e.__spreadArray)([
            "".concat(s, " {")
        ], $df65df868cf712f6$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($df65df868cf712f6$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $804aq.default) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $df65df868cf712f6$var$Xe(e, t, n, o) {
    if ($df65df868cf712f6$var$Ue(e)) return [];
    if ($df65df868cf712f6$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($df65df868cf712f6$var$re(e)) {
        if (!$df65df868cf712f6$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $df65df868cf712f6$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $df65df868cf712f6$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $df65df868cf712f6$var$ce(e) ? $df65df868cf712f6$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($df65df868cf712f6$var$_, e.map(function(e) {
        return $df65df868cf712f6$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $df65df868cf712f6$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($df65df868cf712f6$var$re(n) && !$df65df868cf712f6$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $df65df868cf712f6$var$Ke = $df65df868cf712f6$var$z($df65df868cf712f6$export$83d89fbfd8236492), $df65df868cf712f6$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $df65df868cf712f6$var$Ze(e), this.componentId = t, this.baseHash = $df65df868cf712f6$var$M($df65df868cf712f6$var$Ke, t), this.baseStyle = n, $df65df868cf712f6$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $df65df868cf712f6$var$ie(o, this.staticRulesId);
            else {
                var r = $df65df868cf712f6$var$ae($df65df868cf712f6$var$Xe(this.rules, e, t, n)), s = $df65df868cf712f6$var$x($df65df868cf712f6$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $df65df868cf712f6$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $df65df868cf712f6$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $df65df868cf712f6$var$ae($df65df868cf712f6$var$Xe(u, e, t, n));
                    a = $df65df868cf712f6$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $df65df868cf712f6$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $df65df868cf712f6$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $df65df868cf712f6$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createContext(void 0), $df65df868cf712f6$export$b631efc24e9d5e2f = $df65df868cf712f6$export$2c657da244d00bd6.Consumer;
function $df65df868cf712f6$export$93d4e7f90805808f() {
    var e = (0, $6uYXW.useContext)($df65df868cf712f6$export$2c657da244d00bd6);
    if (!e) throw $df65df868cf712f6$var$he(18);
    return e;
}
function $df65df868cf712f6$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useContext($df65df868cf712f6$export$2c657da244d00bd6), r = (0, $6uYXW.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $df65df868cf712f6$var$he(14);
            if ($df65df868cf712f6$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $df65df868cf712f6$var$he(8);
            return n ? (0, $es48e.__assign)((0, $es48e.__assign)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($df65df868cf712f6$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $df65df868cf712f6$var$rt = {}, $df65df868cf712f6$var$st = new Set;
function $df65df868cf712f6$var$it(e, r, s) {
    var i = $df65df868cf712f6$export$7ba318d8d2f06c76(e), a = e, c = !$df65df868cf712f6$var$L(e), p = r.attrs, d = void 0 === p ? $df65df868cf712f6$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $df65df868cf712f6$var$R(e);
        $df65df868cf712f6$var$rt[n] = ($df65df868cf712f6$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($df65df868cf712f6$var$$($df65df868cf712f6$export$83d89fbfd8236492 + n + $df65df868cf712f6$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $df65df868cf712f6$var$L(e) ? "styled.".concat(e) : "Styled(".concat($df65df868cf712f6$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($df65df868cf712f6$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $df65df868cf712f6$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useContext($df65df868cf712f6$export$2c657da244d00bd6), m = $df65df868cf712f6$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $df65df868cf712f6$var$I(r, f, c) || $df65df868cf712f6$var$C, g = function(e, n, o) {
                for(var r, s = (0, $es48e.__assign)((0, $es48e.__assign)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $df65df868cf712f6$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $df65df868cf712f6$var$ie(s[c], a[c]) : "style" === c ? (0, $es48e.__assign)((0, $es48e.__assign)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $df65df868cf712f6$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $df65df868cf712f6$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $df65df868cf712f6$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$df65df868cf712f6$var$L(S) && !$df65df868cf712f6$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $6uYXW.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $df65df868cf712f6$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$df65df868cf712f6$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $df65df868cf712f6$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $df65df868cf712f6$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $df65df868cf712f6$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $df65df868cf712f6$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $df65df868cf712f6$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($df65df868cf712f6$var$re(t) || $df65df868cf712f6$var$ce(t)) return $df65df868cf712f6$var$ct($df65df868cf712f6$var$Xe($df65df868cf712f6$var$at($df65df868cf712f6$var$_, (0, $es48e.__spreadArray)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $df65df868cf712f6$var$Xe(r) : $df65df868cf712f6$var$ct($df65df868cf712f6$var$Xe($df65df868cf712f6$var$at(r, n)));
}
function $df65df868cf712f6$var$ut(n, o, r) {
    if (void 0 === r && (r = $df65df868cf712f6$var$C), !o) throw $df65df868cf712f6$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $df65df868cf712f6$export$dbf350e5966cf602.apply(void 0, (0, $es48e.__spreadArray)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $df65df868cf712f6$var$ut(n, o, (0, $es48e.__assign)((0, $es48e.__assign)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $df65df868cf712f6$var$ut(n, o, (0, $es48e.__assign)((0, $es48e.__assign)({}, r), e));
    }, s;
}
var $df65df868cf712f6$var$pt = function(e) {
    return $df65df868cf712f6$var$ut($df65df868cf712f6$var$it, e);
}, $df65df868cf712f6$export$2e2bcd8739ae039 = $df65df868cf712f6$var$pt;
$df65df868cf712f6$var$A.forEach(function(e) {
    $df65df868cf712f6$export$2e2bcd8739ae039[e] = $df65df868cf712f6$var$pt(e);
});
var $df65df868cf712f6$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $df65df868cf712f6$var$Ze(e), $df65df868cf712f6$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($df65df868cf712f6$var$ae($df65df868cf712f6$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $df65df868cf712f6$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $df65df868cf712f6$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $df65df868cf712f6$export$dbf350e5966cf602.apply(void 0, (0, $es48e.__spreadArray)([
        n
    ], r, !1)), a = "sc-global-".concat($df65df868cf712f6$var$$(JSON.stringify(i))), c = new $df65df868cf712f6$var$ht(i, a);
    var l = function(e) {
        var t = $df65df868cf712f6$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useContext($df65df868cf712f6$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $df65df868cf712f6$var$b, o, s);
        else {
            var i = (0, $es48e.__assign)((0, $es48e.__assign)({}, n), {
                theme: $df65df868cf712f6$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).memo(l);
}
function $df65df868cf712f6$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $df65df868cf712f6$var$ae($df65df868cf712f6$export$dbf350e5966cf602.apply(void 0, (0, $es48e.__spreadArray)([
        t
    ], n, !1))), s = $df65df868cf712f6$var$$(r);
    return new $df65df868cf712f6$var$We(s, r);
}
function $df65df868cf712f6$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).forwardRef(function(n, r) {
        var s = $df65df868cf712f6$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useContext($df65df868cf712f6$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(e, (0, $es48e.__assign)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($df65df868cf712f6$var$B(e), ")"), $df65df868cf712f6$var$oe(n, e);
}
var $df65df868cf712f6$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $df65df868cf712f6$var$Ce(), o = $df65df868cf712f6$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($df65df868cf712f6$var$f, '="true"'),
                "".concat($df65df868cf712f6$var$y, '="').concat($df65df868cf712f6$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $df65df868cf712f6$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $df65df868cf712f6$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$df65df868cf712f6$var$f] = "", n[$df65df868cf712f6$var$y] = $df65df868cf712f6$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $df65df868cf712f6$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("style", (0, $es48e.__assign)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $df65df868cf712f6$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $df65df868cf712f6$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($df65df868cf712f6$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $df65df868cf712f6$var$he(3);
    }, e;
}(), $df65df868cf712f6$export$5c87cfe6c475f500 = {
    StyleSheet: $df65df868cf712f6$var$ke,
    mainSheet: $df65df868cf712f6$var$Me
};
var $df65df868cf712f6$var$St = "__sc-".concat($df65df868cf712f6$var$f, "__");

});
parcelRegister("es48e", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $a856e2b84215283e$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spreadArray", function () { return $a856e2b84215283e$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a856e2b84215283e$var$extendStatics = function(d, b) {
    $a856e2b84215283e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a856e2b84215283e$var$extendStatics(d, b);
};
function $a856e2b84215283e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a856e2b84215283e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a856e2b84215283e$export$18ce0697a983be9b = function() {
    $a856e2b84215283e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a856e2b84215283e$export$18ce0697a983be9b.apply(this, arguments);
};
function $a856e2b84215283e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a856e2b84215283e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a856e2b84215283e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a856e2b84215283e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a856e2b84215283e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a856e2b84215283e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a856e2b84215283e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a856e2b84215283e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a856e2b84215283e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a856e2b84215283e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a856e2b84215283e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a856e2b84215283e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a856e2b84215283e$export$45d3717a4c69092e(o, m, p);
}
function $a856e2b84215283e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a856e2b84215283e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a856e2b84215283e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a856e2b84215283e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a856e2b84215283e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a856e2b84215283e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a856e2b84215283e$export$10c90e4f7922046c(v) {
    return this instanceof $a856e2b84215283e$export$10c90e4f7922046c ? (this.v = v, this) : new $a856e2b84215283e$export$10c90e4f7922046c(v);
}
function $a856e2b84215283e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a856e2b84215283e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a856e2b84215283e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a856e2b84215283e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a856e2b84215283e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a856e2b84215283e$export$19a8beecd37a4c45 === "function" ? $a856e2b84215283e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a856e2b84215283e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a856e2b84215283e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a856e2b84215283e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a856e2b84215283e$export$45d3717a4c69092e(result, mod, k);
    }
    $a856e2b84215283e$var$__setModuleDefault(result, mod);
    return result;
}
function $a856e2b84215283e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a856e2b84215283e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a856e2b84215283e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a856e2b84215283e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a856e2b84215283e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a856e2b84215283e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a856e2b84215283e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a856e2b84215283e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a856e2b84215283e$export$2e2bcd8739ae039 = {
    __extends: $a856e2b84215283e$export$a8ba968b8961cb8a,
    __assign: $a856e2b84215283e$export$18ce0697a983be9b,
    __rest: $a856e2b84215283e$export$3c9a16f847548506,
    __decorate: $a856e2b84215283e$export$29e00dfd3077644b,
    __param: $a856e2b84215283e$export$d5ad3fd78186038f,
    __metadata: $a856e2b84215283e$export$f1db080c865becb9,
    __awaiter: $a856e2b84215283e$export$1050f835b63b671e,
    __generator: $a856e2b84215283e$export$67ebef60e6f28a6,
    __createBinding: $a856e2b84215283e$export$45d3717a4c69092e,
    __exportStar: $a856e2b84215283e$export$f33643c0debef087,
    __values: $a856e2b84215283e$export$19a8beecd37a4c45,
    __read: $a856e2b84215283e$export$8d051b38c9118094,
    __spread: $a856e2b84215283e$export$afc72e2116322959,
    __spreadArrays: $a856e2b84215283e$export$6388937ca91ccae8,
    __spreadArray: $a856e2b84215283e$export$1216008129fb82ed,
    __await: $a856e2b84215283e$export$10c90e4f7922046c,
    __asyncGenerator: $a856e2b84215283e$export$e427f37a30a4de9b,
    __asyncDelegator: $a856e2b84215283e$export$bbd80228419bb833,
    __asyncValues: $a856e2b84215283e$export$e3b29a3d6162315f,
    __makeTemplateObject: $a856e2b84215283e$export$4fb47efe1390b86f,
    __importStar: $a856e2b84215283e$export$c21735bcef00d192,
    __importDefault: $a856e2b84215283e$export$da59b14a69baef04,
    __classPrivateFieldGet: $a856e2b84215283e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a856e2b84215283e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a856e2b84215283e$export$81fdc39f203e4e04,
    __addDisposableResource: $a856e2b84215283e$export$88ac25d8e944e405,
    __disposeResources: $a856e2b84215283e$export$8f076105dc360e92
};

});

parcelRegister("7QjWr", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("3PlBF", function(module, exports) {

$parcel$export(module.exports, "RULESET", function () { return $c778e460a0062fd0$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "from", function () { return $c778e460a0062fd0$export$6788812c4e6611e6; });
$parcel$export(module.exports, "position", function () { return $c778e460a0062fd0$export$5880b8b5730aff45; });
$parcel$export(module.exports, "next", function () { return $c778e460a0062fd0$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $c778e460a0062fd0$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "token", function () { return $c778e460a0062fd0$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $c778e460a0062fd0$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $c778e460a0062fd0$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $c778e460a0062fd0$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "identifier", function () { return $c778e460a0062fd0$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "compile", function () { return $c778e460a0062fd0$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $c778e460a0062fd0$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $c778e460a0062fd0$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $c778e460a0062fd0$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c778e460a0062fd0$export$38bcb760f1d4871c; });
$parcel$export(module.exports, "prefixer", function () { return $c778e460a0062fd0$export$e08c7d021b829b7a; });
var $c778e460a0062fd0$export$71ad59f2e432cfe8 = "-ms-";
var $c778e460a0062fd0$export$2c0f367103c8d01c = "-moz-";
var $c778e460a0062fd0$export$39dfd62a25e0fe93 = "-webkit-";
var $c778e460a0062fd0$export$a29989082612d0d9 = "comm";
var $c778e460a0062fd0$export$aa3a2e812ca8570d = "rule";
var $c778e460a0062fd0$export$527d108ccf083c2b = "decl";
var $c778e460a0062fd0$export$d3d35020fa5b54f0 = "@page";
var $c778e460a0062fd0$export$500415a86c544f73 = "@media";
var $c778e460a0062fd0$export$a763edbf796b780a = "@import";
var $c778e460a0062fd0$export$2790aeb8b4e5c826 = "@charset";
var $c778e460a0062fd0$export$1cc683e23b84b133 = "@viewport";
var $c778e460a0062fd0$export$9447a5efea57e862 = "@supports";
var $c778e460a0062fd0$export$ef011b4e114b1fba = "@document";
var $c778e460a0062fd0$export$6aad947bda0f3f46 = "@namespace";
var $c778e460a0062fd0$export$b44a8529a35fcb60 = "@keyframes";
var $c778e460a0062fd0$export$2c16de31893252e6 = "@font-face";
var $c778e460a0062fd0$export$3d846dd52e150c6f = "@counter-style";
var $c778e460a0062fd0$export$22314bfbb57653fe = "@font-feature-values";
var $c778e460a0062fd0$export$d773506282b3cfe6 = "@layer";
var $c778e460a0062fd0$export$1c5a554c78c0cd12 = "@scope";
var $c778e460a0062fd0$export$2335f513bbd82c6d = Math.abs;
var $c778e460a0062fd0$export$6788812c4e6611e6 = String.fromCharCode;
var $c778e460a0062fd0$export$e6e34fd1f2686227 = Object.assign;
function $c778e460a0062fd0$export$d6af199866bfb566(e, r) {
    return $c778e460a0062fd0$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c778e460a0062fd0$export$a9db5e087081082d(e, 0)) << 2 ^ $c778e460a0062fd0$export$a9db5e087081082d(e, 1)) << 2 ^ $c778e460a0062fd0$export$a9db5e087081082d(e, 2)) << 2 ^ $c778e460a0062fd0$export$a9db5e087081082d(e, 3) : 0;
}
function $c778e460a0062fd0$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c778e460a0062fd0$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c778e460a0062fd0$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c778e460a0062fd0$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $c778e460a0062fd0$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c778e460a0062fd0$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c778e460a0062fd0$export$36776f635604f274(e) {
    return e.length;
}
function $c778e460a0062fd0$export$f9084667e487ed46(e) {
    return e.length;
}
function $c778e460a0062fd0$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c778e460a0062fd0$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $c778e460a0062fd0$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$c778e460a0062fd0$export$4659b591c19bdf3d(e, r);
    });
}
var $c778e460a0062fd0$export$53f1d5ea8de3d7c = 1;
var $c778e460a0062fd0$export$4e0c71f277ca26b3 = 1;
var $c778e460a0062fd0$export$f24224f1c91d8156 = 0;
var $c778e460a0062fd0$export$5880b8b5730aff45 = 0;
var $c778e460a0062fd0$export$c0306caf338ac095 = 0;
var $c778e460a0062fd0$export$30a86d91af8ff6e6 = "";
function $c778e460a0062fd0$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c778e460a0062fd0$export$53f1d5ea8de3d7c,
        column: $c778e460a0062fd0$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $c778e460a0062fd0$export$784d13d8ee351f07(e, r) {
    return $c778e460a0062fd0$export$e6e34fd1f2686227($c778e460a0062fd0$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $c778e460a0062fd0$export$590e8b2c435046d9(e) {
    while(e.root)e = $c778e460a0062fd0$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $c778e460a0062fd0$export$10d8903dec122b9d(e, e.siblings);
}
function $c778e460a0062fd0$export$eba6f6f03b0a92e7() {
    return $c778e460a0062fd0$export$c0306caf338ac095;
}
function $c778e460a0062fd0$export$232faf9add678146() {
    $c778e460a0062fd0$export$c0306caf338ac095 = $c778e460a0062fd0$export$5880b8b5730aff45 > 0 ? $c778e460a0062fd0$export$a9db5e087081082d($c778e460a0062fd0$export$30a86d91af8ff6e6, --$c778e460a0062fd0$export$5880b8b5730aff45) : 0;
    if ($c778e460a0062fd0$export$4e0c71f277ca26b3--, $c778e460a0062fd0$export$c0306caf338ac095 === 10) $c778e460a0062fd0$export$4e0c71f277ca26b3 = 1, $c778e460a0062fd0$export$53f1d5ea8de3d7c--;
    return $c778e460a0062fd0$export$c0306caf338ac095;
}
function $c778e460a0062fd0$export$48cfd1e771a65c4f() {
    $c778e460a0062fd0$export$c0306caf338ac095 = $c778e460a0062fd0$export$5880b8b5730aff45 < $c778e460a0062fd0$export$f24224f1c91d8156 ? $c778e460a0062fd0$export$a9db5e087081082d($c778e460a0062fd0$export$30a86d91af8ff6e6, $c778e460a0062fd0$export$5880b8b5730aff45++) : 0;
    if ($c778e460a0062fd0$export$4e0c71f277ca26b3++, $c778e460a0062fd0$export$c0306caf338ac095 === 10) $c778e460a0062fd0$export$4e0c71f277ca26b3 = 1, $c778e460a0062fd0$export$53f1d5ea8de3d7c++;
    return $c778e460a0062fd0$export$c0306caf338ac095;
}
function $c778e460a0062fd0$export$4d3fb11e950abb9e() {
    return $c778e460a0062fd0$export$a9db5e087081082d($c778e460a0062fd0$export$30a86d91af8ff6e6, $c778e460a0062fd0$export$5880b8b5730aff45);
}
function $c778e460a0062fd0$export$e88cb2efb12ae807() {
    return $c778e460a0062fd0$export$5880b8b5730aff45;
}
function $c778e460a0062fd0$export$58adb3bec8346d0f(e, r) {
    return $c778e460a0062fd0$export$2f35ab04d2335697($c778e460a0062fd0$export$30a86d91af8ff6e6, e, r);
}
function $c778e460a0062fd0$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c778e460a0062fd0$export$2de70f21292aac9e(e) {
    return $c778e460a0062fd0$export$53f1d5ea8de3d7c = $c778e460a0062fd0$export$4e0c71f277ca26b3 = 1, $c778e460a0062fd0$export$f24224f1c91d8156 = $c778e460a0062fd0$export$36776f635604f274($c778e460a0062fd0$export$30a86d91af8ff6e6 = e), $c778e460a0062fd0$export$5880b8b5730aff45 = 0, [];
}
function $c778e460a0062fd0$export$45918ac1574455b1(e) {
    return $c778e460a0062fd0$export$30a86d91af8ff6e6 = "", e;
}
function $c778e460a0062fd0$export$410ac95b9ec204b8(e) {
    return $c778e460a0062fd0$export$87c2784dc9fc4ab($c778e460a0062fd0$export$58adb3bec8346d0f($c778e460a0062fd0$export$5880b8b5730aff45 - 1, $c778e460a0062fd0$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c778e460a0062fd0$export$660b2ee2d4fb4eff(e) {
    return $c778e460a0062fd0$export$45918ac1574455b1($c778e460a0062fd0$export$5f8c09e3ae6f64e1($c778e460a0062fd0$export$2de70f21292aac9e(e)));
}
function $c778e460a0062fd0$export$7af1228ff777d175(e) {
    while($c778e460a0062fd0$export$c0306caf338ac095 = $c778e460a0062fd0$export$4d3fb11e950abb9e())if ($c778e460a0062fd0$export$c0306caf338ac095 < 33) $c778e460a0062fd0$export$48cfd1e771a65c4f();
    else break;
    return $c778e460a0062fd0$export$9e1725a4cfeada27(e) > 2 || $c778e460a0062fd0$export$9e1725a4cfeada27($c778e460a0062fd0$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c778e460a0062fd0$export$5f8c09e3ae6f64e1(e) {
    while($c778e460a0062fd0$export$48cfd1e771a65c4f())switch($c778e460a0062fd0$export$9e1725a4cfeada27($c778e460a0062fd0$export$c0306caf338ac095)){
        case 0:
            $c778e460a0062fd0$export$10d8903dec122b9d($c778e460a0062fd0$export$c2ab62c7bf24634($c778e460a0062fd0$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c778e460a0062fd0$export$10d8903dec122b9d($c778e460a0062fd0$export$410ac95b9ec204b8($c778e460a0062fd0$export$c0306caf338ac095), e);
            break;
        default:
            $c778e460a0062fd0$export$10d8903dec122b9d($c778e460a0062fd0$export$6788812c4e6611e6($c778e460a0062fd0$export$c0306caf338ac095), e);
    }
    return e;
}
function $c778e460a0062fd0$export$955ba06d119e085e(e, r) {
    while(--r && $c778e460a0062fd0$export$48cfd1e771a65c4f())if ($c778e460a0062fd0$export$c0306caf338ac095 < 48 || $c778e460a0062fd0$export$c0306caf338ac095 > 102 || $c778e460a0062fd0$export$c0306caf338ac095 > 57 && $c778e460a0062fd0$export$c0306caf338ac095 < 65 || $c778e460a0062fd0$export$c0306caf338ac095 > 70 && $c778e460a0062fd0$export$c0306caf338ac095 < 97) break;
    return $c778e460a0062fd0$export$58adb3bec8346d0f(e, $c778e460a0062fd0$export$e88cb2efb12ae807() + (r < 6 && $c778e460a0062fd0$export$4d3fb11e950abb9e() == 32 && $c778e460a0062fd0$export$48cfd1e771a65c4f() == 32));
}
function $c778e460a0062fd0$export$c889f2fcc19dbf12(e) {
    while($c778e460a0062fd0$export$48cfd1e771a65c4f())switch($c778e460a0062fd0$export$c0306caf338ac095){
        case e:
            return $c778e460a0062fd0$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c778e460a0062fd0$export$c889f2fcc19dbf12($c778e460a0062fd0$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c778e460a0062fd0$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c778e460a0062fd0$export$48cfd1e771a65c4f();
            break;
    }
    return $c778e460a0062fd0$export$5880b8b5730aff45;
}
function $c778e460a0062fd0$export$4254d4e2b3745c4c(e, r) {
    while($c778e460a0062fd0$export$48cfd1e771a65c4f())if (e + $c778e460a0062fd0$export$c0306caf338ac095 === 57) break;
    else if (e + $c778e460a0062fd0$export$c0306caf338ac095 === 84 && $c778e460a0062fd0$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c778e460a0062fd0$export$58adb3bec8346d0f(r, $c778e460a0062fd0$export$5880b8b5730aff45 - 1) + "*" + $c778e460a0062fd0$export$6788812c4e6611e6(e === 47 ? e : $c778e460a0062fd0$export$48cfd1e771a65c4f());
}
function $c778e460a0062fd0$export$c2ab62c7bf24634(e) {
    while(!$c778e460a0062fd0$export$9e1725a4cfeada27($c778e460a0062fd0$export$4d3fb11e950abb9e()))$c778e460a0062fd0$export$48cfd1e771a65c4f();
    return $c778e460a0062fd0$export$58adb3bec8346d0f(e, $c778e460a0062fd0$export$5880b8b5730aff45);
}
function $c778e460a0062fd0$export$ef7acd7185315e22(e) {
    return $c778e460a0062fd0$export$45918ac1574455b1($c778e460a0062fd0$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c778e460a0062fd0$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c778e460a0062fd0$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $c778e460a0062fd0$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c778e460a0062fd0$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($c778e460a0062fd0$export$f8e21b1e77979a08(z += $c778e460a0062fd0$export$77ad94ebf1c2b9ed($c778e460a0062fd0$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $c778e460a0062fd0$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $c778e460a0062fd0$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $c778e460a0062fd0$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $c778e460a0062fd0$export$955ba06d119e085e($c778e460a0062fd0$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c778e460a0062fd0$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c778e460a0062fd0$export$10d8903dec122b9d($c778e460a0062fd0$export$4a34f930e789283c($c778e460a0062fd0$export$4254d4e2b3745c4c($c778e460a0062fd0$export$48cfd1e771a65c4f(), $c778e460a0062fd0$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c778e460a0062fd0$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $c778e460a0062fd0$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $c778e460a0062fd0$export$36776f635604f274(z) - l) $c778e460a0062fd0$export$10d8903dec122b9d(p > 32 ? $c778e460a0062fd0$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $c778e460a0062fd0$export$f8483753829ec8f3($c778e460a0062fd0$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $c778e460a0062fd0$export$10d8903dec122b9d(j = $c778e460a0062fd0$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $c778e460a0062fd0$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $c778e460a0062fd0$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c778e460a0062fd0$export$98e6a39c04603d36(e, j, j, n && $c778e460a0062fd0$export$10d8903dec122b9d($c778e460a0062fd0$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $c778e460a0062fd0$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $c778e460a0062fd0$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $c778e460a0062fd0$export$232faf9add678146() == 125) continue;
            }
            switch(z += $c778e460a0062fd0$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c778e460a0062fd0$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c778e460a0062fd0$export$4d3fb11e950abb9e() === 45) z += $c778e460a0062fd0$export$410ac95b9ec204b8($c778e460a0062fd0$export$48cfd1e771a65c4f());
                    v = $c778e460a0062fd0$export$4d3fb11e950abb9e(), o = l = $c778e460a0062fd0$export$36776f635604f274(k = z += $c778e460a0062fd0$export$c2ab62c7bf24634($c778e460a0062fd0$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $c778e460a0062fd0$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $c778e460a0062fd0$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $c778e460a0062fd0$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $c778e460a0062fd0$export$2f35ab04d2335697(e, p + 1, p = $c778e460a0062fd0$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $c778e460a0062fd0$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $c778e460a0062fd0$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $c778e460a0062fd0$export$35059013cd4a06db(e, r, a, s === 0 ? $c778e460a0062fd0$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $c778e460a0062fd0$export$4a34f930e789283c(e, r, a, c) {
    return $c778e460a0062fd0$export$35059013cd4a06db(e, r, a, $c778e460a0062fd0$export$a29989082612d0d9, $c778e460a0062fd0$export$6788812c4e6611e6($c778e460a0062fd0$export$eba6f6f03b0a92e7()), $c778e460a0062fd0$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $c778e460a0062fd0$export$f8483753829ec8f3(e, r, a, n, c) {
    return $c778e460a0062fd0$export$35059013cd4a06db(e, r, a, $c778e460a0062fd0$export$527d108ccf083c2b, $c778e460a0062fd0$export$2f35ab04d2335697(e, 0, n), $c778e460a0062fd0$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $c778e460a0062fd0$export$82e9f45cca5ba907(n, c, s) {
    switch($c778e460a0062fd0$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c778e460a0062fd0$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$2c0f367103c8d01c + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c778e460a0062fd0$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c778e460a0062fd0$export$39dfd62a25e0fe93 + "box-$1$2" + $c778e460a0062fd0$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + "flex-item-" + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c778e460a0062fd0$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c778e460a0062fd0$export$71ad59f2e432cfe8 + "grid-row-" + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + "flex-line-pack" + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + "box-" + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c778e460a0062fd0$export$39dfd62a25e0fe93 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c778e460a0062fd0$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c778e460a0062fd0$export$77ad94ebf1c2b9ed($c778e460a0062fd0$export$77ad94ebf1c2b9ed($c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c778e460a0062fd0$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c778e460a0062fd0$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c778e460a0062fd0$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c778e460a0062fd0$export$77ad94ebf1c2b9ed($c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c778e460a0062fd0$export$39dfd62a25e0fe93 + "box-pack:$3" + $c778e460a0062fd0$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c778e460a0062fd0$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c778e460a0062fd0$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c778e460a0062fd0$export$71ad59f2e432cfe8 + "grid-column-align" + $c778e460a0062fd0$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c778e460a0062fd0$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c778e460a0062fd0$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c778e460a0062fd0$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c778e460a0062fd0$export$f8e21b1e77979a08(s, "span", 0) ? $c778e460a0062fd0$export$4659b591c19bdf3d(s, /\d+/) : +$c778e460a0062fd0$export$4659b591c19bdf3d(s, /\d+/) - +$c778e460a0062fd0$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c778e460a0062fd0$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c778e460a0062fd0$export$71ad59f2e432cfe8 + $c778e460a0062fd0$export$77ad94ebf1c2b9ed($c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c778e460a0062fd0$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c778e460a0062fd0$export$36776f635604f274(n) - 1 - c > 6) switch($c778e460a0062fd0$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c778e460a0062fd0$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c778e460a0062fd0$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c778e460a0062fd0$export$2c0f367103c8d01c + ($c778e460a0062fd0$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c778e460a0062fd0$export$f8e21b1e77979a08(n, "stretch", 0) ? $c778e460a0062fd0$export$82e9f45cca5ba907($c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c778e460a0062fd0$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c778e460a0062fd0$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c778e460a0062fd0$export$a9db5e087081082d(n, c + 6) === 121) return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, ":", ":" + $c778e460a0062fd0$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c778e460a0062fd0$export$a9db5e087081082d(n, $c778e460a0062fd0$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c778e460a0062fd0$export$39dfd62a25e0fe93 + ($c778e460a0062fd0$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c778e460a0062fd0$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c778e460a0062fd0$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, ":", ":" + $c778e460a0062fd0$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c778e460a0062fd0$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $c778e460a0062fd0$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c778e460a0062fd0$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c778e460a0062fd0$export$a763edbf796b780a:
        case $c778e460a0062fd0$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c778e460a0062fd0$export$a29989082612d0d9:
            return "";
        case $c778e460a0062fd0$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c778e460a0062fd0$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c778e460a0062fd0$export$aa3a2e812ca8570d:
            if (!$c778e460a0062fd0$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $c778e460a0062fd0$export$36776f635604f274(a = $c778e460a0062fd0$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c778e460a0062fd0$export$5a7767152ae0305f(e) {
    var r = $c778e460a0062fd0$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c778e460a0062fd0$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c778e460a0062fd0$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c778e460a0062fd0$export$527d108ccf083c2b:
                n.return = $c778e460a0062fd0$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c778e460a0062fd0$export$b44a8529a35fcb60:
                return $c778e460a0062fd0$export$dfdc1655ccc5b9cb([
                    $c778e460a0062fd0$export$784d13d8ee351f07(n, {
                        value: $c778e460a0062fd0$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c778e460a0062fd0$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c778e460a0062fd0$export$aa3a2e812ca8570d:
                if (n.length) return $c778e460a0062fd0$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($c778e460a0062fd0$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $c778e460a0062fd0$export$590e8b2c435046d9($c778e460a0062fd0$export$784d13d8ee351f07(n, {
                                props: [
                                    $c778e460a0062fd0$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c778e460a0062fd0$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $c778e460a0062fd0$export$590e8b2c435046d9($c778e460a0062fd0$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $c778e460a0062fd0$export$e6e34fd1f2686227(n, {
                                props: $c778e460a0062fd0$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $c778e460a0062fd0$export$590e8b2c435046d9($c778e460a0062fd0$export$784d13d8ee351f07(n, {
                                props: [
                                    $c778e460a0062fd0$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c778e460a0062fd0$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $c778e460a0062fd0$export$590e8b2c435046d9($c778e460a0062fd0$export$784d13d8ee351f07(n, {
                                props: [
                                    $c778e460a0062fd0$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c778e460a0062fd0$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $c778e460a0062fd0$export$590e8b2c435046d9($c778e460a0062fd0$export$784d13d8ee351f07(n, {
                                props: [
                                    $c778e460a0062fd0$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c778e460a0062fd0$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $c778e460a0062fd0$export$590e8b2c435046d9($c778e460a0062fd0$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $c778e460a0062fd0$export$e6e34fd1f2686227(n, {
                                props: $c778e460a0062fd0$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $c778e460a0062fd0$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c778e460a0062fd0$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c778e460a0062fd0$export$1be1fc439b849fdf($c778e460a0062fd0$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c778e460a0062fd0$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c778e460a0062fd0$export$2f35ab04d2335697(r, 1, $c778e460a0062fd0$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c778e460a0062fd0$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c778e460a0062fd0$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c778e460a0062fd0$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("804aq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d318e53cf74cc5c$export$2e2bcd8739ae039; });
var $5d318e53cf74cc5c$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("dhPTb", function(module, exports) {

$parcel$export(module.exports, "Config", function () { return $a746ea1a6bfa2797$export$29cd7b75162a9425; });
$parcel$export(module.exports, "setConfiguration", function () { return $a746ea1a6bfa2797$export$6a52175581b4d614; });
let $a746ea1a6bfa2797$export$29cd7b75162a9425 = {
    APP_CAROUSEL_IMAGES: []
};
const $a746ea1a6bfa2797$export$6a52175581b4d614 = (externalConfiguration)=>{
    $a746ea1a6bfa2797$export$29cd7b75162a9425 = externalConfiguration;
};

});

parcelRegister("kqXxS", function(module, exports) {

$parcel$export(module.exports, "errorStore", function () { return $df84c4a387296a2d$export$3c14179d4d032b1b; });
$parcel$export(module.exports, "uuidManager", function () { return $df84c4a387296a2d$export$54aa20e2d2062203; });
$parcel$export(module.exports, "trustManager", function () { return $df84c4a387296a2d$export$6d46941104b14ec0; });
$parcel$export(module.exports, "authenticationManager", function () { return $df84c4a387296a2d$export$131221af18ca7607; });
$parcel$export(module.exports, "featuresManager", function () { return $df84c4a387296a2d$export$382ccb0adb6bd4f9; });
$parcel$export(module.exports, "configurationManager", function () { return $df84c4a387296a2d$export$6482f278b39b32a6; });
$parcel$export(module.exports, "loginService", function () { return $df84c4a387296a2d$export$174042268a1993c3; });
$parcel$export(module.exports, "authExecutor", function () { return $df84c4a387296a2d$export$70ee1de632fa6b9a; });
$parcel$export(module.exports, "i18NManager", function () { return $df84c4a387296a2d$export$8f2e7c88865724ab; });
$parcel$export(module.exports, "clientManager", function () { return $df84c4a387296a2d$export$ad2f848bd5fba9d2; });
$parcel$export(module.exports, "authenticationsSessionsService", function () { return $df84c4a387296a2d$export$63c690cfd6d32f13; });
$parcel$export(module.exports, "authenticationsSessionsManager", function () { return $df84c4a387296a2d$export$b81dba3d0ae46f2e; });
$parcel$export(module.exports, "accountManager", function () { return $df84c4a387296a2d$export$8e3ba3d49accc65e; });
$parcel$export(module.exports, "identityManager", function () { return $df84c4a387296a2d$export$c2131c6cc88a702c; });
$parcel$export(module.exports, "savingsService", function () { return $df84c4a387296a2d$export$18aeb007ff656596; });
$parcel$export(module.exports, "savingsManager", function () { return $df84c4a387296a2d$export$42e9549b83335a40; });
$parcel$export(module.exports, "partyAuthenticationManager", function () { return $df84c4a387296a2d$export$1291906736372779; });
$parcel$export(module.exports, "authorizationHoldManager", function () { return $df84c4a387296a2d$export$49d093be1b6b5518; });
$parcel$export(module.exports, "transactionManager", function () { return $df84c4a387296a2d$export$74b078fec9b81ca9; });
$parcel$export(module.exports, "transactionsManager", function () { return $df84c4a387296a2d$export$5e12589d8c522e1b; });
$parcel$export(module.exports, "externalAccountManager", function () { return $df84c4a387296a2d$export$6c097eb522118652; });
$parcel$export(module.exports, "acceptorManager", function () { return $df84c4a387296a2d$export$c8a01fd7de6e40e4; });
$parcel$export(module.exports, "acceptorCategoriesManager", function () { return $df84c4a387296a2d$export$b2a351d7dd647c1a; });
$parcel$export(module.exports, "billManager", function () { return $df84c4a387296a2d$export$15b747ca267a7e1; });
$parcel$export(module.exports, "billIssuerManager", function () { return $df84c4a387296a2d$export$b38e67f9d0521e44; });
$parcel$export(module.exports, "billIssuerSelectionManager", function () { return $df84c4a387296a2d$export$f58eff29441a0ecd; });
$parcel$export(module.exports, "pincodeKeyboardService", function () { return $df84c4a387296a2d$export$4f28e60574c154ec; });
$parcel$export(module.exports, "pincodeService", function () { return $df84c4a387296a2d$export$a075172aae3ce5f; });
$parcel$export(module.exports, "accountStatementService", function () { return $df84c4a387296a2d$export$cf39d496b1ef2579; });
$parcel$export(module.exports, "cashTransferService", function () { return $df84c4a387296a2d$export$5eb1a29383a30281; });
$parcel$export(module.exports, "cashTransferManager", function () { return $df84c4a387296a2d$export$2dd23ceaa132081; });
$parcel$export(module.exports, "dedicatedTransferManager", function () { return $df84c4a387296a2d$export$20fb78cc9e4a7b0e; });
$parcel$export(module.exports, "registerManager", function () { return $df84c4a387296a2d$export$9bc197bca8e7d2f7; });
$parcel$export(module.exports, "onboardingService", function () { return $df84c4a387296a2d$export$66f3fb1d40113cac; });
$parcel$export(module.exports, "onboardingManager", function () { return $df84c4a387296a2d$export$e4dca90213c30a5f; });
$parcel$export(module.exports, "cardFilterManager", function () { return $df84c4a387296a2d$export$5623f17b42957278; });
$parcel$export(module.exports, "transactionSearchManager", function () { return $df84c4a387296a2d$export$11f222e8895131e9; });
$parcel$export(module.exports, "productManager", function () { return $df84c4a387296a2d$export$2bdb8c98693b3648; });
$parcel$export(module.exports, "autocompleteService", function () { return $df84c4a387296a2d$export$3f938acc29371225; });
$parcel$export(module.exports, "bankToWalletManager", function () { return $df84c4a387296a2d$export$c4cf7d855c011382; });
$parcel$export(module.exports, "contactService", function () { return $df84c4a387296a2d$export$366dcecd19883aa9; });
$parcel$export(module.exports, "transactionCodeManager", function () { return $df84c4a387296a2d$export$792ef74274a51ac; });
$parcel$export(module.exports, "bicReferentialManager", function () { return $df84c4a387296a2d$export$cecb7540719c75ce; });
$parcel$export(module.exports, "spendingsManager", function () { return $df84c4a387296a2d$export$7efa2d74a71af815; });
$parcel$export(module.exports, "attachmentsManager", function () { return $df84c4a387296a2d$export$8d009b2cadd02686; });
$parcel$export(module.exports, "categorizationsManager", function () { return $df84c4a387296a2d$export$1b32e7436e84f322; });
$parcel$export(module.exports, "customerActionService", function () { return $df84c4a387296a2d$export$cedc10ca7ea21eaa; });
$parcel$export(module.exports, "cardManager", function () { return $df84c4a387296a2d$export$4dde3c077dd178f9; });
$parcel$export(module.exports, "transferManager", function () { return $df84c4a387296a2d$export$2284c3db90e93fab; });
$parcel$export(module.exports, "webAppStartManager", function () { return $df84c4a387296a2d$export$b84222a794b6022d; });
$parcel$export(module.exports, "accountBankDetailsService", function () { return $df84c4a387296a2d$export$21661a2472936ebe; });
$parcel$export(module.exports, "beneficiaryManager", function () { return $df84c4a387296a2d$export$e478ee86c9c2a6e9; });
$parcel$export(module.exports, "generateAccountStatementService", function () { return $df84c4a387296a2d$export$861da681a0588f1c; });
$parcel$export(module.exports, "currencyManager", function () { return $df84c4a387296a2d$export$420e1a31b1a9e98f; });
$parcel$export(module.exports, "accountDeleteService", function () { return $df84c4a387296a2d$export$cf0862a81b922612; });
$parcel$export(module.exports, "upcomingTransfersManager", function () { return $df84c4a387296a2d$export$fbe9433ddca057e6; });
$parcel$export(module.exports, "mandatesManager", function () { return $df84c4a387296a2d$export$7afd98e551592b4a; });
$parcel$export(module.exports, "mandateFilterManager", function () { return $df84c4a387296a2d$export$60bf90924be66fe8; });

var $3AGN4 = parcelRequire("3AGN4");

var $7wYYD = parcelRequire("7wYYD");

var $bQGPR = parcelRequire("bQGPR");

var $7nfAL = parcelRequire("7nfAL");

var $3O0H7 = parcelRequire("3O0H7");

var $gV1ek = parcelRequire("gV1ek");

var $7agwe = parcelRequire("7agwe");

var $ba55X = parcelRequire("ba55X");

var $cEBkf = parcelRequire("cEBkf");

var $jtPvJ = parcelRequire("jtPvJ");

var $fb0N8 = parcelRequire("fb0N8");

var $3OBoX = parcelRequire("3OBoX");

var $5MHoL = parcelRequire("5MHoL");

var $DnLEN = parcelRequire("DnLEN");

var $7wo2g = parcelRequire("7wo2g");

var $crfiu = parcelRequire("crfiu");

var $asiRY = parcelRequire("asiRY");

var $3s9ko = parcelRequire("3s9ko");

var $jYJVu = parcelRequire("jYJVu");

var $60oeT = parcelRequire("60oeT");

var $kIm2v = parcelRequire("kIm2v");

var $gL1yS = parcelRequire("gL1yS");

var $jEHGF = parcelRequire("jEHGF");

var $CEBSr = parcelRequire("CEBSr");

var $dz3sL = parcelRequire("dz3sL");

var $2Acav = parcelRequire("2Acav");

var $Rr3Qd = parcelRequire("Rr3Qd");

var $3bBnP = parcelRequire("3bBnP");

var $dKwzC = parcelRequire("dKwzC");

var $h74Ih = parcelRequire("h74Ih");

var $ku1xA = parcelRequire("ku1xA");

var $bGEKX = parcelRequire("bGEKX");

var $kL9gD = parcelRequire("kL9gD");

var $4DBys = parcelRequire("4DBys");

var $2Gwkh = parcelRequire("2Gwkh");

var $ciu8j = parcelRequire("ciu8j");

var $gKRm0 = parcelRequire("gKRm0");

var $gBAsC = parcelRequire("gBAsC");

var $3arnJ = parcelRequire("3arnJ");

var $eVD1w = parcelRequire("eVD1w");

var $4DiDz = parcelRequire("4DiDz");

var $pvLbs = parcelRequire("pvLbs");

var $eEO1c = parcelRequire("eEO1c");

var $agKwC = parcelRequire("agKwC");

var $ixbyZ = parcelRequire("ixbyZ");

var $4kWAI = parcelRequire("4kWAI");

var $lIleL = parcelRequire("lIleL");

var $1GrnA = parcelRequire("1GrnA");

var $6kH50 = parcelRequire("6kH50");

var $dtKQH = parcelRequire("dtKQH");

var $1qf9N = parcelRequire("1qf9N");

var $VHpFU = parcelRequire("VHpFU");

var $6daXU = parcelRequire("6daXU");

var $keHi0 = parcelRequire("keHi0");

var $8urHF = parcelRequire("8urHF");

var $ls8p9 = parcelRequire("ls8p9");

var $c4FrM = parcelRequire("c4FrM");

var $9KPxn = parcelRequire("9KPxn");

var $8LY9U = parcelRequire("8LY9U");

var $6Zk0Z = parcelRequire("6Zk0Z");

var $fuI9I = parcelRequire("fuI9I");

var $dMTzj = parcelRequire("dMTzj");

var $faGbe = parcelRequire("faGbe");

var $jgfcJ = parcelRequire("jgfcJ");

var $jV3Gu = parcelRequire("jV3Gu");

var $fEQSP = parcelRequire("fEQSP");

var $4Cchr = parcelRequire("4Cchr");

var $29Yis = parcelRequire("29Yis");

var $a6zzA = parcelRequire("a6zzA");

var $dl8DR = parcelRequire("dl8DR");

var $8M8RF = parcelRequire("8M8RF");

var $7lmN6 = parcelRequire("7lmN6");

var $lwQMA = parcelRequire("lwQMA");

var $eMOeB = parcelRequire("eMOeB");

var $fWEzG = parcelRequire("fWEzG");

var $dwwRL = parcelRequire("dwwRL");

var $3KRz4 = parcelRequire("3KRz4");

var $9AZir = parcelRequire("9AZir");

var $f1VGu = parcelRequire("f1VGu");

var $ctI69 = parcelRequire("ctI69");

var $gnf0B = parcelRequire("gnf0B");

var $cW7Mc = parcelRequire("cW7Mc");

var $j0zvC = parcelRequire("j0zvC");

var $9YT3o = parcelRequire("9YT3o");

var $gRSic = parcelRequire("gRSic");

var $8heZF = parcelRequire("8heZF");

var $euFJW = parcelRequire("euFJW");

var $7t9hQ = parcelRequire("7t9hQ");

var $fTMJB = parcelRequire("fTMJB");

var $640ed = parcelRequire("640ed");

var $iKRSG = parcelRequire("iKRSG");

var $1m2je = parcelRequire("1m2je");

var $1501u = parcelRequire("1501u");

var $3SQwH = parcelRequire("3SQwH");

var $1L358 = parcelRequire("1L358");

var $cd48V = parcelRequire("cd48V");

var $6Si8z = parcelRequire("6Si8z");

var $9mafT = parcelRequire("9mafT");

var $dhPTb = parcelRequire("dhPTb");

var $9Lc2e = parcelRequire("9Lc2e");

var $b8lpk = parcelRequire("b8lpk");

var $a5pmH = parcelRequire("a5pmH");

var $gztWX = parcelRequire("gztWX");

var $kRPgC = parcelRequire("kRPgC");

var $9McIA = parcelRequire("9McIA");

var $kKOCu = parcelRequire("kKOCu");

var $hg3kg = parcelRequire("hg3kg");

var $bvHZm = parcelRequire("bvHZm");

var $huphj = parcelRequire("huphj");

var $bs8aV = parcelRequire("bs8aV");

var $dZ8li = parcelRequire("dZ8li");

var $2jUR4 = parcelRequire("2jUR4");

var $3rnPM = parcelRequire("3rnPM");
const $df84c4a387296a2d$var$customUserAgentService = null;
const $df84c4a387296a2d$var$webSecuredCookiesService = new (0, $jtPvJ.WebSecuredCookiesService)();
const $df84c4a387296a2d$export$b5b101acdf4c4e2c = new (0, $3rnPM.WebAnalyticsService)();
const $df84c4a387296a2d$export$b6bed72fb1722dab = new (0, $DnLEN.WebDeviceInfoService)();
const $df84c4a387296a2d$export$3c14179d4d032b1b = new (0, $cd48V.ErrorStore)();
const $df84c4a387296a2d$export$c1b2b945bea31d71 = new (0, $bvHZm.HttpService)($df84c4a387296a2d$var$customUserAgentService, $df84c4a387296a2d$var$webSecuredCookiesService, undefined);
const $df84c4a387296a2d$export$c7e4d7944b1065d1 = new (0, $huphj.OauthHttpService)($df84c4a387296a2d$export$3c14179d4d032b1b, $df84c4a387296a2d$var$customUserAgentService, $df84c4a387296a2d$var$webSecuredCookiesService, undefined);
const $df84c4a387296a2d$export$a0a9fb0b6a77bc5f = new (0, $5MHoL.WebUUIDGenerator)();
const $df84c4a387296a2d$export$5d4198ab2bac8c43 = new (0, $kRPgC.I18NStore)();
const $df84c4a387296a2d$export$54aa20e2d2062203 = new (0, $2jUR4.UUIDManager)(new (0, $bQGPR.LocalStorage)(), $df84c4a387296a2d$export$a0a9fb0b6a77bc5f);
const $df84c4a387296a2d$export$6d46941104b14ec0 = new (0, $60oeT.TrustManager)(new (0, $bQGPR.LocalStorage)());
const $df84c4a387296a2d$export$f6a94576d0129ce8 = new (0, $gKRm0.AuthenticationConfigurationService)(null, $df84c4a387296a2d$var$customUserAgentService, $df84c4a387296a2d$export$5d4198ab2bac8c43);
const $df84c4a387296a2d$export$909432510645ee24 = new (0, $asiRY.WebOAuthService)($df84c4a387296a2d$export$c7e4d7944b1065d1, new (0, $bQGPR.LocalStorage)(), $df84c4a387296a2d$export$6d46941104b14ec0);
const $df84c4a387296a2d$export$38e7ffee86a65864 = new (0, $3arnJ.AuthenticationService)($df84c4a387296a2d$export$c7e4d7944b1065d1, $df84c4a387296a2d$export$f6a94576d0129ce8, $df84c4a387296a2d$export$909432510645ee24);
const $df84c4a387296a2d$export$dd8d1f2d5394eeb5 = new (0, $cEBkf.WebNetworkInfoManager)();
const $df84c4a387296a2d$export$131221af18ca7607 = new (0, $gBAsC.AuthenticationManager)($df84c4a387296a2d$export$38e7ffee86a65864, $df84c4a387296a2d$export$dd8d1f2d5394eeb5, new (0, $gV1ek.SessionStorage)(), $df84c4a387296a2d$export$b5b101acdf4c4e2c, $df84c4a387296a2d$export$b6bed72fb1722dab, $df84c4a387296a2d$var$webSecuredCookiesService);
const $df84c4a387296a2d$export$d0204b1ddc8ee140 = new (0, $9McIA.ApiService)($df84c4a387296a2d$export$3c14179d4d032b1b, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$var$customUserAgentService, $df84c4a387296a2d$export$5d4198ab2bac8c43, $df84c4a387296a2d$var$webSecuredCookiesService, undefined);
const $df84c4a387296a2d$export$382ccb0adb6bd4f9 = new (0, $dMTzj.FeaturesManager)($df84c4a387296a2d$export$131221af18ca7607);
const $df84c4a387296a2d$export$f142ab1793038b8f = new (0, $ls8p9.ConfigurationService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$6482f278b39b32a6 = new (0, $8urHF.ConfigurationManager)($df84c4a387296a2d$export$f142ab1793038b8f, new (0, $9mafT.DefaultCacheLoader)(new (0, $3O0H7.SessionCache)((0, $dhPTb.Config).CONFIGURATION_CACHE_TTL, "configuration")), null, $df84c4a387296a2d$export$5d4198ab2bac8c43, $df84c4a387296a2d$export$b5b101acdf4c4e2c, $df84c4a387296a2d$export$b6bed72fb1722dab);
const $df84c4a387296a2d$export$174042268a1993c3 = new (0, $6Si8z.LoginService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$70ee1de632fa6b9a = new (0, $7wYYD.WebAuthExecutor)($df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$6482f278b39b32a6);
const $df84c4a387296a2d$export$4bb12130ac544f17 = new (0, $gztWX.I18NService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$bec0ac3d51f7baf5 = new (0, $3OBoX.WebTranslationsManager)($df84c4a387296a2d$export$6482f278b39b32a6, new (0, $9mafT.DefaultCacheLoader)(new (0, $3O0H7.SessionCache)((0, $dhPTb.Config).TRANSLATIONS_CACHE_TTL, "translations")), $df84c4a387296a2d$export$4bb12130ac544f17);
const $df84c4a387296a2d$export$8f2e7c88865724ab = new (0, $a5pmH.I18NManager)($df84c4a387296a2d$export$5d4198ab2bac8c43, $df84c4a387296a2d$export$bec0ac3d51f7baf5, new (0, $bQGPR.LocalStorage)());
const $df84c4a387296a2d$export$95fc304c3f7c9d54 = new (0, $kKOCu.ConnectedApiService)($df84c4a387296a2d$export$3c14179d4d032b1b, $df84c4a387296a2d$export$c1b2b945bea31d71, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$var$customUserAgentService, $df84c4a387296a2d$var$webSecuredCookiesService, undefined);
const $df84c4a387296a2d$export$dd6fd28d4b3e1cb5 = new (0, $keHi0.ClientService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$ad2f848bd5fba9d2 = new (0, $6daXU.ClientManager)($df84c4a387296a2d$export$dd6fd28d4b3e1cb5, $df84c4a387296a2d$export$382ccb0adb6bd4f9, new (0, $9mafT.DefaultCacheLoader)(new (0, $7nfAL.MemoryCache)((0, $dhPTb.Config).CLIENT_CACHE_TTL, (0, $fb0N8.CLIENT_CACHE_STORAGE_KEY))));
const $df84c4a387296a2d$export$1b7cecc4292f0eeb = new (0, $dZ8li.ServiceDomainApiService)($df84c4a387296a2d$var$customUserAgentService, undefined);
const $df84c4a387296a2d$export$60591c0ba00d5f8d = new (0, $j0zvC.ServiceDomainService)($df84c4a387296a2d$export$1b7cecc4292f0eeb);
const $df84c4a387296a2d$export$a12a659ed0b07a8e = new (0, $hg3kg.ConnectedServiceDomainApiService)($df84c4a387296a2d$export$c1b2b945bea31d71, $df84c4a387296a2d$var$customUserAgentService, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$5d4198ab2bac8c43, $df84c4a387296a2d$var$webSecuredCookiesService, undefined);
const $df84c4a387296a2d$export$63c690cfd6d32f13 = new (0, $4DiDz.default)($df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$b81dba3d0ae46f2e = new (0, $eVD1w.default)($df84c4a387296a2d$export$63c690cfd6d32f13, $df84c4a387296a2d$export$382ccb0adb6bd4f9);
const $df84c4a387296a2d$export$7a13b4751d4f4de3 = new (0, $bs8aV.SavingsApiService)($df84c4a387296a2d$export$c1b2b945bea31d71, $df84c4a387296a2d$var$customUserAgentService, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$5d4198ab2bac8c43, $df84c4a387296a2d$var$webSecuredCookiesService, undefined);
const $df84c4a387296a2d$export$66e841f7a194ff96 = new (0, $2Acav.AccountService)($df84c4a387296a2d$export$a12a659ed0b07a8e, $df84c4a387296a2d$export$7a13b4751d4f4de3);
const $df84c4a387296a2d$export$8e3ba3d49accc65e = new (0, $dz3sL.AccountManager)($df84c4a387296a2d$export$66e841f7a194ff96, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$ad2f848bd5fba9d2, new (0, $9mafT.DefaultCacheLoader)(new (0, $7nfAL.MemoryCache)((0, $dhPTb.Config).ACCOUNTS_CACHE_TTL, (0, $fb0N8.ACCOUNTS_CACHE_STORAGE_KEY))));
const $df84c4a387296a2d$export$b0ef71c8784bc5b3 = new (0, $jgfcJ.IdentityService)($df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$c2131c6cc88a702c = new (0, $faGbe.IdentityManager)($df84c4a387296a2d$export$b0ef71c8784bc5b3);
const $df84c4a387296a2d$export$18aeb007ff656596 = new (0, $cW7Mc.SavingsService)($df84c4a387296a2d$export$7a13b4751d4f4de3);
const $df84c4a387296a2d$export$42e9549b83335a40 = new (0, $gnf0B.SavingsManager)($df84c4a387296a2d$export$18aeb007ff656596);
const $df84c4a387296a2d$export$1291906736372779 = new (0, $dl8DR.PartyAuthenticationManager)(new (0, $8M8RF.PartyAuthenticationService)($df84c4a387296a2d$export$a12a659ed0b07a8e), {});
const $df84c4a387296a2d$export$18f951b6e7afa90c = new (0, $eEO1c.AuthorizationHoldService)($df84c4a387296a2d$export$95fc304c3f7c9d54, $df84c4a387296a2d$export$382ccb0adb6bd4f9);
const $df84c4a387296a2d$export$49d093be1b6b5518 = new (0, $pvLbs.AuthorizationHoldManager)($df84c4a387296a2d$export$18f951b6e7afa90c, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$ad2f848bd5fba9d2, new (0, $9mafT.DefaultCacheLoader)(new (0, $7nfAL.MemoryCache)((0, $dhPTb.Config).AUTHORIZATION_HOLDS_CACHE_TTL, (0, $fb0N8.ACCOUNTS_CACHE_STORAGE_KEY))));
const $df84c4a387296a2d$export$618cecff890bf43e = new (0, $2Gwkh.TransactionService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$74b078fec9b81ca9 = new (0, $4DBys.TransactionManager)($df84c4a387296a2d$export$618cecff890bf43e);
const $df84c4a387296a2d$export$5e12589d8c522e1b = new (0, $ciu8j.TransactionsManager)($df84c4a387296a2d$export$618cecff890bf43e, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$ad2f848bd5fba9d2, new (0, $9mafT.DefaultCacheLoader)(new (0, $7nfAL.MemoryCache)((0, $dhPTb.Config).TRANSACTIONS_CACHE_TTL, (0, $fb0N8.TRANSACTIONS_CACHE_STORAGE_KEY))));
const $df84c4a387296a2d$export$b0463c85276a6ba2 = new (0, $ctI69.ExternalAccountService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$6c097eb522118652 = new (0, $f1VGu.ExternalAccountManager)($df84c4a387296a2d$export$b0463c85276a6ba2, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$382ccb0adb6bd4f9, new (0, $9mafT.DefaultCacheLoader)(new (0, $7nfAL.MemoryCache)((0, $dhPTb.Config).RECIPIENTS_CACHE_TTL, (0, $fb0N8.BENEFICIARIES_CACHE_STORAGE_KEY))));
const $df84c4a387296a2d$export$a764f5315574fb1e = new (0, $CEBSr.AcceptorService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$c8a01fd7de6e40e4 = new (0, $jEHGF.AcceptorManager)($df84c4a387296a2d$export$a764f5315574fb1e);
const $df84c4a387296a2d$export$b2a351d7dd647c1a = new (0, $gL1yS.AcceptorCategoriesManager)($df84c4a387296a2d$export$a764f5315574fb1e);
const $df84c4a387296a2d$export$e98cb43da54f7ca1 = new (0, $7agwe.WebTransactionGeolocalisationManager)();
const $df84c4a387296a2d$export$23232bc3dbb93617 = new (0, $6kH50.BillService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$15b747ca267a7e1 = new (0, $1GrnA.BillManager)($df84c4a387296a2d$export$23232bc3dbb93617, $df84c4a387296a2d$export$e98cb43da54f7ca1, $df84c4a387296a2d$export$8e3ba3d49accc65e, $df84c4a387296a2d$export$5e12589d8c522e1b);
const $df84c4a387296a2d$export$b38e67f9d0521e44 = new (0, $4kWAI.BillIssuerManager)($df84c4a387296a2d$export$23232bc3dbb93617, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$ad2f848bd5fba9d2, new (0, $9mafT.DefaultCacheLoader)(new (0, $7nfAL.MemoryCache)((0, $dhPTb.Config).BILL_ISSUERS_CACHE_TTL, (0, $fb0N8.BILL_ISSUERS_CACHE_STORAGE_KEY))), $df84c4a387296a2d$export$b5b101acdf4c4e2c, $df84c4a387296a2d$export$b6bed72fb1722dab);
const $df84c4a387296a2d$export$f58eff29441a0ecd = new (0, $lIleL.BillIssuerSelectionManager)($df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$ad2f848bd5fba9d2);
const $df84c4a387296a2d$export$4f28e60574c154ec = new (0, $lwQMA.PincodeKeyboardService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$a075172aae3ce5f = new (0, $eMOeB.PincodeService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$94e49c6bd79478eb = new (0, $7lmN6.CheckPincodeService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$cf39d496b1ef2579 = new (0, $crfiu.WebAccountStatementsService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$5eb1a29383a30281 = new (0, $euFJW.CashTransferService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$2dd23ceaa132081 = new (0, $8heZF.CashTransferManager)($df84c4a387296a2d$export$5eb1a29383a30281, $df84c4a387296a2d$export$e98cb43da54f7ca1, $df84c4a387296a2d$export$8e3ba3d49accc65e, $df84c4a387296a2d$export$5e12589d8c522e1b);
const $df84c4a387296a2d$export$b6919d71cd766282 = new (0, $fTMJB.DedicatedTransferService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$20fb78cc9e4a7b0e = new (0, $7t9hQ.DedicatedTransferManager)($df84c4a387296a2d$export$b6919d71cd766282, $df84c4a387296a2d$export$e98cb43da54f7ca1, $df84c4a387296a2d$export$8e3ba3d49accc65e, $df84c4a387296a2d$export$5e12589d8c522e1b);
const $df84c4a387296a2d$export$4d7a7d14704ebc13 = new (0, $fuI9I.RegisterService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$9bc197bca8e7d2f7 = new (0, $6Zk0Z.RegisterManager)($df84c4a387296a2d$export$4d7a7d14704ebc13, new (0, $bQGPR.LocalStorage)(), new (0, $kIm2v.WebImagesConverter)());
const $df84c4a387296a2d$export$66f3fb1d40113cac = new (0, $a6zzA.OnboardingService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$e4dca90213c30a5f = new (0, $29Yis.OnboardingManager)($df84c4a387296a2d$export$66f3fb1d40113cac, $df84c4a387296a2d$export$382ccb0adb6bd4f9, new (0, $kIm2v.WebImagesConverter)());
const $df84c4a387296a2d$export$5623f17b42957278 = new (0, $dtKQH.CardFilterManager)();
const $df84c4a387296a2d$export$11f222e8895131e9 = new (0, $Rr3Qd.TransactionSearchManager)();
const $df84c4a387296a2d$export$12e00c4409c6161a = new (0, $dwwRL.ProductService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$2bdb8c98693b3648 = new (0, $fWEzG.ProductManager)($df84c4a387296a2d$export$12e00c4409c6161a, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$ad2f848bd5fba9d2);
const $df84c4a387296a2d$export$3f938acc29371225 = new (0, $b8lpk.AutocompleteService)($df84c4a387296a2d$export$d0204b1ddc8ee140);
const $df84c4a387296a2d$export$efb56fd943ba65c2 = new (0, $gRSic.BankToWalletService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$c4cf7d855c011382 = new (0, $9YT3o.BankToWalletManager)($df84c4a387296a2d$export$efb56fd943ba65c2, new (0, $bQGPR.LocalStorage)(), $df84c4a387296a2d$export$e98cb43da54f7ca1, $df84c4a387296a2d$export$8e3ba3d49accc65e, $df84c4a387296a2d$export$5e12589d8c522e1b);
const $df84c4a387296a2d$export$366dcecd19883aa9 = new (0, $9Lc2e.ContactService)($df84c4a387296a2d$export$6482f278b39b32a6, $df84c4a387296a2d$export$8f2e7c88865724ab);
const $df84c4a387296a2d$export$2e6e08be90f329c0 = new (0, $1L358.TransactionCodeService)($df84c4a387296a2d$export$95fc304c3f7c9d54, $df84c4a387296a2d$export$8f2e7c88865724ab);
const $df84c4a387296a2d$export$792ef74274a51ac = new (0, $3SQwH.TransactionCodeManager)($df84c4a387296a2d$export$2e6e08be90f329c0);
const $df84c4a387296a2d$export$b6bb2fd9a43e4bf = new (0, $ixbyZ.BicReferentialService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$cecb7540719c75ce = new (0, $agKwC.BicReferentialManager)($df84c4a387296a2d$export$b6bb2fd9a43e4bf);
const $df84c4a387296a2d$export$195b83b175241ead = new (0, $kL9gD.SpendingsService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$7efa2d74a71af815 = new (0, $bGEKX.SpendingsManager)($df84c4a387296a2d$export$195b83b175241ead);
const $df84c4a387296a2d$export$7f2f308e09504caa = new (0, $dKwzC.AttachmentsService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$8d009b2cadd02686 = new (0, $3bBnP.AttachmentsManager)($df84c4a387296a2d$export$7f2f308e09504caa);
const $df84c4a387296a2d$export$42f65df074797b28 = new (0, $ku1xA.CategorizationsService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$1b32e7436e84f322 = new (0, $h74Ih.CategorizationsManager)($df84c4a387296a2d$export$42f65df074797b28);
const $df84c4a387296a2d$export$cedc10ca7ea21eaa = new (0, $8LY9U.CustomerActionService)($df84c4a387296a2d$export$95fc304c3f7c9d54);
const $df84c4a387296a2d$export$69193ec914ccddb5 = new (0, $VHpFU.CardService)($df84c4a387296a2d$export$95fc304c3f7c9d54, $df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$f768e1e4200ae729 = new (0, $3s9ko.CardDetailsManager)($df84c4a387296a2d$export$69193ec914ccddb5);
const $df84c4a387296a2d$export$4dde3c077dd178f9 = new (0, $1qf9N.CardManager)($df84c4a387296a2d$export$69193ec914ccddb5, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$f768e1e4200ae729);
const $df84c4a387296a2d$export$9f2c2e991b336909 = new (0, $iKRSG.TransferService)($df84c4a387296a2d$export$95fc304c3f7c9d54, $df84c4a387296a2d$export$a12a659ed0b07a8e, $df84c4a387296a2d$export$ad2f848bd5fba9d2, $df84c4a387296a2d$export$94e49c6bd79478eb);
const $df84c4a387296a2d$export$2284c3db90e93fab = new (0, $640ed.TransferManager)($df84c4a387296a2d$export$9f2c2e991b336909, $df84c4a387296a2d$export$e98cb43da54f7ca1, $df84c4a387296a2d$export$8e3ba3d49accc65e, $df84c4a387296a2d$export$5e12589d8c522e1b, $df84c4a387296a2d$export$382ccb0adb6bd4f9);
const $df84c4a387296a2d$export$b84222a794b6022d = new (0, $ba55X.WebAppStartManager)($df84c4a387296a2d$export$6482f278b39b32a6, $df84c4a387296a2d$export$8f2e7c88865724ab, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$ad2f848bd5fba9d2, new (0, $gV1ek.SessionStorage)());
const $df84c4a387296a2d$export$21661a2472936ebe = new (0, $7wo2g.WebAccountBankDetailsService)($df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$c7fd40a0a33ceedd = new (0, $9AZir.BeneficiaryService)($df84c4a387296a2d$export$95fc304c3f7c9d54, $df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$e478ee86c9c2a6e9 = new (0, $3KRz4.BeneficiaryManager)($df84c4a387296a2d$export$c7fd40a0a33ceedd, $df84c4a387296a2d$export$131221af18ca7607, $df84c4a387296a2d$export$382ccb0adb6bd4f9, new (0, $9mafT.DefaultCacheLoader)(new (0, $7nfAL.MemoryCache)((0, $dhPTb.Config).RECIPIENTS_CACHE_TTL, (0, $fb0N8.BENEFICIARIES_CACHE_STORAGE_KEY))));
const $df84c4a387296a2d$export$861da681a0588f1c = new (0, $jYJVu.WebGenerateAccountStatementService)($df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$8f8ace278493ba35 = new (0, $9KPxn.CurrencyService)($df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$420e1a31b1a9e98f = new (0, $c4FrM.CurrencyManager)($df84c4a387296a2d$export$8f8ace278493ba35, $df84c4a387296a2d$export$382ccb0adb6bd4f9);
const $df84c4a387296a2d$export$cf0862a81b922612 = new (0, $3AGN4.AccountDeleteService)($df84c4a387296a2d$export$ad2f848bd5fba9d2, $df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$dd1d8d38c51ee025 = new (0, $1501u.UpcomingTransfersService)($df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$fbe9433ddca057e6 = new (0, $1m2je.UpcomingTransfersManager)($df84c4a387296a2d$export$dd1d8d38c51ee025, $df84c4a387296a2d$export$382ccb0adb6bd4f9);
const $df84c4a387296a2d$export$f94e93ca7c97f83d = new (0, $4Cchr.MandatesService)($df84c4a387296a2d$export$a12a659ed0b07a8e);
const $df84c4a387296a2d$export$7afd98e551592b4a = new (0, $fEQSP.MandatesManager)($df84c4a387296a2d$export$f94e93ca7c97f83d, $df84c4a387296a2d$export$382ccb0adb6bd4f9);
const $df84c4a387296a2d$export$60bf90924be66fe8 = new (0, $jV3Gu.MandateFilterManager)();

});
parcelRegister("3AGN4", function(module, exports) {

$parcel$export(module.exports, "AccountDeleteService", function () { return $8aeecd5df1f0f328$export$e6833a53cbb093bb; });

var $kqXxS = parcelRequire("kqXxS");

var $2Rggt = parcelRequire("2Rggt");
class $8aeecd5df1f0f328$export$e6833a53cbb093bb {
    constructor(clientManager, connectedApiService){
        this.clientManager = clientManager;
        this.connectedApiService = connectedApiService;
    }
    buildLinkEmail(email) {
        let url = `mailto:${email}`;
        const client = this.clientManager.client.get();
        if (client) {
            const username = (0, $2Rggt.clientMailName)(client);
            const subject = (0, $kqXxS.i18NManager).formatMessage("accountDeleteMail.subject", {
                username: username
            });
            const intl = (0, $kqXxS.i18NManager).intl.get();
            let body = intl.formatDate(Date(), {
                year: "numeric",
                month: "long",
                day: "numeric"
            }) + "\n";
            body += "\n" + (0, $kqXxS.i18NManager).formatMessage("accountDeleteMail.body") + "\n";
            body += "\n" + username;
            if (client.contactphone) body += "\n" + client.contactphone;
            if (client.email) body += "\n" + client.email;
            if (subject) url += "?subject=" + subject;
            if (body) url += "&body=" + encodeURIComponent(body);
        }
        return url;
    }
    async deleteAccount(identityId, reason) {
        const client = this.clientManager.client.get();
        if (client) try {
            const response = await this.connectedApiService.instance.put(`/identities/${identityId}/required-actions`, {
                requiredActionType: "ACCOUNT_CLOSURE_REQUEST",
                reason: reason
            });
            return response.data;
        } catch (e) {
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});
parcelRegister("2Rggt", function(module, exports) {

$parcel$export(module.exports, "ClientStatus", function () { return $5914f9dce56098d5$export$c9f880587597a98; });
$parcel$export(module.exports, "useClientDisplayName", function () { return $5914f9dce56098d5$export$5fded874273c4ae3; });
$parcel$export(module.exports, "clientMailName", function () { return $5914f9dce56098d5$export$6e242de2db69006e; });

var $6uYXW = parcelRequire("6uYXW");
var $5914f9dce56098d5$export$c9f880587597a98 = /*#__PURE__*/ function(ClientStatus) {
    ClientStatus["Initiated"] = "INITIATED";
    ClientStatus["Pending"] = "PENDING";
    ClientStatus["Opened"] = "OPENED";
    ClientStatus["Blocked"] = "BLOCKED";
    ClientStatus["Closed"] = "CLOSED";
    ClientStatus["Iniblocked"] = "INIBLOCKED";
    return ClientStatus;
}({});
function $5914f9dce56098d5$export$5fded874273c4ae3(client, withoutMaidenName) {
    return (0, $6uYXW.useMemo)(()=>{
        let result = "";
        if (client && client.label) return client.label;
        else if (client) {
            const maidenName = !withoutMaidenName && client.maidenName ? `(${client.maidenName})` : "";
            result = [
                client.firstName,
                client.lastName,
                client.postName,
                maidenName
            ].filter(Boolean).join(" ");
        }
        return result;
    }, [
        client,
        withoutMaidenName
    ]);
}
function $5914f9dce56098d5$export$6e242de2db69006e(client) {
    let result = "";
    if (client) {
        result = [
            client.firstName?.trim(),
            client.lastName?.trim(),
            client.postName?.trim()
        ].filter(Boolean).join(" ");
        if (client.maidenName) result += ` (${client.maidenName.trim()})`;
    }
    return result;
}

});


parcelRegister("7wYYD", function(module, exports) {

$parcel$export(module.exports, "WebAuthExecutor", function () { return $765bb667376e1df0$export$89cbb9b98724ea48; });

var $6JVVB = parcelRequire("6JVVB");

var $aEtmU = parcelRequire("aEtmU");

var $3Ersk = parcelRequire("3Ersk");
class $765bb667376e1df0$export$89cbb9b98724ea48 {
    constructor(authenticationManager, configurationManager){
        this.authenticationManager = authenticationManager;
        this.configurationManager = configurationManager;
        this.isConnecting = new (0, $3Ersk.Observable)(false);
    }
    async authenticateFromRedirect(code, state) {
        try {
            this.isConnecting.set(true);
            await this.authenticationManager.connectWithCodeGrant(code, state);
            this.authenticationManager.setIsAuthenticated(true);
        } catch (e) {
            (0, $6JVVB.logger).error(e);
            await this.authenticationManager.logout();
        } finally{
            this.isConnecting.set(false);
        }
    }
    async validateRegisterOtp(phoneNumber, registeringParameters) {
        if (this.configurationManager.configuration.get().authentication_mode === (0, $aEtmU.AuthenticationMode).PhonePincode) return await this.authenticationManager.validateRegisterOtp(registeringParameters);
        else await this.connect(phoneNumber, registeringParameters);
    }
    async connect(phoneNumber, registeringParameters) {
        if (this.configurationManager.configuration.get().authentication_mode === (0, $aEtmU.AuthenticationMode).LoginPassword) return await this.connectWithUsernameAndPassword(phoneNumber, registeringParameters);
    }
    withPhoneNumberAndPinCode() {
        return this.configurationManager.configuration.get().authentication_mode === (0, $aEtmU.AuthenticationMode).PhonePincode;
    }
    async connectWithUsernameAndPassword(phoneNumber, registeringParameters) {
        await this.authenticationManager.connect(phoneNumber?.number.substring(1), registeringParameters);
    }
}

});
parcelRegister("6JVVB", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $2c1f7f053a48ce04$export$af88d00dbe7f521; });
parcelRequire("e0gj7");
var $7W182 = parcelRequire("7W182");
var $gPpiR = parcelRequire("gPpiR");
var $9LrKb = parcelRequire("9LrKb");

var $dhPTb = parcelRequire("dhPTb");
const $2c1f7f053a48ce04$var$loggingEnabled = (0, $dhPTb.Config).LOGGING_ENABLED;
const $2c1f7f053a48ce04$export$80b9203a431b249f = $2c1f7f053a48ce04$var$loggingEnabled ? new (0, $gPpiR.DefaultLoggerManagerBuilder)().withLevel((0, $9LrKb.LogLevel).DEBUG).withConsoleAppender(new (0, $7W182.ConsoleFormatter)()).build() : new (0, $gPpiR.DefaultLoggerManagerBuilder)().withLevel((0, $9LrKb.LogLevel).ERROR).withConsoleAppender(new (0, $7W182.ConsoleFormatter)()).build();
const $2c1f7f053a48ce04$export$af88d00dbe7f521 = $2c1f7f053a48ce04$export$80b9203a431b249f.getLogger();

});
parcelRegister("e0gj7", function(module, exports) {
$parcel$export(module.exports, "LogLevel", function () { return (parcelRequire("9LrKb")).LogLevel; });
$parcel$export(module.exports, "ConsoleFormatter", function () { return (parcelRequire("7W182")).ConsoleFormatter; });
$parcel$export(module.exports, "DefaultLoggerManagerBuilder", function () { return (parcelRequire("gPpiR")).DefaultLoggerManagerBuilder; });
parcelRequire("9LrKb");
parcelRequire("jb8tq");
parcelRequire("e2GyU");
parcelRequire("drKae");
parcelRequire("1CsTL");

});
parcelRegister("9LrKb", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $71be0633a8b09dab$export$243e62d78d3b544d; });
function $71be0633a8b09dab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
let $71be0633a8b09dab$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["TRACE"] = 0] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})($71be0633a8b09dab$export$243e62d78d3b544d || ($71be0633a8b09dab$export$243e62d78d3b544d = {}));
class $71be0633a8b09dab$export$be953b15647cd6f2 {
    constructor(date, sender, level, args){
        $71be0633a8b09dab$var$_defineProperty(this, "date", void 0);
        $71be0633a8b09dab$var$_defineProperty(this, "sender", void 0);
        $71be0633a8b09dab$var$_defineProperty(this, "level", void 0);
        $71be0633a8b09dab$var$_defineProperty(this, "args", void 0);
        this.date = date;
        this.sender = sender;
        this.level = level;
        this.args = args;
    }
}

});

parcelRegister("jb8tq", function(module, exports) {

$parcel$export(module.exports, "DefaultFormatter", function () { return (parcelRequire("dIPqw")).DefaultFormatter; });
$parcel$export(module.exports, "ConsoleFormatter", function () { return (parcelRequire("7W182")).ConsoleFormatter; });

var $dIPqw = parcelRequire("dIPqw");

var $7W182 = parcelRequire("7W182");

var $9iTMp = parcelRequire("9iTMp");

});
parcelRegister("dIPqw", function(module, exports) {

$parcel$export(module.exports, "DefaultFormatter", function () { return $9fd746b5acc23377$export$2e59aff1353774eb; });

var $9LrKb = parcelRequire("9LrKb");
class $9fd746b5acc23377$export$2e59aff1353774eb {
    logToString(event) {
        if (event.args.length > 0) return "".concat(event.date.toISOString(), " [").concat((0, $9LrKb.LogLevel)[event.level], "] ").concat(event.sender, ": ").concat(this.toMessage(event.args));
        else return "".concat(event.date.toISOString(), " [").concat((0, $9LrKb.LogLevel)[event.level], "] ").concat(event.sender);
    }
    toMessage(args) {
        return args.reduce((prev, v)=>{
            if (!v) return prev;
            return prev ? "".concat(prev, ", ").concat(v) : v;
        });
    }
}

});

parcelRegister("7W182", function(module, exports) {

$parcel$export(module.exports, "ConsoleFormatter", function () { return $5c6ed34eac3c7a14$export$569a8a8c2cf8f583; });

var $l1qT9 = parcelRequire("l1qT9");

var $9LrKb = parcelRequire("9LrKb");
class $5c6ed34eac3c7a14$export$569a8a8c2cf8f583 {
    logToString(event) {
        return "[".concat((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(event.date).format("HH:mm:ss"), "][").concat((0, $9LrKb.LogLevel)[event.level], "] ").concat(event.sender);
    }
}

});
parcelRegister("l1qT9", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias('month', 'M');
    // PRIORITY
    addUnitPriority('month', 8);
    // PARSING
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // ALIASES
    addUnitAlias('year', 'y');
    // PRIORITIES
    addUnitPriority('year', 1);
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // ALIASES
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    // PRIORITIES
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    // PARSING
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // ALIASES
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // ALIASES
    addUnitAlias('hour', 'h');
    // PRIORITY
    addUnitPriority('hour', 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    // PRIORITY
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // ALIASES
    addUnitAlias('quarter', 'Q');
    // PRIORITY
    addUnitPriority('quarter', 7);
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // ALIASES
    addUnitAlias('date', 'D');
    // PRIORITY
    addUnitPriority('date', 9);
    // PARSING
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // ALIASES
    addUnitAlias('dayOfYear', 'DDD');
    // PRIORITY
    addUnitPriority('dayOfYear', 4);
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // ALIASES
    addUnitAlias('minute', 'm');
    // PRIORITY
    addUnitPriority('minute', 14);
    // PARSING
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // ALIASES
    addUnitAlias('second', 's');
    // PRIORITY
    addUnitPriority('second', 15);
    // PARSING
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias('millisecond', 'ms');
    // PRIORITY
    addUnitPriority('millisecond', 16);
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y');
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


parcelRegister("9iTMp", function(module, exports) {

var $l1qT9 = parcelRequire("l1qT9");
class $6c6110327787d51c$export$cc5f163b96ebbf1a {
    logToString(event) {
        if (event.args.length > 0) return "[".concat((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(event.date).format("HH:mm:ss"), "] ").concat(event.sender, ": ").concat(this.toMessage(event.args));
        else return "[".concat((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(event.date).format("HH:mm:ss"), "] ").concat(event.sender);
    }
    toMessage(args) {
        return args.reduce((prev, v)=>{
            if (!v) return prev;
            return prev ? "".concat(prev, ", ").concat(v) : v;
        });
    }
}

});


parcelRegister("e2GyU", function(module, exports) {

$parcel$export(module.exports, "ConsoleAppender", function () { return (parcelRequire("kRI6L")).ConsoleAppender; });
$parcel$export(module.exports, "MemoryAppender", function () { return (parcelRequire("8Fomi")).MemoryAppender; });

var $ivIKc = parcelRequire("ivIKc");

var $kRI6L = parcelRequire("kRI6L");

var $8Fomi = parcelRequire("8Fomi");

});
parcelRegister("ivIKc", function(module, exports) {

$parcel$export(module.exports, "AbstractAppender", function () { return $d79dd48050218a6e$export$676b9f08fa7d172b; });
function $d79dd48050218a6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $d79dd48050218a6e$export$676b9f08fa7d172b {
    constructor(formatter){
        $d79dd48050218a6e$var$_defineProperty(this, "formatter", void 0);
        $d79dd48050218a6e$var$_defineProperty(this, "isInitialized", false);
        this.formatter = formatter;
    }
    init() {
        this.isInitialized = true;
        return Promise.resolve();
    }
}

});

parcelRegister("kRI6L", function(module, exports) {

$parcel$export(module.exports, "ConsoleAppender", function () { return $f30af8d8ef9417ae$export$e5a30aa3d28b26e2; });

var $9LrKb = parcelRequire("9LrKb");

var $ivIKc = parcelRequire("ivIKc");
class $f30af8d8ef9417ae$export$e5a30aa3d28b26e2 extends (0, $ivIKc.AbstractAppender) {
    constructor(formatter){
        super(formatter);
    }
    append(event) {
        const msg = this.formatter.logToString(event);
        if (event.level >= (0, $9LrKb.LogLevel).WARN) console.warn(msg, ...event.args);
        else console.log(msg, ...event.args);
    }
}

});

parcelRegister("8Fomi", function(module, exports) {

$parcel$export(module.exports, "MemoryAppender", function () { return $64f50c2fc920e041$export$af8c5a30b4b9e14e; });

var $ivIKc = parcelRequire("ivIKc");
function $64f50c2fc920e041$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $64f50c2fc920e041$export$af8c5a30b4b9e14e extends (0, $ivIKc.AbstractAppender) {
    constructor(formatter, memoryStorage){
        super(formatter);
        $64f50c2fc920e041$var$_defineProperty(this, "memoryStorage", void 0);
        this.memoryStorage = memoryStorage;
    }
    append(event) {
        this.memoryStorage.add(event.level, this.formatter.logToString(event));
    }
}

});


parcelRegister("drKae", function(module, exports) {

var $b9ySY = parcelRequire("b9ySY");

});
parcelRegister("b9ySY", function(module, exports) {
function $81eb98888b58a71a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $81eb98888b58a71a$export$d7392285c701ecf5 {
    constructor(){
        $81eb98888b58a71a$var$_defineProperty(this, "logs", []);
    }
    add(level, message) {
        this.logs.push({
            level: level,
            message: message
        });
    }
    getLogs() {
        return this.logs;
    }
}

});


parcelRegister("1CsTL", function(module, exports) {

$parcel$export(module.exports, "DefaultLoggerManagerBuilder", function () { return (parcelRequire("gPpiR")).DefaultLoggerManagerBuilder; });

var $1vpoP = parcelRequire("1vpoP");

var $gmi9T = parcelRequire("gmi9T");

var $gPpiR = parcelRequire("gPpiR");

var $5l53i = parcelRequire("5l53i");

});
parcelRegister("1vpoP", function(module, exports) {

$parcel$export(module.exports, "DefaultLogger", function () { return $118c63842422bb71$export$8a1772861f98f91c; });

var $9LrKb = parcelRequire("9LrKb");
function $118c63842422bb71$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $118c63842422bb71$export$8a1772861f98f91c {
    constructor(manager){
        $118c63842422bb71$var$_defineProperty(this, "manager", void 0);
        this.manager = manager;
    }
    trace(...args) {
        this.log((0, $9LrKb.LogLevel).TRACE, args);
    }
    debug(...args) {
        this.log((0, $9LrKb.LogLevel).DEBUG, args);
    }
    info(...args) {
        this.log((0, $9LrKb.LogLevel).INFO, args);
    }
    warn(...args) {
        this.log((0, $9LrKb.LogLevel).WARN, args);
    }
    error(...args) {
        this.log((0, $9LrKb.LogLevel).ERROR, args);
    }
    isDebugEnabled() {
        return this.manager.getLevel() >= (0, $9LrKb.LogLevel).DEBUG;
    }
    isTraceEnabled() {
        return this.manager.getLevel() === (0, $9LrKb.LogLevel).TRACE;
    }
    log(level, args) {
        if (level < this.manager.getLevel()) return;
        const sender = args.shift();
        this.manager.getAppenders().forEach((appender)=>{
            try {
                appender.append({
                    date: new Date(),
                    sender: sender,
                    level: level,
                    args: args
                });
            } catch (err) {
                console.warn("DefaultLogger - cannot append log", err);
            }
        });
    }
}

});

parcelRegister("gmi9T", function(module, exports) {

$parcel$export(module.exports, "DefaultLoggerManager", function () { return $be8cc94d745ea949$export$c8b08de1a9d98060; });

var $9LrKb = parcelRequire("9LrKb");

var $5l53i = parcelRequire("5l53i");
function $be8cc94d745ea949$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $be8cc94d745ea949$export$c8b08de1a9d98060 {
    constructor(initialLevel, appenders, loggerProvider){
        $be8cc94d745ea949$var$_defineProperty(this, "appenders", []);
        $be8cc94d745ea949$var$_defineProperty(this, "currentLevel", (0, $9LrKb.LogLevel).INFO);
        $be8cc94d745ea949$var$_defineProperty(this, "loggerProvider", void 0);
        this.currentLevel = initialLevel;
        this.appenders = appenders;
        this.loggerProvider = loggerProvider;
    }
    async init() {
        for (const appender of this.appenders)await appender.init();
    }
    addAppender(appender) {
        this.appenders.push(appender);
    }
    getAppenders() {
        return this.appenders;
    }
    getLogger(sender) {
        const logger = this.loggerProvider(this);
        return !!sender ? new (0, $5l53i.WithSender)(logger, sender) : logger;
    }
    getLevel() {
        return this.currentLevel;
    }
    setLevel(level) {
        this.currentLevel = level;
    }
    isDebugEnabled() {
        return this.currentLevel >= (0, $9LrKb.LogLevel).DEBUG;
    }
    isTraceEnabled() {
        return this.currentLevel === (0, $9LrKb.LogLevel).TRACE;
    }
}

});
parcelRegister("5l53i", function(module, exports) {

$parcel$export(module.exports, "WithSender", function () { return $3e32d52c1fde429c$export$a9bb129335edc84; });
function $3e32d52c1fde429c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $3e32d52c1fde429c$export$a9bb129335edc84 {
    constructor(logger, sender){
        $3e32d52c1fde429c$var$_defineProperty(this, "logger", void 0);
        $3e32d52c1fde429c$var$_defineProperty(this, "sender", void 0);
        this.logger = logger;
        this.sender = sender;
    }
    trace(...args) {
        this.logger.trace(this.sender, ...args);
    }
    debug(...args) {
        this.logger.debug(this.sender, ...args);
    }
    info(...args) {
        this.logger.info(this.sender, ...args);
    }
    warn(...args) {
        this.logger.warn(this.sender, ...args);
    }
    error(...args) {
        this.logger.error(this.sender, ...args);
    }
    isDebugEnabled() {
        return this.logger.isDebugEnabled();
    }
    isTraceEnabled() {
        return this.logger.isTraceEnabled();
    }
}

});


parcelRegister("gPpiR", function(module, exports) {

$parcel$export(module.exports, "DefaultLoggerManagerBuilder", function () { return $c405097239525d6c$export$70688ba27dd04043; });
parcelRequire("e2GyU");
var $kRI6L = parcelRequire("kRI6L");
var $8Fomi = parcelRequire("8Fomi");
parcelRequire("jb8tq");
var $dIPqw = parcelRequire("dIPqw");

var $9LrKb = parcelRequire("9LrKb");

var $gmi9T = parcelRequire("gmi9T");

var $1vpoP = parcelRequire("1vpoP");
function $c405097239525d6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $c405097239525d6c$export$70688ba27dd04043 {
    constructor(){
        $c405097239525d6c$var$_defineProperty(this, "_appenders", []);
        $c405097239525d6c$var$_defineProperty(this, "_level", (0, $9LrKb.LogLevel).DEBUG);
        $c405097239525d6c$var$_defineProperty(this, "_formatter", new (0, $dIPqw.DefaultFormatter)());
    }
    get formatter() {
        return this._formatter;
    }
    get level() {
        return this._level;
    }
    get appenders() {
        return this._appenders;
    }
    withLevel(level) {
        this._level = level;
        return this;
    }
    withFormatter(formatter) {
        this._formatter = formatter;
        return this;
    }
    withConsoleAppender(formatter) {
        this._appenders.push(new (0, $kRI6L.ConsoleAppender)(formatter !== null && formatter !== void 0 ? formatter : this.formatter));
        return this;
    }
    withMemoryAppender(memoryStorage, formatter) {
        this._appenders.push(new (0, $8Fomi.MemoryAppender)(formatter !== null && formatter !== void 0 ? formatter : this.formatter, memoryStorage));
        return this;
    }
    withAppender(appender) {
        this._appenders.push(appender);
        return this;
    }
    build() {
        const provider = (manager)=>new (0, $1vpoP.DefaultLogger)(manager);
        return new (0, $gmi9T.DefaultLoggerManager)(this.level, this._appenders, provider);
    }
}

});




parcelRegister("aEtmU", function(module, exports) {

$parcel$export(module.exports, "AuthenticationMode", function () { return $b8ffead2bd04855f$export$28a644eddded983a; });
$parcel$export(module.exports, "CONFIGURATION_MEDIA", function () { return $b8ffead2bd04855f$export$5d8a3fbd8acec35d; });
var $b8ffead2bd04855f$export$28a644eddded983a = /*#__PURE__*/ function(AuthenticationMode) {
    AuthenticationMode["LoginPassword"] = "login_password";
    AuthenticationMode["PhonePincode"] = "phone_pincode";
    return AuthenticationMode;
}({});
var $b8ffead2bd04855f$export$5d8a3fbd8acec35d = /*#__PURE__*/ function(CONFIGURATION_MEDIA) {
    CONFIGURATION_MEDIA["M_WALLET"] = "mwallet";
    CONFIGURATION_MEDIA["WEB_CLIENT"] = "webclient";
    return CONFIGURATION_MEDIA;
}({});

});

parcelRegister("3Ersk", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $a91db54abdd420a7$export$77cea355fa80b5f4; });
$parcel$export(module.exports, "useObservable", function () { return $a91db54abdd420a7$export$262b072b280a540c; });

var $kpnq8 = parcelRequire("kpnq8");

var $6uYXW = parcelRequire("6uYXW");
class $a91db54abdd420a7$var$BaseObservable {
    constructor(val){
        this._val = val;
    }
    get() {
        return this._val;
    }
}
class $a91db54abdd420a7$export$77cea355fa80b5f4 extends $a91db54abdd420a7$var$BaseObservable {
    get onChange() {
        return this._onChange;
    }
    set(val) {
        if (this._val !== val) {
            this._val = val;
            this._onChange.dispatch(val);
        }
    }
    constructor(...args){
        super(...args), this._onChange = new (0, $kpnq8.Signal)();
    }
}
function $a91db54abdd420a7$export$262b072b280a540c(observable) {
    const [value, setValue] = (0, $6uYXW.useState)(observable.get());
    (0, $6uYXW.useEffect)(()=>{
        observable.onChange.add(setValue);
        if (observable.get() !== value) setValue(observable.get());
        return ()=>observable.onChange.remove(setValue);
    }, [
        observable,
        value
    ]);
    return value;
}

});
parcelRegister("kpnq8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dCczm = parcelRequire("dCczm");
module.exports.Signal = $dCczm.Signal;

var $kXZ6a = parcelRequire("kXZ6a");
module.exports.ExtendedSignal = $kXZ6a.ExtendedSignal;

var $5l9WE = parcelRequire("5l9WE");
module.exports.ValueCache = $5l9WE.ValueCache;
module.exports.CollectionCache = $5l9WE.CollectionCache;

});
parcelRegister("dCczm", function(module, exports) {
"use strict";
var $9e98930171b0768a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kXZ6a = parcelRequire("kXZ6a");
var $9e98930171b0768a$var$Signal = /** @class */ function(_super) {
    $9e98930171b0768a$var$__extends(Signal, _super);
    function Signal() {
        var _this = _super.call(this, {
            add: function(listener) {
                _this._listeners.add(listener);
            },
            remove: function(listener) {
                _this._listeners.delete(listener);
            }
        }) || this;
        _this._listeners = new Set();
        _this._instanceDefaultListener = function(payload) {
            return Signal._staticDefaultListener(payload);
        };
        return _this;
    }
    Signal.setDefaultListener = function(listener) {
        Signal._staticDefaultListener = listener;
    };
    Signal.prototype.dispatch = function(payload) {
        if (this._listeners.size === 0) {
            var instanceDefaultListener = this._instanceDefaultListener;
            instanceDefaultListener(payload);
            return;
        }
        this._listeners.forEach(function(callback) {
            return callback.call(undefined, payload);
        });
    };
    Signal.prototype.setDefaultListener = function(listener) {
        this._instanceDefaultListener = listener;
    };
    Signal._staticDefaultListener = function() {
    // default static listener is a noop
    };
    return Signal;
}($kXZ6a.ExtendedSignal);
module.exports.Signal = $9e98930171b0768a$var$Signal;

});
parcelRegister("kXZ6a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $SnVMD = parcelRequire("SnVMD");
var $f438b631db569968$var$ExtendedSignal = /** @class */ function() {
    function ExtendedSignal(_baseSignal) {
        this._baseSignal = _baseSignal;
        this._tagMap = new $SnVMD.TagMap();
    }
    ExtendedSignal.merge = function() {
        var signals = [];
        for(var _i = 0; _i < arguments.length; _i++)signals[_i] = arguments[_i];
        var listeners = new Map();
        return new ExtendedSignal({
            add: function(listener) {
                var newListener = function(payload) {
                    return listener(payload);
                };
                listeners.set(listener, newListener);
                signals.forEach(function(signal) {
                    return signal.add(newListener);
                });
            },
            remove: function(listener) {
                var newListener = listeners.get(listener);
                listeners.delete(listener);
                signals.forEach(function(signal) {
                    return signal.remove(newListener);
                });
            }
        });
    };
    ExtendedSignal.promisify = function(resolveSignal, rejectSignal) {
        return new Promise(function(resolve, reject) {
            function clearListeners() {
                resolveSignal.remove(completeResolution);
                if (rejectSignal) rejectSignal.remove(completeRejection);
            }
            function completeRejection(payload) {
                clearListeners();
                reject(payload);
            }
            function completeResolution(payload) {
                clearListeners();
                resolve(payload);
            }
            resolveSignal.add(completeResolution);
            if (rejectSignal) rejectSignal.add(completeRejection);
        });
    };
    ExtendedSignal.prototype.add = function(listener) {
        var tags = [];
        for(var _i = 1; _i < arguments.length; _i++)tags[_i - 1] = arguments[_i];
        var _a;
        (_a = this._tagMap).setListeners.apply(_a, [
            listener
        ].concat(tags));
        this._baseSignal.add(listener);
    };
    ExtendedSignal.prototype.remove = function(listenerOrTag) {
        var _this = this;
        this._tagMap.getListeners(listenerOrTag).forEach(function(taggedListener) {
            _this._baseSignal.remove(taggedListener);
            _this._tagMap.clearListener(taggedListener);
        });
        this._baseSignal.remove(listenerOrTag);
        this._tagMap.clearListener(listenerOrTag);
    };
    ExtendedSignal.prototype.addOnce = function(listener) {
        var _this = this;
        var tags = [];
        for(var _i = 1; _i < arguments.length; _i++)tags[_i - 1] = arguments[_i];
        var _a;
        // to match the set behavior of add, only add the listener if the listener is not already
        // registered, don't add the same listener twice
        if (this._tagMap.getListeners(listener).size > 0) return;
        var oneTimeListener = function(payload) {
            _this._baseSignal.remove(oneTimeListener);
            listener(payload);
        };
        (_a = this._tagMap).setListeners.apply(_a, [
            oneTimeListener,
            listener
        ].concat(tags));
        this._baseSignal.add(oneTimeListener);
    };
    ExtendedSignal.prototype.filter = function(filter) {
        return $f438b631db569968$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                if (filter(payload)) listener(payload);
            };
        });
    };
    ExtendedSignal.prototype.map = function(transform) {
        return $f438b631db569968$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                return listener(transform(payload));
            };
        });
    };
    ExtendedSignal.prototype.merge = function() {
        var signals = [];
        for(var _i = 0; _i < arguments.length; _i++)signals[_i] = arguments[_i];
        return ExtendedSignal.merge.apply(ExtendedSignal, [
            this._baseSignal
        ].concat(signals));
    };
    ExtendedSignal.prototype.promisify = function(rejectSignal) {
        return ExtendedSignal.promisify(this._baseSignal, rejectSignal);
    };
    ExtendedSignal.prototype.readOnly = function() {
        return $f438b631db569968$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                return listener(payload);
            };
        });
    };
    ExtendedSignal.prototype.reduce = function(accumulator, initialValue) {
        return $f438b631db569968$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function() {
                var accum = initialValue;
                return function(payload) {
                    accum = accumulator(accum, payload);
                    listener(accum);
                };
            }();
        });
    };
    ExtendedSignal.prototype.peek = function(peekaboo) {
        return $f438b631db569968$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                peekaboo(payload);
                listener(payload);
            };
        });
    };
    ExtendedSignal.prototype.cache = function(cache) {
        this._baseSignal.add(function(payload) {
            return cache.add(payload);
        });
        return $f438b631db569968$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                return listener(payload);
            };
        }, function(listener, listenerActive) {
            cache.forEach(function(payload) {
                if (listenerActive()) listener(payload);
            });
        });
    };
    return ExtendedSignal;
}();
module.exports.ExtendedSignal = $f438b631db569968$var$ExtendedSignal;
/**
 * Provides a new signal, with its own set of listeners, and the ability to transform listeners that
 * are added to the new signal.
 */ function $f438b631db569968$var$convertedListenerSignal(baseSignal, convertListener, postAddHook) {
    var listenerMap = new Map();
    return new $f438b631db569968$var$ExtendedSignal({
        add: function(listener) {
            var newListener = convertListener(listener);
            listenerMap.set(listener, newListener);
            baseSignal.add(newListener);
            if (postAddHook) postAddHook(listener, function() {
                return listenerMap.has(listener);
            });
        },
        remove: function(listener) {
            var newListener = listenerMap.get(listener);
            listenerMap.delete(listener);
            // TODO undefined ok in other case
            if (newListener !== undefined) baseSignal.remove(newListener);
        }
    });
}

});
parcelRegister("SnVMD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0a379b7500448f4e$var$TagMap = /** @class */ function() {
    function TagMap() {
        this._tagToListeners = new WeakMap();
        this._listenerToTags = new WeakMap();
    }
    TagMap.prototype.setListeners = function(listener) {
        var _this = this;
        var tags = [];
        for(var _i = 1; _i < arguments.length; _i++)tags[_i - 1] = arguments[_i];
        var tagSet = this._listenerToTags.get(listener) || new Set();
        tags.forEach(function(tag) {
            var listenerSet = _this._tagToListeners.get(tag) || new Set();
            listenerSet.add(listener);
            tagSet.add(tag);
            _this._tagToListeners.set(tag, listenerSet);
        });
        this._listenerToTags.set(listener, tagSet);
    };
    TagMap.prototype.getListeners = function(tag) {
        return this._tagToListeners.get(tag) || new Set();
    };
    TagMap.prototype.getTags = function(listener) {
        return this._listenerToTags.get(listener) || new Set();
    };
    TagMap.prototype.clearListener = function(listener) {
        var _this = this;
        var tags = this.getTags(listener);
        this._listenerToTags.delete(listener);
        tags.forEach(function(tag) {
            var listenerSet = _this.getListeners(tag);
            listenerSet.delete(listener);
            if (listenerSet.size === 0) _this._tagToListeners.delete(tag);
        });
    };
    return TagMap;
}();
module.exports.TagMap = $0a379b7500448f4e$var$TagMap;

});



parcelRegister("5l9WE", function(module, exports) {
"use strict";
var $3e36a0ccd352987e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3e36a0ccd352987e$var$ArrayCache = /** @class */ function() {
    function ArrayCache() {
        this._payloads = [];
    }
    ArrayCache.prototype.forEach = function(callback) {
        this._payloads.forEach(function(value) {
            return callback(value);
        });
    };
    return ArrayCache;
}();
module.exports.ArrayCache = $3e36a0ccd352987e$var$ArrayCache;
var $3e36a0ccd352987e$var$ValueCache = /** @class */ function(_super) {
    $3e36a0ccd352987e$var$__extends(ValueCache, _super);
    function ValueCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueCache.prototype.add = function(value) {
        this._payloads = [
            value
        ];
    };
    return ValueCache;
}($3e36a0ccd352987e$var$ArrayCache);
module.exports.ValueCache = $3e36a0ccd352987e$var$ValueCache;
var $3e36a0ccd352987e$var$CollectionCache = /** @class */ function(_super) {
    $3e36a0ccd352987e$var$__extends(CollectionCache, _super);
    function CollectionCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionCache.prototype.add = function(value) {
        this._payloads.push(value);
    };
    return CollectionCache;
}($3e36a0ccd352987e$var$ArrayCache);
module.exports.CollectionCache = $3e36a0ccd352987e$var$CollectionCache;

});




parcelRegister("bQGPR", function(module, exports) {

$parcel$export(module.exports, "LocalStorage", function () { return $b537bc841ae2d639$export$19fffca37ef3e106; });
class $b537bc841ae2d639$export$19fffca37ef3e106 {
    async read(key) {
        const data = window.localStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    }
    async store(data, key) {
        window.localStorage.setItem(key, JSON.stringify(data));
    }
    async clear(key) {
        window.localStorage.removeItem(key);
    }
}

});

parcelRegister("7nfAL", function(module, exports) {

$parcel$export(module.exports, "MemoryCache", function () { return $2ba076f6295916cb$export$67418a4e428ce890; });

var $l1qT9 = parcelRequire("l1qT9");

var $lNKLv = parcelRequire("lNKLv");
class $2ba076f6295916cb$export$67418a4e428ce890 {
    constructor(ttl, storageKey = "memory"){
        this.ttl = ttl;
        this.storageKey = storageKey;
        this.cacheEntry = new Map();
    }
    async read(key) {
        const value = this.cacheEntry.get(this.getStorageKey(key));
        return value?.data ?? null;
    }
    store(data, creation, key) {
        const entryCreation = creation ? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(creation) : (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))();
        this.cacheEntry.set(this.getStorageKey(key), {
            data: data,
            creation: entryCreation,
            ttl: this.ttl
        });
    }
    clear(key) {
        this.cacheEntry.delete(this.getStorageKey(key));
        return Promise.resolve();
    }
    async isValid(key) {
        const entry = await this.cacheEntry.get(this.getStorageKey(key));
        if (entry !== null) return (0, $lNKLv.isCacheValid)(entry);
        return false;
    }
    async readStatus(key) {
        const cacheEntry = await this.cacheEntry.get(this.getStorageKey(key));
        return cacheEntry ? {
            isValid: (0, $lNKLv.isCacheValid)(cacheEntry),
            creation: (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(cacheEntry.creation).toDate()
        } : null;
    }
    getStorageKey(key) {
        if (key !== "default") return `${this.storageKey}_${key}`;
        return this.storageKey;
    }
}

});
parcelRegister("lNKLv", function(module, exports) {

$parcel$export(module.exports, "isCacheValid", function () { return $18307a2b177e3d91$export$18779407bcf5be88; });

var $l1qT9 = parcelRequire("l1qT9");
function $18307a2b177e3d91$export$18779407bcf5be88(cache) {
    if (!cache) return false;
    const dataAge = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))().diff(cache.creation, "seconds");
    return dataAge < cache.ttl;
}

});


parcelRegister("3O0H7", function(module, exports) {

$parcel$export(module.exports, "SessionCache", function () { return $e90b4f814de6d0f4$export$22ed0e381bab4a72; });

var $l1qT9 = parcelRequire("l1qT9");

var $lNKLv = parcelRequire("lNKLv");

var $gV1ek = parcelRequire("gV1ek");
class $e90b4f814de6d0f4$export$22ed0e381bab4a72 {
    constructor(ttl, storageKey){
        this.ttl = ttl;
        this.storageKey = storageKey;
        this.sessionStorage = new (0, $gV1ek.SessionStorage)();
    }
    async read(key) {
        const value = await this.sessionStorage.read(this.getStorageKey(key));
        return value?.data ?? null;
    }
    store(data, creation, key) {
        const entryCreation = creation ? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(creation) : (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))();
        this.sessionStorage.store({
            data: data,
            creation: entryCreation,
            ttl: this.ttl
        }, this.getStorageKey(key));
    }
    clear(key) {
        return this.sessionStorage.clear(this.getStorageKey(key));
    }
    async isValid(key) {
        const entry = await this.sessionStorage.read(this.getStorageKey(key));
        if (entry !== null) return (0, $lNKLv.isCacheValid)(entry);
        return false;
    }
    async readStatus(key) {
        const cacheEntry = await this.sessionStorage.read(this.getStorageKey(key));
        return cacheEntry ? {
            isValid: (0, $lNKLv.isCacheValid)(cacheEntry),
            creation: (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(cacheEntry.creation).toDate()
        } : null;
    }
    getStorageKey(key) {
        if (key !== "default") return `${this.storageKey}_${key}`;
        return this.storageKey;
    }
}

});
parcelRegister("gV1ek", function(module, exports) {

$parcel$export(module.exports, "SessionStorage", function () { return $29e197ff0a9ab6ec$export$2c4b17e1c2e0931; });
class $29e197ff0a9ab6ec$export$2c4b17e1c2e0931 {
    async read(key) {
        const data = window.sessionStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    }
    async store(data, key) {
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }
    async clear(key) {
        window.sessionStorage.removeItem(key);
    }
}

});


parcelRegister("7agwe", function(module, exports) {

$parcel$export(module.exports, "WebTransactionGeolocalisationManager", function () { return $d03e9d0936aa85cf$export$28a23104689f14bd; });
class $d03e9d0936aa85cf$export$28a23104689f14bd {
    initialize() {
        return Promise.resolve();
    }
    requestActivation() {
        return Promise.resolve();
    }
    updatePosition() {
        return Promise.resolve(undefined);
    }
    getPosition() {
        return undefined;
    }
}

});

parcelRegister("ba55X", function(module, exports) {

$parcel$export(module.exports, "WebAppStartManager", function () { return $a46f2975db4ba216$export$b08a09558ece3151; });

var $6JVVB = parcelRequire("6JVVB");

var $aEtmU = parcelRequire("aEtmU");

var $3Ersk = parcelRequire("3Ersk");

var $22v9q = parcelRequire("22v9q");
const $a46f2975db4ba216$var$HAS_PROMPT_PINCODE_CHANGED_KEY = "has_prompt_pincode_changed";
class $a46f2975db4ba216$export$b08a09558ece3151 {
    constructor(configurationManager, i18nManager, authenticationManager, clientManager, sessionStorage){
        this.configurationManager = configurationManager;
        this.i18nManager = i18nManager;
        this.authenticationManager = authenticationManager;
        this.clientManager = clientManager;
        this.sessionStorage = sessionStorage;
        this.shouldPromptPincodeChange = new (0, $3Ersk.Observable)(false);
        this.addLoginTasks();
        this.notifyWhenClientMustChangePincode();
        this.notifyLocaleChange();
    }
    async startApp() {
        await this.initServices();
    }
    async initServices() {
        try {
            await Promise.all([
                this.authenticationManager.initialize(),
                this.configurationManager.load((0, $aEtmU.CONFIGURATION_MEDIA).WEB_CLIENT)
            ]);
        } catch (e) {
            await this.i18nManager.initialize(null);
            await this.authenticationManager.logout();
            (0, $6JVVB.logger).error("Error while initializing services", e);
        // window.location.reload();
        }
        (0, $22v9q.updateTheme)();
        await this.i18nManager.initialize(this.clientManager.client.get());
    }
    addLoginTasks() {
        // The signal fires on both edges. There is no holder to fetch on the way out, and the request
        // would be turned away by the connection check, rejecting with nobody left to hear it.
        this.authenticationManager.isConnected.onChange.add((isConnected)=>{
            if (!isConnected) return;
            this.clientManager.updateClient(true).catch((e)=>(0, $6JVVB.logger).debug("WebAppStartManager", "Failed to update the client on login", e));
        });
    }
    notifyWhenClientMustChangePincode() {
        this.clientManager.client.onChange.add(async (client)=>{
            if (client?.mustChangePincode) {
                const hasAlreadyPromptPincodeChange = await this.sessionStorage.read($a46f2975db4ba216$var$HAS_PROMPT_PINCODE_CHANGED_KEY);
                if (!hasAlreadyPromptPincodeChange) this.shouldPromptPincodeChange.set(true);
            }
        });
    }
    notifyLocaleChange() {
        this.clientManager.client.onChange.add(async (client)=>{
            const currentLocale = this.i18nManager.localeTag.get();
            if (client?.lang !== currentLocale) this.i18nManager.initialize(client);
        });
    }
    hasPromptPincodeChange() {
        this.shouldPromptPincodeChange.set(false);
        this.sessionStorage.store(true, $a46f2975db4ba216$var$HAS_PROMPT_PINCODE_CHANGED_KEY);
    }
}

});
parcelRegister("22v9q", function(module, exports) {

$parcel$export(module.exports, "fonts", function () { return $bd6885b749068c4a$export$f45fbea8fe20ca8a; });
$parcel$export(module.exports, "theme", function () { return $bd6885b749068c4a$export$bca14c5b3b88a9c9; });
$parcel$export(module.exports, "shadows", function () { return $bd6885b749068c4a$export$3eb26d38a832ce9a; });
$parcel$export(module.exports, "updateTheme", function () { return $bd6885b749068c4a$export$c663be6a18716c2; });

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $fRvTz = parcelRequire("fRvTz");
const $bd6885b749068c4a$export$f45fbea8fe20ca8a = {
    regular: {
        fontWeight: "normal"
    },
    // Lato has no Medium weight, so "medium" text styles fall back to bold, as they do on mobile.
    medium: {
        fontWeight: 700
    },
    bold: {
        fontWeight: "bold"
    },
    black: {
        fontWeight: 900
    }
};
const $bd6885b749068c4a$export$bca14c5b3b88a9c9 = {
    mediumText: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.medium
    },
    text: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.regular
    },
    boldText: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.bold
    },
    blackText: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.black
    },
    bodyBlackRegular: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.regular,
        fontSize: 15,
        color: "#000000"
    },
    bodyBlackBold: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.bold,
        fontSize: 15,
        color: "#000000"
    },
    bodyGreyRegular: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.regular,
        fontSize: 15,
        color: "#aaaaaa"
    },
    bodySmallGreyRegular: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.regular,
        fontSize: 13,
        color: "#aaaaaa"
    },
    bodyGreyDarkRegular: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.regular,
        fontSize: 15,
        color: "#626262"
    },
    bodySmallGreyDarkMedium: {
        ...$bd6885b749068c4a$export$f45fbea8fe20ca8a.medium,
        fontSize: 13,
        color: "#626262"
    },
    mainColor: ()=>(0, $kqXxS.configurationManager).getPrimaryColor(),
    brandGradient: "radial-gradient(54.16% 195.87% at 50.15% 30.28%, #003da5 0%, #022b72 100%)",
    mainColorLightBackground: ()=>(0, $kqXxS.configurationManager).getPrimaryColor() + "26",
    colors: {
        gray: {
            25: "#adadad",
            50: "#fafafa",
            100: "#f3f3f3",
            200: "#f0f0f0",
            300: "#e0e0e0",
            500: "#b1b1b1",
            700: "#626262",
            800: "#5a5a5a"
        },
        blue: {
            100: "#f7f8ff",
            200: "#def1ff",
            700: "#003da5",
            800: "#0b293e"
        },
        warning: {
            100: "#F5E9DA",
            300: "#FFECD1",
            500: "#FF9A03"
        },
        success: {
            100: "#E4EBDD",
            300: "#D1FFD1",
            500: "#81C241"
        },
        error: {
            100: "#FFD1D1",
            300: "#FFD1D1",
            500: "#EE161B"
        },
        info: {
            100: "#DBE4EC",
            300: "#B7D5F1",
            500: "#0D71CD"
        }
    }
};
const $bd6885b749068c4a$export$3eb26d38a832ce9a = {
    medium: (0, $jb8NR.css)`
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.05);
  `,
    small: (0, $jb8NR.css)`
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
  `,
    // The design system's shadow/sm, a hairline lift under the cards.
    sm: (0, $jb8NR.css)`
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  `
};
const $bd6885b749068c4a$export$c663be6a18716c2 = ()=>{
    const favicon = document.getElementById("favicon");
    const favicons = document.getElementsByClassName("custom-favicon");
    if (favicons && favicons?.length > 0) [].map.call(favicons, (element)=>{
        element.href = (0, $kqXxS.configurationManager).getFaviconUrl(element.getAttribute("sizes"));
    });
    else if (favicon) favicon.href = (0, $kqXxS.configurationManager).getFaviconUrl();
    (0, $fRvTz.StaticAssets).logo = (0, $kqXxS.configurationManager).getLogoUrl() ?? (0, $fRvTz.StaticAssets).logo;
    (0, $fRvTz.StaticAssets).registerImage = (0, $kqXxS.configurationManager).getRegisterImageUrl() ?? (0, $fRvTz.StaticAssets).registerImage;
    (0, $fRvTz.StaticAssets).carouselImages = (0, $kqXxS.configurationManager).getCarouselUrls() ?? (0, $fRvTz.StaticAssets).carouselImages;
};

});
parcelRegister("fRvTz", function(module, exports) {

$parcel$export(module.exports, "StaticAssets", function () { return $2463de001c798934$export$72dc6427e3a0913; });

var $dhPTb = parcelRequire("dhPTb");
const $2463de001c798934$var$toStaticImageUri = (filename)=>`/static/${filename}`;
const $2463de001c798934$var$toStaticImagesUri = (filenames)=>filenames.map($2463de001c798934$var$toStaticImageUri);
const $2463de001c798934$export$72dc6427e3a0913 = {
    carouselImages: $2463de001c798934$var$toStaticImagesUri((0, $dhPTb.Config).APP_CAROUSEL_IMAGES),
    registerImage: $2463de001c798934$var$toStaticImageUri((0, $dhPTb.Config).APP_REGISTER_IMAGE),
    logo: $2463de001c798934$var$toStaticImageUri((0, $dhPTb.Config).APP_LOGO_IMAGE),
    // Assets bundled with the app rather than provided per tenant. They are served from /static
    // because importing an image from JS does not resolve to its URL in this project.
    brandLogo: $2463de001c798934$var$toStaticImageUri("logo.svg"),
    fluxIncome: $2463de001c798934$var$toStaticImageUri("flux-income.svg"),
    fluxExpense: $2463de001c798934$var$toStaticImageUri("flux-expense.svg"),
    menuHouse: $2463de001c798934$var$toStaticImageUri("menu_house.svg"),
    menuCard: $2463de001c798934$var$toStaticImageUri("menu_card.svg"),
    menuProfile: $2463de001c798934$var$toStaticImageUri("menu_profil.svg"),
    countdown: $2463de001c798934$var$toStaticImageUri("countdown.svg"),
    warningCircle: $2463de001c798934$var$toStaticImageUri("warning_circle.svg"),
    confirmation: $2463de001c798934$var$toStaticImageUri("confirmation.svg"),
    copy: $2463de001c798934$var$toStaticImageUri("copy.svg"),
    download: $2463de001c798934$var$toStaticImageUri("download.svg"),
    share: $2463de001c798934$var$toStaticImageUri("share.svg"),
    cardNew: $2463de001c798934$var$toStaticImageUri("card_new.svg"),
    cardPincode: $2463de001c798934$var$toStaticImageUri("card_pincode.svg"),
    cardOpposition: $2463de001c798934$var$toStaticImageUri("card_opposition.svg"),
    cardLimits: $2463de001c798934$var$toStaticImageUri("card_limits.svg"),
    cardDetails: $2463de001c798934$var$toStaticImageUri("card_details.svg"),
    cardActivate: $2463de001c798934$var$toStaticImageUri("card_activate.svg"),
    justifyTransaction: $2463de001c798934$var$toStaticImageUri("justify_transaction.svg"),
    qualifyTransaction: $2463de001c798934$var$toStaticImageUri("qualify_transaction.svg"),
    justified: $2463de001c798934$var$toStaticImageUri("justified.svg"),
    eye: $2463de001c798934$var$toStaticImageUri("eye.svg"),
    trash: $2463de001c798934$var$toStaticImageUri("trash.svg"),
    close: $2463de001c798934$var$toStaticImageUri("close.svg"),
    profileProfile: $2463de001c798934$var$toStaticImageUri("profile_profile.svg"),
    profileSettings: $2463de001c798934$var$toStaticImageUri("profile_settings.svg"),
    settingsTalk: $2463de001c798934$var$toStaticImageUri("settings_talk.svg"),
    settingsPincode: $2463de001c798934$var$toStaticImageUri("settings_pincode.svg")
};

});



parcelRegister("cEBkf", function(module, exports) {

$parcel$export(module.exports, "WebNetworkInfoManager", function () { return $b784a786926f5256$export$c2d8974523d70ca9; });
class $b784a786926f5256$export$c2d8974523d70ca9 {
    hasInternet() {
        return Promise.resolve(true);
    }
    addHasInternettListener(listener) {
        listener(true);
        return ()=>null;
    }
}

});

parcelRegister("jtPvJ", function(module, exports) {

$parcel$export(module.exports, "WebSecuredCookiesService", function () { return $5dc823f939facd45$export$2630d7fab0f7bf30; });
class $5dc823f939facd45$export$2630d7fab0f7bf30 {
    getSecuredCookies() {
        return false;
    }
}

});

parcelRegister("fb0N8", function(module, exports) {

$parcel$export(module.exports, "CLIENT_CACHE_STORAGE_KEY", function () { return $510f177076d63a71$export$86d76b49a1baae2c; });
$parcel$export(module.exports, "ACCOUNTS_CACHE_STORAGE_KEY", function () { return $510f177076d63a71$export$f5a5a506d133f1f; });
$parcel$export(module.exports, "TRANSACTIONS_CACHE_STORAGE_KEY", function () { return $510f177076d63a71$export$bfd0b4cb697f0a41; });
$parcel$export(module.exports, "BENEFICIARIES_CACHE_STORAGE_KEY", function () { return $510f177076d63a71$export$efa17fe90ba503a9; });
$parcel$export(module.exports, "BILL_ISSUERS_CACHE_STORAGE_KEY", function () { return $510f177076d63a71$export$17c515527cd02941; });
const $510f177076d63a71$export$86d76b49a1baae2c = "client_cache";
const $510f177076d63a71$export$f5a5a506d133f1f = "accounts_cache";
const $510f177076d63a71$export$bfd0b4cb697f0a41 = "transactions_cache";
const $510f177076d63a71$export$a4089c6680fa8cc8 = "authorization_holds_cache";
const $510f177076d63a71$export$efa17fe90ba503a9 = "recipients_cache";
const $510f177076d63a71$export$17c515527cd02941 = "bill_issuers_cache";
const $510f177076d63a71$export$25ef63b1b2bf715 = "app_start_cache";

});

parcelRegister("3OBoX", function(module, exports) {

$parcel$export(module.exports, "WebTranslationsManager", function () { return $ded0f0eb20c29be3$export$f71bc71705d0c76a; });

var $Zv8Ce = parcelRequire("Zv8Ce");

var $iiBUf = parcelRequire("iiBUf");

var $6JVVB = parcelRequire("6JVVB");






class $ded0f0eb20c29be3$export$f71bc71705d0c76a {
    constructor(configurationManager, cacheLoader, i18NService){
        this.configurationManager = configurationManager;
        this.cacheLoader = cacheLoader;
        this.i18NService = i18NService;
        this.configuredLanguages = [];
        this.localTranslations = {
            en_US: ()=>(0, $Zv8Ce.flatten)((parcelRequire("eujvt"))),
            fr_FR: ()=>(0, $Zv8Ce.flatten)((parcelRequire("luMxq"))),
            es_ES: ()=>(0, $Zv8Ce.flatten)((parcelRequire("gqyt4"))),
            //NOT implemented, fallback to en_US
            ar_MA: ()=>(0, $Zv8Ce.flatten)((parcelRequire("irJAx"))),
            rn_BI: ()=>(0, $Zv8Ce.flatten)((parcelRequire("eujvt"))),
            af_NA: ()=>(0, $Zv8Ce.flatten)((parcelRequire("eujvt")))
        };
    }
    async loadTranslations(localeTag) {
        (0, $6JVVB.logger).debug("TranslationsManager", "fetching remote translation for", localeTag);
        const remoteTranslations = await this.cacheLoader.load(()=>this.i18NService.fetchTranslations(localeTag), false, localeTag);
        if (!remoteTranslations) throw new (0, $iiBUf.TranslationsNotLoadedError)("Fetch translations failed and not in cache");
        (0, $6JVVB.logger).debug("I18NManager", "fetched translation for", localeTag);
        Object.entries(remoteTranslations).forEach(([key, value])=>{
            const translationsNotEmpty = Object.fromEntries(Object.entries(value).filter(([_, v])=>v !== ""));
            remoteTranslations[key] = translationsNotEmpty;
        });
        return remoteTranslations;
    }
    getConfiguredLanguages() {
        return this.configurationManager.configuration.get().langs;
    }
}

});
parcelRegister("Zv8Ce", function(module, exports) {
module.exports = $0b8dd9f883a4c6f8$var$flatten;
$0b8dd9f883a4c6f8$var$flatten.flatten = $0b8dd9f883a4c6f8$var$flatten;
$0b8dd9f883a4c6f8$var$flatten.unflatten = $0b8dd9f883a4c6f8$var$unflatten;
function $0b8dd9f883a4c6f8$var$isBuffer(obj) {
    return obj && obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
function $0b8dd9f883a4c6f8$var$keyIdentity(key) {
    return key;
}
function $0b8dd9f883a4c6f8$var$flatten(target, opts) {
    opts = opts || {};
    const delimiter = opts.delimiter || '.';
    const maxDepth = opts.maxDepth;
    const transformKey = opts.transformKey || $0b8dd9f883a4c6f8$var$keyIdentity;
    const output = {};
    function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function(key) {
            const value = object[key];
            const isarray = opts.safe && Array.isArray(value);
            const type = Object.prototype.toString.call(value);
            const isbuffer = $0b8dd9f883a4c6f8$var$isBuffer(value);
            const isobject = type === '[object Object]' || type === '[object Array]';
            const newKey = prev ? prev + delimiter + transformKey(key) : transformKey(key);
            if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) return step(value, newKey, currentDepth + 1);
            output[newKey] = value;
        });
    }
    step(target);
    return output;
}
function $0b8dd9f883a4c6f8$var$unflatten(target, opts) {
    opts = opts || {};
    const delimiter = opts.delimiter || '.';
    const overwrite = opts.overwrite || false;
    const transformKey = opts.transformKey || $0b8dd9f883a4c6f8$var$keyIdentity;
    const result = {};
    const isbuffer = $0b8dd9f883a4c6f8$var$isBuffer(target);
    if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') return target;
    // safely ensure that the key is
    // an integer.
    function getkey(key) {
        const parsedKey = Number(key);
        return isNaN(parsedKey) || key.indexOf('.') !== -1 || opts.object ? key : parsedKey;
    }
    function addKeys(keyPrefix, recipient, target) {
        return Object.keys(target).reduce(function(result, key) {
            result[keyPrefix + delimiter + key] = target[key];
            return result;
        }, recipient);
    }
    function isEmpty(val) {
        const type = Object.prototype.toString.call(val);
        const isArray = type === '[object Array]';
        const isObject = type === '[object Object]';
        if (!val) return true;
        else if (isArray) return !val.length;
        else if (isObject) return !Object.keys(val).length;
    }
    target = Object.keys(target).reduce(function(result, key) {
        const type = Object.prototype.toString.call(target[key]);
        const isObject = type === '[object Object]' || type === '[object Array]';
        if (!isObject || isEmpty(target[key])) {
            result[key] = target[key];
            return result;
        } else return addKeys(key, result, $0b8dd9f883a4c6f8$var$flatten(target[key], opts));
    }, {});
    Object.keys(target).forEach(function(key) {
        const split = key.split(delimiter).map(transformKey);
        let key1 = getkey(split.shift());
        let key2 = getkey(split[0]);
        let recipient = result;
        while(key2 !== undefined){
            if (key1 === '__proto__') return;
            const type = Object.prototype.toString.call(recipient[key1]);
            const isobject = type === '[object Object]' || type === '[object Array]';
            // do not write over falsey, non-undefined values if overwrite is false
            if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') return;
            if (overwrite && !isobject || !overwrite && recipient[key1] == null) recipient[key1] = typeof key2 === 'number' && !opts.object ? [] : {};
            recipient = recipient[key1];
            if (split.length > 0) {
                key1 = getkey(split.shift());
                key2 = getkey(split[0]);
            }
        }
        // unflatten again for 'messy objects'
        recipient[key1] = $0b8dd9f883a4c6f8$var$unflatten(target[key], opts);
    });
    return result;
}

});

parcelRegister("iiBUf", function(module, exports) {

$parcel$export(module.exports, "TranslationsUpdateError", function () { return $e1042ffc804c1fd1$export$8512dd0081b65f89; });
$parcel$export(module.exports, "TranslationsNotLoadedError", function () { return $e1042ffc804c1fd1$export$f05f293051f7ba0e; });
class $e1042ffc804c1fd1$export$8512dd0081b65f89 extends Error {
    constructor(message){
        super(message);
    }
}
class $e1042ffc804c1fd1$export$f05f293051f7ba0e extends Error {
    constructor(message){
        super(message);
    }
}

});

parcelRegister("eujvt", function(module, exports) {
module.exports = JSON.parse('{"PARTY_AUTHENTICATION_SMS_OTP_ALREADY_SENT":"An SMS has already been sent to this phone number. Please wait a few minutes.","TRANSACTION_WITHDRAW_CODE_GENERATION_ERROR":"Withdrawal is not allowed for this transaction point","common":{"fileConstraints":{"formats":"Accepted formats","maxSize":"Maximum size","tooBig":"The file you picked is over the allowed size.","wrongType":"The format of the file you picked is not accepted.","openLabel":"Show the requirements for this file"},"fileField":{"sentOn":"Sent on {date}","sent":"Document sent"},"today":"Today","clear":"Clear","yesterday":"Yesterday","goBack":"Go back","languages":{"fr_FR":"Fran\xe7ais (France)","en_US":"English (USA)","es_ES":"Espa\xf1ol (Espa\xf1a)","af_NA":"Afrikaans (Namibia)","af_ZA":"Afrikaans (South Africa)","ak_CI":"Akan (C\xf4te d\u2019Ivoire)","ak_GH":"Akan (Ghana)","gn_PY":"Ava\xf1e\'\u1EBD","ay_BO":"Aymar aru","az_AZ":"Az\u0259rbaycan dili","id_ID":"Bahasa Indonesia","ms_MY":"Bahasa Melayu","ms_BN":"Bahasa Melayu (Brunei)","ms_CC":"Bahasa Melayu (Cocos (Keeling) Islands)","ms_SG":"Bahasa Melayu (Singapore)","bm_BF":"Bamanakan (Burkina Faso)","bm_CI":"Bamanakan (C\xf4te d\u2019Ivoire)","bm_GM":"Bamanakan (Gambia)","bm_ML":"Bamanakan (Mali)","jv_ID":"Basa Jawa","bh_IN":"Bihari (India)","bs_BA":"Bosanski","br_FR":"Brezhoneg (France)","ca_ES":"Catal\xe0","ca_AD":"Catal\xe0 (Andorra)","ce_RU":"Chechen (Russia)","sn_BW":"ChiShona (Botswana)","sn_MZ":"ChiShona (Mozambique)","sn_ZW":"ChiShona (Zimbabwe)","ht_GA":"Cr\xe9ole haitien (Grandans)","ht_OU":"Cr\xe9ole haitien (Lw\xe8s)","ht_NI":"Cr\xe9ole haitien (Nip)","ht_ND":"Cr\xe9ole haitien (N\xf2)","ht_NO":"Cr\xe9ole haitien (N\xf2dw\xe8s)","ht_NE":"Cr\xe9ole haitien (N\xf2d\xe8s)","ht_CE":"Cr\xe9ole haitien (Sant)","ht_SD":"Cr\xe9ole haitien (Sid)","ht_SE":"Cr\xe9ole haitien (Sid\xe8s)","cy_GB":"Cymraeg","cy_AR":"Cymraeg (Argentina)","da_DK":"Dansk","da_FO":"Dansk (Faroe Islands)","da_DE":"Dansk (Germany)","da_GL":"Dansk (Greenland)","fa_AF":"Dari","se_NO":"Davvis\xe1megiella","de_BE":"Deutsch (Belgium)","de_DK":"Deutsch (Denmark)","de_DE":"Deutsch (Deutschland)","de_FR":"Deutsch (France)","de_HU":"Deutsch (Hungary)","de_IT":"Deutsch (Italy)","de_LI":"Deutsch (Liechtenstein)","de_LU":"Deutsch (Luxembourg)","de_PL":"Deutsch (Poland)","de_CH":"Deutsch (Schweiz)","de_AT":"Deutsch (\xd6sterreich)","dv_MV":"Divehi (Maldives)","dz_BT":"Dzongkha (Bhutan)","et_EE":"Eesti (Estonia)","en_AS":"English (American Samoa)","en_AI":"English (Anguilla)","en_AG":"English (Antigua & Barbuda)","en_AU":"English (Australia)","en_BS":"English (Bahamas)","en_BB":"English (Barbados)","en_BE":"English (Belgium)","en_BZ":"English (Belize)","en_BM":"English (Bermuda)","en_BW":"English (Botswana)","en_IO":"English (British Indian Ocean Territory)","en_VG":"English (British Virgin Islands)","en_BN":"English (Brunei)","en_CM":"English (Cameroon)","en_CA":"English (Canada)","en_KY":"English (Cayman Islands)","en_CK":"English (Cook Islands)","en_DM":"English (Dominica)","en_ER":"English (Eritrea)","en_ET":"English (Ethiopia)","en_FK":"English (Falkland Islands)","en_FJ":"English (Fiji)","en_GM":"English (Gambia)","en_GH":"English (Ghana)","en_GI":"English (Gibraltar)","en_GD":"English (Grenada)","en_GU":"English (Guam)","en_GY":"English (Guyana)","en_HK":"English (Hong Kong SAR China)","en_IN":"English (India)","en_IE":"English (Ireland)","en_IL":"English (Israel)","en_JM":"English (Jamaica)","en_KE":"English (Kenya)","en_KI":"English (Kiribati)","en_LS":"English (Lesotho)","en_LR":"English (Liberia)","en_MW":"English (Malawi)","en_MT":"English (Malta)","en_MH":"English (Marshall Islands)","en_MU":"English (Mauritius)","en_FM":"English (Micronesia)","en_MS":"English (Montserrat)","en_NA":"English (Namibia)","en_NR":"English (Nauru)","en_NZ":"English (New Zealand)","en_NG":"English (Nigeria)","en_NU":"English (Niue)","en_NF":"English (Norfolk Island)","en_MP":"English (Northern Mariana Islands)","en_PK":"English (Pakistan)","en_PW":"English (Palau)","en_PG":"English (Papua New Guinea)","en_PH":"English (Philippines)","en_PI":"English (Pirate)","en_PN":"English (Pitcairn Islands)","en_PR":"English (Puerto Rico)","en_RW":"English (Rwanda)","en_WS":"English (Samoa)","en_SC":"English (Seychelles)","en_SL":"English (Sierra Leone)","en_SG":"English (Singapore)","en_SB":"English (Solomon Islands)","en_SO":"English (Somalia)","en_ZA":"English (South Africa)","en_SH":"English (St. Helena)","en_KN":"English (St. Kitts & Nevis)","en_LC":"English (St. Lucia)","en_VC":"English (St. Vincent & Grenadines)","en_SZ":"English (Swaziland)","en_TK":"English (Tokelau)","en_TO":"English (Tonga)","en_TT":"English (Trinidad & Tobago)","en_TC":"English (Turks & Caicos Islands)","en_UM":"English (U.S. Outlying Islands)","en_VI":"English (U.S. Virgin Islands)","en_GB":"English (UK)","en_UG":"English (Uganda)","en_UD":"English (Upside Down)","en_VU":"English (Vanuatu)","en_ZM":"English (Zambia)","en_ZW":"English (Zimbabwe)","es_AR":"Espa\xf1ol (Argentine)","es_BO":"Espa\xf1ol (Bolivia)","es_CL":"Espa\xf1ol (Chile)","es_CO":"Espa\xf1ol (Colombia)","es_CR":"Espa\xf1ol (Costa Rica)","es_CU":"Espa\xf1ol (Cuba)","es_DO":"Espa\xf1ol (Dominican Republic)","es_EC":"Espa\xf1ol (Ecuador)","es_SV":"Espa\xf1ol (El Salvador)","es_GQ":"Espa\xf1ol (Equatorial Guinea)","es_US":"Espa\xf1ol (Estados Unidos)","es_GT":"Espa\xf1ol (Guatemala)","es_HN":"Espa\xf1ol (Honduras)","es_LA":"Espa\xf1ol (Latinoam\xe9rica)","es_MX":"Espa\xf1ol (M\xe9xico)","es_NI":"Espa\xf1ol (Nicaragua)","es_PA":"Espa\xf1ol (Panama)","es_PY":"Espa\xf1ol (Paraguay)","es_PE":"Espa\xf1ol (Peru)","es_PR":"Espa\xf1ol (Puerto Rico)","es_UY":"Espa\xf1ol (Uruguay)","es_VE":"Espa\xf1ol (Venezuela)","eo_EO":"Esperanto","eu_ES":"Euskara","ee_GH":"E\u028Begbe (Ghana)","ee_TG":"E\u028Begbe (Togo)","tl_PH":"Filipino","fr_AD":"Fran\xe7ais (Andorra)","fr_BE":"Fran\xe7ais (Belgique)","fr_BJ":"Fran\xe7ais (Benin)","fr_BF":"Fran\xe7ais (Burkina Faso)","fr_BI":"Fran\xe7ais (Burundi)","fr_CM":"Fran\xe7ais (Cameroon)","fr_CA":"Fran\xe7ais (Canada)","fr_CF":"Fran\xe7ais (Central African Republic)","fr_TD":"Fran\xe7ais (Chad)","fr_KM":"Fran\xe7ais (Comoros)","fr_CG":"Fran\xe7ais (Congo - Brazzaville)","fr_CD":"Fran\xe7ais (Congo - Kinshasa)","fr_CI":"Fran\xe7ais (C\xf4te d\u2019Ivoire)","fr_DJ":"Fran\xe7ais (Djibouti)","fr_GF":"Fran\xe7ais (French Guiana)","fr_PF":"Fran\xe7ais (French Polynesia)","fr_GA":"Fran\xe7ais (Gabon)","fr_GP":"Fran\xe7ais (Guadeloupe)","fr_GN":"Fran\xe7ais (Guinea)","fr_HT":"Fran\xe7ais (Haiti)","fr_IT":"Fran\xe7ais (Italy)","fr_LB":"Fran\xe7ais (Lebanon)","fr_LU":"Fran\xe7ais (Luxembourg)","fr_MG":"Fran\xe7ais (Madagascar)","fr_ML":"Fran\xe7ais (Mali)","fr_MQ":"Fran\xe7ais (Martinique)","fr_MR":"Fran\xe7ais (Mauritanie)","fr_YT":"Fran\xe7ais (Mayotte)","fr_MC":"Fran\xe7ais (Monaco)","fr_NC":"Fran\xe7ais (New Caledonia)","fr_NE":"Fran\xe7ais (Niger)","fr_RW":"Fran\xe7ais (Rwanda)","fr_RE":"Fran\xe7ais (R\xe9union)","fr_SC":"Fran\xe7ais (Seychelles)","fr_PM":"Fran\xe7ais (St. Pierre & Miquelon)","fr_CH":"Fran\xe7ais (Suisse)","fr_TG":"Fran\xe7ais (Togo)","fr_GB":"Fran\xe7ais (United Kingdom)","fr_VU":"Fran\xe7ais (Vanuatu)","fr_VA":"Fran\xe7ais (Vatican City)","fr_WF":"Fran\xe7ais (Wallis & Futuna)","fy_NL":"Frysk","fo_FO":"F\xf8royskt","ga_IE":"Gaeilge (Gaelic)","ga_GB":"Gaeilge (United Kingdom)","gv_GB":"Gaelg (United Kingdom)","gl_ES":"Galego","ha_BF":"Hausa (Burkina Faso)","ha_NE":"Hausa (Niger)","ha_NG":"Hausa (Nigeria)","ha_SD":"Hausa (Sudan)","ha_TG":"Hausa (Togo)","hr_HR":"Hrvatski","hr_BA":"Hrvatski (Bosnia & Herzegovina)","ig_NG":"Igbo (Nigeria)","rn_BI":"Ikirundi (Uburundi)","iu_CA":"Inuktitut (Canada)","nd_ZW":"IsiNdebele (Zimbabwe)","it_IT":"Italiano","it_HR":"Italiano (Croatia)","it_SM":"Italiano (San Marino)","it_SI":"Italiano (Slovenia)","it_CH":"Italiano (Switzerland)","it_VA":"Italiano (Vatican City)","jv_MY":"Javanese (Malaysia)","jv_SR":"Javanese (Suriname)","kl_GL":"Kalaallisut (Greenland)","ks_IN":"Kashmiri (India)","kw_GB":"Kernewek (United Kingdom)","kg_CG":"KiKongo (Congo Brazzaville)","kg_CD":"KiKongo (Congo Kinshasa RDC)","sw_KE":"Kiswahili","sw_TZ":"Kiswahili (Tanzania)","ku_IR":"Kurdish (Iran)","ku_IQ":"Kurdish (Iraq)","ku_TR":"Kurd\xee","ky_KG":"Kyrgyz (Kyrgyzstan)","lo_LA":"Lao (Laos)","ht_AR":"Latibonit","la_VA":"Latin","lv_LV":"Latvie\u0161u","to_TO":"Lea fakatonga (Tonga)","lt_LT":"Lietuvi\u0173","ln_CG":"Ling\xe1la (Congo - Brazzaville)","ln_CD":"Ling\xe1la (Congo - Kinshasa)","lg_UG":"Luganda (Uganda)","lb_DE":"Luxembourgish (Germany)","lb_LU":"Luxembourgish (Luxembourg)","li_NL":"L\xe8mb\xf6rgs","hu_HU":"Magyar","hu_AT":"Magyar (Austria)","hu_RO":"Magyar (Romania)","hu_SK":"Magyar (Slovakia)","hu_SI":"Magyar (Slovenia)","hu_UA":"Magyar (Ukraine)","mg_MG":"Malagasy","mt_MT":"Malti","ro_MD":"Moldavian","mo_MD":"Moldavian (Moldova)","nl_AW":"Nederlands (Aruba)","nl_BE":"Nederlands (Belgi\xeb)","nl_NL":"Nederlands (Nederland)","nl_SR":"Nederlands (Suriname)","nb_NO":"Norsk (bokm\xe5l)","nn_NO":"Norsk (nynorsk)","se_SE":"Northern Sami (Sweden)","no_NO":"Norwegian (Norway)","ny_MW":"Nyanja (Malawi)","uz_UZ":"O\'zbek","om_ET":"Oromoo (Ethiopia)","om_KE":"Oromoo (Kenya)","os_AZ":"Ossetic (Azerbaijan)","os_GE":"Ossetic (Georgia)","os_KZ":"Ossetic (Kazakhstan)","os_RU":"Ossetic (Russia)","os_TJ":"Ossetic (Tajikistan)","os_TM":"Ossetic (Turkmenistan)","os_UA":"Ossetic (Ukraine)","os_UZ":"Ossetic (Uzbekistan)","pl_PL":"Polski","pl_UA":"Polski (Ukraine)","pt_AO":"Portugu\xeas (Angola)","pt_BR":"Portugu\xeas (Brasil)","pt_CV":"Portugu\xeas (Cape Verde)","pt_GW":"Portugu\xeas (Guinea-Bissau)","pt_MZ":"Portugu\xeas (Mozambique)","pt_PT":"Portugu\xeas (Portugal)","pt_ST":"Portugu\xeas (S\xe3o Tom\xe9 & Pr\xedncipe)","pt_TL":"Portugu\xeas (Timor-Leste)","ff_MR":"Pulaar (Mauritania)","ff_NE":"Pulaar (Niger)","ff_NG":"Pulaar (Nigeria)","ff_SN":"Pulaar (Senegal)","qu_PE":"Qhichwa","ty_PF":"Reo Tahiti","ro_RO":"Rom\xe2n\u0103","ro_UA":"Rom\xe2n\u0103 (Ukraine)","rm_CH":"Rumantsch","gd_GB":"Scottish Gaelic (United Kingdom)","sq_AL":"Shqip","sk_HU":"Sloven\u010Dina (Hungary)","sk_SK":"Sloven\u010Dina (Slovakia)","sl_SI":"Sloven\u0161\u010Dina","so_DJ":"Soomaali (Djibouti)","so_ET":"Soomaali (Ethiopia)","so_KE":"Soomaali (Kenya)","so_SO":"Soomaaliga","nr_ZA":"South Ndebele (South Africa)","st_LS":"Southern Sotho (Lesotho)","fi_FI":"Suomi","fi_SE":"Suomi (Sweden)","sv_SE":"Svenska","sv_FI":"Svenska (Finland)","sv_AX":"Svenska (\xc5land Islands)","ss_ZA":"Swati (South Africa)","ss_SZ":"Swati (Swaziland)","sg_CF":"S\xe4ng\xf6 (Central African Republic)","vi_VN":"Ti\u1EBFng Vi\u1EC7t","ts_ZA":"Tsonga (South Africa)","tn_BW":"Tswana (Botswana)","tn_ZA":"Tswana (South Africa)","tk_TM":"Turkmen (Turkmenistan)","tr_TR":"T\xfcrk\xe7e","tr_BG":"T\xfcrk\xe7e (Bulgaria)","tr_CY":"T\xfcrk\xe7e (Cyprus)","tr_MD":"T\xfcrk\xe7e (Moldova)","ug_AF":"Uyghur (Afghanistan)","ug_KZ":"Uyghur (Kazakhstan)","ug_KG":"Uyghur (Kyrgyzstan)","ug_TJ":"Uyghur (Tajikistan)","ug_TR":"Uyghur (Turkey)","ug_UZ":"Uyghur (Uzbekistan)","ve_ZA":"Venda (South Africa)","ve_ZW":"Venda (Zimbabwe)","wa_BE":"Walloon (Belgium)","fy_DE":"Western Frisian (Germany)","wo_GM":"Wolof (Gambia)","wo_MR":"Wolof (Mauritania)","wo_SN":"Wolof (Senegal)","xh_LS":"Xhosa (Lesotho)","yi_AU":"Yiddish (Australia)","yi_BY":"Yiddish (Belarus)","yi_BE":"Yiddish (Belgium)","yi_CA":"Yiddish (Canada)","yi_EE":"Yiddish (Estonia)","yi_IL":"Yiddish (Israel)","yi_LV":"Yiddish (Latvia)","yi_LT":"Yiddish (Lithuania)","yi_MD":"Yiddish (Moldova)","yi_PL":"Yiddish (Poland)","yi_RO":"Yiddish (Romania)","yi_RU":"Yiddish (Russia)","yi_ZA":"Yiddish (South Africa)","yi_UA":"Yiddish (Ukraine)","yi_US":"Yiddish (United States)","en_UK":"en_UK","xh_ZA":"isiXhosa","zu_ZA":"isiZulu","yo_NG":"\xc8d\xe8 Yor\xf9b\xe1 (Nigeria)","is_IS":"\xcdslenska (Iceland)","cs_CZ":"\u010Ce\u0161tina","el_GR":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC","el_CY":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (Cyprus)","uz_AF":"\u040E\u0437\u0431\u0435\u043A (Afghanistan)","be_BY":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F","bg_BG":"\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438","mk_MK":"\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438)","mn_MN":"\u041C\u043E\u043D\u0433\u043E\u043B","ru_RU":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439","sr_BA":"\u0421\u0440\u043F\u0441\u043A\u0438 (Bosnia & Herzegovina)","sr_HU":"\u0421\u0440\u043F\u0441\u043A\u0438 (Hungary)","sr_RS":"\u0421\u0440\u043F\u0441\u043A\u0438 (Serbia)","uk_UA":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","ru_UA":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (Ukraine)","tt_RU":"\u0442\u0430\u0442\u0430\u0440\u0447\u0430","tg_TJ":"\u0442\u043E\u04B7\u0438\u043A\u04E3","uk_MD":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 (Moldova)","kk_KZ":"\u049A\u0430\u0437\u0430\u049B\u0448\u0430","hy_AM":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576","yi_DE":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9 (German)","he_IL":"\u05E2\u05D1\u05E8\u05D9\u05EA\u200F","ur_PK":"\u0627\u0631\u062F\u0648","ur_IN":"\u0627\u0631\u062F\u0648 (India)","ar_DZ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Algeria)","ar_AR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Argentina)","ar_BH":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Bahrain)","ar_TD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Chad)","ar_EG":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Egypt)","ar_IN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (India)","ar_IQ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Iraq)","ar_IL":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Israel)","ar_JO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Jordan)","ar_KW":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Kuwait)","ar_LB":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Lebanon)","ar_LY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Libya)","ar_MR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Mauritania)","ar_MA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Morocco)","ar_OM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Oman)","ar_PS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Palestinian Territories)","ar_QA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Qatar)","ar_SO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Somalia)","ar_SD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Sudan)","ar_SY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Syria)","ar_TN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Tunisia)","ar_AE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (United Arab Emirates)","ar_YE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Yemen)","ar_SA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)","fa_IR":"\u0641\u0627\u0631\u0633\u06CC","ps_AF":"\u067E\u069A\u062A\u0648","ne_NP":"\u0928\u0947\u092A\u093E\u0932\u0940","ne_BT":"\u0928\u0947\u092A\u093E\u0932\u0940 (Bhutan)","ne_IN":"\u0928\u0947\u092A\u093E\u0932\u0940 (India)","mr_IN":"\u092E\u0930\u093E\u0920\u0940","sa_IN":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D","hi_IN":"\u0939\u093F\u0928\u094D\u0926\u0940","as_IN":"\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE (India)","bn_SG":"\u09AC\u09BE\u0982\u09B2\u09BE (Singapore)","bn_IN":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AD\u09BE\u09B0\u09A4)","bn_BD":"\u09AC\u09BE\u0982\u09B2\u09BE(\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)","pa_IN":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 (\u0A2D\u0A3E\u0A30\u0A24 \u0A28\u0A42\u0A70)","gu_IN":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0","or_IN":"\u0B13\u0B21\u0B3C\u0B3F\u0B06","ta_IN":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD","ta_SG":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (Singapore)","te_IN":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41","kn_IN":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1 (India)","ml_IN":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02","si_LK":"\u0DB4\u0DC5\u0DCF\u0DAD","si_TH":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD (Thailand)","th_TH":"\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22 (\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22)","bo_CN":"\u0F54\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0B (China)","my_MM":"\u1017\u1019\u102C (Myanmar (Burma))","ka_GE":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8","ti_ER":"\u1275\u130D\u122D\u129B (Eritrea)","ti_ET":"\u1275\u130D\u122D\u129B (Ethiopia)","am_ET":"\u12A0\u121B\u122D\u129B (Ethiopia)","ck_US":"\u13E3\u13B3\u13A9 (tsalagi)","km_KH":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","gx_GR":"\u1F19\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u1F00\u03C1\u03C7\u03B1\u03AF\u03B1","zh_MO":"\u4E2D\u6587 (Macau SAR China)","zh_CN":"\u4E2D\u6587\uFF08\u4E2D\u56FD\uFF09","zh_TW":"\u4E2D\u6587\uFF08\u53F0\u7063\uFF09","zh_SG":"\u4E2D\u6587\uFF08\u65B0\u52A0\u5761\uFF09","zh_HK":"\u4E2D\u6587\uFF08\u9999\u6E2F\uFF09","ja_JP":"\u65E5\u672C\u8A9E","ii_CN":"\uA188\uA320\uA259 (China)","ko_KP":"\uD55C\uAD6D\uC5B4 (North Korea)","ko_KR":"\uD55C\uAD6D\uC5B4 (\u97E9\u56FD)"},"autocompletePicker":{"placeholder":"Select...","searchPlaceholder":"Type at least 3 characters to search...","noResults":"No result!"},"invalidPhoneNumber":"Phone number is invalid","yes":"Yes","no":"No","cancel":"Done","validate":"Validate"},"authScreen":{"welcome":"Welcome to your bank portal","headline":"My wallet, simple and secure","headlineDescription":"Manage your business expenses, qualify your transactions and upload your receipts in a glance.","subtitle":"Sign in to reach your business space","languages":"Languages","login":"Sign in","createAccount":"Open an account","appstoreLink":"Appstore","playstoreLink":"Playstore","goToCompanyPortalQuestion":"Are you a company?","goToCompanyPortalLink":"Business web portal","goToPartnersPortalQuestion":"Are you a partner?","goToPartnersPortalLink":"Partner web portal","goToAgentPortalQuestion":"You are an agent?","goToAgentPortalLink":"Agents web portal","storesAvailable":"Also available on","disconnectedDueToInactivity":"You have been disconnected due to inactivity","authenticationFailure":{"title":"Authentication failure"}},"connectScreen":{"title":"Welcome to [emph]Skaleet[/emph]","subtitle":"Please enter your phone number to log in","lostPhoneButton":"Forgot phone number?","connectButton":"Log in","registerQuestion":"Don\u2019t have an account?","registerButton":"Register","errorTitle":"An error occurred","noAccountError":"We were unable to find an account for {phoneNumber}. You can create an account to log in.","pincodeTitle":"Secret [emph]code[/emph]","otpTitle":"Two-step [emph]verification[/emph]","noCodeQuestion":"Code not received?","contactSupportLink":"Please contact support.","contactSupport":{"title":"You no longer [emph]have access to the phone[/emph] linked to your account ?","message":"To change your details, please contact our support team who will tell you what to do.","byPhone":"Contact us by phone","byEmail":"Contact us by email","done":"Done"}},"errorScreen":{"subTitle":"Too many requests","title":"Connection attempt failed","message":"We cannot process your connection request at this moment.\\n\\n Please try again later.","button":"Return to log in page"},"onboardingStatusCard":{"title":"More information is required regarding your onboarding file","subtitle":"Lorem ipsum dolor sit amet","button":"Complete my file"},"onboardingDelegateErrorStatusCard":{"title":"Unable to access the registration form as a delegated user. The available features are limited. The account owner must complete their registration."},"onboardingScreen":{"progressLabel":"Step {step} of {count}: {label}","initialStepTitle":"Welcome to [emph]M-Wallet[/emph]","resumptionStepTitle":"Tell us more about [emph]you[/emph]","successIntroduction":"Congratulations","successTitle":"Your onboarding file has been validated","submissionThanks":"Thank you for your submission!","identityVerificationDescription":"Your identity is being verified by our end. Verification process can take from a few hours up to a few days. You can now login in your space or close this window.","successButton":"Let\'s start","initiationSuccessTitle":"Your enrollment has been successfully initiated.","initiationSuccessMsg":"A secret code has been sent to {phone}","initiationSuccessButton":"Let\'s connect","getStartedButton":"Get started","cancelButton":"Cancel","back":"Back","next":"Next","save":"Save","submit":"Submit","taxedNumberError":{"undefined":"Error: Please enter a valid phone number.","PREMIUM_RATE":"Error: Premium rate numbers cannot be used for account registration. Please provide either a mobile or fixed-line number.","TOLL_FREE":"Error: Toll-free numbers are not supported for account verification. Please use a standard mobile or stationary phone number.","SHARED_COST":"Error: Numbers with shared cost billing are not permitted for account creation. Please enter a mobile or fixed-line number.","VOIP":"Error: Internet-based phone numbers are not eligible for registration. Please use a standard mobile or fixed-line number.","PERSONAL_NUMBER":"Error: Personal numbers connected via satellite are not accepted. Please use a mobile or stationary phone number.","PAGER":"Error: Pager devices are not valid for account creation. Please provide an accepted mobile or fixed-line number.","UAN":"Error: Universal Access Numbers (UAN) cannot be used for registration. Please enter a valid mobile or fixed-line number.","VOICEMAIL":"Error: Numbers dedicated to voicemail services cannot be used. Please enter a mobile or fixed-line number that can directly receive calls."},"formLabels":{"selectDistributorDuringOnboarding":"Onboarding distributor code","selectDistributorDuringOnboardingHelperText":"Please enter the ID provided by your card referent.","firstName":"First name","lastName":"Last name","phoneNumber":"Phone number","email":"Email"}},"registerScreen":{"progressLabel":"Step {step} of {count}: {label}","progressStepLabel":"Step {step} of {count}","progressBackLink":"Back","firstStepTitle":"Welcome!","firstStepSubtitle":"Please enter your phone number to register","connectQuestion":"Already have an account?","connectButton":"Log in","phoneNumberLabel":"Phone number","back":"Back","next":"Next","finish":"Finish","otpTitle":"Phone checking","otpLabel":"Please enter the code sent to your mobile phone","nbPicturesForDocument":{"one":"at least one picture","others":"at least {count} pictures"},"pictureInputFilled":"One file","pictureInputEmpty":"Choose or drop a picture","addPictureButton":"Add a page","eulaTitle":"End-user licence agreement","eulaAcceptLabel":"I accept end-user licence agreement","eulaFirstDescription":"Please accept the terms of use in order to create your account.","eulaSecondDescription":"You will find them by clicking on the following link:","eulaLink":"End-user licence agreement","createMyAccountButton":"Create my account","finishTitleLabel":"Congratulations !","finishLabel":"Your account has been successfully created.","pincodeLabel":"Your secret code","pincodeStepTitle":"Your secret [emph]code.[/emph]","message":"You must choose a four-digit secret code for your account. Do not communicate it to anyone, it is strictly confidential.","doNotForgetWarning":"Be careful to keep it well: you will need it to authenticate yourself and validate all your transactions. ","successSnackbar":"Your code has been confirmed successfully","quitConfirmMessage":"You are about to exit registration. All data filled in will be lost. Are you sure you want to leave the page ?","cancel":"Cancel","newCodeLabel":"Enter the new code","newCodeConfirmationLabel":"Confirm the new code","newCodesDontMatchError":"New codes don\'t match","noEulaTitle":"Account creation confirmation","noEulaFirstDescription":"You\'re almost done!","noEulaSecondDescription":"By clicking the following link, your account creation will be effective. Let\'s go?","privacyTitle":"Privacy policy","privacyFirstDescription":"Please accept the privacy policy in order to create your account.","privacySecondDescription":"You will find them by clicking on the following link:","privacyLink":"Privacy policy","privacyAcceptLabel":"I accept the privacy policy","noPrivacyTitle":"Account creation confirmation","noPrivacyFirstDescription":"You\'re almost done!","noPrivacySecondDescription":"By clicking the following link, your account creation will be effective. Let\'s go?"},"accountOwner":{"male":"Mr. {name}","female":"Ms. {name}","other":"{name}","none":"{name}"},"connectedUserGreetings":{"withName":"Hello,\\n[emph]{name}[/emph]!","hello":"Hello,","withoutName":"Hello!"},"clientStatus":{"clientBlockedMessage":"Your account is blocked.","clientBlockedLink":"More information...","clientPendingMessage":"We are processing your account validation.","accountUnderReview":"Account under review: checking your file may take up to a few days."},"profileMenu":{"title":"Profile and settings","subtitle":"Find all your account information here","generalSection":"General settings","profileTitle":"My profile","profileSubtitle":"Manage your account and your information","settingsTitle":"Settings","settingsSubtitle":"Manage your personal settings"},"navigationMenu":{"accountLink":"Home","profileLink":"Profile and settings","transferLink":"Transfers","payBillLink":"Services","cardsLink":"My Card","savingsLink":"Savings","loansLink":"Loans","contactLink":"Help and support","settingsLink":"See my profile","disconnectButton":"Logout","mandatesLink":"Mandates"},"transfertsSubmenu":{"allTransfer":"Make a transfer","externalAccount":"External account","recipients":"Recipients","cashTransfer":"Pending transfers","upcomingTransfers":"Upcoming transfers","recharge":"Recharge my account","transactionCode":"Transaction code","simpleTransfer":"With phone number"},"savingsSubmenu":{"mySavingsAccount":"My saving accounts","deposits":"Transfers and deposits","createSavingsAccount":"Create a savings account"},"simpleTransfer":{"newTransfer":"New transfer","title":"With phone number","searchRecipient":"Search a recipient","invalidPhoneNumber":"The provided phone number is not recognized"},"accountPendingVerification":{"title":"Account verification","subtitle":"Your account opening request is under verification. Please retry later once it has been reviewed by the back-office.","retryButton":"Retry"},"accountsList":{"title":"My accounts.","loadAccountsError":"An error occurred while loading accounts.","loadAccountsRetry":"Retry","showAllAccountsLink":"Show all accounts","noAccountAvailable":"No account available"},"recipient":{"title":"Make a transfer","subtitle":"Who do you want to transfer your money to?","section":"My recipients","noRecipientsAvailable":"No recipient available","noRecipientsMessage":"Add recipients to transfer money.","addRecipientButton":"Add a recipient","transferTo":"Transfer to {name}","searchInputPlaceholder":"Search","selector":{"beneficiaries":"Recipients","externalAccounts":"External account"},"deletePrompt":{"title":"Delete","message":"Do you really want to delete the recipient {name} ?","recipient":"a recipient","externalAccountTitle":"external account","externalAccountMessage":"Please confirm that you want to delete your external account","cancelButton":"Cancel","confirmButton":"Confirm"},"externalAccounts":{"title":"My external accounts","addButton":"Add an external account","noneAvailableTitle":"Currently no external account","noneAvailableMessage":"Add an external bank account to transfer money.","pendingExternalAccountMessage":"Your external account is being validated."}},"addRecipient":{"selector":{"iban":"IBAN","phone":"Phone","account":"Account num / BIC"},"unauthorized":"You are not authorized to access this feature","title":"Add","subtitle":"a recipient","externalAccountSubtitle":"an external account","nameFieldPlaceholder":"Name","phoneFieldPlaceholder":"Phone number","ibanFieldPlaceholder":"IBAN","accountFieldPlaceholder":"Account number","bicFieldPlaceholder":"BIC","bankFieldPlaceholder":"Bank/BIC","createButton":"Add","otpAdditionalText":"Add recipient {name}","otpAdditionalTextWithBank":"Add recipient {name} from bank {bankName}","addConfirmationMessage":"The recipient {name} was added successfully","searchBank":{"title":"Bank/BIC","bankPlaceholder":"Type at least {num} letters to search","firstSearchMessage":"Make a first search to get some results","noBankMessage":"No matching bank found","errorMessage":"An error occurred while loading the list of banks.","retryButton":"Retry"},"pollingModalSession":{"title":"Approve on the application","messageCancelled":"Approbation cancelled","messageFailed":"Approbation failed","messageRefused":"Approbation refused","messageExpired":"Approbation expired.","messagePending":"Approbation is pending.","messagePendingCheck":"Please check your application.","messageStarted":"Approbation has been started.","messageDone":"Approbation successful","error":"An error occurred while loading operations to approve."}},"editRecipient":{"title":"Edit","subtitle":"a recipient","externalAccountSubtitle":"external account for","saveButton":"Save"},"account":{"accountId":"N\xb0{id}","accountType":{"current":"Current account","joint":"Joint account","savings":"Savings account","dedicated":"Dedicated account","moneyPot":"Money Pot","technical":"Technical account"},"detail":"Details"},"accountStatus":{"opened":"Opened","closed":"Closed","blocked":"Blocked","debitBlocked":"Debit forbidden","creditBlocked":"Credit forbidden"},"homeScreen":{"accountBalance":"Account balance","monthlyFluxTitle":"{month} flow","monthlyFluxIncome":"My income","monthlyFluxExpense":"My expenses","allTransactionsLink":"All my transactions","latestTransactionsTitle":"My latest transactions","requiredActionsTitle":"Required actions","requiredActionsSeeAll":"See all","transactionsToJustify":"Expenses to justify","transactionsToQualify":"Expenses to qualify"},"allTransactions":{"title":"Operation history","subtitle":"Go through all your operations and take the actions they need"},"accountTransactions":{"title":"My transactions.","tagJustified":"Justified","tagNotJustified":"Not justified","tagQualified":"Qualified","tagNotQualified":"Not qualified","emptyTransactionList":"There are no transactions in this period.","loadTransactionsError":"An error occurred while loading transactions.","loadMoreTransactionsError":"An error occurred while loading transactions.","loadMoreTransactionsRetry":"Retry","unjustifiedTransactions":{"title":{"one":"You have {count} transaction waiting for substantiation","other":"You have {count} transactions waiting for substantiation","more":"You have {count} or more transactions waiting for substantiation"},"description":"Some of your transactions are waiting for substantiation documents."},"unjustifiedTransactions2":{"title":{"one":"You have {count} transaction waiting for substantiation","other":"You have {count} transactions waiting for substantiation","more":"You have {count} or more transactions waiting for substantiation"},"description":"Some of your transactions are waiting for substantiation documents."},"unqualifiedTransactions":{"title":{"one":"You have {count} transaction waiting for qualification","other":"You have {count} transactions waiting for qualification","more":"You have {count} or more transactions waiting for qualification"},"description":"Some of your transactions are waiting for qualification documents."},"authorizationHolds":{"title":{"one":"You have {count} pending transaction","other":"You have {count} pending transactions","more":"You have {count} pending transactions"},"description":"The money has been debited from the account but is not yet received by the beneficiary."},"expenseUnjustified":"Unjustified","previousPeriodButtonLabel":"Previous period","nextPeriodButtonLabel":"Next period"},"authorizationHolds":{"cashoutLabel":"Cashout","paymentLabel":"Payment","externalToAccountLabel":"External to account","accountToExternalLabel":"Account to external","externalFromAccountLabel":"External from account","accountRechargeLabel":"Account recharge","onUsCreditTransferLabel":"On-us credit transfer","managementFeesLabel":"Management fees"},"accountingTransactionDetailsModal":{"detailsTitle":"Details","transferLabel":"Transfer","description":"Description: {description}","transaction":"Transaction {id}","reference":"Reference: {id}","feeLabel":"Fee","commissionLabel":"Commission","taxLabel":"Tax","discountLabel":"Discount","interestLabel":"Interests","amountLabel":"Total","balanceLabel":"Balance after transaction","additionalInformationTitle":"Additional information","geolocationTitle":"Localization","externalIdLabel":"Partner transaction reference: {externalId}","justifyButtonLabel":"Justify","refundButtonLabel":"Request a refund","verifyJustificationsButtonLabel":"Verify justifications","justificationFollowUpTitle":"Justification follow-up","documentsSubmitted":"Supporting documents submitted","validationInProgress":"Waiting for validation"},"authorizationHoldsDetailsModal":{"pending":"Pending","detailsTitle":"Details","transferLabel":"Transfer","reference":"Transaction {id}","amountLabel":"Total"},"allAccountsScreen":{"goBackClassicViewButton":"Go back to the classic view","noAccountAvailable":"No account available"},"recipientDetail":{"information":"Informations.","accountDetail":"RIB/Account information.","transferMoneyButton":"Transfer money","dedicatedTransferButton":"Dedicated transfer"},"amountSelection":{"amountLabel":"Amount","currencyLabel":"Currency :","descriptionLabel":"Description :","descriptionButton":"Add a description","descriptionPlaceholder":"Write something\u2026","simpleTransferNameLabel":"Name :","simpleTransferNamePlaceholder":"Write a name","simpleTransferPhoneLabel":"Phone :","simpleTransferPhonePlaceholder":"Write a phone number","sendButton":"Send","since":"Since","to":"To","choose_source_account":"Choose a source account","choose_destination_account":"Choose a destination account","my_accounts":"My accounts","my_external_account":"External account","my_recipients":"My recipients","network":"Interbank network","load_more":"Load more","convertedAmountLabel":"Converted amount","foreignCurrencyPlaceholder":"Choose a currency","creditorAddress":{"addressLabel":"Address","countryLabel":"Country","buildingNumber":"N\xb0","streetName":"Street","postCode":"Post code","townName":"Town","country":"Country"},"insufficient_balance":"Selected account has insufficient balance to perform this operation","instant_transfer_label":"Make this an instant transfer"},"acceptorSelection":{"title":"Selection of a trader","selectionButton":"Select"},"dedicatedTransferAmount":{"title":"Gift amount","subtitle":"Transaction point: {code}"},"dedicatedTransferSummary":{"recepient":"Recipient","account":"Account debited","amount":"Amount","transactionPoint":"Transaction point","expirationDate":"Date of expiry","done":"Done"},"pincodeConfirmation":{"label":"Tap your secret code to continue","networkError":"Please check your internet connection before continuing","loadKeyboardError":"An error occurred while loading keyboard.","loadKeyboardRetry":"Reload keyboard"},"transferSummary":{"accountTransferMode":"To account","cashTransferMode":"To cash","summaryTitle":"Success","accountSummarySubtitle":"Details of the transfer","cashSummarySubtitle":"You will receive message containing a code to give to {recipient} or you can consult your pending transfers to get the code.","summaryMiddleStep":"Transfer","fees":"Fees: {amount}","commission":"Commission: {amount}","discount":"Discount: {amount}","tax":"Tax: {amount}","you":"You","done":"Done","customerInstructionSuccessMessage":"Your transfer N\xb0{id} to {recipient} has been successfully completed.","recurringTransferSuccessMessage":"The recurring transfer N\xb0{id} to {recipient} has been successfully created."},"billFormScreen":{"nextButton":"Next","textInputPlaceholder":"Write something\u2026","saveReferencePromptTitle":"Save {name}","replaceReferencePromptTitle":"Replace {name}","saveReferencePromptMessage":"Do you want to save the {name} for this partner?","replaceReferencePromptMessage":"Do you want to replace the {name} for this partner?","saveReferencePromptCancel":"Cancel","saveReferencePromptConfirm":"Save","replaceReferencePromptConfirm":"Replace","saveReferenceErrorMessage":"The {name} could not be saved","docInputFilled":"One file","docInputEmpty":"Add or drop a picture here","confirmationMessage":"Click below to confirm your payment of [b]{amount} [/b] to [b]{issuer}[/b]","confirmButton":"Confirm"},"billConfirmationScreen":{"fees":"Fees : [b]{amount}[/b]","commission":"Commission : [b]{amount}[/b]","discount":"Discount : [b]{amount}[/b]","tax":"Tax : [b]{amount}[/b]"},"formError":{"invalidIBAN":"IBAN is not valid","invalidFileSize":"Your file exceeds the maximum accepted size ({size})","invalidFileFormat":"The format of your file is not supported. Formats accepted: {formats}"},"billIssuersScreen":{"title":"Pay a bill.","references":"My references","searchInputPlaceholder":"Search","emptyListLabel":"No partner available","loadBillIssuersError":"An error occurred while loading the partners list."},"billReferencesScreen":{"title":"My references","services":"Go back to my services","subtitle":"Saved data for your bill payments","emptyRecipientList":"No registered reference","deletePromptTitle":"Delete reference","deletePromptMessage":"Please confirm that you want to delete reference {name}","deletePromptCancel":"Cancel","deletePromptConfirm":"Confirm","deleteConfirmationMessage":"The reference {name} was removed successfully","deleteErrorMessage":"Deleting the reference {name} failed","loadBillReferencesError":"An error occurred while loading references.","lastUpdateDateTime":"Last update : {date} at {time}"},"otp":{"explanation":"Enter the six-digit code we sent you at:","sendBackCodeButton":"Send back code","cancelOtpButton":"Cancel","confirmOtpButton":"Confirm","goToTransferFormButton":"Go to transfer form","backToRecipients":"Back","otpBlockedErrorMessage":"You made 3 invalid tries. Please restart the operation from the beginning."},"myAccountScreen":{"title":"My account","subtitle":"All the information and details of your personal account","coordinatesTitle":"Your account details","quickActionsTitle":"Quick actions","downloadRib":"Download my bank details","shareDetails":"Share my bank details","manageBeneficiaries":"Manage beneficiaries","manageBeneficiariesSubtitle":"Add or remove your bank beneficiaries","accountStatement":"Account statement","accountStatementSubtitle":"See the detail of your banking operations","feesStatement":"Fees statement","feesStatementSubtitle":"See the detail of your banking fees","accountStatementPageSubtitle":"Find and download all your account statements by period.","feesStatementPageSubtitle":"Find and download all your fees statements by period.","allYears":"Years"},"accountDetails":{"availableBalanceTitle":"Available balance","balanceTitle":"Account balance","balanceMessage":"The account balance does not include pending transactions.","accountStatus":{"blocked":"This account is blocked. For more information please contact our support.","debitBlocked":"Debits are currently forbidden on this account. For more information please contact our support.","creditBlocked":"Credits are currently forbidden on this account. For more information please contact our support."},"accountName":"Account name","accountIdTitle":"Account number","ibanTitle":"IBAN","bicTitle":"BIC","coOwnerTitle":"Co-owner","authorizedOverdraftTitle":"Authorized overdraft","reachedOverdraftMessage":"You have reached your authorized overdraft.","validityDate":"Until {date}","accessStatements":"Account statements","shareRIBLabel":"Share account info","shareRIBMessage":"{firstName} {lastName} {postName}\\nIBAN: {iban}\\nBIC: {bic}","dedicatedMessage":"You can spend this amount at:","clipboard":"{name} copied","downloadBankDetails":"Bank details","accountStartDate":"Account opening date","maximumBoundaries":"Maximum amount","initialAmountLabel":"Initial amount","endDateLabel":"End date","durationLabel":"Duration","monthsLabels":{"DAILY":"days","WEEKLY":"weeks","MONTHLY":"months","QUARTERLY":"quarters","SEMESTER":"semesters","ANNUALLY":"years"},"rateValueLabel":"Applied rate","indexCodeLabel":"Index","rateStartDateLabel":"Rate start date","accruedInterestsLabel":"Accrued interests","startDateLabel":"Earned since","forecastInterestsLabel":"Forecast interests","initialAERLabel":"AER","success":"Saved"},"statementsFilters":{"allAgencies":"All agencies","allYears":"All years","years":"Years"},"accountsStatements":{"title":"My account statements","subtitle":"All the statements","accountLabel":"Account n\xb0{id}","accounts":"Accounts","statements":"Available account statements","emptyStatementList":"No account statement available","cancel":"Cancel","loadStatementsError":"An error occurred while loading account statements.","generateButton":"Generate"},"taxStatements":{"title":"My tax statements","subtitle":"All the statements","accountLabel":"Account n\xb0{id}","accounts":"Accounts","statements":"Available tax statements","emptyStatementList":"No tax statement available","cancel":"Cancel","loadStatementsError":"An error occurred while loading tax statements.","generateButton":"Generate"},"feesStatements":{"title":"My fees statements","subtitle":"All the statements","accountLabel":"Account n\xb0{id}","accounts":"Accounts","statements":"Available fees statements","emptyStatementList":"No fee statement available","cancel":"Cancel","loadStatementsError":"An error occurred while loading fees statements."},"cardsList":{"title":"My cards.","loadCardsError":"An error occurred while loading cards.","loadCardsRetry":"Retry","showAllCardsLink":"Show all cards","myCardTitle":"My card","myCardSubtitle":"View and manage your card","availableBalance":"Available balance","emptyTitle":"No card has been added yet","emptyDescription":"Add a card to start making your payments.","addCardButton":"Add a card","orderCard":"Order a new card","refabricateButton":"Replace card","infos":{"title":"Additional infos"},"details":{"title":"Card details","holder":"Cardholder name","number":"Number","date":"Expiration date"}},"allCardsScreen":{"goBackClassicViewButton":"Go back to the classic view","noCardAvailable":"No card available"},"card":{"virtual":"Virtual","title":"CARD","status":{"all":"All","active":"Active","pending":"Pending","new":"New","expired":"Expired","blocked":"Blocked","opposed":"Opposed","removed":"Removed","cancelled":"Cancelled"},"feature":{"nfc":"NFC","cashOperation":"Cash operation","foreignPayment":"Foreign payment","onlinePayment":"Online payment","eurWithdrawal":"Euro zone withdrawal","foreignWithdrawal":"Foreign withdrawal","paymentAuthorized":"Authorized payment","eurPayment":"Euro zone payment","foreignAll":"Foreign payment and withdrawal","foreignOnlinePayment":"Foreign online payment"},"pendingOperation":{"refabrication":"The card is currently being remade","codeReissuing":"Your PIN code change is currently processing","opposition":"The card is currently being opposed","blocking":"The card is currently being blocked","unblocking":"The card is currently being unblocked","activation":"The card is currently being activated","creation":"The card is currently being created","limitsUpdate":"The limits for your card are currently updating","featuresUpdate":"The \\"{feature}\\" feature for your card is currently processing","unknownFeatureUpdate":"A feature for your card is currently processing"}},"cardPincode":{"importantMessage":"Be careful to keep this code:\\nYou will need it to validate transactions with your card.","previous":"Change","next":"Next","errorCodesMismatch":"Pincodes do not match."},"cardOptions":{"title":"Card & payment settings","outstandings":{"navigateButton":"My limits","title":"My limits","subtitle":"See your card limits","paymentHeader":"Payment limits","cashoutHeader":"Cashout limits","slidingPeriod":"rolling period of {num} {unit}","fixedPeriod":"from {startDate} to {endDate}","used":"Used","available":"Available","maxAmount":"Max amount","maxOperations":"Max operations","selector":{"payments":"Payments","cashouts":"Cashouts"},"noOutstandingLabel":"No limits set","errorMessage":"An error occurred while loading limits.","retryButton":"Retry","durationUnit":{"hour":"hour","hours":"hours","day":"day","days":"days","week":"week","weeks":"weeks","month":"month","months":"months","year":"year","years":"years"},"updateButtonLabel":"Update my limit","modal":{"title":"Update my limit","inputLabel":"New limit","inputLabelUnit":{"day":"(daily)","week":"(weekly)","month":"(monthly)","year":"(yearly)","all":"(global)"},"maximumLabel":"Maximum","submitButtonLabel":"Submit","validationMsg":"Your request has been sent"}},"refabricate":{"modal":{"title":"Confirm","message":"Please confirm that you want to replace this card","cardNumber":"{cardNumber} ","submitButtonLabel":"Confirm"},"motiveLabel":"Please select a motive","motivesOptions":{"DAMAGED":"Damaged card","STOLEN":"Stolen card","LOST":"Lost card","ABUSE":"Card abuse"}},"oppositionCard":{"opposeButton":"Oppose this card","opposeDescription":"Protect your funds if the card is lost or stolen","title":"I want to oppose this card","reasonLost":"Lost card","reasonStolen":"Stolen card","reasonNotDistributed":"Not distributed","opposeConfirmButton":"Confirm","opposeCancelButton":"Cancel","opposePromptTitle":"Oppose this card","opposePromptMessage":"You can not revert this action. Are you sure you want to oppose ?"},"deactivateCard":{"deactivateButton":"Deactivate this card","title":"I want to deactivate this card","deactivateConfirmButton":"Confirm","deactivateCancelButton":"Cancel","deactivatePromptTitle":"Deactivate this card","deactivatePromptMessage":"You can not revert this action. Are you sure you want to oppose ?"},"updateCardPincode":{"updateButton":"Change card PIN code","updateDescription":"Change your PIN code securely","title":"New PIN code","definePincodeMessage":"Choose another four-digit PIN code for your card. Above all, do not communicate it to anyone, it is strictly confidential.","confirmPincodeMessage":"Please confirm your card pincode to continue.","successTitle":"Congratulations !","successSubtitle":"Your card PIN code has been updated !","failureTitle":"Error","failureSubtitle":"Please excuse us.","failureDescription":"An error occured while updating the PIN code for your card. Please try again later or contact our customer service.","confirmationPopup":{"message":"If you quit while modifying the card PIN code it won\'t be updated.\\nQuit editing ?"}},"activationCard":{"title":"Activate my card","activateButton":"Activate","defaultActivationMessage":"Enter the 9-digit identifier on the back of your card.","identifier":"The 9-digit identifier","next":"Next","confirm":"Activate","inputError":"Input error, please try again.","stepPincode":{"title":"PIN code","definePincodeMessage":"You must now choose a four-digit PIN code for your card. Above all, do not communicate it to anyone, it is strictly confidential.","confirmPincodeMessage":"Please confirm your card pincode to continue."}},"switch":{"lockCard":"Temporary lock","unlockCard":"Unlock","showDetails":"Voir le d\xe9tail","hideDetails":"Masquer le d\xe9tail"},"featuresSwitchesOverlay":{"cardLocked":"Card blocked"},"cardOpposedMessage":"You have opposed this card. You can not access to the settings of this card."},"accountBlockedScreen":{"title":"Blocked account","multipleAttemptBlockedReason":{"subtitle":"Three wrong secret code attempts","message":"Unfortunately, your account has been blocked due to three incorrect secret code attempts. Please contact our support {contacts}to reset your secret code."},"defaultBlockedReason":{"message":"Unfortunately, your account has been blocked. Please contact our support {contacts}to reset your secret code."},"contactsPhoneAndEmail":"to {contactPhone} or by email to {contactEmail} ","contactsPhone":"at {contactPhone} ","contactsEmail":"or by email to {contactEmail} ","button":"Ok I understood"},"bankContactScreen":{"title":"My bank.","question":"Need help?","addressContact":"Find us","phoneContact":"Call us","urlContact":"Learn more","emailContact":"Write us"},"pincodeChangeFlow":{"currentCodeLabel":"Enter your current code","newCodeLabel":"Enter the new code","newCodeConfirmationLabel":"Confirm the new code","newCodesDontMatchError":"New codes don\'t match","success":"Your code has been updated successfully"},"pincodeChangeScreen":{"title":"Code change","subtitle":"Change your secret code for more security","message":"You are required to change your secret code in order to continue","messageAfterAuthentication":"You will be required to change your secret code in order to initiate new transactions","changePincodeButton":"Change my secret code","laterButton":"Later","done":"Done"},"clientInformation":{"title":"My personal information","birthDateTitle":"Birth date","birthPlaceTitle":"Birth place","addressTitle":"Address","phoneTitle":"Phone","emailTitle":"Mail","emailSuccess":"You have received a confirmation email","viewMore":"View more","viewLess":"View less"},"documents":{"title":"My documents","CREDITADRESSPROOF":"Credit address proof","PASSPORT":"Passport","CREDITID":"Credit ID","PORTRAIT":"Portrait","PROOF_OF_ACTIVITY":"Proof of activity"},"cashTransferScreen":{"title":"My pending transfers","subtitle":"Cancel or retrieve your cash transfers","receivedSelector":"Received","sentSelector":"Sent","recipient":"Sent to : ","sender":"Sent by : ","emptyReceivedList":"No transfer received","emptySentList":"No transfer send","receivedTransferDefaultTitle":"Transfer received","sentTransferDefaultTitle":"Transfer sent","codeLabel":"Code : {code}","cancelCashTransferButton":"Cancel transfer","retrieveCashTransferButton":"Send to my account","loadCashTransfersError":"An error occurred while loading cash transfers.","loadMoreCashTransfersError":"An error occurred while loading cash transfers.","loadMoreCashTransfersRetry":"Retry","nextButton":"Next","cashCodeTitle":"Enter the code sent by the transfer sender","invalidCode":"The code entered is invalid","summaryTitle":{"sentCashTransfer":"Transfer cancelled","receivedCashTransfer":"Transfer sent to your account"}},"settings":{"title":"My personal settings","changeLanguageTitle":"Change language","changeLanguageDescription":"Change the language used by the app","languageChangeConfirmation":"The application\'s language has been changed successfully","languageChangeFailed":"An error occured while loading language","changePincodeTitle":"Change my secret code","changePincodeDescription":"For more security, change your pincode regularly","accountDeleteTitle":"Delete my account","accountDeleteDescription":"Delete my Skaleet account permanently."},"accountDeleteScreen":{"title":"Delete my account","subtitle":"Note that you do not need to delete your account if:","button":"Delete my account","explanation":"Your request will be sent to our team. This operation may take several days.","options":{"changeProfile":{"title":"You want to change your pincode","description":"Update your pincode in the settings."},"unHappy":{"title":"You are not happy with us","description":"Contact us and tell us."}},"confirm":{"title":"Do you really want to request the closure of your account ?","subtitle":"You will permanently lose all your account datas, contacts and profile info","placeholder":"Please provide a reason for closing the account","warning":"After this, there is no turning back","button":"Confirm your request","success":"Account closing request has been successfully sent"}},"accountDeleteMail":{"subject":"Request to delete the account of {username}","body":"Dear Sir or Madam, I ask you to delete my user account."},"transactionFilter":{"all":"All","credit":"Income","debit":"Outcome","searchDescription":"Easily find your transactions thanks to the search engine.","searchInputPlaceholder":"Search for an operation","timeRangeSelectionTitle":"Custom date","timeRange":{"month":"This month","week":"Last 7 days","quarter":"Last 3 months","from":"From:","to":"To:"},"advancedSearch":"Advanced Search","confirm":"Confirm","amountRangeSelectionTitle":"Filter by amount","panelTitle":"Filters","clearAll":"Clear all","apply":"Apply","toJustify":"To justify","toQualify":"To qualify","amountRangeTitle":"Spending range","periodTitle":"Period","filtersButton":"Filter the operations","allAmountRange":"All amounts","amountRange":{"min":"Min:","max":"Max:"},"emptySearchResult":"No transaction"},"resultScreen":{"activateCard":{"successTitle":"Congratulations !","successSubtitle":"Your card has been activated !","failureTitle":"Error","failureSubtitle":"Please excuse us.","failureDescription":"It would seem that an error occurred while activating your card. Please try again later or contact our customer service."},"createCard":{"successTitle":"Congratulations !","defaultSuccessSubtitle":"Your card has been created !","failureTitle":"Error","failureSubtitle":"Please excuse us.","failureDescription":"An error occurred while creating your card. Please try again later or contact our customer service."},"updateOutstanding":{"successTitle":"Congratulations !","defaultSuccessSubtitle":"Your limit has been updated !","failureTitle":"Error","failureSubtitle":"Please excuse us.","failureDescription":"An error occurred while updating your card limit. Please try again later or contact our customer service."},"refabricate":{"successTitle":"Congratulations !","successSubtitle":"Your demand has been taken into account !","failureTitle":"Error","failureSubtitle":"Please excuse us.","failureDescription":"An error occurred while replacing your card. Please try again later or contact our customer service."},"sensitiveDetails":{"successTitle":"Congratulations !","successSubtitle":"Continue to consult the card sensitive data","failureTitle":"Error","failureSubtitle":"Please excuse us.","failureDescription":"An error occurred while getting your card\'s sensitive data. Please try again later or contact our customer service."},"done":"Done"},"createCard":{"title":"New card","virtualCardtitle":"New virtual card","loadProductsError":"An error occurred.","loadProductsRetry":"Retry","stepSelection":{"title":"Account selection","selectAccountMessage":"Please select the account for which you wish to order a card:","selectVirtualCardMessage":"Please select the account for which you wish to create a virtual card:","selecProductMessage":"Which card would you like to order ?","selectProductForVirtualCardMessage":"Which virtual card would you like to create ?","orderCardButton":"Order my card","createVirtualCardButton":"Create a virtual card","virtualCardTitle":"Get a new virtual card instantly","virtualCardDescription":"For secure online purchases without fear of losing your card!","accountLabel":"Account n\xb0{id}"},"stepCgu":{"title":"Terms of Service","acceptMessage":"By validating the switch, you confirm that you have read and accepted our Terms of Service","next":"Next"}},"recharge":{"title":"Choose an account","description":"Select an account to recharge","noAccountAvailable":"No account available","noAccountExplanation":"It looks like you don\'t have a reloadable account.","contactSupport":"Contact support","rechargeButton":"Recharge"},"rechargeMethod":{"title":"Recharge methods","subtitle":"How do you want to recharge your account?","withCard":{"title":"Bank card","description":"Your account will be credited instantly. Withdrawals at partner banks all over the world.","instantTag":"Instantly"},"bankDebit":{"title":"Direct bank debit","description":"Fund the account from your external account {bankName}. Your account will not be credited instantly.","noBankDescription":"Fund the account from your external account. Your account will not be credited instantly."}},"contactSupport":{"notHappyTitle":"How can we help you?","notHappyMessage":"Tell us what is going on and we will try to put it right.","noContactAvailable":"No means of contact is available at the moment.","rechargeNotAvailableTitle":"Can\'t recharge your account ?","rechargeNotAvailableMessage":"Please contact our support team who will tell you what to do.","contactByPhone":"Contact us by phone at {phoneNumber}","contactByEmail":"Contact us by email at {email}","done":"Done"},"rechargeBankToWallet":{"title":"Recharge by direct debit","subtitle":"Amount to recharge","accountWithdrawnTitle":"Debit external account","accountWithdrawnMessage":"Editable via the Transfers menu","iban":"IBAN","amountToWithdraw":"Amount to be withdrawn :","recharge":"Recharge"},"rechargeByCard":{"title":"Recharge by card","subtitle":"Amount to recharge","creditedAccountTitle":"Credited account","accountId":"N\xb0{id}","amountToCredit":"Amount to be credited :","recharge":"Recharge"},"rechargeSummary":{"title":"Success","rechargedAccount":"Recharged account","rechargeMethod":"Recharge method","bankToWalletMethod":"Direct debit","cardMethod":"By card","rechargeAmount":"Recharged amount","done":"Finish"},"recurringTransfer":{"endDateLabel":"End date","firstExecutionDateLabel":"Start date","frequencyLabel":"Frequency","switchLabel":"Make this a recurring transfer","optionLabel":{"daily":"Daily","weekly":"Weekly","twiceAMonth":"Twice a month","monthly":"Monthly"},"recurringTransferTitleDetails":"To {destinationAccount}","beneficiaryDetails":"Beneficiary details","scheduledAmount":"Scheduled amount","beneficiaryAccount":"Beneficiary account","beneficiaryBIC":"Beneficiary BIC","recurringTransferDetails":"Recurring transfer details","sourceAccount":"Source account","frequency":"Frequency","nextExecutionDate":"Next execution date","endDate":"End date","description":"Description"},"transactionCode":{"title":"Transaction code","description":"Create a code to use it in one of our points of transaction.","noCodeAvailable":"No active transaction code","noCodeAvailableExplanation":"To generate a new transaction code, obtain the partner\'s 6-digit number.","codeTooltip":"Code","newCodeButton":"New code","modalBackButton":"Back","selectAcceptor":{"title":"Transaction point","description":"Enter the 6-digit number of the transaction point","next":"Next"},"selectAmount":{"title":"Allowed amount","acceptorReminder":"Transaction point : {acceptorId}","currencyLabel":"Currency :","amountLabel":"Amount :","amountInformationLabel":"Maximum transaction amount (including fees)","next":"Generate my code"},"pincode":{"title":"Secret code","description":"Enter your secret code to finish"},"summary":{"title":"Success","transactionCode":"Transaction code","transactionPoint":"Transaction point","maxAmount":"Max. amount","expiryDate":"Expiry date","done":"Done"}},"trustChoice":{"title":"Trust this browser ?","explanation":"If you choose to trust this browser, you will not have to enter a validation code during your next connection.","laterButton":"Not now","dontTrustButton":"Do not trust","trustButton":"Trust"},"ubbleCheckScreen":{"success":{"title":"WELL DONE!","subtitle":"Thank you for your submission!","message":"Your identity is being verified on our end. Verification process can take from a few hours up to a few days.\\nYou can now log in your space or close this window.","button":"Continue to login"},"fail":{"title":"Oops!","subtitle":"Something went wrong during the submission process...","message":"You can try again using the same link as before.\\nIf you experience an other error, please take contact with our team by phone or e-mail using the buttons below.","byPhone":"Phone","byEmail":"E-mail"}},"justifyScreen":{"title":"Justify your expenses","subtitle":"Add or modify your justifications","attachments":{"title":"Attachments","sectionTitle":"Upload your attachments","sectionSubtitle":"Format pdf, jpeg, png","addButtonLabel":"Add an attachment","addOtherButtonLabel":"Add another attachment","deletePrompt":{"title":"Supprimer le justificatif","message":"\xcates-vous s\xfbr de vouloir supprimer ce justificatif ?","cancelButton":"Annuler","confirmButton":"Supprimer"}},"spendings":{"title":"Spendings","sectionTitle":"Add a spending","sectionSubtitle":"Declare your spendings","addButtonLabel":"Add a spending","addOtherButtonLabel":"Add another spending","addModal":{"title":"Add a spending","editTitle":"Edit a spending","message":"Additional details of the justification","createButton":"Add","editButton":"Edit"},"addForm":{"titleLabel":"Title","categoryLabel":"Category","subcategoryLabel":"Subcategory","amountLabel":"Amount","additionalDataLabel":"Additional data","addAdditionalDataButton":"Add another data item"},"deletePrompt":{"title":"Supprimer le justificatif","message":"\xcates-vous s\xfbr de vouloir supprimer ce justificatif ?","cancelButton":"Annuler","confirmButton":"Supprimer"}}},"selectField":{"select":"Select","select_an_option":"Select an option"},"refundTransactionModal":{"title":"Ask for a refund","message":"To ask for a refund, please select a reason below:","reasons":{"AC03":"Wrong IBAN","AM09":"Wrong montant","CUST":"Customer decision"},"confirmButton":"Confirm","cancelButton":"Cancel","success":"Your refund request has been sent"},"upcomingTransfers":{"description":"View and manage your upcoming transfers","editTransfer":"Edit recurring transfer","loadMore":"Load more","nextOn":"Next on","status":{"activated":"Active","deactivated":"Paused","expired":"Executed","deleted":"Canceled"},"deletePrompt":{"title":"Delete Upcoming transfer?","message":"Do you really want to delete Upcoming transfer {id} ?"},"confirmButton":"Confirm","sourceAccount":"Source account","scheduledAmount":"Scheduled amount","message":"Message","startDate":"Start date","frequency":"Frequency","endDate":"End date"},"createSavingsAccount":{"title":"Open a savings account","selectAccount":"Select savings account type","initialDeposit":"Initial deposit","accountToCollect":"Account to collect","duration":"Duration","sendRequest":"Send request","selectAccountTypeLabel":"Select the type of the account to collect","selectAccountType":{"INTERNAL":"Internal","EXTERNAL":"External"},"creationSuccessMessage":"Your request to open a savings account has been successfully sent"},"gender":{"male":"Male","female":"Female","unknown":"Unknown"},"mandates":{"description":"View and manage your mandates","status":{"all":"All statuses","active":"Active","opposed":"Opposed","consumed":"Consumed","revoked":"Revoked","creditorOpposed":"Creditor opposed","obsolete":"Obsolete"},"details":{"to":"To","mandateDetails":"Mandate details","reference":"Reference","id":"Id","signatureDate":"Signature date","creditorDetails":"Creditor details","creditorRef":"Creditor reference","accountInformation":"Account information","accountIban":"Account IBAN","accountBic":"Account BIC"},"opposePrompt":{"title":{"first":"Oppose","second":"mandate"},"message":"Do you really want to oppose the mandate {reference} to {creditorName}?"},"activatePrompt":{"title":{"first":"Activate","second":"mandate"},"message":"Do you really want to activate the mandate {reference} to {creditorName}?"},"confirmButton":"Confirm"},"mandatesSubmenu":{"mandates":"Mandates"}}');

});

parcelRegister("luMxq", function(module, exports) {
module.exports = JSON.parse('{"PARTY_AUTHENTICATION_SMS_OTP_ALREADY_SENT":"Un code de v\xe9rification a d\xe9j\xe0 \xe9t\xe9 envoy\xe9 \xe0 ce num\xe9ro de t\xe9l\xe9phone.","TRANSACTION_WITHDRAW_CODE_GENERATION_ERROR":"Le retrait n\'est pas autoris\xe9 pour ce point de transaction","common":{"fileConstraints":{"formats":"Formats accept\xe9s","maxSize":"Taille maximale","tooBig":"Le fichier choisi d\xe9passe la taille autoris\xe9e.","wrongType":"Le format du fichier choisi n\'est pas accept\xe9.","openLabel":"Voir les contraintes attendues pour ce fichier"},"fileField":{"sentOn":"Envoy\xe9 le {date}","sent":"Document envoy\xe9"},"today":"Aujourd\'hui","clear":"Effacer","yesterday":"Hier","goBack":"Retour","languages":{"fr_FR":"Fran\xe7ais (France)","en_US":"English (USA)","es_ES":"Espa\xf1ol (Espa\xf1a)","af_NA":"Afrikaans (Namibia)","af_ZA":"Afrikaans (South Africa)","ak_CI":"Akan (C\xf4te d\u2019Ivoire)","ak_GH":"Akan (Ghana)","gn_PY":"Ava\xf1e\'\u1EBD","ay_BO":"Aymar aru","az_AZ":"Az\u0259rbaycan dili","id_ID":"Bahasa Indonesia","ms_MY":"Bahasa Melayu","ms_BN":"Bahasa Melayu (Brunei)","ms_CC":"Bahasa Melayu (Cocos (Keeling) Islands)","ms_SG":"Bahasa Melayu (Singapore)","bm_BF":"Bamanakan (Burkina Faso)","bm_CI":"Bamanakan (C\xf4te d\u2019Ivoire)","bm_GM":"Bamanakan (Gambia)","bm_ML":"Bamanakan (Mali)","jv_ID":"Basa Jawa","bh_IN":"Bihari (India)","bs_BA":"Bosanski","br_FR":"Brezhoneg (France)","ca_ES":"Catal\xe0","ca_AD":"Catal\xe0 (Andorra)","ce_RU":"Chechen (Russia)","sn_BW":"ChiShona (Botswana)","sn_MZ":"ChiShona (Mozambique)","sn_ZW":"ChiShona (Zimbabwe)","ht_GA":"Cr\xe9ole haitien (Grandans)","ht_OU":"Cr\xe9ole haitien (Lw\xe8s)","ht_NI":"Cr\xe9ole haitien (Nip)","ht_ND":"Cr\xe9ole haitien (N\xf2)","ht_NO":"Cr\xe9ole haitien (N\xf2dw\xe8s)","ht_NE":"Cr\xe9ole haitien (N\xf2d\xe8s)","ht_CE":"Cr\xe9ole haitien (Sant)","ht_SD":"Cr\xe9ole haitien (Sid)","ht_SE":"Cr\xe9ole haitien (Sid\xe8s)","cy_GB":"Cymraeg","cy_AR":"Cymraeg (Argentina)","da_DK":"Dansk","da_FO":"Dansk (Faroe Islands)","da_DE":"Dansk (Germany)","da_GL":"Dansk (Greenland)","fa_AF":"Dari","se_NO":"Davvis\xe1megiella","de_BE":"Deutsch (Belgium)","de_DK":"Deutsch (Denmark)","de_DE":"Deutsch (Deutschland)","de_FR":"Deutsch (France)","de_HU":"Deutsch (Hungary)","de_IT":"Deutsch (Italy)","de_LI":"Deutsch (Liechtenstein)","de_LU":"Deutsch (Luxembourg)","de_PL":"Deutsch (Poland)","de_CH":"Deutsch (Schweiz)","de_AT":"Deutsch (\xd6sterreich)","dv_MV":"Divehi (Maldives)","dz_BT":"Dzongkha (Bhutan)","et_EE":"Eesti (Estonia)","en_AS":"English (American Samoa)","en_AI":"English (Anguilla)","en_AG":"English (Antigua & Barbuda)","en_AU":"English (Australia)","en_BS":"English (Bahamas)","en_BB":"English (Barbados)","en_BE":"English (Belgium)","en_BZ":"English (Belize)","en_BM":"English (Bermuda)","en_BW":"English (Botswana)","en_IO":"English (British Indian Ocean Territory)","en_VG":"English (British Virgin Islands)","en_BN":"English (Brunei)","en_CM":"English (Cameroon)","en_CA":"English (Canada)","en_KY":"English (Cayman Islands)","en_CK":"English (Cook Islands)","en_DM":"English (Dominica)","en_ER":"English (Eritrea)","en_ET":"English (Ethiopia)","en_FK":"English (Falkland Islands)","en_FJ":"English (Fiji)","en_GM":"English (Gambia)","en_GH":"English (Ghana)","en_GI":"English (Gibraltar)","en_GD":"English (Grenada)","en_GU":"English (Guam)","en_GY":"English (Guyana)","en_HK":"English (Hong Kong SAR China)","en_IN":"English (India)","en_IE":"English (Ireland)","en_IL":"English (Israel)","en_JM":"English (Jamaica)","en_KE":"English (Kenya)","en_KI":"English (Kiribati)","en_LS":"English (Lesotho)","en_LR":"English (Liberia)","en_MW":"English (Malawi)","en_MT":"English (Malta)","en_MH":"English (Marshall Islands)","en_MU":"English (Mauritius)","en_FM":"English (Micronesia)","en_MS":"English (Montserrat)","en_NA":"English (Namibia)","en_NR":"English (Nauru)","en_NZ":"English (New Zealand)","en_NG":"English (Nigeria)","en_NU":"English (Niue)","en_NF":"English (Norfolk Island)","en_MP":"English (Northern Mariana Islands)","en_PK":"English (Pakistan)","en_PW":"English (Palau)","en_PG":"English (Papua New Guinea)","en_PH":"English (Philippines)","en_PI":"English (Pirate)","en_PN":"English (Pitcairn Islands)","en_PR":"English (Puerto Rico)","en_RW":"English (Rwanda)","en_WS":"English (Samoa)","en_SC":"English (Seychelles)","en_SL":"English (Sierra Leone)","en_SG":"English (Singapore)","en_SB":"English (Solomon Islands)","en_SO":"English (Somalia)","en_ZA":"English (South Africa)","en_SH":"English (St. Helena)","en_KN":"English (St. Kitts & Nevis)","en_LC":"English (St. Lucia)","en_VC":"English (St. Vincent & Grenadines)","en_SZ":"English (Swaziland)","en_TK":"English (Tokelau)","en_TO":"English (Tonga)","en_TT":"English (Trinidad & Tobago)","en_TC":"English (Turks & Caicos Islands)","en_UM":"English (U.S. Outlying Islands)","en_VI":"English (U.S. Virgin Islands)","en_GB":"English (UK)","en_UG":"English (Uganda)","en_UD":"English (Upside Down)","en_VU":"English (Vanuatu)","en_ZM":"English (Zambia)","en_ZW":"English (Zimbabwe)","es_AR":"Espa\xf1ol (Argentine)","es_BO":"Espa\xf1ol (Bolivia)","es_CL":"Espa\xf1ol (Chile)","es_CO":"Espa\xf1ol (Colombia)","es_CR":"Espa\xf1ol (Costa Rica)","es_CU":"Espa\xf1ol (Cuba)","es_DO":"Espa\xf1ol (Dominican Republic)","es_EC":"Espa\xf1ol (Ecuador)","es_SV":"Espa\xf1ol (El Salvador)","es_GQ":"Espa\xf1ol (Equatorial Guinea)","es_US":"Espa\xf1ol (Estados Unidos)","es_GT":"Espa\xf1ol (Guatemala)","es_HN":"Espa\xf1ol (Honduras)","es_LA":"Espa\xf1ol (Latinoam\xe9rica)","es_MX":"Espa\xf1ol (M\xe9xico)","es_NI":"Espa\xf1ol (Nicaragua)","es_PA":"Espa\xf1ol (Panama)","es_PY":"Espa\xf1ol (Paraguay)","es_PE":"Espa\xf1ol (Peru)","es_PR":"Espa\xf1ol (Puerto Rico)","es_UY":"Espa\xf1ol (Uruguay)","es_VE":"Espa\xf1ol (Venezuela)","eo_EO":"Esperanto","eu_ES":"Euskara","ee_GH":"E\u028Begbe (Ghana)","ee_TG":"E\u028Begbe (Togo)","tl_PH":"Filipino","fr_AD":"Fran\xe7ais (Andorra)","fr_BE":"Fran\xe7ais (Belgique)","fr_BJ":"Fran\xe7ais (Benin)","fr_BF":"Fran\xe7ais (Burkina Faso)","fr_BI":"Fran\xe7ais (Burundi)","fr_CM":"Fran\xe7ais (Cameroon)","fr_CA":"Fran\xe7ais (Canada)","fr_CF":"Fran\xe7ais (Central African Republic)","fr_TD":"Fran\xe7ais (Chad)","fr_KM":"Fran\xe7ais (Comoros)","fr_CG":"Fran\xe7ais (Congo - Brazzaville)","fr_CD":"Fran\xe7ais (Congo - Kinshasa)","fr_CI":"Fran\xe7ais (C\xf4te d\u2019Ivoire)","fr_DJ":"Fran\xe7ais (Djibouti)","fr_GF":"Fran\xe7ais (French Guiana)","fr_PF":"Fran\xe7ais (French Polynesia)","fr_GA":"Fran\xe7ais (Gabon)","fr_GP":"Fran\xe7ais (Guadeloupe)","fr_GN":"Fran\xe7ais (Guinea)","fr_HT":"Fran\xe7ais (Haiti)","fr_IT":"Fran\xe7ais (Italy)","fr_LB":"Fran\xe7ais (Lebanon)","fr_LU":"Fran\xe7ais (Luxembourg)","fr_MG":"Fran\xe7ais (Madagascar)","fr_ML":"Fran\xe7ais (Mali)","fr_MQ":"Fran\xe7ais (Martinique)","fr_MR":"Fran\xe7ais (Mauritanie)","fr_YT":"Fran\xe7ais (Mayotte)","fr_MC":"Fran\xe7ais (Monaco)","fr_NC":"Fran\xe7ais (New Caledonia)","fr_NE":"Fran\xe7ais (Niger)","fr_RW":"Fran\xe7ais (Rwanda)","fr_RE":"Fran\xe7ais (R\xe9union)","fr_SC":"Fran\xe7ais (Seychelles)","fr_PM":"Fran\xe7ais (St. Pierre & Miquelon)","fr_CH":"Fran\xe7ais (Suisse)","fr_TG":"Fran\xe7ais (Togo)","fr_GB":"Fran\xe7ais (United Kingdom)","fr_VU":"Fran\xe7ais (Vanuatu)","fr_VA":"Fran\xe7ais (Vatican City)","fr_WF":"Fran\xe7ais (Wallis & Futuna)","fy_NL":"Frysk","fo_FO":"F\xf8royskt","ga_IE":"Gaeilge (Gaelic)","ga_GB":"Gaeilge (United Kingdom)","gv_GB":"Gaelg (United Kingdom)","gl_ES":"Galego","ha_BF":"Hausa (Burkina Faso)","ha_NE":"Hausa (Niger)","ha_NG":"Hausa (Nigeria)","ha_SD":"Hausa (Sudan)","ha_TG":"Hausa (Togo)","hr_HR":"Hrvatski","hr_BA":"Hrvatski (Bosnia & Herzegovina)","ig_NG":"Igbo (Nigeria)","rn_BI":"Ikirundi (Uburundi)","iu_CA":"Inuktitut (Canada)","nd_ZW":"IsiNdebele (Zimbabwe)","it_IT":"Italiano","it_HR":"Italiano (Croatia)","it_SM":"Italiano (San Marino)","it_SI":"Italiano (Slovenia)","it_CH":"Italiano (Switzerland)","it_VA":"Italiano (Vatican City)","jv_MY":"Javanese (Malaysia)","jv_SR":"Javanese (Suriname)","kl_GL":"Kalaallisut (Greenland)","ks_IN":"Kashmiri (India)","kw_GB":"Kernewek (United Kingdom)","kg_CG":"KiKongo (Congo Brazzaville)","kg_CD":"KiKongo (Congo Kinshasa RDC)","sw_KE":"Kiswahili","sw_TZ":"Kiswahili (Tanzania)","ku_IR":"Kurdish (Iran)","ku_IQ":"Kurdish (Iraq)","ku_TR":"Kurd\xee","ky_KG":"Kyrgyz (Kyrgyzstan)","lo_LA":"Lao (Laos)","ht_AR":"Latibonit","la_VA":"Latin","lv_LV":"Latvie\u0161u","to_TO":"Lea fakatonga (Tonga)","lt_LT":"Lietuvi\u0173","ln_CG":"Ling\xe1la (Congo - Brazzaville)","ln_CD":"Ling\xe1la (Congo - Kinshasa)","lg_UG":"Luganda (Uganda)","lb_DE":"Luxembourgish (Germany)","lb_LU":"Luxembourgish (Luxembourg)","li_NL":"L\xe8mb\xf6rgs","hu_HU":"Magyar","hu_AT":"Magyar (Austria)","hu_RO":"Magyar (Romania)","hu_SK":"Magyar (Slovakia)","hu_SI":"Magyar (Slovenia)","hu_UA":"Magyar (Ukraine)","mg_MG":"Malagasy","mt_MT":"Malti","ro_MD":"Moldavian","mo_MD":"Moldavian (Moldova)","nl_AW":"Nederlands (Aruba)","nl_BE":"Nederlands (Belgi\xeb)","nl_NL":"Nederlands (Nederland)","nl_SR":"Nederlands (Suriname)","nb_NO":"Norsk (bokm\xe5l)","nn_NO":"Norsk (nynorsk)","se_SE":"Northern Sami (Sweden)","no_NO":"Norwegian (Norway)","ny_MW":"Nyanja (Malawi)","uz_UZ":"O\'zbek","om_ET":"Oromoo (Ethiopia)","om_KE":"Oromoo (Kenya)","os_AZ":"Ossetic (Azerbaijan)","os_GE":"Ossetic (Georgia)","os_KZ":"Ossetic (Kazakhstan)","os_RU":"Ossetic (Russia)","os_TJ":"Ossetic (Tajikistan)","os_TM":"Ossetic (Turkmenistan)","os_UA":"Ossetic (Ukraine)","os_UZ":"Ossetic (Uzbekistan)","pl_PL":"Polski","pl_UA":"Polski (Ukraine)","pt_AO":"Portugu\xeas (Angola)","pt_BR":"Portugu\xeas (Brasil)","pt_CV":"Portugu\xeas (Cape Verde)","pt_GW":"Portugu\xeas (Guinea-Bissau)","pt_MZ":"Portugu\xeas (Mozambique)","pt_PT":"Portugu\xeas (Portugal)","pt_ST":"Portugu\xeas (S\xe3o Tom\xe9 & Pr\xedncipe)","pt_TL":"Portugu\xeas (Timor-Leste)","ff_MR":"Pulaar (Mauritania)","ff_NE":"Pulaar (Niger)","ff_NG":"Pulaar (Nigeria)","ff_SN":"Pulaar (Senegal)","qu_PE":"Qhichwa","ty_PF":"Reo Tahiti","ro_RO":"Rom\xe2n\u0103","ro_UA":"Rom\xe2n\u0103 (Ukraine)","rm_CH":"Rumantsch","gd_GB":"Scottish Gaelic (United Kingdom)","sq_AL":"Shqip","sk_HU":"Sloven\u010Dina (Hungary)","sk_SK":"Sloven\u010Dina (Slovakia)","sl_SI":"Sloven\u0161\u010Dina","so_DJ":"Soomaali (Djibouti)","so_ET":"Soomaali (Ethiopia)","so_KE":"Soomaali (Kenya)","so_SO":"Soomaaliga","nr_ZA":"South Ndebele (South Africa)","st_LS":"Southern Sotho (Lesotho)","fi_FI":"Suomi","fi_SE":"Suomi (Sweden)","sv_SE":"Svenska","sv_FI":"Svenska (Finland)","sv_AX":"Svenska (\xc5land Islands)","ss_ZA":"Swati (South Africa)","ss_SZ":"Swati (Swaziland)","sg_CF":"S\xe4ng\xf6 (Central African Republic)","vi_VN":"Ti\u1EBFng Vi\u1EC7t","ts_ZA":"Tsonga (South Africa)","tn_BW":"Tswana (Botswana)","tn_ZA":"Tswana (South Africa)","tk_TM":"Turkmen (Turkmenistan)","tr_TR":"T\xfcrk\xe7e","tr_BG":"T\xfcrk\xe7e (Bulgaria)","tr_CY":"T\xfcrk\xe7e (Cyprus)","tr_MD":"T\xfcrk\xe7e (Moldova)","ug_AF":"Uyghur (Afghanistan)","ug_KZ":"Uyghur (Kazakhstan)","ug_KG":"Uyghur (Kyrgyzstan)","ug_TJ":"Uyghur (Tajikistan)","ug_TR":"Uyghur (Turkey)","ug_UZ":"Uyghur (Uzbekistan)","ve_ZA":"Venda (South Africa)","ve_ZW":"Venda (Zimbabwe)","wa_BE":"Walloon (Belgium)","fy_DE":"Western Frisian (Germany)","wo_GM":"Wolof (Gambia)","wo_MR":"Wolof (Mauritania)","wo_SN":"Wolof (Senegal)","xh_LS":"Xhosa (Lesotho)","yi_AU":"Yiddish (Australia)","yi_BY":"Yiddish (Belarus)","yi_BE":"Yiddish (Belgium)","yi_CA":"Yiddish (Canada)","yi_EE":"Yiddish (Estonia)","yi_IL":"Yiddish (Israel)","yi_LV":"Yiddish (Latvia)","yi_LT":"Yiddish (Lithuania)","yi_MD":"Yiddish (Moldova)","yi_PL":"Yiddish (Poland)","yi_RO":"Yiddish (Romania)","yi_RU":"Yiddish (Russia)","yi_ZA":"Yiddish (South Africa)","yi_UA":"Yiddish (Ukraine)","yi_US":"Yiddish (United States)","en_UK":"en_UK","xh_ZA":"isiXhosa","zu_ZA":"isiZulu","yo_NG":"\xc8d\xe8 Yor\xf9b\xe1 (Nigeria)","is_IS":"\xcdslenska (Iceland)","cs_CZ":"\u010Ce\u0161tina","el_GR":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC","el_CY":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (Cyprus)","uz_AF":"\u040E\u0437\u0431\u0435\u043A (Afghanistan)","be_BY":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F","bg_BG":"\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438","mk_MK":"\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438)","mn_MN":"\u041C\u043E\u043D\u0433\u043E\u043B","ru_RU":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439","sr_BA":"\u0421\u0440\u043F\u0441\u043A\u0438 (Bosnia & Herzegovina)","sr_HU":"\u0421\u0440\u043F\u0441\u043A\u0438 (Hungary)","sr_RS":"\u0421\u0440\u043F\u0441\u043A\u0438 (Serbia)","uk_UA":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","ru_UA":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (Ukraine)","tt_RU":"\u0442\u0430\u0442\u0430\u0440\u0447\u0430","tg_TJ":"\u0442\u043E\u04B7\u0438\u043A\u04E3","uk_MD":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 (Moldova)","kk_KZ":"\u049A\u0430\u0437\u0430\u049B\u0448\u0430","hy_AM":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576","yi_DE":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9 (German)","he_IL":"\u05E2\u05D1\u05E8\u05D9\u05EA\u200F","ur_PK":"\u0627\u0631\u062F\u0648","ur_IN":"\u0627\u0631\u062F\u0648 (India)","ar_DZ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Algeria)","ar_AR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Argentina)","ar_BH":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Bahrain)","ar_TD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Chad)","ar_EG":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Egypt)","ar_IN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (India)","ar_IQ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Iraq)","ar_IL":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Israel)","ar_JO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Jordan)","ar_KW":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Kuwait)","ar_LB":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Lebanon)","ar_LY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Libya)","ar_MR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Mauritania)","ar_MA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Morocco)","ar_OM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Oman)","ar_PS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Palestinian Territories)","ar_QA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Qatar)","ar_SO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Somalia)","ar_SD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Sudan)","ar_SY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Syria)","ar_TN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Tunisia)","ar_AE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (United Arab Emirates)","ar_YE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Yemen)","ar_SA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)","fa_IR":"\u0641\u0627\u0631\u0633\u06CC","ps_AF":"\u067E\u069A\u062A\u0648","ne_NP":"\u0928\u0947\u092A\u093E\u0932\u0940","ne_BT":"\u0928\u0947\u092A\u093E\u0932\u0940 (Bhutan)","ne_IN":"\u0928\u0947\u092A\u093E\u0932\u0940 (India)","mr_IN":"\u092E\u0930\u093E\u0920\u0940","sa_IN":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D","hi_IN":"\u0939\u093F\u0928\u094D\u0926\u0940","as_IN":"\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE (India)","bn_SG":"\u09AC\u09BE\u0982\u09B2\u09BE (Singapore)","bn_IN":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AD\u09BE\u09B0\u09A4)","bn_BD":"\u09AC\u09BE\u0982\u09B2\u09BE(\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)","pa_IN":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 (\u0A2D\u0A3E\u0A30\u0A24 \u0A28\u0A42\u0A70)","gu_IN":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0","or_IN":"\u0B13\u0B21\u0B3C\u0B3F\u0B06","ta_IN":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD","ta_SG":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (Singapore)","te_IN":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41","kn_IN":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1 (India)","ml_IN":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02","si_LK":"\u0DB4\u0DC5\u0DCF\u0DAD","si_TH":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD (Thailand)","th_TH":"\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22 (\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22)","bo_CN":"\u0F54\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0B (China)","my_MM":"\u1017\u1019\u102C (Myanmar (Burma))","ka_GE":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8","ti_ER":"\u1275\u130D\u122D\u129B (Eritrea)","ti_ET":"\u1275\u130D\u122D\u129B (Ethiopia)","am_ET":"\u12A0\u121B\u122D\u129B (Ethiopia)","ck_US":"\u13E3\u13B3\u13A9 (tsalagi)","km_KH":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","gx_GR":"\u1F19\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u1F00\u03C1\u03C7\u03B1\u03AF\u03B1","zh_MO":"\u4E2D\u6587 (Macau SAR China)","zh_CN":"\u4E2D\u6587\uFF08\u4E2D\u56FD\uFF09","zh_TW":"\u4E2D\u6587\uFF08\u53F0\u7063\uFF09","zh_SG":"\u4E2D\u6587\uFF08\u65B0\u52A0\u5761\uFF09","zh_HK":"\u4E2D\u6587\uFF08\u9999\u6E2F\uFF09","ja_JP":"\u65E5\u672C\u8A9E","ii_CN":"\uA188\uA320\uA259 (China)","ko_KP":"\uD55C\uAD6D\uC5B4 (North Korea)","ko_KR":"\uD55C\uAD6D\uC5B4 (\u97E9\u56FD)"},"autocompletePicker":{"placeholder":"S\xe9lectionner...","searchPlaceholder":"\xc9crire au moins 3 caract\xe8res pour rechercher...","noResults":"Aucun r\xe9sultat pour cette recherche"},"invalidPhoneNumber":"Le num\xe9ro de t\xe9l\xe9phone est invalide","yes":"Oui","no":"Non","cancel":"Annuler","validate":"Valider"},"authScreen":{"welcome":"Bienvenue sur votre portail bancaire","headline":"Mon wallet 100% simple et s\xe9curis\xe9","headlineDescription":"G\xe9rez vos d\xe9penses professionnelles, qualifiez vos transactions et importez vos justificatifs en un clin d\'\u0153il.","subtitle":"Connectez-vous pour acc\xe9der \xe0 votre espace pro","languages":"Langues","login":"Connexion","createAccount":"Ouvrir un compte","appstoreLink":"Appstore","playstoreLink":"Playstore","goToCompanyPortalQuestion":"Vous \xeates une entreprise ?","goToCompanyPortalLink":"Espace entreprises","goToPartnersPortalQuestion":"Vous \xeates un commer\xe7ant ?","goToPartnersPortalLink":"Espace commer\xe7ants","goToAgentPortalQuestion":"Vous \xeates un agent ?","goToAgentPortalLink":"Espace agents","storesAvailable":"Disponible aussi sur","disconnectedDueToInactivity":"Vous avez \xe9t\xe9 d\xe9connect\xe9 suite \xe0 une inactivit\xe9 prolong\xe9e","authenticationFailure":{"title":"\xc9chec de l\'authentification"}},"connectScreen":{"title":"Bienvenue sur [emph]Skaleet[/emph]","subtitle":"Veuillez entrer votre num\xe9ro de t\xe9l\xe9phone pour vous connecter","lostPhoneButton":"Num\xe9ro de t\xe9l\xe9phone oubli\xe9 ?","connectButton":"Se connecter","registerQuestion":"Vous n\'avez pas de compte ?","registerButton":"Cr\xe9er un compte","errorTitle":"Une erreur est survenue","noAccountError":"Nous n\'avons pu trouver de compte pour le {phoneNumber}. Vous pouvez cr\xe9er un compte pour vous connecter.","pincodeTitle":"Code [emph]secret[/emph]","otpTitle":"V\xe9rification en [emph]deux \xe9tapes[/emph]","noCodeQuestion":"Code non re\xe7u ?","contactSupportLink":"Veuillez contacter le support.","contactSupport":{"title":"Vous n\'avez plus [emph]acc\xe8s au t\xe9l\xe9phone[/emph] rattach\xe9 \xe0 votre compte ?","message":"Pour modifier vos coordonn\xe9es, veuillez prendre contact avec notre \xe9quipe support qui vous indiquera la marche \xe0 suivre.","byPhone":"Nous contacter par t\xe9l\xe9phone","byEmail":"Nous contacter par email","done":"Terminer"}},"errorScreen":{"subTitle":"Trop de demandes","title":"La tentative de connexion a \xe9chou\xe9","message":"Nous ne pouvons pas traiter votre demande de connexion pour le moment.\\n\\n Veuillez r\xe9essayer plus tard.","button":"Revenir \xe0 la page de connexion"},"onboardingStatusCard":{"title":"Plus d\'informations sont n\xe9cessaires concernant votre dossier d\'inscription","subtitle":"Lorem ipsum dolor sit amet","button":"Compl\xe9ter mon dossier"},"onboardingDelegateErrorStatusCard":{"title":"Impossible d\u2019acc\xe9der au formulaire d\u2019inscription en tant qu\u2019utilisateur d\xe9l\xe9gu\xe9. Les fonctionnalit\xe9s disponibles sont limit\xe9es. Le propri\xe9taire du compte doit compl\xe9ter son inscription."},"onboardingScreen":{"progressLabel":"\xc9tape {step} sur {count} : {label}","initialStepTitle":"Bienvenue sur [emph]MWallet.[/emph]","resumptionStepTitle":"Dites nous en plus sur [emph]vous[/emph]","successIntroduction":"F\xe9licitations","successTitle":"Votre inscription est finalis\xe9e","submissionThanks":"Merci pour votre soumission !","identityVerificationDescription":"Votre identit\xe9 est en cours de v\xe9rification. Le processus peut prendre de quelques heures \xe0 quelques jours. Vous pouvez maintenant vous connecter \xe0 votre espace ou fermer cette fen\xeatre.","successButton":"Commencer !","initiationSuccessTitle":"Votre inscription a \xe9t\xe9 initi\xe9e avec succ\xe8s.","initiationSuccessButton":"Se connecter","initiationSuccessMsg":"Un code secret a \xe9t\xe9 envoy\xe9 \xe0 {phone}","getStartedButton":"Commencer","cancelButton":"Annuler","back":"Pr\xe9c\xe9dent","next":"Suivant","save":"Enregistrer","submit":"Soumettre","taxedNumberError":{"undefined":"Erreur : Veuillez saisir un num\xe9ro de t\xe9l\xe9phone valide.","PREMIUM_RATE":"Erreur: Les num\xe9ros \xe0 tarif major\xe9 ne peuvent pas \xeatre utilis\xe9s pour l\u2019enregistrement d\u2019un compte. Veuillez fournir un num\xe9ro de t\xe9l\xe9phone mobile ou fixe.","TOLL_FREE":"Erreur: Les num\xe9ros gratuits ne sont pas pris en charge pour la v\xe9rification du compte. Veuillez utiliser un num\xe9ro de t\xe9l\xe9phone mobile ou fixe standard.","SHARED_COST":"Erreur: Les num\xe9ros avec facturation \xe0 frais partag\xe9s ne sont pas autoris\xe9s pour la cr\xe9ation de compte. Veuillez saisir un num\xe9ro de mobile ou de ligne fixe.","VOIP":"Erreur: Les num\xe9ros de t\xe9l\xe9phone Internet ne sont pas \xe9ligibles \xe0 l\u2019enregistrement. Veuillez utiliser un num\xe9ro de t\xe9l\xe9phone mobile ou fixe standard.","PERSONAL_NUMBER":"Erreur: Les num\xe9ros personnels connect\xe9s par satellite ne sont pas accept\xe9s. Veuillez utiliser un num\xe9ro de t\xe9l\xe9phone mobile ou fixe.","PAGER":"Erreur: Les appareils de t\xe9l\xe9avertisseur ne sont pas valides pour la cr\xe9ation de compte. Veuillez fournir un num\xe9ro de t\xe9l\xe9phone mobile ou fixe accept\xe9.","UAN":"Erreur : Les num\xe9ros d\'acc\xe8s universels (UAN) ne peuvent pas \xeatre utilis\xe9s pour l\'enregistrement. Veuillez saisir un num\xe9ro de t\xe9l\xe9phone mobile ou fixe valide.","VOICEMAIL":"Erreur : Les num\xe9ros d\xe9di\xe9s aux services de messagerie vocale ne peuvent pas \xeatre utilis\xe9s. Veuillez saisir un num\xe9ro de mobile ou de t\xe9l\xe9phone fixe pouvant recevoir directement des appels."},"formLabels":{"selectDistributorDuringOnboarding":"Code de distributeur d\'int\xe9gration","selectDistributorDuringOnboardingHelperText":"Veuillez renseigner l\u2019ID fourni par votre r\xe9f\xe9rent carte.","firstName":"Pr\xe9nom","lastName":"Nom","phoneNumber":"T\xe9l\xe9phone","email":"Email"}},"registerScreen":{"progressLabel":"\xc9tape {step} sur {count} : {label}","progressStepLabel":"\xc9tape {step} sur {count}","progressBackLink":"Retour","firstStepTitle":"Bienvenue !","firstStepSubtitle":"Veuillez entrer votre num\xe9ro de t\xe9l\xe9phone pour vous inscrire","connectQuestion":"Vous poss\xe9dez d\xe9j\xe0 un compte ?","connectButton":"Se connecter","phoneNumberLabel":"Num\xe9ro de t\xe9l\xe9phone","back":"Pr\xe9c\xe9dent","next":"Suivant","finish":"Terminer","otpTitle":"Verification du t\xe9l\xe9phone","otpLabel":"Veuillez entrer le code re\xe7u par SMS","nbPicturesForDocument":{"one":"une photo minimum","others":"{count} photos minimum"},"pictureInputFilled":"Un fichier","pictureInputEmpty":"Choisir ou d\xe9poser une photo","addPictureButton":"Ajouter une page","eulaTitle":"Conditions d\'utilisations","eulaFirstDescription":"Veuillez accepter les conditions d\'utilisation afin de vous cr\xe9er un compte.","eulaSecondDescription":"Vous les trouverez en cliquant sur le lien suivant :","eulaLink":"Conditions d\'utilisations","eulaAcceptLabel":"J\'accepte les conditions d\'utilisations","createMyAccountButton":"Cr\xe9er mon compte","finishTitleLabel":"F\xe9licitations !","finishLabel":"Votre compte a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s.","pincodeLabel":"Votre code secret","pincodeStepTitle":"Votre code [emph]secret.[/emph]","quitConfirmMessage":"Vous \xeates sur le point de quitter l\'inscription. Toutes les donn\xe9es remplis seront perdus. \xcates vous sur de vouloir quitter la page ?","cancel":"Annuler","message":"Vous devez d\xe9sormais choisir un code secret \xe0 quatre chiffres pour votre compte. Surtout, ne le communiquez \xe0 personne, il est strictement confidentiel.","doNotForgetWarning":"Attention, veillez \xe0 bien le conserver : vous en aurez besoin pour vous authentifier et valider toutes vos op\xe9rations. ","successSnackbar":"Votre code secret a bien \xe9t\xe9 valid\xe9","newCodeLabel":"Entrez votre nouveau code","newCodeConfirmationLabel":"Confirmez votre nouveau code","newCodesDontMatchError":"Les codes entr\xe9s ne correspondent pas","noEulaTitle":"Confirmation de la cr\xe9ation de compte","noEulaFirstDescription":"Vous y \xeates presque !","noEulaSecondDescription":"En cliquant sur le bouton suivant, la cr\xe9ation de votre compte sera effective. On y va ?","privacyTitle":"Politique de confidentialit\xe9","privacyFirstDescription":"Veuillez accepter la politique de confidentialit\xe9 afin de vous cr\xe9er un compte.","privacySecondDescription":"Vous la trouverez en cliquant sur le lien suivant :","privacyLink":"Politique de confidentialit\xe9","privacyAcceptLabel":"J\'accepte la politique de confidentialit\xe9","noPrivacyTitle":"Confirmation de la cr\xe9ation de compte","noPrivacyFirstDescription":"Vous y \xeates presque !","noPrivacySecondDescription":"En cliquant sur le bouton suivant, la cr\xe9ation de votre compte sera effective. On y va ?"},"accountOwner":{"male":"M. {name}","female":"Mme {name}","other":"{name}","none":"{name}"},"connectedUserGreetings":{"withName":"Bonjour, \\n[emph]{name}[/emph]\xa0!","hello":"Bonjour,","withoutName":"Bonjour\xa0!"},"clientStatus":{"clientBlockedMessage":"Votre compte est bloqu\xe9.","clientBlockedLink":"Plus d\'informations...","clientPendingMessage":"Votre dossier est en cours de traitement.","accountUnderReview":"Compte en cours de validation : La v\xe9rification de votre dossier peut prendre jusqu\'\xe0 quelques jours."},"profileMenu":{"title":"Profil et param\xe8tres","subtitle":"Retrouvez ici l\'ensemble de vos informations de compte","generalSection":"R\xe9glages g\xe9n\xe9raux","profileTitle":"Mon profil","profileSubtitle":"G\xe9rez votre compte et vos informations","settingsTitle":"Param\xe8tres","settingsSubtitle":"G\xe9rez vos param\xe8tres personnels"},"navigationMenu":{"accountLink":"Accueil","profileLink":"Profil et param\xe8tres","transferLink":"Transferts","payBillLink":"Services","cardsLink":"Ma Carte","savingsLink":"\xc9pargne","loansLink":"Pr\xeats","contactLink":"Aide et assistance","settingsLink":"Voir mon profil","disconnectButton":"Se d\xe9connecter","mandatesLink":"Mandates"},"transfertsSubmenu":{"allTransfer":"Effectuer un virement","externalAccount":"Compte externe","recipients":"B\xe9n\xe9ficiaires","cashTransfer":"Transferts en attente","upcomingTransfers":"Virements permanents","recharge":"Recharger mon compte","transactionCode":"Code de transaction","simpleTransfer":"Par num\xe9ro de t\xe9l\xe9phone"},"savingsSubmenu":{"mySavingsAccount":"Mes comptes d\'\xe9pargne","deposits":"Virements et d\xe9p\xf4ts","createSavingsAccount":"Cr\xe9er un compte d\'\xe9pargne"},"simpleTransfer":{"newTransfer":"Nouveau transfert","title":"Par num\xe9ro de t\xe9l\xe9phone","searchRecipient":"Rechercher un destinataire","invalidPhoneNumber":"Le num\xe9ro de t\xe9l\xe9phone fourni n\'est pas reconnu"},"accountPendingVerification":{"title":"V\xe9rification de compte","subtitle":"Votre demande de cr\xe9ation de compte est en train d\'\xeatre \xe9tudi\xe9e. Veuillez r\xe9essayer ult\xe9rieurement.","retryButton":"R\xe9essayer"},"accountsList":{"title":"Mes comptes.","loadAccountsError":"Une erreur est survenue lors du chargement des comptes.","loadAccountsRetry":"R\xe9essayer","showAllAccountsLink":"Voir tous mes comptes","noAccountAvailable":"Aucun compte n\'est disponible"},"recipient":{"title":"Effectuer un virement","subtitle":"\xc0 qui voulez-vous transf\xe9rer votre argent ?","section":"Mes b\xe9n\xe9ficiaires","noRecipientsAvailable":"Aucun destinataire n\'est disponible","noRecipientsMessage":"Ajoutez des b\xe9n\xe9ficiaires pour transferer de l\u2019argent.","addRecipientButton":"Ajouter un b\xe9n\xe9ficiaire","transferTo":"Transfert vers {name}","searchInputPlaceholder":"Rechercher un b\xe9n\xe9ficiaire","selector":{"beneficiaries":"B\xe9n\xe9ficiaires","externalAccounts":"Comptes externes"},"deletePrompt":{"title":"Supprimer","message":"Voulez-vous vraiment supprimer le destinataire {name} ?","recipient":"un b\xe9n\xe9ficiaire","externalAccountTitle":"Supprimer un compte externe","externalAccountMessage":"\xcates-vous s\xfbr de vouloir supprimer ce compte externe ?","cancelButton":"Annuler","confirmButton":"OK"},"externalAccounts":{"title":"Mes comptes externes","addButton":"Ajouter un compte externe","noneAvailableTitle":"Aucun compte externe actuellement","noneAvailableMessage":"Ajoutez un compte bancaire externe pour transferer de l\u2019argent.","pendingExternalAccountMessage":"Votre compte externe est en cours de validation."}},"addRecipient":{"selector":{"iban":"IBAN","phone":"T\xe9l\xe9phone","account":"N\xb0 compte"},"unauthorized":"Vous n\'\xeates pas autoris\xe9 \xe0 acc\xe8der \xe0 cette fonctionnalit\xe9","title":"Ajouter","subtitle":"un b\xe9n\xe9ficiaire","externalAccountSubtitle":"un compte externe","nameFieldPlaceholder":"Nom","phoneFieldPlaceholder":"Num\xe9ro de t\xe9l\xe9phone","ibanFieldPlaceholder":"IBAN","accountFieldPlaceholder":"Num\xe9ro de compte","bicFieldPlaceholder":"BIC","bankFieldPlaceholder":"Banque / BIC","createButton":"Ajouter","otpAdditionalText":"Ajout du b\xe9n\xe9ficiaire {name}","otpAdditionalTextWithBank":"Ajout du b\xe9n\xe9ficiaire {name} de la banque {bankName}","addConfirmationMessage":"Le b\xe9n\xe9ficiaire {name} a bien \xe9t\xe9 ajout\xe9","searchBank":{"title":"Banque / BIC","bankPlaceholder":"Tapez au moins {num} lettres pour rechercher","firstSearchMessage":"Faites une premi\xe8re recherche pour obtenir des r\xe9sultats","noBankMessage":"Pas de banque correspondante trouv\xe9e","errorMessage":"Une erreur est survenue lors du chargement de la liste des banques.","retryButton":"R\xe9essayer"},"pollingModalSession":{"title":"Approuvez sur l\'application","messageCancelled":"Approbation annul\xe9e","messageFailed":"\xc9chec de l\'approbation","messageRefused":"Approbation refus\xe9e","messageExpired":"Approbation expir\xe9e.","messagePending":"Approbation en attente.","messagePendingCheck":"Veuillez v\xe9rifier votre application.","messageStarted":"Approbation commenc\xe9e.","messageDone":"Approbation r\xe9ussie","error":"Une erreur s\'est produite lors du chargement des op\xe9rations \xe0 approuver."}},"editRecipient":{"title":"Modifier","subtitle":"un destinataire","externalAccountSubtitle":"le compte externe","saveButton":"Enregistrer"},"account":{"accountId":"N\xb0{id}","accountType":{"current":"Compte courant","joint":"Compte joint","savings":"Compte \xe9pargne","dedicated":"Compte d\xe9di\xe9","moneyPot":"Cagnotte","technical":"Compte technique"},"detail":"D\xe9tails"},"accountStatus":{"opened":"Ouvert","closed":"Clos","blocked":"Bloqu\xe9","debitBlocked":"D\xe9bit interdit","creditBlocked":"Cr\xe9dit interdit"},"homeScreen":{"accountBalance":"Solde du compte","monthlyFluxTitle":"Flux de {month}","monthlyFluxIncome":"Mes recettes","monthlyFluxExpense":"Mes d\xe9penses","allTransactionsLink":"Toutes mes transactions","latestTransactionsTitle":"Mes derni\xe8res transactions","requiredActionsTitle":"Actions requises","requiredActionsSeeAll":"Voir tout","transactionsToJustify":"D\xe9penses \xe0 justifier","transactionsToQualify":"D\xe9penses \xe0 qualifier"},"allTransactions":{"title":"Historique des op\xe9rations","subtitle":"Consultez l\'ensemble de vos op\xe9rations et menez les actions n\xe9cessaires"},"accountTransactions":{"title":"Mes transactions.","tagJustified":"Justifi\xe9e","tagNotJustified":"Non justifi\xe9e","tagQualified":"Qualifi\xe9e","tagNotQualified":"Non qualifi\xe9e","emptyTransactionList":"Aucune transaction pour l\'instant","loadTransactionsError":"Une erreur est survenue lors du chargement des transactions.","loadMoreTransactionsError":"Une erreur est survenue lors du chargement des transactions.","loadMoreTransactionsRetry":"R\xe9essayer","unjustifiedTransactions":{"title":{"one":"Vous avez {count} transaction en attente de justificatif","other":"Vous avez {count} transactions en attente de justificatif","more":"Vous avez {count} transactions ou plus en attente de justificatif"},"description":"Certaines de vos transactions attendent des documents de justification."},"unjustifiedTransactions2":{"title":{"one":"Vous avez {count} transaction en attente de justificatif","other":"Vous avez {count} transactions en attente de justificatif","more":"Vous avez {count} transactions ou plus en attente de justificatif"},"description":"Certaines de vos transactions attendent des documents de justification."},"unqualifiedTransactions":{"title":{"one":"Vous avez {count} transaction en attente de qualification","other":"Vous avez {count} transactions en attente de qualification","more":"Vous avez {count} transactions en attente de qualification"},"description":"Certaines de vos transactions attendent une qualification."},"authorizationHolds":{"title":{"one":"Vous avez {count} transaction en attente","other":"Vous avez {count} transactions en attente","more":"Vous avez {count} transactions en attente"},"description":"L\'argent a \xe9t\xe9 d\xe9bit\xe9 de votre compte mais n\'est pas encore re\xe7u par le b\xe9n\xe9ficiaire."},"expenseUnjustified":"Non justifi\xe9","previousPeriodButtonLabel":"P\xe9riode pr\xe9c\xe9dente","nextPeriodButtonLabel":"P\xe9riode suivante"},"authorizationHolds":{"cashoutLabel":"Retrait","paymentLabel":"Paiement","externalToAccountLabel":"Syst\xe8me externe vers compte","accountToExternalLabel":"Compte vers syst\xe8me externe","externalFromAccountLabel":"Syst\xe8me externe depuis compte","accountRechargeLabel":"Rechargement compte","onUsCreditTransferLabel":"Virement on-us","managementFeesLabel":"Frais de gestion"},"accountingTransactionDetailsModal":{"detailsTitle":"D\xe9tails","transferLabel":"Transfert","description":"Description : {description}","transaction":"Transaction n\xb0{id}","reference":"R\xe9f\xe9rence : {id}","feeLabel":"Frais","commissionLabel":"Commission","taxLabel":"Taxes","discountLabel":"R\xe9duction","interestLabel":"Int\xe9r\xeats","amountLabel":"Total","balanceLabel":"Solde apr\xe8s transaction","additionalInformationTitle":"Informations additionnelles","geolocationTitle":"Localisation","externalIdLabel":"R\xe9f\xe9rence de transaction du partenaire : {externalId}","justifyButtonLabel":"Justifier ma d\xe9pense","refundButtonLabel":"Demander un remboursement","verifyJustificationsButtonLabel":"V\xe9rifier mes justificatifs","justificationFollowUpTitle":"Suivi de justification","documentsSubmitted":"Justificatifs d\xe9pos\xe9s","validationInProgress":"En attente de validation"},"authorizationHoldsDetailsModal":{"pending":"En attente","detailsTitle":"D\xe9tails","transferLabel":"Transfert","reference":"Transaction n\xb0{id}","amountLabel":"Total"},"allAccountsScreen":{"goBackClassicViewButton":"Retour sur la vue classique","noAccountAvailable":"Aucun compte n\'est disponible"},"recipientDetail":{"information":"Informations.","accountDetail":"RIB/Domiciliation.","transferMoneyButton":"Envoyer de l\'argent","dedicatedTransferButton":"Transaction cadeau"},"amountSelection":{"amountLabel":"Montant","currencyLabel":"Devise :","descriptionLabel":"Message :","descriptionButton":"Ajouter une description","descriptionPlaceholder":"Ajouter un message","simpleTransferNameLabel":"Nom","simpleTransferNamePlaceholder":"Ajouter un nom","simpleTransferPhoneLabel":"T\xe9l\xe9phone :","simpleTransferPhonePlaceholder":"Ajouter un t\xe9l\xe9phone","sendButton":"Envoyer","since":"Depuis","to":"Vers","choose_source_account":"S\xe9lectionnez le compte \xe0 d\xe9biter","choose_destination_account":"S\xe9lectionnez le compte \xe0 cr\xe9diter","my_accounts":"Mes comptes","my_external_account":"Compte externe","my_recipients":"Mes b\xe9n\xe9ficiaires","network":"R\xe9seau interbancaire","load_more":"Charger plus","convertedAmountLabel":"Montant converti","foreignCurrencyPlaceholder":"Devise","creditorAddress":{"addressLabel":"Adresse","countryLabel":"Pays","buildingNumber":"N\xb0","streetName":"Rue","postCode":"Code postal","townName":"Ville","country":"Pays"},"insufficient_balance":"Le compte s\xe9lectionn\xe9 n\'a pas un solde suffisant pour effectuer cette op\xe9ration","instant_transfer_label":"Faites-en un transfert instantan\xe9"},"acceptorSelection":{"title":"S\xe9lection d\'un commer\xe7ant","selectionButton":"S\xe9lectionner"},"dedicatedTransferAmount":{"title":"Montant du cadeau","subtitle":"Point de transaction : {code}"},"dedicatedTransferSummary":{"recepient":"B\xe9n\xe9ficiaire","account":"Compte d\xe9bit\xe9","amount":"Montant maximum","transactionPoint":"Point de transaction","expirationDate":"Date d\u2019expiration","done":"Terminer"},"pincodeConfirmation":{"label":"Entrez votre code secret pour continuer","networkError":"Veuillez v\xe9rifier votre connexion internet avant de poursuivre","loadKeyboardError":"Une erreur est survenue lors du chargement du clavier.","loadKeyboardRetry":"Recharger le clavier"},"transferSummary":{"accountTransferMode":"Vers compte","cashTransferMode":"Vers cash","summaryTitle":"Succ\xe8s","accountSummarySubtitle":"D\xe9tails du transfert","cashSummarySubtitle":"Vous allez recevoir un message contenant un code \xe0 remettre \xe0 {recipient} ou consulter vos transferts en attente pour r\xe9cup\xe9rer le code.","summaryMiddleStep":"Transfert","fees":"Frais : {amount}","commission":"Commission : {amount}","discount":"R\xe9duction : {amount}","tax":"Taxe : {amount}","you":"Vous","done":"Terminer","customerInstructionSuccessMessage":"Votre virement N\xb0{id} vers {recipient} a bien \xe9t\xe9 effectu\xe9.","recurringTransferSuccessMessage":"Le virement r\xe9current N\xb0{id} \xe0 destination de {recipient} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s."},"billFormScreen":{"nextButton":"Suivant","textInputPlaceholder":"\xc9crivez quelque chose\u2026","saveReferencePromptTitle":"Sauvegarder le {name}","replaceReferencePromptTitle":"Remplacer le {name}","saveReferencePromptMessage":"Voulez-vous sauvegarder le {name} pour ce facturier ?","replaceReferencePromptMessage":"Voulez-vous remplacer le {name} pour ce facturier ?","saveReferencePromptCancel":"Annuler","saveReferencePromptConfirm":"Sauvegarder","replaceReferencePromptConfirm":"Remplacer","saveReferenceErrorMessage":"Le {name} n\'a pas pu \xeatre enregistr\xe9","docInputFilled":"Un fichier","docInputEmpty":"Ajouter ou d\xe9poser une photo ici","confirmationMessage":"Cliquez ci-dessous pour confirmer votre paiement de [b]{amount} [/b] \xe0 [b]{issuer}[/b]","confirmButton":"Confirmer"},"billConfirmationScreen":{"fees":"Frais : [b]{amount}[/b]","commission":"Commission : [b]{amount}[/b]","discount":"R\xe9duction : [b]{amount}[/b]","tax":"Taxe : [b]{amount}[/b]"},"formError":{"invalidIBAN":"L\'IBAN saisi est invalide","invalidFileSize":"Votre fichier d\xe9passe la taille maximale accept\xe9e ({size})","invalidFileFormat":"Le format de votre fichier n\'est pas support\xe9. Formats accept\xe9s : {formats}"},"billIssuersScreen":{"title":"Mes services.","references":"Mes r\xe9f\xe9rences","searchInputPlaceholder":"Rechercher un partenaire","emptyListLabel":"Aucun partenaire disponible","loadBillIssuersError":"Une erreur est survenue lors du chargement des partenaires."},"billReferencesScreen":{"title":"Mes r\xe9f\xe9rences","services":"Retour \xe0 mes services","subtitle":"Donn\xe9es sauvegard\xe9es pour vos paiements","emptyRecipientList":"Aucune r\xe9f\xe9rence enregistr\xe9e","deletePromptTitle":"Suppression de r\xe9f\xe9rence","deletePromptMessage":"Voulez-vous vraiment supprimer la r\xe9f\xe9rence {name} ?","deletePromptCancel":"Annuler","deletePromptConfirm":"Confirmer","deleteConfirmationMessage":"La r\xe9f\xe9rence {name} a bien \xe9t\xe9 supprim\xe9e","deleteErrorMessage":"La suppression de la r\xe9f\xe9rence {name} a \xe9chou\xe9","loadBillReferencesError":"Une erreur est survenue lors du chargement des r\xe9f\xe9rences.","lastUpdateDateTime":"Derni\xe8re mise \xe0 jour : {date} \xe0 {time}"},"otp":{"explanation":"Entrer le code \xe0 six chiffres que vous avez re\xe7u au:","sendBackCodeButton":"Renvoyer le code","confirmOtpButton":"Confirmer","cancelOtpButton":"Annuler","goToTransferFormButton":"Acc\xe9der au formulaire de transfert","backToRecipients":"Retour","otpBlockedErrorMessage":"Vous avez effectu\xe9 3 tentatives incorrectes. Veuillez recommencer l\'op\xe9ration depuis le d\xe9but"},"myAccountScreen":{"title":"Mon compte","subtitle":"Retrouvez toutes les informations et les d\xe9tails de votre compte personnel","coordinatesTitle":"Coordonn\xe9es de votre compte","quickActionsTitle":"Actions rapides","downloadRib":"T\xe9l\xe9charger mon RIB","shareDetails":"Partager mes coordonn\xe9es","manageBeneficiaries":"G\xe9rer les b\xe9n\xe9ficiaires","manageBeneficiariesSubtitle":"Ajoutez ou supprimez vos b\xe9n\xe9ficiaires bancaires","accountStatement":"Relev\xe9 de compte","accountStatementSubtitle":"Consultez le d\xe9tail de vos op\xe9rations bancaires","feesStatement":"Relev\xe9 de frais","feesStatementSubtitle":"Consultez le d\xe9tail de vos frais bancaires","accountStatementPageSubtitle":"Retrouvez et t\xe9l\xe9chargez l\'ensemble de vos relev\xe9s de compte par p\xe9riode.","feesStatementPageSubtitle":"Retrouvez et t\xe9l\xe9chargez l\'ensemble de vos relev\xe9s de frais par p\xe9riode.","allYears":"Ann\xe9es"},"accountDetails":{"availableBalanceTitle":"Solde disponible","balanceTitle":"Solde comptable","balanceMessage":"Le solde comptable ne prend pas en compte les op\xe9rations en attente.","accountStatus":{"blocked":"Ce compte est bloqu\xe9. Pour plus d\u2019information veuillez contacter notre support.","debitBlocked":"Les d\xe9bits sont actuellement interdits sur ce compte. Pour plus d\u2019informations veuillez contacter notre support.","creditBlocked":"Les cr\xe9dits sont actuellement interdits sur ce compte. Pour plus d\u2019informations veuillez contacter notre support."},"accountName":"Nom du compte","accountIdTitle":"Num\xe9ro de compte","ibanTitle":"IBAN","bicTitle":"BIC","coOwnerTitle":"Copropri\xe9taire","authorizedOverdraftTitle":"D\xe9couvert autoris\xe9","reachedOverdraftMessage":"Vous avez atteint votre d\xe9couvert autoris\xe9.","validityDate":"Jusqu\u2019au {date}","accessStatements":"Mes relev\xe9s de compte","shareRIBLabel":"Partager mon RIB","shareRIBMessage":"{firstName} {lastName} {postName}\\nIBAN : {iban}\\nBIC : {bic}","dedicatedMessage":"Vous pouvez d\xe9penser cette somme chez :","clipboard":"{name} copi\xe9","downloadBankDetails":"Coordonn\xe9es bancaires","accountStartDate":"Date d\'ouverture du compte","maximumBoundaries":"Solde maximum","initialAmountLabel":"Solde initial","endDateLabel":"Date de fin","durationLabel":"Dur\xe9e","monthsLabels":{"DAILY":"jours","WEEKLY":"semaines","MONTHLY":"mois","QUARTERLY":"trimestres","SEMESTER":"semestres","ANNUALLY":"ans"},"rateValueLabel":"Taux appliqu\xe9","indexCodeLabel":"Index","rateStartDateLabel":"Date de d\xe9but du taux","accruedInterestsLabel":"Int\xe9r\xeats acquis","startDateLabel":"Acquis depuis le","forecastInterestsLabel":"Inter\xeat total projet\xe9","initialAERLabel":"TRAAB","success":"Modification enregistr\xe9e"},"statementsFilters":{"allAgencies":"Toutes les agences","allYears":"Toutes les ann\xe9es","years":"Ann\xe9es"},"accountsStatements":{"title":"Relev\xe9s de compte","subtitle":"Tous mes relev\xe9s","accountLabel":"Compte n\xb0{id}","accounts":"Comptes","statements":"Relev\xe9s de compte disponibles","emptyStatementList":"Aucun relev\xe9 de compte disponible","cancel":"Annuler","loadStatementsError":"Une erreur est survenue lors du chargement des relev\xe9s de compte.","generateButton":"G\xe9n\xe9rer"},"taxStatements":{"title":"Mes d\xe9clarations fiscales","subtitle":"Tous mes relev\xe9s","accountLabel":"Compte n\xb0{id}","accounts":"Comptes","statements":"Relev\xe9s fiscaux disponibles","emptyStatementList":"Aucun relev\xe9 fiscal disponible","cancel":"Annuler","loadStatementsError":"Une erreur est survenue lors du chargement des relev\xe9s fiscaux.","generateButton":"G\xe9n\xe9rer"},"feesStatements":{"title":"Relev\xe9s de frais","subtitle":"Tous mes relev\xe9s","accountLabel":"Compte n\xb0{id}","accounts":"Comptes","statements":"Relev\xe9s de frais disponibles","emptyStatementList":"Aucun relev\xe9 de frais disponible","cancel":"Annuler","loadStatementsError":"Une erreur est survenue lors du chargement des relev\xe9s de frais."},"cardsList":{"title":"Mes cartes.","loadCardsError":"Une erreur est survenue lors du chargement des cartes.","loadCardsRetry":"R\xe9essayer","showAllCardsLink":"Voir toutes mes cartes","myCardTitle":"Ma carte","myCardSubtitle":"Consultez et g\xe9rez votre carte","availableBalance":"Solde disponible","emptyTitle":"Aucune carte n\'est encore ajout\xe9e","emptyDescription":"Ajoutez une carte pour commencer \xe0 effectuer vos paiements.","addCardButton":"Ajouter une carte","statusFilterTitle":"Statut","orderCard":"Commander une nouvelle carte","refabricateButton":"Remplacer la carte","infos":{"title":"Informations"},"details":{"title":"Voir le d\xe9tail de la carte","holder":"Titulaire de la carte","number":"Num\xe9ro","date":"Date d\'expiration","cvv":"CVV"}},"allCardsScreen":{"goBackClassicViewButton":"Retour sur la vue classique","noCardAvailable":"Aucune carte n\'est disponible"},"card":{"title":"CARTE","virtual":"Virtuelle","status":{"all":"Tous les statuts","active":"Active","pending":"En attente","new":"Nouvelle","expired":"Expir\xe9e","blocked":"Bloqu\xe9e","opposed":"Oppos\xe9e","removed":"Retir\xe9e","cancelled":"Annul\xe9e"},"feature":{"nfc":"Sans contact","cashOperation":"Retrait","foreignPayment":"Paiement \xe0 l\'\xe9tranger","onlinePayment":"Paiement en ligne","eurWithdrawal":"Retrait en zone euro","foreignWithdrawal":"Retrait \xe0 l\'\xe9tranger","paymentAuthorized":"Paiement autoris\xe9","eurPayment":"Paiement en zone euro","foreignAll":"Paiement et retrait \xe0 l\'\xe9tranger","foreignOnlinePayment":"Paiement en ligne \xe0 l\'\xe9tranger"},"pendingOperation":{"refabrication":"La carte en cours de refabrication","codeReissuing":"Le code PIN de la carte est en cours de modification","opposition":"La carte est en cours d\'opposition","blocking":"La carte est en cours de blocage","unblocking":"La carte est en cours de d\xe9blocage","activation":"La carte est en cours d\'activation","creation":"La carte est en cours de cr\xe9ation","limitsUpdate":"Les plafonds de la carte sont en cours de modifications","featuresUpdate":"La fonctionnalit\xe9 \\"{feature}\\" de la carte est en cours de modification","unknownFeatureUpdate":"Une fonctionnalit\xe9 de la carte est en cours de modification"}},"cardPincode":{"importantMessage":"Attention, veillez \xe0 bien conserver ce code:\\nVous en aurez besoin pour valider les op\xe9rations avec votre carte.","previous":"Changer","next":"Suivant","errorCodesMismatch":"Les codes ne correspondent pas"},"cardOptions":{"title":"R\xe9glages de la carte & paiements","outstandings":{"navigateButton":"Mes plafonds","title":"Mes plafonds","subtitle":"Visionnez les plafonds de votre carte","paymentHeader":"Plafonds de paiement","cashoutHeader":"Plafonds de retrait","slidingPeriod":"p\xe9riode glissante de {num} {unit}","fixedPeriod":"du {startDate} au {endDate}","used":"Consomm\xe9","available":"Disponible","maxAmount":"Montant max","maxOperations":"Op\xe9rations max","selector":{"payments":"Paiements","cashouts":"Retraits"},"noOutstandingLabel":"Pas de plafonds configur\xe9s","errorMessage":"Une erreur est survenue lors du chargement des plafonds.","retryButton":"R\xe9essayer","durationUnit":{"hour":"heure","hours":"heures","day":"jour","days":"jours","week":"semaine","weeks":"semaines","month":"mois","months":"mois","year":"an","years":"ans"},"updateButtonLabel":"Modifier le plafond","modal":{"title":"Modifier mon plafond","inputLabel":"D\xe9finir une limite","inputLabelUnit":{"day":"journali\xe8re","week":"hebdomadaire","month":"mensuelle","year":"annuelle","all":"globale"},"maximumLabel":"Maximum","submitButtonLabel":"D\xe9finir une limite","validationMsg":"Votre modification a \xe9t\xe9 prise en compte"}},"refabricate":{"modal":{"title":"Confirmation","message":"\xcates-vous s\xfbr.e de vouloir remplacer cette carte ?","cardNumber":"{cardNumber} ","submitButtonLabel":"Confirmer"},"motiveLabel":"S\xe9lectionnez le motif","motivesOptions":{"DAMAGED":"Carte endommag\xe9e","STOLEN":"Carte vol\xe9e","LOST":"Carte perdue","ABUSE":"Utilisation frauduleuse"}},"oppositionCard":{"opposeButton":"Faire opposition","opposeDescription":"Prot\xe9gez vos fonds en cas de perte ou vol","title":"Pour faire opposition et bloquer d\xe9finitivement votre carte, choisissez un motif ci-dessous:","reasonLost":"Carte perdue","reasonStolen":"Carte vol\xe9e","reasonNotDistributed":"Carte non distribu\xe9e","opposeConfirmButton":"Confirmer","opposeCancelButton":"Annuler","opposePromptTitle":"Faire opposition","opposePromptMessage":"Cette op\xe9ration est irr\xe9versible. \xcates-vous s\xfbr de vouloir faire opposition ?"},"deactivateCard":{"deactivateButton":"R\xe9silier la carte","title":"Cette op\xe9ration est irr\xe9versible. \xcates-vous s\xfbr de vouloir r\xe9silier ?","deactivateConfirmButton":"Confirmer","deactivateCancelButton":"Annuler","deactivatePromptTitle":"R\xe9silier","deactivatePromptMessage":"Cette op\xe9ration est irr\xe9versible. \xcates-vous s\xfbr de vouloir r\xe9silier ?"},"updateCardPincode":{"updateButton":"Modifier le code PIN","updateDescription":"Changez votre code PIN en toute s\xe9curit\xe9","title":"Modification du Code PIN","definePincodeMessage":"Choisissez un nouveau code PIN \xe0 quatre chiffres pour votre carte. Surtout, ne le communiquez \xe0 personne, il est strictement confidentiel.","confirmPincodeMessage":"Veuillez confirmer le code PIN de votre carte pour continuer.","successTitle":"F\xe9licitations !","successSubtitle":"Le code PIN a \xe9t\xe9 mis \xe0 jour !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la mise \xe0 jour du code PIN de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client.","confirmationPopup":{"message":"Si vous quitter l\'\xe9dition du code PIN il ne sera pas mis \xe0 jour.\\nQuitter l\'\xe9dition ?"}},"activationCard":{"title":"Activer ma carte","activateButton":"Activer","defaultActivationMessage":"Renseignez l\'identifiant \xe0 9 chiffres pr\xe9sent \xe0 l\'arri\xe8re de votre carte.","identifier":"Votre identifiant \xe0 9 chiffres","next":"Suivant","confirm":"Activer","inputError":"Erreur de saisie, veuillez recommencer.","stepPincode":{"title":"Code PIN","definePincodeMessage":"Vous devez d\xe9sormais choisir un code PIN \xe0 quatre chiffres pour votre carte. Surtout, ne le communiquez \xe0 personne, il est strictement confidentiel.","confirmPincodeMessage":"Veuillez confirmer le code PIN de votre carte pour continuer."}},"switch":{"lockCard":"Verrouillage temporaire","unlockCard":"D\xe9verrouillage","showDetails":"Voir le d\xe9tail","hideDetails":"Masquer le d\xe9tail"},"featuresSwitchesOverlay":{"cardLocked":"Carte verrouill\xe9e"},"cardOpposedMessage":"Vous avez fait opposition sur cette carte, vous ne pouvez plus acc\xe9der \xe0 ses options."},"accountBlockedScreen":{"title":"Compte bloqu\xe9","multipleAttemptBlockedReason":{"subtitle":"Trois tentatives de code secret erron\xe9es","message":"Malheureusement, votre compte a \xe9t\xe9 bloqu\xe9 \xe0 cause de trois tentatives de code secret erron\xe9es. Veuillez contacter notre support {contacts}pour r\xe9initialiser votre code secret."},"defaultBlockedReason":{"message":"Malheureusement, votre compte a \xe9t\xe9 bloqu\xe9. Veuillez contacter notre support {contacts}pour r\xe9initialiser votre code secret."},"contactsPhoneAndEmail":"au {contactPhone} ou par mail \xe0 {contactEmail} ","contactsPhone":"au {contactPhone} ","contactsEmail":"par mail \xe0 {contactEmail} ","button":"OK, j\u2019ai compris"},"bankContactScreen":{"title":"Ma banque.","question":"Besoin d\'aide ?","addressContact":"Nous trouver","phoneContact":"Nous appeler","urlContact":"En savoir plus","emailContact":"Nous \xe9crire"},"pincodeChangeFlow":{"currentCodeLabel":"Entrez votre code actuel","newCodeLabel":"Entrez votre nouveau code","newCodeConfirmationLabel":"Confirmez votre nouveau code","newCodesDontMatchError":"Les codes entr\xe9s ne correspondent pas","success":"Votre code a \xe9t\xe9 chang\xe9 avec succ\xe8s"},"pincodeChangeScreen":{"title":"Changement de code","subtitle":"Changez votre code secret pour plus de s\xe9curit\xe9","message":"Il est n\xe9cessaire que vous changiez votre code secret avant d\'effectuer cette op\xe9ration","messageAfterAuthentication":"Vous devrez changer votre code secret avant d\'effectuer de nouvelles op\xe9rations","changePincodeButton":"Changer mon code secret","laterButton":"Plus tard","done":"Terminer"},"clientInformation":{"title":"Mes informations personnelles","birthDateTitle":"Date de naissance","birthPlaceTitle":"Lieu de naissance","addressTitle":"Adresse","phoneTitle":"T\xe9l\xe9phone","emailTitle":"Email","emailSuccess":"Vous avez re\xe7u un e-mail de confirmation","viewMore":"Voir plus","viewLess":"Voir moins"},"documents":{"title":"Mes documents","CREDITADRESSPROOF":"Preuve d\'adresse de cr\xe9dit","PASSPORT":"Passeport","CREDITID":"ID de cr\xe9dit","PORTRAIT":"Portrait","PROOF_OF_ACTIVITY":"Preuve d\'activit\xe9"},"cashTransferScreen":{"title":"Transferts en attente","subtitle":"Annuler ou r\xe9cup\xe9rer votre argent","receivedSelector":"Re\xe7us","sentSelector":"Envoy\xe9s","recipient":"Envoy\xe9 \xe0 : ","sender":"Envoy\xe9 par : ","emptyReceivedList":"Aucun transfert re\xe7u","emptySentList":"Aucun transfert envoy\xe9","receivedTransferDefaultTitle":"Transfert re\xe7u","sentTransferDefaultTitle":"Transfert envoy\xe9","codeLabel":"Code : {code}","cancelCashTransferButton":"Annuler le transfert","retrieveCashTransferButton":"Envoyer sur mon compte","loadCashTransfersError":"Une erreur est survenue lors du chargement des transferts vers cash.","loadMoreCashTransfersError":"Une erreur est survenue lors du chargement des transferts vers cash.","loadMoreCashTransfersRetry":"R\xe9essayer","nextButton":"Suivant","invalidCode":"Le code saisi est invalide","cashCodeTitle":"Entrez le code envoy\xe9 par l\'exp\xe9diteur du transfert","summaryTitle":{"sentCashTransfer":"Transfert annul\xe9","receivedCashTransfer":"Transfert r\xe9cup\xe9r\xe9 sur votre compte"}},"settings":{"title":"Mes param\xe8tres personnels","changeLanguageTitle":"Langue","changeLanguageDescription":"Choisissez la langue de l\'application et des messages que nous vous envoyons.","languageChangeConfirmation":"La langue a \xe9t\xe9 chang\xe9e avec succ\xe8s","languageChangeFailed":"Une erreur s\'est produite lors du chargement de la langue","changePincodeTitle":"Changer mon code secret","changePincodeDescription":"Pour plus de securit\xe9, changez votre code secret r\xe9guli\xe8rement","accountDeleteTitle":"Supprimer mon compte","accountDeleteDescription":"Supprimer d\xe9finitivement mon compte Skaleet."},"accountDeleteScreen":{"title":"Supprimer mon compte","subtitle":"Notez que vous n\'avez pas besoin de supprimer votre compte si:","button":"Supprimer mon compte","explanation":"Votre demande va \xeatre envoy\xe9e \xe0 notre \xe9quipe. La suppression peut prendre plusieurs jours.","options":{"changeProfile":{"title":"Vous voulez changer votre code","description":"Modifiez votre code secret."},"unHappy":{"title":"Vous n\'\xeates pas heureux avec nous","description":"Contactez-nous et dites nous pourquoi."}},"confirm":{"title":"Souhaitez-vous vraiment supprimer votre compte ?","subtitle":"Votre compte sera enti\xe8rement supprim\xe9 et vos donn\xe9es et informations perdues","placeholder":"Selectionnez la raison de suppression","warning":"Cette action est d\xe9finitive","button":"Confirmer","success":"La demande de fermeture de compte a \xe9t\xe9 enregistr\xe9e"}},"accountDeleteMail":{"subject":"Demande de suppression du compte de {username}","body":"Ch\xe8re Madame, Cher Monsieur, je vous prie de bien vouloir proc\xe9der \xe0 la suppression de mon compte utilisateur."},"transactionFilter":{"all":"Tous","credit":"Recettes","debit":"D\xe9penses","searchDescription":"\xc0 l\'aide du moteur de recherche retrouvez facilement vos d\xe9penses.","searchInputPlaceholder":"Rechercher une op\xe9ration","timeRangeSelectionTitle":"Date personnalis\xe9e","timeRange":{"month":"Ce mois","week":"7 derniers jours","quarter":"3 derniers mois","from":"Du\xa0:","to":"Au\xa0:"},"advancedSearch":"Recherche avanc\xe9e.","confirm":"Valider","amountRangeSelectionTitle":"Filtrer par montant","panelTitle":"Filtres","clearAll":"Tout supprimer","apply":"Appliquer","toJustify":"\xc0 justifier","toQualify":"\xc0 qualifier","amountRangeTitle":"Gamme de d\xe9penses","periodTitle":"P\xe9riode","filtersButton":"Filtrer les op\xe9rations","allAmountRange":"Tous les montants","amountRange":{"min":"Min:","max":"Max:"},"emptySearchResult":"Aucune transaction"},"resultScreen":{"activateCard":{"successTitle":"F\xe9licitations !","successSubtitle":"Votre carte a bien \xe9t\xe9 activ\xe9e !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de l\u2019activation de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"createCard":{"successTitle":"F\xe9licitations !","defaultSuccessSubtitle":"Votre carte a bien \xe9t\xe9 cr\xe9\xe9e !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la cr\xe9ation de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"updateOutstanding":{"successTitle":"F\xe9licitations !","defaultSuccessSubtitle":"Votre modification \xe0 \xe9t\xe9 prise en compte !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la modification de votre plafond. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"refabricate":{"successTitle":"F\xe9licitations !","successSubtitle":"La demande de remplacement a \xe9t\xe9 prise en compte !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la demande de remplacement de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"sensitiveDetails":{"successTitle":"F\xe9licitations !","successSubtitle":"Continuez pour consulter les informations de la carte","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la r\xe9cup\xe9ration des informations de la carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"done":"Terminer"},"createCard":{"title":"Nouvelle carte","virtualCardtitle":"Nouvelle carte virtuelle","loadProductsError":"Une erreur est survenue lors du chargement des produits.","loadProductsRetry":"R\xe9essayer","stepSelection":{"title":"S\xe9lection du compte","selectAccountMessage":"Veuillez s\xe9l\xe9ctionner le compte pour lequel vous d\xe9sirez commander une carte :","selectVirtualCardMessage":"Veuillez s\xe9l\xe9ctionner le compte pour lequel vous d\xe9sirez cr\xe9er une carte virtuelle :","selecProductMessage":"Quelle carte souhaitez vous commander ?","selectProductForVirtualCardMessage":"Quelle carte virtuelle souhaitez vous cr\xe9er ?","orderCardButton":"Commander ma carte","createVirtualCardButton":"Cr\xe9er une carte virtuelle","virtualCardTitle":"Obtenez instantan\xe9ment une nouvelle carte virtuelle gratuite","virtualCardDescription":"Pour des achats en ligne s\xe9curis\xe9s sans crainte de perte de votre carte !","accountLabel":"Compte n\xb0{id}"},"stepCgu":{"title":"Conditions g\xe9n\xe9rales d\'utilisation","acceptMessage":"En activant le switch, vous confirmez avoir lu et accept\xe9 nos conditions g\xe9n\xe9rales d\u2019utilisation","next":"Suivant"}},"recharge":{"title":"Recharger mon compte","description":"S\xe9lectionner le compte \xe0 recharger","noAccountAvailable":"Aucun compte n\u2019est disponible","noAccountExplanation":"Il semblerait que vous n\u2019ayez aucun compte rechargeable.","contactSupport":"Contacter le support","rechargeButton":"Recharger"},"rechargeMethod":{"title":"Modes de recharge","subtitle":"Comment voulez-vous recharger votre compte ?","withCard":{"title":"Carte bancaire","description":"Votre compte sera cr\xe9dit\xe9 instantan\xe9ment. Retraits dans les banques partenaires partout dans le monde.","instantTag":"Instantan\xe9"},"bankDebit":{"title":"Pr\xe9l\xe8vement bancaire","description":"Alimenter votre compte \xe0 partir de votre compte externe {bankName}. Votre compte ne sera pas cr\xe9dit\xe9 instantan\xe9ment.","noBankDescription":"Alimenter votre compte \xe0 partir de votre compte externe. Votre compte ne sera pas cr\xe9dit\xe9 instantan\xe9ment."}},"contactSupport":{"notHappyTitle":"Comment pouvons-nous vous aider ?","notHappyMessage":"Dites-nous ce qui se passe et nous essaierons de corriger le probl\xe8me.","noContactAvailable":"Aucun moyen de contact n\'est disponible pour le moment.","rechargeNotAvailableTitle":"Vous ne pouvez pas recharger votre compte ?","rechargeNotAvailableMessage":"Veuillez prendre contact avec notre \xe9quipe support qui vous indiquera la marche \xe0 suivre.","contactByPhone":"Nous contacter par t\xe9l\xe9phone au {phoneNumber}","contactByEmail":"Nous contacter par email \xe0 {email}","done":"Terminer"},"rechargeBankToWallet":{"title":"Recharge par pr\xe9l\xe8vement","subtitle":"Montant \xe0 recharger","accountWithdrawnTitle":"Compte externe prelev\xe9","accountWithdrawnMessage":"Modifiable par le menu Transferts","iban":"IBAN","amountToWithdraw":"Montant \xe0 pr\xe9lever :","recharge":"Recharger"},"rechargeByCard":{"title":"Recharge par carte","subtitle":"Montant \xe0 recharger","creditedAccountTitle":"Compte cr\xe9dit\xe9","accountId":"N\xb0{id}","amountToCredit":"Montant \xe0 cr\xe9diter :","recharge":"Recharger"},"rechargeSummary":{"title":"Succ\xe8s","rechargedAccount":"Compte recharg\xe9","rechargeMethod":"Mode de recharge","bankToWalletMethod":"Pr\xe9l\xe8vement","cardMethod":"Par carte","rechargeAmount":"Montant recharg\xe9","done":"Terminer"},"recurringTransfer":{"endDateLabel":"Date de fin","firstExecutionDateLabel":"Date de d\xe9but","frequencyLabel":"Fr\xe9quence","switchLabel":"Rendre ce transfert r\xe9current","optionLabel":{"daily":"Quotidien","weekly":"Hebdomadaire","twiceAMonth":"Bimensuel","monthly":"Mensuel"},"recurringTransferTitleDetails":"Vers {destinationAccount}","beneficiaryDetails":"D\xe9tails du b\xe9n\xe9ficiaire","scheduledAmount":"Montant pr\xe9vu","beneficiaryAccount":"Compte du b\xe9n\xe9ficiaire","beneficiaryBIC":"BIC du b\xe9n\xe9ficiaire","recurringTransferDetails":"D\xe9tails du transfert r\xe9current","sourceAccount":"Compte source","frequency":"Fr\xe9quence","nextExecutionDate":"Date de la prochaine ex\xe9cution","endDate":"Date de fin","description":"Description"},"transactionCode":{"title":"Code de transaction","description":"Cr\xe9ez un code pour l\'utiliser dans un de nos points de transaction.","noCodeAvailable":"Aucun code de transaction en cours","noCodeAvailableExplanation":"Pour g\xe9n\xe9rer un nouveau code de transaction, obtenez le num\xe9ro \xe0 6 chiffres du partenaire.","codeTooltip":"Code","newCodeButton":"Nouveau code","modalBackButton":"Retour","selectAcceptor":{"title":"Point de transaction","description":"Entrez le num\xe9ro \xe0 6 chiffres du point de transaction","next":"Suivant"},"selectAmount":{"title":"Limite autoris\xe9e","acceptorReminder":"Point de transaction : {acceptorId}","currencyLabel":"Devise :","amountLabel":"Montant :","amountInformationLabel":"Montant maximal de la transaction (frais compris)","next":"G\xe9n\xe9rer mon code"},"pincode":{"title":"Code secret","description":"Rentrez votre code secret pour terminer"},"summary":{"title":"Succ\xe8s","transactionCode":"Code de transaction","transactionPoint":"Point de transaction","maxAmount":"Montant maximum","expiryDate":"Date d\'expiration","done":"Terminer"}},"trustChoice":{"title":"Se fier \xe0 ce navigateur ?","explanation":"Si vous choisissez de faire confiance \xe0 ce navigateur, vous n\'aurez pas \xe0 saisir de code de validation lors de votre prochaine connexion.","laterButton":"Plus tard","dontTrustButton":"Ne pas se fier","trustButton":"Se fier"},"ubbleCheckScreen":{"success":{"title":"BIEN JOU\xc9 !","subtitle":"Merci pour votre enregistrement !","message":"Votre identit\xe9 va \xeatre v\xe9rifi\xe9e de notre c\xf4t\xe9. Le processus de v\xe9rification peut prendre de quelques heures \xe0 quelques jours.\\nVous pouvez maintenant vous connecter \xe0 votre espace ou fermer cette fen\xeatre.","button":"Continuer"},"fail":{"title":"D\xc9SOL\xc9 !","subtitle":"Quelque chose s\'est mal pass\xe9 pendant l\'enregistrement...","message":"Vous pouvez r\xe9essayer en utilisant le m\xeame lien qu\'avant.\\nSi vous rencontrez une autre erreur, veuillez prendre contact avec notre \xe9quipe par t\xe9l\xe9phone ou par e-mail en utilisant les boutons ci-dessous.","byPhone":"T\xe9l\xe9phone","byEmail":"Email"}},"justifyScreen":{"title":"Justifier ma d\xe9pense","subtitle":"Ajouter et modifier un justificatif","attachments":{"title":"Justificatifs","sectionTitle":"T\xe9l\xe9chargez ou d\xe9posez un justificatif","sectionSubtitle":"Au format pdf, jpeg, png","addButtonLabel":"Ajouter un justificatif","addOtherButtonLabel":"Ajouter un autre justificatif","deletePrompt":{"title":"Supprimer le justificatif","message":"\xcates-vous s\xfbr de vouloir supprimer ce justificatif ?","cancelButton":"Annuler","confirmButton":"Supprimer"}},"spendings":{"title":"Sous-d\xe9penses","sectionTitle":"Ajouter une sous-d\xe9pense","sectionSubtitle":"D\xe9clarez les sous-d\xe9penses de votre justificatif","addButtonLabel":"Ajouter une sous-d\xe9pense","addOtherButtonLabel":"Ajouter une autre sous-d\xe9pense","addModal":{"title":"Nouvelle sous-d\xe9pense","editTitle":"Modifier la sous-d\xe9pense","message":"D\xe9tails compl\xe9mentaires du justificatif","createButton":"Valider","editButton":"Enregistrer"},"addForm":{"titleLabel":"Titre","categoryLabel":"Cat\xe9gorie","subcategoryLabel":"Sous-cat\xe9gorie","amountLabel":"Montant","additionalDataLabel":"Donn\xe9e additionnelle","addAdditionalDataButton":"Ajouter une donn\xe9e additionnelle"},"deletePrompt":{"title":"Supprimer la sous-d\xe9pense","message":"\xcates-vous s\xfbr de vouloir supprimer cette sous-d\xe9pense ?","cancelButton":"Annuler","confirmButton":"Supprimer"}}},"selectField":{"select":"S\xe9lectionner un(e)","select_an_option":"S\xe9lectionner une option"},"refundTransactionModal":{"title":"Demander un remboursement","message":"Pour demander un remboursement, choisissez un motif ci-dessous:","reasons":{"AC03":"Mauvais IBAN","AM09":"Mauvais montant","CUST":"D\xe9cision client"},"confirmButton":"Confirmer","cancelButton":"Annuler","success":"Votre demande de remboursement a \xe9t\xe9 envoy\xe9e"},"upcomingTransfers":{"description":"Voir et g\xe9rer vos transferts \xe0 venir","editTransfer":"Modifier le transfert r\xe9current","loadMore":"Charger plus","nextOn":"Prochain le","status":{"activated":"Activ\xe9","deactivated":"En pause","expired":"Ex\xe9cut\xe9","deleted":"Annul\xe9"},"deletePrompt":{"title":"Supprimer Transfert \xe0 venir ?","message":"Souhaitez-vous vraiment supprimer le prochain transfert {id} ?"},"confirmButton":"Confirmer","sourceAccount":"Compte source","scheduledAmount":"Montant pr\xe9vu","message":"Message","startDate":"Date de d\xe9but","frequency":"Fr\xe9quence","endDate":"Date de fin"},"createSavingsAccount":{"title":"Ouvrir un compte d\'\xe9pargne","selectAccount":"S\xe9lectionnez le type de compte d\'\xe9pargne","initialDeposit":"D\xe9p\xf4t initial","accountToCollect":"Compte \xe0 collecter","duration":"Dur\xe9e","sendRequest":"Envoyer une demande","selectAccountTypeLabel":"S\xe9lectionnez le type de compte \xe0 collecter","selectAccountType":{"INTERNAL":"Interne","EXTERNAL":"Externe"},"creationSuccessMessage":"Votre demande de cr\xe9ation de compte d\'\xe9pargne a bien \xe9t\xe9 envoy\xe9e"},"gender":{"male":"M\xe2le","female":"Femelle","unknown":"Inconnu"},"mandates":{"description":"Voir et g\xe9rer vos mandats","status":{"all":"Tous les statuts","active":"Actif","opposed":"Oppos\xe9","consumed":"Utilis\xe9","revoked":"R\xe9voqu\xe9","creditorOpposed":"Oppos\xe9 par le cr\xe9ancier","obsolete":"Obsol\xe8te"},"details":{"to":"\xc0","mandateDetails":"D\xe9tails du mandat","reference":"R\xe9f\xe9rence","id":"Identifiant","signatureDate":"Date de signature","creditorDetails":"D\xe9tails du cr\xe9ancier","creditorRef":"R\xe9f\xe9rence cr\xe9ancier","accountInformation":"Informations du compte","accountIban":"IBAN du compte","accountBic":"BIC du compte"},"opposePrompt":{"title":{"first":"Opposer","second":"le mandat"},"message":"Voulez-vous vraiment opposer le mandat {reference} au cr\xe9ancier {creditorName} ?"},"activatePrompt":{"title":{"first":"Activer","second":"le mandat"},"message":"Voulez-vous vraiment activer le mandat {reference} au cr\xe9ancier {creditorName} ?"},"confirmButton":"Confirmer"},"mandatesSubmenu":{"mandates":"Mandats"}}');

});

parcelRegister("gqyt4", function(module, exports) {
module.exports = JSON.parse('{"TRANSACTION_WITHDRAW_CODE_GENERATION_ERROR":"No se permite el retiro para este punto de transacci\xf3n","common":{"fileConstraints":{"formats":"Formatos aceptados","maxSize":"Tama\xf1o m\xe1ximo","tooBig":"El archivo elegido supera el tama\xf1o permitido.","wrongType":"El formato del archivo elegido no se acepta.","openLabel":"Ver los requisitos de este archivo"},"fileField":{"sentOn":"Enviado el {date}","sent":"Documento enviado"},"today":"Hoy","clear":"Borrar","yesterday":"Ayer","goBack":"Volver","languages":{"fr_FR":"Fran\xe7ais (France)","en_US":"English (USA)","es_ES":"Espa\xf1ol (Espa\xf1a)","af_NA":"Afrikaans (Namibia)","af_ZA":"Afrikaans (South Africa)","ak_CI":"Akan (C\xf4te d\u2019Ivoire)","ak_GH":"Akan (Ghana)","gn_PY":"Ava\xf1e\'\u1EBD","ay_BO":"Aymar aru","az_AZ":"Az\u0259rbaycan dili","id_ID":"Bahasa Indonesia","ms_MY":"Bahasa Melayu","ms_BN":"Bahasa Melayu (Brunei)","ms_CC":"Bahasa Melayu (Cocos (Keeling) Islands)","ms_SG":"Bahasa Melayu (Singapore)","bm_BF":"Bamanakan (Burkina Faso)","bm_CI":"Bamanakan (C\xf4te d\u2019Ivoire)","bm_GM":"Bamanakan (Gambia)","bm_ML":"Bamanakan (Mali)","jv_ID":"Basa Jawa","bh_IN":"Bihari (India)","bs_BA":"Bosanski","br_FR":"Brezhoneg (France)","ca_ES":"Catal\xe0","ca_AD":"Catal\xe0 (Andorra)","ce_RU":"Chechen (Russia)","sn_BW":"ChiShona (Botswana)","sn_MZ":"ChiShona (Mozambique)","sn_ZW":"ChiShona (Zimbabwe)","ht_GA":"Cr\xe9ole haitien (Grandans)","ht_OU":"Cr\xe9ole haitien (Lw\xe8s)","ht_NI":"Cr\xe9ole haitien (Nip)","ht_ND":"Cr\xe9ole haitien (N\xf2)","ht_NO":"Cr\xe9ole haitien (N\xf2dw\xe8s)","ht_NE":"Cr\xe9ole haitien (N\xf2d\xe8s)","ht_CE":"Cr\xe9ole haitien (Sant)","ht_SD":"Cr\xe9ole haitien (Sid)","ht_SE":"Cr\xe9ole haitien (Sid\xe8s)","cy_GB":"Cymraeg","cy_AR":"Cymraeg (Argentina)","da_DK":"Dansk","da_FO":"Dansk (Faroe Islands)","da_DE":"Dansk (Germany)","da_GL":"Dansk (Greenland)","fa_AF":"Dari","se_NO":"Davvis\xe1megiella","de_BE":"Deutsch (Belgium)","de_DK":"Deutsch (Denmark)","de_DE":"Deutsch (Deutschland)","de_FR":"Deutsch (France)","de_HU":"Deutsch (Hungary)","de_IT":"Deutsch (Italy)","de_LI":"Deutsch (Liechtenstein)","de_LU":"Deutsch (Luxembourg)","de_PL":"Deutsch (Poland)","de_CH":"Deutsch (Schweiz)","de_AT":"Deutsch (\xd6sterreich)","dv_MV":"Divehi (Maldives)","dz_BT":"Dzongkha (Bhutan)","et_EE":"Eesti (Estonia)","en_AS":"English (American Samoa)","en_AI":"English (Anguilla)","en_AG":"English (Antigua & Barbuda)","en_AU":"English (Australia)","en_BS":"English (Bahamas)","en_BB":"English (Barbados)","en_BE":"English (Belgium)","en_BZ":"English (Belize)","en_BM":"English (Bermuda)","en_BW":"English (Botswana)","en_IO":"English (British Indian Ocean Territory)","en_VG":"English (British Virgin Islands)","en_BN":"English (Brunei)","en_CM":"English (Cameroon)","en_CA":"English (Canada)","en_KY":"English (Cayman Islands)","en_CK":"English (Cook Islands)","en_DM":"English (Dominica)","en_ER":"English (Eritrea)","en_ET":"English (Ethiopia)","en_FK":"English (Falkland Islands)","en_FJ":"English (Fiji)","en_GM":"English (Gambia)","en_GH":"English (Ghana)","en_GI":"English (Gibraltar)","en_GD":"English (Grenada)","en_GU":"English (Guam)","en_GY":"English (Guyana)","en_HK":"English (Hong Kong SAR China)","en_IN":"English (India)","en_IE":"English (Ireland)","en_IL":"English (Israel)","en_JM":"English (Jamaica)","en_KE":"English (Kenya)","en_KI":"English (Kiribati)","en_LS":"English (Lesotho)","en_LR":"English (Liberia)","en_MW":"English (Malawi)","en_MT":"English (Malta)","en_MH":"English (Marshall Islands)","en_MU":"English (Mauritius)","en_FM":"English (Micronesia)","en_MS":"English (Montserrat)","en_NA":"English (Namibia)","en_NR":"English (Nauru)","en_NZ":"English (New Zealand)","en_NG":"English (Nigeria)","en_NU":"English (Niue)","en_NF":"English (Norfolk Island)","en_MP":"English (Northern Mariana Islands)","en_PK":"English (Pakistan)","en_PW":"English (Palau)","en_PG":"English (Papua New Guinea)","en_PH":"English (Philippines)","en_PI":"English (Pirate)","en_PN":"English (Pitcairn Islands)","en_PR":"English (Puerto Rico)","en_RW":"English (Rwanda)","en_WS":"English (Samoa)","en_SC":"English (Seychelles)","en_SL":"English (Sierra Leone)","en_SG":"English (Singapore)","en_SB":"English (Solomon Islands)","en_SO":"English (Somalia)","en_ZA":"English (South Africa)","en_SH":"English (St. Helena)","en_KN":"English (St. Kitts & Nevis)","en_LC":"English (St. Lucia)","en_VC":"English (St. Vincent & Grenadines)","en_SZ":"English (Swaziland)","en_TK":"English (Tokelau)","en_TO":"English (Tonga)","en_TT":"English (Trinidad & Tobago)","en_TC":"English (Turks & Caicos Islands)","en_UM":"English (U.S. Outlying Islands)","en_VI":"English (U.S. Virgin Islands)","en_GB":"English (UK)","en_UG":"English (Uganda)","en_UD":"English (Upside Down)","en_VU":"English (Vanuatu)","en_ZM":"English (Zambia)","en_ZW":"English (Zimbabwe)","es_AR":"Espa\xf1ol (Argentine)","es_BO":"Espa\xf1ol (Bolivia)","es_CL":"Espa\xf1ol (Chile)","es_CO":"Espa\xf1ol (Colombia)","es_CR":"Espa\xf1ol (Costa Rica)","es_CU":"Espa\xf1ol (Cuba)","es_DO":"Espa\xf1ol (Dominican Republic)","es_EC":"Espa\xf1ol (Ecuador)","es_SV":"Espa\xf1ol (El Salvador)","es_GQ":"Espa\xf1ol (Equatorial Guinea)","es_US":"Espa\xf1ol (Estados Unidos)","es_GT":"Espa\xf1ol (Guatemala)","es_HN":"Espa\xf1ol (Honduras)","es_LA":"Espa\xf1ol (Latinoam\xe9rica)","es_MX":"Espa\xf1ol (M\xe9xico)","es_NI":"Espa\xf1ol (Nicaragua)","es_PA":"Espa\xf1ol (Panama)","es_PY":"Espa\xf1ol (Paraguay)","es_PE":"Espa\xf1ol (Peru)","es_PR":"Espa\xf1ol (Puerto Rico)","es_UY":"Espa\xf1ol (Uruguay)","es_VE":"Espa\xf1ol (Venezuela)","eo_EO":"Esperanto","eu_ES":"Euskara","ee_GH":"E\u028Begbe (Ghana)","ee_TG":"E\u028Begbe (Togo)","tl_PH":"Filipino","fr_AD":"Fran\xe7ais (Andorra)","fr_BE":"Fran\xe7ais (Belgique)","fr_BJ":"Fran\xe7ais (Benin)","fr_BF":"Fran\xe7ais (Burkina Faso)","fr_BI":"Fran\xe7ais (Burundi)","fr_CM":"Fran\xe7ais (Cameroon)","fr_CA":"Fran\xe7ais (Canada)","fr_CF":"Fran\xe7ais (Central African Republic)","fr_TD":"Fran\xe7ais (Chad)","fr_KM":"Fran\xe7ais (Comoros)","fr_CG":"Fran\xe7ais (Congo - Brazzaville)","fr_CD":"Fran\xe7ais (Congo - Kinshasa)","fr_CI":"Fran\xe7ais (C\xf4te d\u2019Ivoire)","fr_DJ":"Fran\xe7ais (Djibouti)","fr_GF":"Fran\xe7ais (French Guiana)","fr_PF":"Fran\xe7ais (French Polynesia)","fr_GA":"Fran\xe7ais (Gabon)","fr_GP":"Fran\xe7ais (Guadeloupe)","fr_GN":"Fran\xe7ais (Guinea)","fr_HT":"Fran\xe7ais (Haiti)","fr_IT":"Fran\xe7ais (Italy)","fr_LB":"Fran\xe7ais (Lebanon)","fr_LU":"Fran\xe7ais (Luxembourg)","fr_MG":"Fran\xe7ais (Madagascar)","fr_ML":"Fran\xe7ais (Mali)","fr_MQ":"Fran\xe7ais (Martinique)","fr_MR":"Fran\xe7ais (Mauritanie)","fr_YT":"Fran\xe7ais (Mayotte)","fr_MC":"Fran\xe7ais (Monaco)","fr_NC":"Fran\xe7ais (New Caledonia)","fr_NE":"Fran\xe7ais (Niger)","fr_RW":"Fran\xe7ais (Rwanda)","fr_RE":"Fran\xe7ais (R\xe9union)","fr_SC":"Fran\xe7ais (Seychelles)","fr_PM":"Fran\xe7ais (St. Pierre & Miquelon)","fr_CH":"Fran\xe7ais (Suisse)","fr_TG":"Fran\xe7ais (Togo)","fr_GB":"Fran\xe7ais (United Kingdom)","fr_VU":"Fran\xe7ais (Vanuatu)","fr_VA":"Fran\xe7ais (Vatican City)","fr_WF":"Fran\xe7ais (Wallis & Futuna)","fy_NL":"Frysk","fo_FO":"F\xf8royskt","ga_IE":"Gaeilge (Gaelic)","ga_GB":"Gaeilge (United Kingdom)","gv_GB":"Gaelg (United Kingdom)","gl_ES":"Galego","ha_BF":"Hausa (Burkina Faso)","ha_NE":"Hausa (Niger)","ha_NG":"Hausa (Nigeria)","ha_SD":"Hausa (Sudan)","ha_TG":"Hausa (Togo)","hr_HR":"Hrvatski","hr_BA":"Hrvatski (Bosnia & Herzegovina)","ig_NG":"Igbo (Nigeria)","rn_BI":"Ikirundi (Uburundi)","iu_CA":"Inuktitut (Canada)","nd_ZW":"IsiNdebele (Zimbabwe)","it_IT":"Italiano","it_HR":"Italiano (Croatia)","it_SM":"Italiano (San Marino)","it_SI":"Italiano (Slovenia)","it_CH":"Italiano (Switzerland)","it_VA":"Italiano (Vatican City)","jv_MY":"Javanese (Malaysia)","jv_SR":"Javanese (Suriname)","kl_GL":"Kalaallisut (Greenland)","ks_IN":"Kashmiri (India)","kw_GB":"Kernewek (United Kingdom)","kg_CG":"KiKongo (Congo Brazzaville)","kg_CD":"KiKongo (Congo Kinshasa RDC)","sw_KE":"Kiswahili","sw_TZ":"Kiswahili (Tanzania)","ku_IR":"Kurdish (Iran)","ku_IQ":"Kurdish (Iraq)","ku_TR":"Kurd\xee","ky_KG":"Kyrgyz (Kyrgyzstan)","lo_LA":"Lao (Laos)","ht_AR":"Latibonit","la_VA":"Latin","lv_LV":"Latvie\u0161u","to_TO":"Lea fakatonga (Tonga)","lt_LT":"Lietuvi\u0173","ln_CG":"Ling\xe1la (Congo - Brazzaville)","ln_CD":"Ling\xe1la (Congo - Kinshasa)","lg_UG":"Luganda (Uganda)","lb_DE":"Luxembourgish (Germany)","lb_LU":"Luxembourgish (Luxembourg)","li_NL":"L\xe8mb\xf6rgs","hu_HU":"Magyar","hu_AT":"Magyar (Austria)","hu_RO":"Magyar (Romania)","hu_SK":"Magyar (Slovakia)","hu_SI":"Magyar (Slovenia)","hu_UA":"Magyar (Ukraine)","mg_MG":"Malagasy","mt_MT":"Malti","ro_MD":"Moldavian","mo_MD":"Moldavian (Moldova)","nl_AW":"Nederlands (Aruba)","nl_BE":"Nederlands (Belgi\xeb)","nl_NL":"Nederlands (Nederland)","nl_SR":"Nederlands (Suriname)","nb_NO":"Norsk (bokm\xe5l)","nn_NO":"Norsk (nynorsk)","se_SE":"Northern Sami (Sweden)","no_NO":"Norwegian (Norway)","ny_MW":"Nyanja (Malawi)","uz_UZ":"O\'zbek","om_ET":"Oromoo (Ethiopia)","om_KE":"Oromoo (Kenya)","os_AZ":"Ossetic (Azerbaijan)","os_GE":"Ossetic (Georgia)","os_KZ":"Ossetic (Kazakhstan)","os_RU":"Ossetic (Russia)","os_TJ":"Ossetic (Tajikistan)","os_TM":"Ossetic (Turkmenistan)","os_UA":"Ossetic (Ukraine)","os_UZ":"Ossetic (Uzbekistan)","pl_PL":"Polski","pl_UA":"Polski (Ukraine)","pt_AO":"Portugu\xeas (Angola)","pt_BR":"Portugu\xeas (Brasil)","pt_CV":"Portugu\xeas (Cape Verde)","pt_GW":"Portugu\xeas (Guinea-Bissau)","pt_MZ":"Portugu\xeas (Mozambique)","pt_PT":"Portugu\xeas (Portugal)","pt_ST":"Portugu\xeas (S\xe3o Tom\xe9 & Pr\xedncipe)","pt_TL":"Portugu\xeas (Timor-Leste)","ff_MR":"Pulaar (Mauritania)","ff_NE":"Pulaar (Niger)","ff_NG":"Pulaar (Nigeria)","ff_SN":"Pulaar (Senegal)","qu_PE":"Qhichwa","ty_PF":"Reo Tahiti","ro_RO":"Rom\xe2n\u0103","ro_UA":"Rom\xe2n\u0103 (Ukraine)","rm_CH":"Rumantsch","gd_GB":"Scottish Gaelic (United Kingdom)","sq_AL":"Shqip","sk_HU":"Sloven\u010Dina (Hungary)","sk_SK":"Sloven\u010Dina (Slovakia)","sl_SI":"Sloven\u0161\u010Dina","so_DJ":"Soomaali (Djibouti)","so_ET":"Soomaali (Ethiopia)","so_KE":"Soomaali (Kenya)","so_SO":"Soomaaliga","nr_ZA":"South Ndebele (South Africa)","st_LS":"Southern Sotho (Lesotho)","fi_FI":"Suomi","fi_SE":"Suomi (Sweden)","sv_SE":"Svenska","sv_FI":"Svenska (Finland)","sv_AX":"Svenska (\xc5land Islands)","ss_ZA":"Swati (South Africa)","ss_SZ":"Swati (Swaziland)","sg_CF":"S\xe4ng\xf6 (Central African Republic)","vi_VN":"Ti\u1EBFng Vi\u1EC7t","ts_ZA":"Tsonga (South Africa)","tn_BW":"Tswana (Botswana)","tn_ZA":"Tswana (South Africa)","tk_TM":"Turkmen (Turkmenistan)","tr_TR":"T\xfcrk\xe7e","tr_BG":"T\xfcrk\xe7e (Bulgaria)","tr_CY":"T\xfcrk\xe7e (Cyprus)","tr_MD":"T\xfcrk\xe7e (Moldova)","ug_AF":"Uyghur (Afghanistan)","ug_KZ":"Uyghur (Kazakhstan)","ug_KG":"Uyghur (Kyrgyzstan)","ug_TJ":"Uyghur (Tajikistan)","ug_TR":"Uyghur (Turkey)","ug_UZ":"Uyghur (Uzbekistan)","ve_ZA":"Venda (South Africa)","ve_ZW":"Venda (Zimbabwe)","wa_BE":"Walloon (Belgium)","fy_DE":"Western Frisian (Germany)","wo_GM":"Wolof (Gambia)","wo_MR":"Wolof (Mauritania)","wo_SN":"Wolof (Senegal)","xh_LS":"Xhosa (Lesotho)","yi_AU":"Yiddish (Australia)","yi_BY":"Yiddish (Belarus)","yi_BE":"Yiddish (Belgium)","yi_CA":"Yiddish (Canada)","yi_EE":"Yiddish (Estonia)","yi_IL":"Yiddish (Israel)","yi_LV":"Yiddish (Latvia)","yi_LT":"Yiddish (Lithuania)","yi_MD":"Yiddish (Moldova)","yi_PL":"Yiddish (Poland)","yi_RO":"Yiddish (Romania)","yi_RU":"Yiddish (Russia)","yi_ZA":"Yiddish (South Africa)","yi_UA":"Yiddish (Ukraine)","yi_US":"Yiddish (United States)","en_UK":"en_UK","xh_ZA":"isiXhosa","zu_ZA":"isiZulu","yo_NG":"\xc8d\xe8 Yor\xf9b\xe1 (Nigeria)","is_IS":"\xcdslenska (Iceland)","cs_CZ":"\u010Ce\u0161tina","el_GR":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC","el_CY":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (Cyprus)","uz_AF":"\u040E\u0437\u0431\u0435\u043A (Afghanistan)","be_BY":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F","bg_BG":"\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438","mk_MK":"\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438)","mn_MN":"\u041C\u043E\u043D\u0433\u043E\u043B","ru_RU":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439","sr_BA":"\u0421\u0440\u043F\u0441\u043A\u0438 (Bosnia & Herzegovina)","sr_HU":"\u0421\u0440\u043F\u0441\u043A\u0438 (Hungary)","sr_RS":"\u0421\u0440\u043F\u0441\u043A\u0438 (Serbia)","uk_UA":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","ru_UA":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (Ukraine)","tt_RU":"\u0442\u0430\u0442\u0430\u0440\u0447\u0430","tg_TJ":"\u0442\u043E\u04B7\u0438\u043A\u04E3","uk_MD":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 (Moldova)","kk_KZ":"\u049A\u0430\u0437\u0430\u049B\u0448\u0430","hy_AM":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576","yi_DE":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9 (German)","he_IL":"\u05E2\u05D1\u05E8\u05D9\u05EA\u200F","ur_PK":"\u0627\u0631\u062F\u0648","ur_IN":"\u0627\u0631\u062F\u0648 (India)","ar_DZ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Algeria)","ar_AR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Argentina)","ar_BH":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Bahrain)","ar_TD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Chad)","ar_EG":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Egypt)","ar_IN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (India)","ar_IQ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Iraq)","ar_IL":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Israel)","ar_JO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Jordan)","ar_KW":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Kuwait)","ar_LB":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Lebanon)","ar_LY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Libya)","ar_MR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Mauritania)","ar_MA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Morocco)","ar_OM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Oman)","ar_PS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Palestinian Territories)","ar_QA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Qatar)","ar_SO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Somalia)","ar_SD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Sudan)","ar_SY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Syria)","ar_TN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Tunisia)","ar_AE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (United Arab Emirates)","ar_YE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Yemen)","ar_SA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)","fa_IR":"\u0641\u0627\u0631\u0633\u06CC","ps_AF":"\u067E\u069A\u062A\u0648","ne_NP":"\u0928\u0947\u092A\u093E\u0932\u0940","ne_BT":"\u0928\u0947\u092A\u093E\u0932\u0940 (Bhutan)","ne_IN":"\u0928\u0947\u092A\u093E\u0932\u0940 (India)","mr_IN":"\u092E\u0930\u093E\u0920\u0940","sa_IN":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D","hi_IN":"\u0939\u093F\u0928\u094D\u0926\u0940","as_IN":"\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE (India)","bn_SG":"\u09AC\u09BE\u0982\u09B2\u09BE (Singapore)","bn_IN":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AD\u09BE\u09B0\u09A4)","bn_BD":"\u09AC\u09BE\u0982\u09B2\u09BE(\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)","pa_IN":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 (\u0A2D\u0A3E\u0A30\u0A24 \u0A28\u0A42\u0A70)","gu_IN":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0","or_IN":"\u0B13\u0B21\u0B3C\u0B3F\u0B06","ta_IN":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD","ta_SG":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (Singapore)","te_IN":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41","kn_IN":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1 (India)","ml_IN":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02","si_LK":"\u0DB4\u0DC5\u0DCF\u0DAD","si_TH":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD (Thailand)","th_TH":"\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22 (\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22)","bo_CN":"\u0F54\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0B (China)","my_MM":"\u1017\u1019\u102C (Myanmar (Burma))","ka_GE":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8","ti_ER":"\u1275\u130D\u122D\u129B (Eritrea)","ti_ET":"\u1275\u130D\u122D\u129B (Ethiopia)","am_ET":"\u12A0\u121B\u122D\u129B (Ethiopia)","ck_US":"\u13E3\u13B3\u13A9 (tsalagi)","km_KH":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","gx_GR":"\u1F19\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u1F00\u03C1\u03C7\u03B1\u03AF\u03B1","zh_MO":"\u4E2D\u6587 (Macau SAR China)","zh_CN":"\u4E2D\u6587\uFF08\u4E2D\u56FD\uFF09","zh_TW":"\u4E2D\u6587\uFF08\u53F0\u7063\uFF09","zh_SG":"\u4E2D\u6587\uFF08\u65B0\u52A0\u5761\uFF09","zh_HK":"\u4E2D\u6587\uFF08\u9999\u6E2F\uFF09","ja_JP":"\u65E5\u672C\u8A9E","ii_CN":"\uA188\uA320\uA259 (China)","ko_KP":"\uD55C\uAD6D\uC5B4 (North Korea)","ko_KR":"\uD55C\uAD6D\uC5B4 (\u97E9\u56FD)"},"autocompletePicker":{"placeholder":"Seleccionar...","searchPlaceholder":"Escriba al menos 3 caracteres para buscar...","noResults":"No hay resultados"},"invalidPhoneNumber":"El n\xfamero de tel\xe9fono no es v\xe1lido","yes":"S\xed","no":"No","cancel":"Cancelar"},"authScreen":{"welcome":"Bienvenido a su portal bancario","headline":"Mi wallet 100% simple y seguro","headlineDescription":"Gestione sus gastos profesionales, califique sus operaciones e importe sus justificantes en un abrir y cerrar de ojos.","subtitle":"Inicie sesi\xf3n para acceder a su espacio profesional","languages":"Idiomas","login":"Conexi\xf3n","createAccount":"Abrir una cuenta","appstoreLink":"Appstore","playstoreLink":"Playstore","goToCompanyPortalQuestion":"Ud. es una empresa?","goToCompanyPortalLink":"Portal para las empresas","goToPartnersPortalQuestion":"Ud. es comerciante?","goToPartnersPortalLink":"Portal para comerciantes","goToAgentPortalQuestion":"Ud. es un agente?","goToAgentPortalLink":"Portal para agentes","storesAvailable":"Disponible tambi\xe9n con","disconnectedDueToInactivity":"Desconectado por inactividad","authenticationFailure":{"title":"Error de autenticaci\xe9n"}},"connectScreen":{"title":"Bienvenido a [emph]Skaleet[/emph]","subtitle":"Por favor ingrese su n\xfamero de tel\xe9fono para conectar","lostPhoneButton":"\xbfOlvid\xf3 el n\xfamero de tel\xe9fono?","connectButton":"Conectar","registerQuestion":"\xbfNo tienes una cuenta?","registerButton":"Crear una cuenta","errorTitle":"Un error ocurri\xf3","noAccountError":"No pudimos encontrar una cuenta para {phoneNumber}. Puede crear una cuenta para iniciar sesi\xf3n.","pincodeTitle":"C\xf3digo [emph]secreto[/emph]","otpTitle":"Verificaci\xf3n de [emph]dos pasos[/emph]","noCodeQuestion":"C\xf3digo no recibido?","contactSupportLink":"Por favor contacte soporte.","contactSupport":{"title":"\xbfYa no tienes [emph]acceso al tel\xe9fono[/emph] vinculado a tu cuenta?","message":"Para cambiar sus datos, comun\xedquese con nuestro equipo de soporte que le dir\xe1 qu\xe9 hacer.","byPhone":"Cont\xe1ctanos por tel\xe9fono","byEmail":"Cont\xe1ctanos por correo electr\xf3nico","done":"Terminar"}},"errorScreen":{"subTitle":"Demasiadas solicitudes","title":"El intento de conexi\xf3n fall\xf3","message":"No podemos procesar su solicitud de conexi\xf3n en este momento.\\n\\n Por favor, int\xe9ntelo de nuevo m\xe1s tarde.","button":"Volver a la p\xe1gina de inicio de sesi\xf3n"},"onboardingStatusCard":{"title":"Mas informaci\xf3n es requerida para su expediente","subtitle":"Lorem ipsum dolor sit amet","button":"Completa mi expediente"},"onboardingDelegateErrorStatusCard":{"title":"No se puede acceder al formulario de registro como usuario delegado. Las funciones disponibles son limitadas. El titular de la cuenta debe completar su registro."},"onboardingScreen":{"progressLabel":"Etapa {step} de {count}: {label}","initialStepTitle":"Bienvenido a [emph]MWallet.[/emph]","resumptionStepTitle":"Cu\xe9ntanos m\xe1s sobre [emph]ti[/emph]","successIntroduction":"Felicidades","successTitle":"Su cuenta ha sido creada con \xe9xito","submissionThanks":"\xa1Gracias por tu env\xedo!","identityVerificationDescription":"Estamos verificando tu identidad. El proceso de verificaci\xf3n puede tardar desde unas horas hasta varios d\xedas. Puedes iniciar sesi\xf3n en tu espacio o cerrar esta ventana.","successButton":"Comenzar","initiationSuccessTitle":"Su cuenta ha sido creada con \xe9xito.","initiationSuccessButton":"Comenzar","initiationSuccessMsg":"Un c\xf3digo secreto ha sido enviado a {phone}","getStartedButton":"Comenzar","cancelButton":"Cancelar","back":"Anterior","next":"Siguiente","save":"Guardar","submit":"Enviar","taxedNumberError":{"undefined":"Error: Ingrese un n\xfamero de tel\xe9fono v\xe1lido.","PREMIUM_RATE":"Error: Los numeros de tarifa premium no se pueden utilizar para registrar una cuenta. Proporcione un numero de linea fija o movil.","TOLL_FREE":"Error: los numeros gratuitos no son compatibles para la verificacion de la cuenta. Utilice un numero de telefono fijo o movil estandar.","SHARED_COST":"Error: Los numeros con facturacion de costos compartidos no estan permitidos para la creacion de cuentas. Por favor ingrese un numero de l\xednea fija o movil.","VOIP":"Error: los numeros de telefono basados en Internet no son elegibles para el registro. Utilice un numero de linea fija o movil estandar.","PERSONAL_NUMBER":"Error: No se aceptan numeros personales conectados via satelite. Utilice un numero de telefono fijo o movil.","PAGER":"Error: Los dispositivos buscapersonas no son validos para la creacion de cuentas. Proporcione un numero de linea fija o movil aceptado.","UAN":"Error: Los numeros de acceso universal (UAN) no se pueden utilizar para el registro. Ingrese un numero de linea fija o movil valido.","VOICEMAIL":"Error: No se pueden utilizar numeros dedicados a servicios de correo de voz. Ingrese un numero de linea fija o movil que pueda recibir llamadas directamente."},"formLabels":{"selectDistributorDuringOnboarding":"C\xf3digo de distribuidor","selectDistributorDuringOnboardingHelperText":"Por favor, introduzca el ID proporcionado por su referente de tarjeta.","firstName":"Nombre","lastName":"Apellido","phoneNumber":"N\xfamero de tel\xe9fono","email":"Correo electr\xf3nico"}},"registerScreen":{"progressLabel":"Etapa {step} de {count}: {label}","progressStepLabel":"Paso {step} de {count}","progressBackLink":"Volver","firstStepTitle":"\xa1Bienvenido!","firstStepSubtitle":"Por favor ingrese su n\xfamero de tel\xe9fono para registrarse","connectQuestion":"\xbfYa tienes una cuenta?","connectButton":"Conectarse","phoneNumberLabel":"N\xfamero de tel\xe9fono","back":"Anterior","next":"Siguiente","finish":"Terminar","otpTitle":"Verificaci\xf3n del tel\xe9fono m\xf3vil","otpLabel":"Por favor ingrese el c\xf3digo enviado a su tel\xe9fono m\xf3vil","nbPicturesForDocument":{"one":"al menos una foto","others":"al menos {count} fotos"},"pictureInputFilled":"Un archivo","pictureInputEmpty":"Elegir or soltar una foto","addPictureButton":"A\xf1adir una pagina","eulaTitle":"Condiciones de uso","eulaFirstDescription":"Acepte las condiciones de uso para crear una cuenta.","eulaSecondDescription":"Los encontrar\xe1 haciendo clic en el enlace siguiente:","eulaLink":"Condiciones de uso","eulaAcceptLabel":"Acepto las condiciones de uso","createMyAccountButton":"Crear mi cuenta","finishTitleLabel":"Felicidades !","finishLabel":"Su cuenta ha sido creada satisfactoriamente.","pincodeLabel":"Su c\xf3digo","pincodeStepTitle":"Su [emph]c\xf3digo.[/emph]","message":"Debe elegir un c\xf3digo secreto de cuatro d\xedgitos para su cuenta. Sobre todo, no se lo comunique a nadie, es estrictamente confidencial.","doNotForgetWarning":"Cuidado, aseg\xfarate de conservarlo: lo necesitar\xe1s para autenticarte y validar todas tus transacciones.","successSnackbar":"Su c\xf3digo ha sido validado","newCodeLabel":"Ingrese su nuevo c\xf3digo","quitConfirmMessage":"Est\xe1 a punto de salir del registro. Se perder\xe1n todos los datos rellenados. \xbfEst\xe1s seguro de que quieres salir de la p\xe1gina?","cancel":"Cancelar","newCodeConfirmationLabel":"Confirme su nuevo c\xf3digo","newCodesDontMatchError":"Los c\xf3digos ingresados no corresponden","noEulaTitle":"Confirmaci\xf3n de la creaci\xf3n de la cuenta","noEulaFirstDescription":"\xa1Ya casi ha terminado!","noEulaSecondDescription":"Al hacer clic en el bot\xf3n de abajo, la creaci\xf3n de su cuenta ser\xe1 efectiva. \xbfSeguimos?","privacyTitle":"Politica de confidencialidad","privacyFirstDescription":"Acepte la politica de privacidad para crear su cuenta.","privacySecondDescription":"Los encontrara haciendo clic en el enlace siguiente:","privacyLink":"Politica de confidencialidad","privacyAcceptLabel":"Acepto la politica de confidencialidad","noPrivacyTitle":"Politica de confidencialidad","noPrivacyFirstDescription":"\xa1Ya casi ha terminado!","noPrivacySecondDescription":"Al hacer clic en el bot\xf3n de abajo, la creaci\xf3n de su cuenta ser\xe1 efectiva. \xbfSeguimos?"},"accountOwner":{"male":"Sr. {name}","female":"Sra. {name}","other":"{name}","none":"{name}"},"connectedUserGreetings":{"withName":"\xa1Hola,\\n[emph]{name}[/emph]!","hello":"Hola,","withoutName":"\xa1Hola!"},"clientStatus":{"clientBlockedMessage":"Su cuenta est\xe1 bloqueada","clientBlockedLink":"Mas informaci\xf3n...","clientPendingMessage":"Estamos procesando la validaci\xf3n de su cuenta","accountUnderReview":"Cuenta en proceso de validaci\xf3n: la verificaci\xf3n de su expediente puede tardar unos d\xedas."},"profileMenu":{"title":"Perfil y ajustes","subtitle":"Encuentre aqu\xed toda la informaci\xf3n de su cuenta","generalSection":"Ajustes generales","profileTitle":"Mi perfil","profileSubtitle":"Gestione su cuenta y su informaci\xf3n","settingsTitle":"Ajustes","settingsSubtitle":"Gestione sus ajustes personales"},"navigationMenu":{"accountLink":"Inicio","profileLink":"Perfil y ajustes","transferLink":"Transferencias","payBillLink":"Servicios","cardsLink":"Mi tarjeta","savingsLink":"Ahorros","loansLink":"Pr\xe9stamos","contactLink":"Ayuda y apoyo","settingsLink":"Mira mi perfil","disconnectButton":"Cerrar sesi\xf3n","mandatesLink":"Mandates"},"transfertsSubmenu":{"allTransfer":"Hacer una transferencia","externalAccount":"Cuenta externa","recipients":"Beneficiarios","cashTransfer":"Transferencias pendientes","upcomingTransfers":"Ordenes permanentes","recharge":"Recargar mi cuenta","transactionCode":"C\xf3digo de transacci\xf3n","simpleTransfer":"Con un n\xfamero de tel\xe9fono"},"savingsSubmenu":{"mySavingsAccount":"Mis cuentas de ahorro","deposits":"Transferencias y dep\xf3sitos","createSavingsAccount":"Crear una cuenta de ahorros"},"simpleTransfer":{"newTransfer":"Nueva transferencia","title":"Con un n\xfamero de tel\xe9fono","searchRecipient":"Encuentra un destinatario","invalidPhoneNumber":"El n\xfamero de tel\xe9fono proporcionado no es reconocido."},"accountPendingVerification":{"title":"Verificacion de la cuenta","subtitle":"Su solicitud de apertura de cuenta esta bajo verificacion. Vuelva a intentarlo mas tarde una vez que el back-office lo haya revisado","retryButton":"Reintentar"},"accountsList":{"title":"Mis cuentas.","loadAccountsError":"Un error ocurri\xf3 al momento de cargar de las cuentas","loadAccountsRetry":"Reintentar","showAllAccountsLink":"Ver todas mis cuentas","noAccountAvailable":"No hay cuenta disponible"},"recipient":{"title":"Hacer una transferencia","subtitle":"\xbfA qui\xe9n quieres transferir tu dinero?","section":"Mis beneficiarios","noRecipientsAvailable":"No hay destinatarios disponible","noRecipientsMessage":"Agrega destinatarios para transferir dinero.","addRecipientButton":"A\xf1adir un beneficiario","transferTo":"Transferencia a {name}","searchInputPlaceholder":"B\xfasqueda","selector":{"beneficiaries":"Beneficiarios","externalAccounts":"Cuenta externa"},"deletePrompt":{"title":"Eliminar","message":"\xbfRRealmente desea eliminar el destinatario {name}?","recipient":"el beneficiario","externalAccountTitle":"Eliminar la cuenta externa","externalAccountMessage":"\xbfRealmente quiere eliminar su cuenta externa?","cancelButton":"Cancelar","confirmButton":"Confirmar"},"externalAccounts":{"title":"Cuentas externas","addButton":"A\xf1adir una cuenta externa","noneAvailableTitle":"Actualmente sin cuenta externa","noneAvailableMessage":"A\xf1ade una cuenta bancaria externa para transferir dinero.","pendingExternalAccountMessage":"Su cuenta externa est\xe1 siendo validada."}},"addRecipient":{"selector":{"iban":"IBAN","phone":"Tel\xe9fono","account":"N\xfam. de cuenta / BIC"},"unauthorized":"Ud. no se encuentra autorizado a acceder a esta funcionalidad","title":"A\xf1adir","subtitle":"un beneficiario","externalAccountSubtitle":"una cuenta externa","nameFieldPlaceholder":"Nombre","phoneFieldPlaceholder":"N\xfamero de tel\xe9fono","ibanFieldPlaceholder":"IBAN","accountFieldPlaceholder":"N\xfamero de cuenta","bicFieldPlaceholder":"BIC","bankFieldPlaceholder":"Banco/BIC","createButton":"A\xf1adir","otpAdditionalText":"A\xf1adir beneficiario {name}","otpAdditionalTextWithBank":"A\xf1adir beneficiario {name} del banco {bankName}","addConfirmationMessage":"El beneficiario {name} ha sido a\xf1adido con \xe9xito","searchBank":{"title":"Banco/BIC","bankPlaceholder":"Escriba al menos {num} letras para buscar","firstSearchMessage":"Haga una b\xfasqueda primero para obtener resultados","noBankMessage":"No se encontr\xf3 banco corresponsal","errorMessage":"Un error ocurri\xf3 al cargar la lista de bancos.","retryButton":"Reintentar"},"pollingModalSession":{"title":"Aprueba en la aplicaci\xf3n","messageCancelled":"Aprobaci\xf3n cancelada","messageFailed":"Aprobaci\xf3n fallida","messageRefused":"Aprobaci\xf3n rechazada","messageExpired":"Aprobaci\xf3n expirada.","messagePending":"Aprobaci\xf3n pendiente.","messagePendingCheck":"Por favor, revisa tu aplicaci\xf3n.","messageStarted":"Aprobaci\xf3n iniciada.","messageDone":"Aprobaci\xf3n exitosa","error":"Se produjo un error al cargar las operaciones para aprobar."}},"editRecipient":{"title":"Editar","subtitle":"un destinatario","externalAccountSubtitle":"el cuenta externa","saveButton":"Guardar"},"account":{"accountId":"N\xb0{id}","accountType":{"current":"Cuenta corriente","joint":"Cuenta conjunta","savings":"Cuenta de ahorros","dedicated":"Cuenta dedicada","moneyPot":"Collecta","technical":"Cuenta t\xe1cnica"},"detail":"Detalle"},"accountStatus":{"opened":"Abierta","closed":"Cerrada","blocked":"Bloqueada","debitBlocked":"D\xe9bito prohibido","creditBlocked":"Cr\xe9dito prohibido"},"homeScreen":{"accountBalance":"Saldo de la cuenta","monthlyFluxTitle":"Flujo de {month}","monthlyFluxIncome":"Mis ingresos","monthlyFluxExpense":"Mis gastos","allTransactionsLink":"Todas mis operaciones","latestTransactionsTitle":"Mis \xfaltimas operaciones","requiredActionsTitle":"Acciones requeridas","requiredActionsSeeAll":"Ver todo","transactionsToJustify":"Gastos por justificar","transactionsToQualify":"Gastos por calificar"},"allTransactions":{"title":"Historial de operaciones","subtitle":"Consulte todas sus operaciones y realice las acciones necesarias"},"accountTransactions":{"title":"Mis operaciones.","tagJustified":"Justificada","tagNotJustified":"No justificada","tagQualified":"Calificada","tagNotQualified":"No calificada","emptyTransactionList":"No hay transacciones por el momento","loadTransactionsError":"Un error","loadMoreTransactionsError":"Un error ocurri\xf3 al momento de cargar las operaciones","loadMoreTransactionsRetry":"Un error ocurri\xf3 al momento de cargar las operaciones","unjustifiedTransactions":{"title":{"one":"Tienes {count} transacci\xf3n en espera de justificativo","other":"Tienes {count} transacciones en espera de justificativo","more":"Tienes {count} or mas transacciones en espera de justificativo"},"description":"Algunas de sus transacciones est\xe1n esperando documentos de verificaci\xf3n."},"unjustifiedTransactions2":{"title":{"one":"Tienes {count} transacci\xf3n en espera de justificativo","other":"Tienes {count} transacciones en espera de justificativo","more":"Tienes {count} or mas transacciones en espera de justificativo"},"description":"Algunas de sus transacciones est\xe1n esperando documentos de verificaci\xf3n."},"unqualifiedTransactions":{"title":{"one":"Tienes {count} transacci\xf3n en espera de cacalificaci\xf3n","other":"Tienes {count} transacciones en espera de calificaci\xf3n","more":"Tienes {count} or mas transacciones en espera de calificaci\xf3n"},"description":"Algunas de sus transacciones est\xe1n esperando documentos de calificaci\xf3n."},"authorizationHolds":{"title":{"one":"Tienes {count} transacci\xf3n pendiente","other":"Tienes {count} transacciones pendientes","more":"Tienes {count} transacciones pendientes"},"description":"El dinero ha sido debitado de la cuenta pero a\xfan no ha sido recibido por el beneficiario."},"previousPeriodButtonLabel":"Periodo anterior","nextPeriodButtonLabel":"Siguiente periodo"},"authorizationHolds":{"cashoutLabel":"Retiro","paymentLabel":"Pago","externalToAccountLabel":"De sistema externo a cuenta","accountToExternalLabel":"De cuenta a sistema externo","externalFromAccountLabel":"Sistema externo desde cuenta","accountRechargeLabel":"Recarga de cuenta","onUsCreditTransferLabel":"Transferencia on-us","managementFeesLabel":"Costes de administraci\xf3n"},"accountingTransactionDetailsModal":{"detailsTitle":"Detalles","transferLabel":"Transferencia","description":"Descripci\xf3n: {description}","transaction":"N\xfamero: {id}","reference":"R\xe9f\xe9rence: {id}","feeLabel":"Honorario","commissionLabel":"Comisi\xf3n","taxLabel":"Impuesto","discountLabel":"Descuento","interestLabel":"Intereses","amountLabel":"Total","balanceLabel":"Saldo despu\xe9s de la operaci\xf3n","additionalInformationTitle":"Informaci\xf3n adicional","geolocationTitle":"Localizaci\xf3n","externalIdLabel":"Referencia de operaci\xf3n del tercero: {externalid}","justifyButtonLabel":"Justificar","refundButtonLabel":"Solicitar un reembolso","verifyJustificationsButtonLabel":"Verificar justificativos","justificationFollowUpTitle":"Seguimiento de justificaci\xf3n","documentsSubmitted":"Recibos presentados","validationInProgress":"Esperando la validaci\xf3n"},"authorizationHoldsDetailsModal":{"pending":"Pendiente","detailsTitle":"Detalles","transferLabel":"Transferencia","reference":"N\xfamero: {id}","amountLabel":"Total"},"allAccountsScreen":{"goBackClassicViewButton":"Volver a la vista cl\xe1sica","noAccountAvailable":"No hay cuenta disponible"},"recipientDetail":{"information":"Informaci\xf3n.","accountDetail":"RIB/informaci\xf3n de cuenta.","transferMoneyButton":"Transferencia de dinero","dedicatedTransferButton":"Transferencia en bono de compra"},"amountSelection":{"amountLabel":"Monto","currencyLabel":"Divisa:","descriptionLabel":"Descripci\xf3n:","descriptionButton":"A\xf1adir una descripci\xf3n","descriptionPlaceholder":"A\xf1adir un mensaje","simpleTransferNameLabel":"Nombre :","simpleTransferNamePlaceholder":"Escribir un nombre","simpleTransferPhoneLabel":"Tel\xe9fono :","simpleTransferPhonePlaceholder":"Escribir un tel\xe9fono","sendButton":"Siguiente","since":"Desde","to":"Hasta","choose_source_account":"Elegir una cuenta de origen","choose_destination_account":"Elegir una cuenta de destino","my_accounts":"Mis cuentas","my_external_account":"Cuentas externa","my_recipients":"Mis beneficiarios","network":"Red","load_more":"Cargar m\xe1s","convertedAmountLabel":"Monto convertido","creditorAddress":{"addressLabel":"Direcci\xf3n","countryLabel":"Pa\xeds","buildingNumber":"N\xb0","streetName":"Calle","postCode":"C\xf3digo postal","townName":"Ciudad","country":"Pa\xeds"},"insufficient_balance":"La cuenta seleccionada no tiene saldo suficiente para realizar esta operaci\xf3n","instant_transfer_label":"Haga de esto una transferencia instant\xe1nea"},"acceptorSelection":{"title":"Selecci\xf3n de un comerciante","selectionButton":"Seleccionar"},"dedicatedTransferAmount":{"title":"Monto del regalo","subtitle":"Punto de transacci\xf3n: {code}"},"dedicatedTransferSummary":{"recepient":"Destinatario","account":"Cuenta debitada","amount":"Monto m\xe1ximo","transactionPoint":"Punto de transacci\xf3n","expirationDate":"Fecha de expiraci\xf3n","done":"Terminar"},"pincodeConfirmation":{"label":"Ingrese su c\xf3digo secreto para continuar","networkError":"Verifique su conexi\xf3n a Internet antes de continuar","loadKeyboardError":"Un error ocurri\xf3 al momento de cargar el teclado","loadKeyboardRetry":"Recargar teclado"},"transferSummary":{"accountTransferMode":"Hacia cuenta","cashTransferMode":"Hacia efectivo","summaryTitle":"\xc9xito","accountSummarySubtitle":"Detalle de la transferencia","cashSummarySubtitle":"Ud. va a recibir un mensaje que contiene un c\xf3digo a entregar a {recipient} o consulte sus transferencias pendientes para recuperar el c\xf3digo.","summaryMiddleStep":"Transferencia","fees":"Honorarios: {amount}","commission":"Comisi\xf3n: {amount}","discount":"Descuento: {amount}","tax":"Impuesto: {amount}","you":"Usted","done":"Terminar","customerInstructionSuccessMessage":"Su transferencia N\xb0{id} a {recipient} ha sido realizada con \xe9xito.","recurringTransferSuccessMessage":"La transferencia recurrente N\xb0{id} a {recipient} se ha creado correctamente."},"billFormScreen":{"nextButton":"Siguiente","textInputPlaceholder":"Escriba cualquier cosa...","saveReferencePromptTitle":"Guardar el {name}","replaceReferencePromptTitle":"Remplazar el {name}","saveReferencePromptMessage":"\xbfDesea guardar el {name} para este emisor de facturas?","replaceReferencePromptMessage":"\xbfDesea remplazar el {name} para este emisor de facturas?","saveReferencePromptCancel":"Cancelar","saveReferencePromptConfirm":"Guardar","replaceReferencePromptConfirm":"Remplazar","saveReferenceErrorMessage":"El {name} no pudo ser guardado","docInputFilled":"Un archivo","docInputEmpty":"A\xf1adir or soltar una foto aqu\xed","confirmationMessage":"Haga clic a continuaci\xf3n para confirmar su pago de [b]{amount} [/b] a [b]{issuer}[/b]","confirmButton":"Confirmar"},"billConfirmationScreen":{"fees":"Costes : [b]{amount}[/b]","commission":"Comisi\xf3n : [b]{amount}[/b]","discount":"Descuento : [b]{amount}[/b]","tax":"Impuesto : [b]{amount}[/b]"},"formError":{"invalidIBAN":"El IBAN es inv\xe1lido","invalidFileSize":"Su archivo excede el tama\xf1o m\xe1ximo aceptado ({size})","invalidFileFormat":"El formato de su archivo no es compatible. Formatos aceptados: {formats}"},"billIssuersScreen":{"title":"Mis servicios.","references":"Mis referencias","searchInputPlaceholder":"B\xfasqueda","emptyListLabel":"No hay socios disponibles","loadBillIssuersError":"Un error ocurri\xf3 al momento de cargar los socios"},"billReferencesScreen":{"title":"Mis referencias","services":"Volver a mis servicios","subtitle":"Datos guardados para sus pagos","emptyRecipientList":"No tiene referencias guardadas","deletePromptTitle":"Eliminar la referencia","deletePromptMessage":"\xbfRealmente quiere eliminar la referencia {name}?","deletePromptCancel":"Cancelar","deletePromptConfirm":"Confirmar","deleteConfirmationMessage":"La referencia {name} ha sido eliminada con \xe9xito","deleteErrorMessage":"La referencia {name} no ha podido ser eliminada","loadBillReferencesError":"Un error ocurri\xf3 al momento de cargar sus referencias","lastUpdateDateTime":"\xdaltima actualizaci\xf3n: {date} a {time}"},"otp":{"explanation":"Ingrese el c\xf3digo de seis d\xedgitos que le enviamos a:","sendBackCodeButton":"Reenviar el c\xf3digo","backToRecipients":"Atr\xe1s","confirmOtpButton":"Confirmer","goToTransferFormButton":"Ir al formulario de transferencia","otpBlockedErrorMessage":"Ha realizado 3 intentos incorrectos. Inicie la operaci\xf3n desde el principio."},"myAccountScreen":{"title":"Mi cuenta","subtitle":"Toda la informaci\xf3n y los detalles de su cuenta personal","coordinatesTitle":"Datos de su cuenta","quickActionsTitle":"Acciones r\xe1pidas","downloadRib":"Descargar mis datos bancarios","shareDetails":"Compartir mis datos bancarios","manageBeneficiaries":"Gestionar beneficiarios","manageBeneficiariesSubtitle":"A\xf1ada o elimine sus beneficiarios bancarios","accountStatement":"Extracto de cuenta","accountStatementSubtitle":"Consulte el detalle de sus operaciones bancarias","feesStatement":"Extracto de comisiones","feesStatementSubtitle":"Consulte el detalle de sus comisiones bancarias","accountStatementPageSubtitle":"Encuentre y descargue todos sus extractos de cuenta por periodo.","feesStatementPageSubtitle":"Encuentre y descargue todos sus extractos de comisiones por periodo.","allYears":"A\xf1os"},"accountDetails":{"availableBalanceTitle":"Saldo disponible","balanceTitle":"Saldo actual","balanceMessage":"El saldo actual no tiene en cuenta las operaciones pendientes","accountStatus":{"blocked":"Esta cuenta se encuentra bloqueada. Para mayor informaci\xf3n por favor contacte nuestro soporte","debitBlocked":"Los d\xe9bitos est\xe1n actualmente prohibidos en esta cuenta. Para mayor informaci\xf3n por favor contacte nuestro soporte","creditBlocked":"Los creditos est\xe1n actualmente prohibidos en esta cuenta. Para mayor informaci\xf3n por favor contacte nuestro soporte"},"accountName":"Nombre de cuenta","accountIdTitle":"N\xfamero de cuenta","ibanTitle":"IBAN","bicTitle":"BIC","coOwnerTitle":"Copropietario","authorizedOverdraftTitle":"Sobregiro autorizado","reachedOverdraftMessage":"Has alcanzado tu sobregiro autorizado.","validityDate":"Hasta {date}","accessStatements":"Estados de cuenta","shareRIBLabel":"Compartir informaci\xf3n de cuenta","shareRIBMessage":"{firstName} {lastName} {postName}","dedicatedMessage":"Puede gastar esta cantidad en:","clipboard":"{name} copiado","downloadBankDetails":"Datos bancarios","accountStartDate":"Fecha de inicio de cuenta","maximumBoundaries":"Saldo maximal","initialAmountLabel":"Saldo inicial","endDateLabel":"Saldo inicial","durationLabel":"Duraci\xf3n","monthsLabels":{"DAILY":"d\xedas","WEEKLY":"semanas","MONTHLY":"mes","QUARTERLY":"trimestrial","SEMESTER":"semestres","ANNUALLY":"a\xf1os"},"rateValueLabel":"Tarifa aplicada","indexCodeLabel":"Indice","rateStartDateLabel":"Fecha de inicio de tarifa","accruedInterestsLabel":"Intereses adquiridos","startDateLabel":"Adquirido desde","forecastInterestsLabel":"Inter\xe9s total proyectado","initialAERLabel":"TRAAB","success":"Cambio guardado"},"statementsFilters":{"allAgencies":"Todas las agencias","allYears":"Todos los a\xf1os","years":"A\xf1os"},"accountsStatements":{"title":"Estados de cuenta","subtitle":"Todos mis estados de cuenta","accountLabel":"Cuenta No. {id}","accounts":"Cuentas","statements":"Estados de cuenta disponibles","emptyStatementList":"Ning\xfan estado de cuenta est\xe1 disponible","cancel":"Cancelar","loadStatementsError":"Un error ocurri\xf3 al momento de cargar los estados de cuenta","generateButton":"Generar"},"taxStatements":{"title":"Mis declaraciones fiscales","subtitle":"Todas las declaraciones","accountLabel":"Cuenta n\xb0{id}","accounts":"Cuentas","statements":"Declaraciones fiscales disponibles","emptyStatementList":"No hay declaraciones fiscales disponibles","cancel":"Cancelar","loadStatementsError":"Se produjo un error al cargar las declaraciones fiscales.","generateButton":"Generar"},"feesStatements":{"title":"Declaraciones de tarifas","subtitle":"Todos mis estados de declaraciones de tarifas","accountLabel":"Cuenta No. {id}","accounts":"Cuentas","statements":"Declaraciones de tarifas disponibles","emptyStatementList":"Ning\xfan declaracion de tarifas est\xe1 disponible","cancel":"Cancelar","loadStatementsError":"Un error ocurri\xf3 al momento de cargar las declaraciones de tarifas"},"cardsList":{"title":"Mis tarjetas.","loadCardsError":"Un error ocurri\xf3 al momento de cargar de las tarjetas","loadCardsRetry":"Reintentar","showAllCardsLink":"Ver todas mis tarjetas","myCardTitle":"Mi tarjeta","myCardSubtitle":"Consulte y gestione su tarjeta","availableBalance":"Saldo disponible","emptyTitle":"Todav\xeda no se ha a\xf1adido ninguna tarjeta","emptyDescription":"A\xf1ada una tarjeta para empezar a realizar sus pagos.","addCardButton":"A\xf1adir una tarjeta","orderCard":"Pedir una nueva tarjeta","refabricateButton":"Reemplazar la tarjeta","infos":{"title":"Informaci\xf3n adicional"},"details":{"title":"Detalles de la tarjeta","holder":"Nombre del titular","number":"N\xfamero de la tarjeta","date":"Fecha de expiraci\xf3n"}},"allCardsScreen":{"goBackClassicViewButton":"Volver a la vista cl\xe1sica","noCardAvailable":"No hay tarjeta disponible"},"card":{"virtual":"Virtual","title":"TARJETA","status":{"all":"Todas","active":"Activa","pending":"Pendiente","new":"Nueva","expired":"Expirada","blocked":"Bloqueada","opposed":"Opuesta","removed":"Remota","cancelled":"Cancelada"},"feature":{"nfc":"Sin contacto","cashOperation":"Retiro","foreignPayment":"Pago en el extranjero","onlinePayment":"Pago en l\xednea","eurWithdrawal":"Retiro en la zona euro","foreignWithdrawal":"Retiro en el extranjero","paymentAuthorized":"Pago autorizado","eurPayment":"Pago en la zona euro","foreignAll":"Retiro y pago en el extranjero","foreignOnlinePayment":"Pago en l\xednea en el extranjero"},"pendingOperation":{"refabrication":"Se est\xe1 rehaciendo la tarjeta","codeReissuing":"Se est\xe1 cambiando el c\xf3digo PIN de su tarjeta","opposition":"Su tarjeta se est\xe1 en curso de opuesta","blocking":"Su tarjeta se est\xe1 en curso de bloqueada","unblocking":"Su tarjeta se est\xe1 en curso de desbloqueo","activation":"Su tarjeta se est\xe1 en curso de activada","creation":"Su tarjeta se est\xe1 creando","limitsUpdate":"Se est\xe1n cambiando los l\xedmites de su tarjeta","featuresUpdate":"Se est\xe1 cambiando la funcionalidad \\"{feature}\\" de su tarjeta","unknownFeatureUpdate":"Se est\xe1 cambiando una funcionalidad de su tarjeta"}},"cardPincode":{"importantMessage":"Tenga cuidado de conservar este c\xf3digo:\\nLo necesitar\xe1 para validar transacciones con su tarjeta.","previous":"Cambiar","next":"Siguiente","errorCodesMismatch":"Los c\xf3digos no coinciden."},"cardOptions":{"title":"Configuraci\xf3n de la tarjeta y de los pagos","outstandings":{"navigateButton":"Mis l\xedmites","title":"Mis l\xedmites","subtitle":"Ver los l\xedmites de su tarjeta","paymentHeader":"L\xedmites de pago","cashoutHeader":"L\xedmites de retiro","paymentLimits":"L\xedmites de pago","slidingPeriod":"periodo de {num} {unit} consecutivos","fixedPeriod":"del {startDate} al {endDate}","used":"Us\xf3","available":"Disponible","maxAmount":"Monto m\xe1x","maxOperations":"Operaciones m\xe1x","selector":{"payments":"Pagos","cashouts":"Retiros"},"noOutstandingLabel":"No l\xedmites","errorMessage":"Un error ocurri\xf3 al cargar los l\xedmites.","retryButton":"Reintentar","durationUnit":{"hour":"hora","hours":"horas","day":"d\xeda","days":"d\xedas","week":"semana","weeks":"semanas","month":"mes","months":"meses","year":"a\xf1o","years":"a\xf1os"},"updateButtonLabel":"Modificar su l\xedmite","modal":{"title":"Modificar su l\xedmite","inputLabel":"Fijar un l\xedmite","inputLabelUnit":{"day":"diario","week":"semanal","month":"mensual","year":"anual","all":"global"},"maximumLabel":"Maximo","submitButtonLabel":"Modificar","validationMsg":"Su modificaci\xf3n ha sido tomada en cuenta"}},"refabricate":{"modal":{"title":"Confirmaci\xf3n","message":"Confirma que deseas reemplazar esta tarjeta","cardNumber":"{cardNumber} ","submitButtonLabel":"Confirmar"},"motiveLabel":"Seleccione el motivo","motivesOptions":{"DAMAGED":"Tarjeta danada","STOLEN":"Tarjeta robada","LOST":"Tarjeta perdida","ABUSE":"Uso fraudulento"}},"oppositionCard":{"opposeButton":"Hacer oposici\xf3n","opposeDescription":"Proteja sus fondos en caso de p\xe9rdida o robo","title":"Para hacer oposici\xf3n y bloquear permanentemente su tarjeta, elija una de las siguientes razones:","reasonLost":"Tarjeta perdida","reasonStolen":"Tarjeta robada","reasonNotDistributed":"Tarjeta no distribuida","opposeConfirmButton":"Confirmar","opposeCancelButton":"Cancelar","opposePromptTitle":"Hacer oposici\xf3n","opposePromptMessage":"Esta operaci\xf3n es irreversible. \xbfEst\xe1 seguro de querer hacer oposici\xf3n?"},"deactivateCard":{"deactivateButton":"Hacer deactivac\xf3n","title":"Para hacer deactivac\xf3n y bloquear permanentemente su tarjeta, elija una de las siguientes razones:","deactivateConfirmButton":"Confirmar","deactivateCancelButton":"Cancelar","deactivatePromptTitle":"Hacer deactivac\xf3n","deactivatePromptMessage":"Esta operaci\xf3n es irreversible. \xbfEst\xe1 seguro de querer hacer oposici\xf3n?"},"updateCardPincode":{"updateButton":"Cambiar PIN de tarjeta","updateDescription":"Cambie su c\xf3digo PIN de forma segura","title":"Edici\xf3n de c\xf3digo","definePincodeMessage":"Elija un nuevo PIN de cuatro d\xedgitos para su tarjeta. Sobre todo, no se lo comunique a nadie, es estrictamente confidencial.","confirmPincodeMessage":"Confirme el c\xf3digo PIN de su tarjeta para continuar.","successTitle":"\xa1Felicidades!","successSubtitle":"\xa1El c\xf3digo PIN ha sido actualizado!","failureTitle":"Error","failureSubtitle":"Pedimos disculpas.","failureDescription":"Parece que hubo un error al cmbiar el c\xf3digo PIN por su tarjeta. Int\xe9ntelo de nuevo m\xe1s tarde o p\xf3ngase en contacto con nuestro servicio de atenci\xf3n al cliente.","confirmationPopup":{"message":"Si deja de editar el c\xf3digo PIN, no se actualizar\xe1.\\n\xbfDejar de editar?"}},"activationCard":{"title":"Activar mi tarjeta","activateButton":"Activar","defaultActivationMessage":"Ingrese el identificador de 9 d\xedgitos en el reverso de su tarjeta.","identifier":"Su identificador de 9 d\xedgitos","next":"Siguiente","confirm":"Activar","inputError":"Error de entrada, int\xe9ntalo de nuevo.","stepPincode":{"title":"C\xf3digo PIN","definePincodeMessage":"Ahora debe elegir un c\xf3digo PIN de cuatro d\xedgitos para su tarjeta. Sobre todo, no se lo comunique a nadie, es estrictamente confidencial.","confirmPincodeMessage":"Confirme el c\xf3digo PIN de su tarjeta para continuar."}},"switch":{"lockCard":"Bloqueo temporal"},"featuresSwitchesOverlay":{"cardLocked":"Tarjeta bloqueada"},"cardOpposedMessage":"Ud. ha realizado una oposici\xf3n sobre esta tarjeta y por eso no puede acceder a sus opciones"},"accountBlockedScreen":{"title":"Cuenta bloqueada","multipleAttemptBlockedReason":{"subtitle":"Tres intentos err\xf3neos de c\xf3digo secreto","message":"Lamentablemente, su cuenta ha sido bloqueada debido a tres intentos incorrectos de c\xf3digo secreto. P\xf3ngase en contacto con nuestro soporte {contacts}para restablecer su c\xf3digo secreto."},"defaultBlockedReason":{"message":"Lamentablemente, su cuenta ha sido bloqueada. P\xf3ngase en contacto con nuestro soporte {contacts}para restablecer su c\xf3digo secreto."},"contactsPhoneAndEmail":"al {contactPhone} o por correo electr\xf3nico a {contactEmail} ","contactsPhone":"al {contactPhone} ","contactsEmail":"o por correo electr\xf3nico a {contactEmail} ","button":"OK entend\xed"},"bankContactScreen":{"title":"Mi banco.","question":"\xbfNecesitas ayuda?","addressContact":"Encu\xe9ntranos","phoneContact":"Ll\xe1manos","urlContact":"Qui\xe9nes somos","emailContact":"Escr\xedbenos"},"pincodeChangeFlow":{"currentCodeLabel":"Ingrese su c\xf3digo actual","newCodeLabel":"Ingrese su nuevo c\xf3digo","newCodeConfirmationLabel":"Confirme su nuevo c\xf3digo","newCodesDontMatchError":"Los c\xf3digos ingresados no corresponden","success":"Su c\xf3digo ha sido cambiado con \xe9xito"},"pincodeChangeScreen":{"title":"Cambio de c\xf3digo","subtitle":"Cambie su c\xf3digo secreto para mayor seguridad","message":"Es necesario que Ud. cambie su c\xf3digo secreto antes de realizar esta operaci\xf3n","messageAfterAuthentication":"Ud. debe cambiar su c\xf3digo secreto antes de realizar nuevas operaciones","changePincodeButton":"Cambiar mi c\xf3digo secreto","laterButton":"M\xe1s tarde","done":"Terminar"},"clientInformation":{"title":"Mi informaci\xf3n personal","birthDateTitle":"Fecha de nacimiento","birthPlaceTitle":"Lugar de nacimiento","addressTitle":"Direcci\xf3n","phoneTitle":"Tel\xe9fono","emailTitle":"Email","emailSuccess":"Usted ha recibido un correo electr\xf3nico de confirmaci\xf3n","viewMore":"Ver m\xe1s","viewLess":"Ver menos"},"documents":{"title":"Mis documentos","CREDITADRESSPROOF":"Comprobante de domicilio de cr\xe9dito","PASSPORT":"Pasaporte","CREDITID":"Identificaci\xf3n de cr\xe9dito","PORTRAIT":"Retrato","PROOF_OF_ACTIVITY":"Prueba de actividad"},"cashTransferScreen":{"title":"Mis transferencias pendendientes","subtitle":"Cancelar o recuperar su dinero","receivedSelector":"Recibidas","sentSelector":"Enviadas","recipient":"Enviado a : ","sender":"Envoy\xe9 por : ","emptyReceivedList":"Ninguna transferencia recibida","emptySentList":"Ninguna transferencia enviada","receivedTransferDefaultTitle":"Transferencia recibida","sentTransferDefaultTitle":"Transferencia enviada","codeLabel":"C\xf3digo: {code}","cancelCashTransferButton":"Cancelar la transferencia","retrieveCashTransferButton":"Enviar a mi cuenta","loadCashTransfersError":"Un error ocurri\xf3 al momento de cargar las transferencias en efectivo","loadMoreCashTransfersError":"Un error ocurri\xf3 al momento de cargar las transferencias en efectivo","loadMoreCashTransfersRetry":"Intentar de nuevo","nextButton":"Siguiente","cashCodeTitle":"Ingrese el c\xf3digo enviado por el remitente de la transferencia","invalidCode":"El c\xf3digo ingresado no es v\xe1lido","summaryTitle":{"sentCashTransfer":"Transferencia cancelada","receivedCashTransfer":"Transferencia recuperada en su cuenta"}},"settings":{"title":"Mis ajustes personales","changeLanguageTitle":"Idioma","changeLanguageDescription":"Elija el idioma de la aplicaci\xf3n y de los mensajes que le enviaremos","languageChangeConfirmation":"El idioma ha sido cambiado con \xe9xito","languageChangeFailed":"Un error se produjo al momento de cambiar el idioma","changePincodeTitle":"Cambiar mi c\xf3digo secreto","changePincodeDescription":"Para mayor seguridad, cambie su c\xf3digo secreto regularmente","accountDeleteTitle":"Eliminar mi cuenta","accountDeleteDescription":"Eliminar mi cuenta de Skaleet de forma permanente."},"accountDeleteScreen":{"title":"Eliminar mi cuenta","subtitle":"Tenga en cuenta que no necesita eliminar su cuenta si:","button":"Eliminar su cuenta","explanation":"Su solicitud ser\xe1 enviada a nuestro equipo. Esta operaci\xf3n puede tardar varios d\xedas.","options":{"changeProfile":{"title":"Quieres cambiar su c\xf3digo","description":"Cambias su c\xf3digo secreto."},"unHappy":{"title":"No est\xe1s contento","description":"Cont\xe1ctanos y cu\xe9ntanos por qu\xe9."}},"confirm":{"title":"Realmente deseas solicitar el cierre de tu cuenta?","subtitle":"Perderas permanentemente todos los datos de tu cuenta, contactos e informacion de perfil","placeholder":"Proporcione una razon para cerrar la cuenta","warning":"Despues de esto ya no hay vuelta atras","button":"Confirmar","success":"La solicitud de cierre de cuenta se ha enviado correctamente"}},"accountDeleteMail":{"subject":"Solicitud para eliminar la cuenta de {username}","body":"Hola, les pido amablemente que eliminen mi cuenta de usuario."},"transactionFilter":{"all":"Todas","credit":"Ingresos","debit":"Gastos","searchDescription":"Usando el motor de b\xfasqueda, encuentre f\xe1cilmente sus gastos.","searchInputPlaceholder":"Buscar una operaci\xf3n","timeRangeSelectionTitle":"Fecha personalizada","timeRange":{"month":"Este mes","week":"\xfaltimos 7 d\xedas","quarter":"\xfaltimos 3 meses","from":"Del :","to":"Al :"},"advancedSearch":"B\xfasqueda avanzada","confirm":"Confirmar","amountRangeSelectionTitle":"Filtrar por cantidad","panelTitle":"Filtros","clearAll":"Borrar todo","apply":"Aplicar","toJustify":"Por justificar","toQualify":"Por calificar","amountRangeTitle":"Rango de gastos","periodTitle":"Periodo","filtersButton":"Filtrar las operaciones","allAmountRange":"Todas las cantidades","amountRange":{"min":"M\xedn:","max":"M\xe1x:"},"emptySearchResult":"No hay transacciones"},"resultScreen":{"activateCard":{"successTitle":"Felicidades !","successSubtitle":"Tu tarjeta ha sido activada !","failureTitle":"Error","failureSubtitle":"Le pedimos disculpas.","failureDescription":"Parece que se ha producido un error al activar su tarjeta. Vuelva a intentarlo m\xe1s tarde o p\xf3ngase en contacto con nuestro servicio de atenci\xf3n al cliente."},"createCard":{"successTitle":"\xa1Felicidades!","defaultSuccessSubtitle":"Su tarjeta ha sido creada !","failureTitle":"Error","failureSubtitle":"Pedimos disculpas.","failureDescription":"Parece que hubo un error al crear su tarjeta. Int\xe9ntelo de nuevo m\xe1s tarde o p\xf3ngase en contacto con nuestro servicio de atenci\xf3n al cliente."},"updateOutstanding":{"successTitle":"\xa1Felicidades!","defaultSuccessSubtitle":"Tu l\xedmite ha sido cambiado.","failureTitle":"Error","failureSubtitle":"Le pedimos disculpas.","failureDescription":"Parece que hubo un error al cambiar su l\xedmite. Int\xe9ntelo de nuevo m\xe1s tarde o p\xf3ngase en contacto con nuestro servicio de atenci\xf3n al cliente."},"refabricate":{"successTitle":"\xa1Felicidades!","successSubtitle":"Su demanda ha sido tomada en cuenta","failureTitle":"Error","failureSubtitle":"Pedimos disculpas.","failureDescription":"Parece que hubo un error al reemplazar su tarjeta. Int\xe9ntelo de nuevo m\xe1s tarde o p\xf3ngase en contacto con nuestro servicio de atenci\xf3n al cliente."},"sensitiveDetails":{"successTitle":"\xa1Felicidades!","successSubtitle":"Continuar consultando los datos sensibles de la tarjeta","failureTitle":"Error","failureSubtitle":"Pedimos disculpas.","failureDescription":"Parece que hubo un error al obtener los datos confidenciales de su tarjeta. Int\xe9ntelo de nuevo m\xe1s tarde o p\xf3ngase en contacto con nuestro servicio de atenci\xf3n al cliente."},"done":"Terminado"},"createCard":{"title":"Nueva tarjeta","virtualCardtitle":"Nueva tarjeta virtual","loadProductsError":"Un error ocurri\xf3","loadProductsRetry":"Reintentar","stepSelection":{"title":"Selecci\xf3n de cuenta","selectAccountMessage":"Seleccione la cuenta para la que desea solicitar una tarjeta:","selectVirtualCardMessage":"Seleccione la cuenta para la que desea solicitar una tarjeta virtual:","selecProductMessage":"\xbf Qu\xe9 tarjeta te gustar\xeda pedir ?","selectProductForVirtualCardMessage":"\xbf Qu\xe9 tarjeta virtual te gustar\xeda pedir ?","orderCardButton":"Pedir mi tarjeta","createVirtualCardButton":"Crear una tarjeta virtual","virtualCardTitle":"Obtenga una tarjeta virtual gratuita","virtualCardDescription":"Para compras en l\xednea seguras sin temor a perder su tarjeta !","accountLabel":"Cuenta No. {id}"},"stepCgu":{"title":"T\xe9rminos de servicio","acceptMessage":"Al activar el interruptor, confirmas que has le\xeddo y aceptado nuestras condiciones generales de uso.","next":"Siguiente"}},"recharge":{"title":"Elige una cuenta","description":"Seleccione la cuenta para recargar","noAccountAvailable":"No cuenta recargable","noAccountExplanation":"Parece que no tienes una cuenta recargable.","contactSupport":"Soporte de contacto","rechargeButton":"Recargar"},"rechargeMethod":{"title":"Modos de carga","subtitle":"\xbfC\xf3mo quieres recargar tu cuenta?","withCard":{"title":"Tarjeta de cr\xe9dito","description":"Su cuenta se acreditar\xe1 instant\xe1neamente. Retiros en bancos asociados en todo el mundo.","instantTag":"Instant\xe1neo"},"bankDebit":{"title":"D\xe9bito","description":"Financie la cuenta desde su cuenta externa {bankName}. Su cuenta no se acreditar\xe1 instant\xe1neamente.","noBankDescription":"Financie la cuenta desde su cuenta externa. Su cuenta no se acreditar\xe1 instant\xe1neamente."}},"contactSupport":{"notHappyTitle":"\xbfC\xf3mo podemos ayudarle?","notHappyMessage":"D\xedganos qu\xe9 ocurre e intentaremos solucionarlo.","noContactAvailable":"No hay ning\xfan medio de contacto disponible por el momento.","rechargeNotAvailableTitle":"\xbf No puedes recargar tu cuenta?","rechargeNotAvailableMessage":"Comun\xedquese con nuestro equipo de soporte que le dir\xe1 qu\xe9 hacer..","contactByPhone":"Cont\xe1ctanos por tel\xe9fono al {phoneNumber}","contactByEmail":"Cont\xe1ctenos por correo electr\xf3nico al {email}","done":"Terminar"},"rechargeBankToWallet":{"title":"Recarga por d\xe9bito bancaria","subtitle":"Cantidad a recargar","accountWithdrawnTitle":"Cuenta externa de debito","accountWithdrawnMessage":"Editable a trav\xe9s del men\xfa Transferencias","iban":"IBAN","amountToWithdraw":"Monto a retirar:","recharge":"Recargar"},"rechargeByCard":{"title":"Recarga con tarjeta","subtitle":"Cantidad a recargar","creditedAccountTitle":"Cuenta acreditada","accountId":"N\xb0{id}","amountToCredit":"Monto a acreditar :","recharge":"Recargar"},"rechargeSummary":{"title":"\xc9xito","rechargedAccount":"Cuenta recargada","rechargeMethod":"Modo de recarga","bankToWalletMethod":"D\xe9bito","cardMethod":"Por tarjeta","rechargeAmount":"Cantidad recargada","done":"Terminar"},"recurringTransfer":{"endDateLabel":"Fecha de finalizaci\xf3n","firstExecutionDateLabel":"Fecha de inicio","frequencyLabel":"Frecuencia","switchLabel":"Hacer esta transferencia recurrente","optionLabel":{"daily":"Diario","weekly":"Semanal","twiceAMonth":"Quincenal","monthly":"Mensual"},"recurringTransferTitleDetails":"A {destinationAccount}","beneficiaryDetails":"Detalles del beneficiario","scheduledAmount":"Monto programado","beneficiaryAccount":"Cuenta del beneficiario","beneficiaryBIC":"BIC del beneficiario","recurringTransferDetails":"Detalles de la transferencia recurrente","sourceAccount":"Cuenta de origen","frequency":"Frecuencia","nextExecutionDate":"Pr\xf3xima fecha de ejecuci\xf3n","endDate":"Fecha de finalizaci\xf3n","description":"Descripci\xf3n"},"transactionCode":{"title":"C\xf3digo de transacci\xf3n","description":"Crea un c\xf3digo para usarlo en uno de nuestros puntos de transacci\xf3n.","noCodeAvailable":"Sin c\xf3digo de transacci\xf3n activo","noCodeAvailableExplanation":"Para generar un nuevo c\xf3digo de transacci\xf3n, obtenga el n\xfamero de 6 d\xedgitos del socio.","codeTooltip":"C\xf3digo","newCodeButton":"Nuevo c\xf3digo","modalBackButton":"Volver","selectAcceptor":{"title":"Punto de transacci\xf3n","description":"Ingrese el n\xfamero de 6 d\xedgitos del punto de transacci\xf3n","next":"Siguiente"},"selectAmount":{"title":"Cantidad permitida","acceptorReminder":"Punto de transacci\xf3n : {acceptorId}","currencyLabel":"Divisa :","amountLabel":"Monto :","amountInformationLabel":"Monto m\xe1ximo de transacci\xf3n (incluidas las tarifas)","next":"Genera mi c\xf3digo"},"pincode":{"title":"C\xf3digo secreto","description":"Ingresa tu c\xf3digo secreto para terminar"},"summary":{"title":"\xc9xito","transactionCode":"C\xf3digo de transacci\xf3n","transactionPoint":"Punto de transacci\xf3n","maxAmount":"Monto m\xe1ximo","expiryDate":"Fecha de caducidad","done":"Terminar"}},"trustChoice":{"title":"\xbfConf\xedas en este navegador?","explanation":"Si elige confiar en este navegador, no tendr\xe1 que ingresar un c\xf3digo de validaci\xf3n durante su pr\xf3xima conexione.","laterButton":"Otra vez","dontTrustButton":"Confiar","trustButton":"No conf\xedes"},"ubbleCheckScreen":{"success":{"title":"\xa1BIEN HECHO!","subtitle":"\xa1Gracias por su registro!","message":"Su identidad  est\xe1 siendo verificada por nosotros. El proceso de verificaci\xf3n puede tardar de unas horas a unos d\xedas.\\nAhora puede conectarse a su espacio o cerrar esta ventana.","button":"Continuar"},"fail":{"title":"LO SIENTO","subtitle":"Ocurri\xf3 un error durante su registro","message":"Puedes volver a intentarlo usando el mismo enlace que antes.\\nSi experimenta otro error, comun\xedquese con nuestro equipo por tel\xe9fono o correo electr\xf3nico utilizando los botones a continuaci\xf3n.","byPhone":"Tel\xe9fono","byEmail":"Correo electr\xf3nico"}},"justifyScreen":{"title":"Justificar mi gasto","subtitle":"Agregar y editar una credencial","attachments":{"title":"Documentos de respaldo","sectionTitle":"Subir o enviar prueba","sectionSubtitle":"En formato pdf, jpeg, png","addButtonLabel":"Agregar un recibo","addOtherButtonLabel":"Agregar un otro recibo","deletePrompt":{"title":"Supprimer le justificatif","message":"\xcates-vous s\xfbr de vouloir supprimer ce justificatif ?","cancelButton":"Annuler","confirmButton":"Supprimer"}},"spendings":{"title":"Gastos","sectionTitle":"A\xf1adir un gasto","sectionSubtitle":"Declarar los gastos menores de su recibo","addButtonLabel":"A\xf1adir un gasto","addOtherButtonLabel":"Agregar otro gasto","addModal":{"title":"A\xf1adir un gasto","editTitle":"Editar un gasto","message":"Detalles adicionales del justificativo","createButton":"A\xf1adir","editButton":"Editar"},"addForm":{"titleLabel":"T\xedtulo","categoryLabel":"Categor\xeda","subcategoryLabel":"Subcategor\xeda","amountLabel":"Cantidad","additionalDataLabel":"Datos adicionales","addAdditionalDataButton":"A\xf1adir un dato adicional"},"deletePrompt":{"title":"Supprimer le justificatif","message":"\xcates-vous s\xfbr de vouloir supprimer ce justificatif ?","cancelButton":"Annuler","confirmButton":"Supprimer"}}},"refundTransactionModal":{"title":"Solicitar un reembolso","message":"Para solicitar un reembolso, elija un motivo a continuacion:","reasons":{"AC03":"IBAN incorrecto","AM09":"Cantidad incorrecta","CUST":"Decisi\xf3n del cliente"},"confirmButton":"Confirmar","cancelButton":"Cancelar","success":"Su solicitud de reembolso ha sido enviada"},"upcomingTransfers":{"description":"Ver y administrar sus transferencias futuras","editTransfer":"Editar transferencia recurrente","loadMore":"Cargar m\xe1s","nextOn":"Pr\xf3ximo en","status":{"activated":"Activo","deactivated":"Pausado","expired":"Expirado","deleted":"Cancelado"},"deletePrompt":{"title":"\xbfEliminar pr\xf3xima transferencia?","message":"\xbfEst\xe1 seguro de que desea eliminar la pr\xf3xima transferencia {id} ?"},"confirmButton":"Confirmar","sourceAccount":"Cuenta de origen","scheduledAmount":"Monto programado","message":"Mensaje","startDate":"Fecha de inicio","frequency":"Frecuencia","endDate":"Fecha de finalizaci\xf3n"},"createSavingsAccount":{"title":"Abrir una cuenta de ahorros","selectAccount":"Seleccione el tipo de cuenta de ahorros","initialDeposit":"Dep\xf3sito inicial","accountToCollect":"Cuenta para cobrar","duration":"Duraci\xf3n","sendRequest":"Enviar solicitud","selectAccountTypeLabel":"Seleccione el tipo de cuenta a cobrar","selectAccountType":{"INTERNAL":"Interno","EXTERNAL":"Externo"},"creationSuccessMessage":"Su solicitud para abrir una cuenta de ahorros ha sido enviada exitosamente"},"gender":{"male":"Masculino","female":"Femenino","unknown":"Desconocido"},"mandates":{"description":"Ver y gestionar tus mandatos","status":{"all":"Todos los estados","active":"Activo","opposed":"Opuesto","consumed":"Consumido","revoked":"Revocado","creditorOpposed":"Opuesto por el acreedor","obsolete":"Obsoleto"},"details":{"to":"A","mandateDetails":"Detalles del mandato","reference":"Referencia","id":"ID","signatureDate":"Fecha de firma","creditorDetails":"Detalles del acreedor","creditorRef":"Referencia del acreedor","accountInformation":"Informaci\xf3n de la cuenta","accountIban":"IBAN de la cuenta","accountBic":"BIC de la cuenta"},"opposePrompt":{"title":{"first":"Oponerse","second":"al mandato"},"message":"\xbfRealmente deseas oponerte al mandato {reference} con {creditorName}?"},"activatePrompt":{"title":{"first":"Activar","second":"mandato"},"message":"\xbfRealmente deseas activar el mandato {reference} con {creditorName}?"},"confirmButton":"Confirmar"},"mandatesSubmenu":{"mandates":"Mandatos"}}');

});

parcelRegister("irJAx", function(module, exports) {
module.exports = JSON.parse('{"common":{"fileConstraints":{"formats":"\u0627\u0644\u0635\u064A\u063A \u0627\u0644\u0645\u0642\u0628\u0648\u0644\u0629","maxSize":"\u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u0623\u0642\u0635\u0649","tooBig":"\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u062E\u062A\u0627\u0631 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647.","wrongType":"\u0635\u064A\u063A\u0629 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u062E\u062A\u0627\u0631 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629.","openLabel":"\u0639\u0631\u0636 \u0627\u0644\u0645\u062A\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641"},"fileField":{"sentOn":"\u0623\u064F\u0631\u0633\u0644 \u0641\u064A {date}","sent":"\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F"},"today":"Aujourd\'hui","clear":"Effacer","yesterday":"Hier","goBack":"Retour","languages":{"fr_FR":"Fran\xe7ais (France)","en_US":"English (USA)","es_ES":"Espa\xf1ol (Espa\xf1a)","af_NA":"Afrikaans (Namibia)","af_ZA":"Afrikaans (South Africa)","ak_CI":"Akan (C\xf4te d\u2019Ivoire)","ak_GH":"Akan (Ghana)","gn_PY":"Ava\xf1e\'\u1EBD","ay_BO":"Aymar aru","az_AZ":"Az\u0259rbaycan dili","id_ID":"Bahasa Indonesia","ms_MY":"Bahasa Melayu","ms_BN":"Bahasa Melayu (Brunei)","ms_CC":"Bahasa Melayu (Cocos (Keeling) Islands)","ms_SG":"Bahasa Melayu (Singapore)","bm_BF":"Bamanakan (Burkina Faso)","bm_CI":"Bamanakan (C\xf4te d\u2019Ivoire)","bm_GM":"Bamanakan (Gambia)","bm_ML":"Bamanakan (Mali)","jv_ID":"Basa Jawa","bh_IN":"Bihari (India)","bs_BA":"Bosanski","br_FR":"Brezhoneg (France)","ca_ES":"Catal\xe0","ca_AD":"Catal\xe0 (Andorra)","ce_RU":"Chechen (Russia)","sn_BW":"ChiShona (Botswana)","sn_MZ":"ChiShona (Mozambique)","sn_ZW":"ChiShona (Zimbabwe)","ht_GA":"Cr\xe9ole haitien (Grandans)","ht_OU":"Cr\xe9ole haitien (Lw\xe8s)","ht_NI":"Cr\xe9ole haitien (Nip)","ht_ND":"Cr\xe9ole haitien (N\xf2)","ht_NO":"Cr\xe9ole haitien (N\xf2dw\xe8s)","ht_NE":"Cr\xe9ole haitien (N\xf2d\xe8s)","ht_CE":"Cr\xe9ole haitien (Sant)","ht_SD":"Cr\xe9ole haitien (Sid)","ht_SE":"Cr\xe9ole haitien (Sid\xe8s)","cy_GB":"Cymraeg","cy_AR":"Cymraeg (Argentina)","da_DK":"Dansk","da_FO":"Dansk (Faroe Islands)","da_DE":"Dansk (Germany)","da_GL":"Dansk (Greenland)","fa_AF":"Dari","se_NO":"Davvis\xe1megiella","de_BE":"Deutsch (Belgium)","de_DK":"Deutsch (Denmark)","de_DE":"Deutsch (Deutschland)","de_FR":"Deutsch (France)","de_HU":"Deutsch (Hungary)","de_IT":"Deutsch (Italy)","de_LI":"Deutsch (Liechtenstein)","de_LU":"Deutsch (Luxembourg)","de_PL":"Deutsch (Poland)","de_CH":"Deutsch (Schweiz)","de_AT":"Deutsch (\xd6sterreich)","dv_MV":"Divehi (Maldives)","dz_BT":"Dzongkha (Bhutan)","et_EE":"Eesti (Estonia)","en_AS":"English (American Samoa)","en_AI":"English (Anguilla)","en_AG":"English (Antigua & Barbuda)","en_AU":"English (Australia)","en_BS":"English (Bahamas)","en_BB":"English (Barbados)","en_BE":"English (Belgium)","en_BZ":"English (Belize)","en_BM":"English (Bermuda)","en_BW":"English (Botswana)","en_IO":"English (British Indian Ocean Territory)","en_VG":"English (British Virgin Islands)","en_BN":"English (Brunei)","en_CM":"English (Cameroon)","en_CA":"English (Canada)","en_KY":"English (Cayman Islands)","en_CK":"English (Cook Islands)","en_DM":"English (Dominica)","en_ER":"English (Eritrea)","en_ET":"English (Ethiopia)","en_FK":"English (Falkland Islands)","en_FJ":"English (Fiji)","en_GM":"English (Gambia)","en_GH":"English (Ghana)","en_GI":"English (Gibraltar)","en_GD":"English (Grenada)","en_GU":"English (Guam)","en_GY":"English (Guyana)","en_HK":"English (Hong Kong SAR China)","en_IN":"English (India)","en_IE":"English (Ireland)","en_IL":"English (Israel)","en_JM":"English (Jamaica)","en_KE":"English (Kenya)","en_KI":"English (Kiribati)","en_LS":"English (Lesotho)","en_LR":"English (Liberia)","en_MW":"English (Malawi)","en_MT":"English (Malta)","en_MH":"English (Marshall Islands)","en_MU":"English (Mauritius)","en_FM":"English (Micronesia)","en_MS":"English (Montserrat)","en_NA":"English (Namibia)","en_NR":"English (Nauru)","en_NZ":"English (New Zealand)","en_NG":"English (Nigeria)","en_NU":"English (Niue)","en_NF":"English (Norfolk Island)","en_MP":"English (Northern Mariana Islands)","en_PK":"English (Pakistan)","en_PW":"English (Palau)","en_PG":"English (Papua New Guinea)","en_PH":"English (Philippines)","en_PI":"English (Pirate)","en_PN":"English (Pitcairn Islands)","en_PR":"English (Puerto Rico)","en_RW":"English (Rwanda)","en_WS":"English (Samoa)","en_SC":"English (Seychelles)","en_SL":"English (Sierra Leone)","en_SG":"English (Singapore)","en_SB":"English (Solomon Islands)","en_SO":"English (Somalia)","en_ZA":"English (South Africa)","en_SH":"English (St. Helena)","en_KN":"English (St. Kitts & Nevis)","en_LC":"English (St. Lucia)","en_VC":"English (St. Vincent & Grenadines)","en_SZ":"English (Swaziland)","en_TK":"English (Tokelau)","en_TO":"English (Tonga)","en_TT":"English (Trinidad & Tobago)","en_TC":"English (Turks & Caicos Islands)","en_UM":"English (U.S. Outlying Islands)","en_VI":"English (U.S. Virgin Islands)","en_GB":"English (UK)","en_UG":"English (Uganda)","en_UD":"English (Upside Down)","en_VU":"English (Vanuatu)","en_ZM":"English (Zambia)","en_ZW":"English (Zimbabwe)","es_AR":"Espa\xf1ol (Argentine)","es_BO":"Espa\xf1ol (Bolivia)","es_CL":"Espa\xf1ol (Chile)","es_CO":"Espa\xf1ol (Colombia)","es_CR":"Espa\xf1ol (Costa Rica)","es_CU":"Espa\xf1ol (Cuba)","es_DO":"Espa\xf1ol (Dominican Republic)","es_EC":"Espa\xf1ol (Ecuador)","es_SV":"Espa\xf1ol (El Salvador)","es_GQ":"Espa\xf1ol (Equatorial Guinea)","es_US":"Espa\xf1ol (Estados Unidos)","es_GT":"Espa\xf1ol (Guatemala)","es_HN":"Espa\xf1ol (Honduras)","es_LA":"Espa\xf1ol (Latinoam\xe9rica)","es_MX":"Espa\xf1ol (M\xe9xico)","es_NI":"Espa\xf1ol (Nicaragua)","es_PA":"Espa\xf1ol (Panama)","es_PY":"Espa\xf1ol (Paraguay)","es_PE":"Espa\xf1ol (Peru)","es_PR":"Espa\xf1ol (Puerto Rico)","es_UY":"Espa\xf1ol (Uruguay)","es_VE":"Espa\xf1ol (Venezuela)","eo_EO":"Esperanto","eu_ES":"Euskara","ee_GH":"E\u028Begbe (Ghana)","ee_TG":"E\u028Begbe (Togo)","tl_PH":"Filipino","fr_AD":"Fran\xe7ais (Andorra)","fr_BE":"Fran\xe7ais (Belgique)","fr_BJ":"Fran\xe7ais (Benin)","fr_BF":"Fran\xe7ais (Burkina Faso)","fr_BI":"Fran\xe7ais (Burundi)","fr_CM":"Fran\xe7ais (Cameroon)","fr_CA":"Fran\xe7ais (Canada)","fr_CF":"Fran\xe7ais (Central African Republic)","fr_TD":"Fran\xe7ais (Chad)","fr_KM":"Fran\xe7ais (Comoros)","fr_CG":"Fran\xe7ais (Congo - Brazzaville)","fr_CD":"Fran\xe7ais (Congo - Kinshasa)","fr_CI":"Fran\xe7ais (C\xf4te d\u2019Ivoire)","fr_DJ":"Fran\xe7ais (Djibouti)","fr_GF":"Fran\xe7ais (French Guiana)","fr_PF":"Fran\xe7ais (French Polynesia)","fr_GA":"Fran\xe7ais (Gabon)","fr_GP":"Fran\xe7ais (Guadeloupe)","fr_GN":"Fran\xe7ais (Guinea)","fr_HT":"Fran\xe7ais (Haiti)","fr_IT":"Fran\xe7ais (Italy)","fr_LB":"Fran\xe7ais (Lebanon)","fr_LU":"Fran\xe7ais (Luxembourg)","fr_MG":"Fran\xe7ais (Madagascar)","fr_ML":"Fran\xe7ais (Mali)","fr_MQ":"Fran\xe7ais (Martinique)","fr_MR":"Fran\xe7ais (Mauritanie)","fr_YT":"Fran\xe7ais (Mayotte)","fr_MC":"Fran\xe7ais (Monaco)","fr_NC":"Fran\xe7ais (New Caledonia)","fr_NE":"Fran\xe7ais (Niger)","fr_RW":"Fran\xe7ais (Rwanda)","fr_RE":"Fran\xe7ais (R\xe9union)","fr_SC":"Fran\xe7ais (Seychelles)","fr_PM":"Fran\xe7ais (St. Pierre & Miquelon)","fr_CH":"Fran\xe7ais (Suisse)","fr_TG":"Fran\xe7ais (Togo)","fr_GB":"Fran\xe7ais (United Kingdom)","fr_VU":"Fran\xe7ais (Vanuatu)","fr_VA":"Fran\xe7ais (Vatican City)","fr_WF":"Fran\xe7ais (Wallis & Futuna)","fy_NL":"Frysk","fo_FO":"F\xf8royskt","ga_IE":"Gaeilge (Gaelic)","ga_GB":"Gaeilge (United Kingdom)","gv_GB":"Gaelg (United Kingdom)","gl_ES":"Galego","ha_BF":"Hausa (Burkina Faso)","ha_NE":"Hausa (Niger)","ha_NG":"Hausa (Nigeria)","ha_SD":"Hausa (Sudan)","ha_TG":"Hausa (Togo)","hr_HR":"Hrvatski","hr_BA":"Hrvatski (Bosnia & Herzegovina)","ig_NG":"Igbo (Nigeria)","rn_BI":"Ikirundi (Uburundi)","iu_CA":"Inuktitut (Canada)","nd_ZW":"IsiNdebele (Zimbabwe)","it_IT":"Italiano","it_HR":"Italiano (Croatia)","it_SM":"Italiano (San Marino)","it_SI":"Italiano (Slovenia)","it_CH":"Italiano (Switzerland)","it_VA":"Italiano (Vatican City)","jv_MY":"Javanese (Malaysia)","jv_SR":"Javanese (Suriname)","kl_GL":"Kalaallisut (Greenland)","ks_IN":"Kashmiri (India)","kw_GB":"Kernewek (United Kingdom)","kg_CG":"KiKongo (Congo Brazzaville)","kg_CD":"KiKongo (Congo Kinshasa RDC)","sw_KE":"Kiswahili","sw_TZ":"Kiswahili (Tanzania)","ku_IR":"Kurdish (Iran)","ku_IQ":"Kurdish (Iraq)","ku_TR":"Kurd\xee","ky_KG":"Kyrgyz (Kyrgyzstan)","lo_LA":"Lao (Laos)","ht_AR":"Latibonit","la_VA":"Latin","lv_LV":"Latvie\u0161u","to_TO":"Lea fakatonga (Tonga)","lt_LT":"Lietuvi\u0173","ln_CG":"Ling\xe1la (Congo - Brazzaville)","ln_CD":"Ling\xe1la (Congo - Kinshasa)","lg_UG":"Luganda (Uganda)","lb_DE":"Luxembourgish (Germany)","lb_LU":"Luxembourgish (Luxembourg)","li_NL":"L\xe8mb\xf6rgs","hu_HU":"Magyar","hu_AT":"Magyar (Austria)","hu_RO":"Magyar (Romania)","hu_SK":"Magyar (Slovakia)","hu_SI":"Magyar (Slovenia)","hu_UA":"Magyar (Ukraine)","mg_MG":"Malagasy","mt_MT":"Malti","ro_MD":"Moldavian","mo_MD":"Moldavian (Moldova)","nl_AW":"Nederlands (Aruba)","nl_BE":"Nederlands (Belgi\xeb)","nl_NL":"Nederlands (Nederland)","nl_SR":"Nederlands (Suriname)","nb_NO":"Norsk (bokm\xe5l)","nn_NO":"Norsk (nynorsk)","se_SE":"Northern Sami (Sweden)","no_NO":"Norwegian (Norway)","ny_MW":"Nyanja (Malawi)","uz_UZ":"O\'zbek","om_ET":"Oromoo (Ethiopia)","om_KE":"Oromoo (Kenya)","os_AZ":"Ossetic (Azerbaijan)","os_GE":"Ossetic (Georgia)","os_KZ":"Ossetic (Kazakhstan)","os_RU":"Ossetic (Russia)","os_TJ":"Ossetic (Tajikistan)","os_TM":"Ossetic (Turkmenistan)","os_UA":"Ossetic (Ukraine)","os_UZ":"Ossetic (Uzbekistan)","pl_PL":"Polski","pl_UA":"Polski (Ukraine)","pt_AO":"Portugu\xeas (Angola)","pt_BR":"Portugu\xeas (Brasil)","pt_CV":"Portugu\xeas (Cape Verde)","pt_GW":"Portugu\xeas (Guinea-Bissau)","pt_MZ":"Portugu\xeas (Mozambique)","pt_PT":"Portugu\xeas (Portugal)","pt_ST":"Portugu\xeas (S\xe3o Tom\xe9 & Pr\xedncipe)","pt_TL":"Portugu\xeas (Timor-Leste)","ff_MR":"Pulaar (Mauritania)","ff_NE":"Pulaar (Niger)","ff_NG":"Pulaar (Nigeria)","ff_SN":"Pulaar (Senegal)","qu_PE":"Qhichwa","ty_PF":"Reo Tahiti","ro_RO":"Rom\xe2n\u0103","ro_UA":"Rom\xe2n\u0103 (Ukraine)","rm_CH":"Rumantsch","gd_GB":"Scottish Gaelic (United Kingdom)","sq_AL":"Shqip","sk_HU":"Sloven\u010Dina (Hungary)","sk_SK":"Sloven\u010Dina (Slovakia)","sl_SI":"Sloven\u0161\u010Dina","so_DJ":"Soomaali (Djibouti)","so_ET":"Soomaali (Ethiopia)","so_KE":"Soomaali (Kenya)","so_SO":"Soomaaliga","nr_ZA":"South Ndebele (South Africa)","st_LS":"Southern Sotho (Lesotho)","fi_FI":"Suomi","fi_SE":"Suomi (Sweden)","sv_SE":"Svenska","sv_FI":"Svenska (Finland)","sv_AX":"Svenska (\xc5land Islands)","ss_ZA":"Swati (South Africa)","ss_SZ":"Swati (Swaziland)","sg_CF":"S\xe4ng\xf6 (Central African Republic)","vi_VN":"Ti\u1EBFng Vi\u1EC7t","ts_ZA":"Tsonga (South Africa)","tn_BW":"Tswana (Botswana)","tn_ZA":"Tswana (South Africa)","tk_TM":"Turkmen (Turkmenistan)","tr_TR":"T\xfcrk\xe7e","tr_BG":"T\xfcrk\xe7e (Bulgaria)","tr_CY":"T\xfcrk\xe7e (Cyprus)","tr_MD":"T\xfcrk\xe7e (Moldova)","ug_AF":"Uyghur (Afghanistan)","ug_KZ":"Uyghur (Kazakhstan)","ug_KG":"Uyghur (Kyrgyzstan)","ug_TJ":"Uyghur (Tajikistan)","ug_TR":"Uyghur (Turkey)","ug_UZ":"Uyghur (Uzbekistan)","ve_ZA":"Venda (South Africa)","ve_ZW":"Venda (Zimbabwe)","wa_BE":"Walloon (Belgium)","fy_DE":"Western Frisian (Germany)","wo_GM":"Wolof (Gambia)","wo_MR":"Wolof (Mauritania)","wo_SN":"Wolof (Senegal)","xh_LS":"Xhosa (Lesotho)","yi_AU":"Yiddish (Australia)","yi_BY":"Yiddish (Belarus)","yi_BE":"Yiddish (Belgium)","yi_CA":"Yiddish (Canada)","yi_EE":"Yiddish (Estonia)","yi_IL":"Yiddish (Israel)","yi_LV":"Yiddish (Latvia)","yi_LT":"Yiddish (Lithuania)","yi_MD":"Yiddish (Moldova)","yi_PL":"Yiddish (Poland)","yi_RO":"Yiddish (Romania)","yi_RU":"Yiddish (Russia)","yi_ZA":"Yiddish (South Africa)","yi_UA":"Yiddish (Ukraine)","yi_US":"Yiddish (United States)","en_UK":"en_UK","xh_ZA":"isiXhosa","zu_ZA":"isiZulu","yo_NG":"\xc8d\xe8 Yor\xf9b\xe1 (Nigeria)","is_IS":"\xcdslenska (Iceland)","cs_CZ":"\u010Ce\u0161tina","el_GR":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC","el_CY":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (Cyprus)","uz_AF":"\u040E\u0437\u0431\u0435\u043A (Afghanistan)","be_BY":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F","bg_BG":"\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438","mk_MK":"\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438)","mn_MN":"\u041C\u043E\u043D\u0433\u043E\u043B","ru_RU":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439","sr_BA":"\u0421\u0440\u043F\u0441\u043A\u0438 (Bosnia & Herzegovina)","sr_HU":"\u0421\u0440\u043F\u0441\u043A\u0438 (Hungary)","sr_RS":"\u0421\u0440\u043F\u0441\u043A\u0438 (Serbia)","uk_UA":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","ru_UA":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (Ukraine)","tt_RU":"\u0442\u0430\u0442\u0430\u0440\u0447\u0430","tg_TJ":"\u0442\u043E\u04B7\u0438\u043A\u04E3","uk_MD":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 (Moldova)","kk_KZ":"\u049A\u0430\u0437\u0430\u049B\u0448\u0430","hy_AM":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576","yi_DE":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9 (German)","he_IL":"\u05E2\u05D1\u05E8\u05D9\u05EA\u200F","ur_PK":"\u0627\u0631\u062F\u0648","ur_IN":"\u0627\u0631\u062F\u0648 (India)","ar_DZ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Algeria)","ar_AR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Argentina)","ar_BH":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Bahrain)","ar_TD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Chad)","ar_EG":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Egypt)","ar_IN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (India)","ar_IQ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Iraq)","ar_IL":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Israel)","ar_JO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Jordan)","ar_KW":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Kuwait)","ar_LB":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Lebanon)","ar_LY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Libya)","ar_MR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Mauritania)","ar_MA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Morocco)","ar_OM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Oman)","ar_PS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Palestinian Territories)","ar_QA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Qatar)","ar_SO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Somalia)","ar_SD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Sudan)","ar_SY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Syria)","ar_TN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Tunisia)","ar_AE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (United Arab Emirates)","ar_YE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (Yemen)","ar_SA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)","fa_IR":"\u0641\u0627\u0631\u0633\u06CC","ps_AF":"\u067E\u069A\u062A\u0648","ne_NP":"\u0928\u0947\u092A\u093E\u0932\u0940","ne_BT":"\u0928\u0947\u092A\u093E\u0932\u0940 (Bhutan)","ne_IN":"\u0928\u0947\u092A\u093E\u0932\u0940 (India)","mr_IN":"\u092E\u0930\u093E\u0920\u0940","sa_IN":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D","hi_IN":"\u0939\u093F\u0928\u094D\u0926\u0940","as_IN":"\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE (India)","bn_SG":"\u09AC\u09BE\u0982\u09B2\u09BE (Singapore)","bn_IN":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AD\u09BE\u09B0\u09A4)","bn_BD":"\u09AC\u09BE\u0982\u09B2\u09BE(\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)","pa_IN":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 (\u0A2D\u0A3E\u0A30\u0A24 \u0A28\u0A42\u0A70)","gu_IN":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0","or_IN":"\u0B13\u0B21\u0B3C\u0B3F\u0B06","ta_IN":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD","ta_SG":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (Singapore)","te_IN":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41","kn_IN":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1 (India)","ml_IN":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02","si_LK":"\u0DB4\u0DC5\u0DCF\u0DAD","si_TH":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD (Thailand)","th_TH":"\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22 (\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22)","bo_CN":"\u0F54\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0B (China)","my_MM":"\u1017\u1019\u102C (Myanmar (Burma))","ka_GE":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8","ti_ER":"\u1275\u130D\u122D\u129B (Eritrea)","ti_ET":"\u1275\u130D\u122D\u129B (Ethiopia)","am_ET":"\u12A0\u121B\u122D\u129B (Ethiopia)","ck_US":"\u13E3\u13B3\u13A9 (tsalagi)","km_KH":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","gx_GR":"\u1F19\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u1F00\u03C1\u03C7\u03B1\u03AF\u03B1","zh_MO":"\u4E2D\u6587 (Macau SAR China)","zh_CN":"\u4E2D\u6587\uFF08\u4E2D\u56FD\uFF09","zh_TW":"\u4E2D\u6587\uFF08\u53F0\u7063\uFF09","zh_SG":"\u4E2D\u6587\uFF08\u65B0\u52A0\u5761\uFF09","zh_HK":"\u4E2D\u6587\uFF08\u9999\u6E2F\uFF09","ja_JP":"\u65E5\u672C\u8A9E","ii_CN":"\uA188\uA320\uA259 (China)","ko_KP":"\uD55C\uAD6D\uC5B4 (North Korea)","ko_KR":"\uD55C\uAD6D\uC5B4 (\u97E9\u56FD)"},"autocompletePicker":{"placeholder":"S\xe9lectionner...","searchPlaceholder":"\xc9crire au moins 3 caract\xe8res pour rechercher...","noResults":"Aucun r\xe9sultat pour cette recherche"},"invalidPhoneNumber":"Le num\xe9ro de t\xe9l\xe9phone est invalide","yes":"Oui","no":"Non","cancel":"Annuler","validate":"Valider"},"authScreen":{"welcome":"Bienvenue sur votre portail bancaire","headline":"Mon wallet 100% simple et s\xe9curis\xe9","headlineDescription":"G\xe9rez vos d\xe9penses professionnelles, qualifiez vos transactions et importez vos justificatifs en un clin d\'\u0153il.","subtitle":"Connectez-vous pour acc\xe9der \xe0 votre espace pro","languages":"Langues","login":"Connexion","createAccount":"Ouvrir un compte","appstoreLink":"Appstore","playstoreLink":"Playstore","goToCompanyPortalQuestion":"Vous \xeates une entreprise ?","goToCompanyPortalLink":"Espace entreprises","goToPartnersPortalQuestion":"Vous \xeates un commer\xe7ant ?","goToPartnersPortalLink":"Espace commer\xe7ants","goToAgentPortalQuestion":"Vous \xeates un agent ?","goToAgentPortalLink":"Espace agents","storesAvailable":"Disponible aussi sur","disconnectedDueToInactivity":"Vous avez \xe9t\xe9 d\xe9connect\xe9 suite \xe0 une inactivit\xe9 prolong\xe9e","authenticationFailure":{"title":"\xc9chec de l\'authentification"}},"connectScreen":{"title":"Bienvenue sur [emph]Skaleet[/emph]","subtitle":"Veuillez entrer votre num\xe9ro de t\xe9l\xe9phone pour vous connecter","lostPhoneButton":"Num\xe9ro de t\xe9l\xe9phone oubli\xe9 ?","connectButton":"Se connecter","registerQuestion":"Vous n\'avez pas de compte ?","registerButton":"Cr\xe9er un compte","errorTitle":"Une erreur est survenue","noAccountError":"Nous n\'avons pu trouver de compte pour le {phoneNumber}. Vous pouvez cr\xe9er un compte pour vous connecter.","pincodeTitle":"Code [emph]secret[/emph]","otpTitle":"V\xe9rification en [emph]deux \xe9tapes[/emph]","noCodeQuestion":"Code non re\xe7u ?","contactSupportLink":"Veuillez contacter le support.","contactSupport":{"title":"Vous n\'avez plus [emph]acc\xe8s au t\xe9l\xe9phone[/emph] rattach\xe9 \xe0 votre compte ?","message":"Pour modifier vos coordonn\xe9es, veuillez prendre contact avec notre \xe9quipe support qui vous indiquera la marche \xe0 suivre.","byPhone":"Nous contacter par t\xe9l\xe9phone","byEmail":"Nous contacter par email","done":"Terminer"}},"errorScreen":{"subTitle":"Trop de demandes","title":"La tentative de connexion a \xe9chou\xe9","message":"Nous ne pouvons pas traiter votre demande de connexion pour le moment.\\n\\n Veuillez r\xe9essayer plus tard.","button":"Revenir \xe0 la page de connexion"},"onboardingStatusCard":{"title":"Plus d\'informations sont n\xe9cessaires concernant votre dossier d\'inscription","subtitle":"Lorem ipsum dolor sit amet","button":"Compl\xe9ter mon dossier"},"onboardingDelegateErrorStatusCard":{"title":"Impossible d\u2019acc\xe9der au formulaire d\u2019inscription en tant qu\u2019utilisateur d\xe9l\xe9gu\xe9. Les fonctionnalit\xe9s disponibles sont limit\xe9es. Le propri\xe9taire du compte doit compl\xe9ter son inscription."},"onboardingScreen":{"progressLabel":"\xc9tape {step} sur {count} : {label}","initialStepTitle":"Bienvenue sur [emph]MWallet.[/emph]","resumptionStepTitle":"Dites nous en plus sur [emph]vous[/emph]","successIntroduction":"F\xe9licitations","successTitle":"Votre inscription est finalis\xe9e","successButton":"Commencer !","initiationSuccessTitle":"Votre inscription a \xe9t\xe9 initi\xe9e avec succ\xe8s.","initiationSuccessButton":"Se connecter","initiationSuccessMsg":"Un code secret a \xe9t\xe9 envoy\xe9 \xe0 {phone}","getStartedButton":"Commencer","cancelButton":"Annuler","back":"Pr\xe9c\xe9dent","next":"Suivant","save":"Enregistrer","submit":"Soumettre","taxedNumberError":{"undefined":"Erreur : Veuillez saisir un num\xe9ro de t\xe9l\xe9phone valide.","PREMIUM_RATE":"Erreur: Les num\xe9ros \xe0 tarif major\xe9 ne peuvent pas \xeatre utilis\xe9s pour l\u2019enregistrement d\u2019un compte. Veuillez fournir un num\xe9ro de t\xe9l\xe9phone mobile ou fixe.","TOLL_FREE":"Erreur: Les num\xe9ros gratuits ne sont pas pris en charge pour la v\xe9rification du compte. Veuillez utiliser un num\xe9ro de t\xe9l\xe9phone mobile ou fixe standard.","SHARED_COST":"Erreur: Les num\xe9ros avec facturation \xe0 frais partag\xe9s ne sont pas autoris\xe9s pour la cr\xe9ation de compte. Veuillez saisir un num\xe9ro de mobile ou de ligne fixe.","VOIP":"Erreur: Les num\xe9ros de t\xe9l\xe9phone Internet ne sont pas \xe9ligibles \xe0 l\u2019enregistrement. Veuillez utiliser un num\xe9ro de t\xe9l\xe9phone mobile ou fixe standard.","PERSONAL_NUMBER":"Erreur: Les num\xe9ros personnels connect\xe9s par satellite ne sont pas accept\xe9s. Veuillez utiliser un num\xe9ro de t\xe9l\xe9phone mobile ou fixe.","PAGER":"Erreur: Les appareils de t\xe9l\xe9avertisseur ne sont pas valides pour la cr\xe9ation de compte. Veuillez fournir un num\xe9ro de t\xe9l\xe9phone mobile ou fixe accept\xe9.","UAN":"Erreur : Les num\xe9ros d\'acc\xe8s universels (UAN) ne peuvent pas \xeatre utilis\xe9s pour l\'enregistrement. Veuillez saisir un num\xe9ro de t\xe9l\xe9phone mobile ou fixe valide.","VOICEMAIL":"Erreur : Les num\xe9ros d\xe9di\xe9s aux services de messagerie vocale ne peuvent pas \xeatre utilis\xe9s. Veuillez saisir un num\xe9ro de mobile ou de t\xe9l\xe9phone fixe pouvant recevoir directement des appels."},"formLabels":{"selectDistributorDuringOnboarding":"Code de distributeur d\'int\xe9gration","selectDistributorDuringOnboardingHelperText":"Veuillez renseigner l\u2019ID fourni par votre r\xe9f\xe9rent carte.","firstName":"Pr\xe9nom","lastName":"Nom","phoneNumber":"T\xe9l\xe9phone","email":"Email"}},"registerScreen":{"progressLabel":"\xc9tape {step} sur {count} : {label}","progressStepLabel":"\xc9tape {step} sur {count}","progressBackLink":"Retour","firstStepTitle":"Bienvenue !","firstStepSubtitle":"Veuillez entrer votre num\xe9ro de t\xe9l\xe9phone pour vous inscrire","connectQuestion":"Vous poss\xe9dez d\xe9j\xe0 un compte ?","connectButton":"Se connecter","phoneNumberLabel":"Num\xe9ro de t\xe9l\xe9phone","back":"Pr\xe9c\xe9dent","next":"Suivant","finish":"Terminer","otpTitle":"Verification du t\xe9l\xe9phone","otpLabel":"Veuillez entrer le code re\xe7u par SMS","nbPicturesForDocument":{"one":"une photo minimum","others":"{count} photos minimum"},"pictureInputFilled":"Un fichier","pictureInputEmpty":"Choisir ou d\xe9poser une photo","addPictureButton":"Ajouter une page","eulaTitle":"Conditions d\'utilisations","eulaFirstDescription":"Veuillez accepter les conditions d\'utilisation afin de vous cr\xe9er un compte.","eulaSecondDescription":"Vous les trouverez en cliquant sur le lien suivant :","eulaLink":"Conditions d\'utilisations","eulaAcceptLabel":"J\'accepte les conditions d\'utilisations","createMyAccountButton":"Cr\xe9er mon compte","finishTitleLabel":"F\xe9licitations !","finishLabel":"Votre compte a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s.","pincodeLabel":"Votre code secret","pincodeStepTitle":"Votre code [emph]secret.[/emph]","quitConfirmMessage":"Vous \xeates sur le point de quitter l\'inscription. Toutes les donn\xe9es remplis seront perdus. \xcates vous sur de vouloir quitter la page ?","cancel":"Annuler","message":"Vous devez d\xe9sormais choisir un code secret \xe0 quatre chiffres pour votre compte. Surtout, ne le communiquez \xe0 personne, il est strictement confidentiel.","doNotForgetWarning":"Attention, veillez \xe0 bien le conserver : vous en aurez besoin pour vous authentifier et valider toutes vos op\xe9rations. ","successSnackbar":"Votre code secret a bien \xe9t\xe9 valid\xe9","newCodeLabel":"Entrez votre nouveau code","newCodeConfirmationLabel":"Confirmez votre nouveau code","newCodesDontMatchError":"Les codes entr\xe9s ne correspondent pas","noEulaTitle":"Confirmation de la cr\xe9ation de compte","noEulaFirstDescription":"Vous y \xeates presque !","noEulaSecondDescription":"En cliquant sur le bouton ci-dessous, la cr\xe9ation de votre compte sera effective. On y va ?","privacyFirstDescription":"Veuillez accepter la politique de confidentialit\xe9 afin de vous cr\xe9er un compte.","privacySecondDescription":"Vous la trouverez en cliquant sur le lien suivant :","privacyLink":"Politique de confidentialit\xe9","privacyAcceptLabel":"J\'accepte la politique de confidentialit\xe9","noPrivacyTitle":"Confirmation de la cr\xe9ation de compte","noPrivacyFirstDescription":"Vous y \xeates presque !","noPrivacySecondDescription":"En cliquant sur le bouton suivant, la cr\xe9ation de votre compte sera effective. On y va ?"},"accountOwner":{"male":"M. {name}","female":"Mme {name}","other":"{name}","none":"{name}"},"connectedUserGreetings":{"withName":"Bonjour, \\n[emph]{name}[/emph]\xa0!","hello":"Bonjour,","withoutName":"Bonjour\xa0!"},"clientStatus":{"clientBlockedMessage":"Votre compte est bloqu\xe9.","clientBlockedLink":"Plus d\'informations...","clientPendingMessage":"Votre dossier est en cours de traitement.","accountUnderReview":"Compte en cours de validation : La v\xe9rification de votre dossier peut prendre jusqu\'\xe0 quelques jours."},"profileMenu":{"title":"Profil et param\xe8tres","subtitle":"Retrouvez ici l\'ensemble de vos informations de compte","generalSection":"R\xe9glages g\xe9n\xe9raux","profileTitle":"Mon profil","profileSubtitle":"G\xe9rez votre compte et vos informations","settingsTitle":"Param\xe8tres","settingsSubtitle":"G\xe9rez vos param\xe8tres personnels"},"navigationMenu":{"accountLink":"Accueil","profileLink":"Profil et param\xe8tres","transferLink":"Transferts","payBillLink":"Services","cardsLink":"Ma Carte","savingsLink":"\xc9pargne","loansLink":"Pr\xeats","settingsLink":"Voir mon profil","contactLink":"Aide et assistance","disconnectButton":"Se d\xe9connecter","mandatesLink":"Mandates"},"transfertsSubmenu":{"allTransfer":"Effectuer un virement","externalAccount":"Compte externe","recipients":"B\xe9n\xe9ficiaires","cashTransfer":"Transferts en attente","upcomingTransfers":"Virements permanents","recharge":"Recharger mon compte","transactionCode":"Code de transaction","simpleTransfer":"Par num\xe9ro de t\xe9l\xe9phone"},"savingsSubmenu":{"mySavingsAccount":"Mes comptes d\'\xe9pargne","deposits":"Virements et d\xe9p\xf4ts"},"simpleTransfer":{"newTransfer":"Nouveau transfert","title":"Par num\xe9ro de t\xe9l\xe9phone","searchRecipient":"Rechercher un destinataire","invalidPhoneNumber":"Le num\xe9ro de t\xe9l\xe9phone fourni n\'est pas reconnu"},"accountPendingVerification":{"title":"V\xe9rification de compte","subtitle":"Votre demande de cr\xe9ation de compte est en train d\'\xeatre \xe9tudi\xe9e. Veuillez r\xe9essayer ult\xe9rieurement.","retryButton":"R\xe9essayer"},"accountsList":{"title":"Mes comptes.","loadAccountsError":"Une erreur est survenue lors du chargement des comptes.","loadAccountsRetry":"R\xe9essayer","showAllAccountsLink":"Voir tous mes comptes","noAccountAvailable":"Aucun compte n\'est disponible"},"recipient":{"title":"Effectuer un virement","subtitle":"\xc0 qui voulez-vous transf\xe9rer votre argent ?","section":"Mes b\xe9n\xe9ficiaires","noRecipientsAvailable":"Aucun destinataire n\'est disponible","noRecipientsMessage":"Ajoutez des b\xe9n\xe9ficiaires pour transferer de l\u2019argent.","addRecipientButton":"Ajouter un b\xe9n\xe9ficiaire","transferTo":"Transfert vers {name}","searchInputPlaceholder":"Rechercher un b\xe9n\xe9ficiaire","selector":{"beneficiaries":"B\xe9n\xe9ficiaires","externalAccounts":"Comptes externes"},"deletePrompt":{"title":"Supprimer un b\xe9n\xe9ficiaire","message":"Voulez-vous vraiment supprimer le destinataire {name} ?","recipient":"un b\xe9n\xe9ficiaire","externalAccountTitle":"Supprimer un compte externe","externalAccountMessage":"\xcates-vous s\xfbr de vouloir supprimer ce compte externe ?","cancelButton":"Annuler","confirmButton":"OK"},"externalAccounts":{"title":"Mes comptes externes","addButton":"Ajouter un compte externe","noneAvailableTitle":"Aucun compte externe actuellement","noneAvailableMessage":"Ajoutez un compte bancaire externe pour transferer de l\u2019argent.","pendingExternalAccountMessage":"Votre compte externe est en cours de validation."}},"addRecipient":{"selector":{"iban":"IBAN","phone":"T\xe9l\xe9phone","account":"N\xb0 compte / BIC"},"unauthorized":"Vous n\'\xeates pas autoris\xe9 \xe0 acc\xe8der \xe0 cette fonctionnalit\xe9","title":"Ajouter","subtitle":"un b\xe9n\xe9ficiaire","externalAccountSubtitle":"un compte externe","nameFieldPlaceholder":"Nom","phoneFieldPlaceholder":"Num\xe9ro de t\xe9l\xe9phone","ibanFieldPlaceholder":"IBAN","accountFieldPlaceholder":"Num\xe9ro de compte","bicFieldPlaceholder":"BIC","bankFieldPlaceholder":"Banque / BIC","createButton":"Ajouter","otpAdditionalText":"Ajout du b\xe9n\xe9ficiaire {name}","otpAdditionalTextWithBank":"Ajout du b\xe9n\xe9ficiaire {name} de la banque {bankName}","addConfirmationMessage":"Le b\xe9n\xe9ficiaire {name} a bien \xe9t\xe9 ajout\xe9","searchBank":{"title":"Banque / BIC","bankPlaceholder":"Tapez au moins {num} lettres pour rechercher","firstSearchMessage":"Faites une premi\xe8re recherche pour obtenir des r\xe9sultats","noBankMessage":"Pas de banque correspondante trouv\xe9e","errorMessage":"Une erreur est survenue lors du chargement de la liste des banques.","retryButton":"R\xe9essayer"}},"editRecipient":{"title":"Modifier","subtitle":"un destinataire","externalAccountSubtitle":"le compte externe","saveButton":"Enregistrer"},"account":{"accountId":"N\xb0{id}","accountType":{"current":"Compte courant","savings":"Compte \xe9pargne","dedicated":"Compte d\xe9di\xe9","moneyPot":"Cagnotte","technical":"Compte technique"},"detail":"D\xe9tails"},"accountStatus":{"opened":"Ouvert","closed":"Clos","blocked":"Bloqu\xe9","debitBlocked":"D\xe9bit interdit","creditBlocked":"Cr\xe9dit interdit"},"homeScreen":{"accountBalance":"Solde du compte","monthlyFluxTitle":"Flux de {month}","monthlyFluxIncome":"Mes recettes","monthlyFluxExpense":"Mes d\xe9penses","allTransactionsLink":"Toutes mes transactions","latestTransactionsTitle":"Mes derni\xe8res transactions","requiredActionsTitle":"Actions requises","requiredActionsSeeAll":"Voir tout","transactionsToJustify":"D\xe9penses \xe0 justifier","transactionsToQualify":"D\xe9penses \xe0 qualifier"},"allTransactions":{"title":"Historique des op\xe9rations","subtitle":"Consultez l\'ensemble de vos op\xe9rations et menez les actions n\xe9cessaires"},"accountTransactions":{"title":"Mes transactions.","tagJustified":"Justifi\xe9e","tagNotJustified":"Non justifi\xe9e","tagQualified":"Qualifi\xe9e","tagNotQualified":"Non qualifi\xe9e","emptyTransactionList":"Aucune transaction pour l\'instant","loadTransactionsError":"Une erreur est survenue lors du chargement des transactions.","loadMoreTransactionsError":"Une erreur est survenue lors du chargement des transactions.","loadMoreTransactionsRetry":"R\xe9essayer","unjustifiedTransactions":{"title":{"one":"Vous avez {count} transaction en attente de justificatif","other":"Vous avez {count} transactions en attente de justificatif","more":"Vous avez {count} transactions ou plus en attente de justificatif"},"description":"Certaines de vos transactions attendent des documents de justification."},"unjustifiedTransactions2":{"title":{"one":"Vous avez {count} transaction en attente de justificatif","other":"Vous avez {count} transactions en attente de justificatif","more":"Vous avez {count} transactions en attente de justificatif"},"description":"Certaines de vos transactions attendent des documents de justification."},"unqualifiedTransactions":{"title":{"one":"Vous avez {count} transaction en attente de qualification","other":"Vous avez {count} transactions en attente de qualification","more":"Vous avez {count} transactions en attente de qualification"},"description":"Certaines de vos transactions attendent une qualification."},"authorizationHolds":{"title":{"one":"Vous avez {count} transaction en attente","other":"Vous avez {count} transactions en attente","more":"Vous avez {count} transactions en attente"},"description":"L\'argent a \xe9t\xe9 d\xe9bit\xe9 de votre compte mais n\'est pas encore re\xe7u par le b\xe9n\xe9ficiaire."},"previousPeriodButtonLabel":"P\xe9riode pr\xe9c\xe9dente","nextPeriodButtonLabel":"P\xe9riode suivante"},"authorizationHolds":{"cashoutLabel":"Retrait","paymentLabel":"Paiement","externalToAccountLabel":"Syst\xe8me externe vers compte","accountToExternalLabel":"Compte vers syst\xe8me externe","externalFromAccountLabel":"Syst\xe8me externe depuis compte","accountRechargeLabel":"Rechargement compte","onUsCreditTransferLabel":"Virement on-us","managementFeesLabel":"Frais de gestion"},"accountingTransactionDetailsModal":{"detailsTitle":"D\xe9tails","transferLabel":"Transfert","description":"Description : {description}","transaction":"Transaction n\xb0{id}","reference":"R\xe9f\xe9rence : {id}","feeLabel":"Frais","commissionLabel":"Commission","taxLabel":"Taxes","discountLabel":"R\xe9duction","interestLabel":"Int\xe9r\xeats","amountLabel":"Total","balanceLabel":"Solde apr\xe8s transaction","additionalInformationTitle":"Informations additionnelles","geolocationTitle":"Localisation","externalIdLabel":"R\xe9f\xe9rence de transaction du partenaire : {externalId}","justifyButtonLabel":"Justifier ma d\xe9pense","refundButtonLabel":"Demander un remboursement","verifyJustificationsButtonLabel":"V\xe9rifier mes justificatifs","justificationFollowUpTitle":"Suivi de justification","documentsSubmitted":"Justificatifs d\xe9pos\xe9s","validationInProgress":"En attente de validation"},"authorizationHoldsDetailsModal":{"pending":"En attente","detailsTitle":"D\xe9tails","transferLabel":"Transfert","reference":"Transaction n\xb0{id}","amountLabel":"Total"},"allAccountsScreen":{"goBackClassicViewButton":"Retour sur la vue classique","noAccountAvailable":"Aucun compte n\'est disponible"},"recipientDetail":{"information":"Informations.","accountDetail":"RIB/Domiciliation.","transferMoneyButton":"Envoyer de l\'argent","dedicatedTransferButton":"Transaction cadeau"},"amountSelection":{"amountLabel":"Montant","currencyLabel":"Devise :","descriptionLabel":"Description :","descriptionButton":"Ajouter une description","descriptionPlaceholder":"Ajouter un message","simpleTransferNameLabel":"Nom","simpleTransferNamePlaceholder":"Ajouter un nom","simpleTransferPhoneLabel":"T\xe9l\xe9phone :","simpleTransferPhonePlaceholder":"Ajouter un t\xe9l\xe9phone","sendButton":"Suivant","since":"Depuis","to":"Vers","choose_source_account":"S\xe9lectionnez le compte \xe0 d\xe9biter","choose_destination_account":"S\xe9lectionnez le compte \xe0 cr\xe9diter","my_accounts":"Mes comptes","my_external_account":"Compte externe","my_recipients":"Mes b\xe9n\xe9ficiaires","network":"R\xe9seau interbancaire","load_more":"Charger plus","convertedAmountLabel":"Montant converti","creditorAddress":{"addressLabel":"Adresse","countryLabel":"Pays","buildingNumber":"N\xb0","streetName":"Rue","postCode":"Code postal","townName":"Ville","country":"Pays"},"insufficient_balance":"Le compte s\xe9lectionn\xe9 n\'a pas un solde suffisant pour effectuer cette op\xe9ration"},"acceptorSelection":{"title":"S\xe9lection d\'un commer\xe7ant","selectionButton":"S\xe9lectionner"},"dedicatedTransferAmount":{"title":"Montant du cadeau","subtitle":"Point de transaction : {code}"},"dedicatedTransferSummary":{"recepient":"B\xe9n\xe9ficiaire","account":"Compte d\xe9bit\xe9","amount":"Montant maximum","transactionPoint":"Point de transaction","expirationDate":"Date d\u2019expiration","done":"Terminer"},"pincodeConfirmation":{"label":"Entrez votre code secret pour continuer","networkError":"Veuillez v\xe9rifier votre connexion internet avant de poursuivre","loadKeyboardError":"Une erreur est survenue lors du chargement du clavier.","loadKeyboardRetry":"Recharger le clavier"},"transferSummary":{"accountTransferMode":"Vers compte","cashTransferMode":"Vers cash","summaryTitle":"Succ\xe8s","accountSummarySubtitle":"D\xe9tails du transfert","cashSummarySubtitle":"Vous allez recevoir un message contenant un code \xe0 remettre \xe0 {recipient} ou consulter vos transferts en attente pour r\xe9cup\xe9rer le code.","summaryMiddleStep":"Transfert","fees":"Frais : {amount}","commission":"Commission : {amount}","discount":"R\xe9duction : {amount}","tax":"Taxe : {amount}","you":"Vous","done":"Terminer","customerInstructionSuccessMessage":"Votre transfert N\xb0{id} vers {recipient} a bien \xe9t\xe9 effectu\xe9.","recurringTransferSuccessMessage":"Le virement r\xe9current N\xb0{id} \xe0 destination de {recipient} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s."},"billFormScreen":{"nextButton":"Suivant","textInputPlaceholder":"\xc9crivez quelque chose\u2026","saveReferencePromptTitle":"Sauvegarder le {name}","replaceReferencePromptTitle":"Remplacer le {name}","saveReferencePromptMessage":"Voulez-vous sauvegarder le {name} pour ce facturier ?","replaceReferencePromptMessage":"Voulez-vous remplacer le {name} pour ce facturier ?","saveReferencePromptCancel":"Annuler","saveReferencePromptConfirm":"Sauvegarder","replaceReferencePromptConfirm":"Remplacer","saveReferenceErrorMessage":"Le {name} n\'a pas pu \xeatre enregistr\xe9","docInputFilled":"Un fichier","docInputEmpty":"Ajouter ou d\xe9poser une photo ici","confirmationMessage":"Cliquez ci-dessous pour confirmer votre paiement de [b]{amount} [/b] \xe0 [b]{issuer}[/b]","confirmButton":"Confirmer"},"billConfirmationScreen":{"fees":"Frais : [b]{amount}[/b]","commission":"Commission : [b]{amount}[/b]","discount":"R\xe9duction : [b]{amount}[/b]","tax":"Taxe : [b]{amount}[/b]"},"formError":{"invalidIBAN":"L\'IBAN saisi est invalide","invalidFileSize":"Votre fichier d\xe9passe la taille maximale accept\xe9e ({size})","invalidFileFormat":"Le format de votre fichier n\'est pas support\xe9. Formats accept\xe9s : {formats}"},"billIssuersScreen":{"title":"Mes services.","references":"Mes r\xe9f\xe9rences","searchInputPlaceholder":"Rechercher un partenaire","emptyListLabel":"Aucun partenaire disponible","loadBillIssuersError":"Une erreur est survenue lors du chargement des partenaires."},"billReferencesScreen":{"title":"Mes r\xe9f\xe9rences","services":"Retour \xe0 mes services","subtitle":"Donn\xe9es sauvegard\xe9es pour vos paiements","emptyRecipientList":"Aucune r\xe9f\xe9rence enregistr\xe9e","deletePromptTitle":"Suppression de r\xe9f\xe9rence","deletePromptMessage":"Voulez-vous vraiment supprimer la r\xe9f\xe9rence {name} ?","deletePromptCancel":"Annuler","deletePromptConfirm":"Confirmer","deleteConfirmationMessage":"La r\xe9f\xe9rence {name} a bien \xe9t\xe9 supprim\xe9e","deleteErrorMessage":"La suppression de la r\xe9f\xe9rence {name} a \xe9chou\xe9","loadBillReferencesError":"Une erreur est survenue lors du chargement des r\xe9f\xe9rences.","lastUpdateDateTime":"Derni\xe8re mise \xe0 jour : {date} \xe0 {time}"},"otp":{"explanation":"Entrer le code \xe0 six chiffres que vous avez re\xe7u au:","sendBackCodeButton":"Renvoyer le code","backToRecipients":"Retour","confirmOtpButton":"Confirmer","goToTransferFormButton":"Acc\xe9der au formulaire de transfert","otpBlockedErrorMessage":"Vous avez effectu\xe9 3 tentatives incorrectes. Veuillez recommencer l\'op\xe9ration depuis le d\xe9but"},"myAccountScreen":{"title":"Mon compte","subtitle":"Retrouvez toutes les informations et les d\xe9tails de votre compte personnel","coordinatesTitle":"Coordonn\xe9es de votre compte","quickActionsTitle":"Actions rapides","downloadRib":"T\xe9l\xe9charger mon RIB","shareDetails":"Partager mes coordonn\xe9es","manageBeneficiaries":"G\xe9rer les b\xe9n\xe9ficiaires","manageBeneficiariesSubtitle":"Ajoutez ou supprimez vos b\xe9n\xe9ficiaires bancaires","accountStatement":"Relev\xe9 de compte","accountStatementSubtitle":"Consultez le d\xe9tail de vos op\xe9rations bancaires","feesStatement":"Relev\xe9 de frais","feesStatementSubtitle":"Consultez le d\xe9tail de vos frais bancaires","accountStatementPageSubtitle":"Retrouvez et t\xe9l\xe9chargez l\'ensemble de vos relev\xe9s de compte par p\xe9riode.","feesStatementPageSubtitle":"Retrouvez et t\xe9l\xe9chargez l\'ensemble de vos relev\xe9s de frais par p\xe9riode.","allYears":"Ann\xe9es"},"accountDetails":{"availableBalanceTitle":"Solde disponible","balanceTitle":"Solde comptable","balanceMessage":"Le solde comptable ne prend pas en compte les op\xe9rations en attente.","accountStatus":{"blocked":"Ce compte est bloqu\xe9. Pour plus d\u2019information veuillez contacter notre support.","debitBlocked":"Les d\xe9bits sont actuellement interdits sur ce compte. Pour plus d\u2019informations veuillez contacter notre support.","creditBlocked":"Les cr\xe9dits sont actuellement interdits sur ce compte. Pour plus d\u2019informations veuillez contacter notre support."},"accountName":"Nom du compte","accountIdTitle":"Num\xe9ro de compte","ibanTitle":"IBAN","bicTitle":"BIC","authorizedOverdraftTitle":"D\xe9couvert autoris\xe9","reachedOverdraftMessage":"Vous avez atteint votre d\xe9couvert autoris\xe9.","validityDate":"Jusqu\u2019au {date}","accessStatements":"Mes relev\xe9s de compte","shareRIBLabel":"Partager mon RIB","shareRIBMessage":"{firstName} {lastName} {postName}\\nIBAN : {iban}\\nBIC : {bic}","dedicatedMessage":"Vous pouvez d\xe9penser cette somme chez :","clipboard":"{name} copi\xe9","downloadBankDetails":"Coordonn\xe9es bancaires","accountStartDate":"Date d\'ouverture du compte","maximumBoundaries":"Solde maximum","initialAmountLabel":"Solde initial","endDateLabel":"Date de fin","durationLabel":"Dur\xe9e","monthsLabels":{"DAILY":"jours","WEEKLY":"semaines","MONTHLY":"mois","QUARTERLY":"trimestres","SEMESTER":"semestres","ANNUALLY":"ans"},"rateValueLabel":"Taux appliqu\xe9","indexCodeLabel":"Index","rateStartDateLabel":"Date de d\xe9but du taux","accruedInterestsLabel":"Int\xe9r\xeats acquis","startDateLabel":"Acquis depuis le","forecastInterestsLabel":"Inter\xeat total projet\xe9","initialAERLabel":"TRAAB","success":"Modification enregistr\xe9e"},"statementsFilters":{"allAgencies":"Toutes les agences","allYears":"Toutes les ann\xe9es","years":"Ann\xe9es"},"accountsStatements":{"title":"Relev\xe9s de compte","subtitle":"Tous mes relev\xe9s","accountLabel":"Compte n\xb0{id}","accounts":"Comptes","statements":"Relev\xe9s de compte disponibles","emptyStatementList":"Aucun relev\xe9 de compte disponible","cancel":"Annuler","loadStatementsError":"Une erreur est survenue lors du chargement des relev\xe9s de compte.","generateButton":"G\xe9n\xe9rer"},"taxStatements":{"title":"Mes d\xe9clarations fiscales","subtitle":"Tous mes relev\xe9s","accountLabel":"Compte n\xb0{id}","accounts":"Comptes","statements":"Relev\xe9s fiscaux disponibles","emptyStatementList":"Aucun relev\xe9 fiscal disponible","cancel":"Annuler","loadStatementsError":"Une erreur est survenue lors du chargement des relev\xe9s fiscaux.","generateButton":"G\xe9n\xe9rer"},"feesStatements":{"title":"Relev\xe9s de frais","subtitle":"Tous mes relev\xe9s","accountLabel":"Compte n\xb0{id}","accounts":"Comptes","statements":"Relev\xe9s de frais disponibles","emptyStatementList":"Aucun relev\xe9 de frais disponible","cancel":"Annuler","loadStatementsError":"Une erreur est survenue lors du chargement des relev\xe9s de frais."},"cardsList":{"title":"Mes cartes.","loadCardsError":"Une erreur est survenue lors du chargement des cartes.","loadCardsRetry":"R\xe9essayer","showAllCardsLink":"Voir toutes mes cartes","myCardTitle":"Ma carte","myCardSubtitle":"Consultez et g\xe9rez votre carte","availableBalance":"Solde disponible","emptyTitle":"Aucune carte n\'est encore ajout\xe9e","emptyDescription":"Ajoutez une carte pour commencer \xe0 effectuer vos paiements.","addCardButton":"Ajouter une carte","statusFilterTitle":"Statut","orderCard":"Commander une nouvelle carte","refabricateButton":"Remplacer la carte","infos":{"title":"Informations"},"details":{"title":"D\xe9tails de la carte","holder":"Titulaire de la carte","number":"Num\xe9ro","date":"Date d\'expiration"}},"allCardsScreen":{"goBackClassicViewButton":"Retour sur la vue classique","noCardAvailable":"Aucune carte n\'est disponible"},"card":{"title":"CARTE","status":{"all":"Tous les statuts","active":"Active","pending":"En attente","new":"Nouvelle","expired":"Expir\xe9e","blocked":"Bloqu\xe9e","opposed":"Oppos\xe9e","removed":"Retir\xe9e","cancelled":"Annul\xe9e"},"feature":{"nfc":"Sans contact","cashOperation":"Retrait","foreignPayment":"Paiement \xe0 l\'\xe9tranger","onlinePayment":"Paiement en ligne","eurWithdrawal":"Retrait en zone euro","foreignWithdrawal":"Retrait \xe0 l\'\xe9tranger","paymentAuthorized":"Paiement autoris\xe9","eurPayment":"Paiement en zone euro","foreignAll":"Paiement et retrait \xe0 l\'\xe9tranger","foreignOnlinePayment":"Paiement en ligne \xe0 l\'\xe9tranger"},"pendingOperation":{"refabrication":"La carte en cours de refabrication","codeReissuing":"Le code PIN de la carte est en cours de modification","opposition":"La carte est en cours d\'opposition","blocking":"La carte est en cours de blocage","unblocking":"La carte est en cours de d\xe9blocage","activation":"La carte est en cours d\'activation","creation":"La carte est en cours de cr\xe9ation","limitsUpdate":"Les plafonds de la carte sont en cours de modifications","featuresUpdate":"La fonctionnalit\xe9 \\"{feature}\\" de la carte est en cours de modification","unknownFeatureUpdate":"Une fonctionnalit\xe9 de la carte est en cours de modification"}},"cardPincode":{"importantMessage":"Attention, veillez \xe0 bien conserver ce code:\\nVous en aurez besoin pour valider les op\xe9rations avec votre carte.","previous":"Changer","next":"Suivant","errorCodesMismatch":"Les codes ne correspondent pas"},"cardOptions":{"title":"R\xe9glages de la carte & paiements","outstandings":{"navigateButton":"Mes plafonds","title":"Mes plafonds","subtitle":"Visionnez les plafonds de votre carte","paymentHeader":"Plafonds de paiement","cashoutHeader":"Plafonds de retrait","slidingPeriod":"p\xe9riode glissante de {num} {unit}","fixedPeriod":"du {startDate} au {endDate}","used":"Consomm\xe9","available":"Disponible","maxAmount":"Montant max","maxOperations":"Op\xe9rations max","selector":{"payments":"Paiements","cashouts":"Retraits"},"noOutstandingLabel":"Pas de plafonds configur\xe9s","errorMessage":"Une erreur est survenue lors du chargement des plafonds.","retryButton":"R\xe9essayer","durationUnit":{"hour":"heure","hours":"heures","day":"jour","days":"jours","week":"semaine","weeks":"semaines","month":"mois","months":"mois","year":"an","years":"ans"},"updateButtonLabel":"Modifier le plafond","modal":{"title":"Modifier mon plafond","inputLabel":"D\xe9finir une limite","inputLabelUnit":{"day":"journali\xe8re","week":"hebdomadaire","month":"mensuelle","year":"annuelle","all":"globale"},"maximumLabel":"Maximum","submitButtonLabel":"D\xe9finir une limite","validationMsg":"Votre modification a \xe9t\xe9 prise en compte"}},"refabricate":{"modal":{"title":"Confirmation","message":"\xcates-vous s\xfbr.e de vouloir remplacer cette carte ?","cardNumber":"{cardNumber} ","submitButtonLabel":"Confirmer"},"motiveLabel":"S\xe9lectionnez le motif","motivesOptions":{"DAMAGED":"Carte endommag\xe9e","STOLEN":"Carte vol\xe9e","LOST":"Carte perdue","ABUSE":"Utilisation frauduleuse"}},"oppositionCard":{"opposeButton":"Faire opposition","opposeDescription":"Prot\xe9gez vos fonds en cas de perte ou vol","title":"Pour faire opposition et bloquer d\xe9finitivement votre carte, choisissez un motif ci-dessous:","reasonLost":"Carte perdue","reasonStolen":"Carte vol\xe9e","reasonNotDistributed":"Carte non distribu\xe9e","opposeConfirmButton":"Confirmer","opposeCancelButton":"Annuler","opposePromptTitle":"Faire opposition","opposePromptMessage":"Cette op\xe9ration est irr\xe9versible. \xcates-vous s\xfbr de vouloir faire opposition ?"},"deactivateCard":{"deactivateButton":"R\xe9silier la carte","title":"Pour r\xe9silier et bloquer d\xe9finitivement votre carte, choisissez un motif ci-dessous:","deactivateConfirmButton":"Confirmer","deactivateCancelButton":"Annuler","deactivatePromptTitle":"R\xe9silier","deactivatePromptMessage":"Cette op\xe9ration est irr\xe9versible. \xcates-vous s\xfbr de vouloir r\xe9silier ?"},"updateCardPincode":{"updateButton":"Modifier le code PIN","updateDescription":"Changez votre code PIN en toute s\xe9curit\xe9","title":"Modification du Code PIN","definePincodeMessage":"Choisissez un nouveau code PIN \xe0 quatre chiffres pour votre carte. Surtout, ne le communiquez \xe0 personne, il est strictement confidentiel.","confirmPincodeMessage":"Veuillez confirmer le code PIN de votre carte pour continuer.","successTitle":"F\xe9licitations !","successSubtitle":"Le code PIN a \xe9t\xe9 mis \xe0 jour !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la mise \xe0 jour du code PIN de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client.","confirmationPopup":{"message":"Si vous quitter l\'\xe9dition du code PIN il ne sera pas mis \xe0 jour.\\nQuitter l\'\xe9dition ?"}},"activationCard":{"title":"Activer ma carte","activateButton":"Activer","defaultActivationMessage":"Renseignez l\'identifiant \xe0 9 chiffres pr\xe9sent \xe0 l\'arri\xe8re de votre carte.","identifier":"Votre identifiant \xe0 9 chiffres","next":"Suivant","confirm":"Activer","inputError":"Erreur de saisie, veuillez recommencer.","stepPincode":{"title":"Code PIN","definePincodeMessage":"Vous devez d\xe9sormais choisir un code PIN \xe0 quatre chiffres pour votre carte. Surtout, ne le communiquez \xe0 personne, il est strictement confidentiel.","confirmPincodeMessage":"Veuillez confirmer le code PIN de votre carte pour continuer."}},"switch":{"lockCard":"Verrouillage temporaire"},"featuresSwitchesOverlay":{"cardLocked":"Carte verrouill\xe9e"},"cardOpposedMessage":"Vous avez fait opposition sur cette carte, vous ne pouvez plus acc\xe9der \xe0 ses options."},"accountBlockedScreen":{"title":"Compte bloqu\xe9","multipleAttemptBlockedReason":{"subtitle":"Trois tentatives de code secret erron\xe9es","message":"Malheureusement, votre compte a \xe9t\xe9 bloqu\xe9 \xe0 cause de trois tentatives de code secret erron\xe9es. Veuillez contacter notre support {contacts}pour r\xe9initialiser votre code secret."},"defaultBlockedReason":{"message":"Malheureusement, votre compte a \xe9t\xe9 bloqu\xe9. Veuillez contacter notre support {contacts}pour r\xe9initialiser votre code secret."},"contactsPhoneAndEmail":"au {contactPhone} ou par mail \xe0 {contactEmail} ","contactsPhone":"au {contactPhone} ","contactsEmail":"par mail \xe0 {contactEmail} ","button":"OK, j\u2019ai compris"},"bankContactScreen":{"title":"Ma banque.","question":"Besoin d\'aide ?","addressContact":"Nous trouver","phoneContact":"Nous appeler","urlContact":"En savoir plus","emailContact":"Nous \xe9crire"},"pincodeChangeFlow":{"currentCodeLabel":"Entrez votre code actuel","newCodeLabel":"Entrez votre nouveau code","newCodeConfirmationLabel":"Confirmez votre nouveau code","newCodesDontMatchError":"Les codes entr\xe9s ne correspondent pas","success":"Votre code a \xe9t\xe9 chang\xe9 avec succ\xe8s"},"pincodeChangeScreen":{"title":"Changement de code","subtitle":"Changez votre code secret pour plus de s\xe9curit\xe9","message":"Il est n\xe9cessaire que vous changiez votre code secret avant d\'effectuer cette op\xe9ration","messageAfterAuthentication":"Vous devrez changer votre code secret avant d\'effectuer de nouvelles op\xe9rations","changePincodeButton":"Changer mon code secret","laterButton":"Plus tard","done":"Terminer"},"clientInformation":{"title":"Mes informations personnelles","birthDateTitle":"Date de naissance","birthPlaceTitle":"Lieu de naissance","addressTitle":"Adresse","phoneTitle":"T\xe9l\xe9phone","emailTitle":"Email"},"cashTransferScreen":{"title":"Transferts en attente","subtitle":"Annuler ou r\xe9cup\xe9rer votre argent","receivedSelector":"Re\xe7us","sentSelector":"Envoy\xe9s","recipient":"Envoy\xe9 \xe0 : ","sender":"Envoy\xe9 par : ","emptyReceivedList":"Aucun transfert re\xe7u","emptySentList":"Aucun transfert envoy\xe9","receivedTransferDefaultTitle":"Transfert re\xe7u","sentTransferDefaultTitle":"Transfert envoy\xe9","codeLabel":"Code : {code}","cancelCashTransferButton":"Annuler le transfert","retrieveCashTransferButton":"Envoyer sur mon compte","loadCashTransfersError":"Une erreur est survenue lors du chargement des transferts vers cash.","loadMoreCashTransfersError":"Une erreur est survenue lors du chargement des transferts vers cash.","loadMoreCashTransfersRetry":"R\xe9essayer","nextButton":"Suivant","invalidCode":"Le code saisi est invalide","cashCodeTitle":"Entrez le code envoy\xe9 par l\'exp\xe9diteur du transfert","summaryTitle":{"sentCashTransfer":"Transfert annul\xe9","receivedCashTransfer":"Transfert r\xe9cup\xe9r\xe9 sur votre compte"}},"settings":{"title":"Mes param\xe8tres personnels","changeLanguageTitle":"Langue","changeLanguageDescription":"Choisissez la langue de l\'application et des messages que nous vous envoyons.","languageChangeConfirmation":"La langue a \xe9t\xe9 chang\xe9e avec succ\xe8s","languageChangeFailed":"Une erreur s\'est produite lors du chargement de la langue","changePincodeTitle":"Changer mon code secret","changePincodeDescription":"Pour plus de securit\xe9, changez votre code secret r\xe9guli\xe8rement","accountDeleteTitle":"Supprimer mon compte","accountDeleteDescription":"Supprimer d\xe9finitivement mon compte Skaleet."},"accountDeleteScreen":{"title":"Supprimer mon compte","subtitle":"Notez que vous n\'avez pas besoin de supprimer votre compte si:","button":"Supprimer mon compte","explanation":"Votre demande va \xeatre envoy\xe9e \xe0 notre \xe9quipe. La suppression peut prendre plusieurs jours.","options":{"changeProfile":{"title":"Vous voulez changer votre code","description":"Modifiez votre code secret."},"unHappy":{"title":"Vous n\'\xeates pas heureux avec nous","description":"Contactez-nous et dites nous pourquoi."}},"confirm":{"title":"Souhaitez-vous vraiment supprimer votre compte ?","subtitle":"Votre compte sera enti\xe8rement supprim\xe9 et vos donn\xe9es et informations perdues","placeholder":"Selectionnez la raison de suppression","warning":"Cette action est d\xe9finitive","button":"Confirmer","success":"La demande de fermeture de compte a \xe9t\xe9 enregistr\xe9e"}},"accountDeleteMail":{"subject":"Demande de suppression du compte de {username}","body":"Ch\xe8re Madame, Cher Monsieur, je vous prie de bien vouloir proc\xe9der \xe0 la suppression de mon compte utilisateur."},"transactionFilter":{"all":"Tous","credit":"Recettes","debit":"D\xe9penses","searchDescription":"\xc0 l\'aide du moteur de recherche retrouvez facilement vos d\xe9penses.","searchInputPlaceholder":"Rechercher une op\xe9ration","timeRangeSelectionTitle":"Date personnalis\xe9e","timeRange":{"month":"Ce mois","week":"7 derniers jours","quarter":"3 derniers mois","from":"Du\xa0:","to":"Au\xa0:"},"advancedSearch":"Recherche avanc\xe9e.","confirm":"Valider","amountRangeSelectionTitle":"Filtrer par montant","panelTitle":"Filtres","clearAll":"Tout supprimer","apply":"Appliquer","toJustify":"\xc0 justifier","toQualify":"\xc0 qualifier","amountRangeTitle":"Gamme de d\xe9penses","periodTitle":"P\xe9riode","filtersButton":"Filtrer les op\xe9rations","allAmountRange":"Tous les montants","amountRange":{"min":"Min:","max":"Max:"},"emptySearchResult":"Aucune transaction"},"resultScreen":{"activateCard":{"successTitle":"F\xe9licitations !","successSubtitle":"Votre carte a bien \xe9t\xe9 activ\xe9e !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de l\u2019activation de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"createCard":{"successTitle":"F\xe9licitations !","defaultSuccessSubtitle":"Votre carte a bien \xe9t\xe9 cr\xe9\xe9e !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la cr\xe9ation de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"updateOutstanding":{"successTitle":"F\xe9licitations !","defaultSuccessSubtitle":"Votre modification \xe0 \xe9t\xe9 prise en compte !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la modification de votre plafond. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"refabricate":{"successTitle":"F\xe9licitations !","successSubtitle":"La demande de remplacement a \xe9t\xe9 prise en compte !","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la demande de remplacement de votre carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"sensitiveDetails":{"successTitle":"F\xe9licitations !","successSubtitle":"Continuez pour consulter les informations de la carte","failureTitle":"Erreur","failureSubtitle":"Veuillez nous excuser.","failureDescription":"Il semble y avoir eu une erreur lors de la r\xe9cup\xe9ration des informations de la carte. Veuillez r\xe9essayer plus tard ou contacter notre service client."},"done":"Terminer"},"createCard":{"title":"Nouvelle carte","virtualCardtitle":"Nouvelle carte virtuelle","loadProductsError":"Une erreur est survenue lors du chargement des produits.","loadProductsRetry":"R\xe9essayer","stepSelection":{"title":"S\xe9lection du compte","selectAccountMessage":"Veuillez s\xe9l\xe9ctionner le compte pour lequel vous d\xe9sirez commander une carte:","selectVirtualCardMessage":"Veuillez s\xe9l\xe9ctionner le compte pour lequel vous d\xe9sirez cr\xe9er une carte virtuelle:","selecProductMessage":"Quelle carte souhaitez vous commander ?","orderCardButton":"Commander ma carte","createVirtualCardButton":"Cr\xe9er une carte virtuelle","virtualCardDescription":"Pour des achats en ligne s\xe9curis\xe9s sans crainte de perte de votre carte !","accountLabel":"Compte n\xb0{id}"},"stepCgu":{"title":"Conditions g\xe9n\xe9rales d\'utilisation","acceptMessage":"En activant le switch, vous confirmez avoir lu et accept\xe9 nos conditions g\xe9n\xe9rales d\u2019utilisation","next":"Suivant"}},"recharge":{"title":"Recharger mon compte","description":"S\xe9lectionner le compte \xe0 recharger","noAccountAvailable":"Aucun compte n\u2019est disponible","noAccountExplanation":"Il semblerait que vous n\u2019ayez aucun compte rechargeable.","contactSupport":"Contacter le support","rechargeButton":"Recharger"},"rechargeMethod":{"title":"Modes de recharge","subtitle":"Comment voulez-vous recharger votre compte ?","withCard":{"title":"Carte bancaire","description":"Votre compte sera cr\xe9dit\xe9 instantan\xe9ment. Retraits dans les banques partenaires partout dans le monde.","instantTag":"Instantan\xe9"},"bankDebit":{"title":"Pr\xe9l\xe8vement bancaire","description":"Alimenter votre compte \xe0 partir de votre compte externe {bankName}. Votre compte ne sera pas cr\xe9dit\xe9 instantan\xe9ment.","noBankDescription":"Alimenter votre compte \xe0 partir de votre compte externe. Votre compte ne sera pas cr\xe9dit\xe9 instantan\xe9ment."}},"contactSupport":{"notHappyTitle":"Comment pouvons-nous vous aider ?","notHappyMessage":"Dites-nous ce qui se passe et nous essaierons de corriger le probl\xe8me.","noContactAvailable":"Aucun moyen de contact n\'est disponible pour le moment.","rechargeNotAvailableTitle":"Vous ne pouvez pas recharger votre compte ?","rechargeNotAvailableMessage":"Veuillez prendre contact avec notre \xe9quipe support qui vous indiquera la marche \xe0 suivre.","contactByPhone":"Nous contacter par t\xe9l\xe9phone au {phoneNumber}","contactByEmail":"Nous contacter par email \xe0 {email}","done":"Terminer"},"rechargeBankToWallet":{"title":"Recharge par pr\xe9l\xe8vement","subtitle":"Montant \xe0 recharger","accountWithdrawnTitle":"Compte externe prelev\xe9","accountWithdrawnMessage":"Modifiable par le menu Transferts","iban":"IBAN","amountToWithdraw":"Montant \xe0 pr\xe9lever :","recharge":"Recharger"},"rechargeByCard":{"title":"Recharge par carte","subtitle":"Montant \xe0 recharger","creditedAccountTitle":"Compte cr\xe9dit\xe9","accountId":"N\xb0{id}","amountToCredit":"Montant \xe0 cr\xe9diter :","recharge":"Recharger"},"rechargeSummary":{"title":"Succ\xe8s","rechargedAccount":"Compte recharg\xe9","rechargeMethod":"Mode de recharge","bankToWalletMethod":"Pr\xe9l\xe8vement","cardMethod":"Par carte","rechargeAmount":"Montant recharg\xe9","done":"Terminer"},"recurringTransfer":{"endDateLabel":"Date de fin","firstExecutionDateLabel":"Date de d\xe9but","frequencyLabel":"Fr\xe9quence","switchLabel":"Rendre ce transfert r\xe9current","optionLabel":{"daily":"Quotidien","weekly":"Hebdomadaire","twiceAMonth":"Bimensuel","monthly":"Mensuel"},"recurringTransferTitleDetails":"Vers {destinationAccount}","beneficiaryDetails":"D\xe9tails du b\xe9n\xe9ficiaire","scheduledAmount":"Montant pr\xe9vu","beneficiaryAccount":"Compte du b\xe9n\xe9ficiaire","beneficiaryBIC":"BIC du b\xe9n\xe9ficiaire","recurringTransferDetails":"D\xe9tails du transfert r\xe9current","sourceAccount":"Compte source","frequency":"Fr\xe9quence","nextExecutionDate":"Date de la prochaine ex\xe9cution","endDate":"Date de fin","description":"Description"},"transactionCode":{"title":"Code de transaction","description":"Cr\xe9ez un code pour l\'utiliser dans un de nos points de transaction.","noCodeAvailable":"Aucun code de transaction en cours","noCodeAvailableExplanation":"Pour g\xe9n\xe9rer un nouveau code de transaction, obtenez le num\xe9ro \xe0 6 chiffres du partenaire.","codeTooltip":"Code","newCodeButton":"Nouveau code","modalBackButton":"Retour","selectAcceptor":{"title":"Point de transaction","description":"Entrez le num\xe9ro \xe0 6 chiffres du point de transaction","next":"Suivant"},"selectAmount":{"title":"Limite autoris\xe9e","acceptorReminder":"Point de transaction : {acceptorId}","currencyLabel":"Devise :","amountLabel":"Montant :","amountInformationLabel":"Montant maximal de la transaction (frais compris)","next":"G\xe9n\xe9rer mon code"},"pincode":{"title":"Code secret","description":"Rentrez votre code secret pour terminer"},"summary":{"title":"Succ\xe8s","transactionCode":"Code de transaction","transactionPoint":"Point de transaction","maxAmount":"Montant maximum","expiryDate":"Date d\'expiration","done":"Terminer"}},"trustChoice":{"title":"Se fier \xe0 ce navigateur ?","explanation":"Si vous choisissez de faire confiance \xe0 ce navigateur, vous n\'aurez pas \xe0 saisir de code de validation lors de votre prochaine connexion.","laterButton":"Plus tard","dontTrustButton":"Ne pas se fier","trustButton":"Se fier"},"ubbleCheckScreen":{"success":{"title":"BIEN JOU\xc9 !","subtitle":"Merci pour votre enregistrement !","message":"Votre identit\xe9 va \xeatre v\xe9rifi\xe9e de notre c\xf4t\xe9. Le processus de v\xe9rification peut prendre de quelques heures \xe0 quelques jours.\\nVous pouvez maintenant vous connecter \xe0 votre espace ou fermer cette fen\xeatre.","button":"Continuer"},"fail":{"title":"D\xc9SOL\xc9 !","subtitle":"Quelque chose s\'est mal pass\xe9 pendant l\'enregistrement...","message":"Vous pouvez r\xe9essayer en utilisant le m\xeame lien qu\'avant.\\nSi vous rencontrez une autre erreur, veuillez prendre contact avec notre \xe9quipe par t\xe9l\xe9phone ou par e-mail en utilisant les boutons ci-dessous.","byPhone":"T\xe9l\xe9phone","byEmail":"Email"}},"justifyScreen":{"title":"Justifier ma d\xe9pense","subtitle":"Ajouter et modifier un justificatif","attachments":{"title":"Justificatifs","sectionTitle":"T\xe9l\xe9chargez ou d\xe9posez un justificatif","sectionSubtitle":"Au format pdf, jpeg, png","addButtonLabel":"Ajouter un justificatif","addOtherButtonLabel":"Ajouter un autre justificatif","deletePrompt":{"title":"Supprimer le justificatif","message":"\xcates-vous s\xfbr de vouloir supprimer ce justificatif ?","cancelButton":"Annuler","confirmButton":"Supprimer"}},"spendings":{"title":"Sous-d\xe9penses","sectionTitle":"Ajouter une sous-d\xe9pense","sectionSubtitle":"D\xe9clarez les sous-d\xe9penses de votre justificatif","addButtonLabel":"Ajouter une sous-d\xe9pense","addOtherButtonLabel":"Ajouter une autre sous-d\xe9pense","addModal":{"title":"Nouvelle sous-d\xe9pense","editTitle":"Modifier la sous-d\xe9pense","message":"D\xe9tails compl\xe9mentaires du justificatif","createButton":"Valider","editButton":"Enregistrer"},"addForm":{"titleLabel":"Titre","categoryLabel":"Cat\xe9gorie","subcategoryLabel":"Sous-cat\xe9gorie","amountLabel":"Montant","additionalDataLabel":"Donn\xe9e additionnelle","addAdditionalDataButton":"Ajouter une donn\xe9e additionnelle"},"deletePrompt":{"title":"Supprimer la sous-d\xe9pense","message":"\xcates-vous s\xfbr de vouloir supprimer cette sous-d\xe9pense ?","cancelButton":"Annuler","confirmButton":"Supprimer"}}},"refundTransactionModal":{"title":"Demander un remboursement","message":"Pour demander un remboursement, choisissez un motif ci-dessous:","reasons":{"AC03":"Mauvais IBAN","AM09":"Mauvais montant","CUST":"D\xe9cision client"},"confirmButton":"Confirmer","cancelButton":"Annuler","success":"Votre demande de remboursement a \xe9t\xe9 envoy\xe9e"},"upcomingTransfers":{"description":"Voir et g\xe9rer vos transferts \xe0 venir","loadMore":"Charger plus","nextOn":"Prochain le","status":{"activated":"Activ\xe9","deactivated":"En pause","expired":"Ex\xe9cut\xe9","deleted":"Annul\xe9"}},"mandates":{"description":"Voir et g\xe9rer vos mandats","status":{"all":"Tous les statuts","active":"Actif","opposed":"Oppos\xe9","consumed":"Utilis\xe9","revoked":"R\xe9voqu\xe9","creditorOpposed":"Oppos\xe9 par le cr\xe9ancier","obsolete":"Obsol\xe8te"},"details":{"to":"\xc0","mandateDetails":"D\xe9tails du mandat","reference":"R\xe9f\xe9rence","id":"Identifiant","signatureDate":"Date de signature","creditorDetails":"D\xe9tails du cr\xe9ancier","creditorRef":"R\xe9f\xe9rence cr\xe9ancier","accountInformation":"Informations du compte","accountIban":"IBAN du compte","accountBic":"BIC du compte"},"opposePrompt":{"title":{"first":"Opposer","second":"le mandat"},"message":"Voulez-vous vraiment opposer le mandat {reference} au cr\xe9ancier {creditorName} ?"},"activatePrompt":{"title":{"first":"Activer","second":"le mandat"},"message":"Voulez-vous vraiment activer le mandat {reference} au cr\xe9ancier {creditorName} ?"},"confirmButton":"Confirmer"},"mandatesSubmenu":{"mandates":"Mandats"}}');

});


parcelRegister("5MHoL", function(module, exports) {

$parcel$export(module.exports, "WebUUIDGenerator", function () { return $e10b562a686fd36c$export$f51bec79cdc5b36d; });

var $9EgSA = parcelRequire("9EgSA");
class $e10b562a686fd36c$export$f51bec79cdc5b36d {
    async getRandomUUID() {
        return (0, $9EgSA.default)();
    }
}

});
parcelRegister("9EgSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7064f1687ebe1af6$export$2e2bcd8739ae039; });

var $48ORP = parcelRequire("48ORP");

var $4bKzo = parcelRequire("4bKzo");
function $7064f1687ebe1af6$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $48ORP.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $4bKzo.default)(rnds);
}
var $7064f1687ebe1af6$export$2e2bcd8739ae039 = $7064f1687ebe1af6$var$v4;

});
parcelRegister("48ORP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $303f5deef2d8e727$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $303f5deef2d8e727$var$getRandomValues;
var $303f5deef2d8e727$var$rnds8 = new Uint8Array(16);
function $303f5deef2d8e727$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$303f5deef2d8e727$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $303f5deef2d8e727$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$303f5deef2d8e727$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $303f5deef2d8e727$var$getRandomValues($303f5deef2d8e727$var$rnds8);
}

});

parcelRegister("4bKzo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30cc504cb90c6dac$export$2e2bcd8739ae039; });

var $9o0Jq = parcelRequire("9o0Jq");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $30cc504cb90c6dac$var$byteToHex = [];
for(var $30cc504cb90c6dac$var$i = 0; $30cc504cb90c6dac$var$i < 256; ++$30cc504cb90c6dac$var$i)$30cc504cb90c6dac$var$byteToHex.push(($30cc504cb90c6dac$var$i + 0x100).toString(16).substr(1));
function $30cc504cb90c6dac$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($30cc504cb90c6dac$var$byteToHex[arr[offset + 0]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 1]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 2]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 3]] + '-' + $30cc504cb90c6dac$var$byteToHex[arr[offset + 4]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 5]] + '-' + $30cc504cb90c6dac$var$byteToHex[arr[offset + 6]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 7]] + '-' + $30cc504cb90c6dac$var$byteToHex[arr[offset + 8]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 9]] + '-' + $30cc504cb90c6dac$var$byteToHex[arr[offset + 10]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 11]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 12]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 13]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 14]] + $30cc504cb90c6dac$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $9o0Jq.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $30cc504cb90c6dac$export$2e2bcd8739ae039 = $30cc504cb90c6dac$var$stringify;

});
parcelRegister("9o0Jq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d56ec3fce7f426e$export$2e2bcd8739ae039; });

var $2wAbc = parcelRequire("2wAbc");
function $6d56ec3fce7f426e$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $2wAbc.default).test(uuid);
}
var $6d56ec3fce7f426e$export$2e2bcd8739ae039 = $6d56ec3fce7f426e$var$validate;

});
parcelRegister("2wAbc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d6aa275d70d9243$export$2e2bcd8739ae039; });
var $1d6aa275d70d9243$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});





parcelRegister("DnLEN", function(module, exports) {

$parcel$export(module.exports, "WebDeviceInfoService", function () { return $00167312c99294bf$export$bc3259dfd478f5e3; });
class $00167312c99294bf$export$bc3259dfd478f5e3 {
    getModel() {
        return "WEB";
    }
}

});

parcelRegister("7wo2g", function(module, exports) {

$parcel$export(module.exports, "WebAccountBankDetailsService", function () { return $deb6be190b29ac6c$export$455b38191a9c57ac; });

var $4Zze3 = parcelRequire("4Zze3");
class $deb6be190b29ac6c$export$455b38191a9c57ac {
    constructor(connectedServiceDomainApiService){
        this.connectedServiceDomainApiService = connectedServiceDomainApiService;
    }
    async downloadAccountBankDetails(accountId) {
        const result = await this.connectedServiceDomainApiService.instance.get(`/accounts/${accountId}/bank-account-details/download`, {
            responseType: "arraybuffer"
        });
        await (0, $4Zze3.downloadFile)(`${accountId}_details.pdf`, result.data, "application/pdf");
        return `${accountId}_details.pdf`;
    }
}

});
parcelRegister("4Zze3", function(module, exports) {

$parcel$export(module.exports, "downloadFile", function () { return $90449d7cbefea265$export$bb3b75778e3e272; });
function $90449d7cbefea265$export$bb3b75778e3e272(filename, content, type) {
    const element = document.createElement("a");
    const file = new Blob([
        content
    ], {
        type: type
    });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

});


parcelRegister("crfiu", function(module, exports) {

$parcel$export(module.exports, "WebAccountStatementsService", function () { return $2d20db94ded0b82a$export$a235338c0dd418f6; });

var $9fsg3 = parcelRequire("9fsg3");

var $4Zze3 = parcelRequire("4Zze3");
class $2d20db94ded0b82a$export$a235338c0dd418f6 extends (0, $9fsg3.BaseAccountStatementsService) {
    constructor(apiService){
        super(apiService);
    }
    async downloadStatement(accountId, statementId, variant) {
        const path = variant === "normal" ? "statements" : "fees-statements";
        const result = await this.apiService.instance.get(`/accounts/${accountId}/${path}/${statementId}/download`, {
            responseType: "arraybuffer"
        });
        await (0, $4Zze3.downloadFile)(`${statementId}.pdf`, result.data, "application/pdf");
        return `${statementId}.pdf`;
    }
}

});
parcelRegister("9fsg3", function(module, exports) {

$parcel$export(module.exports, "BaseAccountStatementsService", function () { return $7b76b9a1a28cc3a5$export$1e569aaf4ef5aff9; });

var $6JVVB = parcelRequire("6JVVB");
class $7b76b9a1a28cc3a5$export$1e569aaf4ef5aff9 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchStatements(accountId, pagination) {
        try {
            const response = await this.apiService.instance.get(`/accounts/${accountId}/statements`, {
                params: {
                    ...pagination
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AccountStatementsService", "Fetch statements failed", e);
            throw e;
        }
    }
    async fetchFeesStatements(accountId, pagination) {
        try {
            const response = await this.apiService.instance.get(`/accounts/${accountId}/fees-statements`, {
                params: {
                    ...pagination
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AccountFeesStatementsService", "Fetch fees statements failed", e);
            throw e;
        }
    }
}

});


parcelRegister("asiRY", function(module, exports) {

$parcel$export(module.exports, "WebOAuthService", function () { return $b1e9106fe48f67f4$export$fa3cf231e713c7ac; });

var $9ouY8 = parcelRequire("9ouY8");

var $dhPTb = parcelRequire("dhPTb");
const $b1e9106fe48f67f4$var$CODE_VERIFIER_KEY = "oauth_code_verifier";
const $b1e9106fe48f67f4$var$STATE_KEY = "oauth_state";
class $b1e9106fe48f67f4$export$fa3cf231e713c7ac {
    constructor(oAuthHttpService, localStorage, trustManager){
        this.oAuthHttpService = oAuthHttpService;
        this.localStorage = localStorage;
        this.trustManager = trustManager;
        this.trustManager.onRemoveState.add(()=>this.removeState());
    }
    async refresh(configuration, refreshConfig) {
        const result = await this.oAuthHttpService.instance.post("/oauth2/token", {
            grant_type: "refresh_token",
            client_id: configuration.clientId,
            refresh_token: refreshConfig.refreshToken,
            client_secret: configuration.clientSecret
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        const { refresh_token: refresh_token, access_token: access_token, expires_in: expires_in, token_type: token_type } = result.data;
        return {
            refreshToken: refresh_token ?? null,
            accessToken: access_token,
            accessTokenExpirationDate: new Date(Date.now() + parseInt(expires_in.toString()) * 1000).toString(),
            tokenType: token_type
        };
    }
    async authorize(configuration) {
        this.redirectToAuthorizationGrant(configuration);
    }
    async redirectToAuthorizationGrant(configuration) {
        const { codeChallenge: codeChallenge, codeVerifier: codeVerifier } = await (0, $9ouY8.OAuth2AuthCodePKCE).generatePKCECodes();
        this.localStorage.store(codeVerifier, $b1e9106fe48f67f4$var$CODE_VERIFIER_KEY);
        let stateQueryParam;
        const previousState = await this.localStorage.read($b1e9106fe48f67f4$var$STATE_KEY);
        if (previousState) stateQueryParam = previousState;
        else {
            stateQueryParam = (0, $9ouY8.OAuth2AuthCodePKCE).generateRandomState((0, $9ouY8.RECOMMENDED_STATE_LENGTH));
            this.localStorage.store(stateQueryParam, $b1e9106fe48f67f4$var$STATE_KEY);
        }
        const additionalParametersText = Object.entries(configuration.additionalParameters ?? {}).reduce((acc, attribute)=>{
            const [key, value] = attribute;
            return acc + `&${key}=${value}`;
        }, "");
        const url = configuration.serviceConfiguration.authorizationEndpoint + "?response_type=code&" + `client_id=${encodeURIComponent(configuration.clientId)}&` + `redirect_uri=${encodeURIComponent(configuration.redirectUrl)}&` + `scope=${encodeURIComponent(configuration.scopes.join(" "))}&` + `state=${stateQueryParam}&` + `code_challenge=${encodeURIComponent(codeChallenge)}&` + "code_challenge_method=S256" + additionalParametersText;
        window.location.replace(url);
    }
    async completeAuthorization(code, paramState, configuration) {
        const codeVerifier = await this.localStorage.read($b1e9106fe48f67f4$var$CODE_VERIFIER_KEY);
        const state = await this.localStorage.read($b1e9106fe48f67f4$var$STATE_KEY);
        if (paramState !== state) throw `OAuth State mismatch (authorize request and url parameters). ${state} ${paramState}`;
        const result = await this.oAuthHttpService.instance.post("/oauth2/token", {
            grant_type: "authorization_code",
            client_id: configuration.clientId,
            client_secret: (0, $dhPTb.Config).API_CLIENT_SECRET,
            redirect_uri: configuration.redirectUrl,
            code_verifier: codeVerifier,
            scopes: configuration.scopes,
            code: code
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        this.localStorage.clear($b1e9106fe48f67f4$var$CODE_VERIFIER_KEY);
        return result.data;
    }
    removeState() {
        this.localStorage.clear($b1e9106fe48f67f4$var$STATE_KEY);
    }
}

});
parcelRegister("9ouY8", function(module, exports) {
"use strict";
/**
 * An implementation of rfc6749#section-4.1 and rfc7636.
 */ var $6d6e60b6113ba0cb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6d6e60b6113ba0cb$var$__assign = module.exports && module.exports.__assign || function() {
    $6d6e60b6113ba0cb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d6e60b6113ba0cb$var$__assign.apply(this, arguments);
};
var $6d6e60b6113ba0cb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6d6e60b6113ba0cb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6d6e60b6113ba0cb$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * A list of OAuth2AuthCodePKCE errors.
 */ // To "namespace" all errors.
var $6d6e60b6113ba0cb$var$ErrorOAuth2 = /** @class */ function() {
    function ErrorOAuth2() {}
    ErrorOAuth2.prototype.toString = function() {
        return 'ErrorOAuth2';
    };
    return ErrorOAuth2;
}();
module.exports.ErrorOAuth2 = $6d6e60b6113ba0cb$var$ErrorOAuth2;
// For really unknown errors.
var $6d6e60b6113ba0cb$var$ErrorUnknown = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorUnknown, _super);
    function ErrorUnknown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnknown.prototype.toString = function() {
        return 'ErrorUnknown';
    };
    return ErrorUnknown;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorUnknown = $6d6e60b6113ba0cb$var$ErrorUnknown;
// Some generic, internal errors that can happen.
var $6d6e60b6113ba0cb$var$ErrorNoAuthCode = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorNoAuthCode, _super);
    function ErrorNoAuthCode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorNoAuthCode.prototype.toString = function() {
        return 'ErrorNoAuthCode';
    };
    return ErrorNoAuthCode;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorNoAuthCode = $6d6e60b6113ba0cb$var$ErrorNoAuthCode;
var $6d6e60b6113ba0cb$var$ErrorInvalidReturnedStateParam = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorInvalidReturnedStateParam, _super);
    function ErrorInvalidReturnedStateParam() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidReturnedStateParam.prototype.toString = function() {
        return 'ErrorInvalidReturnedStateParam';
    };
    return ErrorInvalidReturnedStateParam;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorInvalidReturnedStateParam = $6d6e60b6113ba0cb$var$ErrorInvalidReturnedStateParam;
var $6d6e60b6113ba0cb$var$ErrorInvalidJson = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorInvalidJson, _super);
    function ErrorInvalidJson() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidJson.prototype.toString = function() {
        return 'ErrorInvalidJson';
    };
    return ErrorInvalidJson;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorInvalidJson = $6d6e60b6113ba0cb$var$ErrorInvalidJson;
// Errors that occur across many endpoints
var $6d6e60b6113ba0cb$var$ErrorInvalidScope = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorInvalidScope, _super);
    function ErrorInvalidScope() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidScope.prototype.toString = function() {
        return 'ErrorInvalidScope';
    };
    return ErrorInvalidScope;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorInvalidScope = $6d6e60b6113ba0cb$var$ErrorInvalidScope;
var $6d6e60b6113ba0cb$var$ErrorInvalidRequest = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorInvalidRequest, _super);
    function ErrorInvalidRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidRequest.prototype.toString = function() {
        return 'ErrorInvalidRequest';
    };
    return ErrorInvalidRequest;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorInvalidRequest = $6d6e60b6113ba0cb$var$ErrorInvalidRequest;
var $6d6e60b6113ba0cb$var$ErrorInvalidToken = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorInvalidToken, _super);
    function ErrorInvalidToken() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidToken.prototype.toString = function() {
        return 'ErrorInvalidToken';
    };
    return ErrorInvalidToken;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorInvalidToken = $6d6e60b6113ba0cb$var$ErrorInvalidToken;
/**
 * Possible authorization grant errors given by the redirection from the
 * authorization server.
 */ var $6d6e60b6113ba0cb$var$ErrorAuthenticationGrant = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorAuthenticationGrant, _super);
    function ErrorAuthenticationGrant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAuthenticationGrant.prototype.toString = function() {
        return 'ErrorAuthenticationGrant';
    };
    return ErrorAuthenticationGrant;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorAuthenticationGrant = $6d6e60b6113ba0cb$var$ErrorAuthenticationGrant;
var $6d6e60b6113ba0cb$var$ErrorUnauthorizedClient = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorUnauthorizedClient, _super);
    function ErrorUnauthorizedClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnauthorizedClient.prototype.toString = function() {
        return 'ErrorUnauthorizedClient';
    };
    return ErrorUnauthorizedClient;
}($6d6e60b6113ba0cb$var$ErrorAuthenticationGrant);
module.exports.ErrorUnauthorizedClient = $6d6e60b6113ba0cb$var$ErrorUnauthorizedClient;
var $6d6e60b6113ba0cb$var$ErrorAccessDenied = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorAccessDenied, _super);
    function ErrorAccessDenied() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAccessDenied.prototype.toString = function() {
        return 'ErrorAccessDenied';
    };
    return ErrorAccessDenied;
}($6d6e60b6113ba0cb$var$ErrorAuthenticationGrant);
module.exports.ErrorAccessDenied = $6d6e60b6113ba0cb$var$ErrorAccessDenied;
var $6d6e60b6113ba0cb$var$ErrorUnsupportedResponseType = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorUnsupportedResponseType, _super);
    function ErrorUnsupportedResponseType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnsupportedResponseType.prototype.toString = function() {
        return 'ErrorUnsupportedResponseType';
    };
    return ErrorUnsupportedResponseType;
}($6d6e60b6113ba0cb$var$ErrorAuthenticationGrant);
module.exports.ErrorUnsupportedResponseType = $6d6e60b6113ba0cb$var$ErrorUnsupportedResponseType;
var $6d6e60b6113ba0cb$var$ErrorServerError = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorServerError, _super);
    function ErrorServerError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorServerError.prototype.toString = function() {
        return 'ErrorServerError';
    };
    return ErrorServerError;
}($6d6e60b6113ba0cb$var$ErrorAuthenticationGrant);
module.exports.ErrorServerError = $6d6e60b6113ba0cb$var$ErrorServerError;
var $6d6e60b6113ba0cb$var$ErrorTemporarilyUnavailable = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorTemporarilyUnavailable, _super);
    function ErrorTemporarilyUnavailable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorTemporarilyUnavailable.prototype.toString = function() {
        return 'ErrorTemporarilyUnavailable';
    };
    return ErrorTemporarilyUnavailable;
}($6d6e60b6113ba0cb$var$ErrorAuthenticationGrant);
module.exports.ErrorTemporarilyUnavailable = $6d6e60b6113ba0cb$var$ErrorTemporarilyUnavailable;
/**
 * A list of possible access token response errors.
 */ var $6d6e60b6113ba0cb$var$ErrorAccessTokenResponse = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorAccessTokenResponse, _super);
    function ErrorAccessTokenResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAccessTokenResponse.prototype.toString = function() {
        return 'ErrorAccessTokenResponse';
    };
    return ErrorAccessTokenResponse;
}($6d6e60b6113ba0cb$var$ErrorOAuth2);
module.exports.ErrorAccessTokenResponse = $6d6e60b6113ba0cb$var$ErrorAccessTokenResponse;
var $6d6e60b6113ba0cb$var$ErrorInvalidClient = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorInvalidClient, _super);
    function ErrorInvalidClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidClient.prototype.toString = function() {
        return 'ErrorInvalidClient';
    };
    return ErrorInvalidClient;
}($6d6e60b6113ba0cb$var$ErrorAccessTokenResponse);
module.exports.ErrorInvalidClient = $6d6e60b6113ba0cb$var$ErrorInvalidClient;
var $6d6e60b6113ba0cb$var$ErrorInvalidGrant = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorInvalidGrant, _super);
    function ErrorInvalidGrant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidGrant.prototype.toString = function() {
        return 'ErrorInvalidGrant';
    };
    return ErrorInvalidGrant;
}($6d6e60b6113ba0cb$var$ErrorAccessTokenResponse);
module.exports.ErrorInvalidGrant = $6d6e60b6113ba0cb$var$ErrorInvalidGrant;
var $6d6e60b6113ba0cb$var$ErrorUnsupportedGrantType = /** @class */ function(_super) {
    $6d6e60b6113ba0cb$var$__extends(ErrorUnsupportedGrantType, _super);
    function ErrorUnsupportedGrantType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnsupportedGrantType.prototype.toString = function() {
        return 'ErrorUnsupportedGrantType';
    };
    return ErrorUnsupportedGrantType;
}($6d6e60b6113ba0cb$var$ErrorAccessTokenResponse);
module.exports.ErrorUnsupportedGrantType = $6d6e60b6113ba0cb$var$ErrorUnsupportedGrantType;
/**
 * WWW-Authenticate error object structure for less error prone handling.
 */ var $6d6e60b6113ba0cb$var$ErrorWWWAuthenticate = /** @class */ function() {
    function ErrorWWWAuthenticate() {
        this.realm = "";
        this.error = "";
    }
    return ErrorWWWAuthenticate;
}();
module.exports.ErrorWWWAuthenticate = $6d6e60b6113ba0cb$var$ErrorWWWAuthenticate;
module.exports.RawErrorToErrorClassMap = {
    invalid_request: $6d6e60b6113ba0cb$var$ErrorInvalidRequest,
    invalid_grant: $6d6e60b6113ba0cb$var$ErrorInvalidGrant,
    unauthorized_client: $6d6e60b6113ba0cb$var$ErrorUnauthorizedClient,
    access_denied: $6d6e60b6113ba0cb$var$ErrorAccessDenied,
    unsupported_response_type: $6d6e60b6113ba0cb$var$ErrorUnsupportedResponseType,
    invalid_scope: $6d6e60b6113ba0cb$var$ErrorInvalidScope,
    server_error: $6d6e60b6113ba0cb$var$ErrorServerError,
    temporarily_unavailable: $6d6e60b6113ba0cb$var$ErrorTemporarilyUnavailable,
    invalid_client: $6d6e60b6113ba0cb$var$ErrorInvalidClient,
    unsupported_grant_type: $6d6e60b6113ba0cb$var$ErrorUnsupportedGrantType,
    invalid_json: $6d6e60b6113ba0cb$var$ErrorInvalidJson,
    invalid_token: $6d6e60b6113ba0cb$var$ErrorInvalidToken
};
/**
 * Translate the raw error strings returned from the server into error classes.
 */ function $6d6e60b6113ba0cb$var$toErrorClass(rawError) {
    return new (module.exports.RawErrorToErrorClassMap[rawError] || $6d6e60b6113ba0cb$var$ErrorUnknown)();
}
module.exports.toErrorClass = $6d6e60b6113ba0cb$var$toErrorClass;
/**
 * A convience function to turn, for example, `Bearer realm="bity.com",
 * error="invalid_client"` into `{ realm: "bity.com", error: "invalid_client"
 * }`.
 */ function $6d6e60b6113ba0cb$var$fromWWWAuthenticateHeaderStringToObject(a) {
    var obj = a.slice(7).replace(/"/g, '').split(', ').map(function(tokens) {
        var _a;
        var _b = tokens.split('='), k = _b[0], v = _b[1];
        return _a = {}, _a[k] = v, _a;
    }).reduce(function(a, c) {
        return $6d6e60b6113ba0cb$var$__assign($6d6e60b6113ba0cb$var$__assign({}, a), c);
    }, {});
    return {
        realm: obj.realm,
        error: obj.error
    };
}
module.exports.fromWWWAuthenticateHeaderStringToObject = $6d6e60b6113ba0cb$var$fromWWWAuthenticateHeaderStringToObject;
/**
 * HTTP headers that we need to access.
 */ var $6d6e60b6113ba0cb$var$HEADER_AUTHORIZATION = "Authorization";
var $6d6e60b6113ba0cb$var$HEADER_WWW_AUTHENTICATE = "WWW-Authenticate";
/**
 * To store the OAuth client's data between websites due to redirection.
 */ module.exports.LOCALSTORAGE_ID = "oauth2authcodepkce";
module.exports.LOCALSTORAGE_STATE = module.exports.LOCALSTORAGE_ID + "-state";
/**
 * The maximum length for a code verifier for the best security we can offer.
 * Please note the NOTE section of RFC 7636 § 4.1 - the length must be >= 43,
 * but <= 128, **after** base64 url encoding. This means 32 code verifier bytes
 * encoded will be 43 bytes, or 96 bytes encoded will be 128 bytes. So 96 bytes
 * is the highest valid value that can be used.
 */ module.exports.RECOMMENDED_CODE_VERIFIER_LENGTH = 96;
/**
 * A sensible length for the state's length, for anti-csrf.
 */ module.exports.RECOMMENDED_STATE_LENGTH = 32;
/**
 * Character set to generate code verifier defined in rfc7636.
 */ var $6d6e60b6113ba0cb$var$PKCE_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
/**
 * OAuth 2.0 client that ONLY supports authorization code flow, with PKCE.
 *
 * Many applications structure their OAuth usage in different ways. This class
 * aims to provide both flexible and easy ways to use this configuration of
 * OAuth.
 *
 * See `example.ts` for how you'd typically use this.
 *
 * For others, review this class's methods.
 */ var $6d6e60b6113ba0cb$var$OAuth2AuthCodePKCE = /** @class */ function() {
    function OAuth2AuthCodePKCE(config) {
        this.state = {};
        this.config = config;
        this.recoverState();
        return this;
    }
    /**
     * Attach the OAuth logic to all fetch requests and translate errors (either
     * returned as json or through the WWW-Authenticate header) into nice error
     * classes.
     */ OAuth2AuthCodePKCE.prototype.decorateFetchHTTPClient = function(fetch1) {
        var _this = this;
        return function(url, config) {
            var rest = [];
            for(var _i = 2; _i < arguments.length; _i++)rest[_i - 2] = arguments[_i];
            if (!_this.state.isHTTPDecoratorActive) return fetch1.apply(void 0, $6d6e60b6113ba0cb$var$__spreadArrays([
                url,
                config
            ], rest));
            return _this.getAccessToken().then(function(_a) {
                var token = _a.token;
                var configNew = Object.assign({}, config);
                if (!configNew.headers) configNew.headers = {};
                configNew.headers[$6d6e60b6113ba0cb$var$HEADER_AUTHORIZATION] = "Bearer " + token.value;
                return fetch1.apply(void 0, $6d6e60b6113ba0cb$var$__spreadArrays([
                    url,
                    configNew
                ], rest));
            }).then(function(res) {
                if (res.ok) return res;
                if (!res.headers.has($6d6e60b6113ba0cb$var$HEADER_WWW_AUTHENTICATE.toLowerCase())) return res;
                var error = $6d6e60b6113ba0cb$var$toErrorClass($6d6e60b6113ba0cb$var$fromWWWAuthenticateHeaderStringToObject(res.headers.get($6d6e60b6113ba0cb$var$HEADER_WWW_AUTHENTICATE.toLowerCase())).error);
                if (error instanceof $6d6e60b6113ba0cb$var$ErrorInvalidToken) _this.config.onAccessTokenExpiry(function() {
                    return _this.exchangeRefreshTokenForAccessToken();
                });
                return Promise.reject(error);
            });
        };
    };
    /**
     * If there is an error, it will be passed back as a rejected Promise.
     * If there is no code, the user should be redirected via
     * [fetchAuthorizationCode].
     */ OAuth2AuthCodePKCE.prototype.isReturningFromAuthServer = function() {
        var error = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, 'error');
        if (error) return Promise.reject($6d6e60b6113ba0cb$var$toErrorClass(error));
        var code = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, 'code');
        if (!code) return Promise.resolve(false);
        var state = JSON.parse(localStorage.getItem(module.exports.LOCALSTORAGE_STATE) || '{}');
        var stateQueryParam = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, 'state');
        if (stateQueryParam !== state.stateQueryParam) {
            console.warn("state query string parameter doesn't match the one sent! Possible malicious activity somewhere.");
            return Promise.reject(new $6d6e60b6113ba0cb$var$ErrorInvalidReturnedStateParam());
        }
        state.authorizationCode = code;
        state.hasAuthCodeBeenExchangedForAccessToken = false;
        localStorage.setItem(module.exports.LOCALSTORAGE_STATE, JSON.stringify(state));
        this.setState(state);
        return Promise.resolve(true);
    };
    /**
     * Fetch an authorization grant via redirection. In a sense this function
     * doesn't return because of the redirect behavior (uses `location.replace`).
     *
     * @param oneTimeParams A way to specify "one time" used query string
     * parameters during the authorization code fetching process, usually for
     * values which need to change at run-time.
     */ OAuth2AuthCodePKCE.prototype.fetchAuthorizationCode = function(oneTimeParams) {
        return $6d6e60b6113ba0cb$var$__awaiter(this, void 0, void 0, function() {
            var _a, clientId, extraAuthorizationParams, redirectUrl, scopes, _b, codeChallenge, codeVerifier, stateQueryParam, url, extraParameters;
            return $6d6e60b6113ba0cb$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this.assertStateAndConfigArePresent();
                        _a = this.config, clientId = _a.clientId, extraAuthorizationParams = _a.extraAuthorizationParams, redirectUrl = _a.redirectUrl, scopes = _a.scopes;
                        return [
                            4 /*yield*/ ,
                            OAuth2AuthCodePKCE.generatePKCECodes()
                        ];
                    case 1:
                        _b = _c.sent(), codeChallenge = _b.codeChallenge, codeVerifier = _b.codeVerifier;
                        stateQueryParam = OAuth2AuthCodePKCE.generateRandomState(module.exports.RECOMMENDED_STATE_LENGTH);
                        this.state = $6d6e60b6113ba0cb$var$__assign($6d6e60b6113ba0cb$var$__assign({}, this.state), {
                            codeChallenge: codeChallenge,
                            codeVerifier: codeVerifier,
                            stateQueryParam: stateQueryParam,
                            isHTTPDecoratorActive: true
                        });
                        localStorage.setItem(module.exports.LOCALSTORAGE_STATE, JSON.stringify(this.state));
                        url = this.config.authorizationUrl + "?response_type=code&" + ("client_id=" + encodeURIComponent(clientId) + "&") + ("redirect_uri=" + encodeURIComponent(redirectUrl) + "&") + ("scope=" + encodeURIComponent(scopes.join(' ')) + "&") + ("state=" + stateQueryParam + "&") + ("code_challenge=" + encodeURIComponent(codeChallenge) + "&") + "code_challenge_method=S256";
                        if (extraAuthorizationParams || oneTimeParams) {
                            extraParameters = $6d6e60b6113ba0cb$var$__assign($6d6e60b6113ba0cb$var$__assign({}, extraAuthorizationParams), oneTimeParams);
                            url = url + "&" + OAuth2AuthCodePKCE.objectToQueryString(extraParameters);
                        }
                        location.replace(url);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Tries to get the current access token. If there is none
     * it will fetch another one. If it is expired, it will fire
     * [onAccessTokenExpiry] but it's up to the user to call the refresh token
     * function. This is because sometimes not using the refresh token facilities
     * is easier.
     */ OAuth2AuthCodePKCE.prototype.getAccessToken = function() {
        var _this = this;
        this.assertStateAndConfigArePresent();
        var onAccessTokenExpiry = this.config.onAccessTokenExpiry;
        var _a = this.state, accessToken = _a.accessToken, authorizationCode = _a.authorizationCode, explicitlyExposedTokens = _a.explicitlyExposedTokens, hasAuthCodeBeenExchangedForAccessToken = _a.hasAuthCodeBeenExchangedForAccessToken, refreshToken = _a.refreshToken, scopes = _a.scopes;
        if (!authorizationCode) return Promise.reject(new $6d6e60b6113ba0cb$var$ErrorNoAuthCode());
        if (this.authCodeForAccessTokenRequest) return this.authCodeForAccessTokenRequest;
        if (!this.isAuthorized() || !hasAuthCodeBeenExchangedForAccessToken) {
            this.authCodeForAccessTokenRequest = this.exchangeAuthCodeForAccessToken();
            return this.authCodeForAccessTokenRequest;
        }
        // Depending on the server (and config), refreshToken may not be available.
        if (refreshToken && this.isAccessTokenExpired()) return onAccessTokenExpiry(function() {
            return _this.exchangeRefreshTokenForAccessToken();
        });
        return Promise.resolve({
            token: accessToken,
            explicitlyExposedTokens: explicitlyExposedTokens,
            scopes: scopes,
            refreshToken: refreshToken
        });
    };
    /**
     * Refresh an access token from the remote service.
     */ OAuth2AuthCodePKCE.prototype.exchangeRefreshTokenForAccessToken = function() {
        var _this = this;
        var _a;
        this.assertStateAndConfigArePresent();
        var _b = this.config, extraRefreshParams = _b.extraRefreshParams, clientId = _b.clientId, tokenUrl = _b.tokenUrl;
        var refreshToken = this.state.refreshToken;
        if (!refreshToken) console.warn('No refresh token is present.');
        var url = tokenUrl;
        var body = "grant_type=refresh_token&" + ("refresh_token=" + ((_a = refreshToken) === null || _a === void 0 ? void 0 : _a.value) + "&") + ("client_id=" + clientId);
        if (extraRefreshParams) body = url + "&" + OAuth2AuthCodePKCE.objectToQueryString(extraRefreshParams);
        return fetch(url, {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function(res) {
            return res.status >= 400 ? res.json().then(function(data) {
                return Promise.reject(data);
            }) : res.json();
        }).then(function(json) {
            var access_token = json.access_token, expires_in = json.expires_in, refresh_token = json.refresh_token, scope = json.scope;
            var explicitlyExposedTokens = _this.config.explicitlyExposedTokens;
            var scopes = [];
            var tokensToExpose = {};
            var accessToken = {
                value: access_token,
                expiry: new Date(Date.now() + parseInt(expires_in) * 1000).toString()
            };
            _this.state.accessToken = accessToken;
            if (refresh_token) {
                var refreshToken_1 = {
                    value: refresh_token
                };
                _this.state.refreshToken = refreshToken_1;
            }
            if (explicitlyExposedTokens) {
                tokensToExpose = Object.fromEntries(explicitlyExposedTokens.map(function(tokenName) {
                    return [
                        tokenName,
                        json[tokenName]
                    ];
                }).filter(function(_a) {
                    var _ = _a[0], tokenValue = _a[1];
                    return tokenValue !== undefined;
                }));
                _this.state.explicitlyExposedTokens = tokensToExpose;
            }
            if (scope) {
                // Multiple scopes are passed and delimited by spaces,
                // despite using the singular name "scope".
                scopes = scope.split(' ');
                _this.state.scopes = scopes;
            }
            localStorage.setItem(module.exports.LOCALSTORAGE_STATE, JSON.stringify(_this.state));
            var accessContext = {
                token: accessToken,
                scopes: scopes
            };
            if (explicitlyExposedTokens) accessContext.explicitlyExposedTokens = tokensToExpose;
            return accessContext;
        }).catch(function(data) {
            var onInvalidGrant = _this.config.onInvalidGrant;
            var error = data.error || 'There was a network error.';
            switch(error){
                case 'invalid_grant':
                    onInvalidGrant(function() {
                        return _this.fetchAuthorizationCode();
                    });
                    break;
                default:
                    break;
            }
            return Promise.reject($6d6e60b6113ba0cb$var$toErrorClass(error));
        });
    };
    /**
     * Get the scopes that were granted by the authorization server.
     */ OAuth2AuthCodePKCE.prototype.getGrantedScopes = function() {
        return this.state.scopes;
    };
    /**
     * Signals if OAuth HTTP decorating should be active or not.
     */ OAuth2AuthCodePKCE.prototype.isHTTPDecoratorActive = function(isActive) {
        this.state.isHTTPDecoratorActive = isActive;
        localStorage.setItem(module.exports.LOCALSTORAGE_STATE, JSON.stringify(this.state));
    };
    /**
     * Tells if the client is authorized or not. This means the client has at
     * least once successfully fetched an access token. The access token could be
     * expired.
     */ OAuth2AuthCodePKCE.prototype.isAuthorized = function() {
        return !!this.state.accessToken;
    };
    /**
     * Checks to see if the access token has expired.
     */ OAuth2AuthCodePKCE.prototype.isAccessTokenExpired = function() {
        var accessToken = this.state.accessToken;
        return Boolean(accessToken && new Date() >= new Date(accessToken.expiry));
    };
    /**
     * Resets the state of the client. Equivalent to "logging out" the user.
     */ OAuth2AuthCodePKCE.prototype.reset = function() {
        this.setState({});
        this.authCodeForAccessTokenRequest = undefined;
    };
    /**
     * If the state or config are missing, it means the client is in a bad state.
     * This should never happen, but the check is there just in case.
     */ OAuth2AuthCodePKCE.prototype.assertStateAndConfigArePresent = function() {
        if (!this.state || !this.config) {
            console.error('state:', this.state, 'config:', this.config);
            throw new Error('state or config is not set.');
        }
    };
    /**
     * Fetch an access token from the remote service. You may pass a custom
     * authorization grant code for any reason, but this is non-standard usage.
     */ OAuth2AuthCodePKCE.prototype.exchangeAuthCodeForAccessToken = function(codeOverride) {
        var _this = this;
        this.assertStateAndConfigArePresent();
        var _a = this.state, _b = _a.authorizationCode, authorizationCode = _b === void 0 ? codeOverride : _b, _c = _a.codeVerifier, codeVerifier = _c === void 0 ? '' : _c;
        var _d = this.config, clientId = _d.clientId, onInvalidGrant = _d.onInvalidGrant, redirectUrl = _d.redirectUrl;
        if (!codeVerifier) console.warn('No code verifier is being sent.');
        else if (!authorizationCode) console.warn('No authorization grant code is being passed.');
        var url = this.config.tokenUrl;
        var body = "grant_type=authorization_code&" + ("code=" + encodeURIComponent(authorizationCode || '') + "&") + ("redirect_uri=" + encodeURIComponent(redirectUrl) + "&") + ("client_id=" + encodeURIComponent(clientId) + "&") + ("code_verifier=" + codeVerifier);
        return fetch(url, {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function(res) {
            var jsonPromise = res.json().catch(function(_) {
                return {
                    error: 'invalid_json'
                };
            });
            if (!res.ok) return jsonPromise.then(function(_a) {
                var error = _a.error;
                switch(error){
                    case 'invalid_grant':
                        onInvalidGrant(function() {
                            return _this.fetchAuthorizationCode();
                        });
                        break;
                    default:
                        break;
                }
                return Promise.reject($6d6e60b6113ba0cb$var$toErrorClass(error));
            });
            return jsonPromise.then(function(json) {
                var access_token = json.access_token, expires_in = json.expires_in, refresh_token = json.refresh_token, scope = json.scope;
                var explicitlyExposedTokens = _this.config.explicitlyExposedTokens;
                var scopes = [];
                var tokensToExpose = {};
                _this.state.hasAuthCodeBeenExchangedForAccessToken = true;
                _this.authCodeForAccessTokenRequest = undefined;
                var accessToken = {
                    value: access_token,
                    expiry: new Date(Date.now() + parseInt(expires_in) * 1000).toString()
                };
                _this.state.accessToken = accessToken;
                if (refresh_token) {
                    var refreshToken = {
                        value: refresh_token
                    };
                    _this.state.refreshToken = refreshToken;
                }
                if (explicitlyExposedTokens) {
                    tokensToExpose = Object.fromEntries(explicitlyExposedTokens.map(function(tokenName) {
                        return [
                            tokenName,
                            json[tokenName]
                        ];
                    }).filter(function(_a) {
                        var _ = _a[0], tokenValue = _a[1];
                        return tokenValue !== undefined;
                    }));
                    _this.state.explicitlyExposedTokens = tokensToExpose;
                }
                if (scope) {
                    // Multiple scopes are passed and delimited by spaces,
                    // despite using the singular name "scope".
                    scopes = scope.split(' ');
                    _this.state.scopes = scopes;
                }
                localStorage.setItem(module.exports.LOCALSTORAGE_STATE, JSON.stringify(_this.state));
                var accessContext = {
                    token: accessToken,
                    scopes: scopes
                };
                if (explicitlyExposedTokens) accessContext.explicitlyExposedTokens = tokensToExpose;
                return accessContext;
            });
        });
    };
    OAuth2AuthCodePKCE.prototype.recoverState = function() {
        this.state = JSON.parse(localStorage.getItem(module.exports.LOCALSTORAGE_STATE) || '{}');
        return this;
    };
    OAuth2AuthCodePKCE.prototype.setState = function(state) {
        this.state = state;
        localStorage.setItem(module.exports.LOCALSTORAGE_STATE, JSON.stringify(state));
        return this;
    };
    /**
     * Implements *base64url-encode* (RFC 4648 § 5) without padding, which is NOT
     * the same as regular base64 encoding.
     */ OAuth2AuthCodePKCE.base64urlEncode = function(value) {
        var base64 = btoa(value);
        base64 = base64.replace(/\+/g, '-');
        base64 = base64.replace(/\//g, '_');
        base64 = base64.replace(/=/g, '');
        return base64;
    };
    /**
     * Extracts a query string parameter.
     */ OAuth2AuthCodePKCE.extractParamFromUrl = function(url, param) {
        var queryString = url.split('?');
        if (queryString.length < 2) return '';
        // Account for hash URLs that SPAs usually use.
        queryString = queryString[1].split('#');
        var parts = queryString[0].split('&').reduce(function(a, s) {
            return a.concat(s.split('='));
        }, []);
        if (parts.length < 2) return '';
        var paramIdx = parts.indexOf(param);
        return decodeURIComponent(paramIdx >= 0 ? parts[paramIdx + 1] : '');
    };
    /**
     * Converts the keys and values of an object to a url query string
     */ OAuth2AuthCodePKCE.objectToQueryString = function(dict) {
        return Object.entries(dict).map(function(_a) {
            var key = _a[0], val = _a[1];
            return key + "=" + encodeURIComponent(val);
        }).join('&');
    };
    /**
     * Generates a code_verifier and code_challenge, as specified in rfc7636.
     */ OAuth2AuthCodePKCE.generatePKCECodes = function() {
        var output = new Uint32Array(module.exports.RECOMMENDED_CODE_VERIFIER_LENGTH);
        crypto.getRandomValues(output);
        var codeVerifier = OAuth2AuthCodePKCE.base64urlEncode(Array.from(output).map(function(num) {
            return $6d6e60b6113ba0cb$var$PKCE_CHARSET[num % $6d6e60b6113ba0cb$var$PKCE_CHARSET.length];
        }).join(''));
        return crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier)).then(function(buffer) {
            var hash = new Uint8Array(buffer);
            var binary = '';
            var hashLength = hash.byteLength;
            for(var i = 0; i < hashLength; i++)binary += String.fromCharCode(hash[i]);
            return binary;
        }).then(OAuth2AuthCodePKCE.base64urlEncode).then(function(codeChallenge) {
            return {
                codeChallenge: codeChallenge,
                codeVerifier: codeVerifier
            };
        });
    };
    /**
     * Generates random state to be passed for anti-csrf.
     */ OAuth2AuthCodePKCE.generateRandomState = function(lengthOfState) {
        var output = new Uint32Array(lengthOfState);
        crypto.getRandomValues(output);
        return Array.from(output).map(function(num) {
            return $6d6e60b6113ba0cb$var$PKCE_CHARSET[num % $6d6e60b6113ba0cb$var$PKCE_CHARSET.length];
        }).join('');
    };
    return OAuth2AuthCodePKCE;
}();
module.exports.OAuth2AuthCodePKCE = $6d6e60b6113ba0cb$var$OAuth2AuthCodePKCE;

});


parcelRegister("3s9ko", function(module, exports) {

$parcel$export(module.exports, "CardDetailsManager", function () { return $fecfa23acca37a19$export$4d46b47a23076fb8; });

var $8GUrl = parcelRequire("8GUrl");

var $kpnq8 = parcelRequire("kpnq8");

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $fsofG = parcelRequire("fsofG");
const $fecfa23acca37a19$var$MOCKED_CARD_DETAILS = {
    panDisplay: "1234 5678 9012 3456",
    cvv: "123",
    expirationDate: new Date(2023, 11).toISOString()
};
class $fecfa23acca37a19$export$4d46b47a23076fb8 {
    constructor(cardService){
        this.cardService = cardService;
        this.cards = new (0, $fsofG.ObservableArray)([]);
        this.outstandings = new (0, $fsofG.ObservableArray)([]);
        this.publicKey = new (0, $3Ersk.Observable)(null);
        this.privateKey = new (0, $3Ersk.Observable)(null);
        this.onCardStatusWillChange = new (0, $kpnq8.Signal)();
        (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).ready;
    }
    async getSensitiveCardDetails(cardId, scaToken) {
        if (!this.publicKey.get() || !this.privateKey.get()) {
            const keyPair = (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).crypto_box_keypair();
            this.publicKey.set(keyPair.publicKey);
            this.privateKey.set(keyPair.privateKey);
        }
        const publicKey = this.publicKey.get();
        const privateKey = this.privateKey.get();
        if (publicKey && privateKey) try {
            const response = await this.cardService.getSensitiveCardDetails(cardId, (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).to_hex(publicKey), scaToken || "");
            let content;
            const decodedPan = response.encryptedPan ? (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).crypto_box_seal_open((0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).from_hex(response.encryptedPan), publicKey, privateKey) : null;
            const decodedCvv = response.encryptedCvv ? (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).crypto_box_seal_open((0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).from_hex(response.encryptedCvv), publicKey, privateKey) : null;
            try {
                content = response.content ? await (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).crypto_box_seal_open((0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).from_base64(response.content), publicKey, privateKey) : undefined;
            } catch (e) {
                (0, $6JVVB.logger).debug("CardManager", "Failed to decrypt card image", e);
            }
            return {
                panDisplay: decodedPan ? (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).to_string(decodedPan) : undefined,
                cvv: decodedCvv ? (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).to_string(decodedCvv) : undefined,
                base64Image: content ? (0, (/*@__PURE__*/$parcel$interopDefault($8GUrl))).to_base64(content) : response.content,
                expirationDate: response.expirationYear && response.expirationMonth ? new Date(response.expirationYear, Number(response.expirationMonth)).toISOString() : undefined
            };
        } catch (e) {
            if (e.response?.data?.error?.code === 500) return $fecfa23acca37a19$var$MOCKED_CARD_DETAILS;
            else {
                (0, $6JVVB.logger).debug("CardManager", "Failed to get sensitive card details", e);
                throw e;
            }
        }
        else throw new Error("Keys not generated");
    }
}

});
parcelRegister("8GUrl", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < a.length; _++)"function" == typeof t["_" + r[_]] && (e[r[_]] = a[_]);
                var n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < n.length; _++)"function" == typeof (c = t["_" + n[_].toLowerCase()]) && (e[n[_]] = c());
                var s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < s.length; _++){
                    var c;
                    "function" == typeof (c = t["_" + s[_].toLowerCase()]) && (e[s[_]] = t.UTF8ToString(c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), c = e.crypto_secretbox_easy(_, n, s), o = e.crypto_secretbox_open_easy(c, n, s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)r[t] = e.charCodeAt(t);
            return r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var r = 8192, t = Math.ceil(e.length / r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, n = 0; n < t; n++){
                var c = Array.prototype.slice.call(e, n * r + _, (n + 1) * r + _);
                if (0 != c.length) {
                    var o, h = c.length, p = 0;
                    do {
                        var y = c[--h];
                        y >= 240 ? (p = 4, o = !0) : y >= 224 ? (p = 3, o = !0) : y >= 192 ? (p = 2, o = !0) : y < 128 && (p = 1, o = !0);
                    }while (!o);
                    for(var i = p - (c.length - h), l = 0; l < i; l++)_--, c.pop();
                    a += s(c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var r, t, a, _ = "", n = 0; n < e.length; n++)a = 87 + (t = 15 & e[n]) + (t - 10 >> 8 & -39) << 8 | 87 + (r = e[n] >>> 4) + (r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], n = 0 | Math.floor(e.length / 3), c = e.length - 3 * n, o = 4 * n + (0 !== c ? 0 == (2 & r) ? 4 : 2 + (c >>> 1) : 0), p = new u(o + 1), y = d(e);
            return _.push(y), _.push(p.address), 0 === t._sodium_bin2base64(p.address, p.length, y, e.length, r) && b(_, "conversion failed"), p.length = o, a = s(p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), n = {}, h = 0; h < _.length; h++)n[_[h]] = y(e[_[h]], t);
                return n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < r.length; t++)if (r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var r = v(e.length);
            return t.HEAPU8.set(e, r), r;
        }
        function v(e) {
            var r = t._malloc(e);
            if (0 === r) throw {
                message: "_malloc() failed",
                length: e
            };
            return r;
        }
        function g(e) {
            if (e) for(var r = 0; r < e.length; r++)a = e[r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function w(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Y(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function M(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function I(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function G(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function X(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function D(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha256(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha512(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, s, c, 0, o, p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function le(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function ue(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), s = n.address;
            r.push(s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, s);
            var c = y({
                publicKey: a,
                privateKey: n,
                keyType: "curve25519"
            }, e);
            return g(r), c;
        }
        function de(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(s, "invalid sharedKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), p = h.address;
            _.push(p), t._crypto_box_curve25519xchacha20poly1305_seal(p, n, s, 0, c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(n, "invalid secretKey length"), i = d(a), n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, s, o, 0, h, i);
            var E = y(b, _);
            return g(n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Te(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_box_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_sealbytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_seal(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(n, "invalid privateKey length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_box_seal_open(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_uniform(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), s;
        }
        function Oe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function De(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function je(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ristretto255_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ristretto255_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), s;
        }
        function Qe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function ar(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "hash_length must be an unsigned integer");
            var s = d(r = x(n, r, "message")), c = r.length;
            n.push(s);
            var o = null, h = 0;
            null != a && (o = d(a = x(n, a, "key")), h = a.length, n.push(o));
            var p = new u(e |= 0), i = p.address;
            if (n.push(i), 0 == (0 | t._crypto_generichash(i, e, s, c, 0, o, h))) {
                var v = y(p, _);
                return g(n), v;
            }
            b(n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(s, "subkey_len must be an unsigned integer");
            var c = null, o = 0;
            null != r && (c = d(r = x(s, r, "key")), o = r.length, s.push(c));
            var h = null, p = 0;
            null != a && (a = x(s, a, "id"), p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== p && f(s, "invalid id length"), h = d(a), s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(s, "invalid ctx length"), i = d(_), s.push(i));
            var E = new u(0 | e), k = E.address;
            if (s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, c, o, h, i))) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var n = new u(r |= 0), s = n.address;
            if (_.push(s), 0 == (0 | t._crypto_generichash_final(e, s, r))) {
                var c = (t._free(e), y(n, a));
                return g(_), c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var n = null, s = 0;
            null != e && (n = d(e = x(_, e, "key")), s = e.length, _.push(n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(c, n, s, r))) {
                var o = c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            r.push(_), t._crypto_generichash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_generichash_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha256_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha256(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha512_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha512(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var c = [];
            l(s), m(c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "subkey_len must be an unsigned integer"), m(c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(c, "ctx must be a string"), a = n(a + "\0"), null != h && a.length - 1 !== h && f(c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            c.push(o), _ = x(c, _, "key");
            var p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(c, "invalid key length"), p = d(_), c.push(p);
            var v = new u(0 | e), b = v.address;
            c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, p);
            var E = y(v, s);
            return g(c), E;
        }
        function kr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            r.push(_), t._crypto_kdf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Sr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "clientPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid clientPublicKey length"), s = d(e), n.push(s), r = x(n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid clientSecretKey length"), o = d(r), n.push(o), a = x(n, a, "serverPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid serverPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Tr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_kx_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_kx_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_kx_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_kx_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "serverPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid serverPublicKey length"), s = d(e), n.push(s), r = x(n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid serverSecretKey length"), o = d(r), n.push(o), a = x(n, a, "clientPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid clientPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_onetimeauth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_onetimeauth_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(n, _))) {
                var s = n;
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            r.push(_), t._crypto_onetimeauth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_onetimeauth_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var n, s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== s && f(_, "invalid hash length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var c = [];
            l(s), m(c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "keyLength must be an unsigned integer");
            var o = d(r = x(c, r, "password")), h = r.length;
            c.push(o), a = x(c, a, "salt");
            var p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(c, "invalid salt length"), p = d(a), c.push(p), m(c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(c, "opsLimit must be an unsigned integer"), m(c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, p, _, 0, n))) {
                var k = y(v, s);
                return g(c), k;
            }
            b(c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\0"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Pr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var s = [];
            l(_), "string" != typeof e && f(s, "hashed_password must be a string"), e = n(e + "\0"), null != o && e.length - 1 !== o && f(s, "invalid hashed_password length");
            var c = d(e), o = e.length - 1;
            s.push(c), m(s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(s, "opsLimit must be an unsigned integer"), m(s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(c, r, 0, a));
            return g(s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\0"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var n, s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== s && f(_, "invalid privateKey length"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var n, s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid scalar length"), n = d(e), _.push(n), r = x(_, r, "element");
            var c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ristretto255(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, s, c, 0, o, p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Zr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretbox_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function $r(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_secretbox_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(s, "invalid key length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_secretbox_macbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "nonce");
            var h, p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== p && f(n, "invalid nonce length"), h = d(r), n.push(h), a = x(n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(n, "invalid key length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var n, s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== s && f(_, "invalid header length"), n = d(e), _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, n, c))) {
                var p = h;
                return g(_), p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var s = new u(52).address, c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(s, o, _))) {
                var h = {
                    state: s,
                    header: y(c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _t(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "cipher");
            var s, c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < c && f(n, "cipher is too short"), s = d(r), n.push(s);
            var h = null, p = 0;
            null != a && (h = d(a = x(n, a, "ad")), p = a.length, n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            n.push(b);
            var E, k = (E = v(1), n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, s, o, 0, h, p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(n), k;
        }
        function nt(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "state_address");
            var c = d(r = x(s, r, "message_chunk")), o = r.length;
            s.push(c);
            var h = null, p = 0;
            null != a && (h = d(a = x(s, a, "ad")), p = a.length, s.push(h)), m(s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, c, o, 0, h, p, 0, _))) {
                var E = y(i, n);
                return g(s), E;
            }
            b(s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            r.push(_), t._crypto_shorthash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash_siphashx24(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_sign_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign_detached(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, n = 0 | t._crypto_sign_publickeybytes();
            e.length !== n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_seedbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var n, s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== s && f(_, "invalid privateKey length"), n = d(r), _.push(n);
            var c = new u(0 | t._crypto_sign_bytes()), o = c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, n))) {
                var h = (t._free(e), y(c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "signature");
            var s, c = 0 | t._crypto_sign_bytes();
            r.length !== c && f(n, "invalid signature length"), s = d(r), n.push(s), a = x(n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(n, "invalid publicKey length"), o = d(a), n.push(o);
            var p = 0 == (0 | t._crypto_sign_final_verify(e, s, o));
            return g(n), p;
        }
        function bt(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "internal error");
        }
        function ft(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_sign_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_sign_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "ed25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var n, s = t._crypto_sign_bytes(), c = e.length;
            c < s && f(_, "signedMessage is too short"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var p = new u(c - t._crypto_sign_bytes() | 0), i = p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, n, c, 0, o))) {
                var v = y(p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_sign_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_sign_update(e, n, s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var n, s = 0 | t._crypto_sign_bytes();
            e.length !== s && f(_, "invalid signature length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "publicKey");
            var h, p = 0 | t._crypto_sign_publickeybytes();
            a.length !== p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(n, c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "outLength must be an unsigned integer"), r = x(n, r, "key");
            var s, c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== c && f(n, "invalid key length"), s = d(r), n.push(s), a = x(n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(n, "invalid nonce length"), o = d(a), n.push(o);
            var p = new u(0 | e), i = p.address;
            n.push(i), t._crypto_stream_chacha20(i, e, 0, o, s);
            var v = y(p, _);
            return g(n), v;
        }
        function Tt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Yt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_chacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Bt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Kt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Mt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function It(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), n = _.address;
            a.push(n), t._randombytes_buf(n, e);
            var s = y(_, r);
            return g(a), s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var n, s = 0 | t._randombytes_seedbytes();
            r.length !== s && f(_, "invalid seed length"), n = d(r), _.push(n);
            var c = new u(0 | e), o = c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, n);
            var h = y(c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var r = t._randombytes_random() >>> 0;
            return g([]), r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), n = 0; n < 6; n++)t.setValue(_ + 4 * n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var e = t._sodium_version_string(), r = t.UTF8ToString(e);
            return g([]), r;
        }
        return u.prototype.to_Uint8Array = function() {
            var e = new Uint8Array(this.length);
            return e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], n = new u(3 * (e = x(_, e, "input")).length / 4), s = d(e), c = v(4), o = v(4);
            return _.push(s), _.push(n.address), _.push(n.result_bin_len_p), _.push(n.b64_end_p), 0 !== t._sodium_base642bin(n.address, n.length, s, e.length, 0, c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - s !== e.length && b(_, "incomplete input"), n.length = t.getValue(c, "i32"), a = n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var r, a = [], _ = new u((e = x(a, e, "input")).length / 2), n = d(e), s = v(4);
            return a.push(n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, n, e.length, 0, 0, s) && b(a, "invalid input"), t.getValue(s, "i32") - n !== e.length && b(a, "incomplete input"), r = _.to_Uint8Array(), g(a), r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var r = 256, t = 0, a = e.length; t < a; t++)r >>= 8, r += e[t], e[t] = 255 & r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var r = 0, t = 0, a = e.length; t < a; t++)r |= e[t];
            return 0 === r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var r = 0, t = e.length; r < t; r++)e[r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], n = v(4), s = 1, c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(n), _.push(h.address);
            for(var p = h.address, y = h.address + o + r; p < y; p++)t.HEAPU8[p] = e[c], c += s = 1 & ~((65535 & ((o -= s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), n = v(4);
            return a.push(_), a.push(n), 0 !== t._sodium_unpad(n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("g61g2"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRegister("g61g2", function(module, exports) {
var $bb7e2ea50d670196$var$__dirname = "node_modules/libsodium/dist/modules";

var $j1eoE = parcelRequire("j1eoE");

var $b0kMB = parcelRequire("b0kMB");
var $bb7e2ea50d670196$require$Buffer = $b0kMB.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var I;
        void 0 === (I = A) && (I = {});
        var g = I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = I;
        return I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = false, f = "";
                    if (a) {
                        var c = (parcelRequire("80bNa")), e = (parcelRequire("80bNa"));
                        f = o ? e.dirname(f) + "/" : $bb7e2ea50d670196$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                            var I = g(A, !0);
                            return I.buffer || (I = new Uint8Array(I)), I;
                        }, !Q.thisProgram && $j1eoE.argv.length > 1 && $j1eoE.argv[1].replace(/\\/g, "/"), $j1eoE.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
                    } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.send(null), I.responseText;
                    }, o && (B = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
                    }));
                    Q.print;
                    var r, D = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var t, y = {
                        Memory: function(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function(A) {},
                        Instance: function(A, I) {
                            this.exports = function(A) {
                                for(var I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, E = I, o = C.length, a = I + (3 * o >> 2) - ("=" == C[o - 2]) - ("=" == C[o - 1]); i < o; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[E++] = g[C.charCodeAt(i)] << 2 | B >> 4, E < a && (A[E++] = B << 4 | Q >> 2), E < a && (A[E++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | hI(), B = g + A | 0;
                                        if (g < B && B < 65536) {
                                            var Q = new ArrayBuffer(c(B, 65536));
                                            new Int8Array(Q).set(E), E = new Int8Array(Q), new Int16Array(Q), o = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), f = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, I = a;
                                        }
                                        return g;
                                    };
                                    var E = new Int8Array(i), o = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), f = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), e = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), D = g.c, t = g.d, y = g.e, w = 102096, h = 0;
                                    function n(A, I) {
                                        var g, C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, kA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, yA = o = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, wA = o = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, o = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, X = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = o, MA = o = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, _ = o, oA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, kA = o = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, B = o = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, q = o, EA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, nA = o = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, j = o, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = (fA = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + _ | 0, l = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, o = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > l >>> 0 ? o + 1 | 0 : o) | 0, o = (QA = (f = l) >>> 0 > (l = l + QA | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, iA = tA = l + rA | 0, tA = o = tA >>> 0 < l >>> 0 ? o + 1 | 0 : o, l = DA(l ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), HA = o = h, o = o + 1013904242 | 0, QA = l, V = o = (l = l - 23791573 | 0) >>> 0 < 4271175723 ? o + 1 | 0 : o, fA = DA(l ^ aA, o ^ fA, 40), o = (o = tA) + (tA = h) | 0, aA = DA(QA ^ (w = aA = fA + iA | 0), HA ^ (n = w >>> 0 < fA >>> 0 ? o + 1 | 0 : o), 48), o = V + (x = h) | 0, S = o = (aA = l + (s = aA) | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, aA = o = DA(fA ^ (F = aA), tA ^ o, 1), V = l = h, tA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, HA = o = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, eA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, l = (fA = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, o = (pA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (JA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, o = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (l >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (iA = (f = l) >>> 0 > (l = l + eA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = l + tA | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, f = DA(l ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), D = DA(QA ^ (c = f - 2067093701 | 0), JA ^ (R = (K = l = h) - ((f >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), o = (m = h) + o | 0, o = (d = (H = l = D + eA | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) + V | 0, o = (H >>> 0 > (l = H + aA | 0) >>> 0 ? o + 1 | 0 : o) + j | 0, o = (QA = (e = l) >>> 0 > (l = l + EA | 0) >>> 0 ? o + 1 | 0 : o) + q | 0, v = q = l + g | 0, y = o = q >>> 0 < l >>> 0 ? o + 1 | 0 : o, k = aA, FA = V, V = l, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, l = o = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, JA = o = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, j = o, o = (GA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, o = Q + ((q = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (e = q + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = (j = e + j | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + l | 0, sA = e = j + aA | 0, e = o = e >>> 0 < j >>> 0 ? o + 1 | 0 : o, t = q, q = DA(j ^ (a[0 | (o = A - -64 | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24) ^ -1377402159, eA ^ (a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24) ^ 1359893119, 32), eA = o = h, o = o + 1779033703 | 0, j = q, J = o = (q = q - 205731576 | 0) >>> 0 < 4089235720 ? o + 1 | 0 : o, r = DA(t ^ (G = q), o ^ r, 40), o = (P = h) + e | 0, t = DA(j ^ (e = q = r + sA | 0), eA ^ (M = r >>> 0 > e >>> 0 ? o + 1 | 0 : o), 48), o = DA(t ^ V, (W = h) ^ iA, 32), O = q = h, L = o, C = o = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, eA = sA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, N = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, q = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (j = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, o = (_A = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (b = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, o = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (q >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, o = C + (V = (p = q) >>> 0 > (q = N + q | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (N = q + eA | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, V = DA(q ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, V ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), j = DA(j ^ (eA = V + 1595750129 | 0), (p = b) ^ (b = (U = q = h) - ((V >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), o = (IA = h) + o | 0, q = DA((N = q = j + N | 0) ^ V, U ^ (p = N >>> 0 < j >>> 0 ? o + 1 | 0 : o), 48), o = b + ($ = h) | 0, Y = o = (q = eA + (b = q) | 0) >>> 0 < eA >>> 0 ? o + 1 | 0 : o, o = O + o | 0, T = k ^ (V = L + (U = q) | 0), k = o = V >>> 0 < U >>> 0 ? o + 1 | 0 : o, eA = DA(T, o ^ FA, 40), o = (FA = h) + y | 0, q = DA(v = L ^ (y = q = eA + v | 0), O ^ (L = y >>> 0 < eA >>> 0 ? o + 1 | 0 : o), 48), o = k + (CA = h) | 0, O = o = (k = V + (v = q) | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, q = (u = DA(k ^ eA, FA ^ o, 1)) + (V = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, o = (hA = h) + (FA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, SA = q, z = q >>> 0 < V >>> 0 ? o + 1 | 0 : o, Z = wA, q = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, eA = o = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, j = (o = w) + (w = DA(U ^ j, Y ^ IA, 1)) | 0, o = (U = h) + n | 0, o = (w >>> 0 > j >>> 0 ? o + 1 | 0 : o) + eA | 0, o = (n = (n = j) >>> 0 > (j = q + j | 0) >>> 0 ? o + 1 | 0 : o) + Z | 0, T = Y = j + gA | 0, Y = o = Y >>> 0 < j >>> 0 ? o + 1 | 0 : o, H = DA(f ^ H, d ^ K, 48), d = o = DA(H ^ j, (K = h) ^ n, 32), o = J + W | 0, o = (IA = j = h) + (G = (j = t + G | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, J = o = (n = j) >>> 0 > (t = n + d | 0) >>> 0 ? o + 1 | 0 : o, w = DA(t ^ w, U ^ o, 40), o = (W = h) + Y | 0, o = (U = w >>> 0 > (Y = j = w + T | 0) >>> 0 ? o + 1 | 0 : o) + z | 0, o = (f = Y >>> 0 > (j = Y + SA | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, SA = z = j + oA | 0, z = o = z >>> 0 < j >>> 0 ? o + 1 | 0 : o, T = j, Z = f, j = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = DA(r ^ n, G ^ P, 1), o = (P = h) + p | 0, o = ((f = r + N | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) + j | 0, o = (n = (G = f) >>> 0 > (f = I + f | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, NA = G = f + oA | 0, G = o = G >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(f ^ s, n ^ x, 32), AA = f = h, s = o, n = f, o = K + R | 0, H = f = c + H | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + n | 0, p = f = f + s | 0, x = o = H >>> 0 > f >>> 0 ? o + 1 | 0 : o, n = DA(f ^ r, P ^ o, 40), o = (P = h) + G | 0, s = DA((f = n + NA | 0) ^ s, AA ^ (c = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(s ^ T, (NA = h) ^ Z, 32), AA = r = h, G = o, T = r, D = DA(D ^ H, N ^ m, 1), o = M + (H = h) | 0, o = ((r = e) >>> 0 > (e = e + D | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, o = (e = (r = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + FA | 0, Z = M = r + V | 0, M = o = M >>> 0 < r >>> 0 ? o + 1 | 0 : o, N = D, r = DA(r ^ b, e ^ $, 32), o = (b = h) + S | 0, F = DA(N ^ (e = D = r + F | 0), (S = r >>> 0 > e >>> 0 ? o + 1 | 0 : o) ^ H, 40), o = ($ = h) + M | 0, H = D = F + Z | 0, D = DA(r ^ D, b ^ (M = D >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = S + (i = h) | 0, S = D, b = o = (D = e + D | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + T | 0, o = (N = D) >>> 0 > (D = D + G | 0) >>> 0 ? o + 1 | 0 : o, T = D, D ^= u, u = o, r = DA(D, hA ^ o, 40), o = (hA = h) + z | 0, z = D = r + SA | 0, o = B + (Z = r >>> 0 > D >>> 0 ? o + 1 | 0 : o) | 0, SA = D = D + g | 0, K = o = D >>> 0 < g >>> 0 ? o + 1 | 0 : o, D = f, R = gA, m = wA, f = DA(d ^ Y, U ^ IA, 48), o = J + (IA = h) | 0, d = f, J = o = (e = t + f | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(e ^ w, W ^ o, 1), o = (t = h) + m | 0, o = ((w = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) + c | 0, o = _A + (D = (c = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, Y = w = c + iA | 0, w = o = w >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ S, D ^ i, 32), o = O + (U = h) | 0, S = c, k = o = (c = k + c | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, D = DA(f ^ c, o ^ t, 40), o = (o = w) + (w = h) | 0, t = f = D + Y | 0, f = DA(f ^ S, U ^ (Y = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = k + (W = h) | 0, U = f, O = o = (k = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(D ^ k, w ^ o, 1), o = (w = h) + K | 0, o = C + (D = (c = f + SA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, SA = S = c + sA | 0, S = o = S >>> 0 < sA >>> 0 ? o + 1 | 0 : o, K = f, R = w, o = x + NA | 0, o = (f = s + p | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = f, p = o, o = DA(f ^ n, P ^ o, 1), n = w = h, f = o, o = M + j | 0, o = ((H = I + H | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + w | 0, o = nA + (H = (w = f + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o) | 0, x = M = w + EA | 0, M = o = M >>> 0 < EA >>> 0 ? o + 1 | 0 : o, w = DA(w ^ v, H ^ CA, 32), o = J + (v = h) | 0, H = w, J = o = (J = e) >>> 0 > (e = e + w | 0) >>> 0 ? o + 1 | 0 : o, w = DA(f ^ e, o ^ n, 40), o = (P = h) + M | 0, n = f = w + x | 0, f = DA(M = f ^ H, v ^ (H = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = J + (CA = h) | 0, J = f, M = f = e + f | 0, v = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, x = c, m = D, f = DA(F ^ N, b ^ $, 1), o = (e = h) + _ | 0, o = L + ((c = f + cA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (D = (c = c + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, L = y = c + X | 0, y = o = y >>> 0 < c >>> 0 ? o + 1 | 0 : o, F = f, f = (c = DA(c ^ d, D ^ IA, 32)) + s | 0, o = (s = h) + p | 0, D = f, e = DA(f ^ F, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ e, 40), o = (IA = h) + y | 0, y = f = e + L | 0, N = DA(f ^ c, s ^ (L = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), c = DA(N ^ x, (o = m) ^ (m = h), 32), o = (x = h) + v | 0, s = f = c + M | 0, F = DA(f ^ K, (p = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ R, 40), o = (K = h) + S | 0, S = f = F + SA | 0, f = DA(f ^ c, x ^ (b = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = p + ($ = h) | 0, p = f, x = o = (c = s) >>> 0 > (s = s + f | 0) >>> 0 ? o + 1 | 0 : o, f = DA(s ^ F, K ^ o, 1), o = kA + (SA = h) | 0, K = f, NA = f = oA + f | 0, F = o = f >>> 0 < oA >>> 0 ? o + 1 | 0 : o, c = rA, f = DA(w ^ M, P ^ v, 1), o = Y + (w = h) | 0, o = ((M = t) >>> 0 > (t = f + t | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = (M = (c = c + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + HA | 0, R = t = c + tA | 0, Y = o = t >>> 0 < c >>> 0 ? o + 1 | 0 : o, v = f, t = DA(G ^ z, Z ^ AA, 48), o = DA(t ^ c, (P = h) ^ M, 32), AA = f = h, G = o, c = f, o = d + m | 0, o = (f = D + N | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = f, d = o, o = o + c | 0, M = f = f + G | 0, N = o = D >>> 0 > f >>> 0 ? o + 1 | 0 : o, c = DA(f ^ v, o ^ w, 40), o = (o = Y) + (Y = h) | 0, v = f = c + R | 0, z = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + F | 0, Z = o = (w = f + NA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, F = o, f = DA(e ^ D, d ^ IA, 1), o = l + (e = h) | 0, o = H + ((D = f + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = eA + (n = (D = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, R = H = D + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, d = f, o = DA(D ^ U, n ^ W, 32), m = f = h, D = o, n = f, o = P + u | 0, U = f = t + T | 0, u = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + n | 0, o = (t = f + D | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = t ^ d, d = o, n = DA(f, o ^ e, 40), o = (W = h) + H | 0, e = f = n + R | 0, T = DA(f ^ D, m ^ (H = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(T ^ w, (IA = h) ^ F, 32), NA = f = h, R = o, F = f, f = DA(r ^ U, u ^ hA, 1), o = L + (r = h) | 0, o = GA + ((D = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (D = D + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) + pA | 0, U = L = D + fA | 0, L = o = L >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(D ^ J, y ^ CA, 32), o = O + (u = h) | 0, J = D, y = r, r = o = (D = k + D | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ D, y ^ o, 40), o = (CA = h) + L | 0, k = f = y + U | 0, f = DA(U = f ^ J, u ^ (J = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = r + (P = h) | 0, r = f, L = f = D + f | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + F | 0, O = o = (F = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, D = DA(F ^ K, SA ^ o, 40), o = Z + (u = h) | 0, o = ((f = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + wA | 0, w = f, Z = f = f + gA | 0, K = o = w >>> 0 > f >>> 0 ? o + 1 | 0 : o, m = BA, w = DA(G ^ v, z ^ AA, 48), o = (hA = h) + N | 0, G = f = w + M | 0, o = DA(f ^ c, (M = f >>> 0 < w >>> 0 ? o + 1 | 0 : o) ^ Y, 1), Y = c = h, f = o, o = H + B | 0, o = ((e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = (e = (c = f + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + m | 0, N = H = c + X | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = DA(c ^ r, e ^ P, 32), o = x + (v = h) | 0, s = o = (r = c + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ r, o ^ Y, 40), o = (z = h) + H | 0, H = f = e + N | 0, c = DA(f ^ c, v ^ (Y = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (N = h) | 0, v = o = (s = c + r | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, f = DA(e ^ s, z ^ o, 1), o = (z = h) + K | 0, o = FA + ((r = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + _ | 0, SA = _ = r + cA | 0, _ = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = f, m = r, P = e, r = rA, f = DA(y ^ L, U ^ CA, 1), o = b + (y = h) | 0, o = ((e = S) >>> 0 > (S = f + S | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = pA + (e = (r = r + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o) | 0, b = S = r + fA | 0, L = o = S >>> 0 < fA >>> 0 ? o + 1 | 0 : o, S = f, e = o = DA(r ^ w, e ^ hA, 32), o = d + IA | 0, o = (U = f = h) + (t = (f = t + T | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, d = o = (w = f + e | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = DA(w ^ S, o ^ y, 40), o = (IA = h) + L | 0, L = DA(b = (r = S + b | 0) ^ e, U ^ (e = r >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = DA(L ^ m, (CA = h) ^ P, 32), hA = y = h, b = o, U = y, f = DA(f ^ n, t ^ W, 1), o = eA + (y = h) | 0, o = J + ((t = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = GA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = n = t + QA | 0, n = o = n >>> 0 < QA >>> 0 ? o + 1 | 0 : o, J = f, T = y, t = DA(t ^ p, k ^ $, 32), o = (p = h) + M | 0, y = f = t + G | 0, k = DA(f ^ J, (G = f >>> 0 < t >>> 0 ? o + 1 | 0 : o) ^ T, 40), o = (W = h) + n | 0, J = f = k + m | 0, f = DA(f ^ t, p ^ (M = f >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = G + (m = h) | 0, n = f, G = f = y + f | 0, p = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = o + U | 0, U = f = f + b | 0, t = z, z = o = G >>> 0 > f >>> 0 ? o + 1 | 0 : o, t = DA(f ^ x, t ^ o, 40), o = (o = _) + (_ = h) | 0, T = f = t + SA | 0, x = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = e, f = DA(R ^ Z, K ^ NA, 48), o = O + ($ = h) | 0, O = f, e = (f = F + f | 0) ^ D, D = o = f >>> 0 < F >>> 0 ? o + 1 | 0 : o, e = DA(e, o ^ u, 1), o = (u = h) + y | 0, o = C + ((r = e + r | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + l | 0, Z = F = r + aA | 0, F = o = F >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = DA(r ^ n, y ^ m, 32), o = v + (K = h) | 0, v = r, s = o = (y = s + r | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, u ^ o, 40), o = (o = F) + (F = h) | 0, n = r = e + Z | 0, r = DA(R = r ^ v, K ^ (v = r >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (SA = h) | 0, u = r, Z = o = (s = y + r | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, r = DA(e ^ s, F ^ o, 1), o = (F = h) + x | 0, o = B + ((e = r + T | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = j + (y = (e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, NA = K = I + e | 0, K = o = K >>> 0 < I >>> 0 ? o + 1 | 0 : o, R = r, m = F, F = e, P = y, r = DA(k ^ G, p ^ W, 1), o = (y = h) + Y | 0, o = nA + ((e = r + H | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (k = (e = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + j | 0, Y = H = I + e | 0, H = o = H >>> 0 < e >>> 0 ? o + 1 | 0 : o, G = r, e = o = DA(e ^ O, k ^ $, 32), k = r = h, o = d + CA | 0, d = o = (r = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + k | 0, o = (w = r) >>> 0 > (r = r + e | 0) >>> 0 ? o + 1 | 0 : o, L = r, r ^= G, G = o, y = DA(r, o ^ y, 40), o = (W = h) + H | 0, k = DA(H = (r = y + Y | 0) ^ e, k ^ (e = r >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(k ^ F, (o = P) ^ (P = h), 32), $ = F = h, H = o, Y = D, D = c, o = DA(w ^ S, d ^ IA, 1), p = c = h, w = o, o = M + HA | 0, o = ((S = J + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + c | 0, S = o = (c = w + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ N, 32), o = (o = Y) + (Y = h) | 0, w = DA((f = D + f | 0) ^ w, p ^ (d = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = S + (IA = h) | 0, J = w, o = _A + ((M = c) >>> 0 > (c = c + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, M = o = (w = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ w, Y ^ o, 48), o = d + (CA = h) | 0, N = f, D = c, d = f = f + c | 0, Y = o = N >>> 0 > f >>> 0 ? o + 1 | 0 : o, o = o + F | 0, N = o = (F = f + H | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = (S = DA(F ^ R, o ^ m, 40)) + NA | 0, o = (NA = h) + K | 0, p = f, O = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ T, x ^ hA, 48), o = (b = h) + z | 0, U = c = f + U | 0, R = _, _ = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(c ^ t, R ^ o, 1), T = c = h, t = o, o = e + C | 0, o = ((r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + c | 0, o = FA + (r = (c = r + t | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, x = e = c + V | 0, e = o = e >>> 0 < V >>> 0 ? o + 1 | 0 : o, c = DA(c ^ D, r ^ CA, 32), o = Z + (K = h) | 0, z = c, c = (D = s + c | 0) ^ t, t = o = D >>> 0 < s >>> 0 ? o + 1 | 0 : o, r = DA(c, T ^ o, 40), o = (o = e) + (e = h) | 0, T = c = r + x | 0, c = DA(s = c ^ z, K ^ (z = c >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = t + (CA = h) | 0, Z = c, D = o = (c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = DA(c ^ r, e ^ o, 1), o = (s = h) + O | 0, o = kA + ((e = r + p | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (t = (e = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + BA | 0, AA = x = e + X | 0, x = o = x >>> 0 < e >>> 0 ? o + 1 | 0 : o, K = r, R = e, m = t, r = DA(J ^ d, Y ^ IA, 1), o = (Y = h) + wA | 0, o = v + (r >>> 0 > (e = r + gA | 0) >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, o = DA(f ^ e, o ^ b, 32), b = f = h, n = o, o = G + P | 0, o = (f = k + L | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, k = f, d = o, o = b + o | 0, G = f = f + n | 0, J = o = k >>> 0 > f >>> 0 ? o + 1 | 0 : o, f = DA(f ^ r, Y ^ o, 40), o = t + (P = h) | 0, L = f, o = eA + ((f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (f = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, Y = f, f ^= n, n = o, t = DA(f, b ^ o, 48), o = DA(t ^ R, (o = m) ^ (m = h), 32), IA = f = h, b = o, v = f, f = DA(y ^ k, d ^ W, 1), o = HA + (e = h) | 0, o = M + ((r = f + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + l | 0, M = k = r + aA | 0, k = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, w = f, d = e, f = (r = DA(r ^ u, y ^ SA, 32)) + U | 0, o = (U = h) + _ | 0, e = f, y = DA(y = f ^ w, (w = f >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = (W = h) + k | 0, k = f = y + M | 0, r = DA(f ^ r, U ^ (_ = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (d = h) | 0, M = f = r + e | 0, U = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + v | 0, v = o = (w = f + b | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(w ^ K, o ^ s, 40), o = (u = h) + x | 0, x = f = e + AA | 0, K = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, f = c, s = D, D = r, c = DA(H ^ p, O ^ $, 48), o = N + (AA = h) | 0, H = c, F = o = (r = F + c | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, o = DA(r ^ S, NA ^ o, 1), N = c = h, S = o, o = n + MA | 0, o = ((n = Y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + c | 0, n = o = (c = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ d, 32), o = (Y = h) + s | 0, S = DA((f = D + f | 0) ^ S, N ^ (s = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = n + (p = h) | 0, o = GA + ((n = c) >>> 0 > (c = c + S | 0) >>> 0 ? o + 1 | 0 : o) | 0, d = o = (n = c + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ n, Y ^ o, 48), o = s + ($ = h) | 0, Y = c, N = o = (s = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(s ^ S, p ^ o, 1), o = (S = h) + K | 0, o = nA + ((c = f + x | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = kA + (D = (c = c + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, hA = p = c + oA | 0, p = o = p >>> 0 < oA >>> 0 ? o + 1 | 0 : o, O = f, R = c, f = DA(y ^ M, U ^ W, 1), o = (y = h) + z | 0, o = pA + ((c = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = _A + (M = (c = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, T = U = c + iA | 0, U = o = U >>> 0 < iA >>> 0 ? o + 1 | 0 : o, z = f, o = DA(c ^ H, M ^ AA, 32), AA = f = h, c = o, o = J + m | 0, G = f = t + G | 0, H = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = AA + o | 0, J = o = (t = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(t ^ z, o ^ y, 40), o = (m = h) + U | 0, M = f = y + T | 0, z = DA(f ^ c, AA ^ (U = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(z ^ R, (AA = h) ^ D, 32), W = f = h, T = o, D = f, c = rA, f = DA(G ^ L, H ^ P, 1), o = _ + (H = h) | 0, o = ((G = k) >>> 0 > (k = f + k | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = nA + (k = (c = c + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, G = _ = c + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ Z, k ^ CA, 32), o = F + (L = h) | 0, F = c, o = (c = r + c | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = H, H = o, r = DA(f ^ c, r ^ o, 40), o = (P = h) + _ | 0, k = f = r + G | 0, f = DA(f ^ F, L ^ (_ = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = H + (R = h) | 0, H = f, G = f = c + f | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + D | 0, o = (F = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = F ^ O, O = o, S = DA(f, o ^ S, 40), o = (CA = h) + p | 0, p = f = S + hA | 0, Z = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ x, K ^ IA, 48), o = v + (IA = h) | 0, b = f, o = (f = w + f | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, v = o, o = DA(f ^ e, o ^ u, 1), u = f = h, D = o, o = U + FA | 0, o = ((c = M + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + f | 0, o = GA + (c = (f = c + D | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, M = e = f + QA | 0, e = o = e >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(f ^ H, c ^ R, 32), o = N + (U = h) | 0, H = f, s = o = (c = s + f | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, u ^ o, 40), o = (u = h) + e | 0, M = f = D + M | 0, f = DA(e = f ^ H, U ^ (H = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = s + (hA = h) | 0, s = f, N = o = (e = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(e ^ D, u ^ o, 1), o = (U = h) + Z | 0, o = HA + ((c = f + p | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (D = (c = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + wA | 0, SA = u = c + gA | 0, u = o = u >>> 0 < c >>> 0 ? o + 1 | 0 : o, x = f, K = c, R = D, f = DA(r ^ G, P ^ L, 1), o = pA + (D = h) | 0, o = d + ((c = f + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = MA + (r = (c = c + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, L = n = c + cA | 0, n = o = n >>> 0 < cA >>> 0 ? o + 1 | 0 : o, d = f, G = D, o = DA(c ^ b, r ^ IA, 32), b = f = h, r = o, c = f, o = J + AA | 0, o = (f = t + z | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, t = f, J = o, o = o + c | 0, o = (D = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = D ^ d, d = o, f = DA(f, o ^ G, 40), o = (o = n) + (n = h) | 0, G = c = f + L | 0, L = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, b = DA(c ^ r, b ^ o, 48), o = DA(b ^ K, (o = R) ^ (R = h), 32), P = c = h, z = o, c = DA(t ^ y, J ^ m, 1), o = (t = h) + yA | 0, o = _ + ((r = c + rA | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, o = C + (y = (r = r + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = k = r + sA | 0, k = o = k >>> 0 < sA >>> 0 ? o + 1 | 0 : o, _ = c, J = t, r = DA(r ^ Y, y ^ $, 32), o = (Y = h) + v | 0, t = c = r + w | 0, c = (y = DA(c ^ _, (w = c >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ J, 40)) + m | 0, o = (m = h) + k | 0, _ = c, c = DA(c ^ r, Y ^ (J = c >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (AA = h) | 0, Y = c, v = c = t + c | 0, K = o = c >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = P + o | 0, o = (r = c + z | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = U, U = o, t = DA(r ^ x, c ^ o, 40), o = (IA = h) + u | 0, k = c = t + SA | 0, o = DA(c ^ z, P ^ (u = c >>> 0 < t >>> 0 ? o + 1 | 0 : o), 48), P = c = h, z = o, c = f, o = d + R | 0, d = f = D + b | 0, b = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = DA(f ^ c, o ^ n, 1), D = c = h, f = o, o = J + B | 0, o = ((w = _ + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = eA + (w = (c = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, R = n = c + q | 0, n = o = n >>> 0 < q >>> 0 ? o + 1 | 0 : o, _ = f, J = D, f = DA(p ^ T, Z ^ W, 48), o = O + (W = h) | 0, p = f, o = (f = F + f | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, F = f, c = DA(c ^ s, w ^ hA, 32), O = o, o = o + (T = h) | 0, D = f = c + f | 0, w = DA(f ^ _, (s = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ J, 40), o = (Z = h) + n | 0, n = f = w + R | 0, f = DA(f ^ c, T ^ (_ = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, J = f, T = o = (s = D + f | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, f = DA(w ^ s, Z ^ o, 1), o = GA + (R = h) | 0, Z = f, hA = f = QA + f | 0, D = o = f >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(S ^ F, O ^ CA, 1), o = (w = h) + L | 0, o = _A + ((c = f + G | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (F = (c = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, O = S = c + X | 0, S = o = S >>> 0 < X >>> 0 ? o + 1 | 0 : o, G = w, c = DA(c ^ Y, F ^ AA, 32), o = N + (AA = h) | 0, L = c, o = (w = e + c | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = G, G = o, F = DA(f ^ w, e ^ o, 40), o = (CA = h) + S | 0, Y = f = F + O | 0, o = (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) + D | 0, S = o = (D = f + hA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, O = o = DA(D ^ z, o ^ P, 32), x = f = h, f = DA(y ^ v, K ^ m, 1), o = (e = h) + H | 0, o = j + ((c = f + M | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (c = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + l | 0, K = H = c + aA | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, M = f, v = e, c = DA(c ^ p, y ^ W, 32), o = (p = h) + b | 0, e = f = c + d | 0, f = (y = DA(f ^ M, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ v, 40)) + K | 0, o = (K = h) + H | 0, H = f, f = DA(f ^ c, p ^ (M = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = d + (W = h) | 0, d = f, p = o = (f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + x | 0, b = o = (e = f) >>> 0 > (f = f + O | 0) >>> 0 ? o + 1 | 0 : o, c = DA(f ^ Z, R ^ o, 40), o = S + (R = h) | 0, v = c, o = B + ((c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, Z = c = c + g | 0, D = c ^ O, O = o = c >>> 0 < g >>> 0 ? o + 1 | 0 : o, c = DA(D, x ^ o, 48), o = b + (x = h) | 0, b = o = (S = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = o = DA(S ^ v, R ^ o, 1), v = D = h, D = DA(e ^ y, p ^ K, 1), o = _ + (y = h) | 0, o = _A + ((e = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, o = nA + (n = (e = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, R = _ = e + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, p = D, K = y, o = U + P | 0, o = (D = r + z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, U = D, L = DA(Y ^ L, N ^ AA, 48), y = DA(e ^ L, n ^ (AA = h), 32), Y = o, o = o + (hA = h) | 0, n = D = y + D | 0, D = DA(D ^ p, (N = D >>> 0 < y >>> 0 ? o + 1 | 0 : o) ^ K, 40), o = (p = h) + _ | 0, K = o = (r = D + R | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + v | 0, o = C + ((z = r) >>> 0 > (r = f + r | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + yA | 0, SA = _ = r + rA | 0, R = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, m = f, P = r, o = DA(t ^ U, Y ^ IA, 1), t = r = h, f = o, o = M + pA | 0, o = ((_ = H + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) + r | 0, o = eA + (_ = (r = f + _ | 0) >>> 0 < _ >>> 0 ? o + 1 | 0 : o) | 0, Y = H = r + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, M = f, o = DA(r ^ J, _ ^ $, 32), U = f = h, r = o, _ = f, o = G + AA | 0, G = f = w + L | 0, J = o = f >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + _ | 0, o = (w = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o;
                                        f = w ^ M, M = o, _ = DA(f, o ^ t, 40), o = (AA = h) + H | 0, L = DA(H = (f = _ + Y | 0) ^ r, U ^ (r = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 48), o = DA(o = L ^ P, (P = h) ^ e, 32), IA = e = h, Y = o, H = e, e = DA(F ^ G, J ^ CA, 1), o = BA + (F = h) | 0, o = u + ((t = e + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, J = G = t + tA | 0, G = o = G >>> 0 < tA >>> 0 ? o + 1 | 0 : o, t = DA(t ^ d, k ^ W, 32), o = T + (U = h) | 0, d = t, s = o = (t = s + t | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, k = DA(e ^ t, o ^ F, 40), o = (W = h) + G | 0, F = e = k + J | 0, e = DA(G = e ^ d, U ^ (d = e >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, G = e, J = e = t + e | 0, U = o = e >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + H | 0, o = (t = e + Y | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = v, v = o, s = DA(t ^ m, e ^ o, 40), o = (u = h) + R | 0, H = e = s + SA | 0, e = DA(R = e ^ Y, IA ^ (Y = e >>> 0 < s >>> 0 ? o + 1 | 0 : o), 48), o = v + (IA = h) | 0, v = e, t = o = (e = t + e | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, u = o = DA(e ^ s, u ^ o, 1), CA = o, T = s = h, s = r, r = D, D = DA(y ^ z, K ^ hA, 48), o = N + (hA = h) | 0, N = D, o = (D = n + D | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = f, f = r ^ D, r = o, f = DA(f, o ^ p, 1), o = (p = h) + s | 0, o = MA + (f >>> 0 > (y = n + f | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = wA + (n = (y = y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = s = y + gA | 0, s = o = s >>> 0 < gA >>> 0 ? o + 1 | 0 : o, y = DA(y ^ G, n ^ $, 32), o = b + (K = h) | 0, G = o = (n = y + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(f ^ n, p ^ o, 40), o = ($ = h) + s | 0, p = f = S + z | 0, y = DA(f ^ y, K ^ (b = f >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = G + (z = h) | 0, K = f = y + n | 0, G = f, R = o = f >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = D, s = r, o = M + P | 0, o = (f = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, f ^= _, _ = o, o = DA(f, AA ^ o, 1), m = f = h, M = o, r = o, o = d + l | 0, o = ((D = F + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) + f | 0, F = o = (f = D) >>> 0 > (D = r + D | 0) >>> 0 ? o + 1 | 0 : o, r = DA(c ^ D, o ^ x, 32), o = (o = s) + (s = h) | 0, L = f = r + n | 0, c = DA(c = f ^ M, m ^ (M = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 40), o = F + (x = h) | 0, o = FA + ((f = c + D | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, m = o = (n = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, s = DA(r ^ n, s ^ o, 48), SA = o = h, f = DA(k ^ J, U ^ W, 1), o = (r = h) + O | 0, o = kA + ((D = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = j + (k = (D = D + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, O = F = I + D | 0, J = o = F >>> 0 < I >>> 0 ? o + 1 | 0 : o, U = f, F = DA(D ^ N, k ^ hA, 32), o = (W = h) + _ | 0, _ = f = F + w | 0, D = DA(f ^ U, (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ r, 40), o = (o = J) + (J = h) | 0, U = f = D + O | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = o, o = j + T | 0, o = ((k = I + u | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + r | 0, d = o = (r = f + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, SA ^ o, 32), o = (u = h) + R | 0, w = DA((k = f + G | 0) ^ CA, (o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ T, 40), T = o, o = wA + (G = h) | 0, o = d + ((Z = w + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = r + Z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = u, u = o, r = DA(f ^ d, r ^ o, 48), o = (o = T) + (T = h) | 0, f = w ^ (k = r + k | 0), w = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, Z = o = DA(f, o ^ G, 1), CA = o, P = f = h, G = e, AA = t, e = D, D = DA(F ^ U, O ^ W, 48), o = N + (U = h) | 0, F = f = D + _ | 0, _ = o = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ J, 1), o = (O = h) + MA | 0, o = m + ((f = e + cA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, n = o = (t = f + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, f = DA(t ^ y, o ^ z, 32), o = (J = h) + AA | 0, G = y = f + G | 0, N = o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, o ^ O, 40), o = nA + (hA = h) | 0, O = e, o = n + ((e = EA + e | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(f ^ e, o ^ J, 48), o = (o = N) + (N = h) | 0, z = f = y + G | 0, J = f, m = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = M + SA | 0, G = (f = s + L | 0) ^ c, c = o = f >>> 0 < s >>> 0 ? o + 1 | 0 : o, o = DA(G, o ^ x, 1), x = n = h, G = o, o = b + eA | 0, o = ((s = p + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + n | 0, M = o = (M = s) >>> 0 > (s = s + G | 0) >>> 0 ? o + 1 | 0 : o, L = n = DA(s ^ v, IA ^ o, 32), p = o = h, o = o + _ | 0, b = n = n + F | 0, v = o = L >>> 0 > n >>> 0 ? o + 1 | 0 : o, n = DA(n ^ G, x ^ o, 40), o = yA + (x = h) | 0, o = M + ((F = n + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = o = (G = s) >>> 0 > (s = s + F | 0) >>> 0 ? o + 1 | 0 : o, G = DA(s ^ L, o ^ p, 48), IA = o = h, _ = o, S = DA(S ^ K, R ^ $, 1), M = o = h, L = D, o = o + l | 0, o = Y + ((D = S + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (D = D + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = D ^ L, L = o, H = DA(H, o ^ U, 32), o = ($ = h) + c | 0, Y = f = H + f | 0, c = DA(f ^ S, (c = M) ^ (M = f >>> 0 < H >>> 0 ? o + 1 | 0 : o), 40), o = kA + (p = h) | 0, o = L + ((f = c + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, L = f = f + D | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + _A | 0, o = ((S = Z + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) + D | 0, Z = o = (D = f + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(D ^ G, o ^ _, 32), o = (K = h) + m | 0, _ = DA((S = f + J | 0) ^ CA, (o = S >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = J = h, P = o, o = J + HA | 0, o = Z + ((J = _ + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, Z = o = (J = D + J | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(f ^ J, o ^ K, 48), o = (K = h) + P | 0, f = (S = D + S | 0) ^ _, _ = o = S >>> 0 < D >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = k, W = y, y = c, c = DA(H ^ L, U ^ $, 48), o = (H = h) + M | 0, M = f = c + Y | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, o ^ p, 1), o = (p = h) + GA | 0, o = ((f = y + QA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) + F | 0, s = o = (k = f + s | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(k ^ W, o ^ N, 32), o = (F = h) + w | 0, Y = w = f + AA | 0, N = o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = C + (W = h) | 0, p = y, o = s + ((y = sA + y | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, U = o = (w = y + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ w, o ^ F, 48), o = (o = N) + (N = h) | 0, Y = f = y + Y | 0, AA = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, s = r, k = e, o = v + IA | 0, r = o = (f = G + b | 0) >>> 0 < G >>> 0 ? o + 1 | 0 : o, e = DA(f ^ n, o ^ x, 1), o = (n = h) + BA | 0, o = ((F = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + t | 0, t = DA(s ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ T, 32), F = o, G = e, o = (s = h) + L | 0, o = (e = t + M | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ n, 40), o = B + (L = h) | 0, o = ((n = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + F | 0, b = o = (F = n) >>> 0 > (n = n + k | 0) >>> 0 ? o + 1 | 0 : o, s = DA(t ^ n, o ^ s, 48), IA = o = h, k = o, t = DA(z ^ O, m ^ hA, 1), v = o = h, O = r, o = o + FA | 0, o = u + ((r = t + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, F = H, H = o = (r = r + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, F = DA(c ^ r, F ^ o, 32), o = ($ = h) + O | 0, d = f = F + f | 0, c = DA(f ^ t, (c = v) ^ (v = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 40), o = pA + (O = h) | 0, o = H + ((f = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, u = f = f + r | 0, z = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + eA | 0, o = ((t = q + R | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, o ^ k, 32), o = (T = h) + AA | 0, k = DA((t = f + Y | 0) ^ R, (o = t >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = l + (x = h) | 0, o = H + ((m = k + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + m | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = T, T = o, r = DA(f ^ H, r ^ o, 48), o = (o = R) + (R = h) | 0, f = (t = r + t | 0) ^ k, k = o = t >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), m = f = h, P = y, y = c, c = DA(F ^ u, z ^ $, 48), o = (o = v) + (v = h) | 0, d = f = c + d | 0, F = O, O = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, F ^ o, 1), o = (u = h) + HA | 0, o = b + ((f = y + tA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, F = n, n = f + n | 0, f = N, N = o = F >>> 0 > n >>> 0 ? o + 1 | 0 : o, f = DA(n ^ P, f ^ o, 32), o = (o = _) + (_ = h) | 0, b = o = (F = f + S | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = F, y = DA(y ^ F, o ^ u, 40), o = FA + ($ = h) | 0, u = y, o = N + ((y = V + y | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, N = o = (F = y + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, y = DA(f ^ F, o ^ _, 48), o = (o = b) + (b = h) | 0, z = f = y + S | 0, P = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, S = D, o = G + IA | 0, D = o = (f = s + M | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = wA + (s = h) | 0, o = U + ((n = e + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, G = (n = w + n | 0) ^ S, S = o = n >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = DA(G, o ^ K, 32), _ = o = h, G = e, o = o + O | 0, o = (e = w + d | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ s, 40), o = B + (L = h) | 0, o = S + ((s = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, U = o = (s = n + s | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, S = DA(w ^ s, o ^ _, 48), IA = o = h, n = o, w = DA(p ^ Y, W ^ AA, 1), d = o = h, Y = D, o = o + C | 0, o = Z + ((D = w + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, J = o = (D = D + J | 0) >>> 0 < J >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ v, 32), o = (CA = h) + Y | 0, Y = f = _ + f | 0, c = DA(f ^ w, (p = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = j + (v = h) | 0, o = J + ((f = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, J = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = m + kA | 0, o = ((w = x + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + P | 0, n = DA((w = f + z | 0) ^ x, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), K = o, o = MA + (x = h) | 0, o = d + ((m = n + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + m | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = K) + (K = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), hA = o, m = f = h, AA = t, W = y, t = c, c = DA(_ ^ J, O ^ CA, 48), o = (_ = h) + p | 0, J = f = c + Y | 0, Y = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ v, 1), o = (v = h) + yA | 0, o = U + ((f = t + rA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (p = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = GA + (CA = h) | 0, U = t, o = s + ((t = QA + t | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = p, p = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = G + IA | 0, r = o = (f = S + M | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = (S = h) + pA | 0, o = N + ((k = e + fA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, y = DA(y ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = F = h, F = o, M = e, o = G + Y | 0, o = (e = y + J | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, J = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = nA + (L = h) | 0, o = ((S = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + F | 0, N = G, G = o = (F = k + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, P ^ $, 1), Y = o = h, N = r, o = o + BA | 0, o = T + ((r = y + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + N | 0, N = f = _ + f | 0, c = DA(f ^ y, (c = Y) ^ (Y = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = _A + (u = h) | 0, o = H + ((f = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = m + B | 0, o = ((y = x + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ hA, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), m = o, o = HA + (R = h) | 0, o = H + ((P = k + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + Y | 0, Y = f = c + N | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + GA | 0, o = G + ((f = t + QA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = BA + ($ = h) | 0, u = t, o = F + ((t = X + t | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + J | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = _A + (S = h) | 0, o = p + ((n = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ K, 32), J = o = h, M = e, o = o + N | 0, o = (e = w + Y | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = kA + (Y = h) | 0, o = s + ((S = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + j | 0, o = Z + ((D = I + w | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = FA + (U = h) | 0, o = d + ((f = c + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + wA | 0, o = ((w = R + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ R, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = C + (K = h) | 0, o = d + ((P = n + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + eA | 0, o = J + ((f = t + q | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = pA + (CA = h) | 0, U = t, o = s + ((t = fA + t | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + nA | 0, o = G + ((k = e + EA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = yA + (Y = h) | 0, o = F + ((S = e + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + l | 0, o = x + ((r = y + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (u = h) | 0, o = H + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + C | 0, o = ((y = K + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = _A + (K = h) | 0, o = H + ((P = k + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + l | 0, o = G + ((f = t + aA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = yA + ($ = h) | 0, u = t, o = F + ((t = rA + t | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = nA + (S = h) | 0, o = J + ((n = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = pA + (Y = h) | 0, o = s + ((S = e + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + BA | 0, o = Z + ((D = w + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (U = h) | 0, o = d + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + FA | 0, o = ((w = K + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = j + (K = h) | 0, o = d + ((P = I + n | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + kA | 0, o = J + ((f = t + oA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = B + (CA = h) | 0, U = t, o = s + ((t = g + t | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + wA | 0, o = G + ((k = e + gA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = GA + (Y = h) | 0, o = F + ((S = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + HA | 0, o = x + ((r = y + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = eA + (u = h) | 0, o = H + ((f = c + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + MA | 0, o = ((y = K + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = yA + (K = h) | 0, o = H + ((P = k + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + _A | 0, o = G + ((f = t + iA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = C + ($ = h) | 0, u = t, o = F + ((t = sA + t | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = GA + (S = h) | 0, o = J + ((n = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = l + (Y = h) | 0, o = s + ((S = e + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + pA | 0, o = Z + ((D = w + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = HA + (U = h) | 0, o = d + ((f = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + nA | 0, o = ((w = K + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = B + (K = h) | 0, o = d + ((P = n + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (v = h) + BA | 0, o = J + ((f = t + X | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = k = f + AA | 0, U = o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = FA + (AA = h) | 0, v = t, o = s + ((t = V + t | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, k = t + y | 0, t = J, J = o = k >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ k, t ^ o, 48), o = (o = U) + (U = h) | 0, b = f = t + b | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + j | 0, o = G + ((s = I + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (s = s + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, G = y = DA(y ^ s, o ^ m, 32), M = o = h, L = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, Y = e, e ^= L, L = o, e = DA(e, o ^ S, 40), o = kA + (N = h) | 0, o = F + ((y = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, p = (y = y + s | 0) ^ G, G = o = y >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = DA(p, o ^ M, 48), m = o = h, S = o, M = F = DA(z ^ u, T ^ $, 1), p = o = h, u = r, o = o + eA | 0, o = x + ((r = F + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = _, _ = o, F = DA(c ^ r, H ^ o, 32), o = (W = h) + u | 0, H = f = F + f | 0, c = DA(c = f ^ M, (M = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ p, 40), o = wA + (p = h) | 0, o = _ + ((f = c + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, _ = f = f + r | 0, u = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + FA | 0, o = ((x = V) >>> 0 > (V = K + V | 0) >>> 0 ? o + 1 | 0 : o) + r | 0, FA = o = (f = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, V = DA(f ^ s, o ^ S, 32), o = (z = h) + O | 0, S = DA((r = b + V | 0) ^ K, (o = r >>> 0 < V >>> 0 ? o + 1 | 0 : o) ^ P, 40), x = o, o = kA + (T = h) | 0, o = FA + ((K = oA) >>> 0 > (oA = S + oA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (oA = f + oA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = V ^ oA, V = o;
                                        kA = DA(f, o ^ z, 48), o = (FA = h) + x | 0, r = o = (f = r + kA | 0) >>> 0 < kA >>> 0 ? o + 1 | 0 : o, o = DA(f ^ S, o ^ T, 1), S = h, z = o, T = w, w = gA, x = wA, wA = DA(F ^ _, u ^ W, 48), o = (F = h) + M | 0, M = w, H = o = (gA = H + wA | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o, w = DA(c ^ (_ = gA), o ^ p, 1), o = (p = h) + x | 0, o = G + (w >>> 0 > (gA = M + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, c = o = (gA = y + gA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(t ^ gA, o ^ U, 32), o = (o = n) + (n = h) | 0, G = y = t + T | 0, M = o = y >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = (p = h) + _A | 0, o = (y >>> 0 > (iA = y + iA | 0) >>> 0 ? o + 1 | 0 : o) + c | 0, c = o = (c = iA) >>> 0 > (iA = gA + iA | 0) >>> 0 ? o + 1 | 0 : o, t = DA(t ^ iA, o ^ n, 48), o = (w = h) + M | 0, n = gA = t + G | 0, _A = o = gA >>> 0 < t >>> 0 ? o + 1 | 0 : o, G = I, M = j, o = L + m | 0, gA = o = (I = s + Y | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, j = DA(I ^ e, o ^ N, 1), o = (s = h) + M | 0, o = J + ((e = G + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, D = DA((e = e + k | 0) ^ D, (o = e >>> 0 < k >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = o, J = EA, EA = j, o = (k = h) + H | 0, H = s, s = o = (j = D + _ | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, EA = DA(j ^ EA, H ^ o, 40), o = (_ = h) + nA | 0, o = ((nA = J + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + G | 0, G = nA, e = D ^ (nA = e + nA | 0), D = o = G >>> 0 > nA >>> 0 ? o + 1 | 0 : o, o = DA(e, o ^ k, 48), L = e = h, k = o, H = X, G = BA, X = DA(b ^ v, O ^ AA, 1), M = o = h, o = o + MA | 0, o = Z + ((X = (J = X) + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, cA = o = (X = d + X | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, BA = DA(X ^ wA, o ^ F, 32), o = (d = h) + gA | 0, gA = I = BA + I | 0, wA = DA(I ^ J, (F = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ M, 40), o = (o = G) + (G = h) | 0, o = cA + ((I = wA + H | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o) | 0, cA = I = I + X | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = o, o = S + GA | 0, o = ((J = QA) >>> 0 > (QA = z + QA | 0) >>> 0 ? o + 1 | 0 : o) + X | 0, GA = o = (X = I + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, QA = DA(k ^ X, o ^ e, 32), o = (J = h) + _A | 0, e = I = QA + n | 0, I = DA(I ^ z, (H = S) ^ (S = I >>> 0 < QA >>> 0 ? o + 1 | 0 : o), 40), o = pA + (M = h) | 0, pA = I, o = GA + ((I = fA + I | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, GA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, H = o, N = o ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), X = DA(BA ^ cA, d ^ MA, 48), o = (cA = h) + F | 0, F = I = X + gA | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, BA = rA, o = s + L | 0, rA = o = (I = k + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o, EA = DA(I ^ EA, o ^ _, 1), o = (k = h) + yA | 0, o = ((BA = EA + BA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + c | 0, BA = o = (yA = BA + iA | 0) >>> 0 < BA >>> 0 ? o + 1 | 0 : o, gA = DA(yA ^ kA, o ^ FA, 32), o = (j = h) + MA | 0, iA = o = (fA = gA + F | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o, kA = gA, gA = DA(EA ^ fA, o ^ k, 40), o = (c = h) + HA | 0, o = (gA >>> 0 > (EA = gA + tA | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, s = j, j = o = (yA = EA + yA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, EA = DA(kA ^ (tA = yA), s ^ o, 48), o = (k = h) + iA | 0, o = (BA = EA + fA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, fA = BA, BA ^= Y, E[A + 8 | 0] = BA, E[A + 9 | 0] = BA >>> 8, E[A + 10 | 0] = BA >>> 16, E[A + 11 | 0] = BA >>> 24, iA = o, o ^= N, E[A + 12 | 0] = o, E[A + 13 | 0] = o >>> 8, E[A + 14 | 0] = o >>> 16, E[A + 15 | 0] = o >>> 24, yA = I, BA = rA, I = X, X = DA(y ^ n, p ^ _A, 1), o = (HA = h) + B | 0, o = (X >>> 0 > (rA = X + g | 0) >>> 0 ? o + 1 | 0 : o) + V | 0, oA = o = (n = rA) >>> 0 > (rA = oA + rA | 0) >>> 0 ? o + 1 | 0 : o, I = DA(I ^ rA, o ^ cA, 32), o = (o = BA) + (BA = h) | 0, cA = o = (yA = I + yA | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, kA = I, yA = DA(X ^ (V = yA), o ^ HA, 40), o = (y = h) + C | 0, o = oA + ((I = yA + sA | 0) >>> 0 < yA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o, oA = I, I ^= kA, kA = o, rA = DA(I, o ^ BA, 48), o = (n = h) + cA | 0, V = I = rA + V | 0, cA = I >>> 0 < rA >>> 0 ? o + 1 | 0 : o, wA = I = DA(F ^ wA, G ^ MA, 1), HA = o = h, o = o + l | 0, o = D + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, l = o = (X = I + nA | 0) >>> 0 < nA >>> 0 ? o + 1 | 0 : o, I = (BA = DA(t ^ X, o ^ w, 32)) + f | 0, o = (f = h) + r | 0, nA = I, I = (aA = DA(D = I ^ wA, (wA = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ HA, 40)) + q | 0, o = (q = h) + eA | 0, o = l + (I >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (l = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = l ^ JA ^ V, E[0 | (I = A)] = X, E[I + 1 | 0] = X >>> 8, E[I + 2 | 0] = X >>> 16, E[I + 3 | 0] = X >>> 24, X = o ^ Q ^ cA, E[I + 4 | 0] = X, E[I + 5 | 0] = X >>> 8, E[I + 6 | 0] = X >>> 16, E[I + 7 | 0] = X >>> 24, X = (BA = DA(l ^ BA, o ^ f, 48)) + nA | 0, o = (nA = h) + wA | 0, o = (wA = X >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ kA, l = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ oA ^ X, E[I + 16 | 0] = l, E[I + 17 | 0] = l >>> 8, E[I + 18 | 0] = l >>> 16, E[I + 19 | 0] = l >>> 24, E[I + 20 | 0] = o, E[I + 21 | 0] = o >>> 8, E[I + 22 | 0] = o >>> 16, E[I + 23 | 0] = o >>> 24, I = DA(QA ^ GA, H ^ J, 48), l = h, oA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ DA(gA ^ fA, c ^ iA, 1) ^ I, E[A + 32 | 0] = o, E[A + 33 | 0] = o >>> 8, E[A + 34 | 0] = o >>> 16, E[A + 35 | 0] = o >>> 24, o = h ^ oA ^ l, E[A + 36 | 0] = o, E[A + 37 | 0] = o >>> 8, E[A + 38 | 0] = o >>> 16, E[A + 39 | 0] = o >>> 24, o = S + l | 0, o = (oA = I + e | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ j ^ o, l = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ tA ^ oA, E[I + 24 | 0] = l, E[I + 25 | 0] = l >>> 8, E[I + 26 | 0] = l >>> 16, E[I + 27 | 0] = l >>> 24, E[I + 28 | 0] = gA, E[I + 29 | 0] = gA >>> 8, E[I + 30 | 0] = gA >>> 16, E[I + 31 | 0] = gA >>> 24, gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ DA(X ^ aA, q ^ wA, 1), E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = n ^ h ^ gA, E[A + 44 | 0] = I, E[A + 45 | 0] = I >>> 8, E[A + 46 | 0] = I >>> 16, E[A + 47 | 0] = I >>> 24, X = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ DA(V ^ yA, y ^ cA, 1), E[A + 56 | 0] = I, E[A + 57 | 0] = I >>> 8, E[A + 58 | 0] = I >>> 16, E[A + 59 | 0] = I >>> 24, I = nA ^ h ^ X, E[A + 60 | 0] = I, E[A + 61 | 0] = I >>> 8, E[A + 62 | 0] = I >>> 16, E[A + 63 | 0] = I >>> 24, X = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = EA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ DA(oA ^ pA, o ^ M, 1), E[A + 48 | 0] = I, E[A + 49 | 0] = I >>> 8, E[A + 50 | 0] = I >>> 16, E[A + 51 | 0] = I >>> 24, I = k ^ h ^ X, E[A + 52 | 0] = I, E[A + 53 | 0] = I >>> 8, E[A + 54 | 0] = I >>> 16, E[A + 55 | 0] = I >>> 24;
                                    }
                                    function s(A, I, g, C, B, Q, i) {
                                        var f, c, e, r, D, t, y, n, s, k, S, H, G, _, M, p, J, U, Y, d, K, b, P, v, L, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA, iA, EA, oA, fA, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, dA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0, XA = 0, jA = 0, TA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, $A = 0, AI = 0, II = 0, gI = 0, CI = 0, BI = 0, QI = 0;
                                        return w = e = w - 560 | 0, cA(DA = e + 352 | 0), i && R(DA, 35136, 34, 0), aA(e + 288 | 0, Q, 32, 0), R(tA = e + 352 | 0, e + 320 | 0, 32, 0), R(tA, g, C, B), N(tA, nA = e + 224 | 0), sA = a[(rA = Q) + 32 | 0] | a[rA + 33 | 0] << 8 | a[rA + 34 | 0] << 16 | a[rA + 35 | 0] << 24, SA = a[rA + 36 | 0] | a[rA + 37 | 0] << 8 | a[rA + 38 | 0] << 16 | a[rA + 39 | 0] << 24, yA = a[rA + 40 | 0] | a[rA + 41 | 0] << 8 | a[rA + 42 | 0] << 16 | a[rA + 43 | 0] << 24, eA = a[rA + 44 | 0] | a[rA + 45 | 0] << 8 | a[rA + 46 | 0] << 16 | a[rA + 47 | 0] << 24, DA = a[rA + 48 | 0] | a[rA + 49 | 0] << 8 | a[rA + 50 | 0] << 16 | a[rA + 51 | 0] << 24, Q = a[rA + 52 | 0] | a[rA + 53 | 0] << 8 | a[rA + 54 | 0] << 16 | a[rA + 55 | 0] << 24, wA = a[rA + 60 | 0] | a[rA + 61 | 0] << 8 | a[rA + 62 | 0] << 16 | a[rA + 63 | 0] << 24, rA = a[rA + 56 | 0] | a[rA + 57 | 0] << 8 | a[rA + 58 | 0] << 16 | a[rA + 59 | 0] << 24, E[A + 56 | 0] = rA, E[A + 57 | 0] = rA >>> 8, E[A + 58 | 0] = rA >>> 16, E[A + 59 | 0] = rA >>> 24, E[A + 60 | 0] = wA, E[A + 61 | 0] = wA >>> 8, E[A + 62 | 0] = wA >>> 16, E[A + 63 | 0] = wA >>> 24, E[A + 48 | 0] = DA, E[A + 49 | 0] = DA >>> 8, E[A + 50 | 0] = DA >>> 16, E[A + 51 | 0] = DA >>> 24, E[A + 52 | 0] = Q, E[A + 53 | 0] = Q >>> 8, E[A + 54 | 0] = Q >>> 16, E[A + 55 | 0] = Q >>> 24, E[A + 40 | 0] = yA, E[A + 41 | 0] = yA >>> 8, E[A + 42 | 0] = yA >>> 16, E[A + 43 | 0] = yA >>> 24, E[A + 44 | 0] = eA, E[A + 45 | 0] = eA >>> 8, E[A + 46 | 0] = eA >>> 16, E[A + 47 | 0] = eA >>> 24, E[0 | (Q = A + 32 | 0)] = sA, E[Q + 1 | 0] = sA >>> 8, E[Q + 2 | 0] = sA >>> 16, E[Q + 3 | 0] = sA >>> 24, E[Q + 4 | 0] = SA, E[Q + 5 | 0] = SA >>> 8, E[Q + 6 | 0] = SA >>> 16, E[Q + 7 | 0] = SA >>> 24, F(nA), u(e, nA), MA(A, e), cA(tA), i && R(tA, 35136, 34, 0), R(i = e + 352 | 0, A, 64, 0), R(i, g, C, B), N(i, hA = e + 160 | 0), F(hA), E[e + 288 | 0] = 248 & a[e + 288 | 0], E[e + 319 | 0] = 63 & a[e + 319 | 0] | 64, g = a[23 + (A = c = e + 288 | 0) | 0], yA = kA(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, D = (a[hA + 28 | 0] | a[hA + 29 | 0] << 8 | a[hA + 30 | 0] << 16 | a[hA + 31 | 0] << 24) >>> 7 | 0, 0), DA = h, g = (A = a[hA + 27 | 0]) >>> 24 | 0, B = A << 8 | (eA = a[hA + 23 | 0] | a[hA + 24 | 0] << 8 | a[hA + 25 | 0] << 16 | a[hA + 26 | 0] << 24) >>> 24, A = kA(t = 2097151 & ((3 & (SA = (A = (C = a[hA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, y = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = h + DA | 0, C = A >>> 0 > (B = A + yA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n = (g = a[hA + 23 | 0]) << 16 & 2031616 | a[hA + 21 | 0] | a[hA + 22 | 0] << 8, 0, s = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = h + C | 0, DA = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = kA(k = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, S = eA >>> 5 & 2097151, 0), g = h + B | 0, rA = C = A + DA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, eA = kA(y, 0, S, 0), DA = h, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (JA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = kA(H = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, SA = C >>> 3 | 0, D, 0), A = h + DA | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = kA(r, 0, t, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > (eA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[hA + 19 | 0]) >>> 24 | 0, DA = A << 8 | (NA = a[hA + 15 | 0] | a[hA + 16 | 0] << 8 | a[hA + 17 | 0] << 16 | a[hA + 18 | 0] << 24) >>> 24, A = kA(G = (7 & (yA = (A = (i = a[hA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | DA) >>> 3, _ = yA >>> 3 | 0, s, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n, 0, k, 0), g = h + g | 0, sA = g = A >>> 0 > (nA = A + C | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, eA = C = (A = (2097151 & A) << 11 | (yA = nA - -1048576 | 0) >>> 21) >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, _A = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & A) << 11 | (DA = rA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = kA(s, 0, S, 0), g = h, C = A, A = kA(D, 0, y, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, GA = (A = C) + (C = kA(t, 0, k, 0)) | 0, A = h + g | 0, A = C >>> 0 > GA >>> 0 ? A + 1 | 0 : A, tA = GA - (g = -2097152 & (C = GA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((GA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > GA >>> 0) | 0) | 0) + i | 0, z = g = (A = tA + wA | 0) >>> 0 < tA >>> 0 ? g + 1 | 0 : g, q = A, tA = kA(A, g, 470296, 0), wA = h, g = kA(D, 0, k, 0), A = h, i = g, g = kA(t, 0, s, 0), A = h + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, bA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, X = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, j = g = rA - (C = -2097152 & DA) | 0, T = B = eA - ((C >>> 0 > rA >>> 0) + _A | 0) | 0, O = A, C = kA(A, i, 666643, 0), A = h + wA | 0, A = C >>> 0 > (i = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(g, B, 654183, 0), g = h + A | 0, FA = B = C + i | 0, DA = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, GA = nA - (A = -2097152 & yA) | 0, HA = sA - ((A >>> 0 > nA >>> 0) + HA | 0) | 0, g = kA(t, 0, H, SA), C = h, B = (A = g) + (g = kA(M = JA >>> 6 & 2097151, 0, D, 0)) | 0, A = h + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, n, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, S, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, p = NA >>> 6 & 2097151, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, G, _), g = h + A | 0, nA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = kA(J = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, D, 0), A = h, C = g, g = kA(t, 0, M, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(S, 0, H, SA)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(y, 0, G, _), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, n, 0), g = h + g | 0, yA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[hA + 14 | 0]) >>> 24 | 0, eA = A << 8 | (rA = a[hA + 10 | 0] | a[hA + 11 | 0] << 8 | a[hA + 12 | 0] << 16 | a[hA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[hA + 15 | 0]) >>> 16 | 0, g = kA(U = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | eA) >>> 1), 0, s, 0), A = h + B | 0, A = g >>> 0 > (C = g + yA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, p, 0), A = h + A | 0, eA = A = g >>> 0 > (yA = g + C | 0) >>> 0 ? A + 1 | 0 : A, PA = g = A - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, wA = C = (g = (2097151 & g) << 11 | (tA = yA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + nA | 0) >>> 0 ? C + 1 | 0 : C, YA = g = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + HA | 0, V = A = (g = (C = (2097151 & g) << 11 | (nA = _A - -1048576 | 0) >>> 21) + GA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, Z = g, A = kA(g, A, -997805, -1), g = h + DA | 0, FA = C = A + FA | 0, DA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, GA = (RA = a[23 + (f = e + 224 | 0) | 0] | a[f + 24 | 0] << 8 | a[f + 25 | 0] << 16 | a[f + 26 | 0] << 24) >>> 5 & 2097151, C = kA(Y = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, S, 0), g = h, B = (A = kA(n, 0, d = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(K = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, p, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(U, 0, b = sA >>> 4 & 2097151, 0), A = h + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = kA(P = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, G, _), A = h + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(M, 0, v = (a[hA + 7 | 0] | a[hA + 8 | 0] << 8 | a[hA + 9 | 0] << 16 | a[hA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = kA(J, 0, dA = rA >>> 4 & 2097151, 0), A = h + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[hA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (rA = a[hA + 2 | 0] | a[hA + 3 | 0] << 8 | a[hA + 4 | 0] << 16 | a[hA + 5 | 0] << 24) >>> 24, g = A, A = kA(H, SA, L = 2097151 & ((3 & (g |= C = (A = a[hA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = h + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = kA(x = (A = a[hA + 2 | 0]) << 16 & 2031616 | a[0 | hA] | a[hA + 1 | 0] << 8, 0, y, 0), A = h + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, m = rA >>> 5 & 2097151, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + GA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[f + 21 | 0] | a[f + 22 | 0] << 8, A = kA(n, 0, Y, 0), g = h, rA = (C = A) + (A = kA(G, _, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, K, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, dA, 0), g = h + g | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = C) + (C = kA(p, 0, P, 0)) | 0, A = h + g | 0, A = C >>> 0 > rA >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = kA(J, 0, v, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, m, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, x, 0), g = h + g | 0, A = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[f + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, hA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (rA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + DA | 0, A = (DA = i + FA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, JA = i - -1048576 | 0, pA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, UA = DA - (g = -2097152 & JA) | 0, vA = A - ((g >>> 0 > DA >>> 0) + i | 0) | 0, sA = B, DA = C, A = kA(j, T, 470296, 0), g = h, C = A, A = kA(q, z, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(Z, V, 654183, 0)) | 0, A = h + g | 0, NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(G, _, Y, 0), A = h, C = g, g = kA(p, 0, d, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, dA, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, v, 0), C = h + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, P, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(J, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(H, SA, x, 0)) | 0, g = h + A | 0, GA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 19 | 0]) >>> 24 | 0, HA = A << 8 | (FA = a[f + 15 | 0] | a[f + 16 | 0] << 8 | a[f + 17 | 0] << 16 | a[f + 18 | 0] << 24) >>> 24, C = ((LA = (A = (B = a[f + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, GA = B = (g = (7 & LA) << 29 | (g = (B <<= 16) | HA) >>> 3) + GA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, HA = FA >>> 6 & 2097151, A = kA(p, 0, Y, 0), g = h, C = A, A = kA(U, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, FA = (A = C) + (C = kA(K, 0, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > FA >>> 0 ? A + 1 | 0 : A, C = kA(b, 0, L, 0), g = h + A | 0, g = C >>> 0 > (FA = C + FA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(P, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (FA = C + FA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, x, 0), C = h + A | 0, C = g >>> 0 > (FA = g + FA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, m, 0), g = h + C | 0, A = A >>> 0 > (FA = A + FA | 0) >>> 0 ? g + 1 | 0 : g, TA = A = (xA = FA + HA | 0) >>> 0 < FA >>> 0 ? A + 1 | 0 : A, II = A = A - ((xA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (XA = xA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, VA = A = C >>> 0 > (OA = C + GA | 0) >>> 0 ? A + 1 | 0 : A, gI = A = A - ((OA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (lA = OA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + NA | 0) >>> 0 ? A + 1 | 0 : A) + DA | 0, DA = (C = B + sA | 0) - (A = -2097152 & rA) | 0, hA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + hA | 0) | 0, CI = A = A - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (zA = DA - -1048576 | 0) >>> 21, A = (A >> 21) + vA | 0, B = A = C >>> 0 > (i = C + UA | 0) >>> 0 ? A + 1 | 0 : A, AI = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, qA = (2097151 & A) << 11 | (NA = i - -1048576 | 0) >>> 21, sA = A >> 21, LA = _A - (A = -2097152 & nA) | 0, YA = wA - ((A >>> 0 > _A >>> 0) + YA | 0) | 0, A = kA(D, 0, s, 0), jA = g = h, UA = A, FA = A - -1048576 | 0, mA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, W = A = g >>> 21 | 0, A = kA(l = (2097151 & g) << 11 | FA >>> 21, A, -683901, -1), g = h + eA | 0, g = A >>> 0 > (C = A + yA | 0) >>> 0 ? g + 1 | 0 : g, nA = C - (A = -2097152 & tA) | 0, rA = g - ((A >>> 0 > C >>> 0) + PA | 0) | 0, g = kA(S, 0, M, 0), A = h, C = g, g = kA(D, 0, b, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, J, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = C) + (C = kA(n, 0, H, SA)) | 0, g = h + A | 0, g = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, A = kA(y, 0, p, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, G, _), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, U, 0), A = h + A | 0, yA = C = g + eA | 0, eA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = kA(t, 0, b, 0), g = h, C = A, A = kA(D, 0, K, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, wA = (A = kA(n, 0, M, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > wA >>> 0 ? C + 1 | 0 : C, A = kA(S, 0, J, 0), g = h + C | 0, g = A >>> 0 > (wA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(H, SA, G, _), A = h + g | 0, A = C >>> 0 > (wA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, U, 0), A = h + A | 0, A = g >>> 0 > (C = g + wA | 0) >>> 0 ? A + 1 | 0 : A, wA = (g = C) + (C = kA(r, 0, p, 0)) | 0, g = h + A | 0, g = C >>> 0 > wA >>> 0 ? g + 1 | 0 : g, A = kA(s, 0, v, 0), C = h + g | 0, C = A >>> 0 > (wA = A + wA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(k, 0, dA, 0), g = h + C | 0, HA = g = A >>> 0 > (GA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, WA = A = g - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (_A = GA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, tA = A = g >>> 0 > (PA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, uA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + rA | 0, nA = g = (A = (2097151 & A) << 11 | (wA = PA - -1048576 | 0) >>> 21) >>> 0 > (vA = A + nA | 0) >>> 0 ? g + 1 | 0 : g, ZA = A = g - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & A) << 11 | (rA = vA - -1048576 | 0) >>> 21, A = (A >> 21) + YA | 0, $ = A = (g = eA + LA | 0) >>> 0 < eA >>> 0 ? A + 1 | 0 : A, AA = g, A = kA(g, A, -683901, -1), g = h + sA | 0, qA = C = A + qA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(t, 0, Y, 0), g = h, C = A, A = kA(S, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(G, _, K, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, b, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(n, 0, P, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(M, 0, dA, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(J, 0, U, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(H, SA, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, m, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(r, 0, L, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, x, 0), g = h + A | 0, YA = eA = C + eA | 0, C = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 27 | 0]) >>> 24 | 0, yA = A << 8 | RA >>> 24, eA = 2097151 & ((3 & (g |= A = (eA = a[f + 28 | 0]) >>> 16 | 0)) << 30 | (A = (eA <<= 16) | yA) >>> 2), g = C, yA = A = eA + YA | 0, eA = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g, LA = kA(O, X, 470296, 0), YA = h, A = (C = (2097151 & bA) << 11 | KA >>> 21) + (UA - (g = -2097152 & FA) | 0) | 0, g = jA - ((524287 & mA) + (g >>> 0 > UA >>> 0) | 0) + (bA >>> 21) | 0, IA = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, gA = A, g = kA(A, g, 666643, 0), A = h + YA | 0, A = g >>> 0 > (C = g + LA | 0) >>> 0 ? A + 1 | 0 : A, FA = (g = kA(q, z, 654183, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > FA >>> 0 ? C + 1 | 0 : C, g = kA(j, T, -997805, -1), A = h + C | 0, A = g >>> 0 > (FA = g + FA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(Z, V, 136657, 0), g = h + A | 0, JA = (A = (2097151 & pA) << 11 | JA >>> 21) + (FA = C + FA | 0) | 0, g = (pA >>> 21 | 0) + (C >>> 0 > FA >>> 0 ? g + 1 | 0 : g) | 0, mA = FA = eA - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > JA >>> 0 ? g + 1 | 0 : g) + eA | 0, g = (eA = yA + JA | 0) - (C = -2097152 & (jA = yA - -1048576 | 0)) | 0, C = (A = (A = eA >>> 0 < JA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > eA >>> 0) + FA | 0) | 0) + sA | 0, LA = eA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, UA = (C = (yA = g + qA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (YA = g - -1048576 | 0)) >>> 0 > yA >>> 0) + eA | 0) | 0, RA = A = yA - g | 0, eA = i, i = B, $A = vA - (A = -2097152 & rA) | 0, FA = nA - ((A >>> 0 > vA >>> 0) + ZA | 0) | 0, A = kA(gA, IA, -683901, -1), g = h, B = (C = A) + (A = kA(l, W, 136657, 0)) | 0, C = h + g | 0, g = tA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, wA = (C = B + PA | 0) - (A = -2097152 & wA) | 0, nA = (g = C >>> 0 < PA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + uA | 0) | 0, g = kA(l, W, -997805, -1), A = h + HA | 0, A = g >>> 0 > (C = g + GA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(gA, IA, 136657, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(O, X, -683901, -1), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = B - (A = -2097152 & _A) | 0, sA = g - ((A >>> 0 > B >>> 0) + WA | 0) | 0, g = kA(S, 0, b, 0), A = h, C = g, g = kA(t, 0, K, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(D, 0, P, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(G, _, M, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(n, 0, J, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, p, 0), g = h + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, U, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(s, 0, L, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(k, 0, v, 0), A = h + g | 0, yA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(S, 0, K, 0), g = h, C = A, A = kA(D, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, tA = (A = C) + (C = kA(n, 0, b, 0)) | 0, A = h + g | 0, A = C >>> 0 > tA >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, P, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(M, 0, p, 0), g = h + C | 0, g = A >>> 0 > (tA = A + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, J, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, U, 0), g = h + A | 0, g = C >>> 0 > (tA = C + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, v, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, dA, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, tA = (A = kA(s, 0, m, 0)) + tA | 0, g = h + C | 0, C = kA(k, 0, L, 0), A = h + (A >>> 0 > tA >>> 0 ? g + 1 | 0 : g) | 0, vA = A = C >>> 0 > (ZA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((ZA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (bA = ZA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (qA = C + yA | 0) >>> 0 ? A + 1 | 0 : A, QA = A = A - ((qA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = qA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, JA = A = C >>> 0 > (PA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, iA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = PA - -1048576 | 0) >>> 21, A = (A >> 21) + nA | 0, B = A = C >>> 0 > (rA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, nA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = rA - -1048576 | 0) >>> 21, A = (A >> 21) + FA | 0, WA = A = (yA = sA + $A | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, uA = yA, A = kA(yA, A, -683901, -1), g = h, yA = A, A = kA(AA, $, 136657, 0), g = h + g | 0, A = (A >>> 0 > (yA = yA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, BI = (i = eA + yA | 0) - (g = -2097152 & NA) | 0, QI = (A = i >>> 0 < yA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + AI | 0) | 0, sA = DA, yA = hA, DA = kA(uA, WA, 136657, 0), i = h, $A = A = rA - (g = -2097152 & C) | 0, CA = B = B - ((g >>> 0 > rA >>> 0) + nA | 0) | 0, C = kA(AA, $, -997805, -1), g = h + i | 0, g = C >>> 0 > (DA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(A, B, -683901, -1), A = h + g | 0, AI = B = C + DA | 0, eA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(Z, V, 470296, 0), g = h, B = (C = A) + (A = kA(j, T, 666643, 0)) | 0, C = h + g | 0, g = VA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, FA = A = B + OA | 0, i = g = A >>> 0 < OA >>> 0 ? g + 1 | 0 : g, g = kA(Z, V, 666643, 0), A = h + TA | 0, A = g >>> 0 > (C = g + xA | 0) >>> 0 ? A + 1 | 0 : A, wA = C - (g = -2097152 & XA) | 0, GA = A - ((g >>> 0 > C >>> 0) + II | 0) | 0, g = kA(U, 0, Y, 0), A = h, C = g, g = kA(d, 0, dA, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, L, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA(b, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, v, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, x, 0), g = h + C | 0, rA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 14 | 0]) >>> 24 | 0, DA = A << 8 | (nA = a[f + 10 | 0] | a[f + 11 | 0] << 8 | a[f + 12 | 0] << 16 | a[f + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[f + 15 | 0]) >>> 16 | 0)) << 31 | (A = DA | A << 16) >>> 1), A = B, rA = C = g + rA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, DA = nA >>> 4 & 2097151, A = kA(Y, 0, dA, 0), g = h, C = A, A = kA(d, 0, v, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(K, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, nA = (A = C) + (C = kA(b, 0, x, 0)) | 0, A = h + g | 0, A = C >>> 0 > nA >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, L, 0), C = h + A | 0, A = g >>> 0 > (nA = g + nA | 0) >>> 0 ? C + 1 | 0 : C, hA = A = (XA = DA + nA | 0) >>> 0 < nA >>> 0 ? A + 1 | 0 : A, EA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, _A = g = (A = (2097151 & A) << 11 | (NA = XA - -1048576 | 0) >>> 21) >>> 0 > (VA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, oA = A = g - ((VA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (tA = VA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + GA | 0, nA = A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, fA = A = A - ((wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, II = g = (g = (A = (2097151 & A) << 11 | (rA = wA - -1048576 | 0) >>> 21) >>> 0 > (B = A + FA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & lA) >>> 0 > B >>> 0) + gI | 0) | 0, lA = A = B - C | 0, DA = A - -1048576 | 0, gI = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + eA | 0, g = ((A = (2097151 & A) << 11 | DA >>> 21) >>> 0 > (B = A + AI | 0) >>> 0 ? C + 1 | 0 : C) + yA | 0, xA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & zA) >>> 0 > B >>> 0) + CI | 0) | 0, yA = A = B - C | 0, i = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + QI | 0, zA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (eA = A + BI | 0) >>> 0 ? C + 1 | 0 : C) - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, FA = RA - -1048576 | 0, GA = UA - ((RA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = eA - -1048576 | 0) >>> 21, A = (A >> 21) + UA | 0, CI = (RA = sA + RA | 0) - (g = -2097152 & FA) | 0, BI = (sA >>> 0 > RA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > RA >>> 0) + GA | 0) | 0, QI = eA - (A = -2097152 & B) | 0, AI = C - ((A >>> 0 > eA >>> 0) + zA | 0) | 0, OA = yA - (A = -2097152 & i) | 0, RA = xA - ((A >>> 0 > yA >>> 0) + TA | 0) | 0, A = kA(uA, WA, -997805, -1), g = h, C = A, A = kA(AA, $, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA($A, CA, 136657, 0)) | 0, A = h + g | 0, g = II + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, xA = (C = B + lA | 0) - (A = -2097152 & DA) | 0, TA = (g = C >>> 0 < lA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + gI | 0) | 0, lA = PA - (A = -2097152 & HA) | 0, UA = JA - ((A >>> 0 > PA >>> 0) + iA | 0) | 0, g = kA(gA, IA, -997805, -1), A = h, C = g, g = kA(l, W, 654183, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(O, X, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(q, z, -683901, -1), C = h + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, HA = (C = B + qA | 0) - (A = -2097152 & pA) | 0, JA = (g = C >>> 0 < qA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + QA | 0) | 0, g = kA(gA, IA, 654183, 0), A = h, C = g, g = kA(l, W, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(O, X, -997805, -1)) + C | 0, C = h + A | 0, g = vA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + ZA | 0) >>> 0 < ZA >>> 0 ? g + 1 | 0 : g, C = A, A = kA(q, z, 136657, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(j, T, -683901, -1)) | 0, A = h + g | 0, DA = B - (g = -2097152 & bA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + BA | 0) | 0, B = (a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24) >>> 7 | 0, A = kA(D, 0, Y, 0), g = h, eA = (C = A) + (A = kA(t, 0, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > eA >>> 0 ? C + 1 | 0 : C, A = kA(n, 0, K, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, b, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(S, 0, P, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, U, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, J, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, dA, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, L, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(r, 0, v, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, x, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, m, 0), C = h + A | 0, g = C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & mA) << 11 | jA >>> 21) + (A = B + eA | 0) | 0, A = (mA >>> 21 | 0) + (g = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, zA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, yA = C = (g = (2097151 & g) << 11 | (SA = KA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + DA | 0) >>> 0 ? C + 1 | 0 : C, jA = g = C - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + JA | 0, DA = A = (g = (2097151 & g) << 11 | (eA = pA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + HA | 0) >>> 0 ? A + 1 | 0 : A, bA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + UA | 0, mA = C = (g = (B = (2097151 & g) << 11 | (i = HA - -1048576 | 0) >>> 21) + lA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, UA = g, A = kA(g, C, -683901, -1), g = h + TA | 0, JA = C = A + xA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = kA(AA, $, 470296, 0), A = h + nA | 0, A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(uA, WA, 654183, 0), A = h + (A - (((C = -2097152 & rA) >>> 0 > wA >>> 0) + fA | 0) | 0) | 0, A = g >>> 0 > (rA = g + (wA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA($A, CA, -997805, -1), g = h + A | 0, g = C >>> 0 > (rA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, vA = C = HA - (A = -2097152 & i) | 0, dA = DA = DA - ((A >>> 0 > HA >>> 0) + bA | 0) | 0, rA = (i = kA(UA, mA, 136657, 0)) + rA | 0, A = h + g | 0, C = kA(C, DA, -683901, -1), g = h + (i >>> 0 > rA >>> 0 ? A + 1 | 0 : A) | 0, DA = g = C >>> 0 > (nA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, bA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = nA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, HA = g = (A = g >>> 0 > (rA = g + JA | 0) >>> 0 ? A + 1 | 0 : A) - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & g) << 11 | (B = rA - -1048576 | 0) >>> 21, g = (g >> 21) + RA | 0, OA = JA = wA + OA | 0, JA = wA >>> 0 > JA >>> 0 ? g + 1 | 0 : g, RA = rA - (g = -2097152 & B) | 0, ZA = A - ((g >>> 0 > rA >>> 0) + HA | 0) | 0, xA = nA - (A = -2097152 & i) | 0, TA = DA - ((A >>> 0 > nA >>> 0) + bA | 0) | 0, A = kA(AA, $, 666643, 0), C = _A + h | 0, C = (i = A + VA | 0) >>> 0 < VA >>> 0 ? C + 1 | 0 : C, B = (A = kA(uA, WA, 470296, 0)) + (i - (g = -2097152 & tA) | 0) | 0, g = h + (C - ((g >>> 0 > i >>> 0) + oA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA($A, CA, 654183, 0), A = h + g | 0, rA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = pA - (A = -2097152 & eA) | 0, DA = yA - ((A >>> 0 > pA >>> 0) + jA | 0) | 0, A = kA(gA, IA, 470296, 0), g = h, C = A, A = kA(l, W, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(O, X, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(q, z, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(j, T, 136657, 0), A = h + A | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = kA(Z, V, -683901, -1)) + C | 0, C = h + A | 0, g = sA + (g >>> 0 > eA >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = (2097151 & LA) << 11 | YA >>> 21) + ((eA = eA + KA | 0) - (A = -2097152 & SA) | 0) | 0, A = ((g = eA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > eA >>> 0) + zA | 0) | 0) + (LA >> 21) | 0, HA = A = C >>> 0 > pA >>> 0 ? A + 1 | 0 : A, lA = A = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (tA = pA - -1048576 | 0) >>> 21, A = (A >> 21) + DA | 0, bA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = kA(C, A, -683901, -1), g = h + B | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(UA, mA, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(vA, dA, 136657, 0), C = h + A | 0, YA = B = g + B | 0, yA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, rA = XA - (A = -2097152 & NA) | 0, sA = hA - ((A >>> 0 > XA >>> 0) + EA | 0) | 0, g = kA(Y, 0, v, 0), A = h, C = g, g = kA(d, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(K, 0, x, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(P, 0, m, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, SA = C = (A = (a[f + 7 | 0] | a[f + 8 | 0] << 8 | a[f + 9 | 0] << 16 | a[f + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, eA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(Y, 0, L, 0), g = h, C = A, A = kA(d, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(P, 0, x, 0)) | 0, A = h + g | 0, DA = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[f + 6 | 0]) >>> 24 | 0, i = g << 8 | (zA = a[f + 2 | 0] | a[f + 3 | 0] << 8 | a[f + 4 | 0] << 16 | a[f + 5 | 0] << 24) >>> 24, C = A, g = (A = a[f + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (DA = A + DA | 0) >>> 0 ? C + 1 | 0 : C, qA = A = C - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_A = DA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, wA = A = C >>> 0 > (hA = C + SA | 0) >>> 0 ? A + 1 | 0 : A, jA = A = A - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (nA = hA - -1048576 | 0) >>> 21) >>> 0 > (B = A + rA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(uA, WA, 666643, 0), A = h + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA($A, CA, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(KA, bA, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = kA(vA, dA, -997805, -1)) + C | 0, C = h + g | 0, sA = C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, LA = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (SA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + yA | 0, YA = C = (A = C >>> 0 > (B = C + YA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & C) << 11 | (yA = B - -1048576 | 0) >>> 21, C = (C >> 21) + TA | 0, PA = NA = eA + xA | 0, NA = eA >>> 0 > NA >>> 0 ? C + 1 | 0 : C, eA = B, g = A, B = (pA - (A = -2097152 & tA) | 0) + (tA = (2097151 & GA) << 11 | FA >>> 21) | 0, A = (HA - ((A >>> 0 > pA >>> 0) + lA | 0) | 0) + (GA >> 21) | 0, FA = A = B >>> 0 < tA >>> 0 ? A + 1 | 0 : A, xA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, pA = C = A >> 21, A = kA(uA = (2097151 & A) << 11 | (GA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, TA = C - (A = -2097152 & yA) | 0, XA = g - ((A >>> 0 > C >>> 0) + YA | 0) | 0, g = kA(uA, pA, 136657, 0), A = h + sA | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, VA = C - (g = -2097152 & SA) | 0, LA = A - ((g >>> 0 > C >>> 0) + LA | 0) | 0, g = kA($A, CA, 666643, 0), A = h + (wA - (((C = -2097152 & nA) >>> 0 > hA >>> 0) + jA | 0) | 0) | 0, A = g >>> 0 > (eA = g + (hA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA(KA, bA, -997805, -1), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 470296, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 654183, 0), A = h + C | 0, YA = eA = g + eA | 0, sA = g >>> 0 > eA >>> 0 ? A + 1 | 0 : A, C = zA >>> 5 & 2097151, A = kA(Y, 0, m, 0), g = h, yA = A, A = kA(d, 0, x, 0), g = h + g | 0, A = A >>> 0 > (eA = yA + A | 0) >>> 0 ? g + 1 | 0 : g, yA = g = C + eA | 0, C = A = g >>> 0 < eA >>> 0 ? A + 1 | 0 : A, hA = (g = kA(Y, 0, x, 0)) + (A = (A = a[f + 2 | 0]) << 16 & 2031616 | a[0 | f] | a[f + 1 | 0] << 8) | 0, g = h, tA = g = A >>> 0 > hA >>> 0 ? g + 1 | 0 : g, lA = g = g - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, nA = A = (g = (2097151 & g) << 11 | (wA = hA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, zA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (rA = HA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (eA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(KA, bA, 654183, 0), A = h + (g - (((i = -2097152 & _A) >>> 0 > eA >>> 0) + qA | 0) | 0) | 0, A = C >>> 0 > (DA = C + (eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = kA(UA, mA, 666643, 0), A = h + A | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, SA = (g = C) + (C = kA(vA, dA, 470296, 0)) | 0, g = h + A | 0, yA = g = C >>> 0 > SA >>> 0 ? g + 1 | 0 : g, jA = g = g - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, _A = g = (C = (g = (2097151 & g) << 11 | (eA = SA - -1048576 | 0) >>> 21) >>> 0 > (DA = g + YA | 0) >>> 0 ? C + 1 | 0 : C) - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = DA - -1048576 | 0) >>> 21, g = (g >> 21) + LA | 0, mA = UA = sA + VA | 0, sA = sA >>> 0 > UA >>> 0 ? g + 1 | 0 : g, A = kA(uA, pA, -997805, -1), g = h + C | 0, g = A >>> 0 > (DA = A + DA | 0) >>> 0 ? g + 1 | 0 : g, LA = DA - (A = -2097152 & i) | 0, YA = g - ((A >>> 0 > DA >>> 0) + _A | 0) | 0, g = kA(uA, pA, 654183, 0), A = h + yA | 0, A = g >>> 0 > (C = g + SA | 0) >>> 0 ? A + 1 | 0 : A, UA = C - (g = -2097152 & eA) | 0, _A = A - ((g >>> 0 > C >>> 0) + jA | 0) | 0, A = kA(KA, bA, 470296, 0), C = h + (nA - (((g = -2097152 & rA) >>> 0 > HA >>> 0) + zA | 0) | 0) | 0, C = A >>> 0 > (i = A + (HA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 666643, 0), A = h + C | 0, DA = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = kA(KA, bA, 666643, 0), A = h + (tA - ((4095 & lA) + ((i = -2097152 & wA) >>> 0 > hA >>> 0) | 0) | 0) | 0, SA = A = g >>> 0 > (rA = g + (hA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, tA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (yA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (eA = i + DA | 0) >>> 0 ? A + 1 | 0 : A, wA = A = A - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (DA = eA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, i = i >>> 0 > (nA = i + UA | 0) >>> 0 ? A + 1 | 0 : A, A = kA(uA, pA, 470296, 0), C = h + C | 0, C = A >>> 0 > (g = A + eA | 0) >>> 0 ? C + 1 | 0 : C, eA = g - (A = -2097152 & DA) | 0, DA = C - ((A >>> 0 > g >>> 0) + wA | 0) | 0, g = kA(uA, pA, 666643, 0), A = h + (SA - (((C = -2097152 & yA) >>> 0 > rA >>> 0) + tA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (HA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + DA | 0, A = (A = (g = (A = (2097151 & A) << 11 | HA >>> 21) >>> 0 > (_A = A + eA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | _A >>> 21) >>> 0 > (tA = g + nA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + YA | 0, C = (A = (g = (A = (2097151 & A) << 11 | tA >>> 21) >>> 0 > (i = A + LA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (wA = g + mA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + XA | 0, g = (C = (A = (C = (2097151 & C) << 11 | wA >>> 21) >>> 0 > (nA = C + TA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | nA >>> 21) >>> 0 > (rA = A + PA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, g = (g = (A = (g = (2097151 & g) << 11 | rA >>> 21) >>> 0 > (sA = g + RA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + JA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (SA = A + OA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + AI | 0, A = (g = (C = (g = (2097151 & g) << 11 | SA >>> 21) >>> 0 > (yA = g + QI | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + BI | 0, DA = (GA = B - (g = -2097152 & GA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | yA >>> 21) >>> 0 > (eA = C + CI | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | eA >>> 21) | 0, A = (FA - ((g >>> 0 > B >>> 0) + xA | 0) | 0) + (A >> 21) | 0, GA = g = (A = DA >>> 0 < GA >>> 0 ? A + 1 | 0 : A) >> 21, HA = (A = kA(NA = (2097151 & A) << 11 | DA >>> 21, g, 666643, 0)) + (g = 2097151 & HA) | 0, A = h, B = A = g >>> 0 > HA >>> 0 ? A + 1 | 0 : A, E[0 | Q] = HA, E[Q + 1 | 0] = (255 & A) << 24 | HA >>> 8, A = 2097151 & _A, g = kA(NA, GA, 470296, 0) + A | 0, C = h, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (FA = (2097151 & B) << 11 | HA >>> 21) >>> 0 > (_A = FA + g | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 4 | 0] = (2047 & A) << 21 | _A >>> 11, g = A, C = _A, E[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, E[Q + 2 | 0] = 31 & ((65535 & B) << 16 | HA >>> 16) | C << 5, B = 2097151 & tA, tA = kA(NA, GA, 654183, 0) + B | 0, A = h, _A = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > tA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (tA = _A + tA | 0) >>> 0 < _A >>> 0 ? g + 1 | 0 : g, E[Q + 6 | 0] = (63 & A) << 26 | tA >>> 6, B = tA, tA = 0, E[Q + 5 | 0] = tA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = kA(NA, GA, -997805, -1) + C | 0, g = h, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, tA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = tA + i | 0) >>> 0 < tA >>> 0 ? C + 1 | 0 : C, E[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, E[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, E[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & wA, B = kA(NA, GA, 136657, 0) + g | 0, A = h, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, wA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = wA + B | 0) >>> 0 < wA >>> 0 ? g + 1 | 0 : g, E[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, E[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, E[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & nA, i = kA(NA, GA, -683901, -1) + B | 0, A = h, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (nA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, E[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, E[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & rA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, E[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, E[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, E[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & SA) + (SA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < SA >>> 0 ? g + 1 | 0 : g, SA = B, E[Q + 21 | 0] = B, sA = 0, E[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, E[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & yA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, E[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, E[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, E[Q + 23 | 0] = 31 & ((65535 & g) << 16 | SA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & eA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, E[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & DA) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, E[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, E[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, E[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, E[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, iI(c, 64), iI(f, 64), I && (o[I >> 2] = 64, o[I + 4 >> 2] = 0), w = e + 560 | 0, 0;
                                    }
                                    function k(A, I, g, C) {
                                        for(var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0; i = (B = f << 3) + g | 0, Q = a[0 | (B = I + B | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, M = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, e = (E = 16711680 & Q) << 24, E = E >>> 8 | 0, B = (D = -16777216 & Q) >>> 24 | 0, o[i >> 2] = e | D << 8 | -16777216 & ((255 & M) << 24 | Q >>> 8) | 16711680 & ((16777215 & M) << 8 | Q >>> 24) | M >>> 8 & 65280 | M >>> 24, Q = B | E | c, B = 0, o[i + 4 >> 2] = Q | B | B, 16 != (0 | (f = f + 1 | 0)););
                                        for(I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I, I = o[A + 60 >> 2], o[C + 56 >> 2] = o[A + 56 >> 2], o[C + 60 >> 2] = I, I = o[A + 52 >> 2], o[C + 48 >> 2] = o[A + 48 >> 2], o[C + 52 >> 2] = I, I = o[A + 44 >> 2], o[C + 40 >> 2] = o[A + 40 >> 2], o[C + 44 >> 2] = I, I = o[A + 36 >> 2], o[C + 32 >> 2] = o[A + 32 >> 2], o[C + 36 >> 2] = I, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I; i = o[C + 56 >> 2], E = o[C + 60 >> 2], B = o[(I = M = (p = l << 3) + g | 0) >> 2], I = o[I + 4 >> 2], S = Q = o[C + 36 >> 2], Q = DA(s = o[C + 32 >> 2], Q, 50), f = h, Q = DA(s, S, 46) ^ Q, f ^= h, Q = DA(s, S, 23) ^ Q, I = (h ^ f) + I | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (f = o[(Q = p + 34368 | 0) >> 2]) + B | 0, I = o[Q + 4 >> 2] + I | 0, I = B >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = ((e = o[C + 48 >> 2]) ^ (t = o[C + 40 >> 2])) & s ^ e) + B | 0, B = (((k = o[C + 52 >> 2]) ^ (H = o[C + 44 >> 2])) & S ^ k) + I | 0, I = (Q >>> 0 < f >>> 0 ? B + 1 | 0 : B) + E | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, f = (Q = o[C + 24 >> 2]) + i | 0, B = o[C + 28 >> 2] + I | 0, y = B = Q >>> 0 > f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, F = B = o[C + 4 >> 2], B = DA(Q = o[C >> 2], B, 36), E = h, B = DA(Q, F, 30) ^ B, E ^= h, D = i + (DA(Q, F, 25) ^ B) | 0, B = I + (h ^ E) | 0, B = i >>> 0 > D >>> 0 ? B + 1 | 0 : B, c = (I = D) + (D = Q & ((E = o[C + 16 >> 2]) | (i = o[C + 8 >> 2])) | i & E) | 0, I = (I = B) + (F & ((B = o[C + 20 >> 2]) | (w = o[C + 12 >> 2])) | B & w) | 0, D = I = c >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = c, o[C + 60 >> 2] = I, r = E, n = B, _ = o[(I = v = (G = 8 | p) + g | 0) >> 2], J = o[I + 4 >> 2], B = ((S ^ H) & y ^ H) + k | 0, B = (I = (E = (t ^ s) & f ^ t) + e | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = DA(f, y, 50), e = h, E = DA(f, y, 46) ^ E, e ^= h, E = (k = DA(f, y, 23) ^ E) + I | 0, I = (h ^ e) + B | 0, I = (E >>> 0 < k >>> 0 ? I + 1 | 0 : I) + J | 0, I = (B = E + _ | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = (E = B) + (e = o[(B = G + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (I = E >>> 0 < e >>> 0 ? B + 1 | 0 : B) + n | 0, k = B = (e = E + r | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + ((w | F) & D | w & F) | 0, I = (B = E + ((Q | i) & c | Q & i) | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(c, D, 36), r = h, E = DA(c, D, 30) ^ E, r ^= h, n = B, B = DA(c, D, 25) ^ E, I = (h ^ r) + I | 0, r = I = B >>> 0 > (E = n + B | 0) >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = E, o[C + 52 >> 2] = I, n = i, G = w, I = (w = o[(B = d = (i = 16 | p) + g | 0) >> 2]) + t | 0, B = o[B + 4 >> 2] + H | 0, B = I >>> 0 < w >>> 0 ? B + 1 | 0 : B, i = (t = I) + (w = o[(I = i + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = ((y ^ S) & k ^ S) + (I = i >>> 0 < w >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = i) + (i = (f ^ s) & e ^ s) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = DA(e, k, 50), w = h, i = DA(e, k, 46) ^ i, w ^= h, i = (t = DA(e, k, 23) ^ i) + B | 0, B = (h ^ w) + I | 0, B = (t = i >>> 0 < t >>> 0 ? B + 1 | 0 : B) + G | 0, G = B = (w = i) >>> 0 > (i = i + n | 0) >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = i, o[C + 12 >> 2] = B, I = DA(E, r, 36), B = h, I = DA(E, r, 30) ^ I, B ^= h, H = DA(E, r, 25) ^ I, I = ((D | F) & r | D & F) + (h ^ B) | 0, B = t + ((n = H + ((Q | c) & E | Q & c) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) | 0, w = B = (t = w + n | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = t, o[C + 44 >> 2] = B, n = Q, B = (B = s) + (s = o[(I = L = (Q = 24 | p) + g | 0) >> 2]) | 0, I = o[I + 4 >> 2] + S | 0, I = B >>> 0 < s >>> 0 ? I + 1 | 0 : I, Q = (H = B) + (s = o[(B = Q + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (y ^ (y ^ k) & G) + (B = Q >>> 0 < s >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = f ^ (f ^ e) & i) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(i, G, 50), s = h, Q = DA(i, G, 46) ^ Q, s ^= h, Q = (S = DA(i, G, 23) ^ Q) + I | 0, I = (h ^ s) + B | 0, B = (I = Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) + F | 0, S = B = (F = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C >> 2] = F, o[C + 4 >> 2] = B, B = DA(t, w, 36), s = h, B = DA(t, w, 30) ^ B, n = h ^ s, H = DA(t, w, 25) ^ B, B = ((D | r) & w | D & r) + (h ^ n) | 0, I = I + ((s = H + ((E | c) & t | E & c) | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, s = I = (n = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = n, o[C + 36 >> 2] = I, Q = o[(B = P = (I = 32 | p) + g | 0) >> 2], B = y + o[B + 4 >> 2] | 0, B = (Q = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, Q = (f = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (k ^ (k ^ G) & S) + (I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = e ^ (i ^ e) & F) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(F, S, 50), f = h, Q = DA(F, S, 46) ^ Q, f ^= h, Q = (y = DA(F, S, 23) ^ Q) + B | 0, B = (h ^ f) + I | 0, H = B = Q >>> 0 < y >>> 0 ? B + 1 | 0 : B, I = B, B = DA(n, s, 36), f = h, B = DA(n, s, 30) ^ B, y = h ^ f, _ = DA(n, s, 25) ^ B, B = ((r | w) & s | r & w) + (h ^ y) | 0, I = ((f = _ + ((E | t) & n | E & t) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, f = I = (y = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, o[C + 24 >> 2] = y, o[C + 28 >> 2] = I, B = D + H | 0, H = B = (D = Q + c | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = D, o[C + 60 >> 2] = B, Q = o[(I = K = (B = 40 | p) + g | 0) >> 2], I = k + o[I + 4 >> 2] | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, Q = (c = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = i ^ (i ^ F) & D) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(D, H, 50), c = h, Q = DA(D, H, 46) ^ Q, c ^= h, Q = (e = DA(D, H, 23) ^ Q) + I | 0, I = (h ^ c) + B | 0, I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I, B = DA(y, f, 36), c = h, B = DA(y, f, 30) ^ B, e = h ^ c, k = DA(y, f, 25) ^ B, B = ((w | s) & f | w & s) + (h ^ e) | 0, B = ((c = k + ((t | n) & y | t & n) | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B) + I | 0, c = B = (e = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + r | 0, _ = I = (r = Q + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = r, o[C + 52 >> 2] = I, Q = o[(B = Y = (I = 48 | p) + g | 0) >> 2], B = G + o[B + 4 >> 2] | 0, B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, Q = (i = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = F ^ (D ^ F) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(r, _, 50), i = h, Q = DA(r, _, 46) ^ Q, i ^= h, Q = (E = DA(r, _, 23) ^ Q) + B | 0, B = (h ^ i) + I | 0, E = B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, I = B, B = DA(e, c, 36), i = h, B = DA(e, c, 30) ^ B, k = h ^ i, G = DA(e, c, 25) ^ B, B = ((f | s) & c | f & s) + (h ^ k) | 0, I = ((i = G + ((y | n) & e | y & n) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, k = I = (B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, o[C + 8 >> 2] = i, o[C + 12 >> 2] = I, B = E + w | 0, G = B = (J = Q + t | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = J, o[C + 44 >> 2] = B, Q = o[(I = b = (B = 56 | p) + g | 0) >> 2], I = S + o[I + 4 >> 2] | 0, I = (Q = Q + F | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I, Q = (E = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (H ^ (H ^ _) & G) + (B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = D ^ (D ^ r) & J) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(J, G, 50), E = h, Q = DA(J, G, 46) ^ Q, E ^= h, Q = (w = DA(J, G, 23) ^ Q) + I | 0, I = (h ^ E) + B | 0, I = Q >>> 0 < w >>> 0 ? I + 1 | 0 : I, B = DA(i, k, 36), E = h, B = DA(i, k, 30) ^ B, w = h ^ E, t = DA(i, k, 25) ^ B, B = ((f | c) & k | f & c) + (h ^ w) | 0, B = ((E = t + ((e | y) & i | e & y) | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) + I | 0, w = B = (w = E) >>> 0 > (E = Q + E | 0) >>> 0 ? B + 1 | 0 : B, o[C >> 2] = E, o[C + 4 >> 2] = B, I = I + s | 0, S = I = (t = Q + n | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = t, o[C + 36 >> 2] = I, Q = o[(B = R = (I = 64 | p) + g | 0) >> 2], B = H + o[B + 4 >> 2] | 0, B = (Q = Q + D | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, Q = (D = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (_ ^ (G ^ _) & S) + (I = Q >>> 0 < D >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = r ^ (r ^ J) & t) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(t, S, 50), D = h, Q = DA(t, S, 46) ^ Q, D ^= h, Q = (F = DA(t, S, 23) ^ Q) + B | 0, B = (h ^ D) + I | 0, s = B = Q >>> 0 < F >>> 0 ? B + 1 | 0 : B, I = B, B = DA(E, w, 36), D = h, B = DA(E, w, 30) ^ B, F = h ^ D, n = DA(E, w, 25) ^ B, B = ((c | k) & w | c & k) + (h ^ F) | 0, I = ((D = n + ((i | e) & E | i & e) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, D = I = (F = Q + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = F, o[C + 60 >> 2] = I, B = f + s | 0, H = B = (f = Q + y | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, Q = o[(I = U = (B = 72 | p) + g | 0) >> 2], I = _ + o[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = J ^ (t ^ J) & f) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(f, H, 50), r = h, Q = DA(f, H, 46) ^ Q, r ^= h, Q = (s = DA(f, H, 23) ^ Q) + I | 0, I = (h ^ r) + B | 0, I = Q >>> 0 < s >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 36), r = h, B = DA(F, D, 30) ^ B, s = h ^ r, n = DA(F, D, 25) ^ B, B = ((w | k) & D | w & k) + (h ^ s) | 0, B = ((r = n + ((i | E) & F | i & E) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, r = B = (s = Q + r | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, o[C + 48 >> 2] = s, o[C + 52 >> 2] = B, I = I + c | 0, _ = I = (c = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = c, o[C + 20 >> 2] = I, I = (I = J) + (e = o[(B = J = (Q = 80 | p) + g | 0) >> 2]) | 0, B = o[B + 4 >> 2] + G | 0, B = I >>> 0 < e >>> 0 ? B + 1 | 0 : B, Q = (y = I) + (e = o[(I = Q + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = t ^ (f ^ t) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(c, _, 50), e = h, Q = DA(c, _, 46) ^ Q, e ^= h, Q = (n = DA(c, _, 23) ^ Q) + B | 0, B = (h ^ e) + I | 0, y = B = Q >>> 0 < n >>> 0 ? B + 1 | 0 : B, I = B, B = DA(s, r, 36), e = h, B = DA(s, r, 30) ^ B, n = h ^ e, G = DA(s, r, 25) ^ B, B = ((D | w) & r | D & w) + (h ^ n) | 0, I = ((e = G + ((E | F) & s | E & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C + 40 >> 2] = n, o[C + 44 >> 2] = I, B = y + k | 0, k = B = (y = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = y, o[C + 12 >> 2] = B, B = 34368 + (I = 88 | p) | 0, i = o[(I = N = I + g | 0) >> 2], Q = o[B >> 2] + i | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = S + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, B = (H ^ (H ^ _) & k) + (B = (I = Q + t | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = f ^ (f ^ c) & y) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(y, k, 50), i = h, Q = DA(y, k, 46) ^ Q, i ^= h, Q = (t = DA(y, k, 23) ^ Q) + I | 0, I = (h ^ i) + B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = DA(n, e, 36), i = h, B = DA(n, e, 30) ^ B, t = h ^ i, G = DA(n, e, 25) ^ B, B = ((D | r) & e | D & r) + (h ^ t) | 0, B = ((i = G + ((s | F) & n | s & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, t = B = (t = i) >>> 0 > (i = Q + i | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, I = I + w | 0, w = I = (B = E) >>> 0 > (E = Q + E | 0) >>> 0 ? I + 1 | 0 : I, o[C >> 2] = E, o[C + 4 >> 2] = I, B = 34368 + (I = 96 | p) | 0, G = o[(I = u = I + g | 0) >> 2], Q = o[B >> 2] + G | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = H + (Q >>> 0 < G >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = c ^ (c ^ y) & E) + B | 0, B = (_ ^ (k ^ _) & w) + I | 0, B = Q >>> 0 < f >>> 0 ? B + 1 | 0 : B, I = DA(E, w, 50), f = h, I = DA(E, w, 46) ^ I, f ^= h, H = Q, Q = DA(E, w, 23) ^ I, B = (h ^ f) + B | 0, S = B = (I = H + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = I, I = DA(i, t, 36), f = h, I = DA(i, t, 30) ^ I, G = h ^ f, H = DA(i, t, 25) ^ I, I = ((e | r) & t | e & r) + (h ^ G) | 0, B = ((f = H + ((s | n) & i | s & n) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) + B | 0, f = B = (G = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = G, o[C + 28 >> 2] = B, B = D + S | 0, D = B = (F = Q + F | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = F, o[C + 60 >> 2] = B, B = 34368 + (I = 104 | p) | 0, S = o[(I = m = I + g | 0) >> 2], Q = o[B >> 2] + S | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = _ + (Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, Q = (c = y ^ (E ^ y) & F) + I | 0, I = (k ^ (w ^ k) & D) + B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 50), c = h, B = DA(F, D, 46) ^ B, c ^= h, S = DA(F, D, 23) ^ B, B = (h ^ c) + I | 0, H = B = (Q = S + Q | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B, I = B, B = DA(G, f, 36), c = h, B = DA(G, f, 30) ^ B, S = h ^ c, _ = DA(G, f, 25) ^ B, B = ((e | t) & f | e & t) + (h ^ S) | 0, I = ((c = _ + ((i | n) & G | i & n) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, c = I = (S = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = S, o[C + 20 >> 2] = I, I = r + H | 0, r = I = (s = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = s, o[C + 52 >> 2] = I, B = 34368 + (I = 112 | p) | 0, H = o[(Q = _ = I + g | 0) >> 2], I = o[B >> 2] + H | 0, B = o[B + 4 >> 2] + o[Q + 4 >> 2] | 0, B = k + (I >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, B = (w ^ (D ^ w) & r) + (B = (I = I + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = E ^ (E ^ F) & s) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(s, r, 50), y = h, Q = DA(s, r, 46) ^ Q, y ^= h, Q = (k = DA(s, r, 23) ^ Q) + I | 0, I = (h ^ y) + B | 0, H = I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I, B = I, I = DA(S, c, 36), y = h, I = DA(S, c, 30) ^ I, k = h ^ y, x = DA(S, c, 25) ^ I, I = ((f | t) & c | f & t) + (h ^ k) | 0, B = ((y = x + ((i | G) & S | i & G) | 0) >>> 0 < x >>> 0 ? I + 1 | 0 : I) + B | 0, y = B = (k = Q + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = k, o[C + 12 >> 2] = B, B = e + H | 0, Q = B = (e = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = e, o[C + 44 >> 2] = B, B = 34368 + (I = 120 | p) | 0, p = o[(I = n = I + g | 0) >> 2], H = o[B >> 2] + p | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = w + (H >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, I = (D ^ (D ^ r) & Q) + (I = (B = E + H | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (E = F ^ (s ^ F) & e) + B | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(e, Q, 50), D = h, E = DA(e, Q, 46) ^ E, D ^= h, Q = (E = DA(e, Q, 23) ^ E) + B | 0, B = (h ^ D) + I | 0, B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = Q, D = B, I = B, B = DA(k, y, 36), e = h, B = DA(k, y, 30) ^ B, r = h ^ e, w = DA(k, y, 25) ^ B, B = ((f | c) & y | f & c) + (h ^ r) | 0, I = ((e = w + ((S | G) & k | S & G) | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) + I | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C >> 2] = Q, o[C + 4 >> 2] = I, B = D + t | 0, B = (r = i) >>> 0 > (i = i + E | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, 64 != (0 | l);)c = ((l = l + 16 | 0) << 3) + g | 0, E = o[M >> 2], f = o[M + 4 >> 2], x = o[U >> 2], D = I = o[U + 4 >> 2], B = I, Q = I = o[_ + 4 >> 2], I = DA(G = o[_ >> 2], I, 45), i = h, r = ((63 & Q) << 26 | G >>> 6) ^ (I = DA(G, Q, 3) ^ I), I = (Q >>> 6 ^ (e = h ^ i)) + B | 0, B = ((i = r + x | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + f | 0, B = (I = i + E | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, E = i = o[v + 4 >> 2], i = DA(f = o[v >> 2], i, 63), e = h, i = ((127 & E) << 25 | f >>> 7) ^ DA(f, E, 56) ^ i, B = (h ^ e ^ E >>> 7) + B | 0, i = B = i >>> 0 > (S = i + I | 0) >>> 0 ? B + 1 | 0 : B, o[c >> 2] = S, o[c + 4 >> 2] = B, f = (_ = o[J >> 2]) + f | 0, I = (c = o[J + 4 >> 2]) + E | 0, B = f >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E = I = o[n + 4 >> 2], I = DA(H = o[n >> 2], I, 45), e = h, r = f, f = ((63 & E) << 26 | H >>> 6) ^ DA(H, E, 3) ^ I, B = (h ^ e ^ E >>> 6) + B | 0, f = f >>> 0 > (r = r + f | 0) >>> 0 ? B + 1 | 0 : B, B = DA(e = o[d >> 2], I = o[d + 4 >> 2], 63), w = h, y = r, r = ((127 & I) << 25 | e >>> 7) ^ DA(e, I, 56) ^ B, B = (h ^ w ^ I >>> 7) + f | 0, f = B = r >>> 0 > (k = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 136 >> 2] = k, o[M + 140 >> 2] = B, B = (J = o[N >> 2]) + e | 0, I = (e = o[N + 4 >> 2]) + I | 0, r = DA(S, i, 45), w = h, r = (t = ((63 & i) << 26 | S >>> 6) ^ DA(S, i, 3) ^ r) + B | 0, B = (h ^ w ^ i >>> 6) + (B >>> 0 < J >>> 0 ? I + 1 | 0 : I) | 0, B = r >>> 0 < t >>> 0 ? B + 1 | 0 : B, w = I = o[L + 4 >> 2], I = DA(t = o[L >> 2], I, 63), F = h, y = r, r = ((127 & w) << 25 | t >>> 7) ^ DA(t, w, 56) ^ I, B = (h ^ F ^ w >>> 7) + B | 0, r = B = r >>> 0 > (p = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 144 >> 2] = p, o[M + 148 >> 2] = B, t = (v = o[u >> 2]) + t | 0, I = (I = w) + (w = o[u + 4 >> 2]) | 0, B = t >>> 0 < v >>> 0 ? I + 1 | 0 : I, I = DA(k, f, 45), F = h, s = ((63 & f) << 26 | k >>> 6) ^ DA(k, f, 3) ^ I, B = (h ^ F ^ f >>> 6) + B | 0, B = (t = s + t | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, F = I = o[P + 4 >> 2], I = DA(s = o[P >> 2], I, 63), n = h, y = t, t = ((127 & F) << 25 | s >>> 7) ^ DA(s, F, 56) ^ I, B = (h ^ n ^ F >>> 7) + B | 0, t = B = t >>> 0 > (d = y + t | 0) >>> 0 ? B + 1 | 0 : B, o[M + 152 >> 2] = d, o[M + 156 >> 2] = B, I = (L = o[m >> 2]) + s | 0, B = (B = F) + (F = o[m + 4 >> 2]) | 0, s = DA(p, r, 45), n = h, s = ((63 & r) << 26 | p >>> 6) ^ DA(p, r, 3) ^ s, B = (h ^ n ^ r >>> 6) + (I >>> 0 < L >>> 0 ? B + 1 | 0 : B) | 0, s = (y = s + I | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, B = DA(n = o[K >> 2], I = o[K + 4 >> 2], 63), P = h, N = y, y = ((127 & I) << 25 | n >>> 7) ^ (B = DA(n, I, 56) ^ B), B = (I >>> 7 ^ (K = h ^ P)) + s | 0, s = B = y >>> 0 > (P = N + y | 0) >>> 0 ? B + 1 | 0 : B, o[M + 160 >> 2] = P, o[M + 164 >> 2] = B, I = I + Q | 0, I = (B = n + G | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, n = DA(d, t, 45), y = h, n = (K = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ n) + B | 0, B = (h ^ y ^ t >>> 6) + I | 0, B = n >>> 0 < K >>> 0 ? B + 1 | 0 : B, y = o[Y >> 2], Y = I = o[Y + 4 >> 2], I = DA(y, I, 63), K = h, I = DA(y, Y, 56) ^ I, N = n, B = (Y >>> 7 ^ (U = h ^ K)) + B | 0, n = B = (n = ((127 & Y) << 25 | y >>> 7) ^ I) >>> 0 > (K = N + n | 0) >>> 0 ? B + 1 | 0 : B, o[M + 168 >> 2] = K, o[M + 172 >> 2] = B, I = E + Y | 0, I = (B = y + H | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, N = y = o[b + 4 >> 2], y = DA(U = o[b >> 2], y, 63), Y = h, y = (b = ((127 & N) << 25 | U >>> 7) ^ DA(U, N, 56) ^ y) + B | 0, B = (h ^ Y ^ N >>> 7) + I | 0, I = y >>> 0 < b >>> 0 ? B + 1 | 0 : B, B = DA(P, s, 45), Y = h, B = DA(P, s, 3) ^ B, b = h ^ Y, Y = y, I = (s >>> 6 ^ b) + I | 0, y = I = (y = ((63 & s) << 26 | P >>> 6) ^ B) >>> 0 > (Y = Y + y | 0) >>> 0 ? I + 1 | 0 : I, o[M + 176 >> 2] = Y, o[M + 180 >> 2] = I, u = o[R >> 2], R = I = o[R + 4 >> 2], b = I, I = DA(x, D, 63), B = h, m = ((127 & D) << 25 | x >>> 7) ^ DA(x, D, 56) ^ I, I = (h ^ B ^ D >>> 7) + f | 0, B = ((k = m + k | 0) >>> 0 < m >>> 0 ? I + 1 | 0 : I) + b | 0, B = (I = k + u | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B, f = DA(Y, y, 45), k = h, b = (f = ((63 & y) << 26 | Y >>> 6) ^ DA(Y, y, 3) ^ f) + I | 0, I = (h ^ k ^ y >>> 6) + B | 0, f = I = f >>> 0 > b >>> 0 ? I + 1 | 0 : I, o[M + 192 >> 2] = b, o[M + 196 >> 2] = I, B = i + N | 0, B = (I = S + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, k = DA(u, R, 63), U = h, N = ((127 & R) << 25 | u >>> 7) ^ DA(u, R, 56) ^ k, B = (h ^ U ^ R >>> 7) + B | 0, I = (k = N + I | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, B = DA(K, n, 45), U = h, B = DA(K, n, 3) ^ B, R = k, I = (n >>> 6 ^ (N = h ^ U)) + I | 0, k = I = (k = ((63 & n) << 26 | K >>> 6) ^ B) >>> 0 > (U = R + k | 0) >>> 0 ? I + 1 | 0 : I, o[M + 184 >> 2] = U, o[M + 188 >> 2] = I, I = DA(J, e, 63), B = h, I = ((127 & e) << 25 | J >>> 7) ^ DA(J, e, 56) ^ I, B = (h ^ B ^ e >>> 7) + c | 0, I = t + (I >>> 0 > (N = I + _ | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = d + N | 0) >>> 0 < d >>> 0 ? I + 1 | 0 : I, t = DA(b, f, 45), d = h, t = DA(b, f, 3) ^ t, N = h ^ d, d = (t ^= (63 & f) << 26 | b >>> 6) + B | 0, B = (f >>> 6 ^ N) + I | 0, t = B = t >>> 0 > d >>> 0 ? B + 1 | 0 : B, o[M + 208 >> 2] = d, o[M + 212 >> 2] = B, I = DA(_, c, 63), B = h, N = DA(_, c, 56) ^ I, B = ((I = c >>> 7 | 0) ^ h ^ B) + D | 0, I = r + ((c = (_ = N ^ ((127 & c) << 25 | _ >>> 7)) + x | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) | 0, I = (B = c + p | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, D = DA(U, k, 45), c = h, r = (D = ((63 & k) << 26 | U >>> 6) ^ DA(U, k, 3) ^ D) + B | 0, B = (h ^ c ^ k >>> 6) + I | 0, D = B = D >>> 0 > r >>> 0 ? B + 1 | 0 : B, o[M + 200 >> 2] = r, o[M + 204 >> 2] = B, I = DA(L, F, 63), B = h, _ = ((127 & F) << 25 | L >>> 7) ^ DA(L, F, 56) ^ I, I = (h ^ B ^ F >>> 7) + w | 0, B = n + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = c + K | 0) >>> 0 < K >>> 0 ? B + 1 | 0 : B, c = DA(d, t, 45), n = h, _ = I, I = t >>> 6 | 0, c = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ c, B = (I ^ h ^ n) + B | 0, c = B = c >>> 0 > (t = _ + c | 0) >>> 0 ? B + 1 | 0 : B, o[M + 224 >> 2] = t, o[M + 228 >> 2] = B, I = DA(v, w, 63), B = h, I = DA(v, w, 56) ^ I, n = h ^ B, _ = ((127 & w) << 25 | v >>> 7) ^ I, I = ((B = w >>> 7 | 0) ^ n) + e | 0, B = s + ((w = _ + J | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = w + P | 0) >>> 0 < P >>> 0 ? B + 1 | 0 : B, e = DA(r, D, 45), w = h, n = I, I = D >>> 6 | 0, D = ((63 & D) << 26 | r >>> 6) ^ DA(r, D, 3) ^ e, I = (I ^ h ^ w) + B | 0, D = I = (e = n + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[M + 216 >> 2] = e, o[M + 220 >> 2] = I, I = DA(H, E, 63), B = h, w = ((127 & E) << 25 | H >>> 7) ^ DA(H, E, 56) ^ I, B = (h ^ B ^ E >>> 7) + Q | 0, B = k + ((I = w + G | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) | 0, I = (r = I + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, B = DA(t, c, 45), w = h, n = r, r = DA(t, c, 3) ^ B, B = c >>> 6 | 0, c = n + (r ^= (63 & c) << 26 | t >>> 6) | 0, I = (B ^ h ^ w) + I | 0, o[M + 240 >> 2] = c, o[M + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = DA(G, Q, 63), B = h, I = DA(G, Q, 56) ^ I, c = h ^ B, B = ((B = Q >>> 7 | 0) ^ c) + F | 0, I = y + ((I ^= (127 & Q) << 25 | G >>> 7) >>> 0 > (Q = I + L | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = DA(e, D, 45), c = h, r = B, B = D >>> 6 | 0, Q = ((63 & D) << 26 | e >>> 6) ^ DA(e, D, 3) ^ Q, B = (B ^ h ^ c) + I | 0, Q = B = Q >>> 0 > (D = r + Q | 0) >>> 0 ? B + 1 | 0 : B, o[M + 232 >> 2] = D, o[M + 236 >> 2] = B, I = DA(S, i, 63), B = h, r = DA(S, i, 56) ^ I, B = ((I = i >>> 7 | 0) ^ h ^ B) + E | 0, I = f + ((i = (c = r ^ ((127 & i) << 25 | S >>> 7)) + H | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, I = (B = i + b | 0) >>> 0 < b >>> 0 ? I + 1 | 0 : I, i = DA(D, Q, 45), E = h, r = B, B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | D >>> 6) ^ DA(D, Q, 3) ^ i) | 0, B = (B ^ h ^ E) + I | 0, o[M + 248 >> 2] = Q, o[M + 252 >> 2] = Q >>> 0 < i >>> 0 ? B + 1 | 0 : B;
                                        I = I + o[A + 4 >> 2] | 0, I = (g = Q + o[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[A >> 2] = g, o[A + 4 >> 2] = I, B = o[A + 12 >> 2] + o[C + 12 >> 2] | 0, I = (g = o[C + 8 >> 2]) + o[A + 8 >> 2] | 0, o[A + 8 >> 2] = I, o[A + 12 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 20 >> 2] + o[C + 20 >> 2] | 0, I = (g = o[C + 16 >> 2]) + o[A + 16 >> 2] | 0, o[A + 16 >> 2] = I, o[A + 20 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 28 >> 2] + o[C + 28 >> 2] | 0, g = (B = o[C + 24 >> 2]) + o[A + 24 >> 2] | 0, o[A + 24 >> 2] = g, o[A + 28 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 36 >> 2] + o[C + 36 >> 2] | 0, I = (g = o[C + 32 >> 2]) + o[A + 32 >> 2] | 0, o[A + 32 >> 2] = I, o[A + 36 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 44 >> 2] + o[C + 44 >> 2] | 0, g = (B = o[C + 40 >> 2]) + o[A + 40 >> 2] | 0, o[A + 40 >> 2] = g, o[A + 44 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 52 >> 2] + o[C + 52 >> 2] | 0, I = (g = o[C + 48 >> 2]) + o[A + 48 >> 2] | 0, o[A + 48 >> 2] = I, o[A + 52 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 60 >> 2] + o[C + 60 >> 2] | 0, I = (g = o[C + 56 >> 2]) + o[A + 56 >> 2] | 0, o[A + 56 >> 2] = I, o[A + 60 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B;
                                    }
                                    function F(A) {
                                        var I, g, C, B, Q, i, o, f, c, e, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0;
                                        y = (G = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, t = kA(b = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), D = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = h, k = r = D >>> 0 > (F = t + D | 0) >>> 0 ? r + 1 | 0 : r, N = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, t = r >> 21, r = (D = y) + (y = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21) | 0, D = t, l = D = r >>> 0 < y >>> 0 ? D + 1 | 0 : D, z = r, Y = kA(r, D, -683901, -1), S = h, s = kA(I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), t = (r = a[A + 27 | 0]) >>> 24 | 0, y = r << 8 | (_ = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, D = (r = a[A + 28 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = y | r << 16) >>> 2), r = h, r = D >>> 0 > (t = D + s | 0) >>> 0 ? r + 1 | 0 : r, D = kA(u = (M = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = h + r | 0, s = t = D + t | 0, t = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, w = (D = a[A + 48 | 0]) << 8 | G >>> 24, D = r = D >>> 24 | 0, r = kA(g = 2097151 & ((3 & (G = (r = (y = a[A + 49 | 0]) >>> 16 | 0) | D)) << 30 | (D = (y <<= 16) | w) >>> 2), 0, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + s | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + D | 0, D = h + t | 0, s = y, t = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, D = (r = a[A + 56 | 0]) >>> 24 | 0, w = r << 8 | M >>> 24, D = kA(B = 2097151 & ((1 & (M = (r = (y = a[A + 57 | 0]) >>> 16 | 0) | D)) << 31 | (D = (y <<= 16) | w) >>> 1), 0, 470296, 0), r = h + t | 0, D = (r = (t = y = D + s | 0) >>> 0 < D >>> 0 ? r + 1 | 0 : r) + S | 0, D = t >>> 0 > (y = t + Y | 0) >>> 0 ? D + 1 | 0 : D, J = t - -1048576 | 0, U = t = r - ((t >>> 0 < 4293918720) - 1 | 0) | 0, S = y - (r = -2097152 & J) | 0, Y = D - ((r >>> 0 > y >>> 0) + t | 0) | 0, D = kA(I, 0, 654183, 0), r = h, r = D >>> 0 > (t = D + (_ >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(u, 0, 470296, 0)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + y | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(B, j, 666643, 0)) | 0, r = h + D | 0, w = y, y = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, s = (t = kA(I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, t = h, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, s = (D = kA(u, 0, 666643, 0)) + s | 0, r = h + t | 0, t = kA(g, X, 654183, 0), D = h + (D >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = D = t >>> 0 > (_ = t + s | 0) >>> 0 ? D + 1 | 0 : D, R = D = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >>> 21 | 0) + y | 0, t = r = (D = (2097151 & D) << 11 | (s = _ - -1048576 | 0) >>> 21) >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, H = D = r - ((w >>> 0 < 4293918720) - 1 | 0) | 0, r = S, S = (2097151 & D) << 11 | (y = w - -1048576 | 0) >>> 21, D = (D >> 21) + Y | 0, G = S = (D = S >>> 0 > (p = r + S | 0) >>> 0 ? D + 1 | 0 : D) - ((p >>> 0 < 4293918720) - 1 | 0) | 0, x = p - (r = -2097152 & (Y = p - -1048576 | 0)) | 0, T = D - ((r >>> 0 > p >>> 0) + S | 0) | 0, r = kA(z, l, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, K = D - (r = -2097152 & y) | 0, m = t - ((r >>> 0 > D >>> 0) + H | 0) | 0, p = F - (r = -2097152 & n) | 0, N = k - ((r >>> 0 > F >>> 0) + N | 0) | 0, k = kA(b, 0, 136657, 0), D = (r = a[A + 40 | 0]) >>> 24 | 0, y = r << 8 | (n = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, t = (r = a[A + 41 | 0]) >>> 16 | 0, D = (t |= D) >>> 3 | 0, t = (7 & t) << 29 | (r = y | r << 16) >>> 3, r = D + h | 0, r = t >>> 0 > (y = t + k | 0) >>> 0 ? r + 1 | 0 : r, D = kA(C, 0, -683901, -1), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, w = t, D = kA(b, 0, -997805, -1), t = h, t = D >>> 0 > (y = D + (n >>> 6 & 2097151) | 0) >>> 0 ? t + 1 | 0 : t, n = (D = y) + (y = kA(C, 0, 136657, 0)) | 0, D = h + t | 0, t = kA(B, j, -683901, -1), D = h + (y >>> 0 > n >>> 0 ? D + 1 | 0 : D) | 0, S = D = t >>> 0 > (P = t + n | 0) >>> 0 ? D + 1 | 0 : D, O = t = D - ((P >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >> 21) | 0, n = r = (t = (2097151 & t) << 11 | (F = P - -1048576 | 0) >>> 21) >>> 0 > (H = t + w | 0) >>> 0 ? r + 1 | 0 : r, v = r = r - ((H >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >> 21) + N | 0, q = D = (r = (t = (2097151 & r) << 11 | (w = H - -1048576 | 0) >>> 21) + p | 0) >>> 0 < t >>> 0 ? D + 1 | 0 : D, L = r, D = kA(r, D, -683901, -1), r = h + m | 0, d = t = D + K | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, m = _ - (r = -2097152 & s) | 0, N = M - ((4095 & R) + (r >>> 0 > _ >>> 0) | 0) | 0, _ = kA(I, 0, 666643, 0), r = (D = a[A + 19 | 0]) >>> 24 | 0, s = D << 8 | (M = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, t = r, D = (7 & (t |= D = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (D = (r <<= 16) | s) >>> 3, t = h + (t >>> 3 | 0) | 0, t = D >>> 0 > (s = D + _ | 0) >>> 0 ? t + 1 | 0 : t, r = kA(g, X, 470296, 0), D = h + t | 0, r = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, t = kA(g, X, 666643, 0), D = h, _ = D = t >>> 0 > (K = t + (M >>> 6 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, V = t = D - ((K >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >>> 21 | 0) | 0, M = r = (t = (2097151 & t) << 11 | (k = K - -1048576 | 0) >>> 21) >>> 0 > (p = t + s | 0) >>> 0 ? r + 1 | 0 : r, Z = r = r - ((p >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >>> 21 | 0) + N | 0, D = (r = (2097151 & r) << 11 | (s = p - -1048576 | 0) >>> 21) >>> 0 > (t = r + m | 0) >>> 0 ? D + 1 | 0 : D, N = (r = t) + (t = kA(z, l, -997805, -1)) | 0, r = h + D | 0, r = t >>> 0 > N >>> 0 ? r + 1 | 0 : r, R = D = H - (t = -2097152 & w) | 0, Q = w = n - ((t >>> 0 > H >>> 0) + v | 0) | 0, t = kA(L, q, 136657, 0), r = h + r | 0, r = t >>> 0 > (n = t + N | 0) >>> 0 ? r + 1 | 0 : r, t = kA(D, w, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (N = t + n | 0) >>> 0 ? D + 1 | 0 : D, v = r = D - ((N >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = N - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, d = D = (r = D >>> 0 > (H = D + d | 0) >>> 0 ? r + 1 | 0 : r) - ((H >>> 0 < 4293918720) - 1 | 0) | 0, m = (2097151 & D) << 11 | (y = H - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, o = x = m + x | 0, m = x >>> 0 < m >>> 0 ? D + 1 | 0 : D, f = H - (D = -2097152 & y) | 0, c = r - ((D >>> 0 > H >>> 0) + d | 0) | 0, x = N - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > N >>> 0) + v | 0) | 0, t = (r = kA(z, l, 654183, 0)) + (p - (D = -2097152 & s) | 0) | 0, D = h + (M - ((2147483647 & Z) + (D >>> 0 > p >>> 0) | 0) | 0) | 0, D = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, r = kA(L, q, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(R, Q, 136657, 0)) | 0, r = h + D | 0, d = y, n = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, p = P - (r = -2097152 & F) | 0, H = S - ((r >>> 0 > P >>> 0) + O | 0) | 0, M = kA(u, 0, -683901, -1), r = (D = a[A + 35 | 0]) >>> 24 | 0, y = D << 8 | (s = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, t = r, D = (r = a[A + 36 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + M | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(b, 0, 654183, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, t = kA(C, 0, -997805, -1), r = h + D | 0, r = t >>> 0 > (y = t + y | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 136657, 0), r = h + r | 0, w = t = D + y | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(I, 0, -683901, -1), D = h, D = r >>> 0 > (t = r + (s >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, s = (r = kA(u, 0, 136657, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, r = kA(b, 0, 470296, 0), D = h + t | 0, D = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, s = (t = kA(C, 0, 654183, 0)) + s | 0, r = h + D | 0, D = kA(B, j, -997805, -1), r = h + (t >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = r = D >>> 0 > (S = D + s | 0) >>> 0 ? r + 1 | 0 : r, e = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, t = (r = D >> 21) + y | 0, N = D = (t = (D = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21) >>> 0 > (F = D + w | 0) >>> 0 ? t + 1 | 0 : t) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >> 21) + H | 0, v = r = (D = (y = (2097151 & D) << 11 | (w = F - -1048576 | 0) >>> 21) + p | 0) >>> 0 < y >>> 0 ? r + 1 | 0 : r, y = d, d = D, r = kA(D, r, -683901, -1), D = h + n | 0, H = y = y + r | 0, y = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, n = (r = kA(z, l, 470296, 0)) + (K - (D = -2097152 & k) | 0) | 0, D = h + (_ - ((2047 & V) + (D >>> 0 > K >>> 0) | 0) | 0) | 0, D = r >>> 0 > n >>> 0 ? D + 1 | 0 : D, k = (r = n) + (n = kA(L, q, 654183, 0)) | 0, r = h + D | 0, r = n >>> 0 > k >>> 0 ? r + 1 | 0 : r, n = kA(R, Q, -997805, -1), D = h + r | 0, D = n >>> 0 > (k = n + k | 0) >>> 0 ? D + 1 | 0 : D, P = w = F - (r = -2097152 & w) | 0, i = n = t - ((r >>> 0 > F >>> 0) + N | 0) | 0, t = kA(d, v, 136657, 0), r = h + D | 0, r = t >>> 0 > (k = t + k | 0) >>> 0 ? r + 1 | 0 : r, t = kA(w, n, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (_ = t + k | 0) >>> 0 ? D + 1 | 0 : D, N = r = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = _ - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, H = D = (r = D >>> 0 > (k = D + H | 0) >>> 0 ? r + 1 | 0 : r) - ((k >>> 0 < 4293918720) - 1 | 0) | 0, F = (2097151 & D) << 11 | (y = k - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, O = p = F + x | 0, p = F >>> 0 > p >>> 0 ? D + 1 | 0 : D, V = k - (D = -2097152 & y) | 0, Z = r - ((D >>> 0 > k >>> 0) + H | 0) | 0, x = _ - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > _ >>> 0) + N | 0) | 0, n = kA(z, l, 666643, 0), r = (D = a[A + 14 | 0]) >>> 24 | 0, y = D << 8 | (N = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, t = r, D = (r = a[A + 15 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + n | 0) >>> 0 ? t + 1 | 0 : t, y = (r = D) + (D = kA(L, q, 470296, 0)) | 0, r = h + t | 0, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, D = kA(R, Q, 654183, 0), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(d, v, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 136657, 0), D = h + D | 0, _ = t = r + y | 0, y = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, s = S - (r = -2097152 & s) | 0, n = M - ((r >>> 0 > S >>> 0) + e | 0) | 0, t = kA(I, 0, 136657, 0), r = h, r = (D = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (t = D + t | 0) >>> 0 ? r + 1 | 0 : r, w = (D = t) + (t = kA(u, 0, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -683901, -1), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = kA(b, 0, 666643, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > w >>> 0 ? t + 1 | 0 : t, D = kA(C, 0, 470296, 0), r = h + t | 0, r = D >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 654183, 0), r = h + r | 0, D = (U >> 21) + (D >>> 0 > (t = D + w | 0) >>> 0 ? r + 1 | 0 : r) | 0, F = D = (w = (2097151 & U) << 11 | J >>> 21) >>> 0 > (J = w + t | 0) >>> 0 ? D + 1 | 0 : D, H = r = D - ((J >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (k = J - -1048576 | 0) >>> 21, r = (r >> 21) + n | 0, K = r = (D = w + s | 0) >>> 0 < w >>> 0 ? r + 1 | 0 : r, U = D, D = kA(D, r, -683901, -1), r = h + y | 0, w = t = D + _ | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(L, q, 666643, 0), D = h, D = r >>> 0 > (t = r + (N >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(R, Q, 470296, 0), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, n = (r = kA(d, v, 654183, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(P, i, -997805, -1), r = h + t | 0, r = D >>> 0 > (n = D + n | 0) >>> 0 ? r + 1 | 0 : r, D = kA(U, K, 136657, 0), r = h + r | 0, M = r = D >>> 0 > (S = D + n | 0) >>> 0 ? r + 1 | 0 : r, l = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = w, w = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21, D = (D >> 21) + y | 0, L = y = (D = (t = r + w | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D) - ((t >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = y >> 21) + T | 0, z = w = (y = (2097151 & y) << 11 | (n = t - -1048576 | 0) >>> 21) + x | 0, _ = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, w = t, t = D, y = (J - (D = -2097152 & k) | 0) + (k = (2097151 & G) << 11 | Y >>> 21) | 0, D = (F - ((D >>> 0 > J >>> 0) + H | 0) | 0) + (G >> 21) | 0, N = D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, u = D = D - ((y >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = D >> 21, r = kA(b = (2097151 & D) << 11 | (H = y - -1048576 | 0) >>> 21, r, -683901, -1), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, X = D - (r = -2097152 & n) | 0, j = t - ((r >>> 0 > D >>> 0) + L | 0) | 0, r = kA(b, Y, 136657, 0), D = M + h | 0, q = (t = r + S | 0) - (r = -2097152 & s) | 0, L = (D = t >>> 0 < S >>> 0 ? D + 1 | 0 : D) - ((r >>> 0 > t >>> 0) + l | 0) | 0, D = kA(R, Q, 666643, 0), t = h, t = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (D = r + D | 0) >>> 0 ? t + 1 | 0 : t, w = (r = kA(d, v, 470296, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 654183, 0), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = t) + (t = kA(U, K, -997805, -1)) | 0, r = h + D | 0, k = w, w = t >>> 0 > w >>> 0 ? r + 1 | 0 : r, M = kA(d, v, 666643, 0), r = (D = a[A + 6 | 0]) >>> 24 | 0, n = D << 8 | (J = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, t = r, D = (r = a[A + 7 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = r << 16 | n) >>> 2), r = h, r = D >>> 0 > (t = D + M | 0) >>> 0 ? r + 1 | 0 : r, n = (D = kA(P, i, 470296, 0)) + t | 0, t = h + r | 0, t = D >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(U, K, 654183, 0), r = h + t | 0, M = r = D >>> 0 > (F = D + n | 0) >>> 0 ? r + 1 | 0 : r, G = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, D = (t = r >> 21) + w | 0, S = r = (D = (r = (2097151 & r) << 11 | (s = F - -1048576 | 0) >>> 21) >>> 0 > (n = r + k | 0) >>> 0 ? D + 1 | 0 : D) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, k = (2097151 & r) << 11 | (w = n - -1048576 | 0) >>> 21, r = (r >> 21) + L | 0, L = d = k + q | 0, k = k >>> 0 > d >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + n | 0) >>> 0 ? D + 1 | 0 : D, R = t - (r = -2097152 & w) | 0, v = D - ((r >>> 0 > t >>> 0) + S | 0) | 0, D = kA(b, Y, 654183, 0), r = M + h | 0, d = (t = D + F | 0) - (D = -2097152 & s) | 0, G = (r = t >>> 0 < F >>> 0 ? r + 1 | 0 : r) - ((D >>> 0 > t >>> 0) + G | 0) | 0, r = kA(P, i, 666643, 0), D = h, D = r >>> 0 > (t = r + (J >>> 5 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(U, K, 470296, 0), D = h + D | 0, n = t = r + t | 0, t = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, w = kA(U, K, 666643, 0), D = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = h, M = r = D >>> 0 > (S = w + D | 0) >>> 0 ? r + 1 | 0 : r, K = r = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (s = S - -1048576 | 0) >>> 21, r = (r >> 21) + t | 0, t = r = w >>> 0 > (F = w + n | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21, r = (r >> 21) + G | 0, w = w >>> 0 > (G = U = w + d | 0) >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, 470296, 0), t = t + h | 0, t = (D = r + F | 0) >>> 0 < F >>> 0 ? t + 1 | 0 : t, F = D - (r = -2097152 & n) | 0, n = t - ((r >>> 0 > D >>> 0) + J | 0) | 0, D = kA(b, Y, 666643, 0), r = h + (M - (((t = -2097152 & s) >>> 0 > S >>> 0) + K | 0) | 0) | 0, D = (t = (r = D >>> 0 > (U = D + (S - t | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + n | 0, r = (r = (D = (r = (2097151 & r) << 11 | U >>> 21) >>> 0 > (J = r + F | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + w | 0, D = (D = (r = (D = (2097151 & D) << 11 | J >>> 21) >>> 0 > (G = D + G | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + v | 0, t = (r = (D = (r = (2097151 & r) << 11 | G >>> 21) >>> 0 > (w = r + R | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + k | 0, r = (D = (t = (D = (2097151 & D) << 11 | w >>> 21) >>> 0 > (Y = D + L | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + j | 0, D = (t = (r = (t = (2097151 & t) << 11 | Y >>> 21) >>> 0 > (S = t + X | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + _ | 0, r = (r = (D = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (F = r + z | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + Z | 0, D = (D = (r = (D = (2097151 & D) << 11 | F >>> 21) >>> 0 > (_ = D + V | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + p | 0, t = (r = (D = (r = (2097151 & r) << 11 | _ >>> 21) >>> 0 > (k = r + O | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + c | 0, r = (D = (t = (D = (2097151 & D) << 11 | k >>> 21) >>> 0 > (M = D + f | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + m | 0, n = (H = y - (D = -2097152 & H) | 0) + ((2097151 & (r = (t = (2097151 & t) << 11 | M >>> 21) >>> 0 > (s = t + o | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | s >>> 21) | 0, r = (N - ((D >>> 0 > y >>> 0) + u | 0) | 0) + (r >> 21) | 0, H = D = (r = n >>> 0 < H >>> 0 ? r + 1 | 0 : r) >> 21, U = (r = kA(p = (2097151 & r) << 11 | n >>> 21, D, 666643, 0)) + (D = 2097151 & U) | 0, r = h, y = r = D >>> 0 > U >>> 0 ? r + 1 | 0 : r, E[0 | A] = U, E[A + 1 | 0] = (255 & r) << 24 | U >>> 8, r = 2097151 & J, D = kA(p, H, 470296, 0) + r | 0, t = h, r = (y >> 21) + (r >>> 0 > D >>> 0 ? t + 1 | 0 : t) | 0, r = (N = (2097151 & y) << 11 | U >>> 21) >>> 0 > (J = N + D | 0) >>> 0 ? r + 1 | 0 : r, E[A + 4 | 0] = (2047 & r) << 21 | J >>> 11, D = r, t = J, E[A + 3 | 0] = (7 & r) << 29 | t >>> 3, E[A + 2 | 0] = 31 & ((65535 & y) << 16 | U >>> 16) | t << 5, y = 2097151 & G, G = kA(p, H, 654183, 0) + y | 0, r = h, J = (2097151 & D) << 11 | t >>> 21, D = (D >> 21) + (y = y >>> 0 > G >>> 0 ? r + 1 | 0 : r) | 0, r = D = (G = J + G | 0) >>> 0 < J >>> 0 ? D + 1 | 0 : D, E[A + 6 | 0] = (63 & r) << 26 | G >>> 6, y = G, G = 0, E[A + 5 | 0] = G << 13 | (1572864 & t) >>> 19 | y << 2, t = 2097151 & w, w = kA(p, H, -997805, -1) + t | 0, D = h, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, G = (2097151 & (t = r)) << 11 | y >>> 21, t = (r >>= 21) + D | 0, t = (w = G + w | 0) >>> 0 < G >>> 0 ? t + 1 | 0 : t, E[A + 9 | 0] = (511 & t) << 23 | w >>> 9, E[A + 8 | 0] = (1 & t) << 31 | w >>> 1, D = 0, E[A + 7 | 0] = D << 18 | (2080768 & y) >>> 14 | w << 7, D = 2097151 & Y, y = kA(p, H, 136657, 0) + D | 0, r = h, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (D = t)) << 11 | w >>> 21, D = r + (t = D >> 21) | 0, D = (y = Y + y | 0) >>> 0 < Y >>> 0 ? D + 1 | 0 : D, E[A + 12 | 0] = (4095 & D) << 20 | y >>> 12, t = y, E[A + 11 | 0] = (15 & D) << 28 | t >>> 4, y = 0, E[A + 10 | 0] = y << 15 | (1966080 & w) >>> 17 | t << 4, y = 2097151 & S, w = kA(p, H, -683901, -1) + y | 0, r = h, r = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, y = D, D = r + (D >>= 21) | 0, D = (y = (d = w) + (w = (2097151 & y) << 11 | t >>> 21) | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D, E[A + 14 | 0] = (127 & D) << 25 | y >>> 7, w = 0, E[A + 13 | 0] = w << 12 | (1048576 & t) >>> 20 | y << 1, r = D >> 21, t = (D = (2097151 & D) << 11 | y >>> 21) >>> 0 > (w = D + (2097151 & F) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 17 | 0] = (1023 & t) << 22 | w >>> 10, E[A + 16 | 0] = (3 & t) << 30 | w >>> 2, D = 0, E[A + 15 | 0] = D << 17 | (2064384 & y) >>> 15 | w << 6, r = t >> 21, r = (D = (2097151 & t) << 11 | w >>> 21) >>> 0 > (t = D + (2097151 & _) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 20 | 0] = (8191 & r) << 19 | t >>> 13, E[A + 19 | 0] = (31 & r) << 27 | t >>> 5, y = (D = 2097151 & k) + (k = (2097151 & r) << 11 | t >>> 21) | 0, D = r >> 21, D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, k = y, E[A + 21 | 0] = y, _ = 0, E[A + 18 | 0] = _ << 14 | (1835008 & w) >>> 18 | t << 3, E[A + 22 | 0] = (255 & D) << 24 | y >>> 8, t = D >> 21, t = (y = (w = (2097151 & D) << 11 | y >>> 21) + (2097151 & M) | 0) >>> 0 < w >>> 0 ? t + 1 | 0 : t, E[A + 25 | 0] = (2047 & t) << 21 | y >>> 11, E[A + 24 | 0] = (7 & t) << 29 | y >>> 3, E[A + 23 | 0] = 31 & ((65535 & D) << 16 | k >>> 16) | y << 5, r = t >> 21, r = (D = (2097151 & t) << 11 | y >>> 21) >>> 0 > (t = D + (2097151 & s) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 27 | 0] = (63 & r) << 26 | t >>> 6, w = 0, E[A + 26 | 0] = w << 13 | (1572864 & y) >>> 19 | t << 2, D = r >> 21, D = (r = (y = (2097151 & r) << 11 | t >>> 21) + (2097151 & n) | 0) >>> 0 < y >>> 0 ? D + 1 | 0 : D, E[A + 31 | 0] = (131071 & D) << 15 | r >>> 17, E[A + 30 | 0] = (511 & D) << 23 | r >>> 9, E[A + 29 | 0] = (1 & D) << 31 | r >>> 1, y = 0, E[A + 28 | 0] = y << 18 | (2080768 & t) >>> 14 | r << 7;
                                    }
                                    function S(A, I, g, C, B, Q) {
                                        var i, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0, S = 0, _ = 0, M = 0, p = 0, J = 0, Y = 0, d = 0, K = 0, L = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0;
                                        for(w = i = w - 592 | 0, p = -1, S = A + 32 | 0, k = 32, _ = 1; J = a[2672 + (t = k - 1 | 0) | 0], r = (t = ((e = a[t + S | 0]) ^ J) - 1 >> 8 & _) & (y = a[S + (k = k - 2 | 0) | 0]) - (D = a[k + 2672 | 0]) >> 8 | 255 & (e - J >>> 8 & _ | r), _ = t & (D ^ y) - 1 >> 8, k;);
                                        if (255 & r && !(rA(A) | !(((127 & (-1 ^ a[B + 31 | 0]) | a[B + 1 | 0] & a[B + 2 | 0] & a[B + 3 | 0] & a[B + 4 | 0] & a[B + 5 | 0] & a[B + 6 | 0] & a[B + 7 | 0] & a[B + 8 | 0] & a[B + 9 | 0] & a[B + 10 | 0] & a[B + 11 | 0] & a[B + 12 | 0] & a[B + 13 | 0] & a[B + 14 | 0] & a[B + 15 | 0] & a[B + 16 | 0] & a[B + 17 | 0] & a[B + 18 | 0] & a[B + 19 | 0] & a[B + 20 | 0] & a[B + 21 | 0] & a[B + 22 | 0] & a[B + 23 | 0] & a[B + 24 | 0] & a[B + 25 | 0] & a[B + 26 | 0] & a[B + 27 | 0] & a[B + 28 | 0] & a[B + 30 | 0] & a[B + 29 | 0] ^ 255) - 1 & 236 - a[0 | B] ^ -1) >>> 8 & 1) || rA(B) || U(t = i + 128 | 0, B))) {
                                            for(cA(e = i + 384 | 0), Q && R(e, 35136, 34, 0), R(e, A, 32, 0), R(e, B, 32, 0), R(e, I, g, C), N(e, g = i + 320 | 0), F(g), C = i + 8 | 0, B = 0, I = 0, w = f = w - 2272 | 0; e = g + (B >>> 3 | 0) | 0, E[(Q = f + 2016 | 0) + B | 0] = a[0 | e] >>> (6 & B) & 1, E[(r = Q) + (Q = 1 | B) | 0] = a[0 | e] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 2016 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 2016 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 2016 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 2016 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 2016 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 2016 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; g = S + (B >>> 3 | 0) | 0, E[(I = f + 1760 | 0) + B | 0] = a[0 | g] >>> (6 & B) & 1, E[(Q = I) + (I = 1 | B) | 0] = a[0 | g] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 1760 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(W(B = f + 480 | 0, t), I = o[t + 36 >> 2], o[f + 192 >> 2] = o[t + 32 >> 2], o[f + 196 >> 2] = I, I = o[t + 28 >> 2], o[f + 184 >> 2] = o[t + 24 >> 2], o[f + 188 >> 2] = I, I = o[t + 20 >> 2], o[f + 176 >> 2] = o[t + 16 >> 2], o[f + 180 >> 2] = I, I = o[t + 12 >> 2], o[f + 168 >> 2] = o[t + 8 >> 2], o[f + 172 >> 2] = I, I = o[t + 4 >> 2], o[f + 160 >> 2] = o[t >> 2], o[f + 164 >> 2] = I, I = o[t + 52 >> 2], o[f + 208 >> 2] = o[t + 48 >> 2], o[f + 212 >> 2] = I, I = o[t + 60 >> 2], o[f + 216 >> 2] = o[t + 56 >> 2], o[f + 220 >> 2] = I, I = o[4 + (g = t - -64 | 0) >> 2], o[f + 224 >> 2] = o[g >> 2], o[f + 228 >> 2] = I, I = o[t + 76 >> 2], o[f + 232 >> 2] = o[t + 72 >> 2], o[f + 236 >> 2] = I, I = o[t + 44 >> 2], o[f + 200 >> 2] = o[t + 40 >> 2], o[f + 204 >> 2] = I, I = o[t + 92 >> 2], o[f + 248 >> 2] = o[t + 88 >> 2], o[f + 252 >> 2] = I, I = o[t + 100 >> 2], o[f + 256 >> 2] = o[t + 96 >> 2], o[f + 260 >> 2] = I, I = o[t + 108 >> 2], o[f + 264 >> 2] = o[t + 104 >> 2], o[f + 268 >> 2] = I, I = o[t + 116 >> 2], o[f + 272 >> 2] = o[t + 112 >> 2], o[f + 276 >> 2] = I, I = o[t + 84 >> 2], o[f + 240 >> 2] = o[t + 80 >> 2], o[f + 244 >> 2] = I, G(Q = f + 320 | 0, g = f + 160 | 0), H(f, Q, h = f + 440 | 0), H(f + 40 | 0, n = f + 360 | 0, s = f + 400 | 0), H(f + 80 | 0, s, h), H(f + 120 | 0, Q, n), b(Q, f, B), H(g, Q, h), H(Y = f + 200 | 0, n, s), H(d = f + 240 | 0, s, h), H(M = f + 280 | 0, Q, n), W(I = f + 640 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 800 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 960 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1120 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1280 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1440 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(f + 1600 | 0, g), o[C + 32 >> 2] = 0, o[C + 36 >> 2] = 0, o[C + 24 >> 2] = 0, o[C + 28 >> 2] = 0, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, o[C + 8 >> 2] = 0, o[C + 12 >> 2] = 0, o[C >> 2] = 0, o[C + 4 >> 2] = 0, o[C + 44 >> 2] = 0, o[C + 48 >> 2] = 0, o[(j = C + 40 | 0) >> 2] = 1, o[C + 52 >> 2] = 0, o[C + 56 >> 2] = 0, o[C + 60 >> 2] = 0, o[C + 64 >> 2] = 0, o[C + 68 >> 2] = 0, o[C + 72 >> 2] = 0, o[C + 84 >> 2] = 0, o[C + 88 >> 2] = 0, o[C + 76 >> 2] = 0, o[C + 80 >> 2] = 1, o[C + 92 >> 2] = 0, o[C + 96 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, o[C + 116 >> 2] = 0, IA = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = f + 2016 | 0) + I | 0] && !a[(B = f + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; G(B = f + 320 | 0, C), (0 | (Q = E[(g = I) + (f + 2016 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B, h), H(Y, n, s), H(d, s, h), H(M, B, n), b(B, I, (f + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), P(B, I, (f + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (q = E[g + (f + 1760 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), v(B, I, c((254 & q) >>> 1 | 0, 120) + 1488 | 0)) : (0 | q) >= 0 || (H(f + 160 | 0, X = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, X, n), K = o[f + 160 >> 2], L = o[f + 200 >> 2], u = o[f + 164 >> 2], x = o[f + 204 >> 2], m = o[f + 168 >> 2], l = o[f + 208 >> 2], z = o[f + 172 >> 2], k = o[f + 212 >> 2], S = o[f + 176 >> 2], _ = o[f + 216 >> 2], p = o[f + 180 >> 2], J = o[f + 220 >> 2], r = o[f + 184 >> 2], y = o[f + 224 >> 2], D = o[f + 188 >> 2], e = o[f + 228 >> 2], t = o[f + 192 >> 2], Q = o[f + 232 >> 2], B = o[f + 236 >> 2], I = o[f + 196 >> 2], o[f + 396 >> 2] = B - I, o[f + 392 >> 2] = Q - t, o[f + 388 >> 2] = e - D, o[f + 384 >> 2] = y - r, o[f + 380 >> 2] = J - p, o[f + 376 >> 2] = _ - S, o[f + 372 >> 2] = k - z, o[f + 368 >> 2] = l - m, o[f + 364 >> 2] = x - u, o[f + 360 >> 2] = L - K, o[f + 356 >> 2] = I + B, o[f + 352 >> 2] = Q + t, o[f + 348 >> 2] = e + D, o[f + 344 >> 2] = r + y, o[f + 340 >> 2] = p + J, o[f + 336 >> 2] = S + _, o[f + 332 >> 2] = k + z, o[f + 328 >> 2] = m + l, o[f + 324 >> 2] = u + x, o[f + 320 >> 2] = K + L, H(s, X, 40 + (I = c((0 - q & 254) >>> 1 | 0, 120) + 1488 | 0) | 0), H(n, n, I), H(h, I + 80 | 0, M), gA = o[f + 276 >> 2], CA = o[f + 272 >> 2], q = o[f + 268 >> 2], X = o[f + 264 >> 2], r = o[f + 260 >> 2], y = o[f + 256 >> 2], D = o[f + 252 >> 2], e = o[f + 248 >> 2], t = o[f + 244 >> 2], Q = o[f + 240 >> 2], T = o[f + 360 >> 2], O = o[f + 400 >> 2], V = o[f + 364 >> 2], Z = o[f + 404 >> 2], $ = o[f + 368 >> 2], AA = o[f + 408 >> 2], K = o[f + 372 >> 2], L = o[f + 412 >> 2], u = o[f + 376 >> 2], x = o[f + 416 >> 2], m = o[f + 380 >> 2], l = o[f + 420 >> 2], z = o[f + 384 >> 2], k = o[f + 424 >> 2], S = o[f + 388 >> 2], _ = o[f + 428 >> 2], p = o[f + 392 >> 2], J = o[f + 432 >> 2], B = o[f + 396 >> 2], I = o[f + 436 >> 2], o[f + 396 >> 2] = B + I, o[f + 392 >> 2] = p + J, o[f + 388 >> 2] = S + _, o[f + 384 >> 2] = k + z, o[f + 380 >> 2] = m + l, o[f + 376 >> 2] = u + x, o[f + 372 >> 2] = K + L, o[f + 368 >> 2] = $ + AA, o[f + 364 >> 2] = V + Z, o[f + 360 >> 2] = T + O, o[f + 356 >> 2] = I - B, o[f + 352 >> 2] = J - p, o[f + 348 >> 2] = _ - S, o[f + 344 >> 2] = k - z, o[f + 340 >> 2] = l - m, o[f + 336 >> 2] = x - u, o[f + 332 >> 2] = L - K, o[f + 328 >> 2] = AA - $, o[f + 324 >> 2] = Z - V, o[f + 320 >> 2] = O - T, K = Q << 1, L = o[f + 440 >> 2], o[f + 400 >> 2] = K - L, u = t << 1, x = o[f + 444 >> 2], o[f + 404 >> 2] = u - x, m = e << 1, l = o[f + 448 >> 2], o[f + 408 >> 2] = m - l, z = D << 1, k = o[f + 452 >> 2], o[f + 412 >> 2] = z - k, S = y << 1, _ = o[f + 456 >> 2], o[f + 416 >> 2] = S - _, p = r << 1, J = o[f + 460 >> 2], o[f + 420 >> 2] = p - J, r = X << 1, y = o[f + 464 >> 2], o[f + 424 >> 2] = r - y, D = q << 1, e = o[f + 468 >> 2], o[f + 428 >> 2] = D - e, t = CA << 1, Q = o[f + 472 >> 2], o[f + 432 >> 2] = t - Q, B = gA << 1, I = o[f + 476 >> 2], o[f + 436 >> 2] = B - I, o[f + 440 >> 2] = K + L, o[f + 444 >> 2] = u + x, o[f + 448 >> 2] = m + l, o[f + 452 >> 2] = k + z, o[f + 456 >> 2] = S + _, o[f + 460 >> 2] = p + J, o[f + 464 >> 2] = r + y, o[f + 468 >> 2] = e + D, o[f + 472 >> 2] = Q + t, o[f + 476 >> 2] = I + B), H(C, f + 320 | 0, h), H(j, n, s), H(IA, s, h), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            w = f + 2272 | 0, MA(I = i + 288 | 0, C), BA = -1, QA = nA(I, A), p = ((0 | A) == (0 | I) ? BA : QA) | eA(A, I, 32);
                                        }
                                        return w = i + 592 | 0, p;
                                    }
                                    function H(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v, L, R, u, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        QA = kA(C = o[g + 4 >> 2], D = C >> 31, FA = (k = o[I + 20 >> 2]) << 1, P = FA >> 31), EA = h, iA = (wA = kA(nA = o[g >> 2], Q = nA >> 31, B = o[I + 24 >> 2], i = B >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < wA >>> 0 ? QA + 1 | 0 : QA, rA = kA(E = o[g + 8 >> 2], w = E >> 31, wA = o[I + 16 >> 2], a = wA >> 31), EA = h + QA | 0, EA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? EA + 1 | 0 : EA, QA = (rA = kA(t = o[g + 12 >> 2], F = t >> 31, N = (S = o[I + 12 >> 2]) << 1, v = N >> 31)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, EA = (hA = kA(n = o[g + 16 >> 2], J = n >> 31, rA = o[I + 8 >> 2], f = rA >> 31)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(H = o[g + 20 >> 2], L = H >> 31, U = (G = o[I + 4 >> 2]) << 1, R = U >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, Z = cA = o[g + 24 >> 2], EA = (DA = kA(cA, O = cA >> 31, hA = o[I >> 2], e = hA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < DA >>> 0 ? iA + 1 | 0 : iA, u = o[g + 28 >> 2], QA = (DA = kA(yA = c(u, 19), _ = yA >> 31, Y = (M = o[I + 36 >> 2]) << 1, x = Y >> 31)) + EA | 0, EA = h + iA | 0, EA = QA >>> 0 < DA >>> 0 ? EA + 1 | 0 : EA, _A = o[g + 32 >> 2], iA = (eA = kA(oA = c(_A, 19), s = oA >> 31, DA = o[I + 32 >> 2], r = DA >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < eA >>> 0 ? QA + 1 | 0 : QA, W = o[g + 36 >> 2], g = kA(eA = c(W, 19), y = eA >> 31, d = (p = o[I + 28 >> 2]) << 1, m = d >> 31), QA = h + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = kA(wA, a, C, D), QA = h, iA = kA(nA, Q, k, l = k >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(E, w, S, z = S >> 31), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(rA, f, t, F), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(n, J, G, q = G >> 31), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(hA, e, H, L), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(cA = c(cA, 19), K = cA >> 31, M, X = M >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(DA, r, yA, _), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(oA, s, p, j = p >> 31), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(eA, y, B, i), QA = h + QA | 0, pA = I = iA + I | 0, SA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = kA(C, D, N, v), QA = h, iA = kA(nA, Q, wA, a), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(rA, f, E, w), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(t, F, U, R), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(hA, e, n, J), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(b = c(H, 19), T = b >> 31, Y, x), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(DA, r, cA, K), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(yA, _, d, m), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(oA, s, B, i), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(eA, y, FA, P), QA = h + iA | 0, $ = I = EA + I | 0, AA = QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, EA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + SA | 0, pA = I = EA + pA | 0, QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (EA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (EA = (33554431 & EA) << 7 | I >>> 25) + aA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, HA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 24 >> 2] = iA - (-67108864 & g), g = kA(C, D, U, R), QA = h, iA = kA(nA, Q, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = (QA = g) + (g = kA(hA, e, E, w)) | 0, QA = h + EA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(g = c(t, 19), GA = g >> 31, Y, x), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(DA, r, SA = c(n, 19), V = SA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = kA(d, m, b, T), QA = h + iA | 0, QA = (EA = aA + EA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = kA(B, i, cA, K)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < aA >>> 0 ? EA + 1 | 0 : EA, aA = kA(yA, _, FA, P), QA = h + EA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, wA, a), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(eA, y, N, v)) + iA | 0, iA = h + QA | 0, tA = EA, NA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = kA(hA, e, C, D), iA = h, EA = (aA = kA(nA, Q, G, q)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(E, 19), iA = (fA = kA(iA, MA = iA >> 31, M, X)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(DA, r, g, GA), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(SA, V, p, j), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (fA = kA(B, i, b, T)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < fA >>> 0 ? iA + 1 | 0 : iA, fA = kA(cA, K, k, l), QA = h + iA | 0, QA = (EA = fA + EA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, iA = (fA = kA(wA, a, yA, _)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(oA, s, S, z), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(eA, y, rA, f), QA = h + QA | 0, JA = iA = EA + iA | 0, fA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, QA = kA(QA = c(C, 19), QA >> 31, Y, x), iA = h, EA = kA(nA, Q, hA, e), iA = h + iA | 0, iA = (QA = EA + QA | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = (aA = kA(DA, r, aA, MA)) + QA | 0, QA = h + iA | 0, g = (iA = kA(g, GA, d, m)) + EA | 0, EA = h + (EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, EA = g >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(B, i, SA, V), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(FA, P, b, T), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, cA, K), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = kA(yA, _, N, v), QA = h + iA | 0, QA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(oA, s, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(eA, y, U, R), QA = h + EA | 0, aA = g = iA + g | 0, GA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (EA = QA >> 26) + fA | 0, fA = g = (QA = (67108863 & QA) << 6 | g >>> 26) + JA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, JA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + NA | 0, QA = (g = iA + tA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, NA = iA = (EA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 8 >> 2] = EA - (-67108864 & iA), QA = kA(B, i, C, D), EA = h, iA = (tA = kA(nA, Q, p, j)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, k, l), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, t, F), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, tA = kA(n, J, S, z), EA = h + QA | 0, EA = (iA = tA + iA | 0) >>> 0 < tA >>> 0 ? EA + 1 | 0 : EA, QA = (tA = kA(rA, f, H, L)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, EA = (tA = kA(G, q, Z, O)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(hA, e, u, tA = u >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, M, X), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, sA = kA(eA, y, DA, r), EA = h + QA | 0, QA = I >> 26, I = (HA = (67108863 & I) << 6 | HA >>> 26) + (iA = sA + iA | 0) | 0, iA = QA + (iA >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA) | 0, QA = (EA = I) >>> 0 < HA >>> 0 ? iA + 1 | 0 : iA, HA = iA = EA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 28 >> 2] = EA - (-33554432 & iA), QA = kA(rA, f, C, D), iA = h, sA = kA(nA, Q, S, z), EA = h + iA | 0, EA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA, sA = kA(E, w, G, q), iA = h + EA | 0, iA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA, EA = (sA = kA(hA, e, t, F)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(SA, V, M, X), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(DA, r, b, T), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (cA = kA(cA, K, p, j)) + iA | 0, EA = h + QA | 0, QA = (yA = kA(B, i, yA, _)) + iA | 0, iA = h + (iA >>> 0 < cA >>> 0 ? EA + 1 | 0 : EA) | 0, EA = (oA = kA(oA, s, k, l)) + QA | 0, QA = h + (QA >>> 0 < yA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(eA, y, wA, a), QA = h + QA | 0, oA = iA = iA + EA | 0, QA = (QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, oA = g = oA + (EA = (67108863 & g) << 6 | NA >>> 26) | 0, QA = g >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, yA = iA = g + 16777216 | 0, g = EA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 12 >> 2] = oA - (-33554432 & iA), QA = kA(C, D, d, m), EA = h, iA = (oA = kA(nA, Q, DA, r)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = kA(B, i, E, w), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = kA(t, F, FA, P), EA = h + QA | 0, EA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? EA + 1 | 0 : EA, QA = (oA = kA(wA, a, n, J)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, EA = (oA = kA(N, v, H, L)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(rA, f, Z, O), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(u, tA, U, R), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (FA = kA(hA, e, oA = _A, cA = oA >> 31)) + iA | 0, EA = h + QA | 0, QA = (eA = kA(eA, y, Y, x)) + iA | 0, iA = h + (iA >>> 0 < FA >>> 0 ? EA + 1 | 0 : EA) | 0, iA = QA >>> 0 < eA >>> 0 ? iA + 1 | 0 : iA, _A = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = _A + (EA = (33554431 & I) << 7 | HA >>> 25) | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, eA = iA = (EA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 32 >> 2] = EA - (-67108864 & iA), iA = g >> 25, g = (yA = (33554431 & g) << 7 | yA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (AA - ((QA >>> 0 > $ >>> 0) + gA | 0) | 0) | 0, QA = g >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (EA = pA - (-33554432 & CA) | 0) | 0, o[A + 20 >> 2] = QA, o[A + 16 >> 2] = iA - (-67108864 & g), g = kA(DA, r, C, D), QA = h, iA = kA(nA, Q, M, X), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, p, j), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(B, i, t, F), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(n, J, k, l), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(wA, a, H, L), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(S, z, Z, O), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(rA, f, u, tA), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(oA, cA, G, q), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(hA, e, W, W >> 31), QA = h + EA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (EA = g) + (g = (67108863 & I) << 6 | eA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 36 >> 2] = g - (-33554432 & I), EA = fA - (-33554432 & JA) | 0, iA = aA - (g = -67108864 & MA) | 0, nA = GA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = kA((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = h + nA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + EA | 0, o[A + 4 >> 2] = QA, o[A >> 2] = g - (-67108864 & I);
                                    }
                                    function G(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, n, s, k, F, S, H, G, _, p, N, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0;
                                        w = g = w - 48 | 0, M(A, I), M(A + 80 | 0, I + 40 | 0), J = kA(l = (W = o[I + 92 >> 2]) << 1, i = l >> 31, v = (d = o[I + 84 >> 2]) << 1, C = v >> 31), Y = h, CA = X = o[I + 88 >> 2], U = (u = kA(X, T = X >> 31, X, T)) + J | 0, J = h + Y | 0, J = U >>> 0 < u >>> 0 ? J + 1 | 0 : J, Y = kA(K = o[I + 96 >> 2], E = K >> 31, u = (L = o[I + 80 >> 2]) << 1, B = u >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, gA = o[I + 108 >> 2], Y = kA(x = c(gA, 38), D = x >> 31, gA, n = gA >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = U, $ = o[I + 112 >> 2], R = kA(b = c($, 19), a = b >> 31, U = (O = o[I + 104 >> 2]) << 1, U >> 31), U = h + J | 0, U = (Y = Y + R | 0) >>> 0 < R >>> 0 ? U + 1 | 0 : U, iA = o[I + 116 >> 2], J = kA(R = c(iA, 38), Q = R >> 31, j = (V = o[I + 100 >> 2]) << 1, e = j >> 31), U = h + U | 0, EA = J = (J >>> 0 > (Y = J + Y | 0) >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, oA = Y = 33554432 + (s = Y << 1) | 0, aA = J = Y >>> 0 < 33554432 ? J + 1 | 0 : J, P = (67108863 & J) << 6 | Y >>> 26, Z = J >> 26, J = kA(v, C, K, E), Y = h, U = (AA = kA(X <<= 1, r = X >> 31, W, k = W >> 31)) + J | 0, J = h + Y | 0, J = U >>> 0 < AA >>> 0 ? J + 1 | 0 : J, Y = (AA = kA(V, t = V >> 31, u, B)) + U | 0, U = h + J | 0, U = Y >>> 0 < AA >>> 0 ? U + 1 | 0 : U, BA = kA(b, a, AA = gA << 1, F = AA >> 31), J = h + U | 0, J = (Y = BA + Y | 0) >>> 0 < BA >>> 0 ? J + 1 | 0 : J, U = kA(R, Q, O, f = O >> 31), J = h + J | 0, U = (U = (U >>> 0 > (Y = U + Y | 0) >>> 0 ? J + 1 | 0 : J) << 1 | Y >>> 31) + Z | 0, BA = Y = (J = Y << 1) + P | 0, J = U = J >>> 0 > Y >>> 0 ? U + 1 | 0 : U, fA = Y = Y + 16777216 | 0, P = (33554431 & (J = Y >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | Y >>> 25, Z = J >> 25, J = kA(l, i, W, k), Y = h, U = (m = kA(K, E, X, r)) + J | 0, J = h + Y | 0, J = U >>> 0 < m >>> 0 ? J + 1 | 0 : J, Y = kA(v, C, j, e), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = (m = kA(u, B, O, f)) + U | 0, U = h + J | 0, U = Y >>> 0 < m >>> 0 ? U + 1 | 0 : U, m = kA(b, a, $, y = $ >> 31), J = h + U | 0, J = (Y = m + Y | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = kA(R, Q, AA, F), U = h + J | 0, U = ((Y = m + Y | 0) >>> 0 < m >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, Y = (J = P) + (P = Y << 1) | 0, J = U + Z | 0, J = Y >>> 0 < P >>> 0 ? J + 1 | 0 : J, Z = Y, m = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 144 >> 2] = Z - (-67108864 & U), Z = kA(J = c(V, 38), J >> 31, V, t), P = h, L = kA(J = L, U = J >> 31, J, U), U = h + P | 0, U = (J = L + Z | 0) >>> 0 < L >>> 0 ? U + 1 | 0 : U, P = (IA = kA(L = c(O, 19), S = L >> 31, Z = K << 1, H = Z >> 31)) + J | 0, J = h + U | 0, J = P >>> 0 < IA >>> 0 ? J + 1 | 0 : J, U = P, P = kA(l, i, x, D), J = h + J | 0, J = (U = U + P | 0) >>> 0 < P >>> 0 ? J + 1 | 0 : J, P = (IA = kA(b, a, X, r)) + U | 0, U = h + J | 0, U = P >>> 0 < IA >>> 0 ? U + 1 | 0 : U, IA = kA(v, C, R, Q), J = h + U | 0, IA = J = ((P = IA + P | 0) >>> 0 < IA >>> 0 ? J + 1 | 0 : J) << 1 | P >>> 31, p = U = (P = 33554432 + (G = P << 1) | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, QA = (67108863 & U) << 6 | P >>> 26, cA = U >> 26, J = kA(L, S, j, e), z = h, q = d, U = (d = kA(u, B, d, _ = d >> 31)) + J | 0, J = h + z | 0, J = U >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (z = kA(K, E, x, D)) + U | 0, U = h + J | 0, U = d >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(b, a, l, i), J = h + U | 0, J = (d = z + d | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(R, Q, CA, T), U = h + J | 0, U = ((d = z + d | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31, d = (J = QA) + (QA = d << 1) | 0, J = U + cA | 0, J = d >>> 0 < QA >>> 0 ? J + 1 | 0 : J, cA = d, QA = d = d + 16777216 | 0, N = (33554431 & (J = d >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | d >>> 25, z = J >> 25, J = kA(u, B, CA, T), d = h, U = (q = kA(v, C, q, _)) + J | 0, J = h + d | 0, d = (L = kA(L, S, O, f)) + U | 0, U = h + (U >>> 0 < q >>> 0 ? J + 1 | 0 : J) | 0, U = d >>> 0 < L >>> 0 ? U + 1 | 0 : U, L = kA(j, e, x, D), J = h + U | 0, J = (d = L + d | 0) >>> 0 < L >>> 0 ? J + 1 | 0 : J, U = d, d = kA(b, a, Z, H), J = h + J | 0, J = (U = U + d | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (L = kA(R, Q, l, i)) + U | 0, U = h + J | 0, J = (J = (d >>> 0 < L >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31) + z | 0, q = d = (U = d << 1) + N | 0, J = U >>> 0 > d >>> 0 ? J + 1 | 0 : J, d = (L = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 128 >> 2] = q - (-67108864 & L), J = kA(X, r, V, t), U = h, q = kA(K, E, l, i), U = h + U | 0, U = (J = q + J | 0) >>> 0 < q >>> 0 ? U + 1 | 0 : U, q = (z = kA(v, C, O, f)) + J | 0, J = h + U | 0, J = q >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(u, B, gA, n), U = h + J | 0, U = (q = z + q | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(R, Q, $, y), J = h + U | 0, J = (U = Y >> 26) + (((q = z + q | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J) << 1 | q >>> 31) | 0, J = (Y = (m = (67108863 & Y) << 6 | m >>> 26) + (q << 1) | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = Y, U = J, q = J = Y + 16777216 | 0, Y = U = J >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 148 >> 2] = m - (-33554432 & J), J = kA(u, B, W, k), W = h, U = (T = kA(v, C, CA, T)) + J | 0, J = h + W | 0, J = U >>> 0 < T >>> 0 ? J + 1 | 0 : J, x = kA(O, f, x, D), J = h + J | 0, J = (U = x + U | 0) >>> 0 < x >>> 0 ? J + 1 | 0 : J, b = (x = kA(b, a, j, e)) + U | 0, U = h + J | 0, U = b >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = b, b = kA(R, Q, K, E), U = h + U | 0, U = ((J = J + b | 0) >>> 0 < b >>> 0 ? U + 1 | 0 : U) << 1, b = J, J = (J = U | J >>> 31) + (U = d >> 26) | 0, J = (d = (m = b << 1) + (b = (67108863 & d) << 6 | L >>> 26) | 0) >>> 0 < b >>> 0 ? J + 1 | 0 : J, b = d, x = U = d + 16777216 | 0, d = J = U >>> 0 < 16777216 ? J + 1 | 0 : J, o[A + 132 >> 2] = b - (-33554432 & U), J = kA(O, f, X, r), b = h, U = (K = kA(K, E, K, E)) + J | 0, J = h + b | 0, J = U >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(l, i, j, e), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(v, C, AA, F), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = (b = kA(u, B, $, y)) + U | 0, U = h + J | 0, U = K >>> 0 < b >>> 0 ? U + 1 | 0 : U, J = K, K = kA(K = R, Q, R = iA, j = R >> 31), U = h + U | 0, U = ((J = J + K | 0) >>> 0 < K >>> 0 ? U + 1 | 0 : U) << 1, K = J, J = (J = U | J >>> 31) + (U = Y >> 25) | 0, J = (Y = (b = K << 1) + (K = (33554431 & Y) << 7 | q >>> 25) | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = Y, b = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 152 >> 2] = K - (-67108864 & U), U = s - (J = -67108864 & oA) | 0, K = EA - ((J >>> 0 > s >>> 0) + aA | 0) | 0, J = d >> 25, d = (x = (33554431 & d) << 7 | x >>> 25) + U | 0, U = J + K | 0, K = d, J = U = d >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = ((67108863 & (J = (d = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + (T = BA - (-33554432 & fA) | 0) | 0, o[A + 140 >> 2] = J, o[A + 136 >> 2] = K - (-67108864 & d), J = kA(l, i, O, f), U = h, d = kA(V, t, Z, H), U = h + U | 0, U = (J = d + J | 0) >>> 0 < d >>> 0 ? U + 1 | 0 : U, d = (l = kA(X, r, gA, n)) + J | 0, J = h + U | 0, J = d >>> 0 < l >>> 0 ? J + 1 | 0 : J, v = kA(v, C, $, y), U = h + J | 0, U = (d = v + d | 0) >>> 0 < v >>> 0 ? U + 1 | 0 : U, v = kA(u, B, R, j), J = h + U | 0, J = (J = ((d = v + d | 0) >>> 0 < v >>> 0 ? J + 1 | 0 : J) << 1 | d >>> 31) + (U = Y >> 26) | 0, U = (Y = (K = d << 1) + (d = (67108863 & Y) << 6 | b >>> 26) | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, U = (J = Y + 16777216 | 0) >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 156 >> 2] = Y - (-33554432 & J), d = cA - (-33554432 & QA) | 0, v = G - (Y = -67108864 & P) | 0, u = IA - ((Y >>> 0 > G >>> 0) + p | 0) | 0, Y = kA((33554431 & U) << 7 | J >>> 25, U >> 25, 19, 0), U = h + u | 0, U = (J = Y + v | 0) >>> 0 < Y >>> 0 ? U + 1 | 0 : U, Y = J, U = ((67108863 & (U = (J = J + 33554432 | 0) >>> 0 < 33554432 ? U + 1 | 0 : U)) << 6 | J >>> 26) + d | 0, o[A + 124 >> 2] = U, o[A + 120 >> 2] = Y - (-67108864 & J), J = o[I + 40 >> 2], U = o[I + 44 >> 2], Y = o[I + 4 >> 2], d = o[I + 48 >> 2], v = o[I + 8 >> 2], u = o[I + 52 >> 2], R = o[I + 12 >> 2], l = o[I + 56 >> 2], K = o[I + 16 >> 2], b = o[I + 60 >> 2], O = o[I + 20 >> 2], j = o[I - -64 >> 2], X = o[I + 24 >> 2], x = o[I + 68 >> 2], T = o[I + 28 >> 2], V = o[I + 72 >> 2], $ = o[I + 32 >> 2], CA = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] + o[I + 36 >> 2], o[A + 72 >> 2] = V + $, o[A + 68 >> 2] = x + T, o[(gA = A - -64 | 0) >> 2] = X + j, o[A + 60 >> 2] = b + O, o[A + 56 >> 2] = K + l, o[A + 52 >> 2] = R + u, o[A + 48 >> 2] = d + v, o[A + 44 >> 2] = U + Y, o[(I = A + 40 | 0) >> 2] = J + CA, M(g, I), J = o[A + 80 >> 2], U = o[A + 4 >> 2], Y = o[A + 84 >> 2], d = o[A + 8 >> 2], v = o[A + 88 >> 2], u = o[A + 12 >> 2], R = o[A + 92 >> 2], l = o[A + 16 >> 2], K = o[A + 96 >> 2], b = o[A + 20 >> 2], O = o[A + 100 >> 2], j = o[A + 24 >> 2], X = o[A + 104 >> 2], x = o[A + 28 >> 2], T = o[A + 108 >> 2], V = o[A + 32 >> 2], $ = o[A + 112 >> 2], CA = o[A >> 2], L = (W = o[A + 116 >> 2]) - (AA = o[A + 36 >> 2]) | 0, o[A + 116 >> 2] = L, Z = $ - V | 0, o[A + 112 >> 2] = Z, P = T - x | 0, o[A + 108 >> 2] = P, iA = X - j | 0, o[A + 104 >> 2] = iA, EA = O - b | 0, o[A + 100 >> 2] = EA, oA = K - l | 0, o[A + 96 >> 2] = oA, aA = R - u | 0, o[A + 92 >> 2] = aA, BA = v - d | 0, o[A + 88 >> 2] = BA, fA = Y - U | 0, o[A + 84 >> 2] = fA, m = J - CA | 0, o[A + 80 >> 2] = m, W = W + AA | 0, o[A + 76 >> 2] = W, V = V + $ | 0, o[A + 72 >> 2] = V, x = x + T | 0, o[A + 68 >> 2] = x, j = X + j | 0, o[gA >> 2] = j, b = b + O | 0, o[A + 60 >> 2] = b, l = K + l | 0, o[A + 56 >> 2] = l, u = R + u | 0, o[A + 52 >> 2] = u, d = d + v | 0, o[A + 48 >> 2] = d, U = U + Y | 0, o[A + 44 >> 2] = U, Y = I, I = J + CA | 0, o[Y >> 2] = I, J = o[g >> 2], Y = o[g + 4 >> 2], v = o[g + 8 >> 2], R = o[g + 12 >> 2], K = o[g + 16 >> 2], O = o[g + 20 >> 2], X = o[g + 24 >> 2], T = o[g + 28 >> 2], $ = o[g + 32 >> 2], o[A + 36 >> 2] = o[g + 36 >> 2] - W, o[A + 32 >> 2] = $ - V, o[A + 28 >> 2] = T - x, o[A + 24 >> 2] = X - j, o[A + 20 >> 2] = O - b, o[A + 16 >> 2] = K - l, o[A + 12 >> 2] = R - u, o[A + 8 >> 2] = v - d, o[A + 4 >> 2] = Y - U, o[A >> 2] = J - I, I = o[A + 120 >> 2], J = o[A + 124 >> 2], U = o[A + 128 >> 2], Y = o[A + 132 >> 2], d = o[A + 136 >> 2], v = o[A + 140 >> 2], u = o[A + 144 >> 2], R = o[A + 148 >> 2], l = o[A + 152 >> 2], o[A + 156 >> 2] = o[A + 156 >> 2] - L, o[A + 152 >> 2] = l - Z, o[A + 148 >> 2] = R - P, o[A + 144 >> 2] = u - iA, o[A + 140 >> 2] = v - EA, o[A + 136 >> 2] = d - oA, o[A + 132 >> 2] = Y - aA, o[A + 128 >> 2] = U - BA, o[A + 124 >> 2] = J - fA, o[A + 120 >> 2] = I - m, w = g + 48 | 0;
                                    }
                                    function _(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        for(B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[g >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, o[g + 4 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[g + 8 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[g + 12 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[g + 16 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[g + 20 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[g + 24 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[g + 28 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, o[g + 32 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, o[g + 36 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, o[g + 40 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, o[g + 44 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, o[g + 48 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, o[g + 52 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, o[g + 56 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, o[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I, I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I; f = o[C + 28 >> 2], B = (I = F << 2) + g | 0, i = o[C + 16 >> 2], c = o[B >> 2] + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0, r = (f = ((Q = o[I + 33968 >> 2] + c | 0) + (i & ((c = o[C + 24 >> 2]) ^ (D = o[C + 20 >> 2])) ^ c) | 0) + f | 0) + o[C + 12 >> 2] | 0, o[C + 12 >> 2] = r, f = (y = f + (RA(e = o[C >> 2], 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) + (e & ((Q = o[C + 8 >> 2]) | (E = o[C + 4 >> 2])) | Q & E) | 0, o[C + 28 >> 2] = f, Q = (y = Q) + (c = (o[(h = (Q = 4 | I) + g | 0) >> 2] + ((c + (D ^ r & (i ^ D)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) | 0) + o[Q + 33968 >> 2] | 0) | 0, o[C + 8 >> 2] = Q, c = (c + (f & (E | e) | E & e) | 0) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0, o[C + 24 >> 2] = c, D = (y = E) + (E = (((D + o[(k = (E = 8 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) | 0, o[C + 4 >> 2] = D, E = E + ((c & (f | e) | f & e) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 20 >> 2] = E, i = (y = e) + (e = (((i + o[(S = (e = 12 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (r ^ D & (Q ^ r)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) | 0, o[C >> 2] = i, e = e + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 16 >> 2] = e, r = (t = ((((y = r) + o[(H = (r = 16 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 12 >> 2] = r, t = f + t | 0, o[C + 28 >> 2] = t, f = (Q = (((Q + o[(G = (f = 20 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 8 >> 2] = f, Q = Q + c | 0, o[C + 24 >> 2] = Q, c = (D = (((D + o[(_ = (c = 24 | I) + g | 0) >> 2] | 0) + o[c + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 4 >> 2] = c, D = E + D | 0, o[C + 20 >> 2] = D, E = (i = (((i + o[(M = (E = 28 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C >> 2] = E, i = i + e | 0, o[C + 16 >> 2] = i, e = (t = (((t + o[(p = (e = 32 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 28 >> 2] = e, t = r + t | 0, o[C + 12 >> 2] = t, r = (Q = (((Q + o[(N = (r = 36 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 24 >> 2] = r, Q = Q + f | 0, o[C + 8 >> 2] = Q, f = (D = (((D + o[(J = (f = 40 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 20 >> 2] = f, D = c + D | 0, o[C + 4 >> 2] = D, y = (c = 44 | I) + g | 0, c = (i = ((i + (o[c + 33968 >> 2] + o[y >> 2] | 0) | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 16 >> 2] = c, E = E + i | 0, o[C >> 2] = E, s = (i = 48 | I) + g | 0, i = (t = ((t + (o[i + 33968 >> 2] + o[s >> 2] | 0) | 0) + (Q ^ E & (Q ^ D)) | 0) + (RA(E, 26) ^ RA(E, 21) ^ RA(E, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 12 >> 2] = i, e = e + t | 0, o[C + 28 >> 2] = e, n = (t = 52 | I) + g | 0, Q = (t = (((o[t + 33968 >> 2] + o[n >> 2] | 0) + Q | 0) + (D ^ e & (E ^ D)) | 0) + (RA(e, 26) ^ RA(e, 21) ^ RA(e, 7)) | 0) + ((i & (f | c) | f & c) + (RA(i, 30) ^ RA(i, 19) ^ RA(i, 10)) | 0) | 0, o[C + 8 >> 2] = Q, r = r + t | 0, o[C + 24 >> 2] = r, t = (w = 56 | I) + g | 0, D = (w = (((o[w + 33968 >> 2] + o[t >> 2] | 0) + D | 0) + (E ^ r & (E ^ e)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) + ((Q & (c | i) | c & i) + (RA(Q, 30) ^ RA(Q, 19) ^ RA(Q, 10)) | 0) | 0, o[C + 4 >> 2] = D, f = f + w | 0, o[C + 20 >> 2] = f, w = (I |= 60) + g | 0, f = (I = ((E + (o[I + 33968 >> 2] + o[w >> 2] | 0) | 0) + (e ^ f & (e ^ r)) | 0) + (RA(f, 26) ^ RA(f, 21) ^ RA(f, 7)) | 0) + ((D & (Q | i) | Q & i) + (RA(D, 30) ^ RA(D, 19) ^ RA(D, 10)) | 0) | 0, o[C >> 2] = f, o[C + 16 >> 2] = I + c, 48 != (0 | F);)E = o[N >> 2], F = F + 16 | 0, I = o[t >> 2], f = (Q = o[B >> 2] + (E + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0) | 0) + (RA(c = o[h >> 2], 25) ^ RA(c, 14) ^ c >>> 3) | 0, o[(F << 2) + g >> 2] = f, r = (i = (Q = (e = o[J >> 2]) + c | 0) + (RA(c = o[w >> 2], 15) ^ RA(c, 13) ^ c >>> 10) | 0) + (RA(Q = o[k >> 2], 25) ^ RA(Q, 14) ^ Q >>> 3) | 0, o[B + 68 >> 2] = r, D = (y = ((i = Q) + (Q = o[y >> 2]) | 0) + (RA(f, 15) ^ RA(f, 13) ^ f >>> 10) | 0) + (RA(i = o[S >> 2], 25) ^ RA(i, 14) ^ i >>> 3) | 0, o[B + 72 >> 2] = D, t = (w = ((y = i) + (i = o[s >> 2]) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0) + (RA(y = o[H >> 2], 25) ^ RA(y, 14) ^ y >>> 3) | 0, o[B + 76 >> 2] = t, s = (w = ((w = y) + (y = o[n >> 2]) | 0) + (RA(D, 15) ^ RA(D, 13) ^ D >>> 10) | 0) + (RA(n = o[G >> 2], 25) ^ RA(n, 14) ^ n >>> 3) | 0, o[B + 80 >> 2] = s, n = (h = (I + n | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0) + (RA(w = o[_ >> 2], 25) ^ RA(w, 14) ^ w >>> 3) | 0, o[B + 84 >> 2] = n, w = ((c + w | 0) + (RA(k = o[M >> 2], 25) ^ RA(k, 14) ^ k >>> 3) | 0) + (RA(s, 15) ^ RA(s, 13) ^ s >>> 10) | 0, o[B + 88 >> 2] = w, r = ((h = o[p >> 2]) + (r + (RA(E, 25) ^ RA(E, 14) ^ E >>> 3) | 0) | 0) + (RA(w, 15) ^ RA(w, 13) ^ w >>> 10) | 0, o[B + 96 >> 2] = r, h = ((f + k | 0) + (RA(h, 25) ^ RA(h, 14) ^ h >>> 3) | 0) + (RA(n, 15) ^ RA(n, 13) ^ n >>> 10) | 0, o[B + 92 >> 2] = h, t = (t + (e + (RA(Q, 25) ^ RA(Q, 14) ^ Q >>> 3) | 0) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0, o[B + 104 >> 2] = t, E = (D + (E + (RA(e, 25) ^ RA(e, 14) ^ e >>> 3) | 0) | 0) + (RA(h, 15) ^ RA(h, 13) ^ h >>> 10) | 0, o[B + 100 >> 2] = E, e = (n + (i + (RA(y, 25) ^ RA(y, 14) ^ y >>> 3) | 0) | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0, o[B + 112 >> 2] = e, E = (s + (Q + (RA(i, 25) ^ RA(i, 14) ^ i >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 108 >> 2] = E, U = B, Y = (h + (I + (RA(c, 25) ^ RA(c, 14) ^ c >>> 3) | 0) | 0) + (RA(e, 15) ^ RA(e, 13) ^ e >>> 10) | 0, o[U + 120 >> 2] = Y, I = (w + (y + (RA(I, 25) ^ RA(I, 14) ^ I >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 116 >> 2] = I, U = B, Y = (r + (c + (RA(f, 25) ^ RA(f, 14) ^ f >>> 3) | 0) | 0) + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0, o[U + 124 >> 2] = Y;
                                        o[A >> 2] = f + o[A >> 2], o[A + 4 >> 2] = o[A + 4 >> 2] + o[C + 4 >> 2], o[A + 8 >> 2] = o[A + 8 >> 2] + o[C + 8 >> 2], o[A + 12 >> 2] = o[A + 12 >> 2] + o[C + 12 >> 2], o[A + 16 >> 2] = o[A + 16 >> 2] + o[C + 16 >> 2], o[A + 20 >> 2] = o[A + 20 >> 2] + o[C + 20 >> 2], o[A + 24 >> 2] = o[A + 24 >> 2] + o[C + 24 >> 2], o[A + 28 >> 2] = o[A + 28 >> 2] + o[C + 28 >> 2];
                                    }
                                    function M(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0;
                                        v = kA(C = (s = o[I + 12 >> 2]) << 1, E = C >> 31, s, G = s >> 31), R = h, L = (q = kA(x = o[I + 16 >> 2], a = x >> 31, f = (u = o[I + 8 >> 2]) << 1, t = f >> 31)) + v | 0, v = h + R | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, R = (X = kA(O = (e = o[I + 20 >> 2]) << 1, y = O >> 31, q = (m = o[I + 4 >> 2]) << 1, B = q >> 31)) + L | 0, L = h + v | 0, L = R >>> 0 < X >>> 0 ? L + 1 | 0 : L, l = kA(g = o[I + 24 >> 2], r = g >> 31, X = (W = o[I >> 2]) << 1, Q = X >> 31), v = h + L | 0, v = (R = l + R | 0) >>> 0 < l >>> 0 ? v + 1 | 0 : v, L = R, w = o[I + 32 >> 2], R = kA(j = c(w, 19), D = j >> 31, w, F = w >> 31), v = h + v | 0, v = (L = L + R | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, J = o[I + 36 >> 2], R = kA(l = c(J, 38), i = l >> 31, S = (n = o[I + 28 >> 2]) << 1, _ = S >> 31), I = h + v | 0, Z = L = R + L | 0, R = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, I = kA(q, B, x, a), v = h, L = kA(f, t, s, G), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, z = kA(e, H = e >> 31, X, Q), L = h + v | 0, L = (I = z + I | 0) >>> 0 < z >>> 0 ? L + 1 | 0 : L, z = kA(j, D, S, _), v = h + L | 0, v = (I = z + I | 0) >>> 0 < z >>> 0 ? v + 1 | 0 : v, L = kA(l, i, g, r), v = h + v | 0, CA = I = L + I | 0, T = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, v = kA(q, B, C, E), L = h, M = I = u, u = kA(I, V = I >> 31, I, V), I = h + L | 0, I = (v = u + v | 0) >>> 0 < u >>> 0 ? I + 1 | 0 : I, L = (u = kA(X, Q, x, a)) + v | 0, v = h + I | 0, v = L >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (u = kA(z = c(n, 38), k = z >> 31, n, p = n >> 31)) + L | 0, L = h + v | 0, L = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, I = (v = I) + (u = kA(j, D, I = g << 1, I >> 31)) | 0, v = h + L | 0, v = I >>> 0 < u >>> 0 ? v + 1 | 0 : v, L = I, I = kA(l, i, O, y), v = h + v | 0, U = L = L + I | 0, Y = v = I >>> 0 > L >>> 0 ? v + 1 | 0 : v, I = v, d = L = L + 33554432 | 0, K = I = L >>> 0 < 33554432 ? I + 1 | 0 : I, v = (v = I >> 26) + T | 0, CA = I = (L = (67108863 & I) << 6 | L >>> 26) + CA | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, b = I = I + 16777216 | 0, v = (v = (L = I >>> 0 < 16777216 ? v + 1 | 0 : v) >> 25) + R | 0, I = (I = (33554431 & L) << 7 | I >>> 25) >>> 0 > (L = I + Z | 0) >>> 0 ? v + 1 | 0 : v, Z = v = L + 33554432 | 0, u = I = v >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 24 >> 2] = L - (-67108864 & v), I = kA(X, Q, M, V), v = h, R = kA(q, B, m, $ = m >> 31), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, T = kA(R = c(g, 19), gA = R >> 31, g, r), v = h + L | 0, v = (I = T + I | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, L = (T = kA(O, y, z, k)) + I | 0, I = h + v | 0, I = L >>> 0 < T >>> 0 ? I + 1 | 0 : I, AA = kA(j, D, T = x << 1, N = T >> 31), v = h + I | 0, v = (L = AA + L | 0) >>> 0 < AA >>> 0 ? v + 1 | 0 : v, I = L, L = kA(l, i, C, E), v = h + v | 0, IA = I = I + L | 0, AA = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, I = kA(O, y, R, gA), v = h, m = kA(X, Q, m, $), L = h + v | 0, L = (I = m + I | 0) >>> 0 < m >>> 0 ? L + 1 | 0 : L, m = kA(x, a, z, k), v = h + L | 0, v = (I = m + I | 0) >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = (m = kA(j, D, C, E)) + I | 0, I = h + v | 0, I = L >>> 0 < m >>> 0 ? I + 1 | 0 : I, m = kA(l, i, M, V), v = h + I | 0, BA = L = m + L | 0, $ = L >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = kA(I = c(e, 38), I >> 31, e, H), m = h, I = W, W = L, L = kA(I, v = I >> 31, I, v), v = h + m | 0, v = (I = W + L | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, R = kA(R, gA, T, N), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = kA(C, E, z, k), v = h + L | 0, v = (I = R + I | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, L = (R = kA(j, D, f, t)) + I | 0, I = h + v | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = kA(q, B, l, i), v = h + I | 0, m = L = R + L | 0, W = v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, gA = L = L + 33554432 | 0, P = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, v = (67108863 & v) << 6 | L >>> 26, L = I + $ | 0, $ = R = v + BA | 0, v = v >>> 0 > R >>> 0 ? L + 1 | 0 : L, BA = L = R + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, v = (v >> 25) + AA | 0, v = (L = R + IA | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, AA = I = L + 33554432 | 0, R = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 8 >> 2] = L - (-67108864 & I), I = kA(f, t, e, H), v = h, L = kA(x, a, C, E), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(q, B, g, r), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(X, Q, n, p), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, IA = (L = kA(l, i, w, F)) + I | 0, I = h + v | 0, L = (v = u >> 26) + (L = L >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, Z = I = (u = (67108863 & u) << 6 | Z >>> 26) + IA | 0, v = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, IA = I = I + 16777216 | 0, u = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, o[A + 28 >> 2] = Z - (-33554432 & I), I = kA(X, Q, s, G), L = h, v = (V = kA(q, B, M, V)) + I | 0, I = h + L | 0, I = v >>> 0 < V >>> 0 ? I + 1 | 0 : I, v = (z = kA(g, r, z, k)) + v | 0, L = h + I | 0, I = (j = kA(j, D, O, y)) + v | 0, v = h + (v >>> 0 < z >>> 0 ? L + 1 | 0 : L) | 0, v = I >>> 0 < j >>> 0 ? v + 1 | 0 : v, L = kA(l, i, x, a), v = h + v | 0, v = (v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v) + (L = R >> 26) | 0, I = (L = R = (Z = I) + (I = (67108863 & R) << 6 | AA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, j = v = L + 16777216 | 0, R = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 12 >> 2] = L - (-33554432 & v), I = kA(g, r, f, t), v = h, L = kA(x, a, x, a), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(C, E, O, y), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (x = kA(q, B, S, _)) + I | 0, I = h + v | 0, I = L >>> 0 < x >>> 0 ? I + 1 | 0 : I, v = (x = kA(X, Q, w, F)) + L | 0, L = h + I | 0, L = v >>> 0 < x >>> 0 ? L + 1 | 0 : L, I = (x = kA(I = l, i, l = J, O = l >> 31)) + v | 0, v = h + L | 0, v = I >>> 0 < x >>> 0 ? v + 1 | 0 : v, L = I, v = (I = u >> 25) + v | 0, v = (L = L + (u = (33554431 & u) << 7 | IA >>> 25) | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, x = I = L + 33554432 | 0, u = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 32 >> 2] = L - (-67108864 & I), v = R >> 25, L = (R = (33554431 & R) << 7 | j >>> 25) + (U - (I = -67108864 & d) | 0) | 0, I = v + (Y - ((I >>> 0 > U >>> 0) + K | 0) | 0) | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = L, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | L >>> 26) + (z = CA - (-33554432 & b) | 0) | 0, o[A + 20 >> 2] = I, o[A + 16 >> 2] = R - (-67108864 & L), I = kA(C, E, g, r), L = h, v = (R = kA(e, H, T, N)) + I | 0, I = h + L | 0, I = v >>> 0 < R >>> 0 ? I + 1 | 0 : I, L = (R = kA(f, t, n, p)) + v | 0, v = h + I | 0, v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, I = (R = kA(q, B, w, F)) + L | 0, L = h + v | 0, L = I >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = (v = I) + (I = kA(X, Q, l, O)) | 0, v = h + L | 0, v = (I = I >>> 0 > R >>> 0 ? v + 1 | 0 : v) + (v = u >> 26) | 0, I = (L = (u = (67108863 & u) << 6 | x >>> 26) + R | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (v = L + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = L - (-33554432 & v), u = $ - (-33554432 & BA) | 0, R = m - (L = -67108864 & gA) | 0, q = W - ((L >>> 0 > m >>> 0) + P | 0) | 0, I = kA((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), v = h + q | 0, I = I >>> 0 > (L = I + R | 0) >>> 0 ? v + 1 | 0 : v, I = ((67108863 & (I = (v = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + u | 0, o[A + 4 >> 2] = I, o[A >> 2] = L - (-67108864 & v);
                                    }
                                    function p(A, I, g, C, B) {
                                        var Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0;
                                        for(Q = w + -64 | 0, i = o[A + 60 >> 2], f = o[A + 56 >> 2], l = o[A + 52 >> 2], m = o[A + 48 >> 2], c = o[A + 44 >> 2], e = o[A + 40 >> 2], r = o[A + 36 >> 2], D = o[A + 32 >> 2], t = o[A + 28 >> 2], y = o[A + 24 >> 2], h = o[A + 20 >> 2], n = o[A + 16 >> 2], s = o[A + 12 >> 2], k = o[A + 8 >> 2], F = o[A + 4 >> 2], S = o[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) H = g;
                                            else {
                                                if (o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 40 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, _ = 0, C | B) for(; E[_ + Q | 0] = a[I + _ | 0], !B & (_ = _ + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = H = Q, T = g;
                                            }
                                            for(z = 20, G = S, d = F, K = k, v = s, _ = n, g = h, p = y, N = t, J = D, R = r, b = e, M = i, u = f, L = l, P = m, U = c; Y = _, G = RA((_ = G + _ | 0) ^ P, 16), Y = P = RA(Y ^ (J = G + J | 0), 12), P = RA((x = _ + P | 0) ^ G, 8), _ = RA(Y ^ (J = P + J | 0), 7), M = RA((G = N + v | 0) ^ M, 16), N = RA((U = M + U | 0) ^ N, 12), v = RA((K = p + K | 0) ^ u, 16), p = RA((b = v + b | 0) ^ p, 12), u = (q = G + N | 0) + _ | 0, X = RA((K = p + K | 0) ^ v, 8), G = RA(u ^ X, 16), v = RA((d = g + d | 0) ^ L, 16), g = RA((R = v + R | 0) ^ g, 12), Y = _, L = RA((d = g + d | 0) ^ v, 8), Y = RA(Y ^ (_ = (j = L + R | 0) + G | 0), 12), u = RA(G ^ (v = Y + u | 0), 8), _ = RA((R = u + _ | 0) ^ Y, 7), Y = J, J = K, G = RA(M ^ q, 8), K = RA((M = G + U | 0) ^ N, 7), L = RA((J = J + K | 0) ^ L, 16), U = RA((N = Y + L | 0) ^ K, 12), L = RA(L ^ (K = U + J | 0), 8), N = RA((J = N + L | 0) ^ U, 7), U = M, M = d, d = RA((b = b + X | 0) ^ p, 7), p = U + (P = RA((M = M + d | 0) ^ P, 16)) | 0, U = M, M = RA(p ^ d, 12), P = RA(P ^ (d = U + M | 0), 8), p = RA((U = p + P | 0) ^ M, 7), Y = b, M = G, G = RA(g ^ j, 7), M = RA(M ^ (b = G + x | 0), 16), x = RA((g = Y + M | 0) ^ G, 12), M = RA(M ^ (G = x + b | 0), 8), g = RA((b = g + M | 0) ^ x, 7), z = z - 2 | 0;);
                                            if (z = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, x = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, X = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, j = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, O = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, V = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, Z = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, W = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, G = G + S ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[0 | H] = G, E[H + 1 | 0] = G >>> 8, E[H + 2 | 0] = G >>> 16, E[H + 3 | 0] = G >>> 24, G = M + i ^ CA, E[H + 60 | 0] = G, E[H + 61 | 0] = G >>> 8, E[H + 62 | 0] = G >>> 16, E[H + 63 | 0] = G >>> 24, G = u + f ^ gA, E[H + 56 | 0] = G, E[H + 57 | 0] = G >>> 8, E[H + 58 | 0] = G >>> 16, E[H + 59 | 0] = G >>> 24, G = L + l ^ IA, E[H + 52 | 0] = G, E[H + 53 | 0] = G >>> 8, E[H + 54 | 0] = G >>> 16, E[H + 55 | 0] = G >>> 24, G = P + m ^ AA, E[H + 48 | 0] = G, E[H + 49 | 0] = G >>> 8, E[H + 50 | 0] = G >>> 16, E[H + 51 | 0] = G >>> 24, G = U + c ^ $, E[H + 44 | 0] = G, E[H + 45 | 0] = G >>> 8, E[H + 46 | 0] = G >>> 16, E[H + 47 | 0] = G >>> 24, G = b + e ^ W, E[H + 40 | 0] = G, E[H + 41 | 0] = G >>> 8, E[H + 42 | 0] = G >>> 16, E[H + 43 | 0] = G >>> 24, G = R + r ^ Z, E[H + 36 | 0] = G, E[H + 37 | 0] = G >>> 8, E[H + 38 | 0] = G >>> 16, E[H + 39 | 0] = G >>> 24, G = J + D ^ V, E[H + 32 | 0] = G, E[H + 33 | 0] = G >>> 8, E[H + 34 | 0] = G >>> 16, E[H + 35 | 0] = G >>> 24, N = N + t ^ O, E[H + 28 | 0] = N, E[H + 29 | 0] = N >>> 8, E[H + 30 | 0] = N >>> 16, E[H + 31 | 0] = N >>> 24, p = Y ^ p + y, E[H + 24 | 0] = p, E[H + 25 | 0] = p >>> 8, E[H + 26 | 0] = p >>> 16, E[H + 27 | 0] = p >>> 24, g = j ^ g + h, E[H + 20 | 0] = g, E[H + 21 | 0] = g >>> 8, E[H + 22 | 0] = g >>> 16, E[H + 23 | 0] = g >>> 24, g = X ^ _ + n, E[H + 16 | 0] = g, E[H + 17 | 0] = g >>> 8, E[H + 18 | 0] = g >>> 16, E[H + 19 | 0] = g >>> 24, g = q ^ v + s, E[H + 12 | 0] = g, E[H + 13 | 0] = g >>> 8, E[H + 14 | 0] = g >>> 16, E[H + 15 | 0] = g >>> 24, g = x ^ K + k, E[H + 8 | 0] = g, E[H + 9 | 0] = g >>> 8, E[H + 10 | 0] = g >>> 16, E[H + 11 | 0] = g >>> 24, g = z ^ d + F, E[H + 4 | 0] = g, E[H + 5 | 0] = g >>> 8, E[H + 6 | 0] = g >>> 16, E[H + 7 | 0] = g >>> 24, l = !(m = m + 1 | 0) + l | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(_ = 0; E[_ + T | 0] = a[H + _ | 0], C >>> 0 > (_ = _ + 1 | 0) >>> 0;);
                                                o[A + 52 >> 2] = l, o[A + 48 >> 2] = m;
                                                break;
                                            }
                                            I = I - -64 | 0, g = H - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function N(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, c = 0;
                                        w = g = w - 704 | 0, C = 80 + ((B = o[A + 72 >> 2] >>> 3 & 127) + A | 0) | 0, B >>> 0 >= 112 ? (YA(C, 35008, 128 - B | 0), k(A, B = A + 80 | 0, g, g + 640 | 0), dA(B, 0, 112)) : YA(C, 35008, 112 - B | 0), f = (Q = o[A + 64 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 192 | 0] = C, E[A + 193 | 0] = C >>> 8, E[A + 194 | 0] = C >>> 16, E[A + 195 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 196 | 0] = B, E[A + 197 | 0] = B >>> 8, E[A + 198 | 0] = B >>> 16, E[A + 199 | 0] = B >>> 24, f = (Q = o[A + 72 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 200 | 0] = C, E[A + 201 | 0] = C >>> 8, E[A + 202 | 0] = C >>> 16, E[A + 203 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 204 | 0] = B, E[A + 205 | 0] = B >>> 8, E[A + 206 | 0] = B >>> 16, E[A + 207 | 0] = B >>> 24, k(A, A + 80 | 0, g, g + 640 | 0), f = (Q = o[A >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[0 | I] = C, E[I + 1 | 0] = C >>> 8, E[I + 2 | 0] = C >>> 16, E[I + 3 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, f = (Q = o[A + 8 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 8 | 0] = C, E[I + 9 | 0] = C >>> 8, E[I + 10 | 0] = C >>> 16, E[I + 11 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, f = (Q = o[A + 16 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 16 | 0] = C, E[I + 17 | 0] = C >>> 8, E[I + 18 | 0] = C >>> 16, E[I + 19 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, f = (Q = o[A + 24 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 24 | 0] = C, E[I + 25 | 0] = C >>> 8, E[I + 26 | 0] = C >>> 16, E[I + 27 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, f = (Q = o[A + 32 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 32 | 0] = C, E[I + 33 | 0] = C >>> 8, E[I + 34 | 0] = C >>> 16, E[I + 35 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 36 | 0] = B, E[I + 37 | 0] = B >>> 8, E[I + 38 | 0] = B >>> 16, E[I + 39 | 0] = B >>> 24, f = (Q = o[A + 40 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, f = (Q = o[A + 48 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 48 | 0] = C, E[I + 49 | 0] = C >>> 8, E[I + 50 | 0] = C >>> 16, E[I + 51 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 52 | 0] = B, E[I + 53 | 0] = B >>> 8, E[I + 54 | 0] = B >>> 16, E[I + 55 | 0] = B >>> 24, f = (Q = o[A + 56 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = o[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, E[C + 56 | 0] = I, E[C + 57 | 0] = I >>> 8, E[C + 58 | 0] = I >>> 16, E[C + 59 | 0] = I >>> 24, I = (I = B | i | f) | (B = 0) | B | 0, E[C + 60 | 0] = I, E[C + 61 | 0] = I >>> 8, E[C + 62 | 0] = I >>> 16, E[C + 63 | 0] = I >>> 24, iI(g, 704), iI(A, 208), w = g + 704 | 0;
                                    }
                                    function J(A, I, g) {
                                        var C, B = 0, i = 0, f = 0, c = 0, e = 0, r = 0;
                                        w = C = w + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (f = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, e = i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = (c = f + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, E[0 | B] = c, E[B + 1 | 0] = c >>> 8, E[B + 2 | 0] = c >>> 16, E[B + 3 | 0] = c >>> 24, E[B + 4 | 0] = i, E[B + 5 | 0] = i >>> 8, E[B + 6 | 0] = i >>> 16, E[B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (B = -1 == (0 | e) & f >>> 0 > 4294967167) >>> 0 > (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, n(A, i = A + 96 | 0), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, B >>> 0 >= 129) break A;
                                                        YA(i, A + 224 | 0, B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, f = r = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, f = (e = i + c | 0) >>> 0 < c >>> 0 ? f + 1 | 0 : f, E[0 | B] = e, E[B + 1 | 0] = e >>> 8, E[B + 2 | 0] = e >>> 16, E[B + 3 | 0] = e >>> 24, E[B + 4 | 0] = f, E[B + 5 | 0] = f >>> 8, E[B + 6 | 0] = f >>> 16, E[B + 7 | 0] = f >>> 24, B = (0 | f) == (0 | r) & i >>> 0 > e >>> 0 | f >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < B >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (E[A + 88 | 0] = 255, E[A + 89 | 0] = 255, E[A + 90 | 0] = 255, E[A + 91 | 0] = 255, E[A + 92 | 0] = 255, E[A + 93 | 0] = 255, E[A + 94 | 0] = 255, E[A + 95 | 0] = 255), E[A + 80 | 0] = 255, E[A + 81 | 0] = 255, E[A + 82 | 0] = 255, E[A + 83 | 0] = 255, E[A + 84 | 0] = 255, E[A + 85 | 0] = 255, E[A + 86 | 0] = 255, E[A + 87 | 0] = 255, dA((B = A + 96 | 0) + c | 0, 0, 256 - c | 0), n(A, B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, o[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, o[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, o[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, o[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, o[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, o[C + 60 >> 2] = i, YA(I, C, g), iI(A, 64), iI(B, 256), B = 0;
                                                }
                                                return w = C - -64 | 0, B;
                                            }
                                            zA(), Q();
                                        }
                                        D(1280, 1142, 306, 1086), Q();
                                    }
                                    function U(A, I) {
                                        var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0;
                                        for(w = g = w - 320 | 0, L(C = A + 40 | 0, I), o[A + 84 >> 2] = 0, o[A + 88 >> 2] = 0, o[A + 80 >> 2] = 1, o[A + 92 >> 2] = 0, o[A + 96 >> 2] = 0, o[A + 100 >> 2] = 0, o[A + 104 >> 2] = 0, o[A + 108 >> 2] = 0, o[A + 112 >> 2] = 0, o[A + 116 >> 2] = 0, M(N = g + 240 | 0, C), H(_ = g + 192 | 0, N, 1344), J = -1, B = o[g + 240 >> 2] - 1 | 0, o[g + 240 >> 2] = B, o[g + 192 >> 2] = o[g + 192 >> 2] + 1, Q = o[g + 244 >> 2], i = o[g + 248 >> 2], f = o[g + 252 >> 2], c = o[g + 256 >> 2], e = o[g + 260 >> 2], r = o[g + 264 >> 2], D = o[g + 268 >> 2], t = o[g + 272 >> 2], y = o[g + 276 >> 2], M(p = g + 144 | 0, _), H(p, p, _), M(A, p), H(A, A, _), H(A, A, N), w = S = w - 144 | 0, M(G = S + 96 | 0, A), M(F = S + 48 | 0, G), M(F, F), H(F, A, F), H(G, G, F), M(G, G), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), H(F, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), F = 1; M(S, S), 100 != (0 | (F = F + 1 | 0)););
                                        H(F = S + 48 | 0, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G = S + 96 | 0, F, G), M(G, G), M(G, G), H(A, G, A), w = S + 144 | 0, H(A, A, p), H(A, A, N), M(F = g + 96 | 0, A), H(F, F, _), F = o[g + 132 >> 2], o[g + 84 >> 2] = F - y, S = o[g + 128 >> 2], o[g + 80 >> 2] = S - t, G = o[g + 124 >> 2], o[g + 76 >> 2] = G - D, _ = o[g + 120 >> 2], o[g + 72 >> 2] = _ - r, p = o[g + 116 >> 2], o[g + 68 >> 2] = p - e, N = o[g + 112 >> 2], o[g + 64 >> 2] = N - c, h = o[g + 108 >> 2], o[g + 60 >> 2] = h - f, n = o[g + 104 >> 2], o[g + 56 >> 2] = n - i, s = o[g + 100 >> 2], o[g + 52 >> 2] = s - Q, k = o[g + 96 >> 2], o[g + 48 >> 2] = k - B, IA(g, g + 48 | 0);
                                        A: {
                                            if (!fA(g, 32)) {
                                                if (o[g + 36 >> 2] = F + y, o[g + 32 >> 2] = S + t, o[g + 28 >> 2] = G + D, o[g + 24 >> 2] = _ + r, o[g + 20 >> 2] = p + e, o[g + 16 >> 2] = N + c, o[g + 12 >> 2] = f + h, o[g + 8 >> 2] = i + n, o[g + 4 >> 2] = Q + s, o[g >> 2] = B + k, IA(F = g + 288 | 0, g), !fA(F, 32)) break A;
                                                H(A, A, 1392);
                                            }
                                            IA(g + 288 | 0, A), (1 & E[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (o[A >> 2] = 0 - o[A >> 2], o[A + 36 >> 2] = 0 - o[A + 36 >> 2], o[A + 32 >> 2] = 0 - o[A + 32 >> 2], o[A + 28 >> 2] = 0 - o[A + 28 >> 2], o[A + 24 >> 2] = 0 - o[A + 24 >> 2], o[A + 20 >> 2] = 0 - o[A + 20 >> 2], o[A + 16 >> 2] = 0 - o[A + 16 >> 2], o[A + 12 >> 2] = 0 - o[A + 12 >> 2], o[A + 8 >> 2] = 0 - o[A + 8 >> 2], o[A + 4 >> 2] = 0 - o[A + 4 >> 2]), H(A + 120 | 0, A, C), J = 0;
                                        }
                                        return w = g + 320 | 0, J;
                                    }
                                    function Y(A, I, g) {
                                        var C, B, Q, i, o, f, c, e, r, D, t, y, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0;
                                        for(k = 1634760805, h = C = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = B = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, S = Q = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, H = i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, p = 857760878, G = o = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, n = f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, M = c = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, J = e = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = 2036477234, s = r = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, w = 1797285236, U = D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, N = t = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, g = y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24; _ = RA(h + p | 0, 7) ^ J, Y = RA(_ + p | 0, 9) ^ N, H = RA(g + k | 0, 7) ^ H, d = RA(H + k | 0, 9) ^ M, b = RA(d + H | 0, 13) ^ g, S = RA(w + s | 0, 7) ^ S, K = RA(S + w | 0, 9) ^ n, M = RA(S + K | 0, 13) ^ s, s = RA(K + M | 0, 18) ^ w, n = RA(I + G | 0, 7) ^ U, g = b ^ RA(s + n | 0, 7), N = Y ^ RA(g + s | 0, 9), U = RA(g + N | 0, 13) ^ n, w = RA(N + U | 0, 18) ^ s, F = RA(I + n | 0, 9) ^ F, G = RA(F + n | 0, 13) ^ G, I = RA(G + F | 0, 18) ^ I, s = RA(I + _ | 0, 7) ^ M, M = RA(s + I | 0, 9) ^ d, J = RA(s + M | 0, 13) ^ _, I = RA(M + J | 0, 18) ^ I, _ = RA(_ + Y | 0, 13) ^ h, h = RA(_ + Y | 0, 18) ^ p, G = RA(h + H | 0, 7) ^ G, n = RA(G + h | 0, 9) ^ K, H = RA(n + G | 0, 13) ^ H, p = RA(n + H | 0, 18) ^ h, k = RA(d + b | 0, 18) ^ k, h = RA(k + S | 0, 7) ^ _, F = RA(h + k | 0, 9) ^ F, S = RA(h + F | 0, 13) ^ S, k = RA(F + S | 0, 18) ^ k, _ = P >>> 0 < 18, P = P + 2 | 0, _;);
                                        w = w + 1797285236 | 0, E[A + 60 | 0] = w, E[A + 61 | 0] = w >>> 8, E[A + 62 | 0] = w >>> 16, E[A + 63 | 0] = w >>> 24, w = U + D | 0, E[A + 56 | 0] = w, E[A + 57 | 0] = w >>> 8, E[A + 58 | 0] = w >>> 16, E[A + 59 | 0] = w >>> 24, w = N + t | 0, E[A + 52 | 0] = w, E[A + 53 | 0] = w >>> 8, E[A + 54 | 0] = w >>> 16, E[A + 55 | 0] = w >>> 24, g = g + y | 0, E[A + 48 | 0] = g, E[A + 49 | 0] = g >>> 8, E[A + 50 | 0] = g >>> 16, E[A + 51 | 0] = g >>> 24, g = s + r | 0, E[A + 44 | 0] = g, E[A + 45 | 0] = g >>> 8, E[A + 46 | 0] = g >>> 16, E[A + 47 | 0] = g >>> 24, I = I + 2036477234 | 0, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = J + e | 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, I = M + c | 0, E[A + 32 | 0] = I, E[A + 33 | 0] = I >>> 8, E[A + 34 | 0] = I >>> 16, E[A + 35 | 0] = I >>> 24, I = n + f | 0, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = G + o | 0, E[A + 24 | 0] = I, E[A + 25 | 0] = I >>> 8, E[A + 26 | 0] = I >>> 16, E[A + 27 | 0] = I >>> 24, I = p + 857760878 | 0, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = H + i | 0, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, I = S + Q | 0, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = F + B | 0, E[A + 8 | 0] = I, E[A + 9 | 0] = I >>> 8, E[A + 10 | 0] = I >>> 16, E[A + 11 | 0] = I >>> 24, I = h + C | 0, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = k + 1634760805 | 0, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24;
                                    }
                                    function d(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        if (w = o[A + 36 >> 2], t = o[A + 32 >> 2], y = o[A + 28 >> 2], r = o[A + 24 >> 2], D = o[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(p = !a[A + 80 | 0] << 24, s = o[A + 4 >> 2], N = c(s, 5), F = o[A + 8 >> 2], _ = c(F, 5), H = o[A + 12 >> 2], G = c(H, 5), M = o[A + 16 >> 2], S = c(M, 5), k = o[A >> 2]; B = kA(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, H, 0), f = h, D = (E = kA(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + D | 0, 0, M, 0)) + B | 0, B = h + f | 0, B = E >>> 0 > D >>> 0 ? B + 1 | 0 : B, f = kA(y = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + y | 0, 0, F, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(t = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + t | 0, 0, s, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(w = w + p + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, k, 0), B = h + B | 0, J = D = f + D | 0, D = f >>> 0 > D >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, F, 0), f = h, E = kA(r, 0, H, 0), Q = h + f | 0, Q = (B = E + B | 0) >>> 0 < E >>> 0 ? Q + 1 | 0 : Q, f = (E = kA(y, 0, s, 0)) + B | 0, B = h + Q | 0, B = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, E = kA(t, 0, k, 0), B = h + B | 0, B = E >>> 0 > (f = E + f | 0) >>> 0 ? B + 1 | 0 : B, E = kA(w, 0, S, 0), B = h + B | 0, U = f = E + f | 0, f = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, s, 0), e = h, E = (Q = kA(r, 0, F, 0)) + B | 0, B = h + e | 0, B = Q >>> 0 > E >>> 0 ? B + 1 | 0 : B, e = kA(y, 0, k, 0), Q = h + B | 0, Q = (E = e + E | 0) >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, e = kA(t, 0, S, 0), B = h + Q | 0, B = (E = e + E | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(w, 0, G, 0), B = h + B | 0, Y = E = e + E | 0, E = E >>> 0 < e >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, k, 0), Q = h, e = (n = kA(r, 0, s, 0)) + B | 0, B = h + Q | 0, B = e >>> 0 < n >>> 0 ? B + 1 | 0 : B, Q = kA(y, 0, S, 0), B = h + B | 0, B = Q >>> 0 > (e = Q + e | 0) >>> 0 ? B + 1 | 0 : B, n = kA(t, 0, G, 0), Q = h + B | 0, Q = (e = n + e | 0) >>> 0 < n >>> 0 ? Q + 1 | 0 : Q, n = kA(w, 0, _, 0), B = h + Q | 0, B = (e = n + e | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B, n = e, e = B, B = kA(i, 0, S, 0), Q = h, i = (r = kA(r, 0, k, 0)) + B | 0, B = h + Q | 0, B = i >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(y, 0, G, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(t, 0, _, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(w, 0, N, 0), Q = h + B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, B = e, B = (i = (y = (67108863 & Q) << 6 | i >>> 26) + n | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = i, t = (67108863 & B) << 6 | i >>> 26, B = E, B = (i = t + Y | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = i, Q = f, w = B = (i = (67108863 & B) << 6 | i >>> 26) + U | 0, f = (67108863 & (Q = B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | B >>> 26, B = D, r = (67108863 & y) + ((B = c((67108863 & ((i = f + J | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, y = 67108863 & t, t = 67108863 & w, w = 67108863 & i, D = 67108863 & B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        o[A + 20 >> 2] = D, o[A + 36 >> 2] = w, o[A + 32 >> 2] = t, o[A + 28 >> 2] = y, o[A + 24 >> 2] = r;
                                    }
                                    function K(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var B = 0;
                                        return B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (w = B = w - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, E[A + 4 | 0] = C, E[A + 5 | 0] = C >>> 8, E[A + 6 | 0] = C >>> 16, E[A + 7 | 0] = C >>> 24, dA(g + B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = YA(B, I, g), YA(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24, iI(g, 128), w = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (zA(), Q()), dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, I ^= -222443256, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24, E[A + 4 | 0] = 103, E[A + 5 | 0] = 230, E[A + 6 | 0] = 9, E[A + 7 | 0] = 106), B = 0), 0 | B;
                                    }
                                    function b(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = r << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = e << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = c << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = f << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = a << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = E << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = i << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = Q << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = K << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = D << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function P(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g + 40 | 0), H(t, t, g), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = o[A + 156 >> 2], g = r << 1, o[A + 156 >> 2] = I + g, t = o[A + 152 >> 2], y = e << 1, o[A + 152 >> 2] = t + y, h = o[A + 148 >> 2], n = c << 1, o[A + 148 >> 2] = h + n, s = o[A + 144 >> 2], k = f << 1, o[A + 144 >> 2] = s + k, F = o[A + 140 >> 2], S = a << 1, o[A + 140 >> 2] = F + S, G = o[A + 136 >> 2], _ = E << 1, o[A + 136 >> 2] = G + _, M = o[A + 132 >> 2], p = i << 1, o[A + 132 >> 2] = M + p, w = o[A + 128 >> 2], N = Q << 1, o[A + 128 >> 2] = w + N, J = o[A + 124 >> 2], U = K << 1, o[A + 124 >> 2] = J + U, Y = o[A + 120 >> 2], d = D << 1, o[A + 120 >> 2] = Y + d, o[A + 112 >> 2] = y - t, o[A + 108 >> 2] = n - h, o[A + 104 >> 2] = k - s, o[A + 100 >> 2] = S - F, o[A + 96 >> 2] = _ - G, o[A + 92 >> 2] = p - M, o[A + 88 >> 2] = N - w, o[A + 84 >> 2] = U - J, o[A + 80 >> 2] = d - Y, o[A + 116 >> 2] = g - I;
                                    }
                                    function v(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 80 | 0, I + 120 | 0), K = o[I + 80 >> 2], Q = o[I + 84 >> 2], i = o[I + 88 >> 2], E = o[I + 92 >> 2], a = o[I + 96 >> 2], f = o[I + 100 >> 2], c = o[I + 104 >> 2], e = o[I + 108 >> 2], r = o[I + 112 >> 2], D = o[I + 116 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = D << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = r << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = e << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = c << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = f << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = a << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = E << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = i << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = Q << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = K << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function L(A, I) {
                                        var g, C, B, Q, i, E, f, c, e, r, D, t, y, w, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0;
                                        y = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], E = a[I + 9 | 0], f = a[I + 8 | 0], c = a[I + 7 | 0], e = a[I + 12 | 0], N = a[I + 11 | 0], J = a[I + 10 | 0], r = a[I + 15 | 0], U = a[I + 14 | 0], D = a[I + 13 | 0], G = a[I + 28 | 0], p = a[I + 27 | 0], _ = a[I + 26 | 0], H = a[I + 25 | 0], F = a[I + 24 | 0], k = a[I + 23 | 0], w = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, S = (s = a[I + 21 | 0]) << 15, s = n = s >>> 17 | 0, M = S, M |= (S = a[I + 20 | 0]) << 7, S = (n = S >>> 25 | 0) | s, s = (n = a[I + 22 | 0]) >>> 9 | 0, n = n << 23 | M, s |= S, t = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, S = n, n = (33554431 & (I = (M = t + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | M >>> 25, I = (I >>> 25 | 0) + s | 0, n = (s = S = S + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, I = (S = s + 33554432 | 0) >>> 0 < 33554432 ? n + 1 | 0 : n, o[A + 24 >> 2] = s - (-67108864 & S), n = (s = k >>> 27 | 0) | F >>> 19 | H >>> 11, s = k = (F = H << 21 | (k = F << 13 | k << 5)) + (s = (67108863 & (s = I)) << 6 | S >>> 26) | 0, I = n, n = (k = F + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 28 >> 2] = s - (1040187392 & k), s = (n = (I = n) >>> 25 | 0) + (s = p >>> 20 | _ >>> 28 | G >>> 12) | 0, I = s = (n = k = (I = (33554431 & I) << 7 | k >>> 25) + (p << 12 | _ << 4 | G << 20) | 0) >>> 0 < I >>> 0 ? s + 1 | 0 : s, k = (G = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 32 >> 2] = n - (-67108864 & G), s = e >>> 13 | (n = N >>> 21 | J >>> 29), I = (s = (p = 16777216 + (N = N << 11 | J << 3 | e << 19) | 0) >>> 0 < 16777216 ? s + 1 | 0 : s) >>> 25 | 0, s = (n = F = U << 10 | D << 2 | r << 18) + (F = (33554431 & s) << 7 | p >>> 25) | 0, n = I + (H = U >>> 22 | D >>> 30 | r >>> 14) | 0, I = n = s >>> 0 < F >>> 0 ? n + 1 | 0 : n, F = ((67108863 & (I = (F = s + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (n = F) >>> 26) + (_ = t - (-33554432 & M) | 0) | 0, o[A + 20 >> 2] = F, o[A + 16 >> 2] = s - (-67108864 & n), n = Q >>> 18 | i >>> 26 | B >>> 10, s = (n = (_ = 16777216 + (J = Q << 14 | i << 6 | B << 22) | 0) >>> 0 < 16777216 ? n + 1 | 0 : n) >>> 25 | 0, n = (I = F = f << 13 | c << 5 | E << 21) + (F = (33554431 & n) << 7 | _ >>> 25) | 0, I = s + (H = f >>> 19 | c >>> 27 | E >>> 11) | 0, I = n >>> 0 < F >>> 0 ? I + 1 | 0 : I, s = (H = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 8 >> 2] = n - (-67108864 & H), G = (k = (67108863 & k) << 6 | G >>> 26) + (U = y << 18 & 33292288 | g << 10 | C << 2) | 0, I = n = g >>> 22 | C >>> 30, n = (k = U + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = G - (33554432 & k), s = N + ((67108863 & s) << 6 | H >>> 26) | 0, o[A + 12 >> 2] = s - (234881024 & p), F = J - (2113929216 & _) | 0, s = kA((33554431 & (I = n)) << 7 | k >>> 25, n = I >>> 25 | 0, 19, 0), I = h, s = (n = s + w | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, k = ((67108863 & (s = (I = n + 33554432 | 0) >>> 0 < 33554432 ? s + 1 | 0 : s)) << 6 | I >>> 26) + F | 0, o[A + 4 >> 2] = k, o[A >> 2] = n - (-67108864 & I);
                                    }
                                    function R(A, I, g, C) {
                                        var B, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0;
                                        if (w = B = w - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = f = o[A + 76 >> 2]) | 0, e = (r = o[A + 72 >> 2]) + (c = g << 3) | 0, o[A + 72 >> 2] = e, Q = c >>> 0 > e >>> 0 ? Q + 1 | 0 : Q, o[A + 76 >> 2] = Q, f = o[4 + (c = A - -64 | 0) >> 2], f = (D = Q = (0 | Q) == (0 | i) & e >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + o[c >> 2] | 0) >>> 0 ? f + 1 | 0 : f, e = (D = C >>> 29 | 0) + Q | 0, Q = f, o[c >> 2] = e, o[c + 4 >> 2] = e >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (f = D = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (e = 128 - c | 0) >>> 0 | C >>> 0 > f >>> 0) {
                                                if (i = 0, f = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(s = 252 & e, r = A + 80 | 0; E[(Q = i + c | 0) + r | 0] = a[I + i | 0], E[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | h) != (0 | s) | (0 | n) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & e)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = f, f = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | t) | (0 | r) != (0 | Q););
                                                if (k(A, A + 80 | 0, B, i = B + 640 | 0), I = I + e | 0, !(C = C - ((g >>> 0 < e >>> 0) + D | 0) | 0) & (g = g - e | 0) >>> 0 > 127 | C) for(; k(A, I, B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (h = 3 & g, e = 0, t = 0, n = 0, i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, y = A + 80 | 0, g = 0, C = 0; E[i + y | 0] = a[I + i | 0], E[(Q = 1 | i) + y | 0] = a[I + Q | 0], E[(Q = 2 | i) + y | 0] = a[I + Q | 0], E[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (e | h) for(; E[80 + (A + i | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | t) != (0 | h) | (0 | e) != (0 | Q););
                                                }
                                                iI(B, 704);
                                            } else {
                                                if (i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(e = -4 & g, r = C, C = A + 80 | 0; E[C + (Q = i + c | 0) | 0] = a[I + i | 0], E[C + (D = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | e) != (0 | h) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | t) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return w = B + 704 | 0, 0;
                                    }
                                    function u(A, I) {
                                        var g, C, B, Q, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        for(w = g = w - 480 | 0; c = (f = g + 288 | 0) + (i << 1) | 0, e = a[I + i | 0], E[c + 1 | 0] = e >>> 4, E[0 | c] = 15 & e, f = f + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], E[f + 1 | 0] = c >>> 4, E[0 | f] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (f = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, E[0 | I] = f - (240 & i), i = 8 + (f = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 1 | 0] = f - (240 & i), i = 8 + (f = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 2 | 0] = f - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(E[g + 351 | 0] = a[g + 351 | 0] + I, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A >> 2] = 0, o[A + 4 >> 2] = 0, o[A + 44 >> 2] = 0, o[A + 48 >> 2] = 0, o[(I = A + 40 | 0) >> 2] = 1, o[A + 52 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[A + 80 >> 2] = 1, dA(A + 84 | 0, 0, 76), B = A + 120 | 0, r = A + 80 | 0, f = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), D = i >>> 0 < 62, i = i + 2 | 0, D;);
                                        for(i = o[A + 36 >> 2], o[g + 392 >> 2] = o[A + 32 >> 2], o[g + 396 >> 2] = i, i = o[A + 28 >> 2], o[g + 384 >> 2] = o[A + 24 >> 2], o[g + 388 >> 2] = i, i = o[A + 20 >> 2], o[g + 376 >> 2] = o[A + 16 >> 2], o[g + 380 >> 2] = i, i = o[A + 12 >> 2], o[g + 368 >> 2] = o[A + 8 >> 2], o[g + 372 >> 2] = i, i = o[A + 4 >> 2], o[g + 360 >> 2] = o[A >> 2], o[g + 364 >> 2] = i, i = o[I + 12 >> 2], o[g + 408 >> 2] = o[I + 8 >> 2], o[g + 412 >> 2] = i, i = o[I + 20 >> 2], o[g + 416 >> 2] = o[I + 16 >> 2], o[g + 420 >> 2] = i, i = o[I + 28 >> 2], o[g + 424 >> 2] = o[I + 24 >> 2], o[g + 428 >> 2] = i, i = o[I + 36 >> 2], o[g + 432 >> 2] = o[I + 32 >> 2], o[g + 436 >> 2] = i, i = o[I + 4 >> 2], o[g + 400 >> 2] = o[I >> 2], o[g + 404 >> 2] = i, i = o[r + 12 >> 2], o[g + 448 >> 2] = o[r + 8 >> 2], o[g + 452 >> 2] = i, i = o[r + 20 >> 2], o[g + 456 >> 2] = o[r + 16 >> 2], o[g + 460 >> 2] = i, i = o[r + 28 >> 2], o[g + 464 >> 2] = o[r + 24 >> 2], o[g + 468 >> 2] = i, i = o[r + 36 >> 2], o[g + 472 >> 2] = o[r + 32 >> 2], o[g + 476 >> 2] = i, i = o[r + 4 >> 2], o[g + 440 >> 2] = o[r >> 2], o[g + 444 >> 2] = i, G(e, i = g + 360 | 0), H(i, e, c), H(D = g + 400 | 0, C, f), H(Q = g + 440 | 0, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), i = 0; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        w = g + 480 | 0;
                                    }
                                    function x(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(B = 2036477234, i = 857760878, C = 1634760805, f = 1797285236, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, r = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; e = g, g = RA((n = I) ^ (I = g + C | 0), 16), e = t = RA(e ^ (C = g + t | 0), 12), F = RA((n = I + t | 0) ^ g, 8), I = RA(e ^ (t = F + C | 0), 7), C = y, y = RA((g = f + y | 0) ^ Q, 16), C = RA(C ^ (D = y + D | 0), 12), Q = w, f = RA((B = B + w | 0) ^ r, 16), Q = RA(Q ^ (w = f + c | 0), 12), c = RA((B = Q + B | 0) ^ f, 8), g = RA(c ^ (f = I + (s = g + C | 0) | 0), 16), r = RA((i = i + h | 0) ^ o, 16), h = RA((o = r + k | 0) ^ h, 12), e = I, I = RA((i = i + h | 0) ^ r, 8), e = RA(e ^ (o = g + (S = I + o | 0) | 0), 12), r = RA(g ^ (f = e + f | 0), 8), g = RA((k = r + o | 0) ^ e, 7), e = B, B = C, s = RA(y ^ s, 8), B = RA(B ^ (C = s + D | 0), 7), y = RA((o = e + B | 0) ^ I, 16), D = RA((I = y + t | 0) ^ B, 12), o = RA(y ^ (B = D + o | 0), 8), y = RA((t = I + o | 0) ^ D, 7), I = RA((I = Q) ^ (Q = c + w | 0), 7), w = RA((i = I + i | 0) ^ F, 16), c = RA(I ^ (C = w + C | 0), 12), I = RA(w ^ (i = c + i | 0), 8), w = RA((D = C + I | 0) ^ c, 7), e = Q, C = RA(h ^ S, 7), c = RA((Q = C + n | 0) ^ s, 16), n = RA(C ^ (h = e + c | 0), 12), Q = RA(c ^ (C = n + Q | 0), 8), h = RA((c = h + Q | 0) ^ n, 7), 10 != (0 | (H = H + 1 | 0)););
                                        E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = r, E[A + 25 | 0] = r >>> 8, E[A + 26 | 0] = r >>> 16, E[A + 27 | 0] = r >>> 24, E[A + 20 | 0] = o, E[A + 21 | 0] = o >>> 8, E[A + 22 | 0] = o >>> 16, E[A + 23 | 0] = o >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = f, E[A + 13 | 0] = f >>> 8, E[A + 14 | 0] = f >>> 16, E[A + 15 | 0] = f >>> 24, E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 4 | 0] = i, E[A + 5 | 0] = i >>> 8, E[A + 6 | 0] = i >>> 16, E[A + 7 | 0] = i >>> 24;
                                    }
                                    function m(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(C = 1797285236, c = 2036477234, e = 857760878, B = 1634760805, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, n = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, h = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, s = 20, y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, w = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, D = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, t = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; f = RA(g + e | 0, 7) ^ Q, k = RA(f + e | 0, 9) ^ h, r = RA(B + y | 0, 7) ^ r, F = RA(r + B | 0, 9) ^ o, S = RA(F + r | 0, 13) ^ y, D = RA(C + w | 0, 7) ^ D, i = RA(D + C | 0, 9) ^ i, o = RA(i + D | 0, 13) ^ w, C = RA(i + o | 0, 18) ^ C, Q = RA(I + c | 0, 7) ^ n, y = S ^ RA(C + Q | 0, 7), h = k ^ RA(y + C | 0, 9), n = RA(y + h | 0, 13) ^ Q, C = RA(h + n | 0, 18) ^ C, t = RA(Q + c | 0, 9) ^ t, H = RA(t + Q | 0, 13) ^ I, I = RA(H + t | 0, 18) ^ c, w = RA(I + f | 0, 7) ^ o, o = RA(w + I | 0, 9) ^ F, Q = RA(o + w | 0, 13) ^ f, c = RA(Q + o | 0, 18) ^ I, f = RA(f + k | 0, 13) ^ g, g = RA(f + k | 0, 18) ^ e, I = RA(g + r | 0, 7) ^ H, i = RA(I + g | 0, 9) ^ i, r = RA(I + i | 0, 13) ^ r, e = RA(i + r | 0, 18) ^ g, B = RA(F + S | 0, 18) ^ B, g = RA(B + D | 0, 7) ^ f, t = RA(g + B | 0, 9) ^ t, D = RA(g + t | 0, 13) ^ D, B = RA(t + D | 0, 18) ^ B, f = s >>> 0 > 2, s = s - 2 | 0, f;);
                                        return E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = o, E[A + 25 | 0] = o >>> 8, E[A + 26 | 0] = o >>> 16, E[A + 27 | 0] = o >>> 24, E[A + 20 | 0] = i, E[A + 21 | 0] = i >>> 8, E[A + 22 | 0] = i >>> 16, E[A + 23 | 0] = i >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = C, E[A + 13 | 0] = C >>> 8, E[A + 14 | 0] = C >>> 16, E[A + 15 | 0] = C >>> 24, E[A + 8 | 0] = c, E[A + 9 | 0] = c >>> 8, E[A + 10 | 0] = c >>> 16, E[A + 11 | 0] = c >>> 24, E[A + 4 | 0] = e, E[A + 5 | 0] = e >>> 8, E[A + 6 | 0] = e >>> 16, E[A + 7 | 0] = e >>> 24, 0;
                                    }
                                    function l(A, I) {
                                        var g, C, B = 0, Q = 0, i = 0, a = 0;
                                        w = g = w - 288 | 0, Q = 40 + ((B = o[A + 32 >> 2] >>> 3 & 63) + A | 0) | 0, B >>> 0 >= 56 ? (YA(Q, 34224, 64 - B | 0), _(A, A + 40 | 0, g, g + 256 | 0), o[A + 88 >> 2] = 0, o[A + 92 >> 2] = 0, o[A + 80 >> 2] = 0, o[A + 84 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[(B = A - -64 | 0) >> 2] = 0, o[B + 4 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 48 >> 2] = 0, o[A + 52 >> 2] = 0, o[A + 40 >> 2] = 0, o[A + 44 >> 2] = 0) : YA(Q, 34224, 56 - B | 0), i = (B = 16711680 & (Q = o[A + 32 >> 2])) >>> 8 | 0, a = B << 24, C = (B = -16777216 & Q) >>> 24 | 0, B = (a |= B << 8) | -16777216 & ((255 & (B = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & B) << 8 | Q >>> 24) | B >>> 8 & 65280 | B >>> 24, E[A + 96 | 0] = B, E[A + 97 | 0] = B >>> 8, E[A + 98 | 0] = B >>> 16, E[A + 99 | 0] = B >>> 24, B = (B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, E[A + 100 | 0] = B, E[A + 101 | 0] = B >>> 8, E[A + 102 | 0] = B >>> 16, E[A + 103 | 0] = B >>> 24, _(A, A + 40 | 0, g, g + 256 | 0), B = (B = o[A >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, B = (B = o[A + 4 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, B = (B = o[A + 8 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, B = (B = o[A + 12 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, B = (B = o[A + 16 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, B = (B = o[A + 20 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, B = (B = o[A + 24 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, B = (B = o[A + 28 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, iI(g, 288), iI(A, 104), w = g + 288 | 0;
                                    }
                                    function z(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0;
                                        if (w = C = w - 288 | 0, g) {
                                            if (e = (B = o[A + 36 >> 2]) + (g >>> 29 | 0) | 0, t = (i = o[A + 32 >> 2]) + (f = g << 3) | 0, o[A + 32 >> 2] = t, o[A + 36 >> 2] = f >>> 0 > t >>> 0 ? e + 1 | 0 : e, !0 & (f = 64 - (e = 63 & ((7 & B) << 29 | i >>> 3)) | 0) >>> 0 <= g >>> 0) {
                                                if (B = 0, i = 0, (63 ^ e) >>> 0 >= 3) for(n = 124 & f, t = A + 40 | 0; E[(B + e | 0) + t | 0] = a[I + B | 0], E[(e + (h = 1 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 2 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 3 | B) | 0) + t | 0] = a[I + h | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | y) != (0 | n););
                                                if (Q = 3 & f) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | Q) != (0 | D););
                                                if (_(A, A + 40 | 0, C, r = C + 256 | 0), I = I + f | 0, !(Q = 0 - ((g >>> 0 < f >>> 0) + c | 0) | 0) & (g = g - f | 0) >>> 0 > 63 | Q) for(; _(A, I, C, r), I = I - -64 | 0, Q = Q - 1 | 0, !(Q = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | Q;);
                                                if (g | Q) {
                                                    if (y = 3 & g, D = 0, r = 0, B = 0, i = 0, !Q & g >>> 0 >= 4 | Q) for(t = -4 & g, e = Q, f = A + 40 | 0, g = 0, Q = 0; E[B + f | 0] = a[I + B | 0], E[(c = 1 | B) + f | 0] = a[I + c | 0], E[(c = 2 | B) + f | 0] = a[I + c | 0], E[(c = 3 | B) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (0 | (g = g + 4 | 0)) != (0 | t) | (0 | (Q = g >>> 0 < 4 ? Q + 1 | 0 : Q)) != (0 | e););
                                                    if (y) for(; E[40 + (A + B | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | D) != (0 | y););
                                                }
                                                iI(C, 288);
                                            } else {
                                                if (B = 0, i = 0, g >>> 0 >= 4) for(t = -4 & g, f = A + 40 | 0; E[(B + e | 0) + f | 0] = a[I + B | 0], E[(e + (c = 1 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 2 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 3 | B) | 0) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | t) != (0 | y););
                                                if (g &= 3) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | g) != (0 | D););
                                            }
                                        }
                                        w = C + 288 | 0;
                                    }
                                    function q(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        if (w = C = w - 96 | 0, g >>> 0 >= 65 && (SA(A), z(A, I, g), l(A, C), g = 32, I = C), SA(A), o[C + 88 >> 2] = 909522486, o[C + 92 >> 2] = 909522486, o[C + 80 >> 2] = 909522486, o[C + 84 >> 2] = 909522486, o[C + 72 >> 2] = 909522486, o[C + 76 >> 2] = 909522486, o[(i = r = C - -64 | 0) >> 2] = 909522486, o[i + 4 >> 2] = 909522486, o[C + 56 >> 2] = 909522486, o[C + 60 >> 2] = 909522486, o[C + 48 >> 2] = 909522486, o[C + 52 >> 2] = 909522486, o[C + 40 >> 2] = 909522486, o[C + 44 >> 2] = 909522486, o[C + 32 >> 2] = 909522486, o[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(f = 124 & g; E[0 | (Q = (i = C + 32 | 0) + B | 0)] = a[0 | Q] ^ a[I + B | 0], E[0 | (D = (Q = 1 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (D = (Q = 2 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (Q = (Q = i) + (i = 3 | B) | 0)] = a[0 | Q] ^ a[I + i | 0], B = B + 4 | 0, (0 | f) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; E[0 | (i = (C + 32 | 0) + B | 0)] = a[0 | i] ^ a[I + B | 0], B = B + 1 | 0, (0 | c) != (0 | (e = e + 1 | 0)););
                                        }
                                        if (z(A, C + 32 | 0, 64), SA(i = A + 104 | 0), o[C + 88 >> 2] = 1549556828, o[C + 92 >> 2] = 1549556828, o[C + 80 >> 2] = 1549556828, o[C + 84 >> 2] = 1549556828, o[C + 72 >> 2] = 1549556828, o[C + 76 >> 2] = 1549556828, o[r >> 2] = 1549556828, o[r + 4 >> 2] = 1549556828, o[C + 56 >> 2] = 1549556828, o[C + 60 >> 2] = 1549556828, o[C + 48 >> 2] = 1549556828, o[C + 52 >> 2] = 1549556828, o[C + 40 >> 2] = 1549556828, o[C + 44 >> 2] = 1549556828, o[C + 32 >> 2] = 1549556828, o[C + 36 >> 2] = 1549556828, g) {
                                            if (e = 0, B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; E[0 | (f = (A = C + 32 | 0) + B | 0)] = a[0 | f] ^ a[I + B | 0], E[0 | (Q = (f = 1 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (Q = (f = 2 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (f = (Q = A) + (A = 3 | B) | 0)] = a[0 | f] ^ a[A + I | 0], B = B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C + 32 | 0) + B | 0)] = a[0 | g] ^ a[I + B | 0], B = B + 1 | 0, (0 | A) != (0 | (e = e + 1 | 0)););
                                        }
                                        return z(i, A = C + 32 | 0, 64), iI(A, 64), iI(C, 32), w = C + 96 | 0, 0;
                                    }
                                    function X(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0;
                                        if (I - 65 >>> 0 < 4294967232 | E >>> 0 > 64) A = -1;
                                        else {
                                            D = a = w, w = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((f = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & E) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ (I << 8 | f), o[a + 4 >> 2] = I >>> 24 ^ 1779033703, dA((E = a + 384 | 0) + I | 0, 0, 128 - I | 0), YA(E, i, I), YA(a + 96 | 0, E, 128), o[a + 352 >> 2] = 128, iI(E, 128), I = 128;
                                                    } else dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ f, o[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(t = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (E = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            YA(E, g, C), o[a + 352 >> 2] = C + o[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (YA(E, g, i), o[a + 352 >> 2] = i + o[a + 352 >> 2], e = I = o[a + 68 >> 2], I = (r = (E = o[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, o[a + 64 >> 2] = r, o[a + 68 >> 2] = I, I = o[a + 76 >> 2], I = (e = E = -1 == (0 | e) & E >>> 0 > 4294967167) >>> 0 > (E = E + o[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, o[a + 72 >> 2] = E, o[a + 76 >> 2] = I, n(a, c), YA(c, t, 128), I = o[a + 352 >> 2] - 128 | 0, o[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    J(a, A, f), w = D;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function j(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0;
                                        A: {
                                            if ((i = o[A + 56 >> 2]) | (B = o[A + 60 >> 2])) {
                                                if (t = Q = 16 - i | 0, c = (Q = (0 | (f = 0 - ((i >>> 0 > 16) + B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > f >>> 0) ? t : g, t = Q = Q ? f : C, Q | c) {
                                                    if (Q = 0, i = 0, !t & c >>> 0 >= 4 | t) for(e = -4 & c, f = A - -64 | 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (y = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | D) != (0 | e) | (0 | t) != (0 | B););
                                                    if (f = B = 0, B | (r = 3 & c)) for(; D = Q + o[A + 56 >> 2] | 0, E[(A + D | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                    i = o[A + 56 >> 2], B = o[A + 60 >> 2];
                                                }
                                                if (B = B + t | 0, B = (i = i + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[A + 56 >> 2] = i, o[A + 60 >> 2] = B, !B & i >>> 0 < 16) break A;
                                                d(A, A - -64 | 0, 16, 0), o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + t | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (d(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (w = 0, h = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, t = 0, f = A - -64 | 0, D = 0, r = 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (e = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | c) != (0 | D) | (0 | t) != (0 | B););
                                                if (f = B = 0, B | (r = 3 & g)) for(; B = Q + o[A + 56 >> 2] | 0, E[(A + B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                i = C + o[A + 60 >> 2] | 0, i = (I = g + o[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, o[A + 56 >> 2] = I, o[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function T(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                        y = o[I + 4 >> 2], B = o[A + 4 >> 2], w = o[I + 8 >> 2], Q = o[A + 8 >> 2], h = o[I + 12 >> 2], i = o[A + 12 >> 2], n = o[I + 16 >> 2], E = o[A + 16 >> 2], s = o[I + 20 >> 2], a = o[A + 20 >> 2], k = o[I + 24 >> 2], f = o[A + 24 >> 2], D = o[I + 28 >> 2], c = o[A + 28 >> 2], F = o[I + 32 >> 2], e = o[A + 32 >> 2], S = o[I + 36 >> 2], r = o[A + 36 >> 2], g = 0 - g | 0, t = o[A >> 2], o[A >> 2] = g & (t ^ o[I >> 2]) ^ t, o[A + 36 >> 2] = r ^ g & (r ^ S), o[A + 32 >> 2] = e ^ g & (e ^ F), o[A + 28 >> 2] = c ^ g & (c ^ D), o[A + 24 >> 2] = f ^ g & (f ^ k), o[A + 20 >> 2] = a ^ g & (a ^ s), o[A + 16 >> 2] = E ^ g & (E ^ n), o[A + 12 >> 2] = i ^ g & (i ^ h), o[A + 8 >> 2] = Q ^ g & (Q ^ w), o[A + 4 >> 2] = B ^ g & (B ^ y), B = o[A + 40 >> 2], y = o[I + 40 >> 2], Q = o[A + 44 >> 2], w = o[I + 44 >> 2], i = o[A + 48 >> 2], h = o[I + 48 >> 2], E = o[A + 52 >> 2], n = o[I + 52 >> 2], a = o[A + 56 >> 2], s = o[I + 56 >> 2], f = o[A + 60 >> 2], k = o[I + 60 >> 2], c = o[(D = A - -64 | 0) >> 2], F = o[I - -64 >> 2], e = o[A + 68 >> 2], S = o[I + 68 >> 2], r = o[A + 72 >> 2], t = o[I + 72 >> 2], C = o[A + 76 >> 2], o[A + 76 >> 2] = C ^ g & (o[I + 76 >> 2] ^ C), o[A + 72 >> 2] = r ^ g & (r ^ t), o[A + 68 >> 2] = e ^ g & (e ^ S), o[D >> 2] = c ^ g & (c ^ F), o[A + 60 >> 2] = f ^ g & (f ^ k), o[A + 56 >> 2] = a ^ g & (a ^ s), o[A + 52 >> 2] = E ^ g & (E ^ n), o[A + 48 >> 2] = i ^ g & (i ^ h), o[A + 44 >> 2] = Q ^ g & (Q ^ w), o[A + 40 >> 2] = B ^ g & (B ^ y), B = o[A + 80 >> 2], y = o[I + 80 >> 2], Q = o[A + 84 >> 2], w = o[I + 84 >> 2], i = o[A + 88 >> 2], h = o[I + 88 >> 2], E = o[A + 92 >> 2], n = o[I + 92 >> 2], a = o[A + 96 >> 2], s = o[I + 96 >> 2], f = o[A + 100 >> 2], k = o[I + 100 >> 2], c = o[A + 104 >> 2], D = o[I + 104 >> 2], e = o[A + 108 >> 2], F = o[I + 108 >> 2], r = o[A + 112 >> 2], S = o[I + 112 >> 2], t = o[I + 116 >> 2], I = o[A + 116 >> 2], o[A + 116 >> 2] = g & (t ^ I) ^ I, o[A + 112 >> 2] = r ^ g & (r ^ S), o[A + 108 >> 2] = e ^ g & (e ^ F), o[A + 104 >> 2] = c ^ g & (c ^ D), o[A + 100 >> 2] = f ^ g & (f ^ k), o[A + 96 >> 2] = a ^ g & (a ^ s), o[A + 92 >> 2] = E ^ g & (E ^ n), o[A + 88 >> 2] = i ^ g & (i ^ h), o[A + 84 >> 2] = Q ^ g & (Q ^ w), o[A + 80 >> 2] = B ^ g & (B ^ y);
                                    }
                                    function O(A, I) {
                                        var g, C, B = 0;
                                        for(w = g = w - 192 | 0, M(C = g + 144 | 0, I), M(B = g + 96 | 0, C), M(B, B), H(B, I, B), H(C, C, B), M(I = g + 48 | 0, C), H(B, B, I), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), H(I, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), I = 1; M(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        H(I = g + 48 | 0, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B = g + 96 | 0, I, B), M(B, B), M(B, B), M(B, B), M(B, B), M(B, B), H(A, B, g + 144 | 0), w = g + 192 | 0;
                                    }
                                    function V(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r = 0;
                                        w = C = w - 128 | 0, o[A >> 2] = 1, o[A + 4 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 40 >> 2] = 1, dA(A + 44 | 0, 0, 76), T(A, I = c(I, 960) + 2704 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), T(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), T(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), T(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), T(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), T(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), T(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), T(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = o[A + 76 >> 2], o[C + 40 >> 2] = o[A + 72 >> 2], o[C + 44 >> 2] = I, r = o[4 + (I = A - -64 | 0) >> 2], o[C + 32 >> 2] = o[I >> 2], o[C + 36 >> 2] = r, I = o[A + 60 >> 2], o[C + 24 >> 2] = o[A + 56 >> 2], o[C + 28 >> 2] = I, I = o[A + 52 >> 2], o[C + 16 >> 2] = o[A + 48 >> 2], o[C + 20 >> 2] = I, I = o[A + 44 >> 2], o[C + 8 >> 2] = o[A + 40 >> 2], o[C + 12 >> 2] = I, I = o[A + 12 >> 2], o[C + 56 >> 2] = o[A + 8 >> 2], o[C + 60 >> 2] = I, r = o[A + 20 >> 2], o[(I = C - -64 | 0) >> 2] = o[A + 16 >> 2], o[I + 4 >> 2] = r, I = o[A + 28 >> 2], o[C + 72 >> 2] = o[A + 24 >> 2], o[C + 76 >> 2] = I, I = o[A + 36 >> 2], o[C + 80 >> 2] = o[A + 32 >> 2], o[C + 84 >> 2] = I, I = o[A + 4 >> 2], o[C + 48 >> 2] = o[A >> 2], o[C + 52 >> 2] = I, I = o[A + 80 >> 2], r = o[A + 84 >> 2], B = o[A + 88 >> 2], Q = o[A + 92 >> 2], i = o[A + 96 >> 2], E = o[A + 100 >> 2], a = o[A + 104 >> 2], f = o[A + 108 >> 2], e = o[A + 112 >> 2], o[C + 124 >> 2] = 0 - o[A + 116 >> 2], o[C + 120 >> 2] = 0 - e, o[C + 116 >> 2] = 0 - f, o[C + 112 >> 2] = 0 - a, o[C + 108 >> 2] = 0 - E, o[C + 104 >> 2] = 0 - i, o[C + 100 >> 2] = 0 - Q, o[C + 96 >> 2] = 0 - B, o[C + 92 >> 2] = 0 - r, o[C + 88 >> 2] = 0 - I, T(A, C + 8 | 0, (128 & g) >>> 7 | 0), w = C + 128 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (g | C) A: for(e = A + 224 | 0, f = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (B = Q + f | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                YA(B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (YA(B, I, i), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (o = 128 + (B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, E[A + 64 | 0] = o, E[A + 65 | 0] = o >>> 8, E[A + 66 | 0] = o >>> 16, E[A + 67 | 0] = o >>> 24, E[A + 68 | 0] = Q, E[A + 69 | 0] = Q >>> 8, E[A + 70 | 0] = Q >>> 16, E[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = B = -1 == (0 | c) & B >>> 0 > 4294967167) >>> 0 > (B = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, E[A + 72 | 0] = B, E[A + 73 | 0] = B >>> 8, E[A + 74 | 0] = B >>> 16, E[A + 75 | 0] = B >>> 24, E[A + 76 | 0] = Q, E[A + 77 | 0] = Q >>> 8, E[A + 78 | 0] = Q >>> 16, E[A + 79 | 0] = Q >>> 24, n(A, f), YA(f, e, 128), B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function W(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0;
                                        C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], w = o[(B = I - -64 | 0) >> 2], h = o[I + 28 >> 2], n = o[I + 68 >> 2], s = o[I + 32 >> 2], k = o[I + 72 >> 2], g = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = s + k, o[A + 28 >> 2] = h + n, o[A + 24 >> 2] = y + w, o[A + 20 >> 2] = D + t, o[A + 16 >> 2] = e + r, o[A + 12 >> 2] = f + c, o[A + 8 >> 2] = E + a, o[A + 4 >> 2] = Q + i, o[A >> 2] = C + g, C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], B = o[B >> 2], w = o[I + 28 >> 2], h = o[I + 68 >> 2], n = o[I + 32 >> 2], s = o[I + 72 >> 2], k = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = s - n, o[A + 68 >> 2] = h - w, o[A - -64 >> 2] = B - y, o[A + 60 >> 2] = t - D, o[A + 56 >> 2] = r - e, o[A + 52 >> 2] = c - f, o[A + 48 >> 2] = a - E, o[A + 44 >> 2] = i - Q, o[A + 40 >> 2] = C - k, C = o[I + 84 >> 2], o[A + 80 >> 2] = o[I + 80 >> 2], o[A + 84 >> 2] = C, C = o[I + 92 >> 2], o[A + 88 >> 2] = o[I + 88 >> 2], o[A + 92 >> 2] = C, C = o[I + 100 >> 2], o[A + 96 >> 2] = o[I + 96 >> 2], o[A + 100 >> 2] = C, C = o[I + 108 >> 2], o[A + 104 >> 2] = o[I + 104 >> 2], o[A + 108 >> 2] = C, C = o[I + 116 >> 2], o[A + 112 >> 2] = o[I + 112 >> 2], o[A + 116 >> 2] = C, H(A + 120 | 0, I + 120 | 0, 1440);
                                    }
                                    function $(A, I) {
                                        var g, C, B, Q, i, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                        (a = o[A + 56 >> 2]) | (f = o[A + 60 >> 2]) && (E[(r = A - -64 | 0) + a | 0] = 1, !((n = a + 1 | 0) ? f : f + 1 | 0) & n >>> 0 <= 15 && dA(65 + (A + a | 0) | 0, 0, 15 - a | 0), E[A + 80 | 0] = 1, d(A, r, 16, 0)), n = o[A + 52 >> 2], w = o[A + 48 >> 2], r = o[A + 44 >> 2], a = o[A + 24 >> 2], D = o[A + 28 >> 2] + (a >>> 26 | 0) | 0, e = o[A + 32 >> 2] + (D >>> 26 | 0) | 0, g = o[A + 36 >> 2] + (e >>> 26 | 0) | 0, f = (y = (a = (a = (67108863 & a) + ((t = o[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (D = (e = (i = (67108863 & g) + ((Q = (C = 67108863 & e) + ((B = (h = 67108863 & D) + ((t = a + ((f = 5 + (y = 67108863 & t) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | t & (e = 67108863 & (t = (e >>> 31 | 0) - 1 | 0))) << 26 | f & e | D & y) + o[A + 40 >> 2] | 0, E[0 | I] = f, E[I + 1 | 0] = f >>> 8, E[I + 2 | 0] = f >>> 16, E[I + 3 | 0] = f >>> 24, y = f >>> 0 < y >>> 0, f = 0, f = (a = (h = D & h | e & B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : f, f = (r = a) >>> 0 > (a = a + y | 0) >>> 0 ? f + 1 | 0 : f, E[I + 4 | 0] = a, E[I + 5 | 0] = a >>> 8, E[I + 6 | 0] = a >>> 16, E[I + 7 | 0] = a >>> 24, a = 0, r = (r = (e = D & C | e & Q) << 14 | h >>> 12) >>> 0 > (w = r + w | 0) >>> 0 ? 1 : a, a = w, w = f, a = a + f | 0, f = r, f = a >>> 0 < w >>> 0 ? f + 1 | 0 : f, E[I + 8 | 0] = a, E[I + 9 | 0] = a >>> 8, E[I + 10 | 0] = a >>> 16, E[I + 11 | 0] = a >>> 24, f = (a = (a = (t & i | D & g) << 8 | e >>> 18) + n | 0) + f | 0, E[I + 12 | 0] = f, E[I + 13 | 0] = f >>> 8, E[I + 14 | 0] = f >>> 16, E[I + 15 | 0] = f >>> 24, iI(A, 88);
                                    }
                                    function AA(A, I, g) {
                                        var C, B = 0;
                                        return w = C = w - 16 | 0, E[C + 15 | 0] = 0, B = -1, 0 | wI[o[8806]](A, I, g) || (E[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], B = (a[C + 15 | 0] << 23) - 8388608 >> 31), w = C + 16 | 0, B;
                                    }
                                    function IA(A, I) {
                                        var g, C, B, Q, i, a, f, e = 0, r = 0;
                                        C = o[I + 32 >> 2], B = o[I + 28 >> 2], Q = o[I + 24 >> 2], i = o[I + 20 >> 2], a = o[I + 16 >> 2], f = o[I + 12 >> 2], e = o[I + 4 >> 2], r = o[I >> 2], g = o[I + 36 >> 2], I = o[I + 8 >> 2], r = c((C + (B + (Q + (i + (a + (f + ((e + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, E[0 | A] = r, E[A + 2 | 0] = r >>> 16, E[A + 1 | 0] = r >>> 8, e = e + (r >> 26) | 0, E[A + 5 | 0] = e >>> 14, E[A + 4 | 0] = e >>> 6, E[A + 3 | 0] = r >>> 24 & 3 | e << 2, I = I + (e >> 25) | 0, E[A + 8 | 0] = I >>> 13, E[A + 7 | 0] = I >>> 5, E[A + 6 | 0] = I << 3 | (29360128 & e) >>> 22, r = (I >> 26) + f | 0, E[A + 11 | 0] = r >>> 11, E[A + 10 | 0] = r >>> 3, E[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, e = (r >> 25) + a | 0, E[A + 15 | 0] = e >>> 18, E[A + 14 | 0] = e >>> 10, E[A + 13 | 0] = e >>> 2, I = (e >> 26) + i | 0, E[A + 16 | 0] = I, E[A + 12 | 0] = e << 6 | (33030144 & r) >>> 19, E[A + 18 | 0] = I >>> 16, E[A + 17 | 0] = I >>> 8, e = (I >> 25) + Q | 0, E[A + 21 | 0] = e >>> 15, E[A + 20 | 0] = e >>> 7, E[A + 19 | 0] = I >>> 24 & 1 | e << 1, I = (e >> 26) + B | 0, E[A + 24 | 0] = I >>> 13, E[A + 23 | 0] = I >>> 5, E[A + 22 | 0] = I << 3 | (58720256 & e) >>> 23, e = (I >> 25) + C | 0, E[A + 27 | 0] = e >>> 12, E[A + 26 | 0] = e >>> 4, E[A + 25 | 0] = e << 4 | (31457280 & I) >>> 21, I = g + (e >> 26) | 0, E[A + 30 | 0] = I >>> 10, E[A + 29 | 0] = I >>> 2, E[A + 31 | 0] = (33292288 & I) >>> 18, E[A + 28 | 0] = I << 6 | (66060288 & e) >>> 20;
                                    }
                                    function gA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (w = C = w - 192 | 0, g >>> 0 >= 129 && (cA(A), R(A, I, g, 0), N(A, C), g = 64, I = C), cA(A), dA(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(e = 252 & g; E[0 | (B = (i = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = i) + (i = 3 | Q) | 0)] = a[0 | B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (f = 3 & g) for(; E[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | f) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (R(A, Q = C - -64 | 0, 128, 0), cA(i = A + 208 | 0), dA(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(e = 252 & g, f = 0; E[0 | (B = (A = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = A) + (A = 3 | Q) | 0)] = a[0 | B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return R(i, A = C - -64 | 0, 128, 0), iI(A, 128), iI(C, 64), w = C + 192 | 0, 0;
                                    }
                                    function CA(A, I) {
                                        var g;
                                        return o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, o[g + 4 >> 2] = 0, o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2]] ^ a[o[g + 8 >> 2]], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 1 | 0] ^ a[o[g + 8 >> 2] + 1 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 2 | 0] ^ a[o[g + 8 >> 2] + 2 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 3 | 0] ^ a[o[g + 8 >> 2] + 3 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 4 | 0] ^ a[o[g + 8 >> 2] + 4 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 5 | 0] ^ a[o[g + 8 >> 2] + 5 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 6 | 0] ^ a[o[g + 8 >> 2] + 6 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 7 | 0] ^ a[o[g + 8 >> 2] + 7 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 8 | 0] ^ a[o[g + 8 >> 2] + 8 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 9 | 0] ^ a[o[g + 8 >> 2] + 9 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 10 | 0] ^ a[o[g + 8 >> 2] + 10 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 11 | 0] ^ a[o[g + 8 >> 2] + 11 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 12 | 0] ^ a[o[g + 8 >> 2] + 12 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 13 | 0] ^ a[o[g + 8 >> 2] + 13 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 14 | 0] ^ a[o[g + 8 >> 2] + 14 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 15 | 0] ^ a[o[g + 8 >> 2] + 15 | 0], (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function BA(A, I) {
                                        var g, C = 0, B = 0;
                                        g = I;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(I = a[0 | A]) | (0 | I) == (255 & g)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (I = o[A >> 2])) & I - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (I ^= C)) & I - 16843009 & -2139062144) break I;
                                                if (I = o[A + 4 >> 2], A = A + 4 | 0, I - 16843009 & (-1 ^ I) & -2139062144) break;
                                            }
                                            for(; I = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & g)););
                                            A = I;
                                        } else {
                                            C = A;
                                            I: {
                                                g: {
                                                    C: if (3 & A) {
                                                        if (I = 0, !a[0 | A]) break I;
                                                        for(;;){
                                                            if (!(3 & (A = A + 1 | 0))) break C;
                                                            if (!a[0 | A]) break;
                                                        }
                                                        break g;
                                                    }
                                                    for(; I = A, A = A + 4 | 0, !((-1 ^ (B = o[I >> 2])) & B - 16843009 & -2139062144););
                                                    for(; I = (A = I) + 1 | 0, a[0 | A];);
                                                }
                                                I = A - C | 0;
                                            }
                                            A = I + C | 0;
                                        }
                                        return a[0 | A] == (255 & g) ? A : 0;
                                    }
                                    function QA(A, I, g, C, B, Q, i) {
                                        var E, a, f = 0, c = 0, e = 0;
                                        w = E = w - 96 | 0, m(E, Q, i), i = E + 32 | 0, a = Q + 16 | 0, wI[o[8808]](i, 32, 0, a, E), Q = -1;
                                        A: {
                                            if (!(0 | wI[o[8802]](g, I, C, B, i))) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = pA(A, I, C)), c = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (e = YA(E - -64 | 0, I, g), qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), YA(A, e, g)) : qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), iI(E + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || jA(A + g | 0, I + g | 0, C - g | 0, B - (c + (g >>> 0 > C >>> 0) | 0) | 0, a, E);
                                            }
                                            iI(E, 32);
                                        }
                                        return w = E + 96 | 0, Q;
                                    }
                                    function iA(A, I, g, C, B, Q, i) {
                                        var E, a, f, c, e = 0;
                                        return w = E = w - 352 | 0, m(E, Q, i), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = pA(A, g, C)), o[E + 56 >> 2] = 0, o[E + 60 >> 2] = 0, o[E + 48 >> 2] = 0, o[E + 52 >> 2] = 0, o[E + 40 >> 2] = 0, o[E + 44 >> 2] = 0, o[E + 32 >> 2] = 0, o[E + 36 >> 2] = 0, (f = !((i = (e = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (e = e ? 0 : B))) || YA(E - -64 | 0, g, i), qA(a = E + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? e + 1 | 0 : e, Q = Q + 16 | 0, E), CI(E + 96 | 0, a), f || YA(A, E - -64 | 0, i), iI(E + 32 | 0, 64), !B & C >>> 0 >= 33 | B && jA(A + i | 0, g + i | 0, C - i | 0, B - (e + (C >>> 0 < i >>> 0) | 0) | 0, Q, E), iI(E, 32), $A(g = E + 96 | 0, A, C, B), BI(g, I), iI(g, 256), w = E + 352 | 0, 0;
                                    }
                                    function EA(A, I, g, C, B, Q, i, E, f, c) {
                                        var e, r;
                                        return w = e = w - 400 | 0, o[e + 4 >> 2] = 0, x(r = e + 16 | 0, f, c), c = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[e + 8 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[e + 12 >> 2] = c, ZA(c = e + 80 | 0, 64, e + 4 | 0, r), CI(f = e + 144 | 0, c), iI(c, 64), $A(f, Q, i, E), $A(f, 33904, 0 - i & 15, 0), $A(f, I, g, C), $A(f, 33904, 0 - g & 15, 0), o[e + 72 >> 2] = i, o[e + 76 >> 2] = E, $A(f, Q = e + 72 | 0, 8, 0), o[e + 72 >> 2] = g, o[e + 76 >> 2] = C, $A(f, Q, 8, 0), BI(f, Q = e + 48 | 0), iI(f, 256), f = CA(Q, B), iI(Q, 16), A && (f ? (dA(A, 0, g), f = -1) : (xA(A, I, g, C, e + 4 | 0, e + 16 | 0), f = 0)), iI(e + 16 | 0, 32), w = e + 400 | 0, f;
                                    }
                                    function oA(A, I, g, C, B, Q, i, E, f, c, e) {
                                        var r, D, t;
                                        return w = r = w - 384 | 0, o[r + 4 >> 2] = 0, x(D = r + 16 | 0, c, e), e = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, o[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, o[r + 12 >> 2] = e, ZA(e = r - -64 | 0, 64, t = r + 4 | 0, D), CI(c = r + 128 | 0, e), iI(e, 64), $A(c, i, E, f), $A(c, 33904, 0 - E & 15, 0), xA(A, C, B, Q, t, D), $A(c, A, B, Q), $A(c, 33904, 0 - B & 15, 0), o[r + 56 >> 2] = E, o[r + 60 >> 2] = f, $A(c, A = r + 56 | 0, 8, 0), o[r + 56 >> 2] = B, o[r + 60 >> 2] = Q, $A(c, A, 8, 0), BI(c, I), iI(c, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), iI(r + 16 | 0, 32), w = r + 384 | 0, 0;
                                    }
                                    function aA(A, I, g, C) {
                                        var B, Q = 0;
                                        return w = B = w - 208 | 0, o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, Q = o[8579], o[B + 8 >> 2] = o[8578], o[B + 12 >> 2] = Q, Q = o[8581], o[B + 16 >> 2] = o[8580], o[B + 20 >> 2] = Q, Q = o[8583], o[B + 24 >> 2] = o[8582], o[B + 28 >> 2] = Q, Q = o[8585], o[B + 32 >> 2] = o[8584], o[B + 36 >> 2] = Q, Q = o[8587], o[B + 40 >> 2] = o[8586], o[B + 44 >> 2] = Q, Q = o[8589], o[B + 48 >> 2] = o[8588], o[B + 52 >> 2] = Q, Q = o[8591], o[B + 56 >> 2] = o[8590], o[B + 60 >> 2] = Q, o[B + 64 >> 2] = 0, o[B + 68 >> 2] = 0, Q = o[8577], o[B >> 2] = o[8576], o[B + 4 >> 2] = Q, R(B, I, g, C), N(B, A), w = B + 208 | 0, 0;
                                    }
                                    function fA(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        if (E[15 + (g = w - 16 | 0) | 0] = 0, I) {
                                            if (B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (B) for(I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function cA(A) {
                                        var I = 0;
                                        o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, I = o[8577], o[A >> 2] = o[8576], o[A + 4 >> 2] = I, I = o[8579], o[A + 8 >> 2] = o[8578], o[A + 12 >> 2] = I, I = o[8581], o[A + 16 >> 2] = o[8580], o[A + 20 >> 2] = I, I = o[8583], o[A + 24 >> 2] = o[8582], o[A + 28 >> 2] = I, I = o[8585], o[A + 32 >> 2] = o[8584], o[A + 36 >> 2] = I, I = o[8587], o[A + 40 >> 2] = o[8586], o[A + 44 >> 2] = I, I = o[8589], o[A + 48 >> 2] = o[8588], o[A + 52 >> 2] = I, I = o[8591], o[A + 56 >> 2] = o[8590], o[A + 60 >> 2] = I;
                                    }
                                    function eA(A, I, g) {
                                        var C, B = 0, Q = 0;
                                        if (o[12 + (C = w - 16 | 0) >> 2] = A, o[C + 8 >> 2] = I, A = 0, E[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0], B = 1 | A, E[C + 7 | 0] = a[C + 7 | 0] | a[B + o[C + 12 >> 2] | 0] ^ a[o[C + 8 >> 2] + B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function rA(A) {
                                        for(var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, o = 0, f = 0, c = 0; B = (g = a[A + C | 0]) ^ a[0 | (I = C + 2448 | 0)] | B, Q = g ^ a[I + 192 | 0] | Q, i = g ^ a[I + 160 | 0] | i, E = g ^ a[I + 128 | 0] | E, o = g ^ a[I + 96 | 0] | o, f = g ^ a[I - -64 | 0] | f, c = g ^ a[I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (I | i)) - 1 | (255 & (I | E)) - 1 | (255 & (122 ^ A | o)) - 1 | (255 & (5 ^ A | f)) - 1 | (255 & (A | c)) - 1 | (255 & (A | B)) - 1) >>> 8 & 1;
                                    }
                                    function DA(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0;
                                        return B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> B | 0 : (C = -1 >>> B | 0) | (1 << B) - 1 << 32 - B, Q &= A, C &= I, B = 31 & i, i >>> 0 >= 32 ? (C = Q << B, i = 0) : (C = (1 << B) - 1 & Q >>> 32 - B | C << B, i = Q << B), Q = C, C = 31 & (B = 0 - g & 63), B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & B, B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), h = g | Q, A | i;
                                    }
                                    function tA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, ZA(r = c + 32 | 0, 64, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), $A(e, 33920, 0 - i & 15, 0), $A(e, I, g, C), $A(e, 33920, 0 - g & 15, 0), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (FA(A, I, g, C, a, 1, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function yA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, ZA(D = e + 16 | 0, 64, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), $A(r, 33920, 0 - E & 15, 0), FA(A, C, B, Q, f, 1, c), $A(r, A, B, Q), $A(r, 33920, 0 - B & 15, 0), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, A = e + 8 | 0, 8, 0), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, A, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function wA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, WA(r = c + 32 | 0, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), $A(e, I, g, C), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (uA(A, I, g, C, a, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function hA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, WA(D = e + 16 | 0, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, i = e + 8 | 0, 8, 0), uA(A, C, B, Q, f, c), $A(r, A, B, Q), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, i, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function nA(A, I) {
                                        var g;
                                        for(o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, A = 0, o[g + 4 >> 2] = 0; o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + A | 0] ^ a[o[g + 8 >> 2] + A | 0], I = 1 | A, o[g + 4 >> 2] = o[g + 4 >> 2] | a[I + o[g + 12 >> 2] | 0] ^ a[I + o[g + 8 >> 2] | 0], 32 != (0 | (A = A + 2 | 0)););
                                        return (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function sA(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        for(I = 1; I = a[0 | (g = A + C | 0)] + I | 0, E[0 | g] = I, I = a[0 | (g = (1 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (2 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (3 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (B = B + 4 | 0)););
                                    }
                                    function kA(A, I, g, C) {
                                        var B, Q, i, E, o = 0, a = 0;
                                        return E = c(o = g >>> 16 | 0, a = A >>> 16 | 0), o = (65535 & (a = ((i = c(B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, B) | 0)) + c(o, Q) | 0, h = (c(I, g) + E | 0) + c(A, C) + (a >>> 16) + (o >>> 16) | 0, 65535 & i | o << 16;
                                    }
                                    function FA(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0;
                                        a = C, 1 == (((a = (f = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | f >>> 6))) | 0) & i >>> 0 > (f = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1 ? (zA(), Q()) : wI[o[8813]](A, I, g, C, B, i, E);
                                    }
                                    function SA(A) {
                                        var I = 0;
                                        o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, I = o[8485], o[A >> 2] = o[8484], o[A + 4 >> 2] = I, I = o[8487], o[A + 8 >> 2] = o[8486], o[A + 12 >> 2] = I, I = o[8489], o[A + 16 >> 2] = o[8488], o[A + 20 >> 2] = I, I = o[8491], o[A + 24 >> 2] = o[8490], o[A + 28 >> 2] = I;
                                    }
                                    function HA(A, I) {
                                        A |= 0;
                                        var g, C = 0, B = 0, Q = 0;
                                        if (w = g = w - 16 | 0, I |= 0) for(; E[g + 15 | 0] = 0, B = A + C | 0, Q = 0 | r(35256, g + 15 | 0, 0), E[0 | B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        w = g + 16 | 0;
                                    }
                                    function GA(A, I, g, C, B, Q, i) {
                                        var E, o, a = 0;
                                        return w = E = w - 32 | 0, a = -1, (o = g >>> 0 < 16) & !C || UA(E, Q, i) || (a = QA(A, I + 16 | 0, I, g - 16 | 0, C - o | 0, B, E), iI(E, 32)), w = E + 32 | 0, a;
                                    }
                                    function _A(A) {
                                        var I, g;
                                        return (A = (I = o[8800]) + (g = A + 7 & -8) | 0) >>> 0 <= I >>> 0 && g || A >>> 0 > hI() << 16 >>> 0 && !(0 | y(0 | A)) ? (o[9005] = 48, -1) : (o[8800] = A, I);
                                    }
                                    function MA(A, I) {
                                        var g, C, B;
                                        w = g = w - 176 | 0, O(C = g + 96 | 0, I + 80 | 0), H(B = g + 48 | 0, I, C), H(g, I + 40 | 0, C), IA(A, g), IA(g + 144 | 0, B), E[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, w = g + 176 | 0;
                                    }
                                    function pA(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return YA(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, E[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function NA(A, I, g, C, B, i, E) {
                                        var o, a = 0;
                                        if (w = o = w - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, UA(o, i, E) || (a = iA(A + 16 | 0, A, I, g, C, B, o), iI(o, 32)), w = o + 32 | 0, a;
                                        zA(), Q();
                                    }
                                    function JA(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? QA(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function UA(A, I, g) {
                                        A |= 0;
                                        var C, B = 0;
                                        return w = C = w - 32 | 0, B = -1, AA(C, g |= 0, I |= 0) || (B = m(A, 35184, C)), w = C + 32 | 0, 0 | B;
                                    }
                                    function YA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function dA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function KA(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (D(1260, 1187, 107, 1067), Q()), 0 | J(A, I, 255 & g);
                                    }
                                    function bA(A, I) {
                                        var g;
                                        w = g = w + -64 | 0, N(A, g), R(A = A + 208 | 0, g, 64, 0), N(A, I), iI(g, 64), w = g - -64 | 0;
                                    }
                                    function PA(A, I, g, C, B, Q, i) {
                                        return 0 | iA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function vA(A, I, g, C, B, Q, i) {
                                        return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function LA(A, I) {
                                        var g;
                                        w = g = w - 32 | 0, l(A, g), z(A = A + 104 | 0, g, 32), l(A, I), iI(g, 32), w = g + 32 | 0;
                                    }
                                    function RA(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function uA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8812]](A, I, g, C, B, 1, 0, i);
                                    }
                                    function xA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8813]](A, I, g, C, B, 1, i);
                                    }
                                    function mA() {
                                        var A;
                                        w = A = w - 16 | 0, E[A + 15 | 0] = 0, r(35292, A + 15 | 0, 0), w = A + 16 | 0;
                                    }
                                    function lA(A, I, g) {
                                        return 0 | AA(A |= 0, I |= 0, g |= 0);
                                    }
                                    function zA() {
                                        var A;
                                        (A = o[9137]) && wI[0 | A](), t(), Q();
                                    }
                                    function qA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function XA(A, I) {
                                        return A |= 0, HA(I |= 0, 32), 0 | II(A, I);
                                    }
                                    function jA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 1, 0, Q);
                                    }
                                    function TA(A) {
                                        return A ? 31 - e(A - 1 ^ A) | 0 : 32;
                                    }
                                    function OA(A, I, g, C) {
                                        wI[o[8813]](A, I, 40, 0, g, 0, C);
                                    }
                                    function VA(A, I) {
                                        return 0 | II(A |= 0, I |= 0);
                                    }
                                    function ZA(A, I, g, C) {
                                        wI[o[8811]](A, I, 0, g, C);
                                    }
                                    function WA(A, I, g) {
                                        wI[o[8810]](A, 64, 0, I, g);
                                    }
                                    function $A(A, I, g, C) {
                                        wI[o[8804]](A, I, g, C);
                                    }
                                    function AI(A, I, g, C) {
                                        return R(A, I, g, C), 0;
                                    }
                                    function II(A, I) {
                                        return 0 | wI[o[8807]](A, I);
                                    }
                                    function gI(A, I, g) {
                                        return z(A, I, g), 0;
                                    }
                                    function CI(A, I) {
                                        wI[o[8803]](A, I);
                                    }
                                    function BI(A, I) {
                                        wI[o[8805]](A, I);
                                    }
                                    function QI(A) {
                                        HA(A |= 0, 32);
                                    }
                                    function iI(A, I) {
                                        dA(A, 0, I);
                                    }
                                    function EI() {
                                        return 208;
                                    }
                                    function oI() {
                                        return 16;
                                    }
                                    function aI() {
                                        return 32;
                                    }
                                    function fI() {
                                        return 24;
                                    }
                                    function cI() {
                                        return -17;
                                    }
                                    function eI() {
                                        return 64;
                                    }
                                    function rI() {
                                        return 1;
                                    }
                                    function DI() {
                                        return 8;
                                    }
                                    function tI() {
                                        return 0;
                                    }
                                    B(I = a, 1024, "TGlic29kaXVtRFJHcmFuZG9tYnl0ZXMAYjY0X3BvcyA8PSBiNjRfbGVuAGNyeXB0b19nZW5lcmljaGFzaF9ibGFrZTJiX2ZpbmFsAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAYnVmX2xlbiA8PSBTSVpFX01BWABvdXRsZW4gPD0gVUlOVDhfTUFYAFMtPmJ1ZmxlbiA8PSBCTEFLRTJCX0JMT0NLQllURVMAMS4wLjE5AHNvZGl1bV9iaW4yYmFzZTY0AAAAAAAAAAC2eFn/hXLTAL1uFf8PCmoAKcABAJjoef+8PKD/mXHO/wC34v60DUj/AAAAAAAAAACwoA7+08mG/54YjwB/aTUAYAy9AKfX+/+fTID+amXh/x78BACSDK4="), B(I, 1440, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(I, 1488, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(I, 2480, "AQ=="), B(I, 2512, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 2703, "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"), B(I, 33676, "AQ=="), B(I, 33712, "AQ=="), B(I, 33744, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////fw=="), B(I, 33936, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(I, 34304, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(I, 35136, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(I, 35200, "0I4BAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0=");
                                    var yI, wI = (yI = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 128 & -64, o[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 20 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 16 >> 2] = f >>> 8 & 1048575, o[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 80 | 0] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 52 >> 2] = B, j(Q, I, g, C), $(Q, A), w = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 192 & -64, o[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 84 >> 2] = 0, o[Q + 88 >> 2] = 0, o[Q + 92 >> 2] = 0, o[Q + 96 >> 2] = 0, o[Q + 100 >> 2] = 0, o[Q + 80 >> 2] = f >>> 8 & 1048575, o[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 144 | 0] = 0, o[Q + 120 >> 2] = 0, o[Q + 124 >> 2] = 0, o[Q + 116 >> 2] = B, j(B = Q - -64 | 0, I, g, C), $(B, I = Q + 48 | 0), A = CA(A, I), w = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, o[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, o[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, o[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 16 >> 2] = g >>> 8 & 1048575, o[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[A + 80 | 0] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return j(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return $(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0;
                                            for(w = C = w - 368 | 0; n = (i = a[g + B | 0]) ^ a[0 | (c = B + 33680 | 0)] | n, y = i ^ a[c + 192 | 0] | y, t = i ^ a[c + 160 | 0] | t, D = i ^ a[c + 128 | 0] | D, f = i ^ a[c + 96 | 0] | f, e = i ^ a[c - -64 | 0] | e, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (B = B + 1 | 0)););
                                            if (B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | y)) - 1 | (255 & (i | t)) - 1 | (255 & (i | D)) - 1 | (255 & (87 ^ c | f)) - 1 | (255 & (e | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | n)) - 1))) {
                                                for(B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[C + 360 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[C + 364 >> 2] = I, I = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[C + 352 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[C + 356 >> 2] = I, Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, I = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[C + 336 >> 2] = I, o[C + 340 >> 2] = Q, Q = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[C + 344 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[C + 348 >> 2] = Q, E[C + 336 | 0] = 248 & I, E[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, L(C + 288 | 0, g), o[C + 260 >> 2] = 0, o[C + 264 >> 2] = 0, o[C + 268 >> 2] = 0, o[C + 272 >> 2] = 0, o[C + 276 >> 2] = 0, o[C + 208 >> 2] = 0, o[C + 212 >> 2] = 0, o[C + 216 >> 2] = 0, o[C + 220 >> 2] = 0, o[C + 224 >> 2] = 0, o[C + 228 >> 2] = 0, I = o[C + 308 >> 2], o[C + 160 >> 2] = o[C + 304 >> 2], o[C + 164 >> 2] = I, I = o[C + 316 >> 2], o[C + 168 >> 2] = o[C + 312 >> 2], o[C + 172 >> 2] = I, I = o[C + 324 >> 2], o[C + 176 >> 2] = o[C + 320 >> 2], o[C + 180 >> 2] = I, o[C + 244 >> 2] = 0, o[C + 248 >> 2] = 0, o[C + 240 >> 2] = 1, o[C + 252 >> 2] = 0, o[C + 256 >> 2] = 0, o[C + 192 >> 2] = 0, o[C + 196 >> 2] = 0, o[C + 200 >> 2] = 0, o[C + 204 >> 2] = 0, I = o[C + 292 >> 2], o[C + 144 >> 2] = o[C + 288 >> 2], o[C + 148 >> 2] = I, I = o[C + 300 >> 2], o[C + 152 >> 2] = o[C + 296 >> 2], o[C + 156 >> 2] = I, o[C + 116 >> 2] = 0, o[C + 120 >> 2] = 0, o[C + 124 >> 2] = 0, o[C + 128 >> 2] = 0, o[C + 132 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 96 >> 2] = 1, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, g = 254; $ = o[C + 276 >> 2], i = o[C + 180 >> 2], AA = o[C + 96 >> 2], gA = o[C + 192 >> 2], CA = o[C + 144 >> 2], BA = o[C + 240 >> 2], QA = o[C + 100 >> 2], iA = o[C + 196 >> 2], EA = o[C + 148 >> 2], oA = o[C + 244 >> 2], Y = o[C + 104 >> 2], aA = o[C + 200 >> 2], d = o[C + 152 >> 2], fA = o[C + 248 >> 2], P = o[C + 108 >> 2], cA = o[C + 204 >> 2], v = o[C + 156 >> 2], eA = o[C + 252 >> 2], K = o[C + 112 >> 2], rA = o[C + 208 >> 2], J = o[C + 160 >> 2], DA = o[C + 256 >> 2], n = o[C + 116 >> 2], tA = o[C + 212 >> 2], r = o[C + 164 >> 2], yA = o[C + 260 >> 2], y = o[C + 120 >> 2], wA = o[C + 216 >> 2], t = o[C + 168 >> 2], hA = o[C + 264 >> 2], D = o[C + 124 >> 2], nA = o[C + 220 >> 2], f = o[C + 172 >> 2], sA = o[C + 268 >> 2], e = o[C + 128 >> 2], FA = o[C + 224 >> 2], Q = o[C + 176 >> 2], N = o[C + 272 >> 2], SA = g, U = (G = (I = 0 - ((I = W) ^ (W = a[(HA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((B = o[C + 132 >> 2]) ^ (j = o[C + 228 >> 2]))) ^ B, o[C + 132 >> 2] = U, T = i ^ (_ = I & (i ^ $)), o[C + 84 >> 2] = T - U, b = e ^ (k = I & (e ^ FA)), o[C + 128 >> 2] = b, V = (p = I & (Q ^ N)) ^ Q, o[C + 80 >> 2] = V - b, u = D ^ (F = I & (D ^ nA)), o[C + 124 >> 2] = u, GA = f ^ (S = I & (f ^ sA)), o[C + 76 >> 2] = GA - u, x = y ^ (s = I & (y ^ wA)), o[C + 120 >> 2] = x, _A = t ^ (c = I & (t ^ hA)), o[C + 72 >> 2] = _A - x, m = n ^ (i = I & (n ^ tA)), o[C + 116 >> 2] = m, l = r ^ (n = I & (r ^ yA)), o[C + 68 >> 2] = l - m, z = K ^ (y = I & (K ^ rA)), o[C + 112 >> 2] = z, R = J ^ (t = I & (J ^ DA)), o[C + 64 >> 2] = R - z, q = P ^ (D = I & (P ^ cA)), o[C + 108 >> 2] = q, Z = v ^ (f = I & (v ^ eA)), o[C + 60 >> 2] = Z - q, X = Y ^ (e = I & (Y ^ aA)), o[C + 104 >> 2] = X, P = d ^ (Q = I & (d ^ fA)), o[C + 56 >> 2] = P - X, Y = QA ^ (B = I & (QA ^ iA)), o[C + 100 >> 2] = Y, v = EA ^ (g = I & (EA ^ oA)), o[C + 52 >> 2] = v - Y, d = AA ^ (K = I & (AA ^ gA)), o[C + 96 >> 2] = d, J = (I &= CA ^ BA) ^ CA, o[C + 48 >> 2] = J - d, r = _ ^ $, G ^= j, o[C + 36 >> 2] = r - G, _ = p ^ N, k ^= FA, o[C + 32 >> 2] = _ - k, p = S ^ sA, F ^= nA, o[C + 28 >> 2] = p - F, S = c ^ hA, s ^= wA, o[C + 24 >> 2] = S - s, c = n ^ yA, i ^= tA, o[C + 20 >> 2] = c - i, n = t ^ DA, y ^= rA, o[C + 16 >> 2] = n - y, t = f ^ eA, D ^= cA, o[C + 12 >> 2] = t - D, f = Q ^ fA, e ^= aA, o[C + 8 >> 2] = f - e, Q = g ^ oA, B ^= iA, o[C + 4 >> 2] = Q - B, g = I ^ BA, I = K ^ gA, o[C >> 2] = g - I, o[C + 276 >> 2] = r + G, o[C + 272 >> 2] = _ + k, o[C + 268 >> 2] = F + p, o[C + 264 >> 2] = s + S, o[C + 260 >> 2] = i + c, o[C + 256 >> 2] = y + n, o[C + 248 >> 2] = f + e, o[C + 244 >> 2] = B + Q, o[C + 240 >> 2] = I + g, o[C + 252 >> 2] = D + t, o[C + 228 >> 2] = U + T, o[C + 224 >> 2] = b + V, o[C + 220 >> 2] = u + GA, o[C + 216 >> 2] = x + _A, o[C + 212 >> 2] = m + l, o[C + 208 >> 2] = R + z, o[C + 204 >> 2] = q + Z, o[C + 200 >> 2] = P + X, o[C + 196 >> 2] = Y + v, o[C + 192 >> 2] = J + d, H(T = C + 96 | 0, b = C + 48 | 0, U = C + 240 | 0), H(N = C + 192 | 0, N, C), M(b, C), M(C, U), r = o[C + 192 >> 2], G = o[C + 96 >> 2], _ = o[C + 196 >> 2], k = o[C + 100 >> 2], p = o[C + 200 >> 2], F = o[C + 104 >> 2], S = o[C + 204 >> 2], s = o[C + 108 >> 2], c = o[C + 208 >> 2], i = o[C + 112 >> 2], n = o[C + 212 >> 2], y = o[C + 116 >> 2], t = o[C + 216 >> 2], D = o[C + 120 >> 2], f = o[C + 220 >> 2], e = o[C + 124 >> 2], Q = o[C + 224 >> 2], B = o[C + 128 >> 2], g = o[C + 228 >> 2], I = o[C + 132 >> 2], o[C + 180 >> 2] = g + I, o[C + 176 >> 2] = B + Q, o[C + 172 >> 2] = f + e, o[C + 168 >> 2] = D + t, o[C + 164 >> 2] = y + n, o[C + 160 >> 2] = i + c, o[C + 156 >> 2] = s + S, o[C + 152 >> 2] = F + p, o[C + 148 >> 2] = _ + k, o[C + 144 >> 2] = r + G, o[C + 228 >> 2] = I - g, o[C + 224 >> 2] = B - Q, o[C + 220 >> 2] = e - f, o[C + 216 >> 2] = D - t, o[C + 212 >> 2] = y - n, o[C + 208 >> 2] = i - c, o[C + 204 >> 2] = s - S, o[C + 200 >> 2] = F - p, o[C + 196 >> 2] = k - _, o[C + 192 >> 2] = G - r, H(U, C, b), u = o[C + 52 >> 2], s = o[C + 4 >> 2], x = o[C + 56 >> 2], c = o[C + 8 >> 2], m = o[C + 64 >> 2], t = o[C + 16 >> 2], z = o[C + 60 >> 2], D = o[C + 12 >> 2], q = o[C + 72 >> 2], f = o[C + 24 >> 2], X = o[C + 68 >> 2], e = o[C + 20 >> 2], Y = o[C + 80 >> 2], Q = o[C + 32 >> 2], d = o[C + 76 >> 2], B = o[C + 28 >> 2], j = o[C + 84 >> 2], I = o[C + 36 >> 2], V = o[C + 48 >> 2], g = o[C >> 2] - V | 0, o[C >> 2] = g, I = I - j | 0, o[C + 36 >> 2] = I, K = B - d | 0, o[C + 28 >> 2] = K, J = Q - Y | 0, o[C + 32 >> 2] = J, i = e - X | 0, o[C + 20 >> 2] = i, n = f - q | 0, o[C + 24 >> 2] = n, y = D - z | 0, o[C + 12 >> 2] = y, t = t - m | 0, o[C + 16 >> 2] = t, D = c - x | 0, o[C + 8 >> 2] = D, Q = s - u | 0, o[C + 4 >> 2] = Q, M(N, N), I = kA(I, I >> 31, 121666, 0), B = h, Z = I, I = kA((33554431 & (B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B)) << 7 | r >>> 25, B >> 25, 19, 0), e = h, B = I, I = kA(g, g >> 31, 121666, 0), R = h + e | 0, I = I >>> 0 > (B = B + I | 0) >>> 0 ? R + 1 | 0 : R, g = (f = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, G = B - (-67108864 & f) | 0, o[C + 96 >> 2] = G, e = kA(Q, Q >> 31, 121666, 0), B = h, B = (Q = e + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B, _ = (e - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | f >>> 26) | 0, o[C + 100 >> 2] = _, R = (I = B) >> 25, B = (33554431 & I) << 7 | Q >>> 25, g = kA(D, D >> 31, 121666, 0) + B | 0, I = R + h | 0, I = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, o[C + 104 >> 2] = p, B = kA(t, t >> 31, 121666, 0), Q = h, g = kA(y, y >> 31, 121666, 0), I = h, l = B, P = g, B = (33554431 & (I = (F = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | F >>> 25, I = (I >> 25) + Q | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = (S = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, s = g - (-67108864 & S) | 0, o[C + 112 >> 2] = s, B = kA(n, n >> 31, 121666, 0), f = h, g = kA(i, i >> 31, 121666, 0), I = h, l = B, v = g, B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + f | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, n = g - (-67108864 & i) | 0, o[C + 120 >> 2] = n, f = kA(J, J >> 31, 121666, 0), D = h, g = kA(K, K >> 31, 121666, 0), I = h, J = g, g = (33554431 & (I = (y = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | y >>> 25, I = (I >> 25) + D | 0, I = g >>> 0 > (f = g + f | 0) >>> 0 ? I + 1 | 0 : I, g = (t = f + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = f - (-67108864 & t) | 0, o[C + 128 >> 2] = D, f = (e = P + ((67108863 & e) << 6 | k >>> 26) | 0) - (-33554432 & F) | 0, o[C + 108 >> 2] = f, e = (Q = v + ((67108863 & Q) << 6 | S >>> 26) | 0) - (-33554432 & c) | 0, o[C + 116 >> 2] = e, Q = (I = J + ((67108863 & B) << 6 | i >>> 26) | 0) - (-33554432 & y) | 0, o[C + 124 >> 2] = Q, g = (g = Z + ((67108863 & g) << 6 | t >>> 26) | 0) - (-33554432 & r) | 0, o[C + 132 >> 2] = g, M(I = C + 144 | 0, I), o[C + 84 >> 2] = g + j, o[C + 80 >> 2] = D + Y, o[C + 76 >> 2] = Q + d, o[C + 72 >> 2] = n + q, o[C + 68 >> 2] = e + X, o[C + 64 >> 2] = s + m, o[C + 60 >> 2] = f + z, o[C + 56 >> 2] = p + x, o[C + 52 >> 2] = _ + u, o[C + 48 >> 2] = G + V, g = SA - 1 | 0, H(T, C + 288 | 0, N), H(N, C, b), SA;);
                                                n = o[C + 144 >> 2], G = o[C + 240 >> 2], y = o[C + 148 >> 2], _ = o[C + 244 >> 2], t = o[C + 152 >> 2], k = o[C + 248 >> 2], D = o[C + 156 >> 2], p = o[C + 252 >> 2], f = o[C + 160 >> 2], F = o[C + 256 >> 2], e = o[C + 164 >> 2], S = o[C + 260 >> 2], Q = o[C + 168 >> 2], s = o[C + 264 >> 2], B = o[C + 172 >> 2], c = o[C + 268 >> 2], g = o[C + 176 >> 2], i = o[C + 272 >> 2], r = 0 - W | 0, I = o[C + 276 >> 2], o[C + 276 >> 2] = r & (I ^ o[C + 180 >> 2]) ^ I, o[C + 272 >> 2] = i ^ r & (g ^ i), o[C + 268 >> 2] = c ^ r & (B ^ c), o[C + 264 >> 2] = s ^ r & (Q ^ s), o[C + 260 >> 2] = S ^ r & (e ^ S), o[C + 256 >> 2] = F ^ r & (f ^ F), o[C + 252 >> 2] = p ^ r & (D ^ p), o[C + 248 >> 2] = k ^ r & (t ^ k), o[C + 244 >> 2] = _ ^ r & (y ^ _), o[C + 240 >> 2] = G ^ r & (n ^ G), G = o[C + 192 >> 2], n = o[C + 96 >> 2], _ = o[C + 196 >> 2], y = o[C + 100 >> 2], k = o[C + 200 >> 2], t = o[C + 104 >> 2], p = o[C + 204 >> 2], D = o[C + 108 >> 2], F = o[C + 208 >> 2], f = o[C + 112 >> 2], S = o[C + 212 >> 2], e = o[C + 116 >> 2], s = o[C + 216 >> 2], Q = o[C + 120 >> 2], c = o[C + 220 >> 2], B = o[C + 124 >> 2], i = o[C + 224 >> 2], g = o[C + 128 >> 2], I = o[C + 228 >> 2], o[C + 228 >> 2] = r & (I ^ o[C + 132 >> 2]) ^ I, o[C + 224 >> 2] = i ^ r & (g ^ i), o[C + 220 >> 2] = c ^ r & (B ^ c), o[C + 216 >> 2] = s ^ r & (Q ^ s), o[C + 212 >> 2] = S ^ r & (e ^ S), o[C + 208 >> 2] = F ^ r & (f ^ F), o[C + 204 >> 2] = p ^ r & (D ^ p), o[C + 200 >> 2] = k ^ r & (t ^ k), o[C + 196 >> 2] = _ ^ r & (y ^ _), o[C + 192 >> 2] = G ^ r & (n ^ G), O(N, N), H(U, U, N), IA(A, U), iI(HA, 32), B = 0;
                                            }
                                            return w = C + 368 | 0, 0 | B;
                                        },
                                        function(A, I) {
                                            var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, G, _;
                                            return I |= 0, w = g = w - 304 | 0, E[0 | (A |= 0)] = a[0 | I], E[A + 1 | 0] = a[I + 1 | 0], E[A + 2 | 0] = a[I + 2 | 0], E[A + 3 | 0] = a[I + 3 | 0], E[A + 4 | 0] = a[I + 4 | 0], E[A + 5 | 0] = a[I + 5 | 0], E[A + 6 | 0] = a[I + 6 | 0], E[A + 7 | 0] = a[I + 7 | 0], E[A + 8 | 0] = a[I + 8 | 0], E[A + 9 | 0] = a[I + 9 | 0], E[A + 10 | 0] = a[I + 10 | 0], E[A + 11 | 0] = a[I + 11 | 0], E[A + 12 | 0] = a[I + 12 | 0], E[A + 13 | 0] = a[I + 13 | 0], E[A + 14 | 0] = a[I + 14 | 0], E[A + 15 | 0] = a[I + 15 | 0], E[A + 16 | 0] = a[I + 16 | 0], E[A + 17 | 0] = a[I + 17 | 0], E[A + 18 | 0] = a[I + 18 | 0], E[A + 19 | 0] = a[I + 19 | 0], E[A + 20 | 0] = a[I + 20 | 0], E[A + 21 | 0] = a[I + 21 | 0], E[A + 22 | 0] = a[I + 22 | 0], E[A + 23 | 0] = a[I + 23 | 0], E[A + 24 | 0] = a[I + 24 | 0], E[A + 25 | 0] = a[I + 25 | 0], E[A + 26 | 0] = a[I + 26 | 0], E[A + 27 | 0] = a[I + 27 | 0], E[A + 28 | 0] = a[I + 28 | 0], E[A + 29 | 0] = a[I + 29 | 0], E[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], E[0 | A] = 248 & a[0 | A], E[A + 31 | 0] = 63 & I | 64, u(g + 48 | 0, A), I = o[g + 132 >> 2], C = o[g + 92 >> 2], B = o[g + 136 >> 2], Q = o[g + 96 >> 2], i = o[g + 140 >> 2], f = o[g + 100 >> 2], c = o[g + 144 >> 2], e = o[g + 104 >> 2], r = o[g + 148 >> 2], D = o[g + 108 >> 2], t = o[g + 152 >> 2], y = o[g + 112 >> 2], h = o[g + 156 >> 2], n = o[g + 116 >> 2], s = o[g + 160 >> 2], k = o[g + 120 >> 2], F = o[g + 128 >> 2], S = o[g + 88 >> 2], G = o[g + 124 >> 2], _ = o[g + 164 >> 2], o[g + 292 >> 2] = G + _, o[g + 288 >> 2] = s + k, o[g + 284 >> 2] = h + n, o[g + 280 >> 2] = t + y, o[g + 276 >> 2] = r + D, o[g + 272 >> 2] = c + e, o[g + 268 >> 2] = i + f, o[g + 264 >> 2] = B + Q, o[g + 260 >> 2] = I + C, o[g + 256 >> 2] = F + S, o[g + 244 >> 2] = _ - G, o[g + 240 >> 2] = s - k, o[g + 236 >> 2] = h - n, o[g + 232 >> 2] = t - y, o[g + 228 >> 2] = r - D, o[g + 224 >> 2] = c - e, o[g + 220 >> 2] = i - f, o[g + 216 >> 2] = B - Q, o[g + 212 >> 2] = I - C, o[g + 208 >> 2] = F - S, O(I = g + 208 | 0, I), H(g, g + 256 | 0, I), IA(A, g), w = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0, e = 0;
                                            if (w = Q = w - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 104 >> 2] = 0, o[Q + 108 >> 2] = 0, o[Q + 96 >> 2] = B, o[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; Y(A, Q + 96 | 0, Q), C = a[Q + 104 | 0] + 1 | 0, E[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, E[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, E[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, E[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, E[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, E[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, E[Q + 110 | 0] = C, E[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, Y(Q + 32 | 0, Q + 96 | 0, Q), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; f = c = Q + 32 | 0, E[A + B | 0] = a[f + B | 0], E[(e = 1 | B) + A | 0] = a[f + e | 0], E[(f = 2 | B) + A | 0] = a[f + c | 0], E[(f = 3 | B) + A | 0] = a[f + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; E[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                iI(Q + 32 | 0, 64), iI(Q, 32);
                                            }
                                            return w = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, f) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, f |= 0;
                                            var c, e = 0;
                                            if (w = c = w - 112 | 0, (g |= 0) | (C |= 0)) {
                                                e = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, o[c + 24 >> 2] = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, o[c + 28 >> 2] = e, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[c + 16 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[c + 20 >> 2] = e, e = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, o[c >> 2] = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, o[c + 4 >> 2] = e, e = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, o[c + 8 >> 2] = a[f + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, o[c + 12 >> 2] = e, f = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[c + 100 >> 2] = f, E[c + 104 | 0] = Q, E[c + 111 | 0] = i >>> 24, E[c + 110 | 0] = i >>> 16, E[c + 109 | 0] = i >>> 8, E[c + 108 | 0] = i, E[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, E[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, E[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(f = 0, Y(c + 32 | 0, c + 96 | 0, c); Q = c + 32 | 0, E[A + f | 0] = a[Q + f | 0] ^ a[I + f | 0], E[(B = 1 | f) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (f = f + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, E[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, E[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, E[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, E[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, E[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, E[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, E[c + 110 | 0] = B, E[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (f = 0, Y(c + 32 | 0, c + 96 | 0, c), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, E[A + f | 0] = a[i + f | 0] ^ a[I + f | 0], E[(g = 1 | f) + A | 0] = a[g + i | 0] ^ a[I + g | 0], f = f + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (E[A + f | 0] = a[(c + 32 | 0) + f | 0] ^ a[I + f | 0]);
                                                }
                                                iI(c + 32 | 0, 64), iI(c, 32);
                                            }
                                            return w = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, E) {
                                            var f;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, E |= 0, w = f = w + -64 | 0, (g |= 0) | (C |= 0) && (o[f + 8 >> 2] = 2036477234, o[f + 12 >> 2] = 1797285236, o[f >> 2] = 1634760805, o[f + 4 >> 2] = 857760878, o[f + 16 >> 2] = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, o[f + 20 >> 2] = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, o[f + 24 >> 2] = a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, o[f + 28 >> 2] = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, o[f + 32 >> 2] = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, o[f + 36 >> 2] = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, o[f + 40 >> 2] = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[f + 44 >> 2] = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, o[f + 48 >> 2] = Q, o[f + 52 >> 2] = i, o[f + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[f + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, p(f, I, A, g, C), iI(f, 64)), w = f - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var E;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, w = E = w + -64 | 0, (g |= 0) | (C |= 0) && (o[E + 8 >> 2] = 2036477234, o[E + 12 >> 2] = 1797285236, o[E >> 2] = 1634760805, o[E + 4 >> 2] = 857760878, o[E + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, o[E + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, o[E + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, o[E + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, o[E + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, o[E + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, o[E + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, o[E + 48 >> 2] = Q, o[E + 44 >> 2] = i, o[E + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[E + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, p(E, I, A, g, C), iI(E, 64)), w = E - -64 | 0, 0;
                                        }
                                    ], yI.grow = function(A) {
                                        var I = this.length;
                                        return this.length = this.length + A, I;
                                    }, yI.set = function(A, I) {
                                        this[A] = I;
                                    }, yI.get = function(A) {
                                        return this[A];
                                    }, yI);
                                    function hI() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function() {},
                                        g: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | hA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        h: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (hA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        i: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | yA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        j: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (yA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        k: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | wA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        l: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = wA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        m: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | tA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        n: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = tA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        o: aI,
                                        p: function() {
                                            return 12;
                                        },
                                        q: tI,
                                        r: oI,
                                        s: cI,
                                        t: QI,
                                        u: aI,
                                        v: DI,
                                        w: tI,
                                        x: oI,
                                        y: cI,
                                        z: QI,
                                        A: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | oA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        B: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (oA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        C: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | EA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        D: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = EA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        E: aI,
                                        F: fI,
                                        G: tI,
                                        H: oI,
                                        I: cI,
                                        J: QI,
                                        K: aI,
                                        L: aI,
                                        M: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 480 | 0, gA(Q, B |= 0, 32), AI(Q, I, g, C), bA(Q, Q + 416 | 0), I = o[Q + 444 >> 2], g = o[Q + 440 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 436 >> 2], g = o[Q + 432 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 428 >> 2], g = o[Q + 424 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 420 >> 2], g = o[Q + 416 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, w = Q + 480 | 0, 0;
                                        },
                                        N: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 512 | 0, gA(i = Q + 32 | 0, B |= 0, 32), AI(i, I, g, C), bA(i, Q + 448 | 0), I = o[Q + 476 >> 2], o[Q + 24 >> 2] = o[Q + 472 >> 2], o[Q + 28 >> 2] = I, I = o[Q + 468 >> 2], o[Q + 16 >> 2] = o[Q + 464 >> 2], o[Q + 20 >> 2] = I, I = o[Q + 460 >> 2], o[Q + 8 >> 2] = o[Q + 456 >> 2], o[Q + 12 >> 2] = I, I = o[Q + 452 >> 2], o[Q >> 2] = o[Q + 448 >> 2], o[Q + 4 >> 2] = I, I = nA(A, Q), g = eA(Q, A, 32), w = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        O: QI,
                                        P: aI,
                                        Q: aI,
                                        R: aI,
                                        S: aI,
                                        T: fI,
                                        U: oI,
                                        V: cI,
                                        W: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0;
                                            return w = C = w + -64 | 0, aA(C, g |= 0, 32, 0), g = o[C + 28 >> 2], B = o[C + 24 >> 2], E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, E[I + 28 | 0] = g, E[I + 29 | 0] = g >>> 8, E[I + 30 | 0] = g >>> 16, E[I + 31 | 0] = g >>> 24, g = o[C + 20 >> 2], B = o[C + 16 >> 2], E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, E[I + 20 | 0] = g, E[I + 21 | 0] = g >>> 8, E[I + 22 | 0] = g >>> 16, E[I + 23 | 0] = g >>> 24, g = o[C + 12 >> 2], B = o[C + 8 >> 2], E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, E[I + 12 | 0] = g, E[I + 13 | 0] = g >>> 8, E[I + 14 | 0] = g >>> 16, E[I + 15 | 0] = g >>> 24, g = o[C + 4 >> 2], B = o[C >> 2], E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, E[I + 4 | 0] = g, E[I + 5 | 0] = g >>> 8, E[I + 6 | 0] = g >>> 16, E[I + 7 | 0] = g >>> 24, iI(C, 64), A = II(A, I), w = C - -64 | 0, 0 | A;
                                        },
                                        X: XA,
                                        Y: UA,
                                        Z: PA,
                                        _: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = iA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        $: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), 0 | iA(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        aa: function(A, I, g, C, B, Q, i) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        ba: vA,
                                        ca: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = QA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        da: JA,
                                        ea: function(A, I, g, C, B, Q, i) {
                                            return 0 | GA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fa: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, f, c = 0, e = 0;
                                            return c = g |= 0, g = C |= 0, f = 0 | c, c = C = w, w = Q = C - 512 & -64, C = -1, XA(i = Q - -64 | 0, a = Q + 32 | 0) || (K(C = Q + 128 | 0, 0, 0, 24), Z(C, i, 32, 0), Z(C, B, 32, 0), KA(C, e = Q + 96 | 0, 24), C = NA(A + 32 | 0, I, f, g, e, B, a), I = o[Q + 92 >> 2], g = o[Q + 88 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 84 >> 2], g = o[Q + 80 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 76 >> 2], g = o[Q + 72 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 68 >> 2], g = o[Q + 64 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, iI(a, 32), iI(i, 32), iI(e, 24)), w = c, 0 | C;
                                        },
                                        ga: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, E, o = 0;
                                            return E = o = w, w = i = o - 448 & -64, o = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (K(o = i - -64 | 0, 0, 0, 24), Z(o, I, 32, 0), Z(o, B, 32, 0), KA(o, B = i + 32 | 0, 24), o = GA(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), w = E, 0 | o;
                                        },
                                        ha: function() {
                                            return 48;
                                        },
                                        ia: oI,
                                        ja: eI,
                                        ka: aI,
                                        la: oI,
                                        ma: eI,
                                        na: aI,
                                        oa: function() {
                                            return 384;
                                        },
                                        pa: function(A, I, g, C, B, Q, i) {
                                            return 0 | X(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        qa: K,
                                        ra: function(A, I, g, C) {
                                            return 0 | Z(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        sa: KA,
                                        ta: QI,
                                        ua: eI,
                                        va: function(A, I, g, C) {
                                            return 0 | aA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        wa: oI,
                                        xa: eI,
                                        ya: DI,
                                        za: aI,
                                        Aa: function(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, i |= 0;
                                            var E, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0;
                                            return w = E = w - 32 | 0, f = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 24 >> 2] = 0, o[E + 28 >> 2] = 0, o[E + 16 >> 2] = f, o[E + 20 >> 2] = B, o[E + 8 >> 2] = 0, o[E + 12 >> 2] = 0, o[(B = E) >> 2] = g, o[B + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (o[9005] = 28, A = -1) : I - 65 >>> 0 < 4294967232 ? A = -1 : (w = B = (e = w) - 512 & -64, !i | !A | ((c = 255 & I) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (C = E + 16 | 0, E ? (r = 725511199 ^ (a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24), D = -1694144372 ^ (a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24), g = -1377402159 ^ (a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24), I = 1359893119 ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24)) : (r = 725511199, D = -1694144372, g = -1377402159, I = 1359893119), C ? (t = 327033209 ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), y = 1541459225 ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), f = -79577749 ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), C = 528734635 ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24)) : (t = 327033209, y = 1541459225, f = -79577749, C = 528734635), dA(B - -64 | 0, 0, 293), o[B + 56 >> 2] = t, o[B + 60 >> 2] = y, o[B + 48 >> 2] = f, o[B + 52 >> 2] = C, o[B + 40 >> 2] = r, o[B + 44 >> 2] = D, o[B + 32 >> 2] = g, o[B + 36 >> 2] = I, o[B + 24 >> 2] = 1595750129, o[B + 28 >> 2] = -1521486534, o[B + 16 >> 2] = -23791573, o[B + 20 >> 2] = 1013904242, o[B + 8 >> 2] = -2067093701, o[B + 12 >> 2] = -1150833019, o[B >> 2] = -222443256 ^ (8192 | c), o[B + 4 >> 2] = 1779033703, dA(32 + (I = B + 384 | 0) | 0, 0, 96), YA(I, i, 32), YA(B + 96 | 0, I, 128), o[B + 352 >> 2] = 128, iI(I, 128), J(B, A, c), w = e), A = 0), w = E + 32 | 0, 0 | A;
                                        },
                                        Ba: QI,
                                        Ca: function(A, I, g) {
                                            return 0 | q(A |= 0, I |= 0, g |= 0);
                                        },
                                        Da: function(A, I, g) {
                                            return 0 | gI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ea: function(A, I) {
                                            return LA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Fa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 208 | 0, q(Q, I |= 0, g |= 0), gI(Q, C, B), LA(Q, A), iI(Q, 4), w = Q + 208 | 0, 0;
                                        },
                                        Ga: QI,
                                        Ha: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 256 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, q(i = Q + 48 | 0, B, 32), f && gI(i, (A + f | 0) - 32 | 0, 32), gI(i = Q + 48 | 0, g, C), gI(i, Q + 15 | 0, 1), LA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (f = 31 & I) && (q(I = Q + 48 | 0, B, 32), c && gI(I, (A + c | 0) - 32 | 0, 32), gI(I = Q + 48 | 0, g, C), gI(I, Q + 15 | 0, 1), LA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 32)), iI(Q + 48 | 0, 208), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 256 | 0, 0 | A;
                                        },
                                        Ia: aI,
                                        Ja: tI,
                                        Ka: function() {
                                            return 8160;
                                        },
                                        La: EI,
                                        Ma: function(A, I, g) {
                                            return 0 | gA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Na: function(A, I, g) {
                                            return 0 | AI(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        Oa: function(A, I) {
                                            return bA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Pa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 416 | 0, gA(Q, I |= 0, g |= 0), AI(Q, C, B, 0), bA(Q, A), iI(Q, 4), w = Q + 416 | 0, 0;
                                        },
                                        Qa: function(A) {
                                            HA(A |= 0, 64);
                                        },
                                        Ra: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 496 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, gA(i = Q + 80 | 0, B, 64), f && AI(i, (A + f | 0) - 64 | 0, 64, 0), AI(i = Q + 80 | 0, g, C, 0), AI(i, Q + 15 | 0, 1, 0), bA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (f = 63 & I) && (gA(I = Q + 80 | 0, B, 64), c && AI(I, (A + c | 0) - 64 | 0, 64, 0), AI(I = Q + 80 | 0, g, C, 0), AI(I, Q + 15 | 0, 1, 0), bA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 64)), iI(Q + 80 | 0, 416), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 496 | 0, 0 | A;
                                        },
                                        Sa: eI,
                                        Ta: tI,
                                        Ua: function() {
                                            return 16320;
                                        },
                                        Va: function(A, I, g) {
                                            return A |= 0, X(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | VA(A, I);
                                        },
                                        Wa: function(A, I) {
                                            return A |= 0, HA(I |= 0, 32), 0 | VA(A, I);
                                        },
                                        Xa: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, g, 32, 0), Z(I, B, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + i | 0] = a[0 | g], E[A + C | 0] = a[g + 32 | 0], E[(B = 1 | A) + i | 0] = a[I + B | 0], E[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Ya: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, B, 32, 0), Z(I, g, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + C | 0] = a[0 | g], E[A + i | 0] = a[g + 32 | 0], E[(B = 1 | A) + C | 0] = a[I + B | 0], E[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Za: aI,
                                        _a: aI,
                                        $a: aI,
                                        ab: aI,
                                        bb: VA,
                                        cb: lA,
                                        db: aI,
                                        eb: aI,
                                        fb: aI,
                                        gb: fI,
                                        hb: oI,
                                        ib: cI,
                                        jb: QI,
                                        kb: PA,
                                        lb: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), iA(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        mb: vA,
                                        nb: JA,
                                        ob: QI,
                                        pb: function(A, I, g) {
                                            return A |= 0, g |= 0, HA(I |= 0, 24), x(A, I, g), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        qb: function(A, I, g) {
                                            return x(A |= 0, I |= 0, g |= 0), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        rb: function(A) {
                                            var I, g = 0, C = 0;
                                            w = I = w - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[I + 36 >> 2] = g, OA(I, I, A + 32 | 0, A), g = o[I + 28 >> 2], C = o[I + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = g, E[A + 29 | 0] = g >>> 8, E[A + 30 | 0] = g >>> 16, E[A + 31 | 0] = g >>> 24, g = o[I + 20 >> 2], C = o[I + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = g, E[A + 21 | 0] = g >>> 8, E[A + 22 | 0] = g >>> 16, E[A + 23 | 0] = g >>> 24, g = o[I + 12 >> 2], C = o[I + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = g, E[A + 13 | 0] = g >>> 8, E[A + 14 | 0] = g >>> 16, E[A + 15 | 0] = g >>> 24, g = o[I + 4 >> 2], C = o[I >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = g, E[A + 5 | 0] = g >>> 8, E[A + 6 | 0] = g >>> 16, E[A + 7 | 0] = g >>> 24, C = o[I + 36 >> 2], g = o[I + 32 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24, w = I + 48 | 0;
                                        },
                                        sb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, f |= 0, e |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0;
                                            return t = B |= 0, t |= B = 0, D = B | (c |= 0), w = B = w - 384 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), !i & t >>> 0 < 4294967279 ? (ZA(y = B + 16 | 0, 64, h = A + 32 | 0, A), CI(c = B + 80 | 0, y), iI(y, 64), $A(c, f, D, e), $A(c, 34288, 0 - D & 15, 0), o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, o[(f = B - -64 | 0) >> 2] = 0, o[f + 4 >> 2] = 0, o[B + 56 >> 2] = 0, o[B + 60 >> 2] = 0, o[B + 48 >> 2] = 0, o[B + 52 >> 2] = 0, o[B + 40 >> 2] = 0, o[B + 44 >> 2] = 0, o[B + 32 >> 2] = 0, o[B + 36 >> 2] = 0, o[B + 16 >> 2] = 0, o[B + 20 >> 2] = 0, o[B + 24 >> 2] = 0, o[B + 28 >> 2] = 0, E[B + 16 | 0] = r, FA(y, y, 64, 0, h, 1, A), $A(c, y, 64, 0), E[0 | I] = a[B + 16 | 0], FA(I = I + 1 | 0, C, t, i, h, 2, A), $A(c, I, t, i), $A(c, 34288, 15 & t, 0), o[B + 8 >> 2] = D, o[B + 12 >> 2] = e, $A(c, C = B + 8 | 0, 8, 0), o[B + 8 >> 2] = t - -64, o[B + 12 >> 2] = i - ((t >>> 0 < 4294967232) - 1 | 0), $A(c, C, 8, 0), BI(c, I = I + t | 0), iI(c, 256), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], E[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], sA(h), (2 & r || fA(h, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[B + 372 >> 2] = I, OA(I = B + 336 | 0, I, h, A), I = o[B + 364 >> 2], C = o[B + 360 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[B + 356 >> 2], C = o[B + 352 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[B + 348 >> 2], C = o[B + 344 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[B + 340 >> 2], C = o[B + 336 >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[B + 368 >> 2], C = o[B + 372 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24), g && (i = (A = t + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, o[g >> 2] = A, o[g + 4 >> 2] = i), w = B + 384 | 0) : (zA(), Q()), 0;
                                        },
                                        tb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0;
                                            t = i |= 0, i = f |= 0, y = 0 | t, D = e |= 0, w = f = w - 400 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), C && (E[0 | C] = 255), k = -1;
                                            A: {
                                                I: {
                                                    if (!((e = y >>> 0 < 17) & !i)) {
                                                        if (s = t = i - e | 0, !t & (e = y - 17 | 0) >>> 0 >= 4294967279 | t) break I;
                                                        ZA(h = f + 32 | 0, 64, n = A + 32 | 0, A), CI(t = f + 96 | 0, h), iI(h, 64), $A(t, c, D, r), $A(t, 34288, 0 - D & 15, 0), o[f + 88 >> 2] = 0, o[f + 92 >> 2] = 0, o[f + 80 >> 2] = 0, o[f + 84 >> 2] = 0, o[f + 72 >> 2] = 0, o[f + 76 >> 2] = 0, o[(c = f - -64 | 0) >> 2] = 0, o[c + 4 >> 2] = 0, o[f + 56 >> 2] = 0, o[f + 60 >> 2] = 0, o[f + 48 >> 2] = 0, o[f + 52 >> 2] = 0, o[f + 40 >> 2] = 0, o[f + 44 >> 2] = 0, o[f + 32 >> 2] = 0, o[f + 36 >> 2] = 0, E[f + 32 | 0] = a[0 | B], FA(h, h, 64, 0, n, 1, A), c = a[f + 32 | 0], E[f + 32 | 0] = a[0 | B], $A(t, h, 64, 0), $A(t, B = B + 1 | 0, e, s), $A(t, 34288, y - 1 & 15, 0), o[f + 24 >> 2] = D, o[f + 28 >> 2] = r, $A(t, r = f + 24 | 0, 8, 0), i = (y = y + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, o[f + 24 >> 2] = y, o[f + 28 >> 2] = i, $A(t, r, 8, 0), BI(t, f), iI(t, 256), eA(f, B + e | 0, 16) ? iI(f, 16) : (FA(I, B, e, s, n, 2, A), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | f], E[A + 37 | 0] = a[A + 37 | 0] ^ a[f + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[f + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[f + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[f + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[f + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[f + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[f + 7 | 0], sA(n), (2 & c || fA(n, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[f + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[f + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[f + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[f + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[f + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[f + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[f + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[f + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[f + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[f + 388 >> 2] = I, OA(I = f + 352 | 0, I, n, A), I = o[f + 380 >> 2], B = o[f + 376 >> 2], E[A + 24 | 0] = B, E[A + 25 | 0] = B >>> 8, E[A + 26 | 0] = B >>> 16, E[A + 27 | 0] = B >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[f + 372 >> 2], B = o[f + 368 >> 2], E[A + 16 | 0] = B, E[A + 17 | 0] = B >>> 8, E[A + 18 | 0] = B >>> 16, E[A + 19 | 0] = B >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[f + 364 >> 2], B = o[f + 360 >> 2], E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[f + 356 >> 2], B = o[f + 352 >> 2], E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[f + 384 >> 2], B = o[f + 388 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = B, E[A + 41 | 0] = B >>> 8, E[A + 42 | 0] = B >>> 16, E[A + 43 | 0] = B >>> 24), g && (o[g >> 2] = e, o[g + 4 >> 2] = s), k = 0, C && (E[0 | C] = c));
                                                    }
                                                    w = f + 400 | 0;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            return 0 | k;
                                        },
                                        ub: function() {
                                            return 52;
                                        },
                                        vb: function() {
                                            return 17;
                                        },
                                        wb: fI,
                                        xb: aI,
                                        yb: function() {
                                            return -18;
                                        },
                                        zb: tI,
                                        Ab: rI,
                                        Bb: function() {
                                            return 2;
                                        },
                                        Cb: function() {
                                            return 3;
                                        },
                                        Db: DI,
                                        Eb: oI,
                                        Fb: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                            if (k = 1886610805 ^ (i = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), t = 1936682341 ^ (o = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), i ^= 1852142177, f = 1819895653 ^ o, F = 1852075885 ^ (o = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), S = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), D = 2037671283 ^ o, o = 1952801890 ^ B, n = g, (0 | (w = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (e = o ^ (s = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + f | 0, D = C = i + (B = D ^ (y = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, r = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, i = C, C = g, g = t + S | 0, g = (o = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, c = (f = DA(F, S, 13) ^ o) + i | 0, C = (i = h ^ g) + C | 0, i = DA(f, i, 17) ^ c, k = DA(i, C = (f = f >>> 0 > c >>> 0 ? C + 1 | 0 : C) ^ h, 13), t = h, e = DA(B, e, 16), B = r ^ h, e ^= D, r = DA(o, g, 32), g = h + B | 0, g = (D = C) + (C = (o = e + r | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g) | 0, r = g = (D = i + o | 0) >>> 0 < o >>> 0 ? g + 1 | 0 : g, k = DA(i = D ^ k, g ^= t, 17), t = h, e = DA(e, B, 21), B = C ^ h, e ^= o, o = DA(c, f, 32), C = h + B | 0, g = (o = o >>> 0 > (f = e + o | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, F = (i = i + f | 0) ^ k, C = g = i >>> 0 < f >>> 0 ? g + 1 | 0 : g, S = g ^ t, g = DA(e, B, 16), e = o ^= h, c = DA(g ^= f, o, 21), f = h, r = (o = DA(D, r, 32)) + g | 0, g = h + e | 0, D = c ^ r, o = (g = o >>> 0 > r >>> 0 ? g + 1 | 0 : g) ^ f, i = DA(i, C, 32), f = h, k = r ^ y, t = g ^ s, (0 | w) != (0 | (I = I + 8 | 0)););
                                                I = w;
                                            }
                                            switch(s = 0, c = n << 24, Q - 1 | 0){
                                                case 6:
                                                    c |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    c |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    c |= a[I + 4 | 0];
                                                case 3:
                                                    s |= (g = a[I + 3 | 0]) << 24, c |= C = g >>> 8 | 0;
                                                case 2:
                                                    s |= (C = a[I + 2 | 0]) << 16, c |= g = C >>> 16 | 0;
                                                case 1:
                                                    s |= (g = a[I + 1 | 0]) << 8, c |= C = g >>> 24 | 0;
                                                case 0:
                                                    s = a[0 | I] | s;
                                            }
                                            return I = A, C = DA(B = D ^ s, A = o ^ c, 16), A = A + f | 0, r = A = (D = B + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, y = DA(B = C ^ D, A ^= g = h, 21), o = h, g = t + S | 0, C = g = (i = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, w = B, B = DA(i, g, 32), g = h + A | 0, A = o, o = g = B >>> 0 > (f = w + B | 0) >>> 0 ? g + 1 | 0 : g, e = DA(B = f ^ y, A ^= g, 16), y = h, n = DA(F, S, 13) ^ i, C = (w = h ^ C) + r | 0, r = B, B = DA(g = (i = n) + D | 0, C = g >>> 0 < i >>> 0 ? C + 1 | 0 : C, 32), A = h + A | 0, t = DA(i = e ^ (D = r + B | 0), B = (r = B >>> 0 > D >>> 0 ? A + 1 | 0 : A) ^ y, 21), y = h, e = DA(n, w, 17) ^ g, g = (n = h ^ C) + o | 0, A = g = (C = f = (A = e) + f | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g, o = i, i = DA(C, g, 32), g = h + B | 0, w = g = (o = i >>> 0 > (f = o + i | 0) >>> 0 ? g + 1 | 0 : g) ^ y, y = DA(t ^= f, g, 16), i = h, e = DA(e, n, 13) ^ C, A = (n = A ^ h) + r | 0, C = A = (g = e) >>> 0 > (B = g + D | 0) >>> 0 ? A + 1 | 0 : A, A = DA(B, A, 32), g = w + h | 0, w = g = (r = i) ^ (i = (A = t + (255 ^ A) | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g), D = A, y = DA(t = y ^ A, g, 21), r = h, e = DA(e, n, 17) ^ B, g = (n = C ^ h) + (o ^ c) | 0, C = g = (A = f ^ s) >>> 0 > (B = e + A | 0) >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = w + h | 0, w = g = (o = (A = A + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) ^ r, r = A, y = DA(t = y ^ A, g, 16), f = h, e = DA(e, n, 13) ^ B, A = i + (c = h ^ C) | 0, A = DA(B = D + e | 0, g = A = B >>> 0 < D >>> 0 ? A + 1 | 0 : A, 32), C = w + h | 0, n = C = (i = (A = A + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C) ^ f, f = A, w = DA(t = y ^ A, C, 21), y = h, A = DA(e, c, 17), g = o + (c = g ^ h) | 0, C = g = (B = r + (D = A ^ B) | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = n + h | 0, r = A = A + t | 0, o = g = A >>> 0 < t >>> 0 ? g + 1 | 0 : g, n = DA(e = w ^ A, g ^= y, 16), w = h, A = DA(D, c, 13), C = i + (y = C ^ h) | 0, A = DA(i = f + (c = A ^ B) | 0, C = i >>> 0 < f >>> 0 ? C + 1 | 0 : C, 32), g = g + h | 0, D = A = A + e | 0, f = g = A >>> 0 < e >>> 0 ? g + 1 | 0 : g, e = DA(B = n ^ A, A = g ^ w, 21), n = h, c = DA(c, y, 17), g = o + (w = C ^ h) | 0, y = i ^ c, i = B, B = DA(C = r + y | 0, g = C >>> 0 < r >>> 0 ? g + 1 | 0 : g, 32), A = h + A | 0, n = DA(i = e ^ (r = i + B | 0), B = (o = B >>> 0 > r >>> 0 ? A + 1 | 0 : A) ^ n, 16), c = h, A = DA(y, w, 13), g = f + (w = g ^ h) | 0, A = g = (C = D + (y = A ^ C) | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, f = DA(C, g, 32), g = h + B | 0, c = DA(n ^ (B = i = f + i | 0), (g = B >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ c, 21), D = h, i = DA(y, w, 17) ^ C, f = DA(i, A ^= h, 13), A = A + o | 0, C = A = h ^ ((i = i + r | 0) >>> 0 < r >>> 0 ? A + 1 | 0 : A), i = DA(o = i ^ f, A, 17) ^ c, A = h ^ D, C = g + C | 0, g = DA(g = B + o | 0, C = g >>> 0 < B >>> 0 ? C + 1 | 0 : C, 32) ^ i ^ g, E[0 | I] = g, E[I + 1 | 0] = g >>> 8, E[I + 2 | 0] = g >>> 16, E[I + 3 | 0] = g >>> 24, A ^= C ^ h, E[I + 4 | 0] = A, E[I + 5 | 0] = A >>> 8, E[I + 6 | 0] = A >>> 16, E[I + 7 | 0] = A >>> 24, 0;
                                        },
                                        Gb: function(A) {
                                            HA(A |= 0, 16);
                                        },
                                        Hb: EI,
                                        Ib: eI,
                                        Jb: aI,
                                        Kb: aI,
                                        Lb: eI,
                                        Mb: function() {
                                            return -65;
                                        },
                                        Nb: function(A, I, g) {
                                            A |= 0;
                                            var C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0;
                                            return w = Q = w - 160 | 0, aA(I |= 0, g |= 0, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(Q, I), MA(A, Q), f = a[(B = g) + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, c = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, e = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, r = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, C = I, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[C + 24 | 0] = I, E[C + 25 | 0] = I >>> 8, E[C + 26 | 0] = I >>> 16, E[C + 27 | 0] = I >>> 24, E[C + 28 | 0] = i, E[C + 29 | 0] = i >>> 8, E[C + 30 | 0] = i >>> 16, E[C + 31 | 0] = i >>> 24, E[C + 16 | 0] = c, E[C + 17 | 0] = c >>> 8, E[C + 18 | 0] = c >>> 16, E[C + 19 | 0] = c >>> 24, E[C + 20 | 0] = e, E[C + 21 | 0] = e >>> 8, E[C + 22 | 0] = e >>> 16, E[C + 23 | 0] = e >>> 24, E[C + 8 | 0] = f, E[C + 9 | 0] = f >>> 8, E[C + 10 | 0] = f >>> 16, E[C + 11 | 0] = f >>> 24, E[C + 12 | 0] = o, E[C + 13 | 0] = o >>> 8, E[C + 14 | 0] = o >>> 16, E[C + 15 | 0] = o >>> 24, E[0 | C] = r, E[C + 1 | 0] = r >>> 8, E[C + 2 | 0] = r >>> 16, E[C + 3 | 0] = r >>> 24, E[C + 4 | 0] = g, E[C + 5 | 0] = g >>> 8, E[C + 6 | 0] = g >>> 16, E[C + 7 | 0] = g >>> 24, c = a[(o = A) + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, e = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, r = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, g = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, I = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, A = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, o = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[C + 56 | 0] = o, E[C + 57 | 0] = o >>> 8, E[C + 58 | 0] = o >>> 16, E[C + 59 | 0] = o >>> 24, E[C + 60 | 0] = f, E[C + 61 | 0] = f >>> 8, E[C + 62 | 0] = f >>> 16, E[C + 63 | 0] = f >>> 24, E[C + 48 | 0] = r, E[C + 49 | 0] = r >>> 8, E[C + 50 | 0] = r >>> 16, E[C + 51 | 0] = r >>> 24, E[C + 52 | 0] = g, E[C + 53 | 0] = g >>> 8, E[C + 54 | 0] = g >>> 16, E[C + 55 | 0] = g >>> 24, E[C + 40 | 0] = c, E[C + 41 | 0] = c >>> 8, E[C + 42 | 0] = c >>> 16, E[C + 43 | 0] = c >>> 24, E[C + 44 | 0] = e, E[C + 45 | 0] = e >>> 8, E[C + 46 | 0] = e >>> 16, E[C + 47 | 0] = e >>> 24, E[C + 32 | 0] = I, E[C + 33 | 0] = I >>> 8, E[C + 34 | 0] = I >>> 16, E[C + 35 | 0] = I >>> 24, E[C + 36 | 0] = A, E[C + 37 | 0] = A >>> 8, E[C + 38 | 0] = A >>> 16, E[C + 39 | 0] = A >>> 24, w = Q + 160 | 0, 0;
                                        },
                                        Ob: function(A, I) {
                                            A |= 0, I |= 0;
                                            var g, C, B, Q, i, f = 0, c = 0, e = 0;
                                            return w = c = w - 192 | 0, HA(c, 32), aA(I, c, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(e = c + 32 | 0, I), MA(A, e), g = c, e = o[c + 28 >> 2], c = o[c + 24 >> 2], E[I + 24 | 0] = c, E[I + 25 | 0] = c >>> 8, E[I + 26 | 0] = c >>> 16, E[I + 27 | 0] = c >>> 24, E[I + 28 | 0] = e, E[I + 29 | 0] = e >>> 8, E[I + 30 | 0] = e >>> 16, E[I + 31 | 0] = e >>> 24, e = o[g + 20 >> 2], c = o[g + 16 >> 2], E[I + 16 | 0] = c, E[I + 17 | 0] = c >>> 8, E[I + 18 | 0] = c >>> 16, E[I + 19 | 0] = c >>> 24, E[I + 20 | 0] = e, E[I + 21 | 0] = e >>> 8, E[I + 22 | 0] = e >>> 16, E[I + 23 | 0] = e >>> 24, e = o[g + 12 >> 2], c = o[g + 8 >> 2], E[I + 8 | 0] = c, E[I + 9 | 0] = c >>> 8, E[I + 10 | 0] = c >>> 16, E[I + 11 | 0] = c >>> 24, E[I + 12 | 0] = e, E[I + 13 | 0] = e >>> 8, E[I + 14 | 0] = e >>> 16, E[I + 15 | 0] = e >>> 24, e = o[g + 4 >> 2], c = o[g >> 2], E[0 | I] = c, E[I + 1 | 0] = c >>> 8, E[I + 2 | 0] = c >>> 16, E[I + 3 | 0] = c >>> 24, E[I + 4 | 0] = e, E[I + 5 | 0] = e >>> 8, E[I + 6 | 0] = e >>> 16, E[I + 7 | 0] = e >>> 24, C = a[(f = A) + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, B = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, Q = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, c = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, A = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, i = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, f = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, E[I + 56 | 0] = f, E[I + 57 | 0] = f >>> 8, E[I + 58 | 0] = f >>> 16, E[I + 59 | 0] = f >>> 24, E[I + 60 | 0] = i, E[I + 61 | 0] = i >>> 8, E[I + 62 | 0] = i >>> 16, E[I + 63 | 0] = i >>> 24, E[I + 48 | 0] = Q, E[I + 49 | 0] = Q >>> 8, E[I + 50 | 0] = Q >>> 16, E[I + 51 | 0] = Q >>> 24, E[I + 52 | 0] = e, E[I + 53 | 0] = e >>> 8, E[I + 54 | 0] = e >>> 16, E[I + 55 | 0] = e >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, E[I + 32 | 0] = c, E[I + 33 | 0] = c >>> 8, E[I + 34 | 0] = c >>> 16, E[I + 35 | 0] = c >>> 24, E[I + 36 | 0] = A, E[I + 37 | 0] = A >>> 8, E[I + 38 | 0] = A >>> 16, E[I + 39 | 0] = A >>> 24, iI(g, 32), w = g + 192 | 0, 0;
                                        },
                                        Pb: function(A, I, g, C, B, Q) {
                                            I |= 0, B |= 0, Q |= 0;
                                            var i, E = 0;
                                            return w = i = w - 16 | 0, s(A |= 0, i + 8 | 0, pA(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), 64 != o[i + 8 >> 2] | o[i + 12 >> 2] ? (I && (o[I >> 2] = 0, o[I + 4 >> 2] = 0), dA(A, 0, C - -64 | 0), E = -1) : I && (o[I >> 2] = C - -64, o[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), w = i + 16 | 0, 0 | E;
                                        },
                                        Qb: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, g |= 0;
                                            var i = 0;
                                            A: {
                                                I: {
                                                    if (i = C |= 0, !(!(B |= 0) & C >>> 0 < 64 || (C = B - 1 | 0, !(C = (B = i + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & B >>> 0 > 4294967231 | C))) {
                                                        if (!S(g, i = g - -64 | 0, B, C, Q |= 0, 0)) break I;
                                                        A && dA(A, 0, B);
                                                    }
                                                    if (g = -1, !I) break A;
                                                    o[I >> 2] = 0, o[I + 4 >> 2] = 0;
                                                    break A;
                                                }
                                                I && (o[I >> 2] = B, o[I + 4 >> 2] = C), g = 0, A && pA(A, i, B);
                                            }
                                            return 0 | g;
                                        },
                                        Rb: function(A, I, g, C, B, Q) {
                                            return s(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                        },
                                        Sb: function(A, I, g, C, B) {
                                            return 0 | S(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                        },
                                        Tb: function(A) {
                                            return cA(A |= 0), 0;
                                        },
                                        Ub: function(A, I, g, C) {
                                            return 0 | R(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Vb: function(A, I, g, C) {
                                            var B;
                                            return I |= 0, g |= 0, C |= 0, w = B = w + -64 | 0, N(A |= 0, B), A = s(I, g, B, 64, 0, C, 1), w = B - -64 | 0, 0 | A;
                                        },
                                        Wb: function(A, I, g) {
                                            var C;
                                            return I |= 0, g |= 0, w = C = w + -64 | 0, N(A |= 0, C), A = S(I, C, 64, 0, g, 1), w = C - -64 | 0, 0 | A;
                                        },
                                        Xb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, Y = 0, d = 0, K = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, cA = 0, eA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0;
                                            if (w = g = w - 256 | 0, vA = -1, !rA(I |= 0) && !U(C = g + 96 | 0, I)) {
                                                for(w = Q = w - 2048 | 0, W(i = Q + 640 | 0, C), C = o[(I = C) + 36 >> 2], o[Q + 352 >> 2] = o[I + 32 >> 2], o[Q + 356 >> 2] = C, C = o[I + 28 >> 2], o[Q + 344 >> 2] = o[I + 24 >> 2], o[Q + 348 >> 2] = C, C = o[I + 20 >> 2], o[Q + 336 >> 2] = o[I + 16 >> 2], o[Q + 340 >> 2] = C, C = o[I + 12 >> 2], o[Q + 328 >> 2] = o[I + 8 >> 2], o[Q + 332 >> 2] = C, C = o[I + 4 >> 2], o[Q + 320 >> 2] = o[I >> 2], o[Q + 324 >> 2] = C, C = o[I + 52 >> 2], o[Q + 368 >> 2] = o[I + 48 >> 2], o[Q + 372 >> 2] = C, C = o[I + 60 >> 2], o[Q + 376 >> 2] = o[I + 56 >> 2], o[Q + 380 >> 2] = C, B = o[4 + (C = I - -64 | 0) >> 2], o[Q + 384 >> 2] = o[C >> 2], o[Q + 388 >> 2] = B, C = o[I + 76 >> 2], o[Q + 392 >> 2] = o[I + 72 >> 2], o[Q + 396 >> 2] = C, C = o[I + 44 >> 2], o[Q + 360 >> 2] = o[I + 40 >> 2], o[Q + 364 >> 2] = C, C = o[I + 92 >> 2], o[Q + 408 >> 2] = o[I + 88 >> 2], o[Q + 412 >> 2] = C, C = o[I + 100 >> 2], o[Q + 416 >> 2] = o[I + 96 >> 2], o[Q + 420 >> 2] = C, C = o[I + 108 >> 2], o[Q + 424 >> 2] = o[I + 104 >> 2], o[Q + 428 >> 2] = C, C = o[I + 116 >> 2], o[Q + 432 >> 2] = o[I + 112 >> 2], o[Q + 436 >> 2] = C, C = o[I + 84 >> 2], o[Q + 400 >> 2] = o[I + 80 >> 2], o[Q + 404 >> 2] = C, G(I = Q + 480 | 0, C = Q + 320 | 0), H(B = Q + 160 | 0, I, f = Q + 600 | 0), H(Q + 200 | 0, r = Q + 520 | 0, D = Q + 560 | 0), H(Q + 240 | 0, D, f), H(Q + 280 | 0, I, r), b(I, B, i), H(C, I, f), H(F = Q + 360 | 0, r, D), H(S = Q + 400 | 0, D, f), H(n = Q + 440 | 0, I, r), W(i = Q + 800 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 960 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1120 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1280 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1440 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1600 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(Q + 1760 | 0, C), o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 64 >> 2] = 0, o[Q + 68 >> 2] = 0, o[Q + 72 >> 2] = 0, o[Q + 76 >> 2] = 0, o[Q + 80 >> 2] = 1, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, o[Q + 40 >> 2] = 1, dA(Q + 84 | 0, 0, 76), t = Q + 120 | 0, k = Q + 2008 | 0, s = Q + 1968 | 0, C = Q + 80 | 0, B = Q + 40 | 0, i = 252; a = o[Q + 36 >> 2], o[(I = Q + 1960 | 0) >> 2] = o[Q + 32 >> 2], o[I + 4 >> 2] = a, a = o[Q + 28 >> 2], o[(I = Q + 1952 | 0) >> 2] = o[Q + 24 >> 2], o[I + 4 >> 2] = a, a = o[Q + 20 >> 2], o[(I = Q + 1944 | 0) >> 2] = o[Q + 16 >> 2], o[I + 4 >> 2] = a, a = o[Q + 12 >> 2], o[(I = Q + 1936 | 0) >> 2] = o[Q + 8 >> 2], o[I + 4 >> 2] = a, I = o[Q + 4 >> 2], o[Q + 1928 >> 2] = o[Q >> 2], o[Q + 1932 >> 2] = I, a = o[(I = B) + 36 >> 2], o[s + 32 >> 2] = o[I + 32 >> 2], o[s + 36 >> 2] = a, a = o[I + 28 >> 2], o[s + 24 >> 2] = o[I + 24 >> 2], o[s + 28 >> 2] = a, a = o[I + 20 >> 2], o[s + 16 >> 2] = o[I + 16 >> 2], o[s + 20 >> 2] = a, a = o[I + 12 >> 2], o[s + 8 >> 2] = o[I + 8 >> 2], o[s + 12 >> 2] = a, a = o[I + 4 >> 2], o[s >> 2] = o[I >> 2], o[s + 4 >> 2] = a, a = o[(I = C) + 36 >> 2], o[k + 32 >> 2] = o[I + 32 >> 2], o[k + 36 >> 2] = a, a = o[I + 28 >> 2], o[k + 24 >> 2] = o[I + 24 >> 2], o[k + 28 >> 2] = a, a = o[I + 20 >> 2], o[k + 16 >> 2] = o[I + 16 >> 2], o[k + 20 >> 2] = a, a = o[I + 12 >> 2], o[k + 8 >> 2] = o[I + 8 >> 2], o[k + 12 >> 2] = a, a = o[I + 4 >> 2], o[k >> 2] = o[I >> 2], o[k + 4 >> 2] = a, i = E[(I = i) + 33424 | 0], G(a = Q + 480 | 0, Q + 1928 | 0), (0 | i) > 0 ? (H(M = Q + 320 | 0, a, f), H(F, r, D), H(S, D, f), H(n, a, r), b(a, M, (Q + 640 | 0) + c((254 & i) >>> 1 | 0, 160) | 0)) : (0 | i) >= 0 || (H(M = Q + 320 | 0, a = Q + 480 | 0, f), H(F, r, D), H(S, D, f), H(n, a, r), P(a, M, (Q + 640 | 0) + c((0 - i & 254) >>> 1 | 0, 160) | 0)), H(Q, i = Q + 480 | 0, f), H(B, r, D), H(C, D, f), H(t, i, r), i = I - 1 | 0, I;);
                                                IA(I = Q + 640 | 0, Q), I = fA(I, 32), w = Q + 2048 | 0, I && (Q = o[g + 136 >> 2], o[g >> 2] = 1 - Q, vA = 0, z = o[g + 172 >> 2], o[g + 36 >> 2] = 0 - z, F = o[g + 168 >> 2], o[g + 32 >> 2] = 0 - F, q = o[g + 164 >> 2], o[g + 28 >> 2] = 0 - q, r = o[g + 160 >> 2], o[g + 24 >> 2] = 0 - r, X = o[g + 156 >> 2], o[g + 20 >> 2] = 0 - X, D = o[g + 152 >> 2], o[g + 16 >> 2] = 0 - D, j = o[g + 148 >> 2], o[g + 12 >> 2] = 0 - j, k = o[g + 144 >> 2], o[g + 8 >> 2] = 0 - k, T = o[g + 140 >> 2], o[g + 4 >> 2] = 0 - T, O(g, g), I = kA(S = o[g + 4 >> 2], x = S >> 31, Y = X << 1, cA = Y >> 31), C = h, B = kA(f = o[g >> 2], d = f >> 31, r, K = r >> 31), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (i = kA(a = o[g + 8 >> 2], V = a >> 31, D, v = D >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = B, B = kA(m = o[g + 12 >> 2], AA = m >> 31, BA = j << 1, eA = BA >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(Z = o[g + 16 >> 2], QA = Z >> 31, k, L = k >> 31), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, JA = i = o[g + 20 >> 2], s = kA(i, DA = i >> 31, iA = T << 1, tA = iA >> 31), B = h + I | 0, B = (C = s + C | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, UA = p = o[g + 24 >> 2], I = (Q = kA(p, MA = p >> 31, s = Q + 1 | 0, R = s >> 31)) + C | 0, C = h + B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, yA = o[g + 28 >> 2], B = (Q = kA(M = c(yA, 19), gA = M >> 31, EA = z << 1, wA = EA >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = B, LA = o[g + 32 >> 2], B = kA(t = c(LA, 19), $ = t >> 31, F, u = F >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, RA = o[g + 36 >> 2], B = kA(n = c(RA, 19), l = n >> 31, oA = q << 1, hA = oA >> 31), I = h + I | 0, y = C = B + C | 0, Q = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(D, v, S, x), C = h, e = kA(f, d, X, nA = X >> 31), B = h + C | 0, B = (I = e + I | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(a, V, j, sA = j >> 31), C = h + B | 0, C = (I = e + I | 0) >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(k, L, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(Z, QA, T, FA = T >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(s, R, i, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = kA(p = c(p, 19), aA = p >> 31, z, SA = z >> 31), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(F, u, M, gA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(t, $, q, HA = q >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(r, K, n, l), I = h + I | 0, YA = C = C + B | 0, CA = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(S, x, BA, eA), B = h, C = (e = kA(f, d, D, v)) + I | 0, I = h + B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, e = kA(k, L, a, V), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(m, AA, iA, tA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(s, R, Z, QA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(e = c(i, 19), GA = e >> 31, EA, wA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, p, aA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, i = kA(M, gA, oA, hA), B = h + I | 0, B = (C = i + C | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, I = (i = kA(r, K, t, $)) + C | 0, C = h + B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, B = (i = kA(n, l, Y, cA)) + I | 0, I = h + C | 0, uA = B, xA = I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, mA = B = B + 33554432 | 0, lA = I = B >>> 0 < 33554432 ? I + 1 | 0 : I, B = (67108863 & I) << 6 | B >>> 26, I = (I >> 26) + CA | 0, YA = i = B + YA | 0, I = B >>> 0 > i >>> 0 ? I + 1 | 0 : I, zA = i = i + 16777216 | 0, I = (C = (B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (B = (i = (33554431 & B) << 7 | i >>> 25) + y | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, J = C = B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 72 >> 2] = B - (-67108864 & C), I = kA(S, x, iA, tA), C = h, Q = kA(f, d, k, L), B = h + C | 0, B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(s, R, a, V)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Q = c(m, 19), _A = Q >> 31, EA, wA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(CA = c(Z, 19), pA = CA >> 31, F, u)) + C | 0, C = h + I | 0, C = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, y = kA(oA, hA, e, GA), I = h + C | 0, I = (B = y + B | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, C = (y = kA(r, K, p, aA)) + B | 0, B = h + I | 0, B = C >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = kA(M, gA, Y, cA), I = h + B | 0, I = (C = y + C | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, B = kA(D, v, t, $), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(n, l, BA, eA)) + C | 0, C = h + I | 0, N = B, KA = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, I = kA(s, R, S, x), C = h, B = (y = kA(f, d, T, FA)) + I | 0, I = h + C | 0, I = B >>> 0 < y >>> 0 ? I + 1 | 0 : I, y = C = c(a, 19), C = (_ = kA(C, NA = C >> 31, z, SA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(Q, _A, F, u), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(CA, pA, q, HA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = kA(r, K, e, GA)) + C | 0, C = h + I | 0, C = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = kA(p, aA, X, nA), I = h + C | 0, I = (B = _ + B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = kA(D, v, M, gA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(t, $, j, sA), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(k, L, n, l), I = h + I | 0, bA = C = B + C | 0, _ = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(I = c(S, 19), I >> 31, EA, wA), C = h, B = kA(f, d, s, R), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (y = kA(y, NA, F, u)) + I | 0, I = h + C | 0, C = (Q = kA(Q, _A, oA, hA)) + B | 0, B = h + (B >>> 0 < y >>> 0 ? I + 1 | 0 : I) | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(r, K, CA, pA), I = h + B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Y, cA, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(D, v, p, aA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = kA(M, gA, BA, eA), I = h + C | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = kA(k, L, t, $)) + B | 0, B = h + I | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(n, l, iA, tA), I = h + B | 0, y = C = Q + C | 0, _A = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, NA = C = C + 33554432 | 0, qA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = B + _ | 0, _ = Q = I + bA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, bA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + KA | 0, I = (C = Q + N | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = C, KA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 56 >> 2] = B - (-67108864 & C), I = kA(r, K, S, x), B = h, C = (N = kA(f, d, q, HA)) + I | 0, I = h + B | 0, I = C >>> 0 < N >>> 0 ? I + 1 | 0 : I, B = kA(a, V, X, nA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(D, v, m, AA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = kA(Z, QA, j, sA), B = h + I | 0, B = (C = N + C | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, I = (N = kA(k, L, JA, DA)) + C | 0, C = h + B | 0, C = I >>> 0 < N >>> 0 ? C + 1 | 0 : C, B = (N = kA(T, FA, UA, MA)) + I | 0, I = h + C | 0, I = B >>> 0 < N >>> 0 ? I + 1 | 0 : I, C = B, B = kA(yA, PA = yA >> 31, s, R), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(t, $, z, SA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = (B = C) + (C = kA(F, u, n, l)) | 0, B = h + I | 0, C = (I = i >> 26) + (C = C >>> 0 > N >>> 0 ? B + 1 | 0 : B) | 0, J = B = (i = (67108863 & i) << 6 | J >>> 26) + N | 0, I = C = B >>> 0 < i >>> 0 ? C + 1 | 0 : C, N = B = B + 16777216 | 0, i = I = B >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 76 >> 2] = J - (-33554432 & B), I = kA(k, L, S, x), C = h, J = kA(f, d, j, sA), B = h + C | 0, B = (I = J + I | 0) >>> 0 < J >>> 0 ? B + 1 | 0 : B, J = kA(a, V, T, FA), C = h + B | 0, C = (I = J + I | 0) >>> 0 < J >>> 0 ? C + 1 | 0 : C, B = (J = kA(s, R, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < J >>> 0 ? I + 1 | 0 : I, C = B, B = kA(CA, pA, z, SA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, C = (p = kA(p, aA, q, HA)) + C | 0, B = h + I | 0, I = (M = kA(r, K, M, gA)) + C | 0, C = h + (C >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, B = (t = kA(t, $, X, nA)) + I | 0, I = h + (I >>> 0 < M >>> 0 ? C + 1 | 0 : C) | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(D, v, n, l), I = h + I | 0, J = C = C + B | 0, I = (I = C >>> 0 < B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, t = Q = J + (B = (67108863 & Q) << 6 | KA >>> 26) | 0, I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, M = C = Q + 16777216 | 0, Q = B = C >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 60 >> 2] = t - (-33554432 & C), I = kA(S, x, oA, hA), B = h, C = (t = kA(f, d, F, u)) + I | 0, I = h + B | 0, I = C >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = kA(r, K, a, V), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, t = kA(m, AA, Y, cA), B = h + I | 0, B = (C = t + C | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, I = (t = kA(D, v, Z, QA)) + C | 0, C = h + B | 0, C = I >>> 0 < t >>> 0 ? C + 1 | 0 : C, B = (t = kA(BA, eA, JA, DA)) + I | 0, I = h + C | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(k, L, UA, MA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = C, C = kA(iA, tA, yA, PA), I = h + I | 0, I = C >>> 0 > (B = B + C | 0) >>> 0 ? I + 1 | 0 : I, t = C = LA, C = (Y = kA(C, p = C >> 31, s, R)) + B | 0, B = h + I | 0, I = (n = kA(n, l, EA, wA)) + C | 0, C = h + (C >>> 0 < Y >>> 0 ? B + 1 | 0 : B) | 0, B = I >>> 0 < n >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + B | 0, I = (C = C + (i = (33554431 & i) << 7 | N >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, B = C, n = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 80 >> 2] = B - (-67108864 & C), C = Q >> 25, B = (Q = (33554431 & Q) << 7 | M >>> 25) + (uA - (I = -67108864 & mA) | 0) | 0, I = C + (xA - ((I >>> 0 > uA >>> 0) + lA | 0) | 0) | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (Y = YA - (-33554432 & zA) | 0) | 0, o[g + 68 >> 2] = I, o[g + 64 >> 2] = B - (-67108864 & C), I = kA(F, u, S, x), B = h, C = (Q = kA(f, d, z, SA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (Q = kA(a, V, q, HA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = kA(r, K, m, AA)) + B | 0, B = h + C | 0, B = I >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(Z, QA, X, nA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(D, v, JA, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(j, sA, UA, MA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(k, L, yA, PA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = kA(t, p, T, FA)) + B | 0, B = h + C | 0, B = I >>> 0 > Q >>> 0 ? B + 1 | 0 : B, C = Q, Q = kA(I = RA, I >> 31, s, R), I = h + B | 0, B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (B = B + (i = (67108863 & i) << 6 | n >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 84 >> 2] = B - (-33554432 & C), i = _ - (-33554432 & bA) | 0, Q = y - (B = -67108864 & NA) | 0, f = _A - ((B >>> 0 > y >>> 0) + qA | 0) | 0, I = kA((33554431 & (B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = h + f | 0, I = I >>> 0 > (B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, o[g + 52 >> 2] = I, o[g + 48 >> 2] = B - (-67108864 & C), IA(A, g + 48 | 0));
                                            }
                                            return w = g + 256 | 0, 0 | vA;
                                        },
                                        Yb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return w = g = w + -64 | 0, aA(g, I |= 0, 32, 0), E[0 | g] = 248 & a[0 | g], E[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = o[g + 20 >> 2], C = o[g + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[g + 12 >> 2], C = o[g + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[g + 4 >> 2], C = o[g >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[g + 28 >> 2], C = o[g + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, iI(g, 64), w = g - -64 | 0, 0;
                                        },
                                        Zb: function() {
                                            var A, I;
                                            return w = A = w - 16 | 0, E[A + 15 | 0] = 0, I = 0 | r(35256, A + 15 | 0, 0), w = A + 16 | 0, 0 | I;
                                        },
                                        _b: mA,
                                        $b: function(A) {
                                            var I, g = 0, C = 0;
                                            if (w = I = w - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; E[I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(35256, I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return w = I + 16 | 0, 0 | g;
                                        },
                                        ac: HA,
                                        bc: function(A, I, g) {
                                            ZA(A |= 0, I |= 0, 1024, g |= 0);
                                        },
                                        cc: aI,
                                        dc: function() {
                                            var A = 0, I = 0;
                                            return (A = o[9004]) && (A = o[A + 20 >> 2]) && (I = 0 | wI[0 | A]()), 0 | I;
                                        },
                                        ec: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0, i = 0, o = 0;
                                            if (w = C = w - 16 | 0, g |= 0) D(1240, 1100, 197, 1036), Q();
                                            else {
                                                if (I) for(; E[C + 15 | 0] = 0, i = A + B | 0, o = 0 | r(35256, C + 15 | 0, 0), E[0 | i] = o, (0 | I) != (0 | (B = B + 1 | 0)););
                                                w = C + 16 | 0;
                                            }
                                        },
                                        fc: function(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var B = 0, i = 0, o = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; B = (I << 1) + A | 0, i = 15 & (o = a[I + g | 0]), E[B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = B, B = o >>> 4 | 0, E[0 | i] = 87 + ((B + 65526 >>> 8 & 217) + B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return E[I + A | 0] = 0, 0 | A;
                                            }
                                            zA(), Q();
                                        },
                                        gc: function(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((y = (65526 + (e = (223 & (D = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (D ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                        if (e = e & y | D & w, 255 & r ? (E[A + t | 0] = B | e, t = t + 1 | 0) : B = e << 4, r ^= -1, (0 | (f = f + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    f = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            E: {
                                                                                o: {
                                                                                    a: {
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = r = f + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                                        if (c = e & D | y & w, !(255 & r)) break o;
                                                                                        E[A + t | 0] = c | n, t = t + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = f + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break E;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= t >>> 0) break i;
                                                                                    c = e & D | y & w;
                                                                                }
                                                                                n = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            f = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((f = f + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            o[9005] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    o[9005] = 28, h = -1, f = f - 1 | 0, t = 0;
                                                    break A;
                                                }
                                                c || (t = 0, h = -1);
                                            }
                                            return i ? o[i >> 2] = g + f : (0 | C) != (0 | f) && (o[9005] = 28, h = -1), Q && (o[Q >> 2] = t), 0 | h;
                                        },
                                        hc: function(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (zA(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        ic: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var i = 0, o = 0, f = 0, e = 0, r = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        if (1 == (-7 & (B |= 0)) && (r = (o = (C >>> 0) / 3 | 0) << 2, (o = c(o, -3) + C | 0) && (r = 2 & B ? (2 | r) + (o >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                            if (!(4 & B)) {
                                                                                if (!C) {
                                                                                    B = 0;
                                                                                    break C;
                                                                                }
                                                                                B = 0;
                                                                                break i;
                                                                            }
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            for(B = 0;;){
                                                                                for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 45 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 32705 ^ -1) >>> 8 & 95 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                                if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                            }
                                                                            if (!e) break B;
                                                                            o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 32705 | 0, y = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                            break Q;
                                                                        }
                                                                        zA(), Q();
                                                                    }
                                                                    for(;;){
                                                                        for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 43 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 16321 ^ -1) >>> 8 & 47 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                        if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    if (!e) break B;
                                                                    o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 16321 | 0, y = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                                }
                                                                E[A + B | 0] = g | (-1 ^ t) >>> 8 & y | o | e | C, B = B + 1 | 0;
                                                            }
                                                            if (B >>> 0 > r >>> 0) break g;
                                                        }
                                                        if (B >>> 0 < r >>> 0) break I;
                                                        r = B;
                                                        break A;
                                                    }
                                                    D(1048, 1126, 231, 1319), Q();
                                                }
                                                dA(A + B | 0, 61, r - B | 0);
                                            }
                                            return dA(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                        },
                                        jc: function(A, I, g, C, B, i, f, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, f |= 0;
                                            var e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        if (1 == (-7 & (c |= 0))) {
                                                                                            if (D = 0, !C) break E;
                                                                                            if (4 & c) break f;
                                                                                            for(;;){
                                                                                                D = r;
                                                                                                c: {
                                                                                                    e: {
                                                                                                        r: {
                                                                                                            D: {
                                                                                                                for(;;){
                                                                                                                    if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16336 ^ t) ^ -1) >>> 8 & 63 | (1 + (16340 ^ t) ^ -1) >>> 8 & 62, 255 != (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) break D;
                                                                                                                    if (e = 0, !B) break o;
                                                                                                                    if (!BA(B, t)) break;
                                                                                                                    if ((D = D + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                                }
                                                                                                                r = D;
                                                                                                                break o;
                                                                                                            }
                                                                                                            if (h = e + (h << 6) | 0, y >>> 0 > 1) break e;
                                                                                                            y = y + 6 | 0;
                                                                                                            break c;
                                                                                                        }
                                                                                                        r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                        break o;
                                                                                                    }
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, !((r = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                            }
                                                                                            break o;
                                                                                        }
                                                                                        zA(), Q();
                                                                                    }
                                                                                    f: for(;;){
                                                                                        for(D = r;;){
                                                                                            c: {
                                                                                                if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16288 ^ t) ^ -1) >>> 8 & 63 | (1 + (16338 ^ t) ^ -1) >>> 8 & 62, 255 == (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) {
                                                                                                    if (e = 0, !B) break o;
                                                                                                    if (BA(B, t)) break c;
                                                                                                    r = D;
                                                                                                    break o;
                                                                                                }
                                                                                                if (h = e + (h << 6) | 0, y >>> 0 < 2) y = y + 6 | 0;
                                                                                                else {
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, (r = D + 1 | 0) >>> 0 < C >>> 0) continue f;
                                                                                                break o;
                                                                                            }
                                                                                            if (!((D = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                    break o;
                                                                                }
                                                                                r = D, o[9005] = 68, e = 1;
                                                                            }
                                                                            if (y >>> 0 > 4) break i;
                                                                            D = r;
                                                                        }
                                                                        if (A = D, I = -1, e) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if ((-1 << y ^ -1) & h) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if (2 & c) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (y >>> 0 < 2) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (r = A >>> 0 > C >>> 0 ? A : C, D = y >>> 1 | 0, !B) break Q;
                                                                        for(c = A;;){
                                                                            if ((0 | c) == (0 | r)) {
                                                                                e = 68;
                                                                                break C;
                                                                            }
                                                                            if (61 != (0 | (A = E[g + c | 0]))) {
                                                                                if (!BA(B, A)) {
                                                                                    e = 28, r = c;
                                                                                    break C;
                                                                                }
                                                                            } else D = D - 1 | 0;
                                                                            if (c = c + 1 | 0, !D) break;
                                                                        }
                                                                        break B;
                                                                    }
                                                                    I = -1;
                                                                    break A;
                                                                }
                                                                if (e = 68, A >>> 0 >= C >>> 0) break C;
                                                                if (61 != a[A + g | 0]) {
                                                                    r = A, e = 28;
                                                                    break C;
                                                                }
                                                                if (c = A + D | 0, 1 != (0 | D)) {
                                                                    if ((0 | (y = A + 1 | 0)) == (0 | r)) break C;
                                                                    if (61 != a[g + y | 0]) {
                                                                        r = y, e = 28;
                                                                        break C;
                                                                    }
                                                                    if (2 != (0 | D)) {
                                                                        if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                        if (e = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                    }
                                                                }
                                                            }
                                                            if (I = 0, B) break g;
                                                            break I;
                                                        }
                                                        o[9005] = e;
                                                        break A;
                                                    }
                                                    if (!(C >>> 0 <= c >>> 0)) {
                                                        for(;;){
                                                            if (!BA(B, E[g + c | 0])) break I;
                                                            if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                        }
                                                        c = C;
                                                    }
                                                }
                                                r = c, n = w;
                                            }
                                            return f ? o[f >> 2] = g + r : (0 | C) != (0 | r) && (o[9005] = 28, I = -1), i && (o[i >> 2] = n), 0 | I;
                                        },
                                        kc: function() {
                                            var A = 0;
                                            return o[9136] ? A = 1 : (mA(), HA(36528, 16), o[9136] = 1, A = 0), 0 | A;
                                        },
                                        lc: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, f = 0, c = 0, e = 0;
                                            w = i = w - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((f = C - 1 | 0) & C ? (c = -1 ^ g, f = f - ((g >>> 0) % (C >>> 0) | 0) | 0) : f &= c = -1 ^ g, c >>> 0 <= f >>> 0) break A;
                                                    if (c = -1, !((g = g + f | 0) >>> 0 >= B >>> 0)) for(A && (o[A >> 2] = g + 1), A = I + g | 0, c = 0, E[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, e = a[0 | I] & a[i + 15 | 0], I = (g ^ f) - 1 >>> 24 | 0, E[0 | B] = e | 128 & I, E[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return w = i + 16 | 0, 0 | c;
                                            }
                                            zA(), Q();
                                        },
                                        mc: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0, i = 0, E = 0, f = 0, c = 0;
                                            if (o[12 + (B = w - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; f = ((128 ^ (i = a[c - g | 0])) - 1 & o[B + 12 >> 2] - 1 & E - 1) >>> 8 & 1, o[B + 12 >> 2] = o[B + 12 >> 2] | 0 - f & g, I |= f, E |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                o[A >> 2] = Q - o[B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        nc: function() {
                                            return 1312;
                                        },
                                        oc: function() {
                                            return 26;
                                        },
                                        pc: rI,
                                        qc: rI,
                                        rc: function(A) {
                                            var I, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, c = 0, r = 0, D = 0, t = 0, y = 0, h = 0;
                                            w = I = w - 16 | 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                r: {
                                                                                                    if ((A |= 0) >>> 0 <= 244) {
                                                                                                        if (3 & (g = (E = o[9006]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                            g = 36064 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, B = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[B + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (y = 36024, h = RA(-2, C) & E, o[y >> 2] = h), A = B + 8 | 0, g = C << 3, o[B + 4 >> 2] = 3 | g, o[4 + (g = g + B | 0) >> 2] = 1 | o[g + 4 >> 2];
                                                                                                            break A;
                                                                                                        }
                                                                                                        if ((t = o[9008]) >>> 0 >= c >>> 0) break r;
                                                                                                        if (g) {
                                                                                                            g = 36064 + (A = (B = TA((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[Q + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (E = RA(-2, B) & E, o[9006] = E), o[Q + 4 >> 2] = 3 | c, B = (A = B << 3) - c | 0, o[4 + (C = Q + c | 0) >> 2] = 1 | B, o[A + Q >> 2] = B, t && (g = 36064 + (-8 & t) | 0, i = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = i, o[A + 12 >> 2] = i, o[i + 12 >> 2] = g, o[i + 8 >> 2] = A), A = Q + 8 | 0, o[9011] = C, o[9008] = B;
                                                                                                            break A;
                                                                                                        }
                                                                                                        if (!(D = o[9007])) break r;
                                                                                                        for(C = o[36328 + (TA(D) << 2) >> 2], i = (-8 & o[C + 4 >> 2]) - c | 0, g = C; (A = o[g + 16 >> 2]) || (A = o[g + 20 >> 2]);)i = (B = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = B ? A : C, g = A;
                                                                                                        if (r = o[C + 24 >> 2], (0 | (B = o[C + 12 >> 2])) != (0 | C)) {
                                                                                                            A = o[C + 8 >> 2], o[A + 12 >> 2] = B, o[B + 8 >> 2] = A;
                                                                                                            break I;
                                                                                                        }
                                                                                                        if (!(A = o[(g = C + 20 | 0) >> 2])) {
                                                                                                            if (!(A = o[C + 16 >> 2])) break e;
                                                                                                            g = C + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, B = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = B + 16 | 0, A = o[B + 16 >> 2]););
                                                                                                        o[Q >> 2] = 0;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), D = o[9007])) {
                                                                                                        i = 0 - c | 0, E = 0, c >>> 0 < 256 || (E = 31, c >>> 0 > 16777215 || (E = 62 + ((c >>> 38 - (A = e(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                if (g = o[36328 + (E << 2) >> 2]) for(A = 0, C = c << (31 != (0 | E) ? 25 - (E >>> 1 | 0) | 0 : 0);;){
                                                                                                                    if (!((Q = (-8 & o[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (B = g, i = Q, Q))) {
                                                                                                                        i = 0, A = g;
                                                                                                                        break t;
                                                                                                                    }
                                                                                                                    if (Q = o[g + 20 >> 2], g = o[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                                }
                                                                                                                else A = 0;
                                                                                                                if (!(A | B)) {
                                                                                                                    if (B = 0, !(A = (0 - (A = 2 << E) | A) & D)) break r;
                                                                                                                    A = o[36328 + (TA(A) << 2) >> 2];
                                                                                                                }
                                                                                                                if (!A) break D;
                                                                                                            }
                                                                                                            for(; i = (C = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, B = C ? A : B, A = (g = o[A + 16 >> 2]) || o[A + 20 >> 2];);
                                                                                                        }
                                                                                                        if (!(!B | o[9008] - c >>> 0 <= i >>> 0)) {
                                                                                                            if (E = o[B + 24 >> 2], (0 | B) != (0 | (C = o[B + 12 >> 2]))) {
                                                                                                                A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[C + 8 >> 2] = A;
                                                                                                                break g;
                                                                                                            }
                                                                                                            if (!(A = o[(g = B + 20 | 0) >> 2])) {
                                                                                                                if (!(A = o[B + 16 >> 2])) break c;
                                                                                                                g = B + 16 | 0;
                                                                                                            }
                                                                                                            for(; Q = g, C = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = o[C + 16 >> 2]););
                                                                                                            o[Q >> 2] = 0;
                                                                                                            break g;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                if ((A = o[9008]) >>> 0 >= c >>> 0) {
                                                                                                    B = o[9011], (g = A - c | 0) >>> 0 >= 16 ? (o[4 + (C = B + c | 0) >> 2] = 1 | g, o[A + B >> 2] = g, o[B + 4 >> 2] = 3 | c) : (o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2], C = 0, g = 0), o[9008] = g, o[9011] = C, A = B + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if ((r = o[9009]) >>> 0 > c >>> 0) {
                                                                                                    g = r - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if (A = 0, D = c + 47 | 0, o[9124] ? C = o[9126] : (o[9127] = -1, o[9128] = -1, o[9125] = 4096, o[9126] = 4096, o[9124] = I + 12 & -16 ^ 1431655768, o[9129] = 0, o[9117] = 0, C = 4096), (g = (Q = D + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                                if ((B = o[9116]) && B >>> 0 < (E = (C = o[9114]) + g | 0) >>> 0 | C >>> 0 >= E >>> 0) break A;
                                                                                                r: {
                                                                                                    if (!(4 & a[36468])) {
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                y: {
                                                                                                                    w: {
                                                                                                                        if (B = o[9012]) for(A = 36472;;){
                                                                                                                            if ((C = o[A >> 2]) >>> 0 <= B >>> 0 & B >>> 0 < C + o[A + 4 >> 2] >>> 0) break w;
                                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                                        }
                                                                                                                        if (-1 == (0 | (C = _A(0)))) break D;
                                                                                                                        if (E = g, (A = (B = o[9125]) - 1 | 0) & C && (E = (g - C | 0) + (A + C & 0 - B) | 0), E >>> 0 <= c >>> 0) break D;
                                                                                                                        if ((B = o[9116]) && B >>> 0 < (i = (A = o[9114]) + E | 0) >>> 0 | A >>> 0 >= i >>> 0) break D;
                                                                                                                        if ((0 | C) != (0 | (A = _A(E)))) break y;
                                                                                                                        break r;
                                                                                                                    }
                                                                                                                    if ((0 | (C = _A(E = i & Q - r))) == (o[A >> 2] + o[A + 4 >> 2] | 0)) break t;
                                                                                                                    A = C;
                                                                                                                }
                                                                                                                if (-1 == (0 | A)) break D;
                                                                                                                if (c + 48 >>> 0 <= E >>> 0) {
                                                                                                                    C = A;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if (-1 == (0 | _A(C = (C = o[9126]) + (D - E | 0) & 0 - C))) break D;
                                                                                                                E = C + E | 0, C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 != (0 | C)) break r;
                                                                                                        }
                                                                                                        o[9117] = 4 | o[9117];
                                                                                                    }
                                                                                                    if (-1 == (0 | (C = _A(g))) | -1 == (0 | (A = _A(0))) | A >>> 0 <= C >>> 0) break o;
                                                                                                    if ((E = A - C | 0) >>> 0 <= c + 40 >>> 0) break o;
                                                                                                }
                                                                                                A = o[9114] + E | 0, o[9114] = A, A >>> 0 > f[9115] && (o[9115] = A);
                                                                                                r: {
                                                                                                    if (Q = o[9012]) {
                                                                                                        for(A = 36472;;){
                                                                                                            if (((B = o[A >> 2]) + (g = o[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                        }
                                                                                                        break f;
                                                                                                    }
                                                                                                    for((A = o[9010]) >>> 0 <= C >>> 0 && A || (o[9010] = C), A = 0, o[9119] = E, o[9118] = C, o[9014] = -1, o[9015] = o[9124], o[9121] = 0; g = 36064 + (B = A << 3) | 0, o[B + 36072 >> 2] = g, o[B + 36076 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                    g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                    break a;
                                                                                                }
                                                                                                if (8 & o[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | B >>> 0 > Q >>> 0) break f;
                                                                                                o[A + 4 >> 2] = g + E, C = (A = -8 - Q & 7) + Q | 0, o[9012] = C, A = (g = o[9009] + E | 0) - A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[4 + (g + Q | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                break a;
                                                                                            }
                                                                                            B = 0;
                                                                                            break I;
                                                                                        }
                                                                                        C = 0;
                                                                                        break g;
                                                                                    }
                                                                                    f[9010] > C >>> 0 && (o[9010] = C), g = C + E | 0, A = 36472;
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                for(;;){
                                                                                                    if ((0 | g) != o[A >> 2]) {
                                                                                                        if (A = o[A + 8 >> 2]) continue;
                                                                                                        break e;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                if (!(8 & a[A + 12 | 0])) break c;
                                                                                            }
                                                                                            for(A = 36472;;){
                                                                                                if ((g = o[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + o[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break f;
                                                                                                A = o[A + 8 >> 2];
                                                                                            }
                                                                                        }
                                                                                        if (o[A >> 2] = C, o[A + 4 >> 2] = o[A + 4 >> 2] + E, o[4 + (D = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (E = g + (-8 - g & 7) | 0) - (r = c + D | 0) | 0, (0 | Q) == (0 | E)) {
                                                                                            o[9012] = r, A = o[9009] + A | 0, o[9009] = A, o[r + 4 >> 2] = 1 | A;
                                                                                            break C;
                                                                                        }
                                                                                        if (o[9011] == (0 | E)) {
                                                                                            o[9011] = r, A = o[9008] + A | 0, o[9008] = A, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A;
                                                                                            break C;
                                                                                        }
                                                                                        if (1 != (3 & (i = o[E + 4 >> 2]))) break B;
                                                                                        if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                            if ((0 | (C = o[E + 12 >> 2])) == (0 | (g = o[E + 8 >> 2]))) {
                                                                                                y = 36024, h = o[9006] & RA(-2, i >>> 3 | 0), o[y >> 2] = h;
                                                                                                break Q;
                                                                                            }
                                                                                            o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break Q;
                                                                                        }
                                                                                        if (c = o[E + 24 >> 2], (0 | E) != (0 | (C = o[E + 12 >> 2]))) {
                                                                                            g = o[E + 8 >> 2], o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break i;
                                                                                        }
                                                                                        if (!(i = o[(g = E + 20 | 0) >> 2])) {
                                                                                            if (!(i = o[E + 16 >> 2])) break E;
                                                                                            g = E + 16 | 0;
                                                                                        }
                                                                                        for(; B = g, (i = o[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = o[C + 16 >> 2]););
                                                                                        o[B >> 2] = 0;
                                                                                        break i;
                                                                                    }
                                                                                    for(g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128], o[(B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = o[9121], o[B + 16 >> 2] = o[9120], o[B + 20 >> 2] = A, A = o[9119], o[B + 8 >> 2] = o[9118], o[B + 12 >> 2] = A, o[9120] = B + 8, o[9119] = E, o[9118] = C, o[9121] = 0, A = B + 24 | 0; o[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                    if ((0 | B) != (0 | Q)) {
                                                                                        if (o[B + 4 >> 2] = -2 & o[B + 4 >> 2], i = B - Q | 0, o[Q + 4 >> 2] = 1 | i, o[B >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        else {
                                                                                            A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                                                            f: {
                                                                                                if ((B = o[9007]) & (C = 1 << A)) {
                                                                                                    for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), B = o[g >> 2];;){
                                                                                                        if ((0 | i) == (-8 & o[(g = B) + 4 >> 2])) break f;
                                                                                                        if (C = A >>> 29 | 0, A <<= 1, !(B = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                    }
                                                                                                    o[C + 16 >> 2] = Q;
                                                                                                } else o[9007] = C | B, o[g >> 2] = Q;
                                                                                                o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                                                                break a;
                                                                                            }
                                                                                            A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (!((A = o[9009]) >>> 0 <= c >>> 0)) {
                                                                                    g = A - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                    break A;
                                                                                }
                                                                            }
                                                                            o[9005] = 48, A = 0;
                                                                            break A;
                                                                        }
                                                                        C = 0;
                                                                    }
                                                                    if (c) {
                                                                        B = o[E + 28 >> 2];
                                                                        i: {
                                                                            if (o[(g = 36328 + (B << 2) | 0) >> 2] == (0 | E)) {
                                                                                if (o[g >> 2] = C, C) break i;
                                                                                y = 36028, h = o[9007] & RA(-2, B), o[y >> 2] = h;
                                                                                break Q;
                                                                            }
                                                                            if (o[c + (o[c + 16 >> 2] == (0 | E) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                        }
                                                                        o[C + 24 >> 2] = c, (g = o[E + 16 >> 2]) && (o[C + 16 >> 2] = g, o[g + 24 >> 2] = C), (g = o[E + 20 >> 2]) && (o[C + 20 >> 2] = g, o[g + 24 >> 2] = C);
                                                                    }
                                                                }
                                                                A = A + Q | 0, i = o[4 + (E = Q + E | 0) >> 2];
                                                            }
                                                            if (o[E + 4 >> 2] = -2 & i, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A, A >>> 0 <= 255) g = 36064 + (-8 & A) | 0, (C = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = r, o[A + 12 >> 2] = r, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            else {
                                                                i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = e(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), o[r + 28 >> 2] = i, o[r + 16 >> 2] = 0, o[r + 20 >> 2] = 0, g = 36328 + (i << 2) | 0;
                                                                B: {
                                                                    if ((B = o[9007]) & (C = 1 << i)) {
                                                                        for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = o[g >> 2];;){
                                                                            if (g = C, (-8 & o[C + 4 >> 2]) == (0 | A)) break B;
                                                                            if (B = i >>> 29 | 0, i <<= 1, !(C = o[16 + (B = (4 & B) + C | 0) >> 2])) break;
                                                                        }
                                                                        o[B + 16 >> 2] = r;
                                                                    } else o[9007] = C | B, o[g >> 2] = r;
                                                                    o[r + 24 >> 2] = g, o[r + 12 >> 2] = r, o[r + 8 >> 2] = r;
                                                                    break C;
                                                                }
                                                                A = o[g + 8 >> 2], o[A + 12 >> 2] = r, o[g + 8 >> 2] = r, o[r + 24 >> 2] = 0, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            }
                                                        }
                                                        A = D + 8 | 0;
                                                        break A;
                                                    }
                                                    g: if (E) {
                                                        g = o[B + 28 >> 2];
                                                        C: {
                                                            if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | B)) {
                                                                if (o[A >> 2] = C, C) break C;
                                                                D = RA(-2, g) & D, o[9007] = D;
                                                                break g;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | B) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        o[C + 24 >> 2] = E, (A = o[B + 16 >> 2]) && (o[C + 16 >> 2] = A, o[A + 24 >> 2] = C), (A = o[B + 20 >> 2]) && (o[C + 20 >> 2] = A, o[A + 24 >> 2] = C);
                                                    }
                                                    g: if (i >>> 0 <= 15) A = i + c | 0, o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2];
                                                    else if (o[B + 4 >> 2] = 3 | c, o[4 + (Q = B + c | 0) >> 2] = 1 | i, o[Q + i >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    else {
                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                        C: {
                                                            if ((C = 1 << A) & D) {
                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = o[g >> 2];;){
                                                                    if ((-8 & o[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                    if (C = A >>> 29 | 0, A <<= 1, !(c = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                }
                                                                o[C + 16 >> 2] = Q;
                                                            } else o[9007] = C | D, o[g >> 2] = Q;
                                                            o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                            break g;
                                                        }
                                                        A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    }
                                                    A = B + 8 | 0;
                                                    break A;
                                                }
                                                I: if (r) {
                                                    g = o[C + 28 >> 2];
                                                    g: {
                                                        if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (o[A >> 2] = B, B) break g;
                                                            y = 36028, h = RA(-2, g) & D, o[y >> 2] = h;
                                                            break I;
                                                        }
                                                        if (o[r + (o[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = B, !B) break I;
                                                    }
                                                    o[B + 24 >> 2] = r, (A = o[C + 16 >> 2]) && (o[B + 16 >> 2] = A, o[A + 24 >> 2] = B), (A = o[C + 20 >> 2]) && (o[B + 20 >> 2] = A, o[A + 24 >> 2] = B);
                                                }
                                                i >>> 0 <= 15 ? (A = i + c | 0, o[C + 4 >> 2] = 3 | A, o[4 + (A = A + C | 0) >> 2] = 1 | o[A + 4 >> 2]) : (o[C + 4 >> 2] = 3 | c, o[4 + (B = C + c | 0) >> 2] = 1 | i, o[B + i >> 2] = i, t && (g = 36064 + (-8 & t) | 0, Q = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A), o[9011] = B, o[9008] = i), A = C + 8 | 0;
                                            }
                                            return w = I + 16 | 0, 0 | A;
                                        },
                                        sc: function(A) {
                                            var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, c = 0;
                                            A: if (A |= 0) {
                                                Q = (C = A - 8 | 0) + (A = -8 & (I = o[A - 4 >> 2])) | 0;
                                                I: if (!(1 & I)) {
                                                    if (!(3 & I)) break A;
                                                    if ((C = C - (I = o[C >> 2]) | 0) >>> 0 < f[9010]) break A;
                                                    A = A + I | 0;
                                                    g: {
                                                        C: {
                                                            if (o[9011] != (0 | C)) {
                                                                if (I >>> 0 <= 255) {
                                                                    if (B = I >>> 3 | 0, (0 | (I = o[C + 12 >> 2])) == (0 | (g = o[C + 8 >> 2]))) {
                                                                        a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                        break I;
                                                                    }
                                                                    o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break I;
                                                                }
                                                                if (E = o[C + 24 >> 2], (0 | C) != (0 | (I = o[C + 12 >> 2]))) {
                                                                    g = o[C + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break g;
                                                                }
                                                                if (!(g = o[(B = C + 20 | 0) >> 2])) {
                                                                    if (!(g = o[C + 16 >> 2])) break C;
                                                                    B = C + 16 | 0;
                                                                }
                                                                for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                o[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (I = o[Q + 4 >> 2]))) break I;
                                                            return o[9008] = A, o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, void (o[Q >> 2] = A);
                                                        }
                                                        I = 0;
                                                    }
                                                    if (E) {
                                                        g = o[C + 28 >> 2];
                                                        g: {
                                                            if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                                if (o[B >> 2] = I, I) break g;
                                                                a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                break I;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = I, !I) break I;
                                                        }
                                                        o[I + 24 >> 2] = E, (g = o[C + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[C + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                    }
                                                }
                                                if (!(C >>> 0 >= Q >>> 0) && 1 & (I = o[Q + 4 >> 2])) {
                                                    I: {
                                                        g: {
                                                            C: {
                                                                B: {
                                                                    if (!(2 & I)) {
                                                                        if (o[9012] == (0 | Q)) {
                                                                            if (o[9012] = C, A = o[9009] + A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[9011] != (0 | C)) break A;
                                                                            return o[9008] = 0, void (o[9011] = 0);
                                                                        }
                                                                        if (o[9011] == (0 | Q)) return o[9011] = C, A = o[9008] + A | 0, o[9008] = A, o[C + 4 >> 2] = 1 | A, void (o[A + C >> 2] = A);
                                                                        if (A = (-8 & I) + A | 0, I >>> 0 <= 255) {
                                                                            if (B = I >>> 3 | 0, (0 | (I = o[Q + 12 >> 2])) == (0 | (g = o[Q + 8 >> 2]))) {
                                                                                a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                                break g;
                                                                            }
                                                                            o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break g;
                                                                        }
                                                                        if (E = o[Q + 24 >> 2], (0 | Q) != (0 | (I = o[Q + 12 >> 2]))) {
                                                                            g = o[Q + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break C;
                                                                        }
                                                                        if (!(g = o[(B = Q + 20 | 0) >> 2])) {
                                                                            if (!(g = o[Q + 16 >> 2])) break B;
                                                                            B = Q + 16 | 0;
                                                                        }
                                                                        for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                        o[i >> 2] = 0;
                                                                        break C;
                                                                    }
                                                                    o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A;
                                                                    break I;
                                                                }
                                                                I = 0;
                                                            }
                                                            if (E) {
                                                                g = o[Q + 28 >> 2];
                                                                C: {
                                                                    if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                        if (o[B >> 2] = I, I) break C;
                                                                        a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                        break g;
                                                                    }
                                                                    if (o[E + (o[E + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = I, !I) break g;
                                                                }
                                                                o[I + 24 >> 2] = E, (g = o[Q + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[Q + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                            }
                                                        }
                                                        if (o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A, o[9011] == (0 | C)) return void (o[9008] = A);
                                                    }
                                                    if (A >>> 0 <= 255) return I = 36064 + (-8 & A) | 0, (g = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[I + 8 >> 2] : (o[9006] = A | g, A = I), o[I + 8 >> 2] = C, o[A + 12 >> 2] = C, o[C + 12 >> 2] = I, void (o[C + 8 >> 2] = A);
                                                    g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (I = e(A >>> 8 | 0)) & 1) - (I << 1) | 0) | 0), o[C + 28 >> 2] = g, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, I = 36328 + (g << 2) | 0;
                                                    I: {
                                                        g: {
                                                            if ((B = o[9007]) & (i = 1 << g)) {
                                                                for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), I = o[I >> 2];;){
                                                                    if (B = I, (-8 & o[I + 4 >> 2]) == (0 | A)) break g;
                                                                    if (i = g >>> 29 | 0, g <<= 1, !(I = o[16 + (i = I + (4 & i) | 0) >> 2])) break;
                                                                }
                                                                o[i + 16 >> 2] = C, o[C + 24 >> 2] = B;
                                                            } else o[9007] = B | i, o[I >> 2] = C, o[C + 24 >> 2] = I;
                                                            o[C + 12 >> 2] = C, o[C + 8 >> 2] = C;
                                                            break I;
                                                        }
                                                        A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[B + 8 >> 2] = C, o[C + 24 >> 2] = 0, o[C + 12 >> 2] = B, o[C + 8 >> 2] = A;
                                                    }
                                                    A = o[9014] - 1 | 0, o[9014] = A || -1;
                                                }
                                            }
                                        },
                                        tc: wI
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function(A, I) {
                            return {
                                then: function(g) {
                                    var C = new y.Module(A);
                                    g({
                                        instance: new y.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof y && d("no native wasm support detected");
                    var w, h, n, s, k, F, S, H = !1;
                    function G() {
                        var A = t.buffer;
                        Q.HEAP8 = w = new Int8Array(A), Q.HEAP16 = n = new Int16Array(A), Q.HEAPU8 = h = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = s = new Int32Array(A), Q.HEAPU32 = k = new Uint32Array(A), Q.HEAPF32 = F = new Float32Array(A), Q.HEAPF64 = S = new Float64Array(A);
                    }
                    var _ = Q.INITIAL_MEMORY || 16777216;
                    _ >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + _ + "! (STACK_SIZE=65536)"), t = Q.wasmMemory ? Q.wasmMemory : new y.Memory({
                        initial: _ / 65536,
                        maximum: 32768
                    }), G(), _ = t.buffer.byteLength;
                    var M = [], p = [], N = [], J = 0, U = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), D(A = "Aborted(" + A + ")"), H = !0, A += ". Build with -sASSERTIONS for more info.", new y.RuntimeError(A);
                    }
                    var K, b, P = "data:application/octet-stream;base64,";
                    function v(A) {
                        return A.startsWith(P);
                    }
                    v(K = "<<< WASM_BINARY_FILE >>>") || (b = K, K = Q.locateFile ? Q.locateFile(b, f) : f + b);
                    var L, R = {
                        35256: ()=>Q.getRandomValue(),
                        35292: ()=>{
                            if (void 0 === Q.getRandomValue) try {
                                var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                                    var A = new Uint32Array(1);
                                    return I.getRandomValues(A), A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("d259h")), B = function() {
                                        var A = C.randomBytes(4);
                                        return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, u = (A)=>{
                        for(; A.length > 0;)A.shift()(Q);
                    }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, m = (A, I)=>A ? ((A, I, g)=>{
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var E = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var o = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | E);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        })(h, A, I) : "", l = [], z = (A)=>{
                        var I = (A - t.buffer.byteLength + 65535) / 65536;
                        try {
                            return t.grow(I), G(), 1;
                        } catch (A) {}
                    }, q = {
                        c: (A, I, g, C)=>{
                            d(`Assertion failed: ${m(A)}, at: ` + [
                                I ? m(I) : "unknown filename",
                                g,
                                C ? m(C) : "unknown function"
                            ]);
                        },
                        d: ()=>{
                            d("");
                        },
                        b: (A, I, g)=>((A, I, g)=>{
                                var C = ((A, I)=>{
                                    var g;
                                    for(l.length = 0; g = h[A++];)I += 105 != g && I % 8 ? 4 : 0, l.push(105 == g ? s[I >> 2] : S[I >> 3]), I += 105 == g ? 4 : 8;
                                    return l;
                                })(I, g);
                                return R[A].apply(null, C);
                            })(A, I, g),
                        e: (A)=>{
                            var I = h.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (z(i)) return !0;
                            }
                            return !1;
                        },
                        a: t
                    }, X = function() {
                        var A, I, g = {
                            a: q
                        };
                        function C(A, I) {
                            var g, C = A.exports;
                            return (X = C).tc, g = X.f, p.unshift(g), function(A) {
                                if (J--, Q.monitorRunDependencies && Q.monitorRunDependencies(J), 0 == J && (null !== U && (clearInterval(U), U = null), Y)) {
                                    var I = Y;
                                    Y = null, I();
                                }
                            }(), C;
                        }
                        if (J++, Q.monitorRunDependencies && Q.monitorRunDependencies(J), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return D(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                        }
                        return A = g, I = function(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(()=>(function(A) {
                                    if (A == K && r) return new Uint8Array(r);
                                    var I = function(A) {
                                        if (v(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var I = $bb7e2ea50d670196$require$Buffer.from(A, "base64");
                                                return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                            }
                                            try {
                                                for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                                return C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(P.length));
                                    }(A);
                                    if (I) return I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                })(A));
                        })(K).then((I)=>y.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                            D(`failed to asynchronously prepare wasm: ${A}`), d(A);
                        }), {};
                    }();
                    function j() {
                        function A() {
                            L || (L = !0, Q.calledRun = !0, H || (u(p), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)A = Q.postRun.shift(), N.unshift(A);
                                var A;
                                u(N);
                            }()));
                        }
                        J > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)A = Q.preRun.shift(), M.unshift(A);
                            var A;
                            u(M);
                        }(), J > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = X.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = X.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = X.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = X.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = X.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = X.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = X.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = X.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = X.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = X.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = X.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = X.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = X.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = X.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = X.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = X.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = X.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = X.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = X.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = X.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = X.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = X.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = X.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = X.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = X.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = X.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = X.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = X.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = X.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = X.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = X.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = X.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = X.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = X.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = X.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = X.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = X.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = X.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = X.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = X.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = X.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = X.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = X.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = X.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = X.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = X.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = X._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = X.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = X.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = X.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = X.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = X.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = X.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = X.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = X.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = X.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = X.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = X.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = X.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = X.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = X.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = X.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = X.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = X.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = X.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = X.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = X.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = X.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = X.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = X.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = X.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = X.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = X.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = X.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = X.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = X.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = X.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = X.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = X.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = X.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = X.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = X.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = X.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = X.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = X.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = X.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = X.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = X.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = X.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = X.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = X.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = X.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = X.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = X.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = X.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = X.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = X.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = X.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = X.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = X.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = X._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = X.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = X.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = X.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = X.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = X.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = X.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = X.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = X.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = X.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = X.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = X.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = X.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = X.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = X.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = X.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = X.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = X.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = X.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = X.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = X.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = X.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = X.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = X.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = X.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = X.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = X.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = X.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = X.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = X.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = X.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = X.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = X.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = X.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = X.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = X.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = X.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = X.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = X.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = X.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = X.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = X.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = X.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = X.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = X.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = X.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = X.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = X.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = X.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = X.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = X.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = X.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = X.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = X.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = X._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = X.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = X.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = X.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = X.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = X.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = X.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = X.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = X.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = X.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = X.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = X.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = X.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = X.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = X.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = X.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = X.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = X.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = X.qc)(), Q._malloc = (A)=>(Q._malloc = X.rc)(A), Q._free = (A)=>(Q._free = X.sc)(A), Q.setValue = function(A, I, g = "i8") {
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                w[A >> 0] = I;
                                break;
                            case "i16":
                                n[A >> 1] = I;
                                break;
                            case "i32":
                                s[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                F[A >> 2] = I;
                                break;
                            case "double":
                                S[A >> 3] = I;
                                break;
                            case "*":
                                k[A >> 2] = I;
                                break;
                            default:
                                d(`invalid type for setValue: ${g}`);
                        }
                    }, Q.getValue = function(A, I = "i8") {
                        switch(I.endsWith("*") && (I = "*"), I){
                            case "i1":
                            case "i8":
                                return w[A >> 0];
                            case "i16":
                                return n[A >> 1];
                            case "i32":
                                return s[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return F[A >> 2];
                            case "double":
                                return S[A >> 3];
                            case "*":
                                return k[A >> 2];
                            default:
                                d(`invalid type for getValue: ${I}`);
                        }
                    }, Q.UTF8ToString = m, Y = function A() {
                        L || j(), L || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    j();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = false, f = "";
            if (a) {
                var c = (parcelRequire("80bNa")), e = (parcelRequire("80bNa"));
                f = o ? e.dirname(f) + "/" : $bb7e2ea50d670196$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                    var I = g(A, !0);
                    return I.buffer || (I = new Uint8Array(I)), I;
                }, !Q.thisProgram && $j1eoE.argv.length > 1 && $j1eoE.argv[1].replace(/\\/g, "/"), $j1eoE.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
            } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.send(null), I.responseText;
            }, o && (B = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
            }));
            Q.print;
            var r, D, t = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && U("no native wasm support detected");
            var y, w, h, n, s, k, F, S = !1;
            function H() {
                var A = D.buffer;
                Q.HEAP8 = y = new Int8Array(A), Q.HEAP16 = h = new Int16Array(A), Q.HEAPU8 = w = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = n = new Int32Array(A), Q.HEAPU32 = s = new Uint32Array(A), Q.HEAPF32 = k = new Float32Array(A), Q.HEAPF64 = F = new Float64Array(A);
            }
            var G = [], _ = [], M = [], p = 0, N = null, J = null;
            function U(A) {
                throw Q.onAbort && Q.onAbort(A), t(A = "Aborted(" + A + ")"), S = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, K = "data:application/octet-stream;base64,";
            function b(A) {
                return A.startsWith(K);
            }
            b(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, f) : f + d);
            var P, v = {
                35256: ()=>Q.getRandomValue(),
                35292: ()=>{
                    if (void 0 === Q.getRandomValue) try {
                        var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                            var A = new Uint32Array(1);
                            return I.getRandomValues(A), A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("d259h")), B = function() {
                                var A = C.randomBytes(4);
                                return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, L = (A)=>{
                for(; A.length > 0;)A.shift()(Q);
            }, R = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, u = (A, I)=>A ? ((A, I, g)=>{
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && R) return R.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var E = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var o = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | E);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                })(w, A, I) : "", x = [], m = (A)=>{
                var I = (A - D.buffer.byteLength + 65535) / 65536;
                try {
                    return D.grow(I), H(), 1;
                } catch (A) {}
            }, l = {
                b: (A, I, g, C)=>{
                    U(`Assertion failed: ${u(A)}, at: ` + [
                        I ? u(I) : "unknown filename",
                        g,
                        C ? u(C) : "unknown function"
                    ]);
                },
                c: ()=>{
                    U("");
                },
                a: (A, I, g)=>((A, I, g)=>{
                        var C = ((A, I)=>{
                            var g;
                            for(x.length = 0; g = w[A++];)I += 105 != g && I % 8 ? 4 : 0, x.push(105 == g ? n[I >> 2] : F[I >> 3]), I += 105 == g ? 4 : 8;
                            return x;
                        })(I, g);
                        return v[A].apply(null, C);
                    })(A, I, g),
                d: (A, I, g)=>w.copyWithin(A, I, I + g),
                e: (A)=>{
                    var I = w.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (m(i)) return !0;
                    }
                    return !1;
                }
            }, z = function() {
                var A, I, g = {
                    a: l
                };
                function C(A, I) {
                    var g = A.exports;
                    return D = (z = g).f, H(), z.tc, function(A) {
                        if (p--, Q.monitorRunDependencies && Q.monitorRunDependencies(p), 0 == p && (null !== N && (clearInterval(N), N = null), J)) {
                            var I = J;
                            J = null, I();
                        }
                    }(), g;
                }
                if (p++, Q.monitorRunDependencies && Q.monitorRunDependencies(p), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return t(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                }
                return A = g, I = function(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(()=>(function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var I = function(A) {
                                if (b(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var I = $bb7e2ea50d670196$require$Buffer.from(A, "base64");
                                        return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                    }
                                    try {
                                        for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                        return C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(K.length));
                            }(A);
                            if (I) return I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        })(A));
                })(Y).then((I)=>WebAssembly.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                    t(`failed to asynchronously prepare wasm: ${A}`), U(A);
                }), {};
            }();
            function q() {
                function A() {
                    P || (P = !0, Q.calledRun = !0, S || (L(_), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)A = Q.postRun.shift(), M.unshift(A);
                        var A;
                        L(M);
                    }()));
                }
                p > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)A = Q.preRun.shift(), G.unshift(A);
                    var A;
                    L(G);
                }(), p > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = z.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = z.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = z.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = z.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = z.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = z.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = z.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = z.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = z.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = z.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = z.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = z.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = z.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = z.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = z.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = z.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = z.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = z.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = z.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = z.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = z.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = z.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = z.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = z.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = z.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = z.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = z.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = z.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = z.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = z.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = z.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = z.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = z.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = z.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = z.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = z.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = z.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = z.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = z.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = z.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = z.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = z.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = z.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = z.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = z.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = z.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = z._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = z.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = z.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = z.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = z.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = z.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = z.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = z.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = z.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = z.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = z.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = z.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = z.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = z.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = z.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = z.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = z.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = z.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = z.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = z.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = z.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = z.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = z.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = z.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = z.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = z.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = z.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = z.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = z.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = z.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = z.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = z.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = z.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = z.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = z.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = z.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = z.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = z.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = z.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = z.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = z.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = z.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = z.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = z.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = z.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = z.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = z.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = z.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = z.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = z.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = z.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = z.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = z.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = z.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = z._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = z.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = z.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = z.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = z.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = z.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = z.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = z.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = z.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = z.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = z.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = z.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = z.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = z.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = z.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = z.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = z.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = z.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = z.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = z.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = z.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = z.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = z.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = z.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = z.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = z.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = z.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = z.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = z.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = z.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = z.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = z.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = z.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = z.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = z.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = z.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = z.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = z.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = z.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = z.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = z.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = z.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = z.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = z.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = z.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = z.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = z.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = z.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = z.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = z.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = z.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = z.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = z.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = z.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = z._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = z.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = z.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = z.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = z.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = z.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = z.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = z.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = z.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = z.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = z.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = z.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = z.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = z.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = z.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = z.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = z.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = z.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = z.qc)(), Q._malloc = (A)=>(Q._malloc = z.rc)(A), Q._free = (A)=>(Q._free = z.sc)(A), Q.setValue = function(A, I, g = "i8") {
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        y[A >> 0] = I;
                        break;
                    case "i16":
                        h[A >> 1] = I;
                        break;
                    case "i32":
                        n[A >> 2] = I;
                        break;
                    case "i64":
                        U("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        k[A >> 2] = I;
                        break;
                    case "double":
                        F[A >> 3] = I;
                        break;
                    case "*":
                        s[A >> 2] = I;
                        break;
                    default:
                        U(`invalid type for setValue: ${g}`);
                }
            }, Q.getValue = function(A, I = "i8") {
                switch(I.endsWith("*") && (I = "*"), I){
                    case "i1":
                    case "i8":
                        return y[A >> 0];
                    case "i16":
                        return h[A >> 1];
                    case "i32":
                        return n[A >> 2];
                    case "i64":
                        U("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return k[A >> 2];
                    case "double":
                        return F[A >> 3];
                    case "*":
                        return s[A >> 2];
                    default:
                        U(`invalid type for getValue: ${I}`);
                }
            }, Q.UTF8ToString = u, J = function A() {
                P || q(), P || (J = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            q();
        }).catch(function() {
            return C.useBackupModule();
        }), I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});
parcelRegister("j1eoE", function(module, exports) {
// shim for using process in browser
var $dd89472898af0f52$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $dd89472898af0f52$var$cachedSetTimeout;
var $dd89472898af0f52$var$cachedClearTimeout;
function $dd89472898af0f52$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $dd89472898af0f52$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $dd89472898af0f52$var$cachedSetTimeout = setTimeout;
        else $dd89472898af0f52$var$cachedSetTimeout = $dd89472898af0f52$var$defaultSetTimout;
    } catch (e) {
        $dd89472898af0f52$var$cachedSetTimeout = $dd89472898af0f52$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $dd89472898af0f52$var$cachedClearTimeout = clearTimeout;
        else $dd89472898af0f52$var$cachedClearTimeout = $dd89472898af0f52$var$defaultClearTimeout;
    } catch (e) {
        $dd89472898af0f52$var$cachedClearTimeout = $dd89472898af0f52$var$defaultClearTimeout;
    }
})();
function $dd89472898af0f52$var$runTimeout(fun) {
    if ($dd89472898af0f52$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($dd89472898af0f52$var$cachedSetTimeout === $dd89472898af0f52$var$defaultSetTimout || !$dd89472898af0f52$var$cachedSetTimeout) && setTimeout) {
        $dd89472898af0f52$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dd89472898af0f52$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $dd89472898af0f52$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $dd89472898af0f52$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $dd89472898af0f52$var$runClearTimeout(marker) {
    if ($dd89472898af0f52$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($dd89472898af0f52$var$cachedClearTimeout === $dd89472898af0f52$var$defaultClearTimeout || !$dd89472898af0f52$var$cachedClearTimeout) && clearTimeout) {
        $dd89472898af0f52$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dd89472898af0f52$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $dd89472898af0f52$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $dd89472898af0f52$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $dd89472898af0f52$var$queue = [];
var $dd89472898af0f52$var$draining = false;
var $dd89472898af0f52$var$currentQueue;
var $dd89472898af0f52$var$queueIndex = -1;
function $dd89472898af0f52$var$cleanUpNextTick() {
    if (!$dd89472898af0f52$var$draining || !$dd89472898af0f52$var$currentQueue) return;
    $dd89472898af0f52$var$draining = false;
    if ($dd89472898af0f52$var$currentQueue.length) $dd89472898af0f52$var$queue = $dd89472898af0f52$var$currentQueue.concat($dd89472898af0f52$var$queue);
    else $dd89472898af0f52$var$queueIndex = -1;
    if ($dd89472898af0f52$var$queue.length) $dd89472898af0f52$var$drainQueue();
}
function $dd89472898af0f52$var$drainQueue() {
    if ($dd89472898af0f52$var$draining) return;
    var timeout = $dd89472898af0f52$var$runTimeout($dd89472898af0f52$var$cleanUpNextTick);
    $dd89472898af0f52$var$draining = true;
    var len = $dd89472898af0f52$var$queue.length;
    while(len){
        $dd89472898af0f52$var$currentQueue = $dd89472898af0f52$var$queue;
        $dd89472898af0f52$var$queue = [];
        while(++$dd89472898af0f52$var$queueIndex < len)if ($dd89472898af0f52$var$currentQueue) $dd89472898af0f52$var$currentQueue[$dd89472898af0f52$var$queueIndex].run();
        $dd89472898af0f52$var$queueIndex = -1;
        len = $dd89472898af0f52$var$queue.length;
    }
    $dd89472898af0f52$var$currentQueue = null;
    $dd89472898af0f52$var$draining = false;
    $dd89472898af0f52$var$runClearTimeout(timeout);
}
$dd89472898af0f52$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $dd89472898af0f52$var$queue.push(new $dd89472898af0f52$var$Item(fun, args));
    if ($dd89472898af0f52$var$queue.length === 1 && !$dd89472898af0f52$var$draining) $dd89472898af0f52$var$runTimeout($dd89472898af0f52$var$drainQueue);
};
// v8 likes predictible objects
function $dd89472898af0f52$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$dd89472898af0f52$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$dd89472898af0f52$var$process.title = 'browser';
$dd89472898af0f52$var$process.browser = true;
$dd89472898af0f52$var$process.env = {};
$dd89472898af0f52$var$process.argv = [];
$dd89472898af0f52$var$process.version = ''; // empty string to avoid regexp issues
$dd89472898af0f52$var$process.versions = {};
function $dd89472898af0f52$var$noop() {}
$dd89472898af0f52$var$process.on = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.addListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.once = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.off = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.removeListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.removeAllListeners = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.emit = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.prependListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.prependOnceListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.listeners = function(name) {
    return [];
};
$dd89472898af0f52$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$dd89472898af0f52$var$process.cwd = function() {
    return '/';
};
$dd89472898af0f52$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$dd89472898af0f52$var$process.umask = function() {
    return 0;
};

});

parcelRegister("b0kMB", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $802fd0de90cfa455$export$a143d493d941bafc; }, function (v) { return $802fd0de90cfa455$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $802fd0de90cfa455$export$e4cf37d7f6fb9e0a; }, function (v) { return $802fd0de90cfa455$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $802fd0de90cfa455$export$f99ded8fe4b79145; }, function (v) { return $802fd0de90cfa455$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $802fd0de90cfa455$export$599f31c3813fae4d; }, function (v) { return $802fd0de90cfa455$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $802fd0de90cfa455$export$a143d493d941bafc;
var $802fd0de90cfa455$export$e4cf37d7f6fb9e0a;
var $802fd0de90cfa455$export$f99ded8fe4b79145;
var $802fd0de90cfa455$export$599f31c3813fae4d;
'use strict';

var $grMsK = parcelRequire("grMsK");

var $4mXnX = parcelRequire("4mXnX");
const $802fd0de90cfa455$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$802fd0de90cfa455$export$a143d493d941bafc = $802fd0de90cfa455$var$Buffer;
$802fd0de90cfa455$export$e4cf37d7f6fb9e0a = $802fd0de90cfa455$var$SlowBuffer;
$802fd0de90cfa455$export$f99ded8fe4b79145 = 50;
const $802fd0de90cfa455$var$K_MAX_LENGTH = 0x7fffffff;
$802fd0de90cfa455$export$599f31c3813fae4d = $802fd0de90cfa455$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $802fd0de90cfa455$var$Buffer.TYPED_ARRAY_SUPPORT = $802fd0de90cfa455$var$typedArraySupport();
if (!$802fd0de90cfa455$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $802fd0de90cfa455$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($802fd0de90cfa455$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$802fd0de90cfa455$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($802fd0de90cfa455$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$802fd0de90cfa455$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $802fd0de90cfa455$var$createBuffer(length) {
    if (length > $802fd0de90cfa455$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $802fd0de90cfa455$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $802fd0de90cfa455$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $802fd0de90cfa455$var$allocUnsafe(arg);
    }
    return $802fd0de90cfa455$var$from(arg, encodingOrOffset, length);
}
$802fd0de90cfa455$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $802fd0de90cfa455$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $802fd0de90cfa455$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $802fd0de90cfa455$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($802fd0de90cfa455$var$isInstance(value, ArrayBuffer) || value && $802fd0de90cfa455$var$isInstance(value.buffer, ArrayBuffer)) return $802fd0de90cfa455$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($802fd0de90cfa455$var$isInstance(value, SharedArrayBuffer) || value && $802fd0de90cfa455$var$isInstance(value.buffer, SharedArrayBuffer))) return $802fd0de90cfa455$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $802fd0de90cfa455$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $802fd0de90cfa455$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $802fd0de90cfa455$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $802fd0de90cfa455$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $802fd0de90cfa455$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($802fd0de90cfa455$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($802fd0de90cfa455$var$Buffer, Uint8Array);
function $802fd0de90cfa455$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $802fd0de90cfa455$var$alloc(size, fill, encoding) {
    $802fd0de90cfa455$var$assertSize(size);
    if (size <= 0) return $802fd0de90cfa455$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $802fd0de90cfa455$var$createBuffer(size).fill(fill, encoding) : $802fd0de90cfa455$var$createBuffer(size).fill(fill);
    return $802fd0de90cfa455$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $802fd0de90cfa455$var$Buffer.alloc = function(size, fill, encoding) {
    return $802fd0de90cfa455$var$alloc(size, fill, encoding);
};
function $802fd0de90cfa455$var$allocUnsafe(size) {
    $802fd0de90cfa455$var$assertSize(size);
    return $802fd0de90cfa455$var$createBuffer(size < 0 ? 0 : $802fd0de90cfa455$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $802fd0de90cfa455$var$Buffer.allocUnsafe = function(size) {
    return $802fd0de90cfa455$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $802fd0de90cfa455$var$Buffer.allocUnsafeSlow = function(size) {
    return $802fd0de90cfa455$var$allocUnsafe(size);
};
function $802fd0de90cfa455$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$802fd0de90cfa455$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $802fd0de90cfa455$var$byteLength(string, encoding) | 0;
    let buf = $802fd0de90cfa455$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $802fd0de90cfa455$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $802fd0de90cfa455$var$checked(array.length) | 0;
    const buf = $802fd0de90cfa455$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $802fd0de90cfa455$var$fromArrayView(arrayView) {
    if ($802fd0de90cfa455$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $802fd0de90cfa455$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $802fd0de90cfa455$var$fromArrayLike(arrayView);
}
function $802fd0de90cfa455$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $802fd0de90cfa455$var$Buffer.prototype);
    return buf;
}
function $802fd0de90cfa455$var$fromObject(obj) {
    if ($802fd0de90cfa455$var$Buffer.isBuffer(obj)) {
        const len = $802fd0de90cfa455$var$checked(obj.length) | 0;
        const buf = $802fd0de90cfa455$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $802fd0de90cfa455$var$numberIsNaN(obj.length)) return $802fd0de90cfa455$var$createBuffer(0);
        return $802fd0de90cfa455$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $802fd0de90cfa455$var$fromArrayLike(obj.data);
}
function $802fd0de90cfa455$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $802fd0de90cfa455$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $802fd0de90cfa455$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $802fd0de90cfa455$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $802fd0de90cfa455$var$Buffer.alloc(+length);
}
$802fd0de90cfa455$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $802fd0de90cfa455$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$802fd0de90cfa455$var$Buffer.compare = function compare(a, b) {
    if ($802fd0de90cfa455$var$isInstance(a, Uint8Array)) a = $802fd0de90cfa455$var$Buffer.from(a, a.offset, a.byteLength);
    if ($802fd0de90cfa455$var$isInstance(b, Uint8Array)) b = $802fd0de90cfa455$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(a) || !$802fd0de90cfa455$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$802fd0de90cfa455$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$802fd0de90cfa455$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $802fd0de90cfa455$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $802fd0de90cfa455$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($802fd0de90cfa455$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) buf = $802fd0de90cfa455$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $802fd0de90cfa455$var$byteLength(string, encoding) {
    if ($802fd0de90cfa455$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $802fd0de90cfa455$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $802fd0de90cfa455$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $802fd0de90cfa455$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$802fd0de90cfa455$var$Buffer.byteLength = $802fd0de90cfa455$var$byteLength;
function $802fd0de90cfa455$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $802fd0de90cfa455$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8Slice(this, start, end);
        case 'ascii':
            return $802fd0de90cfa455$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $802fd0de90cfa455$var$latin1Slice(this, start, end);
        case 'base64':
            return $802fd0de90cfa455$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $802fd0de90cfa455$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$802fd0de90cfa455$var$Buffer.prototype._isBuffer = true;
function $802fd0de90cfa455$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$802fd0de90cfa455$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$802fd0de90cfa455$var$swap(this, i, i + 1);
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $802fd0de90cfa455$var$swap(this, i, i + 3);
        $802fd0de90cfa455$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $802fd0de90cfa455$var$swap(this, i, i + 7);
        $802fd0de90cfa455$var$swap(this, i + 1, i + 6);
        $802fd0de90cfa455$var$swap(this, i + 2, i + 5);
        $802fd0de90cfa455$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $802fd0de90cfa455$var$utf8Slice(this, 0, length);
    return $802fd0de90cfa455$var$slowToString.apply(this, arguments);
};
$802fd0de90cfa455$var$Buffer.prototype.toLocaleString = $802fd0de90cfa455$var$Buffer.prototype.toString;
$802fd0de90cfa455$var$Buffer.prototype.equals = function equals(b) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $802fd0de90cfa455$var$Buffer.compare(this, b) === 0;
};
$802fd0de90cfa455$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $802fd0de90cfa455$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($802fd0de90cfa455$var$customInspectSymbol) $802fd0de90cfa455$var$Buffer.prototype[$802fd0de90cfa455$var$customInspectSymbol] = $802fd0de90cfa455$var$Buffer.prototype.inspect;
$802fd0de90cfa455$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($802fd0de90cfa455$var$isInstance(target, Uint8Array)) target = $802fd0de90cfa455$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $802fd0de90cfa455$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($802fd0de90cfa455$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $802fd0de90cfa455$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($802fd0de90cfa455$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $802fd0de90cfa455$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $802fd0de90cfa455$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $802fd0de90cfa455$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$802fd0de90cfa455$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$802fd0de90cfa455$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $802fd0de90cfa455$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$802fd0de90cfa455$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $802fd0de90cfa455$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $802fd0de90cfa455$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($802fd0de90cfa455$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $802fd0de90cfa455$var$utf8Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $802fd0de90cfa455$var$asciiWrite(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$asciiToBytes(string), buf, offset, length);
}
function $802fd0de90cfa455$var$base64Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$base64ToBytes(string), buf, offset, length);
}
function $802fd0de90cfa455$var$ucs2Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$802fd0de90cfa455$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $802fd0de90cfa455$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $802fd0de90cfa455$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $802fd0de90cfa455$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $802fd0de90cfa455$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$802fd0de90cfa455$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $802fd0de90cfa455$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $grMsK.fromByteArray(buf);
    else return $grMsK.fromByteArray(buf.slice(start, end));
}
function $802fd0de90cfa455$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $802fd0de90cfa455$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $802fd0de90cfa455$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $802fd0de90cfa455$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $802fd0de90cfa455$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $802fd0de90cfa455$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $802fd0de90cfa455$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $802fd0de90cfa455$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$802fd0de90cfa455$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $802fd0de90cfa455$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $802fd0de90cfa455$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$802fd0de90cfa455$var$Buffer.prototype.readUintLE = $802fd0de90cfa455$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readUintBE = $802fd0de90cfa455$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint8 = $802fd0de90cfa455$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$802fd0de90cfa455$var$Buffer.prototype.readUint16LE = $802fd0de90cfa455$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint16BE = $802fd0de90cfa455$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$802fd0de90cfa455$var$Buffer.prototype.readUint32LE = $802fd0de90cfa455$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint32BE = $802fd0de90cfa455$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$802fd0de90cfa455$var$Buffer.prototype.readBigUInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$802fd0de90cfa455$var$Buffer.prototype.readBigUInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$802fd0de90cfa455$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$802fd0de90cfa455$var$Buffer.prototype.readBigInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$802fd0de90cfa455$var$Buffer.prototype.readBigInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$802fd0de90cfa455$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return $4mXnX.read(this, offset, true, 23, 4);
};
$802fd0de90cfa455$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return $4mXnX.read(this, offset, false, 23, 4);
};
$802fd0de90cfa455$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 8, this.length);
    return $4mXnX.read(this, offset, true, 52, 8);
};
$802fd0de90cfa455$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 8, this.length);
    return $4mXnX.read(this, offset, false, 52, 8);
};
function $802fd0de90cfa455$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$802fd0de90cfa455$var$Buffer.prototype.writeUintLE = $802fd0de90cfa455$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUintBE = $802fd0de90cfa455$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint8 = $802fd0de90cfa455$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint16LE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint16BE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint32LE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint32BE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $802fd0de90cfa455$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $802fd0de90cfa455$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$802fd0de90cfa455$var$Buffer.prototype.writeBigUInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeBigUInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeBigInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeBigInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $802fd0de90cfa455$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $4mXnX.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$802fd0de90cfa455$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeFloat(this, value, offset, true, noAssert);
};
$802fd0de90cfa455$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeFloat(this, value, offset, false, noAssert);
};
function $802fd0de90cfa455$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $4mXnX.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$802fd0de90cfa455$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeDouble(this, value, offset, true, noAssert);
};
$802fd0de90cfa455$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$802fd0de90cfa455$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$802fd0de90cfa455$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$802fd0de90cfa455$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $802fd0de90cfa455$var$Buffer.isBuffer(val) ? val : $802fd0de90cfa455$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $802fd0de90cfa455$var$errors = {};
function $802fd0de90cfa455$var$E(sym, getMessage, Base) {
    $802fd0de90cfa455$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$802fd0de90cfa455$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$802fd0de90cfa455$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$802fd0de90cfa455$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $802fd0de90cfa455$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $802fd0de90cfa455$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $802fd0de90cfa455$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $802fd0de90cfa455$var$checkBounds(buf, offset, byteLength) {
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $802fd0de90cfa455$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $802fd0de90cfa455$var$checkBounds(buf, offset, byteLength);
}
function $802fd0de90cfa455$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $802fd0de90cfa455$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $802fd0de90cfa455$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $802fd0de90cfa455$var$validateNumber(value, type);
        throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $802fd0de90cfa455$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $802fd0de90cfa455$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $802fd0de90cfa455$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($802fd0de90cfa455$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $802fd0de90cfa455$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $802fd0de90cfa455$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $802fd0de90cfa455$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $802fd0de90cfa455$var$base64ToBytes(str) {
    return $grMsK.toByteArray($802fd0de90cfa455$var$base64clean(str));
}
function $802fd0de90cfa455$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $802fd0de90cfa455$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $802fd0de90cfa455$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $802fd0de90cfa455$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $802fd0de90cfa455$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $802fd0de90cfa455$var$BufferBigIntNotDefined : fn;
}
function $802fd0de90cfa455$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("grMsK", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $bf94c29cc99c1571$export$d622b2ad8d90c771; }, function (v) { return $bf94c29cc99c1571$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $bf94c29cc99c1571$export$6100ba28696e12de; }, function (v) { return $bf94c29cc99c1571$export$6100ba28696e12de = v; });
var $bf94c29cc99c1571$export$a48f0734ac7c2329;
var $bf94c29cc99c1571$export$d622b2ad8d90c771;
var $bf94c29cc99c1571$export$6100ba28696e12de;
'use strict';
$bf94c29cc99c1571$export$a48f0734ac7c2329 = $bf94c29cc99c1571$var$byteLength;
$bf94c29cc99c1571$export$d622b2ad8d90c771 = $bf94c29cc99c1571$var$toByteArray;
$bf94c29cc99c1571$export$6100ba28696e12de = $bf94c29cc99c1571$var$fromByteArray;
var $bf94c29cc99c1571$var$lookup = [];
var $bf94c29cc99c1571$var$revLookup = [];
var $bf94c29cc99c1571$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $bf94c29cc99c1571$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $bf94c29cc99c1571$var$i = 0, $bf94c29cc99c1571$var$len = $bf94c29cc99c1571$var$code.length; $bf94c29cc99c1571$var$i < $bf94c29cc99c1571$var$len; ++$bf94c29cc99c1571$var$i){
    $bf94c29cc99c1571$var$lookup[$bf94c29cc99c1571$var$i] = $bf94c29cc99c1571$var$code[$bf94c29cc99c1571$var$i];
    $bf94c29cc99c1571$var$revLookup[$bf94c29cc99c1571$var$code.charCodeAt($bf94c29cc99c1571$var$i)] = $bf94c29cc99c1571$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bf94c29cc99c1571$var$revLookup['-'.charCodeAt(0)] = 62;
$bf94c29cc99c1571$var$revLookup['_'.charCodeAt(0)] = 63;
function $bf94c29cc99c1571$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bf94c29cc99c1571$var$byteLength(b64) {
    var lens = $bf94c29cc99c1571$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bf94c29cc99c1571$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bf94c29cc99c1571$var$toByteArray(b64) {
    var tmp;
    var lens = $bf94c29cc99c1571$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bf94c29cc99c1571$var$Arr($bf94c29cc99c1571$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 18 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 2 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 10 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bf94c29cc99c1571$var$tripletToBase64(num) {
    return $bf94c29cc99c1571$var$lookup[num >> 18 & 0x3F] + $bf94c29cc99c1571$var$lookup[num >> 12 & 0x3F] + $bf94c29cc99c1571$var$lookup[num >> 6 & 0x3F] + $bf94c29cc99c1571$var$lookup[num & 0x3F];
}
function $bf94c29cc99c1571$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bf94c29cc99c1571$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $bf94c29cc99c1571$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bf94c29cc99c1571$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bf94c29cc99c1571$var$lookup[tmp >> 2] + $bf94c29cc99c1571$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bf94c29cc99c1571$var$lookup[tmp >> 10] + $bf94c29cc99c1571$var$lookup[tmp >> 4 & 0x3F] + $bf94c29cc99c1571$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("4mXnX", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $32e74836fee794be$export$aafa59e2e03f2942; }, function (v) { return $32e74836fee794be$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $32e74836fee794be$export$68d8715fc104d294; }, function (v) { return $32e74836fee794be$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $32e74836fee794be$export$aafa59e2e03f2942;
var $32e74836fee794be$export$68d8715fc104d294;
$32e74836fee794be$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$32e74836fee794be$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("80bNa", function(module, exports) {
"use strict";

});

parcelRegister("d259h", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $97cf74aa430a596f$export$5f828d93ff035aa8; }, function (v) { return $97cf74aa430a596f$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $97cf74aa430a596f$export$cd94982b18c6332c; }, function (v) { return $97cf74aa430a596f$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $97cf74aa430a596f$export$1d518568e4f529b0; }, function (v) { return $97cf74aa430a596f$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $97cf74aa430a596f$export$5285b6d41c912b41; }, function (v) { return $97cf74aa430a596f$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $97cf74aa430a596f$export$2fb37efbf6ae0c0e; }, function (v) { return $97cf74aa430a596f$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $97cf74aa430a596f$export$ab85ecd77ce6a5cd; }, function (v) { return $97cf74aa430a596f$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $97cf74aa430a596f$export$da39cf97e1eb7c91; }, function (v) { return $97cf74aa430a596f$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $97cf74aa430a596f$export$52a9039d7177394f; }, function (v) { return $97cf74aa430a596f$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $97cf74aa430a596f$export$f7201db400317331; }, function (v) { return $97cf74aa430a596f$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $97cf74aa430a596f$export$448fa22aedc9dbca; }, function (v) { return $97cf74aa430a596f$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $97cf74aa430a596f$export$b80c7ba289c8fa56; }, function (v) { return $97cf74aa430a596f$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $97cf74aa430a596f$export$26e5786e8ac8e530; }, function (v) { return $97cf74aa430a596f$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $97cf74aa430a596f$export$bdd223f16383713e; }, function (v) { return $97cf74aa430a596f$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $97cf74aa430a596f$export$20533d26f07f1ee0; }, function (v) { return $97cf74aa430a596f$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $97cf74aa430a596f$export$2f64596b8cbf08b4; }, function (v) { return $97cf74aa430a596f$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $97cf74aa430a596f$export$2ce6d8d0e8b04e1a; }, function (v) { return $97cf74aa430a596f$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $97cf74aa430a596f$export$12ada9414fbc594c; }, function (v) { return $97cf74aa430a596f$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $97cf74aa430a596f$export$f5e7e39d57cd9700; }, function (v) { return $97cf74aa430a596f$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $97cf74aa430a596f$export$36b6d6ef312eab39; }, function (v) { return $97cf74aa430a596f$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $97cf74aa430a596f$export$58a258485f1e49f6; }, function (v) { return $97cf74aa430a596f$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $97cf74aa430a596f$export$dedd8dc3dc62b370; }, function (v) { return $97cf74aa430a596f$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $97cf74aa430a596f$export$971862a2fcb1bb40; }, function (v) { return $97cf74aa430a596f$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $97cf74aa430a596f$export$c6ff6a88acbeaf40; }, function (v) { return $97cf74aa430a596f$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $97cf74aa430a596f$export$fdc27893e98845cc; }, function (v) { return $97cf74aa430a596f$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $97cf74aa430a596f$export$6671fb9a1323bed; }, function (v) { return $97cf74aa430a596f$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $97cf74aa430a596f$export$d74daf141a551db; }, function (v) { return $97cf74aa430a596f$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $97cf74aa430a596f$export$45df7cae684751af; }, function (v) { return $97cf74aa430a596f$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $97cf74aa430a596f$export$1db683ad541682f6; }, function (v) { return $97cf74aa430a596f$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $97cf74aa430a596f$export$6f65485f87568e37; }, function (v) { return $97cf74aa430a596f$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $97cf74aa430a596f$export$91a8e56769aeb334; }, function (v) { return $97cf74aa430a596f$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $97cf74aa430a596f$export$2d4117e99c2179e4; }, function (v) { return $97cf74aa430a596f$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $97cf74aa430a596f$export$512823e338ddb1b7; }, function (v) { return $97cf74aa430a596f$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $97cf74aa430a596f$export$9d0e0c0c4a8d30f3; }, function (v) { return $97cf74aa430a596f$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $97cf74aa430a596f$export$b9d55ff329113abd; }, function (v) { return $97cf74aa430a596f$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $97cf74aa430a596f$export$7efb24e2fddf99b9; }, function (v) { return $97cf74aa430a596f$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $97cf74aa430a596f$export$bb1abf2ce84fc7e8; }, function (v) { return $97cf74aa430a596f$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $97cf74aa430a596f$export$2f7171e78e524d5e; }, function (v) { return $97cf74aa430a596f$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $97cf74aa430a596f$export$e1d879b482f37d98; }, function (v) { return $97cf74aa430a596f$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $97cf74aa430a596f$export$1a988e7317c65621; }, function (v) { return $97cf74aa430a596f$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $97cf74aa430a596f$export$5f828d93ff035aa8;
var $97cf74aa430a596f$export$cd94982b18c6332c;
var $97cf74aa430a596f$export$1d518568e4f529b0;
var $97cf74aa430a596f$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $97cf74aa430a596f$export$2fb37efbf6ae0c0e;
var $97cf74aa430a596f$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $97cf74aa430a596f$export$da39cf97e1eb7c91;
var $97cf74aa430a596f$export$52a9039d7177394f;
var $97cf74aa430a596f$export$f7201db400317331;
var $97cf74aa430a596f$export$448fa22aedc9dbca;
var $97cf74aa430a596f$export$b80c7ba289c8fa56;
var $97cf74aa430a596f$export$26e5786e8ac8e530;
var $97cf74aa430a596f$export$bdd223f16383713e;
var $97cf74aa430a596f$export$20533d26f07f1ee0;
var $97cf74aa430a596f$export$2f64596b8cbf08b4;
var $97cf74aa430a596f$export$2ce6d8d0e8b04e1a;
var $97cf74aa430a596f$export$12ada9414fbc594c;
var $97cf74aa430a596f$export$f5e7e39d57cd9700;
var $97cf74aa430a596f$export$36b6d6ef312eab39;
var $97cf74aa430a596f$export$58a258485f1e49f6;
var $97cf74aa430a596f$export$dedd8dc3dc62b370;
var $97cf74aa430a596f$export$971862a2fcb1bb40;
var $97cf74aa430a596f$export$c6ff6a88acbeaf40;
var $97cf74aa430a596f$export$fdc27893e98845cc;
var $97cf74aa430a596f$export$6671fb9a1323bed;
var $97cf74aa430a596f$export$d74daf141a551db;
var $97cf74aa430a596f$export$45df7cae684751af;
var $97cf74aa430a596f$export$1db683ad541682f6;
var $97cf74aa430a596f$export$6f65485f87568e37;
var $97cf74aa430a596f$export$91a8e56769aeb334;
var $97cf74aa430a596f$export$2d4117e99c2179e4;
var $97cf74aa430a596f$export$512823e338ddb1b7;
var $97cf74aa430a596f$export$9d0e0c0c4a8d30f3;
var $97cf74aa430a596f$export$b9d55ff329113abd;
var $97cf74aa430a596f$export$7efb24e2fddf99b9;
var $97cf74aa430a596f$export$bb1abf2ce84fc7e8;
var $97cf74aa430a596f$export$2f7171e78e524d5e;
var $97cf74aa430a596f$export$e1d879b482f37d98;
var $97cf74aa430a596f$export$1a988e7317c65621;
'use strict';

$97cf74aa430a596f$export$5f828d93ff035aa8 = $97cf74aa430a596f$export$cd94982b18c6332c = $97cf74aa430a596f$export$1d518568e4f529b0 = $97cf74aa430a596f$export$5285b6d41c912b41 = (parcelRequire("a0Pw9"));

$97cf74aa430a596f$export$2fb37efbf6ae0c0e = $97cf74aa430a596f$export$ab85ecd77ce6a5cd = (parcelRequire("5GOyq"));

$97cf74aa430a596f$export$da39cf97e1eb7c91 = $97cf74aa430a596f$export$52a9039d7177394f = (parcelRequire("ikkqh"));

var $dAlkt = parcelRequire("dAlkt");
var $97cf74aa430a596f$var$algoKeys = Object.keys($dAlkt);
var $97cf74aa430a596f$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($97cf74aa430a596f$var$algoKeys);
$97cf74aa430a596f$export$f7201db400317331 = function() {
    return $97cf74aa430a596f$var$hashes;
};

var $btZcF = parcelRequire("btZcF");
$97cf74aa430a596f$export$448fa22aedc9dbca = $btZcF.pbkdf2;
$97cf74aa430a596f$export$b80c7ba289c8fa56 = $btZcF.pbkdf2Sync;

var $lasuy = parcelRequire("lasuy");
$97cf74aa430a596f$export$26e5786e8ac8e530 = $lasuy.Cipher;
$97cf74aa430a596f$export$bdd223f16383713e = $lasuy.createCipher;
$97cf74aa430a596f$export$20533d26f07f1ee0 = $lasuy.Cipheriv;
$97cf74aa430a596f$export$2f64596b8cbf08b4 = $lasuy.createCipheriv;
$97cf74aa430a596f$export$2ce6d8d0e8b04e1a = $lasuy.Decipher;
$97cf74aa430a596f$export$12ada9414fbc594c = $lasuy.createDecipher;
$97cf74aa430a596f$export$f5e7e39d57cd9700 = $lasuy.Decipheriv;
$97cf74aa430a596f$export$36b6d6ef312eab39 = $lasuy.createDecipheriv;
$97cf74aa430a596f$export$58a258485f1e49f6 = $lasuy.getCiphers;
$97cf74aa430a596f$export$dedd8dc3dc62b370 = $lasuy.listCiphers;

var $d9lw7 = parcelRequire("d9lw7");
$97cf74aa430a596f$export$971862a2fcb1bb40 = $d9lw7.DiffieHellmanGroup;
$97cf74aa430a596f$export$c6ff6a88acbeaf40 = $d9lw7.createDiffieHellmanGroup;
$97cf74aa430a596f$export$fdc27893e98845cc = $d9lw7.getDiffieHellman;
$97cf74aa430a596f$export$6671fb9a1323bed = $d9lw7.createDiffieHellman;
$97cf74aa430a596f$export$d74daf141a551db = $d9lw7.DiffieHellman;

var $hvjcZ = parcelRequire("hvjcZ");
$97cf74aa430a596f$export$45df7cae684751af = $hvjcZ.createSign;
$97cf74aa430a596f$export$1db683ad541682f6 = $hvjcZ.Sign;
$97cf74aa430a596f$export$6f65485f87568e37 = $hvjcZ.createVerify;
$97cf74aa430a596f$export$91a8e56769aeb334 = $hvjcZ.Verify;

$97cf74aa430a596f$export$2d4117e99c2179e4 = (parcelRequire("87sXO"));

var $IHdXk = parcelRequire("IHdXk");
$97cf74aa430a596f$export$512823e338ddb1b7 = $IHdXk.publicEncrypt;
$97cf74aa430a596f$export$9d0e0c0c4a8d30f3 = $IHdXk.privateEncrypt;
$97cf74aa430a596f$export$b9d55ff329113abd = $IHdXk.publicDecrypt;
$97cf74aa430a596f$export$7efb24e2fddf99b9 = $IHdXk.privateDecrypt;

var $kimef = parcelRequire("kimef");
$97cf74aa430a596f$export$bb1abf2ce84fc7e8 = $kimef.randomFill;
$97cf74aa430a596f$export$2f7171e78e524d5e = $kimef.randomFillSync;
$97cf74aa430a596f$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$97cf74aa430a596f$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("a0Pw9", function(module, exports) {

var $j1eoE = parcelRequire("j1eoE");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $74a1ddc6c60949a5$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $74a1ddc6c60949a5$var$MAX_UINT32 = 4294967295;
function $74a1ddc6c60949a5$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $fF8dn = parcelRequire("fF8dn");
var $74a1ddc6c60949a5$require$Buffer = $fF8dn.Buffer;
var $74a1ddc6c60949a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($74a1ddc6c60949a5$var$crypto && $74a1ddc6c60949a5$var$crypto.getRandomValues) module.exports = $74a1ddc6c60949a5$var$randomBytes;
else module.exports = $74a1ddc6c60949a5$var$oldBrowser;
function $74a1ddc6c60949a5$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $74a1ddc6c60949a5$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $74a1ddc6c60949a5$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $74a1ddc6c60949a5$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $74a1ddc6c60949a5$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $74a1ddc6c60949a5$var$crypto.getRandomValues(bytes.slice(generated, generated + $74a1ddc6c60949a5$var$MAX_BYTES));
        else $74a1ddc6c60949a5$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $j1eoE.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("fF8dn", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $b6710ea5e50ce74c$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $b6710ea5e50ce74c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($b6710ea5e50ce74c$var$Buffer.from && $b6710ea5e50ce74c$var$Buffer.alloc && $b6710ea5e50ce74c$var$Buffer.allocUnsafe && $b6710ea5e50ce74c$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $b6710ea5e50ce74c$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $b6710ea5e50ce74c$var$SafeBuffer;
}
function $b6710ea5e50ce74c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $b6710ea5e50ce74c$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$b6710ea5e50ce74c$var$copyProps($b6710ea5e50ce74c$var$Buffer, $b6710ea5e50ce74c$var$SafeBuffer);
$b6710ea5e50ce74c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $b6710ea5e50ce74c$var$Buffer(arg, encodingOrOffset, length);
};
$b6710ea5e50ce74c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $b6710ea5e50ce74c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$b6710ea5e50ce74c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b6710ea5e50ce74c$var$Buffer(size);
};
$b6710ea5e50ce74c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});


parcelRegister("5GOyq", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $cfjWo = parcelRequire("cfjWo");

var $ARbIS = parcelRequire("ARbIS");

var $8UwRt = parcelRequire("8UwRt");

var $lRCsB = parcelRequire("lRCsB");
function $42481703190b77f5$var$Hash(hash) {
    $lRCsB.call(this, 'digest');
    this._hash = hash;
}
$4rf1u($42481703190b77f5$var$Hash, $lRCsB);
$42481703190b77f5$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$42481703190b77f5$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $cfjWo();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $ARbIS();
    return new $42481703190b77f5$var$Hash($8UwRt(alg));
};

});
parcelRegister("4rf1u", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("cfjWo", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $2jd9p = parcelRequire("2jd9p");

var $fF8dn = parcelRequire("fF8dn");
var $8ea65a8fcda9e2f0$require$Buffer = $fF8dn.Buffer;
var $8ea65a8fcda9e2f0$var$ARRAY16 = new Array(16);
function $8ea65a8fcda9e2f0$var$MD5() {
    $2jd9p.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$4rf1u($8ea65a8fcda9e2f0$var$MD5, $2jd9p);
$8ea65a8fcda9e2f0$var$MD5.prototype._update = function() {
    var M = $8ea65a8fcda9e2f0$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $8ea65a8fcda9e2f0$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $8ea65a8fcda9e2f0$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $8ea65a8fcda9e2f0$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $8ea65a8fcda9e2f0$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $8ea65a8fcda9e2f0$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $8ea65a8fcda9e2f0$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $8ea65a8fcda9e2f0$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $8ea65a8fcda9e2f0$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $8ea65a8fcda9e2f0$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $8ea65a8fcda9e2f0$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $8ea65a8fcda9e2f0$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $8ea65a8fcda9e2f0$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $8ea65a8fcda9e2f0$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $8ea65a8fcda9e2f0$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $8ea65a8fcda9e2f0$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $8ea65a8fcda9e2f0$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $8ea65a8fcda9e2f0$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $8ea65a8fcda9e2f0$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $8ea65a8fcda9e2f0$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $8ea65a8fcda9e2f0$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $8ea65a8fcda9e2f0$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $8ea65a8fcda9e2f0$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $8ea65a8fcda9e2f0$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $8ea65a8fcda9e2f0$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $8ea65a8fcda9e2f0$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $8ea65a8fcda9e2f0$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $8ea65a8fcda9e2f0$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $8ea65a8fcda9e2f0$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $8ea65a8fcda9e2f0$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $8ea65a8fcda9e2f0$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $8ea65a8fcda9e2f0$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $8ea65a8fcda9e2f0$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $8ea65a8fcda9e2f0$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $8ea65a8fcda9e2f0$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $8ea65a8fcda9e2f0$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $8ea65a8fcda9e2f0$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $8ea65a8fcda9e2f0$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $8ea65a8fcda9e2f0$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $8ea65a8fcda9e2f0$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $8ea65a8fcda9e2f0$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $8ea65a8fcda9e2f0$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $8ea65a8fcda9e2f0$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $8ea65a8fcda9e2f0$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $8ea65a8fcda9e2f0$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $8ea65a8fcda9e2f0$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $8ea65a8fcda9e2f0$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $8ea65a8fcda9e2f0$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $8ea65a8fcda9e2f0$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $8ea65a8fcda9e2f0$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $8ea65a8fcda9e2f0$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $8ea65a8fcda9e2f0$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $8ea65a8fcda9e2f0$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $8ea65a8fcda9e2f0$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $8ea65a8fcda9e2f0$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $8ea65a8fcda9e2f0$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $8ea65a8fcda9e2f0$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $8ea65a8fcda9e2f0$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $8ea65a8fcda9e2f0$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $8ea65a8fcda9e2f0$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $8ea65a8fcda9e2f0$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $8ea65a8fcda9e2f0$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $8ea65a8fcda9e2f0$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $8ea65a8fcda9e2f0$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $8ea65a8fcda9e2f0$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$8ea65a8fcda9e2f0$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8ea65a8fcda9e2f0$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $8ea65a8fcda9e2f0$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8ea65a8fcda9e2f0$var$fnF(a, b, c, d, m, k, s) {
    return $8ea65a8fcda9e2f0$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $8ea65a8fcda9e2f0$var$fnG(a, b, c, d, m, k, s) {
    return $8ea65a8fcda9e2f0$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $8ea65a8fcda9e2f0$var$fnH(a, b, c, d, m, k, s) {
    return $8ea65a8fcda9e2f0$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $8ea65a8fcda9e2f0$var$fnI(a, b, c, d, m, k, s) {
    return $8ea65a8fcda9e2f0$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $8ea65a8fcda9e2f0$var$MD5;

});
parcelRegister("2jd9p", function(module, exports) {
'use strict';

var $fF8dn = parcelRequire("fF8dn");
var $1ae78e9b1ffbd5ee$require$Buffer = $fF8dn.Buffer;

var $lH12X = parcelRequire("lH12X");
var $1ae78e9b1ffbd5ee$require$Transform = $lH12X.Transform;

var $4rf1u = parcelRequire("4rf1u");
function $1ae78e9b1ffbd5ee$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$1ae78e9b1ffbd5ee$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $1ae78e9b1ffbd5ee$var$HashBase(blockSize) {
    $1ae78e9b1ffbd5ee$require$Transform.call(this);
    this._block = $1ae78e9b1ffbd5ee$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$4rf1u($1ae78e9b1ffbd5ee$var$HashBase, $1ae78e9b1ffbd5ee$require$Transform);
$1ae78e9b1ffbd5ee$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$1ae78e9b1ffbd5ee$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$1ae78e9b1ffbd5ee$var$HashBase.prototype.update = function(data, encoding) {
    $1ae78e9b1ffbd5ee$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$1ae78e9b1ffbd5ee$require$Buffer.isBuffer(data)) data = $1ae78e9b1ffbd5ee$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$1ae78e9b1ffbd5ee$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$1ae78e9b1ffbd5ee$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$1ae78e9b1ffbd5ee$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $1ae78e9b1ffbd5ee$var$HashBase;

});
parcelRegister("lH12X", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $fcae6cfcddcd6dc8$var$Stream;

var $ldFei = parcelRequire("ldFei");
var $fcae6cfcddcd6dc8$require$EE = $ldFei.EventEmitter;

var $4rf1u = parcelRequire("4rf1u");
$4rf1u($fcae6cfcddcd6dc8$var$Stream, $fcae6cfcddcd6dc8$require$EE);

$fcae6cfcddcd6dc8$var$Stream.Readable = (parcelRequire("3ZmhZ"));

$fcae6cfcddcd6dc8$var$Stream.Writable = (parcelRequire("7dtXJ"));

$fcae6cfcddcd6dc8$var$Stream.Duplex = (parcelRequire("8mYl7"));

$fcae6cfcddcd6dc8$var$Stream.Transform = (parcelRequire("ijYqS"));

$fcae6cfcddcd6dc8$var$Stream.PassThrough = (parcelRequire("lx5Ur"));

$fcae6cfcddcd6dc8$var$Stream.finished = (parcelRequire("aWKch"));

$fcae6cfcddcd6dc8$var$Stream.pipeline = (parcelRequire("1nXad"));
// Backwards-compat with node 0.4.x
$fcae6cfcddcd6dc8$var$Stream.Stream = $fcae6cfcddcd6dc8$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $fcae6cfcddcd6dc8$var$Stream() {
    $fcae6cfcddcd6dc8$require$EE.call(this);
}
$fcae6cfcddcd6dc8$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($fcae6cfcddcd6dc8$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("ldFei", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $f72acb359e9f7fe8$var$R = typeof Reflect === 'object' ? Reflect : null;
var $f72acb359e9f7fe8$var$ReflectApply = $f72acb359e9f7fe8$var$R && typeof $f72acb359e9f7fe8$var$R.apply === 'function' ? $f72acb359e9f7fe8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $f72acb359e9f7fe8$var$ReflectOwnKeys;
if ($f72acb359e9f7fe8$var$R && typeof $f72acb359e9f7fe8$var$R.ownKeys === 'function') $f72acb359e9f7fe8$var$ReflectOwnKeys = $f72acb359e9f7fe8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $f72acb359e9f7fe8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $f72acb359e9f7fe8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $f72acb359e9f7fe8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $f72acb359e9f7fe8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $f72acb359e9f7fe8$var$EventEmitter() {
    $f72acb359e9f7fe8$var$EventEmitter.init.call(this);
}
module.exports = $f72acb359e9f7fe8$var$EventEmitter;
module.exports.once = $f72acb359e9f7fe8$var$once;
// Backwards-compat with node 0.10.x
$f72acb359e9f7fe8$var$EventEmitter.EventEmitter = $f72acb359e9f7fe8$var$EventEmitter;
$f72acb359e9f7fe8$var$EventEmitter.prototype._events = undefined;
$f72acb359e9f7fe8$var$EventEmitter.prototype._eventsCount = 0;
$f72acb359e9f7fe8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $f72acb359e9f7fe8$var$defaultMaxListeners = 10;
function $f72acb359e9f7fe8$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($f72acb359e9f7fe8$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $f72acb359e9f7fe8$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $f72acb359e9f7fe8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $f72acb359e9f7fe8$var$defaultMaxListeners = arg;
    }
});
$f72acb359e9f7fe8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$f72acb359e9f7fe8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $f72acb359e9f7fe8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $f72acb359e9f7fe8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $f72acb359e9f7fe8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$f72acb359e9f7fe8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $f72acb359e9f7fe8$var$_getMaxListeners(this);
};
$f72acb359e9f7fe8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $f72acb359e9f7fe8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $f72acb359e9f7fe8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$f72acb359e9f7fe8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $f72acb359e9f7fe8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $f72acb359e9f7fe8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $f72acb359e9f7fe8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $f72acb359e9f7fe8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$f72acb359e9f7fe8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $f72acb359e9f7fe8$var$_addListener(this, type, listener, false);
};
$f72acb359e9f7fe8$var$EventEmitter.prototype.on = $f72acb359e9f7fe8$var$EventEmitter.prototype.addListener;
$f72acb359e9f7fe8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $f72acb359e9f7fe8$var$_addListener(this, type, listener, true);
};
function $f72acb359e9f7fe8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $f72acb359e9f7fe8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $f72acb359e9f7fe8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$f72acb359e9f7fe8$var$EventEmitter.prototype.once = function once(type, listener) {
    $f72acb359e9f7fe8$var$checkListener(listener);
    this.on(type, $f72acb359e9f7fe8$var$_onceWrap(this, type, listener));
    return this;
};
$f72acb359e9f7fe8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $f72acb359e9f7fe8$var$checkListener(listener);
    this.prependListener(type, $f72acb359e9f7fe8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$f72acb359e9f7fe8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $f72acb359e9f7fe8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $f72acb359e9f7fe8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$f72acb359e9f7fe8$var$EventEmitter.prototype.off = $f72acb359e9f7fe8$var$EventEmitter.prototype.removeListener;
$f72acb359e9f7fe8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $f72acb359e9f7fe8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $f72acb359e9f7fe8$var$unwrapListeners(evlistener) : $f72acb359e9f7fe8$var$arrayClone(evlistener, evlistener.length);
}
$f72acb359e9f7fe8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $f72acb359e9f7fe8$var$_listeners(this, type, true);
};
$f72acb359e9f7fe8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $f72acb359e9f7fe8$var$_listeners(this, type, false);
};
$f72acb359e9f7fe8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $f72acb359e9f7fe8$var$listenerCount.call(emitter, type);
};
$f72acb359e9f7fe8$var$EventEmitter.prototype.listenerCount = $f72acb359e9f7fe8$var$listenerCount;
function $f72acb359e9f7fe8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$f72acb359e9f7fe8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $f72acb359e9f7fe8$var$ReflectOwnKeys(this._events) : [];
};
function $f72acb359e9f7fe8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $f72acb359e9f7fe8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $f72acb359e9f7fe8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $f72acb359e9f7fe8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $f72acb359e9f7fe8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $f72acb359e9f7fe8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $f72acb359e9f7fe8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $f72acb359e9f7fe8$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $f72acb359e9f7fe8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("3ZmhZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $j1eoE = parcelRequire("j1eoE");
'use strict';
module.exports = $2e785bc843f7f0c3$var$Readable;
/*<replacement>*/ var $2e785bc843f7f0c3$var$Duplex;
/*</replacement>*/ $2e785bc843f7f0c3$var$Readable.ReadableState = $2e785bc843f7f0c3$var$ReadableState;

var $ldFei = parcelRequire("ldFei");
var $2e785bc843f7f0c3$require$EE = $ldFei.EventEmitter;
var $2e785bc843f7f0c3$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $6ILNg = parcelRequire("6ILNg");

var $b0kMB = parcelRequire("b0kMB");
var $2e785bc843f7f0c3$require$Buffer = $b0kMB.Buffer;
var $2e785bc843f7f0c3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $2e785bc843f7f0c3$var$_uint8ArrayToBuffer(chunk) {
    return $2e785bc843f7f0c3$require$Buffer.from(chunk);
}
function $2e785bc843f7f0c3$var$_isUint8Array(obj) {
    return $2e785bc843f7f0c3$require$Buffer.isBuffer(obj) || obj instanceof $2e785bc843f7f0c3$var$OurUint8Array;
}

var $80bNa = parcelRequire("80bNa");
var $2e785bc843f7f0c3$var$debug;
if ($80bNa && $80bNa.debuglog) $2e785bc843f7f0c3$var$debug = $80bNa.debuglog('stream');
else $2e785bc843f7f0c3$var$debug = function debug() {};

var $fC2cP = parcelRequire("fC2cP");

var $iJuNg = parcelRequire("iJuNg");

var $3Lw44 = parcelRequire("3Lw44");
var $2e785bc843f7f0c3$var$getHighWaterMark = $3Lw44.getHighWaterMark;

var $hdIaW = parcelRequire("hdIaW");
var $2e785bc843f7f0c3$require$_require$codes = $hdIaW.codes;
var $2e785bc843f7f0c3$var$ERR_INVALID_ARG_TYPE = $2e785bc843f7f0c3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2e785bc843f7f0c3$var$ERR_STREAM_PUSH_AFTER_EOF = $2e785bc843f7f0c3$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $2e785bc843f7f0c3$var$ERR_METHOD_NOT_IMPLEMENTED = $2e785bc843f7f0c3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2e785bc843f7f0c3$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $2e785bc843f7f0c3$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $2e785bc843f7f0c3$var$StringDecoder;
var $2e785bc843f7f0c3$var$createReadableStreamAsyncIterator;
var $2e785bc843f7f0c3$var$from;

(parcelRequire("4rf1u"))($2e785bc843f7f0c3$var$Readable, $6ILNg);
var $2e785bc843f7f0c3$var$errorOrDestroy = $iJuNg.errorOrDestroy;
var $2e785bc843f7f0c3$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $2e785bc843f7f0c3$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $2e785bc843f7f0c3$var$ReadableState(options, stream, isDuplex) {
    $2e785bc843f7f0c3$var$Duplex = $2e785bc843f7f0c3$var$Duplex || (parcelRequire("8mYl7"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $2e785bc843f7f0c3$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $2e785bc843f7f0c3$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $fC2cP();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$2e785bc843f7f0c3$var$StringDecoder) $2e785bc843f7f0c3$var$StringDecoder = (parcelRequire("2QY83")).StringDecoder;
        this.decoder = new $2e785bc843f7f0c3$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $2e785bc843f7f0c3$var$Readable(options) {
    $2e785bc843f7f0c3$var$Duplex = $2e785bc843f7f0c3$var$Duplex || (parcelRequire("8mYl7"));
    if (!(this instanceof $2e785bc843f7f0c3$var$Readable)) return new $2e785bc843f7f0c3$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2e785bc843f7f0c3$var$Duplex;
    this._readableState = new $2e785bc843f7f0c3$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $6ILNg.call(this);
}
Object.defineProperty($2e785bc843f7f0c3$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$2e785bc843f7f0c3$var$Readable.prototype.destroy = $iJuNg.destroy;
$2e785bc843f7f0c3$var$Readable.prototype._undestroy = $iJuNg.undestroy;
$2e785bc843f7f0c3$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$2e785bc843f7f0c3$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $2e785bc843f7f0c3$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $2e785bc843f7f0c3$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$2e785bc843f7f0c3$var$Readable.prototype.unshift = function(chunk) {
    return $2e785bc843f7f0c3$var$readableAddChunk(this, chunk, null, true, false);
};
function $2e785bc843f7f0c3$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $2e785bc843f7f0c3$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $2e785bc843f7f0c3$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $2e785bc843f7f0c3$var$chunkInvalid(state, chunk);
        if (er) $2e785bc843f7f0c3$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $2e785bc843f7f0c3$require$Buffer.prototype) chunk = $2e785bc843f7f0c3$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $2e785bc843f7f0c3$var$errorOrDestroy(stream, new $2e785bc843f7f0c3$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $2e785bc843f7f0c3$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $2e785bc843f7f0c3$var$errorOrDestroy(stream, new $2e785bc843f7f0c3$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $2e785bc843f7f0c3$var$addChunk(stream, state, chunk, false);
                    else $2e785bc843f7f0c3$var$maybeReadMore(stream, state);
                } else $2e785bc843f7f0c3$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $2e785bc843f7f0c3$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $2e785bc843f7f0c3$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $2e785bc843f7f0c3$var$emitReadable(stream);
    }
    $2e785bc843f7f0c3$var$maybeReadMore(stream, state);
}
function $2e785bc843f7f0c3$var$chunkInvalid(state, chunk) {
    var er;
    if (!$2e785bc843f7f0c3$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $2e785bc843f7f0c3$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$2e785bc843f7f0c3$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$2e785bc843f7f0c3$var$Readable.prototype.setEncoding = function(enc) {
    if (!$2e785bc843f7f0c3$var$StringDecoder) $2e785bc843f7f0c3$var$StringDecoder = (parcelRequire("2QY83")).StringDecoder;
    var decoder = new $2e785bc843f7f0c3$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $2e785bc843f7f0c3$var$MAX_HWM = 0x40000000;
function $2e785bc843f7f0c3$var$computeNewHighWaterMark(n) {
    if (n >= $2e785bc843f7f0c3$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $2e785bc843f7f0c3$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2e785bc843f7f0c3$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $2e785bc843f7f0c3$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$2e785bc843f7f0c3$var$Readable.prototype.read = function(n) {
    $2e785bc843f7f0c3$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $2e785bc843f7f0c3$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $2e785bc843f7f0c3$var$endReadable(this);
        else $2e785bc843f7f0c3$var$emitReadable(this);
        return null;
    }
    n = $2e785bc843f7f0c3$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $2e785bc843f7f0c3$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $2e785bc843f7f0c3$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $2e785bc843f7f0c3$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $2e785bc843f7f0c3$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $2e785bc843f7f0c3$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $2e785bc843f7f0c3$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $2e785bc843f7f0c3$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $2e785bc843f7f0c3$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $2e785bc843f7f0c3$var$onEofChunk(stream, state) {
    $2e785bc843f7f0c3$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $2e785bc843f7f0c3$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $2e785bc843f7f0c3$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $2e785bc843f7f0c3$var$emitReadable(stream) {
    var state = stream._readableState;
    $2e785bc843f7f0c3$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $2e785bc843f7f0c3$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $j1eoE.nextTick($2e785bc843f7f0c3$var$emitReadable_, stream);
    }
}
function $2e785bc843f7f0c3$var$emitReadable_(stream) {
    var state = stream._readableState;
    $2e785bc843f7f0c3$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $2e785bc843f7f0c3$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $2e785bc843f7f0c3$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $j1eoE.nextTick($2e785bc843f7f0c3$var$maybeReadMore_, stream, state);
    }
}
function $2e785bc843f7f0c3$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $2e785bc843f7f0c3$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$2e785bc843f7f0c3$var$Readable.prototype._read = function(n) {
    $2e785bc843f7f0c3$var$errorOrDestroy(this, new $2e785bc843f7f0c3$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$2e785bc843f7f0c3$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $2e785bc843f7f0c3$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $j1eoE.stdout && dest !== $j1eoE.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $j1eoE.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $2e785bc843f7f0c3$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $2e785bc843f7f0c3$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $2e785bc843f7f0c3$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $2e785bc843f7f0c3$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $2e785bc843f7f0c3$var$debug('ondata');
        var ret = dest.write(chunk);
        $2e785bc843f7f0c3$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $2e785bc843f7f0c3$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $2e785bc843f7f0c3$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $2e785bc843f7f0c3$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($2e785bc843f7f0c3$var$EElistenerCount(dest, 'error') === 0) $2e785bc843f7f0c3$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $2e785bc843f7f0c3$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $2e785bc843f7f0c3$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $2e785bc843f7f0c3$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $2e785bc843f7f0c3$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $2e785bc843f7f0c3$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $2e785bc843f7f0c3$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $2e785bc843f7f0c3$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $2e785bc843f7f0c3$var$flow(src);
        }
    };
}
$2e785bc843f7f0c3$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $2e785bc843f7f0c3$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$2e785bc843f7f0c3$var$Readable.prototype.on = function(ev, fn) {
    var res = $6ILNg.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $2e785bc843f7f0c3$var$debug('on readable', state.length, state.reading);
            if (state.length) $2e785bc843f7f0c3$var$emitReadable(this);
            else if (!state.reading) $j1eoE.nextTick($2e785bc843f7f0c3$var$nReadingNextTick, this);
        }
    }
    return res;
};
$2e785bc843f7f0c3$var$Readable.prototype.addListener = $2e785bc843f7f0c3$var$Readable.prototype.on;
$2e785bc843f7f0c3$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $6ILNg.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $j1eoE.nextTick($2e785bc843f7f0c3$var$updateReadableListening, this);
    return res;
};
$2e785bc843f7f0c3$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $6ILNg.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $j1eoE.nextTick($2e785bc843f7f0c3$var$updateReadableListening, this);
    return res;
};
function $2e785bc843f7f0c3$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $2e785bc843f7f0c3$var$nReadingNextTick(self1) {
    $2e785bc843f7f0c3$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$2e785bc843f7f0c3$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $2e785bc843f7f0c3$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $2e785bc843f7f0c3$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $2e785bc843f7f0c3$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $j1eoE.nextTick($2e785bc843f7f0c3$var$resume_, stream, state);
    }
}
function $2e785bc843f7f0c3$var$resume_(stream, state) {
    $2e785bc843f7f0c3$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $2e785bc843f7f0c3$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$2e785bc843f7f0c3$var$Readable.prototype.pause = function() {
    $2e785bc843f7f0c3$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $2e785bc843f7f0c3$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $2e785bc843f7f0c3$var$flow(stream) {
    var state = stream._readableState;
    $2e785bc843f7f0c3$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$2e785bc843f7f0c3$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $2e785bc843f7f0c3$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $2e785bc843f7f0c3$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $2e785bc843f7f0c3$var$kProxyEvents.length; n++)stream.on($2e785bc843f7f0c3$var$kProxyEvents[n], this.emit.bind(this, $2e785bc843f7f0c3$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $2e785bc843f7f0c3$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $2e785bc843f7f0c3$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($2e785bc843f7f0c3$var$createReadableStreamAsyncIterator === undefined) $2e785bc843f7f0c3$var$createReadableStreamAsyncIterator = (parcelRequire("c9qiW"));
    return $2e785bc843f7f0c3$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($2e785bc843f7f0c3$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($2e785bc843f7f0c3$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($2e785bc843f7f0c3$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$2e785bc843f7f0c3$var$Readable._fromList = $2e785bc843f7f0c3$var$fromList;
Object.defineProperty($2e785bc843f7f0c3$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2e785bc843f7f0c3$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $2e785bc843f7f0c3$var$endReadable(stream) {
    var state = stream._readableState;
    $2e785bc843f7f0c3$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $j1eoE.nextTick($2e785bc843f7f0c3$var$endReadableNT, state, stream);
    }
}
function $2e785bc843f7f0c3$var$endReadableNT(state, stream) {
    $2e785bc843f7f0c3$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $2e785bc843f7f0c3$var$Readable.from = function(iterable, opts) {
    if ($2e785bc843f7f0c3$var$from === undefined) $2e785bc843f7f0c3$var$from = (parcelRequire("96xVs"));
    return $2e785bc843f7f0c3$var$from($2e785bc843f7f0c3$var$Readable, iterable, opts);
};
function $2e785bc843f7f0c3$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("6ILNg", function(module, exports) {

module.exports = (parcelRequire("ldFei")).EventEmitter;

});

parcelRegister("fC2cP", function(module, exports) {
'use strict';
function $b5dc1db05d3d67bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b5dc1db05d3d67bb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b5dc1db05d3d67bb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b5dc1db05d3d67bb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b5dc1db05d3d67bb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b5dc1db05d3d67bb$var$_defineProperty(obj, key, value) {
    key = $b5dc1db05d3d67bb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5dc1db05d3d67bb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b5dc1db05d3d67bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b5dc1db05d3d67bb$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b5dc1db05d3d67bb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b5dc1db05d3d67bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b5dc1db05d3d67bb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b5dc1db05d3d67bb$var$_toPropertyKey(arg) {
    var key = $b5dc1db05d3d67bb$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $b5dc1db05d3d67bb$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $b0kMB = parcelRequire("b0kMB");
var $b5dc1db05d3d67bb$var$Buffer = $b0kMB.Buffer;

var $80bNa = parcelRequire("80bNa");
var $b5dc1db05d3d67bb$var$inspect = $80bNa.inspect;
var $b5dc1db05d3d67bb$var$custom = $b5dc1db05d3d67bb$var$inspect && $b5dc1db05d3d67bb$var$inspect.custom || 'inspect';
function $b5dc1db05d3d67bb$var$copyBuffer(src, target, offset) {
    $b5dc1db05d3d67bb$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $b5dc1db05d3d67bb$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $b5dc1db05d3d67bb$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $b5dc1db05d3d67bb$var$Buffer.alloc(0);
                var ret = $b5dc1db05d3d67bb$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $b5dc1db05d3d67bb$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $b5dc1db05d3d67bb$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $b5dc1db05d3d67bb$var$custom,
            value: function value(_, options) {
                return $b5dc1db05d3d67bb$var$inspect(this, $b5dc1db05d3d67bb$var$_objectSpread($b5dc1db05d3d67bb$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("iJuNg", function(module, exports) {

var $j1eoE = parcelRequire("j1eoE");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $da3450e7b79ef677$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $j1eoE.nextTick($da3450e7b79ef677$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $j1eoE.nextTick($da3450e7b79ef677$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $j1eoE.nextTick($da3450e7b79ef677$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $j1eoE.nextTick($da3450e7b79ef677$var$emitErrorAndCloseNT, _this, err);
            } else $j1eoE.nextTick($da3450e7b79ef677$var$emitCloseNT, _this);
        } else if (cb) {
            $j1eoE.nextTick($da3450e7b79ef677$var$emitCloseNT, _this);
            cb(err);
        } else $j1eoE.nextTick($da3450e7b79ef677$var$emitCloseNT, _this);
    });
    return this;
}
function $da3450e7b79ef677$var$emitErrorAndCloseNT(self, err) {
    $da3450e7b79ef677$var$emitErrorNT(self, err);
    $da3450e7b79ef677$var$emitCloseNT(self);
}
function $da3450e7b79ef677$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $da3450e7b79ef677$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $da3450e7b79ef677$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $da3450e7b79ef677$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $da3450e7b79ef677$var$destroy,
    undestroy: $da3450e7b79ef677$var$undestroy,
    errorOrDestroy: $da3450e7b79ef677$var$errorOrDestroy
};

});

parcelRegister("3Lw44", function(module, exports) {
'use strict';

var $2bdea2447f0ebbca$var$ERR_INVALID_OPT_VALUE = (parcelRequire("hdIaW")).codes.ERR_INVALID_OPT_VALUE;
function $2bdea2447f0ebbca$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $2bdea2447f0ebbca$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $2bdea2447f0ebbca$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $2bdea2447f0ebbca$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $2bdea2447f0ebbca$var$getHighWaterMark
};

});
parcelRegister("hdIaW", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $c895eae612b1ee01$export$e45cb6485273080e; }, function (v) { return $c895eae612b1ee01$export$e45cb6485273080e = v; });
var $c895eae612b1ee01$export$e45cb6485273080e;
'use strict';
function $c895eae612b1ee01$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c895eae612b1ee01$var$codes = {};
function $c895eae612b1ee01$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $c895eae612b1ee01$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $c895eae612b1ee01$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $c895eae612b1ee01$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $c895eae612b1ee01$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $c895eae612b1ee01$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $c895eae612b1ee01$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$c895eae612b1ee01$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$c895eae612b1ee01$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $c895eae612b1ee01$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($c895eae612b1ee01$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($c895eae612b1ee01$var$oneOf(expected, 'type'));
    else {
        var type = $c895eae612b1ee01$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($c895eae612b1ee01$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$c895eae612b1ee01$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$c895eae612b1ee01$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$c895eae612b1ee01$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$c895eae612b1ee01$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$c895eae612b1ee01$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$c895eae612b1ee01$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$c895eae612b1ee01$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$c895eae612b1ee01$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$c895eae612b1ee01$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$c895eae612b1ee01$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$c895eae612b1ee01$export$e45cb6485273080e = $c895eae612b1ee01$var$codes;

});


parcelRegister("8mYl7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $j1eoE = parcelRequire("j1eoE");
'use strict';
/*<replacement>*/ var $617f2f02e6c684f0$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $617f2f02e6c684f0$var$Duplex;

var $3ZmhZ = parcelRequire("3ZmhZ");

var $7dtXJ = parcelRequire("7dtXJ");

(parcelRequire("4rf1u"))($617f2f02e6c684f0$var$Duplex, $3ZmhZ);
// Allow the keys array to be GC'ed.
var $617f2f02e6c684f0$var$keys = $617f2f02e6c684f0$var$objectKeys($7dtXJ.prototype);
for(var $617f2f02e6c684f0$var$v = 0; $617f2f02e6c684f0$var$v < $617f2f02e6c684f0$var$keys.length; $617f2f02e6c684f0$var$v++){
    var $617f2f02e6c684f0$var$method = $617f2f02e6c684f0$var$keys[$617f2f02e6c684f0$var$v];
    if (!$617f2f02e6c684f0$var$Duplex.prototype[$617f2f02e6c684f0$var$method]) $617f2f02e6c684f0$var$Duplex.prototype[$617f2f02e6c684f0$var$method] = $7dtXJ.prototype[$617f2f02e6c684f0$var$method];
}
function $617f2f02e6c684f0$var$Duplex(options) {
    if (!(this instanceof $617f2f02e6c684f0$var$Duplex)) return new $617f2f02e6c684f0$var$Duplex(options);
    $3ZmhZ.call(this, options);
    $7dtXJ.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $617f2f02e6c684f0$var$onend);
        }
    }
}
Object.defineProperty($617f2f02e6c684f0$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($617f2f02e6c684f0$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($617f2f02e6c684f0$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $617f2f02e6c684f0$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $j1eoE.nextTick($617f2f02e6c684f0$var$onEndNT, this);
}
function $617f2f02e6c684f0$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($617f2f02e6c684f0$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("7dtXJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $j1eoE = parcelRequire("j1eoE");
'use strict';
module.exports = $5410fd36ca4f4845$var$Writable;
/* <replacement> */ function $5410fd36ca4f4845$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5410fd36ca4f4845$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5410fd36ca4f4845$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5410fd36ca4f4845$var$Duplex;
/*</replacement>*/ $5410fd36ca4f4845$var$Writable.WritableState = $5410fd36ca4f4845$var$WritableState;

/*<replacement>*/ var $5410fd36ca4f4845$var$internalUtil = {
    deprecate: (parcelRequire("1RFk0"))
};

var $6ILNg = parcelRequire("6ILNg");

var $b0kMB = parcelRequire("b0kMB");
var $5410fd36ca4f4845$require$Buffer = $b0kMB.Buffer;
var $5410fd36ca4f4845$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5410fd36ca4f4845$var$_uint8ArrayToBuffer(chunk) {
    return $5410fd36ca4f4845$require$Buffer.from(chunk);
}
function $5410fd36ca4f4845$var$_isUint8Array(obj) {
    return $5410fd36ca4f4845$require$Buffer.isBuffer(obj) || obj instanceof $5410fd36ca4f4845$var$OurUint8Array;
}

var $iJuNg = parcelRequire("iJuNg");

var $3Lw44 = parcelRequire("3Lw44");
var $5410fd36ca4f4845$var$getHighWaterMark = $3Lw44.getHighWaterMark;

var $hdIaW = parcelRequire("hdIaW");
var $5410fd36ca4f4845$require$_require$codes = $hdIaW.codes;
var $5410fd36ca4f4845$var$ERR_INVALID_ARG_TYPE = $5410fd36ca4f4845$require$_require$codes.ERR_INVALID_ARG_TYPE, $5410fd36ca4f4845$var$ERR_METHOD_NOT_IMPLEMENTED = $5410fd36ca4f4845$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5410fd36ca4f4845$var$ERR_MULTIPLE_CALLBACK = $5410fd36ca4f4845$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5410fd36ca4f4845$var$ERR_STREAM_CANNOT_PIPE = $5410fd36ca4f4845$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5410fd36ca4f4845$var$ERR_STREAM_DESTROYED = $5410fd36ca4f4845$require$_require$codes.ERR_STREAM_DESTROYED, $5410fd36ca4f4845$var$ERR_STREAM_NULL_VALUES = $5410fd36ca4f4845$require$_require$codes.ERR_STREAM_NULL_VALUES, $5410fd36ca4f4845$var$ERR_STREAM_WRITE_AFTER_END = $5410fd36ca4f4845$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5410fd36ca4f4845$var$ERR_UNKNOWN_ENCODING = $5410fd36ca4f4845$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5410fd36ca4f4845$var$errorOrDestroy = $iJuNg.errorOrDestroy;

(parcelRequire("4rf1u"))($5410fd36ca4f4845$var$Writable, $6ILNg);
function $5410fd36ca4f4845$var$nop() {}

function $5410fd36ca4f4845$var$WritableState(options, stream, isDuplex) {
    $5410fd36ca4f4845$var$Duplex = $5410fd36ca4f4845$var$Duplex || (parcelRequire("8mYl7"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5410fd36ca4f4845$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5410fd36ca4f4845$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5410fd36ca4f4845$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5410fd36ca4f4845$var$CorkedRequest(this);
}
$5410fd36ca4f4845$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5410fd36ca4f4845$var$WritableState.prototype, 'buffer', {
            get: $5410fd36ca4f4845$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5410fd36ca4f4845$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5410fd36ca4f4845$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5410fd36ca4f4845$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5410fd36ca4f4845$var$realHasInstance.call(this, object)) return true;
            if (this !== $5410fd36ca4f4845$var$Writable) return false;
            return object && object._writableState instanceof $5410fd36ca4f4845$var$WritableState;
        }
    });
} else $5410fd36ca4f4845$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5410fd36ca4f4845$var$Writable(options) {
    $5410fd36ca4f4845$var$Duplex = $5410fd36ca4f4845$var$Duplex || (parcelRequire("8mYl7"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5410fd36ca4f4845$var$Duplex;
    if (!isDuplex && !$5410fd36ca4f4845$var$realHasInstance.call($5410fd36ca4f4845$var$Writable, this)) return new $5410fd36ca4f4845$var$Writable(options);
    this._writableState = new $5410fd36ca4f4845$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $6ILNg.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5410fd36ca4f4845$var$Writable.prototype.pipe = function() {
    $5410fd36ca4f4845$var$errorOrDestroy(this, new $5410fd36ca4f4845$var$ERR_STREAM_CANNOT_PIPE());
};
function $5410fd36ca4f4845$var$writeAfterEnd(stream, cb) {
    var er = new $5410fd36ca4f4845$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5410fd36ca4f4845$var$errorOrDestroy(stream, er);
    $j1eoE.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5410fd36ca4f4845$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5410fd36ca4f4845$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5410fd36ca4f4845$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5410fd36ca4f4845$var$errorOrDestroy(stream, er);
        $j1eoE.nextTick(cb, er);
        return false;
    }
    return true;
}
$5410fd36ca4f4845$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5410fd36ca4f4845$var$_isUint8Array(chunk);
    if (isBuf && !$5410fd36ca4f4845$require$Buffer.isBuffer(chunk)) chunk = $5410fd36ca4f4845$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5410fd36ca4f4845$var$nop;
    if (state.ending) $5410fd36ca4f4845$var$writeAfterEnd(this, cb);
    else if (isBuf || $5410fd36ca4f4845$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5410fd36ca4f4845$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5410fd36ca4f4845$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5410fd36ca4f4845$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5410fd36ca4f4845$var$clearBuffer(this, state);
    }
};
$5410fd36ca4f4845$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5410fd36ca4f4845$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5410fd36ca4f4845$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5410fd36ca4f4845$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5410fd36ca4f4845$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5410fd36ca4f4845$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5410fd36ca4f4845$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5410fd36ca4f4845$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5410fd36ca4f4845$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5410fd36ca4f4845$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5410fd36ca4f4845$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5410fd36ca4f4845$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $j1eoE.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $j1eoE.nextTick($5410fd36ca4f4845$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5410fd36ca4f4845$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5410fd36ca4f4845$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5410fd36ca4f4845$var$finishMaybe(stream, state);
    }
}
function $5410fd36ca4f4845$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5410fd36ca4f4845$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5410fd36ca4f4845$var$ERR_MULTIPLE_CALLBACK();
    $5410fd36ca4f4845$var$onwriteStateUpdate(state);
    if (er) $5410fd36ca4f4845$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5410fd36ca4f4845$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5410fd36ca4f4845$var$clearBuffer(stream, state);
        if (sync) $j1eoE.nextTick($5410fd36ca4f4845$var$afterWrite, stream, state, finished, cb);
        else $5410fd36ca4f4845$var$afterWrite(stream, state, finished, cb);
    }
}
function $5410fd36ca4f4845$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5410fd36ca4f4845$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5410fd36ca4f4845$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5410fd36ca4f4845$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5410fd36ca4f4845$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5410fd36ca4f4845$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5410fd36ca4f4845$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5410fd36ca4f4845$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5410fd36ca4f4845$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5410fd36ca4f4845$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5410fd36ca4f4845$var$Writable.prototype._writev = null;
$5410fd36ca4f4845$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5410fd36ca4f4845$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5410fd36ca4f4845$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5410fd36ca4f4845$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5410fd36ca4f4845$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5410fd36ca4f4845$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5410fd36ca4f4845$var$finishMaybe(stream, state);
    });
}
function $5410fd36ca4f4845$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $j1eoE.nextTick($5410fd36ca4f4845$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5410fd36ca4f4845$var$finishMaybe(stream, state) {
    var need = $5410fd36ca4f4845$var$needFinish(state);
    if (need) {
        $5410fd36ca4f4845$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5410fd36ca4f4845$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5410fd36ca4f4845$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $j1eoE.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5410fd36ca4f4845$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5410fd36ca4f4845$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5410fd36ca4f4845$var$Writable.prototype.destroy = $iJuNg.destroy;
$5410fd36ca4f4845$var$Writable.prototype._undestroy = $iJuNg.undestroy;
$5410fd36ca4f4845$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("1RFk0", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $15bacb47f1085aa2$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $15bacb47f1085aa2$var$deprecate(fn, msg) {
    if ($15bacb47f1085aa2$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($15bacb47f1085aa2$var$config('throwDeprecation')) throw new Error(msg);
            else if ($15bacb47f1085aa2$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $15bacb47f1085aa2$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("2QY83", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $213f1477f6451fdc$export$63a7aa211a91ed69; }, function (v) { return $213f1477f6451fdc$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $213f1477f6451fdc$export$63a7aa211a91ed69;
'use strict';

var $7ymmo = parcelRequire("7ymmo");
var $213f1477f6451fdc$require$Buffer = $7ymmo.Buffer;
/*</replacement>*/ var $213f1477f6451fdc$var$isEncoding = $213f1477f6451fdc$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $213f1477f6451fdc$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $213f1477f6451fdc$var$normalizeEncoding(enc) {
    var nenc = $213f1477f6451fdc$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($213f1477f6451fdc$require$Buffer.isEncoding === $213f1477f6451fdc$var$isEncoding || !$213f1477f6451fdc$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$213f1477f6451fdc$export$63a7aa211a91ed69 = $213f1477f6451fdc$var$StringDecoder;
function $213f1477f6451fdc$var$StringDecoder(encoding) {
    this.encoding = $213f1477f6451fdc$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $213f1477f6451fdc$var$utf16Text;
            this.end = $213f1477f6451fdc$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $213f1477f6451fdc$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $213f1477f6451fdc$var$base64Text;
            this.end = $213f1477f6451fdc$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $213f1477f6451fdc$var$simpleWrite;
            this.end = $213f1477f6451fdc$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $213f1477f6451fdc$require$Buffer.allocUnsafe(nb);
}
$213f1477f6451fdc$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$213f1477f6451fdc$var$StringDecoder.prototype.end = $213f1477f6451fdc$var$utf8End;
// Returns only complete characters in a Buffer
$213f1477f6451fdc$var$StringDecoder.prototype.text = $213f1477f6451fdc$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$213f1477f6451fdc$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $213f1477f6451fdc$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $213f1477f6451fdc$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $213f1477f6451fdc$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $213f1477f6451fdc$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $213f1477f6451fdc$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $213f1477f6451fdc$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $213f1477f6451fdc$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $213f1477f6451fdc$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $213f1477f6451fdc$var$utf8Text(buf, i) {
    var total = $213f1477f6451fdc$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $213f1477f6451fdc$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $213f1477f6451fdc$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $213f1477f6451fdc$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $213f1477f6451fdc$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $213f1477f6451fdc$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $213f1477f6451fdc$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $213f1477f6451fdc$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("7ymmo", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $57fd0da6039ec2ff$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $57fd0da6039ec2ff$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($57fd0da6039ec2ff$var$Buffer.from && $57fd0da6039ec2ff$var$Buffer.alloc && $57fd0da6039ec2ff$var$Buffer.allocUnsafe && $57fd0da6039ec2ff$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $57fd0da6039ec2ff$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $57fd0da6039ec2ff$var$SafeBuffer;
}
function $57fd0da6039ec2ff$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $57fd0da6039ec2ff$var$Buffer(arg, encodingOrOffset, length);
}
$57fd0da6039ec2ff$var$SafeBuffer.prototype = Object.create($57fd0da6039ec2ff$var$Buffer.prototype);
// Copy static methods from Buffer
$57fd0da6039ec2ff$var$copyProps($57fd0da6039ec2ff$var$Buffer, $57fd0da6039ec2ff$var$SafeBuffer);
$57fd0da6039ec2ff$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $57fd0da6039ec2ff$var$Buffer(arg, encodingOrOffset, length);
};
$57fd0da6039ec2ff$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $57fd0da6039ec2ff$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$57fd0da6039ec2ff$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $57fd0da6039ec2ff$var$Buffer(size);
};
$57fd0da6039ec2ff$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});


parcelRegister("c9qiW", function(module, exports) {

var $j1eoE = parcelRequire("j1eoE");
'use strict';
var $8d8abad1ece71733$var$_Object$setPrototypeO;
function $8d8abad1ece71733$var$_defineProperty(obj, key, value) {
    key = $8d8abad1ece71733$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8d8abad1ece71733$var$_toPropertyKey(arg) {
    var key = $8d8abad1ece71733$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8d8abad1ece71733$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $aWKch = parcelRequire("aWKch");
var $8d8abad1ece71733$var$kLastResolve = Symbol('lastResolve');
var $8d8abad1ece71733$var$kLastReject = Symbol('lastReject');
var $8d8abad1ece71733$var$kError = Symbol('error');
var $8d8abad1ece71733$var$kEnded = Symbol('ended');
var $8d8abad1ece71733$var$kLastPromise = Symbol('lastPromise');
var $8d8abad1ece71733$var$kHandlePromise = Symbol('handlePromise');
var $8d8abad1ece71733$var$kStream = Symbol('stream');
function $8d8abad1ece71733$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $8d8abad1ece71733$var$readAndResolve(iter) {
    var resolve = iter[$8d8abad1ece71733$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$8d8abad1ece71733$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$8d8abad1ece71733$var$kLastPromise] = null;
            iter[$8d8abad1ece71733$var$kLastResolve] = null;
            iter[$8d8abad1ece71733$var$kLastReject] = null;
            resolve($8d8abad1ece71733$var$createIterResult(data, false));
        }
    }
}
function $8d8abad1ece71733$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $j1eoE.nextTick($8d8abad1ece71733$var$readAndResolve, iter);
}
function $8d8abad1ece71733$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$8d8abad1ece71733$var$kEnded]) {
                resolve($8d8abad1ece71733$var$createIterResult(undefined, true));
                return;
            }
            iter[$8d8abad1ece71733$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $8d8abad1ece71733$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $8d8abad1ece71733$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($8d8abad1ece71733$var$_Object$setPrototypeO = {
    get stream () {
        return this[$8d8abad1ece71733$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$8d8abad1ece71733$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$8d8abad1ece71733$var$kEnded]) return Promise.resolve($8d8abad1ece71733$var$createIterResult(undefined, true));
        if (this[$8d8abad1ece71733$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $j1eoE.nextTick(function() {
                if (_this[$8d8abad1ece71733$var$kError]) reject(_this[$8d8abad1ece71733$var$kError]);
                else resolve($8d8abad1ece71733$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$8d8abad1ece71733$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($8d8abad1ece71733$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$8d8abad1ece71733$var$kStream].read();
            if (data !== null) return Promise.resolve($8d8abad1ece71733$var$createIterResult(data, false));
            promise = new Promise(this[$8d8abad1ece71733$var$kHandlePromise]);
        }
        this[$8d8abad1ece71733$var$kLastPromise] = promise;
        return promise;
    }
}, $8d8abad1ece71733$var$_defineProperty($8d8abad1ece71733$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $8d8abad1ece71733$var$_defineProperty($8d8abad1ece71733$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$8d8abad1ece71733$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($8d8abad1ece71733$var$createIterResult(undefined, true));
        });
    });
}), $8d8abad1ece71733$var$_Object$setPrototypeO), $8d8abad1ece71733$var$AsyncIteratorPrototype);
var $8d8abad1ece71733$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($8d8abad1ece71733$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $8d8abad1ece71733$var$_defineProperty(_Object$create, $8d8abad1ece71733$var$kStream, {
        value: stream,
        writable: true
    }), $8d8abad1ece71733$var$_defineProperty(_Object$create, $8d8abad1ece71733$var$kLastResolve, {
        value: null,
        writable: true
    }), $8d8abad1ece71733$var$_defineProperty(_Object$create, $8d8abad1ece71733$var$kLastReject, {
        value: null,
        writable: true
    }), $8d8abad1ece71733$var$_defineProperty(_Object$create, $8d8abad1ece71733$var$kError, {
        value: null,
        writable: true
    }), $8d8abad1ece71733$var$_defineProperty(_Object$create, $8d8abad1ece71733$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $8d8abad1ece71733$var$_defineProperty(_Object$create, $8d8abad1ece71733$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$8d8abad1ece71733$var$kStream].read();
            if (data) {
                iterator[$8d8abad1ece71733$var$kLastPromise] = null;
                iterator[$8d8abad1ece71733$var$kLastResolve] = null;
                iterator[$8d8abad1ece71733$var$kLastReject] = null;
                resolve($8d8abad1ece71733$var$createIterResult(data, false));
            } else {
                iterator[$8d8abad1ece71733$var$kLastResolve] = resolve;
                iterator[$8d8abad1ece71733$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$8d8abad1ece71733$var$kLastPromise] = null;
    $aWKch(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$8d8abad1ece71733$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$8d8abad1ece71733$var$kLastPromise] = null;
                iterator[$8d8abad1ece71733$var$kLastResolve] = null;
                iterator[$8d8abad1ece71733$var$kLastReject] = null;
                reject(err);
            }
            iterator[$8d8abad1ece71733$var$kError] = err;
            return;
        }
        var resolve = iterator[$8d8abad1ece71733$var$kLastResolve];
        if (resolve !== null) {
            iterator[$8d8abad1ece71733$var$kLastPromise] = null;
            iterator[$8d8abad1ece71733$var$kLastResolve] = null;
            iterator[$8d8abad1ece71733$var$kLastReject] = null;
            resolve($8d8abad1ece71733$var$createIterResult(undefined, true));
        }
        iterator[$8d8abad1ece71733$var$kEnded] = true;
    });
    stream.on('readable', $8d8abad1ece71733$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $8d8abad1ece71733$var$createReadableStreamAsyncIterator;

});
parcelRegister("aWKch", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $7f8327ee141ab71b$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("hdIaW")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $7f8327ee141ab71b$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $7f8327ee141ab71b$var$noop() {}
function $7f8327ee141ab71b$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $7f8327ee141ab71b$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $7f8327ee141ab71b$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $7f8327ee141ab71b$var$once(callback || $7f8327ee141ab71b$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $7f8327ee141ab71b$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $7f8327ee141ab71b$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($7f8327ee141ab71b$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $7f8327ee141ab71b$var$eos;

});


parcelRegister("96xVs", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("ijYqS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $d568e0fa9f0a05db$var$Transform;

var $hdIaW = parcelRequire("hdIaW");
var $d568e0fa9f0a05db$require$_require$codes = $hdIaW.codes;
var $d568e0fa9f0a05db$var$ERR_METHOD_NOT_IMPLEMENTED = $d568e0fa9f0a05db$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d568e0fa9f0a05db$var$ERR_MULTIPLE_CALLBACK = $d568e0fa9f0a05db$require$_require$codes.ERR_MULTIPLE_CALLBACK, $d568e0fa9f0a05db$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $d568e0fa9f0a05db$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $d568e0fa9f0a05db$var$ERR_TRANSFORM_WITH_LENGTH_0 = $d568e0fa9f0a05db$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $8mYl7 = parcelRequire("8mYl7");

(parcelRequire("4rf1u"))($d568e0fa9f0a05db$var$Transform, $8mYl7);
function $d568e0fa9f0a05db$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $d568e0fa9f0a05db$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $d568e0fa9f0a05db$var$Transform(options) {
    if (!(this instanceof $d568e0fa9f0a05db$var$Transform)) return new $d568e0fa9f0a05db$var$Transform(options);
    $8mYl7.call(this, options);
    this._transformState = {
        afterTransform: $d568e0fa9f0a05db$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $d568e0fa9f0a05db$var$prefinish);
}
function $d568e0fa9f0a05db$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $d568e0fa9f0a05db$var$done(_this, er, data);
    });
    else $d568e0fa9f0a05db$var$done(this, null, null);
}
$d568e0fa9f0a05db$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $8mYl7.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$d568e0fa9f0a05db$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $d568e0fa9f0a05db$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$d568e0fa9f0a05db$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$d568e0fa9f0a05db$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$d568e0fa9f0a05db$var$Transform.prototype._destroy = function(err, cb) {
    $8mYl7.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $d568e0fa9f0a05db$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $d568e0fa9f0a05db$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $d568e0fa9f0a05db$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("lx5Ur", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $fad14384b4f479ad$var$PassThrough;

var $ijYqS = parcelRequire("ijYqS");

(parcelRequire("4rf1u"))($fad14384b4f479ad$var$PassThrough, $ijYqS);
function $fad14384b4f479ad$var$PassThrough(options) {
    if (!(this instanceof $fad14384b4f479ad$var$PassThrough)) return new $fad14384b4f479ad$var$PassThrough(options);
    $ijYqS.call(this, options);
}
$fad14384b4f479ad$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("1nXad", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $1025d5205bc01c8d$var$eos;
function $1025d5205bc01c8d$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $hdIaW = parcelRequire("hdIaW");
var $1025d5205bc01c8d$require$_require$codes = $hdIaW.codes;
var $1025d5205bc01c8d$var$ERR_MISSING_ARGS = $1025d5205bc01c8d$require$_require$codes.ERR_MISSING_ARGS, $1025d5205bc01c8d$var$ERR_STREAM_DESTROYED = $1025d5205bc01c8d$require$_require$codes.ERR_STREAM_DESTROYED;
function $1025d5205bc01c8d$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $1025d5205bc01c8d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $1025d5205bc01c8d$var$destroyer(stream, reading, writing, callback) {
    callback = $1025d5205bc01c8d$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($1025d5205bc01c8d$var$eos === undefined) $1025d5205bc01c8d$var$eos = (parcelRequire("aWKch"));
    $1025d5205bc01c8d$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($1025d5205bc01c8d$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $1025d5205bc01c8d$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $1025d5205bc01c8d$var$call(fn) {
    fn();
}
function $1025d5205bc01c8d$var$pipe(from, to) {
    return from.pipe(to);
}
function $1025d5205bc01c8d$var$popCallback(streams) {
    if (!streams.length) return $1025d5205bc01c8d$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $1025d5205bc01c8d$var$noop;
    return streams.pop();
}
function $1025d5205bc01c8d$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $1025d5205bc01c8d$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $1025d5205bc01c8d$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $1025d5205bc01c8d$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($1025d5205bc01c8d$var$call);
            if (reading) return;
            destroys.forEach($1025d5205bc01c8d$var$call);
            callback(error);
        });
    });
    return streams.reduce($1025d5205bc01c8d$var$pipe);
}
module.exports = $1025d5205bc01c8d$var$pipeline;

});




parcelRegister("ARbIS", function(module, exports) {
'use strict';

var $b0kMB = parcelRequire("b0kMB");
var $06ec9ef3c2dd0a68$require$Buffer = $b0kMB.Buffer;

var $4rf1u = parcelRequire("4rf1u");

var $2jd9p = parcelRequire("2jd9p");
var $06ec9ef3c2dd0a68$var$ARRAY16 = new Array(16);
var $06ec9ef3c2dd0a68$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $06ec9ef3c2dd0a68$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $06ec9ef3c2dd0a68$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $06ec9ef3c2dd0a68$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $06ec9ef3c2dd0a68$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $06ec9ef3c2dd0a68$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $06ec9ef3c2dd0a68$var$RIPEMD160() {
    $2jd9p.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$4rf1u($06ec9ef3c2dd0a68$var$RIPEMD160, $2jd9p);
$06ec9ef3c2dd0a68$var$RIPEMD160.prototype._update = function() {
    var words = $06ec9ef3c2dd0a68$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $06ec9ef3c2dd0a68$var$fn1(al, bl, cl, dl, el, words[$06ec9ef3c2dd0a68$var$zl[i]], $06ec9ef3c2dd0a68$var$hl[0], $06ec9ef3c2dd0a68$var$sl[i]);
            tr = $06ec9ef3c2dd0a68$var$fn5(ar, br, cr, dr, er, words[$06ec9ef3c2dd0a68$var$zr[i]], $06ec9ef3c2dd0a68$var$hr[0], $06ec9ef3c2dd0a68$var$sr[i]);
        } else if (i < 32) {
            tl = $06ec9ef3c2dd0a68$var$fn2(al, bl, cl, dl, el, words[$06ec9ef3c2dd0a68$var$zl[i]], $06ec9ef3c2dd0a68$var$hl[1], $06ec9ef3c2dd0a68$var$sl[i]);
            tr = $06ec9ef3c2dd0a68$var$fn4(ar, br, cr, dr, er, words[$06ec9ef3c2dd0a68$var$zr[i]], $06ec9ef3c2dd0a68$var$hr[1], $06ec9ef3c2dd0a68$var$sr[i]);
        } else if (i < 48) {
            tl = $06ec9ef3c2dd0a68$var$fn3(al, bl, cl, dl, el, words[$06ec9ef3c2dd0a68$var$zl[i]], $06ec9ef3c2dd0a68$var$hl[2], $06ec9ef3c2dd0a68$var$sl[i]);
            tr = $06ec9ef3c2dd0a68$var$fn3(ar, br, cr, dr, er, words[$06ec9ef3c2dd0a68$var$zr[i]], $06ec9ef3c2dd0a68$var$hr[2], $06ec9ef3c2dd0a68$var$sr[i]);
        } else if (i < 64) {
            tl = $06ec9ef3c2dd0a68$var$fn4(al, bl, cl, dl, el, words[$06ec9ef3c2dd0a68$var$zl[i]], $06ec9ef3c2dd0a68$var$hl[3], $06ec9ef3c2dd0a68$var$sl[i]);
            tr = $06ec9ef3c2dd0a68$var$fn2(ar, br, cr, dr, er, words[$06ec9ef3c2dd0a68$var$zr[i]], $06ec9ef3c2dd0a68$var$hr[3], $06ec9ef3c2dd0a68$var$sr[i]);
        } else {
            tl = $06ec9ef3c2dd0a68$var$fn5(al, bl, cl, dl, el, words[$06ec9ef3c2dd0a68$var$zl[i]], $06ec9ef3c2dd0a68$var$hl[4], $06ec9ef3c2dd0a68$var$sl[i]);
            tr = $06ec9ef3c2dd0a68$var$fn1(ar, br, cr, dr, er, words[$06ec9ef3c2dd0a68$var$zr[i]], $06ec9ef3c2dd0a68$var$hr[4], $06ec9ef3c2dd0a68$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $06ec9ef3c2dd0a68$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $06ec9ef3c2dd0a68$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$06ec9ef3c2dd0a68$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $06ec9ef3c2dd0a68$require$Buffer.alloc ? $06ec9ef3c2dd0a68$require$Buffer.alloc(20) : new $06ec9ef3c2dd0a68$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $06ec9ef3c2dd0a68$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $06ec9ef3c2dd0a68$var$fn1(a, b, c, d, e, m, k, s) {
    return $06ec9ef3c2dd0a68$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $06ec9ef3c2dd0a68$var$fn2(a, b, c, d, e, m, k, s) {
    return $06ec9ef3c2dd0a68$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $06ec9ef3c2dd0a68$var$fn3(a, b, c, d, e, m, k, s) {
    return $06ec9ef3c2dd0a68$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $06ec9ef3c2dd0a68$var$fn4(a, b, c, d, e, m, k, s) {
    return $06ec9ef3c2dd0a68$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $06ec9ef3c2dd0a68$var$fn5(a, b, c, d, e, m, k, s) {
    return $06ec9ef3c2dd0a68$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $06ec9ef3c2dd0a68$var$RIPEMD160;

});

parcelRegister("8UwRt", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("2AbFI"));

module.exports.sha1 = (parcelRequire("lseeu"));

module.exports.sha224 = (parcelRequire("iEKNT"));

module.exports.sha256 = (parcelRequire("7X5Nu"));

module.exports.sha384 = (parcelRequire("8Bq7c"));

module.exports.sha512 = (parcelRequire("89dMo"));

});
parcelRegister("2AbFI", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $7hB49 = parcelRequire("7hB49");

var $kxZ31 = parcelRequire("kxZ31");
var $1e17ff56cf0ab917$require$Buffer = $kxZ31.Buffer;
var $1e17ff56cf0ab917$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $1e17ff56cf0ab917$var$W = new Array(80);
function $1e17ff56cf0ab917$var$Sha() {
    this.init();
    this._w = $1e17ff56cf0ab917$var$W;
    $7hB49.call(this, 64, 56);
}
$4rf1u($1e17ff56cf0ab917$var$Sha, $7hB49);
$1e17ff56cf0ab917$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $1e17ff56cf0ab917$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $1e17ff56cf0ab917$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $1e17ff56cf0ab917$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$1e17ff56cf0ab917$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $1e17ff56cf0ab917$var$rotl5(a) + $1e17ff56cf0ab917$var$ft(s, b, c, d) + e + w[j] + $1e17ff56cf0ab917$var$K[s] | 0;
        e = d;
        d = c;
        c = $1e17ff56cf0ab917$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$1e17ff56cf0ab917$var$Sha.prototype._hash = function() {
    var H = $1e17ff56cf0ab917$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $1e17ff56cf0ab917$var$Sha;

});
parcelRegister("7hB49", function(module, exports) {
'use strict';

var $kxZ31 = parcelRequire("kxZ31");
var $54d6df7663070b2a$require$Buffer = $kxZ31.Buffer;

var $j6tHy = parcelRequire("j6tHy");
// prototype class for hash functions
function $54d6df7663070b2a$var$Hash(blockSize, finalSize) {
    this._block = $54d6df7663070b2a$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$54d6df7663070b2a$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $j6tHy(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$54d6df7663070b2a$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$54d6df7663070b2a$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $54d6df7663070b2a$var$Hash;

});
parcelRegister("kxZ31", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $ef563e8baef121b3$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $ef563e8baef121b3$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ef563e8baef121b3$var$Buffer.from && $ef563e8baef121b3$var$Buffer.alloc && $ef563e8baef121b3$var$Buffer.allocUnsafe && $ef563e8baef121b3$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $ef563e8baef121b3$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $ef563e8baef121b3$var$SafeBuffer;
}
function $ef563e8baef121b3$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ef563e8baef121b3$var$Buffer(arg, encodingOrOffset, length);
}
$ef563e8baef121b3$var$SafeBuffer.prototype = Object.create($ef563e8baef121b3$var$Buffer.prototype);
// Copy static methods from Buffer
$ef563e8baef121b3$var$copyProps($ef563e8baef121b3$var$Buffer, $ef563e8baef121b3$var$SafeBuffer);
$ef563e8baef121b3$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $ef563e8baef121b3$var$Buffer(arg, encodingOrOffset, length);
};
$ef563e8baef121b3$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $ef563e8baef121b3$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ef563e8baef121b3$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ef563e8baef121b3$var$Buffer(size);
};
$ef563e8baef121b3$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});

parcelRegister("j6tHy", function(module, exports) {
'use strict';

var $dt1TN = parcelRequire("dt1TN");
var $de859df1f54d641e$require$Buffer = $dt1TN.Buffer;

var $2jrtd = parcelRequire("2jrtd");

var $7ELRW = parcelRequire("7ELRW");
var $de859df1f54d641e$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $7ELRW(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $de859df1f54d641e$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $de859df1f54d641e$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $de859df1f54d641e$var$useFromArrayBuffer = $de859df1f54d641e$var$useArrayBuffer && ($de859df1f54d641e$require$Buffer.prototype instanceof Uint8Array || $de859df1f54d641e$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($de859df1f54d641e$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $de859df1f54d641e$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $de859df1f54d641e$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($de859df1f54d641e$var$useArrayBuffer && $de859df1f54d641e$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $de859df1f54d641e$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($de859df1f54d641e$var$useFromArrayBuffer) {
            var res = $de859df1f54d641e$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $de859df1f54d641e$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($de859df1f54d641e$var$useUint8Array && data instanceof Uint8Array) return $de859df1f54d641e$require$Buffer.from(data);
    var isArr = $2jrtd(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $de859df1f54d641e$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $de859df1f54d641e$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("dt1TN", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $9cdf74e07766ba35$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $9cdf74e07766ba35$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($9cdf74e07766ba35$var$Buffer.from && $9cdf74e07766ba35$var$Buffer.alloc && $9cdf74e07766ba35$var$Buffer.allocUnsafe && $9cdf74e07766ba35$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $9cdf74e07766ba35$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $9cdf74e07766ba35$var$SafeBuffer;
}
function $9cdf74e07766ba35$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $9cdf74e07766ba35$var$Buffer(arg, encodingOrOffset, length);
}
$9cdf74e07766ba35$var$SafeBuffer.prototype = Object.create($9cdf74e07766ba35$var$Buffer.prototype);
// Copy static methods from Buffer
$9cdf74e07766ba35$var$copyProps($9cdf74e07766ba35$var$Buffer, $9cdf74e07766ba35$var$SafeBuffer);
$9cdf74e07766ba35$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $9cdf74e07766ba35$var$Buffer(arg, encodingOrOffset, length);
};
$9cdf74e07766ba35$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $9cdf74e07766ba35$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$9cdf74e07766ba35$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $9cdf74e07766ba35$var$Buffer(size);
};
$9cdf74e07766ba35$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});

parcelRegister("2jrtd", function(module, exports) {
var $1af2aa1f4d2c20e3$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $1af2aa1f4d2c20e3$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("7ELRW", function(module, exports) {
'use strict';

var $dXcsU = parcelRequire("dXcsU");

var $8FFUY = parcelRequire("8FFUY");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $5931669c373169df$var$$typedArrayBuffer = $8FFUY('TypedArray.prototype.buffer', true);

var $ccC26 = parcelRequire("ccC26");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $5931669c373169df$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$ccC26(x)) throw new $dXcsU('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("dXcsU", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("8FFUY", function(module, exports) {
'use strict';

var $2WVT8 = parcelRequire("2WVT8");

var $2ko8I = parcelRequire("2ko8I");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $6502ab18b703b296$var$$indexOf = $2ko8I([
    $2WVT8('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $2WVT8(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $6502ab18b703b296$var$$indexOf(name, '.prototype.') > -1) return $2ko8I(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("2WVT8", function(module, exports) {
'use strict';
var $225de6eea0795db5$var$undefined1;

var $chhQz = parcelRequire("chhQz");

var $ijDaN = parcelRequire("ijDaN");

var $jQVlZ = parcelRequire("jQVlZ");

var $6KITv = parcelRequire("6KITv");

var $5iLG5 = parcelRequire("5iLG5");

var $hG9Es = parcelRequire("hG9Es");

var $dXcsU = parcelRequire("dXcsU");

var $388xh = parcelRequire("388xh");

var $6L456 = parcelRequire("6L456");

var $C0IVc = parcelRequire("C0IVc");

var $1vHUq = parcelRequire("1vHUq");

var $7UeGD = parcelRequire("7UeGD");

var $al1Af = parcelRequire("al1Af");

var $ef5uv = parcelRequire("ef5uv");

var $9DmRS = parcelRequire("9DmRS");
var $225de6eea0795db5$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $225de6eea0795db5$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $225de6eea0795db5$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $59hX3 = parcelRequire("59hX3");

var $9G34V = parcelRequire("9G34V");
var $225de6eea0795db5$var$throwTypeError = function() {
    throw new $dXcsU();
};
var $225de6eea0795db5$var$ThrowTypeError = $59hX3 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $225de6eea0795db5$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $59hX3(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $225de6eea0795db5$var$throwTypeError;
        }
    }
}() : $225de6eea0795db5$var$throwTypeError;

var $225de6eea0795db5$var$hasSymbols = (parcelRequire("bvbJq"))();

var $bTMa3 = parcelRequire("bTMa3");

var $cR4yr = parcelRequire("cR4yr");

var $aRaRY = parcelRequire("aRaRY");

var $fkF4E = parcelRequire("fkF4E");

var $WOe8b = parcelRequire("WOe8b");
var $225de6eea0795db5$var$needsEval = {};
var $225de6eea0795db5$var$TypedArray = typeof Uint8Array === 'undefined' || !$bTMa3 ? undefined : $bTMa3(Uint8Array);
var $225de6eea0795db5$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $225de6eea0795db5$var$hasSymbols && $bTMa3 ? $bTMa3([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $225de6eea0795db5$var$needsEval,
    '%AsyncGenerator%': $225de6eea0795db5$var$needsEval,
    '%AsyncGeneratorFunction%': $225de6eea0795db5$var$needsEval,
    '%AsyncIteratorPrototype%': $225de6eea0795db5$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ijDaN,
    '%eval%': eval,
    '%EvalError%': $jQVlZ,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $225de6eea0795db5$var$$Function,
    '%GeneratorFunction%': $225de6eea0795db5$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $225de6eea0795db5$var$hasSymbols && $bTMa3 ? $bTMa3($bTMa3([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$225de6eea0795db5$var$hasSymbols || !$bTMa3 ? undefined : $bTMa3(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $chhQz,
    '%Object.getOwnPropertyDescriptor%': $59hX3,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6KITv,
    '%ReferenceError%': $5iLG5,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$225de6eea0795db5$var$hasSymbols || !$bTMa3 ? undefined : $bTMa3(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $225de6eea0795db5$var$hasSymbols && $bTMa3 ? $bTMa3(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $225de6eea0795db5$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $hG9Es,
    '%ThrowTypeError%': $225de6eea0795db5$var$ThrowTypeError,
    '%TypedArray%': $225de6eea0795db5$var$TypedArray,
    '%TypeError%': $dXcsU,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $388xh,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $WOe8b,
    '%Function.prototype.apply%': $fkF4E,
    '%Object.defineProperty%': $9G34V,
    '%Object.getPrototypeOf%': $cR4yr,
    '%Math.abs%': $6L456,
    '%Math.floor%': $C0IVc,
    '%Math.max%': $1vHUq,
    '%Math.min%': $7UeGD,
    '%Math.pow%': $al1Af,
    '%Math.round%': $ef5uv,
    '%Math.sign%': $9DmRS,
    '%Reflect.getPrototypeOf%': $aRaRY
};
if ($bTMa3) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $225de6eea0795db5$var$errorProto = $bTMa3($bTMa3(e));
    $225de6eea0795db5$var$INTRINSICS['%Error.prototype%'] = $225de6eea0795db5$var$errorProto;
}
var $225de6eea0795db5$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $225de6eea0795db5$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $225de6eea0795db5$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $225de6eea0795db5$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $bTMa3) value = $bTMa3(gen.prototype);
    }
    $225de6eea0795db5$var$INTRINSICS[name] = value;
    return value;
};
var $225de6eea0795db5$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $9uzLU = parcelRequire("9uzLU");

var $jlMZb = parcelRequire("jlMZb");
var $225de6eea0795db5$var$$concat = $9uzLU.call($WOe8b, Array.prototype.concat);
var $225de6eea0795db5$var$$spliceApply = $9uzLU.call($fkF4E, Array.prototype.splice);
var $225de6eea0795db5$var$$replace = $9uzLU.call($WOe8b, String.prototype.replace);
var $225de6eea0795db5$var$$strSlice = $9uzLU.call($WOe8b, String.prototype.slice);
var $225de6eea0795db5$var$$exec = $9uzLU.call($WOe8b, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $225de6eea0795db5$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $225de6eea0795db5$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $225de6eea0795db5$var$stringToPath = function stringToPath(string) {
    var first = $225de6eea0795db5$var$$strSlice(string, 0, 1);
    var last = $225de6eea0795db5$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $hG9Es('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $hG9Es('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $225de6eea0795db5$var$$replace(string, $225de6eea0795db5$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $225de6eea0795db5$var$$replace(subString, $225de6eea0795db5$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $225de6eea0795db5$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($jlMZb($225de6eea0795db5$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $225de6eea0795db5$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($jlMZb($225de6eea0795db5$var$INTRINSICS, intrinsicName)) {
        var value = $225de6eea0795db5$var$INTRINSICS[intrinsicName];
        if (value === $225de6eea0795db5$var$needsEval) value = $225de6eea0795db5$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $dXcsU('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $hG9Es('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $dXcsU('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $dXcsU('"allowMissing" argument must be a boolean');
    if ($225de6eea0795db5$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $hG9Es('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $225de6eea0795db5$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $225de6eea0795db5$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $225de6eea0795db5$var$$spliceApply(parts, $225de6eea0795db5$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $225de6eea0795db5$var$$strSlice(part, 0, 1);
        var last = $225de6eea0795db5$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $hG9Es('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($jlMZb($225de6eea0795db5$var$INTRINSICS, intrinsicRealName)) value = $225de6eea0795db5$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $dXcsU('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($59hX3 && i + 1 >= parts.length) {
                var desc = $59hX3(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $jlMZb(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $225de6eea0795db5$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("chhQz", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("ijDaN", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("jQVlZ", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("6KITv", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("5iLG5", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("hG9Es", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("388xh", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("6L456", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("C0IVc", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("1vHUq", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("7UeGD", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("al1Af", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("ef5uv", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("9DmRS", function(module, exports) {
'use strict';

var $ambZH = parcelRequire("ambZH");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($ambZH(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("ambZH", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("59hX3", function(module, exports) {
'use strict';

var $50OJs = parcelRequire("50OJs");
var $3bfbb7cd74b05da6$require$$gOPD = $50OJs;
if ($3bfbb7cd74b05da6$require$$gOPD) try {
    $3bfbb7cd74b05da6$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $3bfbb7cd74b05da6$require$$gOPD = null;
}
module.exports = $3bfbb7cd74b05da6$require$$gOPD;

});
parcelRegister("50OJs", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("9G34V", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $70ba6c9aa188ac5d$var$$defineProperty = Object.defineProperty || false;
if ($70ba6c9aa188ac5d$var$$defineProperty) try {
    $70ba6c9aa188ac5d$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $70ba6c9aa188ac5d$var$$defineProperty = false;
}
module.exports = $70ba6c9aa188ac5d$var$$defineProperty;

});

parcelRegister("bvbJq", function(module, exports) {
'use strict';
var $85fbb0999fc0e545$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $jb3CF = parcelRequire("jb3CF");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $85fbb0999fc0e545$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $85fbb0999fc0e545$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $jb3CF();
};

});
parcelRegister("jb3CF", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("bTMa3", function(module, exports) {
'use strict';

var $aRaRY = parcelRequire("aRaRY");

var $cR4yr = parcelRequire("cR4yr");

var $aLzCh = parcelRequire("aLzCh");
/** @type {import('.')} */ module.exports = $aRaRY ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $aRaRY(O);
} : $cR4yr ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $cR4yr(O);
} : $aLzCh ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $aLzCh(O);
} : null;

});
parcelRegister("aRaRY", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("cR4yr", function(module, exports) {
'use strict';

var $kF0c7 = parcelRequire("kF0c7");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $kF0c7.getPrototypeOf || null;

});
parcelRegister("kF0c7", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});


parcelRegister("aLzCh", function(module, exports) {
'use strict';

var $2ko8I = parcelRequire("2ko8I");

var $59hX3 = parcelRequire("59hX3");
var $7d69ebd3caa51734$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $7d69ebd3caa51734$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $7d69ebd3caa51734$var$desc = !!$7d69ebd3caa51734$var$hasProtoAccessor && $59hX3 && $59hX3(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $7d69ebd3caa51734$var$$Object = Object;
var $7d69ebd3caa51734$var$$getPrototypeOf = $7d69ebd3caa51734$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $7d69ebd3caa51734$var$desc && typeof $7d69ebd3caa51734$var$desc.get === 'function' ? $2ko8I([
    $7d69ebd3caa51734$var$desc.get
]) : typeof $7d69ebd3caa51734$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $7d69ebd3caa51734$var$$getPrototypeOf(value == null ? value : $7d69ebd3caa51734$var$$Object(value));
} : false;

});
parcelRegister("2ko8I", function(module, exports) {
'use strict';

var $9uzLU = parcelRequire("9uzLU");

var $dXcsU = parcelRequire("dXcsU");

var $WOe8b = parcelRequire("WOe8b");

var $abWhq = parcelRequire("abWhq");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $dXcsU('a function is required');
    return $abWhq($9uzLU, $WOe8b, args);
};

});
parcelRegister("9uzLU", function(module, exports) {
'use strict';

var $2VToS = parcelRequire("2VToS");
module.exports = Function.prototype.bind || $2VToS;

});
parcelRegister("2VToS", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $222be0f5026b0e60$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $222be0f5026b0e60$var$toStr = Object.prototype.toString;
var $222be0f5026b0e60$var$max = Math.max;
var $222be0f5026b0e60$var$funcType = '[object Function]';
var $222be0f5026b0e60$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $222be0f5026b0e60$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $222be0f5026b0e60$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $222be0f5026b0e60$var$toStr.apply(target) !== $222be0f5026b0e60$var$funcType) throw new TypeError($222be0f5026b0e60$var$ERROR_MESSAGE + target);
    var args = $222be0f5026b0e60$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $222be0f5026b0e60$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $222be0f5026b0e60$var$concatty(args, arguments));
    };
    var boundLength = $222be0f5026b0e60$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $222be0f5026b0e60$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("WOe8b", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("abWhq", function(module, exports) {
'use strict';

var $9uzLU = parcelRequire("9uzLU");

var $fkF4E = parcelRequire("fkF4E");

var $WOe8b = parcelRequire("WOe8b");

var $eWb38 = parcelRequire("eWb38");
/** @type {import('./actualApply')} */ module.exports = $eWb38 || $9uzLU.call($WOe8b, $fkF4E);

});
parcelRegister("fkF4E", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("eWb38", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("jlMZb", function(module, exports) {
'use strict';
var $e165fa13bcec8ba3$var$call = Function.prototype.call;
var $e165fa13bcec8ba3$var$$hasOwn = Object.prototype.hasOwnProperty;

var $9uzLU = parcelRequire("9uzLU");
/** @type {import('.')} */ module.exports = $9uzLU.call($e165fa13bcec8ba3$var$call, $e165fa13bcec8ba3$var$$hasOwn);

});



parcelRegister("ccC26", function(module, exports) {
'use strict';

var $cQnYv = parcelRequire("cQnYv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$cQnYv(value);
};

});
parcelRegister("cQnYv", function(module, exports) {
'use strict';

var $iBWhN = parcelRequire("iBWhN");

var $9eDSV = parcelRequire("9eDSV");

var $2CFNq = parcelRequire("2CFNq");

var $8FFUY = parcelRequire("8FFUY");

var $59hX3 = parcelRequire("59hX3");

var $bTMa3 = parcelRequire("bTMa3");
var $959cf0468f95f10f$var$$toString = $8FFUY('Object.prototype.toString');

var $959cf0468f95f10f$var$hasToStringTag = (parcelRequire("gjgWz"))();
var $959cf0468f95f10f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $959cf0468f95f10f$var$typedArrays = $9eDSV();
var $959cf0468f95f10f$var$$slice = $8FFUY('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $959cf0468f95f10f$var$$indexOf = $8FFUY('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $959cf0468f95f10f$var$cache = {
    __proto__: null
};
if ($959cf0468f95f10f$var$hasToStringTag && $59hX3 && $bTMa3) $iBWhN($959cf0468f95f10f$var$typedArrays, function(typedArray) {
    var arr = new $959cf0468f95f10f$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $bTMa3) {
        var proto = $bTMa3(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $59hX3(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $bTMa3(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $59hX3(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $959cf0468f95f10f$var$cache['$' + typedArray] = $2CFNq(descriptor.get);
    }
});
else $iBWhN($959cf0468f95f10f$var$typedArrays, function(typedArray) {
    var arr = new $959cf0468f95f10f$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $959cf0468f95f10f$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $2CFNq(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $959cf0468f95f10f$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $iBWhN(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $959cf0468f95f10f$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $959cf0468f95f10f$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $959cf0468f95f10f$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $iBWhN(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $959cf0468f95f10f$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $959cf0468f95f10f$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$959cf0468f95f10f$var$hasToStringTag) {
        /** @type {string} */ var tag = $959cf0468f95f10f$var$$slice($959cf0468f95f10f$var$$toString(value), 8, -1);
        if ($959cf0468f95f10f$var$$indexOf($959cf0468f95f10f$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $959cf0468f95f10f$var$trySlices(value);
    }
    if (!$59hX3) return null;
     // unknown engine
    return $959cf0468f95f10f$var$tryTypedArrays(value);
};

});
parcelRegister("iBWhN", function(module, exports) {
'use strict';

var $cgPQb = parcelRequire("cgPQb");
var $d8c8e5128f43b463$var$toStr = Object.prototype.toString;
var $d8c8e5128f43b463$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $d8c8e5128f43b463$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($d8c8e5128f43b463$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $d8c8e5128f43b463$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $d8c8e5128f43b463$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($d8c8e5128f43b463$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $d8c8e5128f43b463$var$isArray(x) {
    return $d8c8e5128f43b463$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$cgPQb(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($d8c8e5128f43b463$var$isArray(list)) $d8c8e5128f43b463$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $d8c8e5128f43b463$var$forEachString(list, iterator, receiver);
    else $d8c8e5128f43b463$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("cgPQb", function(module, exports) {
'use strict';
var $8eef312919ac0999$var$fnToStr = Function.prototype.toString;
var $8eef312919ac0999$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $8eef312919ac0999$var$badArrayLike;
var $8eef312919ac0999$var$isCallableMarker;
if (typeof $8eef312919ac0999$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $8eef312919ac0999$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $8eef312919ac0999$var$isCallableMarker;
        }
    });
    $8eef312919ac0999$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $8eef312919ac0999$var$reflectApply(function() {
        throw 42;
    }, null, $8eef312919ac0999$var$badArrayLike);
} catch (_) {
    if (_ !== $8eef312919ac0999$var$isCallableMarker) $8eef312919ac0999$var$reflectApply = null;
}
else $8eef312919ac0999$var$reflectApply = null;
var $8eef312919ac0999$var$constructorRegex = /^\s*class\b/;
var $8eef312919ac0999$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $8eef312919ac0999$var$fnToStr.call(value);
        return $8eef312919ac0999$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $8eef312919ac0999$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($8eef312919ac0999$var$isES6ClassFn(value)) return false;
        $8eef312919ac0999$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $8eef312919ac0999$var$toStr = Object.prototype.toString;
var $8eef312919ac0999$var$objectClass = '[object Object]';
var $8eef312919ac0999$var$fnClass = '[object Function]';
var $8eef312919ac0999$var$genClass = '[object GeneratorFunction]';
var $8eef312919ac0999$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $8eef312919ac0999$var$ddaClass2 = '[object HTML document.all class]';
var $8eef312919ac0999$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $8eef312919ac0999$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $8eef312919ac0999$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $8eef312919ac0999$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $8eef312919ac0999$var$all = document.all;
    if ($8eef312919ac0999$var$toStr.call($8eef312919ac0999$var$all) === $8eef312919ac0999$var$toStr.call(document.all)) $8eef312919ac0999$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($8eef312919ac0999$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $8eef312919ac0999$var$toStr.call(value);
            return (str === $8eef312919ac0999$var$ddaClass || str === $8eef312919ac0999$var$ddaClass2 || str === $8eef312919ac0999$var$ddaClass3 // opera 12.16
             || str === $8eef312919ac0999$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $8eef312919ac0999$var$reflectApply ? function isCallable(value) {
    if ($8eef312919ac0999$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $8eef312919ac0999$var$reflectApply(value, null, $8eef312919ac0999$var$badArrayLike);
    } catch (e) {
        if (e !== $8eef312919ac0999$var$isCallableMarker) return false;
    }
    return !$8eef312919ac0999$var$isES6ClassFn(value) && $8eef312919ac0999$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($8eef312919ac0999$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($8eef312919ac0999$var$hasToStringTag) return $8eef312919ac0999$var$tryFunctionObject(value);
    if ($8eef312919ac0999$var$isES6ClassFn(value)) return false;
    var strClass = $8eef312919ac0999$var$toStr.call(value);
    if (strClass !== $8eef312919ac0999$var$fnClass && strClass !== $8eef312919ac0999$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $8eef312919ac0999$var$tryFunctionObject(value);
};

});


parcelRegister("9eDSV", function(module, exports) {
'use strict';

var $lvhOf = parcelRequire("lvhOf");
var $6b945c2bd06057d5$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $lvhOf.length; i++)if (typeof $6b945c2bd06057d5$var$g[$lvhOf[i]] === 'function') // @ts-expect-error
    out[out.length] = $lvhOf[i];
    return out;
};

});
parcelRegister("lvhOf", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("2CFNq", function(module, exports) {
'use strict';

var $L4DFZ = parcelRequire("L4DFZ");

var $9G34V = parcelRequire("9G34V");

var $2ko8I = parcelRequire("2ko8I");

var $jEfg3 = parcelRequire("jEfg3");
module.exports = function callBind(originalFunction) {
    var func = $2ko8I(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $L4DFZ(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($9G34V) $9G34V(module.exports, 'apply', {
    value: $jEfg3
});
else module.exports.apply = $jEfg3;

});
parcelRegister("L4DFZ", function(module, exports) {
'use strict';

var $FItZv = parcelRequire("FItZv");

var $l5Lg9 = parcelRequire("l5Lg9");

var $08d7fd18fcec339b$var$hasDescriptors = (parcelRequire("jqyS7"))();

var $59hX3 = parcelRequire("59hX3");

var $dXcsU = parcelRequire("dXcsU");
var $08d7fd18fcec339b$var$$floor = $FItZv('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $dXcsU('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $08d7fd18fcec339b$var$$floor(length) !== length) throw new $dXcsU('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $59hX3) {
        var desc = $59hX3(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($08d7fd18fcec339b$var$hasDescriptors) $l5Lg9(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $l5Lg9(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("FItZv", function(module, exports) {
'use strict';
var $07d655cafc09bdab$var$undefined1;

var $kF0c7 = parcelRequire("kF0c7");

var $ijDaN = parcelRequire("ijDaN");

var $jQVlZ = parcelRequire("jQVlZ");

var $6KITv = parcelRequire("6KITv");

var $5iLG5 = parcelRequire("5iLG5");

var $hG9Es = parcelRequire("hG9Es");

var $dXcsU = parcelRequire("dXcsU");

var $388xh = parcelRequire("388xh");

var $6L456 = parcelRequire("6L456");

var $C0IVc = parcelRequire("C0IVc");

var $1vHUq = parcelRequire("1vHUq");

var $7UeGD = parcelRequire("7UeGD");

var $al1Af = parcelRequire("al1Af");

var $ef5uv = parcelRequire("ef5uv");

var $9DmRS = parcelRequire("9DmRS");
var $07d655cafc09bdab$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $07d655cafc09bdab$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $07d655cafc09bdab$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $59hX3 = parcelRequire("59hX3");

var $9G34V = parcelRequire("9G34V");
var $07d655cafc09bdab$var$throwTypeError = function() {
    throw new $dXcsU();
};
var $07d655cafc09bdab$var$ThrowTypeError = $59hX3 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $07d655cafc09bdab$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $59hX3(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $07d655cafc09bdab$var$throwTypeError;
        }
    }
}() : $07d655cafc09bdab$var$throwTypeError;

var $07d655cafc09bdab$var$hasSymbols = (parcelRequire("bvbJq"))();

var $bTMa3 = parcelRequire("bTMa3");

var $cR4yr = parcelRequire("cR4yr");

var $aRaRY = parcelRequire("aRaRY");

var $fkF4E = parcelRequire("fkF4E");

var $WOe8b = parcelRequire("WOe8b");
var $07d655cafc09bdab$var$needsEval = {};
var $07d655cafc09bdab$var$TypedArray = typeof Uint8Array === 'undefined' || !$bTMa3 ? undefined : $bTMa3(Uint8Array);
var $07d655cafc09bdab$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $07d655cafc09bdab$var$hasSymbols && $bTMa3 ? $bTMa3([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $07d655cafc09bdab$var$needsEval,
    '%AsyncGenerator%': $07d655cafc09bdab$var$needsEval,
    '%AsyncGeneratorFunction%': $07d655cafc09bdab$var$needsEval,
    '%AsyncIteratorPrototype%': $07d655cafc09bdab$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ijDaN,
    '%eval%': eval,
    '%EvalError%': $jQVlZ,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $07d655cafc09bdab$var$$Function,
    '%GeneratorFunction%': $07d655cafc09bdab$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $07d655cafc09bdab$var$hasSymbols && $bTMa3 ? $bTMa3($bTMa3([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$07d655cafc09bdab$var$hasSymbols || !$bTMa3 ? undefined : $bTMa3(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $kF0c7,
    '%Object.getOwnPropertyDescriptor%': $59hX3,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6KITv,
    '%ReferenceError%': $5iLG5,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$07d655cafc09bdab$var$hasSymbols || !$bTMa3 ? undefined : $bTMa3(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $07d655cafc09bdab$var$hasSymbols && $bTMa3 ? $bTMa3(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $07d655cafc09bdab$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $hG9Es,
    '%ThrowTypeError%': $07d655cafc09bdab$var$ThrowTypeError,
    '%TypedArray%': $07d655cafc09bdab$var$TypedArray,
    '%TypeError%': $dXcsU,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $388xh,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $WOe8b,
    '%Function.prototype.apply%': $fkF4E,
    '%Object.defineProperty%': $9G34V,
    '%Object.getPrototypeOf%': $cR4yr,
    '%Math.abs%': $6L456,
    '%Math.floor%': $C0IVc,
    '%Math.max%': $1vHUq,
    '%Math.min%': $7UeGD,
    '%Math.pow%': $al1Af,
    '%Math.round%': $ef5uv,
    '%Math.sign%': $9DmRS,
    '%Reflect.getPrototypeOf%': $aRaRY
};
if ($bTMa3) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $07d655cafc09bdab$var$errorProto = $bTMa3($bTMa3(e));
    $07d655cafc09bdab$var$INTRINSICS['%Error.prototype%'] = $07d655cafc09bdab$var$errorProto;
}
var $07d655cafc09bdab$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $07d655cafc09bdab$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $07d655cafc09bdab$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $07d655cafc09bdab$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $bTMa3) value = $bTMa3(gen.prototype);
    }
    $07d655cafc09bdab$var$INTRINSICS[name] = value;
    return value;
};
var $07d655cafc09bdab$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $9uzLU = parcelRequire("9uzLU");

var $jlMZb = parcelRequire("jlMZb");
var $07d655cafc09bdab$var$$concat = $9uzLU.call($WOe8b, Array.prototype.concat);
var $07d655cafc09bdab$var$$spliceApply = $9uzLU.call($fkF4E, Array.prototype.splice);
var $07d655cafc09bdab$var$$replace = $9uzLU.call($WOe8b, String.prototype.replace);
var $07d655cafc09bdab$var$$strSlice = $9uzLU.call($WOe8b, String.prototype.slice);
var $07d655cafc09bdab$var$$exec = $9uzLU.call($WOe8b, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $07d655cafc09bdab$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $07d655cafc09bdab$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $07d655cafc09bdab$var$stringToPath = function stringToPath(string) {
    var first = $07d655cafc09bdab$var$$strSlice(string, 0, 1);
    var last = $07d655cafc09bdab$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $hG9Es('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $hG9Es('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $07d655cafc09bdab$var$$replace(string, $07d655cafc09bdab$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $07d655cafc09bdab$var$$replace(subString, $07d655cafc09bdab$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $07d655cafc09bdab$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($jlMZb($07d655cafc09bdab$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $07d655cafc09bdab$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($jlMZb($07d655cafc09bdab$var$INTRINSICS, intrinsicName)) {
        var value = $07d655cafc09bdab$var$INTRINSICS[intrinsicName];
        if (value === $07d655cafc09bdab$var$needsEval) value = $07d655cafc09bdab$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $dXcsU('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $hG9Es('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $dXcsU('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $dXcsU('"allowMissing" argument must be a boolean');
    if ($07d655cafc09bdab$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $hG9Es('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $07d655cafc09bdab$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $07d655cafc09bdab$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $07d655cafc09bdab$var$$spliceApply(parts, $07d655cafc09bdab$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $07d655cafc09bdab$var$$strSlice(part, 0, 1);
        var last = $07d655cafc09bdab$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $hG9Es('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($jlMZb($07d655cafc09bdab$var$INTRINSICS, intrinsicRealName)) value = $07d655cafc09bdab$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $dXcsU('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($59hX3 && i + 1 >= parts.length) {
                var desc = $59hX3(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $jlMZb(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $07d655cafc09bdab$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});

parcelRegister("l5Lg9", function(module, exports) {
'use strict';

var $9G34V = parcelRequire("9G34V");

var $hG9Es = parcelRequire("hG9Es");

var $dXcsU = parcelRequire("dXcsU");

var $59hX3 = parcelRequire("59hX3");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $dXcsU('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $dXcsU('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $dXcsU('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $dXcsU('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $dXcsU('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $dXcsU('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$59hX3 && $59hX3(obj, property);
    if ($9G34V) $9G34V(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $hG9Es('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("jqyS7", function(module, exports) {
'use strict';

var $9G34V = parcelRequire("9G34V");
var $e24b7edc1184fbb6$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$9G34V;
};
$e24b7edc1184fbb6$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$9G34V) return null;
    try {
        return $9G34V([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $e24b7edc1184fbb6$var$hasPropertyDescriptors;

});


parcelRegister("jEfg3", function(module, exports) {
'use strict';

var $9uzLU = parcelRequire("9uzLU");

var $fkF4E = parcelRequire("fkF4E");

var $abWhq = parcelRequire("abWhq");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $abWhq($9uzLU, $fkF4E, arguments);
};

});


parcelRegister("gjgWz", function(module, exports) {
'use strict';

var $jb3CF = parcelRequire("jb3CF");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $jb3CF() && !!Symbol.toStringTag;
};

});







parcelRegister("lseeu", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $7hB49 = parcelRequire("7hB49");

var $kxZ31 = parcelRequire("kxZ31");
var $f9e740cb76cdbd73$require$Buffer = $kxZ31.Buffer;
var $f9e740cb76cdbd73$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $f9e740cb76cdbd73$var$W = new Array(80);
function $f9e740cb76cdbd73$var$Sha1() {
    this.init();
    this._w = $f9e740cb76cdbd73$var$W;
    $7hB49.call(this, 64, 56);
}
$4rf1u($f9e740cb76cdbd73$var$Sha1, $7hB49);
$f9e740cb76cdbd73$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $f9e740cb76cdbd73$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $f9e740cb76cdbd73$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $f9e740cb76cdbd73$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $f9e740cb76cdbd73$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$f9e740cb76cdbd73$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $f9e740cb76cdbd73$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $f9e740cb76cdbd73$var$rotl5(a) + $f9e740cb76cdbd73$var$ft(s, b, c, d) + e + w[j] + $f9e740cb76cdbd73$var$K[s] | 0;
        e = d;
        d = c;
        c = $f9e740cb76cdbd73$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$f9e740cb76cdbd73$var$Sha1.prototype._hash = function() {
    var H = $f9e740cb76cdbd73$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $f9e740cb76cdbd73$var$Sha1;

});

parcelRegister("iEKNT", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $7X5Nu = parcelRequire("7X5Nu");

var $7hB49 = parcelRequire("7hB49");

var $kxZ31 = parcelRequire("kxZ31");
var $d95044a834728f7a$require$Buffer = $kxZ31.Buffer;
var $d95044a834728f7a$var$W = new Array(64);
function $d95044a834728f7a$var$Sha224() {
    this.init();
    this._w = $d95044a834728f7a$var$W; // new Array(64)
    $7hB49.call(this, 64, 56);
}
$4rf1u($d95044a834728f7a$var$Sha224, $7X5Nu);
$d95044a834728f7a$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$d95044a834728f7a$var$Sha224.prototype._hash = function() {
    var H = $d95044a834728f7a$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $d95044a834728f7a$var$Sha224;

});
parcelRegister("7X5Nu", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $7hB49 = parcelRequire("7hB49");

var $kxZ31 = parcelRequire("kxZ31");
var $5ca28a48567b7328$require$Buffer = $kxZ31.Buffer;
var $5ca28a48567b7328$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $5ca28a48567b7328$var$W = new Array(64);
function $5ca28a48567b7328$var$Sha256() {
    this.init();
    this._w = $5ca28a48567b7328$var$W; // new Array(64)
    $7hB49.call(this, 64, 56);
}
$4rf1u($5ca28a48567b7328$var$Sha256, $7hB49);
$5ca28a48567b7328$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $5ca28a48567b7328$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $5ca28a48567b7328$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $5ca28a48567b7328$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $5ca28a48567b7328$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $5ca28a48567b7328$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $5ca28a48567b7328$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$5ca28a48567b7328$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $5ca28a48567b7328$var$gamma1(w[i - 2]) + w[i - 7] + $5ca28a48567b7328$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $5ca28a48567b7328$var$sigma1(e) + $5ca28a48567b7328$var$ch(e, f, g) + $5ca28a48567b7328$var$K[j] + w[j] | 0;
        var T2 = $5ca28a48567b7328$var$sigma0(a) + $5ca28a48567b7328$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$5ca28a48567b7328$var$Sha256.prototype._hash = function() {
    var H = $5ca28a48567b7328$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $5ca28a48567b7328$var$Sha256;

});


parcelRegister("8Bq7c", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $89dMo = parcelRequire("89dMo");

var $7hB49 = parcelRequire("7hB49");

var $kxZ31 = parcelRequire("kxZ31");
var $643609579789b876$require$Buffer = $kxZ31.Buffer;
var $643609579789b876$var$W = new Array(160);
function $643609579789b876$var$Sha384() {
    this.init();
    this._w = $643609579789b876$var$W;
    $7hB49.call(this, 128, 112);
}
$4rf1u($643609579789b876$var$Sha384, $89dMo);
$643609579789b876$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$643609579789b876$var$Sha384.prototype._hash = function() {
    var H = $643609579789b876$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $643609579789b876$var$Sha384;

});
parcelRegister("89dMo", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $7hB49 = parcelRequire("7hB49");

var $kxZ31 = parcelRequire("kxZ31");
var $5ee9da54c9c0797d$require$Buffer = $kxZ31.Buffer;
var $5ee9da54c9c0797d$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $5ee9da54c9c0797d$var$W = new Array(160);
function $5ee9da54c9c0797d$var$Sha512() {
    this.init();
    this._w = $5ee9da54c9c0797d$var$W;
    $7hB49.call(this, 128, 112);
}
$4rf1u($5ee9da54c9c0797d$var$Sha512, $7hB49);
$5ee9da54c9c0797d$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $5ee9da54c9c0797d$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $5ee9da54c9c0797d$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $5ee9da54c9c0797d$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $5ee9da54c9c0797d$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $5ee9da54c9c0797d$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $5ee9da54c9c0797d$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $5ee9da54c9c0797d$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $5ee9da54c9c0797d$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $5ee9da54c9c0797d$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$5ee9da54c9c0797d$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $5ee9da54c9c0797d$var$Gamma0(xh, xl);
        var gamma0l = $5ee9da54c9c0797d$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $5ee9da54c9c0797d$var$Gamma1(xh, xl);
        var gamma1l = $5ee9da54c9c0797d$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $5ee9da54c9c0797d$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $5ee9da54c9c0797d$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $5ee9da54c9c0797d$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $5ee9da54c9c0797d$var$maj(ah, bh, ch);
        var majl = $5ee9da54c9c0797d$var$maj(al, bl, cl);
        var sigma0h = $5ee9da54c9c0797d$var$sigma0(ah, al);
        var sigma0l = $5ee9da54c9c0797d$var$sigma0(al, ah);
        var sigma1h = $5ee9da54c9c0797d$var$sigma1(eh, el);
        var sigma1l = $5ee9da54c9c0797d$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $5ee9da54c9c0797d$var$K[j];
        var Kil = $5ee9da54c9c0797d$var$K[j + 1];
        var chh = $5ee9da54c9c0797d$var$Ch(eh, fh, gh);
        var chl = $5ee9da54c9c0797d$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $5ee9da54c9c0797d$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $5ee9da54c9c0797d$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $5ee9da54c9c0797d$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $5ee9da54c9c0797d$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $5ee9da54c9c0797d$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $5ee9da54c9c0797d$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $5ee9da54c9c0797d$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $5ee9da54c9c0797d$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $5ee9da54c9c0797d$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $5ee9da54c9c0797d$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $5ee9da54c9c0797d$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $5ee9da54c9c0797d$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $5ee9da54c9c0797d$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $5ee9da54c9c0797d$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $5ee9da54c9c0797d$var$getCarry(this._hl, hl) | 0;
};
$5ee9da54c9c0797d$var$Sha512.prototype._hash = function() {
    var H = $5ee9da54c9c0797d$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $5ee9da54c9c0797d$var$Sha512;

});



parcelRegister("lRCsB", function(module, exports) {
'use strict';

var $8SHWC = parcelRequire("8SHWC");
var $feac619b666c2a37$require$Buffer = $8SHWC.Buffer;

var $lH12X = parcelRequire("lH12X");
var $feac619b666c2a37$require$Transform = $lH12X.Transform;

var $2QY83 = parcelRequire("2QY83");
var $feac619b666c2a37$require$StringDecoder = $2QY83.StringDecoder;

var $4rf1u = parcelRequire("4rf1u");

var $j6tHy = parcelRequire("j6tHy");
function $feac619b666c2a37$var$CipherBase(hashMode) {
    $feac619b666c2a37$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$4rf1u($feac619b666c2a37$var$CipherBase, $feac619b666c2a37$require$Transform);
$feac619b666c2a37$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $j6tHy(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$feac619b666c2a37$var$CipherBase.prototype.setAutoPadding = function() {};
$feac619b666c2a37$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$feac619b666c2a37$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$feac619b666c2a37$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$feac619b666c2a37$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$feac619b666c2a37$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$feac619b666c2a37$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $feac619b666c2a37$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$feac619b666c2a37$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $feac619b666c2a37$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $feac619b666c2a37$var$CipherBase;

});
parcelRegister("8SHWC", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $6775744fea6b0cc7$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $6775744fea6b0cc7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($6775744fea6b0cc7$var$Buffer.from && $6775744fea6b0cc7$var$Buffer.alloc && $6775744fea6b0cc7$var$Buffer.allocUnsafe && $6775744fea6b0cc7$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $6775744fea6b0cc7$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $6775744fea6b0cc7$var$SafeBuffer;
}
function $6775744fea6b0cc7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $6775744fea6b0cc7$var$Buffer(arg, encodingOrOffset, length);
}
$6775744fea6b0cc7$var$SafeBuffer.prototype = Object.create($6775744fea6b0cc7$var$Buffer.prototype);
// Copy static methods from Buffer
$6775744fea6b0cc7$var$copyProps($6775744fea6b0cc7$var$Buffer, $6775744fea6b0cc7$var$SafeBuffer);
$6775744fea6b0cc7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $6775744fea6b0cc7$var$Buffer(arg, encodingOrOffset, length);
};
$6775744fea6b0cc7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $6775744fea6b0cc7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$6775744fea6b0cc7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6775744fea6b0cc7$var$Buffer(size);
};
$6775744fea6b0cc7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});



parcelRegister("ikkqh", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $9rSsM = parcelRequire("9rSsM");

var $lRCsB = parcelRequire("lRCsB");

var $fF8dn = parcelRequire("fF8dn");
var $d579efd3e81c1e38$require$Buffer = $fF8dn.Buffer;

var $lL4Vt = parcelRequire("lL4Vt");

var $ARbIS = parcelRequire("ARbIS");

var $8UwRt = parcelRequire("8UwRt");
var $d579efd3e81c1e38$var$ZEROS = $d579efd3e81c1e38$require$Buffer.alloc(128);
function $d579efd3e81c1e38$var$Hmac(alg, key) {
    $lRCsB.call(this, 'digest');
    if (typeof key === 'string') key = $d579efd3e81c1e38$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $ARbIS() : $8UwRt(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $d579efd3e81c1e38$require$Buffer.concat([
        key,
        $d579efd3e81c1e38$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $d579efd3e81c1e38$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $d579efd3e81c1e38$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $ARbIS() : $8UwRt(alg);
    this._hash.update(ipad);
}
$4rf1u($d579efd3e81c1e38$var$Hmac, $lRCsB);
$d579efd3e81c1e38$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$d579efd3e81c1e38$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $ARbIS() : $8UwRt(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $d579efd3e81c1e38$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $9rSsM($lL4Vt, key);
    return new $d579efd3e81c1e38$var$Hmac(alg, key);
};

});
parcelRegister("9rSsM", function(module, exports) {
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $fF8dn = parcelRequire("fF8dn");
var $6e10e1e8df63a1af$require$Buffer = $fF8dn.Buffer;

var $lRCsB = parcelRequire("lRCsB");
var $6e10e1e8df63a1af$var$ZEROS = $6e10e1e8df63a1af$require$Buffer.alloc(128);
var $6e10e1e8df63a1af$var$blocksize = 64;
function $6e10e1e8df63a1af$var$Hmac(alg, key) {
    $lRCsB.call(this, 'digest');
    if (typeof key === 'string') key = $6e10e1e8df63a1af$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $6e10e1e8df63a1af$var$blocksize) key = alg(key);
    else if (key.length < $6e10e1e8df63a1af$var$blocksize) key = $6e10e1e8df63a1af$require$Buffer.concat([
        key,
        $6e10e1e8df63a1af$var$ZEROS
    ], $6e10e1e8df63a1af$var$blocksize);
    var ipad = this._ipad = $6e10e1e8df63a1af$require$Buffer.allocUnsafe($6e10e1e8df63a1af$var$blocksize);
    var opad = this._opad = $6e10e1e8df63a1af$require$Buffer.allocUnsafe($6e10e1e8df63a1af$var$blocksize);
    for(var i = 0; i < $6e10e1e8df63a1af$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$4rf1u($6e10e1e8df63a1af$var$Hmac, $lRCsB);
$6e10e1e8df63a1af$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$6e10e1e8df63a1af$var$Hmac.prototype._final = function() {
    var h = this._alg($6e10e1e8df63a1af$require$Buffer.concat(this._hash));
    return this._alg($6e10e1e8df63a1af$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $6e10e1e8df63a1af$var$Hmac;

});

parcelRegister("lL4Vt", function(module, exports) {

var $cfjWo = parcelRequire("cfjWo");
module.exports = function(buffer) {
    return new $cfjWo().update(buffer).digest();
};

});


parcelRegister("dAlkt", function(module, exports) {
'use strict';

module.exports = (parcelRequire("21Dil"));

});
parcelRegister("21Dil", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("btZcF", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $85c1e0d4e9a671cd$export$448fa22aedc9dbca; }, function (v) { return $85c1e0d4e9a671cd$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $85c1e0d4e9a671cd$export$b80c7ba289c8fa56; }, function (v) { return $85c1e0d4e9a671cd$export$b80c7ba289c8fa56 = v; });
var $85c1e0d4e9a671cd$export$448fa22aedc9dbca;
var $85c1e0d4e9a671cd$export$b80c7ba289c8fa56;
'use strict';

$85c1e0d4e9a671cd$export$448fa22aedc9dbca = (parcelRequire("lU2Mu"));

$85c1e0d4e9a671cd$export$b80c7ba289c8fa56 = (parcelRequire("4GgNd"));

});
parcelRegister("lU2Mu", function(module, exports) {
'use strict';

var $3T7lt = parcelRequire("3T7lt");
var $ff20fc2fc3aa8234$require$Buffer = $3T7lt.Buffer;

var $lOmJe = parcelRequire("lOmJe");

var $hg8IG = parcelRequire("hg8IG");

var $4GgNd = parcelRequire("4GgNd");

var $3cjSd = parcelRequire("3cjSd");
var $ff20fc2fc3aa8234$var$ZERO_BUF;
var $ff20fc2fc3aa8234$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $ff20fc2fc3aa8234$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $ff20fc2fc3aa8234$var$checks = [];
var $ff20fc2fc3aa8234$var$nextTick;
function $ff20fc2fc3aa8234$var$getNextTick() {
    if ($ff20fc2fc3aa8234$var$nextTick) return $ff20fc2fc3aa8234$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $ff20fc2fc3aa8234$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $ff20fc2fc3aa8234$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $ff20fc2fc3aa8234$var$nextTick = $parcel$global.setImmediate;
    else $ff20fc2fc3aa8234$var$nextTick = $parcel$global.setTimeout;
    return $ff20fc2fc3aa8234$var$nextTick;
}
function $ff20fc2fc3aa8234$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $ff20fc2fc3aa8234$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $ff20fc2fc3aa8234$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $ff20fc2fc3aa8234$require$Buffer.from(res);
    });
}
function $ff20fc2fc3aa8234$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$ff20fc2fc3aa8234$var$subtle || !$ff20fc2fc3aa8234$var$subtle.importKey || !$ff20fc2fc3aa8234$var$subtle.deriveBits) return Promise.resolve(false);
    if ($ff20fc2fc3aa8234$var$checks[algo] !== undefined) return $ff20fc2fc3aa8234$var$checks[algo];
    $ff20fc2fc3aa8234$var$ZERO_BUF = $ff20fc2fc3aa8234$var$ZERO_BUF || $ff20fc2fc3aa8234$require$Buffer.alloc(8);
    var prom = $ff20fc2fc3aa8234$var$browserPbkdf2($ff20fc2fc3aa8234$var$ZERO_BUF, $ff20fc2fc3aa8234$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $ff20fc2fc3aa8234$var$checks[algo] = prom;
    return prom;
}
function $ff20fc2fc3aa8234$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $ff20fc2fc3aa8234$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $ff20fc2fc3aa8234$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $ff20fc2fc3aa8234$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $ff20fc2fc3aa8234$var$getNextTick()(function() {
            var out;
            try {
                out = $4GgNd(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $lOmJe(iterations, keylen);
    password = $3cjSd(password, $hg8IG, 'Password');
    salt = $3cjSd(salt, $hg8IG, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $ff20fc2fc3aa8234$var$resolvePromise($ff20fc2fc3aa8234$var$checkNative(algo).then(function(resp) {
        if (resp) return $ff20fc2fc3aa8234$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $4GgNd(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("3T7lt", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $2d4c34ce0a64a624$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $2d4c34ce0a64a624$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($2d4c34ce0a64a624$var$Buffer.from && $2d4c34ce0a64a624$var$Buffer.alloc && $2d4c34ce0a64a624$var$Buffer.allocUnsafe && $2d4c34ce0a64a624$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $2d4c34ce0a64a624$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $2d4c34ce0a64a624$var$SafeBuffer;
}
function $2d4c34ce0a64a624$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $2d4c34ce0a64a624$var$Buffer(arg, encodingOrOffset, length);
}
$2d4c34ce0a64a624$var$SafeBuffer.prototype = Object.create($2d4c34ce0a64a624$var$Buffer.prototype);
// Copy static methods from Buffer
$2d4c34ce0a64a624$var$copyProps($2d4c34ce0a64a624$var$Buffer, $2d4c34ce0a64a624$var$SafeBuffer);
$2d4c34ce0a64a624$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $2d4c34ce0a64a624$var$Buffer(arg, encodingOrOffset, length);
};
$2d4c34ce0a64a624$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $2d4c34ce0a64a624$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$2d4c34ce0a64a624$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2d4c34ce0a64a624$var$Buffer(size);
};
$2d4c34ce0a64a624$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});

parcelRegister("lOmJe", function(module, exports) {
'use strict';
var $fe0fe5e3420b003c$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $fe0fe5e3420b003c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("hg8IG", function(module, exports) {

var $j1eoE = parcelRequire("j1eoE");
'use strict';
var $c90ab1d89a3d03c1$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $c90ab1d89a3d03c1$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $c90ab1d89a3d03c1$var$pVersionMajor = parseInt($j1eoE.version.split('.')[0].slice(1), 10);
    $c90ab1d89a3d03c1$var$defaultEncoding = $c90ab1d89a3d03c1$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $c90ab1d89a3d03c1$var$defaultEncoding = 'utf-8';
module.exports = $c90ab1d89a3d03c1$var$defaultEncoding;

});

parcelRegister("4GgNd", function(module, exports) {
'use strict';

var $Wwd6k = parcelRequire("Wwd6k");

var $22svv = parcelRequire("22svv");

var $8UwRt = parcelRequire("8UwRt");

var $3T7lt = parcelRequire("3T7lt");
var $36881c6429de418a$require$Buffer = $3T7lt.Buffer;

var $lOmJe = parcelRequire("lOmJe");

var $hg8IG = parcelRequire("hg8IG");

var $3cjSd = parcelRequire("3cjSd");
var $36881c6429de418a$var$ZEROS = $36881c6429de418a$require$Buffer.alloc(128);
var $36881c6429de418a$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $36881c6429de418a$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $36881c6429de418a$var$rmd160Func(data) {
    return new $22svv().update(data).digest();
}
function $36881c6429de418a$var$getDigest(alg) {
    function shaFunc(data) {
        return $8UwRt(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $36881c6429de418a$var$rmd160Func;
    if (alg === 'md5') return $Wwd6k;
    return shaFunc;
}
function $36881c6429de418a$var$Hmac(alg, key, saltLen) {
    var hash = $36881c6429de418a$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $36881c6429de418a$require$Buffer.concat([
        key,
        $36881c6429de418a$var$ZEROS
    ], blocksize);
    var ipad = $36881c6429de418a$require$Buffer.allocUnsafe(blocksize + $36881c6429de418a$var$sizes[alg]);
    var opad = $36881c6429de418a$require$Buffer.allocUnsafe(blocksize + $36881c6429de418a$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $36881c6429de418a$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $36881c6429de418a$var$sizes[alg];
}
$36881c6429de418a$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $36881c6429de418a$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $lOmJe(iterations, keylen);
    password = $3cjSd(password, $hg8IG, 'Password');
    salt = $3cjSd(salt, $hg8IG, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $36881c6429de418a$var$mapping[lowerDigest] || lowerDigest;
    var size = $36881c6429de418a$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $36881c6429de418a$var$Hmac(mappedDigest, password, salt.length);
    var DK = $36881c6429de418a$require$Buffer.allocUnsafe(keylen);
    var block1 = $36881c6429de418a$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $36881c6429de418a$var$pbkdf2;

});
parcelRegister("Wwd6k", function(module, exports) {
'use strict';

var $b3cIh = parcelRequire("b3cIh");
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $0afe6730cc52e899$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $0afe6730cc52e899$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $0afe6730cc52e899$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $0afe6730cc52e899$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $0afe6730cc52e899$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $0afe6730cc52e899$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $0afe6730cc52e899$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $0afe6730cc52e899$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $0afe6730cc52e899$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $0afe6730cc52e899$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $0afe6730cc52e899$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $0afe6730cc52e899$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $0afe6730cc52e899$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $0afe6730cc52e899$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $0afe6730cc52e899$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $0afe6730cc52e899$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $0afe6730cc52e899$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $0afe6730cc52e899$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $0afe6730cc52e899$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $0afe6730cc52e899$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $0afe6730cc52e899$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $0afe6730cc52e899$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $0afe6730cc52e899$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $0afe6730cc52e899$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $0afe6730cc52e899$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $0afe6730cc52e899$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $0afe6730cc52e899$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $0afe6730cc52e899$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $0afe6730cc52e899$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $0afe6730cc52e899$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $0afe6730cc52e899$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $0afe6730cc52e899$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $0afe6730cc52e899$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $0afe6730cc52e899$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $0afe6730cc52e899$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $0afe6730cc52e899$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $0afe6730cc52e899$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $0afe6730cc52e899$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $0afe6730cc52e899$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $0afe6730cc52e899$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $0afe6730cc52e899$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $0afe6730cc52e899$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $0afe6730cc52e899$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $0afe6730cc52e899$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $0afe6730cc52e899$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $0afe6730cc52e899$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $0afe6730cc52e899$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $0afe6730cc52e899$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $0afe6730cc52e899$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $0afe6730cc52e899$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $0afe6730cc52e899$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $0afe6730cc52e899$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $0afe6730cc52e899$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $0afe6730cc52e899$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $0afe6730cc52e899$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $0afe6730cc52e899$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $0afe6730cc52e899$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $0afe6730cc52e899$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $0afe6730cc52e899$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $0afe6730cc52e899$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $0afe6730cc52e899$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $0afe6730cc52e899$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $0afe6730cc52e899$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $0afe6730cc52e899$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $0afe6730cc52e899$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $0afe6730cc52e899$var$safe_add(a, olda);
        b = $0afe6730cc52e899$var$safe_add(b, oldb);
        c = $0afe6730cc52e899$var$safe_add(c, oldc);
        d = $0afe6730cc52e899$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $0afe6730cc52e899$var$md5_cmn(q, a, b, x, s, t) {
    return $0afe6730cc52e899$var$safe_add($0afe6730cc52e899$var$bit_rol($0afe6730cc52e899$var$safe_add($0afe6730cc52e899$var$safe_add(a, q), $0afe6730cc52e899$var$safe_add(x, t)), s), b);
}
function $0afe6730cc52e899$var$md5_ff(a, b, c, d, x, s, t) {
    return $0afe6730cc52e899$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $0afe6730cc52e899$var$md5_gg(a, b, c, d, x, s, t) {
    return $0afe6730cc52e899$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $0afe6730cc52e899$var$md5_hh(a, b, c, d, x, s, t) {
    return $0afe6730cc52e899$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $0afe6730cc52e899$var$md5_ii(a, b, c, d, x, s, t) {
    return $0afe6730cc52e899$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $0afe6730cc52e899$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $0afe6730cc52e899$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
module.exports = function md5(buf) {
    return $b3cIh(buf, $0afe6730cc52e899$var$core_md5);
};

});
parcelRegister("b3cIh", function(module, exports) {

var $b0kMB = parcelRequire("b0kMB");
var $80b9d614d01bac29$require$Buffer = $b0kMB.Buffer;
'use strict';
var $80b9d614d01bac29$var$intSize = 4;
var $80b9d614d01bac29$var$zeroBuffer = new $80b9d614d01bac29$require$Buffer($80b9d614d01bac29$var$intSize);
$80b9d614d01bac29$var$zeroBuffer.fill(0);
var $80b9d614d01bac29$var$charSize = 8;
var $80b9d614d01bac29$var$hashSize = 16;
function $80b9d614d01bac29$var$toArray(buf) {
    if (buf.length % $80b9d614d01bac29$var$intSize !== 0) {
        var len = buf.length + ($80b9d614d01bac29$var$intSize - buf.length % $80b9d614d01bac29$var$intSize);
        buf = $80b9d614d01bac29$require$Buffer.concat([
            buf,
            $80b9d614d01bac29$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $80b9d614d01bac29$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
module.exports = function hash(buf, fn) {
    var arr = fn($80b9d614d01bac29$var$toArray(buf), buf.length * $80b9d614d01bac29$var$charSize);
    buf = new $80b9d614d01bac29$require$Buffer($80b9d614d01bac29$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};

});


parcelRegister("22svv", function(module, exports) {

var $b0kMB = parcelRequire("b0kMB");
var $17c1e1975d0a2dea$require$Buffer = $b0kMB.Buffer;
'use strict';

var $4rf1u = parcelRequire("4rf1u");

var $DFBg9 = parcelRequire("DFBg9");
function $17c1e1975d0a2dea$var$RIPEMD160() {
    $DFBg9.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$4rf1u($17c1e1975d0a2dea$var$RIPEMD160, $DFBg9);
$17c1e1975d0a2dea$var$RIPEMD160.prototype._update = function() {
    var m = new Array(16);
    for(var i = 0; i < 16; ++i)m[i] = this._block.readInt32LE(i * 4);
    var al = this._a;
    var bl = this._b;
    var cl = this._c;
    var dl = this._d;
    var el = this._e;
    // Mj = 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
    // K = 0x00000000
    // Sj = 11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8
    al = $17c1e1975d0a2dea$var$fn1(al, bl, cl, dl, el, m[0], 0x00000000, 11);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn1(el, al, bl, cl, dl, m[1], 0x00000000, 14);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn1(dl, el, al, bl, cl, m[2], 0x00000000, 15);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn1(cl, dl, el, al, bl, m[3], 0x00000000, 12);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn1(bl, cl, dl, el, al, m[4], 0x00000000, 5);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn1(al, bl, cl, dl, el, m[5], 0x00000000, 8);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn1(el, al, bl, cl, dl, m[6], 0x00000000, 7);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn1(dl, el, al, bl, cl, m[7], 0x00000000, 9);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn1(cl, dl, el, al, bl, m[8], 0x00000000, 11);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn1(bl, cl, dl, el, al, m[9], 0x00000000, 13);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn1(al, bl, cl, dl, el, m[10], 0x00000000, 14);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn1(el, al, bl, cl, dl, m[11], 0x00000000, 15);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn1(dl, el, al, bl, cl, m[12], 0x00000000, 6);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn1(cl, dl, el, al, bl, m[13], 0x00000000, 7);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn1(bl, cl, dl, el, al, m[14], 0x00000000, 9);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn1(al, bl, cl, dl, el, m[15], 0x00000000, 8);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    // Mj = 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8
    // K = 0x5a827999
    // Sj = 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12
    el = $17c1e1975d0a2dea$var$fn2(el, al, bl, cl, dl, m[7], 0x5a827999, 7);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn2(dl, el, al, bl, cl, m[4], 0x5a827999, 6);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn2(cl, dl, el, al, bl, m[13], 0x5a827999, 8);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn2(bl, cl, dl, el, al, m[1], 0x5a827999, 13);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn2(al, bl, cl, dl, el, m[10], 0x5a827999, 11);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn2(el, al, bl, cl, dl, m[6], 0x5a827999, 9);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn2(dl, el, al, bl, cl, m[15], 0x5a827999, 7);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn2(cl, dl, el, al, bl, m[3], 0x5a827999, 15);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn2(bl, cl, dl, el, al, m[12], 0x5a827999, 7);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn2(al, bl, cl, dl, el, m[0], 0x5a827999, 12);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn2(el, al, bl, cl, dl, m[9], 0x5a827999, 15);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn2(dl, el, al, bl, cl, m[5], 0x5a827999, 9);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn2(cl, dl, el, al, bl, m[2], 0x5a827999, 11);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn2(bl, cl, dl, el, al, m[14], 0x5a827999, 7);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn2(al, bl, cl, dl, el, m[11], 0x5a827999, 13);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn2(el, al, bl, cl, dl, m[8], 0x5a827999, 12);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    // Mj = 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12
    // K = 0x6ed9eba1
    // Sj = 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5
    dl = $17c1e1975d0a2dea$var$fn3(dl, el, al, bl, cl, m[3], 0x6ed9eba1, 11);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn3(cl, dl, el, al, bl, m[10], 0x6ed9eba1, 13);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn3(bl, cl, dl, el, al, m[14], 0x6ed9eba1, 6);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn3(al, bl, cl, dl, el, m[4], 0x6ed9eba1, 7);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn3(el, al, bl, cl, dl, m[9], 0x6ed9eba1, 14);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn3(dl, el, al, bl, cl, m[15], 0x6ed9eba1, 9);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn3(cl, dl, el, al, bl, m[8], 0x6ed9eba1, 13);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn3(bl, cl, dl, el, al, m[1], 0x6ed9eba1, 15);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn3(al, bl, cl, dl, el, m[2], 0x6ed9eba1, 14);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn3(el, al, bl, cl, dl, m[7], 0x6ed9eba1, 8);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn3(dl, el, al, bl, cl, m[0], 0x6ed9eba1, 13);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn3(cl, dl, el, al, bl, m[6], 0x6ed9eba1, 6);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn3(bl, cl, dl, el, al, m[13], 0x6ed9eba1, 5);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn3(al, bl, cl, dl, el, m[11], 0x6ed9eba1, 12);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn3(el, al, bl, cl, dl, m[5], 0x6ed9eba1, 7);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn3(dl, el, al, bl, cl, m[12], 0x6ed9eba1, 5);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    // Mj = 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2
    // K = 0x8f1bbcdc
    // Sj = 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12
    cl = $17c1e1975d0a2dea$var$fn4(cl, dl, el, al, bl, m[1], 0x8f1bbcdc, 11);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn4(bl, cl, dl, el, al, m[9], 0x8f1bbcdc, 12);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn4(al, bl, cl, dl, el, m[11], 0x8f1bbcdc, 14);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn4(el, al, bl, cl, dl, m[10], 0x8f1bbcdc, 15);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn4(dl, el, al, bl, cl, m[0], 0x8f1bbcdc, 14);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn4(cl, dl, el, al, bl, m[8], 0x8f1bbcdc, 15);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn4(bl, cl, dl, el, al, m[12], 0x8f1bbcdc, 9);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn4(al, bl, cl, dl, el, m[4], 0x8f1bbcdc, 8);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn4(el, al, bl, cl, dl, m[13], 0x8f1bbcdc, 9);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn4(dl, el, al, bl, cl, m[3], 0x8f1bbcdc, 14);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn4(cl, dl, el, al, bl, m[7], 0x8f1bbcdc, 5);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn4(bl, cl, dl, el, al, m[15], 0x8f1bbcdc, 6);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn4(al, bl, cl, dl, el, m[14], 0x8f1bbcdc, 8);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn4(el, al, bl, cl, dl, m[5], 0x8f1bbcdc, 6);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn4(dl, el, al, bl, cl, m[6], 0x8f1bbcdc, 5);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn4(cl, dl, el, al, bl, m[2], 0x8f1bbcdc, 12);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    // Mj = 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    // K = 0xa953fd4e
    // Sj = 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    bl = $17c1e1975d0a2dea$var$fn5(bl, cl, dl, el, al, m[4], 0xa953fd4e, 9);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn5(al, bl, cl, dl, el, m[0], 0xa953fd4e, 15);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn5(el, al, bl, cl, dl, m[5], 0xa953fd4e, 5);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn5(dl, el, al, bl, cl, m[9], 0xa953fd4e, 11);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn5(cl, dl, el, al, bl, m[7], 0xa953fd4e, 6);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn5(bl, cl, dl, el, al, m[12], 0xa953fd4e, 8);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn5(al, bl, cl, dl, el, m[2], 0xa953fd4e, 13);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn5(el, al, bl, cl, dl, m[10], 0xa953fd4e, 12);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn5(dl, el, al, bl, cl, m[14], 0xa953fd4e, 5);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn5(cl, dl, el, al, bl, m[1], 0xa953fd4e, 12);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn5(bl, cl, dl, el, al, m[3], 0xa953fd4e, 13);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    al = $17c1e1975d0a2dea$var$fn5(al, bl, cl, dl, el, m[8], 0xa953fd4e, 14);
    cl = $17c1e1975d0a2dea$var$rotl(cl, 10);
    el = $17c1e1975d0a2dea$var$fn5(el, al, bl, cl, dl, m[11], 0xa953fd4e, 11);
    bl = $17c1e1975d0a2dea$var$rotl(bl, 10);
    dl = $17c1e1975d0a2dea$var$fn5(dl, el, al, bl, cl, m[6], 0xa953fd4e, 8);
    al = $17c1e1975d0a2dea$var$rotl(al, 10);
    cl = $17c1e1975d0a2dea$var$fn5(cl, dl, el, al, bl, m[15], 0xa953fd4e, 5);
    el = $17c1e1975d0a2dea$var$rotl(el, 10);
    bl = $17c1e1975d0a2dea$var$fn5(bl, cl, dl, el, al, m[13], 0xa953fd4e, 6);
    dl = $17c1e1975d0a2dea$var$rotl(dl, 10);
    var ar = this._a;
    var br = this._b;
    var cr = this._c;
    var dr = this._d;
    var er = this._e;
    // M'j = 5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12
    // K' = 0x50a28be6
    // S'j = 8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6
    ar = $17c1e1975d0a2dea$var$fn5(ar, br, cr, dr, er, m[5], 0x50a28be6, 8);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn5(er, ar, br, cr, dr, m[14], 0x50a28be6, 9);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn5(dr, er, ar, br, cr, m[7], 0x50a28be6, 9);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn5(cr, dr, er, ar, br, m[0], 0x50a28be6, 11);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn5(br, cr, dr, er, ar, m[9], 0x50a28be6, 13);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn5(ar, br, cr, dr, er, m[2], 0x50a28be6, 15);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn5(er, ar, br, cr, dr, m[11], 0x50a28be6, 15);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn5(dr, er, ar, br, cr, m[4], 0x50a28be6, 5);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn5(cr, dr, er, ar, br, m[13], 0x50a28be6, 7);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn5(br, cr, dr, er, ar, m[6], 0x50a28be6, 7);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn5(ar, br, cr, dr, er, m[15], 0x50a28be6, 8);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn5(er, ar, br, cr, dr, m[8], 0x50a28be6, 11);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn5(dr, er, ar, br, cr, m[1], 0x50a28be6, 14);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn5(cr, dr, er, ar, br, m[10], 0x50a28be6, 14);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn5(br, cr, dr, er, ar, m[3], 0x50a28be6, 12);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn5(ar, br, cr, dr, er, m[12], 0x50a28be6, 6);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    // M'j = 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2
    // K' = 0x5c4dd124
    // S'j = 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11
    er = $17c1e1975d0a2dea$var$fn4(er, ar, br, cr, dr, m[6], 0x5c4dd124, 9);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn4(dr, er, ar, br, cr, m[11], 0x5c4dd124, 13);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn4(cr, dr, er, ar, br, m[3], 0x5c4dd124, 15);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn4(br, cr, dr, er, ar, m[7], 0x5c4dd124, 7);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn4(ar, br, cr, dr, er, m[0], 0x5c4dd124, 12);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn4(er, ar, br, cr, dr, m[13], 0x5c4dd124, 8);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn4(dr, er, ar, br, cr, m[5], 0x5c4dd124, 9);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn4(cr, dr, er, ar, br, m[10], 0x5c4dd124, 11);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn4(br, cr, dr, er, ar, m[14], 0x5c4dd124, 7);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn4(ar, br, cr, dr, er, m[15], 0x5c4dd124, 7);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn4(er, ar, br, cr, dr, m[8], 0x5c4dd124, 12);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn4(dr, er, ar, br, cr, m[12], 0x5c4dd124, 7);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn4(cr, dr, er, ar, br, m[4], 0x5c4dd124, 6);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn4(br, cr, dr, er, ar, m[9], 0x5c4dd124, 15);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn4(ar, br, cr, dr, er, m[1], 0x5c4dd124, 13);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn4(er, ar, br, cr, dr, m[2], 0x5c4dd124, 11);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    // M'j = 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13
    // K' = 0x6d703ef3
    // S'j = 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5
    dr = $17c1e1975d0a2dea$var$fn3(dr, er, ar, br, cr, m[15], 0x6d703ef3, 9);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn3(cr, dr, er, ar, br, m[5], 0x6d703ef3, 7);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn3(br, cr, dr, er, ar, m[1], 0x6d703ef3, 15);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn3(ar, br, cr, dr, er, m[3], 0x6d703ef3, 11);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn3(er, ar, br, cr, dr, m[7], 0x6d703ef3, 8);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn3(dr, er, ar, br, cr, m[14], 0x6d703ef3, 6);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn3(cr, dr, er, ar, br, m[6], 0x6d703ef3, 6);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn3(br, cr, dr, er, ar, m[9], 0x6d703ef3, 14);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn3(ar, br, cr, dr, er, m[11], 0x6d703ef3, 12);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn3(er, ar, br, cr, dr, m[8], 0x6d703ef3, 13);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn3(dr, er, ar, br, cr, m[12], 0x6d703ef3, 5);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn3(cr, dr, er, ar, br, m[2], 0x6d703ef3, 14);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn3(br, cr, dr, er, ar, m[10], 0x6d703ef3, 13);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn3(ar, br, cr, dr, er, m[0], 0x6d703ef3, 13);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn3(er, ar, br, cr, dr, m[4], 0x6d703ef3, 7);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn3(dr, er, ar, br, cr, m[13], 0x6d703ef3, 5);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    // M'j = 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14
    // K' = 0x7a6d76e9
    // S'j = 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8
    cr = $17c1e1975d0a2dea$var$fn2(cr, dr, er, ar, br, m[8], 0x7a6d76e9, 15);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn2(br, cr, dr, er, ar, m[6], 0x7a6d76e9, 5);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn2(ar, br, cr, dr, er, m[4], 0x7a6d76e9, 8);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn2(er, ar, br, cr, dr, m[1], 0x7a6d76e9, 11);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn2(dr, er, ar, br, cr, m[3], 0x7a6d76e9, 14);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn2(cr, dr, er, ar, br, m[11], 0x7a6d76e9, 14);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn2(br, cr, dr, er, ar, m[15], 0x7a6d76e9, 6);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn2(ar, br, cr, dr, er, m[0], 0x7a6d76e9, 14);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn2(er, ar, br, cr, dr, m[5], 0x7a6d76e9, 6);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn2(dr, er, ar, br, cr, m[12], 0x7a6d76e9, 9);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn2(cr, dr, er, ar, br, m[2], 0x7a6d76e9, 12);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn2(br, cr, dr, er, ar, m[13], 0x7a6d76e9, 9);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn2(ar, br, cr, dr, er, m[9], 0x7a6d76e9, 12);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn2(er, ar, br, cr, dr, m[7], 0x7a6d76e9, 5);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn2(dr, er, ar, br, cr, m[10], 0x7a6d76e9, 15);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn2(cr, dr, er, ar, br, m[14], 0x7a6d76e9, 8);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    // M'j = 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    // K' = 0x00000000
    // S'j = 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    br = $17c1e1975d0a2dea$var$fn1(br, cr, dr, er, ar, m[12], 0x00000000, 8);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn1(ar, br, cr, dr, er, m[15], 0x00000000, 5);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn1(er, ar, br, cr, dr, m[10], 0x00000000, 12);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn1(dr, er, ar, br, cr, m[4], 0x00000000, 9);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn1(cr, dr, er, ar, br, m[1], 0x00000000, 12);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn1(br, cr, dr, er, ar, m[5], 0x00000000, 5);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn1(ar, br, cr, dr, er, m[8], 0x00000000, 14);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn1(er, ar, br, cr, dr, m[7], 0x00000000, 6);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn1(dr, er, ar, br, cr, m[6], 0x00000000, 8);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn1(cr, dr, er, ar, br, m[2], 0x00000000, 13);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn1(br, cr, dr, er, ar, m[13], 0x00000000, 6);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    ar = $17c1e1975d0a2dea$var$fn1(ar, br, cr, dr, er, m[14], 0x00000000, 5);
    cr = $17c1e1975d0a2dea$var$rotl(cr, 10);
    er = $17c1e1975d0a2dea$var$fn1(er, ar, br, cr, dr, m[0], 0x00000000, 15);
    br = $17c1e1975d0a2dea$var$rotl(br, 10);
    dr = $17c1e1975d0a2dea$var$fn1(dr, er, ar, br, cr, m[3], 0x00000000, 13);
    ar = $17c1e1975d0a2dea$var$rotl(ar, 10);
    cr = $17c1e1975d0a2dea$var$fn1(cr, dr, er, ar, br, m[9], 0x00000000, 11);
    er = $17c1e1975d0a2dea$var$rotl(er, 10);
    br = $17c1e1975d0a2dea$var$fn1(br, cr, dr, er, ar, m[11], 0x00000000, 11);
    dr = $17c1e1975d0a2dea$var$rotl(dr, 10);
    // change state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$17c1e1975d0a2dea$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $17c1e1975d0a2dea$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $17c1e1975d0a2dea$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $17c1e1975d0a2dea$var$fn1(a, b, c, d, e, m, k, s) {
    return $17c1e1975d0a2dea$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $17c1e1975d0a2dea$var$fn2(a, b, c, d, e, m, k, s) {
    return $17c1e1975d0a2dea$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $17c1e1975d0a2dea$var$fn3(a, b, c, d, e, m, k, s) {
    return $17c1e1975d0a2dea$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $17c1e1975d0a2dea$var$fn4(a, b, c, d, e, m, k, s) {
    return $17c1e1975d0a2dea$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $17c1e1975d0a2dea$var$fn5(a, b, c, d, e, m, k, s) {
    return $17c1e1975d0a2dea$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $17c1e1975d0a2dea$var$RIPEMD160;

});
parcelRegister("DFBg9", function(module, exports) {

var $b0kMB = parcelRequire("b0kMB");
var $0773e984c4c4a075$require$Buffer = $b0kMB.Buffer;
'use strict';

var $lH12X = parcelRequire("lH12X");
var $0773e984c4c4a075$require$Transform = $lH12X.Transform;

var $4rf1u = parcelRequire("4rf1u");
function $0773e984c4c4a075$var$HashBase(blockSize) {
    $0773e984c4c4a075$require$Transform.call(this);
    this._block = new $0773e984c4c4a075$require$Buffer(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$4rf1u($0773e984c4c4a075$var$HashBase, $0773e984c4c4a075$require$Transform);
$0773e984c4c4a075$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        if (encoding !== 'buffer') chunk = new $0773e984c4c4a075$require$Buffer(chunk, encoding);
        this.update(chunk);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0773e984c4c4a075$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this._digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0773e984c4c4a075$var$HashBase.prototype.update = function(data, encoding) {
    if (!$0773e984c4c4a075$require$Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
    if (this._finalized) throw new Error('Digest already called');
    if (!$0773e984c4c4a075$require$Buffer.isBuffer(data)) data = new $0773e984c4c4a075$require$Buffer(data, encoding || 'binary');
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$0773e984c4c4a075$var$HashBase.prototype._update = function(data) {
    throw new Error('_update is not implemented');
};
$0773e984c4c4a075$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    return digest;
};
$0773e984c4c4a075$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $0773e984c4c4a075$var$HashBase;

});


parcelRegister("3cjSd", function(module, exports) {
'use strict';

var $3T7lt = parcelRequire("3T7lt");
var $2541e887fed03173$require$Buffer = $3T7lt.Buffer;

var $j6tHy = parcelRequire("j6tHy");
var $2541e887fed03173$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $2541e887fed03173$var$useArrayBuffer = $2541e887fed03173$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $2541e887fed03173$var$isView = $2541e887fed03173$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $2541e887fed03173$require$Buffer.isBuffer(thing) || $2541e887fed03173$var$useUint8Array && thing instanceof Uint8Array || $2541e887fed03173$var$isView && $2541e887fed03173$var$isView(thing)) return $j6tHy(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("lasuy", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $f690a20900a9b7cf$export$bdd223f16383713e; }, function (v) { return $f690a20900a9b7cf$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $f690a20900a9b7cf$export$26e5786e8ac8e530; }, function (v) { return $f690a20900a9b7cf$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $f690a20900a9b7cf$export$2f64596b8cbf08b4; }, function (v) { return $f690a20900a9b7cf$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $f690a20900a9b7cf$export$20533d26f07f1ee0; }, function (v) { return $f690a20900a9b7cf$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $f690a20900a9b7cf$export$12ada9414fbc594c; }, function (v) { return $f690a20900a9b7cf$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $f690a20900a9b7cf$export$2ce6d8d0e8b04e1a; }, function (v) { return $f690a20900a9b7cf$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $f690a20900a9b7cf$export$36b6d6ef312eab39; }, function (v) { return $f690a20900a9b7cf$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $f690a20900a9b7cf$export$f5e7e39d57cd9700; }, function (v) { return $f690a20900a9b7cf$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $f690a20900a9b7cf$export$dedd8dc3dc62b370; }, function (v) { return $f690a20900a9b7cf$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $f690a20900a9b7cf$export$58a258485f1e49f6; }, function (v) { return $f690a20900a9b7cf$export$58a258485f1e49f6 = v; });
var $f690a20900a9b7cf$export$bdd223f16383713e;
var $f690a20900a9b7cf$export$26e5786e8ac8e530;
var $f690a20900a9b7cf$export$2f64596b8cbf08b4;
var $f690a20900a9b7cf$export$20533d26f07f1ee0;
var $f690a20900a9b7cf$export$12ada9414fbc594c;
var $f690a20900a9b7cf$export$2ce6d8d0e8b04e1a;
var $f690a20900a9b7cf$export$36b6d6ef312eab39;
var $f690a20900a9b7cf$export$f5e7e39d57cd9700;
var $f690a20900a9b7cf$export$dedd8dc3dc62b370;
var $f690a20900a9b7cf$export$58a258485f1e49f6;

var $3bVoF = parcelRequire("3bVoF");

var $dvlcQ = parcelRequire("dvlcQ");

var $1HbpH = parcelRequire("1HbpH");

var $b74Lh = parcelRequire("b74Lh");

var $9zoIs = parcelRequire("9zoIs");
function $f690a20900a9b7cf$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($1HbpH[suite]) {
        keyLen = $1HbpH[suite].key;
        ivLen = $1HbpH[suite].iv;
    } else if ($b74Lh[suite]) {
        keyLen = $b74Lh[suite].key * 8;
        ivLen = $b74Lh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $9zoIs(password, false, keyLen, ivLen);
    return $f690a20900a9b7cf$var$createCipheriv(suite, keys.key, keys.iv);
}
function $f690a20900a9b7cf$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($1HbpH[suite]) {
        keyLen = $1HbpH[suite].key;
        ivLen = $1HbpH[suite].iv;
    } else if ($b74Lh[suite]) {
        keyLen = $b74Lh[suite].key * 8;
        ivLen = $b74Lh[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $9zoIs(password, false, keyLen, ivLen);
    return $f690a20900a9b7cf$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $f690a20900a9b7cf$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($1HbpH[suite]) return $dvlcQ.createCipheriv(suite, key, iv);
    if ($b74Lh[suite]) return new $3bVoF({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $f690a20900a9b7cf$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($1HbpH[suite]) return $dvlcQ.createDecipheriv(suite, key, iv);
    if ($b74Lh[suite]) return new $3bVoF({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $f690a20900a9b7cf$var$getCiphers() {
    return Object.keys($b74Lh).concat($dvlcQ.getCiphers());
}
$f690a20900a9b7cf$export$bdd223f16383713e = $f690a20900a9b7cf$export$26e5786e8ac8e530 = $f690a20900a9b7cf$var$createCipher;
$f690a20900a9b7cf$export$2f64596b8cbf08b4 = $f690a20900a9b7cf$export$20533d26f07f1ee0 = $f690a20900a9b7cf$var$createCipheriv;
$f690a20900a9b7cf$export$12ada9414fbc594c = $f690a20900a9b7cf$export$2ce6d8d0e8b04e1a = $f690a20900a9b7cf$var$createDecipher;
$f690a20900a9b7cf$export$36b6d6ef312eab39 = $f690a20900a9b7cf$export$f5e7e39d57cd9700 = $f690a20900a9b7cf$var$createDecipheriv;
$f690a20900a9b7cf$export$dedd8dc3dc62b370 = $f690a20900a9b7cf$export$58a258485f1e49f6 = $f690a20900a9b7cf$var$getCiphers;

});
parcelRegister("3bVoF", function(module, exports) {

var $lRCsB = parcelRequire("lRCsB");

var $b7qpR = parcelRequire("b7qpR");

var $4rf1u = parcelRequire("4rf1u");

var $fF8dn = parcelRequire("fF8dn");
var $252eebfdc96e6d39$require$Buffer = $fF8dn.Buffer;
var $252eebfdc96e6d39$var$modes = {
    'des-ede3-cbc': $b7qpR.CBC.instantiate($b7qpR.EDE),
    'des-ede3': $b7qpR.EDE,
    'des-ede-cbc': $b7qpR.CBC.instantiate($b7qpR.EDE),
    'des-ede': $b7qpR.EDE,
    'des-cbc': $b7qpR.CBC.instantiate($b7qpR.DES),
    'des-ecb': $b7qpR.DES
};
$252eebfdc96e6d39$var$modes.des = $252eebfdc96e6d39$var$modes['des-cbc'];
$252eebfdc96e6d39$var$modes.des3 = $252eebfdc96e6d39$var$modes['des-ede3-cbc'];
module.exports = $252eebfdc96e6d39$var$DES;
$4rf1u($252eebfdc96e6d39$var$DES, $lRCsB);
function $252eebfdc96e6d39$var$DES(opts) {
    $lRCsB.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $252eebfdc96e6d39$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$252eebfdc96e6d39$require$Buffer.isBuffer(key)) key = $252eebfdc96e6d39$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $252eebfdc96e6d39$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$252eebfdc96e6d39$require$Buffer.isBuffer(iv)) iv = $252eebfdc96e6d39$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$252eebfdc96e6d39$var$DES.prototype._update = function(data) {
    return $252eebfdc96e6d39$require$Buffer.from(this._des.update(data));
};
$252eebfdc96e6d39$var$DES.prototype._final = function() {
    return $252eebfdc96e6d39$require$Buffer.from(this._des.final());
};

});
parcelRegister("b7qpR", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $8184d6d6001c1ce5$export$cc8859615686b300; }, function (v) { return $8184d6d6001c1ce5$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $8184d6d6001c1ce5$export$8ad3f227af08fcc5; }, function (v) { return $8184d6d6001c1ce5$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $8184d6d6001c1ce5$export$947646e34766044f; }, function (v) { return $8184d6d6001c1ce5$export$947646e34766044f = v; });
var $8184d6d6001c1ce5$export$eab97d15b1788b8d;
var $8184d6d6001c1ce5$export$26e5786e8ac8e530;
var $8184d6d6001c1ce5$export$cc8859615686b300;
var $8184d6d6001c1ce5$export$8ad3f227af08fcc5;
var $8184d6d6001c1ce5$export$947646e34766044f;
'use strict';

$8184d6d6001c1ce5$export$eab97d15b1788b8d = (parcelRequire("kE36r"));

$8184d6d6001c1ce5$export$26e5786e8ac8e530 = (parcelRequire("ilHPC"));

$8184d6d6001c1ce5$export$cc8859615686b300 = (parcelRequire("4sPrx"));

$8184d6d6001c1ce5$export$8ad3f227af08fcc5 = (parcelRequire("hRbHn"));

$8184d6d6001c1ce5$export$947646e34766044f = (parcelRequire("30RMR"));

});
parcelRegister("kE36r", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $f079f3391e4e78f9$export$cfaef8ed399428b0; }, function (v) { return $f079f3391e4e78f9$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $f079f3391e4e78f9$export$a80c7deaea7cbd80; }, function (v) { return $f079f3391e4e78f9$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $f079f3391e4e78f9$export$ed7577ae6e1cd0ef; }, function (v) { return $f079f3391e4e78f9$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $f079f3391e4e78f9$export$5dcbef3aa594f567; }, function (v) { return $f079f3391e4e78f9$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $f079f3391e4e78f9$export$5bc8001ca71ed9c5; }, function (v) { return $f079f3391e4e78f9$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $f079f3391e4e78f9$export$3e714e2c5d5d8cb2; }, function (v) { return $f079f3391e4e78f9$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $f079f3391e4e78f9$export$94c3e544fd062b7f; }, function (v) { return $f079f3391e4e78f9$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $f079f3391e4e78f9$export$9f77e0932fb78f72; }, function (v) { return $f079f3391e4e78f9$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $f079f3391e4e78f9$export$d865ce2836f5927f; }, function (v) { return $f079f3391e4e78f9$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $f079f3391e4e78f9$export$95e62ad65da8b7d2; }, function (v) { return $f079f3391e4e78f9$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $f079f3391e4e78f9$export$209139ff098c441a; }, function (v) { return $f079f3391e4e78f9$export$209139ff098c441a = v; });
var $f079f3391e4e78f9$export$cfaef8ed399428b0;
var $f079f3391e4e78f9$export$a80c7deaea7cbd80;
var $f079f3391e4e78f9$export$ed7577ae6e1cd0ef;
var $f079f3391e4e78f9$export$5dcbef3aa594f567;
var $f079f3391e4e78f9$export$5bc8001ca71ed9c5;
var $f079f3391e4e78f9$export$3e714e2c5d5d8cb2;
var $f079f3391e4e78f9$export$94c3e544fd062b7f;
var $f079f3391e4e78f9$export$9f77e0932fb78f72;
var $f079f3391e4e78f9$export$d865ce2836f5927f;
var $f079f3391e4e78f9$export$95e62ad65da8b7d2;
var $f079f3391e4e78f9$export$209139ff098c441a;
'use strict';
$f079f3391e4e78f9$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$f079f3391e4e78f9$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$f079f3391e4e78f9$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$f079f3391e4e78f9$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$f079f3391e4e78f9$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$f079f3391e4e78f9$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $f079f3391e4e78f9$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$f079f3391e4e78f9$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $f079f3391e4e78f9$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $f079f3391e4e78f9$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $f079f3391e4e78f9$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $f079f3391e4e78f9$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$f079f3391e4e78f9$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $f079f3391e4e78f9$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$f079f3391e4e78f9$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $f079f3391e4e78f9$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $f079f3391e4e78f9$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $f079f3391e4e78f9$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$f079f3391e4e78f9$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $f079f3391e4e78f9$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $f079f3391e4e78f9$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$f079f3391e4e78f9$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("ilHPC", function(module, exports) {
'use strict';

var $qzkJD = parcelRequire("qzkJD");
function $d5bc303213a9f521$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $d5bc303213a9f521$var$Cipher;
$d5bc303213a9f521$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$d5bc303213a9f521$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$d5bc303213a9f521$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$d5bc303213a9f521$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$d5bc303213a9f521$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$d5bc303213a9f521$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$d5bc303213a9f521$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$d5bc303213a9f521$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$d5bc303213a9f521$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$d5bc303213a9f521$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$d5bc303213a9f521$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $qzkJD.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("qzkJD", function(module, exports) {
module.exports = $04fdd64e8b7471d6$var$assert;
function $04fdd64e8b7471d6$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$04fdd64e8b7471d6$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("4sPrx", function(module, exports) {
'use strict';

var $qzkJD = parcelRequire("qzkJD");

var $4rf1u = parcelRequire("4rf1u");

var $kE36r = parcelRequire("kE36r");

var $ilHPC = parcelRequire("ilHPC");
function $3401ae7f7310fca5$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $3401ae7f7310fca5$var$DES(options) {
    $ilHPC.call(this, options);
    var state = new $3401ae7f7310fca5$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$4rf1u($3401ae7f7310fca5$var$DES, $ilHPC);
module.exports = $3401ae7f7310fca5$var$DES;
$3401ae7f7310fca5$var$DES.create = function create(options) {
    return new $3401ae7f7310fca5$var$DES(options);
};
var $3401ae7f7310fca5$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$3401ae7f7310fca5$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $qzkJD.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $kE36r.readUInt32BE(key, 0);
    var kR = $kE36r.readUInt32BE(key, 4);
    $kE36r.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $3401ae7f7310fca5$var$shiftTable[i >>> 1];
        kL = $kE36r.r28shl(kL, shift);
        kR = $kE36r.r28shl(kR, shift);
        $kE36r.pc2(kL, kR, state.keys, i);
    }
};
$3401ae7f7310fca5$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $kE36r.readUInt32BE(inp, inOff);
    var r = $kE36r.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $kE36r.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $kE36r.writeUInt32BE(out, l, outOff);
    $kE36r.writeUInt32BE(out, r, outOff + 4);
};
$3401ae7f7310fca5$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$3401ae7f7310fca5$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$qzkJD.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$3401ae7f7310fca5$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $kE36r.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $kE36r.substitute(keyL, keyR);
        var f = $kE36r.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $kE36r.rip(r, l, out, off);
};
$3401ae7f7310fca5$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $kE36r.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $kE36r.substitute(keyL, keyR);
        var f = $kE36r.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $kE36r.rip(l, r, out, off);
};

});

parcelRegister("hRbHn", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $d00076021de14d69$export$f9bb8d20ccc7477a; }, function (v) { return $d00076021de14d69$export$f9bb8d20ccc7477a = v; });
var $d00076021de14d69$export$f9bb8d20ccc7477a;
'use strict';

var $qzkJD = parcelRequire("qzkJD");

var $4rf1u = parcelRequire("4rf1u");
var $d00076021de14d69$var$proto = {};
function $d00076021de14d69$var$CBCState(iv) {
    $qzkJD.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $d00076021de14d69$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $4rf1u(CBC, Base);
    var keys = Object.keys($d00076021de14d69$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $d00076021de14d69$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$d00076021de14d69$export$f9bb8d20ccc7477a = $d00076021de14d69$var$instantiate;
$d00076021de14d69$var$proto._cbcInit = function _cbcInit() {
    var state = new $d00076021de14d69$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$d00076021de14d69$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("30RMR", function(module, exports) {
'use strict';

var $qzkJD = parcelRequire("qzkJD");

var $4rf1u = parcelRequire("4rf1u");

var $ilHPC = parcelRequire("ilHPC");

var $4sPrx = parcelRequire("4sPrx");
function $231b182f2e3e6fee$var$EDEState(type, key) {
    $qzkJD.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $4sPrx.create({
            type: 'encrypt',
            key: k1
        }),
        $4sPrx.create({
            type: 'decrypt',
            key: k2
        }),
        $4sPrx.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $4sPrx.create({
            type: 'decrypt',
            key: k3
        }),
        $4sPrx.create({
            type: 'encrypt',
            key: k2
        }),
        $4sPrx.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $231b182f2e3e6fee$var$EDE(options) {
    $ilHPC.call(this, options);
    var state = new $231b182f2e3e6fee$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$4rf1u($231b182f2e3e6fee$var$EDE, $ilHPC);
module.exports = $231b182f2e3e6fee$var$EDE;
$231b182f2e3e6fee$var$EDE.create = function create(options) {
    return new $231b182f2e3e6fee$var$EDE(options);
};
$231b182f2e3e6fee$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$231b182f2e3e6fee$var$EDE.prototype._pad = $4sPrx.prototype._pad;
$231b182f2e3e6fee$var$EDE.prototype._unpad = $4sPrx.prototype._unpad;

});



parcelRegister("dvlcQ", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $9d4e9eb85ce99d01$export$2f64596b8cbf08b4; }, function (v) { return $9d4e9eb85ce99d01$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $9d4e9eb85ce99d01$export$36b6d6ef312eab39; }, function (v) { return $9d4e9eb85ce99d01$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $9d4e9eb85ce99d01$export$58a258485f1e49f6; }, function (v) { return $9d4e9eb85ce99d01$export$58a258485f1e49f6 = v; });
var $9d4e9eb85ce99d01$export$bdd223f16383713e;
var $9d4e9eb85ce99d01$export$26e5786e8ac8e530;
var $9d4e9eb85ce99d01$export$2f64596b8cbf08b4;
var $9d4e9eb85ce99d01$export$20533d26f07f1ee0;
var $9d4e9eb85ce99d01$export$12ada9414fbc594c;
var $9d4e9eb85ce99d01$export$2ce6d8d0e8b04e1a;
var $9d4e9eb85ce99d01$export$36b6d6ef312eab39;
var $9d4e9eb85ce99d01$export$f5e7e39d57cd9700;
var $9d4e9eb85ce99d01$export$dedd8dc3dc62b370;
var $9d4e9eb85ce99d01$export$58a258485f1e49f6;

var $LmZSo = parcelRequire("LmZSo");

var $b2d1k = parcelRequire("b2d1k");

var $2ohAQ = parcelRequire("2ohAQ");
function $9d4e9eb85ce99d01$var$getCiphers() {
    return Object.keys($2ohAQ);
}
$9d4e9eb85ce99d01$export$bdd223f16383713e = $9d4e9eb85ce99d01$export$26e5786e8ac8e530 = $LmZSo.createCipher;
$9d4e9eb85ce99d01$export$2f64596b8cbf08b4 = $9d4e9eb85ce99d01$export$20533d26f07f1ee0 = $LmZSo.createCipheriv;
$9d4e9eb85ce99d01$export$12ada9414fbc594c = $9d4e9eb85ce99d01$export$2ce6d8d0e8b04e1a = $b2d1k.createDecipher;
$9d4e9eb85ce99d01$export$36b6d6ef312eab39 = $9d4e9eb85ce99d01$export$f5e7e39d57cd9700 = $b2d1k.createDecipheriv;
$9d4e9eb85ce99d01$export$dedd8dc3dc62b370 = $9d4e9eb85ce99d01$export$58a258485f1e49f6 = $9d4e9eb85ce99d01$var$getCiphers;

});
parcelRegister("LmZSo", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $08e63aa07c1b9223$export$2f64596b8cbf08b4; }, function (v) { return $08e63aa07c1b9223$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $08e63aa07c1b9223$export$bdd223f16383713e; }, function (v) { return $08e63aa07c1b9223$export$bdd223f16383713e = v; });
var $08e63aa07c1b9223$export$2f64596b8cbf08b4;
var $08e63aa07c1b9223$export$bdd223f16383713e;

var $1HbpH = parcelRequire("1HbpH");

var $guXfM = parcelRequire("guXfM");

var $fF8dn = parcelRequire("fF8dn");
var $08e63aa07c1b9223$require$Buffer = $fF8dn.Buffer;

var $cTcUM = parcelRequire("cTcUM");

var $lRCsB = parcelRequire("lRCsB");

var $jkrBO = parcelRequire("jkrBO");

var $9zoIs = parcelRequire("9zoIs");

var $4rf1u = parcelRequire("4rf1u");
function $08e63aa07c1b9223$var$Cipher(mode, key, iv) {
    $lRCsB.call(this);
    this._cache = new $08e63aa07c1b9223$var$Splitter();
    this._cipher = new $jkrBO.AES(key);
    this._prev = $08e63aa07c1b9223$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$4rf1u($08e63aa07c1b9223$var$Cipher, $lRCsB);
$08e63aa07c1b9223$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $08e63aa07c1b9223$require$Buffer.concat(out);
};
var $08e63aa07c1b9223$var$PADDING = $08e63aa07c1b9223$require$Buffer.alloc(16, 0x10);
$08e63aa07c1b9223$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($08e63aa07c1b9223$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$08e63aa07c1b9223$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $08e63aa07c1b9223$var$Splitter() {
    this.cache = $08e63aa07c1b9223$require$Buffer.allocUnsafe(0);
}
$08e63aa07c1b9223$var$Splitter.prototype.add = function(data) {
    this.cache = $08e63aa07c1b9223$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$08e63aa07c1b9223$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$08e63aa07c1b9223$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $08e63aa07c1b9223$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $08e63aa07c1b9223$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $08e63aa07c1b9223$var$createCipheriv(suite, password, iv) {
    var config = $1HbpH[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $08e63aa07c1b9223$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $08e63aa07c1b9223$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $cTcUM(config.module, password, iv);
    else if (config.type === 'auth') return new $guXfM(config.module, password, iv);
    return new $08e63aa07c1b9223$var$Cipher(config.module, password, iv);
}
function $08e63aa07c1b9223$var$createCipher(suite, password) {
    var config = $1HbpH[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $9zoIs(password, false, config.key, config.iv);
    return $08e63aa07c1b9223$var$createCipheriv(suite, keys.key, keys.iv);
}
$08e63aa07c1b9223$export$2f64596b8cbf08b4 = $08e63aa07c1b9223$var$createCipheriv;
$08e63aa07c1b9223$export$bdd223f16383713e = $08e63aa07c1b9223$var$createCipher;

});
parcelRegister("1HbpH", function(module, exports) {








var $13c2a91b5c8bce85$var$modeModules = {
    ECB: (parcelRequire("28pyd")),
    CBC: (parcelRequire("22fV9")),
    CFB: (parcelRequire("7GRTJ")),
    CFB8: (parcelRequire("gEiVW")),
    CFB1: (parcelRequire("bUBFf")),
    OFB: (parcelRequire("wqags")),
    CTR: (parcelRequire("BexCE")),
    GCM: (parcelRequire("BexCE"))
};

var $2ohAQ = parcelRequire("2ohAQ");
for(var $13c2a91b5c8bce85$var$key in $2ohAQ)$2ohAQ[$13c2a91b5c8bce85$var$key].module = $13c2a91b5c8bce85$var$modeModules[$2ohAQ[$13c2a91b5c8bce85$var$key].mode];
module.exports = $2ohAQ;

});
parcelRegister("28pyd", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $18e02601ddf53146$export$5b0f6292f11d1d18; }, function (v) { return $18e02601ddf53146$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $18e02601ddf53146$export$e85a0c9a1067c5d3; }, function (v) { return $18e02601ddf53146$export$e85a0c9a1067c5d3 = v; });
var $18e02601ddf53146$export$5b0f6292f11d1d18;
var $18e02601ddf53146$export$e85a0c9a1067c5d3;
$18e02601ddf53146$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$18e02601ddf53146$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("22fV9", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $17b81e3314d01849$export$5b0f6292f11d1d18; }, function (v) { return $17b81e3314d01849$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $17b81e3314d01849$export$e85a0c9a1067c5d3; }, function (v) { return $17b81e3314d01849$export$e85a0c9a1067c5d3 = v; });
var $17b81e3314d01849$export$5b0f6292f11d1d18;
var $17b81e3314d01849$export$e85a0c9a1067c5d3;

var $iV0Id = parcelRequire("iV0Id");
$17b81e3314d01849$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $iV0Id(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$17b81e3314d01849$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $iV0Id(out, pad);
};

});
parcelRegister("iV0Id", function(module, exports) {

var $b0kMB = parcelRequire("b0kMB");
var $dc5e1a44304826cb$require$Buffer = $b0kMB.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $dc5e1a44304826cb$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("7GRTJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $599643a3d9a664c2$export$5b0f6292f11d1d18; }, function (v) { return $599643a3d9a664c2$export$5b0f6292f11d1d18 = v; });
var $599643a3d9a664c2$export$5b0f6292f11d1d18;

var $fF8dn = parcelRequire("fF8dn");
var $599643a3d9a664c2$require$Buffer = $fF8dn.Buffer;

var $iV0Id = parcelRequire("iV0Id");
function $599643a3d9a664c2$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $iV0Id(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $599643a3d9a664c2$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$599643a3d9a664c2$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $599643a3d9a664c2$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $599643a3d9a664c2$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $599643a3d9a664c2$require$Buffer.concat([
                out,
                $599643a3d9a664c2$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $599643a3d9a664c2$require$Buffer.concat([
                out,
                $599643a3d9a664c2$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("gEiVW", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c1ef1198855928f7$export$5b0f6292f11d1d18; }, function (v) { return $c1ef1198855928f7$export$5b0f6292f11d1d18 = v; });
var $c1ef1198855928f7$export$5b0f6292f11d1d18;

var $fF8dn = parcelRequire("fF8dn");
var $c1ef1198855928f7$require$Buffer = $fF8dn.Buffer;
function $c1ef1198855928f7$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $c1ef1198855928f7$require$Buffer.concat([
        self._prev.slice(1),
        $c1ef1198855928f7$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$c1ef1198855928f7$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $c1ef1198855928f7$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $c1ef1198855928f7$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("bUBFf", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $8ac223fdb09952c3$export$5b0f6292f11d1d18; }, function (v) { return $8ac223fdb09952c3$export$5b0f6292f11d1d18 = v; });
var $8ac223fdb09952c3$export$5b0f6292f11d1d18;

var $fF8dn = parcelRequire("fF8dn");
var $8ac223fdb09952c3$require$Buffer = $fF8dn.Buffer;
function $8ac223fdb09952c3$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $8ac223fdb09952c3$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $8ac223fdb09952c3$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $8ac223fdb09952c3$require$Buffer.allocUnsafe(buffer.length);
    buffer = $8ac223fdb09952c3$require$Buffer.concat([
        buffer,
        $8ac223fdb09952c3$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$8ac223fdb09952c3$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $8ac223fdb09952c3$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $8ac223fdb09952c3$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("wqags", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $061749026b306711$export$5b0f6292f11d1d18; }, function (v) { return $061749026b306711$export$5b0f6292f11d1d18 = v; });
var $061749026b306711$export$5b0f6292f11d1d18;

var $b0kMB = parcelRequire("b0kMB");
var $061749026b306711$require$Buffer = $b0kMB.Buffer;

var $iV0Id = parcelRequire("iV0Id");
function $061749026b306711$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$061749026b306711$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $061749026b306711$require$Buffer.concat([
        self._cache,
        $061749026b306711$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $iV0Id(chunk, pad);
};

});

parcelRegister("BexCE", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $06febc6a286bfbf3$export$5b0f6292f11d1d18; }, function (v) { return $06febc6a286bfbf3$export$5b0f6292f11d1d18 = v; });
var $06febc6a286bfbf3$export$5b0f6292f11d1d18;

var $iV0Id = parcelRequire("iV0Id");

var $fF8dn = parcelRequire("fF8dn");
var $06febc6a286bfbf3$require$Buffer = $fF8dn.Buffer;

var $bQOlx = parcelRequire("bQOlx");
function $06febc6a286bfbf3$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $bQOlx(self._prev);
    return out;
}
var $06febc6a286bfbf3$var$blockSize = 16;
$06febc6a286bfbf3$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $06febc6a286bfbf3$var$blockSize);
    var start = self._cache.length;
    self._cache = $06febc6a286bfbf3$require$Buffer.concat([
        self._cache,
        $06febc6a286bfbf3$require$Buffer.allocUnsafe(chunkNum * $06febc6a286bfbf3$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $06febc6a286bfbf3$var$getBlock(self);
        var offset = start + i * $06febc6a286bfbf3$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $iV0Id(chunk, pad);
};

});
parcelRegister("bQOlx", function(module, exports) {
function $8a0b9ac4b5218915$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $8a0b9ac4b5218915$var$incr32;

});


parcelRegister("2ohAQ", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("guXfM", function(module, exports) {

var $jkrBO = parcelRequire("jkrBO");

var $fF8dn = parcelRequire("fF8dn");
var $c02d692c94378615$require$Buffer = $fF8dn.Buffer;

var $lRCsB = parcelRequire("lRCsB");

var $4rf1u = parcelRequire("4rf1u");

var $85rSm = parcelRequire("85rSm");

var $iV0Id = parcelRequire("iV0Id");

var $bQOlx = parcelRequire("bQOlx");
function $c02d692c94378615$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $c02d692c94378615$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $c02d692c94378615$require$Buffer.concat([
            iv,
            $c02d692c94378615$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $c02d692c94378615$require$Buffer.concat([
            iv,
            $c02d692c94378615$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $85rSm(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($c02d692c94378615$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($c02d692c94378615$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $c02d692c94378615$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $c02d692c94378615$require$Buffer.from(self._finID);
    $bQOlx(out);
    return out;
}
function $c02d692c94378615$var$StreamCipher(mode, key, iv, decrypt) {
    $lRCsB.call(this);
    var h = $c02d692c94378615$require$Buffer.alloc(4, 0);
    this._cipher = new $jkrBO.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $85rSm(ck);
    iv = $c02d692c94378615$var$calcIv(this, iv, ck);
    this._prev = $c02d692c94378615$require$Buffer.from(iv);
    this._cache = $c02d692c94378615$require$Buffer.allocUnsafe(0);
    this._secCache = $c02d692c94378615$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$4rf1u($c02d692c94378615$var$StreamCipher, $lRCsB);
$c02d692c94378615$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $c02d692c94378615$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$c02d692c94378615$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $iV0Id(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $c02d692c94378615$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$c02d692c94378615$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$c02d692c94378615$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$c02d692c94378615$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$c02d692c94378615$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $c02d692c94378615$var$StreamCipher;

});
parcelRegister("jkrBO", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $e1254d1e971e3338$export$b80fbe1c3a2b92b5; }, function (v) { return $e1254d1e971e3338$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $e1254d1e971e3338$export$b80fbe1c3a2b92b5;

var $fF8dn = parcelRequire("fF8dn");
var $e1254d1e971e3338$require$Buffer = $fF8dn.Buffer;
function $e1254d1e971e3338$var$asUInt32Array(buf) {
    if (!$e1254d1e971e3338$require$Buffer.isBuffer(buf)) buf = $e1254d1e971e3338$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $e1254d1e971e3338$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $e1254d1e971e3338$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $e1254d1e971e3338$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $e1254d1e971e3338$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $e1254d1e971e3338$var$AES(key) {
    this._key = $e1254d1e971e3338$var$asUInt32Array(key);
    this._reset();
}
$e1254d1e971e3338$var$AES.blockSize = 16;
$e1254d1e971e3338$var$AES.keySize = 32;
$e1254d1e971e3338$var$AES.prototype.blockSize = $e1254d1e971e3338$var$AES.blockSize;
$e1254d1e971e3338$var$AES.prototype.keySize = $e1254d1e971e3338$var$AES.keySize;
$e1254d1e971e3338$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $e1254d1e971e3338$var$G.SBOX[t >>> 24] << 24 | $e1254d1e971e3338$var$G.SBOX[t >>> 16 & 0xff] << 16 | $e1254d1e971e3338$var$G.SBOX[t >>> 8 & 0xff] << 8 | $e1254d1e971e3338$var$G.SBOX[t & 0xff];
            t ^= $e1254d1e971e3338$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $e1254d1e971e3338$var$G.SBOX[t >>> 24] << 24 | $e1254d1e971e3338$var$G.SBOX[t >>> 16 & 0xff] << 16 | $e1254d1e971e3338$var$G.SBOX[t >>> 8 & 0xff] << 8 | $e1254d1e971e3338$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $e1254d1e971e3338$var$G.INV_SUB_MIX[0][$e1254d1e971e3338$var$G.SBOX[tt >>> 24]] ^ $e1254d1e971e3338$var$G.INV_SUB_MIX[1][$e1254d1e971e3338$var$G.SBOX[tt >>> 16 & 0xff]] ^ $e1254d1e971e3338$var$G.INV_SUB_MIX[2][$e1254d1e971e3338$var$G.SBOX[tt >>> 8 & 0xff]] ^ $e1254d1e971e3338$var$G.INV_SUB_MIX[3][$e1254d1e971e3338$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$e1254d1e971e3338$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $e1254d1e971e3338$var$asUInt32Array(M);
    return $e1254d1e971e3338$var$cryptBlock(M, this._keySchedule, $e1254d1e971e3338$var$G.SUB_MIX, $e1254d1e971e3338$var$G.SBOX, this._nRounds);
};
$e1254d1e971e3338$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $e1254d1e971e3338$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$e1254d1e971e3338$var$AES.prototype.decryptBlock = function(M) {
    M = $e1254d1e971e3338$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $e1254d1e971e3338$var$cryptBlock(M, this._invKeySchedule, $e1254d1e971e3338$var$G.INV_SUB_MIX, $e1254d1e971e3338$var$G.INV_SBOX, this._nRounds);
    var buf = $e1254d1e971e3338$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$e1254d1e971e3338$var$AES.prototype.scrub = function() {
    $e1254d1e971e3338$var$scrubVec(this._keySchedule);
    $e1254d1e971e3338$var$scrubVec(this._invKeySchedule);
    $e1254d1e971e3338$var$scrubVec(this._key);
};
$e1254d1e971e3338$export$b80fbe1c3a2b92b5 = $e1254d1e971e3338$var$AES;

});

parcelRegister("85rSm", function(module, exports) {

var $fF8dn = parcelRequire("fF8dn");
var $5e3469eda975bd39$require$Buffer = $fF8dn.Buffer;
var $5e3469eda975bd39$var$ZEROES = $5e3469eda975bd39$require$Buffer.alloc(16, 0);
function $5e3469eda975bd39$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $5e3469eda975bd39$var$fromArray(out) {
    var buf = $5e3469eda975bd39$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $5e3469eda975bd39$var$GHASH(key) {
    this.h = key;
    this.state = $5e3469eda975bd39$require$Buffer.alloc(16, 0);
    this.cache = $5e3469eda975bd39$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$5e3469eda975bd39$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$5e3469eda975bd39$var$GHASH.prototype._multiply = function() {
    var Vi = $5e3469eda975bd39$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $5e3469eda975bd39$var$fromArray(Zi);
};
$5e3469eda975bd39$var$GHASH.prototype.update = function(buf) {
    this.cache = $5e3469eda975bd39$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$5e3469eda975bd39$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($5e3469eda975bd39$require$Buffer.concat([
        this.cache,
        $5e3469eda975bd39$var$ZEROES
    ], 16));
    this.ghash($5e3469eda975bd39$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $5e3469eda975bd39$var$GHASH;

});


parcelRegister("cTcUM", function(module, exports) {

var $jkrBO = parcelRequire("jkrBO");

var $fF8dn = parcelRequire("fF8dn");
var $9624a3aea4a53224$require$Buffer = $fF8dn.Buffer;

var $lRCsB = parcelRequire("lRCsB");

var $4rf1u = parcelRequire("4rf1u");
function $9624a3aea4a53224$var$StreamCipher(mode, key, iv, decrypt) {
    $lRCsB.call(this);
    this._cipher = new $jkrBO.AES(key);
    this._prev = $9624a3aea4a53224$require$Buffer.from(iv);
    this._cache = $9624a3aea4a53224$require$Buffer.allocUnsafe(0);
    this._secCache = $9624a3aea4a53224$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$4rf1u($9624a3aea4a53224$var$StreamCipher, $lRCsB);
$9624a3aea4a53224$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$9624a3aea4a53224$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $9624a3aea4a53224$var$StreamCipher;

});

parcelRegister("9zoIs", function(module, exports) {

var $fF8dn = parcelRequire("fF8dn");
var $6f7a8e0cc2f45b23$require$Buffer = $fF8dn.Buffer;

var $cfjWo = parcelRequire("cfjWo");
/* eslint-disable camelcase */ function $6f7a8e0cc2f45b23$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$6f7a8e0cc2f45b23$require$Buffer.isBuffer(password)) password = $6f7a8e0cc2f45b23$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$6f7a8e0cc2f45b23$require$Buffer.isBuffer(salt)) salt = $6f7a8e0cc2f45b23$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $6f7a8e0cc2f45b23$require$Buffer.alloc(keyLen);
    var iv = $6f7a8e0cc2f45b23$require$Buffer.alloc(ivLen || 0);
    var tmp = $6f7a8e0cc2f45b23$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $cfjWo();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $6f7a8e0cc2f45b23$var$EVP_BytesToKey;

});


parcelRegister("b2d1k", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $8089fb33462430d6$export$12ada9414fbc594c; }, function (v) { return $8089fb33462430d6$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $8089fb33462430d6$export$36b6d6ef312eab39; }, function (v) { return $8089fb33462430d6$export$36b6d6ef312eab39 = v; });
var $8089fb33462430d6$export$12ada9414fbc594c;
var $8089fb33462430d6$export$36b6d6ef312eab39;

var $guXfM = parcelRequire("guXfM");

var $fF8dn = parcelRequire("fF8dn");
var $8089fb33462430d6$require$Buffer = $fF8dn.Buffer;

var $1HbpH = parcelRequire("1HbpH");

var $cTcUM = parcelRequire("cTcUM");

var $lRCsB = parcelRequire("lRCsB");

var $jkrBO = parcelRequire("jkrBO");

var $9zoIs = parcelRequire("9zoIs");

var $4rf1u = parcelRequire("4rf1u");
function $8089fb33462430d6$var$Decipher(mode, key, iv) {
    $lRCsB.call(this);
    this._cache = new $8089fb33462430d6$var$Splitter();
    this._last = void 0;
    this._cipher = new $jkrBO.AES(key);
    this._prev = $8089fb33462430d6$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$4rf1u($8089fb33462430d6$var$Decipher, $lRCsB);
$8089fb33462430d6$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $8089fb33462430d6$require$Buffer.concat(out);
};
$8089fb33462430d6$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $8089fb33462430d6$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$8089fb33462430d6$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $8089fb33462430d6$var$Splitter() {
    this.cache = $8089fb33462430d6$require$Buffer.allocUnsafe(0);
}
$8089fb33462430d6$var$Splitter.prototype.add = function(data) {
    this.cache = $8089fb33462430d6$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$8089fb33462430d6$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$8089fb33462430d6$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $8089fb33462430d6$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $8089fb33462430d6$var$createDecipheriv(suite, password, iv) {
    var config = $1HbpH[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $8089fb33462430d6$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $8089fb33462430d6$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $cTcUM(config.module, password, iv, true);
    else if (config.type === 'auth') return new $guXfM(config.module, password, iv, true);
    return new $8089fb33462430d6$var$Decipher(config.module, password, iv);
}
function $8089fb33462430d6$var$createDecipher(suite, password) {
    var config = $1HbpH[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $9zoIs(password, false, config.key, config.iv);
    return $8089fb33462430d6$var$createDecipheriv(suite, keys.key, keys.iv);
}
$8089fb33462430d6$export$12ada9414fbc594c = $8089fb33462430d6$var$createDecipher;
$8089fb33462430d6$export$36b6d6ef312eab39 = $8089fb33462430d6$var$createDecipheriv;

});


parcelRegister("b74Lh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $81740aaefe75d6dc$export$116f8a5cee447347; }, function (v) { return $81740aaefe75d6dc$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $81740aaefe75d6dc$export$7483c4066bfb7ae9; }, function (v) { return $81740aaefe75d6dc$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $81740aaefe75d6dc$export$e7a565d2e588bb06; }, function (v) { return $81740aaefe75d6dc$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $81740aaefe75d6dc$export$aaa2f54a426f3eb8; }, function (v) { return $81740aaefe75d6dc$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $81740aaefe75d6dc$export$eba20568dde4ada; }, function (v) { return $81740aaefe75d6dc$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $81740aaefe75d6dc$export$d3b5e5996938f5ae; }, function (v) { return $81740aaefe75d6dc$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $81740aaefe75d6dc$export$57c08356130bc99b; }, function (v) { return $81740aaefe75d6dc$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $81740aaefe75d6dc$export$c7169791d5c1e65d; }, function (v) { return $81740aaefe75d6dc$export$c7169791d5c1e65d = v; });
var $81740aaefe75d6dc$export$116f8a5cee447347;
var $81740aaefe75d6dc$export$7483c4066bfb7ae9;
var $81740aaefe75d6dc$export$e7a565d2e588bb06;
var $81740aaefe75d6dc$export$aaa2f54a426f3eb8;
var $81740aaefe75d6dc$export$eba20568dde4ada;
var $81740aaefe75d6dc$export$d3b5e5996938f5ae;
var $81740aaefe75d6dc$export$57c08356130bc99b;
var $81740aaefe75d6dc$export$c7169791d5c1e65d;
$81740aaefe75d6dc$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$81740aaefe75d6dc$export$7483c4066bfb7ae9 = $81740aaefe75d6dc$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$81740aaefe75d6dc$export$aaa2f54a426f3eb8 = $81740aaefe75d6dc$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$81740aaefe75d6dc$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$81740aaefe75d6dc$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$81740aaefe75d6dc$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("d9lw7", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $992cce7995534020$export$971862a2fcb1bb40; }, function (v) { return $992cce7995534020$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $992cce7995534020$export$c6ff6a88acbeaf40; }, function (v) { return $992cce7995534020$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $992cce7995534020$export$fdc27893e98845cc; }, function (v) { return $992cce7995534020$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $992cce7995534020$export$6671fb9a1323bed; }, function (v) { return $992cce7995534020$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $992cce7995534020$export$d74daf141a551db; }, function (v) { return $992cce7995534020$export$d74daf141a551db = v; });
var $992cce7995534020$export$971862a2fcb1bb40;
var $992cce7995534020$export$c6ff6a88acbeaf40;
var $992cce7995534020$export$fdc27893e98845cc;
var $992cce7995534020$export$6671fb9a1323bed;
var $992cce7995534020$export$d74daf141a551db;

var $b0kMB = parcelRequire("b0kMB");
var $992cce7995534020$require$Buffer = $b0kMB.Buffer;

var $l0Um0 = parcelRequire("l0Um0");

var $ha7Xb = parcelRequire("ha7Xb");

var $ddbqx = parcelRequire("ddbqx");
function $992cce7995534020$var$getDiffieHellman(mod) {
    var prime = new $992cce7995534020$require$Buffer($ha7Xb[mod].prime, 'hex');
    var gen = new $992cce7995534020$require$Buffer($ha7Xb[mod].gen, 'hex');
    return new $ddbqx(prime, gen);
}
var $992cce7995534020$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $992cce7995534020$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($992cce7995534020$require$Buffer.isBuffer(enc) || $992cce7995534020$var$ENCODINGS[enc] === undefined) return $992cce7995534020$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $992cce7995534020$require$Buffer([
        2
    ]);
    if (!$992cce7995534020$require$Buffer.isBuffer(generator)) generator = new $992cce7995534020$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $ddbqx($l0Um0(prime, generator), generator, true);
    if (!$992cce7995534020$require$Buffer.isBuffer(prime)) prime = new $992cce7995534020$require$Buffer(prime, enc);
    return new $ddbqx(prime, generator, true);
}
$992cce7995534020$export$971862a2fcb1bb40 = $992cce7995534020$export$c6ff6a88acbeaf40 = $992cce7995534020$export$fdc27893e98845cc = $992cce7995534020$var$getDiffieHellman;
$992cce7995534020$export$6671fb9a1323bed = $992cce7995534020$export$d74daf141a551db = $992cce7995534020$var$createDiffieHellman;

});
parcelRegister("l0Um0", function(module, exports) {

var $a0Pw9 = parcelRequire("a0Pw9");
module.exports = $f4c54fcad123f5cb$var$findPrime;
$f4c54fcad123f5cb$var$findPrime.simpleSieve = $f4c54fcad123f5cb$var$simpleSieve;
$f4c54fcad123f5cb$var$findPrime.fermatTest = $f4c54fcad123f5cb$var$fermatTest;

var $gN7z6 = parcelRequire("gN7z6");
var $f4c54fcad123f5cb$var$TWENTYFOUR = new $gN7z6(24);

var $9pqEU = parcelRequire("9pqEU");
var $f4c54fcad123f5cb$var$millerRabin = new $9pqEU();
var $f4c54fcad123f5cb$var$ONE = new $gN7z6(1);
var $f4c54fcad123f5cb$var$TWO = new $gN7z6(2);
var $f4c54fcad123f5cb$var$FIVE = new $gN7z6(5);
var $f4c54fcad123f5cb$var$SIXTEEN = new $gN7z6(16);
var $f4c54fcad123f5cb$var$EIGHT = new $gN7z6(8);
var $f4c54fcad123f5cb$var$TEN = new $gN7z6(10);
var $f4c54fcad123f5cb$var$THREE = new $gN7z6(3);
var $f4c54fcad123f5cb$var$SEVEN = new $gN7z6(7);
var $f4c54fcad123f5cb$var$ELEVEN = new $gN7z6(11);
var $f4c54fcad123f5cb$var$FOUR = new $gN7z6(4);
var $f4c54fcad123f5cb$var$TWELVE = new $gN7z6(12);
var $f4c54fcad123f5cb$var$primes = null;
function $f4c54fcad123f5cb$var$_getPrimes() {
    if ($f4c54fcad123f5cb$var$primes !== null) return $f4c54fcad123f5cb$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $f4c54fcad123f5cb$var$primes = res;
    return res;
}
function $f4c54fcad123f5cb$var$simpleSieve(p) {
    var primes = $f4c54fcad123f5cb$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $f4c54fcad123f5cb$var$fermatTest(p) {
    var red = $gN7z6.mont(p);
    return $f4c54fcad123f5cb$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $f4c54fcad123f5cb$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $gN7z6([
            0x8c,
            0x7b
        ]);
        else return new $gN7z6([
            0x8c,
            0x27
        ]);
    }
    gen = new $gN7z6(gen);
    var num, n2;
    while(true){
        num = new $gN7z6($a0Pw9(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($f4c54fcad123f5cb$var$ONE);
        if (!num.testn(1)) num.iadd($f4c54fcad123f5cb$var$TWO);
        if (!gen.cmp($f4c54fcad123f5cb$var$TWO)) while(num.mod($f4c54fcad123f5cb$var$TWENTYFOUR).cmp($f4c54fcad123f5cb$var$ELEVEN))num.iadd($f4c54fcad123f5cb$var$FOUR);
        else if (!gen.cmp($f4c54fcad123f5cb$var$FIVE)) while(num.mod($f4c54fcad123f5cb$var$TEN).cmp($f4c54fcad123f5cb$var$THREE))num.iadd($f4c54fcad123f5cb$var$FOUR);
        n2 = num.shrn(1);
        if ($f4c54fcad123f5cb$var$simpleSieve(n2) && $f4c54fcad123f5cb$var$simpleSieve(num) && $f4c54fcad123f5cb$var$fermatTest(n2) && $f4c54fcad123f5cb$var$fermatTest(num) && $f4c54fcad123f5cb$var$millerRabin.test(n2) && $f4c54fcad123f5cb$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("gN7z6", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("80bNa")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9pqEU", function(module, exports) {

var $5SZH2 = parcelRequire("5SZH2");

var $cA0my = parcelRequire("cA0my");
function $6d9b20c2b73b670a$var$MillerRabin(rand) {
    this.rand = rand || new $cA0my.Rand();
}
module.exports = $6d9b20c2b73b670a$var$MillerRabin;
$6d9b20c2b73b670a$var$MillerRabin.create = function create(rand) {
    return new $6d9b20c2b73b670a$var$MillerRabin(rand);
};
$6d9b20c2b73b670a$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $5SZH2(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$6d9b20c2b73b670a$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$6d9b20c2b73b670a$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $5SZH2.mont(n);
    var rone = new $5SZH2(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $5SZH2(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$6d9b20c2b73b670a$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $5SZH2.mont(n);
    var rone = new $5SZH2(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $5SZH2(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("5SZH2", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("80bNa")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("cA0my", function(module, exports) {
var $928920e193d481e2$var$r;
module.exports = function rand(len) {
    if (!$928920e193d481e2$var$r) $928920e193d481e2$var$r = new $928920e193d481e2$var$Rand(null);
    return $928920e193d481e2$var$r.generate(len);
};
function $928920e193d481e2$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $928920e193d481e2$var$Rand;
$928920e193d481e2$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$928920e193d481e2$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $928920e193d481e2$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $928920e193d481e2$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $928920e193d481e2$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $928920e193d481e2$var$crypto = (parcelRequire("80bNa"));
    if (typeof $928920e193d481e2$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $928920e193d481e2$var$Rand.prototype._rand = function _rand(n) {
        return $928920e193d481e2$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("ha7Xb", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("ddbqx", function(module, exports) {

var $b0kMB = parcelRequire("b0kMB");
var $99e55a74058d0fbe$require$Buffer = $b0kMB.Buffer;

var $gN7z6 = parcelRequire("gN7z6");

var $9pqEU = parcelRequire("9pqEU");
var $99e55a74058d0fbe$var$millerRabin = new $9pqEU();
var $99e55a74058d0fbe$var$TWENTYFOUR = new $gN7z6(24);
var $99e55a74058d0fbe$var$ELEVEN = new $gN7z6(11);
var $99e55a74058d0fbe$var$TEN = new $gN7z6(10);
var $99e55a74058d0fbe$var$THREE = new $gN7z6(3);
var $99e55a74058d0fbe$var$SEVEN = new $gN7z6(7);

var $l0Um0 = parcelRequire("l0Um0");

var $a0Pw9 = parcelRequire("a0Pw9");
module.exports = $99e55a74058d0fbe$var$DH;
function $99e55a74058d0fbe$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$99e55a74058d0fbe$require$Buffer.isBuffer(pub)) pub = new $99e55a74058d0fbe$require$Buffer(pub, enc);
    this._pub = new $gN7z6(pub);
    return this;
}
function $99e55a74058d0fbe$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$99e55a74058d0fbe$require$Buffer.isBuffer(priv)) priv = new $99e55a74058d0fbe$require$Buffer(priv, enc);
    this._priv = new $gN7z6(priv);
    return this;
}
var $99e55a74058d0fbe$var$primeCache = {};
function $99e55a74058d0fbe$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $99e55a74058d0fbe$var$primeCache) return $99e55a74058d0fbe$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$l0Um0.simpleSieve || !$l0Um0.fermatTest(prime) || !$99e55a74058d0fbe$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $99e55a74058d0fbe$var$primeCache[hex] = error;
        return error;
    }
    if (!$99e55a74058d0fbe$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($99e55a74058d0fbe$var$TWENTYFOUR).cmp($99e55a74058d0fbe$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($99e55a74058d0fbe$var$TEN);
            if (rem.cmp($99e55a74058d0fbe$var$THREE) && rem.cmp($99e55a74058d0fbe$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $99e55a74058d0fbe$var$primeCache[hex] = error;
    return error;
}
function $99e55a74058d0fbe$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $gN7z6(prime);
    this._prime = $gN7z6.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $99e55a74058d0fbe$var$setPublicKey;
        this.setPrivateKey = $99e55a74058d0fbe$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($99e55a74058d0fbe$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $99e55a74058d0fbe$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$99e55a74058d0fbe$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $gN7z6($a0Pw9(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$99e55a74058d0fbe$var$DH.prototype.computeSecret = function(other) {
    other = new $gN7z6(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $99e55a74058d0fbe$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $99e55a74058d0fbe$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $99e55a74058d0fbe$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$99e55a74058d0fbe$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $99e55a74058d0fbe$var$formatReturnValue(this._pub, enc);
};
$99e55a74058d0fbe$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $99e55a74058d0fbe$var$formatReturnValue(this._priv, enc);
};
$99e55a74058d0fbe$var$DH.prototype.getPrime = function(enc) {
    return $99e55a74058d0fbe$var$formatReturnValue(this.__prime, enc);
};
$99e55a74058d0fbe$var$DH.prototype.getGenerator = function(enc) {
    return $99e55a74058d0fbe$var$formatReturnValue(this._gen, enc);
};
$99e55a74058d0fbe$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$99e55a74058d0fbe$require$Buffer.isBuffer(gen)) gen = new $99e55a74058d0fbe$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $gN7z6(gen);
    return this;
};
function $99e55a74058d0fbe$var$formatReturnValue(bn, enc) {
    var buf = new $99e55a74058d0fbe$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("hvjcZ", function(module, exports) {
'use strict';

var $4UJGx = parcelRequire("4UJGx");
var $cbe43b5370f8f3f7$require$Buffer = $4UJGx.Buffer;

var $5GOyq = parcelRequire("5GOyq");

var $dElDN = parcelRequire("dElDN");

var $4rf1u = parcelRequire("4rf1u");

var $vAyWz = parcelRequire("vAyWz");

var $edLK8 = parcelRequire("edLK8");

var $21Dil = parcelRequire("21Dil");
Object.keys($21Dil).forEach(function(key) {
    $21Dil[key].id = $cbe43b5370f8f3f7$require$Buffer.from($21Dil[key].id, 'hex');
    $21Dil[key.toLowerCase()] = $21Dil[key];
});
function $cbe43b5370f8f3f7$var$Sign(algorithm) {
    $dElDN.Writable.call(this);
    var data = $21Dil[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $5GOyq(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$4rf1u($cbe43b5370f8f3f7$var$Sign, $dElDN.Writable);
$cbe43b5370f8f3f7$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$cbe43b5370f8f3f7$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $cbe43b5370f8f3f7$require$Buffer.from(data, enc) : data);
    return this;
};
$cbe43b5370f8f3f7$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $vAyWz(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $cbe43b5370f8f3f7$var$Verify(algorithm) {
    $dElDN.Writable.call(this);
    var data = $21Dil[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $5GOyq(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$4rf1u($cbe43b5370f8f3f7$var$Verify, $dElDN.Writable);
$cbe43b5370f8f3f7$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$cbe43b5370f8f3f7$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $cbe43b5370f8f3f7$require$Buffer.from(data, enc) : data);
    return this;
};
$cbe43b5370f8f3f7$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $cbe43b5370f8f3f7$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $edLK8(sigBuffer, hash, key, this._signType, this._tag);
};
function $cbe43b5370f8f3f7$var$createSign(algorithm) {
    return new $cbe43b5370f8f3f7$var$Sign(algorithm);
}
function $cbe43b5370f8f3f7$var$createVerify(algorithm) {
    return new $cbe43b5370f8f3f7$var$Verify(algorithm);
}
module.exports = {
    Sign: $cbe43b5370f8f3f7$var$createSign,
    Verify: $cbe43b5370f8f3f7$var$createVerify,
    createSign: $cbe43b5370f8f3f7$var$createSign,
    createVerify: $cbe43b5370f8f3f7$var$createVerify
};

});
parcelRegister("4UJGx", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $393fd47b02a8f4bc$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $393fd47b02a8f4bc$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($393fd47b02a8f4bc$var$Buffer.from && $393fd47b02a8f4bc$var$Buffer.alloc && $393fd47b02a8f4bc$var$Buffer.allocUnsafe && $393fd47b02a8f4bc$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $393fd47b02a8f4bc$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $393fd47b02a8f4bc$var$SafeBuffer;
}
function $393fd47b02a8f4bc$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $393fd47b02a8f4bc$var$Buffer(arg, encodingOrOffset, length);
}
$393fd47b02a8f4bc$var$SafeBuffer.prototype = Object.create($393fd47b02a8f4bc$var$Buffer.prototype);
// Copy static methods from Buffer
$393fd47b02a8f4bc$var$copyProps($393fd47b02a8f4bc$var$Buffer, $393fd47b02a8f4bc$var$SafeBuffer);
$393fd47b02a8f4bc$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $393fd47b02a8f4bc$var$Buffer(arg, encodingOrOffset, length);
};
$393fd47b02a8f4bc$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $393fd47b02a8f4bc$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$393fd47b02a8f4bc$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $393fd47b02a8f4bc$var$Buffer(size);
};
$393fd47b02a8f4bc$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});

parcelRegister("dElDN", function(module, exports) {

exports = module.exports = (parcelRequire("dMYtF"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("llDwA"));

exports.Duplex = (parcelRequire("fWoDv"));

exports.Transform = (parcelRequire("4RtJz"));

exports.PassThrough = (parcelRequire("dJmfJ"));

});
parcelRegister("dMYtF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $j1eoE = parcelRequire("j1eoE");
'use strict';

var $jQzVP = parcelRequire("jQzVP");
/*</replacement>*/ module.exports = $a09eab9af52e8419$var$Readable;

var $15mLe = parcelRequire("15mLe");
/*</replacement>*/ /*<replacement>*/ var $a09eab9af52e8419$var$Duplex;
/*</replacement>*/ $a09eab9af52e8419$var$Readable.ReadableState = $a09eab9af52e8419$var$ReadableState;

var $ldFei = parcelRequire("ldFei");
var $a09eab9af52e8419$require$EE = $ldFei.EventEmitter;
var $a09eab9af52e8419$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $kmfCe = parcelRequire("kmfCe");

var $kDn30 = parcelRequire("kDn30");
var $a09eab9af52e8419$require$Buffer = $kDn30.Buffer;
var $a09eab9af52e8419$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $a09eab9af52e8419$var$_uint8ArrayToBuffer(chunk) {
    return $a09eab9af52e8419$require$Buffer.from(chunk);
}
function $a09eab9af52e8419$var$_isUint8Array(obj) {
    return $a09eab9af52e8419$require$Buffer.isBuffer(obj) || obj instanceof $a09eab9af52e8419$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $a09eab9af52e8419$var$util = Object.create((parcelRequire("czp0E")));

$a09eab9af52e8419$var$util.inherits = (parcelRequire("4rf1u"));

var $80bNa = parcelRequire("80bNa");
var $a09eab9af52e8419$var$debug = void 0;
if ($80bNa && $80bNa.debuglog) $a09eab9af52e8419$var$debug = $80bNa.debuglog('stream');
else $a09eab9af52e8419$var$debug = function() {};

var $aiEjh = parcelRequire("aiEjh");

var $l1cFB = parcelRequire("l1cFB");
var $a09eab9af52e8419$var$StringDecoder;
$a09eab9af52e8419$var$util.inherits($a09eab9af52e8419$var$Readable, $kmfCe);
var $a09eab9af52e8419$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $a09eab9af52e8419$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($15mLe(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $a09eab9af52e8419$var$ReadableState(options, stream) {
    $a09eab9af52e8419$var$Duplex = $a09eab9af52e8419$var$Duplex || (parcelRequire("fWoDv"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $a09eab9af52e8419$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aiEjh();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$a09eab9af52e8419$var$StringDecoder) $a09eab9af52e8419$var$StringDecoder = (parcelRequire("lG7Xu")).StringDecoder;
        this.decoder = new $a09eab9af52e8419$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $a09eab9af52e8419$var$Readable(options) {
    $a09eab9af52e8419$var$Duplex = $a09eab9af52e8419$var$Duplex || (parcelRequire("fWoDv"));
    if (!(this instanceof $a09eab9af52e8419$var$Readable)) return new $a09eab9af52e8419$var$Readable(options);
    this._readableState = new $a09eab9af52e8419$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $kmfCe.call(this);
}
Object.defineProperty($a09eab9af52e8419$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$a09eab9af52e8419$var$Readable.prototype.destroy = $l1cFB.destroy;
$a09eab9af52e8419$var$Readable.prototype._undestroy = $l1cFB.undestroy;
$a09eab9af52e8419$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$a09eab9af52e8419$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $a09eab9af52e8419$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $a09eab9af52e8419$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$a09eab9af52e8419$var$Readable.prototype.unshift = function(chunk) {
    return $a09eab9af52e8419$var$readableAddChunk(this, chunk, null, true, false);
};
function $a09eab9af52e8419$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $a09eab9af52e8419$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $a09eab9af52e8419$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $a09eab9af52e8419$require$Buffer.prototype) chunk = $a09eab9af52e8419$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $a09eab9af52e8419$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $a09eab9af52e8419$var$addChunk(stream, state, chunk, false);
                    else $a09eab9af52e8419$var$maybeReadMore(stream, state);
                } else $a09eab9af52e8419$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $a09eab9af52e8419$var$needMoreData(state);
}
function $a09eab9af52e8419$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $a09eab9af52e8419$var$emitReadable(stream);
    }
    $a09eab9af52e8419$var$maybeReadMore(stream, state);
}
function $a09eab9af52e8419$var$chunkInvalid(state, chunk) {
    var er;
    if (!$a09eab9af52e8419$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $a09eab9af52e8419$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$a09eab9af52e8419$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$a09eab9af52e8419$var$Readable.prototype.setEncoding = function(enc) {
    if (!$a09eab9af52e8419$var$StringDecoder) $a09eab9af52e8419$var$StringDecoder = (parcelRequire("lG7Xu")).StringDecoder;
    this._readableState.decoder = new $a09eab9af52e8419$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $a09eab9af52e8419$var$MAX_HWM = 0x800000;
function $a09eab9af52e8419$var$computeNewHighWaterMark(n) {
    if (n >= $a09eab9af52e8419$var$MAX_HWM) n = $a09eab9af52e8419$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a09eab9af52e8419$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $a09eab9af52e8419$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$a09eab9af52e8419$var$Readable.prototype.read = function(n) {
    $a09eab9af52e8419$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $a09eab9af52e8419$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $a09eab9af52e8419$var$endReadable(this);
        else $a09eab9af52e8419$var$emitReadable(this);
        return null;
    }
    n = $a09eab9af52e8419$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $a09eab9af52e8419$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $a09eab9af52e8419$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $a09eab9af52e8419$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $a09eab9af52e8419$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $a09eab9af52e8419$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $a09eab9af52e8419$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $a09eab9af52e8419$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $a09eab9af52e8419$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $a09eab9af52e8419$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $a09eab9af52e8419$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $a09eab9af52e8419$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $a09eab9af52e8419$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $jQzVP.nextTick($a09eab9af52e8419$var$emitReadable_, stream);
        else $a09eab9af52e8419$var$emitReadable_(stream);
    }
}
function $a09eab9af52e8419$var$emitReadable_(stream) {
    $a09eab9af52e8419$var$debug('emit readable');
    stream.emit('readable');
    $a09eab9af52e8419$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $a09eab9af52e8419$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $jQzVP.nextTick($a09eab9af52e8419$var$maybeReadMore_, stream, state);
    }
}
function $a09eab9af52e8419$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $a09eab9af52e8419$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$a09eab9af52e8419$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$a09eab9af52e8419$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $a09eab9af52e8419$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $j1eoE.stdout && dest !== $j1eoE.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $jQzVP.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $a09eab9af52e8419$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $a09eab9af52e8419$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $a09eab9af52e8419$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $a09eab9af52e8419$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $a09eab9af52e8419$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $a09eab9af52e8419$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $a09eab9af52e8419$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $a09eab9af52e8419$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($a09eab9af52e8419$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $a09eab9af52e8419$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $a09eab9af52e8419$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $a09eab9af52e8419$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $a09eab9af52e8419$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $a09eab9af52e8419$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $a09eab9af52e8419$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $a09eab9af52e8419$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $a09eab9af52e8419$var$flow(src);
        }
    };
}
$a09eab9af52e8419$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $a09eab9af52e8419$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$a09eab9af52e8419$var$Readable.prototype.on = function(ev, fn) {
    var res = $kmfCe.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $jQzVP.nextTick($a09eab9af52e8419$var$nReadingNextTick, this);
            else if (state.length) $a09eab9af52e8419$var$emitReadable(this);
        }
    }
    return res;
};
$a09eab9af52e8419$var$Readable.prototype.addListener = $a09eab9af52e8419$var$Readable.prototype.on;
function $a09eab9af52e8419$var$nReadingNextTick(self1) {
    $a09eab9af52e8419$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$a09eab9af52e8419$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $a09eab9af52e8419$var$debug('resume');
        state.flowing = true;
        $a09eab9af52e8419$var$resume(this, state);
    }
    return this;
};
function $a09eab9af52e8419$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $jQzVP.nextTick($a09eab9af52e8419$var$resume_, stream, state);
    }
}
function $a09eab9af52e8419$var$resume_(stream, state) {
    if (!state.reading) {
        $a09eab9af52e8419$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $a09eab9af52e8419$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$a09eab9af52e8419$var$Readable.prototype.pause = function() {
    $a09eab9af52e8419$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $a09eab9af52e8419$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $a09eab9af52e8419$var$flow(stream) {
    var state = stream._readableState;
    $a09eab9af52e8419$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$a09eab9af52e8419$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $a09eab9af52e8419$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $a09eab9af52e8419$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $a09eab9af52e8419$var$kProxyEvents.length; n++)stream.on($a09eab9af52e8419$var$kProxyEvents[n], this.emit.bind(this, $a09eab9af52e8419$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $a09eab9af52e8419$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($a09eab9af52e8419$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$a09eab9af52e8419$var$Readable._fromList = $a09eab9af52e8419$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a09eab9af52e8419$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $a09eab9af52e8419$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a09eab9af52e8419$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $a09eab9af52e8419$var$copyFromBufferString(n, list) : $a09eab9af52e8419$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a09eab9af52e8419$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a09eab9af52e8419$var$copyFromBuffer(n, list) {
    var ret = $a09eab9af52e8419$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $a09eab9af52e8419$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $jQzVP.nextTick($a09eab9af52e8419$var$endReadableNT, state, stream);
    }
}
function $a09eab9af52e8419$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $a09eab9af52e8419$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jQzVP", function(module, exports) {

var $j1eoE = parcelRequire("j1eoE");
'use strict';
module.exports = {
    nextTick: $e72ebeed6dbe8761$var$nextTick
};
function $e72ebeed6dbe8761$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $j1eoE.nextTick(fn);
        case 2:
            return $j1eoE.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $j1eoE.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $j1eoE.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $j1eoE.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("15mLe", function(module, exports) {
var $0ca7e9e7536aae43$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $0ca7e9e7536aae43$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("kmfCe", function(module, exports) {

module.exports = (parcelRequire("ldFei")).EventEmitter;

});

parcelRegister("kDn30", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $f05953e41bacc323$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $f05953e41bacc323$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($f05953e41bacc323$var$Buffer.from && $f05953e41bacc323$var$Buffer.alloc && $f05953e41bacc323$var$Buffer.allocUnsafe && $f05953e41bacc323$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $f05953e41bacc323$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $f05953e41bacc323$var$SafeBuffer;
}
function $f05953e41bacc323$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $f05953e41bacc323$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$f05953e41bacc323$var$copyProps($f05953e41bacc323$var$Buffer, $f05953e41bacc323$var$SafeBuffer);
$f05953e41bacc323$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $f05953e41bacc323$var$Buffer(arg, encodingOrOffset, length);
};
$f05953e41bacc323$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $f05953e41bacc323$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$f05953e41bacc323$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $f05953e41bacc323$var$Buffer(size);
};
$f05953e41bacc323$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});

parcelRegister("czp0E", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $926c274afefa0d9a$export$43bee75e5e14138e; }, function (v) { return $926c274afefa0d9a$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $926c274afefa0d9a$export$f9ce7b637dfbe238; }, function (v) { return $926c274afefa0d9a$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $926c274afefa0d9a$export$630801d484da15df; }, function (v) { return $926c274afefa0d9a$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $926c274afefa0d9a$export$bedb7023a7733221; }, function (v) { return $926c274afefa0d9a$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $926c274afefa0d9a$export$7e4aa119212bc614; }, function (v) { return $926c274afefa0d9a$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $926c274afefa0d9a$export$844ec244b1367d54; }, function (v) { return $926c274afefa0d9a$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $926c274afefa0d9a$export$a244864fd9645c7f; }, function (v) { return $926c274afefa0d9a$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $926c274afefa0d9a$export$fce6876652108ab; }, function (v) { return $926c274afefa0d9a$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $926c274afefa0d9a$export$49841c62b9eff15; }, function (v) { return $926c274afefa0d9a$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $926c274afefa0d9a$export$a6cdc56e425d0d0a; }, function (v) { return $926c274afefa0d9a$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $926c274afefa0d9a$export$871608497c498473; }, function (v) { return $926c274afefa0d9a$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $926c274afefa0d9a$export$e6127cc7fe7395c3; }, function (v) { return $926c274afefa0d9a$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $926c274afefa0d9a$export$f6e2535fb5126e54; }, function (v) { return $926c274afefa0d9a$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $926c274afefa0d9a$export$c3825b437cbdea5c; }, function (v) { return $926c274afefa0d9a$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $926c274afefa0d9a$export$a7884ebc965f8f54; }, function (v) { return $926c274afefa0d9a$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $926c274afefa0d9a$export$43bee75e5e14138e;
var $926c274afefa0d9a$export$f9ce7b637dfbe238;
var $926c274afefa0d9a$export$630801d484da15df;
var $926c274afefa0d9a$export$bedb7023a7733221;
var $926c274afefa0d9a$export$7e4aa119212bc614;
var $926c274afefa0d9a$export$844ec244b1367d54;
var $926c274afefa0d9a$export$a244864fd9645c7f;
var $926c274afefa0d9a$export$fce6876652108ab;
var $926c274afefa0d9a$export$49841c62b9eff15;
var $926c274afefa0d9a$export$a6cdc56e425d0d0a;
var $926c274afefa0d9a$export$871608497c498473;
var $926c274afefa0d9a$export$e6127cc7fe7395c3;
var $926c274afefa0d9a$export$f6e2535fb5126e54;
var $926c274afefa0d9a$export$c3825b437cbdea5c;
var $926c274afefa0d9a$export$a7884ebc965f8f54;

var $b0kMB = parcelRequire("b0kMB");
var $926c274afefa0d9a$require$Buffer = $b0kMB.Buffer;
function $926c274afefa0d9a$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $926c274afefa0d9a$var$objectToString(arg) === '[object Array]';
}
$926c274afefa0d9a$export$43bee75e5e14138e = $926c274afefa0d9a$var$isArray;
function $926c274afefa0d9a$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$926c274afefa0d9a$export$f9ce7b637dfbe238 = $926c274afefa0d9a$var$isBoolean;
function $926c274afefa0d9a$var$isNull(arg) {
    return arg === null;
}
$926c274afefa0d9a$export$630801d484da15df = $926c274afefa0d9a$var$isNull;
function $926c274afefa0d9a$var$isNullOrUndefined(arg) {
    return arg == null;
}
$926c274afefa0d9a$export$bedb7023a7733221 = $926c274afefa0d9a$var$isNullOrUndefined;
function $926c274afefa0d9a$var$isNumber(arg) {
    return typeof arg === 'number';
}
$926c274afefa0d9a$export$7e4aa119212bc614 = $926c274afefa0d9a$var$isNumber;
function $926c274afefa0d9a$var$isString(arg) {
    return typeof arg === 'string';
}
$926c274afefa0d9a$export$844ec244b1367d54 = $926c274afefa0d9a$var$isString;
function $926c274afefa0d9a$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$926c274afefa0d9a$export$a244864fd9645c7f = $926c274afefa0d9a$var$isSymbol;
function $926c274afefa0d9a$var$isUndefined(arg) {
    return arg === void 0;
}
$926c274afefa0d9a$export$fce6876652108ab = $926c274afefa0d9a$var$isUndefined;
function $926c274afefa0d9a$var$isRegExp(re) {
    return $926c274afefa0d9a$var$objectToString(re) === '[object RegExp]';
}
$926c274afefa0d9a$export$49841c62b9eff15 = $926c274afefa0d9a$var$isRegExp;
function $926c274afefa0d9a$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$926c274afefa0d9a$export$a6cdc56e425d0d0a = $926c274afefa0d9a$var$isObject;
function $926c274afefa0d9a$var$isDate(d) {
    return $926c274afefa0d9a$var$objectToString(d) === '[object Date]';
}
$926c274afefa0d9a$export$871608497c498473 = $926c274afefa0d9a$var$isDate;
function $926c274afefa0d9a$var$isError(e) {
    return $926c274afefa0d9a$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$926c274afefa0d9a$export$e6127cc7fe7395c3 = $926c274afefa0d9a$var$isError;
function $926c274afefa0d9a$var$isFunction(arg) {
    return typeof arg === 'function';
}
$926c274afefa0d9a$export$f6e2535fb5126e54 = $926c274afefa0d9a$var$isFunction;
function $926c274afefa0d9a$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$926c274afefa0d9a$export$c3825b437cbdea5c = $926c274afefa0d9a$var$isPrimitive;
$926c274afefa0d9a$export$a7884ebc965f8f54 = $926c274afefa0d9a$require$Buffer.isBuffer;
function $926c274afefa0d9a$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("aiEjh", function(module, exports) {
'use strict';
function $77fada8a6375108c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $kDn30 = parcelRequire("kDn30");
var $77fada8a6375108c$require$Buffer = $kDn30.Buffer;

var $80bNa = parcelRequire("80bNa");
function $77fada8a6375108c$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $77fada8a6375108c$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $77fada8a6375108c$require$Buffer.alloc(0);
        var ret = $77fada8a6375108c$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $77fada8a6375108c$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($80bNa && $80bNa.inspect && $80bNa.inspect.custom) module.exports.prototype[$80bNa.inspect.custom] = function() {
    var obj = $80bNa.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("l1cFB", function(module, exports) {
'use strict';

var $jQzVP = parcelRequire("jQzVP");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $f4d384fb6267b2a7$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $jQzVP.nextTick($f4d384fb6267b2a7$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $jQzVP.nextTick($f4d384fb6267b2a7$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $jQzVP.nextTick($f4d384fb6267b2a7$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $jQzVP.nextTick($f4d384fb6267b2a7$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $f4d384fb6267b2a7$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $f4d384fb6267b2a7$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $f4d384fb6267b2a7$var$destroy,
    undestroy: $f4d384fb6267b2a7$var$undestroy
};

});

parcelRegister("fWoDv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $jQzVP = parcelRequire("jQzVP");
/*</replacement>*/ /*<replacement>*/ var $b9af620224fae083$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b9af620224fae083$var$Duplex;

/*<replacement>*/ var $b9af620224fae083$var$util = Object.create((parcelRequire("czp0E")));

$b9af620224fae083$var$util.inherits = (parcelRequire("4rf1u"));

var $dMYtF = parcelRequire("dMYtF");

var $llDwA = parcelRequire("llDwA");
$b9af620224fae083$var$util.inherits($b9af620224fae083$var$Duplex, $dMYtF);
// avoid scope creep, the keys array can then be collected
var $b9af620224fae083$var$keys = $b9af620224fae083$var$objectKeys($llDwA.prototype);
for(var $b9af620224fae083$var$v = 0; $b9af620224fae083$var$v < $b9af620224fae083$var$keys.length; $b9af620224fae083$var$v++){
    var $b9af620224fae083$var$method = $b9af620224fae083$var$keys[$b9af620224fae083$var$v];
    if (!$b9af620224fae083$var$Duplex.prototype[$b9af620224fae083$var$method]) $b9af620224fae083$var$Duplex.prototype[$b9af620224fae083$var$method] = $llDwA.prototype[$b9af620224fae083$var$method];
}
function $b9af620224fae083$var$Duplex(options) {
    if (!(this instanceof $b9af620224fae083$var$Duplex)) return new $b9af620224fae083$var$Duplex(options);
    $dMYtF.call(this, options);
    $llDwA.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $b9af620224fae083$var$onend);
}
Object.defineProperty($b9af620224fae083$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $b9af620224fae083$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $jQzVP.nextTick($b9af620224fae083$var$onEndNT, this);
}
function $b9af620224fae083$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b9af620224fae083$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$b9af620224fae083$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $jQzVP.nextTick(cb, err);
};

});
parcelRegister("llDwA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $jQzVP = parcelRequire("jQzVP");
/*</replacement>*/ module.exports = $f8aa37ea8ecfb4ca$var$Writable;
/* <replacement> */ function $f8aa37ea8ecfb4ca$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $f8aa37ea8ecfb4ca$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $f8aa37ea8ecfb4ca$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $f8aa37ea8ecfb4ca$var$asyncWrite = (0, $jQzVP.nextTick);
/*</replacement>*/ /*<replacement>*/ var $f8aa37ea8ecfb4ca$var$Duplex;
/*</replacement>*/ $f8aa37ea8ecfb4ca$var$Writable.WritableState = $f8aa37ea8ecfb4ca$var$WritableState;

/*<replacement>*/ var $f8aa37ea8ecfb4ca$var$util = Object.create((parcelRequire("czp0E")));

$f8aa37ea8ecfb4ca$var$util.inherits = (parcelRequire("4rf1u"));

/*</replacement>*/ /*<replacement>*/ var $f8aa37ea8ecfb4ca$var$internalUtil = {
    deprecate: (parcelRequire("1RFk0"))
};

var $kmfCe = parcelRequire("kmfCe");

var $kDn30 = parcelRequire("kDn30");
var $f8aa37ea8ecfb4ca$require$Buffer = $kDn30.Buffer;
var $f8aa37ea8ecfb4ca$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f8aa37ea8ecfb4ca$var$_uint8ArrayToBuffer(chunk) {
    return $f8aa37ea8ecfb4ca$require$Buffer.from(chunk);
}
function $f8aa37ea8ecfb4ca$var$_isUint8Array(obj) {
    return $f8aa37ea8ecfb4ca$require$Buffer.isBuffer(obj) || obj instanceof $f8aa37ea8ecfb4ca$var$OurUint8Array;
}

var $l1cFB = parcelRequire("l1cFB");
$f8aa37ea8ecfb4ca$var$util.inherits($f8aa37ea8ecfb4ca$var$Writable, $kmfCe);
function $f8aa37ea8ecfb4ca$var$nop() {}

function $f8aa37ea8ecfb4ca$var$WritableState(options, stream) {
    $f8aa37ea8ecfb4ca$var$Duplex = $f8aa37ea8ecfb4ca$var$Duplex || (parcelRequire("fWoDv"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $f8aa37ea8ecfb4ca$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $f8aa37ea8ecfb4ca$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $f8aa37ea8ecfb4ca$var$CorkedRequest(this);
}
$f8aa37ea8ecfb4ca$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($f8aa37ea8ecfb4ca$var$WritableState.prototype, 'buffer', {
            get: $f8aa37ea8ecfb4ca$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $f8aa37ea8ecfb4ca$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $f8aa37ea8ecfb4ca$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($f8aa37ea8ecfb4ca$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($f8aa37ea8ecfb4ca$var$realHasInstance.call(this, object)) return true;
            if (this !== $f8aa37ea8ecfb4ca$var$Writable) return false;
            return object && object._writableState instanceof $f8aa37ea8ecfb4ca$var$WritableState;
        }
    });
} else $f8aa37ea8ecfb4ca$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $f8aa37ea8ecfb4ca$var$Writable(options) {
    $f8aa37ea8ecfb4ca$var$Duplex = $f8aa37ea8ecfb4ca$var$Duplex || (parcelRequire("fWoDv"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$f8aa37ea8ecfb4ca$var$realHasInstance.call($f8aa37ea8ecfb4ca$var$Writable, this) && !(this instanceof $f8aa37ea8ecfb4ca$var$Duplex)) return new $f8aa37ea8ecfb4ca$var$Writable(options);
    this._writableState = new $f8aa37ea8ecfb4ca$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $kmfCe.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$f8aa37ea8ecfb4ca$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $f8aa37ea8ecfb4ca$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $jQzVP.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $f8aa37ea8ecfb4ca$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $jQzVP.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$f8aa37ea8ecfb4ca$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $f8aa37ea8ecfb4ca$var$_isUint8Array(chunk);
    if (isBuf && !$f8aa37ea8ecfb4ca$require$Buffer.isBuffer(chunk)) chunk = $f8aa37ea8ecfb4ca$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $f8aa37ea8ecfb4ca$var$nop;
    if (state.ended) $f8aa37ea8ecfb4ca$var$writeAfterEnd(this, cb);
    else if (isBuf || $f8aa37ea8ecfb4ca$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $f8aa37ea8ecfb4ca$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$f8aa37ea8ecfb4ca$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$f8aa37ea8ecfb4ca$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f8aa37ea8ecfb4ca$var$clearBuffer(this, state);
    }
};
$f8aa37ea8ecfb4ca$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $f8aa37ea8ecfb4ca$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $f8aa37ea8ecfb4ca$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($f8aa37ea8ecfb4ca$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f8aa37ea8ecfb4ca$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $f8aa37ea8ecfb4ca$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $f8aa37ea8ecfb4ca$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $f8aa37ea8ecfb4ca$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f8aa37ea8ecfb4ca$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $jQzVP.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $jQzVP.nextTick($f8aa37ea8ecfb4ca$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $f8aa37ea8ecfb4ca$var$finishMaybe(stream, state);
    }
}
function $f8aa37ea8ecfb4ca$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $f8aa37ea8ecfb4ca$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $f8aa37ea8ecfb4ca$var$onwriteStateUpdate(state);
    if (er) $f8aa37ea8ecfb4ca$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $f8aa37ea8ecfb4ca$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f8aa37ea8ecfb4ca$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $f8aa37ea8ecfb4ca$var$asyncWrite($f8aa37ea8ecfb4ca$var$afterWrite, stream, state, finished, cb);
        else $f8aa37ea8ecfb4ca$var$afterWrite(stream, state, finished, cb);
    }
}
function $f8aa37ea8ecfb4ca$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $f8aa37ea8ecfb4ca$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $f8aa37ea8ecfb4ca$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $f8aa37ea8ecfb4ca$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $f8aa37ea8ecfb4ca$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $f8aa37ea8ecfb4ca$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $f8aa37ea8ecfb4ca$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $f8aa37ea8ecfb4ca$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$f8aa37ea8ecfb4ca$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$f8aa37ea8ecfb4ca$var$Writable.prototype._writev = null;
$f8aa37ea8ecfb4ca$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $f8aa37ea8ecfb4ca$var$endWritable(this, state, cb);
};
function $f8aa37ea8ecfb4ca$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $f8aa37ea8ecfb4ca$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $f8aa37ea8ecfb4ca$var$finishMaybe(stream, state);
    });
}
function $f8aa37ea8ecfb4ca$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $jQzVP.nextTick($f8aa37ea8ecfb4ca$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f8aa37ea8ecfb4ca$var$finishMaybe(stream, state) {
    var need = $f8aa37ea8ecfb4ca$var$needFinish(state);
    if (need) {
        $f8aa37ea8ecfb4ca$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $f8aa37ea8ecfb4ca$var$endWritable(stream, state, cb) {
    state.ending = true;
    $f8aa37ea8ecfb4ca$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $jQzVP.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $f8aa37ea8ecfb4ca$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($f8aa37ea8ecfb4ca$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$f8aa37ea8ecfb4ca$var$Writable.prototype.destroy = $l1cFB.destroy;
$f8aa37ea8ecfb4ca$var$Writable.prototype._undestroy = $l1cFB.undestroy;
$f8aa37ea8ecfb4ca$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("lG7Xu", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $fc83b19e5e808c8f$export$63a7aa211a91ed69; }, function (v) { return $fc83b19e5e808c8f$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $fc83b19e5e808c8f$export$63a7aa211a91ed69;
'use strict';

var $ijfrJ = parcelRequire("ijfrJ");
var $fc83b19e5e808c8f$require$Buffer = $ijfrJ.Buffer;
/*</replacement>*/ var $fc83b19e5e808c8f$var$isEncoding = $fc83b19e5e808c8f$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $fc83b19e5e808c8f$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $fc83b19e5e808c8f$var$normalizeEncoding(enc) {
    var nenc = $fc83b19e5e808c8f$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($fc83b19e5e808c8f$require$Buffer.isEncoding === $fc83b19e5e808c8f$var$isEncoding || !$fc83b19e5e808c8f$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$fc83b19e5e808c8f$export$63a7aa211a91ed69 = $fc83b19e5e808c8f$var$StringDecoder;
function $fc83b19e5e808c8f$var$StringDecoder(encoding) {
    this.encoding = $fc83b19e5e808c8f$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $fc83b19e5e808c8f$var$utf16Text;
            this.end = $fc83b19e5e808c8f$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $fc83b19e5e808c8f$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $fc83b19e5e808c8f$var$base64Text;
            this.end = $fc83b19e5e808c8f$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $fc83b19e5e808c8f$var$simpleWrite;
            this.end = $fc83b19e5e808c8f$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $fc83b19e5e808c8f$require$Buffer.allocUnsafe(nb);
}
$fc83b19e5e808c8f$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$fc83b19e5e808c8f$var$StringDecoder.prototype.end = $fc83b19e5e808c8f$var$utf8End;
// Returns only complete characters in a Buffer
$fc83b19e5e808c8f$var$StringDecoder.prototype.text = $fc83b19e5e808c8f$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$fc83b19e5e808c8f$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $fc83b19e5e808c8f$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $fc83b19e5e808c8f$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $fc83b19e5e808c8f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc83b19e5e808c8f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc83b19e5e808c8f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $fc83b19e5e808c8f$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $fc83b19e5e808c8f$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $fc83b19e5e808c8f$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $fc83b19e5e808c8f$var$utf8Text(buf, i) {
    var total = $fc83b19e5e808c8f$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $fc83b19e5e808c8f$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $fc83b19e5e808c8f$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $fc83b19e5e808c8f$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $fc83b19e5e808c8f$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $fc83b19e5e808c8f$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $fc83b19e5e808c8f$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $fc83b19e5e808c8f$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("ijfrJ", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $d545fba7d01f40bc$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $d545fba7d01f40bc$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d545fba7d01f40bc$var$Buffer.from && $d545fba7d01f40bc$var$Buffer.alloc && $d545fba7d01f40bc$var$Buffer.allocUnsafe && $d545fba7d01f40bc$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $d545fba7d01f40bc$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $d545fba7d01f40bc$var$SafeBuffer;
}
function $d545fba7d01f40bc$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d545fba7d01f40bc$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$d545fba7d01f40bc$var$copyProps($d545fba7d01f40bc$var$Buffer, $d545fba7d01f40bc$var$SafeBuffer);
$d545fba7d01f40bc$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $d545fba7d01f40bc$var$Buffer(arg, encodingOrOffset, length);
};
$d545fba7d01f40bc$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $d545fba7d01f40bc$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d545fba7d01f40bc$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $d545fba7d01f40bc$var$Buffer(size);
};
$d545fba7d01f40bc$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});



parcelRegister("4RtJz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $38a32d335f8fbc7d$var$Transform;

var $fWoDv = parcelRequire("fWoDv");

/*<replacement>*/ var $38a32d335f8fbc7d$var$util = Object.create((parcelRequire("czp0E")));

$38a32d335f8fbc7d$var$util.inherits = (parcelRequire("4rf1u"));
/*</replacement>*/ $38a32d335f8fbc7d$var$util.inherits($38a32d335f8fbc7d$var$Transform, $fWoDv);
function $38a32d335f8fbc7d$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $38a32d335f8fbc7d$var$Transform(options) {
    if (!(this instanceof $38a32d335f8fbc7d$var$Transform)) return new $38a32d335f8fbc7d$var$Transform(options);
    $fWoDv.call(this, options);
    this._transformState = {
        afterTransform: $38a32d335f8fbc7d$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $38a32d335f8fbc7d$var$prefinish);
}
function $38a32d335f8fbc7d$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $38a32d335f8fbc7d$var$done(_this, er, data);
    });
    else $38a32d335f8fbc7d$var$done(this, null, null);
}
$38a32d335f8fbc7d$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fWoDv.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$38a32d335f8fbc7d$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$38a32d335f8fbc7d$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$38a32d335f8fbc7d$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$38a32d335f8fbc7d$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $fWoDv.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $38a32d335f8fbc7d$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("dJmfJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $9ff0bd473328b657$var$PassThrough;

var $4RtJz = parcelRequire("4RtJz");

/*<replacement>*/ var $9ff0bd473328b657$var$util = Object.create((parcelRequire("czp0E")));

$9ff0bd473328b657$var$util.inherits = (parcelRequire("4rf1u"));
/*</replacement>*/ $9ff0bd473328b657$var$util.inherits($9ff0bd473328b657$var$PassThrough, $4RtJz);
function $9ff0bd473328b657$var$PassThrough(options) {
    if (!(this instanceof $9ff0bd473328b657$var$PassThrough)) return new $9ff0bd473328b657$var$PassThrough(options);
    $4RtJz.call(this, options);
}
$9ff0bd473328b657$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("vAyWz", function(module, exports) {
'use strict';

var $4UJGx = parcelRequire("4UJGx");
var $05ef41efe1e55543$require$Buffer = $4UJGx.Buffer;

var $ikkqh = parcelRequire("ikkqh");

var $h8SKC = parcelRequire("h8SKC");

var $1C5VP = parcelRequire("1C5VP");
var $05ef41efe1e55543$require$EC = $1C5VP.ec;

var $5k44J = parcelRequire("5k44J");

var $j23JA = parcelRequire("j23JA");

var $3N9uo = parcelRequire("3N9uo");
var $05ef41efe1e55543$var$RSA_PKCS1_PADDING = 1;
function $05ef41efe1e55543$var$sign(hash, key, hashType, signType, tag) {
    var priv = $j23JA(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $05ef41efe1e55543$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $05ef41efe1e55543$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $05ef41efe1e55543$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $05ef41efe1e55543$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $h8SKC(pad, priv);
    return out;
}
function $05ef41efe1e55543$var$ecSign(hash, priv) {
    var curveId = $3N9uo[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $05ef41efe1e55543$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $05ef41efe1e55543$require$Buffer.from(out.toDER());
}
function $05ef41efe1e55543$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $5k44J(0);
    var k;
    var H = $05ef41efe1e55543$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $05ef41efe1e55543$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $05ef41efe1e55543$var$makeKey(q, kv, algo);
        r = $05ef41efe1e55543$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $5k44J(0);
        }
    }
    return $05ef41efe1e55543$var$toDER(r, s);
}
function $05ef41efe1e55543$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $05ef41efe1e55543$require$Buffer.from(res);
}
function $05ef41efe1e55543$var$getKey(x, q, hash, algo) {
    x = $05ef41efe1e55543$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $05ef41efe1e55543$require$Buffer.alloc(q.byteLength() - x.length);
        x = $05ef41efe1e55543$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $05ef41efe1e55543$var$bits2octets(hash, q);
    var v = $05ef41efe1e55543$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $05ef41efe1e55543$require$Buffer.alloc(hlen);
    k = $ikkqh(algo, k).update(v).update($05ef41efe1e55543$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $ikkqh(algo, k).update(v).digest();
    k = $ikkqh(algo, k).update(v).update($05ef41efe1e55543$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $ikkqh(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $05ef41efe1e55543$var$bits2int(obits, q) {
    var bits = new $5k44J(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $05ef41efe1e55543$var$bits2octets(bits, q) {
    bits = $05ef41efe1e55543$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $05ef41efe1e55543$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $05ef41efe1e55543$require$Buffer.alloc(q.byteLength() - out.length);
        out = $05ef41efe1e55543$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $05ef41efe1e55543$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $05ef41efe1e55543$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $ikkqh(algo, kv.k).update(kv.v).digest();
            t = $05ef41efe1e55543$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $05ef41efe1e55543$var$bits2int(t, q);
        kv.k = $ikkqh(algo, kv.k).update(kv.v).update($05ef41efe1e55543$require$Buffer.from([
            0
        ])).digest();
        kv.v = $ikkqh(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $05ef41efe1e55543$var$makeR(g, k, p, q) {
    return g.toRed($5k44J.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $05ef41efe1e55543$var$sign;
module.exports.getKey = $05ef41efe1e55543$var$getKey;
module.exports.makeKey = $05ef41efe1e55543$var$makeKey;

});
parcelRegister("h8SKC", function(module, exports) {
'use strict';

var $5k44J = parcelRequire("5k44J");

var $a0Pw9 = parcelRequire("a0Pw9");

var $9Dmj1 = parcelRequire("9Dmj1");
var $c7ada76c952f8084$require$Buffer = $9Dmj1.Buffer;
function $c7ada76c952f8084$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $5k44J($a0Pw9(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $c7ada76c952f8084$var$blind(priv) {
    var r = $c7ada76c952f8084$var$getr(priv);
    var blinder = r.toRed($5k44J.mont(priv.modulus)).redPow(new $5k44J(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $c7ada76c952f8084$var$crt(msg, priv) {
    var blinds = $c7ada76c952f8084$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $5k44J(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($5k44J.mont(priv.prime1));
    var c2 = blinded.toRed($5k44J.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($c7ada76c952f8084$require$Buffer, 'be', len);
}
$c7ada76c952f8084$var$crt.getr = $c7ada76c952f8084$var$getr;
module.exports = $c7ada76c952f8084$var$crt;

});
parcelRegister("5k44J", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("80bNa")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9Dmj1", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $70390f04bd469d50$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $70390f04bd469d50$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($70390f04bd469d50$var$Buffer.from && $70390f04bd469d50$var$Buffer.alloc && $70390f04bd469d50$var$Buffer.allocUnsafe && $70390f04bd469d50$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $70390f04bd469d50$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $70390f04bd469d50$var$SafeBuffer;
}
function $70390f04bd469d50$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $70390f04bd469d50$var$Buffer(arg, encodingOrOffset, length);
}
$70390f04bd469d50$var$SafeBuffer.prototype = Object.create($70390f04bd469d50$var$Buffer.prototype);
// Copy static methods from Buffer
$70390f04bd469d50$var$copyProps($70390f04bd469d50$var$Buffer, $70390f04bd469d50$var$SafeBuffer);
$70390f04bd469d50$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $70390f04bd469d50$var$Buffer(arg, encodingOrOffset, length);
};
$70390f04bd469d50$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $70390f04bd469d50$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$70390f04bd469d50$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $70390f04bd469d50$var$Buffer(size);
};
$70390f04bd469d50$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});


parcelRegister("1C5VP", function(module, exports) {
'use strict';
var $12cdf0f458e9cbd0$var$elliptic = module.exports;

$12cdf0f458e9cbd0$var$elliptic.version = (parcelRequire("bTGL6")).version;

$12cdf0f458e9cbd0$var$elliptic.utils = (parcelRequire("5J8E2"));

$12cdf0f458e9cbd0$var$elliptic.rand = (parcelRequire("cA0my"));

$12cdf0f458e9cbd0$var$elliptic.curve = (parcelRequire("4l0TI"));

$12cdf0f458e9cbd0$var$elliptic.curves = (parcelRequire("cDhE4"));

// Protocols
$12cdf0f458e9cbd0$var$elliptic.ec = (parcelRequire("7k77E"));

$12cdf0f458e9cbd0$var$elliptic.eddsa = (parcelRequire("dafO5"));

});
parcelRegister("bTGL6", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("5J8E2", function(module, exports) {
'use strict';
var $42b7dc6a1b1fd6ff$var$utils = module.exports;

var $2ofiR = parcelRequire("2ofiR");

var $qzkJD = parcelRequire("qzkJD");

var $gAV2x = parcelRequire("gAV2x");
$42b7dc6a1b1fd6ff$var$utils.assert = $qzkJD;
$42b7dc6a1b1fd6ff$var$utils.toArray = $gAV2x.toArray;
$42b7dc6a1b1fd6ff$var$utils.zero2 = $gAV2x.zero2;
$42b7dc6a1b1fd6ff$var$utils.toHex = $gAV2x.toHex;
$42b7dc6a1b1fd6ff$var$utils.encode = $gAV2x.encode;
// Represent num in a w-NAF form
function $42b7dc6a1b1fd6ff$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$42b7dc6a1b1fd6ff$var$utils.getNAF = $42b7dc6a1b1fd6ff$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $42b7dc6a1b1fd6ff$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$42b7dc6a1b1fd6ff$var$utils.getJSF = $42b7dc6a1b1fd6ff$var$getJSF;
function $42b7dc6a1b1fd6ff$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$42b7dc6a1b1fd6ff$var$utils.cachedProperty = $42b7dc6a1b1fd6ff$var$cachedProperty;
function $42b7dc6a1b1fd6ff$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $42b7dc6a1b1fd6ff$var$utils.toArray(bytes, 'hex') : bytes;
}
$42b7dc6a1b1fd6ff$var$utils.parseBytes = $42b7dc6a1b1fd6ff$var$parseBytes;
function $42b7dc6a1b1fd6ff$var$intFromLE(bytes) {
    return new $2ofiR(bytes, 'hex', 'le');
}
$42b7dc6a1b1fd6ff$var$utils.intFromLE = $42b7dc6a1b1fd6ff$var$intFromLE;

});
parcelRegister("2ofiR", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("80bNa")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gAV2x", function(module, exports) {
'use strict';
var $c14c41113d011ec1$var$utils = module.exports;
function $c14c41113d011ec1$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$c14c41113d011ec1$var$utils.toArray = $c14c41113d011ec1$var$toArray;
function $c14c41113d011ec1$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$c14c41113d011ec1$var$utils.zero2 = $c14c41113d011ec1$var$zero2;
function $c14c41113d011ec1$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $c14c41113d011ec1$var$zero2(msg[i].toString(16));
    return res;
}
$c14c41113d011ec1$var$utils.toHex = $c14c41113d011ec1$var$toHex;
$c14c41113d011ec1$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $c14c41113d011ec1$var$toHex(arr);
    else return arr;
};

});


parcelRegister("4l0TI", function(module, exports) {
'use strict';
var $3289d1dcaa8d5cba$var$curve = module.exports;

$3289d1dcaa8d5cba$var$curve.base = (parcelRequire("64t71"));

$3289d1dcaa8d5cba$var$curve.short = (parcelRequire("78iEK"));

$3289d1dcaa8d5cba$var$curve.mont = (parcelRequire("r72aQ"));

$3289d1dcaa8d5cba$var$curve.edwards = (parcelRequire("lRh91"));

});
parcelRegister("64t71", function(module, exports) {
'use strict';

var $2ofiR = parcelRequire("2ofiR");

var $5J8E2 = parcelRequire("5J8E2");
var $46b9b2e85109e0be$var$getNAF = $5J8E2.getNAF;
var $46b9b2e85109e0be$var$getJSF = $5J8E2.getJSF;
var $46b9b2e85109e0be$var$assert = $5J8E2.assert;
function $46b9b2e85109e0be$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $2ofiR(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $2ofiR.red(conf.prime) : $2ofiR.mont(this.p);
    // Useful for many curves
    this.zero = new $2ofiR(0).toRed(this.red);
    this.one = new $2ofiR(1).toRed(this.red);
    this.two = new $2ofiR(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $2ofiR(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $46b9b2e85109e0be$var$BaseCurve;
$46b9b2e85109e0be$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$46b9b2e85109e0be$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$46b9b2e85109e0be$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $46b9b2e85109e0be$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $46b9b2e85109e0be$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$46b9b2e85109e0be$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $46b9b2e85109e0be$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $46b9b2e85109e0be$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$46b9b2e85109e0be$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $46b9b2e85109e0be$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $46b9b2e85109e0be$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $46b9b2e85109e0be$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $46b9b2e85109e0be$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$46b9b2e85109e0be$var$BaseCurve.BasePoint = $46b9b2e85109e0be$var$BasePoint;
$46b9b2e85109e0be$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$46b9b2e85109e0be$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$46b9b2e85109e0be$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $5J8E2.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $46b9b2e85109e0be$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $46b9b2e85109e0be$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$46b9b2e85109e0be$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$46b9b2e85109e0be$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$46b9b2e85109e0be$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $5J8E2.encode(this._encode(compact), enc);
};
$46b9b2e85109e0be$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$46b9b2e85109e0be$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$46b9b2e85109e0be$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$46b9b2e85109e0be$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$46b9b2e85109e0be$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$46b9b2e85109e0be$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("78iEK", function(module, exports) {
'use strict';

var $5J8E2 = parcelRequire("5J8E2");

var $2ofiR = parcelRequire("2ofiR");

var $4rf1u = parcelRequire("4rf1u");

var $64t71 = parcelRequire("64t71");
var $5317c08315de7745$var$assert = $5J8E2.assert;
function $5317c08315de7745$var$ShortCurve(conf) {
    $64t71.call(this, 'short', conf);
    this.a = new $2ofiR(conf.a, 16).toRed(this.red);
    this.b = new $2ofiR(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$4rf1u($5317c08315de7745$var$ShortCurve, $64t71);
module.exports = $5317c08315de7745$var$ShortCurve;
$5317c08315de7745$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $2ofiR(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $2ofiR(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $5317c08315de7745$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $2ofiR(vec.a, 16),
            b: new $2ofiR(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$5317c08315de7745$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $2ofiR.mont(num);
    var tinv = new $2ofiR(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $2ofiR(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$5317c08315de7745$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $2ofiR(1);
    var y1 = new $2ofiR(0);
    var x2 = new $2ofiR(0);
    var y2 = new $2ofiR(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$5317c08315de7745$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$5317c08315de7745$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $2ofiR(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$5317c08315de7745$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$5317c08315de7745$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $5317c08315de7745$var$Point(curve, x, y, isRed) {
    $64t71.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $2ofiR(x, 16);
        this.y = new $2ofiR(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$4rf1u($5317c08315de7745$var$Point, $64t71.BasePoint);
$5317c08315de7745$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $5317c08315de7745$var$Point(this, x, y, isRed);
};
$5317c08315de7745$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $5317c08315de7745$var$Point.fromJSON(this, obj, red);
};
$5317c08315de7745$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$5317c08315de7745$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$5317c08315de7745$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$5317c08315de7745$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$5317c08315de7745$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$5317c08315de7745$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$5317c08315de7745$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$5317c08315de7745$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$5317c08315de7745$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$5317c08315de7745$var$Point.prototype.mul = function mul(k) {
    k = new $2ofiR(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$5317c08315de7745$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$5317c08315de7745$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$5317c08315de7745$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$5317c08315de7745$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$5317c08315de7745$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $5317c08315de7745$var$JPoint(curve, x, y, z) {
    $64t71.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $2ofiR(0);
    } else {
        this.x = new $2ofiR(x, 16);
        this.y = new $2ofiR(y, 16);
        this.z = new $2ofiR(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$4rf1u($5317c08315de7745$var$JPoint, $64t71.BasePoint);
$5317c08315de7745$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $5317c08315de7745$var$JPoint(this, x, y, z);
};
$5317c08315de7745$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$5317c08315de7745$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$5317c08315de7745$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$5317c08315de7745$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$5317c08315de7745$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$5317c08315de7745$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$5317c08315de7745$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$5317c08315de7745$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$5317c08315de7745$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$5317c08315de7745$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$5317c08315de7745$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $2ofiR(k, kbase);
    return this.curve._wnafMul(this, k);
};
$5317c08315de7745$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$5317c08315de7745$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$5317c08315de7745$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$5317c08315de7745$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("r72aQ", function(module, exports) {
'use strict';

var $2ofiR = parcelRequire("2ofiR");

var $4rf1u = parcelRequire("4rf1u");

var $64t71 = parcelRequire("64t71");

var $5J8E2 = parcelRequire("5J8E2");
function $0517fa8c96140506$var$MontCurve(conf) {
    $64t71.call(this, 'mont', conf);
    this.a = new $2ofiR(conf.a, 16).toRed(this.red);
    this.b = new $2ofiR(conf.b, 16).toRed(this.red);
    this.i4 = new $2ofiR(4).toRed(this.red).redInvm();
    this.two = new $2ofiR(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$4rf1u($0517fa8c96140506$var$MontCurve, $64t71);
module.exports = $0517fa8c96140506$var$MontCurve;
$0517fa8c96140506$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $0517fa8c96140506$var$Point(curve, x, z) {
    $64t71.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $2ofiR(x, 16);
        this.z = new $2ofiR(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$4rf1u($0517fa8c96140506$var$Point, $64t71.BasePoint);
$0517fa8c96140506$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($5J8E2.toArray(bytes, enc), 1);
};
$0517fa8c96140506$var$MontCurve.prototype.point = function point(x, z) {
    return new $0517fa8c96140506$var$Point(this, x, z);
};
$0517fa8c96140506$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $0517fa8c96140506$var$Point.fromJSON(this, obj);
};
$0517fa8c96140506$var$Point.prototype.precompute = function precompute() {
// No-op
};
$0517fa8c96140506$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$0517fa8c96140506$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $0517fa8c96140506$var$Point(curve, obj[0], obj[1] || curve.one);
};
$0517fa8c96140506$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$0517fa8c96140506$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$0517fa8c96140506$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$0517fa8c96140506$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$0517fa8c96140506$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$0517fa8c96140506$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$0517fa8c96140506$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$0517fa8c96140506$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$0517fa8c96140506$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$0517fa8c96140506$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$0517fa8c96140506$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("lRh91", function(module, exports) {
'use strict';

var $5J8E2 = parcelRequire("5J8E2");

var $2ofiR = parcelRequire("2ofiR");

var $4rf1u = parcelRequire("4rf1u");

var $64t71 = parcelRequire("64t71");
var $fe9bd8bfbb4136ad$var$assert = $5J8E2.assert;
function $fe9bd8bfbb4136ad$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $64t71.call(this, 'edwards', conf);
    this.a = new $2ofiR(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $2ofiR(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $2ofiR(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $fe9bd8bfbb4136ad$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$4rf1u($fe9bd8bfbb4136ad$var$EdwardsCurve, $64t71);
module.exports = $fe9bd8bfbb4136ad$var$EdwardsCurve;
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $2ofiR(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $2ofiR(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $fe9bd8bfbb4136ad$var$Point(curve, x, y, z, t) {
    $64t71.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $2ofiR(x, 16);
        this.y = new $2ofiR(y, 16);
        this.z = z ? new $2ofiR(z, 16) : this.curve.one;
        this.t = t && new $2ofiR(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$4rf1u($fe9bd8bfbb4136ad$var$Point, $64t71.BasePoint);
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $fe9bd8bfbb4136ad$var$Point.fromJSON(this, obj);
};
$fe9bd8bfbb4136ad$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $fe9bd8bfbb4136ad$var$Point(this, x, y, z, t);
};
$fe9bd8bfbb4136ad$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $fe9bd8bfbb4136ad$var$Point(curve, obj[0], obj[1], obj[2]);
};
$fe9bd8bfbb4136ad$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$fe9bd8bfbb4136ad$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$fe9bd8bfbb4136ad$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$fe9bd8bfbb4136ad$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$fe9bd8bfbb4136ad$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$fe9bd8bfbb4136ad$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$fe9bd8bfbb4136ad$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$fe9bd8bfbb4136ad$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$fe9bd8bfbb4136ad$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$fe9bd8bfbb4136ad$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$fe9bd8bfbb4136ad$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$fe9bd8bfbb4136ad$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$fe9bd8bfbb4136ad$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$fe9bd8bfbb4136ad$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$fe9bd8bfbb4136ad$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$fe9bd8bfbb4136ad$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$fe9bd8bfbb4136ad$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$fe9bd8bfbb4136ad$var$Point.prototype.toP = $fe9bd8bfbb4136ad$var$Point.prototype.normalize;
$fe9bd8bfbb4136ad$var$Point.prototype.mixedAdd = $fe9bd8bfbb4136ad$var$Point.prototype.add;

});


parcelRegister("cDhE4", function(module, exports) {
'use strict';
var $9326d087eb2b0371$var$curves = module.exports;

var $9zDa1 = parcelRequire("9zDa1");

var $4l0TI = parcelRequire("4l0TI");

var $5J8E2 = parcelRequire("5J8E2");
var $9326d087eb2b0371$var$assert = $5J8E2.assert;
function $9326d087eb2b0371$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $4l0TI.short(options);
    else if (options.type === 'edwards') this.curve = new $4l0TI.edwards(options);
    else this.curve = new $4l0TI.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $9326d087eb2b0371$var$assert(this.g.validate(), 'Invalid curve');
    $9326d087eb2b0371$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$9326d087eb2b0371$var$curves.PresetCurve = $9326d087eb2b0371$var$PresetCurve;
function $9326d087eb2b0371$var$defineCurve(name, options) {
    Object.defineProperty($9326d087eb2b0371$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $9326d087eb2b0371$var$PresetCurve(options);
            Object.defineProperty($9326d087eb2b0371$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$9326d087eb2b0371$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $9zDa1.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$9326d087eb2b0371$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $9zDa1.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$9326d087eb2b0371$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $9zDa1.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$9326d087eb2b0371$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $9zDa1.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$9326d087eb2b0371$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $9zDa1.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$9326d087eb2b0371$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $9zDa1.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$9326d087eb2b0371$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $9zDa1.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $9326d087eb2b0371$var$pre;

try {
    $9326d087eb2b0371$var$pre = (parcelRequire("kIk7x"));
} catch (e) {
    $9326d087eb2b0371$var$pre = undefined;
}
$9326d087eb2b0371$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $9zDa1.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $9326d087eb2b0371$var$pre
    ]
});

});
parcelRegister("9zDa1", function(module, exports) {
var $6f85c26f4c9b2e0a$var$hash = module.exports;

$6f85c26f4c9b2e0a$var$hash.utils = (parcelRequire("5AUhj"));

$6f85c26f4c9b2e0a$var$hash.common = (parcelRequire("46Eyw"));

$6f85c26f4c9b2e0a$var$hash.sha = (parcelRequire("gBlKI"));

$6f85c26f4c9b2e0a$var$hash.ripemd = (parcelRequire("edWCP"));

$6f85c26f4c9b2e0a$var$hash.hmac = (parcelRequire("2RlVW"));
// Proxy hash functions to the main object
$6f85c26f4c9b2e0a$var$hash.sha1 = $6f85c26f4c9b2e0a$var$hash.sha.sha1;
$6f85c26f4c9b2e0a$var$hash.sha256 = $6f85c26f4c9b2e0a$var$hash.sha.sha256;
$6f85c26f4c9b2e0a$var$hash.sha224 = $6f85c26f4c9b2e0a$var$hash.sha.sha224;
$6f85c26f4c9b2e0a$var$hash.sha384 = $6f85c26f4c9b2e0a$var$hash.sha.sha384;
$6f85c26f4c9b2e0a$var$hash.sha512 = $6f85c26f4c9b2e0a$var$hash.sha.sha512;
$6f85c26f4c9b2e0a$var$hash.ripemd160 = $6f85c26f4c9b2e0a$var$hash.ripemd.ripemd160;

});
parcelRegister("5AUhj", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $412bf83c988c91d7$export$69f1b2dcda23c5f8; }, function (v) { return $412bf83c988c91d7$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $412bf83c988c91d7$export$45b10814cc054894; }, function (v) { return $412bf83c988c91d7$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $412bf83c988c91d7$export$7ea66e3774a60b67; }, function (v) { return $412bf83c988c91d7$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $412bf83c988c91d7$export$34a52f00f601f6f1; }, function (v) { return $412bf83c988c91d7$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $412bf83c988c91d7$export$812b0cbd5e8a72ab; }, function (v) { return $412bf83c988c91d7$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $412bf83c988c91d7$export$f24f9e11d63bb314; }, function (v) { return $412bf83c988c91d7$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $412bf83c988c91d7$export$b71357c7e07ca1f1; }, function (v) { return $412bf83c988c91d7$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $412bf83c988c91d7$export$2e58a4b541fdcbe8; }, function (v) { return $412bf83c988c91d7$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $412bf83c988c91d7$export$183b950bde9faab8; }, function (v) { return $412bf83c988c91d7$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $412bf83c988c91d7$export$4785c77169fea59e; }, function (v) { return $412bf83c988c91d7$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $412bf83c988c91d7$export$242a185dfcffac5b; }, function (v) { return $412bf83c988c91d7$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $412bf83c988c91d7$export$58c04ae0ae31877d; }, function (v) { return $412bf83c988c91d7$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $412bf83c988c91d7$export$d058ca695f8c6f11; }, function (v) { return $412bf83c988c91d7$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $412bf83c988c91d7$export$a1efd7fc3e986367; }, function (v) { return $412bf83c988c91d7$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $412bf83c988c91d7$export$bbfea4a2b5abaab4; }, function (v) { return $412bf83c988c91d7$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $412bf83c988c91d7$export$97ad4afc7de86152; }, function (v) { return $412bf83c988c91d7$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $412bf83c988c91d7$export$ce4673d9a79f6a4b; }, function (v) { return $412bf83c988c91d7$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $412bf83c988c91d7$export$786cc99fc6eedc0b; }, function (v) { return $412bf83c988c91d7$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $412bf83c988c91d7$export$45c59b9a1848dd0; }, function (v) { return $412bf83c988c91d7$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $412bf83c988c91d7$export$50d8f613e76d3034; }, function (v) { return $412bf83c988c91d7$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $412bf83c988c91d7$export$b8e83683c60ee162; }, function (v) { return $412bf83c988c91d7$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $412bf83c988c91d7$export$aeeb51790d1bcc4a; }, function (v) { return $412bf83c988c91d7$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $412bf83c988c91d7$export$bb7c616f719ad9c; }, function (v) { return $412bf83c988c91d7$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $412bf83c988c91d7$export$4d63290824f9d7df; }, function (v) { return $412bf83c988c91d7$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $412bf83c988c91d7$export$2f64ceb90ef28ea1; }, function (v) { return $412bf83c988c91d7$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $412bf83c988c91d7$export$8d2089d465f6d10d; }, function (v) { return $412bf83c988c91d7$export$8d2089d465f6d10d = v; });
var $412bf83c988c91d7$export$69f1b2dcda23c5f8;
var $412bf83c988c91d7$export$45b10814cc054894;
var $412bf83c988c91d7$export$7ea66e3774a60b67;
var $412bf83c988c91d7$export$34a52f00f601f6f1;
var $412bf83c988c91d7$export$812b0cbd5e8a72ab;
var $412bf83c988c91d7$export$f24f9e11d63bb314;
var $412bf83c988c91d7$export$b71357c7e07ca1f1;
var $412bf83c988c91d7$export$2e58a4b541fdcbe8;
var $412bf83c988c91d7$export$183b950bde9faab8;
var $412bf83c988c91d7$export$4785c77169fea59e;
var $412bf83c988c91d7$export$242a185dfcffac5b;
var $412bf83c988c91d7$export$58c04ae0ae31877d;
var $412bf83c988c91d7$export$d058ca695f8c6f11;
var $412bf83c988c91d7$export$a1efd7fc3e986367;
var $412bf83c988c91d7$export$bbfea4a2b5abaab4;
var $412bf83c988c91d7$export$97ad4afc7de86152;
var $412bf83c988c91d7$export$ce4673d9a79f6a4b;
var $412bf83c988c91d7$export$786cc99fc6eedc0b;
var $412bf83c988c91d7$export$45c59b9a1848dd0;
var $412bf83c988c91d7$export$50d8f613e76d3034;
var $412bf83c988c91d7$export$b8e83683c60ee162;
var $412bf83c988c91d7$export$aeeb51790d1bcc4a;
var $412bf83c988c91d7$export$bb7c616f719ad9c;
var $412bf83c988c91d7$export$4d63290824f9d7df;
var $412bf83c988c91d7$export$2f64ceb90ef28ea1;
var $412bf83c988c91d7$export$8d2089d465f6d10d;
'use strict';

var $qzkJD = parcelRequire("qzkJD");

var $4rf1u = parcelRequire("4rf1u");
$412bf83c988c91d7$export$69f1b2dcda23c5f8 = $4rf1u;
function $412bf83c988c91d7$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $412bf83c988c91d7$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($412bf83c988c91d7$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$412bf83c988c91d7$export$45b10814cc054894 = $412bf83c988c91d7$var$toArray;
function $412bf83c988c91d7$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $412bf83c988c91d7$var$zero2(msg[i].toString(16));
    return res;
}
$412bf83c988c91d7$export$7ea66e3774a60b67 = $412bf83c988c91d7$var$toHex;
function $412bf83c988c91d7$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$412bf83c988c91d7$export$34a52f00f601f6f1 = $412bf83c988c91d7$var$htonl;
function $412bf83c988c91d7$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $412bf83c988c91d7$var$htonl(w);
        res += $412bf83c988c91d7$var$zero8(w.toString(16));
    }
    return res;
}
$412bf83c988c91d7$export$812b0cbd5e8a72ab = $412bf83c988c91d7$var$toHex32;
function $412bf83c988c91d7$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$412bf83c988c91d7$export$f24f9e11d63bb314 = $412bf83c988c91d7$var$zero2;
function $412bf83c988c91d7$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$412bf83c988c91d7$export$b71357c7e07ca1f1 = $412bf83c988c91d7$var$zero8;
function $412bf83c988c91d7$var$join32(msg, start, end, endian) {
    var len = end - start;
    $qzkJD(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$412bf83c988c91d7$export$2e58a4b541fdcbe8 = $412bf83c988c91d7$var$join32;
function $412bf83c988c91d7$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$412bf83c988c91d7$export$183b950bde9faab8 = $412bf83c988c91d7$var$split32;
function $412bf83c988c91d7$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$412bf83c988c91d7$export$4785c77169fea59e = $412bf83c988c91d7$var$rotr32;
function $412bf83c988c91d7$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$412bf83c988c91d7$export$242a185dfcffac5b = $412bf83c988c91d7$var$rotl32;
function $412bf83c988c91d7$var$sum32(a, b) {
    return a + b >>> 0;
}
$412bf83c988c91d7$export$58c04ae0ae31877d = $412bf83c988c91d7$var$sum32;
function $412bf83c988c91d7$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$412bf83c988c91d7$export$d058ca695f8c6f11 = $412bf83c988c91d7$var$sum32_3;
function $412bf83c988c91d7$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$412bf83c988c91d7$export$a1efd7fc3e986367 = $412bf83c988c91d7$var$sum32_4;
function $412bf83c988c91d7$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$412bf83c988c91d7$export$bbfea4a2b5abaab4 = $412bf83c988c91d7$var$sum32_5;
function $412bf83c988c91d7$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$412bf83c988c91d7$export$97ad4afc7de86152 = $412bf83c988c91d7$var$sum64;
function $412bf83c988c91d7$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$412bf83c988c91d7$export$ce4673d9a79f6a4b = $412bf83c988c91d7$var$sum64_hi;
function $412bf83c988c91d7$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$412bf83c988c91d7$export$786cc99fc6eedc0b = $412bf83c988c91d7$var$sum64_lo;
function $412bf83c988c91d7$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$412bf83c988c91d7$export$45c59b9a1848dd0 = $412bf83c988c91d7$var$sum64_4_hi;
function $412bf83c988c91d7$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$412bf83c988c91d7$export$50d8f613e76d3034 = $412bf83c988c91d7$var$sum64_4_lo;
function $412bf83c988c91d7$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$412bf83c988c91d7$export$b8e83683c60ee162 = $412bf83c988c91d7$var$sum64_5_hi;
function $412bf83c988c91d7$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$412bf83c988c91d7$export$aeeb51790d1bcc4a = $412bf83c988c91d7$var$sum64_5_lo;
function $412bf83c988c91d7$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$412bf83c988c91d7$export$bb7c616f719ad9c = $412bf83c988c91d7$var$rotr64_hi;
function $412bf83c988c91d7$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$412bf83c988c91d7$export$4d63290824f9d7df = $412bf83c988c91d7$var$rotr64_lo;
function $412bf83c988c91d7$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$412bf83c988c91d7$export$2f64ceb90ef28ea1 = $412bf83c988c91d7$var$shr64_hi;
function $412bf83c988c91d7$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$412bf83c988c91d7$export$8d2089d465f6d10d = $412bf83c988c91d7$var$shr64_lo;

});

parcelRegister("46Eyw", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $2fd72e7dad6e23ef$export$8687658379b577e6; }, function (v) { return $2fd72e7dad6e23ef$export$8687658379b577e6 = v; });
var $2fd72e7dad6e23ef$export$8687658379b577e6;
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $qzkJD = parcelRequire("qzkJD");
function $2fd72e7dad6e23ef$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$2fd72e7dad6e23ef$export$8687658379b577e6 = $2fd72e7dad6e23ef$var$BlockHash;
$2fd72e7dad6e23ef$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $5AUhj.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $5AUhj.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$2fd72e7dad6e23ef$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $qzkJD(this.pending === null);
    return this._digest(enc);
};
$2fd72e7dad6e23ef$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("gBlKI", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $c160f9a689ecb54a$export$5091bdda49ba90f5; }, function (v) { return $c160f9a689ecb54a$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $c160f9a689ecb54a$export$97b70509d4e397ea; }, function (v) { return $c160f9a689ecb54a$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $c160f9a689ecb54a$export$bced8d2aada2d1c9; }, function (v) { return $c160f9a689ecb54a$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $c160f9a689ecb54a$export$612d47d55dedde45; }, function (v) { return $c160f9a689ecb54a$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $c160f9a689ecb54a$export$a888d2532e6dc7bb; }, function (v) { return $c160f9a689ecb54a$export$a888d2532e6dc7bb = v; });
var $c160f9a689ecb54a$export$5091bdda49ba90f5;
var $c160f9a689ecb54a$export$97b70509d4e397ea;
var $c160f9a689ecb54a$export$bced8d2aada2d1c9;
var $c160f9a689ecb54a$export$612d47d55dedde45;
var $c160f9a689ecb54a$export$a888d2532e6dc7bb;
'use strict';

$c160f9a689ecb54a$export$5091bdda49ba90f5 = (parcelRequire("E3Vr9"));

$c160f9a689ecb54a$export$97b70509d4e397ea = (parcelRequire("iILkb"));

$c160f9a689ecb54a$export$bced8d2aada2d1c9 = (parcelRequire("4pR8h"));

$c160f9a689ecb54a$export$612d47d55dedde45 = (parcelRequire("4BRjz"));

$c160f9a689ecb54a$export$a888d2532e6dc7bb = (parcelRequire("gSR95"));

});
parcelRegister("E3Vr9", function(module, exports) {
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $46Eyw = parcelRequire("46Eyw");

var $6KAVu = parcelRequire("6KAVu");
var $0786c80b57d07b99$var$rotl32 = $5AUhj.rotl32;
var $0786c80b57d07b99$var$sum32 = $5AUhj.sum32;
var $0786c80b57d07b99$var$sum32_5 = $5AUhj.sum32_5;
var $0786c80b57d07b99$var$ft_1 = $6KAVu.ft_1;
var $0786c80b57d07b99$var$BlockHash = $46Eyw.BlockHash;
var $0786c80b57d07b99$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0786c80b57d07b99$var$SHA1() {
    if (!(this instanceof $0786c80b57d07b99$var$SHA1)) return new $0786c80b57d07b99$var$SHA1();
    $0786c80b57d07b99$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$5AUhj.inherits($0786c80b57d07b99$var$SHA1, $0786c80b57d07b99$var$BlockHash);
module.exports = $0786c80b57d07b99$var$SHA1;
$0786c80b57d07b99$var$SHA1.blockSize = 512;
$0786c80b57d07b99$var$SHA1.outSize = 160;
$0786c80b57d07b99$var$SHA1.hmacStrength = 80;
$0786c80b57d07b99$var$SHA1.padLength = 64;
$0786c80b57d07b99$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0786c80b57d07b99$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0786c80b57d07b99$var$sum32_5($0786c80b57d07b99$var$rotl32(a, 5), $0786c80b57d07b99$var$ft_1(s, b, c, d), e, W[i], $0786c80b57d07b99$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0786c80b57d07b99$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0786c80b57d07b99$var$sum32(this.h[0], a);
    this.h[1] = $0786c80b57d07b99$var$sum32(this.h[1], b);
    this.h[2] = $0786c80b57d07b99$var$sum32(this.h[2], c);
    this.h[3] = $0786c80b57d07b99$var$sum32(this.h[3], d);
    this.h[4] = $0786c80b57d07b99$var$sum32(this.h[4], e);
};
$0786c80b57d07b99$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5AUhj.toHex32(this.h, 'big');
    else return $5AUhj.split32(this.h, 'big');
};

});
parcelRegister("6KAVu", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $4ea3aeb9d71558cc$export$5a92649d7ddb9f63; }, function (v) { return $4ea3aeb9d71558cc$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $4ea3aeb9d71558cc$export$c6d0d020c3a6269; }, function (v) { return $4ea3aeb9d71558cc$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $4ea3aeb9d71558cc$export$eb90c27fca05f956; }, function (v) { return $4ea3aeb9d71558cc$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $4ea3aeb9d71558cc$export$14a4a98e063b1999; }, function (v) { return $4ea3aeb9d71558cc$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $4ea3aeb9d71558cc$export$d20cecfa1564c686; }, function (v) { return $4ea3aeb9d71558cc$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $4ea3aeb9d71558cc$export$44fd472a12fc6db; }, function (v) { return $4ea3aeb9d71558cc$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $4ea3aeb9d71558cc$export$1ed238bb6ea1dd47; }, function (v) { return $4ea3aeb9d71558cc$export$1ed238bb6ea1dd47 = v; });
var $4ea3aeb9d71558cc$export$5a92649d7ddb9f63;
var $4ea3aeb9d71558cc$export$c6d0d020c3a6269;
var $4ea3aeb9d71558cc$export$eb90c27fca05f956;
var $4ea3aeb9d71558cc$export$cc992891a14496a1;
var $4ea3aeb9d71558cc$export$14a4a98e063b1999;
var $4ea3aeb9d71558cc$export$d20cecfa1564c686;
var $4ea3aeb9d71558cc$export$44fd472a12fc6db;
var $4ea3aeb9d71558cc$export$1ed238bb6ea1dd47;
'use strict';

var $5AUhj = parcelRequire("5AUhj");
var $4ea3aeb9d71558cc$var$rotr32 = $5AUhj.rotr32;
function $4ea3aeb9d71558cc$var$ft_1(s, x, y, z) {
    if (s === 0) return $4ea3aeb9d71558cc$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $4ea3aeb9d71558cc$var$p32(x, y, z);
    if (s === 2) return $4ea3aeb9d71558cc$var$maj32(x, y, z);
}
$4ea3aeb9d71558cc$export$5a92649d7ddb9f63 = $4ea3aeb9d71558cc$var$ft_1;
function $4ea3aeb9d71558cc$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$4ea3aeb9d71558cc$export$c6d0d020c3a6269 = $4ea3aeb9d71558cc$var$ch32;
function $4ea3aeb9d71558cc$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$4ea3aeb9d71558cc$export$eb90c27fca05f956 = $4ea3aeb9d71558cc$var$maj32;
function $4ea3aeb9d71558cc$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$4ea3aeb9d71558cc$export$cc992891a14496a1 = $4ea3aeb9d71558cc$var$p32;
function $4ea3aeb9d71558cc$var$s0_256(x) {
    return $4ea3aeb9d71558cc$var$rotr32(x, 2) ^ $4ea3aeb9d71558cc$var$rotr32(x, 13) ^ $4ea3aeb9d71558cc$var$rotr32(x, 22);
}
$4ea3aeb9d71558cc$export$14a4a98e063b1999 = $4ea3aeb9d71558cc$var$s0_256;
function $4ea3aeb9d71558cc$var$s1_256(x) {
    return $4ea3aeb9d71558cc$var$rotr32(x, 6) ^ $4ea3aeb9d71558cc$var$rotr32(x, 11) ^ $4ea3aeb9d71558cc$var$rotr32(x, 25);
}
$4ea3aeb9d71558cc$export$d20cecfa1564c686 = $4ea3aeb9d71558cc$var$s1_256;
function $4ea3aeb9d71558cc$var$g0_256(x) {
    return $4ea3aeb9d71558cc$var$rotr32(x, 7) ^ $4ea3aeb9d71558cc$var$rotr32(x, 18) ^ x >>> 3;
}
$4ea3aeb9d71558cc$export$44fd472a12fc6db = $4ea3aeb9d71558cc$var$g0_256;
function $4ea3aeb9d71558cc$var$g1_256(x) {
    return $4ea3aeb9d71558cc$var$rotr32(x, 17) ^ $4ea3aeb9d71558cc$var$rotr32(x, 19) ^ x >>> 10;
}
$4ea3aeb9d71558cc$export$1ed238bb6ea1dd47 = $4ea3aeb9d71558cc$var$g1_256;

});


parcelRegister("iILkb", function(module, exports) {
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $4pR8h = parcelRequire("4pR8h");
function $da110bb84c11c8db$var$SHA224() {
    if (!(this instanceof $da110bb84c11c8db$var$SHA224)) return new $da110bb84c11c8db$var$SHA224();
    $4pR8h.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$5AUhj.inherits($da110bb84c11c8db$var$SHA224, $4pR8h);
module.exports = $da110bb84c11c8db$var$SHA224;
$da110bb84c11c8db$var$SHA224.blockSize = 512;
$da110bb84c11c8db$var$SHA224.outSize = 224;
$da110bb84c11c8db$var$SHA224.hmacStrength = 192;
$da110bb84c11c8db$var$SHA224.padLength = 64;
$da110bb84c11c8db$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $5AUhj.toHex32(this.h.slice(0, 7), 'big');
    else return $5AUhj.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("4pR8h", function(module, exports) {
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $46Eyw = parcelRequire("46Eyw");

var $6KAVu = parcelRequire("6KAVu");

var $qzkJD = parcelRequire("qzkJD");
var $3372b63e44d9d73e$var$sum32 = $5AUhj.sum32;
var $3372b63e44d9d73e$var$sum32_4 = $5AUhj.sum32_4;
var $3372b63e44d9d73e$var$sum32_5 = $5AUhj.sum32_5;
var $3372b63e44d9d73e$var$ch32 = $6KAVu.ch32;
var $3372b63e44d9d73e$var$maj32 = $6KAVu.maj32;
var $3372b63e44d9d73e$var$s0_256 = $6KAVu.s0_256;
var $3372b63e44d9d73e$var$s1_256 = $6KAVu.s1_256;
var $3372b63e44d9d73e$var$g0_256 = $6KAVu.g0_256;
var $3372b63e44d9d73e$var$g1_256 = $6KAVu.g1_256;
var $3372b63e44d9d73e$var$BlockHash = $46Eyw.BlockHash;
var $3372b63e44d9d73e$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $3372b63e44d9d73e$var$SHA256() {
    if (!(this instanceof $3372b63e44d9d73e$var$SHA256)) return new $3372b63e44d9d73e$var$SHA256();
    $3372b63e44d9d73e$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $3372b63e44d9d73e$var$sha256_K;
    this.W = new Array(64);
}
$5AUhj.inherits($3372b63e44d9d73e$var$SHA256, $3372b63e44d9d73e$var$BlockHash);
module.exports = $3372b63e44d9d73e$var$SHA256;
$3372b63e44d9d73e$var$SHA256.blockSize = 512;
$3372b63e44d9d73e$var$SHA256.outSize = 256;
$3372b63e44d9d73e$var$SHA256.hmacStrength = 192;
$3372b63e44d9d73e$var$SHA256.padLength = 64;
$3372b63e44d9d73e$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $3372b63e44d9d73e$var$sum32_4($3372b63e44d9d73e$var$g1_256(W[i - 2]), W[i - 7], $3372b63e44d9d73e$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $qzkJD(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $3372b63e44d9d73e$var$sum32_5(h, $3372b63e44d9d73e$var$s1_256(e), $3372b63e44d9d73e$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $3372b63e44d9d73e$var$sum32($3372b63e44d9d73e$var$s0_256(a), $3372b63e44d9d73e$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $3372b63e44d9d73e$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $3372b63e44d9d73e$var$sum32(T1, T2);
    }
    this.h[0] = $3372b63e44d9d73e$var$sum32(this.h[0], a);
    this.h[1] = $3372b63e44d9d73e$var$sum32(this.h[1], b);
    this.h[2] = $3372b63e44d9d73e$var$sum32(this.h[2], c);
    this.h[3] = $3372b63e44d9d73e$var$sum32(this.h[3], d);
    this.h[4] = $3372b63e44d9d73e$var$sum32(this.h[4], e);
    this.h[5] = $3372b63e44d9d73e$var$sum32(this.h[5], f);
    this.h[6] = $3372b63e44d9d73e$var$sum32(this.h[6], g);
    this.h[7] = $3372b63e44d9d73e$var$sum32(this.h[7], h);
};
$3372b63e44d9d73e$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5AUhj.toHex32(this.h, 'big');
    else return $5AUhj.split32(this.h, 'big');
};

});


parcelRegister("4BRjz", function(module, exports) {
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $gSR95 = parcelRequire("gSR95");
function $35b3f94b3379f7e1$var$SHA384() {
    if (!(this instanceof $35b3f94b3379f7e1$var$SHA384)) return new $35b3f94b3379f7e1$var$SHA384();
    $gSR95.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$5AUhj.inherits($35b3f94b3379f7e1$var$SHA384, $gSR95);
module.exports = $35b3f94b3379f7e1$var$SHA384;
$35b3f94b3379f7e1$var$SHA384.blockSize = 1024;
$35b3f94b3379f7e1$var$SHA384.outSize = 384;
$35b3f94b3379f7e1$var$SHA384.hmacStrength = 192;
$35b3f94b3379f7e1$var$SHA384.padLength = 128;
$35b3f94b3379f7e1$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5AUhj.toHex32(this.h.slice(0, 12), 'big');
    else return $5AUhj.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("gSR95", function(module, exports) {
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $46Eyw = parcelRequire("46Eyw");

var $qzkJD = parcelRequire("qzkJD");
var $c4aaea1216ba95ba$var$rotr64_hi = $5AUhj.rotr64_hi;
var $c4aaea1216ba95ba$var$rotr64_lo = $5AUhj.rotr64_lo;
var $c4aaea1216ba95ba$var$shr64_hi = $5AUhj.shr64_hi;
var $c4aaea1216ba95ba$var$shr64_lo = $5AUhj.shr64_lo;
var $c4aaea1216ba95ba$var$sum64 = $5AUhj.sum64;
var $c4aaea1216ba95ba$var$sum64_hi = $5AUhj.sum64_hi;
var $c4aaea1216ba95ba$var$sum64_lo = $5AUhj.sum64_lo;
var $c4aaea1216ba95ba$var$sum64_4_hi = $5AUhj.sum64_4_hi;
var $c4aaea1216ba95ba$var$sum64_4_lo = $5AUhj.sum64_4_lo;
var $c4aaea1216ba95ba$var$sum64_5_hi = $5AUhj.sum64_5_hi;
var $c4aaea1216ba95ba$var$sum64_5_lo = $5AUhj.sum64_5_lo;
var $c4aaea1216ba95ba$var$BlockHash = $46Eyw.BlockHash;
var $c4aaea1216ba95ba$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $c4aaea1216ba95ba$var$SHA512() {
    if (!(this instanceof $c4aaea1216ba95ba$var$SHA512)) return new $c4aaea1216ba95ba$var$SHA512();
    $c4aaea1216ba95ba$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $c4aaea1216ba95ba$var$sha512_K;
    this.W = new Array(160);
}
$5AUhj.inherits($c4aaea1216ba95ba$var$SHA512, $c4aaea1216ba95ba$var$BlockHash);
module.exports = $c4aaea1216ba95ba$var$SHA512;
$c4aaea1216ba95ba$var$SHA512.blockSize = 1024;
$c4aaea1216ba95ba$var$SHA512.outSize = 512;
$c4aaea1216ba95ba$var$SHA512.hmacStrength = 192;
$c4aaea1216ba95ba$var$SHA512.padLength = 128;
$c4aaea1216ba95ba$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $c4aaea1216ba95ba$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $c4aaea1216ba95ba$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $c4aaea1216ba95ba$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $c4aaea1216ba95ba$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $c4aaea1216ba95ba$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $c4aaea1216ba95ba$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$c4aaea1216ba95ba$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $qzkJD(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $c4aaea1216ba95ba$var$s1_512_hi(eh, el);
        var c1_lo = $c4aaea1216ba95ba$var$s1_512_lo(eh, el);
        var c2_hi = $c4aaea1216ba95ba$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $c4aaea1216ba95ba$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $c4aaea1216ba95ba$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $c4aaea1216ba95ba$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $c4aaea1216ba95ba$var$s0_512_hi(ah, al);
        c0_lo = $c4aaea1216ba95ba$var$s0_512_lo(ah, al);
        c1_hi = $c4aaea1216ba95ba$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $c4aaea1216ba95ba$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $c4aaea1216ba95ba$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $c4aaea1216ba95ba$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $c4aaea1216ba95ba$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $c4aaea1216ba95ba$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $c4aaea1216ba95ba$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $c4aaea1216ba95ba$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $c4aaea1216ba95ba$var$sum64(this.h, 0, ah, al);
    $c4aaea1216ba95ba$var$sum64(this.h, 2, bh, bl);
    $c4aaea1216ba95ba$var$sum64(this.h, 4, ch, cl);
    $c4aaea1216ba95ba$var$sum64(this.h, 6, dh, dl);
    $c4aaea1216ba95ba$var$sum64(this.h, 8, eh, el);
    $c4aaea1216ba95ba$var$sum64(this.h, 10, fh, fl);
    $c4aaea1216ba95ba$var$sum64(this.h, 12, gh, gl);
    $c4aaea1216ba95ba$var$sum64(this.h, 14, hh, hl);
};
$c4aaea1216ba95ba$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5AUhj.toHex32(this.h, 'big');
    else return $5AUhj.split32(this.h, 'big');
};
function $c4aaea1216ba95ba$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$s0_512_hi(xh, xl) {
    var c0_hi = $c4aaea1216ba95ba$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $c4aaea1216ba95ba$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $c4aaea1216ba95ba$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$s0_512_lo(xh, xl) {
    var c0_lo = $c4aaea1216ba95ba$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $c4aaea1216ba95ba$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $c4aaea1216ba95ba$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$s1_512_hi(xh, xl) {
    var c0_hi = $c4aaea1216ba95ba$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $c4aaea1216ba95ba$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $c4aaea1216ba95ba$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$s1_512_lo(xh, xl) {
    var c0_lo = $c4aaea1216ba95ba$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $c4aaea1216ba95ba$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $c4aaea1216ba95ba$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$g0_512_hi(xh, xl) {
    var c0_hi = $c4aaea1216ba95ba$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $c4aaea1216ba95ba$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $c4aaea1216ba95ba$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$g0_512_lo(xh, xl) {
    var c0_lo = $c4aaea1216ba95ba$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $c4aaea1216ba95ba$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $c4aaea1216ba95ba$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$g1_512_hi(xh, xl) {
    var c0_hi = $c4aaea1216ba95ba$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $c4aaea1216ba95ba$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $c4aaea1216ba95ba$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c4aaea1216ba95ba$var$g1_512_lo(xh, xl) {
    var c0_lo = $c4aaea1216ba95ba$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $c4aaea1216ba95ba$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $c4aaea1216ba95ba$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("edWCP", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $a5afc15a82c45548$export$d1cea0ee4e3f0d3e; }, function (v) { return $a5afc15a82c45548$export$d1cea0ee4e3f0d3e = v; });
var $a5afc15a82c45548$export$d1cea0ee4e3f0d3e;
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $46Eyw = parcelRequire("46Eyw");
var $a5afc15a82c45548$var$rotl32 = $5AUhj.rotl32;
var $a5afc15a82c45548$var$sum32 = $5AUhj.sum32;
var $a5afc15a82c45548$var$sum32_3 = $5AUhj.sum32_3;
var $a5afc15a82c45548$var$sum32_4 = $5AUhj.sum32_4;
var $a5afc15a82c45548$var$BlockHash = $46Eyw.BlockHash;
function $a5afc15a82c45548$var$RIPEMD160() {
    if (!(this instanceof $a5afc15a82c45548$var$RIPEMD160)) return new $a5afc15a82c45548$var$RIPEMD160();
    $a5afc15a82c45548$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$5AUhj.inherits($a5afc15a82c45548$var$RIPEMD160, $a5afc15a82c45548$var$BlockHash);
$a5afc15a82c45548$export$d1cea0ee4e3f0d3e = $a5afc15a82c45548$var$RIPEMD160;
$a5afc15a82c45548$var$RIPEMD160.blockSize = 512;
$a5afc15a82c45548$var$RIPEMD160.outSize = 160;
$a5afc15a82c45548$var$RIPEMD160.hmacStrength = 192;
$a5afc15a82c45548$var$RIPEMD160.padLength = 64;
$a5afc15a82c45548$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $a5afc15a82c45548$var$sum32($a5afc15a82c45548$var$rotl32($a5afc15a82c45548$var$sum32_4(A, $a5afc15a82c45548$var$f(j, B, C, D), msg[$a5afc15a82c45548$var$r[j] + start], $a5afc15a82c45548$var$K(j)), $a5afc15a82c45548$var$s[j]), E);
        A = E;
        E = D;
        D = $a5afc15a82c45548$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $a5afc15a82c45548$var$sum32($a5afc15a82c45548$var$rotl32($a5afc15a82c45548$var$sum32_4(Ah, $a5afc15a82c45548$var$f(79 - j, Bh, Ch, Dh), msg[$a5afc15a82c45548$var$rh[j] + start], $a5afc15a82c45548$var$Kh(j)), $a5afc15a82c45548$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $a5afc15a82c45548$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $a5afc15a82c45548$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $a5afc15a82c45548$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $a5afc15a82c45548$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $a5afc15a82c45548$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $a5afc15a82c45548$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$a5afc15a82c45548$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5AUhj.toHex32(this.h, 'little');
    else return $5AUhj.split32(this.h, 'little');
};
function $a5afc15a82c45548$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $a5afc15a82c45548$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $a5afc15a82c45548$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $a5afc15a82c45548$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $a5afc15a82c45548$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $a5afc15a82c45548$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $a5afc15a82c45548$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("2RlVW", function(module, exports) {
'use strict';

var $5AUhj = parcelRequire("5AUhj");

var $qzkJD = parcelRequire("qzkJD");
function $21518b8b54f7508a$var$Hmac(hash, key, enc) {
    if (!(this instanceof $21518b8b54f7508a$var$Hmac)) return new $21518b8b54f7508a$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($5AUhj.toArray(key, enc));
}
module.exports = $21518b8b54f7508a$var$Hmac;
$21518b8b54f7508a$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $qzkJD(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$21518b8b54f7508a$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$21518b8b54f7508a$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("kIk7x", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("7k77E", function(module, exports) {
'use strict';

var $2ofiR = parcelRequire("2ofiR");

var $lAGXj = parcelRequire("lAGXj");

var $5J8E2 = parcelRequire("5J8E2");

var $cDhE4 = parcelRequire("cDhE4");

var $cA0my = parcelRequire("cA0my");
var $554fed0a2ad208b6$var$assert = $5J8E2.assert;

var $7itzR = parcelRequire("7itzR");

var $aMmlR = parcelRequire("aMmlR");
function $554fed0a2ad208b6$var$EC(options) {
    if (!(this instanceof $554fed0a2ad208b6$var$EC)) return new $554fed0a2ad208b6$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $554fed0a2ad208b6$var$assert(Object.prototype.hasOwnProperty.call($cDhE4, options), 'Unknown curve ' + options);
        options = $cDhE4[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $cDhE4.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $554fed0a2ad208b6$var$EC;
$554fed0a2ad208b6$var$EC.prototype.keyPair = function keyPair(options) {
    return new $7itzR(this, options);
};
$554fed0a2ad208b6$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $7itzR.fromPrivate(this, priv, enc);
};
$554fed0a2ad208b6$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $7itzR.fromPublic(this, pub, enc);
};
$554fed0a2ad208b6$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $lAGXj({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $cA0my(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $2ofiR(2));
    for(;;){
        var priv = new $2ofiR(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$554fed0a2ad208b6$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($2ofiR.isBN(msg) || typeof msg === 'number') {
        msg = new $2ofiR(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $2ofiR(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $2ofiR(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$554fed0a2ad208b6$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$2ofiR.isBN(msg)) {
        $554fed0a2ad208b6$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $554fed0a2ad208b6$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$554fed0a2ad208b6$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $554fed0a2ad208b6$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $554fed0a2ad208b6$var$assert(new $2ofiR(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $lAGXj({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $2ofiR(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $2ofiR(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $aMmlR({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$554fed0a2ad208b6$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $aMmlR(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$554fed0a2ad208b6$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $554fed0a2ad208b6$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $aMmlR(signature, enc);
    var n = this.n;
    var e = new $2ofiR(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$554fed0a2ad208b6$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $aMmlR(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("lAGXj", function(module, exports) {
'use strict';

var $9zDa1 = parcelRequire("9zDa1");

var $gAV2x = parcelRequire("gAV2x");

var $qzkJD = parcelRequire("qzkJD");
function $fb7e47e2fd766579$var$HmacDRBG(options) {
    if (!(this instanceof $fb7e47e2fd766579$var$HmacDRBG)) return new $fb7e47e2fd766579$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $gAV2x.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $gAV2x.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $gAV2x.toArray(options.pers, options.persEnc || 'hex');
    $qzkJD(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $fb7e47e2fd766579$var$HmacDRBG;
$fb7e47e2fd766579$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$fb7e47e2fd766579$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $9zDa1.hmac(this.hash, this.K);
};
$fb7e47e2fd766579$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$fb7e47e2fd766579$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $gAV2x.toArray(entropy, entropyEnc);
    add = $gAV2x.toArray(add, addEnc);
    $qzkJD(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$fb7e47e2fd766579$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $gAV2x.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $gAV2x.encode(res, enc);
};

});

parcelRegister("7itzR", function(module, exports) {
'use strict';

var $2ofiR = parcelRequire("2ofiR");

var $5J8E2 = parcelRequire("5J8E2");
var $55012847700d9bc0$var$assert = $5J8E2.assert;
function $55012847700d9bc0$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $55012847700d9bc0$var$KeyPair;
$55012847700d9bc0$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $55012847700d9bc0$var$KeyPair) return pub;
    return new $55012847700d9bc0$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$55012847700d9bc0$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $55012847700d9bc0$var$KeyPair) return priv;
    return new $55012847700d9bc0$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$55012847700d9bc0$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$55012847700d9bc0$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$55012847700d9bc0$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$55012847700d9bc0$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $2ofiR(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$55012847700d9bc0$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $55012847700d9bc0$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $55012847700d9bc0$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$55012847700d9bc0$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $55012847700d9bc0$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$55012847700d9bc0$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$55012847700d9bc0$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$55012847700d9bc0$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("aMmlR", function(module, exports) {
'use strict';

var $2ofiR = parcelRequire("2ofiR");

var $5J8E2 = parcelRequire("5J8E2");
var $7d8fb9a4372de737$var$assert = $5J8E2.assert;
function $7d8fb9a4372de737$var$Signature(options, enc) {
    if (options instanceof $7d8fb9a4372de737$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $7d8fb9a4372de737$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $2ofiR(options.r, 16);
    this.s = new $2ofiR(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $7d8fb9a4372de737$var$Signature;
function $7d8fb9a4372de737$var$Position() {
    this.place = 0;
}
function $7d8fb9a4372de737$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $7d8fb9a4372de737$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$7d8fb9a4372de737$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $5J8E2.toArray(data, enc);
    var p = new $7d8fb9a4372de737$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $7d8fb9a4372de737$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $7d8fb9a4372de737$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $7d8fb9a4372de737$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $2ofiR(r);
    this.s = new $2ofiR(s);
    this.recoveryParam = null;
    return true;
};
function $7d8fb9a4372de737$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$7d8fb9a4372de737$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $7d8fb9a4372de737$var$rmPadding(r);
    s = $7d8fb9a4372de737$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $7d8fb9a4372de737$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $7d8fb9a4372de737$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $7d8fb9a4372de737$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $5J8E2.encode(res, enc);
};

});


parcelRegister("dafO5", function(module, exports) {
'use strict';

var $9zDa1 = parcelRequire("9zDa1");

var $cDhE4 = parcelRequire("cDhE4");

var $5J8E2 = parcelRequire("5J8E2");
var $99587871b3939604$var$assert = $5J8E2.assert;
var $99587871b3939604$var$parseBytes = $5J8E2.parseBytes;

var $kkopj = parcelRequire("kkopj");

var $8hx7g = parcelRequire("8hx7g");
function $99587871b3939604$var$EDDSA(curve) {
    $99587871b3939604$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $99587871b3939604$var$EDDSA)) return new $99587871b3939604$var$EDDSA(curve);
    curve = $cDhE4[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $9zDa1.sha512;
}
module.exports = $99587871b3939604$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $99587871b3939604$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $99587871b3939604$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $99587871b3939604$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $99587871b3939604$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$99587871b3939604$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $5J8E2.intFromLE(hash.digest()).umod(this.curve.n);
};
$99587871b3939604$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $kkopj.fromPublic(this, pub);
};
$99587871b3939604$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $kkopj.fromSecret(this, secret);
};
$99587871b3939604$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $8hx7g) return sig;
    return new $8hx7g(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $99587871b3939604$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$99587871b3939604$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $5J8E2.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $5J8E2.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$99587871b3939604$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$99587871b3939604$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $5J8E2.intFromLE(bytes);
};
$99587871b3939604$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("kkopj", function(module, exports) {
'use strict';

var $5J8E2 = parcelRequire("5J8E2");
var $ecc89ba7bab2973e$var$assert = $5J8E2.assert;
var $ecc89ba7bab2973e$var$parseBytes = $5J8E2.parseBytes;
var $ecc89ba7bab2973e$var$cachedProperty = $5J8E2.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $ecc89ba7bab2973e$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $ecc89ba7bab2973e$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $ecc89ba7bab2973e$var$parseBytes(params.pub);
}
$ecc89ba7bab2973e$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $ecc89ba7bab2973e$var$KeyPair) return pub;
    return new $ecc89ba7bab2973e$var$KeyPair(eddsa, {
        pub: pub
    });
};
$ecc89ba7bab2973e$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $ecc89ba7bab2973e$var$KeyPair) return secret;
    return new $ecc89ba7bab2973e$var$KeyPair(eddsa, {
        secret: secret
    });
};
$ecc89ba7bab2973e$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$ecc89ba7bab2973e$var$cachedProperty($ecc89ba7bab2973e$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$ecc89ba7bab2973e$var$cachedProperty($ecc89ba7bab2973e$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$ecc89ba7bab2973e$var$cachedProperty($ecc89ba7bab2973e$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$ecc89ba7bab2973e$var$cachedProperty($ecc89ba7bab2973e$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$ecc89ba7bab2973e$var$cachedProperty($ecc89ba7bab2973e$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$ecc89ba7bab2973e$var$cachedProperty($ecc89ba7bab2973e$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$ecc89ba7bab2973e$var$KeyPair.prototype.sign = function sign(message) {
    $ecc89ba7bab2973e$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$ecc89ba7bab2973e$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$ecc89ba7bab2973e$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $ecc89ba7bab2973e$var$assert(this._secret, 'KeyPair is public only');
    return $5J8E2.encode(this.secret(), enc);
};
$ecc89ba7bab2973e$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $5J8E2.encode(this.pubBytes(), enc);
};
module.exports = $ecc89ba7bab2973e$var$KeyPair;

});

parcelRegister("8hx7g", function(module, exports) {
'use strict';

var $2ofiR = parcelRequire("2ofiR");

var $5J8E2 = parcelRequire("5J8E2");
var $6079996d54c1529b$var$assert = $5J8E2.assert;
var $6079996d54c1529b$var$cachedProperty = $5J8E2.cachedProperty;
var $6079996d54c1529b$var$parseBytes = $5J8E2.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $6079996d54c1529b$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $6079996d54c1529b$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $6079996d54c1529b$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $6079996d54c1529b$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $2ofiR) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$6079996d54c1529b$var$cachedProperty($6079996d54c1529b$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$6079996d54c1529b$var$cachedProperty($6079996d54c1529b$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$6079996d54c1529b$var$cachedProperty($6079996d54c1529b$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$6079996d54c1529b$var$cachedProperty($6079996d54c1529b$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$6079996d54c1529b$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$6079996d54c1529b$var$Signature.prototype.toHex = function toHex() {
    return $5J8E2.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $6079996d54c1529b$var$Signature;

});



parcelRegister("j23JA", function(module, exports) {
'use strict';

var $gX7NL = parcelRequire("gX7NL");

var $5jr5l = parcelRequire("5jr5l");

var $d6TcD = parcelRequire("d6TcD");

var $dvlcQ = parcelRequire("dvlcQ");

var $btZcF = parcelRequire("btZcF");

var $eF2Mu = parcelRequire("eF2Mu");
var $ddb119c5b7c7777d$require$Buffer = $eF2Mu.Buffer;
function $ddb119c5b7c7777d$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5jr5l[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $btZcF.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $dvlcQ.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $ddb119c5b7c7777d$require$Buffer.concat(out);
}
function $ddb119c5b7c7777d$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$ddb119c5b7c7777d$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $ddb119c5b7c7777d$require$Buffer.from(buffer);
    var stripped = $d6TcD(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $gX7NL.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $gX7NL.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $gX7NL.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $gX7NL.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $gX7NL.EncryptedPrivateKey.decode(data, 'der');
            data = $ddb119c5b7c7777d$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $gX7NL.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $gX7NL.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $gX7NL.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $gX7NL.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $gX7NL.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $gX7NL.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $gX7NL.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $gX7NL.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$ddb119c5b7c7777d$var$parseKeys.signature = $gX7NL.signature;
module.exports = $ddb119c5b7c7777d$var$parseKeys;

});
parcelRegister("gX7NL", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $c5783546dab98690$export$c98397a6eb8d0678; }, function (v) { return $c5783546dab98690$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $c5783546dab98690$export$f4aab6816f64fa6b; }, function (v) { return $c5783546dab98690$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $c5783546dab98690$export$4471f5c65d097c11; }, function (v) { return $c5783546dab98690$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $c5783546dab98690$export$ca8b6604d6ce14de; }, function (v) { return $c5783546dab98690$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $c5783546dab98690$export$8f54525b330fd87b; }, function (v) { return $c5783546dab98690$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $c5783546dab98690$export$23cd2842b44ca3e7; }, function (v) { return $c5783546dab98690$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $c5783546dab98690$export$245c9aaa9f5ce4ce; }, function (v) { return $c5783546dab98690$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $c5783546dab98690$export$8ad762e3e6399afe; }, function (v) { return $c5783546dab98690$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $c5783546dab98690$export$32ef6f92e22c6ab0; }, function (v) { return $c5783546dab98690$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $c5783546dab98690$export$c9cd164b539ebb63; }, function (v) { return $c5783546dab98690$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $c5783546dab98690$export$c98397a6eb8d0678;
var $c5783546dab98690$export$f4aab6816f64fa6b;
var $c5783546dab98690$export$4471f5c65d097c11;
var $c5783546dab98690$export$ca8b6604d6ce14de;
var $c5783546dab98690$export$8f54525b330fd87b;
var $c5783546dab98690$export$23cd2842b44ca3e7;
var $c5783546dab98690$export$245c9aaa9f5ce4ce;
var $c5783546dab98690$export$8ad762e3e6399afe;
var $c5783546dab98690$export$32ef6f92e22c6ab0;
var $c5783546dab98690$export$c9cd164b539ebb63;
'use strict';

var $7DLsH = parcelRequire("7DLsH");

$c5783546dab98690$export$c98397a6eb8d0678 = (parcelRequire("387Op"));
var $c5783546dab98690$var$RSAPrivateKey = $7DLsH.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$c5783546dab98690$export$f4aab6816f64fa6b = $c5783546dab98690$var$RSAPrivateKey;
var $c5783546dab98690$var$RSAPublicKey = $7DLsH.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$c5783546dab98690$export$4471f5c65d097c11 = $c5783546dab98690$var$RSAPublicKey;
var $c5783546dab98690$var$AlgorithmIdentifier = $7DLsH.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $c5783546dab98690$var$PublicKey = $7DLsH.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($c5783546dab98690$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$c5783546dab98690$export$ca8b6604d6ce14de = $c5783546dab98690$var$PublicKey;
var $c5783546dab98690$var$PrivateKeyInfo = $7DLsH.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($c5783546dab98690$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$c5783546dab98690$export$8f54525b330fd87b = $c5783546dab98690$var$PrivateKeyInfo;
var $c5783546dab98690$var$EncryptedPrivateKeyInfo = $7DLsH.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$c5783546dab98690$export$23cd2842b44ca3e7 = $c5783546dab98690$var$EncryptedPrivateKeyInfo;
var $c5783546dab98690$var$DSAPrivateKey = $7DLsH.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$c5783546dab98690$export$245c9aaa9f5ce4ce = $c5783546dab98690$var$DSAPrivateKey;
$c5783546dab98690$export$8ad762e3e6399afe = $7DLsH.define('DSAparam', function() {
    this['int']();
});
var $c5783546dab98690$var$ECParameters = $7DLsH.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $c5783546dab98690$var$ECPrivateKey = $7DLsH.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($c5783546dab98690$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$c5783546dab98690$export$32ef6f92e22c6ab0 = $c5783546dab98690$var$ECPrivateKey;
$c5783546dab98690$export$c9cd164b539ebb63 = $7DLsH.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("7DLsH", function(module, exports) {
var $5900fdded177743c$var$asn1 = module.exports;

$5900fdded177743c$var$asn1.bignum = (parcelRequire("949dp"));

$5900fdded177743c$var$asn1.define = (parcelRequire("cDDim")).define;

$5900fdded177743c$var$asn1.base = (parcelRequire("lFNT3"));

$5900fdded177743c$var$asn1.constants = (parcelRequire("gI8tU"));

$5900fdded177743c$var$asn1.decoders = (parcelRequire("hbOho"));

$5900fdded177743c$var$asn1.encoders = (parcelRequire("2AJG4"));

});
parcelRegister("949dp", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("80bNa")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("cDDim", function(module, exports) {

var $7DLsH = parcelRequire("7DLsH");

var $4rf1u = parcelRequire("4rf1u");
var $93379bbbbc5c7cdf$var$api = module.exports;
$93379bbbbc5c7cdf$var$api.define = function define(name, body) {
    return new $93379bbbbc5c7cdf$var$Entity(name, body);
};
function $93379bbbbc5c7cdf$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$93379bbbbc5c7cdf$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("jDdVr")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $4rf1u(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$93379bbbbc5c7cdf$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($7DLsH.decoders[enc]);
    return this.decoders[enc];
};
$93379bbbbc5c7cdf$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$93379bbbbc5c7cdf$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($7DLsH.encoders[enc]);
    return this.encoders[enc];
};
$93379bbbbc5c7cdf$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("jDdVr", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("lFNT3", function(module, exports) {
var $fc741fcdaa449197$var$base = module.exports;

$fc741fcdaa449197$var$base.Reporter = (parcelRequire("2dHOC")).Reporter;

$fc741fcdaa449197$var$base.DecoderBuffer = (parcelRequire("3szOp")).DecoderBuffer;

$fc741fcdaa449197$var$base.EncoderBuffer = (parcelRequire("3szOp")).EncoderBuffer;

$fc741fcdaa449197$var$base.Node = (parcelRequire("hi0zV"));

});
parcelRegister("2dHOC", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $19dec87cf051e85c$export$957313a2f485e5ed; }, function (v) { return $19dec87cf051e85c$export$957313a2f485e5ed = v; });
var $19dec87cf051e85c$export$957313a2f485e5ed;

var $4rf1u = parcelRequire("4rf1u");
function $19dec87cf051e85c$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$19dec87cf051e85c$export$957313a2f485e5ed = $19dec87cf051e85c$var$Reporter;
$19dec87cf051e85c$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $19dec87cf051e85c$var$ReporterError;
};
$19dec87cf051e85c$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$19dec87cf051e85c$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$19dec87cf051e85c$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$19dec87cf051e85c$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$19dec87cf051e85c$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$19dec87cf051e85c$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$19dec87cf051e85c$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$19dec87cf051e85c$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$19dec87cf051e85c$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $19dec87cf051e85c$var$ReporterError;
    if (inherited) err = msg;
    else err = new $19dec87cf051e85c$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$19dec87cf051e85c$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $19dec87cf051e85c$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$4rf1u($19dec87cf051e85c$var$ReporterError, Error);
$19dec87cf051e85c$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $19dec87cf051e85c$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("3szOp", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $284fc426a1bbf2ad$export$bf9f79cdc4a49163; }, function (v) { return $284fc426a1bbf2ad$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $284fc426a1bbf2ad$export$8ff24f7760c7a78e; }, function (v) { return $284fc426a1bbf2ad$export$8ff24f7760c7a78e = v; });
var $284fc426a1bbf2ad$export$bf9f79cdc4a49163;
var $284fc426a1bbf2ad$export$8ff24f7760c7a78e;

var $4rf1u = parcelRequire("4rf1u");

var $lFNT3 = parcelRequire("lFNT3");
var $284fc426a1bbf2ad$require$Reporter = $lFNT3.Reporter;

var $b0kMB = parcelRequire("b0kMB");
var $284fc426a1bbf2ad$require$Buffer = $b0kMB.Buffer;
function $284fc426a1bbf2ad$var$DecoderBuffer(base, options) {
    $284fc426a1bbf2ad$require$Reporter.call(this, options);
    if (!$284fc426a1bbf2ad$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$4rf1u($284fc426a1bbf2ad$var$DecoderBuffer, $284fc426a1bbf2ad$require$Reporter);
$284fc426a1bbf2ad$export$bf9f79cdc4a49163 = $284fc426a1bbf2ad$var$DecoderBuffer;
$284fc426a1bbf2ad$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $284fc426a1bbf2ad$require$Reporter.prototype.save.call(this)
    };
};
$284fc426a1bbf2ad$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $284fc426a1bbf2ad$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $284fc426a1bbf2ad$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$284fc426a1bbf2ad$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$284fc426a1bbf2ad$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$284fc426a1bbf2ad$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $284fc426a1bbf2ad$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$284fc426a1bbf2ad$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $284fc426a1bbf2ad$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $284fc426a1bbf2ad$var$EncoderBuffer)) item = new $284fc426a1bbf2ad$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $284fc426a1bbf2ad$require$Buffer.byteLength(value);
    } else if ($284fc426a1bbf2ad$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$284fc426a1bbf2ad$export$8ff24f7760c7a78e = $284fc426a1bbf2ad$var$EncoderBuffer;
$284fc426a1bbf2ad$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $284fc426a1bbf2ad$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($284fc426a1bbf2ad$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("hi0zV", function(module, exports) {

var $lFNT3 = parcelRequire("lFNT3");
var $c96490fb48aab49c$require$Reporter = $lFNT3.Reporter;

var $lFNT3 = parcelRequire("lFNT3");
var $c96490fb48aab49c$require$EncoderBuffer = $lFNT3.EncoderBuffer;

var $lFNT3 = parcelRequire("lFNT3");
var $c96490fb48aab49c$require$DecoderBuffer = $lFNT3.DecoderBuffer;

var $qzkJD = parcelRequire("qzkJD");
// Supported tags
var $c96490fb48aab49c$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $c96490fb48aab49c$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($c96490fb48aab49c$var$tags);
// Overrided methods list
var $c96490fb48aab49c$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $c96490fb48aab49c$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c96490fb48aab49c$var$Node;
var $c96490fb48aab49c$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$c96490fb48aab49c$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c96490fb48aab49c$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c96490fb48aab49c$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c96490fb48aab49c$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c96490fb48aab49c$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $qzkJD(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $qzkJD.equal(state.children.length, 1, 'Root node can have only one child');
};
$c96490fb48aab49c$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $qzkJD(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $qzkJD(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c96490fb48aab49c$var$overrided.forEach(function(method) {
    $c96490fb48aab49c$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$c96490fb48aab49c$var$tags.forEach(function(tag) {
    $c96490fb48aab49c$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $qzkJD(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c96490fb48aab49c$var$Node.prototype.use = function use(item) {
    $qzkJD(item);
    var state = this._baseState;
    $qzkJD(state.use === null);
    state.use = item;
    return this;
};
$c96490fb48aab49c$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c96490fb48aab49c$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $qzkJD(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$c96490fb48aab49c$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $qzkJD(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c96490fb48aab49c$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $qzkJD(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c96490fb48aab49c$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c96490fb48aab49c$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $qzkJD(state.key === null);
    state.key = newKey;
    return this;
};
$c96490fb48aab49c$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c96490fb48aab49c$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $qzkJD(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c96490fb48aab49c$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $qzkJD(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c96490fb48aab49c$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $c96490fb48aab49c$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c96490fb48aab49c$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$c96490fb48aab49c$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $qzkJD(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c96490fb48aab49c$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$c96490fb48aab49c$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c96490fb48aab49c$require$EncoderBuffer(data, this.reporter);
};
$c96490fb48aab49c$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c96490fb48aab49c$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c96490fb48aab49c$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$c96490fb48aab49c$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $qzkJD(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c96490fb48aab49c$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$c96490fb48aab49c$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c96490fb48aab49c$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("gI8tU", function(module, exports) {
var $c2a7559fff60ffe3$var$constants = module.exports;
// Helper
$c2a7559fff60ffe3$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$c2a7559fff60ffe3$var$constants.der = (parcelRequire("dfzyw"));

});
parcelRegister("dfzyw", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $9a5841b7bc10db6d$export$3584c46ed60baee8; }, function (v) { return $9a5841b7bc10db6d$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $9a5841b7bc10db6d$export$f18596ef8d632e49; }, function (v) { return $9a5841b7bc10db6d$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $9a5841b7bc10db6d$export$2b067c6666111485; }, function (v) { return $9a5841b7bc10db6d$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $9a5841b7bc10db6d$export$f17df38a421ab9e3; }, function (v) { return $9a5841b7bc10db6d$export$f17df38a421ab9e3 = v; });
var $9a5841b7bc10db6d$export$3584c46ed60baee8;
var $9a5841b7bc10db6d$export$f18596ef8d632e49;
var $9a5841b7bc10db6d$export$2b067c6666111485;
var $9a5841b7bc10db6d$export$f17df38a421ab9e3;

var $gI8tU = parcelRequire("gI8tU");
$9a5841b7bc10db6d$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$9a5841b7bc10db6d$export$f18596ef8d632e49 = $gI8tU._reverse($9a5841b7bc10db6d$export$3584c46ed60baee8);
$9a5841b7bc10db6d$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$9a5841b7bc10db6d$export$f17df38a421ab9e3 = $gI8tU._reverse($9a5841b7bc10db6d$export$2b067c6666111485);

});


parcelRegister("hbOho", function(module, exports) {
var $c83a77391e0f1d7e$var$decoders = module.exports;

$c83a77391e0f1d7e$var$decoders.der = (parcelRequire("5IYaJ"));

$c83a77391e0f1d7e$var$decoders.pem = (parcelRequire("3CfsM"));

});
parcelRegister("5IYaJ", function(module, exports) {

var $4rf1u = parcelRequire("4rf1u");

var $7DLsH = parcelRequire("7DLsH");
var $42afbcb807c8d057$var$base = $7DLsH.base;
var $42afbcb807c8d057$var$bignum = $7DLsH.bignum;
// Import DER constants
var $42afbcb807c8d057$var$der = $7DLsH.constants.der;
function $42afbcb807c8d057$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $42afbcb807c8d057$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $42afbcb807c8d057$var$DERDecoder;
$42afbcb807c8d057$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $42afbcb807c8d057$var$base.DecoderBuffer)) data = new $42afbcb807c8d057$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $42afbcb807c8d057$var$DERNode(parent) {
    $42afbcb807c8d057$var$base.Node.call(this, 'der', parent);
}
$4rf1u($42afbcb807c8d057$var$DERNode, $42afbcb807c8d057$var$base.Node);
$42afbcb807c8d057$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $42afbcb807c8d057$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$42afbcb807c8d057$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $42afbcb807c8d057$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $42afbcb807c8d057$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$42afbcb807c8d057$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $42afbcb807c8d057$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $42afbcb807c8d057$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$42afbcb807c8d057$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$42afbcb807c8d057$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$42afbcb807c8d057$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$42afbcb807c8d057$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$42afbcb807c8d057$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$42afbcb807c8d057$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$42afbcb807c8d057$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $42afbcb807c8d057$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$42afbcb807c8d057$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $42afbcb807c8d057$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $42afbcb807c8d057$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $42afbcb807c8d057$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $42afbcb807c8d057$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("3CfsM", function(module, exports) {

var $4rf1u = parcelRequire("4rf1u");

var $b0kMB = parcelRequire("b0kMB");
var $2a20ea5e6a68281c$require$Buffer = $b0kMB.Buffer;

var $5IYaJ = parcelRequire("5IYaJ");
function $2a20ea5e6a68281c$var$PEMDecoder(entity) {
    $5IYaJ.call(this, entity);
    this.enc = 'pem';
}
$4rf1u($2a20ea5e6a68281c$var$PEMDecoder, $5IYaJ);
module.exports = $2a20ea5e6a68281c$var$PEMDecoder;
$2a20ea5e6a68281c$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $2a20ea5e6a68281c$require$Buffer(base64, 'base64');
    return $5IYaJ.prototype.decode.call(this, input, options);
};

});


parcelRegister("2AJG4", function(module, exports) {
var $1e326026c52ca974$var$encoders = module.exports;

$1e326026c52ca974$var$encoders.der = (parcelRequire("gzHb9"));

$1e326026c52ca974$var$encoders.pem = (parcelRequire("biCdL"));

});
parcelRegister("gzHb9", function(module, exports) {

var $4rf1u = parcelRequire("4rf1u");

var $b0kMB = parcelRequire("b0kMB");
var $c11168ab93ad7072$require$Buffer = $b0kMB.Buffer;

var $7DLsH = parcelRequire("7DLsH");
var $c11168ab93ad7072$var$base = $7DLsH.base;
// Import DER constants
var $c11168ab93ad7072$var$der = $7DLsH.constants.der;
function $c11168ab93ad7072$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $c11168ab93ad7072$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $c11168ab93ad7072$var$DEREncoder;
$c11168ab93ad7072$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $c11168ab93ad7072$var$DERNode(parent) {
    $c11168ab93ad7072$var$base.Node.call(this, 'der', parent);
}
$4rf1u($c11168ab93ad7072$var$DERNode, $c11168ab93ad7072$var$base.Node);
$c11168ab93ad7072$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $c11168ab93ad7072$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $c11168ab93ad7072$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $c11168ab93ad7072$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$c11168ab93ad7072$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $c11168ab93ad7072$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$c11168ab93ad7072$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $c11168ab93ad7072$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $c11168ab93ad7072$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$c11168ab93ad7072$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $c11168ab93ad7072$var$two(date.getFullYear()),
        $c11168ab93ad7072$var$two(date.getUTCMonth() + 1),
        $c11168ab93ad7072$var$two(date.getUTCDate()),
        $c11168ab93ad7072$var$two(date.getUTCHours()),
        $c11168ab93ad7072$var$two(date.getUTCMinutes()),
        $c11168ab93ad7072$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $c11168ab93ad7072$var$two(date.getFullYear() % 100),
        $c11168ab93ad7072$var$two(date.getUTCMonth() + 1),
        $c11168ab93ad7072$var$two(date.getUTCDate()),
        $c11168ab93ad7072$var$two(date.getUTCHours()),
        $c11168ab93ad7072$var$two(date.getUTCMinutes()),
        $c11168ab93ad7072$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$c11168ab93ad7072$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$c11168ab93ad7072$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$c11168ab93ad7072$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $c11168ab93ad7072$require$Buffer(numArray);
    }
    if ($c11168ab93ad7072$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $c11168ab93ad7072$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $c11168ab93ad7072$require$Buffer(out));
};
$c11168ab93ad7072$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$c11168ab93ad7072$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$c11168ab93ad7072$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $c11168ab93ad7072$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($c11168ab93ad7072$var$der.tagByName.hasOwnProperty(tag)) res = $c11168ab93ad7072$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $c11168ab93ad7072$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("biCdL", function(module, exports) {

var $4rf1u = parcelRequire("4rf1u");

var $gzHb9 = parcelRequire("gzHb9");
function $839f06092a9c987f$var$PEMEncoder(entity) {
    $gzHb9.call(this, entity);
    this.enc = 'pem';
}
$4rf1u($839f06092a9c987f$var$PEMEncoder, $gzHb9);
module.exports = $839f06092a9c987f$var$PEMEncoder;
$839f06092a9c987f$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $gzHb9.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("387Op", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $7DLsH = parcelRequire("7DLsH");
var $24782dc04c011044$var$Time = $7DLsH.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $24782dc04c011044$var$AttributeTypeValue = $7DLsH.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $24782dc04c011044$var$AlgorithmIdentifier = $7DLsH.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $24782dc04c011044$var$SubjectPublicKeyInfo = $7DLsH.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($24782dc04c011044$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $24782dc04c011044$var$RelativeDistinguishedName = $7DLsH.define('RelativeDistinguishedName', function() {
    this.setof($24782dc04c011044$var$AttributeTypeValue);
});
var $24782dc04c011044$var$RDNSequence = $7DLsH.define('RDNSequence', function() {
    this.seqof($24782dc04c011044$var$RelativeDistinguishedName);
});
var $24782dc04c011044$var$Name = $7DLsH.define('Name', function() {
    this.choice({
        rdnSequence: this.use($24782dc04c011044$var$RDNSequence)
    });
});
var $24782dc04c011044$var$Validity = $7DLsH.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($24782dc04c011044$var$Time), this.key('notAfter').use($24782dc04c011044$var$Time));
});
var $24782dc04c011044$var$Extension = $7DLsH.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $24782dc04c011044$var$TBSCertificate = $7DLsH.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($24782dc04c011044$var$AlgorithmIdentifier), this.key('issuer').use($24782dc04c011044$var$Name), this.key('validity').use($24782dc04c011044$var$Validity), this.key('subject').use($24782dc04c011044$var$Name), this.key('subjectPublicKeyInfo').use($24782dc04c011044$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($24782dc04c011044$var$Extension).optional());
});
var $24782dc04c011044$var$X509Certificate = $7DLsH.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($24782dc04c011044$var$TBSCertificate), this.key('signatureAlgorithm').use($24782dc04c011044$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $24782dc04c011044$var$X509Certificate;

});


parcelRegister("5jr5l", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("d6TcD", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $98b6a7ffc1220aac$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $98b6a7ffc1220aac$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $98b6a7ffc1220aac$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $9zoIs = parcelRequire("9zoIs");

var $dvlcQ = parcelRequire("dvlcQ");

var $eF2Mu = parcelRequire("eF2Mu");
var $98b6a7ffc1220aac$require$Buffer = $eF2Mu.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($98b6a7ffc1220aac$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($98b6a7ffc1220aac$var$fullRegex);
        decrypted = $98b6a7ffc1220aac$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $98b6a7ffc1220aac$require$Buffer.from(match[2], 'hex');
        var cipherText = $98b6a7ffc1220aac$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $9zoIs(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $dvlcQ.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $98b6a7ffc1220aac$require$Buffer.concat(out);
    }
    var tag = key.match($98b6a7ffc1220aac$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("eF2Mu", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0kMB = parcelRequire("b0kMB");
var $aac70d502ed01fb1$var$Buffer = $b0kMB.Buffer;
// alternative to using Object.keys for old browsers
function $aac70d502ed01fb1$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($aac70d502ed01fb1$var$Buffer.from && $aac70d502ed01fb1$var$Buffer.alloc && $aac70d502ed01fb1$var$Buffer.allocUnsafe && $aac70d502ed01fb1$var$Buffer.allocUnsafeSlow) module.exports = $b0kMB;
else {
    // Copy properties from require('buffer')
    $aac70d502ed01fb1$var$copyProps($b0kMB, module.exports);
    module.exports.Buffer = $aac70d502ed01fb1$var$SafeBuffer;
}
function $aac70d502ed01fb1$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $aac70d502ed01fb1$var$Buffer(arg, encodingOrOffset, length);
}
$aac70d502ed01fb1$var$SafeBuffer.prototype = Object.create($aac70d502ed01fb1$var$Buffer.prototype);
// Copy static methods from Buffer
$aac70d502ed01fb1$var$copyProps($aac70d502ed01fb1$var$Buffer, $aac70d502ed01fb1$var$SafeBuffer);
$aac70d502ed01fb1$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $aac70d502ed01fb1$var$Buffer(arg, encodingOrOffset, length);
};
$aac70d502ed01fb1$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $aac70d502ed01fb1$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$aac70d502ed01fb1$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $aac70d502ed01fb1$var$Buffer(size);
};
$aac70d502ed01fb1$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0kMB.SlowBuffer(size);
};

});



parcelRegister("3N9uo", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("edLK8", function(module, exports) {
'use strict';

var $4UJGx = parcelRequire("4UJGx");
var $a5a7505cc5dc13b5$require$Buffer = $4UJGx.Buffer;

var $5k44J = parcelRequire("5k44J");

var $1C5VP = parcelRequire("1C5VP");
var $a5a7505cc5dc13b5$require$EC = $1C5VP.ec;

var $j23JA = parcelRequire("j23JA");

var $3N9uo = parcelRequire("3N9uo");
function $a5a7505cc5dc13b5$var$verify(sig, hash, key, signType, tag) {
    var pub = $j23JA(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $a5a7505cc5dc13b5$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $a5a7505cc5dc13b5$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $a5a7505cc5dc13b5$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $a5a7505cc5dc13b5$require$Buffer.from(pad);
    var red = $5k44J.mont(pub.modulus);
    sig = new $5k44J(sig).toRed(red);
    sig = sig.redPow(new $5k44J(pub.publicExponent));
    sig = $a5a7505cc5dc13b5$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $a5a7505cc5dc13b5$var$ecVerify(sig, hash, pub) {
    var curveId = $3N9uo[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $a5a7505cc5dc13b5$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $a5a7505cc5dc13b5$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $j23JA.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $a5a7505cc5dc13b5$var$checkValue(s, q);
    $a5a7505cc5dc13b5$var$checkValue(r, q);
    var montp = $5k44J.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $5k44J(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $a5a7505cc5dc13b5$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $a5a7505cc5dc13b5$var$verify;

});


parcelRegister("87sXO", function(module, exports) {

var $b0kMB = parcelRequire("b0kMB");
var $5e9571c1fadced8e$require$Buffer = $b0kMB.Buffer;

var $1C5VP = parcelRequire("1C5VP");

var $8XPF2 = parcelRequire("8XPF2");
module.exports = function createECDH(curve) {
    return new $5e9571c1fadced8e$var$ECDH(curve);
};
var $5e9571c1fadced8e$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$5e9571c1fadced8e$var$aliases.p224 = $5e9571c1fadced8e$var$aliases.secp224r1;
$5e9571c1fadced8e$var$aliases.p256 = $5e9571c1fadced8e$var$aliases.secp256r1 = $5e9571c1fadced8e$var$aliases.prime256v1;
$5e9571c1fadced8e$var$aliases.p192 = $5e9571c1fadced8e$var$aliases.secp192r1 = $5e9571c1fadced8e$var$aliases.prime192v1;
$5e9571c1fadced8e$var$aliases.p384 = $5e9571c1fadced8e$var$aliases.secp384r1;
$5e9571c1fadced8e$var$aliases.p521 = $5e9571c1fadced8e$var$aliases.secp521r1;
function $5e9571c1fadced8e$var$ECDH(curve) {
    this.curveType = $5e9571c1fadced8e$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1C5VP.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$5e9571c1fadced8e$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$5e9571c1fadced8e$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$5e9571c1fadced8e$require$Buffer.isBuffer(other)) other = new $5e9571c1fadced8e$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $5e9571c1fadced8e$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$5e9571c1fadced8e$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $5e9571c1fadced8e$var$formatReturnValue(key, enc);
};
$5e9571c1fadced8e$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $5e9571c1fadced8e$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$5e9571c1fadced8e$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$5e9571c1fadced8e$require$Buffer.isBuffer(pub)) pub = new $5e9571c1fadced8e$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$5e9571c1fadced8e$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$5e9571c1fadced8e$require$Buffer.isBuffer(priv)) priv = new $5e9571c1fadced8e$require$Buffer(priv, enc);
    var _priv = new $8XPF2(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $5e9571c1fadced8e$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $5e9571c1fadced8e$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $5e9571c1fadced8e$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $5e9571c1fadced8e$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("8XPF2", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("80bNa")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("IHdXk", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $0865a3948fb806f9$export$512823e338ddb1b7; }, function (v) { return $0865a3948fb806f9$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $0865a3948fb806f9$export$7efb24e2fddf99b9; }, function (v) { return $0865a3948fb806f9$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $0865a3948fb806f9$export$9d0e0c0c4a8d30f3; }, function (v) { return $0865a3948fb806f9$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $0865a3948fb806f9$export$b9d55ff329113abd; }, function (v) { return $0865a3948fb806f9$export$b9d55ff329113abd = v; });
var $0865a3948fb806f9$export$512823e338ddb1b7;
var $0865a3948fb806f9$export$7efb24e2fddf99b9;
var $0865a3948fb806f9$export$9d0e0c0c4a8d30f3;
var $0865a3948fb806f9$export$b9d55ff329113abd;

$0865a3948fb806f9$export$512823e338ddb1b7 = (parcelRequire("hvZC2"));

$0865a3948fb806f9$export$7efb24e2fddf99b9 = (parcelRequire("4gF4F"));
$0865a3948fb806f9$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $0865a3948fb806f9$export$512823e338ddb1b7(key, buf, true);
};
$0865a3948fb806f9$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $0865a3948fb806f9$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("hvZC2", function(module, exports) {

var $j23JA = parcelRequire("j23JA");

var $a0Pw9 = parcelRequire("a0Pw9");

var $5GOyq = parcelRequire("5GOyq");

var $4FXYA = parcelRequire("4FXYA");

var $72cn1 = parcelRequire("72cn1");

var $jNVQx = parcelRequire("jNVQx");

var $XT851 = parcelRequire("XT851");

var $h8SKC = parcelRequire("h8SKC");

var $fF8dn = parcelRequire("fF8dn");
var $cc051fe571d870c5$require$Buffer = $fF8dn.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $j23JA(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $cc051fe571d870c5$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $cc051fe571d870c5$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $jNVQx(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $h8SKC(paddedMsg, key);
    else return $XT851(paddedMsg, key);
};
function $cc051fe571d870c5$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $5GOyq('sha1').update($cc051fe571d870c5$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $cc051fe571d870c5$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $a0Pw9(hLen);
    var maskedDb = $72cn1($cc051fe571d870c5$require$Buffer.concat([
        iHash,
        ps,
        $cc051fe571d870c5$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $4FXYA(seed, dblen));
    var maskedSeed = $72cn1(seed, $4FXYA(maskedDb, hLen));
    return new $jNVQx($cc051fe571d870c5$require$Buffer.concat([
        $cc051fe571d870c5$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $cc051fe571d870c5$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $cc051fe571d870c5$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $cc051fe571d870c5$var$nonZero(k - mLen - 3);
    return new $jNVQx($cc051fe571d870c5$require$Buffer.concat([
        $cc051fe571d870c5$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $cc051fe571d870c5$require$Buffer.alloc(1),
        msg
    ], k));
}
function $cc051fe571d870c5$var$nonZero(len) {
    var out = $cc051fe571d870c5$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $a0Pw9(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $a0Pw9(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("4FXYA", function(module, exports) {

var $5GOyq = parcelRequire("5GOyq");

var $fF8dn = parcelRequire("fF8dn");
var $367983c24b290bd5$require$Buffer = $fF8dn.Buffer;
module.exports = function(seed, len) {
    var t = $367983c24b290bd5$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $367983c24b290bd5$var$i2ops(i++);
        t = $367983c24b290bd5$require$Buffer.concat([
            t,
            $5GOyq('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $367983c24b290bd5$var$i2ops(c) {
    var out = $367983c24b290bd5$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("72cn1", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("jNVQx", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("80bNa")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("XT851", function(module, exports) {

var $jNVQx = parcelRequire("jNVQx");

var $fF8dn = parcelRequire("fF8dn");
var $0b4046569412a8ef$require$Buffer = $fF8dn.Buffer;
function $0b4046569412a8ef$var$withPublic(paddedMsg, key) {
    return $0b4046569412a8ef$require$Buffer.from(paddedMsg.toRed($jNVQx.mont(key.modulus)).redPow(new $jNVQx(key.publicExponent)).fromRed().toArray());
}
module.exports = $0b4046569412a8ef$var$withPublic;

});


parcelRegister("4gF4F", function(module, exports) {

var $j23JA = parcelRequire("j23JA");

var $4FXYA = parcelRequire("4FXYA");

var $72cn1 = parcelRequire("72cn1");

var $jNVQx = parcelRequire("jNVQx");

var $h8SKC = parcelRequire("h8SKC");

var $5GOyq = parcelRequire("5GOyq");

var $XT851 = parcelRequire("XT851");

var $fF8dn = parcelRequire("fF8dn");
var $31b88488a0e53e39$require$Buffer = $fF8dn.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $j23JA(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $jNVQx(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $XT851(new $jNVQx(enc), key);
    else msg = $h8SKC(enc, key);
    var zBuffer = $31b88488a0e53e39$require$Buffer.alloc(k - msg.length);
    msg = $31b88488a0e53e39$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $31b88488a0e53e39$var$oaep(key, msg);
    else if (padding === 1) return $31b88488a0e53e39$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $31b88488a0e53e39$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $5GOyq('sha1').update($31b88488a0e53e39$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $72cn1(maskedSeed, $4FXYA(maskedDb, hLen));
    var db = $72cn1(maskedDb, $4FXYA(seed, k - hLen - 1));
    if ($31b88488a0e53e39$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $31b88488a0e53e39$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $31b88488a0e53e39$var$compare(a, b) {
    a = $31b88488a0e53e39$require$Buffer.from(a);
    b = $31b88488a0e53e39$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("kimef", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $ec66bb462bf2017e$export$bb1abf2ce84fc7e8; }, function (v) { return $ec66bb462bf2017e$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $ec66bb462bf2017e$export$2f7171e78e524d5e; }, function (v) { return $ec66bb462bf2017e$export$2f7171e78e524d5e = v; });
var $ec66bb462bf2017e$export$bb1abf2ce84fc7e8;
var $ec66bb462bf2017e$export$2f7171e78e524d5e;

var $j1eoE = parcelRequire("j1eoE");
'use strict';
function $ec66bb462bf2017e$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $fF8dn = parcelRequire("fF8dn");

var $a0Pw9 = parcelRequire("a0Pw9");
var $ec66bb462bf2017e$var$Buffer = $fF8dn.Buffer;
var $ec66bb462bf2017e$var$kBufferMaxLength = $fF8dn.kMaxLength;
var $ec66bb462bf2017e$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $ec66bb462bf2017e$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $ec66bb462bf2017e$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $ec66bb462bf2017e$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $ec66bb462bf2017e$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $ec66bb462bf2017e$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $ec66bb462bf2017e$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $ec66bb462bf2017e$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($ec66bb462bf2017e$var$crypto && $ec66bb462bf2017e$var$crypto.getRandomValues || false) {
    $ec66bb462bf2017e$export$bb1abf2ce84fc7e8 = $ec66bb462bf2017e$var$randomFill;
    $ec66bb462bf2017e$export$2f7171e78e524d5e = $ec66bb462bf2017e$var$randomFillSync;
} else {
    $ec66bb462bf2017e$export$bb1abf2ce84fc7e8 = $ec66bb462bf2017e$var$oldBrowser;
    $ec66bb462bf2017e$export$2f7171e78e524d5e = $ec66bb462bf2017e$var$oldBrowser;
}
function $ec66bb462bf2017e$var$randomFill(buf, offset, size, cb) {
    if (!$ec66bb462bf2017e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $ec66bb462bf2017e$var$assertOffset(offset, buf.length);
    $ec66bb462bf2017e$var$assertSize(size, offset, buf.length);
    return $ec66bb462bf2017e$var$actualFill(buf, offset, size, cb);
}
function $ec66bb462bf2017e$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $ec66bb462bf2017e$var$crypto.getRandomValues(uint);
    if (cb) {
        $j1eoE.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $a0Pw9(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $a0Pw9(size);
    bytes.copy(buf, offset);
    return buf;
}
function $ec66bb462bf2017e$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$ec66bb462bf2017e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $ec66bb462bf2017e$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $ec66bb462bf2017e$var$assertSize(size, offset, buf.length);
    return $ec66bb462bf2017e$var$actualFill(buf, offset, size);
}

});




parcelRegister("fsofG", function(module, exports) {

$parcel$export(module.exports, "ObservableArray", function () { return $97cde0d1c72eee9a$export$2b76b04f92326cd; });

var $3Ersk = parcelRequire("3Ersk");
class $97cde0d1c72eee9a$export$2b76b04f92326cd extends (0, $3Ersk.Observable) {
    replace(value, comparator) {
        const array = [
            ...this.get()
        ];
        const index = array.findIndex((item)=>comparator(item));
        if (index !== -1) array[index] = value;
        this.set(array);
    }
}

});


parcelRegister("jYJVu", function(module, exports) {

$parcel$export(module.exports, "WebGenerateAccountStatementService", function () { return $a3651144e5c99f0b$export$2069266290c02c5a; });

var $l1qT9 = parcelRequire("l1qT9");

var $cNsCW = parcelRequire("cNsCW");

var $4Zze3 = parcelRequire("4Zze3");
class $a3651144e5c99f0b$export$2069266290c02c5a {
    constructor(connectedServiceDomainApiService){
        this.connectedServiceDomainApiService = connectedServiceDomainApiService;
    }
    async downloadGenerateAccountStatement(accountId, startDate, endDate) {
        try {
            const result = await this.connectedServiceDomainApiService.instance.get(`/accounts/${accountId}/statements/generate`, {
                params: {
                    startDate: (0, $cNsCW.makeUtcDate)(new Date(startDate)),
                    endDate: (0, $cNsCW.makeUtcDate)(new Date(endDate))
                },
                responseType: "arraybuffer"
            });
            const formattedStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate).format("YYYYMMDD");
            const formattedEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate).format("YYYYMMDD");
            const filename = `statement_${accountId}_${formattedStartDate}_${formattedEndDate}.pdf`;
            await (0, $4Zze3.downloadFile)(filename, result.data, "application/pdf");
            return filename;
        } catch (error) {
            console.error("Failed to generate statement:", {
                accountId: accountId,
                startDate: startDate,
                endDate: endDate,
                error: error.response?.data || error.message || error
            });
            throw new Error("Failed to generate statement.");
        }
    }
}

});
parcelRegister("cNsCW", function(module, exports) {

$parcel$export(module.exports, "getLocaleDateFromUtcDateString", function () { return $03aae90e35d6c606$export$2de4ede4c7ea982b; });
$parcel$export(module.exports, "makeUtcDate", function () { return $03aae90e35d6c606$export$e2873a9415ab1f96; });
$parcel$export(module.exports, "arrangeDates", function () { return $03aae90e35d6c606$export$fa19ecaa4351cf6b; });

var $l1qT9 = parcelRequire("l1qT9");
const $03aae90e35d6c606$export$2de4ede4c7ea982b = (utcIsoDate)=>(0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(utcIsoDate).toDate();
const $03aae90e35d6c606$export$e4903f1b03cda9f8 = (utcIsoDate)=>{
    const localeDate = new Date(utcIsoDate);
    localeDate.setFullYear(utcIsoDate.getUTCFullYear(), utcIsoDate.getUTCMonth(), utcIsoDate.getUTCDate());
    localeDate.setHours(0, 0, 0, 0);
    return localeDate;
};
const $03aae90e35d6c606$export$31af136e131d0533 = (localeDate)=>{
    const utcIsoDate = new Date(localeDate);
    utcIsoDate.setUTCFullYear(localeDate.getFullYear(), localeDate.getMonth(), localeDate.getDate());
    utcIsoDate.setUTCHours(0, 0, 0, 0);
    return localeDate;
};
const $03aae90e35d6c606$export$e2873a9415ab1f96 = (date)=>{
    const transformedUtcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    return transformedUtcDate;
};
const $03aae90e35d6c606$export$fa19ecaa4351cf6b = (startDate, endDate, preserveDayTimings)=>{
    let selectedStartDate = preserveDayTimings ? startDate : (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate).startOf("day").toDate();
    let selectedEndDate = preserveDayTimings ? endDate : (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate).endOf("day").toDate();
    if (startDate > endDate) {
        selectedStartDate = preserveDayTimings ? endDate : (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate).startOf("day").toDate();
        selectedEndDate = preserveDayTimings ? startDate : (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate).endOf("day").toDate();
    }
    return {
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate
    };
};

});


parcelRegister("60oeT", function(module, exports) {

$parcel$export(module.exports, "TrustManager", function () { return $a676d2fcd185bda7$export$64434dc6545256be; });

var $kpnq8 = parcelRequire("kpnq8");

var $l1qT9 = parcelRequire("l1qT9");

var $6JVVB = parcelRequire("6JVVB");
var $a676d2fcd185bda7$export$9cc5ac9aa6e1cb17 = /*#__PURE__*/ function(TrustStatus) {
    TrustStatus[TrustStatus["Trusted"] = 0] = "Trusted";
    TrustStatus[TrustStatus["Untrusted"] = 1] = "Untrusted";
    TrustStatus[TrustStatus["Unknown"] = 2] = "Unknown";
    return TrustStatus;
}({});
const $a676d2fcd185bda7$var$TRUST_KEY = "trust";
class $a676d2fcd185bda7$export$64434dc6545256be {
    constructor(cache){
        this.cache = cache;
        this.trust = null;
        this.onRemoveState = new (0, $kpnq8.Signal)();
    }
    async isValid() {
        await this.updateTrust();
        const result = this.dateIsValid();
        return result;
    }
    async checkTrusted() {
        await this.updateTrust();
        const isTrusted = this.trust?.status === 0;
        if (!isTrusted) this.onRemoveState.dispatch(null);
    }
    setUnknown() {
        this.onRemoveState.dispatch(null);
        if (this.trust) {
            this.trust.status = 2;
            this.updateNextDate();
            this.save();
        }
    }
    setTrust(nbDays) {
        if (this.trust) {
            this.trust.status = 0;
            this.updateNextDate(nbDays);
            this.save();
        }
    }
    setUntrust(nbDays) {
        this.onRemoveState.dispatch(null);
        if (this.trust) {
            this.trust.status = 1;
            this.updateNextDate(nbDays);
            this.save();
        }
    }
    async updateTrust() {
        const restoredTrust = await this.restore();
        if (restoredTrust) this.trust = restoredTrust;
        else this.trust = {
            validUntil: new Date(),
            status: 2
        };
    }
    save() {
        if (this.trust) try {
            this.cache.store(this.trust, $a676d2fcd185bda7$var$TRUST_KEY);
        } catch (e) {
            (0, $6JVVB.logger).debug("Trust Manager", "Failed to save trust ", e);
        }
    }
    async restore() {
        try {
            return await this.cache.read($a676d2fcd185bda7$var$TRUST_KEY);
        } catch (e) {
            (0, $6JVVB.logger).debug("Trust Manager", "Failed to restore trust ", e);
            return Promise.resolve(null);
        }
    }
    updateNextDate(nbDays = 1) {
        if (this.trust) {
            const nextValidDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(this.trust.validUntil).add(nbDays, "days");
            this.trust.validUntil = new Date(nextValidDate.get("year"), nextValidDate.get("month"), nextValidDate.get("date"));
        }
    }
    dateIsValid() {
        const today = new Date();
        return (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(this.trust?.validUntil).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(today));
    }
}

});

parcelRegister("kIm2v", function(module, exports) {

$parcel$export(module.exports, "WebImagesConverter", function () { return $dea618108aa45153$export$f9d65608119a91fa; });

var $jGp7U = parcelRequire("jGp7U");

var $6JVVB = parcelRequire("6JVVB");
const $dea618108aa45153$var$A4_PAPER_DIMENSIONS = {
    width: 210,
    height: 297
};
const $dea618108aa45153$var$A4_PAPER_RATIO = $dea618108aa45153$var$A4_PAPER_DIMENSIONS.width / $dea618108aa45153$var$A4_PAPER_DIMENSIONS.height;
// Calculates the best possible position of an image on the A4 paper format,
// so that the maximal area of A4 is used and the image ratio is preserved.
const $dea618108aa45153$var$imageDimensionsOnA4 = (dimensions)=>{
    const isLandscapeImage = dimensions.width >= dimensions.height;
    // If the image is in landscape, the full width of A4 is used.
    if (isLandscapeImage) return {
        width: $dea618108aa45153$var$A4_PAPER_DIMENSIONS.width * 0.9,
        height: $dea618108aa45153$var$A4_PAPER_DIMENSIONS.width * 0.9 / (dimensions.width / dimensions.height)
    };
    // If the image is in portrait and the full height of A4 would skew
    // the image ratio, we scale the image dimensions.
    const imageRatio = dimensions.width / dimensions.height;
    if (imageRatio > $dea618108aa45153$var$A4_PAPER_RATIO) {
        const imageScaleFactor = $dea618108aa45153$var$A4_PAPER_RATIO * dimensions.height / dimensions.width * 0.9;
        const scaledImageHeight = $dea618108aa45153$var$A4_PAPER_DIMENSIONS.height * imageScaleFactor;
        return {
            height: scaledImageHeight,
            width: scaledImageHeight * imageRatio
        };
    }
    // The full height of A4 can be used without skewing the image ratio.
    return {
        width: $dea618108aa45153$var$A4_PAPER_DIMENSIONS.height / (dimensions.height / dimensions.width),
        height: $dea618108aa45153$var$A4_PAPER_DIMENSIONS.height
    };
};
class $dea618108aa45153$export$f9d65608119a91fa {
    constructor(){
        this.toPdf = async (images)=>{
            try {
                const doc = new (0, $jGp7U.jsPDF)();
                // We let the images add all pages,
                // therefore the first default page can be removed.
                doc.deletePage(1);
                images.forEach((image)=>{
                    const webImage = image;
                    const imageDimensions = $dea618108aa45153$var$imageDimensionsOnA4({
                        width: webImage.width,
                        height: webImage.height
                    });
                    doc.addPage();
                    doc.addImage(webImage.base64, "JPEG", // Images are vertically and horizontally centered on the page.
                    ($dea618108aa45153$var$A4_PAPER_DIMENSIONS.width - imageDimensions.width) / 2, ($dea618108aa45153$var$A4_PAPER_DIMENSIONS.height - imageDimensions.height) / 2, imageDimensions.width, imageDimensions.height, undefined, "FAST");
                });
                // Creates a PDF
                const pdf = doc.output();
                return pdf.toString();
            } catch (e) {
                // Raised, not swallowed: a caller handed an empty value to the form and nobody was told.
                (0, $6JVVB.logger).debug("toPDF " + e);
                throw e;
            }
        };
        this.toBase64 = async (binaryData)=>{
            const base64 = btoa(binaryData);
            return Promise.resolve(base64);
        };
        this.fileIntoBase64 = async (file)=>new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = (error)=>reject(error);
            });
    }
}

});
parcelRegister("jGp7U", function(module, exports) {

$parcel$export(module.exports, "jsPDF", function () { return $e5456e2f96ba3898$export$2e2bcd8739ae039; });
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 3.0.3 Built on 2025-09-18T08:03:54.261Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2025 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2025 yWorks GmbH, http://www.yworks.com
 *               2015-2025 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ 
var $alU2v = parcelRequire("alU2v");

var $gCcZP = parcelRequire("gCcZP");

var $dgEZh = parcelRequire("dgEZh");

var $jyQYM = parcelRequire("jyQYM");
var $e5456e2f96ba3898$var$i = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $e5456e2f96ba3898$var$a() {
    $e5456e2f96ba3898$var$i.console && "function" == typeof $e5456e2f96ba3898$var$i.console.log && $e5456e2f96ba3898$var$i.console.log.apply($e5456e2f96ba3898$var$i.console, arguments);
}
var $e5456e2f96ba3898$var$o = {
    log: $e5456e2f96ba3898$var$a,
    warn: function(t) {
        $e5456e2f96ba3898$var$i.console && ("function" == typeof $e5456e2f96ba3898$var$i.console.warn ? $e5456e2f96ba3898$var$i.console.warn.apply($e5456e2f96ba3898$var$i.console, arguments) : $e5456e2f96ba3898$var$a.call(null, arguments));
    },
    error: function(t) {
        $e5456e2f96ba3898$var$i.console && ("function" == typeof $e5456e2f96ba3898$var$i.console.error ? $e5456e2f96ba3898$var$i.console.error.apply($e5456e2f96ba3898$var$i.console, arguments) : $e5456e2f96ba3898$var$a(t));
    }
};
function $e5456e2f96ba3898$var$s(t, e, n) {
    var r = new XMLHttpRequest;
    r.open("GET", t), r.responseType = "blob", r.onload = function() {
        $e5456e2f96ba3898$var$l(r.response, e, n);
    }, r.onerror = function() {
        $e5456e2f96ba3898$var$o.error("could not download file");
    }, r.send();
}
function $e5456e2f96ba3898$var$u(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (n) {}
    return e.status >= 200 && e.status <= 299;
}
function $e5456e2f96ba3898$var$c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (n) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $e5456e2f96ba3898$var$l = $e5456e2f96ba3898$var$i.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(window)) || window !== $e5456e2f96ba3898$var$i ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, n) {
    var r = $e5456e2f96ba3898$var$i.URL || $e5456e2f96ba3898$var$i.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? $e5456e2f96ba3898$var$u(a.href) ? $e5456e2f96ba3898$var$s(t, e, n) : $e5456e2f96ba3898$var$c(a, a.target = "_blank") : $e5456e2f96ba3898$var$c(a)) : (a.href = r.createObjectURL(t), setTimeout(function() {
        r.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        $e5456e2f96ba3898$var$c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, n, r) {
    if (n = n || e.name || "download", "string" == typeof e) {
        if ($e5456e2f96ba3898$var$u(e)) $e5456e2f96ba3898$var$s(e, n, r);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                $e5456e2f96ba3898$var$c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, n) {
        return void 0 === n ? n = {
            autoBom: !1
        } : "object" !== (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(n) && ($e5456e2f96ba3898$var$o.warn("Deprecated: Expected third argument to be a object"), n = {
            autoBom: !n
        }), n.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, r), n);
} : function(e, n, r, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $e5456e2f96ba3898$var$s(e, n, r);
    var o = "application/octet-stream" === e.type, u = /constructor/i.test($e5456e2f96ba3898$var$i.HTMLElement) || $e5456e2f96ba3898$var$i.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((c || o && u) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(FileReader))) {
        var l = new FileReader;
        l.onloadend = function() {
            var t = l.result;
            t = c ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, l.readAsDataURL(e);
    } else {
        var h = $e5456e2f96ba3898$var$i.URL || $e5456e2f96ba3898$var$i.webkitURL, f = h.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            h.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $e5456e2f96ba3898$var$h(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var n = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], r = 0; r < n.length; r++){
        var i = n[r].re, a = n[r].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
    };
}
var $e5456e2f96ba3898$var$f = $e5456e2f96ba3898$var$i.atob.bind($e5456e2f96ba3898$var$i), $e5456e2f96ba3898$var$d = $e5456e2f96ba3898$var$i.btoa.bind($e5456e2f96ba3898$var$i);
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function $e5456e2f96ba3898$var$p(t, e) {
    var n = t[0], r = t[1], i = t[2], a = t[3];
    n = $e5456e2f96ba3898$var$m(n, r, i, a, e[0], 7, -680876936), a = $e5456e2f96ba3898$var$m(a, n, r, i, e[1], 12, -389564586), i = $e5456e2f96ba3898$var$m(i, a, n, r, e[2], 17, 606105819), r = $e5456e2f96ba3898$var$m(r, i, a, n, e[3], 22, -1044525330), n = $e5456e2f96ba3898$var$m(n, r, i, a, e[4], 7, -176418897), a = $e5456e2f96ba3898$var$m(a, n, r, i, e[5], 12, 1200080426), i = $e5456e2f96ba3898$var$m(i, a, n, r, e[6], 17, -1473231341), r = $e5456e2f96ba3898$var$m(r, i, a, n, e[7], 22, -45705983), n = $e5456e2f96ba3898$var$m(n, r, i, a, e[8], 7, 1770035416), a = $e5456e2f96ba3898$var$m(a, n, r, i, e[9], 12, -1958414417), i = $e5456e2f96ba3898$var$m(i, a, n, r, e[10], 17, -42063), r = $e5456e2f96ba3898$var$m(r, i, a, n, e[11], 22, -1990404162), n = $e5456e2f96ba3898$var$m(n, r, i, a, e[12], 7, 1804603682), a = $e5456e2f96ba3898$var$m(a, n, r, i, e[13], 12, -40341101), i = $e5456e2f96ba3898$var$m(i, a, n, r, e[14], 17, -1502002290), n = $e5456e2f96ba3898$var$v(n, r = $e5456e2f96ba3898$var$m(r, i, a, n, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = $e5456e2f96ba3898$var$v(a, n, r, i, e[6], 9, -1069501632), i = $e5456e2f96ba3898$var$v(i, a, n, r, e[11], 14, 643717713), r = $e5456e2f96ba3898$var$v(r, i, a, n, e[0], 20, -373897302), n = $e5456e2f96ba3898$var$v(n, r, i, a, e[5], 5, -701558691), a = $e5456e2f96ba3898$var$v(a, n, r, i, e[10], 9, 38016083), i = $e5456e2f96ba3898$var$v(i, a, n, r, e[15], 14, -660478335), r = $e5456e2f96ba3898$var$v(r, i, a, n, e[4], 20, -405537848), n = $e5456e2f96ba3898$var$v(n, r, i, a, e[9], 5, 568446438), a = $e5456e2f96ba3898$var$v(a, n, r, i, e[14], 9, -1019803690), i = $e5456e2f96ba3898$var$v(i, a, n, r, e[3], 14, -187363961), r = $e5456e2f96ba3898$var$v(r, i, a, n, e[8], 20, 1163531501), n = $e5456e2f96ba3898$var$v(n, r, i, a, e[13], 5, -1444681467), a = $e5456e2f96ba3898$var$v(a, n, r, i, e[2], 9, -51403784), i = $e5456e2f96ba3898$var$v(i, a, n, r, e[7], 14, 1735328473), n = $e5456e2f96ba3898$var$b(n, r = $e5456e2f96ba3898$var$v(r, i, a, n, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = $e5456e2f96ba3898$var$b(a, n, r, i, e[8], 11, -2022574463), i = $e5456e2f96ba3898$var$b(i, a, n, r, e[11], 16, 1839030562), r = $e5456e2f96ba3898$var$b(r, i, a, n, e[14], 23, -35309556), n = $e5456e2f96ba3898$var$b(n, r, i, a, e[1], 4, -1530992060), a = $e5456e2f96ba3898$var$b(a, n, r, i, e[4], 11, 1272893353), i = $e5456e2f96ba3898$var$b(i, a, n, r, e[7], 16, -155497632), r = $e5456e2f96ba3898$var$b(r, i, a, n, e[10], 23, -1094730640), n = $e5456e2f96ba3898$var$b(n, r, i, a, e[13], 4, 681279174), a = $e5456e2f96ba3898$var$b(a, n, r, i, e[0], 11, -358537222), i = $e5456e2f96ba3898$var$b(i, a, n, r, e[3], 16, -722521979), r = $e5456e2f96ba3898$var$b(r, i, a, n, e[6], 23, 76029189), n = $e5456e2f96ba3898$var$b(n, r, i, a, e[9], 4, -640364487), a = $e5456e2f96ba3898$var$b(a, n, r, i, e[12], 11, -421815835), i = $e5456e2f96ba3898$var$b(i, a, n, r, e[15], 16, 530742520), n = $e5456e2f96ba3898$var$y(n, r = $e5456e2f96ba3898$var$b(r, i, a, n, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = $e5456e2f96ba3898$var$y(a, n, r, i, e[7], 10, 1126891415), i = $e5456e2f96ba3898$var$y(i, a, n, r, e[14], 15, -1416354905), r = $e5456e2f96ba3898$var$y(r, i, a, n, e[5], 21, -57434055), n = $e5456e2f96ba3898$var$y(n, r, i, a, e[12], 6, 1700485571), a = $e5456e2f96ba3898$var$y(a, n, r, i, e[3], 10, -1894986606), i = $e5456e2f96ba3898$var$y(i, a, n, r, e[10], 15, -1051523), r = $e5456e2f96ba3898$var$y(r, i, a, n, e[1], 21, -2054922799), n = $e5456e2f96ba3898$var$y(n, r, i, a, e[8], 6, 1873313359), a = $e5456e2f96ba3898$var$y(a, n, r, i, e[15], 10, -30611744), i = $e5456e2f96ba3898$var$y(i, a, n, r, e[6], 15, -1560198380), r = $e5456e2f96ba3898$var$y(r, i, a, n, e[13], 21, 1309151649), n = $e5456e2f96ba3898$var$y(n, r, i, a, e[4], 6, -145523070), a = $e5456e2f96ba3898$var$y(a, n, r, i, e[11], 10, -1120210379), i = $e5456e2f96ba3898$var$y(i, a, n, r, e[2], 15, 718787259), r = $e5456e2f96ba3898$var$y(r, i, a, n, e[9], 21, -343485551), t[0] = $e5456e2f96ba3898$var$P(n, t[0]), t[1] = $e5456e2f96ba3898$var$P(r, t[1]), t[2] = $e5456e2f96ba3898$var$P(i, t[2]), t[3] = $e5456e2f96ba3898$var$P(a, t[3]);
}
function $e5456e2f96ba3898$var$g(t, e, n, r, i, a) {
    return e = $e5456e2f96ba3898$var$P($e5456e2f96ba3898$var$P(e, t), $e5456e2f96ba3898$var$P(r, a)), $e5456e2f96ba3898$var$P(e << i | e >>> 32 - i, n);
}
function $e5456e2f96ba3898$var$m(t, e, n, r, i, a, o) {
    return $e5456e2f96ba3898$var$g(e & n | ~e & r, t, e, i, a, o);
}
function $e5456e2f96ba3898$var$v(t, e, n, r, i, a, o) {
    return $e5456e2f96ba3898$var$g(e & r | n & ~r, t, e, i, a, o);
}
function $e5456e2f96ba3898$var$b(t, e, n, r, i, a, o) {
    return $e5456e2f96ba3898$var$g(e ^ n ^ r, t, e, i, a, o);
}
function $e5456e2f96ba3898$var$y(t, e, n, r, i, a, o) {
    return $e5456e2f96ba3898$var$g(n ^ (e | ~r), t, e, i, a, o);
}
function $e5456e2f96ba3898$var$w(t) {
    var e, n = t.length, r = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)$e5456e2f96ba3898$var$p(r, $e5456e2f96ba3898$var$N(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for($e5456e2f96ba3898$var$p(r, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * n, $e5456e2f96ba3898$var$p(r, i), r;
}
function $e5456e2f96ba3898$var$N(t) {
    var e, n = [];
    for(e = 0; e < 64; e += 4)n[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return n;
}
var $e5456e2f96ba3898$var$L = "0123456789abcdef".split("");
function $e5456e2f96ba3898$var$x(t) {
    for(var e = "", n = 0; n < 4; n++)e += $e5456e2f96ba3898$var$L[t >> 8 * n + 4 & 15] + $e5456e2f96ba3898$var$L[t >> 8 * n & 15];
    return e;
}
function $e5456e2f96ba3898$var$A(t) {
    return String.fromCharCode(255 & t, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function $e5456e2f96ba3898$var$S(t) {
    return $e5456e2f96ba3898$var$w(t).map($e5456e2f96ba3898$var$A).join("");
}
var $e5456e2f96ba3898$var$_ = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = $e5456e2f96ba3898$var$x(t[e]);
    return t.join("");
}($e5456e2f96ba3898$var$w("hello"));
function $e5456e2f96ba3898$var$P(t, e) {
    if ($e5456e2f96ba3898$var$_) {
        var n = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function $e5456e2f96ba3898$var$k(t, e) {
    var n, r, i, a;
    if (t !== n) {
        for(var o = (i = t, a = 1 + (256 / t.length | 0), new Array(a + 1).join(i)), s = [], u = 0; u < 256; u++)s[u] = u;
        var c = 0;
        for(u = 0; u < 256; u++){
            var l = s[u];
            c = (c + l + o.charCodeAt(u)) % 256, s[u] = s[c], s[c] = l;
        }
        n = t, r = s;
    } else s = r;
    var h = e.length, f = 0, d = 0, p = "";
    for(u = 0; u < h; u++)d = (d + (l = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = l, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(u) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var $e5456e2f96ba3898$var$F = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function $e5456e2f96ba3898$var$I(t, e, n, r) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== $e5456e2f96ba3898$var$F.perm) throw new Error("Invalid permission: " + t);
        i += $e5456e2f96ba3898$var$F[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (n + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = $e5456e2f96ba3898$var$S(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = $e5456e2f96ba3898$var$k(this.encryptionKey, this.padding);
}
function $e5456e2f96ba3898$var$j(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", n = t.length, r = 0; r < n; r++){
        var i = t.charCodeAt(r);
        e += i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126 ? "#" + ("0" + i.toString(16)).slice(-2) : t[r];
    }
    return e;
}
function $e5456e2f96ba3898$var$C(e) {
    if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var n = {};
    this.subscribe = function(t, e, r) {
        if (r = r || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof r) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        n.hasOwnProperty(t) || (n[t] = {});
        var i = Math.random().toString(35);
        return n[t][i] = [
            e,
            !!r
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in n)if (n[e][t]) return delete n[e][t], 0 === Object.keys(n[e]).length && delete n[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (n.hasOwnProperty(t)) {
            var r = Array.prototype.slice.call(arguments, 1), a = [];
            for(var s in n[t]){
                var u = n[t][s];
                try {
                    u[0].apply(e, r);
                } catch (c) {
                    $e5456e2f96ba3898$var$i.console && $e5456e2f96ba3898$var$o.error("jsPDF PubSub Error", c.message, c);
                }
                u[1] && a.push(s);
            }
            a.length && a.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return n;
    };
}
function $e5456e2f96ba3898$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $e5456e2f96ba3898$export$1bc649ab427a02ba)) return new $e5456e2f96ba3898$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var n in t)t.hasOwnProperty(n) && e.indexOf(n) >= 0 && (this[n] = t[n]);
    this.id = "", this.objectNumber = -1;
}
function $e5456e2f96ba3898$var$B(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $e5456e2f96ba3898$export$7235f0ad083cb4c6(t, e, n, r, i) {
    if (!(this instanceof $e5456e2f96ba3898$export$7235f0ad083cb4c6)) return new $e5456e2f96ba3898$export$7235f0ad083cb4c6(t, e, n, r, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = n, $e5456e2f96ba3898$var$B.call(this, r, i);
}
function $e5456e2f96ba3898$export$549f717800d2b57f(t, e, n, r, i) {
    if (!(this instanceof $e5456e2f96ba3898$export$549f717800d2b57f)) return new $e5456e2f96ba3898$export$549f717800d2b57f(t, e, n, r, i);
    this.boundingBox = t, this.xStep = e, this.yStep = n, this.stream = "", this.cloneIndex = 0, $e5456e2f96ba3898$var$B.call(this, r, i);
}
function $e5456e2f96ba3898$export$2e2bcd8739ae039(e) {
    var n, r = "string" == typeof arguments[0] ? arguments[0] : "p", a = arguments[1], s = arguments[2], u = arguments[3], c = [], f = 1, p = 16, g = "S", m = null;
    "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e = e || {}) && (r = e.orientation, a = e.unit || a, s = e.format || s, u = e.compress || e.compressPdf || u, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), f = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (n = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), c = e.filters || (!0 === u ? [
        "FlateEncode"
    ] : c), a = a || "mm", r = ("" + (r || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = $e5456e2f96ba3898$var$C;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var x = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var A = "compat", S = "advanced", _ = A;
    function P() {
        this.saveGraphicsState(), lt(new Wt(St, 0, 0, -St, 0, _n() * St).toString() + " cm"), this.setFontSize(this.getFontSize() / St), g = "n", _ = S;
    }
    function k() {
        this.restoreGraphicsState(), g = "S", _ = A;
    }
    var F = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = _ === A;
        return e && P.call(this), "function" != typeof t || (t(this), e && k.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = _ === S;
        return e && k.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return _ === S;
    };
    var B, R = function(t) {
        if (_ !== S) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var r = n || e;
        if (isNaN(t) || isNaN(r)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(r).replace(/0+$/, "");
    };
    B = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var T = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, z = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return _ === A ? t * St : _ === S ? t : void 0;
    }, H = function(t) {
        return U(function(t) {
            return _ === A ? _n() - t : _ === S ? t : void 0;
        }(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (n = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (je = new $e5456e2f96ba3898$var$I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), n = e < 0 ? "+" : "-", r = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            n,
            Q(r),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, n, r, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, nt = [], rt = [], it = 0, at = [], ot = [], st = !1, ut = rt;
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ut = t;
    };
    var ct = function(t) {
        st || (ut = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ut = rt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ut.push(t), ut;
    }, ht = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, ft = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
        return n;
    }, dt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return dt;
    };
    var pt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return pt = _ === S ? t / St : t, this;
    };
    var gt, mt = y.__private__.getFontSize = y.getFontSize = function() {
        return _ === A ? pt : pt * St;
    }, vt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return vt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return vt;
    };
    var bt, yt = y.__private__.setZoomMode = function(t) {
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) gt = t;
        else if (isNaN(t)) {
            if (-1 === [
                void 0,
                null,
                "fullwidth",
                "fullheight",
                "fullpage",
                "original"
            ].indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            gt = t;
        } else gt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return gt;
    };
    var wt, Nt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        bt = t;
    };
    y.__private__.getPageMode = function() {
        return bt;
    };
    var Lt = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        wt = t;
    };
    y.__private__.getLayoutMode = function() {
        return wt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, n) {
        return yt(t), Lt(e), Nt(n), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var At, St, _t, Pt, kt, Ft = {}, It = {}, jt = [], Ct = {}, Ot = {}, Bt = {}, Mt = {}, qt = null, Et = 0, Rt = [], Dt = new $e5456e2f96ba3898$var$C(y), Tt = e.hotfixes || [], zt = {}, Ut = {}, Ht = [], Wt = function t(e, n, r, i, a, o) {
        if (!(this instanceof t)) return new t(e, n, r, i, a, o);
        isNaN(e) && (e = 1), isNaN(n) && (n = 0), isNaN(r) && (r = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            n,
            r,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Wt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Wt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Wt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Wt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Wt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(B).join(t);
    }, Wt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, n = t.sx * this.shy + t.shy * this.sy, r = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Wt(e, n, r, i, a, o);
    }, Wt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * n + (e /= o) * r;
        n -= t * s, r -= e * s;
        var u = Math.sqrt(n * n + r * r);
        return s /= u, t * (r /= u) < e * (n /= u) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Wt(o, 0, 0, u, 0, 0),
            translate: new Wt(1, 0, 0, 1, i, a),
            rotate: new Wt(t, e, -e, t, 0, 0),
            skew: new Wt(1, 0, s, 1, 0, 0)
        };
    }, Wt.prototype.toString = function(t) {
        return this.join(" ");
    }, Wt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = 1 / (t * r - e * n), s = r * o, u = -e * o, c = -n * o, l = t * o;
        return new Wt(s, u, c, l, -s * i - c * a, -u * i - l * a);
    }, Wt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, n = t.x * this.shy + t.y * this.sy + this.ty;
        return new gn(e, n);
    }, Wt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), n = this.applyToPoint(new gn(t.x + t.w, t.y + t.h));
        return new mn(e.x, e.y, n.x - e.x, n.y - e.y);
    }, Wt.prototype.clone = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty;
        return new Wt(t, e, n, r, i, a);
    }, y.Matrix = Wt;
    var Vt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Gt = new Wt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Gt;
    var Yt = function(t, e) {
        if (!Ot[t]) {
            var n = (e instanceof $e5456e2f96ba3898$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(Ct).length + 1).toString(10);
            e.id = n, Ot[t] = n, Ct[n] = e, Dt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = $e5456e2f96ba3898$export$7235f0ad083cb4c6, y.TilingPattern = $e5456e2f96ba3898$export$549f717800d2b57f, y.addShadingPattern = function(t, e) {
        return R("addShadingPattern()"), Yt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        R("beginTilingPattern()"), bn(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        R("endTilingPattern()"), e.stream = ot[$].join("\n"), Yt(t, e), Dt.publish("endTilingPattern", e), Ht.pop().restore();
    };
    var Jt, Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, nt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, nt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) 5 !== e.length || "k" !== e[4] && "K" !== e[4] || (e = [
            (1 - e[0]) * (1 - e[3]),
            (1 - e[1]) * (1 - e[3]),
            (1 - e[2]) * (1 - e[3]),
            "r"
        ]);
        else {
            var n = parseFloat(e[0]);
            e = [
                n,
                n,
                n,
                "r"
            ];
        }
        for(var r = "#", i = 0; i < 3; i++)r += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return r;
    }, ne = y.__private__.encodeColorString = function(e) {
        var n;
        "string" == typeof e && (e = {
            ch1: e
        });
        var r = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof r && "#" !== r.charAt(0)) {
            var u = new $e5456e2f96ba3898$var$h(r);
            if (u.ok) r = u.toHex();
            else if (!/^\d*\.?\d*$/.test(r)) throw new Error('Invalid color "' + r + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof r && /^#[0-9A-Fa-f]{3}$/.test(r) && (r = "#" + r[1] + r[1] + r[2] + r[2] + r[3] + r[3]), "string" == typeof r && /^#[0-9A-Fa-f]{6}$/.test(r)) {
            var c = parseInt(r.substr(1), 16);
            r = c >> 16 & 255, i = c >> 8 & 255, a = 255 & c;
        }
        if (void 0 === i || void 0 === o && r === i && i === a) n = "string" == typeof r ? r + " " + s[0] : 2 === e.precision ? T(r / 255) + " " + s[0] : z(r / 255) + " " + s[0];
        else if (void 0 === o || "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            n = "string" == typeof r ? [
                r,
                i,
                a,
                s[1]
            ].join(" ") : 2 === e.precision ? [
                T(r / 255),
                T(i / 255),
                T(a / 255),
                s[1]
            ].join(" ") : [
                z(r / 255),
                z(i / 255),
                z(a / 255),
                s[1]
            ].join(" ");
        } else n = "string" == typeof r ? [
            r,
            i,
            a,
            o,
            s[2]
        ].join(" ") : 2 === e.precision ? [
            T(r),
            T(i),
            T(a),
            T(o),
            s[2]
        ].join(" ") : [
            z(r),
            z(i),
            z(a),
            z(o),
            s[2]
        ].join(" ");
        return n;
    }, re = y.__private__.getFilters = function() {
        return c;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", n = t.filters || re(), r = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = je.encryptor(o, 0));
        var u = {};
        !0 === n && (n = [
            "FlateEncode"
        ]);
        var c = t.additionalKeyValues || [], l = (u = void 0 !== $e5456e2f96ba3898$export$2e2bcd8739ae039.API.processDataByFilters ? $e5456e2f96ba3898$export$2e2bcd8739ae039.API.processDataByFilters(e, n) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
        if (0 !== u.data.length && (c.push({
            key: "Length",
            value: u.data.length
        }), !0 === i && c.push({
            key: "Length1",
            value: a
        })), 0 != l.length) {
            if (l.split("/").length - 1 == 1) c.push({
                key: "Filter",
                value: l
            });
            else {
                c.push({
                    key: "Filter",
                    value: "[" + l + "]"
                });
                for(var h = 0; h < c.length; h += 1)if ("DecodeParms" === c[h].key) {
                    for(var f = [], d = 0; d < u.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(c[h].value), c[h].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < c.length; p++)lt("/" + c[p].key + " " + c[p].value);
        lt(">>"), 0 !== u.data.length && (lt("stream"), lt(s(u.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, n = t.data, r = t.objId, i = t.contentsObjId;
        Zt(r, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(B(t.mediaBox.bottomLeftX)) + " " + parseFloat(B(t.mediaBox.bottomLeftY)) + " " + B(t.mediaBox.topRightX) + " " + B(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + B(t.cropBox.bottomLeftX) + " " + B(t.cropBox.bottomLeftY) + " " + B(t.cropBox.topRightX) + " " + B(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + B(t.bleedBox.bottomLeftX) + " " + B(t.bleedBox.bottomLeftY) + " " + B(t.bleedBox.topRightX) + " " + B(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + B(t.trimBox.bottomLeftX) + " " + B(t.trimBox.bottomLeftY) + " " + B(t.trimBox.topRightX) + " " + B(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + B(t.artBox.bottomLeftX) + " " + B(t.artBox.bottomLeftY) + " " + B(t.artBox.topRightX) + " " + B(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Dt.publish("putPage", {
            objId: r,
            pageContext: Rt[e],
            pageNumber: e,
            page: n
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = n.join("\n");
        return _ === S && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: re(),
            objectId: i
        }), lt("endobj"), r;
    }, oe = y.__private__.putPages = function() {
        var t, e, n = [];
        for(t = 1; t <= Et; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Et; t++)n.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var r = "/Kids [";
        for(e = 0; e < Et; e++)r += n[e] + " 0 R ";
        lt(r + "]"), lt("/Count " + Et), lt(">>"), lt("endobj"), Dt.publish("postPutPages");
    }, se = function(t) {
        Dt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + $e5456e2f96ba3898$var$j(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                B(t.x),
                B(t.y),
                B(t.x + t.width),
                B(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var n = t.pages[1].join("\n");
        ie({
            data: n,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, ce = function(t, e) {
        e || (e = 21);
        var n = Xt(), r = function(t, e) {
            var n, r = [], i = 1 / (e - 1);
            for(n = 0; n < 1; n += i)r.push(n);
            if (r.push(1), 0 != t[0].offset) {
                var a = {
                    offset: 0,
                    color: t[0].color
                };
                t.unshift(a);
            }
            if (1 != t[t.length - 1].offset) {
                var o = {
                    offset: 1,
                    color: t[t.length - 1].color
                };
                t.push(o);
            }
            for(var s = "", u = 0, c = 0; c < r.length; c++){
                for(n = r[c]; n > t[u + 1].offset;)u++;
                var l = t[u].offset, h = (n - l) / (t[u + 1].offset - l), f = t[u].color, d = t[u + 1].color;
                s += tt(Math.round((1 - h) * f[0] + h * d[0]).toString(16)) + tt(Math.round((1 - h) * f[1] + h * d[1]).toString(16)) + tt(Math.round((1 - h) * f[2] + h * d[2]).toString(16));
            }
            return s.trim();
        }(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: r,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: n
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + B(parseFloat(t.coords[0])) + " " + B(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) : a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) + " " + B(parseFloat(t.coords[4])) + " " + B(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + n + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, le = function(t, e) {
        var n = Kt(), r = Xt();
        e.push({
            resourcesOid: n,
            objectOid: r
        }), t.objectNumber = r;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(B).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: B(t.xStep)
        }), i.push({
            key: "YStep",
            value: B(t.yStep)
        }), i.push({
            key: "Resources",
            value: n + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + T(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + T(t[e]));
        }
        lt(">>"), lt("endobj");
    }, fe = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), function() {
            for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
            lt(">>");
        }(), function() {
            if (Object.keys(Ct).length > 0) {
                for(var t in lt("/Shading <<"), Ct)Ct.hasOwnProperty(t) && Ct[t] instanceof $e5456e2f96ba3898$export$7235f0ad083cb4c6 && Ct[t].objectNumber >= 0 && lt("/" + t + " " + Ct[t].objectNumber + " 0 R");
                Dt.publish("putShadingPatternDict"), lt(">>");
            }
        }(), function(t) {
            if (Object.keys(Ct).length > 0) {
                for(var e in lt("/Pattern <<"), Ct)Ct.hasOwnProperty(e) && Ct[e] instanceof y.TilingPattern && Ct[e].objectNumber >= 0 && Ct[e].objectNumber < t && lt("/" + e + " " + Ct[e].objectNumber + " 0 R");
                Dt.publish("putTilingPatternDict"), lt(">>");
            }
        }(t.objectOid), function() {
            if (Object.keys(Bt).length > 0) {
                var t;
                for(t in lt("/ExtGState <<"), Bt)Bt.hasOwnProperty(t) && Bt[t].objectNumber >= 0 && lt("/" + t + " " + Bt[t].objectNumber + " 0 R");
                Dt.publish("putGStateDict"), lt(">>");
            }
        }(), function() {
            for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
            Dt.publish("putXobjectDict"), lt(">>");
        }(), lt(">>"), lt("endobj");
    }, de = function(t) {
        It[t.fontName] = It[t.fontName] || {}, It[t.fontName][t.fontStyle] = t.id;
    }, pe = function(t, e, n, r, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: n,
            encoding: r,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Dt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, de(a), a.id;
    }, ge = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return (function(t, e) {
            var n, r, i, a, o, s, u, c, l;
            if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[At].metadata && Ft[At].metadata[i] && Ft[At].metadata[i].encoding && (a = Ft[At].metadata[i].encoding, !o && Ft[At].encoding && (o = Ft[At].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
                for(u = !1, s = [], n = 0, r = t.length; n < r; n++)(c = o[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (u = !0);
                t = s.join("");
            }
            for(n = t.length; void 0 === u && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (u = !0), n--;
            if (!u) return t;
            for(s = e.noBOM ? [] : [
                254,
                255
            ], n = 0, r = t.length; n < r; n++){
                if ((l = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                s.push(l), s.push(c - (l << 8));
            }
            return String.fromCharCode.apply(void 0, s);
        })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, me = y.__private__.beginPage = function(t) {
        ot[++Et] = [], Rt[Et] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(f),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, ye(Et), ct(ot[$]);
    }, ve = function(t, e) {
        var n, i, a;
        switch(r = e || r, "string" == typeof t && (n = x(t.toLowerCase()), Array.isArray(n) && (i = n[0], a = n[1])), Array.isArray(t) && (i = t[0] * St, a = t[1] * St), isNaN(i) && (i = s[0], a = s[1]), (i > 14400 || a > 14400) && ($e5456e2f96ba3898$var$o.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), i = Math.min(14400, i), a = Math.min(14400, a)), s = [
            i,
            a
        ], r.substr(0, 1)){
            case "l":
                a > i && (s = [
                    a,
                    i
                ]);
                break;
            case "p":
                i > a && (s = [
                    a,
                    i
                ]);
        }
        me(s), Ze(Xe), lt(on), 0 !== fn && lt(fn + " J"), 0 !== dn && lt(dn + " j"), Dt.publish("addPage", {
            pageNumber: Et
        });
    }, be = function(t) {
        t > 0 && t <= Et && (ot.splice(t, 1), Rt.splice(t, 1), Et--, $ > Et && ($ = Et), this.setPage($));
    }, ye = function(t) {
        t > 0 && t <= Et && ($ = t);
    }, we = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, Ne = function(t, e, n) {
        var r, i = void 0;
        return n = n || {}, t = void 0 !== t ? t : Ft[At].fontName, e = void 0 !== e ? e : Ft[At].fontStyle, r = t.toLowerCase(), void 0 !== It[r] && void 0 !== It[r][e] ? i = It[r][e] : void 0 !== It[t] && void 0 !== It[t][e] ? i = It[t][e] : !1 === n.disableWarning && $e5456e2f96ba3898$var$o.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = It.times[e]) && (i = It.times.normal), i;
    }, Le = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var n in null !== m && (e = je.encryptor(t, 0)), lt("<<"), lt("/Producer (" + ge(e("jsPDF " + $e5456e2f96ba3898$export$2e2bcd8739ae039.version)) + ")"), xt)xt.hasOwnProperty(n) && xt[n] && lt("/" + n.substr(0, 1).toUpperCase() + n.substr(1) + " (" + ge(e(xt[n])) + ")");
        lt("/CreationDate (" + ge(e(W)) + ")"), lt(">>"), lt("endobj");
    }, xe = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), gt || (gt = "fullwidth"), gt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var n = "" + gt;
                "%" === n.substr(n.length - 1) && (gt = parseInt(gt) / 100), "number" == typeof gt && lt("/OpenAction [3 0 R /XYZ null null " + T(gt) + "]");
        }
        switch(wt || (wt = "continuous"), wt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        bt && lt("/PageMode /" + bt), Dt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Ae = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + je.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Se = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, _e = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof nt[e] ? lt((t + nt[e]()).slice(-10) + " 00000 n ") : void 0 !== nt[e] ? lt((t + nt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, Pe = y.__private__.buildDocument = function() {
        var t;
        et = 0, it = 0, rt = [], nt = [], at = [], Qt = Kt(), te = Kt(), ct(rt), Dt.publish("buildDocument"), Se(), oe(), function() {
            Dt.publish("putAdditionalObjects");
            for(var t = 0; t < at.length; t++){
                var e = at[t];
                Zt(e.objId, !0), lt(e.content), lt("endobj");
            }
            Dt.publish("postPutAdditionalObjects");
        }(), t = [], function() {
            for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
        }(), function() {
            var t;
            for(t in Bt)Bt.hasOwnProperty(t) && he(Bt[t]);
        }(), function() {
            for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
        }(), function(t) {
            var e;
            for(e in Ct)Ct.hasOwnProperty(e) && (Ct[e] instanceof $e5456e2f96ba3898$export$7235f0ad083cb4c6 ? ce(Ct[e]) : Ct[e] instanceof $e5456e2f96ba3898$export$549f717800d2b57f && le(Ct[e], t));
        }(t), Dt.publish("putResources"), t.forEach(fe), fe({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Dt.publish("postPutResources"), null !== m && (je.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + je.v), lt("/R " + je.r), lt("/U <" + je.toHexString(je.U) + ">"), lt("/O <" + je.toHexString(je.O) + ">"), lt("/P " + je.P), lt(">>"), lt("endobj")), Le(), xe();
        var e = it;
        return _e(), Ae(), lt("startxref"), lt("" + e), lt("%%EOF"), ct(ot[$]), rt.join("\n");
    }, ke = y.__private__.getBlob = function(t) {
        return new Blob([
            ft(t)
        ], {
            type: "application/pdf"
        });
    }, Fe = y.output = y.__private__.output = (Jt = function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return Pe();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return ft(Pe());
            case "blob":
                return ke(Pe());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $e5456e2f96ba3898$var$i.URL && "function" == typeof $e5456e2f96ba3898$var$i.URL.createObjectURL) return $e5456e2f96ba3898$var$i.URL && $e5456e2f96ba3898$var$i.URL.createObjectURL(ke(Pe())) || void 0;
                $e5456e2f96ba3898$var$o.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var n = "", r = Pe();
                try {
                    n = $e5456e2f96ba3898$var$d(r);
                } catch (m) {
                    n = $e5456e2f96ba3898$var$d(unescape(encodeURIComponent(r)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + n;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($e5456e2f96ba3898$var$i)) {
                    var a = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (a = e.pdfObjectUrl, s = "");
                    var u = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + a + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", c = $e5456e2f96ba3898$var$i.open();
                    return null !== c && c.document.write(u), c;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($e5456e2f96ba3898$var$i)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', h = $e5456e2f96ba3898$var$i.open();
                    if (null !== h) {
                        h.document.write(l);
                        var f = this;
                        h.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            h.document.title = e.filename, h.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(f.output("bloburl"));
                        };
                    }
                    return h;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($e5456e2f96ba3898$var$i)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = $e5456e2f96ba3898$var$i.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return $e5456e2f96ba3898$var$i.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }, Jt.foo = function() {
        try {
            return Jt.apply(this, arguments);
        } catch (n) {
            var t = n.stack || "";
            ~t.indexOf(" at ") && (t = t.split(" at ")[1]);
            var e = "Error in function " + t.split("\n")[0].split("<")[0] + ": " + n.message;
            if (!$e5456e2f96ba3898$var$i.console) throw new Error(e);
            $e5456e2f96ba3898$var$i.console.error(e, n), $e5456e2f96ba3898$var$i.alert && alert(e);
        }
    }, Jt.foo.bar = Jt, Jt.foo), Ie = function(t) {
        return !0 === Array.isArray(Tt) && Tt.indexOf(t) > -1;
    };
    switch(a){
        case "pt":
            St = 1;
            break;
        case "mm":
            St = 72 / 25.4;
            break;
        case "cm":
            St = 72 / 2.54;
            break;
        case "in":
            St = 72;
            break;
        case "px":
            St = 1 == Ie("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            St = 12;
            break;
        case "ex":
            St = 6;
            break;
        default:
            if ("number" != typeof a) throw new Error("Invalid unit: " + a);
            St = a;
    }
    var je = null;
    K(), Y();
    var Ce = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Oe = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Ce(e);
    }, Be = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return ve.apply(this, arguments), this;
    }, y.setPage = function() {
        return ye.apply(this, arguments), ct.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var n, r;
        if (t > e) {
            n = ot[t], r = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = n, Rt[e] = r, this.setPage(e);
        } else if (t < e) {
            n = ot[t], r = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = n, Rt[e] = r, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, n, r, i, a) {
        var o, s, u, c, l, h, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof n && ("string" == typeof r || Array.isArray(r))) {
            var m = r;
            r = n, n = e, e = m;
        }
        if (arguments[3] instanceof Wt == 0 ? (u = arguments[4], c = arguments[5], "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(f = arguments[3]) && null !== f || ("string" == typeof u && (c = u, u = null), "string" == typeof f && (c = f, f = null), "number" == typeof f && (u = f, f = null), i = {
            flags: f,
            angle: u,
            align: c
        })) : (R("The transform parameter of text() with a Matrix value"), p = a), isNaN(n) || isNaN(r) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v, y = "", w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : Je, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), ge(t, f);
        }
        function x(t) {
            for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? r.push(e[0]) : r.push([
                e[0],
                e[1],
                e[2]
            ]);
            return r;
        }
        function A(t, e) {
            var n;
            if ("string" == typeof t) n = e(t)[0];
            else if (Array.isArray(t)) {
                for(var r, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (r = a.shift()) ? o.push(e(r)[0]) : Array.isArray(r) && "string" == typeof r[0] && (i = e(r[0], r[1], r[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                n = o;
            }
            return n;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var F = e.concat();
            s = [];
            for(var I, j = F.length; j--;)("string" != typeof (I = F.shift()) || Array.isArray(I) && "string" != typeof I[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var C = pt / g.internal.scaleFactor, O = C * (w - 1);
        switch(i.baseline){
            case "bottom":
                r -= O;
                break;
            case "top":
                r += C - O;
                break;
            case "hanging":
                r += C - 2 * O;
                break;
            case "middle":
                r += C / 2 - O;
        }
        if ((h = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, h) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, h));
        }, []))), o = {
            text: e,
            x: n,
            y: r,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("preProcessText", o), e = o.text, u = (i = o.options).angle, p instanceof Wt == 0 && u && "number" == typeof u) {
            u *= Math.PI / 180, 0 === i.rotationDirection && (u = -u), _ === S && (u = -u);
            var M = Math.cos(u), q = Math.sin(u);
            p = new Wt(M, q, -q, M, 0, 0);
        } else u && u instanceof Wt && (p = u);
        _ !== S || p || (p = Gt), void 0 !== (l = i.charSpace || ln) && (y += B(U(l)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (y += B(100 * d) + " Tz\n"), i.lang;
        var E = -1, D = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(D){
            case 0:
            case !1:
            case "fill":
                E = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                E = 1;
                break;
            case 2:
            case "fillThenStroke":
                E = 2;
                break;
            case 3:
            case "invisible":
                E = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                E = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                E = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                E = 6;
                break;
            case 7:
            case "addToPathForClipping":
                E = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== E ? y += E + " Tr\n" : -1 !== z && (y += "0 Tr\n"), -1 !== E && (T.usedRenderingMode = E), c = i.align || "left";
        var H, W = pt * w, V = g.internal.pageSize.getWidth(), G = Ft[At];
        l = i.charSpace || ln, h = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [], J = function(t) {
            return g.getStringUnitWidth(t, {
                font: G,
                charSpace: l,
                fontSize: pt,
                doKerning: !1
            }) * pt / N;
        };
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var X;
            s = x(e), "left" !== c && (H = s.map(J));
            var K, Z = 0;
            if ("right" === c) {
                n -= H[0], e = [], j = s.length;
                for(var $ = 0; $ < j; $++)0 === $ ? (K = en(n), X = nn(r)) : (K = U(Z - H[$]), X = -W), e.push([
                    s[$],
                    K,
                    X
                ]), Z = H[$];
            } else if ("center" === c) {
                n -= H[0] / 2, e = [], j = s.length;
                for(var Q = 0; Q < j; Q++)0 === Q ? (K = en(n), X = nn(r)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                    s[Q],
                    K,
                    X
                ]), Z = H[Q];
            } else if ("left" === c) {
                e = [], j = s.length;
                for(var tt = 0; tt < j; tt++)e.push(s[tt]);
            } else if ("justify" === c && "Identity-H" === G.encoding) {
                e = [], j = s.length, h = 0 !== h ? h : V;
                for(var et = 0, nt = 0; nt < j; nt++)if (X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : et, nt < j - 1) {
                    var rt = U((h - H[nt]) / (s[nt].split(" ").length - 1)), it = s[nt].split(" ");
                    e.push([
                        it[0] + " ",
                        K,
                        X
                    ]), et = 0;
                    for(var at = 1; at < it.length; at++){
                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + rt;
                        at == it.length - 1 ? e.push([
                            it[at],
                            ot,
                            0
                        ]) : e.push([
                            it[at] + " ",
                            ot,
                            0
                        ]), et -= ot;
                    }
                } else e.push([
                    s[nt],
                    K,
                    X
                ]);
                e.push([
                    "",
                    et,
                    0
                ]);
            } else {
                if ("justify" !== c) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                for(e = [], j = s.length, h = 0 !== h ? h : V, nt = 0; nt < j; nt++){
                    X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : 0;
                    var st = s[nt].split(" ").length - 1, ut = st > 0 ? (h - H[nt]) / st : 0;
                    nt < j - 1 ? Y.push(B(U(ut))) : Y.push(0), e.push([
                        s[nt],
                        K,
                        X
                    ]);
                }
            }
        }
        !0 === ("boolean" == typeof i.R2L ? i.R2L : vt) && (e = A(e, function(t, e, n) {
            return [
                t.split("").reverse().join(""),
                e,
                n
            ];
        })), o = {
            text: e,
            x: n,
            y: r,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("postProcessText", o), e = o.text, v = o.mutex.isHex || !1;
        var ct = Ft[At].encoding;
        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = A(e, function(t, e, n) {
            return [
                L(t),
                e,
                n
            ];
        })), s = x(e), e = [];
        for(var ht, ft, dt, gt = Array.isArray(s[0]) ? 1 : 0, mt = "", bt = function(t, e, n) {
            var r = "";
            return n instanceof Wt ? (n = "number" == typeof i.angle ? Vt(n, new Wt(1, 0, 0, 1, t, e)) : Vt(new Wt(1, 0, 0, 1, t, e), n), _ === S && (n = Vt(new Wt(1, 0, 0, -1, 0, 0), n)), r = n.join(" ") + " Tm\n") : r = B(t) + " " + B(e) + " Td\n", r;
        }, yt = 0; yt < s.length; yt++){
            switch(mt = "", gt){
                case 1:
                    dt = (v ? "<" : "(") + s[yt][0] + (v ? ">" : ")"), ht = parseFloat(s[yt][1]), ft = parseFloat(s[yt][2]);
                    break;
                case 0:
                    dt = (v ? "<" : "(") + s[yt] + (v ? ">" : ")"), ht = en(n), ft = nn(r);
            }
            void 0 !== Y && void 0 !== Y[yt] && (mt = Y[yt] + " Tw\n"), 0 === yt ? e.push(mt + bt(ht, ft, p) + dt) : 0 === gt ? e.push(mt + dt) : 1 === gt && e.push(mt + bt(ht, ft, p) + dt);
        }
        e = 0 === gt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var wt = "BT\n/";
        return wt += At + " " + pt + " Tf\n", wt += B(pt * w) + " TL\n", wt += un + "\n", wt += y, wt += e, lt(wt += "ET"), b[At] = !0, g;
    };
    var Me = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return Me("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var qe = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return qe(t) && (g = t), this;
    };
    var Ee = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, Re = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return De("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return De("f*", t), this;
    }, y.fillStroke = function(t) {
        return De("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return De("B*", t), this;
    };
    var De = function(e, n) {
        "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(n) ? Ue(n, e) : lt(e);
    }, Te = function(t) {
        null === t || _ === S && void 0 === t || (t = Ee(t), lt(t));
    };
    function ze(t, e, n, r, i) {
        var a = new $e5456e2f96ba3898$export$549f717800d2b57f(e || this.boundingBox, n || this.xStep, r || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Yt(o, a), a;
    }
    var Ue = function(t, e) {
        var n = Ot[t.key], r = Ct[n];
        if (r instanceof $e5456e2f96ba3898$export$7235f0ad083cb4c6) lt("q"), lt(He(e)), r.gState && y.setGState(r.gState), lt(t.matrix.toString() + " cm"), lt("/" + n + " sh"), lt("Q");
        else if (r instanceof $e5456e2f96ba3898$export$549f717800d2b57f) {
            var i = new Wt(1, 0, 0, -1, 0, _n());
            t.matrix && (i = i.multiply(t.matrix || Gt), n = ze.call(r, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + n + " scn"), r.gState && y.setGState(r.gState), lt(e), lt("Q");
        }
    }, He = function(t) {
        switch(t){
            case "f":
            case "F":
            case "n":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
            case "S":
                return "W S";
            case "B*":
                return "W* S";
        }
    }, We = y.moveTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " m"), this;
    }, Ve = y.lineTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " l"), this;
    }, Ge = y.curveTo = function(t, e, n, r, i, a) {
        return lt([
            B(U(t)),
            B(H(e)),
            B(U(n)),
            B(H(r)),
            B(U(i)),
            B(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return _ === A ? this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, n, r, i, a) {
        var o, s, u, c, l, h, f, d, p, g, m, v;
        if ("number" == typeof t && (v = n, n = e, e = t, t = v), r = r || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(n) || !Array.isArray(t) || !Array.isArray(r) || !qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(We(e, n), o = r[0], s = r[1], c = t.length, g = e, m = n, u = 0; u < c; u++)2 === (l = t[u]).length ? (g = l[0] * o + g, m = l[1] * s + m, Ve(g, m)) : (h = l[0] * o + g, f = l[1] * s + m, d = l[2] * o + g, p = l[3] * s + m, g = l[4] * o + g, m = l[5] * s + m, Ge(h, f, d, p, g, m));
        return a && Re(), Te(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var n = t[e], r = n.c;
            switch(n.op){
                case "m":
                    We(r[0], r[1]);
                    break;
                case "l":
                    Ve(r[0], r[1]);
                    break;
                case "c":
                    Ge.apply(this, r);
                    break;
                case "h":
                    Re();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return _ === A && (r = -r), lt([
            B(U(t)),
            B(H(e)),
            B(U(n)),
            B(U(r)),
            "re"
        ].join(" ")), Te(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                n - t,
                r - e
            ],
            [
                i - n,
                a - r
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * n), a = Math.min(a, .5 * r), this.lines([
            [
                n - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                r - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - n,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - r
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * n, o = 4 / 3 * (Math.SQRT2 - 1) * r;
        return We(t + n, e), Ge(t + n, e - o, t + a, e - r, t, e - r), Ge(t - a, e - r, t - n, e - o, t - n, e), Ge(t - n, e + o, t - a, e + r, t, e + r), Ge(t + a, e + r, t + n, e + o, t + n, e), Te(i), this;
    }, y.__private__.circle = y.circle = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || !qe(r)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, n, n, r);
    }, y.setFont = function(t, e, n) {
        return n && (e = F(e, n)), At = Ne(t, e, {
            disableWarning: !1
        }), this;
    };
    var Ye = y.__private__.getFont = y.getFont = function() {
        return Ft[Ne.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, n = {};
        for(t in It)if (It.hasOwnProperty(t)) for(e in n[t] = [], It[t])It[t].hasOwnProperty(e) && n[t].push(e);
        return n;
    }, y.addFont = function(t, e, n, r, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (n = F(n, r)), pe.call(this, t, e, n, i = i || "Identity-H");
    };
    var Je, Xe = e.lineWidth || .200025, Ke = y.__private__.getLineWidth = y.getLineWidth = function() {
        return Xe;
    }, Ze = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return Xe = t, lt(B(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = $e5456e2f96ba3898$export$2e2bcd8739ae039.API.setLineDash = $e5456e2f96ba3898$export$2e2bcd8739ae039.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return B(U(t));
        }).join(" "), e = B(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var $e = y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Je;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Je;
    };
    var Qe = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (Je = t), this;
    }, tn = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return Je;
    };
    Qe(e.lineHeight);
    var en = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, nn = y.__private__.getVerticalCoordinate = function(t) {
        return _ === S ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, rn = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return B(en(t));
    }, an = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return B(nn(t));
    }, on = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(on);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, n, r) {
        return on = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "draw",
            precision: 2
        }), lt(on), this;
    };
    var sn = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(sn);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, n, r) {
        return sn = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "fill",
            precision: 2
        }), lt(sn), this;
    };
    var un = e.textColor || "0 g", cn = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(un);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, n, r) {
        return un = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var ln = e.charSpace, hn = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(ln || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return ln = t, this;
    };
    var fn = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return fn = e, lt(e + " J"), this;
    };
    var dn = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return dn = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(B(U(t)) + " M"), this;
    }, y.GState = $e5456e2f96ba3898$export$1bc649ab427a02ba, y.setGState = function(t) {
        (t = "string" == typeof t ? Bt[Mt[t]] : pn(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var pn = function(t, e) {
        if (!t || !Mt[t]) {
            var n = !1;
            for(var r in Bt)if (Bt.hasOwnProperty(r) && Bt[r].equals(e)) {
                n = !0;
                break;
            }
            if (n) e = Bt[r];
            else {
                var i = "GS" + (Object.keys(Bt).length + 1).toString(10);
                Bt[i] = e, e.id = i;
            }
            return t && (Mt[t] = e.id), Dt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return pn(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: At,
            size: pt,
            color: un
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = jt.pop();
        return At = t.key, pt = t.size, un = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var gn = function(t, e) {
        var n = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var r = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, mn = function(t, e, n, r) {
        gn.call(this, t, e), this.type = "rect";
        var i = n || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = r || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, vn = function() {
        this.page = Et, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = _t, this.y = Pt, this.matrix = kt, this.width = wn($), this.height = Ln($), this.outputDestination = ut, this.id = "", this.objectNumber = -1;
    };
    vn.prototype.restore = function() {
        Et = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, _t = this.x, Pt = this.y, kt = this.matrix, Nn($, this.width), xn($, this.height), ut = this.outputDestination;
    };
    var bn = function(t, e, n, r, i) {
        Ht.push(new vn), Et = $ = 0, ot = [], _t = t, Pt = e, kt = i, me([
            n,
            r
        ]);
    };
    for(var yn in y.beginFormObject = function(t, e, n, r, i) {
        return bn(t, e, n, r, i), this;
    }, y.endFormObject = function(t) {
        return function(t) {
            if (Ut[t]) Ht.pop().restore();
            else {
                var e = new vn, n = "Xo" + (Object.keys(zt).length + 1).toString(10);
                e.id = n, Ut[t] = n, zt[n] = e, Dt.publish("addFormObject", e), Ht.pop().restore();
            }
        }(t), this;
    }, y.doFormObject = function(t, e) {
        var n = zt[Ut[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + n.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ut[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? ($e5456e2f96ba3898$var$l(ke(Pe()), t), "function" == typeof $e5456e2f96ba3898$var$l.unload && $e5456e2f96ba3898$var$i.setTimeout && setTimeout($e5456e2f96ba3898$var$l.unload, 911), this) : new Promise(function(e, n) {
            try {
                var r = $e5456e2f96ba3898$var$l(ke(Pe()), t);
                "function" == typeof $e5456e2f96ba3898$var$l.unload && $e5456e2f96ba3898$var$i.setTimeout && setTimeout($e5456e2f96ba3898$var$l.unload, 911), e(r);
            } catch (a) {
                n(a.message);
            }
        });
    }, $e5456e2f96ba3898$export$2e2bcd8739ae039.API)$e5456e2f96ba3898$export$2e2bcd8739ae039.API.hasOwnProperty(yn) && ("events" === yn && $e5456e2f96ba3898$export$2e2bcd8739ae039.API.events.length ? function(t, e) {
        var n, r, i;
        for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
            n
        ].concat("function" == typeof r ? [
            r
        ] : r));
    }(Dt, $e5456e2f96ba3898$export$2e2bcd8739ae039.API.events) : y[yn] = $e5456e2f96ba3898$export$2e2bcd8739ae039.API[yn]);
    function wn(t) {
        return Rt[t].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX;
    }
    function Nn(t, e) {
        Rt[t].mediaBox.topRightX = e + Rt[t].mediaBox.bottomLeftX;
    }
    function Ln(t) {
        return Rt[t].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY;
    }
    function xn(t, e) {
        Rt[t].mediaBox.topRightY = e + Rt[t].mediaBox.bottomLeftY;
    }
    var An = y.getPageWidth = function(t) {
        return wn(t = t || $) / St;
    }, Sn = y.setPageWidth = function(t, e) {
        Nn(t, e * St);
    }, _n = y.getPageHeight = function(t) {
        return Ln(t = t || $) / St;
    }, Pn = y.setPageHeight = function(t, e) {
        xn(t, e * St);
    };
    return y.internal = {
        pdfEscape: ge,
        getStyle: Ee,
        getFont: Ye,
        getFontSize: mt,
        getCharSpace: hn,
        getTextColor: cn,
        getLineHeight: $e,
        getLineHeightFactor: tn,
        getLineWidth: Ke,
        write: ht,
        getHorizontalCoordinate: en,
        getVerticalCoordinate: nn,
        getCoordinateString: rn,
        getVerticalCoordinateString: an,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: re,
        putStream: ie,
        events: Dt,
        scaleFactor: St,
        pageSize: {
            getWidth: function() {
                return An($);
            },
            setWidth: function(t) {
                Sn($, t);
            },
            getHeight: function() {
                return _n($);
            },
            setHeight: function(t) {
                Pn($, t);
            }
        },
        encryptionOptions: m,
        encryption: je,
        getEncryptor: function(t) {
            return null !== m ? je.encryptor(t, 0) : function(t) {
                return t;
            };
        },
        output: Fe,
        getNumberOfPages: we,
        pages: ot,
        out: lt,
        f2: T,
        f3: z,
        getPageInfo: Ce,
        getPageInfoByObjId: Oe,
        getCurrentPageInfo: Be,
        getPDFVersion: N,
        Point: gn,
        Rectangle: mn,
        Matrix: Wt,
        hasHotfix: Ie
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return An($);
        },
        set: function(t) {
            Sn($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return _n($);
        },
        set: function(t) {
            Pn($, t);
        },
        enumerable: !0,
        configurable: !0
    }), (function(t) {
        for(var e = 0, n = dt.length; e < n; e++){
            var r = pe.call(this, t[e][0], t[e][1], t[e][2], dt[e][3], !0);
            !1 === v && (b[r] = !0);
            var i = t[e][0].split("-");
            de({
                id: r,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Dt.publish("addFonts", {
            fonts: Ft,
            dictionary: It
        });
    }).call(y, dt), At = "F1", ve(s, r), Dt.publish("initialized"), y;
}
$e5456e2f96ba3898$var$I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, $e5456e2f96ba3898$var$I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, $e5456e2f96ba3898$var$I.prototype.hexToBytes = function(t) {
    for(var e = [], n = 0; n < t.length; n += 2)e.push(String.fromCharCode(parseInt(t.substr(n, 2), 16)));
    return e.join("");
}, $e5456e2f96ba3898$var$I.prototype.processOwnerPassword = function(t, e) {
    return $e5456e2f96ba3898$var$k($e5456e2f96ba3898$var$S(e).substr(0, 5), t);
}, $e5456e2f96ba3898$var$I.prototype.encryptor = function(t, e) {
    var n = $e5456e2f96ba3898$var$S(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return $e5456e2f96ba3898$var$k(n, t);
    };
}, $e5456e2f96ba3898$export$1bc649ab427a02ba.prototype.equals = function(e) {
    var n, r = "id,objectNumber,equals";
    if (!e || (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(this)) return !1;
    var i = 0;
    for(n in this)if (!(r.indexOf(n) >= 0)) {
        if (this.hasOwnProperty(n) && !e.hasOwnProperty(n)) return !1;
        if (this[n] !== e[n]) return !1;
        i++;
    }
    for(n in e)e.hasOwnProperty(n) && r.indexOf(n) < 0 && i--;
    return 0 === i;
}, $e5456e2f96ba3898$export$2e2bcd8739ae039.API = {
    events: []
}, $e5456e2f96ba3898$export$2e2bcd8739ae039.version = "3.0.3";
var $e5456e2f96ba3898$var$R = $e5456e2f96ba3898$export$2e2bcd8739ae039.API, $e5456e2f96ba3898$var$D = 1, $e5456e2f96ba3898$var$T = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $e5456e2f96ba3898$var$z = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $e5456e2f96ba3898$var$U = function(t) {
    return t.toFixed(2);
}, $e5456e2f96ba3898$var$H = function(t) {
    return t.toFixed(5);
};
$e5456e2f96ba3898$var$R.__acroform__ = {};
var $e5456e2f96ba3898$var$W = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $e5456e2f96ba3898$var$V = function(t) {
    return t * $e5456e2f96ba3898$var$D;
}, $e5456e2f96ba3898$var$G = function(t) {
    var e = new $e5456e2f96ba3898$var$ct, n = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) || 0, r = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($e5456e2f96ba3898$var$U(r)),
        Number($e5456e2f96ba3898$var$U(n))
    ], e;
}, $e5456e2f96ba3898$var$Y = $e5456e2f96ba3898$var$R.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t | 1 << e;
}, $e5456e2f96ba3898$var$J = $e5456e2f96ba3898$var$R.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t & ~(1 << e);
}, $e5456e2f96ba3898$var$X = $e5456e2f96ba3898$var$R.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return t & 1 << e ? 1 : 0;
}, $e5456e2f96ba3898$var$K = $e5456e2f96ba3898$var$R.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $e5456e2f96ba3898$var$X(t, e - 1);
}, $e5456e2f96ba3898$var$Z = $e5456e2f96ba3898$var$R.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $e5456e2f96ba3898$var$Y(t, e - 1);
}, $e5456e2f96ba3898$var$$ = $e5456e2f96ba3898$var$R.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $e5456e2f96ba3898$var$J(t, e - 1);
}, $e5456e2f96ba3898$var$Q = $e5456e2f96ba3898$var$R.__acroform__.calculateCoordinates = function(t, e) {
    var n = e.internal.getHorizontalCoordinate, r = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], u = {};
    return u.lowerLeft_X = n(i) || 0, u.lowerLeft_Y = r(a + s) || 0, u.upperRight_X = n(i + o) || 0, u.upperRight_Y = r(a) || 0, [
        Number($e5456e2f96ba3898$var$U(u.lowerLeft_X)),
        Number($e5456e2f96ba3898$var$U(u.lowerLeft_Y)),
        Number($e5456e2f96ba3898$var$U(u.upperRight_X)),
        Number($e5456e2f96ba3898$var$U(u.upperRight_Y))
    ];
}, $e5456e2f96ba3898$var$tt = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], n = t._V || t.DV, r = $e5456e2f96ba3898$var$et(t, n), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + $e5456e2f96ba3898$var$U(r.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = $e5456e2f96ba3898$var$G(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, $e5456e2f96ba3898$var$et = function(t, e) {
    var n = 0 === t.fontSize ? t.maxFontSize : t.fontSize, r = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = n, o = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var u = function(e, n, r) {
        if (e + 1 < i.length) {
            var a = n + " " + i[e + 1][0];
            return $e5456e2f96ba3898$var$nt(a, t, r).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var c, l, h = $e5456e2f96ba3898$var$nt("3", t, a).height, f = t.multiline ? o - a : (o - h) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $e5456e2f96ba3898$var$nt(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((h + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = u(N, v, a), x = y >= i.length - 1;
                if (L && !x) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || x) {
                    if (x) g = N;
                    else if (t.multiline && (h + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((h + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var A = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        A += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        A += _[_.length - 1] + " ";
                        continue;
                    }
                }
                A += _[0] + " ";
            }
            switch(A = " " == A.substr(A.length - 1) ? A.substr(0, A.length - 1) : A, l = $e5456e2f96ba3898$var$nt(A, t, a).width, t.textAlign){
                case "right":
                    c = s - l - 2;
                    break;
                case "center":
                    c = (s - l) / 2;
                    break;
                default:
                    c = 2;
            }
            e += $e5456e2f96ba3898$var$U(c) + " " + $e5456e2f96ba3898$var$U(d) + " Td\n", e += "(" + $e5456e2f96ba3898$var$T(A) + ") Tj\n", e += -$e5456e2f96ba3898$var$U(c) + " 0 Td\n", d = -(a + 2), l = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return r.text = e, r.fontSize = a, r;
}, $e5456e2f96ba3898$var$nt = function(t, e, n) {
    var r = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: r,
        fontSize: parseFloat(n),
        charSpace: 0
    }) * parseFloat(n);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: r,
            fontSize: parseFloat(n),
            charSpace: 0
        }) * parseFloat(n) * 1.5,
        width: i
    };
}, $e5456e2f96ba3898$var$rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $e5456e2f96ba3898$var$it = function(t, e) {
    var n = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === n.type && t.object === n.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(n);
}, $e5456e2f96ba3898$var$at = function(e, n) {
    if (n.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if ($e5456e2f96ba3898$var$ht.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify($e5456e2f96ba3898$var$rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $e5456e2f96ba3898$var$D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new $e5456e2f96ba3898$var$lt, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var n in e)if (e.hasOwnProperty(n)) {
                    var r = e[n];
                    r.objId = void 0, r.hasAnnotation && $e5456e2f96ba3898$var$it(r, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(n) {
            !function(e, n) {
                var r = !e;
                for(var i in e || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $e5456e2f96ba3898$var$Q(a.Rect, n)), n.internal.newObjectDeferredBegin(a.objId, !0), a.DA = $e5456e2f96ba3898$export$7d753ad993606f45.createDefaultAppearanceStream(a), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var u = $e5456e2f96ba3898$var$tt(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + u + ">>"
                        }), n.internal.acroformPlugin.xForms.push(u);
                    }
                    if (a.appearanceStreamContent) {
                        var c = "";
                        for(var l in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(l)) {
                            var h = a.appearanceStreamContent[l];
                            if (c += "/" + l + " ", c += "<<", Object.keys(h).length >= 1 || Array.isArray(h)) {
                                for(var i in h)if (h.hasOwnProperty(i)) {
                                    var f = h[i];
                                    "function" == typeof f && (f = f.call(n, a)), c += "/" + i + " " + f + " ", n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = h) && (f = f.call(n, a)), c += "/" + i + " " + f, n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                            c += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + c + ">>"
                        });
                    }
                    n.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), n.internal.out("endobj");
                }
                r && function(e, n) {
                    for(var r in e)if (e.hasOwnProperty(r)) {
                        var i = r, a = e[r];
                        n.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
                    }
                }(n.internal.acroformPlugin.xForms, n);
            }(n, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, $e5456e2f96ba3898$var$ot = $e5456e2f96ba3898$var$R.__acroform__.arrayToPdfArray = function(e, n, r) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== n && r && (i = r.internal.getEncryptor(n)), a += "(" + $e5456e2f96ba3898$var$T(i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a + "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, $e5456e2f96ba3898$var$st = function(t, e, n) {
    var r = function(t) {
        return t;
    };
    return void 0 !== e && n && (r = n.internal.getEncryptor(e)), (t = t || "").toString(), "(" + $e5456e2f96ba3898$var$T(r(t)) + ")";
}, $e5456e2f96ba3898$var$ut = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
$e5456e2f96ba3898$var$ut.prototype.toString = function() {
    return this.objId + " 0 R";
}, $e5456e2f96ba3898$var$ut.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, $e5456e2f96ba3898$var$ut.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var n in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[n]).configurable) {
        var r = e[n], i = this[r];
        i && (Array.isArray(i) ? t.push({
            key: r,
            value: $e5456e2f96ba3898$var$ot(i, this.objId, this.scope)
        }) : i instanceof $e5456e2f96ba3898$var$ut ? (i.scope = this.scope, t.push({
            key: r,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: r,
            value: i
        }));
    }
    return t;
};
var $e5456e2f96ba3898$var$ct = function() {
    $e5456e2f96ba3898$var$ut.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$var$ct, $e5456e2f96ba3898$var$ut);
var $e5456e2f96ba3898$var$lt = function() {
    $e5456e2f96ba3898$var$ut.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $e5456e2f96ba3898$var$T(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$var$lt, $e5456e2f96ba3898$var$ut);
var $e5456e2f96ba3898$var$ht = function t() {
    $e5456e2f96ba3898$var$ut.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = $e5456e2f96ba3898$var$Z(e, 3) : this.F = $e5456e2f96ba3898$var$$(e, 3);
        }
    });
    var n = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            n = t;
        }
    });
    var r = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== r.length) return r;
        },
        set: function(t) {
            r = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[0]) ? 0 : r[0];
        },
        set: function(t) {
            r[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[1]) ? 0 : r[1];
        },
        set: function(t) {
            r[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[2]) ? 0 : r[2];
        },
        set: function(t) {
            r[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[3]) ? 0 : r[3];
        },
        set: function(t) {
            r[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof $e5456e2f96ba3898$var$yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $e5456e2f96ba3898$var$T(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var u = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return u;
        },
        set: function(t) {
            u = t;
        }
    });
    var c = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === c ? 50 / $e5456e2f96ba3898$var$D : c;
        },
        set: function(t) {
            c = t;
        }
    });
    var l = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return l;
        },
        set: function(t) {
            l = t;
        }
    });
    var h = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!h || this instanceof $e5456e2f96ba3898$var$yt || this instanceof $e5456e2f96ba3898$export$9d1b52e7fab50c84)) return $e5456e2f96ba3898$var$st(h, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), h = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 0 ? $e5456e2f96ba3898$var$st(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 0 ? "(" === t.substr(0, 1) ? $e5456e2f96ba3898$var$z(t.substr(1, t.length - 2)) : $e5456e2f96ba3898$var$z(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 1 ? $e5456e2f96ba3898$var$z(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 1 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 0 ? $e5456e2f96ba3898$var$st(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 0 ? "(" === t.substr(0, 1) ? $e5456e2f96ba3898$var$z(t.substr(1, t.length - 2)) : $e5456e2f96ba3898$var$z(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 1 ? $e5456e2f96ba3898$var$z(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $e5456e2f96ba3898$export$6aae594af76bbb7b == 1 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 1) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 2) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 3) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                default:
                    m = 0;
            }
        }
    });
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$var$ht, $e5456e2f96ba3898$var$ut);
var $e5456e2f96ba3898$export$a47202eb3f827bb2 = function() {
    $e5456e2f96ba3898$var$ht.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return $e5456e2f96ba3898$var$ot(e, this.objId, this.scope);
        },
        set: function(t) {
            var n, r;
            r = [], "string" == typeof (n = t) && (r = function(t, e, n) {
                n || (n = 1);
                for(var r, i = []; r = e.exec(t);)i.push(r[n]);
                return i;
            }(n, /\((.*?)\)/g)), e = r;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, n) {
        for(n = n || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== n););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 18) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 19) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 20), e.sort()) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 22) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 23) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 27) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$a47202eb3f827bb2, $e5456e2f96ba3898$var$ht);
var $e5456e2f96ba3898$export$9e021dd9568dc486 = function() {
    $e5456e2f96ba3898$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$9e021dd9568dc486, $e5456e2f96ba3898$export$a47202eb3f827bb2);
var $e5456e2f96ba3898$export$f2239d28df5f43bd = function() {
    $e5456e2f96ba3898$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$f2239d28df5f43bd, $e5456e2f96ba3898$export$9e021dd9568dc486);
var $e5456e2f96ba3898$export$4af052e7e598ad1a = function() {
    $e5456e2f96ba3898$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$4af052e7e598ad1a, $e5456e2f96ba3898$export$f2239d28df5f43bd);
var $e5456e2f96ba3898$export$6aae594af76bbb7b = function() {
    $e5456e2f96ba3898$var$ht.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 15) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 16) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 17) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 26) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 26);
        }
    });
    var e, n = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(n).length) {
                var e, r = [];
                for(e in r.push("<<"), n)r.push("/" + e + " (" + $e5456e2f96ba3898$var$T(t(n[e])) + ")");
                return r.push(">>"), r.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e) && (n = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (n.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + t;
        }
    });
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$6aae594af76bbb7b, $e5456e2f96ba3898$var$ht);
var $e5456e2f96ba3898$export$98b7c3ef37465410 = function() {
    $e5456e2f96ba3898$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$98b7c3ef37465410, $e5456e2f96ba3898$export$6aae594af76bbb7b);
var $e5456e2f96ba3898$export$bc1318bc7e5f1315 = function() {
    $e5456e2f96ba3898$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$bc1318bc7e5f1315, $e5456e2f96ba3898$export$6aae594af76bbb7b);
var $e5456e2f96ba3898$var$yt = function() {
    var e, n;
    $e5456e2f96ba3898$var$ht.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    });
    var r, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, n = [];
            for(e in n.push("<<"), i)n.push("/" + e + " (" + $e5456e2f96ba3898$var$T(t(i[e])) + ")");
            return n.push(">>"), n.join("\n");
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.substr(1, r.length - 1);
        },
        set: function(t) {
            r = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $e5456e2f96ba3898$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$var$yt, $e5456e2f96ba3898$var$ht), $e5456e2f96ba3898$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var n = this.Kids[e];
        n.appearanceStreamContent = t.createAppearanceStream(n.optionName), n.caption = t.getCA();
    }
}, $e5456e2f96ba3898$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $e5456e2f96ba3898$var$yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $e5456e2f96ba3898$var$At.call(this.scope, e), e;
};
var $e5456e2f96ba3898$export$5fd5db01c4615478 = function() {
    $e5456e2f96ba3898$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $e5456e2f96ba3898$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$5fd5db01c4615478, $e5456e2f96ba3898$export$6aae594af76bbb7b);
var $e5456e2f96ba3898$export$9d1b52e7fab50c84 = function() {
    $e5456e2f96ba3898$var$ht.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 13) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 21) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 23) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 24) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 25) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 26) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$9d1b52e7fab50c84, $e5456e2f96ba3898$var$ht);
var $e5456e2f96ba3898$export$c48d8668f8cea64d = function() {
    $e5456e2f96ba3898$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($e5456e2f96ba3898$var$K(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $e5456e2f96ba3898$var$Z(this.Ff, 14) : this.Ff = $e5456e2f96ba3898$var$$(this.Ff, 14);
        }
    }), this.password = !0;
};
$e5456e2f96ba3898$var$W($e5456e2f96ba3898$export$c48d8668f8cea64d, $e5456e2f96ba3898$export$9d1b52e7fab50c84);
var $e5456e2f96ba3898$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: $e5456e2f96ba3898$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $e5456e2f96ba3898$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $e5456e2f96ba3898$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = $e5456e2f96ba3898$var$G(t);
            e.scope = t.scope;
            var n = [], r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = $e5456e2f96ba3898$var$et(t, t.caption);
            return n.push("0.749023 g"), n.push("0 0 " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t)) + " " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + $e5456e2f96ba3898$var$U(a.fontSize) + " Tf " + i), n.push("BT"), n.push(a.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = $e5456e2f96ba3898$var$G(t);
            e.scope = t.scope;
            var n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color), i = [], a = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t), o = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t), s = $e5456e2f96ba3898$var$et(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + $e5456e2f96ba3898$var$U(o) + " " + $e5456e2f96ba3898$var$U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + $e5456e2f96ba3898$var$U(o - 1) + " " + $e5456e2f96ba3898$var$U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + $e5456e2f96ba3898$var$U(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = $e5456e2f96ba3898$var$G(t);
            e.scope = t.scope;
            var n = [];
            return n.push("0.749023 g"), n.push("0 0 " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t)) + " " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $e5456e2f96ba3898$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $e5456e2f96ba3898$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $e5456e2f96ba3898$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = $e5456e2f96ba3898$var$G(t);
                e.scope = t.scope;
                var n = [], r = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) <= $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) ? $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) / 4 : $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = $e5456e2f96ba3898$export$7d753ad993606f45.internal.Bezier_C, a = Number((r * i).toFixed(5));
                return n.push("q"), n.push("1 0 0 1 " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $e5456e2f96ba3898$var$G(t);
                e.scope = t.scope;
                var n = [], r = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) <= $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) ? $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) / 4 : $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = Number((2 * r).toFixed(5)), a = Number((i * $e5456e2f96ba3898$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((r * $e5456e2f96ba3898$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $e5456e2f96ba3898$var$G(t);
                e.scope = t.scope;
                var n = [], r = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) <= $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) ? $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) / 4 : $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = Number((2 * r).toFixed(5)), a = Number((i * $e5456e2f96ba3898$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $e5456e2f96ba3898$var$H($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $e5456e2f96ba3898$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $e5456e2f96ba3898$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $e5456e2f96ba3898$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = $e5456e2f96ba3898$var$G(t);
                e.scope = t.scope;
                var n = [], r = $e5456e2f96ba3898$export$7d753ad993606f45.internal.calculateCross(t);
                return n.push("q"), n.push("1 1 " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($e5456e2f96ba3898$var$U(r.x1.x) + " " + $e5456e2f96ba3898$var$U(r.x1.y) + " m"), n.push($e5456e2f96ba3898$var$U(r.x2.x) + " " + $e5456e2f96ba3898$var$U(r.x2.y) + " l"), n.push($e5456e2f96ba3898$var$U(r.x4.x) + " " + $e5456e2f96ba3898$var$U(r.x4.y) + " m"), n.push($e5456e2f96ba3898$var$U(r.x3.x) + " " + $e5456e2f96ba3898$var$U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $e5456e2f96ba3898$var$G(t);
                e.scope = t.scope;
                var n = $e5456e2f96ba3898$export$7d753ad993606f45.internal.calculateCross(t), r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t)) + " " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($e5456e2f96ba3898$var$U(n.x1.x) + " " + $e5456e2f96ba3898$var$U(n.x1.y) + " m"), r.push($e5456e2f96ba3898$var$U(n.x2.x) + " " + $e5456e2f96ba3898$var$U(n.x2.y) + " l"), r.push($e5456e2f96ba3898$var$U(n.x4.x) + " " + $e5456e2f96ba3898$var$U(n.x4.y) + " m"), r.push($e5456e2f96ba3898$var$U(n.x3.x) + " " + $e5456e2f96ba3898$var$U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $e5456e2f96ba3898$var$G(t);
                e.scope = t.scope;
                var n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t)) + " " + $e5456e2f96ba3898$var$U($e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + n;
    }
};
$e5456e2f96ba3898$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth(t), n = $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight(t), r = Math.min(e, n);
        return {
            x1: {
                x: (e - r) / 2,
                y: (n - r) / 2 + r
            },
            x2: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2
            },
            x3: {
                x: (e - r) / 2,
                y: (n - r) / 2
            },
            x4: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2 + r
            }
        };
    }
}, $e5456e2f96ba3898$export$7d753ad993606f45.internal.getWidth = function(e) {
    var n = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e) && (n = $e5456e2f96ba3898$var$V(e.Rect[2])), n;
}, $e5456e2f96ba3898$export$7d753ad993606f45.internal.getHeight = function(e) {
    var n = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e) && (n = $e5456e2f96ba3898$var$V(e.Rect[3])), n;
};
var $e5456e2f96ba3898$var$At = $e5456e2f96ba3898$var$R.addField = function(t) {
    if ($e5456e2f96ba3898$var$at(this, t), !(t instanceof $e5456e2f96ba3898$var$ht)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
$e5456e2f96ba3898$var$R.AcroFormChoiceField = $e5456e2f96ba3898$export$a47202eb3f827bb2, $e5456e2f96ba3898$var$R.AcroFormListBox = $e5456e2f96ba3898$export$9e021dd9568dc486, $e5456e2f96ba3898$var$R.AcroFormComboBox = $e5456e2f96ba3898$export$f2239d28df5f43bd, $e5456e2f96ba3898$var$R.AcroFormEditBox = $e5456e2f96ba3898$export$4af052e7e598ad1a, $e5456e2f96ba3898$var$R.AcroFormButton = $e5456e2f96ba3898$export$6aae594af76bbb7b, $e5456e2f96ba3898$var$R.AcroFormPushButton = $e5456e2f96ba3898$export$98b7c3ef37465410, $e5456e2f96ba3898$var$R.AcroFormRadioButton = $e5456e2f96ba3898$export$bc1318bc7e5f1315, $e5456e2f96ba3898$var$R.AcroFormCheckBox = $e5456e2f96ba3898$export$5fd5db01c4615478, $e5456e2f96ba3898$var$R.AcroFormTextField = $e5456e2f96ba3898$export$9d1b52e7fab50c84, $e5456e2f96ba3898$var$R.AcroFormPasswordField = $e5456e2f96ba3898$export$c48d8668f8cea64d, $e5456e2f96ba3898$var$R.AcroFormAppearance = $e5456e2f96ba3898$export$7d753ad993606f45, $e5456e2f96ba3898$var$R.AcroForm = {
    ChoiceField: $e5456e2f96ba3898$export$a47202eb3f827bb2,
    ListBox: $e5456e2f96ba3898$export$9e021dd9568dc486,
    ComboBox: $e5456e2f96ba3898$export$f2239d28df5f43bd,
    EditBox: $e5456e2f96ba3898$export$4af052e7e598ad1a,
    Button: $e5456e2f96ba3898$export$6aae594af76bbb7b,
    PushButton: $e5456e2f96ba3898$export$98b7c3ef37465410,
    RadioButton: $e5456e2f96ba3898$export$bc1318bc7e5f1315,
    CheckBox: $e5456e2f96ba3898$export$5fd5db01c4615478,
    TextField: $e5456e2f96ba3898$export$9d1b52e7fab50c84,
    PasswordField: $e5456e2f96ba3898$export$c48d8668f8cea64d,
    Appearance: $e5456e2f96ba3898$export$7d753ad993606f45
}, $e5456e2f96ba3898$export$2e2bcd8739ae039.AcroForm = {
    ChoiceField: $e5456e2f96ba3898$export$a47202eb3f827bb2,
    ListBox: $e5456e2f96ba3898$export$9e021dd9568dc486,
    ComboBox: $e5456e2f96ba3898$export$f2239d28df5f43bd,
    EditBox: $e5456e2f96ba3898$export$4af052e7e598ad1a,
    Button: $e5456e2f96ba3898$export$6aae594af76bbb7b,
    PushButton: $e5456e2f96ba3898$export$98b7c3ef37465410,
    RadioButton: $e5456e2f96ba3898$export$bc1318bc7e5f1315,
    CheckBox: $e5456e2f96ba3898$export$5fd5db01c4615478,
    TextField: $e5456e2f96ba3898$export$9d1b52e7fab50c84,
    PasswordField: $e5456e2f96ba3898$export$c48d8668f8cea64d,
    Appearance: $e5456e2f96ba3898$export$7d753ad993606f45
};
var $e5456e2f96ba3898$export$9cf40f67b77f45f4 = $e5456e2f96ba3898$export$2e2bcd8739ae039.AcroForm;
function $e5456e2f96ba3898$var$_t(t) {
    return t.reduce(function(t, e, n) {
        return t[e] = n, t;
    }, {});
}
!function(e) {
    var n = "addImage_";
    e.__addimage__ = {};
    var r = "UNKNOWN", i = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, a = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var n, a, o, s, u, c = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (A(t)) for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        else for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        return c === r && e !== r && (c = e), c;
    }, o = function t(e) {
        for(var n = this.internal.write, r = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === y.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === y.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency) && e.transparency.length > 0) {
            for(var o = "", s = 0, u = e.transparency.length; s < u; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var c = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (r({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: c,
            objectId: e.objectId
        }), n("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var l, h = null !== (l = e.sMaskBitsPerComponent) && void 0 !== l ? l : e.bitsPerComponent, f = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: h,
                data: e.sMask
            };
            "filter" in e && (f.decodeParameters = "/Predictor ".concat(e.predictor, " /Colors 1 /BitsPerComponent ").concat(h, " /Columns ").concat(e.width), f.filter = e.filter), t.call(this, f);
        }
        if (e.colorSpace === y.INDEXED) {
            var d = this.internal.newObject();
            r({
                data: _(new Uint8Array(e.palette)),
                objectId: d
            }), n("endobj");
        }
    }, s = function() {
        var t = this.internal.collections[n + "images"];
        for(var e in t)o.call(this, t[e]);
    }, u = function() {
        var t, e = this.internal.collections[n + "images"], r = this.internal.write;
        for(var i in e)r("/I" + (t = e[i]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections[n + "images"] || (this.internal.collections[n + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", u));
    }, l = function() {
        var t = this.internal.collections[n + "images"];
        return c.call(this), t;
    }, h = function() {
        return Object.keys(this.internal.collections[n + "images"]).length;
    }, d = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, p = function(e) {
        return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e) && 1 === e.nodeType;
    }, g = function(t, n) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var r = "" + t.getAttribute("src");
            if (0 === r.indexOf("data:image/")) return $e5456e2f96ba3898$var$f(unescape(r).split("base64,").pop());
            var i = e.loadFile(r, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(n){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                default:
                    a = "image/jpeg";
            }
            return $e5456e2f96ba3898$var$f(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, m = function(t) {
        var e = this.internal.collections[n + "images"];
        if (e) {
            for(var r in e)if (t === e[r].alias) return e[r];
        }
    }, v = function(t, e, n) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * n.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.width / n.height), 0 === e && (e = t * n.height / n.width), [
            t,
            e
        ];
    }, b = function(t, e, n, r, i, a) {
        var o = v.call(this, n, r, i), s = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString, c = l.call(this);
        if (n = o[0], r = o[1], c[i.index] = i, a) {
            a *= Math.PI / 180;
            var h = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(h),
                d(f),
                d(-1 * f),
                d(h),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, y = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var w = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, N = e.__addimage__.sHashCode = function(t) {
        var e, n, r = 0;
        if ("string" == typeof t) for(n = t.length, e = 0; e < n; e++)r = (r << 5) - r + t.charCodeAt(e), r |= 0;
        else if (A(t)) for(n = t.byteLength / 2, e = 0; e < n; e++)r = (r << 5) - r + t[e], r |= 0;
        return r;
    }, L = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, x = e.__addimage__.extractImageFromDataUrl = function(t) {
        if (null == t) return null;
        if (!(t = t.trim()).startsWith("data:")) return null;
        var e = t.indexOf(",");
        return e < 0 ? null : t.substring(0, e).trim().endsWith("base64") ? t.substring(e + 1) : null;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return t instanceof ArrayBuffer;
    };
    var A = e.__addimage__.isArrayBufferView = function(t) {
        return t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array;
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", n = A(t) ? t : new Uint8Array(t), r = 0; r < n.length; r += 8192)e += String.fromCharCode.apply(null, n.subarray(r, r + 8192));
        return e;
    };
    e.addImage = function() {
        var e, n, i, a, o, s, u, l, h;
        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], l = arguments[6], h = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], l = arguments[7], h = arguments[8]), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e = arguments[0]) && !p(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, l = f.compression || l, h = f.rotation || f.angle || h;
        }
        var d = this.internal.getFilters();
        if (void 0 === l && -1 !== d.indexOf("FlateEncode") && (l = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, l);
        return b.call(this, i, a, o, s, g, h), this;
    };
    var P = function(t, n, i, o) {
        var s, u, c;
        if ("string" == typeof t && a(t) === r) {
            t = unescape(t);
            var l = k(t, !1);
            ("" !== l || void 0 !== (l = e.loadFile(t, !0))) && (t = l);
        }
        if (p(t) && (t = g(t, n)), n = a(t, n), !d(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (c = i) || 0 === c.length) && (i = function(t) {
            return "string" == typeof t || A(t) ? N(t) : A(t.data) ? N(t.data) : null;
        }(t)), (s = m.call(this, i)) || (t instanceof Uint8Array || "RGBA" === n || (u = t, t = S(t)), s = this["process" + n.toUpperCase()](t, h.call(this), i, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : w.NONE;
        }(o), u)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        e = "boolean" != typeof e || e;
        var n, r = "";
        if ("string" == typeof t) {
            var i;
            n = null !== (i = x(t)) && void 0 !== i ? i : t;
            try {
                r = $e5456e2f96ba3898$var$f(n);
            } catch (a) {
                if (e) throw L(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + a.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return r;
    };
    e.getImageProperties = function(t) {
        var n, i, o = "";
        if (p(t) && (t = g(t)), "string" == typeof t && a(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), i = a(t), !d(i)) throw new Error("addImage does not support files of type '" + i + "', please ensure that a plugin for '" + i + "' support is added.");
        if (t instanceof Uint8Array || (t = S(t)), !(n = this["process" + i.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = i, n;
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $e5456e2f96ba3898$export$2e2bcd8739ae039.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var n, r, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), u = t.pageContext.annotations, c = !1, l = 0; l < u.length && !c; l++)switch((n = u[l]).type){
                case "link":
                    (e(n.options.url) || e(n.options.pageNumber)) && (c = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    c = !0;
            }
            if (0 != c) {
                this.internal.write("/Annots [");
                for(var h = 0; h < u.length; h++){
                    n = u[h];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(n.type){
                        case "reference":
                            this.internal.write(" " + n.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = n.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y) + "] ") + "/Contents (" + f(m(n.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (r = "/Rect [" + a(n.bounds.x + 30) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w + 30) + " " + o(n.bounds.y) + "] ") + " /Parent " + b, n.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y + n.bounds.h) + "] ";
                            var y = n.color || "#000000";
                            i = "<</Type /Annot /Subtype /FreeText " + r + "/Contents (" + f(d(n.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (n.options.name) {
                                var w = this.annotations._nameMap[n.options.name];
                                n.options.pageNumber = w.page, n.options.top = w.y;
                            } else n.options.top || (n.options.top = 0);
                            if (r = "/Rect [" + n.finalBounds.x + " " + n.finalBounds.y + " " + n.finalBounds.w + " " + n.finalBounds.h + "] ", i = "", n.options.url) i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(n.options.url)) + ") >>";
                            else if (n.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(n.options.pageNumber).objId + " 0 R", n.options.magFactor = n.options.magFactor || "XYZ", n.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + n.options.top + "]";
                                    break;
                                case "FitV":
                                    n.options.left = n.options.left || 0, i += " /FitV " + n.options.left + "]";
                                    break;
                                default:
                                    var N = o(n.options.top);
                                    n.options.left = n.options.left || 0, void 0 === n.options.zoom && (n.options.zoom = 0), i += " /XYZ " + n.options.left + " " + N + " " + n.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + n),
                h: s(e + r)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== r.maxWidth) {
            a = r.maxWidth;
            var u = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * u);
        } else a = o, i = s;
        return this.text(t, e, n, r), n += .2 * s, "center" === r.align && (e -= o / 2), "right" === r.align && (e -= o), this.link(e, n - s, a, i, r), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, n = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, r = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, u = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var c = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var l = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, h = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, r = n, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== r[t.charCodeAt(e)] ? (a++, "number" == typeof (r = r[t.charCodeAt(e)]) && (i += String.fromCharCode(r), r = n, a = 0), e === t.length - 1 && (r = n, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (r = n, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== r[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, n) {
        return o(t) ? !1 === a(t) ? -1 : !c(t) || !o(e) && !o(n) || !o(n) && s(e) || s(t) && !o(e) || s(t) && u(e) || s(t) && s(e) ? 0 : l(t) && o(e) && !s(e) && o(n) && c(n) ? 3 : s(t) || !o(n) ? 1 : 2 : -1;
    }, d = function(t) {
        var n = 0, r = 0, i = 0, a = "", s = "", u = "", c = (t = t || "").split("\\s+"), l = [];
        for(n = 0; n < c.length; n += 1){
            for(l.push(""), r = 0; r < c[n].length; r += 1)a = c[n][r], s = c[n][r - 1], u = c[n][r + 1], o(a) ? (i = f(a, s, u), l[n] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : l[n] += a;
            l[n] = h(l[n]);
        }
        return l.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, n = [];
        if (Array.isArray(e)) {
            var r = 0;
            for(n = [], r = 0; r < e.length; r += 1)Array.isArray(e[r]) ? n.push([
                d(e[r][0]),
                e[r][1],
                e[r][2]
            ]) : n.push([
                d(e[r])
            ]);
            t = n;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), $e5456e2f96ba3898$export$2e2bcd8739ae039.API.autoPrint = function(t) {
    var e;
    return (t = t || {}).variant = t.variant || "non-conform", "javascript" === t.variant ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + e + " 0 R");
    })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var n = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
            }
        });
        var r = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var n;
        if ("2d" !== (t = t || "2d")) return null;
        for(n in e)this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = e[n]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), function(e) {
    var n = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, r = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, n), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var n = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var r = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var n = (e = e || {}).fontSize || this.getFontSize(), r = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, u = 0, c = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var l = e.maxWidth;
        l > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, l) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(c.splitTextToSize(e, l));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var h = 0; h < t.length; h++)o < (u = this.getStringUnitWidth(t[h], {
            font: r
        }) * n) && (o = u);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * n * this.getLineHeightFactor() - n * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || n;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || n, u = this.internal.__cell__.tableHeaderRow, c = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, c && u && (this.printHeaderRow(t.lineNumber, !0), t.y += u[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === r ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, r, c, l, h) {
        if (i.call(this), !c) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], x = (h = h || {}).autoSize || !1, A = !1 !== h.printHeaders, S = h.css && void 0 !== h.css["font-size"] ? 16 * h.css["font-size"] : h.fontSize || 12, _ = h.margins || Object.assign({
            width: this.getPageWidth()
        }, n), P = "number" == typeof h.padding ? h.padding : 3, k = h.headerBackgroundColor || "#c8c8c8", F = h.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = A, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = F, this.setFontSize(S), null == l) v = m = Object.keys(c[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(l) && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(l[0])) for(m = l.map(function(t) {
            return t.name;
        }), v = l.map(function(t) {
            return t.prompt || t.name || "";
        }), b = l.map(function(t) {
            return t.align || "left";
        }), f = 0; f < l.length; f += 1)w[l[f].name] = .7499990551181103 * l[f].width;
        else Array.isArray(l) && "string" == typeof l[0] && (v = m = l, b = m.map(function() {
            return "left";
        }));
        if (x || Array.isArray(l) && "string" == typeof l[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = c.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (A) {
            var I = {};
            for(f = 0; f < m.length; f += 1)I[m[f]] = {}, I[m[f]].text = v[f], I[m[f]].align = b[f];
            var j = u.call(this, I, w);
            L = m.map(function(t) {
                return new o(e, r, w[t], j, I[t].text, void 0, I[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var C = l.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < c.length; f += 1){
            "rowStart" in h && h.rowStart instanceof Function && h.rowStart({
                row: f,
                data: c[f]
            }, this);
            var O = u.call(this, c[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = c[f][m[p]];
                "cellStart" in h && h.cellStart instanceof Function && h.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, r, w[m[p]], O, B, f + 2, C[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = r, this;
    };
    var u = function(t, e) {
        var n = this.internal.__cell__.padding, r = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(r) {
            var i = t[r];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[r] - n - n);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * r / i + n + n;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var n;
        if (r = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var u = [], c = 0; c < this.internal.__cell__.tableHeaderRow.length; c += 1){
            n = this.internal.__cell__.tableHeaderRow[c].clone(), e && (n.y = this.internal.__cell__.margins.top || 0, u.push(n)), n.lineNumber = t;
            var l = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, n), this.setTextColor(l);
        }
        u.length > 0 && this.setTableHeaderRow(u), this.setFont(void 0, "normal"), r = !1;
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API);
var $e5456e2f96ba3898$var$Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, $e5456e2f96ba3898$var$kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], $e5456e2f96ba3898$var$Ft = $e5456e2f96ba3898$var$_t($e5456e2f96ba3898$var$kt), $e5456e2f96ba3898$var$It = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], $e5456e2f96ba3898$var$jt = $e5456e2f96ba3898$var$_t($e5456e2f96ba3898$var$It);
function $e5456e2f96ba3898$var$Ct(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), n = function(t) {
        return $e5456e2f96ba3898$var$Pt[t = t || "normal"] ? t : "normal";
    }(t.style), r = function(t) {
        return t ? "number" == typeof t ? t >= 100 && t <= 900 && t % 100 == 0 ? t : 400 : /^\d00$/.test(t) ? parseInt(t) : "bold" === t ? 700 : 400 : 400;
    }(t.weight), i = function(t) {
        return "number" == typeof $e5456e2f96ba3898$var$Ft[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: n,
        weight: r,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                n,
                r
            ].join(" ")
        }
    };
}
function $e5456e2f96ba3898$var$Ot(t, e, n, r) {
    var i;
    for(i = n; i >= 0 && i < e.length; i += r)if (t[e[i]]) return t[e[i]];
    for(i = n; i >= 0 && i < e.length; i -= r)if (t[e[i]]) return t[e[i]];
}
var $e5456e2f96ba3898$var$Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, $e5456e2f96ba3898$var$Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function $e5456e2f96ba3898$var$qt(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function $e5456e2f96ba3898$var$Et(t) {
    return t.trimLeft();
}
function $e5456e2f96ba3898$var$Rt(t, e) {
    for(var n = 0; n < t.length;){
        if (t.charAt(n) === e) return [
            t.substring(0, n),
            t.substring(n + 1)
        ];
        n += 1;
    }
    return null;
}
function $e5456e2f96ba3898$var$Dt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var $e5456e2f96ba3898$var$Tt, $e5456e2f96ba3898$var$zt, $e5456e2f96ba3898$var$Ut, $e5456e2f96ba3898$var$Ht, $e5456e2f96ba3898$var$Wt, $e5456e2f96ba3898$var$Vt, $e5456e2f96ba3898$var$Gt, $e5456e2f96ba3898$var$Yt, $e5456e2f96ba3898$var$Jt = [
    "times"
];
function $e5456e2f96ba3898$var$Xt(t, n, r, i, a) {
    var o = 4, s = $e5456e2f96ba3898$var$$t;
    switch(a){
        case $e5456e2f96ba3898$export$2e2bcd8739ae039.API.image_compression.FAST:
            o = 1, s = $e5456e2f96ba3898$var$Zt;
            break;
        case $e5456e2f96ba3898$export$2e2bcd8739ae039.API.image_compression.MEDIUM:
            o = 6, s = $e5456e2f96ba3898$var$Qt;
            break;
        case $e5456e2f96ba3898$export$2e2bcd8739ae039.API.image_compression.SLOW:
            o = 9, s = $e5456e2f96ba3898$var$te;
    }
    t = function(t, e, n, r) {
        for(var i, a = t.length / e, o = new Uint8Array(t.length + a), s = [
            $e5456e2f96ba3898$var$Kt,
            $e5456e2f96ba3898$var$Zt,
            $e5456e2f96ba3898$var$$t,
            $e5456e2f96ba3898$var$Qt,
            $e5456e2f96ba3898$var$te
        ], u = 0; u < a; u += 1){
            var c = u * e, l = t.subarray(c, c + e);
            if (r) o.set(r(l, n, i), c + u);
            else {
                for(var h = s.length, f = [], d = 0; d < h; d += 1)f[d] = s[d](l, n, i);
                var p = $e5456e2f96ba3898$var$ne(f.concat());
                o.set(f[p], c + u);
            }
            i = l;
        }
        return o;
    }(t, n, Math.ceil(r * i / 8), s);
    var u = (0, $gCcZP.zlibSync)(t, {
        level: o
    });
    return $e5456e2f96ba3898$export$2e2bcd8739ae039.API.__addimage__.arrayBufferToBinaryString(u);
}
function $e5456e2f96ba3898$var$Kt(t) {
    var e = Array.apply([], t);
    return e.unshift(0), e;
}
function $e5456e2f96ba3898$var$Zt(t, e) {
    var n = t.length, r = [];
    r[0] = 1;
    for(var i = 0; i < n; i += 1){
        var a = t[i - e] || 0;
        r[i + 1] = t[i] - a + 256 & 255;
    }
    return r;
}
function $e5456e2f96ba3898$var$$t(t, e, n) {
    var r = t.length, i = [];
    i[0] = 2;
    for(var a = 0; a < r; a += 1){
        var o = n && n[a] || 0;
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function $e5456e2f96ba3898$var$Qt(t, e, n) {
    var r = t.length, i = [];
    i[0] = 3;
    for(var a = 0; a < r; a += 1){
        var o = t[a - e] || 0, s = n && n[a] || 0;
        i[a + 1] = t[a] + 256 - (o + s >>> 1) & 255;
    }
    return i;
}
function $e5456e2f96ba3898$var$te(t, e, n) {
    var r = t.length, i = [];
    i[0] = 4;
    for(var a = 0; a < r; a += 1){
        var o = $e5456e2f96ba3898$var$ee(t[a - e] || 0, n && n[a] || 0, n && n[a - e] || 0);
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function $e5456e2f96ba3898$var$ee(t, e, n) {
    if (t === e && e === n) return t;
    var r = Math.abs(e - n), i = Math.abs(t - n), a = Math.abs(t + e - n - n);
    return r <= i && r <= a ? t : i <= a ? e : n;
}
function $e5456e2f96ba3898$var$ne(t) {
    var e = t.map(function(t) {
        return t.reduce(function(t, e) {
            return t + Math.abs(e);
        }, 0);
    });
    return e.indexOf(Math.min.apply(null, e));
}
function $e5456e2f96ba3898$var$re(t, e, n) {
    var r = e * n, i = Math.floor(r / 8), a = 16 - (r - 8 * i + n), o = (1 << n) - 1;
    return $e5456e2f96ba3898$var$ae(t, i) >> a & o;
}
function $e5456e2f96ba3898$var$ie(t, e, n, r) {
    var i = n * r, a = Math.floor(i / 8), o = 16 - (i - 8 * a + r), s = (1 << r) - 1, u = (e & s) << o;
    !function(t, e, n) {
        if (e + 1 < t.byteLength) t.setUint16(e, n, !1);
        else {
            var r = n >> 8 & 255;
            t.setUint8(e, r);
        }
    }(t, a, $e5456e2f96ba3898$var$ae(t, a) & ~(s << o) & 65535 | u);
}
function $e5456e2f96ba3898$var$ae(t, e) {
    return e + 1 < t.byteLength ? t.getUint16(e, !1) : t.getUint8(e) << 8;
}
function $e5456e2f96ba3898$var$oe(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var n = t[e++] | t[e++] << 8, r = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << 1 + (7 & i);
    t[e++], t[e++];
    var s = null, u = null;
    a && (s = e, u = o, e += 3 * o);
    var c = !0, l = [], h = 0, f = null, d = 0, p = null;
    for(this.width = n, this.height = r; c && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    h = t[e++] | t[e++] << 8, f = t[e++], 1 & g || (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << 1 + (7 & w), x = s, A = u, S = !1;
            w >> 7 && (S = !0, x = e, A = L, e += 3 * L);
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            l.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: x,
                palette_size: A,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: h,
                disposal: d
            });
            break;
        case 59:
            c = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return l.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= l.length) throw new Error("Frame index out of range.");
        return l[t];
    }, this.decodeAndBlitFrameBGRA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $e5456e2f96ba3898$var$se(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = L, r[p++] = N, r[p++] = w, r[p++] = 255;
            }
            --h;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $e5456e2f96ba3898$var$se(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = w, r[p++] = N, r[p++] = L, r[p++] = 255;
            }
            --h;
        }
    };
}
function $e5456e2f96ba3898$var$se(t, e, n, r) {
    for(var i = t[e++], a = 1 << i, s = a + 1, u = s + 1, c = i + 1, l = (1 << c) - 1, h = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; h < 16 && 0 !== p;)f |= t[e++] << h, h += 8, 1 === p ? p = t[e++] : --p;
        if (h < c) break;
        var v = f & l;
        if (f >>= c, h -= c, v !== a) {
            if (v === s) break;
            for(var b = v < u ? v : m, y = 0, w = b; w > a;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > r) return void $e5456e2f96ba3898$var$o.log("Warning, gif stream longer than expected.");
            n[d++] = N;
            var L = d += y;
            for(b !== v && (n[d++] = N), w = b; y--;)w = g[w], n[--L] = 255 & w, w >>= 8;
            null !== m && u < 4096 && (g[u++] = m << 8 | N, u >= l + 1 && c < 12 && (++c, l = l << 1 | 1)), m = v;
        } else u = s + 1, l = (1 << (c = i + 1)) - 1, m = null;
    }
    return d !== r && $e5456e2f96ba3898$var$o.log("Warning, gif stream shorter than expected."), n;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $e5456e2f96ba3898$var$ue(t) {
    var e, n, r, i, a, o = Math.floor, s = new Array(64), u = new Array(64), c = new Array(64), l = new Array(64), h = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), x = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], A = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], F = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], I = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], j = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function C(t, e) {
        for(var n = 0, r = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = a, r++, n++;
            n *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], n = t[1] - 1; n >= 0;)e & 1 << n && (m |= 1 << v), n--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function q(t, e, n, r, i) {
        for(var a, o = i[0], s = i[240], u = function(t, e) {
            var n, r, i, a, o, s, u, c, l, h, f = 0;
            for(l = 0; l < 8; ++l){
                n = t[f], r = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], u = t[f + 6];
                var p = n + (c = t[f + 7]), g = n - c, m = r + u, v = r - u, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, x = p - w, A = m + b, S = m - b;
                t[f] = L + A, t[f + 4] = L - A;
                var _ = .707106781 * (S + x);
                t[f + 2] = x + _, t[f + 6] = x - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, F = 1.306562965 * S + P, I = .707106781 * (A = y + v), j = g + I, C = g - I;
                t[f + 5] = C + k, t[f + 3] = C - k, t[f + 1] = j + F, t[f + 7] = j - F, f += 8;
            }
            for(f = 0, l = 0; l < 8; ++l){
                n = t[f], r = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], u = t[f + 48];
                var O = n + (c = t[f + 56]), B = n - c, M = r + u, q = r - u, E = i + s, R = i - s, D = a + o, T = a - o, z = O + D, U = O - D, H = M + E, W = M - E;
                t[f] = z + H, t[f + 32] = z - H;
                var V = .707106781 * (W + U);
                t[f + 16] = U + V, t[f + 48] = U - V;
                var G = .382683433 * ((z = T + R) - (W = q + B)), Y = .5411961 * z + G, J = 1.306562965 * W + G, X = .707106781 * (H = R + q), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(l = 0; l < 64; ++l)h = t[l] * e[l], d[l] = h > 0 ? h + .5 | 0 : h - .5 | 0;
            return d;
        }(t, e), c = 0; c < 64; ++c)p[x[c]] = u[c];
        var l = p[0] - n;
        n = p[0], 0 == l ? O(r[0]) : (O(r[f[a = 32767 + l]]), O(h[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), n;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(h[a]), v++;
        }
        return 63 != g && O(o), n;
    }
    function E(t) {
        t = Math.min(Math.max(t, 1), 100), a != t && (function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], n = 0; n < 64; n++){
                var r = o((e[n] * t + 50) / 100);
                r = Math.min(Math.max(r, 1), 255), s[x[n]] = r;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var h = o((i[a] * t + 50) / 100);
                h = Math.min(Math.max(h, 1), 255), u[x[a]] = h;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)c[d] = 1 / (s[x[d]] * f[p] * f[g] * 8), l[d] = 1 / (u[x[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && E(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(u[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(A[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var n = 0; n < 16; n++)B(_[n + 1]);
            for(var r = 0; r <= 161; r++)B(P[r]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(F[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(I[o + 1]);
            for(var s = 0; s <= 161; s++)B(j[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, h = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, x, C, R, D, T, z, U = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(C = V * G + d, D = -1, T = 0, z = 0; z < 64; z++)R = C + (T = z >> 3) * V + (D = 4 * (7 & z)), G + T >= W && (R -= V * (G + 1 + T - W)), d + D >= V && (R -= d + D - V + 4), p = U[R++], N = U[R++], x = U[R++], b[z] = (L[p] + L[N + 256 | 0] + L[x + 512 | 0] >> 16) - 128, y[z] = (L[p + 768 | 0] + L[N + 1024 | 0] + L[x + 1280 | 0] >> 16) - 128, w[z] = (L[p + 1280 | 0] + L[N + 1536 | 0] + L[x + 1792 | 0] >> 16) - 128;
                o = q(b, c, o, e, r), h = q(y, l, h, n, i), f = q(w, l, f, n, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = C(A, S), n = C(k, F), r = C(_, P), i = C(I, j), function() {
        for(var t = 1, e = 2, n = 1; n <= 15; n++){
            for(var r = t; r < e; r++)f[32767 + r] = n, h[32767 + r] = [], h[32767 + r][1] = n, h[32767 + r][0] = r;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = n, h[32767 + i] = [], h[32767 + i][1] = n, h[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 | 0] = 38470 * t, L[t + 512 | 0] = 7471 * t + 32768, L[t + 768 | 0] = -11059 * t, L[t + 1024 | 0] = -21709 * t, L[t + 1280 | 0] = 32768 * t + 8421375, L[t + 1536 | 0] = -27439 * t, L[t + 1792 | 0] = -5329 * t;
    }(), E(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $e5456e2f96ba3898$var$ce(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $e5456e2f96ba3898$var$le(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function n(t, e, n) {
        for(var r = 0; 4 > r; r++)if (t[e + r] != n.charCodeAt(r)) return !0;
        return !1;
    }
    function r(t, e, n, r, i) {
        for(var a = 0; a < i; a++)t[e + a] = n[r + a];
    }
    function i(t, e, n, r) {
        for(var i = 0; i < r; i++)t[e + i] = n;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var n = [], r = 0; r < t; r++)n.push(new e);
        return n;
    }
    function s(t, e) {
        var n = [];
        return function t(n, r, i) {
            for(var a = i[r], o = 0; o < a && (n.push(i.length > r + 1 ? [] : new e), !(i.length < r + 1)); o++)t(n[o], r + 1, i);
        }(n, 0, t), n;
    }
    var u = function() {
        var t = this;
        function u(t, e) {
            for(var n = 1 << e - 1 >>> 0; t & n;)n >>>= 1;
            return n ? (t & n - 1) + n : t;
        }
        function c(t, n, r, i, a) {
            e(!(i % r));
            do t[n + (i -= r)] = a;
            while (0 < i);
        }
        function l(t, n, r, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, n, r, i, o, s) {
                var l, f, d = n, p = 1 << r, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < r), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, l = 1; 15 > l; ++l){
                    if (g[l] > 1 << l) return 0;
                    m[l + 1] = m[l] + g[l];
                }
                for(f = 0; f < o; ++f)l = i[f], 0 < i[f] && (s[m[l]++] = f);
                if (1 == m[15]) return (i = new h).g = 0, i.value = s[0], c(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, x = 1 << r;
                for(f = 0, l = 1, o = 2; l <= r; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l])(i = new h).g = l, i.value = s[f++], c(t, d + w, o, x, i), w = u(w, l);
                }
                for(l = r + 1, o = 2; 15 >= l; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l]){
                        if (i = new h, (w & y) != b) {
                            for(d += x, v = 1 << (b = l) - r; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += x = 1 << (v = b - r), t[n + (b = w & y)].g = v + r, t[n + b].value = d - n - b;
                        }
                        i.g = l - r, i.value = s[f++], c(t, d + (w >> r), o, x, i), w = u(w, l);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, n, r, i, o, s);
        }
        function h() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, h), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Rn, f);
        }
        function p(t, n, r, i) {
            e(null != t), e(null != n), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = n, t.pa = r, t.Jd = n, t.Yc = r + i, t.Zc = 4 <= i ? r + i - 4 + 1 : r, _(t);
        }
        function g(t, e) {
            for(var n = 0; 0 < e--;)n |= k(t, 128) << e;
            return n;
        }
        function m(t, e) {
            var n = g(t, e);
            return P(t) ? -n : n;
        }
        function v(t, n, r, i) {
            var a, o = 0;
            for(e(null != t), e(null != n), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += n[r + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = n, t.pa = r;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << zn - 8 >>> 0, ++t.bb, t.u -= 8;
            x(t) && (t.h = 1, t.u = 0);
        }
        function y(t, n) {
            if (e(0 <= n), !t.h && n <= Tn) {
                var r = L(t) & Dn[n];
                return t.u += n, b(t), r;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & zn - 1) >>> 0;
        }
        function x(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > zn;
        }
        function A(t, e) {
            t.u = e, t.h = x(t);
        }
        function S(t) {
            t.u >= Un && (e(t.u >= Un), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var n = t.Ca;
            0 > t.b && _(t);
            var r = t.b, i = n * e >>> 8, a = (t.I >>> r > i) + 0;
            for(a ? (n -= i, t.I -= i + 1 << r >>> 0) : n = i + 1, r = n, i = 0; 256 <= r;)i += 8, r >>= 8;
            return r = 7 ^ i + Hn[r], t.b -= r, t.Ca = (n << r) - 1, a;
        }
        function F(t, e, n) {
            t[e + 0] = n >> 24 & 255, t[e + 1] = n >> 16 & 255, t[e + 2] = n >> 8 & 255, t[e + 3] = 255 & n;
        }
        function I(t, e) {
            return t[e + 0] | t[e + 1] << 8;
        }
        function j(t, e) {
            return I(t, e) | t[e + 2] << 16;
        }
        function C(t, e) {
            return I(t, e) | I(t, e + 2) << 16;
        }
        function O(t, n) {
            var r = 1 << n;
            return e(null != t), e(0 < n), t.X = a(r), null == t.X ? 0 : (t.Mb = 32 - n, t.Xa = n, 1);
        }
        function B(t, n) {
            e(null != t), e(null != n), e(t.Xa == n.Xa), r(n.X, 0, t.X, 0, 1 << n.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function q(t, n, r, i) {
            e(null != r), e(null != i);
            var a = r[0], o = i[0];
            return 0 == a && (a = (t * o + n / 2) / n), 0 == o && (o = (n * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (r[0] = a, i[0] = o, 1);
        }
        function E(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function R(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function D(e, n) {
            t[n] = function(n, r, i, a, o, s, u) {
                var c;
                for(c = 0; c < o; ++c){
                    var l = t[e](s[u + c - 1], i, a + c);
                    s[u + c] = R(n[r + c], l);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function z(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function U(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return U(t + (t - e + .5 >> 1));
        }
        function W(t, e, n) {
            return Math.abs(e - n) - Math.abs(t - n);
        }
        function V(t, e, n, r, i, a, o) {
            for(r = a[o - 1], n = 0; n < i; ++n)a[o + n] = r = R(t[e + n], r);
        }
        function G(t, e, n, r, i) {
            var a;
            for(a = 0; a < n; ++a){
                var o = t[e + a], s = o >> 8 & 255, u = 16711935 & (u = (u = 16711935 & o) + ((s << 16) + s));
                r[i + a] = (4278255360 & o) + u >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = 255 & t, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, n, r, i, a) {
            var o;
            for(o = 0; o < r; ++o){
                var s = e[n + o], u = s >>> 8, c = s, l = 255 & (l = (l = s >>> 16) + ((t.jd << 24 >> 24) * (u << 24 >> 24) >>> 5));
                c = 255 & (c = (c += (t.hd << 24 >> 24) * (u << 24 >> 24) >>> 5) + ((t.ud << 24 >> 24) * (l << 24 >> 24) >>> 5)), i[a + o] = (4278255360 & s) + (l << 16) + c;
            }
        }
        function X(e, n, r, i, a) {
            t[n] = function(t, e, n, r, o, s, u, c, l) {
                for(r = u; r < c; ++r)for(u = 0; u < l; ++u)o[s++] = a(n[i(t[e++])]);
            }, t[e] = function(e, n, o, s, u, c, l) {
                var h = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > h) for(e = (1 << e.b) - 1, p = (1 << h) - 1; n < o; ++n){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[u++])), c[l++] = a(d[m & p]), m >>= h;
                }
                else t["VP8LMapColor" + r](s, u, d, p, c, l, n, o, f);
            };
        }
        function K(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a;
            }
        }
        function Z(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a, r[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = 240 & o | o >> 28 & 15;
                r[i++] = a, r[i++] = o;
            }
        }
        function Q(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                r[i++] = a, r[i++] = o;
            }
        }
        function tt(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = 255 & a, r[i++] = a >> 8 & 255, r[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, n, i, a, o) {
            if (0 == o) for(n = e + n; e < n;)F(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else r(i, a, t, e, n);
        }
        function nt(e, n) {
            t[n][0] = t[e + "0"], t[n][1] = t[e + "1"], t[n][2] = t[e + "2"], t[n][3] = t[e + "3"], t[n][4] = t[e + "4"], t[n][5] = t[e + "5"], t[n][6] = t[e + "6"], t[n][7] = t[e + "7"], t[n][8] = t[e + "8"], t[n][9] = t[e + "9"], t[n][10] = t[e + "10"], t[n][11] = t[e + "11"], t[n][12] = t[e + "12"], t[n][13] = t[e + "13"], t[n][14] = t[e + "0"], t[n][15] = t[e + "0"];
        }
        function rt(t) {
            return t == Ur || t == Hr || t == Wr || t == Vr;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ut() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ct(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function lt(t, e) {
            var n = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = mi[e.ba.S], u = t.y, c = t.O, l = t.f, h = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(u, c, null, null, l, h, f, d, l, h, f, d, a, o, null, null, w) : (s(e.ec, e.fc, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w), ++n); b + 2 < y; b += 2)p = l, g = h, m = f, v = d, h += t.Rc, d += t.Rc, o += 2 * i.A, s(u, (c += 2 * t.fa) - t.fa, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w);
            return c += t.fa, t.j + y < t.o ? (r(e.ec, e.fc, u, c, w), r(e.cc, e.dc, l, h, N), r(e.Mc, e.Nc, f, d, N), n--) : 1 & y || s(u, c, null, null, l, h, f, d, l, h, f, d, a, o + i.A, null, null, w), n;
        }
        function ht(t, n, r) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = n.ba.S, u = s == Dr || s == Wr;
                n = n.ba.f.RGBA;
                var c = [
                    0
                ], l = t.ka;
                c[0] = t.T, t.Kb && (0 == l ? --c[0] : (--l, a[0] -= t.width), t.j + t.ka + t.T == t.o && (c[0] = t.o - t.j - l));
                var h = n.eb;
                l = n.fb + l * n.A, t = Ar(i, a[0], t.width, o, c, h, l + (u ? 0 : 3), n.A), e(r == c), t && rt(s) && Lr(h, l, u, o, c, n.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, n = e.ba.S, r = 11 > n, i = n == qr || n == Rr || n == Dr || n == Tr || 12 == n || rt(n);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mn(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && rt(n) && bn(), t.da) alert("todo:use_scaling");
            else {
                if (r) {
                    if (e.Ib = ct, t.Kb) {
                        if (n = t.U + 1 >> 1, e.memory = a(t.U + 2 * n), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + n, e.Ib = lt, bn();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = ht, r && mn());
            }
            if (r && !Ii) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + Si >> Ai, Bi[t] = -22014 * (t - 128) + Si, Oi[t] = -45773 * (t - 128), Ci[t] = 113618 * (t - 128) + Si >> Ai;
                for(t = _i; t < Pi; ++t)e = 76283 * (t - 16) + Si >> Ai, Mi[t - _i] = Vt(e, 255), qi[t - _i] = Vt(e + 8 >> 4, 15);
                Ii = 1;
            }
            return 1;
        }
        function dt(t) {
            var n = t.ma, r = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= r || 0 >= i ? 0 : (r = n.Ib(t, n), null != n.Jb && n.Jb(t, n, r), n.Dc += r, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, n, r) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, n[0] = y(t, 14) + 1, r[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var n = t - 2 >> 1;
            return (2 + (1 & t) << n) + y(e, n) + 1;
        }
        function vt(t, e) {
            var n;
            return 120 < e ? e - 120 : 1 <= (n = ((n = Zr[e - 1]) >> 4) * t + (8 - (15 & n))) ? n : 1;
        }
        function bt(t, e, n) {
            var r = L(n), i = t[e += 255 & r].g - 8;
            return 0 < i && (A(n, n.u + 8), r = L(n), e += t[e].value, e += r & (1 << i) - 1), A(n, n.u + t[e].g), t[e].value;
        }
        function yt(t, n, r) {
            return r.g += t.g, r.value += t.value << n >>> 0, e(8 >= r.g), t.g;
        }
        function wt(t, n, r) {
            var i = t.xc;
            return e((n = 0 == i ? 0 : t.vc[t.md * (r >> i) + (n >> i)]) < t.Wb), t.Ya[n];
        }
        function Nt(t, n, i, a) {
            var o = t.ab, s = t.c * n, u = t.C;
            n = u + n;
            var c = i, l = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var h = t.gc[o], f = u, d = n, p = c, g = l, m = (l = a, c = i, h.Ea);
                switch(e(f < d), e(d <= h.nc), h.hc){
                    case 2:
                        Gn(p, g, (d - f) * m, l, c);
                        break;
                    case 0:
                        var v = f, b = d, y = l, w = c, N = (_ = h).Ea;
                        0 == v && (Wn(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, x = L - 1, A = E(N, _.b), S = _.K, _ = _.w + (v >> _.b) * A; v < b;){
                            var P = S, k = _, F = 1;
                            for(Vn(p, g, y, w - N, 1, y, w); F < N;){
                                var I = (F & ~x) + L;
                                I > N && (I = N), (0, Zn[P[k++] >> 8 & 15])(p, g + +F, y, w + F - N, I - F, y, w + F), F = I;
                            }
                            g += N, w += N, ++v & x || (_ += A);
                        }
                        d != h.nc && r(l, c - m, l, c + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = h.Ea) - (w = p & ~(y = (g = 1 << h.b) - 1)), v = E(p, h.b), L = h.K, h = h.w + (f >> h.b) * v; f < d;){
                            for(x = L, A = h, S = new T, _ = b + w, P = b + p; b < _;)Y(x[A++], S), $n(S, m, b, g, l, c), b += g, c += g;
                            b < P && (Y(x[A++], S), $n(S, m, b, N, l, c), b += N, c += N), ++f & y || (h += v);
                        }
                        break;
                    case 3:
                        if (p == l && g == c && 0 < h.b) {
                            for(b = l, p = m = c + (d - f) * m - (w = (d - f) * E(h.Ea, h.b)), g = l, y = c, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yn(h, f, d, l, m, l, c);
                        } else Yn(h, f, d, p, g, l, c);
                }
                c = a, l = i;
            }
            l != i && r(a, i, c, l, s);
        }
        function Lt(t, n) {
            var r = t.V, i = t.Ba + t.c * t.C, a = n - t.C;
            if (e(n <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, u = t.Ua, c = o.width;
                if (Nt(t, a, r, i), a = u = [
                    u
                ], e((r = t.C) < (i = n)), e(o.v < o.va), i > o.o && (i = o.o), r < o.j) {
                    var l = o.j - r;
                    r = o.j, a[0] += l * c;
                }
                if (r >= i ? r = 0 : (a[0] += 4 * o.v, o.ka = r - o.j, o.U = o.va - o.v, o.T = i - r, r = 1), r) {
                    if (u = u[0], 11 > (r = t.ca).S) {
                        var h = r.f.RGBA, f = (i = r.S, a = o.U, o = o.T, l = h.eb, h.A), d = o;
                        for(h = h.fb + t.Ma * h.A; 0 < d--;){
                            var p = s, g = u, m = a, v = l, b = h;
                            switch(i){
                                case Mr:
                                    Qn(p, g, m, v, b);
                                    break;
                                case qr:
                                    tr(p, g, m, v, b);
                                    break;
                                case Ur:
                                    tr(p, g, m, v, b), Lr(v, b, 0, m, 1, 0);
                                    break;
                                case Er:
                                    rr(p, g, m, v, b);
                                    break;
                                case Rr:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Hr:
                                    et(p, g, m, v, b, 1), Lr(v, b, 0, m, 1, 0);
                                    break;
                                case Dr:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Wr:
                                    et(p, g, m, v, b, 0), Lr(v, b, 1, m, 1, 0);
                                    break;
                                case Tr:
                                    er(p, g, m, v, b);
                                    break;
                                case Vr:
                                    er(p, g, m, v, b), xr(v, b, m, 1, 0);
                                    break;
                                case zr:
                                    nr(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            u += c, h += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= r.height);
                }
            }
            t.C = n, e(t.C <= t.i);
        }
        function xt(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var n = t.Ya[e].G, r = t.Ya[e].H;
                if (0 < n[1][r[1] + 0].g || 0 < n[2][r[2] + 0].g || 0 < n[3][r[3] + 0].g) return 0;
            }
            return 1;
        }
        function At(t, n, r, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, u = t.rd;
                for(e(null != gi[t.Z]); n < r; ++n)gi[t.Z](s, u, i, a, i, a, o), s = i, u = a, a += o;
                t.qd = s, t.rd = u;
            }
        }
        function St(t, n) {
            var r = t.l.ma, i = 0 == r.Z || 1 == r.Z ? t.l.j : t.C;
            if (i = t.C < i ? i : t.C, e(n <= t.l.o), n > i) {
                var a = t.l.width, o = r.ca, s = r.tb + a * i, u = t.V, c = t.Ba + t.c * i, l = t.gc;
                e(1 == t.ab), e(3 == l[0].hc), Xn(l[0], i, n, u, c, o, s), At(r, i, n, o, s, a);
            }
            t.C = t.Ma = n;
        }
        function _t(t, n, r, i, a, o, s) {
            var u = t.$ / i, c = t.$ % i, l = t.m, h = t.s, f = r + t.$, d = f;
            a = r + i * a;
            var p = r + i * o, g = 280 + h.ua, m = t.Pb ? u : 16777216, v = 0 < h.ua ? h.Wa : null, b = h.wc, y = f < p ? wt(h, c, u) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (u >= m) {
                        var _ = f - r;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = u + Qr;
                    }
                    if (c & b || (y = wt(h, c, u)), e(null != y), y.Qb && (n[f] = y.qb, w = !0), !w) {
                        if (S(l), y.jc) {
                            N = l, _ = n;
                            var P = f, k = y.pd[L(N) & Rn - 1];
                            e(y.jc), 256 > k.g ? (A(N, N.u + k.g), _[P] = k.value, N = 0) : (A(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], l);
                    }
                    if (l.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) n[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(l), w = bt(y.G[1], y.H[1], l), S(l), _ = bt(y.G[2], y.H[2], l), P = bt(y.G[3], y.H[3], l), l.h) break;
                                n[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++c >= i && (c = 0, ++u, null != s && u <= o && !(u % 16) && s(t, u), null != v)) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, l), _ = bt(y.G[4], y.H[4], l), S(l), _ = vt(i, _ = mt(_, l)), l.h) break;
                        if (f - r < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)n[f + P] = n[f + P - _];
                        for(f += N, c += N; c >= i;)c -= i, ++u, null != s && u <= o && !(u % 16) && s(t, u);
                        if (e(f <= a), c & b && (y = wt(h, c, u)), null != v) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), n[N] = _.X[w], w = !0;
                    }
                    w || e(l.h == x(l));
                }
                if (t.Pb && l.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (l.h) break t;
                    null != s && s(t, u > o ? o : u), t.a = 0, t.$ = f - r;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var n = t.Wa;
            null != n && (n.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new on;
            return null == e ? null : (e.a = 0, e.xb = pi, nt("Predictor", "VP8LPredictors"), nt("Predictor", "VP8LPredictors_C"), nt("PredictorAdd", "VP8LPredictorsAdd"), nt("PredictorAdd", "VP8LPredictorsAdd_C"), Gn = G, $n = J, Qn = K, tr = Z, er = $, nr = Q, rr = tt, t.VP8LMapColor32b = Jn, t.VP8LMapColor8b = Kn, e);
        }
        function Ft(t, n, r, s, u) {
            var c = 1, f = [
                t
            ], p = [
                n
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (r) for(; c && y(g, 1);){
                    var w = f, N = p, x = s, _ = 1, P = x.m, k = x.gc[x.ab], F = y(P, 2);
                    if (x.Oc & 1 << F) c = 0;
                    else {
                        switch(x.Oc |= 1 << F, k.hc = F, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++x.ab, e(4 >= x.ab), F){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = Ft(E(k.Ea, k.b), E(k.nc, k.b), 0, x, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var I, j = y(P, 8) + 1, C = 16 < j ? 0 : 4 < j ? 1 : 2 < j ? 2 : 3;
                                if (w[0] = E(k.Ea, C), k.b = C, I = _ = Ft(j, 1, 0, x, k.K)) {
                                    var B, M = j, q = k, D = 1 << (8 >> q.b), T = a(D);
                                    if (null == T) I = 0;
                                    else {
                                        var z = q.K[0], U = q.w;
                                        for(T[0] = q.K[0][0], B = 1; B < 1 * M; ++B)T[B] = R(z[U + B], T[B - 1]);
                                        for(; B < 4 * D; ++B)T[B] = 0;
                                        q.K[0] = null, q.K[0] = T, I = 1;
                                    }
                                }
                                _ = I;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        c = _;
                    }
                }
                if (f = f[0], p = p[0], c && y(g, 1) && !(c = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = c) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = r, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, nt = 0, rt = $r[K];
                    n: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = E(J, it), ot = E(X, it), st = at * ot;
                            if (!Ft(at, ot, 0, Y, tt)) break n;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ut = tt[W] >> 8 & 65535;
                                tt[W] = ut, ut >= et && (et = ut + 1);
                            }
                        }
                        if ($.h) break n;
                        for(V = 0; 5 > V; ++V){
                            var ct = Jr[V];
                            !V && 0 < K && (ct += 1 << K), nt < ct && (nt = ct);
                        }
                        var lt = o(et * rt, h), ht = et, ft = o(ht, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= ht), dt = ft;
                        var pt = a(nt);
                        if (null == dt || null == pt || null == lt) {
                            Y.a = 1;
                            break n;
                        }
                        var gt = lt;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ct = Jr[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ct += 1 << K);
                                r: {
                                    var xt, At = ct, St = Y, kt = pt, It = gt, jt = G, Ct = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, At), Bt) {
                                        var Mt = y(Ot, 1) + 1, qt = y(Ot, 1), Et = y(Ot, 0 == qt ? 1 : 8);
                                        kt[Et] = 1, 2 == Mt && (kt[Et = y(Ot, 8)] = 1);
                                        var Rt = 1;
                                    } else {
                                        var Dt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var zt = 0;
                                            break r;
                                        }
                                        for(xt = 0; xt < Tt; ++xt)Dt[Kr[xt]] = y(Ot, 3);
                                        var Ut = void 0, Ht = void 0, Wt = St, Vt = Dt, Gt = At, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, h);
                                        i: for(; l(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((Ut = 2 + y(Xt, $t)) > Gt) break i;
                                            } else Ut = Gt;
                                            for(Ht = 0; Ht < Gt && Ut--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                A(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, ne = te - 16, re = Yr[ne], ie = y(Xt, Gr[ne]) + re;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Rt = Jt;
                                    }
                                    (Rt = Rt && !Ot.h) && (Ct = l(It, jt, 8, kt, At)), Rt && 0 != Ct ? zt = Ct : (St.a = 3, zt = 0);
                                }
                                if (0 == zt) break n;
                                if (Nt && 1 == Xr[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += zt, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ct; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ue, ce = mt;
                                for(ue = 0; ue < Rn; ++ue){
                                    var le = ue, he = ce.pd[le], fe = ce.G[0][ce.H[0] + le];
                                    256 <= fe.value ? (he.g = fe.g + 256, he.value = fe.value) : (he.g = 0, he.value = 0, le >>= yt(fe, 8, he), le >>= yt(ce.G[1][ce.H[1] + le], 16, he), le >>= yt(ce.G[2][ce.H[2] + le], 0, he), yt(ce.G[3][ce.H[3] + le], 24, he));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = lt, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(c = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, c = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = E(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, r) {
                    s.xb = di;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, c = 0;
                    break t;
                }
                c = (c = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return c ? (null != u ? u[0] = v : (e(null == v), e(r)), s.$ = 0, r || Pt(m)) : Pt(m), c;
        }
        function It(t, n) {
            var r = t.c * t.i, i = r + n + 16 * n;
            return e(t.c <= n), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + r + n, 1);
        }
        function jt(t, n) {
            var r = t.C, i = n - r, a = t.V, o = t.Ba + t.c * r;
            for(e(n <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, u = t.l.ma, c = t.l.width, l = c * s, h = u.ca, f = u.tb + c * r, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), Sr(d, p, h, f, l), At(u, r, r + s, h, f, c), i -= s, a += s * t.c, r += s;
            }
            e(r == n), t.C = t.Ma = n;
        }
        function Ct() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, n, r) {
                    for(var i = r[n], a = 0; a < i && (e.push(r.length > n + 1 ? [] : 0), !(r.length < n + 1)); a++)t(e[a], n + 1, r);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function qt() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function Et() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Rt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Dt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function zt() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function Ut() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Rt), this.Y = 0, this.ya = Array(new zt), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new Ct, this.Kc = new Ot, this.ed = new Et, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new Ut, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new qt, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Dt), this.sb = 0, this.wa = Array(new Rt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new zt), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Rt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
        }
        function Jt(t, e, n) {
            return 0 == t.a && (t.a = e, t.sc = n, t.cb = 0), 0;
        }
        function Xt(t, e, n) {
            return 3 <= n && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, n) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == n) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var r = n.data, a = n.w, o = n.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = r[a + 0] | r[a + 1] << 8 | r[a + 2] << 16, u = t.Od;
            if (u.Rb = !(1 & s), u.td = s >> 1 & 7, u.yd = s >> 4 & 1, u.ub = s >> 5, 3 < u.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!u.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var c = t.Kc;
            if (u.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(r, a, o)) return Jt(t, 3, "Bad code word");
                c.c = 16383 & (r[a + 4] << 8 | r[a + 3]), c.Td = r[a + 4] >> 6, c.i = 16383 & (r[a + 6] << 8 | r[a + 5]), c.Ud = r[a + 6] >> 6, a += 7, o -= 7, t.za = c.c + 15 >> 4, t.Ub = c.i + 15 >> 4, n.width = c.c, n.height = c.i, n.Da = 0, n.j = 0, n.v = 0, n.va = n.width, n.o = n.height, n.da = 0, n.ib = n.width, n.hb = n.height, n.U = n.width, n.T = n.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (u.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, r, a, u.ub), a += u.ub, o -= u.ub, u.Rb && (c.Ld = P(s), c.Kd = P(s)), c = t.Qa;
            var l, h = t.Pa;
            if (e(null != s), e(null != c), c.Cb = P(s), c.Cb) {
                if (c.Bb = P(s), P(s)) {
                    for(c.Fb = P(s), l = 0; 4 > l; ++l)c.Zb[l] = P(s) ? m(s, 7) : 0;
                    for(l = 0; 4 > l; ++l)c.Lb[l] = P(s) ? m(s, 6) : 0;
                }
                if (c.Bb) for(l = 0; 3 > l; ++l)h.jb[l] = P(s) ? g(s, 8) : 255;
            } else c.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((c = t.ed).zd = P(s), c.Tb = g(s, 6), c.wb = g(s, 3), c.Pc = P(s), c.Pc && P(s)) {
                for(h = 0; 4 > h; ++h)P(s) && (c.vd[h] = m(s, 6));
                for(h = 0; 4 > h; ++h)P(s) && (c.od[h] = m(s, 6));
            }
            if (t.L = 0 == c.Tb ? 0 : c.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = l = a, a = l + f, c = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (h = t.Xb)) r = 7;
            else {
                for(l += 3 * h, c -= 3 * h, f = 0; f < h; ++f){
                    var d = r[o + 0] | r[o + 1] << 8 | r[o + 2] << 16;
                    d > c && (d = c), p(t.Jc[+f], r, l, d), l += d, c -= d, o += 3;
                }
                p(t.Jc[+h], r, l, c), r = l < a ? 0 : 5;
            }
            if (0 != r) return Jt(t, r, "cannot parse partitions");
            for(r = g(l = t.m, 7), o = P(l) ? m(l, 4) : 0, a = P(l) ? m(l, 4) : 0, c = P(l) ? m(l, 4) : 0, h = P(l) ? m(l, 4) : 0, l = P(l) ? m(l, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += r);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = r;
                }
                var b = t.pb[d];
                b.Sc[0] = ti[Vt(v + o, 127)], b.Sc[1] = ei[Vt(v + 0, 127)], b.Eb[0] = 2 * ti[Vt(v + a, 127)], b.Eb[1] = 101581 * ei[Vt(v + c, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ti[Vt(v + h, 117)], b.Qc[1] = ei[Vt(v + l, 127)], b.lc = v + l;
            }
            if (!u.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), u = t.Pa, r = 0; 4 > r; ++r){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(c = 0; 11 > c; ++c)h = k(s, ui[r][o][a][c]) ? g(s, 8) : oi[r][o][a][c], u.Wc[r][o].Yb[a][c] = h;
                for(o = 0; 17 > o; ++o)u.Xc[r][o] = u.Wc[r][ci[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, n, r, i, a, o) {
            var s = e[i].Yb[n];
            for(n = 0; 16 > i; ++i){
                if (!k(t, s[n + 0])) return i;
                for(; !k(t, s[n + 1]);)if (s = e[++i].Yb[0], n = 0, 16 == i) return 16;
                var u = e[i + 1].Yb;
                if (k(t, s[n + 2])) {
                    var c = t, l = 0;
                    if (k(c, (f = s)[(h = n) + 3])) {
                        if (k(c, f[h + 6])) {
                            for(s = 0, h = 2 * (l = k(c, f[h + 8])) + (f = k(c, f[h + 9 + l])), l = 0, f = ri[h]; f[s]; ++s)l += l + k(c, f[s]);
                            l += 3 + (8 << h);
                        } else k(c, f[h + 7]) ? (l = 7 + 2 * k(c, 165), l += k(c, 145)) : l = 5 + k(c, 159);
                    } else l = k(c, f[h + 4]) ? 3 + k(c, f[h + 5]) : 2;
                    s = u[2];
                } else l = 1, s = u[1];
                u = o + ii[i], 0 > (c = t).b && _(c);
                var h, f = c.b, d = (h = c.Ca >> 1) - (c.I >> f) >> 31;
                --c.b, c.Ca += d, c.Ca |= 1, c.I -= (h + 1 & d) << f, a[u] = ((l ^ d) - d) * r[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, e, n, r, i) {
            i = t[e + n + 32 * r] + (i >> 3), t[e + n + 32 * r] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function te(t, e, n, r, i, a) {
            Qt(t, e, 0, n, r + i), Qt(t, e, 1, n, r + a), Qt(t, e, 2, n, r - a), Qt(t, e, 3, n, r - i);
        }
        function ee(t) {
            return (20091 * t >> 16) + t;
        }
        function ne(t, e, n, r) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var u = t[e + 0] + t[e + 8], c = t[e + 0] - t[e + 8], l = (35468 * t[e + 4] >> 16) - ee(t[e + 12]), h = ee(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = u + h, s[o + 1] = c + l, s[o + 2] = c - l, s[o + 3] = u - h, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)u = (t = s[o + 0] + 4) + s[o + 8], c = t - s[o + 8], l = (35468 * s[o + 4] >> 16) - ee(s[o + 12]), Qt(n, r, 0, 0, u + (h = ee(s[o + 4]) + (35468 * s[o + 12] >> 16))), Qt(n, r, 1, 0, c + l), Qt(n, r, 2, 0, c - l), Qt(n, r, 3, 0, u - h), o++, r += 32;
        }
        function re(t, e, n, r) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = ee(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            te(n, r, 0, i + o, t = ee(t[e + 1]), s), te(n, r, 1, i + a, t, s), te(n, r, 2, i - a, t, s), te(n, r, 3, i - o, t, s);
        }
        function ie(t, e, n, r, i) {
            ne(t, e, n, r), i && ne(t, e + 16, n, r + 4);
        }
        function ae(t, e, n, r) {
            ar(t, e + 0, n, r, 1), ar(t, e + 32, n, r + 128, 1);
        }
        function oe(t, e, n, r) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)Qt(n, r, e, i, t);
        }
        function se(t, e, n, r) {
            t[e + 0] && ur(t, e + 0, n, r), t[e + 16] && ur(t, e + 16, n, r + 4), t[e + 32] && ur(t, e + 32, n, r + 128), t[e + 48] && ur(t, e + 48, n, r + 128 + 4);
        }
        function ue(t, e, n, r) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], u = t[e + 4 + i] + t[e + 8 + i], c = t[e + 4 + i] - t[e + 8 + i], l = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + u, o[8 + i] = s - u, o[4 + i] = l + c, o[12 + i] = l - c;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], u = o[1 + 4 * i] + o[2 + 4 * i], c = o[1 + 4 * i] - o[2 + 4 * i], l = t - o[3 + 4 * i], n[r + 0] = s + u >> 3, n[r + 16] = l + c >> 3, n[r + 32] = s - u >> 3, n[r + 48] = l - c >> 3, r += 64;
        }
        function ce(t, e, n) {
            var r, i = e - 32, a = Or, o = 255 - t[i - 1];
            for(r = 0; r < n; ++r){
                var s, u = a, c = o + t[e - 1];
                for(s = 0; s < n; ++s)t[e + s] = u[c + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            ce(t, e, 4);
        }
        function he(t, e) {
            ce(t, e, 8);
        }
        function fe(t, e) {
            ce(t, e, 16);
        }
        function de(t, e) {
            var n;
            for(n = 0; 16 > n; ++n)r(t, e + 32 * n, t, e - 32, 16);
        }
        function pe(t, e) {
            var n;
            for(n = 16; 0 < n; --n)i(t, e, t[e - 1], 16), e += 32;
        }
        function ge(t, e, n) {
            var r;
            for(r = 0; 16 > r; ++r)i(e, n + 32 * r, t, 16);
        }
        function me(t, e) {
            var n, r = 16;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n] + t[e + n - 32];
            ge(r >> 5, t, e);
        }
        function ve(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n];
            ge(r >> 4, t, e);
        }
        function be(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e + n - 32];
            ge(r >> 4, t, e);
        }
        function ye(t, e) {
            ge(128, t, e);
        }
        function we(t, e, n) {
            return t + 2 * e + n + 2 >> 2;
        }
        function Ne(t, e) {
            var n, i = e - 32;
            for(i = new Uint8Array([
                we(t[i - 1], t[i + 0], t[i + 1]),
                we(t[i + 0], t[i + 1], t[i + 2]),
                we(t[i + 1], t[i + 2], t[i + 3]),
                we(t[i + 2], t[i + 3], t[i + 4])
            ]), n = 0; 4 > n; ++n)r(t, e + 32 * n, i, 0, i.length);
        }
        function Le(t, e) {
            var n = t[e - 1], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            F(t, e + 0, 16843009 * we(t[e - 1 - 32], n, r)), F(t, e + 32, 16843009 * we(n, r, i)), F(t, e + 64, 16843009 * we(r, i, a)), F(t, e + 96, 16843009 * we(i, a, a));
        }
        function xe(t, e) {
            var n, r = 4;
            for(n = 0; 4 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            for(r >>= 3, n = 0; 4 > n; ++n)i(t, e + 32 * n, r, 4);
        }
        function Ae(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 96] = we(r, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = we(n, r, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = we(a, n, r), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = we(o, a, n), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = we(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = we(u, s, o), t[e + 3 + 0] = we(c, u, s);
        }
        function Se(t, e) {
            var n = t[e + 1 - 32], r = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = we(t[e + 0 - 32], n, r), t[e + 1 + 0] = t[e + 0 + 32] = we(n, r, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = we(r, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = we(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = we(o, s, u), t[e + 3 + 96] = we(s, u, u);
        }
        function _e(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + u + 1 >> 1, t[e + 3 + 0] = u + c + 1 >> 1, t[e + 0 + 96] = we(i, r, n), t[e + 0 + 64] = we(r, n, a), t[e + 0 + 32] = t[e + 1 + 96] = we(n, a, o), t[e + 1 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = we(o, s, u), t[e + 3 + 32] = we(s, u, c);
        }
        function Pe(t, e) {
            var n = t[e + 0 - 32], r = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], u = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = r + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = we(n, r, i), t[e + 1 + 32] = t[e + 0 + 96] = we(r, i, a), t[e + 2 + 32] = t[e + 1 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 3 + 64] = we(o, s, u), t[e + 3 + 96] = we(s, u, c);
        }
        function ke(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = r + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = we(n, r, i), t[e + 3 + 0] = t[e + 1 + 32] = we(r, i, a), t[e + 3 + 32] = t[e + 1 + 64] = we(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], u = t[e + 1 - 32], c = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = n + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = r + n + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + r + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = we(s, u, c), t[e + 2 + 0] = we(o, s, u), t[e + 1 + 0] = t[e + 3 + 32] = we(n, o, s), t[e + 1 + 32] = t[e + 3 + 64] = we(r, n, o), t[e + 1 + 64] = t[e + 3 + 96] = we(i, r, n), t[e + 1 + 96] = we(a, i, r);
        }
        function Ie(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)r(t, e + 32 * n, t, e - 32, 8);
        }
        function je(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)i(t, e, t[e - 1], 8), e += 32;
        }
        function Ce(t, e, n) {
            var r;
            for(r = 0; 8 > r; ++r)i(e, n + 32 * r, t, 8);
        }
        function Oe(t, e) {
            var n, r = 8;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            Ce(r >> 4, t, e);
        }
        function Be(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32];
            Ce(r >> 3, t, e);
        }
        function Me(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e - 1 + 32 * n];
            Ce(r >> 3, t, e);
        }
        function qe(t, e) {
            Ce(128, t, e);
        }
        function Ee(t, e, n) {
            var r = t[e - n], i = t[e + 0], a = 3 * (i - r) + jr[1020 + t[e - 2 * n] - t[e + n]], o = Cr[112 + (a + 4 >> 3)];
            t[e - n] = Or[255 + r + Cr[112 + (a + 3 >> 3)]], t[e + 0] = Or[255 + i - o];
        }
        function Re(t, e, n, r) {
            var i = t[e + 0], a = t[e + n];
            return Br[255 + t[e - 2 * n] - t[e - n]] > r || Br[255 + a - i] > r;
        }
        function De(t, e, n, r) {
            return 4 * Br[255 + t[e - n] - t[e + 0]] + Br[255 + t[e - 2 * n] - t[e + n]] <= r;
        }
        function Te(t, e, n, r, i) {
            var a = t[e - 3 * n], o = t[e - 2 * n], s = t[e - n], u = t[e + 0], c = t[e + n], l = t[e + 2 * n], h = t[e + 3 * n];
            return 4 * Br[255 + s - u] + Br[255 + o - c] > r ? 0 : Br[255 + t[e - 4 * n] - a] <= i && Br[255 + a - o] <= i && Br[255 + o - s] <= i && Br[255 + h - l] <= i && Br[255 + l - c] <= i && Br[255 + c - u] <= i;
        }
        function ze(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r, n, i) && Ee(t, e + r, n);
        }
        function Ue(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r * n, 1, i) && Ee(t, e + r * n, 1);
        }
        function He(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * n, n, r);
        }
        function We(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)Ue(t, e += 4, n, r);
        }
        function Ve(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, n, a, o)) {
                    if (Re(t, e, n, s)) Ee(t, e, n);
                    else {
                        var u = t, c = e, l = n, h = u[c - 2 * l], f = u[c - l], d = u[c + 0], p = u[c + l], g = u[c + 2 * l], m = 27 * (b = jr[1020 + 3 * (d - f) + jr[1020 + h - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        u[c - 3 * l] = Or[255 + u[c - 3 * l] + b], u[c - 2 * l] = Or[255 + h + v], u[c - l] = Or[255 + f + m], u[c + 0] = Or[255 + d - m], u[c + l] = Or[255 + p - v], u[c + 2 * l] = Or[255 + g - b];
                    }
                }
                e += r;
            }
        }
        function Ge(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, n, a, o)) {
                    if (Re(t, e, n, s)) Ee(t, e, n);
                    else {
                        var u = t, c = e, l = n, h = u[c - l], f = u[c + 0], d = u[c + l], p = Cr[112 + (4 + (g = 3 * (f - h)) >> 3)], g = Cr[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        u[c - 2 * l] = Or[255 + u[c - 2 * l] + m], u[c - l] = Or[255 + h + g], u[c + 0] = Or[255 + f - p], u[c + l] = Or[255 + d - m];
                    }
                }
                e += r;
            }
        }
        function Ye(t, e, n, r, i, a) {
            Ve(t, e, n, 1, 16, r, i, a);
        }
        function Je(t, e, n, r, i, a) {
            Ve(t, e, 1, n, 16, r, i, a);
        }
        function Xe(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4 * n, n, 1, 16, r, i, a);
        }
        function Ke(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4, 1, n, 16, r, i, a);
        }
        function Ze(t, e, n, r, i, a, o, s) {
            Ve(t, e, i, 1, 8, a, o, s), Ve(n, r, i, 1, 8, a, o, s);
        }
        function $e(t, e, n, r, i, a, o, s) {
            Ve(t, e, 1, i, 8, a, o, s), Ve(n, r, 1, i, 8, a, o, s);
        }
        function Qe(t, e, n, r, i, a, o, s) {
            Ge(t, e + 4 * i, i, 1, 8, a, o, s), Ge(n, r + 4 * i, i, 1, 8, a, o, s);
        }
        function tn(t, e, n, r, i, a, o, s) {
            Ge(t, e + 4, 1, i, 8, a, o, s), Ge(n, r + 4, 1, i, 8, a, o, s);
        }
        function en() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ut, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function nn() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function rn() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function an() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new h;
        }
        function on() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new an, this.ab = 0, this.gc = o(4, rn), this.Oc = 0;
        }
        function sn() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function un(t, e, n, r, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + n[r + e] & 255, t = i[a + e];
        }
        function cn(t, e, n, r, i, a, o) {
            var s;
            if (null == t) un(null, null, n, r, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + n[r + s] & 255;
        }
        function ln(t, e, n, r, i, a, o) {
            if (null == t) un(null, null, n, r, i, a, o);
            else {
                var s, u = t[e + 0], c = u, l = u;
                for(s = 0; s < o; ++s)c = l + (u = t[e + s]) - c, l = n[r + s] + (-256 & c ? 0 > c ? 0 : 255 : c) & 255, c = u, i[a + s] = l;
            }
        }
        function hn(t, n, i, o) {
            var s = n.width, u = n.o;
            if (e(null != t && null != n), 0 > i || 0 >= o || i + o > u) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var c;
                    if (t.ga = new sn, (c = null == t.ga) || (c = n.width * n.o, e(0 == t.Gb.length), t.Gb = a(c), t.Uc = 0, null == t.Gb ? c = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, c = 1), c = !c), !c) {
                        c = t.ga;
                        var l = t.Fa, h = t.P, f = t.qc, d = t.mb, p = t.nb, g = h + 1, m = f - 1, b = c.l;
                        if (e(null != l && null != d && null != n), gi[0] = null, gi[1] = un, gi[2] = cn, gi[3] = ln, c.ca = d, c.tb = p, c.c = n.width, c.i = n.height, e(0 < c.c && 0 < c.i), 1 >= f) n = 0;
                        else if (c.$a = 3 & l[h + 0], c.Z = l[h + 0] >> 2 & 3, c.Lc = l[h + 0] >> 4 & 3, h = l[h + 0] >> 6 & 3, 0 > c.$a || 1 < c.$a || 4 <= c.Z || 1 < c.Lc || h) n = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = c, b.width = n.width, b.height = n.height, b.Da = n.Da, b.v = n.v, b.va = n.va, b.j = n.j, b.o = n.o, c.$a) t: {
                            e(1 == c.$a), n = kt();
                            e: for(;;){
                                if (null == n) {
                                    n = 0;
                                    break t;
                                }
                                if (e(null != c), c.mc = n, n.c = c.c, n.i = c.i, n.l = c.l, n.l.ma = c, n.l.width = c.c, n.l.height = c.i, n.a = 0, v(n.m, l, g, m), !Ft(c.c, c.i, 1, n, null)) break e;
                                if (1 == n.ab && 3 == n.gc[0].hc && xt(n.s) ? (c.ic = 1, l = n.c * n.i, n.Ta = null, n.Ua = 0, n.V = a(l), n.Ba = 0, null == n.V ? (n.a = 1, n = 0) : n = 1) : (c.ic = 0, n = It(n, c.c)), !n) break e;
                                n = 1;
                                break t;
                            }
                            c.mc = null, n = 0;
                        }
                        else n = m >= c.c * c.i;
                        c = !n;
                    }
                    if (c) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = u - i;
                }
                e(null != t.ga), e(i + o <= u);
                t: {
                    if (n = (l = t.ga).c, u = l.l.o, 0 == l.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, h = t.P + 1 + i * n, f = t.mb, d = t.nb + i * n, e(h <= t.P + t.qc), 0 != l.Z) for(e(null != gi[l.Z]), c = 0; c < o; ++c)gi[l.Z](g, m, b, h, f, d, n), g = f, m = d, d += n, h += n;
                        else for(c = 0; c < o; ++c)r(f, d, b, h, n), g = f, m = d, d += n, h += n;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != l.mc), n = i + o, e(null != (c = l.mc)), e(n <= c.i), c.C >= n) n = 1;
                        else if (l.ic || mn(), l.ic) {
                            l = c.V, g = c.Ba, m = c.c;
                            var y = c.i, w = (b = 1, h = c.$ / m, f = c.$ % m, d = c.m, p = c.s, c.$), N = m * y, L = m * n, A = p.wc, _ = w < L ? wt(p, f, h) : null;
                            e(w <= N), e(n <= y), e(xt(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & A || (_ = wt(p, f, h)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) l[g + w] = y, ++w, ++f >= m && (f = 0, ++h <= n && !(h % 16) && St(c, h));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)l[g + w + P] = l[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++h <= n && !(h % 16) && St(c, h);
                                        w < L && f & A && (_ = wt(p, f, h));
                                    }
                                    e(d.h == x(d));
                                }
                                St(c, h > n ? n : h);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, c.a = d.h ? 5 : 3) : c.$ = w, n = b;
                        } else n = _t(c, c.V, c.Ba, c.c, c.i, n, jt);
                        if (!n) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= u && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fn(t, e, n, r, i, a) {
            for(; 0 < i--;){
                var o, s = t, u = e + (n ? 1 : 0), c = t, l = e + (n ? 0 : 3);
                for(o = 0; o < r; ++o){
                    var h = c[l + 4 * o];
                    255 != h && (h *= 32897, s[u + 4 * o + 0] = s[u + 4 * o + 0] * h >> 23, s[u + 4 * o + 1] = s[u + 4 * o + 1] * h >> 23, s[u + 4 * o + 2] = s[u + 4 * o + 2] * h >> 23);
                }
                e += a;
            }
        }
        function dn(t, e, n, r, i) {
            for(; 0 < r--;){
                var a;
                for(a = 0; a < n; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (c = t[e + 2 * a + 1]), u = 4369 * s, c = (240 & c | c >> 4) * u >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * u >> 16 & 240 | (15 & o | o << 4) * u >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & c | s;
                }
                e += i;
            }
        }
        function pn(t, e, n, r, i, a, o, s) {
            var u, c, l = 255;
            for(c = 0; c < i; ++c){
                for(u = 0; u < r; ++u){
                    var h = t[e + u];
                    a[o + 4 * u] = h, l &= h;
                }
                e += n, o += s;
            }
            return 255 != l;
        }
        function gn(t, e, n, r, i) {
            var a;
            for(a = 0; a < i; ++a)n[r + a] = t[e + a] >> 8;
        }
        function mn() {
            Lr = fn, xr = dn, Ar = pn, Sr = gn;
        }
        function vn(n, r, i) {
            t[n] = function(t, n, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[u + 0] | c[l + 0] << 16, x = h[f + 0] | d[p + 0] << 16;
                e(null != t);
                var A = 3 * L + x + 131074 >> 2;
                for(r(t[n + 0], 255 & A, A >> 16, g, m), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + 0], 255 & A, A >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[u + w] | c[l + w] << 16, _ = h[f + w] | d[p + w] << 16, P = L + S + x + _ + 524296, k = P + 2 * (S + x) >> 3;
                    A = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, r(t[n + 2 * w - 1], 255 & A, A >> 16, g, m + (2 * w - 1) * i), r(t[n + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (A = P + x >> 1, L = k + _ >> 1, r(a[o + 2 * w - 1], 255 & A, A >> 16, v, b + (2 * w - 1) * i), r(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, x = _;
                }
                1 & y || (A = 3 * L + x + 131074 >> 2, r(t[n + y - 1], 255 & A, A >> 16, g, m + (y - 1) * i), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + y - 1], 255 & A, A >> 16, v, b + (y - 1) * i)));
            };
        }
        function bn() {
            mi[Mr] = vi, mi[qr] = yi, mi[Er] = bi, mi[Rr] = wi, mi[Dr] = Ni, mi[Tr] = Li, mi[zr] = xi, mi[Ur] = yi, mi[Hr] = wi, mi[Wr] = Ni, mi[Vr] = Li;
        }
        function yn(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> ki;
        }
        function wn(t, e) {
            return yn((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Nn(t, e, n) {
            return yn((19077 * t >> 8) - (6419 * e >> 8) - (13320 * n >> 8) + 8708);
        }
        function Ln(t, e) {
            return yn((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function xn(t, e, n, r, i) {
            r[i + 0] = wn(t, n), r[i + 1] = Nn(t, e, n), r[i + 2] = Ln(t, e);
        }
        function An(t, e, n, r, i) {
            r[i + 0] = Ln(t, e), r[i + 1] = Nn(t, e, n), r[i + 2] = wn(t, n);
        }
        function Sn(t, e, n, r, i) {
            var a = Nn(t, e, n);
            e = a << 3 & 224 | Ln(t, e) >> 3, r[i + 0] = 248 & wn(t, n) | a >> 5, r[i + 1] = e;
        }
        function _n(t, e, n, r, i) {
            var a = 240 & Ln(t, e) | 15;
            r[i + 0] = 240 & wn(t, n) | Nn(t, e, n) >> 4, r[i + 1] = a;
        }
        function Pn(t, e, n, r, i) {
            r[i + 0] = 255, xn(t, e, n, r, i + 1);
        }
        function kn(t, e, n, r, i) {
            An(t, e, n, r, i), r[i + 3] = 255;
        }
        function Fn(t, e, n, r, i) {
            xn(t, e, n, r, i), r[i + 3] = 255;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function In(e, n, r) {
            t[e] = function(t, e, i, a, o, s, u, c, l) {
                for(var h = c + (-2 & l) * r; c != h;)n(t[e + 0], i[a + 0], o[s + 0], u, c), n(t[e + 1], i[a + 0], o[s + 0], u, c + r), e += 2, ++a, ++s, c += 2 * r;
                1 & l && n(t[e + 0], i[a + 0], o[s + 0], u, c);
            };
        }
        function jn(t, e, n) {
            return 0 == n ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : n;
        }
        function Cn(t, e, n, r, i) {
            switch(t >>> 30){
                case 3:
                    ar(e, n, r, i, 0);
                    break;
                case 2:
                    or(e, n, r, i);
                    break;
                case 1:
                    ur(e, n, r, i);
            }
        }
        function On(t, e) {
            var n, a, o = e.M, s = e.Nb, u = t.oc, c = t.pc + 40, l = t.oc, h = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(n = 0; 16 > n; ++n)u[c + 32 * n - 1] = 129;
            for(n = 0; 8 > n; ++n)l[h + 32 * n - 1] = 129, f[d + 32 * n - 1] = 129;
            for(0 < o ? u[c - 1 - 32] = l[h - 1 - 32] = f[d - 1 - 32] = 129 : (i(u, c - 32 - 1, 127, 21), i(l, h - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(n = -1; 16 > n; ++n)r(u, c + 32 * n - 4, u, c + 32 * n + 12, 4);
                    for(n = -1; 8 > n; ++n)r(l, h + 32 * n - 4, l, h + 32 * n + 4, 4), r(f, d + 32 * n - 4, f, d + 32 * n + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (r(u, c - 32, g[m].y, 0, 16), r(l, h - 32, g[m].f, 0, 8), r(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = u, w = c - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : r(y, w, g[m + 1].y, 0, 4)), n = 0; 4 > n; n++)y[w + 128 + n] = y[w + 256 + n] = y[w + 384 + n] = y[w + 0 + n];
                    for(n = 0; 16 > n; ++n, b <<= 2)y = u, w = c + Ei[n], hi[p.Ob[n]](y, w), Cn(b, v, 16 * +n, y, w);
                } else if (y = jn(a, o, p.Ob[0]), li[y](u, c), 0 != b) for(n = 0; 16 > n; ++n, b <<= 2)Cn(b, v, 16 * +n, u, c + Ei[n]);
                for(n = p.Gc, y = jn(a, o, p.Dd), fi[y](l, h), fi[y](f, d), b = v, y = l, w = h, 255 & (p = 0 | n) && (170 & p ? sr(b, 256, y, w) : cr(b, 256, y, w)), p = f, b = d, 255 & (n >>= 8) && (170 & n ? sr(v, 320, p, b) : cr(v, 320, p, b)), o < t.Ub - 1 && (r(g[m].y, 0, u, c + 480, 16), r(g[m].f, 0, l, h + 224, 8), r(g[m].ea, 0, f, d + 224, 8)), n = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + n, b = t.Ha, y = t.Ia + 8 * a + n, n = 0; 16 > n; ++n)r(g, m + n * t.R, u, c + 32 * n, 16);
                for(n = 0; 8 > n; ++n)r(v, p + n * t.B, l, h + 32 * n, 8), r(b, y + n * t.B, f, d + 32 * n, 8);
            }
        }
        function Bn(t, r, i, a, o, s, u, c, l) {
            var h = [
                0
            ], f = [
                0
            ], d = 0, p = null != l ? l.kd : 0, g = null != l ? l : new nn;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = r, g.ha = i, r = [
                r
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = r, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !n(t, m[0], "RIFF")) {
                    if (n(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = C(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = r, y = i;
                    var x = h, A = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!n(L, b[0], "VP8X")) {
                            if (10 != C(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = C(L, b[0] + 8), P = 1 + j(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + j(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != x && (x[0] = P), null != A && (A[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != u && (u[0] = b), null != c && (c[0] = 0), u = h[0], m = f[0], d && b && null == l) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !n(t, r[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = r, w = i;
                        var k = g.gb;
                        x = g.na, A = g.P, S = g.Sa, P = 22, e(null != _), e(null != w), L = y[0];
                        var F = w[0];
                        for(e(null != x), e(null != S), x[0] = null, A[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = F, 8 > F) {
                                y = 7;
                                break t;
                            }
                            var I = C(_, L + 4);
                            if (4294967286 < I) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + I + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!n(_, L, "VP8 ") || !n(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (F[0] < O) {
                                y = 7;
                                break t;
                            }
                            n(_, L, "ALPH") || (x[0] = _, A[0] = L + 8, S[0] = I), L += O, F -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = r, w = i, x = g.gb[0], A = g.Ja, S = g.xa, _ = y[0], L = !n(k, _, "VP8 "), P = !n(k, _, "VP8L"), e(null != k), e(null != w), e(null != A), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = C(k, _ + 4), 12 <= x && k > x - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        A[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), A[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], r = r[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == c || b || (c[0] = g.xa ? 2 : 1), u = [
                    u
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    c = u, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[r + 0] && !(t[r + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], x = [
                        0
                    ], v(A = new N, t, r, i), gt(A, w, k, x) ? (null != c && (c[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = x[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    c = m, null == t || 10 > i || !Xt(t, r + 3, i - 3) ? t = 0 : (p = t[r + 0] | t[r + 1] << 8 | t[r + 2] << 16, b = 16383 & (t[r + 7] << 8 | t[r + 6]), t = 16383 & (t[r + 9] << 8 | t[r + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (u && (u[0] = b), c && (c[0] = t), t = 1));
                }
                if (!t) return 3;
                if (u = u[0], m = m[0], d && (h[0] != u || f[0] != m)) return 3;
                null != l && (l[0] = g, l.offset = r - l.w, e(4294967286 > r - l.w), e(l.offset == l.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == l ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = u), null != o && (o[0] = m), 0) : y;
        }
        function Mn(t, e, n) {
            var r = e.width, i = e.height, a = 0, o = 0, s = r, u = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, u = t.bd, a = t.v, o = t.j, 11 > n || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= u || a + s > r || o + u > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + u, e.U = s, e.T = u, e.da = null != t && 0 < t.da, e.da) {
                if (!q(s, u, n = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = n[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * r / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function qn(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function En(t, e, n, r) {
            if (null == r || 0 >= t || 0 >= e) return 2;
            if (null != n) {
                if (n.Da) {
                    var i = n.cd, o = n.bd, s = -2 & n.v, u = -2 & n.j;
                    if (0 > s || 0 > u || 0 >= i || 0 >= o || s + i > t || u + o > e) return 2;
                    t = i, e = o;
                }
                if (n.da) {
                    if (!q(t, e, i = [
                        n.ib
                    ], o = [
                        n.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            r.width = t, r.height = e;
            t: {
                var c = r.width, l = r.height;
                if (t = r.S, 0 >= c || 0 >= l || !(t >= Mr && 13 > t)) t = 2;
                else {
                    if (0 >= r.Rd && null == r.sd) {
                        s = o = i = e = 0;
                        var h = (u = c * zi[t]) * l;
                        if (11 > t || (o = (l + 1) / 2 * (e = (c + 1) / 2), 12 == t && (s = (i = c) * l)), null == (l = a(h + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        r.sd = l, 11 > t ? ((c = r.f.RGBA).eb = l, c.fb = 0, c.A = u, c.size = h) : ((c = r.f.kb).y = l, c.O = 0, c.fa = u, c.Fd = h, c.f = l, c.N = 0 + h, c.Ab = e, c.Cd = o, c.ea = l, c.W = 0 + h + o, c.Db = e, c.Ed = o, 12 == t && (c.F = l, c.J = 0 + h + 2 * o), c.Tc = s, c.lb = i);
                    }
                    if (e = 1, i = r.S, o = r.width, s = r.height, i >= Mr && 13 > i) {
                        if (11 > i) t = r.f.RGBA, e &= (u = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= u >= o * zi[i], e &= null != t.eb;
                        else {
                            t = r.f.kb, u = (o + 1) / 2, h = (s + 1) / 2, c = Math.abs(t.fa), l = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= c * (s - 1) + o <= t.Fd, e &= l * (h - 1) + u <= t.Cd, e = (e &= f * (h - 1) + u <= t.Ed) & c >= o & l >= u & f >= u, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != n && n.fd && (t = qn(r)), t;
        }
        var Rn = 64, Dn = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tn = 24, zn = 32, Un = 8, Hn = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        D("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, n) {
            return e[n + 0];
        }, t.Predictor3 = function(t, e, n) {
            return e[n + 1];
        }, t.Predictor4 = function(t, e, n) {
            return e[n - 1];
        }, t.Predictor5 = function(t, e, n) {
            return z(z(t, e[n + 1]), e[n + 0]);
        }, t.Predictor6 = function(t, e, n) {
            return z(t, e[n - 1]);
        }, t.Predictor7 = function(t, e, n) {
            return z(t, e[n + 0]);
        }, t.Predictor8 = function(t, e, n) {
            return z(e[n - 1], e[n + 0]);
        }, t.Predictor9 = function(t, e, n) {
            return z(e[n + 0], e[n + 1]);
        }, t.Predictor10 = function(t, e, n) {
            return z(z(t, e[n - 1]), z(e[n + 0], e[n + 1]));
        }, t.Predictor11 = function(t, e, n) {
            var r = e[n + 0];
            return 0 >= W(r >> 24 & 255, t >> 24 & 255, (e = e[n - 1]) >> 24 & 255) + W(r >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(r >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & r, 255 & t, 255 & e) ? r : t;
        }, t.Predictor12 = function(t, e, n) {
            var r = e[n + 0];
            return (U((t >> 24 & 255) + (r >> 24 & 255) - ((e = e[n - 1]) >> 24 & 255)) << 24 | U((t >> 16 & 255) + (r >> 16 & 255) - (e >> 16 & 255)) << 16 | U((t >> 8 & 255) + (r >> 8 & 255) - (e >> 8 & 255)) << 8 | U((255 & t) + (255 & r) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, n) {
            var r = e[n - 1];
            return (H((t = z(t, e[n + 0])) >> 24 & 255, r >> 24 & 255) << 24 | H(t >> 16 & 255, r >> 16 & 255) << 16 | H(t >> 8 & 255, r >> 8 & 255) << 8 | H(255 & t, 255 & r)) >>> 0;
        };
        var Wn = t.PredictorAdd0;
        t.PredictorAdd1 = V, D("Predictor2", "PredictorAdd2"), D("Predictor3", "PredictorAdd3"), D("Predictor4", "PredictorAdd4"), D("Predictor5", "PredictorAdd5"), D("Predictor6", "PredictorAdd6"), D("Predictor7", "PredictorAdd7"), D("Predictor8", "PredictorAdd8"), D("Predictor9", "PredictorAdd9"), D("Predictor10", "PredictorAdd10"), D("Predictor11", "PredictorAdd11"), D("Predictor12", "PredictorAdd12"), D("Predictor13", "PredictorAdd13");
        var Vn = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gn, Yn = t.ColorIndexInverseTransform, Jn = t.MapARGB, Xn = t.VP8LColorIndexInverseTransformAlpha, Kn = t.MapAlpha, Zn = t.VP8LPredictorsAdd = [];
        Zn.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var $n, Qn, tr, er, nr, rr, ir, ar, or, sr, ur, cr, lr, hr, fr, dr, pr, gr, mr, vr, br, yr, wr, Nr, Lr, xr, Ar, Sr, _r = a(511), Pr = a(2041), kr = a(225), Fr = a(767), Ir = 0, jr = Pr, Cr = kr, Or = Fr, Br = _r, Mr = 0, qr = 1, Er = 2, Rr = 3, Dr = 4, Tr = 5, zr = 6, Ur = 7, Hr = 8, Wr = 9, Vr = 10, Gr = [
            2,
            3,
            7
        ], Yr = [
            3,
            3,
            11
        ], Jr = [
            280,
            256,
            256,
            256,
            40
        ], Xr = [
            0,
            1,
            1,
            1,
            0
        ], Kr = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], Zr = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], $r = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], Qr = 8, ti = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ri = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ii = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], ai = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], oi = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], si = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], ci = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], hi = [], fi = [], di = 1, pi = 2, gi = [], mi = [];
        vn("UpsampleRgbLinePair", xn, 3), vn("UpsampleBgrLinePair", An, 3), vn("UpsampleRgbaLinePair", Fn, 4), vn("UpsampleBgraLinePair", kn, 4), vn("UpsampleArgbLinePair", Pn, 4), vn("UpsampleRgba4444LinePair", _n, 2), vn("UpsampleRgb565LinePair", Sn, 2);
        var vi = t.UpsampleRgbLinePair, bi = t.UpsampleBgrLinePair, yi = t.UpsampleRgbaLinePair, wi = t.UpsampleBgraLinePair, Ni = t.UpsampleArgbLinePair, Li = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Ai = 16, Si = 1 << Ai - 1, _i = -227, Pi = 482, ki = 6, Fi = (256 << ki) - 1, Ii = 0, ji = a(256), Ci = a(256), Oi = a(256), Bi = a(256), Mi = a(Pi - _i), qi = a(Pi - _i);
        In("YuvToRgbRow", xn, 3), In("YuvToBgrRow", An, 3), In("YuvToRgbaRow", Fn, 4), In("YuvToBgraRow", kn, 4), In("YuvToArgbRow", Pn, 4), In("YuvToRgba4444Row", _n, 2), In("YuvToRgb565Row", Sn, 2);
        var Ei = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Di = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ti = 1;
        this.WebPDecodeRGBA = function(t, n, s, u, c) {
            var l = qr, h = new en, f = new ot;
            h.ba = f, f.S = l, f.width = [
                f.width
            ], f.height = [
                f.height
            ];
            var d = f.width, p = f.height, g = new st;
            if (null == g || null == t) var m = 2;
            else e(null != g), m = Bn(t, n, s, g.width, g.height, g.Pd, g.Qd, g.format, null);
            if (0 != m ? d = 0 : (null != d && (d[0] = g.width[0]), null != p && (p[0] = g.height[0]), d = 1), d) {
                f.width = f.width[0], f.height = f.height[0], null != u && (u[0] = f.width), null != c && (c[0] = f.height);
                t: {
                    if (u = new Gt, (c = new nn).data = t, c.w = n, c.ha = s, c.kd = 1, n = [
                        0
                    ], e(null != c), (0 == (t = Bn(c.data, c.w, c.ha, null, null, null, n, null, c)) || 7 == t) && n[0] && (t = 4), 0 == (n = t)) {
                        if (e(null != h), u.data = c.data, u.w = c.w + c.offset, u.ha = c.ha - c.offset, u.put = dt, u.ac = ft, u.bc = pt, u.ma = h, c.xa) {
                            if (null == (t = kt())) {
                                h = 1;
                                break t;
                            }
                            if (function(t, n) {
                                var r = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == n) return t.a = 2, 0;
                                    if (t.l = n, t.a = 0, v(t.m, n.data, n.w, n.ha), !gt(t.m, r, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = pi, n.width = r[0], n.height = i[0], !Ft(r[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, u)) {
                                if (u = 0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                    e: {
                                        u = t;
                                        n: for(;;){
                                            if (null == u) {
                                                u = 0;
                                                break e;
                                            }
                                            if (e(null != u.s.yc), e(null != u.s.Ya), e(0 < u.s.Wb), e(null != (s = u.l)), e(null != (c = s.ma)), 0 != u.xb) {
                                                if (u.ca = c.ba, u.tb = c.tb, e(null != u.ca), !Mn(c.Oa, s, Rr)) {
                                                    u.a = 2;
                                                    break n;
                                                }
                                                if (!It(u, s.width)) break n;
                                                if (s.da) break n;
                                                if ((s.da || rt(u.ca.S)) && mn(), 11 > u.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != u.ca.f.kb.F && mn()), u.Pb && 0 < u.s.ua && null == u.s.vb.X && !O(u.s.vb, u.s.Wa.Xa)) {
                                                    u.a = 1;
                                                    break n;
                                                }
                                                u.xb = 0;
                                            }
                                            if (!_t(u, u.V, u.Ba, u.c, u.i, s.o, Lt)) break n;
                                            c.Dc = u.Ma, u = 1;
                                            break e;
                                        }
                                        e(0 != u.a), u = 0;
                                    }
                                    u = !u;
                                }
                                u && (n = t.a);
                            } else n = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = c.na, t.P = c.P, t.qc = c.Sa, Kt(t, u)) {
                                if (0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                    if (t.Aa = 0, s = h.Oa, e(null != (c = t)), null != s) {
                                        if (0 < (d = 0 > (d = s.Md) ? 0 : 100 < d ? 255 : 255 * d / 100)) {
                                            for(p = g = 0; 4 > p; ++p)12 > (m = c.pb[p]).lc && (m.ia = d * Di[0 > m.lc ? 0 : m.lc] >> 3), g |= m.ia;
                                            g && (alert("todo:VP8InitRandom"), c.ia = 1);
                                        }
                                        c.Ga = s.Id, 100 < c.Ga ? c.Ga = 100 : 0 > c.Ga && (c.Ga = 0);
                                    }
                                    (function(t, n) {
                                        if (null == t) return 0;
                                        if (null == n) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
                                        if (!t.cb && !Kt(t, n)) return 0;
                                        if (e(t.cb), null == n.ac || n.ac(n)) {
                                            n.ob && (t.L = 0);
                                            var s = Ri[t.L];
                                            if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = n.v - s >> 4, t.zb = n.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = n.o + 15 + s >> 4, t.Hb = n.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                                                var u = t.ed;
                                                for(s = 0; 4 > s; ++s){
                                                    var c;
                                                    if (t.Qa.Cb) {
                                                        var l = t.Qa.Lb[s];
                                                        t.Qa.Fb || (l += u.Tb);
                                                    } else l = u.Tb;
                                                    for(c = 0; 1 >= c; ++c){
                                                        var h = t.gd[s][c], f = l;
                                                        if (u.Pc && (f += u.vd[0], c && (f += u.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                                            var d = f;
                                                            0 < u.wb && (d = 4 < u.wb ? d >> 2 : d >> 1) > 9 - u.wb && (d = 9 - u.wb), 1 > d && (d = 1), h.dd = d, h.tc = 2 * f + d, h.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                                                        } else h.tc = 0;
                                                        h.La = c;
                                                    }
                                                }
                                            }
                                            s = 0;
                                        } else Jt(t, 6, "Frame setup failed"), s = t.a;
                                        if (s = 0 == s) {
                                            if (s) {
                                                t.$c = 0, 0 < t.Aa || (t.Ic = Ti);
                                                e: {
                                                    s = t.Ic, u = 4 * (d = t.za);
                                                    var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                                                    if ((h = u + 832 + (c = 3 * (16 * s + Ri[t.L]) / 2 * p) + (l = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != h) s = 0;
                                                    else {
                                                        if (h > t.Vb) {
                                                            if (t.Vb = 0, t.Ec = a(h), t.Fc = 0, null == t.Ec) {
                                                                s = Jt(t, 1, "no memory during frame initialization.");
                                                                break e;
                                                            }
                                                            t.Vb = h;
                                                        }
                                                        h = t.Ec, f = t.Fc, t.Ac = h, t.Bc = f, f += u, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Dt), t.sb = 1, t.wa = m ? o(m, Rt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = h, t.pc = f, f += 832, t.ya = o(v, zt), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = h, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += c, t.mb = l ? h : null, t.nb = l ? f : null, e(f + l <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, u), s = 1;
                                                    }
                                                }
                                                if (s) {
                                                    if (n.ka = 0, n.y = t.sa, n.O = t.ta, n.f = t.qa, n.N = t.ra, n.ea = t.Ha, n.Vd = t.Ia, n.fa = t.R, n.Rc = t.B, n.F = null, n.J = 0, !Ir) {
                                                        for(s = -255; 255 >= s; ++s)_r[255 + s] = 0 > s ? -s : s;
                                                        for(s = -1020; 1020 >= s; ++s)Pr[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                                                        for(s = -112; 112 >= s; ++s)kr[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                                                        for(s = -255; 510 >= s; ++s)Fr[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                                                        Ir = 1;
                                                    }
                                                    ir = ue, ar = ie, sr = ae, ur = oe, cr = se, or = re, lr = Ye, hr = Je, fr = Ze, dr = $e, pr = Xe, gr = Ke, mr = Qe, vr = tn, br = ze, yr = Ue, wr = He, Nr = We, hi[0] = xe, hi[1] = le, hi[2] = Ne, hi[3] = Le, hi[4] = Ae, hi[5] = _e, hi[6] = Se, hi[7] = Pe, hi[8] = Fe, hi[9] = ke, li[0] = me, li[1] = fe, li[2] = de, li[3] = pe, li[4] = ve, li[5] = be, li[6] = ye, fi[0] = Oe, fi[1] = he, fi[2] = Ie, fi[3] = je, fi[4] = Me, fi[5] = Be, fi[6] = qe, s = 1;
                                                } else s = 0;
                                            }
                                            s && (s = function(t, n) {
                                                for(t.M = 0; t.M < t.Va; ++t.M){
                                                    var o, s = t.Jc[t.M & t.Xb], u = t.m, c = t;
                                                    for(o = 0; o < c.za; ++o){
                                                        var l = u, h = c, f = h.Ac, d = h.Bc + 4 * o, p = h.zc, g = h.ya[h.aa + o];
                                                        if (h.Qa.Bb ? g.$b = k(l, h.Pa.jb[0]) ? 2 + k(l, h.Pa.jb[2]) : k(l, h.Pa.jb[1]) : g.$b = 0, h.kc && (g.Ad = k(l, h.Bd)), g.Za = !k(l, 145) + 0, g.Za) {
                                                            var m = g.Ob, v = 0;
                                                            for(h = 0; 4 > h; ++h){
                                                                var b, y = p[0 + h];
                                                                for(b = 0; 4 > b; ++b){
                                                                    y = si[f[d + b]][y];
                                                                    for(var w = ai[k(l, y[0])]; 0 < w;)w = ai[2 * w + k(l, y[w])];
                                                                    y = -w, f[d + b] = y;
                                                                }
                                                                r(m, v, f, d, 4), v += 4, p[0 + h] = y;
                                                            }
                                                        } else y = k(l, 156) ? k(l, 128) ? 1 : 3 : k(l, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                                                        g.Dd = k(l, 142) ? k(l, 114) ? k(l, 183) ? 1 : 3 : 2 : 0;
                                                    }
                                                    if (c.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                                                    for(; t.ja < t.za; ++t.ja){
                                                        if (c = s, l = (u = t).rb[u.sb - 1], f = u.rb[u.sb + u.ja], o = u.ya[u.aa + u.ja], d = u.kc ? o.Ad : 0) l.la = f.la = 0, o.Za || (l.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                                                        else {
                                                            var N, L;
                                                            if (l = f, f = c, d = u.Pa.Xc, p = u.ya[u.aa + u.ja], g = u.pb[p.$b], h = p.ad, m = 0, v = u.rb[u.sb - 1], y = b = 0, i(h, m, 0, 384), p.Za) var x = 0, A = d[3];
                                                            else {
                                                                w = a(16);
                                                                var S = l.Na + v.Na;
                                                                if (S = ni(f, d[1], S, g.Eb, 0, w, 0), l.Na = v.Na = (0 < S) + 0, 1 < S) ir(w, 0, h, m);
                                                                else {
                                                                    var _ = w[0] + 3 >> 3;
                                                                    for(w = 0; 256 > w; w += 16)h[m + w] = _;
                                                                }
                                                                x = 1, A = d[0];
                                                            }
                                                            var P = 15 & l.la, F = 15 & v.la;
                                                            for(w = 0; 4 > w; ++w){
                                                                var I = 1 & F;
                                                                for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (I = (S = ni(f, A, S = I + (1 & P), g.Sc, x, h, m)) > x) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                P >>= 4, F = F >> 1 | I << 7, b = (b << 8 | L) >>> 0;
                                                            }
                                                            for(A = P, x = F >> 4, N = 0; 4 > N; N += 2){
                                                                for(L = 0, P = l.la >> 4 + N, F = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                                                    for(I = 1 & F, _ = 0; 2 > _; ++_)S = I + (1 & P), P = P >> 1 | (I = 0 < (S = ni(f, d[2], S, g.Qc, 0, h, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                    P >>= 2, F = F >> 1 | I << 5;
                                                                }
                                                                y |= L << 4 * N, A |= P << 4 << N, x |= (240 & F) << N;
                                                            }
                                                            l.la = A, v.la = x, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                                                        }
                                                        if (0 < u.L && (u.wa[u.Y + u.ja] = u.gd[o.$b][o.Za], u.wa[u.Y + u.ja].La |= !d), c.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                                                    }
                                                    if ($t(t), u = n, c = 1, o = (s = t).D, l = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) e: {
                                                        if (o.M = s.M, o.uc = l, On(s, o), c = 1, o = (L = s.D).Nb, l = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - l + w, g = s.qa, h = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, F = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && On(s, L), L.uc) for(I = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                                            x = L, A = I;
                                                            var j = (C = (z = S).D).Nb;
                                                            N = z.R;
                                                            var C = C.wa[C.Y + x], O = z.sa, B = z.ta + 16 * j * N + 16 * x, M = C.dd, q = C.tc;
                                                            if (0 != q) {
                                                                if (e(3 <= q), 1 == z.L) 0 < x && yr(O, B, N, q + 4), C.La && Nr(O, B, N, q), 0 < A && br(O, B, N, q + 4), C.La && wr(O, B, N, q);
                                                                else {
                                                                    var E = z.B, R = z.qa, D = z.ra + 8 * j * E + 8 * x, T = z.Ha, z = z.Ia + 8 * j * E + 8 * x;
                                                                    j = C.ld, 0 < x && (hr(O, B, N, q + 4, M, j), dr(R, D, T, z, E, q + 4, M, j)), C.La && (gr(O, B, N, q, M, j), vr(R, D, T, z, E, q, M, j)), 0 < A && (lr(O, B, N, q + 4, M, j), fr(R, D, T, z, E, q + 4, M, j)), C.La && (pr(O, B, N, q, M, j), mr(R, D, T, z, E, q, M, j));
                                                                }
                                                            }
                                                        }
                                                        if (s.ia && alert("todo:DitherRow"), null != u.put) {
                                                            if (L = 16 * P, P = 16 * (P + 1), F ? (u.y = s.sa, u.O = s.ta + w, u.f = s.qa, u.N = s.ra + _, u.ea = s.Ha, u.W = s.Ia + _) : (L -= y, u.y = d, u.O = p, u.f = g, u.N = h, u.ea = m, u.W = v), b || (P -= y), P > u.o && (P = u.o), u.F = null, u.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (u.J = hn(s, u, L, P - L), u.F = s.mb, null == u.F && 0 == u.F.length)) {
                                                                c = Jt(s, 3, "Could not decode alpha data.");
                                                                break e;
                                                            }
                                                            L < u.j && (y = u.j - L, L = u.j, e(!(1 & y)), u.O += s.R * y, u.N += s.B * (y >> 1), u.W += s.B * (y >> 1), null != u.F && (u.J += u.width * y)), L < P && (u.O += u.v, u.N += u.v >> 1, u.W += u.v >> 1, null != u.F && (u.J += u.v), u.ka = L - u.j, u.U = u.va - u.v, u.T = P - L, c = u.put(u));
                                                        }
                                                        o + 1 != s.Ic || b || (r(s.sa, s.ta - l, d, p + 16 * s.R, l), r(s.qa, s.ra - f, g, h + 8 * s.B, f), r(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                                                    }
                                                    if (!c) return Jt(t, 6, "Output aborted.");
                                                }
                                                return 1;
                                            }(t, n)), null != n.bc && n.bc(n), s &= 1;
                                        }
                                        return s ? (t.cb = 0, s) : 0;
                                    })(t, u) || (n = t.a);
                                }
                            } else n = t.a;
                        }
                        0 == n && null != h.Oa && h.Oa.fd && (n = qn(h.ba));
                    }
                    h = n;
                }
                l = 0 != h ? null : 11 > l ? f.f.RGBA.eb : f.f.kb.y;
            } else l = null;
            return l;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function c(t, e) {
        for(var n = "", r = 0; r < 4; r++)n += String.fromCharCode(t[e++]);
        return n;
    }
    function l(t, e) {
        return t[e + 0] | t[e + 1] << 8;
    }
    function h(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function f(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new u;
    var d = [
        0
    ], p = [
        0
    ], g = [], m = new u, v = t, b = function(t, e) {
        var n = {}, r = 0, i = !1, a = 0, o = 0;
        if (n.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e) {
            for(var n = 0; n < 4; n++)if (t[e + n] != "RIFF".charCodeAt(n)) return !0;
            return !1;
        }(t, e)) {
            for(f(t, e += 4), e += 8; e < t.length;){
                var s = c(t, e), u = f(t, e += 4);
                e += 4;
                var d = u + (1 & u);
                switch(s){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === n.frames[r] && (n.frames[r] = {}), (m = n.frames[r]).src_off = i ? o : e - 8, m.src_size = a + u + 8, r++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (m = n.header = {}).feature_flags = t[e];
                        var p = e + 4;
                        m.canvas_width = 1 + h(t, p), p += 3, m.canvas_height = 1 + h(t, p), p += 3;
                        break;
                    case "ALPH":
                        i = !0, a = d + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (m = n.header).bgcolor = f(t, e), p = e + 4, m.loop_count = l(t, p), p += 2;
                        break;
                    case "ANMF":
                        var g, m;
                        (m = n.frames[r] = {}).offset_x = 2 * h(t, e), e += 3, m.offset_y = 2 * h(t, e), e += 3, m.width = 1 + h(t, e), e += 3, m.height = 1 + h(t, e), e += 3, m.duration = h(t, e), e += 3, g = t[e++], m.dispose = 1 & g, m.blend = g >> 1 & 1;
                }
                "ANMF" != s && (e += d);
            }
            return n;
        }
    }(v, 0);
    b.response = v, b.rgbaoutput = !0, b.dataurl = !1;
    var y = b.header ? b.header : null, w = b.frames ? b.frames : null;
    if (y) {
        y.loop_counter = y.loop_count, d = [
            y.canvas_height
        ], p = [
            y.canvas_width
        ];
        for(var N = 0; N < w.length && 0 != w[N].blend; N++);
    }
    var L = w[0], x = m.WebPDecodeRGBA(v, L.src_off, L.src_size, p, d);
    L.rgba = x, L.imgwidth = p[0], L.imgheight = d[0];
    for(var A = 0; A < p[0] * d[0] * 4; A++)g[A] = x[A];
    return this.width = p, this.height = d, this.data = g, this;
}



!function(e) {
    var n, r, i, a, s, u, c, l, f, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new l, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new u, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new u, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), n = this.internal.f2, r = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, a = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, u = this.internal.Point, c = this.internal.Rectangle, l = this.internal.Matrix, f = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return f.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), f.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return f;
            },
            set: function(t) {
                t instanceof d && (f = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return f.path;
            },
            set: function(t) {
                f.path = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var l = null;
        var h = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return h;
            },
            set: function(t) {
                l = null, h = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var n = e[1];
                    e[2];
                    var r = e[3], i = e[4];
                    e[5];
                    var a = e[6], o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, n, r = [], i = t.trim();
                        if ("" === i) return $e5456e2f96ba3898$var$Jt;
                        if (i in $e5456e2f96ba3898$var$Mt) return [
                            $e5456e2f96ba3898$var$Mt[i]
                        ];
                        for(; "" !== i;){
                            switch(n = null, e = (i = $e5456e2f96ba3898$var$Et(i)).charAt(0)){
                                case '"':
                                case "'":
                                    n = $e5456e2f96ba3898$var$Rt(i.substring(1), e);
                                    break;
                                default:
                                    n = $e5456e2f96ba3898$var$Dt(i);
                            }
                            if (null === n) return $e5456e2f96ba3898$var$Jt;
                            if (r.push(n[0]), "" !== (i = $e5456e2f96ba3898$var$Et(n[1])) && "," !== i.charAt(0)) return $e5456e2f96ba3898$var$Jt;
                            i = i.replace(/^,/, "");
                        }
                        return r;
                    }(a);
                    if (this.fontFaces) {
                        var u = function(t, e) {
                            if (null === l) {
                                var n = function(t) {
                                    var e = [];
                                    return Object.keys(t).forEach(function(n) {
                                        t[n].forEach(function(t) {
                                            var r = null;
                                            switch(t){
                                                case "bold":
                                                    r = {
                                                        family: n,
                                                        weight: "bold"
                                                    };
                                                    break;
                                                case "italic":
                                                    r = {
                                                        family: n,
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "bolditalic":
                                                    r = {
                                                        family: n,
                                                        weight: "bold",
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "":
                                                case "normal":
                                                    r = {
                                                        family: n
                                                    };
                                            }
                                            null !== r && (r.ref = {
                                                name: n,
                                                style: t
                                            }, e.push(r));
                                        });
                                    }), e;
                                }(t.getFontList());
                                l = function(t) {
                                    for(var e = {}, n = 0; n < t.length; ++n){
                                        var r = $e5456e2f96ba3898$var$Ct(t[n]), i = r.family, a = r.stretch, o = r.style, s = r.weight;
                                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = r;
                                    }
                                    return e;
                                }(n.concat(e));
                            }
                            return l;
                        }(this.pdf, this.fontFaces), c = s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: r,
                                style: n
                            };
                        }), h = function(t, e, n) {
                            for(var r = (n = n || {}).defaultFontFamily || "times", i = Object.assign({}, $e5456e2f96ba3898$var$Bt, n.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = $e5456e2f96ba3898$var$Ct(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
                                o = t[a.family];
                                break;
                            }
                            if (!(o = o || t[r])) throw new Error("Could not find a font-family for the rule '" + $e5456e2f96ba3898$var$qt(a) + "' and default family '" + r + "'.");
                            if (o = function(t, e) {
                                if (e[t]) return e[t];
                                var n = $e5456e2f96ba3898$var$Ft[t], r = n <= $e5456e2f96ba3898$var$Ft.normal ? -1 : 1, i = $e5456e2f96ba3898$var$Ot(e, $e5456e2f96ba3898$var$kt, n, r);
                                if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
                                return i;
                            }(a.stretch, o), o = function(t, e) {
                                if (e[t]) return e[t];
                                for(var n = $e5456e2f96ba3898$var$Pt[t], r = 0; r < n.length; ++r)if (e[n[r]]) return e[n[r]];
                                throw new Error("Could not find a matching font-style for " + t);
                            }(a.style, o), !(o = function(t, e) {
                                if (e[t]) return e[t];
                                if (400 === t && e[500]) return e[500];
                                if (500 === t && e[400]) return e[400];
                                var n = $e5456e2f96ba3898$var$jt[t], r = $e5456e2f96ba3898$var$Ot(e, $e5456e2f96ba3898$var$It, n, t < 400 ? -1 : 1);
                                if (!r) throw new Error("Could not find a matching font-weight for value " + t);
                                return r;
                            }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + $e5456e2f96ba3898$var$qt(a) + "'.");
                            return o;
                        }(u, c);
                        this.pdf.setFont(h.ref.name, h.ref.style);
                    } else {
                        var f = "";
                        ("bold" === r || parseInt(r, 10) >= 700 || "bold" === n) && (f = "bold"), "italic" === n && (f += "italic"), 0 === f.length && (f = "normal");
                        for(var d = "", p = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, g = 0; g < s.length; g++){
                            if (void 0 !== this.pdf.internal.getFont(s[g], f, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                d = s[g];
                                break;
                            }
                            if ("bolditalic" === f && void 0 !== this.pdf.internal.getFont(s[g], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) d = s[g], f = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[g], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                d = s[g], f = "normal";
                                break;
                            }
                        }
                        if ("" === d) {
                            for(var m = 0; m < s.length; m++)if (p[s[m]]) {
                                d = p[s[m]];
                                break;
                            }
                        }
                        d = "" === d ? "Times" : d, this.pdf.setFont(d, f);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        x.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        x.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var n = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "mt",
            x: n.x,
            y: n.y
        }), this.ctx.lastPoint = new u(t, e);
    }, p.prototype.closePath = function() {
        var e = new u(0, 0), n = 0;
        for(n = this.path.length - 1; -1 !== n; n--)if ("begin" === this.path[n].type && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(this.path[n + 1]) && "number" == typeof this.path[n + 1].x) {
            e = new u(this.path[n + 1].x, this.path[n + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new u(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var n = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "lt",
            x: n.x,
            y: n.y
        }), this.ctx.lastPoint = new u(n.x, n.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), x.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, n, r) {
        if (isNaN(n) || isNaN(r) || isNaN(t) || isNaN(e)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new u(n, r)), a = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "qct",
            x1: a.x,
            y1: a.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new u(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, n, r, i, a) {
        if (isNaN(i) || isNaN(a) || isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new u(i, a)), c = this.ctx.transform.applyToPoint(new u(t, e)), l = this.ctx.transform.applyToPoint(new u(n, r));
        this.path.push({
            type: "bct",
            x1: c.x,
            y1: c.y,
            x2: l.x,
            y2: l.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new u(s.x, s.y);
    }, p.prototype.arc = function(t, e, n, r, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (a = Boolean(a), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new u(t, e));
            t = s.x, e = s.y;
            var c = this.ctx.transform.applyToPoint(new u(0, n)), l = this.ctx.transform.applyToPoint(new u(0, 0));
            n = Math.sqrt(Math.pow(c.x - l.x, 2) + Math.pow(c.y - l.y, 2));
        }
        Math.abs(i - r) >= 2 * Math.PI && (r = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: n,
            startAngle: r,
            endAngle: i,
            counterclockwise: a
        });
    }, p.prototype.arcTo = function(t, e, n, r, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.lineTo(t + n, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, n, r), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, n, r), this.stroke());
    }, p.prototype.clearRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, n, r));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var r = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = r;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, n, r, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, n = 0, r = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $e5456e2f96ba3898$var$h(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16);
            }
        }
        return {
            r: e,
            g: n,
            b: r,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, n, r) {
        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (r = isNaN(r) ? void 0 : r, !m.call(this)) {
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            j.call(this, {
                text: t,
                x: e,
                y: n,
                scale: a,
                angle: i,
                align: this.textAlign,
                maxWidth: r
            });
        }
    }, p.prototype.strokeText = function(t, e, n, r) {
        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            r = isNaN(r) ? void 0 : r;
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            j.call(this, {
                text: t,
                x: e,
                y: n,
                scale: a,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: r
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, n = this.pdf.internal.scaleFactor, r = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * r / e.internal.scaleFactor;
        return new function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        }({
            width: i *= Math.round(96 * n / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var n = new l(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(n);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new l(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var n = new l(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(n);
    }, p.prototype.transform = function(t, e, n, r, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a)) throw $e5456e2f96ba3898$var$o.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new l(t, e, n, r, i, a);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, n, r, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, n = isNaN(n) ? 0 : n, r = isNaN(r) ? 1 : r, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new l(t, e, n, r, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, n, r, i, a, o, s, u) {
        var h = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== r && void 0 !== s && (p = s / r, g = u / i, f = h.width / r * s / r, d = h.height / i * u / i), void 0 === a && (a = e, o = n, e = 0, n = 0), void 0 !== r && void 0 === s && (s = r, u = i), void 0 === r && void 0 === s && (s = h.width, u = h.height);
        for(var m, v = this.ctx.transform.decompose(), w = E(v.rotate.shx), x = new l, S = (x = (x = (x = x.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new c(a - e * p, o - n * g, r * f, i * d)), _ = y.call(this, S), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
        if (L(P), this.autoPaging) for(var F = P[0], I = P[P.length - 1], j = F; j < I + 1; j++){
            this.pdf.setPage(j);
            var C = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === j ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], q = 1 === j ? 0 : B + (j - 2) * M;
            if (0 !== this.ctx.clip_path.length) {
                var R = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset), A.call(this, "fill", !0), this.path = R;
            }
            var D = JSON.parse(JSON.stringify(S));
            D = N([
                D
            ], this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset)[0];
            var T = (j > F || j < I) && b.call(this);
            T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], C, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", D.x, D.y, D.w, D.h, null, null, w), T && this.pdf.restoreGraphicsState();
        }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function(t, e, n) {
        var r = [];
        e = e || this.pdf.internal.pageSize.width, n = n || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                r.push(Math.floor((t.y + i) / n) + 1);
                break;
            case "arc":
                r.push(Math.floor((t.y + i - t.radius) / n) + 1), r.push(Math.floor((t.y + i + t.radius) / n) + 1);
                break;
            case "qct":
                var a = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                r.push(Math.floor((a.y + i) / n) + 1), r.push(Math.floor((a.y + a.h + i) / n) + 1);
                break;
            case "bct":
                var o = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                r.push(Math.floor((o.y + i) / n) + 1), r.push(Math.floor((o.y + o.h + i) / n) + 1);
                break;
            case "rect":
                r.push(Math.floor((t.y + i) / n) + 1), r.push(Math.floor((t.y + t.h + i) / n) + 1);
        }
        for(var s = 0; s < r.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < r[s];)w.call(this);
        return r;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, n = this.font, r = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = n, this.lineCap = r, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, n) {
        for(var r = 0; r < t.length; r++)switch(t[r].type){
            case "bct":
                t[r].x2 += e, t[r].y2 += n;
            case "qct":
                t[r].x1 += e, t[r].y1 += n;
            default:
                t[r].x += e, t[r].y += n;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, x = function(t, e) {
        for(var n, r, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, u = Math.abs(s * this.ctx.transform.scaleX), c = this.lineJoin, l = JSON.parse(JSON.stringify(this.path)), h = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < h.length; d++)if (void 0 !== h[d].x) for(var p = y.call(this, h[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
        if (L(f), this.autoPaging) for(var v = f[0], x = f[f.length - 1], S = v; S < x + 1; S++){
            this.pdf.setPage(S), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = u, this.lineJoin = c;
            var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], F = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], I = 1 === S ? 0 : k + (S - 2) * F;
            if (0 !== this.ctx.clip_path.length) {
                var j = this.path;
                n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(n, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), A.call(this, t, !0), this.path = j;
            }
            if (r = JSON.parse(JSON.stringify(l)), this.path = N(r, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                var C = (S > v || S < x) && b.call(this);
                C && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, F, null).clip().discardPath()), A.call(this, t, e), C && this.pdf.restoreGraphicsState();
            }
            this.lineWidth = s;
        }
        else this.lineWidth = u, A.call(this, t, e), this.lineWidth = s;
        this.path = l;
    }, A = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var n, r, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var u = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (n = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], u > 0)) {
                            for(; u >= 0; u--)if (!0 !== i[u - 1].close && !0 !== i[u - 1].begin) {
                                i[u - 1].deltas.push(n), i[u - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        n = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "qct":
                        var c = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), l = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), h = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        n = [
                            c - a[o - 1].x,
                            l - a[o - 1].y,
                            h - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            r = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : C.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, x = i[b].start.y;
                O.call(this, i[b].deltas, L, x), g = !0;
            }
            r && k.call(this, r), e && F.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - n;
            case "top":
                return t + e - n;
            case "hanging":
                return t + e - 2 * n;
            case "middle":
                return t + e / 2 - n;
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, n, r, i, a, o, s, u) {
        for(var c = M.call(this, n, r, i, a), l = 0; l < c.length; l++){
            var h = c[l];
            0 === l && (u ? I.call(this, h.x1 + t, h.y1 + e) : C.call(this, h.x1 + t, h.y1 + e)), B.call(this, t, e, h.x2, h.y2, h.x3, h.y3, h.x4, h.y4);
        }
        s ? F.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, F = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, I = function(t, e) {
        this.pdf.internal.out(r(t) + " " + i(e) + " m");
    }, j = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            default:
                e = "left";
        }
        var n = this.pdf.getTextDimensions(t.text), r = S.call(this, t.y), i = _.call(this, r) - n.h, a = this.ctx.transform.applyToPoint(new u(t.x, r)), o = this.ctx.transform.decompose(), s = new l;
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for(var h, f, d, p = this.ctx.transform.applyToRectangle(new c(t.x, r, n.w, n.h)), g = s.applyToRectangle(new c(t.x, i, n.w, n.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for(var x = v[0], P = v[v.length - 1], k = x; k < P + 1; k++){
            this.pdf.setPage(k);
            var F = 1 === k ? this.posY + this.margin[0] : this.margin[0], I = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], j = this.pdf.internal.pageSize.height - this.margin[2], C = j - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : I + (k - 2) * C;
            if (0 !== this.ctx.clip_path.length) {
                var q = this.path;
                h = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(h, this.posX + this.margin[3], -1 * M + F), A.call(this, "fill", !0), this.path = q;
            }
            var E = N([
                JSON.parse(JSON.stringify(g))
            ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0];
            t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
            var R = "text" !== this.autoPaging;
            if (R || E.y + E.h <= j) {
                if (R || E.y >= F && E.x <= O) {
                    var D = R ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - E.x)[0], T = N([
                        JSON.parse(JSON.stringify(p))
                    ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0], z = R && (k > x || k < P) && b.call(this);
                    z && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, C, null).clip().discardPath()), this.pdf.text(D, T.x, T.y, {
                        angle: t.angle,
                        align: e,
                        renderingMode: t.renderingMode
                    }), z && this.pdf.restoreGraphicsState();
                }
            } else E.y < j && (this.ctx.prevPageLastElemOffset += j - E.y);
            t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        }
        else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
    }, C = function(t, e, n, a) {
        n = n || 0, a = a || 0, this.pdf.internal.out(r(t + n) + " " + i(e + a) + " l");
    }, O = function(t, e, n) {
        return this.pdf.lines(t, e, n, null, null);
    }, B = function(t, e, r, i, o, u, c, l) {
        this.pdf.internal.out([
            n(a(r + t)),
            n(s(i + e)),
            n(a(o + t)),
            n(s(u + e)),
            n(a(c + t)),
            n(s(l + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, n, r) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > n;)e -= i;
        var o = Math.abs(n - e);
        o < i && r && (o = i - o);
        for(var s = [], u = r ? -1 : 1, c = e; o > 1e-5;){
            var l = c + u * Math.min(o, a);
            s.push(q.call(this, t, c, l)), o -= Math.abs(l - c), c = l;
        }
        return s;
    }, q = function(t, e, n) {
        var r = (n - e) / 2, i = t * Math.cos(r), a = t * Math.sin(r), o = i, s = -a, u = o * o + s * s, c = u + o * i + s * a, l = 4 / 3 * (Math.sqrt(2 * u * c) - c) / (o * a - s * i), h = o - l * s, f = s + l * o, d = h, p = -f, g = r + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: h * m - f * v,
            y2: h * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(n),
            y4: t * Math.sin(n)
        };
    }, E = function(t) {
        return 180 * t / Math.PI;
    }, R = function(t, e, n, r, i, a) {
        var o = t + .5 * (n - t), s = e + .5 * (r - e), u = i + .5 * (n - i), l = a + .5 * (r - a), h = Math.min(t, i, o, u), f = Math.max(t, i, o, u), d = Math.min(e, a, s, l), p = Math.max(e, a, s, l);
        return new c(h, d, f - h, p - d);
    }, D = function(t, e, n, r, i, a, o, s) {
        var u, l, h, f, d, p, g, m, v, b, y, w, N, L, x = n - t, A = r - e, S = i - n, _ = a - r, P = o - i, k = s - a;
        for(l = 0; l < 41; l++)v = (g = (h = t + (u = l / 40) * x) + u * ((d = n + u * S) - h)) + u * (d + u * (i + u * P - d) - g), b = (m = (f = e + u * A) + u * ((p = r + u * _) - f)) + u * (p + u * (a + u * k - p) - m), 0 == l ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new c(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, n = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== n && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = n);
        }
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var n = function(t) {
        var e, n, r, i, a, o, s, u, c, l;
        for(/[^\x00-\xFF]/.test(t), n = [], r = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > r; r += 4)0 !== (a = (t.charCodeAt(r) << 24) + (t.charCodeAt(r + 1) << 16) + (t.charCodeAt(r + 2) << 8) + t.charCodeAt(r + 3)) ? (o = (a = ((a = ((a = ((a = (a - (l = a % 85)) / 85) - (c = a % 85)) / 85) - (u = a % 85)) / 85) - (s = a % 85)) / 85) % 85, n.push(o + 33, s + 33, u + 33, c + 33, l + 33)) : n.push(122);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(n, e.length), String.fromCharCode.apply(String, n) + "~>";
    }, r = function(t) {
        var e, n, r, i, a, o = String, s = "length", u = 255, c = "charCodeAt", l = "slice", h = "replace";
        for(t[l](-2), t = t[l](0, -2)[h](/\s/g, "")[h]("z", "!!!!!"), r = [], i = 0, a = (t += e = "uuuuu"[l](t[s] % 5 || 5))[s]; a > i; i += 5)n = 52200625 * (t[c](i) - 33) + 614125 * (t[c](i + 1) - 33) + 7225 * (t[c](i + 2) - 33) + 85 * (t[c](i + 3) - 33) + (t[c](i + 4) - 33), r.push(u & n >> 24, u & n >> 16, u & n >> 8, u & n);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(r, e[s]), o.fromCharCode.apply(o, r);
    }, i = function(t) {
        return t.split("").map(function(t) {
            return ("0" + t.charCodeAt().toString(16)).slice(-2);
        }).join("") + ">";
    }, a = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var n = "", r = 0; r < t.length; r += 2)n += String.fromCharCode("0x" + (t[r] + t[r + 1]));
        return n;
    }, o = function(t) {
        for(var n = new Uint8Array(t.length), r = t.length; r--;)n[r] = t.charCodeAt(r);
        return (n = (0, $gCcZP.zlibSync)(n)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var s = 0, u = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), s = 0; s < e.length; s += 1)switch(e[s]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                u = r(u), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                u = n(u), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                u = a(u), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                u = i(u), c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                u = o(u), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[s] + '" is not implemented');
        }
        return {
            data: u,
            reverseChain: c.reverse().join(" ")
        };
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, n) {
        return function(t, e, n) {
            e = !1 !== e, n = "function" == typeof n ? n : function() {};
            var r = void 0;
            try {
                r = function(t, e, n) {
                    var r = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, n = [], r = String.fromCharCode;
                        for(i = 0; i < e; i += 1)n.push(r(255 & t.charCodeAt(i)));
                        return n.join("");
                    };
                    if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                        200 === r.status ? n(a(this.responseText)) : n(void 0);
                    }), r.send(null), e && 200 === r.status) return a(r.responseText);
                }(t, e, n);
            } catch (i) {}
            return r;
        }(t, e, n);
    }, t.loadImageFile = t.loadFile;
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), function(e) {
    function n() {
        return ($e5456e2f96ba3898$var$i.html2canvas ? Promise.resolve($e5456e2f96ba3898$var$i.html2canvas) : (parcelRequire("8LL9e"))).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function r() {
        return ($e5456e2f96ba3898$var$i.DOMPurify ? Promise.resolve($e5456e2f96ba3898$var$i.DOMPurify) : (parcelRequire("dP7i3"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var n = (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e);
        return "undefined" === n ? "undefined" : "string" === n || e instanceof String ? "string" : "number" === n || e instanceof Number ? "number" : "function" === n || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === n ? "object" : "unknown";
    }, o = function(t, e) {
        var n = document.createElement(t);
        for(var r in e.className && (n.className = e.className), e.innerHTML && e.dompurify && (n.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)n.style[r] = e.style[r];
        return n;
    }, s = function t(e, n) {
        for(var r = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== n && 1 === i.nodeType && "SCRIPT" === i.nodeName || r.appendChild(t(i, n));
        return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (r.value = e.value), r.addEventListener("load", function() {
            r.scrollTop = e.scrollTop, r.scrollLeft = e.scrollLeft;
        }, !0)), r;
    }, u = function t(e) {
        var n = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), r = t.convert(Promise.resolve(), n);
        return (r = r.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (u.prototype = Object.create(Promise.prototype)).constructor = u, u.convert = function(t, e) {
        return t.__proto__ = e || u.prototype, t;
    }, u.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, u.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t), e){
                case "string":
                    return this.then(r).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, u.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, u.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = s(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, u.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = this.opt.jsPDF, n = this.opt.fontFaces, r = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: r,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = n, n) for(var a = 0; a < n.length; ++a){
                var o = n[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, u.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, u.prototype.output = function(t, e, n) {
        return "img" === (n = n || "pdf").toLowerCase() || "image" === n.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, u.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, u.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, u.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, u.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, u.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in u.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, u.prototype.get = function(t, e) {
        return this.then(function() {
            var n = t in u.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(n) : n;
        });
    }, u.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, u.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || $e5456e2f96ba3898$export$2e2bcd8739ae039.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, u.prototype.setProgress = function(t, e, n, r) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != n && (this.progress.n = n), null != r && (this.progress.stack = r), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, u.prototype.updateProgress = function(t, e, n, r) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, n ? this.progress.n + n : null, r ? this.progress.stack.concat(r) : null);
    }, u.prototype.then = function(t, e) {
        var n = this;
        return this.thenCore(t, e, function(t, e) {
            return n.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return n.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return n.updateProgress(1), t;
            });
        });
    }, u.prototype.thenCore = function(t, e, n) {
        n = n || Promise.prototype.then;
        var r = this;
        t && (t = t.bind(r)), e && (e = e.bind(r));
        var i = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? r : u.convert(Object.assign({}, r), Promise.prototype), a = n.call(i, t, e);
        return u.convert(a, r.__proto__);
    }, u.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, u.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, u.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return u.convert(e, this);
    }, u.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, u.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, u.prototype.using = u.prototype.set, u.prototype.saveAs = u.prototype.save, u.prototype.export = u.prototype.output, u.prototype.run = u.prototype.then, $e5456e2f96ba3898$export$2e2bcd8739ae039.getPageSize = function(e, n, r) {
        if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e)) {
            var i = e;
            e = i.orientation, n = i.unit || n, r = i.format || r;
        }
        n = n || "mm", r = r || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + r).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(n){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + n;
        }
        var u, c = 0, l = 0;
        if (s.hasOwnProperty(o)) c = s[o][1] / a, l = s[o][0] / a;
        else try {
            c = r[1], l = r[0];
        } catch (h) {
            throw new Error("Invalid format: " + r);
        }
        if ("p" === e || "portrait" === e) e = "p", l > c && (u = l, l = c, c = u);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", c > l && (u = l, l = c, c = u);
        }
        return {
            width: l,
            height: c,
            unit: n,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map($e5456e2f96ba3898$var$Ct) : null;
        var n = new u(e);
        return e.worker ? n : n.from(t).doCallback();
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), $e5456e2f96ba3898$export$2e2bcd8739ae039.API.addJS = function(t) {
    return $e5456e2f96ba3898$var$Ut = t, this.internal.events.subscribe("postPutResources", function() {
        $e5456e2f96ba3898$var$Tt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($e5456e2f96ba3898$var$Tt + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), $e5456e2f96ba3898$var$zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + $e5456e2f96ba3898$var$Ut + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== $e5456e2f96ba3898$var$Tt && void 0 !== $e5456e2f96ba3898$var$zt && this.internal.out("/Names <</JavaScript " + $e5456e2f96ba3898$var$Tt + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, n = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var r = t.outline.render().split(/\r\n/), i = 0; i < r.length; i++){
                var a = r[i], o = n.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var u = this.internal.pages.length, c = [];
                for(i = 0; i < u; i++){
                    var l = t.internal.newObject();
                    c.push(l);
                    var h = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + h.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), i = 0; i < c.length; i++)t.internal.write("(page_" + (i + 1) + ")" + c[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            var t = this;
            t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var n = 0; n < e.children.length; n++)this.genIds_r(e.children[n]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var n = this.ctx.pdf.internal.getVerticalCoordinateString, r = 0; r < e.children.length; r++){
                    var i = e.children[r];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), r > 0 && this.line("/Prev " + this.makeRef(e.children[r - 1])), r < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[r + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]);
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, n, r, i, a, o) {
        var s, u = this.decode.DCT_DECODE, c = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, s = function(t) {
                for(var n, r = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += r, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        n = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: n,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    r = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), s.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            c = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: u,
                index: n,
                alias: r
            };
        }
        return c;
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), $e5456e2f96ba3898$export$2e2bcd8739ae039.API.processPNG = function(t, i, a, o) {
    if (this.__addimage__.isArrayBuffer(t) && (t = new Uint8Array(t)), this.__addimage__.isArrayBufferView(t)) {
        var s, u = (0, $jyQYM.decode)(t, {
            checkCrc: !0
        }), c = u.width, l = u.height, h = u.channels, f = u.palette, d = u.depth;
        s = f && 1 === h ? function(t) {
            for(var e = t.width, r = t.height, i = t.data, a = t.palette, o = t.depth, s = !1, u = [], c = [], l = void 0, h = !1, f = 0, d = 0; d < a.length; d++){
                var p = (0, (/*@__PURE__*/$parcel$interopDefault($dgEZh)))(a[d], 4), g = p[0], m = p[1], v = p[2], b = p[3];
                u.push(g, m, v), null != b && (0 === b ? (f++, c.length < 1 && c.push(d)) : b < 255 && (h = !0));
            }
            if (h || f > 1) {
                s = !0, c = void 0;
                var y = e * r;
                l = new Uint8Array(y);
                for(var w = new DataView(i.buffer), N = 0; N < y; N++){
                    var L = $e5456e2f96ba3898$var$re(w, N, o), x = (0, (/*@__PURE__*/$parcel$interopDefault($dgEZh)))(a[L], 4)[3];
                    l[N] = x;
                }
            } else 0 === f && (c = void 0);
            return {
                colorSpace: "Indexed",
                colorsPerPixel: 1,
                sMaskBitsPerComponent: s ? 8 : void 0,
                colorBytes: i,
                alphaBytes: l,
                needSMask: s,
                palette: u,
                mask: c
            };
        }(u) : 2 === h || 4 === h ? function(t) {
            for(var e = t.data, n = t.width, r = t.height, i = t.channels, a = t.depth, o = 2 === i ? "DeviceGray" : "DeviceRGB", s = i - 1, u = n * r, c = s, l = u * c, h = 1 * u, f = Math.ceil(l * a / 8), d = Math.ceil(h * a / 8), p = new Uint8Array(f), g = new Uint8Array(d), m = new DataView(e.buffer), v = new DataView(p.buffer), b = new DataView(g.buffer), y = !1, w = 0; w < u; w++){
                for(var N = w * i, L = 0; L < c; L++)$e5456e2f96ba3898$var$ie(v, $e5456e2f96ba3898$var$re(m, N + L, a), w * c + L, a);
                var x = $e5456e2f96ba3898$var$re(m, N + c, a);
                x < (1 << a) - 1 && (y = !0), $e5456e2f96ba3898$var$ie(b, x, 1 * w, a);
            }
            return {
                colorSpace: o,
                colorsPerPixel: s,
                sMaskBitsPerComponent: y ? a : void 0,
                colorBytes: p,
                alphaBytes: g,
                needSMask: y
            };
        }(u) : function(t) {
            var e = t.data, n = 1 === t.channels ? "DeviceGray" : "DeviceRGB";
            return {
                colorSpace: n,
                colorsPerPixel: "DeviceGray" === n ? 1 : 3,
                colorBytes: e instanceof Uint16Array ? function(t) {
                    for(var e = t.length, n = new Uint8Array(2 * e), r = new DataView(n.buffer, n.byteOffset, n.byteLength), i = 0; i < e; i++)r.setUint16(2 * i, t[i], !1);
                    return n;
                }(e) : e,
                needSMask: !1
            };
        }(u);
        var p, g, m, v = s, b = v.colorSpace, y = v.colorsPerPixel, w = v.sMaskBitsPerComponent, N = v.colorBytes, L = v.alphaBytes, x = v.needSMask, A = v.palette, S = v.mask, _ = null;
        return o !== $e5456e2f96ba3898$export$2e2bcd8739ae039.API.image_compression.NONE && "function" == typeof (0, $gCcZP.zlibSync) ? (_ = function(t) {
            var e;
            switch(t){
                case $e5456e2f96ba3898$export$2e2bcd8739ae039.API.image_compression.FAST:
                    e = 11;
                    break;
                case $e5456e2f96ba3898$export$2e2bcd8739ae039.API.image_compression.MEDIUM:
                    e = 13;
                    break;
                case $e5456e2f96ba3898$export$2e2bcd8739ae039.API.image_compression.SLOW:
                    e = 14;
                    break;
                default:
                    e = 12;
            }
            return e;
        }(o), p = this.decode.FLATE_DECODE, g = "/Predictor ".concat(_, " /Colors ").concat(y, " /BitsPerComponent ").concat(d, " /Columns ").concat(c), t = $e5456e2f96ba3898$var$Xt(N, Math.ceil(c * y * d / 8), y, d, o), x && (m = $e5456e2f96ba3898$var$Xt(L, Math.ceil(c * w / 8), 1, w, o))) : (p = void 0, g = void 0, t = N, x && (m = L)), (this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) && (t = this.__addimage__.arrayBufferToBinaryString(t)), (m && this.__addimage__.isArrayBuffer(m) || this.__addimage__.isArrayBufferView(m)) && (m = this.__addimage__.arrayBufferToBinaryString(m)), {
            alias: a,
            data: t,
            index: i,
            filter: p,
            decodeParameters: g,
            transparency: S,
            palette: A,
            sMask: m,
            predictor: _,
            width: c,
            height: l,
            bitsPerComponent: d,
            sMaskBitsPerComponent: w,
            colorSpace: b
        };
    }
}, function(t) {
    t.processGIF89A = function(e, n, r, i) {
        var a = new $e5456e2f96ba3898$var$oe(e), o = a.width, s = a.height, u = [];
        a.decodeAndBlitFrameRGBA(0, u);
        var c = {
            data: u,
            width: o,
            height: s
        }, l = new $e5456e2f96ba3898$var$ue(100).encode(c, 100);
        return t.processJPEG.call(this, l, n, r, i);
    }, t.processGIF87A = t.processGIF89A;
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), $e5456e2f96ba3898$var$ce.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: r,
                blue: n,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $e5456e2f96ba3898$var$ce.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (n) {
        $e5456e2f96ba3898$var$o.log("bit decode error:" + n);
    }
}, $e5456e2f96ba3898$var$ce.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), n = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var r = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var u = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = u.blue, this.data[o + 4 * s + 1] = u.green, this.data[o + 4 * s + 2] = u.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== n && (this.pos += 4 - n);
    }
}, $e5456e2f96ba3898$var$ce.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * i * 4, s = a >> 4, u = 15 & a, c = this.palette[s];
            if (this.data[o] = c.blue, this.data[o + 1] = c.green, this.data[o + 2] = c.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            c = this.palette[u], this.data[o + 4] = c.blue, this.data[o + 4 + 1] = c.green, this.data[o + 4 + 2] = c.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $e5456e2f96ba3898$var$ce.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
            var i = this.datav.getUint8(this.pos++, !0), a = n * this.width * 4 + 4 * r;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, $e5456e2f96ba3898$var$ce.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, u = (a >> 10 & e) / e * 255 | 0, c = a >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
            this.data[l] = u, this.data[l + 1] = s, this.data[l + 2] = o, this.data[l + 3] = c;
        }
        this.pos += t;
    }
}, $e5456e2f96ba3898$var$ce.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; r >= 0; r--){
        for(var i = this.bottom_up ? r : this.height - 1 - r, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, u = (o >> 5 & n) / n * 255 | 0, c = (o >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * a;
            this.data[l] = c, this.data[l + 1] = u, this.data[l + 2] = s, this.data[l + 3] = 255;
        }
        this.pos += t;
    }
}, $e5456e2f96ba3898$var$ce.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * n;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = r, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $e5456e2f96ba3898$var$ce.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
        var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = o;
    }
}, $e5456e2f96ba3898$var$ce.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, n, r, i) {
        var a = new $e5456e2f96ba3898$var$ce(e, !1), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $e5456e2f96ba3898$var$ue(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), $e5456e2f96ba3898$var$le.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, n, r, i) {
        var a = new $e5456e2f96ba3898$var$le(e), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $e5456e2f96ba3898$var$ue(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), $e5456e2f96ba3898$export$2e2bcd8739ae039.API.processRGBA = function(t, e, n) {
    for(var r = t.data, i = r.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, u = 0, c = 0; c < i; c += 4){
        var l = r[c], h = r[c + 1], f = r[c + 2], d = r[c + 3];
        a[s++] = l, a[s++] = h, a[s++] = f, o[u++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: n,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, $e5456e2f96ba3898$export$2e2bcd8739ae039.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, $e5456e2f96ba3898$var$Ht = $e5456e2f96ba3898$export$2e2bcd8739ae039.API, $e5456e2f96ba3898$var$Wt = $e5456e2f96ba3898$var$Ht.getCharWidthsArray = function(e, n) {
    var r, i, a = (n = n || {}).font || this.internal.getFont(), o = n.fontSize || this.internal.getFontSize(), s = n.charSpace || this.internal.getCharSpace(), u = n.widths ? n.widths : a.metadata.Unicode.widths, c = u.fof ? u.fof : 1, l = n.kerning ? n.kerning : a.metadata.Unicode.kerning, h = l.fof ? l.fof : 1, f = !1 !== n.doKerning, d = 0, p = e.length, g = 0, m = u[0] || c, v = [];
    for(r = 0; r < p; r++)i = e.charCodeAt(r), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(l[i]) && !isNaN(parseInt(l[i][g], 10)) ? l[i][g] / h : 0, v.push((u[i] || m) / c + d)), g = i;
    return v;
}, $e5456e2f96ba3898$var$Vt = $e5456e2f96ba3898$var$Ht.getStringUnitWidth = function(t, e) {
    var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return $e5456e2f96ba3898$var$Ht.processArabic && (t = $e5456e2f96ba3898$var$Ht.processArabic(t)), "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : $e5456e2f96ba3898$var$Wt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $e5456e2f96ba3898$var$Gt = function(t, e, n, r) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < n;)s += e[a], a++;
    i.push(t.slice(0, a));
    var u = a;
    for(s = 0; a !== o;)s + e[a] > r && (i.push(t.slice(u, a)), s = 0, u = a), s += e[a], a++;
    return u !== a && i.push(t.slice(u, a)), i;
}, $e5456e2f96ba3898$var$Yt = function(t, e, n) {
    n || (n = {});
    var r, i, a, o, s, u, c, l = [], h = [
        l
    ], f = n.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $e5456e2f96ba3898$var$Wt.apply(this, [
        " ",
        n
    ])[0];
    if (u = -1 === n.lineIndent ? g[0].length + 2 : n.lineIndent || 0) {
        var v = Array(u).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, u = $e5456e2f96ba3898$var$Vt.apply(this, [
            v,
            n
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (r = g[a], u && "\n" == r[0] && (r = r.substr(1), y = 1), f + d + (p = (i = $e5456e2f96ba3898$var$Wt.apply(this, [
            r,
            n
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = $e5456e2f96ba3898$var$Gt.apply(this, [
                    r,
                    i,
                    e - (f + d),
                    e
                ]), l.push(s.shift()), l = [
                    s.pop()
                ]; s.length;)h.push([
                    s.shift()
                ]);
                p = i.slice(r.length - (l[0] ? l[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else l = [
                r
            ];
            h.push(l), f = p + u, d = m;
        } else l.push(r), f += d + p, d = m;
    }
    return c = u ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, h.map(c);
}, $e5456e2f96ba3898$var$Ht.splitTextToSize = function(t, e, n) {
    var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle), n = "Unicode";
        return e.metadata[n] ? {
            widths: e.metadata[n].widths || {
                0: 1
            },
            kerning: e.metadata[n].kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, n);
    r = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = n.lineIndent;
    var s, u, c = [];
    for(s = 0, u = r.length; s < u; s++)c = c.concat($e5456e2f96ba3898$var$Yt.apply(this, [
        r[s],
        o,
        a
    ]));
    return c;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var n = "0123456789abcdef", r = "klmnopqrstuvwxyz", i = {}, a = {}, o = 0; o < 16; o++)i[r[o]] = n[o], a[n[o]] = r[o];
    var s = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, u = e.__fontmetrics__.compress = function(e) {
        var n, r, i, o, c = [
            "{"
        ];
        for(var l in e){
            if (n = e[l], isNaN(parseInt(l, 10)) ? r = "'" + l + "'" : (l = parseInt(l, 10), r = (r = s(l).slice(2)).slice(0, -1) + a[r.slice(-1)]), "number" == typeof n) n < 0 ? (i = s(n).slice(3), o = "-") : (i = s(n).slice(2), o = ""), i = o + i.slice(0, -1) + a[i.slice(-1)];
            else {
                if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(n)) throw new Error("Don't know what to do with value type " + (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(n) + ".");
                i = u(n);
            }
            c.push(r + i);
        }
        return c.push("}"), c.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, n, r, a, o = {}, s = 1, u = o, c = [], l = "", h = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (r = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (c.push([
            u,
            r
        ]), u = {}, r = void 0) : "}" == a ? ((n = c.pop())[0][n[1]] = u, r = void 0, u = n[0]) : "-" == a ? s = -1 : void 0 === r ? i.hasOwnProperty(a) ? (l += i[a], r = parseInt(l, 16) * s, s = 1, l = "") : l += a : i.hasOwnProperty(a) ? (h += i[a], u[r] = parseInt(h, 16) * s, s = 1, r = void 0, h = "") : h += a;
        return o;
    }, l = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: l,
            "Courier-Bold": l,
            "Courier-BoldOblique": l,
            "Courier-Oblique": l,
            Helvetica: l,
            "Helvetica-Bold": l,
            "Helvetica-BoldOblique": l,
            "Helvetica-Oblique": l,
            "Times-Roman": l,
            "Times-Bold": l,
            "Times-BoldItalic": l,
            "Times-Italic": l
        }
    }, f = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, n = f.Unicode[e.postScriptName];
            n && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = n.widths, e.metadata.Unicode.kerning = n.kerning);
            var r = h.Unicode[e.postScriptName];
            r && (e.metadata.Unicode.encoding = r, e.encoding = r.codePages[0]);
        }
    ]);
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    };
    t.API.events.push([
        "addFont",
        function(n) {
            var r = void 0, i = n.font, a = n.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (r = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(n, r) {
                    r = /^\x00\x01\x00\x00/.test(r) ? e(r) : e($e5456e2f96ba3898$var$f(r)), n.metadata = t.API.TTFFont.open(r), n.metadata.Unicode = n.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, n.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, r);
            }
        }
    ]);
}($e5456e2f96ba3898$export$2e2bcd8739ae039), $e5456e2f96ba3898$export$2e2bcd8739ae039.API.addSvgAsImage = function(t, e, n, r, a, s, u, c) {
    if (isNaN(e) || isNaN(n)) throw $e5456e2f96ba3898$var$o.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(r) || isNaN(a)) throw $e5456e2f96ba3898$var$o.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var l = document.createElement("canvas");
    l.width = r, l.height = a;
    var h = l.getContext("2d");
    h.fillStyle = "#fff", h.fillRect(0, 0, l.width, l.height);
    var f = {
        ignoreMouse: !0,
        ignoreAnimation: !0,
        ignoreDimensions: !0
    }, d = this;
    return ($e5456e2f96ba3898$var$i.canvg ? Promise.resolve($e5456e2f96ba3898$var$i.canvg) : (parcelRequire("bI9cw"))).catch(function(t) {
        return Promise.reject(new Error("Could not load canvg: " + t));
    }).then(function(t) {
        return t.default ? t.default : t;
    }).then(function(e) {
        return e.fromString(h, t, f);
    }, function() {
        return Promise.reject(new Error("Could not load canvg."));
    }).then(function(t) {
        return t.render(f);
    }).then(function() {
        d.addImage(l.toDataURL("image/jpeg", 1), e, n, r, a, u, c);
    });
}, $e5456e2f96ba3898$export$2e2bcd8739ae039.API.putTotalPages = function(t) {
    var e, n = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), n = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var r = 1; r <= this.internal.getNumberOfPages(); r++)for(var i = 0; i < this.internal.pages[r].length; i++)this.internal.pages[r][i] = this.internal.pages[r][i].replace(e, n);
    return this;
}, $e5456e2f96ba3898$export$2e2bcd8739ae039.API.viewerPreferences = function(e, n) {
    var r;
    e = e || {}, n = n || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, u = Object.keys(s), c = [], l = 0, h = 0, f = 0;
    function d(t, e) {
        var n, r = !1;
        for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
        return r;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), r = this.internal.viewerpreferences.configuration, "reset" === e || !0 === n) {
        var p = u.length;
        for(f = 0; f < p; f += 1)r[u[f]].value = r[u[f]].defaultValue, r[u[f]].explicitSet = !1;
    }
    if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($alU2v)))(e)) {
        for(a in e)if (o = e[a], d(u, a) && void 0 !== o) {
            if ("boolean" === r[a].type && "boolean" == typeof o) r[a].value = o;
            else if ("name" === r[a].type && d(r[a].valueSet, o)) r[a].value = o;
            else if ("integer" === r[a].type && Number.isInteger(o)) r[a].value = o;
            else if ("array" === r[a].type) {
                for(l = 0; l < o.length; l += 1)if (i = !0, 1 === o[l].length && "number" == typeof o[l][0]) c.push(String(o[l] - 1));
                else if (o[l].length > 1) {
                    for(h = 0; h < o[l].length; h += 1)"number" != typeof o[l][h] && (i = !1);
                    !0 === i && c.push([
                        o[l][0] - 1,
                        o[l][1] - 1
                    ].join(" "));
                }
                r[a].value = "[" + c.join(" ") + "]";
            } else r[a].value = r[a].defaultValue;
            r[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in r)!0 === r[t].explicitSet && ("name" === r[t].type ? e.push("/" + t + " /" + r[t].value) : e.push("/" + t + " " + r[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = r, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = n.length + r.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, n = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, r) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: r || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", e)), this;
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), function(t) {
    var e = t.API, n = e.pdfEscape16 = function(t, e) {
        for(var n, r = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (n = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(n), e.metadata.toUnicode[n] = t.charCodeAt(o), -1 == r.indexOf(n) && (r.push(n), r.push([
                parseInt(e.metadata.widthOfGlyph(n), 10)
            ])), "0" == n) return a.join("");
            n = n.toString(16), a.push(i[4 - n.length], n);
        }
        return a.join("");
    }, r = function(t) {
        var e, n, r, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", r = [], o = 0, s = (n = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = n[o], r.length >= 100 && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar", r = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), r.push("<" + e + "><" + i + ">"));
        return r.length && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar\n"), a + "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (n.metadata instanceof t.API.TTFFont && "Identity-H" === n.encoding) {
                    for(var s = n.metadata.Unicode.widths, u = n.metadata.subset.encode(n.metadata.glyIdsUsed, 1), c = "", l = 0; l < u.length; l++)c += String.fromCharCode(u[l]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + $e5456e2f96ba3898$var$j(n.fontName)), i("/FontFile2 " + h + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/Flags " + n.metadata.flags), i("/StemV " + n.metadata.stemV), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + $e5456e2f96ba3898$var$j(n.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + n.encoding + ")"), i(">>"), i(">>"), i("endobj"), n.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + $e5456e2f96ba3898$var$j(n.fontName)), i("/Encoding /" + n.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]), e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (n.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === n.encoding) {
                    for(var s = n.metadata.rawData, u = "", c = 0; c < s.length; c++)u += String.fromCharCode(s[c]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var h = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i("/StemV " + n.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + l + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/FontName /" + $e5456e2f96ba3898$var$j(n.fontName)), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i(">>"), i("endobj"), n.objectNumber = a();
                    for(var d = 0; d < n.metadata.hmtx.widths.length; d++)n.metadata.hmtx.widths[d] = parseInt(n.metadata.hmtx.widths[d] * (1e3 / n.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + h + " 0 R/BaseFont/" + $e5456e2f96ba3898$var$j(n.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + n.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(n.metadata.hmtx.widths) + ">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, r = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, u = s.pdfEscape, c = s.activeFontKey, l = s.fonts, h = c, f = "", d = 0, p = "", g = l[h].encoding;
        if ("Identity-H" !== l[h].encoding) return {
            text: r,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = r, h = c, Array.isArray(r) && (p = r[0]), d = 0; d < p.length; d += 1)l[h].metadata.hasOwnProperty("cmap") && (e = l[h].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && l[h].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(h.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = u(f, h).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = n(f, l[h])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", n = [], r = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? n.push([
                    i(Object.assign({}, r, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : n.push(i(Object.assign({}, r, {
                    text: e[a]
                })).text);
                t.text = n;
            } else t.text = i(Object.assign({}, r, {
                text: e
            })).text;
        }
    ]);
}($e5456e2f96ba3898$export$2e2bcd8739ae039), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, n) {
        return e.call(this), this.internal.vFS[t] = n, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($e5456e2f96ba3898$export$2e2bcd8739ae039.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var n, r, i, a, o, s, u, c = e, l = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], h = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), n = e >> 8, r = d[n];
            return void 0 !== r ? c[256 * r + (255 & e)] : 252 === n || 253 === n ? "AL" : g.test(n) ? "L" : 8 === n ? "R" : "N";
        }, y = function(t) {
            for(var e, n = 0; n < t.length; n++){
                if ("L" === (e = b(t.charAt(n)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var u, c, l, h, f = e[s];
            switch(f){
                case "L":
                case "R":
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                case "BN":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (u = o[s - 1]) && "AN" !== u || "EN" !== (c = e[s + 1]) && "AN" !== c ? f = "N" : m && (c = "AN"), f = c === u ? c : "N";
                    break;
                case "ES":
                    f = "EN" === (u = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(l = s + 1, h = e.length; l < h && "ET" === e[l];)l++;
                    f = l < h && "EN" === e[l] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(h = e.length, l = s + 1; l < h && "NSM" === e[l];)l++;
                        if (l < h) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (u = e[l], p && ("R" === u || "AL" === u)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (u = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, n = !0, f = v;
                    break;
                case "S":
                    r = !0, f = "N";
            }
            return f;
        }, N = function(t, e, n) {
            var r = t.split("");
            return n && L(r, n, {
                hiLevel: v
            }), r.reverse(), e && e.reverse(), r.join("");
        }, L = function(t, e, i) {
            var a, o, s, u, c, d = -1, p = t.length, g = 0, y = [], N = v ? h : l, L = [];
            for(m = !1, n = !1, r = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (c = g, y[s] = w(t, L, y, s), a = 240 & (g = N[c][f[y[s]]]), g &= 15, e[s] = u = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = u;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= u;
            }
            r && function(t, e, n) {
                for(var r = 0; r < n; r++)if ("S" === t[r]) {
                    e[r] = v;
                    for(var i = r - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, x = function(t, e, r, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !n) return e.reverse(), void (r && r.reverse());
                for(var o, s, u, c, l = e.length, h = 0; h < l;){
                    if (i[h] >= t) {
                        for(u = h + 1; u < l && i[u] >= t;)u++;
                        for(c = h, s = u - 1; c < s; c++, s--)o = e[c], e[c] = e[s], e[s] = o, r && (o = r[c], r[c] = r[s], r[s] = o);
                        h = u;
                    }
                    h++;
                }
            }
        }, A = function(t, e, n) {
            var r = t.split(""), i = {
                hiLevel: v
            };
            return n || (n = []), L(r, n, i), function(t, e, n) {
                if (0 !== n.hiLevel && u) for(var r, i = 0; i < t.length; i++)1 === e[i] && (r = p.indexOf(t[i])) >= 0 && (t[i] = p[r + 1]);
            }(r, n, i), x(2, r, e, n, i), x(1, r, e, n, i), r.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, n) {
            if (function(t, e) {
                if (e) for(var n = 0; n < t.length; n++)e[n] = n;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, n);
                else if (!i && o && s) v = a ? 1 : 0, t = A(t, e, n), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = A(t, e, n)) : (v = 1, t = A(t, e, n), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = A(t, e, n), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var r = u;
                        a ? (v = 1, t = A(t, e, n), v = 0, u = !1, t = A(t, e, n), u = r) : (v = 0, t = A(t, e, n), t = N(t, e), v = 1, u = !1, t = A(t, e, n), u = r, t = N(t, e));
                    }
                } else v = 0, t = A(t, e, n);
            } else v = a ? 1 : 0, t = A(t, e, n);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, u = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], n = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text;
            t.x, t.y;
            var r = t.options || {};
            t.mutex, r.lang;
            var i = [];
            if (r.isInputVisual = "boolean" != typeof r.isInputVisual || r.isInputVisual, n.setOptions(r), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    n.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    n.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = n.doBidiReorder(e);
            n.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($e5456e2f96ba3898$export$2e2bcd8739ae039), $e5456e2f96ba3898$export$2e2bcd8739ae039.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $e5456e2f96ba3898$var$fe(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $e5456e2f96ba3898$var$je(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new $e5456e2f96ba3898$var$de(this.contents), this.head = new $e5456e2f96ba3898$var$me(this), this.name = new $e5456e2f96ba3898$var$xe(this), this.cmap = new $e5456e2f96ba3898$var$be(this), this.toUnicode = {}, this.hhea = new $e5456e2f96ba3898$var$ye(this), this.maxp = new $e5456e2f96ba3898$var$Ae(this), this.hmtx = new $e5456e2f96ba3898$var$Se(this), this.post = new $e5456e2f96ba3898$var$Ne(this), this.os2 = new $e5456e2f96ba3898$var$we(this), this.loca = new $e5456e2f96ba3898$var$Ie(this), this.glyf = new $e5456e2f96ba3898$var$Pe(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, n, r, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, n, r, i;
            for(i = [], e = 0, n = (r = this.bbox).length; e < n; e++)t = r[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (n = 255 & (r = this.post.italic_angle), 32768 & (e = r >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + n)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, n) {
        var r, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)r = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var n;
        return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
    }, t;
}();
var $e5456e2f96ba3898$var$he, $e5456e2f96ba3898$var$fe = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, n;
        for(n = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)n[e] = String.fromCharCode(this.readByte());
        return n.join("");
    }, t.prototype.writeString = function(t) {
        var e, n, r;
        for(r = [], e = 0, n = t.length; 0 <= n ? e < n : e > n; e = 0 <= n ? ++e : --e)r.push(this.writeByte(t.charCodeAt(e)));
        return r;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, n, r, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, n;
        return e = Math.floor(t / 4294967296), n = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, n;
        for(e = [], n = 0; 0 <= t ? n < t : n > t; n = 0 <= t ? ++n : --n)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, n, r, i;
        for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
        return i;
    }, t;
}(), $e5456e2f96ba3898$var$de = function() {
    var t;
    function e(t) {
        var e, n, r;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), l = 16 * Math.floor(Math.log(f) / s), a = Math.floor(l / s), c = 16 * f - l, (r = new $e5456e2f96ba3898$var$fe).writeInt(this.scalarType), r.writeShort(f), r.writeShort(l), r.writeShort(a), r.writeShort(c), i = 16 * f, u = r.pos + i, o = null, d = [], e)for(h = e[p], r.writeString(p), r.writeInt(t(h)), r.writeInt(u), r.writeInt(h.length), d = d.concat(h), "head" === p && (o = u), u += h.length; u % 4;)d.push(0), u++;
        return r.write(d), n = 2981146554 - t(r.data), r.pos = o + 8, r.writeUInt32(n), r.data;
    }, t = function(t) {
        var e, n, r, i;
        for(t = $e5456e2f96ba3898$var$_e.call(t); t.length % 4;)t.push(0);
        for(r = new $e5456e2f96ba3898$var$fe(t), n = 0, e = 0, i = t.length; e < i; e = e += 4)n += r.readUInt32();
        return 4294967295 & n;
    }, e;
}(), $e5456e2f96ba3898$var$pe = {}.hasOwnProperty, $e5456e2f96ba3898$var$ge = function(t, e) {
    for(var n in e)$e5456e2f96ba3898$var$pe.call(e, n) && (t[n] = e[n]);
    function r() {
        this.constructor = t;
    }
    return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
};
$e5456e2f96ba3898$var$he = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var $e5456e2f96ba3898$var$me = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "head", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, t.prototype.encode = function(t) {
        var e;
        return (e = new $e5456e2f96ba3898$var$fe).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, t;
}(), $e5456e2f96ba3898$var$ve = function() {
    function t(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), l = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), h = f / 2, t.pos += 6, i = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), t.pos += 2, p = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), u = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), c = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), r = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= r ? e < r : e > r; s = 0 <= r ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], n = v = d = p[s]; d <= g ? v <= g : v >= g; n = d <= g ? ++v : --v)0 === c[s] ? a = n + u[s] : 0 !== (a = o[c[s] / 2 + (n - d) - (h - s)] || 0) && (a += u[s]), this.codeMap[n] = 65535 & a;
        }
        t.pos = l;
    }
    return t.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y, w, N, L, x, A, S, _, P, k, F, I, j, C, O, B, M, q, E, R, D, T, z, U, H, W, V, G, Y;
        switch(F = new $e5456e2f96ba3898$var$fe, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, I = 0, B = a.length; I < B; I++)null == v[W = t[r = a[I]]] && (v[W] = ++p), i[r] = {
                    old: t[r],
                    new: v[t[r]]
                }, g[r] = v[t[r]];
                return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                    charMap: i,
                    subtable: F.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], l = [], b = 0, v = {}, n = {}, m = u = null, j = 0, M = a.length; j < M; j++)null == v[w = t[r = a[j]]] && (v[w] = ++b), n[r] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - r, null != m && o === u || (m && l.push(m), P.push(r), u = o), m = r;
                for(m && l.push(m), l.push(65535), P.push(65535), S = 2 * (A = P.length), x = 2 * Math.pow(Math.log(A) / Math.LN2, 2), h = Math.log(x / 2) / Math.LN2, L = 2 * A - x, s = [], N = [], f = [], d = C = 0, q = P.length; C < q; d = ++C){
                    if (_ = P[d], c = l[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = n[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + A - d)), r = O = _; _ <= c ? O <= c : O >= c; r = _ <= c ? ++O : --O)f.push(n[r].new);
                    else s.push(k - _), N.push(0);
                }
                for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * A + 2 * f.length), F.writeUInt16(0), F.writeUInt16(S), F.writeUInt16(x), F.writeUInt16(h), F.writeUInt16(L), U = 0, E = l.length; U < E; U++)r = l[U], F.writeUInt16(r);
                for(F.writeUInt16(0), H = 0, R = P.length; H < R; H++)r = P[H], F.writeUInt16(r);
                for(V = 0, D = s.length; V < D; V++)o = s[V], F.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], F.writeUInt16(y);
                for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                return {
                    charMap: n,
                    subtable: F.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), $e5456e2f96ba3898$var$be = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "cmap", t.prototype.parse = function(t) {
        var e, n, r;
        for(t.pos = this.offset, this.version = t.readUInt16(), r = t.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = new $e5456e2f96ba3898$var$ve(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, t.encode = function(t, e) {
        var n, r;
        return null == e && (e = "macroman"), n = $e5456e2f96ba3898$var$ve.encode(t, e), (r = new $e5456e2f96ba3898$var$fe).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
    }, t;
}(), $e5456e2f96ba3898$var$ye = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "hhea", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, t;
}(), $e5456e2f96ba3898$var$we = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "OS/2", t.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, n;
            for(n = [], e = 0; e < 10; ++e)n.push(t.readByte());
            return n;
        }(), this.charRange = function() {
            var e, n;
            for(n = [], e = 0; e < 4; ++e)n.push(t.readInt());
            return n;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, n;
            for(n = [], e = 0; e < 2; e = ++e)n.push(t.readInt());
            return n;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, t;
}(), $e5456e2f96ba3898$var$Ne = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "post", t.prototype.parse = function(t) {
        var e, n, r;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
            case 196608:
                break;
            case 131072:
                var i;
                for(n = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= n ? i < n : i > n; i = 0 <= n ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], r = []; t.pos < this.offset + this.length;)e = t.readByte(), r.push(this.names.push(t.readString(e)));
                return r;
            case 151552:
                return n = t.readUInt16(), this.offsets = t.read(n);
            case 262144:
                return this.map = (function() {
                    var e, n, r;
                    for(r = [], i = e = 0, n = this.file.maxp.numGlyphs; 0 <= n ? e < n : e > n; i = 0 <= n ? ++e : --e)r.push(t.readUInt32());
                    return r;
                }).call(this);
        }
    }, t;
}(), $e5456e2f96ba3898$var$Le = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $e5456e2f96ba3898$var$xe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "name", t.prototype.parse = function(t) {
        var e, n, r, i, a, o, s, u, c, l, h;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), n = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)n.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = c = 0, l = n.length; c < l; i = ++c)r = n[i], t.pos = r.offset, u = t.readString(r.length), a = new $e5456e2f96ba3898$var$Le(u, r), null == s[h = r.nameID] && (s[h] = []), s[r.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (f) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, t;
}(), $e5456e2f96ba3898$var$Ae = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "maxp", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, t;
}(), $e5456e2f96ba3898$var$Se = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "hmtx", t.prototype.parse = function(t) {
        var e, n, r, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var n, i;
            for(i = [], e = n = 0; 0 <= r ? n < r : n > r; e = 0 <= r ? ++n : --n)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, n, r;
            for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
            return r;
        }).call(this), n = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= r ? a < r : a > r; e = 0 <= r ? ++a : --a)s.push(this.widths.push(n));
        return s;
    }, t.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, t;
}(), $e5456e2f96ba3898$var$_e = [].slice, $e5456e2f96ba3898$var$Pe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "glyf", t.prototype.parse = function() {
        return this.cache = {};
    }, t.prototype.glyphFor = function(t) {
        var e, n, r, i, a, o, s, u, c, l;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, a = (o = new $e5456e2f96ba3898$var$fe(e.read(r))).readShort(), u = o.readShort(), l = o.readShort(), s = o.readShort(), c = o.readShort(), this.cache[t] = -1 === a ? new $e5456e2f96ba3898$var$Fe(o, u, l, s, c) : new $e5456e2f96ba3898$var$ke(o, a, u, l, s, c), this.cache[t]));
    }, t.prototype.encode = function(t, e, n) {
        var r, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)r = t[e[o]], i.push(a.length), r && (a = a.concat(r.encode(n)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, t;
}(), $e5456e2f96ba3898$var$ke = function() {
    function t(t, e, n, r, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), $e5456e2f96ba3898$var$Fe = function() {
    function t(t, e, n, r, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, n;
        for(e = new $e5456e2f96ba3898$var$fe($e5456e2f96ba3898$var$_e.call(this.raw.data)), t = 0, n = this.glyphIDs.length; t < n; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), $e5456e2f96ba3898$var$Ie = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $e5456e2f96ba3898$var$ge(t, $e5456e2f96ba3898$var$he), t.prototype.tag = "loca", t.prototype.parse = function(t) {
        var e, n;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 2)r.push(2 * t.readUInt16());
            return r;
        }).call(this) : (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 4)r.push(t.readUInt32());
            return r;
        }).call(this);
    }, t.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, t.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, t.prototype.encode = function(t, e) {
        for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, a = 0; a < n.length; ++a)if (n[a] = r, i < e.length && e[i] == a) {
            ++i, n[a] = r;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (r += s);
        }
        for(var u = new Array(4 * n.length), c = 0; c < n.length; ++c)u[4 * c + 3] = 255 & n[c], u[4 * c + 2] = (65280 & n[c]) >> 8, u[4 * c + 1] = (16711680 & n[c]) >> 16, u[4 * c] = (4278190080 & n[c]) >> 24;
        return u;
    }, t;
}(), $e5456e2f96ba3898$var$je = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, n, r, i;
        for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, n, r, i, a, o, s;
        for(r = {}, a = 0, o = t.length; a < o; a++)r[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
        return r;
    }, t.prototype.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m;
        for(r in n = $e5456e2f96ba3898$var$be.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = n.charMap)f[(s = m[r]).old] = s.new;
        for(d in h = n.maxGlyphID, a)d in f || (f[d] = h++);
        return c = function(t) {
            var e, n;
            for(e in n = {}, t)n[t[e]] = e;
            return n;
        }(f), l = Object.keys(c).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, n;
            for(n = [], t = 0, e = l.length; t < e; t++)o = l[t], n.push(c[o]);
            return n;
        }(), i = this.font.glyf.encode(a, p, f), u = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: u,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
$e5456e2f96ba3898$export$2e2bcd8739ae039.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(n) {
        var r, i, a, o;
        if (Array.isArray(n)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = n.length; t < i; t++)r = n[t], a.push(e.convert(r));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof n) return "/" + n;
        if (null != n ? n.isString : void 0) return "(" + n + ")";
        if (n instanceof Date) return "(D:" + t(n.getUTCFullYear(), 4) + t(n.getUTCMonth(), 2) + t(n.getUTCDate(), 2) + t(n.getUTCHours(), 2) + t(n.getUTCMinutes(), 2) + t(n.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(n)) {
            for(i in a = [
                "<<"
            ], n)o = n[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + n;
    }, e;
}();

});
parcelRegister("alU2v", function(module, exports) {
function $789755c9ec22d0a0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $789755c9ec22d0a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $789755c9ec22d0a0$var$_typeof(o);
}
module.exports = $789755c9ec22d0a0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gCcZP", function(module, exports) {

$parcel$export(module.exports, "zlibSync", function () { return $c18a46ba849e3904$export$f87121a6d50aff25; });
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $c18a46ba849e3904$var$ch2 = {};
var $c18a46ba849e3904$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($c18a46ba849e3904$var$ch2[id] || ($c18a46ba849e3904$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $c18a46ba849e3904$var$u8 = Uint8Array, $c18a46ba849e3904$var$u16 = Uint16Array, $c18a46ba849e3904$var$i32 = Int32Array;
// fixed length extra bits
var $c18a46ba849e3904$var$fleb = new $c18a46ba849e3904$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $c18a46ba849e3904$var$fdeb = new $c18a46ba849e3904$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $c18a46ba849e3904$var$clim = new $c18a46ba849e3904$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $c18a46ba849e3904$var$freb = function(eb, start) {
    var b = new $c18a46ba849e3904$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $c18a46ba849e3904$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $c18a46ba849e3904$var$_a = $c18a46ba849e3904$var$freb($c18a46ba849e3904$var$fleb, 2), $c18a46ba849e3904$var$fl = $c18a46ba849e3904$var$_a.b, $c18a46ba849e3904$var$revfl = $c18a46ba849e3904$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$c18a46ba849e3904$var$fl[28] = 258, $c18a46ba849e3904$var$revfl[258] = 28;
var $c18a46ba849e3904$var$_b = $c18a46ba849e3904$var$freb($c18a46ba849e3904$var$fdeb, 0), $c18a46ba849e3904$var$fd = $c18a46ba849e3904$var$_b.b, $c18a46ba849e3904$var$revfd = $c18a46ba849e3904$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $c18a46ba849e3904$var$rev = new $c18a46ba849e3904$var$u16(32768);
for(var $c18a46ba849e3904$var$i = 0; $c18a46ba849e3904$var$i < 32768; ++$c18a46ba849e3904$var$i){
    // reverse table algorithm from SO
    var $c18a46ba849e3904$var$x = ($c18a46ba849e3904$var$i & 0xAAAA) >> 1 | ($c18a46ba849e3904$var$i & 0x5555) << 1;
    $c18a46ba849e3904$var$x = ($c18a46ba849e3904$var$x & 0xCCCC) >> 2 | ($c18a46ba849e3904$var$x & 0x3333) << 2;
    $c18a46ba849e3904$var$x = ($c18a46ba849e3904$var$x & 0xF0F0) >> 4 | ($c18a46ba849e3904$var$x & 0x0F0F) << 4;
    $c18a46ba849e3904$var$rev[$c18a46ba849e3904$var$i] = (($c18a46ba849e3904$var$x & 0xFF00) >> 8 | ($c18a46ba849e3904$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $c18a46ba849e3904$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $c18a46ba849e3904$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $c18a46ba849e3904$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $c18a46ba849e3904$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$c18a46ba849e3904$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $c18a46ba849e3904$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $c18a46ba849e3904$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $c18a46ba849e3904$var$flt = new $c18a46ba849e3904$var$u8(288);
for(var $c18a46ba849e3904$var$i = 0; $c18a46ba849e3904$var$i < 144; ++$c18a46ba849e3904$var$i)$c18a46ba849e3904$var$flt[$c18a46ba849e3904$var$i] = 8;
for(var $c18a46ba849e3904$var$i = 144; $c18a46ba849e3904$var$i < 256; ++$c18a46ba849e3904$var$i)$c18a46ba849e3904$var$flt[$c18a46ba849e3904$var$i] = 9;
for(var $c18a46ba849e3904$var$i = 256; $c18a46ba849e3904$var$i < 280; ++$c18a46ba849e3904$var$i)$c18a46ba849e3904$var$flt[$c18a46ba849e3904$var$i] = 7;
for(var $c18a46ba849e3904$var$i = 280; $c18a46ba849e3904$var$i < 288; ++$c18a46ba849e3904$var$i)$c18a46ba849e3904$var$flt[$c18a46ba849e3904$var$i] = 8;
// fixed distance tree
var $c18a46ba849e3904$var$fdt = new $c18a46ba849e3904$var$u8(32);
for(var $c18a46ba849e3904$var$i = 0; $c18a46ba849e3904$var$i < 32; ++$c18a46ba849e3904$var$i)$c18a46ba849e3904$var$fdt[$c18a46ba849e3904$var$i] = 5;
// fixed length map
var $c18a46ba849e3904$var$flm = /*#__PURE__*/ $c18a46ba849e3904$var$hMap($c18a46ba849e3904$var$flt, 9, 0), $c18a46ba849e3904$var$flrm = /*#__PURE__*/ $c18a46ba849e3904$var$hMap($c18a46ba849e3904$var$flt, 9, 1);
// fixed distance map
var $c18a46ba849e3904$var$fdm = /*#__PURE__*/ $c18a46ba849e3904$var$hMap($c18a46ba849e3904$var$fdt, 5, 0), $c18a46ba849e3904$var$fdrm = /*#__PURE__*/ $c18a46ba849e3904$var$hMap($c18a46ba849e3904$var$fdt, 5, 1);
// find max of array
var $c18a46ba849e3904$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $c18a46ba849e3904$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $c18a46ba849e3904$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $c18a46ba849e3904$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $c18a46ba849e3904$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $c18a46ba849e3904$var$u8(v.subarray(s, e));
};
var $c18a46ba849e3904$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $c18a46ba849e3904$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $c18a46ba849e3904$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $c18a46ba849e3904$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $c18a46ba849e3904$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $c18a46ba849e3904$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $c18a46ba849e3904$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $c18a46ba849e3904$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $c18a46ba849e3904$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $c18a46ba849e3904$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $c18a46ba849e3904$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $c18a46ba849e3904$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $c18a46ba849e3904$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $c18a46ba849e3904$var$flrm, dm = $c18a46ba849e3904$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $c18a46ba849e3904$var$bits(dat, pos, 31) + 257, hcLen = $c18a46ba849e3904$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $c18a46ba849e3904$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $c18a46ba849e3904$var$u8(tl);
                // code length tree
                var clt = new $c18a46ba849e3904$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$c18a46ba849e3904$var$clim[i]] = $c18a46ba849e3904$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $c18a46ba849e3904$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $c18a46ba849e3904$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$c18a46ba849e3904$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $c18a46ba849e3904$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $c18a46ba849e3904$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $c18a46ba849e3904$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $c18a46ba849e3904$var$max(lt);
                // max dist bits
                dbt = $c18a46ba849e3904$var$max(dt);
                lm = $c18a46ba849e3904$var$hMap(lt, lbt, 1);
                dm = $c18a46ba849e3904$var$hMap(dt, dbt, 1);
            } else $c18a46ba849e3904$var$err(1);
            if (pos > tbts) {
                if (noSt) $c18a46ba849e3904$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$c18a46ba849e3904$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $c18a46ba849e3904$var$err(0);
                break;
            }
            if (!c) $c18a46ba849e3904$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $c18a46ba849e3904$var$fleb[i];
                    add = $c18a46ba849e3904$var$bits(dat, pos, (1 << b) - 1) + $c18a46ba849e3904$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$c18a46ba849e3904$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $c18a46ba849e3904$var$err(3);
                pos += d & 15;
                var dt = $c18a46ba849e3904$var$fd[dsym];
                if (dsym > 3) {
                    var b = $c18a46ba849e3904$var$fdeb[dsym];
                    dt += $c18a46ba849e3904$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $c18a46ba849e3904$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $c18a46ba849e3904$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $c18a46ba849e3904$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $c18a46ba849e3904$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $c18a46ba849e3904$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $c18a46ba849e3904$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $c18a46ba849e3904$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $c18a46ba849e3904$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $c18a46ba849e3904$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $c18a46ba849e3904$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $c18a46ba849e3904$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $c18a46ba849e3904$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($c18a46ba849e3904$var$ln(n.l, l, d + 1), $c18a46ba849e3904$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $c18a46ba849e3904$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $c18a46ba849e3904$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $c18a46ba849e3904$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $c18a46ba849e3904$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $c18a46ba849e3904$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $c18a46ba849e3904$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $c18a46ba849e3904$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $c18a46ba849e3904$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $c18a46ba849e3904$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $c18a46ba849e3904$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $c18a46ba849e3904$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $c18a46ba849e3904$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $c18a46ba849e3904$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$c18a46ba849e3904$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $c18a46ba849e3904$var$clen(lf, $c18a46ba849e3904$var$flt) + $c18a46ba849e3904$var$clen(df, $c18a46ba849e3904$var$fdt) + eb;
    var dtlen = $c18a46ba849e3904$var$clen(lf, dlt) + $c18a46ba849e3904$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $c18a46ba849e3904$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $c18a46ba849e3904$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $c18a46ba849e3904$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $c18a46ba849e3904$var$hMap(dlt, mlb, 0), ll = dlt, dm = $c18a46ba849e3904$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $c18a46ba849e3904$var$hMap(lct, mlcb, 0);
        $c18a46ba849e3904$var$wbits(out, p, nlc - 257);
        $c18a46ba849e3904$var$wbits(out, p + 5, ndc - 1);
        $c18a46ba849e3904$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$c18a46ba849e3904$var$wbits(out, p + 3 * i, lct[$c18a46ba849e3904$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $c18a46ba849e3904$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $c18a46ba849e3904$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $c18a46ba849e3904$var$flm, ll = $c18a46ba849e3904$var$flt, dm = $c18a46ba849e3904$var$fdm, dl = $c18a46ba849e3904$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $c18a46ba849e3904$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $c18a46ba849e3904$var$wbits(out, p, sym >> 23 & 31), p += $c18a46ba849e3904$var$fleb[len];
            var dst = sym & 31;
            $c18a46ba849e3904$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $c18a46ba849e3904$var$wbits16(out, p, sym >> 5 & 8191), p += $c18a46ba849e3904$var$fdeb[dst];
        } else $c18a46ba849e3904$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $c18a46ba849e3904$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $c18a46ba849e3904$var$deo = /*#__PURE__*/ new $c18a46ba849e3904$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $c18a46ba849e3904$var$et = /*#__PURE__*/ new $c18a46ba849e3904$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $c18a46ba849e3904$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $c18a46ba849e3904$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $c18a46ba849e3904$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $c18a46ba849e3904$var$u16(32768), head = st.h || new $c18a46ba849e3904$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $c18a46ba849e3904$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $c18a46ba849e3904$var$u16(288), df = new $c18a46ba849e3904$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $c18a46ba849e3904$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $c18a46ba849e3904$var$revfl[l] << 18 | $c18a46ba849e3904$var$revfd[d];
                    var lin = $c18a46ba849e3904$var$revfl[l] & 31, din = $c18a46ba849e3904$var$revfd[d] & 31;
                    eb += $c18a46ba849e3904$var$fleb[lin] + $c18a46ba849e3904$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $c18a46ba849e3904$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $c18a46ba849e3904$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $c18a46ba849e3904$var$slc(o, 0, pre + $c18a46ba849e3904$var$shft(pos) + post);
};
// CRC32 table
var $c18a46ba849e3904$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $c18a46ba849e3904$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $c18a46ba849e3904$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $c18a46ba849e3904$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $c18a46ba849e3904$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $c18a46ba849e3904$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $c18a46ba849e3904$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $c18a46ba849e3904$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $c18a46ba849e3904$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $c18a46ba849e3904$var$ch = [];
// clone bufs
var $c18a46ba849e3904$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $c18a46ba849e3904$var$wrkr = function(fns, init, id, cb) {
    if (!$c18a46ba849e3904$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $c18a46ba849e3904$var$wcln(fns[i], fnStr, td_1);
        $c18a46ba849e3904$var$ch[id] = {
            c: $c18a46ba849e3904$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $c18a46ba849e3904$var$mrg({}, $c18a46ba849e3904$var$ch[id].e);
    return $c18a46ba849e3904$var$wk($c18a46ba849e3904$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $c18a46ba849e3904$var$cbfs(td), cb);
};
// base async inflate fn
var $c18a46ba849e3904$var$bInflt = function() {
    return [
        $c18a46ba849e3904$var$u8,
        $c18a46ba849e3904$var$u16,
        $c18a46ba849e3904$var$i32,
        $c18a46ba849e3904$var$fleb,
        $c18a46ba849e3904$var$fdeb,
        $c18a46ba849e3904$var$clim,
        $c18a46ba849e3904$var$fl,
        $c18a46ba849e3904$var$fd,
        $c18a46ba849e3904$var$flrm,
        $c18a46ba849e3904$var$fdrm,
        $c18a46ba849e3904$var$rev,
        $c18a46ba849e3904$var$ec,
        $c18a46ba849e3904$var$hMap,
        $c18a46ba849e3904$var$max,
        $c18a46ba849e3904$var$bits,
        $c18a46ba849e3904$var$bits16,
        $c18a46ba849e3904$var$shft,
        $c18a46ba849e3904$var$slc,
        $c18a46ba849e3904$var$err,
        $c18a46ba849e3904$var$inflt,
        $c18a46ba849e3904$export$90366d8b308ba94a,
        $c18a46ba849e3904$var$pbf,
        $c18a46ba849e3904$var$gopt
    ];
};
var $c18a46ba849e3904$var$bDflt = function() {
    return [
        $c18a46ba849e3904$var$u8,
        $c18a46ba849e3904$var$u16,
        $c18a46ba849e3904$var$i32,
        $c18a46ba849e3904$var$fleb,
        $c18a46ba849e3904$var$fdeb,
        $c18a46ba849e3904$var$clim,
        $c18a46ba849e3904$var$revfl,
        $c18a46ba849e3904$var$revfd,
        $c18a46ba849e3904$var$flm,
        $c18a46ba849e3904$var$flt,
        $c18a46ba849e3904$var$fdm,
        $c18a46ba849e3904$var$fdt,
        $c18a46ba849e3904$var$rev,
        $c18a46ba849e3904$var$deo,
        $c18a46ba849e3904$var$et,
        $c18a46ba849e3904$var$hMap,
        $c18a46ba849e3904$var$wbits,
        $c18a46ba849e3904$var$wbits16,
        $c18a46ba849e3904$var$hTree,
        $c18a46ba849e3904$var$ln,
        $c18a46ba849e3904$var$lc,
        $c18a46ba849e3904$var$clen,
        $c18a46ba849e3904$var$wfblk,
        $c18a46ba849e3904$var$wblk,
        $c18a46ba849e3904$var$shft,
        $c18a46ba849e3904$var$slc,
        $c18a46ba849e3904$var$dflt,
        $c18a46ba849e3904$var$dopt,
        $c18a46ba849e3904$export$21533ff51b8a0b4a,
        $c18a46ba849e3904$var$pbf
    ];
};
// gzip extra
var $c18a46ba849e3904$var$gze = function() {
    return [
        $c18a46ba849e3904$var$gzh,
        $c18a46ba849e3904$var$gzhl,
        $c18a46ba849e3904$var$wbytes,
        $c18a46ba849e3904$var$crc,
        $c18a46ba849e3904$var$crct
    ];
};
// gunzip extra
var $c18a46ba849e3904$var$guze = function() {
    return [
        $c18a46ba849e3904$var$gzs,
        $c18a46ba849e3904$var$gzl
    ];
};
// zlib extra
var $c18a46ba849e3904$var$zle = function() {
    return [
        $c18a46ba849e3904$var$zlh,
        $c18a46ba849e3904$var$wbytes,
        $c18a46ba849e3904$var$adler
    ];
};
// unzlib extra
var $c18a46ba849e3904$var$zule = function() {
    return [
        $c18a46ba849e3904$var$zls
    ];
};
// post buf
var $c18a46ba849e3904$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $c18a46ba849e3904$var$gopt = function(o) {
    return o && {
        out: o.size && new $c18a46ba849e3904$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $c18a46ba849e3904$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $c18a46ba849e3904$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $c18a46ba849e3904$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $c18a46ba849e3904$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $c18a46ba849e3904$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $c18a46ba849e3904$var$err(5);
        if (t) strm.ondata($c18a46ba849e3904$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $c18a46ba849e3904$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $c18a46ba849e3904$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $c18a46ba849e3904$var$b8 = function(d, b) {
    return $c18a46ba849e3904$var$b4(d, b) + $c18a46ba849e3904$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $c18a46ba849e3904$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $c18a46ba849e3904$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $c18a46ba849e3904$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $c18a46ba849e3904$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $c18a46ba849e3904$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $c18a46ba849e3904$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $c18a46ba849e3904$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $c18a46ba849e3904$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $c18a46ba849e3904$var$adler();
        h.p(o.dictionary);
        $c18a46ba849e3904$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $c18a46ba849e3904$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $c18a46ba849e3904$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $c18a46ba849e3904$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $c18a46ba849e3904$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $c18a46ba849e3904$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $c18a46ba849e3904$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($c18a46ba849e3904$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        if (this.s.l) $c18a46ba849e3904$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $c18a46ba849e3904$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        if (this.s.l) $c18a46ba849e3904$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $c18a46ba849e3904$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $c18a46ba849e3904$var$astrmify([
            $c18a46ba849e3904$var$bDflt,
            function() {
                return [
                    $c18a46ba849e3904$var$astrm,
                    $c18a46ba849e3904$export$ae157b6234afe138
                ];
            }
        ], this, $c18a46ba849e3904$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $c18a46ba849e3904$export$ae157b6234afe138(ev.data);
            onmessage = $c18a46ba849e3904$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $c18a46ba849e3904$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    return $c18a46ba849e3904$var$cbify(data, opts, [
        $c18a46ba849e3904$var$bDflt
    ], function(ev) {
        return $c18a46ba849e3904$var$pbf($c18a46ba849e3904$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $c18a46ba849e3904$export$21533ff51b8a0b4a(data, opts) {
    return $c18a46ba849e3904$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $c18a46ba849e3904$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $c18a46ba849e3904$var$u8(32768);
        this.p = new $c18a46ba849e3904$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        if (this.d) $c18a46ba849e3904$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $c18a46ba849e3904$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $c18a46ba849e3904$var$inflt(this.p, this.s, this.o);
        this.ondata($c18a46ba849e3904$var$slc(dt, bts, this.s.b), this.d);
        this.o = $c18a46ba849e3904$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $c18a46ba849e3904$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $c18a46ba849e3904$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $c18a46ba849e3904$var$astrmify([
            $c18a46ba849e3904$var$bInflt,
            function() {
                return [
                    $c18a46ba849e3904$var$astrm,
                    $c18a46ba849e3904$export$d1de70a877d6e43c
                ];
            }
        ], this, $c18a46ba849e3904$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $c18a46ba849e3904$export$d1de70a877d6e43c(ev.data);
            onmessage = $c18a46ba849e3904$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $c18a46ba849e3904$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    return $c18a46ba849e3904$var$cbify(data, opts, [
        $c18a46ba849e3904$var$bInflt
    ], function(ev) {
        return $c18a46ba849e3904$var$pbf($c18a46ba849e3904$export$90366d8b308ba94a(ev.data[0], $c18a46ba849e3904$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $c18a46ba849e3904$export$90366d8b308ba94a(data, opts) {
    return $c18a46ba849e3904$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $c18a46ba849e3904$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $c18a46ba849e3904$var$crc();
        this.l = 0;
        this.v = 1;
        $c18a46ba849e3904$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $c18a46ba849e3904$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $c18a46ba849e3904$var$dopt(c, this.o, this.v && $c18a46ba849e3904$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $c18a46ba849e3904$var$gzh(raw, this.o), this.v = 0;
        if (f) $c18a46ba849e3904$var$wbytes(raw, raw.length - 8, this.c.d()), $c18a46ba849e3904$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $c18a46ba849e3904$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $c18a46ba849e3904$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $c18a46ba849e3904$var$astrmify([
            $c18a46ba849e3904$var$bDflt,
            $c18a46ba849e3904$var$gze,
            function() {
                return [
                    $c18a46ba849e3904$var$astrm,
                    $c18a46ba849e3904$export$ae157b6234afe138,
                    $c18a46ba849e3904$export$8e4b66d280bf8342
                ];
            }
        ], this, $c18a46ba849e3904$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $c18a46ba849e3904$export$8e4b66d280bf8342(ev.data);
            onmessage = $c18a46ba849e3904$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $c18a46ba849e3904$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    return $c18a46ba849e3904$var$cbify(data, opts, [
        $c18a46ba849e3904$var$bDflt,
        $c18a46ba849e3904$var$gze,
        function() {
            return [
                $c18a46ba849e3904$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $c18a46ba849e3904$var$pbf($c18a46ba849e3904$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $c18a46ba849e3904$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $c18a46ba849e3904$var$crc(), l = data.length;
    c.p(data);
    var d = $c18a46ba849e3904$var$dopt(data, opts, $c18a46ba849e3904$var$gzhl(opts), 8), s = d.length;
    return $c18a46ba849e3904$var$gzh(d, opts), $c18a46ba849e3904$var$wbytes(d, s - 8, c.d()), $c18a46ba849e3904$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $c18a46ba849e3904$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $c18a46ba849e3904$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $c18a46ba849e3904$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $c18a46ba849e3904$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $c18a46ba849e3904$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $c18a46ba849e3904$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $c18a46ba849e3904$var$u8(0);
            this.push(new $c18a46ba849e3904$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $c18a46ba849e3904$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $c18a46ba849e3904$var$astrmify([
            $c18a46ba849e3904$var$bInflt,
            $c18a46ba849e3904$var$guze,
            function() {
                return [
                    $c18a46ba849e3904$var$astrm,
                    $c18a46ba849e3904$export$d1de70a877d6e43c,
                    $c18a46ba849e3904$export$4cb607de6db70415
                ];
            }
        ], this, $c18a46ba849e3904$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $c18a46ba849e3904$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $c18a46ba849e3904$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $c18a46ba849e3904$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    return $c18a46ba849e3904$var$cbify(data, opts, [
        $c18a46ba849e3904$var$bInflt,
        $c18a46ba849e3904$var$guze,
        function() {
            return [
                $c18a46ba849e3904$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $c18a46ba849e3904$var$pbf($c18a46ba849e3904$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $c18a46ba849e3904$export$c80456f7aaba691c(data, opts) {
    var st = $c18a46ba849e3904$var$gzs(data);
    if (st + 8 > data.length) $c18a46ba849e3904$var$err(6, 'invalid gzip data');
    return $c18a46ba849e3904$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $c18a46ba849e3904$var$u8($c18a46ba849e3904$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $c18a46ba849e3904$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $c18a46ba849e3904$var$adler();
        this.v = 1;
        $c18a46ba849e3904$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $c18a46ba849e3904$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $c18a46ba849e3904$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $c18a46ba849e3904$var$zlh(raw, this.o), this.v = 0;
        if (f) $c18a46ba849e3904$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $c18a46ba849e3904$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $c18a46ba849e3904$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $c18a46ba849e3904$var$astrmify([
            $c18a46ba849e3904$var$bDflt,
            $c18a46ba849e3904$var$zle,
            function() {
                return [
                    $c18a46ba849e3904$var$astrm,
                    $c18a46ba849e3904$export$ae157b6234afe138,
                    $c18a46ba849e3904$export$4187ccf2467013b9
                ];
            }
        ], this, $c18a46ba849e3904$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $c18a46ba849e3904$export$4187ccf2467013b9(ev.data);
            onmessage = $c18a46ba849e3904$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $c18a46ba849e3904$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    return $c18a46ba849e3904$var$cbify(data, opts, [
        $c18a46ba849e3904$var$bDflt,
        $c18a46ba849e3904$var$zle,
        function() {
            return [
                $c18a46ba849e3904$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $c18a46ba849e3904$var$pbf($c18a46ba849e3904$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $c18a46ba849e3904$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $c18a46ba849e3904$var$adler();
    a.p(data);
    var d = $c18a46ba849e3904$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $c18a46ba849e3904$var$zlh(d, opts), $c18a46ba849e3904$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $c18a46ba849e3904$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $c18a46ba849e3904$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $c18a46ba849e3904$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($c18a46ba849e3904$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $c18a46ba849e3904$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $c18a46ba849e3904$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $c18a46ba849e3904$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $c18a46ba849e3904$var$astrmify([
            $c18a46ba849e3904$var$bInflt,
            $c18a46ba849e3904$var$zule,
            function() {
                return [
                    $c18a46ba849e3904$var$astrm,
                    $c18a46ba849e3904$export$d1de70a877d6e43c,
                    $c18a46ba849e3904$export$af2424f875ff1b17
                ];
            }
        ], this, $c18a46ba849e3904$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $c18a46ba849e3904$export$af2424f875ff1b17(ev.data);
            onmessage = $c18a46ba849e3904$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $c18a46ba849e3904$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    return $c18a46ba849e3904$var$cbify(data, opts, [
        $c18a46ba849e3904$var$bInflt,
        $c18a46ba849e3904$var$zule,
        function() {
            return [
                $c18a46ba849e3904$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $c18a46ba849e3904$var$pbf($c18a46ba849e3904$export$9ec8134f0f1b9fc6(ev.data[0], $c18a46ba849e3904$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $c18a46ba849e3904$export$9ec8134f0f1b9fc6(data, opts) {
    return $c18a46ba849e3904$var$inflt(data.subarray($c18a46ba849e3904$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $c18a46ba849e3904$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $c18a46ba849e3904$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $c18a46ba849e3904$export$4cb607de6db70415;
        this.I = $c18a46ba849e3904$export$d1de70a877d6e43c;
        this.Z = $c18a46ba849e3904$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $c18a46ba849e3904$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $c18a46ba849e3904$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $c18a46ba849e3904$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $c18a46ba849e3904$export$d5adcdd968132151;
        this.I = $c18a46ba849e3904$export$fff8358d6dbaa9cc;
        this.Z = $c18a46ba849e3904$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $c18a46ba849e3904$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $c18a46ba849e3904$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $c18a46ba849e3904$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $c18a46ba849e3904$export$cae1ce83fe4a1782(data, opts, cb) : $c18a46ba849e3904$export$ca7cbb494e731274(data, opts, cb);
}
function $c18a46ba849e3904$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $c18a46ba849e3904$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $c18a46ba849e3904$export$90366d8b308ba94a(data, opts) : $c18a46ba849e3904$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $c18a46ba849e3904$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $c18a46ba849e3904$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $c18a46ba849e3904$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $c18a46ba849e3904$var$u8(0),
                op
            ];
            $c18a46ba849e3904$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $c18a46ba849e3904$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $c18a46ba849e3904$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $c18a46ba849e3904$var$tds = 0;
try {
    $c18a46ba849e3904$var$td.decode($c18a46ba849e3904$var$et, {
        stream: true
    });
    $c18a46ba849e3904$var$tds = 1;
} catch (e) {}
// decode UTF8
var $c18a46ba849e3904$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $c18a46ba849e3904$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $c18a46ba849e3904$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($c18a46ba849e3904$var$tds) this.t = new TextDecoder();
        else this.p = $c18a46ba849e3904$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $c18a46ba849e3904$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $c18a46ba849e3904$var$err(4);
        var dat = new $c18a46ba849e3904$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $c18a46ba849e3904$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $c18a46ba849e3904$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $c18a46ba849e3904$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        if (this.d) $c18a46ba849e3904$var$err(4);
        this.ondata($c18a46ba849e3904$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $c18a46ba849e3904$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $c18a46ba849e3904$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($c18a46ba849e3904$var$te) return $c18a46ba849e3904$var$te.encode(str);
    var l = str.length;
    var ar = new $c18a46ba849e3904$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $c18a46ba849e3904$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $c18a46ba849e3904$var$slc(ar, 0, ai);
}
function $c18a46ba849e3904$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($c18a46ba849e3904$var$td) return $c18a46ba849e3904$var$td.decode(dat);
    else {
        var _a = $c18a46ba849e3904$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $c18a46ba849e3904$var$err(8);
        return s;
    }
}
// deflate bit flag
var $c18a46ba849e3904$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $c18a46ba849e3904$var$slzh = function(d, b) {
    return b + 30 + $c18a46ba849e3904$var$b2(d, b + 26) + $c18a46ba849e3904$var$b2(d, b + 28);
};
// read zip header
var $c18a46ba849e3904$var$zh = function(d, b, z) {
    var fnl = $c18a46ba849e3904$var$b2(d, b + 28), fn = $c18a46ba849e3904$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($c18a46ba849e3904$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $c18a46ba849e3904$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $c18a46ba849e3904$var$z64e(d, es) : [
        bs,
        $c18a46ba849e3904$var$b4(d, b + 24),
        $c18a46ba849e3904$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $c18a46ba849e3904$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $c18a46ba849e3904$var$b2(d, b + 30) + $c18a46ba849e3904$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $c18a46ba849e3904$var$z64e = function(d, b) {
    for(; $c18a46ba849e3904$var$b2(d, b) != 1; b += 4 + $c18a46ba849e3904$var$b2(d, b + 2));
    return [
        $c18a46ba849e3904$var$b8(d, b + 12),
        $c18a46ba849e3904$var$b8(d, b + 4),
        $c18a46ba849e3904$var$b8(d, b + 20)
    ];
};
// extra field length
var $c18a46ba849e3904$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $c18a46ba849e3904$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $c18a46ba849e3904$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $c18a46ba849e3904$var$exfl(ex);
    $c18a46ba849e3904$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $c18a46ba849e3904$var$err(10);
    $c18a46ba849e3904$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $c18a46ba849e3904$var$wbytes(d, b, f.crc);
        $c18a46ba849e3904$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $c18a46ba849e3904$var$wbytes(d, b + 8, f.size);
    }
    $c18a46ba849e3904$var$wbytes(d, b + 12, fl);
    $c18a46ba849e3904$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $c18a46ba849e3904$var$wbytes(d, b, col);
        $c18a46ba849e3904$var$wbytes(d, b + 6, f.attrs);
        $c18a46ba849e3904$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $c18a46ba849e3904$var$wbytes(d, b, +k);
        $c18a46ba849e3904$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $c18a46ba849e3904$var$wzf = function(o, b, c, d, e) {
    $c18a46ba849e3904$var$wbytes(o, b, 0x6054B50); // skip disk
    $c18a46ba849e3904$var$wbytes(o, b + 8, c);
    $c18a46ba849e3904$var$wbytes(o, b + 10, c);
    $c18a46ba849e3904$var$wbytes(o, b + 12, d);
    $c18a46ba849e3904$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $c18a46ba849e3904$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $c18a46ba849e3904$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $c18a46ba849e3904$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $c18a46ba849e3904$export$2b25194e1767ea06.call(this, filename);
        this.d = new $c18a46ba849e3904$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $c18a46ba849e3904$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $c18a46ba849e3904$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $c18a46ba849e3904$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $c18a46ba849e3904$export$2b25194e1767ea06.call(this, filename);
        this.d = new $c18a46ba849e3904$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $c18a46ba849e3904$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $c18a46ba849e3904$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $c18a46ba849e3904$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $c18a46ba849e3904$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($c18a46ba849e3904$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $c18a46ba849e3904$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $c18a46ba849e3904$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $c18a46ba849e3904$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($c18a46ba849e3904$var$err(11, 0, 1), null, false);
            var header = new $c18a46ba849e3904$var$u8(hl_1);
            $c18a46ba849e3904$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $c18a46ba849e3904$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $c18a46ba849e3904$var$u8(16);
                        $c18a46ba849e3904$var$wbytes(dd, 0, 0x8074B50);
                        $c18a46ba849e3904$var$wbytes(dd, 4, file.crc);
                        $c18a46ba849e3904$var$wbytes(dd, 8, cl_1);
                        $c18a46ba849e3904$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($c18a46ba849e3904$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $c18a46ba849e3904$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $c18a46ba849e3904$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $c18a46ba849e3904$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $c18a46ba849e3904$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $c18a46ba849e3904$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $c18a46ba849e3904$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    var r = {};
    $c18a46ba849e3904$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $c18a46ba849e3904$var$mt(function() {
            cb(a, b);
        });
    };
    $c18a46ba849e3904$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $c18a46ba849e3904$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $c18a46ba849e3904$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $c18a46ba849e3904$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $c18a46ba849e3904$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $c18a46ba849e3904$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $c18a46ba849e3904$var$crc(), size = file.length;
        c.p(file);
        var f = $c18a46ba849e3904$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $c18a46ba849e3904$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $c18a46ba849e3904$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $c18a46ba849e3904$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($c18a46ba849e3904$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $c18a46ba849e3904$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($c18a46ba849e3904$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $c18a46ba849e3904$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $c18a46ba849e3904$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $c18a46ba849e3904$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $c18a46ba849e3904$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $c18a46ba849e3904$var$exfl(p.extra);
        if (s > 65535) $c18a46ba849e3904$var$err(11);
        var d = compression ? $c18a46ba849e3904$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $c18a46ba849e3904$var$crc();
        c.p(file);
        files.push($c18a46ba849e3904$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $c18a46ba849e3904$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $c18a46ba849e3904$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $c18a46ba849e3904$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $c18a46ba849e3904$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $c18a46ba849e3904$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $c18a46ba849e3904$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $c18a46ba849e3904$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $c18a46ba849e3904$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $c18a46ba849e3904$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $c18a46ba849e3904$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $c18a46ba849e3904$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $c18a46ba849e3904$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $c18a46ba849e3904$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $c18a46ba849e3904$export$93f81d5bbbb7c6bf
        };
        this.p = $c18a46ba849e3904$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $c18a46ba849e3904$var$err(5);
        if (!this.p) $c18a46ba849e3904$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $c18a46ba849e3904$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $c18a46ba849e3904$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $c18a46ba849e3904$var$b2(buf, i + 6), cmp_1 = $c18a46ba849e3904$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $c18a46ba849e3904$var$b2(buf, i + 26), es = $c18a46ba849e3904$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $c18a46ba849e3904$var$b4(buf, i + 18), su_1 = $c18a46ba849e3904$var$b4(buf, i + 22);
                        var fn_1 = $c18a46ba849e3904$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $c18a46ba849e3904$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $c18a46ba849e3904$var$err(5);
                                if (!sc_1) file_1.ondata(null, $c18a46ba849e3904$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($c18a46ba849e3904$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($c18a46ba849e3904$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $c18a46ba849e3904$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($c18a46ba849e3904$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $c18a46ba849e3904$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $c18a46ba849e3904$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $c18a46ba849e3904$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $c18a46ba849e3904$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $c18a46ba849e3904$var$mt(function() {
            cb(a, b);
        });
    };
    $c18a46ba849e3904$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $c18a46ba849e3904$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($c18a46ba849e3904$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $c18a46ba849e3904$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $c18a46ba849e3904$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $c18a46ba849e3904$var$b4(data, e - 12);
            z = $c18a46ba849e3904$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $c18a46ba849e3904$var$b4(data, ze + 32);
                o = $c18a46ba849e3904$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $c18a46ba849e3904$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $c18a46ba849e3904$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $c18a46ba849e3904$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $c18a46ba849e3904$export$90366d8b308ba94a(infl, {
                            out: new $c18a46ba849e3904$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($c18a46ba849e3904$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($c18a46ba849e3904$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $c18a46ba849e3904$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $c18a46ba849e3904$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $c18a46ba849e3904$var$err(13);
    var c = $c18a46ba849e3904$var$b2(data, e + 8);
    if (!c) return {};
    var o = $c18a46ba849e3904$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $c18a46ba849e3904$var$b4(data, e - 12);
        z = $c18a46ba849e3904$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $c18a46ba849e3904$var$b4(data, ze + 32);
            o = $c18a46ba849e3904$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $c18a46ba849e3904$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $c18a46ba849e3904$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $c18a46ba849e3904$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $c18a46ba849e3904$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $c18a46ba849e3904$var$u8(su)
            });
            else $c18a46ba849e3904$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

});

parcelRegister("dgEZh", function(module, exports) {

var $2hCjH = parcelRequire("2hCjH");

var $aFbO1 = parcelRequire("aFbO1");

var $jeQwo = parcelRequire("jeQwo");

var $ipITt = parcelRequire("ipITt");
function $9a8c9034ce375439$var$_slicedToArray(r, e) {
    return $2hCjH(r) || $aFbO1(r, e) || $jeQwo(r, e) || $ipITt();
}
module.exports = $9a8c9034ce375439$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2hCjH", function(module, exports) {
function $1a9ae4350b1c02b5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $1a9ae4350b1c02b5$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aFbO1", function(module, exports) {
function $7c36e4193e0e9f4d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $7c36e4193e0e9f4d$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jeQwo", function(module, exports) {

var $csTkU = parcelRequire("csTkU");
function $e01810c7d7623954$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $csTkU(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $csTkU(r, a) : void 0;
    }
}
module.exports = $e01810c7d7623954$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("csTkU", function(module, exports) {
function $9133062e2e805f9a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $9133062e2e805f9a$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ipITt", function(module, exports) {
function $d67d62c2588881dd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $d67d62c2588881dd$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jyQYM", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $e3da49e677a17e5f$export$2f872c0f2117be69; });

var $jhU3k = parcelRequire("jhU3k");

var $fU0Bj = parcelRequire("fU0Bj");

var $7Gf4Z = parcelRequire("7Gf4Z");
parcelRequire("q07ZQ");

var $4IoKO = parcelRequire("4IoKO");
function $e3da49e677a17e5f$export$2f872c0f2117be69(data, options) {
    const decoder = new (0, $jhU3k.default)(data, options);
    return decoder.decode();
}
function $e3da49e677a17e5f$export$c564cdbbe6da493(png, options) {
    const encoder = new (0, $fU0Bj.default)(png, options);
    return encoder.encode();
}
function $e3da49e677a17e5f$export$2a608823614fb725(data, options) {
    const decoder = new (0, $jhU3k.default)(data, options);
    return decoder.decodeApng();
}

});
parcelRegister("jhU3k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0ab15bcb7686c8b$export$2e2bcd8739ae039; });

var $jycrM = parcelRequire("jycrM");

var $3rlLc = parcelRequire("3rlLc");

var $dLMW8 = parcelRequire("dLMW8");

var $k8R1z = parcelRequire("k8R1z");

var $kpTCe = parcelRequire("kpTCe");

var $7Gf4Z = parcelRequire("7Gf4Z");

var $8jcMv = parcelRequire("8jcMv");

var $6eaCd = parcelRequire("6eaCd");
class $e0ab15bcb7686c8b$export$2e2bcd8739ae039 extends (0, $jycrM.IOBuffer) {
    _checkCrc;
    _inflator;
    _png;
    _apng;
    _end;
    _hasPalette;
    _palette;
    _hasTransparency;
    _transparency;
    _compressionMethod;
    _filterMethod;
    _interlaceMethod;
    _colorType;
    _isAnimated;
    _numberOfFrames;
    _numberOfPlays;
    _frames;
    _writingDataChunks;
    constructor(data, options = {}){
        super(data);
        const { checkCrc: checkCrc = false } = options;
        this._checkCrc = checkCrc;
        this._inflator = new (0, $3rlLc.Inflate)();
        this._png = {
            width: -1,
            height: -1,
            channels: -1,
            data: new Uint8Array(0),
            depth: 1,
            text: {}
        };
        this._apng = {
            width: -1,
            height: -1,
            channels: -1,
            depth: 1,
            numberOfFrames: 1,
            numberOfPlays: 0,
            text: {},
            frames: []
        };
        this._end = false;
        this._hasPalette = false;
        this._palette = [];
        this._hasTransparency = false;
        this._transparency = new Uint16Array(0);
        this._compressionMethod = (0, $6eaCd.CompressionMethod).UNKNOWN;
        this._filterMethod = (0, $6eaCd.FilterMethod).UNKNOWN;
        this._interlaceMethod = (0, $6eaCd.InterlaceMethod).UNKNOWN;
        this._colorType = (0, $6eaCd.ColorType).UNKNOWN;
        this._isAnimated = false;
        this._numberOfFrames = 1;
        this._numberOfPlays = 0;
        this._frames = [];
        this._writingDataChunks = false;
        // PNG is always big endian
        // https://www.w3.org/TR/PNG/#7Integers-and-byte-order
        this.setBigEndian();
    }
    decode() {
        (0, $7Gf4Z.checkSignature)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeChunk(length, type);
        }
        this.decodeImage();
        return this._png;
    }
    decodeApng() {
        (0, $7Gf4Z.checkSignature)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeApngChunk(length, type);
        }
        this.decodeApngImage();
        return this._apng;
    }
    // https://www.w3.org/TR/PNG/#5Chunk-layout
    decodeChunk(length, type) {
        const offset = this.offset;
        switch(type){
            // 11.2 Critical chunks
            case 'IHDR':
                this.decodeIHDR();
                break;
            case 'PLTE':
                this.decodePLTE(length);
                break;
            case 'IDAT':
                this.decodeIDAT(length);
                break;
            case 'IEND':
                this._end = true;
                break;
            // 11.3 Ancillary chunks
            case 'tRNS':
                this.decodetRNS(length);
                break;
            case 'iCCP':
                this.decodeiCCP(length);
                break;
            case 0, $8jcMv.textChunkName:
                (0, $8jcMv.decodetEXt)(this._png.text, this, length);
                break;
            case 'pHYs':
                this.decodepHYs();
                break;
            default:
                this.skip(length);
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, $dLMW8.checkCrc)(this, length + 4, type);
        else this.skip(4);
    }
    decodeApngChunk(length, type) {
        const offset = this.offset;
        if (type !== 'fdAT' && type !== 'IDAT' && this._writingDataChunks) this.pushDataToFrame();
        switch(type){
            case 'acTL':
                this.decodeACTL();
                break;
            case 'fcTL':
                this.decodeFCTL();
                break;
            case 'fdAT':
                this.decodeFDAT(length);
                break;
            default:
                this.decodeChunk(length, type);
                this.offset = offset + length;
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, $dLMW8.checkCrc)(this, length + 4, type);
        else this.skip(4);
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    decodeIHDR() {
        const image = this._png;
        image.width = this.readUint32();
        image.height = this.readUint32();
        image.depth = $e0ab15bcb7686c8b$var$checkBitDepth(this.readUint8());
        const colorType = this.readUint8();
        this._colorType = colorType;
        let channels;
        switch(colorType){
            case (0, $6eaCd.ColorType).GREYSCALE:
                channels = 1;
                break;
            case (0, $6eaCd.ColorType).TRUECOLOUR:
                channels = 3;
                break;
            case (0, $6eaCd.ColorType).INDEXED_COLOUR:
                channels = 1;
                break;
            case (0, $6eaCd.ColorType).GREYSCALE_ALPHA:
                channels = 2;
                break;
            case (0, $6eaCd.ColorType).TRUECOLOUR_ALPHA:
                channels = 4;
                break;
            // Kept for exhaustiveness.
            // eslint-disable-next-line unicorn/no-useless-switch-case
            case (0, $6eaCd.ColorType).UNKNOWN:
            default:
                throw new Error(`Unknown color type: ${colorType}`);
        }
        this._png.channels = channels;
        this._compressionMethod = this.readUint8();
        if (this._compressionMethod !== (0, $6eaCd.CompressionMethod).DEFLATE) throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
        this._filterMethod = this.readUint8();
        this._interlaceMethod = this.readUint8();
    }
    decodeACTL() {
        this._numberOfFrames = this.readUint32();
        this._numberOfPlays = this.readUint32();
        this._isAnimated = true;
    }
    decodeFCTL() {
        const image = {
            sequenceNumber: this.readUint32(),
            width: this.readUint32(),
            height: this.readUint32(),
            xOffset: this.readUint32(),
            yOffset: this.readUint32(),
            delayNumber: this.readUint16(),
            delayDenominator: this.readUint16(),
            disposeOp: this.readUint8(),
            blendOp: this.readUint8(),
            data: new Uint8Array(0)
        };
        this._frames.push(image);
    }
    // https://www.w3.org/TR/PNG/#11PLTE
    decodePLTE(length) {
        if (length % 3 !== 0) throw new RangeError(`PLTE field length must be a multiple of 3. Got ${length}`);
        const l = length / 3;
        this._hasPalette = true;
        const palette = [];
        this._palette = palette;
        for(let i = 0; i < l; i++)palette.push([
            this.readUint8(),
            this.readUint8(),
            this.readUint8()
        ]);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    decodeIDAT(length) {
        this._writingDataChunks = true;
        const dataLength = length;
        const dataOffset = this.offset + this.byteOffset;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    decodeFDAT(length) {
        this._writingDataChunks = true;
        let dataLength = length;
        let dataOffset = this.offset + this.byteOffset;
        dataOffset += 4;
        dataLength -= 4;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    // https://www.w3.org/TR/PNG/#11tRNS
    decodetRNS(length) {
        switch(this._colorType){
            case (0, $6eaCd.ColorType).GREYSCALE:
            case (0, $6eaCd.ColorType).TRUECOLOUR:
                if (length % 2 !== 0) throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${length}`);
                if (length / 2 > this._png.width * this._png.height) throw new Error(`tRNS chunk contains more alpha values than there are pixels (${length / 2} vs ${this._png.width * this._png.height})`);
                this._hasTransparency = true;
                this._transparency = new Uint16Array(length / 2);
                for(let i = 0; i < length / 2; i++)this._transparency[i] = this.readUint16();
                break;
            case (0, $6eaCd.ColorType).INDEXED_COLOUR:
                {
                    if (length > this._palette.length) throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${length} vs ${this._palette.length})`);
                    let i = 0;
                    for(; i < length; i++){
                        const alpha = this.readByte();
                        this._palette[i].push(alpha);
                    }
                    for(; i < this._palette.length; i++)this._palette[i].push(255);
                    break;
                }
            // Kept for exhaustiveness.
            /* eslint-disable unicorn/no-useless-switch-case */ case (0, $6eaCd.ColorType).UNKNOWN:
            case (0, $6eaCd.ColorType).GREYSCALE_ALPHA:
            case (0, $6eaCd.ColorType).TRUECOLOUR_ALPHA:
            default:
                throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
        }
    }
    // https://www.w3.org/TR/PNG/#11iCCP
    decodeiCCP(length) {
        const name = (0, $8jcMv.readKeyword)(this);
        const compressionMethod = this.readUint8();
        if (compressionMethod !== (0, $6eaCd.CompressionMethod).DEFLATE) throw new Error(`Unsupported iCCP compression method: ${compressionMethod}`);
        const compressedProfile = this.readBytes(length - name.length - 2);
        this._png.iccEmbeddedProfile = {
            name: name,
            profile: (0, $3rlLc.inflate)(compressedProfile)
        };
    }
    // https://www.w3.org/TR/PNG/#11pHYs
    decodepHYs() {
        const ppuX = this.readUint32();
        const ppuY = this.readUint32();
        const unitSpecifier = this.readByte();
        this._png.resolution = {
            x: ppuX,
            y: ppuY,
            unit: unitSpecifier
        };
    }
    decodeApngImage() {
        this._apng.width = this._png.width;
        this._apng.height = this._png.height;
        this._apng.channels = this._png.channels;
        this._apng.depth = this._png.depth;
        this._apng.numberOfFrames = this._numberOfFrames;
        this._apng.numberOfPlays = this._numberOfPlays;
        this._apng.text = this._png.text;
        this._apng.resolution = this._png.resolution;
        for(let i = 0; i < this._numberOfFrames; i++){
            const newFrame = {
                sequenceNumber: this._frames[i].sequenceNumber,
                delayNumber: this._frames[i].delayNumber,
                delayDenominator: this._frames[i].delayDenominator,
                data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
            };
            const frame = this._frames.at(i);
            if (frame) {
                frame.data = (0, $kpTCe.decodeInterlaceNull)({
                    data: frame.data,
                    width: frame.width,
                    height: frame.height,
                    channels: this._apng.channels,
                    depth: this._apng.depth
                });
                if (this._hasPalette) this._apng.palette = this._palette;
                if (this._hasTransparency) this._apng.transparency = this._transparency;
                if (i === 0 || frame.xOffset === 0 && frame.yOffset === 0 && frame.width === this._png.width && frame.height === this._png.height) newFrame.data = frame.data;
                else {
                    const prevFrame = this._apng.frames.at(i - 1);
                    this.disposeFrame(frame, prevFrame, newFrame);
                    this.addFrameDataToCanvas(newFrame, frame);
                }
                this._apng.frames.push(newFrame);
            }
        }
        return this._apng;
    }
    disposeFrame(frame, prevFrame, imageFrame) {
        switch(frame.disposeOp){
            case (0, $6eaCd.DisposeOpType).NONE:
                break;
            case (0, $6eaCd.DisposeOpType).BACKGROUND:
                for(let row = 0; row < this._png.height; row++)for(let col = 0; col < this._png.width; col++){
                    const index = (row * frame.width + col) * this._png.channels;
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = 0;
                }
                break;
            case (0, $6eaCd.DisposeOpType).PREVIOUS:
                imageFrame.data.set(prevFrame.data);
                break;
            default:
                throw new Error('Unknown disposeOp');
        }
    }
    addFrameDataToCanvas(imageFrame, frame) {
        const maxValue = 1 << this._png.depth;
        const calculatePixelIndices = (row, col)=>{
            const index = ((row + frame.yOffset) * this._png.width + frame.xOffset + col) * this._png.channels;
            const frameIndex = (row * frame.width + col) * this._png.channels;
            return {
                index: index,
                frameIndex: frameIndex
            };
        };
        switch(frame.blendOp){
            case (0, $6eaCd.BlendOpType).SOURCE:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index: index, frameIndex: frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = frame.data[frameIndex + channel];
                }
                break;
            // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
            case (0, $6eaCd.BlendOpType).OVER:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index: index, frameIndex: frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++){
                        const sourceAlpha = frame.data[frameIndex + this._png.channels - 1] / maxValue;
                        const foregroundValue = channel % (this._png.channels - 1) === 0 ? 1 : frame.data[frameIndex + channel];
                        const value = Math.floor(sourceAlpha * foregroundValue + (1 - sourceAlpha) * imageFrame.data[index + channel]);
                        imageFrame.data[index + channel] += value;
                    }
                }
                break;
            default:
                throw new Error('Unknown blendOp');
        }
    }
    decodeImage() {
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        const data = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
        if (this._filterMethod !== (0, $6eaCd.FilterMethod).ADAPTIVE) throw new Error(`Filter method ${this._filterMethod} not supported`);
        if (this._interlaceMethod === (0, $6eaCd.InterlaceMethod).NO_INTERLACE) this._png.data = (0, $kpTCe.decodeInterlaceNull)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else if (this._interlaceMethod === (0, $6eaCd.InterlaceMethod).ADAM7) this._png.data = (0, $k8R1z.decodeInterlaceAdam7)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
        if (this._hasPalette) this._png.palette = this._palette;
        if (this._hasTransparency) this._png.transparency = this._transparency;
    }
    pushDataToFrame() {
        const result = this._inflator.result;
        const lastFrame = this._frames.at(-1);
        if (lastFrame) lastFrame.data = result;
        else this._frames.push({
            sequenceNumber: 0,
            width: this._png.width,
            height: this._png.height,
            xOffset: 0,
            yOffset: 0,
            delayNumber: 0,
            delayDenominator: 0,
            disposeOp: (0, $6eaCd.DisposeOpType).NONE,
            blendOp: (0, $6eaCd.BlendOpType).SOURCE,
            data: result
        });
        this._inflator = new (0, $3rlLc.Inflate)();
        this._writingDataChunks = false;
    }
}
function $e0ab15bcb7686c8b$var$checkBitDepth(value) {
    if (value !== 1 && value !== 2 && value !== 4 && value !== 8 && value !== 16) throw new Error(`invalid bit depth: ${value}`);
    return value;
}

});
parcelRegister("jycrM", function(module, exports) {

$parcel$export(module.exports, "IOBuffer", function () { return $e3bad905562d4d5a$export$6b4c32f3d5b8738a; });

var $drEsS = parcelRequire("drEsS");
const $e3bad905562d4d5a$var$defaultByteLength = 8192;
const $e3bad905562d4d5a$var$hostBigEndian = (()=>{
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    return !((view[0] = 1) & array[0]);
})();
const $e3bad905562d4d5a$var$typedArrays = {
    int8: globalThis.Int8Array,
    uint8: globalThis.Uint8Array,
    int16: globalThis.Int16Array,
    uint16: globalThis.Uint16Array,
    int32: globalThis.Int32Array,
    uint32: globalThis.Uint32Array,
    uint64: globalThis.BigUint64Array,
    int64: globalThis.BigInt64Array,
    float32: globalThis.Float32Array,
    float64: globalThis.Float64Array
};
class $e3bad905562d4d5a$export$6b4c32f3d5b8738a {
    /**
     * Reference to the internal ArrayBuffer object.
     */ buffer;
    /**
     * Byte length of the internal ArrayBuffer.
     */ byteLength;
    /**
     * Byte offset of the internal ArrayBuffer.
     */ byteOffset;
    /**
     * Byte length of the internal ArrayBuffer.
     */ length;
    /**
     * The current offset of the buffer's pointer.
     */ offset;
    lastWrittenByte;
    littleEndian;
    _data;
    _mark;
    _marks;
    /**
     * Create a new IOBuffer.
     * @param data - The data to construct the IOBuffer with.
     * If data is a number, it will be the new buffer's length<br>
     * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
     * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
     * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
     * @param options - An object for the options.
     * @returns A new IOBuffer instance.
     */ constructor(data = $e3bad905562d4d5a$var$defaultByteLength, options = {}){
        let dataIsGiven = false;
        if (typeof data === 'number') data = new ArrayBuffer(data);
        else {
            dataIsGiven = true;
            this.lastWrittenByte = data.byteLength;
        }
        const offset = options.offset ? options.offset >>> 0 : 0;
        const byteLength = data.byteLength - offset;
        let dvOffset = offset;
        if (ArrayBuffer.isView(data) || data instanceof $e3bad905562d4d5a$export$6b4c32f3d5b8738a) {
            if (data.byteLength !== data.buffer.byteLength) dvOffset = data.byteOffset + offset;
            data = data.buffer;
        }
        if (dataIsGiven) this.lastWrittenByte = byteLength;
        else this.lastWrittenByte = 0;
        this.buffer = data;
        this.length = byteLength;
        this.byteLength = byteLength;
        this.byteOffset = dvOffset;
        this.offset = 0;
        this.littleEndian = true;
        this._data = new DataView(this.buffer, dvOffset, byteLength);
        this._mark = 0;
        this._marks = [];
    }
    /**
     * Checks if the memory allocated to the buffer is sufficient to store more
     * bytes after the offset.
     * @param byteLength - The needed memory in bytes.
     * @returns `true` if there is sufficient space and `false` otherwise.
     */ available(byteLength = 1) {
        return this.offset + byteLength <= this.length;
    }
    /**
     * Check if little-endian mode is used for reading and writing multi-byte
     * values.
     * @returns `true` if little-endian mode is used, `false` otherwise.
     */ isLittleEndian() {
        return this.littleEndian;
    }
    /**
     * Set little-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setLittleEndian() {
        this.littleEndian = true;
        return this;
    }
    /**
     * Check if big-endian mode is used for reading and writing multi-byte values.
     * @returns `true` if big-endian mode is used, `false` otherwise.
     */ isBigEndian() {
        return !this.littleEndian;
    }
    /**
     * Switches to big-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setBigEndian() {
        this.littleEndian = false;
        return this;
    }
    /**
     * Move the pointer n bytes forward.
     * @param n - Number of bytes to skip.
     * @returns This.
     */ skip(n = 1) {
        this.offset += n;
        return this;
    }
    /**
     * Move the pointer n bytes backward.
     * @param n - Number of bytes to move back.
     * @returns This.
     */ back(n = 1) {
        this.offset -= n;
        return this;
    }
    /**
     * Move the pointer to the given offset.
     * @param offset - The offset to move to.
     * @returns This.
     */ seek(offset) {
        this.offset = offset;
        return this;
    }
    /**
     * Store the current pointer offset.
     * @see {@link IOBuffer#reset}
     * @returns This.
     */ mark() {
        this._mark = this.offset;
        return this;
    }
    /**
     * Move the pointer back to the last pointer offset set by mark.
     * @see {@link IOBuffer#mark}
     * @returns This.
     */ reset() {
        this.offset = this._mark;
        return this;
    }
    /**
     * Push the current pointer offset to the mark stack.
     * @see {@link IOBuffer#popMark}
     * @returns This.
     */ pushMark() {
        this._marks.push(this.offset);
        return this;
    }
    /**
     * Pop the last pointer offset from the mark stack, and set the current
     * pointer offset to the popped value.
     * @see {@link IOBuffer#pushMark}
     * @returns This.
     */ popMark() {
        const offset = this._marks.pop();
        if (offset === undefined) throw new Error('Mark stack empty');
        this.seek(offset);
        return this;
    }
    /**
     * Move the pointer offset back to 0.
     * @returns This.
     */ rewind() {
        this.offset = 0;
        return this;
    }
    /**
     * Make sure the buffer has sufficient memory to write a given byteLength at
     * the current pointer offset.
     * If the buffer's memory is insufficient, this method will create a new
     * buffer (a copy) with a length that is twice (byteLength + current offset).
     * @param byteLength - The needed memory in bytes.
     * @returns This.
     */ ensureAvailable(byteLength = 1) {
        if (!this.available(byteLength)) {
            const lengthNeeded = this.offset + byteLength;
            const newLength = lengthNeeded * 2;
            const newArray = new Uint8Array(newLength);
            newArray.set(new Uint8Array(this.buffer));
            this.buffer = newArray.buffer;
            this.length = newLength;
            this.byteLength = newLength;
            this._data = new DataView(this.buffer);
        }
        return this;
    }
    /**
     * Read a byte and return false if the byte's value is 0, or true otherwise.
     * Moves pointer forward by one byte.
     * @returns The read boolean.
     */ readBoolean() {
        return this.readUint8() !== 0;
    }
    /**
     * Read a signed 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readInt8() {
        return this._data.getInt8(this.offset++);
    }
    /**
     * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readUint8() {
        return this._data.getUint8(this.offset++);
    }
    /**
     * Alias for {@link IOBuffer#readUint8}.
     * @returns The read byte.
     */ readByte() {
        return this.readUint8();
    }
    /**
     * Read `n` bytes and move pointer forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The read bytes.
     */ readBytes(n = 1) {
        return this.readArray(n, 'uint8');
    }
    /**
     * Creates an array of corresponding to the type `type` and size `size`.
     * For example type `uint8` will create a `Uint8Array`.
     * @param size - size of the resulting array
     * @param type - number type of elements to read
     * @returns The read array.
     */ readArray(size, type) {
        const bytes = $e3bad905562d4d5a$var$typedArrays[type].BYTES_PER_ELEMENT * size;
        const offset = this.byteOffset + this.offset;
        const slice = this.buffer.slice(offset, offset + bytes);
        if (this.littleEndian === $e3bad905562d4d5a$var$hostBigEndian && type !== 'uint8' && type !== 'int8') {
            const slice = new Uint8Array(this.buffer.slice(offset, offset + bytes));
            slice.reverse();
            const returnArray = new $e3bad905562d4d5a$var$typedArrays[type](slice.buffer);
            this.offset += bytes;
            returnArray.reverse();
            return returnArray;
        }
        const returnArray = new $e3bad905562d4d5a$var$typedArrays[type](slice);
        this.offset += bytes;
        return returnArray;
    }
    /**
     * Read a 16-bit signed integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readInt16() {
        const value = this._data.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readUint16() {
        const value = this._data.getUint16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 32-bit signed integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readInt32() {
        const value = this._data.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readUint32() {
        const value = this._data.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit floating number and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readFloat32() {
        const value = this._data.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 64-bit floating number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readFloat64() {
        const value = this._data.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigInt64() {
        const value = this._data.getBigInt64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigUint64() {
        const value = this._data.getBigUint64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 1-byte ASCII character and move pointer forward by 1 byte.
     * @returns The read character.
     */ readChar() {
        // eslint-disable-next-line unicorn/prefer-code-point
        return String.fromCharCode(this.readInt8());
    }
    /**
     * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
     * @param n - Number of characters to read.
     * @returns The read characters.
     */ readChars(n = 1) {
        let result = '';
        for(let i = 0; i < n; i++)result += this.readChar();
        return result;
    }
    /**
     * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
     * forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The decoded string.
     */ readUtf8(n = 1) {
        return (0, $drEsS.decode)(this.readBytes(n));
    }
    /**
     * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
     * forward by `n` bytes.
     * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
     * @param n - Number of bytes to read.
     * @param encoding - The encoding to use. Default is 'utf8'.
     * @returns The decoded string.
     */ decodeText(n = 1, encoding = 'utf8') {
        return (0, $drEsS.decode)(this.readBytes(n), encoding);
    }
    /**
     * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
     * forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeBoolean(value) {
        this.writeUint8(value ? 0xff : 0x00);
        return this;
    }
    /**
     * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeInt8(value) {
        this.ensureAvailable(1);
        this._data.setInt8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
     * byte.
     * @param value - The value to write.
     * @returns This.
     */ writeUint8(value) {
        this.ensureAvailable(1);
        this._data.setUint8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * An alias for {@link IOBuffer#writeUint8}.
     * @param value - The value to write.
     * @returns This.
     */ writeByte(value) {
        return this.writeUint8(value);
    }
    /**
     * Write all elements of `bytes` as uint8 values and move pointer forward by
     * `bytes.length` bytes.
     * @param bytes - The array of bytes to write.
     * @returns This.
     */ writeBytes(bytes) {
        this.ensureAvailable(bytes.length);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < bytes.length; i++)this._data.setUint8(this.offset++, bytes[i]);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit signed integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt16(value) {
        this.ensureAvailable(2);
        this._data.setInt16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint16(value) {
        this.ensureAvailable(2);
        this._data.setUint16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit signed integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt32(value) {
        this.ensureAvailable(4);
        this._data.setInt32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint32(value) {
        this.ensureAvailable(4);
        this._data.setUint32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit floating number and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat32(value) {
        this.ensureAvailable(4);
        this._data.setFloat32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit floating number and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat64(value) {
        this.ensureAvailable(8);
        this._data.setFloat64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit signed bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigInt64(value) {
        this.ensureAvailable(8);
        this._data.setBigInt64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigUint64(value) {
        this.ensureAvailable(8);
        this._data.setBigUint64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write the charCode of `str`'s first character as an 8-bit unsigned integer
     * and move pointer forward by 1 byte.
     * @param str - The character to write.
     * @returns This.
     */ writeChar(str) {
        // eslint-disable-next-line unicorn/prefer-code-point
        return this.writeUint8(str.charCodeAt(0));
    }
    /**
     * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
     * and move pointer forward by `str.length` bytes.
     * @param str - The characters to write.
     * @returns This.
     */ writeChars(str) {
        for(let i = 0; i < str.length; i++)// eslint-disable-next-line unicorn/prefer-code-point
        this.writeUint8(str.charCodeAt(i));
        return this;
    }
    /**
     * UTF-8 encode and write `str` to the current pointer offset and move pointer
     * forward according to the encoded length.
     * @param str - The string to write.
     * @returns This.
     */ writeUtf8(str) {
        return this.writeBytes((0, $drEsS.encode)(str));
    }
    /**
     * Export a Uint8Array view of the internal buffer.
     * The view starts at the byte offset and its length
     * is calculated to stop at the last written byte or the original length.
     * @returns A new Uint8Array view.
     */ toArray() {
        return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
    }
    /**
     *  Get the total number of bytes written so far, regardless of the current offset.
     * @returns - Total number of bytes.
     */ getWrittenByteLength() {
        return this.lastWrittenByte - this.byteOffset;
    }
    /**
     * Update the last written byte offset
     * @private
     */ _updateLastWrittenByte() {
        if (this.offset > this.lastWrittenByte) this.lastWrittenByte = this.offset;
    }
}

});
parcelRegister("drEsS", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $9c9d2f6acb59037d$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $9c9d2f6acb59037d$export$c564cdbbe6da493; });
function $9c9d2f6acb59037d$export$2f872c0f2117be69(bytes, encoding = 'utf8') {
    const decoder = new TextDecoder(encoding);
    return decoder.decode(bytes);
}
const $9c9d2f6acb59037d$var$encoder = new TextEncoder();
function $9c9d2f6acb59037d$export$c564cdbbe6da493(str) {
    return $9c9d2f6acb59037d$var$encoder.encode(str);
}

});


parcelRegister("3rlLc", function(module, exports) {

$parcel$export(module.exports, "deflate", function () { return $71c4f79ea79b1245$export$2316623ecd1285ab; });
$parcel$export(module.exports, "Inflate", function () { return $71c4f79ea79b1245$export$d1de70a877d6e43c; });
$parcel$export(module.exports, "inflate", function () { return $71c4f79ea79b1245$export$cae1ce83fe4a1782; });
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $71c4f79ea79b1245$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $71c4f79ea79b1245$var$Z_BINARY = 0;
const $71c4f79ea79b1245$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $71c4f79ea79b1245$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $71c4f79ea79b1245$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $71c4f79ea79b1245$var$STORED_BLOCK = 0;
const $71c4f79ea79b1245$var$STATIC_TREES = 1;
const $71c4f79ea79b1245$var$DYN_TREES = 2;
/* The three kinds of block type */ const $71c4f79ea79b1245$var$MIN_MATCH$1 = 3;
const $71c4f79ea79b1245$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $71c4f79ea79b1245$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $71c4f79ea79b1245$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $71c4f79ea79b1245$var$L_CODES$1 = $71c4f79ea79b1245$var$LITERALS$1 + 1 + $71c4f79ea79b1245$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $71c4f79ea79b1245$var$D_CODES$1 = 30;
/* number of distance codes */ const $71c4f79ea79b1245$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $71c4f79ea79b1245$var$HEAP_SIZE$1 = 2 * $71c4f79ea79b1245$var$L_CODES$1 + 1;
/* maximum heap size */ const $71c4f79ea79b1245$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $71c4f79ea79b1245$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $71c4f79ea79b1245$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $71c4f79ea79b1245$var$END_BLOCK = 256;
/* end of block literal code */ const $71c4f79ea79b1245$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $71c4f79ea79b1245$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $71c4f79ea79b1245$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $71c4f79ea79b1245$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $71c4f79ea79b1245$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $71c4f79ea79b1245$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $71c4f79ea79b1245$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $71c4f79ea79b1245$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $71c4f79ea79b1245$var$static_ltree = new Array(($71c4f79ea79b1245$var$L_CODES$1 + 2) * 2);
$71c4f79ea79b1245$var$zero$1($71c4f79ea79b1245$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $71c4f79ea79b1245$var$static_dtree = new Array($71c4f79ea79b1245$var$D_CODES$1 * 2);
$71c4f79ea79b1245$var$zero$1($71c4f79ea79b1245$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $71c4f79ea79b1245$var$_dist_code = new Array($71c4f79ea79b1245$var$DIST_CODE_LEN);
$71c4f79ea79b1245$var$zero$1($71c4f79ea79b1245$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $71c4f79ea79b1245$var$_length_code = new Array($71c4f79ea79b1245$var$MAX_MATCH$1 - $71c4f79ea79b1245$var$MIN_MATCH$1 + 1);
$71c4f79ea79b1245$var$zero$1($71c4f79ea79b1245$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $71c4f79ea79b1245$var$base_length = new Array($71c4f79ea79b1245$var$LENGTH_CODES$1);
$71c4f79ea79b1245$var$zero$1($71c4f79ea79b1245$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $71c4f79ea79b1245$var$base_dist = new Array($71c4f79ea79b1245$var$D_CODES$1);
$71c4f79ea79b1245$var$zero$1($71c4f79ea79b1245$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $71c4f79ea79b1245$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $71c4f79ea79b1245$var$static_l_desc;
let $71c4f79ea79b1245$var$static_d_desc;
let $71c4f79ea79b1245$var$static_bl_desc;
function $71c4f79ea79b1245$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $71c4f79ea79b1245$var$d_code = (dist)=>{
    return dist < 256 ? $71c4f79ea79b1245$var$_dist_code[dist] : $71c4f79ea79b1245$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $71c4f79ea79b1245$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $71c4f79ea79b1245$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $71c4f79ea79b1245$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $71c4f79ea79b1245$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $71c4f79ea79b1245$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $71c4f79ea79b1245$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $71c4f79ea79b1245$var$send_code = (s, c, tree)=>{
    $71c4f79ea79b1245$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $71c4f79ea79b1245$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $71c4f79ea79b1245$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $71c4f79ea79b1245$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $71c4f79ea79b1245$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $71c4f79ea79b1245$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $71c4f79ea79b1245$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $71c4f79ea79b1245$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($71c4f79ea79b1245$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $71c4f79ea79b1245$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $71c4f79ea79b1245$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $71c4f79ea79b1245$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($71c4f79ea79b1245$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $71c4f79ea79b1245$var$LENGTH_CODES$1 - 1; code++){
        $71c4f79ea79b1245$var$base_length[code] = length;
        for(n = 0; n < 1 << $71c4f79ea79b1245$var$extra_lbits[code]; n++)$71c4f79ea79b1245$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $71c4f79ea79b1245$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $71c4f79ea79b1245$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $71c4f79ea79b1245$var$extra_dbits[code]; n++)$71c4f79ea79b1245$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $71c4f79ea79b1245$var$D_CODES$1; code++){
        $71c4f79ea79b1245$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $71c4f79ea79b1245$var$extra_dbits[code] - 7; n++)$71c4f79ea79b1245$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $71c4f79ea79b1245$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $71c4f79ea79b1245$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $71c4f79ea79b1245$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $71c4f79ea79b1245$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $71c4f79ea79b1245$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $71c4f79ea79b1245$var$gen_codes($71c4f79ea79b1245$var$static_ltree, $71c4f79ea79b1245$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $71c4f79ea79b1245$var$D_CODES$1; n++){
        $71c4f79ea79b1245$var$static_dtree[n * 2 + 1] = 5;
        $71c4f79ea79b1245$var$static_dtree[n * 2] = $71c4f79ea79b1245$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $71c4f79ea79b1245$var$static_l_desc = new $71c4f79ea79b1245$var$StaticTreeDesc($71c4f79ea79b1245$var$static_ltree, $71c4f79ea79b1245$var$extra_lbits, $71c4f79ea79b1245$var$LITERALS$1 + 1, $71c4f79ea79b1245$var$L_CODES$1, $71c4f79ea79b1245$var$MAX_BITS$1);
    $71c4f79ea79b1245$var$static_d_desc = new $71c4f79ea79b1245$var$StaticTreeDesc($71c4f79ea79b1245$var$static_dtree, $71c4f79ea79b1245$var$extra_dbits, 0, $71c4f79ea79b1245$var$D_CODES$1, $71c4f79ea79b1245$var$MAX_BITS$1);
    $71c4f79ea79b1245$var$static_bl_desc = new $71c4f79ea79b1245$var$StaticTreeDesc(new Array(0), $71c4f79ea79b1245$var$extra_blbits, 0, $71c4f79ea79b1245$var$BL_CODES$1, $71c4f79ea79b1245$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $71c4f79ea79b1245$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $71c4f79ea79b1245$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $71c4f79ea79b1245$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $71c4f79ea79b1245$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$71c4f79ea79b1245$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $71c4f79ea79b1245$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $71c4f79ea79b1245$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $71c4f79ea79b1245$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $71c4f79ea79b1245$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $71c4f79ea79b1245$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($71c4f79ea79b1245$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $71c4f79ea79b1245$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $71c4f79ea79b1245$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $71c4f79ea79b1245$var$_length_code[lc];
            $71c4f79ea79b1245$var$send_code(s, code + $71c4f79ea79b1245$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $71c4f79ea79b1245$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $71c4f79ea79b1245$var$base_length[code];
                $71c4f79ea79b1245$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $71c4f79ea79b1245$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $71c4f79ea79b1245$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $71c4f79ea79b1245$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $71c4f79ea79b1245$var$base_dist[code];
                $71c4f79ea79b1245$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $71c4f79ea79b1245$var$send_code(s, $71c4f79ea79b1245$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $71c4f79ea79b1245$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $71c4f79ea79b1245$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$71c4f79ea79b1245$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $71c4f79ea79b1245$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $71c4f79ea79b1245$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $71c4f79ea79b1245$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $71c4f79ea79b1245$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $71c4f79ea79b1245$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$71c4f79ea79b1245$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$71c4f79ea79b1245$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$71c4f79ea79b1245$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $71c4f79ea79b1245$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $71c4f79ea79b1245$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $71c4f79ea79b1245$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $71c4f79ea79b1245$var$send_code(s, $71c4f79ea79b1245$var$REP_3_6, s.bl_tree);
            $71c4f79ea79b1245$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $71c4f79ea79b1245$var$send_code(s, $71c4f79ea79b1245$var$REPZ_3_10, s.bl_tree);
            $71c4f79ea79b1245$var$send_bits(s, count - 3, 3);
        } else {
            $71c4f79ea79b1245$var$send_code(s, $71c4f79ea79b1245$var$REPZ_11_138, s.bl_tree);
            $71c4f79ea79b1245$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $71c4f79ea79b1245$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $71c4f79ea79b1245$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $71c4f79ea79b1245$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $71c4f79ea79b1245$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $71c4f79ea79b1245$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$71c4f79ea79b1245$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $71c4f79ea79b1245$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $71c4f79ea79b1245$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $71c4f79ea79b1245$var$send_bits(s, dcodes - 1, 5);
    $71c4f79ea79b1245$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $71c4f79ea79b1245$var$send_bits(s, s.bl_tree[$71c4f79ea79b1245$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $71c4f79ea79b1245$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $71c4f79ea79b1245$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $71c4f79ea79b1245$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $71c4f79ea79b1245$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $71c4f79ea79b1245$var$Z_TEXT;
    for(n = 32; n < $71c4f79ea79b1245$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $71c4f79ea79b1245$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $71c4f79ea79b1245$var$Z_BINARY;
};
let $71c4f79ea79b1245$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $71c4f79ea79b1245$var$_tr_init$1 = (s)=>{
    if (!$71c4f79ea79b1245$var$static_init_done) {
        $71c4f79ea79b1245$var$tr_static_init();
        $71c4f79ea79b1245$var$static_init_done = true;
    }
    s.l_desc = new $71c4f79ea79b1245$var$TreeDesc(s.dyn_ltree, $71c4f79ea79b1245$var$static_l_desc);
    s.d_desc = new $71c4f79ea79b1245$var$TreeDesc(s.dyn_dtree, $71c4f79ea79b1245$var$static_d_desc);
    s.bl_desc = new $71c4f79ea79b1245$var$TreeDesc(s.bl_tree, $71c4f79ea79b1245$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $71c4f79ea79b1245$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $71c4f79ea79b1245$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $71c4f79ea79b1245$var$send_bits(s, ($71c4f79ea79b1245$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $71c4f79ea79b1245$var$bi_windup(s); /* align on byte boundary */ 
    $71c4f79ea79b1245$var$put_short(s, stored_len);
    $71c4f79ea79b1245$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $71c4f79ea79b1245$var$_tr_align$1 = (s)=>{
    $71c4f79ea79b1245$var$send_bits(s, $71c4f79ea79b1245$var$STATIC_TREES << 1, 3);
    $71c4f79ea79b1245$var$send_code(s, $71c4f79ea79b1245$var$END_BLOCK, $71c4f79ea79b1245$var$static_ltree);
    $71c4f79ea79b1245$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $71c4f79ea79b1245$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $71c4f79ea79b1245$var$Z_UNKNOWN$1) s.strm.data_type = $71c4f79ea79b1245$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $71c4f79ea79b1245$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $71c4f79ea79b1245$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $71c4f79ea79b1245$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $71c4f79ea79b1245$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $71c4f79ea79b1245$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $71c4f79ea79b1245$var$send_bits(s, ($71c4f79ea79b1245$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $71c4f79ea79b1245$var$compress_block(s, $71c4f79ea79b1245$var$static_ltree, $71c4f79ea79b1245$var$static_dtree);
    } else {
        $71c4f79ea79b1245$var$send_bits(s, ($71c4f79ea79b1245$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $71c4f79ea79b1245$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $71c4f79ea79b1245$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $71c4f79ea79b1245$var$init_block(s);
    if (last) $71c4f79ea79b1245$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $71c4f79ea79b1245$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($71c4f79ea79b1245$var$_length_code[lc] + $71c4f79ea79b1245$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$71c4f79ea79b1245$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $71c4f79ea79b1245$var$_tr_init_1 = $71c4f79ea79b1245$var$_tr_init$1;
var $71c4f79ea79b1245$var$_tr_stored_block_1 = $71c4f79ea79b1245$var$_tr_stored_block$1;
var $71c4f79ea79b1245$var$_tr_flush_block_1 = $71c4f79ea79b1245$var$_tr_flush_block$1;
var $71c4f79ea79b1245$var$_tr_tally_1 = $71c4f79ea79b1245$var$_tr_tally$1;
var $71c4f79ea79b1245$var$_tr_align_1 = $71c4f79ea79b1245$var$_tr_align$1;
var $71c4f79ea79b1245$var$trees = {
    _tr_init: $71c4f79ea79b1245$var$_tr_init_1,
    _tr_stored_block: $71c4f79ea79b1245$var$_tr_stored_block_1,
    _tr_flush_block: $71c4f79ea79b1245$var$_tr_flush_block_1,
    _tr_tally: $71c4f79ea79b1245$var$_tr_tally_1,
    _tr_align: $71c4f79ea79b1245$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $71c4f79ea79b1245$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $71c4f79ea79b1245$var$adler32_1 = $71c4f79ea79b1245$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $71c4f79ea79b1245$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $71c4f79ea79b1245$var$crcTable = new Uint32Array($71c4f79ea79b1245$var$makeTable());
const $71c4f79ea79b1245$var$crc32 = (crc, buf, len, pos)=>{
    const t = $71c4f79ea79b1245$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $71c4f79ea79b1245$var$crc32_1 = $71c4f79ea79b1245$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $71c4f79ea79b1245$var$messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $71c4f79ea79b1245$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $71c4f79ea79b1245$var$_tr_init, _tr_stored_block: $71c4f79ea79b1245$var$_tr_stored_block, _tr_flush_block: $71c4f79ea79b1245$var$_tr_flush_block, _tr_tally: $71c4f79ea79b1245$var$_tr_tally, _tr_align: $71c4f79ea79b1245$var$_tr_align } = $71c4f79ea79b1245$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $71c4f79ea79b1245$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $71c4f79ea79b1245$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $71c4f79ea79b1245$var$Z_FULL_FLUSH$1, Z_FINISH: $71c4f79ea79b1245$var$Z_FINISH$3, Z_BLOCK: $71c4f79ea79b1245$var$Z_BLOCK$1, Z_OK: $71c4f79ea79b1245$var$Z_OK$3, Z_STREAM_END: $71c4f79ea79b1245$var$Z_STREAM_END$3, Z_STREAM_ERROR: $71c4f79ea79b1245$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $71c4f79ea79b1245$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $71c4f79ea79b1245$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $71c4f79ea79b1245$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $71c4f79ea79b1245$var$Z_FILTERED, Z_HUFFMAN_ONLY: $71c4f79ea79b1245$var$Z_HUFFMAN_ONLY, Z_RLE: $71c4f79ea79b1245$var$Z_RLE, Z_FIXED: $71c4f79ea79b1245$var$Z_FIXED, Z_DEFAULT_STRATEGY: $71c4f79ea79b1245$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $71c4f79ea79b1245$var$Z_UNKNOWN, Z_DEFLATED: $71c4f79ea79b1245$var$Z_DEFLATED$2 } = $71c4f79ea79b1245$var$constants$2;
/*============================================================================*/ const $71c4f79ea79b1245$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $71c4f79ea79b1245$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $71c4f79ea79b1245$var$DEF_MEM_LEVEL = 8;
const $71c4f79ea79b1245$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $71c4f79ea79b1245$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $71c4f79ea79b1245$var$L_CODES = $71c4f79ea79b1245$var$LITERALS + 1 + $71c4f79ea79b1245$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $71c4f79ea79b1245$var$D_CODES = 30;
/* number of distance codes */ const $71c4f79ea79b1245$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $71c4f79ea79b1245$var$HEAP_SIZE = 2 * $71c4f79ea79b1245$var$L_CODES + 1;
/* maximum heap size */ const $71c4f79ea79b1245$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $71c4f79ea79b1245$var$MIN_MATCH = 3;
const $71c4f79ea79b1245$var$MAX_MATCH = 258;
const $71c4f79ea79b1245$var$MIN_LOOKAHEAD = $71c4f79ea79b1245$var$MAX_MATCH + $71c4f79ea79b1245$var$MIN_MATCH + 1;
const $71c4f79ea79b1245$var$PRESET_DICT = 0x20;
const $71c4f79ea79b1245$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $71c4f79ea79b1245$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $71c4f79ea79b1245$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $71c4f79ea79b1245$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $71c4f79ea79b1245$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $71c4f79ea79b1245$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $71c4f79ea79b1245$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $71c4f79ea79b1245$var$FINISH_STATE = 666; /* stream complete */ 
const $71c4f79ea79b1245$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $71c4f79ea79b1245$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $71c4f79ea79b1245$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $71c4f79ea79b1245$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $71c4f79ea79b1245$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $71c4f79ea79b1245$var$err = (strm, errorCode)=>{
    strm.msg = $71c4f79ea79b1245$var$messages[errorCode];
    return errorCode;
};
const $71c4f79ea79b1245$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $71c4f79ea79b1245$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $71c4f79ea79b1245$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $71c4f79ea79b1245$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $71c4f79ea79b1245$var$HASH = $71c4f79ea79b1245$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $71c4f79ea79b1245$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $71c4f79ea79b1245$var$flush_block_only = (s, last)=>{
    $71c4f79ea79b1245$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $71c4f79ea79b1245$var$flush_pending(s.strm);
};
const $71c4f79ea79b1245$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $71c4f79ea79b1245$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $71c4f79ea79b1245$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $71c4f79ea79b1245$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $71c4f79ea79b1245$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $71c4f79ea79b1245$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $71c4f79ea79b1245$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $71c4f79ea79b1245$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $71c4f79ea79b1245$var$MAX_MATCH - (strend - scan);
        scan = strend - $71c4f79ea79b1245$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $71c4f79ea79b1245$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $71c4f79ea79b1245$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $71c4f79ea79b1245$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $71c4f79ea79b1245$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $71c4f79ea79b1245$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[str + $71c4f79ea79b1245$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $71c4f79ea79b1245$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $71c4f79ea79b1245$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $71c4f79ea79b1245$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $71c4f79ea79b1245$var$Z_FINISH$3 || flush === $71c4f79ea79b1245$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $71c4f79ea79b1245$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $71c4f79ea79b1245$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $71c4f79ea79b1245$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $71c4f79ea79b1245$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $71c4f79ea79b1245$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $71c4f79ea79b1245$var$Z_NO_FLUSH$2 && flush !== $71c4f79ea79b1245$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $71c4f79ea79b1245$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $71c4f79ea79b1245$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $71c4f79ea79b1245$var$Z_FINISH$3) && flush !== $71c4f79ea79b1245$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $71c4f79ea79b1245$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $71c4f79ea79b1245$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $71c4f79ea79b1245$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $71c4f79ea79b1245$var$BS_FINISH_STARTED : $71c4f79ea79b1245$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $71c4f79ea79b1245$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $71c4f79ea79b1245$var$MIN_LOOKAHEAD) {
            $71c4f79ea79b1245$var$fill_window(s);
            if (s.lookahead < $71c4f79ea79b1245$var$MIN_LOOKAHEAD && flush === $71c4f79ea79b1245$var$Z_NO_FLUSH$2) return $71c4f79ea79b1245$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $71c4f79ea79b1245$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[s.strstart + $71c4f79ea79b1245$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $71c4f79ea79b1245$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $71c4f79ea79b1245$var$longest_match(s, hash_head);
        if (s.match_length >= $71c4f79ea79b1245$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $71c4f79ea79b1245$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $71c4f79ea79b1245$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[s.strstart + $71c4f79ea79b1245$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $71c4f79ea79b1245$var$MIN_MATCH - 1 ? s.strstart : $71c4f79ea79b1245$var$MIN_MATCH - 1;
    if (flush === $71c4f79ea79b1245$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $71c4f79ea79b1245$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_FINISH_STARTED;
        /***/ return $71c4f79ea79b1245$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
    /***/ }
    return $71c4f79ea79b1245$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $71c4f79ea79b1245$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $71c4f79ea79b1245$var$MIN_LOOKAHEAD) {
            $71c4f79ea79b1245$var$fill_window(s);
            if (s.lookahead < $71c4f79ea79b1245$var$MIN_LOOKAHEAD && flush === $71c4f79ea79b1245$var$Z_NO_FLUSH$2) return $71c4f79ea79b1245$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $71c4f79ea79b1245$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[s.strstart + $71c4f79ea79b1245$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $71c4f79ea79b1245$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $71c4f79ea79b1245$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $71c4f79ea79b1245$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $71c4f79ea79b1245$var$Z_FILTERED || s.match_length === $71c4f79ea79b1245$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $71c4f79ea79b1245$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $71c4f79ea79b1245$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $71c4f79ea79b1245$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $71c4f79ea79b1245$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[s.strstart + $71c4f79ea79b1245$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $71c4f79ea79b1245$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $71c4f79ea79b1245$var$MIN_MATCH - 1 ? s.strstart : $71c4f79ea79b1245$var$MIN_MATCH - 1;
    if (flush === $71c4f79ea79b1245$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $71c4f79ea79b1245$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_FINISH_STARTED;
        /***/ return $71c4f79ea79b1245$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
    /***/ }
    return $71c4f79ea79b1245$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $71c4f79ea79b1245$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $71c4f79ea79b1245$var$MAX_MATCH) {
            $71c4f79ea79b1245$var$fill_window(s);
            if (s.lookahead <= $71c4f79ea79b1245$var$MAX_MATCH && flush === $71c4f79ea79b1245$var$Z_NO_FLUSH$2) return $71c4f79ea79b1245$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $71c4f79ea79b1245$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $71c4f79ea79b1245$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $71c4f79ea79b1245$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $71c4f79ea79b1245$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, 1, s.match_length - $71c4f79ea79b1245$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $71c4f79ea79b1245$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $71c4f79ea79b1245$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_FINISH_STARTED;
        /***/ return $71c4f79ea79b1245$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
    /***/ }
    return $71c4f79ea79b1245$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $71c4f79ea79b1245$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $71c4f79ea79b1245$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $71c4f79ea79b1245$var$Z_NO_FLUSH$2) return $71c4f79ea79b1245$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $71c4f79ea79b1245$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $71c4f79ea79b1245$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $71c4f79ea79b1245$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_FINISH_STARTED;
        /***/ return $71c4f79ea79b1245$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $71c4f79ea79b1245$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $71c4f79ea79b1245$var$BS_NEED_MORE;
    /***/ }
    return $71c4f79ea79b1245$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $71c4f79ea79b1245$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $71c4f79ea79b1245$var$configuration_table = [
    /*      good lazy nice chain */ new $71c4f79ea79b1245$var$Config(0, 0, 0, 0, $71c4f79ea79b1245$var$deflate_stored),
    /* 0 store only */ new $71c4f79ea79b1245$var$Config(4, 4, 8, 4, $71c4f79ea79b1245$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $71c4f79ea79b1245$var$Config(4, 5, 16, 8, $71c4f79ea79b1245$var$deflate_fast),
    /* 2 */ new $71c4f79ea79b1245$var$Config(4, 6, 32, 32, $71c4f79ea79b1245$var$deflate_fast),
    /* 3 */ new $71c4f79ea79b1245$var$Config(4, 4, 16, 16, $71c4f79ea79b1245$var$deflate_slow),
    /* 4 lazy matches */ new $71c4f79ea79b1245$var$Config(8, 16, 32, 32, $71c4f79ea79b1245$var$deflate_slow),
    /* 5 */ new $71c4f79ea79b1245$var$Config(8, 16, 128, 128, $71c4f79ea79b1245$var$deflate_slow),
    /* 6 */ new $71c4f79ea79b1245$var$Config(8, 32, 128, 256, $71c4f79ea79b1245$var$deflate_slow),
    /* 7 */ new $71c4f79ea79b1245$var$Config(32, 128, 258, 1024, $71c4f79ea79b1245$var$deflate_slow),
    /* 8 */ new $71c4f79ea79b1245$var$Config(32, 258, 258, 4096, $71c4f79ea79b1245$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $71c4f79ea79b1245$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $71c4f79ea79b1245$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $71c4f79ea79b1245$var$configuration_table[s.level].max_lazy;
    s.good_match = $71c4f79ea79b1245$var$configuration_table[s.level].good_length;
    s.nice_match = $71c4f79ea79b1245$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $71c4f79ea79b1245$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $71c4f79ea79b1245$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $71c4f79ea79b1245$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $71c4f79ea79b1245$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($71c4f79ea79b1245$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $71c4f79ea79b1245$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $71c4f79ea79b1245$var$BL_CODES + 1) * 2);
    $71c4f79ea79b1245$var$zero(this.dyn_ltree);
    $71c4f79ea79b1245$var$zero(this.dyn_dtree);
    $71c4f79ea79b1245$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($71c4f79ea79b1245$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $71c4f79ea79b1245$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $71c4f79ea79b1245$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $71c4f79ea79b1245$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $71c4f79ea79b1245$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $71c4f79ea79b1245$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $71c4f79ea79b1245$var$INIT_STATE && //#ifdef GZIP
    s.status !== $71c4f79ea79b1245$var$GZIP_STATE && //#endif
    s.status !== $71c4f79ea79b1245$var$EXTRA_STATE && s.status !== $71c4f79ea79b1245$var$NAME_STATE && s.status !== $71c4f79ea79b1245$var$COMMENT_STATE && s.status !== $71c4f79ea79b1245$var$HCRC_STATE && s.status !== $71c4f79ea79b1245$var$BUSY_STATE && s.status !== $71c4f79ea79b1245$var$FINISH_STATE) return 1;
    return 0;
};
const $71c4f79ea79b1245$var$deflateResetKeep = (strm)=>{
    if ($71c4f79ea79b1245$var$deflateStateCheck(strm)) return $71c4f79ea79b1245$var$err(strm, $71c4f79ea79b1245$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $71c4f79ea79b1245$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $71c4f79ea79b1245$var$GZIP_STATE : //#endif
    s.wrap ? $71c4f79ea79b1245$var$INIT_STATE : $71c4f79ea79b1245$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $71c4f79ea79b1245$var$_tr_init(s);
    return $71c4f79ea79b1245$var$Z_OK$3;
};
const $71c4f79ea79b1245$var$deflateReset = (strm)=>{
    const ret = $71c4f79ea79b1245$var$deflateResetKeep(strm);
    if (ret === $71c4f79ea79b1245$var$Z_OK$3) $71c4f79ea79b1245$var$lm_init(strm.state);
    return ret;
};
const $71c4f79ea79b1245$var$deflateSetHeader = (strm, head)=>{
    if ($71c4f79ea79b1245$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $71c4f79ea79b1245$var$Z_OK$3;
};
const $71c4f79ea79b1245$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $71c4f79ea79b1245$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $71c4f79ea79b1245$var$MAX_MEM_LEVEL || method !== $71c4f79ea79b1245$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $71c4f79ea79b1245$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $71c4f79ea79b1245$var$err(strm, $71c4f79ea79b1245$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $71c4f79ea79b1245$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $71c4f79ea79b1245$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $71c4f79ea79b1245$var$MIN_MATCH - 1) / $71c4f79ea79b1245$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $71c4f79ea79b1245$var$deflateReset(strm);
};
const $71c4f79ea79b1245$var$deflateInit = (strm, level)=>{
    return $71c4f79ea79b1245$var$deflateInit2(strm, level, $71c4f79ea79b1245$var$Z_DEFLATED$2, $71c4f79ea79b1245$var$MAX_WBITS$1, $71c4f79ea79b1245$var$DEF_MEM_LEVEL, $71c4f79ea79b1245$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $71c4f79ea79b1245$var$deflate$2 = (strm, flush)=>{
    if ($71c4f79ea79b1245$var$deflateStateCheck(strm) || flush > $71c4f79ea79b1245$var$Z_BLOCK$1 || flush < 0) return strm ? $71c4f79ea79b1245$var$err(strm, $71c4f79ea79b1245$var$Z_STREAM_ERROR$2) : $71c4f79ea79b1245$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $71c4f79ea79b1245$var$FINISH_STATE && flush !== $71c4f79ea79b1245$var$Z_FINISH$3) return $71c4f79ea79b1245$var$err(strm, strm.avail_out === 0 ? $71c4f79ea79b1245$var$Z_BUF_ERROR$1 : $71c4f79ea79b1245$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $71c4f79ea79b1245$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $71c4f79ea79b1245$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $71c4f79ea79b1245$var$rank(flush) <= $71c4f79ea79b1245$var$rank(old_flush) && flush !== $71c4f79ea79b1245$var$Z_FINISH$3) return $71c4f79ea79b1245$var$err(strm, $71c4f79ea79b1245$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $71c4f79ea79b1245$var$FINISH_STATE && strm.avail_in !== 0) return $71c4f79ea79b1245$var$err(strm, $71c4f79ea79b1245$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $71c4f79ea79b1245$var$INIT_STATE && s.wrap === 0) s.status = $71c4f79ea79b1245$var$BUSY_STATE;
    if (s.status === $71c4f79ea79b1245$var$INIT_STATE) {
        /* zlib header */ let header = $71c4f79ea79b1245$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $71c4f79ea79b1245$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $71c4f79ea79b1245$var$PRESET_DICT;
        header += 31 - header % 31;
        $71c4f79ea79b1245$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $71c4f79ea79b1245$var$putShortMSB(s, strm.adler >>> 16);
            $71c4f79ea79b1245$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $71c4f79ea79b1245$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $71c4f79ea79b1245$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $71c4f79ea79b1245$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $71c4f79ea79b1245$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $71c4f79ea79b1245$var$put_byte(s, 31);
        $71c4f79ea79b1245$var$put_byte(s, 139);
        $71c4f79ea79b1245$var$put_byte(s, 8);
        if (!s.gzhead) {
            $71c4f79ea79b1245$var$put_byte(s, 0);
            $71c4f79ea79b1245$var$put_byte(s, 0);
            $71c4f79ea79b1245$var$put_byte(s, 0);
            $71c4f79ea79b1245$var$put_byte(s, 0);
            $71c4f79ea79b1245$var$put_byte(s, 0);
            $71c4f79ea79b1245$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $71c4f79ea79b1245$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $71c4f79ea79b1245$var$put_byte(s, $71c4f79ea79b1245$var$OS_CODE);
            s.status = $71c4f79ea79b1245$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $71c4f79ea79b1245$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $71c4f79ea79b1245$var$Z_OK$3;
            }
        } else {
            $71c4f79ea79b1245$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $71c4f79ea79b1245$var$put_byte(s, s.gzhead.time & 0xff);
            $71c4f79ea79b1245$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $71c4f79ea79b1245$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $71c4f79ea79b1245$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $71c4f79ea79b1245$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $71c4f79ea79b1245$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $71c4f79ea79b1245$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $71c4f79ea79b1245$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $71c4f79ea79b1245$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $71c4f79ea79b1245$var$EXTRA_STATE;
        }
    }
    if (s.status === $71c4f79ea79b1245$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $71c4f79ea79b1245$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $71c4f79ea79b1245$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $71c4f79ea79b1245$var$NAME_STATE;
    }
    if (s.status === $71c4f79ea79b1245$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $71c4f79ea79b1245$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $71c4f79ea79b1245$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $71c4f79ea79b1245$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $71c4f79ea79b1245$var$COMMENT_STATE;
    }
    if (s.status === $71c4f79ea79b1245$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $71c4f79ea79b1245$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $71c4f79ea79b1245$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $71c4f79ea79b1245$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71c4f79ea79b1245$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $71c4f79ea79b1245$var$HCRC_STATE;
    }
    if (s.status === $71c4f79ea79b1245$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $71c4f79ea79b1245$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $71c4f79ea79b1245$var$Z_OK$3;
                }
            }
            $71c4f79ea79b1245$var$put_byte(s, strm.adler & 0xff);
            $71c4f79ea79b1245$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $71c4f79ea79b1245$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $71c4f79ea79b1245$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $71c4f79ea79b1245$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $71c4f79ea79b1245$var$Z_NO_FLUSH$2 && s.status !== $71c4f79ea79b1245$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $71c4f79ea79b1245$var$deflate_stored(s, flush) : s.strategy === $71c4f79ea79b1245$var$Z_HUFFMAN_ONLY ? $71c4f79ea79b1245$var$deflate_huff(s, flush) : s.strategy === $71c4f79ea79b1245$var$Z_RLE ? $71c4f79ea79b1245$var$deflate_rle(s, flush) : $71c4f79ea79b1245$var$configuration_table[s.level].func(s, flush);
        if (bstate === $71c4f79ea79b1245$var$BS_FINISH_STARTED || bstate === $71c4f79ea79b1245$var$BS_FINISH_DONE) s.status = $71c4f79ea79b1245$var$FINISH_STATE;
        if (bstate === $71c4f79ea79b1245$var$BS_NEED_MORE || bstate === $71c4f79ea79b1245$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $71c4f79ea79b1245$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $71c4f79ea79b1245$var$BS_BLOCK_DONE) {
            if (flush === $71c4f79ea79b1245$var$Z_PARTIAL_FLUSH) $71c4f79ea79b1245$var$_tr_align(s);
            else if (flush !== $71c4f79ea79b1245$var$Z_BLOCK$1) {
                $71c4f79ea79b1245$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $71c4f79ea79b1245$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $71c4f79ea79b1245$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $71c4f79ea79b1245$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $71c4f79ea79b1245$var$Z_OK$3;
            }
        }
    }
    if (flush !== $71c4f79ea79b1245$var$Z_FINISH$3) return $71c4f79ea79b1245$var$Z_OK$3;
    if (s.wrap <= 0) return $71c4f79ea79b1245$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $71c4f79ea79b1245$var$put_byte(s, strm.adler & 0xff);
        $71c4f79ea79b1245$var$put_byte(s, strm.adler >> 8 & 0xff);
        $71c4f79ea79b1245$var$put_byte(s, strm.adler >> 16 & 0xff);
        $71c4f79ea79b1245$var$put_byte(s, strm.adler >> 24 & 0xff);
        $71c4f79ea79b1245$var$put_byte(s, strm.total_in & 0xff);
        $71c4f79ea79b1245$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $71c4f79ea79b1245$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $71c4f79ea79b1245$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $71c4f79ea79b1245$var$putShortMSB(s, strm.adler >>> 16);
        $71c4f79ea79b1245$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $71c4f79ea79b1245$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $71c4f79ea79b1245$var$Z_OK$3 : $71c4f79ea79b1245$var$Z_STREAM_END$3;
};
const $71c4f79ea79b1245$var$deflateEnd = (strm)=>{
    if ($71c4f79ea79b1245$var$deflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $71c4f79ea79b1245$var$BUSY_STATE ? $71c4f79ea79b1245$var$err(strm, $71c4f79ea79b1245$var$Z_DATA_ERROR$2) : $71c4f79ea79b1245$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $71c4f79ea79b1245$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($71c4f79ea79b1245$var$deflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $71c4f79ea79b1245$var$INIT_STATE || s.lookahead) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $71c4f79ea79b1245$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $71c4f79ea79b1245$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $71c4f79ea79b1245$var$fill_window(s);
    while(s.lookahead >= $71c4f79ea79b1245$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($71c4f79ea79b1245$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $71c4f79ea79b1245$var$HASH(s, s.ins_h, s.window[str + $71c4f79ea79b1245$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $71c4f79ea79b1245$var$MIN_MATCH - 1;
        $71c4f79ea79b1245$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $71c4f79ea79b1245$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $71c4f79ea79b1245$var$Z_OK$3;
};
var $71c4f79ea79b1245$var$deflateInit_1 = $71c4f79ea79b1245$var$deflateInit;
var $71c4f79ea79b1245$var$deflateInit2_1 = $71c4f79ea79b1245$var$deflateInit2;
var $71c4f79ea79b1245$var$deflateReset_1 = $71c4f79ea79b1245$var$deflateReset;
var $71c4f79ea79b1245$var$deflateResetKeep_1 = $71c4f79ea79b1245$var$deflateResetKeep;
var $71c4f79ea79b1245$var$deflateSetHeader_1 = $71c4f79ea79b1245$var$deflateSetHeader;
var $71c4f79ea79b1245$var$deflate_2$1 = $71c4f79ea79b1245$var$deflate$2;
var $71c4f79ea79b1245$var$deflateEnd_1 = $71c4f79ea79b1245$var$deflateEnd;
var $71c4f79ea79b1245$var$deflateSetDictionary_1 = $71c4f79ea79b1245$var$deflateSetDictionary;
var $71c4f79ea79b1245$var$deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $71c4f79ea79b1245$var$deflate_1$2 = {
    deflateInit: $71c4f79ea79b1245$var$deflateInit_1,
    deflateInit2: $71c4f79ea79b1245$var$deflateInit2_1,
    deflateReset: $71c4f79ea79b1245$var$deflateReset_1,
    deflateResetKeep: $71c4f79ea79b1245$var$deflateResetKeep_1,
    deflateSetHeader: $71c4f79ea79b1245$var$deflateSetHeader_1,
    deflate: $71c4f79ea79b1245$var$deflate_2$1,
    deflateEnd: $71c4f79ea79b1245$var$deflateEnd_1,
    deflateSetDictionary: $71c4f79ea79b1245$var$deflateSetDictionary_1,
    deflateInfo: $71c4f79ea79b1245$var$deflateInfo
};
const $71c4f79ea79b1245$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $71c4f79ea79b1245$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($71c4f79ea79b1245$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $71c4f79ea79b1245$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $71c4f79ea79b1245$var$common = {
    assign: $71c4f79ea79b1245$var$assign,
    flattenChunks: $71c4f79ea79b1245$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $71c4f79ea79b1245$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $71c4f79ea79b1245$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $71c4f79ea79b1245$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$71c4f79ea79b1245$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$71c4f79ea79b1245$var$_utf8len[254] = $71c4f79ea79b1245$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $71c4f79ea79b1245$var$string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $71c4f79ea79b1245$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $71c4f79ea79b1245$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $71c4f79ea79b1245$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $71c4f79ea79b1245$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $71c4f79ea79b1245$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $71c4f79ea79b1245$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $71c4f79ea79b1245$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $71c4f79ea79b1245$var$strings = {
    string2buf: $71c4f79ea79b1245$var$string2buf,
    buf2string: $71c4f79ea79b1245$var$buf2string,
    utf8border: $71c4f79ea79b1245$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $71c4f79ea79b1245$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $71c4f79ea79b1245$var$zstream = $71c4f79ea79b1245$var$ZStream;
const $71c4f79ea79b1245$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $71c4f79ea79b1245$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $71c4f79ea79b1245$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $71c4f79ea79b1245$var$Z_FULL_FLUSH, Z_FINISH: $71c4f79ea79b1245$var$Z_FINISH$2, Z_OK: $71c4f79ea79b1245$var$Z_OK$2, Z_STREAM_END: $71c4f79ea79b1245$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $71c4f79ea79b1245$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $71c4f79ea79b1245$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $71c4f79ea79b1245$var$Z_DEFLATED$1 } = $71c4f79ea79b1245$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $71c4f79ea79b1245$var$Deflate$1(options) {
    this.options = $71c4f79ea79b1245$var$common.assign({
        level: $71c4f79ea79b1245$var$Z_DEFAULT_COMPRESSION,
        method: $71c4f79ea79b1245$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $71c4f79ea79b1245$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $71c4f79ea79b1245$var$zstream();
    this.strm.avail_out = 0;
    let status = $71c4f79ea79b1245$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $71c4f79ea79b1245$var$Z_OK$2) throw new Error($71c4f79ea79b1245$var$messages[status]);
    if (opt.header) $71c4f79ea79b1245$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $71c4f79ea79b1245$var$strings.string2buf(opt.dictionary);
        else if ($71c4f79ea79b1245$var$toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $71c4f79ea79b1245$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $71c4f79ea79b1245$var$Z_OK$2) throw new Error($71c4f79ea79b1245$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $71c4f79ea79b1245$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $71c4f79ea79b1245$var$Z_FINISH$2 : $71c4f79ea79b1245$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $71c4f79ea79b1245$var$strings.string2buf(data);
    else if ($71c4f79ea79b1245$var$toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $71c4f79ea79b1245$var$Z_SYNC_FLUSH || _flush_mode === $71c4f79ea79b1245$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $71c4f79ea79b1245$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $71c4f79ea79b1245$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $71c4f79ea79b1245$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $71c4f79ea79b1245$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $71c4f79ea79b1245$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $71c4f79ea79b1245$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $71c4f79ea79b1245$var$Z_OK$2) this.result = $71c4f79ea79b1245$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $71c4f79ea79b1245$var$deflate$1(input, options) {
    const deflator = new $71c4f79ea79b1245$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $71c4f79ea79b1245$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $71c4f79ea79b1245$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $71c4f79ea79b1245$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $71c4f79ea79b1245$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $71c4f79ea79b1245$var$deflate$1(input, options);
}
var $71c4f79ea79b1245$var$Deflate_1$1 = $71c4f79ea79b1245$var$Deflate$1;
var $71c4f79ea79b1245$var$deflate_2 = $71c4f79ea79b1245$var$deflate$1;
var $71c4f79ea79b1245$var$deflateRaw_1$1 = $71c4f79ea79b1245$var$deflateRaw$1;
var $71c4f79ea79b1245$var$gzip_1$1 = $71c4f79ea79b1245$var$gzip$1;
var $71c4f79ea79b1245$var$constants$1 = $71c4f79ea79b1245$var$constants$2;
var $71c4f79ea79b1245$var$deflate_1$1 = {
    Deflate: $71c4f79ea79b1245$var$Deflate_1$1,
    deflate: $71c4f79ea79b1245$var$deflate_2,
    deflateRaw: $71c4f79ea79b1245$var$deflateRaw_1$1,
    gzip: $71c4f79ea79b1245$var$gzip_1$1,
    constants: $71c4f79ea79b1245$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $71c4f79ea79b1245$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $71c4f79ea79b1245$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $71c4f79ea79b1245$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $71c4f79ea79b1245$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $71c4f79ea79b1245$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $71c4f79ea79b1245$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $71c4f79ea79b1245$var$TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $71c4f79ea79b1245$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $71c4f79ea79b1245$var$MAXBITS = 15;
const $71c4f79ea79b1245$var$ENOUGH_LENS$1 = 852;
const $71c4f79ea79b1245$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $71c4f79ea79b1245$var$CODES$1 = 0;
const $71c4f79ea79b1245$var$LENS$1 = 1;
const $71c4f79ea79b1245$var$DISTS$1 = 2;
const $71c4f79ea79b1245$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $71c4f79ea79b1245$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $71c4f79ea79b1245$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $71c4f79ea79b1245$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $71c4f79ea79b1245$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($71c4f79ea79b1245$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($71c4f79ea79b1245$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $71c4f79ea79b1245$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $71c4f79ea79b1245$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $71c4f79ea79b1245$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $71c4f79ea79b1245$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $71c4f79ea79b1245$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $71c4f79ea79b1245$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $71c4f79ea79b1245$var$LENS$1) {
        base = $71c4f79ea79b1245$var$lbase;
        extra = $71c4f79ea79b1245$var$lext;
        match = 257;
    } else {
        base = $71c4f79ea79b1245$var$dbase;
        extra = $71c4f79ea79b1245$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $71c4f79ea79b1245$var$LENS$1 && used > $71c4f79ea79b1245$var$ENOUGH_LENS$1 || type === $71c4f79ea79b1245$var$DISTS$1 && used > $71c4f79ea79b1245$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $71c4f79ea79b1245$var$LENS$1 && used > $71c4f79ea79b1245$var$ENOUGH_LENS$1 || type === $71c4f79ea79b1245$var$DISTS$1 && used > $71c4f79ea79b1245$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $71c4f79ea79b1245$var$inftrees = $71c4f79ea79b1245$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $71c4f79ea79b1245$var$CODES = 0;
const $71c4f79ea79b1245$var$LENS = 1;
const $71c4f79ea79b1245$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $71c4f79ea79b1245$var$Z_FINISH$1, Z_BLOCK: $71c4f79ea79b1245$var$Z_BLOCK, Z_TREES: $71c4f79ea79b1245$var$Z_TREES, Z_OK: $71c4f79ea79b1245$var$Z_OK$1, Z_STREAM_END: $71c4f79ea79b1245$var$Z_STREAM_END$1, Z_NEED_DICT: $71c4f79ea79b1245$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $71c4f79ea79b1245$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $71c4f79ea79b1245$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $71c4f79ea79b1245$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $71c4f79ea79b1245$var$Z_BUF_ERROR, Z_DEFLATED: $71c4f79ea79b1245$var$Z_DEFLATED } = $71c4f79ea79b1245$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $71c4f79ea79b1245$var$HEAD = 16180; /* i: waiting for magic header */ 
const $71c4f79ea79b1245$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $71c4f79ea79b1245$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $71c4f79ea79b1245$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $71c4f79ea79b1245$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $71c4f79ea79b1245$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $71c4f79ea79b1245$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $71c4f79ea79b1245$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $71c4f79ea79b1245$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $71c4f79ea79b1245$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $71c4f79ea79b1245$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $71c4f79ea79b1245$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $71c4f79ea79b1245$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $71c4f79ea79b1245$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $71c4f79ea79b1245$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $71c4f79ea79b1245$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $71c4f79ea79b1245$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $71c4f79ea79b1245$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $71c4f79ea79b1245$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $71c4f79ea79b1245$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $71c4f79ea79b1245$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $71c4f79ea79b1245$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $71c4f79ea79b1245$var$DIST = 16202; /* i: waiting for distance code */ 
const $71c4f79ea79b1245$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $71c4f79ea79b1245$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $71c4f79ea79b1245$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $71c4f79ea79b1245$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $71c4f79ea79b1245$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $71c4f79ea79b1245$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $71c4f79ea79b1245$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $71c4f79ea79b1245$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $71c4f79ea79b1245$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $71c4f79ea79b1245$var$ENOUGH_LENS = 852;
const $71c4f79ea79b1245$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $71c4f79ea79b1245$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $71c4f79ea79b1245$var$DEF_WBITS = $71c4f79ea79b1245$var$MAX_WBITS;
const $71c4f79ea79b1245$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $71c4f79ea79b1245$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $71c4f79ea79b1245$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $71c4f79ea79b1245$var$HEAD || state.mode > $71c4f79ea79b1245$var$SYNC) return 1;
    return 0;
};
const $71c4f79ea79b1245$var$inflateResetKeep = (strm)=>{
    if ($71c4f79ea79b1245$var$inflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $71c4f79ea79b1245$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($71c4f79ea79b1245$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($71c4f79ea79b1245$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $71c4f79ea79b1245$var$Z_OK$1;
};
const $71c4f79ea79b1245$var$inflateReset = (strm)=>{
    if ($71c4f79ea79b1245$var$inflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $71c4f79ea79b1245$var$inflateResetKeep(strm);
};
const $71c4f79ea79b1245$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($71c4f79ea79b1245$var$inflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $71c4f79ea79b1245$var$inflateReset(strm);
};
const $71c4f79ea79b1245$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $71c4f79ea79b1245$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $71c4f79ea79b1245$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $71c4f79ea79b1245$var$inflateReset2(strm, windowBits);
    if (ret !== $71c4f79ea79b1245$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $71c4f79ea79b1245$var$inflateInit = (strm)=>{
    return $71c4f79ea79b1245$var$inflateInit2(strm, $71c4f79ea79b1245$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $71c4f79ea79b1245$var$virgin = true;
let $71c4f79ea79b1245$var$lenfix, $71c4f79ea79b1245$var$distfix; // We have no pointers in JS, so keep tables separate
const $71c4f79ea79b1245$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($71c4f79ea79b1245$var$virgin) {
        $71c4f79ea79b1245$var$lenfix = new Int32Array(512);
        $71c4f79ea79b1245$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $71c4f79ea79b1245$var$inftrees($71c4f79ea79b1245$var$LENS, state.lens, 0, 288, $71c4f79ea79b1245$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $71c4f79ea79b1245$var$inftrees($71c4f79ea79b1245$var$DISTS, state.lens, 0, 32, $71c4f79ea79b1245$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $71c4f79ea79b1245$var$virgin = false;
    }
    state.lencode = $71c4f79ea79b1245$var$lenfix;
    state.lenbits = 9;
    state.distcode = $71c4f79ea79b1245$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $71c4f79ea79b1245$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $71c4f79ea79b1245$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($71c4f79ea79b1245$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $71c4f79ea79b1245$var$TYPE) state.mode = $71c4f79ea79b1245$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $71c4f79ea79b1245$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $71c4f79ea79b1245$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $71c4f79ea79b1245$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $71c4f79ea79b1245$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $71c4f79ea79b1245$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $71c4f79ea79b1245$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $71c4f79ea79b1245$var$DICTID : $71c4f79ea79b1245$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $71c4f79ea79b1245$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $71c4f79ea79b1245$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $71c4f79ea79b1245$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $71c4f79ea79b1245$var$TIME;
        /* falls through */ case $71c4f79ea79b1245$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $71c4f79ea79b1245$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $71c4f79ea79b1245$var$OS;
        /* falls through */ case $71c4f79ea79b1245$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $71c4f79ea79b1245$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $71c4f79ea79b1245$var$EXLEN;
        /* falls through */ case $71c4f79ea79b1245$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $71c4f79ea79b1245$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $71c4f79ea79b1245$var$EXTRA;
        /* falls through */ case $71c4f79ea79b1245$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $71c4f79ea79b1245$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $71c4f79ea79b1245$var$NAME;
        /* falls through */ case $71c4f79ea79b1245$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $71c4f79ea79b1245$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $71c4f79ea79b1245$var$COMMENT;
        /* falls through */ case $71c4f79ea79b1245$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $71c4f79ea79b1245$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $71c4f79ea79b1245$var$HCRC;
        /* falls through */ case $71c4f79ea79b1245$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $71c4f79ea79b1245$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $71c4f79ea79b1245$var$TYPE;
            break;
        case $71c4f79ea79b1245$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $71c4f79ea79b1245$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $71c4f79ea79b1245$var$DICT;
        /* falls through */ case $71c4f79ea79b1245$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $71c4f79ea79b1245$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $71c4f79ea79b1245$var$TYPE;
        /* falls through */ case $71c4f79ea79b1245$var$TYPE:
            if (flush === $71c4f79ea79b1245$var$Z_BLOCK || flush === $71c4f79ea79b1245$var$Z_TREES) break inf_leave;
        /* falls through */ case $71c4f79ea79b1245$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $71c4f79ea79b1245$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $71c4f79ea79b1245$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $71c4f79ea79b1245$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $71c4f79ea79b1245$var$LEN_; /* decode codes */ 
                    if (flush === $71c4f79ea79b1245$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $71c4f79ea79b1245$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $71c4f79ea79b1245$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $71c4f79ea79b1245$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $71c4f79ea79b1245$var$COPY_;
            if (flush === $71c4f79ea79b1245$var$Z_TREES) break inf_leave;
        /* falls through */ case $71c4f79ea79b1245$var$COPY_:
            state.mode = $71c4f79ea79b1245$var$COPY;
        /* falls through */ case $71c4f79ea79b1245$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $71c4f79ea79b1245$var$TYPE;
            break;
        case $71c4f79ea79b1245$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $71c4f79ea79b1245$var$LENLENS;
        /* falls through */ case $71c4f79ea79b1245$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $71c4f79ea79b1245$var$inftrees($71c4f79ea79b1245$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $71c4f79ea79b1245$var$CODELENS;
        /* falls through */ case $71c4f79ea79b1245$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $71c4f79ea79b1245$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $71c4f79ea79b1245$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $71c4f79ea79b1245$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $71c4f79ea79b1245$var$inftrees($71c4f79ea79b1245$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $71c4f79ea79b1245$var$inftrees($71c4f79ea79b1245$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $71c4f79ea79b1245$var$LEN_;
            if (flush === $71c4f79ea79b1245$var$Z_TREES) break inf_leave;
        /* falls through */ case $71c4f79ea79b1245$var$LEN_:
            state.mode = $71c4f79ea79b1245$var$LEN;
        /* falls through */ case $71c4f79ea79b1245$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $71c4f79ea79b1245$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $71c4f79ea79b1245$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $71c4f79ea79b1245$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $71c4f79ea79b1245$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $71c4f79ea79b1245$var$LENEXT;
        /* falls through */ case $71c4f79ea79b1245$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $71c4f79ea79b1245$var$DIST;
        /* falls through */ case $71c4f79ea79b1245$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $71c4f79ea79b1245$var$DISTEXT;
        /* falls through */ case $71c4f79ea79b1245$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $71c4f79ea79b1245$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $71c4f79ea79b1245$var$MATCH;
        /* falls through */ case $71c4f79ea79b1245$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $71c4f79ea79b1245$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $71c4f79ea79b1245$var$LEN;
            break;
        case $71c4f79ea79b1245$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $71c4f79ea79b1245$var$LEN;
            break;
        case $71c4f79ea79b1245$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $71c4f79ea79b1245$var$crc32_1(state.check, output, _out, put - _out) : $71c4f79ea79b1245$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $71c4f79ea79b1245$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $71c4f79ea79b1245$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $71c4f79ea79b1245$var$LENGTH;
        /* falls through */ case $71c4f79ea79b1245$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $71c4f79ea79b1245$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $71c4f79ea79b1245$var$DONE;
        /* falls through */ case $71c4f79ea79b1245$var$DONE:
            ret = $71c4f79ea79b1245$var$Z_STREAM_END$1;
            break inf_leave;
        case $71c4f79ea79b1245$var$BAD:
            ret = $71c4f79ea79b1245$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $71c4f79ea79b1245$var$MEM:
            return $71c4f79ea79b1245$var$Z_MEM_ERROR$1;
        case $71c4f79ea79b1245$var$SYNC:
        /* falls through */ default:
            return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $71c4f79ea79b1245$var$BAD && (state.mode < $71c4f79ea79b1245$var$CHECK || flush !== $71c4f79ea79b1245$var$Z_FINISH$1)) $71c4f79ea79b1245$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $71c4f79ea79b1245$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $71c4f79ea79b1245$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $71c4f79ea79b1245$var$TYPE ? 128 : 0) + (state.mode === $71c4f79ea79b1245$var$LEN_ || state.mode === $71c4f79ea79b1245$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $71c4f79ea79b1245$var$Z_FINISH$1) && ret === $71c4f79ea79b1245$var$Z_OK$1) ret = $71c4f79ea79b1245$var$Z_BUF_ERROR;
    return ret;
};
const $71c4f79ea79b1245$var$inflateEnd = (strm)=>{
    if ($71c4f79ea79b1245$var$inflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $71c4f79ea79b1245$var$Z_OK$1;
};
const $71c4f79ea79b1245$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($71c4f79ea79b1245$var$inflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $71c4f79ea79b1245$var$Z_OK$1;
};
const $71c4f79ea79b1245$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($71c4f79ea79b1245$var$inflateStateCheck(strm)) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $71c4f79ea79b1245$var$DICT) return $71c4f79ea79b1245$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $71c4f79ea79b1245$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $71c4f79ea79b1245$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $71c4f79ea79b1245$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $71c4f79ea79b1245$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $71c4f79ea79b1245$var$MEM;
        return $71c4f79ea79b1245$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $71c4f79ea79b1245$var$Z_OK$1;
};
var $71c4f79ea79b1245$var$inflateReset_1 = $71c4f79ea79b1245$var$inflateReset;
var $71c4f79ea79b1245$var$inflateReset2_1 = $71c4f79ea79b1245$var$inflateReset2;
var $71c4f79ea79b1245$var$inflateResetKeep_1 = $71c4f79ea79b1245$var$inflateResetKeep;
var $71c4f79ea79b1245$var$inflateInit_1 = $71c4f79ea79b1245$var$inflateInit;
var $71c4f79ea79b1245$var$inflateInit2_1 = $71c4f79ea79b1245$var$inflateInit2;
var $71c4f79ea79b1245$var$inflate_2$1 = $71c4f79ea79b1245$var$inflate$2;
var $71c4f79ea79b1245$var$inflateEnd_1 = $71c4f79ea79b1245$var$inflateEnd;
var $71c4f79ea79b1245$var$inflateGetHeader_1 = $71c4f79ea79b1245$var$inflateGetHeader;
var $71c4f79ea79b1245$var$inflateSetDictionary_1 = $71c4f79ea79b1245$var$inflateSetDictionary;
var $71c4f79ea79b1245$var$inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $71c4f79ea79b1245$var$inflate_1$2 = {
    inflateReset: $71c4f79ea79b1245$var$inflateReset_1,
    inflateReset2: $71c4f79ea79b1245$var$inflateReset2_1,
    inflateResetKeep: $71c4f79ea79b1245$var$inflateResetKeep_1,
    inflateInit: $71c4f79ea79b1245$var$inflateInit_1,
    inflateInit2: $71c4f79ea79b1245$var$inflateInit2_1,
    inflate: $71c4f79ea79b1245$var$inflate_2$1,
    inflateEnd: $71c4f79ea79b1245$var$inflateEnd_1,
    inflateGetHeader: $71c4f79ea79b1245$var$inflateGetHeader_1,
    inflateSetDictionary: $71c4f79ea79b1245$var$inflateSetDictionary_1,
    inflateInfo: $71c4f79ea79b1245$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $71c4f79ea79b1245$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $71c4f79ea79b1245$var$gzheader = $71c4f79ea79b1245$var$GZheader;
const $71c4f79ea79b1245$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $71c4f79ea79b1245$var$Z_NO_FLUSH, Z_FINISH: $71c4f79ea79b1245$var$Z_FINISH, Z_OK: $71c4f79ea79b1245$var$Z_OK, Z_STREAM_END: $71c4f79ea79b1245$var$Z_STREAM_END, Z_NEED_DICT: $71c4f79ea79b1245$var$Z_NEED_DICT, Z_STREAM_ERROR: $71c4f79ea79b1245$var$Z_STREAM_ERROR, Z_DATA_ERROR: $71c4f79ea79b1245$var$Z_DATA_ERROR, Z_MEM_ERROR: $71c4f79ea79b1245$var$Z_MEM_ERROR } = $71c4f79ea79b1245$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $71c4f79ea79b1245$var$Inflate$1(options) {
    this.options = $71c4f79ea79b1245$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ''
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $71c4f79ea79b1245$var$zstream();
    this.strm.avail_out = 0;
    let status = $71c4f79ea79b1245$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $71c4f79ea79b1245$var$Z_OK) throw new Error($71c4f79ea79b1245$var$messages[status]);
    this.header = new $71c4f79ea79b1245$var$gzheader();
    $71c4f79ea79b1245$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $71c4f79ea79b1245$var$strings.string2buf(opt.dictionary);
        else if ($71c4f79ea79b1245$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $71c4f79ea79b1245$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $71c4f79ea79b1245$var$Z_OK) throw new Error($71c4f79ea79b1245$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $71c4f79ea79b1245$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $71c4f79ea79b1245$var$Z_FINISH : $71c4f79ea79b1245$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($71c4f79ea79b1245$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $71c4f79ea79b1245$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $71c4f79ea79b1245$var$Z_NEED_DICT && dictionary) {
            status = $71c4f79ea79b1245$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $71c4f79ea79b1245$var$Z_OK) status = $71c4f79ea79b1245$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $71c4f79ea79b1245$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $71c4f79ea79b1245$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $71c4f79ea79b1245$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $71c4f79ea79b1245$var$inflate_1$2.inflateReset(strm);
            status = $71c4f79ea79b1245$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $71c4f79ea79b1245$var$Z_STREAM_ERROR:
            case $71c4f79ea79b1245$var$Z_DATA_ERROR:
            case $71c4f79ea79b1245$var$Z_NEED_DICT:
            case $71c4f79ea79b1245$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $71c4f79ea79b1245$var$Z_STREAM_END) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $71c4f79ea79b1245$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $71c4f79ea79b1245$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $71c4f79ea79b1245$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $71c4f79ea79b1245$var$Z_STREAM_END) {
            status = $71c4f79ea79b1245$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $71c4f79ea79b1245$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $71c4f79ea79b1245$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $71c4f79ea79b1245$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $71c4f79ea79b1245$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $71c4f79ea79b1245$var$inflate$1(input, options) {
    const inflator = new $71c4f79ea79b1245$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $71c4f79ea79b1245$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $71c4f79ea79b1245$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $71c4f79ea79b1245$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $71c4f79ea79b1245$var$Inflate_1$1 = $71c4f79ea79b1245$var$Inflate$1;
var $71c4f79ea79b1245$var$inflate_2 = $71c4f79ea79b1245$var$inflate$1;
var $71c4f79ea79b1245$var$inflateRaw_1$1 = $71c4f79ea79b1245$var$inflateRaw$1;
var $71c4f79ea79b1245$var$ungzip$1 = $71c4f79ea79b1245$var$inflate$1;
var $71c4f79ea79b1245$var$constants = $71c4f79ea79b1245$var$constants$2;
var $71c4f79ea79b1245$var$inflate_1$1 = {
    Inflate: $71c4f79ea79b1245$var$Inflate_1$1,
    inflate: $71c4f79ea79b1245$var$inflate_2,
    inflateRaw: $71c4f79ea79b1245$var$inflateRaw_1$1,
    ungzip: $71c4f79ea79b1245$var$ungzip$1,
    constants: $71c4f79ea79b1245$var$constants
};
const { Deflate: $71c4f79ea79b1245$var$Deflate, deflate: $71c4f79ea79b1245$var$deflate, deflateRaw: $71c4f79ea79b1245$var$deflateRaw, gzip: $71c4f79ea79b1245$var$gzip } = $71c4f79ea79b1245$var$deflate_1$1;
const { Inflate: $71c4f79ea79b1245$var$Inflate, inflate: $71c4f79ea79b1245$var$inflate, inflateRaw: $71c4f79ea79b1245$var$inflateRaw, ungzip: $71c4f79ea79b1245$var$ungzip } = $71c4f79ea79b1245$var$inflate_1$1;
var $71c4f79ea79b1245$export$ae157b6234afe138 = $71c4f79ea79b1245$var$Deflate;
var $71c4f79ea79b1245$export$2316623ecd1285ab = $71c4f79ea79b1245$var$deflate;
var $71c4f79ea79b1245$export$e95d6a8f69fb340a = $71c4f79ea79b1245$var$deflateRaw;
var $71c4f79ea79b1245$export$69f0ea7cf3a331a8 = $71c4f79ea79b1245$var$gzip;
var $71c4f79ea79b1245$export$d1de70a877d6e43c = $71c4f79ea79b1245$var$Inflate;
var $71c4f79ea79b1245$export$cae1ce83fe4a1782 = $71c4f79ea79b1245$var$inflate;
var $71c4f79ea79b1245$export$d0f0aa2d05c905c5 = $71c4f79ea79b1245$var$inflateRaw;
var $71c4f79ea79b1245$export$95adf9d270383091 = $71c4f79ea79b1245$var$ungzip;
var $71c4f79ea79b1245$export$1a988e7317c65621 = $71c4f79ea79b1245$var$constants$2;
var $71c4f79ea79b1245$export$2e2bcd8739ae039 = {
    Deflate: $71c4f79ea79b1245$export$ae157b6234afe138,
    deflate: $71c4f79ea79b1245$export$2316623ecd1285ab,
    deflateRaw: $71c4f79ea79b1245$export$e95d6a8f69fb340a,
    gzip: $71c4f79ea79b1245$export$69f0ea7cf3a331a8,
    Inflate: $71c4f79ea79b1245$export$d1de70a877d6e43c,
    inflate: $71c4f79ea79b1245$export$cae1ce83fe4a1782,
    inflateRaw: $71c4f79ea79b1245$export$d0f0aa2d05c905c5,
    ungzip: $71c4f79ea79b1245$export$95adf9d270383091,
    constants: $71c4f79ea79b1245$export$1a988e7317c65621
};

});

parcelRegister("dLMW8", function(module, exports) {

$parcel$export(module.exports, "checkCrc", function () { return $a0659ff13d35486f$export$a27e44f4abee07bd; });
$parcel$export(module.exports, "writeCrc", function () { return $a0659ff13d35486f$export$f1eadea2b27d7525; });
const $a0659ff13d35486f$var$crcTable = [];
for(let n = 0; n < 256; n++){
    let c = n;
    for(let k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
    else c = c >>> 1;
    $a0659ff13d35486f$var$crcTable[n] = c;
}
const $a0659ff13d35486f$var$initialCrc = 0xffffffff;
function $a0659ff13d35486f$var$updateCrc(currentCrc, data, length) {
    let c = currentCrc;
    for(let n = 0; n < length; n++)c = $a0659ff13d35486f$var$crcTable[(c ^ data[n]) & 0xff] ^ c >>> 8;
    return c;
}
function $a0659ff13d35486f$var$crc(data, length) {
    return ($a0659ff13d35486f$var$updateCrc($a0659ff13d35486f$var$initialCrc, data, length) ^ $a0659ff13d35486f$var$initialCrc) >>> 0;
}
function $a0659ff13d35486f$export$a27e44f4abee07bd(buffer, crcLength, chunkName) {
    const expectedCrc = buffer.readUint32();
    const actualCrc = $a0659ff13d35486f$var$crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - crcLength - 4, crcLength), crcLength); // "- 4" because we already advanced by reading the CRC
    if (actualCrc !== expectedCrc) throw new Error(`CRC mismatch for chunk ${chunkName}. Expected ${expectedCrc}, found ${actualCrc}`);
}
function $a0659ff13d35486f$export$f1eadea2b27d7525(buffer, length) {
    buffer.writeUint32($a0659ff13d35486f$var$crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - length, length), length));
}

});

parcelRegister("k8R1z", function(module, exports) {

$parcel$export(module.exports, "decodeInterlaceAdam7", function () { return $ea9daf875f6f5128$export$4e311ab71083585; });

var $k43i6 = parcelRequire("k43i6");
const $ea9daf875f6f5128$var$uint16 = new Uint16Array([
    0x00ff
]);
const $ea9daf875f6f5128$var$uint8 = new Uint8Array($ea9daf875f6f5128$var$uint16.buffer);
const $ea9daf875f6f5128$var$osIsLittleEndian = $ea9daf875f6f5128$var$uint8[0] === 0xff;
function $ea9daf875f6f5128$export$4e311ab71083585(params) {
    const { data: data, width: width, height: height, channels: channels, depth: depth } = params;
    // Adam7 interlacing pattern
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const resultData = new Uint8Array(height * width * bytesPerPixel);
    let offset = 0;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        // Calculate pass dimensions
        const passWidth = Math.ceil((width - pass.x) / pass.xStep);
        const passHeight = Math.ceil((height - pass.y) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * bytesPerPixel;
        const prevLine = new Uint8Array(passLineBytes);
        // Process each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            // First byte is the filter type
            const filterType = data[offset++];
            const currentLine = data.subarray(offset, offset + passLineBytes);
            offset += passLineBytes;
            // Create a new line for the unfiltered data
            const newLine = new Uint8Array(passLineBytes);
            // Apply the appropriate unfilter
            (0, $k43i6.applyUnfilter)(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            prevLine.set(newLine);
            for(let x = 0; x < passWidth; x++){
                const outputX = pass.x + x * pass.xStep;
                const outputY = pass.y + y * pass.yStep;
                if (outputX >= width || outputY >= height) continue;
                for(let i = 0; i < bytesPerPixel; i++)resultData[(outputY * width + outputX) * bytesPerPixel + i] = newLine[x * bytesPerPixel + i];
            }
        }
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(resultData.buffer);
        if ($ea9daf875f6f5128$var$osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = $ea9daf875f6f5128$var$swap16(uint16Data[k]);
        return uint16Data;
    } else return resultData;
}
function $ea9daf875f6f5128$var$swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}

});
parcelRegister("k43i6", function(module, exports) {

$parcel$export(module.exports, "applyUnfilter", function () { return $e9b6bbe18cd933c7$export$cf2952a533e34237; });

var $6lOCC = parcelRequire("6lOCC");
function $e9b6bbe18cd933c7$export$cf2952a533e34237(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel) {
    switch(filterType){
        case 0:
            (0, $6lOCC.unfilterNone)(currentLine, newLine, passLineBytes);
            break;
        case 1:
            (0, $6lOCC.unfilterSub)(currentLine, newLine, passLineBytes, bytesPerPixel);
            break;
        case 2:
            (0, $6lOCC.unfilterUp)(currentLine, newLine, prevLine, passLineBytes);
            break;
        case 3:
            (0, $6lOCC.unfilterAverage)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        case 4:
            (0, $6lOCC.unfilterPaeth)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        default:
            throw new Error(`Unsupported filter: ${filterType}`);
    }
}

});
parcelRegister("6lOCC", function(module, exports) {

$parcel$export(module.exports, "unfilterNone", function () { return $49fbf8b32dc8d1b8$export$b7b5bfc0952df2ea; });
$parcel$export(module.exports, "unfilterSub", function () { return $49fbf8b32dc8d1b8$export$74a31f89f2bf5d02; });
$parcel$export(module.exports, "unfilterUp", function () { return $49fbf8b32dc8d1b8$export$42813f03f0be1153; });
$parcel$export(module.exports, "unfilterAverage", function () { return $49fbf8b32dc8d1b8$export$ad0279a52dc26d29; });
$parcel$export(module.exports, "unfilterPaeth", function () { return $49fbf8b32dc8d1b8$export$6c7fcb68da6b62; });
function $49fbf8b32dc8d1b8$export$b7b5bfc0952df2ea(currentLine, newLine, bytesPerLine) {
    for(let i = 0; i < bytesPerLine; i++)newLine[i] = currentLine[i];
}
function $49fbf8b32dc8d1b8$export$74a31f89f2bf5d02(currentLine, newLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    for(; i < bytesPerPixel; i++)// just copy first bytes
    newLine[i] = currentLine[i];
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
}
function $49fbf8b32dc8d1b8$export$42813f03f0be1153(currentLine, newLine, prevLine, bytesPerLine) {
    let i = 0;
    if (prevLine.length === 0) // just copy bytes for first line
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i];
    else for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
}
function $49fbf8b32dc8d1b8$export$ad0279a52dc26d29(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] >> 1) & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + (prevLine[i] >> 1) & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] + prevLine[i] >> 1) & 0xff;
    }
}
function $49fbf8b32dc8d1b8$export$6c7fcb68da6b62(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + $49fbf8b32dc8d1b8$var$paethPredictor(newLine[i - bytesPerPixel], prevLine[i], prevLine[i - bytesPerPixel]) & 0xff;
    }
}
function $49fbf8b32dc8d1b8$var$paethPredictor(a, b, c) {
    const p = a + b - c;
    const pa = Math.abs(p - a);
    const pb = Math.abs(p - b);
    const pc = Math.abs(p - c);
    if (pa <= pb && pa <= pc) return a;
    else if (pb <= pc) return b;
    else return c;
}

});



parcelRegister("kpTCe", function(module, exports) {

$parcel$export(module.exports, "decodeInterlaceNull", function () { return $edd14894279359af$export$fe66f1bbb29d778e; });

var $6lOCC = parcelRequire("6lOCC");
const $edd14894279359af$var$uint16 = new Uint16Array([
    0x00ff
]);
const $edd14894279359af$var$uint8 = new Uint8Array($edd14894279359af$var$uint16.buffer);
const $edd14894279359af$var$osIsLittleEndian = $edd14894279359af$var$uint8[0] === 0xff;
const $edd14894279359af$var$empty = new Uint8Array(0);
function $edd14894279359af$export$fe66f1bbb29d778e(params) {
    const { data: data, width: width, height: height, channels: channels, depth: depth } = params;
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const bytesPerLine = Math.ceil(depth / 8 * channels * width);
    const newData = new Uint8Array(height * bytesPerLine);
    let prevLine = $edd14894279359af$var$empty;
    let offset = 0;
    let currentLine;
    let newLine;
    for(let i = 0; i < height; i++){
        currentLine = data.subarray(offset + 1, offset + 1 + bytesPerLine);
        newLine = newData.subarray(i * bytesPerLine, (i + 1) * bytesPerLine);
        switch(data[offset]){
            case 0:
                (0, $6lOCC.unfilterNone)(currentLine, newLine, bytesPerLine);
                break;
            case 1:
                (0, $6lOCC.unfilterSub)(currentLine, newLine, bytesPerLine, bytesPerPixel);
                break;
            case 2:
                (0, $6lOCC.unfilterUp)(currentLine, newLine, prevLine, bytesPerLine);
                break;
            case 3:
                (0, $6lOCC.unfilterAverage)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            case 4:
                (0, $6lOCC.unfilterPaeth)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            default:
                throw new Error(`Unsupported filter: ${data[offset]}`);
        }
        prevLine = newLine;
        offset += bytesPerLine + 1;
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(newData.buffer);
        if ($edd14894279359af$var$osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = $edd14894279359af$var$swap16(uint16Data[k]);
        return uint16Data;
    } else return newData;
}
function $edd14894279359af$var$swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}

});

parcelRegister("7Gf4Z", function(module, exports) {

$parcel$export(module.exports, "writeSignature", function () { return $5978271cf04b3790$export$6d91aec43a397576; });
$parcel$export(module.exports, "checkSignature", function () { return $5978271cf04b3790$export$9b20e139d888fd41; });
// https://www.w3.org/TR/PNG/#5PNG-file-signature
const $5978271cf04b3790$var$pngSignature = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function $5978271cf04b3790$export$6d91aec43a397576(buffer) {
    buffer.writeBytes($5978271cf04b3790$var$pngSignature);
}
function $5978271cf04b3790$export$9b20e139d888fd41(buffer) {
    if (!$5978271cf04b3790$export$eb3857d891b50bba(buffer.readBytes($5978271cf04b3790$var$pngSignature.length))) throw new Error('wrong PNG signature');
}
function $5978271cf04b3790$export$eb3857d891b50bba(array) {
    if (array.length < $5978271cf04b3790$var$pngSignature.length) return false;
    for(let i = 0; i < $5978271cf04b3790$var$pngSignature.length; i++){
        if (array[i] !== $5978271cf04b3790$var$pngSignature[i]) return false;
    }
    return true;
}

});

parcelRegister("8jcMv", function(module, exports) {

$parcel$export(module.exports, "textChunkName", function () { return $60ca032e9bbdc518$export$b7828eccb3fa75e; });
$parcel$export(module.exports, "decodetEXt", function () { return $60ca032e9bbdc518$export$eaa080cfa45e66ec; });
$parcel$export(module.exports, "readKeyword", function () { return $60ca032e9bbdc518$export$7ff9b48854e294c6; });
$parcel$export(module.exports, "encodetEXt", function () { return $60ca032e9bbdc518$export$304fabbece3077af; });

var $dLMW8 = parcelRequire("dLMW8");
const $60ca032e9bbdc518$export$b7828eccb3fa75e = 'tEXt';
const $60ca032e9bbdc518$var$NULL = 0;
const $60ca032e9bbdc518$var$latin1Decoder = new TextDecoder('latin1');
function $60ca032e9bbdc518$var$validateKeyword(keyword) {
    $60ca032e9bbdc518$var$validateLatin1(keyword);
    if (keyword.length === 0 || keyword.length > 79) throw new Error('keyword length must be between 1 and 79');
}
// eslint-disable-next-line no-control-regex
const $60ca032e9bbdc518$var$latin1Regex = /^[\u0000-\u00FF]*$/;
function $60ca032e9bbdc518$var$validateLatin1(text) {
    if (!$60ca032e9bbdc518$var$latin1Regex.test(text)) throw new Error('invalid latin1 text');
}
function $60ca032e9bbdc518$export$eaa080cfa45e66ec(text, buffer, length) {
    const keyword = $60ca032e9bbdc518$export$7ff9b48854e294c6(buffer);
    text[keyword] = $60ca032e9bbdc518$export$6f32b93aa65863bd(buffer, length - keyword.length - 1);
}
function $60ca032e9bbdc518$export$304fabbece3077af(buffer, keyword, text) {
    $60ca032e9bbdc518$var$validateKeyword(keyword);
    $60ca032e9bbdc518$var$validateLatin1(text);
    const length = keyword.length + 1 /* NULL */  + text.length;
    buffer.writeUint32(length);
    buffer.writeChars($60ca032e9bbdc518$export$b7828eccb3fa75e);
    buffer.writeChars(keyword);
    buffer.writeByte($60ca032e9bbdc518$var$NULL);
    buffer.writeChars(text);
    (0, $dLMW8.writeCrc)(buffer, length + 4);
}
function $60ca032e9bbdc518$export$7ff9b48854e294c6(buffer) {
    buffer.mark();
    while(buffer.readByte() !== $60ca032e9bbdc518$var$NULL);
    const end = buffer.offset;
    buffer.reset();
    const keyword = $60ca032e9bbdc518$var$latin1Decoder.decode(buffer.readBytes(end - buffer.offset - 1));
    // NULL
    buffer.skip(1);
    $60ca032e9bbdc518$var$validateKeyword(keyword);
    return keyword;
}
function $60ca032e9bbdc518$export$6f32b93aa65863bd(buffer, length) {
    return $60ca032e9bbdc518$var$latin1Decoder.decode(buffer.readBytes(length));
}

});

parcelRegister("6eaCd", function(module, exports) {

$parcel$export(module.exports, "ColorType", function () { return $488c48e654625462$export$2cd82751acc0e609; });
$parcel$export(module.exports, "CompressionMethod", function () { return $488c48e654625462$export$825f3c317f99229; });
$parcel$export(module.exports, "FilterMethod", function () { return $488c48e654625462$export$3ecd618ea72c47f7; });
$parcel$export(module.exports, "InterlaceMethod", function () { return $488c48e654625462$export$2b1dd3da86572fe2; });
$parcel$export(module.exports, "DisposeOpType", function () { return $488c48e654625462$export$c2de24028defae28; });
$parcel$export(module.exports, "BlendOpType", function () { return $488c48e654625462$export$b8d06ec133a3a0ca; });
const $488c48e654625462$export$2cd82751acc0e609 = {
    UNKNOWN: -1,
    GREYSCALE: 0,
    TRUECOLOUR: 2,
    INDEXED_COLOUR: 3,
    GREYSCALE_ALPHA: 4,
    TRUECOLOUR_ALPHA: 6
};
const $488c48e654625462$export$825f3c317f99229 = {
    UNKNOWN: -1,
    DEFLATE: 0
};
const $488c48e654625462$export$3ecd618ea72c47f7 = {
    UNKNOWN: -1,
    ADAPTIVE: 0
};
const $488c48e654625462$export$2b1dd3da86572fe2 = {
    UNKNOWN: -1,
    NO_INTERLACE: 0,
    ADAM7: 1
};
const $488c48e654625462$export$c2de24028defae28 = {
    NONE: 0,
    BACKGROUND: 1,
    PREVIOUS: 2
};
const $488c48e654625462$export$b8d06ec133a3a0ca = {
    SOURCE: 0,
    OVER: 1
};

});


parcelRegister("fU0Bj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b93c8d4ed7e04aa3$export$2e2bcd8739ae039; });

var $jycrM = parcelRequire("jycrM");

var $3rlLc = parcelRequire("3rlLc");

var $dLMW8 = parcelRequire("dLMW8");

var $7Gf4Z = parcelRequire("7Gf4Z");

var $8jcMv = parcelRequire("8jcMv");

var $6eaCd = parcelRequire("6eaCd");
const $b93c8d4ed7e04aa3$var$defaultZlibOptions = {
    level: 3
};
class $b93c8d4ed7e04aa3$export$2e2bcd8739ae039 extends (0, $jycrM.IOBuffer) {
    _png;
    _zlibOptions;
    _colorType;
    _interlaceMethod;
    constructor(data, options = {}){
        super();
        this._colorType = (0, $6eaCd.ColorType).UNKNOWN;
        this._zlibOptions = {
            ...$b93c8d4ed7e04aa3$var$defaultZlibOptions,
            ...options.zlib
        };
        this._png = this._checkData(data);
        this._interlaceMethod = (options.interlace === 'Adam7' ? (0, $6eaCd.InterlaceMethod).ADAM7 : (0, $6eaCd.InterlaceMethod).NO_INTERLACE) ?? (0, $6eaCd.InterlaceMethod).NO_INTERLACE;
        this.setBigEndian();
    }
    encode() {
        (0, $7Gf4Z.writeSignature)(this);
        this.encodeIHDR();
        if (this._png.palette) {
            this.encodePLTE();
            if (this._png.palette[0].length === 4) this.encodeTRNS();
        }
        this.encodeData();
        if (this._png.text) for (const [keyword, text] of Object.entries(this._png.text))(0, $8jcMv.encodetEXt)(this, keyword, text);
        this.encodeIEND();
        return this.toArray();
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    encodeIHDR() {
        this.writeUint32(13);
        this.writeChars('IHDR');
        this.writeUint32(this._png.width);
        this.writeUint32(this._png.height);
        this.writeByte(this._png.depth);
        this.writeByte(this._colorType);
        this.writeByte((0, $6eaCd.CompressionMethod).DEFLATE);
        this.writeByte((0, $6eaCd.FilterMethod).ADAPTIVE);
        this.writeByte(this._interlaceMethod);
        (0, $dLMW8.writeCrc)(this, 17);
    }
    // https://www.w3.org/TR/PNG/#11IEND
    encodeIEND() {
        this.writeUint32(0);
        this.writeChars('IEND');
        (0, $dLMW8.writeCrc)(this, 4);
    }
    encodePLTE() {
        const paletteLength = this._png.palette?.length * 3;
        this.writeUint32(paletteLength);
        this.writeChars('PLTE');
        for (const color of this._png.palette){
            this.writeByte(color[0]);
            this.writeByte(color[1]);
            this.writeByte(color[2]);
        }
        (0, $dLMW8.writeCrc)(this, 4 + paletteLength);
    }
    encodeTRNS() {
        const alpha = this._png.palette.filter((color)=>{
            return color.at(-1) !== 255;
        });
        this.writeUint32(alpha.length);
        this.writeChars('tRNS');
        for (const el of alpha)this.writeByte(el.at(-1));
        (0, $dLMW8.writeCrc)(this, 4 + alpha.length);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    encodeIDAT(data) {
        this.writeUint32(data.length);
        this.writeChars('IDAT');
        this.writeBytes(data);
        (0, $dLMW8.writeCrc)(this, data.length + 4);
    }
    encodeData() {
        const { width: width, height: height, channels: channels, depth: depth, data: data } = this._png;
        const slotsPerLine = depth <= 8 ? Math.ceil(width * depth / 8) * channels : Math.ceil(width * depth / 8 * channels / 2);
        const newData = new (0, $jycrM.IOBuffer)().setBigEndian();
        let offset = 0;
        if (this._interlaceMethod === (0, $6eaCd.InterlaceMethod).NO_INTERLACE) for(let i = 0; i < height; i++){
            newData.writeByte(0); // no filter
            if (depth === 16) offset = $b93c8d4ed7e04aa3$var$writeDataUint16(data, newData, slotsPerLine, offset);
            else offset = $b93c8d4ed7e04aa3$var$writeDataBytes(data, newData, slotsPerLine, offset);
        }
        else if (this._interlaceMethod === (0, $6eaCd.InterlaceMethod).ADAM7) // Adam7 interlacing
        offset = $b93c8d4ed7e04aa3$var$writeDataInterlaced(this._png, data, newData, offset);
        const buffer = newData.toArray();
        const compressed = (0, $3rlLc.deflate)(buffer, this._zlibOptions);
        this.encodeIDAT(compressed);
    }
    _checkData(data) {
        const { colorType: colorType, channels: channels, depth: depth } = $b93c8d4ed7e04aa3$var$getColorType(data, data.palette);
        const png = {
            width: $b93c8d4ed7e04aa3$var$checkInteger(data.width, 'width'),
            height: $b93c8d4ed7e04aa3$var$checkInteger(data.height, 'height'),
            channels: channels,
            data: data.data,
            depth: depth,
            text: data.text,
            palette: data.palette
        };
        this._colorType = colorType;
        const expectedSize = depth < 8 ? Math.ceil(png.width * depth / 8) * png.height * channels : png.width * png.height * channels;
        if (png.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${png.data.length}, expected ${expectedSize}`);
        return png;
    }
}
function $b93c8d4ed7e04aa3$var$checkInteger(value, name) {
    if (Number.isInteger(value) && value > 0) return value;
    throw new TypeError(`${name} must be a positive integer`);
}
function $b93c8d4ed7e04aa3$var$getColorType(data, palette) {
    const { channels: channels = 4, depth: depth = 8 } = data;
    if (channels !== 4 && channels !== 3 && channels !== 2 && channels !== 1) throw new RangeError(`unsupported number of channels: ${channels}`);
    const returnValue = {
        channels: channels,
        depth: depth,
        colorType: (0, $6eaCd.ColorType).UNKNOWN
    };
    switch(channels){
        case 4:
            returnValue.colorType = (0, $6eaCd.ColorType).TRUECOLOUR_ALPHA;
            break;
        case 3:
            returnValue.colorType = (0, $6eaCd.ColorType).TRUECOLOUR;
            break;
        case 1:
            if (palette) returnValue.colorType = (0, $6eaCd.ColorType).INDEXED_COLOUR;
            else returnValue.colorType = (0, $6eaCd.ColorType).GREYSCALE;
            break;
        case 2:
            returnValue.colorType = (0, $6eaCd.ColorType).GREYSCALE_ALPHA;
            break;
        default:
            throw new Error('unsupported number of channels');
    }
    return returnValue;
}
function $b93c8d4ed7e04aa3$var$writeDataBytes(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeByte(data[offset++]);
    return offset;
}
function $b93c8d4ed7e04aa3$var$writeDataInterlaced(imageData, data, newData, offset) {
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const { width: width, height: height, channels: channels, depth: depth } = imageData;
    let pixelSize = 0;
    if (depth === 16) pixelSize = channels * depth / 8 / 2;
    else pixelSize = channels * depth / 8;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        const passWidth = Math.floor((width - pass.x + pass.xStep - 1) / pass.xStep);
        const passHeight = Math.floor((height - pass.y + pass.yStep - 1) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * pixelSize;
        // For each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            const imageY = pass.y + y * pass.yStep;
            // Extract raw scanline data
            const rawScanline = depth <= 8 ? new Uint8Array(passLineBytes) : new Uint16Array(passLineBytes);
            let rawOffset = 0;
            for(let x = 0; x < passWidth; x++){
                const imageX = pass.x + x * pass.xStep;
                if (imageX < width && imageY < height) {
                    const srcPos = (imageY * width + imageX) * pixelSize;
                    for(let i = 0; i < pixelSize; i++)rawScanline[rawOffset++] = data[srcPos + i];
                }
            }
            newData.writeByte(0); // no filter
            if (depth === 8) newData.writeBytes(rawScanline);
            else if (depth === 16) for (const value of rawScanline){
                newData.writeByte(value >> 8 & 0xff); // High byte
                newData.writeByte(value & 0xff);
            }
        }
    }
    return offset;
}
function $b93c8d4ed7e04aa3$var$writeDataUint16(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeUint16(data[offset++]);
    return offset;
}

});

parcelRegister("q07ZQ", function(module, exports) {
var $04e2873c70ac10d6$export$ba7e3928a2814288;
(function(ResolutionUnitSpecifier) {
    /**
     * Unit is unknown
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Unit is the metre
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["METRE"] = 1] = "METRE";
})($04e2873c70ac10d6$export$ba7e3928a2814288 || ($04e2873c70ac10d6$export$ba7e3928a2814288 = {}));

});

parcelRegister("4IoKO", function(module, exports) {
/**
 * Converts indexed data into RGB/RGBA format
 * @param decodedImage - Image to decode data from.
 * @returns Uint8Array with RGB data.
 */ function $36ee791b5569fd39$export$83c94b26563411c8(decodedImage) {
    const palette = decodedImage.palette;
    const depth = decodedImage.depth;
    if (!palette) throw new Error('Color palette is undefined.');
    $36ee791b5569fd39$var$checkDataSize(decodedImage);
    const indexSize = decodedImage.width * decodedImage.height;
    const resSize = indexSize * palette[0].length;
    const res = new Uint8Array(resSize);
    let indexPos = 0;
    let offset = 0;
    const indexes = new Uint8Array(indexSize);
    let bit = 0xff;
    switch(depth){
        case 1:
            bit = 0x80;
            break;
        case 2:
            bit = 0xc0;
            break;
        case 4:
            bit = 0xf0;
            break;
        case 8:
            bit = 0xff;
            break;
        default:
            throw new Error('Incorrect depth value');
    }
    for (const byte of decodedImage.data){
        let bit2 = bit;
        let shift = 8;
        while(bit2){
            shift -= depth;
            indexes[indexPos++] = (byte & bit2) >> shift;
            bit2 = bit2 >> depth;
            if (indexPos % decodedImage.width === 0) break;
        }
    }
    if (decodedImage.palette) for (const index of indexes){
        const color = decodedImage.palette.at(index);
        if (!color) throw new Error('Incorrect index of palette color');
        res.set(color, offset);
        offset += color.length;
    }
    return res;
}
function $36ee791b5569fd39$var$checkDataSize(image) {
    const expectedSize = image.depth < 8 ? Math.ceil(image.width * image.depth / 8) * image.height * image.channels : image.width * image.height * image.channels;
    if (image.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${image.data.length}, expected ${expectedSize}`);
}

});


parcelRegister("8LL9e", function(module, exports) {
module.exports = $parcel$import("1Hukf").then(()=>parcelRequire('4ZSQu'));

});

parcelRegister("dP7i3", function(module, exports) {
module.exports = $parcel$import("5yelA").then(()=>parcelRequire('iCvRj'));

});

parcelRegister("bI9cw", function(module, exports) {
module.exports = $parcel$import("9Nfi1").then(()=>parcelRequire('hndC7'));

});



parcelRegister("gL1yS", function(module, exports) {

$parcel$export(module.exports, "AcceptorCategoriesManager", function () { return $78419451a4e95dee$export$8a8b077f2280a581; });

var $fsofG = parcelRequire("fsofG");
class $78419451a4e95dee$export$8a8b077f2280a581 {
    constructor(acceptorService){
        this.acceptorService = acceptorService;
        this.acceptorCategories = new (0, $fsofG.ObservableArray)([]);
    }
    async refresh() {
        const categories = await this.acceptorService.getAcceptorCategories();
        this.acceptorCategories.set(categories);
    }
}

});

parcelRegister("jEHGF", function(module, exports) {

$parcel$export(module.exports, "AcceptorManager", function () { return $fdaa16e24873ba29$export$ab8efee2a8aba77e; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $fsofG = parcelRequire("fsofG");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");
class $fdaa16e24873ba29$export$ab8efee2a8aba77e {
    constructor(acceptorService){
        this.acceptorService = acceptorService;
        this.acceptors = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.error = new (0, $3Ersk.Observable)(null);
        this.loading = new (0, $3Ersk.Observable)(false);
        this.loadingMore = new (0, $3Ersk.Observable)(false);
        this.loadingMoreError = new (0, $3Ersk.Observable)(null);
        this.latitude = new (0, $3Ersk.Observable)(0);
        this.longitude = new (0, $3Ersk.Observable)(0);
        this.radius = new (0, $3Ersk.Observable)(undefined);
        this.categoryFilters = new (0, $fsofG.ObservableArray)([]);
        this.currentRefreshPromise = null;
        this.supportDedicatedTransfers = new (0, $3Ersk.Observable)(false);
    }
    isFiltered(category) {
        return this.categoryFilters.get().includes(category);
    }
    areAllFiltered(categories) {
        return this.categoryFilters.get().length === Object.keys(categories).length;
    }
    async toggleAll(categories) {
        if (this.areAllFiltered(categories)) this.categoryFilters.set([]);
        else this.categoryFilters.set(categories);
        await this.load(this.latitude.get(), this.longitude.get(), this.supportDedicatedTransfers.get());
    }
    async load(latitude, longitude, supportDedicatedTransfers = false, limit, radius) {
        if (this.loading.get()) return;
        try {
            this.loading.set(true);
            this.error.set(null);
            this.acceptors.set((0, $lbTbw.createEmptyPaginatedData)());
            this.latitude.set(latitude);
            this.longitude.set(longitude);
            this.radius.set(radius);
            const acceptors = await this.searchAcceptor(latitude, longitude, supportDedicatedTransfers, this.categoryFilters.get(), {
                offset: 0,
                limit: limit || 10
            }, radius);
            if (!acceptors) throw Error("Failed to fetch acceptors");
            this.acceptors.set(acceptors);
            this.loading.set(false);
        } catch (e) {
            this.error.set(e);
            (0, $6JVVB.logger).debug("AcceptorManager", "Fetch acceptors failed", e);
            this.acceptors.set((0, $lbTbw.createEmptyPaginatedData)());
            this.loading.set(false);
            if (!(e instanceof $fdaa16e24873ba29$export$edc1efb3da1593e0)) throw e;
        }
    }
    async loadMore() {
        if (this.loading.get() || this.loadingMore.get()) return;
        try {
            this.loadingMore.set(true);
            this.loadingMoreError.set(null);
            const additional = await this.acceptorService.searchAcceptors(this.latitude.get(), this.longitude.get(), this.supportDedicatedTransfers.get(), this.categoryFilters.get(), {
                offset: this.acceptors.get().offset + this.acceptors.get().limit,
                limit: this.acceptors.get().limit
            });
            this.acceptors.add(additional);
            this.loadingMore.set(false);
        } catch (e) {
            this.loadingMoreError.set(e);
            (0, $6JVVB.logger).debug("Acceptors Manager", "Load more acceptors failed", e);
            this.loadingMore.set(false);
        }
    }
    async resetFilters(limit, latitude, longitude, radius) {
        this.categoryFilters.set([]);
        await this.load(latitude || this.latitude.get(), longitude || this.longitude.get(), this.supportDedicatedTransfers.get(), limit, radius);
    }
    async updateFilters(category) {
        const filters = this.categoryFilters.get();
        if (filters.includes(category)) this.categoryFilters.set(filters.filter((c)=>c !== category));
        else {
            filters.push(category);
            this.categoryFilters.set(filters);
        }
        await this.load(this.latitude.get(), this.longitude.get(), this.supportDedicatedTransfers.get());
    }
    async searchAcceptor(latitude, longitude, supportDedicatedTransfers, categories, pagination, radius) {
        this.supportDedicatedTransfers.set(supportDedicatedTransfers);
        const promise = this.acceptorService.searchAcceptors(latitude, longitude, supportDedicatedTransfers, categories, pagination, radius);
        this.currentRefreshPromise = promise;
        const acceptors = await promise;
        if (promise !== this.currentRefreshPromise) throw new $fdaa16e24873ba29$export$edc1efb3da1593e0();
        return acceptors;
    }
}
class $fdaa16e24873ba29$export$edc1efb3da1593e0 extends Error {
    constructor(message){
        super(message);
    }
}

});
parcelRegister("hngyi", function(module, exports) {

$parcel$export(module.exports, "ObservablePaginated", function () { return $e2dbcd757c14a669$export$119138ae2cc47c77; });
$parcel$export(module.exports, "useObservablePaginated", function () { return $e2dbcd757c14a669$export$49c0848d3bc60fd2; });

var $6uYXW = parcelRequire("6uYXW");

var $3Ersk = parcelRequire("3Ersk");
class $e2dbcd757c14a669$export$119138ae2cc47c77 extends (0, $3Ersk.Observable) {
    add(page) {
        const data = {
            items: [
                ...this.get().items,
                ...page.items
            ],
            count: page.count,
            total: page.total,
            offset: page.offset,
            limit: page.limit,
            sort: page.sort
        };
        this.set(data);
    }
}
function $e2dbcd757c14a669$export$49c0848d3bc60fd2(observable) {
    const [value, setValue] = (0, $6uYXW.useState)(observable.get());
    (0, $6uYXW.useEffect)(()=>{
        observable.onChange.add(setValue);
        if (observable.get() !== value) setValue(observable.get());
        return ()=>observable.onChange.remove(setValue);
    }, [
        observable,
        value
    ]);
    return value;
}

});

parcelRegister("lbTbw", function(module, exports) {

$parcel$export(module.exports, "createEmptyPaginatedData", function () { return $b9c8b12d26280b1c$export$b5c4e02ffaeb6e3b; });
$parcel$export(module.exports, "usePaginatedFetch", function () { return $b9c8b12d26280b1c$export$420e020e1fd0f1e5; });

var $6uYXW = parcelRequire("6uYXW");

var $k4Ecv = parcelRequire("k4Ecv");
const $b9c8b12d26280b1c$var$DEFAULT_PAGE_SIZE = 20;
function $b9c8b12d26280b1c$export$b5c4e02ffaeb6e3b() {
    return {
        items: [],
        count: 0,
        total: 0,
        offset: 0,
        limit: 0,
        sort: ""
    };
}
function $b9c8b12d26280b1c$export$420e020e1fd0f1e5(fun, // eslint-disable-next-line @typescript-eslint/no-explicit-any
deps = [], sort, limit) {
    const [data, setData] = (0, $6uYXW.useState)([]);
    const [offset, setOffset] = (0, $6uYXW.useState)(0);
    const [nextOffset, setNextOffset] = (0, $6uYXW.useState)(0);
    const [total, setTotal] = (0, $6uYXW.useState)(0);
    const [hasMore, setHasMore] = (0, $6uYXW.useState)(false);
    const { loading: loading, error: error, result: result, redo: redo, redoLoading: redoLoading } = (0, $k4Ecv.useAsyncFunction)(async ()=>await fun({
            offset: 0,
            limit: limit,
            sort: sort
        }), [
        ...deps
    ]);
    const { loading: loadingMore, error: moreError, result: moreResult, redo: redoLoadMore, redoLoading: redoLoadingMore } = (0, $k4Ecv.useAsyncFunction)(async ()=>{
        if (offset === 0) return null;
        return await fun({
            offset: offset,
            limit: limit,
            sort: sort
        });
    }, [
        offset
    ]);
    (0, $6uYXW.useEffect)(()=>{
        setData([]);
        setOffset(0);
        setNextOffset(0);
        setTotal(0);
        setHasMore(false);
    }, [
        ...deps
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (result) {
            setData([
                ...result.items
            ]);
            setTotal(result.total);
            setNextOffset(result.limit);
            setHasMore(result.limit < result.total);
        } else if (error) {
            setData([]);
            setOffset(0);
            setNextOffset(0);
            setTotal(0);
            setHasMore(false);
        }
    }, [
        setData,
        setTotal,
        setNextOffset,
        setHasMore,
        result,
        error
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (moreResult) {
            setData((data)=>[
                    ...data,
                    ...moreResult.items
                ]);
            setTotal(moreResult.total);
            setNextOffset(moreResult.offset + moreResult.limit);
            setHasMore(moreResult.offset + moreResult.limit < moreResult.total);
        }
    }, [
        setData,
        setTotal,
        setNextOffset,
        setHasMore,
        moreResult
    ]);
    const fetchMore = ()=>{
        if (hasMore && !loadingMore) setOffset(nextOffset);
    };
    return {
        loading: loading,
        error: error,
        data: data,
        total: total,
        redo: redo,
        redoLoading: redoLoading,
        fetchMore: fetchMore,
        hasMore: hasMore,
        loadingMore: loadingMore || redoLoadingMore,
        moreError: moreError,
        redoLoadMore: redoLoadMore
    };
}
function $b9c8b12d26280b1c$export$f80c710216eae131(data, pageSize = $b9c8b12d26280b1c$var$DEFAULT_PAGE_SIZE) {
    const [pageCount, setPageCount] = (0, $6uYXW.useState)(1);
    (0, $6uYXW.useEffect)(()=>{
        setPageCount(1);
    }, [
        data,
        pageSize
    ]);
    const getMore = (0, $6uYXW.useCallback)(()=>{
        setPageCount((count)=>count + 1);
    }, []);
    const canShowMore = data.length > pageCount * pageSize;
    return (0, $6uYXW.useMemo)(()=>({
            data: data.slice(0, pageCount * pageSize),
            canShowMore: canShowMore,
            getMore: getMore
        }), [
        data,
        getMore,
        pageCount,
        pageSize
    ]);
}
function $b9c8b12d26280b1c$export$3c2c0202c3808ef9(...sources) {
    const [currentSourceIndex, setCurrentSourceIndex] = (0, $6uYXW.useState)(0);
    const firstSource = sources[0];
    (0, $6uYXW.useEffect)(()=>{
        setCurrentSourceIndex(0);
    }, [
        firstSource
    ]);
    return {
        data: sources.map((source, index)=>index <= currentSourceIndex ? source.data : []),
        hasMore: currentSourceIndex < sources.length - 1 || sources[currentSourceIndex].hasMore,
        getMore: (0, $6uYXW.useCallback)(()=>{
            const currentSource = sources[currentSourceIndex];
            if (currentSource.getMoreError) return;
            if (currentSource.hasMore) currentSource.getMore();
            else if (currentSourceIndex < sources.length - 1) {
                setCurrentSourceIndex(currentSourceIndex + 1);
                sources[currentSourceIndex + 1].getMore();
            }
        }, [
            currentSourceIndex,
            sources
        ])
    };
}

});
parcelRegister("k4Ecv", function(module, exports) {

$parcel$export(module.exports, "useAsyncEffect", function () { return $399431b4fa5a86e4$export$6875e16a8bdc9a91; });
$parcel$export(module.exports, "useAsyncFunction", function () { return $399431b4fa5a86e4$export$8a236f6590895227; });
$parcel$export(module.exports, "repeat", function () { return $399431b4fa5a86e4$export$76d90c956114f2c2; });
$parcel$export(module.exports, "isAnNotEmptyArray", function () { return $399431b4fa5a86e4$export$f0cff9c615eb7a74; });
$parcel$export(module.exports, "useAsyncOperation", function () { return $399431b4fa5a86e4$export$7d619ed4f883db21; });
$parcel$export(module.exports, "isObjectEmpty", function () { return $399431b4fa5a86e4$export$23cfe696632d10f4; });
$parcel$export(module.exports, "filterObjectKeys", function () { return $399431b4fa5a86e4$export$2dbf66002a1c3bbf; });
$parcel$export(module.exports, "getGenderByInt", function () { return $399431b4fa5a86e4$export$93d1adf046c65d55; });
$parcel$export(module.exports, "getUniqueNetworksByServiceLevel", function () { return $399431b4fa5a86e4$export$8da9a11b5975edd5; });
$parcel$export(module.exports, "isSctEnabled", function () { return $399431b4fa5a86e4$export$797850fa429341fc; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $bx6cc = parcelRequire("bx6cc");
function $399431b4fa5a86e4$export$1391212d75b2ee65(time) {
    return new Promise((resolve)=>setTimeout(resolve, time));
}
function $399431b4fa5a86e4$export$6875e16a8bdc9a91(effect, // eslint-disable-next-line @typescript-eslint/no-explicit-any
deps) {
    (0, $6uYXW.useEffect)(()=>{
        const maybePromise = effect();
        if (maybePromise && typeof maybePromise.then === "function") maybePromise.then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
function $399431b4fa5a86e4$export$8a236f6590895227(fun, // eslint-disable-next-line @typescript-eslint/no-explicit-any
deps = []) {
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [redoLoading, setRedoLoading] = (0, $6uYXW.useState)(false);
    const [error, setError] = (0, $6uYXW.useState)(null);
    const [result, setResult] = (0, $6uYXW.useState)(null);
    const [tries, setTries] = (0, $6uYXW.useState)(0);
    $399431b4fa5a86e4$export$6875e16a8bdc9a91(async ()=>{
        try {
            setTries(0);
            setResult(null);
            setError(null);
            setLoading(true);
            const res = await fun();
            setResult(res);
        } catch (e) {
            setError(e);
        } finally{
            setLoading(false);
        }
    }, [
        setError,
        setLoading,
        setResult,
        ...deps
    ]);
    $399431b4fa5a86e4$export$6875e16a8bdc9a91(async ()=>{
        if (tries !== 0) try {
            setResult(null);
            setError(null);
            const res = await fun(true);
            setResult(res);
        } catch (e) {
            setError(e);
        } finally{
            setRedoLoading(false);
        }
    }, [
        setError,
        setLoading,
        setResult,
        tries
    ]);
    const redo = (0, $6uYXW.useCallback)(()=>{
        setRedoLoading(true);
        setTries((tries)=>tries + 1);
    }, []);
    return {
        loading: loading,
        error: error,
        result: result,
        redo: redo,
        redoLoading: redoLoading
    };
}
function $399431b4fa5a86e4$export$76d90c956114f2c2(count, factory) {
    return new Array(count).fill(null).map((_, index)=>factory(index));
}
function $399431b4fa5a86e4$export$f0cff9c615eb7a74(value) {
    return Array.isArray(value) && value.length > 0;
}
function $399431b4fa5a86e4$export$bce3bfec9f56c837() {
    const mounted = (0, $6uYXW.useRef)(false);
    (0, $6uYXW.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return mounted;
}
function $399431b4fa5a86e4$export$7d619ed4f883db21(operation) {
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [error, setError] = (0, $6uYXW.useState)(null);
    const isCancelled = (0, $6uYXW.useRef)(false);
    (0, $6uYXW.useEffect)(()=>()=>{
            isCancelled.current = true;
        }, []);
    const operationWrapper = (0, $6uYXW.useCallback)(async ()=>{
        try {
            setLoading(true);
            const result = await operation();
            if (!isCancelled.current) {
                setError(null);
                setLoading(false);
            }
            return result;
        } catch (err) {
            (0, $6JVVB.logger).debug("useAsyncOperation", operation.name, err);
            if (!isCancelled.current) setError(err?.response?.data?.error?.message || err.toString());
        } finally{
            if (!isCancelled.current) setLoading(false);
        }
    }, [
        operation
    ]);
    return [
        operationWrapper,
        loading,
        error
    ];
}
const $399431b4fa5a86e4$export$23cfe696632d10f4 = (object)=>Object.keys(object).length === 0;
const $399431b4fa5a86e4$export$2dbf66002a1c3bbf = (obj, keys, mode = "exclude")=>Object.fromEntries(Object.entries(obj).filter(([key])=>mode === "include" ? keys.includes(key) : !keys.includes(key)));
const $399431b4fa5a86e4$export$93d1adf046c65d55 = (int = 1)=>{
    switch(int){
        case 0:
            return "female";
        case 1:
            return "male";
        default:
            return "unknown";
    }
};
const $399431b4fa5a86e4$export$8da9a11b5975edd5 = (paymentNetworks)=>Array.from(new Map(paymentNetworks.map((network)=>[
            network.serviceLevel,
            network
        ])).values());
const $399431b4fa5a86e4$export$797850fa429341fc = (networkList)=>{
    if (!networkList) return false;
    return !!networkList.find((network)=>network.serviceLevel === (0, $bx6cc.ServiceLevel).SCT_INST);
};

});
parcelRegister("bx6cc", function(module, exports) {

$parcel$export(module.exports, "ServiceLevel", function () { return $f91d2ecd46628bd5$export$7e6e4daf3e119d55; });
$parcel$export(module.exports, "PaymentIdentificationMode", function () { return $f91d2ecd46628bd5$export$611976935249be92; });
$parcel$export(module.exports, "PaymentAcceptedAddress", function () { return $f91d2ecd46628bd5$export$53d6d01c66d0be98; });
$parcel$export(module.exports, "NETWORK_ACCEPTED_ADDRESSES_NEEDED", function () { return $f91d2ecd46628bd5$export$d0caa118b94035e7; });
$parcel$export(module.exports, "makeFormattedCustomerInstruction", function () { return $f91d2ecd46628bd5$export$a246b22d748156cd; });
var $f91d2ecd46628bd5$export$7e6e4daf3e119d55 = /*#__PURE__*/ function(ServiceLevel) {
    ServiceLevel["XCT"] = "XCT";
    ServiceLevel["SEPA"] = "SEPA";
    ServiceLevel["BACI"] = "BACI";
    ServiceLevel["KNGA"] = "KNGA";
    ServiceLevel["ON_US"] = "ON_US";
    ServiceLevel["SCT_INST"] = "SCT_INST";
    return ServiceLevel;
}({});
var $f91d2ecd46628bd5$export$439d2d6c03747598 = /*#__PURE__*/ function(PaymentType) {
    PaymentType["PHONE"] = "phone";
    PaymentType["IBAN"] = "IBAN";
    PaymentType["OTHER"] = "other";
    return PaymentType;
}({});
var $f91d2ecd46628bd5$export$611976935249be92 = /*#__PURE__*/ function(PaymentIdentificationMode) {
    PaymentIdentificationMode["IBAN"] = "IBAN";
    PaymentIdentificationMode["PHONE"] = "PHONE";
    PaymentIdentificationMode["ACCOUNT_NUMBER"] = "ACCOUNT_NUMBER";
    PaymentIdentificationMode["IDENTITY_ID"] = "IDENTITY_ID";
    return PaymentIdentificationMode;
}({});
var $f91d2ecd46628bd5$export$53d6d01c66d0be98 = /*#__PURE__*/ function(PaymentAcceptedAddress) {
    PaymentAcceptedAddress["STRUCTURED"] = "STRUCTURED";
    PaymentAcceptedAddress["UNSTRUCTURED"] = "UNSTRUCTURED";
    PaymentAcceptedAddress["UNSTRUCTURED_OR_NULL"] = "UNSTRUCTURED_OR_NULL";
    PaymentAcceptedAddress["BOTH"] = "BOTH";
    PaymentAcceptedAddress["NO_ADDRESS"] = "NO_ADDRESS";
    return PaymentAcceptedAddress;
}({});
const $f91d2ecd46628bd5$export$d0caa118b94035e7 = [
    "BOTH",
    "STRUCTURED",
    "UNSTRUCTURED",
    "UNSTRUCTURED_OR_NULL"
];
function $f91d2ecd46628bd5$export$9c31559418635646({ amount: amount, label: label, serviceLevel: serviceLevel, foreignAmount: foreignAmount }) {
    const canSetForeignAmount = foreignAmount && foreignAmount.currency !== amount?.currency;
    return {
        customerInstructionInformation: {
            paymentInstrument: serviceLevel === "SCT_INST" ? "CreditTransferInst" : "CreditTransfer",
            paymentService: "PAYMENTS",
            batchBooking: true,
            customerInstructionReference: `CINSTR${new Date().toISOString()}`,
            requestedExecutionDate: new Date().toISOString().substring(0, 10),
            requestedTotalAmount: amount,
            customerInstructionTypeInformation: {
                categoryPurpose: "NULL",
                serviceLevel: serviceLevel
            },
            ...canSetForeignAmount && {
                foreignAmount: {
                    currency: foreignAmount.currency
                }
            }
        },
        customerInstructionOrderingParties: {
            initiatingParty: {
                name: undefined,
                id: {
                    value: undefined,
                    type: undefined
                }
            },
            debtor: {
                name: undefined,
                accountId: {
                    value: undefined,
                    type: undefined,
                    bankId: {
                        value: undefined,
                        type: undefined
                    }
                }
            }
        },
        paymentTransaction: {
            paymentTransactionAmountInformation: {
                instructedAmount: amount,
                ...canSetForeignAmount && {
                    foreignAmount: {
                        currency: foreignAmount.currency
                    }
                }
            },
            paymentTransactionParties: {
                creditor: {
                    name: undefined,
                    accountId: {
                        value: undefined,
                        type: undefined
                    }
                }
            },
            ...label && {
                paymentTransactionDedicatedInformations: {
                    remittanceInformation: {
                        value: label,
                        type: "UNSTRUCTURED"
                    }
                }
            }
        }
    };
}
function $f91d2ecd46628bd5$export$a246b22d748156cd({ client: client, amount: amount, creditorAddress: creditorAddress, destinationAccountOrRecipient: destinationAccountOrRecipient, foreignAmount: foreignAmount, label: label, paymentNetwork: paymentNetwork, sourceAccount: sourceAccount, recurringTransferParams: recurringTransferParams }) {
    const customerInstruction = $f91d2ecd46628bd5$export$9c31559418635646({
        amount: amount,
        serviceLevel: paymentNetwork.serviceLevel,
        foreignAmount: foreignAmount,
        label: label
    });
    // Set the debtor information
    const identificationModes = paymentNetwork.identificationMode;
    const needPhoneNumberIdentificationMode = identificationModes.includes("PHONE") && identificationModes.length === 1;
    const needAccountIdentificationMode = identificationModes.includes("ACCOUNT_NUMBER") && identificationModes.length === 1;
    customerInstruction.customerInstructionOrderingParties.debtor = {
        ...customerInstruction.customerInstructionOrderingParties.debtor,
        name: client ? `${client.firstName} ${client.lastName}` : sourceAccount.name,
        accountId: {
            value: needAccountIdentificationMode ? sourceAccount.id : sourceAccount.iban?.replaceAll(" ", "") || sourceAccount.id,
            type: sourceAccount.iban ? "IBAN" : "other"
        },
        ...needPhoneNumberIdentificationMode && {
            id: {
                value: client?.contactphone,
                type: "phone"
            },
            type: null
        }
    };
    // Set the initiating party information
    customerInstruction.customerInstructionOrderingParties.initiatingParty = {
        ...customerInstruction.customerInstructionOrderingParties.initiatingParty,
        name: `${client?.firstName} ${client?.lastName}`,
        id: {
            value: client?.contactphone,
            type: "phone"
        }
    };
    // Set the creditor information
    customerInstruction.paymentTransaction.paymentTransactionParties.creditor = {
        ...customerInstruction.paymentTransaction.paymentTransactionParties.creditor,
        name: destinationAccountOrRecipient.name,
        ...creditorAddress && {
            postalAddress: creditorAddress
        },
        ...destinationAccountOrRecipient.hasOwnProperty("iban") ? {
            accountId: {
                value: needAccountIdentificationMode ? destinationAccountOrRecipient.id : destinationAccountOrRecipient.iban?.replaceAll(" ", "") || destinationAccountOrRecipient.id,
                type: destinationAccountOrRecipient.iban ? "IBAN" : "other"
            }
        } : destinationAccountOrRecipient.accountReference ? {
            accountId: {
                value: destinationAccountOrRecipient.accountReference,
                type: "other"
            }
        } : {},
        ...destinationAccountOrRecipient.phone && {
            id: {
                value: destinationAccountOrRecipient.phone,
                type: "phone"
            }
        }
    };
    // Set standing order information
    if (recurringTransferParams?.enabled) return {
        ...customerInstruction,
        firstExecutionDate: recurringTransferParams.firstExecutionDate,
        frequency: recurringTransferParams.frequency,
        ...recurringTransferParams.endDate && {
            endDate: recurringTransferParams.endDate
        }
    };
    return customerInstruction;
}

});




parcelRegister("CEBSr", function(module, exports) {

$parcel$export(module.exports, "AcceptorService", function () { return $c2f70f7c129012d0$export$19ec2af68a4afc14; });

var $6JVVB = parcelRequire("6JVVB");
class $c2f70f7c129012d0$export$19ec2af68a4afc14 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async searchAcceptors(latitude, longitude, supportDedicatedTransfers, categories, pagination, radius) {
        try {
            const response = await this.apiService.instance.get("/acceptors", {
                params: {
                    latitude: latitude,
                    longitude: longitude,
                    supportDedicatedTransfers: supportDedicatedTransfers,
                    categories: categories ? categories.map((category)=>category.id) : undefined,
                    ...pagination,
                    ...radius && {
                        radius: radius
                    }
                }
            });
            const result = response.data;
            return result;
        } catch (e) {
            (0, $6JVVB.logger).debug("AcceptorService", "Search acceptor failed", e);
            throw e;
        }
    }
    async getAcceptorCategories() {
        try {
            const response = await this.apiService.instance.get("/acceptors/categories");
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AcceptorService", "Get acceptor categories failed", e);
            throw e;
        }
    }
}

});

parcelRegister("dz3sL", function(module, exports) {

$parcel$export(module.exports, "AccountManager", function () { return $793fb9ea3f63e953$export$a1e1c1cb52ebd7df; });

var $3Ersk = parcelRequire("3Ersk");

var $fsofG = parcelRequire("fsofG");

var $kGswT = parcelRequire("kGswT");

var $9hGVP = parcelRequire("9hGVP");
class $793fb9ea3f63e953$export$a1e1c1cb52ebd7df {
    constructor(accountService, authenticationManager, clientManager, cacheLoader){
        this.accountService = accountService;
        this.authenticationManager = authenticationManager;
        this.clientManager = clientManager;
        this.cacheLoader = cacheLoader;
        this.accounts = new (0, $fsofG.ObservableArray)([]);
        this.loading = new (0, $3Ersk.Observable)(true);
        this.error = new (0, $3Ersk.Observable)(null);
        this.refreshing = new (0, $3Ersk.Observable)(false);
        this.cacheStatus = new (0, $3Ersk.Observable)(null);
        this.authenticationManager.isConnected.onChange.add(async (isConnected)=>{
            if (!isConnected) await this.clear();
        });
        this.clientManager.onLanguageChange.add(async ()=>{
            await this.clear();
            await this.load();
        });
    }
    async load() {
        this.loading.set(true);
        await this.loadOrRefresh();
        this.loading.set(false);
    }
    async refresh() {
        this.refreshing.set(true);
        await this.loadOrRefresh(true);
        this.refreshing.set(false);
    }
    async loadOrRefresh(forceRefresh) {
        try {
            this.error.set(null);
            const accounts = await this.cacheLoader.load(()=>this.accountService.fetchAccounts(), forceRefresh);
            if (!accounts) throw new Error("Failed to fetch accounts");
            await this.updateCacheStatus();
            this.accounts.set(accounts.items.filter((account)=>(0, $kGswT.isSupportedAccountType)(account)));
        } catch (e) {
            this.error.set(e);
        }
    }
    async updateAccountName(accountId, name) {
        try {
            this.error.set(null);
            const res = await this.accountService.updateAccountName(accountId, name);
            return res;
        } catch (e) {
            this.error.set(e);
            throw e;
        }
    }
    async clear() {
        await this.cacheLoader.clear();
        this.accounts.set([]);
        this.loading.set(true);
        this.error.set(null);
        this.cacheStatus.set(null);
    }
    async updateCacheStatus() {
        const cacheStatus = await this.cacheLoader.readStatus();
        this.cacheStatus.set(cacheStatus);
    }
    async fetchAuthorizedOverdraft(accountId) {
        try {
            const accountDetails = await this.accountService.fetchAccountDetails(accountId);
            const authorizedOverdraft = accountDetails.authorizedOverdraft?.display.replace("-", "");
            const authorizedOverdraftValue = Math.abs(accountDetails.authorizedOverdraft?.value ?? 0);
            const overdraftContract = await this.accountService.fetchOverdraftContract(accountId);
            const latestCycle = (0, $9hGVP.getLatestCycle)(overdraftContract?.accrualCycles);
            const validityDate = latestCycle?.endDate ?? null;
            return {
                authorizedOverdraft: authorizedOverdraft,
                validityDate: validityDate,
                authorizedOverdraftValue: authorizedOverdraftValue
            };
        } catch (error) {
            this.error.set(error);
            throw error;
        }
    }
}

});
parcelRegister("kGswT", function(module, exports) {

$parcel$export(module.exports, "AccountStatus", function () { return $411fc29a4a86a061$export$3693f74db10d5f88; });
$parcel$export(module.exports, "AccountType", function () { return $411fc29a4a86a061$export$b8ca5fa4899cbfc7; });
$parcel$export(module.exports, "isSupportedAccountType", function () { return $411fc29a4a86a061$export$d45d8ee9c77efc9c; });
$parcel$export(module.exports, "getAvailableBalance", function () { return $411fc29a4a86a061$export$7b35db5195b0378a; });
$parcel$export(module.exports, "getSettlementBalance", function () { return $411fc29a4a86a061$export$1d2ea490cfe56c39; });
$parcel$export(module.exports, "redirectionHandledOnAccountBlocked", function () { return $411fc29a4a86a061$export$6a025165567519db; });

var $4fYE4 = parcelRequire("4fYE4");

var $1YFGv = parcelRequire("1YFGv");
var $411fc29a4a86a061$export$3693f74db10d5f88 = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus["Opened"] = "OPENED";
    AccountStatus["Closed"] = "CLOSED";
    AccountStatus["Blocked"] = "BLOCKED";
    AccountStatus["DebitBlocked"] = "DEBIT_BLOCKED";
    AccountStatus["CreditBlocked"] = "CREDIT_BLOCKED";
    return AccountStatus;
}({});
var $411fc29a4a86a061$export$6568ec4fe366cd0b = /*#__PURE__*/ function(BalanceType) {
    BalanceType["Available"] = "AvailableBalance";
    BalanceType["Settlement"] = "SettlementPositionBalance";
    return BalanceType;
}({});
var $411fc29a4a86a061$export$b8ca5fa4899cbfc7 = /*#__PURE__*/ function(AccountType) {
    AccountType["Current"] = "CURRENT";
    AccountType["Joint"] = "JOINT";
    AccountType["Savings"] = "SAVINGS";
    AccountType["Dedicated"] = "DEDICATED";
    AccountType["MoneyPot"] = "MONEYPOT";
    AccountType["Technical"] = "TECHNICAL";
    return AccountType;
}({});
function $411fc29a4a86a061$export$d45d8ee9c77efc9c(account) {
    return account.type === "CURRENT" || account.type === "DEDICATED" || account.type === "MONEYPOT" || account.type === "SAVINGS" || account.type === "TECHNICAL";
}
function $411fc29a4a86a061$export$7b35db5195b0378a(account) {
    return account.balances?.filter((b)=>b.balanceType === "AvailableBalance")[0] || null;
}
function $411fc29a4a86a061$export$1d2ea490cfe56c39(account) {
    return account.balances?.filter((b)=>b.balanceType === "SettlementPositionBalance")[0] || null;
}
function $411fc29a4a86a061$export$6a025165567519db(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, redirect) {
    if ((0, $1YFGv.isAccountBlocked)(error)) {
        redirect(error.type === (0, $1YFGv.ErrorType).DefaultAccountBlocked ? (0, $4fYE4.Path).AccountBlocked : (0, $4fYE4.Path).AccountBlockedAfterPincodeError);
        return true;
    }
    return false;
}
function $411fc29a4a86a061$export$45ca5bfc13e493c(account) {
    return account.type === "SAVINGS";
}

});
parcelRegister("4fYE4", function(module, exports) {

$parcel$export(module.exports, "TRANSFER_BASE_PATH", function () { return $f78a72c2193757fa$export$c4fab3a257ea646b; });
$parcel$export(module.exports, "SAVING_BASE_PATH", function () { return $f78a72c2193757fa$export$683e58895a34d994; });
$parcel$export(module.exports, "Path", function () { return $f78a72c2193757fa$export$4b2950bdac9b6ee9; });
const $f78a72c2193757fa$export$c4fab3a257ea646b = "/transfer";
const $f78a72c2193757fa$export$683e58895a34d994 = "/saving";
var $f78a72c2193757fa$export$4b2950bdac9b6ee9 = /*#__PURE__*/ function(Path) {
    Path["Root"] = "/";
    Path["OAuthRedirect"] = "/oauth-redirect";
    Path["UbbleRedirect"] = "/ubble-redirect";
    Path["Register"] = "/new-account";
    Path["Onboarding"] = "/onboarding";
    Path["OnboardingFile"] = "/onboarding-file";
    Path["OnboardingFileSubmitted"] = "/onboarding-finalized";
    Path["AccountBlocked"] = "/account-blocked";
    Path["AccountBlockedAfterPincodeError"] = "/pincode-error";
    Path["AccountTransactions"] = "/account-transactions";
    Path["Recipients"] = "/transfer/recipients";
    Path["AllAccounts"] = "/all-accounts";
    Path["AllTransactions"] = "/all-transactions";
    Path["MyAccount"] = "/my-account";
    Path["AccountStatements"] = "/account-statements";
    Path["FeesStatements"] = "/fees-statements";
    Path["Transfer"] = "/transfer/all";
    Path["SimpleTransfer"] = "/transfer/simple-transfer";
    Path["Cards"] = "/cards";
    Path["AllCards"] = "/all-cards";
    Path["CardOutstandings"] = "/card-outstandings";
    Path["BillIssuers"] = "/bill-issuers";
    Path["References"] = "/references";
    Path["BankContact"] = "/contact";
    Path["ProfileMenu"] = "/profile";
    Path["Profile"] = "/my-profile";
    Path["Settings"] = "/my-settings";
    Path["CashTransfers"] = "/transfer/cash-transfers";
    Path["UpcomingTransfers"] = "/transfer/upcoming-transfers";
    Path["Recharge"] = "/transfer/recharge";
    Path["TransactionCodes"] = "/transfer/transaction-codes";
    Path["ExternalAccount"] = "/transfer/external-account";
    Path["Loans"] = "/loans";
    Path["PspRedirect"] = "/psp-redirect";
    Path["Connect"] = "/connect";
    Path["TransferMenu"] = "/transfer";
    Path["UbbleCheck"] = "/ubble-check";
    Path["JustifyTransaction"] = "/justify-transaction";
    Path["ErrorScreen"] = "/error-screen";
    Path["SavingMenu"] = "/saving";
    Path["CreateSavingAccount"] = "/saving/create-saving-account";
    Path["UbbleRedirectNewOnboarding"] = "/ubble-redirect-new-onboarding";
    Path["Mandates"] = "/mandates";
    Path["DeleteAccount"] = "/delete-account";
    Path["DeleteData"] = "/delete-data";
    return Path;
}({});

});

parcelRegister("1YFGv", function(module, exports) {

$parcel$export(module.exports, "PINCODE_MUST_BE_CHANGED_ERROR_CODE", function () { return $3b41769dcd3c2ea6$export$cd6bd5b371c20bb7; });
$parcel$export(module.exports, "ErrorType", function () { return $3b41769dcd3c2ea6$export$dba1278861bf0dc1; });
$parcel$export(module.exports, "PincodeMustBeChangedError", function () { return $3b41769dcd3c2ea6$export$1676ea704626ec0c; });
$parcel$export(module.exports, "AccountBlockedErrorFromErrorResponse", function () { return $3b41769dcd3c2ea6$export$d75cd44f30702383; });
$parcel$export(module.exports, "isAccountBlockedErrorResponse", function () { return $3b41769dcd3c2ea6$export$f755fd25054fd97c; });
$parcel$export(module.exports, "isAccountBlocked", function () { return $3b41769dcd3c2ea6$export$a056a0c1631a1ca2; });
$parcel$export(module.exports, "isRecipientNotFoundByInvalidPhoneErrorResponse", function () { return $3b41769dcd3c2ea6$export$434f428cd5d17e3c; });
$parcel$export(module.exports, "isRecipientNotFoundByInvalidPhoneError", function () { return $3b41769dcd3c2ea6$export$cce38e2f1e9141fe; });
const $3b41769dcd3c2ea6$export$cd6bd5b371c20bb7 = 30242;
const $3b41769dcd3c2ea6$export$c65ce0bd30e8fc3e = 30229;
const $3b41769dcd3c2ea6$export$8b50d14f3124c14d = 20029;
const $3b41769dcd3c2ea6$export$9c4022fd067bacee = 62329;
var $3b41769dcd3c2ea6$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["PincodeMustBeChanged"] = "PINCODE_MUST_BE_CHANGE";
    ErrorType["AccountBlockedAfterThreePincodeAttempts"] = "ACCOUNT_BLOCKED_AFTER_THREE_PINCODE_ATTEMPTS";
    ErrorType["DefaultAccountBlocked"] = "DEFAULT_ACCOUNT_BLOCKED";
    ErrorType["RecipientNotFoundByInvalidPhoneError"] = "RECIPIENT_NOT_FOUND_BY_INVALID_PHONE_ERROR";
    return ErrorType;
}({});
class $3b41769dcd3c2ea6$export$1676ea704626ec0c extends Error {
    constructor(message){
        super(message), this.type = "PINCODE_MUST_BE_CHANGE";
    }
}
class $3b41769dcd3c2ea6$export$8f92cf8c908ba74 extends Error {
    constructor(message){
        super(message), this.type = "ACCOUNT_BLOCKED_AFTER_THREE_PINCODE_ATTEMPTS";
    }
}
class $3b41769dcd3c2ea6$export$5ff4cb4b8fbdc10d extends Error {
    constructor(message){
        super(message), this.type = "DEFAULT_ACCOUNT_BLOCKED";
    }
}
class $3b41769dcd3c2ea6$export$96bc1d974a49c94e extends Error {
    constructor(message){
        super(message), this.type = "RECIPIENT_NOT_FOUND_BY_INVALID_PHONE_ERROR";
    }
}
function $3b41769dcd3c2ea6$export$d75cd44f30702383(error) {
    const code = error?.response?.data?.error?.code;
    const message = error?.response?.data?.error?.message || error.toString();
    if (code === $3b41769dcd3c2ea6$export$8b50d14f3124c14d) return new $3b41769dcd3c2ea6$export$5ff4cb4b8fbdc10d(message);
    else if (code === $3b41769dcd3c2ea6$export$c65ce0bd30e8fc3e) return new $3b41769dcd3c2ea6$export$8f92cf8c908ba74(message);
    else if (code === $3b41769dcd3c2ea6$export$cd6bd5b371c20bb7) return new $3b41769dcd3c2ea6$export$1676ea704626ec0c(message);
    else if (code === $3b41769dcd3c2ea6$export$9c4022fd067bacee) return new $3b41769dcd3c2ea6$export$96bc1d974a49c94e(message);
    return new Error(message);
}
function $3b41769dcd3c2ea6$export$f755fd25054fd97c(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error) {
    return [
        $3b41769dcd3c2ea6$export$8b50d14f3124c14d,
        $3b41769dcd3c2ea6$export$c65ce0bd30e8fc3e
    ].includes(error?.response?.data?.error?.code);
}
function $3b41769dcd3c2ea6$export$a056a0c1631a1ca2(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error) {
    return error?.type === "ACCOUNT_BLOCKED_AFTER_THREE_PINCODE_ATTEMPTS" || error?.type === "DEFAULT_ACCOUNT_BLOCKED";
}
function $3b41769dcd3c2ea6$export$434f428cd5d17e3c(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error) {
    return error?.type === "RECIPIENT_NOT_FOUND_BY_INVALID_PHONE_ERROR";
}
function $3b41769dcd3c2ea6$export$cce38e2f1e9141fe(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error) {
    return error?.response?.data?.error?.code === $3b41769dcd3c2ea6$export$9c4022fd067bacee;
}

});


parcelRegister("9hGVP", function(module, exports) {

$parcel$export(module.exports, "getLatestCycle", function () { return $02c5bd12450c36a9$export$fe1771f33a03ec9f; });
function $02c5bd12450c36a9$export$fe1771f33a03ec9f(accrualCycles) {
    try {
        if (!Array.isArray(accrualCycles) || accrualCycles.length === 0) return null;
        // Ensure all cycles have a valid endDate
        const validCycles = accrualCycles.filter((cycle)=>cycle?.endDate && !isNaN(new Date(cycle.endDate).getTime()));
        if (validCycles.length === 0) return null;
        return validCycles.slice().sort((a, b)=>new Date(b.endDate).getTime() - new Date(a.endDate).getTime())[0];
    } catch (error) {
        console.error("Error in getLatestCycle:", error);
        return null;
    }
}

});


parcelRegister("2Acav", function(module, exports) {

$parcel$export(module.exports, "AccountService", function () { return $0cd5dd5c9a2e706f$export$b662858863b75c61; });

var $6JVVB = parcelRequire("6JVVB");

var $kGswT = parcelRequire("kGswT");
class $0cd5dd5c9a2e706f$export$b662858863b75c61 {
    constructor(apiService, savingsApiService){
        this.apiService = apiService;
        this.savingsApiService = savingsApiService;
    }
    async fetchAccounts() {
        try {
            const response = await this.apiService.instance.get("/accounts", {
                params: {
                    status: [
                        (0, $kGswT.AccountStatus).Opened,
                        (0, $kGswT.AccountStatus).Blocked,
                        (0, $kGswT.AccountStatus).DebitBlocked,
                        (0, $kGswT.AccountStatus).CreditBlocked
                    ],
                    limit: 200
                }
            });
            //TODO keep until next part of ticket (vc-1086) is done
            // const fake = response.data.items.filter((e) => +e.id === +"17000660633")[0];
            // console.log(fake);
            // return { ...response.data, items: [fake], count: 1, total: 1 };
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AccountService", "Failed to fetch accounts", e);
            throw e;
        }
    }
    async updateAccountName(accountId, name) {
        try {
            const response = await this.apiService.instance.patch(`/accounts/${accountId}/name`, {
                name: name
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AccountService", "Failed to update account name", e);
            throw e;
        }
    }
    async fetchAccountDetails(accountId) {
        try {
            const response = await this.apiService.instance.get(`/accounts/${accountId}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AccountService", "Failed to fetch account details", e);
            throw e;
        }
    }
    async fetchOverdraftContract(accountId) {
        if (!this.savingsApiService?.instance) {
            (0, $6JVVB.logger).debug("AccountService", "savingsApiService is not initialized");
            throw new Error("Savings API Service is not initialized. Please ensure it is properly configured.");
        }
        try {
            const response = await this.savingsApiService.instance.get(`/cash-facility-advanced-overdraft-contracts/${accountId}/contract-details`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AccountService", "Failed to fetch overdraft contract", e);
            throw e;
        }
    }
}

});

parcelRegister("Rr3Qd", function(module, exports) {

$parcel$export(module.exports, "JustificationFilter", function () { return $1732df0c562e053c$export$dfcd8a687bfcc6ed; });
$parcel$export(module.exports, "TransactionSearchManager", function () { return $1732df0c562e053c$export$f323533eec103894; });

var $l1qT9 = parcelRequire("l1qT9");

var $3Ersk = parcelRequire("3Ersk");

var $7Uj1Y = parcelRequire("7Uj1Y");

var $ao7HR = parcelRequire("ao7HR");

var $7yIx1 = parcelRequire("7yIx1");
const $1732df0c562e053c$var$NO_BOUNDS = [
    null,
    null
];
var $1732df0c562e053c$export$dfcd8a687bfcc6ed = /*#__PURE__*/ function(JustificationFilter) {
    JustificationFilter["ALL"] = "All";
    JustificationFilter["TO_JUSTIFY"] = "ToJustify";
    JustificationFilter["TO_QUALIFY"] = "ToQualify";
    return JustificationFilter;
}({});
class $1732df0c562e053c$export$f323533eec103894 {
    setTimeRange(timeRange, bounds) {
        if (timeRange === (0, $7yIx1.TimeRange).Other) this.timeRangeSelection.set({
            timeRange: (0, $7yIx1.TimeRange).Other,
            bounds: bounds ? bounds : $1732df0c562e053c$var$NO_BOUNDS
        });
        else this.timeRangeSelection.set({
            timeRange: timeRange,
            bounds: this.getTimeBounds(timeRange)
        });
    }
    setAmountRange(low, high) {
        this.amountRange.set([
            low,
            high
        ]);
    }
    setTransactionDirection(direction) {
        this.directionSelection.set(direction);
    }
    setJustificationFilter(justification) {
        this.justificationSelection.set(justification);
    }
    getTimeBounds(timeRange) {
        const today = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9))).utc().endOf("day");
        const todayRef = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9))).utc().endOf("day");
        switch(timeRange){
            case (0, $7yIx1.TimeRange).Quarter:
                {
                    const { startDate: startDate, endDate: endDate } = (0, $7Uj1Y.getPeriod)("previous", today);
                    return [
                        startDate,
                        endDate
                    ];
                }
            case (0, $7yIx1.TimeRange).Week:
                return [
                    todayRef.subtract(7, "days"),
                    today
                ];
            case (0, $7yIx1.TimeRange).Month:
                return [
                    todayRef.subtract(1, "months"),
                    today
                ];
        }
    }
    clear() {
        this.timeRangeSelection.set({
            timeRange: (0, $7yIx1.TimeRange).Quarter,
            bounds: $1732df0c562e053c$var$NO_BOUNDS
        });
        this.absoluteAmountSelection.set($1732df0c562e053c$var$NO_BOUNDS);
        this.amountRange.set($1732df0c562e053c$var$NO_BOUNDS);
        this.directionSelection.set((0, $ao7HR.TransactionDirection).ALL);
        this.justificationSelection.set("All");
    }
    constructor(){
        this.timeRangeSelection = new (0, $3Ersk.Observable)({
            timeRange: (0, $7yIx1.TimeRange).Quarter,
            bounds: this.getTimeBounds((0, $7yIx1.TimeRange).Quarter)
        });
        this.absoluteAmountSelection = new (0, $3Ersk.Observable)($1732df0c562e053c$var$NO_BOUNDS);
        this.directionSelection = new (0, $3Ersk.Observable)((0, $ao7HR.TransactionDirection).ALL);
        this.amountRange = new (0, $3Ersk.Observable)($1732df0c562e053c$var$NO_BOUNDS);
        this.justificationSelection = new (0, $3Ersk.Observable)("All");
    }
}

});
parcelRegister("7Uj1Y", function(module, exports) {

$parcel$export(module.exports, "getPeriod", function () { return $cea65175b1f21dd2$export$d7b798838bc3adf4; });
$parcel$export(module.exports, "fetchPeriod", function () { return $cea65175b1f21dd2$export$e1a9386f3811b877; });

var $l1qT9 = parcelRequire("l1qT9");

var $7yIx1 = parcelRequire("7yIx1");
const $cea65175b1f21dd2$export$d7b798838bc3adf4 = (type, date)=>{
    let newStartDate, newEndDate;
    if (type === "previous") {
        newEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(date).subtract(1, "second");
        newStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(newEndDate).subtract(3, "months").subtract(1, "hour").add(1, "second");
    } else if (type === "next") {
        newStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(date).add(1, "second");
        newEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(newStartDate).add(3, "months").add(1, "hour");
    }
    return {
        startDate: newStartDate,
        endDate: newEndDate
    };
};
const $cea65175b1f21dd2$export$e1a9386f3811b877 = (type, startDate, endDate, transactionSearchManager)=>{
    let newStartDate, newEndDate;
    if (type === "previous") {
        const { startDate: tmpStartDate, endDate: tmpNewEndDate } = $cea65175b1f21dd2$export$d7b798838bc3adf4(type, startDate);
        newStartDate = tmpStartDate;
        newEndDate = tmpNewEndDate;
    } else if (type === "next") {
        const { startDate: tmpStartDate, endDate: tmpNewEndDate } = $cea65175b1f21dd2$export$d7b798838bc3adf4(type, endDate);
        newStartDate = tmpStartDate;
        newEndDate = tmpNewEndDate;
    }
    transactionSearchManager.setTimeRange((0, $7yIx1.TimeRange).Other, [
        newStartDate,
        newEndDate
    ]);
};

});
parcelRegister("7yIx1", function(module, exports) {

$parcel$export(module.exports, "TimeRange", function () { return $38659842f56e1c8b$export$74e1c7e2f1829413; });
var $38659842f56e1c8b$export$74e1c7e2f1829413 = /*#__PURE__*/ function(TimeRange) {
    TimeRange["Week"] = "Week";
    TimeRange["Month"] = "Month";
    TimeRange["Quarter"] = "Quarter";
    TimeRange["Other"] = "Other";
    return TimeRange;
}({});

});


parcelRegister("ao7HR", function(module, exports) {

$parcel$export(module.exports, "TransactionDirection", function () { return $4263b20a554a07aa$export$7d3b461c2a2bfacd; });
var $4263b20a554a07aa$export$7d3b461c2a2bfacd = /*#__PURE__*/ function(TransactionDirection) {
    TransactionDirection["ALL"] = "All";
    TransactionDirection["INCOME"] = "Income";
    TransactionDirection["OUTCOME"] = "Outcome";
    return TransactionDirection;
}({});

});


parcelRegister("3bBnP", function(module, exports) {

$parcel$export(module.exports, "AttachmentsManager", function () { return $e4c1f54414c6f463$export$8f8d3798e725b59e; });

var $6JVVB = parcelRequire("6JVVB");

var $fsofG = parcelRequire("fsofG");

var $eHurR = parcelRequire("eHurR");

var $93CAX = parcelRequire("93CAX");
class $e4c1f54414c6f463$export$8f8d3798e725b59e {
    constructor(attachmentsService){
        this.attachmentsService = attachmentsService;
        this.attachments = new (0, $fsofG.ObservableArray)([]);
    }
    clear() {
        this.attachments.set([]);
    }
    removeAttachment(attachmentId) {
        this.attachments.set(this.attachments.get().filter((spending)=>spending.id !== attachmentId));
    }
    async deleteAll(transactionId) {
        const deletedAttachments = this.attachments.get();
        for (const attachment of deletedAttachments){
            const url = (0, $eHurR.getUrlFromLink)(attachment.links, (0, $93CAX.AttachmentsLinks).Delete);
            this.deleteAttachment(transactionId, attachment.id, url);
        }
        this.clear();
    }
    async addAttachment(transactionId, content, description, url) {
        try {
            const newAttachment = await this.attachmentsService.addAttachment(transactionId, content, description, url);
            this.attachments.set([
                ...this.attachments.get(),
                newAttachment
            ]);
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsManager", "Add attachment failed", e);
            throw e;
        }
    }
    async refresh(transactionId, url) {
        try {
            const updatedAttachments = await this.attachmentsService.getAttachments(transactionId, url);
            this.attachments.set(updatedAttachments);
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsManager", "Refresh attachments failed", e);
            throw e;
        }
    }
    async deleteAttachment(transactionId, attachmentId, url) {
        try {
            await this.attachmentsService.deleteAttachment(transactionId, attachmentId, url);
            this.removeAttachment(attachmentId);
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsManager", "Delete attachment failed", e);
            throw e;
        }
    }
    async getContent(transactionId, attachmentId, url) {
        try {
            return await this.attachmentsService.getContent(transactionId, attachmentId, url);
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsManager", "Get content attachment failed", e);
            throw e;
        }
    }
}

});
parcelRegister("eHurR", function(module, exports) {

$parcel$export(module.exports, "getUrlFromLink", function () { return $7b3c0d5ee88e48ea$export$d8507c8e693a500; });
const $7b3c0d5ee88e48ea$export$d8507c8e693a500 = (links, relLink)=>{
    if (!links) return undefined;
    const index = links.findIndex((link)=>link.rel === relLink);
    if (index > -1) return links[index].href;
    else return undefined;
};

});

parcelRegister("93CAX", function(module, exports) {

$parcel$export(module.exports, "AttachmentsLinks", function () { return $7a01b71ecf26a660$export$da9566608f97f0c9; });
var $7a01b71ecf26a660$export$da9566608f97f0c9 = /*#__PURE__*/ function(AttachmentsLinks) {
    AttachmentsLinks["GetContent"] = "getContent";
    AttachmentsLinks["GetPreview"] = "getPreview";
    AttachmentsLinks["Delete"] = "deleteAttachment";
    AttachmentsLinks["AddAnother"] = "addAttachmentOnSameTransaction";
    return AttachmentsLinks;
}({});

});


parcelRegister("dKwzC", function(module, exports) {

$parcel$export(module.exports, "AttachmentsService", function () { return $d3b1301ed7ff7187$export$c5fb745ef932bbbd; });

var $b0kMB = parcelRequire("b0kMB");

var $6JVVB = parcelRequire("6JVVB");
class $d3b1301ed7ff7187$export$c5fb745ef932bbbd {
    constructor(apiService){
        this.apiService = apiService;
    }
    async addAttachment(transactionId, content, description, url) {
        try {
            const response = await this.apiService.instance.post(url ?? `/transactions/${transactionId}/attachments`, {
                content: content,
                description: description
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsService", "Add attachment failed", e?.response?.data?.error?.message);
            throw e;
        }
    }
    async getAttachments(transactionId, url) {
        try {
            const response = await this.apiService.instance.get(url ?? `/transactions/${transactionId}/attachments`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsService", "Get attachments failed", e);
            throw e;
        }
    }
    async deleteAttachment(transactionId, attachmentId, url) {
        try {
            await this.apiService.instance.delete(url ?? `/transactions/${transactionId}/attachments/${attachmentId}`);
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsService", "Delete attachment failed", e);
            throw e;
        }
    }
    async getContent(transactionId, attachmentId, url) {
        try {
            const response = await this.apiService.instance.get(url ?? `/transactions/${transactionId}/attachments/${attachmentId}/content`, {
                responseType: "arraybuffer"
            });
            if (response) {
                const contentType = response.headers["content-type"];
                const base64 = (0, $b0kMB.Buffer).from(response.data, "binary").toString("base64");
                return {
                    contentType: contentType,
                    base64Img: base64,
                    content: response.data
                };
            }
            return null;
        } catch (e) {
            (0, $6JVVB.logger).debug("AttachmentsService", "Get content failed", e);
            throw e;
        }
    }
}

});

parcelRegister("h74Ih", function(module, exports) {

$parcel$export(module.exports, "CategorizationsManager", function () { return $16faa4e20e44a106$export$ab196f3a9879c38d; });

var $6JVVB = parcelRequire("6JVVB");

var $fsofG = parcelRequire("fsofG");
class $16faa4e20e44a106$export$ab196f3a9879c38d {
    constructor(categorizationsService){
        this.categorizationsService = categorizationsService;
        this.categories = new (0, $fsofG.ObservableArray)([]);
        this.additionalData = new (0, $fsofG.ObservableArray)([]);
    }
    async load(forceReload = false) {
        try {
            if (this.categories.get().length == 0 || forceReload) {
                const categories = await this.categorizationsService.getCategories();
                this.categories.set(categories);
            }
            if (this.additionalData.get().length == 0 || forceReload) {
                const additionalData = await this.categorizationsService.getAdditionalData();
                this.additionalData.set(additionalData);
            }
        } catch (e) {
            (0, $6JVVB.logger).debug("CategorizationsManager", "Failed to load", e);
            throw e;
        }
    }
}

});

parcelRegister("ku1xA", function(module, exports) {

$parcel$export(module.exports, "CategorizationsService", function () { return $d9fb0f03affb5814$export$f3eb521c5ed43ae4; });

var $6JVVB = parcelRequire("6JVVB");
class $d9fb0f03affb5814$export$f3eb521c5ed43ae4 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async getCategories() {
        try {
            const response = await this.apiService.instance.get("/spendings-categorization/categories");
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsService", "Get categories failed", e);
            throw e;
        }
    }
    async getAdditionalData() {
        try {
            const response = await this.apiService.instance.get("/spendings-categorization/available-additional-data");
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsService", "Get additional data failed", e);
            throw e;
        }
    }
}

});

parcelRegister("bGEKX", function(module, exports) {

$parcel$export(module.exports, "SpendingsManager", function () { return $7d8d30180738725a$export$16f4a6f18ad8d092; });

var $6JVVB = parcelRequire("6JVVB");

var $fsofG = parcelRequire("fsofG");
class $7d8d30180738725a$export$16f4a6f18ad8d092 {
    constructor(spendingsService){
        this.spendingsService = spendingsService;
        this.spendings = new (0, $fsofG.ObservableArray)([]);
    }
    clear() {
        this.spendings.set([]);
    }
    removeSpending(spendingId) {
        this.spendings.set(this.spendings.get().filter((spending)=>spending.id !== spendingId));
    }
    async addSpendingDetails(transactionId, detailedSpending, url) {
        return await this.spendingsService.addDetailedSpending(transactionId, detailedSpending, url);
    }
    async refresh(transactionId, url) {
        try {
            this.clear();
            const updatedSpendings = await this.spendingsService.getSpendingDetails(transactionId, url);
            this.spendings.set(updatedSpendings);
            return updatedSpendings;
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsManager", "Refresh spending details failed", e);
            throw e;
        }
    }
    async updateSpendingDetails(transactionId, spendingId, detailedSpending, url) {
        try {
            return await this.spendingsService.updateSpendingDetails(transactionId, spendingId, detailedSpending, url);
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsManager", "Update spending details failed", e);
            throw e;
        }
    }
    async deleteSpendingDetails(transactionId, spendingId, url) {
        try {
            await this.spendingsService.deleteSpendingDetails(transactionId, spendingId, url);
            this.removeSpending(spendingId);
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsManager", "Delete spending details failed", e);
            throw e;
        }
    }
}

});

parcelRegister("kL9gD", function(module, exports) {

$parcel$export(module.exports, "SpendingsService", function () { return $ffa3c769b3a86c0c$export$5fab7fb2b363ae10; });

var $6JVVB = parcelRequire("6JVVB");
class $ffa3c769b3a86c0c$export$5fab7fb2b363ae10 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async getSpendingDetails(transactionId, url) {
        try {
            const response = await this.apiService.instance.get(url ?? `/transactions/${transactionId}/spendings`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsService", "Get spending details failed", JSON.stringify(e));
            throw e;
        }
    }
    async addDetailedSpending(transactionId, detailedSpending, url) {
        try {
            const response = await this.apiService.instance.post(url ?? `/transactions/${transactionId}/spendings`, detailedSpending);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsService", "Add detailed spending failed", e);
            if (e?.response?.status === 403 && e?.response?.data?.error?.code === 71404) throw e?.response?.data?.error?.message;
            else throw undefined;
        }
    }
    async updateSpendingDetails(transactionId, spendingId, detailedSpending, url) {
        try {
            const response = await this.apiService.instance.patch(url ?? `/transactions/${transactionId}/spendings/${spendingId}`, detailedSpending);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsService", "Updated detailed spending failed", e);
            throw e?.response?.data?.error?.message;
        }
    }
    async deleteSpendingDetails(transactionId, spendingId, url) {
        try {
            await this.apiService.instance.delete(url ?? `/transactions/${transactionId}/spendings/${spendingId}`);
        } catch (e) {
            (0, $6JVVB.logger).debug("SpendingsService", "Delete detailed spending failed", e);
            throw e;
        }
    }
}

});

parcelRegister("4DBys", function(module, exports) {

$parcel$export(module.exports, "TransactionManager", function () { return $feb7cef05f09d35c$export$6cfe42a1ca6a97cb; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");
class $feb7cef05f09d35c$export$6cfe42a1ca6a97cb {
    constructor(transactionService){
        this.transactionService = transactionService;
        this.transaction = new (0, $3Ersk.Observable)(undefined);
    }
    clear() {
        this.transaction.set(undefined);
    }
    async fetch(accountId, transactionId) {
        try {
            const transaction = await this.transactionService.fetchTransaction(accountId, transactionId);
            this.transaction.set(transaction);
        } catch (e) {
            (0, $6JVVB.logger).debug("TransactionManager", "Fetch transaction failed", e);
            throw e;
        }
    }
}

});

parcelRegister("2Gwkh", function(module, exports) {

$parcel$export(module.exports, "TransactionService", function () { return $6aa8197686b8d1ed$export$985c8653d1398450; });

var $8xKCH = parcelRequire("8xKCH");

var $6JVVB = parcelRequire("6JVVB");

var $1kIeb = parcelRequire("1kIeb");

var $ixrkn = parcelRequire("ixrkn");

var $ao7HR = parcelRequire("ao7HR");
class $6aa8197686b8d1ed$export$985c8653d1398450 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchTransaction(accountId, transactionId) {
        try {
            const response = await this.apiService.instance.get("/transactions", {
                params: {
                    accountId: accountId,
                    id: transactionId
                }
            });
            return response.data.items && response.data.items.length ? response.data.items[0] : {};
        } catch (e) {
            (0, $6JVVB.logger).debug("TransactionService", "Fetch transactions failed", JSON.stringify(e));
            throw e;
        }
    }
    async fetchTransactions(accountId, pagination, direction, filter) {
        try {
            const response = await this.apiService.instance.get("/transactions", {
                params: {
                    accountId: accountId,
                    ...pagination,
                    ...this.directionParams(direction),
                    ...this.filterParam(filter)
                }
            });
            return {
                ...response.data,
                items: response.data.items.map((transaction)=>({
                        ...transaction,
                        objectType: (0, $ixrkn.AccountingTransactionType).Transaction
                    }))
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("TransactionService", "Fetch transactions failed", JSON.stringify(e));
            throw e;
        }
    }
    directionParams(filter) {
        switch(filter){
            case (0, $ao7HR.TransactionDirection).ALL:
                return undefined;
            case (0, $ao7HR.TransactionDirection).INCOME:
                return {
                    direction: "credit"
                };
            case (0, $ao7HR.TransactionDirection).OUTCOME:
                return {
                    direction: "debit"
                };
            default:
                return undefined;
        }
    }
    filterParam(filter) {
        if (!filter) return {};
        let params = {};
        const [startDate, endDate] = filter.timerange.bounds;
        if (startDate && endDate) {
            const { startDate: adjustedStartDate, endDate: adjustedEndDate } = (0, $1kIeb.adjustDateRange)(startDate, endDate);
            params = {
                ...params,
                startDate: adjustedStartDate,
                endDate: adjustedEndDate
            };
        }
        const [minAmount, maxAmount] = filter.amountRange;
        const decimalNumber = filter.currencyId ? (0, $8xKCH.Currencies)[filter.currencyId].decimal_number : 0;
        if (minAmount !== null) params = {
            ...params,
            minAmount: minAmount * Math.pow(10, decimalNumber)
        };
        if (maxAmount !== null) params = {
            ...params,
            maxAmount: maxAmount * Math.pow(10, decimalNumber)
        };
        if (filter.hasOwnProperty("isQualified")) params = {
            ...params,
            isQualified: filter.isQualified
        };
        if (filter.hasOwnProperty("isJustified")) params = {
            ...params,
            isJustified: filter.isJustified
        };
        if (filter.hasOwnProperty("isLocked")) params = {
            ...params,
            isLocked: filter.isLocked
        };
        if (filter.hasOwnProperty("direction")) params = {
            ...params,
            direction: filter.direction
        };
        return params;
    }
}

});
parcelRegister("8xKCH", function(module, exports) {

$parcel$export(module.exports, "Currencies", function () { return $3bedd787f03c1bfb$export$330f51eee3728a4c; });
$parcel$export(module.exports, "COUNTRY_CURRENCIES", function () { return $3bedd787f03c1bfb$export$5c07011fe780a1c4; });
const $3bedd787f03c1bfb$export$330f51eee3728a4c = {
    ALL: {
        name: "Lek",
        iso_numeric: "008",
        iso_alpha: "ALL",
        decimal_number: 2,
        symbol: "ALL"
    },
    DZD: {
        name: "Algerian Dinar",
        iso_numeric: "012",
        iso_alpha: "DZD",
        decimal_number: 2,
        symbol: "DZD"
    },
    ARS: {
        name: "Argentine Peso",
        iso_numeric: "032",
        iso_alpha: "ARS",
        decimal_number: 2,
        symbol: "ARS"
    },
    AUD: {
        name: "Australian Dollar",
        iso_numeric: "036",
        iso_alpha: "AUD",
        decimal_number: 2,
        symbol: "AUD"
    },
    BSD: {
        name: "Bahamian Dollar",
        iso_numeric: "044",
        iso_alpha: "BSD",
        decimal_number: 2,
        symbol: "BSD"
    },
    BHD: {
        name: "Bahraini Dinar",
        iso_numeric: "048",
        iso_alpha: "BHD",
        decimal_number: 3,
        symbol: "BHD"
    },
    BDT: {
        name: "Taka",
        iso_numeric: "050",
        iso_alpha: "BDT",
        decimal_number: 2,
        symbol: "Tk"
    },
    AMD: {
        name: "Armenian Dram",
        iso_numeric: "051",
        iso_alpha: "AMD",
        decimal_number: 2,
        symbol: "AMD"
    },
    BBD: {
        name: "Barbados Dollar",
        iso_numeric: "052",
        iso_alpha: "BBD",
        decimal_number: 2,
        symbol: "BBD"
    },
    BMD: {
        name: "Bermudian Dollar",
        iso_numeric: "060",
        iso_alpha: "BMD",
        decimal_number: 2,
        symbol: "BMD"
    },
    BTN: {
        name: "Ngultrum",
        iso_numeric: "064",
        iso_alpha: "BTN",
        decimal_number: 2,
        symbol: "BTN"
    },
    BOB: {
        name: "Boliviano",
        iso_numeric: "068",
        iso_alpha: "BOB",
        decimal_number: 2,
        symbol: "BOB"
    },
    BWP: {
        name: "Pula",
        iso_numeric: "072",
        iso_alpha: "BWP",
        decimal_number: 2,
        symbol: "BWP"
    },
    BZD: {
        name: "Belize Dollar",
        iso_numeric: "084",
        iso_alpha: "BZD",
        decimal_number: 2,
        symbol: "BZD"
    },
    SBD: {
        name: "Solomon Islands Dollar",
        iso_numeric: "090",
        iso_alpha: "SBD",
        decimal_number: 2,
        symbol: "SBD"
    },
    BND: {
        name: "Brunei Dollar",
        iso_numeric: "096",
        iso_alpha: "BND",
        decimal_number: 2,
        symbol: "BND"
    },
    MMK: {
        name: "Kyat",
        iso_numeric: "104",
        iso_alpha: "MMK",
        decimal_number: 2,
        symbol: "MMK"
    },
    BIF: {
        name: "Burundi Franc",
        iso_numeric: "108",
        iso_alpha: "BIF",
        decimal_number: 0,
        symbol: "BIF"
    },
    KHR: {
        name: "Riel",
        iso_numeric: "116",
        iso_alpha: "KHR",
        decimal_number: 2,
        symbol: "KHR"
    },
    CAD: {
        name: "Canadian Dollar",
        iso_numeric: "124",
        iso_alpha: "CAD",
        decimal_number: 2,
        symbol: "CAD"
    },
    CVE: {
        name: "Cabo Verde Escudo",
        iso_numeric: "132",
        iso_alpha: "CVE",
        decimal_number: 2,
        symbol: "CVE"
    },
    KYD: {
        name: "Cayman Islands Dollar",
        iso_numeric: "136",
        iso_alpha: "KYD",
        decimal_number: 2,
        symbol: "KYD"
    },
    LKR: {
        name: "Sri Lanka Rupee",
        iso_numeric: "144",
        iso_alpha: "LKR",
        decimal_number: 2,
        symbol: "LKR"
    },
    CLP: {
        name: "Chilean Peso",
        iso_numeric: "152",
        iso_alpha: "CLP",
        decimal_number: 0,
        symbol: "CLP"
    },
    CNY: {
        name: "Yuan Renminbi",
        iso_numeric: "156",
        iso_alpha: "CNY",
        decimal_number: 2,
        symbol: "CNY"
    },
    COP: {
        name: "Colombian Peso",
        iso_numeric: "170",
        iso_alpha: "COP",
        decimal_number: 2,
        symbol: "COP"
    },
    KMF: {
        name: "Comorian Franc",
        iso_numeric: "174",
        iso_alpha: "KMF",
        decimal_number: 0,
        symbol: "KMF"
    },
    CRC: {
        name: "Colon CostaRica",
        iso_numeric: "188",
        iso_alpha: "CRC",
        decimal_number: 0,
        symbol: "CRC"
    },
    HRK: {
        name: "Croatian Kuna",
        iso_numeric: "191",
        iso_alpha: "HRK",
        decimal_number: 2,
        symbol: "HRK"
    },
    CUP: {
        name: "Cuban Peso",
        iso_numeric: "192",
        iso_alpha: "CUP",
        decimal_number: 2,
        symbol: "CUP"
    },
    CZK: {
        name: "Czech Koruna",
        iso_numeric: "203",
        iso_alpha: "CZK",
        decimal_number: 2,
        symbol: "CZK"
    },
    DKK: {
        name: "Danish Krone",
        iso_numeric: "208",
        iso_alpha: "DKK",
        decimal_number: 2,
        symbol: "DKK"
    },
    DOP: {
        name: "Dominican Peso",
        iso_numeric: "214",
        iso_alpha: "DOP",
        decimal_number: 2,
        symbol: "DOP"
    },
    SVC: {
        name: "El Salvador Colon",
        iso_numeric: "222",
        iso_alpha: "SVC",
        decimal_number: 2,
        symbol: "SVC"
    },
    ETB: {
        name: "Ethiopian Birr",
        iso_numeric: "230",
        iso_alpha: "ETB",
        decimal_number: 2,
        symbol: "ETB"
    },
    ERN: {
        name: "Nakfa",
        iso_numeric: "232",
        iso_alpha: "ERN",
        decimal_number: 2,
        symbol: "ERN"
    },
    FKP: {
        name: "Falkland Islands Pound",
        iso_numeric: "238",
        iso_alpha: "FKP",
        decimal_number: 2,
        symbol: "FKP"
    },
    FJD: {
        name: "Fiji Dollar",
        iso_numeric: "242",
        iso_alpha: "FJD",
        decimal_number: 2,
        symbol: "FJD"
    },
    DJF: {
        name: "Djibouti Franc",
        iso_numeric: "262",
        iso_alpha: "DJF",
        decimal_number: 0,
        symbol: "DJF"
    },
    GMD: {
        name: "Dalasi",
        iso_numeric: "270",
        iso_alpha: "GMD",
        decimal_number: 2,
        symbol: "GMD"
    },
    GIP: {
        name: "Gibraltar Pound",
        iso_numeric: "292",
        iso_alpha: "GIP",
        decimal_number: 2,
        symbol: "GIP"
    },
    GTQ: {
        name: "Quetzal",
        iso_numeric: "320",
        iso_alpha: "GTQ",
        decimal_number: 2,
        symbol: "GTQ"
    },
    GNF: {
        name: "Guinea Franc",
        iso_numeric: "324",
        iso_alpha: "GNF",
        decimal_number: 0,
        symbol: "GNF"
    },
    GYD: {
        name: "Guyana Dollar",
        iso_numeric: "328",
        iso_alpha: "GYD",
        decimal_number: 2,
        symbol: "GYD"
    },
    HTG: {
        name: "Gourde",
        iso_numeric: "332",
        iso_alpha: "HTG",
        decimal_number: 0,
        symbol: "HTG"
    },
    HNL: {
        name: "Lempira",
        iso_numeric: "340",
        iso_alpha: "HNL",
        decimal_number: 2,
        symbol: "HNL"
    },
    HKD: {
        name: "Hong Kong Dollar",
        iso_numeric: "344",
        iso_alpha: "HKD",
        decimal_number: 2,
        symbol: "HKD"
    },
    HUF: {
        name: "Forint",
        iso_numeric: "348",
        iso_alpha: "HUF",
        decimal_number: 2,
        symbol: "HUF"
    },
    ISK: {
        name: "Iceland Krona",
        iso_numeric: "352",
        iso_alpha: "ISK",
        decimal_number: 0,
        symbol: "ISK"
    },
    INR: {
        name: "Indian Rupee",
        iso_numeric: "356",
        iso_alpha: "INR",
        decimal_number: 0,
        symbol: "Rs "
    },
    IDR: {
        name: "Indonesian rupiah",
        iso_numeric: "360",
        iso_alpha: "IDR",
        decimal_number: 0,
        symbol: "Rp"
    },
    IRR: {
        name: "Iranian Rial",
        iso_numeric: "364",
        iso_alpha: "IRR",
        decimal_number: 2,
        symbol: "IRR"
    },
    IQD: {
        name: "Iraqi Dinar",
        iso_numeric: "368",
        iso_alpha: "IQD",
        decimal_number: 3,
        symbol: "IQD"
    },
    ILS: {
        name: "New Israeli Sheqel",
        iso_numeric: "376",
        iso_alpha: "ILS",
        decimal_number: 2,
        symbol: "ILS"
    },
    JMD: {
        name: "Jamaican Dollar",
        iso_numeric: "388",
        iso_alpha: "JMD",
        decimal_number: 2,
        symbol: "JMD"
    },
    JPY: {
        name: "Yen",
        iso_numeric: "392",
        iso_alpha: "JPY",
        decimal_number: 0,
        symbol: "JPY"
    },
    KZT: {
        name: "Tenge",
        iso_numeric: "398",
        iso_alpha: "KZT",
        decimal_number: 2,
        symbol: "KZT"
    },
    JOD: {
        name: "Jordanian Dinar",
        iso_numeric: "400",
        iso_alpha: "JOD",
        decimal_number: 3,
        symbol: "JOD"
    },
    KES: {
        name: "Shilling Kenyan",
        iso_numeric: "404",
        iso_alpha: "KES",
        decimal_number: 2,
        symbol: "Ksh"
    },
    KPW: {
        name: "North Korean Won",
        iso_numeric: "408",
        iso_alpha: "KPW",
        decimal_number: 2,
        symbol: "KPW"
    },
    KRW: {
        name: "Won",
        iso_numeric: "410",
        iso_alpha: "KRW",
        decimal_number: 0,
        symbol: "KRW"
    },
    KWD: {
        name: "Kuwaiti Dinar",
        iso_numeric: "414",
        iso_alpha: "KWD",
        decimal_number: 3,
        symbol: "KWD"
    },
    KGS: {
        name: "Kyrgyzstani som",
        iso_numeric: "417",
        iso_alpha: "KGS",
        decimal_number: 2,
        symbol: "KGS"
    },
    LAK: {
        name: "Kip",
        iso_numeric: "418",
        iso_alpha: "LAK",
        decimal_number: 2,
        symbol: "LAK"
    },
    LBP: {
        name: "Lebanese Pound",
        iso_numeric: "422",
        iso_alpha: "LBP",
        decimal_number: 2,
        symbol: "LBP"
    },
    LSL: {
        name: "Loti",
        iso_numeric: "426",
        iso_alpha: "LSL",
        decimal_number: 2,
        symbol: "LSL"
    },
    LRD: {
        name: "Liberian Dollar",
        iso_numeric: "430",
        iso_alpha: "LRD",
        decimal_number: 2,
        symbol: "LRD"
    },
    LYD: {
        name: "Libyan Dinar",
        iso_numeric: "434",
        iso_alpha: "LYD",
        decimal_number: 3,
        symbol: "LYD"
    },
    MOP: {
        name: "Pataca",
        iso_numeric: "446",
        iso_alpha: "MOP",
        decimal_number: 2,
        symbol: "MOP"
    },
    MWK: {
        name: "Kwacha",
        iso_numeric: "454",
        iso_alpha: "MWK",
        decimal_number: 2,
        symbol: "MWK"
    },
    MYR: {
        name: "Malaysian Ringgit",
        iso_numeric: "458",
        iso_alpha: "MYR",
        decimal_number: 2,
        symbol: "MYR"
    },
    MVR: {
        name: "Rufiyaa",
        iso_numeric: "462",
        iso_alpha: "MVR",
        decimal_number: 2,
        symbol: "MVR"
    },
    MRO: {
        name: "Ouguiya",
        iso_numeric: "478",
        iso_alpha: "MRO",
        decimal_number: 2,
        symbol: "MRO"
    },
    MRU: {
        name: "Ouguiya",
        iso_numeric: "929",
        iso_alpha: "MRU",
        decimal_number: 2,
        symbol: "MRU"
    },
    MUR: {
        name: "Mauritius Rupee",
        iso_numeric: "480",
        iso_alpha: "MUR",
        decimal_number: 2,
        symbol: "MUR"
    },
    MXN: {
        name: "Mexican Peso",
        iso_numeric: "484",
        iso_alpha: "MXN",
        decimal_number: 2,
        symbol: "MXN"
    },
    MNT: {
        name: "Tugrik",
        iso_numeric: "496",
        iso_alpha: "MNT",
        decimal_number: 2,
        symbol: "MNT"
    },
    MDL: {
        name: "Moldovan Leu",
        iso_numeric: "498",
        iso_alpha: "MDL",
        decimal_number: 2,
        symbol: "MDL"
    },
    MAD: {
        name: "Moroccan Dirham",
        iso_numeric: "504",
        iso_alpha: "MAD",
        decimal_number: 2,
        symbol: "MAD"
    },
    OMR: {
        name: "Rial Omani",
        iso_numeric: "512",
        iso_alpha: "OMR",
        decimal_number: 3,
        symbol: "OMR"
    },
    NAD: {
        name: "Dollar Namibia",
        iso_numeric: "516",
        iso_alpha: "NAD",
        decimal_number: 2,
        symbol: "N$"
    },
    NPR: {
        name: "Nepalese Rupee",
        iso_numeric: "524",
        iso_alpha: "NPR",
        decimal_number: 2,
        symbol: "NPR"
    },
    ANG: {
        name: "Netherlands Antillean Guilder",
        iso_numeric: "532",
        iso_alpha: "ANG",
        decimal_number: 2,
        symbol: "ANG"
    },
    AWG: {
        name: "Aruban Florin",
        iso_numeric: "533",
        iso_alpha: "AWG",
        decimal_number: 2,
        symbol: "AWG"
    },
    VUV: {
        name: "Vatu",
        iso_numeric: "548",
        iso_alpha: "VUV",
        decimal_number: 0,
        symbol: "VUV"
    },
    NZD: {
        name: "New Zealand Dollar",
        iso_numeric: "554",
        iso_alpha: "NZD",
        decimal_number: 2,
        symbol: "NZD"
    },
    NIO: {
        name: "Nicaraguan c\u00f3rdoba",
        iso_numeric: "558",
        iso_alpha: "NIO",
        decimal_number: 2,
        symbol: "C$"
    },
    NGN: {
        name: "Nigeria Naira",
        iso_numeric: "566",
        iso_alpha: "NGN",
        decimal_number: 2,
        symbol: "NGN"
    },
    NOK: {
        name: "Norwegian Krone",
        iso_numeric: "578",
        iso_alpha: "NOK",
        decimal_number: 2,
        symbol: "NOK"
    },
    PKR: {
        name: "Pakistani Rupee",
        iso_numeric: "586",
        iso_alpha: "PKR",
        decimal_number: 0,
        symbol: "Rs "
    },
    PAB: {
        name: "Balboa",
        iso_numeric: "590",
        iso_alpha: "PAB",
        decimal_number: 2,
        symbol: "PAB"
    },
    PGK: {
        name: "Kina",
        iso_numeric: "598",
        iso_alpha: "PGK",
        decimal_number: 2,
        symbol: "PGK"
    },
    PYG: {
        name: "Guarani",
        iso_numeric: "600",
        iso_alpha: "PYG",
        decimal_number: 0,
        symbol: "PYG"
    },
    PEN: {
        name: "Nuevo Sol",
        iso_numeric: "604",
        iso_alpha: "PEN",
        decimal_number: 2,
        symbol: "PEN"
    },
    PHP: {
        name: "Philippine Peso",
        iso_numeric: "608",
        iso_alpha: "PHP",
        decimal_number: 2,
        symbol: "PHP"
    },
    QAR: {
        name: "Qatari Rial",
        iso_numeric: "634",
        iso_alpha: "QAR",
        decimal_number: 2,
        symbol: "QAR"
    },
    RUB: {
        name: "Russian Ruble",
        iso_numeric: "643",
        iso_alpha: "RUB",
        decimal_number: 2,
        symbol: "RUB"
    },
    RWF: {
        name: "Franc Rwandais",
        iso_numeric: "646",
        iso_alpha: "RWF",
        decimal_number: 2,
        symbol: "RWF"
    },
    SHP: {
        name: "Saint Helena Pound",
        iso_numeric: "654",
        iso_alpha: "SHP",
        decimal_number: 2,
        symbol: "SHP"
    },
    STD: {
        name: "Dobra",
        iso_numeric: "678",
        iso_alpha: "STD",
        decimal_number: 2,
        symbol: "STD"
    },
    SAR: {
        name: "Saudi Riyal",
        iso_numeric: "682",
        iso_alpha: "SAR",
        decimal_number: 2,
        symbol: "SAR"
    },
    SCR: {
        name: "Seychelles Rupee",
        iso_numeric: "690",
        iso_alpha: "SCR",
        decimal_number: 2,
        symbol: "SCR"
    },
    SLL: {
        name: "Leone",
        iso_numeric: "694",
        iso_alpha: "SLL",
        decimal_number: 2,
        symbol: "SLL"
    },
    SGD: {
        name: "Singapore Dollar",
        iso_numeric: "702",
        iso_alpha: "SGD",
        decimal_number: 2,
        symbol: "S$"
    },
    VND: {
        name: "Vietnam dong",
        iso_numeric: "704",
        iso_alpha: "VND",
        decimal_number: 0,
        symbol: "VND"
    },
    SOS: {
        name: "Somali Shilling",
        iso_numeric: "706",
        iso_alpha: "SOS",
        decimal_number: 2,
        symbol: "SOS"
    },
    ZAR: {
        name: "South Africa Rand",
        iso_numeric: "710",
        iso_alpha: "ZAR",
        decimal_number: 2,
        symbol: "R"
    },
    SSP: {
        name: "South Sudanese Pound",
        iso_numeric: "728",
        iso_alpha: "SSP",
        decimal_number: 2,
        symbol: "SSP"
    },
    SZL: {
        name: "Lilangeni",
        iso_numeric: "748",
        iso_alpha: "SZL",
        decimal_number: 2,
        symbol: "SZL"
    },
    SEK: {
        name: "Swedish Krona",
        iso_numeric: "752",
        iso_alpha: "SEK",
        decimal_number: 2,
        symbol: "SEK"
    },
    CHF: {
        name: "Francs Suisse",
        iso_numeric: "756",
        iso_alpha: "CHF",
        decimal_number: 2,
        symbol: "Chf"
    },
    SYP: {
        name: "Syrian Pound",
        iso_numeric: "760",
        iso_alpha: "SYP",
        decimal_number: 2,
        symbol: "SYP"
    },
    THB: {
        name: "Baht",
        iso_numeric: "764",
        iso_alpha: "THB",
        decimal_number: 2,
        symbol: "THB"
    },
    TOP: {
        name: "Pa\u2019anga",
        iso_numeric: "776",
        iso_alpha: "TOP",
        decimal_number: 2,
        symbol: "TOP"
    },
    TTD: {
        name: "Trinidad and Tobago Dollar",
        iso_numeric: "780",
        iso_alpha: "TTD",
        decimal_number: 2,
        symbol: "TTD"
    },
    AED: {
        name: "UAE Dirham",
        iso_numeric: "784",
        iso_alpha: "AED",
        decimal_number: 2,
        symbol: "AED"
    },
    TND: {
        name: "Tunisian Dinar",
        iso_numeric: "788",
        iso_alpha: "TND",
        decimal_number: 3,
        symbol: "TND"
    },
    UGX: {
        name: "Uganda Shilling",
        iso_numeric: "800",
        iso_alpha: "UGX",
        decimal_number: 0,
        symbol: "UGX"
    },
    MKD: {
        name: "Denar",
        iso_numeric: "807",
        iso_alpha: "MKD",
        decimal_number: 2,
        symbol: "MKD"
    },
    EGP: {
        name: "Egyptian Pound",
        iso_numeric: "818",
        iso_alpha: "EGP",
        decimal_number: 2,
        symbol: "\xa3"
    },
    GBP: {
        name: "Pound sterling",
        iso_numeric: "826",
        iso_alpha: "GBP",
        decimal_number: 2,
        symbol: "\xa3"
    },
    TZS: {
        name: "Tanzanian Shilling",
        iso_numeric: "834",
        iso_alpha: "TZS",
        decimal_number: 2,
        symbol: "TZS"
    },
    USD: {
        name: "Dollar",
        iso_numeric: "840",
        iso_alpha: "USD",
        decimal_number: 2,
        symbol: "$"
    },
    UYU: {
        name: "Peso Uruguayo",
        iso_numeric: "858",
        iso_alpha: "UYU",
        decimal_number: 2,
        symbol: "UYU"
    },
    UZS: {
        name: "Uzbekistan Sum",
        iso_numeric: "860",
        iso_alpha: "UZS",
        decimal_number: 2,
        symbol: "UZS"
    },
    WST: {
        name: "Tala",
        iso_numeric: "882",
        iso_alpha: "WST",
        decimal_number: 2,
        symbol: "WST"
    },
    YER: {
        name: "Yemeni Rial",
        iso_numeric: "886",
        iso_alpha: "YER",
        decimal_number: 2,
        symbol: "YER"
    },
    ZMK: {
        name: "Kwacha",
        iso_numeric: "894",
        iso_alpha: "ZMK",
        decimal_number: 0,
        symbol: "ZMK"
    },
    TWD: {
        name: "New Taiwan Dollar",
        iso_numeric: "901",
        iso_alpha: "TWD",
        decimal_number: 2,
        symbol: "TWD"
    },
    CUC: {
        name: "Peso Convertible",
        iso_numeric: "931",
        iso_alpha: "CUC",
        decimal_number: 2,
        symbol: "CUC"
    },
    ZWL: {
        name: "Zimbabwe Dollar",
        iso_numeric: "932",
        iso_alpha: "ZWL",
        decimal_number: 2,
        symbol: "ZWL"
    },
    TMT: {
        name: "Turkmenistan New Manat",
        iso_numeric: "934",
        iso_alpha: "TMT",
        decimal_number: 2,
        symbol: "TMT"
    },
    GHS: {
        name: "Ghana Cedi",
        iso_numeric: "936",
        iso_alpha: "GHS",
        decimal_number: 2,
        symbol: "GHS"
    },
    VEF: {
        name: "Bolivar",
        iso_numeric: "937",
        iso_alpha: "VEF",
        decimal_number: 2,
        symbol: "VEF"
    },
    SDG: {
        name: "Sudanese Pound",
        iso_numeric: "938",
        iso_alpha: "SDG",
        decimal_number: 2,
        symbol: "SDG"
    },
    UYI: {
        name: "Uruguay Peso en Unidades Indexadas (URUIURUI)",
        iso_numeric: "940",
        iso_alpha: "UYI",
        decimal_number: 0,
        symbol: "UYI"
    },
    RSD: {
        name: "Serbian Dinar",
        iso_numeric: "941",
        iso_alpha: "RSD",
        decimal_number: 2,
        symbol: "RSD"
    },
    MZN: {
        name: "Mozambique Metical",
        iso_numeric: "943",
        iso_alpha: "MZN",
        decimal_number: 2,
        symbol: "MZN"
    },
    AZN: {
        name: "Azerbaijanian Manat",
        iso_numeric: "944",
        iso_alpha: "AZN",
        decimal_number: 2,
        symbol: "AZN"
    },
    RON: {
        name: "New Romanian Leu",
        iso_numeric: "946",
        iso_alpha: "RON",
        decimal_number: 2,
        symbol: "RON"
    },
    CHE: {
        name: "WIR Euro",
        iso_numeric: "947",
        iso_alpha: "CHE",
        decimal_number: 2,
        symbol: "CHE"
    },
    CHW: {
        name: "WIR Franc",
        iso_numeric: "948",
        iso_alpha: "CHW",
        decimal_number: 2,
        symbol: "CHW"
    },
    TRY: {
        name: "Turkish Lira",
        iso_numeric: "949",
        iso_alpha: "TRY",
        decimal_number: 2,
        symbol: "TL"
    },
    XAF: {
        name: "CFA Franc BEAC",
        iso_numeric: "950",
        iso_alpha: "XAF",
        decimal_number: 0,
        symbol: "XAF"
    },
    XCD: {
        name: "East Caribbean Dollar",
        iso_numeric: "951",
        iso_alpha: "XCD",
        decimal_number: 2,
        symbol: "XCD"
    },
    XOF: {
        name: "Franc CFA",
        iso_numeric: "952",
        iso_alpha: "XOF",
        decimal_number: 0,
        symbol: "FCFA"
    },
    XPF: {
        name: "CFP Franc",
        iso_numeric: "953",
        iso_alpha: "XPF",
        decimal_number: 0,
        symbol: "XPF"
    },
    XBA: {
        name: "Bond Markets Unit European Composite Unit (EURCO)",
        iso_numeric: "955",
        iso_alpha: "XBA",
        decimal_number: 0,
        symbol: "XBA"
    },
    XBB: {
        name: "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
        iso_numeric: "956",
        iso_alpha: "XBB",
        decimal_number: 0,
        symbol: "XBB"
    },
    XBC: {
        name: "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
        iso_numeric: "957",
        iso_alpha: "XBC",
        decimal_number: 0,
        symbol: "XBC"
    },
    XBD: {
        name: "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
        iso_numeric: "958",
        iso_alpha: "XBD",
        decimal_number: 0,
        symbol: "XBD"
    },
    XAU: {
        name: "Gold",
        iso_numeric: "959",
        iso_alpha: "XAU",
        decimal_number: 0,
        symbol: "XAU"
    },
    XDR: {
        name: "SDR (Special Drawing Right)",
        iso_numeric: "960",
        iso_alpha: "XDR",
        decimal_number: 0,
        symbol: "XDR"
    },
    XAG: {
        name: "Silver",
        iso_numeric: "961",
        iso_alpha: "XAG",
        decimal_number: 0,
        symbol: "XAG"
    },
    XPT: {
        name: "Platinum",
        iso_numeric: "962",
        iso_alpha: "XPT",
        decimal_number: 0,
        symbol: "XPT"
    },
    XTS: {
        name: "Codes specifically reserved for testing purposes",
        iso_numeric: "963",
        iso_alpha: "XTS",
        decimal_number: 0,
        symbol: "XTS"
    },
    XPD: {
        name: "Palladium",
        iso_numeric: "964",
        iso_alpha: "XPD",
        decimal_number: 0,
        symbol: "XPD"
    },
    XUA: {
        name: "ADB Unit of Account",
        iso_numeric: "965",
        iso_alpha: "XUA",
        decimal_number: 0,
        symbol: "XUA"
    },
    ZMW: {
        name: "Zambian Kwacha",
        iso_numeric: "967",
        iso_alpha: "ZMW",
        decimal_number: 2,
        symbol: "ZMW"
    },
    SRD: {
        name: "Surinam Dollar",
        iso_numeric: "968",
        iso_alpha: "SRD",
        decimal_number: 2,
        symbol: "SRD"
    },
    MGA: {
        name: "Malagasy Ariary",
        iso_numeric: "969",
        iso_alpha: "MGA",
        decimal_number: 2,
        symbol: "MGA"
    },
    COU: {
        name: "Unidad de Valor Real",
        iso_numeric: "970",
        iso_alpha: "COU",
        decimal_number: 2,
        symbol: "COU"
    },
    AFN: {
        name: "Afghani",
        iso_numeric: "971",
        iso_alpha: "AFN",
        decimal_number: 2,
        symbol: "AFN"
    },
    TJS: {
        name: "Somoni",
        iso_numeric: "972",
        iso_alpha: "TJS",
        decimal_number: 2,
        symbol: "TJS"
    },
    AOA: {
        name: "Kwanza",
        iso_numeric: "973",
        iso_alpha: "AOA",
        decimal_number: 2,
        symbol: "AOA"
    },
    BYR: {
        name: "Belarussian Ruble",
        iso_numeric: "974",
        iso_alpha: "BYR",
        decimal_number: 0,
        symbol: "BYR"
    },
    BGN: {
        name: "Bulgarian Lev",
        iso_numeric: "975",
        iso_alpha: "BGN",
        decimal_number: 2,
        symbol: "BGN"
    },
    CDF: {
        name: "Franc Congolais",
        iso_numeric: "976",
        iso_alpha: "CDF",
        decimal_number: 0,
        symbol: "CDF"
    },
    BAM: {
        name: "Convertible Mark",
        iso_numeric: "977",
        iso_alpha: "BAM",
        decimal_number: 2,
        symbol: "BAM"
    },
    EUR: {
        name: "Euro",
        iso_numeric: "978",
        iso_alpha: "EUR",
        decimal_number: 2,
        symbol: "\u20ac"
    },
    MXV: {
        name: "Mexican Unidad de Inversion (UDI)",
        iso_numeric: "979",
        iso_alpha: "MXV",
        decimal_number: 2,
        symbol: "MXV"
    },
    UAH: {
        name: "Hryvnia",
        iso_numeric: "980",
        iso_alpha: "UAH",
        decimal_number: 2,
        symbol: "UAH"
    },
    GEL: {
        name: "Lari",
        iso_numeric: "981",
        iso_alpha: "GEL",
        decimal_number: 2,
        symbol: "GEL"
    },
    BOV: {
        name: "Mvdol",
        iso_numeric: "984",
        iso_alpha: "BOV",
        decimal_number: 2,
        symbol: "BOV"
    },
    PLN: {
        name: "Zloty",
        iso_numeric: "985",
        iso_alpha: "PLN",
        decimal_number: 2,
        symbol: "PLN"
    },
    BRL: {
        name: "Brazilian Real",
        iso_numeric: "986",
        iso_alpha: "BRL",
        decimal_number: 2,
        symbol: "BRL"
    },
    CLF: {
        name: "Unidad de Fomento",
        iso_numeric: "990",
        iso_alpha: "CLF",
        decimal_number: 4,
        symbol: "CLF"
    },
    XSU: {
        name: "Sucre",
        iso_numeric: "994",
        iso_alpha: "XSU",
        decimal_number: 0,
        symbol: "XSU"
    },
    USN: {
        name: "US Dollar (Next day)",
        iso_numeric: "997",
        iso_alpha: "USN",
        decimal_number: 2,
        symbol: "USN"
    },
    TAG: {
        name: "TAG$",
        iso_numeric: "999",
        iso_alpha: "TAG",
        decimal_number: 2,
        symbol: "T$"
    }
};
const $3bedd787f03c1bfb$export$5c07011fe780a1c4 = {
    BD: "BDT",
    BE: "EUR",
    BF: "XOF",
    BG: "BGN",
    BA: "BAM",
    BB: "BBD",
    WF: "XPF",
    BL: "EUR",
    BM: "BMD",
    BN: "BND",
    BO: "BOB",
    BH: "BHD",
    BI: "BIF",
    BJ: "XOF",
    BT: "BTN",
    JM: "JMD",
    BV: "NOK",
    BW: "BWP",
    WS: "WST",
    BQ: "USD",
    BR: "BRL",
    BS: "BSD",
    JE: "GBP",
    BY: "BYR",
    BZ: "BZD",
    RU: "RUB",
    RW: "RWF",
    RS: "RSD",
    TL: "USD",
    RE: "EUR",
    TM: "TMT",
    TJ: "TJS",
    RO: "RON",
    TK: "NZD",
    GW: "XOF",
    GU: "USD",
    GT: "GTQ",
    GS: "GBP",
    GR: "EUR",
    GQ: "XAF",
    GP: "EUR",
    JP: "JPY",
    GY: "GYD",
    GG: "GBP",
    GF: "EUR",
    GE: "GEL",
    GD: "XCD",
    GB: "GBP",
    GA: "XAF",
    SV: "USD",
    GN: "GNF",
    GM: "GMD",
    GL: "DKK",
    GI: "GIP",
    GH: "GHS",
    OM: "OMR",
    TN: "TND",
    JO: "JOD",
    HR: "HRK",
    HT: "HTG",
    HU: "HUF",
    HK: "HKD",
    HN: "HNL",
    HM: "AUD",
    VE: "VEF",
    PR: "USD",
    PS: "ILS",
    PW: "USD",
    PT: "EUR",
    SJ: "NOK",
    PY: "PYG",
    IQ: "IQD",
    PA: "PAB",
    PF: "XPF",
    PG: "PGK",
    PE: "PEN",
    PK: "PKR",
    PH: "PHP",
    PN: "NZD",
    PL: "PLN",
    PM: "EUR",
    ZM: "ZMK",
    EH: "MAD",
    EE: "EUR",
    EG: "EGP",
    ZA: "ZAR",
    EC: "USD",
    IT: "EUR",
    VN: "VND",
    SB: "SBD",
    ET: "ETB",
    SO: "SOS",
    ZW: "ZWL",
    SA: "SAR",
    ES: "EUR",
    ER: "ERN",
    ME: "EUR",
    MD: "MDL",
    MG: "MGA",
    MF: "EUR",
    MA: "MAD",
    MC: "EUR",
    UZ: "UZS",
    MM: "MMK",
    ML: "XOF",
    MO: "MOP",
    MN: "MNT",
    MH: "USD",
    MK: "MKD",
    MU: "MUR",
    MT: "EUR",
    MW: "MWK",
    MV: "MVR",
    MQ: "EUR",
    MP: "USD",
    MS: "XCD",
    MR: "MRO",
    IM: "GBP",
    UG: "UGX",
    TZ: "TZS",
    MY: "MYR",
    MX: "MXN",
    IL: "ILS",
    FR: "EUR",
    IO: "USD",
    SH: "SHP",
    FI: "EUR",
    FJ: "FJD",
    FK: "FKP",
    FM: "USD",
    FO: "DKK",
    NI: "NIO",
    NL: "EUR",
    NO: "NOK",
    NA: "NAD",
    VU: "VUV",
    NC: "XPF",
    NE: "XOF",
    NF: "AUD",
    NG: "NGN",
    NZ: "NZD",
    NP: "NPR",
    NR: "AUD",
    NU: "NZD",
    CK: "NZD",
    XK: "EUR",
    CI: "XOF",
    CH: "CHF",
    CO: "COP",
    CN: "CNY",
    CM: "XAF",
    CL: "CLP",
    CC: "AUD",
    CA: "CAD",
    CG: "XAF",
    CF: "XAF",
    CD: "CDF",
    CZ: "CZK",
    CY: "EUR",
    CX: "AUD",
    CR: "CRC",
    CW: "ANG",
    CV: "CVE",
    CU: "CUP",
    SZ: "SZL",
    SY: "SYP",
    SX: "ANG",
    KG: "KGS",
    KE: "KES",
    SS: "SSP",
    SR: "SRD",
    KI: "AUD",
    KH: "KHR",
    KN: "XCD",
    KM: "KMF",
    ST: "STD",
    SK: "EUR",
    KR: "KRW",
    SI: "EUR",
    KP: "KPW",
    KW: "KWD",
    SN: "XOF",
    SM: "EUR",
    SL: "SLL",
    SC: "SCR",
    KZ: "KZT",
    KY: "KYD",
    SG: "SGD",
    SE: "SEK",
    SD: "SDG",
    DO: "DOP",
    DM: "XCD",
    DJ: "DJF",
    DK: "DKK",
    VG: "USD",
    DE: "EUR",
    YE: "YER",
    DZ: "DZD",
    US: "USD",
    UY: "UYU",
    YT: "EUR",
    UM: "USD",
    LB: "LBP",
    LC: "XCD",
    LA: "LAK",
    TV: "AUD",
    TW: "TWD",
    TT: "TTD",
    TR: "TRY",
    LK: "LKR",
    LI: "CHF",
    LV: "EUR",
    TO: "TOP",
    LT: "LTL",
    LU: "EUR",
    LR: "LRD",
    LS: "LSL",
    TH: "THB",
    TF: "EUR",
    TG: "XOF",
    TD: "XAF",
    TC: "USD",
    LY: "LYD",
    VA: "EUR",
    VC: "XCD",
    AE: "AED",
    AD: "EUR",
    AG: "XCD",
    AF: "AFN",
    AI: "XCD",
    VI: "USD",
    IS: "ISK",
    IR: "IRR",
    AM: "AMD",
    AL: "ALL",
    AO: "AOA",
    AS: "USD",
    AR: "ARS",
    AU: "AUD",
    AT: "EUR",
    AW: "AWG",
    IN: "INR",
    AX: "EUR",
    AZ: "AZN",
    IE: "EUR",
    ID: "IDR",
    UA: "UAH",
    QA: "QAR",
    MZ: "MZN"
};

});

parcelRegister("1kIeb", function(module, exports) {

$parcel$export(module.exports, "adjustDateRange", function () { return $1afbeb1e98b28ee1$export$2f2507b576014df2; });

var $l1qT9 = parcelRequire("l1qT9");
function $1afbeb1e98b28ee1$export$2f2507b576014df2(startDate, endDate) {
    const maxEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate).add(3, "months").add(1, "hour");
    if ((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate).isAfter(maxEndDate)) return {
        startDate: startDate.set({
            h: startDate.hour(),
            m: startDate.minutes(),
            s: startDate.seconds()
        }).format(),
        endDate: maxEndDate.set({
            h: maxEndDate.hour(),
            m: maxEndDate.minutes(),
            s: maxEndDate.seconds()
        }).format()
    };
    return {
        startDate: startDate.set({
            h: startDate.hour(),
            m: startDate.minutes(),
            s: startDate.seconds()
        }).format(),
        endDate: endDate.set({
            h: endDate.hour(),
            m: endDate.minutes(),
            s: endDate.seconds()
        }).format()
    };
}

});

parcelRegister("ixrkn", function(module, exports) {

$parcel$export(module.exports, "AccountingTransactionType", function () { return $fe253bcef30223c6$export$df627c6eef217d31; });
var $fe253bcef30223c6$export$df627c6eef217d31 = /*#__PURE__*/ function(AccountingTransactionType) {
    AccountingTransactionType["Transaction"] = "Transaction";
    AccountingTransactionType["AuthorizationHold"] = "AuthorizationHold";
    return AccountingTransactionType;
}({});

});


parcelRegister("ciu8j", function(module, exports) {

$parcel$export(module.exports, "TransactionsManager", function () { return $8e9a99be12d3442c$export$e4f0542db2525170; });

var $ao7HR = parcelRequire("ao7HR");

var $hJYIj = parcelRequire("hJYIj");
class $8e9a99be12d3442c$export$e4f0542db2525170 {
    constructor(accountingTransactionService, authenticationManager, clientManager, cacheLoader){
        this.accountingTransactionService = accountingTransactionService;
        this.authenticationManager = authenticationManager;
        this.clientManager = clientManager;
        this.cacheLoader = cacheLoader;
        this.transactionLoaders = new Map();
        this.defaultTransactionLoader = new (0, $hJYIj.TransactionsLoader)(null, this.accountingTransactionService, this.cacheLoader, (0, $ao7HR.TransactionDirection).ALL);
        this.authenticationManager.isConnected.onChange.add(async (isConnected)=>{
            if (!isConnected) await this.clear();
        });
        this.clientManager.onLanguageChange.add(async ()=>{
            await this.clear();
        });
    }
    getLoaderKey(accountId, transactionDirection = (0, $ao7HR.TransactionDirection).ALL) {
        return `${accountId}_${transactionDirection}`;
    }
    getDefaultLoader() {
        return this.defaultTransactionLoader;
    }
    getSearchTransactionsLoader(accountId, transactionDirection = (0, $ao7HR.TransactionDirection).ALL, transactionFilters) {
        return new (0, $hJYIj.TransactionsLoader)(accountId, this.accountingTransactionService, this.cacheLoader, transactionDirection, transactionFilters);
    }
    getTransactionsLoader(accountId, transactionDirection = (0, $ao7HR.TransactionDirection).ALL) {
        const loaderKey = this.getLoaderKey(accountId, transactionDirection);
        let cache = this.transactionLoaders.get(loaderKey);
        if (!cache) {
            cache = new (0, $hJYIj.TransactionsLoader)(accountId, this.accountingTransactionService, this.cacheLoader, transactionDirection);
            this.transactionLoaders.set(loaderKey, cache);
        }
        return cache;
    }
    async clear() {
        for (const key of this.transactionLoaders.keys())await this.transactionLoaders.get(key)?.clear();
    }
    async refresh(accountIds) {
        for (const accountId of accountIds){
            const loader = this.getTransactionsLoader(accountId);
            await loader.refresh();
        }
    }
}

});
parcelRegister("hJYIj", function(module, exports) {

$parcel$export(module.exports, "TransactionsLoader", function () { return $88a8bba272512fa7$export$c676e30f9982d2f8; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");

var $7yIx1 = parcelRequire("7yIx1");
/** Neutral criteria, so the categorisation queries below can always carry their own filters. */ const $88a8bba272512fa7$var$NO_FILTERS = {
    timerange: {
        timeRange: (0, $7yIx1.TimeRange).Other,
        bounds: [
            null,
            null
        ]
    },
    amountRange: [
        null,
        null
    ],
    currencyId: undefined
};
class $88a8bba272512fa7$export$c676e30f9982d2f8 {
    constructor(accountId, accountingTransactionService, cacheLoader, direction, filters){
        this.accountId = accountId;
        this.accountingTransactionService = accountingTransactionService;
        this.cacheLoader = cacheLoader;
        this.direction = direction;
        this.filters = filters;
        this.data = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.unjustifiedData = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.unqualifiedData = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.cacheStatus = new (0, $3Ersk.Observable)(null);
        this.initializing = new (0, $3Ersk.Observable)(true);
        this.loading = new (0, $3Ersk.Observable)(false);
        this.refreshing = new (0, $3Ersk.Observable)(false);
        this.error = new (0, $3Ersk.Observable)(null);
        this.loadingMore = new (0, $3Ersk.Observable)(false);
        this.loadingMoreError = new (0, $3Ersk.Observable)(null);
        this.isSearchLoader = this.filters ? true : false;
        this.cacheKey = this.isSearchLoader ? `${accountId}_search` : `${accountId}_${this.direction}`;
        // Three different queries: they cannot share one cache entry, or the last two just read
        // back what the first one stored.
        this.unjustifiedCacheKey = `${this.cacheKey}_unjustified`;
        this.unqualifiedCacheKey = `${this.cacheKey}_unqualified`;
    }
    /**
   * Restricts a query to what is still awaiting justification or qualification. These criteria
   * used to be applied only when the loader already had filters, so on the account and home
   * screens both sub-queries were identical to the main one: the "pending" lists and their
   * counters were in fact the whole transaction list, incoming money included.
   */ categorizationFilters(pending) {
        return {
            ...this.filters ?? $88a8bba272512fa7$var$NO_FILTERS,
            [pending]: 0,
            isLocked: 0,
            direction: "debit"
        };
    }
    async load() {
        if (!this.accountId || this.loading.get() || this.refreshing.get()) return;
        this.loading.set(true);
        this.initializing.set(false);
        await this.loadOrRefresh(this.isSearchLoader);
        this.loading.set(false);
    }
    async refresh() {
        if (!this.accountId || this.refreshing.get() || this.loading.get()) return;
        this.refreshing.set(true);
        await this.loadOrRefresh(true);
        this.refreshing.set(false);
    }
    async loadOrRefresh(forceRefresh) {
        if (this.accountId) {
            const accountId = this.accountId;
            try {
                this.error.set(null);
                const transactions = await this.cacheLoader.load(()=>this.accountingTransactionService.fetchTransactions(accountId, undefined, this.direction, this.filters), forceRefresh, this.cacheKey);
                const unjustifiedTransactions = await this.cacheLoader.load(()=>this.accountingTransactionService.fetchTransactions(accountId, undefined, this.direction, this.categorizationFilters("isJustified")), forceRefresh, this.unjustifiedCacheKey);
                const unqualifiedTransactions = await this.cacheLoader.load(()=>this.accountingTransactionService.fetchTransactions(accountId, undefined, this.direction, this.categorizationFilters("isQualified")), forceRefresh, this.unqualifiedCacheKey);
                if (!transactions) throw Error("Failed to fetch transactions");
                if (!unjustifiedTransactions) throw Error("Failed to fetch unjustified transactions");
                if (!unqualifiedTransactions) throw Error("Failed to fetch unqualified transactions");
                await this.updateCacheStatus();
                this.data.set(transactions);
                this.unjustifiedData.set(unjustifiedTransactions);
                this.unqualifiedData.set(unqualifiedTransactions);
            } catch (e) {
                (0, $6JVVB.logger).debug("TransactionsLoader", "Failed to load or refresh transactions", e);
                this.error.set(e);
                this.data.set((0, $lbTbw.createEmptyPaginatedData)());
            }
        }
    }
    async loadMore() {
        if (this.accountId) {
            const accountId = this.accountId;
            if (!this.accountId || this.loading.get() || this.loadingMore.get()) return;
            try {
                this.loadingMore.set(true);
                this.loadingMoreError.set(null);
                const additional = await this.accountingTransactionService.fetchTransactions(accountId, {
                    offset: this.data.get().offset + this.data.get().limit,
                    limit: this.data.get().limit,
                    sort: this.data.get().sort
                }, this.direction, this.filters);
                this.data.add(additional);
                this.cacheLoader.store(this.data.get(), this.cacheStatus.get()?.creation, this.cacheKey);
            } catch (e) {
                (0, $6JVVB.logger).debug("TransactionsLoader", "Failed to load more transactions", e);
                this.loadingMoreError.set(e);
            } finally{
                this.loadingMore.set(false);
            }
        }
    }
    async updateCacheStatus() {
        if (this.accountId) {
            const cacheStatus = await this.cacheLoader.readStatus(this.cacheKey);
            this.cacheStatus.set(cacheStatus);
        }
    }
    async clear() {
        if (this.accountId) {
            await this.cacheLoader.clear(this.cacheKey);
            await this.cacheLoader.clear(this.unjustifiedCacheKey);
            await this.cacheLoader.clear(this.unqualifiedCacheKey);
            this.data.set((0, $lbTbw.createEmptyPaginatedData)());
            this.unjustifiedData.set((0, $lbTbw.createEmptyPaginatedData)());
            this.unqualifiedData.set((0, $lbTbw.createEmptyPaginatedData)());
            this.cacheStatus.set(null);
        }
    }
}

});


parcelRegister("gKRm0", function(module, exports) {

$parcel$export(module.exports, "AuthenticationConfigurationService", function () { return $b899478c6e2a24aa$export$92646d589919b91; });

var $dhPTb = parcelRequire("dhPTb");

var $3YlV7 = parcelRequire("3YlV7");

var $5fjus = parcelRequire("5fjus");

var $hoiie = parcelRequire("hoiie");
class $b899478c6e2a24aa$export$92646d589919b91 {
    constructor(uuidManager, customUserAgentService, i18NStore){
        this.uuidManager = uuidManager;
        this.customUserAgentService = customUserAgentService;
        this.i18NStore = i18NStore;
        this.configuration = {
            serviceConfiguration: {
                authorizationEndpoint: `${(0, $dhPTb.Config).API_URL}/oauth2/authorize`,
                tokenEndpoint: `${(0, $dhPTb.Config).API_URL}/oauth2/token`
            },
            clientId: (0, $dhPTb.Config).API_CLIENT_ID,
            clientSecret: (0, $dhPTb.Config).API_CLIENT_SECRET,
            redirectUrl: (0, $5fjus.getAuthorizeRedirectUrl)(),
            scopes: (0, $3YlV7.getApplicationScopes)((0, $hoiie.ApplicationScopes), (0, $dhPTb.Config).SAVINGS_ACCOUNT_CREATION_ENABLED)
        };
    }
    async getConfiguration(phoneNumber, registeringParameters) {
        const deviceUUID = await this.uuidManager?.getUUID();
        const optionalDeviceUUID = deviceUUID ? {
            device_id: deviceUUID
        } : {};
        const userAgent = this.customUserAgentService ? await this.customUserAgentService.getUserAgent() : null;
        const localeTag = await this.i18NStore.localeTag.get();
        const customHeaders = userAgent ? {
            token: {
                "User-Agent": userAgent
            }
        } : undefined;
        if (registeringParameters) return {
            ...this.configuration,
            additionalParameters: {
                ...registeringParameters,
                ...optionalDeviceUUID,
                signUp: "1",
                phone: phoneNumber ?? "",
                lang: localeTag
            },
            customHeaders: // only used by Android
            customHeaders
        };
        else return {
            ...this.configuration,
            additionalParameters: {
                ...optionalDeviceUUID,
                signUp: phoneNumber ? "1" : "0",
                phone: phoneNumber ?? "",
                lang: localeTag
            },
            customHeaders: // only used by Android
            customHeaders
        };
    }
}

});
parcelRegister("3YlV7", function(module, exports) {

$parcel$export(module.exports, "getApplicationScopes", function () { return $ce9c8017b10dfc1e$export$d0ce112c5635bb43; });

var $hoiie = parcelRequire("hoiie");
const $ce9c8017b10dfc1e$export$117b66c3ae2ec106 = (scopes, excludedScopes)=>scopes.filter((scope)=>!excludedScopes.includes(scope));
const $ce9c8017b10dfc1e$export$d0ce112c5635bb43 = (allScopes, isSavingsAccountCreationEnabled)=>{
    const excludedScopes = isSavingsAccountCreationEnabled ? [] : [
        (0, $hoiie.SavingsScope).SavProductRead,
        (0, $hoiie.SavingsScope).SavContractWrite
    ];
    return $ce9c8017b10dfc1e$export$117b66c3ae2ec106(allScopes, excludedScopes);
};

});
parcelRegister("hoiie", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $23a0e857223ad56c$export$775b6bb06e53a214; });
$parcel$export(module.exports, "SharedServiceDomainScope", function () { return $23a0e857223ad56c$export$5bb02b6795b233fa; });
$parcel$export(module.exports, "ServiceDomainScope", function () { return $23a0e857223ad56c$export$b432eab31b0e2f01; });
$parcel$export(module.exports, "CreditScope", function () { return $23a0e857223ad56c$export$ac133cfe10c88691; });
$parcel$export(module.exports, "SavingsScope", function () { return $23a0e857223ad56c$export$602916517e868d95; });
$parcel$export(module.exports, "ApplicationScopes", function () { return $23a0e857223ad56c$export$22df5edd67c1371e; });
$parcel$export(module.exports, "NotAuthenticatedScopes", function () { return $23a0e857223ad56c$export$d37c61c7442f4890; });
$parcel$export(module.exports, "RegisterOtpScopes", function () { return $23a0e857223ad56c$export$878b9ae4d0b37eca; });
var $23a0e857223ad56c$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Payment"] = "payment";
    Scope["BillPayment"] = "bill_payment";
    Scope["P2PTransfer"] = "p2p_transfer";
    Scope["P2PSimpleTransfer"] = "p2p_simple_transfer";
    Scope["P2PCashTransfer"] = "p2p_cash_transfer";
    Scope["P2PDedicatedTransfer"] = "p2p_transfer_dedicated";
    Scope["RetrieveCashTransfer"] = "retrieve_cash_transfer";
    Scope["Payout"] = "payout";
    Scope["TransactionCode"] = "transaction_code";
    Scope["SubscribeLoan"] = "subscribe_loan";
    Scope["ConsultLoans"] = "consult_loans";
    Scope["WalletToBank"] = "wallet_to_bank";
    Scope["BankToWallet"] = "bank_to_wallet";
    Scope["ConsultBankAccount"] = "consult_bank_account";
    Scope["CardsManagement"] = "cards_management";
    Scope["CardsVirtualCreation"] = "cards_virtual_creation";
    Scope["MobilesManagement"] = "mobiles_management";
    Scope["Notifications"] = "notifications";
    Scope["KYCView"] = "kyc_view";
    Scope["KYCUpdate"] = "kyc_update";
    Scope["PincodeUpdate"] = "pincode_update";
    Scope["AccountsView"] = "accounts_view";
    Scope["ConsultAuthorizationHolds"] = "consult_authorization_holds";
    Scope["PincodeCheck"] = "pincode_check";
    Scope["ClientOnboarding"] = "client_onboarding";
    Scope["SdaCustomerOnboardingCreate"] = "sda_customer_onboarding_create";
    Scope["SdaCustomerOnboardingView"] = "sda_customer_onboarding_view";
    Scope["SdaCustomerOnboardingUpdate"] = "sda_customer_onboarding_update";
    Scope["SdaCustomerOnboardingSubmit"] = "sda_customer_onboarding_submit";
    Scope["SdaCustomerOnboardingActionsInitiate"] = "sda_customer-actions_initiate";
    Scope["AcceptorSearch"] = "acceptor_search";
    Scope["Configuration"] = "configuration";
    Scope["OtpCheck"] = "otp_check";
    Scope["Withdraw"] = "withdraw";
    Scope["WalletRechargeByCard"] = "wallet_recharge_by_card";
    Scope["ManageQrCode"] = "qr_code_management";
    Scope["ManageCategorizationSpendings"] = "spendings_categorization_management";
    Scope["BicReferential"] = "bic_referential_view";
    Scope["ExternalAccountsManagement"] = "external_account_management";
    Scope["ExternalAccountsUsage"] = "external_account_usage";
    Scope["BeneficiariesManagement"] = "beneficiaries_management";
    Scope["BeneficiariesUsage"] = "beneficiaries_usage";
    Scope["StrongCustomerAuthentication"] = "strong_customer_authentication";
    Scope["CardSensitiveDataView"] = "card_sensitive_data_view";
    Scope["IdentityDocumentView"] = "identity_documents_view";
    Scope["IdentityView"] = "identity_view";
    Scope["TrustedDevices"] = "trusted_devices";
    Scope["MandateView"] = "mandate_view";
    Scope["MandateManagement"] = "mandate_management";
    return Scope;
}({});
var $23a0e857223ad56c$export$5bb02b6795b233fa = /*#__PURE__*/ function(SharedServiceDomainScope) {
    SharedServiceDomainScope["CustomerInstructionDeletion"] = "customer-instruction_deletion";
    SharedServiceDomainScope["CustomerInstructionInitiation"] = "customer-instruction_initiation";
    SharedServiceDomainScope["CustomerInstructionSubmit"] = "customer-instruction_submit";
    SharedServiceDomainScope["CustomerInstructionUpdate"] = "customer-instruction_update";
    SharedServiceDomainScope["CustomerInstructionView"] = "customer-instruction_view";
    SharedServiceDomainScope["PaymentContract"] = "payment-service-contract_view";
    SharedServiceDomainScope["PaymentInstructionView"] = "payment-instruction_view";
    SharedServiceDomainScope["PaymentStandingOrderCreate"] = "payment-standing-order_create";
    SharedServiceDomainScope["PaymentStandingOrderUpdate"] = "payment-standing-order_update";
    SharedServiceDomainScope["PaymentStandingOrderDelete"] = "payment-standing-order_delete";
    SharedServiceDomainScope["PaymentStandingOrderView"] = "payment-standing-order_view";
    SharedServiceDomainScope["PaymentNetwork"] = "payment_network";
    SharedServiceDomainScope["ProductManagement"] = "product_management";
    SharedServiceDomainScope["RecipientCreate"] = "recipients_create";
    SharedServiceDomainScope["SdaAccountsNameUpdate"] = "sda_accounts_name_update";
    SharedServiceDomainScope["SdaAccountView"] = "sda_accounts_view";
    SharedServiceDomainScope["SdaAuthenticationsSessionsAuth"] = "sda_authentications-sessions_auth";
    SharedServiceDomainScope["SdaAuthenticationsSessionsView"] = "sda_authentications-sessions_view";
    SharedServiceDomainScope["SdaAuthenticationsSessionsSuspicious"] = "sda_authentications-sessions_suspicious";
    SharedServiceDomainScope["SdaExchangeRateView"] = "sda_exchange-rates_view";
    SharedServiceDomainScope["SdaRequiredActionsWrite"] = "sda_required-actions_write";
    SharedServiceDomainScope["SdaTransactionsView"] = "sda_transactions_view";
    return SharedServiceDomainScope;
}({});
var $23a0e857223ad56c$export$b432eab31b0e2f01 = /*#__PURE__*/ function(ServiceDomainScope) {
    ServiceDomainScope["DocumentSetupView"] = "document_setup_view";
    ServiceDomainScope["AdditionalDataRead"] = "additional-data_read";
    ServiceDomainScope["FormRead"] = "form_read";
    return ServiceDomainScope;
}({});
var $23a0e857223ad56c$export$ac133cfe10c88691 = /*#__PURE__*/ function(CreditScope) {
    CreditScope["CdtProductRead"] = "cdt_product_read";
    CreditScope["CdtCreditRequestRead"] = "cdt_credit_request_read";
    CreditScope["CdtCreditRequestWrite"] = "cdt_credit_request_write";
    CreditScope["CdtCreditServicingRead"] = "cdt_credit_servicing_read";
    return CreditScope;
}({});
var $23a0e857223ad56c$export$602916517e868d95 = /*#__PURE__*/ function(SavingsScope) {
    SavingsScope["SavContractRead"] = "sav_contract_read";
    SavingsScope["SavDeposit"] = "sav_deposit";
    SavingsScope["SavProductRead"] = "sav_product_read";
    SavingsScope["SavContractWrite"] = "sav_contract_write";
    SavingsScope["SavDocumentsRead"] = "sav_documents_read";
    return SavingsScope;
}({});
const $23a0e857223ad56c$export$22df5edd67c1371e = [
    ...Object.values($23a0e857223ad56c$export$775b6bb06e53a214),
    ...Object.values($23a0e857223ad56c$export$5bb02b6795b233fa),
    ...Object.values($23a0e857223ad56c$export$ac133cfe10c88691),
    ...Object.values($23a0e857223ad56c$export$602916517e868d95),
    ...Object.values($23a0e857223ad56c$export$b432eab31b0e2f01)
];
const $23a0e857223ad56c$export$d37c61c7442f4890 = [
    "pincode_check",
    "client_onboarding",
    "acceptor_search",
    "configuration",
    "sda_customer_onboarding_create",
    "sda_customer_onboarding_view"
];
const $23a0e857223ad56c$export$878b9ae4d0b37eca = [
    "pincode_check",
    "otp_check"
];

});


parcelRegister("5fjus", function(module, exports) {

$parcel$export(module.exports, "getAuthorizeRedirectUrl", function () { return $5867729ddb5acc64$export$44db56502aedfeff; });

var $dhPTb = parcelRequire("dhPTb");
function $5867729ddb5acc64$export$44db56502aedfeff() {
    return (0, $dhPTb.Config).AUTH_REDIRECT_WEB_CLIENT_SCHEME;
}

});


parcelRegister("gBAsC", function(module, exports) {

$parcel$export(module.exports, "AuthenticationManager", function () { return $b638048f0db2d653$export$20a8f046f7b7ebc2; });

var $enbp3 = parcelRequire("enbp3");

var $3sC2g = parcelRequire("3sC2g");

var $hoiie = parcelRequire("hoiie");

var $3Ersk = parcelRequire("3Ersk");

var $7roNm = parcelRequire("7roNm");

var $kpnq8 = parcelRequire("kpnq8");

var $2mnb2 = parcelRequire("2mnb2");

var $gDlNU = parcelRequire("gDlNU");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");
const $b638048f0db2d653$export$3887e3f1720d5952 = "session";
class $b638048f0db2d653$export$20a8f046f7b7ebc2 {
    constructor(authenticationService, networkInfoManager, storage, analyticsService, deviceInfoService, securedCookiesService){
        this.authenticationService = authenticationService;
        this.networkInfoManager = networkInfoManager;
        this.storage = storage;
        this.analyticsService = analyticsService;
        this.deviceInfoService = deviceInfoService;
        this.securedCookiesService = securedCookiesService;
        this.sessionBuilder = new (0, $7roNm.SessionBuilder)(this.securedCookiesService);
        this.codeValidationTokenResult = null;
        this.session = new (0, $3Ersk.Observable)(this.sessionBuilder.build());
        this.hasBeenDisconnectedDueToInactivity = new (0, $3Ersk.Observable)(false);
        this.isConnected = new (0, $3Ersk.Observable)(false);
        this.isAuthenticated = new (0, $3Ersk.Observable)(false);
        this._lock = new (0, (/*@__PURE__*/$parcel$interopDefault($enbp3)))();
        this._initialized = false;
        this._onSessionExpired = new (0, $kpnq8.Signal)();
        this._isFirstLaunch = false;
        this._notAuthenticatedScopes = (0, $hoiie.NotAuthenticatedScopes);
        this.session.onChange.add((session)=>this.sessionChanged(session));
    }
    async initialize(isFirstLaunch) {
        if (!this._initialized) {
            if ((0, $gDlNU.isDefined)(isFirstLaunch)) this._isFirstLaunch = isFirstLaunch;
            await this.restoreCurrentSession();
            this._initialized = true;
        }
    }
    async connect(phoneNumber, registeringParameters) {
        this.hasBeenDisconnectedDueToInactivity.set(false);
        const authorizeResult = await this.authenticationService.authorize(phoneNumber, registeringParameters);
        if (authorizeResult) {
            // Only mobile get AccessToken in one step.
            // Web must proceed with connectWithCodeGrant after redirection
            this.session.set(this.sessionBuilder.build(authorizeResult));
            await this.saveCurrentSession();
        }
    }
    async connectWithCodeGrant(code, state) {
        this.hasBeenDisconnectedDueToInactivity.set(false);
        const tokenResult = await this.authenticationService.authorizeWithCodeGrant(code, state);
        this.session.set(this.sessionBuilder.build(tokenResult));
        await this.saveCurrentSession();
    }
    async connectWithToken(tokenResult) {
        this.hasBeenDisconnectedDueToInactivity.set(false);
        this.session.set(this.sessionBuilder.build(tokenResult));
        await this.saveCurrentSession();
    }
    async connectWithPhoneNumberAndPincode(pincode, verifyOtp, registeringParameters) {
        const skipOtp = (0, $gDlNU.isDefined)(registeringParameters);
        if (skipOtp) {
            const connectedTokenResult = await this.authenticationService.authorizeWithPincode(pincode, registeringParameters?.enrollment_id);
            this.session.set(this.sessionBuilder.build(connectedTokenResult));
            await this.saveCurrentSession();
        } else {
            const codeValidationTokenResult = await this.authenticationService.authorizeWithPincode(pincode);
            verifyOtp(async (otp)=>{
                const authorizeResult = await this.authenticationService.validateAuthorizationWithPincode(codeValidationTokenResult.accessToken, otp);
                this.session.set(this.sessionBuilder.build(authorizeResult));
                await this.saveCurrentSession();
            });
        }
    }
    async askWebAuthentOtp(pincode, registeringParameters) {
        if (registeringParameters) {
            this.codeValidationTokenResult = await this.authenticationService.authorizeWithPincode(pincode, registeringParameters?.enrollment_id);
            this.session.set(this.sessionBuilder.build(this.codeValidationTokenResult));
            await this.saveCurrentSession();
        } else this.codeValidationTokenResult = await this.authenticationService.authorizeWithPincode(pincode);
    }
    async validateWebAuthentOtp(otp) {
        if (!this.codeValidationTokenResult) return Promise.reject("Token Error");
        else if (!otp) return Promise.reject("Otp Error");
        else try {
            const authorizeResult = await this.authenticationService.validateAuthorizationWithPincode(this.codeValidationTokenResult.accessToken, otp);
            this.session.set(this.sessionBuilder.build(authorizeResult));
            await this.saveCurrentSession();
            return Promise.resolve();
        } catch (error) {
            (0, $6JVVB.logger).debug("validateWebAuthentOtp error : ", error);
            return Promise.reject(error);
        }
    }
    async validateRegisterOtp(registeringParameters) {
        return await this.authenticationService.validateRegisterOtp(registeringParameters);
    }
    async getAccessToken(forceRefresh = false) {
        return await this._lock.acquire("tokenLock", async ()=>{
            let token = this.session.get().accessToken;
            if (!token || forceRefresh || token && (0, $2mnb2.isAccessTokenExpired)(token)) token = await this.renewAccessToken();
            return token;
        });
    }
    setIsAuthenticated(isAuthenticated) {
        this.isAuthenticated.set(isAuthenticated);
    }
    async logout(clearSession = true, hasBeenDisconnectedDueToInactivity = false) {
        try {
            if (clearSession) {
                // hard logout : clear session
                this.session.set(this.sessionBuilder.build());
                await this.saveCurrentSession();
                this.setIsAuthenticated(false);
                this.analyticsService.event("user_disconnect_clear_session", {
                    install_id: await (0, $kqXxS.uuidManager).getUUID(),
                    device_model: this.deviceInfoService.getModel()
                });
                await this.getAccessToken(true);
            } else {
                // soft logout : keep session opened
                // when user disconnects manually from menu
                this.setIsAuthenticated(false);
                this.analyticsService.event("user_disconnect_keep_session_opened", {
                    install_id: await (0, $kqXxS.uuidManager).getUUID(),
                    device_model: this.deviceInfoService.getModel()
                });
            }
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationManager", "Logout failed", e);
        }
        if (hasBeenDisconnectedDueToInactivity) this.hasBeenDisconnectedDueToInactivity.set(true);
    }
    get onSessionExpired() {
        return this._onSessionExpired;
    }
    async renewAccessToken() {
        try {
            await this.renewSession();
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationManager", "Failed to renew token", e);
            await this.handleAccessTokenRenewError(e);
        }
        const newSession = this.session.get();
        return newSession ? newSession.accessToken : null;
    }
    async handleAccessTokenRenewError(error) {
        if (!(error instanceof Error)) error = new Error(error);
        await this.analyticsService.recordError(error);
        await this.analyticsService.event("token_renew_failure", {
            install_id: await (0, $kqXxS.uuidManager).getUUID(),
            device_model: this.deviceInfoService.getModel(),
            error: JSON.stringify(error)
        });
        if (error instanceof (0, $3sC2g.NetworkErrorOnAuthentication)) {
            await this.analyticsService.event("token_renew_failure_networl_error");
            (0, $6JVVB.logger).warn("Network error during access token refresh");
        } else {
            await this.analyticsService.event("token_renew_failure_expired_session");
            this.session.set(this.sessionBuilder.build());
            await this.saveCurrentSession();
            this._onSessionExpired.dispatch();
            this.setIsAuthenticated(false);
        }
    }
    async saveCurrentSession() {
        try {
            const session = this.session.get();
            await this.storage.store(JSON.stringify(session), $b638048f0db2d653$export$3887e3f1720d5952);
        // if (session && session.accessToken && session.isConnected) {
        // 	this.setIsAuthenticated(true);
        // }
        } catch (e) {
            if (!this._isFirstLaunch) {
                (0, $6JVVB.logger).debug("AuthenticationManager", "Save current session failed", e);
                await this.analyticsService.recordError(e instanceof Error ? e : new Error(e));
                await this.analyticsService.event("session_save_failure", {
                    install_id: await (0, $kqXxS.uuidManager).getUUID(),
                    device_model: this.deviceInfoService.getModel(),
                    error: JSON.stringify(e)
                });
            } else {
                (0, $6JVVB.logger).debug("AuthenticationManager", "saveCurrentSession error: Is First Launch");
                await this.analyticsService.recordError(e instanceof Error ? e : new Error(e));
                await this.analyticsService.event("session_save_first_launch", {
                    install_id: await (0, $kqXxS.uuidManager).getUUID(),
                    device_model: this.deviceInfoService.getModel(),
                    error: JSON.stringify(e)
                });
            }
        }
    }
    async restoreCurrentSession() {
        try {
            let session = await this.getSessionFromStorage();
            if (!session) session = this.sessionBuilder.build();
            this.session.set(session);
            await this.saveCurrentSession();
        } catch (e) {
            if (!this._isFirstLaunch) {
                (0, $6JVVB.logger).debug("AuthenticationManager", "Failed to restore current session", e);
                await this.analyticsService.recordError(e instanceof Error ? e : new Error(e));
                await this.analyticsService.event("session_restore_failure", {
                    install_id: await (0, $kqXxS.uuidManager).getUUID(),
                    device_model: this.deviceInfoService.getModel(),
                    error: JSON.stringify(e)
                });
            } else {
                (0, $6JVVB.logger).debug("AuthenticationManager", "restoreCurrentSession error : Is First Launch");
                await this.analyticsService.recordError(e instanceof Error ? e : new Error(e));
                await this.analyticsService.event("session_restore_first_launch", {
                    install_id: await (0, $kqXxS.uuidManager).getUUID(),
                    device_model: this.deviceInfoService.getModel(),
                    error: JSON.stringify(e)
                });
            }
            this.session.set(this.sessionBuilder.build());
            await this.saveCurrentSession();
        }
    }
    async renewSession() {
        const session = await this.getSessionFromStorage();
        let result;
        try {
            if (session && session.isConnected) {
                this.addObservability();
                result = await this.authenticationService.refresh(session.refreshToken);
            } else result = await this.authenticationService.requestNotConnectedAccessToken(this._notAuthenticatedScopes);
            this.session.set(this.sessionBuilder.build(result));
            await this.saveCurrentSession();
        } catch (e) {
            this.logout();
        }
    }
    sessionChanged(session) {
        this.isConnected.set(session !== null && session.isConnected);
    }
    updateNotAuthenticatedScope(scope) {
        if ((0, $hoiie.NotAuthenticatedScopes).includes(scope)) {
            let updatedScopes = this._notAuthenticatedScopes;
            if (updatedScopes.includes(scope)) updatedScopes = updatedScopes.filter(function(value) {
                return value !== scope;
            });
            else updatedScopes.push(scope);
            this._notAuthenticatedScopes = updatedScopes;
        }
    }
    getNotAuthenticatedScope(scope) {
        return this._notAuthenticatedScopes.includes(scope);
    }
    resetNotAuthenticatedScope() {
        this._notAuthenticatedScopes = (0, $hoiie.NotAuthenticatedScopes);
    }
    getClientId() {
        const session = this.session.get();
        if (session && session.clientId) return session.clientId;
        return null;
    }
    async addObservability() {
        try {
            const message = "authentication_manager_refresh_token";
            (0, $6JVVB.logger).debug(message);
            await this.analyticsService.event(message, {
                device_model: this.deviceInfoService.getModel()
            });
        } catch (error) {
            (0, $6JVVB.logger).error("AuthenticationManager: ", error);
        }
    }
    async getSessionFromStorage() {
        const sessionString = await this.storage.read($b638048f0db2d653$export$3887e3f1720d5952);
        const session = sessionString ? JSON.parse(sessionString) : null;
        return session;
    }
}

});
parcelRegister("enbp3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5ELPz"));

});
parcelRegister("5ELPz", function(module, exports) {

var $j1eoE = parcelRequire("j1eoE");
'use strict';
var $41e5ca63c8642955$var$AsyncLock = function(opts) {
    opts = opts || {};
    this.Promise = opts.Promise || Promise;
    // format: {key : [fn, fn]}
    // queues[key] = null indicates no job running for key
    this.queues = Object.create(null);
    // lock is reentrant for same domain
    this.domainReentrant = opts.domainReentrant || false;
    if (this.domainReentrant) throw new Error("Domain-reentrant locks require `process.domain` to exist. Please flip `opts.domainReentrant = false`, use a NodeJS version that still implements Domain, or install a browser polyfill.");
    this.timeout = opts.timeout || $41e5ca63c8642955$var$AsyncLock.DEFAULT_TIMEOUT;
    this.maxOccupationTime = opts.maxOccupationTime || $41e5ca63c8642955$var$AsyncLock.DEFAULT_MAX_OCCUPATION_TIME;
    this.maxExecutionTime = opts.maxExecutionTime || $41e5ca63c8642955$var$AsyncLock.DEFAULT_MAX_EXECUTION_TIME;
    if (opts.maxPending === Infinity || Number.isInteger(opts.maxPending) && opts.maxPending >= 0) this.maxPending = opts.maxPending;
    else this.maxPending = $41e5ca63c8642955$var$AsyncLock.DEFAULT_MAX_PENDING;
};
$41e5ca63c8642955$var$AsyncLock.DEFAULT_TIMEOUT = 0; //Never
$41e5ca63c8642955$var$AsyncLock.DEFAULT_MAX_OCCUPATION_TIME = 0; //Never
$41e5ca63c8642955$var$AsyncLock.DEFAULT_MAX_EXECUTION_TIME = 0; //Never
$41e5ca63c8642955$var$AsyncLock.DEFAULT_MAX_PENDING = 1000;
/**
 * Acquire Locks
 *
 * @param {String|Array} key 	resource key or keys to lock
 * @param {function} fn 	async function
 * @param {function} cb 	callback function, otherwise will return a promise
 * @param {Object} opts 	options
 */ $41e5ca63c8642955$var$AsyncLock.prototype.acquire = function(key, fn, cb, opts) {
    if (Array.isArray(key)) return this._acquireBatch(key, fn, cb, opts);
    if (typeof fn !== 'function') throw new Error('You must pass a function to execute');
    // faux-deferred promise using new Promise() (as Promise.defer is deprecated)
    var deferredResolve = null;
    var deferredReject = null;
    var deferred = null;
    if (typeof cb !== 'function') {
        opts = cb;
        cb = null;
        // will return a promise
        deferred = new this.Promise(function(resolve, reject) {
            deferredResolve = resolve;
            deferredReject = reject;
        });
    }
    opts = opts || {};
    var resolved = false;
    var timer = null;
    var occupationTimer = null;
    var executionTimer = null;
    var self = this;
    var done = function(locked, err, ret) {
        if (occupationTimer) {
            clearTimeout(occupationTimer);
            occupationTimer = null;
        }
        if (executionTimer) {
            clearTimeout(executionTimer);
            executionTimer = null;
        }
        if (locked) {
            if (!!self.queues[key] && self.queues[key].length === 0) delete self.queues[key];
            if (self.domainReentrant) delete self.domains[key];
        }
        if (!resolved) {
            if (!deferred) {
                if (typeof cb === 'function') cb(err, ret);
            } else //promise mode
            if (err) deferredReject(err);
            else deferredResolve(ret);
            resolved = true;
        }
        if (locked) //run next func
        {
            if (!!self.queues[key] && self.queues[key].length > 0) self.queues[key].shift()();
        }
    };
    var exec = function(locked) {
        if (resolved) return done(locked);
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        if (self.domainReentrant && locked) self.domains[key] = $j1eoE.domain;
        var maxExecutionTime = opts.maxExecutionTime || self.maxExecutionTime;
        if (maxExecutionTime) executionTimer = setTimeout(function() {
            if (!!self.queues[key]) done(locked, new Error('Maximum execution time is exceeded ' + key));
        }, maxExecutionTime);
        // Callback mode
        if (fn.length === 1) {
            var called = false;
            try {
                fn(function(err, ret) {
                    if (!called) {
                        called = true;
                        done(locked, err, ret);
                    }
                });
            } catch (err) {
                // catching error thrown in user function fn
                if (!called) {
                    called = true;
                    done(locked, err);
                }
            }
        } else // Promise mode
        self._promiseTry(function() {
            return fn();
        }).then(function(ret) {
            done(locked, undefined, ret);
        }, function(error) {
            done(locked, error);
        });
    };
    if (self.domainReentrant && !!$j1eoE.domain) exec = $j1eoE.domain.bind(exec);
    var maxPending = opts.maxPending || self.maxPending;
    if (!self.queues[key]) {
        self.queues[key] = [];
        exec(true);
    } else if (self.domainReentrant && !!$j1eoE.domain && $j1eoE.domain === self.domains[key]) // If code is in the same domain of current running task, run it directly
    // Since lock is re-enterable
    exec(false);
    else if (self.queues[key].length >= maxPending) done(false, new Error('Too many pending tasks in queue ' + key));
    else {
        var taskFn = function() {
            exec(true);
        };
        if (opts.skipQueue) self.queues[key].unshift(taskFn);
        else self.queues[key].push(taskFn);
        var timeout = opts.timeout || self.timeout;
        if (timeout) timer = setTimeout(function() {
            timer = null;
            done(false, new Error('async-lock timed out in queue ' + key));
        }, timeout);
    }
    var maxOccupationTime = opts.maxOccupationTime || self.maxOccupationTime;
    if (maxOccupationTime) occupationTimer = setTimeout(function() {
        if (!!self.queues[key]) done(false, new Error('Maximum occupation time is exceeded in queue ' + key));
    }, maxOccupationTime);
    if (deferred) return deferred;
};
/*
 * Below is how this function works:
 *
 * Equivalent code:
 * self.acquire(key1, function(cb){
 *     self.acquire(key2, function(cb){
 *         self.acquire(key3, fn, cb);
 *     }, cb);
 * }, cb);
 *
 * Equivalent code:
 * var fn3 = getFn(key3, fn);
 * var fn2 = getFn(key2, fn3);
 * var fn1 = getFn(key1, fn2);
 * fn1(cb);
 */ $41e5ca63c8642955$var$AsyncLock.prototype._acquireBatch = function(keys, fn, cb, opts) {
    if (typeof cb !== 'function') {
        opts = cb;
        cb = null;
    }
    var self = this;
    var getFn = function(key, fn) {
        return function(cb) {
            self.acquire(key, fn, cb, opts);
        };
    };
    var fnx = keys.reduceRight(function(prev, key) {
        return getFn(key, prev);
    }, fn);
    if (typeof cb === 'function') fnx(cb);
    else return new this.Promise(function(resolve, reject) {
        // check for promise mode in case keys is empty array
        if (fnx.length === 1) fnx(function(err, ret) {
            if (err) reject(err);
            else resolve(ret);
        });
        else resolve(fnx());
    });
};
/*
 *	Whether there is any running or pending asyncFunc
 *
 *	@param {String} key
 */ $41e5ca63c8642955$var$AsyncLock.prototype.isBusy = function(key) {
    if (!key) return Object.keys(this.queues).length > 0;
    else return !!this.queues[key];
};
/**
 * Promise.try() implementation to become independent of Q-specific methods
 */ $41e5ca63c8642955$var$AsyncLock.prototype._promiseTry = function(fn) {
    try {
        return this.Promise.resolve(fn());
    } catch (e) {
        return this.Promise.reject(e);
    }
};
module.exports = $41e5ca63c8642955$var$AsyncLock;

});


parcelRegister("3sC2g", function(module, exports) {

$parcel$export(module.exports, "AuthenticatedSessionExpiredError", function () { return $7a99dfee399ed068$export$5f3c4771399a0d65; });
$parcel$export(module.exports, "NetworkErrorOnAuthentication", function () { return $7a99dfee399ed068$export$fc481d8d65e40887; });
class $7a99dfee399ed068$export$5f3c4771399a0d65 extends Error {
    constructor(message){
        super(message);
    }
}
class $7a99dfee399ed068$export$fc481d8d65e40887 extends Error {
    constructor(message){
        super(message);
    }
}

});

parcelRegister("7roNm", function(module, exports) {

$parcel$export(module.exports, "SessionBuilder", function () { return $bd73e8a40f0ac1a4$export$ba4e3b912e741892; });

var $6EEoI = parcelRequire("6EEoI");

var $6JVVB = parcelRequire("6JVVB");
class $bd73e8a40f0ac1a4$export$ba4e3b912e741892 {
    constructor(securedCookiesService){
        this.securedCookies = securedCookiesService?.getSecuredCookies() ?? false;
    }
    build(tokens) {
        try {
            if (!tokens) return this.buildNotConnectedSession();
            else {
                if (tokens.refreshToken) return this.buildConnectedSession(tokens, tokens.refreshToken);
                else return this.buildNotConnectedSession(tokens);
            }
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationManager", "Build session failed", e);
            return this.buildNotConnectedSession();
        }
    }
    buildScopes(tokens) {
        const decodedToken = tokens ? (0, (/*@__PURE__*/$parcel$interopDefault($6EEoI)))(tokens.accessToken) : null;
        const scopes = decodedToken?.scopes ?? [];
        // Only emitted when Config.LOGGING_ENABLED is on (testbed envs), never in production builds.
        (0, $6JVVB.logger).debug("SessionBuilder", `Scopes carried by the access token (${scopes.length})`, scopes);
        return scopes;
    }
    buildAccessToken(tokens, expirationDate) {
        return this.securedCookies ? {
            value: "",
            type: "",
            expirationDate: expirationDate
        } : {
            value: tokens.accessToken,
            type: tokens.tokenType,
            expirationDate: expirationDate
        };
    }
    buildClientId(tokens) {
        const decodedToken = tokens ? (0, (/*@__PURE__*/$parcel$interopDefault($6EEoI)))(tokens.accessToken) : null;
        return decodedToken?.user?.id ?? null;
    }
    buildConnectedSession(tokens, refreshToken) {
        const clientId = this.buildClientId(tokens);
        const scopes = this.buildScopes(tokens);
        const accessToken = this.buildAccessToken(tokens, tokens.expirationDate);
        return this.securedCookies ? {
            accessToken: accessToken,
            refreshToken: "",
            scopes: scopes,
            isConnected: true,
            clientId: clientId
        } : {
            accessToken: accessToken,
            refreshToken: refreshToken,
            scopes: scopes,
            isConnected: true,
            clientId: clientId
        };
    }
    buildNotConnectedSession(tokens) {
        const scopes = this.buildScopes(tokens);
        const accessToken = tokens ? this.buildAccessToken(tokens, tokens.expirationDate) : null;
        return {
            accessToken: accessToken,
            scopes: scopes,
            isConnected: false
        };
    }
}

});
parcelRegister("6EEoI", function(module, exports) {
'use strict';

var $4fH8H = parcelRequire("4fH8H");
function $4d85d0a243bc48ca$var$InvalidTokenError(message) {
    this.message = message;
}
$4d85d0a243bc48ca$var$InvalidTokenError.prototype = new Error();
$4d85d0a243bc48ca$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
module.exports = function(token, options) {
    if (typeof token !== 'string') throw new $4d85d0a243bc48ca$var$InvalidTokenError('Invalid token specified');
    options = options || {};
    var pos = options.header === true ? 0 : 1;
    try {
        return JSON.parse($4fH8H(token.split('.')[pos]));
    } catch (e) {
        throw new $4d85d0a243bc48ca$var$InvalidTokenError('Invalid token specified: ' + e.message);
    }
};
module.exports.InvalidTokenError = $4d85d0a243bc48ca$var$InvalidTokenError;

});
parcelRegister("4fH8H", function(module, exports) {

var $lk888 = parcelRequire("lk888");
function $318a06bb988a6b9c$var$b64DecodeUnicode(str) {
    return decodeURIComponent($lk888(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
module.exports = function(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return $318a06bb988a6b9c$var$b64DecodeUnicode(output);
    } catch (err) {
        return $lk888(output);
    }
};

});
parcelRegister("lk888", function(module, exports) {
/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */ var $f861c5bb826b3103$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $f861c5bb826b3103$var$InvalidCharacterError(message) {
    this.message = message;
}
$f861c5bb826b3103$var$InvalidCharacterError.prototype = new Error();
$f861c5bb826b3103$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
function $f861c5bb826b3103$var$polyfill(input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) throw new $f861c5bb826b3103$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    for(// initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
    buffer = str.charAt(idx++); // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))// try to find character in table (0-63, not found => -1)
    buffer = $f861c5bb826b3103$var$chars.indexOf(buffer);
    return output;
}
module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $f861c5bb826b3103$var$polyfill;

});




parcelRegister("2mnb2", function(module, exports) {

$parcel$export(module.exports, "sessionHasScope", function () { return $62265aef99ce9917$export$7dc2503608102f17; });
$parcel$export(module.exports, "isAccessTokenExpired", function () { return $62265aef99ce9917$export$42e2aa8e36b8f4fa; });

var $l1qT9 = parcelRequire("l1qT9");
function $62265aef99ce9917$export$7dc2503608102f17(session, scope) {
    return session.scopes.includes(scope);
}
function $62265aef99ce9917$export$42e2aa8e36b8f4fa(accessToken) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(accessToken.expirationDate).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))());
}

});

parcelRegister("gDlNU", function(module, exports) {

$parcel$export(module.exports, "isDefined", function () { return $53ebd0e589f72b6e$export$4e62c701997796c1; });
$parcel$export(module.exports, "atLeastOneIsDefined", function () { return $53ebd0e589f72b6e$export$3eb550bcc4b7b80b; });
$parcel$export(module.exports, "hasOwnDeepProperty", function () { return $53ebd0e589f72b6e$export$7eee404d95d47e7; });
function $53ebd0e589f72b6e$export$4e62c701997796c1(data) {
    if (data === null || data === undefined) return false;
    return true;
}
function $53ebd0e589f72b6e$export$3eb550bcc4b7b80b(list) {
    return list.filter((it)=>$53ebd0e589f72b6e$export$4e62c701997796c1(it)).length > 0;
}
function $53ebd0e589f72b6e$export$7eee404d95d47e7(obj, prop) {
    // only performs property checks on objects (taking care of the corner case for null as well)
    if (typeof obj === "object" && obj !== null) {
        // if this object already contains the property, we are done
        if (obj.hasOwnProperty(prop)) return true;
        // otherwise iterate on all the properties of this object.
        for(const p in obj){
            // and as soon as you find the property you are looking for, return true
            if (obj.hasOwnProperty(p) && $53ebd0e589f72b6e$export$7eee404d95d47e7(obj[p], prop)) return true;
        }
    }
    return false;
}

});


parcelRegister("3arnJ", function(module, exports) {

$parcel$export(module.exports, "AuthenticationService", function () { return $ac6e1671eb12c5ae$export$a15b8b4ccae62017; });

var $l1qT9 = parcelRequire("l1qT9");

var $3sC2g = parcelRequire("3sC2g");

var $asiRY = parcelRequire("asiRY");

var $dhPTb = parcelRequire("dhPTb");

var $6JVVB = parcelRequire("6JVVB");

var $3YlV7 = parcelRequire("3YlV7");

var $hoiie = parcelRequire("hoiie");
class $ac6e1671eb12c5ae$export$a15b8b4ccae62017 {
    constructor(oauthHttpService, authenticationConfigurationService, oauthService){
        this.oauthHttpService = oauthHttpService;
        this.authenticationConfigurationService = authenticationConfigurationService;
        this.oauthService = oauthService;
    }
    async requestNotConnectedAccessToken(notConnectedScopes) {
        try {
            const result = await this.oauthHttpService.instance.post("/oauth2/token", {
                grant_type: "client_credentials",
                client_id: (0, $dhPTb.Config).API_CLIENT_ID,
                client_secret: (0, $dhPTb.Config).API_CLIENT_SECRET,
                scope: notConnectedScopes
            });
            return $ac6e1671eb12c5ae$export$a15b8b4ccae62017.tokenResultFromDto(result.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationService", "Failed to request not connected access token", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async authorizeWithPincode(pincode, enrollmentId) {
        try {
            const pincodeValue = pincode.value.join(";");
            const password = enrollmentId ? [
                pincodeValue,
                enrollmentId
            ].join("|") : pincodeValue;
            const scopes = enrollmentId ? (0, $hoiie.ApplicationScopes) : (0, $hoiie.RegisterOtpScopes);
            const result = await this.oauthHttpService.instance.post("/oauth2/token", {
                grant_type: "password",
                client_id: (0, $dhPTb.Config).API_CLIENT_ID,
                client_secret: (0, $dhPTb.Config).API_CLIENT_SECRET,
                scope: scopes,
                username: pincode.id,
                password: password
            });
            return $ac6e1671eb12c5ae$export$a15b8b4ccae62017.tokenResultFromDto(result.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationService", "Failed to authorize with phone number and pincode", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async validateAuthorizationWithPincode(accessToken, otp) {
        try {
            const result = await this.oauthHttpService.instance.post("/oauth2/otp", {
                grant_type: "password",
                client_id: (0, $dhPTb.Config).API_CLIENT_ID,
                client_secret: (0, $dhPTb.Config).API_CLIENT_SECRET,
                scope: (0, $3YlV7.getApplicationScopes)((0, $hoiie.ApplicationScopes), (0, $dhPTb.Config).SAVINGS_ACCOUNT_CREATION_ENABLED),
                username: accessToken,
                password: otp
            });
            return $ac6e1671eb12c5ae$export$a15b8b4ccae62017.tokenResultFromDto(result.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationService", "Failed to authorize with phone number and pincode", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async authorize(phoneNumber, registeringParameters) {
        try {
            const result = await this.oauthService.authorize(await this.authenticationConfigurationService.getConfiguration(phoneNumber, registeringParameters));
            if (result) return $ac6e1671eb12c5ae$export$a15b8b4ccae62017.tokenResultFromAuthorizeOrRefreshResult(result);
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationService", "Authorize failed", e);
            throw e;
        }
    }
    async authorizeWithCodeGrant(code, state) {
        try {
            if (!(this.oauthService instanceof (0, $asiRY.WebOAuthService))) throw "Code Grant Authorization flow is Web specific";
            const result = await this.oauthService.completeAuthorization(code, state, await this.authenticationConfigurationService.getConfiguration());
            return $ac6e1671eb12c5ae$export$a15b8b4ccae62017.tokenResultFromDto(result);
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationService", "Authorize authorizeWithCodeGrant failed", e);
            throw e;
        }
    }
    async validateRegisterOtp(registeringParameters) {
        try {
            const result = await this.oauthHttpService.instance.post("/oauth2/otp", {
                grant_type: "password",
                client_id: (0, $dhPTb.Config).API_CLIENT_ID,
                client_secret: (0, $dhPTb.Config).API_CLIENT_SECRET,
                scope: (0, $hoiie.RegisterOtpScopes),
                username: registeringParameters?.enrollment_id,
                password: registeringParameters?.enrollment_otp
            });
            return $ac6e1671eb12c5ae$export$a15b8b4ccae62017.tokenResultFromDto(result.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationService", "Register validation failed", e);
            if (e.response) // Request made and server responded
            (0, $6JVVB.logger).error("AuthenticationService", "Error content:", e.response.headers, e.response.status, e.response.data);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async refresh(refreshToken) {
        try {
            const result = await this.oauthHttpService.instance.post("/oauth2/token", {
                grant_type: "refresh_token",
                client_id: (0, $dhPTb.Config).API_CLIENT_ID,
                client_secret: (0, $dhPTb.Config).API_CLIENT_SECRET,
                refresh_token: refreshToken
            });
            return $ac6e1671eb12c5ae$export$a15b8b4ccae62017.tokenResultFromDto(result.data);
        } catch (error) {
            (0, $6JVVB.logger).debug("AuthenticationService", "Refresh token failed", JSON.stringify(error));
            throw $ac6e1671eb12c5ae$export$a15b8b4ccae62017.handleRefreshError(error);
        }
    }
    static handleRefreshError(error) {
        if (error instanceof Error) {
            if ("Network error".toLowerCase() == error.message.toLowerCase()) return new (0, $3sC2g.NetworkErrorOnAuthentication)(error.message);
            return new (0, $3sC2g.AuthenticatedSessionExpiredError)(error.message);
        }
        return new Error("unable to handle refresh error: " + JSON.stringify(error));
    }
    static tokenResultFromDto(dto) {
        return {
            accessToken: dto.access_token,
            expirationDate: (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))().add(dto.expires_in, "seconds").toDate(),
            tokenType: dto.token_type,
            refreshToken: dto.refresh_token ?? undefined
        };
    }
    static tokenResultFromAuthorizeOrRefreshResult(result) {
        return {
            accessToken: result.accessToken,
            expirationDate: new Date(result.accessTokenExpirationDate),
            tokenType: result.tokenType,
            refreshToken: result.refreshToken ?? undefined
        };
    }
}

});

parcelRegister("eVD1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6372d4363585b717$export$2e2bcd8739ae039; });

var $6JVVB = parcelRequire("6JVVB");

var $61WqT = parcelRequire("61WqT");
class $6372d4363585b717$export$2e2bcd8739ae039 {
    constructor(authenticationsSessionsService, featuresManager){
        this.authenticationsSessionsService = authenticationsSessionsService;
        this.featuresManager = featuresManager;
    }
    async getAuthenticationSession(strongAuthenticationReference) {
        if (!this.featuresManager.features.get().sdaAuthenticationsSessionsView) throw "Cannot get authentication session. Feature not enabled";
        try {
            const session = await this.authenticationsSessionsService.getAuthenticationSession(strongAuthenticationReference);
            if (session.token) return this.sendAuthentication(session.token);
        } catch (error) {
            throw error;
        }
    }
    async sendAuthentication(strongAuthenticationReference) {
        if (!this.featuresManager.features.get().sdaAuthenticationsSessionsAuth) throw "Cannot send authentication SMS. Feature not enabled";
        return await this.authenticationsSessionsService.sendAuthentication(strongAuthenticationReference);
    }
    async verifyAuthentication(strongAuthenticationReference, code, method, isMultipleMethods) {
        try {
            const verifyResponse = await this.authenticationsSessionsService.verifyAuthentication(strongAuthenticationReference, code, method);
            if (verifyResponse.status === (0, $61WqT.VerifyAuthenticationStatus).DONE || isMultipleMethods) return verifyResponse;
            else throw "Authentication failed";
        } catch (error) {
            throw error;
        }
    }
    async cancelAuthentication(strongAuthenticationReference) {
        try {
            await this.authenticationsSessionsService.cancelAuthentication(strongAuthenticationReference);
        } catch (error) {
            (0, $6JVVB.logger).debug("AuthenticationsSessionsService", "Failed to cancel authentication", error);
            throw error;
        }
    }
}

});
parcelRegister("61WqT", function(module, exports) {

$parcel$export(module.exports, "VerifyAuthenticationStatus", function () { return $795db14780a183a3$export$eeb50472ece49ecd; });
$parcel$export(module.exports, "AuthenticationsMethod", function () { return $795db14780a183a3$export$8685c8bab6dce930; });
var $795db14780a183a3$export$eeb50472ece49ecd = /*#__PURE__*/ function(VerifyAuthenticationStatus) {
    VerifyAuthenticationStatus["INITIATED"] = "INITIATED";
    VerifyAuthenticationStatus["STARTED"] = "STARTED";
    VerifyAuthenticationStatus["DONE"] = "DONE";
    VerifyAuthenticationStatus["CANCELLED"] = "CANCELLED";
    VerifyAuthenticationStatus["FAILED"] = "FAILED";
    VerifyAuthenticationStatus["REFUSED"] = "REFUSED";
    return VerifyAuthenticationStatus;
}({});
var $795db14780a183a3$export$8685c8bab6dce930 = /*#__PURE__*/ function(AuthenticationsMethod) {
    AuthenticationsMethod["SMS"] = "sms";
    AuthenticationsMethod["EMAIL"] = "email";
    AuthenticationsMethod["PINCODE"] = "pincode";
    return AuthenticationsMethod;
}({});

});


parcelRegister("4DiDz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07755aac5fc5b7b6$export$2e2bcd8739ae039; });

var $6JVVB = parcelRequire("6JVVB");

var $61WqT = parcelRequire("61WqT");
class $07755aac5fc5b7b6$export$2e2bcd8739ae039 {
    constructor(serviceDomainApiService){
        this.serviceDomainApiService = serviceDomainApiService;
    }
    async getAuthenticationSession(sessionReference) {
        try {
            const response = await this.serviceDomainApiService.instance.get(`/authentications/sessions/${sessionReference}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationsSessionService", "Failed to get authentication session", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async sendAuthentication(sessionToken, method = (0, $61WqT.AuthenticationsMethod).SMS) {
        try {
            const response = await this.serviceDomainApiService.instance.post(`/authentications/sessions/${sessionToken}/methods/${method}/send`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationsSessionService", "Failed to send authentication SMS", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async verifyAuthentication(sessionToken, code, method = (0, $61WqT.AuthenticationsMethod).SMS) {
        try {
            const response = await this.serviceDomainApiService.instance.post(`/authentications/sessions/${sessionToken}/methods/${method}/verify`, {
                ...method === (0, $61WqT.AuthenticationsMethod).PINCODE ? {
                    pincode: code
                } : {
                    code: code
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthenticationsSessionService", "Failed to send authentication SMS", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async cancelAuthentication(sessionToken) {
        try {
            await this.serviceDomainApiService.instance.post(`/authentications/sessions/${sessionToken}/cancel`);
        } catch (error) {
            (0, $6JVVB.logger).debug("ServiceDomainApiService", "Failed to cancel authentication", error);
            throw error?.response?.data?.error?.message || error?.response?.data?.message || error.toString();
        }
    }
}

});

parcelRegister("pvLbs", function(module, exports) {

$parcel$export(module.exports, "AuthorizationHoldManager", function () { return $de05e0a54bf4873c$export$200fd98c618d345b; });

var $8pxyS = parcelRequire("8pxyS");
class $de05e0a54bf4873c$export$200fd98c618d345b {
    constructor(authorizationHoldService, authenticationManager, clientManager, cacheLoader){
        this.authorizationHoldService = authorizationHoldService;
        this.authenticationManager = authenticationManager;
        this.clientManager = clientManager;
        this.cacheLoader = cacheLoader;
        this.authorizationHoldLoaders = new Map();
        this.defaultAuthorizationHoldLoader = new (0, $8pxyS.AuthorizationHoldLoader)(null, this.authorizationHoldService, this.cacheLoader);
        this.authenticationManager.isConnected.onChange.add(async (isConnected)=>{
            if (!isConnected) await this.clear();
        });
        this.clientManager.onLanguageChange.add(async ()=>{
            await this.clear();
        });
    }
    getDefaultLoader() {
        return this.defaultAuthorizationHoldLoader;
    }
    getTransactionsLoader(accountId) {
        let cache = this.authorizationHoldLoaders.get(accountId);
        if (!cache) {
            cache = new (0, $8pxyS.AuthorizationHoldLoader)(accountId, this.authorizationHoldService, this.cacheLoader);
            this.authorizationHoldLoaders.set(accountId, cache);
        }
        return cache;
    }
    async clear() {
        for (const accountId of this.authorizationHoldLoaders.keys())await this.authorizationHoldLoaders.get(accountId)?.clear();
    }
}

});
parcelRegister("8pxyS", function(module, exports) {

$parcel$export(module.exports, "AuthorizationHoldLoader", function () { return $0cd18739ee600267$export$e3203ba0b4968a7; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");
class $0cd18739ee600267$export$e3203ba0b4968a7 {
    constructor(accountId, authorizationHoldService, cacheLoader){
        this.accountId = accountId;
        this.authorizationHoldService = authorizationHoldService;
        this.cacheLoader = cacheLoader;
        this.data = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.cacheStatus = new (0, $3Ersk.Observable)(null);
        this.initializing = new (0, $3Ersk.Observable)(true);
        this.loading = new (0, $3Ersk.Observable)(false);
        this.refreshing = new (0, $3Ersk.Observable)(false);
        this.error = new (0, $3Ersk.Observable)(null);
        this.loadingMore = new (0, $3Ersk.Observable)(false);
        this.loadingMoreError = new (0, $3Ersk.Observable)(null);
    }
    async load() {
        if (!this.accountId || this.loading.get() || this.refreshing.get()) return;
        this.loading.set(true);
        this.initializing.set(false);
        await this.loadOrRefresh();
        this.loading.set(false);
    }
    async refresh() {
        if (!this.accountId || this.refreshing.get() || this.loading.get()) return;
        this.refreshing.set(true);
        await this.loadOrRefresh(true);
        this.refreshing.set(false);
    }
    async loadOrRefresh(forceRefresh) {
        if (this.accountId) {
            const accountId = this.accountId;
            try {
                this.error.set(null);
                const transactions = await this.cacheLoader.load(()=>this.authorizationHoldService.fetchAuthorizationHolds(accountId, {
                        sort: "-date",
                        offset: 0
                    }), forceRefresh, this.accountId);
                if (!transactions) throw Error("Failed to fetch transactions");
                await this.updateCacheStatus();
                this.data.set(transactions);
            } catch (e) {
                (0, $6JVVB.logger).debug("AuthorizationHoldLoader", "Failed to load or refresh authorizations hold", e);
                this.error.set(e);
                this.data.set((0, $lbTbw.createEmptyPaginatedData)());
            }
        }
    }
    async loadMore() {
        if (this.accountId) {
            const accountId = this.accountId;
            if (!this.accountId || this.loading.get() || this.loadingMore.get()) return;
            try {
                this.loadingMore.set(true);
                this.loadingMoreError.set(null);
                const additional = await this.authorizationHoldService.fetchAuthorizationHolds(accountId, {
                    offset: this.data.get().offset + this.data.get().limit,
                    limit: this.data.get().limit,
                    sort: this.data.get().sort
                });
                this.data.add(additional);
                await this.cacheLoader.store(this.data.get(), this.cacheStatus.get()?.creation, accountId);
            } catch (e) {
                (0, $6JVVB.logger).debug("AuthorizationHoldLoader", "Failed to load more authorizations hold", e);
                this.loadingMoreError.set(e);
            } finally{
                this.loadingMore.set(false);
            }
        }
    }
    async updateCacheStatus() {
        if (this.accountId) {
            const cacheStatus = await this.cacheLoader.readStatus(this.accountId);
            this.cacheStatus.set(cacheStatus);
        }
    }
    async clear() {
        if (this.accountId) {
            await this.cacheLoader.clear(this.accountId);
            this.data.set((0, $lbTbw.createEmptyPaginatedData)());
            this.cacheStatus.set(null);
        }
    }
}

});


parcelRegister("eEO1c", function(module, exports) {

$parcel$export(module.exports, "AuthorizationHoldService", function () { return $3ece7936f52864bf$export$9a03b65ca7e20b36; });

var $6JVVB = parcelRequire("6JVVB");

var $ixrkn = parcelRequire("ixrkn");
class $3ece7936f52864bf$export$9a03b65ca7e20b36 {
    constructor(apiService, featuresManager){
        this.apiService = apiService;
        this.featuresManager = featuresManager;
    }
    async fetchAuthorizationHolds(accountId, pagination) {
        if (!this.featuresManager.features.get().consultAuthorizationHolds) throw new Error("Feature is not enabled");
        try {
            const response = await this.apiService.instance.get("/authorization-holds", {
                params: {
                    accountId: accountId,
                    ...pagination
                }
            });
            return {
                ...response.data,
                items: response.data.items.map((accountingEntry)=>({
                        ...accountingEntry,
                        objectType: (0, $ixrkn.AccountingTransactionType).AuthorizationHold
                    }))
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthorizationHoldService", "Fetching list of authorization hold failed", e);
            throw e;
        }
    }
    async fetchAuthorizationHold(externalId) {
        if (!this.featuresManager.features.get().consultAuthorizationHolds) throw new Error("Feature is not enabled");
        try {
            const response = await this.apiService.instance.get("/authorization-holds", {
                params: {
                    externalId: externalId
                }
            });
            const authorizationHold = response.data.items[0];
            return {
                ...authorizationHold,
                objectType: (0, $ixrkn.AccountingTransactionType).AuthorizationHold
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("AuthorizationHoldService", "Fetching a authorization hold failed", e);
            throw e;
        }
    }
}

});

parcelRegister("agKwC", function(module, exports) {

$parcel$export(module.exports, "MIN_SEARCH_CHARACTERS", function () { return $24b89b546521b5b8$export$b9650dbf9f141f77; });
$parcel$export(module.exports, "BicReferentialManager", function () { return $24b89b546521b5b8$export$e987c73b5aeb49e5; });

var $6JVVB = parcelRequire("6JVVB");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");

var $lRVBj = parcelRequire("lRVBj");
const $24b89b546521b5b8$export$b9650dbf9f141f77 = 3;
class $24b89b546521b5b8$export$e987c73b5aeb49e5 {
    static{
        this.search = "";
    }
    static{
        this.timeoutId = null;
    }
    constructor(bicReferentialService){
        this.bicReferentialService = bicReferentialService;
        this.bics = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.error = new (0, $3Ersk.Observable)(null);
        this.loading = new (0, $3Ersk.Observable)(false);
        this.loadingMore = new (0, $3Ersk.Observable)(false);
        this.loadingMoreError = new (0, $3Ersk.Observable)(null);
        this.canLoadMore = new (0, $3Ersk.Observable)(false);
        this.nextPageUrl = undefined;
        this.getNextPageUrl = (links)=>{
            if (links) {
                const index = links.findIndex((link)=>link.rel === (0, $lRVBj.BicReferentialLinks).NextPage);
                if (index > -1) return links[index].href;
            }
            return undefined;
        };
    }
    async reset(emptySet = false) {
        if (emptySet) {
            $24b89b546521b5b8$export$e987c73b5aeb49e5.search = "";
            this.bics.set((0, $lbTbw.createEmptyPaginatedData)());
        }
        this.loading.set(false);
        this.loadingMore.set(false);
        this.canLoadMore.set(false);
        this.nextPageUrl = undefined;
    }
    async scheduleLoad(search) {
        if (search.length < $24b89b546521b5b8$export$b9650dbf9f141f77) return;
        this.loading.set(true);
        $24b89b546521b5b8$export$e987c73b5aeb49e5.search = search.trim();
        if ($24b89b546521b5b8$export$e987c73b5aeb49e5.timeoutId) {
            clearTimeout($24b89b546521b5b8$export$e987c73b5aeb49e5.timeoutId);
            $24b89b546521b5b8$export$e987c73b5aeb49e5.timeoutId = null;
        }
        $24b89b546521b5b8$export$e987c73b5aeb49e5.timeoutId = setTimeout((function() {
            this.loadAfter();
        }).bind(this), 700);
    }
    loadAfter() {
        this.load($24b89b546521b5b8$export$e987c73b5aeb49e5.search);
        $24b89b546521b5b8$export$e987c73b5aeb49e5.timeoutId = null;
    }
    async load(search) {
        try {
            this.error.set(null);
            const bicsResult = await this.bicReferentialService.searchBic(search);
            if (!bicsResult) throw Error("Failed to fetch bics");
            const { links: links, ...bics } = bicsResult;
            this.nextPageUrl = this.getNextPageUrl(links);
            this.canLoadMore.set((0, $gDlNU.isDefined)(this.nextPageUrl));
            this.bics.set(bics);
            this.loading.set(false);
        } catch (e) {
            this.loading.set(false);
            if (!(e instanceof $24b89b546521b5b8$export$d7821f06112bf778)) {
                this.error.set(e);
                (0, $6JVVB.logger).debug("BicReferentialManager", "Fetch bics failed: ", JSON.stringify(e));
                this.bics.set((0, $lbTbw.createEmptyPaginatedData)());
                throw e;
            }
        }
    }
    async loadMore() {
        if (this.loading.get() || this.loadingMore.get()) return;
        try {
            this.loadingMore.set(true);
            this.loadingMoreError.set(null);
            const additional = await this.bicReferentialService.searchBic($24b89b546521b5b8$export$e987c73b5aeb49e5.search, this.nextPageUrl);
            const { links: links, ...bics } = additional;
            this.nextPageUrl = this.getNextPageUrl(links);
            this.canLoadMore.set((0, $gDlNU.isDefined)(this.nextPageUrl));
            this.bics.add(bics);
            this.loadingMore.set(false);
        } catch (e) {
            this.loadingMoreError.set(e);
            (0, $6JVVB.logger).debug("BicReferentialManager", "Load more bics failed", e);
            this.loadingMore.set(false);
        }
    }
}
class $24b89b546521b5b8$export$d7821f06112bf778 extends Error {
    constructor(message){
        super(message);
    }
}

});
parcelRegister("lRVBj", function(module, exports) {

$parcel$export(module.exports, "BicReferentialLinks", function () { return $87c1a04be40710a6$export$54b662eaac6fbbc2; });
var $87c1a04be40710a6$export$54b662eaac6fbbc2 = /*#__PURE__*/ function(BicReferentialLinks) {
    BicReferentialLinks["CurrentPage"] = "getCurrentpage";
    BicReferentialLinks["NextPage"] = "getNextPage";
    BicReferentialLinks["PreviousPage"] = "getPreviousPage";
    return BicReferentialLinks;
}({});

});


parcelRegister("ixbyZ", function(module, exports) {

$parcel$export(module.exports, "BicReferentialService", function () { return $d52a50eab2f1b189$export$9dc080c776159e7b; });

var $6JVVB = parcelRequire("6JVVB");
class $d52a50eab2f1b189$export$9dc080c776159e7b {
    constructor(apiService){
        this.apiService = apiService;
    }
    async searchBic(search, url) {
        try {
            const response = await this.apiService.instance.get(url ?? "/bic-referential", {
                params: {
                    search: search,
                    limit: 200
                }
            });
            const result = response.data;
            return result;
        } catch (e) {
            (0, $6JVVB.logger).debug("BicReferentialService", "Search Bic failed", JSON.stringify(e));
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("4kWAI", function(module, exports) {

$parcel$export(module.exports, "BillIssuerManager", function () { return $964227b759485b34$export$3749b06d5dd75456; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $a2Egq = parcelRequire("a2Egq");
class $964227b759485b34$export$3749b06d5dd75456 {
    constructor(billService, authenticationManager, clientManager, cacheLoader, analyticsService, deviceInfoService){
        this.billService = billService;
        this.authenticationManager = authenticationManager;
        this.clientManager = clientManager;
        this.cacheLoader = cacheLoader;
        this.analyticsService = analyticsService;
        this.deviceInfoService = deviceInfoService;
        this.issuers = new (0, $a2Egq.ObservableTree)([]);
        this.loading = new (0, $3Ersk.Observable)(true);
        this.error = new (0, $3Ersk.Observable)(null);
        this.refreshing = new (0, $3Ersk.Observable)(false);
        this.cacheStatus = new (0, $3Ersk.Observable)(null);
        this.authenticationManager.isAuthenticated.onChange.add(async (isAuthenticated)=>{
            if (!isAuthenticated) await this.clear();
            else await this.load();
        });
        this.clientManager.onLanguageChange.add(async ()=>{
            (0, $6JVVB.logger).debug("clientManager.onLanguageChange");
            await this.clear();
            await this.load();
        });
    }
    async load(billItemId) {
        this.loading.set(true);
        (0, $6JVVB.logger).debug("load issuers");
        await this.loadOrRefresh(billItemId);
        this.loading.set(false);
    }
    async refresh(billItemId) {
        this.refreshing.set(true);
        (0, $6JVVB.logger).debug("refresh issuers");
        await this.loadOrRefresh(billItemId, true);
        this.refreshing.set(false);
    }
    async loadOrRefresh(billItemId, forceRefresh) {
        (0, $6JVVB.logger).debug("loadOrRefresh");
        this.addObservability(forceRefresh);
        try {
            this.error.set(null);
            const issuers = await this.cacheLoader.load(()=>this.billService.fetchIssuers(billItemId), forceRefresh);
            if (!issuers) throw new Error("Failed to refresh bill issuers");
            await this.updateCacheStatus();
            this.issuers.set(issuers);
        } catch (e) {
            this.error.set(e);
        }
    }
    async saveReference(issuer, newReference) {
        const newIssuer = await this.billService.saveReference(issuer, newReference);
        this.issuers.replace(newIssuer, (existingIssuer)=>existingIssuer.id === newIssuer.id);
        this.cacheLoader.store(this.issuers.get());
        await this.updateCacheStatus();
    }
    async deleteReference(issuer) {
        await this.billService.deleteReference(issuer);
        this.cacheLoader.store(this.issuers.get());
        await this.updateCacheStatus();
        await this.refresh();
    }
    async clear() {
        (0, $6JVVB.logger).debug("clear issuers");
        await this.cacheLoader.clear();
        this.issuers.set([]);
        this.cacheStatus.set(null);
    }
    async updateCacheStatus() {
        const cacheStatus = await this.cacheLoader.readStatus();
        this.cacheStatus.set(cacheStatus);
    }
    async addObservability(forceRefresh) {
        try {
            const isValid = await this.cacheLoader.isValid();
            if (!isValid) {
                const message = "bill_issuers_cache_is_not_valid";
                (0, $6JVVB.logger).debug(message);
                await this.analyticsService.event(message, {
                    device_model: this.deviceInfoService.getModel()
                });
            }
            if (isValid && forceRefresh) {
                const message = "bill_issuers_cache_force_the_refresh";
                (0, $6JVVB.logger).debug(message);
                await this.analyticsService.event(message, {
                    device_model: this.deviceInfoService.getModel()
                });
            }
        } catch (error) {
            (0, $6JVVB.logger).error("BillIssuerManager: ", error);
        }
    }
}

});
parcelRegister("a2Egq", function(module, exports) {

$parcel$export(module.exports, "ObservableTree", function () { return $50ea5260dba6cf28$export$25bb868c9b1d635a; });

var $3Ersk = parcelRequire("3Ersk");
class $50ea5260dba6cf28$export$25bb868c9b1d635a extends (0, $3Ersk.Observable) {
    constructor(val){
        super(val);
    }
    replace(newValue, comparator) {
        const newTree = $50ea5260dba6cf28$var$replaceInTree(this.get(), newValue, comparator);
        this.set(newTree);
    }
}
function $50ea5260dba6cf28$var$replaceInTree(tree, newValue, comparator) {
    const t = [
        ...tree
    ];
    const index = t.findIndex((item)=>comparator(item));
    if (index >= 0) t[index] = newValue;
    tree.forEach((item)=>{
        const children = item.children;
        if (children && children.length > 0) item.children = $50ea5260dba6cf28$var$replaceInTree(children, newValue, comparator);
    });
    return t;
}

});


parcelRegister("lIleL", function(module, exports) {

$parcel$export(module.exports, "BillIssuerSelectionManager", function () { return $9a9c18d521b34421$export$e40412a43e90a564; });

var $3Ersk = parcelRequire("3Ersk");
class $9a9c18d521b34421$export$e40412a43e90a564 {
    constructor(authenticationManager, clientManager){
        this.authenticationManager = authenticationManager;
        this.clientManager = clientManager;
        this.search = new (0, $3Ersk.Observable)(undefined);
        this.hierarchy = new (0, $3Ersk.Observable)([]);
        this.authenticationManager.isConnected.onChange.add((isConnected)=>{
            if (!isConnected) this.clear();
            this.clientManager.onLanguageChange.add(()=>{
                this.clear();
            });
        });
    }
    clear() {
        this.search.set(undefined);
        this.hierarchy.set([]);
    }
}

});

parcelRegister("1GrnA", function(module, exports) {

$parcel$export(module.exports, "BillManager", function () { return $672647f77533dc42$export$4dd55463f98fe72a; });

var $8MdLL = parcelRequire("8MdLL");

var $5QnaE = parcelRequire("5QnaE");
class $672647f77533dc42$export$4dd55463f98fe72a {
    constructor(billService, geolocationManager, accountManager, transactionsManager){
        this.billService = billService;
        this.geolocationManager = geolocationManager;
        this.accountManager = accountManager;
        this.transactionsManager = transactionsManager;
    }
    async initPayBill(issuerId) {
        const location = await this.geolocationManager.updatePosition();
        return this.billService.initPayBill(issuerId, location);
    }
    async payBill(billSession, inputValues) {
        return this.billService.payBill(billSession, inputValues);
    }
    async validateBillPayment(billSession, confirmationMode, pincode) {
        const result = await this.billService.validateBillPayment(billSession, confirmationMode, pincode);
        await this.refreshAccountAndTransactions(result.metadata.transaction);
        return result;
    }
    refreshAccountAndTransactions(transaction) {
        (0, $8MdLL.runAfterInteractions)(async ()=>{
            const accountIds = (0, $5QnaE.accountsAffectedByTransaction)(transaction);
            await this.accountManager.refresh();
            await this.transactionsManager.refresh(accountIds);
        });
    }
}

});
parcelRegister("8MdLL", function(module, exports) {

$parcel$export(module.exports, "runAfterInteractions", function () { return $a0741ebd17e054d0$export$5fd614336353534a; });
const $a0741ebd17e054d0$export$5fd614336353534a = (task)=>{
    if (task) task();
};

});

parcelRegister("5QnaE", function(module, exports) {

$parcel$export(module.exports, "accountsAffectedByTransaction", function () { return $b2dcee296292e459$export$3855f6c2db59f00d; });
function $b2dcee296292e459$export$3855f6c2db59f00d(transaction) {
    const accountIds = [];
    if (transaction.detailedAccounting) transaction.detailedAccounting.map((accountingEntry)=>{
        if (!accountIds.includes(accountingEntry.accountId)) accountIds.push(accountingEntry.accountId);
    });
    return accountIds;
}

});


parcelRegister("6kH50", function(module, exports) {

$parcel$export(module.exports, "BillService", function () { return $488b7960bc35ed4e$export$50b422f27467479c; });

var $6JVVB = parcelRequire("6JVVB");

var $1YFGv = parcelRequire("1YFGv");
class $488b7960bc35ed4e$export$50b422f27467479c {
    constructor(apiService){
        this.apiService = apiService;
    }
    async initPayBill(issuerId, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/paybill", {
                location: location ? {
                    latitude: location.coords.latitude,
                    longitude: location.coords.longitude
                } : undefined,
                billIssuerId: issuerId
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BillService", "Init pay bill failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async payBill(billSession, inputValues) {
        try {
            const response = await this.apiService.instance.patch(`/transactions/paybill/${billSession}`, {
                inputs: inputValues
            });
            if (response.status === 200) return {
                data: response.data,
                done: false
            };
            else return {
                data: response.data,
                done: true
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("BillService", "Pay bill failed", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async validateBillPayment(billSession, confirmationMode, pincode) {
        try {
            const response = await this.apiService.instance.post(`/transactions/paybill/${billSession}`, {
                confirmationMode: confirmationMode,
                pincode: pincode
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BillService", "Validate bill payment failed", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async fetchIssuers(billItemId) {
        try {
            const response = await this.apiService.instance.get("/billers", {
                ...billItemId && {
                    params: {
                        billItemId: billItemId
                    }
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BillService", "Fetch issuers failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async saveReference(issuer, value) {
        try {
            const response = await this.apiService.instance.post(`/billers/${issuer.id}/references`, {
                reference: value
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BillService", "Save reference failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async deleteReference(issuer) {
        if (!issuer.references) {
            (0, $6JVVB.logger).error(`Trying to remove reference from issuer ${issuer}`);
            return issuer;
        }
        try {
            const response = await this.apiService.instance.delete(`/billers/${issuer.id}/references/${issuer.references[0]}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BillService", "Delete reference failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("dtKQH", function(module, exports) {

$parcel$export(module.exports, "CardFilterManager", function () { return $8f585aa0df9bad69$export$40e39c11f30b1db6; });

var $3Ersk = parcelRequire("3Ersk");

var $jSdHh = parcelRequire("jSdHh");
class $8f585aa0df9bad69$export$40e39c11f30b1db6 {
    setStatusSelection(status) {
        this.statusSelection.set(status);
    }
    clear() {
        this.statusSelection.set((0, $jSdHh.CardStatus).ALL);
    }
    constructor(){
        this.statusSelection = new (0, $3Ersk.Observable)((0, $jSdHh.CardStatus).ALL);
    }
}

});
parcelRegister("jSdHh", function(module, exports) {

$parcel$export(module.exports, "CardStatus", function () { return $05c9e270fed73ffc$export$490c7ce941281ba8; });
var $05c9e270fed73ffc$export$490c7ce941281ba8 = /*#__PURE__*/ function(CardStatus) {
    CardStatus["ALL"] = "ALL";
    CardStatus["NEW"] = "NEW";
    CardStatus["PENDING"] = "PENDING";
    CardStatus["ACTIVE"] = "ACTIVE";
    CardStatus["EXPIRED"] = "EXPIRED";
    CardStatus["REMOVED"] = "REMOVED";
    CardStatus["BLOCKED"] = "BLOCKED";
    CardStatus["OPPOSED"] = "OPPOSED";
    CardStatus["CANCELLED"] = "CANCELLED";
    return CardStatus;
}({});

});


parcelRegister("1qf9N", function(module, exports) {

$parcel$export(module.exports, "CREATE_PINCODE", function () { return $a8e620dbfd1e3435$export$e7f1d7a4f28d50b9; });
$parcel$export(module.exports, "UPDATE_PINCODE", function () { return $a8e620dbfd1e3435$export$d0cae3342f225313; });
$parcel$export(module.exports, "CardManager", function () { return $a8e620dbfd1e3435$export$2048cdcc63bae7e9; });

var $kpnq8 = parcelRequire("kpnq8");

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $fsofG = parcelRequire("fsofG");

var $jSdHh = parcelRequire("jSdHh");
const $a8e620dbfd1e3435$export$e7f1d7a4f28d50b9 = false;
const $a8e620dbfd1e3435$export$d0cae3342f225313 = true;
const $a8e620dbfd1e3435$export$787064594c96d09c = [
    (0, $jSdHh.CardStatus).CANCELLED,
    (0, $jSdHh.CardStatus).REMOVED,
    (0, $jSdHh.CardStatus).EXPIRED
];
class $a8e620dbfd1e3435$export$2048cdcc63bae7e9 {
    constructor(cardService, authenticationManager, cardDetailManager){
        this.cardService = cardService;
        this.authenticationManager = authenticationManager;
        this.cardDetailManager = cardDetailManager;
        this.cards = new (0, $fsofG.ObservableArray)([]);
        this.outstandings = new (0, $fsofG.ObservableArray)([]);
        this.publicKey = new (0, $3Ersk.Observable)(null);
        this.privateKey = new (0, $3Ersk.Observable)(null);
        this.onCardStatusWillChange = new (0, $kpnq8.Signal)();
        this.authenticationManager.isConnected.onChange.add((isConnected)=>{
            if (!isConnected) this.clear();
        });
    }
    async refresh(status) {
        try {
            const cards = await this.cardService.fetchCards({}, status);
            this.cards.set(cards.items.filter((i)=>!$a8e620dbfd1e3435$export$787064594c96d09c.includes(i.status)));
            this.outstandings.set([]);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to refresh", e);
            throw e;
        }
    }
    async oppose(cardId, reason) {
        try {
            const opposedCard = await this.cardService.opposeCard(cardId, reason);
            this.cards.replace(opposedCard, (card)=>card.id === cardId);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to oppose card", e);
            throw e;
        }
    }
    async block(cardId) {
        try {
            this.onCardStatusWillChange.dispatch((0, $jSdHh.CardStatus).BLOCKED);
            const blockedCard = await this.cardService.blockCard(cardId);
            this.cards.replace(blockedCard, (card)=>card.id === cardId);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to block card", e);
            throw e;
        }
    }
    async unblock(cardId) {
        try {
            this.onCardStatusWillChange.dispatch((0, $jSdHh.CardStatus).ACTIVE);
            const unblockedCard = await this.cardService.unblockCard(cardId);
            this.cards.replace(unblockedCard, (card)=>card.id === cardId);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to unblock card", e);
            throw e;
        }
    }
    async activate(cardId, activationCode, scaSessionToken) {
        try {
            const activatedCard = await this.cardService.activateCard(cardId, activationCode, scaSessionToken || "");
            this.cards.replace(activatedCard, (card)=>card.id === cardId);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to activate card", e);
            throw e;
        }
    }
    async deactivate(cardId, scaSessionToken) {
        try {
            const deactivatedCard = await this.cardService.deactivateCard(cardId, scaSessionToken);
            this.cards.replace(deactivatedCard, (card)=>card.id === cardId);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to deactivate card", e);
            throw e;
        }
    }
    async enableFeature(cardId, feature, isEnabled) {
        try {
            const updatedCard = await this.cardService.enableCardFeature(cardId, feature, isEnabled);
            this.cards.replace(updatedCard, (card)=>card.id === cardId);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to enable feature", e);
            throw e;
        }
    }
    async createCard(accountId, productId, pincode, scaToken, isVirtual) {
        try {
            const createdCard = await this.cardService.createCard(accountId, productId, pincode, scaToken || "", isVirtual);
            this.cards.set([
                ...this.cards.get(),
                createdCard
            ]);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to create card", e);
            throw e;
        }
    }
    async reissuePincode(cardId, newPincode, withChannel, scaSessionToken) {
        try {
            const modifiedCard = await this.cardService.reissuePincode(cardId, newPincode, withChannel, scaSessionToken || "");
            this.cards.replace(modifiedCard, (card)=>card.id === cardId);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to reissue Pin code for card", e);
            throw e;
        }
    }
    async retrieveCard(cardId) {
        try {
            const updatedCard = await this.cardService.retrieveCard(cardId);
            this.cards.replace(updatedCard, (card)=>card.id === cardId);
            return updatedCard;
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to retrieve card", e);
            throw e;
        }
    }
    async getCardImage(cardId) {
        try {
            const cardImage = await this.cardService.getCardImage(cardId);
            return cardImage;
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to get card image", e);
            return "";
        }
    }
    async getOutstandingsCard(cardId, url) {
        try {
            this.outstandings.set([]);
            const cardOutstandings = await this.cardService.getOutstandings(cardId, url);
            this.outstandings.set(cardOutstandings);
            return cardOutstandings;
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to get oustandings card", e);
            throw e;
        }
    }
    async updateOutstanding(cardId, params, scaToken) {
        try {
            await this.cardService.updateOutstanding(cardId, params, scaToken || "");
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to enable feature", e);
            throw e;
        }
    }
    async refabricateCard(cardId, replacementReason, scaToken) {
        try {
            await this.cardService.refabricateCard(cardId, replacementReason, scaToken || "");
        } catch (e) {
            (0, $6JVVB.logger).debug("CardManager", "Failed to refabricate Card", e);
            throw e;
        }
    }
    async getSensitiveCardDetails(cardId, scaToken) {
        return this.cardDetailManager.getSensitiveCardDetails(cardId, scaToken);
    }
    clear() {
        this.cards.set([]);
        this.outstandings.set([]);
    }
}

});

parcelRegister("VHpFU", function(module, exports) {

$parcel$export(module.exports, "CardService", function () { return $1d180ea6f93198ef$export$1926ec33ea263be2; });

var $b0kMB = parcelRequire("b0kMB");

var $6JVVB = parcelRequire("6JVVB");

var $gDlNU = parcelRequire("gDlNU");

var $Pnk5J = parcelRequire("Pnk5J");
class $1d180ea6f93198ef$export$1926ec33ea263be2 {
    constructor(apiService, serviceDomainService){
        this.apiService = apiService;
        this.serviceDomainService = serviceDomainService;
    }
    async fetchCards(pagination, status) {
        try {
            const response = await this.apiService.instance.get("/cards", {
                params: {
                    ...pagination,
                    status: status
                }
            });
            return {
                ...response.data,
                items: response.data.items.map((dto)=>this.transformDtoToCard(dto))
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Fetch cards failed", e);
            throw e;
        }
    }
    async opposeCard(id, reason) {
        try {
            const response = await this.apiService.instance.post(`/cards/${id}/_actions/oppose`, {
                reason: reason
            });
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Oppose card failed", e);
            throw e;
        }
    }
    async blockCard(id) {
        try {
            const response = await this.apiService.instance.post(`/cards/${id}/_actions/block`);
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Block card failed", e);
            throw e;
        }
    }
    async unblockCard(id) {
        try {
            const response = await this.apiService.instance.post(`/cards/${id}/_actions/unblock`);
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Unblock card failed", e);
            throw e;
        }
    }
    async activateCard(id, activationCode, scaSessionToken) {
        try {
            const body = (0, $gDlNU.isDefined)(activationCode) && activationCode.length > 0 ? {
                code: activationCode
            } : undefined;
            const response = await this.apiService.instance.post(`/cards/${id}/_actions/activate`, body, {
                headers: scaSessionToken ? {
                    "SCAP-Token": scaSessionToken
                } : {}
            });
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Activate card failed", e);
            throw e;
        }
    }
    async deactivateCard(id, scaSessionToken) {
        try {
            const response = await this.apiService.instance.delete(`/cards/${id}/_actions/deactivate`, {
                headers: scaSessionToken ? {
                    "SCAP-Token": scaSessionToken
                } : {}
            });
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Deactivate card failed", e);
            throw e;
        }
    }
    async enableCardFeature(id, feature, isEnabled) {
        try {
            const response = await this.apiService.instance.patch(`/cards/${id}/features`, {
                id: feature,
                enabled: isEnabled
            });
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Enable card feature failed", e);
            throw e;
        }
    }
    async createCard(accountId, productId, pincode, scaToken, isVirtual) {
        try {
            const response = await this.apiService.instance.post(`/accounts/${accountId}/${isVirtual ? "cards-virtual" : "cards"}`, {
                productId: productId,
                pincode: pincode
            }, {
                headers: scaToken ? {
                    "SCAP-Token": scaToken
                } : {}
            });
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Enable card feature failed", e);
            throw e;
        }
    }
    async reissuePincode(id, pincode, withChannel, scaSessionToken) {
        try {
            const body = withChannel ? {
                newPin: pincode,
                channnel: "APP"
            } : {
                newPin: pincode
            };
            const response = await this.apiService.instance.post(`/cards/${id}/_actions/pinCodeReissuing`, body, {
                headers: scaSessionToken ? {
                    "SCAP-Token": scaSessionToken
                } : {}
            });
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Reissue Pin code for card failed", e);
            throw e;
        }
    }
    async retrieveCard(id) {
        try {
            const response = await this.apiService.instance.get(`/cards/${id}`);
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Retrieve card failed", e);
            throw e;
        }
    }
    async getCardImage(id) {
        try {
            const response = await this.apiService.instance.get(`/cards/${id}/image`, {
                responseType: "arraybuffer"
            });
            const base64 = (0, $b0kMB.Buffer).from(response.data, "binary").toString("base64");
            return base64;
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Get card image failed", e);
            throw e;
        }
    }
    async getOutstandings(id, url) {
        try {
            const response = await this.apiService.instance.get(url ?? `/cards/${id}/outstandings`);
            if (response.data.outstandings && response.data.outstandings.length > 0) {
                const formatted = response.data.outstandings.map((outstandingDTO)=>this.transformDtoToOutstanding(outstandingDTO));
                return formatted;
            } else return [];
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Get outstandings failed", JSON.stringify(e));
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async updateOutstanding(card_id, params, scaToken) {
        try {
            const response = await this.apiService.instance.patch(`/cards/${card_id}/limits`, params, {
                headers: scaToken ? {
                    "SCAP-Token": scaToken
                } : {}
            });
            return this.transformDtoToCard(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "Enable card feature failed", e);
            throw e;
        }
    }
    async refabricateCard(card_id, replacement_reason, scaToken) {
        try {
            const response = await this.apiService.instance.patch(`/cards/${card_id}/refabricate`, {
                replacement_reason: replacement_reason
            }, {
                headers: scaToken ? {
                    "SCAP-Token": scaToken
                } : {}
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("CardService", "refabricateCard failed", e);
            throw e || e.toString();
        }
    }
    transformDtoToCard(card) {
        return {
            ...card,
            id: card.id.toString()
        };
    }
    transformDtoToOutstanding(outstanding) {
        const maxValue = outstanding.limit.value;
        const usedValue = outstanding.current.value;
        const availableValue = maxValue - usedValue >= 0 ? maxValue - usedValue : 0;
        return {
            id: outstanding.id,
            title: outstanding.label ?? "",
            maxValue: maxValue,
            usedValue: usedValue,
            availableValue: availableValue,
            maxAmount: (0, $Pnk5J.amount)(maxValue, outstanding.limit.currency),
            usedAmount: (0, $Pnk5J.amount)(usedValue, outstanding.current.currency),
            availableAmount: (0, $Pnk5J.amount)(availableValue, outstanding.current.currency),
            isPayment: (0, $Pnk5J.isPayment)(outstanding.type),
            period: outstanding.period,
            specificPeriod: outstanding.specificPeriod,
            type: outstanding.type
        };
    }
    async scaAuthenticationVerifyToken(token, otpCode, method = "sms") {
        try {
            const url = `/authentications/sessions/${token}/methods/${method}/verify`;
            const response = await this.serviceDomainService.instance.post(url, {
                code: otpCode
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ServiceDomainService", "SCA verify token failed", e);
            throw e.response.data.message;
        }
    }
    async getSensitiveCardDetails(cardId, publicKey, scaToken) {
        try {
            const response = await this.apiService.instance.post(`/cards/${cardId}/details`, {
                publicKey: publicKey
            }, {
                headers: scaToken ? {
                    "SCAP-Token": scaToken
                } : {}
            });
            return response.data;
        } catch (e) {
            // if (e.response.data.error.code === 500) {
            // 	return {
            // 		encryptedPan: this.sodium.to_hex(
            // 			this.sodium.crypto_box_seal("0812081208120812", this.sodium.from_hex(publicKey))
            // 		),
            // 		encryptedCvv: this.sodium.to_hex(this.sodium.crypto_box_seal("123", this.sodium.from_hex(publicKey))),
            // 		expirationMonth: 9,
            // 		expirationYear: 2023,
            // 	};
            // } else {
            (0, $6JVVB.logger).debug("CardService", "Get sensitive card details failed", e);
            throw e;
        // }
        }
    }
}

});
parcelRegister("Pnk5J", function(module, exports) {

$parcel$export(module.exports, "OutstandingsType", function () { return $6a956a2ec72fe743$export$d1ff6b24bfe1fe6d; });
$parcel$export(module.exports, "DurationUnit", function () { return $6a956a2ec72fe743$export$5c92cf4c87d0aa6a; });
$parcel$export(module.exports, "isPayment", function () { return $6a956a2ec72fe743$export$f64f46775ba5bcfe; });
$parcel$export(module.exports, "amount", function () { return $6a956a2ec72fe743$export$802cfe72001a1ee; });

var $5P656 = parcelRequire("5P656");

var $8xKCH = parcelRequire("8xKCH");

var $gDlNU = parcelRequire("gDlNU");
var $6a956a2ec72fe743$export$d1ff6b24bfe1fe6d = /*#__PURE__*/ function(OutstandingsType) {
    OutstandingsType[OutstandingsType["None"] = 0] = "None";
    OutstandingsType[OutstandingsType["Payments"] = 1] = "Payments";
    OutstandingsType[OutstandingsType["Cashouts"] = 2] = "Cashouts";
    return OutstandingsType;
}({});
var $6a956a2ec72fe743$export$5c92cf4c87d0aa6a = /*#__PURE__*/ function(DurationUnit) {
    DurationUnit["Hour"] = "HOUR";
    DurationUnit["Week"] = "WEEK";
    DurationUnit["Day"] = "DAY";
    DurationUnit["Month"] = "MONTH";
    DurationUnit["Year"] = "YEAR";
    return DurationUnit;
}({});
const $6a956a2ec72fe743$var$cashoutTypes = [
    "LIMIT_CASHOUT_DAY",
    "LIMIT_CASHOUT_WEEK",
    "LIMIT_CASHOUT_MONTH",
    "LIMIT_CASHOUT_YEAR",
    "LIMIT_CASHOUT_ALL"
];
const $6a956a2ec72fe743$var$paymentTypes = [
    "LIMIT_PAYMENT_DAY",
    "LIMIT_PAYMENT_WEEK",
    "LIMIT_PAYMENT_MONTH",
    "LIMIT_PAYMENT_YEAR",
    "LIMIT_PAYMENT_ALL"
];
function $6a956a2ec72fe743$export$f64f46775ba5bcfe(outstandingType) {
    if (outstandingType) return $6a956a2ec72fe743$var$paymentTypes.includes(outstandingType);
    return false;
}
function $6a956a2ec72fe743$export$802cfe72001a1ee(value, currency) {
    if ((0, $gDlNU.isDefined)(currency) && (0, $gDlNU.isDefined)((0, $8xKCH.Currencies)[currency])) {
        const amountVal = (0, $5P656.amountValueForCurrency)(value, currency);
        return new (0, $5P656.Amount)(amountVal, currency);
    }
}

});
parcelRegister("5P656", function(module, exports) {

$parcel$export(module.exports, "Amount", function () { return $4971bb8311852ab3$export$5a2795e4838b67d2; });
$parcel$export(module.exports, "addAmounts", function () { return $4971bb8311852ab3$export$a88b6d85e1d50684; });
$parcel$export(module.exports, "diffAmount", function () { return $4971bb8311852ab3$export$68a50cb64618fcb1; });
$parcel$export(module.exports, "getAmountValueString", function () { return $4971bb8311852ab3$export$f0ca20aec1533756; });
$parcel$export(module.exports, "amountValueForCurrency", function () { return $4971bb8311852ab3$export$ae046339847fe2c7; });
$parcel$export(module.exports, "switchCurrency", function () { return $4971bb8311852ab3$export$892440987a99df31; });
$parcel$export(module.exports, "sanitizeAmountValue", function () { return $4971bb8311852ab3$export$b833dcd37203286c; });
$parcel$export(module.exports, "validAmountRegex", function () { return $4971bb8311852ab3$export$f216d9ddceb7e5d; });

var $8xKCH = parcelRequire("8xKCH");
class $4971bb8311852ab3$export$5a2795e4838b67d2 {
    constructor(value, currency, originalInput){
        this.currency = currency;
        const currencyData = (0, $8xKCH.Currencies)[currency];
        const decimalPlaces = currencyData ? currencyData.decimal_number : 2;
        // Store value as an integer of the smallest unit (e.g., cents)
        this.value = Math.round((value ?? 0) * Math.pow(10, decimalPlaces));
        // Preserve the exact original input if provided
        this.originalInput = originalInput?.trim();
    }
}
function $4971bb8311852ab3$export$a88b6d85e1d50684(...amounts) {
    const currency = amounts[0].currency;
    const currencyData = (0, $8xKCH.Currencies)[currency];
    return new $4971bb8311852ab3$export$5a2795e4838b67d2(amounts.reduce((total, amount)=>{
        if (currency != amount.currency) throw new Error("trying to add amounts with different currencies");
        return total + amount.value / Math.pow(10, currencyData.decimal_number);
    }, 0), currency);
}
function $4971bb8311852ab3$export$68a50cb64618fcb1(firstAmount, secondAmount) {
    const diffVal = (Math.abs(firstAmount.value) - Math.abs(secondAmount.value)) / Math.pow(10, (0, $8xKCH.Currencies)[firstAmount.currency].decimal_number);
    return new $4971bb8311852ab3$export$5a2795e4838b67d2(diffVal, firstAmount.currency);
}
function $4971bb8311852ab3$export$ccb72270459eb409(firstAmount, secondAmount) {
    return Math.abs(firstAmount.value) < Math.abs(secondAmount.value);
}
function $4971bb8311852ab3$export$b7510e0666cb6ae6(amount) {
    const absoluteVal = Math.abs(amount.value) / Math.pow(10, (0, $8xKCH.Currencies)[amount.currency]?.decimal_number);
    return new $4971bb8311852ab3$export$5a2795e4838b67d2(absoluteVal, amount.currency);
}
function $4971bb8311852ab3$export$f0ca20aec1533756(amount) {
    if (amount.originalInput !== undefined) return amount.originalInput.replace(/^0+(?=\d)/, "");
    const decimalNumber = (0, $8xKCH.Currencies)[amount.currency]?.decimal_number ?? 2;
    const valueString = (amount.value / 10 ** decimalNumber).toFixed(decimalNumber);
    // Return "0" for exact zero values
    if (parseFloat(valueString) === 0) return "0";
    // Remove trailing zeros only if the user did not explicitly enter them
    return valueString.replace(/(?:\.0+|(\.\d*?[1-9])0+)$/, "$1");
}
function $4971bb8311852ab3$export$ae046339847fe2c7(value, currency) {
    const currencyData = (0, $8xKCH.Currencies)[currency];
    if (!currencyData) throw new Error(`Currency ${currency} not found in Currencies object`);
    return value / Math.pow(10, currencyData.decimal_number);
}
function $4971bb8311852ab3$var$convertValue(value, oldDecimals, newDecimals) {
    const decimalValue = value / Math.pow(10, oldDecimals);
    const integerPart = Math.trunc(decimalValue);
    const decimalPart = Math.trunc((decimalValue - integerPart) * Math.pow(10, newDecimals) + 0.00001);
    return integerPart + decimalPart / Math.pow(10, newDecimals);
}
function $4971bb8311852ab3$export$892440987a99df31(amount, currency) {
    const convertedValue = $4971bb8311852ab3$var$convertValue(amount.value, (0, $8xKCH.Currencies)[amount.currency].decimal_number, (0, $8xKCH.Currencies)[currency].decimal_number);
    return new $4971bb8311852ab3$export$5a2795e4838b67d2(convertedValue, currency);
}
const $4971bb8311852ab3$export$b833dcd37203286c = (str, decimals)=>{
    let safeValue = "";
    if (str) {
        str = str.replace(/,/g, ".");
        // Remove invalid characters and handle leading period
        const sanitizedString = str.replace(/[^0-9.]/g, "").replace(/^\./, "0.");
        const index = sanitizedString.indexOf(".");
        if (index > 0) {
            const lengthMax = Math.min(sanitizedString.length, index + 1 + decimals);
            const decimalPart = sanitizedString.substring(index + 1, lengthMax);
            safeValue = sanitizedString.substring(0, index + 1) + decimalPart;
        } else safeValue = sanitizedString;
    }
    if (parseFloat(safeValue) === 0) return "0";
    return safeValue;
};
const $4971bb8311852ab3$export$f216d9ddceb7e5d = /^(?!.*[.,]{2})\d*(?:[.,]\d{0,2})?$/;
function $4971bb8311852ab3$export$4233d2f7dfbd86fc(amount1, amount2) {
    return amount1.value === amount2.value && amount1.currency === amount2.currency;
}

});



parcelRegister("6daXU", function(module, exports) {

$parcel$export(module.exports, "ClientManager", function () { return $bc9f7d0b6eb2f989$export$4c2a11cba7d29ac0; });

var $kpnq8 = parcelRequire("kpnq8");

var $6JVVB = parcelRequire("6JVVB");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $2Rggt = parcelRequire("2Rggt");

var $1eErS = parcelRequire("1eErS");
class $bc9f7d0b6eb2f989$export$4c2a11cba7d29ac0 {
    constructor(clientService, featuresManager, cacheLoader){
        this.clientService = clientService;
        this.featuresManager = featuresManager;
        this.cacheLoader = cacheLoader;
        this.clientWithKycActionsLoading = new (0, $3Ersk.Observable)(false);
        this.initiateInfoNotChangedLoading = new (0, $3Ersk.Observable)(false);
        this.client = new (0, $3Ersk.Observable)(null);
        this.clientWithKycActions = new (0, $3Ersk.Observable)(null);
        this.clientWithKycActionsError = new (0, $3Ersk.Observable)(null);
        this.initiateInfoNotChangedError = new (0, $3Ersk.Observable)(null);
        this.onLanguageChange = new (0, $kpnq8.Signal)();
    }
    async initialize() {
        const client = await this.cacheLoader.read();
        this.client.set(client);
    }
    async updateClient(forceRefresh) {
        if (this.featuresManager.features.get().clientInformationView) {
            const client = await this.cacheLoader.load(()=>this.clientService.fetchClient(), forceRefresh);
            // A refresh that comes back empty says the call failed, not that the holder is gone: the
            // last known client stands. Publishing null here logged the screens out for an instant,
            // since they read a null client as "no session". Only clear() ends a session.
            if (!client) throw new (0, $1eErS.ClientNotLoadedError)("Failed to update client");
            this.client.set(client);
            return client;
        }
        if (forceRefresh) (0, $6JVVB.logger).debug("Missing kyc_view scope to retrieve client");
        else throw new (0, $1eErS.ClientNotLoadedError)("Missing kyc_view scope to retrieve client");
    }
    async checkAccountIsOpen() {
        const client = this.client?.get();
        if (!client) return false;
        const previousClientStatus = client.status;
        try {
            const updatedClient = await this.updateClient(true);
            return updatedClient?.status != previousClientStatus && (0, $gDlNU.isDefined)(previousClientStatus) && updatedClient?.status === (0, $2Rggt.ClientStatus).Opened;
        } catch (error) {
            (0, $6JVVB.logger).debug("checkAccountIsOpen failed to update client ", error);
            return false;
        }
    }
    async setLanguage(language) {
        const client = await this.clientService.patchClient({
            lang: language
        });
        if (client) this.cacheLoader.store(client);
        this.client.set(client);
        this.onLanguageChange.dispatch(null);
    }
    async clear() {
        await this.cacheLoader.clear();
        this.client.set(null);
    }
    async fetchClientWithKycActions() {
        try {
            this.clientWithKycActionsLoading.set(true);
            this.clientWithKycActionsError.set(null);
            const res = await this.clientService.fetchClientWithKycActions();
            this.clientWithKycActions.set(res);
        } catch (e) {
            this.clientWithKycActionsError.set(e);
            throw e;
        } finally{
            this.clientWithKycActionsLoading.set(false);
        }
    }
    async initiateInfoNotChangedAction(targetPartyId) {
        try {
            this.initiateInfoNotChangedLoading.set(true);
            this.initiateInfoNotChangedError.set(null);
            await this.clientService.initiateInfoNotChangedAction(targetPartyId);
        } catch (e) {
            this.initiateInfoNotChangedError.set(e);
            throw e;
        } finally{
            this.initiateInfoNotChangedLoading.set(false);
        }
    }
}

});
parcelRegister("1eErS", function(module, exports) {

$parcel$export(module.exports, "ClientNotLoadedError", function () { return $eec048cf411fa539$export$9324d2a1c027312; });
class $eec048cf411fa539$export$9324d2a1c027312 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("keHi0", function(module, exports) {

$parcel$export(module.exports, "ClientService", function () { return $21c27d79791d65cd$export$15fb21390f08bb4c; });

var $6JVVB = parcelRequire("6JVVB");
class $21c27d79791d65cd$export$15fb21390f08bb4c {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchClient() {
        try {
            const response = await this.apiService.instance.get("/client");
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ClientService", "Fetch client failed", e);
            throw e;
        }
    }
    async fetchClientWithKycActions() {
        try {
            const response = await this.apiService.instance.get("/client", {
                headers: {
                    "Skaleet-Multiple-Required-Actions": ""
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ClientService", "Fetch client with KYC actions failed", e);
            throw e;
        }
    }
    async initiateInfoNotChangedAction(targetPartyId) {
        try {
            await this.apiService.instance.put("/customer-actions/initiate-action/additional_data_unchanged", {
                targetPartyId: targetPartyId
            });
        } catch (e) {
            (0, $6JVVB.logger).debug("ClientService", "Initiate data unchanged action failed", e);
            throw e;
        }
    }
    async patchClient(values) {
        try {
            const response = await this.apiService.instance.patch("/client", values);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ClientService", "Update client failed", e);
            throw e;
        }
    }
}

});

parcelRegister("8urHF", function(module, exports) {

$parcel$export(module.exports, "ConfigurationManager", function () { return $7c7c2edb0989eed9$export$20f75fb4cfd446c4; });

var $dhPTb = parcelRequire("dhPTb");

var $6JVVB = parcelRequire("6JVVB");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $aEtmU = parcelRequire("aEtmU");

var $7Tx4z = parcelRequire("7Tx4z");
const $7c7c2edb0989eed9$var$DEFAULT_NB_DAYS_TRUST_DURATION = 30;
class $7c7c2edb0989eed9$export$20f75fb4cfd446c4 {
    constructor(configurationService, cacheLoader, defaultCountryProvider, i18NStore, analyticsService, deviceInfoService){
        this.configurationService = configurationService;
        this.cacheLoader = cacheLoader;
        this.defaultCountryProvider = defaultCountryProvider;
        this.i18NStore = i18NStore;
        this.analyticsService = analyticsService;
        this.deviceInfoService = deviceInfoService;
        this.configuration = new (0, $3Ersk.Observable)({
            enrollment: true,
            pincode: {
                maxLength: 4,
                minLength: 4
            },
            otp: {
                maxLength: 6,
                minLength: 6
            },
            p2pCodeLength: {
                maxLength: 5,
                minLength: 5
            },
            langs: [
                "fr_FR",
                "en_US",
                "es_ES"
            ],
            countries: [
                "FR",
                "ES",
                "DE"
            ],
            colorScheme: {
                primaryColor: "",
                menuColors: [],
                recipientColors: [],
                billIssuerColors: []
            },
            authentication_mode: (0, $aEtmU.AuthenticationMode).LoginPassword,
            visaPaymentAvailable: false,
            isCameraCaptureAuthorized: false,
            isLocalFileUploadAuthorized: false,
            logo: "",
            favicon: "",
            registerImage: "",
            carouselImages: [],
            userAppMinimumVersion: "",
            trustDuration: $7c7c2edb0989eed9$var$DEFAULT_NB_DAYS_TRUST_DURATION,
            simplePayment: false,
            selectDistributorDuringOnboarding: false
        });
        this.defaultCountry = new (0, $3Ersk.Observable)("FR");
    }
    async load(media) {
        (0, $6JVVB.logger).debug("load configuration");
        this.addObservability();
        try {
            const configuration = await this.cacheLoader.load(async ()=>await this.configurationService.fetchConfiguration(media));
            if (!configuration) throw new (0, $7Tx4z.ConfigurationNotLoadedError)("Fetch configuration failed and configuration not in cache");
            this.configuration.set(configuration);
            const defaultCountry = await this.getDefaultCountry(configuration);
            if (defaultCountry) this.defaultCountry.set(defaultCountry);
        } catch (e) {
            (0, $6JVVB.logger).debug("ConfigurationManager", "Fetch configuration failed", e);
            throw new (0, $7Tx4z.ConfigurationInitializationFailedError)("Failed to fetch configuration");
        }
    }
    getPrimaryColor() {
        const primaryColor = this.configuration.get().colorScheme.primaryColor;
        if (primaryColor && primaryColor.length > 0) return primaryColor;
        return (0, $dhPTb.Config).APP_PRIMARY_COLOR;
    }
    getAvatarColors() {
        const avatarColors = this.configuration.get().colorScheme.recipientColors;
        if (avatarColors && avatarColors.length > 0) return avatarColors;
        return (0, $dhPTb.Config).APP_AVATAR_COLORS;
    }
    computeAvatarColor(str = "") {
        const avatarColors = this.getAvatarColors();
        return avatarColors[Array.from(str).reduce((acc, char)=>acc + char.charCodeAt(0), 0) % avatarColors.length];
    }
    getMenuColors() {
        const menuColors = this.configuration.get().colorScheme.menuColors;
        if (menuColors && menuColors.length > 0) return menuColors;
        return (0, $dhPTb.Config).APP_MORE_MENU_COLORS;
    }
    getBillIssuerColors() {
        const billIssuerColors = this.configuration.get().colorScheme.billIssuerColors;
        if (billIssuerColors && billIssuerColors.length > 0) return billIssuerColors;
        return (0, $dhPTb.Config).APP_BILL_ISSUERS_COLORS;
    }
    async getDefaultCountry(configuration) {
        let carrierCountryCode;
        try {
            if (this.defaultCountryProvider) {
                const DEFAULT_COUNTRY_CODE = "US";
                carrierCountryCode = (await this.defaultCountryProvider.getDefaultCountry())?.toUpperCase() || DEFAULT_COUNTRY_CODE;
            }
        } catch (e) {
            (0, $6JVVB.logger).debug("ConfigurationManager", "Get default country failed", e);
        }
        if (configuration.countries) return carrierCountryCode && configuration.countries.includes(carrierCountryCode) ? carrierCountryCode : configuration.countries[0];
        else return undefined;
    }
    getBestInfoUrlLocale() {
        const locale = this.i18NStore.localeTag.get();
        const infoUrl = this.configuration.get().infoUrl;
        const fallbackLocale = "en_US";
        if (!(0, $gDlNU.isDefined)(infoUrl)) return null;
        const hasLocaleUrl = (0, $gDlNU.isDefined)(infoUrl[locale]);
        if (hasLocaleUrl) return infoUrl[locale];
        const hasFallbackUrl = (0, $gDlNU.isDefined)(infoUrl[fallbackLocale]);
        if (hasFallbackUrl) return infoUrl[fallbackLocale];
        const urlAsArray = Object.values(infoUrl);
        return urlAsArray.length > 0 ? urlAsArray[0] : null;
    }
    getFaviconUrl(size) {
        const faviconFromConfig = this.configuration.get().favicon;
        if ((0, $gDlNU.isDefined)(faviconFromConfig)) return faviconFromConfig;
        const extension = size ? ".png" : ".ico";
        const filename = size ? `favicon-${size}` : "favicon-mw";
        return `./static/${filename}${extension}`;
    }
    getLogoUrl() {
        const logoFromConfig = this.configuration.get().logo;
        if ((0, $gDlNU.isDefined)(logoFromConfig)) return logoFromConfig;
        return null;
    }
    getRegisterImageUrl() {
        const registerImageFromConfig = this.configuration.get().registerImage;
        if ((0, $gDlNU.isDefined)(registerImageFromConfig)) return registerImageFromConfig;
        return null;
    }
    getCarouselUrls() {
        const carouselImages = this.configuration.get().carouselImages;
        if ((0, $gDlNU.isDefined)(carouselImages) && carouselImages.length > 0) return carouselImages;
        return null;
    }
    getNbDaysTrustDuration() {
        const nbDaysTrustDuration = this.configuration.get().trustDuration;
        if ((0, $gDlNU.isDefined)(nbDaysTrustDuration)) return nbDaysTrustDuration;
        return $7c7c2edb0989eed9$var$DEFAULT_NB_DAYS_TRUST_DURATION;
    }
    isSimplePayment() {
        const simplePayment = this.configuration.get().simplePayment;
        if ((0, $gDlNU.isDefined)(simplePayment)) return simplePayment;
        return false;
    }
    needDistributorSelectionDuringOnboarding() {
        const selectDistributorDuringOnboarding = this.configuration.get().selectDistributorDuringOnboarding;
        if ((0, $gDlNU.isDefined)(selectDistributorDuringOnboarding)) return selectDistributorDuringOnboarding;
        return false;
    }
    async reload(media) {
        (0, $6JVVB.logger).debug("reload configuration");
        this.cacheLoader.clear();
        await this.load(media);
    }
    async addObservability() {
        try {
            const isValid = await this.cacheLoader.isValid();
            if (!isValid) {
                const message = "configuration_cache_is_not_valid";
                (0, $6JVVB.logger).debug(message);
                await this.analyticsService.event(message, {
                    device_model: this.deviceInfoService.getModel()
                });
            }
        } catch (error) {
            (0, $6JVVB.logger).error("ConfigurationManager: ", error);
        }
    }
}

});
parcelRegister("7Tx4z", function(module, exports) {

$parcel$export(module.exports, "ConfigurationInitializationFailedError", function () { return $cf5412d7628a72fd$export$31361f0f76564c; });
$parcel$export(module.exports, "ConfigurationNotLoadedError", function () { return $cf5412d7628a72fd$export$f65590020b260830; });
class $cf5412d7628a72fd$export$31361f0f76564c extends Error {
    constructor(message){
        super(message);
    }
}
class $cf5412d7628a72fd$export$f65590020b260830 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("ls8p9", function(module, exports) {

$parcel$export(module.exports, "ConfigurationService", function () { return $debbe554d3839b51$export$6052c3988f38b078; });

var $6JVVB = parcelRequire("6JVVB");
class $debbe554d3839b51$export$6052c3988f38b078 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchConfiguration(media) {
        try {
            const response = await this.apiService.instance.get("/configuration", {
                params: {
                    media: media
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ConfigurationService", "Fetch configuration failed", e);
            throw e;
        }
    }
}

});

parcelRegister("c4FrM", function(module, exports) {

$parcel$export(module.exports, "CurrencyManager", function () { return $ab195465cc851986$export$96885af2d888db77; });

var $3Ersk = parcelRequire("3Ersk");
class $ab195465cc851986$export$96885af2d888db77 {
    constructor(currencyService, featuresManager){
        this.currencyService = currencyService;
        this.featuresManager = featuresManager;
        this.exchangeRates = new (0, $3Ersk.Observable)(null);
    }
    async getExchangeRates() {
        if (!this.featuresManager.features.get().sdaExchangeRateView) return;
        try {
            const exchangeRatesResponse = await this.currencyService.getExchangeRates();
            this.exchangeRates.set(exchangeRatesResponse);
        } catch (e) {
            this.exchangeRates.set(null);
            throw e;
        }
    }
}

});

parcelRegister("9KPxn", function(module, exports) {

$parcel$export(module.exports, "CurrencyService", function () { return $7b0a63a6d0ef0809$export$2684242beaf2882f; });

var $6JVVB = parcelRequire("6JVVB");
class $7b0a63a6d0ef0809$export$2684242beaf2882f {
    constructor(connectedServiceDomainApiService){
        this.connectedServiceDomainApiService = connectedServiceDomainApiService;
    }
    async getExchangeRates() {
        try {
            const response = await this.connectedServiceDomainApiService.instance.get("/exchange-rates");
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("CurrencyService", "Fetch exchange rates failed", e);
            throw e;
        }
    }
}

});

parcelRegister("8LY9U", function(module, exports) {

$parcel$export(module.exports, "CustomerActionService", function () { return $e86fcd7c347056e8$export$c686fa429ae3be4a; });
class $e86fcd7c347056e8$export$c686fa429ae3be4a {
    constructor(apiService){
        this.apiService = apiService;
    }
    async makeCustomerAction(url, body) {
        try {
            const initialResponse = await this.apiService.instance.put(url);
            const processLink = initialResponse.data.links.href;
            if (!processLink) throw new Error("No process link");
            try {
                const response = await this.apiService.instance.patch(processLink, body);
                const submitLink = response.data.links.find((link)=>link.rel === "submitForValidation")?.href;
                if (!submitLink) throw new Error("No submit link");
                try {
                    const submitResponse = await this.apiService.instance.post(submitLink, body);
                    return submitResponse.data;
                } catch (e) {
                    throw e;
                }
            } catch (e) {
                throw e;
            }
        } catch (e) {
            throw e;
        }
    }
}

});

parcelRegister("6Zk0Z", function(module, exports) {

$parcel$export(module.exports, "RegisterManager", function () { return $8421a5817ccffd52$export$4030fbcdb124970b; });

var $8Ba1X = parcelRequire("8Ba1X");

var $jO1Lj = parcelRequire("jO1Lj");

var $bL1Jk = parcelRequire("bL1Jk");

var $6JVVB = parcelRequire("6JVVB");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $19AHh = parcelRequire("19AHh");

var $eIxDs = parcelRequire("eIxDs");
const $8421a5817ccffd52$var$PENDING_ENROLLMENT_KEYSTORE_KEY = "pending_enrollment";
class $8421a5817ccffd52$export$4030fbcdb124970b {
    constructor(registerService, storage, imagesConverter){
        this.registerService = registerService;
        this.storage = storage;
        this.imagesConverter = imagesConverter;
        this./**
   * True while a picked image is being turned into a PDF. That conversion is asynchronous and
   * nobody awaits it, so without this the user can reach the next step before the document is
   * ready and submit an empty — or stale — field.
   */ converting = new (0, $3Ersk.Observable)(false);
        this.pendingConversions = 0;
        this.form = new (0, $3Ersk.Observable)(null);
        this.confirmError = new (0, $3Ersk.Observable)(null);
        this.confirmLoading = new (0, $3Ersk.Observable)(false);
        this.formStepsAsArray = new (0, $3Ersk.Observable)([]);
        this.extraFormInput = new (0, $3Ersk.Observable)({
            pincodeFormInput: null
        });
        this.parsedPhoneNumber = new (0, $3Ersk.Observable)(undefined);
    }
    async start(phoneNumber) {
        this.parsedPhoneNumber.set(phoneNumber);
        this.savePendingEnrollment({
            phoneNumber: phoneNumber
        });
        const form = $8421a5817ccffd52$var$addHierarchy(await this.registerService.startRegister(phoneNumber.number.substring(1)));
        this.form.set(form);
        this.extraFormInput.set((0, $bL1Jk.parseExtraStepFormInput)(form));
        this.formStepsAsArray.set($8421a5817ccffd52$var$collectCollections(form));
    }
    fillPincode(pincodeSubmission) {
        const form = this.form.get();
        const pincodeFormInput = this.extraFormInput.get().pincodeFormInput;
        if (form !== null && pincodeFormInput !== null) {
            const node = $8421a5817ccffd52$export$7c112ceec8941e67(form, pincodeFormInput.hierarchy);
            node.id = pincodeFormInput.id;
            node.value = {
                id: pincodeSubmission.id,
                value: pincodeSubmission.value
            };
            this.form.set({
                ...form
            });
        }
    }
    fillResponse(input, value, fileProps) {
        const form = this.form.get();
        if (form !== null) {
            $8421a5817ccffd52$export$7c112ceec8941e67(form, input.hierarchy).value = value;
            $8421a5817ccffd52$export$7c112ceec8941e67(form, input.hierarchy).fileProps = fileProps;
            this.form.set({
                ...form
            });
            this.formStepsAsArray.set($8421a5817ccffd52$var$collectCollections(form));
        }
    }
    async fillMultiImagesResponse(input, values) {
        const isReady = values.reduce((prev, value)=>prev + (value ? 1 : 0), 0) >= (input.minimumPageCount ?? 1);
        let pdfDocument;
        if (isReady) {
            // Counted rather than a plain flag: adding two pages in a row overlaps two conversions.
            this.pendingConversions += 1;
            this.converting.set(true);
            try {
                const filteredValues = values.filter((value)=>value);
                try {
                    const converted = await this.imagesConverter.toPdf(filteredValues);
                    pdfDocument = (0, $gDlNU.isDefined)(converted) ? await this.imagesConverter.toBase64(converted) : undefined;
                } catch (e) {
                    // The field keeps what it held: writing the failure into it would read as a page the
                    // holder never removed, and the form would only say the field is missing.
                    (0, $6JVVB.logger).debug("RegisterManager", "error converting the pages to a document", e);
                    return;
                }
                if (!(0, $gDlNU.isDefined)(pdfDocument)) {
                    (0, $6JVVB.logger).debug("RegisterManager", "the pages produced no document");
                    return;
                }
            } finally{
                this.pendingConversions = Math.max(0, this.pendingConversions - 1);
                this.converting.set(this.pendingConversions > 0);
            }
        }
        const form = this.form.get();
        if (form !== null) {
            $8421a5817ccffd52$export$7c112ceec8941e67(form, input.hierarchy).values = values;
            $8421a5817ccffd52$export$7c112ceec8941e67(form, input.hierarchy).value = pdfDocument;
            this.form.set({
                ...form
            });
            this.formStepsAsArray.set($8421a5817ccffd52$var$collectCollections(form));
        }
    }
    setInputValidity(input, isValid) {
        const form = this.form.get();
        if (form !== null) {
            $8421a5817ccffd52$export$7c112ceec8941e67(form, input.hierarchy).invalid = !isValid;
            this.form.set({
                ...form
            });
            this.formStepsAsArray.set($8421a5817ccffd52$var$collectCollections(form));
        }
    }
    async confirmRegister() {
        const pendingEnrollment = await this.loadPendingEnrollment();
        const enrollmentId = pendingEnrollment?.preAuth?.metadata.enrollmentId;
        const phoneNumber = pendingEnrollment?.phoneNumber;
        if (!phoneNumber) throw new Error("Can't confirm, phoneNumber is undefined");
        if (!enrollmentId) throw new Error("Can't confirm, enrollmentId is undefined");
        const result = await this.registerService.confirmRegister(phoneNumber.number.substring(1), enrollmentId);
        return result;
    }
    async validateForm() {
        const phoneNumber = (await this.loadPendingEnrollment())?.phoneNumber;
        if (!phoneNumber) throw new Error("Can't validate, phoneNumber is undefined");
        const form = this.form.get();
        if (!form) throw new Error("Can't validate, form is null");
        const result = await this.registerService.validateForm(phoneNumber.number.substring(1), $8421a5817ccffd52$var$collectValue(form), (0, $eIxDs.getUbbleRedirectUrl)());
        if (result.done) await this.savePendingEnrollment({
            preAuth: result.data
        });
        return result;
    }
    async retrieveUbbleUrl() {
        const confirmation = (await this.loadPendingEnrollment())?.preAuth?.metadata.confirmationMode;
        if (confirmation?.mode === (0, $19AHh.RegisterConfirmationMode).ValidationNeeded && confirmation.type === (0, $19AHh.RegisterTypeConfirmation).Url) return confirmation.value;
        return null;
    }
    async getUbbleUrl() {
        const url = await this.retrieveUbbleUrl();
        if ((0, $gDlNU.isDefined)(url)) return url;
        throw new Error("No pending enrollment or ubble URL incorrect");
    }
    async loadPendingEnrollment() {
        let storedValue;
        try {
            storedValue = await this.storage.read($8421a5817ccffd52$var$PENDING_ENROLLMENT_KEYSTORE_KEY);
        } catch (e) {
            storedValue = null;
        }
        if (storedValue) {
            const parsed = JSON.parse(storedValue);
            return parsed.phoneNumber ? {
                preAuth: parsed.preAuth,
                phoneNumber: (0, $8Ba1X.parsePhoneNumberFromString)(parsed.phoneNumber)
            } : {
                preAuth: parsed.preAuth
            };
        }
        return null;
    }
    async clearPendingEnrollment() {
        await this.storage.clear($8421a5817ccffd52$var$PENDING_ENROLLMENT_KEYSTORE_KEY);
    }
    async savePendingEnrollment(enrollment) {
        const previousEnrollment = await this.loadPendingEnrollment();
        const phoneNumberSerialized = enrollment.phoneNumber?.formatInternational() || previousEnrollment?.phoneNumber?.formatInternational();
        const dto = {
            preAuth: {
                ...previousEnrollment?.preAuth,
                ...enrollment.preAuth
            },
            phoneNumber: phoneNumberSerialized
        };
        await this.storage.store(JSON.stringify(dto), $8421a5817ccffd52$var$PENDING_ENROLLMENT_KEYSTORE_KEY);
    }
}
function $8421a5817ccffd52$var$addHierarchy(input, hierarchy = "") {
    return {
        ...input,
        hierarchy: `${hierarchy}/${input.id}`,
        inputs: input.inputs.map((child)=>{
            if (child.type === (0, $jO1Lj.FormInputType).Collection) return $8421a5817ccffd52$var$addHierarchy(child, `${hierarchy}${input.id}/`);
            else return $8421a5817ccffd52$var$addHierarchyToInput(child, `${hierarchy}${input.id}`);
        })
    };
}
function $8421a5817ccffd52$var$addHierarchyToInput(input, hierarchy = "") {
    return {
        ...input,
        hierarchy: `${hierarchy}/${input.id}`
    };
}
function $8421a5817ccffd52$var$collectCollections(input) {
    //@ts-ignore
    return input.inputs.reduce((acc, input)=>{
        if (input.type !== (0, $jO1Lj.FormInputType).Collection) return [];
        if (input.id.endsWith("FieldSet")) return [
            ...acc,
            input
        ];
        return [
            ...acc,
            ...$8421a5817ccffd52$var$collectCollections(input)
        ];
    }, []);
}
function $8421a5817ccffd52$export$7c112ceec8941e67(root, hierarchy) {
    let node = {
        inputs: [
            root
        ]
    };
    const parts = hierarchy.split("/");
    for (const part of parts){
        const foundNode = node.inputs.find((n)=>n.id === part);
        if (!foundNode) throw new Error(`can't find node ${part} in hierarchy ${hierarchy}`);
        node = foundNode;
    }
    return node;
}
function $8421a5817ccffd52$var$collectValue(input) {
    if (input.disabled === true) return null;
    if (input.type === (0, $jO1Lj.FormInputType).Collection) return input.inputs.reduce((acc, child)=>{
        const value = $8421a5817ccffd52$var$collectValue(child);
        if (value || child.type === (0, $jO1Lj.FormInputType).Bool) acc[child.id] = $8421a5817ccffd52$var$collectValue(child);
        return acc;
    }, {});
    else return input.value;
}

});
parcelRegister("8Ba1X", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumberFromString", function () { return $64298f4c61e2ce72$export$9c5cae3d55d8e910; });

var $bP4Vr = parcelRequire("bP4Vr");

var $gGN3t = parcelRequire("gGN3t");
function $64298f4c61e2ce72$export$9c5cae3d55d8e910() {
    return (0, $bP4Vr.withMetadata)((0, $gGN3t.default), arguments);
}

});
parcelRegister("bP4Vr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89b84733a9b8529e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "withMetadata", function () { return $89b84733a9b8529e$export$164451d7043c1432; });
// Importing from `.json.js` a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239

var $6cM0Z = parcelRequire("6cM0Z");
var $89b84733a9b8529e$export$2e2bcd8739ae039 = (0, $6cM0Z.default);
function $89b84733a9b8529e$export$164451d7043c1432(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $6cM0Z.default));
    return func.apply(this, args);
}

});
parcelRegister("6cM0Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48491bd8914ad64c$export$2e2bcd8739ae039; });
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $48491bd8914ad64c$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([457]\\d{6})$",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2457]\\d{6})$",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([267]\\d{6})$",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "0|(183[12])",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365|46",
                        "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[047]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[25689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[25689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-8]\\d{6})$",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-79]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "600[2-9]\\d{6}"
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "801"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-3]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "(?:10|2[0-57-9])(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "0|(1(?:[12]\\d|79)\\d\\d)",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[146][2-9]|[2578]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "[39]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[189]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-59]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-59]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[02459]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94|80\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([25-9]\\d{5})$",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d\\d|606)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-9]\\d{6})$",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "[2-489]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-489]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([25-8]\\d{5})$",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[245])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1[4679]|[38]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([0-24-8]\\d{5})$",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "(?:18|[2569]\\d\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[25]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "0|(1001)"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1-$2",
                    [
                        "5(?:29|38)",
                        "5(?:29|38)[89]",
                        "5(?:29|38)[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|892",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-3]|6[1267]|7[0-57]))\\d{6}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "592(?:4[0-2]|93)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0|([24-9]\\d{6})$",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[57-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:69|80)\\d{7}|(?:59|97)6\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([34]\\d{6})$",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[3467]|9[13-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:65[0-689]|99[1-9])\\d{7}|(?:1(?:[0147]\\d|[235][1-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9])|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1[36-8]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "[2-57-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[04]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-57-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[489]|59"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-579]|6[2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[47]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-579]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|[89]0",
                        "50(?:[0367]|88)|[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[59]|80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7|86"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "(?:[45]|80\\d\\d)\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[126]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "9769\\d{5}|(?:26|[68]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "26[23]|69|[89]"
        ],
        "RO": [
            "40",
            "00",
            "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "8000\\d{3}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-4]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "24|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3478]|64|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|(5\\d{6})$",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-479]\\d{6})$",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "(?:00|11|[2-57-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[34]7|91[78]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02-57-9]|11"
                    ],
                    0,
                    1
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|616)",
                        "5(?:[0-59]|6161)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-46-8]\\d{6})$",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[26-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
                        "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-2]|[28]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "405|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[24]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:33|55|[679]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[35-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-578]\\d{6})$",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[69]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7[24-68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "80\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "269|63"
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:005|[1-9]\\d\\d)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:005|[1-9]\\d\\d)\\d{5}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "[0-36-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-36-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "4"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-3]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "210\\d{7}|51\\d{7}(?:\\d{3})?",
            [
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:210|51[013]0\\d)\\d{7}|5100\\d{5}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});


parcelRegister("gGN3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2669ee7b45c3b88$export$2e2bcd8739ae039; });

var $l6EHW = parcelRequire("l6EHW");

var $kG6CT = parcelRequire("kG6CT");
function $c2669ee7b45c3b88$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $l6EHW.normalizeArguments)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $kG6CT.default)(text, options, metadata);
}

});
parcelRegister("l6EHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5d9bc361bef929c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "normalizeArguments", function () { return $f5d9bc361bef929c$export$abc60e668512edf9; });

var $67FaS = parcelRequire("67FaS");
function $f5d9bc361bef929c$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f5d9bc361bef929c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f5d9bc361bef929c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f5d9bc361bef929c$var$_typeof(obj);
}
function $f5d9bc361bef929c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $f5d9bc361bef929c$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $f5d9bc361bef929c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f5d9bc361bef929c$var$_slicedToArray(arr, i) {
    return $f5d9bc361bef929c$var$_arrayWithHoles(arr) || $f5d9bc361bef929c$var$_iterableToArrayLimit(arr, i) || $f5d9bc361bef929c$var$_nonIterableRest();
}
function $f5d9bc361bef929c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $f5d9bc361bef929c$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f5d9bc361bef929c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f5d9bc361bef929c$export$2e2bcd8739ae039() {
    var _normalizeArguments = $f5d9bc361bef929c$export$abc60e668512edf9(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $67FaS.default)(text, options, metadata);
}
function $f5d9bc361bef929c$export$abc60e668512edf9(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $f5d9bc361bef929c$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $f5d9bc361bef929c$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ($f5d9bc361bef929c$var$isObject(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
} // Otherwise istanbul would show this as "branch not covered".
/* istanbul ignore next */ var $f5d9bc361bef929c$var$isObject = function isObject(_) {
    return $f5d9bc361bef929c$var$_typeof(_) === 'object';
};

});
parcelRegister("67FaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $475355e796f7d8d2$export$2e2bcd8739ae039; });

var $6Ly25 = parcelRequire("6Ly25");
function $475355e796f7d8d2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $475355e796f7d8d2$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $475355e796f7d8d2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $475355e796f7d8d2$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $6Ly25.default)(text, $475355e796f7d8d2$var$_objectSpread({}, options, {
        v2: true
    }), metadata);
}

});
parcelRegister("6Ly25", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ed1880adfb8939e$export$2e2bcd8739ae039; });
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $d7zKk = parcelRequire("d7zKk");

var $eFwB4 = parcelRequire("eFwB4");

var $gduQK = parcelRequire("gduQK");

var $cbj09 = parcelRequire("cbj09");

var $2dmic = parcelRequire("2dmic");

var $87bfc = parcelRequire("87bfc");

var $gduQK = parcelRequire("gduQK");

var $dKk3y = parcelRequire("dKk3y");

var $hz1jF = parcelRequire("hz1jF");

var $7Smoa = parcelRequire("7Smoa");

var $4BIg9 = parcelRequire("4BIg9");

var $5hKFp = parcelRequire("5hKFp");


var $beB59 = parcelRequire("beB59");


var $kMd25 = parcelRequire("kMd25");
// This prevents malicious input from consuming CPU.
var $4ed1880adfb8939e$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $4ed1880adfb8939e$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $d7zKk.PLUS_CHARS) + (0, $d7zKk.VALID_DIGITS) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $4ed1880adfb8939e$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $d7zKk.VALID_DIGITS) + '#' + ']+$');
var $4ed1880adfb8939e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $4ed1880adfb8939e$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $gduQK.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $eFwB4.default)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $4ed1880adfb8939e$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $eFwB4.default)('TOO_SHORT');
            throw new (0, $eFwB4.default)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $4ed1880adfb8939e$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $eFwB4.default)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $d7zKk.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $eFwB4.default)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $d7zKk.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $eFwB4.default)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $7Smoa.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $4BIg9.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $4ed1880adfb8939e$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $dKk3y.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $4ed1880adfb8939e$var$extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $4ed1880adfb8939e$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $eFwB4.default)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($4ed1880adfb8939e$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($4ed1880adfb8939e$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $4ed1880adfb8939e$var$parseInput(text, v2, extract) {
    // Parse RFC 3966 phone number URI.
    if (text && text.indexOf('tel:') === 0) return (0, $hz1jF.parseRFC3966)(text);
    var number = $4ed1880adfb8939e$var$extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $cbj09.default)(number)) {
        if ((0, $cbj09.isViablePhoneNumberStart)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $2dmic.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $4ed1880adfb8939e$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $4ed1880adfb8939e$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $5hKFp.default)((0, $87bfc.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($4ed1880adfb8939e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $gduQK.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $beB59.default)((0, $87bfc.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $kMd25.default)(countryCallingCode, nationalNumber, metadata);
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRegister("d7zKk", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", function () { return $98d7a84050901927$export$cd8355bcbe13154; });
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", function () { return $98d7a84050901927$export$85ddd8c9b243679b; });
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", function () { return $98d7a84050901927$export$514717690676fb4a; });
$parcel$export(module.exports, "VALID_DIGITS", function () { return $98d7a84050901927$export$852d1d4a47329634; });
$parcel$export(module.exports, "VALID_PUNCTUATION", function () { return $98d7a84050901927$export$7f01587e28f9194; });
$parcel$export(module.exports, "PLUS_CHARS", function () { return $98d7a84050901927$export$207c99ccf3902df8; });
// The minimum length of the national significant number.
var $98d7a84050901927$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $98d7a84050901927$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $98d7a84050901927$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $98d7a84050901927$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $98d7a84050901927$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $98d7a84050901927$var$SLASHES = "\uFF0F/";
var $98d7a84050901927$var$DOTS = "\uFF0E.";
var $98d7a84050901927$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $98d7a84050901927$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $98d7a84050901927$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $98d7a84050901927$export$7f01587e28f9194 = "".concat($98d7a84050901927$var$DASHES).concat($98d7a84050901927$var$SLASHES).concat($98d7a84050901927$var$DOTS).concat($98d7a84050901927$export$20542845033f576e).concat($98d7a84050901927$var$BRACKETS).concat($98d7a84050901927$var$TILDES);
var $98d7a84050901927$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});

parcelRegister("eFwB4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aade2e1b3782cdd9$export$2e2bcd8739ae039; });
function $aade2e1b3782cdd9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// https://stackoverflow.com/a/46971044/970769
var $aade2e1b3782cdd9$export$2e2bcd8739ae039 = function ParseError(code) {
    $aade2e1b3782cdd9$var$_classCallCheck(this, ParseError);
    this.name = this.constructor.name;
    this.message = code;
    this.stack = new Error(code).stack;
};
$aade2e1b3782cdd9$export$2e2bcd8739ae039.prototype = Object.create(Error.prototype);
$aade2e1b3782cdd9$export$2e2bcd8739ae039.prototype.constructor = $aade2e1b3782cdd9$export$2e2bcd8739ae039;

});

parcelRegister("gduQK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bce5ca6227cb3ed2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getCountryCallingCode", function () { return $bce5ca6227cb3ed2$export$32876ca2f1919cf0; });
$parcel$export(module.exports, "isSupportedCountry", function () { return $bce5ca6227cb3ed2$export$bd9e113b8b17202a; });

var $1w9E2 = parcelRequire("1w9E2");
function $bce5ca6227cb3ed2$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bce5ca6227cb3ed2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bce5ca6227cb3ed2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bce5ca6227cb3ed2$var$_typeof(obj);
}
function $bce5ca6227cb3ed2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bce5ca6227cb3ed2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bce5ca6227cb3ed2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bce5ca6227cb3ed2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bce5ca6227cb3ed2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $bce5ca6227cb3ed2$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $bce5ca6227cb3ed2$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $bce5ca6227cb3ed2$var$V4 = '1.7.35';
var $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $bce5ca6227cb3ed2$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $bce5ca6227cb3ed2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, Metadata);
        $bce5ca6227cb3ed2$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $bce5ca6227cb3ed2$var$setVersion.call(this, metadata);
    }
    $bce5ca6227cb3ed2$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $bce5ca6227cb3ed2$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $bce5ca6227cb3ed2$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $bce5ca6227cb3ed2$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $bce5ca6227cb3ed2$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $bce5ca6227cb3ed2$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $bce5ca6227cb3ed2$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // Is always present.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $bce5ca6227cb3ed2$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $bce5ca6227cb3ed2$var$getType(this.types(), _type2)) return new $bce5ca6227cb3ed2$var$Type($bce5ca6227cb3ed2$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $bce5ca6227cb3ed2$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $bce5ca6227cb3ed2$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$bce5ca6227cb3ed2$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $bce5ca6227cb3ed2$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $bce5ca6227cb3ed2$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $bce5ca6227cb3ed2$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $bce5ca6227cb3ed2$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $bce5ca6227cb3ed2$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!$bce5ca6227cb3ed2$var$is_object(metadata) || !$bce5ca6227cb3ed2$var$is_object(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat($bce5ca6227cb3ed2$var$is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $bce5ca6227cb3ed2$var$type_of(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $bce5ca6227cb3ed2$var$is_object = function is_object(_) {
    return $bce5ca6227cb3ed2$var$_typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $bce5ca6227cb3ed2$var$type_of = function type_of(_) {
    return $bce5ca6227cb3ed2$var$_typeof(_);
};
function $bce5ca6227cb3ed2$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $bce5ca6227cb3ed2$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX;
}
function $bce5ca6227cb3ed2$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $bce5ca6227cb3ed2$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $bce5ca6227cb3ed2$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries[country] !== undefined;
}
function $bce5ca6227cb3ed2$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $1w9E2.default)(version, $bce5ca6227cb3ed2$var$V3) === -1) this.v2 = true;
        else if ((0, $1w9E2.default)(version, $bce5ca6227cb3ed2$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRegister("1w9E2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b042dd02a0a0fd$export$2e2bcd8739ae039; });
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $11b042dd02a0a0fd$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});


parcelRegister("cbj09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0249e422af2fc5e5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isViablePhoneNumberStart", function () { return $0249e422af2fc5e5$export$4c3f76c95c05197c; });

var $d7zKk = parcelRequire("d7zKk");

var $iRWiM = parcelRequire("iRWiM");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $0249e422af2fc5e5$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $d7zKk.VALID_DIGITS) + ']{' + (0, $d7zKk.MIN_LENGTH_FOR_NSN) + '}'; //
var $0249e422af2fc5e5$export$a77dd7471651eee = '[' + (0, $d7zKk.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $d7zKk.VALID_PUNCTUATION) + ']*' + '[' + (0, $d7zKk.VALID_DIGITS) + ']' + '){3,}' + '[' + (0, $d7zKk.VALID_PUNCTUATION) + (0, $d7zKk.VALID_DIGITS) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $d7zKk.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $d7zKk.VALID_PUNCTUATION) + ']*' + '[' + (0, $d7zKk.VALID_DIGITS) + ']' + '){1,2}' + '$', 'i');
var $0249e422af2fc5e5$export$a2d12a04749c087d = $0249e422af2fc5e5$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $iRWiM.default)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $0249e422af2fc5e5$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $0249e422af2fc5e5$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $0249e422af2fc5e5$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $d7zKk.MIN_LENGTH_FOR_NSN) && $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $0249e422af2fc5e5$export$4c3f76c95c05197c(number) {
    return $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRegister("iRWiM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbca66c422f02c44$export$2e2bcd8739ae039; });

var $d7zKk = parcelRequire("d7zKk");
var $dbca66c422f02c44$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $dbca66c422f02c44$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $d7zKk.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $dbca66c422f02c44$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $dbca66c422f02c44$var$RFC3966_EXTN_PREFIX + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});


parcelRegister("2dmic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19ce1682d761f46a$export$2e2bcd8739ae039; });

var $iRWiM = parcelRequire("iRWiM");
// 1 or more valid digits, for use when parsing.
var $19ce1682d761f46a$var$EXTN_PATTERN = new RegExp('(?:' + (0, $iRWiM.default)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $19ce1682d761f46a$export$2e2bcd8739ae039(number) {
    var start = number.search($19ce1682d761f46a$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($19ce1682d761f46a$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRegister("87bfc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e87b301cd757756$export$2e2bcd8739ae039; });

var $7zd5W = parcelRequire("7zd5W");
function $5e87b301cd757756$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var character = _ref;
        result += $5e87b301cd757756$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $5e87b301cd757756$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return '+';
    } // Allow digits.
    return (0, $7zd5W.parseDigit)(character);
}

});
parcelRegister("7zd5W", function(module, exports) {

$parcel$export(module.exports, "parseDigit", function () { return $5825f5a4b211fdc2$export$1d16fddea1437169; });
$parcel$export(module.exports, "default", function () { return $5825f5a4b211fdc2$export$2e2bcd8739ae039; });
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var $5825f5a4b211fdc2$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $5825f5a4b211fdc2$export$1d16fddea1437169(character) {
    return $5825f5a4b211fdc2$export$2848f3d68c08fe69[character];
}
function $5825f5a4b211fdc2$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var character = _ref;
        var digit = $5825f5a4b211fdc2$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRegister("dKk3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a01f2103be3480d7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPossibleNumber", function () { return $a01f2103be3480d7$export$4f8890cedf1e0497; });

var $gduQK = parcelRequire("gduQK");

var $bJAjw = parcelRequire("bJAjw");
function $a01f2103be3480d7$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $gduQK.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    }
    if (metadata.possibleLengths()) return $a01f2103be3480d7$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $a01f2103be3480d7$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $bJAjw.default)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRegister("bJAjw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b010df83443a8d$export$2e2bcd8739ae039; });

var $4lwTs = parcelRequire("4lwTs");
function $88b010df83443a8d$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $88b010df83443a8d$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $88b010df83443a8d$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $88b010df83443a8d$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $4lwTs.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

});
parcelRegister("4lwTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a2a39031f8d445$export$2e2bcd8739ae039; });
/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */ function $32a2a39031f8d445$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var element = _ref;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRegister("hz1jF", function(module, exports) {

$parcel$export(module.exports, "parseRFC3966", function () { return $cc96b9e725eeb911$export$26fe644d7d92bb13; });
$parcel$export(module.exports, "formatRFC3966", function () { return $cc96b9e725eeb911$export$d4f2d2bc1159d115; });

var $cbj09 = parcelRequire("cbj09");
function $cc96b9e725eeb911$var$_slicedToArray(arr, i) {
    return $cc96b9e725eeb911$var$_arrayWithHoles(arr) || $cc96b9e725eeb911$var$_iterableToArrayLimit(arr, i) || $cc96b9e725eeb911$var$_nonIterableRest();
}
function $cc96b9e725eeb911$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $cc96b9e725eeb911$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $cc96b9e725eeb911$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cc96b9e725eeb911$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var part = _ref;
        var _part$split = part.split('='), _part$split2 = $cc96b9e725eeb911$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $cbj09.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $cc96b9e725eeb911$export$d4f2d2bc1159d115(_ref2) {
    var number = _ref2.number, ext = _ref2.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

});

parcelRegister("7Smoa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bbef17d1712b412$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");

var $dKk3y = parcelRequire("dKk3y");

var $lUcBJ = parcelRequire("lUcBJ");


var $ewjdy = parcelRequire("ewjdy");

var $9HWjP = parcelRequire("9HWjP");
function $5bbef17d1712b412$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $5bbef17d1712b412$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $5bbef17d1712b412$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5bbef17d1712b412$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5bbef17d1712b412$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5bbef17d1712b412$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5bbef17d1712b412$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5bbef17d1712b412$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $5bbef17d1712b412$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $5bbef17d1712b412$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
        $5bbef17d1712b412$var$_classCallCheck(this, PhoneNumber);
        if (!countryCallingCode) throw new TypeError('`country` or `countryCallingCode` not passed');
        if (!nationalNumber) throw new TypeError('`nationalNumber` not passed');
        if (!metadata) throw new TypeError('`metadata` not passed');
        var _metadata = new (0, $gduQK.default)(metadata); // If country code is passed then derive `countryCallingCode` from it.
        // Also store the country code as `.country`.
        if ($5bbef17d1712b412$var$isCountryCode(countryCallingCode)) {
            this.country = countryCallingCode;
            _metadata.country(countryCallingCode);
            countryCallingCode = _metadata.countryCallingCode();
        } else {
            /* istanbul ignore if */ if ($5bbef17d1712b412$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (_metadata.isNonGeographicCallingCode(countryCallingCode)) this.country = '001';
            }
        }
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber;
        this.metadata = metadata;
    }
    $5bbef17d1712b412$var$_createClass(PhoneNumber, [
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $dKk3y.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $lUcBJ.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $gduQK.default)(this.metadata);
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // // Is just an alias for `this.isValid() && this.country === country`.
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $ewjdy.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $9HWjP.default)(this, _format, options ? $5bbef17d1712b412$var$_objectSpread({}, options, {
                    v2: true
                }) : {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $5bbef17d1712b412$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};

});
parcelRegister("lUcBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff289b8e0a4b41dc$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");

var $4BIg9 = parcelRequire("4BIg9");

var $ewjdy = parcelRequire("ewjdy");
function $ff289b8e0a4b41dc$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $gduQK.default)(metadata); // This is just to support `isValidNumber({})`
    // for cases when `parseNumber()` returns `{}`.
    if (!input.country) return false;
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $ewjdy.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var national_number = options.v2 ? input.nationalNumber : input.phone;
    return (0, $4BIg9.default)(national_number, metadata.nationalNumberPattern());
}

});
parcelRegister("4BIg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35acf32273274407$export$2e2bcd8739ae039; });
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $35acf32273274407$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

});

parcelRegister("ewjdy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a922f615bcdd44fd$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");

var $4BIg9 = parcelRequire("4BIg9");
var $a922f615bcdd44fd$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $a922f615bcdd44fd$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returned `{}`
    // meaning that the phone number is not a valid one.
    if (!input.country) return;
    metadata = new (0, $gduQK.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $4BIg9.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // v1 metadata.
        // Legacy.
        // Deprecated.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _i = 0, _NON_FIXED_LINE_PHONE = $a922f615bcdd44fd$var$NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++){
        var type = _NON_FIXED_LINE_PHONE[_i];
        if ($a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $4BIg9.default)(nationalNumber, type.pattern());
}

});


parcelRegister("9HWjP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71155e22d8222541$export$2e2bcd8739ae039; });

var $4BIg9 = parcelRequire("4BIg9");

var $9EHK1 = parcelRequire("9EHK1");

var $gduQK = parcelRequire("gduQK");

var $6VB1Y = parcelRequire("6VB1Y");

var $hz1jF = parcelRequire("hz1jF");
function $71155e22d8222541$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $71155e22d8222541$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $71155e22d8222541$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $71155e22d8222541$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    } // Formats a phone number
};
function $71155e22d8222541$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $71155e22d8222541$var$_objectSpread({}, $71155e22d8222541$var$DEFAULT_OPTIONS, options);
    else options = $71155e22d8222541$var$DEFAULT_OPTIONS;
    metadata = new (0, $gduQK.default)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $71155e22d8222541$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $71155e22d8222541$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $71155e22d8222541$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $71155e22d8222541$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $hz1jF.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $71155e22d8222541$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $71155e22d8222541$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $71155e22d8222541$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $71155e22d8222541$var$chooseFormatForNumber(metadata.formats(), number);
    if (!format) return number;
    return (0, $9EHK1.default)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $71155e22d8222541$var$chooseFormatForNumber(availableFormats, nationalNnumber) {
    for(var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var format = _ref;
        // Validate leading digits
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $4BIg9.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $71155e22d8222541$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $71155e22d8222541$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $gduQK.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $71155e22d8222541$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $6VB1Y.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($71155e22d8222541$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}

});
parcelRegister("9EHK1", function(module, exports) {

$parcel$export(module.exports, "FIRST_GROUP_PATTERN", function () { return $7079c79331818186$export$4f32ad1c51a7a6be; });
$parcel$export(module.exports, "default", function () { return $7079c79331818186$export$2e2bcd8739ae039; });

var $aEFmc = parcelRequire("aEFmc");
var $7079c79331818186$export$4f32ad1c51a7a6be = /(\$\d)/;
function $7079c79331818186$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($7079c79331818186$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $aEFmc.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRegister("aEFmc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c1db87101d8728f$export$2e2bcd8739ae039; });

var $d7zKk = parcelRequire("d7zKk");
function $7c1db87101d8728f$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $d7zKk.VALID_PUNCTUATION), "]+"), 'g'), ' ').trim();
}

});


parcelRegister("6VB1Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50b4ca8186ad142e$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $50b4ca8186ad142e$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $50b4ca8186ad142e$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $gduQK.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($50b4ca8186ad142e$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});



parcelRegister("5hKFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d92bd5f5d91cfad$export$2e2bcd8739ae039; });

var $hbkEH = parcelRequire("hbkEH");

var $bDn2E = parcelRequire("bDn2E");

var $gduQK = parcelRequire("gduQK");

var $d7zKk = parcelRequire("d7zKk");
function $3d92bd5f5d91cfad$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
     // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $hbkEH.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) number = '+' + numberWithoutIDD;
        else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $bDn2E.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $gduQK.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $d7zKk.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
}

});
parcelRegister("hbkEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8237c822f170abb$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");

var $d7zKk = parcelRequire("d7zKk");
var $c8237c822f170abb$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $d7zKk.VALID_DIGITS) + '])');
function $c8237c822f170abb$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $gduQK.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($c8237c822f170abb$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}

});

parcelRegister("bDn2E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878535d1f6f3c21d$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");

var $4BIg9 = parcelRequire("4BIg9");

var $beB59 = parcelRequire("beB59");

var $bJAjw = parcelRequire("bJAjw");

var $gduQK = parcelRequire("gduQK");
function $878535d1f6f3c21d$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $gduQK.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $gduQK.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $beB59.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $beB59.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $4BIg9.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $4BIg9.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $bJAjw.default)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRegister("beB59", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82ddc43a260803c8$export$2e2bcd8739ae039; });

var $jbBLp = parcelRequire("jbBLp");

var $4BIg9 = parcelRequire("4BIg9");

var $bJAjw = parcelRequire("bJAjw");
function $82ddc43a260803c8$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $jbBLp.default)(number, metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
    if (!$82ddc43a260803c8$var$shouldExtractNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
    return {
        nationalNumber: number
    };
     // If a national prefix has been extracted, check to see
    // if the resultant number isn't too short.
    // Same code in Google's `libphonenumber`:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3291-L3302
    // For some reason, they do this check right after the `national_number_pattern` check
    // this library does in `shouldExtractNationalPrefix()` function.
    // Why is there a second "resultant" number validity check?
    // They don't provide an explanation.
    // This library just copies the behavior.
    if (number.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    {
        if (metadata.possibleLengths()) // "We require that the NSN remaining after stripping the national prefix and
        // carrier code be long enough to be a possible length for the region.
        // Otherwise, we don't do the stripping, since the original number could be
        // a valid short number."
        // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
        switch((0, $bJAjw.default)(nationalNumber, metadata)){
            case 'TOO_SHORT':
            case 'INVALID_LENGTH':
                // case 'IS_POSSIBLE_LOCAL_ONLY':
                // Don't strip the national prefix.
                return {
                    nationalNumber: number
                };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $82ddc43a260803c8$var$shouldExtractNationalPrefix(number, nationalSignificantNumber, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $4BIg9.default)(number, metadata.nationalNumberPattern()) && !(0, $4BIg9.default)(nationalSignificantNumber, metadata.nationalNumberPattern())) return false;
     // Just "possible" number check would be more relaxed, so it's not used.
    // if (isPossibleNumber(number, metadata) &&
    // 	!isPossibleNumber(numberWithNationalPrefixExtracted, metadata)) {
    // 	return false
    // }
    return true;
}

});
parcelRegister("jbBLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df7c5677e63c77d4$export$2e2bcd8739ae039; });
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`.
 */ function $df7c5677e63c77d4$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRegister("kMd25", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f202665e259874b0$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");

var $ewjdy = parcelRequire("ewjdy");
var $f202665e259874b0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $f202665e259874b0$export$2e2bcd8739ae039(callingCode, nationalPhoneNumber, metadata) {
    /* istanbul ignore if */ if ($f202665e259874b0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    } // Is always non-empty, because `callingCode` is always valid
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return $f202665e259874b0$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}
function $f202665e259874b0$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $gduQK.default)(metadata);
    for(var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var country = _ref;
        metadata.country(country); // Leading digits check would be the simplest and fastest one.
        // Leading digits patterns are only defined for about 20% of all countries.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // Matching "leading digits" is a sufficient but not necessary condition.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $ewjdy.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) return country;
    }
}

});




parcelRegister("kG6CT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0dcdebd3647a668$export$2e2bcd8739ae039; });

var $67FaS = parcelRequire("67FaS");

var $eFwB4 = parcelRequire("eFwB4");

var $gduQK = parcelRequire("gduQK");
function $f0dcdebd3647a668$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $f0dcdebd3647a668$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $f0dcdebd3647a668$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f0dcdebd3647a668$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $gduQK.isSupportedCountry)(options.defaultCountry, metadata)) options = $f0dcdebd3647a668$var$_objectSpread({}, options, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $67FaS.default)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $eFwB4.default)) ;
        else throw error;
    }
}

});



parcelRegister("jO1Lj", function(module, exports) {

$parcel$export(module.exports, "FormInputType", function () { return $9426504e3b43c3a5$export$8473c976ec77d2a0; });
var $9426504e3b43c3a5$export$8473c976ec77d2a0 = /*#__PURE__*/ function(FormInputType) {
    FormInputType["Amount"] = "AMOUNT";
    FormInputType["Text"] = "TEXT";
    FormInputType["Bool"] = "BOOL";
    FormInputType["Date"] = "DATE";
    FormInputType["DateTime"] = "DATE_TIME";
    FormInputType["Duration"] = "DURATION";
    FormInputType["Email"] = "EMAIL";
    FormInputType["File"] = "FILE";
    FormInputType["FileContent"] = "FILE_CONTENT";
    FormInputType["Collection"] = "COLLECTION";
    FormInputType["Image"] = "IMAGE";
    FormInputType["Int"] = "INT";
    FormInputType["Ip"] = "IP";
    FormInputType["MultiSelect"] = "MULTI_SELECT";
    FormInputType["Number"] = "NUMBER";
    FormInputType["Percent"] = "PERCENT";
    FormInputType["Password"] = "PASSWORD";
    FormInputType["Phone"] = "PHONE";
    FormInputType["Rate"] = "RATE";
    FormInputType["Select"] = "SELECT";
    FormInputType["SelectWithAmount"] = "SELECT_WITH_AMOUNT";
    FormInputType["Pincode"] = "PINCODE";
    FormInputType["Autocomplete"] = "AUTOCOMPLETE";
    return FormInputType;
}({});

});

parcelRegister("bL1Jk", function(module, exports) {

$parcel$export(module.exports, "parseExtraStepFormInput", function () { return $050b2d6ed81c2202$export$a51771271bb18879; });

var $jO1Lj = parcelRequire("jO1Lj");
function $050b2d6ed81c2202$export$a51771271bb18879(input) {
    let pincodeFormInput = null;
    function findConfigurationRecursively(input) {
        if (input.type === "COLLECTION") return input.inputs.map((it)=>{
            findConfigurationRecursively(it);
        }, []);
        else if (input.type === (0, $jO1Lj.FormInputType).Pincode) pincodeFormInput = input;
        return [];
    }
    if (input !== null) findConfigurationRecursively(input);
    return {
        pincodeFormInput: pincodeFormInput
    };
}

});

parcelRegister("19AHh", function(module, exports) {

$parcel$export(module.exports, "RegisterMode", function () { return $1e30e1d5e60f0181$export$ecdf45deecb8cf40; });
$parcel$export(module.exports, "RegisterConfirmationMode", function () { return $1e30e1d5e60f0181$export$b45c8e7d0476accd; });
$parcel$export(module.exports, "RegisterTypeConfirmation", function () { return $1e30e1d5e60f0181$export$5a13e15edb568aa2; });
var $1e30e1d5e60f0181$export$ecdf45deecb8cf40 = /*#__PURE__*/ function(RegisterMode) {
    RegisterMode["PreAuth"] = "PREAUTH";
    RegisterMode["Transaction"] = "TRANSACTION";
    return RegisterMode;
}({});
var $1e30e1d5e60f0181$export$b45c8e7d0476accd = /*#__PURE__*/ function(RegisterConfirmationMode) {
    RegisterConfirmationMode["ValidationNeeded"] = "VALIDATION_NEEDED";
    return RegisterConfirmationMode;
}({});
var $1e30e1d5e60f0181$export$5a13e15edb568aa2 = /*#__PURE__*/ function(RegisterTypeConfirmation) {
    RegisterTypeConfirmation["None"] = "NONE";
    RegisterTypeConfirmation["Url"] = "URL";
    return RegisterTypeConfirmation;
}({});

});

parcelRegister("eIxDs", function(module, exports) {

$parcel$export(module.exports, "getUbbleRedirectUrl", function () { return $1ca0381734a64d4b$export$a8466f03324ebd5; });
$parcel$export(module.exports, "getUbbleRedirectUrlNewOnboarding", function () { return $1ca0381734a64d4b$export$75ef1ea796ef150d; });

var $dhPTb = parcelRequire("dhPTb");
function $1ca0381734a64d4b$export$a8466f03324ebd5() {
    return (0, $dhPTb.Config).UBBLE_REDIRECT_WEB_CLIENT_SCHEME;
}
function $1ca0381734a64d4b$export$75ef1ea796ef150d() {
    return (0, $dhPTb.Config).UBBLE_REDIRECT_NEW_ONBOARDING_WEB_CLIENT_URL;
}

});


parcelRegister("fuI9I", function(module, exports) {

$parcel$export(module.exports, "RegisterService", function () { return $be57a8e7ec33662a$export$f081687a3defd6f3; });

var $6JVVB = parcelRequire("6JVVB");

var $19AHh = parcelRequire("19AHh");
class $be57a8e7ec33662a$export$f081687a3defd6f3 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async startRegister(phoneNumber) {
        try {
            const response = await this.apiService.instance.get(`/enrollment/${phoneNumber}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("RegisterService", "Failed to start register", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmRegister(phoneNumber, enrollmentId) {
        try {
            const response = await this.apiService.instance.post(`/enrollment/${phoneNumber}`, {
                metadata: {
                    mode: (0, $19AHh.RegisterMode).Transaction,
                    enrollmentId: enrollmentId
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("RegisterService", "Failed to confirm register", e, JSON.stringify(e));
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async validateForm(phoneNumber, form, redirectUrl) {
        try {
            const response = await this.apiService.instance.post(`/enrollment/${phoneNumber}`, {
                metadata: {
                    mode: (0, $19AHh.RegisterMode).PreAuth
                },
                data: {
                    form: form,
                    redirectUrl: redirectUrl
                }
            });
            if (response.status === 200) return {
                data: response.data,
                done: true
            };
            else return {
                data: response.data,
                done: false
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("RegisterService", "Failed to validate register", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("dMTzj", function(module, exports) {

$parcel$export(module.exports, "FeaturesManager", function () { return $00cfcc4c70018c62$export$6a3283d7f4407485; });

var $dhPTb = parcelRequire("dhPTb");

var $3Ersk = parcelRequire("3Ersk");

var $hoiie = parcelRequire("hoiie");

var $2mnb2 = parcelRequire("2mnb2");

var $kQMLL = parcelRequire("kQMLL");
class $00cfcc4c70018c62$export$6a3283d7f4407485 {
    constructor(authenticationManager){
        this.authenticationManager = authenticationManager;
        this.features = new (0, $3Ersk.Observable)(new (0, $kQMLL.Features)());
        this.updateFeatures(authenticationManager.session.get());
        this.authenticationManager.session.onChange.add((session)=>this.updateFeatures(session));
    }
    updateFeatures(session) {
        const features = {};
        if (session) {
            features.accounts = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).AccountsView);
            features.payment = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).Payment);
            features.payout = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).Payout);
            features.p2pTransfer = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).P2PTransfer);
            features.p2pSimpleTransfer = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).P2PSimpleTransfer);
            features.p2pCashTransfer = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).P2PCashTransfer);
            features.p2pDedicatedTransfer = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).P2PDedicatedTransfer);
            features.billPayment = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).BillPayment);
            features.transactionCode = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).TransactionCode);
            features.consultLoans = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).ConsultLoans);
            features.subscribeLoan = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).SubscribeLoan);
            features.cards = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).CardsManagement);
            features.virtualCardCreation = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).CardsVirtualCreation);
            features.clientInformationView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).KYCView);
            features.clientInformationUpdate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).KYCUpdate);
            features.pincodeUpdate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).PincodeUpdate);
            features.notifications = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).Notifications);
            features.withdraw = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).Withdraw);
            features.walletRechargeByCard = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).WalletRechargeByCard);
            features.bankToWallet = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).BankToWallet);
            features.acceptorSearch = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).AcceptorSearch);
            features.manageQrCode = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).ManageQrCode);
            features.manageCategorizationSpendings = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).ManageCategorizationSpendings);
            features.bicReferential = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).BicReferential);
            features.externalAccountsManagement = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).ExternalAccountsManagement);
            features.externalAccountsUsage = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).ExternalAccountsUsage);
            features.beneficiariesManagement = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).BeneficiariesManagement);
            features.beneficiariesUsage = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).BeneficiariesUsage);
            features.sdaCustomerOnboardingCreate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).SdaCustomerOnboardingCreate);
            features.sdaCustomerOnboardingView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).SdaCustomerOnboardingView);
            features.sdaCustomerOnboardingUpdate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).SdaCustomerOnboardingUpdate);
            features.sdaCustomerOnboardingSubmit = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).SdaCustomerOnboardingSubmit);
            features.strongCustomerAuthentication = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).StrongCustomerAuthentication);
            features.consultAuthorizationHolds = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).ConsultAuthorizationHolds);
            features.cardSensitiveDataView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).CardSensitiveDataView);
            // features.sdaCardView = sessionHasScope(session, SharedServiceDomainScope.SdaCardView);
            features.sdaCustomerOnboardingActionsInitiate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).SdaCustomerOnboardingActionsInitiate);
            features.identityDocumentView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).IdentityDocumentView);
            features.identityView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).IdentityView);
            features.trustedDevices = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).TrustedDevices);
            features.mandateView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).MandateView);
            features.mandateManagement = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.Scope).MandateManagement);
            // SERVICE DOMAIN
            features.additionalDataRead = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.ServiceDomainScope).AdditionalDataRead);
            features.customerInstructionView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).CustomerInstructionView);
            features.customerInstructionInitiation = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).CustomerInstructionInitiation);
            features.customerInstructionSubmit = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).CustomerInstructionSubmit);
            features.customerInstructionUpdate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).CustomerInstructionUpdate);
            features.customerInstructionDeletion = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).CustomerInstructionDeletion);
            features.paymentNetwork = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).PaymentNetwork);
            features.paymentContract = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).PaymentContract);
            features.sdaAuthenticationsSessionsView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaAuthenticationsSessionsView);
            features.sdaAuthenticationsSessionsAuth = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaAuthenticationsSessionsAuth);
            features.paymentInstructionView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).PaymentInstructionView);
            features.sdaAccountView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaAccountView);
            features.sdaExchangeRateView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaExchangeRateView);
            features.recipientCreate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).RecipientCreate);
            features.sdaTransactionsView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaTransactionsView);
            features.sdaAccountsNameUpdate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaAccountsNameUpdate);
            features.paymentStandingOrderCreate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).PaymentStandingOrderCreate);
            features.paymentStandingOrderUpdate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).PaymentStandingOrderUpdate);
            features.paymentStandingOrderDelete = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).PaymentStandingOrderDelete);
            features.paymentStandingOrderView = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).PaymentStandingOrderView);
            // SAVINGS API
            features.savContractRead = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SavingsScope).SavContractRead);
            features.sdaRequiredActionsWrite = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaRequiredActionsWrite);
            features.sdaAccountsNameUpdate = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SharedServiceDomainScope).SdaAccountsNameUpdate);
            features.savDeposit = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SavingsScope).SavDeposit);
            features.savProductRead = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SavingsScope).SavProductRead);
            features.savContractWrite = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SavingsScope).SavContractWrite);
            features.savDocumentsRead = (0, $2mnb2.sessionHasScope)(session, (0, $hoiie.SavingsScope).SavDocumentsRead);
        }
        features.externalLoanManagement = (0, $dhPTb.Config).EXTERNAL_LOAN_MANAGEMENT;
        this.features.set({
            ...this.features.get(),
            ...features
        });
    }
}

});
parcelRegister("kQMLL", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return $2dd8d68a3d866688$export$617d79dae526d2cf; });
class $2dd8d68a3d866688$export$617d79dae526d2cf {
    constructor(){
        this.acceptorSearch = false;
        this.accounts = false;
        this.bankToWallet = false;
        this.beneficiariesManagement = false;
        this.beneficiariesUsage = false;
        this.bicReferential = false;
        this.billPayment = false;
        this.cardSensitiveDataView = false;
        this.cards = false;
        this.clientInformationUpdate = false;
        this.clientInformationView = false;
        this.consultAuthorizationHolds = false;
        this.consultLoans = false;
        this.customerInstructionDeletion = false;
        this.customerInstructionInitiation = false;
        this.customerInstructionSubmit = false;
        this.customerInstructionUpdate = false;
        this.customerInstructionView = false;
        this.externalAccountsManagement = false;
        this.externalAccountsUsage = false;
        this.externalLoanManagement = false;
        this.identityDocumentView = false;
        this.identityView = false;
        this.trustedDevices = false;
        this.manageCategorizationSpendings = false;
        this.manageQrCode = false;
        this.notifications = false;
        this.p2pCashTransfer = false;
        this.p2pDedicatedTransfer = false;
        this.p2pSimpleTransfer = false;
        this.p2pTransfer = false;
        this.payment = false;
        this.paymentContract = false;
        this.paymentInstructionView = false;
        this.paymentNetwork = false;
        this.paymentStandingOrderCreate = false;
        this.paymentStandingOrderView = false;
        this.paymentStandingOrderUpdate = false;
        this.paymentStandingOrderDelete = false;
        this.payout = false;
        this.pincodeUpdate = false;
        this.recipientCreate = false;
        this.savContractRead = false;
        this.savDeposit = false;
        this.savProductRead = false;
        this.savContractWrite = false;
        this.sdaAccountView = false;
        this.sdaAccountsNameUpdate = false;
        this.sdaAuthenticationsSessionsAuth = false;
        this.sdaAuthenticationsSessionsView = false;
        this.sdaCardView = false;
        this.sdaCustomerOnboardingActionsInitiate = false;
        this.sdaCustomerOnboardingCreate = false;
        this.sdaCustomerOnboardingSubmit = false;
        this.sdaCustomerOnboardingUpdate = false;
        this.sdaCustomerOnboardingView = false;
        this.sdaExchangeRateView = false;
        this.sdaRequiredActionsWrite = false;
        this.sdaTransactionsView = false;
        this.strongCustomerAuthentication = false;
        this.subscribeLoan = false;
        this.transactionCode = false;
        this.virtualCardCreation = false;
        this.walletRechargeByCard = false;
        this.withdraw = false;
        this.partyAuthenticationManagement = false;
        this.savDocumentsRead = false;
        this.additionalDataRead = false;
        this.mandateView = false;
        this.mandateManagement = false;
    }
}

});


parcelRegister("faGbe", function(module, exports) {

$parcel$export(module.exports, "IdentityManager", function () { return $2f5edf0afba25466$export$ee0bb48cca54fafe; });

var $3Ersk = parcelRequire("3Ersk");

var $fsofG = parcelRequire("fsofG");
class $2f5edf0afba25466$export$ee0bb48cca54fafe {
    constructor(identityService){
        this.identityService = identityService;
        this.clientRoleLoading = new (0, $3Ersk.Observable)(false);
        this.kycDocumentsLoading = new (0, $3Ersk.Observable)(false);
        this.clientRole = new (0, $3Ersk.Observable)(null);
        this.kycDocuments = new (0, $fsofG.ObservableArray)([]);
        this.kycLabels = new (0, $3Ersk.Observable)(null);
        this.clientRoleError = new (0, $3Ersk.Observable)(null);
        this.kycLabelsError = new (0, $3Ersk.Observable)(null);
        this.kycDocumentsError = new (0, $3Ersk.Observable)(null);
        this.downloadKycError = new (0, $3Ersk.Observable)(null);
    }
    async fetchClientRole(clientId) {
        try {
            this.clientRoleLoading.set(true);
            this.clientRoleError.set(null);
            const res = await this.identityService.fetchClientRole();
            const clientRole = res.items.find((identity)=>identity.id === clientId);
            this.clientRole.set(clientRole);
        } catch (e) {
            this.clientRoleError.set(e);
            throw e;
        } finally{
            this.clientRoleLoading.set(false);
        }
    }
    async fetchKycLabels(profileId) {
        try {
            this.kycLabelsError.set(null);
            const res = await this.identityService.fetchKycLabels(profileId);
            const mappedLabels = Object.fromEntries(res.map((kycLabel)=>[
                    kycLabel.id,
                    kycLabel.label
                ]));
            this.kycLabels.set(mappedLabels);
        } catch (e) {
            this.kycLabelsError.set(e);
            throw e;
        }
    }
    async fetchKycDocuments(clientId) {
        try {
            this.kycDocumentsLoading.set(true);
            this.kycDocumentsError.set(null);
            const res = await this.identityService.fetchKycDocuments(clientId);
            this.kycDocuments.set(res.items);
        } catch (e) {
            this.kycDocumentsError.set(e);
            throw e;
        } finally{
            this.kycDocumentsLoading.set(false);
        }
    }
    async downloadKycDocument(id) {
        try {
            this.downloadKycError.set(null);
            const res = await this.identityService.downloadKycDocument(id);
            return res;
        } catch (e) {
            this.downloadKycError.set(e);
            throw e;
        }
    }
}

});

parcelRegister("jgfcJ", function(module, exports) {

$parcel$export(module.exports, "IdentityService", function () { return $f0aac6d97b20e853$export$a15d2c6f0a44e818; });

var $4Zze3 = parcelRequire("4Zze3");

var $6JVVB = parcelRequire("6JVVB");
class $f0aac6d97b20e853$export$a15d2c6f0a44e818 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchClientRole() {
        try {
            const response = await this.apiService.instance.get("/identities?role=CLIENT");
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("IdentityService", "Failed to fetch client role", e);
            throw e;
        }
    }
    async fetchKycLabels(profileId) {
        try {
            const response = await this.apiService.instance.get("/additional-data-requirements", {
                params: {
                    legalType: "NATURAL_PERSON",
                    profileId: profileId
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("IdentityService", "Failed to fetch kyc labels", e);
            throw e;
        }
    }
    async fetchKycDocuments(clientId) {
        try {
            const response = await this.apiService.instance.get(`/identities/${clientId}/documents`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("IdentityService", "Failed to fetch kyc documents", e);
            throw e;
        }
    }
    async downloadKycDocument(id) {
        try {
            const response = await this.apiService.instance.get(`/documents/${id}/content`, {
                responseType: "arraybuffer"
            });
            const contentType = response.headers["content-type"];
            const contentFileType = contentType && contentType.split(";")[0];
            (0, $4Zze3.downloadFile)(`${id}_document.png`, response.data, contentFileType ?? "image/png");
            return `${id}_details.png`;
        } catch (e) {
            (0, $6JVVB.logger).debug("IdentityService", "Failed to download kyc document", e);
            throw e;
        }
    }
}

});

parcelRegister("jV3Gu", function(module, exports) {

$parcel$export(module.exports, "MandateFilterManager", function () { return $c7dda47dae6f625f$export$68c8b002ebf4f967; });

var $3Ersk = parcelRequire("3Ersk");

var $hppbX = parcelRequire("hppbX");
class $c7dda47dae6f625f$export$68c8b002ebf4f967 {
    setStatusSelection(status) {
        this.statusSelection.set(status);
    }
    clear() {
        this.statusSelection.set((0, $hppbX.MandateStatus).ALL);
    }
    constructor(){
        this.statusSelection = new (0, $3Ersk.Observable)((0, $hppbX.MandateStatus).ALL);
    }
}

});
parcelRegister("hppbX", function(module, exports) {

$parcel$export(module.exports, "MandateStatus", function () { return $e3b4be4acd484ca1$export$2705328036c71d76; });
$parcel$export(module.exports, "MandateStatusColor", function () { return $e3b4be4acd484ca1$export$d1e68af0344fa3ac; });
$parcel$export(module.exports, "MANDATES_STATUSES", function () { return $e3b4be4acd484ca1$export$2cb89a70b3d12d94; });
var $e3b4be4acd484ca1$export$2705328036c71d76 = /*#__PURE__*/ function(MandateStatus) {
    MandateStatus["ALL"] = "ALL";
    MandateStatus["ACTIVE"] = "ACTIVE";
    MandateStatus["CONSUMED"] = "CONSUMED";
    MandateStatus["REVOKED"] = "REVOKED";
    MandateStatus["OPPOSED"] = "OPPOSED";
    MandateStatus["CREDITOR_OPPOSED"] = "CREDITOR_OPPOSED";
    MandateStatus["OBSOLETE"] = "OBSOLETE";
    return MandateStatus;
}({});
var $e3b4be4acd484ca1$export$d1e68af0344fa3ac = /*#__PURE__*/ function(MandateStatusColor) {
    MandateStatusColor["SUCCESS"] = "success";
    MandateStatusColor["WARNING"] = "warning";
    MandateStatusColor["GRAY"] = "gray";
    return MandateStatusColor;
}({});
const $e3b4be4acd484ca1$export$2cb89a70b3d12d94 = {
    ["ALL"]: {
        label: "mandates.status.all",
        color: "success"
    },
    ["ACTIVE"]: {
        label: "mandates.status.active",
        color: "success"
    },
    ["OPPOSED"]: {
        label: "mandates.status.opposed",
        color: "warning"
    },
    ["CONSUMED"]: {
        label: "mandates.status.consumed",
        color: "gray"
    },
    ["REVOKED"]: {
        label: "mandates.status.revoked",
        color: "warning"
    },
    ["CREDITOR_OPPOSED"]: {
        label: "mandates.status.creditorOpposed",
        color: "gray"
    },
    ["OBSOLETE"]: {
        label: "mandates.status.obsolete",
        color: "gray"
    }
};

});


parcelRegister("fEQSP", function(module, exports) {

$parcel$export(module.exports, "MandatesManager", function () { return $2abc00e6708b6f3a$export$5132de43acfa8bf4; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");
class $2abc00e6708b6f3a$export$5132de43acfa8bf4 {
    constructor(mandatesService, featuresManager, cacheLoader){
        this.mandatesService = mandatesService;
        this.featuresManager = featuresManager;
        this.cacheLoader = cacheLoader;
        this.paginatedMandates = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.isLoading = new (0, $3Ersk.Observable)(false);
        this.canLoadMore = new (0, $3Ersk.Observable)(false);
    }
    async getMandates(offset) {
        const features = this.featuresManager.features.get();
        if (!features.mandateView) {
            (0, $6JVVB.logger).debug("MandatesManager", "User does not have permission to view mandates");
            this.paginatedMandates.set((0, $lbTbw.createEmptyPaginatedData)());
            this.canLoadMore.set(false);
            return;
        }
        this.isLoading.set(true);
        try {
            const response = await this.mandatesService.getMandates(offset);
            if (offset) this.paginatedMandates.add(response);
            else this.paginatedMandates.set(response);
            this.canLoadMore.set(response.count > response.limit + Number(response.offset));
        } catch (error) {
            (0, $6JVVB.logger).debug("MandatesManager", "Failed to get mandates", error);
            throw new Error(error);
        } finally{
            this.isLoading.set(false);
        }
    }
    async opposeMandate(id) {
        try {
            const response = await this.mandatesService.opposeMandate(id);
            return response;
        } catch (error) {
            (0, $6JVVB.logger).debug("MandatesManager", "Failed to oppose mandate", error);
            throw new Error(error);
        }
    }
    async activateMandate(id) {
        try {
            const response = await this.mandatesService.activateMandate(id);
            return response;
        } catch (error) {
            (0, $6JVVB.logger).debug("MandatesManager", "Failed to activate mandate", error);
            throw new Error(error);
        }
    }
    async loadMore() {
        if (this.canLoadMore.get()) {
            const paginatedMandates = this.paginatedMandates.get();
            const nextOffset = paginatedMandates.limit + Number(paginatedMandates.offset);
            await this.getMandates(nextOffset);
        }
    }
}

});

parcelRegister("4Cchr", function(module, exports) {

$parcel$export(module.exports, "MandatesService", function () { return $7b0065cab5edcff7$export$121e55542939159e; });

var $6JVVB = parcelRequire("6JVVB");
class $7b0065cab5edcff7$export$121e55542939159e {
    constructor(serviceDomainApiService){
        this.serviceDomainApiService = serviceDomainApiService;
    }
    async getMandates(offset) {
        try {
            const response = await this.serviceDomainApiService.instance.get("/mandates", {
                params: {
                    offset: offset
                }
            });
            if (!response?.data) throw new Error("Invalid response structure");
            return response.data;
        } catch (error) {
            (0, $6JVVB.logger).debug("MandatesService", "Failed to get mandates", error);
            throw new Error(error instanceof Error ? error.message : String(error));
        }
    }
    async opposeMandate(mandateId) {
        try {
            const response = await this.serviceDomainApiService.instance.post(`/mandates/${mandateId}/oppose`);
            return response.data;
        } catch (error) {
            (0, $6JVVB.logger).debug("MandatesService", "Failed to oppose mandate", error);
            throw new Error(error);
        }
    }
    async activateMandate(mandateId) {
        try {
            const response = await this.serviceDomainApiService.instance.post(`/mandates/${mandateId}/activate`);
            if (!response.data || typeof response.data !== "object" || !response.data.id) throw new Error("Invalid response structure");
            return response.data;
        } catch (error) {
            (0, $6JVVB.logger).debug("MandatesService", "Failed to activate mandate", error);
            throw new Error(error);
        }
    }
}

});

parcelRegister("29Yis", function(module, exports) {

$parcel$export(module.exports, "OnboardingManager", function () { return $f961a6c87e7e8eab$export$a2f244fe169736c5; });

var $gALIi = parcelRequire("gALIi");

var $jO1Lj = parcelRequire("jO1Lj");

var $6JVVB = parcelRequire("6JVVB");

var $gDlNU = parcelRequire("gDlNU");

var $ksEiC = parcelRequire("ksEiC");

var $3Ersk = parcelRequire("3Ersk");

var $cPJq2 = parcelRequire("cPJq2");
class $f961a6c87e7e8eab$export$a2f244fe169736c5 {
    constructor(onboardingService, featuresManager, imagesConverter){
        this.onboardingService = onboardingService;
        this.featuresManager = featuresManager;
        this.imagesConverter = imagesConverter;
        this.onboardingFile = new (0, $3Ersk.Observable)(null);
        this.steps = new (0, $3Ersk.Observable)([]);
        this.updated = new (0, $3Ersk.Observable)(true);
        this./**
   * True while a picked image is being turned into a PDF. That conversion is asynchronous and
   * nobody awaits it, so without this the user can reach the next step before the document is
   * ready and submit an empty — or stale — field.
   */ converting = new (0, $3Ersk.Observable)(false);
        this.pendingConversions = 0;
        this.updating = new (0, $3Ersk.Observable)(false);
        this.submitting = new (0, $3Ersk.Observable)(false);
        this.error = new (0, $3Ersk.Observable)(null);
        this.needOnboardingFileRedirect = new (0, $3Ersk.Observable)(false);
        this.allRequiredFieldsFilled = new (0, $3Ersk.Observable)(false);
        this.initializing = null;
    }
    async initialize() {
        if (!this.initializing) this.initializing = this.fetchOnboardingFile().finally(()=>{
            this.initializing = null;
        });
        return this.initializing;
    }
    async fetchOnboardingFile() {
        if (this.featuresManager.features.get().sdaCustomerOnboardingView) try {
            const onboardingFile = await this.onboardingService.getOnboardingFile();
            if (onboardingFile) {
                this.onboardingFile.set(onboardingFile);
                const needOnboardingFileRedirect = [
                    (0, $cPJq2.OnboardingStatus).INITIATED
                ].includes(onboardingFile?.status);
                this.needOnboardingFileRedirect.set(needOnboardingFileRedirect);
                this.setFilteredSteps(onboardingFile.form.inputs);
                return {
                    onboardingFile: onboardingFile,
                    needOnboardingFileRedirect: needOnboardingFileRedirect
                };
            }
        } catch (e) {
            if (e === "CLIENT_DELEGATE_USER_NOT_ALLOWED") throw e;
            else (0, $6JVVB.logger).debug("error getting onboarding file", e);
        }
    }
    async initiate(data) {
        try {
            await this.onboardingService.initiateOnboarding(data);
        } catch (e) {
            (0, $6JVVB.logger).debug("error initiating onboarding", e);
            throw e?.response?.data?.error?.message ?? e.toString();
        }
    }
    async updateOnboardingFile(stepId) {
        this.clearError();
        this.updating.set(true);
        try {
            const rawCollection = this.getStepById(stepId);
            const stepValues = this.getFlatCollectionData(rawCollection);
            const hasMissingRequiredFields = this.valuesHaveMissingRequiredFields(rawCollection.inputs);
            const hasValidationErrors = this.valuesHaveValidationErrors(rawCollection.inputs);
            if (!hasMissingRequiredFields.allCorrect) throw JSON.stringify({
                message: "Missing required fields",
                fields: hasMissingRequiredFields.errorFields
            });
            if (!hasValidationErrors.allCorrect) throw JSON.stringify({
                message: "Invalid fields",
                fields: hasValidationErrors.errorFields
            });
            if (this.updated.get()) {
                const onboardingFile = await this.onboardingService.updateOnboardingFile(stepValues);
                this.onboardingFile.set(onboardingFile);
                this.needOnboardingFileRedirect.set([
                    (0, $cPJq2.OnboardingStatus).INITIATED
                ].includes(onboardingFile?.status));
                this.setFilteredSteps(onboardingFile.form.inputs);
                this.updated.set(false);
            }
        } catch (e) {
            let JSONError;
            try {
                JSONError = JSON.parse(e);
            } catch  {
                JSONError = null;
            }
            if (JSONError?.message === "Invalid fields") {
                this.error.set("Certains champs sont incorrects.");
                throw JSONError;
            } else if (JSONError?.message === "Missing required fields") {
                this.error.set("Certains champs sont requis.");
                throw JSONError;
            } else {
                this.error.set(e?.response?.data?.error?.message ?? e.toString());
                throw e?.response?.data?.error?.message ?? e.toString();
            }
        } finally{
            this.updating.set(false);
        }
    }
    hasInputValueChanged(value, id, stepId) {
        const onboardingFile = this.onboardingFile.get();
        if (onboardingFile) {
            const step = onboardingFile?.form.inputs.find((s)=>s.id === stepId);
            if (!step) return false;
            const oldValue = $f961a6c87e7e8eab$var$getInput(step, id).value;
            return !(0, $gALIi.isEqual)(oldValue, value);
        }
        return false;
    }
    stringToRegex(str) {
        const main = str.match(/\/(.+)\/.*/);
        const options = str.match(/\/.+\/(.*)/);
        if (main && main.length > 1 && options && options.length > 1) return new RegExp(main[1], options[1]);
        return null;
    }
    valuesHaveMissingRequiredFields(inputs) {
        const result = {
            allCorrect: true,
            errorFields: []
        };
        const requiredFields = inputs.filter((e)=>e.required);
        requiredFields.forEach((input)=>{
            const requiredFieldValue = input.value;
            if (!requiredFieldValue && requiredFieldValue !== 0 || requiredFieldValue === "" || requiredFieldValue === null || requiredFieldValue === undefined) {
                //value not present or empty
                result.allCorrect = false;
                result.errorFields.push(input.id);
            }
        });
        return result;
    }
    valuesHaveValidationErrors(inputs) {
        const result = {
            allCorrect: true,
            errorFields: []
        };
        inputs.forEach((input)=>{
            const fieldValue = input.value;
            if (!!input.validators && !!fieldValue) {
                if (input.validators.some((rule)=>{
                    //if one of the validators is evaluated to false
                    const regex = this.stringToRegex(rule);
                    if (regex) return !regex.test(fieldValue?.toString());
                    return false;
                })) {
                    result.allCorrect = false;
                    result.errorFields.push(input.id);
                }
            }
        });
        return result;
    }
    getFlatCollectionData(collection) {
        const data = {};
        collection.inputs.forEach((input)=>{
            const fieldIsFileAndAlreadyUploaded = input.type === (0, $jO1Lj.FormInputType).FileContent && typeof input.value !== "string";
            if (!fieldIsFileAndAlreadyUploaded) data[input.id] = input.value;
        });
        return {
            [collection.id]: data
        };
    }
    fillResponse(stepId, input, value) {
        const steps = this.steps.get();
        const currentStep = steps.find((s)=>s.id === stepId);
        if (!currentStep) throw new Error(`Step ${stepId} not found`);
        if (this.hasInputValueChanged(value, input.id, stepId)) {
            this.updated.set(true);
            $f961a6c87e7e8eab$var$getInput(currentStep, input.id).value = value;
            // Prevent app freeze when updating a lot of inputs
            setTimeout(()=>{
                this.steps.set([
                    ...steps
                ]);
            }, 0);
        }
    }
    async fillMultiImagesResponse(stepId, input, values) {
        const isReady = values.reduce((prev, value)=>prev + (value ? 1 : 0), 0) >= (input.minimumPageCount ?? 1);
        let pdfDocument;
        if (isReady) {
            this.startConversion();
            try {
                const filteredValues = values.filter((value)=>value);
                try {
                    const converted = await this.imagesConverter.toPdf(filteredValues);
                    pdfDocument = (0, $gDlNU.isDefined)(converted) ? await this.imagesConverter.toBase64(converted) : undefined;
                } catch (e) {
                    // The field keeps what it held: writing the failure into it would read as a page the
                    // holder never removed, and the form would only say the field is missing.
                    (0, $6JVVB.logger).debug("error converting the pages to a document", e);
                    this.error.set("Le document n'a pas pu \xeatre pr\xe9par\xe9. R\xe9essayez ou choisissez un autre fichier.");
                    return;
                }
                if (!(0, $gDlNU.isDefined)(pdfDocument)) {
                    (0, $6JVVB.logger).debug("the pages produced no document");
                    this.error.set("Le document n'a pas pu \xeatre pr\xe9par\xe9. R\xe9essayez ou choisissez un autre fichier.");
                    return;
                }
            } finally{
                this.endConversion();
            }
        }
        const steps = this.steps.get();
        const currentStep = steps.find((s)=>s.id === stepId);
        if (!currentStep) throw new Error(`Step ${stepId} not found`);
        this.updated.set(true);
        const filledInput = $f961a6c87e7e8eab$var$getInput(currentStep, input.id);
        // Without the pages the field keeps no trace of what was already taken, so ImageField
        // resets its own list every time one is added — silently dropping the previous ones. The
        // register manager has always recorded them; only this one had been forgotten.
        filledInput.values = values;
        filledInput.value = pdfDocument;
        setTimeout(()=>{
            this.steps.set([
                ...steps
            ]);
        }, 0);
    }
    // Counted rather than a plain flag: adding two pages in a row overlaps two conversions.
    startConversion() {
        this.pendingConversions += 1;
        this.converting.set(true);
    }
    endConversion() {
        this.pendingConversions = Math.max(0, this.pendingConversions - 1);
        this.converting.set(this.pendingConversions > 0);
    }
    async submitOnboardingFile() {
        this.clearError();
        this.submitting.set(true);
        try {
            await this.onboardingService.submitOnboardingFile();
            this.updated.set(false);
            return await this.initialize();
        } catch (e) {
            (0, $6JVVB.logger).debug("error submitting onboarding file", e);
            this.error.set(e?.response?.data?.error?.message ?? e.toString());
        } finally{
            this.submitting.set(false);
        }
    }
    async getAttachmentPreview(attachmentId, links) {
        try {
            const url = links?.find((l)=>l.rel === "getDocumentPreview")?.href;
            const preview = await this.onboardingService.getAttachmentPreview(attachmentId, url);
            return preview;
        } catch (e) {
            (0, $6JVVB.logger).debug("error getting attachment preview", e);
        }
    }
    clearError() {
        this.error.set(null);
    }
    setFilteredSteps(inputs) {
        const filteredSteps = (0, $ksEiC.formatCollectionInputs)(inputs);
        this.steps.set(filteredSteps);
    }
    getStepById(stepId) {
        const steps = this.steps.get();
        const step = steps.find((s)=>s.id === stepId);
        if (!step) throw new Error(`Step ${stepId} not found`);
        return step;
    }
}
function $f961a6c87e7e8eab$var$getInput(collection, inputId) {
    const input = collection.inputs.find((i)=>i.id === inputId);
    if (!input) throw new Error(`can't find input ${inputId} in collection ${collection.id}`);
    return input;
}
class $f961a6c87e7e8eab$export$e826f5e6236eb1c0 extends Error {
    constructor(msg, fields){
        super(msg);
        this.fields = fields;
    }
}

});
parcelRegister("gALIi", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("ksEiC", function(module, exports) {

$parcel$export(module.exports, "formatCollectionInputs", function () { return $17c4fa215826956b$export$638d7656238b138a; });
function $17c4fa215826956b$export$638d7656238b138a(inputs) {
    return inputs.map((collection)=>({
            ...collection,
            inputs: Array.isArray(collection.inputs) ? collection.inputs : []
        })).filter((collection)=>collection.inputs.length > 0);
}

});

parcelRegister("cPJq2", function(module, exports) {

$parcel$export(module.exports, "OnboardingStatus", function () { return $268e4f9b4324cf3d$export$bcc3ec789deb1f8c; });
$parcel$export(module.exports, "MUST_RETAKE_ONBOARDING_FILE_STATUSES", function () { return $268e4f9b4324cf3d$export$273769f351c01c94; });
var $268e4f9b4324cf3d$export$bcc3ec789deb1f8c = /*#__PURE__*/ function(OnboardingStatus) {
    OnboardingStatus["INITIATED"] = "INITIATED";
    OnboardingStatus["COMPLETION_PENDING"] = "COMPLETION_PENDING";
    OnboardingStatus["READY_TO_SUBMIT"] = "READY_TO_SUBMIT";
    OnboardingStatus["SUBMITTED"] = "SUBMITTED";
    OnboardingStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    OnboardingStatus["EXTERNAL_CHECK_PENDING"] = "EXTERNAL_CHECK_PENDING";
    return OnboardingStatus;
}({});
const $268e4f9b4324cf3d$export$273769f351c01c94 = [
    "INITIATED",
    "READY_TO_SUBMIT",
    "COMPLETION_PENDING"
];

});


parcelRegister("a6zzA", function(module, exports) {

$parcel$export(module.exports, "OnboardingService", function () { return $3616b1c3d37cf14f$export$f25aa0aa32428d81; });

var $6JVVB = parcelRequire("6JVVB");

var $ksEiC = parcelRequire("ksEiC");

var $eIxDs = parcelRequire("eIxDs");
class $3616b1c3d37cf14f$export$f25aa0aa32428d81 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async initiateOnboarding(data) {
        try {
            const response = await this.apiService.instance.post("/onboarding/initiate", {
                ...data,
                phoneNumber: data.phoneNumber?.number
            });
            return response.status === 204;
        } catch (e) {
            (0, $6JVVB.logger).debug("OnboardingService", "Failed to initiate onboarding", e);
            // console.log(e)
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async getOnboardingFile() {
        try {
            const response = await this.apiService.instance.get("/onboarding/file");
            const formattedInputs = (0, $ksEiC.formatCollectionInputs)(response.data.form.inputs);
            return {
                ...response.data,
                form: {
                    ...response.data.form,
                    inputs: formattedInputs
                }
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("OnboardingService", "Failed to get onboarding file", e);
            if (e?.response.data.error.code === 62328) throw "CLIENT_DELEGATE_USER_NOT_ALLOWED";
            else throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async updateOnboardingFile(form) {
        try {
            const response = await this.apiService.instance.patch("/onboarding/file", {
                form: form
            });
            const formattedInputs = (0, $ksEiC.formatCollectionInputs)(response.data.form.inputs);
            return {
                ...response.data,
                inputs: formattedInputs
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("OnboardingService", "Failed to update onboarding file", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async getDocument(documentId, link) {
        try {
            const response = await this.apiService.instance.get(link || `/documents/${documentId}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("OnboardingService", "Failed to get document", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async getDocumentContent(documentId, link) {
        try {
            const response = await this.apiService.instance.get(link || `/documents/${documentId}/content`, {
                responseType: "arraybuffer"
            });
            const contentType = response.headers["content-type"]?.split(";")[0];
            return {
                data: response.data,
                contentType: contentType
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("OnboardingService", "Failed to get document content", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async getAttachmentPreview(attachmentId, link) {
        try {
            const response = await this.apiService.instance.get(link || `/documents/${attachmentId}/preview`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("OnboardingService", "Failed to get attachment preview", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async submitOnboardingFile() {
        try {
            const response = await this.apiService.instance.post("/onboarding/submit", {
                externalSystemOnboardingRedirectUrl: (0, $eIxDs.getUbbleRedirectUrlNewOnboarding)()
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("OnboardingService", "Failed to submit onboarding file", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("dl8DR", function(module, exports) {

$parcel$export(module.exports, "PartyAuthenticationManager", function () { return $c7209ddd4858e53d$export$5d317d285166cc25; });

var $l1qT9 = parcelRequire("l1qT9");

var $4LbnF = parcelRequire("4LbnF");

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $fsofG = parcelRequire("fsofG");

var $f1clM = parcelRequire("f1clM");
var $c7209ddd4858e53d$export$63b7e54359503931 = /*#__PURE__*/ function(PartyAuthenticationManagerState) {
    PartyAuthenticationManagerState["INITIATED"] = "INITIATED";
    PartyAuthenticationManagerState["SELECT_SESSION"] = "SELECT_SESSION";
    PartyAuthenticationManagerState["CAN_START_SESSION"] = "CAN_START_SESSION";
    PartyAuthenticationManagerState["START_SESSION"] = "START_SESSION";
    PartyAuthenticationManagerState["VERIFY_OTP"] = "VERIFY_OTP";
    PartyAuthenticationManagerState["VERIFY_PINCODE"] = "VERIFY_PINCODE";
    PartyAuthenticationManagerState["ERROR"] = "ERROR";
    return PartyAuthenticationManagerState;
}({});
const $c7209ddd4858e53d$var$SESSION_FILTER_THRESHOLD = {
    hours: 12
};
class $c7209ddd4858e53d$export$5d317d285166cc25 {
    constructor(service, navigationService){
        this.service = service;
        this.navigationService = navigationService;
        this.loading = new (0, $3Ersk.Observable)(false);
        this.error = new (0, $3Ersk.Observable)(null);
        this.state = new (0, $3Ersk.Observable)("INITIATED");
        this.sessions = new (0, $fsofG.ObservableArray)([]);
        this.currentSession = new (0, $3Ersk.Observable)(null);
    }
    async initialize() {
        await this.autoStart();
    }
    async refreshSessionList() {
        return await this.loadingWrapper(async ()=>await this.service.list()).then(async (data)=>{
            /**
         * We filter out sessions that are expired in the last 12 hours or in the future.
         */ const items = data.filter((session)=>(0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(session.expiredAt).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(new Date()).subtract($c7209ddd4858e53d$var$SESSION_FILTER_THRESHOLD.hours, "hours"))).map((session)=>new (0, $f1clM.PartyAuthenticationSessionState)(session));
            this.sessions.set(items);
        }, async (error)=>{
            this.error.set(error);
            this.state.set("ERROR");
            (0, $6JVVB.logger).debug("PartyAuthenticationManager", "refreshSessionList", error);
        });
    }
    async autoStart() {
        await this.refreshSessionList();
        const pendingSessions = this.sessions.get().filter((session)=>session.canStart());
        if (pendingSessions.length > 0) {
            this.state.set("SELECT_SESSION");
            try {
                if (pendingSessions.length === 1) {
                    await this.selectSession(pendingSessions[0].token);
                    const session = this.currentSession.get();
                    if (session) this.navigationService.navigate((0, $4LbnF.Routes).PartyAuthentication, {
                        token: session.token
                    });
                } else this.navigationService.navigate((0, $4LbnF.Routes).PartyAuthenticationList);
            } catch (error) {
                (0, $6JVVB.logger).debug("PartyAuthenticationManager", "Error while navigating, probably because logging is required", error);
            }
        }
    }
    async selectSession(token) {
        await this.loadingWrapper(async ()=>await this.service.getSession(token)).then((session)=>{
            this.error.set(null);
            this.currentSession.set(new (0, $f1clM.PartyAuthenticationSessionState)(session));
            this.state.set("CAN_START_SESSION");
        }).catch((error)=>{
            this.error.set(error);
            this.state.set("ERROR");
        });
    }
    async getSession(token) {
        (0, $6JVVB.logger).debug("PartyAuthenticationManager", "getSession", token);
        let session;
        try {
            session = await this.service.getSession(token);
            this.currentSession.set(new (0, $f1clM.PartyAuthenticationSessionState)(session));
        } catch (e) {
            (0, $6JVVB.logger).debug("PartyAuthenticationManager", "getSession failed", e);
            this.error.set(e);
        }
        return session;
    }
    async cancelSession(cancelLink) {
        let link;
        if (cancelLink) link = cancelLink;
        else link = this.currentSession.get().getCancelLink();
        await this.loadingWrapper(()=>this.service.authenticationSessionCancel(link));
    }
    async refuseSession() {
        await this.loadingWrapper(()=>this.service.authenticationSessionRefuse(this.currentSession.get().token));
    }
    async markSuspicious() {
        await this.loadingWrapper(()=>this.service.authenticationSessionMarkSuspicious(this.currentSession.get().token));
    }
    async startSession() {
        this.state.set("START_SESSION");
        if (this.currentSession.get()?.canSendSmsOtp()) {
            this.state.set("VERIFY_OTP");
            await this.sendSmsOtp();
        } else if (this.currentSession.get()?.canVerifyPincode()) this.state.set("VERIFY_PINCODE");
    }
    async sendSmsOtp(smsOtpLink) {
        (0, $6JVVB.logger).debug("PartyAuthenticationManager", "sendSmsOtp", this.state.get());
        let link;
        if (smsOtpLink) link = smsOtpLink;
        else link = this.currentSession.get().getSmsOtpLink();
        return await this.statusUpdate(async ()=>await this.service.authenticationSessionSendSMSOTP(link));
    }
    async verifySmsOtp(code, verifySmsOtpLink) {
        let link;
        if (verifySmsOtpLink) link = verifySmsOtpLink;
        else link = this.currentSession.get().getVerifySmsOtpLink();
        return await this.statusUpdate(async ()=>await this.service.authenticationSessionVerifySMSOTP(link, code));
    }
    async generatePincodeKeyboard(keyboardRequest, token) {
        (0, $6JVVB.logger).debug("PartyAuthenticationManager", "generatePincodeKeyboard", keyboardRequest);
        let sessionToken;
        if (token) sessionToken = token;
        else sessionToken = this.currentSession.get().token;
        return await this.service.generateVirtualKeyboard(sessionToken, keyboardRequest);
    }
    async verifyPinCode(pincode, verifyPincodeLink) {
        let link;
        if (verifyPincodeLink) link = verifyPincodeLink;
        else link = this.currentSession.get().getVerifyPincodeLink();
        return await this.statusUpdate(async ()=>await this.service.authenticationSessionVerifyPincode(link, pincode));
    }
    async verifyTrustedDevice(secret, verifyTrustedDeviceLink) {
        let link;
        if (verifyTrustedDeviceLink) link = verifyTrustedDeviceLink;
        else link = this.currentSession.get().getVerifyTrustedDeviceLink();
        return await this.statusUpdate(async ()=>await this.service.authenticationSessionVerifyTrustedDevice(link, secret));
    }
    async loadingWrapper(cb) {
        let result;
        try {
            this.loading.set(true);
            this.error.set(null);
            result = await cb();
        } catch (e) {
            this.error.set(e);
            this.state.set("ERROR");
            (0, $6JVVB.logger).debug("PartyAuthenticationManager", "loadingWrapper failed", e);
            throw e;
        } finally{
            this.loading.set(false);
        }
        return result;
    }
    async statusUpdate(cb) {
        let result;
        try {
            result = await this.loadingWrapper(cb);
        } catch (e) {
            result = e;
            (0, $6JVVB.logger).debug("PartyAuthenticationManager", "statusUpdate failed", e);
            throw e;
        } finally{
            if (result.links) {
                const sessionState = this.currentSession.get();
                result = sessionState?.update ? sessionState.update(result) : result;
                (0, $6JVVB.logger).debug("PartyAuthenticationManager", "Updated session", result);
                this.currentSession.set(result);
            }
        }
        return result;
    }
}

});
parcelRegister("4LbnF", function(module, exports) {

$parcel$export(module.exports, "Routes", function () { return $2833397c6291e26d$export$3565eb3d00ca5a74; });
var $2833397c6291e26d$export$3565eb3d00ca5a74 = /*#__PURE__*/ function(Routes) {
    Routes["Home"] = "Home";
    Routes["TransferNavigator"] = "TransferNavigator";
    Routes["TilesHome"] = "TilesHome";
    Routes["Loading"] = "Loading";
    Routes["AuthStack"] = "AuthStack";
    Routes["Auth"] = "Auth";
    Routes["Login"] = "Login";
    Routes["Register"] = "Register";
    Routes["FormCompleted"] = "FormCompleted";
    Routes["Onboarding"] = "Onboarding";
    Routes["OnboardingSuccess"] = "OnboardingSuccess";
    Routes["OnboardingFile"] = "OnboardingFile";
    Routes["OnboardingFileSubmitted"] = "OnboardingFileSubmitted";
    Routes["AccountsTab"] = "AccountsTab";
    Routes["ProductsTab"] = "ProductsTab";
    Routes["CardsTab"] = "CardsTab";
    Routes["PayBillTab"] = "PayBillTab";
    Routes["TransferTab"] = "TransferTab";
    Routes["TransferSelection"] = "TransferSelection";
    Routes["SourceAccountSelection"] = "SourceAccountSelection";
    Routes["DestinationAccountOrRecipient"] = "DestinationAccountOrRecipient";
    Routes["OpenLoopTransfer"] = "OpenLoopTransfer";
    Routes["OpenLoopTransferNavbar"] = "OpenLoopTransferNavbar";
    Routes["OpenLoopSummary"] = "OpenloopSummary";
    Routes["MoreTab"] = "MoreTab";
    Routes["AccountDetails"] = "AccountDetails";
    Routes["ClientInformation"] = "ClientInformation";
    Routes["KycUnchangedConfirmation"] = "KycUnchangedConfirmation";
    Routes["Recipients"] = "Recipients";
    Routes["AddBeneficiary"] = "AddBeneficiary";
    Routes["AddExternalAccount"] = "AddExternalAccount";
    Routes["EditRecipient"] = "EditRecipient";
    Routes["BeneficiaryDetail"] = "BeneficiaryDetail";
    Routes["BeneficiariesTransferModeSelection"] = "BeneficiariesTransferModeSelection";
    Routes["SearchBank"] = "SearchBank";
    Routes["Otp"] = "Otp";
    Routes["Cards"] = "Cards";
    Routes["NewCards"] = "NewCards";
    Routes["AcceptorNavigator"] = "AcceptorNavigator";
    Routes["ConnectedAcceptorNavigator"] = "ConnectedAcceptorNavigator";
    Routes["AcceptorTabNavigator"] = "AcceptorTabNavigator";
    Routes["AcceptorSearch"] = "AcceptorSearch";
    Routes["AcceptorList"] = "AcceptorList";
    Routes["AcceptorMapRedirect"] = "AcceptorMapRedirect";
    Routes["Transfer"] = "Transfer";
    Routes["TransferRecipients"] = "TransferRecipients";
    Routes["SimpleTransfer"] = "SimpleTransfer";
    Routes["TransferAmountSelection"] = "TransferAmountSelection";
    Routes["TransactionConfirmation"] = "TransactionConfirmation";
    Routes["PincodeConfirmation"] = "PincodeConfirmation";
    Routes["AccountBlocked"] = "AccountBlocked";
    Routes["TransferSummary"] = "TransferSummary";
    Routes["PayBill"] = "PayBill";
    Routes["BillForm"] = "BillForm";
    Routes["BillReferences"] = "BillReferences";
    Routes["TransactionCodes"] = "TransactionCodes";
    Routes["CodeEntry"] = "CodeEntry";
    Routes["TransactionCodeSummary"] = "TransactionCodeSummary";
    Routes["AccountStatementsNavigator"] = "AccountStatementsNavigator";
    Routes["AccountStatements"] = "AccountStatements";
    Routes["TaxStatements"] = "TaxStatements";
    Routes["EditRib"] = "EditRib";
    Routes["FeesStatements"] = "FeesStatements";
    Routes["Settings"] = "Settings";
    Routes["Security"] = "Security";
    Routes["DesignateTrustedDevice"] = "DesignateTrustedDevice";
    Routes["DesignateTrustedDeviceSuccessScreen"] = "DesignateTrustedDeviceSuccessScreen";
    Routes["DesignateTrustedDeviceErrorScreen"] = "DesignateTrustedDeviceErrorScreen";
    Routes["DisassociateTrustedDevice"] = "DisassociateTrustedDevice";
    Routes["DisassociateTrustedDeviceSuccessScreen"] = "DisassociateTrustedDeviceSuccessScreen";
    Routes["DisassociateTrustedDeviceErrorScreen"] = "DisassociateTrustedDeviceErrorScreen";
    Routes["PincodeChange"] = "PincodeChange";
    Routes["EULA"] = "EULA";
    Routes["Privacy"] = "Privacy";
    Routes["OtpAuth"] = "OtpAuth";
    Routes["CashTransfer"] = "CashTransfer";
    Routes["TransactionSummary"] = "TransactionSummary";
    Routes["ContactSupport"] = "ContactSupport";
    Routes["AccountTransaction"] = "AccountTransaction";
    Routes["ExternalLoansManagement"] = "ExternalLoansManagement";
    Routes["PaymentForm"] = "PaymentForm";
    Routes["ExternalUbble"] = "ExternalUbble";
    Routes["Result"] = "Result";
    Routes["ClientStatusResult"] = "ClientStatusResult";
    Routes["ActivateCard"] = "ActivateCard";
    Routes["CreateCard"] = "CreateCard";
    Routes["RefabricateCard"] = "RefabricateCard";
    Routes["UpdateCardPincode"] = "UpdateCardPincode";
    Routes["RechargeAccount"] = "RechargeAccount";
    Routes["AccountSelection"] = "AccountSelection";
    Routes["RechargeByCard"] = "RechargeByCard";
    Routes["RechargeBankToWallet"] = "RechargeBankToWallet";
    Routes["RechargeSummary"] = "RechargeSummary";
    Routes["OpposeCard"] = "OpposeCard";
    Routes["AccountDelete"] = "AccountDelete";
    Routes["QRCode"] = "QRCode";
    Routes["QRCodeInput"] = "QRCodeInput";
    Routes["QRCodeResult"] = "QRCodeResult";
    Routes["QRCodeParameters"] = "QRCodeParameters";
    Routes["QRCodeDisplay"] = "QRCodeDisplay";
    Routes["QrCodesLibrary"] = "QrCodesLibrary";
    Routes["QRCodeFocus"] = "QRCodeFocus";
    Routes["AuthorizationHoldsList"] = "AuthorizationHoldsList";
    Routes["JustifyTransaction"] = "JustifyTransaction";
    Routes["ExpenseEditDetails"] = "ExpenseEditDetails";
    Routes["CardOutstandings"] = "CardOutstandings";
    Routes["UpdateCardOutstanding"] = "UpdateCardOutstanding";
    Routes["DebugNavigator"] = "DebugNavigator";
    Routes["PartyAuthenticationList"] = "PartyAuthenticationList";
    Routes["PartyAuthentication"] = "PartyAuthentication";
    Routes["PartyAuthenticationAccepted"] = "PartyAuthenticationAccepted";
    Routes["PartyAuthenticationRefused"] = "PartyAuthenticationRefused";
    Routes["PartyAuthenticationFailed"] = "PartyAuthenticationFailed";
    Routes["PartyAuthenticationCancelled"] = "PartyAuthenticationCancelled";
    Routes["PartyAuthenticationBlocked"] = "PartyAuthenticationBlocked";
    Routes["AskCredit"] = "AskCredit";
    Routes["CreditSimulation"] = "CreditSimulation";
    Routes["CreditAdditionnalForm"] = "CreditAdditionnalForm";
    Routes["CreditResponse"] = "CreditResponse";
    Routes["ManageCredits"] = "ManageCredits";
    Routes["CreditDetails"] = "CreditDetails";
    Routes["BillIssuerNavigator"] = "BillIssuerNavigator";
    Routes["MarchantBillIssuerNavigator"] = "MarchantBillIssuerNavigator";
    Routes["MobileBillIssuerNavigator"] = "MobileBillIssuerNavigator";
    Routes["CodeConfirmationBillIssuerNavigator"] = "CodeConfirmationBillIssuerNavigator";
    Routes["CodeConfirmationBillIssuer"] = "CodeConfirmationBillIssuer";
    Routes["InvestmentBillIssuerNavigator"] = "InvestmentBillIssuerNavigator";
    Routes["InvestmentBillIssuer"] = "InvestmentBillIssuer";
    Routes["TransferBillIssuerNavigator"] = "TransferBillIssuerNavigator";
    Routes["TransferBillIssuer"] = "TransferBillIssuer";
    Routes["RechargeNavigator"] = "RechargeNavigator";
    Routes["TransferBankNavigator"] = "TransferBankNavigator";
    Routes["BillIssuerByType"] = "BillIssuerByType";
    Routes["Beneficiaries"] = "Beneficiaries";
    Routes["AccountPendingVerification"] = "AccountPendingVerification";
    Routes["WithdrawalNavigator"] = "WithdrawalNavigator";
    Routes["ErrorScreen"] = "ErrorScreen";
    Routes["RefundTransaction"] = "RefundTransactionScreen";
    Routes["UpcomingTransfers"] = "UpcomingTransfers";
    Routes["EditUpcomingTransfer"] = "EditUpcomingTransfer";
    Routes["UbbleRedirectionSuccess"] = "UbbleRedirectionSuccess";
    Routes["Mandates"] = "Mandates";
    return Routes;
}({});

});

parcelRegister("f1clM", function(module, exports) {

$parcel$export(module.exports, "PartyAuthenticationSessionState", function () { return $c403ca28470a18f7$export$976744255b9e95dd; });

var $bJu5B = parcelRequire("bJu5B");
class $c403ca28470a18f7$export$976744255b9e95dd {
    constructor(session){
        this.session = session;
    }
    update(statusUpdate) {
        if (this.session) {
            this.session.status = statusUpdate.status;
            this.session.links = statusUpdate.links;
        }
        return this;
    }
    get token() {
        return this.session.token;
    }
    get identityIdentifier() {
        return this.session.identityIdentifier;
    }
    get externalIdentifier() {
        return this.session.externalIdentifier;
    }
    get description() {
        return this.session.data?.description;
    }
    get initiatedAt() {
        return this.session.initiatedAt;
    }
    get expiredAt() {
        return this.session.expiredAt;
    }
    get currentStatus() {
        return this.isActive() && this.session.expiredAt <= new Date() ? (0, $bJu5B.PartyAuthenticationSessionStatus).EXPIRED : this.session.status;
    }
    canStart() {
        return this.isActive() && !this.isExpired();
    }
    isActive() {
        return [
            (0, $bJu5B.PartyAuthenticationSessionStatus).PENDING,
            (0, $bJu5B.PartyAuthenticationSessionStatus).STARTED
        ].includes(this.session.status);
    }
    isExpired() {
        return this.currentStatus === (0, $bJu5B.PartyAuthenticationSessionStatus).EXPIRED;
    }
    isValid() {
        return [
            (0, $bJu5B.PartyAuthenticationSessionStatus).PENDING,
            (0, $bJu5B.PartyAuthenticationSessionStatus).STARTED,
            (0, $bJu5B.PartyAuthenticationSessionStatus).DONE
        ].includes(this.currentStatus);
    }
    isError() {
        return [
            (0, $bJu5B.PartyAuthenticationSessionStatus).CANCELLED,
            (0, $bJu5B.PartyAuthenticationSessionStatus).REFUSED,
            (0, $bJu5B.PartyAuthenticationSessionStatus).FAILED
        ].includes(this.currentStatus);
    }
    isDone() {
        return this.session.status === (0, $bJu5B.PartyAuthenticationSessionStatus).DONE;
    }
    getStatus() {
        return this.session.status;
    }
    canCancel() {
        return !!this.session.links.authenticationSessionCancel;
    }
    getCancelLink() {
        return this.session.links.authenticationSessionCancel ?? null;
    }
    canRefuse() {
        return this.session.status === (0, $bJu5B.PartyAuthenticationSessionStatus).PENDING || this.session.status === (0, $bJu5B.PartyAuthenticationSessionStatus).STARTED;
    }
    canSendSmsOtp() {
        return !!this.session.links.authenticationSessionSendSMSOTP;
    }
    getSmsOtpLink() {
        return this.session.links.authenticationSessionSendSMSOTP ?? null;
    }
    canVerifySmsOtp() {
        return !!this.session.links.authenticationSessionVerifySMSOTP;
    }
    getVerifySmsOtpLink() {
        return this.session.links.authenticationSessionVerifySMSOTP ?? null;
    }
    canVerifyPincode() {
        return !!this.session.links.authenticationSessionVerifyPincode;
    }
    getVerifyPincodeLink() {
        return this.session.links.authenticationSessionVerifyPincode ?? null;
    }
    canVerifyTrustedDevice() {
        return !!this.session.links.authenticationSessionVerifyTrustedDevice;
    }
    getVerifyTrustedDeviceLink() {
        // ATTENTION: remove this replace code when the trusted device link is fixed
        const hateoasLink = this.session.links.authenticationSessionVerifyTrustedDevice ?? null;
        if (hateoasLink) {
            const customHateoasLink = {
                ...hateoasLink,
                href: hateoasLink.href.replace("/methods/devices/verify", "/methods/device/verify")
            };
            return customHateoasLink;
        }
        return hateoasLink;
    }
    canOnlyVerifyPincode() {
        return this.canVerifyPincode() && !this.canVerifySmsOtp();
    }
    canOnlyVerifySmsOtp() {
        return !this.canVerifyPincode() && this.canVerifySmsOtp();
    }
    canVerifyPincodeAndSmsOtp() {
        return this.canVerifyPincode() && this.canVerifySmsOtp();
    }
    canVerifyTrustedDeviceAndPincode(secret) {
        const allMethodsAreAvailable = this.canVerifyTrustedDevice() && this.canVerifyPincode() && this.canVerifySmsOtp();
        return !allMethodsAreAvailable && !!secret && this.canVerifyTrustedDevice() && this.canVerifyPincode();
    }
}

});
parcelRegister("bJu5B", function(module, exports) {

$parcel$export(module.exports, "PartyAuthenticationSessionStatus", function () { return $fa71152c1f3fd846$export$14cfd3a5087773ed; });
var $fa71152c1f3fd846$export$14cfd3a5087773ed = /*#__PURE__*/ function(PartyAuthenticationSessionStatus) {
    PartyAuthenticationSessionStatus["PENDING"] = "PENDING";
    PartyAuthenticationSessionStatus["STARTED"] = "STARTED";
    PartyAuthenticationSessionStatus["DONE"] = "DONE";
    PartyAuthenticationSessionStatus["CANCELLED"] = "CANCELLED";
    PartyAuthenticationSessionStatus["FAILED"] = "FAILED";
    PartyAuthenticationSessionStatus["REFUSED"] = "REFUSED";
    PartyAuthenticationSessionStatus["EXPIRED"] = "EXPIRED";
    return PartyAuthenticationSessionStatus;
}({});
var $fa71152c1f3fd846$export$6642c3d3607ec312 = /*#__PURE__*/ function(PartyIdentifierType) {
    PartyIdentifierType["PHONE_NUMBER"] = "PHONE_NUMBER";
    PartyIdentifierType["IDENTITY_ID"] = "IDENTITY_ID";
    PartyIdentifierType["TRUSTED_DEVICE"] = "TRUSTED_DEVICE";
    PartyIdentifierType["CREATE_RECIPIENT"] = "CREATE_RECIPIENT";
    PartyIdentifierType["LOGIN"] = "LOGIN";
    PartyIdentifierType["CARD_ID"] = "CARD_ID";
    return PartyIdentifierType;
}({});

});



parcelRegister("8M8RF", function(module, exports) {

$parcel$export(module.exports, "PartyAuthenticationService", function () { return $4eab283493f18d94$export$26464c74f5d125f; });

var $6JVVB = parcelRequire("6JVVB");
class $4eab283493f18d94$export$26464c74f5d125f {
    constructor(apiService){
        this.apiService = apiService;
    }
    async list() {
        try {
            const response = await this.apiService.getInstance().get("/authentications/sessions", {
                params: {
                    sort: "-expirationDate"
                }
            });
            return response.data.items.map(this.getPartyAuthenticationSessionFromData, this);
        } catch (error) {
            (0, $6JVVB.logger).debug("PartyAuthenticationService", "Get party authentication sessions list failed", error);
            throw error;
        }
    }
    async getSession(token) {
        try {
            const response = await this.apiService.getInstance().get(`/authentications/sessions/${token}`);
            return this.getPartyAuthenticationSessionFromData(response.data);
        } catch (e) {
            (0, $6JVVB.logger).debug("PartyAuthenticationService", `Get party authentication session #${token} failed`, e);
            throw e;
        }
    }
    async authenticationSessionRefuse(token) {
        try {
            await this.apiService.getInstance().post(`/authentications/sessions/${token}/refuse`);
            return;
        } catch (e) {
            (0, $6JVVB.logger).debug("PartyAuthenticationService", `Refuse party authentication session #${token} failed`, e);
            throw new Error(e);
        }
    }
    async authenticationSessionMarkSuspicious(token) {
        try {
            await this.apiService.getInstance().patch(`/authentications/sessions/${token}/mark-suspicious`);
            return;
        } catch (e) {
            (0, $6JVVB.logger).debug("PartyAuthenticationService", `Mark Suspicious party authentication session #${token} failed`, e);
            throw new Error(e);
        }
    }
    async authenticationSessionCancel(link) {
        return this.emptyAction(link);
    }
    async authenticationSessionSendSMSOTP(link) {
        return this.actionWithSessionStatus(link, {});
    }
    async authenticationSessionVerifySMSOTP(link, code) {
        return this.actionWithSessionStatus(link, {
            code: code
        });
    }
    async generateVirtualKeyboard(token, keyboardSpec) {
        try {
            const response = await this.apiService.getInstance().post(`/authentications/sessions/${token}/keyboard`, keyboardSpec);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("PartyAuthenticationService", `#${token} keyboard fetch failed`, e);
            throw e;
        }
    }
    async authenticationSessionVerifyPincode(link, pincode) {
        return this.actionWithSessionStatus(link, {
            pincode: pincode
        });
    }
    async authenticationSessionVerifyTrustedDevice(link, secret) {
        return this.actionWithSessionStatus(link, {
            secret: secret
        });
    }
    async actionWithSessionStatus(link, payload) {
        try {
            const href = link.href;
            const response = await this.apiService.getInstance().post(href, payload);
            if (response.data?.status === "FAILED") throw new Error("AUTHENTICATION_IS_ENDED");
            return {
                ...response.data,
                // @ts-ignore
                links: this.extractLinks(response.data.links ?? [])
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("PartyAuthenticationService", `Action failed with link.rel ${link.rel}`, e);
            if (e.response?.data?.status) throw new Error({
                ...e.response.data,
                // @ts-ignore
                links: this.extractLinks(e.response.data.links ?? [])
            });
            throw e;
        }
    }
    async emptyAction(link) {
        try {
            const href = link.href;
            await this.apiService.getInstance().post(href);
            return;
        } catch (e) {
            (0, $6JVVB.logger).debug("PartyAuthenticationService", `Action ${link.rel} failed on party authentication session failed`, e);
            throw e;
        }
    }
    getPartyAuthenticationSessionFromData(item) {
        return {
            ...item,
            initiatedAt: item.initiatedAt ? new Date(item.initiatedAt) : undefined,
            expiredAt: item.expiredAt ? new Date(item.expiredAt) : undefined,
            links: this.extractLinks(item.links)
        };
    }
    extractLinks(links) {
        const sessionLinks = {};
        links.forEach((link)=>{
            sessionLinks[link.rel] = link;
        });
        return sessionLinks;
    }
}

});

parcelRegister("7lmN6", function(module, exports) {

$parcel$export(module.exports, "CheckPincodeService", function () { return $e386d2b8972a3fa0$export$9f59b2489ddfd7d4; });

var $6JVVB = parcelRequire("6JVVB");

var $1YFGv = parcelRequire("1YFGv");
class $e386d2b8972a3fa0$export$9f59b2489ddfd7d4 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async checkPincode(pincode) {
        try {
            await this.apiService.instance.post("/client/pincode/verify", {
                pincode: pincode
            });
        } catch (e) {
            (0, $6JVVB.logger).debug("PincodeService", "Check pincode failed", e);
            if (e?.response?.data?.error?.code === (0, $1YFGv.PINCODE_MUST_BE_CHANGED_ERROR_CODE)) throw new (0, $1YFGv.PincodeMustBeChangedError)(e?.response?.data?.error?.message);
            else if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("lwQMA", function(module, exports) {

$parcel$export(module.exports, "PincodeKeyboardService", function () { return $fad844c00224de28$export$7fb61e2a5be4d0b7; });

var $6JVVB = parcelRequire("6JVVB");

var $7ijMf = parcelRequire("7ijMf");
class $fad844c00224de28$export$7fb61e2a5be4d0b7 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchKeyboard(touchSize, clientPhone, fontSize, fontFamily = "DMSans", fontWeight = "Medium") {
        try {
            const pixelSize = (0, $7ijMf.getPixelSizeForLayoutSize)(touchSize);
            const requestedFontSize = fontSize ? fontSize : pixelSize * 0.5;
            const requestedFontFamily = `${fontFamily}-${fontWeight}`;
            const response = await this.apiService.instance.get(clientPhone ? `/keyboard/${clientPhone}?font=${requestedFontFamily}&width=${pixelSize}&fontSize=${requestedFontSize}` : `/keyboard?font=${requestedFontFamily}&width=${pixelSize}&fontSize=${requestedFontSize}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("PincodeService", "Fetch keyboard failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});
parcelRegister("7ijMf", function(module, exports) {

$parcel$export(module.exports, "getPixelSizeForLayoutSize", function () { return $fc7735adeb37c704$export$86ad991bf5d2b1b7; });
const $fc7735adeb37c704$export$86ad991bf5d2b1b7 = (layoutSize)=>layoutSize;

});


parcelRegister("eMOeB", function(module, exports) {

$parcel$export(module.exports, "PincodeService", function () { return $4e5354f180d7719e$export$3c460f9f1de229cd; });

var $6JVVB = parcelRequire("6JVVB");
class $4e5354f180d7719e$export$3c460f9f1de229cd {
    constructor(apiService){
        this.apiService = apiService;
    }
    async changePincode(currentPincode, newPincode) {
        try {
            const response = await this.apiService.instance.put("/client/pincode", {
                currentPincode: currentPincode,
                newPincode: newPincode
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("PincodeService", "Change pincode failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("fWEzG", function(module, exports) {

$parcel$export(module.exports, "ProductManager", function () { return $d6cbae0653a544c0$export$12a802f9b816c574; });

var $6JVVB = parcelRequire("6JVVB");

var $gDlNU = parcelRequire("gDlNU");

var $fsofG = parcelRequire("fsofG");

var $il8Zm = parcelRequire("il8Zm");
class $d6cbae0653a544c0$export$12a802f9b816c574 {
    constructor(productService, authenticationManager, clientManager){
        this.productService = productService;
        this.authenticationManager = authenticationManager;
        this.clientManager = clientManager;
        this.debitCardProducts = new (0, $fsofG.ObservableArray)([]);
        this.authenticationManager.isConnected.onChange.add((isConnected)=>{
            if (!isConnected) this.clear();
            this.clientManager.onLanguageChange.add(async ()=>{
                await this.clear();
            });
        });
    }
    // TPMW-76 : Fix while the backend does not fill the cardActivationMode
    // In this case we must be able to activate the card with a code
    // which is considered the default mode
    addActivationMode(products) {
        const updatedProducts = products.map((product)=>!(0, $gDlNU.isDefined)(product.cardActivationMode) ? {
                ...product,
                cardActivationMode: (0, $il8Zm.ProductCardActivationMode).withCode
            } : product);
        return updatedProducts;
    }
    async loadDebitCardProducts() {
        try {
            const products = await this.productService.fetchProducts((0, $il8Zm.ProductType).DebitCard);
            this.debitCardProducts.set(this.addActivationMode(products.items));
        } catch (e) {
            (0, $6JVVB.logger).debug("ProductManager", "Failed to load products of type DebitCard", e);
            throw e;
        }
    }
    clear() {
        this.debitCardProducts.set([]);
    }
}

});
parcelRegister("il8Zm", function(module, exports) {

$parcel$export(module.exports, "ProductType", function () { return $6d6543c9d0901fdc$export$11b099a658b17995; });
$parcel$export(module.exports, "ProductCardActivationMode", function () { return $6d6543c9d0901fdc$export$70bc7dcada2067a8; });
var $6d6543c9d0901fdc$export$11b099a658b17995 = /*#__PURE__*/ function(ProductType) {
    ProductType["Current"] = "CURRRENT";
    ProductType["Savings"] = "SAVINGS";
    ProductType["Commissions"] = "COMMISSIONS";
    ProductType["Dedicated"] = "DEDICATED";
    ProductType["MoneyPot"] = "MONEYPOT";
    ProductType["DebitCard"] = "DEBIT_CARD";
    ProductType["GuaranteeAccount"] = "GUARANTEE_ACCOUNT";
    return ProductType;
}({});
var $6d6543c9d0901fdc$export$70bc7dcada2067a8 = /*#__PURE__*/ function(ProductCardActivationMode) {
    ProductCardActivationMode["withCode"] = "WITH_CODE";
    ProductCardActivationMode["withoutCode"] = "WITHOUT_CODE";
    return ProductCardActivationMode;
}({});

});


parcelRegister("dwwRL", function(module, exports) {

$parcel$export(module.exports, "ProductService", function () { return $74a1f5c96940747f$export$f4ea222e76e5ca5c; });

var $6JVVB = parcelRequire("6JVVB");
class $74a1f5c96940747f$export$f4ea222e76e5ca5c {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchProducts(productTypeFilter, pagination) {
        try {
            const response = await this.apiService.instance.get("/products", {
                params: {
                    type: productTypeFilter,
                    ...pagination
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ProductService", "Fetch products failed", e);
            throw e;
        }
    }
}

});

parcelRegister("3KRz4", function(module, exports) {

$parcel$export(module.exports, "BeneficiaryManager", function () { return $ad9398e8f73cb5fb$export$53c6522f78b33ab0; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");
class $ad9398e8f73cb5fb$export$53c6522f78b33ab0 {
    constructor(beneficiaryService, authenticationManager, featuresManager, cacheLoader){
        this.beneficiaryService = beneficiaryService;
        this.authenticationManager = authenticationManager;
        this.featuresManager = featuresManager;
        this.cacheLoader = cacheLoader;
        this.recipients = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.cacheStatus = new (0, $3Ersk.Observable)(null);
        this.loading = new (0, $3Ersk.Observable)(false);
        this.error = new (0, $3Ersk.Observable)(null);
        this.loadingMore = new (0, $3Ersk.Observable)(false);
        this.loadingMoreError = new (0, $3Ersk.Observable)(null);
        this.authenticationManager.isConnected.onChange.add(async (isConnected)=>{
            if (!isConnected) await this.clear();
        });
    }
    async load(forceRefresh) {
        if (this.loading.get() || !(this.featuresManager.features.get().beneficiariesManagement || this.featuresManager.features.get().beneficiariesUsage)) return;
        try {
            this.loading.set(true);
            this.error.set(null);
            const recipients = await this.cacheLoader.load(()=>this.beneficiaryService.fetchRecipients(undefined), forceRefresh);
            if (!recipients) throw Error("Failed to fetch recipients");
            await this.updateCacheStatus();
            this.recipients.set(recipients);
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryManager", "Load beneficiary failed", e);
            this.error.set(e);
            this.recipients.set((0, $lbTbw.createEmptyPaginatedData)());
        } finally{
            this.loading.set(false);
        }
    }
    async loadMore() {
        if (this.loading.get() || this.loadingMore.get()) return;
        try {
            this.loadingMore.set(true);
            this.loadingMoreError.set(null);
            const additional = await this.beneficiaryService.fetchRecipients({
                offset: this.recipients.get().offset + this.recipients.get().limit,
                limit: this.recipients.get().limit,
                sort: this.recipients.get().sort
            });
            this.recipients.add(additional);
            this.cacheLoader.store(this.recipients.get(), this.cacheStatus.get()?.creation);
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryManager", "Load more recipient failed", e);
            this.loadingMoreError.set(e);
        } finally{
            this.loadingMore.set(false);
        }
    }
    async requestNewRecipient(name, identity) {
        const session = this.authenticationManager.session.get();
        return await this.beneficiaryService.requestNewRecipient(session.clientId, name, identity);
    }
    async confirmNewRecipient(name, identity, otp) {
        const session = this.authenticationManager.session.get();
        const result = await this.beneficiaryService.confirmNewRecipient(session.clientId, name, identity, otp);
        await this.load(true);
        return result;
    }
    async deleteRecipient(id) {
        await this.beneficiaryService.deleteRecipient(id);
        await this.load(true);
    }
    async updateRecipient(id, name) {
        await this.beneficiaryService.updateRecipient(id, name);
        const recipients = this.recipients.get();
        const index = recipients.items.findIndex((recipient)=>recipient.id === id);
        const recipient = recipients.items[index];
        if (index >= 0) {
            recipients.items[index] = {
                ...recipient,
                name: name
            };
            this.recipients.set(recipients);
        }
        await this.load(true);
    }
    async updateCacheStatus() {
        const cacheStatus = await this.cacheLoader.readStatus();
        this.cacheStatus.set(cacheStatus);
    }
    async clear() {
        await this.cacheLoader.clear();
        this.recipients.set((0, $lbTbw.createEmptyPaginatedData)());
        this.cacheStatus.set(null);
    }
}

});

parcelRegister("9AZir", function(module, exports) {

$parcel$export(module.exports, "BeneficiaryService", function () { return $fcd36a3945a93988$export$6b563d21d2bf52de; });

var $6JVVB = parcelRequire("6JVVB");

var $kwKQQ = parcelRequire("kwKQQ");
class $fcd36a3945a93988$export$6b563d21d2bf52de {
    constructor(apiService, serviceDomainApiService){
        this.apiService = apiService;
        this.serviceDomainApiService = serviceDomainApiService;
    }
    async fetchRecipients(pagination) {
        try {
            const response = await this.apiService.instance.get("/beneficiaries", {
                params: pagination
            });
            return {
                ...response.data,
                items: response.data.items.filter((item)=>item.state === (0, $kwKQQ.RecipientStateEnum).OPENED || item.state === (0, $kwKQQ.RecipientStateEnum).PENDING)
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryService", "Fetch beneficiaries failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async requestNewRecipient(clientId, name, identity) {
        if (clientId) try {
            const response = await this.serviceDomainApiService.instance.post(`/identities/${clientId}/recipients`, {
                name: name,
                ...identity,
                // if phone convert it to number
                ...identity.phone && {
                    phone: Number(identity.phone)
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryService", "Request new recipient failed", e);
            throw e?.response?.data?.message || e.toString();
        }
        else throw "Client ID is missing";
    }
    async confirmNewRecipient(clientId, name, identity, otp) {
        if (clientId) try {
            const response = await this.serviceDomainApiService.instance.post(`/identities/${clientId}/recipients`, {
                name: name,
                ...identity,
                otp: otp
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryService", "Confirm new recipient failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
        else throw "Client ID is missing";
    }
    async updateRecipient(id, name) {
        try {
            const response = await this.apiService.instance.patch(`/beneficiaries/${id}`, {
                name: name
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryService", "Update recipient failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async deleteRecipient(id) {
        try {
            await this.apiService.instance.delete(`/beneficiaries/${id}`);
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryService", "Delete recipient failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});
parcelRegister("kwKQQ", function(module, exports) {

$parcel$export(module.exports, "RecipientStateEnum", function () { return $a1b9461e064f4979$export$ff4c30e96dab41e2; });
var $a1b9461e064f4979$export$ff4c30e96dab41e2 = /*#__PURE__*/ function(RecipientStateEnum) {
    RecipientStateEnum["OPENED"] = "opened";
    RecipientStateEnum["CLOSED"] = "closed";
    RecipientStateEnum["PENDING"] = "pending";
    return RecipientStateEnum;
}({});
var $a1b9461e064f4979$export$d47a8e622103cca = /*#__PURE__*/ function(RecipientStrongAuthenticationModeEnum) {
    RecipientStrongAuthenticationModeEnum["OTP_SMS"] = "SMS_OTP";
    RecipientStrongAuthenticationModeEnum["PINCODE"] = "PINCODE";
    return RecipientStrongAuthenticationModeEnum;
}({});

});


parcelRegister("f1VGu", function(module, exports) {

$parcel$export(module.exports, "ExternalAccountManager", function () { return $8e9fd90b95bd827c$export$6efb8d06679eb32e; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");
class $8e9fd90b95bd827c$export$6efb8d06679eb32e {
    constructor(externalAccountService, authenticationManager, featuresManager, cacheLoader){
        this.externalAccountService = externalAccountService;
        this.authenticationManager = authenticationManager;
        this.featuresManager = featuresManager;
        this.cacheLoader = cacheLoader;
        this.externalAccounts = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.cacheStatus = new (0, $3Ersk.Observable)(null);
        this.loading = new (0, $3Ersk.Observable)(false);
        this.error = new (0, $3Ersk.Observable)(null);
        this.loadingMore = new (0, $3Ersk.Observable)(false);
        this.loadingMoreError = new (0, $3Ersk.Observable)(null);
        this.authenticationManager.isConnected.onChange.add(async (isConnected)=>{
            if (!isConnected) await this.clear();
        });
    }
    async load(forceRefresh) {
        if (this.loading.get() || !(this.featuresManager.features.get().externalAccountsManagement || this.featuresManager.features.get().externalAccountsUsage)) return;
        try {
            this.loading.set(true);
            this.error.set(null);
            const externalAccounts = await this.cacheLoader.load(()=>this.externalAccountService.fetchRecipients(undefined), forceRefresh);
            if (!externalAccounts) throw Error("Failed to fetch externalAccounts");
            await this.updateCacheStatus();
            this.externalAccounts.set(externalAccounts);
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryManager", "Load beneficiary failed", e);
            this.error.set(e);
            this.externalAccounts.set((0, $lbTbw.createEmptyPaginatedData)());
        } finally{
            this.loading.set(false);
        }
    }
    async loadMore() {
        if (this.loading.get() || this.loadingMore.get()) return;
        try {
            this.loadingMore.set(true);
            this.loadingMoreError.set(null);
            const additional = await this.externalAccountService.fetchRecipients({
                offset: this.externalAccounts.get().offset + this.externalAccounts.get().limit,
                limit: this.externalAccounts.get().limit,
                sort: this.externalAccounts.get().sort
            });
            this.externalAccounts.add(additional);
            this.cacheLoader.store(this.externalAccounts.get(), this.cacheStatus.get()?.creation);
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryManager", "Load more recipient failed", e);
            this.loadingMoreError.set(e);
        } finally{
            this.loadingMore.set(false);
        }
    }
    async requestNewRecipient(name, identity) {
        return await this.externalAccountService.requestNewRecipient(name, identity);
    }
    async confirmNewRecipient(name, identity, otp) {
        const result = await this.externalAccountService.confirmNewRecipient(name, identity, otp);
        await this.load(true);
        return result;
    }
    async updateRecipient(id, name) {
        await this.externalAccountService.updateRecipient(id, name);
        const externalAccounts = this.externalAccounts.get();
        const index = externalAccounts.items.findIndex((externalAccount)=>externalAccount.id === id);
        const externalAccount = externalAccounts.items[index];
        if (index >= 0) {
            externalAccounts.items[index] = {
                ...externalAccount,
                name: name
            };
            this.externalAccounts.set(externalAccounts);
        }
        await this.load(true);
    }
    async deleteRecipient(id) {
        await this.externalAccountService.deleteRecipient(id);
        await this.load(true);
    }
    async updateCacheStatus() {
        const cacheStatus = await this.cacheLoader.readStatus();
        this.cacheStatus.set(cacheStatus);
    }
    async clear() {
        await this.cacheLoader.clear();
        this.externalAccounts.set((0, $lbTbw.createEmptyPaginatedData)());
        this.cacheStatus.set(null);
    }
}

});

parcelRegister("ctI69", function(module, exports) {

$parcel$export(module.exports, "ExternalAccountService", function () { return $0bed3e70d4ec6178$export$6b261ebfefe8a16a; });

var $6JVVB = parcelRequire("6JVVB");
class $0bed3e70d4ec6178$export$6b261ebfefe8a16a {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchRecipients(pagination) {
        try {
            const response = await this.apiService.instance.get("/external-accounts", {
                params: pagination
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ExternalAccountService", "Fetch beneficiaries failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async requestNewRecipient(name, identity) {
        try {
            const response = await this.apiService.instance.post("/external-accounts/auth", {
                name: name,
                ...identity
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ExternalAccountService", "Request new recipient failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmNewRecipient(name, identity, otp) {
        try {
            const response = await this.apiService.instance.post("/external-accounts", {
                name: name,
                ...identity,
                otp: otp
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ExternalAccountService", "Confirm new recipient failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async updateRecipient(id, name) {
        try {
            const response = await this.apiService.instance.patch(`/external-accounts/${id}`, {
                name: name
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BeneficiaryService", "Update recipient failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async deleteRecipient(id) {
        try {
            await this.apiService.instance.delete(`/external-accounts/${id}`);
        } catch (e) {
            (0, $6JVVB.logger).debug("ExternalAccountService", "Delete recipient failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("gnf0B", function(module, exports) {

$parcel$export(module.exports, "SavingsManager", function () { return $6348cf89a8b3daa8$export$7f4b4ec35e1e5b5; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");
class $6348cf89a8b3daa8$export$7f4b4ec35e1e5b5 {
    constructor(savingsService){
        this.savingsService = savingsService;
        this.savingDetails = new (0, $3Ersk.Observable)({});
        this.taxStatements = new (0, $3Ersk.Observable)({});
        this.allSavingsProduct = new (0, $3Ersk.Observable)({});
        this.error = new (0, $3Ersk.Observable)(null);
        this.loading = new (0, $3Ersk.Observable)(true);
    }
    async getSavingsDetails(accountId) {
        try {
            this.loading.set(true);
            this.error.set(null);
            const details = await this.savingsService.getSavingsDetails(accountId);
            this.loading.set(false);
            this.savingDetails.set(details);
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Manager", "Failed to get Savings details", e);
            this.error.set(e);
            this.loading.set(false);
            throw e;
        }
    }
    async getTaxStatements(accountId) {
        try {
            this.loading.set(true);
            this.error.set(null);
            const statements = await this.savingsService.getTaxStatements(accountId);
            this.loading.set(false);
            this.taxStatements.set(statements);
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Manager", "Failed to get tax statements", e);
            this.error.set(e);
            this.loading.set(false);
            throw e;
        }
    }
    async getAllSavingsProduct(limit) {
        try {
            this.loading.set(true);
            this.error.set(null);
            const allSavings = await this.savingsService.getAllSavingsProduct(limit);
            this.loading.set(false);
            this.allSavingsProduct.set(allSavings);
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Manager", "Failed to get all Savings product details", e);
            this.error.set(e);
            this.loading.set(false);
            throw e;
        }
    }
    async createSavingsContract(contract) {
        return await this.savingsService.createSavingsContract(contract);
    }
}

});

parcelRegister("cW7Mc", function(module, exports) {

$parcel$export(module.exports, "SavingsService", function () { return $1cfcdd5f25be219b$export$34fff9251a087e75; });

var $4Zze3 = parcelRequire("4Zze3");

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");
class $1cfcdd5f25be219b$export$34fff9251a087e75 {
    constructor(apiService){
        this.apiService = apiService;
        this.token = new (0, $3Ersk.Observable)("");
    }
    async getSavingsDetails(cbsAccountId) {
        try {
            const response = await this.apiService.instance.get(`/contracts/by-account-number/${cbsAccountId}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Service", "get savings failed", e);
            throw e;
        }
    }
    async getTaxStatements(userId) {
        try {
            const response = await this.apiService.instance.get(`/user/${userId}/tax-statements`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Service", "get tax statements failed", e);
            throw e.response;
        }
    }
    async downloadTaxStatement(documentId) {
        try {
            const response = await this.apiService.instance.get(`/documents/${documentId}/content`, {
                responseType: "arraybuffer"
            });
            await (0, $4Zze3.downloadFile)(`${documentId}.pdf`, response.data, "application/pdf");
            return `${documentId}.pdf`;
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Service", "retrieve tax statement content failed", e);
            throw e;
        }
    }
    async getAllSavingsProduct(limit) {
        const url = limit ? `/products?limit=${limit}` : "/products";
        try {
            const response = await this.apiService.instance.get(url);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Service", "get all savings product failed", e);
            throw e;
        }
    }
    async createSavingsContract(contract) {
        try {
            const response = await this.apiService.instance.post("/contracts", contract);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("Savings Service", "saving a contract creation failed", e);
            throw e;
        }
    }
}

});

parcelRegister("j0zvC", function(module, exports) {

$parcel$export(module.exports, "ServiceDomainService", function () { return $148ef41e7dc2a421$export$734d28789ec57d8e; });

var $6JVVB = parcelRequire("6JVVB");

var $fDyyZ = parcelRequire("fDyyZ");
class $148ef41e7dc2a421$export$734d28789ec57d8e {
    constructor(serviceDomainApiService){
        this.serviceDomainApiService = serviceDomainApiService;
    }
    async getToken(clientId, clientSecret) {
        try {
            const response = await this.serviceDomainApiService.instance.post("/oauth2/token", {
                grant_type: "client_credentials",
                client_id: clientId,
                client_secret: clientSecret,
                scope: [
                    ...(0, $fDyyZ.SAVINGS_SCOPES),
                    ...(0, $fDyyZ.CREDIT_SCOPES),
                    ...(0, $fDyyZ.SERVICE_DOMAIN_SCOPES)
                ].join(" ")
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("ServiceDomainService", "Fetch token failed", e);
            throw e;
        }
    }
}

});
parcelRegister("fDyyZ", function(module, exports) {

$parcel$export(module.exports, "CREDIT_SCOPES", function () { return $74d58518d8142ad3$export$83aab0c656e4b30b; });
$parcel$export(module.exports, "SAVINGS_SCOPES", function () { return $74d58518d8142ad3$export$67c4a86563489542; });
$parcel$export(module.exports, "SERVICE_DOMAIN_SCOPES", function () { return $74d58518d8142ad3$export$6e5ea78c780c01c6; });

var $hoiie = parcelRequire("hoiie");
const $74d58518d8142ad3$export$83aab0c656e4b30b = [
    (0, $hoiie.CreditScope).CdtProductRead,
    (0, $hoiie.CreditScope).CdtCreditRequestRead,
    (0, $hoiie.CreditScope).CdtCreditRequestWrite,
    (0, $hoiie.CreditScope).CdtCreditServicingRead
];
const $74d58518d8142ad3$export$67c4a86563489542 = [
    (0, $hoiie.SavingsScope).SavContractRead,
    (0, $hoiie.SavingsScope).SavDeposit,
    (0, $hoiie.SavingsScope).SavProductRead,
    (0, $hoiie.SavingsScope).SavContractWrite,
    (0, $hoiie.SavingsScope).SavDocumentsRead
];
const $74d58518d8142ad3$export$6e5ea78c780c01c6 = [
    (0, $hoiie.ServiceDomainScope).DocumentSetupView,
    (0, $hoiie.ServiceDomainScope).AdditionalDataRead,
    (0, $hoiie.ServiceDomainScope).FormRead,
    (0, $hoiie.SharedServiceDomainScope).PaymentNetwork,
    (0, $hoiie.SharedServiceDomainScope).PaymentContract,
    (0, $hoiie.SharedServiceDomainScope).CustomerInstructionView,
    (0, $hoiie.SharedServiceDomainScope).CustomerInstructionInitiation,
    (0, $hoiie.SharedServiceDomainScope).CustomerInstructionUpdate,
    (0, $hoiie.SharedServiceDomainScope).CustomerInstructionDeletion,
    (0, $hoiie.SharedServiceDomainScope).CustomerInstructionSubmit,
    (0, $hoiie.SharedServiceDomainScope).SdaAuthenticationsSessionsAuth,
    (0, $hoiie.SharedServiceDomainScope).SdaAuthenticationsSessionsView,
    (0, $hoiie.SharedServiceDomainScope).SdaAuthenticationsSessionsSuspicious,
    (0, $hoiie.SharedServiceDomainScope).SdaAccountView,
    (0, $hoiie.SharedServiceDomainScope).RecipientCreate,
    (0, $hoiie.SharedServiceDomainScope).PaymentInstructionView,
    (0, $hoiie.SharedServiceDomainScope).SdaAccountsNameUpdate,
    (0, $hoiie.SharedServiceDomainScope).SdaRequiredActionsWrite
];

});


parcelRegister("9YT3o", function(module, exports) {

$parcel$export(module.exports, "BankToWalletManager", function () { return $392129e123f2ccfd$export$4173e2110ba78bed; });

var $8MdLL = parcelRequire("8MdLL");

var $7Qb2U = parcelRequire("7Qb2U");

var $4SVM1 = parcelRequire("4SVM1");
const $392129e123f2ccfd$var$PENDING_PSP_RECHARGE_KEYSTORE_KEY = "pending-psp-recharge";
class $392129e123f2ccfd$export$4173e2110ba78bed {
    constructor(bankToWalletService, storage, geolocationManager, accountManager, transactionsManager){
        this.bankToWalletService = bankToWalletService;
        this.storage = storage;
        this.geolocationManager = geolocationManager;
        this.accountManager = accountManager;
        this.transactionsManager = transactionsManager;
    }
    async startBankToWallet(amount, creditorReference, debtorReference) {
        const location = await this.geolocationManager.updatePosition();
        return await this.bankToWalletService.startBankToWallet(amount, creditorReference, debtorReference, location);
    }
    async confirmBankToWallet(confirmationMode, amount, creditorReference, debtorReference, pincode) {
        const location = this.geolocationManager.getPosition();
        const result = await this.bankToWalletService.confirmBankToWallet(confirmationMode, amount, creditorReference, debtorReference, pincode, location);
        return result;
    }
    async confirmRechargeByCard(amount, accountId) {
        const location = this.geolocationManager.getPosition();
        const result = await this.bankToWalletService.confirmRechargeByCard(amount, accountId, (0, $7Qb2U.getPspRedirectUrl)(), location);
        if (result.data.pspResult !== (0, $4SVM1.PspOperationResult).Failure) await this.savePendingRechargeTransaction({
            accountId: accountId,
            amount: result.metadata.transaction.amount
        });
        return result;
    }
    async completePspTransaction() {
        const pendingRecharge = await this.loadPendingRechargeTransaction();
        if (pendingRecharge) this.refreshAccountAndTransactions(pendingRecharge.accountId);
        return pendingRecharge;
    }
    refreshAccountAndTransactions(accountId) {
        (0, $8MdLL.runAfterInteractions)(async ()=>{
            await this.accountManager.refresh();
            await this.transactionsManager.refresh([
                accountId
            ]);
        });
    }
    async loadPendingRechargeTransaction() {
        let storedValue;
        try {
            storedValue = await this.storage.read($392129e123f2ccfd$var$PENDING_PSP_RECHARGE_KEYSTORE_KEY);
        } catch (e) {
            storedValue = null;
        }
        if (storedValue) {
            const parsed = JSON.parse(storedValue);
            return parsed;
        }
        return null;
    }
    async savePendingRechargeTransaction(pendingTransaction) {
        await this.storage.store(JSON.stringify(pendingTransaction), $392129e123f2ccfd$var$PENDING_PSP_RECHARGE_KEYSTORE_KEY);
    }
}

});
parcelRegister("7Qb2U", function(module, exports) {

$parcel$export(module.exports, "getPspRedirectUrl", function () { return $d2a2b0829555288d$export$18cbd7a06c7b412e; });

var $dhPTb = parcelRequire("dhPTb");
function $d2a2b0829555288d$export$18cbd7a06c7b412e() {
    return (0, $dhPTb.Config).CARD_PSP_REDIRECT_WEB_CLIENT_SCHEME;
}

});

parcelRegister("4SVM1", function(module, exports) {

$parcel$export(module.exports, "PspOperationResult", function () { return $8782bd5d0afc62ba$export$2230093614a6c26a; });
var $8782bd5d0afc62ba$export$2230093614a6c26a = /*#__PURE__*/ function(PspOperationResult) {
    PspOperationResult["Success"] = "SUCCESS";
    PspOperationResult["Pending"] = "PENDING";
    PspOperationResult["Failure"] = "FAILURE";
    return PspOperationResult;
}({});

});


parcelRegister("gRSic", function(module, exports) {

$parcel$export(module.exports, "BankToWalletService", function () { return $5c9c4ac674fd88bc$export$cc9e29b9f8b82460; });

var $6JVVB = parcelRequire("6JVVB");

var $1YFGv = parcelRequire("1YFGv");

var $8UJ8q = parcelRequire("8UJ8q");
class $5c9c4ac674fd88bc$export$cc9e29b9f8b82460 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async startBankToWallet(amount, creditorReference, debtorReference, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/bank-to-wallet", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).PreAuth,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    amount: amount,
                    creditorReference: creditorReference,
                    debtorReference: debtorReference
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BankToWalletService", "Failed to start transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmBankToWallet(confirmationMode, amount, creditorReference, debtorReference, pincode, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/bank-to-wallet", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: confirmationMode,
                    pincode: pincode,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    amount: amount,
                    creditorReference: creditorReference,
                    debtorReference: debtorReference
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BankToWalletService", "Failed to confirm transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmRechargeByCard(amount, accountId, returnUrl, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/recharge-by-card", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: (0, $8UJ8q.ConfirmationMode).Confirm,
                    webviewReturnUrl: returnUrl,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    amount: amount,
                    accountId: accountId
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("BankToWalletService", "Confirm recharge by card failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});
parcelRegister("8UJ8q", function(module, exports) {

$parcel$export(module.exports, "TransactionCallType", function () { return $4cceec5c45d13d80$export$6cc839bba03eb4a1; });
$parcel$export(module.exports, "ConfirmationMode", function () { return $4cceec5c45d13d80$export$6d057e601713ccff; });
var $4cceec5c45d13d80$export$6cc839bba03eb4a1 = /*#__PURE__*/ function(TransactionCallType) {
    TransactionCallType["PreAuth"] = "PREAUTH";
    TransactionCallType["Transaction"] = "TRANSACTION";
    return TransactionCallType;
}({});
var $4cceec5c45d13d80$export$6d057e601713ccff = /*#__PURE__*/ function(ConfirmationMode) {
    ConfirmationMode["Confirm"] = "CONFIRM";
    ConfirmationMode["PinCode"] = "PINCODE";
    return ConfirmationMode;
}({});

});


parcelRegister("8heZF", function(module, exports) {

$parcel$export(module.exports, "CashTransferManager", function () { return $7f54ec4863bd1261$export$4ac0ca5c7a25ab00; });

var $8MdLL = parcelRequire("8MdLL");

var $5QnaE = parcelRequire("5QnaE");
class $7f54ec4863bd1261$export$4ac0ca5c7a25ab00 {
    constructor(cashTransferService, geolocationManager, accountManager, transactionsManager){
        this.cashTransferService = cashTransferService;
        this.geolocationManager = geolocationManager;
        this.accountManager = accountManager;
        this.transactionsManager = transactionsManager;
    }
    async startRetrieveCashTransfer(cashTransferCode) {
        const location = await this.geolocationManager.updatePosition();
        return await this.cashTransferService.startRetrieveCashTransfer(cashTransferCode, location);
    }
    async confirmRetrieveCashTransfer(confirmationMode, cashTransferCode, pincode) {
        const location = this.geolocationManager.getPosition();
        const result = await this.cashTransferService.confirmRetrieveCashTransfer(confirmationMode, cashTransferCode, pincode, location);
        this.refreshAccountAndTransactions(result.metadata.transaction);
        return result;
    }
    refreshAccountAndTransactions(transaction) {
        (0, $8MdLL.runAfterInteractions)(async ()=>{
            const accountIds = (0, $5QnaE.accountsAffectedByTransaction)(transaction);
            await this.accountManager.refresh();
            await this.transactionsManager.refresh(accountIds);
        });
    }
}

});

parcelRegister("euFJW", function(module, exports) {

$parcel$export(module.exports, "CashTransferService", function () { return $2755d3660e9e24e5$export$6c452dc6381f2e66; });

var $6JVVB = parcelRequire("6JVVB");

var $1YFGv = parcelRequire("1YFGv");

var $8UJ8q = parcelRequire("8UJ8q");

var $kRR5N = parcelRequire("kRR5N");

var $dNQob = parcelRequire("dNQob");
class $2755d3660e9e24e5$export$6c452dc6381f2e66 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchCashTransfer(pagination) {
        try {
            const response = await this.apiService.instance.get("/cash-transfers", {
                params: {
                    ...pagination
                }
            });
            return {
                ...response.data,
                items: response.data.items.map((transfer)=>({
                        ...transfer,
                        type: transfer.code ? (0, $kRR5N.CashTransferType).Sent : (0, $kRR5N.CashTransferType).Received
                    }))
            };
        } catch (e) {
            (0, $6JVVB.logger).debug("CashTransferService", "Fetch cash transfer failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async startRetrieveCashTransfer(cashTransferCode, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/retrieve-cash-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).PreAuth,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    cashTransferCode: cashTransferCode
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("CashTransferService", "Start retrieve cash transfer failed", e);
            if (e?.response && e?.response?.status === 404) throw new (0, $dNQob.CashTransferCodeNotFound)("Cash transactions code is not valid");
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmRetrieveCashTransfer(confirmationMode, cashTransferCode, pincode, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/retrieve-cash-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: confirmationMode,
                    pincode: pincode,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    cashTransferCode: cashTransferCode
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("CashTransferService", "Confirm retrieve cash transfer failed", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});
parcelRegister("kRR5N", function(module, exports) {

$parcel$export(module.exports, "CashTransferType", function () { return $078acf244b303f22$export$9d922959afd999f3; });
$parcel$export(module.exports, "defaultTransferTitles", function () { return $078acf244b303f22$export$cab1faf6191ff52a; });
var $078acf244b303f22$export$9d922959afd999f3 = /*#__PURE__*/ function(CashTransferType) {
    CashTransferType[CashTransferType["Received"] = 0] = "Received";
    CashTransferType[CashTransferType["Sent"] = 1] = "Sent";
    return CashTransferType;
}({});
const $078acf244b303f22$export$cab1faf6191ff52a = {
    [0]: "cashTransferScreen.receivedTransferDefaultTitle",
    [1]: "cashTransferScreen.sentTransferDefaultTitle"
};

});

parcelRegister("dNQob", function(module, exports) {

$parcel$export(module.exports, "CashTransferCodeNotFound", function () { return $869878ed0b05faa1$export$2cb4671b6846a30a; });
$parcel$export(module.exports, "isCashTransferCodeNotFoundError", function () { return $869878ed0b05faa1$export$9279df671691d4ce; });
class $869878ed0b05faa1$export$2cb4671b6846a30a extends Error {
    constructor(message){
        super(message), this.type = "CashTransferCodeNotFoundError";
    }
}
function $869878ed0b05faa1$export$9279df671691d4ce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error) {
    return error?.type === "CashTransferCodeNotFoundError";
}

});


parcelRegister("7t9hQ", function(module, exports) {

$parcel$export(module.exports, "DedicatedTransferManager", function () { return $f6f943305ee45ab6$export$c6c0fe25e87d7599; });

var $8MdLL = parcelRequire("8MdLL");

var $fsofG = parcelRequire("fsofG");

var $5QnaE = parcelRequire("5QnaE");
class $f6f943305ee45ab6$export$c6c0fe25e87d7599 {
    constructor(dedicatedTransferService, geolocationManager, accountManager, transactionsManager){
        this.dedicatedTransferService = dedicatedTransferService;
        this.geolocationManager = geolocationManager;
        this.accountManager = accountManager;
        this.transactionsManager = transactionsManager;
        this.transactionCodes = new (0, $fsofG.ObservableArray)([]);
    }
    async startTransfer(recipientId, acceptorId, amount, label) {
        try {
            const location = await this.geolocationManager.updatePosition();
            return await this.dedicatedTransferService.startTransfer(recipientId, acceptorId, amount, label, location);
        } catch (e) {
            console.log(e);
            throw e;
        }
    }
    async confirmSendDedicatedTransfer(confirmationMode, dedicatedTransfer, pincode) {
        const location = this.geolocationManager.getPosition();
        const result = await this.dedicatedTransferService.confirmSendDedicatedTransfer(confirmationMode, dedicatedTransfer, pincode, location);
        this.refreshAccountAndTransactions(result.metadata.transaction);
        return result;
    }
    refreshAccountAndTransactions(transaction) {
        (0, $8MdLL.runAfterInteractions)(async ()=>{
            const accountIds = (0, $5QnaE.accountsAffectedByTransaction)(transaction);
            await this.accountManager.refresh();
            await this.transactionsManager.refresh(accountIds);
        });
    }
}

});

parcelRegister("fTMJB", function(module, exports) {

$parcel$export(module.exports, "DedicatedTransferService", function () { return $63c5bfff772a565e$export$f137707f5d79be5e; });

var $6JVVB = parcelRequire("6JVVB");

var $1YFGv = parcelRequire("1YFGv");

var $8UJ8q = parcelRequire("8UJ8q");
class $63c5bfff772a565e$export$f137707f5d79be5e {
    constructor(apiService){
        this.apiService = apiService;
    }
    async startTransfer(recipientId, acceptorId, amount, label, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-dedicated-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).PreAuth,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    amount: amount,
                    recipientId: recipientId,
                    acceptorId: acceptorId,
                    label: label
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("DedicatedTransferService", "Failed to start transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmSendDedicatedTransfer(confirmationMode, dedicatedTransfer, pincode, location) {
        const { recipientId: recipientId, amount: amount, acceptorId: acceptorId, label: label } = dedicatedTransfer;
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-dedicated-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: confirmationMode,
                    pincode: pincode,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    amount: amount,
                    acceptorId: acceptorId,
                    recipientId: recipientId,
                    label: label
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("DedicatedTransferService", "Confirm dedicated transfer failed", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("640ed", function(module, exports) {

$parcel$export(module.exports, "TransferManager", function () { return $452f0d39a9b36d06$export$bfc01515376fd8fd; });

var $8MdLL = parcelRequire("8MdLL");

var $3Ersk = parcelRequire("3Ersk");

var $5QnaE = parcelRequire("5QnaE");

var $bx6cc = parcelRequire("bx6cc");
class $452f0d39a9b36d06$export$bfc01515376fd8fd {
    constructor(transferService, geolocationManager, accountManager, transactionsManager, featuresManager){
        this.transferService = transferService;
        this.geolocationManager = geolocationManager;
        this.accountManager = accountManager;
        this.transactionsManager = transactionsManager;
        this.featuresManager = featuresManager;
        this.paymentNetworks = new (0, $3Ersk.Observable)([]);
        this.paymentNetworksByIban = new (0, $3Ersk.Observable)([]);
        this.paymentNetworksOnConfig = new (0, $3Ersk.Observable)([]);
    }
    async startTransfer(recipientId, amount, label) {
        const location = await this.geolocationManager.updatePosition();
        return await this.transferService.startTransfer(recipientId, amount, label, location);
    }
    async confirmTransfer(confirmationMode, recipientId, amount, label, pincode) {
        const location = this.geolocationManager.getPosition();
        const result = await this.transferService.confirmTransfer(confirmationMode, recipientId, amount, label, pincode, location);
        this.refreshAccountAndTransactions(result.metadata.transaction);
        return result;
    }
    async startPayout(recipientId, amount, srcAccountId, purpose) {
        const location = await this.geolocationManager.updatePosition();
        return await this.transferService.startPayout(recipientId, amount, srcAccountId, purpose, location);
    }
    async confirmPayout(confirmationMode, recipientId, amount, srcAccountId, purpose, pincode) {
        const location = this.geolocationManager.getPosition();
        const result = await this.transferService.confirmPayout(confirmationMode, recipientId, amount, srcAccountId, purpose, pincode, location);
        this.refreshAccountAndTransactions(result.metadata.transaction);
        return result;
    }
    async startCashTransfer(recipientId, amount, label) {
        const location = await this.geolocationManager.updatePosition();
        return await this.transferService.startCashTransfer(recipientId, amount, label, location);
    }
    async confirmCashTransfer(confirmationMode, recipientId, amount, label, pincode) {
        const location = this.geolocationManager.getPosition();
        const result = await this.transferService.confirmCashTransfer(confirmationMode, recipientId, amount, label, pincode, location);
        this.refreshAccountAndTransactions(result.metadata.transaction);
        return result;
    }
    refreshAccountAndTransactions(transaction) {
        (0, $8MdLL.runAfterInteractions)(async ()=>{
            const accountIds = (0, $5QnaE.accountsAffectedByTransaction)(transaction);
            await this.accountManager.refresh();
            await this.transactionsManager.refresh(accountIds);
        });
    }
    // SIMPLE TRANSFER
    async startSimpleTransfer(amount, phoneNumber, label) {
        const location = await this.geolocationManager.updatePosition();
        return await this.transferService.startSimpleTransfer(amount, phoneNumber, label, location);
    }
    async confirmSimpleTransfer(confirmationMode, amount, phoneNumber, label, pincode) {
        const location = this.geolocationManager.getPosition();
        const result = await this.transferService.confirmSimpleTransfer(confirmationMode, amount, phoneNumber, label, pincode, location);
        this.refreshAccountAndTransactions(result.metadata.transaction);
        return result;
    }
    // CUSTOMER INSTRUCTIONS
    async getPaymentNetworks() {
        if (!this.featuresManager.features.get().paymentNetwork || !this.featuresManager.features.get().paymentContract) return [];
        try {
            const response = await this.transferService.getPaymentNetworks();
            // TODO: remove this filter when the backend is fixed
            const paymentNetworks = response.filter((item)=>item.activated && item.serviceLevel !== (0, $bx6cc.ServiceLevel).ON_US);
            this.paymentNetworks.set(paymentNetworks);
            return paymentNetworks;
        } catch (error) {
            this.paymentNetworks.set([]);
            throw error;
        }
    }
    async getPaymentNetworksOnConfig() {
        if (!this.featuresManager.features.get().paymentNetwork) return [];
        try {
            const response = await this.transferService.getPaymentNetworksOnConfig();
            this.paymentNetworksOnConfig.set(response);
            return response;
        } catch (error) {
            this.paymentNetworksOnConfig.set([]);
            throw error;
        }
    }
    async getPaymentNetworksByIban(iban) {
        if (!this.featuresManager.features.get().paymentContract) return [];
        try {
            const response = await this.transferService.getPaymentNetworksByIban(iban);
            this.paymentNetworksByIban.set(response);
            return response;
        } catch (error) {
            this.paymentNetworksByIban.set([]);
            throw error;
        }
    }
    async getPaymentNetworkProduct(productId) {
        try {
            const response = await this.transferService.getPaymentNetworkProduct(productId);
            return response;
        } catch (error) {
            throw error;
        }
    }
    async startCustomerInstruction(paymentNetwork, amount, sourceAccount, destinationAccountOrRecipient, pincode, label, creditorAddress, foreignAmount, recurringTransferParams, automaticRoutingConfig) {
        if (!this.featuresManager.features.get().customerInstructionInitiation) throw "Customer instruction initiation is not enabled";
        return await this.transferService.startCustomerInstruction(paymentNetwork, amount, sourceAccount, destinationAccountOrRecipient, pincode, label, creditorAddress, foreignAmount, recurringTransferParams, automaticRoutingConfig);
    }
    async submitCustomerInstruction(strongAuthenticationReference, id) {
        try {
            return await this.transferService.submitCustomerInstruction(id, strongAuthenticationReference);
        } catch (error) {
            throw error;
        }
    }
    async submitCreditTransferSinglePayment(businessProcessId, client, refundReason) {
        try {
            const res = await this.getPaymentTransaction(businessProcessId);
            const paymentRTransaction = {
                paymentRTransactionAmountInformation: {
                    returnedAmount: res.paymentTransactionAmountInformation.instructedAmount,
                    chargeBearer: res.paymentTransactionAmountInformation.chargeBearer,
                    chargesAmount: res.paymentTransactionAmountInformation.chargesAmount
                },
                paymentRTransactionInformation: {
                    paymentRTransactionIdentification: {
                        originalTransactionId: businessProcessId,
                        relatedTransactionInternalId: businessProcessId
                    },
                    paymentRTransactionReturnInformation: {
                        originator: {
                            value: `${client.firstName} ${client.lastName}`,
                            type: "name"
                        },
                        reason: refundReason
                    }
                }
            };
            const submitResponse = await this.transferService.submitCreditTransferSinglePayment(res, paymentRTransaction);
            return submitResponse;
        } catch (e) {
            throw e;
        }
    }
    async getPaymentTransaction(id) {
        if (!this.featuresManager.features.get().paymentInstructionView) throw "Cannot get payment instruction. Feature not enabled";
        return await this.transferService.getPaymentTransaction(id);
    }
}

});

parcelRegister("iKRSG", function(module, exports) {

$parcel$export(module.exports, "TransferService", function () { return $d25df3744bccd9c9$export$d29d0839857e3ef3; });

var $6JVVB = parcelRequire("6JVVB");

var $1YFGv = parcelRequire("1YFGv");

var $bx6cc = parcelRequire("bx6cc");

var $8UJ8q = parcelRequire("8UJ8q");
class $d25df3744bccd9c9$export$d29d0839857e3ef3 {
    constructor(apiService, serviceDomainApiService, clientManager, checkPincodeService){
        this.apiService = apiService;
        this.serviceDomainApiService = serviceDomainApiService;
        this.clientManager = clientManager;
        this.checkPincodeService = checkPincodeService;
    }
    async startSimpleTransfer(amount, phoneNumber, label, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-simple-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).PreAuth,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    amount: amount,
                    label: label,
                    phoneNumber: phoneNumber
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to start transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e) || (0, $1YFGv.isRecipientNotFoundByInvalidPhoneError)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmSimpleTransfer(confirmationMode, amount, phoneNumber, label, pincode, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-simple-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: confirmationMode,
                    pincode: pincode,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    amount: amount,
                    label: label,
                    phoneNumber: phoneNumber
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to confirm transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e) || (0, $1YFGv.isRecipientNotFoundByInvalidPhoneError)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async startTransfer(recipientId, amount, label, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).PreAuth,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    recipientId: recipientId,
                    amount: amount,
                    label: label
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to start transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmTransfer(confirmationMode, recipientId, amount, label, pincode, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: confirmationMode,
                    pincode: pincode,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    recipientId: recipientId,
                    amount: amount,
                    label: label
                }
            });
            return response.data;
        } catch (e) {
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async startPayout(recipientId, amount, srcAccountId, purpose, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/payout", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).PreAuth,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    recipientId: recipientId,
                    amount: amount,
                    purpose: purpose,
                    srcAccountId: srcAccountId
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to start payout", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmPayout(confirmationMode, recipientId, amount, srcAccountId, purpose, pincode, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/payout", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: confirmationMode,
                    pincode: pincode,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    recipientId: recipientId,
                    amount: amount,
                    srcAccountId: srcAccountId,
                    purpose: purpose
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to confirm payout", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async startCashTransfer(recipientId, amount, label, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-cash-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).PreAuth,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    recipientId: recipientId,
                    amount: amount,
                    label: label
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to start cash transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async confirmCashTransfer(confirmationMode, recipientId, amount, label, pincode, location) {
        try {
            const response = await this.apiService.instance.post("/transactions/p2p-cash-transfer", {
                metadata: {
                    mode: (0, $8UJ8q.TransactionCallType).Transaction,
                    confirmationMode: confirmationMode,
                    pincode: pincode,
                    location: location ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    } : undefined
                },
                data: {
                    recipientId: recipientId,
                    amount: amount,
                    label: label
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to confirm cash transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    // CUSTOMER INSTRUCTION
    async getPaymentNetworks() {
        try {
            const response = await Promise.all([
                this.serviceDomainApiService.instance.get("/payment-networks/configuration"),
                this.serviceDomainApiService.instance.get("/payment-service-contract")
            ]);
            const networks = response[0].data;
            const contracts = response[1].data.creditTransferEmission;
            const paymentNetworks = contracts.filter((contract)=>contract.serviceLevel !== "ON_US").map((contract)=>{
                const network = networks.items.find((n)=>n.serviceLevel === contract.serviceLevel);
                return {
                    ...network,
                    ...contract
                };
            });
            return paymentNetworks;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to get payment networks", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async getPaymentNetworksOnConfig() {
        try {
            const response = await this.serviceDomainApiService.instance.get("/payment-networks/configuration");
            return response.data.items;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to get payment networks config", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async getPaymentNetworksByIban(iban) {
        try {
            const response = await this.serviceDomainApiService.instance.get("/payment-service-contract", {
                params: {
                    iban: iban
                }
            });
            return response.data.creditTransferEmission;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to get payment contracts by IBAN", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async getPaymentNetworkProduct(productId) {
        try {
            const response = await this.serviceDomainApiService.instance.get(`/products/${productId}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to get payment network product", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async startCustomerInstruction(paymentNetwork, amount, sourceAccount, destinationAccountOrRecipient, pincode, label, creditorAddress, foreignAmount, recurringTransferParams, automaticRoutingConfig) {
        const client = this.clientManager.client.get();
        const customerInstruction = (0, $bx6cc.makeFormattedCustomerInstruction)({
            client: client,
            amount: amount,
            creditorAddress: creditorAddress,
            destinationAccountOrRecipient: destinationAccountOrRecipient,
            foreignAmount: foreignAmount,
            label: label,
            paymentNetwork: paymentNetwork,
            sourceAccount: sourceAccount,
            recurringTransferParams: recurringTransferParams
        });
        try {
            if (pincode) await this.checkPincodeService.checkPincode(pincode);
            const endpoint = recurringTransferParams?.enabled && !foreignAmount ? "/standing-orders/credit-transfers" : "/customer-instructions/credit-transfers/submit";
            if (automaticRoutingConfig?.instantTransfer) {
                customerInstruction.customerInstructionInformation.customerInstructionTypeInformation.serviceLevel = (0, $bx6cc.ServiceLevel).SCT_INST;
                customerInstruction.customerInstructionInformation.paymentInstrument = "CreditTransferInst";
            } else if (automaticRoutingConfig?.automaticRoutingEnabled) delete customerInstruction.customerInstructionInformation.customerInstructionTypeInformation.serviceLevel;
            const response = await this.serviceDomainApiService.instance.post(endpoint, customerInstruction);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to start transfer", e);
            if ((0, $1YFGv.isAccountBlockedErrorResponse)(e)) throw (0, $1YFGv.AccountBlockedErrorFromErrorResponse)(e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async submitCustomerInstruction(id, token) {
        try {
            const response = await this.serviceDomainApiService.instance.post(`/customer-instructions/credit-transfers/${id}/submit`, null, {
                headers: {
                    "SCAP-token": token
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to submit customer instruction", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async getAuthenticationSession(customerInstructionReference) {
        try {
            const response = await this.serviceDomainApiService.instance.get(`/authentications/sessions/${customerInstructionReference}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to get authentication session", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async getCustomerInstruction(id) {
        try {
            const response = await this.serviceDomainApiService.instance.get(`/customer-instructions/${id}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to get customer instruction", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async submitCreditTransferSinglePayment(customerInstructionInformation, paymentRTransaction) {
        try {
            const response = await this.serviceDomainApiService.instance.post("/customer-instructions/r-credit-transfers/submit", {
                customerInstructionInformation: {
                    ...customerInstructionInformation,
                    paymentInstrument: "CreditTransferRecall"
                },
                paymentRTransaction: {
                    ...paymentRTransaction
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to submit Credit Transfer Single Payment", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
    async getPaymentTransaction(id) {
        try {
            const response = await this.serviceDomainApiService.instance.get(`/payment-transactions/${id}`);
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransferService", "Failed to get payment transaction", e);
            throw e?.response?.data?.error?.message || e?.response?.data?.message || e.toString();
        }
    }
}

});

parcelRegister("1m2je", function(module, exports) {

$parcel$export(module.exports, "UpcomingTransfersManager", function () { return $8428c6654fcc2c30$export$e3ea2fd8403fd887; });

var $6JVVB = parcelRequire("6JVVB");

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $lbTbw = parcelRequire("lbTbw");
class $8428c6654fcc2c30$export$e3ea2fd8403fd887 {
    constructor(upcomingTransfersService, featuresManager, cacheLoader){
        this.upcomingTransfersService = upcomingTransfersService;
        this.featuresManager = featuresManager;
        this.cacheLoader = cacheLoader;
        this.paginatedUpcomingTransfers = new (0, $hngyi.ObservablePaginated)((0, $lbTbw.createEmptyPaginatedData)());
        this.isLoading = new (0, $3Ersk.Observable)(false);
        this.canLoadMore = new (0, $3Ersk.Observable)(false);
    }
    async getUpcomingTransfers(offset) {
        const features = this.featuresManager.features.get();
        if (!features.paymentStandingOrderView && features.customerInstructionInitiation) {
            (0, $6JVVB.logger).debug("UpcomingTransfersManger", "User does not have permission to view upcoming transfers");
            this.paginatedUpcomingTransfers.set((0, $lbTbw.createEmptyPaginatedData)());
            this.canLoadMore.set(false);
            return;
        }
        this.isLoading.set(true);
        try {
            const response = await this.upcomingTransfersService.getUpcomingTransfers(offset);
            if (offset) this.paginatedUpcomingTransfers.add(response);
            else this.paginatedUpcomingTransfers.set(response);
            this.canLoadMore.set(response.count > response.limit + Number(response.offset));
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersManger", "Failed to get upcoming transfers", error);
            throw new Error(error);
        } finally{
            this.isLoading.set(false);
        }
    }
    async editUpcomingTransfer(id, modifiedTransfer) {
        try {
            const response = await this.upcomingTransfersService.editUpcomingTransfer(id, modifiedTransfer);
            return response;
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersManger", "Failed to edit upcoming transfer", error);
            throw new Error(error);
        }
    }
    async updateStatusUpcomingTransfer(id, status) {
        try {
            const response = await this.upcomingTransfersService.updateStatusUpcomingTransfer(id, status);
            return response;
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersManger", "Failed to update upcoming transfer status", error);
            throw new Error(error);
        }
    }
    async deleteUpcomingTransfer(id) {
        try {
            const response = await this.upcomingTransfersService.deleteUpcomingTransfer(id);
            return response;
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersManger", "Failed to delete upcoming transfer", error);
            throw new Error(error);
        }
    }
    async loadMore() {
        if (this.canLoadMore) {
            const paginatedUpcomingTransfers = this.paginatedUpcomingTransfers.get();
            const nextOffset = paginatedUpcomingTransfers.limit + Number(paginatedUpcomingTransfers.offset);
            await this.getUpcomingTransfers(nextOffset);
        }
    }
}

});

parcelRegister("1501u", function(module, exports) {

$parcel$export(module.exports, "UpcomingTransfersService", function () { return $68328b5bff5f4a60$export$8f68addc9fdd0bde; });

var $6JVVB = parcelRequire("6JVVB");
class $68328b5bff5f4a60$export$8f68addc9fdd0bde {
    constructor(serviceDomainApiService){
        this.serviceDomainApiService = serviceDomainApiService;
    }
    async getUpcomingTransfers(offset) {
        try {
            const response = await this.serviceDomainApiService.instance.get("/standing-orders/credit-transfers", {
                params: {
                    offset: offset
                }
            });
            return response.data;
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersService", "Failed to get upcoming transfers", error);
            throw new Error(error);
        }
    }
    async editUpcomingTransfer(id, modifiedTransfer) {
        try {
            const response = await this.serviceDomainApiService.instance.patch(`/standing-orders/credit-transfers/${id}`, modifiedTransfer);
            return response.data;
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersService", "Failed to edit upcoming transfer", error);
            throw new Error(error);
        }
    }
    async updateStatusUpcomingTransfer(id, status) {
        try {
            const response = await this.serviceDomainApiService.instance.patch(`/standing-orders/credit-transfers/${id}`, {
                status: status
            });
            return response.data;
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersService", "Failed to update upcoming transfer status", error);
            throw new Error(error);
        }
    }
    async deleteUpcomingTransfer(id) {
        try {
            const response = await this.serviceDomainApiService.instance.delete(`/standing-orders/credit-transfers/${id}`);
            return response.data;
        } catch (error) {
            (0, $6JVVB.logger).debug("UpcomingTransfersService", "Failed to delete upcoming transfer", error);
            throw new Error(error);
        }
    }
}

});

parcelRegister("3SQwH", function(module, exports) {

$parcel$export(module.exports, "TransactionCodeManager", function () { return $55c67e2a760e1b33$export$c090fcb1234fa3d6; });

var $fsofG = parcelRequire("fsofG");
class $55c67e2a760e1b33$export$c090fcb1234fa3d6 {
    constructor(transactionCodeService){
        this.transactionCodeService = transactionCodeService;
        this.transactionCodes = new (0, $fsofG.ObservableArray)([]);
    }
    async refresh() {
        const transactionCodes = await this.transactionCodeService.fetchTransactionCodes();
        this.transactionCodes.set(transactionCodes);
    }
    async createTransactionCode(amount, acceptorShortCode, pincode) {
        const newTransactionCode = await this.transactionCodeService.createTransactionCode(amount, acceptorShortCode, pincode);
        this.transactionCodes.set([
            ...this.transactionCodes.get(),
            newTransactionCode
        ]);
        return newTransactionCode;
    }
}

});

parcelRegister("1L358", function(module, exports) {

$parcel$export(module.exports, "TransactionCodeService", function () { return $110dc9fe12ee9297$export$78e1982662be0f3e; });

var $6JVVB = parcelRequire("6JVVB");
var $110dc9fe12ee9297$var$TransactionCodeError = /*#__PURE__*/ function(TransactionCodeError) {
    TransactionCodeError["TransactionWithdrawCodeGenerationError"] = "TRANSACTION_WITHDRAW_CODE_GENERATION_ERROR";
    return TransactionCodeError;
}($110dc9fe12ee9297$var$TransactionCodeError || {});
class $110dc9fe12ee9297$export$78e1982662be0f3e {
    constructor(apiService, i18NManager){
        this.apiService = apiService;
        this.i18NManager = i18NManager;
    }
    async fetchTransactionCodes() {
        try {
            const response = await this.apiService.instance.get("/transaction-codes");
            return response.data.items;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransactionCodeService", "Failed to fetch transaction codes", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    async createTransactionCode(amount, acceptorShortCode, pincode) {
        try {
            const response = await this.apiService.instance.post("/transaction-codes", {
                amount: amount,
                acceptorShortCode: acceptorShortCode,
                pincode: pincode
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("TransactionCodeService", "Failed to create transaction codes", e);
            let message = e?.response?.data?.error?.message || e.toString();
            if (message === "TRANSACTION_WITHDRAW_CODE_GENERATION_ERROR") message = this.i18NManager.formatMessage("TRANSACTION_WITHDRAW_CODE_GENERATION_ERROR");
            throw message;
        }
    }
}

});

parcelRegister("cd48V", function(module, exports) {

$parcel$export(module.exports, "ErrorStore", function () { return $f346f53bbe678b5c$export$f3d62f08088a4a3a; });

var $3Ersk = parcelRequire("3Ersk");
class $f346f53bbe678b5c$export$f3d62f08088a4a3a {
    constructor(){
        this.error = new (0, $3Ersk.Observable)(null);
    }
}

});

parcelRegister("6Si8z", function(module, exports) {

$parcel$export(module.exports, "LoginService", function () { return $b3692a4cb479988f$export$9aa0815bbb7f01f0; });
class $b3692a4cb479988f$export$9aa0815bbb7f01f0 {
    static{
        this.ERROR_CODES_INDICATING_PHONE_NUMBER_OK = [
            30234,
            62201
        ];
    }
    constructor(apiService){
        this.apiService = apiService;
    }
    async checkPhoneNumber(phoneNumber) {
        try {
            await this.apiService.instance.get(`/enrollment/${phoneNumber}`);
            return false;
        } catch (e) {
            if (e?.response?.status === 400 && this.checkErrorCode(e?.response?.data?.error?.code)) return true;
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
    checkErrorCode(code) {
        return $b3692a4cb479988f$export$9aa0815bbb7f01f0.ERROR_CODES_INDICATING_PHONE_NUMBER_OK.includes(code);
    }
}

});

parcelRegister("9mafT", function(module, exports) {

$parcel$export(module.exports, "DefaultCacheLoader", function () { return $c3c7de7413290458$export$f11f757a05d6f4db; });
class $c3c7de7413290458$export$f11f757a05d6f4db {
    constructor(cache){
        this.cache = cache;
    }
    async clear(key = "default") {
        return await this.cache.clear(key);
    }
    async isValid(key = "default") {
        return await this.cache.isValid(key);
    }
    async read(key = "default") {
        return await this.cache.read(key);
    }
    async readStatus(key = "default") {
        return await this.cache.readStatus(key);
    }
    async load(loadFunction, forceRefresh = false, key = "default") {
        const isCacheValid = await this.cache.isValid(key);
        if (isCacheValid && !forceRefresh) return await this.cache.read(key);
        else try {
            const data = await loadFunction();
            this.cache.store(data, undefined, key);
            return data;
        } catch (e) {
            if (!forceRefresh) return await this.cache.read(key);
            else throw e;
        }
    }
    store(data, creation, key = "default") {
        this.cache.store(data, creation, key);
    }
}

});

parcelRegister("9Lc2e", function(module, exports) {

$parcel$export(module.exports, "ContactService", function () { return $cb3b582404580e85$export$7500cbca02a113b2; });

var $lrNCO = parcelRequire("lrNCO");
class $cb3b582404580e85$export$7500cbca02a113b2 {
    constructor(configurationManager, i18NManager){
        this.configurationManager = configurationManager;
        this.i18NManager = i18NManager;
    }
    getContacts() {
        const contacts = new Map([]);
        const configuration = this.configurationManager.configuration.get();
        if (configuration.contactPhone) contacts.set((0, $lrNCO.ContactType).Phone, configuration.contactPhone);
        if (configuration.contactEmail) contacts.set((0, $lrNCO.ContactType).Email, configuration.contactEmail);
        if (configuration.infoUrl) contacts.set((0, $lrNCO.ContactType).Url, configuration.infoUrl[this.i18NManager.localeTag.get()]);
        return contacts;
    }
}

});
parcelRegister("lrNCO", function(module, exports) {

$parcel$export(module.exports, "ContactType", function () { return $f3409efad0b5985c$export$9f5bdfa4eeb4bc7e; });
var $f3409efad0b5985c$export$9f5bdfa4eeb4bc7e = /*#__PURE__*/ function(ContactType) {
    ContactType["Phone"] = "phone";
    ContactType["Email"] = "email";
    ContactType["Address"] = "address";
    ContactType["Url"] = "url";
    return ContactType;
}({});

});


parcelRegister("b8lpk", function(module, exports) {

$parcel$export(module.exports, "AutocompleteService", function () { return $9a508eef40e91054$export$1f14987e9cb31ec2; });

var $6JVVB = parcelRequire("6JVVB");
class $9a508eef40e91054$export$1f14987e9cb31ec2 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fieldAutocomplete(inputId, userInput) {
        try {
            const response = await this.apiService.instance.get(`/autocomplete/${inputId}`, {
                params: {
                    userInput: userInput
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).debug("AutocompleteService", "Autocomplete values search failed", e);
            throw e?.response?.data?.error?.message || e.toString();
        }
    }
}

});

parcelRegister("a5pmH", function(module, exports) {

$parcel$export(module.exports, "I18NManager", function () { return $c633f970d52bf91b$export$ec5aa2bff0b93f05; });

var $4nbTq = parcelRequire("4nbTq");
var $94jk9 = parcelRequire("94jk9");

var $loPuh = parcelRequire("loPuh");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $dhPTb = parcelRequire("dhPTb");

var $8xKCH = parcelRequire("8xKCH");

var $6JVVB = parcelRequire("6JVVB");

var $iiBUf = parcelRequire("iiBUf");

var $cykUx = parcelRequire("cykUx");
const $c633f970d52bf91b$var$fallbackLanguage = (0, $dhPTb.Config).FALLBACK_LANGUAGE;
const $c633f970d52bf91b$var$fallbackTranslationsEnabled = (0, $dhPTb.Config).FALLBACK_TRANSLATIONS_ENABLED;
const $c633f970d52bf91b$var$STORAGE_LOCALE_KEY = "core-i18n-locale";
class $c633f970d52bf91b$export$ec5aa2bff0b93f05 {
    constructor(i18NStore, translationsManager, storage){
        this.i18NStore = i18NStore;
        this.translationsManager = translationsManager;
        this.storage = storage;
        this.isRTL = new (0, $3Ersk.Observable)(false);
        this.initialized = new (0, $3Ersk.Observable)(false);
        this.localTranslations = {};
        this.formatAmount = (amount, absolute, forceSign)=>{
            const currency = amount.currencyAlpha ? (0, $8xKCH.Currencies)[amount.currencyAlpha] : (0, $8xKCH.Currencies)[amount.currency];
            let amountValue = amount.value / Math.pow(10, currency ? currency.decimal_number : 2);
            amountValue = absolute ? Math.abs(amountValue) : amountValue;
            const additionalFormatConfig = {
                currencyDisplay: "symbol"
            };
            const locale = this.intl.get().locale;
            if (locale === "ar-MR") additionalFormatConfig.currencyDisplay = "code";
            const result = (forceSign && Math.sign(amount.value) > 0 ? "+" : "") + this.intl.get().formatNumber(amountValue, {
                ...additionalFormatConfig,
                currency: amount.currencyAlpha ? amount.currencyAlpha : amount.currency,
                style: "currency",
                minimumFractionDigits: currency ? currency.decimal_number : 2,
                numberingSystem: "latn"
            });
            const handleRTLLayout = (value)=>{
                /**
       * This regex is used to extract the sign, the currency symbol and the amount value
       * NOTE: To ensure the regex is efficient and avoids potential Denial of Service (DoS) vulnerabilities
       * (such as catastrophic backtracking), we must structure the pattern carefully.
       * Examine regular expressions for potential Denial of Service vulnerabilities:
       * https://devina.io/redos-checker
       */ const regex = /([+-])([^0-9]+)([0-9,.]+)/;
                const match = value.match(regex);
                let updatedValue = value;
                if (match) updatedValue = match[2] + match[1] + match[3];
                return updatedValue;
            };
            return (0, $cykUx.isRTLLayout)(locale) ? handleRTLLayout(result) : result;
        };
        this.formatMessage = (id, values)=>{
            let translation = "";
            if (this.initialized.get()) {
                const { messages: messages, formatMessage: formatMessage } = this.intl.get();
                if ((0, $gDlNU.hasOwnDeepProperty)(messages, id)) translation = formatMessage({
                    id: id
                }, values);
                else {
                    translation = id;
                    (0, $6JVVB.logger).debug("I18NManager", `${this.localeTag.get()} Translation for ${id} not found`);
                }
            }
            return translation;
        };
        this.formatRelativeDate = (date)=>{
            const intl = this.intl.get();
            if (intl.formatDate(new Date()) === intl.formatDate(date)) return this.formatMessage("common.today");
            else if (intl.formatDate(Date.now() - 86400000) === intl.formatDate(date)) return this.formatMessage("common.yesterday");
            return intl.formatDate(date, {
                month: "long",
                day: "2-digit",
                year: "numeric"
            });
        };
        this.formatDistanceToNow = (date, options = {
            addSuffix: true,
            includeSeconds: false
        })=>date ? (0, $94jk9.formatDistanceToNow)(date, options) : "invalid";
        this.formatDistanceFromNow = (date)=>date ? (0, $4nbTq.formatDistance)(new Date(), date, {
                addSuffix: true
            }) : "invalid";
        this.intl = new (0, $3Ersk.Observable)($c633f970d52bf91b$export$ec5aa2bff0b93f05.createIntl(this.localeTag.get(), {}));
        this.localTranslations = this.translationsManager.localTranslations;
    }
    async initialize(client) {
        const configuredLanguages = this.translationsManager.getConfiguredLanguages();
        (0, $6JVVB.logger).debug("I18NManager", "available languages:", configuredLanguages);
        const clientLanguage = await this.getClientOrDeviceOrFallbackLanguage(client, configuredLanguages);
        const appLanguage = await this.storage.read($c633f970d52bf91b$var$STORAGE_LOCALE_KEY) ?? clientLanguage;
        let currentLanguage = clientLanguage;
        if (clientLanguage !== appLanguage) currentLanguage = appLanguage;
        this.i18NStore.localeTag.set(currentLanguage);
        try {
            await this.setLocale(this.i18NStore.localeTag.get());
            this.initialized.set(true);
        } catch (e) {
            if (e instanceof (0, $iiBUf.TranslationsUpdateError)) this.initialized.set(true);
            throw e;
        }
    }
    get localeTag() {
        return this.i18NStore.localeTag;
    }
    async getClientOrDeviceOrFallbackLanguage(client, configuredLanguages) {
        if (this.storage) {
            // prefer stored locale at login if available
            const storedLocale = await this.storage.read($c633f970d52bf91b$var$STORAGE_LOCALE_KEY);
            if (storedLocale) {
                (0, $6JVVB.logger).debug("I18NManager", "stored locale: ", storedLocale);
                return storedLocale;
            }
        }
        if (client?.lang) {
            (0, $6JVVB.logger).debug("I18NManager", "client already has a defined language: ", client.lang);
            return client.lang;
        }
        const userLocale = $c633f970d52bf91b$export$ec5aa2bff0b93f05.getBestAvailableLanguage(configuredLanguages);
        if (userLocale) {
            (0, $6JVVB.logger).debug("I18NManager", "selecting best available locale from device ", userLocale);
            return userLocale;
        }
        (0, $6JVVB.logger).debug("I18NManager", "falling back to", $c633f970d52bf91b$var$fallbackLanguage);
        return $c633f970d52bf91b$var$fallbackLanguage;
    }
    async setLocale(locale, storeIntoDevice = false) {
        this.i18NStore.localeTag.set(locale);
        await this.updateTranslations(this.i18NStore.localeTag.get());
        this.isRTL.set((0, $cykUx.isRTLLayout)(locale));
        if (storeIntoDevice && this.storage) await this.storage.store(locale, $c633f970d52bf91b$var$STORAGE_LOCALE_KEY);
    }
    async updateTranslations(localeTag) {
        let translations;
        let error;
        try {
            const remoteTranslations = await this.translationsManager.loadTranslations(localeTag);
            const localTranslation = this.localTranslations[localeTag];
            const fallbackTranslations = $c633f970d52bf91b$var$fallbackTranslationsEnabled ? this.localTranslations[$c633f970d52bf91b$var$fallbackLanguage] : undefined;
            translations = {
                ...fallbackTranslations ? fallbackTranslations() : {},
                ...localTranslation ? localTranslation() : {},
                ...remoteTranslations[localeTag]
            };
        } catch (e) {
            if (this.localTranslations[localeTag]) translations = {
                ...this.localTranslations[localeTag](),
                ...this.localTranslations[$c633f970d52bf91b$var$fallbackLanguage]()
            };
            else {
                (0, $6JVVB.logger).debug("I18NManager", `No local translation for user language, falling back to ${$c633f970d52bf91b$var$fallbackLanguage}`);
                translations = this.localTranslations[$c633f970d52bf91b$var$fallbackLanguage]();
            }
        }
        this.intl.set($c633f970d52bf91b$export$ec5aa2bff0b93f05.createIntl(this.i18NStore.localeTag.get(), translations));
        if (error) throw new (0, $iiBUf.TranslationsUpdateError)("Translations update failed");
    }
    static createIntl(localeTag, translations) {
        return (0, $loPuh.createIntl)({
            locale: localeTag.replace("_", "-"),
            messages: translations
        });
    }
    static getBestAvailableLanguage(languageTags) {
        const userLocale = (0, $cykUx.findBestAvailableLanguage)(languageTags.map((l)=>l.replace("_", "-")));
        if (userLocale) {
            const localeTag = userLocale.languageTag.replace("-", "_");
            return localeTag;
        }
        return null;
    }
}

});
parcelRegister("4nbTq", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $32f2891b9306e262$export$2c14ff85d6318973; });

var $jaZN1 = parcelRequire("jaZN1");

var $8gt7j = parcelRequire("8gt7j");

var $hLYc5 = parcelRequire("hLYc5");

var $8pDM2 = parcelRequire("8pDM2");

var $iBXRc = parcelRequire("iBXRc");

var $fCWjd = parcelRequire("fCWjd");

var $kV2aL = parcelRequire("kV2aL");

var $aM5UR = parcelRequire("aM5UR");
function $32f2891b9306e262$export$2c14ff85d6318973(laterDate, earlierDate, options) {
    const defaultOptions = (0, $8gt7j.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $jaZN1.enUS);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $iBXRc.compareAsc)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, $8pDM2.normalizeDates)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const seconds = (0, $aM5UR.differenceInSeconds)(earlierDate_, laterDate_);
    const offsetInSeconds = ((0, $hLYc5.getTimezoneOffsetInMilliseconds)(earlierDate_) - (0, $hLYc5.getTimezoneOffsetInMilliseconds)(laterDate_)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, $fCWjd.minutesInDay)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, $fCWjd.minutesInMonth)) {
        const days = Math.round(minutes / (0, $fCWjd.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, $fCWjd.minutesInMonth) * 2) {
        months = Math.round(minutes / (0, $fCWjd.minutesInMonth));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $kV2aL.differenceInMonths)(earlierDate_, laterDate_);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, $fCWjd.minutesInMonth));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
var // Fallback for modularized imports:
$32f2891b9306e262$export$2e2bcd8739ae039 = $32f2891b9306e262$export$2c14ff85d6318973;

});
parcelRegister("jaZN1", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $039a4df627cbe957$export$137380d9ce54f7f; });

var $6ReEg = parcelRequire("6ReEg");

var $dyGUc = parcelRequire("dyGUc");

var $dSGPB = parcelRequire("dSGPB");

var $ltylL = parcelRequire("ltylL");

var $i6rrG = parcelRequire("i6rrG");
const $039a4df627cbe957$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $6ReEg.formatDistance),
    formatLong: (0, $dyGUc.formatLong),
    formatRelative: (0, $dSGPB.formatRelative),
    localize: (0, $ltylL.localize),
    match: (0, $i6rrG.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$039a4df627cbe957$export$2e2bcd8739ae039 = $039a4df627cbe957$export$137380d9ce54f7f;

});
parcelRegister("6ReEg", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4fe30e327887a816$export$2c14ff85d6318973; });
const $4fe30e327887a816$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $4fe30e327887a816$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $4fe30e327887a816$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("dyGUc", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $9defbb737b5d0282$export$cbf60ecb96cbb82f; });

var $1gRzf = parcelRequire("1gRzf");
const $9defbb737b5d0282$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $9defbb737b5d0282$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $9defbb737b5d0282$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $9defbb737b5d0282$export$cbf60ecb96cbb82f = {
    date: (0, $1gRzf.buildFormatLongFn)({
        formats: $9defbb737b5d0282$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $1gRzf.buildFormatLongFn)({
        formats: $9defbb737b5d0282$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $1gRzf.buildFormatLongFn)({
        formats: $9defbb737b5d0282$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("1gRzf", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $0ed0d6764ebd9b3a$export$38e44e97ce4dbb7d; });
function $0ed0d6764ebd9b3a$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("dSGPB", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a1b18ae30b9073ea$export$8fbbfd65594f46a0; });
const $a1b18ae30b9073ea$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $a1b18ae30b9073ea$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$a1b18ae30b9073ea$var$formatRelativeLocale[token];

});

parcelRegister("ltylL", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $fa26f39d0b9c03bc$export$b3bd0bc58e36cd63; });

var $hGYiY = parcelRequire("hGYiY");
const $fa26f39d0b9c03bc$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $fa26f39d0b9c03bc$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $fa26f39d0b9c03bc$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $fa26f39d0b9c03bc$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $fa26f39d0b9c03bc$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $fa26f39d0b9c03bc$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $fa26f39d0b9c03bc$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $fa26f39d0b9c03bc$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $fa26f39d0b9c03bc$var$ordinalNumber,
    era: (0, $hGYiY.buildLocalizeFn)({
        values: $fa26f39d0b9c03bc$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $hGYiY.buildLocalizeFn)({
        values: $fa26f39d0b9c03bc$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $hGYiY.buildLocalizeFn)({
        values: $fa26f39d0b9c03bc$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $hGYiY.buildLocalizeFn)({
        values: $fa26f39d0b9c03bc$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $hGYiY.buildLocalizeFn)({
        values: $fa26f39d0b9c03bc$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $fa26f39d0b9c03bc$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("hGYiY", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $ce15233db19353b6$export$63596d6ee8878b25; });
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $ce15233db19353b6$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("i6rrG", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $d2de13a42d4f7930$export$4659b591c19bdf3d; });

var $3XvjD = parcelRequire("3XvjD");

var $k3PLJ = parcelRequire("k3PLJ");
const $d2de13a42d4f7930$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2de13a42d4f7930$var$parseOrdinalNumberPattern = /\d+/i;
const $d2de13a42d4f7930$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2de13a42d4f7930$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2de13a42d4f7930$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2de13a42d4f7930$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2de13a42d4f7930$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2de13a42d4f7930$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2de13a42d4f7930$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2de13a42d4f7930$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2de13a42d4f7930$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2de13a42d4f7930$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2de13a42d4f7930$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $k3PLJ.buildMatchPatternFn)({
        matchPattern: $d2de13a42d4f7930$var$matchOrdinalNumberPattern,
        parsePattern: $d2de13a42d4f7930$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $3XvjD.buildMatchFn)({
        matchPatterns: $d2de13a42d4f7930$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2de13a42d4f7930$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $3XvjD.buildMatchFn)({
        matchPatterns: $d2de13a42d4f7930$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2de13a42d4f7930$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $3XvjD.buildMatchFn)({
        matchPatterns: $d2de13a42d4f7930$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2de13a42d4f7930$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $3XvjD.buildMatchFn)({
        matchPatterns: $d2de13a42d4f7930$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2de13a42d4f7930$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $3XvjD.buildMatchFn)({
        matchPatterns: $d2de13a42d4f7930$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2de13a42d4f7930$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("3XvjD", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $2e1f2c6f9f2f13e9$export$1430a0f35710914d; });
function $2e1f2c6f9f2f13e9$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $2e1f2c6f9f2f13e9$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $2e1f2c6f9f2f13e9$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $2e1f2c6f9f2f13e9$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $2e1f2c6f9f2f13e9$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("k3PLJ", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $e9ac3eade12cf688$export$fdaf2fd6d7edde95; });
function $e9ac3eade12cf688$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("8gt7j", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $604667612889f1d4$export$430a3269e24b912e; });
let $604667612889f1d4$var$defaultOptions = {};
function $604667612889f1d4$export$430a3269e24b912e() {
    return $604667612889f1d4$var$defaultOptions;
}
function $604667612889f1d4$export$95365be1b0704abc(newOptions) {
    $604667612889f1d4$var$defaultOptions = newOptions;
}

});

parcelRegister("hLYc5", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $cf0584b2ed49045a$export$113002b5eff6e430; });

var $a7Jiv = parcelRequire("a7Jiv");
function $cf0584b2ed49045a$export$113002b5eff6e430(date) {
    const _date = (0, $a7Jiv.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});
parcelRegister("a7Jiv", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $75edb1f348bf26f7$export$e67a095c620b86fe; });

var $e2gOb = parcelRequire("e2gOb");
function $75edb1f348bf26f7$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $e2gOb.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$75edb1f348bf26f7$export$2e2bcd8739ae039 = $75edb1f348bf26f7$export$e67a095c620b86fe;

});
parcelRegister("e2gOb", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $a37e4a6930da6942$export$ead8a1812b171991; });

var $fCWjd = parcelRequire("fCWjd");
function $a37e4a6930da6942$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $fCWjd.constructFromSymbol) in date) return date[0, $fCWjd.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$a37e4a6930da6942$export$2e2bcd8739ae039 = $a37e4a6930da6942$export$ead8a1812b171991;

});
parcelRegister("fCWjd", function(module, exports) {

$parcel$export(module.exports, "minutesInMonth", function () { return $b607a28e150403a3$export$ab7da2ccd1075c38; });
$parcel$export(module.exports, "minutesInDay", function () { return $b607a28e150403a3$export$2423174df8cd3cd2; });
$parcel$export(module.exports, "constructFromSymbol", function () { return $b607a28e150403a3$export$2a7b97929c48d47d; });
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $b607a28e150403a3$export$dfd9b671c89acc8e = 7;
const $b607a28e150403a3$export$3913210603d8e9ae = 365.2425;
const $b607a28e150403a3$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $b607a28e150403a3$export$4dec998e48f9c246 = -$b607a28e150403a3$export$81caae6e1cc7a622;
const $b607a28e150403a3$export$4fad13613e88edc8 = 604800000;
const $b607a28e150403a3$export$b76b1809a2898f9a = 86400000;
const $b607a28e150403a3$export$91246f0b9bd9beff = 60000;
const $b607a28e150403a3$export$7f72910d6dfd237a = 3600000;
const $b607a28e150403a3$export$397c2d5776aa9055 = 1000;
const $b607a28e150403a3$export$3633035e63cee86a = 525600;
const $b607a28e150403a3$export$ab7da2ccd1075c38 = 43200;
const $b607a28e150403a3$export$2423174df8cd3cd2 = 1440;
const $b607a28e150403a3$export$f2f5ae5a8e2d8f9f = 60;
const $b607a28e150403a3$export$3c58128db900d44e = 3;
const $b607a28e150403a3$export$80d7e435f744f319 = 12;
const $b607a28e150403a3$export$4db7641526e3241f = 4;
const $b607a28e150403a3$export$698aec755e92c695 = 3600;
const $b607a28e150403a3$export$a77c1a7ebebe2a5a = 60;
const $b607a28e150403a3$export$815a9362476d2fe3 = $b607a28e150403a3$export$698aec755e92c695 * 24;
const $b607a28e150403a3$export$34804a017b31e2fe = $b607a28e150403a3$export$815a9362476d2fe3 * 7;
const $b607a28e150403a3$export$7271e9e3478110d1 = $b607a28e150403a3$export$815a9362476d2fe3 * $b607a28e150403a3$export$3913210603d8e9ae;
const $b607a28e150403a3$export$8e6600bbdee7dabb = $b607a28e150403a3$export$7271e9e3478110d1 / 12;
const $b607a28e150403a3$export$be1dccf2de902d31 = $b607a28e150403a3$export$8e6600bbdee7dabb * 3;
const $b607a28e150403a3$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});




parcelRegister("8pDM2", function(module, exports) {

$parcel$export(module.exports, "normalizeDates", function () { return $61ff82cd27c72d3a$export$9f53b88e82f64d8d; });

var $e2gOb = parcelRequire("e2gOb");
function $61ff82cd27c72d3a$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $e2gOb.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

});

parcelRegister("iBXRc", function(module, exports) {

$parcel$export(module.exports, "compareAsc", function () { return $d8ca1d0eb52bc370$export$fe114145ae75d197; });

var $a7Jiv = parcelRequire("a7Jiv");
function $d8ca1d0eb52bc370$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $a7Jiv.toDate)(dateLeft) - +(0, $a7Jiv.toDate)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$d8ca1d0eb52bc370$export$2e2bcd8739ae039 = $d8ca1d0eb52bc370$export$fe114145ae75d197;

});

parcelRegister("kV2aL", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", function () { return $f3aad0f340ef754f$export$fc1ed482c2861792; });

var $8pDM2 = parcelRequire("8pDM2");

var $iBXRc = parcelRequire("iBXRc");

var $dYnjb = parcelRequire("dYnjb");

var $fL1pj = parcelRequire("fL1pj");
function $f3aad0f340ef754f$export$fc1ed482c2861792(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, $8pDM2.normalizeDates)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, $iBXRc.compareAsc)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, $dYnjb.differenceInCalendarMonths)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, $iBXRc.compareAsc)(workingLaterDate, earlierDate_) === -sign;
    if ((0, $fL1pj.isLastDayOfMonth)(laterDate_) && difference === 1 && (0, $iBXRc.compareAsc)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$f3aad0f340ef754f$export$2e2bcd8739ae039 = $f3aad0f340ef754f$export$fc1ed482c2861792;

});
parcelRegister("dYnjb", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", function () { return $a2c2f584fdd62072$export$489984ac7c996389; });

var $8pDM2 = parcelRequire("8pDM2");
function $a2c2f584fdd62072$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $8pDM2.normalizeDates)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$a2c2f584fdd62072$export$2e2bcd8739ae039 = $a2c2f584fdd62072$export$489984ac7c996389;

});

parcelRegister("fL1pj", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", function () { return $b78c56409e0212d5$export$c817d0312007ea5e; });

var $lH0xJ = parcelRequire("lH0xJ");

var $fQHuO = parcelRequire("fQHuO");

var $a7Jiv = parcelRequire("a7Jiv");
function $b78c56409e0212d5$export$c817d0312007ea5e(date, options) {
    const _date = (0, $a7Jiv.toDate)(date, options?.in);
    return +(0, $lH0xJ.endOfDay)(_date, options) === +(0, $fQHuO.endOfMonth)(_date, options);
}
var // Fallback for modularized imports:
$b78c56409e0212d5$export$2e2bcd8739ae039 = $b78c56409e0212d5$export$c817d0312007ea5e;

});
parcelRegister("lH0xJ", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $fcae08f77689de06$export$eb9a03f0e9aa6cea; });

var $a7Jiv = parcelRequire("a7Jiv");
function $fcae08f77689de06$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $a7Jiv.toDate)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$fcae08f77689de06$export$2e2bcd8739ae039 = $fcae08f77689de06$export$eb9a03f0e9aa6cea;

});

parcelRegister("fQHuO", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $b89d73c143690b1e$export$a2258d9c4118825c; });

var $a7Jiv = parcelRequire("a7Jiv");
function $b89d73c143690b1e$export$a2258d9c4118825c(date, options) {
    const _date = (0, $a7Jiv.toDate)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$b89d73c143690b1e$export$2e2bcd8739ae039 = $b89d73c143690b1e$export$a2258d9c4118825c;

});



parcelRegister("aM5UR", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", function () { return $7d82f9e5ef4f34cb$export$c1889aec51783710; });

var $6mEU7 = parcelRequire("6mEU7");

var $7yCr5 = parcelRequire("7yCr5");
function $7d82f9e5ef4f34cb$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $7yCr5.differenceInMilliseconds)(laterDate, earlierDate) / 1000;
    return (0, $6mEU7.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$7d82f9e5ef4f34cb$export$2e2bcd8739ae039 = $7d82f9e5ef4f34cb$export$c1889aec51783710;

});
parcelRegister("6mEU7", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $4a2486e0d80de5c7$export$b6474a47258c1211; });
function $4a2486e0d80de5c7$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("7yCr5", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", function () { return $580985f5824e529e$export$7be94d13716b4bf6; });

var $a7Jiv = parcelRequire("a7Jiv");
function $580985f5824e529e$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $a7Jiv.toDate)(laterDate) - +(0, $a7Jiv.toDate)(earlierDate);
}
var // Fallback for modularized imports:
$580985f5824e529e$export$2e2bcd8739ae039 = $580985f5824e529e$export$7be94d13716b4bf6;

});



parcelRegister("94jk9", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", function () { return $69a37a1ca82b835d$export$d130c20a256f8817; });

var $dDS5q = parcelRequire("dDS5q");

var $4nbTq = parcelRequire("4nbTq");
function $69a37a1ca82b835d$export$d130c20a256f8817(date, options) {
    return (0, $4nbTq.formatDistance)(date, (0, $dDS5q.constructNow)(date), options);
}
var // Fallback for modularized imports:
$69a37a1ca82b835d$export$2e2bcd8739ae039 = $69a37a1ca82b835d$export$d130c20a256f8817;

});
parcelRegister("dDS5q", function(module, exports) {

$parcel$export(module.exports, "constructNow", function () { return $9ee8df5045cab209$export$18c3c6510fb97afc; });

var $e2gOb = parcelRequire("e2gOb");
function $9ee8df5045cab209$export$18c3c6510fb97afc(date) {
    return (0, $e2gOb.constructFrom)(date, Date.now());
}
var // Fallback for modularized imports:
$9ee8df5045cab209$export$2e2bcd8739ae039 = $9ee8df5045cab209$export$18c3c6510fb97afc;

});


parcelRegister("loPuh", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $f943c72d75c0ab8e$export$7e4cbedfdd7b4c0d; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $4xyqa = parcelRequire("4xyqa");

var $c8BYW = parcelRequire("c8BYW");
var $7iqF8 = parcelRequire("7iqF8");

var $6uYXW = parcelRequire("6uYXW");

var $63AeI = parcelRequire("63AeI");

var $dR1O2 = parcelRequire("dR1O2");
function $f943c72d75c0ab8e$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $dR1O2.isFormatXMLElementFn)(v) ? (0, $63AeI.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $f943c72d75c0ab8e$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $f943c72d75c0ab8e$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $7iqF8.formatMessage).apply(void 0, (0, $4xyqa.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $6uYXW.Children.toArray(chunks);
    return chunks;
};
var $f943c72d75c0ab8e$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $4xyqa.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $f943c72d75c0ab8e$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $c8BYW.createIntl)((0, $4xyqa.__assign)((0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, (0, $63AeI.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, coreIntl), {
        formatMessage: $f943c72d75c0ab8e$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $f943c72d75c0ab8e$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("4xyqa", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $34e4f1c6c3b5f63e$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $34e4f1c6c3b5f63e$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $34e4f1c6c3b5f63e$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $34e4f1c6c3b5f63e$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $34e4f1c6c3b5f63e$var$extendStatics = function(d, b) {
    $34e4f1c6c3b5f63e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $34e4f1c6c3b5f63e$var$extendStatics(d, b);
};
function $34e4f1c6c3b5f63e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $34e4f1c6c3b5f63e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $34e4f1c6c3b5f63e$export$18ce0697a983be9b = function() {
    $34e4f1c6c3b5f63e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $34e4f1c6c3b5f63e$export$18ce0697a983be9b.apply(this, arguments);
};
function $34e4f1c6c3b5f63e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $34e4f1c6c3b5f63e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $34e4f1c6c3b5f63e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $34e4f1c6c3b5f63e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $34e4f1c6c3b5f63e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $34e4f1c6c3b5f63e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $34e4f1c6c3b5f63e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $34e4f1c6c3b5f63e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $34e4f1c6c3b5f63e$export$45d3717a4c69092e(o, m, p);
}
function $34e4f1c6c3b5f63e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $34e4f1c6c3b5f63e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $34e4f1c6c3b5f63e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($34e4f1c6c3b5f63e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $34e4f1c6c3b5f63e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $34e4f1c6c3b5f63e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $34e4f1c6c3b5f63e$export$10c90e4f7922046c(v) {
    return this instanceof $34e4f1c6c3b5f63e$export$10c90e4f7922046c ? (this.v = v, this) : new $34e4f1c6c3b5f63e$export$10c90e4f7922046c(v);
}
function $34e4f1c6c3b5f63e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $34e4f1c6c3b5f63e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $34e4f1c6c3b5f63e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $34e4f1c6c3b5f63e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $34e4f1c6c3b5f63e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $34e4f1c6c3b5f63e$export$19a8beecd37a4c45 === "function" ? $34e4f1c6c3b5f63e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $34e4f1c6c3b5f63e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $34e4f1c6c3b5f63e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $34e4f1c6c3b5f63e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $34e4f1c6c3b5f63e$export$45d3717a4c69092e(result, mod, k);
    }
    $34e4f1c6c3b5f63e$var$__setModuleDefault(result, mod);
    return result;
}
function $34e4f1c6c3b5f63e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $34e4f1c6c3b5f63e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $34e4f1c6c3b5f63e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $34e4f1c6c3b5f63e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});

parcelRegister("c8BYW", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $8d63b1cd1086bb6a$export$7e4cbedfdd7b4c0d; });

var $4xyqa = parcelRequire("4xyqa");

var $5jRl7 = parcelRequire("5jRl7");

var $iOnyF = parcelRequire("iOnyF");

var $9ujoZ = parcelRequire("9ujoZ");

var $7GtnU = parcelRequire("7GtnU");

var $e8QND = parcelRequire("e8QND");

var $1pPd0 = parcelRequire("1pPd0");

var $7iqF8 = parcelRequire("7iqF8");

var $g9t38 = parcelRequire("g9t38");

var $2t9V9 = parcelRequire("2t9V9");
function $8d63b1cd1086bb6a$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $8d63b1cd1086bb6a$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $8d63b1cd1086bb6a$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $8d63b1cd1086bb6a$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $5jRl7.createFormatters)(cache);
    var resolvedConfig = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, (0, $5jRl7.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $iOnyF.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iOnyF.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iOnyF.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $8d63b1cd1086bb6a$var$verifyConfigMessages(resolvedConfig);
    return (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $9ujoZ.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $9ujoZ.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $7GtnU.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $e8QND.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $e8QND.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $e8QND.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $e8QND.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $e8QND.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $1pPd0.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $7iqF8.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $7iqF8.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $g9t38.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $g9t38.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $2t9V9.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("5jRl7", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $3df81a4280db9838$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $3df81a4280db9838$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createFormatters", function () { return $3df81a4280db9838$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $3df81a4280db9838$export$4ee1db8ce44a209b; });

var $4xyqa = parcelRequire("4xyqa");
parcelRequire("2UWva");
var $eJOg2 = parcelRequire("eJOg2");

var $gGNvx = parcelRequire("gGNvx");

var $iOnyF = parcelRequire("iOnyF");
function $3df81a4280db9838$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $3df81a4280db9838$var$defaultErrorHandler = function(error) {};
var $3df81a4280db9838$var$defaultWarnHandler = function(warning) {};
var $3df81a4280db9838$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $3df81a4280db9838$var$defaultErrorHandler,
    onWarn: $3df81a4280db9838$var$defaultWarnHandler
};
function $3df81a4280db9838$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $3df81a4280db9838$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $3df81a4280db9838$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $3df81a4280db9838$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $gGNvx.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $4xyqa.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $3df81a4280db9838$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $gGNvx.strategies).variadic
    });
    var getNumberFormat = (0, $gGNvx.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $4xyqa.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $3df81a4280db9838$var$createFastMemoizeCache(cache.number),
        strategy: (0, $gGNvx.strategies).variadic
    });
    var getPluralRules = (0, $gGNvx.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $4xyqa.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $3df81a4280db9838$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $gGNvx.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $gGNvx.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $eJOg2.IntlMessageFormat)(message, locales, overrideFormats, (0, $4xyqa.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $3df81a4280db9838$var$createFastMemoizeCache(cache.message),
            strategy: (0, $gGNvx.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $gGNvx.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $4xyqa.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $3df81a4280db9838$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $gGNvx.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $gGNvx.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $4xyqa.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $3df81a4280db9838$var$createFastMemoizeCache(cache.list),
            strategy: (0, $gGNvx.strategies).variadic
        }),
        getDisplayNames: (0, $gGNvx.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $4xyqa.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $3df81a4280db9838$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $gGNvx.strategies).variadic
        })
    };
}
function $3df81a4280db9838$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $iOnyF.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("2UWva", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("4ksLn")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("4ksLn")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("dR1O2")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("eJOg2")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $eJOg2 = parcelRequire("eJOg2");
parcelRequire("4ksLn");
parcelRequire("dR1O2");
var $21fe30f66f948cf5$export$2e2bcd8739ae039 = (0, $eJOg2.IntlMessageFormat);

});
parcelRegister("eJOg2", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $abac40c77d4e02af$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $4xyqa = parcelRequire("4xyqa");

var $7VjoF = parcelRequire("7VjoF");

var $gGNvx = parcelRequire("gGNvx");

var $dR1O2 = parcelRequire("dR1O2");
// -- MessageFormat --------------------------------------------------------
function $abac40c77d4e02af$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $4xyqa.__assign)((0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $abac40c77d4e02af$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $abac40c77d4e02af$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $4xyqa.__assign)({}, defaultConfig));
}
function $abac40c77d4e02af$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $abac40c77d4e02af$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $gGNvx.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $4xyqa.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $abac40c77d4e02af$var$createFastMemoizeCache(cache.number),
            strategy: (0, $gGNvx.strategies).variadic
        }),
        getDateTimeFormat: (0, $gGNvx.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $4xyqa.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $abac40c77d4e02af$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $gGNvx.strategies).variadic
        }),
        getPluralRules: (0, $gGNvx.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $4xyqa.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $abac40c77d4e02af$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $gGNvx.strategies).variadic
        })
    };
}
var $abac40c77d4e02af$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $dR1O2.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $dR1O2.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $4xyqa.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $abac40c77d4e02af$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $abac40c77d4e02af$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $7VjoF.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("7VjoF", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("kgwv6")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("kgwv6")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("kgwv6")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("kgwv6")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("kgwv6")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("kgwv6")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("kgwv6")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("kgwv6")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("kgwv6")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("kgwv6")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("kgwv6")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("kgwv6")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $5c4ce711032dbde7$export$98e6a39c04603d36; });

var $4xyqa = parcelRequire("4xyqa");

var $bWaJ4 = parcelRequire("bWaJ4");

var $xs2e6 = parcelRequire("xs2e6");

var $kgwv6 = parcelRequire("kgwv6");
function $5c4ce711032dbde7$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $kgwv6.isSelectElement)(el) || (0, $kgwv6.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $5c4ce711032dbde7$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $kgwv6.isNumberElement)(el) && (0, $kgwv6.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $kgwv6.isDateElement)(el) || (0, $kgwv6.isTimeElement)(el)) && (0, $kgwv6.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $kgwv6.isTagElement)(el)) $5c4ce711032dbde7$var$pruneLocation(el.children);
    });
}
function $5c4ce711032dbde7$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $4xyqa.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $xs2e6.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $bWaJ4.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $5c4ce711032dbde7$var$pruneLocation(result.val);
    return result.val;
}
var $5c4ce711032dbde7$export$d3c1bfa0f7d806e9 = (0, $xs2e6.Parser);

});
parcelRegister("bWaJ4", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $8b0d6e6e75b2d894$export$896afd8541959ee5; });
var $8b0d6e6e75b2d894$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($8b0d6e6e75b2d894$export$896afd8541959ee5 || ($8b0d6e6e75b2d894$export$896afd8541959ee5 = {}));

});

parcelRegister("xs2e6", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $0648d454d3562de6$export$7acfa6ed01010e37; });

var $4xyqa = parcelRequire("4xyqa");

var $bWaJ4 = parcelRequire("bWaJ4");

var $kgwv6 = parcelRequire("kgwv6");

var $8JWDH = parcelRequire("8JWDH");
parcelRequire("4FCkn");
var $9Vjtx = parcelRequire("9Vjtx");
var $9DMO5 = parcelRequire("9DMO5");

var $eEnlQ = parcelRequire("eEnlQ");
var $0648d454d3562de6$var$_a;
var $0648d454d3562de6$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $8JWDH.SPACE_SEPARATOR_REGEX).source, "*"));
var $0648d454d3562de6$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $8JWDH.SPACE_SEPARATOR_REGEX).source, "*$"));
function $0648d454d3562de6$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $0648d454d3562de6$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $0648d454d3562de6$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $0648d454d3562de6$var$hasNativeFromEntries = !!Object.fromEntries;
var $0648d454d3562de6$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $0648d454d3562de6$var$hasTrimStart = !!String.prototype.trimStart;
var $0648d454d3562de6$var$hasTrimEnd = !!String.prototype.trimEnd;
var $0648d454d3562de6$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $0648d454d3562de6$var$isSafeInteger = $0648d454d3562de6$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $0648d454d3562de6$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $0648d454d3562de6$var$re = $0648d454d3562de6$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $0648d454d3562de6$var$REGEX_SUPPORTS_U_AND_Y = (($0648d454d3562de6$var$_a = $0648d454d3562de6$var$re.exec('a')) === null || $0648d454d3562de6$var$_a === void 0 ? void 0 : $0648d454d3562de6$var$_a[0]) === 'a';
} catch (_) {
    $0648d454d3562de6$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $0648d454d3562de6$var$startsWith = $0648d454d3562de6$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $0648d454d3562de6$var$fromCodePoint = $0648d454d3562de6$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $0648d454d3562de6$var$fromEntries = // native
$0648d454d3562de6$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $0648d454d3562de6$var$codePointAt = $0648d454d3562de6$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $0648d454d3562de6$var$trimStart = $0648d454d3562de6$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($0648d454d3562de6$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $0648d454d3562de6$var$trimEnd = $0648d454d3562de6$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($0648d454d3562de6$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $0648d454d3562de6$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $0648d454d3562de6$var$matchIdentifierAtIndex;
if ($0648d454d3562de6$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $0648d454d3562de6$var$IDENTIFIER_PREFIX_RE_1 = $0648d454d3562de6$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $0648d454d3562de6$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $0648d454d3562de6$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $0648d454d3562de6$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$0648d454d3562de6$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $0648d454d3562de6$var$codePointAt(s, index);
        if (c === undefined || $0648d454d3562de6$var$_isWhiteSpace(c) || $0648d454d3562de6$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $0648d454d3562de6$var$fromCodePoint.apply(void 0, match);
};
var $0648d454d3562de6$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $kgwv6.TYPE).pound,
                    location: $0648d454d3562de6$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $bWaJ4.ErrorKind).UNMATCHED_CLOSING_TAG, $0648d454d3562de6$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $0648d454d3562de6$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $kgwv6.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $0648d454d3562de6$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$0648d454d3562de6$var$_isAlpha(this.char())) return this.error((0, $bWaJ4.ErrorKind).INVALID_TAG, $0648d454d3562de6$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $bWaJ4.ErrorKind).UNMATCHED_CLOSING_TAG, $0648d454d3562de6$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $bWaJ4.ErrorKind).INVALID_TAG, $0648d454d3562de6$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $kgwv6.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $0648d454d3562de6$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $bWaJ4.ErrorKind).UNCLOSED_TAG, $0648d454d3562de6$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $bWaJ4.ErrorKind).INVALID_TAG, $0648d454d3562de6$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $0648d454d3562de6$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $0648d454d3562de6$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $kgwv6.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$0648d454d3562de6$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $0648d454d3562de6$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $0648d454d3562de6$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $bWaJ4.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $bWaJ4.ErrorKind).EMPTY_ARGUMENT, $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $bWaJ4.ErrorKind).MALFORMED_ARGUMENT, $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $bWaJ4.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $kgwv6.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $bWaJ4.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $bWaJ4.ErrorKind).MALFORMED_ARGUMENT, $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $0648d454d3562de6$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $0648d454d3562de6$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $bWaJ4.ErrorKind).EXPECT_ARGUMENT_TYPE, $0648d454d3562de6$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $0648d454d3562de6$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $bWaJ4.ErrorKind).EXPECT_ARGUMENT_STYLE, $0648d454d3562de6$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $0648d454d3562de6$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $0648d454d3562de6$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $0648d454d3562de6$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $kgwv6.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $bWaJ4.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $eEnlQ.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $kgwv6.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $9Vjtx.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $kgwv6.TYPE).date : (0, $kgwv6.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $kgwv6.TYPE).number : argType === 'date' ? (0, $kgwv6.TYPE).date : (0, $kgwv6.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $bWaJ4.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $0648d454d3562de6$var$createLocation(typeEndPosition_1, (0, $4xyqa.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $bWaJ4.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $0648d454d3562de6$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $bWaJ4.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $bWaJ4.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $kgwv6.TYPE).select,
                        value: value,
                        options: $0648d454d3562de6$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $kgwv6.TYPE).plural,
                        value: value,
                        options: $0648d454d3562de6$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $bWaJ4.ErrorKind).INVALID_ARGUMENT_TYPE, $0648d454d3562de6$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $bWaJ4.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $bWaJ4.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $0648d454d3562de6$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $9DMO5.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $bWaJ4.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $kgwv6.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $9DMO5.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $bWaJ4.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $bWaJ4.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $0648d454d3562de6$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $bWaJ4.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $bWaJ4.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $bWaJ4.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $bWaJ4.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $0648d454d3562de6$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $0648d454d3562de6$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $bWaJ4.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $bWaJ4.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $0648d454d3562de6$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $bWaJ4.ErrorKind).MISSING_OTHER_CLAUSE, $0648d454d3562de6$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $0648d454d3562de6$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$0648d454d3562de6$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $0648d454d3562de6$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($0648d454d3562de6$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $0648d454d3562de6$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $0648d454d3562de6$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $0648d454d3562de6$var$_isAlphaOrSlash(codepoint) {
    return $0648d454d3562de6$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $0648d454d3562de6$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $0648d454d3562de6$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $0648d454d3562de6$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("kgwv6", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $ec0e83331218276f$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $ec0e83331218276f$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $ec0e83331218276f$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $ec0e83331218276f$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $ec0e83331218276f$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $ec0e83331218276f$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $ec0e83331218276f$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $ec0e83331218276f$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $ec0e83331218276f$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $ec0e83331218276f$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $ec0e83331218276f$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $ec0e83331218276f$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $ec0e83331218276f$export$7680c41f1a55f4cf; });
var $ec0e83331218276f$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($ec0e83331218276f$export$b87f371cbc396fcf || ($ec0e83331218276f$export$b87f371cbc396fcf = {}));
var $ec0e83331218276f$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($ec0e83331218276f$export$906452485466fa53 || ($ec0e83331218276f$export$906452485466fa53 = {}));
function $ec0e83331218276f$export$cfa10c5697238752(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.literal;
}
function $ec0e83331218276f$export$4f55724281bdfaf9(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.argument;
}
function $ec0e83331218276f$export$e11187b219e191e1(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.number;
}
function $ec0e83331218276f$export$32d811605da75f40(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.date;
}
function $ec0e83331218276f$export$34ec46f596b1702f(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.time;
}
function $ec0e83331218276f$export$dcfe1c11d168b5a1(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.select;
}
function $ec0e83331218276f$export$6c796d116f0a4fbc(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.plural;
}
function $ec0e83331218276f$export$c0ece297bdd0c082(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.pound;
}
function $ec0e83331218276f$export$5c83de34745812b(el) {
    return el.type === $ec0e83331218276f$export$b87f371cbc396fcf.tag;
}
function $ec0e83331218276f$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $ec0e83331218276f$export$906452485466fa53.number);
}
function $ec0e83331218276f$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $ec0e83331218276f$export$906452485466fa53.dateTime);
}
function $ec0e83331218276f$export$f0ac572c1121c662(value) {
    return {
        type: $ec0e83331218276f$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $ec0e83331218276f$export$425e864b0ba114f1(value, style) {
    return {
        type: $ec0e83331218276f$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("8JWDH", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $65d00342fd094dc9$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $65d00342fd094dc9$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $65d00342fd094dc9$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("4FCkn", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("9Vjtx")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("9DMO5")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("9DMO5")).parseNumberSkeletonFromString; });
parcelRequire("9Vjtx");
parcelRequire("9DMO5");

});
parcelRegister("9Vjtx", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $73988b523d3de7b8$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $73988b523d3de7b8$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $73988b523d3de7b8$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($73988b523d3de7b8$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("9DMO5", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $704d9d9ae179d067$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $704d9d9ae179d067$export$47c6f8480bda3e11; });

var $4xyqa = parcelRequire("4xyqa");

var $i762v = parcelRequire("i762v");
function $704d9d9ae179d067$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $i762v.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $704d9d9ae179d067$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $704d9d9ae179d067$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $704d9d9ae179d067$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $704d9d9ae179d067$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $704d9d9ae179d067$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $704d9d9ae179d067$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($704d9d9ae179d067$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $704d9d9ae179d067$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $704d9d9ae179d067$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$704d9d9ae179d067$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $704d9d9ae179d067$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $704d9d9ae179d067$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $704d9d9ae179d067$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $704d9d9ae179d067$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $4xyqa.__assign)((0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, all), $704d9d9ae179d067$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $4xyqa.__assign)((0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, all), $704d9d9ae179d067$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($704d9d9ae179d067$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($704d9d9ae179d067$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($704d9d9ae179d067$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($704d9d9ae179d067$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, result), $704d9d9ae179d067$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($704d9d9ae179d067$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, result), $704d9d9ae179d067$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $704d9d9ae179d067$var$parseSign(token.stem);
        if (signOpts) result = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $704d9d9ae179d067$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("i762v", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $d2fd90bd2c258d3b$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $d2fd90bd2c258d3b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("eEnlQ", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $aaa6ea32f1f691af$export$29c5368be8904d27; });

var $n0Fng = parcelRequire("n0Fng");
function $aaa6ea32f1f691af$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $aaa6ea32f1f691af$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $aaa6ea32f1f691af$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $n0Fng.timeData)[regionTag || ''] || (0, $n0Fng.timeData)[languageTag || ''] || (0, $n0Fng.timeData)["".concat(languageTag, "-001")] || (0, $n0Fng.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("n0Fng", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $0452aa6a80cf956a$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $0452aa6a80cf956a$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("gGNvx", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $c266f8c76a4c657e$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $c266f8c76a4c657e$export$c5491a8691a23b9e; });
//
// Main
//
function $c266f8c76a4c657e$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $c266f8c76a4c657e$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c266f8c76a4c657e$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c266f8c76a4c657e$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c266f8c76a4c657e$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $c266f8c76a4c657e$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c266f8c76a4c657e$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c266f8c76a4c657e$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c266f8c76a4c657e$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c266f8c76a4c657e$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c266f8c76a4c657e$var$monadic : $c266f8c76a4c657e$var$variadic;
    return $c266f8c76a4c657e$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c266f8c76a4c657e$var$strategyVariadic(fn, options) {
    return $c266f8c76a4c657e$var$assemble(fn, this, $c266f8c76a4c657e$var$variadic, options.cache.create(), options.serializer);
}
function $c266f8c76a4c657e$var$strategyMonadic(fn, options) {
    return $c266f8c76a4c657e$var$assemble(fn, this, $c266f8c76a4c657e$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $c266f8c76a4c657e$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $c266f8c76a4c657e$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c266f8c76a4c657e$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c266f8c76a4c657e$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c266f8c76a4c657e$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $c266f8c76a4c657e$var$ObjectWithoutPrototypeCache();
    }
};
var $c266f8c76a4c657e$export$c5491a8691a23b9e = {
    variadic: $c266f8c76a4c657e$var$strategyVariadic,
    monadic: $c266f8c76a4c657e$var$strategyMonadic
};

});

parcelRegister("dR1O2", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $a161a03e8e6b9fdb$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $a161a03e8e6b9fdb$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $a161a03e8e6b9fdb$export$275d4a3bb5f66fda; });
parcelRequire("7VjoF");
var $kgwv6 = parcelRequire("kgwv6");

var $4ksLn = parcelRequire("4ksLn");
var $a161a03e8e6b9fdb$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($a161a03e8e6b9fdb$export$49694c2877b44c57 || ($a161a03e8e6b9fdb$export$49694c2877b44c57 = {}));
function $a161a03e8e6b9fdb$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $a161a03e8e6b9fdb$export$49694c2877b44c57.literal || part.type !== $a161a03e8e6b9fdb$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $a161a03e8e6b9fdb$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $a161a03e8e6b9fdb$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $kgwv6.isLiteralElement)(els[0])) return [
        {
            type: $a161a03e8e6b9fdb$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $kgwv6.isLiteralElement)(el)) {
            result.push({
                type: $a161a03e8e6b9fdb$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $kgwv6.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $a161a03e8e6b9fdb$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $4ksLn.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $kgwv6.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $a161a03e8e6b9fdb$export$49694c2877b44c57.literal : $a161a03e8e6b9fdb$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $kgwv6.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $kgwv6.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $a161a03e8e6b9fdb$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $kgwv6.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $kgwv6.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $a161a03e8e6b9fdb$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $kgwv6.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $kgwv6.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $a161a03e8e6b9fdb$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $kgwv6.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$a161a03e8e6b9fdb$export$df0c12a2d414a163(formatFn)) throw new (0, $4ksLn.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $a161a03e8e6b9fdb$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $a161a03e8e6b9fdb$export$49694c2877b44c57.literal : $a161a03e8e6b9fdb$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $kgwv6.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $4ksLn.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a161a03e8e6b9fdb$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $kgwv6.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $4ksLn.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $4ksLn.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $4ksLn.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a161a03e8e6b9fdb$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $a161a03e8e6b9fdb$var$mergeLiteral(result);
}

});
parcelRegister("4ksLn", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $326f57711e69b0d8$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $326f57711e69b0d8$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $326f57711e69b0d8$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $326f57711e69b0d8$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $326f57711e69b0d8$export$8bfc137e4d23fdf0; });

var $4xyqa = parcelRequire("4xyqa");
var $326f57711e69b0d8$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($326f57711e69b0d8$export$d4e71bc0b80dc0fb || ($326f57711e69b0d8$export$d4e71bc0b80dc0fb = {}));
var $326f57711e69b0d8$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $326f57711e69b0d8$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $326f57711e69b0d8$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($326f57711e69b0d8$export$7369836851cc1329);
var $326f57711e69b0d8$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $326f57711e69b0d8$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($326f57711e69b0d8$export$7369836851cc1329);
var $326f57711e69b0d8$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $326f57711e69b0d8$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($326f57711e69b0d8$export$7369836851cc1329);

});




parcelRegister("iOnyF", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $db1f2babc7bc92f4$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $db1f2babc7bc92f4$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $db1f2babc7bc92f4$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $db1f2babc7bc92f4$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $db1f2babc7bc92f4$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $db1f2babc7bc92f4$export$2ddcb436d0aa3688; });

var $4xyqa = parcelRequire("4xyqa");
var $db1f2babc7bc92f4$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($db1f2babc7bc92f4$export$557d6acb76e8a244 || ($db1f2babc7bc92f4$export$557d6acb76e8a244 = {}));
var $db1f2babc7bc92f4$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $db1f2babc7bc92f4$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $db1f2babc7bc92f4$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($db1f2babc7bc92f4$export$c016d36112f6ddf8);
var $db1f2babc7bc92f4$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $db1f2babc7bc92f4$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($db1f2babc7bc92f4$export$c016d36112f6ddf8);
var $db1f2babc7bc92f4$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $db1f2babc7bc92f4$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($db1f2babc7bc92f4$export$c016d36112f6ddf8);
var $db1f2babc7bc92f4$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $db1f2babc7bc92f4$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($db1f2babc7bc92f4$export$c016d36112f6ddf8);
var $db1f2babc7bc92f4$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($db1f2babc7bc92f4$export$e3b7eee1dbc44895);
var $db1f2babc7bc92f4$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $4xyqa.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $db1f2babc7bc92f4$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($db1f2babc7bc92f4$export$c016d36112f6ddf8);

});


parcelRegister("9ujoZ", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $6e85f74024a1454d$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $6e85f74024a1454d$export$6871080848f10b2f; });

var $iOnyF = parcelRequire("iOnyF");

var $5jRl7 = parcelRequire("5jRl7");
var $6e85f74024a1454d$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $6e85f74024a1454d$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $5jRl7.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $5jRl7.filterProps)(options, $6e85f74024a1454d$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $6e85f74024a1454d$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $6e85f74024a1454d$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $iOnyF.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $6e85f74024a1454d$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $6e85f74024a1454d$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $iOnyF.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("7GtnU", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $59833fd391cf7601$export$b4ea3b48dcf921f6; });

var $5jRl7 = parcelRequire("5jRl7");

var $4ksLn = parcelRequire("4ksLn");

var $iOnyF = parcelRequire("iOnyF");
var $59833fd391cf7601$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $59833fd391cf7601$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $5jRl7.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $5jRl7.filterProps)(options, $59833fd391cf7601$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $59833fd391cf7601$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $4ksLn.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $4ksLn.ErrorCode).MISSING_INTL_API));
    try {
        return $59833fd391cf7601$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $iOnyF.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("e8QND", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $a4bac4ecd52153e0$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $a4bac4ecd52153e0$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $a4bac4ecd52153e0$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $a4bac4ecd52153e0$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $a4bac4ecd52153e0$export$af6e5d7a5c73edeb; });

var $4xyqa = parcelRequire("4xyqa");

var $5jRl7 = parcelRequire("5jRl7");

var $iOnyF = parcelRequire("iOnyF");
var $a4bac4ecd52153e0$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $a4bac4ecd52153e0$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $5jRl7.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $5jRl7.filterProps)(options, $a4bac4ecd52153e0$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $a4bac4ecd52153e0$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a4bac4ecd52153e0$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iOnyF.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $a4bac4ecd52153e0$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a4bac4ecd52153e0$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iOnyF.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $a4bac4ecd52153e0$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $5jRl7.filterProps)(options, $a4bac4ecd52153e0$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $iOnyF.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $a4bac4ecd52153e0$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a4bac4ecd52153e0$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iOnyF.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $a4bac4ecd52153e0$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a4bac4ecd52153e0$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iOnyF.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("1pPd0", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $107fd93922e481a7$export$bbbd05c900f3568d; });

var $5jRl7 = parcelRequire("5jRl7");

var $iOnyF = parcelRequire("iOnyF");

var $4ksLn = parcelRequire("4ksLn");
var $107fd93922e481a7$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $107fd93922e481a7$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $4ksLn.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $4ksLn.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5jRl7.filterProps)(options, $107fd93922e481a7$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $iOnyF.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("7iqF8", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $54fee56ecd406849$export$25868d1e8e76735f; });

var $4xyqa = parcelRequire("4xyqa");

var $cLeS9 = parcelRequire("cLeS9");
parcelRequire("2UWva");
var $eJOg2 = parcelRequire("eJOg2");

var $iOnyF = parcelRequire("iOnyF");
parcelRequire("7VjoF");
var $kgwv6 = parcelRequire("kgwv6");
function $54fee56ecd406849$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $4xyqa.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $54fee56ecd406849$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $54fee56ecd406849$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $eJOg2.IntlMessageFormat).formats;
    return (0, $4xyqa.__assign)((0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, mfFormats), f1), {
        date: $54fee56ecd406849$var$deepMergeOptions($54fee56ecd406849$var$setTimeZoneInOptions(mfFormats.date, timeZone), $54fee56ecd406849$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $54fee56ecd406849$var$deepMergeOptions($54fee56ecd406849$var$setTimeZoneInOptions(mfFormats.time, timeZone), $54fee56ecd406849$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $54fee56ecd406849$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $cLeS9.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $kgwv6.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, defaultRichTextElements), values || {});
    formats = $54fee56ecd406849$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $54fee56ecd406849$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $iOnyF.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $iOnyF.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $4xyqa.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iOnyF.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iOnyF.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});
parcelRegister("cLeS9", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $94a5692bcd9cda39$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $94a5692bcd9cda39$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $94a5692bcd9cda39$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $94a5692bcd9cda39$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $94a5692bcd9cda39$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $94a5692bcd9cda39$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $94a5692bcd9cda39$export$3fae2929ed23c202(map, pl, field) {
    return $94a5692bcd9cda39$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $94a5692bcd9cda39$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $94a5692bcd9cda39$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $94a5692bcd9cda39$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $94a5692bcd9cda39$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $94a5692bcd9cda39$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $94a5692bcd9cda39$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});


parcelRegister("g9t38", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $bc240537dde6f155$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $bc240537dde6f155$export$6f284aad1934db69; });

var $4xyqa = parcelRequire("4xyqa");

var $5jRl7 = parcelRequire("5jRl7");

var $4ksLn = parcelRequire("4ksLn");

var $iOnyF = parcelRequire("iOnyF");
var $bc240537dde6f155$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $bc240537dde6f155$var$now = Date.now();
function $bc240537dde6f155$var$generateToken(i) {
    return "".concat($bc240537dde6f155$var$now, "_").concat(i, "_").concat($bc240537dde6f155$var$now);
}
function $bc240537dde6f155$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $bc240537dde6f155$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $bc240537dde6f155$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $4ksLn.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $4ksLn.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5jRl7.filterProps)(options, $bc240537dde6f155$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $bc240537dde6f155$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $iOnyF.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("2t9V9", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $1cc5fc43947a1418$export$62fe1a4d9e891fa2; });

var $5jRl7 = parcelRequire("5jRl7");

var $4ksLn = parcelRequire("4ksLn");

var $iOnyF = parcelRequire("iOnyF");
var $1cc5fc43947a1418$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $1cc5fc43947a1418$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $4ksLn.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $4ksLn.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5jRl7.filterProps)(options, $1cc5fc43947a1418$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $iOnyF.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});


parcelRegister("63AeI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $468f21a8259c4ab8$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $468f21a8259c4ab8$export$cfec03d26465fa63; });

var $4xyqa = parcelRequire("4xyqa");

var $6uYXW = parcelRequire("6uYXW");

var $kedHh = parcelRequire("kedHh");

var $5jRl7 = parcelRequire("5jRl7");
function $468f21a8259c4ab8$export$45c4bbf6e55bba1f(intl) {
    (0, $kedHh.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $468f21a8259c4ab8$export$b52f8d6fc0d47415 = (0, $4xyqa.__assign)((0, $4xyqa.__assign)({}, (0, $5jRl7.DEFAULT_INTL_CONFIG)), {
    textComponent: $6uYXW.Fragment
});
function $468f21a8259c4ab8$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($6uYXW.Children.toArray(parts));
    };
}
function $468f21a8259c4ab8$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("kedHh", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $eb9fbd6e13c346a4$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $eb9fbd6e13c346a4$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $eb9fbd6e13c346a4$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $eb9fbd6e13c346a4$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $eb9fbd6e13c346a4$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $eb9fbd6e13c346a4$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $eb9fbd6e13c346a4$export$3fae2929ed23c202(map, pl, field) {
    return $eb9fbd6e13c346a4$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $eb9fbd6e13c346a4$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $eb9fbd6e13c346a4$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $eb9fbd6e13c346a4$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $eb9fbd6e13c346a4$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $eb9fbd6e13c346a4$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $eb9fbd6e13c346a4$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});



parcelRegister("cykUx", function(module, exports) {

$parcel$export(module.exports, "isRTLLayout", function () { return $67f7ed1e6e8fcb49$export$d66146dd16d03b14; });
$parcel$export(module.exports, "findBestAvailableLanguage", function () { return $67f7ed1e6e8fcb49$export$51e9e47e72e51afd; });
const $67f7ed1e6e8fcb49$var$USES_RTL_LAYOUT = [
    "ar",
    "ckb",
    "fa",
    "he",
    "ks",
    "lrc",
    "mzn",
    "ps",
    "ug",
    "ur",
    "yi"
];
const $67f7ed1e6e8fcb49$export$d66146dd16d03b14 = (locale)=>{
    const [languageCode] = locale.replace("_", "-").split("-");
    return $67f7ed1e6e8fcb49$var$USES_RTL_LAYOUT.includes(languageCode);
};
function $67f7ed1e6e8fcb49$var$ensureCountryCode(countryCode) {
    return countryCode === "419" ? "UN" : countryCode.toUpperCase();
}
function $67f7ed1e6e8fcb49$var$splitLanguageTag(languageTag) {
    const [languageCode, countryCode] = languageTag.split("-");
    return {
        languageCode: languageCode,
        countryCode: countryCode
    };
}
function $67f7ed1e6e8fcb49$var$getDefaultCountry() {
    const { languages: languages } = navigator;
    for(let i = 0; i < languages.length; i++){
        const { countryCode: countryCode } = $67f7ed1e6e8fcb49$var$splitLanguageTag(languages[i]);
        if (countryCode) return $67f7ed1e6e8fcb49$var$ensureCountryCode(countryCode);
    }
    return "US";
}
const $67f7ed1e6e8fcb49$var$defaultMainCountries = {
    ar: "MA",
    cs: "CZ",
    da: "DK",
    de: "DE",
    el: "GR",
    en: "US",
    es: "ES",
    et: "EE",
    fa: "IR",
    fr: "FR",
    he: "IL",
    hi: "IN",
    hr: "HR",
    hu: "HU",
    hy: "AM",
    id: "ID",
    is: "IS",
    it: "IT",
    ja: "JP",
    ka: "GE",
    nl: "NL",
    no: "NO",
    pl: "PL",
    pt: "PT",
    ro: "RO",
    ru: "RU",
    sk: "SK",
    sl: "SI",
    sv: "SE",
    tr: "TR",
    uk: "UA",
    vi: "VN",
    zh: "CN"
};
function $67f7ed1e6e8fcb49$var$getCountry(languageCode) {
    return $67f7ed1e6e8fcb49$var$defaultMainCountries[languageCode];
}
function $67f7ed1e6e8fcb49$var$convertLanguageTagToLocale(languageTag, countryCodeFallback) {
    let { languageCode: languageCode, countryCode: countryCode } = $67f7ed1e6e8fcb49$var$splitLanguageTag(languageTag);
    languageCode = languageCode.toLowerCase();
    countryCode = $67f7ed1e6e8fcb49$var$ensureCountryCode(countryCode || $67f7ed1e6e8fcb49$var$getCountry(languageCode) || countryCodeFallback);
    return {
        languageCode: languageCode,
        countryCode: countryCode,
        languageTag: `${languageCode}-${countryCode}`,
        isRTL: $67f7ed1e6e8fcb49$var$USES_RTL_LAYOUT.includes(languageCode)
    };
}
function $67f7ed1e6e8fcb49$var$getLocales() {
    const { languages: languages } = navigator;
    const countryCode = $67f7ed1e6e8fcb49$var$getDefaultCountry();
    const cache = [];
    const locales = [];
    languages.forEach((language)=>{
        const locale = $67f7ed1e6e8fcb49$var$convertLanguageTagToLocale(language, countryCode);
        if (cache.indexOf(locale.languageTag) === -1) {
            locales.push(locale);
            cache.push(locale.languageTag);
        }
    });
    return locales;
}
function $67f7ed1e6e8fcb49$var$getPartialTag({ languageCode: languageCode, scriptCode: scriptCode }) {
    return languageCode + (scriptCode ? "-" + scriptCode : "");
}
function $67f7ed1e6e8fcb49$export$51e9e47e72e51afd(languageTags) {
    const locales = $67f7ed1e6e8fcb49$var$getLocales();
    for(let i = 0; i < locales.length; i++){
        const currentLocale = locales[i];
        const { languageTag: languageTag, languageCode: languageCode, isRTL: isRTL } = currentLocale;
        if (languageTags.includes(languageTag)) return {
            languageTag: languageTag,
            isRTL: isRTL
        };
        const partial = $67f7ed1e6e8fcb49$var$getPartialTag(currentLocale);
        const next = locales[i + 1];
        if ((!next || partial !== $67f7ed1e6e8fcb49$var$getPartialTag(next)) && languageTags.includes(partial)) return {
            languageTag: partial,
            isRTL: isRTL
        };
        if ((!next || languageCode !== next.languageCode) && languageTags.includes(languageCode)) return {
            languageTag: languageCode,
            isRTL: isRTL
        };
    }
}

});


parcelRegister("gztWX", function(module, exports) {

$parcel$export(module.exports, "I18NService", function () { return $2a8d30bd3ae0bfbe$export$884fb88d482880be; });

var $6JVVB = parcelRequire("6JVVB");
class $2a8d30bd3ae0bfbe$export$884fb88d482880be {
    constructor(apiService){
        this.apiService = apiService;
    }
    async fetchTranslations(locale) {
        try {
            const response = await this.apiService.instance.get("/translations", {
                params: {
                    applicationId: "mwallet",
                    langs: [
                        locale
                    ]
                }
            });
            return response.data;
        } catch (e) {
            (0, $6JVVB.logger).warn("I18NService", "Failed to fetch translations", e);
            throw e;
        }
    }
}

});

parcelRegister("kRPgC", function(module, exports) {

$parcel$export(module.exports, "I18NStore", function () { return $bd24e4249a7786d4$export$4fc54ca96db279c8; });

var $3Ersk = parcelRequire("3Ersk");
class $bd24e4249a7786d4$export$4fc54ca96db279c8 {
    constructor(){
        this.localeTag = new (0, $3Ersk.Observable)("en_US");
    }
}

});

parcelRegister("9McIA", function(module, exports) {

$parcel$export(module.exports, "ApiService", function () { return $d9912065a234f9fa$export$ae14c375fc93363; });
parcelRequire("ix4Sq");
var $51oiE = parcelRequire("51oiE");

var $2SVrO = parcelRequire("2SVrO");

var $01zXo = parcelRequire("01zXo");

var $76Kw8 = parcelRequire("76Kw8");

var $hYOFB = parcelRequire("hYOFB");

var $aKQUN = parcelRequire("aKQUN");

var $iEpXQ = parcelRequire("iEpXQ");

var $eUi4d = parcelRequire("eUi4d");

var $iP77T = parcelRequire("iP77T");

var $hNHUm = parcelRequire("hNHUm");

var $4MyHt = parcelRequire("4MyHt");
class $d9912065a234f9fa$export$ae14c375fc93363 {
    constructor(errorStore, authenticationManager, customUserAgentService, i18NStore, securedCookiesService, debugIntercept){
        this.errorStore = errorStore;
        this.authenticationManager = authenticationManager;
        this.customUserAgentService = customUserAgentService;
        this.i18NStore = i18NStore;
        this.securedCookiesService = securedCookiesService;
        this.debugIntercept = debugIntercept;
        this.instance = (0, $51oiE.default).create({
            timeout: (0, $2SVrO.API_TIMEOUT_MS)
        });
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hNHUm.addRequestLogInterceptor)());
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hYOFB.addBaseUrlInterceptor)());
        if (this.securedCookiesService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $aKQUN.addSecuredCookieInterceptor)(this.securedCookiesService));
        if (this.customUserAgentService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $iEpXQ.addUserAgentInterceptor)(this.customUserAgentService));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $76Kw8.addAuthorizationInterceptor)(this.authenticationManager, this.securedCookiesService));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $01zXo.addAcceptLanguageInterceptor)(this.i18NStore));
        if (this.debugIntercept) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $eUi4d.debugResponseInterceptor)(this.debugIntercept));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $4MyHt.logResponseInterceptor));
        this.instance.interceptors.response.use((response)=>response, (error)=>{
            if (error.response && error.response.status === 429 || error.code == "ERR_NETWORK") this.errorStore.error.set(error);
            return Promise.reject(error);
        });
    }
}

});
parcelRegister("ix4Sq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("51oiE")).default; });

var $51oiE = parcelRequire("51oiE");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $d7df1784dcfb62bb$export$1c00760e9e5a4e95, AxiosError: $d7df1784dcfb62bb$export$c1fbed17c2f6a328, CanceledError: $d7df1784dcfb62bb$export$1ab0c6b20d94fa14, isCancel: $d7df1784dcfb62bb$export$3b22524397b493c6, CancelToken: $d7df1784dcfb62bb$export$fd08e3cb425f0d61, VERSION: $d7df1784dcfb62bb$export$a4ad2735b021c132, all: $d7df1784dcfb62bb$export$84bf76cd7afc7469, Cancel: $d7df1784dcfb62bb$export$848c9b7ead0df967, isAxiosError: $d7df1784dcfb62bb$export$fbafdbe06a5b5a9a, spread: $d7df1784dcfb62bb$export$3ae0fd4797ed47c8, toFormData: $d7df1784dcfb62bb$export$10ae0d317ea97f8b, AxiosHeaders: $d7df1784dcfb62bb$export$4e7d6ff0f3e6520, HttpStatusCode: $d7df1784dcfb62bb$export$a972f69c851492b3, formToJSON: $d7df1784dcfb62bb$export$86d7c59254d6a2c9, getAdapter: $d7df1784dcfb62bb$export$17ddc20a97d669e2, mergeConfig: $d7df1784dcfb62bb$export$7ec1ebcfa9d8bd6a } = (0, $51oiE.default);

});
parcelRegister("51oiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a7fe52a8cf7806b$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $2p35b = parcelRequire("2p35b");

var $dtJBM = parcelRequire("dtJBM");

var $aK4zo = parcelRequire("aK4zo");

var $el4I6 = parcelRequire("el4I6");

var $e8ica = parcelRequire("e8ica");

var $dqGYi = parcelRequire("dqGYi");

var $cVaqw = parcelRequire("cVaqw");

var $ew887 = parcelRequire("ew887");

var $gV8y1 = parcelRequire("gV8y1");

var $nicrs = parcelRequire("nicrs");

var $eT7G0 = parcelRequire("eT7G0");

var $gPA3n = parcelRequire("gPA3n");

var $5npTQ = parcelRequire("5npTQ");

var $dntH2 = parcelRequire("dntH2");

var $fbMHn = parcelRequire("fbMHn");

var $9Zvhb = parcelRequire("9Zvhb");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $3a7fe52a8cf7806b$var$createInstance(defaultConfig) {
    const context = new (0, $dtJBM.default)(defaultConfig);
    const instance = (0, $2p35b.default)((0, $dtJBM.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $cWqj5.default).extend(instance, (0, $dtJBM.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $cWqj5.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $3a7fe52a8cf7806b$var$createInstance((0, $aK4zo.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $3a7fe52a8cf7806b$var$axios = $3a7fe52a8cf7806b$var$createInstance((0, $el4I6.default));
// Expose Axios class to allow class inheritance
$3a7fe52a8cf7806b$var$axios.Axios = (0, $dtJBM.default);
// Expose Cancel & CancelToken
$3a7fe52a8cf7806b$var$axios.CanceledError = (0, $dqGYi.default);
$3a7fe52a8cf7806b$var$axios.CancelToken = (0, $cVaqw.default);
$3a7fe52a8cf7806b$var$axios.isCancel = (0, $ew887.default);
$3a7fe52a8cf7806b$var$axios.VERSION = (0, $gV8y1.VERSION);
$3a7fe52a8cf7806b$var$axios.toFormData = (0, $nicrs.default);
// Expose AxiosError class
$3a7fe52a8cf7806b$var$axios.AxiosError = (0, $eT7G0.default);
// alias for CanceledError for backward compatibility
$3a7fe52a8cf7806b$var$axios.Cancel = $3a7fe52a8cf7806b$var$axios.CanceledError;
// Expose all/spread
$3a7fe52a8cf7806b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$3a7fe52a8cf7806b$var$axios.spread = (0, $gPA3n.default);
// Expose isAxiosError
$3a7fe52a8cf7806b$var$axios.isAxiosError = (0, $5npTQ.default);
// Expose mergeConfig
$3a7fe52a8cf7806b$var$axios.mergeConfig = (0, $aK4zo.default);
$3a7fe52a8cf7806b$var$axios.AxiosHeaders = (0, $dntH2.default);
$3a7fe52a8cf7806b$var$axios.formToJSON = (thing)=>(0, $e8ica.default)((0, $cWqj5.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$3a7fe52a8cf7806b$var$axios.getAdapter = (0, $fbMHn.default).getAdapter;
$3a7fe52a8cf7806b$var$axios.HttpStatusCode = (0, $9Zvhb.default);
$3a7fe52a8cf7806b$var$axios.default = $3a7fe52a8cf7806b$var$axios;
var // this module should only have a default export
$3a7fe52a8cf7806b$export$2e2bcd8739ae039 = $3a7fe52a8cf7806b$var$axios;

});
parcelRegister("cWqj5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96bf4ecd87681c49$export$2e2bcd8739ae039; });

var $2p35b = parcelRequire("2p35b");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $96bf4ecd87681c49$var$toString } = Object.prototype;
const { getPrototypeOf: $96bf4ecd87681c49$var$getPrototypeOf } = Object;
const { iterator: $96bf4ecd87681c49$var$iterator, toStringTag: $96bf4ecd87681c49$var$toStringTag } = Symbol;
const $96bf4ecd87681c49$var$kindOf = ((cache)=>(thing)=>{
        const str = $96bf4ecd87681c49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $96bf4ecd87681c49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$96bf4ecd87681c49$var$kindOf(thing) === type;
};
const $96bf4ecd87681c49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $96bf4ecd87681c49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $96bf4ecd87681c49$var$isUndefined = $96bf4ecd87681c49$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $96bf4ecd87681c49$var$isBuffer(val) {
    return val !== null && !$96bf4ecd87681c49$var$isUndefined(val) && val.constructor !== null && !$96bf4ecd87681c49$var$isUndefined(val.constructor) && $96bf4ecd87681c49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $96bf4ecd87681c49$var$isArrayBuffer = $96bf4ecd87681c49$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $96bf4ecd87681c49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $96bf4ecd87681c49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $96bf4ecd87681c49$var$isString = $96bf4ecd87681c49$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $96bf4ecd87681c49$var$isFunction = $96bf4ecd87681c49$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $96bf4ecd87681c49$var$isNumber = $96bf4ecd87681c49$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $96bf4ecd87681c49$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $96bf4ecd87681c49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $96bf4ecd87681c49$var$isPlainObject = (val)=>{
    if ($96bf4ecd87681c49$var$kindOf(val) !== 'object') return false;
    const prototype = $96bf4ecd87681c49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($96bf4ecd87681c49$var$toStringTag in val) && !($96bf4ecd87681c49$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $96bf4ecd87681c49$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$96bf4ecd87681c49$var$isObject(val) || $96bf4ecd87681c49$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $96bf4ecd87681c49$var$isDate = $96bf4ecd87681c49$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $96bf4ecd87681c49$var$isFile = $96bf4ecd87681c49$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $96bf4ecd87681c49$var$isBlob = $96bf4ecd87681c49$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $96bf4ecd87681c49$var$isFileList = $96bf4ecd87681c49$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $96bf4ecd87681c49$var$isStream = (val)=>$96bf4ecd87681c49$var$isObject(val) && $96bf4ecd87681c49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $96bf4ecd87681c49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $96bf4ecd87681c49$var$isFunction(thing.append) && ((kind = $96bf4ecd87681c49$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $96bf4ecd87681c49$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $96bf4ecd87681c49$var$isURLSearchParams = $96bf4ecd87681c49$var$kindOfTest('URLSearchParams');
const [$96bf4ecd87681c49$var$isReadableStream, $96bf4ecd87681c49$var$isRequest, $96bf4ecd87681c49$var$isResponse, $96bf4ecd87681c49$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($96bf4ecd87681c49$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $96bf4ecd87681c49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $96bf4ecd87681c49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($96bf4ecd87681c49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($96bf4ecd87681c49$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $96bf4ecd87681c49$var$findKey(obj, key) {
    if ($96bf4ecd87681c49$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $96bf4ecd87681c49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $96bf4ecd87681c49$var$isContextDefined = (context)=>!$96bf4ecd87681c49$var$isUndefined(context) && context !== $96bf4ecd87681c49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $96bf4ecd87681c49$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $96bf4ecd87681c49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $96bf4ecd87681c49$var$findKey(result, key) || key;
        if ($96bf4ecd87681c49$var$isPlainObject(result[targetKey]) && $96bf4ecd87681c49$var$isPlainObject(val)) result[targetKey] = $96bf4ecd87681c49$var$merge(result[targetKey], val);
        else if ($96bf4ecd87681c49$var$isPlainObject(val)) result[targetKey] = $96bf4ecd87681c49$var$merge({}, val);
        else if ($96bf4ecd87681c49$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$96bf4ecd87681c49$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $96bf4ecd87681c49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $96bf4ecd87681c49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $96bf4ecd87681c49$var$forEach(b, (val, key)=>{
        if (thisArg && $96bf4ecd87681c49$var$isFunction(val)) a[key] = (0, $2p35b.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $96bf4ecd87681c49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $96bf4ecd87681c49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $96bf4ecd87681c49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $96bf4ecd87681c49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $96bf4ecd87681c49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $96bf4ecd87681c49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($96bf4ecd87681c49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$96bf4ecd87681c49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $96bf4ecd87681c49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $96bf4ecd87681c49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $96bf4ecd87681c49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$96bf4ecd87681c49$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $96bf4ecd87681c49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $96bf4ecd87681c49$var$isHTMLForm = $96bf4ecd87681c49$var$kindOfTest('HTMLFormElement');
const $96bf4ecd87681c49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $96bf4ecd87681c49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $96bf4ecd87681c49$var$isRegExp = $96bf4ecd87681c49$var$kindOfTest('RegExp');
const $96bf4ecd87681c49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $96bf4ecd87681c49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $96bf4ecd87681c49$var$freezeMethods = (obj)=>{
    $96bf4ecd87681c49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($96bf4ecd87681c49$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$96bf4ecd87681c49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $96bf4ecd87681c49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $96bf4ecd87681c49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $96bf4ecd87681c49$var$noop = ()=>{};
const $96bf4ecd87681c49$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $96bf4ecd87681c49$var$isSpecCompliantForm(thing) {
    return !!(thing && $96bf4ecd87681c49$var$isFunction(thing.append) && thing[$96bf4ecd87681c49$var$toStringTag] === 'FormData' && thing[$96bf4ecd87681c49$var$iterator]);
}
const $96bf4ecd87681c49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($96bf4ecd87681c49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($96bf4ecd87681c49$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $96bf4ecd87681c49$var$isArray(source) ? [] : {};
                $96bf4ecd87681c49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$96bf4ecd87681c49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $96bf4ecd87681c49$var$isAsyncFn = $96bf4ecd87681c49$var$kindOfTest('AsyncFunction');
const $96bf4ecd87681c49$var$isThenable = (thing)=>thing && ($96bf4ecd87681c49$var$isObject(thing) || $96bf4ecd87681c49$var$isFunction(thing)) && $96bf4ecd87681c49$var$isFunction(thing.then) && $96bf4ecd87681c49$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $96bf4ecd87681c49$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $96bf4ecd87681c49$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $96bf4ecd87681c49$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $96bf4ecd87681c49$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $96bf4ecd87681c49$var$isFunction($96bf4ecd87681c49$var$_global.postMessage));
const $96bf4ecd87681c49$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($96bf4ecd87681c49$var$_global) : $96bf4ecd87681c49$var$_setImmediate;
// *********************
const $96bf4ecd87681c49$var$isIterable = (thing)=>thing != null && $96bf4ecd87681c49$var$isFunction(thing[$96bf4ecd87681c49$var$iterator]);
var $96bf4ecd87681c49$export$2e2bcd8739ae039 = {
    isArray: $96bf4ecd87681c49$var$isArray,
    isArrayBuffer: $96bf4ecd87681c49$var$isArrayBuffer,
    isBuffer: $96bf4ecd87681c49$var$isBuffer,
    isFormData: $96bf4ecd87681c49$var$isFormData,
    isArrayBufferView: $96bf4ecd87681c49$var$isArrayBufferView,
    isString: $96bf4ecd87681c49$var$isString,
    isNumber: $96bf4ecd87681c49$var$isNumber,
    isBoolean: $96bf4ecd87681c49$var$isBoolean,
    isObject: $96bf4ecd87681c49$var$isObject,
    isPlainObject: $96bf4ecd87681c49$var$isPlainObject,
    isEmptyObject: $96bf4ecd87681c49$var$isEmptyObject,
    isReadableStream: $96bf4ecd87681c49$var$isReadableStream,
    isRequest: $96bf4ecd87681c49$var$isRequest,
    isResponse: $96bf4ecd87681c49$var$isResponse,
    isHeaders: $96bf4ecd87681c49$var$isHeaders,
    isUndefined: $96bf4ecd87681c49$var$isUndefined,
    isDate: $96bf4ecd87681c49$var$isDate,
    isFile: $96bf4ecd87681c49$var$isFile,
    isBlob: $96bf4ecd87681c49$var$isBlob,
    isRegExp: $96bf4ecd87681c49$var$isRegExp,
    isFunction: $96bf4ecd87681c49$var$isFunction,
    isStream: $96bf4ecd87681c49$var$isStream,
    isURLSearchParams: $96bf4ecd87681c49$var$isURLSearchParams,
    isTypedArray: $96bf4ecd87681c49$var$isTypedArray,
    isFileList: $96bf4ecd87681c49$var$isFileList,
    forEach: $96bf4ecd87681c49$var$forEach,
    merge: $96bf4ecd87681c49$var$merge,
    extend: $96bf4ecd87681c49$var$extend,
    trim: $96bf4ecd87681c49$var$trim,
    stripBOM: $96bf4ecd87681c49$var$stripBOM,
    inherits: $96bf4ecd87681c49$var$inherits,
    toFlatObject: $96bf4ecd87681c49$var$toFlatObject,
    kindOf: $96bf4ecd87681c49$var$kindOf,
    kindOfTest: $96bf4ecd87681c49$var$kindOfTest,
    endsWith: $96bf4ecd87681c49$var$endsWith,
    toArray: $96bf4ecd87681c49$var$toArray,
    forEachEntry: $96bf4ecd87681c49$var$forEachEntry,
    matchAll: $96bf4ecd87681c49$var$matchAll,
    isHTMLForm: $96bf4ecd87681c49$var$isHTMLForm,
    hasOwnProperty: $96bf4ecd87681c49$var$hasOwnProperty,
    hasOwnProp: $96bf4ecd87681c49$var$hasOwnProperty,
    reduceDescriptors: $96bf4ecd87681c49$var$reduceDescriptors,
    freezeMethods: $96bf4ecd87681c49$var$freezeMethods,
    toObjectSet: $96bf4ecd87681c49$var$toObjectSet,
    toCamelCase: $96bf4ecd87681c49$var$toCamelCase,
    noop: $96bf4ecd87681c49$var$noop,
    toFiniteNumber: $96bf4ecd87681c49$var$toFiniteNumber,
    findKey: $96bf4ecd87681c49$var$findKey,
    global: $96bf4ecd87681c49$var$_global,
    isContextDefined: $96bf4ecd87681c49$var$isContextDefined,
    isSpecCompliantForm: $96bf4ecd87681c49$var$isSpecCompliantForm,
    toJSONObject: $96bf4ecd87681c49$var$toJSONObject,
    isAsyncFn: $96bf4ecd87681c49$var$isAsyncFn,
    isThenable: $96bf4ecd87681c49$var$isThenable,
    setImmediate: $96bf4ecd87681c49$var$_setImmediate,
    asap: $96bf4ecd87681c49$var$asap,
    isIterable: $96bf4ecd87681c49$var$isIterable
};

});
parcelRegister("2p35b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c004eb3eb783df1$export$2e2bcd8739ae039; });
'use strict';
function $1c004eb3eb783df1$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("dtJBM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d015caea9a29454$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $jmR4Z = parcelRequire("jmR4Z");

var $eCYEu = parcelRequire("eCYEu");

var $l5nvP = parcelRequire("l5nvP");

var $aK4zo = parcelRequire("aK4zo");

var $a59GD = parcelRequire("a59GD");

var $d2LaV = parcelRequire("d2LaV");

var $dntH2 = parcelRequire("dntH2");
'use strict';
const $9d015caea9a29454$var$validators = (0, $d2LaV.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $9d015caea9a29454$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $eCYEu.default)(),
            response: new (0, $eCYEu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $aK4zo.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $d2LaV.default).assertOptions(transitional, {
            silentJSONParsing: $9d015caea9a29454$var$validators.transitional($9d015caea9a29454$var$validators.boolean),
            forcedJSONParsing: $9d015caea9a29454$var$validators.transitional($9d015caea9a29454$var$validators.boolean),
            clarifyTimeoutError: $9d015caea9a29454$var$validators.transitional($9d015caea9a29454$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $cWqj5.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $d2LaV.default).assertOptions(paramsSerializer, {
                encode: $9d015caea9a29454$var$validators.function,
                serialize: $9d015caea9a29454$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $d2LaV.default).assertOptions(config, {
            baseUrl: $9d015caea9a29454$var$validators.spelling('baseURL'),
            withXsrfToken: $9d015caea9a29454$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $cWqj5.default).merge(headers.common, headers[config.method]);
        headers && (0, $cWqj5.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $dntH2.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $l5nvP.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $l5nvP.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $aK4zo.default)(this.defaults, config);
        const fullPath = (0, $a59GD.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $jmR4Z.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $cWqj5.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9d015caea9a29454$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $aK4zo.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $cWqj5.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $aK4zo.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $9d015caea9a29454$var$Axios.prototype[method] = generateHTTPMethod();
    $9d015caea9a29454$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $9d015caea9a29454$export$2e2bcd8739ae039 = $9d015caea9a29454$var$Axios;

});
parcelRegister("jmR4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1993edaebf31f88$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $3mfLa = parcelRequire("3mfLa");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $e1993edaebf31f88$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $e1993edaebf31f88$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $e1993edaebf31f88$var$encode;
    if ((0, $cWqj5.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $cWqj5.default).isURLSearchParams(params) ? params.toString() : new (0, $3mfLa.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("3mfLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $271fa6b9caa4f02d$export$2e2bcd8739ae039; });

var $nicrs = parcelRequire("nicrs");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $271fa6b9caa4f02d$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $271fa6b9caa4f02d$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $nicrs.default)(params, this, options);
}
const $271fa6b9caa4f02d$var$prototype = $271fa6b9caa4f02d$var$AxiosURLSearchParams.prototype;
$271fa6b9caa4f02d$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$271fa6b9caa4f02d$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $271fa6b9caa4f02d$var$encode);
    } : $271fa6b9caa4f02d$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $271fa6b9caa4f02d$export$2e2bcd8739ae039 = $271fa6b9caa4f02d$var$AxiosURLSearchParams;

});
parcelRegister("nicrs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0460442c5e4d0eef$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $eT7G0 = parcelRequire("eT7G0");

var $cNh2u = parcelRequire("cNh2u");

var $b0kMB = parcelRequire("b0kMB");
var $0460442c5e4d0eef$require$Buffer = $b0kMB.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0460442c5e4d0eef$var$isVisitable(thing) {
    return (0, $cWqj5.default).isPlainObject(thing) || (0, $cWqj5.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0460442c5e4d0eef$var$removeBrackets(key) {
    return (0, $cWqj5.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0460442c5e4d0eef$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0460442c5e4d0eef$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0460442c5e4d0eef$var$isFlatArray(arr) {
    return (0, $cWqj5.default).isArray(arr) && !arr.some($0460442c5e4d0eef$var$isVisitable);
}
const $0460442c5e4d0eef$var$predicates = (0, $cWqj5.default).toFlatObject((0, $cWqj5.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0460442c5e4d0eef$var$toFormData(obj, formData, options) {
    if (!(0, $cWqj5.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $cNh2u.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $cWqj5.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $cWqj5.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $cWqj5.default).isSpecCompliantForm(formData);
    if (!(0, $cWqj5.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $cWqj5.default).isDate(value)) return value.toISOString();
        if ((0, $cWqj5.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $cWqj5.default).isBlob(value)) throw new (0, $eT7G0.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $cWqj5.default).isArrayBuffer(value) || (0, $cWqj5.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $0460442c5e4d0eef$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $cWqj5.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $cWqj5.default).isArray(value) && $0460442c5e4d0eef$var$isFlatArray(value) || ((0, $cWqj5.default).isFileList(value) || (0, $cWqj5.default).endsWith(key, '[]')) && (arr = (0, $cWqj5.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0460442c5e4d0eef$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $cWqj5.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0460442c5e4d0eef$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($0460442c5e4d0eef$var$isVisitable(value)) return true;
        formData.append($0460442c5e4d0eef$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0460442c5e4d0eef$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0460442c5e4d0eef$var$isVisitable
    });
    function build(value, path) {
        if ((0, $cWqj5.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $cWqj5.default).forEach(value, function each(el, key) {
            const result = !((0, $cWqj5.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $cWqj5.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $cWqj5.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $0460442c5e4d0eef$export$2e2bcd8739ae039 = $0460442c5e4d0eef$var$toFormData;

});
parcelRegister("eT7G0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad6c282166e6c43d$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ad6c282166e6c43d$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $cWqj5.default).inherits($ad6c282166e6c43d$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $cWqj5.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $ad6c282166e6c43d$var$prototype = $ad6c282166e6c43d$var$AxiosError.prototype;
const $ad6c282166e6c43d$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $ad6c282166e6c43d$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ad6c282166e6c43d$var$AxiosError, $ad6c282166e6c43d$var$descriptors);
Object.defineProperty($ad6c282166e6c43d$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$ad6c282166e6c43d$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ad6c282166e6c43d$var$prototype);
    (0, $cWqj5.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $ad6c282166e6c43d$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ad6c282166e6c43d$export$2e2bcd8739ae039 = $ad6c282166e6c43d$var$AxiosError;

});

parcelRegister("cNh2u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9507473dc3236b04$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $9507473dc3236b04$export$2e2bcd8739ae039 = null;

});




parcelRegister("eCYEu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa63a98a0047561b$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");
'use strict';
class $aa63a98a0047561b$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $cWqj5.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $aa63a98a0047561b$export$2e2bcd8739ae039 = $aa63a98a0047561b$var$InterceptorManager;

});

parcelRegister("l5nvP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f59c4da7c686563f$export$2e2bcd8739ae039; });

var $1mhQS = parcelRequire("1mhQS");

var $ew887 = parcelRequire("ew887");

var $el4I6 = parcelRequire("el4I6");

var $dqGYi = parcelRequire("dqGYi");

var $dntH2 = parcelRequire("dntH2");

var $fbMHn = parcelRequire("fbMHn");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f59c4da7c686563f$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dqGYi.default)(null, config);
}
function $f59c4da7c686563f$export$2e2bcd8739ae039(config) {
    $f59c4da7c686563f$var$throwIfCancellationRequested(config);
    config.headers = (0, $dntH2.default).from(config.headers);
    // Transform request data
    config.data = (0, $1mhQS.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $fbMHn.default).getAdapter(config.adapter || (0, $el4I6.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $f59c4da7c686563f$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $1mhQS.default).call(config, config.transformResponse, response);
        response.headers = (0, $dntH2.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ew887.default)(reason)) {
            $f59c4da7c686563f$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $1mhQS.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $dntH2.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("1mhQS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fd5b188ce25bfb6$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $el4I6 = parcelRequire("el4I6");

var $dntH2 = parcelRequire("dntH2");
'use strict';
function $0fd5b188ce25bfb6$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $el4I6.default);
    const context = response || config;
    const headers = (0, $dntH2.default).from(context.headers);
    let data = context.data;
    (0, $cWqj5.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("el4I6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a706ae374901563f$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $eT7G0 = parcelRequire("eT7G0");

var $9pWSW = parcelRequire("9pWSW");

var $nicrs = parcelRequire("nicrs");

var $fCRSO = parcelRequire("fCRSO");

var $6c9IQ = parcelRequire("6c9IQ");

var $e8ica = parcelRequire("e8ica");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a706ae374901563f$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $cWqj5.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $cWqj5.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a706ae374901563f$var$defaults = {
    transitional: (0, $9pWSW.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $cWqj5.default).isObject(data);
            if (isObjectPayload && (0, $cWqj5.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $cWqj5.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $e8ica.default)(data)) : data;
            if ((0, $cWqj5.default).isArrayBuffer(data) || (0, $cWqj5.default).isBuffer(data) || (0, $cWqj5.default).isStream(data) || (0, $cWqj5.default).isFile(data) || (0, $cWqj5.default).isBlob(data) || (0, $cWqj5.default).isReadableStream(data)) return data;
            if ((0, $cWqj5.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $cWqj5.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $fCRSO.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $cWqj5.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $nicrs.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a706ae374901563f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a706ae374901563f$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $cWqj5.default).isResponse(data) || (0, $cWqj5.default).isReadableStream(data)) return data;
            if (data && (0, $cWqj5.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $eT7G0.default).from(e, (0, $eT7G0.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $6c9IQ.default).classes.FormData,
        Blob: (0, $6c9IQ.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $cWqj5.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $a706ae374901563f$var$defaults.headers[method] = {};
});
var $a706ae374901563f$export$2e2bcd8739ae039 = $a706ae374901563f$var$defaults;

});
parcelRegister("9pWSW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6db42038762d90d3$export$2e2bcd8739ae039; });
'use strict';
var $6db42038762d90d3$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("fCRSO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b60433b467e8f345$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $nicrs = parcelRequire("nicrs");

var $6c9IQ = parcelRequire("6c9IQ");
'use strict';
function $b60433b467e8f345$export$2e2bcd8739ae039(data, options) {
    return (0, $nicrs.default)(data, new (0, $6c9IQ.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $6c9IQ.default).isNode && (0, $cWqj5.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("6c9IQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $482b67b2d3fa61b4$export$2e2bcd8739ae039; });

var $9XwbB = parcelRequire("9XwbB");

var $2k3QY = parcelRequire("2k3QY");
var $482b67b2d3fa61b4$export$2e2bcd8739ae039 = {
    ...$2k3QY,
    ...(0, $9XwbB.default)
};

});
parcelRegister("9XwbB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7402973c36ad2888$export$2e2bcd8739ae039; });

var $kM6xc = parcelRequire("kM6xc");

var $lE4Si = parcelRequire("lE4Si");

var $hdxzg = parcelRequire("hdxzg");
var $7402973c36ad2888$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $kM6xc.default,
        FormData: $lE4Si.default,
        Blob: $hdxzg.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("kM6xc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1fd5bf5f6af2f1b$export$2e2bcd8739ae039; });

var $3mfLa = parcelRequire("3mfLa");
'use strict';
var $f1fd5bf5f6af2f1b$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $3mfLa.default);

});

parcelRegister("lE4Si", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc211d65e2bf23ba$export$2e2bcd8739ae039; });
'use strict';
var $fc211d65e2bf23ba$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("hdxzg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c88db0704cf2a52f$export$2e2bcd8739ae039; });
'use strict';
var $c88db0704cf2a52f$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("2k3QY", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $1b10703c05bc4563$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $1b10703c05bc4563$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $1b10703c05bc4563$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $1b10703c05bc4563$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $1b10703c05bc4563$export$f710a83a91838a36; });
const $1b10703c05bc4563$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1b10703c05bc4563$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1b10703c05bc4563$export$c0bcc9250309d66 = $1b10703c05bc4563$export$c4996c4b7b93b0bf && (!$1b10703c05bc4563$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1b10703c05bc4563$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1b10703c05bc4563$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1b10703c05bc4563$export$f710a83a91838a36 = $1b10703c05bc4563$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("e8ica", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a49fed3c533ba4d1$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a49fed3c533ba4d1$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $cWqj5.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a49fed3c533ba4d1$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a49fed3c533ba4d1$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $cWqj5.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $cWqj5.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $cWqj5.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $cWqj5.default).isArray(target[name])) target[name] = $a49fed3c533ba4d1$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $cWqj5.default).isFormData(formData) && (0, $cWqj5.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $cWqj5.default).forEachEntry(formData, (name, value)=>{
            buildPath($a49fed3c533ba4d1$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a49fed3c533ba4d1$export$2e2bcd8739ae039 = $a49fed3c533ba4d1$var$formDataToJSON;

});


parcelRegister("dntH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bd474c9ee06b25a$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $eStZN = parcelRequire("eStZN");
'use strict';
const $9bd474c9ee06b25a$var$$internals = Symbol('internals');
function $9bd474c9ee06b25a$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $9bd474c9ee06b25a$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $cWqj5.default).isArray(value) ? value.map($9bd474c9ee06b25a$var$normalizeValue) : String(value);
}
function $9bd474c9ee06b25a$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $9bd474c9ee06b25a$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $9bd474c9ee06b25a$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $cWqj5.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $cWqj5.default).isString(value)) return;
    if ((0, $cWqj5.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $cWqj5.default).isRegExp(filter)) return filter.test(value);
}
function $9bd474c9ee06b25a$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $9bd474c9ee06b25a$var$buildAccessors(obj, header) {
    const accessorName = (0, $cWqj5.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $9bd474c9ee06b25a$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $9bd474c9ee06b25a$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $cWqj5.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $9bd474c9ee06b25a$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $cWqj5.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $cWqj5.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $cWqj5.default).isString(header) && (header = header.trim()) && !$9bd474c9ee06b25a$var$isValidHeaderName(header)) setHeaders((0, $eStZN.default)(header), valueOrRewrite);
        else if ((0, $cWqj5.default).isObject(header) && (0, $cWqj5.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $cWqj5.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $cWqj5.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $9bd474c9ee06b25a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cWqj5.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $9bd474c9ee06b25a$var$parseTokens(value);
                if ((0, $cWqj5.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $cWqj5.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $9bd474c9ee06b25a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cWqj5.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $9bd474c9ee06b25a$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $9bd474c9ee06b25a$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $cWqj5.default).findKey(self, _header);
                if (key && (!matcher || $9bd474c9ee06b25a$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $cWqj5.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $9bd474c9ee06b25a$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $cWqj5.default).forEach(this, (value, header)=>{
            const key = (0, $cWqj5.default).findKey(headers, header);
            if (key) {
                self[key] = $9bd474c9ee06b25a$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $9bd474c9ee06b25a$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $9bd474c9ee06b25a$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $cWqj5.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $cWqj5.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$9bd474c9ee06b25a$var$$internals] = this[$9bd474c9ee06b25a$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $9bd474c9ee06b25a$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $9bd474c9ee06b25a$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $cWqj5.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$9bd474c9ee06b25a$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $cWqj5.default).reduceDescriptors($9bd474c9ee06b25a$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $cWqj5.default).freezeMethods($9bd474c9ee06b25a$var$AxiosHeaders);
var $9bd474c9ee06b25a$export$2e2bcd8739ae039 = $9bd474c9ee06b25a$var$AxiosHeaders;

});
parcelRegister("eStZN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad4d605599f235a1$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $ad4d605599f235a1$var$ignoreDuplicateOf = (0, $cWqj5.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $ad4d605599f235a1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $ad4d605599f235a1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("ew887", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a91a5c4415fe8f73$export$2e2bcd8739ae039; });
'use strict';
function $a91a5c4415fe8f73$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dqGYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c6f095464d44aba$export$2e2bcd8739ae039; });

var $eT7G0 = parcelRequire("eT7G0");

var $cWqj5 = parcelRequire("cWqj5");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9c6f095464d44aba$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $eT7G0.default).call(this, message == null ? 'canceled' : message, (0, $eT7G0.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $cWqj5.default).inherits($9c6f095464d44aba$var$CanceledError, (0, $eT7G0.default), {
    __CANCEL__: true
});
var $9c6f095464d44aba$export$2e2bcd8739ae039 = $9c6f095464d44aba$var$CanceledError;

});

parcelRegister("fbMHn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0eda89ffc150414$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $cNh2u = parcelRequire("cNh2u");

var $hs4SE = parcelRequire("hs4SE");

var $5fCNL = parcelRequire("5fCNL");

var $eT7G0 = parcelRequire("eT7G0");
const $b0eda89ffc150414$var$knownAdapters = {
    http: (0, $cNh2u.default),
    xhr: (0, $hs4SE.default),
    fetch: {
        get: $5fCNL.getFetch
    }
};
(0, $cWqj5.default).forEach($b0eda89ffc150414$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $b0eda89ffc150414$var$renderReason = (reason)=>`- ${reason}`;
const $b0eda89ffc150414$var$isResolvedHandle = (adapter)=>(0, $cWqj5.default).isFunction(adapter) || adapter === null || adapter === false;
var $b0eda89ffc150414$export$2e2bcd8739ae039 = {
    getAdapter: (adapters, config)=>{
        adapters = (0, $cWqj5.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$b0eda89ffc150414$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $b0eda89ffc150414$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $eT7G0.default)(`Unknown adapter '${id}'`);
            }
            if (adapter && ((0, $cWqj5.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($b0eda89ffc150414$var$renderReason).join('\n') : ' ' + $b0eda89ffc150414$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $eT7G0.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $b0eda89ffc150414$var$knownAdapters
};

});
parcelRegister("hs4SE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb48d65dc7fd2148$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $eJfIB = parcelRequire("eJfIB");

var $9pWSW = parcelRequire("9pWSW");

var $eT7G0 = parcelRequire("eT7G0");

var $dqGYi = parcelRequire("dqGYi");

var $35nsA = parcelRequire("35nsA");

var $6c9IQ = parcelRequire("6c9IQ");

var $dntH2 = parcelRequire("dntH2");

var $jw9Hz = parcelRequire("jw9Hz");

var $mtfwf = parcelRequire("mtfwf");
const $cb48d65dc7fd2148$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $cb48d65dc7fd2148$export$2e2bcd8739ae039 = $cb48d65dc7fd2148$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $mtfwf.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $dntH2.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $dntH2.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $eJfIB.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $eT7G0.default)('Request aborted', (0, $eT7G0.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $eT7G0.default)(msg, (0, $eT7G0.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $9pWSW.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $eT7G0.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $eT7G0.default).ETIMEDOUT : (0, $eT7G0.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $cWqj5.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $cWqj5.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $jw9Hz.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $jw9Hz.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dqGYi.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $35nsA.default)(_config.url);
        if (protocol && (0, $6c9IQ.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $eT7G0.default)('Unsupported protocol ' + protocol + ':', (0, $eT7G0.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("eJfIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab9175fae9871e46$export$2e2bcd8739ae039; });

var $eT7G0 = parcelRequire("eT7G0");
'use strict';
function $ab9175fae9871e46$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $eT7G0.default)('Request failed with status code ' + response.status, [
        (0, $eT7G0.default).ERR_BAD_REQUEST,
        (0, $eT7G0.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("35nsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23f40965218f17e2$export$2e2bcd8739ae039; });
'use strict';
function $23f40965218f17e2$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("jw9Hz", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $e3588811115eff11$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $e3588811115eff11$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $e3588811115eff11$export$5d35863c355a22a9; });

var $1IDca = parcelRequire("1IDca");

var $6MzcG = parcelRequire("6MzcG");

var $cWqj5 = parcelRequire("cWqj5");
const $e3588811115eff11$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $1IDca.default)(50, 250);
    return (0, $6MzcG.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $e3588811115eff11$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $e3588811115eff11$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $cWqj5.default).asap(()=>fn(...args));

});
parcelRegister("1IDca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14084ddc7d7d1513$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $14084ddc7d7d1513$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $14084ddc7d7d1513$export$2e2bcd8739ae039 = $14084ddc7d7d1513$var$speedometer;

});

parcelRegister("6MzcG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f0288725be3e659$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $4f0288725be3e659$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $4f0288725be3e659$export$2e2bcd8739ae039 = $4f0288725be3e659$var$throttle;

});


parcelRegister("mtfwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0438be7e0fa7476f$export$2e2bcd8739ae039; });

var $6c9IQ = parcelRequire("6c9IQ");

var $cWqj5 = parcelRequire("cWqj5");

var $cJG1K = parcelRequire("cJG1K");

var $2CWwD = parcelRequire("2CWwD");

var $a59GD = parcelRequire("a59GD");

var $aK4zo = parcelRequire("aK4zo");

var $dntH2 = parcelRequire("dntH2");

var $jmR4Z = parcelRequire("jmR4Z");
var $0438be7e0fa7476f$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $aK4zo.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $dntH2.default).from(headers);
    newConfig.url = (0, $jmR4Z.default)((0, $a59GD.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $cWqj5.default).isFormData(data)) {
        if ((0, $6c9IQ.default).hasStandardBrowserEnv || (0, $6c9IQ.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $cWqj5.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $6c9IQ.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $cWqj5.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $cJG1K.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $2CWwD.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("cJG1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $945a49bbb414db81$export$2e2bcd8739ae039; });

var $6c9IQ = parcelRequire("6c9IQ");
var $945a49bbb414db81$export$2e2bcd8739ae039 = (0, $6c9IQ.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $6c9IQ.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $6c9IQ.default).origin), (0, $6c9IQ.default).navigator && /(msie|trident)/i.test((0, $6c9IQ.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("2CWwD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e9c874f84e57f14$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $6c9IQ = parcelRequire("6c9IQ");
var $1e9c874f84e57f14$export$2e2bcd8739ae039 = (0, $6c9IQ.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $cWqj5.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $cWqj5.default).isString(path) && cookie.push('path=' + path);
        (0, $cWqj5.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("a59GD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7571e290c6210b17$export$2e2bcd8739ae039; });

var $g0Vbl = parcelRequire("g0Vbl");

var $kSFPp = parcelRequire("kSFPp");
'use strict';
function $7571e290c6210b17$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $g0Vbl.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $kSFPp.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("g0Vbl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba8900928e0faf28$export$2e2bcd8739ae039; });
'use strict';
function $ba8900928e0faf28$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("kSFPp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3394c016e7ae517$export$2e2bcd8739ae039; });
'use strict';
function $f3394c016e7ae517$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("aK4zo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d21bec2a36f0740$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");

var $dntH2 = parcelRequire("dntH2");
'use strict';
const $7d21bec2a36f0740$var$headersToObject = (thing)=>thing instanceof (0, $dntH2.default) ? {
        ...thing
    } : thing;
function $7d21bec2a36f0740$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $cWqj5.default).isPlainObject(target) && (0, $cWqj5.default).isPlainObject(source)) return (0, $cWqj5.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $cWqj5.default).isPlainObject(source)) return (0, $cWqj5.default).merge({}, source);
        else if ((0, $cWqj5.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $cWqj5.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $cWqj5.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $cWqj5.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $cWqj5.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $cWqj5.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($7d21bec2a36f0740$var$headersToObject(a), $7d21bec2a36f0740$var$headersToObject(b), prop, true)
    };
    (0, $cWqj5.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $cWqj5.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("5fCNL", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $3d2c73a3b3f653c1$export$3105c6651375d4fa; });

var $6c9IQ = parcelRequire("6c9IQ");

var $cWqj5 = parcelRequire("cWqj5");

var $eT7G0 = parcelRequire("eT7G0");

var $2v1BM = parcelRequire("2v1BM");

var $gf8vG = parcelRequire("gf8vG");

var $dntH2 = parcelRequire("dntH2");

var $jw9Hz = parcelRequire("jw9Hz");

var $mtfwf = parcelRequire("mtfwf");

var $eJfIB = parcelRequire("eJfIB");
const $3d2c73a3b3f653c1$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $3d2c73a3b3f653c1$var$isFunction } = (0, $cWqj5.default);
const $3d2c73a3b3f653c1$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $cWqj5.default).global);
const { ReadableStream: $3d2c73a3b3f653c1$var$ReadableStream, TextEncoder: $3d2c73a3b3f653c1$var$TextEncoder } = (0, $cWqj5.default).global;
const $3d2c73a3b3f653c1$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $3d2c73a3b3f653c1$var$factory = (env)=>{
    env = (0, $cWqj5.default).merge.call({
        skipUndefined: true
    }, $3d2c73a3b3f653c1$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $3d2c73a3b3f653c1$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $3d2c73a3b3f653c1$var$isFunction(Request);
    const isResponseSupported = $3d2c73a3b3f653c1$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $3d2c73a3b3f653c1$var$isFunction($3d2c73a3b3f653c1$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $3d2c73a3b3f653c1$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $3d2c73a3b3f653c1$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $3d2c73a3b3f653c1$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $6c9IQ.default).origin, {
            body: new $3d2c73a3b3f653c1$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $3d2c73a3b3f653c1$var$test(()=>(0, $cWqj5.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $eT7G0.default)(`Response type '${type}' is not supported`, (0, $eT7G0.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $cWqj5.default).isBlob(body)) return body.size;
        if ((0, $cWqj5.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $6c9IQ.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $cWqj5.default).isArrayBufferView(body) || (0, $cWqj5.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $cWqj5.default).isURLSearchParams(body)) body = body + '';
        if ((0, $cWqj5.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $cWqj5.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $mtfwf.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $2v1BM.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $cWqj5.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $jw9Hz.progressEventDecorator)(requestContentLength, (0, $jw9Hz.progressEventReducer)((0, $jw9Hz.asyncDecorator)(onUploadProgress)));
                    data = (0, $gf8vG.trackStream)(_request.body, $3d2c73a3b3f653c1$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $cWqj5.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $cWqj5.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $jw9Hz.progressEventDecorator)(responseContentLength, (0, $jw9Hz.progressEventReducer)((0, $jw9Hz.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, $gf8vG.trackStream)(response.body, $3d2c73a3b3f653c1$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $cWqj5.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $eJfIB.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $dntH2.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $eT7G0.default)('Network Error', (0, $eT7G0.default).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $eT7G0.default).from(err, err && err.code, config, request);
        }
    };
};
const $3d2c73a3b3f653c1$var$seedCache = new Map();
const $3d2c73a3b3f653c1$export$3105c6651375d4fa = (config)=>{
    let env = config ? config.env : {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $3d2c73a3b3f653c1$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $3d2c73a3b3f653c1$var$factory(env));
        map = target;
    }
    return target;
};
const $3d2c73a3b3f653c1$var$adapter = $3d2c73a3b3f653c1$export$3105c6651375d4fa();
var $3d2c73a3b3f653c1$export$2e2bcd8739ae039 = $3d2c73a3b3f653c1$var$adapter;

});
parcelRegister("2v1BM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d1fb9660061b9bf$export$2e2bcd8739ae039; });

var $dqGYi = parcelRequire("dqGYi");

var $eT7G0 = parcelRequire("eT7G0");

var $cWqj5 = parcelRequire("cWqj5");
const $1d1fb9660061b9bf$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $eT7G0.default) ? err : new (0, $dqGYi.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $eT7G0.default)(`timeout ${timeout} of ms exceeded`, (0, $eT7G0.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $cWqj5.default).asap(unsubscribe);
        return signal;
    }
};
var $1d1fb9660061b9bf$export$2e2bcd8739ae039 = $1d1fb9660061b9bf$var$composeSignals;

});

parcelRegister("gf8vG", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $bd34a5fac98eaabf$export$b0119225647bd83; });
const $bd34a5fac98eaabf$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $bd34a5fac98eaabf$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $bd34a5fac98eaabf$var$readStream(iterable))yield* $bd34a5fac98eaabf$export$71b051935044bd5d(chunk, chunkSize);
};
const $bd34a5fac98eaabf$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $bd34a5fac98eaabf$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $bd34a5fac98eaabf$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("d2LaV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97f00e46dc04fb38$export$2e2bcd8739ae039; });

var $gV8y1 = parcelRequire("gV8y1");

var $eT7G0 = parcelRequire("eT7G0");
'use strict';
const $97f00e46dc04fb38$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $97f00e46dc04fb38$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $97f00e46dc04fb38$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $97f00e46dc04fb38$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $gV8y1.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $eT7G0.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $eT7G0.default).ERR_DEPRECATED);
        if (version && !$97f00e46dc04fb38$var$deprecatedWarnings[opt]) {
            $97f00e46dc04fb38$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$97f00e46dc04fb38$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $97f00e46dc04fb38$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $eT7G0.default)('options must be an object', (0, $eT7G0.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $eT7G0.default)('option ' + opt + ' must be ' + result, (0, $eT7G0.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $eT7G0.default)('Unknown option ' + opt, (0, $eT7G0.default).ERR_BAD_OPTION);
    }
}
var $97f00e46dc04fb38$export$2e2bcd8739ae039 = {
    assertOptions: $97f00e46dc04fb38$var$assertOptions,
    validators: $97f00e46dc04fb38$var$validators
};

});
parcelRegister("gV8y1", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $c518999a8c95b317$export$a4ad2735b021c132; });
const $c518999a8c95b317$export$a4ad2735b021c132 = "1.12.2";

});



parcelRegister("cVaqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9682e576288e4c91$export$2e2bcd8739ae039; });

var $dqGYi = parcelRequire("dqGYi");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $9682e576288e4c91$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dqGYi.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $9682e576288e4c91$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $9682e576288e4c91$export$2e2bcd8739ae039 = $9682e576288e4c91$var$CancelToken;

});

parcelRegister("gPA3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c40d60358c7afb0b$export$2e2bcd8739ae039; });
'use strict';
function $c40d60358c7afb0b$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("5npTQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ea330dd19ed61a9$export$2e2bcd8739ae039; });

var $cWqj5 = parcelRequire("cWqj5");
'use strict';
function $3ea330dd19ed61a9$export$2e2bcd8739ae039(payload) {
    return (0, $cWqj5.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("9Zvhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7462125ec565a4a9$export$2e2bcd8739ae039; });
const $7462125ec565a4a9$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($7462125ec565a4a9$var$HttpStatusCode).forEach(([key, value])=>{
    $7462125ec565a4a9$var$HttpStatusCode[value] = key;
});
var $7462125ec565a4a9$export$2e2bcd8739ae039 = $7462125ec565a4a9$var$HttpStatusCode;

});



parcelRegister("2SVrO", function(module, exports) {

$parcel$export(module.exports, "API_TIMEOUT_MS", function () { return $0ab75e4d9435f87a$export$30dc62967391881f; });
/**
 * Every axios instance was created without a timeout, and axios defaults to none: a request
 * that stalls never settles, so the screen spins forever instead of surfacing an error. Two
 * minutes leaves room for a multi-page KYC document on a poor connection while still failing
 * in a bounded time.
 */ const $0ab75e4d9435f87a$export$30dc62967391881f = 120000;

});

parcelRegister("01zXo", function(module, exports) {

$parcel$export(module.exports, "addAcceptLanguageInterceptor", function () { return $e44c69e29b713e51$export$7b6882b258738c32; });
const $e44c69e29b713e51$export$7b6882b258738c32 = (store)=>({
        onFulfilled: (config)=>({
                ...config,
                headers: {
                    "Accept-Language": store.localeTag.get(),
                    ...config.headers
                }
            })
    });

});

parcelRegister("76Kw8", function(module, exports) {

$parcel$export(module.exports, "addAuthorizationInterceptor", function () { return $87bd9872fb6f54fc$export$d759b701deb95aa1; });
const $87bd9872fb6f54fc$export$d759b701deb95aa1 = (authenticationManager, securedCookiesService)=>({
        onFulfilled: async (config)=>{
            const accessToken = await authenticationManager.getAccessToken();
            const addAuthorization = !securedCookiesService?.getSecuredCookies();
            return {
                ...config,
                headers: {
                    ...config.headers,
                    ...accessToken && addAuthorization && {
                        Authorization: `${accessToken.type} ${accessToken.value}`
                    }
                }
            };
        }
    });

});

parcelRegister("hYOFB", function(module, exports) {

$parcel$export(module.exports, "addBaseUrlInterceptor", function () { return $a5841c36fcc7c712$export$e3834c5ea0e5b9dd; });

var $dhPTb = parcelRequire("dhPTb");
const $a5841c36fcc7c712$export$e3834c5ea0e5b9dd = (apiUrl = (0, $dhPTb.Config).API_URL)=>({
        onFulfilled: (config)=>{
            if (config.url?.startsWith("https://")) return config;
            else return {
                ...config,
                url: `${apiUrl}${config.url}`
            };
        }
    });

});

parcelRegister("aKQUN", function(module, exports) {

$parcel$export(module.exports, "addSecuredCookieInterceptor", function () { return $ead3d06f2758abf1$export$8d14b077b8705215; });
const $ead3d06f2758abf1$export$8d14b077b8705215 = (securedCookiesService)=>({
        // X-TagPay-OAuth2-Cookie muste be set to a number not a string
        // @ts-ignore
        onFulfilled: (config)=>securedCookiesService.getSecuredCookies() ? {
                ...config,
                headers: {
                    ...config.headers,
                    "X-TagPay-OAuth2-Cookie": 1
                },
                withCredentials: true
            } : {
                ...config
            }
    });

});

parcelRegister("iEpXQ", function(module, exports) {

$parcel$export(module.exports, "addUserAgentInterceptor", function () { return $ba3db82c78e992b0$export$8793b9628610015d; });
const $ba3db82c78e992b0$export$8793b9628610015d = (userAgentService)=>({
        onFulfilled: async (config)=>{
            const userAgent = await userAgentService.getUserAgent();
            return {
                ...config,
                headers: {
                    "User-Agent": userAgent,
                    ...config.headers
                }
            };
        }
    });

});

parcelRegister("eUi4d", function(module, exports) {

$parcel$export(module.exports, "debugResponseInterceptor", function () { return $0bef4657c514c6f9$export$fb3a409c4e5742da; });

var $dhPTb = parcelRequire("dhPTb");

var $6JVVB = parcelRequire("6JVVB");
const $0bef4657c514c6f9$export$fb3a409c4e5742da = (debugIntercept)=>({
        onFulfilled: (response)=>{
            if (debugIntercept && debugIntercept.isAvailable()) {
                const filterURL = (0, $dhPTb.Config).API_URL + debugIntercept.getURL();
                if (response.config?.url?.includes(filterURL)) try {
                    const strResponse = JSON.stringify(response.data, null, 2);
                    const toRead = debugIntercept.getToRead();
                    if (toRead) {
                        debugIntercept.setJsonStr(strResponse);
                        return response;
                    }
                    const toOverride = debugIntercept.getToOverride();
                    const jsonData = debugIntercept.getJsonData() ?? null;
                    if (toOverride && jsonData) {
                        (0, $6JVVB.logger).debug("Interceptor : ", `Update response for ${debugIntercept.getURL()} with ${JSON.stringify(jsonData)}`);
                        return {
                            ...response,
                            data: jsonData
                        };
                    }
                } catch (error) {
                    (0, $6JVVB.logger).error("Debug Error : " + error);
                    return response;
                }
            }
            return response;
        }
    });

});

parcelRegister("iP77T", function(module, exports) {

$parcel$export(module.exports, "addRequestInterceptor", function () { return $e5fd9dd7ecc819ed$export$3be7240099dfcd9f; });
$parcel$export(module.exports, "addResponseInterceptor", function () { return $e5fd9dd7ecc819ed$export$3ceabb822ce04969; });
function $e5fd9dd7ecc819ed$export$3be7240099dfcd9f(axiosInstance, interceptor) {
    return axiosInstance.interceptors.request.use(interceptor.onFulfilled, interceptor.onRejected);
}
function $e5fd9dd7ecc819ed$export$3ceabb822ce04969(axiosInstance, interceptor) {
    return axiosInstance.interceptors.response.use(interceptor.onFulfilled, interceptor.onRejected);
}

});

parcelRegister("hNHUm", function(module, exports) {

$parcel$export(module.exports, "addRequestLogInterceptor", function () { return $376bb8bcdde3a74d$export$4d5ebcd0aa0f04f3; });

var $6JVVB = parcelRequire("6JVVB");

var $6y3mf = parcelRequire("6y3mf");

var $iIVJN = parcelRequire("iIVJN");
const $376bb8bcdde3a74d$export$4d5ebcd0aa0f04f3 = ()=>({
        onFulfilled: async (config)=>{
            (0, $6y3mf.markRequestStart)(config);
            if (!(0, $iIVJN.netLogConfig).requests || !(0, $iIVJN.isLoggedUrl)(config.url)) return config;
            const parts = [
                "HTTP \u2192",
                (0, $6y3mf.describeRequest)(config)
            ];
            if ((0, $iIVJN.netLogConfig).headers) parts.push(`headers: ${(0, $6y3mf.summarizeHeaders)(config.headers)}`);
            if ((0, $iIVJN.netLogConfig).requestBody) parts.push(`body: ${(0, $6y3mf.summarizeBody)(config.data)}`);
            (0, $6JVVB.logger).info(...parts);
            return config;
        }
    });

});
parcelRegister("6y3mf", function(module, exports) {

$parcel$export(module.exports, "markRequestStart", function () { return $b632f322b9dbc27c$export$dfbf297fe049b5dc; });
$parcel$export(module.exports, "describeRequest", function () { return $b632f322b9dbc27c$export$fdd345a3d06cb9c6; });
$parcel$export(module.exports, "describeDuration", function () { return $b632f322b9dbc27c$export$c72e64ffe492b79e; });
$parcel$export(module.exports, "summarizeHeaders", function () { return $b632f322b9dbc27c$export$841fd1d7232901d7; });
$parcel$export(module.exports, "summarizeBody", function () { return $b632f322b9dbc27c$export$a46530180aaf25d7; });
$parcel$export(module.exports, "responseSize", function () { return $b632f322b9dbc27c$export$ee980c41336f3a40; });

var $iIVJN = parcelRequire("iIVJN");
const $b632f322b9dbc27c$var$REDACTED_HEADERS = [
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key"
];
const $b632f322b9dbc27c$var$requestStarts = new WeakMap();
function $b632f322b9dbc27c$export$dfbf297fe049b5dc(config) {
    $b632f322b9dbc27c$var$requestStarts.set(config, Date.now());
}
function $b632f322b9dbc27c$export$6ca819828f83957f(config) {
    if (!config) return undefined;
    const start = $b632f322b9dbc27c$var$requestStarts.get(config);
    return start === undefined ? undefined : Date.now() - start;
}
function $b632f322b9dbc27c$export$fdd345a3d06cb9c6(config) {
    const method = config.method ? config.method.toUpperCase() : "?";
    return `${method} ${$b632f322b9dbc27c$var$fullUrl(config)}`;
}
function $b632f322b9dbc27c$export$c72e64ffe492b79e(config) {
    if (!(0, $iIVJN.netLogConfig).timing) return "";
    const elapsed = $b632f322b9dbc27c$export$6ca819828f83957f(config);
    return elapsed === undefined ? "" : `${elapsed}ms`;
}
function $b632f322b9dbc27c$export$841fd1d7232901d7(headers) {
    const raw = $b632f322b9dbc27c$var$toPlainObject(headers);
    if (!raw) return "";
    const safe = Object.entries(raw).reduce((accumulator, [name, value])=>{
        accumulator[name] = $b632f322b9dbc27c$var$REDACTED_HEADERS.includes(name.toLowerCase()) ? "[redacted]" : value;
        return accumulator;
    }, {});
    return $b632f322b9dbc27c$export$a46530180aaf25d7(safe);
}
function $b632f322b9dbc27c$export$a46530180aaf25d7(data) {
    if (data === undefined || data === null) return "";
    if (typeof data === "string") return $b632f322b9dbc27c$var$truncate(data, (0, $iIVJN.netLogConfig).maxBodyLength);
    if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) return `[binary ${$b632f322b9dbc27c$var$formatBytes(data.byteLength)}]`;
    if (typeof FormData !== "undefined" && data instanceof FormData) return "[FormData]";
    if (typeof Blob !== "undefined" && data instanceof Blob) return `[Blob ${$b632f322b9dbc27c$var$formatBytes(data.size)} ${data.type || "?"}]`;
    try {
        return $b632f322b9dbc27c$var$truncate(JSON.stringify(data, $b632f322b9dbc27c$var$truncateFields) ?? "", (0, $iIVJN.netLogConfig).maxBodyLength);
    } catch  {
        return "[unserializable]";
    }
}
function $b632f322b9dbc27c$var$truncateFields(_key, value) {
    return typeof value === "string" ? $b632f322b9dbc27c$var$truncate(value, (0, $iIVJN.netLogConfig).maxFieldLength) : value;
}
function $b632f322b9dbc27c$var$truncate(value, max) {
    return value.length <= max ? value : `${value.slice(0, max)}\u{2026}(+${value.length - max} chars)`;
}
function $b632f322b9dbc27c$var$formatBytes(bytes) {
    if (bytes < 1024) return `${bytes}B`;
    if (bytes < 1048576) return `${Math.round(bytes / 1024)}KB`;
    return `${(bytes / 1048576).toFixed(1)}MB`;
}
function $b632f322b9dbc27c$var$fullUrl(config) {
    const url = config.url ?? "";
    const baseUrl = config.baseURL ?? "";
    return !baseUrl || url.startsWith("http") ? url : `${baseUrl.replace(/\/$/, "")}/${url.replace(/^\//, "")}`;
}
function $b632f322b9dbc27c$var$toPlainObject(value) {
    if (!value || typeof value !== "object") return null;
    const candidate = value;
    return typeof candidate.toJSON === "function" ? candidate.toJSON() : value;
}
function $b632f322b9dbc27c$export$ee980c41336f3a40(response) {
    const data = response?.data;
    if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) return $b632f322b9dbc27c$var$formatBytes(data.byteLength);
    if (typeof data === "string") return $b632f322b9dbc27c$var$formatBytes(data.length);
    return "";
}

});
parcelRegister("iIVJN", function(module, exports) {

$parcel$export(module.exports, "netLogConfig", function () { return $5e4806c744f10a88$export$1a3c5cd53945debb; });
$parcel$export(module.exports, "isLoggedUrl", function () { return $5e4806c744f10a88$export$4111735bff66cc03; });
const $5e4806c744f10a88$export$1a3c5cd53945debb = {
    requests: true,
    responses: true,
    errors: true,
    headers: false,
    requestBody: false,
    responseBody: false,
    errorBody: true,
    timing: true,
    maxBodyLength: 2000,
    maxFieldLength: 512,
    ignoredUrls: []
};
function $5e4806c744f10a88$export$4111735bff66cc03(url) {
    return !$5e4806c744f10a88$export$1a3c5cd53945debb.ignoredUrls.some((ignored)=>ignored.test(url ?? ""));
}

});



parcelRegister("4MyHt", function(module, exports) {

$parcel$export(module.exports, "logResponseInterceptor", function () { return $be3ce34dade4d092$export$4b926e0076d5c457; });

var $6JVVB = parcelRequire("6JVVB");

var $6y3mf = parcelRequire("6y3mf");

var $iIVJN = parcelRequire("iIVJN");
const $be3ce34dade4d092$export$4b926e0076d5c457 = {
    onFulfilled: (response)=>{
        if (!(0, $iIVJN.netLogConfig).responses || !(0, $iIVJN.isLoggedUrl)(response.config?.url)) return response;
        const parts = [
            "HTTP \u2190",
            `${response.status}`,
            (0, $6y3mf.describeRequest)(response.config),
            (0, $6y3mf.describeDuration)(response.config)
        ];
        const size = (0, $6y3mf.responseSize)(response);
        if (size) parts.push(size);
        if ((0, $iIVJN.netLogConfig).headers) parts.push(`headers: ${(0, $6y3mf.summarizeHeaders)(response.headers)}`);
        if ((0, $iIVJN.netLogConfig).responseBody) parts.push(`body: ${(0, $6y3mf.summarizeBody)(response.data)}`);
        (0, $6JVVB.logger).debug(...parts.filter(Boolean));
        return response;
    },
    onRejected: (error)=>{
        if (!(0, $iIVJN.netLogConfig).errors || !(0, $iIVJN.isLoggedUrl)(error?.config?.url)) return Promise.reject(error);
        const parts = [
            "HTTP \u2717",
            `${error?.response?.status ?? error?.code ?? "no status"}`,
            error?.config ? (0, $6y3mf.describeRequest)(error.config) : "",
            (0, $6y3mf.describeDuration)(error?.config)
        ];
        if ((0, $iIVJN.netLogConfig).requestBody) parts.push(`sent: ${(0, $6y3mf.summarizeBody)(error?.config?.data)}`);
        if ((0, $iIVJN.netLogConfig).errorBody) parts.push(`received: ${(0, $6y3mf.summarizeBody)(error?.response?.data)}`);
        (0, $6JVVB.logger).debug(...parts.filter(Boolean));
        return Promise.reject(error);
    }
};

});


parcelRegister("kKOCu", function(module, exports) {

$parcel$export(module.exports, "ConnectedApiService", function () { return $556ed3e8120b911b$export$60974d4fbdf6e075; });
parcelRequire("ix4Sq");
var $51oiE = parcelRequire("51oiE");

var $2SVrO = parcelRequire("2SVrO");

var $76Kw8 = parcelRequire("76Kw8");

var $hYOFB = parcelRequire("hYOFB");

var $aKQUN = parcelRequire("aKQUN");

var $iEpXQ = parcelRequire("iEpXQ");

var $eUi4d = parcelRequire("eUi4d");

var $iP77T = parcelRequire("iP77T");

var $fWzcr = parcelRequire("fWzcr");

var $hNHUm = parcelRequire("hNHUm");

var $4MyHt = parcelRequire("4MyHt");

var $5hk6f = parcelRequire("5hk6f");
class $556ed3e8120b911b$export$60974d4fbdf6e075 {
    constructor(errorStore, httpService, authenticationManager, customUserAgentService, securedCookiesService, debugIntercept){
        this.errorStore = errorStore;
        this.httpService = httpService;
        this.authenticationManager = authenticationManager;
        this.customUserAgentService = customUserAgentService;
        this.securedCookiesService = securedCookiesService;
        this.debugIntercept = debugIntercept;
        this.instance = (0, $51oiE.default).create({
            timeout: (0, $2SVrO.API_TIMEOUT_MS)
        });
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hNHUm.addRequestLogInterceptor)());
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hYOFB.addBaseUrlInterceptor)());
        if (this.securedCookiesService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $aKQUN.addSecuredCookieInterceptor)(this.securedCookiesService));
        if (this.customUserAgentService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $iEpXQ.addUserAgentInterceptor)(this.customUserAgentService));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $76Kw8.addAuthorizationInterceptor)(this.authenticationManager));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $fWzcr.isConnectedCheckInterceptor)(this.authenticationManager));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $5hk6f.renewTokenInterceptor)(this.httpService, this.authenticationManager, this.securedCookiesService));
        if (this.debugIntercept) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $eUi4d.debugResponseInterceptor)(debugIntercept));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $4MyHt.logResponseInterceptor));
        this.instance.interceptors.response.use((response)=>response, (error)=>{
            if (error.response && error.response.status === 429 || error.code == "ERR_NETWORK") this.errorStore.error.set(error);
            // Resolving here handed callers an undefined response, which they dereferenced: the real
            // error was lost behind a TypeError. The unauthenticated service already rejects.
            return Promise.reject(error);
        });
    }
    async buildAuthenticatedRequest(url) {
        let request = {
            url: url
        };
        const baseUrlInterceptor = (0, $hYOFB.addBaseUrlInterceptor)();
        if (baseUrlInterceptor.onFulfilled) request = await baseUrlInterceptor.onFulfilled({
            url: url
        });
        const authorizationInterceptor = (0, $76Kw8.addAuthorizationInterceptor)(this.authenticationManager);
        if (authorizationInterceptor.onFulfilled) request = await authorizationInterceptor.onFulfilled(request);
        return request;
    }
}

});
parcelRegister("fWzcr", function(module, exports) {

$parcel$export(module.exports, "isConnectedCheckInterceptor", function () { return $19504fb8218451a5$export$b1188c761b1625c8; });

var $6JVVB = parcelRequire("6JVVB");
const $19504fb8218451a5$export$b1188c761b1625c8 = (authenticationManager)=>({
        onFulfilled: async (config)=>{
            if (!authenticationManager.isConnected.get()) {
                (0, $6JVVB.logger).debug("Request cancelled, not connected");
                return Promise.reject("Request cancelled, not connected");
            }
            return config;
        }
    });

});

parcelRegister("5hk6f", function(module, exports) {

$parcel$export(module.exports, "renewTokenInterceptor", function () { return $5081e72af4bc92a5$export$c4e14ca0e4f0edbb; });
const $5081e72af4bc92a5$export$c4e14ca0e4f0edbb = (httpService, authenticationManager, securedCookiesService)=>({
        onRejected: async (error)=>{
            if (!error?.response || error?.response?.status != 401) return Promise.reject(error);
            try {
                const accessToken = await authenticationManager.getAccessToken(true);
                const addAuthorization = !securedCookiesService?.getSecuredCookies();
                if (accessToken && addAuthorization) error.response.config.headers.Authorization = `${accessToken.type} ${accessToken.value}`;
                return httpService.instance(error.response.config);
            } catch (e) {
                return Promise.reject(error);
            }
        }
    });

});


parcelRegister("hg3kg", function(module, exports) {

$parcel$export(module.exports, "ConnectedServiceDomainApiService", function () { return $662a096e7049ebdb$export$f6050e5c5a00ebbc; });
parcelRequire("ix4Sq");
var $51oiE = parcelRequire("51oiE");

var $dhPTb = parcelRequire("dhPTb");

var $2SVrO = parcelRequire("2SVrO");

var $01zXo = parcelRequire("01zXo");

var $76Kw8 = parcelRequire("76Kw8");

var $hYOFB = parcelRequire("hYOFB");

var $aKQUN = parcelRequire("aKQUN");

var $iEpXQ = parcelRequire("iEpXQ");

var $eUi4d = parcelRequire("eUi4d");

var $iP77T = parcelRequire("iP77T");

var $hNHUm = parcelRequire("hNHUm");

var $4MyHt = parcelRequire("4MyHt");

var $5hk6f = parcelRequire("5hk6f");
class $662a096e7049ebdb$export$f6050e5c5a00ebbc {
    constructor(httpService, customUserAgentService, authManager, i18NStore, securedCookiesService, debugIntercept){
        this.httpService = httpService;
        this.customUserAgentService = customUserAgentService;
        this.authManager = authManager;
        this.i18NStore = i18NStore;
        this.securedCookiesService = securedCookiesService;
        this.debugIntercept = debugIntercept;
        this.instance = (0, $51oiE.default).create({
            timeout: (0, $2SVrO.API_TIMEOUT_MS)
        });
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hNHUm.addRequestLogInterceptor)());
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hYOFB.addBaseUrlInterceptor)((0, $dhPTb.Config).SERVICE_DOMAIN_API_URL));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $01zXo.addAcceptLanguageInterceptor)(this.i18NStore));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $76Kw8.addAuthorizationInterceptor)(this.authManager));
        if (this.httpService) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $5hk6f.renewTokenInterceptor)(this.httpService, this.authManager, this.securedCookiesService));
        if (this.securedCookiesService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $aKQUN.addSecuredCookieInterceptor)(this.securedCookiesService));
        if (this.customUserAgentService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $iEpXQ.addUserAgentInterceptor)(this.customUserAgentService));
        if (this.debugIntercept) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $eUi4d.debugResponseInterceptor)(debugIntercept));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $4MyHt.logResponseInterceptor));
    }
    async buildAuthenticatedRequest(url) {
        let request = {
            url: url
        };
        const baseUrlInterceptor = (0, $hYOFB.addBaseUrlInterceptor)((0, $dhPTb.Config).SERVICE_DOMAIN_API_URL);
        if (baseUrlInterceptor.onFulfilled) request = await baseUrlInterceptor.onFulfilled({
            url: url
        });
        const authorizationInterceptor = (0, $76Kw8.addAuthorizationInterceptor)(this.authManager);
        if (authorizationInterceptor.onFulfilled) request = await authorizationInterceptor.onFulfilled(request);
        return request;
    }
    getInstance() {
        return this.instance;
    }
}

});

parcelRegister("bvHZm", function(module, exports) {

$parcel$export(module.exports, "HttpService", function () { return $c2c85639f4fe3684$export$502655d8af8a4dab; });
parcelRequire("ix4Sq");
var $51oiE = parcelRequire("51oiE");

var $2SVrO = parcelRequire("2SVrO");

var $aKQUN = parcelRequire("aKQUN");

var $iEpXQ = parcelRequire("iEpXQ");

var $eUi4d = parcelRequire("eUi4d");

var $iP77T = parcelRequire("iP77T");

var $hNHUm = parcelRequire("hNHUm");

var $4MyHt = parcelRequire("4MyHt");
class $c2c85639f4fe3684$export$502655d8af8a4dab {
    constructor(customUserAgentService, securedCookiesService, debugIntercept){
        this.customUserAgentService = customUserAgentService;
        this.securedCookiesService = securedCookiesService;
        this.debugIntercept = debugIntercept;
        this.instance = (0, $51oiE.default).create({
            timeout: (0, $2SVrO.API_TIMEOUT_MS)
        });
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hNHUm.addRequestLogInterceptor)());
        if (this.securedCookiesService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $aKQUN.addSecuredCookieInterceptor)(this.securedCookiesService));
        if (this.customUserAgentService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $iEpXQ.addUserAgentInterceptor)(this.customUserAgentService));
        if (this.debugIntercept) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $eUi4d.debugResponseInterceptor)(debugIntercept));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $4MyHt.logResponseInterceptor));
    }
}

});

parcelRegister("huphj", function(module, exports) {

$parcel$export(module.exports, "OauthHttpService", function () { return $f445a35e3e5aee42$export$1496ba99e61be27e; });
parcelRequire("ix4Sq");
var $51oiE = parcelRequire("51oiE");

var $2SVrO = parcelRequire("2SVrO");

var $hYOFB = parcelRequire("hYOFB");

var $aKQUN = parcelRequire("aKQUN");

var $iEpXQ = parcelRequire("iEpXQ");

var $eUi4d = parcelRequire("eUi4d");

var $iP77T = parcelRequire("iP77T");

var $hNHUm = parcelRequire("hNHUm");

var $4MyHt = parcelRequire("4MyHt");
class $f445a35e3e5aee42$export$1496ba99e61be27e {
    constructor(errorStore, customUserAgentService, securedCookiesService, debugIntercept){
        this.errorStore = errorStore;
        this.customUserAgentService = customUserAgentService;
        this.securedCookiesService = securedCookiesService;
        this.debugIntercept = debugIntercept;
        this.instance = (0, $51oiE.default).create({
            timeout: (0, $2SVrO.API_TIMEOUT_MS)
        });
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hNHUm.addRequestLogInterceptor)());
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hYOFB.addBaseUrlInterceptor)());
        if (this.securedCookiesService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $aKQUN.addSecuredCookieInterceptor)(this.securedCookiesService));
        if (this.customUserAgentService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $iEpXQ.addUserAgentInterceptor)(this.customUserAgentService));
        if (this.debugIntercept) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $eUi4d.debugResponseInterceptor)(debugIntercept));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $4MyHt.logResponseInterceptor));
        this.instance.interceptors.response.use((response)=>response, (error)=>{
            if (error.response && error.response.status === 429 || error.code == "ERR_NETWORK") {
                this.errorStore.error.set(error);
                return Promise.resolve();
            }
            return Promise.reject(error);
        });
    }
}

});

parcelRegister("bs8aV", function(module, exports) {

$parcel$export(module.exports, "SavingsApiService", function () { return $d0ce3399d7fd2cdf$export$fca1c1e5606b7584; });
parcelRequire("ix4Sq");
var $51oiE = parcelRequire("51oiE");

var $dhPTb = parcelRequire("dhPTb");

var $2SVrO = parcelRequire("2SVrO");

var $01zXo = parcelRequire("01zXo");

var $76Kw8 = parcelRequire("76Kw8");

var $hYOFB = parcelRequire("hYOFB");

var $aKQUN = parcelRequire("aKQUN");

var $iEpXQ = parcelRequire("iEpXQ");

var $eUi4d = parcelRequire("eUi4d");

var $iP77T = parcelRequire("iP77T");

var $hNHUm = parcelRequire("hNHUm");

var $4MyHt = parcelRequire("4MyHt");

var $5hk6f = parcelRequire("5hk6f");
class $d0ce3399d7fd2cdf$export$fca1c1e5606b7584 {
    constructor(httpService, customUserAgentService, authManager, i18NStore, securedCookiesService, debugIntercept){
        this.httpService = httpService;
        this.customUserAgentService = customUserAgentService;
        this.authManager = authManager;
        this.i18NStore = i18NStore;
        this.securedCookiesService = securedCookiesService;
        this.debugIntercept = debugIntercept;
        this.instance = (0, $51oiE.default).create({
            timeout: (0, $2SVrO.API_TIMEOUT_MS)
        });
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hNHUm.addRequestLogInterceptor)());
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hYOFB.addBaseUrlInterceptor)((0, $dhPTb.Config).SAVINGS_API_URL));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $01zXo.addAcceptLanguageInterceptor)(this.i18NStore));
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $76Kw8.addAuthorizationInterceptor)(this.authManager));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $5hk6f.renewTokenInterceptor)(this.httpService, this.authManager, this.securedCookiesService));
        if (this.securedCookiesService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $aKQUN.addSecuredCookieInterceptor)(this.securedCookiesService));
        if (this.customUserAgentService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $iEpXQ.addUserAgentInterceptor)(this.customUserAgentService));
        if (this.debugIntercept) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $eUi4d.debugResponseInterceptor)(debugIntercept));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $4MyHt.logResponseInterceptor));
    }
    async buildAuthenticatedRequest(url) {
        let request = {
            url: url
        };
        const baseUrlInterceptor = (0, $hYOFB.addBaseUrlInterceptor)((0, $dhPTb.Config).SAVINGS_API_URL);
        if (baseUrlInterceptor.onFulfilled) request = await baseUrlInterceptor.onFulfilled({
            url: url
        });
        const authorizationInterceptor = (0, $76Kw8.addAuthorizationInterceptor)(this.authManager);
        if (authorizationInterceptor.onFulfilled) request = await authorizationInterceptor.onFulfilled(request);
        return request;
    }
}

});

parcelRegister("dZ8li", function(module, exports) {

$parcel$export(module.exports, "ServiceDomainApiService", function () { return $26bd1714efc9ab35$export$47aedb50532b90c9; });
parcelRequire("ix4Sq");
var $51oiE = parcelRequire("51oiE");

var $dhPTb = parcelRequire("dhPTb");

var $2SVrO = parcelRequire("2SVrO");

var $hYOFB = parcelRequire("hYOFB");

var $aKQUN = parcelRequire("aKQUN");

var $iEpXQ = parcelRequire("iEpXQ");

var $eUi4d = parcelRequire("eUi4d");

var $iP77T = parcelRequire("iP77T");

var $hNHUm = parcelRequire("hNHUm");

var $4MyHt = parcelRequire("4MyHt");
class $26bd1714efc9ab35$export$47aedb50532b90c9 {
    constructor(customUserAgentService, securedCookiesService, debugIntercept){
        this.customUserAgentService = customUserAgentService;
        this.securedCookiesService = securedCookiesService;
        this.debugIntercept = debugIntercept;
        this.instance = (0, $51oiE.default).create({
            timeout: (0, $2SVrO.API_TIMEOUT_MS)
        });
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hNHUm.addRequestLogInterceptor)());
        (0, $iP77T.addRequestInterceptor)(this.instance, (0, $hYOFB.addBaseUrlInterceptor)((0, $dhPTb.Config).SERVICE_DOMAIN_API_URL));
        //addRequestInterceptor(this.instance, addAuthorizationInterceptor(this.serviceDomainManager));
        if (this.securedCookiesService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $aKQUN.addSecuredCookieInterceptor)(this.securedCookiesService));
        if (this.customUserAgentService) (0, $iP77T.addRequestInterceptor)(this.instance, (0, $iEpXQ.addUserAgentInterceptor)(this.customUserAgentService));
        if (this.debugIntercept) (0, $iP77T.addResponseInterceptor)(this.instance, (0, $eUi4d.debugResponseInterceptor)(debugIntercept));
        (0, $iP77T.addResponseInterceptor)(this.instance, (0, $4MyHt.logResponseInterceptor));
    }
}

});

parcelRegister("2jUR4", function(module, exports) {

$parcel$export(module.exports, "UUIDManager", function () { return $fd593810404b6aa5$export$869ea3e8049ce0a7; });

var $6JVVB = parcelRequire("6JVVB");
const $fd593810404b6aa5$var$UUID_KEYSTORE_KEY = "device_uuid";
class $fd593810404b6aa5$export$869ea3e8049ce0a7 {
    constructor(cache, uuidGenerator){
        this.cache = cache;
        this.uuidGenerator = uuidGenerator;
        this.UUID = null;
    }
    async getUUID() {
        try {
            if (this.UUID !== null) return this.UUID;
            else {
                this.UUID = await this.restore();
                if (this.UUID === null || this.UUID === undefined) {
                    this.UUID = await this.uuidGenerator.getRandomUUID();
                    await this.save();
                }
                return this.UUID;
            }
        } catch (e) {
            (0, $6JVVB.logger).debug("UUID Manager", "Failed to load device uuid, generate a new UUID", e);
            this.UUID = await this.uuidGenerator.getRandomUUID();
            await this.save();
            return this.UUID;
        }
    }
    async setUuid(id) {
        const oldId = this.UUID;
        try {
            this.UUID = id;
            await this.save();
            (0, $6JVVB.logger).debug("UUID Manager", "Saved custom ID: ", this.UUID);
        } catch (e) {
            this.UUID = oldId;
        }
    }
    async save() {
        try {
            if (this.UUID) this.cache.store(this.UUID, $fd593810404b6aa5$var$UUID_KEYSTORE_KEY);
        } catch (e) {
            (0, $6JVVB.logger).debug("UUID Manager", "Save UUID failed", e);
        }
    }
    async restore() {
        try {
            return this.cache.read($fd593810404b6aa5$var$UUID_KEYSTORE_KEY);
        } catch (e) {
            (0, $6JVVB.logger).debug("UUID Manager", "Failed to restore device uuid", e);
            return Promise.resolve(null);
        }
    }
}

});

parcelRegister("3rnPM", function(module, exports) {

$parcel$export(module.exports, "WebAnalyticsService", function () { return $26df14313cb4629d$export$d37e798bec40b45d; });
class $26df14313cb4629d$export$d37e798bec40b45d {
    recordError(e) {}
    tagScreen(screenName) {}
    event(eventName, params) {}
}

});


parcelRegister("dFWfS", function(module, exports) {

$parcel$export(module.exports, "AppRouter", function () { return $a96ce9ee80cb547b$export$8707b35fd1c03f46; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $aMGcY = parcelRequire("aMGcY");

var $cJ83d = parcelRequire("cJ83d");

var $eL3qb = parcelRequire("eL3qb");

var $j1R2o = parcelRequire("j1R2o");

var $56WMd = parcelRequire("56WMd");

var $18F7H = parcelRequire("18F7H");

var $7yMne = parcelRequire("7yMne");

var $bBtVU = parcelRequire("bBtVU");

var $5uojP = parcelRequire("5uojP");

var $evDSv = parcelRequire("evDSv");

var $kl80K = parcelRequire("kl80K");

var $g9I8n = parcelRequire("g9I8n");

var $dTIxs = parcelRequire("dTIxs");

var $5z1GG = parcelRequire("5z1GG");

var $kqgT4 = parcelRequire("kqgT4");

var $e4b5h = parcelRequire("e4b5h");

var $hfj6a = parcelRequire("hfj6a");

var $fEANk = parcelRequire("fEANk");

var $fHt3E = parcelRequire("fHt3E");

var $1jH8u = parcelRequire("1jH8u");

var $csDxW = parcelRequire("csDxW");

var $3L6c2 = parcelRequire("3L6c2");

var $4RLfY = parcelRequire("4RLfY");

var $je7Jr = parcelRequire("je7Jr");

var $ePc1F = parcelRequire("ePc1F");

var $3n4vt = parcelRequire("3n4vt");

var $20t15 = parcelRequire("20t15");

var $4SmBi = parcelRequire("4SmBi");

var $b6m5I = parcelRequire("b6m5I");

var $1bqgL = parcelRequire("1bqgL");

var $9TaaL = parcelRequire("9TaaL");

var $eVOlS = parcelRequire("eVOlS");

var $fy9od = parcelRequire("fy9od");

var $cGTzu = parcelRequire("cGTzu");

var $lrkNK = parcelRequire("lrkNK");

var $I09Mh = parcelRequire("I09Mh");

var $gAfhx = parcelRequire("gAfhx");

var $4fYE4 = parcelRequire("4fYE4");

var $dYYgR = parcelRequire("dYYgR");

var $3QpQZ = parcelRequire("3QpQZ");

var $dE0SD = parcelRequire("dE0SD");
function $a96ce9ee80cb547b$export$8707b35fd1c03f46() {
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $NQIVp.Switch), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $3QpQZ.HomeRoute), {
                exact: true,
                path: (0, $4fYE4.Path).Root,
                component: (0, $je7Jr.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dE0SD.OAuthRedirectRoute), {
                path: (0, $4fYE4.Path).OAuthRedirect,
                component: (0, $ePc1F.OAuthLoadingScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).DeleteAccount,
                component: (0, $dTIxs.DeleteAccount)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).DeleteData,
                component: (0, $5z1GG.DeleteData)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).ErrorScreen,
                component: (0, $csDxW.ErrorScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).UbbleRedirect,
                exact: false,
                component: (0, $fHt3E.RegisterScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).Register,
                component: (0, $fHt3E.RegisterScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).Onboarding,
                component: (0, $fEANk.OnboardingScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).OnboardingFileSubmitted,
                component: (0, $e4b5h.OnboardingFileSubmittedScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).UbbleRedirectNewOnboarding,
                exact: false,
                component: (0, $hfj6a.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).Connect,
                component: (0, $g9I8n.ConnectScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
                path: (0, $4fYE4.Path).UbbleCheck,
                component: (0, $1jH8u.UbbleCheckScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).OnboardingFile,
                component: (0, $kqgT4.OnboardingFileScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).AccountBlocked,
                component: ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $aMGcY.AccountBlockedScreen), {})
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).AccountBlockedAfterPincodeError,
                component: ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $aMGcY.AccountBlockedScreen), {
                        isThreePincodeAttemptsError: true
                    })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).AccountTransactions,
                component: (0, $56WMd.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).AllAccounts,
                component: (0, $18F7H.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).AllTransactions,
                component: (0, $7yMne.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).MyAccount,
                component: (0, $j1R2o.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).AccountStatements,
                component: (0, $cJ83d.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).FeesStatements,
                component: (0, $eL3qb.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Transfer,
                component: (0, $I09Mh.TransferScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).SimpleTransfer,
                component: (0, $lrkNK.SimpleTransferScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).CashTransfers,
                component: (0, $cGTzu.CashTransferScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).UpcomingTransfers,
                component: (0, $gAfhx.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).BillIssuers,
                component: (0, $bBtVU.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).References,
                component: (0, $5uojP.BillReferencesScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Cards,
                component: (0, $evDSv.AllCardsScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).AllCards,
                component: (0, $evDSv.AllCardsScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).CardOutstandings,
                component: (0, $kl80K.CardOutstandingsScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).ProfileMenu,
                component: (0, $eVOlS.ProfileMenuScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Profile,
                component: (0, $1bqgL.MyProfileScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Settings,
                component: (0, $9TaaL.MySettingsScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Recharge,
                component: (0, $20t15.RechargeScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Loans,
                component: (0, $4RLfY.ExternalLoansScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).PspRedirect,
                exact: false,
                component: (0, $20t15.RechargeScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).TransactionCodes,
                component: (0, $fy9od.TransactionCodesScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).JustifyTransaction,
                component: (0, $3L6c2.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Recipients,
                component: (0, $4SmBi.RecipientsScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).CreateSavingAccount,
                component: (0, $b6m5I.CreateSavingScreen)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $dYYgR.AuthNavRoute), {
                path: (0, $4fYE4.Path).Mandates,
                component: (0, $3n4vt.default)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
                path: "*",
                to: (0, $4fYE4.Path).Root
            })
        ]
    });
}

});
parcelRegister("aMGcY", function(module, exports) {

$parcel$export(module.exports, "AccountBlockedScreen", function () { return $276b0f89e802c673$export$f2e66566394688f6; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $e4wja = parcelRequire("e4wja");

var $k4Ecv = parcelRequire("k4Ecv");

var $4fYE4 = parcelRequire("4fYE4");

var $7Zu6k = parcelRequire("7Zu6k");

var $amCCH = parcelRequire("amCCH");

var $22v9q = parcelRequire("22v9q");
const $276b0f89e802c673$export$f2e66566394688f6 = ({ isThreePincodeAttemptsError: isThreePincodeAttemptsError })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const isConnected = (0, $3Ersk.useObservable)((0, $kqXxS.authenticationManager).isConnected);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (isConnected) {
            await (0, $kqXxS.clientManager).updateClient(true);
            await (0, $kqXxS.accountManager).refresh();
        }
    });
    const getContacts = ()=>{
        if (configuration.contactPhone && configuration.contactEmail) return formatMessage("accountBlockedScreen.contactsPhoneAndEmail", {
            contactPhone: (0, $e4wja.formatPhoneNumber)(configuration.contactPhone),
            contactEmail: configuration.contactEmail
        });
        if (configuration.contactPhone) return formatMessage("accountBlockedScreen.contactsPhone", {
            contactPhone: (0, $e4wja.formatPhoneNumber)(configuration.contactPhone)
        });
        if (configuration.contactEmail) return formatMessage("accountBlockedScreen.contactsEmail", {
            contactEmail: configuration.contactEmail
        });
        return "";
    };
    const reason = isThreePincodeAttemptsError ? {
        subtitle: formatMessage("accountBlockedScreen.multipleAttemptBlockedReason.subtitle"),
        message: formatMessage("accountBlockedScreen.multipleAttemptBlockedReason.message", {
            contacts: getContacts()
        })
    } : {
        subtitle: undefined,
        message: formatMessage("accountBlockedScreen.defaultBlockedReason.message", {
            contacts: getContacts()
        })
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($276b0f89e802c673$var$BlockedSection, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $amCCH.PageHeader), {
                title: formatMessage("accountBlockedScreen.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($276b0f89e802c673$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($276b0f89e802c673$var$Message, {
                        children: reason.message
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryLink), {
                        to: (0, $4fYE4.Path).AccountTransactions,
                        size: "M",
                        children: formatMessage("accountBlockedScreen.button")
                    })
                ]
            })
        ]
    });
};
const $276b0f89e802c673$var$BlockedSection = (0, $jb8NR.default).section`
  align-self: stretch;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $276b0f89e802c673$var$Message = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
`;
const $276b0f89e802c673$var$Content = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > *:not(:first-child) {
    margin-top: 40px;
  }
`;

});
parcelRegister("5hpYi", function(module, exports) {

$parcel$export(module.exports, "useIntl", function () { return $c2b823ab601d9003$export$5aebe9a147f4d146; });

var $6uYXW = parcelRequire("6uYXW");

var $3Ersk = parcelRequire("3Ersk");

var $kqXxS = parcelRequire("kqXxS");
function $c2b823ab601d9003$export$5aebe9a147f4d146() {
    const intl = (0, $3Ersk.useObservable)((0, $kqXxS.i18NManager).intl);
    return (0, $6uYXW.useMemo)(()=>({
            ...intl,
            formatAmount: (0, $kqXxS.i18NManager).formatAmount,
            formatMessage: (0, $kqXxS.i18NManager).formatMessage,
            formatRelativeDate: (0, $kqXxS.i18NManager).formatRelativeDate,
            formatDistanceToNow: (0, $kqXxS.i18NManager).formatDistanceToNow,
            formatDistanceFromNow: (0, $kqXxS.i18NManager).formatDistanceFromNow
        }), [
        intl
    ]);
}

});

parcelRegister("e4wja", function(module, exports) {

$parcel$export(module.exports, "formatPhoneNumber", function () { return $0a04ad0604e30f86$export$842dcfa371c6bb83; });
$parcel$export(module.exports, "validatePhoneNumber", function () { return $0a04ad0604e30f86$export$30dc0b291f505e34; });
$parcel$export(module.exports, "anonymizePhoneNumber", function () { return $0a04ad0604e30f86$export$83ebb252681b5752; });
$parcel$export(module.exports, "formatPhoneNumberBasedOnCountryCode", function () { return $0a04ad0604e30f86$export$1796a558f684f967; });
$parcel$export(module.exports, "extractFormattedPhoneNumber", function () { return $0a04ad0604e30f86$export$19e6c1be6c9ef455; });

var $glqzU = parcelRequire("glqzU");
var $raeIM = parcelRequire("raeIM");
var $8Ba1X = parcelRequire("8Ba1X");
function $0a04ad0604e30f86$export$842dcfa371c6bb83(phoneNumber) {
    const formattedPhoneNumber = (0, $8Ba1X.parsePhoneNumberFromString)(`+${phoneNumber}`);
    return formattedPhoneNumber ? formattedPhoneNumber.formatInternational() : phoneNumber;
}
function $0a04ad0604e30f86$export$30dc0b291f505e34(intl, phone, country) {
    const phoneNumber = (0, $8Ba1X.parsePhoneNumberFromString)(phone, country);
    if (!phoneNumber) throw intl.formatMessage("common.invalidPhoneNumber");
    return phoneNumber.number;
}
function $0a04ad0604e30f86$export$83ebb252681b5752(str, leftover = 0) {
    return str.slice(0, str.length - leftover).replace(/[^\s]/g, "\u2022") + str.slice(str.length - leftover);
}
const $0a04ad0604e30f86$export$1796a558f684f967 = (nationalPhoneNumber, countryCode)=>(0, $raeIM.format)(nationalPhoneNumber, countryCode, "NATIONAL");
function $0a04ad0604e30f86$export$19e6c1be6c9ef455(internationalPhoneNumber, nationalNumber) {
    return new (0, $glqzU.AsYouType)().input(internationalPhoneNumber).substring(nationalNumber.length);
}

});
parcelRegister("glqzU", function(module, exports) {

$parcel$export(module.exports, "AsYouType", function () { return $be633967b7a3ffaf$export$80d8c6912928a4eb; });

var $bP4Vr = parcelRequire("bP4Vr");

var $546ih = parcelRequire("546ih");
function $be633967b7a3ffaf$export$80d8c6912928a4eb(country) {
    return (0, $546ih.default).call(this, country, (0, $bP4Vr.default));
}
$be633967b7a3ffaf$export$80d8c6912928a4eb.prototype = Object.create((0, $546ih.default).prototype, {});
$be633967b7a3ffaf$export$80d8c6912928a4eb.prototype.constructor = $be633967b7a3ffaf$export$80d8c6912928a4eb;

});
parcelRegister("546ih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b02354e1959a468$export$2e2bcd8739ae039; });

var $gduQK = parcelRequire("gduQK");

var $7Smoa = parcelRequire("7Smoa");

var $54M6d = parcelRequire("54M6d");

var $l5fpF = parcelRequire("l5fpF");
var $aDSao = parcelRequire("aDSao");

var $1gL54 = parcelRequire("1gL54");

var $kMd25 = parcelRequire("kMd25");
function $3b02354e1959a468$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3b02354e1959a468$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3b02354e1959a468$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3b02354e1959a468$var$_typeof(obj);
}
function $3b02354e1959a468$var$_slicedToArray(arr, i) {
    return $3b02354e1959a468$var$_arrayWithHoles(arr) || $3b02354e1959a468$var$_iterableToArrayLimit(arr, i) || $3b02354e1959a468$var$_nonIterableRest();
}
function $3b02354e1959a468$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $3b02354e1959a468$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3b02354e1959a468$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b02354e1959a468$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3b02354e1959a468$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3b02354e1959a468$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3b02354e1959a468$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3b02354e1959a468$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $3b02354e1959a468$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $3b02354e1959a468$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $3b02354e1959a468$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $gduQK.default)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $3b02354e1959a468$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1];
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $3b02354e1959a468$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ($3b02354e1959a468$var$_typeof(optionsOrDefaultCountry) === 'object') {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($3b02354e1959a468$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $54M6d.default)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $l5fpF.default)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $1gL54.default)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset(this.defaultCountry, this.defaultCallingCode);
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var _this$state = this.state, digits = _this$state.digits, country = _this$state.country; // If no digits have been input yet,
                // then `this.country` is the `defaultCountry`.
                // Won't return the `defaultCountry` in such case.
                if (!digits) return;
                var countryCode = country;
                /* istanbul ignore if */ if ($3b02354e1959a468$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) // `AsYouType.getCountry()` returns `undefined`
                // for "non-geographic" phone numbering plans.
                {
                    if (countryCode === '001') countryCode = undefined;
                }
                return countryCode;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state2 = this.state, nationalSignificantNumber = _this$state2.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state2.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state2.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $aDSao.DIGIT_PLACEHOLDER));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $kMd25.default)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode;
                if (this.isInternational()) {
                    if (!this.state.callingCode) return;
                } else {
                    if (!this.state.country && !this.defaultCallingCode) return;
                }
                if (!nationalSignificantNumber) return;
                var countryCode = this.getCountry();
                var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
                var phoneNumber = new (0, $7Smoa.default)(countryCode || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();

});
parcelRegister("54M6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b22a2f86de092fd$export$2e2bcd8739ae039; });
function $3b22a2f86de092fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3b22a2f86de092fd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3b22a2f86de092fd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3b22a2f86de092fd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3b22a2f86de092fd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3b22a2f86de092fd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3b22a2f86de092fd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var _this = this;
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $3b22a2f86de092fd$var$_classCallCheck(this, AsYouTypeState);
        $3b22a2f86de092fd$var$_defineProperty(this, "update", function(properties) {
            for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                var key = _Object$keys[_i];
                _this[key] = properties[key];
            }
        });
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $3b22a2f86de092fd$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(defaultCountry, defaultCallingCode) {
                this.international = false;
                this.IDDPrefix = undefined;
                this.missingPlus = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                return this.onCallingCodeChange(this.country, callingCode);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber() {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode();
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();

});

parcelRegister("l5fpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f59605527552a2a8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DIGIT_PLACEHOLDER", function () { return (parcelRequire("aDSao")).DIGIT_PLACEHOLDER; });

var $aDSao = parcelRequire("aDSao");

var $erdtY = parcelRequire("erdtY");

var $7zd5W = parcelRequire("7zd5W");

var $9EHK1 = parcelRequire("9EHK1");

var $d7zKk = parcelRequire("d7zKk");

var $aEFmc = parcelRequire("aEFmc");
function $f59605527552a2a8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f59605527552a2a8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f59605527552a2a8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f59605527552a2a8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f59605527552a2a8$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f59605527552a2a8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Could be any digit, I guess.
var $f59605527552a2a8$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $f59605527552a2a8$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $f59605527552a2a8$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $aDSao.repeat)($f59605527552a2a8$var$DUMMY_DIGIT, $f59605527552a2a8$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $f59605527552a2a8$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $f59605527552a2a8$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $f59605527552a2a8$var$CREATE_CHARACTER_CLASS_PATTERN = $f59605527552a2a8$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $f59605527552a2a8$var$CREATE_STANDALONE_DIGIT_PATTERN = $f59605527552a2a8$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $f59605527552a2a8$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp("^[" + (0, $d7zKk.VALID_PUNCTUATION) + ']*' + '(\\$\\d[' + (0, $d7zKk.VALID_PUNCTUATION) + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $f59605527552a2a8$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $f59605527552a2a8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var _this = this;
        var state = _ref.state, metadata = _ref.metadata;
        $f59605527552a2a8$var$_classCallCheck(this, AsYouTypeFormatter);
        $f59605527552a2a8$var$_defineProperty(this, "getSeparatorAfterNationalPrefix", function(format) {
            // `US` metadata doesn't have a `national_prefix_formatting_rule`,
            // so the `if` condition below doesn't apply to `US`,
            // but in reality there shoudl be a separator
            // between a national prefix and a national (significant) number.
            // So `US` national prefix separator is a "special" "hardcoded" case.
            if (_this.isNANP) return ' ';
             // If a `format` has a `national_prefix_formatting_rule`
            // and that rule has a separator after a national prefix,
            // then it means that there should be a separator
            // between a national prefix and a national (significant) number.
            if (format && format.nationalPrefixFormattingRule() && $f59605527552a2a8$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
             // At this point, there seems to be no clear evidence that
            // there should be a separator between a national prefix
            // and a national (significant) number. So don't insert one.
            return '';
        });
        $f59605527552a2a8$var$_defineProperty(this, "shouldTryNationalPrefixFormattingRule", function(format, _ref2) {
            var international = _ref2.international, nationalPrefix = _ref2.nationalPrefix;
            if (format.nationalPrefixFormattingRule()) {
                // In some countries, `national_prefix_formatting_rule` is `($1)`,
                // so it applies even if the user hasn't input a national prefix.
                // `format.usesNationalPrefix()` detects such cases.
                var usesNationalPrefix = format.usesNationalPrefix();
                if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
            }
        });
        this.metadata = metadata;
        this.resetFormat();
    }
    $f59605527552a2a8$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this2 = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $erdtY.canFormatCompleteNumber)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                    var _ref3;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref3 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref3 = _i.value;
                    }
                    var format = _ref3;
                    var formattedCompleteNumber = (0, $erdtY.default)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this2.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $aDSao.DIGIT_PLACEHOLDER)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $aDSao.DIGIT_PLACEHOLDER));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref4) {
                var _this3 = this;
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, nationalPrefix = _ref4.nationalPrefix, international = _ref4.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $f59605527552a2a8$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                if (leadingDigits.length < $f59605527552a2a8$var$MIN_LEADING_DIGITS_LENGTH) return true;
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
                // then format matching starts narrowing down the list of possible formats
                // (only previously matched formats are considered for next digits).
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
                // all or-ed (`|`) parts, not just the first one.
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this4 = this;
                var _loop2 = function _loop2() {
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) return "break";
                        _ref5 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) return "break";
                        _ref5 = _i2.value;
                    }
                    var format = _ref5;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this4.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$f59605527552a2a8$var$NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state.international))) return "continue";
                    if (!_this4.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this4.matchingFormats = _this4.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this4.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                _loop: for(var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                    var _ref5;
                    var _ret = _loop2();
                    switch(_ret){
                        case "break":
                            break _loop;
                        case "continue":
                            continue;
                    }
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($f59605527552a2a8$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
                var IDDPrefix = _ref6.IDDPrefix, missingPlus = _ref6.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $aDSao.DIGIT_PLACEHOLDER), index + 1);
                    i++;
                }
                return (0, $aDSao.cutAndStripNonPairedParens)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $aDSao.DIGIT_PLACEHOLDER)) + (0, $aDSao.repeat)((0, $aDSao.DIGIT_PLACEHOLDER), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref7) {
                var nationalSignificantNumber = _ref7.nationalSignificantNumber, international = _ref7.international, nationalPrefix = _ref7.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($f59605527552a2a8$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($f59605527552a2a8$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($f59605527552a2a8$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $f59605527552a2a8$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $f59605527552a2a8$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $9EHK1.FIRST_GROUP_PATTERN), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $7zd5W.default)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $7zd5W.default)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $aDSao.DIGIT_PLACEHOLDER));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($f59605527552a2a8$var$DUMMY_DIGIT, 'g'), (0, $aDSao.DIGIT_PLACEHOLDER)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $aDSao.repeat)((0, $aDSao.DIGIT_PLACEHOLDER), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $aDSao.repeat)((0, $aDSao.DIGIT_PLACEHOLDER), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $aEFmc.default)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $aDSao.populateTemplateWithDigits)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $aDSao.cutAndStripNonPairedParens)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        }
    ]);
    return AsYouTypeFormatter;
}();

});
parcelRegister("aDSao", function(module, exports) {

$parcel$export(module.exports, "DIGIT_PLACEHOLDER", function () { return $7bf79044a42778ee$export$2a0174a7c311f338; });
$parcel$export(module.exports, "repeat", function () { return $7bf79044a42778ee$export$76d90c956114f2c2; });
$parcel$export(module.exports, "cutAndStripNonPairedParens", function () { return $7bf79044a42778ee$export$ac095dcff0205861; });
$parcel$export(module.exports, "populateTemplateWithDigits", function () { return $7bf79044a42778ee$export$a15547494b55ca4e; });
// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var $7bf79044a42778ee$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $7bf79044a42778ee$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($7bf79044a42778ee$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $7bf79044a42778ee$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var character = _ref;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $7bf79044a42778ee$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $7bf79044a42778ee$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $7bf79044a42778ee$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $7bf79044a42778ee$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $7bf79044a42778ee$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $7bf79044a42778ee$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $7bf79044a42778ee$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++){
        var index = _dangling_braces[_i2];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $7bf79044a42778ee$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = digits.split(''), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
        var _ref2;
        if (_isArray2) {
            if (_i3 >= _iterator2.length) break;
            _ref2 = _iterator2[_i3++];
        } else {
            _i3 = _iterator2.next();
            if (_i3.done) break;
            _ref2 = _i3.value;
        }
        var digit = _ref2;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($7bf79044a42778ee$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($7bf79044a42778ee$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($7bf79044a42778ee$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}

});

parcelRegister("erdtY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a82e0ba0e1ad95f9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "canFormatCompleteNumber", function () { return $a82e0ba0e1ad95f9$export$9e33d25ea5d3e526; });

var $bJAjw = parcelRequire("bJAjw");

var $7zd5W = parcelRequire("7zd5W");

var $9EHK1 = parcelRequire("9EHK1");
function $a82e0ba0e1ad95f9$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $a82e0ba0e1ad95f9$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $a82e0ba0e1ad95f9$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $bJAjw.default)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $a82e0ba0e1ad95f9$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $a82e0ba0e1ad95f9$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $a82e0ba0e1ad95f9$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $a82e0ba0e1ad95f9$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $9EHK1.default)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($a82e0ba0e1ad95f9$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $a82e0ba0e1ad95f9$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $7zd5W.default)(formattedNationalNumber) === state.getNationalDigits();
}

});


parcelRegister("1gL54", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ecbce592be4bcbf$export$2e2bcd8739ae039; });

var $5hKFp = parcelRequire("5hKFp");

var $bDn2E = parcelRequire("bDn2E");

var $jbBLp = parcelRequire("jbBLp");

var $hbkEH = parcelRequire("hbkEH");

var $7zd5W = parcelRequire("7zd5W");

var $d7zKk = parcelRequire("d7zKk");
function $0ecbce592be4bcbf$var$_slicedToArray(arr, i) {
    return $0ecbce592be4bcbf$var$_arrayWithHoles(arr) || $0ecbce592be4bcbf$var$_iterableToArrayLimit(arr, i) || $0ecbce592be4bcbf$var$_nonIterableRest();
}
function $0ecbce592be4bcbf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $0ecbce592be4bcbf$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0ecbce592be4bcbf$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0ecbce592be4bcbf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0ecbce592be4bcbf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0ecbce592be4bcbf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0ecbce592be4bcbf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0ecbce592be4bcbf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0ecbce592be4bcbf$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $d7zKk.VALID_PUNCTUATION) + (0, $d7zKk.VALID_DIGITS) + ']+';
var $0ecbce592be4bcbf$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $0ecbce592be4bcbf$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $0ecbce592be4bcbf$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $d7zKk.PLUS_CHARS) + ']' + '[' + (0, $d7zKk.VALID_PUNCTUATION) + (0, $d7zKk.VALID_DIGITS) + ']*' + '|' + '[' + (0, $d7zKk.VALID_PUNCTUATION) + (0, $d7zKk.VALID_DIGITS) + ']+' + ')';
var $0ecbce592be4bcbf$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $d7zKk.VALID_PUNCTUATION) + (0, $d7zKk.VALID_DIGITS) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $0ecbce592be4bcbf$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $0ecbce592be4bcbf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $0ecbce592be4bcbf$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $0ecbce592be4bcbf$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $0ecbce592be4bcbf$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $0ecbce592be4bcbf$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $7zd5W.default)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $5hKFp.default)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $0ecbce592be4bcbf$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $jbBLp.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $jbBLp.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, state.update)) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $hbkEH.default)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state);
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $bDn2E.default)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state);
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state) {
                state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $0ecbce592be4bcbf$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($0ecbce592be4bcbf$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($0ecbce592be4bcbf$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $0ecbce592be4bcbf$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $0ecbce592be4bcbf$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $0ecbce592be4bcbf$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $0ecbce592be4bcbf$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $0ecbce592be4bcbf$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$0ecbce592be4bcbf$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}

});



parcelRegister("raeIM", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $051a76797807c921$export$d9468344d3651243; });

var $bP4Vr = parcelRequire("bP4Vr");

var $lUcTx = parcelRequire("lUcTx");
function $051a76797807c921$export$d9468344d3651243() {
    return (0, $bP4Vr.withMetadata)((0, $lUcTx.default), arguments);
}

});
parcelRegister("lUcTx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff28d49019c4a2f9$export$2e2bcd8739ae039; });

var $9HWjP = parcelRequire("9HWjP");

var $6Ly25 = parcelRequire("6Ly25");
function $ff28d49019c4a2f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ff28d49019c4a2f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ff28d49019c4a2f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ff28d49019c4a2f9$var$_typeof(obj);
}
function $ff28d49019c4a2f9$var$_slicedToArray(arr, i) {
    return $ff28d49019c4a2f9$var$_arrayWithHoles(arr) || $ff28d49019c4a2f9$var$_iterableToArrayLimit(arr, i) || $ff28d49019c4a2f9$var$_nonIterableRest();
}
function $ff28d49019c4a2f9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $ff28d49019c4a2f9$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ff28d49019c4a2f9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ff28d49019c4a2f9$export$2e2bcd8739ae039() {
    var _normalizeArguments = $ff28d49019c4a2f9$var$normalizeArguments(arguments), input = _normalizeArguments.input, format = _normalizeArguments.format, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $9HWjP.default)(input, format, options, metadata);
} // Sort out arguments
function $ff28d49019c4a2f9$var$normalizeArguments(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $ff28d49019c4a2f9$var$_slicedToArray(_Array$prototype$slic, 5), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3], arg_5 = _Array$prototype$slic2[4];
    var input;
    var format;
    var options;
    var metadata; // Sort out arguments.
    // If the phone number is passed as a string.
    // `format('8005553535', ...)`.
    if (typeof arg_1 === 'string') {
        // If country code is supplied.
        // `format('8005553535', 'RU', 'NATIONAL', [options], metadata)`.
        if (typeof arg_3 === 'string') {
            format = arg_3;
            if (arg_5) {
                options = arg_4;
                metadata = arg_5;
            } else metadata = arg_4;
            input = (0, $6Ly25.default)(arg_1, {
                defaultCountry: arg_2,
                extended: true
            }, metadata);
        } else {
            if (typeof arg_2 !== 'string') throw new Error('`format` argument not passed to `formatNumber(number, format)`');
            format = arg_2;
            if (arg_4) {
                options = arg_3;
                metadata = arg_4;
            } else metadata = arg_3;
            input = (0, $6Ly25.default)(arg_1, {
                extended: true
            }, metadata);
        }
    } else if ($ff28d49019c4a2f9$var$is_object(arg_1)) {
        input = arg_1;
        format = arg_2;
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else metadata = arg_3;
    } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.'); // Legacy lowercase formats.
    if (format === 'International') format = 'INTERNATIONAL';
    else if (format === 'National') format = 'NATIONAL';
    return {
        input: input,
        format: format,
        options: options,
        metadata: metadata
    };
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $ff28d49019c4a2f9$var$is_object = function is_object(_) {
    return $ff28d49019c4a2f9$var$_typeof(_) === 'object';
};

});



parcelRegister("7Zu6k", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", function () { return $7fe2731995de23d9$export$ac16a6a04d9b7c84; });
$parcel$export(module.exports, "WhitePrimaryButton", function () { return $7fe2731995de23d9$export$947e0cc46158e2; });
$parcel$export(module.exports, "GrayPrimaryButton", function () { return $7fe2731995de23d9$export$b672f2d22759bcfb; });
$parcel$export(module.exports, "BluePrimaryButton", function () { return $7fe2731995de23d9$export$8c10ecd4c748a259; });
$parcel$export(module.exports, "PrimaryLink", function () { return $7fe2731995de23d9$export$238528861f43da33; });
$parcel$export(module.exports, "PrimaryExternalLink", function () { return $7fe2731995de23d9$export$e4f579bc9a0ea412; });

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");

var $bewhU = parcelRequire("bewhU");
var $7fe2731995de23d9$export$9a725b402a0e842a = /*#__PURE__*/ function(ButtonHorizontalPadding) {
    ButtonHorizontalPadding["XS"] = "0px";
    ButtonHorizontalPadding["S"] = "46px";
    ButtonHorizontalPadding["M"] = "76px";
    ButtonHorizontalPadding["L"] = "102px";
    return ButtonHorizontalPadding;
}({});
const $7fe2731995de23d9$var$getCommonStyle = (paddingType)=>(0, $jb8NR.css)`
  padding: 13px ${$7fe2731995de23d9$export$9a725b402a0e842a[paddingType]};
  border-radius: 25px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  background-color: #000000;
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).boldText};
  line-height: normal;
  text-align: center;
  color: #ffffff;

  &:focus,
  &:active,
  &:hover {
    background-color: #3d3d3d;
  }
  &:disabled {
    background-color: #b1b1b1;
    color: #ffffff;
  }
`;
const $7fe2731995de23d9$export$ac16a6a04d9b7c84 = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(props)=>$7fe2731995de23d9$var$getCommonStyle(props.size)};
`;
const $7fe2731995de23d9$export$947e0cc46158e2 = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(props)=>$7fe2731995de23d9$var$getCommonStyle(props.size)};
  background-color: #ffffff;
  color: #000000;
  &:focus,
  &:active,
  &:hover {
    background-color: #f9f9f9;
  }
`;
const $7fe2731995de23d9$export$b672f2d22759bcfb = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(props)=>$7fe2731995de23d9$var$getCommonStyle(props.size)};
  background-color: #d1d1d1;
  color: #000000;
  &:focus,
  &:active,
  &:hover {
    background-color: #b1b1b1;
  }
`;
const $7fe2731995de23d9$export$8c10ecd4c748a259 = (0, $jb8NR.default)($7fe2731995de23d9$export$ac16a6a04d9b7c84)`
  background-color: ${(0, $22v9q.theme).colors.blue[700]};

  &:focus,
  &:active,
  &:hover {
    background-color: #022b72;
  }
`;
const $7fe2731995de23d9$export$238528861f43da33 = (0, $jb8NR.default)((0, $bewhU.DefaultLink))`
  ${(props)=>$7fe2731995de23d9$var$getCommonStyle(props.size)};
`;
const $7fe2731995de23d9$export$e4f579bc9a0ea412 = (0, $jb8NR.default)((0, $bewhU.DefaultExternalLink))`
  ${(props)=>$7fe2731995de23d9$var$getCommonStyle(props.size)};
`;

});
parcelRegister("bewhU", function(module, exports) {

$parcel$export(module.exports, "DefaultButton", function () { return $24d35c234b712199$export$b7c3a2f69225ecf; });
$parcel$export(module.exports, "UnstyledButton", function () { return $24d35c234b712199$export$3167f6ecaaaa3457; });
$parcel$export(module.exports, "DefaultLink", function () { return $24d35c234b712199$export$59d1b06f370beb91; });
$parcel$export(module.exports, "DefaultExternalLink", function () { return $24d35c234b712199$export$72f473a41367cc83; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $b8ojz = parcelRequire("b8ojz");

var $jb8NR = parcelRequire("jb8NR");

var $k4kME = parcelRequire("k4kME");
const $24d35c234b712199$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $6uYXW.forwardRef)((props, ref)=>{
    const { showSpinner: showSpinner = false, spinnerColor: spinnerColor = "inherit", spinnerSize: spinnerSize = "20px", children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($24d35c234b712199$var$Button, {
        ref: ref,
        $noPointerEvents: showSpinner,
        ...rest,
        children: [
            showSpinner && /*#__PURE__*/ (0, $4m918.jsx)($24d35c234b712199$var$StyledSpinner, {
                size: spinnerSize,
                color: spinnerColor
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($24d35c234b712199$var$ButtonContent, {
                $hide: showSpinner,
                children: children
            })
        ]
    });
});
const $24d35c234b712199$export$3167f6ecaaaa3457 = /*#__PURE__*/ (0, $6uYXW.forwardRef)((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($24d35c234b712199$var$NoAppearanceButton, {
        ref: ref,
        ...rest,
        children: children
    });
});
const $24d35c234b712199$var$commonStyle = (0, $jb8NR.css)`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  appearance: none;
  border: none;

  /* The ring is dropped for the pointer, which does not need it, and kept for the keyboard,
     which has nothing else to go by. */
  outline: none;

  &:focus-visible {
    outline: 2px solid #003da5;
    outline-offset: 2px;
  }

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: auto;
  }
`;
const $24d35c234b712199$export$59d1b06f370beb91 = (0, $jb8NR.default)((0, $b8ojz.Link))`
  ${$24d35c234b712199$var$commonStyle};
`;
const $24d35c234b712199$export$72f473a41367cc83 = (0, $jb8NR.default).a`
  ${$24d35c234b712199$var$commonStyle};
`;
const $24d35c234b712199$var$Button = (0, $jb8NR.default).button`
  ${({ $noPointerEvents: noPointersEvents })=>noPointersEvents && (0, $jb8NR.css)`
      pointer-events: none;
    `};
  ${$24d35c234b712199$var$commonStyle}
`;
const $24d35c234b712199$var$StyledSpinner = (0, $jb8NR.default)((0, $k4kME.Spinner))`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $24d35c234b712199$var$ButtonContent = (0, $jb8NR.default).div`
  opacity: ${(props)=>props.$hide ? 0 : 1};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const $24d35c234b712199$var$NoAppearanceButton = (0, $jb8NR.default).button`
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;

  /* The ring is dropped for the pointer, which does not need it, and kept for the keyboard,
     which has nothing else to go by. */
  outline: none;

  &:focus-visible {
    outline: 2px solid #003da5;
    outline-offset: 2px;
  }

  &:hover {
    opacity: 0.8;
  }
`;

});
parcelRegister("k4kME", function(module, exports) {

$parcel$export(module.exports, "Spinner", function () { return $729e466104599bcc$export$7f7cbe89f1eacd2; });
$parcel$export(module.exports, "MainColorSpinner", function () { return $729e466104599bcc$export$82f384907d528ec8; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
function $729e466104599bcc$export$7f7cbe89f1eacd2(props) {
    const { size: size = "30px", color: color = "currentColor", ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)("div", {
        ...rest,
        children: /*#__PURE__*/ (0, $4m918.jsx)($729e466104599bcc$var$Loader, {
            size: size,
            color: color
        })
    });
}
const $729e466104599bcc$export$82f384907d528ec8 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)($729e466104599bcc$export$7f7cbe89f1eacd2, {
        color: (0, $22v9q.theme).mainColor(),
        ...props
    });
const $729e466104599bcc$var$clip = (0, $jb8NR.keyframes)`
  0% {transform: rotate(0deg) scale(1)}
  50% {transform: rotate(180deg) scale(0.8)}
  100% {transform: rotate(360deg) scale(1)}
`;
const $729e466104599bcc$var$Loader = (0, $jb8NR.default).div`
  background: transparent;
  width: ${({ size: size })=>size};
  height: ${({ size: size })=>size};
  border-radius: 100%;
  border: 2px solid;
  border-color: ${({ color: color })=>color};
  border-bottom-color: transparent;
  animation: ${$729e466104599bcc$var$clip} 0.75s 0s infinite linear;
  animation-fill-mode: both;
`;

});



parcelRegister("amCCH", function(module, exports) {

$parcel$export(module.exports, "PageHeader", function () { return $01009f39f92f5ddf$export$53f1cd6809577fc5; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $7XqbX = parcelRequire("7XqbX");

var $jEKif = parcelRequire("jEKif");
const $01009f39f92f5ddf$export$53f1cd6809577fc5 = ({ title: title, description: description, children: children })=>{
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($01009f39f92f5ddf$var$StyledPageHeader, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($01009f39f92f5ddf$var$StyledTitlesContainer, {
                $isRTL: isRTL,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $jEKif.PageSectionTitle), {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $4m918.jsx)((0, $jEKif.PageSectionDescription), {
                        children: description
                    })
                ]
            }),
            children && children
        ]
    });
};
const $01009f39f92f5ddf$var$StyledTitlesContainer = (0, $jb8NR.default).div`
  margin-right: ${({ $isRTL: $isRTL })=>$isRTL ? 0 : 10}px;
  margin-left: ${({ $isRTL: $isRTL })=>$isRTL ? 10 : 0}px;
`;
const $01009f39f92f5ddf$var$StyledPageHeader = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
`;

});
parcelRegister("yYT9n", function(module, exports) {

$parcel$export(module.exports, "useRTL", function () { return $51b8f9c6ffd88266$export$81f015b3ec5d61cf; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");
function $51b8f9c6ffd88266$export$81f015b3ec5d61cf() {
    const isRTL = (0, $3Ersk.useObservable)((0, $kqXxS.i18NManager).isRTL);
    (0, $6uYXW.useEffect)(()=>{
        document.body.dir = isRTL ? "rtl" : "ltr";
    }, [
        isRTL
    ]);
    return {
        isRTL: isRTL
    };
}

});

parcelRegister("7XqbX", function(module, exports) {

$parcel$export(module.exports, "UIConstants", function () { return $c7508e155e7acd1e$export$82198aeea667c851; });
const $c7508e155e7acd1e$export$82198aeea667c851 = {
    PAGE_MAX_WIDTH: 2000,
    CONTENT_HORIZONTAL_PADDING_NOT_DESKTOP: 20,
    CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL: 50,
    CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE: 70,
    NAV_WIDTH: 285,
    NAV_WIDTH_REDUCED: 80,
    NAV_LEFT_MARGIN_DESKTOP_SMALL: 0,
    NAV_LEFT_MARGIN_DESKTOP_LARGE: 0,
    ACCOUNT_TILE_WIDTH_NOT_MOBILE: 392,
    ACCOUNT_TILE_WIDTH_MOBILE: 250,
    CARD_TILE_WIDTH_NOT_MOBILE: 291,
    CARD_TILE_WIDTH_MOBILE: 250,
    TABLET_BREAKPOINT: 768,
    PHONE_BREAKPOINT: 450,
    DESKTOP_SMALL_BREAKPOINT: 1024,
    DESKTOP_LARGE_BREAKPOINT: 1440,
    MODAL_WIDTH: 420,
    CONTACT_TILE_WIDTH_NOT_MOBILE: 392,
    CONTACT_TILE_WIDTH_MOBILE: 300,
    DESKTOP_EXTRA_LARGE_BREAKPOINT: 1640,
    PROFILE_GRID_WIDTH_BREAKPOINT: 1204
};

});

parcelRegister("jEKif", function(module, exports) {

$parcel$export(module.exports, "PageSectionTitle", function () { return $9746e78e000a03d2$export$1f8437f84ff8cea; });
$parcel$export(module.exports, "PageSectionDescription", function () { return $9746e78e000a03d2$export$2107bd1a19727ccd; });

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
const $9746e78e000a03d2$export$1f8437f84ff8cea = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.125rem;
  margin: 5px 0;
`;
const $9746e78e000a03d2$export$2107bd1a19727ccd = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).bodyGreyRegular}
`;

});



parcelRegister("cJ83d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59d2a9411fc754cf$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $9mhzx = parcelRequire("9mhzx");

var $e0mue = parcelRequire("e0mue");

var $4Nwuw = parcelRequire("4Nwuw");
function $59d2a9411fc754cf$export$2e2bcd8739ae039() {
    const accounts = (0, $9mhzx.useAccounts)();
    const [account] = (0, $e0mue.useSelectedAccount)(accounts);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    if (!account) return null;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4Nwuw.StatementsPage), {
        account: account,
        accounts: accounts,
        variant: "normal",
        title: formatMessage("myAccountScreen.accountStatement"),
        subtitle: formatMessage("myAccountScreen.accountStatementPageSubtitle"),
        emptyLabel: formatMessage("accountsStatements.emptyStatementList")
    });
}

});
parcelRegister("9mhzx", function(module, exports) {

$parcel$export(module.exports, "useAccounts", function () { return $44af50b00659eb5b$export$c229550bd86eba85; });

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $44af50b00659eb5b$export$c229550bd86eba85 = ()=>{
    const accounts = (0, $3Ersk.useObservable)((0, $kqXxS.accountManager).accounts);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await (0, $kqXxS.accountManager).load();
    }, []);
    return accounts;
};

});

parcelRegister("e0mue", function(module, exports) {

$parcel$export(module.exports, "ACCOUNT_QUERY_PARAM", function () { return $6223f61d71031673$export$6fc39344a0581674; });
$parcel$export(module.exports, "useSelectedAccount", function () { return $6223f61d71031673$export$5e36d435e3a6a871; });

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $k4Ecv = parcelRequire("k4Ecv");

var $31CeI = parcelRequire("31CeI");
const $6223f61d71031673$export$6fc39344a0581674 = "account";
const $6223f61d71031673$export$5e36d435e3a6a871 = (accounts)=>{
    const accountId = (0, $31CeI.useQueryParam)($6223f61d71031673$export$6fc39344a0581674);
    const history = (0, $NQIVp.useHistory)();
    const accountState = (0, $6uYXW.useState)(accounts.find((account)=>account.id === accountId) ?? null);
    const [selectedAccount, setSelectedAccount] = accountState;
    if (selectedAccount === null && accounts && (0, $k4Ecv.isAnNotEmptyArray)(accounts)) setSelectedAccount(accounts.find((account)=>account.id === accountId) ?? accounts[0]);
    if ((accounts === null || !(0, $k4Ecv.isAnNotEmptyArray)(accounts)) && selectedAccount) setSelectedAccount(null);
    (0, $6uYXW.useEffect)(()=>{
        setSelectedAccount(accounts.find((account)=>account.id === accountId) ?? null);
    }, [
        accountId,
        accounts,
        setSelectedAccount
    ]);
    (0, $6uYXW.useEffect)(()=>{
        selectedAccount && history.push({
            search: `?${$6223f61d71031673$export$6fc39344a0581674}=${selectedAccount.id}`
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedAccount
    ]);
    return accountState;
};

});
parcelRegister("31CeI", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", function () { return $aca8eee95978b349$export$ae316f0eeb712a36; });

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");
function $aca8eee95978b349$export$ae316f0eeb712a36(param) {
    const location = (0, $NQIVp.useLocation)();
    return (0, $6uYXW.useMemo)(()=>new URLSearchParams(location.search).get(param), [
        location,
        param
    ]);
}

});


parcelRegister("4Nwuw", function(module, exports) {

$parcel$export(module.exports, "StatementsPage", function () { return $5120e9838de330ca$export$4a34a953774f2ed7; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $bewhU = parcelRequire("bewhU");

var $3yEBF = parcelRequire("3yEBF");

var $8JW2B = parcelRequire("8JW2B");

var $k4kME = parcelRequire("k4kME");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");
function $5120e9838de330ca$export$4a34a953774f2ed7(props) {
    const { account: account, accounts: accounts, variant: variant, title: title, subtitle: subtitle, emptyLabel: emptyLabel } = props;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const { goBack: goBack } = (0, $NQIVp.useHistory)();
    const [entries, setEntries] = (0, $6uYXW.useState)(null);
    const [selectedAccounts, setSelectedAccounts] = (0, $6uYXW.useState)([]);
    const [selectedYears, setSelectedYears] = (0, $6uYXW.useState)([]);
    const scope = (0, $6uYXW.useMemo)(()=>accounts.length > 0 ? accounts : [
            account
        ], [
        accounts,
        account
    ]);
    (0, $6uYXW.useEffect)(()=>{
        const fetchStatements = variant === "fee" ? (0, $kqXxS.accountStatementService).fetchFeesStatements : (0, $kqXxS.accountStatementService).fetchStatements;
        Promise.all(scope.map(async (it)=>{
            try {
                const page = await fetchStatements.call((0, $kqXxS.accountStatementService), it.id);
                return (page?.items ?? []).map((statement)=>({
                        statement: statement,
                        account: it
                    }));
            } catch (e) {
                (0, $6JVVB.logger).debug("StatementsPage", "Failed to fetch statements", e);
                return [];
            }
        })).then((pages)=>setEntries(pages.flat()));
    }, [
        scope,
        variant
    ]);
    const items = entries ?? [];
    // Each kind keeps its own labels, so a tenant can word them differently.
    const accountLabelKey = variant === "fee" ? "feesStatements.accountLabel" : "accountsStatements.accountLabel";
    const accountOptions = (0, $6uYXW.useMemo)(()=>[
            ...new Set(items.map((it)=>it.account.id))
        ].map((id)=>({
                id: id
            })), [
        items
    ]);
    const yearOptions = (0, $6uYXW.useMemo)(()=>[
            ...new Set(items.map((it)=>String(new Date(it.statement.fromDate).getFullYear())))
        ].sort().reverse().map((id)=>({
                id: id
            })), [
        items
    ]);
    const keptAccounts = selectedAccounts.map((it)=>it.id);
    const keptYears = selectedYears.map((it)=>it.id);
    // No selection means no restriction, the way the mobile filters behave.
    const visibleItems = items.filter((it)=>(keptAccounts.length === 0 || keptAccounts.includes(it.account.id)) && (keptYears.length === 0 || keptYears.includes(String(new Date(it.statement.fromDate).getFullYear()))));
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $8JW2B.PageBackHeader), {
                title: title,
                subtitle: subtitle,
                account: account,
                onBack: goBack
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($5120e9838de330ca$var$Filters, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $3yEBF.MultiSelectInput), {
                        style: {
                            minWidth: "200px"
                        },
                        innerId: "statement-accounts",
                        selectedValues: selectedAccounts,
                        options: accountOptions,
                        placeholder: formatMessage("statementsFilters.allAgencies"),
                        itemRenderer: (option)=>formatMessage(accountLabelKey, {
                                id: option.id
                            }),
                        onChange: setSelectedAccounts
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $3yEBF.MultiSelectInput), {
                        style: {
                            minWidth: "160px"
                        },
                        innerId: "statement-years",
                        selectedValues: selectedYears,
                        options: yearOptions,
                        placeholder: formatMessage("statementsFilters.years"),
                        itemRenderer: (option)=>option.id,
                        onChange: setSelectedYears
                    })
                ]
            }),
            entries === null ? /*#__PURE__*/ (0, $4m918.jsx)($5120e9838de330ca$var$LoaderRow, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "24px"
                })
            }) : visibleItems.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)($5120e9838de330ca$var$EmptyLabel, {
                children: emptyLabel
            }) : /*#__PURE__*/ (0, $4m918.jsx)($5120e9838de330ca$var$List, {
                children: visibleItems.map(({ statement: statement, account: owner })=>/*#__PURE__*/ (0, $4m918.jsxs)($5120e9838de330ca$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($5120e9838de330ca$var$RowTexts, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsxs)($5120e9838de330ca$var$Period, {
                                        children: [
                                            formatDate(statement.fromDate, {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric"
                                            }),
                                            " -",
                                            " ",
                                            formatDate(statement.toDate, {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($5120e9838de330ca$var$AccountLabel, {
                                        children: formatMessage(accountLabelKey, {
                                            id: owner.id
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($5120e9838de330ca$var$DownloadButton, {
                                "aria-label": formatMessage("myAccountScreen.downloadRib"),
                                onClick: ()=>(0, $kqXxS.accountStatementService).downloadStatement(owner.id, statement.id, variant),
                                children: /*#__PURE__*/ (0, $4m918.jsx)($5120e9838de330ca$var$DownloadIcon, {
                                    src: (0, $fRvTz.StaticAssets).download,
                                    alt: ""
                                })
                            })
                        ]
                    }, `${owner.id}-${statement.id}`))
            })
        ]
    });
}
const $5120e9838de330ca$var$Filters = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-bottom: 20px;
`;
const $5120e9838de330ca$var$List = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  overflow: hidden;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
  ${(0, $22v9q.shadows).sm};
`;
const $5120e9838de330ca$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  border-top: 1px solid ${(0, $22v9q.theme).colors.gray[100]};

  &:first-of-type {
    border-top: 0;
  }
`;
const $5120e9838de330ca$var$RowTexts = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const $5120e9838de330ca$var$Period = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 16px;
  line-height: 22px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $5120e9838de330ca$var$AccountLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 2px;
  font-size: 12px;
  line-height: 15px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $5120e9838de330ca$var$DownloadButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  flex-shrink: 0;
  padding: 4px;
`;
const $5120e9838de330ca$var$DownloadIcon = (0, $jb8NR.default).img`
  width: 18px;
  height: 18px;
`;
const $5120e9838de330ca$var$LoaderRow = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
`;
const $5120e9838de330ca$var$EmptyLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;

});
parcelRegister("3yEBF", function(module, exports) {

$parcel$export(module.exports, "MultiSelectInput", function () { return $347a1fccfd9ea737$export$5a8f20dde0180f76; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $bgHg3 = parcelRequire("bgHg3");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
function $347a1fccfd9ea737$export$5a8f20dde0180f76({ innerId: id, label: label, onChange: onChange, placeholder: placeholder, options: options, disabledOptions: disabledOptions, selectedValues: selectedValues, className: className, style: style, itemRenderer: itemRenderer = (v)=>`${v}`, ...rest }) {
    const castOptions = options.map((option)=>({
            value: option.id.toString(),
            label: itemRenderer(option),
            isDisabled: !!disabledOptions?.find((opt)=>opt.id === option.id)
        }));
    const castSelectedValues = selectedValues.map((option)=>({
            value: option.id.toString(),
            label: itemRenderer(option)
        }));
    const handleOnChange = (values)=>{
        onChange(values.map((val)=>options.find((option)=>option.id.toString() === (val.value !== "" ? val.value.trim() : ""))).filter((v)=>v !== undefined));
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($347a1fccfd9ea737$var$SelectContainer, {
        className: className,
        hasLabel: !!label,
        style: style,
        children: [
            label && /*#__PURE__*/ (0, $4m918.jsx)($347a1fccfd9ea737$var$Label, {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($347a1fccfd9ea737$var$SelectWrapper, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bgHg3.default), {
                    ...rest,
                    id: id,
                    className: "multi-select",
                    menuPortalTarget: document.body,
                    styles: {
                        menuPortal: (base)=>({
                                ...base,
                                zIndex: 2000000001
                            })
                    },
                    placeholder: placeholder,
                    defaultValue: castSelectedValues,
                    isMulti: true,
                    onChange: handleOnChange,
                    options: castOptions
                })
            })
        ]
    });
}
const $347a1fccfd9ea737$var$SelectContainer = (0, $jb8NR.default).div`
  display: inline-flex;
  flex-direction: ${(props)=>props.hasLabel ? "column" : "row"};
  flex-shrink: 1;
  flex-grow: 1;
  background-color: #ffffff;
  border-radius: 10px;
  ${(0, $22v9q.shadows).medium};
`;
const $347a1fccfd9ea737$var$Label = (0, $jb8NR.default).label`
  font-weight: 700;
  color: #000000;
  margin-bottom: 10px;
  font-size: 1rem;
`;
const $347a1fccfd9ea737$var$SelectWrapper = (0, $jb8NR.default).div`
  position: relative;
  flex-shrink: 1;
  flex-grow: 1;

  .multi-select {
    font-family: inherit;
    font-size: 0.875rem;
    ${(0, $22v9q.theme).mediumText};
    color: black;
    flex-shrink: 0;
    background-color: white;
    width: 100%;
  }
`;

});
parcelRegister("bgHg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8342be6ff814edb4$export$2e2bcd8739ae039; });

var $j6KjX = parcelRequire("j6KjX");

var $3jNg8 = parcelRequire("3jNg8");

var $a587z = parcelRequire("a587z");

var $hwUbf = parcelRequire("hwUbf");

var $h0Uae = parcelRequire("h0Uae");

var $f72IT = parcelRequire("f72IT");

var $6uYXW = parcelRequire("6uYXW");

var $2vniM = parcelRequire("2vniM");

var $7ItjZ = parcelRequire("7ItjZ");

var $4wHBI = parcelRequire("4wHBI");
parcelRequire("dBWLf");
parcelRequire("8Zamr");
parcelRequire("7U7y0");
parcelRequire("6OIJ6");
parcelRequire("alU2v");
parcelRequire("eF7NI");
parcelRequire("5WJXj");
parcelRequire("6JczY");
var $8342be6ff814edb4$export$a7deb1594c5ce10e = /*#__PURE__*/ function(_Component) {
    (0, $h0Uae.default)(NonceProvider, _Component);
    var _super = (0, $f72IT._)(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, $a587z.default)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce, key) {
            return (0, $7ItjZ.default)({
                nonce: nonce,
                key: key
            });
        };
        _this.createEmotionCache = (0, $4wHBI.default)(_this.createEmotionCache);
        return _this;
    }
    (0, $hwUbf.default)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $2vniM.C), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, $6uYXW.Component));
var $8342be6ff814edb4$var$index = (0, $3jNg8.m)((0, $j6KjX.S));
var $8342be6ff814edb4$export$2e2bcd8739ae039 = $8342be6ff814edb4$var$index;

});
parcelRegister("j6KjX", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $de92823810222d66$export$25ce5a424b770e84; });

var $jqghu = parcelRequire("jqghu");

var $f72IT = parcelRequire("f72IT");

var $a587z = parcelRequire("a587z");

var $hwUbf = parcelRequire("hwUbf");

var $h0Uae = parcelRequire("h0Uae");

var $8uPz0 = parcelRequire("8uPz0");

var $6uYXW = parcelRequire("6uYXW");

var $iJLNd = parcelRequire("iJLNd");

var $4wHBI = parcelRequire("4wHBI");

var $9DelO = parcelRequire("9DelO");
function $de92823810222d66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $de92823810222d66$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $de92823810222d66$var$A11yText = function A11yText(props) {
    return (0, $iJLNd.jsx)("span", (0, $jqghu.default)({
        css: $de92823810222d66$var$_ref
    }, props));
};
var $de92823810222d66$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, _props$focused = props.focused, focused = _props$focused === void 0 ? {} : _props$focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $de92823810222d66$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes
    var messages = (0, $6uYXW.useMemo)(function() {
        return (0, $f72IT.a)((0, $f72IT.a)({}, $de92823810222d66$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]); // Update aria live selected option when prop changes
    var ariaSelected = (0, $6uYXW.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, removedValue = ariaSelection.removedValue, value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            var selected = removedValue || option || asOption(value);
            var onChangeProps = (0, $f72IT.a)({
                isDisabled: selected && isOptionDisabled(selected),
                label: selected ? getOptionLabel(selected) : ''
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        isOptionDisabled,
        getOptionLabel,
        messages
    ]);
    var ariaFocused = (0, $6uYXW.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused),
                isSelected: isSelected,
                options: options,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        options,
        selectValue
    ]);
    var ariaResults = (0, $6uYXW.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $6uYXW.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    return (0, $iJLNd.jsx)($de92823810222d66$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && (0, $iJLNd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Fragment, null, (0, $iJLNd.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $iJLNd.jsx)("span", {
        id: "aria-context"
    }, ariaContext)));
};
var $de92823810222d66$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $de92823810222d66$var$anyDiacritic = new RegExp('[' + $de92823810222d66$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $de92823810222d66$var$diacriticToBase = {};
for(var $de92823810222d66$var$i = 0; $de92823810222d66$var$i < $de92823810222d66$var$diacritics.length; $de92823810222d66$var$i++){
    var $de92823810222d66$var$diacritic = $de92823810222d66$var$diacritics[$de92823810222d66$var$i];
    for(var $de92823810222d66$var$j = 0; $de92823810222d66$var$j < $de92823810222d66$var$diacritic.letters.length; $de92823810222d66$var$j++)$de92823810222d66$var$diacriticToBase[$de92823810222d66$var$diacritic.letters[$de92823810222d66$var$j]] = $de92823810222d66$var$diacritic.base;
}
var $de92823810222d66$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($de92823810222d66$var$anyDiacritic, function(match) {
        return $de92823810222d66$var$diacriticToBase[match];
    });
};
var $de92823810222d66$var$memoizedStripDiacriticsForInput = (0, $4wHBI.default)($de92823810222d66$var$stripDiacritics);
var $de92823810222d66$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $de92823810222d66$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $de92823810222d66$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        var _ignoreCase$ignoreAcc = (0, $f72IT.a)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $de92823810222d66$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $de92823810222d66$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $de92823810222d66$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $de92823810222d66$var$memoizedStripDiacriticsForInput(input);
            candidate = $de92823810222d66$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
function $de92823810222d66$var$DummyInput(_ref) {
    _ref.in;
    _ref.out;
    _ref.onExited;
    _ref.appear;
    _ref.enter;
    _ref.exit;
    var innerRef = _ref.innerRef;
    _ref.emotion;
    var props = (0, $9DelO.default)(_ref, [
        "in",
        "out",
        "onExited",
        "appear",
        "enter",
        "exit",
        "innerRef",
        "emotion"
    ]);
    return (0, $iJLNd.jsx)("input", (0, $jqghu.default)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, $iJLNd.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: 'inherit',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(0)'
        }, "", "")
    }));
}
var $de92823810222d66$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $de92823810222d66$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $6uYXW.useRef)(false);
    var isTop = (0, $6uYXW.useRef)(false);
    var touchStart = (0, $6uYXW.useRef)(0);
    var scrollTarget = (0, $6uYXW.useRef)(null);
    var handleEventDelta = (0, $6uYXW.useCallback)(function(event, delta) {
        // Reference should never be `null` at this point, but flow complains otherwise
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        } // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        } // cancel scroll
        if (shouldCancelScroll) $de92823810222d66$var$cancelScroll(event);
    }, []);
    var onWheel = (0, $6uYXW.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $6uYXW.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $6uYXW.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $6uYXW.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $f72IT.s) ? {
            passive: false
        } : false; // all the if statements are to appease Flow 😢
        if (typeof el.addEventListener === 'function') el.addEventListener('wheel', onWheel, notPassive);
        if (typeof el.addEventListener === 'function') el.addEventListener('touchstart', onTouchStart, notPassive);
        if (typeof el.addEventListener === 'function') el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $6uYXW.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return; // all the if statements are to appease Flow 😢
        if (typeof el.removeEventListener === 'function') el.removeEventListener('wheel', onWheel, false);
        if (typeof el.removeEventListener === 'function') el.removeEventListener('touchstart', onTouchStart, false);
        if (typeof el.removeEventListener === 'function') el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $6uYXW.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $de92823810222d66$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $de92823810222d66$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $de92823810222d66$var$preventTouchMove(e) {
    e.preventDefault();
}
function $de92823810222d66$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $de92823810222d66$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $de92823810222d66$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $de92823810222d66$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $de92823810222d66$var$activeScrollLocks = 0;
var $de92823810222d66$var$listenerOptions = {
    capture: false,
    passive: false
};
function $de92823810222d66$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $6uYXW.useRef)({});
    var scrollTarget = (0, $6uYXW.useRef)(null);
    var addScrollLock = (0, $6uYXW.useCallback)(function(touchScrollTarget) {
        if (!$de92823810222d66$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $de92823810222d66$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
         // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $de92823810222d66$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($de92823810222d66$var$LOCK_STYLES).forEach(function(key) {
                var val = $de92823810222d66$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        } // account for touch devices
        if (target && $de92823810222d66$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $de92823810222d66$var$preventTouchMove, $de92823810222d66$var$listenerOptions); // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $de92823810222d66$var$preventInertiaScroll, $de92823810222d66$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $de92823810222d66$var$allowTouchMove, $de92823810222d66$var$listenerOptions);
            }
        } // increment active scroll locks
        $de92823810222d66$var$activeScrollLocks += 1;
    }, []);
    var removeScrollLock = (0, $6uYXW.useCallback)(function(touchScrollTarget) {
        if (!$de92823810222d66$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style; // safely decrement active scroll locks
        $de92823810222d66$var$activeScrollLocks = Math.max($de92823810222d66$var$activeScrollLocks - 1, 0); // reapply original body styles, if any
        if (accountForScrollbars && $de92823810222d66$var$activeScrollLocks < 1) $de92823810222d66$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
         // remove touch listeners
        if (target && $de92823810222d66$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $de92823810222d66$var$preventTouchMove, $de92823810222d66$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $de92823810222d66$var$preventInertiaScroll, $de92823810222d66$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $de92823810222d66$var$allowTouchMove, $de92823810222d66$var$listenerOptions);
            }
        }
    }, []);
    (0, $6uYXW.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $de92823810222d66$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $de92823810222d66$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $de92823810222d66$var$_ref2 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $de92823810222d66$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $de92823810222d66$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $de92823810222d66$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $iJLNd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Fragment, null, lockEnabled && (0, $iJLNd.jsx)("div", {
        onClick: $de92823810222d66$var$blurSelectInput,
        css: $de92823810222d66$var$_ref2
    }), children(targetRef));
}
var $de92823810222d66$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $de92823810222d66$export$407448d2b89b1813 = function getOptionLabel(option) {
    return option.label;
};
var $de92823810222d66$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $de92823810222d66$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $de92823810222d66$var$defaultStyles = {
    clearIndicator: (0, $f72IT.b),
    container: (0, $f72IT.d),
    control: (0, $f72IT.e),
    dropdownIndicator: (0, $f72IT.f),
    group: (0, $f72IT.g),
    groupHeading: (0, $f72IT.h),
    indicatorsContainer: (0, $f72IT.i),
    indicatorSeparator: (0, $f72IT.j),
    input: (0, $f72IT.k),
    loadingIndicator: (0, $f72IT.l),
    loadingMessage: (0, $f72IT.m),
    menu: (0, $f72IT.n),
    menuList: (0, $f72IT.o),
    menuPortal: (0, $f72IT.p),
    multiValue: (0, $f72IT.q),
    multiValueLabel: (0, $f72IT.r),
    multiValueRemove: (0, $f72IT.t),
    noOptionsMessage: (0, $f72IT.u),
    option: (0, $f72IT.v),
    placeholder: (0, $f72IT.w),
    singleValue: (0, $f72IT.x),
    valueContainer: (0, $f72IT.y)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function $de92823810222d66$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $f72IT.a)({}, source); // massage in target styles
    Object.keys(target).forEach(function(key) {
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $de92823810222d66$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $de92823810222d66$var$borderRadius = 4; // Used to calculate consistent margin/padding on elements
var $de92823810222d66$var$baseUnit = 4; // The minimum height of the control
var $de92823810222d66$var$controlHeight = 38; // The amount of space between the control and menu */
var $de92823810222d66$var$menuGutter = $de92823810222d66$var$baseUnit * 2;
var $de92823810222d66$var$spacing = {
    baseUnit: $de92823810222d66$var$baseUnit,
    controlHeight: $de92823810222d66$var$controlHeight,
    menuGutter: $de92823810222d66$var$menuGutter
};
var $de92823810222d66$export$4368d992c4eafac0 = {
    borderRadius: $de92823810222d66$var$borderRadius,
    colors: $de92823810222d66$var$colors,
    spacing: $de92823810222d66$var$spacing
};
var $de92823810222d66$export$8b22cf2602fb60ce = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $f72IT.z)(),
    captureMenuScroll: !(0, $f72IT.z)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $de92823810222d66$export$db3b6bfb95261072(),
    formatGroupLabel: $de92823810222d66$var$formatGroupLabel,
    getOptionLabel: $de92823810222d66$export$407448d2b89b1813,
    getOptionValue: $de92823810222d66$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $de92823810222d66$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $f72IT.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: '0',
    tabSelectsValue: true
};
function $de92823810222d66$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $de92823810222d66$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $de92823810222d66$var$_isOptionSelected(props, option, selectValue);
    var label = $de92823810222d66$var$getOptionLabel$1(props, option);
    var value = $de92823810222d66$var$getOptionValue$1(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $de92823810222d66$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if (groupOrOption.options) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $de92823810222d66$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $de92823810222d66$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $de92823810222d66$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $de92823810222d66$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }) // Flow limitation (see https://github.com/facebook/flow/issues/1414)
    .filter(function(categorizedOption) {
        return !!categorizedOption;
    });
}
function $de92823810222d66$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $8uPz0.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $de92823810222d66$var$buildFocusableOptions(props, selectValue) {
    return $de92823810222d66$var$buildFocusableOptionsFromCategorizedOptions($de92823810222d66$var$buildCategorizedOptions(props, selectValue));
}
function $de92823810222d66$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$de92823810222d66$var$shouldHideSelectedOptions(props) || !isSelected) && $de92823810222d66$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $de92823810222d66$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $de92823810222d66$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $de92823810222d66$var$getOptionLabel$1 = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $de92823810222d66$var$getOptionValue$1 = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $de92823810222d66$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $de92823810222d66$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $de92823810222d66$var$getOptionValue$1(props, option);
    return selectValue.some(function(i) {
        return $de92823810222d66$var$getOptionValue$1(props, i) === candidate;
    });
}
function $de92823810222d66$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $de92823810222d66$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $de92823810222d66$var$instanceId = 1;
var $de92823810222d66$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $h0Uae.default)(Select, _Component);
    var _super = (0, $f72IT._)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $a587z.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
            var option = arguments.length > 2 ? arguments[2] : undefined;
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
            _this.onInputChange('', {
                action: 'set-value'
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                }), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue([].concat((0, $8uPz0.default)(selectValue), [
                    newValue
                ]), 'select-option', newValue);
                else _this.setValue(newValue, 'select-option');
            } else {
                _this.ariaOnChange(newValue, {
                    action: 'select-option',
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange(_this.props.isMulti ? [] : null, {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $f72IT.B).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $de92823810222d66$var$getOptionLabel$1(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $de92823810222d66$var$getOptionValue$1(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var base = $de92823810222d66$var$defaultStyles[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $f72IT.C)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $de92823810222d66$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $de92823810222d66$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $f72IT.a)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $f72IT.D)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change'
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur'
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $de92823810222d66$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close'
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$de92823810222d66$var$instanceId);
        _this.state.selectValue = (0, $f72IT.E)(_props.value);
        return _this;
    }
    (0, $hwUbf.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $f72IT.F)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            } // ==============================
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close'
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return $de92823810222d66$export$4368d992c4eafac0;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($de92823810222d66$export$4368d992c4eafac0);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $f72IT.a)((0, $f72IT.a)({}, $de92823810222d66$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $de92823810222d66$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $de92823810222d66$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $de92823810222d66$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            value: // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = {
                    'aria-autocomplete': 'list',
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby']
                };
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($de92823810222d66$var$DummyInput, (0, $jqghu.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $f72IT.G),
                    onFocus: this.onInputFocus,
                    readOnly: true,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Input, (0, $jqghu.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Placeholder, (0, $jqghu.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), placeholder);
                if (isMulti) {
                    var selectValues = selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(MultiValue, (0, $jqghu.default)({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: "".concat(_this3.getOptionValue(opt)).concat(index),
                            index: index,
                            removeProps: {
                                onClick: function onClick() {
                                    return _this3.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this3.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            },
                            data: opt
                        }), _this3.formatOptionLabel(opt, 'value'));
                    });
                    return selectValues;
                }
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(SingleValue, (0, $jqghu.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(ClearIndicator, (0, $jqghu.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(LoadingIndicator, (0, $jqghu.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(IndicatorSeparator, (0, $jqghu.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(DropdownIndicator, (0, $jqghu.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Option, (0, $jqghu.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Group, (0, $jqghu.default)({}, commonProps, {
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $f72IT.M), (0, $jqghu.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Menu, (0, $jqghu.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($de92823810222d66$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(MenuList, (0, $jqghu.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(MenuPortal, (0, $jqghu.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, focusedOption = _this$state5.focusedOption, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($de92823810222d66$var$LiveRegion, (0, $jqghu.default)({}, commonProps, {
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(SelectContainer, (0, $jqghu.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Control, (0, $jqghu.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(ValueContainer, (0, $jqghu.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(IndicatorsContainer, (0, $jqghu.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue;
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var selectValue = (0, $f72IT.E)(value);
                    var focusableOptions = menuIsOpen ? $de92823810222d66$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $de92823810222d66$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $de92823810222d66$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                } // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                return (0, $f72IT.a)((0, $f72IT.a)((0, $f72IT.a)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props
                });
            }
        }
    ]);
    return Select;
}((0, $6uYXW.Component));
$de92823810222d66$export$25ce5a424b770e84.defaultProps = $de92823810222d66$export$8b22cf2602fb60ce;

});
parcelRegister("f72IT", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $b0099f3386d71368$export$407448d2b89b1813; });
$parcel$export(module.exports, "_", function () { return $b0099f3386d71368$export$71511d61b312f219; });
$parcel$export(module.exports, "G", function () { return $b0099f3386d71368$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "B", function () { return $b0099f3386d71368$export$ef35774e6d314e91; });
$parcel$export(module.exports, "E", function () { return $b0099f3386d71368$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $b0099f3386d71368$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "D", function () { return $b0099f3386d71368$export$96f57966bedc81b4; });
$parcel$export(module.exports, "F", function () { return $b0099f3386d71368$export$d66501df72047452; });
$parcel$export(module.exports, "z", function () { return $b0099f3386d71368$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $b0099f3386d71368$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $b0099f3386d71368$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "n", function () { return $b0099f3386d71368$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "M", function () { return $b0099f3386d71368$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "o", function () { return $b0099f3386d71368$export$ae1af26003f05816; });
$parcel$export(module.exports, "u", function () { return $b0099f3386d71368$export$3b14a55fb2447963; });
$parcel$export(module.exports, "m", function () { return $b0099f3386d71368$export$953cecd6e717a553; });
$parcel$export(module.exports, "p", function () { return $b0099f3386d71368$export$ffb5f4729a158638; });
$parcel$export(module.exports, "d", function () { return $b0099f3386d71368$export$4368d992c4eafac0; });
$parcel$export(module.exports, "y", function () { return $b0099f3386d71368$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $b0099f3386d71368$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "f", function () { return $b0099f3386d71368$export$2d1720544b23b823; });
$parcel$export(module.exports, "b", function () { return $b0099f3386d71368$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "j", function () { return $b0099f3386d71368$export$35e795649ee09318; });
$parcel$export(module.exports, "l", function () { return $b0099f3386d71368$export$882b5998b3b9117c; });
$parcel$export(module.exports, "e", function () { return $b0099f3386d71368$export$f1e1789686576879; });
$parcel$export(module.exports, "g", function () { return $b0099f3386d71368$export$39b482c5e57630a8; });
$parcel$export(module.exports, "h", function () { return $b0099f3386d71368$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "k", function () { return $b0099f3386d71368$export$342063e11d6c3cad; });
$parcel$export(module.exports, "q", function () { return $b0099f3386d71368$export$9e5f44173e64f162; });
$parcel$export(module.exports, "r", function () { return $b0099f3386d71368$export$43caf9889c228507; });
$parcel$export(module.exports, "t", function () { return $b0099f3386d71368$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $b0099f3386d71368$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $b0099f3386d71368$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $b0099f3386d71368$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $b0099f3386d71368$export$db3b6bfb95261072; });
$parcel$export(module.exports, "C", function () { return $b0099f3386d71368$export$e7094788287c5e9b; });

var $jqghu = parcelRequire("jqghu");

var $iJLNd = parcelRequire("iJLNd");

var $bg8YK = parcelRequire("bg8YK");

var $9DelO = parcelRequire("9DelO");

var $aAf2N = parcelRequire("aAf2N");

var $eF7NI = parcelRequire("eF7NI");

var $a587z = parcelRequire("a587z");

var $hwUbf = parcelRequire("hwUbf");

var $h0Uae = parcelRequire("h0Uae");

var $clR1z = parcelRequire("clR1z");

var $6uYXW = parcelRequire("6uYXW");

var $6JczY = parcelRequire("6JczY");
function $b0099f3386d71368$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0099f3386d71368$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b0099f3386d71368$export$407448d2b89b1813(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b0099f3386d71368$var$ownKeys(Object(source), true).forEach(function(key) {
            $b0099f3386d71368$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b0099f3386d71368$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b0099f3386d71368$var$_getPrototypeOf(o) {
    $b0099f3386d71368$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b0099f3386d71368$var$_getPrototypeOf(o);
}
function $b0099f3386d71368$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b0099f3386d71368$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b0099f3386d71368$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $b0099f3386d71368$var$_assertThisInitialized(self);
}
function $b0099f3386d71368$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = $b0099f3386d71368$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b0099f3386d71368$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b0099f3386d71368$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b0099f3386d71368$var$_possibleConstructorReturn(this, result);
    };
}
// ==============================
// NO OP
// ==============================
var $b0099f3386d71368$export$2329c99376c9d0a4 = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $b0099f3386d71368$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $b0099f3386d71368$export$ef35774e6d314e91(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($b0099f3386d71368$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
} // ==============================
// Clean Value
// ==============================
var $b0099f3386d71368$export$a9c23c6ac3fc3eca = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, $aAf2N.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Clean Common Props
// ==============================
var $b0099f3386d71368$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $9DelO.default)(props, [
        "className",
        "clearValue",
        "cx",
        "getStyles",
        "getValue",
        "hasValue",
        "isMulti",
        "isRtl",
        "options",
        "selectOption",
        "selectProps",
        "setValue",
        "theme"
    ]);
    return $b0099f3386d71368$export$407448d2b89b1813({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================
function $b0099f3386d71368$export$7f8ddf7c7c20b3cd(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function $b0099f3386d71368$export$96f57966bedc81b4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function $b0099f3386d71368$var$getScrollTop(el) {
    if ($b0099f3386d71368$export$96f57966bedc81b4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $b0099f3386d71368$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($b0099f3386d71368$export$96f57966bedc81b4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function $b0099f3386d71368$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...
    if (style.position === 'fixed') return docEl;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return docEl;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $b0099f3386d71368$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $b0099f3386d71368$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $b0099f3386d71368$export$2329c99376c9d0a4;
    var start = $b0099f3386d71368$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $b0099f3386d71368$var$easeOutCubic(currentTime, start, change, duration);
        $b0099f3386d71368$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function $b0099f3386d71368$export$d66501df72047452(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $b0099f3386d71368$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $b0099f3386d71368$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $b0099f3386d71368$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function $b0099f3386d71368$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function $b0099f3386d71368$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $b0099f3386d71368$var$passiveOptionAccessed = false;
var $b0099f3386d71368$var$options = {
    get passive () {
        return $b0099f3386d71368$var$passiveOptionAccessed = true;
    }
}; // check for SSR
var $b0099f3386d71368$var$w = typeof window !== 'undefined' ? window : {};
if ($b0099f3386d71368$var$w.addEventListener && $b0099f3386d71368$var$w.removeEventListener) {
    $b0099f3386d71368$var$w.addEventListener('p', $b0099f3386d71368$export$2329c99376c9d0a4, $b0099f3386d71368$var$options);
    $b0099f3386d71368$var$w.removeEventListener('p', $b0099f3386d71368$export$2329c99376c9d0a4, false);
}
var $b0099f3386d71368$export$2408f22a0fab9ae5 = $b0099f3386d71368$var$passiveOptionAccessed;
function $b0099f3386d71368$var$getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = $b0099f3386d71368$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = $b0099f3386d71368$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0099f3386d71368$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $b0099f3386d71368$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === 'bottom') {
                if (shouldScroll) $b0099f3386d71368$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0099f3386d71368$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $b0099f3386d71368$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(placement, "\"."));
    } // fulfil contract with flow: implicit return value of undefined
    return defaultState;
} // Menu Component
// ------------------------------
function $b0099f3386d71368$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $b0099f3386d71368$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $b0099f3386d71368$export$7ccc53e8f1e7dfc5 = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: 'menu'
    }, (0, $clR1z.default)(_ref3, $b0099f3386d71368$var$alignToControl(placement), '100%'), (0, $clR1z.default)(_ref3, "backgroundColor", colors.neutral0), (0, $clR1z.default)(_ref3, "borderRadius", borderRadius), (0, $clR1z.default)(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), (0, $clR1z.default)(_ref3, "marginBottom", spacing.menuGutter), (0, $clR1z.default)(_ref3, "marginTop", spacing.menuGutter), (0, $clR1z.default)(_ref3, "position", 'absolute'), (0, $clR1z.default)(_ref3, "width", '100%'), (0, $clR1z.default)(_ref3, "zIndex", 1), _ref3;
};
var $b0099f3386d71368$var$PortalPlacementContext = /*#__PURE__*/ (0, $6uYXW.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var $b0099f3386d71368$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Component) {
    (0, $h0Uae.default)(MenuPlacer, _Component);
    var _super = $b0099f3386d71368$export$71511d61b312f219(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, $a587z.default)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === 'fixed';
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = $b0099f3386d71368$var$getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || $b0099f3386d71368$var$coercePlacement(menuPlacement);
            return $b0099f3386d71368$export$407448d2b89b1813($b0099f3386d71368$export$407448d2b89b1813({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, $hwUbf.default)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, $6uYXW.Component));
$b0099f3386d71368$export$3a1a48c8f6ef640e.contextType = $b0099f3386d71368$var$PortalPlacementContext;
var $b0099f3386d71368$var$Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('menu', props),
        className: cx({
            menu: true
        }, className),
        ref: innerRef
    }, innerProps), children);
};
// Menu List
// ==============================
var $b0099f3386d71368$export$ae1af26003f05816 = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: 'auto',
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    };
};
var $b0099f3386d71368$var$MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('menuList', props),
        className: cx({
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var $b0099f3386d71368$var$noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: 'center'
    };
};
var $b0099f3386d71368$export$3b14a55fb2447963 = $b0099f3386d71368$var$noticeCSS;
var $b0099f3386d71368$export$953cecd6e717a553 = $b0099f3386d71368$var$noticeCSS;
var $b0099f3386d71368$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('noOptionsMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--no-options': true
        }, className)
    }, innerProps), children);
};
$b0099f3386d71368$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $b0099f3386d71368$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('loadingMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--loading': true
        }, className)
    }, innerProps), children);
};
$b0099f3386d71368$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================
var $b0099f3386d71368$export$ffb5f4729a158638 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $b0099f3386d71368$var$MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, $h0Uae.default)(MenuPortal, _Component2);
    var _super2 = $b0099f3386d71368$export$71511d61b312f219(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, $a587z.default)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = $b0099f3386d71368$var$coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, $hwUbf.default)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === 'fixed'; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || $b0099f3386d71368$var$coercePlacement(menuPlacement);
                var rect = $b0099f3386d71368$var$getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
                    css: getStyles('menuPortal', state),
                    className: cx({
                        'menu-portal': true
                    }, className)
                }, innerProps), children);
                return (0, $iJLNd.jsx)($b0099f3386d71368$var$PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, $6JczY.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, $6uYXW.Component));
var $b0099f3386d71368$export$4368d992c4eafac0 = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : null,
        pointerEvents: isDisabled ? 'none' : null,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $b0099f3386d71368$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('container', props),
        className: cx({
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var $b0099f3386d71368$export$4a5767248b18ef41 = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    };
};
var $b0099f3386d71368$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('valueContainer', props),
        className: cx({
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        }, className)
    }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================
var $b0099f3386d71368$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $b0099f3386d71368$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('indicatorsContainer', props),
        className: cx({
            indicators: true
        }, className)
    }, innerProps), children);
};
var $b0099f3386d71368$var$_templateObject;
function $b0099f3386d71368$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b0099f3386d71368$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var $b0099f3386d71368$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9DelO.default)(_ref, [
        "size"
    ]);
    return (0, $iJLNd.jsx)("svg", (0, $jqghu.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $b0099f3386d71368$var$_ref2
    }, props));
};
var $b0099f3386d71368$var$CrossIcon = function CrossIcon(props) {
    return (0, $iJLNd.jsx)($b0099f3386d71368$var$Svg, (0, $jqghu.default)({
        size: 20
    }, props), (0, $iJLNd.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $b0099f3386d71368$var$DownChevron = function DownChevron(props) {
    return (0, $iJLNd.jsx)($b0099f3386d71368$var$Svg, (0, $jqghu.default)({
        size: 20
    }, props), (0, $iJLNd.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var $b0099f3386d71368$var$baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: 'indicatorContainer',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var $b0099f3386d71368$export$2d1720544b23b823 = $b0099f3386d71368$var$baseCSS;
var $b0099f3386d71368$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('dropdownIndicator', props),
        className: cx({
            indicator: true,
            'dropdown-indicator': true
        }, className)
    }, innerProps), children || (0, $iJLNd.jsx)($b0099f3386d71368$var$DownChevron, null));
};
var $b0099f3386d71368$export$8b22cf2602fb60ce = $b0099f3386d71368$var$baseCSS;
var $b0099f3386d71368$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('clearIndicator', props),
        className: cx({
            indicator: true,
            'clear-indicator': true
        }, className)
    }, innerProps), children || (0, $iJLNd.jsx)($b0099f3386d71368$var$CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var $b0099f3386d71368$export$35e795649ee09318 = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var $b0099f3386d71368$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("span", (0, $jqghu.default)({}, innerProps, {
        css: getStyles('indicatorSeparator', props),
        className: cx({
            'indicator-separator': true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var $b0099f3386d71368$var$loadingDotAnimations = (0, $iJLNd.keyframes)($b0099f3386d71368$var$_templateObject || ($b0099f3386d71368$var$_templateObject = (0, $bg8YK.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $b0099f3386d71368$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: 'loadingIndicator',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    };
};
var $b0099f3386d71368$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $iJLNd.jsx)("span", {
        css: /*#__PURE__*/ (0, $iJLNd.css)({
            animation: "".concat($b0099f3386d71368$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : null,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $b0099f3386d71368$var$LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('loadingIndicator', props),
        className: cx({
            indicator: true,
            'loading-indicator': true
        }, className)
    }, innerProps), (0, $iJLNd.jsx)($b0099f3386d71368$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $iJLNd.jsx)($b0099f3386d71368$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $iJLNd.jsx)($b0099f3386d71368$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$b0099f3386d71368$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $b0099f3386d71368$export$f1e1789686576879 = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: 'control',
        alignItems: 'center',
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var $b0099f3386d71368$var$Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        ref: innerRef,
        css: getStyles('control', props),
        className: cx({
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }, className)
    }, innerProps), children);
};
var $b0099f3386d71368$export$39b482c5e57630a8 = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $b0099f3386d71368$var$Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('group', props),
        className: cx({
            group: true
        }, className)
    }, innerProps), (0, $iJLNd.jsx)(Heading, (0, $jqghu.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, $iJLNd.jsx)("div", null, children));
};
var $b0099f3386d71368$export$dda1d9f60106f0e9 = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: 'group',
        color: '#999',
        cursor: 'default',
        display: 'block',
        fontSize: '75%',
        fontWeight: '500',
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    };
};
var $b0099f3386d71368$var$GroupHeading = function GroupHeading(props) {
    var getStyles = props.getStyles, cx = props.cx, className = props.className;
    var _cleanCommonProps = $b0099f3386d71368$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $9DelO.default)(_cleanCommonProps, [
        "data"
    ]);
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('groupHeading', props),
        className: cx({
            'group-heading': true
        }, className)
    }, innerProps));
};
var $b0099f3386d71368$export$342063e11d6c3cad = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? 'hidden' : 'visible',
        color: colors.neutral80
    };
};
var $b0099f3386d71368$var$inputStyle = function inputStyle(isHidden) {
    return {
        label: 'input',
        background: 0,
        border: 0,
        fontSize: 'inherit',
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: 'inherit'
    };
};
var $b0099f3386d71368$var$Input = function Input(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles;
    var _cleanCommonProps = $b0099f3386d71368$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, innerProps = (0, $9DelO.default)(_cleanCommonProps, [
        "innerRef",
        "isDisabled",
        "isHidden"
    ]);
    return (0, $iJLNd.jsx)("div", {
        css: getStyles('input', props)
    }, (0, $iJLNd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eF7NI))), (0, $jqghu.default)({
        className: cx({
            input: true
        }, className),
        inputRef: innerRef,
        inputStyle: $b0099f3386d71368$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $b0099f3386d71368$export$9e5f44173e64f162 = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: 'multiValue',
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: 'flex',
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var $b0099f3386d71368$export$43caf9889c228507 = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        overflow: 'hidden',
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis ? 'ellipsis' : null,
        whiteSpace: 'nowrap'
    };
};
var $b0099f3386d71368$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: 'center',
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused && colors.dangerLight,
        display: 'flex',
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var $b0099f3386d71368$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $iJLNd.jsx)("div", innerProps, children);
};
var $b0099f3386d71368$var$MultiValueContainer = $b0099f3386d71368$var$MultiValueGeneric;
var $b0099f3386d71368$var$MultiValueLabel = $b0099f3386d71368$var$MultiValueGeneric;
function $b0099f3386d71368$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $iJLNd.jsx)("div", innerProps, children || (0, $iJLNd.jsx)($b0099f3386d71368$var$CrossIcon, {
        size: 14
    }));
}
var $b0099f3386d71368$var$MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $iJLNd.jsx)((0, $iJLNd.ClassNames), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, $iJLNd.jsx)(Container, {
            data: data,
            innerProps: $b0099f3386d71368$export$407448d2b89b1813({
                className: emotionCx(css(getStyles('multiValue', props)), cx({
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }, className))
            }, innerProps),
            selectProps: selectProps
        }, (0, $iJLNd.jsx)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
                    'multi-value__label': true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, $iJLNd.jsx)(Remove, {
            data: data,
            innerProps: $b0099f3386d71368$export$407448d2b89b1813({
                className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
                    'multi-value__remove': true
                }, className))
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
$b0099f3386d71368$var$MultiValue.defaultProps = {
    cropWithEllipsis: true
};
var $b0099f3386d71368$export$90a7f3efeed30595 = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'option',
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
        }
    };
};
var $b0099f3386d71368$var$Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('option', props),
        className: cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className),
        ref: innerRef
    }, innerProps), children);
};
var $b0099f3386d71368$export$efccba1c4a2ef57b = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'placeholder',
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var $b0099f3386d71368$var$Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('placeholder', props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var $b0099f3386d71368$export$d141bba7fdc215a3 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'singleValue',
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
        overflow: 'hidden',
        position: 'absolute',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var $b0099f3386d71368$var$SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $iJLNd.jsx)("div", (0, $jqghu.default)({
        css: getStyles('singleValue', props),
        className: cx({
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }, className)
    }, innerProps), children);
};
var $b0099f3386d71368$export$db3b6bfb95261072 = {
    ClearIndicator: $b0099f3386d71368$var$ClearIndicator,
    Control: $b0099f3386d71368$var$Control,
    DropdownIndicator: $b0099f3386d71368$var$DropdownIndicator,
    DownChevron: $b0099f3386d71368$var$DownChevron,
    CrossIcon: $b0099f3386d71368$var$CrossIcon,
    Group: $b0099f3386d71368$var$Group,
    GroupHeading: $b0099f3386d71368$var$GroupHeading,
    IndicatorsContainer: $b0099f3386d71368$var$IndicatorsContainer,
    IndicatorSeparator: $b0099f3386d71368$var$IndicatorSeparator,
    Input: $b0099f3386d71368$var$Input,
    LoadingIndicator: $b0099f3386d71368$var$LoadingIndicator,
    Menu: $b0099f3386d71368$var$Menu,
    MenuList: $b0099f3386d71368$var$MenuList,
    MenuPortal: $b0099f3386d71368$var$MenuPortal,
    LoadingMessage: $b0099f3386d71368$var$LoadingMessage,
    NoOptionsMessage: $b0099f3386d71368$var$NoOptionsMessage,
    MultiValue: $b0099f3386d71368$var$MultiValue,
    MultiValueContainer: $b0099f3386d71368$var$MultiValueContainer,
    MultiValueLabel: $b0099f3386d71368$var$MultiValueLabel,
    MultiValueRemove: $b0099f3386d71368$var$MultiValueRemove,
    Option: $b0099f3386d71368$var$Option,
    Placeholder: $b0099f3386d71368$var$Placeholder,
    SelectContainer: $b0099f3386d71368$var$SelectContainer,
    SingleValue: $b0099f3386d71368$var$SingleValue,
    ValueContainer: $b0099f3386d71368$var$ValueContainer
};
var $b0099f3386d71368$export$e7094788287c5e9b = function defaultComponents(props) {
    return $b0099f3386d71368$export$407448d2b89b1813($b0099f3386d71368$export$407448d2b89b1813({}, $b0099f3386d71368$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("iJLNd", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $da4180a3d89fe2aa$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $da4180a3d89fe2aa$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $da4180a3d89fe2aa$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $da4180a3d89fe2aa$export$c8a8987d4410bf2d; });

var $6uYXW = parcelRequire("6uYXW");
parcelRequire("7ItjZ");

var $2vniM = parcelRequire("2vniM");
parcelRequire("dBWLf");
parcelRequire("h5T7V");
parcelRequire("9HO5c");


var $ibD2N = parcelRequire("ibD2N");

var $1fiZw = parcelRequire("1fiZw");

var $5mjjI = parcelRequire("5mjjI");
var $da4180a3d89fe2aa$var$pkg = {
    name: "@emotion/react",
    version: "11.4.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "isolated-hoist-non-react-statics-do-not-use-this-in-your-code",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/cache": "^11.4.0",
        "@emotion/serialize": "^1.0.2",
        "@emotion/sheet": "^1.0.2",
        "@emotion/utils": "^1.0.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.1.3",
        "@emotion/css-prettifier": "1.0.0",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.3.0",
        "@types/react": "^16.9.11",
        dtslint: "^0.3.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./isolated-hoist-non-react-statics-do-not-use-this-in-your-code.js"
        ],
        umdName: "emotionReact"
    }
};
var $da4180a3d89fe2aa$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $2vniM.h).call(props, 'css')) // $FlowFixMe
    return (0, $6uYXW.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $2vniM.E);
    createElementArgArray[1] = (0, $2vniM.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $6uYXW.createElement).apply(null, createElementArgArray);
};
var $da4180a3d89fe2aa$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $da4180a3d89fe2aa$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $2vniM.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $1fiZw.serializeStyles)([
        styles
    ], undefined, (0, $6uYXW.useContext)((0, $2vniM.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $6uYXW.useRef)();
    (0, $6uYXW.useLayoutEffect)(function() {
        var key = cache.key + "-global";
        var sheet = new (0, $5mjjI.StyleSheet)({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $6uYXW.useLayoutEffect)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $ibD2N.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $da4180a3d89fe2aa$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $1fiZw.serializeStyles)(args);
}
var $da4180a3d89fe2aa$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $da4180a3d89fe2aa$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $da4180a3d89fe2aa$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $da4180a3d89fe2aa$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $ibD2N.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $da4180a3d89fe2aa$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $2vniM.w)(function(props, cache) {
    var hasRendered = false;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $1fiZw.serializeStyles)(args, cache.registered);
        (0, $ibD2N.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $da4180a3d89fe2aa$var$merge(cache.registered, css, $da4180a3d89fe2aa$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $6uYXW.useContext)((0, $2vniM.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return ele;
});
var $da4180a3d89fe2aa$var$isBrowser, $da4180a3d89fe2aa$var$isJest, $da4180a3d89fe2aa$var$globalContext, $da4180a3d89fe2aa$var$globalKey;

});
parcelRegister("7ItjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59e363119e94bfab$export$2e2bcd8739ae039; });

var $5mjjI = parcelRequire("5mjjI");

var $3PlBF = parcelRequire("3PlBF");
parcelRequire("h5T7V");
parcelRequire("32NfM");
var $59e363119e94bfab$var$last = function last(arr) {
    return arr.length ? arr[arr.length - 1] : null;
};
var $59e363119e94bfab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $3PlBF.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $3PlBF.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += (0, $3PlBF.identifier)((0, $3PlBF.position) - 1);
            break;
        case 2:
            parsed[index] += (0, $3PlBF.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $3PlBF.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $3PlBF.from)(character);
    }
    while (character = (0, $3PlBF.next)());
    return parsed;
};
var $59e363119e94bfab$var$getRules = function getRules(value, points) {
    return (0, $3PlBF.dealloc)($59e363119e94bfab$var$toRules((0, $3PlBF.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $59e363119e94bfab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $59e363119e94bfab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
    !element.length) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$59e363119e94bfab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $59e363119e94bfab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $59e363119e94bfab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $59e363119e94bfab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $59e363119e94bfab$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $59e363119e94bfab$var$isIgnoringComment = function isIgnoringComment(element) {
    return !!element && element.type === 'comm' && element.children.indexOf($59e363119e94bfab$var$ignoreFlag) > -1;
};
var $59e363119e94bfab$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule') return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses && cache.compat !== true) {
            var prevElement = index > 0 ? children[index - 1] : null;
            if (prevElement && $59e363119e94bfab$var$isIgnoringComment($59e363119e94bfab$var$last(prevElement.children))) return;
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $59e363119e94bfab$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $59e363119e94bfab$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$59e363119e94bfab$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $59e363119e94bfab$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $59e363119e94bfab$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$59e363119e94bfab$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $59e363119e94bfab$var$nullifyElement(element);
    } else if ($59e363119e94bfab$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $59e363119e94bfab$var$nullifyElement(element);
    }
};
var $59e363119e94bfab$var$defaultStylisPlugins = [
    (0, $3PlBF.prefixer)
];
var $59e363119e94bfab$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $59e363119e94bfab$var$defaultStylisPlugins;
    var inserted = {}; // $FlowFixMe
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $59e363119e94bfab$var$compat,
        $59e363119e94bfab$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $3PlBF.stringify),
        (0, $3PlBF.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $3PlBF.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $3PlBF.serialize)((0, $3PlBF.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $5mjjI.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $59e363119e94bfab$export$2e2bcd8739ae039 = $59e363119e94bfab$var$createCache;

});
parcelRegister("5mjjI", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $3e6dfdc9bb134835$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $3e6dfdc9bb134835$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $3e6dfdc9bb134835$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3e6dfdc9bb134835$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) before = _this.prepend ? _this.container.firstChild : _this.before;
            else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3e6dfdc9bb134835$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $3e6dfdc9bb134835$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("h5T7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c71daa5233a1b973$export$2e2bcd8739ae039; });
var $c71daa5233a1b973$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $c71daa5233a1b973$export$2e2bcd8739ae039 = $c71daa5233a1b973$var$weakMemoize;

});

parcelRegister("32NfM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2377c3b634e7be7f$export$2e2bcd8739ae039; });
function $2377c3b634e7be7f$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $2377c3b634e7be7f$export$2e2bcd8739ae039 = $2377c3b634e7be7f$var$memoize;

});


parcelRegister("2vniM", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $1d308d508ebe2c6e$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $1d308d508ebe2c6e$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $1d308d508ebe2c6e$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $1d308d508ebe2c6e$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $1d308d508ebe2c6e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $1d308d508ebe2c6e$export$a9c23c6ac3fc3eca; });

var $6uYXW = parcelRequire("6uYXW");

var $7ItjZ = parcelRequire("7ItjZ");

var $jqghu = parcelRequire("jqghu");

var $h5T7V = parcelRequire("h5T7V");

var $eczg9 = parcelRequire("eczg9");

var $ibD2N = parcelRequire("ibD2N");

var $1fiZw = parcelRequire("1fiZw");
var $1d308d508ebe2c6e$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $1d308d508ebe2c6e$var$EmotionCacheContext = /* #__PURE__ */ (0, $6uYXW.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $7ItjZ.default)({
    key: 'css'
}) : null);
var $1d308d508ebe2c6e$export$e7094788287c5e9b = $1d308d508ebe2c6e$var$EmotionCacheContext.Provider;
var $1d308d508ebe2c6e$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $6uYXW.useContext)($1d308d508ebe2c6e$var$EmotionCacheContext);
};
var $1d308d508ebe2c6e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $6uYXW.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $6uYXW.useContext)($1d308d508ebe2c6e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $1d308d508ebe2c6e$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $6uYXW.createContext)({});
var $1d308d508ebe2c6e$export$3b14a55fb2447963 = function useTheme() {
    return (0, $6uYXW.useContext)($1d308d508ebe2c6e$export$971d5caa766a69d7);
};
var $1d308d508ebe2c6e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $jqghu.default)({}, outerTheme, theme);
};
var $1d308d508ebe2c6e$var$createCacheWithTheme = /* #__PURE__ */ (0, $h5T7V.default)(function(outerTheme) {
    return (0, $h5T7V.default)(function(theme) {
        return $1d308d508ebe2c6e$var$getTheme(outerTheme, theme);
    });
});
var $1d308d508ebe2c6e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $6uYXW.useContext)($1d308d508ebe2c6e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $1d308d508ebe2c6e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $6uYXW.createElement)($1d308d508ebe2c6e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $1d308d508ebe2c6e$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = (0, $6uYXW.useContext)($1d308d508ebe2c6e$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $6uYXW.createElement)(Component, (0, $jqghu.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $6uYXW.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $eczg9.default)(WithTheme, Component);
}
// thus we only need to replace what is a valid character for JS, but not for CSS
var $1d308d508ebe2c6e$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $1d308d508ebe2c6e$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $1d308d508ebe2c6e$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $1d308d508ebe2c6e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($1d308d508ebe2c6e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$1d308d508ebe2c6e$var$typePropName] = type;
    var error, match;
    return newProps;
};
var $1d308d508ebe2c6e$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $1d308d508ebe2c6e$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$1d308d508ebe2c6e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $ibD2N.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $1fiZw.serializeStyles)(registeredStyles, undefined, (0, $6uYXW.useContext)($1d308d508ebe2c6e$export$971d5caa766a69d7));
    var labelFromStack;
    var rules = (0, $ibD2N.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($1d308d508ebe2c6e$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $1d308d508ebe2c6e$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $6uYXW.createElement)(type, newProps);
    return ele;
});

});
parcelRegister("eczg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a56d897b0c92c4cb$export$2e2bcd8739ae039; });

var $9HO5c = parcelRequire("9HO5c");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $a56d897b0c92c4cb$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9HO5c)))(targetComponent, sourceComponent);
};
var $a56d897b0c92c4cb$export$2e2bcd8739ae039 = $a56d897b0c92c4cb$var$hoistNonReactStatics;

});

parcelRegister("ibD2N", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $d3d78a6d95e135db$export$95d99596f328fd52; });
$parcel$export(module.exports, "insertStyles", function () { return $d3d78a6d95e135db$export$6f077d94b33a01aa; });
var $d3d78a6d95e135db$var$isBrowser = true;
function $d3d78a6d95e135db$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $d3d78a6d95e135db$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d3d78a6d95e135db$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("1fiZw", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $0e85ec6a62f6e2b3$export$6321afa313b251b5; });

var $zuBaW = parcelRequire("zuBaW");

var $hT9qG = parcelRequire("hT9qG");

var $32NfM = parcelRequire("32NfM");
var $0e85ec6a62f6e2b3$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $0e85ec6a62f6e2b3$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $0e85ec6a62f6e2b3$var$hyphenateRegex = /[A-Z]|^ms/g;
var $0e85ec6a62f6e2b3$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $0e85ec6a62f6e2b3$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $0e85ec6a62f6e2b3$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $0e85ec6a62f6e2b3$var$processStyleName = /* #__PURE__ */ (0, $32NfM.default)(function(styleName) {
    return $0e85ec6a62f6e2b3$var$isCustomProperty(styleName) ? styleName : styleName.replace($0e85ec6a62f6e2b3$var$hyphenateRegex, '-$&').toLowerCase();
});
var $0e85ec6a62f6e2b3$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($0e85ec6a62f6e2b3$var$animationRegex, function(match, p1, p2) {
                $0e85ec6a62f6e2b3$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $0e85ec6a62f6e2b3$var$cursor
                };
                return p1;
            });
    }
    if ((0, $hT9qG.default)[key] !== 1 && !$0e85ec6a62f6e2b3$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $0e85ec6a62f6e2b3$var$contentValuePattern, $0e85ec6a62f6e2b3$var$contentValues, $0e85ec6a62f6e2b3$var$oldProcessStyleValue, $0e85ec6a62f6e2b3$var$msPattern, $0e85ec6a62f6e2b3$var$hyphenPattern, $0e85ec6a62f6e2b3$var$hyphenatedCache;
function $0e85ec6a62f6e2b3$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $0e85ec6a62f6e2b3$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $0e85ec6a62f6e2b3$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $0e85ec6a62f6e2b3$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $0e85ec6a62f6e2b3$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $0e85ec6a62f6e2b3$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $0e85ec6a62f6e2b3$var$cursor;
                var result = interpolation(mergedProps);
                $0e85ec6a62f6e2b3$var$cursor = previousCursor;
                return $0e85ec6a62f6e2b3$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $0e85ec6a62f6e2b3$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $0e85ec6a62f6e2b3$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($0e85ec6a62f6e2b3$var$isProcessableValue(value)) string += $0e85ec6a62f6e2b3$var$processStyleName(_key) + ":" + $0e85ec6a62f6e2b3$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($0e85ec6a62f6e2b3$var$isProcessableValue(value[_i])) string += $0e85ec6a62f6e2b3$var$processStyleName(_key) + ":" + $0e85ec6a62f6e2b3$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $0e85ec6a62f6e2b3$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $0e85ec6a62f6e2b3$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $0e85ec6a62f6e2b3$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $0e85ec6a62f6e2b3$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $0e85ec6a62f6e2b3$var$cursor;
var $0e85ec6a62f6e2b3$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $0e85ec6a62f6e2b3$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $0e85ec6a62f6e2b3$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $0e85ec6a62f6e2b3$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $0e85ec6a62f6e2b3$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $0e85ec6a62f6e2b3$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $zuBaW.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $0e85ec6a62f6e2b3$var$cursor
    };
};

});
parcelRegister("zuBaW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06ab013e9ffa41ed$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $06ab013e9ffa41ed$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $06ab013e9ffa41ed$export$2e2bcd8739ae039 = $06ab013e9ffa41ed$var$murmur2;

});

parcelRegister("hT9qG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d05ee335ab1b2f1d$export$2e2bcd8739ae039; });
var $d05ee335ab1b2f1d$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d05ee335ab1b2f1d$export$2e2bcd8739ae039 = $d05ee335ab1b2f1d$var$unitlessKeys;

});



parcelRegister("dBWLf", function(module, exports) {
function $9e8c4fccc04934d4$var$_extends() {
    return module.exports = $9e8c4fccc04934d4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9e8c4fccc04934d4$var$_extends.apply(null, arguments);
}
module.exports = $9e8c4fccc04934d4$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bg8YK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83282756bfdfd559$export$2e2bcd8739ae039; });
function $83282756bfdfd559$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("9DelO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7032e35652ef15d8$export$2e2bcd8739ae039; });

var $akkJo = parcelRequire("akkJo");
function $7032e35652ef15d8$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $akkJo.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("aAf2N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b48ef9cd66679bb$export$2e2bcd8739ae039; });
function $7b48ef9cd66679bb$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $7b48ef9cd66679bb$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7b48ef9cd66679bb$export$2e2bcd8739ae039(o);
}

});

parcelRegister("eF7NI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $aacaf2176d347a94$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $aacaf2176d347a94$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6uYXW = parcelRequire("6uYXW");
var $aacaf2176d347a94$var$_react2 = $aacaf2176d347a94$var$_interopRequireDefault($6uYXW);

var $k8j0a = parcelRequire("k8j0a");
var $aacaf2176d347a94$var$_propTypes2 = $aacaf2176d347a94$var$_interopRequireDefault($k8j0a);
function $aacaf2176d347a94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aacaf2176d347a94$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $aacaf2176d347a94$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aacaf2176d347a94$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $aacaf2176d347a94$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $aacaf2176d347a94$var$sizerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    visibility: 'hidden',
    height: 0,
    overflow: 'scroll',
    whiteSpace: 'pre'
};
var $aacaf2176d347a94$var$INPUT_PROPS_BLACKLIST = [
    'extraWidth',
    'injectStyles',
    'inputClassName',
    'inputRef',
    'inputStyle',
    'minWidth',
    'onAutosize',
    'placeholderIsMinWidth'
];
var $aacaf2176d347a94$var$cleanInputProps = function cleanInputProps(inputProps) {
    $aacaf2176d347a94$var$INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var $aacaf2176d347a94$var$copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var $aacaf2176d347a94$var$isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var $aacaf2176d347a94$var$generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return $aacaf2176d347a94$var$isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};
var $aacaf2176d347a94$var$AutosizeInput = function(_Component) {
    $aacaf2176d347a94$var$_inherits(AutosizeInput, _Component);
    $aacaf2176d347a94$var$_createClass(AutosizeInput, null, [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(props, state) {
                var id = props.id;
                return id !== state.prevId ? {
                    inputId: id || $aacaf2176d347a94$var$generateId(),
                    prevId: id
                } : null;
            }
        }
    ]);
    function AutosizeInput(props) {
        $aacaf2176d347a94$var$_classCallCheck(this, AutosizeInput);
        var _this = $aacaf2176d347a94$var$_possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === 'function') _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || $aacaf2176d347a94$var$generateId(),
            prevId: props.id
        };
        return _this;
    }
    $aacaf2176d347a94$var$_createClass(AutosizeInput, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === 'function') this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: 'copyInputStyles',
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                $aacaf2176d347a94$var$copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) $aacaf2176d347a94$var$copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: 'updateInputWidth',
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: 'getInput',
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: 'focus',
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: 'blur',
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: 'select',
            value: function select() {
                this.input.select();
            }
        },
        {
            key: 'renderStyles',
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return $aacaf2176d347a94$var$isIE && injectStyles ? $aacaf2176d347a94$var$_react2.default.createElement('style', {
                    dangerouslySetInnerHTML: {
                        __html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
                    }
                }) : null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ''
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = $aacaf2176d347a94$var$_extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
                var inputStyle = $aacaf2176d347a94$var$_extends({
                    boxSizing: 'content-box',
                    width: this.state.inputWidth + 'px'
                }, this.props.inputStyle);
                var inputProps = $aacaf2176d347a94$var$_objectWithoutProperties(this.props, []);
                $aacaf2176d347a94$var$cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return $aacaf2176d347a94$var$_react2.default.createElement('div', {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), $aacaf2176d347a94$var$_react2.default.createElement('input', $aacaf2176d347a94$var$_extends({}, inputProps, {
                    ref: this.inputRef
                })), $aacaf2176d347a94$var$_react2.default.createElement('div', {
                    ref: this.sizerRef,
                    style: $aacaf2176d347a94$var$sizerStyle
                }, sizerValue), this.props.placeholder ? $aacaf2176d347a94$var$_react2.default.createElement('div', {
                    ref: this.placeHolderSizerRef,
                    style: $aacaf2176d347a94$var$sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}($6uYXW.Component);
$aacaf2176d347a94$var$AutosizeInput.propTypes = {
    className: $aacaf2176d347a94$var$_propTypes2.default.string,
    defaultValue: $aacaf2176d347a94$var$_propTypes2.default.any,
    extraWidth: $aacaf2176d347a94$var$_propTypes2.default.oneOfType([
        $aacaf2176d347a94$var$_propTypes2.default.number,
        $aacaf2176d347a94$var$_propTypes2.default.string
    ]),
    id: $aacaf2176d347a94$var$_propTypes2.default.string,
    injectStyles: $aacaf2176d347a94$var$_propTypes2.default.bool,
    inputClassName: $aacaf2176d347a94$var$_propTypes2.default.string,
    inputRef: $aacaf2176d347a94$var$_propTypes2.default.func,
    inputStyle: $aacaf2176d347a94$var$_propTypes2.default.object,
    minWidth: $aacaf2176d347a94$var$_propTypes2.default.oneOfType([
        $aacaf2176d347a94$var$_propTypes2.default.number,
        $aacaf2176d347a94$var$_propTypes2.default.string
    ]),
    onAutosize: $aacaf2176d347a94$var$_propTypes2.default.func,
    onChange: $aacaf2176d347a94$var$_propTypes2.default.func,
    placeholder: $aacaf2176d347a94$var$_propTypes2.default.string,
    placeholderIsMinWidth: $aacaf2176d347a94$var$_propTypes2.default.bool,
    style: $aacaf2176d347a94$var$_propTypes2.default.object,
    value: $aacaf2176d347a94$var$_propTypes2.default.any // field value
};
$aacaf2176d347a94$var$AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
module.exports.default = $aacaf2176d347a94$var$AutosizeInput;

});

parcelRegister("a587z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7570abb19e7d38d2$export$2e2bcd8739ae039; });
function $7570abb19e7d38d2$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hwUbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc31011318caad1e$export$2e2bcd8739ae039; });

var $bnvdA = parcelRequire("bnvdA");
function $cc31011318caad1e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $bnvdA.default)(o.key), o);
    }
}
function $cc31011318caad1e$export$2e2bcd8739ae039(e, r, t) {
    return r && $cc31011318caad1e$var$_defineProperties(e.prototype, r), t && $cc31011318caad1e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("bnvdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $848a0ef2a3cc1e7d$export$2e2bcd8739ae039; });

var $aAf2N = parcelRequire("aAf2N");

var $83Rig = parcelRequire("83Rig");
function $848a0ef2a3cc1e7d$export$2e2bcd8739ae039(t) {
    var i = (0, $83Rig.default)(t, "string");
    return "symbol" == (0, $aAf2N.default)(i) ? i : i + "";
}

});
parcelRegister("83Rig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de7f1835d751315$export$2e2bcd8739ae039; });

var $aAf2N = parcelRequire("aAf2N");
function $5de7f1835d751315$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $aAf2N.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $aAf2N.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("h0Uae", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c62e00bde2c34b25$export$2e2bcd8739ae039; });

var $9om4f = parcelRequire("9om4f");
function $c62e00bde2c34b25$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $9om4f.default)(t, e);
}

});

parcelRegister("clR1z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fe093b6a58ac1a6$export$2e2bcd8739ae039; });

var $bnvdA = parcelRequire("bnvdA");
function $8fe093b6a58ac1a6$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bnvdA.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("8uPz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62f91f83ac3a083d$export$2e2bcd8739ae039; });

var $hNHU0 = parcelRequire("hNHU0");

var $lpej7 = parcelRequire("lpej7");

var $dgZ0z = parcelRequire("dgZ0z");

var $73pfg = parcelRequire("73pfg");
function $62f91f83ac3a083d$export$2e2bcd8739ae039(r) {
    return (0, $hNHU0.default)(r) || (0, $lpej7.default)(r) || (0, $dgZ0z.default)(r) || (0, $73pfg.default)();
}

});
parcelRegister("hNHU0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf59115852393fcc$export$2e2bcd8739ae039; });

var $75ceU = parcelRequire("75ceU");
function $cf59115852393fcc$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $75ceU.default)(r);
}

});
parcelRegister("75ceU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52827e8636195283$export$2e2bcd8739ae039; });
function $52827e8636195283$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("lpej7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f95707e4eadb8560$export$2e2bcd8739ae039; });
function $f95707e4eadb8560$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("dgZ0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a9c17f0241a0b95$export$2e2bcd8739ae039; });

var $75ceU = parcelRequire("75ceU");
function $9a9c17f0241a0b95$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $75ceU.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $75ceU.default)(r, a) : void 0;
    }
}

});

parcelRegister("73pfg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $522c655f1f56a33e$export$2e2bcd8739ae039; });
function $522c655f1f56a33e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4wHBI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34bbfa137734caa0$export$2e2bcd8739ae039; });
var $34bbfa137734caa0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $34bbfa137734caa0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($34bbfa137734caa0$var$safeIsNaN(first) && $34bbfa137734caa0$var$safeIsNaN(second)) return true;
    return false;
}
function $34bbfa137734caa0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$34bbfa137734caa0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $34bbfa137734caa0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $34bbfa137734caa0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $34bbfa137734caa0$export$2e2bcd8739ae039 = $34bbfa137734caa0$var$memoizeOne;

});


parcelRegister("3jNg8", function(module, exports) {

$parcel$export(module.exports, "m", function () { return $26a95b4cbbd4c4b0$export$953cecd6e717a553; });

var $jqghu = parcelRequire("jqghu");

var $9DelO = parcelRequire("9DelO");

var $a587z = parcelRequire("a587z");

var $hwUbf = parcelRequire("hwUbf");

var $h0Uae = parcelRequire("h0Uae");

var $f72IT = parcelRequire("f72IT");

var $6uYXW = parcelRequire("6uYXW");
var $26a95b4cbbd4c4b0$var$defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
};
var $26a95b4cbbd4c4b0$export$953cecd6e717a553 = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $h0Uae.default)(StateManager, _Component);
        var _super = (0, $f72IT._)(StateManager);
        function StateManager() {
            var _this;
            (0, $a587z.default)(this, StateManager);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _this.select = void 0;
            _this.state = {
                inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
                menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
                value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
            };
            _this.onChange = function(value, actionMeta) {
                _this.callProp('onChange', value, actionMeta);
                _this.setState({
                    value: value
                });
            };
            _this.onInputChange = function(value, actionMeta) {
                // TODO: for backwards compatibility, we allow the prop to return a new
                // value, but now inputValue is a controllable prop we probably shouldn't
                var newValue = _this.callProp('onInputChange', value, actionMeta);
                _this.setState({
                    inputValue: newValue !== undefined ? newValue : value
                });
            };
            _this.onMenuOpen = function() {
                _this.callProp('onMenuOpen');
                _this.setState({
                    menuIsOpen: true
                });
            };
            _this.onMenuClose = function() {
                _this.callProp('onMenuClose');
                _this.setState({
                    menuIsOpen: false
                });
            };
            return _this;
        }
        (0, $hwUbf.default)(StateManager, [
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                } // FIXME: untyped flow code, return any
            },
            {
                key: "getProp",
                value: function getProp(key) {
                    return this.props[key] !== undefined ? this.props[key] : this.state[key];
                } // FIXME: untyped flow code, return any
            },
            {
                key: "callProp",
                value: function callProp(name) {
                    if (typeof this.props[name] === 'function') {
                        var _this$props;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        return (_this$props = this.props)[name].apply(_this$props, args);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props2 = this.props;
                    _this$props2.defaultInputValue;
                    _this$props2.defaultMenuIsOpen;
                    _this$props2.defaultValue;
                    var props = (0, $9DelO.default)(_this$props2, [
                        "defaultInputValue",
                        "defaultMenuIsOpen",
                        "defaultValue"
                    ]);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(SelectComponent, (0, $jqghu.default)({}, props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        inputValue: this.getProp('inputValue'),
                        menuIsOpen: this.getProp('menuIsOpen'),
                        onChange: this.onChange,
                        onInputChange: this.onInputChange,
                        onMenuClose: this.onMenuClose,
                        onMenuOpen: this.onMenuOpen,
                        value: this.getProp('value')
                    }));
                }
            }
        ]);
        return StateManager;
    }((0, $6uYXW.Component)), _class.defaultProps = $26a95b4cbbd4c4b0$var$defaultProps, _temp;
};

});

parcelRegister("8Zamr", function(module, exports) {

var $1l3QK = parcelRequire("1l3QK");

var $ee9hV = parcelRequire("ee9hV");

var $jeQwo = parcelRequire("jeQwo");

var $cuy0q = parcelRequire("cuy0q");
function $68ac0eb7dffa057e$var$_toConsumableArray(r) {
    return $1l3QK(r) || $ee9hV(r) || $jeQwo(r) || $cuy0q();
}
module.exports = $68ac0eb7dffa057e$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1l3QK", function(module, exports) {

var $csTkU = parcelRequire("csTkU");
function $0f9abd144b8ae998$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $csTkU(r);
}
module.exports = $0f9abd144b8ae998$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ee9hV", function(module, exports) {
function $a5b993eb98deab4b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $a5b993eb98deab4b$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cuy0q", function(module, exports) {
function $9182aa3862a48e16$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9182aa3862a48e16$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7U7y0", function(module, exports) {

var $j4hMs = parcelRequire("j4hMs");
function $5c139e27e69ea5c7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $j4hMs(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $5c139e27e69ea5c7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j4hMs", function(module, exports) {
function $de1c2ee1230c5067$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $de1c2ee1230c5067$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6OIJ6", function(module, exports) {
function $4f6a1b57776ef224$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $4f6a1b57776ef224$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5WJXj", function(module, exports) {

var $iwDV4 = parcelRequire("iwDV4");
function $4546045cc3da6ac1$var$_defineProperty(e, r, t) {
    return (r = $iwDV4(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $4546045cc3da6ac1$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iwDV4", function(module, exports) {

var $alU2v = parcelRequire("alU2v");
var $d7ca2e50d9ad00a0$var$_typeof = $alU2v.default;

var $jE3gD = parcelRequire("jE3gD");
function $d7ca2e50d9ad00a0$var$toPropertyKey(t) {
    var i = $jE3gD(t, "string");
    return "symbol" == $d7ca2e50d9ad00a0$var$_typeof(i) ? i : i + "";
}
module.exports = $d7ca2e50d9ad00a0$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jE3gD", function(module, exports) {

var $alU2v = parcelRequire("alU2v");
var $e4d44993671b7ae0$var$_typeof = $alU2v.default;
function $e4d44993671b7ae0$var$toPrimitive(t, r) {
    if ("object" != $e4d44993671b7ae0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e4d44993671b7ae0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $e4d44993671b7ae0$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("8JW2B", function(module, exports) {

$parcel$export(module.exports, "PageBackLink", function () { return $e5e66e7ab1d85f62$export$81713009ad790e50; });
$parcel$export(module.exports, "PageBackHeader", function () { return $e5e66e7ab1d85f62$export$8f1ba9f60c9c4fd4; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $22v9q = parcelRequire("22v9q");

var $bZlaH = parcelRequire("bZlaH");

var $bewhU = parcelRequire("bewhU");

var $51d3M = parcelRequire("51d3M");

var $1VCpi = parcelRequire("1VCpi");
function $e5e66e7ab1d85f62$export$81713009ad790e50({ className: className, onBack: onBack }) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($e5e66e7ab1d85f62$var$BackLink, {
        type: "button",
        className: className,
        onClick: onBack,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($e5e66e7ab1d85f62$var$BackChevron, {
                width: 10,
                height: 10
            }),
            formatMessage("registerScreen.progressBackLink")
        ]
    });
}
function $e5e66e7ab1d85f62$export$8f1ba9f60c9c4fd4({ title: title, subtitle: subtitle, account: account, onBack: onBack }) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderBand), {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($e5e66e7ab1d85f62$var$HeaderRow, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsxs)($e5e66e7ab1d85f62$var$Texts, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($e5e66e7ab1d85f62$export$81713009ad790e50, {
                            onBack: onBack
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderTitle), {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($e5e66e7ab1d85f62$var$Subtitle, {
                            children: subtitle
                        })
                    ]
                }),
                !!account && /*#__PURE__*/ (0, $4m918.jsxs)($e5e66e7ab1d85f62$var$BalanceBlock, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsxs)($e5e66e7ab1d85f62$var$BalanceLabel, {
                            children: [
                                formatMessage("homeScreen.accountBalance"),
                                " : ",
                                formatMessage("account.accountId", {
                                    id: account.id
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($e5e66e7ab1d85f62$var$Balance, {
                            amount: (0, $kGswT.getSettlementBalance)(account)
                        })
                    ]
                })
            ]
        })
    });
}
const $e5e66e7ab1d85f62$var$HeaderRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
`;
const $e5e66e7ab1d85f62$var$Texts = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $e5e66e7ab1d85f62$var$BackLink = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 0.8125rem;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
/* The chevron points back: the icon's own path faces forward. */ const $e5e66e7ab1d85f62$var$BackChevron = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  fill: ${(0, $22v9q.theme).colors.blue[700]};
  transform: rotate(180deg);
`;
const $e5e66e7ab1d85f62$var$Subtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 16px;
  line-height: 24px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $e5e66e7ab1d85f62$var$BalanceBlock = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
`;
const $e5e66e7ab1d85f62$var$BalanceLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 13px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $e5e66e7ab1d85f62$var$Balance = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).boldText};
  margin-top: 4px;
  font-size: 28px;
  line-height: 34px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;

});
parcelRegister("bZlaH", function(module, exports) {

$parcel$export(module.exports, "AmountText", function () { return $8464bdffff9d4b0d$export$fe650a1a7aa2d95f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");
const $8464bdffff9d4b0d$export$fe650a1a7aa2d95f = (props)=>{
    const { amount: amount, absolute: absolute, forceSign: forceSign, ...rest } = props;
    const { formatAmount: formatAmount } = (0, $5hpYi.useIntl)();
    const formattedAmount = formatAmount(amount, absolute, forceSign);
    return /*#__PURE__*/ (0, $4m918.jsx)($8464bdffff9d4b0d$var$Container, {
        ...rest,
        children: formattedAmount
    });
};
const $8464bdffff9d4b0d$var$Container = (0, $jb8NR.default).div`
  direction: ltr;
`;

});

parcelRegister("51d3M", function(module, exports) {

$parcel$export(module.exports, "ChevronIcon", function () { return $df2f20c96d87e347$export$ae15c545ca677b81; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $df2f20c96d87e347$export$ae15c545ca677b81(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 21 21",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M0 1.346L1.375 0l5.793 5.671L12.962 0l1.374 1.346-6.332 6.199c-.465.454-1.207.454-1.672 0L0 1.345z",
            transform: "translate(-1344 -179) translate(453 171) translate(836) rotate(-180 41.5 17.855) rotate(90 9.81 17.355) translate(2.264 6.036)"
        })
    });
}

});

parcelRegister("1VCpi", function(module, exports) {

$parcel$export(module.exports, "PageHeaderBand", function () { return $4dd5c071ad49976c$export$279f249479861174; });
$parcel$export(module.exports, "PageHeaderTitle", function () { return $4dd5c071ad49976c$export$7f365262018175ea; });
$parcel$export(module.exports, "PageHeaderSubtitle", function () { return $4dd5c071ad49976c$export$59fe178165167b5a; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
function $4dd5c071ad49976c$export$279f249479861174(props) {
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($4dd5c071ad49976c$var$Band, {
        ...rest,
        children: /*#__PURE__*/ (0, $4m918.jsx)($4dd5c071ad49976c$var$Inner, {
            children: children
        })
    });
}
const $4dd5c071ad49976c$var$Band = (0, $jb8NR.default).div`
  align-self: stretch;
  margin: -80px -${(0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_NOT_DESKTOP}px 40px;
  padding: 80px ${(0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_NOT_DESKTOP}px 32px;
  background-color: #ffffff;

  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    margin: -60px -${(0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL}px 40px;
    padding: 60px ${(0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL}px 32px;
  }

  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_LARGE_BREAKPOINT}px) {
    margin: -60px -${(0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE}px 40px;
    padding: 60px ${(0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE}px 32px;
  }
`;
const $4dd5c071ad49976c$var$Inner = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $4dd5c071ad49976c$export$7f365262018175ea = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 32px;
  line-height: 42px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $4dd5c071ad49976c$export$59fe178165167b5a = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 20px;
  line-height: 30px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;

});




parcelRegister("eL3qb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca4e9150f9ea82c3$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $9mhzx = parcelRequire("9mhzx");

var $e0mue = parcelRequire("e0mue");

var $4Nwuw = parcelRequire("4Nwuw");
function $ca4e9150f9ea82c3$export$2e2bcd8739ae039() {
    const accounts = (0, $9mhzx.useAccounts)();
    const [account] = (0, $e0mue.useSelectedAccount)(accounts);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    if (!account) return null;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4Nwuw.StatementsPage), {
        account: account,
        accounts: accounts,
        variant: "fee",
        title: formatMessage("myAccountScreen.feesStatement"),
        subtitle: formatMessage("myAccountScreen.feesStatementPageSubtitle"),
        emptyLabel: formatMessage("feesStatements.emptyStatementList")
    });
}

});

parcelRegister("j1R2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09c97cbc87dc01c1$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $4wvTY = parcelRequire("4wvTY");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $9mhzx = parcelRequire("9mhzx");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");

var $izd7j = parcelRequire("izd7j");

var $bZlaH = parcelRequire("bZlaH");

var $1VCpi = parcelRequire("1VCpi");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $e0mue = parcelRequire("e0mue");

var $jzBQx = parcelRequire("jzBQx");
function $09c97cbc87dc01c1$export$2e2bcd8739ae039() {
    const accounts = (0, $9mhzx.useAccounts)();
    const [account] = (0, $e0mue.useSelectedAccount)(accounts);
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { push: push } = (0, $NQIVp.useHistory)();
    const [accountName, setAccountName] = (0, $6uYXW.useState)(account?.name ?? "");
    const [error, setError] = (0, $6uYXW.useState)("");
    const [success, setSuccess] = (0, $6uYXW.useState)("");
    if (!account) return null;
    const downloadBankDetails = async ()=>{
        try {
            await (0, $kqXxS.accountBankDetailsService).downloadAccountBankDetails(account.id);
        } catch (e) {
            setError(e?.response?.data?.error?.message ?? String(e));
        }
    };
    /** Hands the details to the platform's share sheet, falling back to the clipboard without one. */ const shareBankDetails = async ()=>{
        const details = [
            accountName,
            account.iban,
            account.bic
        ].filter(Boolean).join("\n");
        if (navigator.share) await navigator.share({
            text: details
        }).catch(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4wvTY)))(details));
        else (0, (/*@__PURE__*/$parcel$interopDefault($4wvTY)))(details);
    };
    const submitAccountName = ()=>{
        if (accountName === account.name) return;
        (0, $kqXxS.accountManager).updateAccountName(account.id, accountName).then(()=>setSuccess(formatMessage("accountDetails.success"))).catch((e)=>setError(e?.response?.data?.message ?? String(e)));
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)((0, $1VCpi.PageHeaderBand), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderTitle), {
                        children: formatMessage("myAccountScreen.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderSubtitle), {
                        children: formatMessage("myAccountScreen.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($09c97cbc87dc01c1$var$Columns, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$MainColumn, {
                        children: /*#__PURE__*/ (0, $4m918.jsxs)($09c97cbc87dc01c1$var$Card, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$CardTitle, {
                                    children: formatMessage("myAccountScreen.coordinatesTitle")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)((0, $jzBQx.AccountFieldRow), {
                                    label: formatMessage("accountDetails.accountName"),
                                    value: accountName,
                                    onChange: features.sdaAccountsNameUpdate ? (name)=>{
                                        setSuccess("");
                                        setError("");
                                        setAccountName(name);
                                    } : undefined,
                                    onSubmit: submitAccountName
                                }),
                                !!error && /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$FieldError, {
                                    children: error
                                }),
                                !!success && /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$FieldSuccess, {
                                    children: success
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)((0, $jzBQx.AccountFieldRow), {
                                    label: formatMessage("accountDetails.accountIdTitle"),
                                    value: account.id
                                }),
                                (0, $gDlNU.isDefined)(account.iban) && /*#__PURE__*/ (0, $4m918.jsx)((0, $jzBQx.AccountFieldRow), {
                                    label: formatMessage("accountDetails.ibanTitle"),
                                    value: account.iban
                                }),
                                (0, $gDlNU.isDefined)(account.bic) && /*#__PURE__*/ (0, $4m918.jsx)((0, $jzBQx.AccountFieldRow), {
                                    label: formatMessage("accountDetails.bicTitle"),
                                    value: account.bic
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($09c97cbc87dc01c1$var$SideColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($09c97cbc87dc01c1$var$BalanceCard, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsxs)($09c97cbc87dc01c1$var$BalanceRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$BalanceTitle, {
                                                children: formatMessage("accountDetails.balanceTitle")
                                            }),
                                            /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$Balance, {
                                                amount: (0, $kGswT.getSettlementBalance)(account)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$BalanceMessage, {
                                        children: formatMessage("accountDetails.balanceMessage")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($09c97cbc87dc01c1$var$SectionTitle, {
                                children: formatMessage("myAccountScreen.quickActionsTitle")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)((0, $izd7j.ActionRowList), {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                                        label: formatMessage("myAccountScreen.downloadRib"),
                                        trailingIconSrc: (0, $fRvTz.StaticAssets).download,
                                        onClick: downloadBankDetails
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                                        label: formatMessage("myAccountScreen.shareDetails"),
                                        trailingIconSrc: (0, $fRvTz.StaticAssets).share,
                                        onClick: shareBankDetails
                                    }),
                                    features.beneficiariesManagement && /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                                        label: formatMessage("myAccountScreen.manageBeneficiaries"),
                                        subtitle: formatMessage("myAccountScreen.manageBeneficiariesSubtitle"),
                                        onClick: ()=>push((0, $4fYE4.Path).Recipients)
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                                        label: formatMessage("myAccountScreen.accountStatement"),
                                        subtitle: formatMessage("myAccountScreen.accountStatementSubtitle"),
                                        onClick: ()=>push((0, $4fYE4.Path).AccountStatements)
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                                        label: formatMessage("myAccountScreen.feesStatement"),
                                        subtitle: formatMessage("myAccountScreen.feesStatementSubtitle"),
                                        onClick: ()=>push((0, $4fYE4.Path).FeesStatements)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $09c97cbc87dc01c1$var$Columns = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  width: 100%;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    flex-direction: column;
  }
`;
const $09c97cbc87dc01c1$var$MainColumn = (0, $jb8NR.default).div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
`;
const $09c97cbc87dc01c1$var$SideColumn = (0, $jb8NR.default).div`
  display: flex;
  flex: 0 0 380px;
  flex-direction: column;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    flex: 1 1 auto;
    align-self: stretch;
  }
`;
const $09c97cbc87dc01c1$var$Card = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
  ${(0, $22v9q.shadows).sm};
`;
const $09c97cbc87dc01c1$var$CardTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0 0 8px;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $09c97cbc87dc01c1$var$BalanceCard = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[200]};
  border-radius: 12px;
  background-color: ${(0, $22v9q.theme).colors.blue[100]};
  ${(0, $22v9q.shadows).sm};
`;
const $09c97cbc87dc01c1$var$BalanceRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
`;
const $09c97cbc87dc01c1$var$BalanceTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $09c97cbc87dc01c1$var$Balance = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 18px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $09c97cbc87dc01c1$var$BalanceMessage = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 6px;
  max-width: 260px;
  font-size: 12px;
  line-height: 16px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $09c97cbc87dc01c1$var$FieldError = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 12px;
  color: ${(0, $22v9q.theme).colors.error[500]};
`;
const $09c97cbc87dc01c1$var$FieldSuccess = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 12px;
  color: ${(0, $22v9q.theme).colors.success[500]};
`;
const $09c97cbc87dc01c1$var$SectionTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 24px 0 12px;
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;

});
parcelRegister("4wvTY", function(module, exports) {
"use strict";

var $lMsSD = parcelRequire("lMsSD");
var $34b2e59a5db95989$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $34b2e59a5db95989$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $34b2e59a5db95989$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $34b2e59a5db95989$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $lMsSD();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $34b2e59a5db95989$var$clipboardToIE11Formatting[options.format] || $34b2e59a5db95989$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $34b2e59a5db95989$var$format("message" in options ? options.message : $34b2e59a5db95989$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $34b2e59a5db95989$var$copy;

});
parcelRegister("lMsSD", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("izd7j", function(module, exports) {

$parcel$export(module.exports, "ActionRowList", function () { return $abbaa80af46e1f30$export$a9630aa44ea098c6; });
$parcel$export(module.exports, "actionRowStyle", function () { return $abbaa80af46e1f30$export$5d94b2afbc22b06; });
$parcel$export(module.exports, "ActionRow", function () { return $abbaa80af46e1f30$export$549b91d6da945c97; });
$parcel$export(module.exports, "ToggleRow", function () { return $abbaa80af46e1f30$export$8c9abd0860cfec30; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");

var $ajNEj = parcelRequire("ajNEj");

var $51d3M = parcelRequire("51d3M");
const $abbaa80af46e1f30$export$a9630aa44ea098c6 = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
  ${(0, $22v9q.shadows).sm};
`;
const $abbaa80af46e1f30$export$5d94b2afbc22b06 = (0, $jb8NR.css)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px 20px;
  border: 0;
  border-top: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 0;
  background-color: transparent;
  text-align: left;
  cursor: pointer;

  &:first-child {
    border-top: 0;
  }

  &:hover {
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }

  &:disabled {
    cursor: default;
    opacity: 0.3;
  }
`;
function $abbaa80af46e1f30$export$549b91d6da945c97(props) {
    const { label: label, subtitle: subtitle, iconSrc: iconSrc, trailingIconSrc: trailingIconSrc, disabled: disabled, className: className, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($abbaa80af46e1f30$var$Row, {
        type: "button",
        className: className,
        disabled: disabled,
        onClick: onClick,
        children: [
            !!iconSrc && /*#__PURE__*/ (0, $4m918.jsx)($abbaa80af46e1f30$var$LeadingIcon, {
                src: iconSrc,
                alt: ""
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($abbaa80af46e1f30$var$Texts, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($abbaa80af46e1f30$var$Label, {
                        children: label
                    }),
                    !!subtitle && /*#__PURE__*/ (0, $4m918.jsx)($abbaa80af46e1f30$var$Subtitle, {
                        children: subtitle
                    })
                ]
            }),
            trailingIconSrc ? /*#__PURE__*/ (0, $4m918.jsx)($abbaa80af46e1f30$var$TrailingIcon, {
                src: trailingIconSrc,
                alt: ""
            }) : /*#__PURE__*/ (0, $4m918.jsx)($abbaa80af46e1f30$var$RowChevron, {
                width: 14,
                height: 14
            })
        ]
    });
}
function $abbaa80af46e1f30$export$8c9abd0860cfec30(props) {
    const { label: label, value: value, disabled: disabled, className: className, onSwitch: onSwitch } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($abbaa80af46e1f30$var$SwitchRow, {
        className: className,
        $disabled: disabled,
        value: value,
        getSwitchLabel: ()=>label,
        onSwitch: (next)=>!disabled && onSwitch(next)
    });
}
const $abbaa80af46e1f30$var$Row = (0, $jb8NR.default).button`
  ${$abbaa80af46e1f30$export$5d94b2afbc22b06};
`;
/* SwitchContainer already lays a label out against a switch; only the row chrome is missing. */ const $abbaa80af46e1f30$var$SwitchRow = (0, $jb8NR.default)((0, $ajNEj.SwitchContainer))`
  ${$abbaa80af46e1f30$export$5d94b2afbc22b06};
  gap: 12px;

  ${({ $disabled: $disabled })=>$disabled && (0, $jb8NR.css)`
      cursor: default;
      opacity: 0.3;
    `};

  ${(0, $ajNEj.SwitchLabel)} {
    ${(0, $22v9q.theme).text};
    font-size: 16px;
    line-height: 22px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }
`;
const $abbaa80af46e1f30$var$Texts = (0, $jb8NR.default).span`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const $abbaa80af46e1f30$var$Label = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 16px;
  line-height: 22px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $abbaa80af46e1f30$var$Subtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 2px;
  font-size: 12px;
  line-height: 15px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $abbaa80af46e1f30$var$LeadingIcon = (0, $jb8NR.default).img`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
`;
const $abbaa80af46e1f30$var$TrailingIcon = (0, $jb8NR.default).img`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
`;
const $abbaa80af46e1f30$var$RowChevron = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  flex-shrink: 0;
  fill: ${(0, $22v9q.theme).colors.blue[800]};
`;

});
parcelRegister("ajNEj", function(module, exports) {

$parcel$export(module.exports, "SwitchContainer", function () { return $c7868b6cde285691$export$24bf2dbffe2d5985; });
$parcel$export(module.exports, "SwitchLabel", function () { return $c7868b6cde285691$export$39c63c162e5f0cd; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
function $c7868b6cde285691$export$72111f742dee7cb8(props) {
    const { value: value, onSwitch: onSwitch, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($c7868b6cde285691$var$Switch, {
        role: "switch",
        "aria-checked": value,
        onClick: ()=>onSwitch(!value),
        ...rest,
        children: /*#__PURE__*/ (0, $4m918.jsx)($c7868b6cde285691$var$Round, {})
    });
}
function $c7868b6cde285691$export$24bf2dbffe2d5985(props) {
    const { value: value, labelPosition: labelPosition = "rigth", className: className, onSwitch: onSwitch, getSwitchLabel: getSwitchLabel, ...rest } = props;
    return(/* The button is what the keyboard reaches, so it is what carries the state: the drawing
       inside it would otherwise hold a role nobody can land on. */ /*#__PURE__*/ (0, $4m918.jsxs)($c7868b6cde285691$var$Container, {
        type: "button",
        role: "switch",
        "aria-checked": value,
        className: className,
        onClick: ()=>onSwitch(!value),
        reversed: labelPosition === "left",
        children: [
            getSwitchLabel && /*#__PURE__*/ (0, $4m918.jsx)($c7868b6cde285691$export$39c63c162e5f0cd, {
                children: getSwitchLabel(props.value)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($c7868b6cde285691$export$72111f742dee7cb8, {
                ...rest,
                value: value,
                onSwitch: onSwitch,
                "aria-hidden": "true",
                tabIndex: -1
            })
        ]
    }));
}
const $c7868b6cde285691$var$Container = (0, $jb8NR.default).button`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 15px;
  padding: 2px;
  border: none;
  background-color: transparent;
  ${({ reversed: reversed })=>reversed ? "flex-direction: row-reverse;" : ""}
`;
const $c7868b6cde285691$var$Switch = (0, $jb8NR.default).div`
  width: 48px;
  height: 25px;
  padding: 3px 3px 3px 26px;
  border-radius: 12.5px;
  background-color: ${(0, $22v9q.theme).mainColor};
  opacity: 1;
  transition: opacity 0.2s;
  will-change: opacity;

  &[aria-checked="false"] {
    background-color: ${(0, $22v9q.theme).colors.gray[300]};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
const $c7868b6cde285691$var$Round = (0, $jb8NR.default).div`
  width: 19px;
  height: 19px;
  border-radius: 10px;
  background-color: white;
  transition: transform 0.2s;
  will-change: transform;
  transform: translateX(-23px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

  [aria-checked="true"] & {
    background-color: #ffffff;
    transform: translateX(0);
  }
`;
const $c7868b6cde285691$export$39c63c162e5f0cd = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText}
  flex: 1;
  color: black;
  font-size: 0.85rem;
  user-select: none;
`;

});


parcelRegister("jzBQx", function(module, exports) {

$parcel$export(module.exports, "AccountFieldRow", function () { return $997437892649d71f$export$ff1da05aae189caa; });

var $4m918 = parcelRequire("4m918");

var $4wvTY = parcelRequire("4wvTY");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bewhU = parcelRequire("bewhU");

var $6cHy0 = parcelRequire("6cHy0");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");
function $997437892649d71f$export$ff1da05aae189caa({ label: label, value: value, onChange: onChange, onSubmit: onSubmit }) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const editable = !!onChange;
    return /*#__PURE__*/ (0, $4m918.jsxs)($997437892649d71f$var$Row, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($997437892649d71f$var$LabelRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($997437892649d71f$var$Label, {
                        children: label
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($997437892649d71f$var$CopyButton, {
                        "aria-label": formatMessage("accountDetails.clipboard", {
                            name: label
                        }),
                        onClick: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($4wvTY)))(value),
                        children: /*#__PURE__*/ (0, $4m918.jsx)($997437892649d71f$var$CopyIcon, {
                            src: (0, $fRvTz.StaticAssets).copy,
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($997437892649d71f$var$Box, {
                $editable: editable,
                children: editable ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($997437892649d71f$var$Input, {
                            value: value,
                            onChange: (event)=>onChange?.(event.target.value),
                            onBlur: ()=>onSubmit?.(),
                            onKeyDown: (event)=>event.key === "Enter" && onSubmit?.()
                        }),
                        !!value && /*#__PURE__*/ (0, $4m918.jsx)($997437892649d71f$var$ClearButton, {
                            "aria-label": formatMessage("common.clear"),
                            onClick: ()=>onChange?.(""),
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $6cHy0.CrossIcon), {
                                width: 12,
                                height: 12
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $4m918.jsx)($997437892649d71f$var$ReadOnlyValue, {
                    children: value
                })
            })
        ]
    });
}
const $997437892649d71f$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $997437892649d71f$var$LabelRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
`;
const $997437892649d71f$var$Label = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 13px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $997437892649d71f$var$CopyButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  padding: 2px;
`;
const $997437892649d71f$var$CopyIcon = (0, $jb8NR.default).img`
  width: 16px;
  height: 16px;
`;
const $997437892649d71f$var$Box = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 14px;
  border: 1px solid ${(props)=>props.$editable ? "#d9d9d9" : (0, $22v9q.theme).colors.gray[100]};
  border-radius: 8px;
  background-color: ${(props)=>props.$editable ? "#ffffff" : "#fbfbfb"};
`;
const $997437892649d71f$var$Input = (0, $jb8NR.default).input`
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  background-color: transparent;
  font-family: inherit;
  font-size: 14px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $997437892649d71f$var$ClearButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  flex-shrink: 0;
  padding: 2px;
`;
const $997437892649d71f$var$ReadOnlyValue = (0, $jb8NR.default).span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-size: 14px;
  color: ${(0, $22v9q.theme).colors.gray[500]};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

});
parcelRegister("6cHy0", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", function () { return $6d5e74c66852b2d7$export$3b621d86b1566b2; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $6d5e74c66852b2d7$export$3b621d86b1566b2(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "27",
        height: "27",
        viewBox: "0 0 27 27",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("g", {
            fillRule: "evenodd",
            fill: props.fill ?? "#fff",
            children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M175.548 302.605c.586-.585 1.536-.585 2.122 0l9.663 9.664 9.664-9.664c.586-.585 1.536-.585 2.121 0l.943.943c.586.586.586 1.536 0 2.122l-9.664 9.663 9.664 9.664c.586.586.586 1.536 0 2.121l-.943.943c-.585.586-1.535.586-2.12 0l-9.666-9.664-9.662 9.664c-.586.586-1.536.586-2.122 0l-.943-.943c-.585-.585-.585-1.535 0-2.12l9.663-9.665-9.663-9.663c-.585-.586-.585-1.536 0-2.122l.943-.943z",
                transform: "translate(-174 -302)"
            })
        })
    });
}

});



parcelRegister("56WMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf4c616d22f186db$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $9mhzx = parcelRequire("9mhzx");

var $b6V1s = parcelRequire("b6V1s");

var $3U0hy = parcelRequire("3U0hy");

var $cPJq2 = parcelRequire("cPJq2");

var $cKILb = parcelRequire("cKILb");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $bQhUC = parcelRequire("bQhUC");

var $4fYE4 = parcelRequire("4fYE4");

var $5Wai4 = parcelRequire("5Wai4");

var $gf1iA = parcelRequire("gf1iA");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $levoc = parcelRequire("levoc");

var $eSR05 = parcelRequire("eSR05");

var $iy3jB = parcelRequire("iy3jB");

var $kVkkQ = parcelRequire("kVkkQ");

var $agLlU = parcelRequire("agLlU");

var $hZs1x = parcelRequire("hZs1x");

var $e0mue = parcelRequire("e0mue");
const $bf4c616d22f186db$var$LATEST_TRANSACTIONS_COUNT = 5;
function $bf4c616d22f186db$export$2e2bcd8739ae039() {
    const accounts = (0, $9mhzx.useAccounts)();
    const transactionDirection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).directionSelection);
    const isConnecting = (0, $3Ersk.useObservable)((0, $kqXxS.authExecutor).isConnecting);
    const loading = (0, $3Ersk.useObservable)((0, $kqXxS.accountManager).loading);
    const refreshing = (0, $3Ersk.useObservable)((0, $kqXxS.accountManager).refreshing);
    const accountsLoading = loading || refreshing;
    const [isGlobalLoading, setIsGlobalLoading] = (0, $6uYXW.useState)(true);
    const [onboardingIsPendingVerification, setOnboardingIsPendingVerification] = (0, $6uYXW.useState)(false);
    const [focusedAccount] = (0, $e0mue.useSelectedAccount)(accounts);
    const { filters: filters } = (0, $b6V1s.useTransactionFilter)(focusedAccount);
    const transactions = (0, $3U0hy.useTransactions)(focusedAccount, transactionDirection, filters);
    const { onboardingFile: onboardingFile, needOnboardingFileRedirect: needOnboardingFileRedirect, loading: onboardingFileLoading } = (0, $cKILb.useOnboardingFile)();
    const history = (0, $NQIVp.useHistory)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const showTrustModal = ()=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.TRUST_CHOICE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $hZs1x.TrustChoiceModal), {}), {
            backdropColor: "#f4f4f4",
            backdropOpacity: 1,
            canBeDismissed: false
        });
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (isConnecting) {
            const shouldShowTrustModal = !await (0, $kqXxS.trustManager).isValid();
            if (shouldShowTrustModal) showTrustModal();
            else await (0, $kqXxS.trustManager).checkTrusted();
        }
    }, [
        isConnecting
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (!onboardingFileLoading) {
            if (needOnboardingFileRedirect) history.push((0, $4fYE4.Path).OnboardingFile);
            setIsGlobalLoading(false);
        }
    }, [
        onboardingFileLoading
    ]);
    (0, $6uYXW.useEffect)(()=>{
        setOnboardingIsPendingVerification(onboardingFile?.status === (0, $cPJq2.OnboardingStatus).PENDING_VERIFICATION);
    }, [
        onboardingFile
    ]);
    const showTransactionDetails = (transaction)=>{
        focusedAccount && (0, $5Wai4.Modal).present((0, $bQhUC.ACCOUNT_TRANSACTION_DETAILS_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $eSR05.AccountTransactionDetailsModal), {
                transaction: transaction,
                account: focusedAccount
            }), {
            canBeDismissed: false
        });
    };
    if (onboardingIsPendingVerification) return /*#__PURE__*/ (0, $4m918.jsx)($bf4c616d22f186db$var$StyledGlobalContainer, {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($bf4c616d22f186db$var$StyledMessageCard, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($bf4c616d22f186db$var$StyledTitle, {
                    children: formatMessage("accountPendingVerification.title")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($bf4c616d22f186db$var$StyledMessage, {
                    children: formatMessage("accountPendingVerification.subtitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($bf4c616d22f186db$var$UnderlinedButton, {
                    onClick: ()=>window.location.reload(),
                    children: formatMessage("accountPendingVerification.retry")
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            !accountsLoading && accounts.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)($bf4c616d22f186db$var$NoAccountAvailable, {
                children: formatMessage("accountsList.noAccountAvailable")
            }) : !!focusedAccount && /*#__PURE__*/ (0, $4m918.jsxs)($bf4c616d22f186db$var$Columns, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($bf4c616d22f186db$var$MainColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $levoc.AccountBalanceCard), {
                                account: focusedAccount
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $kVkkQ.MonthlyFluxSection), {
                                account: focusedAccount
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3jB.LatestTransactionsSection), {
                                transactions: transactions.data.slice(0, $bf4c616d22f186db$var$LATEST_TRANSACTIONS_COUNT),
                                loading: transactions.loading,
                                onTransactionClick: showTransactionDetails
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($bf4c616d22f186db$var$SideColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($bf4c616d22f186db$var$AlertsSlot, {}),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $agLlU.RequiredActionsCard), {
                                account: focusedAccount,
                                toJustifyCount: transactions.unjustifiedTransactions2.total,
                                toQualifyCount: transactions.unqualifiedTransactions.total
                            })
                        ]
                    })
                ]
            }),
            isGlobalLoading && /*#__PURE__*/ (0, $4m918.jsx)($bf4c616d22f186db$var$StyledGlobalLoader, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "60"
                })
            })
        ]
    });
}
const $bf4c616d22f186db$var$Columns = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  width: 100%;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    flex-direction: column;
  }
`;
const $bf4c616d22f186db$var$MainColumn = (0, $jb8NR.default).div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`;
const $bf4c616d22f186db$var$SideColumn = (0, $jb8NR.default).div`
  display: flex;
  flex: 0 0 340px;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    flex: 1 1 auto;
    align-self: stretch;
  }
`;
/* The page alerts land here instead of above the content; their stacking is the column's. */ const $bf4c616d22f186db$var$AlertsSlot = (0, $jb8NR.default)((0, $gf1iA.PageAlertsSlot))`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;
const $bf4c616d22f186db$var$NoAccountAvailable = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 20px;
  margin-bottom: 40px;
`;
const $bf4c616d22f186db$var$StyledGlobalLoader = (0, $jb8NR.default).div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(0, $22v9q.theme).colors.gray[100]};
  z-index: 1000000;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $bf4c616d22f186db$var$StyledGlobalContainer = (0, $jb8NR.default).div`
  height: 100%;
  margin-top: -20px;
  background-color: ${(0, $22v9q.theme).colors.gray[100]};
`;
const $bf4c616d22f186db$var$StyledMessageCard = (0, $jb8NR.default).div`
  background-color: #ffecd1;
  border-radius: 13px;
  padding: 16px;
`;
const $bf4c616d22f186db$var$StyledTitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).bodyBlackBold}
  color: #000000;
  flex-grow: 1;
  flex-shrink: 1;
  padding-right: 8px;
`;
const $bf4c616d22f186db$var$StyledMessage = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  font-size: 14px;
  margin-top: 10px;
  color: ${(0, $22v9q.theme).colors.gray[700]};
`;
const $bf4c616d22f186db$var$UnderlinedButton = (0, $jb8NR.default).button`
  ${(0, $22v9q.theme).bodyGreyRegular}
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  appearance: none;
  color: #000000;
  font-size: 13px;
  text-decoration: underline;
  margin-top: 16px;
  &:hover {
    text-decoration: none;
  }
`;

});
parcelRegister("b6V1s", function(module, exports) {

$parcel$export(module.exports, "useTransactionFilter", function () { return $bec0ffe4fc1c314b$export$dee2ef5c42884977; });
$parcel$export(module.exports, "useFormattedAmountRange", function () { return $bec0ffe4fc1c314b$export$d340bbb8e42ada66; });
$parcel$export(module.exports, "useTransactionDateFilter", function () { return $bec0ffe4fc1c314b$export$ecb40188c05d0636; });

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $kGswT = parcelRequire("kGswT");

var $7yIx1 = parcelRequire("7yIx1");

var $Rr3Qd = parcelRequire("Rr3Qd");

var $ao7HR = parcelRequire("ao7HR");
const $bec0ffe4fc1c314b$export$dee2ef5c42884977 = (account)=>{
    const timerangeSelection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).timeRangeSelection);
    const amountRange = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).amountRange);
    const directionSelection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).directionSelection);
    const justificationSelection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).justificationSelection);
    const filters = (0, $6uYXW.useMemo)(()=>({
            timerange: timerangeSelection,
            amountRange: amountRange,
            currencyId: account?.currencyAlpha,
            // The API only accepts the "not yet done" side of these, hence 0 or undefined.
            ...justificationSelection === (0, $Rr3Qd.JustificationFilter).TO_JUSTIFY && {
                isJustified: 0,
                isLocked: 0
            },
            ...justificationSelection === (0, $Rr3Qd.JustificationFilter).TO_QUALIFY && {
                isQualified: 0,
                isLocked: 0
            },
            // Justification and qualification only concern expenses. Without this the API returns
            // every unjustified transaction, incoming money included, since a credit is never
            // justified. Same restriction as the counters in TransactionsLoader.
            ...justificationSelection !== (0, $Rr3Qd.JustificationFilter).ALL && {
                direction: "debit"
            }
        }), [
        timerangeSelection,
        amountRange,
        account,
        justificationSelection
    ]);
    const { formattedAmountRange: formattedAmountRange, hasAmountFilter: hasAmountFilter } = $bec0ffe4fc1c314b$export$d340bbb8e42ada66(account);
    const hasDirectionFilter = directionSelection !== (0, $ao7HR.TransactionDirection).ALL;
    const hasJustificationFilter = justificationSelection !== (0, $Rr3Qd.JustificationFilter).ALL;
    const hasFilter = hasDirectionFilter || timerangeSelection.timeRange !== (0, $7yIx1.TimeRange).Quarter || hasAmountFilter || hasJustificationFilter;
    return {
        filters: filters,
        formattedAmountRange: formattedAmountRange,
        hasFilter: hasFilter,
        hasDirectionFilter: hasDirectionFilter,
        directionFilter: directionSelection,
        hasDateCustomFilter: timerangeSelection.timeRange === (0, $7yIx1.TimeRange).Other,
        fromDate: timerangeSelection.bounds[0]?.toDate(),
        toDate: timerangeSelection.bounds[1]?.toDate(),
        hasAmountFilter: hasAmountFilter,
        justificationFilter: justificationSelection,
        hasJustificationFilter: hasJustificationFilter
    };
};
const $bec0ffe4fc1c314b$export$d340bbb8e42ada66 = (account)=>{
    const currency = account ? (0, $kGswT.getSettlementBalance)(account).currencyAlpha : null;
    const { formatNumber: formatNumber } = (0, $5hpYi.useIntl)();
    const amountRange = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).amountRange);
    const hasAmountFilter = $bec0ffe4fc1c314b$var$hasBounds(amountRange);
    const formattedAmountRange = (0, $6uYXW.useMemo)(()=>currency ? `${formatNumber(amountRange[0] ?? 0, {
            currency: currency,
            style: "currency",
            minimumFractionDigits: 0
        })} - ${amountRange[1] ? formatNumber(amountRange[1], {
            currency: currency,
            style: "currency",
            minimumFractionDigits: 0
        }) : "--"}` : "-- - --", [
        amountRange,
        currency,
        formatNumber
    ]);
    return {
        formattedAmountRange: formattedAmountRange,
        hasAmountFilter: hasAmountFilter
    };
};
const $bec0ffe4fc1c314b$export$ecb40188c05d0636 = ()=>{
    const [startDate, setStartDate] = (0, $6uYXW.useState)((0, $kqXxS.transactionSearchManager).timeRangeSelection.get().timeRange === (0, $7yIx1.TimeRange).Other ? (0, $kqXxS.transactionSearchManager).timeRangeSelection.get().bounds[0]?.toDate() : undefined);
    const [endDate, setEndDate] = (0, $6uYXW.useState)((0, $kqXxS.transactionSearchManager).timeRangeSelection.get().timeRange === (0, $7yIx1.TimeRange).Other ? (0, $kqXxS.transactionSearchManager).timeRangeSelection.get().bounds[1]?.toDate() : undefined);
    const onStartDateChange = (0, $6uYXW.useCallback)((newStartDate, onlyOneMonth)=>{
        setStartDate(newStartDate);
        if (!$bec0ffe4fc1c314b$var$isValidInterval(newStartDate, endDate)) {
            const monthsToAdd = onlyOneMonth ? 1 : 3;
            setEndDate((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(newStartDate).add(monthsToAdd, "month").endOf("day").toDate());
        }
    }, [
        endDate
    ]);
    const onEndDateChange = (0, $6uYXW.useCallback)((newEndDate, onlyOneMonth, preventStartDateChange)=>{
        setEndDate(newEndDate);
        if (preventStartDateChange) {
            if (!startDate) setStartDate((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(newEndDate).subtract(1, "month").add(1, "day").startOf("day").toDate());
        } else if (!$bec0ffe4fc1c314b$var$isValidInterval(startDate, newEndDate)) {
            const monthsToSubtract = onlyOneMonth ? 1 : 3;
            setStartDate((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(newEndDate).subtract(monthsToSubtract, "month").add(1, "hour").toDate());
        }
    }, [
        startDate
    ]);
    return {
        startDate: startDate,
        endDate: endDate,
        onStartDateChange: onStartDateChange,
        onEndDateChange: onEndDateChange
    };
};
function $bec0ffe4fc1c314b$var$hasBounds(bounds) {
    const [low, high] = bounds;
    return low !== null || high !== null;
}
const $bec0ffe4fc1c314b$var$isValidInterval = (from, to)=>{
    if (from === undefined && to === undefined) return true;
    if (to === undefined || from === undefined) return false;
    const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(from);
    const endDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(to);
    const isStartDateBeforeEndDate = startDate.isSameOrBefore(endDate);
    return isStartDateBeforeEndDate && endDate.diff(startDate, "month", true) <= 3;
};

});

parcelRegister("3U0hy", function(module, exports) {

$parcel$export(module.exports, "useTransactions", function () { return $93d24d86cf856376$export$4127a74fddb92b6f; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $fZL4e = parcelRequire("fZL4e");
function $93d24d86cf856376$export$4127a74fddb92b6f(account, transactionDirection, transactionFilters, loadAtStartup = true) {
    const accountId = (0, $6uYXW.useMemo)(()=>account !== null ? account.id : null, [
        account
    ]);
    const loader = (0, $6uYXW.useMemo)(()=>{
        if (!accountId) return (0, $kqXxS.transactionsManager).getDefaultLoader();
        if (transactionFilters) return (0, $kqXxS.transactionsManager).getSearchTransactionsLoader(accountId, transactionDirection, transactionFilters);
        return (0, $kqXxS.transactionsManager).getTransactionsLoader(accountId, transactionDirection);
    }, [
        accountId,
        transactionDirection,
        transactionFilters
    ]);
    const data = (0, $3Ersk.useObservable)(loader.data);
    const unjustifiedData = (0, $3Ersk.useObservable)(loader.unjustifiedData);
    const unqualifiedData = (0, $3Ersk.useObservable)(loader.unqualifiedData);
    const initializing = (0, $3Ersk.useObservable)(loader.initializing);
    const loading = (0, $3Ersk.useObservable)(loader.loading);
    const refreshing = (0, $3Ersk.useObservable)(loader.refreshing);
    const error = (0, $3Ersk.useObservable)(loader.error);
    const loadingMore = (0, $3Ersk.useObservable)(loader.loadingMore);
    const loadingMoreError = (0, $3Ersk.useObservable)(loader.loadingMoreError);
    const cacheStatus = (0, $3Ersk.useObservable)(loader.cacheStatus);
    const { canJustify: canJustify, canShowJustifyLabel: canShowJustifyLabel } = (0, $fZL4e.useTransactionLinks)();
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (loadAtStartup) await loader.load();
    }, [
        loader
    ]);
    const refresh = (0, $6uYXW.useCallback)(async ()=>{
        await loader.refresh();
    }, [
        loader
    ]);
    const canLoadMore = (0, $6uYXW.useMemo)(()=>data.offset + data.limit < data.total, [
        data.offset,
        data.limit,
        data.total
    ]);
    const loadMore = (0, $6uYXW.useCallback)(async ()=>{
        await loader.loadMore();
    }, [
        loader
    ]);
    const unjustifiedTransactions = (0, $6uYXW.useMemo)(()=>{
        if (!data.items) return [];
        return data.items.filter((transaction)=>canShowJustifyLabel(transaction));
    }, [
        data.items
    ]);
    const unjustifiedTransactions2 = (0, $6uYXW.useMemo)(()=>{
        if (!unjustifiedData.items) return {
            total: 0,
            items: []
        };
        return {
            total: unjustifiedData.total,
            items: unjustifiedData.items
        };
    }, [
        unjustifiedData.items
    ]);
    const unqualifiedTransactions = (0, $6uYXW.useMemo)(()=>{
        if (!unqualifiedData.items) return {
            total: 0,
            items: []
        };
        return {
            total: unqualifiedData.total,
            items: unqualifiedData.items
        };
    }, [
        unqualifiedData.items
    ]);
    return {
        data: data.items,
        unjustifiedTransactions: unjustifiedTransactions,
        unjustifiedTransactions2: unjustifiedTransactions2,
        unqualifiedTransactions: unqualifiedTransactions,
        loading: initializing || loading,
        error: error,
        canLoadMore: canLoadMore,
        loadMore: loadMore,
        loadingMore: loadingMore,
        loadingMoreError: loadingMoreError,
        refresh: refresh,
        refreshing: refreshing,
        cacheStatus: cacheStatus
    };
}

});
parcelRegister("fZL4e", function(module, exports) {

$parcel$export(module.exports, "useTransactionLinks", function () { return $162a7fd4173c707b$export$1c1b2aeecb9d7c25; });

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $iMWY7 = parcelRequire("iMWY7");

var $4RaAR = parcelRequire("4RaAR");
const $162a7fd4173c707b$export$1c1b2aeecb9d7c25 = ()=>{
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const getLinks = (transaction)=>// Filter to keep only expenses
        // if (transaction && transaction.amount && transaction.amount.value > 0) {
        // 	return [];
        // }
        transaction?.links ?? [];
    const isOutgoing = (transaction)=>{
        if (transaction.detailedAccounting) return (0, $iMWY7.getTotalOfDetailedAccounting)(transaction.detailedAccounting) < 0;
        return Number(transaction.amount?.value) < 0;
    };
    const canViewJustification = (transaction)=>(canGetSpendings(transaction) || canGetAttachments(transaction)) && isOutgoing(transaction);
    const canJustify = (transaction)=>{
        if (!features.manageCategorizationSpendings) return false;
        return (!transaction.justified || !transaction.qualified) && isOutgoing(transaction);
    };
    const canShowJustifyLabel = (transaction)=>{
        if (!features.manageCategorizationSpendings) return false;
        if (transaction.locked) return false;
        return (!transaction.justified || !transaction.qualified) && isOutgoing(transaction);
    };
    const canEditJustification = (transaction)=>{
        if (!features.manageCategorizationSpendings) return false;
        const links = getLinks(transaction);
        return links.findIndex((link)=>link.rel === (0, $4RaAR.TransactionLinks).GetSpendings || link.rel === (0, $4RaAR.TransactionLinks).GetAttachments) > -1;
    };
    const canShowAttachments = (transaction)=>{
        const links = getLinks(transaction);
        return links.findIndex((link)=>link.rel === (0, $4RaAR.TransactionLinks).AddAttachment || link.rel === (0, $4RaAR.TransactionLinks).GetAttachments) > -1;
    };
    const canShowSpendings = (transaction)=>{
        const links = getLinks(transaction);
        return links.findIndex((link)=>link.rel === (0, $4RaAR.TransactionLinks).AddSpending || link.rel === (0, $4RaAR.TransactionLinks).GetSpendings) > -1;
    };
    const canGetSpendings = (transaction)=>{
        const links = getLinks(transaction);
        return links.findIndex((link)=>link.rel === (0, $4RaAR.TransactionLinks).GetSpendings) > -1;
    };
    const canGetAttachments = (transaction)=>{
        const links = getLinks(transaction);
        return links.findIndex((link)=>link.rel === (0, $4RaAR.TransactionLinks).GetAttachments) > -1;
    };
    const canAddSpending = (transaction)=>{
        const links = getLinks(transaction);
        return links.findIndex((link)=>link.rel === (0, $4RaAR.TransactionLinks).AddSpending) > -1;
    };
    const canAddAttachment = (transaction)=>{
        const links = getLinks(transaction);
        return links.findIndex((link)=>link.rel === (0, $4RaAR.TransactionLinks).AddAttachment) > -1;
    };
    const canGetBothAttachmentsAndSpendings = (transaction)=>{
        if (!features.manageCategorizationSpendings) return false;
        return canGetAttachments(transaction) && canGetSpendings(transaction);
    };
    return {
        isOutgoing: isOutgoing,
        canJustify: canJustify,
        canShowJustifyLabel: canShowJustifyLabel,
        canEditJustification: canEditJustification,
        canShowAttachments: canShowAttachments,
        canShowSpendings: canShowSpendings,
        canGetSpendings: canGetSpendings,
        canGetAttachments: canGetAttachments,
        canAddSpending: canAddSpending,
        canAddAttachment: canAddAttachment,
        canViewJustification: canViewJustification,
        canGetBothAttachmentsAndSpendings: canGetBothAttachmentsAndSpendings
    };
};

});
parcelRegister("iMWY7", function(module, exports) {

$parcel$export(module.exports, "getTotalOfDetailedAccounting", function () { return $aeabe043d652f144$export$816cd24d8c5f4d12; });
function $aeabe043d652f144$export$816cd24d8c5f4d12(detailedAccounting) {
    return detailedAccounting.reduce((total, item)=>total + item.amount.value, 0);
}

});

parcelRegister("4RaAR", function(module, exports) {

$parcel$export(module.exports, "TransactionLinks", function () { return $4b2851a9a81cffe5$export$d90cdd21c1b28eab; });
var $4b2851a9a81cffe5$export$d90cdd21c1b28eab = /*#__PURE__*/ function(TransactionLinks) {
    TransactionLinks["AddSpending"] = "addSpending";
    TransactionLinks["AddAttachment"] = "addAttachment";
    TransactionLinks["GetSpendings"] = "getSpendings";
    TransactionLinks["GetAttachments"] = "getAttachments";
    return TransactionLinks;
}({});

});



parcelRegister("cKILb", function(module, exports) {

$parcel$export(module.exports, "useOnboardingFile", function () { return $bbfae75430d6dcb2$export$14c783a731e1b520; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $bbfae75430d6dcb2$export$c680df02dce50aab = ()=>{
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const getLinks = (onboardingFile)=>onboardingFile?.links ?? [];
    const canUpdate = (onboardingFile)=>{
        let links = [];
        if (onboardingFile) links = getLinks(onboardingFile);
        return links.some((link)=>link.rel === "updateFile") && features.sdaCustomerOnboardingUpdate;
    };
    const canSubmit = (onboardingFile)=>{
        let links = [];
        if (onboardingFile) links = getLinks(onboardingFile);
        return links.some((link)=>link.rel === "submitFile") && features.sdaCustomerOnboardingSubmit;
    };
    return {
        getLinks: getLinks,
        canUpdate: canUpdate,
        canSubmit: canSubmit
    };
};
const $bbfae75430d6dcb2$export$14c783a731e1b520 = ()=>{
    const onboardingFile = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).onboardingFile);
    const steps = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).steps);
    const [loading, setLoading] = (0, $6uYXW.useState)(true);
    const needSaveBeforeSubmit = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).updated);
    const isUpdating = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).updating);
    const isConverting = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).converting);
    const isSubmitting = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).submitting);
    const error = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).error);
    const [currentStepIndex, setCurrentStepIndex] = (0, $6uYXW.useState)(0);
    const [erroredFields, setErroredFields] = (0, $6uYXW.useState)([]);
    const { canSubmit: canSubmit, canUpdate: canUpdate } = $bbfae75430d6dcb2$export$c680df02dce50aab();
    const needOnboardingFileRedirect = (0, $3Ersk.useObservable)((0, $kqXxS.onboardingManager).needOnboardingFileRedirect);
    const [clientDelegateErrorDetected, setClientDelegateErrorDetected] = (0, $6uYXW.useState)(false);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        try {
            setLoading(true);
            await (0, $kqXxS.onboardingManager).initialize();
        } catch (e) {
            if (e === "CLIENT_DELEGATE_USER_NOT_ALLOWED") setClientDelegateErrorDetected(true);
            else console.error(e);
        } finally{
            setLoading(false);
        }
    }, []);
    const moveForward = async (successCallback)=>{
        setErroredFields([]);
        if (currentStepIndex + 1 <= steps.length) {
            if (canUpdate(onboardingFile)) try {
                // Pass step ID string instead of index
                const stepId = steps[currentStepIndex]?.id;
                if (!stepId) throw new Error(`Step at index ${currentStepIndex} not found`);
                await (0, $kqXxS.onboardingManager).updateOnboardingFile(stepId);
                if (currentStepIndex + 1 < steps.length) setCurrentStepIndex(currentStepIndex + 1);
                successCallback?.();
            } catch (e) {
                if (e.hasOwnProperty("message") && (e.message === "Invalid fields" || e.message === "Missing required fields")) setErroredFields(e.fields);
                else (0, $6JVVB.logger).debug("error updating onboarding file", e);
            }
            else {
                if (currentStepIndex + 1 < steps.length) setCurrentStepIndex(currentStepIndex + 1);
                successCallback?.();
            }
        }
    };
    const moveBackward = ()=>{
        if (currentStepIndex > 0) {
            (0, $kqXxS.onboardingManager).clearError();
            setCurrentStepIndex(currentStepIndex - 1);
        }
    };
    const submitOnboardingFile = async ()=>{
        if (!canSubmit(onboardingFile)) return;
        try {
            return await (0, $kqXxS.onboardingManager).submitOnboardingFile();
        } catch (e) {
            (0, $6JVVB.logger).debug("error submitting onboarding file", e);
        }
    };
    return {
        onboardingFile: onboardingFile,
        steps: steps,
        loading: loading,
        currentStepIndex: currentStepIndex,
        currentStep: steps[currentStepIndex],
        needSaveBeforeSubmit: needSaveBeforeSubmit,
        isUpdating: isUpdating,
        isConverting: isConverting,
        isSubmitting: isSubmitting,
        error: error,
        erroredFields: erroredFields,
        canSubmit: canSubmit(onboardingFile),
        canUpdate: canUpdate(onboardingFile),
        isLastStep: currentStepIndex === steps.length - 1,
        needOnboardingFileRedirect: needOnboardingFileRedirect,
        clientDelegateErrorDetected: clientDelegateErrorDetected,
        moveForward: moveForward,
        moveBackward: moveBackward,
        submitOnboardingFile: submitOnboardingFile,
        initiate: async (data)=>{
            await (0, $kqXxS.onboardingManager).initiate(data);
        },
        fillResponse: (input, value)=>{
            const stepId = steps[currentStepIndex]?.id;
            if (!stepId) throw new Error(`Step at index ${currentStepIndex} not found`);
            (0, $kqXxS.onboardingManager).fillResponse(stepId, input, value);
        },
        fillMultiImages: (input, values)=>{
            const stepId = steps[currentStepIndex]?.id;
            if (!stepId) throw new Error(`Step at index ${currentStepIndex} not found`);
            return (0, $kqXxS.onboardingManager).fillMultiImagesResponse(stepId, input, values);
        },
        areThereMissingRequiredFields: (inputs)=>(0, $kqXxS.onboardingManager).valuesHaveMissingRequiredFields(inputs).errorFields.length > 0
    };
};

});

parcelRegister("bQhUC", function(module, exports) {

$parcel$export(module.exports, "TRANSFER_MODAL_ID", function () { return $855ba498af576448$export$8251873390cbda07; });
$parcel$export(module.exports, "BILL_ISSUER_MODAL_ID", function () { return $855ba498af576448$export$800d490a2e85ba52; });
$parcel$export(module.exports, "ADD_RECIPIENT_MODAL_ID", function () { return $855ba498af576448$export$76e99c6c5f675d40; });
$parcel$export(module.exports, "EDIT_RECIPIENT_MODAL_ID", function () { return $855ba498af576448$export$7890c93d3286e2e0; });
$parcel$export(module.exports, "REMOVE_RECIPIENT_MODAL_ID", function () { return $855ba498af576448$export$86f172adad7759d1; });
$parcel$export(module.exports, "ADD_OR_EDIT_SPENDING", function () { return $855ba498af576448$export$931924a93466d830; });
$parcel$export(module.exports, "REMOVE_ATTACHMENT_MODAL_ID", function () { return $855ba498af576448$export$da40dedd7ee48a81; });
$parcel$export(module.exports, "REMOVE_SPENDING_MODAL_ID", function () { return $855ba498af576448$export$41ac648b5541798c; });
$parcel$export(module.exports, "ACCOUNT_TRANSACTION_DETAILS_MODAL_ID", function () { return $855ba498af576448$export$bd4105273b581e47; });
$parcel$export(module.exports, "ACCOUNT_DETAIL_MODAL_ID", function () { return $855ba498af576448$export$8dd5501249bc1137; });
$parcel$export(module.exports, "CASH_TRANSFER_MODAL_ID", function () { return $855ba498af576448$export$2007ebba11237b4a; });
$parcel$export(module.exports, "CARD_OPPOSITION_MODAL_ID", function () { return $855ba498af576448$export$e55761f23de72926; });
$parcel$export(module.exports, "CARD_DEACTIVATION_MODAL_ID", function () { return $855ba498af576448$export$453ddf8496cc7bd8; });
$parcel$export(module.exports, "CARD_ACTIVATION_MODAL_ID", function () { return $855ba498af576448$export$b4775db91bd3a0be; });
$parcel$export(module.exports, "CARD_CREATION_MODAL_ID", function () { return $855ba498af576448$export$3c595e48bb83e5ab; });
$parcel$export(module.exports, "CARD_PINCODE_UPDATE_MODAL_ID", function () { return $855ba498af576448$export$ebc2916a28edbacc; });
$parcel$export(module.exports, "CARD_UPDATE_OUTSTANDING_MODAL_ID", function () { return $855ba498af576448$export$930196dcf4a94d3; });
$parcel$export(module.exports, "CARD_REFABRICATION_MODAL_ID", function () { return $855ba498af576448$export$d22905ab137b326; });
$parcel$export(module.exports, "CARD_SENSITIVE_DETAILS_MODAL_ID", function () { return $855ba498af576448$export$f6c4ef69ba9e353b; });
$parcel$export(module.exports, "PINCODE_MUST_BE_CHANGED_MODAL_ID", function () { return $855ba498af576448$export$67bb2a2055713b7d; });
$parcel$export(module.exports, "CONTACT_SUPPORT_MODAL_ID", function () { return $855ba498af576448$export$9a0c429716441f36; });
$parcel$export(module.exports, "RECHARGE_MODAL_ID", function () { return $855ba498af576448$export$fa1eea6ec02ba9cf; });
$parcel$export(module.exports, "TRANSACTION_CODE_ID", function () { return $855ba498af576448$export$8795fd7d38a053cc; });
$parcel$export(module.exports, "TRUST_CHOICE_MODAL_ID", function () { return $855ba498af576448$export$ab1d49aae5b60586; });
$parcel$export(module.exports, "ACCOUNT_DELETE_MODAL_ID", function () { return $855ba498af576448$export$2f77cc9741c6eeeb; });
$parcel$export(module.exports, "REFUND_TRANSACTION_REASON_MODAL_ID", function () { return $855ba498af576448$export$88f3474e80e0d31c; });
$parcel$export(module.exports, "DELETE_UPCOMING_TRANSFER_MODAL_ID", function () { return $855ba498af576448$export$93b3996b43620469; });
$parcel$export(module.exports, "EDIT_UPCOMING_TRANSFER_MODAL_ID", function () { return $855ba498af576448$export$526d7aff50147d43; });
$parcel$export(module.exports, "DETAIL_UPCOMING_TRANSFER_MODAL_ID", function () { return $855ba498af576448$export$4a53c76217c0e6b5; });
$parcel$export(module.exports, "DETAIL_MANDATE_MODAL_ID", function () { return $855ba498af576448$export$2d94544e8e89d3a8; });
$parcel$export(module.exports, "OPPOSE_MANDATE_MODAL_ID", function () { return $855ba498af576448$export$3214628a8a310e0; });
$parcel$export(module.exports, "ACTIVATE_MANDATE_MODAL_ID", function () { return $855ba498af576448$export$c29244d365b4007; });
const $855ba498af576448$export$8251873390cbda07 = "transfer";
const $855ba498af576448$export$7426a5a969c943ad = "simple_transfer";
const $855ba498af576448$export$800d490a2e85ba52 = "bill_issuer";
const $855ba498af576448$export$76e99c6c5f675d40 = "add_recipient";
const $855ba498af576448$export$7890c93d3286e2e0 = "edit_recipient";
const $855ba498af576448$export$86f172adad7759d1 = "remove_recipient";
const $855ba498af576448$export$931924a93466d830 = "add_or_edit_spending";
const $855ba498af576448$export$da40dedd7ee48a81 = "remove_attachment";
const $855ba498af576448$export$41ac648b5541798c = "remove_spending";
const $855ba498af576448$export$bd4105273b581e47 = "account_transaction-details";
const $855ba498af576448$export$f3941d3ce374a9a2 = "account_transaction-details";
const $855ba498af576448$export$8dd5501249bc1137 = "account_detail";
const $855ba498af576448$export$2007ebba11237b4a = "cash_transfer";
const $855ba498af576448$export$e55761f23de72926 = "card_opposition";
const $855ba498af576448$export$453ddf8496cc7bd8 = "card_deactivation";
const $855ba498af576448$export$b4775db91bd3a0be = "card_activation";
const $855ba498af576448$export$3c595e48bb83e5ab = "card_creation";
const $855ba498af576448$export$ebc2916a28edbacc = "card_pincode_update";
const $855ba498af576448$export$930196dcf4a94d3 = "card_update_outstanding";
const $855ba498af576448$export$d22905ab137b326 = "card_refabrication";
const $855ba498af576448$export$f6c4ef69ba9e353b = "card_sensitive_details_modal_id";
const $855ba498af576448$export$67bb2a2055713b7d = "pincode_must_be_changed";
const $855ba498af576448$export$9a0c429716441f36 = "contact_support";
const $855ba498af576448$export$fa1eea6ec02ba9cf = "recharge";
const $855ba498af576448$export$8795fd7d38a053cc = "transaction_code";
const $855ba498af576448$export$ab1d49aae5b60586 = "trust_choice_modal";
const $855ba498af576448$export$2f77cc9741c6eeeb = "account_delete";
const $855ba498af576448$export$88f3474e80e0d31c = "refund_transaction_reason";
const $855ba498af576448$export$93b3996b43620469 = "delete_upcoming_transfer";
const $855ba498af576448$export$526d7aff50147d43 = "edit_upcoming_transfer";
const $855ba498af576448$export$4a53c76217c0e6b5 = "detail_upcoming_transfer";
const $855ba498af576448$export$2d94544e8e89d3a8 = "detail_mandate";
const $855ba498af576448$export$3214628a8a310e0 = "oppose_mandate";
const $855ba498af576448$export$c29244d365b4007 = "activate_mandate";

});

parcelRegister("5Wai4", function(module, exports) {

$parcel$export(module.exports, "Modal", function () { return $1dda72fe0af262c2$export$2b77a92f1a5ad772; });
$parcel$export(module.exports, "ModalContainer", function () { return $1dda72fe0af262c2$export$c9554889b3e706cd; });

var $4m918 = parcelRequire("4m918");

var $gALIi = parcelRequire("gALIi");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $39ngP = parcelRequire("39ngP");

var $dPBkx = parcelRequire("dPBkx");
let $1dda72fe0af262c2$var$modalContainer = null;
class $1dda72fe0af262c2$export$2b77a92f1a5ad772 extends (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).PureComponent {
    static present(id, content, options) {
        const container = $1dda72fe0af262c2$var$modalContainer;
        if (container === null) throw new Error("ModalContainer must be mounted to present a modal");
        container.present(id, content, options);
    }
    static dismiss(id) {
        const container = $1dda72fe0af262c2$var$modalContainer;
        if (container === null) throw new Error("ModalContainer must be mounted to dismiss a modal");
        container.dismiss(id);
    }
    static dismissAll() {
        const container = $1dda72fe0af262c2$var$modalContainer;
        if (container === null) throw new Error("ModalContainer must be mounted to dismiss a modal");
        Object.keys(container.state.modals).forEach((id)=>container.dismiss(id));
    }
    render() {
        const { canBeDismissed: canBeDismissed, onShouldDismiss: onShouldDismiss, onHideComplete: onHideComplete, onUserDismiss: onUserDismiss } = this.props;
        return /*#__PURE__*/ (0, $4m918.jsx)($1dda72fe0af262c2$var$ModalContent, {
            backdropOpacity: this.backdropOpacity,
            backdropColor: this.backdropColor,
            onClick: ()=>{
                canBeDismissed && onShouldDismiss();
                onUserDismiss?.();
            },
            isVisible: !!this.props.visible,
            onTransitionEnd: ()=>onHideComplete(),
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.backdropOpacity = this.props.backdropOpacity ?? 0.7, this.backdropColor = this.props.backdropColor ?? "#000000";
    }
}
const $1dda72fe0af262c2$var$ModalContent = ({ backdropOpacity: backdropOpacity, backdropColor: backdropColor, onClick: onClick, isVisible: isVisible, onTransitionEnd: onTransitionEnd, children: children })=>{
    (0, $dPBkx.useLockBodyScroll)();
    return /* After upgrading to styled-components v6, we have added a wrapper div to ensure the backdrop is positioned correctly */ /*#__PURE__*/ (0, $4m918.jsx)($1dda72fe0af262c2$var$ModalBase, {
        id: "backdrop",
        children: /*#__PURE__*/ (0, $4m918.jsx)($1dda72fe0af262c2$var$ModalBackdrop, {
            $isVisible: isVisible,
            opacity: backdropOpacity,
            color: backdropColor,
            onClick: onClick,
            onTransitionEnd: onTransitionEnd,
            children: /*#__PURE__*/ (0, $4m918.jsx)($1dda72fe0af262c2$var$ContentContainer, {
                onTransitionEnd: (e)=>e.stopPropagation(),
                children: isVisible && children
            })
        })
    });
};
const $1dda72fe0af262c2$var$fadeIn = (0, $jb8NR.keyframes)`
	from {
		opacity: 0;
	} to {
		opacity: 1;
	}
`;
// firefox bug: sometimes firing a onTransitionEnd event while opacity is set to 1 when mount.
// We just want the transition append when opacity go from 1 to 0 that's why "${props => (!props.$isVisible ? "transition: opacity 0.5s" : null)};"
const $1dda72fe0af262c2$var$ModalBase = (0, $jb8NR.default).div`
  position: fixed;
  z-index: 2000000000;
`;
const $1dda72fe0af262c2$var$ModalBackdrop = (0, $jb8NR.default).div`
  position: fixed;
  pointer-events: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-y: auto;
  background-color: ${(props)=>(0, $39ngP.colorWithOpacity)(props.color, props.opacity)};
  opacity: ${(props)=>props.$isVisible ? 1 : 0};
  ${(props)=>!props.$isVisible ? "transition: opacity 0.5s" : ""};
  animation: ${$1dda72fe0af262c2$var$fadeIn} 0.2s;
`;
const $1dda72fe0af262c2$var$ContentContainer = (0, $jb8NR.default).div`
  position: relative;
  pointer-events: all;
`;
class $1dda72fe0af262c2$export$c9554889b3e706cd extends (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            modals: {}
        };
    }
    present(id, content, options) {
        this.setState((state)=>({
                modals: {
                    ...state.modals,
                    [id]: {
                        content: content,
                        options: options,
                        visible: true
                    }
                }
            }));
    }
    dismiss(id) {
        const modal = this.state.modals[id];
        if (modal) this.setState({
            modals: {
                ...this.state.modals,
                [id]: {
                    ...modal,
                    visible: false
                }
            }
        });
    }
    unmount(id) {
        this.setState((state)=>({
                modals: (0, (/*@__PURE__*/$parcel$interopDefault($gALIi))).omit(state.modals, id)
            }));
    }
    componentDidMount() {
        $1dda72fe0af262c2$var$modalContainer = this;
    }
    componentWillUnmount() {
        $1dda72fe0af262c2$var$modalContainer = null;
    }
    render() {
        return /*#__PURE__*/ (0, $4m918.jsx)($1dda72fe0af262c2$var$ModalHolder, {
            children: Object.entries(this.state.modals).map(([id, modal])=>/*#__PURE__*/ (0, $4m918.jsx)($1dda72fe0af262c2$export$2b77a92f1a5ad772, {
                    ...modal.options,
                    visible: modal.visible,
                    onShouldDismiss: ()=>this.dismiss(id),
                    onHideComplete: ()=>this.unmount(id),
                    children: modal.content()
                }, id))
        });
    }
}
const $1dda72fe0af262c2$var$ModalHolder = (0, $jb8NR.default).div`
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

});
parcelRegister("39ngP", function(module, exports) {

$parcel$export(module.exports, "colorWithOpacity", function () { return $f926fa733c3673e2$export$701c7602c894fd10; });
function $f926fa733c3673e2$export$701c7602c894fd10(color, opacity) {
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
}
const $f926fa733c3673e2$var$colorRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
function $f926fa733c3673e2$export$5a544e13ad4e1fa5(hex) {
    const result = $f926fa733c3673e2$var$colorRegex.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $f926fa733c3673e2$export$34d09c4a771c46ef({ r: r, g: g, b: b }) {
    return "#" + $f926fa733c3673e2$export$485e52e0e5409cea(r) + $f926fa733c3673e2$export$485e52e0e5409cea(g) + $f926fa733c3673e2$export$485e52e0e5409cea(b);
}
function $f926fa733c3673e2$export$485e52e0e5409cea(c) {
    let hex = c.toString(16);
    if (hex.length < 2) hex = "0" + hex;
    return hex;
}
const $f926fa733c3673e2$export$c0816ed86df316af = (color, factor = 0.1)=>{
    const rgb = $f926fa733c3673e2$export$5a544e13ad4e1fa5(color);
    if (!rgb) throw new Error("Can't convert color");
    const newColor = {
        r: Math.round(Math.min(255, rgb.r + 255 * factor)),
        g: Math.round(Math.min(255, rgb.g + 255 * factor)),
        b: Math.round(Math.min(255, rgb.b + 255 * factor))
    };
    return $f926fa733c3673e2$export$34d09c4a771c46ef(newColor);
};
const $f926fa733c3673e2$export$4b073707ff63303 = (color, factor = 0.1)=>{
    const rgb = $f926fa733c3673e2$export$5a544e13ad4e1fa5(color);
    if (!rgb) throw new Error("Can't convert color");
    const newColor = {
        r: Math.round(Math.max(0, rgb.r - 255 * factor)),
        g: Math.round(Math.max(0, rgb.g - 255 * factor)),
        b: Math.round(Math.max(0, rgb.b - 255 * factor))
    };
    return $f926fa733c3673e2$export$34d09c4a771c46ef(newColor);
};

});

parcelRegister("dPBkx", function(module, exports) {

$parcel$export(module.exports, "useLockBodyScroll", function () { return $2bf75d00ea5680d4$export$bd4ec12442706c3d; });

var $6uYXW = parcelRequire("6uYXW");
function $2bf75d00ea5680d4$export$bd4ec12442706c3d() {
    (0, $6uYXW.useLayoutEffect)(()=>{
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = originalStyle;
        };
    }, []);
}

});


parcelRegister("gf1iA", function(module, exports) {

$parcel$export(module.exports, "PageAlertsSlotContext", function () { return $fa42564581f28526$export$e164a1a06bb1a337; });
$parcel$export(module.exports, "PageAlertsSlot", function () { return $fa42564581f28526$export$9a806ef354200db5; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");
const $fa42564581f28526$export$e164a1a06bb1a337 = /*#__PURE__*/ (0, $6uYXW.createContext)(null);
function $fa42564581f28526$export$9a806ef354200db5(props) {
    const register = (0, $6uYXW.useContext)($fa42564581f28526$export$e164a1a06bb1a337);
    const ref = (0, $6uYXW.useCallback)((node)=>register?.(node), [
        register
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)("div", {
        ref: ref,
        ...props
    });
}

});

parcelRegister("levoc", function(module, exports) {

$parcel$export(module.exports, "AccountBalanceCard", function () { return $ef027d079daa95b6$export$a222358e5e293948; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $4fYE4 = parcelRequire("4fYE4");

var $bZlaH = parcelRequire("bZlaH");

var $bewhU = parcelRequire("bewhU");

var $26OFD = parcelRequire("26OFD");

var $22v9q = parcelRequire("22v9q");
function $ef027d079daa95b6$export$a222358e5e293948(props) {
    const { account: account, onUpdate: onUpdate, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { push: push } = (0, $NQIVp.useHistory)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($ef027d079daa95b6$var$Card, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($ef027d079daa95b6$var$TopRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($ef027d079daa95b6$var$BalanceLabel, {
                        children: formatMessage("homeScreen.accountBalance")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($ef027d079daa95b6$var$AccountNumber, {
                        children: formatMessage("account.accountId", {
                            id: account.id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($ef027d079daa95b6$var$BottomRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($ef027d079daa95b6$var$Balance, {
                        amount: (0, $kGswT.getAvailableBalance)(account)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($ef027d079daa95b6$var$DetailsButton, {
                        "aria-label": formatMessage("myAccountScreen.title"),
                        onClick: ()=>push((0, $4fYE4.Path).MyAccount),
                        children: /*#__PURE__*/ (0, $4m918.jsx)($ef027d079daa95b6$var$WhiteDotsIcon, {})
                    })
                ]
            })
        ]
    });
}
const $ef027d079daa95b6$var$Card = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: stretch;
  min-height: 118px;
  padding: 20px 24px;
  border-radius: 16px;
  background: ${(0, $22v9q.theme).brandGradient};
  color: #ffffff;
`;
const $ef027d079daa95b6$var$TopRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;
const $ef027d079daa95b6$var$BottomRow = (0, $jb8NR.default)($ef027d079daa95b6$var$TopRow)`
  align-items: flex-end;
`;
const $ef027d079daa95b6$var$BalanceLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 14px;
  line-height: 18px;
  opacity: 0.85;
`;
const $ef027d079daa95b6$var$AccountNumber = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 12px;
  line-height: 16px;
  opacity: 0.7;
`;
const $ef027d079daa95b6$var$Balance = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.75rem;
  line-height: 34px;
`;
const $ef027d079daa95b6$var$DetailsButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
`;
const $ef027d079daa95b6$var$WhiteDotsIcon = (0, $jb8NR.default)((0, $26OFD.DotsIcon))`
  fill: #ffffff;
  width: 20px;
  height: 20px;
`;

});
parcelRegister("26OFD", function(module, exports) {

$parcel$export(module.exports, "DotsIcon", function () { return $e9736cf0bbff5edb$export$b705c91150cd1563; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $e9736cf0bbff5edb$export$b705c91150cd1563(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "#000",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M13 18c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-7c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-7c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z",
            transform: "translate(-1320 -473) translate(453 264) translate(0 184) translate(863 21) rotate(90 13 17)"
        })
    });
}

});


parcelRegister("eSR05", function(module, exports) {

$parcel$export(module.exports, "AccountTransactionDetailsModal", function () { return $5c8e804f365e374b$export$879306bdf9f3d288; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $75iyY = parcelRequire("75iyY");

var $hmO0M = parcelRequire("hmO0M");

var $fZL4e = parcelRequire("fZL4e");

var $5ea1c = parcelRequire("5ea1c");

var $3Ersk = parcelRequire("3Ersk");

var $iMWY7 = parcelRequire("iMWY7");

var $bQhUC = parcelRequire("bQhUC");

var $4fYE4 = parcelRequire("4fYE4");

var $7N0kU = parcelRequire("7N0kU");

var $yYT9n = parcelRequire("yYT9n");

var $bZlaH = parcelRequire("bZlaH");

var $7Zu6k = parcelRequire("7Zu6k");

var $i6Znu = parcelRequire("i6Znu");

var $5Wai4 = parcelRequire("5Wai4");

var $7xALQ = parcelRequire("7xALQ");

var $60xvI = parcelRequire("60xvI");

var $22v9q = parcelRequire("22v9q");

var $dsMqc = parcelRequire("dsMqc");

var $2XXLB = parcelRequire("2XXLB");
const $5c8e804f365e374b$var$accountEntryLabels = {
    [(0, $75iyY.AccountingEntryType).Transfer]: "accountingTransactionDetailsModal.transferLabel",
    [(0, $75iyY.AccountingEntryType).Fee]: "accountingTransactionDetailsModal.feeLabel",
    [(0, $75iyY.AccountingEntryType).Commission]: "accountingTransactionDetailsModal.commissionLabel",
    [(0, $75iyY.AccountingEntryType).Tax]: "accountingTransactionDetailsModal.taxLabel",
    [(0, $75iyY.AccountingEntryType).Discount]: "accountingTransactionDetailsModal.discountLabel",
    [(0, $75iyY.AccountingEntryType).Interest]: "accountingTransactionDetailsModal.interestLabel"
};
const $5c8e804f365e374b$export$879306bdf9f3d288 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $7xALQ.WhiteModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.ACCOUNT_TRANSACTION_DETAILS_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$AccountTransactionDetails, {
            transaction: props.transaction,
            account: props.account
        })
    });
const $5c8e804f365e374b$var$AccountTransactionDetails = ({ transaction: transaction, account: account })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const { canJustify: canJustify, canEditJustification: canEditJustification, canViewJustification: canViewJustification, isOutgoing: isOutgoing } = (0, $fZL4e.useTransactionLinks)();
    const { push: push } = (0, $NQIVp.useHistory)();
    const { client: client } = (0, $7N0kU.useClient)();
    const { amountJustified: amountJustified, spendings: spendings } = (0, $hmO0M.useSpendings)(transaction);
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const detailedAccountingTransfer = transaction?.detailedAccounting?.find((accounting)=>accounting.type === (0, $75iyY.AccountingEntryType).Transfer);
    const transactionDescription = transaction.shortDescription || detailedAccountingTransfer?.description || transaction.type.label;
    const additionalInformation = (0, $6uYXW.useMemo)(()=>{
        let externalDataValue;
        let externalId;
        if (transaction) {
            externalId = transaction.externalId;
            if (transaction.externalData) {
                const externalData = transaction.externalData;
                externalDataValue = Object.keys(externalData).map((key)=>`${key} : ${externalData[key]}`).join("\n");
            }
            if (transaction.additional) externalDataValue = externalDataValue ? externalDataValue + "\n" + transaction.additional : transaction.additional;
        }
        return {
            externalId: externalId,
            externalData: externalDataValue
        };
    }, [
        transaction
    ]);
    const remittanceInformation = transaction.externalData?.remittanceInformation;
    if (!transaction.amount) return null;
    const handleJustifyTransaction = ()=>{
        push((0, $4fYE4.Path).JustifyTransaction, {
            transaction: transaction,
            account: account
        });
        (0, $5Wai4.Modal).dismiss((0, $bQhUC.ACCOUNT_TRANSACTION_DETAILS_MODAL_ID));
    };
    /**
   * This is a temporary solution to hide the refund button.
   * The feature must be hidden until the api handles this type of request (by implementing a step of bank validation)
   * Original ticket: https://tagpay.atlassian.net/browse/VC-563
   * Dev Note: TODO remove this const variable when the feature is enabled.
   */ const displayRefundButton = false;
    return /*#__PURE__*/ (0, $4m918.jsxs)($5c8e804f365e374b$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($5c8e804f365e374b$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Title, {
                        children: transactionDescription
                    }),
                    isOutgoing(transaction) && /*#__PURE__*/ (0, $4m918.jsxs)($5c8e804f365e374b$var$Tags, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $2XXLB.TransactionStateTag), {
                                label: formatMessage(transaction.justified ? "accountTransactions.tagJustified" : "accountTransactions.tagNotJustified"),
                                done: !!transaction.justified
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $2XXLB.TransactionStateTag), {
                                label: formatMessage(transaction.qualified ? "accountTransactions.tagQualified" : "accountTransactions.tagNotQualified"),
                                done: !!transaction.qualified
                            })
                        ]
                    })
                ]
            }),
            !!transaction.id && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Reference, {
                children: formatMessage("accountingTransactionDetailsModal.transaction", {
                    id: transaction.id
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Reference, {
                children: formatDate(transaction.date, {
                    month: "long",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                })
            }),
            !!transaction.description && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Description, {
                children: transaction.description
            }),
            !!transaction.label && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Description, {
                children: formatMessage("accountingTransactionDetailsModal.description", {
                    description: transaction.label
                })
            }),
            remittanceInformation && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Description, {
                children: formatMessage("accountingTransactionDetailsModal.reference", {
                    id: remittanceInformation
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$DetailsTitle, {
                children: formatMessage("accountingTransactionDetailsModal.detailsTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($5c8e804f365e374b$var$Items, {
                children: [
                    transaction.detailedAccounting.map((value, index)=>/*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$export$ffcefe2b8efe070f, {
                            label: index === 0 ? formatMessage($5c8e804f365e374b$var$accountEntryLabels[transaction.detailedAccounting[0]?.type]) : formatMessage($5c8e804f365e374b$var$accountEntryLabels[value.type]),
                            amount: {
                                value: value.amount.value,
                                currency: transaction.amount.currency
                            },
                            bold: transaction.detailedAccounting.length === 1,
                            showExchangeRate: transaction.detailedAccounting.length === 1,
                            hasLink: true
                        }, value.id)),
                    (!transaction.detailedAccounting || transaction.detailedAccounting.length > 1) && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$export$ffcefe2b8efe070f, {
                        label: formatMessage("accountingTransactionDetailsModal.amountLabel"),
                        amount: {
                            value: (0, $iMWY7.getTotalOfDetailedAccounting)(transaction.detailedAccounting),
                            currency: transaction.amount.currency
                        },
                        hasLink: true,
                        bold: true,
                        showExchangeRate: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$export$ffcefe2b8efe070f, {
                        label: formatMessage("accountingTransactionDetailsModal.balanceLabel"),
                        amount: transaction.balance,
                        isBalance: true
                    })
                ]
            }),
            spendings.length > 0 ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$DetailsTitle, {
                        children: formatMessage("accountingTransactionDetailsModal.justificationFollowUpTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($5c8e804f365e374b$var$Items, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$export$ffcefe2b8efe070f, {
                                label: formatMessage("accountingTransactionDetailsModal.documentsSubmitted"),
                                amount: amountJustified(),
                                hasLink: canEditJustification(transaction),
                                bold: true
                            }),
                            canEditJustification(transaction) ? /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
                                children: /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$export$ffcefe2b8efe070f, {
                                    label: formatMessage("accountingTransactionDetailsModal.validationInProgress"),
                                    amount: null,
                                    grey: true
                                })
                            }) : null
                        ]
                    })
                ]
            }) : null,
            (0, $dhPTb.Config).APP_ACCOUNTING_TRANSACTION_DETAILS_DISPLAY_ADDITIONAL_INFO && (additionalInformation.externalId || additionalInformation.externalData) ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$DetailsTitle, {
                        children: formatMessage("accountingTransactionDetailsModal.additionalInformationTitle")
                    }),
                    additionalInformation.externalData ? /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Description, {
                        children: additionalInformation.externalData
                    }) : null,
                    additionalInformation.externalId ? /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$ExternalId, {
                        children: formatMessage("accountingTransactionDetailsModal.externalIdLabel", {
                            externalId: additionalInformation.externalId
                        })
                    }) : null
                ]
            }) : null,
            transaction.geolocation && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Location, {
                        children: formatMessage("accountingTransactionDetailsModal.geolocationTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $i6Znu.MapIframe), {
                        location: transaction.geolocation,
                        allowFullScreen: true
                    })
                ]
            }),
            displayRefundButton && transaction.businessProcessId && transaction.type?.value === "ACCOUNT_TO_EXTERNAL" && features.customerInstructionSubmit && features.customerInstructionView && features.paymentInstructionView && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$CanRefundButton, {
                onClick: ()=>{
                    (0, $5Wai4.Modal).present((0, $bQhUC.REFUND_TRANSACTION_REASON_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $dsMqc.RefundTransactionReasonModal), {
                            transaction: transaction,
                            client: client
                        }), {
                        canBeDismissed: false
                    });
                },
                size: "S",
                children: formatMessage("accountingTransactionDetailsModal.refundButtonLabel")
            }),
            (canViewJustification(transaction) || canJustify(transaction)) && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$CanJustifyButton, {
                onClick: handleJustifyTransaction,
                size: "XS",
                children: formatMessage(canJustify(transaction) ? "accountingTransactionDetailsModal.justifyButtonLabel" : "accountingTransactionDetailsModal.verifyJustificationsButtonLabel")
            })
        ]
    });
};
const $5c8e804f365e374b$export$ffcefe2b8efe070f = (props)=>{
    const { label: label, amount: amount, isBalance: isBalance, grey: grey, hasLink: hasLink, bold: bold, showExchangeRate: showExchangeRate, ...viewProps } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const { canShowExchangeRate: canShowExchangeRate, convertedAmount: convertedAmount } = (0, $5ea1c.default)(amount, (0, $dhPTb.Config).CURRENCY_TO_CONVERT_IN_EUR_ENABLED ? "EUR" : null);
    return /*#__PURE__*/ (0, $4m918.jsxs)($5c8e804f365e374b$var$Item, {
        ...viewProps,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$BulletSlot, {
                        $isRTL: isRTL,
                        children: isBalance || grey ? /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Bullet, {
                            grey: grey
                        }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $60xvI.TransactionValidateIcon), {
                            width: 16,
                            height: 16,
                            fill: (0, $22v9q.theme).colors.success[500]
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$ItemLabel, {
                                grey: grey,
                                bold: bold,
                                children: label
                            }),
                            canShowExchangeRate && showExchangeRate && convertedAmount && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$ItemLabel, {
                                style: {
                                    ...(0, $22v9q.theme).bodyGreyRegular
                                },
                                children: formatMessage("amountSelection.convertedAmountLabel")
                            })
                        ]
                    })
                ]
            }),
            amount !== null ? /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$ItemValue, {
                bold: bold,
                children: /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                    style: {
                        textAlign: "right"
                    },
                    children: [
                        amount && /*#__PURE__*/ (0, $4m918.jsx)((0, $bZlaH.AmountText), {
                            amount: amount
                        }),
                        canShowExchangeRate && showExchangeRate && convertedAmount && /*#__PURE__*/ (0, $4m918.jsx)((0, $bZlaH.AmountText), {
                            style: {
                                ...(0, $22v9q.theme).bodyGreyRegular
                            },
                            amount: convertedAmount
                        })
                    ]
                })
            }) : null,
            hasLink && /*#__PURE__*/ (0, $4m918.jsx)($5c8e804f365e374b$var$Link, {
                $isRTL: isRTL
            })
        ]
    });
};
/* The cross now sits in the top right corner, where the tags are: they start below it. */ const $5c8e804f365e374b$var$Container = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
`;
const $5c8e804f365e374b$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;
const $5c8e804f365e374b$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText};
  margin: 0;
  flex: 1 1 auto;

  /* A label carrying no space still has to give way, or it pushes the tags out. */
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $5c8e804f365e374b$var$Tags = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: 8px;
`;
const $5c8e804f365e374b$var$DetailsTitle = (0, $jb8NR.default).h3`
  ${(0, $22v9q.theme).mediumText};
  margin: 28px 0 12px;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $5c8e804f365e374b$var$Reference = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 4px;
  font-size: 13px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[500]};
`;
const $5c8e804f365e374b$var$Description = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 8px;

  /* The additional data comes joined by newlines; they have to survive. */
  white-space: pre-line;
  font-size: 13px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $5c8e804f365e374b$var$ExternalId = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
`;
const $5c8e804f365e374b$var$Item = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
const $5c8e804f365e374b$var$ItemLabel = (0, $jb8NR.default).span`
  ${(props)=>props.bold ? (0, $22v9q.theme).boldText : (0, $22v9q.theme).text};
  display: block;
  font-size: 15px;
  color: ${(props)=>props.grey ? "#b1b1b1" : (0, $22v9q.theme).colors.blue[800]};
  flex-shrink: 1;
  flex-grow: 1;
`;
const $5c8e804f365e374b$var$ItemValue = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  margin-left: 20px;
  font-size: 15px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $5c8e804f365e374b$var$BulletSlot = (0, $jb8NR.default).span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: ${(props)=>props.$isRTL ? 0 : 12}px;
  margin-left: ${(props)=>props.$isRTL ? 12 : 0}px;
`;
/* The balance the line ends on: a dark centre inside a ring, as the mockup draws it. */ const $5c8e804f365e374b$var$Bullet = (0, $jb8NR.default).span`
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  background-color: ${(props)=>props.grey ? "#b1b1b1" : (0, $22v9q.theme).colors.blue[800]};
  box-shadow: 0 0 0 1.5px ${(props)=>props.grey ? "#b1b1b1" : (0, $22v9q.theme).colors.blue[800]};
`;
const $5c8e804f365e374b$var$Items = (0, $jb8NR.default).div`
  margin-bottom: 4px;

  > *:not(:last-child) {
    margin-bottom: 20px;
  }
`;
const $5c8e804f365e374b$var$Link = (0, $jb8NR.default).div`
  position: absolute;
  top: 100%;
  left: ${(props)=>props.$isRTL ? "unset" : "7px"};
  right: ${(props)=>props.$isRTL ? "7px" : "unset"};
  width: 2px;
  height: 20px;
  border-radius: 1.5px;
  background-color: ${(0, $22v9q.theme).colors.success[500]};
`;
const $5c8e804f365e374b$var$Location = (0, $jb8NR.default)($5c8e804f365e374b$var$DetailsTitle)`
  margin-top: 30px;
`;
const $5c8e804f365e374b$var$CanJustifyButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  align-self: center;
  margin-top: 28px;
  padding: 13px 28px;
  box-shadow: none;
`;
const $5c8e804f365e374b$var$CanRefundButton = (0, $jb8NR.default)((0, $7Zu6k.GrayPrimaryButton))`
  margin-top: 35px;
`;

});
parcelRegister("75iyY", function(module, exports) {

$parcel$export(module.exports, "AccountingEntryType", function () { return $680f6184cc54d415$export$25e039b8d906c8a7; });
var $680f6184cc54d415$export$25e039b8d906c8a7 = /*#__PURE__*/ function(AccountingEntryType) {
    AccountingEntryType["Transfer"] = "TRANSFER";
    AccountingEntryType["Fee"] = "FEE";
    AccountingEntryType["Commission"] = "COMMISSION";
    AccountingEntryType["Tax"] = "TAX";
    AccountingEntryType["Discount"] = "DISCOUNT";
    AccountingEntryType["Interest"] = "INTEREST";
    return AccountingEntryType;
}({});

});

parcelRegister("hmO0M", function(module, exports) {

$parcel$export(module.exports, "useSpendings", function () { return $726a7eed54a04476$export$b96dc8645e83ea23; });

var $6uYXW = parcelRequire("6uYXW");

var $5P656 = parcelRequire("5P656");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $eHurR = parcelRequire("eHurR");

var $fZL4e = parcelRequire("fZL4e");

var $lOi9O = parcelRequire("lOi9O");

var $4RaAR = parcelRequire("4RaAR");
const $726a7eed54a04476$export$b96dc8645e83ea23 = (transaction)=>{
    const spendings = (0, $3Ersk.useObservable)((0, $kqXxS.spendingsManager).spendings);
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [error, setError] = (0, $6uYXW.useState)("");
    const { canGetSpendings: canGetSpendings } = (0, $fZL4e.useTransactionLinks)();
    const refresh = async (forceRefresh = false)=>{
        await (0, $kqXxS.spendingsManager).clear();
        if (transaction && (canGetSpendings(transaction) || forceRefresh)) try {
            setError("");
            setLoading(true);
            const url = (0, $eHurR.getUrlFromLink)(transaction.links, (0, $4RaAR.TransactionLinks).GetSpendings);
            await (0, $kqXxS.spendingsManager).refresh(transaction.id, url);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            setError(e.response.data.error.message);
            (0, $6JVVB.logger).debug("error fetching spendings", e);
        }
        else (0, $kqXxS.spendingsManager).clear();
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await refresh();
    }, [
        transaction
    ]);
    const amountJustified = ()=>{
        const filteredAmounts = (0, $lOi9O.getAmounts)(spendings);
        if (filteredAmounts.length > 0) return (0, $5P656.addAmounts)(...filteredAmounts);
        return undefined;
    };
    const spendingsCount = ()=>spendings.length;
    const remainingAmount = (transactionAmount)=>{
        if (!(0, $gDlNU.isDefined)(transactionAmount)) return undefined;
        const amountAlreadyJustified = amountJustified();
        if (!(0, $gDlNU.isDefined)(amountAlreadyJustified)) return transactionAmount;
        if (amountAlreadyJustified.currency == transactionAmount.currency) return (0, $5P656.diffAmount)(transactionAmount, amountAlreadyJustified);
        return new (0, $5P656.Amount)(0, transactionAmount.currency);
    };
    return {
        spendings: spendings,
        spendingsCount: spendingsCount,
        amountJustified: amountJustified,
        remainingAmount: remainingAmount,
        refresh: refresh,
        loading: loading,
        error: error
    };
};

});
parcelRegister("lOi9O", function(module, exports) {

$parcel$export(module.exports, "getAmounts", function () { return $3a99cb95785a65a9$export$89a7c5b151eadd86; });

var $gDlNU = parcelRequire("gDlNU");
function $3a99cb95785a65a9$export$89a7c5b151eadd86(spendings) {
    const filteredAmounts = [];
    for (const spending of spendings)if ((0, $gDlNU.isDefined)(spending.amount)) filteredAmounts.push(spending.amount);
    return filteredAmounts;
}

});


parcelRegister("5ea1c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26eeff3e23828325$export$2e2bcd8739ae039; });

var $gALIi = parcelRequire("gALIi");

var $6uYXW = parcelRequire("6uYXW");

var $5P656 = parcelRequire("5P656");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
function $26eeff3e23828325$export$2e2bcd8739ae039(amount, foreignCurrency) {
    const exchangeRates = (0, $3Ersk.useObservable)((0, $kqXxS.currencyManager).exchangeRates);
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const canShowExchangeRate = features.sdaExchangeRateView;
    const matchingExchangeRate = (0, $6uYXW.useMemo)(()=>{
        if (exchangeRates && amount && foreignCurrency) return (0, $gALIi.find)(exchangeRates, (rate)=>rate.baseCurrency === amount.currency && rate.foreignCurrency === foreignCurrency);
        return null;
    }, [
        exchangeRates,
        amount,
        foreignCurrency
    ]);
    const reversedMatchingExchangeRate = (0, $6uYXW.useMemo)(()=>{
        if (exchangeRates && amount && foreignCurrency && !matchingExchangeRate) return (0, $gALIi.find)(exchangeRates, (rate)=>rate.baseCurrency === foreignCurrency && rate.foreignCurrency === amount.currency);
        return null;
    }, [
        exchangeRates,
        matchingExchangeRate,
        amount,
        foreignCurrency
    ]);
    const convertedAmount = (0, $6uYXW.useMemo)(()=>{
        if (amount && foreignCurrency) {
            const baseAmount = (0, $5P656.amountValueForCurrency)(amount.value, amount.currency);
            if (matchingExchangeRate) return new (0, $5P656.Amount)(baseAmount * matchingExchangeRate.exchangeRates.sellRate, foreignCurrency);
            else if (reversedMatchingExchangeRate) return new (0, $5P656.Amount)(baseAmount / reversedMatchingExchangeRate.exchangeRates.sellRate, foreignCurrency);
        }
        return null;
    }, [
        amount,
        foreignCurrency,
        reversedMatchingExchangeRate,
        matchingExchangeRate
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (canShowExchangeRate && !exchangeRates && foreignCurrency) await (0, $kqXxS.currencyManager).getExchangeRates();
    }, [
        canShowExchangeRate,
        exchangeRates,
        foreignCurrency
    ]);
    return {
        canShowExchangeRate: canShowExchangeRate,
        convertedAmount: convertedAmount,
        getExchangeRate: (0, $kqXxS.currencyManager).getExchangeRates
    };
}

});

parcelRegister("7N0kU", function(module, exports) {

$parcel$export(module.exports, "useClient", function () { return $3c0ad87b26ba31cc$export$95f99d327bc8fbbd; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $3c0ad87b26ba31cc$export$95f99d327bc8fbbd = ()=>{
    const client = (0, $3Ersk.useObservable)((0, $kqXxS.clientManager).client);
    const [loading, setLoading] = (0, $6uYXW.useState)(true);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        try {
            setLoading(true);
            await (0, $kqXxS.clientManager).updateClient();
        } catch (e) {
            (0, $6JVVB.logger).debug("client fetch error", e);
        } finally{
            setLoading(false);
        }
    }, [
        (0, $kqXxS.clientManager)
    ]);
    return {
        client: client,
        loading: loading
    };
};

});

parcelRegister("i6Znu", function(module, exports) {

$parcel$export(module.exports, "MapIframe", function () { return $395a47149f387c22$export$e57ab6ff77adc7e7; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");
const $395a47149f387c22$export$e57ab6ff77adc7e7 = ({ location: location, ...otherProps })=>{
    const userLanguage = (0, $3Ersk.useObservable)((0, $kqXxS.i18NManager).localeTag);
    if (!(0, $dhPTb.Config).GOOGLE_MAP_API_KEY) {
        (0, $6JVVB.logger).debug("GOOGLE_MAP_API_KEY is not defined in the config file");
        return null;
    }
    return /*#__PURE__*/ (0, $4m918.jsx)($395a47149f387c22$var$Map, {
        ...otherProps,
        src: `https://www.google.com/maps/embed/v1/place?key=${(0, $dhPTb.Config).GOOGLE_MAP_API_KEY}
    &q=${location.latitude},${location.longitude}&language=${userLanguage}`
    });
};
const $395a47149f387c22$var$Map = (0, $jb8NR.default).iframe`
  width: 100%;
  height: 250px;
  border: 0;
  border-radius: 10px;
`;

});

parcelRegister("7xALQ", function(module, exports) {

$parcel$export(module.exports, "WhiteModalContainer", function () { return $e5bca33f4481f7f4$export$6e7e610a77a5114f; });

var $jb8NR = parcelRequire("jb8NR");

var $iy3Ex = parcelRequire("iy3Ex");
const $e5bca33f4481f7f4$export$6e7e610a77a5114f = (0, $jb8NR.default)((0, $iy3Ex.RoundedModalContainer))`
  padding: 24px;
  border-radius: 16px;
  background-color: #ffffff;
`;

});
parcelRegister("iy3Ex", function(module, exports) {

$parcel$export(module.exports, "RoundedModalContainer", function () { return $e8217be9bf4e9bb1$export$6e999eb0c52c3494; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $bewhU = parcelRequire("bewhU");

var $j26Ew = parcelRequire("j26Ew");

var $5Wai4 = parcelRequire("5Wai4");
const $e8217be9bf4e9bb1$export$6e999eb0c52c3494 = (props)=>{
    const { closeButton: closeButton, closeModal: closeModal = ()=>(0, $5Wai4.Modal).dismiss(id), id: id, children: children, className: className, contentClassName: contentClassName } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($e8217be9bf4e9bb1$var$Container, {
                className: className,
                children: [
                    closeButton && /*#__PURE__*/ (0, $4m918.jsx)($e8217be9bf4e9bb1$var$CloseContainer, {
                        $isRTL: isRTL,
                        children: /*#__PURE__*/ (0, $4m918.jsx)($e8217be9bf4e9bb1$var$CloseButton, {
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $j26Ew.CloseIcon), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($e8217be9bf4e9bb1$var$ContentContainer, {
                        className: contentClassName,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($e8217be9bf4e9bb1$var$Offset, {})
        ]
    });
};
const $e8217be9bf4e9bb1$var$Offset = (0, $jb8NR.default).div`
  width: 100%;
  height: 5vh;
`;
const $e8217be9bf4e9bb1$var$Container = (0, $jb8NR.default).div`
  position: relative;
  background-color: ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 20px;
  padding: 20px;
  margin-top: 15vh;
`;
const $e8217be9bf4e9bb1$var$ContentContainer = (0, $jb8NR.default).div`
  max-width: calc(100vw - 60px);
  width: ${(0, $7XqbX.UIConstants).MODAL_WIDTH}px;
  overflow: visible;
`;
/* Pulled in by the button's own padding, so the cross still reads 20px off the corner. */ const $e8217be9bf4e9bb1$var$CloseContainer = (0, $jb8NR.default).div`
  position: absolute;
  top: 12px;
  right: ${(props)=>props.$isRTL ? "unset" : "12px"};
  left: ${(props)=>props.$isRTL ? "12px" : "unset"};
  z-index: 2000;
`;
const $e8217be9bf4e9bb1$var$CloseButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  padding: 8px;
`;

});
parcelRegister("j26Ew", function(module, exports) {

$parcel$export(module.exports, "CloseIcon", function () { return $479c06363828e003$export$cae179f078f4b4a4; });

var $jb8NR = parcelRequire("jb8NR");

var $fRvTz = parcelRequire("fRvTz");
const $479c06363828e003$export$cae179f078f4b4a4 = (0, $jb8NR.default).img.attrs({
    src: (0, $fRvTz.StaticAssets).close,
    alt: ""
})`
  width: 24px;
  height: 24px;
  display: block;
`;

});



parcelRegister("60xvI", function(module, exports) {

$parcel$export(module.exports, "TransactionValidateIcon", function () { return $5d53c1bb292604ce$export$7636782c897a20a9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $5d53c1bb292604ce$export$7636782c897a20a9(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M9.6518 5.2232C9.71298 5.28417 9.76152 5.35662 9.79464 5.43638C9.82777 5.51615 9.84482 5.60168 9.84482 5.68805C9.84482 5.77442 9.82777 5.85994 9.79464 5.93971C9.76152 6.01948 9.71298 6.09192 9.6518 6.15289L6.5893 9.21539C6.52833 9.27657 6.45589 9.32511 6.37612 9.35824C6.29635 9.39136 6.21083 9.40841 6.12445 9.40841C6.03808 9.40841 5.95256 9.39136 5.87279 9.35824C5.79302 9.32511 5.72058 9.27657 5.65961 9.21539L4.34711 7.90289C4.28607 7.84185 4.23764 7.76938 4.20461 7.68962C4.17157 7.60986 4.15457 7.52438 4.15457 7.43805C4.15457 7.35172 4.17157 7.26623 4.20461 7.18647C4.23764 7.10672 4.28607 7.03425 4.34711 6.9732C4.40816 6.91216 4.48063 6.86374 4.56038 6.8307C4.64014 6.79766 4.72563 6.78066 4.81196 6.78066C4.89828 6.78066 4.98377 6.79766 5.06353 6.8307C5.14328 6.86374 5.21575 6.91216 5.2768 6.9732L6.125 7.82031L8.7232 5.22156C8.78426 5.16065 8.85672 5.11238 8.93645 5.07949C9.01617 5.04661 9.1016 5.02976 9.18784 5.02991C9.27408 5.03007 9.35945 5.04721 9.43906 5.08038C9.51867 5.11355 9.59096 5.16208 9.6518 5.2232ZM12.9063 7C12.9063 8.16815 12.5599 9.31006 11.9109 10.2813C11.2619 11.2526 10.3395 12.0096 9.26023 12.4567C8.181 12.9037 6.99345 13.0207 5.84775 12.7928C4.70205 12.5649 3.64966 12.0024 2.82365 11.1763C1.99765 10.3503 1.43513 9.29795 1.20724 8.15225C0.979346 7.00655 1.09631 5.819 1.54334 4.73978C1.99037 3.66055 2.74739 2.73812 3.71867 2.08913C4.68994 1.44015 5.83186 1.09375 7 1.09375C8.5659 1.09549 10.0672 1.71831 11.1744 2.82557C12.2817 3.93283 12.9045 5.4341 12.9063 7ZM11.5938 7C11.5938 6.09144 11.3243 5.20329 10.8196 4.44785C10.3148 3.69241 9.59735 3.10362 8.75795 2.75593C7.91856 2.40824 6.99491 2.31727 6.10381 2.49452C5.21271 2.67177 4.39418 3.10928 3.75173 3.75173C3.10928 4.39418 2.67177 5.2127 2.49452 6.1038C2.31727 6.9949 2.40824 7.91855 2.75593 8.75795C3.10362 9.59735 3.69241 10.3148 4.44785 10.8196C5.20329 11.3243 6.09144 11.5937 7 11.5937C8.21794 11.5924 9.38562 11.108 10.2468 10.2468C11.108 9.38562 11.5924 8.21794 11.5938 7Z",
            fill: props.fill ?? "#0B293E"
        })
    });
}

});

parcelRegister("dsMqc", function(module, exports) {

$parcel$export(module.exports, "RefundTransactionReasonModal", function () { return $4baf56fe187b27f6$export$72fc2cde1239f238; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $jdZtx = parcelRequire("jdZtx");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $kw746 = parcelRequire("kw746");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $4baf56fe187b27f6$export$72fc2cde1239f238 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.REFUND_TRANSACTION_REASON_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsx)($4baf56fe187b27f6$var$RefundTransactionCard, {
            ...props
        })
    });
const $4baf56fe187b27f6$var$RefundTransactionCard = (props)=>{
    const { transaction: transaction, loading: loading, client: client, className: className } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [error, setError] = (0, $6uYXW.useState)(null);
    const [success, setSuccess] = (0, $6uYXW.useState)(null);
    const [selectedRefundReason, setSelectedRefundReason] = (0, $6uYXW.useState)((0, $jdZtx.RefundTransactionReason).AC03);
    (0, $6uYXW.useEffect)(()=>{
        setSelectedRefundReason((0, $jdZtx.RefundTransactionReason).AC03);
    }, [
        transaction
    ]);
    const opposeReasons = (0, $6uYXW.useMemo)(()=>new Map([
            [
                (0, $jdZtx.RefundTransactionReason).AC03,
                formatMessage("refundTransactionModal.reasons.AC03")
            ],
            [
                (0, $jdZtx.RefundTransactionReason).AM09,
                formatMessage("refundTransactionModal.reasons.AM09")
            ],
            [
                (0, $jdZtx.RefundTransactionReason).CUST,
                formatMessage("refundTransactionModal.reasons.CUST")
            ]
        ]), [
        formatMessage
    ]);
    const handleRefundConfirm = async ()=>{
        //Get the associated P-Transaction using the businessProcessId of the transaction
        if (transaction.businessProcessId) try {
            const response = await (0, $kqXxS.transferManager).submitCreditTransferSinglePayment(transaction.businessProcessId, client, selectedRefundReason);
            if (response) setSuccess(formatMessage("refundTransactionModal.success"));
        } catch (err) {
            setError(err);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($4baf56fe187b27f6$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($4baf56fe187b27f6$var$MessageLabel, {
                children: formatMessage("refundTransactionModal.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($4baf56fe187b27f6$var$ReasonsContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($4baf56fe187b27f6$var$StyledRadioSelector, {
                    innerId: "opposition_button",
                    values: opposeReasons,
                    value: selectedRefundReason,
                    onChange: setSelectedRefundReason
                })
            }),
            error && /*#__PURE__*/ (0, $4m918.jsx)($4baf56fe187b27f6$var$StyledErrorMessage, {
                children: error
            }),
            success && /*#__PURE__*/ (0, $4m918.jsx)($4baf56fe187b27f6$var$StyledSuccessMessage, {
                children: success
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($4baf56fe187b27f6$var$ConfirmButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                        size: "S",
                        onClick: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.REFUND_TRANSACTION_REASON_MODAL_ID)),
                        children: formatMessage("refundTransactionModal.cancelButton")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                        showSpinner: loading,
                        size: "S",
                        onClick: ()=>!loading && handleRefundConfirm(),
                        children: formatMessage("refundTransactionModal.confirmButton")
                    })
                ]
            })
        ]
    });
};
const $4baf56fe187b27f6$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #ffffff;
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  padding: 20px;
`;
const $4baf56fe187b27f6$var$ReasonsContainer = (0, $jb8NR.default).div`
  display: flex;
  margin-top: 25px;
  align-self: stretch;
`;
const $4baf56fe187b27f6$var$MessageLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 18px;
  color: black;
`;
const $4baf56fe187b27f6$var$ConfirmButtonsContainer = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 36px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    > * {
      width: 100%;
      max-width: 200px;
    }

    > *:not(:first-child) {
      margin-top: 10px;
    }
  }
`;
const $4baf56fe187b27f6$var$StyledRadioSelector = (0, $jb8NR.default)((0, $kw746.RadioSelector))`
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 20px;
  }
`;
const $4baf56fe187b27f6$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0;
`;
const $4baf56fe187b27f6$var$StyledSuccessMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0;
  color: ${(0, $22v9q.theme).colors.success[500]};
`;

});
parcelRegister("jdZtx", function(module, exports) {

$parcel$export(module.exports, "RefundTransactionReason", function () { return $b49319a1d3ddcaa1$export$3ffd62b92a66cd42; });
var $b49319a1d3ddcaa1$export$3ffd62b92a66cd42 = /*#__PURE__*/ function(RefundTransactionReason) {
    RefundTransactionReason["AC03"] = "AC03";
    RefundTransactionReason["AM09"] = "AM09";
    RefundTransactionReason["CUST"] = "CUST";
    return RefundTransactionReason;
}({});

});

parcelRegister("jn1mK", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", function () { return $ec1d1c0a048d5501$export$915e9e7bd4f0f96d; });

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
const $ec1d1c0a048d5501$export$915e9e7bd4f0f96d = (0, $jb8NR.default).div`
  color: #ff4242;
  font-size: 0.875rem;
  ${(0, $22v9q.theme).mediumText};
`;

});

parcelRegister("kw746", function(module, exports) {

$parcel$export(module.exports, "RadioSelector", function () { return $f138ce618f67da08$export$1543fb9e21cc58f6; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $dzZR4 = parcelRequire("dzZR4");
function $f138ce618f67da08$export$1543fb9e21cc58f6(props) {
    const { className: className, values: values, value: value, onChange: onChange, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $dzZR4.RadioButtonsInput), {
        className: className,
        value: value,
        onChange: (v)=>onChange?.(v),
        options: Array.from(values.keys()),
        itemRenderer: (item)=>values.get(item) ?? "",
        ...rest
    });
}

});
parcelRegister("dzZR4", function(module, exports) {

$parcel$export(module.exports, "RadioButtonsInput", function () { return $4ba04477efb0e81b$export$c42f5e088c1d62b4; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");
function $4ba04477efb0e81b$export$c42f5e088c1d62b4({ innerId: id, onChange: onChange, options: options, value: value, className: className, orientation: orientation = "left", itemRenderer: itemRenderer = (v)=>`${v}`, buttonColorRenderer: buttonColorRenderer, disabled: disabled, ...rest }) {
    const valueStr = itemRenderer(value);
    const selectedIndex = options.findIndex((it)=>itemRenderer(it) === valueStr);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)($4ba04477efb0e81b$var$RadioContainer, {
        className: className,
        $isRTL: isRTL,
        children: options.map((v, index)=>/*#__PURE__*/ (0, $4m918.jsxs)($4ba04477efb0e81b$var$ButtonWrapper, {
                orientation: orientation,
                disabled: disabled,
                $isRTL: isRTL,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($4ba04477efb0e81b$var$CheckedInput, {
                        type: "radio",
                        id: `${id}-${index}`,
                        name: id,
                        defaultChecked: selectedIndex === -1 ? undefined : selectedIndex === index,
                        color: buttonColorRenderer?.(v),
                        disabled: disabled,
                        value: itemRenderer(v),
                        onChange: ()=>onChange(v),
                        $isRTL: isRTL,
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($4ba04477efb0e81b$var$StyledLabel, {
                        htmlFor: `${id}-${index}`,
                        children: itemRenderer(v)
                    })
                ]
            }, index))
    });
}
const $4ba04477efb0e81b$var$RadioContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;

  > *:not(:last-child) {
    margin-right: ${(props)=>props.$isRTL ? 0 : 10}px;
    margin-left: ${(props)=>props.$isRTL ? 10 : 0}px;
  }
`;
const $4ba04477efb0e81b$var$StyledLabel = (0, $jb8NR.default).label`
  font-size: 0.875rem;
  ${(0, $22v9q.theme).boldText}
`;
const $4ba04477efb0e81b$var$ButtonWrapper = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: ${(props)=>props.orientation === "left" ? "row" : "row-reverse"};
  justify-content: ${(props)=>props.orientation === "left" ? "flex-start" : "flex-end"};
  align-items: center;

  > * {
    cursor: ${(props)=>props.disabled ? null : "pointer"};
  }

  > *:not(:last-child) {
    ${(props)=>props.orientation === "left" && !props.$isRTL ? "margin-right: 10px" : "margin-left: 10px"};
  }
`;
const $4ba04477efb0e81b$var$CheckedInput = (0, $jb8NR.default).input`
  width: 25px;
  height: 25px;
  background-color: #fff;
  border-radius: 15px;
  display: inline-block;
  border: solid 1px ${(props)=>props.color ?? (0, $22v9q.theme).mainColor};
  position: relative;
  -webkit-appearance: none;

  &:checked::after {
    background-color: ${(props)=>props.color ?? (0, $22v9q.theme).mainColor};
    border-radius: 25px;
    content: "";
    display: block;
    height: 11px;
    width: 11px;
    left: ${(props)=>props.$isRTL ? "unset" : "6px"};
    right: ${(props)=>props.$isRTL ? "6px" : "unset"};
    top: 6px;
    position: relative;
  }
`;

});



parcelRegister("2XXLB", function(module, exports) {

$parcel$export(module.exports, "TransactionStateTag", function () { return $712a4ef418d8bc6c$export$f8a205bfe43256d7; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $fEJVB = parcelRequire("fEJVB");

var $60xvI = parcelRequire("60xvI");
const $712a4ef418d8bc6c$var$PENDING_COLOR = "#741537";
const $712a4ef418d8bc6c$var$DONE_COLOR = "#0b293e";
function $712a4ef418d8bc6c$export$f8a205bfe43256d7({ label: label, done: done }) {
    return /*#__PURE__*/ (0, $4m918.jsxs)($712a4ef418d8bc6c$var$Pill, {
        $done: done,
        children: [
            done ? /*#__PURE__*/ (0, $4m918.jsx)((0, $60xvI.TransactionValidateIcon), {
                width: 14,
                height: 14,
                fill: $712a4ef418d8bc6c$var$DONE_COLOR
            }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $fEJVB.TransactionErrorIcon), {
                width: 12,
                height: 12,
                fill: $712a4ef418d8bc6c$var$PENDING_COLOR
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($712a4ef418d8bc6c$var$Label, {
                $done: done,
                children: label
            })
        ]
    });
}
/* Mauve flags what is still pending, neutral grey what is done. */ const $712a4ef418d8bc6c$var$Pill = (0, $jb8NR.default).span`
  display: inline-flex;
  align-items: center;
  background-color: ${(props)=>props.$done ? "#f7f8ff" : "#f1e7eb"};
  border-radius: 3px;
  padding: 5px 10px;
`;
const $712a4ef418d8bc6c$var$Label = (0, $jb8NR.default).span`
  margin-left: 6px;
  font-size: 12px;
  color: ${(props)=>props.$done ? $712a4ef418d8bc6c$var$DONE_COLOR : $712a4ef418d8bc6c$var$PENDING_COLOR};
`;

});
parcelRegister("fEJVB", function(module, exports) {

$parcel$export(module.exports, "TransactionErrorIcon", function () { return $1967704043d4f0ce$export$a6eb701b8360e7ec; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $1967704043d4f0ce$export$a6eb701b8360e7ec(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M8.12055 4.62055L6.83594 5.90625L8.12219 7.19195C8.24547 7.31524 8.31473 7.48245 8.31473 7.6568C8.31473 7.83115 8.24547 7.99836 8.12219 8.12164C7.99891 8.24492 7.8317 8.31419 7.65735 8.31419C7.483 8.31419 7.31579 8.24492 7.1925 8.12164L5.90625 6.83594L4.62055 8.12219C4.49726 8.24547 4.33006 8.31473 4.15571 8.31473C3.98135 8.31473 3.81415 8.24547 3.69086 8.12219C3.56758 7.9989 3.49832 7.83169 3.49832 7.65734C3.49832 7.48299 3.56758 7.31578 3.69086 7.1925L4.97656 5.90625L3.69196 4.62055C3.63091 4.5595 3.58249 4.48703 3.54945 4.40727C3.51641 4.32752 3.49941 4.24203 3.49941 4.1557C3.49941 3.98135 3.56867 3.81414 3.69196 3.69086C3.81524 3.56757 3.98245 3.49831 4.1568 3.49831C4.33115 3.49831 4.49836 3.56757 4.62164 3.69086L5.90625 4.97656L7.19195 3.69031C7.31524 3.56703 7.48245 3.49777 7.6568 3.49777C7.83115 3.49777 7.99836 3.56703 8.12164 3.69031C8.24493 3.8136 8.31419 3.98081 8.31419 4.15516C8.31419 4.32951 8.24493 4.49672 8.12164 4.62L8.12055 4.62055ZM11.8125 5.90625C11.8125 7.0744 11.4661 8.21631 10.8171 9.18759C10.1681 10.1589 9.2457 10.9159 8.16648 11.3629C7.08725 11.8099 5.8997 11.9269 4.754 11.699C3.6083 11.4711 2.55591 10.9086 1.7299 10.0826C0.903899 9.2566 0.341384 8.2042 0.11349 7.0585C-0.114404 5.9128 0.0025591 4.72525 0.449589 3.64603C0.896619 2.5668 1.65364 1.64437 2.62492 0.995383C3.59619 0.346396 4.73811 0 5.90625 0C7.47215 0.001737 8.97342 0.624559 10.0807 1.73182C11.1879 2.83908 11.8108 4.34035 11.8125 5.90625ZM10.5 5.90625C10.5 4.99769 10.2306 4.10954 9.72581 3.3541C9.22105 2.59866 8.5036 2.00987 7.6642 1.66218C6.82481 1.31449 5.90116 1.22352 5.01006 1.40077C4.11896 1.57802 3.30043 2.01553 2.65798 2.65798C2.01553 3.30043 1.57802 4.11895 1.40077 5.01005C1.22352 5.90115 1.31449 6.8248 1.66218 7.6642C2.00987 8.5036 2.59866 9.22105 3.3541 9.72581C4.10954 10.2306 4.99769 10.5 5.90625 10.5C7.12419 10.4987 8.29187 10.0143 9.15308 9.15308C10.0143 8.29187 10.4987 7.12419 10.5 5.90625Z",
            fill: props.fill ?? "#0B293E"
        })
    });
}

});



parcelRegister("iy3jB", function(module, exports) {

$parcel$export(module.exports, "LatestTransactionsSection", function () { return $d905ac179e89a50c$export$8295088f446789f1; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $5xxJk = parcelRequire("5xxJk");
function $d905ac179e89a50c$export$8295088f446789f1(props) {
    const { transactions: transactions, loading: loading, onTransactionClick: onTransactionClick, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($d905ac179e89a50c$var$Section, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($d905ac179e89a50c$var$Title, {
                children: formatMessage("homeScreen.latestTransactionsTitle")
            }),
            loading ? /*#__PURE__*/ (0, $4m918.jsx)($d905ac179e89a50c$var$LoaderRow, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "24px"
                })
            }) : transactions.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)($d905ac179e89a50c$var$EmptyLabel, {
                children: formatMessage("accountTransactions.emptyTransactionList")
            }) : transactions.map((transaction)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $5xxJk.TransactionRow), {
                    transaction: transaction,
                    onClick: ()=>onTransactionClick(transaction)
                }, transaction.id))
        ]
    });
}
const $d905ac179e89a50c$var$Section = (0, $jb8NR.default).section`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;
const $d905ac179e89a50c$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $d905ac179e89a50c$var$LoaderRow = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
`;
const $d905ac179e89a50c$var$EmptyLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  color: ${(0, $22v9q.theme).colors.gray[500]};
`;

});
parcelRegister("5xxJk", function(module, exports) {

$parcel$export(module.exports, "TransactionRow", function () { return $6e5f9e7ffea446f4$export$be59229647a59a8; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $fZL4e = parcelRequire("fZL4e");

var $iMWY7 = parcelRequire("iMWY7");

var $bZlaH = parcelRequire("bZlaH");

var $bewhU = parcelRequire("bewhU");

var $51d3M = parcelRequire("51d3M");

var $22v9q = parcelRequire("22v9q");

var $loTnT = parcelRequire("loTnT");

var $2XXLB = parcelRequire("2XXLB");
function $6e5f9e7ffea446f4$export$be59229647a59a8({ transaction: transaction, className: className, onClick: onClick }) {
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const { isOutgoing: isOutgoing } = (0, $fZL4e.useTransactionLinks)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($6e5f9e7ffea446f4$var$Row, {
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($6e5f9e7ffea446f4$var$RowContent, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($6e5f9e7ffea446f4$var$Label, {
                        children: $6e5f9e7ffea446f4$var$describe(transaction)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($6e5f9e7ffea446f4$var$Date, {
                        children: formatDate(transaction.date, {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric"
                        })
                    }),
                    isOutgoing(transaction) && /*#__PURE__*/ (0, $4m918.jsxs)($6e5f9e7ffea446f4$var$TagRow, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $2XXLB.TransactionStateTag), {
                                label: formatMessage(transaction.justified ? "accountTransactions.tagJustified" : "accountTransactions.tagNotJustified"),
                                done: !!transaction.justified
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $2XXLB.TransactionStateTag), {
                                label: formatMessage(transaction.qualified ? "accountTransactions.tagQualified" : "accountTransactions.tagNotQualified"),
                                done: !!transaction.qualified
                            })
                        ]
                    })
                ]
            }),
            transaction.detailedAccounting && transaction.amount && /*#__PURE__*/ (0, $4m918.jsx)($6e5f9e7ffea446f4$var$RowAmount, {
                amount: {
                    value: (0, $iMWY7.getTotalOfDetailedAccounting)(transaction.detailedAccounting),
                    currency: transaction.amount.currency
                }
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($6e5f9e7ffea446f4$var$RowChevron, {})
        ]
    });
}
function $6e5f9e7ffea446f4$var$describe(transaction) {
    return (0, $loTnT.hasObjectType)(transaction) ? transaction.shortDescription || transaction.type.label : "";
}
const $6e5f9e7ffea446f4$var$Row = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 12px;
  padding: 16px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
  text-align: left;

  &:hover {
    opacity: 1;
    border-color: #e4e4e4;
  }
`;
const $6e5f9e7ffea446f4$var$RowContent = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;
const $6e5f9e7ffea446f4$var$Label = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 15px;
  line-height: 20px;
  color: #000000;
`;
const $6e5f9e7ffea446f4$var$Date = (0, $jb8NR.default).span`
  font-size: 13px;
  line-height: 17px;
  color: ${(0, $22v9q.theme).colors.gray[500]};
`;
const $6e5f9e7ffea446f4$var$TagRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 4px;
`;
const $6e5f9e7ffea446f4$var$RowAmount = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 15px;
  color: #000000;
`;
const $6e5f9e7ffea446f4$var$RowChevron = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

});
parcelRegister("loTnT", function(module, exports) {

$parcel$export(module.exports, "AccountTransactionCard", function () { return $d3f232fe6072771a$export$f7b614efa2a7df68; });
$parcel$export(module.exports, "hasObjectType", function () { return $d3f232fe6072771a$export$e3cf6486a4f77bc6; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $75iyY = parcelRequire("75iyY");

var $ixrkn = parcelRequire("ixrkn");

var $fZL4e = parcelRequire("fZL4e");

var $iMWY7 = parcelRequire("iMWY7");

var $yYT9n = parcelRequire("yYT9n");

var $bZlaH = parcelRequire("bZlaH");

var $f5HsK = parcelRequire("f5HsK");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $3FSND = parcelRequire("3FSND");
function $d3f232fe6072771a$export$f7b614efa2a7df68(props) {
    const { transaction: transaction, received: received, showUnjustifiedTag: showUnjustifiedTag = false, ...rest } = props;
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { labelForType: labelForType } = (0, $3FSND.useAuthorizationHoldLabel)();
    const { canShowJustifyLabel: canShowJustifyLabel } = (0, $fZL4e.useTransactionLinks)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const detailedAccountingTransfer = transaction?.detailedAccounting?.find((accounting)=>accounting.type === (0, $75iyY.AccountingEntryType).Transfer);
    const transactionDescription = $d3f232fe6072771a$export$e3cf6486a4f77bc6(transaction) ? transaction.objectType === (0, $ixrkn.AccountingTransactionType).Transaction ? transaction.shortDescription || detailedAccountingTransfer?.description || transaction.type.label : labelForType(transaction.type) : transaction.label;
    return /*#__PURE__*/ (0, $4m918.jsxs)($d3f232fe6072771a$var$Card, {
        $isRTL: isRTL,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($d3f232fe6072771a$var$IconLabelContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($d3f232fe6072771a$var$Label, {
                    $isRTL: isRTL,
                    children: transactionDescription
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($d3f232fe6072771a$var$Date, {
                $isRTL: isRTL,
                children: formatDate(transaction.date, {
                    month: "short",
                    day: "numeric",
                    year: "numeric"
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($d3f232fe6072771a$var$UnjustifiedLabelContainer, {
                children: canShowJustifyLabel(transaction) && showUnjustifiedTag ? /*#__PURE__*/ (0, $4m918.jsxs)($d3f232fe6072771a$var$StyledUnjustifiedLabel, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($d3f232fe6072771a$var$Dot, {
                            size: 6
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($d3f232fe6072771a$var$UnjustifiedMention, {
                            children: formatMessage("accountTransactions.expenseUnjustified")
                        })
                    ]
                }) : null
            }),
            transaction.detailedAccounting && /*#__PURE__*/ (0, $4m918.jsx)($d3f232fe6072771a$var$Amount, {
                amount: {
                    value: (0, $iMWY7.getTotalOfDetailedAccounting)(transaction.detailedAccounting),
                    currency: transaction.amount.currency
                },
                $isRTL: isRTL
            })
        ]
    });
}
function $d3f232fe6072771a$export$e3cf6486a4f77bc6(transaction) {
    return transaction?.objectType !== undefined;
}
const $d3f232fe6072771a$var$Card = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  padding: ${(props)=>props.$isRTL ? "18px 15px 18px 27px" : "18px 27px 18px 15px"};
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};

  background-color: #ffffff;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const $d3f232fe6072771a$var$IconLabelContainer = (0, $jb8NR.default).div`
  flex: 1 0 45%;
  display: flex;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    flex: 0 1 auto;
  }
`;
const $d3f232fe6072771a$var$Label = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  line-height: 1.2rem;
  ${(0, $22v9q.theme).boldText};
  margin: ${(props)=>props.$isRTL ? "auto 27px auto 0" : "auto 0 auto 27px"};
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    margin: ${(props)=>props.$isRTL ? "auto 27px 10px 0" : "auto 0 10px 27px"};
  }
`;
const $d3f232fe6072771a$var$Date = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 0.9375rem;
  padding: 0 30px;
  text-align: left;
  width: 25%;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    padding: ${(props)=>props.$isRTL ? "0 67px 8px 0" : "0 0 8px 67px"};
    width: auto;
  }
`;
const $d3f232fe6072771a$var$Amount = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
  justify-content: flex-end;
  text-align: ${(props)=>props.$isRTL ? "start" : "end"};
  flex: 1 1 25%;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    margin: ${(props)=>props.$isRTL ? "0 67px 0 0" : "0 0 0 67px"};
    flex: 0 1 auto;
  }
`;
const $d3f232fe6072771a$var$Dot = (0, $jb8NR.default)((0, $f5HsK.Circle))`
  background-color: #b1b1b1;
  margin: 0 8px;
  float: left;
`;
const $d3f232fe6072771a$var$UnjustifiedMention = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 12px;
  color: ${(0, $22v9q.theme).colors.warning[500]};
`;
const $d3f232fe6072771a$var$UnjustifiedLabelContainer = (0, $jb8NR.default).div`
  width: 30%;
`;
const $d3f232fe6072771a$var$StyledUnjustifiedLabel = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

});
parcelRegister("f5HsK", function(module, exports) {

$parcel$export(module.exports, "Circle", function () { return $bc3ed033923c0929$export$c89a927ffc67e6fa; });

var $jb8NR = parcelRequire("jb8NR");
const $bc3ed033923c0929$export$c89a927ffc67e6fa = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: ${(props)=>props.size}px;
  width: ${(props)=>props.size}px;
  border-radius: ${(props)=>props.size / 2}px;
`;

});

parcelRegister("3FSND", function(module, exports) {

$parcel$export(module.exports, "useAuthorizationHoldLabel", function () { return $8905bfd25677c5f8$export$feb938a93be41ff3; });

var $5hpYi = parcelRequire("5hpYi");
const $8905bfd25677c5f8$export$feb938a93be41ff3 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const authorizationHoldLabels = {
        ["CASHOUT"]: "authorizationHolds.cashoutLabel",
        ["PAYMENT"]: "authorizationHolds.paymentLabel",
        ["EXTERNAL_TO_ACCOUNT"]: "authorizationHolds.externalToAccountLabel",
        ["ACCOUNT_TO_EXTERNAL"]: "authorizationHolds.accountToExternalLabel",
        ["EXTERNAL_FROM_ACCOUNT"]: "authorizationHolds.externalFromAccountLabel",
        ["ACCOUNT_RECHARGE"]: "authorizationHolds.accountRechargeLabel",
        ["ON_US_CREDIT_TRANSFER"]: "authorizationHolds.onUsCreditTransferLabel",
        ["MANAGEMENT_FEES"]: "authorizationHolds.managementFeesLabel"
    };
    const labelForType = (type)=>authorizationHoldLabels[type] ? formatMessage(authorizationHoldLabels[type]) : type;
    return {
        labelForType: labelForType
    };
};

});




parcelRegister("kVkkQ", function(module, exports) {

$parcel$export(module.exports, "MonthlyFluxSection", function () { return $21cf9694ca39b25e$export$53388f6cb42ec3a8; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $9WZNm = parcelRequire("9WZNm");

var $4fYE4 = parcelRequire("4fYE4");

var $bZlaH = parcelRequire("bZlaH");

var $bewhU = parcelRequire("bewhU");

var $k4kME = parcelRequire("k4kME");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $e0mue = parcelRequire("e0mue");
function $21cf9694ca39b25e$export$53388f6cb42ec3a8(props) {
    const { account: account, ...rest } = props;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const { income: income, outcome: outcome, loading: loading } = (0, $9WZNm.useMonthlyFlux)(account);
    // react-intl carries the app's locale data, moment's locale files are never imported.
    const monthLabel = (0, $6uYXW.useMemo)(()=>formatDate(new Date(), {
            month: "long"
        }), [
        formatDate
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($21cf9694ca39b25e$var$Section, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($21cf9694ca39b25e$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$Title, {
                        children: formatMessage("homeScreen.monthlyFluxTitle", {
                            month: monthLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$SeeAllLink, {
                        to: `${(0, $4fYE4.Path).AllTransactions}?${(0, $e0mue.ACCOUNT_QUERY_PARAM)}=${account.id}`,
                        children: formatMessage("homeScreen.allTransactionsLink")
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$LoaderRow, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "24px"
                })
            }) : /*#__PURE__*/ (0, $4m918.jsxs)($21cf9694ca39b25e$var$Tiles, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($21cf9694ca39b25e$var$FluxTile, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$Illustration, {
                                src: (0, $fRvTz.StaticAssets).fluxIncome,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$TileLabel, {
                                children: formatMessage("homeScreen.monthlyFluxIncome")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$TileAmount, {
                                $positive: true,
                                amount: income,
                                forceSign: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($21cf9694ca39b25e$var$FluxTile, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$Illustration, {
                                src: (0, $fRvTz.StaticAssets).fluxExpense,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$TileLabel, {
                                children: formatMessage("homeScreen.monthlyFluxExpense")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($21cf9694ca39b25e$var$TileAmount, {
                                amount: outcome,
                                forceSign: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $21cf9694ca39b25e$var$Section = (0, $jb8NR.default).section`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;
const $21cf9694ca39b25e$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;
const $21cf9694ca39b25e$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $21cf9694ca39b25e$var$SeeAllLink = (0, $jb8NR.default)((0, $bewhU.DefaultLink))`
  ${(0, $22v9q.theme).mediumText};
  font-size: 13px;
  color: ${(0, $22v9q.theme).mainColor()};
`;
const $21cf9694ca39b25e$var$Tiles = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    flex-direction: column;
  }
`;
const $21cf9694ca39b25e$var$FluxTile = (0, $jb8NR.default).div`
  display: flex;
  flex: 1 1 0;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
`;
const $21cf9694ca39b25e$var$Illustration = (0, $jb8NR.default).img`
  width: 48px;
  height: 48px;
`;
const $21cf9694ca39b25e$var$LoaderRow = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
`;
const $21cf9694ca39b25e$var$TileLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  flex: 1;
  font-size: 14px;
  line-height: 18px;
  color: #000000;
`;
/** Green marks what came in; what went out stays neutral, its minus sign carries the meaning. */ const $21cf9694ca39b25e$var$TileAmount = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 17px;
  color: ${(props)=>props.$positive ? "#26cc8f" : "#000000"};
`;

});
parcelRegister("9WZNm", function(module, exports) {

$parcel$export(module.exports, "useMonthlyFlux", function () { return $c4f6efde25737484$export$c83226c2c40e9cf7; });

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $7yIx1 = parcelRequire("7yIx1");

var $ao7HR = parcelRequire("ao7HR");

var $3U0hy = parcelRequire("3U0hy");
function $c4f6efde25737484$export$c83226c2c40e9cf7(account) {
    const filters = (0, $6uYXW.useMemo)(()=>({
            timerange: {
                timeRange: (0, $7yIx1.TimeRange).Other,
                bounds: [
                    (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))().startOf("month"),
                    (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))()
                ]
            },
            amountRange: [
                null,
                null
            ],
            currencyId: undefined,
            isQualified: undefined,
            isJustified: undefined,
            isLocked: undefined
        }), []);
    const income = (0, $3U0hy.useTransactions)(account, (0, $ao7HR.TransactionDirection).INCOME, filters);
    const outcome = (0, $3U0hy.useTransactions)(account, (0, $ao7HR.TransactionDirection).OUTCOME, filters);
    const total = (transactions)=>transactions.reduce((sum, transaction)=>sum + (transaction.amount?.value ?? 0), 0);
    const toAmount = (value)=>({
            value: value,
            currency: account?.currency,
            currencyAlpha: account?.currencyAlpha
        });
    return {
        income: toAmount(total(income.data)),
        outcome: toAmount(-Math.abs(total(outcome.data))),
        loading: income.loading || outcome.loading
    };
}

});


parcelRegister("agLlU", function(module, exports) {

$parcel$export(module.exports, "RequiredActionsCard", function () { return $f338ac2381cd2acf$export$e39b89bfa1be0f6e; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $4fYE4 = parcelRequire("4fYE4");

var $bewhU = parcelRequire("bewhU");

var $51d3M = parcelRequire("51d3M");

var $22v9q = parcelRequire("22v9q");

var $e0mue = parcelRequire("e0mue");
function $f338ac2381cd2acf$export$e39b89bfa1be0f6e(props) {
    const { account: account, toJustifyCount: toJustifyCount, toQualifyCount: toQualifyCount, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const allTransactions = `${(0, $4fYE4.Path).AllTransactions}?${(0, $e0mue.ACCOUNT_QUERY_PARAM)}=${account.id}`;
    if (toJustifyCount <= 0 && toQualifyCount <= 0) return null;
    return /*#__PURE__*/ (0, $4m918.jsxs)($f338ac2381cd2acf$var$Card, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($f338ac2381cd2acf$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$Title, {
                        children: formatMessage("homeScreen.requiredActionsTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$SeeAllLink, {
                        to: allTransactions,
                        children: formatMessage("homeScreen.requiredActionsSeeAll")
                    })
                ]
            }),
            toJustifyCount > 0 && /*#__PURE__*/ (0, $4m918.jsxs)($f338ac2381cd2acf$var$ActionRow, {
                to: allTransactions,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$ActionLabel, {
                        children: formatMessage("homeScreen.transactionsToJustify")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$CountBadge, {
                        children: toJustifyCount
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$RowChevron, {})
                ]
            }),
            toQualifyCount > 0 && /*#__PURE__*/ (0, $4m918.jsxs)($f338ac2381cd2acf$var$ActionRow, {
                to: allTransactions,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$ActionLabel, {
                        children: formatMessage("homeScreen.transactionsToQualify")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$CountBadge, {
                        children: toQualifyCount
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($f338ac2381cd2acf$var$RowChevron, {})
                ]
            })
        ]
    });
}
const $f338ac2381cd2acf$var$Card = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  padding: 16px;
  border-radius: 16px;
  background-color: #ffffff;
`;
const $f338ac2381cd2acf$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;
const $f338ac2381cd2acf$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $f338ac2381cd2acf$var$SeeAllLink = (0, $jb8NR.default)((0, $bewhU.DefaultLink))`
  ${(0, $22v9q.theme).mediumText};
  font-size: 13px;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
const $f338ac2381cd2acf$var$ActionRow = (0, $jb8NR.default)((0, $bewhU.DefaultLink))`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 14px 16px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  border-radius: 12px;
  color: ${(0, $22v9q.theme).colors.blue[700]};

  &:last-of-type {
    margin-bottom: 0;
  }
`;
const $f338ac2381cd2acf$var$ActionLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  flex: 1;
  text-align: left;
  font-size: 14px;
  line-height: 18px;
`;
const $f338ac2381cd2acf$var$CountBadge = (0, $jb8NR.default).span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  background-color: ${(0, $22v9q.theme).colors.blue[700]};
  color: #ffffff;
  font-size: 12px;
`;
const $f338ac2381cd2acf$var$RowChevron = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  fill: ${(0, $22v9q.theme).colors.blue[700]};
`;

});

parcelRegister("hZs1x", function(module, exports) {

$parcel$export(module.exports, "TrustChoiceModal", function () { return $4cccefc4eabd7f56$export$f3d5c158b7a09459; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $bQhUC = parcelRequire("bQhUC");

var $bewhU = parcelRequire("bewhU");

var $7Zu6k = parcelRequire("7Zu6k");

var $ZE1cB = parcelRequire("ZE1cB");

var $5Wai4 = parcelRequire("5Wai4");

var $f5HsK = parcelRequire("f5HsK");

var $9lwgv = parcelRequire("9lwgv");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");
const $4cccefc4eabd7f56$export$f3d5c158b7a09459 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const nbDaysTrustDuration = (0, $kqXxS.configurationManager).getNbDaysTrustDuration();
    const close = (0, $6uYXW.useCallback)(()=>{
        (0, $5Wai4.Modal).dismiss((0, $bQhUC.TRUST_CHOICE_MODAL_ID));
    }, []);
    const later = (0, $6uYXW.useCallback)(()=>{
        (0, $kqXxS.trustManager).setUnknown();
        close();
    }, [
        close
    ]);
    const trust = (0, $6uYXW.useCallback)(()=>{
        (0, $kqXxS.trustManager).setTrust(nbDaysTrustDuration);
        close();
    }, [
        close,
        nbDaysTrustDuration
    ]);
    const doNotTrust = (0, $6uYXW.useCallback)(()=>{
        (0, $kqXxS.trustManager).setUntrust(nbDaysTrustDuration);
        close();
    }, [
        close,
        nbDaysTrustDuration
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($4cccefc4eabd7f56$var$ModalContainer, {
        id: (0, $bQhUC.TRUST_CHOICE_MODAL_ID),
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($4cccefc4eabd7f56$var$Logo, {
                src: (0, $fRvTz.StaticAssets).logo
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($4cccefc4eabd7f56$var$MainContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($4cccefc4eabd7f56$var$ShieldContainer, {
                        size: 124,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $9lwgv.ShieldIcon), {
                            color: (0, $22v9q.theme).mainColor()
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($4cccefc4eabd7f56$var$Title, {
                        children: formatMessage("trustChoice.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($4cccefc4eabd7f56$var$Explanation, {
                        children: formatMessage("trustChoice.explanation")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($4cccefc4eabd7f56$var$ButtonsContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($4cccefc4eabd7f56$var$LaterButton, {
                                onClick: later,
                                children: formatMessage("trustChoice.laterButton")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($4cccefc4eabd7f56$var$ChoiceContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.WhitePrimaryButton), {
                                        size: "S",
                                        onClick: doNotTrust,
                                        children: formatMessage("trustChoice.dontTrustButton")
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                                        size: "S",
                                        onClick: trust,
                                        children: formatMessage("trustChoice.trustButton")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $4cccefc4eabd7f56$var$ModalContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fbfbfb;
  width: 536px;
  height: 100%;
  padding: 0;
  margin: 0;
`;
const $4cccefc4eabd7f56$var$MainContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-bottom: 244px;
`;
const $4cccefc4eabd7f56$var$Logo = (0, $jb8NR.default).img`
  width: 112px;
  height: 112px;
  object-fit: contain;
  margin-top: 44px;
  margin-bottom: 88px;
`;
const $4cccefc4eabd7f56$var$ShieldContainer = (0, $jb8NR.default)((0, $f5HsK.Circle))`
  background-color: white;
  ${(0, $22v9q.shadows).medium}
`;
const $4cccefc4eabd7f56$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.5rem;
  text-align: center;
  margin-top: 36px;
  margin-bottom: 20px;
`;
const $4cccefc4eabd7f56$var$Explanation = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 1.125rem;
  line-height: 1.625rem;
  text-align: center;
  padding: 0 8px;
  margin-bottom: 36px;
`;
const $4cccefc4eabd7f56$var$ButtonsContainer = (0, $jb8NR.default).div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;
const $4cccefc4eabd7f56$var$ChoiceContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
const $4cccefc4eabd7f56$var$LaterButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.875rem;
  opacity: 0.4;
  text-decoration: underline;
`;

});
parcelRegister("ZE1cB", function(module, exports) {

$parcel$export(module.exports, "MarkdownText", function () { return $2bad81120bde9e66$export$52d6c26e2e11f6ec; });

var $4m918 = parcelRequire("4m918");

var $7Pi05 = parcelRequire("7Pi05");
parcelRequire("6uYXW");

var $22v9q = parcelRequire("22v9q");
const $2bad81120bde9e66$export$52d6c26e2e11f6ec = (props)=>{
    const { children: children, ...otherProps } = props;
    const tagStyles = {
        emph: {
            color: (0, $22v9q.theme).mainColor()
        },
        b: {
            color: "#000000",
            ...(0, $22v9q.theme).boldText
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $7Pi05.StyledTaggedSpan), {
        ...otherProps,
        tagsStyle: tagStyles,
        children: children
    });
};

});
parcelRegister("7Pi05", function(module, exports) {

$parcel$export(module.exports, "StyledTaggedSpan", function () { return $5b2b4251174e8275$export$6c251e5a19c78efa; });

var $6uYXW = parcelRequire("6uYXW");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5b2b4251174e8275$var$t(r, n, t) {
    if (t || 2 === arguments.length) for(var e, i = 0, o = n.length; i < o; i++)!e && i in n || (e || (e = Array.prototype.slice.call(n, 0, i)), e[i] = n[i]);
    return r.concat(e || n);
}
var $5b2b4251174e8275$var$e;
!function(r) {
    r[r.TAG = 0] = "TAG", r[r.WORD = 1] = "WORD";
}($5b2b4251174e8275$var$e || ($5b2b4251174e8275$var$e = {}));
var $5b2b4251174e8275$var$i = function(r) {
    return "/" === r[1].charAt(0);
}, $5b2b4251174e8275$var$o = function(r, n) {
    var t, o, a = null !== (t = null == n ? void 0 : n.parseUnspecifiedTags) && void 0 !== t && t, s = null !== (o = null == n ? void 0 : n.supportedTags) && void 0 !== o ? o : new Set, c = function r(n) {
        if (0 === n.length) return [];
        var t = n[0];
        if (t[0] === $5b2b4251174e8275$var$e.WORD) return $5b2b4251174e8275$var$u(t[1], r(n.slice(1)));
        if (t[0] === $5b2b4251174e8275$var$e.TAG) {
            if (!function(r) {
                return !!a || s.has(r[1]);
            }(t)) return $5b2b4251174e8275$var$u("[" + t[1] + "]", r(n.slice(1)));
            if (function(r) {
                return !$5b2b4251174e8275$var$i(r);
            }(t)) {
                var o = function(r, n) {
                    var e = r.findIndex(function(r) {
                        var n, e;
                        return e = t, $5b2b4251174e8275$var$i(n = r) && n[1].slice(1) === e[1];
                    });
                    return -1 === e || 0 === e ? [
                        [],
                        r
                    ] : [
                        r.slice(0, e),
                        r.slice(e + 1)
                    ];
                }(n.slice(1)), c = o[0], f = o[1];
                return c.length > 0 ? $5b2b4251174e8275$var$u({
                    tag: t[1],
                    content: r(c)
                }, r(f)) : $5b2b4251174e8275$var$u("[" + t[1] + "]", r(n.slice(1)));
            }
            if ($5b2b4251174e8275$var$i(t)) return $5b2b4251174e8275$var$u("[" + t[1] + "]", r(n.slice(1)));
        }
        return [];
    }(r);
    return Array.isArray(c) ? c : [
        c
    ];
};
function $5b2b4251174e8275$var$u(r, n) {
    return Array.isArray(n) && 0 === n.length ? r : "string" == typeof r && "string" == typeof n ? r + n : "string" == typeof r && Array.isArray(n) && n.length > 0 && "string" == typeof n[0] ? (n[0] = r + n[0], n) : Array.isArray(r) && Array.isArray(n) ? r.concat(n) : Array.isArray(r) ? $5b2b4251174e8275$var$t($5b2b4251174e8275$var$t([], r), [
        n
    ]) : Array.isArray(n) ? $5b2b4251174e8275$var$t([
        r
    ], n) : [
        r,
        n
    ];
}
function $5b2b4251174e8275$var$a(t, i, u, a, s) {
    void 0 === s && (s = !1);
    var c = (0, $6uYXW.useMemo)(function() {
        var r, n;
        return r = u || "", n = {
            parseUnspecifiedTags: s,
            supportedTags: new Set(Object.keys(a))
        }, $5b2b4251174e8275$var$o((function(r) {
            var n = [], t = function(r) {
                var n = {
                    pos: 0,
                    len: r.length
                }, t = function(r) {
                    void 0 === r && (r = 1), n.pos += r;
                }, e = function() {
                    return n.len > n.pos;
                }, i = function() {
                    return r[n.pos];
                };
                return {
                    skip: t,
                    hasNext: e,
                    getCurrent: i,
                    grabUntil: function(o) {
                        var u = 0;
                        if (e()) for(u = n.pos; e() && !o(i());)t();
                        return r.substr(u, n.pos - u);
                    },
                    substrUntilChar: function(t) {
                        var e = n.pos, i = r.indexOf(t, e);
                        return i >= 0 ? r.substr(e, i - e) : "";
                    }
                };
            }(r), i = function(r, t) {
                return n.push([
                    r,
                    t
                ]);
            };
            function o() {
                if ("[" === t.getCurrent()) {
                    var r = t.substrUntilChar("]");
                    if (0 === r.length || r.indexOf("[", 1) >= 0) {
                        var n = t.grabUntil(function(r) {
                            return "[" === r;
                        });
                        return i($5b2b4251174e8275$var$e.WORD, n), void t.skip();
                    }
                    t.skip();
                    var o = t.grabUntil(function(r) {
                        return "]" === r;
                    });
                    return i($5b2b4251174e8275$var$e.TAG, o), void t.skip();
                }
                var u = t.grabUntil(function(r) {
                    return "[" === r;
                });
                i($5b2b4251174e8275$var$e.WORD, u);
            }
            return {
                tokenize: function() {
                    for(; t.hasNext();)o();
                    return n;
                }
            };
        })(r).tokenize(), n);
    }, [
        u,
        a,
        s
    ]);
    function f(n, e) {
        var i;
        if (void 0 !== n) return "string" == typeof n ? n : "object" == typeof n ? Array.isArray(n) ? n.map(function(r, n) {
            return f(r, "inline-styled-" + n.toString());
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(t, {
            style: (i = n.tag, a[i] || {}),
            key: e
        }, f(n.content)) : void 0;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(t, i, function(r) {
        return r.map(function(r, n) {
            return f(r, "inline-styled-" + n.toString());
        });
    }(c));
}
function $5b2b4251174e8275$export$6c251e5a19c78efa(r) {
    var n = r.children, t = r.removeUnknownTags, e = void 0 !== t && t, i = r.tagsStyle, o = void 0 === i ? {} : i;
    return $5b2b4251174e8275$var$a("span", function(r, n) {
        var t = {};
        for(var e in r)Object.prototype.hasOwnProperty.call(r, e) && n.indexOf(e) < 0 && (t[e] = r[e]);
        if (null != r && "function" == typeof Object.getOwnPropertySymbols) {
            var i = 0;
            for(e = Object.getOwnPropertySymbols(r); i < e.length; i++)n.indexOf(e[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, e[i]) && (t[e[i]] = r[e[i]]);
        }
        return t;
    }(r, [
        "children",
        "removeUnknownTags",
        "tagsStyle"
    ]), n, o, e);
}

});


parcelRegister("9lwgv", function(module, exports) {

$parcel$export(module.exports, "ShieldIcon", function () { return $2574148b413ebf5c$export$2d8598c0b89a07db; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $2574148b413ebf5c$export$2d8598c0b89a07db = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "75",
        height: "75",
        viewBox: "0 0 75 75",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M37.744 8h.52c.065.045.124.106.196.132 3.073 1.115 6.148 2.229 9.224 3.338 4.755 1.716 9.51 3.43 14.269 5.137.339.122.697.192 1.047.286V39.32c-.041.11-.114.22-.118.333-.047 1.286-.282 2.55-.574 3.794-1.042 4.442-3.124 8.362-6.198 11.754a31.94 31.94 0 0 1-4.536 4.134c-3.935 2.944-8.281 5.079-12.997 6.49-.151.046-.295.116-.443.175h-.26c-.02-.034-.035-.089-.063-.098-.944-.298-1.903-.553-2.83-.893-4.105-1.506-7.906-3.554-11.32-6.286-2.392-1.915-4.5-4.093-6.2-6.634-2.917-4.356-4.37-9.167-4.446-14.385-.03-2.083-.006-4.167-.006-6.25v-13.98c0-.507.005-.506.471-.674 3.222-1.161 6.441-2.327 9.664-3.485 4.58-1.645 9.164-3.283 13.744-4.929.294-.106.571-.256.856-.386",
                    fill: "#000"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M37.744 8h.52c.065.045.124.106.196.132 3.073 1.115 6.148 2.229 9.224 3.338 4.755 1.716 9.51 3.43 14.269 5.137.339.122.697.192 1.047.286V39.32c-.041.11-.114.22-.118.333-.047 1.286-.282 2.55-.574 3.794-1.042 4.442-3.124 8.362-6.198 11.754a31.94 31.94 0 0 1-4.536 4.134c-3.935 2.944-8.281 5.079-12.997 6.49-.151.046-.295.116-.443.175h-.26c-.02-.034-.035-.089-.063-.098-.944-.298-1.903-.553-2.83-.893-4.105-1.506-7.906-3.554-11.32-6.286-2.392-1.915-4.5-4.093-6.2-6.634-2.917-4.356-4.37-9.167-4.446-14.385-.03-2.083-.006-4.167-.006-6.25v-13.98c0-.507.005-.506.471-.674 3.222-1.161 6.441-2.327 9.664-3.485 4.58-1.645 9.164-3.283 13.744-4.929.294-.106.571-.256.856-.386",
                    fill: props.color ?? "#81C241",
                    opacity: ".93"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M37.947 66h-.259c-.02-.034-.034-.089-.063-.098-.936-.298-1.888-.553-2.809-.893-4.074-1.506-7.846-3.554-11.234-6.286-2.375-1.915-4.466-4.093-6.155-6.634-2.894-4.356-4.337-9.167-4.412-14.385-.03-2.083-.006-4.167-.006-6.25v-13.98c0-.507.005-.506.468-.674 3.197-1.161 6.393-2.327 9.592-3.485 4.546-1.645 9.095-3.283 13.64-4.929.292-.106.567-.256.85-.386h.255c.087 0 .279 57.941.133 58z",
                    fill: props.color ?? "#81C241"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M26.702 36.705a1.52 1.52 0 0 0-2.092 0 1.388 1.388 0 0 0 0 2.015l7.397 7.126a1.52 1.52 0 0 0 2.093 0L50.374 30.17a1.388 1.388 0 0 0 0-2.016 1.52 1.52 0 0 0-2.092 0L33.053 42.823l-6.351-6.118z",
                    fill: "#FFF",
                    fillRule: "nonzero",
                    stroke: "#FFF",
                    strokeWidth: ".5"
                })
            ]
        })
    });

});



parcelRegister("18F7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21e6121dc34e2bc1$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $elspu = parcelRequire("elspu");

var $3zcrz = parcelRequire("3zcrz");

var $9mhzx = parcelRequire("9mhzx");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $4fYE4 = parcelRequire("4fYE4");

var $7N0kU = parcelRequire("7N0kU");

var $yYT9n = parcelRequire("yYT9n");

var $4nDe7 = parcelRequire("4nDe7");

var $dvzf7 = parcelRequire("dvzf7");

var $amCCH = parcelRequire("amCCH");

var $22v9q = parcelRequire("22v9q");

var $i04qV = parcelRequire("i04qV");

var $ke9vw = parcelRequire("ke9vw");

var $e0mue = parcelRequire("e0mue");
const $21e6121dc34e2bc1$var$SKELETON_ACCOUNT_NUMBER = 4;
function $21e6121dc34e2bc1$export$2e2bcd8739ae039() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const history = (0, $NQIVp.useHistory)();
    const { client: client } = (0, $7N0kU.useClient)();
    const accounts = (0, $9mhzx.useAccounts)();
    const accountsLoading = (0, $3Ersk.useObservable)((0, $kqXxS.accountManager).loading);
    const [focusedAccount] = (0, $e0mue.useSelectedAccount)(accounts);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const groupedAccounts = (0, $3zcrz.groupByAccountType)(accounts);
    const goBackToClassicViewLinkTo = focusedAccount ? `${(0, $4fYE4.Path).AccountTransactions}?${0, $e0mue.ACCOUNT_QUERY_PARAM}=${focusedAccount.id}` : (0, $4fYE4.Path).AccountTransactions;
    return /*#__PURE__*/ (0, $4m918.jsxs)($21e6121dc34e2bc1$var$AccountsSection, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $amCCH.PageHeader), {
                title: formatMessage("accountsList.title"),
                children: /*#__PURE__*/ (0, $4m918.jsx)($21e6121dc34e2bc1$var$GoBackToClassicViewLink, {
                    to: goBackToClassicViewLinkTo,
                    children: formatMessage("allAccountsScreen.goBackClassicViewButton")
                })
            }),
            !accountsLoading && accounts.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)($21e6121dc34e2bc1$var$NoAccountAvailable, {
                children: formatMessage("allAccountsScreen.noAccountAvailable")
            }) : accountsLoading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $4nDe7.AccountListGrid), {
                children: (0, $k4Ecv.repeat)($21e6121dc34e2bc1$var$SKELETON_ACCOUNT_NUMBER, (index)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $i04qV.SkeletonAccountTile), {
                        $isRTL: isRTL
                    }, index))
            }) : groupedAccounts.map((groupedTypeAccounts)=>/*#__PURE__*/ (0, $4m918.jsxs)($21e6121dc34e2bc1$var$GroupAccountContainer, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($21e6121dc34e2bc1$var$AccountTypeText, {
                            children: formatMessage((0, $elspu.accountTypeLabelsWeb)[groupedTypeAccounts.type])
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $4nDe7.AccountListGrid), {
                            children: groupedTypeAccounts.data.map((groupedAccount, index)=>/*#__PURE__*/ (0, $4m918.jsx)($21e6121dc34e2bc1$var$StyledAccountTile, {
                                    onAccountClick: (account)=>(0, $ke9vw.navigateToAccountTransactions)(history, account.id),
                                    isActive: groupedAccount.id === focusedAccount?.id,
                                    account: groupedAccount,
                                    owner: client,
                                    withDetail: true
                                }, groupedAccount.id + index))
                        })
                    ]
                }, groupedTypeAccounts.type))
        ]
    });
}
const $21e6121dc34e2bc1$var$AccountsSection = (0, $jb8NR.default).section`
  align-self: stretch;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $21e6121dc34e2bc1$var$StyledAccountTile = (0, $jb8NR.default)((0, $i04qV.AccountTile))`
  text-align: left;
`;
const $21e6121dc34e2bc1$var$GoBackToClassicViewLink = (0, $jb8NR.default)((0, $dvzf7.TertiaryLink))`
  text-align: center;
`;
const $21e6121dc34e2bc1$var$NoAccountAvailable = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 20px;
`;
const $21e6121dc34e2bc1$var$GroupAccountContainer = (0, $jb8NR.default).div`
  width: 100%;
  margin-bottom: 10px;
`;
const $21e6121dc34e2bc1$var$AccountTypeText = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 1rem;
  color: #b1b1b1;
  margin-top: 16px;
  margin-bottom: 16px;
`;

});
parcelRegister("elspu", function(module, exports) {

$parcel$export(module.exports, "accountTypeLabels", function () { return $48351dcaa4a09613$export$e28afa4e5606353c; });
$parcel$export(module.exports, "accountTypeLabelsWeb", function () { return $48351dcaa4a09613$export$6cba41d9dbcb87da; });

var $kGswT = parcelRequire("kGswT");
const $48351dcaa4a09613$export$e28afa4e5606353c = {
    [(0, $kGswT.AccountType).Current]: "accountType.current",
    [(0, $kGswT.AccountType).Joint]: "accountType.joint",
    [(0, $kGswT.AccountType).Savings]: "accountType.savings",
    [(0, $kGswT.AccountType).Dedicated]: "accountType.dedicated",
    [(0, $kGswT.AccountType).MoneyPot]: "accountType.moneyPot",
    [(0, $kGswT.AccountType).Technical]: "accountType.technical"
};
const $48351dcaa4a09613$export$6cba41d9dbcb87da = {
    [(0, $kGswT.AccountType).Current]: "account.accountType.current",
    [(0, $kGswT.AccountType).Joint]: "account.accountType.joint",
    [(0, $kGswT.AccountType).Savings]: "account.accountType.savings",
    [(0, $kGswT.AccountType).Dedicated]: "account.accountType.dedicated",
    [(0, $kGswT.AccountType).MoneyPot]: "account.accountType.moneyPot",
    [(0, $kGswT.AccountType).Technical]: "account.accountType.technical"
};

});

parcelRegister("3zcrz", function(module, exports) {

$parcel$export(module.exports, "isJointAccount", function () { return $e5319b7f1dd0a800$export$bf16840866e57655; });
$parcel$export(module.exports, "retrieveCoOwner", function () { return $e5319b7f1dd0a800$export$c5f728c35d6680eb; });
$parcel$export(module.exports, "groupByAccountType", function () { return $e5319b7f1dd0a800$export$40feeb1a80fb2858; });

var $kGswT = parcelRequire("kGswT");
const $e5319b7f1dd0a800$export$bf16840866e57655 = (account)=>account.type === "CURRENT" && account.coOwners.length > 0;
const $e5319b7f1dd0a800$export$c5f728c35d6680eb = (account)=>account?.coOwners.filter((coOwner)=>coOwner.userId !== account?.userId)[0];
function $e5319b7f1dd0a800$export$40feeb1a80fb2858(accounts) {
    const accountsWithJoint = accounts.map((account)=>{
        if ($e5319b7f1dd0a800$export$bf16840866e57655(account)) return {
            ...account,
            type: "JOINT"
        };
        return account;
    });
    const accountsGroupByType = accountsWithJoint.reduce((acc, curr)=>{
        (acc[curr.type] = acc[curr.type] || []).push(curr);
        return acc;
    }, {});
    return Object.entries(accountsGroupByType).map((entry)=>({
            type: entry[0],
            data: entry[1]
        }));
}
const $e5319b7f1dd0a800$export$e238a77ea3a8cd66 = (account)=>{
    if (!account) return undefined;
    switch(account.status){
        case (0, $kGswT.AccountStatus).Blocked:
            return "accountDetailsScreen.accountStatus.blocked";
        case (0, $kGswT.AccountStatus).CreditBlocked:
            return "accountDetailsScreen.accountStatus.creditBlocked";
        case (0, $kGswT.AccountStatus).DebitBlocked:
            return "accountDetailsScreen.accountStatus.debitBlocked";
        default:
            return undefined;
    }
};
const $e5319b7f1dd0a800$export$9c3ee57c664156cd = (account)=>{
    if (!account) return undefined;
    switch(account.status){
        case (0, $kGswT.AccountStatus).Blocked:
            return "#ff6060";
        case (0, $kGswT.AccountStatus).CreditBlocked:
        case (0, $kGswT.AccountStatus).DebitBlocked:
            return "#ff6b21";
        default:
            return undefined;
    }
};

});

parcelRegister("4nDe7", function(module, exports) {

$parcel$export(module.exports, "AccountListGrid", function () { return $6d834ec357925740$export$920d1da99be1955e; });

var $jb8NR = parcelRequire("jb8NR");

var $7XqbX = parcelRequire("7XqbX");
const $6d834ec357925740$export$920d1da99be1955e = (0, $jb8NR.default).div`
  display: grid;
  width: 100%;
  grid-row-gap: 20px;
  grid-column-gap: 20px;

  grid-template-columns: repeat(auto-fill, ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_NOT_MOBILE}px);
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    grid-template-columns: repeat(auto-fill, ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_MOBILE}px);
  }
`;

});

parcelRegister("dvzf7", function(module, exports) {

$parcel$export(module.exports, "TertiaryButton", function () { return $57e0dacf3ee70675$export$3a30621a8b0c1490; });
$parcel$export(module.exports, "TertiaryLink", function () { return $57e0dacf3ee70675$export$bdae450cd9e14053; });
$parcel$export(module.exports, "TertiaryDiv", function () { return $57e0dacf3ee70675$export$c69b3423c35ba173; });

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");

var $bewhU = parcelRequire("bewhU");
const $57e0dacf3ee70675$var$commonStyle = (0, $jb8NR.css)`
  padding: 6px 17px;
  border-radius: 25px;
  background-color: #ececec;
  font-size: 0.8125rem;
  ${(0, $22v9q.theme).boldText};
  line-height: normal;
  color: #000000;

  &:focus,
  &:active,
  &:hover {
    background-color: #e2e2e2;
  }
  &:disabled {
    opacity: 0.5;
  }
`;
const $57e0dacf3ee70675$export$3a30621a8b0c1490 = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${$57e0dacf3ee70675$var$commonStyle};
`;
const $57e0dacf3ee70675$export$bdae450cd9e14053 = (0, $jb8NR.default)((0, $bewhU.DefaultLink))`
  ${$57e0dacf3ee70675$var$commonStyle};
`;
const $57e0dacf3ee70675$export$c69b3423c35ba173 = (0, $jb8NR.default).div`
  ${$57e0dacf3ee70675$var$commonStyle};
`;

});

parcelRegister("i04qV", function(module, exports) {

$parcel$export(module.exports, "AccountTile", function () { return $774cc8cd9487acd4$export$a64bc673ea05eeee; });
$parcel$export(module.exports, "RechargeableAccountTile", function () { return $774cc8cd9487acd4$export$44504645cec3f36f; });
$parcel$export(module.exports, "SkeletonAccountTile", function () { return $774cc8cd9487acd4$export$ae5b5a1ff2bd0842; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $elspu = parcelRequire("elspu");

var $3zcrz = parcelRequire("3zcrz");

var $2Rggt = parcelRequire("2Rggt");

var $2X4v0 = parcelRequire("2X4v0");

var $1TLtu = parcelRequire("1TLtu");

var $jGFoX = parcelRequire("jGFoX");

var $cG3cd = parcelRequire("cG3cd");

var $bQhUC = parcelRequire("bQhUC");

var $yYT9n = parcelRequire("yYT9n");

var $aj4dZ = parcelRequire("aj4dZ");

var $bZlaH = parcelRequire("bZlaH");

var $dvzf7 = parcelRequire("dvzf7");

var $5Wai4 = parcelRequire("5Wai4");

var $aeCtF = parcelRequire("aeCtF");

var $baGfh = parcelRequire("baGfh");

var $9BpLd = parcelRequire("9BpLd");

var $hw6wy = parcelRequire("hw6wy");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $68yql = parcelRequire("68yql");
function $774cc8cd9487acd4$export$a64bc673ea05eeee(props) {
    const { account: account, isActive: isActive, onAccountClick: onAccountClick, withDetail: withDetail, onUpdate: onUpdate, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const usualOrJointAccount = (0, $3zcrz.isJointAccount)(account) ? {
        ...account,
        type: (0, $kGswT.AccountType).Joint
    } : account;
    const [displayedAccountName, setDisplayedAccountName] = (0, $6uYXW.useState)(usualOrJointAccount.name);
    const onNameUpdated = (n)=>{
        setDisplayedAccountName(n);
    };
    const accountDetailsModalImpl = ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $68yql.AccountDetailsModal), {
            account: usualOrJointAccount,
            onNameUpdated: onNameUpdated,
            displayedAccountName: displayedAccountName
        });
    return /*#__PURE__*/ (0, $4m918.jsxs)($774cc8cd9487acd4$var$ClickableTile, {
        onClick: ()=>onAccountClick(usualOrJointAccount),
        $isRTL: isRTL,
        ...rest,
        children: [
            isActive && /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$ActiveMark, {
                $isRTL: isRTL
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$OwnerName, {
                children: usualOrJointAccount.type === (0, $kGswT.AccountType).Dedicated ? usualOrJointAccount.merchant ?? "" : displayedAccountName
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$AccountBalance, {
                amount: (0, $kGswT.getAvailableBalance)(usualOrJointAccount)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$StyledAccountType, {
                children: formatMessage(`account.${(0, $elspu.accountTypeLabels)[usualOrJointAccount.type]}`)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$AccountNumber, {
                children: formatMessage("account.accountId", {
                    id: usualOrJointAccount.id
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$AccountStatus, {
                account: usualOrJointAccount,
                $isRTL: isRTL
            }),
            withDetail && /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$DetailButton, {
                onClick: (e)=>{
                    e.stopPropagation();
                    (0, $5Wai4.Modal).present((0, $bQhUC.ACCOUNT_DETAIL_MODAL_ID), ()=>accountDetailsModalImpl(), {
                        canBeDismissed: false,
                        onUserDismiss: ()=>{
                            onUpdate?.();
                        }
                    });
                },
                $isRTL: isRTL,
                children: formatMessage("account.detail")
            })
        ]
    });
}
function $774cc8cd9487acd4$export$44504645cec3f36f(props) {
    const { owner: owner, account: account, onClick: onClick, ...rest } = props;
    const displayName = (0, $2Rggt.useClientDisplayName)(owner, true);
    const gender = owner?.gender ?? (0, $2X4v0.Gender).None;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { data: data } = (0, $cG3cd.useExternalAccounts)();
    const externalAccount = data?.[0];
    const externalAccountIBAN = externalAccount?.iban;
    const { hasRechargeByCard: hasRechargeByCard, hasBankToWallet: hasBankToWallet } = (0, $jGFoX.getAvailableRechargeMethod)(externalAccountIBAN);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($774cc8cd9487acd4$var$Tile, {
        $isRTL: isRTL,
        ...rest,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$OwnerName, {
                children: formatMessage((0, $1TLtu.nameWithGenderLabels)[gender], {
                    name: displayName
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$AccountBalance, {
                amount: (0, $kGswT.getSettlementBalance)(account)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$Spacer, {}),
            /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$AccountNumber, {
                children: formatMessage("account.accountId", {
                    id: account.id
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($774cc8cd9487acd4$var$RechargeMethodContainer, {
                $isRTL: isRTL,
                children: [
                    hasRechargeByCard && /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$IconContainer, {
                        $isRTL: isRTL,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $baGfh.RechargeCardIcon), {
                            fill: (0, $22v9q.theme).mainColor()
                        })
                    }),
                    hasBankToWallet && /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$IconContainer, {
                        $isRTL: isRTL,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $aeCtF.RechargeBankToWalletIcon), {
                            fill: (0, $22v9q.theme).mainColor()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($774cc8cd9487acd4$var$RechargeButton, {
                $isRTL: isRTL,
                children: [
                    formatMessage("recharge.rechargeButton"),
                    /*#__PURE__*/ (0, $4m918.jsx)($774cc8cd9487acd4$var$Chevron, {
                        $isRTL: isRTL
                    })
                ]
            })
        ]
    });
}
const $774cc8cd9487acd4$var$ClickableTile = (0, $jb8NR.default).div`
  appearance: none;
  outline: none;
  border: none;
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: auto;
  }
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_NOT_MOBILE}px;
  min-height: 188px;
  padding: ${(props)=>props.$isRTL ? "26px 31px 26px 22px" : "26px 22px 26px 31px"};
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  background-color: #ffffff;
  color: #000000;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_MOBILE}px;
  }
`;
const $774cc8cd9487acd4$var$Tile = (0, $jb8NR.default)($774cc8cd9487acd4$var$ClickableTile)`
  &:hover {
    cursor: auto;
  }
`;
const $774cc8cd9487acd4$export$ae5b5a1ff2bd0842 = (0, $jb8NR.default)($774cc8cd9487acd4$var$ClickableTile)`
  ${(0, $hw6wy.AnimatedSkeletonStyle)};
`;
const $774cc8cd9487acd4$var$ActiveMark = (0, $jb8NR.default).div`
  position: absolute;
  top: 38px;
  left: ${(props)=>props.$isRTL ? "unset" : 0};
  right: ${(props)=>props.$isRTL ? 0 : "unset"};
  width: 6px;
  height: 112px;
  border-radius: 3px;
  background-color: ${(0, $22v9q.theme).mainColor};
`;
const $774cc8cd9487acd4$var$OwnerName = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).text};
  margin-bottom: 3px;
  margin-right: 68px;
  text-align: start;
`;
const $774cc8cd9487acd4$var$AccountBalance = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  font-size: 1.25rem;
  ${(0, $22v9q.theme).boldText};
  margin-bottom: 33px;
  text-align: start;
`;
const $774cc8cd9487acd4$var$StyledAccountType = (0, $jb8NR.default).span`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
  margin-bottom: 4px;
  text-align: start;
`;
const $774cc8cd9487acd4$var$AccountNumber = (0, $jb8NR.default).span`
  font-size: 0.8125rem;
  ${(0, $22v9q.theme).boldText};
  color: #b1b1b1;
  padding-bottom: 14px;
  word-break: break-all;
  text-align: start;
`;
const $774cc8cd9487acd4$var$AccountStatus = (0, $jb8NR.default)((0, $aj4dZ.AccountStatusView))`
  position: absolute;
  right: ${(props)=>props.$isRTL ? "unset" : "15px"};
  left: ${(props)=>props.$isRTL ? "15px" : "unset"};

  bottom: 15px;
`;
const $774cc8cd9487acd4$var$DetailButton = (0, $jb8NR.default)((0, $dvzf7.TertiaryButton))`
  position: absolute;
  right: ${(props)=>props.$isRTL ? "unset" : "15px"};
  left: ${(props)=>props.$isRTL ? "15px" : "unset"};
  top: 15px;
`;
const $774cc8cd9487acd4$var$RechargeMethodContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: ${(props)=>props.$isRTL ? "unset" : "15px"};
  left: ${(props)=>props.$isRTL ? "15px" : "unset"};
  top: 15px;
`;
const $774cc8cd9487acd4$var$IconContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 8px;
  background-color: ${()=>(0, $22v9q.theme).mainColorLightBackground()};
  &:not(:last-of-type) {
    margin-right: ${(props)=>props.$isRTL ? 0 : 10}px;
    margin-left: ${(props)=>props.$isRTL ? 10 : 0}px;
  }
`;
const $774cc8cd9487acd4$var$RechargeButton = (0, $jb8NR.default)((0, $dvzf7.TertiaryButton))`
  position: absolute;
  display: flex;
  justify-content: center;
  right: ${(props)=>props.$isRTL ? "unset" : "15px"};
  left: ${(props)=>props.$isRTL ? "15px" : "unset"};
  bottom: 35px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    bottom: 70px;
  }
`;
const $774cc8cd9487acd4$var$Spacer = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
`;
const $774cc8cd9487acd4$var$Chevron = (0, $jb8NR.default)((0, $9BpLd.SmallChevronIcon))`
  margin-left: ${(props)=>props.$isRTL ? -4 : 4}px;
  margin-right: ${(props)=>props.$isRTL ? 4 : -4}px;
`;

});
parcelRegister("2X4v0", function(module, exports) {

$parcel$export(module.exports, "Gender", function () { return $c0279f9b6dfeb692$export$d549c77c8a078892; });
var $c0279f9b6dfeb692$export$d549c77c8a078892 = /*#__PURE__*/ function(Gender) {
    Gender["Male"] = "MALE";
    Gender["Female"] = "FEMALE";
    Gender["Other"] = "OTHER";
    Gender["None"] = "NONE";
    return Gender;
}({});

});

parcelRegister("1TLtu", function(module, exports) {

$parcel$export(module.exports, "nameWithGenderLabels", function () { return $79c1addcb347147a$export$a1583486b7070c8b; });

var $2X4v0 = parcelRequire("2X4v0");
const $79c1addcb347147a$export$a1583486b7070c8b = {
    [(0, $2X4v0.Gender).Male]: "accountOwner.male",
    [(0, $2X4v0.Gender).Female]: "accountOwner.female",
    [(0, $2X4v0.Gender).Other]: "accountOwner.other",
    [(0, $2X4v0.Gender).None]: "accountOwner.none"
};

});

parcelRegister("jGFoX", function(module, exports) {

$parcel$export(module.exports, "getAvailableRechargeMethod", function () { return $a96ff420a4e3f3d8$export$164467c3b449a772; });

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");
const $a96ff420a4e3f3d8$export$164467c3b449a772 = (externalAccountIBAN)=>{
    const features = (0, $kqXxS.featuresManager).features.get();
    const hasBankToWallet = features.bankToWallet && (0, $gDlNU.isDefined)(externalAccountIBAN);
    const hasRechargeByCard = features.walletRechargeByCard;
    return {
        hasRechargeByCard: hasRechargeByCard,
        hasBankToWallet: hasBankToWallet
    };
};

});

parcelRegister("cG3cd", function(module, exports) {

$parcel$export(module.exports, "useExternalAccounts", function () { return $df152af974c5258b$export$e5e86f91ed2f815f; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
function $df152af974c5258b$export$e5e86f91ed2f815f() {
    const [refreshing, setRefreshing] = (0, $6uYXW.useState)(false);
    const rawData = (0, $3Ersk.useObservable)((0, $kqXxS.externalAccountManager).externalAccounts);
    const loading = (0, $3Ersk.useObservable)((0, $kqXxS.externalAccountManager).loading);
    const error = (0, $3Ersk.useObservable)((0, $kqXxS.externalAccountManager).error);
    const loadingMore = (0, $3Ersk.useObservable)((0, $kqXxS.externalAccountManager).loadingMore);
    const loadingMoreError = (0, $3Ersk.useObservable)((0, $kqXxS.externalAccountManager).loadingMoreError);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await (0, $kqXxS.externalAccountManager).load();
    }, []);
    const refresh = (0, $6uYXW.useCallback)(async ()=>{
        setRefreshing(true);
        await (0, $kqXxS.externalAccountManager).load(true);
        setRefreshing(false);
    }, []);
    const canLoadMore = (0, $6uYXW.useMemo)(()=>(rawData?.offset ?? 0) + (rawData?.limit ?? 0) < (rawData?.total ?? 0), [
        rawData?.offset,
        rawData?.limit,
        rawData?.total
    ]);
    const data = (0, $6uYXW.useMemo)(()=>rawData?.items ?? [], [
        rawData?.items
    ]);
    const loadMore = (0, $6uYXW.useCallback)(async ()=>{
        await (0, $kqXxS.externalAccountManager).loadMore();
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        canLoadMore: canLoadMore,
        loadingMore: loadingMore,
        loadingMoreError: loadingMoreError,
        refreshing: refreshing,
        loadMore: loadMore,
        refresh: refresh
    };
}

});

parcelRegister("aj4dZ", function(module, exports) {

$parcel$export(module.exports, "AccountStatusView", function () { return $9ede72ec02ffb87b$export$da181d308ed08d4d; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $8eBGe = parcelRequire("8eBGe");

var $39ngP = parcelRequire("39ngP");

var $22v9q = parcelRequire("22v9q");
const $9ede72ec02ffb87b$export$da181d308ed08d4d = ({ account: account, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    if (account.status === (0, $kGswT.AccountStatus).Opened) return null;
    const statusColor = (0, $8eBGe.statusColors)[account.status];
    return /*#__PURE__*/ (0, $4m918.jsxs)($9ede72ec02ffb87b$var$StatusContainer, {
        color: statusColor,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($9ede72ec02ffb87b$var$StatusDot, {
                color: statusColor
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($9ede72ec02ffb87b$var$StatusLabel, {
                color: statusColor,
                children: formatMessage(`${(0, $8eBGe.statusLabels)[account.status]}`)
            })
        ]
    });
};
const $9ede72ec02ffb87b$var$StatusContainer = (0, $jb8NR.default).div`
  background-color: ${(props)=>(0, $39ngP.colorWithOpacity)(props.color, 0.2)};
  border-radius: 13px;
  padding: 4px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $9ede72ec02ffb87b$var$StatusDot = (0, $jb8NR.default).div`
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: ${(props)=>props.color};
  margin-right: 4px;
`;
const $9ede72ec02ffb87b$var$StatusLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  font-size: 0.625rem;
  color: ${(props)=>props.color};
`;

});
parcelRegister("8eBGe", function(module, exports) {

$parcel$export(module.exports, "statusLabels", function () { return $193586dd0e517dbb$export$5fa319c5b92df2f; });
$parcel$export(module.exports, "statusColors", function () { return $193586dd0e517dbb$export$6881c75116d5bd6e; });

var $kGswT = parcelRequire("kGswT");
const $193586dd0e517dbb$export$5fa319c5b92df2f = {
    [(0, $kGswT.AccountStatus).Opened]: "accountStatus.opened",
    [(0, $kGswT.AccountStatus).Closed]: "accountStatus.closed",
    [(0, $kGswT.AccountStatus).Blocked]: "accountStatus.blocked",
    [(0, $kGswT.AccountStatus).DebitBlocked]: "accountStatus.debitBlocked",
    [(0, $kGswT.AccountStatus).CreditBlocked]: "accountStatus.creditBlocked"
};
const $193586dd0e517dbb$export$6881c75116d5bd6e = {
    [(0, $kGswT.AccountStatus).Opened]: "transparent",
    [(0, $kGswT.AccountStatus).Closed]: "#ff4242",
    [(0, $kGswT.AccountStatus).Blocked]: "#ff4242",
    [(0, $kGswT.AccountStatus).DebitBlocked]: "#ff6b21",
    [(0, $kGswT.AccountStatus).CreditBlocked]: "#ff6b21"
};

});


parcelRegister("aeCtF", function(module, exports) {

$parcel$export(module.exports, "RechargeBankToWalletIcon", function () { return $05d5ecf63f828a5f$export$fdef4b7b3c0a3b5e; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $05d5ecf63f828a5f$export$fdef4b7b3c0a3b5e(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "18",
        height: "18",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("g", {
            fill: props.fill,
            fillRule: "nonzero",
            children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M11.992 9.418h1.339v3.207h-1.34zM9.456 9.418h1.339v3.207h-1.34zM6.92 9.418h1.339v3.207h-1.34zM4.383 9.418h1.34v3.207h-1.34zM13.777 8.414v-.335h-9.84v.335c0 .185.15.335.335.335h9.17c.185 0 .335-.15.335-.335zM14.236 13.295H3.478a.335.335 0 0 0-.335.334v.893c0 .185.15.335.335.335h10.758c.185 0 .335-.15.335-.335v-.893a.335.335 0 0 0-.335-.334zM3.478 7.41h10.759a.335.335 0 0 0 .175-.62l-5.38-3.312a.335.335 0 0 0-.35 0L3.302 6.79a.335.335 0 0 0 .176.62zM8.63 5.397h.455a.335.335 0 1 1 0 .67H8.63a.335.335 0 1 1 0-.67z"
            })
        })
    });
}

});

parcelRegister("baGfh", function(module, exports) {

$parcel$export(module.exports, "RechargeCardIcon", function () { return $8975e964cbfa33da$export$92c2f6d7cd69e292; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $8975e964cbfa33da$export$92c2f6d7cd69e292(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 16 16",
        width: "16",
        height: "16",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M0 0h15.714v15.714H0z"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M3.681 3.222c-.865 0-1.566.701-1.566 1.566v1.044H13.6V4.788a1.566 1.566 0 0 0-1.566-1.566H3.681zM13.6 6.876H2.115v4.176a1.566 1.566 0 0 0 1.566 1.565h8.352a1.566 1.566 0 0 0 1.566-1.565V6.876zm-8.946 4.243h1.793a.792.792 0 0 0 .79-.79.792.792 0 0 0-.79-.79H4.653a.792.792 0 0 0-.79.79.792.792 0 0 0 .79.79z",
                    fill: props.fill
                })
            ]
        })
    });
}

});

parcelRegister("9BpLd", function(module, exports) {

$parcel$export(module.exports, "SmallChevronIcon", function () { return $54c7a58c24cc26f5$export$1debc4c39842460b; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $54c7a58c24cc26f5$export$1debc4c39842460b(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 12 12",
        width: "12",
        height: "12",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M0 12V0h12v12z"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "m4.516 10.615-.824-.84 3.47-3.544-3.47-3.544.824-.84L8.307 5.72a.73.73 0 0 1 0 1.022l-3.791 3.873z",
                    fill: props.color ?? "#000"
                })
            ]
        })
    });
}

});

parcelRegister("hw6wy", function(module, exports) {

$parcel$export(module.exports, "AnimatedSkeletonStyle", function () { return $8fa416b036a51821$export$4d6f5c1d34adfa3d; });

var $jb8NR = parcelRequire("jb8NR");
const $8fa416b036a51821$var$loadingAnimation = (0, $jb8NR.keyframes)`
	0%{background-position:0% 0%}
	100%{background-position:89% 89%}
`;
const $8fa416b036a51821$export$4d6f5c1d34adfa3d = (0, $jb8NR.css)`
  background: linear-gradient(313deg, #e8e8e8, #ffffff, #e8e8e8, #ffffff);
  background-position: 100% 100%;
  background-size: 400% 400%;
  animation: ${$8fa416b036a51821$var$loadingAnimation} ease-in-out infinite 1s;
`;

});

parcelRegister("68yql", function(module, exports) {

$parcel$export(module.exports, "AccountDetailsModal", function () { return $f39f0055a87f9384$export$93bbbe8d044ee29; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $h2P2T = parcelRequire("h2P2T");

var $5P656 = parcelRequire("5P656");

var $jO1Lj = parcelRequire("jO1Lj");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $8eBGe = parcelRequire("8eBGe");

var $elspu = parcelRequire("elspu");

var $3zcrz = parcelRequire("3zcrz");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $k73b6 = parcelRequire("k73b6");

var $bQhUC = parcelRequire("bQhUC");

var $1qRJe = parcelRequire("1qRJe");

var $aj4dZ = parcelRequire("aj4dZ");

var $bZlaH = parcelRequire("bZlaH");

var $iy3Ex = parcelRequire("iy3Ex");

var $kQgvS = parcelRequire("kQgvS");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $6OTGa = parcelRequire("6OTGa");

var $aihh2 = parcelRequire("aihh2");

var $dS30h = parcelRequire("dS30h");

var $hSCKm = parcelRequire("hSCKm");

var $jIu9M = parcelRequire("jIu9M");

var $iVSHW = parcelRequire("iVSHW");
const $f39f0055a87f9384$export$93bbbe8d044ee29 = (props)=>{
    const { account: account, onNameUpdated: onNameUpdated, displayedAccountName: displayedAccountName } = props;
    const { formatMessage: formatMessage, formatDate: formatDate, formatAmount: formatAmount } = (0, $5hpYi.useIntl)();
    const [authorizedOverdraft, setAuthorizedOverdraft] = (0, $6uYXW.useState)(null);
    const [authorizedOverdraftValue, setAuthorizedOverdraftValue] = (0, $6uYXW.useState)(null);
    const [validityDate, setValidityDate] = (0, $6uYXW.useState)(null);
    const statusMessage = $f39f0055a87f9384$var$statusMessageKey(account.status);
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const savingsDetails = (0, $3Ersk.useObservable)((0, $kqXxS.savingsManager).savingDetails);
    const accountIsSavings = account?.type === "SAVINGS";
    const userLanguage = (0, $3Ersk.useObservable)((0, $kqXxS.i18NManager).localeTag);
    const [setAccountNameEditing] = (0, $6uYXW.useState)(false);
    const [accountNameValue, setAccountNameValue] = (0, $6uYXW.useState)(displayedAccountName);
    const [success, setSuccess] = (0, $6uYXW.useState)("");
    const [error, setError] = (0, $6uYXW.useState)("");
    const productName = (0, $1qRJe.getAccountProductName)({
        accountIsSavings: accountIsSavings,
        savingsDetails: savingsDetails,
        userLanguage: userLanguage,
        accountTypeLabelsWeb: $elspu.accountTypeLabelsWeb,
        accountType: account?.type,
        formatMessage: formatMessage
    });
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (accountIsSavings) await (0, $kqXxS.savingsManager).getSavingsDetails(account.id);
        setAccountNameValue(displayedAccountName);
    }, [
        account,
        displayedAccountName
    ]);
    (0, $6uYXW.useEffect)(()=>{
        onNameUpdated(accountNameValue);
    }, [
        accountNameValue
    ]);
    (0, $6uYXW.useEffect)(()=>{
        const fetchOverdraftDetails = async ()=>{
            try {
                const response = await (0, $kqXxS.accountManager).fetchAuthorizedOverdraft(account.id);
                const { authorizedOverdraft: fetchedAuthorizedOverdraft, validityDate: fetchedValidityDate, authorizedOverdraftValue: fetchAuthorizedOverdraftValue } = response;
                setAuthorizedOverdraft(fetchedAuthorizedOverdraft);
                setAuthorizedOverdraftValue(fetchAuthorizedOverdraftValue);
                setValidityDate(fetchedValidityDate);
                if ((0, $k73b6.isDateInPast)(fetchedValidityDate)) setAuthorizedOverdraft(null);
            } catch (e) {
                // The overdraft is optional data served by the savings API: tenants without it fail here,
                // and console.error would raise the dev error overlay over a case that is expected.
                (0, $6JVVB.logger).debug("AccountDetailsModal", "Failed to fetch overdraft details", e);
            }
        };
        fetchOverdraftDetails();
    }, [
        account.id
    ]);
    const handleAccountNameUpdate = (name)=>{
        setSuccess("");
        setError("");
        setAccountNameValue(name);
    };
    const handleSubmitAccountNameUpdate = ()=>{
        if (accountNameValue !== account.name) (0, $kqXxS.accountManager).updateAccountName(account.id, accountNameValue).then((res)=>{
            setSuccess(formatMessage("accountDetails.success"));
        }).catch((e)=>{
            setError(e.response.data.message);
        });
    };
    const coOwner = (0, $3zcrz.retrieveCoOwner)(account);
    const hasMaximumValue = !!savingsDetails?.product?.balanceBoundaries?.maximum?.value;
    return /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$AccountDetailsModalContainer, {
        className: "account-modal-container",
        contentClassName: "content",
        closeButton: true,
        id: (0, $bQhUC.ACCOUNT_DETAIL_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$ContentContainer, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$AccountTypeText, {
                    children: productName
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$AccountDetailsModalContent, {
                    className: "scroll-container-without-shadow",
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledAccountStatus, {
                            account: account
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$AccountAvailableBalanceContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$AccountAvailableBalanceTitle, {
                                    children: formatMessage("accountDetails.availableBalanceTitle")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$AccountAvailableBalance, {
                                    amount: (0, $kGswT.getAvailableBalance)(account)
                                })
                            ]
                        }),
                        statusMessage && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatusMessage, {
                            color: (0, $8eBGe.statusColors)[account.status],
                            children: formatMessage(statusMessage)
                        }),
                        account.type === (0, $kGswT.AccountType).Dedicated && (0, $gDlNU.isDefined)(account.merchant) ? /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$DedicatedAccountContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$DedicatedAccountMessage, {
                                    children: formatMessage("accountDetails.dedicatedMessage")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$DedicatedAccountMerchant, {
                                    children: account.merchant
                                })
                            ]
                        }) : null,
                        (error.length > 0 || !!authorizedOverdraft && (0, $h2P2T.isOverdraftMatchingBalance)(account, authorizedOverdraftValue)) && /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$ErrorMessageContainer, {
                            children: [
                                error.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$ErrorMessage, {
                                    children: error
                                }),
                                !!authorizedOverdraft && (0, $h2P2T.isOverdraftMatchingBalance)(account, authorizedOverdraftValue) && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$ErrorMessage, {
                                    children: formatMessage("accountDetails.reachedOverdraftMessage")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$DedicatedAccountContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$AccountBalanceTitleContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$AccountBalanceTitle, {
                                            children: formatMessage("accountDetails.balanceTitle")
                                        }),
                                        /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$AccountBalance, {
                                            amount: (0, $kGswT.getSettlementBalance)(account)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$AccountBalanceMessage, {
                                    children: formatMessage("accountDetails.balanceMessage")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$InformationContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                    title: formatMessage("accountDetails.accountName"),
                                    value: accountNameValue || "",
                                    editAction: features.sdaAccountsNameUpdate ? ()=>setAccountNameEditing(true) : null,
                                    input: {
                                        type: (0, $jO1Lj.FormInputType).Text,
                                        id: "accountName",
                                        label: "Account Name",
                                        value: accountNameValue
                                    },
                                    onEditChange: (name)=>handleAccountNameUpdate(name),
                                    onEnterPressed: handleSubmitAccountNameUpdate,
                                    onBlur: handleSubmitAccountNameUpdate,
                                    successLabel: success,
                                    errorLabel: error
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                    title: formatMessage("accountDetails.accountIdTitle"),
                                    value: account.id
                                }),
                                coOwner && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                    title: formatMessage("accountDetails.coOwnerTitle"),
                                    value: coOwner.ownerName
                                }),
                                !accountIsSavings && (0, $gDlNU.isDefined)(account.iban) && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                    title: formatMessage("accountDetails.ibanTitle"),
                                    value: account.iban
                                }),
                                !accountIsSavings && (0, $gDlNU.isDefined)(account.bic) && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                    title: formatMessage("accountDetails.bicTitle"),
                                    value: account.bic
                                }),
                                !accountIsSavings && authorizedOverdraft !== null && /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$AuthorizedOverdraftContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                            noCopy: true,
                                            title: formatMessage("accountDetails.authorizedOverdraftTitle"),
                                            value: String(authorizedOverdraft ?? formatMessage("noDataAvailable"))
                                        }),
                                        validityDate && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$ValidityDateText, {
                                            children: formatMessage("accountDetails.validityDate", {
                                                date: formatDate(validityDate, {
                                                    month: "long",
                                                    day: "numeric",
                                                    year: "numeric"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                accountIsSavings && savingsDetails?.startDate && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                    title: formatMessage("accountDetails.accountStartDate"),
                                    value: formatDate(savingsDetails.startDate, {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "2-digit"
                                    }),
                                    noCopy: true
                                }),
                                accountIsSavings && hasMaximumValue && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                    title: formatMessage("accountDetails.maximumBoundaries"),
                                    value: formatAmount(savingsDetails.product?.balanceBoundaries.maximum)
                                }),
                                (0, $gDlNU.isDefined)(account.externalData) && Object.entries(account.externalData).map(([title, value], index)=>/*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledClipboardInformationRow, {
                                        title: title,
                                        value: value
                                    }, index))
                            ]
                        }),
                        accountIsSavings && savingsDetails.initialAmount && /*#__PURE__*/ (0, $4m918.jsx)((0, $dS30h.CollapsableRowsSection), {
                            rows: [
                                {
                                    title: formatMessage("accountDetails.initialAmountLabel"),
                                    value: formatAmount(new (0, $5P656.Amount)(savingsDetails.initialAmount.amount, savingsDetails.initialAmount.currency))
                                },
                                {
                                    title: formatMessage("accountDetails.endDateLabel"),
                                    value: formatDate(savingsDetails.endDate, {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "2-digit"
                                    })
                                },
                                {
                                    title: formatMessage("accountDetails.durationLabel"),
                                    value: `${savingsDetails.durationValue} ${formatMessage(`accountDetails.monthsLabels.${savingsDetails.cycleFrequency}`)}`
                                }
                            ],
                            accountIsSavings: true
                        }),
                        accountIsSavings && savingsDetails.product?.index?.rate?.value && savingsDetails.product?.index?.rate?.type && /*#__PURE__*/ (0, $4m918.jsx)((0, $dS30h.CollapsableRowsSection), {
                            rows: [
                                {
                                    title: formatMessage("accountDetails.rateValueLabel"),
                                    value: `${savingsDetails.product?.index?.rate?.value} % (${savingsDetails.product.index?.rate?.type})`
                                },
                                {
                                    title: formatMessage("accountDetails.indexCodeLabel"),
                                    value: savingsDetails.product?.index?.code
                                },
                                {
                                    title: formatMessage("accountDetails.rateStartDateLabel"),
                                    value: formatDate(savingsDetails.product?.index?.rate?.startDate, {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "2-digit"
                                    })
                                }
                            ],
                            accountIsSavings: true
                        }),
                        accountIsSavings && savingsDetails.accruedInterests && /*#__PURE__*/ (0, $4m918.jsx)((0, $dS30h.CollapsableRowsSection), {
                            rows: [
                                {
                                    title: formatMessage("accountDetails.accruedInterestsLabel"),
                                    value: formatAmount(new (0, $5P656.Amount)(savingsDetails.accruedInterests?.amount, savingsDetails.accruedInterests?.currency))
                                },
                                {
                                    title: formatMessage("accountDetails.startDateLabel"),
                                    value: formatDate(savingsDetails.startDate, {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "2-digit"
                                    })
                                },
                                {
                                    title: formatMessage("accountDetails.forecastInterestsLabel"),
                                    value: formatAmount(new (0, $5P656.Amount)(savingsDetails.forecastInterests?.amount, savingsDetails.forecastInterests?.currency))
                                },
                                {
                                    title: formatMessage("accountDetails.initialAERLabel"),
                                    value: `${(+savingsDetails.initialAer * 100).toFixed(2)} %`
                                }
                            ],
                            accountIsSavings: true
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("div", {
                            style: {
                                marginTop: 20
                            }
                        }),
                        features.sdaAccountView && (0, $gDlNU.isDefined)(account.iban) && /*#__PURE__*/ (0, $4m918.jsx)((0, $hSCKm.DownloadBankAccountDetails), {
                            account: account
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$export$2af1cab00121fb14, {
                            account: account
                        }),
                        accountIsSavings && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$export$f18e3cad4590f52a, {
                            account: account
                        }),
                        !accountIsSavings && /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$export$8d96cb331c945a00, {
                            account: account
                        })
                    ]
                })
            ]
        })
    });
};
const $f39f0055a87f9384$export$2af1cab00121fb14 = (props)=>{
    const { account: account } = props;
    const [statements, setStatements] = (0, $6uYXW.useState)(null);
    (0, $6uYXW.useEffect)(()=>{
        (0, $kqXxS.accountStatementService).fetchStatements(account.id).then((result)=>setStatements(result));
    }, [
        account.id
    ]);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    if (statements === null) return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("accountsStatements.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$SpinnerContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {})
            })
        ]
    });
    else if (statements.items.length > 0) return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("accountsStatements.title")
            }),
            features.sdaAccountView ? /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledGenerateAccountButton, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $6OTGa.GenerateAccountStatementButton), {
                    accountId: account.id
                })
            }) : null,
            statements.items.map((it)=>/*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledStatementRow, {
                    statement: it,
                    account: account
                }, it.id))
        ]
    });
    return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("accountsStatements.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$NoStatementAvailable, {
                children: formatMessage("accountsStatements.emptyStatementList")
            })
        ]
    });
};
const $f39f0055a87f9384$export$8d96cb331c945a00 = (props)=>{
    const { account: account } = props;
    const [statements, setStatements] = (0, $6uYXW.useState)(null);
    (0, $6uYXW.useEffect)(()=>{
        (0, $kqXxS.accountStatementService).fetchFeesStatements(account.id).then((result)=>setStatements(result));
    }, [
        account.id
    ]);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    if (statements === null) return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("feesStatements.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$SpinnerContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {})
            })
        ]
    });
    else if (statements.items.length > 0) return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("feesStatements.title")
            }),
            statements.items.map((it)=>/*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledStatementRow, {
                    variant: "fee",
                    statement: it,
                    account: account
                }, it.id))
        ]
    });
    return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("feesStatements.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$NoStatementAvailable, {
                children: formatMessage("feesStatements.emptyStatementList")
            })
        ]
    });
};
const $f39f0055a87f9384$export$f18e3cad4590f52a = (props)=>{
    const { account: account } = props;
    const [statements, setStatements] = (0, $6uYXW.useState)(null);
    (0, $6uYXW.useEffect)(()=>{
        (0, $kqXxS.savingsService).getTaxStatements(account.userId).then((result)=>setStatements(result));
    }, [
        account.id
    ]);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    if (statements === null) return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("taxStatements.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$SpinnerContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {})
            })
        ]
    });
    else if (statements.items.length > 0) return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("taxStatements.title")
            }),
            statements.items.map((it)=>/*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StyledTaxStatementRow, {
                    variant: "fee",
                    statement: it,
                    account: account
                }, it.documentId))
        ]
    });
    return /*#__PURE__*/ (0, $4m918.jsxs)($f39f0055a87f9384$var$StatementContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$StatementTitle, {
                children: formatMessage("taxStatements.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f39f0055a87f9384$var$NoStatementAvailable, {
                children: formatMessage("taxStatements.emptyStatementList")
            })
        ]
    });
};
const $f39f0055a87f9384$var$statusMessageKey = (status)=>{
    switch(status){
        case (0, $kGswT.AccountStatus).Blocked:
            return "accountDetails.accountStatus.blocked";
        case (0, $kGswT.AccountStatus).CreditBlocked:
            return "accountDetails.accountStatus.creditBlocked";
        case (0, $kGswT.AccountStatus).DebitBlocked:
            return "accountDetails.accountStatus.debitBlocked";
        default:
            return undefined;
    }
};
const $f39f0055a87f9384$var$AccountDetailsModalContainer = (0, $jb8NR.default)((0, $iy3Ex.RoundedModalContainer))`
  &.account-modal-container {
    margin-top: 10vh;
  }
  .content {
    width: 600px;
  }
`;
const $f39f0055a87f9384$var$AccountDetailsModalContent = (0, $jb8NR.default)((0, $kQgvS.ScrollableDiv))`
  &.scroll-container-without-shadow {
    &::before,
    &::after {
      display: none;
    }
  }
`;
const $f39f0055a87f9384$var$ContentContainer = (0, $jb8NR.default).div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin-top: 30px;
  width: 100%;
  height: 710px;
`;
const $f39f0055a87f9384$var$AccountTypeText = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  margin-left: 30px;
  margin-bottom: 20px;
`;
const $f39f0055a87f9384$var$StyledAccountStatus = (0, $jb8NR.default)((0, $aj4dZ.AccountStatusView))`
  position: absolute;
  right: 15px;
  top: 0;
`;
const $f39f0055a87f9384$var$AccountAvailableBalanceContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  align-self: stretch;
`;
const $f39f0055a87f9384$var$AccountAvailableBalanceTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 1rem;
  color: #b1b1b1;
`;
const $f39f0055a87f9384$var$AccountAvailableBalance = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  font-size: 2rem;
  ${(0, $22v9q.theme).boldText};
  margin-top: 5px;
`;
const $f39f0055a87f9384$var$StatusMessage = (0, $jb8NR.default).div`
  color: ${(props)=>props.color};
  text-align: center;
  font-size: 0.875rem;
  ${(0, $22v9q.theme).mediumText}
  margin: 30px 30px 0 30px;
`;
const $f39f0055a87f9384$var$DedicatedAccountContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  ${(0, $22v9q.shadows).medium};
  margin: 15px 20px 15px 20px;
  padding: 25px 15px 25px 15px;
  border-radius: 13px;
  align-items: center;
`;
const $f39f0055a87f9384$var$DedicatedAccountMessage = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  font-size: 1rem;
  color: #b1b1b1;
  text-align: center;
`;
const $f39f0055a87f9384$var$DedicatedAccountMerchant = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.875rem;
  color: ${(0, $22v9q.theme).mainColor};
`;
const $f39f0055a87f9384$var$AccountBalanceTitleContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: stretch;
  margin-bottom: 10px;
`;
const $f39f0055a87f9384$var$AccountBalanceTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
`;
const $f39f0055a87f9384$var$AccountBalance = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).boldText};
  color: ${(0, $22v9q.theme).mainColor};
`;
const $f39f0055a87f9384$var$AccountBalanceMessage = (0, $jb8NR.default).span`
  text-align: center;
  color: #b1b1b1;
  font-size: 0.875rem;
`;
const $f39f0055a87f9384$var$InformationContainer = (0, $jb8NR.default).div`
  padding: 0 30px 30px 30px;
`;
const $f39f0055a87f9384$var$AuthorizedOverdraftContainer = (0, $jb8NR.default).div`
  padding: 10px 0 0;
`;
const $f39f0055a87f9384$var$StyledClipboardInformationRow = (0, $jb8NR.default)((0, $aihh2.ClipboardInformationRow))`
  &:not(:last-of-type) {
    margin-bottom: 15px;
  }
`;
const $f39f0055a87f9384$var$StatementContainer = (0, $jb8NR.default).div`
  padding: 0 30px 40px 30px;
`;
const $f39f0055a87f9384$var$StatementTitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.125rem;
  margin-bottom: 15px;
`;
const $f39f0055a87f9384$var$StyledStatementRow = (0, $jb8NR.default)((0, $jIu9M.StatementRow))`
  padding: 15px 15px 15px 15px;
  ${(0, $22v9q.shadows).medium};
  border-radius: 13px;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;
const $f39f0055a87f9384$var$StyledTaxStatementRow = (0, $jb8NR.default)((0, $iVSHW.TaxStatementRow))`
  padding: 15px 15px 15px 15px;
  ${(0, $22v9q.shadows).medium};
  border-radius: 13px;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;
const $f39f0055a87f9384$var$NoStatementAvailable = (0, $jb8NR.default).span`
  font-size: 0.9375rem;
  color: #b1b1b1;
`;
const $f39f0055a87f9384$var$SpinnerContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const $f39f0055a87f9384$var$StyledGenerateAccountButton = (0, $jb8NR.default).div`
  display: flex;
  justify-content: flex-end;
`;
const $f39f0055a87f9384$var$ErrorMessageContainer = (0, $jb8NR.default).div`
  padding: 35px 0 10px;
`;
const $f39f0055a87f9384$var$ErrorMessage = (0, $jb8NR.default).div`
  color: ${(0, $22v9q.theme).colors.error[500]};
  text-align: center;
  font-size: 0.875rem;
  ${(0, $22v9q.theme).mediumText}
`;
const $f39f0055a87f9384$var$ValidityDateText = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText}
  ${(0, $22v9q.theme).bodyBlackBold}
  margin-top: -10px;
`;

});
parcelRegister("h2P2T", function(module, exports) {

$parcel$export(module.exports, "isOverdraftMatchingBalance", function () { return $733ef2b921cf32af$export$fdd53064fc75ba6c; });

var $kGswT = parcelRequire("kGswT");

var $iMWY7 = parcelRequire("iMWY7");
const $733ef2b921cf32af$export$fdd53064fc75ba6c = (account, authorizedOverdraftValue)=>{
    const availableBalance = (0, $kGswT.getAvailableBalance)(account)?.value;
    // If the available balance is negative and equals the absolute value of the overdraft
    if (availableBalance < 0 && availableBalance === -authorizedOverdraftValue) return true;
    return false;
};
function $733ef2b921cf32af$export$cc328cce87d9e0af(detailedAccounting) {
    return (0, $iMWY7.getTotalOfDetailedAccounting)(detailedAccounting) > 0;
}

});

parcelRegister("k73b6", function(module, exports) {

$parcel$export(module.exports, "isDateInPast", function () { return $4f2b317d901e0ca9$export$b61c42c7211e77c7; });
/**
 * Checks if a given date is in the past.
 * @param date A date string or null
 * @returns true if the date is in the past, false otherwise
 */ const $4f2b317d901e0ca9$export$b61c42c7211e77c7 = (date)=>{
    if (!date) return false;
    const inputDate = new Date(date);
    const todayDate = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    const today = new Date(todayDate);
    // Normalize both dates to midnight
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return inputDate < today;
};

});

parcelRegister("1qRJe", function(module, exports) {

$parcel$export(module.exports, "getAccountProductName", function () { return $ee2186438d05e7fd$export$8c008b1eeacc2b20; });
const $ee2186438d05e7fd$export$8c008b1eeacc2b20 = ({ accountIsSavings: accountIsSavings, savingsDetails: savingsDetails, userLanguage: userLanguage, accountTypeLabelsWeb: accountTypeLabelsWeb, accountType: accountType, formatMessage: formatMessage })=>{
    if (accountIsSavings) {
        const getProductName = (product, language)=>product?.names?.[language] ?? product?.names?.en_US ?? formatMessage(accountTypeLabelsWeb[accountType] ?? accountType);
        return getProductName(savingsDetails?.product, userLanguage);
    }
    const accountTypeKey = accountTypeLabelsWeb?.[accountType] ?? accountType;
    return formatMessage(accountTypeKey);
};

});

parcelRegister("kQgvS", function(module, exports) {

$parcel$export(module.exports, "ScrollableDiv", function () { return $2cf87a77e5679f63$export$ccb7a07a93c033b9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");
const $2cf87a77e5679f63$export$ccb7a07a93c033b9 = ({ children: children, className: className, childrenClassName: childrenClassName })=>/*#__PURE__*/ (0, $4m918.jsx)($2cf87a77e5679f63$var$FaderContainer, {
        className: className,
        children: /*#__PURE__*/ (0, $4m918.jsx)($2cf87a77e5679f63$var$ScrollContainer, {
            className: childrenClassName,
            children: children
        })
    });
const $2cf87a77e5679f63$var$FaderContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  ::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 15px;
    height: 15px;
    pointer-events: none;
    z-index: 1;
  }

  ::after {
    position: absolute;
    content: "";
    pointer-events: none;
    bottom: 0;
    left: 0;
    right: 15px;
    height: 15px;
  }
`;
const $2cf87a77e5679f63$var$ScrollContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  height: 100%;
`;

});

parcelRegister("6OTGa", function(module, exports) {

$parcel$export(module.exports, "GenerateAccountStatementButton", function () { return $40501f93d3de98d0$export$b3a8dea11b31bc8; });

var $4m918 = parcelRequire("4m918");

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $b6V1s = parcelRequire("b6V1s");

var $cNsCW = parcelRequire("cNsCW");

var $k10cE = parcelRequire("k10cE");

var $j0Nhs = parcelRequire("j0Nhs");

var $6evmn = parcelRequire("6evmn");

var $k4kME = parcelRequire("k4kME");

var $iqXYI = parcelRequire("iqXYI");

var $b6TEo = parcelRequire("b6TEo");

var $22v9q = parcelRequire("22v9q");
const $40501f93d3de98d0$export$89c207bbd43fc8b9 = (props)=>{
    const { children: children, onClick: onClick, active: active, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$GenerateButtonContainer, {
        ...rest,
        onClick: onClick,
        $active: active,
        children: children
    });
};
const $40501f93d3de98d0$export$b3a8dea11b31bc8 = ({ accountId: accountId, ...props })=>{
    const dropdownContentRef = (0, $6uYXW.useRef)(null);
    (0, $k10cE.useClickOutsideHandler)(dropdownContentRef, ()=>setShowDropdown(false));
    const [showDropdown, setShowDropdown] = (0, $6uYXW.useState)(false);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { startDate: startDate, endDate: endDate, onStartDateChange: onStartDateChange, onEndDateChange: onEndDateChange } = (0, $b6V1s.useTransactionDateFilter)();
    const [isLoading, setIsLoading] = (0, $6uYXW.useState)(false);
    const [isDateChanged, setIsDateChanged] = (0, $6uYXW.useState)(false);
    const handleStartDateChange = (e)=>{
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(e.target.value); // e.target.value --> YYYY-MM-DD
        if (date.isValid()) {
            onStartDateChange(date.toDate(), true);
            setIsDateChanged(true);
        }
    };
    const handleEndDateChange = (e)=>{
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(e.target.value).endOf("day");
        if (date.isValid()) {
            onEndDateChange(date.toDate(), true, true);
            setIsDateChanged(true);
        }
    };
    const handleDownloadAccountStatement = async ()=>{
        const { selectedStartDate: selectedStartDate, selectedEndDate: selectedEndDate } = (0, $cNsCW.arrangeDates)(startDate, endDate);
        try {
            setIsLoading(true);
            await (0, $kqXxS.generateAccountStatementService).downloadGenerateAccountStatement(accountId, selectedStartDate, selectedEndDate);
            setShowDropdown(false);
        } catch (error) {
            console.error("Error generating statement", error);
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($40501f93d3de98d0$export$89c207bbd43fc8b9, {
        ...props,
        onClick: ()=>{
            setShowDropdown((show)=>!show);
        },
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($40501f93d3de98d0$var$StyledGenerateButton, {
                $active: showDropdown,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $b6TEo.GenerateIcon), {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$StyledGenerateLabel, {
                        children: formatMessage("accountsStatements.generateButton")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$GenerateAccountStatementContent, {
                ref: dropdownContentRef,
                $isVisible: showDropdown,
                onClick: (e)=>e.stopPropagation(),
                children: /*#__PURE__*/ (0, $4m918.jsxs)($40501f93d3de98d0$var$PanelFilterByDate, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$DateTitle, {
                            children: formatMessage("transactionFilter.timeRangeSelectionTitle")
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($40501f93d3de98d0$var$Row, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$DateCaption, {
                                    children: formatMessage("transactionFilter.timeRange.from")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$DateContainer, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$StyledDateInput, {
                                        mode: "date",
                                        withoutTheme: true,
                                        onChange: handleStartDateChange,
                                        value: startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate).format("YYYY-MM-DD") : ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$DateCaption, {
                                    children: formatMessage("transactionFilter.timeRange.to")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$DateContainer, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$StyledDateInput, {
                                        mode: "date",
                                        withoutTheme: true,
                                        onChange: handleEndDateChange,
                                        value: endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate).format("YYYY-MM-DD") : ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$CheckContainer, {
                                    children: isLoading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {}) : /*#__PURE__*/ (0, $4m918.jsx)((0, $j0Nhs.RoundActionButton), {
                                        size: 27,
                                        onClick: handleDownloadAccountStatement,
                                        disabled: !isDateChanged,
                                        children: /*#__PURE__*/ (0, $4m918.jsx)($40501f93d3de98d0$var$SmallCheckIcon, {})
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $40501f93d3de98d0$var$GenerateButtonContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 10px;
  &:hover {
    cursor: pointer;
  }
`;
const $40501f93d3de98d0$var$GenerateAccountStatementContent = (0, $jb8NR.default).div`
  ${(0, $22v9q.shadows).medium};
  display: ${(props)=>props.$isVisible ? "block" : "none"};
  overflow: hidden;
  border-radius: 10px;
  width: 100%;
  padding: 50px 0 15px 15px;
  margin: -35px 0 0;
`;
const $40501f93d3de98d0$var$PanelFilterByDate = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $40501f93d3de98d0$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const $40501f93d3de98d0$var$DateTitle = (0, $jb8NR.default).div`
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: bold;
`;
const $40501f93d3de98d0$var$StyledGenerateButton = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  ${(props)=>!props.$active ? (0, $22v9q.shadows).medium : ""};
  display: flex;
  align-items: center;
  background: ${(0, $22v9q.theme).colors.gray[50]};
  font-weight: bold;
  font-size: 15px;
  padding: 6px 12px;
  border-radius: 10px;
`;
const $40501f93d3de98d0$var$StyledGenerateLabel = (0, $jb8NR.default).span`
  padding-left: 5px;
`;
const $40501f93d3de98d0$var$DateContainer = (0, $jb8NR.default).div`
  height: 25px;
  margin-right: 8px;
`;
const $40501f93d3de98d0$var$DateCaption = (0, $jb8NR.default).div`
  font-size: 12px;
  margin-right: 3px;
`;
const $40501f93d3de98d0$var$StyledDateInput = (0, $jb8NR.default)((0, $6evmn.DateInput))`
  min-width: 110px;
  background-color: ${(0, $22v9q.theme).colors.gray[100]};
  height: 25px;
  padding: 0 3px;
  font-size: 12px;
`;
const $40501f93d3de98d0$var$CheckContainer = (0, $jb8NR.default)($40501f93d3de98d0$var$Row)`
  align-items: center;
  justify-content: center;
`;
const $40501f93d3de98d0$var$SmallCheckIcon = (0, $jb8NR.default)((0, $iqXYI.CheckIcon))`
  width: 14px;
  height: 14px;
`;

});
parcelRegister("k10cE", function(module, exports) {

$parcel$export(module.exports, "useClickOutsideHandler", function () { return $c4b3cf361de0144a$export$6e05929b9b4fb022; });

var $6uYXW = parcelRequire("6uYXW");
function $c4b3cf361de0144a$export$6e05929b9b4fb022(ref, handler) {
    (0, $6uYXW.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) handler();
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handler,
        ref
    ]);
}

});

parcelRegister("j0Nhs", function(module, exports) {

$parcel$export(module.exports, "RoundActionButton", function () { return $e9003a6c225bbab5$export$ccd5d4cb55e86b1f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $7Zu6k = parcelRequire("7Zu6k");
const $e9003a6c225bbab5$export$ccd5d4cb55e86b1f = (props)=>{
    const { label: label, children: children, size: size = 46, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($e9003a6c225bbab5$var$RoundButton, {
        ...rest,
        size: "S",
        diameter: size,
        children: children ? children : label || ">"
    });
};
const $e9003a6c225bbab5$var$RoundButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props)=>props.diameter};
  height: ${(props)=>props.diameter};
  padding: 0px 0px;
`;

});

parcelRegister("6evmn", function(module, exports) {

$parcel$export(module.exports, "DateInput", function () { return $db9c6bc09db24781$export$7edc06cf1783b30f; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $9mlIh = parcelRequire("9mlIh");
const $db9c6bc09db24781$export$7edc06cf1783b30f = ({ withoutTheme: withoutTheme, mode: mode, ...props })=>{
    const dateInputIsSupported = (0, $6uYXW.useMemo)(()=>$db9c6bc09db24781$var$isDateInputSupported(), []);
    const commonProps = {
        value: dateInputIsSupported ? props.value : $db9c6bc09db24781$var$deNormalizeDate(props.value?.toString() ?? ""),
        onChange: (e)=>dateInputIsSupported ? props.onChange?.(e) : props.onChange?.({
                ...e,
                target: {
                    ...e.target,
                    value: $db9c6bc09db24781$var$normalizeDate(e.target.value)
                }
            }),
        type: mode,
        max: mode === "date" ? "9999-12-31" : undefined,
        pattern: dateInputIsSupported ? "[0-9]{4}-[0-9]{2}-[0-9]{2}" : "[0-9]{2}/[0-9]{2}/[0-9]{4}",
        placeholder: dateInputIsSupported ? props.placeholder : "JJ/MM/YYYY"
    };
    return withoutTheme ? /*#__PURE__*/ (0, $4m918.jsx)($db9c6bc09db24781$var$Input, {
        ...props,
        ...commonProps
    }) : /*#__PURE__*/ (0, $4m918.jsx)($db9c6bc09db24781$var$StyledTextInput, {
        ...props,
        ...commonProps
    });
};
function $db9c6bc09db24781$var$isDateInputSupported() {
    const input = document.createElement("input");
    const value = "a";
    input.setAttribute("type", "date");
    input.setAttribute("value", value);
    return input.value !== value;
}
function $db9c6bc09db24781$var$normalizeDate(date) {
    const match = date.match(/(\d{0,2})\/(\d{0,2})\/(\d{0,4})/);
    if (match) return `${match[3]}-${match[2]}-${match[1]}`;
    else return date;
}
function $db9c6bc09db24781$var$deNormalizeDate(date) {
    const match = date.match(/(\d{0,4})\-(\d{0,2})\-(\d{0,2})/);
    if (match) return `${match[3]}/${match[2]}/${match[1]}`;
    else return date;
}
const $db9c6bc09db24781$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  input {
    color: ${(props)=>props.value ? null : "#b1b1b1"};
  }
`;
const $db9c6bc09db24781$var$Input = (0, $jb8NR.default).input`
  appearance: none;
  border-radius: 7px;
  border: none;
  background-color: #fff;
  padding-left: 10px;
  padding-right: 10px;
  flex-grow: 1;

  &:focus {
    outline: 0;
  }
`;

});
parcelRegister("9mlIh", function(module, exports) {

$parcel$export(module.exports, "TextInput", function () { return $919c96e2a3dbb3d2$export$c86715117507e8e5; });
$parcel$export(module.exports, "Input", function () { return $919c96e2a3dbb3d2$export$f5b8910cec6cf069; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
const $919c96e2a3dbb3d2$export$c86715117507e8e5 = /*#__PURE__*/ (0, $6uYXW.forwardRef)((props, ref)=>{
    const { variant: variant, hasError: hasError, errorMessage: errorMessage, className: className, disabled: disabled, bottomOffset: bottomOffset, multiline: multiline, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($919c96e2a3dbb3d2$var$Container, {
                className: className,
                disabled: disabled,
                children: multiline ? /*#__PURE__*/ (0, $4m918.jsx)($919c96e2a3dbb3d2$export$f5c9f3c2c4054eec, {
                    variant: variant,
                    ref: ref,
                    hasError: hasError,
                    ...rest
                }) : /*#__PURE__*/ (0, $4m918.jsx)($919c96e2a3dbb3d2$export$f5b8910cec6cf069, {
                    variant: variant,
                    ref: ref,
                    hasError: hasError,
                    ...rest
                })
            }),
            errorMessage && hasError && /*#__PURE__*/ (0, $4m918.jsx)($919c96e2a3dbb3d2$var$StyledErrorMessage, {
                hasError: hasError,
                children: errorMessage
            })
        ]
    });
});
const $919c96e2a3dbb3d2$var$Container = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 15px 19px 14px 17px;
  border-radius: 10px;
  background-color: #ffffff;
  ${({ disabled: disabled })=>({
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "default"
    })}
`;
const $919c96e2a3dbb3d2$export$f5b8910cec6cf069 = (0, $jb8NR.default).input`
  max-width: 100%;
  flex: 1 0 auto;
  outline: none;
  border: none;
  ${(0, $22v9q.theme).boldText};
  font-size: 0.8125rem;
  color: #000000;
  ::placeholder {
    color: #b1b1b1;
  }
  ${({ hasError: hasError })=>hasError && (0, $jb8NR.css)`
      color: #ff4242;
    `}
  ${({ variant: variant })=>variant === "big" && (0, $jb8NR.css)`
      font-size: 1.5rem;
      line-height: 1.75rem;
      height: 2rem;
    `}
`;
const $919c96e2a3dbb3d2$export$f5c9f3c2c4054eec = (0, $jb8NR.default).textarea`
  max-width: 100%;
  flex: 1 0 auto;
  outline: none;
  border: none;
  ${(0, $22v9q.theme).boldText};
  font-size: 0.8125rem;
  color: #000000;
  ::placeholder {
    color: #b1b1b1;
  }
  ${({ hasError: hasError })=>hasError && (0, $jb8NR.css)`
      color: #ff4242;
    `}
  ${({ variant: variant })=>variant === "big" && (0, $jb8NR.css)`
      font-size: 1.5rem;
      line-height: 1.75rem;
      height: 2rem;
    `}
`;
const $919c96e2a3dbb3d2$var$StyledErrorMessage = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.825rem;
  margin-top: 6px;
  color: ${(props)=>props.hasError ? (0, $22v9q.theme).colors.error[500] : (0, $22v9q.theme).colors.gray[700]};
`;

});


parcelRegister("iqXYI", function(module, exports) {

$parcel$export(module.exports, "CheckIcon", function () { return $c9e877163c05ab9b$export$7dd004358974b05d; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $c9e877163c05ab9b$export$7dd004358974b05d(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "38",
        height: "38",
        viewBox: "0 0 38 38",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                transform: "translate(-701 -453) translate(511 201) translate(113 175)",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        d: "M0 0H36.496V36.496H0z",
                        transform: "translate(77.752 77.752)"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        fill: props.fill ?? "#fff",
                        fillRule: "nonzero",
                        d: "M8.046 27.728c-.636.748-1.758.84-2.507.203-.748-.636-.839-1.758-.203-2.506L20.45 7.645c.646-.76 1.79-.84 2.536-.177l8.001 7.112c.734.652.8 1.776.148 2.51-.653.734-1.776.8-2.51.147l-6.643-5.904L8.046 27.728z",
                        transform: "translate(77.752 77.752) rotate(-180 18.248 17.686)"
                    })
                ]
            })
        })
    });
}

});

parcelRegister("b6TEo", function(module, exports) {

$parcel$export(module.exports, "GenerateIcon", function () { return $72c834bf0407ff6a$export$6859bfa6378db6d3; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $72c834bf0407ff6a$export$6859bfa6378db6d3(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("g", {
                children: /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                    fill: "none",
                    height: "24",
                    width: "24"
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("g", {}),
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                                d: "M17,19.22H5V7h7V5H5C3.9,5,3,5.9,3,7v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-7h-2V19.22z"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                                d: "M19,2h-2v3h-3c0.01,0.01,0,2,0,2h3v2.99c0.01,0.01,2,0,2,0V7h3V5h-3V2z"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                                height: "2",
                                width: "8",
                                x: "7",
                                y: "9"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("polygon", {
                                points: "7,12 7,14 15,14 15,12 12,12"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                                height: "2",
                                width: "8",
                                x: "7",
                                y: "15"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});


parcelRegister("aihh2", function(module, exports) {

$parcel$export(module.exports, "ClipboardInformationRow", function () { return $fa085e934eb39eb9$export$724cbf07643b5cdc; });

var $4m918 = parcelRequire("4m918");

var $4wvTY = parcelRequire("4wvTY");

var $6uYXW = parcelRequire("6uYXW");

var $gL91i = parcelRequire("gL91i");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $05ceX = parcelRequire("05ceX");

var $9jdzG = parcelRequire("9jdzG");

var $fxmB5 = parcelRequire("fxmB5");

var $7RQw4 = parcelRequire("7RQw4");

var $fiXwA = parcelRequire("fiXwA");

var $7wSRt = parcelRequire("7wSRt");

var $22v9q = parcelRequire("22v9q");
const $fa085e934eb39eb9$export$724cbf07643b5cdc = (props)=>{
    const { title: title, value: value, noCopy: noCopy, editAction: editAction, input: input, onEditChange: onEditChange, onEnterPressed: onEnterPressed, successLabel: successLabel, errorLabel: errorLabel, ...rest } = props;
    const { elementRef: elementRef, showTooltip: showTooltip } = (0, $9jdzG.useTooltip)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [uid] = (0, $6uYXW.useState)((0, $05ceX.getRandomID)());
    const copyToClipboard = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($4wvTY)))(value);
        showTooltip();
    };
    const [isEditing, setIsEditing] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $4m918.jsxs)($fa085e934eb39eb9$var$Row, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($fa085e934eb39eb9$var$Column, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($fa085e934eb39eb9$var$Title, {
                        children: title
                    }),
                    isEditing && input ? /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $fxmB5.FormField), {
                                input: input,
                                onChange: onEditChange,
                                onBlur: (e)=>onEnterPressed ? onEnterPressed(e.target.value) : null,
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        onEnterPressed(e.target.value);
                                    }
                                }
                            }),
                            successLabel?.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($fa085e934eb39eb9$var$Subtitle, {
                                style: {
                                    color: (0, $22v9q.theme).colors.success[500],
                                    marginTop: 8
                                },
                                children: successLabel
                            }),
                            errorLabel?.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($fa085e934eb39eb9$var$Subtitle, {
                                style: {
                                    color: (0, $22v9q.theme).colors.error[500]
                                },
                                children: errorLabel
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4m918.jsx)($fa085e934eb39eb9$var$Value, {
                        children: value
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($fa085e934eb39eb9$var$ActionButtonsContainer, {
                children: [
                    editAction && /*#__PURE__*/ (0, $4m918.jsx)($fa085e934eb39eb9$var$GreyRoundedSquare, {
                        size: 34,
                        onClick: ()=>setIsEditing(!isEditing),
                        style: {
                            marginRight: 4
                        },
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7wSRt.PenIcon), {
                            width: 18,
                            fill: "#000000"
                        })
                    }),
                    !noCopy && /*#__PURE__*/ (0, $4m918.jsx)($fa085e934eb39eb9$var$GreyRoundedSquare, {
                        "data-for": uid,
                        ref: elementRef,
                        size: 34,
                        "data-tip": formatMessage("accountDetails.clipboard", {
                            name: title
                        }),
                        onClick: copyToClipboard,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $fiXwA.ClipboardIcon), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $gL91i.default), {
                id: uid,
                place: "top",
                type: "dark",
                effect: "solid",
                event: "none"
            })
        ]
    });
};
const $fa085e934eb39eb9$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
`;
const $fa085e934eb39eb9$var$Column = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 80%;
`;
const $fa085e934eb39eb9$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 0.9375rem;
  color: #b1b1b1;
`;
const $fa085e934eb39eb9$var$Value = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.9375rem;
`;
const $fa085e934eb39eb9$var$GreyRoundedSquare = (0, $jb8NR.default)((0, $7RQw4.RoundedSquareButton))`
  background-color: #f4f4f4;
`;
const $fa085e934eb39eb9$var$ActionButtonsContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
`;
const $fa085e934eb39eb9$var$Subtitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  font-size: 1rem;
  color: #b1b1b1;
  text-align: center;
  margin-left: 16px;
`;

});
parcelRegister("gL91i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c338084cf8dfe3b4$export$2e2bcd8739ae039; });

var $6uYXW = parcelRequire("6uYXW");

var $k8j0a = parcelRequire("k8j0a");

var $8OOcO = parcelRequire("8OOcO");
function $c338084cf8dfe3b4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c338084cf8dfe3b4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c338084cf8dfe3b4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c338084cf8dfe3b4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c338084cf8dfe3b4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c338084cf8dfe3b4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c338084cf8dfe3b4$var$_extends() {
    $c338084cf8dfe3b4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c338084cf8dfe3b4$var$_extends.apply(this, arguments);
}
function $c338084cf8dfe3b4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c338084cf8dfe3b4$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c338084cf8dfe3b4$var$ownKeys(Object(source), true).forEach(function(key) {
            $c338084cf8dfe3b4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c338084cf8dfe3b4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c338084cf8dfe3b4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c338084cf8dfe3b4$var$_setPrototypeOf(subClass, superClass);
}
function $c338084cf8dfe3b4$var$_getPrototypeOf(o) {
    $c338084cf8dfe3b4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c338084cf8dfe3b4$var$_getPrototypeOf(o);
}
function $c338084cf8dfe3b4$var$_setPrototypeOf(o, p) {
    $c338084cf8dfe3b4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c338084cf8dfe3b4$var$_setPrototypeOf(o, p);
}
function $c338084cf8dfe3b4$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $c338084cf8dfe3b4$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $c338084cf8dfe3b4$var$_assertThisInitialized(self1);
}
var $c338084cf8dfe3b4$var$CONSTANT = {
    GLOBAL: {
        HIDE: '__react_tooltip_hide_event',
        REBUILD: '__react_tooltip_rebuild_event',
        SHOW: '__react_tooltip_show_event'
    }
};
/**
 * Static methods for react-tooltip
 */ var $c338084cf8dfe3b4$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === 'function') event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $c338084cf8dfe3b4$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $c338084cf8dfe3b4$var$dispatchGlobalEvent($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $c338084cf8dfe3b4$var$dispatchGlobalEvent($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $c338084cf8dfe3b4$var$dispatchGlobalEvent($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $c338084cf8dfe3b4$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
        window.removeEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
        window.removeEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
        if (resizeHide) {
            window.removeEventListener('resize', this.onWindowResize);
            window.addEventListener('resize', this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($c338084cf8dfe3b4$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $c338084cf8dfe3b4$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute('currentItem');
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === 'true') {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute('currentItem', 'true');
        $c338084cf8dfe3b4$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $c338084cf8dfe3b4$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute('currentItem', 'false');
    else targetArray[i].setAttribute('currentItem', 'true');
};
var $c338084cf8dfe3b4$var$customListeners = {
    id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $c338084cf8dfe3b4$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $c338084cf8dfe3b4$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute('data-event');
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute('data-event') || event;
        var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
        dataEvent.split(' ').forEach(function(event) {
            ele.removeEventListener(event, $c338084cf8dfe3b4$var$customListeners.get(ele, event));
            var customListener = $c338084cf8dfe3b4$var$checkStatus.bind(_this, dataEventOff);
            $c338084cf8dfe3b4$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(' ').forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute('data-event');
        var dataEventOff = eventOff || ele.getAttribute('data-event-off');
        ele.removeEventListener(dataEvent, $c338084cf8dfe3b4$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $c338084cf8dfe3b4$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $c338084cf8dfe3b4$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute('data-effect');
        return dataEffect || this.props.effect || 'float';
    };
}
/**
 * Util method to get effect
 */ var $c338084cf8dfe3b4$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === 'function') proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $c338084cf8dfe3b4$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = e.target.getAttribute('data-tip') || null;
    var forId = e.target.getAttribute('data-for') || null;
    var target = e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
        var proxy = $c338084cf8dfe3b4$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $c338084cf8dfe3b4$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(' ').forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $c338084cf8dfe3b4$var$getBody = function getBody() {
    return document.getElementsByTagName('body')[0];
};
function $c338084cf8dfe3b4$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $c338084cf8dfe3b4$var$getBody();
        var customEvents = $c338084cf8dfe3b4$var$findCustomEvents(targetArray, 'data-event');
        var customEventsOff = $c338084cf8dfe3b4$var$findCustomEvents(targetArray, 'data-event-off');
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(' ').forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(' ').forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $c338084cf8dfe3b4$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $c338084cf8dfe3b4$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $c338084cf8dfe3b4$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $c338084cf8dfe3b4$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
            $c338084cf8dfe3b4$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $c338084cf8dfe3b4$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $c338084cf8dfe3b4$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $c338084cf8dfe3b4$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $c338084cf8dfe3b4$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $c338084cf8dfe3b4$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $c338084cf8dfe3b4$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $c338084cf8dfe3b4$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $c338084cf8dfe3b4$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $c338084cf8dfe3b4$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $c338084cf8dfe3b4$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $c338084cf8dfe3b4$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $c338084cf8dfe3b4$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    }; //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    }; // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placesList = [
        'top',
        'bottom',
        'left',
        'right'
    ];
    var insideList = [];
    for(var i = 0; i < 4; i++){
        var p = placesList[i];
        if (inside(p)) insideList.push(p);
    }
    var isNewState = false;
    var newPlace;
    var shouldUpdatePlace = desiredPlace !== place;
    if (inside(desiredPlace) && shouldUpdatePlace) {
        isNewState = true;
        newPlace = desiredPlace;
    } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
        isNewState = true;
        newPlace = insideList[0];
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $c338084cf8dfe3b4$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
}; // Get current mouse offset
var $c338084cf8dfe3b4$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $c338084cf8dfe3b4$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === 'float') return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $c338084cf8dfe3b4$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === 'float') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === 'solid') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}; // Consider additional offset into position calculation
var $c338084cf8dfe3b4$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === '[object String]') offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === 'top') extraOffsetY -= parseInt(offset[key], 10);
        else if (key === 'bottom') extraOffsetY += parseInt(offset[key], 10);
        else if (key === 'left') extraOffsetX -= parseInt(offset[key], 10);
        else if (key === 'right') extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
}; // Get the offset of the parent elements
var $c338084cf8dfe3b4$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent); // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $c338084cf8dfe3b4$var$getTipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === 'false' || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
     // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $c338084cf8dfe3b4$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $c338084cf8dfe3b4$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $c338084cf8dfe3b4$var$generateUUID() {
    return 't' + (0, $8OOcO.default)();
}
var $c338084cf8dfe3b4$var$baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";
/**
 * Default pop-up style values (text color, background color).
 */ var $c338084cf8dfe3b4$var$defaultColors = {
    dark: {
        text: '#fff',
        background: '#222',
        border: 'transparent',
        arrow: '#222'
    },
    success: {
        text: '#fff',
        background: '#8DC572',
        border: 'transparent',
        arrow: '#8DC572'
    },
    warning: {
        text: '#fff',
        background: '#F0AD4E',
        border: 'transparent',
        arrow: '#F0AD4E'
    },
    error: {
        text: '#fff',
        background: '#BE6464',
        border: 'transparent',
        arrow: '#BE6464'
    },
    info: {
        text: '#fff',
        background: '#337AB7',
        border: 'transparent',
        arrow: '#337AB7'
    },
    light: {
        text: '#222',
        background: '#fff',
        border: 'transparent',
        arrow: '#fff'
    }
};
function $c338084cf8dfe3b4$var$getDefaultPopupColors(type) {
    return $c338084cf8dfe3b4$var$defaultColors[type] ? $c338084cf8dfe3b4$var$_objectSpread2({}, $c338084cf8dfe3b4$var$defaultColors[type]) : undefined;
}
/**
 * Generates the specific tooltip style for use on render.
 */ function $c338084cf8dfe3b4$var$generateTooltipStyle(uuid, customColors, type, hasBorder) {
    return $c338084cf8dfe3b4$var$generateStyle(uuid, $c338084cf8dfe3b4$var$getPopupColors(customColors, type, hasBorder));
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $c338084cf8dfe3b4$var$generateStyle(uuid, colors) {
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}
function $c338084cf8dfe3b4$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $c338084cf8dfe3b4$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === 'light' ? 'black' : 'white';
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $c338084cf8dfe3b4$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $c338084cf8dfe3b4$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $c338084cf8dfe3b4$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $c338084cf8dfe3b4$var$global_1 = // eslint-disable-next-line es/no-global-this -- safe
$c338084cf8dfe3b4$var$check(typeof globalThis == 'object' && globalThis) || $c338084cf8dfe3b4$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$c338084cf8dfe3b4$var$check(typeof self == 'object' && self) || $c338084cf8dfe3b4$var$check(typeof $c338084cf8dfe3b4$var$commonjsGlobal == 'object' && $c338084cf8dfe3b4$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();
var $c338084cf8dfe3b4$var$fails = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
// Detect IE8's incomplete defineProperty implementation
var $c338084cf8dfe3b4$var$descriptors = !$c338084cf8dfe3b4$var$fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $c338084cf8dfe3b4$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c338084cf8dfe3b4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $c338084cf8dfe3b4$var$NASHORN_BUG = $c338084cf8dfe3b4$var$getOwnPropertyDescriptor && !$c338084cf8dfe3b4$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $c338084cf8dfe3b4$var$f = $c338084cf8dfe3b4$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $c338084cf8dfe3b4$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $c338084cf8dfe3b4$var$$propertyIsEnumerable;
var $c338084cf8dfe3b4$var$objectPropertyIsEnumerable = {
    f: $c338084cf8dfe3b4$var$f
};
var $c338084cf8dfe3b4$var$createPropertyDescriptor = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $c338084cf8dfe3b4$var$toString = {}.toString;
var $c338084cf8dfe3b4$var$classofRaw = function(it) {
    return $c338084cf8dfe3b4$var$toString.call(it).slice(8, -1);
};
var $c338084cf8dfe3b4$var$split = ''.split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $c338084cf8dfe3b4$var$indexedObject = $c338084cf8dfe3b4$var$fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $c338084cf8dfe3b4$var$classofRaw(it) == 'String' ? $c338084cf8dfe3b4$var$split.call(it, '') : Object(it);
} : Object;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $c338084cf8dfe3b4$var$requireObjectCoercible = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $c338084cf8dfe3b4$var$toIndexedObject = function(it) {
    return $c338084cf8dfe3b4$var$indexedObject($c338084cf8dfe3b4$var$requireObjectCoercible(it));
};
var $c338084cf8dfe3b4$var$isObject = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var $c338084cf8dfe3b4$var$toPrimitive = function(input, PREFERRED_STRING) {
    if (!$c338084cf8dfe3b4$var$isObject(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !$c338084cf8dfe3b4$var$isObject(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == 'function' && !$c338084cf8dfe3b4$var$isObject(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !$c338084cf8dfe3b4$var$isObject(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $c338084cf8dfe3b4$var$toObject = function(argument) {
    return Object($c338084cf8dfe3b4$var$requireObjectCoercible(argument));
};
var $c338084cf8dfe3b4$var$hasOwnProperty = {}.hasOwnProperty;
var $c338084cf8dfe3b4$var$has = function hasOwn(it, key) {
    return $c338084cf8dfe3b4$var$hasOwnProperty.call($c338084cf8dfe3b4$var$toObject(it), key);
};
var $c338084cf8dfe3b4$var$document$1 = $c338084cf8dfe3b4$var$global_1.document;
// typeof document.createElement is 'object' in old IE
var $c338084cf8dfe3b4$var$EXISTS = $c338084cf8dfe3b4$var$isObject($c338084cf8dfe3b4$var$document$1) && $c338084cf8dfe3b4$var$isObject($c338084cf8dfe3b4$var$document$1.createElement);
var $c338084cf8dfe3b4$var$documentCreateElement = function(it) {
    return $c338084cf8dfe3b4$var$EXISTS ? $c338084cf8dfe3b4$var$document$1.createElement(it) : {};
};
// Thank's IE8 for his funny defineProperty
var $c338084cf8dfe3b4$var$ie8DomDefine = !$c338084cf8dfe3b4$var$descriptors && !$c338084cf8dfe3b4$var$fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($c338084cf8dfe3b4$var$documentCreateElement('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c338084cf8dfe3b4$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $c338084cf8dfe3b4$var$f$1 = $c338084cf8dfe3b4$var$descriptors ? $c338084cf8dfe3b4$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $c338084cf8dfe3b4$var$toIndexedObject(O);
    P = $c338084cf8dfe3b4$var$toPrimitive(P, true);
    if ($c338084cf8dfe3b4$var$ie8DomDefine) try {
        return $c338084cf8dfe3b4$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($c338084cf8dfe3b4$var$has(O, P)) return $c338084cf8dfe3b4$var$createPropertyDescriptor(!$c338084cf8dfe3b4$var$objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var $c338084cf8dfe3b4$var$objectGetOwnPropertyDescriptor = {
    f: $c338084cf8dfe3b4$var$f$1
};
var $c338084cf8dfe3b4$var$anObject = function(it) {
    if (!$c338084cf8dfe3b4$var$isObject(it)) throw TypeError(String(it) + ' is not an object');
    return it;
};
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $c338084cf8dfe3b4$var$$defineProperty = Object.defineProperty;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $c338084cf8dfe3b4$var$f$2 = $c338084cf8dfe3b4$var$descriptors ? $c338084cf8dfe3b4$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c338084cf8dfe3b4$var$anObject(O);
    P = $c338084cf8dfe3b4$var$toPrimitive(P, true);
    $c338084cf8dfe3b4$var$anObject(Attributes);
    if ($c338084cf8dfe3b4$var$ie8DomDefine) try {
        return $c338084cf8dfe3b4$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};
var $c338084cf8dfe3b4$var$objectDefineProperty = {
    f: $c338084cf8dfe3b4$var$f$2
};
var $c338084cf8dfe3b4$var$createNonEnumerableProperty = $c338084cf8dfe3b4$var$descriptors ? function(object, key, value) {
    return $c338084cf8dfe3b4$var$objectDefineProperty.f(object, key, $c338084cf8dfe3b4$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $c338084cf8dfe3b4$var$setGlobal = function(key, value) {
    try {
        $c338084cf8dfe3b4$var$createNonEnumerableProperty($c338084cf8dfe3b4$var$global_1, key, value);
    } catch (error) {
        $c338084cf8dfe3b4$var$global_1[key] = value;
    }
    return value;
};
var $c338084cf8dfe3b4$var$SHARED = '__core-js_shared__';
var $c338084cf8dfe3b4$var$store = $c338084cf8dfe3b4$var$global_1[$c338084cf8dfe3b4$var$SHARED] || $c338084cf8dfe3b4$var$setGlobal($c338084cf8dfe3b4$var$SHARED, {});
var $c338084cf8dfe3b4$var$sharedStore = $c338084cf8dfe3b4$var$store;
var $c338084cf8dfe3b4$var$functionToString = Function.toString;
// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $c338084cf8dfe3b4$var$sharedStore.inspectSource != 'function') $c338084cf8dfe3b4$var$sharedStore.inspectSource = function(it) {
    return $c338084cf8dfe3b4$var$functionToString.call(it);
};
var $c338084cf8dfe3b4$var$inspectSource = $c338084cf8dfe3b4$var$sharedStore.inspectSource;
var $c338084cf8dfe3b4$var$WeakMap = $c338084cf8dfe3b4$var$global_1.WeakMap;
var $c338084cf8dfe3b4$var$nativeWeakMap = typeof $c338084cf8dfe3b4$var$WeakMap === 'function' && /native code/.test($c338084cf8dfe3b4$var$inspectSource($c338084cf8dfe3b4$var$WeakMap));
var $c338084cf8dfe3b4$var$shared = $c338084cf8dfe3b4$var$createCommonjsModule(function(module) {
    (module.exports = function(key, value) {
        return $c338084cf8dfe3b4$var$sharedStore[key] || ($c338084cf8dfe3b4$var$sharedStore[key] = value !== undefined ? value : {});
    })('versions', []).push({
        version: '3.12.1',
        mode: 'global',
        copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
    });
});
var $c338084cf8dfe3b4$var$id = 0;
var $c338084cf8dfe3b4$var$postfix = Math.random();
var $c338084cf8dfe3b4$var$uid = function(key) {
    return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++$c338084cf8dfe3b4$var$id + $c338084cf8dfe3b4$var$postfix).toString(36);
};
var $c338084cf8dfe3b4$var$keys = $c338084cf8dfe3b4$var$shared('keys');
var $c338084cf8dfe3b4$var$sharedKey = function(key) {
    return $c338084cf8dfe3b4$var$keys[key] || ($c338084cf8dfe3b4$var$keys[key] = $c338084cf8dfe3b4$var$uid(key));
};
var $c338084cf8dfe3b4$var$hiddenKeys = {};
var $c338084cf8dfe3b4$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $c338084cf8dfe3b4$var$WeakMap$1 = $c338084cf8dfe3b4$var$global_1.WeakMap;
var $c338084cf8dfe3b4$var$set, $c338084cf8dfe3b4$var$get, $c338084cf8dfe3b4$var$has$1;
var $c338084cf8dfe3b4$var$enforce = function(it) {
    return $c338084cf8dfe3b4$var$has$1(it) ? $c338084cf8dfe3b4$var$get(it) : $c338084cf8dfe3b4$var$set(it, {});
};
var $c338084cf8dfe3b4$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$c338084cf8dfe3b4$var$isObject(it) || (state = $c338084cf8dfe3b4$var$get(it)).type !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($c338084cf8dfe3b4$var$nativeWeakMap || $c338084cf8dfe3b4$var$sharedStore.state) {
    var $c338084cf8dfe3b4$var$store$1 = $c338084cf8dfe3b4$var$sharedStore.state || ($c338084cf8dfe3b4$var$sharedStore.state = new $c338084cf8dfe3b4$var$WeakMap$1());
    var $c338084cf8dfe3b4$var$wmget = $c338084cf8dfe3b4$var$store$1.get;
    var $c338084cf8dfe3b4$var$wmhas = $c338084cf8dfe3b4$var$store$1.has;
    var $c338084cf8dfe3b4$var$wmset = $c338084cf8dfe3b4$var$store$1.set;
    $c338084cf8dfe3b4$var$set = function(it, metadata) {
        if ($c338084cf8dfe3b4$var$wmhas.call($c338084cf8dfe3b4$var$store$1, it)) throw new TypeError($c338084cf8dfe3b4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $c338084cf8dfe3b4$var$wmset.call($c338084cf8dfe3b4$var$store$1, it, metadata);
        return metadata;
    };
    $c338084cf8dfe3b4$var$get = function(it) {
        return $c338084cf8dfe3b4$var$wmget.call($c338084cf8dfe3b4$var$store$1, it) || {};
    };
    $c338084cf8dfe3b4$var$has$1 = function(it) {
        return $c338084cf8dfe3b4$var$wmhas.call($c338084cf8dfe3b4$var$store$1, it);
    };
} else {
    var $c338084cf8dfe3b4$var$STATE = $c338084cf8dfe3b4$var$sharedKey('state');
    $c338084cf8dfe3b4$var$hiddenKeys[$c338084cf8dfe3b4$var$STATE] = true;
    $c338084cf8dfe3b4$var$set = function(it, metadata) {
        if ($c338084cf8dfe3b4$var$has(it, $c338084cf8dfe3b4$var$STATE)) throw new TypeError($c338084cf8dfe3b4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $c338084cf8dfe3b4$var$createNonEnumerableProperty(it, $c338084cf8dfe3b4$var$STATE, metadata);
        return metadata;
    };
    $c338084cf8dfe3b4$var$get = function(it) {
        return $c338084cf8dfe3b4$var$has(it, $c338084cf8dfe3b4$var$STATE) ? it[$c338084cf8dfe3b4$var$STATE] : {};
    };
    $c338084cf8dfe3b4$var$has$1 = function(it) {
        return $c338084cf8dfe3b4$var$has(it, $c338084cf8dfe3b4$var$STATE);
    };
}
var $c338084cf8dfe3b4$var$internalState = {
    set: $c338084cf8dfe3b4$var$set,
    get: $c338084cf8dfe3b4$var$get,
    has: $c338084cf8dfe3b4$var$has$1,
    enforce: $c338084cf8dfe3b4$var$enforce,
    getterFor: $c338084cf8dfe3b4$var$getterFor
};
var $c338084cf8dfe3b4$var$redefine = $c338084cf8dfe3b4$var$createCommonjsModule(function(module) {
    var getInternalState = $c338084cf8dfe3b4$var$internalState.get;
    var enforceInternalState = $c338084cf8dfe3b4$var$internalState.enforce;
    var TEMPLATE = String(String).split('String');
    (module.exports = function(O, key, value, options) {
        var unsafe = options ? !!options.unsafe : false;
        var simple = options ? !!options.enumerable : false;
        var noTargetGet = options ? !!options.noTargetGet : false;
        var state;
        if (typeof value == 'function') {
            if (typeof key == 'string' && !$c338084cf8dfe3b4$var$has(value, 'name')) $c338084cf8dfe3b4$var$createNonEnumerableProperty(value, 'name', key);
            state = enforceInternalState(value);
            if (!state.source) state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
        }
        if (O === $c338084cf8dfe3b4$var$global_1) {
            if (simple) O[key] = value;
            else $c338084cf8dfe3b4$var$setGlobal(key, value);
            return;
        } else if (!unsafe) delete O[key];
        else if (!noTargetGet && O[key]) simple = true;
        if (simple) O[key] = value;
        else $c338084cf8dfe3b4$var$createNonEnumerableProperty(O, key, value);
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, 'toString', function toString() {
        return typeof this == 'function' && getInternalState(this).source || $c338084cf8dfe3b4$var$inspectSource(this);
    });
});
var $c338084cf8dfe3b4$var$path = $c338084cf8dfe3b4$var$global_1;
var $c338084cf8dfe3b4$var$aFunction = function(variable) {
    return typeof variable == 'function' ? variable : undefined;
};
var $c338084cf8dfe3b4$var$getBuiltIn = function(namespace, method) {
    return arguments.length < 2 ? $c338084cf8dfe3b4$var$aFunction($c338084cf8dfe3b4$var$path[namespace]) || $c338084cf8dfe3b4$var$aFunction($c338084cf8dfe3b4$var$global_1[namespace]) : $c338084cf8dfe3b4$var$path[namespace] && $c338084cf8dfe3b4$var$path[namespace][method] || $c338084cf8dfe3b4$var$global_1[namespace] && $c338084cf8dfe3b4$var$global_1[namespace][method];
};
var $c338084cf8dfe3b4$var$ceil = Math.ceil;
var $c338084cf8dfe3b4$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var $c338084cf8dfe3b4$var$toInteger = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $c338084cf8dfe3b4$var$floor : $c338084cf8dfe3b4$var$ceil)(argument);
};
var $c338084cf8dfe3b4$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $c338084cf8dfe3b4$var$toLength = function(argument) {
    return argument > 0 ? $c338084cf8dfe3b4$var$min($c338084cf8dfe3b4$var$toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $c338084cf8dfe3b4$var$max = Math.max;
var $c338084cf8dfe3b4$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $c338084cf8dfe3b4$var$toAbsoluteIndex = function(index, length) {
    var integer = $c338084cf8dfe3b4$var$toInteger(index);
    return integer < 0 ? $c338084cf8dfe3b4$var$max(integer + length, 0) : $c338084cf8dfe3b4$var$min$1(integer, length);
};
// `Array.prototype.{ indexOf, includes }` methods implementation
var $c338084cf8dfe3b4$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $c338084cf8dfe3b4$var$toIndexedObject($this);
        var length = $c338084cf8dfe3b4$var$toLength(O.length);
        var index = $c338084cf8dfe3b4$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $c338084cf8dfe3b4$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $c338084cf8dfe3b4$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $c338084cf8dfe3b4$var$createMethod(false)
};
var $c338084cf8dfe3b4$var$indexOf = $c338084cf8dfe3b4$var$arrayIncludes.indexOf;
var $c338084cf8dfe3b4$var$objectKeysInternal = function(object, names) {
    var O = $c338084cf8dfe3b4$var$toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$c338084cf8dfe3b4$var$has($c338084cf8dfe3b4$var$hiddenKeys, key) && $c338084cf8dfe3b4$var$has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($c338084cf8dfe3b4$var$has(O, key = names[i++])) ~$c338084cf8dfe3b4$var$indexOf(result, key) || result.push(key);
    return result;
};
// IE8- don't enum bug keys
var $c338084cf8dfe3b4$var$enumBugKeys = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
var $c338084cf8dfe3b4$var$hiddenKeys$1 = $c338084cf8dfe3b4$var$enumBugKeys.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $c338084cf8dfe3b4$var$f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c338084cf8dfe3b4$var$objectKeysInternal(O, $c338084cf8dfe3b4$var$hiddenKeys$1);
};
var $c338084cf8dfe3b4$var$objectGetOwnPropertyNames = {
    f: $c338084cf8dfe3b4$var$f$3
};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $c338084cf8dfe3b4$var$f$4 = Object.getOwnPropertySymbols;
var $c338084cf8dfe3b4$var$objectGetOwnPropertySymbols = {
    f: $c338084cf8dfe3b4$var$f$4
};
// all object keys, includes non-enumerable and symbols
var $c338084cf8dfe3b4$var$ownKeys$1 = $c338084cf8dfe3b4$var$getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $c338084cf8dfe3b4$var$objectGetOwnPropertyNames.f($c338084cf8dfe3b4$var$anObject(it));
    var getOwnPropertySymbols = $c338084cf8dfe3b4$var$objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};
var $c338084cf8dfe3b4$var$copyConstructorProperties = function(target, source) {
    var keys = $c338084cf8dfe3b4$var$ownKeys$1(source);
    var defineProperty = $c338084cf8dfe3b4$var$objectDefineProperty.f;
    var getOwnPropertyDescriptor = $c338084cf8dfe3b4$var$objectGetOwnPropertyDescriptor.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$c338084cf8dfe3b4$var$has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $c338084cf8dfe3b4$var$replacement = /#|\.prototype\./;
var $c338084cf8dfe3b4$var$isForced = function(feature, detection) {
    var value = $c338084cf8dfe3b4$var$data[$c338084cf8dfe3b4$var$normalize(feature)];
    return value == $c338084cf8dfe3b4$var$POLYFILL ? true : value == $c338084cf8dfe3b4$var$NATIVE ? false : typeof detection == 'function' ? $c338084cf8dfe3b4$var$fails(detection) : !!detection;
};
var $c338084cf8dfe3b4$var$normalize = $c338084cf8dfe3b4$var$isForced.normalize = function(string) {
    return String(string).replace($c338084cf8dfe3b4$var$replacement, '.').toLowerCase();
};
var $c338084cf8dfe3b4$var$data = $c338084cf8dfe3b4$var$isForced.data = {};
var $c338084cf8dfe3b4$var$NATIVE = $c338084cf8dfe3b4$var$isForced.NATIVE = 'N';
var $c338084cf8dfe3b4$var$POLYFILL = $c338084cf8dfe3b4$var$isForced.POLYFILL = 'P';
var $c338084cf8dfe3b4$var$isForced_1 = $c338084cf8dfe3b4$var$isForced;
var $c338084cf8dfe3b4$var$getOwnPropertyDescriptor$1 = $c338084cf8dfe3b4$var$objectGetOwnPropertyDescriptor.f;
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ var $c338084cf8dfe3b4$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $c338084cf8dfe3b4$var$global_1;
    else if (STATIC) target = $c338084cf8dfe3b4$var$global_1[TARGET] || $c338084cf8dfe3b4$var$setGlobal(TARGET, {});
    else target = ($c338084cf8dfe3b4$var$global_1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $c338084cf8dfe3b4$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $c338084cf8dfe3b4$var$isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $c338084cf8dfe3b4$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $c338084cf8dfe3b4$var$createNonEnumerableProperty(sourceProperty, 'sham', true);
        // extend global
        $c338084cf8dfe3b4$var$redefine(target, key, sourceProperty, options);
    }
};
var $c338084cf8dfe3b4$var$aFunction$1 = function(it) {
    if (typeof it != 'function') throw TypeError(String(it) + ' is not a function');
    return it;
};
// optional / simple context binding
var $c338084cf8dfe3b4$var$functionBindContext = function(fn, that, length) {
    $c338084cf8dfe3b4$var$aFunction$1(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $c338084cf8dfe3b4$var$isArray = Array.isArray || function isArray(arg) {
    return $c338084cf8dfe3b4$var$classofRaw(arg) == 'Array';
};
var $c338084cf8dfe3b4$var$engineUserAgent = $c338084cf8dfe3b4$var$getBuiltIn('navigator', 'userAgent') || '';
var $c338084cf8dfe3b4$var$process = $c338084cf8dfe3b4$var$global_1.process;
var $c338084cf8dfe3b4$var$versions = $c338084cf8dfe3b4$var$process && $c338084cf8dfe3b4$var$process.versions;
var $c338084cf8dfe3b4$var$v8 = $c338084cf8dfe3b4$var$versions && $c338084cf8dfe3b4$var$versions.v8;
var $c338084cf8dfe3b4$var$match, $c338084cf8dfe3b4$var$version;
if ($c338084cf8dfe3b4$var$v8) {
    $c338084cf8dfe3b4$var$match = $c338084cf8dfe3b4$var$v8.split('.');
    $c338084cf8dfe3b4$var$version = $c338084cf8dfe3b4$var$match[0] < 4 ? 1 : $c338084cf8dfe3b4$var$match[0] + $c338084cf8dfe3b4$var$match[1];
} else if ($c338084cf8dfe3b4$var$engineUserAgent) {
    $c338084cf8dfe3b4$var$match = $c338084cf8dfe3b4$var$engineUserAgent.match(/Edge\/(\d+)/);
    if (!$c338084cf8dfe3b4$var$match || $c338084cf8dfe3b4$var$match[1] >= 74) {
        $c338084cf8dfe3b4$var$match = $c338084cf8dfe3b4$var$engineUserAgent.match(/Chrome\/(\d+)/);
        if ($c338084cf8dfe3b4$var$match) $c338084cf8dfe3b4$var$version = $c338084cf8dfe3b4$var$match[1];
    }
}
var $c338084cf8dfe3b4$var$engineV8Version = $c338084cf8dfe3b4$var$version && +$c338084cf8dfe3b4$var$version;
/* eslint-disable es/no-symbol -- required for testing */ // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $c338084cf8dfe3b4$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$c338084cf8dfe3b4$var$fails(function() {
    return !String(Symbol()) || // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $c338084cf8dfe3b4$var$engineV8Version && $c338084cf8dfe3b4$var$engineV8Version < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $c338084cf8dfe3b4$var$useSymbolAsUid = $c338084cf8dfe3b4$var$nativeSymbol && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var $c338084cf8dfe3b4$var$WellKnownSymbolsStore = $c338084cf8dfe3b4$var$shared('wks');
var $c338084cf8dfe3b4$var$Symbol$1 = $c338084cf8dfe3b4$var$global_1.Symbol;
var $c338084cf8dfe3b4$var$createWellKnownSymbol = $c338084cf8dfe3b4$var$useSymbolAsUid ? $c338084cf8dfe3b4$var$Symbol$1 : $c338084cf8dfe3b4$var$Symbol$1 && $c338084cf8dfe3b4$var$Symbol$1.withoutSetter || $c338084cf8dfe3b4$var$uid;
var $c338084cf8dfe3b4$var$wellKnownSymbol = function(name) {
    if (!$c338084cf8dfe3b4$var$has($c338084cf8dfe3b4$var$WellKnownSymbolsStore, name) || !($c338084cf8dfe3b4$var$nativeSymbol || typeof $c338084cf8dfe3b4$var$WellKnownSymbolsStore[name] == 'string')) {
        if ($c338084cf8dfe3b4$var$nativeSymbol && $c338084cf8dfe3b4$var$has($c338084cf8dfe3b4$var$Symbol$1, name)) $c338084cf8dfe3b4$var$WellKnownSymbolsStore[name] = $c338084cf8dfe3b4$var$Symbol$1[name];
        else $c338084cf8dfe3b4$var$WellKnownSymbolsStore[name] = $c338084cf8dfe3b4$var$createWellKnownSymbol('Symbol.' + name);
    }
    return $c338084cf8dfe3b4$var$WellKnownSymbolsStore[name];
};
var $c338084cf8dfe3b4$var$SPECIES = $c338084cf8dfe3b4$var$wellKnownSymbol('species');
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $c338084cf8dfe3b4$var$arraySpeciesCreate = function(originalArray, length) {
    var C;
    if ($c338084cf8dfe3b4$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $c338084cf8dfe3b4$var$isArray(C.prototype))) C = undefined;
        else if ($c338084cf8dfe3b4$var$isObject(C)) {
            C = C[$c338084cf8dfe3b4$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};
var $c338084cf8dfe3b4$var$push = [].push;
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var $c338084cf8dfe3b4$var$createMethod$1 = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_OUT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $c338084cf8dfe3b4$var$toObject($this);
        var self1 = $c338084cf8dfe3b4$var$indexedObject(O);
        var boundFunction = $c338084cf8dfe3b4$var$functionBindContext(callbackfn, that, 3);
        var length = $c338084cf8dfe3b4$var$toLength(self1.length);
        var index = 0;
        var create = specificCreate || $c338084cf8dfe3b4$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $c338084cf8dfe3b4$var$push.call(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $c338084cf8dfe3b4$var$push.call(target, value); // filterOut
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $c338084cf8dfe3b4$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $c338084cf8dfe3b4$var$createMethod$1(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $c338084cf8dfe3b4$var$createMethod$1(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $c338084cf8dfe3b4$var$createMethod$1(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $c338084cf8dfe3b4$var$createMethod$1(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $c338084cf8dfe3b4$var$createMethod$1(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $c338084cf8dfe3b4$var$createMethod$1(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $c338084cf8dfe3b4$var$createMethod$1(6),
    // `Array.prototype.filterOut` method
    // https://github.com/tc39/proposal-array-filtering
    filterOut: $c338084cf8dfe3b4$var$createMethod$1(7)
};
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $c338084cf8dfe3b4$var$objectKeys = Object.keys || function keys(O) {
    return $c338084cf8dfe3b4$var$objectKeysInternal(O, $c338084cf8dfe3b4$var$enumBugKeys);
};
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $c338084cf8dfe3b4$var$objectDefineProperties = $c338084cf8dfe3b4$var$descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
    $c338084cf8dfe3b4$var$anObject(O);
    var keys = $c338084cf8dfe3b4$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$c338084cf8dfe3b4$var$objectDefineProperty.f(O, key = keys[index++], Properties[key]);
    return O;
};
var $c338084cf8dfe3b4$var$html = $c338084cf8dfe3b4$var$getBuiltIn('document', 'documentElement');
var $c338084cf8dfe3b4$var$GT = '>';
var $c338084cf8dfe3b4$var$LT = '<';
var $c338084cf8dfe3b4$var$PROTOTYPE = 'prototype';
var $c338084cf8dfe3b4$var$SCRIPT = 'script';
var $c338084cf8dfe3b4$var$IE_PROTO = $c338084cf8dfe3b4$var$sharedKey('IE_PROTO');
var $c338084cf8dfe3b4$var$EmptyConstructor = function() {};
var $c338084cf8dfe3b4$var$scriptTag = function(content) {
    return $c338084cf8dfe3b4$var$LT + $c338084cf8dfe3b4$var$SCRIPT + $c338084cf8dfe3b4$var$GT + content + $c338084cf8dfe3b4$var$LT + '/' + $c338084cf8dfe3b4$var$SCRIPT + $c338084cf8dfe3b4$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $c338084cf8dfe3b4$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($c338084cf8dfe3b4$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $c338084cf8dfe3b4$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $c338084cf8dfe3b4$var$documentCreateElement('iframe');
    var JS = 'java' + $c338084cf8dfe3b4$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $c338084cf8dfe3b4$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($c338084cf8dfe3b4$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $c338084cf8dfe3b4$var$activeXDocument;
var $c338084cf8dfe3b4$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject -- old IE */ $c338084cf8dfe3b4$var$activeXDocument = document.domain && new ActiveXObject('htmlfile');
    } catch (error) {}
    $c338084cf8dfe3b4$var$NullProtoObject = $c338084cf8dfe3b4$var$activeXDocument ? $c338084cf8dfe3b4$var$NullProtoObjectViaActiveX($c338084cf8dfe3b4$var$activeXDocument) : $c338084cf8dfe3b4$var$NullProtoObjectViaIFrame();
    var length = $c338084cf8dfe3b4$var$enumBugKeys.length;
    while(length--)delete $c338084cf8dfe3b4$var$NullProtoObject[$c338084cf8dfe3b4$var$PROTOTYPE][$c338084cf8dfe3b4$var$enumBugKeys[length]];
    return $c338084cf8dfe3b4$var$NullProtoObject();
};
$c338084cf8dfe3b4$var$hiddenKeys[$c338084cf8dfe3b4$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var $c338084cf8dfe3b4$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $c338084cf8dfe3b4$var$EmptyConstructor[$c338084cf8dfe3b4$var$PROTOTYPE] = $c338084cf8dfe3b4$var$anObject(O);
        result = new $c338084cf8dfe3b4$var$EmptyConstructor();
        $c338084cf8dfe3b4$var$EmptyConstructor[$c338084cf8dfe3b4$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$c338084cf8dfe3b4$var$IE_PROTO] = O;
    } else result = $c338084cf8dfe3b4$var$NullProtoObject();
    return Properties === undefined ? result : $c338084cf8dfe3b4$var$objectDefineProperties(result, Properties);
};
var $c338084cf8dfe3b4$var$UNSCOPABLES = $c338084cf8dfe3b4$var$wellKnownSymbol('unscopables');
var $c338084cf8dfe3b4$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($c338084cf8dfe3b4$var$ArrayPrototype[$c338084cf8dfe3b4$var$UNSCOPABLES] == undefined) $c338084cf8dfe3b4$var$objectDefineProperty.f($c338084cf8dfe3b4$var$ArrayPrototype, $c338084cf8dfe3b4$var$UNSCOPABLES, {
    configurable: true,
    value: $c338084cf8dfe3b4$var$objectCreate(null)
});
// add a key to Array.prototype[@@unscopables]
var $c338084cf8dfe3b4$var$addToUnscopables = function(key) {
    $c338084cf8dfe3b4$var$ArrayPrototype[$c338084cf8dfe3b4$var$UNSCOPABLES][key] = true;
};
var $c338084cf8dfe3b4$var$$find = $c338084cf8dfe3b4$var$arrayIteration.find;
var $c338084cf8dfe3b4$var$FIND = 'find';
var $c338084cf8dfe3b4$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($c338084cf8dfe3b4$var$FIND in []) Array(1)[$c338084cf8dfe3b4$var$FIND](function() {
    $c338084cf8dfe3b4$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$c338084cf8dfe3b4$var$_export({
    target: 'Array',
    proto: true,
    forced: $c338084cf8dfe3b4$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $c338084cf8dfe3b4$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$c338084cf8dfe3b4$var$addToUnscopables($c338084cf8dfe3b4$var$FIND);
var $c338084cf8dfe3b4$var$_class, $c338084cf8dfe3b4$var$_class2, $c338084cf8dfe3b4$var$_temp;
var $c338084cf8dfe3b4$var$ReactTooltip = $c338084cf8dfe3b4$var$staticMethods($c338084cf8dfe3b4$var$_class = $c338084cf8dfe3b4$var$windowListener($c338084cf8dfe3b4$var$_class = $c338084cf8dfe3b4$var$customEvent($c338084cf8dfe3b4$var$_class = $c338084cf8dfe3b4$var$isCapture($c338084cf8dfe3b4$var$_class = $c338084cf8dfe3b4$var$getEffect($c338084cf8dfe3b4$var$_class = $c338084cf8dfe3b4$var$bodyMode($c338084cf8dfe3b4$var$_class = $c338084cf8dfe3b4$var$trackRemoval($c338084cf8dfe3b4$var$_class = ($c338084cf8dfe3b4$var$_temp = $c338084cf8dfe3b4$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $c338084cf8dfe3b4$var$_inherits(ReactTooltip, _React$Component);
    $c338084cf8dfe3b4$var$_createClass(ReactTooltip, null, [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).object,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($k8j0a))).bool
                };
            }
        }
    ]);
    function ReactTooltip(props) {
        var _this;
        $c338084cf8dfe3b4$var$_classCallCheck(this, ReactTooltip);
        _this = $c338084cf8dfe3b4$var$_possibleConstructorReturn(this, $c338084cf8dfe3b4$var$_getPrototypeOf(ReactTooltip).call(this, props));
        _this.state = {
            uuid: props.uuid || $c338084cf8dfe3b4$var$generateUUID(),
            place: props.place || 'top',
            // Direction of tooltip
            desiredPlace: props.place || 'top',
            type: 'dark',
            // Color theme of tooltip
            effect: 'float',
            // float or fixed
            show: false,
            border: false,
            customColors: {},
            offset: {},
            extraClass: '',
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $c338084cf8dfe3b4$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || '',
            possibleCustomEventsOff: props.possibleCustomEventsOff || '',
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            'showTooltip',
            'updateTooltip',
            'hideTooltip',
            'hideTooltipOnScroll',
            'getTooltipContent',
            'globalRebuild',
            'globalShow',
            'globalHide',
            'onWindowResize',
            'mouseOnToolTip'
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $c338084cf8dfe3b4$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, insecure = _this$props.insecure, resizeHide = _this$props.resizeHide;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case 'Document':
                    case 'HTMLDocument':
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case 'ShadowRoot':
                    default:
                        domRoot = parentNode;
                        break;
                } // Prevent styles duplication.
                if (!domRoot.querySelector('style[data-react-tooltip]')) {
                    var style = document.createElement('style');
                    style.textContent = $c338084cf8dfe3b4$var$baseCss;
                    style.setAttribute('data-react-tooltip', 'true');
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(':hover');
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = '[data-tip]:not([data-for])';
                else {
                    var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                    selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
                } // Scan document for shadow DOM elements
                $c338084cf8dfe3b4$var$nodeListToArray(document.getElementsByTagName('*')).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($c338084cf8dfe3b4$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($c338084cf8dfe3b4$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute('currentItem') === null) target.setAttribute('currentItem', 'false');
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
                    target.addEventListener('focus', _this3.showTooltip, isCaptureMode);
                    if (effect === 'float') target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
                    target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
                    target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
                });
                 // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                } // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
                target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
                target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children; // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $c338084cf8dfe3b4$var$getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                } // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute('data-tip');
                var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute('data-scroll-hide')) scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                 // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute('aria-describedby', this.state.uuid);
                 // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
                var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
                var result = $c338084cf8dfe3b4$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute('data-type') || self1.props.type || 'dark',
                        customColors: {
                            text: target.getAttribute('data-text-color') || self1.props.textColor || null,
                            background: target.getAttribute('data-background-color') || self1.props.backgroundColor || null,
                            border: target.getAttribute('data-border-color') || self1.props.borderColor || null,
                            arrow: target.getAttribute('data-arrow-color') || self1.props.arrowColor || null
                        },
                        effect: effect,
                        offset: offset,
                        html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self1.props.html) || false,
                        delayShow: target.getAttribute('data-delay-show') || self1.props.delayShow || 0,
                        delayHide: target.getAttribute('data-delay-hide') || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute('data-delay-update') || self1.props.delayUpdate || 0,
                        border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self1.props.border) || false,
                        extraClass: target.getAttribute('data-class') || self1.props["class"] || self1.props.className || '',
                        disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = $c338084cf8dfe3b4$var$getTipContent(originTooltip, '', _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                }; // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var afterShow = this.props.afterShow;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                 // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition();
                            if (isInvisible && afterShow) afterShow(e);
                        });
                    }
                };
                clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else updateState();
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var afterHide = this.props.afterHide;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                } // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute('aria-describedby');
                var resetState = function resetState() {
                    var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            } // Calculation the position
        },
        {
            key: "updatePosition",
            value: function updatePosition() {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $c338084cf8dfe3b4$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition();
                });
                 // Set tooltip position
                node.style.left = result.position.left + 'px';
                node.style.top = result.position.top + 'px';
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.delayShowLoop);
                clearTimeout(this.delayHideLoop);
                clearTimeout(this.delayReshow);
                clearInterval(this.intervalUpdateContent);
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== 'border' && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors['border']);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = $c338084cf8dfe3b4$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
                var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + (this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(' ');
                if (html) {
                    var htmlContent = "".concat(content, "\n<style aria-hidden=\"true\">").concat(style, "</style>");
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Wrapper, $c338084cf8dfe3b4$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(Wrapper, $c338084cf8dfe3b4$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $c338084cf8dfe3b4$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $c338084cf8dfe3b4$var$_objectSpread2({}, prevState, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Component), $c338084cf8dfe3b4$var$_defineProperty($c338084cf8dfe3b4$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: 'div',
    clickable: false
}), $c338084cf8dfe3b4$var$_defineProperty($c338084cf8dfe3b4$var$_class2, "supportedWrappers", [
    'div',
    'span'
]), $c338084cf8dfe3b4$var$_defineProperty($c338084cf8dfe3b4$var$_class2, "displayName", 'ReactTooltip'), $c338084cf8dfe3b4$var$_temp)) || $c338084cf8dfe3b4$var$_class) || $c338084cf8dfe3b4$var$_class) || $c338084cf8dfe3b4$var$_class) || $c338084cf8dfe3b4$var$_class) || $c338084cf8dfe3b4$var$_class) || $c338084cf8dfe3b4$var$_class) || $c338084cf8dfe3b4$var$_class;
var $c338084cf8dfe3b4$export$2e2bcd8739ae039 = $c338084cf8dfe3b4$var$ReactTooltip;

});
parcelRegister("8OOcO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66b9f009014e9b73$export$2e2bcd8739ae039; });

var $3uP6w = parcelRequire("3uP6w");

var $1dX0w = parcelRequire("1dX0w");
function $66b9f009014e9b73$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $3uP6w.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $1dX0w.default)(rnds);
}
var $66b9f009014e9b73$export$2e2bcd8739ae039 = $66b9f009014e9b73$var$v4;

});
parcelRegister("3uP6w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28bbd0a7b1a9e522$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $28bbd0a7b1a9e522$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var $28bbd0a7b1a9e522$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $28bbd0a7b1a9e522$export$2e2bcd8739ae039() {
    if (!$28bbd0a7b1a9e522$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    return $28bbd0a7b1a9e522$var$getRandomValues($28bbd0a7b1a9e522$var$rnds8);
}

});

parcelRegister("1dX0w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e44c6fc4e862f13$export$2e2bcd8739ae039; });
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $0e44c6fc4e862f13$var$byteToHex = [];
for(var $0e44c6fc4e862f13$var$i = 0; $0e44c6fc4e862f13$var$i < 256; ++$0e44c6fc4e862f13$var$i)$0e44c6fc4e862f13$var$byteToHex[$0e44c6fc4e862f13$var$i] = ($0e44c6fc4e862f13$var$i + 0x100).toString(16).substr(1);
function $0e44c6fc4e862f13$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $0e44c6fc4e862f13$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
var $0e44c6fc4e862f13$export$2e2bcd8739ae039 = $0e44c6fc4e862f13$var$bytesToUuid;

});



parcelRegister("05ceX", function(module, exports) {

$parcel$export(module.exports, "getRandomID", function () { return $e6a3468e30976dfb$export$aecd216cdb71c044; });
// Uses window.crypto to generate a random ID
// it is used only in web applications
const $e6a3468e30976dfb$export$aecd216cdb71c044 = ()=>window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36).slice(2, 9);

});

parcelRegister("9jdzG", function(module, exports) {

$parcel$export(module.exports, "useTooltip", function () { return $292bf89d8da3c3f1$export$1c4b08e0eca38426; });

var $6uYXW = parcelRequire("6uYXW");

var $gL91i = parcelRequire("gL91i");
function $292bf89d8da3c3f1$export$1c4b08e0eca38426() {
    const elementRef = (0, $6uYXW.useRef)(null);
    const tooltipHideTimeout = (0, $6uYXW.useRef)(null);
    const showTooltip = (0, $6uYXW.useCallback)(()=>{
        if (tooltipHideTimeout.current) clearTimeout(tooltipHideTimeout.current);
        if (elementRef.current) {
            (0, $gL91i.default).show(elementRef.current);
            tooltipHideTimeout.current = setTimeout(()=>{
                if (elementRef.current) (0, $gL91i.default).hide(elementRef.current);
            }, 3000);
        }
    }, []);
    return {
        elementRef: elementRef,
        showTooltip: showTooltip
    };
}

});

parcelRegister("fxmB5", function(module, exports) {

$parcel$export(module.exports, "FormField", function () { return $cacb0249dd696049$export$56e87bf42978147a; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jO1Lj = parcelRequire("jO1Lj");

var $cmDL9 = parcelRequire("cmDL9");

var $fqRO9 = parcelRequire("fqRO9");

var $lICJU = parcelRequire("lICJU");

var $hEAyK = parcelRequire("hEAyK");

var $16qxo = parcelRequire("16qxo");

var $5QqIi = parcelRequire("5QqIi");

var $jPANG = parcelRequire("jPANG");

var $5gnbF = parcelRequire("5gnbF");

var $kFdHs = parcelRequire("kFdHs");

var $99mod = parcelRequire("99mod");

var $48tuN = parcelRequire("48tuN");

var $kNccP = parcelRequire("kNccP");

var $lxFZd = parcelRequire("lxFZd");

var $7QebT = parcelRequire("7QebT");
function $cacb0249dd696049$export$56e87bf42978147a({ input: input, hasError: hasError, onChange: onChange, onMultiImagesChange: onMultiImagesChange, onViolations: onViolations, selectFieldType: selectFieldType, disabled: disabled, onKeyDown: onKeyDown, onBlur: onBlur }) {
    const isMultiImageField = (0, $jO1Lj.FormInputType).FileContent === input.type && (input.minimumPageCount && input.minimumPageCount > 1 || input.maximumPageCount && input.maximumPageCount > 1);
    return input.type === (0, $jO1Lj.FormInputType).Text ? /*#__PURE__*/ (0, $4m918.jsx)((0, $7QebT.TextField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError,
        onKeyDown: onKeyDown,
        onBlur: onBlur
    }, input.id) : input.type === (0, $jO1Lj.FormInputType).Email ? /*#__PURE__*/ (0, $4m918.jsx)((0, $16qxo.EmailField), {
        input: input,
        onChange: onChange,
        disabled: disabled
    }, input.id) : input.type === (0, $jO1Lj.FormInputType).Int ? /*#__PURE__*/ (0, $4m918.jsx)((0, $5gnbF.IntField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }, input.id) : input.type === (0, $jO1Lj.FormInputType).Number ? /*#__PURE__*/ (0, $4m918.jsx)((0, $99mod.NumberField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }, input.id) : input.type === (0, $jO1Lj.FormInputType).Amount ? /*#__PURE__*/ (0, $4m918.jsx)((0, $cmDL9.AmountField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }) : input.type === (0, $jO1Lj.FormInputType).Select ? /*#__PURE__*/ (0, $4m918.jsx)((0, $kNccP.SelectField), {
        type: selectFieldType ?? "combobox",
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }) : input.type === (0, $jO1Lj.FormInputType).SelectWithAmount ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lxFZd.SelectWithAmountField), {
        type: selectFieldType ?? "combobox",
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }) : [
        (0, $jO1Lj.FormInputType).Image
    ].includes(input.type) || isMultiImageField ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jPANG.ImageField), {
        onChange: onChange,
        onMultiImagesChange: onMultiImagesChange,
        onViolations: onViolations,
        disabled: disabled,
        hasError: hasError,
        input: input
    }) : [
        (0, $jO1Lj.FormInputType).File,
        (0, $jO1Lj.FormInputType).FileContent
    ].includes(input.type) ? /*#__PURE__*/ (0, $4m918.jsx)((0, $5QqIi.FileField), {
        onChange: onChange,
        onViolations: onViolations,
        disabled: disabled,
        input: input
    }) : input.type === (0, $jO1Lj.FormInputType).Date || input.type === (0, $jO1Lj.FormInputType).DateTime ? /*#__PURE__*/ (0, $4m918.jsx)((0, $hEAyK.DateField), {
        input: input,
        disabled: disabled,
        hasError: hasError,
        onChange: onChange,
        mode: input.type === (0, $jO1Lj.FormInputType).DateTime ? "datetime-local" : "date"
    }) : input.type === (0, $jO1Lj.FormInputType).MultiSelect ? /*#__PURE__*/ (0, $4m918.jsx)((0, $kFdHs.MultiSelectField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }) : input.type === (0, $jO1Lj.FormInputType).Autocomplete ? /*#__PURE__*/ (0, $4m918.jsx)((0, $fqRO9.AutocompleteField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }, input.id) : input.type === (0, $jO1Lj.FormInputType).Bool ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lICJU.BoolField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }, input.id) : input.type === (0, $jO1Lj.FormInputType).Phone ? /*#__PURE__*/ (0, $4m918.jsx)((0, $48tuN.PhoneField), {
        input: input,
        onChange: onChange,
        disabled: disabled,
        hasError: hasError
    }, input.id) : /*#__PURE__*/ (0, $4m918.jsxs)("span", {
        children: [
            "Can't find type ",
            input.type
        ]
    });
}

});
parcelRegister("cmDL9", function(module, exports) {

$parcel$export(module.exports, "AmountField", function () { return $aa1c2db8170e94fc$export$a193780d6f1da33f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5P656 = parcelRequire("5P656");

var $5hpYi = parcelRequire("5hpYi");

var $5rJrd = parcelRequire("5rJrd");

var $jbtl1 = parcelRequire("jbtl1");
const $aa1c2db8170e94fc$export$a193780d6f1da33f = ({ input: input, onChange: onChange, disabled: disabled })=>{
    const { formatAmount: formatAmount } = (0, $5hpYi.useIntl)();
    return (input.disabled || disabled) && input.value ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: formatAmount(input.value)
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $5rJrd.AmountInput), {
        required: input.required,
        value: input.value || new (0, $5P656.Amount)(0, input.defaultCurrency),
        currencies: input.currencies,
        onChange: (value)=>onChange && onChange(isNaN(value.value) ? undefined : value)
    });
};

});
parcelRegister("5rJrd", function(module, exports) {

$parcel$export(module.exports, "AmountInput", function () { return $5f488fe8ded01257$export$1a8f21b7e95bd816; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5P656 = parcelRequire("5P656");

var $8xKCH = parcelRequire("8xKCH");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $39jSd = parcelRequire("39jSd");

var $9mlIh = parcelRequire("9mlIh");
const $5f488fe8ded01257$export$1a8f21b7e95bd816 = (props)=>{
    const { variant: variant, value: value, onChange: onChange, currencies: currencies, required: required, className: className } = props;
    const [originalInput, setOriginalInput] = (0, $6uYXW.useState)("");
    (0, $6uYXW.useEffect)(()=>{
        if (value) {
            const amountValueString = (0, $5P656.getAmountValueString)(value);
            setOriginalInput(amountValueString);
        } else setOriginalInput("0");
    }, [
        value
    ]);
    const handleAmountChange = (str)=>{
        if ((0, $5P656.validAmountRegex).test(str)) {
            if (onChange && value) {
                const sanitizedValue = (0, $5P656.sanitizeAmountValue)(str, (0, $8xKCH.Currencies)[value.currency]?.decimal_number || 2);
                onChange(new (0, $5P656.Amount)(parseFloat(sanitizedValue), value.currency, str));
            }
        }
    };
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($5f488fe8ded01257$var$Row, {
        className: className,
        children: [
            value ? /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
                children: currencies ? /*#__PURE__*/ (0, $4m918.jsx)($5f488fe8ded01257$var$CurrencyContainer, {
                    $isRTL: isRTL,
                    children: /*#__PURE__*/ (0, $4m918.jsx)($5f488fe8ded01257$var$StyledSelectInput, {
                        disabled: props.disabled,
                        "data-testid": "currency-select-test",
                        innerId: "currencies",
                        value: value.currency,
                        options: currencies,
                        onChange: (currency)=>{
                            if (onChange) onChange((0, $5P656.switchCurrency)(value, currency));
                        },
                        disabledArrow: true,
                        withPointer: true
                    })
                }) : /*#__PURE__*/ (0, $4m918.jsx)($5f488fe8ded01257$var$CurrencyContainer, {
                    $isRTL: isRTL,
                    children: /*#__PURE__*/ (0, $4m918.jsx)($5f488fe8ded01257$var$CurrencyDisplay, {
                        big: (0, $8xKCH.Currencies)[value.currency].symbol.length === 1,
                        children: (0, $8xKCH.Currencies)[value.currency].symbol
                    })
                })
            }) : /*#__PURE__*/ (0, $4m918.jsx)($5f488fe8ded01257$var$CurrencyContainer, {}),
            /*#__PURE__*/ (0, $4m918.jsx)($5f488fe8ded01257$var$StyledTextInput, {
                id: props.id,
                "data-testid": "amount-input-test",
                variant: variant,
                disabled: props.disabled,
                required: required,
                value: originalInput,
                onChange: (event)=>handleAmountChange(event.target.value),
                autoComplete: "off"
            })
        ]
    });
};
const $5f488fe8ded01257$var$CurrencyContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background: #fff;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    bottom: 0;
    right: ${(props)=>props.$isRTL ? "auto" : 0};
    left: ${(props)=>props.$isRTL ? 0 : "auto"};
    width: 1px;
    height: calc(100% - 10px);
    background-color: ${(0, $22v9q.theme).colors.gray[500]};
    transform: translateY(-50%);
  }
`;
const $5f488fe8ded01257$var$StyledSelectInput = (0, $jb8NR.default)((0, $39jSd.SelectInput))`
  position: absolute;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
`;
const $5f488fe8ded01257$var$CurrencyDisplay = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  color: ${(0, $22v9q.theme).colors.gray[500]};
  font-size: ${({ big: big })=>big ? "26px" : "inherit"};
`;
const $5f488fe8ded01257$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;
const $5f488fe8ded01257$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  width: 100%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

});
parcelRegister("39jSd", function(module, exports) {

$parcel$export(module.exports, "SelectInput", function () { return $2c8e57bfce04ed01$export$d6701e98ab1a6725; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $f72IT = parcelRequire("f72IT");
var $bgHg3 = parcelRequire("bgHg3");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $4O97W = parcelRequire("4O97W");
const $2c8e57bfce04ed01$var$selectColor = {
    error: (0, $22v9q.theme).colors.error[500],
    optionText: "#000",
    singleText: "#000",
    disabledText: (0, $22v9q.theme).colors.gray[700],
    bg: {
        normal: "#fff",
        selected: (0, $22v9q.theme).colors.info[500],
        focus: (0, $22v9q.theme).colors.gray[50],
        hover: (0, $22v9q.theme).colors.gray[300],
        disabled: (0, $22v9q.theme).colors.gray[300]
    }
};
const $2c8e57bfce04ed01$var$customStyles = {
    control: (provided, state)=>({
            ...provided,
            fontFamily: "inherit",
            fontSize: "0.875rem",
            color: state.selectProps.$hasError ? $2c8e57bfce04ed01$var$selectColor.error : $2c8e57bfce04ed01$var$selectColor.optionText,
            cursor: state.selectProps.withPointer ? "pointer" : "default",
            borderRadius: "8px",
            padding: state.selectProps.disabledArrow ? "0 10px" : "9px 25px 9px 5px",
            outline: "none",
            width: "100%",
            minHeight: "48px",
            border: "0",
            boxShadow: "0",
            backgroundColor: state.selectProps.disabled ? $2c8e57bfce04ed01$var$selectColor.bg.disabled : $2c8e57bfce04ed01$var$selectColor.bg.normal,
            pointerEvents: state.selectProps.disabled ? "none" : "auto",
            "&:hover": {
                border: "0"
            }
        }),
    option: (provided, state)=>({
            ...provided,
            fontSize: "0.875rem",
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflow: "visible",
            paddingLeft: "20px",
            backgroundColor: state.isSelected ? $2c8e57bfce04ed01$var$selectColor.bg.selected : state.isFocused ? $2c8e57bfce04ed01$var$selectColor.bg.focus : $2c8e57bfce04ed01$var$selectColor.bg.normal,
            "&:hover": {
                backgroundColor: $2c8e57bfce04ed01$var$selectColor.bg.hover,
                color: $2c8e57bfce04ed01$var$selectColor.optionText
            }
        }),
    singleValue: (provided, state)=>({
            ...provided,
            whiteSpace: "normal",
            wordWrap: "break-word",
            position: "static",
            transform: "none",
            marginLeft: state.selectProps.disabledArrow ? "0" : "5px",
            color: state.selectProps.$hasError ? $2c8e57bfce04ed01$var$selectColor.error : state.selectProps.disabled ? $2c8e57bfce04ed01$var$selectColor.disabledText : $2c8e57bfce04ed01$var$selectColor.singleText
        }),
    valueContainer: (provided)=>({
            ...provided,
            padding: "2px 0 2px 8px",
            height: "auto",
            overflow: "visible"
        }),
    placeholder: (provided)=>({
            ...provided,
            position: "static",
            transform: "none"
        }),
    input: (provided)=>({
            ...provided,
            position: "absolute",
            top: "0"
        }),
    menuPortal: (base)=>({
            ...base,
            zIndex: 2000000001
        }),
    menu: (provided)=>({
            ...provided,
            maxHeight: "300px",
            overflowY: "auto"
        }),
    indicatorSeparator: (provided)=>({
            ...provided,
            width: 0
        })
};
const $2c8e57bfce04ed01$var$mergeStyles = (customStyle, selectStyle = {})=>{
    const mergedStyles = {
        ...customStyle
    };
    Object.keys(selectStyle).forEach((key)=>{
        if (typeof customStyle[key] === "object" && typeof selectStyle[key] === "object") mergedStyles[key] = {
            ...customStyle[key],
            ...selectStyle[key]
        };
        else mergedStyles[key] = selectStyle[key];
    });
    return mergedStyles;
};
const $2c8e57bfce04ed01$var$DropdownIndicator = (props)=>{
    if (props.selectProps.disabledArrow) return null; // Do not render the dropdown indicator if disabledArrow is true
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $f72IT.c).DropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)($2c8e57bfce04ed01$var$ChevronDownIcon, {
            $isRTL: !!props.selectProps.$isRTL
        })
    });
};
function $2c8e57bfce04ed01$export$d6701e98ab1a6725({ autoFocus: autoFocus = false, className: className, disabled: disabled, disabledArrow: disabledArrow, disabledOptions: disabledOptions, hasError: hasError = false, innerId: id, label: label, options: options, placeholder: placeholder, selectStyle: selectStyle, style: style, value: value, withPointer: withPointer, itemRenderer: itemRenderer = (v)=>`${v}`, onChange: onChange, ...rest }) {
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const selectRef = (0, $6uYXW.useRef)(null);
    (0, $6uYXW.useEffect)(()=>{
        if (autoFocus && selectRef.current) selectRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleChange = (selectedOption)=>{
        if (options && selectedOption) onChange(options[selectedOption.value - 1]);
    };
    const selectOptions = (0, $6uYXW.useMemo)(()=>[
            ...placeholder && !value && value !== 0 ? [
                {
                    value: "",
                    label: placeholder,
                    isDisabled: true
                }
            ] : [],
            ...options?.map((v, index)=>({
                    value: index + 1,
                    label: itemRenderer(v),
                    isDisabled: disabledOptions?.includes(v)
                })) || []
        ], [
        options,
        disabledOptions,
        placeholder,
        value,
        itemRenderer
    ]);
    const mergedStyles = (0, $6uYXW.useMemo)(()=>$2c8e57bfce04ed01$var$mergeStyles($2c8e57bfce04ed01$var$customStyles, selectStyle), [
        selectStyle
    ]);
    const selectedValue = selectOptions.find((option)=>option.label === itemRenderer(value));
    return /*#__PURE__*/ (0, $4m918.jsxs)($2c8e57bfce04ed01$var$SelectContainer, {
        className: className,
        $hasLabel: !!label,
        style: style,
        children: [
            label && /*#__PURE__*/ (0, $4m918.jsx)($2c8e57bfce04ed01$var$Label, {
                id: `${id}-label`,
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($2c8e57bfce04ed01$var$SelectWrapper, {
                "data-testid": "currency-select-test",
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bgHg3.default), {
                    ref: selectRef,
                    ...rest,
                    id: id,
                    className: "react-select-container",
                    classNamePrefix: "react-select",
                    "aria-labelledby": label ? `${id}-label` : undefined,
                    "aria-invalid": hasError,
                    styles: mergedStyles,
                    placeholder: placeholder,
                    value: selectedValue,
                    onChange: handleChange,
                    options: selectOptions,
                    menuPortalTarget: document.body,
                    $isRTL: !!isRTL,
                    $hasError: hasError,
                    withPointer: withPointer,
                    disabled: disabled,
                    disabledArrow: disabled || disabledArrow,
                    components: {
                        DropdownIndicator: $2c8e57bfce04ed01$var$DropdownIndicator
                    },
                    menuPlacement: "auto"
                })
            })
        ]
    });
}
const $2c8e57bfce04ed01$var$SelectContainer = (0, $jb8NR.default).div`
  display: inline-flex;
  flex-direction: ${(props)=>props.$hasLabel ? "column" : "row"};
  flex-shrink: 1;
  flex-grow: 1;
  background: #fff;
  border-radius: 10px;
`;
const $2c8e57bfce04ed01$var$Label = (0, $jb8NR.default).label`
  font-weight: 700;
  color: #000;
  margin-bottom: 10px;
  font-size: 1rem;
`;
const $2c8e57bfce04ed01$var$SelectWrapper = (0, $jb8NR.default).div`
  position: relative;
  flex-shrink: 1;
  flex-grow: 1;
`;
const $2c8e57bfce04ed01$var$ChevronDownIcon = (0, $jb8NR.default)((0, $4O97W.ChevronDown))`
  pointer-events: none;
  position: absolute;
  top: 50%;
  right: ${(props)=>props.$isRTL ? "unset" : "15px"};
  left: ${(props)=>props.$isRTL ? "10px" : "unset"};
  transform: translateY(-50%);
  width: 15px;
`;

});
parcelRegister("4O97W", function(module, exports) {

$parcel$export(module.exports, "ChevronDown", function () { return $b209c39eb2ed735c$export$4e3778eb35f54199; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $b209c39eb2ed735c$export$4e3778eb35f54199(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "none",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M0 0L18 0 18 18 0 18z",
                    transform: "translate(-1123 -70) translate(90 33) translate(909 33) rotate(-90 73 -51)"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    fill: props.fill ?? "#252525",
                    d: "M14.418 13.232c-.392.003-.77-.143-1.058-.407L8.785 8.497l-4.574 4.328c-.597.55-1.516.55-2.112 0-.28-.257-.438-.62-.438-.998 0-.38.158-.742.438-.998l5.63-5.326c.595-.552 1.516-.552 2.11 0l5.633 5.32c.28.257.438.62.438.998 0 .38-.158.742-.438.998-.287.265-.664.41-1.054.408",
                    transform: "translate(-1123 -70) translate(90 33) translate(909 33) rotate(-90 73 -51) rotate(-90 8.786 9.163)"
                })
            ]
        })
    });
}

});



parcelRegister("jbtl1", function(module, exports) {

$parcel$export(module.exports, "DisableValueText", function () { return $cec3f3138d178483$export$81ec01db243b992b; });

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
const $cec3f3138d178483$export$81ec01db243b992b = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  color: #b3b3b3;
`;

});


parcelRegister("fqRO9", function(module, exports) {

$parcel$export(module.exports, "AutocompleteField", function () { return $efd967a99be41d35$export$a7cdf89ad0449fb9; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $6pyVg = parcelRequire("6pyVg");

var $jbtl1 = parcelRequire("jbtl1");
const $efd967a99be41d35$export$a7cdf89ad0449fb9 = ({ input: input, disabled: disabled = false, onChange: onChange })=>{
    const handleOnChange = (0, $6uYXW.useCallback)((value)=>{
        if (onChange) onChange(value ?? "");
    }, [
        onChange
    ]);
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: input.value
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $6pyVg.AutocompleteInput), {
        inputId: input.id,
        value: input.value ?? "",
        onChange: handleOnChange
    });
};

});
parcelRegister("6pyVg", function(module, exports) {

$parcel$export(module.exports, "AutocompleteInput", function () { return $537d2bfd15b9c5d6$export$909904bdb4cb4458; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $equ2o = parcelRequire("equ2o");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $22v9q = parcelRequire("22v9q");
const $537d2bfd15b9c5d6$export$909904bdb4cb4458 = ({ inputId: inputId, className: className, onChange: onChange, value: value = "" })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [selected, setSelected] = (0, $6uYXW.useState)(null);
    (0, $6uYXW.useEffect)(()=>{
        if (value) setSelected({
            value: value,
            label: value
        });
        else setSelected(null);
    }, [
        value
    ]);
    const onSearchChange = (0, $6uYXW.useCallback)((search)=>{
        if (search.length < 3) return Promise.resolve([]);
        return (0, $kqXxS.autocompleteService).fieldAutocomplete(inputId, search).then((result)=>result.possibleValues).catch((error)=>{
            (0, $6JVVB.logger).error("Autocomplete error: " + error);
            return Promise.resolve([]);
        });
    }, [
        inputId
    ]);
    const handleChange = (0, $6uYXW.useCallback)((valueOption)=>{
        setSelected(valueOption);
        onChange(valueOption?.value ?? "");
    }, [
        onChange
    ]);
    const handleNoResultMessage = (0, $6uYXW.useCallback)(({ inputValue: inputValue })=>inputValue && inputValue.length >= 3 ? formatMessage("common.autocompletePicker.noResults") : formatMessage("common.autocompletePicker.searchPlaceholder"), [
        formatMessage
    ]);
    const style = {
        control: (base)=>({
                ...base,
                border: 0,
                boxShadow: "none"
            }),
        input: (base)=>({
                ...base,
                ...(0, $22v9q.theme).boldText
            }),
        placeholder: (base)=>({
                ...base,
                color: "#b1b1b1"
            }),
        dropdownIndicator: (base)=>({
                ...base,
                color: "#252525"
            })
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($537d2bfd15b9c5d6$var$Container, {
        className: className,
        children: /*#__PURE__*/ (0, $4m918.jsx)($537d2bfd15b9c5d6$var$SelectWrapper, {
            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $equ2o.default), {
                testID: `autocomplete-${inputId}-input`,
                className: "autocomplete-select",
                styles: style,
                cacheOptions: true,
                value: selected,
                loadOptions: onSearchChange,
                onChange: handleChange,
                menuPlacement: "auto",
                maxMenuHeight: 160,
                components: {
                    IndicatorSeparator: ()=>null
                },
                noOptionsMessage: handleNoResultMessage,
                placeholder: formatMessage("common.autocompletePicker.placeholder")
            })
        })
    });
};
const $537d2bfd15b9c5d6$var$Container = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  align-items: stretch;
  padding: 5px 0 5px 9px;
  border-radius: 10px;
  ${(0, $22v9q.shadows).medium};
  background-color: #ffffff;
`;
const $537d2bfd15b9c5d6$var$SelectWrapper = (0, $jb8NR.default).div`
  position: relative;
  flex-shrink: 1;
  flex-grow: 1;

  .autocomplete-select {
    font-family: inherit;
    font-size: 0.875rem;
    ${(0, $22v9q.theme).boldText};
    color: black;
    flex-shrink: 0;
    background-color: white;
    width: 100%;
  }
`;

});
parcelRegister("equ2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a80acb422aeed55b$export$2e2bcd8739ae039; });

var $jqghu = parcelRequire("jqghu");

var $9DelO = parcelRequire("9DelO");

var $clR1z = parcelRequire("clR1z");

var $f72IT = parcelRequire("f72IT");

var $a587z = parcelRequire("a587z");

var $hwUbf = parcelRequire("hwUbf");

var $h0Uae = parcelRequire("h0Uae");

var $6uYXW = parcelRequire("6uYXW");

var $j6KjX = parcelRequire("j6KjX");

var $3jNg8 = parcelRequire("3jNg8");

parcelRequire("6OIJ6");
parcelRequire("alU2v");
parcelRequire("eF7NI");
parcelRequire("6JczY");
parcelRequire("8Zamr");

var $a80acb422aeed55b$export$9c21a3269931e1e6 = {
    cacheOptions: false,
    defaultOptions: false,
    filterOption: null,
    isLoading: false
};
var $a80acb422aeed55b$export$fde5c51448bdd112 = function makeAsyncSelect(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $h0Uae.default)(Async, _Component);
        var _super = (0, $f72IT._)(Async);
        function Async(props) {
            var _this;
            (0, $a587z.default)(this, Async);
            _this = _super.call(this);
            _this.select = void 0;
            _this.lastRequest = void 0;
            _this.mounted = false;
            _this.handleInputChange = function(newValue, actionMeta) {
                var _this$props = _this.props, cacheOptions = _this$props.cacheOptions, onInputChange = _this$props.onInputChange; // TODO
                var inputValue = (0, $f72IT.H)(newValue, actionMeta, onInputChange);
                if (!inputValue) {
                    delete _this.lastRequest;
                    _this.setState({
                        inputValue: '',
                        loadedInputValue: '',
                        loadedOptions: [],
                        isLoading: false,
                        passEmptyOptions: false
                    });
                    return;
                }
                if (cacheOptions && _this.state.optionsCache[inputValue]) _this.setState({
                    inputValue: inputValue,
                    loadedInputValue: inputValue,
                    loadedOptions: _this.state.optionsCache[inputValue],
                    isLoading: false,
                    passEmptyOptions: false
                });
                else {
                    var request = _this.lastRequest = {};
                    _this.setState({
                        inputValue: inputValue,
                        isLoading: true,
                        passEmptyOptions: !_this.state.loadedInputValue
                    }, function() {
                        _this.loadOptions(inputValue, function(options) {
                            if (!_this.mounted) return;
                            if (request !== _this.lastRequest) return;
                            delete _this.lastRequest;
                            _this.setState(function(state) {
                                return {
                                    isLoading: false,
                                    loadedInputValue: inputValue,
                                    loadedOptions: options || [],
                                    passEmptyOptions: false,
                                    optionsCache: options ? (0, $f72IT.a)((0, $f72IT.a)({}, state.optionsCache), {}, (0, $clR1z.default)({}, inputValue, options)) : state.optionsCache
                                };
                            });
                        });
                    });
                }
                return inputValue;
            };
            _this.state = {
                defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
                inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
                isLoading: props.defaultOptions === true,
                loadedOptions: [],
                passEmptyOptions: false,
                optionsCache: {},
                prevDefaultOptions: undefined,
                prevCacheOptions: undefined
            };
            return _this;
        }
        (0, $hwUbf.default)(Async, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    this.mounted = true;
                    var defaultOptions = this.props.defaultOptions;
                    var inputValue = this.state.inputValue;
                    if (defaultOptions === true) this.loadOptions(inputValue, function(options) {
                        if (!_this2.mounted) return;
                        var isLoading = !!_this2.lastRequest;
                        _this2.setState({
                            defaultOptions: options || [],
                            isLoading: isLoading
                        });
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.mounted = false;
                }
            },
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                }
            },
            {
                key: "loadOptions",
                value: function loadOptions(inputValue, callback) {
                    var loadOptions = this.props.loadOptions;
                    if (!loadOptions) return callback();
                    var loader = loadOptions(inputValue, callback);
                    if (loader && typeof loader.then === 'function') loader.then(callback, function() {
                        return callback();
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    var _this$props2 = this.props;
                    _this$props2.loadOptions;
                    var isLoadingProp = _this$props2.isLoading, props = (0, $9DelO.default)(_this$props2, [
                        "loadOptions",
                        "isLoading"
                    ]);
                    var _this$state = this.state, defaultOptions = _this$state.defaultOptions, inputValue = _this$state.inputValue, isLoading = _this$state.isLoading, loadedInputValue = _this$state.loadedInputValue, loadedOptions = _this$state.loadedOptions, passEmptyOptions = _this$state.passEmptyOptions;
                    var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(SelectComponent, (0, $jqghu.default)({}, props, {
                        ref: function ref(_ref) {
                            _this3.select = _ref;
                        },
                        options: options,
                        isLoading: isLoading || isLoadingProp,
                        onInputChange: this.handleInputChange
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var newCacheOptionsState = props.cacheOptions !== state.prevCacheOptions ? {
                        prevCacheOptions: props.cacheOptions,
                        optionsCache: {}
                    } : {};
                    var newDefaultOptionsState = props.defaultOptions !== state.prevDefaultOptions ? {
                        prevDefaultOptions: props.defaultOptions,
                        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined
                    } : {};
                    return (0, $f72IT.a)((0, $f72IT.a)({}, newCacheOptionsState), newDefaultOptionsState);
                }
            }
        ]);
        return Async;
    }((0, $6uYXW.Component)), _class.defaultProps = $a80acb422aeed55b$export$9c21a3269931e1e6, _temp;
};
var $a80acb422aeed55b$var$SelectState = (0, $3jNg8.m)((0, $j6KjX.S));
var $a80acb422aeed55b$var$Async = $a80acb422aeed55b$export$fde5c51448bdd112($a80acb422aeed55b$var$SelectState);
var $a80acb422aeed55b$export$2e2bcd8739ae039 = $a80acb422aeed55b$var$Async;

});



parcelRegister("lICJU", function(module, exports) {

$parcel$export(module.exports, "BoolField", function () { return $1da200633d85418a$export$2a44f298c66baf25; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kw746 = parcelRequire("kw746");

var $jbtl1 = parcelRequire("jbtl1");
const $1da200633d85418a$export$2a44f298c66baf25 = ({ input: input, onChange: onChange, disabled: disabled })=>{
    (0, $6uYXW.useEffect)(()=>{
        if (!input.value) onChange?.(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const values = [
        {
            id: true,
            label: formatMessage("common.yes")
        },
        {
            id: false,
            label: formatMessage("common.no")
        }
    ];
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: input.label
    }) : /*#__PURE__*/ (0, $4m918.jsx)($1da200633d85418a$var$StyledRadioSelector, {
        innerId: input.id,
        values: new Map(values.map(({ id: id, label: label })=>[
                id,
                label
            ])),
        value: input.value,
        onChange: (value)=>onChange && onChange(value || false)
    });
};
const $1da200633d85418a$var$StyledRadioSelector = (0, $jb8NR.default)((0, $kw746.RadioSelector))`
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
`;

});

parcelRegister("hEAyK", function(module, exports) {

$parcel$export(module.exports, "DateField", function () { return $a0e7cd49bdc5b392$export$d9781c7894a82487; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $6evmn = parcelRequire("6evmn");
const $a0e7cd49bdc5b392$export$d9781c7894a82487 = ({ input: input, onChange: onChange, disabled: disabled, mode: mode })=>{
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(input.value);
    const handleOnChange = (val)=>{
        setValue(val);
        onChange?.(val);
    };
    (0, $6uYXW.useEffect)(()=>{
        if (input.value !== value) setValue(input.value);
    }, [
        input.value
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $6evmn.DateInput), {
            onChange: (e)=>handleOnChange?.(e.target.value),
            value: value ?? "",
            disabled: disabled,
            required: input.required,
            mode: mode
        })
    });
};

});

parcelRegister("16qxo", function(module, exports) {

$parcel$export(module.exports, "EmailField", function () { return $e49e9234d9f4a582$export$e78a688765264a0; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $9mlIh = parcelRequire("9mlIh");

var $jbtl1 = parcelRequire("jbtl1");
const $e49e9234d9f4a582$export$e78a688765264a0 = /*#__PURE__*/ (0, $6uYXW.forwardRef)(({ id: id, input: input, disabled: disabled, onChange: onChange }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: input.value
    }) : /*#__PURE__*/ (0, $4m918.jsx)($e49e9234d9f4a582$var$StyledTextInput, {
        id: id,
        "data-testid": id,
        ref: ref,
        required: input.required,
        value: input.value ?? "",
        type: "email",
        onChange: (e)=>onChange?.(e.target.value),
        placeholder: formatMessage("billFormScreen.textInputPlaceholder")
    });
});
const $e49e9234d9f4a582$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  input::placeholder {
    color: #b1b1b1;
  }
`;

});

parcelRegister("5QqIi", function(module, exports) {

$parcel$export(module.exports, "FileField", function () { return $8bd9511748b48a1a$export$ad2d04c8e5b15ad7; });

var $4m918 = parcelRequire("4m918");

var $kgvRN = parcelRequire("kgvRN");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $cw0v5 = parcelRequire("cw0v5");

var $5hpYi = parcelRequire("5hpYi");

var $nOswI = parcelRequire("nOswI");

var $gDlNU = parcelRequire("gDlNU");

var $j9aGM = parcelRequire("j9aGM");

var $kIvZR = parcelRequire("kIvZR");
const $8bd9511748b48a1a$export$ad2d04c8e5b15ad7 = ({ input: input, onChange: onChange, onViolations: onViolations, disabled: disabled })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    // Only what was picked here can be opened: a file already sent lives on the server, and its
    // contents were never brought back.
    const [pickedFile, setPickedFile] = (0, $6uYXW.useState)(null);
    // Surtout pas `document` : dans un navigateur, ce nom est déjà celui du DOM.
    const [sentDocument, setSentDocument] = (0, $6uYXW.useState)();
    const isDictInputValue = input.value && typeof input.value === "object";
    const hasExistingFile = (0, $6uYXW.useMemo)(()=>{
        if (typeof input.value === "object") return (0, $gDlNU.isDefined)(input.value?.documentId);
        return false;
    }, [
        input.value
    ]);
    const documentId = (0, $6uYXW.useMemo)(()=>hasExistingFile ? input.value.documentId : undefined, [
        hasExistingFile,
        input.value
    ]);
    // Le serveur ne renvoie que l'identifiant ; la date d'envoi se demande, une fois.
    (0, $6uYXW.useEffect)(()=>{
        if (!documentId) {
            setSentDocument(undefined);
            return;
        }
        let abandoned = false;
        (0, $nOswI.describeDocument)(documentId).then((described)=>!abandoned && setSentDocument(described)).catch(()=>undefined);
        return ()=>{
            abandoned = true;
        };
    }, [
        documentId
    ]);
    const onPreview = (0, $6uYXW.useCallback)(()=>{
        if (pickedFile) {
            window.open(URL.createObjectURL(pickedFile), "_blank", "noopener");
            return;
        }
        if (documentId) (0, $kIvZR.openDocument)(documentId).catch(()=>undefined);
    }, [
        documentId,
        pickedFile
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)($8bd9511748b48a1a$var$InputContainer, {
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $j9aGM.FileUploader), {
            initialFile: input.value && !isDictInputValue ? {
                name: formatMessage("billFormScreen.docInputFilled"),
                type: "image/png",
                size: (0, (/*@__PURE__*/$parcel$interopDefault($kgvRN)))((0, $cw0v5.base64ByteSize)(input.value))
            } : hasExistingFile ? {
                name: sentDocument ? formatMessage("common.fileField.sentOn", {
                    date: formatDate(new Date(sentDocument.uploadDate), {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric"
                    })
                }) : formatMessage("common.fileField.sent"),
                type: "",
                size: ""
            } : undefined,
            hasExistingFile: hasExistingFile,
            onViolations: onViolations,
            typeAllowed: input.acceptedTypes || (0, $j9aGM.DEFAULT_FILE_UPLOADER_TYPES),
            onPreviewClicked: pickedFile || documentId ? onPreview : undefined,
            fileUploaded: async (file)=>{
                setPickedFile(file);
                if (!file) {
                    onChange(null);
                    return;
                }
                const reader = new FileReader();
                reader.addEventListener("load", ()=>{
                    // convert image file to base64 string
                    const base64Image = reader.result?.toString() ?? null;
                    onChange(base64Image?.split("base64,")?.[1] ?? null);
                }, false);
                if (file) reader.readAsDataURL(file);
            },
            instructions: formatMessage("billFormScreen.docInputEmpty"),
            disabled: disabled,
            maxSize: input.maxSize,
            required: input.required,
            showDownloadIcon: true
        })
    });
};
const $8bd9511748b48a1a$var$InputContainer = (0, $jb8NR.default).div`
  position: relative;
  flex: 1;
`;

});
parcelRegister("kgvRN", function(module, exports) {
/*!
 2022 Jason Mulligan <jason.mulligan@avoidwork.com>
 @version 9.0.11
*/ !function(i, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    function i(t) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(i) {
            return typeof i;
        } : function(i) {
            return i && "function" == typeof Symbol && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
        }, i(t);
    }
    var t = "array", o = "bits", e = "byte", n = "bytes", r = "", b = "exponent", l = "function", a = "iec", d = "Invalid number", f = "Invalid rounding method", u = "jedec", s = "object", c = ".", p = "round", y = "kbit", m = "string", v = {
        symbol: {
            iec: {
                bits: [
                    "bit",
                    "Kibit",
                    "Mibit",
                    "Gibit",
                    "Tibit",
                    "Pibit",
                    "Eibit",
                    "Zibit",
                    "Yibit"
                ],
                bytes: [
                    "B",
                    "KiB",
                    "MiB",
                    "GiB",
                    "TiB",
                    "PiB",
                    "EiB",
                    "ZiB",
                    "YiB"
                ]
            },
            jedec: {
                bits: [
                    "bit",
                    "Kbit",
                    "Mbit",
                    "Gbit",
                    "Tbit",
                    "Pbit",
                    "Ebit",
                    "Zbit",
                    "Ybit"
                ],
                bytes: [
                    "B",
                    "KB",
                    "MB",
                    "GB",
                    "TB",
                    "PB",
                    "EB",
                    "ZB",
                    "YB"
                ]
            }
        },
        fullform: {
            iec: [
                "",
                "kibi",
                "mebi",
                "gibi",
                "tebi",
                "pebi",
                "exbi",
                "zebi",
                "yobi"
            ],
            jedec: [
                "",
                "kilo",
                "mega",
                "giga",
                "tera",
                "peta",
                "exa",
                "zetta",
                "yotta"
            ]
        }
    };
    function g(g) {
        var h = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, B = h.bits, M = void 0 !== B && B, S = h.pad, T = void 0 !== S && S, w = h.base, x = void 0 === w ? -1 : w, E = h.round, j = void 0 === E ? 2 : E, N = h.locale, P = void 0 === N ? r : N, k = h.localeOptions, G = void 0 === k ? {} : k, K = h.separator, Y = void 0 === K ? r : K, Z = h.spacer, z = void 0 === Z ? " " : Z, I = h.symbols, L = void 0 === I ? {} : I, O = h.standard, q = void 0 === O ? r : O, A = h.output, C = void 0 === A ? m : A, D = h.fullform, F = void 0 !== D && D, H = h.fullforms, J = void 0 === H ? [] : H, Q = h.exponent, R = void 0 === Q ? -1 : Q, U = h.roundingMethod, V = void 0 === U ? p : U, W = h.precision, X = void 0 === W ? 0 : W, $ = R, _ = Number(g), ii = [], ti = 0, oi = r;
        -1 === x && 0 === q.length ? (x = 10, q = u) : -1 === x && q.length > 0 ? x = (q = q === a ? a : u) === a ? 2 : 10 : q = 10 === (x = 2 === x ? 2 : 10) || q === u ? u : a;
        var ei = 10 === x ? 1e3 : 1024, ni = !0 === F, ri = _ < 0, bi = Math[V];
        if (isNaN(g)) throw new TypeError(d);
        if (i(bi) !== l) throw new TypeError(f);
        if (ri && (_ = -_), (-1 === $ || isNaN($)) && ($ = Math.floor(Math.log(_) / Math.log(ei))) < 0 && ($ = 0), $ > 8 && (X > 0 && (X += 8 - $), $ = 8), C === b) return $;
        if (0 === _) ii[0] = 0, oi = ii[1] = v.symbol[q][M ? o : n][$];
        else {
            ti = _ / (2 === x ? Math.pow(2, 10 * $) : Math.pow(1e3, $)), M && (ti *= 8) >= ei && $ < 8 && (ti /= ei, $++);
            var li = Math.pow(10, $ > 0 ? j : 0);
            ii[0] = bi(ti * li) / li, ii[0] === ei && $ < 8 && -1 === R && (ii[0] = 1, $++), oi = ii[1] = 10 === x && 1 === $ ? M ? y : "kB" : v.symbol[q][M ? o : n][$];
        }
        if (ri && (ii[0] = -ii[0]), X > 0 && (ii[0] = ii[0].toPrecision(X)), ii[1] = L[ii[1]] || ii[1], !0 === P ? ii[0] = ii[0].toLocaleString() : P.length > 0 ? ii[0] = ii[0].toLocaleString(P, G) : Y.length > 0 && (ii[0] = ii[0].toString().replace(c, Y)), T && !1 === Number.isInteger(ii[0]) && j > 0) {
            var ai = Y || c, di = ii[0].toString().split(ai), fi = di[1] || r, ui = fi.length, si = j - ui;
            ii[0] = "".concat(di[0]).concat(ai).concat(fi.padEnd(ui + si, "0"));
        }
        return ni && (ii[1] = J[$] ? J[$] : v.fullform[q][$] + (M ? "bit" : e) + (1 === ii[0] ? r : "s")), C === t ? ii : C === s ? {
            value: ii[0],
            symbol: ii[1],
            exponent: $,
            unit: oi
        } : ii.join(z);
    }
    return g.partial = function(i) {
        return function(t) {
            return g(t, i);
        };
    }, g;
});

});

parcelRegister("cw0v5", function(module, exports) {

$parcel$export(module.exports, "FileViolation", function () { return $c01d5ff2640f699e$export$bdb347be3d9711de; });
$parcel$export(module.exports, "acceptedTypeLabels", function () { return $c01d5ff2640f699e$export$c785261704cc615; });
$parcel$export(module.exports, "formatMaxSize", function () { return $c01d5ff2640f699e$export$911ed9b4c136ec9c; });
$parcel$export(module.exports, "base64ByteSize", function () { return $c01d5ff2640f699e$export$12fe8181c7a50fcc; });
const $c01d5ff2640f699e$var$MIB = 1048576;
var $c01d5ff2640f699e$export$bdb347be3d9711de = /*#__PURE__*/ function(FileViolation) {
    FileViolation["TooBig"] = "TOO_BIG";
    FileViolation["WrongType"] = "WRONG_TYPE";
    return FileViolation;
}({});
const $c01d5ff2640f699e$var$LABELS = {
    "application/pdf": "PDF",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
    "image/jpeg": "JPG",
    "image/jpg": "JPG",
    "image/png": "PNG",
    "image/gif": "GIF",
    "image/bmp": "BMP",
    "image/heic": "HEIC",
    "image/heif": "HEIC",
    "image/webp": "WEBP"
};
/** The same format under its several spellings. */ const $c01d5ff2640f699e$var$ALIASES = {
    JPEG: "JPG",
    HEIF: "HEIC"
};
function $c01d5ff2640f699e$export$f1d5cf548aa9b8d9(type) {
    const known = $c01d5ff2640f699e$var$LABELS[type.toLowerCase()];
    if (known) return known;
    const subtype = (type.includes("/") ? type.slice(type.lastIndexOf("/") + 1) : type).toUpperCase();
    return $c01d5ff2640f699e$var$ALIASES[subtype] ?? subtype;
}
function $c01d5ff2640f699e$export$c785261704cc615(acceptedTypes) {
    if (!acceptedTypes?.length) return [];
    return acceptedTypes.reduce((labels, type)=>{
        const label = $c01d5ff2640f699e$export$f1d5cf548aa9b8d9(type);
        return labels.includes(label) ? labels : [
            ...labels,
            label
        ];
    }, []);
}
function $c01d5ff2640f699e$export$911ed9b4c136ec9c(maxSize) {
    const inMib = maxSize / $c01d5ff2640f699e$var$MIB;
    return `${Number.isInteger(inMib) ? inMib : inMib.toFixed(1)} Mo`;
}
function $c01d5ff2640f699e$export$12fe8181c7a50fcc(base64) {
    const padding = base64.endsWith("==") ? 2 : base64.endsWith("=") ? 1 : 0;
    return Math.max(0, Math.floor(base64.length * 3 / 4) - padding);
}
function $c01d5ff2640f699e$export$7963b66bab8b9e14(facts, constraints) {
    const violations = [];
    if (constraints.maxSize !== undefined && facts.byteSize > constraints.maxSize) violations.push("TOO_BIG");
    const expected = $c01d5ff2640f699e$export$c785261704cc615(constraints.acceptedTypes);
    if (expected.length) {
        const actual = [
            facts.mimeType,
            facts.extension
        ].filter(Boolean).map((value)=>$c01d5ff2640f699e$export$f1d5cf548aa9b8d9(value));
        // A file whose own type could not be read is left alone: a wrong guess would block a document
        // the back office would have taken.
        if (actual.length && !actual.some((type)=>expected.includes(type))) violations.push("WRONG_TYPE");
    }
    return violations;
}

});

parcelRegister("nOswI", function(module, exports) {

$parcel$export(module.exports, "describeDocument", function () { return $6043404f55f29608$export$37c820c9aba85354; });

var $kqXxS = parcelRequire("kqXxS");
/**
 * Un champ se redessine souvent et le document, lui, ne bouge plus : sans ce cache la fiche est
 * redemandée à chaque rendu. Partagé, parce que le web et le mobile ont le même besoin.
 */ const $6043404f55f29608$var$described = new Map();
function $6043404f55f29608$export$37c820c9aba85354(documentId) {
    const known = $6043404f55f29608$var$described.get(documentId);
    if (known) return known;
    const pending = (0, $kqXxS.onboardingService).getDocument(documentId);
    $6043404f55f29608$var$described.set(documentId, pending);
    // Un échec ne se met pas en cache, sinon le champ reste muet jusqu'au prochain lancement.
    pending.catch(()=>$6043404f55f29608$var$described.delete(documentId));
    return pending;
}

});

parcelRegister("j9aGM", function(module, exports) {

$parcel$export(module.exports, "FileUploaderType", function () { return $2f60236daf01c8b2$export$269291b5dcead9db; });
$parcel$export(module.exports, "DEFAULT_FILE_UPLOADER_TYPES", function () { return $2f60236daf01c8b2$export$5ded5d9cf9ddd734; });
$parcel$export(module.exports, "MATCH_FILE_UPLOADER_TYPES", function () { return $2f60236daf01c8b2$export$581d431f9d2cfdd1; });
$parcel$export(module.exports, "FileUploader", function () { return $2f60236daf01c8b2$export$1a5cb5295a7d2749; });

var $4m918 = parcelRequire("4m918");

var $kgvRN = parcelRequire("kgvRN");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $cw0v5 = parcelRequire("cw0v5");

var $5hpYi = parcelRequire("5hpYi");

var $gDlNU = parcelRequire("gDlNU");





var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $hKftu = parcelRequire("hKftu");

var $jn1mK = parcelRequire("jn1mK");

var $4r738 = parcelRequire("4r738");
const $2f60236daf01c8b2$var$MAX_SIZE_ALLOWED = 7340032; // 7MB
const $2f60236daf01c8b2$var$MAX_SIZE_FILENAME = 15;
var $2f60236daf01c8b2$export$269291b5dcead9db = /*#__PURE__*/ function(FileUploaderType) {
    FileUploaderType["PDF"] = "application/pdf";
    FileUploaderType["JPG"] = "image/jpg";
    FileUploaderType["JPEG"] = "image/jpeg";
    FileUploaderType["PNG"] = "image/png";
    FileUploaderType["BMP"] = "image/bmp";
    FileUploaderType["GIF"] = "image/gif";
    FileUploaderType["DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    return FileUploaderType;
}({});
var $2f60236daf01c8b2$export$5926a1a8a1eb321c = /*#__PURE__*/ function(LegacyFileUploaderType) {
    LegacyFileUploaderType["PDF"] = "pdf";
    LegacyFileUploaderType["JPG"] = "jpg";
    LegacyFileUploaderType["JPEG"] = "jpeg";
    LegacyFileUploaderType["PNG"] = "png";
    LegacyFileUploaderType["BMP"] = "bmp";
    LegacyFileUploaderType["GIF"] = "gif";
    LegacyFileUploaderType["DOCX"] = "docx";
    return LegacyFileUploaderType;
}({});
const $2f60236daf01c8b2$export$5ded5d9cf9ddd734 = [
    "application/pdf",
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/bmp",
    "image/gif",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
const $2f60236daf01c8b2$export$67036f9d58683367 = [
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "bmp",
    "gif",
    "docx"
];
const $2f60236daf01c8b2$var$FILE_UPLOADER_TYPE_EXTENSIONS = new Map([
    [
        "application/pdf",
        "PDF"
    ],
    [
        "image/jpg",
        "JPG"
    ],
    [
        "image/jpeg",
        "JPEG"
    ],
    [
        "image/png",
        "PNG"
    ],
    [
        "image/png",
        "BMP"
    ],
    [
        "image/png",
        "GIF"
    ],
    [
        "image/png",
        "DOCX"
    ]
]);
const $2f60236daf01c8b2$export$581d431f9d2cfdd1 = {
    ["pdf"]: "application/pdf",
    ["jpg"]: "image/jpg",
    ["jpeg"]: "image/jpeg",
    ["png"]: "image/png",
    ["bmp"]: "image/bmp",
    ["gif"]: "image/gif",
    ["docx"]: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
};
const $2f60236daf01c8b2$var$matchingLegacyUploadType = (type)=>{
    switch(type){
        case "pdf":
            return "application/pdf";
        case "jpg":
            return "image/jpg";
        case "jpeg":
            return "image/jpeg";
        case "png":
            return "image/png";
        case "bmp":
            return "image/bmp";
        case "gif":
            return "image/gif";
        case "docx":
            return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        default:
            return null;
    }
};
const $2f60236daf01c8b2$export$1a5cb5295a7d2749 = ({ id: id, hasExistingFile: hasExistingFile, initialFile: initialFile, fileUploaded: fileUploaded, onViolations: onViolations, onPreviewClicked: onPreviewClicked, onImageDeleted: onImageDeleted, typeAllowed: typeAllowed, className: className, instructions: instructions, disabled: disabled, required: required, maxSize: maxSize, showDownloadIcon: showDownloadIcon, badgeIndex: badgeIndex, fileProps: fileProps })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const maxSizeAllowed = maxSize ?? $2f60236daf01c8b2$var$MAX_SIZE_ALLOWED;
    const [fileAccepted, setFileAccepted] = (0, $6uYXW.useState)(!!initialFile);
    const [fileProperties, setFileProperties] = (0, $6uYXW.useState)(null);
    const [error, setError] = (0, $6uYXW.useState)("");
    const uploadWording = instructions ?? "";
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const updateFile = (file, props)=>{
        setFileAccepted(!!file);
        fileUploaded(file, props);
    };
    const formatAllowedString = typeAllowed ? typeAllowed.join(",") : Array.from($2f60236daf01c8b2$var$FILE_UPLOADER_TYPE_EXTENSIONS.keys()).join(", ");
    const onFileAdded = (event)=>{
        const fileList = event.target.files;
        if (fileList && fileList.length > 0) {
            const fileName = truncateFilename(fileList[0].name, $2f60236daf01c8b2$var$MAX_SIZE_FILENAME);
            const fileType = fileList[0].type;
            const biggerThanAllowed = fileList[0].size > maxSizeAllowed;
            const wrongFormat = typeAllowed ? !typeAllowed.find((type)=>type === fileType) && !typeAllowed.find((type)=>fileType === $2f60236daf01c8b2$var$matchingLegacyUploadType(type)) : !$2f60236daf01c8b2$export$5ded5d9cf9ddd734.includes(fileType);
            // The field above reads these to open its constraints panel on the spot: a refused file
            // never reaches fileUploaded, so nobody upstream would otherwise hear about it.
            onViolations?.([
                ...biggerThanAllowed ? [
                    (0, $cw0v5.FileViolation).TooBig
                ] : [],
                ...wrongFormat ? [
                    (0, $cw0v5.FileViolation).WrongType
                ] : []
            ]);
            if (biggerThanAllowed) {
                setError(formatMessage("formError.invalidFileSize", {
                    size: (0, (/*@__PURE__*/$parcel$interopDefault($kgvRN)))(maxSizeAllowed)
                }));
                return;
            } else if (wrongFormat) setError(formatMessage("formError.invalidFileFormat", {
                formats: formatAllowedString
            }));
            else {
                setError("");
                const fileSizeLabel = (0, (/*@__PURE__*/$parcel$interopDefault($kgvRN)))(fileList[0].size);
                const filePropsData = {
                    name: fileName,
                    size: fileSizeLabel,
                    type: fileType
                };
                updateFile(fileList[0], filePropsData);
                setFileProperties(filePropsData);
            }
        }
    };
    function truncateFilename(originalFilename, len) {
        const extension = originalFilename.substring(originalFilename.lastIndexOf(".") + 1, originalFilename.length).toLowerCase();
        let filename = originalFilename.replace("." + extension, "");
        if (filename.length <= len) return originalFilename;
        else {
            const maxSizeTruncateFilename = Math.floor(len / 2);
            const firstPartStart = 0;
            const firstPartEnd = firstPartStart + maxSizeTruncateFilename;
            const secondPartStart = filename.length - maxSizeTruncateFilename;
            const secondPartEnd = secondPartStart + maxSizeTruncateFilename;
            filename = filename.substring(firstPartStart, firstPartEnd) + "..." + filename.substring(secondPartStart, secondPartEnd);
            return filename + "." + extension;
        }
    }
    $6uYXW.useEffect(()=>{
        if (fileProps) {
            setFileProperties(fileProps);
            setFileAccepted(true);
        }
    }, [
        fileProps
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($2f60236daf01c8b2$var$FileUploadContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($2f60236daf01c8b2$var$DropArea, {
                $isRTL: isRTL,
                $empty: !fileAccepted && !hasExistingFile,
                children: [
                    fileAccepted || hasExistingFile ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$GreenCheck, {
                                $isRTL: isRTL,
                                src: (0, {})
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$FileLabel, {
                                $isRTL: isRTL,
                                children: fileProperties && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4m918.jsx)("span", {
                                            children: fileProperties.name
                                        }),
                                        /*#__PURE__*/ (0, $4m918.jsxs)($2f60236daf01c8b2$var$FileSizeStyle, {
                                            children: [
                                                "(",
                                                fileProperties.size,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            (hasExistingFile || fileAccepted) && !!onPreviewClicked ? /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$PreviewIcon, {
                                $isRTL: isRTL,
                                onClick: ()=>onPreviewClicked(),
                                src: (0, {})
                            }) : null,
                            /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$RemoveFileIcon, {
                                $isRTL: isRTL,
                                src: (0, {}),
                                onClick: ()=>{
                                    updateFile(null);
                                    onImageDeleted?.();
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            (0, $gDlNU.isDefined)(badgeIndex) && /*#__PURE__*/ (0, $4m918.jsx)((0, $hKftu.BadgeCount), {
                                num: `${badgeIndex}`,
                                margin: 10
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$Placeholder, {
                                children: uploadWording
                            }),
                            showDownloadIcon ? /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$DownloadFileIcon, {
                                $isRTL: isRTL
                            }) : /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$FileIcon, {
                                $isRTL: isRTL,
                                src: (0, {})
                            })
                        ]
                    }),
                    !fileAccepted && !hasExistingFile && /*#__PURE__*/ (0, $4m918.jsx)("input", {
                        id: id,
                        type: "file",
                        accept: formatAllowedString,
                        required: required,
                        onChange: onFileAdded,
                        disabled: disabled,
                        autoFocus: true
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $4m918.jsx)($2f60236daf01c8b2$var$StyledErrorMessage, {
                children: error
            }) : null
        ]
    });
};
const $2f60236daf01c8b2$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 10px;
`;
const $2f60236daf01c8b2$var$FileSizeStyle = (0, $jb8NR.default).span`
  color: #828282;
  padding-left: 5px;
`;
const $2f60236daf01c8b2$var$FileUploadContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  ${(0, $22v9q.theme).mediumText};
`;
/* An empty zone reads as a target — dashed, flat. Once filled, it becomes a card. */ const $2f60236daf01c8b2$var$DropArea = (0, $jb8NR.default).div`
  position: relative;
  padding: ${(props)=>props.$isRTL ? "15px 17px 14px 66px" : "15px 66px 14px 17px"};
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  background-color: ${(props)=>props.$empty ? "transparent" : "#ffffff"};
  border-radius: 10px;
  ${(props)=>props.$empty ? "" : (0, $22v9q.shadows).medium};
  border: ${(props)=>props.dragging ? "1px dashed #2b2b2b" : props.$empty ? "1px dashed #d9d9d9" : "1px solid #ffffff"};

  input[type="file"],
  input[type="file"]::-webkit-file-upload-button {
    appearance: none;
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    width: 100%;
  }

  input[type="file"]:not(:disabled) {
    cursor: pointer;
  }
`;
const $2f60236daf01c8b2$var$FileLabel = (0, $jb8NR.default).div`
  min-height: 20px;
  display: flex;
  flex-direction: column;
  margin-left: ${(props)=>props.$isRTL ? 0 : 35}px;
  margin-right: ${(props)=>props.$isRTL ? 35 : 0}px;
`;
const $2f60236daf01c8b2$var$SideIcon = (0, $jb8NR.default).img`
  position: absolute;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  width: 25px;
  height: 25px;
  border-radius: 7px;
`;
const $2f60236daf01c8b2$var$FileIcon = (0, $jb8NR.default)($2f60236daf01c8b2$var$SideIcon)`
  right: ${(props)=>props.$isRTL ? "unset" : "10px"};
  left: ${(props)=>props.$isRTL ? "10px" : "unset"};
`;
const $2f60236daf01c8b2$var$DownloadFileIcon = (0, $jb8NR.default)((0, $4r738.DownloadIcon))`
  position: absolute;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  right: ${(props)=>props.$isRTL ? "unset" : "10px"};
  left: ${(props)=>props.$isRTL ? "10px" : "unset"};
  width: 25px;
  height: 25px;
  border-radius: 7px;
`;
const $2f60236daf01c8b2$var$RemoveFileIcon = (0, $jb8NR.default)($2f60236daf01c8b2$var$SideIcon)`
  width: 20px;
  height: 20px;
  right: ${(props)=>props.$isRTL ? "unset" : "10px"};
  left: ${(props)=>props.$isRTL ? "10px" : "unset"};
  z-index: 2;
`;
const $2f60236daf01c8b2$var$GreenCheck = (0, $jb8NR.default)($2f60236daf01c8b2$var$SideIcon)`
  width: 35px;
  height: 35px;
  right: ${(props)=>props.$isRTL ? "10px" : "unset"};
  left: ${(props)=>props.$isRTL ? "unset" : "10px"};
  z-index: 2;
  padding: 10px;
  border-radius: 35px;
  background-color: #2dd794;
`;
const $2f60236daf01c8b2$var$Placeholder = (0, $jb8NR.default).span`
  color: #b1b1b1;
  font-weight: bold;
`;
const $2f60236daf01c8b2$var$PreviewIcon = (0, $jb8NR.default)($2f60236daf01c8b2$var$SideIcon)`
  right: ${(props)=>props.$isRTL ? "unset" : "40px"};
  left: ${(props)=>props.$isRTL ? "40px" : "unset"};
`;

});
parcelRegister("hKftu", function(module, exports) {

$parcel$export(module.exports, "BadgeCount", function () { return $7bf4c437231def57$export$9e57541bac5c6a86; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");
const $7bf4c437231def57$export$9e57541bac5c6a86 = (props)=>{
    const { num: num, margin: margin = 0 } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)($7bf4c437231def57$var$Circle, {
        $isRTL: isRTL,
        margin: margin,
        children: /*#__PURE__*/ (0, $4m918.jsx)($7bf4c437231def57$var$Value, {
            children: num
        })
    });
};
const $7bf4c437231def57$var$Circle = (0, $jb8NR.default).div`
  display: flex;
  width: 22px;
  height: 22px;
  border-radius: 22px;
  background-color: #ececec;
  align-items: center;
  justify-content: center;
  margin-right: ${({ $isRTL: $isRTL, margin: margin })=>$isRTL ? 0 : margin}px;
  margin-left: ${({ $isRTL: $isRTL, margin: margin })=>$isRTL ? margin : 0}px;
`;
const $7bf4c437231def57$var$Value = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  color: black;
  font-size: 0.75rem;
`;

});

parcelRegister("4r738", function(module, exports) {

$parcel$export(module.exports, "DownloadIcon", function () { return $426f7a104ade04a0$export$4e54df4252b4a99c; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $426f7a104ade04a0$export$4e54df4252b4a99c(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    fill: "#000",
                    fillRule: "nonzero",
                    d: "M2 13c0-.5.5-1 1-1s1 .5 1 1v5c0 1.105.895 2 2 2h12c1.105 0 2-.895 2-2v-5c0-.552.448-1 1-1s1 .448 1 1v5c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4v-5z"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                    width: "2",
                    height: "14",
                    x: "11",
                    y: "1",
                    fill: "#000",
                    fillRule: "nonzero",
                    rx: "1",
                    transform: "rotate(-180 12 8)"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    fill: "#000",
                    fillRule: "nonzero",
                    d: "M7.707 15.707c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.024 0-1.414l5-5c.376-.376.98-.392 1.376-.036l5 4.5c.41.37.444 1.001.074 1.412-.37.41-1.001.444-1.412.074l-4.295-3.865-4.329 4.33z",
                    transform: "rotate(-180 12 12.5)"
                })
            ]
        })
    });
}

});


parcelRegister("kIvZR", function(module, exports) {

$parcel$export(module.exports, "openDocument", function () { return $c33a8b6e9f3c6e90$export$ce93c6f09fc13aff; });

var $kqXxS = parcelRequire("kqXxS");
async function $c33a8b6e9f3c6e90$export$ce93c6f09fc13aff(documentId) {
    const { data: data, contentType: contentType } = await (0, $kqXxS.onboardingService).getDocumentContent(documentId);
    const url = URL.createObjectURL(new Blob([
        data
    ], {
        type: contentType || "application/octet-stream"
    }));
    window.open(url, "_blank", "noopener");
    // L'onglet a pris sa copie ; garder l'URL vivante ne ferait que retenir le blob en mémoire.
    setTimeout(()=>URL.revokeObjectURL(url), 60000);
}

});


parcelRegister("jPANG", function(module, exports) {

$parcel$export(module.exports, "ImageField", function () { return $a5f4b5104d5d598c$export$d8d17c714ce39824; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $3PmF6 = parcelRequire("3PmF6");

var $22v9q = parcelRequire("22v9q");

var $j4m0d = parcelRequire("j4m0d");
const $a5f4b5104d5d598c$var$MAX_NB_PAGES = 20;
const $a5f4b5104d5d598c$export$d8d17c714ce39824 = ({ input: input, onChange: onChange, onMultiImagesChange: onMultiImagesChange, onViolations: onViolations, disabled: disabled })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const hasSeveralPages = (0, $6uYXW.useMemo)(()=>(0, $3PmF6.hasMultiplePages)(input), [
        input
    ]);
    const [nbInputs, setNbInputs] = (0, $6uYXW.useState)(input.minimumPageCount ?? 1);
    const [images, setImages] = (0, $6uYXW.useState)([]);
    const imageKeys = (0, $6uYXW.useMemo)(()=>nbInputs > 1 ? [
            ...Array(nbInputs).keys()
        ] : [
            0
        ], [
        nbInputs
    ]);
    const showAddButton = (0, $6uYXW.useMemo)(()=>{
        const maxPages = input.maximumPageCount ?? $a5f4b5104d5d598c$var$MAX_NB_PAGES;
        return maxPages > nbInputs;
    }, [
        input,
        nbInputs
    ]);
    const addImageInput = (0, $6uYXW.useCallback)(()=>{
        if (input.maximumPageCount && nbInputs < input.maximumPageCount) {
            setNbInputs(nbInputs + 1);
            setImages((prevImages)=>[
                    ...prevImages,
                    null
                ]);
        }
    }, [
        input,
        nbInputs
    ]);
    const handleImageChange = (image, index)=>{
        const updatedImages = [
            ...images
        ];
        updatedImages[index] = image;
        setImages(updatedImages);
        if (hasSeveralPages) onMultiImagesChange(updatedImages);
        else onChange(image?.base64.split("base64,")?.[1] ?? null, image?.fileProps);
    };
    const hasExistingFile = (key)=>!!images[key];
    (0, $6uYXW.useEffect)(()=>{
        if (hasSeveralPages && images.length < nbInputs) setImages((prevImages)=>{
            const newImages = [
                ...prevImages
            ];
            while(newImages.length < nbInputs)newImages.push(null); // only add
            return newImages;
        });
    }, [
        nbInputs,
        hasSeveralPages
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (input.values) setImages(input.values.slice(0, $a5f4b5104d5d598c$var$MAX_NB_PAGES));
        else if (input.value) setImages([
            input.value
        ]);
        else setImages(Array(input.minimumPageCount ?? 1).fill(null));
    }, [
        input.values,
        input.value
    ]);
    const isRequired = ()=>{
        const { minimumPageCount: minimumPageCount } = input;
        const imageCount = images.filter(Boolean).length;
        if (minimumPageCount) return imageCount < minimumPageCount;
        return input.required;
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            imageKeys.map((key, index)=>/*#__PURE__*/ (0, $4m918.jsx)("div", {
                    style: {
                        marginTop: 2,
                        marginBottom: 8
                    },
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $j4m0d.SingleImageField), {
                        onChange: (uploadedImage)=>handleImageChange(uploadedImage, index),
                        onViolations: onViolations,
                        disabled: disabled,
                        input: {
                            ...input,
                            required: isRequired()
                        },
                        hasExistingFile: hasExistingFile(key),
                        value: images[index]?.base64 ?? images[index]?.value ?? (index === 0 ? input.value : undefined),
                        fileProps: images[index]?.fileProps ?? (index === 0 ? input.fileProps : undefined),
                        index: hasSeveralPages ? index + 1 : undefined
                    })
                }, key)),
            showAddButton ? /*#__PURE__*/ (0, $4m918.jsx)($a5f4b5104d5d598c$var$AddPictureContainer, {
                onClick: addImageInput,
                children: /*#__PURE__*/ (0, $4m918.jsx)($a5f4b5104d5d598c$var$AddPictureWrapper, {
                    children: /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($a5f4b5104d5d598c$var$PlusTitle, {
                                children: "\uFF0B"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($a5f4b5104d5d598c$var$AddPictureTitle, {
                                children: formatMessage("registerScreen.addPictureButton")
                            })
                        ]
                    })
                })
            }) : null
        ]
    });
};
const $a5f4b5104d5d598c$var$AddPictureContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
  margin-top: 16px;
  border-color: #bfbfbf;
  border-style: dashed;
  border-radius: 11px;
  border-width: 1.5px;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  &:hover {
    cursor: pointer;
  }
`;
const $a5f4b5104d5d598c$var$AddPictureWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const $a5f4b5104d5d598c$var$AddPictureTitle = (0, $jb8NR.default).span`
  font-size: 0.85rem;
  ${(0, $22v9q.theme).mediumText};
  margin: 0 4px;
`;
const $a5f4b5104d5d598c$var$PlusTitle = (0, $jb8NR.default).span`
  margin: 0 4px;
  font-size: 0.875rem;
  ${(0, $22v9q.theme).boldText};
`;

});
parcelRegister("3PmF6", function(module, exports) {

$parcel$export(module.exports, "hasMultiplePages", function () { return $f9ae6c951271e8cd$export$f5b20568a0a272ef; });

var $gDlNU = parcelRequire("gDlNU");
function $f9ae6c951271e8cd$export$f5b20568a0a272ef(imageInput) {
    return (0, $gDlNU.isDefined)(imageInput.minimumPageCount) && (imageInput.minimumPageCount !== imageInput.maximumPageCount || imageInput.minimumPageCount > 1);
}

});

parcelRegister("j4m0d", function(module, exports) {

$parcel$export(module.exports, "SingleImageField", function () { return $2921a1ac0c8250d9$export$49b9a60196dca333; });

var $4m918 = parcelRequire("4m918");

var $kgvRN = parcelRequire("kgvRN");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $j9aGM = parcelRequire("j9aGM");
const $2921a1ac0c8250d9$export$49b9a60196dca333 = ({ input: input, value: value, index: index, disabled: disabled, hasExistingFile: hasExistingFile, fileProps: fileProps, onChange: onChange, onViolations: onViolations })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [previewDisplayed, setPreviewDisplayed] = (0, $6uYXW.useState)(false);
    const [image, setImage] = (0, $6uYXW.useState)(null);
    (0, $6uYXW.useEffect)(()=>{
        if (value) {
            if (typeof value === "string") setImage(value.startsWith("data:") ? value : `data:image/png;base64,${value}`);
            else if (typeof value === "object") setImage(null);
        } else setImage(null);
        setPreviewDisplayed(false);
    }, [
        value,
        index
    ]);
    let acceptedTypes;
    if (input.acceptedTypes) {
        const inputTypes = input.acceptedTypes;
        acceptedTypes = inputTypes.map((item)=>(0, $j9aGM.MATCH_FILE_UPLOADER_TYPES)[item] ?? item);
        acceptedTypes = acceptedTypes.filter((item)=>![
                (0, $j9aGM.FileUploaderType).PDF,
                (0, $j9aGM.FileUploaderType).DOCX
            ].includes(item));
    } else acceptedTypes = [
        (0, $j9aGM.FileUploaderType).PNG,
        (0, $j9aGM.FileUploaderType).JPG,
        (0, $j9aGM.FileUploaderType).JPEG
    ];
    const loadImgDimensions = async (imageUrl, setDimensions)=>{
        const img = new window.Image();
        img.src = imageUrl;
        img.onload = ()=>setDimensions({
                width: img.width,
                height: img.height
            });
        img.onerror = (err)=>{
            (0, $6JVVB.logger).debug("Image dimensions error : " + err);
        };
    };
    const onDelete = ()=>{
        setPreviewDisplayed(false);
        setImage(null);
        onChange(null);
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($2921a1ac0c8250d9$var$InputContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $j9aGM.FileUploader), {
                hasExistingFile: hasExistingFile,
                initialFile: value && hasExistingFile ? {
                    name: formatMessage("registerScreen.pictureInputFilled"),
                    type: (0, $j9aGM.FileUploaderType).PNG,
                    size: typeof value === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($kgvRN)))(value.length) : "0"
                } : undefined,
                typeAllowed: acceptedTypes,
                fileUploaded: async (file, props)=>{
                    if (!file) {
                        onChange(null);
                        return;
                    }
                    const reader = new FileReader();
                    console.log("Uploaded file name:", file.name);
                    reader.addEventListener("load", async ()=>{
                        const base64Image = reader.result?.toString();
                        if (base64Image) {
                            const setImageDimension = (imageDimension)=>{
                                onChange({
                                    base64: base64Image,
                                    width: imageDimension.width,
                                    height: imageDimension.height,
                                    fileProps: props
                                });
                            };
                            await loadImgDimensions(base64Image, setImageDimension);
                            setImage(base64Image);
                        }
                    }, false);
                    reader.readAsDataURL(file);
                },
                onPreviewClicked: ()=>setPreviewDisplayed(!previewDisplayed),
                onImageDeleted: onDelete,
                instructions: formatMessage("registerScreen.pictureInputEmpty"),
                disabled: disabled,
                maxSize: input.maxSize,
                onViolations: onViolations,
                required: input.required,
                badgeIndex: index,
                fileProps: fileProps
            }),
            previewDisplayed && image ? /*#__PURE__*/ (0, $4m918.jsx)($2921a1ac0c8250d9$var$PreviewImage, {
                src: image
            }) : null
        ]
    });
};
const $2921a1ac0c8250d9$var$InputContainer = (0, $jb8NR.default).div`
  position: relative;
  flex: 1;
`;
const $2921a1ac0c8250d9$var$PreviewImage = (0, $jb8NR.default).img`
  width: 100%;
  height: 100px;
  object-fit: contain;
`;

});


parcelRegister("5gnbF", function(module, exports) {

$parcel$export(module.exports, "IntField", function () { return $bc71545103fd2b67$export$bb5683a4a1865447; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $9mlIh = parcelRequire("9mlIh");

var $jbtl1 = parcelRequire("jbtl1");
const $bc71545103fd2b67$export$bb5683a4a1865447 = ({ input: input, disabled: disabled, hasError: hasError, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: input.value
    }) : /*#__PURE__*/ (0, $4m918.jsx)($bc71545103fd2b67$var$StyledTextInput, {
        value: input.value?.toString() ?? "",
        required: input.required,
        type: "text",
        onChange: (e)=>{
            if (onChange) {
                const parsedInt = parseInt(e.target.value);
                onChange(isNaN(parsedInt) ? 0 : parsedInt);
            }
        },
        placeholder: formatMessage("billFormScreen.textInputPlaceholder"),
        hasError: hasError ? hasError : null
    });
};
const $bc71545103fd2b67$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  input::placeholder {
    color: #b1b1b1;
  }
`;

});

parcelRegister("kFdHs", function(module, exports) {

$parcel$export(module.exports, "MultiSelectField", function () { return $f1b8cdf9c91a0b32$export$4efd8d874a0cb609; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $k4Ecv = parcelRequire("k4Ecv");

var $3yEBF = parcelRequire("3yEBF");

var $jbtl1 = parcelRequire("jbtl1");
const $f1b8cdf9c91a0b32$export$4efd8d874a0cb609 = ({ input: input, onChange: onChange, disabled: disabled })=>{
    const getInitialSelectedValues = ()=>{
        if (!input.value || !(0, $k4Ecv.isAnNotEmptyArray)(input.value)) return [];
        return input.value.map((i)=>input.values.find((e)=>e.id === i)).filter((item)=>item !== undefined);
    };
    const [selected, setSelected] = (0, $6uYXW.useState)(getInitialSelectedValues());
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: $f1b8cdf9c91a0b32$var$getSelectedOptionsLabels(input)
    }) : /*#__PURE__*/ (0, $4m918.jsx)($f1b8cdf9c91a0b32$var$InputContainer, {
        children: /*#__PURE__*/ (0, $4m918.jsx)($f1b8cdf9c91a0b32$var$MultiSelect, {
            innerId: input.id,
            options: input.values,
            selectedValues: selected,
            disabled: input.disabled,
            required: input.required,
            onChange: (selectedItems)=>{
                setSelected(selectedItems);
                if (onChange) onChange(selectedItems.length !== 0 ? selectedItems.map((v)=>v.id.trim()) : []);
            },
            itemRenderer: (v)=>v?.label ?? ""
        })
    });
};
const $f1b8cdf9c91a0b32$var$MultiSelect = (0, $jb8NR.default)((0, $3yEBF.MultiSelectInput))`
  width: 100%;

  .multi-select {
    background-color: transparent;
    > div {
      min-height: 48px;
      border-radius: 10px;
      border: 0;
      div[class$="-placeholder"] {
        position: relative;
        top: 10px;
      }
      div[class$="-multiValue"] + div {
        padding: 0;
        margin: 1px;
      }

      input[type="text"] {
        height: 0;
        padding: 0;
        margin: 0;
      }
    }
  }
`;
const $f1b8cdf9c91a0b32$var$InputContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  padding-bottom: 10px;
`;
function $f1b8cdf9c91a0b32$var$getSelectedOptionsLabels(input) {
    let selectedLabels = "";
    if (input.value) input.value.forEach((id)=>{
        const value = input.values?.find((e)=>e.id === id);
        if (value) selectedLabels = selectedLabels.concat(" " + value.label);
    });
    return selectedLabels;
}

});

parcelRegister("99mod", function(module, exports) {

$parcel$export(module.exports, "NumberField", function () { return $0a516775e1a5bf5f$export$63c5fa0b2fdccd2e; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $9mlIh = parcelRequire("9mlIh");

var $jbtl1 = parcelRequire("jbtl1");
const $0a516775e1a5bf5f$export$63c5fa0b2fdccd2e = ({ input: input, disabled: disabled, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: input.value
    }) : /*#__PURE__*/ (0, $4m918.jsx)($0a516775e1a5bf5f$var$StyledTextInput, {
        required: input.required,
        value: input.value?.toString() ?? "",
        type: "text",
        onChange: (e)=>{
            if (onChange) {
                const parsedFloat = parseFloat(e.target.value);
                onChange(isNaN(parsedFloat) ? 0 : parsedFloat);
            }
        },
        placeholder: formatMessage("billFormScreen.textInputPlaceholder")
    });
};
const $0a516775e1a5bf5f$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  input::placeholder {
    color: #b1b1b1;
  }
`;

});

parcelRegister("48tuN", function(module, exports) {

$parcel$export(module.exports, "PhoneField", function () { return $920a6b5d28b1e256$export$a2638f6c2fc66a45; });

var $4m918 = parcelRequire("4m918");

var $8Ba1X = parcelRequire("8Ba1X");

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3BANn = parcelRequire("3BANn");

var $3Ersk = parcelRequire("3Ersk");

var $1Ny0s = parcelRequire("1Ny0s");

var $jbtl1 = parcelRequire("jbtl1");
const $920a6b5d28b1e256$export$a2638f6c2fc66a45 = ({ input: input, disabled: disabled, onChange: onChange })=>{
    const defaultCountry = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).defaultCountry);
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)((0, $3BANn.getCountryByNumeric)(input.value?.country) || defaultCountry);
    const onPhoneNumberChange = (0, $6uYXW.useCallback)((phone)=>{
        const phoneNumberParsed = (0, $8Ba1X.parsePhoneNumberFromString)(phone, countryCode);
        if (phoneNumberParsed) onChange?.(phoneNumberParsed.number.substring(1));
    }, [
        countryCode,
        onChange
    ]);
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: input.value
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $1Ny0s.PhoneInput), {
            initialPhone: input.value?.number,
            required: input.required,
            onChangeCountryCode: setCountryCode,
            onChangePhoneNumber: onPhoneNumberChange,
            initialCountryCode: countryCode
        })
    });
};

});
parcelRegister("3BANn", function(module, exports) {

$parcel$export(module.exports, "getCountryByNumeric", function () { return $93f43f60a2cf518c$export$d48055d3baeb98e4; });
$parcel$export(module.exports, "setCountryFromAccount", function () { return $93f43f60a2cf518c$export$cf93ecfc58d2b64a; });

var $a5OyK = parcelRequire("a5OyK");

var $gbifg = parcelRequire("gbifg");
const $93f43f60a2cf518c$export$d48055d3baeb98e4 = (numeric)=>{
    const res = (0, $a5OyK.countriesArray).filter((c)=>c["iso-numeric"] === numeric);
    return res.length > 0 ? res[0]["alpha-2"] : null;
};
const $93f43f60a2cf518c$export$d78a38bc90a89b9f = (alpha2)=>(0, $a5OyK.countriesArray).find((country)=>country["alpha-2"] === alpha2) || null;
const $93f43f60a2cf518c$export$84f0c95cfd9167ca = (bic)=>{
    if (bic.length < 8) return null;
    return bic.substring(4, 6).toUpperCase();
};
const $93f43f60a2cf518c$export$cf93ecfc58d2b64a = (account, handleSetSelectedCountry)=>{
    if (account?.iban) {
        const countryCodeFromIban = (0, $gbifg.getCountryCodeFromIban)(account.iban);
        if (countryCodeFromIban) {
            const country = $93f43f60a2cf518c$export$d78a38bc90a89b9f(countryCodeFromIban);
            if (country) handleSetSelectedCountry(country);
        }
    } else if (account?.bic) {
        const countryCodeFromBic = $93f43f60a2cf518c$export$84f0c95cfd9167ca(account.bic);
        if (countryCodeFromBic) {
            const country = $93f43f60a2cf518c$export$d78a38bc90a89b9f(countryCodeFromBic);
            if (country) handleSetSelectedCountry(country);
        }
    }
};

});
parcelRegister("a5OyK", function(module, exports) {

$parcel$export(module.exports, "countries", function () { return $ee3412ff2ebcc714$export$e5ad74579c86b003; });
$parcel$export(module.exports, "countriesArray", function () { return $ee3412ff2ebcc714$export$73d6de068238ed0f; });






















































































































































































































































const $ee3412ff2ebcc714$export$e5ad74579c86b003 = {
    AD: {
        englishName: "Andorra",
        localeName: "Andorra",
        phoneCode: "376",
        flag: {}
    },
    AE: {
        englishName: "United Arab Emirates",
        localeName: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0651\u0629 \u0627\u0644\u0645\u062A\u0651\u062D\u062F\u0629",
        phoneCode: "971",
        flag: {}
    },
    AF: {
        englishName: "Afghanistan",
        localeName: "\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        phoneCode: "93",
        flag: {}
    },
    AG: {
        englishName: "Antigua and Barbuda",
        localeName: "Antigua and Barbuda",
        phoneCode: "1-268",
        flag: {}
    },
    AI: {
        englishName: "Anguilla",
        localeName: "Anguilla",
        phoneCode: "1-264",
        flag: {}
    },
    AL: {
        englishName: "Albania",
        localeName: "Shqip\xebria",
        phoneCode: "355",
        flag: {}
    },
    AM: {
        englishName: "Armenia",
        localeName: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
        phoneCode: "374",
        flag: {}
    },
    AO: {
        englishName: "Angola",
        localeName: "Angola",
        phoneCode: "244",
        flag: {}
    },
    AQ: {
        englishName: "Antarctica",
        localeName: "Antarctica,\xa0Ant\xe1rtico,\xa0Antarctique,\xa0\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u043A\u0435",
        phoneCode: "672",
        flag: undefined
    },
    AR: {
        englishName: "Argentina",
        localeName: "Argentina",
        phoneCode: "54",
        flag: {}
    },
    AS: {
        englishName: "American Samoa",
        localeName: "American Samoa",
        phoneCode: "1-684",
        flag: {}
    },
    AT: {
        englishName: "Austria",
        localeName: "\xd6sterreich",
        phoneCode: "43",
        flag: {}
    },
    AU: {
        englishName: "Australia",
        localeName: "Australia",
        phoneCode: "61",
        flag: {}
    },
    AW: {
        englishName: "Aruba",
        localeName: "Aruba",
        phoneCode: "297",
        flag: {}
    },
    AX: {
        englishName: "Aland Islands",
        localeName: "\xc5land",
        phoneCode: "297",
        flag: {}
    },
    AZ: {
        englishName: "Azerbaijan",
        localeName: "Az\u0259rbaycan",
        phoneCode: "994",
        flag: {}
    },
    BA: {
        englishName: "Bosnia and Herzegovina",
        localeName: "Bosna i Hercegovina",
        phoneCode: "387",
        flag: {}
    },
    BB: {
        englishName: "Barbados",
        localeName: "Barbados",
        phoneCode: "1-246",
        flag: {}
    },
    BD: {
        englishName: "Bangladesh",
        localeName: "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6",
        phoneCode: "880",
        flag: {}
    },
    BE: {
        englishName: "Belgium",
        localeName: "Belgi\xeb,\xa0Belgique,\xa0Belgien",
        phoneCode: "32",
        flag: {}
    },
    BF: {
        englishName: "Burkina Faso",
        localeName: "Burkina Faso",
        phoneCode: "226",
        flag: {}
    },
    BG: {
        englishName: "Bulgaria",
        localeName: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
        phoneCode: "359",
        flag: {}
    },
    BH: {
        englishName: "Bahrein",
        localeName: "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        phoneCode: "973",
        flag: {}
    },
    BI: {
        englishName: "Burundi",
        localeName: "Burundi",
        phoneCode: "257",
        flag: {}
    },
    BJ: {
        englishName: "Benin",
        localeName: "B\xe9nin",
        phoneCode: "229",
        flag: {}
    },
    BL: {
        englishName: "Saint-Barth\xe9lemy",
        localeName: "Saint-Barth\xe9lemy",
        phoneCode: "590",
        flag: {}
    },
    BM: {
        englishName: "Bermuda",
        localeName: "Bermuda",
        phoneCode: "1-441",
        flag: {}
    },
    BN: {
        englishName: "Brunei Darussalam",
        localeName: "Brunei Darussalam",
        phoneCode: "673",
        flag: {}
    },
    BO: {
        englishName: "Bolivia",
        localeName: "Bolivia,\xa0Bulibiya,\xa0Vol\xedvia,\xa0Wuliwya",
        phoneCode: "591",
        flag: {}
    },
    BQ: {
        englishName: "Caribbean Netherlands",
        localeName: "Caribisch Nederland",
        phoneCode: "591",
        flag: undefined
    },
    BR: {
        englishName: "Brazil",
        localeName: "Brasil",
        phoneCode: "55",
        flag: {}
    },
    BS: {
        englishName: "Bahamas",
        localeName: "Bahamas",
        phoneCode: "1-242",
        flag: {}
    },
    BT: {
        englishName: "Bhutan",
        localeName: "\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F61\u0F74\u0F63",
        phoneCode: "975",
        flag: {}
    },
    BV: {
        englishName: "Bouvet Island",
        localeName: "Bouvet\xf8ya",
        phoneCode: "975",
        flag: {}
    },
    BW: {
        englishName: "Botswana",
        localeName: "Botswana",
        phoneCode: "267",
        flag: {}
    },
    BY: {
        englishName: "Belarus",
        localeName: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
        phoneCode: "375",
        flag: {}
    },
    BZ: {
        englishName: "Belize",
        localeName: "Belize",
        phoneCode: "501",
        flag: {}
    },
    CA: {
        englishName: "Canada",
        localeName: "Canada",
        phoneCode: "1",
        flag: {}
    },
    CC: {
        englishName: "Cocos (Keeling) Islands",
        localeName: "Cocos (Keeling) Islands",
        phoneCode: "61",
        flag: {}
    },
    CD: {
        englishName: "Democratic Republic of the Congo",
        localeName: "R\xe9publique D\xe9mocratique du Congo",
        phoneCode: "243",
        flag: {}
    },
    CF: {
        englishName: "Centrafrican Republic",
        localeName: "R\xe9publique centrafricaine,\xa0K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka",
        phoneCode: "236",
        flag: {}
    },
    CG: {
        englishName: "Republic of the Congo\xa0(Congo-Brazzaville)",
        localeName: "R\xe9publique du Congo",
        phoneCode: "242",
        flag: {}
    },
    CH: {
        englishName: "Switzerland",
        localeName: "Schweiz,\xa0Suisse,\xa0Svizzera,\xa0Svizra",
        phoneCode: "41",
        flag: {}
    },
    CI: {
        englishName: "C\xf4te d'Ivoire",
        localeName: "C\xf4te d'Ivoire",
        phoneCode: "225",
        flag: {}
    },
    CK: {
        englishName: "Cook Islands",
        localeName: "Cook Islands,\xa0K\u016Bki \u02BB\u0100irani",
        phoneCode: "682",
        flag: {}
    },
    CL: {
        englishName: "Chile",
        localeName: "Chile",
        phoneCode: "56",
        flag: {}
    },
    CM: {
        englishName: "Cameroon",
        localeName: "Cameroun,\xa0Cameroon",
        phoneCode: "237",
        flag: {}
    },
    CN: {
        englishName: "China",
        localeName: "\u4E2D\u56FD",
        phoneCode: "86",
        flag: {}
    },
    CO: {
        englishName: "Colombia",
        localeName: "Colombia",
        phoneCode: "57",
        flag: {}
    },
    CR: {
        englishName: "Costa Rica",
        localeName: "Costa Rica",
        phoneCode: "506",
        flag: {}
    },
    CU: {
        englishName: "Cuba",
        localeName: "Cuba",
        phoneCode: "53",
        flag: {}
    },
    CV: {
        englishName: "Cabo Verde",
        localeName: "Cabo Verde",
        phoneCode: "238",
        flag: {}
    },
    CW: {
        englishName: "Cura\xe7ao",
        localeName: "Cura\xe7ao",
        phoneCode: "599",
        flag: {}
    },
    CX: {
        englishName: "Christmas Island",
        localeName: "Christmas Island",
        phoneCode: "61",
        flag: {}
    },
    CY: {
        englishName: "Cyprus",
        localeName: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2,\xa0Kibris",
        phoneCode: "357",
        flag: {}
    },
    CZ: {
        englishName: "Czech Republic",
        localeName: "\u010Cesk\xe1 republika",
        phoneCode: "420",
        flag: {}
    },
    DE: {
        englishName: "Germany",
        localeName: "Deutschland",
        phoneCode: "49",
        flag: {}
    },
    DJ: {
        englishName: "Djibouti",
        localeName: "Djibouti,\xa0\u062C\u064A\u0628\u0648\u062A\u064A,\xa0Jabuuti,\xa0Gabuutih",
        phoneCode: "253",
        flag: {}
    },
    DK: {
        englishName: "Denmark",
        localeName: "Danmark",
        phoneCode: "45",
        flag: {}
    },
    DM: {
        englishName: "Dominica",
        localeName: "Dominica",
        phoneCode: "1-767",
        flag: {}
    },
    DO: {
        englishName: "Dominican Republic",
        localeName: "Rep\xfablica Dominicana",
        phoneCode: "1",
        flag: {}
    },
    DZ: {
        englishName: "Algeria",
        localeName: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        phoneCode: "213",
        flag: {}
    },
    EC: {
        englishName: "Ecuador",
        localeName: "Ecuador",
        phoneCode: "593",
        flag: {}
    },
    EE: {
        englishName: "Estonia",
        localeName: "Eesti",
        phoneCode: "372",
        flag: {}
    },
    EG: {
        englishName: "Egypt",
        localeName: "\u0645\u0635\u0631",
        phoneCode: "20",
        flag: {}
    },
    EH: {
        englishName: "Western Sahara",
        localeName: "Sahara Occidental",
        phoneCode: "212",
        flag: undefined
    },
    ER: {
        englishName: "Eritrea",
        localeName: "\u12A4\u122D\u1275\u122B,\xa0\u0625\u0631\u062A\u0631\u064A\u0627,\xa0Eritrea",
        phoneCode: "291",
        flag: {}
    },
    ES: {
        englishName: "Spain",
        localeName: "Espa\xf1a",
        phoneCode: "34",
        flag: {}
    },
    ET: {
        englishName: "Ethiopia",
        localeName: "\u12A2\u1275\u12EE\u1335\u12EB,\xa0Itoophiyaa",
        phoneCode: "251",
        flag: {}
    },
    FI: {
        englishName: "Finland",
        localeName: "Suomi",
        phoneCode: "358",
        flag: {}
    },
    FJ: {
        englishName: "Fiji",
        localeName: "Fiji",
        phoneCode: "679",
        flag: {}
    },
    FK: {
        englishName: "Falkland Islands",
        localeName: "Falkland Islands",
        phoneCode: "500",
        flag: {}
    },
    FM: {
        englishName: "Micronesia (Federated States of)",
        localeName: "Micronesia",
        phoneCode: "691",
        flag: {}
    },
    FO: {
        englishName: "Faroe Islands",
        localeName: "F\xf8royar,\xa0F\xe6r\xf8erne",
        phoneCode: "298",
        flag: {}
    },
    FR: {
        englishName: "France",
        localeName: "France",
        phoneCode: "33",
        flag: {}
    },
    GA: {
        englishName: "Gabon",
        localeName: "Gabon",
        phoneCode: "241",
        flag: {}
    },
    GB: {
        englishName: "United Kingdom",
        localeName: "United Kingdom",
        phoneCode: "44",
        flag: {}
    },
    GD: {
        englishName: "Grenada",
        localeName: "Grenada",
        phoneCode: "1-473",
        flag: {}
    },
    GE: {
        englishName: "Georgia",
        localeName: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
        phoneCode: "995",
        flag: {}
    },
    GF: {
        englishName: "French Guiana",
        localeName: "Guyane fran\xe7aise",
        phoneCode: "594",
        flag: {}
    },
    GG: {
        englishName: "Guernsey",
        localeName: "Guernsey",
        phoneCode: "44-1481",
        flag: {}
    },
    GH: {
        englishName: "Ghana",
        localeName: "Ghana",
        phoneCode: "233",
        flag: {}
    },
    GI: {
        englishName: "Gibraltar",
        localeName: "Gibraltar",
        phoneCode: "350",
        flag: {}
    },
    GL: {
        englishName: "Greenland",
        localeName: "Kalaallit Nunaat,\xa0Gr\xf8nland",
        phoneCode: "299",
        flag: {}
    },
    GM: {
        englishName: "The Gambia",
        localeName: "The Gambia",
        phoneCode: "220",
        flag: {}
    },
    GN: {
        englishName: "Guinea",
        localeName: "Guin\xe9e",
        phoneCode: "224",
        flag: {}
    },
    GP: {
        englishName: "Guadeloupe",
        localeName: "Guadeloupe",
        phoneCode: "590",
        flag: {}
    },
    GQ: {
        englishName: "Equatorial Guinea",
        localeName: "Guiena ecuatorial,\xa0Guin\xe9e \xe9quatoriale,\xa0Guin\xe9 Equatorial",
        phoneCode: "240",
        flag: {}
    },
    GR: {
        englishName: "Greece",
        localeName: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
        phoneCode: "30",
        flag: {}
    },
    GS: {
        englishName: "South Georgia and the South Sandwich Islands",
        localeName: "South Georgia and the South Sandwich Islands",
        phoneCode: "30",
        flag: {}
    },
    GT: {
        englishName: "Guatemala",
        localeName: "Guatemala",
        phoneCode: "502",
        flag: {}
    },
    GU: {
        englishName: "Guam",
        localeName: "Guam,\xa0Gu\xe5h\xe5n",
        phoneCode: "1-671",
        flag: {}
    },
    GW: {
        englishName: "Guinea Bissau",
        localeName: "Guin\xe9-Bissau",
        phoneCode: "245",
        flag: {}
    },
    GY: {
        englishName: "Guyana",
        localeName: "Guyana",
        phoneCode: "592",
        flag: {}
    },
    HK: {
        englishName: "Hong Kong (SAR of China)",
        localeName: "\u9999\u6E2F,\xa0Hong Kong",
        phoneCode: "852",
        flag: {}
    },
    HM: {
        englishName: "Heard Island and McDonald Islands",
        localeName: "Heard Island and McDonald Islands",
        phoneCode: "852",
        flag: {}
    },
    HN: {
        englishName: "Honduras",
        localeName: "Honduras",
        phoneCode: "504",
        flag: {}
    },
    HR: {
        englishName: "Croatia",
        localeName: "Hrvatska",
        phoneCode: "385",
        flag: {}
    },
    HT: {
        englishName: "Haiti",
        localeName: "Ha\xefti,\xa0Ayiti",
        phoneCode: "509",
        flag: {}
    },
    HU: {
        englishName: "Hungary",
        localeName: "Magyarorsz\xe1g",
        phoneCode: "36",
        flag: {}
    },
    ID: {
        englishName: "Indonesia",
        localeName: "Indonesia",
        phoneCode: "62",
        flag: {}
    },
    IE: {
        englishName: "Ireland",
        localeName: "Ireland,\xa0\xc9ire",
        phoneCode: "353",
        flag: {}
    },
    IL: {
        englishName: "Israel",
        localeName: "\u05D9\u05E9\u05E8\u05D0\u05DC",
        phoneCode: "972",
        flag: {}
    },
    IM: {
        englishName: "Isle of Man",
        localeName: "Isle of Man",
        phoneCode: "44-1624",
        flag: {}
    },
    IN: {
        englishName: "India",
        localeName: "\u092D\u093E\u0930\u0924,\xa0India",
        phoneCode: "91",
        flag: {}
    },
    IO: {
        englishName: "British Indian Ocean Territory",
        localeName: "British Indian Ocean Territory",
        phoneCode: "246",
        flag: {}
    },
    IQ: {
        englishName: "Iraq",
        localeName: "\u0627\u0644\u0639\u0631\u0627\u0642,\xa0Iraq",
        phoneCode: "964",
        flag: {}
    },
    IR: {
        englishName: "Iran",
        localeName: "\u0627\u06CC\u0631\u0627\u0646",
        phoneCode: "98",
        flag: {}
    },
    IS: {
        englishName: "Iceland",
        localeName: "\xcdsland",
        phoneCode: "354",
        flag: {}
    },
    IT: {
        englishName: "Italy",
        localeName: "Italia",
        phoneCode: "39",
        flag: {}
    },
    JE: {
        englishName: "Jersey",
        localeName: "Jersey",
        phoneCode: "44-1534",
        flag: {}
    },
    JM: {
        englishName: "Jamaica",
        localeName: "Jamaica",
        phoneCode: "1-876",
        flag: {}
    },
    JO: {
        englishName: "Jordan",
        localeName: "\u0627\u0644\u0623\u064F\u0631\u0652\u062F\u064F\u0646",
        phoneCode: "962",
        flag: {}
    },
    JP: {
        englishName: "Japan",
        localeName: "\u65E5\u672C",
        phoneCode: "81",
        flag: {}
    },
    KE: {
        englishName: "Kenya",
        localeName: "Kenya",
        phoneCode: "254",
        flag: {}
    },
    KG: {
        englishName: "Kyrgyzstan",
        localeName: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D,\xa0\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F",
        phoneCode: "996",
        flag: {}
    },
    KH: {
        englishName: "Cambodia",
        localeName: "\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6",
        phoneCode: "855",
        flag: {}
    },
    KI: {
        englishName: "Kiribati",
        localeName: "Kiribati",
        phoneCode: "686",
        flag: {}
    },
    KM: {
        englishName: "Comores",
        localeName: "\uFE8D\uFEDF\uFED8\uFEE4\uFEAE\u064A,\xa0Comores,\xa0Komori",
        phoneCode: "269",
        flag: {}
    },
    KN: {
        englishName: "Saint Kitts and Nevis",
        localeName: "Saint Kitts and Nevis",
        phoneCode: "1-869",
        flag: {}
    },
    KP: {
        englishName: "North Korea",
        localeName: "\uBD81\uC870\uC120",
        phoneCode: "850",
        flag: {}
    },
    KR: {
        englishName: "South Korea",
        localeName: "\uB300\uD55C\uBBFC\uAD6D",
        phoneCode: "82",
        flag: {}
    },
    KW: {
        englishName: "Kuweit",
        localeName: "\u0627\u0644\u0643\u0648\u064A\u062A",
        phoneCode: "965",
        flag: {}
    },
    KY: {
        englishName: "Cayman Islands",
        localeName: "Cayman Islands",
        phoneCode: "1-345",
        flag: {}
    },
    KZ: {
        englishName: "Kazakhstan",
        localeName: "\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D,\xa0\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        phoneCode: "7",
        flag: {}
    },
    LA: {
        englishName: "Laos",
        localeName: "\u0E9B\u0EB0\u0E8A\u0EB2\u0E8A\u0EBB\u0E99\u0EA5\u0EB2\u0EA7",
        phoneCode: "856",
        flag: {}
    },
    LB: {
        englishName: "Lebanon",
        localeName: "\u0644\u0628\u0646\u0627\u0646,\xa0Liban",
        phoneCode: "961",
        flag: {}
    },
    LC: {
        englishName: "Saint Lucia",
        localeName: "Saint Lucia",
        phoneCode: "1-758",
        flag: {}
    },
    LI: {
        englishName: "Liechtenstein",
        localeName: "Liechtenstein",
        phoneCode: "423",
        flag: {}
    },
    LK: {
        englishName: "Sri Lanka",
        localeName: "\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF,\xa0\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8",
        phoneCode: "94",
        flag: {}
    },
    LR: {
        englishName: "Liberia",
        localeName: "Liberia",
        phoneCode: "231",
        flag: {}
    },
    LS: {
        englishName: "Lesotho",
        localeName: "Lesotho",
        phoneCode: "266",
        flag: {}
    },
    LT: {
        englishName: "Lithuania",
        localeName: "Lietuva",
        phoneCode: "370",
        flag: {}
    },
    LU: {
        englishName: "Luxembourg",
        localeName: "L\xebtzebuerg,\xa0Luxembourg,\xa0Luxemburg",
        phoneCode: "352",
        flag: {}
    },
    LV: {
        englishName: "Latvia",
        localeName: "Latvija",
        phoneCode: "371",
        flag: {}
    },
    LY: {
        englishName: "Libya",
        localeName: "\u0644\u064A\u0628\u064A\u0627",
        phoneCode: "218",
        flag: {}
    },
    MA: {
        englishName: "Morocco",
        localeName: "Maroc,\xa0\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31,\xa0\u0627\u0644\u0645\u063A\u0631\u0628",
        phoneCode: "212",
        flag: {}
    },
    MC: {
        englishName: "Monaco",
        localeName: "Monaco",
        phoneCode: "377",
        flag: {}
    },
    MD: {
        englishName: "Moldova",
        localeName: "Moldova,\xa0\u041C\u043E\u043B\u0434\u0430\u0432\u0438\u044F",
        phoneCode: "373",
        flag: {}
    },
    ME: {
        englishName: "Montenegro",
        localeName: "Crna Gora,\xa0\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
        phoneCode: "382",
        flag: {}
    },
    MF: {
        englishName: "Saint Martin (French part)",
        localeName: "Saint-Martin",
        phoneCode: "590",
        flag: {}
    },
    MG: {
        englishName: "Madagascar",
        localeName: "Madagasikara,\xa0Madagascar",
        phoneCode: "261",
        flag: {}
    },
    MH: {
        englishName: "Marshall Islands",
        localeName: "Marshall Islands",
        phoneCode: "692",
        flag: {}
    },
    MK: {
        englishName: "Macedonia (Former Yugoslav Republic of)",
        localeName: "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
        phoneCode: "389",
        flag: {}
    },
    ML: {
        englishName: "Mali",
        localeName: "Mali",
        phoneCode: "223",
        flag: {}
    },
    MM: {
        englishName: "Myanmar",
        localeName: "\u1019\u103C\u1014\u103A\u1019\u102C",
        phoneCode: "95",
        flag: {}
    },
    MN: {
        englishName: "Mongolia",
        localeName: "\u041C\u043E\u043D\u0433\u043E\u043B \u0423\u043B\u0441",
        phoneCode: "976",
        flag: {}
    },
    MO: {
        englishName: "Macao (SAR of China)",
        localeName: "\u6FB3\u9580,\xa0Macau",
        phoneCode: "853",
        flag: {}
    },
    MP: {
        englishName: "Northern Mariana Islands",
        localeName: "Northern Mariana Islands",
        phoneCode: "1-670",
        flag: {}
    },
    MQ: {
        englishName: "Martinique",
        localeName: "Martinique",
        phoneCode: "596",
        flag: {}
    },
    MR: {
        englishName: "Mauritania",
        localeName: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627,\xa0Mauritanie",
        phoneCode: "222",
        flag: {}
    },
    MS: {
        englishName: "Montserrat",
        localeName: "Montserrat",
        phoneCode: "1-664",
        flag: {}
    },
    MT: {
        englishName: "Malta",
        localeName: "Malta",
        phoneCode: "356",
        flag: {}
    },
    MU: {
        englishName: "Mauritius",
        localeName: "Maurice,\xa0Mauritius",
        phoneCode: "230",
        flag: {}
    },
    MV: {
        englishName: "Maldives",
        localeName: "Maldives",
        phoneCode: "960",
        flag: {}
    },
    MW: {
        englishName: "Malawi",
        localeName: "Malawi",
        phoneCode: "265",
        flag: {}
    },
    MX: {
        englishName: "Mexico",
        localeName: "M\xe9xico",
        phoneCode: "52",
        flag: {}
    },
    MY: {
        englishName: "Malaysia",
        localeName: "Malaysia",
        phoneCode: "60",
        flag: {}
    },
    MZ: {
        englishName: "Mozambique",
        localeName: "Mozambique",
        phoneCode: "258",
        flag: {}
    },
    NA: {
        englishName: "Namibia",
        localeName: "Namibia",
        phoneCode: "264",
        flag: {}
    },
    NC: {
        englishName: "New Caledonia",
        localeName: "Nouvelle-Cal\xe9donie",
        phoneCode: "687",
        flag: {}
    },
    NE: {
        englishName: "Niger",
        localeName: "Niger",
        phoneCode: "227",
        flag: {}
    },
    NF: {
        englishName: "Norfolk Island",
        localeName: "Norfolk Island",
        phoneCode: "227",
        flag: {}
    },
    NG: {
        englishName: "Nigeria",
        localeName: "Nigeria",
        phoneCode: "234",
        flag: {}
    },
    NI: {
        englishName: "Nicaragua",
        localeName: "Nicaragua",
        phoneCode: "505",
        flag: {}
    },
    NL: {
        englishName: "The Netherlands",
        localeName: "Nederland",
        phoneCode: "31",
        flag: {}
    },
    NO: {
        englishName: "Norway",
        localeName: "Norge,\xa0Noreg",
        phoneCode: "47",
        flag: {}
    },
    NP: {
        englishName: "Nepal",
        localeName: "\u0928\u0947\u092A\u093E\u0932",
        phoneCode: "977",
        flag: {}
    },
    NR: {
        englishName: "Nauru",
        localeName: "Nauru",
        phoneCode: "674",
        flag: {}
    },
    NU: {
        englishName: "Niue",
        localeName: "Niue",
        phoneCode: "683",
        flag: {}
    },
    NZ: {
        englishName: "New Zealand",
        localeName: "New Zealand",
        phoneCode: "64",
        flag: {}
    },
    OM: {
        englishName: "Oman",
        localeName: "\u0633\u0644\u0637\u0646\u0629 \u0639\u064F\u0645\u0627\u0646",
        phoneCode: "968",
        flag: {}
    },
    PA: {
        englishName: "Panama",
        localeName: "Panama",
        phoneCode: "507",
        flag: {}
    },
    PE: {
        englishName: "Peru",
        localeName: "Per\xfa",
        phoneCode: "51",
        flag: {}
    },
    PF: {
        englishName: "French Polynesia",
        localeName: "Polyn\xe9sie fran\xe7aise",
        phoneCode: "689",
        flag: {}
    },
    PG: {
        englishName: "Papua New Guinea",
        localeName: "Papua New Guinea",
        phoneCode: "675",
        flag: {}
    },
    PH: {
        englishName: "Philippines",
        localeName: "Philippines",
        phoneCode: "63",
        flag: {}
    },
    PK: {
        englishName: "Pakistan",
        localeName: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        phoneCode: "92",
        flag: {}
    },
    PL: {
        englishName: "Poland",
        localeName: "Polska",
        phoneCode: "48",
        flag: {}
    },
    PM: {
        englishName: "Saint Pierre and Miquelon",
        localeName: "Saint-Pierre-et-Miquelon",
        phoneCode: "508",
        flag: {}
    },
    PN: {
        englishName: "Pitcairn",
        localeName: "Pitcairn",
        phoneCode: "64",
        flag: {}
    },
    PR: {
        englishName: "Puerto Rico",
        localeName: "Puerto Rico",
        phoneCode: "1",
        flag: {}
    },
    PS: {
        englishName: "Palestinian Territory",
        localeName: "Palestinian Territory",
        phoneCode: "970",
        flag: {}
    },
    PT: {
        englishName: "Portugal",
        localeName: "Portugal",
        phoneCode: "351",
        flag: {}
    },
    PW: {
        englishName: "Palau",
        localeName: "Palau",
        phoneCode: "680",
        flag: {}
    },
    PY: {
        englishName: "Paraguay",
        localeName: "Paraguay",
        phoneCode: "595",
        flag: {}
    },
    QA: {
        englishName: "Qatar",
        localeName: "\u0642\u0637\u0631",
        phoneCode: "974",
        flag: {}
    },
    RE: {
        englishName: "Reunion",
        localeName: "La R\xe9union",
        phoneCode: "262",
        flag: {}
    },
    RO: {
        englishName: "Romania",
        localeName: "Rom\xe2nia",
        phoneCode: "40",
        flag: {}
    },
    RS: {
        englishName: "Serbia",
        localeName: "\u0421\u0440\u0431\u0438\u0458\u0430",
        phoneCode: "381",
        flag: {}
    },
    RU: {
        englishName: "Russia",
        localeName: "\u0420\u043E\u0441\u0441\u0438\u044F",
        phoneCode: "7",
        flag: {}
    },
    RW: {
        englishName: "Rwanda",
        localeName: "Rwanda",
        phoneCode: "250",
        flag: {}
    },
    SA: {
        englishName: "Saudi Arabia",
        localeName: "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        phoneCode: "966",
        flag: {}
    },
    SB: {
        englishName: "Solomon Islands",
        localeName: "Solomon Islands",
        phoneCode: "677",
        flag: {}
    },
    SC: {
        englishName: "Seychelles",
        localeName: "Seychelles",
        phoneCode: "248",
        flag: {}
    },
    SD: {
        englishName: "Sudan",
        localeName: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        phoneCode: "249",
        flag: {}
    },
    SE: {
        englishName: "Sweden",
        localeName: "Sverige",
        phoneCode: "46",
        flag: {}
    },
    SG: {
        englishName: "Singapore",
        localeName: "Singapore",
        phoneCode: "65",
        flag: {}
    },
    SH: {
        englishName: "Saint Helena",
        localeName: "Saint Helena",
        phoneCode: "290",
        flag: {}
    },
    SI: {
        englishName: "Slovenia",
        localeName: "Slovenija",
        phoneCode: "386",
        flag: {}
    },
    SJ: {
        englishName: "Svalbard and Jan Mayen",
        localeName: "Svalbard and Jan Mayen",
        phoneCode: "47",
        flag: {}
    },
    SK: {
        englishName: "Slovakia",
        localeName: "Slovensko",
        phoneCode: "421",
        flag: {}
    },
    SL: {
        englishName: "Sierra Leone",
        localeName: "Sierra Leone",
        phoneCode: "232",
        flag: {}
    },
    SM: {
        englishName: "San Marino",
        localeName: "San Marino",
        phoneCode: "378",
        flag: {}
    },
    SN: {
        englishName: "S\xe9n\xe9gal",
        localeName: "S\xe9n\xe9gal",
        phoneCode: "221",
        flag: {}
    },
    SO: {
        englishName: "Somalia",
        localeName: "Somalia,\xa0\u0627\u0644\u0635\u0648\u0645\u0627\u0644",
        phoneCode: "252",
        flag: {}
    },
    SR: {
        englishName: "Suriname",
        localeName: "Suriname",
        phoneCode: "597",
        flag: {}
    },
    ST: {
        englishName: "S\xe3o Tom\xe9 and Pr\xedncipe",
        localeName: "S\xe3o Tom\xe9 e Pr\xedncipe",
        phoneCode: "239",
        flag: {}
    },
    SS: {
        englishName: "South Sudan",
        localeName: "South Sudan",
        phoneCode: "211",
        flag: {}
    },
    SV: {
        englishName: "El Salvador",
        localeName: "El Salvador",
        phoneCode: "503",
        flag: {}
    },
    SX: {
        englishName: "Saint Martin (Dutch part)",
        localeName: "Sint Maarten",
        phoneCode: "1-721",
        flag: {}
    },
    SY: {
        englishName: "Syria",
        localeName: "\u0633\u0648\u0631\u064A\u0627,\xa0S\u016Briyya",
        phoneCode: "963",
        flag: {}
    },
    SZ: {
        englishName: "Swaziland",
        localeName: "Swaziland",
        phoneCode: "268",
        flag: {}
    },
    TC: {
        englishName: "Turks and Caicos Islands",
        localeName: "Turks and Caicos Islands",
        phoneCode: "1-649",
        flag: {}
    },
    TD: {
        englishName: "Chad",
        localeName: "Tchad,\xa0\u062A\u0634\u0627\u062F",
        phoneCode: "235",
        flag: {}
    },
    TF: {
        englishName: "French Southern and Antarctic Lands",
        localeName: "Terres australes et antarctiques fran\xe7aises",
        phoneCode: "235",
        flag: {}
    },
    TG: {
        englishName: "Togo",
        localeName: "Togo",
        phoneCode: "228",
        flag: {}
    },
    TH: {
        englishName: "Thailand",
        localeName: "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22",
        phoneCode: "66",
        flag: {}
    },
    TJ: {
        englishName: "Tajikistan",
        localeName: "\u0422\u043E\u0447\u0438\u043A\u0438\u0441\u0442\u043E\u043D",
        phoneCode: "992",
        flag: {}
    },
    TK: {
        englishName: "Tokelau",
        localeName: "Tokelau",
        phoneCode: "690",
        flag: {}
    },
    TL: {
        englishName: "Timor-Leste",
        localeName: "Timor-Leste,\xa0Timor Lorosa'e",
        phoneCode: "670",
        flag: {}
    },
    TM: {
        englishName: "Turkmenistan",
        localeName: "T\xfcrkmenistan",
        phoneCode: "993",
        flag: {}
    },
    TN: {
        englishName: "Tunisia",
        localeName: "\u062A\u0648\u0646\u0633,\xa0Tunisie",
        phoneCode: "216",
        flag: {}
    },
    TO: {
        englishName: "Tonga",
        localeName: "Tonga",
        phoneCode: "676",
        flag: {}
    },
    TR: {
        englishName: "Turkey",
        localeName: "T\xfcrkiye",
        phoneCode: "90",
        flag: {}
    },
    TT: {
        englishName: "Trinidad and Tobago",
        localeName: "Trinidad and Tobago",
        phoneCode: "1-868",
        flag: {}
    },
    TV: {
        englishName: "Tuvalu",
        localeName: "Tuvalu",
        phoneCode: "688",
        flag: {}
    },
    TW: {
        englishName: "Taiwan",
        localeName: "Taiwan",
        phoneCode: "886",
        flag: {}
    },
    TZ: {
        englishName: "Tanzania",
        localeName: "Tanzania",
        phoneCode: "255",
        flag: {}
    },
    UA: {
        englishName: "Ukraine",
        localeName: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        phoneCode: "380",
        flag: {}
    },
    UG: {
        englishName: "Uganda",
        localeName: "Uganda",
        phoneCode: "256",
        flag: {}
    },
    UM: {
        englishName: "United States Minor Outlying Islands",
        localeName: "United States Minor Outlying Islands",
        phoneCode: "256",
        flag: {}
    },
    US: {
        englishName: "United States of America",
        localeName: "United States of America",
        phoneCode: "1",
        flag: {}
    },
    UY: {
        englishName: "Uruguay",
        localeName: "Uruguay",
        phoneCode: "598",
        flag: {}
    },
    UZ: {
        englishName: "Uzbekistan",
        localeName: "O'zbekiston",
        phoneCode: "998",
        flag: {}
    },
    VA: {
        englishName: "City of the Vatican",
        localeName: "Citt\xe0 del Vaticano",
        phoneCode: "379",
        flag: {}
    },
    VC: {
        englishName: "Saint Vincent and the Grenadines",
        localeName: "Saint Vincent and the Grenadines",
        phoneCode: "1-784",
        flag: {}
    },
    VE: {
        englishName: "Venezuela",
        localeName: "Venezuela",
        phoneCode: "58",
        flag: {}
    },
    VG: {
        englishName: "British Virgin Islands",
        localeName: "British Virgin Islands",
        phoneCode: "1-284",
        flag: {}
    },
    VI: {
        englishName: "United States Virgin Islands",
        localeName: "United States Virgin Islands",
        phoneCode: "1-340",
        flag: {}
    },
    VN: {
        englishName: "Vietnam",
        localeName: "Vi\u1EC7t Nam",
        phoneCode: "84",
        flag: {}
    },
    VU: {
        englishName: "Vanuatu",
        localeName: "Vanuatu",
        phoneCode: "678",
        flag: {}
    },
    WF: {
        englishName: "Wallis and Futuna",
        localeName: "Wallis-et-Futuna",
        phoneCode: "681",
        flag: {}
    },
    WS: {
        englishName: "Samoa",
        localeName: "Samoa",
        phoneCode: "685",
        flag: {}
    },
    YE: {
        englishName: "Yemen",
        localeName: "\u0627\u0644\u064A\u064E\u0645\u064E\u0646",
        phoneCode: "967",
        flag: {}
    },
    YT: {
        englishName: "Mayotte",
        localeName: "Mayotte",
        phoneCode: "269",
        flag: {}
    },
    ZA: {
        englishName: "South Africa",
        localeName: "South Africa",
        phoneCode: "27",
        flag: {}
    },
    ZM: {
        englishName: "Zambia",
        localeName: "Zambia",
        phoneCode: "260",
        flag: {}
    },
    ZW: {
        englishName: "Zimbabwe",
        localeName: "Zimbabwe",
        phoneCode: "263",
        flag: {}
    }
};
const $ee3412ff2ebcc714$export$73d6de068238ed0f = [
    {
        name: "Afghanistan",
        "alpha-2": "AF",
        "iso-numeric": "004"
    },
    {
        name: "\xc5land Islands",
        "alpha-2": "AX",
        "iso-numeric": "248"
    },
    {
        name: "Albania",
        "alpha-2": "AL",
        "iso-numeric": "008"
    },
    {
        name: "Algeria",
        "alpha-2": "DZ",
        "iso-numeric": "012"
    },
    {
        name: "American Samoa",
        "alpha-2": "AS",
        "iso-numeric": "016"
    },
    {
        name: "Andorra",
        "alpha-2": "AD",
        "iso-numeric": "020"
    },
    {
        name: "Angola",
        "alpha-2": "AO",
        "iso-numeric": "024"
    },
    {
        name: "Anguilla",
        "alpha-2": "AI",
        "iso-numeric": "660"
    },
    {
        name: "Antarctica",
        "alpha-2": "AQ",
        "iso-numeric": "010"
    },
    {
        name: "Antigua and Barbuda",
        "alpha-2": "AG",
        "iso-numeric": "028"
    },
    {
        name: "Argentina",
        "alpha-2": "AR",
        "iso-numeric": "032"
    },
    {
        name: "Armenia",
        "alpha-2": "AM",
        "iso-numeric": "051"
    },
    {
        name: "Aruba",
        "alpha-2": "AW",
        "iso-numeric": "533"
    },
    {
        name: "Australia",
        "alpha-2": "AU",
        "iso-numeric": "036"
    },
    {
        name: "Austria",
        "alpha-2": "AT",
        "iso-numeric": "040"
    },
    {
        name: "Azerbaijan",
        "alpha-2": "AZ",
        "iso-numeric": "031"
    },
    {
        name: "Bahamas",
        "alpha-2": "BS",
        "iso-numeric": "044"
    },
    {
        name: "Bahrain",
        "alpha-2": "BH",
        "iso-numeric": "048"
    },
    {
        name: "Bangladesh",
        "alpha-2": "BD",
        "iso-numeric": "050"
    },
    {
        name: "Barbados",
        "alpha-2": "BB",
        "iso-numeric": "052"
    },
    {
        name: "Belarus",
        "alpha-2": "BY",
        "iso-numeric": "112"
    },
    {
        name: "Belgium",
        "alpha-2": "BE",
        "iso-numeric": "056"
    },
    {
        name: "Belize",
        "alpha-2": "BZ",
        "iso-numeric": "084"
    },
    {
        name: "Benin",
        "alpha-2": "BJ",
        "iso-numeric": "204"
    },
    {
        name: "Bermuda",
        "alpha-2": "BM",
        "iso-numeric": "060"
    },
    {
        name: "Bhutan",
        "alpha-2": "BT",
        "iso-numeric": "064"
    },
    {
        name: "Bolivia (Plurinational State of)",
        "alpha-2": "BO",
        "iso-numeric": "068"
    },
    {
        name: "Bonaire, Sint Eustatius and Saba",
        "alpha-2": "BQ",
        "iso-numeric": "535"
    },
    {
        name: "Bosnia and Herzegovina",
        "alpha-2": "BA",
        "iso-numeric": "070"
    },
    {
        name: "Botswana",
        "alpha-2": "BW",
        "iso-numeric": "072"
    },
    {
        name: "Bouvet Island",
        "alpha-2": "BV",
        "iso-numeric": "074"
    },
    {
        name: "Brazil",
        "alpha-2": "BR",
        "iso-numeric": "076"
    },
    {
        name: "British Indian Ocean Territory",
        "alpha-2": "IO",
        "iso-numeric": "086"
    },
    {
        name: "Brunei Darussalam",
        "alpha-2": "BN",
        "iso-numeric": "096"
    },
    {
        name: "Bulgaria",
        "alpha-2": "BG",
        "iso-numeric": "100"
    },
    {
        name: "Burkina Faso",
        "alpha-2": "BF",
        "iso-numeric": "854"
    },
    {
        name: "Burundi",
        "alpha-2": "BI",
        "iso-numeric": "108"
    },
    {
        name: "Cabo Verde",
        "alpha-2": "CV",
        "iso-numeric": "132"
    },
    {
        name: "Cambodia",
        "alpha-2": "KH",
        "iso-numeric": "116"
    },
    {
        name: "Cameroon",
        "alpha-2": "CM",
        "iso-numeric": "120"
    },
    {
        name: "Canada",
        "alpha-2": "CA",
        "iso-numeric": "124"
    },
    {
        name: "Cayman Islands",
        "alpha-2": "KY",
        "iso-numeric": "136"
    },
    {
        name: "Central African Republic",
        "alpha-2": "CF",
        "iso-numeric": "140"
    },
    {
        name: "Chad",
        "alpha-2": "TD",
        "iso-numeric": "148"
    },
    {
        name: "Chile",
        "alpha-2": "CL",
        "iso-numeric": "152"
    },
    {
        name: "China",
        "alpha-2": "CN",
        "iso-numeric": "156"
    },
    {
        name: "Christmas Island",
        "alpha-2": "CX",
        "iso-numeric": "162"
    },
    {
        name: "Cocos (Keeling) Islands",
        "alpha-2": "CC",
        "iso-numeric": "166"
    },
    {
        name: "Colombia",
        "alpha-2": "CO",
        "iso-numeric": "170"
    },
    {
        name: "Comoros",
        "alpha-2": "KM",
        "iso-numeric": "174"
    },
    {
        name: "Congo",
        "alpha-2": "CG",
        "iso-numeric": "178"
    },
    {
        name: "Congo, Democratic Republic of the",
        "alpha-2": "CD",
        "iso-numeric": "180"
    },
    {
        name: "Cook Islands",
        "alpha-2": "CK",
        "iso-numeric": "184"
    },
    {
        name: "Costa Rica",
        "alpha-2": "CR",
        "iso-numeric": "188"
    },
    {
        name: "C\xf4te d'Ivoire",
        "alpha-2": "CI",
        "iso-numeric": "384"
    },
    {
        name: "Croatia",
        "alpha-2": "HR",
        "iso-numeric": "191"
    },
    {
        name: "Cuba",
        "alpha-2": "CU",
        "iso-numeric": "192"
    },
    {
        name: "Cura\xe7ao",
        "alpha-2": "CW",
        "iso-numeric": "531"
    },
    {
        name: "Cyprus",
        "alpha-2": "CY",
        "iso-numeric": "196"
    },
    {
        name: "Czechia",
        "alpha-2": "CZ",
        "iso-numeric": "203"
    },
    {
        name: "Denmark",
        "alpha-2": "DK",
        "iso-numeric": "208"
    },
    {
        name: "Djibouti",
        "alpha-2": "DJ",
        "iso-numeric": "262"
    },
    {
        name: "Dominica",
        "alpha-2": "DM",
        "iso-numeric": "212"
    },
    {
        name: "Dominican Republic",
        "alpha-2": "DO",
        "iso-numeric": "214"
    },
    {
        name: "Ecuador",
        "alpha-2": "EC",
        "iso-numeric": "218"
    },
    {
        name: "Egypt",
        "alpha-2": "EG",
        "iso-numeric": "818"
    },
    {
        name: "El Salvador",
        "alpha-2": "SV",
        "iso-numeric": "222"
    },
    {
        name: "Equatorial Guinea",
        "alpha-2": "GQ",
        "iso-numeric": "226"
    },
    {
        name: "Eritrea",
        "alpha-2": "ER",
        "iso-numeric": "232"
    },
    {
        name: "Estonia",
        "alpha-2": "EE",
        "iso-numeric": "233"
    },
    {
        name: "Eswatini",
        "alpha-2": "SZ",
        "iso-numeric": "748"
    },
    {
        name: "Ethiopia",
        "alpha-2": "ET",
        "iso-numeric": "231"
    },
    {
        name: "Falkland Islands (Malvinas)",
        "alpha-2": "FK",
        "iso-numeric": "238"
    },
    {
        name: "Faroe Islands",
        "alpha-2": "FO",
        "iso-numeric": "234"
    },
    {
        name: "Fiji",
        "alpha-2": "FJ",
        "iso-numeric": "242"
    },
    {
        name: "Finland",
        "alpha-2": "FI",
        "iso-numeric": "246"
    },
    {
        name: "France",
        "alpha-2": "FR",
        "iso-numeric": "250"
    },
    {
        name: "French Guiana",
        "alpha-2": "GF",
        "iso-numeric": "254"
    },
    {
        name: "French Polynesia",
        "alpha-2": "PF",
        "iso-numeric": "258"
    },
    {
        name: "French Southern Territories",
        "alpha-2": "TF",
        "iso-numeric": "260"
    },
    {
        name: "Gabon",
        "alpha-2": "GA",
        "iso-numeric": "266"
    },
    {
        name: "Gambia",
        "alpha-2": "GM",
        "iso-numeric": "270"
    },
    {
        name: "Georgia",
        "alpha-2": "GE",
        "iso-numeric": "268"
    },
    {
        name: "Germany",
        "alpha-2": "DE",
        "iso-numeric": "276"
    },
    {
        name: "Ghana",
        "alpha-2": "GH",
        "iso-numeric": "288"
    },
    {
        name: "Gibraltar",
        "alpha-2": "GI",
        "iso-numeric": "292"
    },
    {
        name: "Greece",
        "alpha-2": "GR",
        "iso-numeric": "300"
    },
    {
        name: "Greenland",
        "alpha-2": "GL",
        "iso-numeric": "304"
    },
    {
        name: "Grenada",
        "alpha-2": "GD",
        "iso-numeric": "308"
    },
    {
        name: "Guadeloupe",
        "alpha-2": "GP",
        "iso-numeric": "312"
    },
    {
        name: "Guam",
        "alpha-2": "GU",
        "iso-numeric": "316"
    },
    {
        name: "Guatemala",
        "alpha-2": "GT",
        "iso-numeric": "320"
    },
    {
        name: "Guernsey",
        "alpha-2": "GG",
        "iso-numeric": "831"
    },
    {
        name: "Guinea",
        "alpha-2": "GN",
        "iso-numeric": "324"
    },
    {
        name: "Guinea-Bissau",
        "alpha-2": "GW",
        "iso-numeric": "624"
    },
    {
        name: "Guyana",
        "alpha-2": "GY",
        "iso-numeric": "328"
    },
    {
        name: "Haiti",
        "alpha-2": "HT",
        "iso-numeric": "332"
    },
    {
        name: "Heard Island and McDonald Islands",
        "alpha-2": "HM",
        "iso-numeric": "334"
    },
    {
        name: "Holy See",
        "alpha-2": "VA",
        "iso-numeric": "336"
    },
    {
        name: "Honduras",
        "alpha-2": "HN",
        "iso-numeric": "340"
    },
    {
        name: "Hong Kong",
        "alpha-2": "HK",
        "iso-numeric": "344"
    },
    {
        name: "Hungary",
        "alpha-2": "HU",
        "iso-numeric": "348"
    },
    {
        name: "Iceland",
        "alpha-2": "IS",
        "iso-numeric": "352"
    },
    {
        name: "India",
        "alpha-2": "IN",
        "iso-numeric": "356"
    },
    {
        name: "Indonesia",
        "alpha-2": "ID",
        "iso-numeric": "360"
    },
    {
        name: "Iran (Islamic Republic of)",
        "alpha-2": "IR",
        "iso-numeric": "364"
    },
    {
        name: "Iraq",
        "alpha-2": "IQ",
        "iso-numeric": "368"
    },
    {
        name: "Ireland",
        "alpha-2": "IE",
        "iso-numeric": "372"
    },
    {
        name: "Isle of Man",
        "alpha-2": "IM",
        "iso-numeric": "833"
    },
    {
        name: "Israel",
        "alpha-2": "IL",
        "iso-numeric": "376"
    },
    {
        name: "Italy",
        "alpha-2": "IT",
        "iso-numeric": "380"
    },
    {
        name: "Jamaica",
        "alpha-2": "JM",
        "iso-numeric": "388"
    },
    {
        name: "Japan",
        "alpha-2": "JP",
        "iso-numeric": "392"
    },
    {
        name: "Jersey",
        "alpha-2": "JE",
        "iso-numeric": "832"
    },
    {
        name: "Jordan",
        "alpha-2": "JO",
        "iso-numeric": "400"
    },
    {
        name: "Kazakhstan",
        "alpha-2": "KZ",
        "iso-numeric": "398"
    },
    {
        name: "Kenya",
        "alpha-2": "KE",
        "iso-numeric": "404"
    },
    {
        name: "Kiribati",
        "alpha-2": "KI",
        "iso-numeric": "296"
    },
    {
        name: "Korea (Democratic People's Republic of)",
        "alpha-2": "KP",
        "iso-numeric": "408"
    },
    {
        name: "Korea, Republic of",
        "alpha-2": "KR",
        "iso-numeric": "410"
    },
    {
        name: "Kuwait",
        "alpha-2": "KW",
        "iso-numeric": "414"
    },
    {
        name: "Kyrgyzstan",
        "alpha-2": "KG",
        "iso-numeric": "417"
    },
    {
        name: "Lao People's Democratic Republic",
        "alpha-2": "LA",
        "iso-numeric": "418"
    },
    {
        name: "Latvia",
        "alpha-2": "LV",
        "iso-numeric": "428"
    },
    {
        name: "Lebanon",
        "alpha-2": "LB",
        "iso-numeric": "422"
    },
    {
        name: "Lesotho",
        "alpha-2": "LS",
        "iso-numeric": "426"
    },
    {
        name: "Liberia",
        "alpha-2": "LR",
        "iso-numeric": "430"
    },
    {
        name: "Libya",
        "alpha-2": "LY",
        "iso-numeric": "434"
    },
    {
        name: "Liechtenstein",
        "alpha-2": "LI",
        "iso-numeric": "438"
    },
    {
        name: "Lithuania",
        "alpha-2": "LT",
        "iso-numeric": "440"
    },
    {
        name: "Luxembourg",
        "alpha-2": "LU",
        "iso-numeric": "442"
    },
    {
        name: "Macao",
        "alpha-2": "MO",
        "iso-numeric": "446"
    },
    {
        name: "Madagascar",
        "alpha-2": "MG",
        "iso-numeric": "450"
    },
    {
        name: "Malawi",
        "alpha-2": "MW",
        "iso-numeric": "454"
    },
    {
        name: "Malaysia",
        "alpha-2": "MY",
        "iso-numeric": "458"
    },
    {
        name: "Maldives",
        "alpha-2": "MV",
        "iso-numeric": "462"
    },
    {
        name: "Mali",
        "alpha-2": "ML",
        "iso-numeric": "466"
    },
    {
        name: "Malta",
        "alpha-2": "MT",
        "iso-numeric": "470"
    },
    {
        name: "Marshall Islands",
        "alpha-2": "MH",
        "iso-numeric": "584"
    },
    {
        name: "Martinique",
        "alpha-2": "MQ",
        "iso-numeric": "474"
    },
    {
        name: "Mauritania",
        "alpha-2": "MR",
        "iso-numeric": "478"
    },
    {
        name: "Mauritius",
        "alpha-2": "MU",
        "iso-numeric": "480"
    },
    {
        name: "Mayotte",
        "alpha-2": "YT",
        "iso-numeric": "175"
    },
    {
        name: "Mexico",
        "alpha-2": "MX",
        "iso-numeric": "484"
    },
    {
        name: "Micronesia (Federated States of)",
        "alpha-2": "FM",
        "iso-numeric": "583"
    },
    {
        name: "Moldova, Republic of",
        "alpha-2": "MD",
        "iso-numeric": "498"
    },
    {
        name: "Monaco",
        "alpha-2": "MC",
        "iso-numeric": "492"
    },
    {
        name: "Mongolia",
        "alpha-2": "MN",
        "iso-numeric": "496"
    },
    {
        name: "Montenegro",
        "alpha-2": "ME",
        "iso-numeric": "499"
    },
    {
        name: "Montserrat",
        "alpha-2": "MS",
        "iso-numeric": "500"
    },
    {
        name: "Morocco",
        "alpha-2": "MA",
        "iso-numeric": "504"
    },
    {
        name: "Mozambique",
        "alpha-2": "MZ",
        "iso-numeric": "508"
    },
    {
        name: "Myanmar",
        "alpha-2": "MM",
        "iso-numeric": "104"
    },
    {
        name: "Namibia",
        "alpha-2": "NA",
        "iso-numeric": "516"
    },
    {
        name: "Nauru",
        "alpha-2": "NR",
        "iso-numeric": "520"
    },
    {
        name: "Nepal",
        "alpha-2": "NP",
        "iso-numeric": "524"
    },
    {
        name: "Netherlands",
        "alpha-2": "NL",
        "iso-numeric": "528"
    },
    {
        name: "New Caledonia",
        "alpha-2": "NC",
        "iso-numeric": "540"
    },
    {
        name: "New Zealand",
        "alpha-2": "NZ",
        "iso-numeric": "554"
    },
    {
        name: "Nicaragua",
        "alpha-2": "NI",
        "iso-numeric": "558"
    },
    {
        name: "Niger",
        "alpha-2": "NE",
        "iso-numeric": "562"
    },
    {
        name: "Nigeria",
        "alpha-2": "NG",
        "iso-numeric": "566"
    },
    {
        name: "Niue",
        "alpha-2": "NU",
        "iso-numeric": "570"
    },
    {
        name: "Norfolk Island",
        "alpha-2": "NF",
        "iso-numeric": "574"
    },
    {
        name: "North Macedonia",
        "alpha-2": "MK",
        "iso-numeric": "807"
    },
    {
        name: "Northern Mariana Islands",
        "alpha-2": "MP",
        "iso-numeric": "580"
    },
    {
        name: "Norway",
        "alpha-2": "NO",
        "iso-numeric": "578"
    },
    {
        name: "Oman",
        "alpha-2": "OM",
        "iso-numeric": "512"
    },
    {
        name: "Pakistan",
        "alpha-2": "PK",
        "iso-numeric": "586"
    },
    {
        name: "Palau",
        "alpha-2": "PW",
        "iso-numeric": "585"
    },
    {
        name: "Palestine, State of",
        "alpha-2": "PS",
        "iso-numeric": "275"
    },
    {
        name: "Panama",
        "alpha-2": "PA",
        "iso-numeric": "591"
    },
    {
        name: "Papua New Guinea",
        "alpha-2": "PG",
        "iso-numeric": "598"
    },
    {
        name: "Paraguay",
        "alpha-2": "PY",
        "iso-numeric": "600"
    },
    {
        name: "Peru",
        "alpha-2": "PE",
        "iso-numeric": "604"
    },
    {
        name: "Philippines",
        "alpha-2": "PH",
        "iso-numeric": "608"
    },
    {
        name: "Pitcairn",
        "alpha-2": "PN",
        "iso-numeric": "612"
    },
    {
        name: "Poland",
        "alpha-2": "PL",
        "iso-numeric": "616"
    },
    {
        name: "Portugal",
        "alpha-2": "PT",
        "iso-numeric": "620"
    },
    {
        name: "Puerto Rico",
        "alpha-2": "PR",
        "iso-numeric": "630"
    },
    {
        name: "Qatar",
        "alpha-2": "QA",
        "iso-numeric": "634"
    },
    {
        name: "R\xe9union",
        "alpha-2": "RE",
        "iso-numeric": "638"
    },
    {
        name: "Romania",
        "alpha-2": "RO",
        "iso-numeric": "642"
    },
    {
        name: "Russian Federation",
        "alpha-2": "RU",
        "iso-numeric": "643"
    },
    {
        name: "Rwanda",
        "alpha-2": "RW",
        "iso-numeric": "646"
    },
    {
        name: "Saint Barth\xe9lemy",
        "alpha-2": "BL",
        "iso-numeric": "652"
    },
    {
        name: "Saint Helena, Ascension and Tristan da Cunha",
        "alpha-2": "SH",
        "iso-numeric": "654"
    },
    {
        name: "Saint Kitts and Nevis",
        "alpha-2": "KN",
        "iso-numeric": "659"
    },
    {
        name: "Saint Lucia",
        "alpha-2": "LC",
        "iso-numeric": "662"
    },
    {
        name: "Saint Martin (French part)",
        "alpha-2": "MF",
        "iso-numeric": "663"
    },
    {
        name: "Saint Pierre and Miquelon",
        "alpha-2": "PM",
        "iso-numeric": "666"
    },
    {
        name: "Saint Vincent and the Grenadines",
        "alpha-2": "VC",
        "iso-numeric": "670"
    },
    {
        name: "Samoa",
        "alpha-2": "WS",
        "iso-numeric": "882"
    },
    {
        name: "San Marino",
        "alpha-2": "SM",
        "iso-numeric": "674"
    },
    {
        name: "Sao Tome and Principe",
        "alpha-2": "ST",
        "iso-numeric": "678"
    },
    {
        name: "Saudi Arabia",
        "alpha-2": "SA",
        "iso-numeric": "682"
    },
    {
        name: "Senegal",
        "alpha-2": "SN",
        "iso-numeric": "686"
    },
    {
        name: "Serbia",
        "alpha-2": "RS",
        "iso-numeric": "688"
    },
    {
        name: "Seychelles",
        "alpha-2": "SC",
        "iso-numeric": "690"
    },
    {
        name: "Sierra Leone",
        "alpha-2": "SL",
        "iso-numeric": "694"
    },
    {
        name: "Singapore",
        "alpha-2": "SG",
        "iso-numeric": "702"
    },
    {
        name: "Sint Maarten (Dutch part)",
        "alpha-2": "SX",
        "iso-numeric": "534"
    },
    {
        name: "Slovakia",
        "alpha-2": "SK",
        "iso-numeric": "703"
    },
    {
        name: "Slovenia",
        "alpha-2": "SI",
        "iso-numeric": "705"
    },
    {
        name: "Solomon Islands",
        "alpha-2": "SB",
        "iso-numeric": "090"
    },
    {
        name: "Somalia",
        "alpha-2": "SO",
        "iso-numeric": "706"
    },
    {
        name: "South Africa",
        "alpha-2": "ZA",
        "iso-numeric": "710"
    },
    {
        name: "South Georgia and the South Sandwich Islands",
        "alpha-2": "GS",
        "iso-numeric": "239"
    },
    {
        name: "South Sudan",
        "alpha-2": "SS",
        "iso-numeric": "728"
    },
    {
        name: "Spain",
        "alpha-2": "ES",
        "iso-numeric": "724"
    },
    {
        name: "Sri Lanka",
        "alpha-2": "LK",
        "iso-numeric": "144"
    },
    {
        name: "Sudan",
        "alpha-2": "SD",
        "iso-numeric": "729"
    },
    {
        name: "Suriname",
        "alpha-2": "SR",
        "iso-numeric": "740"
    },
    {
        name: "Svalbard and Jan Mayen",
        "alpha-2": "SJ",
        "iso-numeric": "744"
    },
    {
        name: "Sweden",
        "alpha-2": "SE",
        "iso-numeric": "752"
    },
    {
        name: "Switzerland",
        "alpha-2": "CH",
        "iso-numeric": "756"
    },
    {
        name: "Syrian Arab Republic",
        "alpha-2": "SY",
        "iso-numeric": "760"
    },
    {
        name: "Taiwan, Province of China",
        "alpha-2": "TW",
        "iso-numeric": "158"
    },
    {
        name: "Tajikistan",
        "alpha-2": "TJ",
        "iso-numeric": "762"
    },
    {
        name: "Tanzania, United Republic of",
        "alpha-2": "TZ",
        "iso-numeric": "834"
    },
    {
        name: "Thailand",
        "alpha-2": "TH",
        "iso-numeric": "764"
    },
    {
        name: "Timor-Leste",
        "alpha-2": "TL",
        "iso-numeric": "626"
    },
    {
        name: "Togo",
        "alpha-2": "TG",
        "iso-numeric": "768"
    },
    {
        name: "Tokelau",
        "alpha-2": "TK",
        "iso-numeric": "772"
    },
    {
        name: "Tonga",
        "alpha-2": "TO",
        "iso-numeric": "776"
    },
    {
        name: "Trinidad and Tobago",
        "alpha-2": "TT",
        "iso-numeric": "780"
    },
    {
        name: "Tunisia",
        "alpha-2": "TN",
        "iso-numeric": "788"
    },
    {
        name: "Turkey",
        "alpha-2": "TR",
        "iso-numeric": "792"
    },
    {
        name: "Turkmenistan",
        "alpha-2": "TM",
        "iso-numeric": "795"
    },
    {
        name: "Turks and Caicos Islands",
        "alpha-2": "TC",
        "iso-numeric": "796"
    },
    {
        name: "Tuvalu",
        "alpha-2": "TV",
        "iso-numeric": "798"
    },
    {
        name: "Uganda",
        "alpha-2": "UG",
        "iso-numeric": "800"
    },
    {
        name: "Ukraine",
        "alpha-2": "UA",
        "iso-numeric": "804"
    },
    {
        name: "United Arab Emirates",
        "alpha-2": "AE",
        "iso-numeric": "784"
    },
    {
        name: "United Kingdom of Great Britain and Northern Ireland",
        "alpha-2": "GB",
        "iso-numeric": "826"
    },
    {
        name: "United States of America",
        "alpha-2": "US",
        "iso-numeric": "840"
    },
    {
        name: "United States Minor Outlying Islands",
        "alpha-2": "UM",
        "iso-numeric": "581"
    },
    {
        name: "Uruguay",
        "alpha-2": "UY",
        "iso-numeric": "858"
    },
    {
        name: "Uzbekistan",
        "alpha-2": "UZ",
        "iso-numeric": "860"
    },
    {
        name: "Vanuatu",
        "alpha-2": "VU",
        "iso-numeric": "548"
    },
    {
        name: "Venezuela (Bolivarian Republic of)",
        "alpha-2": "VE",
        "iso-numeric": "862"
    },
    {
        name: "Viet Nam",
        "alpha-2": "VN",
        "iso-numeric": "704"
    },
    {
        name: "Virgin Islands (British)",
        "alpha-2": "VG",
        "iso-numeric": "092"
    },
    {
        name: "Virgin Islands (U.S.)",
        "alpha-2": "VI",
        "iso-numeric": "850"
    },
    {
        name: "Wallis and Futuna",
        "alpha-2": "WF",
        "iso-numeric": "876"
    },
    {
        name: "Western Sahara",
        "alpha-2": "EH",
        "iso-numeric": "732"
    },
    {
        name: "Yemen",
        "alpha-2": "YE",
        "iso-numeric": "887"
    },
    {
        name: "Zambia",
        "alpha-2": "ZM",
        "iso-numeric": "894"
    },
    {
        name: "Zimbabwe",
        "alpha-2": "ZW",
        "iso-numeric": "716"
    }
];

});

parcelRegister("gbifg", function(module, exports) {

$parcel$export(module.exports, "anonimyzeIban", function () { return $079165af51dc1c14$export$5153efc13b7f7c41; });
$parcel$export(module.exports, "getCurrencyFromIban", function () { return $079165af51dc1c14$export$daf563edb134492a; });
$parcel$export(module.exports, "getCurrencyFromBic", function () { return $079165af51dc1c14$export$3485e03283b5faaf; });
$parcel$export(module.exports, "getCountryCodeFromIban", function () { return $079165af51dc1c14$export$2c6e433adda7b6b1; });

var $8xKCH = parcelRequire("8xKCH");
const $079165af51dc1c14$export$5153efc13b7f7c41 = (iban)=>{
    const splittedIban = iban.split(" ");
    const length = splittedIban.length;
    const anonymizedIban = splittedIban.map((bloc, i)=>{
        if (i === 0 || i === length - 1) return bloc;
        else return bloc.replace(/[0-9A-Z]/g, "\u2022");
    });
    return anonymizedIban.join(" ");
};
const $079165af51dc1c14$export$daf563edb134492a = (iban)=>{
    const ibanCountryCode = iban.slice(0, 2);
    const currency = (0, $8xKCH.COUNTRY_CURRENCIES)[ibanCountryCode];
    return currency || "EUR";
};
const $079165af51dc1c14$export$3485e03283b5faaf = (bic)=>{
    const bicCountryCode = bic.slice(4, 6);
    const currency = (0, $8xKCH.COUNTRY_CURRENCIES)[bicCountryCode];
    return currency || "EUR";
};
const $079165af51dc1c14$export$2c6e433adda7b6b1 = (iban)=>{
    if (iban.length < 2) return "";
    return iban.slice(0, 2).toUpperCase();
};

});


parcelRegister("1Ny0s", function(module, exports) {

$parcel$export(module.exports, "PhoneInput", function () { return $3b0c2bfe45f61ce0$export$d9c67ff858089902; });

var $4m918 = parcelRequire("4m918");

var $glqzU = parcelRequire("glqzU");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $a5OyK = parcelRequire("a5OyK");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $etzj2 = parcelRequire("etzj2");

var $cUa6O = parcelRequire("cUa6O");

var $dkEe7 = parcelRequire("dkEe7");
const $3b0c2bfe45f61ce0$export$d9c67ff858089902 = ({ required: required = true, disabled: disabled, maxWidth: maxWidth, initialPhone: initialPhone, initialCountryCode: initialCountryCode, onChangePhoneNumber: onChangePhoneNumber, onChangeCountryCode: onChangeCountryCode })=>{
    const defaultCountry = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).defaultCountry);
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)(initialCountryCode ?? defaultCountry);
    const [phoneNumber, setPhoneNumber] = (0, $6uYXW.useState)(initialPhone ?? "");
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const updateCountryCode = (0, $6uYXW.useCallback)((code)=>{
        setCountryCode(code);
        onChangeCountryCode?.(code);
    }, [
        onChangeCountryCode
    ]);
    const updatePhoneNumber = (0, $6uYXW.useCallback)((phone)=>{
        const nationalNumber = "+" + (0, $a5OyK.countries)[countryCode].phoneCode;
        const internationalPhoneNumber = phone.startsWith(nationalNumber) ? phone : nationalNumber + phone;
        const formatted = new (0, $glqzU.AsYouType)().input(internationalPhoneNumber).substr(nationalNumber.length);
        setPhoneNumber(formatted);
        onChangePhoneNumber?.(phone);
    }, [
        countryCode,
        onChangePhoneNumber
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($3b0c2bfe45f61ce0$var$PhoneInputContainer, {
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($3b0c2bfe45f61ce0$var$CountrySelectInput, {
                disabled: disabled,
                onChange: updateCountryCode,
                innerId: "country-select-field",
                options: configuration.countries,
                itemRenderer: (code)=>(0, $a5OyK.countries)[code].englishName,
                value: countryCode,
                prefixElement: (0, $a5OyK.countries)[countryCode] && /*#__PURE__*/ (0, $4m918.jsx)($3b0c2bfe45f61ce0$var$FlagIcon, {
                    src: (0, $etzj2.flagUrl)(countryCode),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($3b0c2bfe45f61ce0$var$TelPhoneInput, {
                required: required,
                disabled: disabled,
                placeholder: formatMessage("addRecipient.phoneFieldPlaceholder"),
                prefixElement: /*#__PURE__*/ (0, $4m918.jsxs)($3b0c2bfe45f61ce0$var$PhoneCode, {
                    children: [
                        "+",
                        (0, $a5OyK.countries)[countryCode].phoneCode
                    ]
                }),
                type: "tel",
                value: phoneNumber,
                onChange: (event)=>{
                    updatePhoneNumber(event.target.value);
                }
            })
        ]
    });
};
const $3b0c2bfe45f61ce0$var$PhoneInputContainer = (0, $jb8NR.default).div`
  max-width: ${(props)=>props.maxWidth === "0" ? "none" : props.maxWidth || "100%"};
`;
const $3b0c2bfe45f61ce0$var$inputStyle = (0, $jb8NR.css)`
  width: 100%;
  margin-bottom: 20px;
`;
const $3b0c2bfe45f61ce0$var$CountrySelectInput = (0, $jb8NR.default)((0, $cUa6O.PrefixedSelectInput))`
  ${$3b0c2bfe45f61ce0$var$inputStyle};
`;
const $3b0c2bfe45f61ce0$var$FlagIcon = (0, $jb8NR.default).img`
  width: 14px;
  height: 14px;
  border-radius: 7px;
`;
const $3b0c2bfe45f61ce0$var$TelPhoneInput = (0, $jb8NR.default)((0, $dkEe7.PrefixedTextInput))`
  ${$3b0c2bfe45f61ce0$var$inputStyle};

  ${(0, $dkEe7.PrefixContainer)} {
    width: 80px;
  }
`;
const $3b0c2bfe45f61ce0$var$PhoneCode = (0, $jb8NR.default).span`
  font-size: 0.875rem;
`;

});
parcelRegister("etzj2", function(module, exports) {

$parcel$export(module.exports, "flagUrl", function () { return $9e47490a49a4fb74$export$a2b8715397522463; });

var $a5OyK = parcelRequire("a5OyK");

var $gDlNU = parcelRequire("gDlNU");
function $9e47490a49a4fb74$export$a2b8715397522463(countryCode) {
    if (!countryCode || !(0, $gDlNU.isDefined)((0, $a5OyK.countries)[countryCode]?.flag)) return undefined;
    return `/static/flags/${countryCode}.png`;
}

});

parcelRegister("cUa6O", function(module, exports) {

$parcel$export(module.exports, "PrefixedSelectInput", function () { return $02c4d69034755382$export$3e66b6a32e9cbb92; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $39jSd = parcelRequire("39jSd");
function $02c4d69034755382$export$3e66b6a32e9cbb92(props) {
    const { prefixElement: prefixElement, className: className, ...rest } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($02c4d69034755382$var$Row, {
        className: className,
        dir: "ltr",
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($02c4d69034755382$var$PrefixContainer, {
                $isRTL: isRTL,
                children: prefixElement
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                style: $02c4d69034755382$var$selectInputStyle,
                ...rest,
                "data-testid": "currency-select-test"
            })
        ]
    });
}
// We use React CSSProperties because Generic Type Component is not working well with StyledComponent
const $02c4d69034755382$var$selectInputStyle = {
    width: "100%",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 10
};
const $02c4d69034755382$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
`;
const $02c4d69034755382$var$PrefixContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #ffffff;
  width: 80px;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    bottom: 0;
    right: ${(props)=>props.$isRTL ? "auto" : 0};
    left: ${(props)=>props.$isRTL ? 0 : "auto"};
    width: 1px;
    height: calc(100% - 10px);
    background-color: ${(0, $22v9q.theme).colors.gray[500]};
    transform: translateY(-50%);
  }
`;

});

parcelRegister("dkEe7", function(module, exports) {

$parcel$export(module.exports, "PrefixedTextInput", function () { return $77cf11ed7a567158$export$59b6931357143144; });
$parcel$export(module.exports, "PrefixContainer", function () { return $77cf11ed7a567158$export$4c8fe4d659b4d85f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $9mlIh = parcelRequire("9mlIh");
const $77cf11ed7a567158$export$59b6931357143144 = (props)=>{
    const { prefixElement: prefixElement, className: className, bottomOffset: bottomOffset, ...rest } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($77cf11ed7a567158$var$Row, {
        className: className,
        dir: "ltr",
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($77cf11ed7a567158$export$4c8fe4d659b4d85f, {
                $isRTL: isRTL,
                children: prefixElement
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($77cf11ed7a567158$var$StyledTextInput, {
                ...rest,
                bottomOffset: bottomOffset
            })
        ]
    });
};
const $77cf11ed7a567158$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
`;
const $77cf11ed7a567158$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  width: 100%;
`;
const $77cf11ed7a567158$export$4c8fe4d659b4d85f = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #ffffff;
  width: 60px;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    bottom: 0;
    right: ${(props)=>props.$isRTL ? "auto" : 0};
    left: ${(props)=>props.$isRTL ? 0 : "auto"};
    width: 1px;
    height: calc(100% - 10px);
    background-color: ${(0, $22v9q.theme).colors.gray[500]};
    transform: translateY(-50%);
  }
`;

});



parcelRegister("kNccP", function(module, exports) {

$parcel$export(module.exports, "SelectField", function () { return $bf2b39c4299ed711$export$d55b50a564d0b931; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kw746 = parcelRequire("kw746");

var $39jSd = parcelRequire("39jSd");

var $jbtl1 = parcelRequire("jbtl1");
const $bf2b39c4299ed711$export$d55b50a564d0b931 = ({ input: input, onChange: onChange, type: type, disabled: disabled, hasError: hasError = false })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    (0, $6uYXW.useEffect)(()=>{
        if (!input.values) (0, $6JVVB.logger).debug("SelectField: input.values is empty", input.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = (value)=>{
        onChange?.(value || value === 0 ? value : "");
    };
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: $bf2b39c4299ed711$var$getSelectedOptionLabel(input)
    }) : type === "radio" ? /*#__PURE__*/ (0, $4m918.jsx)($bf2b39c4299ed711$var$StyledRadioSelector, {
        innerId: "select",
        values: new Map(input.values?.map(({ id: id, label: label })=>[
                id,
                label
            ])),
        value: input.value,
        onChange: handleChange
    }) : // type === "combobox"
    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
        style: {
            width: "100%"
        },
        innerId: input.id,
        placeholder: input.label ? `${formatMessage("selectField.select")} ${input.label.toLowerCase()}` : formatMessage("selectField.select_an_option"),
        required: input.required,
        options: input.values?.map((x)=>x.id),
        value: $bf2b39c4299ed711$var$findValue(input),
        onChange: handleChange,
        itemRenderer: (v)=>{
            const foundValue = input.values?.find((x)=>v != null && x.id != null && v.toString() === x.id.toString());
            return foundValue?.label ?? "";
        },
        hasError: hasError
    }, input.id);
};
function $bf2b39c4299ed711$var$findValue(input) {
    if (!input.value && input.value !== 0) (0, $6JVVB.logger).debug("input.value is empty for KYC:", input.id, "input:", input);
    const matchingValue = input.values?.find((v)=>v.id.toString() === input.value?.toString());
    return matchingValue ? matchingValue.id : null;
}
function $bf2b39c4299ed711$var$getSelectedOptionLabel(input) {
    const option = input.values?.find((v)=>v.id === input.value);
    if (option) return option.label;
    return null;
}
const $bf2b39c4299ed711$var$StyledRadioSelector = (0, $jb8NR.default)((0, $kw746.RadioSelector))`
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

});

parcelRegister("lxFZd", function(module, exports) {

$parcel$export(module.exports, "SelectWithAmountField", function () { return $aeb476eec9269cef$export$9c77a6de0b5c6dd8; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $kw746 = parcelRequire("kw746");

var $39jSd = parcelRequire("39jSd");

var $jbtl1 = parcelRequire("jbtl1");
const $aeb476eec9269cef$export$9c77a6de0b5c6dd8 = ({ input: input, onChange: onChange, type: type, disabled: disabled })=>{
    (0, $6uYXW.useEffect)(()=>{
        if (!input.value && input.values) onChange?.(input.values?.[0].id);
        else if (!input.values) console.warn("SelectWithAmountField: input.values is empty", input.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: $aeb476eec9269cef$var$getSelectedOptionLabel(input)
    }) : type === "radio" ? /*#__PURE__*/ (0, $4m918.jsx)($aeb476eec9269cef$var$StyledRadioSelector, {
        innerId: "select_amount",
        values: new Map(input.values.map(({ id: id, label: label, amount: amount, valueWithRef: valueWithRef })=>[
                id,
                `${valueWithRef || label} ${(0, $kqXxS.i18NManager).formatAmount(amount)}`
            ])),
        value: input.value,
        onChange: (value)=>onChange && onChange(value || "")
    }) : // type === "combobox"
    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
        style: {
            width: "100%"
        },
        innerId: input.id,
        required: input.required,
        options: input.values,
        value: input.values?.find((v)=>v.id === input.value) || null,
        onChange: (value)=>onChange && onChange(value.id),
        itemRenderer: (v)=>v ? `${v.valueWithRef || v.label} ${(0, $kqXxS.i18NManager).formatAmount(v.amount)}` : ""
    }, input.id);
};
function $aeb476eec9269cef$var$getSelectedOptionLabel(input) {
    const option = input.values?.find((v)=>v.id === input.value);
    if (option) return `${option.valueWithRef || option.label} ${(0, $kqXxS.i18NManager).formatAmount(option.amount)}`;
    return null;
}
const $aeb476eec9269cef$var$StyledRadioSelector = (0, $jb8NR.default)((0, $kw746.RadioSelector))`
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

});

parcelRegister("7QebT", function(module, exports) {

$parcel$export(module.exports, "TextField", function () { return $c8914944dd24a466$export$2c73285ae9390cec; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $gf0cb = parcelRequire("gf0cb");

var $9mlIh = parcelRequire("9mlIh");

var $jbtl1 = parcelRequire("jbtl1");
const $c8914944dd24a466$export$2c73285ae9390cec = ({ input: input, disabled: disabled, hasError: hasError = false, errorMessage: errorMessage, onChange: onChange, placeholder: placeholder, innerStyle: innerStyle, multiline: multiline, onKeyDown: onKeyDown, onBlur: onBlur })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const handleOnChange = (value)=>{
        const text = (0, $gf0cb.escapeHtmlChars)(value);
        onChange?.(text);
    };
    return input.disabled || disabled ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jbtl1.DisableValueText), {
        children: input.value
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
        required: input.required,
        value: input.value ?? "",
        onChange: (e)=>handleOnChange(e.target.value),
        placeholder: placeholder ? placeholder : formatMessage("billFormScreen.textInputPlaceholder"),
        hasError: !!hasError,
        errorMessage: errorMessage,
        style: innerStyle,
        multiline: multiline,
        onKeyDown: (e)=>onKeyDown?.(e),
        onBlur: onBlur
    });
};

});
parcelRegister("gf0cb", function(module, exports) {

$parcel$export(module.exports, "caseInsensitiveIncludes", function () { return $b083c9e3e474f61a$export$7de2889b893c62b0; });
$parcel$export(module.exports, "escapeHtmlChars", function () { return $b083c9e3e474f61a$export$ba1e986d2d849e00; });
const $b083c9e3e474f61a$export$7de2889b893c62b0 = function(value, search) {
    return value !== undefined && value.match(new RegExp(search.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i")) !== null;
};
function $b083c9e3e474f61a$export$1c052e42cda30a91(text) {
    return text.replace(/[^\w\s]/gi, "").replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, "");
}
function $b083c9e3e474f61a$export$ba1e986d2d849e00(text) {
    return text.replace(/[&<>"'`=\/]/g, "");
}
function $b083c9e3e474f61a$export$1537a998b8928040(text, validationRule) {
    return text.replace(/[&<>"'`=\/]/g, "");
}
function $b083c9e3e474f61a$export$d176197a2ee83c66(input) {
    let output = "";
    const regex = new RegExp("[a-zA-Z|0-9| |/|-|-|?|:|(|)|.|,|'|\u2018|\u2019|+]");
    for (const char of input)if (char.match(regex)) output += char;
    return output;
}
function $b083c9e3e474f61a$export$4eadcf0bf35a2ddb(str) {
    const main = str.match(/\/(.+)\/.*/);
    const options = str.match(/\/.+\/(.*)/);
    if (main && main.length > 1 && options && options.length > 1) return new RegExp(main[1], options[1]);
    return null;
}

});



parcelRegister("7RQw4", function(module, exports) {

$parcel$export(module.exports, "RoundedSquare", function () { return $191ee84a3bc2af04$export$95ba543a59d033c1; });
$parcel$export(module.exports, "RoundedSquareButton", function () { return $191ee84a3bc2af04$export$2f687f6c2c27331e; });

var $jb8NR = parcelRequire("jb8NR");

var $bewhU = parcelRequire("bewhU");
const $191ee84a3bc2af04$var$commonStyle = (size)=>(0, $jb8NR.css)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: ${size}px;
  width: ${size}px;
  border-radius: 10px;
`;
const $191ee84a3bc2af04$export$95ba543a59d033c1 = (0, $jb8NR.default).div`
  ${(props)=>$191ee84a3bc2af04$var$commonStyle(props.size)};
`;
const $191ee84a3bc2af04$export$2f687f6c2c27331e = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(props)=>$191ee84a3bc2af04$var$commonStyle(props.size)};
  &:focus,
  &:active,
  &:hover {
    background-color: #e2e2e2;
  }
  &:disabled {
    opacity: 0.5;
  }
`;

});

parcelRegister("fiXwA", function(module, exports) {

$parcel$export(module.exports, "ClipboardIcon", function () { return $184cf3d2b246cb95$export$60f3f00eeba09710; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $184cf3d2b246cb95$export$60f3f00eeba09710(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "24",
        height: "24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                fill: "#000",
                fillRule: "nonzero",
                d: "M15.996 6H9C7.343 6 6 7.343 6 9v6.996c-1.298-.064-2-.825-2-2.178V6.182C4 4.768 4.768 4 6.182 4h7.636c1.353 0 2.114.702 2.178 2z"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                fill: "#000",
                fillRule: "nonzero",
                d: "M10.182 8h7.636C19.232 8 20 8.768 20 10.182v7.636C20 19.232 19.232 20 17.818 20h-7.636C8.768 20 8 19.232 8 17.818v-7.636C8 8.768 8.768 8 10.182 8z"
            })
        ]
    });
}

});

parcelRegister("7wSRt", function(module, exports) {

$parcel$export(module.exports, "PenIcon", function () { return $0b9a221ac9be2f47$export$eeb42689c16a5321; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $0b9a221ac9be2f47$export$eeb42689c16a5321(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M17.82 10.986c.19.194.19.504 0 .699l-8.042 8.073c-.193.195-.424.348-.679.45l-4.33 1.756c-.185.074-.397.031-.538-.11-.207-.132-.287-.394-.19-.619l1.716-4.331c.102-.255.254-.486.45-.679l8.05-8.053c.094-.095.222-.148.355-.148.133 0 .26.053.354.148l2.853 2.814zm3.74-5.888l-.658-.659c-.28-.28-.66-.439-1.057-.439h-.758c-.404-.005-.793.153-1.078.44l-1.806 1.825c-.19.194-.19.505 0 .699l2.804 2.844c.093.095.22.148.354.148.133 0 .26-.053.354-.148l1.846-1.816c.286-.285.444-.674.439-1.078v-.758c0-.397-.158-.778-.44-1.058z"
        })
    });
}

});


parcelRegister("dS30h", function(module, exports) {

$parcel$export(module.exports, "CollapsableRowsSection", function () { return $32d8da8c16425359$export$300572298ff14c81; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $51d3M = parcelRequire("51d3M");
const $32d8da8c16425359$export$300572298ff14c81 = (props)=>{
    const { rows: rows, accountIsSavings: accountIsSavings = false } = props;
    const [isOpened, setIsOpened] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $4m918.jsxs)($32d8da8c16425359$var$StyledSectionContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($32d8da8c16425359$var$StyledSectionHeader, {
                onClick: ()=>setIsOpened(!isOpened),
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($32d8da8c16425359$var$StyledHeaderLabel, {
                        accountIsSavings: accountIsSavings,
                        children: rows[0].title
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($32d8da8c16425359$var$StyledHeaderSeparator, {
                        children: "\u2014"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($32d8da8c16425359$var$StyledHeaderLabel, {
                        accountIsSavings: accountIsSavings,
                        children: rows[0].value
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($32d8da8c16425359$var$ArrowDown, {
                        width: 16,
                        height: 16,
                        fill: "#ADADAD",
                        $reversed: isOpened
                    })
                ]
            }),
            isOpened && /*#__PURE__*/ (0, $4m918.jsx)($32d8da8c16425359$var$StyledRowContainer, {
                children: rows.slice(1, rows.length).map((r)=>/*#__PURE__*/ (0, $4m918.jsxs)($32d8da8c16425359$var$StyledRow, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($32d8da8c16425359$var$StyledRowText, {
                                accountIsSavings: accountIsSavings,
                                children: r.title
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($32d8da8c16425359$var$StyledRowText, {
                                accountIsSavings: accountIsSavings,
                                children: r.value
                            })
                        ]
                    }, r.title))
            })
        ]
    });
};
const $32d8da8c16425359$var$StyledSectionContainer = (0, $jb8NR.default).div`
  margin-left: 30px;
  margin-right: 30px;
`;
const $32d8da8c16425359$var$StyledSectionHeader = (0, $jb8NR.default).div`
  display: grid;
  grid-template-columns: 1fr 24px 1fr auto;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
  margin-top: 8px;
`;
const $32d8da8c16425359$var$StyledHeaderSeparator = (0, $jb8NR.default).span`
  margin-left: 12px;
  margin-right: 12px;
  color: #d6d6d6;
  text-align: center;
`;
const $32d8da8c16425359$var$StyledRowText = (0, $jb8NR.default).span`
  font-weight: 700;
  ${(accountIsSavings)=>accountIsSavings ? "#212121" : "#666666"};
  margin-bottom: 7px;
  font-size: 12px;
  font-style: normal;
  line-height: normal;
`;
const $32d8da8c16425359$var$StyledRowContainer = (0, $jb8NR.default).div`
  border-left-color: #d6d6d6;
  border-left-width: 1px;
  border-left-style: solid;
  padding-left: 8px;
  padding-top: 6px;
  margin-left: 6px;
  margin-right: 34px;
`;
const $32d8da8c16425359$var$StyledRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const $32d8da8c16425359$var$ArrowDown = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  transform: ${(props)=>props.$reversed ? "rotate(-90deg)" : "rotate(90deg)"};
`;
const $32d8da8c16425359$var$StyledHeaderLabel = (0, $jb8NR.default).span`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(accountIsSavings)=>accountIsSavings ? "#ADADAD" : "#212121"};
  font-weight: 700;
  font-size: 15px;
  font-style: normal;
  line-height: normal;

  &:nth-of-type(3) {
    text-align: right;
  }
`;

});

parcelRegister("hSCKm", function(module, exports) {

$parcel$export(module.exports, "DownloadBankAccountDetails", function () { return $c3a7e8bc3f0d7de5$export$a783a73c30977d4c; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $7RQw4 = parcelRequire("7RQw4");

var $k4kME = parcelRequire("k4kME");

var $4r738 = parcelRequire("4r738");

var $22v9q = parcelRequire("22v9q");
const $c3a7e8bc3f0d7de5$export$a783a73c30977d4c = (props)=>{
    const { account: account } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [isDownloading, setIsDownloading] = (0, $6uYXW.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)(null);
    const handleDownload = async ()=>{
        try {
            setIsDownloading(true);
            await (0, $kqXxS.accountBankDetailsService).downloadAccountBankDetails(account.id);
        } catch (e) {
            console.log(e.response.data.error.message);
            setErrorMessage(e.response.data.error.message);
        } finally{
            setIsDownloading(false);
        }
    };
    (0, $6uYXW.useEffect)(()=>{
        if (errorMessage) setErrorMessage(null);
    }, [
        errorMessage
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: /*#__PURE__*/ (0, $4m918.jsx)($c3a7e8bc3f0d7de5$var$BankDetailsContainer, {
            children: /*#__PURE__*/ (0, $4m918.jsxs)($c3a7e8bc3f0d7de5$var$DownloadBankDetails, {
                children: [
                    formatMessage("accountDetails.downloadBankDetails"),
                    isDownloading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {}) : null,
                    /*#__PURE__*/ (0, $4m918.jsx)($c3a7e8bc3f0d7de5$var$GreyRoundedSquareButton, {
                        size: 34,
                        onClick: handleDownload,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $4r738.DownloadIcon), {})
                    })
                ]
            })
        })
    });
};
const $c3a7e8bc3f0d7de5$var$DownloadBankDetails = (0, $jb8NR.default).div`
  ${(0, $22v9q.shadows).medium};
  ${(0, $22v9q.theme).boldText};
  width: 100%;
  font-size: 0.9375rem;
  margin: 10px 0;
  padding: 15px;
  border-radius: 13px;
  border: 0 none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const $c3a7e8bc3f0d7de5$var$GreyRoundedSquareButton = (0, $jb8NR.default)((0, $7RQw4.RoundedSquareButton))`
  background-color: #f4f4f4;
`;
const $c3a7e8bc3f0d7de5$var$BankDetailsContainer = (0, $jb8NR.default).div`
  padding: 0 30px 10px 30px;
`;

});

parcelRegister("jIu9M", function(module, exports) {

$parcel$export(module.exports, "StatementRow", function () { return $1e2d1871c3a1ead0$export$b10a8c9daaaa53aa; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $7RQw4 = parcelRequire("7RQw4");

var $4r738 = parcelRequire("4r738");

var $22v9q = parcelRequire("22v9q");
const $1e2d1871c3a1ead0$export$b10a8c9daaaa53aa = (props)=>{
    const { statement: statement, account: account, variant: variant = "normal", withAccountId: withAccountId, ...rest } = props;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($1e2d1871c3a1ead0$var$Row, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($1e2d1871c3a1ead0$var$Column, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($1e2d1871c3a1ead0$var$Title, {
                        children: [
                            formatDate(statement.fromDate, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            }),
                            " -",
                            " ",
                            formatDate(statement.toDate, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })
                        ]
                    }),
                    withAccountId && /*#__PURE__*/ (0, $4m918.jsx)($1e2d1871c3a1ead0$var$Value, {
                        children: formatMessage("accountsStatements.accountLabel", {
                            id: account.id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1e2d1871c3a1ead0$var$GreyRoundedSquareButton, {
                size: 34,
                onClick: ()=>(0, $kqXxS.accountStatementService).downloadStatement(account.id, statement.id, variant),
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $4r738.DownloadIcon), {})
            })
        ]
    });
};
const $1e2d1871c3a1ead0$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
`;
const $1e2d1871c3a1ead0$var$Column = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $1e2d1871c3a1ead0$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.9375rem;
`;
const $1e2d1871c3a1ead0$var$Value = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
  font-size: 0.9375rem;
`;
const $1e2d1871c3a1ead0$var$GreyRoundedSquareButton = (0, $jb8NR.default)((0, $7RQw4.RoundedSquareButton))`
  background-color: #f4f4f4;
`;

});

parcelRegister("iVSHW", function(module, exports) {

$parcel$export(module.exports, "TaxStatementRow", function () { return $c4226d37b9e6aca7$export$5d1b6d3c5a7ad32a; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $7RQw4 = parcelRequire("7RQw4");

var $4r738 = parcelRequire("4r738");

var $22v9q = parcelRequire("22v9q");
const $c4226d37b9e6aca7$export$5d1b6d3c5a7ad32a = (props)=>{
    const { statement: statement, account: account, variant: variant = "normal", withAccountId: withAccountId, ...rest } = props;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const firstDayOfYear = new Date(Number(statement.year), 0, 1);
    const lastDayOfYear = new Date(Number(statement.year), 11, 31);
    return /*#__PURE__*/ (0, $4m918.jsxs)($c4226d37b9e6aca7$var$Row, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($c4226d37b9e6aca7$var$Column, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($c4226d37b9e6aca7$var$Title, {
                        children: [
                            formatDate(firstDayOfYear, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            }),
                            " -",
                            " ",
                            formatDate(lastDayOfYear, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })
                        ]
                    }),
                    withAccountId && /*#__PURE__*/ (0, $4m918.jsx)($c4226d37b9e6aca7$var$Value, {
                        children: formatMessage("taxStatements.accountLabel", {
                            id: account.id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($c4226d37b9e6aca7$var$GreyRoundedSquareButton, {
                size: 34,
                onClick: ()=>(0, $kqXxS.savingsService).downloadTaxStatement(statement.documentId),
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $4r738.DownloadIcon), {})
            })
        ]
    });
};
const $c4226d37b9e6aca7$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
`;
const $c4226d37b9e6aca7$var$Column = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $c4226d37b9e6aca7$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.9375rem;
`;
const $c4226d37b9e6aca7$var$Value = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
  font-size: 0.9375rem;
`;
const $c4226d37b9e6aca7$var$GreyRoundedSquareButton = (0, $jb8NR.default)((0, $7RQw4.RoundedSquareButton))`
  background-color: #f4f4f4;
`;

});



parcelRegister("ke9vw", function(module, exports) {

$parcel$export(module.exports, "navigateToAccountTransactions", function () { return $48119f4be8c0ebc7$export$4a5c9151ca00555e; });

var $4fYE4 = parcelRequire("4fYE4");

var $e0mue = parcelRequire("e0mue");
const $48119f4be8c0ebc7$export$4a5c9151ca00555e = (history, accountId)=>{
    history.push(`${(0, $4fYE4.Path).AccountTransactions}?${(0, $e0mue.ACCOUNT_QUERY_PARAM)}=${accountId}`);
};

});


parcelRegister("7yMne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0112eda00d7d4745$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $42awV = parcelRequire("42awV");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $9mhzx = parcelRequire("9mhzx");

var $7yIx1 = parcelRequire("7yIx1");

var $Rr3Qd = parcelRequire("Rr3Qd");

var $ao7HR = parcelRequire("ao7HR");

var $b6V1s = parcelRequire("b6V1s");

var $3U0hy = parcelRequire("3U0hy");

var $Y6t65 = parcelRequire("Y6t65");

var $3Ersk = parcelRequire("3Ersk");

var $7Uj1Y = parcelRequire("7Uj1Y");

var $bQhUC = parcelRequire("bQhUC");

var $bewhU = parcelRequire("bewhU");

var $dvzf7 = parcelRequire("dvzf7");

var $j26Ew = parcelRequire("j26Ew");

var $5Wai4 = parcelRequire("5Wai4");

var $8JW2B = parcelRequire("8JW2B");

var $dtlTY = parcelRequire("dtlTY");

var $k4kME = parcelRequire("k4kME");

var $596TL = parcelRequire("596TL");

var $l0drh = parcelRequire("l0drh");

var $22v9q = parcelRequire("22v9q");

var $eSR05 = parcelRequire("eSR05");

var $5xxJk = parcelRequire("5xxJk");

var $fhsMR = parcelRequire("fhsMR");

var $e0mue = parcelRequire("e0mue");
function $0112eda00d7d4745$export$2e2bcd8739ae039() {
    const accounts = (0, $9mhzx.useAccounts)();
    const { goBack: goBack } = (0, $NQIVp.useHistory)();
    const transactionDirection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).directionSelection);
    const timerangeSelection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).timeRangeSelection);
    const [startDate, endDate] = timerangeSelection.bounds;
    const [startPeriodLabel, setStartPeriodLabel] = (0, $6uYXW.useState)();
    const [nextPeriodLabel, setNextPeriodLabel] = (0, $6uYXW.useState)();
    const [showFilters, setShowFilters] = (0, $6uYXW.useState)(false);
    const [search, setSearch] = (0, $6uYXW.useState)("");
    const [focusedAccount] = (0, $e0mue.useSelectedAccount)(accounts);
    const { filters: filters, formattedAmountRange: formattedAmountRange, hasAmountFilter: hasAmountFilter, justificationFilter: justificationFilter } = (0, $b6V1s.useTransactionFilter)(focusedAccount);
    const transactions = (0, $3U0hy.useTransactions)(focusedAccount, transactionDirection, filters);
    const intl = (0, $5hpYi.useIntl)();
    const { formatMessage: formatMessage, formatDate: formatDate } = intl;
    const searchedTransactions = (0, $6uYXW.useMemo)(()=>{
        if (!search || !transactions.data) return transactions.data;
        const needle = search.toLowerCase();
        return transactions.data.filter((transaction)=>transaction.type?.label?.toLowerCase().includes(needle) || transaction.shortDescription?.toLowerCase().includes(needle) || transaction.description?.toLowerCase().includes(needle));
    }, [
        transactions.data,
        search
    ]);
    const sections = (0, $6uYXW.useMemo)(()=>{
        if (transactions.loading || !searchedTransactions) return [];
        const transactionsGroupedByDay = $0112eda00d7d4745$var$groupTransactionsByDay(intl, searchedTransactions);
        return Object.values(transactionsGroupedByDay).sort((a, b)=>new Date(b.date).getTime() - new Date(a.date).getTime());
    }, [
        searchedTransactions,
        transactions.loading,
        intl
    ]);
    const loadMoreDebounce = (0, $Y6t65.useLoadMoreDebounce)();
    const loadMore = (0, $6uYXW.useCallback)(()=>loadMoreDebounce(transactions.loadMore, transactions.loading || transactions.loadingMore, transactions.canLoadMore), [
        transactions,
        loadMoreDebounce
    ]);
    const fetchPreviousPeriod = ()=>{
        (0, $7Uj1Y.fetchPeriod)("previous", startDate ?? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(), endDate ?? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(), (0, $kqXxS.transactionSearchManager));
    };
    const fetchNextPeriod = ()=>{
        (0, $7Uj1Y.fetchPeriod)("next", startDate ?? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(), endDate ?? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(), (0, $kqXxS.transactionSearchManager));
    };
    (0, $6uYXW.useEffect)(()=>{
        if (startDate) setStartPeriodLabel(`${(0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate)?.subtract(3, "M").format("DD/MM/YYYY")} \u{2192} ${(0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate)?.subtract(1, "days").format("DD/MM/YYYY")}`);
    }, [
        startDate
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (endDate) setNextPeriodLabel(`${(0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate)?.add(1, "days").format("DD/MM/YYYY")} \u{2192} ${(0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate)?.add(3, "M").add(1, "days").format("DD/MM/YYYY")}`);
    }, [
        endDate
    ]);
    const isNextPeriodInTheFuture = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate).add(1, "day").startOf("day").isAfter();
    const showTransactionDetails = (transaction)=>{
        focusedAccount && (0, $5Wai4.Modal).present((0, $bQhUC.ACCOUNT_TRANSACTION_DETAILS_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $eSR05.AccountTransactionDetailsModal), {
                transaction: transaction,
                account: focusedAccount
            }), {
            canBeDismissed: false
        });
    };
    if (!focusedAccount) return null;
    const hasCustomPeriod = timerangeSelection.timeRange === (0, $7yIx1.TimeRange).Other;
    /** One removable chip per filter the drawer holds, so what narrows the list stays in sight. */ const chips = [
        justificationFilter !== (0, $Rr3Qd.JustificationFilter).ALL && {
            key: "justification",
            label: formatMessage(justificationFilter === (0, $Rr3Qd.JustificationFilter).TO_JUSTIFY ? "transactionFilter.toJustify" : "transactionFilter.toQualify"),
            clear: ()=>(0, $kqXxS.transactionSearchManager).setJustificationFilter((0, $Rr3Qd.JustificationFilter).ALL)
        },
        hasAmountFilter && {
            key: "amount",
            label: formattedAmountRange,
            clear: ()=>(0, $kqXxS.transactionSearchManager).setAmountRange(null, null)
        },
        hasCustomPeriod && {
            key: "period",
            label: [
                startDate,
                endDate
            ].filter(Boolean).map((bound)=>formatDate(bound.toDate(), {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                })).join(" \u2192 "),
            clear: ()=>(0, $kqXxS.transactionSearchManager).setTimeRange((0, $7yIx1.TimeRange).Quarter)
        }
    ].filter(Boolean);
    const directions = [
        {
            value: (0, $ao7HR.TransactionDirection).ALL,
            label: formatMessage("transactionFilter.all")
        },
        {
            value: (0, $ao7HR.TransactionDirection).OUTCOME,
            label: formatMessage("transactionFilter.debit")
        },
        {
            value: (0, $ao7HR.TransactionDirection).INCOME,
            label: formatMessage("transactionFilter.credit")
        }
    ];
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $8JW2B.PageBackHeader), {
                title: formatMessage("allTransactions.title"),
                subtitle: formatMessage("allTransactions.subtitle"),
                account: focusedAccount,
                onBack: goBack
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$Controls, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $dtlTY.SegmentedControl), {
                        options: directions,
                        value: transactionDirection,
                        onChange: (direction)=>(0, $kqXxS.transactionSearchManager).setTransactionDirection(direction)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$RightControls, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$SearchField, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$SearchGlyph, {
                                        width: 18,
                                        height: 18,
                                        fill: (0, $22v9q.theme).colors.gray[500]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$SearchInput, {
                                        type: "search",
                                        value: search,
                                        placeholder: formatMessage("transactionFilter.searchInputPlaceholder"),
                                        onChange: (e)=>setSearch(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$FiltersButton, {
                                type: "button",
                                "aria-label": formatMessage("transactionFilter.filtersButton"),
                                onClick: ()=>setShowFilters(true),
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $596TL.FiltersIcon), {})
                            })
                        ]
                    })
                ]
            }),
            chips.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$Chips, {
                children: chips.map((chip)=>/*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$Chip, {
                        type: "button",
                        onClick: chip.clear,
                        children: [
                            chip.label,
                            /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$ChipCross, {})
                        ]
                    }, chip.key))
            }),
            transactions.loading && transactions.data.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$Loader, {}, "spinner") : searchedTransactions.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$EmptyLabel, {
                children: formatMessage("accountTransactions.emptyTransactionList")
            }) : /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$StyledInfiniteScroll, {
                loadMore: loadMore,
                hasMore: transactions.canLoadMore,
                loader: /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$Loader, {}, "transaction-loader"),
                children: sections.map((section)=>/*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$SectionTitle, {
                                children: section.label
                            }),
                            section.data.map((transaction)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $5xxJk.TransactionRow), {
                                    transaction: transaction,
                                    onClick: ()=>showTransactionDetails(transaction)
                                }, transaction.id))
                        ]
                    }, section.label))
            }),
            !transactions.canLoadMore && !transactions.loading && /*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$PeriodButtons, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$PeriodButton, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $dvzf7.TertiaryButton), {
                                onClick: fetchPreviousPeriod,
                                children: formatMessage("accountTransactions.previousPeriodButtonLabel")
                            }),
                            !!startPeriodLabel && /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$PeriodLabel, {
                                children: startPeriodLabel
                            })
                        ]
                    }),
                    !isNextPeriodInTheFuture() && /*#__PURE__*/ (0, $4m918.jsxs)($0112eda00d7d4745$var$PeriodButton, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $dvzf7.TertiaryButton), {
                                onClick: fetchNextPeriod,
                                children: formatMessage("accountTransactions.nextPeriodButtonLabel")
                            }),
                            !!nextPeriodLabel && /*#__PURE__*/ (0, $4m918.jsx)($0112eda00d7d4745$var$PeriodLabel, {
                                children: nextPeriodLabel
                            })
                        ]
                    })
                ]
            }),
            showFilters && /*#__PURE__*/ (0, $4m918.jsx)((0, $fhsMR.TransactionsFilterDrawer), {
                currencyId: (0, $kGswT.getSettlementBalance)(focusedAccount)?.currencyAlpha ?? focusedAccount.currencyAlpha,
                toJustifyCount: transactions.unjustifiedTransactions2.total,
                toQualifyCount: transactions.unqualifiedTransactions.total,
                onClose: ()=>setShowFilters(false)
            })
        ]
    });
}
function $0112eda00d7d4745$var$groupTransactionsByDay(intl, transactions) {
    return transactions.reduce((groups, transaction)=>{
        const dateGroup = intl.formatDate(transaction.date, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        if (groups[dateGroup]) groups[dateGroup].data.push(transaction);
        else groups[dateGroup] = {
            label: intl.formatRelativeDate(transaction.date),
            date: transaction.date,
            data: [
                transaction
            ]
        };
        return groups;
    }, {});
}
const $0112eda00d7d4745$var$Controls = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  margin-bottom: 16px;
`;
/* The field and the button travel together, against the right edge. */ const $0112eda00d7d4745$var$RightControls = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;
const $0112eda00d7d4745$var$SearchField = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 320px;
  max-width: 100%;
  padding: 0 16px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
`;
const $0112eda00d7d4745$var$SearchGlyph = (0, $jb8NR.default)((0, $l0drh.SearchIcon))`
  flex-shrink: 0;
`;
const $0112eda00d7d4745$var$SearchInput = (0, $jb8NR.default).input`
  flex: 1;
  height: 42px;
  border: 0;
  outline: none;
  background-color: transparent;
  ${(0, $22v9q.theme).text};
  font-size: 14px;
  color: ${(0, $22v9q.theme).colors.blue[800]};

  &::placeholder {
    color: ${(0, $22v9q.theme).colors.gray[500]};
  }
`;
const $0112eda00d7d4745$var$FiltersButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
/* Ferried to the right, under the search field they belong to. */ const $0112eda00d7d4745$var$Chips = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  align-self: stretch;
  margin-bottom: 20px;
`;
const $0112eda00d7d4745$var$Chip = (0, $jb8NR.default).button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 16px;
  background-color: #ffffff;
  cursor: pointer;
  ${(0, $22v9q.theme).text};
  font-size: 13px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $0112eda00d7d4745$var$ChipCross = (0, $jb8NR.default)((0, $j26Ew.CloseIcon))`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
`;
const $0112eda00d7d4745$var$Section = (0, $jb8NR.default).section`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  margin-bottom: 8px;
`;
const $0112eda00d7d4745$var$SectionTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).text};
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $0112eda00d7d4745$var$StyledInfiniteScroll = (0, $jb8NR.default)((0, (/*@__PURE__*/$parcel$interopDefault($42awV))))`
  align-self: stretch;
  width: 100%;
`;
const $0112eda00d7d4745$var$Loader = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  align-self: center;
  margin: 24px 0;
`;
const $0112eda00d7d4745$var$EmptyLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  color: ${(0, $22v9q.theme).colors.gray[500]};
`;
const $0112eda00d7d4745$var$PeriodButtons = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: stretch;
  gap: 16px;
  margin-top: 16px;
`;
const $0112eda00d7d4745$var$PeriodButton = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $0112eda00d7d4745$var$PeriodLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 4px;
  font-size: 12px;
  color: ${(0, $22v9q.theme).colors.gray[500]};
`;

});
parcelRegister("42awV", function(module, exports) {

module.exports = (parcelRequire("eFUtU"));

});
parcelRegister("eFUtU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $aaf0b5123a18b27c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6uYXW = parcelRequire("6uYXW");
var $aaf0b5123a18b27c$var$_react2 = $aaf0b5123a18b27c$var$_interopRequireDefault($6uYXW);

var $k8j0a = parcelRequire("k8j0a");
var $aaf0b5123a18b27c$var$_propTypes2 = $aaf0b5123a18b27c$var$_interopRequireDefault($k8j0a);
function $aaf0b5123a18b27c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aaf0b5123a18b27c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $aaf0b5123a18b27c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aaf0b5123a18b27c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $aaf0b5123a18b27c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $aaf0b5123a18b27c$var$InfiniteScroll = function(_Component) {
    $aaf0b5123a18b27c$var$_inherits(InfiniteScroll, _Component);
    function InfiniteScroll(props) {
        $aaf0b5123a18b27c$var$_classCallCheck(this, InfiniteScroll);
        var _this = $aaf0b5123a18b27c$var$_possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));
        _this.scrollListener = _this.scrollListener.bind(_this);
        _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
        _this.mousewheelListener = _this.mousewheelListener.bind(_this);
        return _this;
    }
    $aaf0b5123a18b27c$var$_createClass(InfiniteScroll, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.pageLoaded = this.props.pageStart;
                this.options = this.eventListenerOptions();
                this.attachScrollListener();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.props.isReverse && this.loadMore) {
                    var parentElement = this.getParentElement(this.scrollComponent);
                    parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
                    this.loadMore = false;
                }
                this.attachScrollListener();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.detachScrollListener();
                this.detachMousewheelListener();
            }
        },
        {
            key: 'isPassiveSupported',
            value: function isPassiveSupported() {
                var passive = false;
                var testOptions = {
                    get passive () {
                        passive = true;
                    }
                };
                try {
                    document.addEventListener('test', null, testOptions);
                    document.removeEventListener('test', null, testOptions);
                } catch (e) {
                // ignore
                }
                return passive;
            }
        },
        {
            key: 'eventListenerOptions',
            value: function eventListenerOptions() {
                var options = this.props.useCapture;
                if (this.isPassiveSupported()) options = {
                    useCapture: this.props.useCapture,
                    passive: true
                };
                else options = {
                    passive: false
                };
                return options;
            }
        },
        {
            key: 'setDefaultLoader',
            value: function setDefaultLoader(loader) {
                this.defaultLoader = loader;
            }
        },
        {
            key: 'detachMousewheelListener',
            value: function detachMousewheelListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.scrollComponent.parentNode;
                scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: 'detachScrollListener',
            value: function detachScrollListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.getParentElement(this.scrollComponent);
                scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: 'getParentElement',
            value: function getParentElement(el) {
                var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
                if (scrollParent != null) return scrollParent;
                return el && el.parentNode;
            }
        },
        {
            key: 'filterProps',
            value: function filterProps(props) {
                return props;
            }
        },
        {
            key: 'attachScrollListener',
            value: function attachScrollListener() {
                var parentElement = this.getParentElement(this.scrollComponent);
                if (!this.props.hasMore || !parentElement) return;
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = parentElement;
                scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
                if (this.props.initialLoad) this.scrollListener();
            }
        },
        {
            key: 'mousewheelListener',
            value: function mousewheelListener(e) {
                // Prevents Chrome hangups
                // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
                if (e.deltaY === 1 && !this.isPassiveSupported()) e.preventDefault();
            }
        },
        {
            key: 'scrollListener',
            value: function scrollListener() {
                var el = this.scrollComponent;
                var scrollEl = window;
                var parentNode = this.getParentElement(el);
                var offset = void 0;
                if (this.props.useWindow) {
                    var doc = document.documentElement || document.body.parentNode || document.body;
                    var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
                    if (this.props.isReverse) offset = scrollTop;
                    else offset = this.calculateOffset(el, scrollTop);
                } else if (this.props.isReverse) offset = parentNode.scrollTop;
                else offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
                // Here we make sure the element is visible as well as checking the offset
                if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
                    this.detachScrollListener();
                    this.beforeScrollHeight = parentNode.scrollHeight;
                    this.beforeScrollTop = parentNode.scrollTop;
                    // Call loadMore after detachScrollListener to allow for non-async loadMore functions
                    if (typeof this.props.loadMore === 'function') {
                        this.props.loadMore(this.pageLoaded += 1);
                        this.loadMore = true;
                    }
                }
            }
        },
        {
            key: 'calculateOffset',
            value: function calculateOffset(el, scrollTop) {
                if (!el) return 0;
                return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
            }
        },
        {
            key: 'calculateTopPosition',
            value: function calculateTopPosition(el) {
                if (!el) return 0;
                return el.offsetTop + this.calculateTopPosition(el.offsetParent);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var renderProps = this.filterProps(this.props);
                var children = renderProps.children, element = renderProps.element, hasMore = renderProps.hasMore, initialLoad = renderProps.initialLoad, isReverse = renderProps.isReverse, loader = renderProps.loader, loadMore = renderProps.loadMore, pageStart = renderProps.pageStart, ref = renderProps.ref, threshold = renderProps.threshold, useCapture = renderProps.useCapture, useWindow = renderProps.useWindow, getScrollParent = renderProps.getScrollParent, props = $aaf0b5123a18b27c$var$_objectWithoutProperties(renderProps, [
                    'children',
                    'element',
                    'hasMore',
                    'initialLoad',
                    'isReverse',
                    'loader',
                    'loadMore',
                    'pageStart',
                    'ref',
                    'threshold',
                    'useCapture',
                    'useWindow',
                    'getScrollParent'
                ]);
                props.ref = function(node) {
                    _this2.scrollComponent = node;
                    if (ref) ref(node);
                };
                var childrenArray = [
                    children
                ];
                if (hasMore) {
                    if (loader) isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
                    else if (this.defaultLoader) isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
                }
                return $aaf0b5123a18b27c$var$_react2.default.createElement(element, props, childrenArray);
            }
        }
    ]);
    return InfiniteScroll;
}($6uYXW.Component);
$aaf0b5123a18b27c$var$InfiniteScroll.propTypes = {
    children: $aaf0b5123a18b27c$var$_propTypes2.default.node.isRequired,
    element: $aaf0b5123a18b27c$var$_propTypes2.default.node,
    hasMore: $aaf0b5123a18b27c$var$_propTypes2.default.bool,
    initialLoad: $aaf0b5123a18b27c$var$_propTypes2.default.bool,
    isReverse: $aaf0b5123a18b27c$var$_propTypes2.default.bool,
    loader: $aaf0b5123a18b27c$var$_propTypes2.default.node,
    loadMore: $aaf0b5123a18b27c$var$_propTypes2.default.func.isRequired,
    pageStart: $aaf0b5123a18b27c$var$_propTypes2.default.number,
    ref: $aaf0b5123a18b27c$var$_propTypes2.default.func,
    getScrollParent: $aaf0b5123a18b27c$var$_propTypes2.default.func,
    threshold: $aaf0b5123a18b27c$var$_propTypes2.default.number,
    useCapture: $aaf0b5123a18b27c$var$_propTypes2.default.bool,
    useWindow: $aaf0b5123a18b27c$var$_propTypes2.default.bool
};
$aaf0b5123a18b27c$var$InfiniteScroll.defaultProps = {
    element: 'div',
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    ref: null,
    threshold: 250,
    useWindow: true,
    isReverse: false,
    useCapture: false,
    loader: null,
    getScrollParent: null
};
module.exports.default = $aaf0b5123a18b27c$var$InfiniteScroll;
module.exports = module.exports['default'];

});


parcelRegister("Y6t65", function(module, exports) {

$parcel$export(module.exports, "useLoadMoreDebounce", function () { return $c481b218906f9efa$export$d153e8512d27b37f; });

var $gALIi = parcelRequire("gALIi");

var $6uYXW = parcelRequire("6uYXW");
function $c481b218906f9efa$export$d153e8512d27b37f(wait = 200) {
    return (0, $6uYXW.useCallback)((0, $gALIi.debounce)((fetch, loading, hasMore)=>{
        if (!loading && hasMore) fetch();
    }, wait, {
        leading: false,
        trailing: true
    }), [
        wait
    ]);
}

});

parcelRegister("dtlTY", function(module, exports) {

$parcel$export(module.exports, "SegmentedControl", function () { return $13466d798de45836$export$668709c620d0b8e2; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
function $13466d798de45836$export$668709c620d0b8e2({ options: options, value: value, className: className, onChange: onChange }) {
    return /*#__PURE__*/ (0, $4m918.jsx)($13466d798de45836$var$Track, {
        className: className,
        role: "tablist",
        children: options.map((option)=>/*#__PURE__*/ (0, $4m918.jsx)($13466d798de45836$var$Segment, {
                type: "button",
                role: "tab",
                "aria-selected": value === option.value,
                $selected: value === option.value,
                onClick: ()=>onChange(option.value),
                children: option.label
            }, String(option.value)))
    });
}
const $13466d798de45836$var$Track = (0, $jb8NR.default).div`
  display: inline-flex;
  flex-direction: row;
  gap: 4px;
  padding: 4px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 24px;
  background-color: #ffffff;
`;
const $13466d798de45836$var$Segment = (0, $jb8NR.default).button`
  padding: 10px 24px;
  border: 0;
  border-radius: 20px;
  background-color: ${(props)=>props.$selected ? (0, $22v9q.theme).colors.blue[100] : "transparent"};
  cursor: pointer;
  font-size: 15px;
  line-height: 20px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
  ${(props)=>props.$selected ? (0, $22v9q.theme).mediumText : (0, $22v9q.theme).text};

  &:hover {
    background-color: ${(props)=>props.$selected ? (0, $22v9q.theme).colors.blue[100] : (0, $22v9q.theme).colors.gray[50]};
  }
`;

});

parcelRegister("596TL", function(module, exports) {

$parcel$export(module.exports, "FiltersIcon", function () { return $363330cfc4a5b0dd$export$45a125c43defd703; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $363330cfc4a5b0dd$export$45a125c43defd703(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M3 6h9M15 6h2M3 14h2M8 14h9",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "13.5",
                cy: "6",
                r: "2.25",
                stroke: "currentColor",
                strokeWidth: "1.5",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "6.5",
                cy: "14",
                r: "2.25",
                stroke: "currentColor",
                strokeWidth: "1.5",
                fill: "none"
            })
        ]
    });
}

});

parcelRegister("l0drh", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", function () { return $919ff3c31cada4bd$export$82eafebb825fc23f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $919ff3c31cada4bd$export$82eafebb825fc23f(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                transform: "translate(-599 -180) translate(453 173) translate(139)",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        d: "M0 0H26V26H0z",
                        transform: "translate(7 7)"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        fill: props.fill || "#B1B1B1",
                        d: "M15.745 11.373c0 2.415-1.957 4.372-4.372 4.372S7 13.788 7 11.373 8.958 7 11.373 7s4.372 1.958 4.372 4.373zm-.629 5.157c-1.05.764-2.345 1.215-3.743 1.215-3.52 0-6.373-2.853-6.373-6.372C5 7.853 7.853 5 11.373 5s6.372 2.853 6.372 6.373c0 1.398-.45 2.692-1.215 3.743l4.471 4.471-1.414 1.414-4.47-4.47z",
                        transform: "translate(7 7)"
                    })
                ]
            })
        })
    });
}

});

parcelRegister("fhsMR", function(module, exports) {

$parcel$export(module.exports, "TransactionsFilterDrawer", function () { return $527054fb5a420e35$export$1fec8e6da82d48c0; });

var $4m918 = parcelRequire("4m918");

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $7yIx1 = parcelRequire("7yIx1");

var $Rr3Qd = parcelRequire("Rr3Qd");

var $3Ersk = parcelRequire("3Ersk");

var $bewhU = parcelRequire("bewhU");

var $7Zu6k = parcelRequire("7Zu6k");

var $j26Ew = parcelRequire("j26Ew");

var $6evmn = parcelRequire("6evmn");

var $22v9q = parcelRequire("22v9q");
/** The ceiling of the spending slider, as the design sets it. */ const $527054fb5a420e35$var$AMOUNT_MAX = 3000;
/** The slider moves by the same increment as the app's. */ const $527054fb5a420e35$var$AMOUNT_STEP = 10;
/**
 * The range is shared with whoever else sets it, and a slider cannot show what sits outside its
 * own track: a bound from elsewhere is brought back inside before it is read out.
 */ const $527054fb5a420e35$var$withinBounds = (amount)=>Math.min(Math.max(amount, 0), $527054fb5a420e35$var$AMOUNT_MAX);
function $527054fb5a420e35$export$1fec8e6da82d48c0(props) {
    const { currencyId: currencyId, toJustifyCount: toJustifyCount, toQualifyCount: toQualifyCount, onClose: onClose } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $5hpYi.useIntl)();
    /**
   * Read out the way the app's slider does. The account carries two currency fields and only the
   * ISO alpha one ("EUR") is a currency: the other is the numeric code, which would print as 978.
   */ const formatAmount = (amount)=>currencyId ? formatNumber(amount, {
            currency: currencyId,
            style: "currency",
            minimumFractionDigits: 0
        }) : formatNumber(amount);
    const justification = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).justificationSelection);
    const amountRange = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).amountRange);
    const timeRange = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).timeRangeSelection);
    const [draftJustification, setDraftJustification] = (0, $6uYXW.useState)(justification);
    const [low, setLow] = (0, $6uYXW.useState)($527054fb5a420e35$var$withinBounds(amountRange[0] ?? 0));
    const [high, setHigh] = (0, $6uYXW.useState)($527054fb5a420e35$var$withinBounds(amountRange[1] ?? $527054fb5a420e35$var$AMOUNT_MAX));
    const [from, setFrom] = (0, $6uYXW.useState)($527054fb5a420e35$var$toInputDate(timeRange.bounds[0]));
    const [to, setTo] = (0, $6uYXW.useState)($527054fb5a420e35$var$toInputDate(timeRange.bounds[1]));
    (0, $6uYXW.useEffect)(()=>{
        setDraftJustification(justification);
        setLow($527054fb5a420e35$var$withinBounds(amountRange[0] ?? 0));
        setHigh($527054fb5a420e35$var$withinBounds(amountRange[1] ?? $527054fb5a420e35$var$AMOUNT_MAX));
        setFrom($527054fb5a420e35$var$toInputDate(timeRange.bounds[0]));
        setTo($527054fb5a420e35$var$toInputDate(timeRange.bounds[1]));
    }, [
        justification,
        amountRange,
        timeRange
    ]);
    const clearAll = ()=>{
        setDraftJustification((0, $Rr3Qd.JustificationFilter).ALL);
        setLow(0);
        setHigh($527054fb5a420e35$var$AMOUNT_MAX);
        setFrom("");
        setTo("");
    };
    const apply = ()=>{
        (0, $kqXxS.transactionSearchManager).setJustificationFilter(draftJustification);
        // Untouched ends mean no bound at all, so the API is not handed a range nobody asked for.
        (0, $kqXxS.transactionSearchManager).setAmountRange(low > 0 ? low : null, high < $527054fb5a420e35$var$AMOUNT_MAX ? high : null);
        if (from && to) (0, $kqXxS.transactionSearchManager).setTimeRange((0, $7yIx1.TimeRange).Other, [
            (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(from),
            (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(to)
        ]);
        else (0, $kqXxS.transactionSearchManager).setTimeRange((0, $7yIx1.TimeRange).Quarter);
        onClose();
    };
    const choices = [
        {
            value: (0, $Rr3Qd.JustificationFilter).ALL,
            label: formatMessage("transactionFilter.all"),
            count: undefined
        },
        {
            value: (0, $Rr3Qd.JustificationFilter).TO_JUSTIFY,
            label: formatMessage("transactionFilter.toJustify"),
            count: toJustifyCount
        },
        {
            value: (0, $Rr3Qd.JustificationFilter).TO_QUALIFY,
            label: formatMessage("transactionFilter.toQualify"),
            count: toQualifyCount
        }
    ];
    return /*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$Panel, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$CloseButton, {
                type: "button",
                onClick: onClose,
                "aria-label": formatMessage("transactionFilter.panelTitle"),
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $j26Ew.CloseIcon), {})
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$TitleRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$PanelTitle, {
                        children: formatMessage("transactionFilter.panelTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$ClearLink, {
                        type: "button",
                        onClick: clearAll,
                        children: formatMessage("transactionFilter.clearAll")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$Choices, {
                children: choices.map((choice)=>/*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$Choice, {
                        type: "button",
                        $selected: draftJustification === choice.value,
                        onClick: ()=>setDraftJustification(choice.value),
                        children: [
                            choice.label,
                            choice.count !== undefined && choice.count > 0 && /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$Count, {
                                children: choice.count
                            })
                        ]
                    }, choice.value))
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$SectionTitle, {
                children: formatMessage("transactionFilter.amountRangeTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$RangeBounds, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("span", {
                        children: formatAmount(low)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("span", {
                        children: formatAmount(high)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$RangeTrack, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$RangeFill, {
                        $from: low / $527054fb5a420e35$var$AMOUNT_MAX * 100,
                        $to: high / $527054fb5a420e35$var$AMOUNT_MAX * 100
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$RangeInput, {
                        type: "range",
                        min: 0,
                        max: $527054fb5a420e35$var$AMOUNT_MAX,
                        step: $527054fb5a420e35$var$AMOUNT_STEP,
                        value: low,
                        "aria-label": formatMessage("transactionFilter.amountRange.min"),
                        onChange: (e)=>setLow(Math.min(Number(e.target.value), high))
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$RangeInput, {
                        type: "range",
                        min: 0,
                        max: $527054fb5a420e35$var$AMOUNT_MAX,
                        step: $527054fb5a420e35$var$AMOUNT_STEP,
                        value: high,
                        "aria-label": formatMessage("transactionFilter.amountRange.max"),
                        onChange: (e)=>setHigh(Math.max(Number(e.target.value), low))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$SectionTitle, {
                children: formatMessage("transactionFilter.periodTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$Dates, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$DateField, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$DateCaption, {
                                children: formatMessage("transactionFilter.timeRange.from")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$StyledDateInput, {
                                mode: "date",
                                withoutTheme: true,
                                value: from,
                                onChange: (e)=>setFrom(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($527054fb5a420e35$var$DateField, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$DateCaption, {
                                children: formatMessage("transactionFilter.timeRange.to")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$StyledDateInput, {
                                mode: "date",
                                withoutTheme: true,
                                value: to,
                                onChange: (e)=>setTo(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($527054fb5a420e35$var$ApplyButton, {
                size: "XS",
                onClick: apply,
                children: formatMessage("transactionFilter.apply")
            })
        ]
    });
}
function $527054fb5a420e35$var$toInputDate(bound) {
    return bound ? bound.format("YYYY-MM-DD") : "";
}
const $527054fb5a420e35$var$Panel = (0, $jb8NR.default).aside`
  position: fixed;
  z-index: 150;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 370px;
  max-width: 100%;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: -8px 0 24px 0 rgba(0, 0, 0, 0.08);
  overflow-y: auto;
`;
const $527054fb5a420e35$var$CloseButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  align-self: flex-end;
  padding: 8px;
  margin: -8px -8px 0 0;
`;
const $527054fb5a420e35$var$TitleRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 16px;
`;
const $527054fb5a420e35$var$PanelTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $527054fb5a420e35$var$ClearLink = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  ${(0, $22v9q.theme).text};
  font-size: 14px;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
const $527054fb5a420e35$var$Choices = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
`;
const $527054fb5a420e35$var$Choice = (0, $jb8NR.default).button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid ${(props)=>props.$selected ? (0, $22v9q.theme).colors.blue[700] : (0, $22v9q.theme).colors.gray[300]};
  border-radius: 20px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  color: ${(props)=>props.$selected ? (0, $22v9q.theme).colors.blue[700] : (0, $22v9q.theme).colors.blue[800]};
`;
const $527054fb5a420e35$var$Count = (0, $jb8NR.default).span`
  font-size: 12px;
  color: ${(0, $22v9q.theme).colors.gray[700]};
`;
const $527054fb5a420e35$var$SectionTitle = (0, $jb8NR.default).h3`
  ${(0, $22v9q.theme).text};
  margin: 28px 0 12px;
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $527054fb5a420e35$var$RangeBounds = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${(0, $22v9q.theme).text};
  font-size: 13px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $527054fb5a420e35$var$RangeTrack = (0, $jb8NR.default).div`
  position: relative;
  height: 24px;
  margin-top: 8px;

  &::before {
    content: "";
    position: absolute;
    top: 11px;
    right: 0;
    left: 0;
    height: 2px;
    border-radius: 1px;
    background-color: ${(0, $22v9q.theme).colors.gray[300]};
  }
`;
const $527054fb5a420e35$var$RangeFill = (0, $jb8NR.default).div`
  position: absolute;
  top: 11px;
  left: ${(props)=>props.$from}%;
  width: ${(props)=>props.$to - props.$from}%;
  height: 2px;
  border-radius: 1px;
  background-color: ${(0, $22v9q.theme).colors.blue[700]};
`;
/* Both inputs cover the track; only their thumbs take the pointer, so either end stays reachable. */ const $527054fb5a420e35$var$RangeInput = (0, $jb8NR.default).input`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 24px;
  margin: 0;
  appearance: none;
  background: transparent;
  pointer-events: none;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 16px;
    height: 16px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    background-color: ${(0, $22v9q.theme).colors.blue[700]};
    cursor: pointer;
    pointer-events: auto;
  }

  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    background-color: ${(0, $22v9q.theme).colors.blue[700]};
    cursor: pointer;
    pointer-events: auto;
  }
`;
const $527054fb5a420e35$var$Dates = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;
const $527054fb5a420e35$var$DateField = (0, $jb8NR.default).label`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
`;
const $527054fb5a420e35$var$DateCaption = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 12px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $527054fb5a420e35$var$StyledDateInput = (0, $jb8NR.default)((0, $6evmn.DateInput))`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[300]};
  border-radius: 8px;
  font-size: 14px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $527054fb5a420e35$var$ApplyButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  width: 100%;
  margin-top: 28px;
  padding: 13px;
  box-shadow: none;
`;

});


parcelRegister("bBtVU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c91a4ab22fb8de6$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $9beBp = parcelRequire("9beBp");

var $2jAE5 = parcelRequire("2jAE5");

var $4fYE4 = parcelRequire("4fYE4");

var $yYT9n = parcelRequire("yYT9n");

var $dvzf7 = parcelRequire("dvzf7");

var $jn1mK = parcelRequire("jn1mK");

var $finOR = parcelRequire("finOR");

var $amCCH = parcelRequire("amCCH");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $f5Iw6 = parcelRequire("f5Iw6");

var $i7hHc = parcelRequire("i7hHc");
function $1c91a4ab22fb8de6$export$2e2bcd8739ae039() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { billIssuers: billIssuers, load: load, loading: loading, refreshing: refreshing, error: error, search: search, setSearch: setSearch, billIssuerColors: billIssuerColors } = (0, $9beBp.useBillIssuer)();
    const searchedIssuers = (0, $6uYXW.useMemo)(()=>billIssuers && search ? (0, $2jAE5.collectIssuersWithTopLevelCategory)(billIssuers).filter((billIssuer)=>billIssuer.name && billIssuer.name.toLowerCase().includes(search.toLowerCase())) : null, [
        billIssuers,
        search
    ]);
    const colors = (0, $6uYXW.useMemo)(()=>new Map(billIssuers ? billIssuers.filter((issuerOrCategory)=>issuerOrCategory.type === "CATEGORY").map((category, index)=>[
                category.id,
                billIssuerColors[index % billIssuerColors.length]
            ]) : null), [
        billIssuers,
        billIssuerColors
    ]);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    (0, $6uYXW.useEffect)(()=>{
        load();
    }, []);
    return /*#__PURE__*/ (0, $4m918.jsxs)($1c91a4ab22fb8de6$var$BillIssuerSection, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)((0, $amCCH.PageHeader), {
                title: formatMessage("billIssuersScreen.title"),
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$GoToMyReferencesLink, {
                        to: (0, $4fYE4.Path).References,
                        $isRTL: isRTL,
                        children: formatMessage("billIssuersScreen.references")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $finOR.SearchBar), {
                        initialValue: search || "",
                        onChange: (text)=>setSearch(text)
                    })
                ]
            }),
            billIssuers && billIssuers.length > 0 ? searchedIssuers ? searchedIssuers.map((issuer)=>/*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$StyledBillIssuerView, {
                    issuer: issuer,
                    color: colors.get(issuer.topLevelCategory?.id ?? "") || "#000000",
                    topLevelCategory: issuer.topLevelCategory
                }, issuer.id)) : /*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$BillIssuerRenderer, {
                issuers: billIssuers,
                colors: colors,
                isTopLevel: true
            }) : loading || refreshing ? /*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$StyledSpinner, {}) : error ? /*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$StyledErrorMessage, {
                children: formatMessage("billIssuersScreen.loadBillIssuersError")
            }) : /*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$EmptyListMessage, {
                children: formatMessage("billIssuersScreen.emptyListLabel")
            })
        ]
    });
}
const $1c91a4ab22fb8de6$var$BillIssuerRenderer = ({ issuers: issuers, colors: colors, isTopLevel: isTopLevel, topLevelCategory: topLevelCategory })=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: issuers.map((issuerOrCategory)=>issuerOrCategory.type === "CATEGORY" ? /*#__PURE__*/ (0, $4m918.jsx)((0, $f5Iw6.BillCategoryView), {
                category: issuerOrCategory,
                color: colors.get(issuerOrCategory.id) || "#000000",
                isTopLevel: isTopLevel,
                children: /*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$BillIssuerRenderer, {
                    issuers: issuerOrCategory.children,
                    colors: colors,
                    topLevelCategory: topLevelCategory || issuerOrCategory
                })
            }, issuerOrCategory.id) : isTopLevel ? /*#__PURE__*/ (0, $4m918.jsx)($1c91a4ab22fb8de6$var$StyledBillIssuerView, {
                issuer: issuerOrCategory,
                color: colors.get(topLevelCategory?.id ?? "") || "#000000",
                topLevelCategory: topLevelCategory
            }, issuerOrCategory.id) : /*#__PURE__*/ (0, $4m918.jsx)((0, $i7hHc.BillIssuerView), {
                issuer: issuerOrCategory,
                color: colors.get(topLevelCategory?.id ?? "") || "#000000",
                topLevelCategory: topLevelCategory
            }, issuerOrCategory.id))
    });
const $1c91a4ab22fb8de6$var$BillIssuerSection = (0, $jb8NR.default).section`
  align-self: stretch;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $1c91a4ab22fb8de6$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 30px;
`;
const $1c91a4ab22fb8de6$var$EmptyListMessage = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.875rem;
  color: #b1b1b1;
  padding: 0 20px;
  margin-top: 30px;
  text-align: center;
`;
const $1c91a4ab22fb8de6$var$StyledSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: 40px auto 0 auto;
`;
const $1c91a4ab22fb8de6$var$StyledBillIssuerView = (0, $jb8NR.default)((0, $i7hHc.BillIssuerView))`
  margin: 10px 0;
  border-radius: 10px;
  ${(0, $22v9q.shadows).medium};
  background-color: #ffffff;
`;
const $1c91a4ab22fb8de6$var$GoToMyReferencesLink = (0, $jb8NR.default)((0, $dvzf7.TertiaryLink))`
  text-align: center;
  margin-right: ${(props)=>props.$isRTL ? 0 : 10}px;
  margin-left: ${(props)=>props.$isRTL ? 10 : 0}px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-bottom: 20px;
  }
`;

});
parcelRegister("9beBp", function(module, exports) {

$parcel$export(module.exports, "useBillIssuer", function () { return $4e4b8693c5d582cb$export$8ab47ec8d7c543b0; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");
const $4e4b8693c5d582cb$export$8ab47ec8d7c543b0 = (issuerTypes)=>{
    const billIssuers = (0, $3Ersk.useObservable)((0, $kqXxS.billIssuerManager).issuers);
    const loading = (0, $3Ersk.useObservable)((0, $kqXxS.billIssuerManager).loading);
    const refreshing = (0, $3Ersk.useObservable)((0, $kqXxS.billIssuerManager).refreshing);
    const error = (0, $3Ersk.useObservable)((0, $kqXxS.billIssuerManager).error);
    const cacheStatus = (0, $3Ersk.useObservable)((0, $kqXxS.billIssuerManager).cacheStatus);
    const search = (0, $3Ersk.useObservable)((0, $kqXxS.billIssuerSelectionManager).search);
    const hierarchy = (0, $3Ersk.useObservable)((0, $kqXxS.billIssuerSelectionManager).hierarchy);
    const setSearch = (0, $6uYXW.useCallback)((searchParam)=>(0, $kqXxS.billIssuerSelectionManager).search.set(searchParam), []);
    const filteredCategories = (0, $6uYXW.useMemo)(()=>issuerTypes ? billIssuers.filter((billIssuer)=>issuerTypes.includes(billIssuer.id)) : billIssuers, [
        issuerTypes,
        billIssuers
    ]);
    const allChildrenIssuers = (0, $6uYXW.useMemo)(()=>filteredCategories.reduce((acc, curr)=>[
                ...acc,
                ...curr.children?.filter((billIssuer)=>billIssuer.type === "BILL_ISSUER")
            ].filter((billIssuer)=>search ? billIssuer.name?.toLowerCase().includes(search.toLowerCase()) : true), []) || [], [
        filteredCategories,
        search
    ]);
    const setHierarchy = (0, $6uYXW.useCallback)((hierarchyParam)=>(0, $kqXxS.billIssuerSelectionManager).hierarchy.set(hierarchyParam), []);
    const load = (0, $6uYXW.useCallback)(()=>{
        (0, $kqXxS.billIssuerManager).load();
    }, []);
    const refresh = (0, $6uYXW.useCallback)(()=>{
        (0, $kqXxS.billIssuerManager).refresh();
    }, []);
    const refreshSearch = (0, $6uYXW.useCallback)(()=>{
        setSearch("");
    }, [
        setSearch
    ]);
    const billIssuerColors = (0, $kqXxS.configurationManager).getBillIssuerColors();
    return {
        billIssuers: billIssuers,
        allChildrenIssuers: allChildrenIssuers,
        filteredCategories: filteredCategories,
        billIssuerColors: billIssuerColors,
        refreshing: refreshing,
        load: load,
        loading: loading,
        error: error,
        cacheStatus: cacheStatus,
        search: search,
        hierarchy: hierarchy,
        refresh: refresh,
        refreshSearch: refreshSearch,
        setSearch: setSearch,
        setHierarchy: setHierarchy
    };
};

});

parcelRegister("2jAE5", function(module, exports) {

$parcel$export(module.exports, "collectIssuersWithTopLevelCategory", function () { return $d97d946965688b60$export$8cf8020d87e947c0; });
function $d97d946965688b60$export$2d1c78e1f4c39e3a(issuers) {
    return issuers.reduce((acc, item)=>item.type === "CATEGORY" ? [
            ...acc,
            ...$d97d946965688b60$export$2d1c78e1f4c39e3a(item.children)
        ] : [
            ...acc,
            item
        ], []);
}
function $d97d946965688b60$export$8cf8020d87e947c0(issuers, topLevelCategory) {
    return issuers.reduce((acc, item)=>item.type === "CATEGORY" ? [
            ...acc,
            ...$d97d946965688b60$export$8cf8020d87e947c0(item.children, topLevelCategory || item)
        ] : [
            ...acc,
            {
                topLevelCategory: topLevelCategory,
                ...item
            }
        ], []);
}

});

parcelRegister("finOR", function(module, exports) {

$parcel$export(module.exports, "SearchBar", function () { return $0b77cff71ba01a85$export$79d13b60110f33be; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $gDlNU = parcelRequire("gDlNU");

var $yYT9n = parcelRequire("yYT9n");

var $9mlIh = parcelRequire("9mlIh");

var $l0drh = parcelRequire("l0drh");

var $22v9q = parcelRequire("22v9q");
const $0b77cff71ba01a85$export$79d13b60110f33be = ({ value: value, placeholder: placeholder, initialValue: initialValue, onChange: onChange, autoFocus: autoFocus, className: className, withIcon: withIcon = true, widthSize: widthSize })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [searchText, setSearchText] = (0, $6uYXW.useState)(initialValue);
    const notifyTextChange = (text)=>{
        setSearchText(text);
        onChange && onChange(text);
    };
    const active = (0, $gDlNU.isDefined)(searchText) && searchText.length > 0;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    (0, $6uYXW.useEffect)(()=>{
        setSearchText(value ?? "");
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($0b77cff71ba01a85$var$SearchBarContainer, {
        className: className,
        $isRTL: isRTL,
        children: [
            withIcon ? /*#__PURE__*/ (0, $4m918.jsx)((0, $l0drh.SearchIcon), {
                fill: active ? (0, $22v9q.theme).mainColor() : "#b1b1b1",
                width: 26,
                height: 26
            }) : null,
            /*#__PURE__*/ (0, $4m918.jsx)($0b77cff71ba01a85$var$StyledTextInput, {
                autoFocus: autoFocus,
                value: value || searchText,
                onChange: (e)=>notifyTextChange(e.target.value),
                placeholder: placeholder ?? formatMessage("billIssuersScreen.searchInputPlaceholder"),
                widthSize: widthSize
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($0b77cff71ba01a85$var$ActiveMark, {
                visible: active,
                $isRTL: isRTL
            })
        ]
    });
};
const $0b77cff71ba01a85$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  width: ${(props)=>props.widthSize ?? 250}px;
  background-color: #f4f4f4;
  box-shadow: unset;
  padding: 10px 5px;

  input {
    background-color: #f4f4f4;
    font-weight: normal;
  }
`;
const $0b77cff71ba01a85$var$SearchBarContainer = (0, $jb8NR.default).div`
  position: relative;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: ${(props)=>props.$isRTL ? 0 : 10}px;
  padding-right: ${(props)=>props.$isRTL ? 10 : 0}px;
  border-radius: 10px;
`;
const $0b77cff71ba01a85$var$ActiveMark = (0, $jb8NR.default).div`
  position: absolute;
  left: ${(props)=>props.$isRTL ? "unset" : "0px"};
  right: ${(props)=>props.$isRTL ? "0px" : "unset"};
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 3.5px;
  background-color: ${(0, $22v9q.theme).mainColor};
  opacity: ${(props)=>props.visible ? 1 : 0};
`;

});

parcelRegister("f5Iw6", function(module, exports) {

$parcel$export(module.exports, "BillCategoryView", function () { return $62f49b3fefce659c$export$2a1d66b4365c2259; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");

var $lIea8 = parcelRequire("lIea8");

var $iE8YO = parcelRequire("iE8YO");
const $62f49b3fefce659c$export$2a1d66b4365c2259 = ({ category: category, color: color, isTopLevel: isTopLevel, children: children })=>{
    const [isOpened, setIsOpened] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $4m918.jsxs)($62f49b3fefce659c$var$Category, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($62f49b3fefce659c$var$CategoryContainer, {
                onClick: ()=>setIsOpened(!isOpened),
                style: isTopLevel ? {
                    backgroundColor: color,
                    borderRadius: 20
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($62f49b3fefce659c$var$CategoryIcon, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($62f49b3fefce659c$var$Logo, {
                            src: (0, $lIea8.billCategoryIcon)[category.id] || (0, $lIea8.billCategoryIcon).default
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($62f49b3fefce659c$var$CategoryName, {
                        style: {
                            color: isTopLevel ? "#fff" : "#000"
                        },
                        children: category.name
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $iE8YO.CategoryOpener), {
                        isOpened: isOpened
                    })
                ]
            }),
            isOpened && children
        ]
    });
};
const $62f49b3fefce659c$var$Category = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  margin: 10px 0;
  ${(0, $22v9q.shadows).medium};
  background-color: #ffffff;
  align-items: stretch;
`;
const $62f49b3fefce659c$var$CategoryContainer = (0, $jb8NR.default).div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const $62f49b3fefce659c$var$CategoryIcon = (0, $jb8NR.default).div`
  display: flex;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background-color: rgba(0, 0, 0, 0.2);
  margin: 16px;
  align-items: center;
  justify-content: center;
`;
const $62f49b3fefce659c$var$CategoryName = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 1rem;
  margin: 0 16px;
  flex: 1;
`;
const $62f49b3fefce659c$var$Logo = (0, $jb8NR.default).img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

});
parcelRegister("lIea8", function(module, exports) {

$parcel$export(module.exports, "billCategoryIcon", function () { return $973e5b791ac1339d$export$1103f7d0fd746ed2; });









const $973e5b791ac1339d$export$1103f7d0fd746ed2 = {
    BILL_ISSUER_ELECTRICITY: {},
    Electricity: {},
    BILL_ISSUER_WATER: {},
    Water: {},
    BILL_ISSUER_MOBILE: {},
    Mobile: {},
    BILL_ISSUER_DSTV: {},
    DStv: {},
    default: {}
};

});

parcelRegister("iE8YO", function(module, exports) {

$parcel$export(module.exports, "CategoryOpener", function () { return $8b9f095cfbb25f30$export$878355728579da58; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $51d3M = parcelRequire("51d3M");
const $8b9f095cfbb25f30$export$878355728579da58 = ({ isOpened: isOpened, ...otherProps })=>/*#__PURE__*/ (0, $4m918.jsx)($8b9f095cfbb25f30$var$CategoryIcon, {
        ...otherProps,
        children: /*#__PURE__*/ (0, $4m918.jsx)($8b9f095cfbb25f30$var$StyledChevronIcon, {
            style: {
                transform: isOpened ? "rotate(-90deg)" : "rotate(90deg)"
            }
        })
    });
const $8b9f095cfbb25f30$var$CategoryIcon = (0, $jb8NR.default).div`
  display: flex;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background-color: #f4f4f4;
  margin: 16px;
  align-items: center;
  justify-content: center;
`;
const $8b9f095cfbb25f30$var$StyledChevronIcon = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  width: 20px;
  height: 20px;
  transition: transform linear 0.2s;
`;

});


parcelRegister("i7hHc", function(module, exports) {

$parcel$export(module.exports, "BillIssuerView", function () { return $71ff7f7065d6c2d8$export$1cdc3173c4c657f7; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $bQhUC = parcelRequire("bQhUC");

var $arOSR = parcelRequire("arOSR");

var $eWtPC = parcelRequire("eWtPC");

var $5Wai4 = parcelRequire("5Wai4");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $flGUg = parcelRequire("flGUg");

var $kjBAo = parcelRequire("kjBAo");

var $lIea8 = parcelRequire("lIea8");
const $71ff7f7065d6c2d8$export$1cdc3173c4c657f7 = ({ issuer: issuer, topLevelCategory: topLevelCategory, color: color, withReference: withReference, ...otherProps })=>{
    const [openMenu, setOpenMenu] = (0, $6uYXW.useState)(false);
    const toggleMenu = ()=>setOpenMenu((bool)=>!bool);
    return /*#__PURE__*/ (0, $4m918.jsxs)($71ff7f7065d6c2d8$var$IssuerContainer, {
        ...otherProps,
        onClick: (0, $flGUg.performTaskIfPossible)(()=>{
            (0, $5Wai4.Modal).present((0, $bQhUC.BILL_ISSUER_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $kjBAo.BillIssuerModal), {
                    issuer: issuer,
                    topLevelCategory: topLevelCategory,
                    color: color
                }), {
                canBeDismissed: false
            });
        }),
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($71ff7f7065d6c2d8$var$IssuerIcon, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($71ff7f7065d6c2d8$var$LogoWithFallback, {
                    src: issuer.logoUrl || "",
                    width: $71ff7f7065d6c2d8$var$LOGO_WIDTH,
                    height: $71ff7f7065d6c2d8$var$LOGO_HEIGHT,
                    renderErrorImage: ()=>/*#__PURE__*/ (0, $4m918.jsx)($71ff7f7065d6c2d8$var$Logo, {
                            style: {
                                backgroundColor: color
                            },
                            src: (0, $lIea8.billCategoryIcon)[topLevelCategory?.id ?? ""] || (0, $lIea8.billCategoryIcon).default
                        })
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($71ff7f7065d6c2d8$var$DataContainer, {
                children: [
                    issuer.name && /*#__PURE__*/ (0, $4m918.jsx)($71ff7f7065d6c2d8$var$IssuerName, {
                        children: issuer.name
                    }),
                    withReference && issuer.references?.[0] && /*#__PURE__*/ (0, $4m918.jsx)($71ff7f7065d6c2d8$var$IssuerReference, {
                        children: issuer.references[0]
                    })
                ]
            }),
            withReference && /*#__PURE__*/ (0, $4m918.jsxs)($71ff7f7065d6c2d8$var$MoreMenu, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.MoreButton), {
                        active: openMenu,
                        onClick: toggleMenu
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.DeleteButton), {
                        show: openMenu,
                        onClick: ()=>(0, $kqXxS.billIssuerManager).deleteReference(issuer)
                    })
                ]
            })
        ]
    });
};
const $71ff7f7065d6c2d8$var$IssuerContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;
const $71ff7f7065d6c2d8$var$IssuerIcon = (0, $jb8NR.default).div`
  width: 65px;
  height: 45px;
  border-radius: 9px;
  margin: 16px;
  align-items: center;
  justify-content: center;
`;
const $71ff7f7065d6c2d8$var$IssuerName = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.9375rem;
  color: #000000;
  flex-shrink: 1;
  padding-right: 10px;
`;
const $71ff7f7065d6c2d8$var$LOGO_WIDTH = 55;
const $71ff7f7065d6c2d8$var$LOGO_HEIGHT = 45;
const $71ff7f7065d6c2d8$var$LogoWithFallback = (0, $jb8NR.default)((0, $eWtPC.ImageWithFallback))`
  object-fit: contain;
`;
const $71ff7f7065d6c2d8$var$Logo = (0, $jb8NR.default).img`
  width: ${$71ff7f7065d6c2d8$var$LOGO_WIDTH}px;
  height: ${$71ff7f7065d6c2d8$var$LOGO_HEIGHT}px;
  padding: 10px;
  object-fit: contain;
  border-radius: 10px;
`;
const $71ff7f7065d6c2d8$var$MoreMenu = (0, $jb8NR.default).div`
  position: absolute;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  right: 25px;
  top: 0;
  bottom: 0;
  z-index: 1;
`;
const $71ff7f7065d6c2d8$var$DataContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const $71ff7f7065d6c2d8$var$IssuerReference = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.9375rem;
  color: #000000;
`;

});
parcelRegister("arOSR", function(module, exports) {

$parcel$export(module.exports, "MoreButton", function () { return $29a23b1d8d61cfd3$export$7f94856880993f27; });
$parcel$export(module.exports, "DeleteButton", function () { return $29a23b1d8d61cfd3$export$d6f68d0fe29f8050; });
$parcel$export(module.exports, "EditButton", function () { return $29a23b1d8d61cfd3$export$a8d3280cb45e38b8; });
$parcel$export(module.exports, "PauseButton", function () { return $29a23b1d8d61cfd3$export$72bd7594b33d50e; });
$parcel$export(module.exports, "OpenButton", function () { return $29a23b1d8d61cfd3$export$3a4c6d3406a95fae; });
$parcel$export(module.exports, "CancelButton", function () { return $29a23b1d8d61cfd3$export$488fee190faedb43; });
$parcel$export(module.exports, "PlayButton", function () { return $29a23b1d8d61cfd3$export$fbed5f62d839a0cd; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $9NRo2 = parcelRequire("9NRo2");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7RQw4 = parcelRequire("7RQw4");

var $k4kME = parcelRequire("k4kME");

var $hYGJn = parcelRequire("hYGJn");

var $26OFD = parcelRequire("26OFD");

var $3YfEE = parcelRequire("3YfEE");

var $7wSRt = parcelRequire("7wSRt");

var $4Mx75 = parcelRequire("4Mx75");
const $29a23b1d8d61cfd3$var$BUTTON_RIGHT_MARGIN = 12;
const $29a23b1d8d61cfd3$var$BUTTON_SIZE = 34;
const $29a23b1d8d61cfd3$export$7f94856880993f27 = (props)=>{
    const { onClick: onClick } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$StyledRoundedSquare, {
        size: $29a23b1d8d61cfd3$var$BUTTON_SIZE,
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        children: /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$StyledDotsIcon, {})
    });
};
const $29a23b1d8d61cfd3$var$StyledRoundedSquare = (0, $jb8NR.default)((0, $7RQw4.RoundedSquare))`
  background-color: white;
  transition: background-color 0.5s ease;

  &:hover {
    background-color: #f4f4f4;
    cursor: pointer;
  }
`;
const $29a23b1d8d61cfd3$var$StyledDotsIcon = (0, $jb8NR.default)((0, $26OFD.DotsIcon))`
  fill: black;
  transform: rotate(90deg);
`;
const $29a23b1d8d61cfd3$var$ActionIcon = (0, $jb8NR.default).img`
  width: 20px;
  height: 20px;
`;
const $29a23b1d8d61cfd3$var$BlackRoundedSquare = (0, $jb8NR.default)((0, $7RQw4.RoundedSquare))`
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  background-color: #ffffff;
  margin-right: ${$29a23b1d8d61cfd3$var$BUTTON_RIGHT_MARGIN}px;
  transform: ${(props)=>props.$show ? "translateX(0}px)" : `translateX(${$29a23b1d8d61cfd3$var$BUTTON_SIZE + $29a23b1d8d61cfd3$var$BUTTON_RIGHT_MARGIN}px)`};
  opacity: ${(props)=>props.$show ? "1" : "0"};
  transition:
    transform 0.2s,
    opacity 0.2s;
`;
const $29a23b1d8d61cfd3$export$d6f68d0fe29f8050 = (props)=>{
    const { onClick: onClick, ...other } = props;
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const deleteOperation = async ()=>{
        try {
            setLoading(true);
            await onClick();
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$MenuButton, {
        onClick: deleteOperation,
        ...other,
        children: loading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {
            color: (0, $22v9q.theme).colors.blue[800],
            size: "13px"
        }) : /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$ActionIcon, {
            src: (0, $fRvTz.StaticAssets).trash,
            alt: ""
        })
    });
};
const $29a23b1d8d61cfd3$export$a8d3280cb45e38b8 = (props)=>{
    const { onClick: onClick, ...other } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$MenuButton, {
        onClick: onClick,
        ...other,
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7wSRt.PenIcon), {
            width: 20,
            fill: "#000000"
        })
    });
};
const $29a23b1d8d61cfd3$export$72bd7594b33d50e = (props)=>{
    const { isPaused: isPaused, onClick: onClick, ...other } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$MenuButton, {
        onClick: onClick,
        ...other,
        children: isPaused ? /*#__PURE__*/ (0, $4m918.jsx)((0, $4Mx75.PlayIcon), {
            width: 20,
            fill: "#000000"
        }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $3YfEE.PauseIcon), {
            width: 20,
            fill: "#000000"
        })
    });
};
const $29a23b1d8d61cfd3$export$3a4c6d3406a95fae = (props)=>{
    const { onClick: onClick, ...other } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$MenuButton, {
        onClick: onClick,
        ...other,
        children: /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$ActionIcon, {
            src: (0, $fRvTz.StaticAssets).eye,
            alt: ""
        })
    });
};
const $29a23b1d8d61cfd3$export$488fee190faedb43 = (props)=>{
    const { onClick: onClick, ...other } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$MenuButton, {
        onClick: onClick,
        ...other,
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $hYGJn.CancelIcon), {
            width: 20,
            color: "#000000"
        })
    });
};
const $29a23b1d8d61cfd3$export$fbed5f62d839a0cd = (props)=>{
    const { onClick: onClick, ...other } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$MenuButton, {
        onClick: onClick,
        ...other,
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $4Mx75.PlayIcon), {
            width: 20,
            fill: "#000000"
        })
    });
};
const $29a23b1d8d61cfd3$var$MenuButton = (props)=>{
    const { show: show, onClick: onClick, children: children } = props;
    const [translateAnimation, setTranslateAnimation] = (0, $6uYXW.useState)(false);
    const { shouldRender: shouldRender, onTransitionEnd: onTransitionEnd } = (0, $9NRo2.useMountAnimation)(show, ()=>setTranslateAnimation(true), ()=>setTranslateAnimation(false));
    return shouldRender ? /*#__PURE__*/ (0, $4m918.jsx)($29a23b1d8d61cfd3$var$BlackRoundedSquare, {
        size: $29a23b1d8d61cfd3$var$BUTTON_SIZE,
        $show: translateAnimation,
        onTransitionEnd: onTransitionEnd,
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        children: children
    }) : null;
};

});
parcelRegister("9NRo2", function(module, exports) {

$parcel$export(module.exports, "useMountAnimation", function () { return $664f3f27660455f1$export$9908cbf70724d74e; });

var $6uYXW = parcelRequire("6uYXW");
const $664f3f27660455f1$export$9908cbf70724d74e = (visible, mountAnimation, unmountAnimation)=>{
    const [shouldRender, setShouldRender] = (0, $6uYXW.useState)(visible);
    (0, $6uYXW.useEffect)(()=>{
        if (shouldRender) mountAnimation && mountAnimation();
    // Does not support mount animation change between renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldRender
    ]);
    (0, $6uYXW.useLayoutEffect)(()=>{
        if (visible) setShouldRender(true);
        else unmountAnimation && unmountAnimation();
    // Does not support unmount animation change between renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visible
    ]);
    const onTransitionEnd = ()=>{
        if (!visible) setShouldRender(false);
    };
    return {
        shouldRender: shouldRender,
        onTransitionEnd: onTransitionEnd
    };
};

});

parcelRegister("hYGJn", function(module, exports) {

$parcel$export(module.exports, "CancelIcon", function () { return $18d784440e1d69a1$export$3259ba4c3540caf0; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $18d784440e1d69a1$export$3259ba4c3540caf0(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                stroke: "currentColor",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("line", {
                x1: "13.7071",
                y1: "2.70711",
                x2: "3.70711",
                y2: "12.7071",
                stroke: "currentColor",
                strokeWidth: "2"
            })
        ]
    });
}

});

parcelRegister("3YfEE", function(module, exports) {

$parcel$export(module.exports, "PauseIcon", function () { return $6aa748e9049c3ec9$export$9b47433640e5db3a; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $6aa748e9049c3ec9$export$9b47433640e5db3a(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "9",
                y: "7",
                width: "3",
                height: "12",
                rx: "1",
                fillRule: "nonzero"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "14",
                y: "7",
                width: "3",
                height: "12",
                rx: "1",
                fillRule: "nonzero"
            })
        ]
    });
}

});

parcelRegister("4Mx75", function(module, exports) {

$parcel$export(module.exports, "PlayIcon", function () { return $54a0b7d8634297cf$export$a6630b90defda83f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $54a0b7d8634297cf$export$a6630b90defda83f(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M21.5 13L9.5 18.6292V7.37083L21.5 13Z",
            fillRule: "nonzero"
        })
    });
}

});


parcelRegister("eWtPC", function(module, exports) {

$parcel$export(module.exports, "ImageWithFallback", function () { return $20c80be1a7ce922a$export$e0e15e6cefd4eb7b; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");
const $20c80be1a7ce922a$export$e0e15e6cefd4eb7b = (props)=>{
    const { renderPlaceholder: renderPlaceholder, renderErrorImage: renderErrorImage, onError: onError, onLoad: onLoad, style: style, ...otherProps } = props;
    const [isLoading, setLoading] = (0, $6uYXW.useState)(true);
    const [isErrored, setIsErrored] = (0, $6uYXW.useState)(false);
    const ImageMemoized = (0, $6uYXW.useMemo)(()=>/*#__PURE__*/ (0, $4m918.jsx)("img", {
            ...otherProps,
            style: {
                position: "absolute",
                opacity: isLoading || isErrored ? 0 : 1,
                left: 0
            },
            onError: (e)=>{
                setLoading(false);
                setIsErrored(true);
                onError && onError(e);
            },
            onLoad: (e)=>{
                setLoading(false);
                setIsErrored(false);
                onLoad && onLoad(e);
            }
        }), [
        onError,
        onLoad,
        otherProps,
        isLoading,
        isErrored
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($20c80be1a7ce922a$var$Container, {
        style: style,
        height: typeof props.height === "number" ? `${props.height}px` : props.height,
        width: typeof props.width === "number" ? `${props.width}px` : props.width,
        children: [
            ImageMemoized,
            isLoading && renderPlaceholder?.(props.className),
            isErrored && renderErrorImage?.(props.className)
        ]
    });
};
const $20c80be1a7ce922a$var$Container = (0, $jb8NR.default).div`
  position: relative;
  height: ${(props)=>props.height};
  width: ${(props)=>props.width};
`;

});

parcelRegister("flGUg", function(module, exports) {

$parcel$export(module.exports, "performTaskIfPossible", function () { return $9ad1493f3918599d$export$1ffb392701e2cc4a; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $bQhUC = parcelRequire("bQhUC");

var $5Wai4 = parcelRequire("5Wai4");

var $ahCyz = parcelRequire("ahCyz");
function $9ad1493f3918599d$export$1ffb392701e2cc4a(task) {
    return ()=>{
        const client = (0, $kqXxS.clientManager).client.get();
        if (client?.mustChangePincode) (0, $5Wai4.Modal).present((0, $bQhUC.PINCODE_MUST_BE_CHANGED_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $ahCyz.PincodeChangeModal), {
                type: "operation-requirement"
            }), {
            canBeDismissed: false
        });
        else task();
    };
}

});
parcelRegister("ahCyz", function(module, exports) {

$parcel$export(module.exports, "PincodeChangeModal", function () { return $58af513aae460526$export$3db8007b2632d5b9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $adlcU = parcelRequire("adlcU");

var $bewhU = parcelRequire("bewhU");

var $eyjPK = parcelRequire("eyjPK");

var $5Wai4 = parcelRequire("5Wai4");

var $7xALQ = parcelRequire("7xALQ");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $4fJFQ = parcelRequire("4fJFQ");

var $iJFSS = parcelRequire("iJFSS");
const $58af513aae460526$export$3db8007b2632d5b9 = (props)=>{
    const { type: type } = props;
    const { state: state, context: context, submitCurrentPincode: submitCurrentPincode, submitNewPincode: submitNewPincode, confirmNewPincode: confirmNewPincode, startPincodeChange: startPincodeChange, goBack: goBack } = (0, $adlcU.useChangePincodeMachine)(type === "skip-explanation");
    const { errorMessage: errorMessage } = context;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const dismissModal = ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.PINCODE_MUST_BE_CHANGED_MODAL_ID));
    const renderPincodeMachineState = ()=>{
        const keyboard = context.keyboard;
        switch(state){
            case (0, $adlcU.ChangePincodeState).Explaining:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $4fJFQ.PincodeChangeExplanation), {
                    startPincodeChange: startPincodeChange,
                    abort: dismissModal,
                    type: type
                });
            case (0, $adlcU.ChangePincodeState).FetchingCurrentPincodeKeyboard:
            case (0, $adlcU.ChangePincodeState).FetchingCurrentPincodeKeyboardAfterError:
            case (0, $adlcU.ChangePincodeState).PromptingCurrentPincodeKeyboard:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($58af513aae460526$var$Illustration, {
                            src: (0, $fRvTz.StaticAssets).settingsPincode,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                            title: formatMessage("pincodeChangeFlow.currentCodeLabel"),
                            errorMessage: errorMessage,
                            keyboard: keyboard,
                            loadingKeyboard: state === (0, $adlcU.ChangePincodeState).FetchingCurrentPincodeKeyboard || state === (0, $adlcU.ChangePincodeState).FetchingCurrentPincodeKeyboardAfterError,
                            onSubmit: submitCurrentPincode
                        })
                    ]
                });
            case (0, $adlcU.ChangePincodeState).FetchingChangePincodeKeyboard:
            case (0, $adlcU.ChangePincodeState).PromptingChangePincodeKeyboard:
            case (0, $adlcU.ChangePincodeState).PincodePromptNotMatch:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($58af513aae460526$var$Illustration, {
                            src: (0, $fRvTz.StaticAssets).settingsPincode,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                            title: formatMessage("pincodeChangeFlow.newCodeLabel"),
                            errorMessage: state === (0, $adlcU.ChangePincodeState).PincodePromptNotMatch ? formatMessage("pincodeChangeFlow.newCodesDontMatchError") : errorMessage,
                            keyboard: keyboard,
                            loadingKeyboard: state === (0, $adlcU.ChangePincodeState).FetchingChangePincodeKeyboard,
                            onSubmit: submitNewPincode
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($58af513aae460526$var$BottomLink, {
                            type: "button",
                            onClick: goBack,
                            children: formatMessage("common.goBack")
                        })
                    ]
                });
            case (0, $adlcU.ChangePincodeState).PromptingConfirmPincodeKeyboard:
            case (0, $adlcU.ChangePincodeState).RequestingPincodeChange:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($58af513aae460526$var$Illustration, {
                            src: (0, $fRvTz.StaticAssets).settingsPincode,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                            title: formatMessage("pincodeChangeFlow.newCodeConfirmationLabel"),
                            errorMessage: errorMessage,
                            keyboard: keyboard,
                            loadingKeyboard: state === (0, $adlcU.ChangePincodeState).RequestingPincodeChange,
                            onSubmit: confirmNewPincode
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($58af513aae460526$var$BottomLink, {
                            type: "button",
                            onClick: goBack,
                            children: formatMessage("common.goBack")
                        })
                    ]
                });
            case (0, $adlcU.ChangePincodeState).Done:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $iJFSS.PincodeChangeSuccess), {
                    onComplete: dismissModal
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($58af513aae460526$var$ModalContainer, {
        closeButton: true,
        id: (0, $bQhUC.PINCODE_MUST_BE_CHANGED_MODAL_ID),
        children: renderPincodeMachineState()
    });
};
const $58af513aae460526$var$ModalContainer = (0, $jb8NR.default)((0, $7xALQ.WhiteModalContainer))`
  padding: 56px 28px 28px;
`;
/* The drawing announcing the step, as the mockup opens on. */ const $58af513aae460526$var$Illustration = (0, $jb8NR.default).img`
  display: block;
  width: 72px;
  height: 72px;
  margin: 0 auto 24px;
`;
/* The single way out at the foot of the keypad: back a step, or out of the flow altogether. */ const $58af513aae460526$var$BottomLink = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  ${(0, $22v9q.theme).text};
  display: block;
  margin: 28px auto 0;
  font-size: 15px;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;

});
parcelRegister("adlcU", function(module, exports) {

$parcel$export(module.exports, "useChangePincodeMachine", function () { return $03cbf78d7d4a2016$export$23663e5be37b7058; });
$parcel$export(module.exports, "ChangePincodeState", function () { return $03cbf78d7d4a2016$export$687e21a77af5c58; });

var $lCuQx = parcelRequire("lCuQx");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $40sjz = parcelRequire("40sjz");
const $03cbf78d7d4a2016$export$23663e5be37b7058 = (skipExplaination = true)=>{
    const [state, sendEvent] = (0, $lCuQx.useMachine)($03cbf78d7d4a2016$export$5cd809d02e89a813(skipExplaination));
    const submitCurrentPincode = (pincode)=>{
        sendEvent({
            type: "SUBMIT_CURRENT_PINCODE",
            pincode: pincode
        });
    };
    const submitNewPincode = (pincode)=>{
        sendEvent({
            type: "SUBMIT_NEW_PINCODE",
            pincode: pincode
        });
    };
    const confirmNewPincode = (pincode)=>{
        sendEvent({
            type: "CONFIRM_NEW_PINCODE",
            pincode: pincode
        });
    };
    const startPincodeChange = ()=>{
        sendEvent({
            type: "CHANGE_PINCODE"
        });
    };
    const goBack = ()=>{
        sendEvent({
            type: "GO_BACK"
        });
    };
    return {
        state: state.value,
        context: state.context,
        submitCurrentPincode: submitCurrentPincode,
        submitNewPincode: submitNewPincode,
        confirmNewPincode: confirmNewPincode,
        startPincodeChange: startPincodeChange,
        goBack: goBack
    };
};
var $03cbf78d7d4a2016$export$687e21a77af5c58 = /*#__PURE__*/ function(ChangePincodeState) {
    ChangePincodeState["Explaining"] = "Explaining";
    ChangePincodeState["FetchingCurrentPincodeKeyboard"] = "FetchingCurrentPincodeKeyboard";
    ChangePincodeState["PromptingCurrentPincodeKeyboard"] = "PromptingCurrentPincodeKeyboard";
    ChangePincodeState["FetchingCurrentPincodeKeyboardAfterError"] = "FetchingCurrentPincodeKeyboardAfterError";
    ChangePincodeState["FetchingChangePincodeKeyboard"] = "FetchingChangePincodeKeyboard";
    ChangePincodeState["PromptingChangePincodeKeyboard"] = "PromptingChangePincodeKeyboard";
    ChangePincodeState["PromptingConfirmPincodeKeyboard"] = "PromptingConfirmPincodeKeyboard";
    ChangePincodeState["PincodePromptNotMatch"] = "PincodePromptNotMatch";
    ChangePincodeState["RequestingPincodeChange"] = "RequestingPincodeChange";
    ChangePincodeState["Done"] = "Done";
    return ChangePincodeState;
}({});
const $03cbf78d7d4a2016$export$5cd809d02e89a813 = (skipExplaination = true)=>(0, $TAle5.Machine)({
        id: "ChangePincode",
        initial: skipExplaination ? "FetchingCurrentPincodeKeyboard" : "Explaining",
        states: {
            ["Explaining"]: {
                on: {
                    CHANGE_PINCODE: {
                        target: "FetchingCurrentPincodeKeyboard"
                    }
                }
            },
            ["FetchingCurrentPincodeKeyboard"]: {
                invoke: {
                    id: "fetchKeyboard",
                    src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                keyboard: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "PROMPT_KEYBOARD"
                            })
                        ]
                    }
                },
                on: {
                    PROMPT_KEYBOARD: "PromptingCurrentPincodeKeyboard"
                }
            },
            ["FetchingCurrentPincodeKeyboardAfterError"]: {
                invoke: {
                    id: "fetchKeyboard",
                    src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                keyboard: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "PROMPT_KEYBOARD"
                            })
                        ]
                    }
                },
                on: {
                    PROMPT_KEYBOARD: "PromptingCurrentPincodeKeyboard"
                }
            },
            ["PromptingCurrentPincodeKeyboard"]: {
                on: {
                    SUBMIT_CURRENT_PINCODE: {
                        target: "FetchingChangePincodeKeyboard",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        actions: (0, $c8ePo.assign)({
                            currentCode: (_, event)=>event.pincode,
                            errorMessage: ()=>undefined
                        })
                    }
                }
            },
            ["FetchingChangePincodeKeyboard"]: {
                invoke: {
                    id: "fetchKeyboard",
                    src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                keyboard: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "PROMPT_KEYBOARD"
                            })
                        ]
                    }
                },
                on: {
                    PROMPT_KEYBOARD: "PromptingChangePincodeKeyboard"
                }
            },
            ["PromptingChangePincodeKeyboard"]: {
                on: {
                    SUBMIT_NEW_PINCODE: {
                        target: "PromptingConfirmPincodeKeyboard",
                        actions: (0, $c8ePo.assign)({
                            newCode: (_, event)=>event.pincode
                        })
                    },
                    GO_BACK: {
                        target: "FetchingCurrentPincodeKeyboard"
                    }
                }
            },
            ["PromptingConfirmPincodeKeyboard"]: {
                on: {
                    CONFIRM_NEW_PINCODE: {
                        actions: (0, $c8ePo.send)((context, event)=>event.pincode.value.join() === context.newCode?.value.join() ? {
                                type: "REQUEST_PINCODE_CHANGE"
                            } : {
                                type: "PINCODE_DONT_MATCH"
                            })
                    },
                    PINCODE_DONT_MATCH: {
                        target: "PincodePromptNotMatch"
                    },
                    REQUEST_PINCODE_CHANGE: {
                        target: "RequestingPincodeChange"
                    },
                    GO_BACK: {
                        target: "FetchingCurrentPincodeKeyboard"
                    }
                }
            },
            ["RequestingPincodeChange"]: {
                invoke: {
                    id: "RequestPincodeChange",
                    src: (context)=>(0, $kqXxS.pincodeService).changePincode(context.currentCode, context.newCode),
                    onDone: {
                        target: "Done"
                    },
                    onError: {
                        target: "FetchingCurrentPincodeKeyboardAfterError",
                        actions: (0, $c8ePo.assign)({
                            errorMessage: (_, event)=>event.data
                        })
                    }
                }
            },
            ["PincodePromptNotMatch"]: {
                on: {
                    SUBMIT_NEW_PINCODE: {
                        target: "PromptingConfirmPincodeKeyboard",
                        actions: (0, $c8ePo.assign)({
                            newCode: (_, event)=>event.pincode
                        })
                    },
                    GO_BACK: {
                        target: "FetchingCurrentPincodeKeyboard"
                    }
                }
            },
            ["Done"]: {
                entry: ()=>{
                    (0, $kqXxS.clientManager).updateClient(true).catch((e)=>(0, $6JVVB.logger).debug("ChangePincodeMachine", "Failed to update the client", e));
                },
                type: "final"
            }
        }
    });

});
parcelRegister("lCuQx", function(module, exports) {

$parcel$export(module.exports, "useMachine", function () { return $fbd5130c965e5eb3$export$e0338c4153421160; });

var $6uYXW = parcelRequire("6uYXW");

var $VhKse = parcelRequire("VhKse");

var $4oJEX = parcelRequire("4oJEX");
var $dtyqS = parcelRequire("dtyqS");

var $6KIg3 = parcelRequire("6KIg3");
var $fbd5130c965e5eb3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $fbd5130c965e5eb3$var$identity(a) {
    return a;
}
function $fbd5130c965e5eb3$export$e0338c4153421160(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $fbd5130c965e5eb3$var$__read(_a, 1), _c = _b[0], options = _c === void 0 ? {} : _c;
    // using `useIdleInterpreter` allows us to subscribe to the service *before* we start it
    // so we don't miss any notifications
    var service = (0, $6KIg3.useIdleInterpreter)(getMachine, options);
    var getSnapshot = (0, $6uYXW.useCallback)(function() {
        if (service.status === (0, $4oJEX.InterpreterStatus).NotStarted) return options.state ? (0, $dtyqS.State).create(options.state) : service.machine.initialState;
        return service.state;
    }, [
        service
    ]);
    var isEqual = (0, $6uYXW.useCallback)(function(prevState, nextState) {
        if (service.status === (0, $4oJEX.InterpreterStatus).NotStarted) return true;
        // Only change the current state if:
        // - the incoming state is the "live" initial state (since it might have new actors)
        // - OR the incoming state actually changed.
        //
        // The "live" initial state will have .changed === undefined.
        var initialStateChanged = nextState.changed === undefined && (Object.keys(nextState.children).length > 0 || typeof prevState.changed === 'boolean');
        return !(nextState.changed || initialStateChanged);
    }, [
        service
    ]);
    var subscribe = (0, $6uYXW.useCallback)(function(handleStoreChange) {
        var unsubscribe = service.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        service
    ]);
    var storeSnapshot = (0, $VhKse.useSyncExternalStoreWithSelector)(subscribe, getSnapshot, getSnapshot, $fbd5130c965e5eb3$var$identity, isEqual);
    (0, $6uYXW.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $dtyqS.State).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $4oJEX.InterpreterStatus).NotStarted;
        };
    }, []);
    return [
        storeSnapshot,
        service.send,
        service
    ];
}

});
parcelRegister("VhKse", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aZSdd"));

});
parcelRegister("aZSdd", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $8019a7496ae3faee$export$bf730a2d8bf68b42; }, function (v) { return $8019a7496ae3faee$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8019a7496ae3faee$export$bf730a2d8bf68b42;
"use strict";

var $6uYXW = parcelRequire("6uYXW");

var $8JQzD = parcelRequire("8JQzD");
function $8019a7496ae3faee$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8019a7496ae3faee$var$objectIs = "function" === typeof Object.is ? Object.is : $8019a7496ae3faee$var$is, $8019a7496ae3faee$var$useSyncExternalStore = $8JQzD.useSyncExternalStore, $8019a7496ae3faee$var$useRef = $6uYXW.useRef, $8019a7496ae3faee$var$useEffect = $6uYXW.useEffect, $8019a7496ae3faee$var$useMemo = $6uYXW.useMemo, $8019a7496ae3faee$var$useDebugValue = $6uYXW.useDebugValue;
$8019a7496ae3faee$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $8019a7496ae3faee$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $8019a7496ae3faee$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($8019a7496ae3faee$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $8019a7496ae3faee$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $8019a7496ae3faee$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $8019a7496ae3faee$var$useDebugValue(value);
    return value;
};

});
parcelRegister("8JQzD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3suYI"));

});
parcelRegister("3suYI", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $284c0446ee4b48f3$export$306c0aa65ff9ec16; }, function (v) { return $284c0446ee4b48f3$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $284c0446ee4b48f3$export$306c0aa65ff9ec16;
"use strict";

var $6uYXW = parcelRequire("6uYXW");
function $284c0446ee4b48f3$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $284c0446ee4b48f3$var$objectIs = "function" === typeof Object.is ? Object.is : $284c0446ee4b48f3$var$is, $284c0446ee4b48f3$var$useState = $6uYXW.useState, $284c0446ee4b48f3$var$useEffect = $6uYXW.useEffect, $284c0446ee4b48f3$var$useLayoutEffect = $6uYXW.useLayoutEffect, $284c0446ee4b48f3$var$useDebugValue = $6uYXW.useDebugValue;
function $284c0446ee4b48f3$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $284c0446ee4b48f3$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $284c0446ee4b48f3$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $284c0446ee4b48f3$var$useEffect(function() {
        $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $284c0446ee4b48f3$var$useDebugValue(value);
    return value;
}
function $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$284c0446ee4b48f3$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $284c0446ee4b48f3$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $284c0446ee4b48f3$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $284c0446ee4b48f3$var$useSyncExternalStore$1 : $284c0446ee4b48f3$var$useSyncExternalStore$2;
$284c0446ee4b48f3$export$306c0aa65ff9ec16 = void 0 !== $6uYXW.useSyncExternalStore ? $6uYXW.useSyncExternalStore : $284c0446ee4b48f3$var$shim;

});




parcelRegister("4oJEX", function(module, exports) {

$parcel$export(module.exports, "InterpreterStatus", function () { return $333cd25ba004981c$export$7a567c9c5088a551; });
$parcel$export(module.exports, "interpret", function () { return $333cd25ba004981c$export$67beed298888a38b; });

var $gbTwD = parcelRequire("gbTwD");

var $4fIPK = parcelRequire("4fIPK");

var $dtyqS = parcelRequire("dtyqS");

var $kTkZo = parcelRequire("kTkZo");

var $OT6fs = parcelRequire("OT6fs");

var $cFnln = parcelRequire("cFnln");

var $5rAbY = parcelRequire("5rAbY");

var $jPSGW = parcelRequire("jPSGW");

var $gZqNd = parcelRequire("gZqNd");

var $4BB5k = parcelRequire("4BB5k");

var $aORon = parcelRequire("aORon");

var $dWCC7 = parcelRequire("dWCC7");

var $qzolc = parcelRequire("qzolc");
var $333cd25ba004981c$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $333cd25ba004981c$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($333cd25ba004981c$export$7a567c9c5088a551 || ($333cd25ba004981c$export$7a567c9c5088a551 = {}));
var $333cd25ba004981c$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $333cd25ba004981c$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $5rAbY.isArray)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $5rAbY.toSCXMLEvent)((0, $5rAbY.toEventObject)(event1, payload));
            if (_this.status === $333cd25ba004981c$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $333cd25ba004981c$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $4fIPK.SpecialTargets).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $5rAbY.isString)(to) ? _this.children.get(to) || (0, $4BB5k.registry).get(to) : (0, $5rAbY.isActor)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ('machine' in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $333cd25ba004981c$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, event1), {
                        name: event1.name === (0, $kTkZo.error) ? "".concat((0, $OT6fs.error)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $OT6fs.getActionFunction)(action.type, actionFunctionMap);
            var exec = (0, $5rAbY.isFunction)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: 'xstate.error',
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $kTkZo.send:
                    var sendAction = action;
                    if (typeof sendAction.delay === 'number') {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $OT6fs.initEvent));
                    else _this.send(sendAction._event);
                    break;
                case 0, $kTkZo.cancel:
                    _this.cancel(action.sendId);
                    break;
                case 0, $kTkZo.start:
                    if (_this.status !== $333cd25ba004981c$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $4fIPK.ActionTypes).Invoke) {
                        var invokeSource = (0, $5rAbY.toInvokeSource)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(!('forward' in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $5rAbY.mapContext)(data, context, _event) : undefined;
                        if (typeof serviceCreator === 'string') // TODO: warn
                        return;
                        var source = (0, $5rAbY.isFunction)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $5rAbY.isMachine)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $kTkZo.stop:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $kTkZo.log:
                    var label = action.label, value = action.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $jPSGW.Scheduler)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $4BB5k.registry).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $dWCC7.provide)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(this.status !== $333cd25ba004981c$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $gbTwD.__values)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $OT6fs.initEvent)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $gbTwD.__values)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $gbTwD.__values)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $gbTwD.__values)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === 'final' && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $5rAbY.mapContext)(finalChildStateNode.doneData, state.context, _event) : undefined;
            try {
                for(var _l = (0, $gbTwD.__values)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener((0, $OT6fs.doneInvoke)(this.id, doneData));
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $333cd25ba004981c$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $5rAbY.toObserver)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $333cd25ba004981c$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $333cd25ba004981c$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $333cd25ba004981c$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $4BB5k.registry).register(this.sessionId, this);
        this.initialized = true;
        this.status = $333cd25ba004981c$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $dWCC7.provide)(this, function() {
            return (0, $dtyqS.isStateConfig)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $dtyqS.State).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $OT6fs.initEvent));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $5rAbY.isFunction)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $gbTwD.__values)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $gbTwD.__values)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $gbTwD.__values)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $gbTwD.__values)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $333cd25ba004981c$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $gbTwD.__values)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $jPSGW.Scheduler)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $5rAbY.toSCXMLEvent)({
                type: 'xstate.stop'
            });
            var nextState = (0, $dWCC7.provide)(_this, function() {
                var exitActions = (0, $5rAbY.flatten)((0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $OT6fs.toActionObjects)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $gbTwD.__read)((0, $OT6fs.resolveActions)(_this.machine, _this.state, _this.state.context, _event, [
                    exitActions
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $dtyqS.State)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return action.type !== (0, $kTkZo.raise) && (action.type !== (0, $kTkZo.send) || !!action.to && action.to !== (0, $4fIPK.SpecialTargets).Internal);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $4BB5k.registry).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $333cd25ba004981c$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
        } else if (this.status !== $333cd25ba004981c$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $5rAbY.toSCXMLEvent)(event_1);
                _this.forward(_event);
                nextState = (0, $dWCC7.provide)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $dtyqS.bindActionToState)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $gbTwD.__values)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $5rAbY.toSCXMLEvent)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $5rAbY.toSCXMLEvent)(event1);
        if (_event.name.indexOf((0, $kTkZo.errorPlatform)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $kTkZo.errorPlatform)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $dWCC7.provide)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $gbTwD.__values)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        this.delayedEventsMap[sendAction.id] = this.clock.setTimeout(function() {
            if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $5rAbY.isFunction)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $333cd25ba004981c$export$7a567c9c5088a551.Running) return (0, $gZqNd.createDeferredActor)(entity, name);
        if ((0, $5rAbY.isPromiseLike)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $5rAbY.isFunction)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $gZqNd.isSpawnedActor)(entity)) return this.spawnActor(entity, name);
        else if ((0, $5rAbY.isObservable)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $5rAbY.isMachine)(entity)) return this.spawnMachine(entity, (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, options), {
            id: name
        }));
        else if ((0, $5rAbY.isBehavior)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, $333cd25ba004981c$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $kTkZo.update), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $5rAbY.toSCXMLEvent)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $qzolc.spawnBehavior)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $5rAbY.toSCXMLEvent)((0, $OT6fs.doneInvoke)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $OT6fs.error)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $5rAbY.toSCXMLEvent)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $5rAbY.reportUnhandledExceptionOnInvocation)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $5rAbY.toObserver)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $5rAbY.symbolObservable] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $5rAbY.toSCXMLEvent)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $OT6fs.error)(id, err));
        }
        if ((0, $5rAbY.isPromiseLike)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $5rAbY.toObserver)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $5rAbY.isFunction)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $5rAbY.symbolObservable] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $5rAbY.toSCXMLEvent)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $5rAbY.toSCXMLEvent)((0, $OT6fs.error)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $5rAbY.toSCXMLEvent)((0, $OT6fs.doneInvoke)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $5rAbY.symbolObservable] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $5rAbY.symbolObservable] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $aORon.getGlobal)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $gbTwD.__assign)((0, $gbTwD.__assign)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $gbTwD.__assign)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $aORon.registerService)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $5rAbY.symbolObservable] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $333cd25ba004981c$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $333cd25ba004981c$export$67beed298888a38b;
    return Interpreter;
}();
var $333cd25ba004981c$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $5rAbY.isString)(nameOrOptions)) return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, $333cd25ba004981c$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $gbTwD.__assign)((0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, $333cd25ba004981c$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $5rAbY.uniqueId)()
    }), nameOrOptions);
};
function $333cd25ba004981c$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $333cd25ba004981c$var$resolveSpawnOptions(nameOrOptions);
    return (0, $dWCC7.consume)(function(service) {
        if (!(0, $cFnln.IS_PRODUCTION)) {
            var isLazyEntity = (0, $5rAbY.isMachine)(entity) || (0, $5rAbY.isFunction)(entity);
            (0, $5rAbY.warn)(!!service || isLazyEntity, "Attempted to spawn an Actor (ID: \"".concat((0, $5rAbY.isMachine)(entity) ? entity.id : 'undefined', "\") outside of a service. This will have no effect."));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $gZqNd.createDeferredActor)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $333cd25ba004981c$export$67beed298888a38b(machine, options) {
    var interpreter = new $333cd25ba004981c$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}

});
parcelRegister("gbTwD", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $030ab8c0800bfeaf$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $030ab8c0800bfeaf$export$3c9a16f847548506; });
$parcel$export(module.exports, "__values", function () { return $030ab8c0800bfeaf$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $030ab8c0800bfeaf$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $030ab8c0800bfeaf$export$1216008129fb82ed; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $030ab8c0800bfeaf$export$18ce0697a983be9b = function() {
    $030ab8c0800bfeaf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $030ab8c0800bfeaf$export$18ce0697a983be9b.apply(this, arguments);
};
function $030ab8c0800bfeaf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $030ab8c0800bfeaf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $030ab8c0800bfeaf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $030ab8c0800bfeaf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

});

parcelRegister("4fIPK", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", function () { return $318b572cea8e830c$export$1385d81a6c6bbcd4; });
$parcel$export(module.exports, "SpecialTargets", function () { return $318b572cea8e830c$export$79f5baa747fbdd45; });
var $318b572cea8e830c$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($318b572cea8e830c$export$1385d81a6c6bbcd4 || ($318b572cea8e830c$export$1385d81a6c6bbcd4 = {}));
var $318b572cea8e830c$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($318b572cea8e830c$export$79f5baa747fbdd45 || ($318b572cea8e830c$export$79f5baa747fbdd45 = {}));

});

parcelRegister("dtyqS", function(module, exports) {

$parcel$export(module.exports, "stateValuesEqual", function () { return $9cf8b15a8e5c88a2$export$3a6d15eeb5fb214c; });
$parcel$export(module.exports, "isStateConfig", function () { return $9cf8b15a8e5c88a2$export$4c86eb6450eda77a; });
$parcel$export(module.exports, "bindActionToState", function () { return $9cf8b15a8e5c88a2$export$e42513ad58964418; });
$parcel$export(module.exports, "State", function () { return $9cf8b15a8e5c88a2$export$7254cc27399e90bd; });

var $gbTwD = parcelRequire("gbTwD");

var $81uvS = parcelRequire("81uvS");

var $5rAbY = parcelRequire("5rAbY");

var $7KiTp = parcelRequire("7KiTp");

var $OT6fs = parcelRequire("OT6fs");

var $cFnln = parcelRequire("cFnln");
function $9cf8b15a8e5c88a2$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $5rAbY.isString)(a) || (0, $5rAbY.isString)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $9cf8b15a8e5c88a2$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $9cf8b15a8e5c88a2$export$4c86eb6450eda77a(state) {
    if (typeof state !== 'object' || state === null) return false;
    return 'value' in state && '_event' in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $9cf8b15a8e5c88a2$export$e5d60a6bbabd36f = $9cf8b15a8e5c88a2$export$4c86eb6450eda77a;
function $9cf8b15a8e5c88a2$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $9cf8b15a8e5c88a2$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $81uvS.EMPTY_ACTIVITY_MAP);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $81uvS.EMPTY_ACTIVITY_MAP);
        this.meta = (0, $7KiTp.getMeta)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, 'nextEvents', {
            get: function() {
                return (0, $7KiTp.nextEvents)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $OT6fs.initEvent);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $OT6fs.initEvent);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = '.';
        if ((0, $5rAbY.isString)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $gbTwD.__rest)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $5rAbY.matchesState)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $cFnln.IS_PRODUCTION) (0, $5rAbY.warn)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();

});
parcelRegister("81uvS", function(module, exports) {

$parcel$export(module.exports, "STATE_DELIMITER", function () { return $0181e794995cde3a$export$b060f3cec92ef5c9; });
$parcel$export(module.exports, "EMPTY_ACTIVITY_MAP", function () { return $0181e794995cde3a$export$505a390a702f4a23; });
$parcel$export(module.exports, "DEFAULT_GUARD_TYPE", function () { return $0181e794995cde3a$export$656461011b562379; });
$parcel$export(module.exports, "TARGETLESS_KEY", function () { return $0181e794995cde3a$export$31935b4577455331; });
var $0181e794995cde3a$export$b060f3cec92ef5c9 = '.';
var $0181e794995cde3a$export$505a390a702f4a23 = {};
var $0181e794995cde3a$export$656461011b562379 = 'xstate.guard';
var $0181e794995cde3a$export$31935b4577455331 = '';

});

parcelRegister("5rAbY", function(module, exports) {

$parcel$export(module.exports, "matchesState", function () { return $3f6b8c63cbf47243$export$2870710bf0eac88e; });
$parcel$export(module.exports, "toStateValue", function () { return $3f6b8c63cbf47243$export$fb3aecd1d93744e3; });
$parcel$export(module.exports, "isString", function () { return $3f6b8c63cbf47243$export$844ec244b1367d54; });
$parcel$export(module.exports, "getEventType", function () { return $3f6b8c63cbf47243$export$7193fc8c8cd445e9; });
$parcel$export(module.exports, "isFunction", function () { return $3f6b8c63cbf47243$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "toStatePath", function () { return $3f6b8c63cbf47243$export$304cde62ecda7af8; });
$parcel$export(module.exports, "isArray", function () { return $3f6b8c63cbf47243$export$43bee75e5e14138e; });
$parcel$export(module.exports, "pathToStateValue", function () { return $3f6b8c63cbf47243$export$f2ee84fc53c45e74; });
$parcel$export(module.exports, "mapValues", function () { return $3f6b8c63cbf47243$export$825e789796ab7275; });
$parcel$export(module.exports, "mapFilterValues", function () { return $3f6b8c63cbf47243$export$2d4204fe9b34204e; });
$parcel$export(module.exports, "path", function () { return $3f6b8c63cbf47243$export$bb654e07daaf8c3a; });
$parcel$export(module.exports, "nestedPath", function () { return $3f6b8c63cbf47243$export$314d0a1a7c835392; });
$parcel$export(module.exports, "toStatePaths", function () { return $3f6b8c63cbf47243$export$a2618e9e89698dd6; });
$parcel$export(module.exports, "flatten", function () { return $3f6b8c63cbf47243$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "toArray", function () { return $3f6b8c63cbf47243$export$45b10814cc054894; });
$parcel$export(module.exports, "mapContext", function () { return $3f6b8c63cbf47243$export$e756e60189cc2351; });
$parcel$export(module.exports, "isBuiltInEvent", function () { return $3f6b8c63cbf47243$export$479b1b8942fd0b8d; });
$parcel$export(module.exports, "isPromiseLike", function () { return $3f6b8c63cbf47243$export$ae936b9d47e5870e; });
$parcel$export(module.exports, "isBehavior", function () { return $3f6b8c63cbf47243$export$42749ebe1e7fdef7; });
$parcel$export(module.exports, "partition", function () { return $3f6b8c63cbf47243$export$b29f828819edca8d; });
$parcel$export(module.exports, "updateHistoryValue", function () { return $3f6b8c63cbf47243$export$240d7cdd99ccb95a; });
$parcel$export(module.exports, "updateContext", function () { return $3f6b8c63cbf47243$export$d84706064a6e6c1c; });
$parcel$export(module.exports, "warn", function () { return $3f6b8c63cbf47243$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "toGuard", function () { return $3f6b8c63cbf47243$export$b0f5a08e0ca47933; });
$parcel$export(module.exports, "isObservable", function () { return $3f6b8c63cbf47243$export$5cd057a6046189f9; });
$parcel$export(module.exports, "symbolObservable", function () { return $3f6b8c63cbf47243$export$c45ebe72e3b2885; });
$parcel$export(module.exports, "isMachine", function () { return $3f6b8c63cbf47243$export$2163e7903738b5df; });
$parcel$export(module.exports, "isActor", function () { return $3f6b8c63cbf47243$export$e769f6913f14f1b7; });
$parcel$export(module.exports, "uniqueId", function () { return $3f6b8c63cbf47243$export$8b15d37bc3f197d4; });
$parcel$export(module.exports, "toEventObject", function () { return $3f6b8c63cbf47243$export$5a4ea50826a01d14; });
$parcel$export(module.exports, "toSCXMLEvent", function () { return $3f6b8c63cbf47243$export$eaf22249b410f633; });
$parcel$export(module.exports, "toTransitionConfigArray", function () { return $3f6b8c63cbf47243$export$3822a36ea084a4d5; });
$parcel$export(module.exports, "normalizeTarget", function () { return $3f6b8c63cbf47243$export$2a4fe5c3c80e3288; });
$parcel$export(module.exports, "reportUnhandledExceptionOnInvocation", function () { return $3f6b8c63cbf47243$export$b240b9b7a78b5f3e; });
$parcel$export(module.exports, "evaluateGuard", function () { return $3f6b8c63cbf47243$export$91646ab912d254e8; });
$parcel$export(module.exports, "toInvokeSource", function () { return $3f6b8c63cbf47243$export$436e852aa2feda95; });
$parcel$export(module.exports, "toObserver", function () { return $3f6b8c63cbf47243$export$75b67481063f2f98; });
$parcel$export(module.exports, "createInvokeId", function () { return $3f6b8c63cbf47243$export$107b54c5097f9157; });

var $gbTwD = parcelRequire("gbTwD");

var $81uvS = parcelRequire("81uvS");

var $cFnln = parcelRequire("cFnln");
var $3f6b8c63cbf47243$var$_a;
function $3f6b8c63cbf47243$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $3f6b8c63cbf47243$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $81uvS.STATE_DELIMITER);
    var parentStateValue = $3f6b8c63cbf47243$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $3f6b8c63cbf47243$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($3f6b8c63cbf47243$export$844ec244b1367d54(childStateValue)) {
        if ($3f6b8c63cbf47243$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($3f6b8c63cbf47243$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $3f6b8c63cbf47243$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $3f6b8c63cbf47243$export$7193fc8c8cd445e9(event) {
    try {
        return $3f6b8c63cbf47243$export$844ec244b1367d54(event) || typeof event === 'number' ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error('Events must be strings or objects with a string event.type property.');
    }
}
function $3f6b8c63cbf47243$export$e303144c5506946a(action) {
    try {
        return $3f6b8c63cbf47243$export$844ec244b1367d54(action) || typeof action === 'number' ? "".concat(action) : $3f6b8c63cbf47243$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error('Actions must be strings or objects with a string action.type property.');
    }
}
function $3f6b8c63cbf47243$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($3f6b8c63cbf47243$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $3f6b8c63cbf47243$export$e080e3931a079c9b(state) {
    return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function $3f6b8c63cbf47243$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($3f6b8c63cbf47243$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($3f6b8c63cbf47243$export$43bee75e5e14138e(stateValue)) return $3f6b8c63cbf47243$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== 'string') return stateValue;
    var statePath = $3f6b8c63cbf47243$export$304cde62ecda7af8(stateValue, delimiter);
    return $3f6b8c63cbf47243$export$f2ee84fc53c45e74(statePath);
}
function $3f6b8c63cbf47243$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $3f6b8c63cbf47243$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $3f6b8c63cbf47243$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $gbTwD.__values)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $3f6b8c63cbf47243$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $gbTwD.__values)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $3f6b8c63cbf47243$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $gbTwD.__values)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $3f6b8c63cbf47243$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($3f6b8c63cbf47243$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $3f6b8c63cbf47243$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $3f6b8c63cbf47243$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $3f6b8c63cbf47243$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $gbTwD.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $3f6b8c63cbf47243$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(array), false));
}
function $3f6b8c63cbf47243$export$2c0b6b2f4faf21e1(value) {
    if ($3f6b8c63cbf47243$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $3f6b8c63cbf47243$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $3f6b8c63cbf47243$export$2c0b6b2f4faf21e1(value);
}
function $3f6b8c63cbf47243$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($3f6b8c63cbf47243$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $gbTwD.__values)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($3f6b8c63cbf47243$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $3f6b8c63cbf47243$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $3f6b8c63cbf47243$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($3f6b8c63cbf47243$export$f6e2535fb5126e54(value) || typeof value === 'object') && $3f6b8c63cbf47243$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $3f6b8c63cbf47243$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}
function $3f6b8c63cbf47243$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $gbTwD.__read)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $gbTwD.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $3f6b8c63cbf47243$export$3737909a0074eb1(hist, stateValue) {
    return $3f6b8c63cbf47243$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($3f6b8c63cbf47243$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $3f6b8c63cbf47243$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $3f6b8c63cbf47243$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $3f6b8c63cbf47243$export$3737909a0074eb1(hist, stateValue)
    };
}
function $3f6b8c63cbf47243$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $cFnln.IS_PRODUCTION)) $3f6b8c63cbf47243$export$c106dd0671a0fc2d(!!context, 'Attempting to update undefined context');
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($3f6b8c63cbf47243$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $gbTwD.__values)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $3f6b8c63cbf47243$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $3f6b8c63cbf47243$export$c106dd0671a0fc2d = function() {};
if (!(0, $cFnln.IS_PRODUCTION)) $3f6b8c63cbf47243$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $3f6b8c63cbf47243$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $3f6b8c63cbf47243$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $3f6b8c63cbf47243$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $3f6b8c63cbf47243$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($3f6b8c63cbf47243$export$844ec244b1367d54(condition)) return {
        type: (0, $81uvS.DEFAULT_GUARD_TYPE),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($3f6b8c63cbf47243$export$f6e2535fb5126e54(condition)) return {
        type: (0, $81uvS.DEFAULT_GUARD_TYPE),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $3f6b8c63cbf47243$export$5cd057a6046189f9(value) {
    try {
        return 'subscribe' in value && $3f6b8c63cbf47243$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $3f6b8c63cbf47243$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $3f6b8c63cbf47243$export$a6273dafbee7f61e = ($3f6b8c63cbf47243$var$_a = {}, $3f6b8c63cbf47243$var$_a[$3f6b8c63cbf47243$export$c45ebe72e3b2885] = function() {
    return this;
}, $3f6b8c63cbf47243$var$_a[Symbol.observable] = function() {
    return this;
}, $3f6b8c63cbf47243$var$_a);
function $3f6b8c63cbf47243$export$2163e7903738b5df(value) {
    return !!value && '__xstatenode' in value;
}
function $3f6b8c63cbf47243$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === 'function';
}
var $3f6b8c63cbf47243$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $3f6b8c63cbf47243$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($3f6b8c63cbf47243$export$844ec244b1367d54(event) || typeof event === 'number') return (0, $gbTwD.__assign)({
        type: event
    }, payload);
    return event;
}
function $3f6b8c63cbf47243$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$3f6b8c63cbf47243$export$844ec244b1367d54(event) && '$$type' in event && event.$$type === 'scxml') return event;
    var eventObject = $3f6b8c63cbf47243$export$5a4ea50826a01d14(event);
    return (0, $gbTwD.__assign)({
        name: eventObject.type,
        data: eventObject,
        $$type: 'scxml',
        type: 'external'
    }, scxmlEvent);
}
function $3f6b8c63cbf47243$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $3f6b8c63cbf47243$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $3f6b8c63cbf47243$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $3f6b8c63cbf47243$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $81uvS.TARGETLESS_KEY)) return undefined;
    return $3f6b8c63cbf47243$export$45b10814cc054894(target);
}
function $3f6b8c63cbf47243$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $cFnln.IS_PRODUCTION)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $3f6b8c63cbf47243$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $81uvS.DEFAULT_GUARD_TYPE)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $3f6b8c63cbf47243$export$436e852aa2feda95(src) {
    if (typeof src === 'string') return {
        type: src
    };
    return src;
}
function $3f6b8c63cbf47243$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === 'object';
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $3f6b8c63cbf47243$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}

});
parcelRegister("cFnln", function(module, exports) {

$parcel$export(module.exports, "IS_PRODUCTION", function () { return $938b6bf0a22b6ed3$export$9b5f2e1c20ef6571; });
var $938b6bf0a22b6ed3$export$9b5f2e1c20ef6571 = true;

});


parcelRegister("7KiTp", function(module, exports) {

$parcel$export(module.exports, "isLeafNode", function () { return $5a3b7bfa86bf6f3d$export$335db82b86111fd1; });
$parcel$export(module.exports, "getAllChildren", function () { return $5a3b7bfa86bf6f3d$export$ad3d2e38d4deaf6d; });
$parcel$export(module.exports, "getChildren", function () { return $5a3b7bfa86bf6f3d$export$f8cf48ee793b41be; });
$parcel$export(module.exports, "getAllStateNodes", function () { return $5a3b7bfa86bf6f3d$export$3de19bba299e3801; });
$parcel$export(module.exports, "getConfiguration", function () { return $5a3b7bfa86bf6f3d$export$3de01744a82b21a4; });
$parcel$export(module.exports, "getValue", function () { return $5a3b7bfa86bf6f3d$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "has", function () { return $5a3b7bfa86bf6f3d$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "nextEvents", function () { return $5a3b7bfa86bf6f3d$export$c661ab6895e3ed73; });
$parcel$export(module.exports, "isInFinalState", function () { return $5a3b7bfa86bf6f3d$export$cf3d5dae927fcf63; });
$parcel$export(module.exports, "getMeta", function () { return $5a3b7bfa86bf6f3d$export$c47913ca32a5c6f7; });
$parcel$export(module.exports, "getTagsFromConfiguration", function () { return $5a3b7bfa86bf6f3d$export$5301196121335ca0; });

var $gbTwD = parcelRequire("gbTwD");

var $5rAbY = parcelRequire("5rAbY");
var $5a3b7bfa86bf6f3d$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === 'atomic' || stateNode.type === 'final';
};
function $5a3b7bfa86bf6f3d$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $5a3b7bfa86bf6f3d$export$f8cf48ee793b41be(stateNode) {
    return $5a3b7bfa86bf6f3d$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== 'history';
    });
}
function $5a3b7bfa86bf6f3d$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($5a3b7bfa86bf6f3d$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $5rAbY.flatten)($5a3b7bfa86bf6f3d$export$f8cf48ee793b41be(stateNode).map($5a3b7bfa86bf6f3d$export$3de19bba299e3801)));
}
function $5a3b7bfa86bf6f3d$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $5a3b7bfa86bf6f3d$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $gbTwD.__values)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $5a3b7bfa86bf6f3d$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $gbTwD.__values)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === 'parallel') try {
                    for(var _e = (e_3 = void 0, (0, $gbTwD.__values)($5a3b7bfa86bf6f3d$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $gbTwD.__values)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $5a3b7bfa86bf6f3d$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($5a3b7bfa86bf6f3d$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $5a3b7bfa86bf6f3d$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $5a3b7bfa86bf6f3d$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $gbTwD.__values)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $5a3b7bfa86bf6f3d$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $5a3b7bfa86bf6f3d$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $5a3b7bfa86bf6f3d$var$getValueFromAdj(rootNode, $5a3b7bfa86bf6f3d$export$b837d8c2d0189d63(config));
}
function $5a3b7bfa86bf6f3d$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $5a3b7bfa86bf6f3d$export$c661ab6895e3ed73(configuration) {
    return (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(new Set((0, $5rAbY.flatten)((0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $5a3b7bfa86bf6f3d$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === 'compound') return $5a3b7bfa86bf6f3d$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === 'final' && $5a3b7bfa86bf6f3d$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === 'parallel') return $5a3b7bfa86bf6f3d$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $5a3b7bfa86bf6f3d$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $5a3b7bfa86bf6f3d$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $5a3b7bfa86bf6f3d$export$5301196121335ca0(configuration) {
    return new Set((0, $5rAbY.flatten)(configuration.map(function(sn) {
        return sn.tags;
    })));
}

});

parcelRegister("OT6fs", function(module, exports) {

$parcel$export(module.exports, "initEvent", function () { return $098f694b73b82078$export$163c566c60ed2ec9; });
$parcel$export(module.exports, "getActionFunction", function () { return $098f694b73b82078$export$c7e5ca927bd4567; });
$parcel$export(module.exports, "toActionObject", function () { return $098f694b73b82078$export$b38b66cc2da3ede7; });
$parcel$export(module.exports, "toActionObjects", function () { return $098f694b73b82078$export$aa68691f32e6c459; });
$parcel$export(module.exports, "toActivityDefinition", function () { return $098f694b73b82078$export$e81fdd8937d44864; });
$parcel$export(module.exports, "raise", function () { return $098f694b73b82078$export$66313c302b2ea154; });
$parcel$export(module.exports, "send", function () { return $098f694b73b82078$export$89db4734f6c919c4; });
$parcel$export(module.exports, "sendParent", function () { return $098f694b73b82078$export$408d8d51fa351f53; });
$parcel$export(module.exports, "sendUpdate", function () { return $098f694b73b82078$export$7f8b724299523eb6; });
$parcel$export(module.exports, "cancel", function () { return $098f694b73b82078$export$70b61ad426ddbe54; });
$parcel$export(module.exports, "start", function () { return $098f694b73b82078$export$b3571188c770cc5a; });
$parcel$export(module.exports, "stop", function () { return $098f694b73b82078$export$fa6813432f753b0d; });
$parcel$export(module.exports, "assign", function () { return $098f694b73b82078$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "after", function () { return $098f694b73b82078$export$742acabee3dd6465; });
$parcel$export(module.exports, "done", function () { return $098f694b73b82078$export$3df11c9c20e7b288; });
$parcel$export(module.exports, "doneInvoke", function () { return $098f694b73b82078$export$c105e588793f70b4; });
$parcel$export(module.exports, "error", function () { return $098f694b73b82078$export$a3bc9b8ed74fc; });
$parcel$export(module.exports, "forwardTo", function () { return $098f694b73b82078$export$eb147b7589db8e8a; });
$parcel$export(module.exports, "resolveActions", function () { return $098f694b73b82078$export$b8b9e7ba5b8c7b3e; });

var $gbTwD = parcelRequire("gbTwD");

var $4fIPK = parcelRequire("4fIPK");

var $kTkZo = parcelRequire("kTkZo");

var $5rAbY = parcelRequire("5rAbY");

var $cFnln = parcelRequire("cFnln");
var $098f694b73b82078$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $5rAbY.toSCXMLEvent)({
    type: (0, $kTkZo.init)
});
function $098f694b73b82078$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $098f694b73b82078$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $5rAbY.isString)(action) || typeof action === 'number') {
        var exec = $098f694b73b82078$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $5rAbY.isFunction)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $5rAbY.isFunction)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $098f694b73b82078$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $5rAbY.isFunction)(exec)) actionObject = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $gbTwD.__assign)((0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $098f694b73b82078$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $5rAbY.isArray)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $098f694b73b82078$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $098f694b73b82078$export$e81fdd8937d44864(action) {
    var actionObject = $098f694b73b82078$export$b38b66cc2da3ede7(action);
    return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({
        id: (0, $5rAbY.isString)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $098f694b73b82078$export$66313c302b2ea154(event) {
    if (!(0, $5rAbY.isString)(event)) return $098f694b73b82078$export$89db4734f6c919c4(event, {
        to: (0, $4fIPK.SpecialTargets).Internal
    });
    return {
        type: (0, $kTkZo.raise),
        event: event
    };
}
function $098f694b73b82078$export$ed3daf8e935ede01(action) {
    return {
        type: (0, $kTkZo.raise),
        _event: (0, $5rAbY.toSCXMLEvent)(action.event)
    };
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $098f694b73b82078$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $kTkZo.send),
        event: (0, $5rAbY.isFunction)(event) ? event : (0, $5rAbY.toEventObject)(event),
        delay: options ? options.delay : undefined,
        id: options && options.id !== undefined ? options.id : (0, $5rAbY.isFunction)(event) ? event.name : (0, $5rAbY.getEventType)(event)
    };
}
function $098f694b73b82078$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $5rAbY.toSCXMLEvent)((0, $5rAbY.isFunction)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $5rAbY.isString)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $5rAbY.isFunction)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $5rAbY.isFunction)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $5rAbY.isFunction)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $098f694b73b82078$export$408d8d51fa351f53(event, options) {
    return $098f694b73b82078$export$89db4734f6c919c4(event, (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, options), {
        to: (0, $4fIPK.SpecialTargets).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $098f694b73b82078$export$daa976aaff721e41(actor, event, options) {
    return $098f694b73b82078$export$89db4734f6c919c4(event, (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $098f694b73b82078$export$7f8b724299523eb6() {
    return $098f694b73b82078$export$408d8d51fa351f53((0, $kTkZo.update));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $098f694b73b82078$export$72b816ae90496f19(event, options) {
    return $098f694b73b82078$export$89db4734f6c919c4(event, (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $098f694b73b82078$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $098f694b73b82078$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $098f694b73b82078$var$defaultLogExpr;
    return {
        type: (0, $kTkZo.log),
        label: label,
        expr: expr
    };
}
var $098f694b73b82078$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, action), {
        value: (0, $5rAbY.isString)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $098f694b73b82078$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $kTkZo.cancel),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $098f694b73b82078$export$b3571188c770cc5a(activity) {
    var activityDef = $098f694b73b82078$export$e81fdd8937d44864(activity);
    return {
        type: (0, $4fIPK.ActionTypes).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $098f694b73b82078$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $5rAbY.isFunction)(actorRef) ? actorRef : $098f694b73b82078$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $4fIPK.ActionTypes).Stop,
        activity: activity,
        exec: undefined
    };
}
function $098f694b73b82078$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $5rAbY.isFunction)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === 'string' ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $4fIPK.ActionTypes).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $098f694b73b82078$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $kTkZo.assign),
        assignment: assignment
    };
};
function $098f694b73b82078$export$6e816592f80fc079(action) {
    return typeof action === 'object' && 'type' in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $098f694b73b82078$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : '';
    return "".concat((0, $4fIPK.ActionTypes).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $098f694b73b82078$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $4fIPK.ActionTypes).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $098f694b73b82078$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $4fIPK.ActionTypes).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $098f694b73b82078$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $4fIPK.ActionTypes).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $098f694b73b82078$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $4fIPK.ActionTypes).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $098f694b73b82078$export$eb147b7589db8e8a(target, options) {
    if (!(0, $cFnln.IS_PRODUCTION) && (!target || typeof target === 'function')) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === 'function' ? originalTarget_1.apply(void 0, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $098f694b73b82078$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $098f694b73b82078$export$f514678a4137c4d6(errorData, options) {
    return $098f694b73b82078$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $kTkZo.error),
            data: (0, $5rAbY.isFunction)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, options), {
        to: (0, $4fIPK.SpecialTargets).Parent
    }));
}
function $098f694b73b82078$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $4fIPK.ActionTypes).Choose,
        conds: conds
    };
}
var $098f694b73b82078$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $gbTwD.__values)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.length){
                if (block[i].type === (0, $kTkZo.assign)) {
                    assignActions.push(block[i]);
                    block.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $098f694b73b82078$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $098f694b73b82078$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $5rAbY.updateContext)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $kTkZo.raise:
                return $098f694b73b82078$export$ed3daf8e935ede01(actionObject);
            case 0, $kTkZo.send:
                var sendAction = $098f694b73b82078$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $cFnln.IS_PRODUCTION)) // warn after resolving as we can create better contextual message here
                (0, $5rAbY.warn)(!(0, $5rAbY.isString)(actionObject.delay) || typeof sendAction.delay === 'number', "No delay reference for delay expression '".concat(actionObject.delay, "' was found on machine '").concat(machine.id, "'"));
                if (predictableExec && sendAction.to !== (0, $4fIPK.SpecialTargets).Internal) deferredToBlockEnd.push(sendAction);
                return sendAction;
            case 0, $kTkZo.log:
                var resolved = $098f694b73b82078$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $kTkZo.choose:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $5rAbY.toGuard)(condition.cond, machine.options.guards);
                    return !guard || (0, $5rAbY.evaluateGuard)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $gbTwD.__read)($098f694b73b82078$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    $098f694b73b82078$export$aa68691f32e6c459((0, $5rAbY.toArray)(matchedActions), machine.options.actions)
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $kTkZo.pure:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $gbTwD.__read)($098f694b73b82078$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    $098f694b73b82078$export$aa68691f32e6c459((0, $5rAbY.toArray)(matchedActions), machine.options.actions)
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $kTkZo.stop:
                var resolved = $098f694b73b82078$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $kTkZo.assign:
                updatedContext = (0, $5rAbY.updateContext)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $098f694b73b82078$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    resolvedActionObject = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $gbTwD.__spreadArray)([
                                preservedContexts[contextIndex_1]
                            ], (0, $gbTwD.__read)(args), false));
                        }
                    });
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var block_1 = (0, $gbTwD.__values)(block), block_1_1 = block_1.next(); !block_1_1.done; block_1_1 = block_1.next()){
                var action = block_1_1.value;
                var resolved = handleAction(action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (block_1_1 && !block_1_1.done && (_a = block_1.return)) _a.call(block_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $5rAbY.flatten)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}

});
parcelRegister("kTkZo", function(module, exports) {

$parcel$export(module.exports, "start", function () { return $f35939bf24acab72$export$b3571188c770cc5a; });
$parcel$export(module.exports, "stop", function () { return $f35939bf24acab72$export$fa6813432f753b0d; });
$parcel$export(module.exports, "raise", function () { return $f35939bf24acab72$export$66313c302b2ea154; });
$parcel$export(module.exports, "send", function () { return $f35939bf24acab72$export$89db4734f6c919c4; });
$parcel$export(module.exports, "cancel", function () { return $f35939bf24acab72$export$70b61ad426ddbe54; });
$parcel$export(module.exports, "nullEvent", function () { return $f35939bf24acab72$export$9477ceca5dcd796a; });
$parcel$export(module.exports, "assign", function () { return $f35939bf24acab72$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "log", function () { return $f35939bf24acab72$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "init", function () { return $f35939bf24acab72$export$2cd8252107eb640b; });
$parcel$export(module.exports, "invoke", function () { return $f35939bf24acab72$export$468cda29b159ee5d; });
$parcel$export(module.exports, "errorPlatform", function () { return $f35939bf24acab72$export$503a23d0e5cd1226; });
$parcel$export(module.exports, "error", function () { return $f35939bf24acab72$export$a3bc9b8ed74fc; });
$parcel$export(module.exports, "update", function () { return $f35939bf24acab72$export$722fbec263ad908a; });
$parcel$export(module.exports, "choose", function () { return $f35939bf24acab72$export$7877a478dd30fd3d; });
$parcel$export(module.exports, "pure", function () { return $f35939bf24acab72$export$48ec4a2b1cfc6557; });

var $4fIPK = parcelRequire("4fIPK");
var $f35939bf24acab72$export$b3571188c770cc5a = (0, $4fIPK.ActionTypes).Start;
var $f35939bf24acab72$export$fa6813432f753b0d = (0, $4fIPK.ActionTypes).Stop;
var $f35939bf24acab72$export$66313c302b2ea154 = (0, $4fIPK.ActionTypes).Raise;
var $f35939bf24acab72$export$89db4734f6c919c4 = (0, $4fIPK.ActionTypes).Send;
var $f35939bf24acab72$export$70b61ad426ddbe54 = (0, $4fIPK.ActionTypes).Cancel;
var $f35939bf24acab72$export$9477ceca5dcd796a = (0, $4fIPK.ActionTypes).NullEvent;
var $f35939bf24acab72$export$e6e34fd1f2686227 = (0, $4fIPK.ActionTypes).Assign;
var $f35939bf24acab72$export$742acabee3dd6465 = (0, $4fIPK.ActionTypes).After;
var $f35939bf24acab72$export$de2557b5933c9ac6 = (0, $4fIPK.ActionTypes).DoneState;
var $f35939bf24acab72$export$bef1f36f5486a6a3 = (0, $4fIPK.ActionTypes).Log;
var $f35939bf24acab72$export$2cd8252107eb640b = (0, $4fIPK.ActionTypes).Init;
var $f35939bf24acab72$export$468cda29b159ee5d = (0, $4fIPK.ActionTypes).Invoke;
var $f35939bf24acab72$export$aca059ee6fbf94e8 = (0, $4fIPK.ActionTypes).ErrorExecution;
var $f35939bf24acab72$export$503a23d0e5cd1226 = (0, $4fIPK.ActionTypes).ErrorPlatform;
var $f35939bf24acab72$export$a3bc9b8ed74fc = (0, $4fIPK.ActionTypes).ErrorCustom;
var $f35939bf24acab72$export$722fbec263ad908a = (0, $4fIPK.ActionTypes).Update;
var $f35939bf24acab72$export$7877a478dd30fd3d = (0, $4fIPK.ActionTypes).Choose;
var $f35939bf24acab72$export$48ec4a2b1cfc6557 = (0, $4fIPK.ActionTypes).Pure;

});



parcelRegister("jPSGW", function(module, exports) {

$parcel$export(module.exports, "Scheduler", function () { return $e70d345b2e226ce3$export$d3e54bb8584cda7c; });

var $gbTwD = parcelRequire("gbTwD");
var $e70d345b2e226ce3$var$defaultOptions = {
    deferEvents: false
};
var $e70d345b2e226ce3$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, $e70d345b2e226ce3$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error('Event queue should be empty when it is not processing events');
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();

});

parcelRegister("gZqNd", function(module, exports) {

$parcel$export(module.exports, "createInvocableActor", function () { return $c5e72052684b668f$export$78b4a98dcb5ac328; });
$parcel$export(module.exports, "createDeferredActor", function () { return $c5e72052684b668f$export$59bcb51d8e40ed48; });
$parcel$export(module.exports, "isSpawnedActor", function () { return $c5e72052684b668f$export$b0f989039dc164f9; });
$parcel$export(module.exports, "toActorRef", function () { return $c5e72052684b668f$export$ccadea5f6b9e9b4e; });

var $gbTwD = parcelRequire("gbTwD");

var $5rAbY = parcelRequire("5rAbY");

var $dWCC7 = parcelRequire("dWCC7");
function $c5e72052684b668f$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $5rAbY.symbolObservable] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $c5e72052684b668f$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $5rAbY.toInvokeSource)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $5rAbY.mapContext)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $c5e72052684b668f$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $c5e72052684b668f$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $c5e72052684b668f$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $c5e72052684b668f$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $5rAbY.isMachine)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $dWCC7.provide)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $c5e72052684b668f$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === 'function';
    } catch (e) {
        return false;
    }
}
function $c5e72052684b668f$export$b0f989039dc164f9(item) {
    return $c5e72052684b668f$export$e769f6913f14f1b7(item) && 'id' in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $c5e72052684b668f$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $gbTwD.__assign)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: 'anonymous',
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $5rAbY.symbolObservable] = function() {
        return this;
    }, _a), actorRefLike);
}

});
parcelRegister("dWCC7", function(module, exports) {

$parcel$export(module.exports, "provide", function () { return $a26ea50877f4b00f$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "consume", function () { return $a26ea50877f4b00f$export$e11e6a155c5c4d9d; });
/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $a26ea50877f4b00f$var$serviceStack = [];
var $a26ea50877f4b00f$export$abe1e183e22e10ad = function(service, fn) {
    $a26ea50877f4b00f$var$serviceStack.push(service);
    var result = fn(service);
    $a26ea50877f4b00f$var$serviceStack.pop();
    return result;
};
var $a26ea50877f4b00f$export$e11e6a155c5c4d9d = function(fn) {
    return fn($a26ea50877f4b00f$var$serviceStack[$a26ea50877f4b00f$var$serviceStack.length - 1]);
};

});


parcelRegister("4BB5k", function(module, exports) {

$parcel$export(module.exports, "registry", function () { return $35a762719761405a$export$4bb7493d241fd8a5; });
var $35a762719761405a$var$children = /*#__PURE__*/ new Map();
var $35a762719761405a$var$sessionIdIndex = 0;
var $35a762719761405a$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($35a762719761405a$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $35a762719761405a$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $35a762719761405a$var$children.get(id);
    },
    free: function(id) {
        $35a762719761405a$var$children.delete(id);
    }
};

});

parcelRegister("aORon", function(module, exports) {

$parcel$export(module.exports, "getGlobal", function () { return $7e07fd71b249a452$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "registerService", function () { return $7e07fd71b249a452$export$4d7a7d14704ebc13; });

var $cFnln = parcelRequire("cFnln");
function $7e07fd71b249a452$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    if (!(0, $cFnln.IS_PRODUCTION)) console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
}
function $7e07fd71b249a452$var$getDevTools() {
    var global1 = $7e07fd71b249a452$export$a4e55266d2135a7f();
    if (global1 && '__xstate__' in global1) return global1.__xstate__;
    return undefined;
}
function $7e07fd71b249a452$export$4d7a7d14704ebc13(service) {
    if (!$7e07fd71b249a452$export$a4e55266d2135a7f()) return;
    var devTools = $7e07fd71b249a452$var$getDevTools();
    if (devTools) devTools.register(service);
}

});

parcelRegister("qzolc", function(module, exports) {

$parcel$export(module.exports, "spawnBehavior", function () { return $04fde1db482ed382$export$cc3859917b3feaf8; });

var $OT6fs = parcelRequire("OT6fs");

var $gZqNd = parcelRequire("gZqNd");

var $5rAbY = parcelRequire("5rAbY");
/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $04fde1db482ed382$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $04fde1db482ed382$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: 'pending'
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case 'fulfill':
                    parent === null || parent === void 0 || parent.send((0, $OT6fs.doneInvoke)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: 'fulfilled'
                    };
                case 'reject':
                    parent === null || parent === void 0 || parent.send((0, $OT6fs.error)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: 'rejected'
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: 'fulfill',
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: 'reject',
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $04fde1db482ed382$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $gZqNd.toActorRef)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $5rAbY.toObserver)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || 'anonymous',
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}

});


parcelRegister("6KIg3", function(module, exports) {

$parcel$export(module.exports, "useIdleInterpreter", function () { return $4ea95ea53322ef4e$export$d09836c9e303db57; });

var $6uYXW = parcelRequire("6uYXW");

var $aAXZE = parcelRequire("aAXZE");

var $4oJEX = parcelRequire("4oJEX");
var $dtyqS = parcelRequire("dtyqS");
var $5rAbY = parcelRequire("5rAbY");

var $1tH5J = parcelRequire("1tH5J");
var $4ea95ea53322ef4e$var$__assign = undefined && undefined.__assign || function() {
    $4ea95ea53322ef4e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ea95ea53322ef4e$var$__assign.apply(this, arguments);
};
var $4ea95ea53322ef4e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4ea95ea53322ef4e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $4ea95ea53322ef4e$export$d09836c9e303db57(getMachine, options) {
    var machine = (0, $1tH5J.default)(function() {
        return typeof getMachine === 'function' ? getMachine() : getMachine;
    });
    var _a, initialMachine;
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $4ea95ea53322ef4e$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $1tH5J.default)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return $4ea95ea53322ef4e$var$__assign($4ea95ea53322ef4e$var$__assign({}, machine.context), context);
        });
        return (0, $4oJEX.interpret)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $aAXZE.default)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function $4ea95ea53322ef4e$export$d9e9b060fbbae528(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $4ea95ea53322ef4e$var$__read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = $4ea95ea53322ef4e$export$d09836c9e303db57(getMachine, options);
    (0, $6uYXW.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, $5rAbY.toObserver)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $6uYXW.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $dtyqS.State).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $4oJEX.InterpreterStatus).NotStarted;
        };
    }, []);
    return service;
}

});
parcelRegister("aAXZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b6bcd9a4da2d555$export$2e2bcd8739ae039; });

var $6uYXW = parcelRequire("6uYXW");
var $7b6bcd9a4da2d555$var$index = (0, $6uYXW.useLayoutEffect);
var $7b6bcd9a4da2d555$export$2e2bcd8739ae039 = $7b6bcd9a4da2d555$var$index;

});

parcelRegister("1tH5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1139ecf3e77e0d20$export$2e2bcd8739ae039; });

var $6uYXW = parcelRequire("6uYXW");
function $1139ecf3e77e0d20$export$2e2bcd8739ae039(fn) {
    var ref = $6uYXW.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}

});



parcelRegister("c8ePo", function(module, exports) {

$parcel$export(module.exports, "assign", function () { return $8d51bbe39c1b3d81$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "send", function () { return $8d51bbe39c1b3d81$export$89db4734f6c919c4; });

var $OT6fs = parcelRequire("OT6fs");


var $4oJEX = parcelRequire("4oJEX");

var $TAle5 = parcelRequire("TAle5");




var $dtyqS = parcelRequire("dtyqS");




var $5rAbY = parcelRequire("5rAbY");
var $8d51bbe39c1b3d81$export$e6e34fd1f2686227 = (0, $OT6fs.assign), $8d51bbe39c1b3d81$export$89db4734f6c919c4 = (0, $OT6fs.send), $8d51bbe39c1b3d81$export$408d8d51fa351f53 = (0, $OT6fs.sendParent), $8d51bbe39c1b3d81$export$7f8b724299523eb6 = (0, $OT6fs.sendUpdate), $8d51bbe39c1b3d81$export$eb147b7589db8e8a = (0, $OT6fs.forwardTo), $8d51bbe39c1b3d81$export$c105e588793f70b4 = (0, $OT6fs.doneInvoke);

});
parcelRegister("TAle5", function(module, exports) {

$parcel$export(module.exports, "Machine", function () { return $0a7153ce43280321$export$f391db14ff2d9279; });
$parcel$export(module.exports, "createMachine", function () { return $0a7153ce43280321$export$aaa7fa18f8e9b2e8; });

var $8oC1C = parcelRequire("8oC1C");

var $cFnln = parcelRequire("cFnln");
var $0a7153ce43280321$var$warned = false;
function $0a7153ce43280321$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $8oC1C.StateNode)(config, options, initialContext);
}
function $0a7153ce43280321$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $cFnln.IS_PRODUCTION) && !config.predictableActionArguments && !$0a7153ce43280321$var$warned) {
        $0a7153ce43280321$var$warned = true;
        console.warn('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html');
    }
    return new (0, $8oC1C.StateNode)(config, options);
}

});
parcelRegister("8oC1C", function(module, exports) {

$parcel$export(module.exports, "StateNode", function () { return $61ce0f9db6f2a186$export$342f24f5edd47b1; });

var $gbTwD = parcelRequire("gbTwD");

var $5rAbY = parcelRequire("5rAbY");

var $4fIPK = parcelRequire("4fIPK");

var $dtyqS = parcelRequire("dtyqS");

var $kTkZo = parcelRequire("kTkZo");

var $OT6fs = parcelRequire("OT6fs");

var $cFnln = parcelRequire("cFnln");

var $81uvS = parcelRequire("81uvS");

var $7KiTp = parcelRequire("7KiTp");

var $gZqNd = parcelRequire("gZqNd");

var $14fhl = parcelRequire("14fhl");
var $61ce0f9db6f2a186$var$NULL_EVENT = '';
var $61ce0f9db6f2a186$var$STATE_IDENTIFIER = '#';
var $61ce0f9db6f2a186$var$WILDCARD = '*';
var $61ce0f9db6f2a186$var$EMPTY_OBJECT = {};
var $61ce0f9db6f2a186$var$isStateId = function(str) {
    return str[0] === $61ce0f9db6f2a186$var$STATE_IDENTIFIER;
};
var $61ce0f9db6f2a186$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $61ce0f9db6f2a186$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !('cond' in transition) && !('in' in transition) && ((0, $5rAbY.isString)(transition.target) || (0, $5rAbY.isMachine)(transition.target));
    });
    var eventText = event === $61ce0f9db6f2a186$var$NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
    (0, $5rAbY.warn)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $61ce0f9db6f2a186$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = 'context' in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($61ce0f9db6f2a186$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $81uvS.STATE_DELIMITER));
        this.id = this.config.id || (0, $gbTwD.__spreadArray)([
            this.machine.key
        ], (0, $gbTwD.__read)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $5rAbY.mapValues)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $gbTwD.__assign)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $61ce0f9db6f2a186$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $gbTwD.__values)((0, $7KiTp.getAllChildren)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $61ce0f9db6f2a186$var$NULL_EVENT;
        }) : $61ce0f9db6f2a186$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $5rAbY.toArray)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $OT6fs.toActionObject)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $5rAbY.toArray)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $OT6fs.toActionObject)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === 'final' ? this.config.data : undefined;
        this.invoke = (0, $5rAbY.toArray)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $5rAbY.isMachine)(invokeConfig)) {
                var invokeId = (0, $5rAbY.createInvokeId)(_this.id, i);
                _this.machine.options.services = (0, $gbTwD.__assign)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $14fhl.toInvokeDefinition)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $5rAbY.isString)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $5rAbY.createInvokeId)(_this.id, i);
                return (0, $14fhl.toInvokeDefinition)((0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $5rAbY.isMachine)(invokeConfig.src) || (0, $5rAbY.isFunction)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $5rAbY.createInvokeId)(_this.id, i);
                _this.machine.options.services = (0, $gbTwD.__assign)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $14fhl.toInvokeDefinition)((0, $gbTwD.__assign)((0, $gbTwD.__assign)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $14fhl.toInvokeDefinition)((0, $gbTwD.__assign)((0, $gbTwD.__assign)({
                    id: (0, $5rAbY.createInvokeId)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $5rAbY.toArray)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $OT6fs.toActivityDefinition)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $5rAbY.toArray)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $7KiTp.getAllStateNodes)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, actions), options.actions),
            activities: (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, activities), options.activities),
            guards: (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, guards), options.guards),
            services: (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, services), options.services),
            delays: (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $5rAbY.isFunction)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $5rAbY.mapValues)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $61ce0f9db6f2a186$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $61ce0f9db6f2a186$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $5rAbY.isFunction)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $OT6fs.after)(delayRef, _this.id);
            _this.onEntry.push((0, $OT6fs.send)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $OT6fs.cancel)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $5rAbY.isArray)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, transition), {
                event: eventType
            });
        }) : (0, $5rAbY.flatten)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $5rAbY.isString)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $5rAbY.toArray)(resolvedTransition).map(function(transition) {
                return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $dtyqS.State) ? state.value : (0, $5rAbY.toStateValue)(state, this.delimiter);
        if ((0, $5rAbY.isString)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)((0, $5rAbY.flatten)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $5rAbY.getEventType)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $dtyqS.State) ? state : (0, $dtyqS.State).create(state);
        var configuration = Array.from((0, $7KiTp.getConfiguration)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $dtyqS.State)((0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $7KiTp.isInFinalState)(configuration, this),
            tags: (0, $7KiTp.getTagsFromConfiguration)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $gbTwD.__values)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $5rAbY.flatten)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var entryNodes = (0, $5rAbY.flatten)(stateTransitions.map(function(t) {
            return t.entrySet;
        }));
        var configuration = (0, $5rAbY.flatten)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            entrySet: entryNodes,
            exitSet: (0, $5rAbY.flatten)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $5rAbY.flatten)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $5rAbY.isString)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $5rAbY.toSCXMLEvent)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $gbTwD.__values)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $5rAbY.isString)(stateIn) && $61ce0f9db6f2a186$var$isStateId(stateIn) ? state.matches((0, $5rAbY.toStateValue)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $5rAbY.matchesState)((0, $5rAbY.toStateValue)(stateIn, this.delimiter), (0, $5rAbY.path)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $5rAbY.evaluateGuard)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            entrySet: [],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $5rAbY.flatten)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        var reentryNodes = [];
        if (!isInternal) nextStateNodes.forEach(function(targetNode) {
            reentryNodes.push.apply(reentryNodes, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(_this.getExternalReentryNodes(targetNode)), false));
        });
        return {
            transitions: [
                selectedTransition
            ],
            entrySet: reentryNodes,
            exitSet: isInternal ? [] : [
                this
            ],
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    };
    StateNode.prototype.getExternalReentryNodes = function(targetNode) {
        var nodes = [];
        var _a = (0, $gbTwD.__read)(targetNode.order > this.order ? [
            targetNode,
            this
        ] : [
            this,
            targetNode
        ], 2), marker = _a[0], possibleAncestor = _a[1];
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = (0, $7KiTp.getConfiguration)([], prevState ? this.getStateNodes(prevState.value) : [
            this
        ]);
        try {
            for(var resolvedConfig_1 = (0, $gbTwD.__values)(resolvedConfig), resolvedConfig_1_1 = resolvedConfig_1.next(); !resolvedConfig_1_1.done; resolvedConfig_1_1 = resolvedConfig_1.next()){
                var sn = resolvedConfig_1_1.value;
                if (!(0, $7KiTp.has)(prevConfig, sn) || (0, $7KiTp.has)(transition.entrySet, sn.parent)) transition.entrySet.push(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (resolvedConfig_1_1 && !resolvedConfig_1_1.done && (_a = resolvedConfig_1.return)) _a.call(resolvedConfig_1);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $gbTwD.__values)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $7KiTp.has)(resolvedConfig, sn) || (0, $7KiTp.has)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        var doneEvents = (0, $5rAbY.flatten)(transition.entrySet.map(function(sn) {
            var events = [];
            if (sn.type !== 'final') return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $OT6fs.done)(sn.id, sn.doneData), (0, $OT6fs.done)(parent.id, sn.doneData ? (0, $5rAbY.mapContext)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === 'parallel') {
                if ((0, $7KiTp.getChildren)(grandparent).every(function(parentNode) {
                    return (0, $7KiTp.isInFinalState)(transition.configuration, parentNode);
                })) events.push((0, $OT6fs.done)(grandparent.id));
            }
            return events;
        }));
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        transition.entrySet.sort(function(a, b) {
            return a.order - b.order;
        });
        var entryStates = new Set(transition.entrySet);
        var exitStates = new Set(transition.exitSet);
        var entryActions = Array.from(entryStates).map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $OT6fs.start)(activity);
            });
            return (0, $OT6fs.toActionObjects)(predictableExec ? (0, $gbTwD.__spreadArray)((0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(entryActions), false), (0, $gbTwD.__read)(invokeActions), false) : (0, $gbTwD.__spreadArray)((0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(invokeActions), false), (0, $gbTwD.__read)(entryActions), false), _this.machine.options.actions);
        }).concat([
            doneEvents.map((0, $OT6fs.raise))
        ]);
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return (0, $OT6fs.toActionObjects)((0, $gbTwD.__spreadArray)((0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(stateNode.onExit), false), (0, $gbTwD.__read)(stateNode.activities.map(function(activity) {
                return (0, $OT6fs.stop)(activity);
            })), false), _this.machine.options.actions);
        });
        var actions = exitActions.concat([
            (0, $OT6fs.toActionObjects)(transition.actions, this.machine.options.actions)
        ]).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $OT6fs.toActionObjects)((0, $5rAbY.flatten)((0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return action.type !== (0, $kTkZo.raise) && (action.type !== (0, $kTkZo.send) || !!action.to && action.to !== (0, $4fIPK.SpecialTargets).Internal);
            });
            return actions.concat([
                stopActions
            ]);
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $5rAbY.toSCXMLEvent)(event);
        var currentState;
        if (state instanceof (0, $dtyqS.State)) currentState = context === undefined ? state : this.resolveState((0, $dtyqS.State).from(state, context));
        else {
            var resolvedStateValue = (0, $5rAbY.isString)(state) ? this.resolve((0, $5rAbY.pathToStateValue)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $dtyqS.State).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $cFnln.IS_PRODUCTION) && _event.name === $61ce0f9db6f2a186$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($61ce0f9db6f2a186$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $5rAbY.isBuiltInEvent)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            entrySet: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $7KiTp.getConfiguration)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $7KiTp.getConfiguration)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $OT6fs.initEvent);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $7KiTp.isInFinalState)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $7KiTp.getValue)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $gbTwD.__assign)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $gbTwD.__values)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var block_1 = (e_7 = void 0, (0, $gbTwD.__values)(block)), block_1_1 = block_1.next(); !block_1_1.done; block_1_1 = block_1.next()){
                        var action = block_1_1.value;
                        if (action.type === (0, $kTkZo.start)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $kTkZo.stop)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (block_1_1 && !block_1_1.done && (_b = block_1.return)) _b.call(block_1);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _c = (0, $gbTwD.__read)((0, $OT6fs.resolveActions)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _c[0], updatedContext = _c[1];
        var _d = (0, $gbTwD.__read)((0, $5rAbY.partition)(resolvedActions, function(action) {
            return action.type === (0, $kTkZo.raise) || action.type === (0, $kTkZo.send) && action.to === (0, $4fIPK.SpecialTargets).Internal;
        }), 2), raisedEvents = _d[0], nonRaisedActions = _d[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $kTkZo.start) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $kTkZo.invoke);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $gZqNd.createInvocableActor)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $gbTwD.__assign)({}, currentState.children) : {});
        var nextState = new (0, $dtyqS.State)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $5rAbY.updateHistoryValue)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $7KiTp.getTagsFromConfiguration)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $kTkZo.update) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $61ce0f9db6f2a186$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $kTkZo.nullEvent)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $dtyqS.stateValuesEqual)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($61ce0f9db6f2a186$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $61ce0f9db6f2a186$var$isStateId(stateId) ? stateId.slice($61ce0f9db6f2a186$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === 'string' && $61ce0f9db6f2a186$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $5rAbY.toStatePath)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $61ce0f9db6f2a186$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case 'parallel':
                return (0, $5rAbY.mapValues)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $61ce0f9db6f2a186$var$EMPTY_OBJECT;
                });
            case 'compound':
                if ((0, $5rAbY.isString)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $5rAbY.mapValues)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $61ce0f9db6f2a186$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $61ce0f9db6f2a186$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($61ce0f9db6f2a186$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($61ce0f9db6f2a186$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $5rAbY.toStatePath)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === 'parallel') initialStateValue = (0, $5rAbY.mapFilterValues)(this.states, function(state) {
                return state.initialStateValue || $61ce0f9db6f2a186$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === 'history');
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $7KiTp.isLeafNode)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            entrySet: (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(configuration), false),
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === 'history') {
                var historyConfig = this.config;
                if ((0, $5rAbY.isString)(historyConfig.target)) target = $61ce0f9db6f2a186$var$isStateId(historyConfig.target) ? (0, $5rAbY.pathToStateValue)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $7KiTp.isLeafNode)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === 'compound' && !this.initial) {
                if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $5rAbY.toStatePaths)(this.initialStateValue);
            return (0, $5rAbY.flatten)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $gbTwD.__read)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === 'history') return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $5rAbY.mapFilterValues)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $5rAbY.isString)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== 'history') return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $5rAbY.flatten)((0, $5rAbY.toStatePaths)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $5rAbY.nestedPath)(parent.path, 'states')(historyValue).current;
        if ((0, $5rAbY.isString)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $5rAbY.flatten)((0, $5rAbY.toStatePaths)(subHistoryValue).map(function(subStatePath) {
            return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $5rAbY.flatten)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $gbTwD.__values)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $gbTwD.__values)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $5rAbY.isString)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $5rAbY.normalizeTarget)(transitionConfig.target);
        var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $5rAbY.isString)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, transitionConfig), {
            actions: (0, $OT6fs.toActionObjects)((0, $5rAbY.toArray)(transitionConfig.actions)),
            cond: (0, $5rAbY.toGuard)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $61ce0f9db6f2a186$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $gbTwD.__rest)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $5rAbY.flatten)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $cFnln.IS_PRODUCTION) && key === $61ce0f9db6f2a186$var$NULL_EVENT) (0, $5rAbY.warn)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
                var transitionConfigArray = (0, $5rAbY.toTransitionConfigArray)(key, strictTransitionConfigs_1[key]);
                if (!(0, $cFnln.IS_PRODUCTION)) $61ce0f9db6f2a186$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $5rAbY.toTransitionConfigArray)($61ce0f9db6f2a186$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $5rAbY.toTransitionConfigArray)('', this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $5rAbY.toTransitionConfigArray)(String((0, $OT6fs.done)(this.id)), this.config.onDone) : [];
        if (!(0, $cFnln.IS_PRODUCTION)) (0, $5rAbY.warn)(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
        var invokeConfig = (0, $5rAbY.flatten)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)((0, $5rAbY.toTransitionConfigArray)(String((0, $OT6fs.doneInvoke)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)((0, $5rAbY.toTransitionConfigArray)(String((0, $OT6fs.error)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $5rAbY.flatten)((0, $gbTwD.__spreadArray)((0, $gbTwD.__spreadArray)((0, $gbTwD.__spreadArray)((0, $gbTwD.__spreadArray)([], (0, $gbTwD.__read)(doneConfig), false), (0, $gbTwD.__read)(invokeConfig), false), (0, $gbTwD.__read)(onConfig), false), (0, $gbTwD.__read)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $5rAbY.toArray)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $gbTwD.__values)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();

});
parcelRegister("14fhl", function(module, exports) {

$parcel$export(module.exports, "toInvokeDefinition", function () { return $0c72042eb2ddf721$export$4c73f685ba879446; });

var $gbTwD = parcelRequire("gbTwD");


var $kTkZo = parcelRequire("kTkZo");


function $0c72042eb2ddf721$export$436e852aa2feda95(src) {
    if (typeof src === 'string') {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $0c72042eb2ddf721$export$4c73f685ba879446(invokeConfig) {
    return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({
        type: (0, $kTkZo.invoke)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $gbTwD.__rest)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $gbTwD.__assign)((0, $gbTwD.__assign)({}, invokeDef), {
                type: (0, $kTkZo.invoke),
                src: $0c72042eb2ddf721$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}

});




parcelRegister("40sjz", function(module, exports) {

$parcel$export(module.exports, "PincodeState", function () { return $891c82a5cb3c2a2e$export$490e4628c85155ec; });
$parcel$export(module.exports, "TOUCH_SIZE", function () { return $891c82a5cb3c2a2e$export$c60b73df8d423c01; });
$parcel$export(module.exports, "FONT_SIZE", function () { return $891c82a5cb3c2a2e$export$306b9e34fb186dbb; });
var $891c82a5cb3c2a2e$export$490e4628c85155ec = /*#__PURE__*/ function(PincodeState) {
    PincodeState["PincodeConfirmation"] = "PincodeConfirmation";
    PincodeState["PromptingKeyboard"] = "PromptingKeyboard";
    PincodeState["FetchKeyboardAfterError"] = "FetchKeyboardAfterError";
    PincodeState["PromptingKeyboardPincode"] = "PromptingKeyboardPincode";
    PincodeState["FetchKeyboardAfterErrorPincode"] = "FetchKeyboardAfterErrorPincode";
    return PincodeState;
}({});
const $891c82a5cb3c2a2e$export$c60b73df8d423c01 = 135;
const $891c82a5cb3c2a2e$export$306b9e34fb186dbb = 64;

});


parcelRegister("eyjPK", function(module, exports) {

$parcel$export(module.exports, "PincodeKeyboard", function () { return $6eca98e070dd32d3$export$66c2964ee93788ae; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $9rDXi = parcelRequire("9rDXi");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $22v9q = parcelRequire("22v9q");

var $bewhU = parcelRequire("bewhU");

var $jn1mK = parcelRequire("jn1mK");

var $k4kME = parcelRequire("k4kME");

var $1NWxv = parcelRequire("1NWxv");
const $6eca98e070dd32d3$var$GRID_COLUMNS = 4;
const $6eca98e070dd32d3$export$fd9474dd86e08954 = 4;
const $6eca98e070dd32d3$export$1781b91d0e0b11d3 = 12;
const $6eca98e070dd32d3$var$TOUCH_SIZE = 56;
const $6eca98e070dd32d3$export$66c2964ee93788ae = (props)=>{
    const { keyboard: keyboard, onSubmit: onSubmit, className: className, title: title, errorMessage: errorMessage, loadingKeyboard: loadingKeyboard, keyColor: keyColor } = props;
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const pincodeMaxLength = configuration.pincode.maxLength;
    const { pincode: pincode, enterDigit: enterDigit, resetCode: resetCode } = (0, $9rDXi.usePincode)(pincodeMaxLength);
    (0, $6uYXW.useEffect)(()=>{
        if (pincode.length >= pincodeMaxLength) {
            resetCode();
            if (onSubmit && keyboard) onSubmit({
                id: keyboard.id,
                value: pincode
            });
        }
    }, [
        keyboard,
        onSubmit,
        pincode,
        resetCode,
        pincodeMaxLength
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($6eca98e070dd32d3$var$KeyboardContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($6eca98e070dd32d3$var$Header, {
                children: [
                    !!title && /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$Title, {
                        children: title
                    }),
                    !!errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$StyledErrorMessage, {
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($6eca98e070dd32d3$var$CodeRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$SideZone, {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$Code, {
                        children: (0, $k4Ecv.repeat)(pincodeMaxLength, (index)=>/*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$Circle, {
                                $filled: index < pincode.length
                            }, `indicator-${index}`))
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$SideZone, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$ClearButton, {
                            onClick: resetCode,
                            "aria-label": "Clear PIN",
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $1NWxv.ResetIcon), {})
                        })
                    })
                ]
            }),
            loadingKeyboard || !(0, $gDlNU.isDefined)(keyboard) ? /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$SpinnerContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {})
            }) : /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$Grid, {
                children: (0, $k4Ecv.repeat)($6eca98e070dd32d3$export$fd9474dd86e08954, (rowIndex)=>/*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$KeyboardRow, {
                        children: (0, $k4Ecv.repeat)($6eca98e070dd32d3$var$GRID_COLUMNS, (cellIndex)=>// The index sent back to the server is the cell position, never the digit itself.
                            /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$KeyboardTouch, {
                                onClick: ()=>enterDigit(rowIndex * $6eca98e070dd32d3$export$fd9474dd86e08954 + cellIndex),
                                $backgroundColor: keyColor,
                                // The glyph is drawn server side and its digit is deliberately unknown here, so
                                // the key is named by its place: enough to be reached, nothing given away.
                                "aria-label": `Digit ${rowIndex * $6eca98e070dd32d3$export$fd9474dd86e08954 + cellIndex}`,
                                children: /*#__PURE__*/ (0, $4m918.jsx)($6eca98e070dd32d3$var$KeyboardImage, {
                                    src: `data:image/png;base64,${keyboard.images[rowIndex * 4 + cellIndex]}`,
                                    alt: ""
                                })
                            }, `${rowIndex}-${cellIndex}`))
                    }, rowIndex))
            })
        ]
    });
};
const $6eca98e070dd32d3$var$KEYBOARD_WIDTH = $6eca98e070dd32d3$var$GRID_COLUMNS * $6eca98e070dd32d3$var$TOUCH_SIZE + ($6eca98e070dd32d3$var$GRID_COLUMNS - 1) * $6eca98e070dd32d3$export$1781b91d0e0b11d3;
const $6eca98e070dd32d3$var$KeyboardContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const $6eca98e070dd32d3$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 320px;
  text-align: center;
`;
const $6eca98e070dd32d3$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 20px;
  line-height: 28px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $6eca98e070dd32d3$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 16px;
  font-size: 14px;
  text-align: center;
`;
const $6eca98e070dd32d3$var$CodeRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${$6eca98e070dd32d3$var$KEYBOARD_WIDTH}px;
  margin: 32px 0;
`;
const $6eca98e070dd32d3$var$SideZone = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
const $6eca98e070dd32d3$var$Code = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const $6eca98e070dd32d3$var$Circle = (0, $jb8NR.default).div`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  margin: 0 9px;
  background-color: ${(props)=>props.$filled ? (0, $22v9q.theme).colors.blue[700] : "#d9d9d9"};
`;
const $6eca98e070dd32d3$var$ClearButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  padding: 6px 10px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  border-radius: 8px;

  svg {
    width: 20px;
    height: 18px;
    object-fit: contain;
    fill: ${(0, $22v9q.theme).colors.blue[700]};
  }
`;
const $6eca98e070dd32d3$var$Grid = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: ${$6eca98e070dd32d3$export$1781b91d0e0b11d3}px;
`;
const $6eca98e070dd32d3$var$KeyboardRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: ${$6eca98e070dd32d3$export$1781b91d0e0b11d3}px;
`;
const $6eca98e070dd32d3$var$KeyboardTouch = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  overflow: hidden;
  padding: 0;
  width: ${$6eca98e070dd32d3$var$TOUCH_SIZE}px;
  height: ${$6eca98e070dd32d3$var$TOUCH_SIZE}px;
  border: 1px solid #ededed;
  border-radius: 12px;
  background-color: ${(props)=>props.$backgroundColor ?? "#ffffff"};

  &:hover {
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }
`;
const $6eca98e070dd32d3$var$KeyboardImage = (0, $jb8NR.default).img`
  width: ${$6eca98e070dd32d3$var$TOUCH_SIZE}px;
  height: ${$6eca98e070dd32d3$var$TOUCH_SIZE}px;
`;
const $6eca98e070dd32d3$var$SpinnerContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${$6eca98e070dd32d3$var$KEYBOARD_WIDTH}px;
  height: ${$6eca98e070dd32d3$export$fd9474dd86e08954 * $6eca98e070dd32d3$var$TOUCH_SIZE + ($6eca98e070dd32d3$export$fd9474dd86e08954 - 1) * $6eca98e070dd32d3$export$1781b91d0e0b11d3}px;
`;

});
parcelRegister("9rDXi", function(module, exports) {

$parcel$export(module.exports, "usePincode", function () { return $f76bbbe54d825b3e$export$8334c7d775399ded; });

var $6uYXW = parcelRequire("6uYXW");
function $f76bbbe54d825b3e$export$8334c7d775399ded(length) {
    const [pincode, setPincode] = (0, $6uYXW.useState)([]);
    return {
        pincode: pincode,
        enterDigit: (digit)=>setPincode([
                ...pincode,
                digit
            ].slice(0, length)),
        resetCode: ()=>setPincode([])
    };
}

});

parcelRegister("1NWxv", function(module, exports) {

$parcel$export(module.exports, "ResetIcon", function () { return $e1729c0bb8c3f90e$export$7637ad60dd86d3b1; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $e1729c0bb8c3f90e$export$7637ad60dd86d3b1(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 19 24",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M0 9.5v1.188h2.375V9.5c0-3.93 3.196-7.125 7.125-7.125 3.93 0 7.125 3.196 7.125 7.125 0 3.93-3.196 7.125-7.125 7.125H8.312v-4.75l-5.937 5.938 5.938 5.937V19H9.5c5.238 0 9.5-4.262 9.5-9.5S14.738 0 9.5 0 0 4.262 0 9.5z"
        })
    });
}

});


parcelRegister("4fJFQ", function(module, exports) {

$parcel$export(module.exports, "PincodeChangeExplanation", function () { return $2cd6f0b6d7f98be5$export$d7734e758172bd9d; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $22v9q = parcelRequire("22v9q");
const $2cd6f0b6d7f98be5$export$d7734e758172bd9d = (props)=>{
    const { startPincodeChange: startPincodeChange, abort: abort, type: type } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($2cd6f0b6d7f98be5$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($2cd6f0b6d7f98be5$var$Title, {
                children: formatMessage("pincodeChangeScreen.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($2cd6f0b6d7f98be5$var$Subtitle, {
                children: formatMessage("pincodeChangeScreen.subtitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($2cd6f0b6d7f98be5$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($2cd6f0b6d7f98be5$var$ExplanationMessage, {
                        children: type === "after-authentication" ? formatMessage("pincodeChangeScreen.messageAfterAuthentication") : formatMessage("pincodeChangeScreen.message")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($2cd6f0b6d7f98be5$var$ActionButton, {
                        size: "S",
                        onClick: startPincodeChange,
                        children: formatMessage("pincodeChangeScreen.changePincodeButton")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($2cd6f0b6d7f98be5$var$ActionButton, {
                        size: "S",
                        onClick: abort,
                        children: formatMessage("pincodeChangeScreen.laterButton")
                    })
                ]
            })
        ]
    });
};
const $2cd6f0b6d7f98be5$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin: 0px 30px 30px 30px;
`;
const $2cd6f0b6d7f98be5$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
`;
const $2cd6f0b6d7f98be5$var$Subtitle = (0, $jb8NR.default).span`
  color: #b1b1b1;
  font-size: 0.9375rem;
`;
const $2cd6f0b6d7f98be5$var$ExplanationMessage = (0, $jb8NR.default).span`
  color: #b1b1b1;
  ${(0, $22v9q.theme).boldText};
  text-align: center;
`;
const $2cd6f0b6d7f98be5$var$Content = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
`;
const $2cd6f0b6d7f98be5$var$ActionButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  &:not(:last-of-type) {
    margin-bottom: 20px;
    margin-top: 30px;
  }
`;

});

parcelRegister("iJFSS", function(module, exports) {

$parcel$export(module.exports, "PincodeChangeSuccess", function () { return $b0776258b7be17ca$export$22362234eb489578; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $8RlWY = parcelRequire("8RlWY");

var $22v9q = parcelRequire("22v9q");
const $b0776258b7be17ca$export$22362234eb489578 = (props)=>{
    const { onComplete: onComplete } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($b0776258b7be17ca$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($b0776258b7be17ca$var$Title, {
                children: formatMessage("pincodeChangeScreen.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($b0776258b7be17ca$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($b0776258b7be17ca$var$GreenCheckCircle, {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($b0776258b7be17ca$var$ExplanationMessage, {
                        children: formatMessage("pincodeChangeFlow.success")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($b0776258b7be17ca$var$DoneButton, {
                        size: "S",
                        onClick: onComplete,
                        children: formatMessage("pincodeChangeScreen.done")
                    })
                ]
            })
        ]
    });
};
const $b0776258b7be17ca$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin: 0px 30px 30px 30px;
`;
const $b0776258b7be17ca$var$ExplanationMessage = (0, $jb8NR.default).span`
  color: #b1b1b1;
  ${(0, $22v9q.theme).mediumText};
  text-align: center;
`;
const $b0776258b7be17ca$var$Content = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`;
const $b0776258b7be17ca$var$GreenCheckCircle = (0, $jb8NR.default)((0, $8RlWY.SuccessCircle))`
  margin-top: 20px;
  margin-bottom: 50px;
`;
const $b0776258b7be17ca$var$DoneButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 30px;
`;
const $b0776258b7be17ca$var$Title = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
`;

});
parcelRegister("8RlWY", function(module, exports) {

$parcel$export(module.exports, "SuccessCircle", function () { return $e0a7124468608a91$export$bf96f6001151435e; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $f5HsK = parcelRequire("f5HsK");

var $iqXYI = parcelRequire("iqXYI");
const $e0a7124468608a91$export$bf96f6001151435e = (props)=>/*#__PURE__*/ (0, $4m918.jsx)($e0a7124468608a91$var$GreenCircle, {
        ...props,
        size: 116,
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $iqXYI.CheckIcon), {
            fill: props.theme === "shallow" ? "#2ed794" : "#ffffff"
        })
    });
const $e0a7124468608a91$var$GreenCircle = (0, $jb8NR.default)((0, $f5HsK.Circle))`
  align-self: center;
  background-color: ${(props)=>props.theme === "shallow" ? "#ffffff" : "#2ed794"};
  box-shadow: 0 6px 44px 0 rgba(46, 215, 148, 0.87);
`;

});




parcelRegister("kjBAo", function(module, exports) {

$parcel$export(module.exports, "BillIssuerModal", function () { return $7e10f0ab3533e225$export$5f84ea31269a6d50; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $1YFGv = parcelRequire("1YFGv");

var $bQhUC = parcelRequire("bQhUC");

var $40sjz = parcelRequire("40sjz");

var $5H32X = parcelRequire("5H32X");

var $lpekq = parcelRequire("lpekq");

var $eyjPK = parcelRequire("eyjPK");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $gJJ1c = parcelRequire("gJJ1c");

var $lIea8 = parcelRequire("lIea8");

var $iZaNC = parcelRequire("iZaNC");

var $7yOoG = parcelRequire("7yOoG");
const $7e10f0ab3533e225$export$5f84ea31269a6d50 = (props)=>{
    const { issuer: issuer, topLevelCategory: topLevelCategory, color: color } = props;
    const logoUrl = topLevelCategory ? (0, $lIea8.billCategoryIcon)[topLevelCategory?.id ?? ""] || (0, $lIea8.billCategoryIcon).default : issuer.logoUrl;
    const issuerLogo = issuer.logoUrl || logoUrl;
    return /*#__PURE__*/ (0, $4m918.jsx)($7e10f0ab3533e225$var$BillIssuerModalContainer, {
        closeButton: true,
        id: (0, $bQhUC.BILL_ISSUER_MODAL_ID),
        className: "bill-issuer-modal-container",
        children: /*#__PURE__*/ (0, $4m918.jsxs)($7e10f0ab3533e225$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsxs)($7e10f0ab3533e225$var$Header, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($7e10f0ab3533e225$var$Logo, {
                            style: topLevelCategory ? {
                                backgroundColor: color,
                                padding: 5
                            } : {},
                            src: logoUrl
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($7e10f0ab3533e225$var$TitleContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($7e10f0ab3533e225$var$Title, {
                                    children: topLevelCategory?.name || issuer.name
                                }),
                                !!topLevelCategory?.name && /*#__PURE__*/ (0, $4m918.jsx)($7e10f0ab3533e225$var$SubTitle, {
                                    children: issuer.name
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($7e10f0ab3533e225$var$BillIssuerContent, {
                    issuer: {
                        ...issuer,
                        logoUrl: issuerLogo
                    },
                    styledIssuerLogo: !issuer.logoUrl,
                    color: color
                })
            ]
        })
    });
};
const $7e10f0ab3533e225$var$BillIssuerContent = (props)=>{
    const { issuer: issuer, styledIssuerLogo: styledIssuerLogo, color: color } = props;
    const history = (0, $NQIVp.useHistory)();
    const paybillMachine = (0, $5H32X.usePaybillMachine)();
    const { state: state, submitPincode: submitPincode, userConfirmPayment: userConfirmPayment, context: context } = paybillMachine;
    const closeModal = ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.BILL_ISSUER_MODAL_ID));
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    (0, $6uYXW.useEffect)(()=>{
        if ((0, $kGswT.redirectionHandledOnAccountBlocked)(context.error, history.push)) closeModal();
    }, [
        context.error,
        history.push
    ]);
    const renderPaybillMachineState = (0, $6uYXW.useMemo)(()=>{
        const errorMessage = !(0, $1YFGv.isAccountBlocked)(context.error) ? context.error : undefined;
        switch(state){
            case (0, $5H32X.PaybillState).FillingForm:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $7yOoG.BillIssuerForm), {
                    issuer: issuer
                });
            case (0, $5H32X.PaybillState).UserConfirmPayment:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $iZaNC.BillConfirmationView), {
                    amount: context.transaction?.amount,
                    transactionDetails: context.transaction?.detailedAccounting,
                    issuer: issuer,
                    onSubmit: userConfirmPayment
                });
            case (0, $40sjz.PincodeState).PromptingKeyboard:
                {
                    const keyboard = context.keyboard;
                    return /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                        keyboard: keyboard,
                        onSubmit: submitPincode,
                        title: formatMessage("pincodeConfirmation.label"),
                        errorMessage: errorMessage
                    });
                }
            case (0, $5H32X.PaybillState).Done:
                {
                    const billPaymentResult = context.billPaymentResult;
                    return /*#__PURE__*/ (0, $4m918.jsx)($7e10f0ab3533e225$var$SummaryContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($7e10f0ab3533e225$var$StyledTransferSummary, {
                            billIssuer: issuer,
                            title: formatMessage("transferSummary.summaryTitle"),
                            subtitle: formatMessage("transferSummary.accountSummarySubtitle"),
                            middleStepLabel: formatMessage("transferSummary.summaryMiddleStep"),
                            transaction: billPaymentResult.metadata.transaction,
                            onDone: closeModal,
                            styledIssuerLogo: styledIssuerLogo,
                            color: color
                        })
                    });
                }
            default:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    style: {
                        margin: "auto"
                    },
                    size: "50px"
                });
        }
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $lpekq.PaybillContext).Provider, {
        value: paybillMachine,
        children: renderPaybillMachineState
    });
};
const $7e10f0ab3533e225$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 530px;
`;
const $7e10f0ab3533e225$var$Logo = (0, $jb8NR.default).img`
  width: 40px;
  height: 40px;
  border-radius: 9px;
  object-fit: contain;
  margin-right: 10px;
`;
const $7e10f0ab3533e225$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`;
const $7e10f0ab3533e225$var$TitleContainer = (0, $jb8NR.default).div`
  flex: 1;
`;
const $7e10f0ab3533e225$var$Title = (0, $jb8NR.default).h3`
  ${(0, $22v9q.theme).boldText};
  color: #000000;
  margin: 0;
`;
const $7e10f0ab3533e225$var$SubTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 0.8125rem;
  color: #b1b1b1;
`;
const $7e10f0ab3533e225$var$SummaryContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  margin-top: -20px;
`;
const $7e10f0ab3533e225$var$StyledTransferSummary = (0, $jb8NR.default)((0, $gJJ1c.TransferSummary))`
  height: 100%;
  margin-bottom: 0;
`;
const $7e10f0ab3533e225$var$BillIssuerModalContainer = (0, $jb8NR.default)((0, $iy3Ex.RoundedModalContainer))`
  &.bill-issuer-modal-container {
    margin-top: 10vh;
  }
`;

});
parcelRegister("5H32X", function(module, exports) {

$parcel$export(module.exports, "usePaybillMachine", function () { return $0acf01cea71674e3$export$320b66cf56df9d42; });
$parcel$export(module.exports, "PaybillState", function () { return $0acf01cea71674e3$export$426496f109c25c90; });

var $lCuQx = parcelRequire("lCuQx");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");

var $8UJ8q = parcelRequire("8UJ8q");

var $40sjz = parcelRequire("40sjz");
const $0acf01cea71674e3$export$320b66cf56df9d42 = ()=>{
    const [state, sendEvent] = (0, $lCuQx.useMachine)($0acf01cea71674e3$var$paybillMachine);
    const startPaybillConfirmation = (billIssuer, sessionId, confirmationMode, transaction, additionalData)=>sendEvent("FORM_ALL_FILLED", {
            billIssuer: billIssuer,
            sessionId: sessionId,
            confirmationMode: confirmationMode,
            transaction: transaction,
            additionalData: additionalData
        });
    const submitPincode = (submission)=>{
        sendEvent("SUBMIT_PINCODE", {
            pincodeSubmission: submission
        });
    };
    const userConfirmPayment = ()=>{
        sendEvent("USER_CONFIRM_PAYMENT");
    };
    return {
        state: state.value,
        context: state.context,
        startPaybillConfirmation: startPaybillConfirmation,
        submitPincode: submitPincode,
        userConfirmPayment: userConfirmPayment
    };
};
var $0acf01cea71674e3$export$426496f109c25c90 = /*#__PURE__*/ function(PaybillState) {
    PaybillState["FillingForm"] = "FillingForm";
    PaybillState["UserConfirmPayment"] = "UserConfirmPayment";
    PaybillState["SubmitPayment"] = "SubmitPayment";
    PaybillState["SubmitPaymentError"] = "SubmitPaymentError";
    PaybillState["Done"] = "Done";
    return PaybillState;
}({});
var $0acf01cea71674e3$var$PaybillInvokeName = /*#__PURE__*/ function(PaybillInvokeName) {
    PaybillInvokeName["FetchKeyboard"] = "FetchKeyboard";
    PaybillInvokeName["SubmitPayment"] = "SubmitPayment";
    return PaybillInvokeName;
}($0acf01cea71674e3$var$PaybillInvokeName || {});
const $0acf01cea71674e3$var$paybillMachine = (0, $TAle5.Machine)({
    id: "paybill",
    initial: "FillingForm",
    states: {
        ["FillingForm"]: {
            on: {
                FORM_ALL_FILLED: {
                    actions: [
                        (0, $c8ePo.assign)({
                            sessionId: (_, event)=>event.sessionId,
                            confirmationMode: (_, event)=>event.confirmationMode,
                            transaction: (_, event)=>event.transaction
                        }),
                        (0, $c8ePo.send)({
                            type: "USER_CONFIRM_PAYMENT"
                        })
                    ]
                },
                USER_CONFIRM_PAYMENT: "UserConfirmPayment"
            }
        },
        ["UserConfirmPayment"]: {
            on: {
                USER_CONFIRM_PAYMENT: {
                    target: (0, $40sjz.PincodeState).PincodeConfirmation
                }
            }
        },
        [(0, $40sjz.PincodeState).PincodeConfirmation]: {
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboard]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "SubmitPayment",
                    actions: (0, $c8ePo.assign)({
                        pincodeSubmission: (_, event)=>event.pincodeSubmission
                    })
                }
            }
        },
        ["SubmitPayment"]: {
            invoke: {
                id: "SubmitPayment",
                src: (context)=>(0, $kqXxS.billManager).validateBillPayment(context.sessionId, context.confirmationMode, context.pincodeSubmission),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            billPaymentResult: (_, event)=>event.data,
                            error: undefined
                        }),
                        ()=>(0, $kqXxS.billIssuerSelectionManager).clear(),
                        (0, $c8ePo.send)({
                            type: "PAYMENT_DONE"
                        })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)((ctx)=>ctx.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "PAYMENT_CONFIRMATION_PINCODE_ERROR"
                            } : {
                                type: "PAYMENT_CONFIRMATION_ERROR"
                            })
                    ]
                }
            },
            on: {
                PAYMENT_DONE: "Done",
                PAYMENT_CONFIRMATION_PINCODE_ERROR: (0, $40sjz.PincodeState).FetchKeyboardAfterError,
                PAYMENT_CONFIRMATION_ERROR: "SubmitPaymentError"
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        ["SubmitPaymentError"]: {
            exit: (0, $c8ePo.assign)({
                error: undefined
            }),
            on: {
                FORM_ALL_FILLED: {
                    actions: [
                        (0, $c8ePo.assign)({
                            sessionId: (_, event)=>event.sessionId,
                            confirmationMode: (_, event)=>event.confirmationMode
                        }),
                        (0, $c8ePo.send)((context)=>context.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "PINCODE_CONFIRM"
                            } : {
                                type: "CONFIRM"
                            })
                    ]
                },
                PINCODE_CONFIRM: (0, $40sjz.PincodeState).PincodeConfirmation,
                CONFIRM: "SubmitPayment"
            }
        },
        ["Done"]: {
            type: "final"
        }
    }
});

});

parcelRegister("lpekq", function(module, exports) {

$parcel$export(module.exports, "PaybillContext", function () { return $a8b9cbe2f138ca11$export$60aca8e36e5c72e0; });

var $6uYXW = parcelRequire("6uYXW");
const $a8b9cbe2f138ca11$export$60aca8e36e5c72e0 = /*#__PURE__*/ (0, $6uYXW.createContext)(null);

});

parcelRegister("gJJ1c", function(module, exports) {

$parcel$export(module.exports, "TransferSummary", function () { return $9fc61333368756de$export$e63cb336c930404d; });
$parcel$export(module.exports, "Subtitle", function () { return $9fc61333368756de$export$cf345ef34cd72655; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5P656 = parcelRequire("5P656");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $yYT9n = parcelRequire("yYT9n");

var $jMdmu = parcelRequire("jMdmu");

var $7Zu6k = parcelRequire("7Zu6k");

var $f5HsK = parcelRequire("f5HsK");

var $8RlWY = parcelRequire("8RlWY");

var $aUSui = parcelRequire("aUSui");

var $eSrUc = parcelRequire("eSrUc");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $9fc61333368756de$export$e63cb336c930404d = (props)=>{
    const { billIssuer: billIssuer, className: className, color: color, middleStepLabel: middleStepLabel, recipient: recipient, sender: sender, styledIssuerLogo: styledIssuerLogo, subtitle: subtitle, title: title, toSelf: toSelf, transaction: transaction, onDone: onDone } = props;
    const { formatMessage: formatMessage, formatAmount: formatAmount } = (0, $5hpYi.useIntl)();
    const client = (0, $3Ersk.useObservable)((0, $kqXxS.clientManager).client);
    const transferEntry = transaction.detailedAccounting?.find((entry)=>entry.type === "TRANSFER");
    let transferAmount;
    if (!transferEntry) transferAmount = transaction.amount;
    else transferAmount = (0, $5P656.addAmounts)(...transaction.detailedAccounting?.map((entry)=>entry.amount));
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($9fc61333368756de$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$GreenCheckCircle, {}),
            /*#__PURE__*/ (0, $4m918.jsxs)($9fc61333368756de$var$Centered, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$SuccessText, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$export$cf345ef34cd72655, {
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($9fc61333368756de$var$ScrollableDiv, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($9fc61333368756de$var$Details, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$BlackCircle, {
                                        size: 46,
                                        $isRTL: isRTL,
                                        children: /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$Arrow, {
                                            width: 14,
                                            height: 14,
                                            $isRTL: isRTL
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$Line, {}),
                                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$MiddleStepText, {
                                        children: middleStepLabel
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$Line, {}),
                                    recipient?.name ? /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$StyledAvatar, {
                                        size: 46,
                                        name: recipient.name,
                                        $isRTL: isRTL
                                    }) : billIssuer ? /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$IssuerLogo, {
                                        style: styledIssuerLogo ? {
                                            backgroundColor: color,
                                            padding: 5,
                                            borderRadius: 9
                                        } : {},
                                        src: billIssuer.logoUrl,
                                        $isRTL: isRTL
                                    }) : toSelf && client && client.firstName ? /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$StyledAvatar, {
                                        size: 46,
                                        name: client.firstName,
                                        $isRTL: isRTL
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($9fc61333368756de$var$NameDetails, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsxs)($9fc61333368756de$var$Name, {
                                        children: [
                                            sender ?? formatMessage("transferSummary.you"),
                                            "\n",
                                            transferAmount && formatAmount(transferAmount, toSelf)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$SideEntries, {
                                        children: transaction.detailedAccounting?.filter((entry)=>entry.type !== "TRANSFER").map((entry, idx)=>/*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$Name, {
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $eSrUc.SideEntryLabel), {
                                                    translationKeyPrefix: "transferSummary",
                                                    entry: entry,
                                                    absolute: !toSelf
                                                })
                                            }, `${entry.type}_${idx}`))
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsxs)($9fc61333368756de$var$RightAlignName, {
                                        children: [
                                            recipient ? recipient.name : billIssuer ? billIssuer.name : toSelf ? formatMessage("transferSummary.you") : "",
                                            "\n",
                                            transferEntry && (toSelf ? transferAmount ? formatAmount(transferAmount) : null : formatAmount(transferEntry.amount, true))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($9fc61333368756de$var$DoneButton, {
                        size: "M",
                        onClick: onDone,
                        children: formatMessage("transferSummary.done")
                    })
                ]
            })
        ]
    });
};
const $9fc61333368756de$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
const $9fc61333368756de$var$GreenCheckCircle = (0, $jb8NR.default)((0, $8RlWY.SuccessCircle))`
  margin-top: 28px;
`;
const $9fc61333368756de$var$Centered = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;
const $9fc61333368756de$var$SuccessText = (0, $jb8NR.default).div`
  font-size: 1.375rem;
  ${(0, $22v9q.theme).boldText};
  padding-bottom: 25px;
  padding-top: 30px;
  align-self: center;
`;
const $9fc61333368756de$export$cf345ef34cd72655 = (0, $jb8NR.default).div`
  font-size: 1rem;
  ${(0, $22v9q.theme).boldText};
  align-self: center;
  padding-bottom: 25px;
  text-align: center;
`;
const $9fc61333368756de$var$Details = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
`;
const $9fc61333368756de$var$BlackCircle = (0, $jb8NR.default)((0, $f5HsK.Circle))`
  background-color: #000000;
  margin-right: ${(props)=>props.$isRTL ? 0 : 20}px;
  margin-left: ${(props)=>props.$isRTL ? 20 : 0}px;
`;
const $9fc61333368756de$var$Line = (0, $jb8NR.default).div`
  background-color: #000000;
  height: 2px;
  flex-grow: 1;
`;
const $9fc61333368756de$var$MiddleStepText = (0, $jb8NR.default)($9fc61333368756de$export$cf345ef34cd72655)`
  padding: 0 20px;
`;
const $9fc61333368756de$var$StyledAvatar = (0, $jb8NR.default)((0, $jMdmu.Avatar))`
  margin-left: ${(props)=>props.$isRTL ? 0 : 20}px;
  margin-right: ${(props)=>props.$isRTL ? 20 : 0}px;
`;
const $9fc61333368756de$var$IssuerLogo = (0, $jb8NR.default).img`
  margin-left: ${(props)=>props.$isRTL ? 0 : 20}px;
  margin-right: ${(props)=>props.$isRTL ? 20 : 0}px;
  width: 46px;
  height: 46px;
  object-fit: contain;
`;
const $9fc61333368756de$var$NameDetails = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: stretch;
  margin-top: 15px;
`;
const $9fc61333368756de$var$Name = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.875rem;
  color: #000000;
  white-space: pre-line;
`;
const $9fc61333368756de$var$RightAlignName = (0, $jb8NR.default)($9fc61333368756de$var$Name)`
  text-align: right;
  max-width: 120px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    max-width: 90px;
  }
`;
const $9fc61333368756de$var$SideEntries = (0, $jb8NR.default).div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $9fc61333368756de$var$DoneButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $9fc61333368756de$var$ScrollableDiv = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  overflow: auto;
  padding-bottom: 15px;
  margin-bottom: 15px;
  margin-left: 10px;
  margin-right: 10px;
`;
const $9fc61333368756de$var$Arrow = (0, $jb8NR.default)((0, $aUSui.RightArrow))`
  transform: ${(props)=>props.$isRTL ? "rotate(180deg)" : "rotate(0deg)"};
`;

});
parcelRegister("jMdmu", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $17d9db6835efa4b4$export$e2255cf6045e8d47; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $1f0ZO = parcelRequire("1f0ZO");

var $22v9q = parcelRequire("22v9q");
const $17d9db6835efa4b4$export$e2255cf6045e8d47 = (props)=>{
    const { size: size, name: name, fontSize: fontSize = "1rem", className: className } = props;
    const color = (0, $6uYXW.useMemo)(()=>(0, $kqXxS.configurationManager).computeAvatarColor(name), [
        name
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)($17d9db6835efa4b4$var$RoundContainer, {
        size: size,
        className: className,
        backgroundColor: color,
        children: /*#__PURE__*/ (0, $4m918.jsx)($17d9db6835efa4b4$var$Initials, {
            fontSize: fontSize,
            theme: (0, $gDlNU.isDefined)(color) ? "dark" : "light",
            children: (0, $1f0ZO.getInitials)(name)
        })
    });
};
const $17d9db6835efa4b4$var$RoundContainer = (0, $jb8NR.default).div`
  display: flex;
  width: ${(props)=>props.size}px;
  height: ${(props)=>props.size}px;
  border-radius: ${(props)=>props.size}px;
  background-color: ${(props)=>props.backgroundColor ? props.backgroundColor : "#f4f4f4"};
  justify-content: center;
  align-items: center;
`;
const $17d9db6835efa4b4$var$Initials = (0, $jb8NR.default).div`
  ${(0, $22v9q.fonts).bold}
  font-size: ${(props)=>props.fontSize};
  color: ${(props)=>props.theme === "dark" ? "#ffffff" : "#000000"};
`;

});
parcelRegister("1f0ZO", function(module, exports) {

$parcel$export(module.exports, "getInitials", function () { return $805597a4504fccbd$export$de9bdbce6502b027; });
function $805597a4504fccbd$export$de9bdbce6502b027(name) {
    const parts = name.trim().split(" ");
    if (parts.length < 2) return $805597a4504fccbd$var$capitalize(name.trim().substring(0, 2));
    const firstPart = parts[0].charAt(0);
    const lastPart = parts[parts.length - 1].charAt(0);
    return (firstPart + lastPart).toUpperCase();
}
function $805597a4504fccbd$var$capitalize(str) {
    return str.charAt(0).toUpperCase() + str.charAt(1).toLowerCase();
}

});


parcelRegister("aUSui", function(module, exports) {

$parcel$export(module.exports, "RightArrow", function () { return $87ecd9899733d0a4$export$6208675820d4cc50; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $87ecd9899733d0a4$export$6208675820d4cc50(props) {
    const fillColor = props.fill || "#ffffff";
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 10",
        ...props,
        fillRule: "nonzero",
        children: /*#__PURE__*/ (0, $4m918.jsx)("g", {
            fill: fillColor,
            children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M6.754 1.088a.583.583 0 0 1 .825 0l3.5 3.5A.586.586 0 0 1 11.25 5l-.004-.065.003.03.001.035a.592.592 0 0 1-.082.298.58.58 0 0 1-.089.114l.062-.072a.584.584 0 0 1-.004.005l-.058.067-3.5 3.5a.583.583 0 0 1-.825-.824l2.504-2.505H1.333a.583.583 0 0 1-.575-.488L.75 5c0-.322.261-.583.583-.583h7.925L6.754 1.912a.584.584 0 0 1-.067-.744z"
            })
        })
    });
}

});

parcelRegister("eSrUc", function(module, exports) {

$parcel$export(module.exports, "SideEntryLabel", function () { return $150f71700dcecf64$export$20393ebf43db5191; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $dOAz5 = parcelRequire("dOAz5");

var $ZE1cB = parcelRequire("ZE1cB");
const $150f71700dcecf64$export$20393ebf43db5191 = ({ entry: entry, translationKeyPrefix: translationKeyPrefix, absolute: absolute = true })=>{
    const sideEntryText = (0, $dOAz5.useSideEntryLabel)(entry, translationKeyPrefix, absolute);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $ZE1cB.MarkdownText), {
        children: sideEntryText
    });
};

});
parcelRegister("dOAz5", function(module, exports) {

$parcel$export(module.exports, "useSideEntryLabel", function () { return $753469ea56cde77a$export$3f87ad6048af4551; });

var $5hpYi = parcelRequire("5hpYi");
const $753469ea56cde77a$export$3f87ad6048af4551 = (entry, translationKeyPrefix, absolute = true)=>{
    const { formatMessage: formatMessage, formatAmount: formatAmount } = (0, $5hpYi.useIntl)();
    return formatMessage(entry.type === "FEE" ? `${translationKeyPrefix}.fees` : entry.type === "COMMISSION" ? `${translationKeyPrefix}.commission` : entry.type === "DISCOUNT" ? `${translationKeyPrefix}.discount` : entry.type === "TAX" ? `${translationKeyPrefix}.tax` : "", {
        amount: formatAmount(entry.amount, absolute)
    });
};

});



parcelRegister("iZaNC", function(module, exports) {

$parcel$export(module.exports, "BillConfirmationView", function () { return $566522571c810235$export$29b382db93c35969; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $ZE1cB = parcelRequire("ZE1cB");

var $eSrUc = parcelRequire("eSrUc");

var $22v9q = parcelRequire("22v9q");
const $566522571c810235$export$29b382db93c35969 = (props)=>{
    const { issuer: issuer, transactionDetails: transactionDetails, amount: amount, onSubmit: onSubmit } = props;
    const { formatMessage: formatMessage, formatAmount: formatAmount } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($566522571c810235$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($566522571c810235$var$DetailsWrapper, {
                children: /*#__PURE__*/ (0, $4m918.jsxs)($566522571c810235$var$Details, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($566522571c810235$var$SummaryText, {
                            children: formatMessage("billFormScreen.confirmationMessage", {
                                amount: formatAmount(amount, true),
                                issuer: issuer?.name
                            })
                        }),
                        transactionDetails && transactionDetails.filter((entry)=>entry.type !== "TRANSFER").map((entry, index)=>/*#__PURE__*/ (0, $4m918.jsx)($566522571c810235$var$Name, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $eSrUc.SideEntryLabel), {
                                    entry: entry,
                                    translationKeyPrefix: "billConfirmationScreen"
                                })
                            }, `${entry.type}_${index}`))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($566522571c810235$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                    size: "M",
                    style: {
                        marginBottom: 15
                    },
                    onClick: onSubmit,
                    children: formatMessage("billFormScreen.confirmButton")
                })
            })
        ]
    });
};
const $566522571c810235$var$SummaryText = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  font-size: 15px;
  text-align: center;
  color: #aaa;
  width: 80%;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const $566522571c810235$var$FlexColumn = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $566522571c810235$var$Details = (0, $jb8NR.default)($566522571c810235$var$FlexColumn)`
  justify-content: center;
  align-items: center;
`;
const $566522571c810235$var$DetailsWrapper = (0, $jb8NR.default)($566522571c810235$var$FlexColumn)`
  justify-content: center;
  align-items: center;
  flex: 1;
  margin-bottom: 20px;
`;
const $566522571c810235$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $566522571c810235$var$Name = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.875rem;
  color: #aaaaaa;
  white-space: pre-line;
`;
const $566522571c810235$var$Wrapper = (0, $jb8NR.default)($566522571c810235$var$FlexColumn)`
  flex: 1;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
`;

});

parcelRegister("7yOoG", function(module, exports) {

$parcel$export(module.exports, "BillIssuerForm", function () { return $1965ebcdb50864a7$export$21d911e6286eead8; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $1YFGv = parcelRequire("1YFGv");

var $duu9m = parcelRequire("duu9m");

var $eV0lh = parcelRequire("eV0lh");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $kQgvS = parcelRequire("kQgvS");

var $k4kME = parcelRequire("k4kME");

var $gKqKf = parcelRequire("gKqKf");

var $cToC7 = parcelRequire("cToC7");
const $1965ebcdb50864a7$export$21d911e6286eead8 = (props)=>{
    const { issuer: issuer } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const saveReference = (issuer, newReference)=>{
        if (window.confirm(formatMessage(issuer.references ? "billFormScreen.replaceReferencePromptTitle" : "billFormScreen.saveReferencePromptTitle", {
            name: newReference.label
        }) + ". " + formatMessage(issuer.references ? "billFormScreen.replaceReferencePromptMessage" : "billFormScreen.saveReferencePromptMessage", {
            name: newReference.label
        }))) (0, $kqXxS.billIssuerManager).saveReference(issuer, newReference.value);
    };
    const { inputs: inputs, latestInputs: latestInputs, loading: loading, error: error, sendInputs: sendInputs, updateInputValue: updateInputValue } = (0, $gKqKf.usePaybillFlow)(issuer, saveReference);
    const lastElementRef = (0, $6uYXW.useRef)(null);
    (0, $eV0lh.useScrollToEnd)(lastElementRef, [
        latestInputs,
        loading,
        error
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($1965ebcdb50864a7$var$Form, {
        onSubmit: (e)=>{
            e?.preventDefault();
            sendInputs(latestInputs);
        },
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($1965ebcdb50864a7$var$BillFormContainer, {
                childrenClassName: "scroll-content",
                children: [
                    inputs.map((input, index)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $cToC7.BillFormItem), {
                            issuer: issuer,
                            showLeftDecoration: true,
                            input: input,
                            disabled: true
                        }, `${input.id}_${index}`)),
                    latestInputs.map((input, index)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $cToC7.BillFormItem), {
                            issuer: issuer,
                            showLeftDecoration: index < latestInputs.length - 1,
                            input: input,
                            onChange: (value)=>updateInputValue(input, value)
                        }, `latest_${input.id}_${index}`)),
                    loading && /*#__PURE__*/ (0, $4m918.jsx)($1965ebcdb50864a7$var$Spinner, {}),
                    error && !(0, $1YFGv.isAccountBlocked)(error) && /*#__PURE__*/ (0, $4m918.jsx)($1965ebcdb50864a7$var$StyledErrorMessage, {
                        children: error
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($1965ebcdb50864a7$var$Spacer, {
                        ref: lastElementRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1965ebcdb50864a7$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                    size: "M",
                    type: "submit",
                    disabled: !(0, $duu9m.areAllRequiredInputsFilled)(latestInputs) || latestInputs.length < 1 || loading,
                    style: {
                        marginTop: 20
                    },
                    children: formatMessage("billFormScreen.nextButton")
                })
            })
        ]
    });
};
const $1965ebcdb50864a7$var$Spinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 15px;
`;
const $1965ebcdb50864a7$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  padding: 20px 0 20px 30px;
`;
const $1965ebcdb50864a7$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $1965ebcdb50864a7$var$Form = (0, $jb8NR.default).form`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;
const $1965ebcdb50864a7$var$Spacer = (0, $jb8NR.default).div`
  flex: 1;
`;
const $1965ebcdb50864a7$var$BillFormContainer = (0, $jb8NR.default)((0, $kQgvS.ScrollableDiv))`{
    .scroll-content {
        overflow-x: hidden;
    }
}
`;

});
parcelRegister("duu9m", function(module, exports) {

$parcel$export(module.exports, "collectValues", function () { return $735ff7598afb5e6f$export$307fd834572ec7e2; });
$parcel$export(module.exports, "areAllRequiredInputsFilled", function () { return $735ff7598afb5e6f$export$a5b930d5cb0c72a4; });

var $jO1Lj = parcelRequire("jO1Lj");

var $gDlNU = parcelRequire("gDlNU");
function $735ff7598afb5e6f$export$307fd834572ec7e2(inputs) {
    return inputs.reduce((acc, value)=>{
        acc[value.id] = value.value;
        return acc;
    }, {});
}
function $735ff7598afb5e6f$export$a5b930d5cb0c72a4(inputs) {
    return inputs.reduce((acc, input)=>acc && (!input.required || input.type === (0, $jO1Lj.FormInputType).Bool && input.value !== undefined || [
            (0, $jO1Lj.FormInputType).Select,
            (0, $jO1Lj.FormInputType).SelectWithAmount
        ].includes(input.type) && input.value !== "" && input.value !== undefined || !!input.value), true);
}
function $735ff7598afb5e6f$export$df80db2059f0f6c4(inputs) {
    return inputs.reduce((acc, input)=>acc && !input.invalid, true);
}
// Recursively flattens inputs
// [{id: "a", type: "COLLECTION", inputs: [{id: "b", value: 1}, {id: "c", value: 2}]}]
// is flatten to [{id: "a.b", value: 1}, {id: "a.c", value: 2}]
const $735ff7598afb5e6f$var$DELIMITER = ".";
function $735ff7598afb5e6f$export$dc98b8ca46d40ff8(inputs) {
    return inputs.reduce((acc, input)=>{
        if (input.type === (0, $jO1Lj.FormInputType).Collection) return acc.concat($735ff7598afb5e6f$export$dc98b8ca46d40ff8(input.inputs).map((it)=>({
                ...it,
                id: `${input.id}${$735ff7598afb5e6f$var$DELIMITER}${it.id}`
            })));
        else return acc.concat(input);
    }, []);
}
function $735ff7598afb5e6f$export$88a0ee93c1322b78(inputs) {
    const collectedValues = {};
    for (const input of inputs){
        const path = input.id.split($735ff7598afb5e6f$var$DELIMITER);
        const depth = path.length;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let leaf = collectedValues;
        for(let i = 0; i < depth - 1; i++){
            if (!(0, $gDlNU.isDefined)(leaf[path[i]])) leaf[path[i]] = {};
            leaf = leaf[path[i]];
        }
        leaf[path[depth - 1]] = input.value;
    }
    return collectedValues;
}

});

parcelRegister("eV0lh", function(module, exports) {

$parcel$export(module.exports, "useScrollToEnd", function () { return $5c17b55615d795f8$export$296d94f94d195283; });

var $6uYXW = parcelRequire("6uYXW");
function $5c17b55615d795f8$export$296d94f94d195283(lastElementRef, deps) {
    (0, $6uYXW.useEffect)(()=>{
        lastElementRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ...deps,
        lastElementRef.current
    ]);
}

});

parcelRegister("gKqKf", function(module, exports) {

$parcel$export(module.exports, "usePaybillFlow", function () { return $4e14abb35c13d37f$export$2dc224f8c84c4e03; });

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $duu9m = parcelRequire("duu9m");

var $k4Ecv = parcelRequire("k4Ecv");

var $bQhUC = parcelRequire("bQhUC");

var $40sjz = parcelRequire("40sjz");

var $lpekq = parcelRequire("lpekq");

var $5Wai4 = parcelRequire("5Wai4");
const $4e14abb35c13d37f$export$2dc224f8c84c4e03 = (issuer, onSaveReference)=>{
    const history = (0, $NQIVp.useHistory)();
    const [inputs, setInputs] = (0, $6uYXW.useState)([]);
    const [latestInputs, setLatestInputs] = (0, $6uYXW.useState)([]);
    const [loading, setLoading] = (0, $6uYXW.useState)(true);
    const [error, setError] = (0, $6uYXW.useState)(null);
    const sessionId = (0, $6uYXW.useRef)("");
    const { context: context, state: state, startPaybillConfirmation: startPaybillConfirmation } = (0, $6uYXW.useContext)((0, $lpekq.PaybillContext));
    const setupNewInputs = (0, $6uYXW.useCallback)((result)=>{
        if (result.done) startPaybillConfirmation(issuer, sessionId.current, result.data.metadata.confirmationMode, result.data.metadata.transaction, result.data.data);
        else {
            setInputs((inputs)=>[
                    ...inputs,
                    ...latestInputs
                ]);
            setLatestInputs(result.data.inputs);
        }
    }, [
        issuer,
        latestInputs,
        startPaybillConfirmation
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        setLoading(true);
        try {
            const { paybillSessionId: paybillSessionId } = await (0, $kqXxS.billManager).initPayBill(issuer.id);
            sessionId.current = paybillSessionId;
            $4e14abb35c13d37f$var$saveBillReference(issuer, inputs, onSaveReference);
            const result = await (0, $kqXxS.billManager).payBill(sessionId.current, {});
            setupNewInputs(result);
        } catch (error) {
            if ((0, $kGswT.redirectionHandledOnAccountBlocked)(error, history.push)) {
                (0, $6JVVB.logger).debug("Paybill init error ", error);
                (0, $5Wai4.Modal).dismiss((0, $bQhUC.BILL_ISSUER_MODAL_ID));
            } else setError(error);
        } finally{
            setLoading(false);
        }
    }, []);
    const sendInputs = (0, $6uYXW.useCallback)(async (inputs)=>{
        setError(null);
        setLoading(true);
        try {
            $4e14abb35c13d37f$var$saveBillReference(issuer, inputs, onSaveReference);
            const result = await (0, $kqXxS.billManager).payBill(sessionId.current, (0, $duu9m.collectValues)(inputs));
            setupNewInputs(result);
        } catch (error) {
            if ((0, $kGswT.redirectionHandledOnAccountBlocked)(error, history.push)) {
                (0, $6JVVB.logger).debug("Paybill error ", error);
                (0, $5Wai4.Modal).dismiss((0, $bQhUC.BILL_ISSUER_MODAL_ID));
            } else setError(error);
        } finally{
            setLoading(false);
        }
    }, [
        history.push,
        issuer,
        onSaveReference,
        setupNewInputs
    ]);
    const updateInputValue = (0, $6uYXW.useCallback)(function(input, value) {
        const index = latestInputs.findIndex((i)=>i.id === input.id);
        setLatestInputs((latestInputs)=>[
                ...latestInputs.slice(0, index),
                {
                    ...input,
                    value: value
                },
                ...latestInputs.slice(index + 1)
            ]);
    }, [
        latestInputs
    ]);
    return {
        inputs: inputs,
        latestInputs: latestInputs,
        loading: loading || state === (0, $40sjz.PincodeState).PincodeConfirmation,
        error: error || context.error,
        sendInputs: sendInputs,
        updateInputValue: updateInputValue
    };
};
function $4e14abb35c13d37f$var$saveBillReference(issuer, inputs, onSaveReference) {
    const referenceInput = inputs.find((input)=>input.id === "billId");
    if (referenceInput && !$4e14abb35c13d37f$var$isReferenceAlreadySaved(referenceInput, issuer)) {
        const referenceName = referenceInput.label ? referenceInput.label.toLowerCase() : referenceInput.id;
        onSaveReference?.(issuer, {
            label: referenceName,
            value: referenceInput.value
        });
    }
}
function $4e14abb35c13d37f$var$isReferenceAlreadySaved(referenceInput, issuer) {
    return !!issuer.references && referenceInput.value === issuer.references[0];
}

});

parcelRegister("cToC7", function(module, exports) {

$parcel$export(module.exports, "BillFormItem", function () { return $9298250ed062848b$export$8fd0836bf7501780; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $jO1Lj = parcelRequire("jO1Lj");

var $fxmB5 = parcelRequire("fxmB5");

var $7QebT = parcelRequire("7QebT");

var $22v9q = parcelRequire("22v9q");
function $9298250ed062848b$export$8fd0836bf7501780({ input: input, issuer: issuer, onChange: onChange, showLeftDecoration: showLeftDecoration, disabled: disabled }) {
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($9298250ed062848b$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($9298250ed062848b$var$Bullet, {}),
                    /*#__PURE__*/ (0, $4m918.jsxs)($9298250ed062848b$var$SectionText, {
                        children: [
                            input.label,
                            " ",
                            input.required ? "*" : ""
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($9298250ed062848b$var$FormPart, {
                showLeftDecoration: showLeftDecoration,
                children: [
                    input.description && /*#__PURE__*/ (0, $4m918.jsx)($9298250ed062848b$var$Description, {
                        children: input.description
                    }),
                    input.type === (0, $jO1Lj.FormInputType).Text ? /*#__PURE__*/ (0, $4m918.jsx)($9298250ed062848b$var$TextFieldWithAutofillReference, {
                        input: input,
                        disabled: disabled,
                        issuer: issuer,
                        onChange: onChange
                    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $fxmB5.FormField), {
                        input: input,
                        disabled: disabled,
                        selectFieldType: "combobox",
                        onChange: onChange
                    })
                ]
            })
        ]
    });
}
const $9298250ed062848b$var$TextFieldWithAutofillReference = ({ issuer: issuer, ...props })=>{
    $9298250ed062848b$var$useAutofillReference(props.input, issuer, props.onChange);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $7QebT.TextField), {
        ...props
    });
};
function $9298250ed062848b$var$useAutofillReference(input, issuer, onChange) {
    (0, $6uYXW.useEffect)(()=>{
        if (!input.value && input.id === "billId" && issuer?.references && onChange) onChange(issuer.references[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
const $9298250ed062848b$var$Bullet = ()=>/*#__PURE__*/ (0, $4m918.jsx)($9298250ed062848b$var$BulletContainer, {
        children: /*#__PURE__*/ (0, $4m918.jsx)($9298250ed062848b$var$OutterBullet, {
            children: /*#__PURE__*/ (0, $4m918.jsx)($9298250ed062848b$var$InnerBullet, {})
        })
    });
const $9298250ed062848b$var$FormPart = ({ showLeftDecoration: showLeftDecoration, children: children })=>/*#__PURE__*/ (0, $4m918.jsxs)($9298250ed062848b$var$FormPartContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("div", {
                style: {
                    marginRight: 23,
                    width: 4,
                    backgroundColor: "black",
                    borderRadius: 4,
                    opacity: showLeftDecoration ? 1 : 0
                }
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($9298250ed062848b$var$FormPartChildrenContainer, {
                children: children
            })
        ]
    });
const $9298250ed062848b$var$FormPartContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  padding-left: 22px;
`;
const $9298250ed062848b$var$FormPartChildrenContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding: 10px 32px 10px 0;
  flex-grow: 1;
`;
const $9298250ed062848b$var$Section = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px;
`;
const $9298250ed062848b$var$SectionText = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 15px;
  color: black;
  margin-left: 10px;
`;
const $9298250ed062848b$var$Description = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  margin-bottom: 15px;
`;
const $9298250ed062848b$var$BulletContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $9298250ed062848b$var$OutterBullet = (0, $jb8NR.default).div`
  display: flex;
  width: 28px;
  height: 28px;
  border-radius: 28px;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
`;
const $9298250ed062848b$var$InnerBullet = (0, $jb8NR.default).div`
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background-color: #000000;
`;

});





parcelRegister("5uojP", function(module, exports) {

$parcel$export(module.exports, "BillReferencesScreen", function () { return $9301c0811071e040$export$b44e0970c02e4377; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $9beBp = parcelRequire("9beBp");

var $2jAE5 = parcelRequire("2jAE5");

var $4fYE4 = parcelRequire("4fYE4");

var $dvzf7 = parcelRequire("dvzf7");

var $jn1mK = parcelRequire("jn1mK");

var $amCCH = parcelRequire("amCCH");

var $jEKif = parcelRequire("jEKif");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $i7hHc = parcelRequire("i7hHc");
const $9301c0811071e040$export$b44e0970c02e4377 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { billIssuers: billIssuersAndCategories, loading: loading, refreshing: refreshing, error: error, billIssuerColors: billIssuerColors } = (0, $9beBp.useBillIssuer)();
    const issuers = (0, $6uYXW.useMemo)(()=>billIssuersAndCategories ? (0, $2jAE5.collectIssuersWithTopLevelCategory)(billIssuersAndCategories).filter((issuer)=>issuer.references) : null, [
        billIssuersAndCategories
    ]);
    const colors = (0, $6uYXW.useMemo)(()=>new Map(billIssuersAndCategories ? billIssuersAndCategories.filter((issuerOrCategory)=>issuerOrCategory.type === "CATEGORY").map((category, index)=>[
                category.id,
                billIssuerColors[index % billIssuerColors.length]
            ]) : null), [
        billIssuersAndCategories,
        billIssuerColors
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($9301c0811071e040$var$ReferenceSection, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $amCCH.PageHeader), {
                title: formatMessage("billReferencesScreen.title"),
                children: /*#__PURE__*/ (0, $4m918.jsx)($9301c0811071e040$var$GoBackToServicesLink, {
                    to: (0, $4fYE4.Path).BillIssuers,
                    children: formatMessage("billReferencesScreen.services")
                })
            }),
            issuers && issuers.length > 0 ? issuers.map((issuer)=>/*#__PURE__*/ (0, $4m918.jsx)($9301c0811071e040$var$IssuerView, {
                    issuer: issuer,
                    topLevelCategory: issuer.topLevelCategory,
                    color: colors.get(issuer.topLevelCategory?.id ?? "") || "#000000",
                    withReference: true
                }, issuer.id)) : loading || refreshing ? /*#__PURE__*/ (0, $4m918.jsx)($9301c0811071e040$var$StyledSpinner, {}) : error ? /*#__PURE__*/ (0, $4m918.jsx)($9301c0811071e040$var$StyledErrorMessage, {
                children: formatMessage("billReferencesScreen.loadBillReferencesError")
            }) : /*#__PURE__*/ (0, $4m918.jsx)($9301c0811071e040$var$EmptyListMessage, {
                children: formatMessage("billReferencesScreen.emptyRecipientList")
            })
        ]
    });
};
const $9301c0811071e040$var$ReferenceSection = (0, $jb8NR.default).section`
  align-self: stretch;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $9301c0811071e040$var$ReferenceSectionTitle = (0, $jb8NR.default)((0, $jEKif.PageSectionTitle))`
  margin-right: 10px;
`;
const $9301c0811071e040$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 30px;
`;
const $9301c0811071e040$var$EmptyListMessage = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.875rem;
  color: #b1b1b1;
  margin-top: 30px;
  text-align: center;
`;
const $9301c0811071e040$var$StyledSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: 40px auto 0 auto;
`;
const $9301c0811071e040$var$GoBackToServicesLink = (0, $jb8NR.default)((0, $dvzf7.TertiaryLink))`
  text-align: center;
  margin-right: 10px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-bottom: 20px;
  }
`;
const $9301c0811071e040$var$IssuerView = (0, $jb8NR.default)((0, $i7hHc.BillIssuerView))`
  position: relative;
  margin: 10px 0;
  border-radius: 10px;
  ${(0, $22v9q.shadows).medium};
  background-color: #ffffff;
`;

});

parcelRegister("evDSv", function(module, exports) {

$parcel$export(module.exports, "AllCardsScreen", function () { return $1c19481823c8334b$export$176ca4e6410bd0c8; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $j6DTh = parcelRequire("j6DTh");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $9mhzx = parcelRequire("9mhzx");

var $3fNyH = parcelRequire("3fNyH");

var $4LgRR = parcelRequire("4LgRR");

var $2owH9 = parcelRequire("2owH9");

var $kokda = parcelRequire("kokda");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $bQhUC = parcelRequire("bQhUC");

var $izd7j = parcelRequire("izd7j");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $1VCpi = parcelRequire("1VCpi");

var $k4kME = parcelRequire("k4kME");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $aMHYD = parcelRequire("aMHYD");

var $a0LAX = parcelRequire("a0LAX");

var $2AJ6K = parcelRequire("2AJ6K");

var $lQpdA = parcelRequire("lQpdA");

var $kQZCH = parcelRequire("kQZCH");

var $iNTcF = parcelRequire("iNTcF");

var $cJrqV = parcelRequire("cJrqV");

var $gnXS1 = parcelRequire("gnXS1");

var $2w2vI = parcelRequire("2w2vI");

var $2F9AR = parcelRequire("2F9AR");

var $jpP4c = parcelRequire("jpP4c");

var $h1vyY = parcelRequire("h1vyY");

var $kdHXC = parcelRequire("kdHXC");
function $1c19481823c8334b$export$176ca4e6410bd0c8() {
    const { cards: cards, loading: cardsLoading, error: cardsError, retry: reloadCards } = (0, $4LgRR.useCards)();
    const { loading: productsLoading, products: products } = (0, $kokda.useProducts)();
    const accounts = (0, $9mhzx.useAccounts)();
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { canRefabricateCard: canRefabricateCard } = (0, $j6DTh.useCardLinks)();
    const [sensitiveData, setSensitiveData] = (0, $6uYXW.useState)(null);
    const [pendingOperation, setPendingOperation] = (0, $6uYXW.useState)(false);
    const screenLoading = cardsLoading || productsLoading;
    const card = (0, $6uYXW.useMemo)(()=>(0, $2owH9.getWalletCard)(cards), [
        cards
    ]);
    const { loading: loading, oppose: oppose, deactivate: deactivate, block: block, unblock: unblock, enableFeature: enableFeature } = (0, $4LgRR.useCardOperation)(card?.id ?? null);
    (0, $6uYXW.useEffect)(()=>{
        setSensitiveData(null);
        setPendingOperation((0, $gDlNU.isDefined)(card?.pendingManagementOperation));
    }, [
        card
    ]);
    const balance = (0, $6uYXW.useMemo)(()=>{
        const account = accounts.find((a)=>a.id === card?.accountId);
        return account ? (0, $kGswT.getAvailableBalance)(account) : null;
    }, [
        accounts,
        card
    ]);
    const hasActions = (0, $6uYXW.useMemo)(()=>{
        switch(card?.status){
            case (0, $3fNyH.CardStatus).Pending:
            case (0, $3fNyH.CardStatus).Active:
            case (0, $3fNyH.CardStatus).Blocked:
                return true;
            default:
                return false;
        }
    }, [
        card
    ]);
    const canActivateCard = (0, $6uYXW.useMemo)(()=>{
        const cardProduct = products.find((p)=>p.id === card?.productId);
        return (0, $gDlNU.isDefined)(cardProduct?.cardActivationMode);
    }, [
        card,
        products
    ]);
    // The settings column exists only for a card that actually carries switchable features.
    const showFeatures = !!card && (card.status === (0, $3fNyH.CardStatus).Active || card.status === (0, $3fNyH.CardStatus).Blocked) && (card.features?.length ?? 0) > 0;
    const canOrderAgain = !!card && (card.status === (0, $3fNyH.CardStatus).Opposed || canRefabricateCard(card));
    const refreshCard = (0, $6uYXW.useCallback)(async ()=>{
        if ((0, $gDlNU.isDefined)(card)) try {
            await (0, $kqXxS.cardManager).retrieveCard(card.id);
        } catch (e) {
            (0, $6JVVB.logger).debug("Error refreshCard : ", e?.response?.data?.error?.message);
        }
    }, [
        card
    ]);
    const toggleCardDetails = ()=>{
        if (sensitiveData?.panDisplay) setSensitiveData(null);
        else (0, $5Wai4.Modal).present((0, $bQhUC.CARD_SENSITIVE_DETAILS_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $2AJ6K.CardSensitiveDetails), {
                card: card,
                onCompleted: (res)=>setSensitiveData(res)
            }), {
            canBeDismissed: false
        });
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)((0, $1VCpi.PageHeaderBand), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderTitle), {
                        children: formatMessage("cardsList.myCardTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderSubtitle), {
                        children: formatMessage("cardsList.myCardSubtitle")
                    })
                ]
            }),
            screenLoading ? /*#__PURE__*/ (0, $4m918.jsx)($1c19481823c8334b$var$LoadingContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {})
            }) : cardsError ? /*#__PURE__*/ (0, $4m918.jsxs)($1c19481823c8334b$var$LoadError, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($1c19481823c8334b$var$LoadErrorMessage, {
                        children: formatMessage("cardsList.loadCardsError")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($1c19481823c8334b$var$RetryButton, {
                        size: "XS",
                        onClick: reloadCards,
                        children: formatMessage("cardsList.loadCardsRetry")
                    })
                ]
            }) : !card ? /*#__PURE__*/ (0, $4m918.jsx)((0, $a0LAX.EmptyCardPanel), {}) : /*#__PURE__*/ (0, $4m918.jsxs)($1c19481823c8334b$var$Columns, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($1c19481823c8334b$var$MainColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $lQpdA.CardVisual), {
                                card: card,
                                balance: balance,
                                sensitiveData: sensitiveData
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($1c19481823c8334b$var$StyledAdditionalInfos, {
                                card: card,
                                onClick: refreshCard
                            }),
                            (hasActions || canOrderAgain) && /*#__PURE__*/ (0, $4m918.jsxs)($1c19481823c8334b$var$Actions, {
                                children: [
                                    hasActions && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)((0, $2w2vI.LockCardSwitch), {
                                                card: card,
                                                loading: loading,
                                                disabled: pendingOperation,
                                                block: block,
                                                unblock: unblock
                                            }),
                                            /*#__PURE__*/ (0, $4m918.jsx)((0, $kdHXC.UpdateCardPinCodeButton), {
                                                card: card,
                                                disabled: pendingOperation
                                            }),
                                            card.virtual ? /*#__PURE__*/ (0, $4m918.jsx)((0, $gnXS1.DeactivateButton), {
                                                card: card,
                                                loading: loading,
                                                deactivate: deactivate
                                            }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $2F9AR.OppositionButton), {
                                                card: card,
                                                loading: loading,
                                                oppose: oppose
                                            }),
                                            canActivateCard && /*#__PURE__*/ (0, $4m918.jsx)((0, $iNTcF.ActivationButton), {
                                                card: card,
                                                disabled: pendingOperation
                                            }),
                                            features.cardSensitiveDataView && /*#__PURE__*/ (0, $4m918.jsx)((0, $aMHYD.ActionMenu), {
                                                title: formatMessage(sensitiveData?.panDisplay ? "cardOptions.switch.hideDetails" : "cardOptions.switch.showDetails"),
                                                iconSrc: (0, $fRvTz.StaticAssets).cardDetails,
                                                onClick: toggleCardDetails
                                            })
                                        ]
                                    }),
                                    card.status === (0, $3fNyH.CardStatus).Opposed && /*#__PURE__*/ (0, $4m918.jsx)((0, $jpP4c.OrderNewCardButton), {
                                        card: card
                                    }),
                                    canRefabricateCard(card) && card.status !== (0, $3fNyH.CardStatus).Opposed && /*#__PURE__*/ (0, $4m918.jsx)((0, $h1vyY.RefabricateButton), {
                                        card: card
                                    })
                                ]
                            })
                        ]
                    }),
                    showFeatures && /*#__PURE__*/ (0, $4m918.jsxs)($1c19481823c8334b$var$SideColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($1c19481823c8334b$var$SectionTitle, {
                                children: formatMessage("cardOptions.title")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $cJrqV.CardFeaturesSwitches), {
                                card: card,
                                loading: loading,
                                enableFeature: enableFeature,
                                disabled: pendingOperation
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $1c19481823c8334b$var$LoadingContainer = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  justify-content: center;
  padding: 80px 0;
`;
/* A failed list is not an empty one: the holder is told, and offered the call again. */ const $1c19481823c8334b$var$LoadError = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 20px;
  padding: 64px 24px;
  border-radius: 12px;
  background-color: ${(0, $22v9q.theme).colors.blue[200]};
`;
const $1c19481823c8334b$var$LoadErrorMessage = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $1c19481823c8334b$var$RetryButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  padding: 13px 28px;
  box-shadow: none;
`;
const $1c19481823c8334b$var$Columns = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  width: 100%;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    flex-direction: column;
    gap: 24px;
  }
`;
/* The card sets the column's width, so it keeps the mockup's proportions on any window. */ const $1c19481823c8334b$var$MainColumn = (0, $jb8NR.default).div`
  display: flex;
  flex: 0 0 472px;
  flex-direction: column;
  min-width: 0;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    flex: 1 1 auto;
    align-self: stretch;
  }
`;
const $1c19481823c8334b$var$SideColumn = (0, $jb8NR.default).div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    align-self: stretch;
  }
`;
const $1c19481823c8334b$var$StyledAdditionalInfos = (0, $jb8NR.default)((0, $kQZCH.AdditionalInfosSection))`
  margin-top: 20px;
`;
const $1c19481823c8334b$var$Actions = (0, $jb8NR.default)((0, $izd7j.ActionRowList))`
  margin-top: 20px;
`;
const $1c19481823c8334b$var$SectionTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0 0 12px;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;

});
parcelRegister("j6DTh", function(module, exports) {

$parcel$export(module.exports, "useCardLinks", function () { return $630877b614c5ea66$export$90bcb998d7b28bf5; });

var $aWjzi = parcelRequire("aWjzi");
const $630877b614c5ea66$export$90bcb998d7b28bf5 = ()=>{
    const canGetOutstandings = (card)=>{
        if (!card.links) return false;
        return card.links.findIndex((link)=>link.rel === (0, $aWjzi.CardLinks).GetOutstandings) > -1;
    };
    const canUpdateLimits = (card)=>{
        if (!card.links) return false;
        return card.links.findIndex((link)=>link.rel === (0, $aWjzi.CardLinks).UpdateLimits) > -1;
    };
    const canRefabricateCard = (card)=>{
        if (!card.links) return false;
        return card.links.findIndex((link)=>link.rel === (0, $aWjzi.CardLinks).Refabricate) > -1 && !card.virtual;
    };
    return {
        canGetOutstandings: canGetOutstandings,
        canUpdateLimits: canUpdateLimits,
        canRefabricateCard: canRefabricateCard
    };
};

});
parcelRegister("aWjzi", function(module, exports) {

$parcel$export(module.exports, "CardLinks", function () { return $28280df24ba7cff7$export$955b33155a1e7657; });
var $28280df24ba7cff7$export$955b33155a1e7657 = /*#__PURE__*/ function(CardLinks) {
    CardLinks["Refabricate"] = "refabricateCard";
    CardLinks["ReissueCode"] = "reissueCardCode";
    CardLinks["Oppose"] = "opposeCard";
    CardLinks["Block"] = "blockCard";
    CardLinks["Unblock"] = "unblockCard";
    CardLinks["Activate"] = "activateCard";
    CardLinks["ActivateWithCode"] = "activateCardWithCode";
    CardLinks["UpdateFeatures"] = "updateCardFeatures";
    CardLinks["UpdateLimits"] = "updateCardLimits";
    CardLinks["Deactivate"] = "deactivateCard";
    CardLinks["GetOutstandings"] = "getOutstandings";
    return CardLinks;
}({});

});


parcelRegister("3fNyH", function(module, exports) {

$parcel$export(module.exports, "CardStatus", function () { return $888a33a59c8ce0cd$export$490c7ce941281ba8; });
$parcel$export(module.exports, "CardPendingOperationType", function () { return $888a33a59c8ce0cd$export$75d4ceda73e7fb40; });
$parcel$export(module.exports, "CardFeatureType", function () { return $888a33a59c8ce0cd$export$b32361014be3fe51; });
$parcel$export(module.exports, "OpposeCardReason", function () { return $888a33a59c8ce0cd$export$1a936bb56d5ff1d1; });
$parcel$export(module.exports, "CardRefabricateMotive", function () { return $888a33a59c8ce0cd$export$b5682bea254e770; });

var $g1DMc = parcelRequire("g1DMc");
var $888a33a59c8ce0cd$export$f1a79bffad3377cd = /*#__PURE__*/ function(CardType) {
    CardType["DebitCard"] = "DEBIT_CARD";
    return CardType;
}({});
var $888a33a59c8ce0cd$export$490c7ce941281ba8 = /*#__PURE__*/ function(CardStatus) {
    CardStatus["New"] = "NEW";
    CardStatus["Pending"] = "PENDING";
    CardStatus["Active"] = "ACTIVE";
    CardStatus["Expired"] = "EXPIRED";
    CardStatus["Blocked"] = "BLOCKED";
    CardStatus["Opposed"] = "OPPOSED";
    CardStatus["Removed"] = "REMOVED";
    CardStatus["Cancelled"] = "CANCELLED";
    return CardStatus;
}({});
const $888a33a59c8ce0cd$export$1886e078c4ce8b7c = [
    {
        value: "ALL",
        label: (0, $g1DMc.cardStatusLabels).ALL
    },
    {
        value: "NEW",
        label: (0, $g1DMc.cardStatusLabels)["NEW"]
    },
    {
        value: "PENDING",
        label: (0, $g1DMc.cardStatusLabels)["PENDING"]
    },
    {
        value: "ACTIVE",
        label: (0, $g1DMc.cardStatusLabels)["ACTIVE"]
    },
    {
        value: "BLOCKED",
        label: (0, $g1DMc.cardStatusLabels)["BLOCKED"]
    },
    {
        value: "OPPOSED",
        label: (0, $g1DMc.cardStatusLabels)["OPPOSED"]
    }
];
var $888a33a59c8ce0cd$export$75d4ceda73e7fb40 = /*#__PURE__*/ function(CardPendingOperationType) {
    CardPendingOperationType["Refabrication"] = "refabrication";
    CardPendingOperationType["CodeReissuing"] = "card_code_reissuing";
    CardPendingOperationType["Opposition"] = "card_opposition";
    CardPendingOperationType["Blocking"] = "card_blocking";
    CardPendingOperationType["Unblocking"] = "card_unblocking";
    CardPendingOperationType["Activation"] = "card_activation";
    CardPendingOperationType["Creation"] = "card_creation";
    CardPendingOperationType["FeaturesUpdate"] = "card_features_update";
    CardPendingOperationType["LimitsUpdate"] = "card_limits_update";
    return CardPendingOperationType;
}({});
var $888a33a59c8ce0cd$export$b32361014be3fe51 = /*#__PURE__*/ function(CardFeatureType) {
    CardFeatureType["Nfc"] = "NFC";
    CardFeatureType["CashOperation"] = "CASH_OPERATION";
    CardFeatureType["ForeignPayment"] = "FOREIGN_PAYMENT";
    CardFeatureType["OnlinePayment"] = "ONLINE_PAYMENT";
    CardFeatureType["EurWithdrawal"] = "EUR_WITHDRAWAL";
    CardFeatureType["ForeignWithdrawal"] = "FOREIGN_WITHDRAWAL";
    CardFeatureType["PaymentAuthorized"] = "PAYMENT_AUTHORIZED";
    CardFeatureType["EurPayment"] = "EUR_PAYMENT";
    CardFeatureType["ForeignAll"] = "FOREIGN_ALL";
    CardFeatureType["ForeignOnlinePayment"] = "FOREIGN_ONLINE_PAYMENT";
    return CardFeatureType;
}({});
var $888a33a59c8ce0cd$export$1a936bb56d5ff1d1 = /*#__PURE__*/ function(OpposeCardReason) {
    OpposeCardReason["Lost"] = "LOST";
    OpposeCardReason["Stolen"] = "STOLEN";
    OpposeCardReason["NotDistributed"] = "NOT_DISTRIBUTED";
    return OpposeCardReason;
}({});
var $888a33a59c8ce0cd$export$b5682bea254e770 = /*#__PURE__*/ function(CardRefabricateMotive) {
    CardRefabricateMotive["Damaged"] = "DAMAGED";
    CardRefabricateMotive["Stolen"] = "STOLEN";
    CardRefabricateMotive["Lost"] = "LOST";
    CardRefabricateMotive["Abuse"] = "ABUSE";
    return CardRefabricateMotive;
}({});
const $888a33a59c8ce0cd$export$d62cba6449a78755 = [
    {
        key: "DAMAGED"
    }
];
const $888a33a59c8ce0cd$export$5bb25d72d5b7c137 = [
    {
        key: "STOLEN"
    },
    {
        key: "LOST"
    },
    {
        key: "ABUSE"
    }
];

});
parcelRegister("g1DMc", function(module, exports) {

$parcel$export(module.exports, "cardStatusLabels", function () { return $cd1862e5070d231b$export$ec0756ed53ee245; });

var $jSdHh = parcelRequire("jSdHh");
const $cd1862e5070d231b$export$ec0756ed53ee245 = {
    [(0, $jSdHh.CardStatus).ALL]: "card.status.all",
    [(0, $jSdHh.CardStatus).NEW]: "card.status.new",
    [(0, $jSdHh.CardStatus).PENDING]: "card.status.pending",
    [(0, $jSdHh.CardStatus).ACTIVE]: "card.status.active",
    [(0, $jSdHh.CardStatus).EXPIRED]: "card.status.expired",
    [(0, $jSdHh.CardStatus).REMOVED]: "card.status.removed",
    [(0, $jSdHh.CardStatus).BLOCKED]: "card.status.blocked",
    [(0, $jSdHh.CardStatus).OPPOSED]: "card.status.opposed",
    [(0, $jSdHh.CardStatus).CANCELLED]: "card.status.cancelled"
};

});


parcelRegister("4LgRR", function(module, exports) {

$parcel$export(module.exports, "useCards", function () { return $84e54bcdc6c0d643$export$5fe928848609fec7; });
$parcel$export(module.exports, "useCardOperation", function () { return $84e54bcdc6c0d643$export$aa492ca53bb456d3; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $84e54bcdc6c0d643$export$5fe928848609fec7 = ()=>{
    const cards = (0, $3Ersk.useObservable)((0, $kqXxS.cardManager).cards);
    const [loading, setLoading] = (0, $6uYXW.useState)(true);
    const [error, setError] = (0, $6uYXW.useState)(null);
    const load = (0, $6uYXW.useCallback)(async ()=>{
        try {
            setLoading(true);
            setError(null);
            await (0, $kqXxS.cardManager).refresh();
        } catch (e) {
            // Kept so a screen can tell "no card" from "the list could not be loaded", as mobile does.
            setError(e);
            (0, $6JVVB.logger).debug("error fetching cards", e);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $k4Ecv.useAsyncEffect)(load, []);
    return {
        cards: cards,
        loading: loading,
        error: error,
        retry: load
    };
};
const $84e54bcdc6c0d643$export$aa492ca53bb456d3 = (cardId)=>{
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const operationWrapper = (0, $6uYXW.useCallback)(async (operation)=>{
        try {
            setLoading(true);
            await operation();
        } catch (e) {
            throw e;
        } finally{
            setLoading(false);
        }
    }, []);
    return {
        loading: loading,
        oppose: (reason)=>operationWrapper(async ()=>{
                cardId && await (0, $kqXxS.cardManager).oppose(cardId, reason);
            }),
        deactivate: ()=>operationWrapper(async ()=>{
                cardId && await (0, $kqXxS.cardManager).deactivate(cardId);
            }),
        block: ()=>operationWrapper(async ()=>{
                cardId && await (0, $kqXxS.cardManager).block(cardId);
            }),
        unblock: ()=>operationWrapper(async ()=>{
                cardId && await (0, $kqXxS.cardManager).unblock(cardId);
            }),
        activate: (cardIdentifier)=>operationWrapper(async ()=>{
                cardId && await (0, $kqXxS.cardManager).activate(cardId, cardIdentifier);
            }),
        enableFeature: (feature, isEnabled)=>operationWrapper(async ()=>{
                cardId && await (0, $kqXxS.cardManager).enableFeature(cardId, feature, isEnabled);
            })
    };
};

});

parcelRegister("2owH9", function(module, exports) {

$parcel$export(module.exports, "getWalletCard", function () { return $f0a7fdba64da3ea4$export$2d3eeef32dda1450; });

var $3fNyH = parcelRequire("3fNyH");
/** Statuses a card can carry without being part of the holder's wallet any more. */ const $f0a7fdba64da3ea4$var$EXCLUDED_STATUSES = [
    (0, $3fNyH.CardStatus).Expired,
    (0, $3fNyH.CardStatus).Removed,
    (0, $3fNyH.CardStatus).Cancelled
];
const $f0a7fdba64da3ea4$export$2d3eeef32dda1450 = (cards)=>cards.find((card)=>!$f0a7fdba64da3ea4$var$EXCLUDED_STATUSES.includes(card.status));

});

parcelRegister("kokda", function(module, exports) {

$parcel$export(module.exports, "useProducts", function () { return $cc9fc143d784f6c5$export$964e8498268f0fe3; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $cc9fc143d784f6c5$export$964e8498268f0fe3 = ()=>{
    const products = (0, $3Ersk.useObservable)((0, $kqXxS.productManager).debitCardProducts);
    const [loading, setLoading] = (0, $6uYXW.useState)(true);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        try {
            setLoading(true);
            await (0, $kqXxS.productManager).loadDebitCardProducts();
        } catch (e) {
            (0, $6JVVB.logger).debug("error fetching products", e);
        } finally{
            setLoading(false);
        }
    }, []);
    return {
        products: products,
        loading: loading
    };
};

});

parcelRegister("aMHYD", function(module, exports) {

$parcel$export(module.exports, "ActionMenu", function () { return $56595fd8b930f5c7$export$ed57a210b9d13bb6; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $izd7j = parcelRequire("izd7j");
const $56595fd8b930f5c7$export$ed57a210b9d13bb6 = (props)=>{
    const { title: title, description: description, iconSrc: iconSrc, className: className, disabled: disabled, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
        className: className,
        label: title,
        subtitle: description,
        iconSrc: iconSrc,
        disabled: disabled,
        onClick: onClick
    });
};

});

parcelRegister("a0LAX", function(module, exports) {

$parcel$export(module.exports, "EmptyCardPanel", function () { return $2c1d8d47c97d5f8d$export$6d95afa97dc492bf; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $bfYs4 = parcelRequire("bfYs4");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $fdKqW = parcelRequire("fdKqW");
const $2c1d8d47c97d5f8d$export$6d95afa97dc492bf = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const startCardCreationFlow = ()=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.CARD_CREATION_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $fdKqW.CardCreationModal), {}), {
            canBeDismissed: false
        });
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($2c1d8d47c97d5f8d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($2c1d8d47c97d5f8d$var$Panel, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($2c1d8d47c97d5f8d$var$Illustration, {
                        src: (0, $fRvTz.StaticAssets).cardNew,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($2c1d8d47c97d5f8d$var$Title, {
                        children: formatMessage("cardsList.emptyTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($2c1d8d47c97d5f8d$var$Description, {
                        children: formatMessage("cardsList.emptyDescription")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($2c1d8d47c97d5f8d$var$AddCardButton, {
                size: "XS",
                onClick: startCardCreationFlow,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($2c1d8d47c97d5f8d$var$PlusSign, {
                        width: 20,
                        height: 20
                    }),
                    formatMessage("cardsList.addCardButton")
                ]
            })
        ]
    });
};
const $2c1d8d47c97d5f8d$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 100%;
`;
const $2c1d8d47c97d5f8d$var$Panel = (0, $jb8NR.default).div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-height: 520px;
  padding: 32px 24px;
  border-radius: 12px;
  background-color: ${(0, $22v9q.theme).colors.blue[200]};
`;
const $2c1d8d47c97d5f8d$var$Illustration = (0, $jb8NR.default).img`
  width: 67px;
  height: 68px;
`;
const $2c1d8d47c97d5f8d$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  margin-top: 16px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #741537;
`;
const $2c1d8d47c97d5f8d$var$Description = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 8px;
  text-align: center;
  font-size: 13px;
  line-height: 18px;
  color: #8c8c8c;
`;
const $2c1d8d47c97d5f8d$var$AddCardButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  margin-top: 28px;
  padding: 13px 28px;
  box-shadow: none;

  /* DefaultButton wraps the children, so the gap belongs to that wrapper. */
  > div {
    gap: 8px;
  }
`;
/* The icon paints itself black, so the fill is set back here rather than through a prop. */ const $2c1d8d47c97d5f8d$var$PlusSign = (0, $jb8NR.default)((0, $bfYs4.PlusIcon))`
  flex-shrink: 0;

  path {
    fill: #ffffff;
  }
`;

});
parcelRegister("bfYs4", function(module, exports) {

$parcel$export(module.exports, "PlusIcon", function () { return $2491c5c96611be8a$export$f21ab0717a89c77f; });
$parcel$export(module.exports, "PlusIconSmall", function () { return $2491c5c96611be8a$export$c9ea04c1efe0cb2; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $2491c5c96611be8a$export$f21ab0717a89c77f = (props)=>/*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("mask", {
                id: "ldqh4dtm5a",
                maskUnits: "userSpaceOnUse",
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                fill: "#000",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        fill: "#fff",
                        d: "M2 2h20v20H2z"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12 3a.31.31 0 0 0-.31.31v8.38H3.31a.31.31 0 1 0 0 .62h8.38v8.38a.31.31 0 1 0 .62 0v-8.38h8.38a.31.31 0 0 0 0-.62h-8.38V3.31A.31.31 0 0 0 12 3z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 3a.31.31 0 0 0-.31.31v8.38H3.31a.31.31 0 1 0 0 .62h8.38v8.38a.31.31 0 1 0 .62 0v-8.38h8.38a.31.31 0 0 0 0-.62h-8.38V3.31A.31.31 0 0 0 12 3z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M11.69 11.69v.4h.4v-.4h-.4zm0 .62h.4v-.4h-.4v.4zm.62 0v-.4h-.4v.4h.4zm0-.62h-.4v.4h.4v-.4zm-.22-8.38c0 .05-.04.09-.09.09v-.8a.71.71 0 0 0-.71.71h.8zm0 8.38V3.31h-.8v8.38h.8zm-8.78.4h8.38v-.8H3.31v.8zM3.4 12c0 .05-.04.09-.09.09v-.8a.71.71 0 0 0-.71.71h.8zm-.09-.09c.05 0 .09.04.09.09h-.8c0 .392.318.71.71.71v-.8zm8.38 0H3.31v.8h8.38v-.8zm.4 8.78v-8.38h-.8v8.38h.8zM12 20.6c.05 0 .09.04.09.09h-.8c0 .392.318.71.71.71v-.8zm-.09.09c0-.05.04-.09.09-.09v.8a.71.71 0 0 0 .71-.71h-.8zm0-8.38v8.38h.8v-8.38h-.8zm8.78-.4h-8.38v.8h8.38v-.8zm-.09.09c0-.05.04-.09.09-.09v.8a.71.71 0 0 0 .71-.71h-.8zm.09.09a.09.09 0 0 1-.09-.09h.8a.71.71 0 0 0-.71-.71v.8zm-8.38 0h8.38v-.8h-8.38v.8zm-.4-8.78v8.38h.8V3.31h-.8zm.09.09a.09.09 0 0 1-.09-.09h.8A.71.71 0 0 0 12 2.6v.8z",
                fill: "#000",
                mask: "url(#ldqh4dtm5a)"
            })
        ]
    });
const $2491c5c96611be8a$export$c9ea04c1efe0cb2 = (props)=>/*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        ...props,
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.25 8.25V3.75C8.25 3.33579 8.58579 3 9 3C9.41421 3 9.75 3.33579 9.75 3.75V8.25H14.25C14.6642 8.25 15 8.58579 15 9C15 9.41421 14.6642 9.75 14.25 9.75H9.75V14.25C9.75 14.6642 9.41421 15 9 15C8.58579 15 8.25 14.6642 8.25 14.25V9.75H3.75C3.33579 9.75 3 9.41421 3 9C3 8.58579 3.33579 8.25 3.75 8.25H8.25Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("mask", {
                id: "mask0_25_1582",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "3",
                width: "12",
                height: "12",
                children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.25 8.25V3.75C8.25 3.33579 8.58579 3 9 3C9.41421 3 9.75 3.33579 9.75 3.75V8.25H14.25C14.6642 8.25 15 8.58579 15 9C15 9.41421 14.6642 9.75 14.25 9.75H9.75V14.25C9.75 14.6642 9.41421 15 9 15C8.58579 15 8.25 14.6642 8.25 14.25V9.75H3.75C3.33579 9.75 3 9.41421 3 9C3 8.58579 3.33579 8.25 3.75 8.25H8.25Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("g", {
                mask: "url(#mask0_25_1582)",
                children: /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                    width: "18",
                    height: "18",
                    fill: "black"
                })
            })
        ]
    });

});

parcelRegister("fdKqW", function(module, exports) {

$parcel$export(module.exports, "CardCreationModal", function () { return $a2b57a63c4a9406b$export$14a6823a4c8c1eda; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $61WqT = parcelRequire("61WqT");

var $kKSXp = parcelRequire("kKSXp");

var $gDlNU = parcelRequire("gDlNU");

var $e4wja = parcelRequire("e4wja");

var $k4Ecv = parcelRequire("k4Ecv");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $k4kME = parcelRequire("k4kME");

var $8Mjlc = parcelRequire("8Mjlc");

var $jNOeu = parcelRequire("jNOeu");

var $8wRZz = parcelRequire("8wRZz");

var $dxm8d = parcelRequire("dxm8d");
const $a2b57a63c4a9406b$export$14a6823a4c8c1eda = ({ isVirtual: isVirtual })=>/*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CARD_CREATION_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsx)($a2b57a63c4a9406b$var$CardCreationView, {
            isVirtual: isVirtual
        })
    });
const $a2b57a63c4a9406b$var$CardCreationView = ({ isVirtual: isVirtual })=>{
    const { step: step, selectedProduct: selectedProduct, selectedAccount: selectedAccount, debitCardProducts: debitCardProducts, currentAccounts: currentAccounts, cgu: cgu, creationError: creationError, scaToken: scaToken, startCreationFlow: startCreationFlow, setSelectedProduct: setSelectedProduct, setSelectedAccount: setSelectedAccount, confirmSelection: confirmSelection, acceptCguWithoutPin: acceptCguWithoutPin, createCard: createCard } = (0, $kKSXp.useCardCreation)(isVirtual);
    const [scaIsLoading, setScaIsLoading] = (0, $6uYXW.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)("");
    const { client: client } = (0, $7N0kU.useClient)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { loading: loading } = (0, $k4Ecv.useAsyncFunction)(async ()=>{
        await Promise.all([
            (0, $kqXxS.accountManager).load(),
            (0, $kqXxS.productManager).loadDebitCardProducts()
        ]);
        await startCreationFlow();
    }, []);
    const successSubtitle = ()=>selectedProduct?.cardCreationProcess?.creationEndText || formatMessage("resultScreen.createCard.defaultSuccessSubtitle");
    const handleOTPValidation = async (otp, scaToken)=>{
        if (scaToken) try {
            setScaIsLoading(true);
            const response = await (0, $kqXxS.authenticationsSessionsService).verifyAuthentication(scaToken, otp);
            if (response.status === (0, $61WqT.VerifyAuthenticationStatus).DONE) createCard(selectedAccount, selectedProduct, null, scaToken);
        } catch (e) {
            setErrorMessage(e);
        } finally{
            setScaIsLoading(false);
        }
        else throw new Error("Missing SCA Token");
    };
    const innerStepComponent = ()=>{
        switch(step){
            case (0, $kKSXp.CardCreationStep).SelectAccountOrCard:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $dxm8d.CreateCardSelectionStep), {
                    isVirtual: isVirtual,
                    currentAccounts: currentAccounts,
                    selectedAccount: (0, $gDlNU.isDefined)(selectedAccount) ? selectedAccount : undefined,
                    selectAccount: setSelectedAccount,
                    debitCardProducts: debitCardProducts,
                    selectedProduct: (0, $gDlNU.isDefined)(selectedProduct) ? selectedProduct : undefined,
                    selectProduct: setSelectedProduct,
                    confirmSelection: confirmSelection
                });
            case (0, $kKSXp.CardCreationStep).PresentCgu:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $8wRZz.CreateCardCguStep), {
                    cgu: cgu,
                    acceptCgu: acceptCguWithoutPin
                });
            case (0, $kKSXp.CardCreationStep).SCACheck:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: (otp)=>handleOTPValidation(otp, scaToken),
                    errorMessage: errorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: scaIsLoading
                });
            case (0, $kKSXp.CardCreationStep).Error:
                return /*#__PURE__*/ (0, $4m918.jsx)($a2b57a63c4a9406b$var$StyledResultView, {
                    type: "error",
                    title: formatMessage("resultScreen.createCard.failureTitle"),
                    subtitle: formatMessage("resultScreen.createCard.failureSubtitle"),
                    description: formatMessage("resultScreen.createCard.failureDescription"),
                    error: creationError,
                    onConfirm: ()=>{
                        (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_CREATION_MODAL_ID));
                    }
                });
            case (0, $kKSXp.CardCreationStep).Success:
                return /*#__PURE__*/ (0, $4m918.jsx)($a2b57a63c4a9406b$var$StyledResultView, {
                    type: "success",
                    title: formatMessage("resultScreen.createCard.successTitle"),
                    subtitle: successSubtitle(),
                    onConfirm: ()=>{
                        (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_CREATION_MODAL_ID));
                    }
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($a2b57a63c4a9406b$var$ModalContainer, {
        children: loading ? /*#__PURE__*/ (0, $4m918.jsx)($a2b57a63c4a9406b$var$StyledSpinner, {}) : innerStepComponent()
    });
};
const $a2b57a63c4a9406b$var$ModalContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $a2b57a63c4a9406b$var$StyledSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: auto;
`;
const $a2b57a63c4a9406b$var$StyledResultView = (0, $jb8NR.default)((0, $jNOeu.ResultView))`
  margin-left: 20px;
  margin-right: 20px;
`;

});
parcelRegister("kKSXp", function(module, exports) {

$parcel$export(module.exports, "CardCreationStep", function () { return $e88056d974cc819b$export$b16587aa320e31dc; });
$parcel$export(module.exports, "useCardCreation", function () { return $e88056d974cc819b$export$be2f191cdde1b718; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $kGswT = parcelRequire("kGswT");
var $e88056d974cc819b$export$b16587aa320e31dc = /*#__PURE__*/ function(CardCreationStep) {
    CardCreationStep["SelectAccountOrCard"] = "SELECT_ACCOUNT_OR_CARD";
    CardCreationStep["PresentCgu"] = "PRESENT_CGU";
    CardCreationStep["Success"] = "CARD_CREATION_SUCCESS";
    CardCreationStep["Error"] = "CARD_CREATION_ERROR";
    CardCreationStep["SCACheck"] = "SCA_CHECK";
    return CardCreationStep;
}({});
const $e88056d974cc819b$export$be2f191cdde1b718 = (isVirtual)=>{
    const [step, setStep] = (0, $6uYXW.useState)(undefined);
    const [scaToken, setScaToken] = (0, $6uYXW.useState)("");
    const [selectedProduct, setSelectedProduct] = (0, $6uYXW.useState)(null);
    const [selectedAccount, setSelectedAccount] = (0, $6uYXW.useState)(null);
    const [creationError, setCreationError] = (0, $6uYXW.useState)(undefined);
    const accounts = (0, $3Ersk.useObservable)((0, $kqXxS.accountManager).accounts);
    const currentAccounts = (0, $6uYXW.useMemo)(()=>accounts.filter((account)=>account.type == (0, $kGswT.AccountType).Current), [
        accounts
    ]);
    const debitCardProducts = (0, $3Ersk.useObservable)((0, $kqXxS.productManager).debitCardProducts);
    const cgu = (0, $6uYXW.useMemo)(()=>selectedProduct?.cardCreationProcess?.termsOfServiceHtml || "", [
        selectedProduct
    ]);
    const resetStep = ()=>{
        setStep("SELECT_ACCOUNT_OR_CARD");
    };
    const createCard = (0, $6uYXW.useCallback)(async (account, product, pincode, scaToken)=>{
        try {
            if (!(0, $gDlNU.isDefined)(account)) throw new Error("missing account to create card");
            if (!(0, $gDlNU.isDefined)(product) && !isVirtual) throw new Error("missing product to create card");
            setCreationError(undefined);
            await (0, $kqXxS.cardManager).createCard(account.id, product.id, pincode, scaToken, isVirtual);
            setStep("CARD_CREATION_SUCCESS");
        } catch (e) {
            //SCA use case, must send and verify the given token
            if (e.response?.data?.error === "Unauthorized" && e.response?.data?.new_token) {
                setScaToken(e.response.data.new_token);
                setStep("SCA_CHECK");
                (0, $kqXxS.authenticationsSessionsService).sendAuthentication(e.response.data.new_token);
            } else {
                setCreationError(e.response?.data?.error?.message || e.toString());
                setStep("CARD_CREATION_ERROR");
            }
        }
    }, [
        setStep,
        setCreationError
    ]);
    const startCreationFlow = (0, $6uYXW.useCallback)(async ()=>{
        const availableAccounts = (0, $kqXxS.accountManager).accounts.get().filter((account)=>account.type == (0, $kGswT.AccountType).Current);
        const availableDebitCards = (0, $kqXxS.productManager).debitCardProducts.get();
        if (availableAccounts.length === 0) {
            setCreationError("Can't create card. No current account available.");
            setStep("CARD_CREATION_ERROR");
            return;
        }
        if (availableDebitCards.length === 0) {
            setCreationError("Can't create card. No debit card product available.");
            setStep("CARD_CREATION_ERROR");
            return;
        }
        if (availableAccounts.length > 1 || availableDebitCards.length > 1) setStep("SELECT_ACCOUNT_OR_CARD");
        else {
            setSelectedAccount(availableAccounts[0]);
            setSelectedProduct(availableDebitCards[0]);
            const nextStep = getStepFromCardCreationProcess(availableDebitCards[0].cardCreationProcess);
            if ((0, $gDlNU.isDefined)(nextStep)) setStep(nextStep);
            else await createCard(availableAccounts[0], availableDebitCards[0]);
        }
    }, [
        createCard
    ]);
    const confirmSelection = (0, $6uYXW.useCallback)(async ()=>{
        if (!(0, $gDlNU.isDefined)(selectedAccount)) throw new Error("missing account to create card");
        if (!(0, $gDlNU.isDefined)(selectedProduct)) throw new Error("missing product to create card");
        // to show CGU again if dismissed without validation
        setStep("SELECT_ACCOUNT_OR_CARD");
        const nextStep = getStepFromCardCreationProcess(selectedProduct.cardCreationProcess);
        if ((0, $gDlNU.isDefined)(nextStep)) setStep(nextStep);
        else await createCard(selectedAccount, selectedProduct);
    }, [
        selectedAccount,
        selectedProduct,
        createCard,
        setStep
    ]);
    const rejectCgu = (0, $6uYXW.useCallback)(()=>{
        setStep("SELECT_ACCOUNT_OR_CARD");
    }, [
        setStep
    ]);
    const acceptCguWithoutPin = (0, $6uYXW.useCallback)(async ()=>{
        await createCard(selectedAccount, selectedProduct);
    }, [
        selectedAccount,
        selectedProduct,
        createCard
    ]);
    const getStepFromCardCreationProcess = (process)=>{
        if (process?.termsOfServiceHtml) return "PRESENT_CGU";
        return undefined;
    };
    return {
        startCreationFlow: startCreationFlow,
        step: step,
        selectedProduct: selectedProduct,
        setSelectedProduct: setSelectedProduct,
        selectedAccount: selectedAccount,
        setSelectedAccount: setSelectedAccount,
        debitCardProducts: debitCardProducts,
        currentAccounts: currentAccounts,
        confirmSelection: confirmSelection,
        cgu: cgu,
        rejectCgu: rejectCgu,
        acceptCguWithoutPin: acceptCguWithoutPin,
        creationError: creationError,
        scaToken: scaToken,
        resetStep: resetStep,
        createCard: createCard
    };
};

});

parcelRegister("8Mjlc", function(module, exports) {

$parcel$export(module.exports, "OtpConfirm", function () { return $efd046932380157a$export$93e2f5b458634e1d; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $8L45G = parcelRequire("8L45G");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $efd046932380157a$export$93e2f5b458634e1d = (props)=>{
    const { submitOtp: submitOtp, sendOtpAgain: sendOtpAgain, cancelOtp: cancelOtp, onOtpBlocked: onOtpBlocked, additionalText: additionalText, loading: loading, phoneNumber: phoneNumber, refreshingOtp: refreshingOtp, errorMessage: errorMessage, refreshingErrorMessage: refreshingErrorMessage, explanationColor: explanationColor } = props;
    const [otp, setOTP] = (0, $6uYXW.useState)("");
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const otpInputRef = (0, $6uYXW.useRef)(null);
    const hasOtpBeenReset = (0, $6uYXW.useRef)(false);
    const resetOtp = (0, $6uYXW.useCallback)(()=>{
        otpInputRef.current?.reset();
        hasOtpBeenReset.current = true;
    }, []);
    const isOtpValid = otp.length >= configuration.otp.maxLength;
    const OTP_MAX_TRIES = 3;
    const [otpTriesLeft, setOtpTriesLeft] = (0, $6uYXW.useState)(OTP_MAX_TRIES);
    const [otpFailed, setOtpFailed] = (0, $6uYXW.useState)(false);
    (0, $6uYXW.useEffect)(()=>{
        const authFailed = errorMessage === "Authentication failed";
        if ((0, $gDlNU.isDefined)(errorMessage) && !hasOtpBeenReset.current) {
            setOtpFailed(authFailed);
            resetOtp();
            setOtpTriesLeft((prev)=>Math.max(prev - 1, 0));
        } else if (isOtpValid && !props.onConfirm) {
            setOtpFailed(false);
            hasOtpBeenReset.current = false;
            submitOtp(otp);
        }
    }, [
        errorMessage,
        isOtpValid,
        otp,
        otpTriesLeft,
        props.onConfirm,
        resetOtp,
        submitOtp
    ]);
    const handleConfirmClick = (event)=>{
        event.preventDefault();
        if (isOtpValid) {
            props.onConfirm?.(otp);
            setOtpTriesLeft((prev)=>Math.max(prev - 1, 0));
        }
    };
    const handleCancelClick = ()=>{
        props.onCancel?.();
    };
    const handleSendOtpAgain = ()=>{
        if (otpTriesLeft <= 0 && onOtpBlocked) onOtpBlocked();
        else {
            resetOtp();
            setOtpTriesLeft(OTP_MAX_TRIES);
            if (sendOtpAgain) sendOtpAgain();
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($efd046932380157a$var$Container, {
        children: [
            (0, $gDlNU.isDefined)(additionalText) && /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$AdditionalText, {
                children: additionalText
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$Explanation, {
                textColor: explanationColor,
                children: formatMessage("otp.explanation")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$PhoneNumber, {
                dir: "ltr",
                children: phoneNumber ?? "** ** ** ** **"
            }),
            refreshingErrorMessage && /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$StyledErrorMessage, {
                children: formatMessage(refreshingErrorMessage)
            }),
            otpTriesLeft > 0 ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    (0, $gDlNU.isDefined)(errorMessage) && /*#__PURE__*/ (0, $4m918.jsxs)($efd046932380157a$var$StyledErrorMessage, {
                        children: [
                            errorMessage,
                            "\xa0",
                            onOtpBlocked ? `\n${otpTriesLeft} tentative(s) restante(s)` : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$StyledOtpInput, {
                        ref: otpInputRef,
                        length: configuration.otp.maxLength,
                        onOtpChange: (otpCode)=>setOTP(otpCode),
                        disabled: otpTriesLeft === 0
                    })
                ]
            }) : /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$StyledErrorMessage, {
                children: formatMessage("otp.otpBlockedErrorMessage")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$Footer, {
                children: loading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {}) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        sendOtpAgain ? /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$SendOtpAgainButton, {
                            size: "S",
                            onClick: handleSendOtpAgain,
                            disabled: refreshingOtp,
                            children: formatMessage(otpTriesLeft <= 0 && onOtpBlocked ? "otp.backToRecipients" : "otp.sendBackCodeButton")
                        }) : null,
                        cancelOtp ? /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$CancelOtpButton, {
                            size: "S",
                            onClick: ()=>{
                                cancelOtp();
                            },
                            disabled: refreshingOtp,
                            children: formatMessage("otp.cancelOtpButton")
                        }) : null,
                        /*#__PURE__*/ (0, $4m918.jsxs)($efd046932380157a$var$ContainerButtons, {
                            children: [
                                props.onCancel && /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$CancelButton, {
                                    size: "S",
                                    onClick: handleCancelClick,
                                    children: otpFailed ? formatMessage("otp.goToTransferFormButton") : formatMessage("otp.cancelOtpButton")
                                }),
                                props.onConfirm && !otpFailed && /*#__PURE__*/ (0, $4m918.jsx)($efd046932380157a$var$ConfirmButton, {
                                    size: "S",
                                    onClick: handleConfirmClick,
                                    disabled: !isOtpValid,
                                    children: formatMessage("otp.confirmOtpButton")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $efd046932380157a$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
`;
const $efd046932380157a$var$SendOtpAgainButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $efd046932380157a$var$CancelOtpButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))``;
const $efd046932380157a$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $efd046932380157a$var$CancelButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))``;
const $efd046932380157a$var$Explanation = (0, $jb8NR.default).div`
  color: ${(props)=>props.textColor ?? "black"};
  margin-left: 50px;
  margin-right: 50px;
  text-align: center;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-left: 0;
    margin-right: 0;
  }
`;
const $efd046932380157a$var$AdditionalText = (0, $jb8NR.default)($efd046932380157a$var$Explanation)`
  margin-bottom: 20px;
`;
const $efd046932380157a$var$PhoneNumber = (0, $jb8NR.default)($efd046932380157a$var$Explanation)`
  ${(0, $22v9q.theme).boldText}
  color: black;
`;
const $efd046932380157a$var$StyledOtpInput = (0, $jb8NR.default)((0, $8L45G.OtpInput))`
  justify-content: center;
  margin-top: 40px;
`;
const $efd046932380157a$var$Footer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 20px;
  min-height: 46px;
  width: 100%;
`;
const $efd046932380157a$var$ContainerButtons = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
`;
const $efd046932380157a$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0;
  text-align: center;
`;

});
parcelRegister("8L45G", function(module, exports) {

$parcel$export(module.exports, "OtpInput", function () { return $e1029e7003bdb3d4$export$955b768f4e275de8; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $05ceX = parcelRequire("05ceX");

var $k4Ecv = parcelRequire("k4Ecv");

var $9mlIh = parcelRequire("9mlIh");
// keyCode constant
const $e1029e7003bdb3d4$var$BACKSPACE = 8;
const $e1029e7003bdb3d4$var$DELETE = 46;
const $e1029e7003bdb3d4$export$955b768f4e275de8 = /*#__PURE__*/ (0, $6uYXW.forwardRef)((props, ref)=>{
    const { length: length, onOtpChange: onOtpChange, className: className } = props;
    const [inputs, setInputs] = (0, $6uYXW.useState)((0, $k4Ecv.repeat)(length, (index)=>({
            id: `otpInput_${index}_${(0, $05ceX.getRandomID)()}`,
            name: `otpInput${index}`,
            value: ""
        })));
    const [focusInputId, setFocusInputId] = (0, $6uYXW.useState)(inputs[0].id);
    const resetOtp = ()=>{
        setInputs((prevInputs)=>prevInputs.map((input)=>({
                    ...input,
                    value: ""
                })));
        document.getElementById(inputs[0].id)?.focus({
            preventScroll: true
        });
        onOtpChange?.("");
    };
    (0, $6uYXW.useImperativeHandle)(ref, ()=>({
            reset: resetOtp
        }));
    (0, $6uYXW.useEffect)(()=>{
        document.getElementById(focusInputId)?.focus({
            preventScroll: true
        });
    }, [
        focusInputId
    ]);
    const handleRemoveKeys = (e, inputIndex)=>{
        if (props.disabled) return;
        if (e.keyCode === $e1029e7003bdb3d4$var$BACKSPACE || e.key === "Backspace" || e.keyCode === $e1029e7003bdb3d4$var$DELETE || e.key === "Delete") {
            e.preventDefault();
            if (inputs[inputIndex].value.length > 0) {
                inputs[inputIndex].value = "";
                setInputs([
                    ...inputs
                ]);
            } else if (inputIndex > 0) {
                const previousInput = inputs[inputIndex - 1];
                if (previousInput.value.length > 0) {
                    inputs[inputIndex - 1].value = "";
                    setInputs([
                        ...inputs
                    ]);
                    setFocusInputId(inputs[inputIndex - 1].id);
                }
            }
        }
    };
    const handleOnChange = (e, inputIndex)=>{
        if (props.disabled) return;
        const { value: value } = e.target;
        const sanitazedValue = value.replace(/[^0-9]/g, "");
        let nextFocusId = inputs[inputIndex].id;
        if (value.length === 0 && sanitazedValue.length === 0) {
            const prevInputIndex = inputIndex - 1;
            if (prevInputIndex >= 0) nextFocusId = inputs[prevInputIndex].id;
            inputs[inputIndex].value = sanitazedValue;
        } else if (sanitazedValue.length === 1) {
            const nextInputIndex = inputIndex + 1;
            if (nextInputIndex < inputs.length) nextFocusId = inputs[nextInputIndex].id;
            inputs[inputIndex].value = sanitazedValue;
        } else if (sanitazedValue.length > 1) {
            let inputIndexInLoop = inputIndex;
            for(; inputIndexInLoop < Math.min(length, sanitazedValue.length + inputIndex); inputIndexInLoop++)inputs[inputIndexInLoop].value = sanitazedValue[inputIndexInLoop - inputIndex];
            nextFocusId = inputs[Math.min(length - 1, inputIndexInLoop)].id;
        }
        setInputs([
            ...inputs
        ]);
        setFocusInputId(nextFocusId);
        if (focusInputId === nextFocusId) document.getElementById(focusInputId)?.focus({
            preventScroll: true
        });
        if (onOtpChange) {
            const otp = inputs.map((input)=>input.value).join("");
            onOtpChange(otp);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($e1029e7003bdb3d4$var$Container, {
        className: className,
        dir: "ltr",
        children: inputs.map((input, index)=>/*#__PURE__*/ (0, $4m918.jsx)($e1029e7003bdb3d4$var$NumberInput, {
                value: input.value,
                id: input.id,
                onChange: (event)=>handleOnChange(event, index),
                onKeyDown: (event)=>handleRemoveKeys(event, index),
                disabled: props.disabled
            }, index))
    });
});
const $e1029e7003bdb3d4$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
`;
const $e1029e7003bdb3d4$var$NumberInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  padding-left: 1px;
  padding-right: 1px;

  input {
    width: 34px;
    text-align: center;
    opacity: ${(props)=>props.disabled ? "0" : "1"};
  }

  margin-left: 5px;
  margin-right: 5px;
`;

});


parcelRegister("jNOeu", function(module, exports) {

$parcel$export(module.exports, "ResultView", function () { return $5f87270fe81c8655$export$7e5333f99680078; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $gDlNU = parcelRequire("gDlNU");

var $7Zu6k = parcelRequire("7Zu6k");

var $k0Hih = parcelRequire("k0Hih");

var $jn1mK = parcelRequire("jn1mK");

var $8RlWY = parcelRequire("8RlWY");

var $22v9q = parcelRequire("22v9q");
const $5f87270fe81c8655$export$7e5333f99680078 = (props)=>{
    const { type: type, title: title, onConfirm: onConfirm, subtitle: subtitle, description: description, error: error } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($5f87270fe81c8655$var$Container, {
        children: [
            type === "success" ? /*#__PURE__*/ (0, $4m918.jsx)((0, $8RlWY.SuccessCircle), {
                theme: "shallow"
            }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $k0Hih.ErrorCircle), {
                theme: "shallow"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($5f87270fe81c8655$var$Title, {
                children: title
            }),
            (0, $gDlNU.isDefined)(subtitle) && /*#__PURE__*/ (0, $4m918.jsx)($5f87270fe81c8655$var$Subtitle, {
                children: subtitle
            }),
            (0, $gDlNU.isDefined)(description) && /*#__PURE__*/ (0, $4m918.jsx)($5f87270fe81c8655$var$Description, {
                children: description
            }),
            (0, $gDlNU.isDefined)(error) && /*#__PURE__*/ (0, $4m918.jsx)($5f87270fe81c8655$var$StyledErrorMessage, {
                children: error
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($5f87270fe81c8655$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($5f87270fe81c8655$var$CompleteButton, {
                    size: "S",
                    onClick: onConfirm,
                    children: formatMessage("resultScreen.done")
                })
            })
        ]
    });
};
const $5f87270fe81c8655$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 28px;
  flex: 1;
`;
const $5f87270fe81c8655$var$Title = (0, $jb8NR.default).div`
  text-align: center;
  font-size: 1.375rem;
  ${(0, $22v9q.theme).boldText};
  padding-top: 30px;
  padding-bottom: 5px;
`;
const $5f87270fe81c8655$var$Subtitle = (0, $jb8NR.default).div`
  text-align: center;
  ${(0, $22v9q.theme).text};
  font-size: 1rem;
  padding-top: 5px;
`;
const $5f87270fe81c8655$var$Description = (0, $jb8NR.default).div`
  text-align: center;
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
  padding-top: 15px;
  color: #aaaaaa;
`;
const $5f87270fe81c8655$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0px 10px 0px;
`;
const $5f87270fe81c8655$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex: 1 0;
`;
const $5f87270fe81c8655$var$CompleteButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 30px;
  margin-bottom: 20px;
`;

});
parcelRegister("k0Hih", function(module, exports) {

$parcel$export(module.exports, "ErrorCircle", function () { return $57b106db9452a31a$export$19e0e85c173cf6ee; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $f5HsK = parcelRequire("f5HsK");

var $6cHy0 = parcelRequire("6cHy0");
const $57b106db9452a31a$export$19e0e85c173cf6ee = (props)=>/*#__PURE__*/ (0, $4m918.jsx)($57b106db9452a31a$var$RedCircle, {
        size: 116,
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $6cHy0.CrossIcon), {
            fill: props.theme === "shallow" ? "#ff4242" : "#ffffff"
        })
    });
const $57b106db9452a31a$var$RedCircle = (0, $jb8NR.default)((0, $f5HsK.Circle))`
  align-self: center;
  background-color: ${(props)=>props.theme === "shallow" ? "#ffffff" : "#ff4242"};
  box-shadow: 0 6px 44px 0 rgba(255, 66, 66, 0.5);
`;

});


parcelRegister("8wRZz", function(module, exports) {

$parcel$export(module.exports, "CreateCardCguStep", function () { return $28cb08061f22f2a6$export$962997ecf5edf279; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $k4Ecv = parcelRequire("k4Ecv");

var $7Zu6k = parcelRequire("7Zu6k");

var $ajNEj = parcelRequire("ajNEj");

var $kQgvS = parcelRequire("kQgvS");

var $22v9q = parcelRequire("22v9q");
const $28cb08061f22f2a6$export$962997ecf5edf279 = (props)=>{
    const { cgu: cgu, acceptCgu: acceptCgu } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [isCguAccepted, setCGUAccepted] = (0, $6uYXW.useState)(false);
    const [goToNextStep, loading] = (0, $k4Ecv.useAsyncOperation)(async ()=>{
        await acceptCgu();
    });
    return /*#__PURE__*/ (0, $4m918.jsxs)($28cb08061f22f2a6$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($28cb08061f22f2a6$var$CguTitle, {
                children: formatMessage("createCard.stepCgu.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $kQgvS.ScrollableDiv), {
                children: /*#__PURE__*/ (0, $4m918.jsx)($28cb08061f22f2a6$var$CguContainer, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)($28cb08061f22f2a6$var$CguInfo, {
                        children: cgu
                    })
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $ajNEj.SwitchContainer), {
                value: isCguAccepted,
                onSwitch: setCGUAccepted
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($28cb08061f22f2a6$var$AcceptCguLabel, {
                children: formatMessage("createCard.stepCgu.acceptMessage")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($28cb08061f22f2a6$var$ContinueButton, {
                size: "S",
                showSpinner: loading,
                disabled: !isCguAccepted,
                onClick: goToNextStep,
                children: formatMessage("createCard.stepCgu.next")
            })
        ]
    });
};
const $28cb08061f22f2a6$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 530px;
`;
const $28cb08061f22f2a6$var$CguTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  padding-bottom: 20px;
  font-size: 1.125rem;
  color: #000000;
`;
const $28cb08061f22f2a6$var$CguContainer = (0, $jb8NR.default).div`
  display: flex;
`;
const $28cb08061f22f2a6$var$CguInfo = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  padding-top: 30px;
  padding-bottom: 10px;
  font-size: 0.9375rem;
  white-space: pre-wrap;
  color: #000000;
`;
const $28cb08061f22f2a6$var$AcceptCguLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.75rem;
  color: #aaaaaa;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
`;
const $28cb08061f22f2a6$var$ContinueButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  align-self: center;
  margin-bottom: 20px;
`;

});

parcelRegister("dxm8d", function(module, exports) {

$parcel$export(module.exports, "CreateCardSelectionStep", function () { return $dcd2b770e3b91dd7$export$8fae50aef9d7a919; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $gDlNU = parcelRequire("gDlNU");

var $k4Ecv = parcelRequire("k4Ecv");

var $7Zu6k = parcelRequire("7Zu6k");

var $22v9q = parcelRequire("22v9q");

var $9PdBu = parcelRequire("9PdBu");

var $hpMu5 = parcelRequire("hpMu5");
const $dcd2b770e3b91dd7$export$8fae50aef9d7a919 = (props)=>{
    const { currentAccounts: currentAccounts, selectedAccount: selectedAccount, debitCardProducts: debitCardProducts, selectedProduct: selectedProduct, isVirtual: isVirtual, selectAccount: selectAccount, selectProduct: selectProduct, confirmSelection: confirmSelection } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [goNext, loading] = (0, $k4Ecv.useAsyncOperation)(async ()=>{
        await confirmSelection();
    });
    const isPhysical = !isVirtual;
    const disabled = !((0, $gDlNU.isDefined)(selectedAccount) && (0, $gDlNU.isDefined)(selectedProduct));
    return /*#__PURE__*/ (0, $4m918.jsxs)($dcd2b770e3b91dd7$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($dcd2b770e3b91dd7$var$SelectTitle, {
                children: formatMessage("createCard.stepSelection.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($dcd2b770e3b91dd7$var$SelectInstructions, {
                children: formatMessage(isPhysical ? "createCard.stepSelection.selectAccountMessage" : "createCard.stepSelection.selectVirtualCardMessage")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($dcd2b770e3b91dd7$var$SelectorContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $9PdBu.CreateCardSelector), {
                    values: currentAccounts,
                    selectedValue: selectedAccount,
                    getLabel: (account)=>formatMessage("createCard.stepSelection.accountLabel", {
                            id: account.id
                        }),
                    onChange: selectAccount
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($dcd2b770e3b91dd7$var$SelectInstructions, {
                children: formatMessage(isPhysical ? "createCard.stepSelection.selecProductMessage" : "createCard.stepSelection.selectProductForVirtualCardMessage")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($dcd2b770e3b91dd7$var$SelectorContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $9PdBu.CreateCardSelector), {
                    values: debitCardProducts,
                    selectedValue: selectedProduct,
                    getLabel: (product)=>product.name,
                    onChange: selectProduct
                })
            }),
            isVirtual && /*#__PURE__*/ (0, $4m918.jsx)((0, $hpMu5.VirtualCardDescrition), {}),
            /*#__PURE__*/ (0, $4m918.jsx)($dcd2b770e3b91dd7$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                    size: "S",
                    disabled: disabled,
                    onClick: goNext,
                    showSpinner: loading,
                    children: formatMessage(isVirtual ? "createCard.stepSelection.createVirtualCardButton" : "createCard.stepSelection.orderCardButton")
                })
            })
        ]
    });
};
const $dcd2b770e3b91dd7$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const $dcd2b770e3b91dd7$var$SelectTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  margin-bottom: 20px;
  font-size: 1.125rem;
  color: #000000;
`;
const $dcd2b770e3b91dd7$var$SelectInstructions = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.875rem;
  color: #aaaaaa;
`;
const $dcd2b770e3b91dd7$var$SelectorContainer = (0, $jb8NR.default).div`
  flex: 0;
  margin-top: 16px;
  margin-bottom: 20px;
`;
const $dcd2b770e3b91dd7$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
`;

});
parcelRegister("9PdBu", function(module, exports) {

$parcel$export(module.exports, "CreateCardSelector", function () { return $efaac7cb7edf8cc1$export$f66dbb08af063639; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $k10cE = parcelRequire("k10cE");

var $22v9q = parcelRequire("22v9q");

var $jfz5i = parcelRequire("jfz5i");
function $efaac7cb7edf8cc1$export$f66dbb08af063639(props) {
    const { values: values, selectedValue: selectedValue, onChange: onChange, getLabel: getLabel } = props;
    const [showDropdown, setShowDropdown] = (0, $6uYXW.useState)(false);
    const dropdownContentRef = (0, $6uYXW.useRef)(null);
    (0, $k10cE.useClickOutsideHandler)(dropdownContentRef, ()=>setShowDropdown(false));
    const safeValue = selectedValue ?? values[0];
    (0, $6uYXW.useEffect)(()=>{
        if (values.length > 0) onChange(safeValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $jfz5i.FilterDropdown), {
        onClick: (e)=>{
            if (e.target === e.currentTarget) setShowDropdown((show)=>!show);
        },
        children: [
            getLabel(safeValue),
            /*#__PURE__*/ (0, $4m918.jsx)($efaac7cb7edf8cc1$var$DropdownContent, {
                ref: dropdownContentRef,
                onClick: (e)=>{
                    e.stopPropagation();
                },
                $isVisible: showDropdown,
                children: values.map((each, index)=>/*#__PURE__*/ (0, $4m918.jsx)($efaac7cb7edf8cc1$var$PressableRow, {
                        onClick: ()=>{
                            onChange(each);
                            setShowDropdown(false);
                        },
                        children: getLabel(each)
                    }, index))
            })
        ]
    });
}
const $efaac7cb7edf8cc1$var$DropdownContent = (0, $jb8NR.default).div`
  display: ${(props)=>props.$isVisible ? "block" : "none"};
  overflow: hidden;
  text-align: start;
  position: absolute;
  top: 120%;
  left: 0px;
  background-color: #f4f4f4;
  border-radius: 10px;
  border: 1px solid #e2e2e2;
  z-index: 1;
  min-width: 100%;
  ${(0, $22v9q.shadows).medium};
  &:hover {
    cursor: auto;
  }
`;
const $efaac7cb7edf8cc1$var$PressableRow = (0, $jb8NR.default).div`
  padding: 5px 10px 5px 10px;
  &:focus,
  &:active,
  &:hover {
    background-color: #e2e2e2;
    cursor: pointer;
  }
`;

});
parcelRegister("jfz5i", function(module, exports) {

$parcel$export(module.exports, "FilterDropdown", function () { return $0ded345e9baf223e$export$d21937a90300cd7a; });

var $4m918 = parcelRequire("4m918");

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5P656 = parcelRequire("5P656");

var $8xKCH = parcelRequire("8xKCH");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $7yIx1 = parcelRequire("7yIx1");

var $1qA9R = parcelRequire("1qA9R");

var $h9xPH = parcelRequire("h9xPH");

var $ao7HR = parcelRequire("ao7HR");

var $b6V1s = parcelRequire("b6V1s");

var $jSdHh = parcelRequire("jSdHh");

var $g1DMc = parcelRequire("g1DMc");

var $cNsCW = parcelRequire("cNsCW");

var $3Ersk = parcelRequire("3Ersk");

var $k10cE = parcelRequire("k10cE");

var $j0Nhs = parcelRequire("j0Nhs");

var $dvzf7 = parcelRequire("dvzf7");

var $6evmn = parcelRequire("6evmn");

var $9mlIh = parcelRequire("9mlIh");

var $iqXYI = parcelRequire("iqXYI");

var $4O97W = parcelRequire("4O97W");

var $22v9q = parcelRequire("22v9q");
const $0ded345e9baf223e$export$d21937a90300cd7a = (props)=>{
    const { children: children, onClick: onClick, active: active, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$FilterButtonContainer, {
        ...rest,
        onClick: onClick,
        $active: active,
        children: [
            children,
            /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$ChevronDownIcon, {})
        ]
    });
};
const $0ded345e9baf223e$var$timeranges = [
    (0, $7yIx1.TimeRange).Quarter,
    (0, $7yIx1.TimeRange).Month,
    (0, $7yIx1.TimeRange).Week
];
const $0ded345e9baf223e$var$PressableRow = (0, $jb8NR.default).div`
  padding: 5px 10px 5px 10px;
  &:focus,
  &:active,
  &:hover {
    background-color: #e2e2e2;
    cursor: pointer;
  }
`;
const $0ded345e9baf223e$export$62fb82b940094116 = (props)=>{
    const dropdownContentRef = (0, $6uYXW.useRef)(null);
    (0, $k10cE.useClickOutsideHandler)(dropdownContentRef, ()=>setShowDropdown(false));
    const [showDropdown, setShowDropdown] = (0, $6uYXW.useState)(false);
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const timerangeSelection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).timeRangeSelection);
    const { startDate: startDate, endDate: endDate, onStartDateChange: onStartDateChange, onEndDateChange: onEndDateChange } = (0, $b6V1s.useTransactionDateFilter)();
    const hasDateCustomFilter = timerangeSelection.timeRange === (0, $7yIx1.TimeRange).Other;
    const [fromDate, toDate] = timerangeSelection.bounds;
    const dateFormatter = new Intl.DateTimeFormat(undefined, {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit"
    });
    const label = hasDateCustomFilter ? `${fromDate ? dateFormatter.format(fromDate.toDate()) : "--/--/----"} - ${toDate ? dateFormatter.format(toDate.toDate()) : "--/--/----"}` : formatMessage((0, $h9xPH.timeRangeLabel)[timerangeSelection.timeRange]);
    const applyCustomTimerange = ()=>{
        const { selectedStartDate: selectedStartDate, selectedEndDate: selectedEndDate } = (0, $cNsCW.arrangeDates)(startDate, endDate);
        (0, $kqXxS.transactionSearchManager).setTimeRange((0, $7yIx1.TimeRange).Other, [
            (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(selectedStartDate),
            (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(selectedEndDate)
        ]);
        setShowDropdown(false);
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$export$d21937a90300cd7a, {
        ...props,
        onClick: ()=>{
            setShowDropdown((show)=>!show);
        },
        active: timerangeSelection.timeRange !== (0, $7yIx1.TimeRange).Quarter,
        children: [
            label,
            /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$DropdownContent, {
                ref: dropdownContentRef,
                $isVisible: showDropdown,
                onClick: (e)=>e.stopPropagation(),
                children: [
                    $0ded345e9baf223e$var$timeranges.map((timerange)=>/*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$PressableRow, {
                            onClick: ()=>{
                                (0, $kqXxS.transactionSearchManager).setTimeRange(timerange);
                                setShowDropdown(false);
                            },
                            children: formatMessage((0, $h9xPH.timeRangeLabel)[timerange])
                        }, timerange)),
                    /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$Panel, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$CustomDateTitle, {
                                children: formatMessage("transactionFilter.timeRangeSelectionTitle")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$Row, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$Column, {
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$DateContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$DateCaption, {
                                                        children: formatMessage("transactionFilter.timeRange.from")
                                                    }),
                                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$StyledDateInput, {
                                                        mode: "date",
                                                        withoutTheme: true,
                                                        onChange: (e)=>{
                                                            const date = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(e.target.value);
                                                            if (date.isValid()) onStartDateChange(date.toDate(), true);
                                                        },
                                                        value: startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(startDate).format("YYYY-MM-DD") : ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$DateContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$DateCaption, {
                                                        children: formatMessage("transactionFilter.timeRange.to")
                                                    }),
                                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$StyledDateInput, {
                                                        mode: "date",
                                                        withoutTheme: true,
                                                        onChange: (e)=>{
                                                            const date = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(e.target.value);
                                                            if (date.isValid()) onEndDateChange(date.endOf("day").toDate(), false, true);
                                                        },
                                                        value: endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(endDate).format("YYYY-MM-DD") : ""
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$CheckContainer, {
                                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $j0Nhs.RoundActionButton), {
                                            size: 30,
                                            onClick: applyCustomTimerange,
                                            children: /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$SmallCheckIcon, {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $0ded345e9baf223e$export$e36162fbdc06cfcc = (props)=>{
    const { account: account, ...rest } = props;
    const [showDropdown, setShowDropdown] = (0, $6uYXW.useState)(false);
    const dropdownContentRef = (0, $6uYXW.useRef)(null);
    (0, $k10cE.useClickOutsideHandler)(dropdownContentRef, ()=>setShowDropdown(false));
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { formattedAmountRange: formattedAmountRange, hasAmountFilter: hasAmountFilter } = (0, $b6V1s.useFormattedAmountRange)(account);
    return /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$export$d21937a90300cd7a, {
        ...rest,
        onClick: (e)=>{
            if (e.target === e.currentTarget) setShowDropdown((show)=>!show);
        },
        active: hasAmountFilter,
        children: [
            hasAmountFilter ? formattedAmountRange : formatMessage("transactionFilter.allAmountRange"),
            /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$DropdownContent, {
                ref: dropdownContentRef,
                onClick: (e)=>{
                    e.stopPropagation();
                },
                $isVisible: showDropdown,
                children: account && /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$AmountSelection, {
                    account: account,
                    onSubmit: ()=>setShowDropdown(false)
                })
            })
        ]
    });
};
const $0ded345e9baf223e$var$AmountSelection = (props)=>{
    const { account: account, onSubmit: onSubmit } = props;
    const currency = (0, $kGswT.getSettlementBalance)(account).currencyAlpha ? (0, $kGswT.getSettlementBalance)(account).currencyAlpha : (0, $kGswT.getSettlementBalance)(account).currency;
    const [initialLow, initialHigh] = (0, $kqXxS.transactionSearchManager).amountRange.get();
    const [lowTextValue, setLowTextValue] = (0, $6uYXW.useState)(initialLow ? initialLow.toString() : "");
    const [highTextValue, setHighTextValue] = (0, $6uYXW.useState)(initialHigh ? initialHigh.toString() : "");
    const { formatAmount: formatAmount, formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const applyAmountFilter = ()=>{
        const lowValue = Number.parseFloat(lowTextValue);
        const highValue = Number.parseFloat(highTextValue);
        (0, $kqXxS.transactionSearchManager).setAmountRange(Number.isNaN(lowValue) ? null : lowValue, Number.isNaN(highValue) || highValue === 0 ? null : highValue);
        onSubmit();
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$AmountSelectionContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$CustomDateTitle, {
                children: formatMessage("transactionFilter.amountRangeSelectionTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$Row, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$Column, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$AmountInputContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$AmountInputCaption, {
                                        children: formatMessage("transactionFilter.amountRange.min")
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$StyledAmountInput, {
                                        value: lowTextValue,
                                        placeholder: formatAmount(new (0, $5P656.Amount)(0, currency)),
                                        onChange: (e)=>{
                                            const safeValue = (0, $5P656.sanitizeAmountValue)(e.target.value, (0, $8xKCH.Currencies)[currency].decimal_number);
                                            setLowTextValue(safeValue);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$var$AmountInputContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$AmountInputCaption, {
                                        children: formatMessage("transactionFilter.amountRange.max")
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$StyledAmountInput, {
                                        value: highTextValue,
                                        placeholder: formatAmount(new (0, $5P656.Amount)(0, currency)),
                                        onChange: (e)=>{
                                            const safeValue = (0, $5P656.sanitizeAmountValue)(e.target.value, (0, $8xKCH.Currencies)[currency].decimal_number);
                                            setHighTextValue(safeValue);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$CheckContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $j0Nhs.RoundActionButton), {
                            size: 30,
                            onClick: applyAmountFilter,
                            children: /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$SmallCheckIcon, {})
                        })
                    })
                ]
            })
        ]
    });
};
const $0ded345e9baf223e$export$340ad9e67302a635 = (props)=>{
    const [showDropdown, setShowDropdown] = (0, $6uYXW.useState)(false);
    const dropdownContentRef = (0, $6uYXW.useRef)(null);
    (0, $k10cE.useClickOutsideHandler)(dropdownContentRef, ()=>setShowDropdown(false));
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const currentDirection = (0, $3Ersk.useObservable)((0, $kqXxS.transactionSearchManager).directionSelection);
    return /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$export$d21937a90300cd7a, {
        ...props,
        onClick: (e)=>{
            if (e.target === e.currentTarget) setShowDropdown((show)=>!show);
        },
        active: currentDirection !== (0, $ao7HR.TransactionDirection).ALL,
        children: [
            formatMessage((0, $1qA9R.transactionDirectionLabels)[currentDirection]),
            /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$DropdownContent, {
                ref: dropdownContentRef,
                onClick: (e)=>{
                    e.stopPropagation();
                },
                $isVisible: showDropdown,
                children: [
                    (0, $ao7HR.TransactionDirection).ALL,
                    (0, $ao7HR.TransactionDirection).OUTCOME,
                    (0, $ao7HR.TransactionDirection).INCOME
                ].map((direction)=>/*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$PressableRow, {
                        onClick: ()=>{
                            (0, $kqXxS.transactionSearchManager).setTransactionDirection(direction);
                            setShowDropdown(false);
                        },
                        children: formatMessage((0, $1qA9R.transactionDirectionLabels)[direction])
                    }, direction))
            })
        ]
    });
};
const $0ded345e9baf223e$export$19681628866a4fe1 = (props)=>{
    const [showDropdown, setShowDropdown] = (0, $6uYXW.useState)(false);
    const dropdownContentRef = (0, $6uYXW.useRef)(null);
    (0, $k10cE.useClickOutsideHandler)(dropdownContentRef, ()=>setShowDropdown(false));
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const currentStatus = (0, $3Ersk.useObservable)((0, $kqXxS.cardFilterManager).statusSelection);
    return /*#__PURE__*/ (0, $4m918.jsxs)($0ded345e9baf223e$export$d21937a90300cd7a, {
        ...props,
        onClick: (e)=>{
            if (e.target === e.currentTarget) setShowDropdown((show)=>!show);
        },
        active: currentStatus !== (0, $jSdHh.CardStatus).ALL,
        children: [
            formatMessage((0, $g1DMc.cardStatusLabels)[currentStatus]),
            /*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$DropdownContent, {
                ref: dropdownContentRef,
                onClick: (e)=>{
                    e.stopPropagation();
                },
                $isVisible: showDropdown,
                children: [
                    (0, $jSdHh.CardStatus).NEW,
                    (0, $jSdHh.CardStatus).PENDING,
                    (0, $jSdHh.CardStatus).ACTIVE,
                    (0, $jSdHh.CardStatus).BLOCKED,
                    (0, $jSdHh.CardStatus).OPPOSED
                ].map((status)=>/*#__PURE__*/ (0, $4m918.jsx)($0ded345e9baf223e$var$PressableRow, {
                        onClick: ()=>{
                            (0, $kqXxS.cardFilterManager).setStatusSelection(status);
                            setShowDropdown(false);
                        },
                        children: formatMessage((0, $g1DMc.cardStatusLabels)[status])
                    }, status))
            })
        ]
    });
};
const $0ded345e9baf223e$var$AmountInputCaption = (0, $jb8NR.default).div`
  display: flex;
  flex: 1 1 auto;
  ${(0, $22v9q.theme).text};
`;
const $0ded345e9baf223e$var$AmountInputContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;
const $0ded345e9baf223e$var$AmountSelectionContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
`;
const $0ded345e9baf223e$var$StyledAmountInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  padding: 0px;
  margin-left: 10px;
  margin-right: 10px;
  ${(0, $9mlIh.Input)} {
    width: 80px;
  }
`;
const $0ded345e9baf223e$var$DropdownContent = (0, $jb8NR.default).div`
  display: ${(props)=>props.$isVisible ? "block" : "none"};
  overflow: hidden;
  text-align: start;
  position: absolute;
  top: 120%;
  left: 0px;
  background-color: #f4f4f4;
  border-radius: 10px;
  z-index: 1;
  min-width: 100%;
  &:hover {
    cursor: auto;
  }
`;
const $0ded345e9baf223e$var$Panel = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding: 10px 5px;
  margin: 5px;
  border-radius: 10px;
  background-color: #ffffff;
`;
const $0ded345e9baf223e$var$Column = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $0ded345e9baf223e$var$CheckContainer = (0, $jb8NR.default)($0ded345e9baf223e$var$Column)`
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  margin-right: 10px;
`;
const $0ded345e9baf223e$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
`;
const $0ded345e9baf223e$var$CustomDateTitle = (0, $jb8NR.default).div`
  margin-bottom: 10px;
`;
const $0ded345e9baf223e$var$DateCaption = (0, $jb8NR.default).div`
  flex-shrink: 0;
  margin-right: 5px;
  ${(0, $22v9q.theme).text}
`;
const $0ded345e9baf223e$var$DateContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;
const $0ded345e9baf223e$var$FilterButtonContainer = (0, $jb8NR.default)((0, $dvzf7.TertiaryDiv))`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: ${(props)=>props.$active ? "#e4e4e4" : "#f4f4f4"};
  &:hover {
    cursor: pointer;
  }
`;
const $0ded345e9baf223e$var$ChevronDownIcon = (0, $jb8NR.default)((0, $4O97W.ChevronDown))`
  margin-left: 6px;
  margin-right: 6px;
  pointer-events: none;
  width: 15px;
`;
const $0ded345e9baf223e$var$SmallCheckIcon = (0, $jb8NR.default)((0, $iqXYI.CheckIcon))`
  width: 14px;
  height: 14px;
`;
const $0ded345e9baf223e$var$StyledDateInput = (0, $jb8NR.default)((0, $6evmn.DateInput))`
  min-width: 120px;
  background-color: #f4f4f4;
`;

});
parcelRegister("1qA9R", function(module, exports) {

$parcel$export(module.exports, "transactionDirectionLabels", function () { return $c8e9b3abbe702fca$export$2e21e0c059d987b3; });

var $ao7HR = parcelRequire("ao7HR");
const $c8e9b3abbe702fca$export$2e21e0c059d987b3 = {
    [(0, $ao7HR.TransactionDirection).ALL]: "transactionFilter.all",
    [(0, $ao7HR.TransactionDirection).INCOME]: "transactionFilter.credit",
    [(0, $ao7HR.TransactionDirection).OUTCOME]: "transactionFilter.debit"
};

});

parcelRegister("h9xPH", function(module, exports) {

$parcel$export(module.exports, "timeRangeLabel", function () { return $4c18f3a001cf800f$export$2168f5e111e02aa9; });

var $7yIx1 = parcelRequire("7yIx1");
const $4c18f3a001cf800f$export$2168f5e111e02aa9 = {
    [(0, $7yIx1.TimeRange).Month]: "transactionFilter.timeRange.month",
    [(0, $7yIx1.TimeRange).Week]: "transactionFilter.timeRange.week",
    [(0, $7yIx1.TimeRange).Quarter]: "transactionFilter.timeRange.quarter",
    [(0, $7yIx1.TimeRange).Other]: "undefined"
};

});



parcelRegister("hpMu5", function(module, exports) {

$parcel$export(module.exports, "VirtualCardDescrition", function () { return $f5e9c261bd3d2afd$export$bdd019114d642531; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $22v9q = parcelRequire("22v9q");
const $f5e9c261bd3d2afd$export$bdd019114d642531 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($f5e9c261bd3d2afd$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f5e9c261bd3d2afd$var$DescriptionTitle, {
                children: formatMessage("createCard.stepSelection.virtualCardTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f5e9c261bd3d2afd$var$DescriptionText, {
                children: formatMessage("createCard.stepSelection.virtualCardDescription")
            })
        ]
    });
};
const $f5e9c261bd3d2afd$var$Container = (0, $jb8NR.default).div`
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  background-color: ${(0, $22v9q.theme).colors.gray[200]};
`;
const $f5e9c261bd3d2afd$var$DescriptionTitle = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).bodyBlackBold}
  margin: 0;
`;
const $f5e9c261bd3d2afd$var$DescriptionText = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).bodyGreyDarkRegular}
  margin: 10px 0 0;
`;

});




parcelRegister("2AJ6K", function(module, exports) {

$parcel$export(module.exports, "CardSensitiveDetails", function () { return $7263dd44bd3ad33d$export$158a924061374be3; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $jKRLO = parcelRequire("jKRLO");

var $e4wja = parcelRequire("e4wja");

var $k4Ecv = parcelRequire("k4Ecv");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $k4kME = parcelRequire("k4kME");

var $8Mjlc = parcelRequire("8Mjlc");

var $jNOeu = parcelRequire("jNOeu");
const $7263dd44bd3ad33d$export$158a924061374be3 = (props)=>{
    const { card: card, onCompleted: onCompleted } = props;
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)("");
    const { client: client } = (0, $7N0kU.useClient)();
    const { loading: loading, error: error, scaToken: scaToken, step: step, getSensitiveCardDetails: getSensitiveCardDetails } = (0, $jKRLO.useCardSensitiveDetails)();
    const handleOTPValidation = async (otp, scaToken)=>{
        if (scaToken) try {
            const response = await (0, $kqXxS.authenticationsSessionsService).verifyAuthentication(scaToken, otp);
            if (response.status === "DONE" && card) await handleGetSensitiveCardDetails(card, scaToken);
        } catch (e) {
            setErrorMessage(e.response?.data?.error?.message || e.toString());
        }
        else throw new Error("Missing SCA Token");
    };
    const handleGetSensitiveCardDetails = (0, $6uYXW.useCallback)(async (cardToUse, scaSessionToken)=>{
        try {
            const response = await getSensitiveCardDetails(cardToUse, scaSessionToken);
            if (response) onCompleted(response);
        } catch (e) {
            setErrorMessage(e.response?.data?.error?.message || e.toString());
        }
    }, [
        getSensitiveCardDetails
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (step === (0, $jKRLO.CardSensitiveDetailsStep).Init && card) await handleGetSensitiveCardDetails(card);
        else if (step === (0, $jKRLO.CardSensitiveDetailsStep).Success) closeModal();
    }, [
        step
    ]);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const closeModal = (0, $6uYXW.useCallback)(()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_SENSITIVE_DETAILS_MODAL_ID)), []);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CARD_SENSITIVE_DETAILS_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)($7263dd44bd3ad33d$var$StyledModalContainer, {
            children: [
                step === (0, $jKRLO.CardSensitiveDetailsStep).Init && /*#__PURE__*/ (0, $4m918.jsx)($7263dd44bd3ad33d$var$StyledBlueSpinner, {}),
                step === (0, $jKRLO.CardSensitiveDetailsStep).SCACheck && /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: (otp)=>handleOTPValidation(otp, scaToken),
                    errorMessage: errorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: loading
                }),
                step === (0, $jKRLO.CardSensitiveDetailsStep).Error && /*#__PURE__*/ (0, $4m918.jsx)($7263dd44bd3ad33d$var$StyledResultView, {
                    type: "error",
                    title: formatMessage("resultScreen.sensitiveDetails.failureTitle"),
                    subtitle: formatMessage("resultScreen.sensitiveDetails.failureSubtitle"),
                    description: formatMessage("resultScreen.sensitiveDetails.failureDescription"),
                    error: error,
                    onConfirm: ()=>{
                        closeModal();
                    }
                })
            ]
        })
    });
};
const $7263dd44bd3ad33d$var$StyledResultView = (0, $jb8NR.default)((0, $jNOeu.ResultView))`
  margin-left: 20px;
  margin-right: 20px;
`;
const $7263dd44bd3ad33d$var$StyledModalContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;
const $7263dd44bd3ad33d$var$StyledBlueSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))``;

});
parcelRegister("jKRLO", function(module, exports) {

$parcel$export(module.exports, "CardSensitiveDetailsStep", function () { return $c7d0e94eb8537e92$export$2ff131d989d0aa63; });
$parcel$export(module.exports, "useCardSensitiveDetails", function () { return $c7d0e94eb8537e92$export$2ff4f77fcf0497f2; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");
var $c7d0e94eb8537e92$export$2ff131d989d0aa63 = /*#__PURE__*/ function(CardSensitiveDetailsStep) {
    CardSensitiveDetailsStep["Init"] = "INIT";
    CardSensitiveDetailsStep["Confirm"] = "CONFIRM";
    CardSensitiveDetailsStep["Success"] = "SUCCESS";
    CardSensitiveDetailsStep["Error"] = "ERROR";
    CardSensitiveDetailsStep["SCACheck"] = "SCA_CHECK";
    return CardSensitiveDetailsStep;
}({});
const $c7d0e94eb8537e92$export$2ff4f77fcf0497f2 = ()=>{
    const [step, setStep] = (0, $6uYXW.useState)("INIT");
    const [scaToken, setScaToken] = (0, $6uYXW.useState)("");
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [sensitiveData, setSensitiveData] = (0, $6uYXW.useState)();
    const [card, setCard] = (0, $6uYXW.useState)(undefined);
    const [textError, setTextError] = (0, $6uYXW.useState)(undefined);
    const resetStep = ()=>{
        setStep("INIT");
    };
    const resetStepToConfirm = ()=>{
        setStep("CONFIRM");
    };
    const getSensitiveCardDetailsFlow = (0, $6uYXW.useCallback)(async (cardToUse, scaSessionToken)=>{
        try {
            setLoading(true);
            const data = await (0, $kqXxS.cardManager).getSensitiveCardDetails(cardToUse.id, scaSessionToken);
            setSensitiveData(data);
            setStep("SUCCESS");
            setLoading(false);
            return data;
        } catch (e) {
            const result = e;
            //SCA use case, must send and verify the given token
            if (result.response?.data?.error === "Unauthorized" && result.response?.data?.new_token) {
                setScaToken(result.response.data.new_token);
                setStep("SCA_CHECK");
                await (0, $kqXxS.authenticationsSessionsService).sendAuthentication(result.response.data.new_token);
                setLoading(false);
            } else {
                setLoading(false);
                setTextError(result.response?.data?.error?.message || result.toString());
                setStep("ERROR");
                throw e;
            }
        }
    }, [
        setStep,
        setTextError
    ]);
    const getSensitiveCardDetails = (0, $6uYXW.useCallback)(async (card, scaSessionToken)=>await getSensitiveCardDetailsFlow(card, scaSessionToken || ""), [
        getSensitiveCardDetailsFlow
    ]);
    return {
        step: step,
        loading: loading,
        card: card,
        sensitiveData: sensitiveData,
        scaToken: scaToken,
        error: textError,
        setCard: setCard,
        getSensitiveCardDetails: getSensitiveCardDetails,
        resetStep: resetStep,
        resetStepToConfirm: resetStepToConfirm
    };
};

});


parcelRegister("lQpdA", function(module, exports) {

$parcel$export(module.exports, "CardVisual", function () { return $ecb4bc29982ea814$export$688b560f8d4653c4; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3fNyH = parcelRequire("3fNyH");

var $k4Ecv = parcelRequire("k4Ecv");

var $bZlaH = parcelRequire("bZlaH");

var $22v9q = parcelRequire("22v9q");

var $8d7eD = parcelRequire("8d7eD");
function $ecb4bc29982ea814$export$688b560f8d4653c4({ card: card, balance: balance, sensitiveData: sensitiveData }) {
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const [cardImage, setCardImage] = (0, $6uYXW.useState)("");
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        setCardImage(await (0, $kqXxS.cardManager).getCardImage(card.id));
    }, [
        card.id
    ]);
    const { statusColor: statusColor, statusText: statusText } = (0, $8d7eD.getCardConfigurations)(card.status);
    const cardImageOverride = sensitiveData?.base64Image;
    const image = cardImageOverride || cardImage;
    // An active card needs no badge: the mockup keeps the artwork clean and the lock state is already
    // carried by the "Verrouillage temporaire" row underneath.
    const badgeText = card.virtual ? "card.virtual" : card.status !== (0, $3fNyH.CardStatus).Active ? statusText : undefined;
    // "Virtuelle" is a kind of card, not a status, so it keeps the neutral tone.
    const badgeColor = card.virtual ? (0, $22v9q.theme).colors.gray[700] : statusColor;
    const panDisplay = sensitiveData?.panDisplay || card.panDisplay;
    return /*#__PURE__*/ (0, $4m918.jsxs)($ecb4bc29982ea814$var$Frame, {
        children: [
            image ? /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$Artwork, {
                src: `data:image/png;base64,${image}`,
                alt: ""
            }) : /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$Skeleton, {}),
            !cardImageOverride && /*#__PURE__*/ (0, $4m918.jsxs)($ecb4bc29982ea814$var$DetailsPanel, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("div", {
                        children: !!balance && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$BalanceLabel, {
                                    children: formatMessage("cardsList.availableBalance")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$BalanceValue, {
                                    amount: balance
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                        children: [
                            !!card.embossedName && /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$HolderName, {
                                children: card.embossedName
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($ecb4bc29982ea814$var$MetaRow, {
                                children: [
                                    !!panDisplay && /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$Meta, {
                                        children: panDisplay
                                    }),
                                    !!card.expirationDate && /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$Meta, {
                                        children: formatDate(card.expirationDate, {
                                            month: "2-digit",
                                            year: "2-digit",
                                            timeZone: "UTC"
                                        })
                                    }),
                                    !!sensitiveData?.cvv && /*#__PURE__*/ (0, $4m918.jsxs)($ecb4bc29982ea814$var$Meta, {
                                        children: [
                                            formatMessage("cardsList.details.cvv"),
                                            " ",
                                            sensitiveData.cvv
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!badgeText && /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$Badge, {
                color: badgeColor,
                children: /*#__PURE__*/ (0, $4m918.jsx)($ecb4bc29982ea814$var$BadgeLabel, {
                    children: formatMessage(badgeText)
                })
            })
        ]
    });
}
/* The artwork is the card's own face, so the frame keeps a card's proportions rather than crop it. */ const $ecb4bc29982ea814$var$Frame = (0, $jb8NR.default).div`
  position: relative;
  width: 100%;
  aspect-ratio: 1.586;
  border-radius: 12px;
  overflow: hidden;
`;
const $ecb4bc29982ea814$var$Artwork = (0, $jb8NR.default).img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const $ecb4bc29982ea814$var$Skeleton = (0, $jb8NR.default).div`
  position: absolute;
  inset: 0;
  background-color: #e8e8e8;
`;
const $ecb4bc29982ea814$var$Badge = (0, $jb8NR.default).div`
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 3px 10px;
  border-radius: 10px;
  background-color: ${(props)=>props.color};
`;
const $ecb4bc29982ea814$var$BadgeLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 11px;
  color: #ffffff;
`;
const $ecb4bc29982ea814$var$DetailsPanel = (0, $jb8NR.default).div`
  position: absolute;
  inset: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  border-radius: 10px;

  /* The blur alone still averages out bright artwork, so a light scrim guarantees the contrast. */
  background-color: rgba(11, 41, 62, 0.2);
  backdrop-filter: blur(12px);
`;
const $ecb4bc29982ea814$var$BalanceLabel = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText};
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
`;
const $ecb4bc29982ea814$var$BalanceValue = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).blackText};
  margin-top: 2px;
  font-size: 33px;
  color: #ffffff;
`;
const $ecb4bc29982ea814$var$HolderName = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText};
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
`;
const $ecb4bc29982ea814$var$MetaRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  margin-top: 2px;
`;
const $ecb4bc29982ea814$var$Meta = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 12px;
  line-height: 15px;
  color: #ffffff;
`;

});
parcelRegister("8d7eD", function(module, exports) {

$parcel$export(module.exports, "getCardConfigurations", function () { return $e5968e1970b0afb4$export$db23af5f330a6d69; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $3fNyH = parcelRequire("3fNyH");

var $ePeIa = parcelRequire("ePeIa");

var $22v9q = parcelRequire("22v9q");
const $e5968e1970b0afb4$export$db23af5f330a6d69 = (cardStatus)=>{
    switch(cardStatus){
        case (0, $3fNyH.CardStatus).New:
            return {
                statusText: "card.status.new",
                statusColor: "#1c1dff"
            };
        case (0, $3fNyH.CardStatus).Pending:
            return {
                statusText: "card.status.pending",
                statusColor: "#1c1dff"
            };
        case (0, $3fNyH.CardStatus).Active:
            return {
                statusText: "card.status.active",
                statusColor: (0, $22v9q.theme).colors.success[500],
                cornerIcon: /*#__PURE__*/ (0, $4m918.jsx)($e5968e1970b0afb4$var$StyledPadlockUnlock, {})
            };
        case (0, $3fNyH.CardStatus).Blocked:
            return {
                statusText: "card.status.blocked",
                statusColor: "#ff6b21",
                cornerIcon: /*#__PURE__*/ (0, $4m918.jsx)($e5968e1970b0afb4$var$StyledPadlockLocked, {})
            };
        case (0, $3fNyH.CardStatus).Opposed:
            return {
                statusText: "card.status.opposed",
                statusColor: "#e61c1c"
            };
        case (0, $3fNyH.CardStatus).Expired:
            return {
                statusText: "card.status.expired",
                statusColor: "#aaaaaa"
            };
    }
    return {};
};
const $e5968e1970b0afb4$var$StyledPadlockUnlock = (0, $jb8NR.default)((0, $ePeIa.PadlockUnlock))`
  height: 16px;
  width: 16px;
  fill: white;
`;
const $e5968e1970b0afb4$var$StyledPadlockLocked = (0, $jb8NR.default)((0, $ePeIa.PadlockLocked))`
  height: 16px;
  width: 16px;
  fill: white;
`;

});
parcelRegister("ePeIa", function(module, exports) {

$parcel$export(module.exports, "PadlockUnlock", function () { return $c407bf3635a7cbea$export$549f0beeef0b960b; });
$parcel$export(module.exports, "PadlockLocked", function () { return $c407bf3635a7cbea$export$9b5d9564b6abe8a9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $c407bf3635a7cbea$export$549f0beeef0b960b(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M12.75 7.887c-.162-.162-.358-.243-.59-.243H5.794V4.876c0-.612.217-1.133.65-1.566.432-.433.954-.649 1.565-.649.612 0 1.134.216 1.566.649.433.433.649.955.649 1.566 0 .15.055.28.164.39.11.109.24.164.39.164h.553c.15 0 .28-.055.39-.165.11-.11.164-.24.164-.389 0-1.067-.38-1.98-1.138-2.738C9.988 1.379 9.076 1 8.008 1c-1.067 0-1.98.38-2.738 1.138-.759.758-1.138 1.67-1.138 2.738v2.768h-.277c-.23 0-.426.081-.588.243-.161.161-.242.357-.242.588v4.983c0 .231.08.427.242.589.162.161.358.242.588.242h8.306c.23 0 .427-.08.588-.242.161-.162.242-.358.242-.589V8.475c0-.23-.08-.427-.242-.588z"
        })
    });
}
function $c407bf3635a7cbea$export$9b5d9564b6abe8a9(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M12.166 7.644c.23 0 .427.081.589.243.161.161.242.357.242.588v4.983c0 .231-.081.427-.242.589-.162.161-.358.242-.589.242H3.857c-.23 0-.427-.08-.589-.242-.161-.162-.242-.358-.242-.589V8.475c0-.23.08-.427.242-.588.162-.162.358-.243.589-.243h.277V4.876c0-1.067.38-1.98 1.138-2.738C6.031 1.379 6.944 1 8.012 1h-.003.003c1.064 0 1.977.38 2.736 1.138.759.758 1.138 1.67 1.138 2.738v2.768zm-1.941-2.768c0-.612-.217-1.133-.65-1.566-.432-.432-.954-.648-1.564-.649-.612 0-1.133.217-1.566.649-.433.433-.65.954-.65 1.566v2.768h4.43V4.876z"
        })
    });
}

});



parcelRegister("kQZCH", function(module, exports) {

$parcel$export(module.exports, "AdditionalInfosSection", function () { return $9642532539f1a21d$export$af6c6082a5fd9577; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $3fNyH = parcelRequire("3fNyH");

var $gp5id = parcelRequire("gp5id");

var $gDlNU = parcelRequire("gDlNU");

var $yYT9n = parcelRequire("yYT9n");

var $bewhU = parcelRequire("bewhU");

var $1NWxv = parcelRequire("1NWxv");

var $22v9q = parcelRequire("22v9q");

var $8d7eD = parcelRequire("8d7eD");
function $9642532539f1a21d$export$af6c6082a5fd9577(props) {
    const { card: card, onClick: onClick, className: className } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    if (!(0, $gDlNU.isDefined)(card.pendingManagementOperation) && card.status != (0, $3fNyH.CardStatus).Opposed) return null;
    const pendingOperationMessage = (infos)=>{
        switch(infos?.operationType){
            case (0, $3fNyH.CardPendingOperationType).Refabrication:
                return formatMessage("card.pendingOperation.refabrication");
            case (0, $3fNyH.CardPendingOperationType).CodeReissuing:
                return formatMessage("card.pendingOperation.codeReissuing");
            case (0, $3fNyH.CardPendingOperationType).Opposition:
                return formatMessage("card.pendingOperation.opposition");
            case (0, $3fNyH.CardPendingOperationType).Blocking:
                return formatMessage("card.pendingOperation.blocking");
            case (0, $3fNyH.CardPendingOperationType).Unblocking:
                return formatMessage("card.pendingOperation.unblocking");
            case (0, $3fNyH.CardPendingOperationType).Activation:
                return formatMessage("card.pendingOperation.activation");
            case (0, $3fNyH.CardPendingOperationType).Creation:
                return formatMessage("card.pendingOperation.creation");
            case (0, $3fNyH.CardPendingOperationType).LimitsUpdate:
                return formatMessage("card.pendingOperation.limitsUpdate");
            case (0, $3fNyH.CardPendingOperationType).FeaturesUpdate:
                const feature = infos.featureId ? formatMessage((0, $gp5id.cardFeatures)[infos.featureId]) : undefined;
                return feature ? formatMessage("card.pendingOperation.featuresUpdate", {
                    feature: feature
                }) : formatMessage("card.pendingOperation.unknownFeatureUpdate");
        }
    };
    const { statusColor: statusColor } = (0, $8d7eD.getCardConfigurations)(card.status);
    return /*#__PURE__*/ (0, $4m918.jsx)($9642532539f1a21d$var$GlobalContainer, {
        className: className,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($9642532539f1a21d$var$LabelContainer, {
            $isRTL: isRTL,
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($9642532539f1a21d$var$Title, {
                    children: formatMessage("cardsList.infos.title")
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($9642532539f1a21d$var$InfosContainer, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($9642532539f1a21d$var$InfosLabel, {
                            children: card.status === (0, $3fNyH.CardStatus).Opposed ? formatMessage("cardOptions.cardOpposedMessage") : pendingOperationMessage(card.pendingManagementOperation)
                        }),
                        (0, $gDlNU.isDefined)(card.pendingManagementOperation) ? /*#__PURE__*/ (0, $4m918.jsx)($9642532539f1a21d$var$RefreshButton, {
                            onClick: onClick,
                            $isRTL: isRTL,
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $1NWxv.ResetIcon), {})
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($9642532539f1a21d$var$StatusDot, {
                    color: statusColor,
                    $isRTL: isRTL
                })
            ]
        })
    });
}
const $9642532539f1a21d$var$GlobalContainer = (0, $jb8NR.default).div`
  flex: 1;
  width: 100%;
`;
const $9642532539f1a21d$var$LabelContainer = (0, $jb8NR.default).div`
  flex: 1 0 auto;
  position: relative;
  flex-direction: column;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
  padding: ${(props)=>props.$isRTL ? "4px 20px 16px 48px" : "4px 48px 16px 20px"};
  ${(0, $22v9q.shadows).sm};
`;
const $9642532539f1a21d$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $9642532539f1a21d$var$InfosContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const $9642532539f1a21d$var$InfosLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 16px;
  line-height: 22px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $9642532539f1a21d$var$StatusDot = (0, $jb8NR.default).div`
  position: absolute;
  display: flex;
  top: 18px;
  right: ${(props)=>props.$isRTL ? "unset" : "16px"};
  left: ${(props)=>props.$isRTL ? "16px" : "unset"};
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: ${(props)=>props.color};
  opacity: 1;
`;
const $9642532539f1a21d$var$RefreshButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  left: ${(props)=>props.$isRTL ? 0 : 32}px;
  right: ${(props)=>props.$isRTL ? 32 : 0}px;
  top: 2px;
  height: 19px;
  width: 24px;
  svg {
    width: 19px;
    height: 24px;
    object-fit: contain;
    fill: #aaaaaa;
  }
`;

});
parcelRegister("gp5id", function(module, exports) {

$parcel$export(module.exports, "cardFeatures", function () { return $61db3d0e212dc42f$export$e005b46d577062d3; });
/** Label of every card feature the app knows how to name, shared by both platforms. */ 
var $3fNyH = parcelRequire("3fNyH");
const $61db3d0e212dc42f$export$e005b46d577062d3 = {
    [(0, $3fNyH.CardFeatureType).Nfc]: "card.feature.nfc",
    [(0, $3fNyH.CardFeatureType).CashOperation]: "card.feature.cashOperation",
    [(0, $3fNyH.CardFeatureType).ForeignPayment]: "card.feature.foreignPayment",
    [(0, $3fNyH.CardFeatureType).OnlinePayment]: "card.feature.onlinePayment",
    [(0, $3fNyH.CardFeatureType).EurWithdrawal]: "card.feature.eurWithdrawal",
    [(0, $3fNyH.CardFeatureType).ForeignWithdrawal]: "card.feature.foreignWithdrawal",
    [(0, $3fNyH.CardFeatureType).PaymentAuthorized]: "card.feature.paymentAuthorized",
    [(0, $3fNyH.CardFeatureType).EurPayment]: "card.feature.eurPayment",
    [(0, $3fNyH.CardFeatureType).ForeignAll]: "card.feature.foreignAll",
    [(0, $3fNyH.CardFeatureType).ForeignOnlinePayment]: "card.feature.foreignOnlinePayment"
};

});


parcelRegister("iNTcF", function(module, exports) {

$parcel$export(module.exports, "ActivationButton", function () { return $edc24398b297fe4b$export$877da4107b78035e; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $3fNyH = parcelRequire("3fNyH");

var $bQhUC = parcelRequire("bQhUC");

var $5Wai4 = parcelRequire("5Wai4");

var $fRvTz = parcelRequire("fRvTz");

var $aMHYD = parcelRequire("aMHYD");

var $jzlzv = parcelRequire("jzlzv");
const $edc24398b297fe4b$export$877da4107b78035e = ({ card: card, className: className, disabled: disabled })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const canActivate = (0, $6uYXW.useMemo)(()=>card.status === (0, $3fNyH.CardStatus).Pending, [
        card.status
    ]);
    if (!canActivate) return null;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aMHYD.ActionMenu), {
        title: formatMessage("cardOptions.activationCard.activateButton"),
        iconSrc: (0, $fRvTz.StaticAssets).cardActivate,
        disabled: disabled,
        className: className,
        onClick: ()=>{
            (0, $5Wai4.Modal).present((0, $bQhUC.CARD_ACTIVATION_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $jzlzv.CardActivationModal), {
                    card: card,
                    className: className
                }), {
                canBeDismissed: false
            });
        }
    });
};

});
parcelRegister("jzlzv", function(module, exports) {

$parcel$export(module.exports, "CardActivationModal", function () { return $63524d047ebeec99$export$6181f13aeb5b530f; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $61WqT = parcelRequire("61WqT");

var $irqL0 = parcelRequire("irqL0");

var $3Ersk = parcelRequire("3Ersk");

var $e4wja = parcelRequire("e4wja");

var $k4Ecv = parcelRequire("k4Ecv");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $7Zu6k = parcelRequire("7Zu6k");

var $9mlIh = parcelRequire("9mlIh");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $8Mjlc = parcelRequire("8Mjlc");

var $jNOeu = parcelRequire("jNOeu");

var $aZ9nc = parcelRequire("aZ9nc");
const $63524d047ebeec99$export$6181f13aeb5b530f = (props)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CARD_ACTIVATION_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$CardActivationView, {
            ...props
        })
    });
const $63524d047ebeec99$var$CardActivationView = (props)=>{
    const { card: selectedCard, className: className } = props;
    const { startActivationFlow: startActivationFlow, step: step, activationCode: activationCode, setActivationCode: setActivationCode, activateCard: activateCard, validatePincode: validatePincode, activationError: activationError, scaActivationToken: scaActivationToken, scaPincodeToken: scaPincodeToken } = (0, $irqL0.useCardActivation)();
    const { client: client } = (0, $7N0kU.useClient)();
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)("");
    const [scaIsLoading, setScaIsLoading] = (0, $6uYXW.useState)(false);
    const [pincode, setPincode] = (0, $6uYXW.useState)("");
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [inputError, setInputError] = (0, $6uYXW.useState)(null);
    const [buttonEnabled, setButtonEnabled] = (0, $6uYXW.useState)(false);
    const { loading: loading } = (0, $k4Ecv.useAsyncFunction)(async ()=>{
        await Promise.all([
            (0, $kqXxS.productManager).loadDebitCardProducts()
        ]);
        await startActivationFlow(selectedCard);
    }, []);
    const products = (0, $3Ersk.useObservable)((0, $kqXxS.productManager).debitCardProducts);
    const activationMessage = (0, $6uYXW.useMemo)(()=>{
        const cardProduct = products.find((p)=>p.id === selectedCard.productId);
        return cardProduct?.cardActivationProcess || formatMessage("cardOptions.activationCard.defaultActivationMessage");
    }, [
        formatMessage,
        products,
        selectedCard.productId
    ]);
    const pattern = (0, $6uYXW.useMemo)(()=>{
        const cardProduct = products.find((p)=>p.id === selectedCard.productId);
        return cardProduct?.cardActivationCodeValidationRegex;
    }, [
        selectedCard,
        products
    ]);
    const handleCodeChangeText = (text)=>{
        setActivationCode(text);
        if (pattern) setInputError(null);
        if (text.length == 0) setButtonEnabled(false);
    };
    const handleEndEditing = (text)=>{
        if (pattern) {
            let normalizedPattern = pattern;
            let options;
            const re = new RegExp("/(.+)/([i|g|m|u|x|s]*)");
            const matches = pattern.match(re);
            if (matches) {
                normalizedPattern = matches[1];
                if (matches.length > 2) options = matches[2];
            }
            const regex = new RegExp(normalizedPattern, options);
            const isValid = text.length > 0 && text.match(regex) != null;
            setInputError(isValid ? null : formatMessage("cardOptions.activationCard.inputError"));
            setButtonEnabled(isValid);
        } else setButtonEnabled(text.length > 0);
    };
    const handleOTPValidation = async (otp, scaToken, mode)=>{
        if (scaToken) try {
            setScaIsLoading(true);
            const response = await (0, $kqXxS.authenticationsSessionsService).verifyAuthentication(scaToken, otp);
            if (response.status === (0, $61WqT.VerifyAuthenticationStatus).DONE) {
                if (mode === "ACTIVATION") activateCard(selectedCard, activationCode, scaToken);
                else validatePincode(selectedCard, pincode, scaToken);
            }
        } catch (e) {
            setErrorMessage(e);
        } finally{
            setScaIsLoading(false);
        }
        else throw new Error("Missing SCA Token");
    };
    const innerStepComponent = ()=>{
        switch(step){
            case (0, $irqL0.CardActivationStep).ActivationCode:
                return /*#__PURE__*/ (0, $4m918.jsxs)($63524d047ebeec99$var$Container, {
                    className: className,
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$Title, {
                            children: formatMessage("cardOptions.activationCard.title")
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$MessageLabel, {
                            children: activationMessage
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$IdentifierLabel, {
                            children: formatMessage("cardOptions.activationCard.identifier")
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$StyledTextInput, {
                            autoFocus: true,
                            type: "text",
                            value: activationCode,
                            onChange: (event)=>handleCodeChangeText(event.target.value),
                            autoCapitalize: "none",
                            onBlur: ()=>handleEndEditing(activationCode),
                            hasError: !!inputError
                        }),
                        inputError && /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$ErrorMessage, {
                            children: inputError
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$ActivateCardButton, {
                            disabled: !buttonEnabled,
                            showSpinner: loading,
                            size: "S",
                            onClick: ()=>!loading && activateCard(selectedCard, activationCode),
                            children: formatMessage("cardOptions.activationCard.next")
                        })
                    ]
                });
            case (0, $irqL0.CardActivationStep).DefinePincode:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $aZ9nc.SetCardPincode), {
                    updatePincode: setPincode,
                    validatePincode: (pincode)=>validatePincode(selectedCard, pincode),
                    title: formatMessage("cardOptions.activationCard.stepPincode.title"),
                    instructionsText: formatMessage("cardOptions.activationCard.stepPincode.definePincodeMessage"),
                    confirmationText: formatMessage("cardOptions.activationCard.stepPincode.confirmPincodeMessage"),
                    validateButtonTitle: formatMessage("cardOptions.activationCard.confirm")
                });
            case (0, $irqL0.CardActivationStep).SCAActivationCheck:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: (otp)=>handleOTPValidation(otp, scaActivationToken, "ACTIVATION"),
                    errorMessage: errorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: scaIsLoading
                });
            case (0, $irqL0.CardActivationStep).SCAPincodeCheck:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: (otp)=>handleOTPValidation(otp, scaPincodeToken, "PINCODE"),
                    errorMessage: errorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: scaIsLoading
                });
            case (0, $irqL0.CardActivationStep).Error:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $jNOeu.ResultView), {
                    type: "error",
                    title: formatMessage("resultScreen.activateCard.failureTitle"),
                    subtitle: formatMessage("resultScreen.activateCard.failureSubtitle"),
                    description: formatMessage("resultScreen.activateCard.failureDescription"),
                    error: activationError,
                    onConfirm: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_ACTIVATION_MODAL_ID))
                });
            case (0, $irqL0.CardActivationStep).Success:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $jNOeu.ResultView), {
                    type: "success",
                    title: formatMessage("resultScreen.activateCard.successTitle"),
                    subtitle: formatMessage("resultScreen.activateCard.successSubtitle"),
                    onConfirm: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_ACTIVATION_MODAL_ID))
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$ModalContainer, {
        children: loading ? /*#__PURE__*/ (0, $4m918.jsx)($63524d047ebeec99$var$StyledSpinner, {}) : innerStepComponent()
    });
};
const $63524d047ebeec99$var$ModalContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  width: 100%;
  height: 400px;
`;
const $63524d047ebeec99$var$StyledSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: auto;
`;
const $63524d047ebeec99$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  background-color: #fafafa;
  padding: 20px;
`;
const $63524d047ebeec99$var$MessageLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  text-align: center;
  font-size: 0.875rem;
  color: #b1b1b1;
  margin-bottom: 56px;
`;
const $63524d047ebeec99$var$IdentifierLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  margin-bottom: 8px;
  font-size: 0.9375rem;
  color: #000000;
`;
const $63524d047ebeec99$var$ActivateCardButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  position: absolute;
  bottom: 40px;
  align-self: center;
`;
const $63524d047ebeec99$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  text-align: center;
  font-size: 1.375rem;
  color: black;
  margin-top: 10px;
  margin-bottom: 12px;
`;
const $63524d047ebeec99$var$StyledTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  margin-bottom: ${(props)=>props.hasError ? 8 : 32}px;
`;
const $63524d047ebeec99$var$ErrorMessage = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.813rem;
  color: #ff4646;
`;

});
parcelRegister("irqL0", function(module, exports) {

$parcel$export(module.exports, "CardActivationStep", function () { return $a594c2f7975843f4$export$5091a9c319c7ad3a; });
$parcel$export(module.exports, "useCardActivation", function () { return $a594c2f7975843f4$export$2ecc75e5550751e4; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $il8Zm = parcelRequire("il8Zm");

var $1qf9N = parcelRequire("1qf9N");
var $a594c2f7975843f4$export$5091a9c319c7ad3a = /*#__PURE__*/ function(CardActivationStep) {
    CardActivationStep["ActivationCode"] = "ACTIVATION_CODE";
    CardActivationStep["DefinePincode"] = "DEFINE_PINCODE";
    CardActivationStep["Success"] = "CARD_ACTIVATION_SUCCESS";
    CardActivationStep["Error"] = "CARD_ACTIVATION_ERROR";
    CardActivationStep["SCAActivationCheck"] = "SCA_ACTIVATION_CHECK";
    CardActivationStep["SCAPincodeCheck"] = "SCA_PINCODE_CHECK";
    return CardActivationStep;
}({});
const $a594c2f7975843f4$export$2ecc75e5550751e4 = ()=>{
    const [step, setStep] = (0, $6uYXW.useState)(undefined);
    const [scaActivationToken, setScaActivationToken] = (0, $6uYXW.useState)("");
    const [scaPincodeToken, setScaPincodeToken] = (0, $6uYXW.useState)("");
    const [activationCode, setActivationCode] = (0, $6uYXW.useState)("");
    const [activationError, setActivationError] = (0, $6uYXW.useState)(undefined);
    const debitCardProducts = (0, $3Ersk.useObservable)((0, $kqXxS.productManager).debitCardProducts);
    const resetStepToActivation = ()=>{
        setStep("ACTIVATION_CODE");
    };
    const resetStepToPincode = ()=>{
        setStep("DEFINE_PINCODE");
    };
    const productForCard = (0, $6uYXW.useCallback)((selectedCard)=>{
        const cardProcess = debitCardProducts.filter((product)=>product.id === selectedCard.productId);
        if (cardProcess.length == 0) throw new Error("missing card product information");
        return cardProcess[0];
    }, [
        debitCardProducts
    ]);
    const activateCard = (0, $6uYXW.useCallback)(async (cardToActivate, activationCodeInput, scaSessionToken)=>{
        try {
            if (!(0, $gDlNU.isDefined)(cardToActivate)) throw new Error("missing card");
            const productCard = productForCard(cardToActivate);
            if (productCard.cardActivationMode === (0, $il8Zm.ProductCardActivationMode).withCode) {
                if (!(0, $gDlNU.isDefined)(activationCodeInput) || activationCodeInput.length == 0) throw new Error("missing activation code");
            }
            setActivationError(undefined);
            await (0, $kqXxS.cardManager).activate(cardToActivate.id, activationCodeInput, scaSessionToken);
            setStep(getStepFromCardCreationProcess(productCard.cardCreationProcess));
        } catch (e) {
            //SCA use case, must send and verify the given token
            if (e.response?.data?.error === "Unauthorized" && e.response?.data?.new_token) {
                setScaActivationToken(e.response.data.new_token);
                setStep("SCA_ACTIVATION_CHECK");
                (0, $kqXxS.authenticationsSessionsService).sendAuthentication(e.response.data.new_token);
            } else {
                setActivationError(e.response?.data?.error?.message || e.toString());
                setStep("CARD_ACTIVATION_ERROR");
            }
        }
    }, [
        productForCard
    ]);
    const startActivationFlow = (0, $6uYXW.useCallback)(async (cardToActivate)=>{
        const productCard = productForCard(cardToActivate);
        if (productCard.cardActivationMode === (0, $il8Zm.ProductCardActivationMode).withCode) setStep("ACTIVATION_CODE");
        else await activateCard(cardToActivate);
    }, [
        setStep
    ]);
    const reissuePincodeOnCard = (0, $6uYXW.useCallback)(async (cardToUse, newPincode, scaToken)=>{
        try {
            if (!(0, $gDlNU.isDefined)(activationCode)) throw new Error("missing activation code");
            setActivationError(undefined);
            await (0, $kqXxS.cardManager).reissuePincode(cardToUse.id, newPincode, (0, $1qf9N.CREATE_PINCODE), scaToken || "");
            setStep("CARD_ACTIVATION_SUCCESS");
        } catch (e) {
            if (e.response?.data?.error === "Unauthorized" && e.response?.data?.new_token) {
                setScaPincodeToken(e.response.data.new_token);
                setStep("SCA_PINCODE_CHECK");
                (0, $kqXxS.authenticationsSessionsService).sendAuthentication(e.response.data.new_token);
            } else {
                setActivationError(e.response?.data?.error?.message || e.toString());
                setStep("CARD_ACTIVATION_ERROR");
            }
        }
    }, [
        setStep,
        setActivationError
    ]);
    const validatePincodeOnCard = (0, $6uYXW.useCallback)(async (card, pincode, scaSessionToken)=>{
        await reissuePincodeOnCard(card, pincode, scaSessionToken);
    }, [
        reissuePincodeOnCard
    ]);
    const getStepFromCardCreationProcess = (process)=>{
        if (process?.isPincodeSelectedByClient) return "DEFINE_PINCODE";
        return "CARD_ACTIVATION_SUCCESS";
    };
    return {
        startActivationFlow: startActivationFlow,
        step: step,
        activationCode: activationCode,
        setActivationCode: setActivationCode,
        activateCard: activateCard,
        validatePincode: validatePincodeOnCard,
        activationError: activationError,
        scaActivationToken: scaActivationToken,
        scaPincodeToken: scaPincodeToken,
        resetStepToActivation: resetStepToActivation,
        resetStepToPincode: resetStepToPincode
    };
};

});

parcelRegister("aZ9nc", function(module, exports) {

$parcel$export(module.exports, "SetCardPincode", function () { return $1102598dfc758f37$export$14605bff56438ece; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $gDlNU = parcelRequire("gDlNU");

var $k4Ecv = parcelRequire("k4Ecv");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $dpJf9 = parcelRequire("dpJf9");
const $1102598dfc758f37$var$CardPinCodeLength = 4;
const $1102598dfc758f37$export$14605bff56438ece = (props)=>{
    const { validatePincode: validatePincode, updatePincode: updatePincode, title: title, instructionsText: instructions, confirmationText: confirmation, validateButtonTitle: validateButtonTitle } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [pincode, setPincode] = (0, $6uYXW.useState)("");
    const [confirmPincode, setConfirmPincode] = (0, $6uYXW.useState)("");
    const [pincodeState, setPincodeState] = (0, $6uYXW.useState)("define");
    const isDefinePincodeValid = pincode.length === $1102598dfc758f37$var$CardPinCodeLength;
    const isConfirmPincodeValid = confirmPincode === pincode;
    const [goToNextStep, loading] = (0, $k4Ecv.useAsyncOperation)(async ()=>{
        if (pincodeState === "confirm") await validatePincode(pincode);
        else {
            setPincodeState("confirm");
            resetInput();
        }
    });
    const pincodeInputRef = (0, $6uYXW.useRef)(null);
    const resetInput = (0, $6uYXW.useCallback)(()=>{
        pincodeInputRef.current?.reset();
    }, []);
    const definePincode = (code, complete)=>{
        // Do not reset pincode once it has been defined
        if (pincode === "") updatePincode?.(code);
        if (complete) setPincode(code);
    };
    const changePinCode = ()=>{
        setPincode("");
        setPincodeState("define");
        setConfirmPincode("");
        resetInput();
    };
    const pincodeConfig = pincodeState === "define" ? {
        pincodeInstructions: instructions,
        onIdentifierChange: definePincode,
        isPinCodeValid: isDefinePincodeValid,
        isError: false,
        back: undefined
    } : {
        pincodeInstructions: confirmation,
        onIdentifierChange: (code)=>setConfirmPincode(code),
        isPinCodeValid: isConfirmPincodeValid,
        isError: confirmPincode.length === $1102598dfc758f37$var$CardPinCodeLength && !isConfirmPincodeValid,
        validator: (value)=>value === pincode,
        back: changePinCode
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($1102598dfc758f37$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$Illustration, {
                src: (0, $fRvTz.StaticAssets).cardPincode,
                alt: ""
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$PincodeTitle, {
                children: title
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$PincodeInstructions, {
                children: pincodeConfig.pincodeInstructions
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$PincodeInput, {
                ref: pincodeInputRef,
                length: $1102598dfc758f37$var$CardPinCodeLength,
                onIdentifierChange: pincodeConfig.onIdentifierChange,
                validator: pincodeConfig.validator
            }),
            pincodeConfig.isError && /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$StyledErrorMessage, {
                children: formatMessage("cardPincode.errorCodesMismatch")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$ImportantMessage, {
                children: formatMessage("cardPincode.importantMessage")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($1102598dfc758f37$var$ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$NextButton, {
                        disabled: !pincodeConfig.isPinCodeValid,
                        showSpinner: loading,
                        size: "XS",
                        onClick: goToNextStep,
                        children: (0, $gDlNU.isDefined)(pincodeConfig.back) && (0, $gDlNU.isDefined)(validateButtonTitle) ? validateButtonTitle : formatMessage("cardPincode.next")
                    }),
                    (0, $gDlNU.isDefined)(pincodeConfig.back) && /*#__PURE__*/ (0, $4m918.jsx)($1102598dfc758f37$var$PreviousButton, {
                        size: "XS",
                        onClick: pincodeConfig.back,
                        children: formatMessage("cardPincode.previous")
                    })
                ]
            })
        ]
    });
};
const $1102598dfc758f37$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
`;
const $1102598dfc758f37$var$Illustration = (0, $jb8NR.default).img`
  width: 56px;
  height: 56px;
`;
const $1102598dfc758f37$var$PincodeTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 16px 0 0;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $1102598dfc758f37$var$PincodeInstructions = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 8px;
  font-size: 14px;
  line-height: 19px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $1102598dfc758f37$var$PincodeInput = (0, $jb8NR.default)((0, $dpJf9.DigitsInput))`
  margin-top: 28px;
  align-self: center;
`;
const $1102598dfc758f37$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 12px;
  text-align: center;
`;
/* The warning about never sharing the code: quieter than the instructions, still readable. */ const $1102598dfc758f37$var$ImportantMessage = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 24px;
  font-size: 12px;
  line-height: 16px;
  color: ${(0, $22v9q.theme).colors.gray[700]};
`;
const $1102598dfc758f37$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;
const $1102598dfc758f37$var$NextButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  width: 100%;
  padding: 13px;
  box-shadow: none;
`;
/* Outlined, not a plain white fill: DefaultButton clears the border, so it is set back here. */ const $1102598dfc758f37$var$PreviousButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))`
  width: 100%;
  padding: 13px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  box-shadow: none;
  color: ${(0, $22v9q.theme).colors.blue[700]};

  &:focus,
  &:active,
  &:hover {
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }
`;

});
parcelRegister("dpJf9", function(module, exports) {

$parcel$export(module.exports, "DigitsInput", function () { return $0eec9923bb9f78d4$export$644f43cafb1aa655; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $gDlNU = parcelRequire("gDlNU");

var $05ceX = parcelRequire("05ceX");

var $k4Ecv = parcelRequire("k4Ecv");

var $22v9q = parcelRequire("22v9q");
// keyCode constant
const $0eec9923bb9f78d4$var$BACKSPACE = 8;
const $0eec9923bb9f78d4$var$DELETE = 46;
const $0eec9923bb9f78d4$var$ARROW_LEFT = 37;
const $0eec9923bb9f78d4$var$ARROW_RIGHT = 39;
const $0eec9923bb9f78d4$export$644f43cafb1aa655 = /*#__PURE__*/ (0, $6uYXW.forwardRef)((props, ref)=>{
    const { length: length, onIdentifierChange: onIdentifierChange, validator: validator, className: className } = props;
    const [inputs, setInputs] = (0, $6uYXW.useState)((0, $k4Ecv.repeat)(length, (index)=>({
            id: `cardIdInput_${index}_${(0, $05ceX.getRandomID)()}`,
            name: `cardIdInput_${index}`,
            value: ""
        })));
    const [focusInputId, setFocusInputId] = (0, $6uYXW.useState)(inputs[0].id);
    const [isError, setError] = (0, $6uYXW.useState)(false);
    const resetInput = ()=>{
        setInputs((prevInputs)=>prevInputs.map((input)=>({
                    ...input,
                    value: ""
                })));
        document.getElementById(inputs[0].id)?.focus({
            preventScroll: true
        });
        onIdentifierChange?.("", false);
    };
    (0, $6uYXW.useImperativeHandle)(ref, ()=>({
            reset: resetInput
        }));
    (0, $6uYXW.useEffect)(()=>{
        document.getElementById(focusInputId)?.focus({
            preventScroll: true
        });
    }, [
        focusInputId
    ]);
    const notifyIdentifierChange = ()=>{
        if (onIdentifierChange || validator) {
            const identifier = inputs.map((input)=>input.value).join("");
            const isComplete = identifier.length === length;
            onIdentifierChange?.(identifier, isComplete);
            setError(isComplete && (0, $gDlNU.isDefined)(validator) && !validator(identifier));
        }
    };
    const handleRemoveKeys = (e, inputIndex)=>{
        const shiftLeftTo = (index)=>{
            while(index < length - 1){
                inputs[index].value = inputs[index + 1].value;
                index++;
            }
            inputs[length - 1].value = "";
        };
        if (e.keyCode === $0eec9923bb9f78d4$var$BACKSPACE || e.key === "Backspace" || e.keyCode === $0eec9923bb9f78d4$var$DELETE || e.key === "Delete") {
            e.preventDefault();
            if (inputs[inputIndex].value.length > 0) {
                shiftLeftTo(inputIndex);
                setInputs([
                    ...inputs
                ]);
                notifyIdentifierChange();
            } else {
                shiftLeftTo(inputIndex);
                if (inputIndex > 0) setFocusInputId(inputs[inputIndex - 1].id);
            }
        } else if ((e.keyCode === $0eec9923bb9f78d4$var$ARROW_LEFT || e.key === "ArrowLeft") && inputIndex > 0) setFocusInputId(inputs[inputIndex - 1].id);
        else if ((e.keyCode === $0eec9923bb9f78d4$var$ARROW_RIGHT || e.key === "ArrowRight") && inputIndex < length - 1) setFocusInputId(inputs[inputIndex + 1].id);
    };
    const handleOnChange = (e, inputIndex)=>{
        const { value: value } = e.target;
        const sanitizedValue = value.replace(/[^0-9]/g, "");
        let nextFocusId = inputs[inputIndex].id;
        if (value.length === 0 && sanitizedValue.length === 0) {
            const prevInputIndex = inputIndex - 1;
            if (prevInputIndex >= 0) nextFocusId = inputs[prevInputIndex].id;
            inputs[inputIndex].value = sanitizedValue;
        } else if (sanitizedValue.length === 1) {
            const nextInputIndex = inputIndex + 1;
            if (nextInputIndex < inputs.length) nextFocusId = inputs[nextInputIndex].id;
            inputs[inputIndex].value = sanitizedValue;
        } else if (sanitizedValue.length > 1) {
            let inputIndexInLoop = inputIndex;
            for(; inputIndexInLoop < Math.min(length, sanitizedValue.length + inputIndex); inputIndexInLoop++)inputs[inputIndexInLoop].value = sanitizedValue[inputIndexInLoop - inputIndex];
            nextFocusId = inputs[Math.min(length - 1, inputIndexInLoop)].id;
        }
        setInputs([
            ...inputs
        ]);
        setFocusInputId(nextFocusId);
        if (focusInputId === nextFocusId) document.getElementById(focusInputId)?.focus({
            preventScroll: true
        });
        notifyIdentifierChange();
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($0eec9923bb9f78d4$var$Container, {
        className: className,
        children: inputs.map((input, index)=>/*#__PURE__*/ (0, $4m918.jsx)($0eec9923bb9f78d4$export$49d37c88f6a209ee, {
                input: input,
                index: index,
                isError: isError,
                onChangeAtIndex: handleOnChange,
                onKeyDownAtIndex: handleRemoveKeys
            }, index))
    });
});
const $0eec9923bb9f78d4$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`;
const $0eec9923bb9f78d4$export$49d37c88f6a209ee = (props)=>{
    const { input: input, index: index, isError: isError, onChangeAtIndex: onChangeAtIndex, onKeyDownAtIndex: onKeyDownAtIndex } = props;
    const isFilled = input.value.length > 0;
    const borderColor = ()=>{
        if (isFilled) return isError ? (0, $22v9q.theme).colors.error[500] : (0, $22v9q.theme).colors.blue[700];
        return (0, $22v9q.theme).colors.gray[300];
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($0eec9923bb9f78d4$var$DigitContainer, {
        style: {
            borderColor: borderColor()
        },
        children: /*#__PURE__*/ (0, $4m918.jsx)($0eec9923bb9f78d4$var$NumberInput, {
            value: input.value,
            id: input.id,
            onFocus: (event)=>event.target.select(),
            onChange: (event)=>onChangeAtIndex(event, index),
            onKeyDown: (event)=>onKeyDownAtIndex(event, index)
        }, index)
    });
};
/* A box per digit, the way the design system draws an input, instead of a bare underline. */ const $0eec9923bb9f78d4$var$DigitContainer = (0, $jb8NR.default).div`
  display: flex;
  width: 44px;
  height: 52px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[300]};
  border-radius: 10px;
  background-color: #ffffff;
  transition: border-color 0.15s;

  &:focus-within {
    border-color: ${(0, $22v9q.theme).colors.blue[700]};
  }
`;
const $0eec9923bb9f78d4$var$NumberInput = (0, $jb8NR.default).input`
  flex: 1 0 auto;
  width: 100%;
  outline: none;
  border: none;
  border-radius: 10px;
  ${(0, $22v9q.theme).boldText};
  font-size: 20px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
  background-color: transparent;
  text-align: center;
`;

});




parcelRegister("cJrqV", function(module, exports) {

$parcel$export(module.exports, "CardFeaturesSwitches", function () { return $61cb085516dd6761$export$fd080da4e969d18d; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $3fNyH = parcelRequire("3fNyH");

var $gp5id = parcelRequire("gp5id");

var $gDlNU = parcelRequire("gDlNU");

var $izd7j = parcelRequire("izd7j");

var $jn1mK = parcelRequire("jn1mK");

var $ePeIa = parcelRequire("ePeIa");

var $22v9q = parcelRequire("22v9q");
function $61cb085516dd6761$export$fd080da4e969d18d(props) {
    const { card: card, disabled: disabled, className: className, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const isVisible = (0, $6uYXW.useMemo)(()=>card.status === (0, $3fNyH.CardStatus).Active || card.status === (0, $3fNyH.CardStatus).Blocked, [
        card.status
    ]);
    if (!isVisible || card.features === undefined || card.features.length == 0) return null;
    return /*#__PURE__*/ (0, $4m918.jsxs)($61cb085516dd6761$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRowList), {
                onClick: (e)=>e.stopPropagation(),
                children: card.features.map((value, index)=>/*#__PURE__*/ (0, $4m918.jsx)($61cb085516dd6761$var$CardFeatureSwitch, {
                        card: card,
                        feature: value,
                        disabled: card.status !== (0, $3fNyH.CardStatus).Active || disabled,
                        ...otherProps
                    }, index))
            }),
            card.status === (0, $3fNyH.CardStatus).Blocked ? /*#__PURE__*/ (0, $4m918.jsxs)($61cb085516dd6761$var$OverlayContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($61cb085516dd6761$var$Overlay, {}),
                    /*#__PURE__*/ (0, $4m918.jsxs)($61cb085516dd6761$var$LockContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($61cb085516dd6761$var$Lock, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)($61cb085516dd6761$var$LockImage, {})
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($61cb085516dd6761$var$LockText, {
                                children: formatMessage("cardOptions.featuresSwitchesOverlay.cardLocked")
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}
function $61cb085516dd6761$var$CardFeatureSwitch(props) {
    const { card: card, feature: feature, loading: loading, disabled: disabled, enableFeature: enableFeature, className: className } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [error, setError] = (0, $6uYXW.useState)(null);
    const [isFeatureEnabled, setIsFeatureEnabled] = (0, $6uYXW.useState)(feature.enabled);
    const featureLabel = (0, $gp5id.cardFeatures)[feature.id];
    (0, $6uYXW.useEffect)(()=>{
        setError(null);
    }, [
        card
    ]);
    (0, $6uYXW.useEffect)(()=>{
        setIsFeatureEnabled(feature.enabled);
    }, [
        feature.enabled,
        setIsFeatureEnabled
    ]);
    const enableFeatureWithError = async (isEnabled)=>{
        if (!loading && card.status === (0, $3fNyH.CardStatus).Active) try {
            setError(null);
            setIsFeatureEnabled(isEnabled);
            await enableFeature(feature.id, isEnabled);
        } catch (e) {
            setIsFeatureEnabled(!isEnabled);
            (0, $6JVVB.logger).debug(e);
            setError(e?.response?.data?.error?.message);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            (0, $gDlNU.isDefined)(featureLabel) && /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ToggleRow), {
                className: className,
                label: formatMessage(featureLabel),
                value: isFeatureEnabled,
                disabled: disabled,
                onSwitch: enableFeatureWithError
            }),
            error && /*#__PURE__*/ (0, $4m918.jsx)($61cb085516dd6761$var$StyledErrorMessage, {
                children: error
            })
        ]
    });
}
const $61cb085516dd6761$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0;
`;
const $61cb085516dd6761$var$Wrapper = (0, $jb8NR.default).div`
  position: relative;
`;
const $61cb085516dd6761$var$OverlayContainer = (0, $jb8NR.default).div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
const $61cb085516dd6761$var$Overlay = (0, $jb8NR.default).div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  opacity: 0.8;
  border-radius: 12px;
  padding: 10px 15px;
  width: 100%;
  height: 100%;
  z-index: 1;
`;
const $61cb085516dd6761$var$LockContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 1;
  z-index: 2;
`;
const $61cb085516dd6761$var$Lock = (0, $jb8NR.default).div`
  background-color: #000000;
  width: 42px;
  height: 42px;
  border-radius: 21px;
`;
const $61cb085516dd6761$var$LockImage = (0, $jb8NR.default)((0, $ePeIa.PadlockLocked))`
  position: relative;
  top: 13px;
  left: 13px;
  width: 16px;
  height: 16px;
  fill: #ffffff;
`;
const $61cb085516dd6761$var$LockText = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText}
  font-size: 0.8125rem;
  color: #000000;
  margin-top: 12px;
`;

});

parcelRegister("gnXS1", function(module, exports) {

$parcel$export(module.exports, "DeactivateButton", function () { return $97c8004cddf1cb5c$export$f1a39c7292105984; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $3fNyH = parcelRequire("3fNyH");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $aMHYD = parcelRequire("aMHYD");
const $97c8004cddf1cb5c$export$f1a39c7292105984 = ({ card: card, className: className, ...otherOptions })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const canDeactivate = (0, $6uYXW.useMemo)(()=>{
        switch(card.status){
            case (0, $3fNyH.CardStatus).Pending:
            case (0, $3fNyH.CardStatus).Active:
            case (0, $3fNyH.CardStatus).Blocked:
                return true;
            default:
                return false;
        }
    }, [
        card.status
    ]);
    if (!canDeactivate) return null;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aMHYD.ActionMenu), {
        title: formatMessage("cardOptions.deactivateCard.deactivateButton"),
        className: className,
        onClick: ()=>{
            (0, $5Wai4.Modal).present((0, $bQhUC.CARD_DEACTIVATION_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)($97c8004cddf1cb5c$var$DeactivateModal, {
                    card: card,
                    ...otherOptions
                }), {
                canBeDismissed: false
            });
        }
    });
};
const $97c8004cddf1cb5c$var$DeactivateModal = (props)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CARD_DEACTIVATION_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsx)($97c8004cddf1cb5c$var$DeactivateCard, {
            ...props
        })
    });
const $97c8004cddf1cb5c$var$DeactivateCard = (props)=>{
    const { card: card, loading: loading, deactivate: deactivate, className: className } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [error, setError] = (0, $6uYXW.useState)(null);
    const [selectedOpposeReason, setSelectedOpposeReason] = (0, $6uYXW.useState)((0, $3fNyH.OpposeCardReason).Lost);
    (0, $6uYXW.useEffect)(()=>{
        setSelectedOpposeReason((0, $3fNyH.OpposeCardReason).Lost);
    }, [
        card
    ]);
    const deactivateCard = async ()=>{
        try {
            setError(null);
            await deactivate(selectedOpposeReason);
            (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_DEACTIVATION_MODAL_ID));
        } catch (e) {
            (0, $6JVVB.logger).debug(e);
            setError(e?.response?.data?.error?.message);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($97c8004cddf1cb5c$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($97c8004cddf1cb5c$var$MessageTitle, {
                children: formatMessage("cardOptions.deactivateCard.deactivatePromptTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($97c8004cddf1cb5c$var$MessageLabel, {
                children: formatMessage("cardOptions.deactivateCard.title")
            }),
            error && /*#__PURE__*/ (0, $4m918.jsx)($97c8004cddf1cb5c$var$StyledErrorMessage, {
                children: error
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($97c8004cddf1cb5c$var$ConfirmButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.WhitePrimaryButton), {
                        size: "S",
                        onClick: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_DEACTIVATION_MODAL_ID)),
                        children: formatMessage("cardOptions.deactivateCard.deactivateCancelButton")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                        disabled: loading,
                        showSpinner: loading,
                        size: "S",
                        onClick: ()=>!loading && deactivateCard(),
                        children: formatMessage("cardOptions.deactivateCard.deactivateConfirmButton")
                    })
                ]
            })
        ]
    });
};
const $97c8004cddf1cb5c$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
`;
const $97c8004cddf1cb5c$var$MessageTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).bodyBlackBold}
  margin-bottom: 10px;
`;
const $97c8004cddf1cb5c$var$MessageLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 14px;
`;
const $97c8004cddf1cb5c$var$ConfirmButtonsContainer = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 36px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    > * {
      width: 100%;
      max-width: 200px;
    }

    > *:not(:first-child) {
      margin-top: 10px;
    }
  }
`;
const $97c8004cddf1cb5c$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0;
`;

});

parcelRegister("2w2vI", function(module, exports) {

$parcel$export(module.exports, "LockCardSwitch", function () { return $a09bd3a74b5c785f$export$a90d5d7b99a158bc; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3fNyH = parcelRequire("3fNyH");

var $l5c4C = parcelRequire("l5c4C");

var $izd7j = parcelRequire("izd7j");

var $jn1mK = parcelRequire("jn1mK");
function $a09bd3a74b5c785f$export$a90d5d7b99a158bc(props) {
    const { card: card, loading: loading, disabled: disabled, block: block, unblock: unblock, className: className } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [error, setError] = (0, $6uYXW.useState)(null);
    const [pending, setPending] = (0, $6uYXW.useState)(false);
    const [isLocked, setIsLocked] = (0, $6uYXW.useState)(card.status === (0, $3fNyH.CardStatus).Blocked);
    (0, $6uYXW.useEffect)(()=>{
        setIsLocked(card.status === (0, $3fNyH.CardStatus).Blocked);
    }, [
        card.status,
        setIsLocked
    ]);
    (0, $6uYXW.useEffect)(()=>{
        setError(null);
    }, [
        card
    ]);
    const isCardBlockable = card.status === (0, $3fNyH.CardStatus).Active || card.status === (0, $3fNyH.CardStatus).Blocked;
    const blockOrUnblock = async (lock)=>{
        if (loading || pending) return;
        setError(null);
        setPending(true);
        setIsLocked(lock);
        try {
            // The API answers before the card has moved, so the new status is polled for rather than
            // assumed: the switch would otherwise flip back on the next refresh.
            if (lock) {
                await block();
                await (0, $l5c4C.pollCardStatus)(card.id, (0, $3fNyH.CardStatus).Blocked, (id)=>(0, $kqXxS.cardManager).retrieveCard(id));
            } else {
                await unblock();
                await (0, $l5c4C.pollCardStatus)(card.id, (0, $3fNyH.CardStatus).Active, (id)=>(0, $kqXxS.cardManager).retrieveCard(id));
            }
            await (0, $kqXxS.cardManager).refresh();
        } catch (e) {
            setIsLocked(!lock);
            (0, $6JVVB.logger).debug(e);
            setError(e?.response?.data?.error?.message);
        } finally{
            setPending(false);
        }
    };
    return isCardBlockable ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ToggleRow), {
                className: className,
                label: formatMessage("cardOptions.switch.lockCard"),
                value: isLocked,
                disabled: disabled || pending,
                onSwitch: blockOrUnblock
            }),
            error && /*#__PURE__*/ (0, $4m918.jsx)($a09bd3a74b5c785f$var$StyledErrorMessage, {
                children: error
            })
        ]
    }) : null;
}
const $a09bd3a74b5c785f$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0;
`;

});
parcelRegister("l5c4C", function(module, exports) {

$parcel$export(module.exports, "pollCardStatus", function () { return $998fdb952650c1ec$export$2953f778abbdc064; });
async function $998fdb952650c1ec$export$2953f778abbdc064(cardId, expectedStatus, retrieveCard, { interval: interval = 2000, maxAttempts: maxAttempts = 10, requireNoPendingOperation: requireNoPendingOperation = false } = {}) {
    let attempts = 0;
    while(attempts < maxAttempts){
        const card = await retrieveCard(cardId);
        const statusMatch = card.status === expectedStatus;
        const noPending = !requireNoPendingOperation || !card.pendingManagementOperation;
        if (statusMatch && noPending) return card;
        await new Promise((resolve)=>setTimeout(resolve, interval));
        attempts++;
    }
    return null;
}

});


parcelRegister("2F9AR", function(module, exports) {

$parcel$export(module.exports, "OppositionButton", function () { return $f11ba3537342e36d$export$cd858bb228f0a3cc; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $3fNyH = parcelRequire("3fNyH");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $kw746 = parcelRequire("kw746");

var $5Wai4 = parcelRequire("5Wai4");

var $7xALQ = parcelRequire("7xALQ");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $aMHYD = parcelRequire("aMHYD");
const $f11ba3537342e36d$export$cd858bb228f0a3cc = ({ card: card, className: className, ...otherOptions })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const canOppose = (0, $6uYXW.useMemo)(()=>{
        switch(card.status){
            case (0, $3fNyH.CardStatus).Pending:
            case (0, $3fNyH.CardStatus).Active:
            case (0, $3fNyH.CardStatus).Blocked:
                return true;
            default:
                return false;
        }
    }, [
        card.status
    ]);
    if (!canOppose) return null;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aMHYD.ActionMenu), {
        title: formatMessage("cardOptions.oppositionCard.opposeButton"),
        description: formatMessage("cardOptions.oppositionCard.opposeDescription"),
        iconSrc: (0, $fRvTz.StaticAssets).cardOpposition,
        className: className,
        onClick: ()=>{
            (0, $5Wai4.Modal).present((0, $bQhUC.CARD_OPPOSITION_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$OppositionModal, {
                    card: card,
                    ...otherOptions
                }), {
                canBeDismissed: false
            });
        }
    });
};
const $f11ba3537342e36d$var$OppositionModal = (props)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $7xALQ.WhiteModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CARD_OPPOSITION_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$OppositionCard, {
            ...props
        })
    });
const $f11ba3537342e36d$var$OppositionCard = (props)=>{
    const { card: card, loading: loading, oppose: oppose, className: className } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [error, setError] = (0, $6uYXW.useState)(null);
    const [selectedOpposeReason, setSelectedOpposeReason] = (0, $6uYXW.useState)((0, $3fNyH.OpposeCardReason).Lost);
    (0, $6uYXW.useEffect)(()=>{
        setSelectedOpposeReason((0, $3fNyH.OpposeCardReason).Lost);
    }, [
        card
    ]);
    const opposeReasons = (0, $6uYXW.useMemo)(()=>new Map([
            [
                (0, $3fNyH.OpposeCardReason).Lost,
                formatMessage("cardOptions.oppositionCard.reasonLost")
            ],
            [
                (0, $3fNyH.OpposeCardReason).Stolen,
                formatMessage("cardOptions.oppositionCard.reasonStolen")
            ],
            [
                (0, $3fNyH.OpposeCardReason).NotDistributed,
                formatMessage("cardOptions.oppositionCard.reasonNotDistributed")
            ]
        ]), [
        formatMessage
    ]);
    const opposeCard = async ()=>{
        try {
            setError(null);
            await oppose(selectedOpposeReason);
            (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_OPPOSITION_MODAL_ID));
        } catch (e) {
            (0, $6JVVB.logger).debug(e);
            setError(e?.response?.data?.error?.message);
        }
    };
    const opposeCardWithConfirm = ()=>{
        if (window?.confirm) {
            if (window.confirm(`${formatMessage("cardOptions.oppositionCard.opposePromptTitle")}. ${formatMessage("cardOptions.oppositionCard.opposePromptMessage")}`)) opposeCard();
            else (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_OPPOSITION_MODAL_ID));
        } else opposeCard();
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($f11ba3537342e36d$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$Illustration, {
                src: (0, $fRvTz.StaticAssets).cardOpposition,
                alt: ""
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$Title, {
                children: formatMessage("cardOptions.oppositionCard.opposePromptTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$MessageLabel, {
                children: formatMessage("cardOptions.oppositionCard.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$StyledRadioSelector, {
                innerId: "opposition_button",
                values: opposeReasons,
                value: selectedOpposeReason,
                onChange: setSelectedOpposeReason
            }),
            error && /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$StyledErrorMessage, {
                children: error
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($f11ba3537342e36d$var$ConfirmButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$ConfirmButton, {
                        showSpinner: loading,
                        size: "XS",
                        onClick: ()=>!loading && opposeCardWithConfirm(),
                        children: formatMessage("cardOptions.oppositionCard.opposeConfirmButton")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($f11ba3537342e36d$var$CancelButton, {
                        size: "XS",
                        onClick: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_OPPOSITION_MODAL_ID)),
                        children: formatMessage("cardOptions.oppositionCard.opposeCancelButton")
                    })
                ]
            })
        ]
    });
};
const $f11ba3537342e36d$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
const $f11ba3537342e36d$var$Illustration = (0, $jb8NR.default).img`
  width: 56px;
  height: 56px;
`;
const $f11ba3537342e36d$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 16px 0 0;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $f11ba3537342e36d$var$MessageLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 8px;
  font-size: 14px;
  line-height: 19px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $f11ba3537342e36d$var$ConfirmButtonsContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;
const $f11ba3537342e36d$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  width: 100%;
  padding: 13px;
  box-shadow: none;
`;
/* Outlined, not a plain white fill: DefaultButton clears the border, so it is set back here. */ const $f11ba3537342e36d$var$CancelButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))`
  width: 100%;
  padding: 13px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  box-shadow: none;
  color: ${(0, $22v9q.theme).colors.blue[700]};

  &:focus,
  &:active,
  &:hover {
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }
`;
/* One reason per line, each on its own row of the list. */ const $f11ba3537342e36d$var$StyledRadioSelector = (0, $jb8NR.default)((0, $kw746.RadioSelector))`
  flex-direction: column;
  margin-top: 20px;

  > * {
    padding: 14px 0;
    border-top: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  }

  > *:first-child {
    border-top: 0;
  }

  label {
    ${(0, $22v9q.theme).text};
    flex: 1;
    font-size: 16px;
    line-height: 22px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }

  input {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    border-color: ${(0, $22v9q.theme).colors.blue[700]};
  }

  input:checked::after {
    width: 10px;
    height: 10px;
    top: 5px;
    left: 5px;
    background-color: ${(0, $22v9q.theme).colors.blue[700]};
  }
`;
const $f11ba3537342e36d$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 16px 0 0;
`;

});

parcelRegister("jpP4c", function(module, exports) {

$parcel$export(module.exports, "OrderNewCardButton", function () { return $c9bd1256bb69d544$export$a20d92e8994741e0; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $5Wai4 = parcelRequire("5Wai4");

var $fRvTz = parcelRequire("fRvTz");

var $aMHYD = parcelRequire("aMHYD");

var $amMv7 = parcelRequire("amMv7");
const $c9bd1256bb69d544$export$a20d92e8994741e0 = ({ card: card, className: className })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aMHYD.ActionMenu), {
        title: formatMessage("cardsList.orderCard"),
        iconSrc: (0, $fRvTz.StaticAssets).cardNew,
        className: className,
        onClick: ()=>{
            (0, $5Wai4.Modal).present((0, $bQhUC.CARD_REFABRICATION_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $amMv7.CardRefabricateModal), {
                    card: card
                }), {
                canBeDismissed: false
            });
        }
    });
};

});
parcelRegister("amMv7", function(module, exports) {

$parcel$export(module.exports, "CardRefabricateModal", function () { return $08c581a41207bf9f$export$a75470522081db3c; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $61WqT = parcelRequire("61WqT");

var $3fNyH = parcelRequire("3fNyH");

var $gr9kI = parcelRequire("gr9kI");

var $e4wja = parcelRequire("e4wja");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $7Zu6k = parcelRequire("7Zu6k");

var $kw746 = parcelRequire("kw746");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $8Mjlc = parcelRequire("8Mjlc");

var $jNOeu = parcelRequire("jNOeu");
const $08c581a41207bf9f$export$a75470522081db3c = (props)=>{
    const { card: card } = props;
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)("");
    const { client: client } = (0, $7N0kU.useClient)();
    const [motive, setMotive] = (0, $6uYXW.useState)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    (0, $6uYXW.useEffect)(()=>{
        if (card.status !== (0, $3fNyH.CardStatus).Opposed) // the only motive for not opposed card is DAMAGED
        setMotive((0, $3fNyH.CardRefabricateMotive).Damaged);
    }, []);
    const opposeReasons = (0, $6uYXW.useMemo)(()=>new Map([
            [
                (0, $3fNyH.CardRefabricateMotive).Lost,
                formatMessage("cardOptions.refabricate.motivesOptions.LOST")
            ],
            [
                (0, $3fNyH.CardRefabricateMotive).Stolen,
                formatMessage("cardOptions.refabricate.motivesOptions.STOLEN")
            ],
            [
                (0, $3fNyH.CardRefabricateMotive).Abuse,
                formatMessage("cardOptions.refabricate.motivesOptions.ABUSE")
            ]
        ]), [
        formatMessage
    ]);
    const { loading: loading, error: error, scaToken: scaToken, refabricateCard: refabricateCard, step: step } = (0, $gr9kI.useCardRefabrication)();
    const handleOTPValidation = async (otp, scaToken)=>{
        if (scaToken) try {
            const response = await (0, $kqXxS.authenticationsSessionsService).verifyAuthentication(scaToken, otp);
            if (response.status === (0, $61WqT.VerifyAuthenticationStatus).DONE) await refabricateCard(card, motive, scaToken);
        } catch (e) {
            setErrorMessage(e.response?.data?.error?.message || e.toString());
        }
        else throw new Error("Missing SCA Token");
    };
    const handleSubmit = async ()=>{
        try {
            await refabricateCard(card, motive);
        } catch (e) {
            setErrorMessage(e.response.data.error.message);
        }
    };
    const closeModal = (0, $6uYXW.useCallback)(()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_REFABRICATION_MODAL_ID)), []);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CARD_REFABRICATION_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)($08c581a41207bf9f$var$StyledModalContainer, {
            children: [
                step === (0, $gr9kI.CardRefabricationStep).Motive && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledModalTitle, {
                                    children: formatMessage("cardOptions.refabricate.modal.title")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsxs)($08c581a41207bf9f$var$StyledInputLabel, {
                                    children: [
                                        formatMessage("cardOptions.refabricate.modal.message"),
                                        /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledCardNumber, {
                                            children: formatMessage("cardOptions.refabricate.modal.cardNumber", {
                                                cardNumber: card.panDisplay
                                            })
                                        })
                                    ]
                                }),
                                card.status === (0, $3fNyH.CardStatus).Opposed && /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$ReasonsContainer, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledRadioSelector, {
                                        innerId: "opposition_button",
                                        values: opposeReasons,
                                        value: motive,
                                        onChange: setMotive
                                    })
                                }),
                                loading && /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledModalInner, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledBlueSpinner, {}, "spinner")
                                }),
                                error && error?.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledErrorLabel, {
                                    children: error
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledButton, {
                            disabled: !motive,
                            size: "S",
                            onClick: ()=>handleSubmit(),
                            children: formatMessage("cardOptions.refabricate.modal.submitButtonLabel")
                        })
                    ]
                }),
                step === (0, $gr9kI.CardRefabricationStep).SCACheck && /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: (otp)=>handleOTPValidation(otp, scaToken),
                    errorMessage: errorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: loading
                }),
                step === (0, $gr9kI.CardRefabricationStep).Error && /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledResultView, {
                    type: "error",
                    title: formatMessage("resultScreen.refabricate.failureTitle"),
                    subtitle: formatMessage("resultScreen.refabricate.failureSubtitle"),
                    description: formatMessage("resultScreen.refabricate.failureDescription"),
                    error: error.response?.data?.error?.message || error.toString(),
                    onConfirm: ()=>{
                        closeModal();
                    }
                }),
                step === (0, $gr9kI.CardRefabricationStep).Success && /*#__PURE__*/ (0, $4m918.jsx)($08c581a41207bf9f$var$StyledResultView, {
                    type: "success",
                    title: formatMessage("resultScreen.refabricate.successTitle"),
                    subtitle: formatMessage("resultScreen.refabricate.successSubtitle"),
                    onConfirm: ()=>{
                        closeModal();
                    }
                })
            ]
        })
    });
};
const $08c581a41207bf9f$var$StyledButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 32px;
  align-self: center;
`;
const $08c581a41207bf9f$var$StyledInputLabel = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).bodyBlackRegular}
  font-size: 18px;
  margin-top: 18px;
`;
const $08c581a41207bf9f$var$StyledErrorLabel = (0, $jb8NR.default).p`
  font-size: 14px;
  color: red;
  margin-top: 12px;
`;
const $08c581a41207bf9f$var$StyledCardNumber = (0, $jb8NR.default).p`
  color: ${(0, $22v9q.theme).mainColor};
`;
const $08c581a41207bf9f$var$StyledResultView = (0, $jb8NR.default)((0, $jNOeu.ResultView))`
  margin-left: 20px;
  margin-right: 20px;
`;
const $08c581a41207bf9f$var$ReasonsContainer = (0, $jb8NR.default).div`
  display: flex;
  margin-top: 25px;
  align-self: stretch;
`;
const $08c581a41207bf9f$var$StyledRadioSelector = (0, $jb8NR.default)((0, $kw746.RadioSelector))`
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 20px;
  }
`;
const $08c581a41207bf9f$var$StyledModalTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  padding-bottom: 40px;
  font-size: 1.125rem;
  color: #000000;
`;
const $08c581a41207bf9f$var$StyledModalContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
`;
const $08c581a41207bf9f$var$StyledModalInner = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
`;
const $08c581a41207bf9f$var$StyledBlueSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))``;

});
parcelRegister("gr9kI", function(module, exports) {

$parcel$export(module.exports, "CardRefabricationStep", function () { return $8f68d867cecd2f7f$export$2992890db0fc6a90; });
$parcel$export(module.exports, "useCardRefabrication", function () { return $8f68d867cecd2f7f$export$f5d1c6092ef8c052; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");
var $8f68d867cecd2f7f$export$2992890db0fc6a90 = /*#__PURE__*/ function(CardRefabricationStep) {
    CardRefabricationStep["Motive"] = "MOTIVE";
    CardRefabricationStep["Confirm"] = "CONFIRM";
    CardRefabricationStep["Success"] = "SUCCESS";
    CardRefabricationStep["Error"] = "ERROR";
    CardRefabricationStep["SCACheck"] = "SCA_CHECK";
    return CardRefabricationStep;
}({});
const $8f68d867cecd2f7f$export$f5d1c6092ef8c052 = ()=>{
    const [step, setStep] = (0, $6uYXW.useState)("MOTIVE");
    const [scaToken, setScaToken] = (0, $6uYXW.useState)("");
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [card, setCard] = (0, $6uYXW.useState)(undefined);
    const [textError, setTextError] = (0, $6uYXW.useState)(undefined);
    const resetStep = ()=>{
        setStep("MOTIVE");
    };
    const resetStepToConfirm = ()=>{
        setStep("CONFIRM");
    };
    const refabricateCardStartFlow = (0, $6uYXW.useCallback)(async (cardToUse, replacementReason, scaSessionToken)=>{
        try {
            setLoading(true);
            await (0, $kqXxS.cardManager).refabricateCard(cardToUse.id, replacementReason, scaSessionToken);
            setStep("SUCCESS");
            setLoading(false);
        } catch (e) {
            const result = e;
            //SCA use case, must send and verify the given token
            if (result.response?.data?.error === "Unauthorized" && result.response?.data?.new_token) {
                setScaToken(result.response.data.new_token);
                setStep("SCA_CHECK");
                (0, $kqXxS.authenticationsSessionsService).sendAuthentication(result.response.data.new_token);
            } else {
                setTextError(result.response?.data?.error?.message || result.toString());
                setStep("ERROR");
            }
            setLoading(false);
        }
    }, [
        setStep,
        setTextError
    ]);
    const refabricateCard = (0, $6uYXW.useCallback)(async (card, replacementReason, scaSessionToken)=>{
        await refabricateCardStartFlow(card, replacementReason, scaSessionToken || "");
    }, [
        refabricateCardStartFlow
    ]);
    return {
        step: step,
        loading: loading,
        card: card,
        setCard: setCard,
        refabricateCard: refabricateCard,
        error: textError,
        scaToken: scaToken,
        resetStep: resetStep,
        resetStepToConfirm: resetStepToConfirm
    };
};

});



parcelRegister("h1vyY", function(module, exports) {

$parcel$export(module.exports, "RefabricateButton", function () { return $2e6d2f668d00e134$export$c69544645281dc84; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $5Wai4 = parcelRequire("5Wai4");

var $fRvTz = parcelRequire("fRvTz");

var $aMHYD = parcelRequire("aMHYD");

var $amMv7 = parcelRequire("amMv7");
const $2e6d2f668d00e134$export$c69544645281dc84 = ({ card: card, className: className })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aMHYD.ActionMenu), {
        title: formatMessage("cardsList.refabricateButton"),
        iconSrc: (0, $fRvTz.StaticAssets).cardNew,
        className: className,
        onClick: ()=>{
            (0, $5Wai4.Modal).present((0, $bQhUC.CARD_REFABRICATION_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $amMv7.CardRefabricateModal), {
                    card: card
                }), {
                canBeDismissed: false
            });
        }
    });
};

});

parcelRegister("kdHXC", function(module, exports) {

$parcel$export(module.exports, "UpdateCardPinCodeButton", function () { return $0539d4bf388f8013$export$1fe9fc0a2d6c2215; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $3fNyH = parcelRequire("3fNyH");

var $bQhUC = parcelRequire("bQhUC");

var $5Wai4 = parcelRequire("5Wai4");

var $fRvTz = parcelRequire("fRvTz");

var $aMHYD = parcelRequire("aMHYD");

var $22j3x = parcelRequire("22j3x");
const $0539d4bf388f8013$export$1fe9fc0a2d6c2215 = ({ card: card, disabled: disabled, className: className })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const canUpdate = (0, $6uYXW.useMemo)(()=>card.status === (0, $3fNyH.CardStatus).Active || card.status === (0, $3fNyH.CardStatus).Blocked, [
        card.status
    ]);
    if (!canUpdate) return null;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aMHYD.ActionMenu), {
        title: formatMessage("cardOptions.updateCardPincode.updateButton"),
        description: formatMessage("cardOptions.updateCardPincode.updateDescription"),
        iconSrc: (0, $fRvTz.StaticAssets).cardPincode,
        disabled: disabled,
        className: className,
        onClick: ()=>{
            (0, $5Wai4.Modal).present((0, $bQhUC.CARD_PINCODE_UPDATE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $22j3x.CardUpdatePincodeModal), {
                    card: card
                }), {
                canBeDismissed: false
            });
        }
    });
};

});
parcelRegister("22j3x", function(module, exports) {

$parcel$export(module.exports, "CardUpdatePincodeModal", function () { return $d9c7d0fc72aecf08$export$f1591da655d5a24f; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $61WqT = parcelRequire("61WqT");

var $upxoh = parcelRequire("upxoh");

var $e4wja = parcelRequire("e4wja");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $5Wai4 = parcelRequire("5Wai4");

var $7xALQ = parcelRequire("7xALQ");

var $596Xf = parcelRequire("596Xf");

var $8Mjlc = parcelRequire("8Mjlc");

var $jNOeu = parcelRequire("jNOeu");

var $aZ9nc = parcelRequire("aZ9nc");
const $d9c7d0fc72aecf08$export$f1591da655d5a24f = (props)=>{
    const { card: card } = props;
    const { client: client } = (0, $7N0kU.useClient)();
    const { step: step, validatePincode: validatePincode, textError: textError, scaToken: scaToken } = (0, $upxoh.useCardUpdatePincode)();
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)("");
    const [scaIsLoading, setScaIsLoading] = (0, $6uYXW.useState)(false);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [pincode, setPincode] = (0, $6uYXW.useState)("");
    const isEdtingPinCode = (0, $6uYXW.useMemo)(()=>step === (0, $upxoh.CardUpdatePincodeStep).DefinePincode && pincode.length > 0, [
        step,
        pincode
    ]);
    const updateCard = (0, $6uYXW.useCallback)((card)=>{
        try {
            (0, $kqXxS.cardManager).retrieveCard(card.id);
        } catch (e) {
            const error = e;
            console.error(error.response.data.error.message);
        }
    }, []);
    const { isAllowedToQuit: isAllowedToQuit } = (0, $596Xf.useQuitBlocking)(isEdtingPinCode, formatMessage("cardOptions.updateCardPincode.confirmationPopup.message"));
    const handleOTPValidation = async (card, otp, scaToken)=>{
        if (scaToken) try {
            setScaIsLoading(true);
            const response = await (0, $kqXxS.authenticationsSessionsService).verifyAuthentication(scaToken, otp);
            if (response.status === (0, $61WqT.VerifyAuthenticationStatus).DONE) validatePincode(card, pincode, scaToken);
        } catch (e) {
            setErrorMessage(e);
        } finally{
            setScaIsLoading(false);
        }
        else throw new Error("Missing SCA Token");
    };
    const innerStepComponent = ()=>{
        switch(step){
            case (0, $upxoh.CardUpdatePincodeStep).DefinePincode:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $aZ9nc.SetCardPincode), {
                    validatePincode: (pincode)=>validatePincode(card, pincode),
                    updatePincode: setPincode,
                    title: formatMessage("cardOptions.updateCardPincode.title"),
                    instructionsText: formatMessage("cardOptions.updateCardPincode.definePincodeMessage"),
                    confirmationText: formatMessage("cardOptions.updateCardPincode.confirmPincodeMessage")
                });
            case (0, $upxoh.CardUpdatePincodeStep).SCACheck:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: (otp)=>handleOTPValidation(card, otp, scaToken),
                    errorMessage: errorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: scaIsLoading
                });
            case (0, $upxoh.CardUpdatePincodeStep).Error:
                return /*#__PURE__*/ (0, $4m918.jsx)($d9c7d0fc72aecf08$var$StyledResultView, {
                    type: "error",
                    title: formatMessage("cardOptions.updateCardPincode.failureTitle"),
                    subtitle: formatMessage("cardOptions.updateCardPincode.failureSubtitle"),
                    description: formatMessage("cardOptions.updateCardPincode.failureDescription"),
                    error: textError,
                    onConfirm: ()=>{
                        updateCard(card);
                        (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_PINCODE_UPDATE_MODAL_ID));
                    }
                });
            case (0, $upxoh.CardUpdatePincodeStep).Success:
                return /*#__PURE__*/ (0, $4m918.jsx)($d9c7d0fc72aecf08$var$StyledResultView, {
                    type: "success",
                    title: formatMessage("cardOptions.updateCardPincode.successTitle"),
                    subtitle: formatMessage("cardOptions.updateCardPincode.successSubtitle"),
                    onConfirm: ()=>{
                        updateCard(card);
                        (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_PINCODE_UPDATE_MODAL_ID));
                    }
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $7xALQ.WhiteModalContainer), {
        id: (0, $bQhUC.CARD_PINCODE_UPDATE_MODAL_ID),
        closeButton: true,
        closeModal: async ()=>{
            if (await isAllowedToQuit()) (0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_PINCODE_UPDATE_MODAL_ID));
        },
        children: /*#__PURE__*/ (0, $4m918.jsx)($d9c7d0fc72aecf08$var$ModalContainer, {
            children: innerStepComponent()
        })
    });
};
/* No fixed height any more: each step is as tall as what it has to say. */ const $d9c7d0fc72aecf08$var$ModalContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $d9c7d0fc72aecf08$var$StyledResultView = (0, $jb8NR.default)((0, $jNOeu.ResultView))`
  margin-left: 20px;
  margin-right: 20px;
`;

});
parcelRegister("upxoh", function(module, exports) {

$parcel$export(module.exports, "CardUpdatePincodeStep", function () { return $dea71a99fc623ba3$export$d6708e73c885ab89; });
$parcel$export(module.exports, "useCardUpdatePincode", function () { return $dea71a99fc623ba3$export$c62d33469e83a8d8; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $1qf9N = parcelRequire("1qf9N");
var $dea71a99fc623ba3$export$d6708e73c885ab89 = /*#__PURE__*/ function(CardUpdatePincodeStep) {
    CardUpdatePincodeStep["DefinePincode"] = "CARD_UPDATE_PINCODE_DEFINE";
    CardUpdatePincodeStep["Success"] = "CARD_UPDATE_PINCODE_SUCCESS";
    CardUpdatePincodeStep["Error"] = "CARD_UPDATE_PINCODE_ERROR";
    CardUpdatePincodeStep["SCACheck"] = "SCA_CHECK";
    return CardUpdatePincodeStep;
}({});
const $dea71a99fc623ba3$export$c62d33469e83a8d8 = ()=>{
    const [step, setStep] = (0, $6uYXW.useState)("CARD_UPDATE_PINCODE_DEFINE");
    const [scaToken, setScaToken] = (0, $6uYXW.useState)("");
    const [card, setCard] = (0, $6uYXW.useState)(undefined);
    const [textError, setTextError] = (0, $6uYXW.useState)(undefined);
    const resetStep = ()=>{
        setStep("CARD_UPDATE_PINCODE_DEFINE");
    };
    const reissuePincodeOnCard = (0, $6uYXW.useCallback)(async (cardToUse, newPincode, scaSessionToken)=>{
        try {
            await (0, $kqXxS.cardManager).reissuePincode(cardToUse.id, newPincode, (0, $1qf9N.UPDATE_PINCODE), scaSessionToken);
            setStep("CARD_UPDATE_PINCODE_SUCCESS");
        } catch (e) {
            const result = e;
            //SCA use case, must send and verify the given token
            if (result.response?.data?.error === "Unauthorized" && result.response?.data?.new_token) {
                setScaToken(result.response.data.new_token);
                setStep("SCA_CHECK");
                (0, $kqXxS.authenticationsSessionsService).sendAuthentication(result.response.data.new_token);
            } else {
                setTextError(result.response?.data?.error?.message || result.toString());
                setStep("CARD_UPDATE_PINCODE_ERROR");
            }
        }
    }, [
        setStep,
        setTextError
    ]);
    const validatePincodeOnCard = (0, $6uYXW.useCallback)(async (card, pincode, scaSessionToken)=>{
        await reissuePincodeOnCard(card, pincode, scaSessionToken || "");
    }, [
        reissuePincodeOnCard
    ]);
    return {
        step: step,
        card: card,
        setCard: setCard,
        validatePincode: validatePincodeOnCard,
        textError: textError,
        scaToken: scaToken,
        resetStep: resetStep
    };
};

});

parcelRegister("596Xf", function(module, exports) {

$parcel$export(module.exports, "useQuitBlocking", function () { return $07413d1201eb478d$export$111b8d00ddadaa34; });

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");
function $07413d1201eb478d$export$111b8d00ddadaa34(block, confirmMessage) {
    const history = (0, $NQIVp.useHistory)();
    (0, $6uYXW.useEffect)(()=>{
        const showConfirm = (ev)=>{
            if (block) {
                ev.returnValue = confirmMessage;
                return confirmMessage;
            }
            return null;
        };
        window.addEventListener("beforeunload", showConfirm);
        return ()=>window.removeEventListener("beforeunload", showConfirm);
    }, [
        block,
        confirmMessage
    ]);
    const redirectIfAllowed = (path)=>{
        if (block) {
            if (window.confirm(confirmMessage)) history.push(path);
        } else history.push(path);
    };
    const isAllowedToQuit = async ()=>!block || await window.confirm(confirmMessage);
    return {
        redirectIfAllowed: redirectIfAllowed,
        isAllowedToQuit: isAllowedToQuit
    };
}

});




parcelRegister("kl80K", function(module, exports) {

$parcel$export(module.exports, "CardOutstandingsScreen", function () { return $6f0e346df885334e$export$d38e5ecf6b96571e; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $eHurR = parcelRequire("eHurR");

var $aWjzi = parcelRequire("aWjzi");

var $Pnk5J = parcelRequire("Pnk5J");

var $4LgRR = parcelRequire("4LgRR");

var $gDlNU = parcelRequire("gDlNU");

var $k4Ecv = parcelRequire("k4Ecv");

var $bQhUC = parcelRequire("bQhUC");

var $31CeI = parcelRequire("31CeI");

var $yYT9n = parcelRequire("yYT9n");

var $5Wai4 = parcelRequire("5Wai4");

var $amCCH = parcelRequire("amCCH");

var $jEKif = parcelRequire("jEKif");

var $3yllK = parcelRequire("3yllK");

var $k4kME = parcelRequire("k4kME");

var $7XqbX = parcelRequire("7XqbX");

var $a0LAX = parcelRequire("a0LAX");

var $iOAO5 = parcelRequire("iOAO5");

var $6CqKu = parcelRequire("6CqKu");
function $6f0e346df885334e$export$d38e5ecf6b96571e() {
    const { cards: cards, loading: cardsLoading } = (0, $4LgRR.useCards)();
    const [card, setCard] = (0, $6uYXW.useState)({});
    const [isLoading, setIsLoading] = (0, $6uYXW.useState)(true);
    const card_id = (0, $31CeI.useQueryParam)("card_id");
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const screenLoading = cardsLoading;
    const [destination, setDestination] = (0, $6uYXW.useState)((0, $Pnk5J.OutstandingsType).Payments);
    const [paymentOutstandings, setPaymentOutstandings] = (0, $6uYXW.useState)([]);
    const [cashoutOutstandings, setCashoutOutstandings] = (0, $6uYXW.useState)([]);
    const [validationMsg, setValidationMsg] = (0, $6uYXW.useState)(false);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const outstandingToCard = (outstanding)=>{
        const durationLabel = (nb, unit)=>{
            const durationUnit = "cardOptions.outstandings.durationUnit";
            switch(unit){
                case (0, $Pnk5J.DurationUnit).Hour:
                    return durationUnit + (nb > 1 ? ".hours" : ".hour");
                case (0, $Pnk5J.DurationUnit).Day:
                    return durationUnit + (nb > 1 ? ".days" : ".day");
                case (0, $Pnk5J.DurationUnit).Week:
                    return durationUnit + (nb > 1 ? ".weeks" : ".week");
                case (0, $Pnk5J.DurationUnit).Month:
                    return durationUnit + (nb > 1 ? ".months" : ".month");
                case (0, $Pnk5J.DurationUnit).Year:
                    return durationUnit + (nb > 1 ? ".years" : ".year");
            }
        };
        const periodLabel = ()=>{
            if (outstanding.specificPeriod) return formatMessage("cardOptions.outstandings.fixedPeriod", {
                startDate: formatDate(outstanding.specificPeriod.startDate),
                endDate: formatDate(outstanding.specificPeriod.endDate)
            });
            else if (outstanding.period) {
                const unitLabel = formatMessage(durationLabel(outstanding.period.value, outstanding.period.unit));
                return formatMessage("cardOptions.outstandings.slidingPeriod", {
                    num: outstanding.period.value,
                    unit: unitLabel
                });
            }
            return "";
        };
        const title = outstanding.title;
        const period = periodLabel();
        const rawPeriod = outstanding.period;
        const type = outstanding.type ?? "";
        const maxValue = outstanding.maxValue;
        const maxAmount = outstanding.maxAmount;
        const usedValue = outstanding.usedValue;
        const availableValue = outstanding.availableValue >= 0 ? outstanding.availableValue : 0;
        const percentage = usedValue / maxValue || 0;
        const operationType = formatMessage((0, $gDlNU.isDefined)(outstanding.maxAmount) ? "cardOptions.outstandings.maxAmount" : "cardOptions.outstandings.maxOperations");
        let maxAmountLabel = `${maxValue}`;
        if ((0, $gDlNU.isDefined)(outstanding.maxAmount)) maxAmountLabel = (0, $kqXxS.i18NManager).formatAmount(outstanding.maxAmount);
        let usedAmountLabel = `${usedValue}`;
        if ((0, $gDlNU.isDefined)(outstanding.usedAmount)) usedAmountLabel = (0, $kqXxS.i18NManager).formatAmount(outstanding.usedAmount);
        let availableAmountLabel = `${availableValue}`;
        if ((0, $gDlNU.isDefined)(outstanding.availableAmount)) availableAmountLabel = (0, $kqXxS.i18NManager).formatAmount(outstanding.availableAmount);
        return {
            id: outstanding.id,
            title: title,
            period: period,
            rawPeriod: rawPeriod,
            percentage: percentage,
            type: type,
            operationType: operationType,
            maxAmountLabel: maxAmountLabel,
            maxAmount: maxAmount,
            maxValue: maxValue,
            usedAmountLabel: usedAmountLabel,
            availableAmountLabel: availableAmountLabel
        };
    };
    const cardLimitToCard = (cardLimit, currency)=>{
        const maxValue = Number(cardLimit[1]) || 0;
        const percentage = 0;
        const operationType = formatMessage("cardOptions.outstandings.maxAmount");
        // A card may carry no currency, or one the app cannot read; its ceiling still has to show.
        const maxAmount = (0, $Pnk5J.amount)(maxValue, currency);
        const maxAmountLabel = (0, $gDlNU.isDefined)(maxAmount) ? (0, $kqXxS.i18NManager).formatAmount(maxAmount) : `${maxValue}`;
        return {
            id: cardLimit[0],
            title: cardLimit[0],
            period: "",
            type: cardLimit[0],
            percentage: percentage,
            operationType: operationType,
            maxAmountLabel: maxAmountLabel,
            maxAmount: maxAmount,
            maxValue: maxValue
        };
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (card_id) try {
            const response = await (0, $kqXxS.cardManager).retrieveCard(card_id);
            setCard(response);
        } catch (e) {
            failOutstandings(e);
        }
    }, [
        card_id
    ]);
    const getOutstandings = ()=>{
        try {
            const url = (0, $eHurR.getUrlFromLink)(card.links, (0, $aWjzi.CardLinks).GetOutstandings);
            (0, $kqXxS.cardManager).getOutstandingsCard(card.id, url).then((response)=>{
                // LOGIC : If no ongoing outstandings, the API returns []. So we must at this point rely on the card's limit to display the gauges.
                if (response && response.length > 0) setupOutstandingsFromOutstandings(response);
                else setupOutstandingsFromCardLimits();
            }).catch((err)=>failOutstandings(err));
        } catch (e) {
            failOutstandings(e);
        }
    };
    /** Whatever goes wrong, the spinner has to give way; it used to spin for ever. */ const failOutstandings = (e)=>{
        (0, $6JVVB.logger).debug("CardOutstandingsScreen", "Failed to load the outstandings", e);
        setPaymentOutstandings([]);
        setCashoutOutstandings([]);
        setIsLoading(false);
    };
    const setupOutstandingsFromCardLimits = ()=>{
        if (card.limits) {
            const paymentsLimitsRaw = Object.entries(card.limits).filter((e)=>e[0].startsWith("LIMIT_PAYMENT"));
            const cashoutsLimitsRaw = Object.entries(card.limits).filter((e)=>e[0].startsWith("LIMIT_CASHOUT"));
            const c = paymentsLimitsRaw.length > 0 ? paymentsLimitsRaw.map((cardLimit)=>cardLimitToCard(cardLimit, card.currency)) : [];
            const d = cashoutsLimitsRaw.length > 0 ? cashoutsLimitsRaw.map((cardLimit)=>cardLimitToCard(cardLimit, card.currency)) : [];
            setPaymentOutstandings(c);
            setCashoutOutstandings(d);
        } else {
            setPaymentOutstandings([]);
            setCashoutOutstandings([]);
        }
        setIsLoading(false);
    };
    const setupOutstandingsFromOutstandings = (outstandings)=>{
        const paymentsRaw = outstandings.filter((e)=>e.type.startsWith("LIMIT_PAYMENT")).filter((e)=>e.maxValue > 0);
        const cashoutsRaw = outstandings.filter((e)=>e.type.startsWith("LIMIT_CASHOUT")).filter((e)=>e.maxValue > 0);
        const a = paymentsRaw.length > 0 ? paymentsRaw.map((outstanding)=>outstandingToCard(outstanding)) : [];
        const b = cashoutsRaw.length > 0 ? cashoutsRaw.map((outstanding)=>outstandingToCard(outstanding)) : [];
        const paymentsOutstandingsOrder = [
            "LIMIT_PAYMENT_DAY",
            "LIMIT_PAYMENT_WEEK",
            "LIMIT_PAYMENT_MONTH",
            "LIMIT_PAYMENT_YEAR",
            "LIMIT_PAYMENT_ALL"
        ];
        const cashoutsOutstandingsOrder = [
            "LIMIT_CASHOUT_DAY",
            "LIMIT_CASHOUT_WEEK",
            "LIMIT_CASHOUT_MONTH",
            "LIMIT_CASHOUT_YEAR",
            "LIMIT_CASHOUT_ALL"
        ];
        a.sort((c, d)=>paymentsOutstandingsOrder.indexOf(c.type) - paymentsOutstandingsOrder.indexOf(d.type));
        b.sort((c, d)=>cashoutsOutstandingsOrder.indexOf(c.type) - cashoutsOutstandingsOrder.indexOf(d.type));
        setPaymentOutstandings(a);
        setCashoutOutstandings(b);
        setIsLoading(false);
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (card.id) getOutstandings();
    }, [
        card
    ]);
    const handleRefresh = ()=>{
        setValidationMsg(true);
        setIsLoading(true);
        getOutstandings();
    };
    const handleSetDestination = (value)=>{
        setDestination(value);
    };
    const updateOutstandingLimit = (outstanding)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.CARD_UPDATE_OUTSTANDING_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $iOAO5.CardUpdateOutstandingModal), {
                card: card,
                outstanding: outstanding,
                onSuccess: ()=>handleRefresh()
            }), {
            canBeDismissed: false
        });
    };
    const canUpdateOutstandings = ()=>{
        const url = (0, $eHurR.getUrlFromLink)(card.links, (0, $aWjzi.CardLinks).UpdateLimits);
        return url !== undefined;
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($6f0e346df885334e$var$CardsSection, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($6f0e346df885334e$var$StyledPageHeader, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($6f0e346df885334e$var$CardsSectionTitle, {
                    $isRTL: isRTL,
                    children: formatMessage("cardOptions.outstandings.title")
                })
            }),
            isLoading ? /*#__PURE__*/ (0, $4m918.jsx)($6f0e346df885334e$var$StyledBlueSpinner, {}, "spinner") : /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
                children: !screenLoading && cards.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)((0, $a0LAX.EmptyCardPanel), {}) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($6f0e346df885334e$var$SelectorContainer, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $3yllK.Selector), {
                                size: "L",
                                options: [
                                    {
                                        value: (0, $Pnk5J.OutstandingsType).Payments,
                                        text: formatMessage("cardOptions.outstandings.selector.payments"),
                                        key: "payments"
                                    },
                                    {
                                        value: (0, $Pnk5J.OutstandingsType).Cashouts,
                                        text: formatMessage("cardOptions.outstandings.selector.cashouts"),
                                        key: "cashouts"
                                    }
                                ],
                                value: destination,
                                onChange: handleSetDestination
                            })
                        }),
                        isLoading ? /*#__PURE__*/ (0, $4m918.jsx)($6f0e346df885334e$var$StyledBlueSpinner, {}, "spinner") : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                            children: [
                                destination === (0, $Pnk5J.OutstandingsType).Payments && paymentOutstandings && /*#__PURE__*/ (0, $4m918.jsxs)($6f0e346df885334e$var$StyledGaugeContainer, {
                                    children: [
                                        paymentOutstandings.length === 0 && /*#__PURE__*/ (0, $4m918.jsx)($6f0e346df885334e$var$NoOutstandingsLabel, {
                                            children: formatMessage("cardOptions.outstandings.noOutstandingLabel")
                                        }),
                                        paymentOutstandings.map((e)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $6CqKu.OutstandingsGaugeView), {
                                                outstanding: e,
                                                onUpdateClick: (o)=>updateOutstandingLimit(o),
                                                canUpdate: canUpdateOutstandings()
                                            }, e.id))
                                    ]
                                }),
                                destination === (0, $Pnk5J.OutstandingsType).Cashouts && /*#__PURE__*/ (0, $4m918.jsxs)($6f0e346df885334e$var$StyledGaugeContainer, {
                                    children: [
                                        cashoutOutstandings.length === 0 && /*#__PURE__*/ (0, $4m918.jsx)($6f0e346df885334e$var$NoOutstandingsLabel, {
                                            children: formatMessage("cardOptions.outstandings.noOutstandingLabel")
                                        }),
                                        cashoutOutstandings.map((e)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $6CqKu.OutstandingsGaugeView), {
                                                outstanding: e,
                                                onUpdateClick: (o)=>updateOutstandingLimit(o),
                                                canUpdate: canUpdateOutstandings()
                                            }, e.id))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
const $6f0e346df885334e$var$NoOutstandingsLabel = (0, $jb8NR.default).p``;
const $6f0e346df885334e$var$CardsSection = (0, $jb8NR.default).section`
  align-self: stretch;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $6f0e346df885334e$var$StyledPageHeader = (0, $jb8NR.default)((0, $amCCH.PageHeader))`
  margin-bottom: 10px;
`;
const $6f0e346df885334e$var$CardsSectionTitle = (0, $jb8NR.default)((0, $jEKif.PageSectionTitle))`
  margin-right: ${(props)=>props.$isRTL ? 0 : 10}px;
  margin-left: ${(props)=>props.$isRTL ? 10 : 0}px;
`;
const $6f0e346df885334e$var$SelectorContainer = (0, $jb8NR.default).div`
  margin-top: 8px;
  margin-bottom: 32px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-bottom: 32px;
  }
`;
const $6f0e346df885334e$var$StyledGaugeContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;
const $6f0e346df885334e$var$StyledBlueSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: 40px auto 0 auto;
`;

});
parcelRegister("3yllK", function(module, exports) {

$parcel$export(module.exports, "Selector", function () { return $a88eba9d7de8f401$export$d15f4cd5286f9b1e; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $bewhU = parcelRequire("bewhU");
var $a88eba9d7de8f401$export$9b2507d2cf7278c3 = /*#__PURE__*/ function(SelectorHorizontalPadding) {
    SelectorHorizontalPadding["S"] = "10px";
    SelectorHorizontalPadding["M"] = "20px";
    SelectorHorizontalPadding["L"] = "21px";
    return SelectorHorizontalPadding;
}({});
function $a88eba9d7de8f401$export$d15f4cd5286f9b1e(props) {
    const { options: options, value: value, onChange: onChange, className: className, size: size = "M" } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)($a88eba9d7de8f401$var$SelectorRow, {
        className: className,
        children: options.filter((it)=>!it.disabled).map((it)=>/*#__PURE__*/ (0, $4m918.jsx)($a88eba9d7de8f401$var$SelectorButton, {
                onClick: ()=>onChange(it.value),
                $isRTL: isRTL,
                children: /*#__PURE__*/ (0, $4m918.jsx)($a88eba9d7de8f401$var$SelectorItem, {
                    value: it.value,
                    text: it.text,
                    selected: value === it.value,
                    size: size
                })
            }, it.key))
    });
}
const $a88eba9d7de8f401$var$SelectorButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  padding: 0 2px;
  white-space: normal;
  height: auto;
  ${(props)=>props.$isRTL ? "&:not(:last-of-type) {margin-left: 10px;}" : "&:not(:last-of-type) {margin-right: 10px;}"};
`;
const $a88eba9d7de8f401$var$SelectorRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
`;
function $a88eba9d7de8f401$var$SelectorItem(props) {
    const { text: text, selected: selected, size: size } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($a88eba9d7de8f401$var$RoundedSquare, {
        selected: selected,
        size: size,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($a88eba9d7de8f401$var$ItemLabel, {
                selected: selected,
                children: text
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($a88eba9d7de8f401$var$AnimatedOverlap, {
                selected: selected,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($a88eba9d7de8f401$var$WhiteCircle, {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($a88eba9d7de8f401$var$ThemeCircle, {})
                ]
            })
        ]
    });
}
const $a88eba9d7de8f401$var$RoundedSquare = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props)=>props.selected ? "#ffffff" : "#f4f4f4"};
  border-radius: 8px;
  height: ${(props)=>props.size == "L" ? 40 : 32}px;
  padding-left: ${({ size: size })=>$a88eba9d7de8f401$export$9b2507d2cf7278c3[size]};
  padding-right: ${({ size: size })=>$a88eba9d7de8f401$export$9b2507d2cf7278c3[size]};
  ${(props)=>props.selected ? (0, $22v9q.shadows).medium : undefined};
`;
const $a88eba9d7de8f401$var$ItemLabel = (0, $jb8NR.default).span`
  font-size: 0.9375rem;
  ${(props)=>props.selected ? (0, $22v9q.theme).boldText : (0, $22v9q.theme).text};
  text-align: center;
  color: ${(props)=>props.selected ? "#000000" : "#707070"};
`;
const $a88eba9d7de8f401$var$ThemeCircle = (0, $jb8NR.default).div`
  position: absolute;
  background-color: ${(0, $22v9q.theme).mainColor};
  width: 10px;
  height: 10px;
  border-radius: 5px;
`;
const $a88eba9d7de8f401$var$WhiteCircle = (0, $jb8NR.default).div`
  position: absolute;
  background-color: #ffffff;
  width: 14px;
  height: 14px;
  border-radius: 7px;
`;
const $a88eba9d7de8f401$var$AnimatedOverlap = (0, $jb8NR.default).div`
  display: flex;
  position: absolute;
  justify-content: center;
  bottom: -7px;
  height: 14px;
  width: 14px;
  align-items: center;
  transition: transform 0.4s;
  transform: ${(props)=>props.selected ? "scale(1)" : "scale(0)"};
  transform-origin: center;
`;

});

parcelRegister("iOAO5", function(module, exports) {

$parcel$export(module.exports, "CardUpdateOutstandingModal", function () { return $536b662ecf189cfc$export$285c2e3bbe8d393b; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $61WqT = parcelRequire("61WqT");

var $Pnk5J = parcelRequire("Pnk5J");

var $3KrBH = parcelRequire("3KrBH");

var $e4wja = parcelRequire("e4wja");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $7Zu6k = parcelRequire("7Zu6k");

var $5rJrd = parcelRequire("5rJrd");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $8Mjlc = parcelRequire("8Mjlc");

var $jNOeu = parcelRequire("jNOeu");
const $536b662ecf189cfc$export$285c2e3bbe8d393b = (props)=>{
    const { card: card, outstanding: outstanding } = props;
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)("");
    const { client: client } = (0, $7N0kU.useClient)();
    const { loading: loading, error: error, scaToken: scaToken, updateOutstanding: updateOutstanding, step: step } = (0, $3KrBH.useOutstandings)(card);
    const [updateOutstandingParams, setUpdateOutstandingParams] = (0, $6uYXW.useState)({
        limit: outstanding.type,
        valueAsAmount: outstanding.maxAmount,
        amount: outstanding.maxValue
    });
    const durationLabel = (unit)=>{
        const durationUnit = "cardOptions.outstandings.modal.inputLabelUnit";
        switch(unit){
            case (0, $Pnk5J.DurationUnit).Day:
                return durationUnit + ".day";
            case (0, $Pnk5J.DurationUnit).Week:
                return durationUnit + ".week";
            case (0, $Pnk5J.DurationUnit).Month:
                return durationUnit + ".month";
            case (0, $Pnk5J.DurationUnit).Year:
                return durationUnit + ".year";
        }
    };
    const handleOTPValidation = async (otp, scaToken)=>{
        if (scaToken) try {
            const response = await (0, $kqXxS.authenticationsSessionsService).verifyAuthentication(scaToken, otp);
            if (response.status === (0, $61WqT.VerifyAuthenticationStatus).DONE) await updateOutstanding(updateOutstandingParams, scaToken);
        } catch (e) {
            setErrorMessage(e.response?.data?.error?.message || e.toString());
        }
        else throw new Error("Missing SCA Token");
    };
    const handleSubmit = async ()=>{
        try {
            await updateOutstanding(updateOutstandingParams);
        } catch (e) {
            setErrorMessage(e.response.data.error.message);
        }
    };
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const closeModal = (0, $6uYXW.useCallback)(()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.CARD_UPDATE_OUTSTANDING_MODAL_ID)), []);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CARD_UPDATE_OUTSTANDING_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)($536b662ecf189cfc$var$StyledModalContainer, {
            children: [
                step === (0, $3KrBH.CardUpdateOutstandingStep).UpdateLimit && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($536b662ecf189cfc$var$StyledModalTitle, {
                                    children: formatMessage("cardOptions.outstandings.modal.title")
                                }),
                                outstanding.rawPeriod && /*#__PURE__*/ (0, $4m918.jsxs)($536b662ecf189cfc$var$StyledInputLabel, {
                                    children: [
                                        formatMessage("cardOptions.outstandings.modal.inputLabel"),
                                        " ",
                                        formatMessage(durationLabel(outstanding.rawPeriod?.unit))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)("div", {
                                    style: {
                                        marginTop: 12
                                    },
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $5rJrd.AmountInput), {
                                        variant: "big",
                                        id: "amount",
                                        value: updateOutstandingParams.valueAsAmount ?? null,
                                        onChange: (i)=>setUpdateOutstandingParams({
                                                ...updateOutstandingParams,
                                                valueAsAmount: i,
                                                amount: i.value
                                            })
                                    })
                                }),
                                loading && /*#__PURE__*/ (0, $4m918.jsx)($536b662ecf189cfc$var$StyledModalInner, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)($536b662ecf189cfc$var$StyledBlueSpinner, {}, "spinner")
                                }),
                                error.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($536b662ecf189cfc$var$StyledErrorLabel, {
                                    children: error
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($536b662ecf189cfc$var$StyledButton, {
                            size: "S",
                            onClick: ()=>handleSubmit(),
                            children: formatMessage("cardOptions.outstandings.modal.submitButtonLabel")
                        })
                    ]
                }),
                step === (0, $3KrBH.CardUpdateOutstandingStep).SCACheck && /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: (otp)=>handleOTPValidation(otp, scaToken),
                    errorMessage: errorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: loading
                }),
                step === (0, $3KrBH.CardUpdateOutstandingStep).Error && /*#__PURE__*/ (0, $4m918.jsx)($536b662ecf189cfc$var$StyledResultView, {
                    type: "error",
                    title: formatMessage("resultScreen.updateOutstanding.failureTitle"),
                    subtitle: formatMessage("resultScreen.updateOutstanding.failureSubtitle"),
                    description: formatMessage("resultScreen.updateOutstanding.failureDescription"),
                    error: error.response?.data?.error?.message || error.toString(),
                    onConfirm: ()=>{
                        closeModal();
                    }
                }),
                step === (0, $3KrBH.CardUpdateOutstandingStep).Success && /*#__PURE__*/ (0, $4m918.jsx)($536b662ecf189cfc$var$StyledResultView, {
                    type: "success",
                    title: formatMessage("resultScreen.updateOutstanding.successTitle"),
                    subtitle: formatMessage("resultScreen.updateOutstanding.defaultSuccessSubtitle"),
                    onConfirm: ()=>{
                        closeModal();
                    }
                })
            ]
        })
    });
};
const $536b662ecf189cfc$var$StyledButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 32px;
  align-self: center;
`;
const $536b662ecf189cfc$var$StyledInputLabel = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).bodyGreyRegular}
  font-size: 20px;
  text-align: left;
`;
const $536b662ecf189cfc$var$StyledErrorLabel = (0, $jb8NR.default).p`
  font-size: 14px;
  color: red;
  margin-top: 12px;
`;
const $536b662ecf189cfc$var$StyledResultView = (0, $jb8NR.default)((0, $jNOeu.ResultView))`
  margin-left: 20px;
  margin-right: 20px;
`;
const $536b662ecf189cfc$var$StyledMaximumLabel = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).bodyGreyRegular}
  font-size: 14px;
  margin-top: 12px;
`;
const $536b662ecf189cfc$var$StyledModalTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  padding-bottom: 40px;
  font-size: 1.125rem;
  color: #000000;
`;
const $536b662ecf189cfc$var$StyledModalContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $536b662ecf189cfc$var$StyledModalInner = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
`;
const $536b662ecf189cfc$var$StyledBlueSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))``;

});
parcelRegister("3KrBH", function(module, exports) {

$parcel$export(module.exports, "CardUpdateOutstandingStep", function () { return $ebaf94a05a7a2133$export$f94630cdf503647e; });
$parcel$export(module.exports, "useOutstandings", function () { return $ebaf94a05a7a2133$export$a2423bf5777ab286; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $eHurR = parcelRequire("eHurR");

var $aWjzi = parcelRequire("aWjzi");
var $ebaf94a05a7a2133$export$f94630cdf503647e = /*#__PURE__*/ function(CardUpdateOutstandingStep) {
    CardUpdateOutstandingStep["UpdateLimit"] = "CARD_UPDATE_LIMIT";
    CardUpdateOutstandingStep["Success"] = "CARD_UPDATE_LIMIT_SUCCESS";
    CardUpdateOutstandingStep["Error"] = "CARD_UPDATE_LIMIT_ERROR";
    CardUpdateOutstandingStep["SCACheck"] = "SCA_CHECK";
    return CardUpdateOutstandingStep;
}({});
const $ebaf94a05a7a2133$export$a2423bf5777ab286 = (card)=>{
    const outstandings = (0, $3Ersk.useObservable)((0, $kqXxS.cardManager).outstandings);
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [error, setError] = (0, $6uYXW.useState)("");
    const [step, setStep] = (0, $6uYXW.useState)("CARD_UPDATE_LIMIT");
    const [scaToken, setScaToken] = (0, $6uYXW.useState)("");
    const resetStep = ()=>{
        setStep("CARD_UPDATE_LIMIT");
    };
    const refresh = (0, $6uYXW.useCallback)(async ()=>{
        try {
            setError("");
            setLoading(true);
            const url = (0, $eHurR.getUrlFromLink)(card.links, (0, $aWjzi.CardLinks).GetOutstandings);
            await (0, $kqXxS.cardManager).getOutstandingsCard(card.id, url);
        } catch (err) {
            setError(err);
            (0, $6JVVB.logger).debug("UseOustandings: error getting outstanding", err);
        } finally{
            setLoading(false);
        }
    }, [
        card
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await refresh();
    }, []);
    const updateOutstanding = (0, $6uYXW.useCallback)(async (updateOutstandingParams, scaToken)=>{
        try {
            setError("");
            setLoading(true);
            await (0, $kqXxS.cardManager).updateOutstanding(card.id, updateOutstandingParams, scaToken);
            setStep("CARD_UPDATE_LIMIT_SUCCESS");
        } catch (e) {
            //SCA use case, must send and verify the given token
            if (e.response?.data?.error === "Unauthorized" && e.response?.data?.new_token) {
                setScaToken(e.response.data.new_token);
                setStep("SCA_CHECK");
                (0, $kqXxS.authenticationsSessionsService).sendAuthentication(e.response.data.new_token);
            } else {
                setError(e.response?.data?.error?.message);
                setStep("CARD_UPDATE_LIMIT_ERROR");
            }
        } finally{
            setLoading(false);
        }
    }, [
        card,
        setStep,
        setScaToken
    ]);
    return {
        outstandings: outstandings,
        refresh: refresh,
        loading: loading,
        error: error,
        scaToken: scaToken,
        resetStep: resetStep,
        updateOutstanding: updateOutstanding,
        step: step
    };
};

});


parcelRegister("6CqKu", function(module, exports) {

$parcel$export(module.exports, "OutstandingsGaugeView", function () { return $3a0d922d5079eb47$export$595044064fdf3d17; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $22v9q = parcelRequire("22v9q");
const $3a0d922d5079eb47$export$595044064fdf3d17 = (props)=>{
    const { outstanding: outstanding, onUpdateClick: onUpdateClick, canUpdate: canUpdate = false } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const usedColor = (0, $22v9q.theme).mainColor();
    const availableColor = (0, $22v9q.theme).mainColorLightBackground();
    const shouldReduceSize = (amountText)=>amountText.length > 10;
    const maxAmountSmallSize = shouldReduceSize(outstanding.maxAmountLabel);
    return /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$StyledCard, {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($3a0d922d5079eb47$var$CardContainer, {
            children: [
                outstanding.title ? /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$Title, {
                    children: outstanding.title
                }) : null,
                outstanding.period ? /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$Subtitle, {
                    children: outstanding.period
                }) : null,
                /*#__PURE__*/ (0, $4m918.jsxs)($3a0d922d5079eb47$var$GaugeContainer, {
                    size: 100,
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsxs)($3a0d922d5079eb47$var$GaugeArea, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)("div", {
                                    style: {
                                        marginTop: 12
                                    },
                                    children: /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$export$f747a62539aef579, {
                                        percentage: outstanding.percentage,
                                        size: 240,
                                        availableColor: availableColor,
                                        usedColor: usedColor
                                    })
                                }),
                                /*#__PURE__*/ (0, $4m918.jsxs)($3a0d922d5079eb47$var$MaxContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$MaxValue, {
                                            offsetTop: 30,
                                            isSmallSize: maxAmountSmallSize,
                                            children: outstanding.maxAmountLabel
                                        }),
                                        /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$MaxLabel, {
                                            children: outstanding.operationType
                                        })
                                    ]
                                })
                            ]
                        }),
                        outstanding.usedAmountLabel && outstanding.availableAmountLabel && /*#__PURE__*/ (0, $4m918.jsxs)($3a0d922d5079eb47$var$LegendArea, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$export$b0b33bcc0f604685, {
                                    smallSize: false,
                                    amount: outstanding.usedAmountLabel,
                                    label: formatMessage("cardOptions.outstandings.used"),
                                    color: usedColor
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$export$b0b33bcc0f604685, {
                                    smallSize: false,
                                    amount: outstanding.availableAmountLabel,
                                    label: formatMessage("cardOptions.outstandings.available"),
                                    color: availableColor
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$StyledButtonContainer, {
                            outstanding: outstanding,
                            onClick: ()=>onUpdateClick?.(outstanding),
                            children: /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$ModifyButton, {
                                children: formatMessage("cardOptions.outstandings.updateButtonLabel")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $3a0d922d5079eb47$var$StyledCard = (0, $jb8NR.default).div`
  margin-top: 20px;
  width: 300px;
  margin-right: 24px;
  margin-left: 24px;
  border-radius: 13px;
  padding: 16px;
  background-color: white;
  ${(0, $22v9q.shadows).medium};
`;
const $3a0d922d5079eb47$var$CardContainer = (0, $jb8NR.default).div`
  background-color: white;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
const $3a0d922d5079eb47$var$GaugeContainer = (0, $jb8NR.default).div`
  margin-top: 24px;
  width: ${(props)=>props.size + 150}px;
  height: ${(props)=>props.size + 150}px;
`;
const $3a0d922d5079eb47$var$Title = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  margin-bottom: 2px;
  text-align: center;
  font-size: 17px;
  color: black;
`;
const $3a0d922d5079eb47$var$Subtitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  text-align: center;
  font-size: 15px;
  color: black;
`;
const $3a0d922d5079eb47$var$GaugeArea = (0, $jb8NR.default).div`
  position: relative;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
const $3a0d922d5079eb47$var$LegendArea = (0, $jb8NR.default).div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
`;
const $3a0d922d5079eb47$var$MaxContainer = (0, $jb8NR.default).div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 80%;
  top: 20%;
  left: 52%;
  transform: translate(-50%);
  align-items: center;
  justify-content: center;
`;
const $3a0d922d5079eb47$var$MaxValue = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: ${(props)=>props.isSmallSize ? 28 : 32}px;
  color: black;
  text-align: center;
  margin-top: ${(props)=>props.offsetTop}px;
`;
const $3a0d922d5079eb47$var$MaxLabel = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText};
  font-size: 14px;
  color: #626262;
  text-align: center;
`;
const $3a0d922d5079eb47$var$ModifyButton = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).bodyGreyRegular};
  color: #626262;
  text-align: center;
  padding-left: 10px;
  cursor: pointer;
`;
const $3a0d922d5079eb47$var$StyledButtonContainer = (0, $jb8NR.default).div`
  padding: 10px 0px 0px 0px;
  margin-top: ${(props)=>props.outstanding.usedAmountLabel ? "-30px" : "-60px"};
  position: relative;
  z-index: 100000;
`;
const $3a0d922d5079eb47$export$f747a62539aef579 = (props)=>{
    const { percentage: percentage = 0, size: size, strokeWidth: strokeWidth = 14, availableColor: backColor, usedColor: color } = props;
    const radius = size / 2;
    const circleRef = (0, $6uYXW.useRef)(null);
    const halfCircle = radius + strokeWidth;
    const circleCircumference = 2 * Math.PI * radius;
    const halfCircumference = circleCircumference / 2.4;
    return /*#__PURE__*/ (0, $4m918.jsx)("div", {
        style: {
            transform: "rotate(165deg)"
        },
        children: /*#__PURE__*/ (0, $4m918.jsx)("svg", {
            width: radius * 2,
            height: radius * 2,
            viewBox: `0 0 ${halfCircle * 2} ${halfCircle * 2}`,
            children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        cx: "50%",
                        cy: "50%",
                        stroke: backColor,
                        strokeWidth: strokeWidth,
                        r: radius,
                        fill: "transparent",
                        strokeDasharray: circleCircumference,
                        strokeDashoffset: halfCircumference,
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        ref: circleRef,
                        cx: "50%",
                        cy: "50%",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        r: radius,
                        fill: "transparent",
                        strokeDasharray: circleCircumference,
                        strokeDashoffset: circleCircumference - halfCircumference * 1.4 * percentage,
                        strokeLinecap: "round"
                    })
                ]
            })
        })
    });
};
const $3a0d922d5079eb47$export$b0b33bcc0f604685 = (props)=>{
    const { amount: amount, label: label, color: color, smallSize: smallSize = false } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)("div", {
        style: {
            marginTop: -60,
            paddingVertical: 20,
            justifyContent: "center",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$Amount, {
                isSmallSize: smallSize,
                children: amount
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$Label, {
                children: label
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($3a0d922d5079eb47$var$Dot, {
                color: color?.toString(),
                size: 8
            })
        ]
    });
};
const $3a0d922d5079eb47$var$Amount = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: ${(props)=>props.isSmallSize ? 16 : 18}px;
  color: black;
  line-height: ${(props)=>props.isSmallSize ? 20 : 22}px;
  text-align: center;
  margin: 0 7px 1px 6px;
  max-width: 120px;
`;
const $3a0d922d5079eb47$var$Label = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  font-size: 12px;
  color: black;
  line-height: 16px;
  margin: 1px 0 0;
  text-align: left;
`;
const $3a0d922d5079eb47$var$Dot = (0, $jb8NR.default).div`
  background-color: ${(props)=>props.color};
  margin: 5px 28px 0 29px;
  border-radius: 10px;
  width: ${(props)=>props.size};
  height: ${(props)=>props.size};
`;

});


parcelRegister("g9I8n", function(module, exports) {

$parcel$export(module.exports, "ConnectScreen", function () { return $7ebf30f89f17effa$export$649ef710399df613; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $e4wja = parcelRequire("e4wja");

var $4fYE4 = parcelRequire("4fYE4");

var $31CeI = parcelRequire("31CeI");

var $yYT9n = parcelRequire("yYT9n");

var $aP6ve = parcelRequire("aP6ve");

var $40sjz = parcelRequire("40sjz");

var $bewhU = parcelRequire("bewhU");

var $7Zu6k = parcelRequire("7Zu6k");

var $d0gXD = parcelRequire("d0gXD");

var $bkbe2 = parcelRequire("bkbe2");

var $ZE1cB = parcelRequire("ZE1cB");

var $eyjPK = parcelRequire("eyjPK");

var $cAn8H = parcelRequire("cAn8H");

var $gxFwH = parcelRequire("gxFwH");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $kYdKS = parcelRequire("kYdKS");

var $8Mjlc = parcelRequire("8Mjlc");

var $eVe7X = parcelRequire("eVe7X");

var $7u30r = parcelRequire("7u30r");
const $7ebf30f89f17effa$var$centeredStates = [
    (0, $40sjz.PincodeState).PromptingKeyboard,
    (0, $40sjz.PincodeState).FetchKeyboardAfterError,
    (0, $aP6ve.ConnectState).ValidatePincode,
    (0, $aP6ve.ConnectState).OTPSubmission,
    (0, $aP6ve.ConnectState).OTPConfirming
];
const $7ebf30f89f17effa$export$577926c98bcbfc24 = "idx";
const $7ebf30f89f17effa$export$649ef710399df613 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const history = (0, $NQIVp.useHistory)();
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const phoneParam = (0, $31CeI.useQueryParam)("phone");
    const defaultCountry = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).defaultCountry);
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)(defaultCountry);
    const [phoneNumber, setPhoneNumber] = (0, $6uYXW.useState)(phoneParam || "");
    const { state: state, context: context, showContactSupport: showContactSupport, phoneLoading: phoneLoading, phoneError: phoneError, checkPhoneNumber: checkPhoneNumber, confirmOtp: confirmOtp, submitPinCode: submitPinCode } = (0, $aP6ve.useConnectMachine)();
    const goToRoot = ()=>{
        history.replace((0, $4fYE4.Path).Root);
    };
    const errorMessage = context.errorMessage;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const goToRegisterPage = ()=>{
        const path = features.sdaCustomerOnboardingCreate ? (0, $4fYE4.Path).Onboarding : (0, $4fYE4.Path).Register;
        history.push(path);
    };
    const renderInnerStep = ()=>{
        switch(state){
            case (0, $aP6ve.ConnectState).WaitingForPhoneNumber:
            case (0, $40sjz.PincodeState).PincodeConfirmation:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $7u30r.ConnectInputNumber), {
                            onLostPhoneClick: showContactSupport,
                            error: phoneError,
                            onUpdatePhone: setPhoneNumber,
                            onUpdateCountryCode: setCountryCode,
                            currentCountryCode: countryCode,
                            initialValue: phoneNumber
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($7ebf30f89f17effa$var$BottomContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$SubmitButton, {
                                    size: "M",
                                    onClick: ()=>checkPhoneNumber(phoneNumber, countryCode),
                                    showSpinner: phoneLoading,
                                    children: formatMessage("connectScreen.connectButton")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsxs)($7ebf30f89f17effa$var$RowContainer, {
                                    withLargeTopOffset: true,
                                    children: [
                                        /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$RowQuestion, {
                                            children: formatMessage("connectScreen.registerQuestion")
                                        }),
                                        /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$RowLink, {
                                            onClick: goToRegisterPage,
                                            children: formatMessage("connectScreen.registerButton")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case (0, $aP6ve.ConnectState).ContactSupport:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $eVe7X.ConnectContactSupport), {}),
                        /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$BottomContainer, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$SubmitButton, {
                                size: "M",
                                onClick: ()=>goToRoot(),
                                children: formatMessage("connectScreen.contactSupport.done")
                            })
                        })
                    ]
                });
            case (0, $40sjz.PincodeState).PromptingKeyboard:
            case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
            case (0, $aP6ve.ConnectState).ValidatePincode:
                {
                    const keyboard = context.keyboard;
                    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$CenteredTitle, {
                                children: formatMessage("connectScreen.pincodeTitle")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                                keyboard: keyboard,
                                onSubmit: (pincode)=>submitPinCode(pincode),
                                title: formatMessage("pincodeConfirmation.label"),
                                loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError,
                                errorMessage: errorMessage,
                                keyColor: "white"
                            })
                        ]
                    });
                }
            case (0, $aP6ve.ConnectState).OTPSubmission:
            case (0, $aP6ve.ConnectState).OTPConfirming:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$CenteredTitle, {
                            children: formatMessage("connectScreen.otpTitle")
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                            submitOtp: confirmOtp,
                            phoneNumber: context.phone ? (0, $e4wja.anonymizePhoneNumber)(context.phone, 2) : undefined,
                            errorMessage: errorMessage,
                            explanationColor: "#b1b1b1"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$BottomContainer, {
                            children: /*#__PURE__*/ (0, $4m918.jsxs)($7ebf30f89f17effa$var$RowContainer, {
                                withLargeTopOffset: false,
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$RowQuestion, {
                                        children: formatMessage("connectScreen.noCodeQuestion")
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$RowButton, {
                                        onClick: showContactSupport,
                                        children: formatMessage("connectScreen.contactSupportLink")
                                    })
                                ]
                            })
                        })
                    ]
                });
            case (0, $aP6ve.ConnectState).Connected:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
                    to: {
                        pathname: (0, $4fYE4.Path).AccountTransactions
                    }
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($7ebf30f89f17effa$var$Page, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($7ebf30f89f17effa$var$MainRow, {
                $isRTL: isRTL,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$LeftPanel, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$LeftImage, {
                            src: (0, $fRvTz.StaticAssets).registerImage
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($7ebf30f89f17effa$var$CenterPanel, {
                        isCentered: $7ebf30f89f17effa$var$centeredStates.includes(state),
                        $isRTL: isRTL,
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$Logo, {
                                src: (0, $fRvTz.StaticAssets).logo,
                                onClick: goToRoot
                            }),
                            renderInnerStep(),
                            /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$Spacer, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$RightPanel, {
                        $isRTL: isRTL,
                        children: state == (0, $aP6ve.ConnectState).WaitingForPhoneNumber && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsxs)($7ebf30f89f17effa$var$TopRightContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $4m918.jsx)((0, $bkbe2.ExternalSites), {}),
                                        /*#__PURE__*/ (0, $4m918.jsx)((0, $gxFwH.StoreButtons), {
                                            showIsAvailable: true,
                                            smallVersion: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$Spacer, {}),
                                /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$HelpContainer, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $d0gXD.BankContact), {})
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($7ebf30f89f17effa$var$BottomRow, {
                $isRTL: isRTL,
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $kYdKS.VersionBox), {})
            })
        ]
    });
};
const $7ebf30f89f17effa$var$Page = (0, $jb8NR.default)((0, $cAn8H.ResponsiveContainer))`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 0;
  margin: 0;
`;
const $7ebf30f89f17effa$var$MainRow = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1 0 auto;
  overflow: hidden;
  width: auto;
  margin-left: ${(props)=>props.$isRTL ? 0 : 20}px;
  margin-right: ${(props)=>props.$isRTL ? 20 : 0}px;
  padding: 0 20px;
  justify-content: stretch;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
    align-items: stretch;

    margin-left: 10px;
    margin-right: 10px;
    padding-top: 0px;
    margin-top: 0px;
  }
`;
const $7ebf30f89f17effa$var$BottomRow = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
  margin: 0;
  padding: 0 42px 10px 42px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    padding: 0 30px 10px 30px;
  }
`;
const $7ebf30f89f17effa$var$LeftPanel = (0, $jb8NR.default).div`
  justify-content: center;
  flex-direction: column;
  margin: 0;
  width: 40%;
  width: 600px;
  max-height: 754px;
  padding: 30px 0 10px 0;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    max-width: 0;
  }
`;
const $7ebf30f89f17effa$var$CenterPanel = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  max-width: 660px;
  width: 660px;
  padding: ${(props)=>props.isCentered ? "100px 40px 10px 40px" : props.$isRTL ? "100px 100px 10px 50px" : "100px 50px 10px 100px"};
  margin: 10px 0;
  align-items: ${(props)=>props.isCentered ? "center" : "flex-start"};

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    padding: 0 0 20px 0;
    margin: -20px 0 0 0;
    max-width: 414px;
    width: 100%;
    justify-content: flex-start;
  }
`;
const $7ebf30f89f17effa$var$RightPanel = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 10px 0;
  align-items: flex-end;
  padding: 30px 10px 0 10px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    align-items: flex-start;
    max-width: 414px;
    width: auto;
    padding: 30px 0 20px 0;
  }
`;
const $7ebf30f89f17effa$var$Spacer = (0, $jb8NR.default).div`
  flex-grow: 1;
`;
const $7ebf30f89f17effa$var$LeftImage = (0, $jb8NR.default).img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 21px;
  ${(0, $22v9q.shadows).medium};
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    width: 0;
    opacity: 0;
  }
`;
const $7ebf30f89f17effa$var$Logo = (0, $jb8NR.default).img`
  width: 112px;
  height: 112px;
  object-fit: contain;
  margin-top: 0;
  margin-bottom: 8px;
  &:hover {
    cursor: pointer;
  }

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-bottom: 0;
  }
`;
const $7ebf30f89f17effa$var$BottomContainer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $7ebf30f89f17effa$var$SubmitButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $7ebf30f89f17effa$var$RowContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  margin-top: ${(props)=>props.withLargeTopOffset ? 48 : 12}px;
  white-space: pre;
  align-items: baseline;
`;
const $7ebf30f89f17effa$var$RowQuestion = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.8125rem;
  color: #b1b1b1;
`;
const $7ebf30f89f17effa$var$RowLink = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.8125rem;
  color: black;
  text-decoration: underline;
  margin-right: 4px;
  margin-left: 4px;
`;
const $7ebf30f89f17effa$var$RowButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.8125rem;
  color: black;
  text-decoration: underline;
`;
const $7ebf30f89f17effa$var$CenteredTitle = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText}
  font-size: 1.875rem;
  margin-bottom: 24px;
  text-align: center;
`;
const $7ebf30f89f17effa$var$TopRightContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
`;
const $7ebf30f89f17effa$var$HelpContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    gap: 12px;
    margin-top: 40px;
  }
`;

});
parcelRegister("aP6ve", function(module, exports) {

$parcel$export(module.exports, "useConnectMachine", function () { return $e2b02d63e747d1a5$export$1d1e4541c209ebdc; });
$parcel$export(module.exports, "ConnectState", function () { return $e2b02d63e747d1a5$export$3f668acd0d0c878b; });

var $lCuQx = parcelRequire("lCuQx");

var $8Ba1X = parcelRequire("8Ba1X");

var $6uYXW = parcelRequire("6uYXW");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $e4wja = parcelRequire("e4wja");

var $40sjz = parcelRequire("40sjz");
const $e2b02d63e747d1a5$export$1d1e4541c209ebdc = ()=>{
    const [state, sendEvent] = (0, $lCuQx.useMachine)($e2b02d63e747d1a5$export$8299bb2cf1db860b);
    const [phoneError, setPhoneError] = (0, $6uYXW.useState)("");
    const [phoneLoading, setPhoneLoading] = (0, $6uYXW.useState)(false);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const showContactSupport = ()=>{
        sendEvent("CONTACT_SUPPORT");
    };
    const goBack = ()=>{
        sendEvent("GO_BACK");
    };
    const submitPinCode = async (pincode)=>{
        const pendingEnrollment = await (0, $kqXxS.registerManager).loadPendingEnrollment();
        sendEvent("SUBMIT_PINCODE", {
            pincode: pincode,
            ...pendingEnrollment?.preAuth?.metadata.enrollmentId && {
                registerParams: {
                    enrollment_id: pendingEnrollment?.preAuth?.metadata.enrollmentId
                }
            }
        });
    };
    const confirmOtp = (otp)=>{
        sendEvent("OTP_CONFIRM", {
            otp: otp
        });
    };
    const checkPhoneNumber = async (phone, countryCode)=>{
        try {
            setPhoneLoading(true);
            setPhoneError("");
            const phoneNumberParsed = (0, $8Ba1X.parsePhoneNumberFromString)(phone, countryCode);
            if (!phoneNumberParsed) throw formatMessage("common.invalidPhoneNumber");
            const prefixedPhoneNumber = phoneNumberParsed.number.substring(1);
            const hasAccount = await (0, $kqXxS.loginService).checkPhoneNumber(prefixedPhoneNumber);
            setPhoneLoading(false);
            if (hasAccount) sendEvent("PHONE_NUMBER_CHECKED", {
                phone: prefixedPhoneNumber
            });
            else setPhoneError(formatMessage("connectScreen.noAccountError", {
                phoneNumber: (0, $e4wja.formatPhoneNumber)(phoneNumberParsed.number.substring(1))
            }));
        } catch (e) {
            setPhoneLoading(false);
            setPhoneError(e);
        }
    };
    return {
        state: state.value,
        context: state.context,
        phoneLoading: phoneLoading,
        phoneError: phoneError,
        showContactSupport: showContactSupport,
        goBack: goBack,
        checkPhoneNumber: checkPhoneNumber,
        submitPinCode: submitPinCode,
        confirmOtp: confirmOtp
    };
};
var $e2b02d63e747d1a5$export$3f668acd0d0c878b = /*#__PURE__*/ function(ConnectState) {
    ConnectState["WaitingForPhoneNumber"] = "WAITING_FOR_PHONE_NUMBER";
    ConnectState["ContactSupport"] = "CONTACT_SUPPORT";
    ConnectState["ValidatePincode"] = "VALIDATE_PINCODE";
    ConnectState["OTPSubmission"] = "OTP_SUBMISSION";
    ConnectState["OTPConfirming"] = "OTP_CONFIRMING";
    ConnectState["Connected"] = "CONNECTED";
    return ConnectState;
}({});
var $e2b02d63e747d1a5$var$ConnectInvokeName = /*#__PURE__*/ function(ConnectInvokeName) {
    ConnectInvokeName["FetchKeyboard"] = "FetchKeyboard";
    ConnectInvokeName["PincodeValidating"] = "PincodeValidating";
    ConnectInvokeName["OtpSubmitting"] = "OtpSubmitting";
    ConnectInvokeName["OtpRefreshing"] = "OtpRefresihng";
    ConnectInvokeName["OtpConfirming"] = "OtpConfirming";
    ConnectInvokeName["Connected"] = "Connected";
    return ConnectInvokeName;
}($e2b02d63e747d1a5$var$ConnectInvokeName || {});
const $e2b02d63e747d1a5$export$8299bb2cf1db860b = (0, $TAle5.Machine)({
    id: "Connect",
    initial: "WAITING_FOR_PHONE_NUMBER",
    states: {
        ["WAITING_FOR_PHONE_NUMBER"]: {
            on: {
                PHONE_NUMBER_CHECKED: {
                    target: (0, $40sjz.PincodeState).PincodeConfirmation,
                    actions: (0, $c8ePo.assign)({
                        phone: (_, event)=>event.phone
                    })
                },
                CONTACT_SUPPORT: "CONTACT_SUPPORT"
            }
        },
        [(0, $40sjz.PincodeState).PincodeConfirmation]: {
            invoke: {
                id: "FetchKeyboard",
                src: (ctx)=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), ctx.phone, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboard]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "VALIDATE_PINCODE",
                    actions: (0, $c8ePo.assign)({
                        pincode: (_, event)=>event.pincode,
                        registerParams: (_, event)=>event.registerParams
                    })
                },
                GO_BACK: {
                    target: "WAITING_FOR_PHONE_NUMBER"
                }
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
            invoke: {
                id: "FetchKeyboard",
                src: (ctx)=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), ctx.phone, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        ["VALIDATE_PINCODE"]: {
            invoke: {
                id: "PincodeValidating",
                src: (ctx)=>(0, $kqXxS.authenticationManager).askWebAuthentOtp(ctx.pincode, ctx.registerParams),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            errorMessage: undefined
                        }),
                        (0, $c8ePo.send)((event)=>({
                                type: event.registerParams ? "OTP_CONFIRMED" : "PINCODE_VALIDATED"
                            }))
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            errorMessage: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PINCODE_ERROR"
                        })
                    ]
                }
            },
            on: {
                PINCODE_ERROR: (0, $40sjz.PincodeState).FetchKeyboardAfterError,
                PINCODE_VALIDATED: "OTP_SUBMISSION",
                OTP_CONFIRMED: "CONNECTED"
            }
        },
        ["OTP_SUBMISSION"]: {
            on: {
                OTP_CONFIRM: {
                    target: "OTP_CONFIRMING",
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    actions: (0, $c8ePo.assign)({
                        otp: (_, event)=>event.otp
                    })
                },
                CONTACT_SUPPORT: "CONTACT_SUPPORT"
            }
        },
        ["OTP_CONFIRMING"]: {
            invoke: {
                id: "OtpConfirming",
                src: (ctx)=>(0, $kqXxS.authenticationManager).validateWebAuthentOtp(ctx.otp),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            errorMessage: undefined
                        }),
                        (0, $c8ePo.send)({
                            type: "OTP_CONFIRMED"
                        })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            errorMessage: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "OTP_ERROR"
                        })
                    ]
                }
            },
            on: {
                OTP_ERROR: "OTP_SUBMISSION",
                OTP_CONFIRMED: "CONNECTED",
                CONTACT_SUPPORT: "CONTACT_SUPPORT"
            }
        },
        ["CONTACT_SUPPORT"]: {
            type: "final"
        },
        ["CONNECTED"]: {
            type: "final",
            invoke: {
                id: "Connected",
                src: async (ctx)=>{
                    await (0, $kqXxS.registerManager).clearPendingEnrollment();
                    return (0, $kqXxS.uuidManager).setUuid(ctx.pincode.id);
                }
            }
        }
    }
});

});

parcelRegister("d0gXD", function(module, exports) {

$parcel$export(module.exports, "BankContact", function () { return $48591f704f65a535$export$7633f7e46da4a560; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $fplBl = parcelRequire("fplBl");

var $3Ersk = parcelRequire("3Ersk");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $i1jpl = parcelRequire("i1jpl");

var $dmWk7 = parcelRequire("dmWk7");

var $ku6TL = parcelRequire("ku6TL");

var $37D4z = parcelRequire("37D4z");
const $48591f704f65a535$export$7633f7e46da4a560 = (props)=>{
    const { withBigButtons: bigSection } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const { contactEmail: contactEmail, contactPhone: contactPhone } = configuration;
    const infoUrl = (0, $kqXxS.configurationManager).getBestInfoUrlLocale();
    const [phoneTooltipVisible, setPhoneTooltipVisible] = (0, $6uYXW.useState)(false);
    const [mailTooltipVisible, setMailTooltipVisible] = (0, $6uYXW.useState)(false);
    const [webTooltipVisible, setWebTooltipVisible] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: bigSection ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
            children: [
                (0, $gDlNU.isDefined)(contactEmail) && /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$StyledContactLink, {
                    type: "email",
                    href: (0, $fplBl.buildLinkMailTo)(contactEmail)
                }),
                (0, $gDlNU.isDefined)(contactPhone) && /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$StyledContactLink, {
                    type: "phone",
                    href: (0, $fplBl.buildLinkPhoneTo)(contactPhone)
                }),
                (0, $gDlNU.isDefined)(infoUrl) && /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$StyledContactLink, {
                    href: infoUrl,
                    type: "website"
                })
            ]
        }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$HelpQuestion, {
                    children: formatMessage("bankContactScreen.question")
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($48591f704f65a535$var$HelpButtonsContainer, {
                    children: [
                        (0, $gDlNU.isDefined)(contactPhone) && /*#__PURE__*/ (0, $4m918.jsxs)($48591f704f65a535$var$HelpContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$HelpTip, {
                                    $isVisible: phoneTooltipVisible,
                                    children: formatMessage("bankContactScreen.phoneContact")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$HelpButton, {
                                    onMouseEnter: ()=>setPhoneTooltipVisible(true),
                                    onMouseLeave: ()=>setPhoneTooltipVisible(false),
                                    type: "phone",
                                    href: (0, $fplBl.buildLinkPhoneTo)(contactPhone),
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $dmWk7.ContactPhoneIcon), {
                                        color: "black",
                                        width: 20,
                                        height: 20
                                    })
                                })
                            ]
                        }),
                        (0, $gDlNU.isDefined)(contactEmail) && /*#__PURE__*/ (0, $4m918.jsxs)($48591f704f65a535$var$HelpContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$HelpTip, {
                                    $isVisible: mailTooltipVisible,
                                    children: formatMessage("bankContactScreen.emailContact")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$HelpButton, {
                                    onMouseEnter: ()=>setMailTooltipVisible(true),
                                    onMouseLeave: ()=>setMailTooltipVisible(false),
                                    type: "email",
                                    href: (0, $fplBl.buildLinkMailTo)(contactEmail),
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $i1jpl.ContactEmailIcon), {
                                        color: "black",
                                        width: 20,
                                        height: 20
                                    })
                                })
                            ]
                        }),
                        (0, $gDlNU.isDefined)(infoUrl) && /*#__PURE__*/ (0, $4m918.jsxs)($48591f704f65a535$var$HelpContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$HelpTip, {
                                    $isVisible: webTooltipVisible,
                                    children: formatMessage("bankContactScreen.urlContact")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($48591f704f65a535$var$HelpButton, {
                                    onMouseEnter: ()=>setWebTooltipVisible(true),
                                    onMouseLeave: ()=>setWebTooltipVisible(false),
                                    type: "website",
                                    href: infoUrl,
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $ku6TL.QuestionIcon), {
                                        color: "black",
                                        width: 20,
                                        height: 20
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $48591f704f65a535$var$StyledContactLink = (0, $jb8NR.default)((0, $37D4z.ContactLink))`
  &:not(:last-of-type) {
    margin-bottom: 64px;
    @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
      margin-bottom: 34px;
    }
  }
`;
const $48591f704f65a535$var$HelpQuestion = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.8125rem;
  color: #b1b1b1;
`;
const $48591f704f65a535$var$HelpContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;
const $48591f704f65a535$var$HelpTip = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  color: white;
  font-size: 0.825rem;
  text-align: center;
  height: 23px;
  width: auto;
  padding: 3px 8px;
  border-radius: 8px;
  background-color: #1a1c1e;
  display: inline-block;
  position: absolute;
  opacity: ${(props)=>props.$isVisible ? 1 : 0};
  margin-top: -32px;
  z-index: 10;
  transition: opacity 0.3s ease-in;
`;
const $48591f704f65a535$var$HelpButton = (0, $jb8NR.default).a`
  background-color: #e2e2e2;
  width: 40px;
  height: 40px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const $48591f704f65a535$var$HelpButtonsContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

});
parcelRegister("fplBl", function(module, exports) {

$parcel$export(module.exports, "buildLinkMailTo", function () { return $e441730bb161418d$export$e8772e7530182cf8; });
$parcel$export(module.exports, "buildLinkPhoneTo", function () { return $e441730bb161418d$export$7a69e1f027b042e3; });
const $e441730bb161418d$export$e8772e7530182cf8 = (email)=>`mailto:${email}`;
const $e441730bb161418d$export$7a69e1f027b042e3 = (phoneNumber)=>`tel:${phoneNumber}`;

});

parcelRegister("i1jpl", function(module, exports) {

$parcel$export(module.exports, "ContactEmailIcon", function () { return $87b584c601cf687c$export$d8dc06b34c9cb388; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $87b584c601cf687c$export$d8dc06b34c9cb388 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M.5.5h18v18H.5z"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M4.115 4.654h10.77c.85 0 1.538.689 1.538 1.538v6.923c0 .85-.689 1.539-1.538 1.539H4.115c-.85 0-1.538-.689-1.538-1.539V6.192c0-.85.689-1.538 1.538-1.538zm10.111 1.415L9.5 8.614 4.774 6.069a.577.577 0 0 0-.548 1.016l5 2.692c.171.092.377.092.548 0l5-2.692a.577.577 0 0 0-.548-1.016z",
                    fill: props.color ?? "#000",
                    fillRule: "nonzero"
                })
            ]
        })
    });

});

parcelRegister("dmWk7", function(module, exports) {

$parcel$export(module.exports, "ContactPhoneIcon", function () { return $70863e19c65f7130$export$a8ddaad0f9d510b3; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $70863e19c65f7130$export$a8ddaad0f9d510b3 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M0 0h26v26H0z"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M20.96 5.395a.542.542 0 0 1 .102.14l1.196 2.393a4.753 4.753 0 0 1-.89 5.486l-6.499 6.5a5.88 5.88 0 0 1-6.016 1.42l-2.616-.872a.542.542 0 0 1-.212-.897l2.872-2.873a2.167 2.167 0 0 1 2.501-.405l.27.135a2.167 2.167 0 0 0 2.502-.406l2.388-2.388c.66-.66.823-1.667.406-2.5l-.136-.271a2.167 2.167 0 0 1 .406-2.501l2.96-2.96a.542.542 0 0 1 .767 0zm-5.254-3.204-.2 2.157a9.726 9.726 0 0 0-7.803 2.814 9.726 9.726 0 0 0-2.814 7.79l-2.158.199a11.892 11.892 0 0 1 3.44-9.521 11.892 11.892 0 0 1 9.535-3.44zm-.379 4.317-.207 2.156a5.403 5.403 0 0 0-4.352 1.562 5.402 5.402 0 0 0-1.563 4.337l-2.158.201a7.569 7.569 0 0 1 2.189-6.07 7.569 7.569 0 0 1 6.091-2.186z",
                    fill: props.color ?? "#000"
                })
            ]
        })
    });

});

parcelRegister("ku6TL", function(module, exports) {

$parcel$export(module.exports, "QuestionIcon", function () { return $f3ae8282366c0cf1$export$f314ed182f5da2a0; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $f3ae8282366c0cf1$export$f314ed182f5da2a0(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 2.538a8.462 8.462 0 1 0 0 16.923 8.462 8.462 0 0 0 0-16.923zm.846 13.116c0 .233-.19.423-.423.423h-.846a.423.423 0 0 1-.423-.423v-.846c0-.234.19-.424.423-.424h.846c.234 0 .423.19.423.424v.846zm.745-4.409a2.445 2.445 0 0 0 1.692-2.31v-.473a2.437 2.437 0 0 0-2.437-2.437h-1.692a2.437 2.437 0 0 0-2.437 2.437v.423c0 .233.19.423.423.423h.643c.234 0 .423-.19.423-.423v-.423c0-.524.424-.948.948-.948h1.692a.948.948 0 0 1 .982.948v.473a.956.956 0 0 1-.643.906l-.804.262a1.59 1.59 0 0 0-1.092 1.506v.66c0 .234.19.423.423.423h.643c.234 0 .423-.19.423-.423v-.66a.11.11 0 0 1 .068-.101l.745-.263z"
        })
    });
}

});

parcelRegister("37D4z", function(module, exports) {

$parcel$export(module.exports, "ContactLink", function () { return $07397919c4177983$export$96c211badc9d5a98; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $7wSRt = parcelRequire("7wSRt");

var $lFDz4 = parcelRequire("lFDz4");

var $033LV = parcelRequire("033LV");

var $6BZKL = parcelRequire("6BZKL");
const $07397919c4177983$var$ContactLinkType = {
    email: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $7wSRt.PenIcon), {}),
        label: "bankContactScreen.emailContact"
    },
    website: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $6BZKL.QuestionMarkIcon), {}),
        label: "bankContactScreen.urlContact"
    },
    phone: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $lFDz4.PhoneIcon), {}),
        label: "bankContactScreen.phoneContact"
    },
    address: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $033LV.PinIcon), {}),
        label: "bankContactScreen.addressContact"
    }
};
function $07397919c4177983$export$96c211badc9d5a98(props) {
    const { type: type, ...rest } = props;
    const linkAttributes = type === "website" && {
        target: "_blank",
        rel: "noopener noreferrer nofollow"
    };
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($07397919c4177983$var$OutsideLink, {
        ...linkAttributes,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($07397919c4177983$var$IconSquare, {
                children: $07397919c4177983$var$ContactLinkType[type].icon
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($07397919c4177983$var$Label, {
                children: formatMessage($07397919c4177983$var$ContactLinkType[type].label)
            })
        ]
    });
}
function $07397919c4177983$export$c9ce65124d222c64(props) {
    const { type: type, value: value, ...rest } = props;
    const linkAttributes = type === "website" && {
        target: "_blank",
        rel: "noopener noreferrer nofollow"
    };
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)($07397919c4177983$var$OutsideLink, {
        ...linkAttributes,
        ...rest,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($07397919c4177983$var$CardContainer, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($07397919c4177983$var$IconSquare, {
                    children: $07397919c4177983$var$ContactLinkType[type].icon
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($07397919c4177983$var$Column, {
                    $isRTL: isRTL,
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($07397919c4177983$var$CardContactLabel, {
                            children: formatMessage($07397919c4177983$var$ContactLinkType[type].label)
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($07397919c4177983$var$CardContactValue, {
                            children: value
                        })
                    ]
                })
            ]
        })
    });
}
const $07397919c4177983$var$OutsideLink = (0, $jb8NR.default).a`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $07397919c4177983$var$IconSquare = (0, $jb8NR.default).div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  border-radius: 18px;
  ${(0, $22v9q.shadows).medium};
  background-color: ${(0, $22v9q.theme).mainColor};
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 26px;
    height: 26px;
    object-fit: contain;
    fill: #ffffff;
  }
`;
const $07397919c4177983$var$Label = (0, $jb8NR.default).span`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).mediumText};
  color: #000000;
  text-align: center;
`;
const $07397919c4177983$var$CardContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 25px;
  ${(0, $22v9q.shadows).medium};
  border-radius: 18px;
  height: 120px;
  width: ${(0, $7XqbX.UIConstants).CONTACT_TILE_WIDTH_NOT_MOBILE}px;
  min-height: 120px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    width: ${(0, $7XqbX.UIConstants).CONTACT_TILE_WIDTH_MOBILE}px;
  }
  background-color: #ffffff;
`;
const $07397919c4177983$var$Column = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${(props)=>props.$isRTL ? 0 : 15}px;
  margin-right: ${(props)=>props.$isRTL ? 15 : 0}px;
`;
const $07397919c4177983$var$CardContactLabel = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText};
  color: #000000;
  margin-bottom: 10px;
  font-size: 0.9375rem;
`;
const $07397919c4177983$var$CardContactValue = (0, $jb8NR.default).span`
  font-size: 0.9375rem;
  word-break: break-word;
  color: #b1b1b1;
  direction: ltr;
`;

});
parcelRegister("lFDz4", function(module, exports) {

$parcel$export(module.exports, "PhoneIcon", function () { return $a4cebe6fff89ca0c$export$54336acd81078d46; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $a4cebe6fff89ca0c$export$54336acd81078d46(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M20.96 5.395c.042.041.076.089.102.14l1.196 2.393c.915 1.83.556 4.04-.89 5.486l-6.499 6.5c-1.575 1.574-3.904 2.124-6.016 1.42l-2.616-.872c-.284-.095-.437-.402-.343-.686.027-.08.072-.152.131-.211l2.872-2.873c.66-.659 1.667-.823 2.501-.405l.27.135c.835.417 1.843.253 2.502-.406l2.388-2.388c.66-.66.823-1.667.406-2.5l-.136-.271c-.417-.834-.253-1.842.406-2.501l2.96-2.96c.212-.212.555-.212.767 0zm-5.254-3.204l-.2 2.157c-2.872-.267-5.723.735-7.803 2.814-2.076 2.076-3.077 4.922-2.814 7.79l-2.158.199c-.321-3.503.904-6.985 3.44-9.521 2.54-2.54 6.028-3.765 9.535-3.44zm-.379 4.317l-.207 2.156c-1.602-.154-3.193.402-4.352 1.562-1.156 1.156-1.712 2.74-1.563 4.337l-2.158.201c-.208-2.232.572-4.453 2.189-6.07 1.622-1.622 3.852-2.401 6.091-2.186z"
        })
    });
}

});

parcelRegister("033LV", function(module, exports) {

$parcel$export(module.exports, "PinIcon", function () { return $5f9bb741f382d7d4$export$8dedaee0e594ee0e; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $5f9bb741f382d7d4$export$8dedaee0e594ee0e(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M13 3.25c4.188 0 7.583 3.395 7.583 7.583 0 3.367-2.193 6.221-5.23 7.211L13 22.75l-2.352-4.705-.221-.076c-2.922-1.054-5.01-3.85-5.01-7.136C5.417 6.645 8.812 3.25 13 3.25zm0 5.417c-1.197 0-2.167.97-2.167 2.166 0 1.197.97 2.167 2.167 2.167 1.197 0 2.167-.97 2.167-2.167 0-1.196-.97-2.166-2.167-2.166z",
            transform: "translate(17 17)"
        })
    });
}

});

parcelRegister("6BZKL", function(module, exports) {

$parcel$export(module.exports, "QuestionMarkIcon", function () { return $559568c4ef76baa1$export$58a334b597cee6d6; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $559568c4ef76baa1$export$58a334b597cee6d6(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M13 3C7.477 3 3 7.477 3 13s4.477 10 10 10 10-4.477 10-10c0-2.652-1.054-5.196-2.929-7.071C18.196 4.054 15.652 3 13 3zm1 15.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5v-1c0-.276.224-.5.5-.5h1c.276 0 .5.224.5.5v1zm2.88-7.94c-.008 1.246-.815 2.346-2 2.73l-.88.31c-.048.02-.08.068-.08.12v.78c0 .276-.224.5-.5.5h-.76c-.276 0-.5-.224-.5-.5v-.78c.002-.81.522-1.526 1.29-1.78l.95-.31c.456-.158.761-.588.76-1.07V10c0-.304-.123-.595-.342-.806-.219-.212-.514-.325-.818-.314h-2c-.619 0-1.12.501-1.12 1.12v.5c0 .276-.224.5-.5.5h-.76c-.276 0-.5-.224-.5-.5V10c0-1.59 1.29-2.88 2.88-2.88h2c.764 0 1.496.303 2.036.844.54.54.844 1.272.844 2.036v.56z"
        })
    });
}

});



parcelRegister("bkbe2", function(module, exports) {

$parcel$export(module.exports, "ExternalSites", function () { return $aca268df8554b730$export$aa4502510b82c6fb; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $5hpYi = parcelRequire("5hpYi");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $bewhU = parcelRequire("bewhU");
const $aca268df8554b730$export$aa4502510b82c6fb = (props)=>{
    const { centerWhenSmall: centerWhenSmall } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const externalLinks = (0, $6uYXW.useMemo)(()=>{
        const links = [];
        if ((0, $dhPTb.Config).COMPANY_PORTAL_URL) links.push({
            url: (0, $dhPTb.Config).COMPANY_PORTAL_URL,
            question: formatMessage("authScreen.goToCompanyPortalQuestion"),
            linkLabel: formatMessage("authScreen.goToCompanyPortalLink")
        });
        if ((0, $dhPTb.Config).PARTNERS_PORTAL_URL) links.push({
            url: (0, $dhPTb.Config).PARTNERS_PORTAL_URL,
            question: formatMessage("authScreen.goToPartnersPortalQuestion"),
            linkLabel: formatMessage("authScreen.goToPartnersPortalLink")
        });
        return links;
    }, [
        formatMessage
    ]);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)($aca268df8554b730$var$ExternalSiteContainer, {
        $centerWhenSmall: centerWhenSmall,
        children: externalLinks.map((externalLink, index)=>/*#__PURE__*/ (0, $4m918.jsxs)($aca268df8554b730$var$ExternalSiteLink, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($aca268df8554b730$var$GoToExternalSiteQuestion, {
                        $isRTL: isRTL,
                        $centerWhenSmall: centerWhenSmall,
                        children: externalLink.question
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($aca268df8554b730$var$GoToExternalSiteLink, {
                        href: externalLink.url,
                        $centerWhenSmall: centerWhenSmall,
                        children: externalLink.linkLabel
                    })
                ]
            }, index))
    });
};
const $aca268df8554b730$var$ExternalSiteContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  width: 100%;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    align-items: ${(props)=>props.$centerWhenSmall ? "center" : "flex-start"};
    margin: 0;
  }
`;
const $aca268df8554b730$var$ExternalSiteLink = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
`;
const $aca268df8554b730$var$GoToExternalSiteQuestion = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  text-align: ${(props)=>props.$isRTL ? "left" : "right"};
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    text-align: ${(props)=>props.$centerWhenSmall ? "center" : props.$isRTL ? "left" : "right"};
  }
`;
const $aca268df8554b730$var$GoToExternalSiteLink = (0, $jb8NR.default)((0, $bewhU.DefaultExternalLink))`
  ${(0, $22v9q.theme).boldText};
  color: ${(0, $22v9q.theme).mainColor};
  justify-content: flex-end;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    justify-content: ${(props)=>props.$centerWhenSmall ? "center" : "flex-start"};
  }
`;

});

parcelRegister("cAn8H", function(module, exports) {

$parcel$export(module.exports, "ResponsiveContainer", function () { return $f4105022a5ee01da$export$e60a4704009a0009; });

var $jb8NR = parcelRequire("jb8NR");

var $7XqbX = parcelRequire("7XqbX");
const $f4105022a5ee01da$var$PADDING_NOT_MOBILE = 120;
const $f4105022a5ee01da$var$PADDING_LEFT_DESKTOP_SMALL = (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL + (0, $7XqbX.UIConstants).NAV_WIDTH + (0, $7XqbX.UIConstants).NAV_LEFT_MARGIN_DESKTOP_SMALL;
const $f4105022a5ee01da$var$PADDING_LEFT_DESKTOP_LARGE = (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE + (0, $7XqbX.UIConstants).NAV_WIDTH + (0, $7XqbX.UIConstants).NAV_LEFT_MARGIN_DESKTOP_LARGE;
const $f4105022a5ee01da$export$e60a4704009a0009 = (0, $jb8NR.default).div`
  width: ${(0, $7XqbX.UIConstants).PAGE_MAX_WIDTH}px;
  max-width: 100%;
  margin: 0 auto;
  padding-top: 80px;
  padding-left: ${(props)=>props.$isRTL ? $f4105022a5ee01da$var$PADDING_NOT_MOBILE : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_NOT_DESKTOP}px;
  padding-right: ${(props)=>props.$isRTL ? $f4105022a5ee01da$var$PADDING_NOT_MOBILE : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_NOT_DESKTOP}px;

  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    padding-top: 60px;
    padding-left: ${(props)=>props.$isRTL ? (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL : props.$withNav ? $f4105022a5ee01da$var$PADDING_LEFT_DESKTOP_SMALL : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL}px;
    padding-right: ${(props)=>props.$isRTL ? props.$withNav ? $f4105022a5ee01da$var$PADDING_LEFT_DESKTOP_SMALL : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL}px;
  }
  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_LARGE_BREAKPOINT}px) {
    padding-left: ${(props)=>props.$isRTL ? (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE : props.$withNav ? $f4105022a5ee01da$var$PADDING_LEFT_DESKTOP_LARGE : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE}px;
    padding-right: ${(props)=>props.$isRTL ? props.$withNav ? $f4105022a5ee01da$var$PADDING_LEFT_DESKTOP_LARGE : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE : (0, $7XqbX.UIConstants).CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE}px;
  }
`;

});

parcelRegister("gxFwH", function(module, exports) {

$parcel$export(module.exports, "StoreButtons", function () { return $008a80fc6a7ed171$export$8c7d97e16832431c; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $5hpYi = parcelRequire("5hpYi");

var $yYT9n = parcelRequire("yYT9n");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $7Zu6k = parcelRequire("7Zu6k");


const $008a80fc6a7ed171$export$8c7d97e16832431c = (props)=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { showIsAvailable: showIsAvailable, smallVersion: smallVersion } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: (0, $dhPTb.Config).APP_APPLE_STORE_ID || (0, $dhPTb.Config).APP_ID ? /*#__PURE__*/ (0, $4m918.jsxs)($008a80fc6a7ed171$var$StoresSiteWrapper, {
            children: [
                showIsAvailable && /*#__PURE__*/ (0, $4m918.jsx)($008a80fc6a7ed171$var$StoreAvailable, {
                    $isRTL: isRTL,
                    children: formatMessage("authScreen.storesAvailable")
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($008a80fc6a7ed171$var$StoreButtonWrapper, {
                    $isRTL: isRTL,
                    children: [
                        (0, $dhPTb.Config).APP_APPLE_STORE_ID && /*#__PURE__*/ (0, $4m918.jsxs)($008a80fc6a7ed171$var$AppstoreLink, {
                            size: "S",
                            target: "_blank",
                            href: "itms-apps://itunes.apple.com/app/apple-store/idtest?mt=8",
                            isSmallVersion: smallVersion,
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($008a80fc6a7ed171$var$AppstoreLogo, {
                                    src: {},
                                    $isRTL: isRTL,
                                    isSmallVersion: smallVersion
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)("span", {
                                    children: formatMessage("authScreen.appstoreLink")
                                })
                            ]
                        }),
                        (0, $dhPTb.Config).APP_ID && /*#__PURE__*/ (0, $4m918.jsxs)($008a80fc6a7ed171$var$PlaystoreLink, {
                            size: "S",
                            target: "_blank",
                            href: `http://play.google.com/store/apps/details?id=${(0, $dhPTb.Config).APP_ID}`,
                            $isRTL: isRTL,
                            isSmallVersion: smallVersion,
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($008a80fc6a7ed171$var$PlaystoreLogo, {
                                    src: {},
                                    $isRTL: isRTL,
                                    isSmallVersion: smallVersion
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)("span", {
                                    children: formatMessage("authScreen.playstoreLink")
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : null
    });
};
const $008a80fc6a7ed171$var$StoresSiteWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    align-items: flex-start;
    margin-top: 40px;
  }
`;
const $008a80fc6a7ed171$var$StoreAvailable = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  text-align: ${(props)=>props.$isRTL ? "left" : "right"};
  margin-bottom: 8px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    align-self: flex-start;
  }
`;
const $008a80fc6a7ed171$var$StoreButtonWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_LARGE_BREAKPOINT}px) {
    flex-direction: column;
    align-items: flex-end;
  }

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;
const $008a80fc6a7ed171$var$StoreLink = (0, $jb8NR.default)((0, $7Zu6k.PrimaryExternalLink))`
  ${(0, $22v9q.theme).text}
  font-size: ${(props)=>props.isSmallVersion ? 0.75 : 1}rem;
  padding: ${(props)=>props.isSmallVersion ? "20px 16px" : "13px 20px"};
  height: ${(props)=>props.isSmallVersion ? "24px" : "auto"};
`;
const $008a80fc6a7ed171$var$AppstoreLink = (0, $jb8NR.default)($008a80fc6a7ed171$var$StoreLink)``;
const $008a80fc6a7ed171$var$PlaystoreLink = (0, $jb8NR.default)($008a80fc6a7ed171$var$StoreLink)`
  background-color: #fff;
  color: #000;

  &:focus,
  &:active,
  &:hover {
    background-color: #f9f9f9;
  }

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    margin-left: unset;
    margin-right: unset;
  }
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-top: 0;
  }
`;
const $008a80fc6a7ed171$var$PlaystoreLogo = (0, $jb8NR.default).img`
  width: ${(props)=>props.isSmallVersion ? 16 : 20}px;
  height: auto;
  ${(props)=>props.$isRTL ? "margin-left: 10px" : "margin-right: 10px"};
`;
const $008a80fc6a7ed171$var$AppstoreLogo = (0, $jb8NR.default).img`
  width: ${(props)=>props.isSmallVersion ? 12 : 15}px;
  height: auto;
  ${(props)=>props.$isRTL ? "margin-left: 10px" : "margin-right: 10px"};
`;

});

parcelRegister("kYdKS", function(module, exports) {

$parcel$export(module.exports, "VersionBox", function () { return $cef9d309162fe2c6$export$e83ffb78b976f69f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $22v9q = parcelRequire("22v9q");
function $cef9d309162fe2c6$export$e83ffb78b976f69f() {
    return /*#__PURE__*/ (0, $4m918.jsx)($cef9d309162fe2c6$var$Version, {
        children: /*#__PURE__*/ (0, $4m918.jsx)($cef9d309162fe2c6$var$VersionContent, {
            children: (0, $dhPTb.Config).APP_VERSION
        })
    });
}
const $cef9d309162fe2c6$var$Version = (0, $jb8NR.default).div`
  align-self: flex-start;
`;
const $cef9d309162fe2c6$var$VersionContent = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  color: #cacaca;
`;

});

parcelRegister("eVe7X", function(module, exports) {

$parcel$export(module.exports, "ConnectContactSupport", function () { return $1e3b5cfdff65ec20$export$1dad8551141b953f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $fplBl = parcelRequire("fplBl");

var $3Ersk = parcelRequire("3Ersk");

var $ZE1cB = parcelRequire("ZE1cB");

var $i1jpl = parcelRequire("i1jpl");

var $dmWk7 = parcelRequire("dmWk7");

var $22v9q = parcelRequire("22v9q");
const $1e3b5cfdff65ec20$export$1dad8551141b953f = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const { contactEmail: contactEmail, contactPhone: contactPhone } = configuration;
    return /*#__PURE__*/ (0, $4m918.jsxs)($1e3b5cfdff65ec20$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($1e3b5cfdff65ec20$var$Title, {
                children: formatMessage("connectScreen.contactSupport.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1e3b5cfdff65ec20$var$Message, {
                children: formatMessage("connectScreen.contactSupport.message")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($1e3b5cfdff65ec20$var$ButtonsContainer, {
                children: [
                    (0, $gDlNU.isDefined)(contactPhone) && /*#__PURE__*/ (0, $4m918.jsxs)($1e3b5cfdff65ec20$var$Button, {
                        type: "phone",
                        href: (0, $fplBl.buildLinkPhoneTo)(contactPhone),
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($1e3b5cfdff65ec20$var$Logo, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $dmWk7.ContactPhoneIcon), {})
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($1e3b5cfdff65ec20$var$ButtonLegend, {
                                children: formatMessage("connectScreen.contactSupport.byPhone")
                            })
                        ]
                    }),
                    (0, $gDlNU.isDefined)(contactEmail) && /*#__PURE__*/ (0, $4m918.jsxs)($1e3b5cfdff65ec20$var$Button, {
                        type: "email",
                        href: (0, $fplBl.buildLinkMailTo)(contactEmail),
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($1e3b5cfdff65ec20$var$Logo, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $i1jpl.ContactEmailIcon), {})
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($1e3b5cfdff65ec20$var$ButtonLegend, {
                                children: formatMessage("connectScreen.contactSupport.byEmail")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $1e3b5cfdff65ec20$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $1e3b5cfdff65ec20$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText}
  font-size: 1.875rem;
  margin-bottom: 12px;
`;
const $1e3b5cfdff65ec20$var$Message = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.9375rem;
  color: #b1b1b1;
  margin-bottom: 42px;
`;
const $1e3b5cfdff65ec20$var$ButtonsContainer = (0, $jb8NR.default).span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 12px;
`;
const $1e3b5cfdff65ec20$var$Button = (0, $jb8NR.default).a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 44px;
`;
const $1e3b5cfdff65ec20$var$Logo = (0, $jb8NR.default).div`
  display: flex;
  width: 37px;
  height: 37px;
  border-radius: 27px;
  background-color: #ececec;
  align-items: center;
  justify-content: center;
  margin-right: 22px;
`;
const $1e3b5cfdff65ec20$var$ButtonLegend = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.9375rem;
  color: black;
  text-decoration: underline;
`;

});

parcelRegister("7u30r", function(module, exports) {

$parcel$export(module.exports, "ConnectInputNumber", function () { return $269923b534024d02$export$44003ffe479b5dcb; });

var $4m918 = parcelRequire("4m918");

var $glqzU = parcelRequire("glqzU");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $a5OyK = parcelRequire("a5OyK");

var $5hpYi = parcelRequire("5hpYi");

var $bewhU = parcelRequire("bewhU");

var $ZE1cB = parcelRequire("ZE1cB");

var $1Ny0s = parcelRequire("1Ny0s");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $269923b534024d02$export$44003ffe479b5dcb = (props)=>{
    const { onLostPhoneClick: onLostPhoneClick, error: error, onUpdatePhone: onUpdatePhone, onUpdateCountryCode: onUpdateCountryCode, initialValue: initialValue, currentCountryCode: currentCountryCode } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)(currentCountryCode);
    const [phoneNumber, setPhoneNumber] = (0, $6uYXW.useState)(initialValue || "");
    const updateCountryCode = (countryCode)=>{
        setCountryCode(countryCode);
        onUpdateCountryCode(countryCode);
    };
    const updatePhoneNumber = (phoneNumber)=>{
        const nationalNumber = "+" + (0, $a5OyK.countries)[countryCode].phoneCode;
        const internationalPhoneNumber = phoneNumber.startsWith(nationalNumber) ? phoneNumber : nationalNumber + phoneNumber;
        const formatted = new (0, $glqzU.AsYouType)().input(internationalPhoneNumber).substr(nationalNumber.length);
        setPhoneNumber(formatted);
        onUpdatePhone(formatted);
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($269923b534024d02$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($269923b534024d02$var$Title, {
                children: formatMessage("connectScreen.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($269923b534024d02$var$Subtitle, {
                children: formatMessage("connectScreen.subtitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($269923b534024d02$var$InputContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $1Ny0s.PhoneInput), {
                        onChangeCountryCode: updateCountryCode,
                        onChangePhoneNumber: updatePhoneNumber,
                        initialCountryCode: countryCode,
                        initialPhone: phoneNumber
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($269923b534024d02$var$TextButton, {
                        onClick: onLostPhoneClick,
                        children: formatMessage("connectScreen.lostPhoneButton")
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $4m918.jsxs)($269923b534024d02$var$ErrorContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($269923b534024d02$var$ErrorTitle, {
                        children: formatMessage("connectScreen.errorTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($269923b534024d02$var$ErrorMessage, {
                        children: error
                    })
                ]
            })
        ]
    });
};
const $269923b534024d02$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 32px;
`;
const $269923b534024d02$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText}
  font-size: 2.5rem;
  line-height: 2.875rem;
  align-self: flex-start;
  margin-bottom: 24px;
`;
const $269923b534024d02$var$Subtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  color: #b1b1b1;
  font-size: 0.9375rem;
  margin-bottom: 52px;
`;
const $269923b534024d02$var$InputContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  width: 100%;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    max-width: 320px;
  }
`;
const $269923b534024d02$var$ErrorContainer = (0, $jb8NR.default).div`
  display: flex;
  width: 100%;
  padding: 8px;
  border-radius: 10px;
  flex-direction: column;
  margin-bottom: 8px;
`;
const $269923b534024d02$var$ErrorTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.875rem;
  color: #ff4242;
  margin: 8px 0 4px 8px;
`;
const $269923b534024d02$var$ErrorMessage = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.8125rem;
  color: #ff4242;
  margin-left: 8px;
  margin-bottom: 8px;
`;
const $269923b534024d02$var$TextButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.8125rem;
  align-self: flex-end;
  text-decoration: underline;
  margin-bottom: 20px;
`;

});


parcelRegister("dTIxs", function(module, exports) {

$parcel$export(module.exports, "DeleteAccount", function () { return $9032430ab18879d3$export$840b7e4b38b99ca; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $dhPTb = parcelRequire("dhPTb");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $aRU9F = parcelRequire("aRU9F");
const $9032430ab18879d3$export$840b7e4b38b99ca = ()=>{
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const contactMail = configuration.contactEmail;
    const appName = (0, $dhPTb.Config).APP_NAME;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aRU9F.ArticlePage), {
        mainTitle: `Request to delete your account on ${appName}`,
        intro: `This article explains how to request deletion of your personal data collected via the ${appName}.`,
        sections: [
            {
                title: "Steps to Delete Your Account",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("ol", {
                    className: "list",
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsxs)("li", {
                            className: "list__item",
                            children: [
                                "Open the ",
                                appName,
                                " on your mobile device"
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)("li", {
                            className: "list__item",
                            children: [
                                "Go to ",
                                /*#__PURE__*/ (0, $4m918.jsx)("strong", {
                                    children: "Settings"
                                }),
                                " > ",
                                /*#__PURE__*/ (0, $4m918.jsx)("strong", {
                                    children: "Account Settings"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)("li", {
                            className: "list__item",
                            children: [
                                "Select ",
                                /*#__PURE__*/ (0, $4m918.jsx)("strong", {
                                    children: "Delete My Account"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Confirm your identity and follow the on-screen instructions"
                        })
                    ]
                })
            },
            {
                title: "",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("p", {
                    children: [
                        "Alternatively, you may contact our support team at ",
                        /*#__PURE__*/ (0, $4m918.jsx)("a", {
                            href: `mailto:${contactMail}`,
                            children: contactMail
                        }),
                        " ",
                        "with the subject line: ",
                        /*#__PURE__*/ (0, $4m918.jsxs)("em", {
                            children: [
                                '"Request to Delete My Account - ',
                                appName,
                                '"'
                            ]
                        }),
                        "."
                    ]
                })
            },
            {
                title: "What Data Will Be Deleted?",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("ul", {
                    className: "list",
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Your user profile and login credentials"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Personal identification data (name, email, phone number)"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Transaction history associated with your account"
                        })
                    ]
                })
            },
            {
                title: "Data We May Retain",
                content: /*#__PURE__*/ (0, $4m918.jsx)("p", {
                    children: "Some financial or regulatory data may be retained for up to 5 years as required by applicable law."
                })
            },
            {
                title: "Processing Time",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("p", {
                    children: [
                        "We will process your deletion request within ",
                        /*#__PURE__*/ (0, $4m918.jsx)("strong", {
                            children: "7 business days"
                        }),
                        "."
                    ]
                })
            },
            {
                title: "Need Help?",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("p", {
                    children: [
                        "Email us at ",
                        /*#__PURE__*/ (0, $4m918.jsx)("a", {
                            href: `mailto:${contactMail}`,
                            children: contactMail
                        })
                    ]
                })
            }
        ]
    });
};

});
parcelRegister("aRU9F", function(module, exports) {

$parcel$export(module.exports, "ArticlePage", function () { return $11b186b265881d62$export$a13276473c6d41ce; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $cAn8H = parcelRequire("cAn8H");
const $11b186b265881d62$export$a13276473c6d41ce = ({ mainTitle: mainTitle, intro: intro, sections: sections })=>/*#__PURE__*/ (0, $4m918.jsx)($11b186b265881d62$var$Page, {
        children: /*#__PURE__*/ (0, $4m918.jsxs)("section", {
            className: "article-details-page",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("div", {
                    className: "article-details-page__header",
                    children: /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                        className: "article-content",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("h1", {
                                className: "article-content__title",
                                children: mainTitle
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("p", {
                                children: intro
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("div", {
                    className: "article-details-content",
                    children: sections.map((section, index)=>/*#__PURE__*/ (0, $4m918.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)("h2", {
                                    className: "article-details-content__title",
                                    children: section.title
                                }),
                                section.content
                            ]
                        }, index))
                })
            ]
        })
    });
const $11b186b265881d62$var$Page = (0, $jb8NR.default)((0, $cAn8H.ResponsiveContainer))`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 0;
  margin: 0;
`;

});


parcelRegister("5z1GG", function(module, exports) {

$parcel$export(module.exports, "DeleteData", function () { return $4f8e0702cc49f5d2$export$840c199aeda40c61; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $dhPTb = parcelRequire("dhPTb");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $aRU9F = parcelRequire("aRU9F");
const $4f8e0702cc49f5d2$export$840c199aeda40c61 = ()=>{
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const contactMail = configuration.contactEmail;
    const appName = (0, $dhPTb.Config).APP_NAME;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $aRU9F.ArticlePage), {
        mainTitle: `Delete your data on ${appName}`,
        intro: `This page explains how to request deletion of your personal data collected via the ${appName} app.`,
        sections: [
            {
                title: "Steps to Request Data Deletion",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("ol", {
                    className: "list",
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsxs)("li", {
                            className: "list__item",
                            children: [
                                "Email us at ",
                                /*#__PURE__*/ (0, $4m918.jsx)("a", {
                                    href: `mailto:${contactMail}`,
                                    children: contactMail
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)("li", {
                            className: "list__item",
                            children: [
                                "Use the subject line: ",
                                /*#__PURE__*/ (0, $4m918.jsx)("strong", {
                                    children: "Request to Delete Personal Data"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Include the email associated with your account and identity confirmation"
                        })
                    ]
                })
            },
            {
                title: "What Data Will Be Deleted?",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("ul", {
                    className: "list",
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Location and usage data"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Device identifiers"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("li", {
                            className: "list__item",
                            children: "Transaction history and saved settings"
                        })
                    ]
                })
            },
            {
                title: "Data We May Retain",
                content: /*#__PURE__*/ (0, $4m918.jsx)("p", {
                    children: "Some financial data or identifiers may be retained where required by local regulations or for fraud prevention."
                })
            },
            {
                title: "Processing Time",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("p", {
                    children: [
                        "Your request will be processed within ",
                        /*#__PURE__*/ (0, $4m918.jsx)("strong", {
                            children: "5\u20137 business days"
                        }),
                        "."
                    ]
                })
            },
            {
                title: "Need Help?",
                content: /*#__PURE__*/ (0, $4m918.jsxs)("p", {
                    children: [
                        "Contact us anytime at ",
                        /*#__PURE__*/ (0, $4m918.jsx)("a", {
                            href: `mailto:${contactMail}`,
                            children: contactMail
                        })
                    ]
                })
            }
        ]
    });
};

});

parcelRegister("kqgT4", function(module, exports) {

$parcel$export(module.exports, "OnboardingFileScreen", function () { return $afeb42c32a4cdc29$export$657c59a671693ad3; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $cPJq2 = parcelRequire("cPJq2");

var $cKILb = parcelRequire("cKILb");

var $4fYE4 = parcelRequire("4fYE4");

var $bewhU = parcelRequire("bewhU");

var $7Zu6k = parcelRequire("7Zu6k");

var $k4kME = parcelRequire("k4kME");

var $51d3M = parcelRequire("51d3M");

var $22v9q = parcelRequire("22v9q");

var $hlKpB = parcelRequire("hlKpB");

var $2CQIp = parcelRequire("2CQIp");

var $8UUD6 = parcelRequire("8UUD6");
const $afeb42c32a4cdc29$export$657c59a671693ad3 = ()=>{
    const { push: push } = (0, $NQIVp.useHistory)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { error: error, erroredFields: erroredFields, needSaveBeforeSubmit: needSaveBeforeSubmit, isUpdating: isUpdating, isSubmitting: isSubmitting, onboardingFile: onboardingFile, steps: steps, canUpdate: canUpdate, canSubmit: canSubmit, currentStepIndex: currentStepIndex, currentStep: currentStep, isLastStep: isLastStep, fillResponse: fillResponse, fillMultiImages: fillMultiImages, moveBackward: moveBackward, moveForward: moveForward, submitOnboardingFile: submitOnboardingFile, areThereMissingRequiredFields: areThereMissingRequiredFields } = (0, $cKILb.useOnboardingFile)();
    (0, $6uYXW.useEffect)(()=>{
        if (onboardingFile?.status === (0, $cPJq2.OnboardingStatus).SUBMITTED || onboardingFile?.status === (0, $cPJq2.OnboardingStatus).PENDING_VERIFICATION) push((0, $4fYE4.Path).OnboardingFileSubmitted);
    }, [
        onboardingFile
    ]);
    const handleSubmitOnboardingFIle = async ()=>{
        const res = await submitOnboardingFile();
        if (res?.onboardingFile?.status === (0, $cPJq2.OnboardingStatus).EXTERNAL_CHECK_PENDING) {
            const clientJourneyUrl = res.onboardingFile.links.find((l)=>l.rel === "clientJourneyUrl").href;
            clientJourneyUrl && window.location.assign(clientJourneyUrl);
        }
    };
    const handleMoveBackward = ()=>{
        moveBackward();
    };
    const hasFormErrors = erroredFields.length > 0 || areThereMissingRequiredFields(currentStep.inputs);
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $hlKpB.default), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $2CQIp.default), {
                step: currentStepIndex,
                stepCount: steps?.length,
                label: currentStep?.label,
                onBack: currentStepIndex > 0 ? handleMoveBackward : undefined
            }),
            !!currentStep && onboardingFile && /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
                children: /*#__PURE__*/ (0, $4m918.jsx)($afeb42c32a4cdc29$var$EnrollmentStepFormWrapper, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $8UUD6.default), {
                        disabled: !canUpdate || isUpdating,
                        step: currentStep,
                        onInputValueChange: fillResponse,
                        onInputMultiImagesChange: fillMultiImages,
                        onSubmit: moveForward,
                        errorMessage: error,
                        erroredFields: erroredFields,
                        overrideActions: /*#__PURE__*/ (0, $4m918.jsx)($afeb42c32a4cdc29$var$StyledMainButtonContainer, {
                            children: isLastStep ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsxs)($afeb42c32a4cdc29$var$SaveLink, {
                                        type: "submit",
                                        disabled: isUpdating || !canUpdate,
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)($afeb42c32a4cdc29$var$SaveLabel, {
                                                $hidden: isUpdating,
                                                children: formatMessage("onboardingScreen.save")
                                            }),
                                            isUpdating && /*#__PURE__*/ (0, $4m918.jsx)($afeb42c32a4cdc29$var$SaveLoader, {
                                                size: "16px"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                                        size: "S",
                                        type: "button",
                                        onClick: handleSubmitOnboardingFIle,
                                        showSpinner: isSubmitting,
                                        disabled: needSaveBeforeSubmit || !canSubmit || hasFormErrors,
                                        children: formatMessage("onboardingScreen.submit")
                                    })
                                ]
                            }) : /* Spinning already blocks the pointer, so the button is not greyed out too. */ /*#__PURE__*/ (0, $4m918.jsxs)($afeb42c32a4cdc29$var$NextButton, {
                                size: "S",
                                type: "submit",
                                showSpinner: isUpdating,
                                disabled: !canUpdate,
                                children: [
                                    formatMessage("onboardingScreen.next"),
                                    /*#__PURE__*/ (0, $4m918.jsx)($afeb42c32a4cdc29$var$NextChevron, {
                                        width: 10,
                                        height: 10
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};
const $afeb42c32a4cdc29$var$EnrollmentStepFormWrapper = (0, $jb8NR.default).div`
  flex: 1;
  width: 100%;
  max-width: 600px;
`;
const $afeb42c32a4cdc29$var$StyledMainButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  margin-top: 24px;
`;
/* Outlined and chevroned, the way the mockup carries the step forward. */ const $afeb42c32a4cdc29$var$NextButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  box-shadow: none;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
const $afeb42c32a4cdc29$var$NextChevron = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  fill: ${(0, $22v9q.theme).colors.blue[700]};
`;
const $afeb42c32a4cdc29$var$SaveLink = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  position: relative;
  font-size: 0.8125rem;
  color: ${(0, $22v9q.theme).colors.blue[700]};
  text-decoration: underline;

  &:disabled {
    opacity: 0.5;
  }
`;
const $afeb42c32a4cdc29$var$SaveLabel = (0, $jb8NR.default).span`
  opacity: ${(props)=>props.$hidden ? 0 : 1};
`;
/* UnstyledButton drops showSpinner, so the save link overlays its own. */ const $afeb42c32a4cdc29$var$SaveLoader = (0, $jb8NR.default)((0, $k4kME.Spinner))`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

});
parcelRegister("hlKpB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2341bc7d7b06f0a6$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $bXSbQ = parcelRequire("bXSbQ");

var $7XqbX = parcelRequire("7XqbX");
const $2341bc7d7b06f0a6$var$EnrollmentLayout = ({ children: children, centered: centered })=>/*#__PURE__*/ (0, $4m918.jsxs)($2341bc7d7b06f0a6$var$Page, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($2341bc7d7b06f0a6$var$StickyBrandPanel, {}),
            /*#__PURE__*/ (0, $4m918.jsx)($2341bc7d7b06f0a6$var$RightPanel, {
                $isCentered: centered,
                children: children
            })
        ]
    });
var $2341bc7d7b06f0a6$export$2e2bcd8739ae039 = $2341bc7d7b06f0a6$var$EnrollmentLayout;
const $2341bc7d7b06f0a6$var$Page = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
/** The form scrolls on its own; the pitch stays in view beside it. */ const $2341bc7d7b06f0a6$var$StickyBrandPanel = (0, $jb8NR.default)((0, $bXSbQ.BrandPanel))`
  position: sticky;
  top: 0;
  height: 100vh;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    position: static;
    height: auto;
  }
`;
const $2341bc7d7b06f0a6$var$RightPanel = (0, $jb8NR.default).div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: ${(props)=>props.$isCentered ? "center" : "stretch"};
  padding: 24px 40px 48px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    padding: 20px;
  }
`;

});
parcelRegister("bXSbQ", function(module, exports) {

$parcel$export(module.exports, "BrandPanel", function () { return $6804af1a21c1d7c4$export$2b9241db9640b25; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
function $6804af1a21c1d7c4$export$2b9241db9640b25(props) {
    const { children: children, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($6804af1a21c1d7c4$var$Panel, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($6804af1a21c1d7c4$var$Logo, {
                src: (0, $fRvTz.StaticAssets).brandLogo,
                alt: ""
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($6804af1a21c1d7c4$var$Pitch, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($6804af1a21c1d7c4$var$Headline, {
                        children: formatMessage("authScreen.headline")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($6804af1a21c1d7c4$var$Description, {
                        children: formatMessage("authScreen.headlineDescription")
                    })
                ]
            }),
            children
        ]
    });
}
const $6804af1a21c1d7c4$var$Panel = (0, $jb8NR.default).section`
  display: flex;
  flex: 0 0 42%;
  flex-direction: column;
  padding: 64px;
  background: ${(0, $22v9q.theme).brandGradient};
  color: #ffffff;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex: 0 0 auto;
    padding: 32px;
  }
`;
const $6804af1a21c1d7c4$var$Logo = (0, $jb8NR.default).img`
  width: 186px;
  object-fit: contain;
  align-self: flex-start;
`;
/**
 * Sits in the lower half of the panel: centred in the space the logo leaves below it, then
 * pushed down by half the top padding, which puts its centre at the mockup's 60% mark.
 */ const $6804af1a21c1d7c4$var$Pitch = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  max-width: 560px;
  padding-top: 16vh;
`;
const $6804af1a21c1d7c4$var$Headline = (0, $jb8NR.default).h1`
  ${(0, $22v9q.theme).boldText};
  margin: 0 0 32px;
  font-size: 52px;
  line-height: 68px;
  color: #ffffff;
`;
const $6804af1a21c1d7c4$var$Description = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).text};
  margin: 0;
  font-size: 22px;
  line-height: 33px;

  color: ${(0, $22v9q.theme).colors.gray[100]};
  opacity: 0.8;
`;

});


parcelRegister("2CQIp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2db7c185f861330b$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $k4Ecv = parcelRequire("k4Ecv");

var $yYT9n = parcelRequire("yYT9n");

var $bewhU = parcelRequire("bewhU");

var $ZE1cB = parcelRequire("ZE1cB");

var $51d3M = parcelRequire("51d3M");

var $22v9q = parcelRequire("22v9q");
const $2db7c185f861330b$var$EnrollmentProgress = ({ step: step, stepCount: stepCount, label: label, onBack: onBack })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return step !== undefined && step >= 0 && stepCount ? /*#__PURE__*/ (0, $4m918.jsxs)($2db7c185f861330b$var$ProgressContainer, {
        children: [
            onBack && /*#__PURE__*/ (0, $4m918.jsxs)($2db7c185f861330b$var$BackLink, {
                type: "button",
                onClick: onBack,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($2db7c185f861330b$var$BackChevron, {
                        width: 10,
                        height: 10
                    }),
                    formatMessage("registerScreen.progressBackLink")
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($2db7c185f861330b$var$ProgressText, {
                children: formatMessage("registerScreen.progressStepLabel", {
                    step: step + 1,
                    count: stepCount ?? 0
                })
            }),
            !!label && /*#__PURE__*/ (0, $4m918.jsx)($2db7c185f861330b$var$ProgressSubtitle, {
                children: label
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($2db7c185f861330b$var$ProgressParts, {
                $isRTL: isRTL,
                children: [
                    (0, $k4Ecv.repeat)(step + 1, (index)=>/*#__PURE__*/ (0, $4m918.jsx)($2db7c185f861330b$var$FilledStep, {
                            bigger: index === step
                        }, `filled ${index}`)),
                    (0, $k4Ecv.repeat)(stepCount - (step + 1), (index)=>/*#__PURE__*/ (0, $4m918.jsx)($2db7c185f861330b$var$EmptyStep, {}, `empty ${index}`))
                ]
            })
        ]
    }) : null;
};
var $2db7c185f861330b$export$2e2bcd8739ae039 = $2db7c185f861330b$var$EnrollmentProgress;
const $2db7c185f861330b$var$ProgressContainer = (0, $jb8NR.default).div`
  align-self: stretch;
  margin-bottom: 40px;
`;
const $2db7c185f861330b$var$BackLink = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  font-size: 0.8125rem;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
/* The chevron points back: the icon's own path faces forward. */ const $2db7c185f861330b$var$BackChevron = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  fill: ${(0, $22v9q.theme).colors.blue[700]};
  transform: rotate(180deg);
`;
const $2db7c185f861330b$var$ProgressSubtitle = (0, $jb8NR.default).div`
  margin-top: 2px;
  font-size: 0.75rem;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $2db7c185f861330b$var$ProgressText = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 1rem;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $2db7c185f861330b$var$ProgressParts = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  height: 5px;
  margin-top: 15px;

  > *:not(:first-child) {
    margin-left: ${(props)=>props.$isRTL ? 0 : 10}px;
    margin-right: ${(props)=>props.$isRTL ? 10 : 0}px;
  }
`;
const $2db7c185f861330b$var$EmptyStep = (0, $jb8NR.default).div`
  display: flex;
  width: 5px;
  height: 5px;
  flex-grow: 2;
  flex-shrink: 0;
  border-radius: 5px;
  background: #b1b1b1;
`;
const $2db7c185f861330b$var$FilledStep = (0, $jb8NR.default)($2db7c185f861330b$var$EmptyStep)`
  flex-grow: ${(props)=>props.bigger ? 3 : 2};
  background: #81c241;
`;

});

parcelRegister("8UUD6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $389e5a2ff8de5158$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $jO1Lj = parcelRequire("jO1Lj");

var $5hpYi = parcelRequire("5hpYi");

var $gDlNU = parcelRequire("gDlNU");

var $3PmF6 = parcelRequire("3PmF6");

var $bewhU = parcelRequire("bewhU");

var $1nkfV = parcelRequire("1nkfV");

var $fxmB5 = parcelRequire("fxmB5");

var $k5s21 = parcelRequire("k5s21");

var $ZE1cB = parcelRequire("ZE1cB");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $kSLZ3 = parcelRequire("kSLZ3");
const $389e5a2ff8de5158$var$EnrollmentStepForm = ({ disabled: disabled, overrideActions: overrideActions, step: step, errorMessage: errorMessage, erroredFields: erroredFields, onInputValueChange: onInputValueChange, onInputMultiImagesChange: onInputMultiImagesChange, onSubmit: onSubmit, onBackward: onBackward })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [openConstraints, setOpenConstraints] = (0, $6uYXW.useState)([]);
    const [fileViolations, setFileViolations] = (0, $6uYXW.useState)({});
    const toggleConstraints = (0, $6uYXW.useCallback)((id)=>{
        setOpenConstraints((open)=>open.includes(id) ? open.filter((other)=>other !== id) : [
                ...open,
                id
            ]);
    }, []);
    // A file that breaks the rules opens the panel on its own: the reason has to be in front of the
    // holder at the moment the file is picked, not after a submission.
    const reportViolations = (0, $6uYXW.useCallback)((id, violations)=>{
        setFileViolations((all)=>({
                ...all,
                [id]: violations
            }));
        if (violations.length) setOpenConstraints((open)=>open.includes(id) ? open : [
                ...open,
                id
            ]);
    }, []);
    const nbImages = (input)=>{
        const nbPicturesForDocumentText = (count)=>{
            if (count === 1) return "(" + formatMessage("registerScreen.nbPicturesForDocument.one") + ")";
            return `(${formatMessage("registerScreen.nbPicturesForDocument.others", {
                count: count
            })})`;
        };
        if (input.type === (0, $jO1Lj.FormInputType).Image) {
            const inputImage = input;
            if ((0, $gDlNU.isDefined)(inputImage.minimumPageCount)) return (0, $3PmF6.hasMultiplePages)(inputImage) ? nbPicturesForDocumentText(inputImage.minimumPageCount) : undefined;
        }
        return undefined;
    };
    const inputHasError = (inputName)=>erroredFields ? erroredFields?.includes(inputName) : false;
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $kSLZ3.FormWithButtons), {
        disabled: disabled,
        overrideActions: overrideActions,
        onSubmit: ()=>onSubmit?.(),
        errorMessage: errorMessage,
        onBackward: ()=>onBackward?.(),
        children: [
            step.label && /*#__PURE__*/ (0, $4m918.jsx)($389e5a2ff8de5158$var$StepTitle, {
                children: step.label
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($389e5a2ff8de5158$var$InputsContainer, {
                children: step?.inputs?.map((input, index)=>{
                    if (input.disabled) return null;
                    // An input without an id cannot be told from its neighbours, so its position stands in.
                    const fieldId = input.id ?? String(index);
                    const constraints = $389e5a2ff8de5158$var$constraintsOf(input);
                    const violations = fileViolations[fieldId] ?? [];
                    const constraintsOpen = openConstraints.includes(fieldId);
                    return /*#__PURE__*/ (0, $4m918.jsxs)($389e5a2ff8de5158$var$Cell, {
                        $wide: $389e5a2ff8de5158$var$isWideInput(input),
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($389e5a2ff8de5158$var$LabelRow, {
                                children: [
                                    input.label && /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                        disableFormatting: true,
                                        label: input.label,
                                        required: input.required
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsxs)($389e5a2ff8de5158$var$LabelAside, {
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)($389e5a2ff8de5158$var$Comment, {
                                                children: nbImages(input)
                                            }),
                                            !!constraints && /*#__PURE__*/ (0, $4m918.jsx)($389e5a2ff8de5158$var$InfoButton, {
                                                type: "button",
                                                "aria-expanded": constraintsOpen,
                                                "aria-label": formatMessage("common.fileConstraints.openLabel"),
                                                $failed: violations.length > 0,
                                                onClick: ()=>toggleConstraints(fieldId),
                                                children: "i"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !!constraints && constraintsOpen && /*#__PURE__*/ (0, $4m918.jsx)((0, $1nkfV.FileConstraintsPanel), {
                                constraints: constraints,
                                violations: violations
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $fxmB5.FormField), {
                                input: input,
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                onChange: (value, fileProps)=>onInputValueChange(input, value, fileProps),
                                onMultiImagesChange: (values)=>onInputMultiImagesChange(input, values),
                                onViolations: (reported)=>reportViolations(fieldId, reported),
                                hasError: inputHasError(input.id) || violations.length > 0
                            }, input.id),
                            !!input.description && /*#__PURE__*/ (0, $4m918.jsx)($389e5a2ff8de5158$var$Description, {
                                style: inputHasError(input.id) ? {
                                    color: (0, $22v9q.theme).colors.error[500]
                                } : {},
                                children: input.description
                            })
                        ]
                    }, input.id);
                })
            })
        ]
    });
};
var $389e5a2ff8de5158$export$2e2bcd8739ae039 = $389e5a2ff8de5158$var$EnrollmentStepForm;
/**
 * The form definition carries no layout hint, so width is decided by type: pickers and nested
 * collections need the room, plain fields pair up two per row.
 */ const $389e5a2ff8de5158$var$WIDE_INPUT_TYPES = [
    (0, $jO1Lj.FormInputType).File,
    (0, $jO1Lj.FormInputType).FileContent,
    (0, $jO1Lj.FormInputType).Image,
    (0, $jO1Lj.FormInputType).Collection,
    (0, $jO1Lj.FormInputType).MultiSelect
];
const $389e5a2ff8de5158$var$isWideInput = (input)=>$389e5a2ff8de5158$var$WIDE_INPUT_TYPES.includes(input.type);
const $389e5a2ff8de5158$var$FILE_TYPES = [
    (0, $jO1Lj.FormInputType).File,
    (0, $jO1Lj.FormInputType).FileContent,
    (0, $jO1Lj.FormInputType).Image
];
/** What the form says this field will take, when it says anything at all. */ const $389e5a2ff8de5158$var$constraintsOf = (input)=>{
    if (!$389e5a2ff8de5158$var$FILE_TYPES.includes(input.type)) return undefined;
    const { maxSize: maxSize, acceptedTypes: acceptedTypes } = input;
    return maxSize !== undefined || acceptedTypes?.length ? {
        maxSize: maxSize,
        acceptedTypes: acceptedTypes
    } : undefined;
};
const $389e5a2ff8de5158$var$StepTitle = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  display: block;
  font-size: 1.8rem;
  line-height: 2.875rem;
  align-self: flex-start;
  margin-bottom: 24px;
`;
const $389e5a2ff8de5158$var$Description = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text}
  font-size: 0.688rem;
  color: ${(0, $22v9q.theme).colors.gray[700]};
  margin-top: 5px;
`;
const $389e5a2ff8de5158$var$Comment = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.688rem;
  font-style: italic;
  color: #969696;
`;
const $389e5a2ff8de5158$var$InputsContainer = (0, $jb8NR.default).div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
const $389e5a2ff8de5158$var$Cell = (0, $jb8NR.default).div`
  grid-column: ${(props)=>props.$wide ? "1 / -1" : "auto"};

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    grid-column: auto;
  }
`;
const $389e5a2ff8de5158$var$LabelRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
`;
const $389e5a2ff8de5158$var$LabelAside = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
/* Hard right in the label, the way the app carries it. */ const $389e5a2ff8de5158$var$InfoButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props)=>props.$failed ? (0, $22v9q.theme).colors.error[500] : "#8c8c8c"};
  border-radius: 10px;
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.75rem;
  line-height: 0.9375rem;
  color: ${(props)=>props.$failed ? (0, $22v9q.theme).colors.error[500] : "#8c8c8c"};
`;

});
parcelRegister("1nkfV", function(module, exports) {

$parcel$export(module.exports, "FileConstraintsPanel", function () { return $0acbe196d3b909d2$export$bb3989b21fa7af53; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $cw0v5 = parcelRequire("cw0v5");

var $5hpYi = parcelRequire("5hpYi");

var $22v9q = parcelRequire("22v9q");
const $0acbe196d3b909d2$export$bb3989b21fa7af53 = ({ constraints: constraints, violations: violations })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const formats = (0, $cw0v5.acceptedTypeLabels)(constraints.acceptedTypes);
    return /*#__PURE__*/ (0, $4m918.jsxs)($0acbe196d3b909d2$var$Panel, {
        children: [
            formats.length > 0 && /*#__PURE__*/ (0, $4m918.jsxs)($0acbe196d3b909d2$var$Line, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($0acbe196d3b909d2$var$Term, {
                        children: formatMessage("common.fileConstraints.formats")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($0acbe196d3b909d2$var$Value, {
                        $failed: violations.includes((0, $cw0v5.FileViolation).WrongType),
                        children: formats.join(", ")
                    })
                ]
            }),
            constraints.maxSize !== undefined && /*#__PURE__*/ (0, $4m918.jsxs)($0acbe196d3b909d2$var$Line, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($0acbe196d3b909d2$var$Term, {
                        children: formatMessage("common.fileConstraints.maxSize")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($0acbe196d3b909d2$var$Value, {
                        $failed: violations.includes((0, $cw0v5.FileViolation).TooBig),
                        children: (0, $cw0v5.formatMaxSize)(constraints.maxSize)
                    })
                ]
            }),
            violations.includes((0, $cw0v5.FileViolation).TooBig) && /*#__PURE__*/ (0, $4m918.jsx)($0acbe196d3b909d2$var$Fault, {
                children: formatMessage("common.fileConstraints.tooBig")
            }),
            violations.includes((0, $cw0v5.FileViolation).WrongType) && /*#__PURE__*/ (0, $4m918.jsx)($0acbe196d3b909d2$var$Fault, {
                children: formatMessage("common.fileConstraints.wrongType")
            })
        ]
    });
};
const $0acbe196d3b909d2$var$Panel = (0, $jb8NR.default).div`
  margin-bottom: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #f6f7f8;
`;
const $0acbe196d3b909d2$var$Line = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;
const $0acbe196d3b909d2$var$Term = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.8125rem;
  line-height: 1.125rem;
  color: #8c8c8c;
`;
const $0acbe196d3b909d2$var$Value = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  flex-shrink: 1;
  margin-left: 12px;
  text-align: right;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  color: ${(props)=>props.$failed ? (0, $22v9q.theme).colors.error[500] : "#0b293e"};
`;
const $0acbe196d3b909d2$var$Fault = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text}
  margin-top: 6px;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  color: ${(0, $22v9q.theme).colors.error[500]};
`;

});

parcelRegister("k5s21", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0868d268195690f$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $22v9q = parcelRequire("22v9q");
function $a0868d268195690f$export$2e2bcd8739ae039(props) {
    const { htmlFor: htmlFor, margin: margin = "none", size: size = "small", label: label, required: required, disableFormatting: disableFormatting } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($a0868d268195690f$var$Label, {
        margin: margin,
        htmlFor: htmlFor,
        size: size,
        children: [
            disableFormatting ? label : formatMessage(label),
            required ? " *" : ""
        ]
    });
}
const $a0868d268195690f$var$Label = (0, $jb8NR.default).label`
  ${(0, $22v9q.theme).mediumText};
  display: block;
  font-size: ${({ size: size })=>size === "small" ? ".75rem" : "15px"};
  margin-top: ${({ margin: margin })=>margin === "dense" ? "20px" : margin === "normal" ? "30px" : "0"};
  margin-bottom: 8px;
`;

});

parcelRegister("kSLZ3", function(module, exports) {

$parcel$export(module.exports, "FormWithButtons", function () { return $7e74aa30a9e14d09$export$7a30138ad1c5b7ae; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $7XqbX = parcelRequire("7XqbX");
const $7e74aa30a9e14d09$export$7a30138ad1c5b7ae = ({ children: children, disabled: disabled, overrideActions: overrideActions, errorMessage: errorMessage, loading: loading, disableSubmitButton: disableSubmitButton, submitWording: submitWording, onSubmit: onSubmit, onBackward: onBackward })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($7e74aa30a9e14d09$var$FormContainer, {
        disabled: disabled,
        onSubmit: async (e)=>{
            e?.preventDefault();
            onSubmit?.();
        },
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("div", {
                style: {
                    flex: 1
                },
                children: children
            }),
            errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($7e74aa30a9e14d09$var$StyledErrorMessage, {
                children: errorMessage
            }),
            overrideActions,
            !overrideActions && /*#__PURE__*/ (0, $4m918.jsxs)($7e74aa30a9e14d09$var$ButtonWrapper, {
                children: [
                    onBackward && /*#__PURE__*/ (0, $4m918.jsx)($7e74aa30a9e14d09$var$NavigationButton, {
                        size: "S",
                        type: "button",
                        onClick: onBackward,
                        children: formatMessage("registerScreen.back")
                    }),
                    !!onSubmit && /*#__PURE__*/ (0, $4m918.jsx)($7e74aa30a9e14d09$var$NavigationButton, {
                        showSpinner: loading,
                        size: "S",
                        type: "submit",
                        disabled: disableSubmitButton,
                        children: submitWording || formatMessage("registerScreen.next")
                    })
                ]
            })
        ]
    });
};
const $7e74aa30a9e14d09$var$FormContainer = (0, $jb8NR.default).form`
  display: flex;
  height: 100%;
  flex-direction: column;
  margin-bottom: 0;
  width: 100%;
  opacity: ${(props)=>props.disabled ? 0.5 : 1};
  pointer-events: ${(props)=>props.disabled ? "none" : "auto"};
`;
const $7e74aa30a9e14d09$var$ButtonWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 44px;
`;
const $7e74aa30a9e14d09$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-bottom: 25px;
`;
const $7e74aa30a9e14d09$var$NavigationButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-left: 10px;
  margin-right: 10px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    padding: 13px 30px;
  }
`;

});



parcelRegister("e4b5h", function(module, exports) {

$parcel$export(module.exports, "OnboardingFileSubmittedScreen", function () { return $ad584a1731299354$export$d37d1f9997eed0f9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $4fYE4 = parcelRequire("4fYE4");

var $7Zu6k = parcelRequire("7Zu6k");

var $ZE1cB = parcelRequire("ZE1cB");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $hlKpB = parcelRequire("hlKpB");
const $ad584a1731299354$export$d37d1f9997eed0f9 = ()=>{
    const { push: push } = (0, $NQIVp.useHistory)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $hlKpB.default), {
        centered: true,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($ad584a1731299354$var$Panel, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($ad584a1731299354$var$SuccessLogoImage, {
                    src: (0, $fRvTz.StaticAssets).confirmation,
                    alt: ""
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($ad584a1731299354$var$Title, {
                    children: formatMessage("onboardingScreen.successIntroduction")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($ad584a1731299354$var$Subtitle, {
                    children: formatMessage("onboardingScreen.successTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($ad584a1731299354$var$StartButton, {
                    size: "S",
                    onClick: ()=>push((0, $4fYE4.Path).Root),
                    children: formatMessage("onboardingScreen.successButton")
                })
            ]
        })
    });
};
/* Centred in the panel with room to breathe, instead of stacked tight against the top. */ const $ad584a1731299354$var$Panel = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 420px;
  margin: 0 auto;
  padding: 48px 0;
  text-align: center;
`;
const $ad584a1731299354$var$SuccessLogoImage = (0, $jb8NR.default).img`
  width: 160px;
  height: 160px;
  margin-bottom: 40px;
  object-fit: contain;
`;
const $ad584a1731299354$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  margin-bottom: 16px;
  font-size: 32px;
  line-height: 42px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $ad584a1731299354$var$Subtitle = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  margin-bottom: 48px;
  font-size: 16px;
  line-height: 24px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $ad584a1731299354$var$StartButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))``;

});

parcelRegister("hfj6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $872cf8ca18673eb6$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $d0DGo = parcelRequire("d0DGo");

var $4fYE4 = parcelRequire("4fYE4");

var $7Zu6k = parcelRequire("7Zu6k");

var $ZE1cB = parcelRequire("ZE1cB");

var $22v9q = parcelRequire("22v9q");

var $hlKpB = parcelRequire("hlKpB");
const $872cf8ca18673eb6$var$OnboardingRedirectScreen = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { push: push } = (0, $NQIVp.useHistory)();
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $hlKpB.default), {
        centered: true,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($872cf8ca18673eb6$var$SuccessLogoImage, {
                src: (0, $d0DGo.circleSuccessIcon),
                alt: "onboarding-success"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($872cf8ca18673eb6$var$Title, {
                children: formatMessage("onboardingScreen.submissionThanks")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($872cf8ca18673eb6$var$Subtitle, {
                children: formatMessage("onboardingScreen.identityVerificationDescription")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                size: "S",
                onClick: ()=>push((0, $4fYE4.Path).Root),
                children: formatMessage("onboardingScreen.successButton")
            })
        ]
    });
};
var $872cf8ca18673eb6$export$2e2bcd8739ae039 = $872cf8ca18673eb6$var$OnboardingRedirectScreen;
const $872cf8ca18673eb6$var$SuccessLogoImage = (0, $jb8NR.default).img`
  align-self: center;
  width: 200px;
  height: 200px;
`;
const $872cf8ca18673eb6$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.2rem;
  line-height: 2.875rem;
  margin-bottom: 10px;
`;
const $872cf8ca18673eb6$var$Subtitle = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  color: ${(0, $22v9q.theme).colors.gray[500]};
  text-align: center;
  margin-bottom: 24px;
`;

});
parcelRegister("d0DGo", function(module, exports) {

$parcel$export(module.exports, "circleSuccessIcon", function () { return $c6099719a01c1897$export$8ab2ba25a20c2582; });

const $c6099719a01c1897$export$8ab2ba25a20c2582 = {};

});


parcelRegister("fEANk", function(module, exports) {

$parcel$export(module.exports, "OnboardingScreen", function () { return $f45748b6298d36b6$export$72f1aafc693b96fe; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $4fYE4 = parcelRequire("4fYE4");

var $l8vHS = parcelRequire("l8vHS");

var $bewhU = parcelRequire("bewhU");

var $596Xf = parcelRequire("596Xf");

var $22v9q = parcelRequire("22v9q");

var $hlKpB = parcelRequire("hlKpB");

var $78uVV = parcelRequire("78uVV");

var $02KgJ = parcelRequire("02KgJ");
const $f45748b6298d36b6$var$centeredStates = [
    (0, $l8vHS.OnboardingState).InitiateOnboardingSuccess
];
const $f45748b6298d36b6$export$72f1aafc693b96fe = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const history = (0, $NQIVp.useHistory)();
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState({
        privacyPolicyAcceptance: false,
        termsAcceptance: false,
        distributorConfigurationCode: "",
        phoneNumber: undefined,
        email: "",
        firstName: "",
        lastName: ""
    });
    const { state: state, context: context, start: start } = (0, $l8vHS.useOnboardingMachine)((0, $l8vHS.OnboardingState).WaitingForData);
    const { redirectIfAllowed: redirectIfAllowed } = (0, $596Xf.useQuitBlocking)(false, formatMessage("registerScreen.quitConfirmMessage"));
    const connect = ()=>{
        if ((0, $kqXxS.authExecutor).withPhoneNumberAndPinCode()) history.push(`${(0, $4fYE4.Path).Connect}?phone=${data.phoneNumber?.nationalNumber}`);
        else (0, $kqXxS.authExecutor).connect();
    };
    const renderRegisterMachine = ()=>{
        switch(state){
            case (0, $l8vHS.OnboardingState).InitiateOnboarding:
            case (0, $l8vHS.OnboardingState).WaitingForData:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $78uVV.default), {
                            value: data,
                            onChange: setData,
                            onSubmit: (data)=>{
                                start(data);
                            },
                            onCancel: ()=>redirectIfAllowed((0, $4fYE4.Path).Root),
                            loading: state === (0, $l8vHS.OnboardingState).InitiateOnboarding,
                            errorMessage: context.error
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($f45748b6298d36b6$var$BottomContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($f45748b6298d36b6$var$ConnectQuestion, {
                                    children: formatMessage("registerScreen.connectQuestion")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($f45748b6298d36b6$var$ConnectButton, {
                                    onClick: connect,
                                    children: formatMessage("registerScreen.connectButton")
                                })
                            ]
                        })
                    ]
                });
            case (0, $l8vHS.OnboardingState).InitiateOnboardingSuccess:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $02KgJ.OnboardingInitialFormSuccess), {
                        phoneNumber: data.phoneNumber
                    })
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $hlKpB.default), {
        centered: $f45748b6298d36b6$var$centeredStates.includes(state),
        children: renderRegisterMachine()
    });
};
/* The question and its answer read as one line, as the rest of the redesign puts them. */ const $f45748b6298d36b6$var$BottomContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
  margin-top: 24px;
`;
const $f45748b6298d36b6$var$ConnectQuestion = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $f45748b6298d36b6$var$ConnectButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(0, $22v9q.theme).text};
  padding: 0;
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;

});
parcelRegister("l8vHS", function(module, exports) {

$parcel$export(module.exports, "useOnboardingMachine", function () { return $31196aa280483401$export$ca86f8dc3b906f1; });
$parcel$export(module.exports, "OnboardingState", function () { return $31196aa280483401$export$ff1cd117057bac38; });

var $lCuQx = parcelRequire("lCuQx");

var $6uYXW = parcelRequire("6uYXW");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");
const $31196aa280483401$export$ca86f8dc3b906f1 = (initialState)=>{
    const initialOnboardingMachine = (0, $6uYXW.useMemo)(()=>$31196aa280483401$var$initialOnboardingMachineBuilder(initialState), [
        initialState
    ]);
    const [machine, sendEvent] = (0, $lCuQx.useMachine)(initialOnboardingMachine);
    const { value: state, context: context } = machine;
    const start = (data)=>{
        sendEvent("ONBOARDING_CREATE", {
            data: data
        });
    };
    return {
        state: state,
        context: context,
        start: start,
        error: context.error
    };
};
var $31196aa280483401$export$ff1cd117057bac38 = /*#__PURE__*/ function(OnboardingState) {
    OnboardingState["WaitingForData"] = "WAITING_FOR_DATA";
    OnboardingState["InitiateOnboarding"] = "INITIATE_ONBOARDING";
    OnboardingState["InitiateOnboardingSuccess"] = "INITIATE_ONBOARDING_SUCCESS";
    return OnboardingState;
}({});
const $31196aa280483401$var$initialOnboardingMachineBuilder = (initialState)=>(0, $TAle5.Machine)({
        id: "register",
        initial: initialState,
        states: {
            ["WAITING_FOR_DATA"]: {
                on: {
                    ONBOARDING_CREATE: {
                        target: "INITIATE_ONBOARDING",
                        actions: (0, $c8ePo.assign)({
                            initialData: (_, event)=>event.data
                        })
                    }
                }
            },
            ["INITIATE_ONBOARDING"]: {
                invoke: {
                    id: "initiateOnboarding",
                    src: (ctx)=>(0, $kqXxS.onboardingManager).initiate(ctx.initialData),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_)=>undefined
                            }),
                            (0, $c8ePo.send)({
                                type: "INITIATE_ONBOARDING_SUCCESS"
                            })
                        ]
                    },
                    onError: {
                        target: "WAITING_FOR_DATA",
                        actions: (0, $c8ePo.assign)({
                            error: (_, event)=>event?.data
                        })
                    }
                },
                on: {
                    INITIATE_ONBOARDING_SUCCESS: "INITIATE_ONBOARDING_SUCCESS"
                }
            },
            ["INITIATE_ONBOARDING_SUCCESS"]: {
                type: "final"
            }
        }
    });

});

parcelRegister("78uVV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a5165fac3fcef4$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $8Ba1X = parcelRequire("8Ba1X");

var $dvOfD = parcelRequire("dvOfD");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $aEtmU = parcelRequire("aEtmU");

var $3Ersk = parcelRequire("3Ersk");

var $7Zu6k = parcelRequire("7Zu6k");

var $ajNEj = parcelRequire("ajNEj");

var $jn1mK = parcelRequire("jn1mK");

var $k5s21 = parcelRequire("k5s21");

var $ZE1cB = parcelRequire("ZE1cB");

var $1Ny0s = parcelRequire("1Ny0s");

var $9mlIh = parcelRequire("9mlIh");

var $22v9q = parcelRequire("22v9q");

var $kP5ln = parcelRequire("kP5ln");

var $jxTls = parcelRequire("jxTls");
const $08a5165fac3fcef4$var$OnboardingInitialForm = ({ value: value, loading: loading, errorMessage: errorMessage, initialPhoneNumber: initialPhoneNumber, onCancel: onCancel, onChange: onChange, onSubmit: onSubmit })=>{
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const defaultCountry = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).defaultCountry);
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)(initialPhoneNumber?.country ?? defaultCountry);
    const [number, setPhoneNumber] = (0, $6uYXW.useState)(value.phoneNumber?.number || "");
    const [error, setError] = (0, $6uYXW.useState)(null);
    const [isTermAccepted, setIsTermAccepted] = (0, $6uYXW.useState)(false);
    const [isPrivacyAccepted, setIsPrivacyAccepted] = (0, $6uYXW.useState)(false);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [needDistributorSelectionDuringOnboarding, setNeedDistributorSelectionDuringOnboarding] = (0, $6uYXW.useState)(false);
    (0, $6uYXW.useEffect)(()=>{
        (0, $kqXxS.configurationManager).reload((0, $aEtmU.CONFIGURATION_MEDIA).WEB_CLIENT).then(function() {
            setNeedDistributorSelectionDuringOnboarding((0, $kqXxS.configurationManager).needDistributorSelectionDuringOnboarding());
        });
    }, []);
    (0, $6uYXW.useEffect)(()=>{
        const phoneNumber = (0, $8Ba1X.parsePhoneNumberFromString)(number, countryCode);
        onChange?.({
            ...value,
            phoneNumber: phoneNumber
        });
    }, [
        countryCode,
        number
    ]);
    const handleChange = (name, val)=>{
        onChange?.({
            ...value,
            [name]: val
        });
    };
    const isFormValid = ()=>{
        if (!value.firstName || !value.lastName || !value.email || !value.phoneNumber) return false;
        if (configuration.privacyPolicyUrl && !isPrivacyAccepted) return false;
        return configuration.termsAndConditionsUrl ? isTermAccepted : true;
    };
    const checkIsTaxedNumber = ()=>{
        const ACCEPTED_TYPES = [
            "MOBILE",
            "FIXED_LINE",
            "FIXED_LINE_OR_MOBILE"
        ];
        const phone = (0, $8Ba1X.parsePhoneNumberFromString)(number, countryCode);
        const type = (0, $dvOfD.parsePhoneNumberFromString)(phone?.number)?.getType();
        return {
            accepted: ACCEPTED_TYPES.includes(type),
            type: type
        };
    };
    const handleSubmit = ()=>{
        const checkTaxedNumber = checkIsTaxedNumber();
        if (!checkTaxedNumber.accepted) setError(formatMessage(`onboardingScreen.taxedNumberError.${checkTaxedNumber.type}`));
        else onSubmit(value);
    };
    const handleTermsChange = ()=>{
        onChange?.({
            ...value,
            termsAcceptance: !isTermAccepted
        });
        setIsTermAccepted(!isTermAccepted);
    };
    const handlePrivacyChange = ()=>{
        onChange?.({
            ...value,
            privacyPolicyAcceptance: !isPrivacyAccepted
        });
        setIsPrivacyAccepted(!isPrivacyAccepted);
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($08a5165fac3fcef4$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($08a5165fac3fcef4$var$StepTitle, {
                    children: formatMessage("onboardingScreen.initialStepTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($08a5165fac3fcef4$var$FormFieldWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                            label: "onboardingScreen.formLabels.firstName"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                            disabled: loading,
                            value: value.firstName,
                            onChange: (text)=>handleChange("firstName", text.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($08a5165fac3fcef4$var$FormFieldWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                            label: "onboardingScreen.formLabels.lastName"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                            disabled: loading,
                            value: value.lastName,
                            onChange: (text)=>handleChange("lastName", text.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($08a5165fac3fcef4$var$PhoneFieldWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                            label: "onboardingScreen.formLabels.phoneNumber"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $1Ny0s.PhoneInput), {
                            maxWidth: "0",
                            disabled: loading,
                            onChangeCountryCode: setCountryCode,
                            onChangePhoneNumber: setPhoneNumber,
                            initialCountryCode: initialPhoneNumber?.country ?? defaultCountry,
                            initialPhone: initialPhoneNumber?.nationalNumber.toString() ?? ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($08a5165fac3fcef4$var$FormFieldWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                            label: "onboardingScreen.formLabels.email"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                            disabled: loading,
                            type: "email",
                            value: value.email,
                            onChange: (text)=>handleChange("email", text.target.value)
                        })
                    ]
                }),
                needDistributorSelectionDuringOnboarding && /*#__PURE__*/ (0, $4m918.jsxs)($08a5165fac3fcef4$var$FormFieldWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                            label: "onboardingScreen.formLabels.selectDistributorDuringOnboarding"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                            disabled: loading,
                            type: "text",
                            value: value.distributorConfigurationCode,
                            onChange: (text)=>handleChange("distributorConfigurationCode", text.target.value)
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($08a5165fac3fcef4$var$HelperText, {
                            children: formatMessage("onboardingScreen.formLabels.selectDistributorDuringOnboardingHelperText")
                        })
                    ]
                }),
                configuration.termsAndConditionsUrl && /*#__PURE__*/ (0, $4m918.jsx)($08a5165fac3fcef4$var$StyledRegisterTermOfServiceWidgetWrapper, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $jxTls.RegisterTermOfServiceWidget), {
                        showTitle: false,
                        isTermAccepted: isTermAccepted,
                        onTermChange: handleTermsChange,
                        url: configuration.termsAndConditionsUrl,
                        hasEula: !!configuration.termsAndConditionsUrl
                    })
                }),
                configuration.privacyPolicyUrl && /*#__PURE__*/ (0, $4m918.jsx)($08a5165fac3fcef4$var$StyledRegisterTermOfServiceWidgetWrapper, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $kP5ln.RegisterPrivacyPolicy), {
                        showTitle: false,
                        isTermAccepted: isPrivacyAccepted,
                        onTermChange: handlePrivacyChange,
                        url: configuration.privacyPolicyUrl,
                        hasEula: !!configuration.privacyPolicyUrl
                    })
                }),
                !!(error || errorMessage) && /*#__PURE__*/ (0, $4m918.jsx)((0, $jn1mK.ErrorMessage), {
                    children: error || errorMessage
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($08a5165fac3fcef4$var$ButtonContainer, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($08a5165fac3fcef4$var$CancelButton, {
                            onClick: ()=>onCancel?.(),
                            size: "S",
                            children: formatMessage("onboardingScreen.cancelButton")
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($08a5165fac3fcef4$var$SubmitButton, {
                            disabled: !isFormValid() || loading,
                            onClick: ()=>{
                                try {
                                    handleSubmit();
                                } catch (e) {
                                    setError(e);
                                }
                            },
                            size: "S",
                            children: formatMessage("onboardingScreen.getStartedButton")
                        })
                    ]
                })
            ]
        })
    });
};
var $08a5165fac3fcef4$export$2e2bcd8739ae039 = $08a5165fac3fcef4$var$OnboardingInitialForm;
const $08a5165fac3fcef4$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  max-width: 460px;
`;
const $08a5165fac3fcef4$var$StepTitle = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  align-self: flex-start;
  margin-bottom: 32px;
  font-size: 32px;
  line-height: 42px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
/* Each field brings its own padded box; on a white page only the outline was missing, which left
   the fields standing invisible. */ const $08a5165fac3fcef4$var$FormFieldWrapper = (0, $jb8NR.default).div`
  margin-bottom: 20px;

  label {
    ${(0, $22v9q.theme).text};
    font-size: 14px;
    line-height: 18px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }

  input {
    ${(0, $22v9q.theme).text};
    font-size: 15px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }

  > div {
    width: 100%;
    border: 1px solid ${(0, $22v9q.theme).colors.gray[300]};
    border-radius: 8px;
  }
`;
const $08a5165fac3fcef4$var$HelperText = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  display: block;
  margin-top: 6px;
  font-size: 13px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
/* The phone stacks a country and a number, so the outline belongs to each of its two rows. */ const $08a5165fac3fcef4$var$PhoneFieldWrapper = (0, $jb8NR.default)($08a5165fac3fcef4$var$FormFieldWrapper)`
  > div {
    border: 0;
  }

  > div > div {
    width: 100%;
    overflow: hidden;
    border: 1px solid ${(0, $22v9q.theme).colors.gray[300]};
    border-radius: 8px;
  }

  > div > div:not(:last-child) {
    margin-bottom: 12px;
  }
`;
const $08a5165fac3fcef4$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 8px;
  width: 100%;
`;
const $08a5165fac3fcef4$var$CancelButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))`
  flex: 1;
  padding: 13px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  box-shadow: none;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
const $08a5165fac3fcef4$var$SubmitButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  flex: 1;
  padding: 13px;
  box-shadow: none;
`;
/* A panel of its own, as the redesign frames a block of text one has to read before agreeing. */ const $08a5165fac3fcef4$var$StyledRegisterTermOfServiceWidgetWrapper = (0, $jb8NR.default).div`
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;

  /* The widget keeps its own look where the register flow shows it alone; inside this panel the
     two lines and the switch are sized like the rest of the form. */
  > div > div > div {
    ${(0, $22v9q.theme).text};
    margin-bottom: 0;
    font-size: 15px;
    line-height: 20px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }

  > div > div > div:last-child {
    margin-top: 8px;
    font-size: 13px;
    line-height: 18px;
    color: ${(0, $22v9q.theme).colors.gray[800]};
  }

  a {
    color: ${(0, $22v9q.theme).colors.blue[700]};
  }

  /* The consent sits across the panel, the switch answering the label from the far side. */
  > div > button {
    width: 100%;
    max-width: none;
    justify-content: space-between;
    margin: 16px 0 0;
    padding: 0;
  }

  ${(0, $ajNEj.SwitchLabel)} {
    ${(0, $22v9q.theme).text};
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }
`;

});
parcelRegister("dvOfD", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumberFromString", function () { return $9d65266c95804ef1$export$9c5cae3d55d8e910; });

var $8oQb8 = parcelRequire("8oQb8");

var $gGN3t = parcelRequire("gGN3t");
function $9d65266c95804ef1$export$9c5cae3d55d8e910() {
    return (0, $8oQb8.withMetadata)((0, $gGN3t.default), arguments);
}

});
parcelRegister("8oQb8", function(module, exports) {

$parcel$export(module.exports, "withMetadata", function () { return $61d90a32f14df62d$export$164451d7043c1432; });
// Importing from `.json.js` a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239

var $5Aa8t = parcelRequire("5Aa8t");
var $61d90a32f14df62d$export$2e2bcd8739ae039 = (0, $5Aa8t.default);
function $61d90a32f14df62d$export$164451d7043c1432(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $5Aa8t.default));
    return func.apply(this, args);
}

});
parcelRegister("5Aa8t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41082d4363be0e52$export$2e2bcd8739ae039; });
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $41082d4363be0e52$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "6[2-467]\\d{3}",
                    [
                        5
                    ]
                ],
                [
                    "4\\d{4}",
                    [
                        5
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:0[1-9]|[1589]\\d)\\d{4}",
                    [
                        6
                    ]
                ]
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[78]\\d{5}",
                    [
                        6
                    ]
                ],
                [
                    "690\\d{6}|[356]\\d{5}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "180[02]\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "[19]\\d{5}",
                    [
                        6
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[2-4679][2-8]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "5[024-68]\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "400\\d{6}|800\\d{2,9}"
                ],
                [
                    "900[02]\\d{5}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "600[25]\\d{5}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "700[05]\\d{5}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"
                ],
                [
                    "7\\d{8}"
                ]
            ]
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([457]\\d{6})$",
            "268$1",
            0,
            "268",
            [
                [
                    "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"
                ],
                [
                    "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                [
                    "26840[69]\\d{4}"
                ],
                [
                    "26848[01]\\d{4}"
                ]
            ]
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2457]\\d{6})$",
            "264$1",
            0,
            "264",
            [
                [
                    "264(?:292|4(?:6[12]|9[78]))\\d{4}"
                ],
                [
                    "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                [
                    "264724\\d{4}"
                ]
            ]
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "6(?:[78][2-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "900[1-9]\\d\\d",
                    [
                        6
                    ]
                ],
                [
                    "700[2-9]\\d{4}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "808[1-9]\\d\\d",
                    [
                        6
                    ]
                ]
            ]
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"
                ],
                [
                    "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"
                ],
                [
                    "800\\d{5}"
                ],
                [
                    "90[016]\\d{5}"
                ],
                0,
                0,
                0,
                0,
                [
                    "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}"
                ],
                [
                    "80[1-4]\\d{5}"
                ]
            ]
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"
                ],
                [
                    "9[1-49]\\d{7}"
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1",
            0,
            0,
            [
                [
                    "3888[013-9]\\d{5}|(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"
                ],
                [
                    "800\\d{7,8}"
                ],
                [
                    "60[04579]\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                [
                    "810\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([267]\\d{6})$",
            "684$1",
            0,
            "684",
            [
                [
                    "6846(?:22|33|44|55|77|88|9[19])\\d{4}"
                ],
                [
                    "684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"
                ],
                [
                    "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ],
                [
                    "800\\d{6,10}",
                    [
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ],
                [
                    "9(?:0[01]|3[019])\\d{6,10}",
                    [
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ],
                [
                    "8(?:10|2[018])\\d{6,10}|828\\d{5}",
                    [
                        8,
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ]
            ]
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "0|(183[12])",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2\\d|8[1-9])\\d{4}"
                ],
                [
                    "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"
                ],
                [
                    "800\\d{4}"
                ],
                [
                    "900\\d{4}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:28\\d|501)\\d{4}"
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            [
                [
                    "18[1-8]\\d{3,6}",
                    [
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "800\\d{4,6}",
                    [
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "[67]00\\d{5,6}",
                    [
                        8,
                        9
                    ]
                ],
                0,
                0,
                [
                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"
                ]
            ],
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365|46",
                        "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:222[0-79]\\d|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}|(?:(?:1[28]|46)\\d|2(?:[045]2|1[24]|2[34]|33|6[23]))\\d{6}"
                ],
                [
                    "(?:36554|99[2-9]\\d\\d)\\d{4}|(?:[16]0|4[04]|5[015]|7[07])\\d{7}"
                ],
                [
                    "88\\d{7}"
                ],
                [
                    "900200\\d{3}"
                ]
            ]
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"
                ],
                [
                    "8[08]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "9[0246]\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    "8[12]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "246$1",
            0,
            "246",
            [
                [
                    "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"
                ],
                [
                    "246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "(?:246976|900[2-9]\\d\\d)\\d{4}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                [
                    "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}"
                ],
                0,
                [
                    "24631\\d{5}"
                ]
            ]
        ],
        "BD": [
            "880",
            "00",
            "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2[45]\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"
                ],
                [
                    "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "80[03]\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "4[5-9]\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "800[1-9]\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "(?:70(?:2[0-57]|3[04-7]|44|69|7[0579])|90(?:0[0-8]|1[36]|2[0-3568]|3[013-689]|[47][2-68]|5[1-68]|6[0-378]|9[34679]))\\d{4}",
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    "78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078]|9\\d)\\d{4}",
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    "7879\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"
                ],
                [
                    "(?:0[1267]|5[1-8]|[67]\\d)\\d{6}"
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
                    [
                        6,
                        7,
                        8
                    ]
                ],
                [
                    "43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "800\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "90\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "700\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[047]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}"
                ],
                [
                    "(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"
                ],
                [
                    "80\\d{6}"
                ],
                [
                    "(?:87|9[014578])\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "84\\d{6}"
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "22\\d{6}"
                ],
                [
                    "(?:29|31|6[1289]|7[125-9])\\d{6}"
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[25689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[25689]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:02|1[037]|2[45]|3[68])\\d{5}"
                ],
                [
                    "(?:5[1-35-8]|6\\d|9[013-9])\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "81\\d{6}"
                ],
                0,
                [
                    "857[58]\\d{4}"
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "441$1",
            0,
            "441",
            [
                [
                    "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"
                ],
                [
                    "441(?:[2378]\\d|5[0-39])\\d{5}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"
                ],
                [
                    "(?:22[89]|[78]\\d\\d)\\d{4}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "5[34]\\d{5}"
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?",
            0,
            0,
            0,
            [
                [
                    "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "[67]\\d{7}",
                    [
                        8
                    ]
                ],
                [
                    "8001[07]\\d{4}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]",
            [
                [
                    "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"
                ],
                [
                    "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"
                ]
            ]
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2",
            0,
            0,
            [
                [
                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                    [
                        10,
                        11
                    ]
                ],
                [
                    "800\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "300\\d{6}|[59]00\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}",
                    [
                        8,
                        10
                    ]
                ]
            ]
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-8]\\d{6})$",
            "242$1",
            0,
            "242",
            [
                [
                    "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"
                ],
                [
                    "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"
                ],
                [
                    "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                [
                    "242225\\d{4}"
                ]
            ]
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "(?:1[67]|77)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-79]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "(?:321|7(?:[1-7]\\d|8[01]))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "(?:0800|800\\d)\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "90\\d{5}",
                    [
                        7
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            [
                [
                    "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
                    [
                        9
                    ]
                ],
                [
                    "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"
                ],
                [
                    "(?:810|902)\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "249\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "6[0-35-7]\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "0800\\d{7}",
                    [
                        11
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "600[2-9]\\d{6}"
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "12\\d{7}|[1-6]\\d{6}"
                ],
                [
                    "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}"
                ]
            ]
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2[12]\\d{6}"
                ],
                [
                    "7[0257]\\d{6}"
                ],
                0,
                [
                    "8776\\d{4}"
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "801"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "222[1-589]\\d{5}"
                ],
                [
                    "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"
                ],
                0,
                [
                    "80(?:0\\d\\d|11[0-4])\\d{4}"
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}"
                ],
                [
                    "7[35-9]\\d{7}"
                ],
                [
                    "800\\d{6}"
                ],
                [
                    "90[016]\\d{6}"
                ],
                [
                    "878\\d{6}"
                ],
                0,
                [
                    "5[18]\\d{7}"
                ],
                [
                    "74[0248]\\d{6}"
                ],
                0,
                [
                    "84[0248]\\d{6}"
                ]
            ]
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|[23][45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"
                ],
                [
                    "0704[0-7]\\d{5}|0(?:[15]\\d\\d|7(?:0[0-37-9]|[4-9][7-9]))\\d{6}"
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2\\d|3[13-7]|4[1-5])\\d{3}"
                ],
                [
                    "[578]\\d{4}"
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-3]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "",
                    [
                        9
                    ]
                ],
                [
                    "(?:123|8)00\\d{6}",
                    [
                        9,
                        11
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "44\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "600\\d{7,8}",
                    [
                        10,
                        11
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:22|33)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "(?:24[23]|6[5-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "88\\d{6,7}"
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "(?:10|2[0-57-9])(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "0|(1(?:[12]\\d|79)\\d\\d)",
            0,
            0,
            0,
            [
                [
                    "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                    [
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}",
                    [
                        11
                    ]
                ],
                [
                    "(?:(?:10|21)8|8)00\\d{7}",
                    [
                        10,
                        12
                    ]
                ],
                [
                    "16[08]\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ]
            ],
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[146][2-9]|[2578]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "[39]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?",
            0,
            0,
            0,
            [
                [
                    "60[124-8][2-9]\\d{6}|[124-8][2-9]\\d{6}",
                    [
                        8,
                        10
                    ]
                ],
                [
                    "3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[2-6]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "1800\\d{7}",
                    [
                        11
                    ]
                ],
                [
                    "19(?:0[01]|4[78])\\d{7}",
                    [
                        11
                    ]
                ]
            ]
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))",
            0,
            0,
            0,
            [
                [
                    "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "800\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "90[059]\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"
                ],
                [
                    "5\\d{7}",
                    [
                        8
                    ]
                ],
                [
                    "800\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "807\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"
                ],
                [
                    "(?:[34][36]|5[1-389]|9\\d)\\d{5}"
                ],
                [
                    "800\\d{4}"
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]",
            [
                [
                    "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"
                ],
                [
                    "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "955\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                [
                    "60[0-2]\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2[2-6]\\d{6}"
                ],
                [
                    "9[4-79]\\d{6}"
                ],
                [
                    "800\\d{5}"
                ],
                [
                    "90[09]\\d{5}"
                ],
                [
                    "700\\d{5}"
                ],
                0,
                [
                    "(?:50|77)\\d{6}"
                ],
                0,
                0,
                [
                    "80[1-9]\\d{5}"
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}"
                ],
                [
                    "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"
                ],
                [
                    "800\\d{6}"
                ],
                [
                    "9(?:0[05689]|76)\\d{6}"
                ],
                [
                    "70[01]\\d{6}"
                ],
                0,
                [
                    "9(?:5\\d|7[2-4])\\d{6}"
                ],
                0,
                [
                    "9[17]0\\d{6}"
                ],
                [
                    "8[134]\\d{7}"
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "32\\d{9,11}|49[3-6]\\d{10}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15
                    ]
                ],
                [
                    "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",
                    [
                        10,
                        11
                    ]
                ],
                [
                    "800\\d{7,12}",
                    [
                        10,
                        11,
                        12,
                        13,
                        14,
                        15
                    ]
                ],
                [
                    "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
                    [
                        10,
                        11
                    ]
                ],
                [
                    "700\\d{8}",
                    [
                        11
                    ]
                ],
                0,
                [
                    "18(?:1\\d{5,11}|[2-9]\\d{8})",
                    [
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ],
                [
                    "16(?:4\\d{1,10}|[89]\\d{1,11})",
                    [
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ],
                0,
                [
                    "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ]
            ]
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:1[2-5]|7[45])\\d{5}"
                ],
                [
                    "77\\d{6}"
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "80\\d{6}"
                ],
                [
                    "90\\d{6}"
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "767$1",
            0,
            "767",
            [
                [
                    "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"
                ],
                [
                    "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9",
            [
                [
                    "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"
                ],
                [
                    "8[024]9[2-9]\\d{6}"
                ],
                [
                    "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}"
                ],
                [
                    "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "80[3-689]1\\d{5}",
                    [
                        9
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "98[23]\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "80[12]1\\d{5}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[2-7][2-7]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "1800\\d{7}|1[78]00\\d{6}",
                    [
                        10,
                        11
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "[2-7]890\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                    [
                        7,
                        8
                    ]
                ],
                [
                    "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"
                ],
                [
                    "(?:40\\d\\d|900)\\d{4}",
                    [
                        7,
                        8
                    ]
                ],
                [
                    "70[0-2]\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[189]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "1[0-25]\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "800\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "900\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]",
            [
                [
                    "528[89]\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-3]|6[1267]|7[0-57]))\\d{6}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "592(?:4[0-2]|93)\\d{4}"
                ]
            ]
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"
                ],
                [
                    "(?:17[1-3]|7\\d\\d)\\d{4}"
                ]
            ]
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"
                ],
                [
                    "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"
                ],
                [
                    "[89]00\\d{6}"
                ],
                [
                    "80[367]\\d{6}"
                ],
                [
                    "70\\d{7}"
                ],
                0,
                [
                    "51\\d{7}"
                ],
                0,
                0,
                [
                    "90[12]\\d{6}"
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-59]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-59]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"
                ],
                [
                    "9\\d{8}"
                ]
            ]
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            [
                [
                    "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "800\\d{4,6}",
                    [
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "[67]00\\d{5,6}",
                    [
                        8,
                        9
                    ]
                ],
                0,
                0,
                [
                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"
                ]
            ],
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "0800\\d{7}",
                    [
                        11
                    ]
                ]
            ],
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[2-47]\\d{4}"
                ],
                [
                    "[56]\\d{4}"
                ]
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"
                ],
                [
                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))",
            0,
            0,
            0,
            [
                [
                    "(?:20|[34]\\d|8[19])\\d{4}"
                ],
                [
                    "(?:[27][1-9]|5\\d|91)\\d{4}"
                ],
                [
                    "80[257-9]\\d{3}"
                ],
                [
                    "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:6[0-36]|88)\\d{4}"
                ]
            ]
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:[1-35]\\d|4[1-9])\\d{7}"
                ],
                [
                    "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7(?:00|[3-9]\\d))\\d{6}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                [
                    "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"
                ],
                0,
                0,
                [
                    "80[6-9]\\d{6}"
                ],
                0,
                [
                    "9\\d{8}"
                ],
                [
                    "8(?:1[01]|2[0156]|84)\\d{6}"
                ]
            ]
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})",
            "$1",
            0,
            0,
            [
                [
                    "[01]1\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "(?:0[2-7]|6[256]|7[47])\\d{6}|[2-7]\\d{6}"
                ]
            ]
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[02459]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "473$1",
            0,
            "473",
            [
                [
                    "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"
                ],
                [
                    "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"
                ],
                [
                    "5(?:0555[5-9]|757(?:7[7-9]|8[01]))\\d{3}|5(?:0070|[25]222|3333)[0-4]\\d{3}|5(?:00(?:0\\d|50)|11(?:1\\d|2[0-4])|5200|75(?:00|[57]5)|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88)))\\d{4}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}"
                ],
                [
                    "800\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "70[67]\\d{6}"
                ]
            ]
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94|80\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[0-24])\\d{4}"
                ],
                [
                    "694(?:[0-249]\\d|3[0-48])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976\\d{6}"
                ]
            ]
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([25-9]\\d{5})$",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
                    [
                        9
                    ]
                ],
                [
                    "(?:2(?:[0346-8]\\d|5[67])|5(?:[0457]\\d|6[01]|9[1-9]))\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d\\d|606)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}"
                ],
                [
                    "(?:5[146-8]\\d|606)\\d{5}"
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}"
                ],
                [
                    "[245]\\d{5}"
                ],
                [
                    "80\\d{4}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "3[89]\\d{4}"
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"
                ],
                [
                    "(?:[23679]\\d|5[0-389])\\d{5}"
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "6[0-356]\\d{7}",
                    [
                        9
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "722\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"
                ],
                [
                    "(?:222|55\\d)\\d{6}"
                ],
                [
                    "80\\d[1-9]\\d{5}"
                ],
                [
                    "90\\d[1-9]\\d{5}"
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "800\\d{7,8}"
                ],
                [
                    "90[19]\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "5005000\\d{3}",
                    [
                        10
                    ]
                ],
                0,
                0,
                [
                    "8(?:0[16]|12|[27]5|50)\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[267][2-9]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "[3-5]\\d{7}",
                    [
                        8
                    ]
                ],
                [
                    "18[01]\\d{8}",
                    [
                        11
                    ]
                ],
                [
                    "19\\d{9}",
                    [
                        11
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-9]\\d{6})$",
            "671$1",
            0,
            "671",
            [
                [
                    "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "443\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "9(?:5\\d|6[569]|77)\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "40\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}"
                ],
                [
                    "6\\d{6}"
                ],
                [
                    "(?:289|862)\\d{4}"
                ],
                [
                    "9008\\d{3}"
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-6]|5[0-5]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "(?:46(?:[07][0-7]|1[0-6]|4[0-57-9]|5[0-8]|6[0-4])|5730|6(?:26[013-7]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|929[03-9])\\d{4}|(?:46[238]|5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "800\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                    [
                        5,
                        6,
                        7,
                        8,
                        11
                    ]
                ],
                [
                    "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
                    [
                        8
                    ]
                ],
                0,
                [
                    "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:2(?:0[0-39]|1[1-367]|[23]\\d|4[03-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-9]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|74|80)|6(?:[056]\\d|17|2[07]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "[37-9]\\d{7}",
                    [
                        8
                    ]
                ],
                [
                    "8002\\d{7}",
                    [
                        11
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "80[01]\\d{4,6}",
                    [
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "6[01459]\\d{6}|6[01]\\d{4,5}",
                    [
                        6,
                        7,
                        8
                    ]
                ],
                [
                    "7[45]\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                [
                    "62\\d{6,7}|72\\d{6}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "HT": [
            "509",
            "00",
            "[2-489]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-489]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:2\\d|5[1-5]|81|9[149])\\d{5}"
                ],
                [
                    "[34]\\d{7}"
                ],
                [
                    "8\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "(?:[257]0|3[01])\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "(?:[48]0\\d|6802)\\d{5}"
                ],
                [
                    "9[01]\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    "38\\d{7}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "21\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "8[1-35-9]\\d{7,10}",
                    [
                        9,
                        10,
                        11,
                        12
                    ]
                ],
                [
                    "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",
                    [
                        8,
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ],
                [
                    "809\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                [
                    "(?:1500|8071\\d{3})\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                0,
                0,
                [
                    "804\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"
                ],
                [
                    "8(?:22|[35-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "1800\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "700\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "818\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "76\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "18[59]0\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
                    [
                        8,
                        11,
                        12
                    ]
                ],
                [
                    "5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                    [
                        9
                    ]
                ],
                [
                    "1(?:255|80[019]\\d{3})\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}",
                    [
                        8,
                        10
                    ]
                ],
                0,
                0,
                [
                    "1599\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "1700\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([25-8]\\d{5})$",
            "1624$1",
            0,
            "74576|(?:16|7[56])24",
            [
                [
                    "1624(?:230|[5-8]\\d\\d)\\d{3}"
                ],
                [
                    "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"
                ],
                [
                    "808162\\d{4}"
                ],
                [
                    "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"
                ],
                [
                    "70\\d{8}"
                ],
                0,
                [
                    "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"
                ],
                0,
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"
                ],
                [
                    "186[12]\\d{9}",
                    [
                        13
                    ]
                ],
                0,
                0,
                [
                    "140\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                [
                    "1860\\d{7}",
                    [
                        11
                    ]
                ]
            ]
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "37\\d{5}"
                ],
                [
                    "38\\d{5}"
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "7[3-9]\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}",
                    [
                        6,
                        7,
                        10
                    ]
                ],
                [
                    "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:(?:[0-3]\\d|4[0145])\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|[19]\\d|21|77|8[7-9])))\\d{5}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                    [
                        4,
                        5
                    ]
                ]
            ]
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}"
                ],
                [
                    "80[08]\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                    [
                        7
                    ]
                ],
                0,
                0,
                [
                    "809\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "49[0-24-79]\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[245])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1[4679]|[38]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([0-24-8]\\d{5})$",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876",
            [
                [
                    "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"
                ],
                [
                    "(?:658295|876(?:2(?:0[6-9]|[14-9]\\d|2[013-9]|3[7-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "7(?:[78][0-25-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "80\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "9\\d{7}",
                    [
                        8
                    ]
                ],
                [
                    "70\\d{7}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "8(?:10|8\\d)\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "74(?:66|77)\\d{5}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "85\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "[7-9]0[1-9]\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"
                ],
                [
                    "990\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "60\\d{7}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "570\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "20\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "50[1-9]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                    [
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "(?:1(?:0[0-6]|1[0-5]|2[014])|7\\d\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800[24-8]\\d{5,6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "900[02-9]\\d{5}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
                    [
                        9
                    ]
                ],
                [
                    "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|880|99[05-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{6,7}"
                ]
            ]
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "1800(?:1\\d|2[019])\\d{4}",
                    [
                        10
                    ]
                ],
                [
                    "1900(?:1\\d|2[09])\\d{4}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"
                ],
                [
                    "(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",
                    [
                        8
                    ]
                ]
            ]
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "7[4-7]\\d{5}"
                ],
                [
                    "[34]\\d{6}"
                ],
                0,
                [
                    "8\\d{6}"
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "869$1",
            0,
            "869",
            [
                [
                    "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"
                ],
                [
                    "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"
                ],
                [
                    "19[1-3]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?",
            0,
            0,
            0,
            [
                [
                    "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                    [
                        5,
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}",
                    [
                        9,
                        11,
                        12,
                        13,
                        14
                    ]
                ],
                [
                    "60[2-9]\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "50\\d{8,9}",
                    [
                        10,
                        11
                    ]
                ],
                0,
                [
                    "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "15\\d{7,8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KW": [
            "965",
            "00",
            "(?:18|[2569]\\d\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[25]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "(?:5(?:2(?:22|5[25])|7(?:55|77)|88[58])|6(?:222|333|444|70[013-9]|888|93[039])|9(?:11[01]|3(?:00|33)|500))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|[4679]\\d|55|8[057-9]))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "18\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "345$1",
            0,
            "345",
            [
                [
                    "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}"
                ],
                [
                    "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "(?:345976|900[2-9]\\d\\d)\\d{4}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                [
                    "345849\\d{4}"
                ]
            ]
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            [
                [
                    "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|108\\d{3})\\d{7}"
                ],
                [
                    "809\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "808\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "751\\d{7}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "30[013-9]\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"
                ],
                [
                    "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"
                ],
                0,
                [
                    "9[01]\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "80\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "758$1",
            0,
            "758",
            [
                [
                    "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"
                ],
                [
                    "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "LI": [
            "423",
            "00",
            "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "0|(1001)",
            0,
            0,
            0,
            [
                [
                    "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "(?:6(?:4(?:69|[7-9]\\d)|5[0-4]\\d|6(?:[024]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"
                ],
                [
                    "80(?:02[28]|9\\d\\d)\\d\\d",
                    [
                        7
                    ]
                ],
                [
                    "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                    [
                        7
                    ]
                ],
                0,
                0,
                [
                    "870(?:28|87)\\d\\d",
                    [
                        7
                    ]
                ]
            ]
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"
                ],
                [
                    "7(?:[0-25-8]\\d|4[01])\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "1973\\d{5}"
                ]
            ]
        ],
        "LR": [
            "231",
            "00",
            "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2\\d{3}|33333)\\d{4}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",
                    [
                        7,
                        9
                    ]
                ],
                0,
                [
                    "332(?:02|[34]\\d)\\d{4}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2\\d{7}"
                ],
                [
                    "[56]\\d{7}"
                ],
                [
                    "800[256]\\d{4}"
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]",
            0,
            0,
            0,
            [
                [
                    "(?:3[1478]|4[124-6]|52)\\d{6}"
                ],
                [
                    "6\\d{7}"
                ],
                [
                    "80[02]\\d{5}"
                ],
                [
                    "9(?:0[0239]|10)\\d{5}"
                ],
                [
                    "70[05]\\d{5}"
                ],
                0,
                [
                    "70[67]\\d{5}"
                ],
                0,
                [
                    "[89]01\\d{5}"
                ],
                [
                    "808\\d{5}"
                ]
            ]
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
            0,
            0,
            0,
            [
                [
                    "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"
                ],
                [
                    "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "90[015]\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "20(?:1\\d{5}|[2-689]\\d{1,7})",
                    [
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "801\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "6\\d{7}"
                ],
                [
                    "2\\d{7}"
                ],
                [
                    "80\\d{6}"
                ],
                [
                    "90\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "81\\d{6}"
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"
                ],
                [
                    "9[1-6]\\d{7}"
                ]
            ]
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1-$2",
                    [
                        "5(?:29|38)",
                        "5(?:29|38)[89]",
                        "5(?:29|38)[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|892",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-3]|6[1267]|7[0-57]))\\d{6}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "592(?:4[0-2]|93)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:870|9[2-47-9]\\d)\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"
                ],
                [
                    "(?:800|90\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"
                ],
                [
                    "562\\d{5}|(?:6\\d|7[16-9])\\d{6}"
                ],
                [
                    "800\\d{5}"
                ],
                [
                    "90[056]\\d{5}"
                ],
                0,
                0,
                [
                    "803\\d{5}"
                ],
                0,
                [
                    "3[08]\\d{6}"
                ],
                [
                    "808\\d{5}"
                ]
            ]
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "80(?:[0-2578]|9\\d)\\d{5}"
                ],
                [
                    "9(?:4[1568]|5[178])\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    "77[1-9]\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                [
                    "78[1-49]\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MF": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0|([24-9]\\d{6})$",
            "20$1",
            0,
            0,
            [
                [
                    "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}"
                ],
                [
                    "3[2-489]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "22\\d{7}"
                ]
            ]
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:247|528|625)\\d{4}"
                ],
                [
                    "(?:(?:23|54)5|329|45[56])\\d{4}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "635\\d{4}"
                ]
            ]
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"
                ],
                [
                    "7(?:3555|4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[2-4]|42|9[23])\\d{5}"
                ],
                [
                    "800\\d{5}"
                ],
                [
                    "5[02-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "8(?:0[1-9]|[1-9]\\d)\\d{5}"
                ]
            ]
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"
                ],
                [
                    "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}"
                ],
                [
                    "80\\d{6}"
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                    [
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "80080(?:[01][1-9]|2\\d)\\d{3}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "1333\\d{4}|[12]468\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[57-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"
                ],
                [
                    "(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "712[0-79]\\d{4}|7(?:1[013-9]|[5-8]\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "0800\\d{3}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "670$1",
            0,
            "670",
            [
                [
                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "MQ": [
            "596",
            "00",
            "(?:69|80)\\d{7}|(?:59|97)6\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "596(?:0[0-8]|10|2[7-9]|3[04-9]|[4-7]\\d|8[09]|9[4-9])\\d{4}"
                ],
                [
                    "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976(?:6\\d|7[0-367])\\d{4}"
                ]
            ]
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:25[08]|35\\d|45[1-7])\\d{5}"
                ],
                [
                    "[2-4][0-46-9]\\d{6}"
                ],
                [
                    "800\\d{5}"
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([34]\\d{6})$",
            "664$1",
            0,
            "664",
            [
                [
                    "6644(?:1[0-3]|91)\\d{4}"
                ],
                [
                    "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:0(?:[19]\\d|3[1-4]|6[059])|[1-357]\\d\\d)\\d{4}"
                ],
                [
                    "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"
                ],
                [
                    "800[3467]\\d{4}"
                ],
                [
                    "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"
                ],
                0,
                0,
                [
                    "501\\d{5}"
                ],
                [
                    "7117\\d{4}"
                ],
                [
                    "3550\\d{4}"
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
                    [
                        7,
                        8
                    ]
                ],
                [
                    "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[5-9]|4[3-589]|[57]\\d|8[0-689]|9[0-8])\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "802\\d{7}|80[0-2]\\d{4}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "30\\d{5}",
                    [
                        7
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "3(?:20|9\\d)\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[3467]|9[13-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "800\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "900\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                [
                    "4[05]0\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1[2-9]|21\\d\\d)\\d{5}"
                ],
                [
                    "111\\d{6}|(?:31|77|88|9[89])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:65[0-689]|99[1-9])\\d{7}|(?:1(?:[0147]\\d|[235][1-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            [
                [
                    "6571\\d{6}|(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "6571\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}"
                ],
                [
                    "8(?:00|88)\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "900\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "500\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "300\\d{7}",
                    [
                        10
                    ]
                ]
            ],
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9])|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1[36-8]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "1(?:1888[69]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0134]\\d|2[1-9]|5[0-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "1[378]00\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "1600\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "8[2-79]\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"
                ],
                [
                    "(?:60|8[1245])\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "80\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "8701\\d{5}",
                    [
                        9
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "8(?:3\\d\\d|86)\\d{5}"
                ]
            ]
        ],
        "NC": [
            "687",
            "00",
            "[2-57-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"
                ],
                [
                    "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"
                ],
                0,
                [
                    "36\\d{4}"
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[04]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"
                ],
                [
                    "(?:23|7[04]|[89]\\d)\\d{6}"
                ],
                [
                    "08\\d{6}"
                ],
                [
                    "09\\d{6}"
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1",
            0,
            0,
            [
                [
                    "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"
                ],
                [
                    "(?:14|3[58])\\d{4}"
                ]
            ]
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
                    [
                        7,
                        8
                    ]
                ],
                [
                    "(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|9(?:0[1-9]|1[2356]))\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "800\\d{7,11}",
                    [
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ],
                0,
                0,
                0,
                [
                    "700\\d{7,11}",
                    [
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ]
            ]
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2\\d{7}"
                ],
                [
                    "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"
                ],
                [
                    "1800\\d{4}"
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-57-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "6[1-58]\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{4,7}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "90[069]\\d{4,7}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                0,
                0,
                [
                    "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
                    [
                        5,
                        6,
                        9
                    ]
                ],
                [
                    "66\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "(?:85|91)\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[489]|59"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]",
            [
                [
                    "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "(?:4[015-8]|59|9\\d)\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "80[01]\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "82[09]\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "880\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                [
                    "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"
                ],
                0,
                [
                    "85[0-5]\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-579]|6[2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "1(?:66001|800\\d\\d)\\d{5}",
                    [
                        11
                    ]
                ]
            ]
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "444\\d{4}"
                ],
                [
                    "(?:55[3-9]|666|8\\d\\d)\\d{4}"
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[47]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[47]\\d{3}",
                    [
                        4
                    ]
                ],
                [
                    "888[4-9]\\d{3}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-579]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|[89]0",
                        "50(?:[0367]|88)|[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[59]|80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7|86"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "2[0-27-9]\\d{7,8}|21\\d{6}",
                    [
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "508\\d{6,7}|80\\d{6,8}",
                    [
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "70\\d{7}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}"
                ],
                [
                    "[28]6\\d{6,7}",
                    [
                        8,
                        9
                    ]
                ]
            ],
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2[2-6]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "1505\\d{4}|(?:7(?:[1289]\\d|70)|9(?:0[1-9]|[1-9]\\d))\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "8007\\d{4,5}|(?:500|800[05])\\d{4}"
                ],
                [
                    "900\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[139])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-5]|33|4[0-79]|55|6[068]|7[03-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[6-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-8])\\d|8(?:1[01]|7[23]))\\d{4}",
                    [
                        7,
                        8
                    ]
                ],
                [
                    "800\\d{4}(?:\\d(?:\\d{2})?)?"
                ],
                [
                    "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "9\\d{8}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "805\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "80[24]\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "801\\d{5}",
                    [
                        8
                    ]
                ]
            ],
            0,
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "4(?:0[4-689]|9[4-68])\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "8[7-9]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "80[0-5]\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                0,
                [
                    "44\\d{4}",
                    [
                        6
                    ]
                ],
                0,
                [
                    "499\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "(?:7\\d|8[18])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "180\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "27[01]\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "2(?:0[0-47]|7[568])\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[2357]\\d|4[2-9]|6[0-35-9]|8[135-9]|9[1-9]))\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "1800\\d{7,9}",
                    [
                        11,
                        12,
                        13
                    ]
                ]
            ]
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "800\\d{5}(?:\\d{3})?",
                    [
                        8,
                        11
                    ]
                ],
                [
                    "900\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "122\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                    [
                        11,
                        12
                    ]
                ]
            ]
        ],
        "PL": [
            "48",
            "00",
            "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
                    [
                        7,
                        9
                    ]
                ],
                [
                    "211(?:1\\d|3[1-5])\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "70[01346-8]\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "804\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "64\\d{4,7}",
                    [
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "39\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "801\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "(?:[45]|80\\d\\d)\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:4[1-3]|50)\\d{4}",
                    [
                        6
                    ]
                ],
                [
                    "(?:4[02-4]|5[05])\\d{4}",
                    [
                        6
                    ]
                ],
                [
                    "80[0-5]\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939",
            [
                [
                    "(?:787|939)[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "5[69]\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "1800\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1700\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}"
                ],
                [
                    "6[0356]92(?:30|9\\d)\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"
                ],
                [
                    "80[02]\\d{6}"
                ],
                [
                    "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"
                ],
                [
                    "884[0-4689]\\d{5}"
                ],
                0,
                [
                    "70(?:7\\d|8[17])\\d{5}"
                ],
                0,
                [
                    "30\\d{7}"
                ],
                [
                    "80(?:8\\d|9[1579])\\d{5}"
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"
                ],
                [
                    "(?:46[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                    [
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "9800\\d{5,7}",
                    [
                        9,
                        10,
                        11
                    ]
                ],
                0,
                0,
                0,
                [
                    "[2-9]0\\d{4,7}",
                    [
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                0,
                [
                    "8700[0-4]\\d{4}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "QA": [
            "974",
            "00",
            "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[126]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "4141\\d{4}|(?:23|4[04])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "(?:28|[35-7]\\d)\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "800\\d{4}(?:\\d{2})?",
                    [
                        7,
                        9
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "2(?:[12]\\d|61)\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "9769\\d{5}|(?:26|[68]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "26[23]|69|[89]",
            [
                [
                    "26(?:2\\d\\d|30[0-5])\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"
                ],
                [
                    "7020\\d{5}|7(?:0[013-9]|1[0-2]|[2-7]\\d|8[03-8]|9[019])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "90[0136]\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "(?:37\\d|80[578])\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "801\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11,
                        12
                    ]
                ],
                [
                    "6(?:[0-689]|7\\d)\\d{6,7}",
                    [
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "800\\d{3,9}"
                ],
                [
                    "(?:78\\d|90[0169])\\d{3,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                0,
                0,
                [
                    "7[06]\\d{4,10}"
                ]
            ]
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            [
                [
                    "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "9\\d{9}",
                    [
                        10
                    ]
                ],
                [
                    "8(?:0[04]|108\\d{3})\\d{7}"
                ],
                [
                    "80[39]\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "808\\d{7}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:06|2[23568]\\d)\\d{6}"
                ],
                [
                    "7[2389]\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "900\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "579[01]\\d{5}|5(?:[013-689]\\d|7[0-36-8])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "925\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "811\\d{7}",
                    [
                        10
                    ]
                ],
                0,
                0,
                [
                    "920\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
                    [
                        5
                    ]
                ],
                [
                    "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"
                ],
                [
                    "1[38]\\d{3}",
                    [
                        5
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "5[12]\\d{3}",
                    [
                        5
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "8000\\d{3}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "4[2-46]\\d{5}"
                ],
                [
                    "2[5-8]\\d{5}"
                ],
                [
                    "8000\\d{3}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "971\\d{4}|(?:64|95)\\d{5}"
                ]
            ],
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "1(?:5\\d|8[35-7])\\d{6}"
                ],
                [
                    "(?:1[0-2]|9[0-3569])\\d{7}"
                ]
            ]
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                    [
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "7[02369]\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "20\\d{4,7}",
                    [
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "75[1-8]\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "10[1-8]\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "74[02-9]\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "77[0-7]\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-4]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "662[0-24-9]\\d{4}|6(?:[1-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "(?:8(?:0(?:[13]\\d|2[013-9]|4[0-35-7])|[1-8]\\d\\d|9(?:[0-4]\\d|5[0-2]))|9[0-8]\\d\\d)\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "(?:18|8)00\\d{7}",
                    [
                        10,
                        11
                    ]
                ],
                [
                    "1900\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "7000\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                [
                    "(?:3[12]\\d|666)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]",
            [
                [
                    "2(?:[0-57-9]\\d|6[4-9])\\d\\d"
                ],
                [
                    "[56]\\d{4}",
                    [
                        5
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "262\\d\\d",
                    [
                        5
                    ]
                ]
            ]
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:[1-357][2-8]|4[24-8])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "80\\d{4,6}",
                    [
                        6,
                        7,
                        8
                    ]
                ],
                [
                    "89[1-3]\\d{2,5}|90\\d{4,6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79",
            [
                [
                    "79\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "(?:4[015-8]|59|9\\d)\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "80[01]\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "82[09]\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "880\\d{5}",
                    [
                        8
                    ]
                ],
                0,
                [
                    "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"
                ],
                0,
                [
                    "85[0-5]\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"
                ],
                [
                    "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "800\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "9(?:00|[78]\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "96\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "9090\\d{3}",
                    [
                        7
                    ]
                ],
                [
                    "6(?:02|5[0-4]|9[0-6])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "8[5-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "22[2-4][2-9]\\d{4}"
                ],
                [
                    "(?:25|3[0-5]|66|7[3-9]|8[08]|9[09])\\d{6}"
                ]
            ]
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1",
            0,
            0,
            [
                [
                    "0549(?:8[0157-9]|9\\d)\\d{4}",
                    [
                        10
                    ]
                ],
                [
                    "6[16]\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                [
                    "7[178]\\d{6}",
                    [
                        8
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "5[158]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"
                ],
                [
                    "75(?:01|[38]3)\\d{5}|7(?:[06-8]\\d|21|5[4-7]|90)\\d{6}"
                ],
                [
                    "800\\d{6}"
                ],
                [
                    "88[4689]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"
                ],
                [
                    "81[02468]\\d{6}"
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "24|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3478]|64|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                    [
                        6,
                        7
                    ]
                ],
                [
                    "(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:6\\d|7[1-9])\\d{6}",
                    [
                        7,
                        8,
                        9
                    ]
                ]
            ]
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"
                ],
                [
                    "(?:7[124-7]|8[124-9])\\d{5}",
                    [
                        7
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "56\\d{4}",
                    [
                        6
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "1[89]\\d{7}"
                ],
                [
                    "(?:12|9[1257-9])\\d{7}"
                ]
            ]
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "22\\d{5}"
                ],
                [
                    "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}",
                    [
                        8
                    ]
                ],
                [
                    "66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "800\\d{4}(?:\\d{4})?",
                    [
                        7,
                        11
                    ]
                ],
                [
                    "900\\d{4}(?:\\d{4})?",
                    [
                        7,
                        11
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|(5\\d{6})$",
            "721$1",
            0,
            "721",
            [
                [
                    "7215(?:4[2-8]|8[239]|9[056])\\d{4}"
                ],
                [
                    "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"
                ],
                [
                    "9(?:22|[3-689]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "[23][2-5]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "7[6-9]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "0800\\d{4}",
                    [
                        8
                    ]
                ],
                [
                    "900\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "70\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8",
            [
                [
                    "8\\d{3}"
                ]
            ]
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-479]\\d{6})$",
            "649$1",
            0,
            "649",
            [
                [
                    "649(?:266|712|9(?:4\\d|50))\\d{4}"
                ],
                [
                    "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "649(?:71[01]|966)\\d{4}"
                ]
            ]
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "22(?:[37-9]0|5[0-5]|6[89])\\d{4}"
                ],
                [
                    "(?:6[023568]|77|9\\d)\\d{6}"
                ]
            ],
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"
                ],
                [
                    "(?:7[09]|9[0-36-9])\\d{6}"
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "671[0-3]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "1800\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "1900\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "6[08]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "TJ": [
            "992",
            "810",
            "(?:00|11|[2-57-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[34]7|91[78]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02-57-9]|11"
                    ],
                    0,
                    1
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"
                ],
                [
                    "41[18]\\d{6}|(?:[034]0|11|2[02]|5[05]|7[07]|8[08]|9\\d)\\d{7}"
                ]
            ],
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[2-4]|[34]\\d)\\d{2,5}"
                ],
                [
                    "7[2-4]\\d{2,5}"
                ]
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "7[2-8]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "80\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "90\\d{5}",
                    [
                        7
                    ]
                ],
                [
                    "70\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"
                ],
                [
                    "6\\d{7}"
                ]
            ],
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"
                ],
                [
                    "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"
                ],
                [
                    "8010\\d{4}"
                ],
                [
                    "88\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "8[12]10\\d{4}"
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                    [
                        5
                    ]
                ],
                [
                    "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "0800\\d{3}",
                    [
                        7
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "55[0-37-9]\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|616)",
                        "5(?:[0-59]|6161)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
                    [
                        10,
                        12,
                        13
                    ]
                ],
                [
                    "(?:8[89]8|900)\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "592(?:21[12]|461)\\d{4}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "444\\d{4}",
                    [
                        7
                    ]
                ],
                [
                    "512\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "850\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-46-8]\\d{6})$",
            "868$1",
            0,
            "868",
            [
                [
                    "868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"
                ],
                [
                    "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2[02-9]\\d{3}",
                    [
                        5
                    ]
                ],
                [
                    "(?:7[01]\\d|90)\\d{4}",
                    [
                        6,
                        7
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "80[0-79]\\d{6}|800\\d{5}",
                    [
                        8,
                        9
                    ]
                ],
                [
                    "20(?:[013-9]\\d\\d|2)\\d{4}",
                    [
                        7,
                        9
                    ]
                ],
                [
                    "99\\d{7}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "50[0-46-9]\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                [
                    "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
                    [
                        10,
                        11
                    ]
                ]
            ],
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[26-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2[2-8]\\d{7}"
                ],
                [
                    "77[2-9]\\d{6}|(?:6[1-9]|7[1-689])\\d{7}"
                ],
                [
                    "80[08]\\d{6}"
                ],
                [
                    "90\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "41\\d{7}"
                ],
                [
                    "8(?:40|6[01])\\d{6}"
                ]
            ]
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
                        "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "800[1-8]\\d{5,6}"
                ],
                [
                    "900[239]\\d{5,6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "89[1-579]\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[0147]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"
                ],
                [
                    "7260\\d{5}|7(?:[0157-9]\\d|20|36|[46][0-4])\\d{6}"
                ],
                [
                    "800[1-3]\\d{5}"
                ],
                [
                    "90[1-3]\\d{6}"
                ]
            ]
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-2]|[28]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "405|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[24]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2\\d|4[2-7])\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "9[1-9]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "(?:4\\d{5}|80[05])\\d{4}|405\\d{4}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "90[0-8]\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:33|55|[679]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[35-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}"
                ],
                [
                    "(?:(?:33|88|9[0-57-9])\\d{3}|55(?:50[13]|90\\d)|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"
                ]
            ],
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698",
            [
                [
                    "06698\\d{1,6}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "784$1",
            0,
            "784",
            [
                [
                    "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"
                ],
                [
                    "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"
                ],
                [
                    "4(?:1[24-8]|2[46])\\d{7}"
                ],
                [
                    "800\\d{7}"
                ],
                [
                    "90[01]\\d{7}"
                ],
                0,
                0,
                [
                    "501\\d{7}"
                ]
            ]
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-578]\\d{6})$",
            "284$1",
            0,
            "284",
            [
                [
                    "284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"
                ],
                [
                    "284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}"
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "340$1",
            0,
            "340",
            [
                [
                    "340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[69]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                    [
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1900\\d{4,6}",
                    [
                        8,
                        9,
                        10
                    ]
                ],
                0,
                0,
                [
                    "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                    [
                        7,
                        8
                    ]
                ],
                0,
                [
                    "672\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
                    [
                        5
                    ]
                ],
                [
                    "(?:[58]\\d|7[013-7])\\d{5}",
                    [
                        7
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:3[03]|900\\d)\\d{3}"
                ],
                0,
                [
                    "9(?:0[1-9]|1[01])\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "72\\d{4}",
                    [
                        6
                    ]
                ],
                [
                    "(?:72|8[23])\\d{4}",
                    [
                        6
                    ]
                ],
                [
                    "80[0-5]\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
                    [
                        5,
                        6
                    ]
                ],
                [
                    "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "800\\d{3}",
                    [
                        6
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}"
                ],
                [
                    "4[3-9]\\d{6}",
                    [
                        8
                    ]
                ],
                [
                    "800\\d{5}",
                    [
                        8
                    ]
                ],
                [
                    "900\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7[24-68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
                    [
                        7,
                        8
                    ]
                ],
                [
                    "7[0137]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "YT": [
            "262",
            "00",
            "80\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "269|63",
            [
                [
                    "269(?:0[67]|5[0-3]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "80\\d{7}",
                    [
                        9
                    ]
                ],
                [
                    "(?:86[2-9]|9[0-2]\\d)\\d{6}",
                    [
                        9
                    ]
                ],
                0,
                0,
                [
                    "861\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                [
                    "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
                    [
                        9
                    ]
                ],
                [
                    "860\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "ZM": [
            "260",
            "00",
            "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "21[1-8]\\d{6}"
                ],
                [
                    "(?:7[679]|9[5-8])\\d{7}"
                ],
                [
                    "800\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "630\\d{6}"
                ]
            ]
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"
                ],
                [
                    "7(?:[178]\\d|3[1-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "80(?:[01]\\d|20|8[0-8])\\d{3}",
                    [
                        7
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:005|[1-9]\\d\\d)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:005|[1-9]\\d\\d)\\d{5}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "[0-36-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-36-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "4"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-3]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "210\\d{7}|51\\d{7}(?:\\d{3})?",
            [
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:210|51[013]0\\d)\\d{7}|5100\\d{5}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});



parcelRegister("kP5ln", function(module, exports) {

$parcel$export(module.exports, "RegisterPrivacyPolicy", function () { return $ec11ee188ba4dfa2$export$72cb4d8a2e1015fd; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bewhU = parcelRequire("bewhU");

var $ajNEj = parcelRequire("ajNEj");

var $ZE1cB = parcelRequire("ZE1cB");

var $22v9q = parcelRequire("22v9q");

var $kSLZ3 = parcelRequire("kSLZ3");
const $ec11ee188ba4dfa2$export$72cb4d8a2e1015fd = ({ showTitle: showTitle = true, url: url, hasEula: hasEula, isTermAccepted: isTermAccepted, onTermChange: onTermChange })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($ec11ee188ba4dfa2$var$Container, {
        children: [
            showTitle && /*#__PURE__*/ (0, $4m918.jsx)($ec11ee188ba4dfa2$var$Title, {
                children: formatMessage(hasEula ? "registerScreen.privacyTitle" : "registerScreen.noPrivacyTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($ec11ee188ba4dfa2$var$LinkWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($ec11ee188ba4dfa2$var$MainDescriptionText, {
                        children: formatMessage(hasEula ? "registerScreen.privacyFirstDescription" : "registerScreen.noPrivacyFirstDescription")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($ec11ee188ba4dfa2$var$DescriptionText, {
                        children: [
                            formatMessage(hasEula ? "registerScreen.privacySecondDescription" : "registerScreen.noPrivacySecondDescription"),
                            hasEula && /*#__PURE__*/ (0, $4m918.jsx)($ec11ee188ba4dfa2$var$TermOfUseLink, {
                                target: "_blank",
                                href: url,
                                children: formatMessage("registerScreen.privacyLink")
                            })
                        ]
                    })
                ]
            }),
            hasEula && /*#__PURE__*/ (0, $4m918.jsx)($ec11ee188ba4dfa2$var$StyledSwitchButton, {
                getSwitchLabel: ()=>formatMessage("registerScreen.privacyAcceptLabel"),
                value: isTermAccepted,
                onSwitch: onTermChange
            })
        ]
    });
};
const $ec11ee188ba4dfa2$export$18a9113bd0f012c8 = ({ onSubmit: onSubmit, onBackward: onBackward, errorMessage: errorMessage, loading: loading, url: url, hasEula: hasEula })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [isTermAccepted, setIsTermAccepted] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $kSLZ3.FormWithButtons), {
        onSubmit: onSubmit,
        errorMessage: errorMessage,
        onBackward: onBackward,
        loading: loading,
        disableSubmitButton: hasEula ? !isTermAccepted : false,
        submitWording: formatMessage("registerScreen.createMyAccountButton"),
        children: /*#__PURE__*/ (0, $4m918.jsx)($ec11ee188ba4dfa2$export$72cb4d8a2e1015fd, {
            hasEula: hasEula,
            url: url,
            isTermAccepted: isTermAccepted,
            onTermChange: setIsTermAccepted
        })
    });
};
const $ec11ee188ba4dfa2$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 500px;
`;
const $ec11ee188ba4dfa2$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.875rem;
  margin-bottom: 20px;
`;
const $ec11ee188ba4dfa2$var$LinkWrapper = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const $ec11ee188ba4dfa2$var$StyledSwitchButton = (0, $jb8NR.default)((0, $ajNEj.SwitchContainer))`
  margin-bottom: 30px;
  max-width: 400px;
`;
const $ec11ee188ba4dfa2$var$DescriptionText = (0, $jb8NR.default).div`
  font-size: 0.8rem;
  margin-bottom: 20px;
  color: ${(0, $22v9q.theme).colors.gray[700]};
`;
const $ec11ee188ba4dfa2$var$MainDescriptionText = (0, $jb8NR.default)($ec11ee188ba4dfa2$var$DescriptionText)`
  font-weight: bold;
  color: black;
`;
const $ec11ee188ba4dfa2$var$TermOfUseLink = (0, $jb8NR.default)((0, $bewhU.DefaultExternalLink))`
  color: ${(0, $22v9q.theme).mainColor};
  text-decoration: underline;
  display: inline;
  margin-left: 5px;
  text-transform: lowercase;
`;

});

parcelRegister("jxTls", function(module, exports) {

$parcel$export(module.exports, "RegisterTermOfServiceWidget", function () { return $ebe67a59d587a4a4$export$8533534bd8342bee; });
$parcel$export(module.exports, "RegisterTermOfServiceStep", function () { return $ebe67a59d587a4a4$export$18a9113bd0f012c8; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bewhU = parcelRequire("bewhU");

var $ajNEj = parcelRequire("ajNEj");

var $ZE1cB = parcelRequire("ZE1cB");

var $22v9q = parcelRequire("22v9q");

var $kSLZ3 = parcelRequire("kSLZ3");
const $ebe67a59d587a4a4$export$8533534bd8342bee = ({ showTitle: showTitle = true, url: url, hasEula: hasEula, isTermAccepted: isTermAccepted, onTermChange: onTermChange })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($ebe67a59d587a4a4$var$Container, {
        children: [
            showTitle && /*#__PURE__*/ (0, $4m918.jsx)($ebe67a59d587a4a4$var$Title, {
                children: formatMessage(hasEula ? "registerScreen.eulaTitle" : "registerScreen.noEulaTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($ebe67a59d587a4a4$var$LinkWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($ebe67a59d587a4a4$var$MainDescriptionText, {
                        children: formatMessage(hasEula ? "registerScreen.eulaFirstDescription" : "registerScreen.noEulaFirstDescription")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($ebe67a59d587a4a4$var$DescriptionText, {
                        children: [
                            formatMessage(hasEula ? "registerScreen.eulaSecondDescription" : "registerScreen.noEulaSecondDescription"),
                            hasEula && /*#__PURE__*/ (0, $4m918.jsx)($ebe67a59d587a4a4$var$TermOfUseLink, {
                                target: "_blank",
                                href: url,
                                children: formatMessage("registerScreen.eulaLink")
                            })
                        ]
                    })
                ]
            }),
            hasEula && /*#__PURE__*/ (0, $4m918.jsx)($ebe67a59d587a4a4$var$StyledSwitchButton, {
                getSwitchLabel: ()=>formatMessage("registerScreen.eulaAcceptLabel"),
                value: isTermAccepted,
                onSwitch: onTermChange
            })
        ]
    });
};
const $ebe67a59d587a4a4$export$18a9113bd0f012c8 = ({ onSubmit: onSubmit, onBackward: onBackward, errorMessage: errorMessage, loading: loading, url: url, hasEula: hasEula })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [isTermAccepted, setIsTermAccepted] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $kSLZ3.FormWithButtons), {
        onSubmit: onSubmit,
        errorMessage: errorMessage,
        onBackward: onBackward,
        loading: loading,
        disableSubmitButton: hasEula ? !isTermAccepted : false,
        submitWording: formatMessage("registerScreen.createMyAccountButton"),
        children: /*#__PURE__*/ (0, $4m918.jsx)($ebe67a59d587a4a4$export$8533534bd8342bee, {
            hasEula: hasEula,
            url: url,
            isTermAccepted: isTermAccepted,
            onTermChange: setIsTermAccepted
        })
    });
};
const $ebe67a59d587a4a4$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 500px;
`;
const $ebe67a59d587a4a4$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.875rem;
  margin-bottom: 20px;
`;
const $ebe67a59d587a4a4$var$LinkWrapper = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const $ebe67a59d587a4a4$var$StyledSwitchButton = (0, $jb8NR.default)((0, $ajNEj.SwitchContainer))`
  margin-bottom: 30px;
  max-width: 400px;
`;
const $ebe67a59d587a4a4$var$DescriptionText = (0, $jb8NR.default).div`
  font-size: 0.8rem;
  margin-bottom: 20px;
  color: ${(0, $22v9q.theme).colors.gray[700]};
`;
const $ebe67a59d587a4a4$var$MainDescriptionText = (0, $jb8NR.default)($ebe67a59d587a4a4$var$DescriptionText)`
  font-weight: bold;
  color: black;
`;
const $ebe67a59d587a4a4$var$TermOfUseLink = (0, $jb8NR.default)((0, $bewhU.DefaultExternalLink))`
  color: ${(0, $22v9q.theme).mainColor};
  text-decoration: underline;
  display: inline;
  margin-left: 5px;
  text-transform: lowercase;
`;

});


parcelRegister("02KgJ", function(module, exports) {

$parcel$export(module.exports, "OnboardingInitialFormSuccess", function () { return $d8d9900b634d5b7e$export$1ad39198b5d09436; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $e4wja = parcelRequire("e4wja");

var $d0DGo = parcelRequire("d0DGo");

var $7Zu6k = parcelRequire("7Zu6k");

var $ZE1cB = parcelRequire("ZE1cB");

var $22v9q = parcelRequire("22v9q");
const $d8d9900b634d5b7e$export$1ad39198b5d09436 = (props)=>{
    const { phoneNumber: phoneNumber } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const formattedPhoneNumber = (0, $e4wja.formatPhoneNumberBasedOnCountryCode)(phoneNumber?.nationalNumber, phoneNumber?.country);
    return /*#__PURE__*/ (0, $4m918.jsxs)($d8d9900b634d5b7e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($d8d9900b634d5b7e$var$SuccessLogoImage, {
                src: (0, $d0DGo.circleSuccessIcon),
                alt: ""
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($d8d9900b634d5b7e$var$Title, {
                children: formatMessage("onboardingScreen.successIntroduction")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($d8d9900b634d5b7e$var$Subtitle, {
                children: formatMessage("onboardingScreen.initiationSuccessTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($d8d9900b634d5b7e$var$Description, {
                children: formatMessage("onboardingScreen.initiationSuccessMsg", {
                    phone: formattedPhoneNumber
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                size: "S",
                onClick: ()=>(0, $kqXxS.authExecutor).connect(phoneNumber),
                children: formatMessage("onboardingScreen.getStartedButton")
            })
        ]
    });
};
const $d8d9900b634d5b7e$var$SuccessLogoImage = (0, $jb8NR.default).img`
  align-self: center;
  width: 200px;
  height: 200px;
`;
const $d8d9900b634d5b7e$var$Container = (0, $jb8NR.default).div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
`;
const $d8d9900b634d5b7e$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 2.5rem;
  line-height: 2.875rem;
  margin-bottom: 10px;
`;
const $d8d9900b634d5b7e$var$Subtitle = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  color: ${(0, $22v9q.theme).colors.gray[700]};
  line-height: 1.875rem;
  align-self: flex-start;
`;
const $d8d9900b634d5b7e$var$Description = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  color: ${(0, $22v9q.theme).colors.gray[700]};
  line-height: 1.875rem;
  align-self: flex-start;
  margin-bottom: 24px;
`;

});


parcelRegister("fHt3E", function(module, exports) {

$parcel$export(module.exports, "RegisterScreen", function () { return $65e2dd7ddabe7ccd$export$bb617a8b14cea279; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $k4Ecv = parcelRequire("k4Ecv");

var $4fYE4 = parcelRequire("4fYE4");

var $6Hqg0 = parcelRequire("6Hqg0");

var $bewhU = parcelRequire("bewhU");

var $596Xf = parcelRequire("596Xf");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $hlKpB = parcelRequire("hlKpB");

var $2CQIp = parcelRequire("2CQIp");

var $8UUD6 = parcelRequire("8UUD6");

var $4iy8M = parcelRequire("4iy8M");

var $9usPr = parcelRequire("9usPr");

var $iacpk = parcelRequire("iacpk");

var $jxTls = parcelRequire("jxTls");
const $65e2dd7ddabe7ccd$var$usePendingEnrollment = ()=>{
    const [pendingEnrollment, setPendingEnrollment] = (0, $6uYXW.useState)(null);
    const phoneNumber = (0, $kqXxS.registerManager).parsedPhoneNumber.get();
    (0, $k4Ecv.useAsyncFunction)(async ()=>{
        const pendingEnrollment = await (0, $kqXxS.registerManager).loadPendingEnrollment();
        setPendingEnrollment(pendingEnrollment);
    }, []);
    return {
        phoneNumber: phoneNumber || pendingEnrollment?.phoneNumber
    };
};
const $65e2dd7ddabe7ccd$var$centeredStates = [
    (0, $6Hqg0.RegisterState).ValidateForm,
    (0, $6Hqg0.RegisterState).ConfirmRegister,
    (0, $6Hqg0.RegisterState).ConfirmRegisterAfterUbble,
    (0, $6Hqg0.RegisterState).OTPSubmission,
    (0, $6Hqg0.RegisterState).OTPConfirming,
    (0, $6Hqg0.RegisterState).PromptForPincodeChoice,
    (0, $6Hqg0.RegisterState).FetchingPincodeKeyboard,
    (0, $6Hqg0.RegisterState).PromptingPincodeKeyboard,
    (0, $6Hqg0.RegisterState).PincodePromptNotMatch,
    (0, $6Hqg0.RegisterState).PromptingConfirmPincodeKeyboard
];
const $65e2dd7ddabe7ccd$export$bb617a8b14cea279 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { pathname: pathname } = (0, $NQIVp.useLocation)();
    const history = (0, $NQIVp.useHistory)();
    const { phoneNumber: phoneNumber } = $65e2dd7ddabe7ccd$var$usePendingEnrollment();
    const [formPhoneNumber, setFormPhoneNumber] = (0, $6uYXW.useState)(undefined);
    const { state: state, context: context, keyboard: keyboard, start: start, moveForward: moveForward, moveBackward: moveBackward, eulaUri: eulaUri, step: step, stepIndex: stepIndex, stepCount: stepCount, fillResponse: fillResponse, fillMultiImages: fillMultiImages, error: error, complete: complete, submitPincode: submitPincode, confirmPincode: confirmPincode, completeTermOfService: completeTermOfService, confirmOtp: confirmOtp } = (0, $6Hqg0.useRegisterMachine)(pathname.includes((0, $4fYE4.Path).UbbleRedirect) ? (0, $6Hqg0.RegisterState).ConfirmRegisterAfterUbble : (0, $6Hqg0.RegisterState).WaitingForPhoneNumber);
    const { redirectIfAllowed: redirectIfAllowed } = (0, $596Xf.useQuitBlocking)(state !== (0, $6Hqg0.RegisterState).WaitingForPhoneNumber && state !== (0, $6Hqg0.RegisterState).OTPConfirming && state !== (0, $6Hqg0.RegisterState).RegistrationCompleted && state !== (0, $6Hqg0.RegisterState).ValidateForm, formatMessage("registerScreen.quitConfirmMessage"));
    const renderProgressBar = (label)=>/*#__PURE__*/ (0, $4m918.jsx)($65e2dd7ddabe7ccd$var$ProgressBarWrapper, {
            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $2CQIp.default), {
                step: stepIndex,
                stepCount: stepCount || undefined,
                label: label
            })
        });
    const connect = ()=>{
        if ((0, $kqXxS.authExecutor).withPhoneNumberAndPinCode()) {
            const path = (0, $4fYE4.Path).Connect;
            history.push(path);
        } else (0, $kqXxS.authExecutor).connect();
    };
    const renderRegisterMachine = ()=>{
        switch(state){
            case (0, $6Hqg0.RegisterState).StartRegistration:
            case (0, $6Hqg0.RegisterState).WaitingForPhoneNumber:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $9usPr.default), {
                            onSubmit: (phoneNumber)=>{
                                setFormPhoneNumber(phoneNumber);
                                start(phoneNumber);
                            },
                            loading: state === (0, $6Hqg0.RegisterState).StartRegistration,
                            errorMessage: context.error,
                            initialPhoneNumber: formPhoneNumber
                        }),
                        /*#__PURE__*/ (0, $4m918.jsxs)($65e2dd7ddabe7ccd$var$BottomContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($65e2dd7ddabe7ccd$var$ConnectQuestion, {
                                    children: formatMessage("registerScreen.connectQuestion")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($65e2dd7ddabe7ccd$var$ConnectButton, {
                                    onClick: connect,
                                    children: formatMessage("registerScreen.connectButton")
                                })
                            ]
                        })
                    ]
                });
            case (0, $6Hqg0.RegisterState).Completing:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        renderProgressBar(step ? step.label : formatMessage("registerScreen.pincodeStepTitle")),
                        step && /*#__PURE__*/ (0, $4m918.jsx)((0, $8UUD6.default), {
                            onInputValueChange: fillResponse,
                            onInputMultiImagesChange: fillMultiImages,
                            step: step,
                            onSubmit: moveForward,
                            onBackward: moveBackward,
                            errorMessage: error
                        })
                    ]
                });
            case (0, $6Hqg0.RegisterState).PromptForPincodeChoice:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $iacpk.RegisterPincodeStep), {
                    onSubmit: complete,
                    onBackward: moveBackward,
                    errorMessage: error
                });
            case (0, $6Hqg0.RegisterState).FetchingPincodeKeyboard:
            case (0, $6Hqg0.RegisterState).PromptingPincodeKeyboard:
            case (0, $6Hqg0.RegisterState).PincodePromptNotMatch:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        renderProgressBar(formatMessage("registerScreen.pincodeStepTitle")),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $iacpk.RegisterNewPincodeStep), {
                            keyboard: keyboard,
                            onSubmit: submitPincode,
                            onBackward: moveBackward,
                            errorMessage: state === (0, $6Hqg0.RegisterState).PincodePromptNotMatch ? formatMessage("registerScreen.newCodesDontMatchError") : undefined
                        })
                    ]
                });
            case (0, $6Hqg0.RegisterState).PromptingConfirmPincodeKeyboard:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        renderProgressBar(formatMessage("registerScreen.pincodeStepTitle")),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $iacpk.RegisterConfirmPincodeStep), {
                            keyboard: keyboard,
                            onSubmit: confirmPincode,
                            onBackward: moveBackward
                        })
                    ]
                });
            case (0, $6Hqg0.RegisterState).ValidateForm:
            case (0, $6Hqg0.RegisterState).ConfirmRegister:
            case (0, $6Hqg0.RegisterState).ReadingTermOfService:
                return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                    children: [
                        renderProgressBar(formatMessage(eulaUri ? "registerScreen.eulaTitle" : "registerScreen.noEulaTitle")),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $jxTls.RegisterTermOfServiceStep), {
                            onSubmit: completeTermOfService,
                            onBackward: moveBackward,
                            url: eulaUri ?? "https://tagpay.fr/conditionsgeneralesdutilisation",
                            loading: state === (0, $6Hqg0.RegisterState).ConfirmRegister || state === (0, $6Hqg0.RegisterState).ValidateForm,
                            errorMessage: error,
                            hasEula: !!eulaUri
                        })
                    ]
                });
            case (0, $6Hqg0.RegisterState).ConfirmRegisterAfterUbble:
            case (0, $6Hqg0.RegisterState).OTPSubmission:
            case (0, $6Hqg0.RegisterState).OTPConfirming:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $4iy8M.RegisterOtpStep), {
                    onSubmit: confirmOtp,
                    phoneNumber: phoneNumber,
                    loading: state === (0, $6Hqg0.RegisterState).ConfirmRegisterAfterUbble,
                    errorMessage: error
                });
            case (0, $6Hqg0.RegisterState).RegistrationCompleted:
                console.log(`RegisterState.RegistrationCompleted then redirectTo${(0, $4fYE4.Path).Root}?phone=${phoneNumber?.nationalNumber}`);
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
                    to: `${(0, $4fYE4.Path).Root}?phone=${phoneNumber?.nationalNumber}`
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $hlKpB.default), {
        centered: $65e2dd7ddabe7ccd$var$centeredStates.includes(state),
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($65e2dd7ddabe7ccd$var$Logo, {
                src: (0, $fRvTz.StaticAssets).logo,
                onClick: ()=>redirectIfAllowed((0, $4fYE4.Path).Root)
            }),
            renderRegisterMachine()
        ]
    });
};
const $65e2dd7ddabe7ccd$var$Logo = (0, $jb8NR.default).img`
  width: 112px;
  height: 112px;
  object-fit: contain;
  margin-top: 0;
  margin-bottom: 8px;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
const $65e2dd7ddabe7ccd$var$ProgressBarWrapper = (0, $jb8NR.default).div`
  margin: 30px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: stretch;
    margin: 0;
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;
const $65e2dd7ddabe7ccd$var$BottomContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  white-space: pre;
  align-items: baseline;
`;
const $65e2dd7ddabe7ccd$var$ConnectQuestion = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.9375rem;
  color: black;
`;
const $65e2dd7ddabe7ccd$var$ConnectButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  ${(0, $22v9q.theme).boldText}
  font-size: 0.9375rem;
  color: ${(0, $22v9q.theme).mainColor};
`;

});
parcelRegister("6Hqg0", function(module, exports) {

$parcel$export(module.exports, "useRegisterMachine", function () { return $b000adde8fc000b6$export$dd4ceffd4ef65367; });
$parcel$export(module.exports, "RegisterState", function () { return $b000adde8fc000b6$export$8ef8a99c0cf7dcb6; });

var $lCuQx = parcelRequire("lCuQx");

var $6uYXW = parcelRequire("6uYXW");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");

var $19AHh = parcelRequire("19AHh");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $40sjz = parcelRequire("40sjz");
const $b000adde8fc000b6$export$dd4ceffd4ef65367 = (initialState = "WAITING_FOR_PHONE_NUMBER")=>{
    const registerMachine = (0, $6uYXW.useMemo)(()=>$b000adde8fc000b6$var$registerMachineBuilder(initialState), [
        initialState
    ]);
    const [machine, sendEvent] = (0, $lCuQx.useMachine)(registerMachine);
    const { value: state, context: context } = machine;
    const extraFormInput = (0, $3Ersk.useObservable)((0, $kqXxS.registerManager).extraFormInput);
    const formStepsAsArray = (0, $3Ersk.useObservable)((0, $kqXxS.registerManager).formStepsAsArray);
    const confirmError = (0, $3Ersk.useObservable)((0, $kqXxS.registerManager).confirmError);
    const [stepIndex, setStepIndex] = (0, $6uYXW.useState)(-1);
    const stepCount = formStepsAsArray.length + (extraFormInput.pincodeFormInput !== null ? 1 : 0);
    const step = formStepsAsArray.length > stepIndex ? formStepsAsArray[stepIndex] : null;
    const complete = ()=>{
        sendEvent("COMPLETE", {
            extraFormInput: extraFormInput
        });
    };
    const moveForward = (0, $6uYXW.useCallback)(()=>setStepIndex((index)=>index + 1), []);
    const moveBackward = ()=>{
        if (!(state === "COMPLETING" && stepIndex !== 0)) sendEvent({
            type: "GO_BACK"
        });
        setStepIndex((index)=>index - 1);
    };
    const start = (newPhoneNumber)=>{
        sendEvent("CHECK_PHONE_NUMBER", {
            phoneNumber: newPhoneNumber
        });
        setStepIndex(0);
    };
    const completeTermOfService = ()=>{
        sendEvent("COMPLETE_TERM_OF_SERVICE");
    };
    const submitPincode = (pincode)=>{
        sendEvent({
            type: "SUBMIT_PINCODE",
            pincode: pincode
        });
    };
    const confirmPincode = (pincode)=>{
        sendEvent({
            type: "CONFIRM_PINCODE",
            pincode: pincode
        });
    };
    const confirmOtp = (otp)=>{
        sendEvent("OTP_CONFIRM", {
            otp: otp
        });
    };
    if (state === "COMPLETING" && !step) complete();
    return {
        state: state,
        context: context,
        eulaUri: context.termOfServiceUri,
        start: start,
        keyboard: context.keyboard,
        moveForward: moveForward,
        moveBackward: moveBackward,
        step: step,
        stepIndex: stepIndex,
        stepCount: stepCount,
        fillResponse: (input, value, fileProps)=>(0, $kqXxS.registerManager).fillResponse(input, value, fileProps),
        fillMultiImages: (input, values)=>(0, $kqXxS.registerManager).fillMultiImagesResponse(input, values),
        error: confirmError || context.error,
        complete: complete,
        submitPincode: submitPincode,
        confirmPincode: confirmPincode,
        completeTermOfService: completeTermOfService,
        confirmOtp: confirmOtp
    };
};
var $b000adde8fc000b6$export$8ef8a99c0cf7dcb6 = /*#__PURE__*/ function(RegisterState) {
    RegisterState["WaitingForPhoneNumber"] = "WAITING_FOR_PHONE_NUMBER";
    RegisterState["StartRegistration"] = "START_REGISTRATION";
    RegisterState["ValidateForm"] = "VALIDATE_FORM";
    RegisterState["Completing"] = "COMPLETING";
    RegisterState["PromptForPincodeChoice"] = "PROMPT_PINCODE_CHOICE_DISCLAIMER";
    RegisterState["FetchingPincodeKeyboard"] = "FETCHING_PINCODE_KEYBOARD";
    RegisterState["PromptingPincodeKeyboard"] = "PROMPTING_PINCODE_KEYBOARD";
    RegisterState["PromptingConfirmPincodeKeyboard"] = "PROMPTING_CONFIRM_PINECODE_KEYBOARD";
    RegisterState["PincodePromptNotMatch"] = "PINCODE_PROMPT_NOT_MATCH";
    RegisterState["ReadingTermOfService"] = "READING_TERM_OF_SERVICE";
    RegisterState["ConfirmRegister"] = "CONFIRM_REGISTER";
    RegisterState["ConfirmRegisterAfterUbble"] = "CONFIRM_REGISTER_AFTER_UBBLE";
    RegisterState["OTPSubmission"] = "OTP_SUBMISSION";
    RegisterState["OTPConfirming"] = "OTP_CONFIRMING";
    RegisterState["RegistrationCompleted"] = "REGISTRATION_COMPLETED";
    RegisterState["UbbleConfirmationRedirection"] = "UBBLE_CONFIRMATION_REDIRECTION";
    return RegisterState;
}({});
const $b000adde8fc000b6$var$registerMachineBuilder = (initialState)=>(0, $TAle5.Machine)({
        id: "register",
        initial: initialState,
        states: {
            ["WAITING_FOR_PHONE_NUMBER"]: {
                on: {
                    CHECK_PHONE_NUMBER: {
                        target: "START_REGISTRATION",
                        actions: (0, $c8ePo.assign)({
                            phoneNumber: (_, event)=>event.phoneNumber
                        })
                    }
                }
            },
            ["START_REGISTRATION"]: {
                invoke: {
                    id: "startRegistration",
                    src: (ctx)=>(0, $kqXxS.registerManager).start(ctx.phoneNumber),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_)=>undefined
                            }),
                            (0, $c8ePo.send)({
                                type: "START_COMPLETING"
                            })
                        ]
                    },
                    onError: {
                        target: "WAITING_FOR_PHONE_NUMBER",
                        actions: (0, $c8ePo.assign)({
                            error: (_, event)=>event?.data
                        })
                    }
                },
                on: {
                    START_COMPLETING: "COMPLETING"
                }
            },
            ["COMPLETING"]: {
                on: {
                    COMPLETE: {
                        actions: [
                            (0, $c8ePo.assign)({
                                extraFormInput: (_, event)=>event.extraFormInput,
                                pincodeRequired: (_, event)=>!!event?.extraFormInput?.pincodeFormInput,
                                termOfServiceUri: (_)=>(0, $kqXxS.configurationManager).configuration.get().termsAndConditionsUrl ?? null
                            }),
                            (0, $c8ePo.send)((ctx)=>ctx?.pincodeRequired ? {
                                    type: "PINCODE_REQUIRED"
                                } : ctx?.termOfServiceUri ? {
                                    type: "TERM_OF_SERVICE_REQUIRED"
                                } : {
                                    type: "TERM_OF_SERVICE_NOT_REQUIRED"
                                })
                        ]
                    },
                    GO_BACK: "WAITING_FOR_PHONE_NUMBER",
                    PINCODE_REQUIRED: "PROMPT_PINCODE_CHOICE_DISCLAIMER",
                    TERM_OF_SERVICE_REQUIRED: "READING_TERM_OF_SERVICE",
                    TERM_OF_SERVICE_NOT_REQUIRED: "READING_TERM_OF_SERVICE"
                }
            },
            ["PROMPT_PINCODE_CHOICE_DISCLAIMER"]: {
                on: {
                    COMPLETE: "FETCHING_PINCODE_KEYBOARD",
                    GO_BACK: "COMPLETING"
                }
            },
            ["FETCHING_PINCODE_KEYBOARD"]: {
                invoke: {
                    id: "fetchKeyboard",
                    src: (ctx)=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), ctx.phoneNumber?.number?.substring(1), (0, $40sjz.FONT_SIZE)),
                    onDone: {
                        target: "PROMPTING_PINCODE_KEYBOARD",
                        actions: (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        })
                    }
                }
            },
            ["PROMPTING_PINCODE_KEYBOARD"]: {
                on: {
                    SUBMIT_PINCODE: {
                        target: "PROMPTING_CONFIRM_PINECODE_KEYBOARD",
                        actions: (0, $c8ePo.assign)({
                            code: (_, event)=>event.pincode
                        })
                    },
                    GO_BACK: "COMPLETING"
                }
            },
            ["PROMPTING_CONFIRM_PINECODE_KEYBOARD"]: {
                on: {
                    CONFIRM_PINCODE: {
                        actions: (0, $c8ePo.send)((ctx, event)=>{
                            if (event.pincode.value.join() === ctx.code?.value.join()) {
                                (0, $kqXxS.registerManager).fillPincode(event.pincode);
                                return ctx?.termOfServiceUri ? {
                                    type: "TERM_OF_SERVICE_REQUIRED"
                                } : {
                                    type: "TERM_OF_SERVICE_NOT_REQUIRED"
                                };
                            }
                            return {
                                type: "PINCODE_DONT_MATCH"
                            };
                        })
                    },
                    PINCODE_DONT_MATCH: "PINCODE_PROMPT_NOT_MATCH",
                    TERM_OF_SERVICE_REQUIRED: "READING_TERM_OF_SERVICE",
                    TERM_OF_SERVICE_NOT_REQUIRED: "VALIDATE_FORM",
                    GO_BACK: "FETCHING_PINCODE_KEYBOARD"
                }
            },
            ["PINCODE_PROMPT_NOT_MATCH"]: {
                on: {
                    SUBMIT_PINCODE: {
                        target: "PROMPTING_CONFIRM_PINECODE_KEYBOARD",
                        actions: (0, $c8ePo.assign)({
                            code: (_, event)=>event.pincode
                        })
                    },
                    GO_BACK: "FETCHING_PINCODE_KEYBOARD"
                }
            },
            ["READING_TERM_OF_SERVICE"]: {
                on: {
                    COMPLETE_TERM_OF_SERVICE: "VALIDATE_FORM",
                    GO_BACK: {
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_)=>undefined
                            }),
                            (0, $c8ePo.send)((ctx)=>ctx?.pincodeRequired ? {
                                    type: "PINCODE_REQUIRED"
                                } : {
                                    type: "PINCODE_NOT_REQUIRED"
                                })
                        ]
                    },
                    PINCODE_REQUIRED: "FETCHING_PINCODE_KEYBOARD",
                    PINCODE_NOT_REQUIRED: "COMPLETING"
                }
            },
            ["VALIDATE_FORM"]: {
                invoke: {
                    id: "validateForm",
                    src: ()=>(0, $kqXxS.registerManager).validateForm(),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_, event)=>event.data.done ? undefined : event.data.data.error.message
                            }),
                            (0, $c8ePo.send)((_, event)=>{
                                if (event.data.done) {
                                    if (event.data.data.metadata.confirmationMode?.type === (0, $19AHh.RegisterTypeConfirmation).Url) return {
                                        type: "FORM_VALID_UBBLE_CONFIRMATION"
                                    };
                                    return {
                                        type: "FORM_VALID"
                                    };
                                }
                                return {
                                    type: "FORM_NOT_VALID"
                                };
                            })
                        ]
                    },
                    onError: {
                        target: "READING_TERM_OF_SERVICE",
                        actions: (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        })
                    }
                },
                on: {
                    FORM_VALID: "CONFIRM_REGISTER",
                    FORM_NOT_VALID: "READING_TERM_OF_SERVICE",
                    FORM_VALID_UBBLE_CONFIRMATION: "UBBLE_CONFIRMATION_REDIRECTION"
                }
            },
            ["UBBLE_CONFIRMATION_REDIRECTION"]: {
                invoke: {
                    id: "ubbleConfirmation",
                    src: async ()=>window.location.assign(await (0, $kqXxS.registerManager).getUbbleUrl())
                }
            },
            ["CONFIRM_REGISTER_AFTER_UBBLE"]: {
                invoke: {
                    id: "confirmRegisterAfterUbble",
                    src: ()=>(0, $kqXxS.registerManager).confirmRegister(),
                    onDone: {
                        target: "OTP_SUBMISSION",
                        actions: (0, $c8ePo.assign)({
                            error: (_)=>undefined
                        })
                    },
                    onError: {
                        actions: (0, $c8ePo.assign)({
                            error: (_, event)=>event?.data
                        })
                    }
                }
            },
            ["CONFIRM_REGISTER"]: {
                invoke: {
                    id: "confirmRegister",
                    src: ()=>(0, $kqXxS.registerManager).confirmRegister(),
                    onDone: {
                        target: "OTP_SUBMISSION",
                        actions: (0, $c8ePo.assign)({
                            error: (_)=>undefined
                        })
                    },
                    onError: {
                        target: "READING_TERM_OF_SERVICE",
                        actions: (0, $c8ePo.assign)({
                            error: (_, event)=>event?.data
                        })
                    }
                }
            },
            ["OTP_SUBMISSION"]: {
                on: {
                    OTP_CONFIRM: {
                        target: "OTP_CONFIRMING",
                        actions: (0, $c8ePo.assign)({
                            otp: (_, event)=>event.otp
                        })
                    }
                }
            },
            ["OTP_CONFIRMING"]: {
                invoke: {
                    id: "validateRegisterOtp",
                    src: (ctx)=>(0, $kqXxS.registerManager).loadPendingEnrollment().then((pendingEnrollment)=>{
                            if ((0, $gDlNU.isDefined)(pendingEnrollment) && (0, $gDlNU.isDefined)(pendingEnrollment.phoneNumber)) return (0, $kqXxS.authExecutor).validateRegisterOtp(pendingEnrollment.phoneNumber, {
                                enrollment_id: pendingEnrollment.preAuth.metadata.enrollmentId,
                                enrollment_otp: ctx.otp
                            });
                        }),
                    onDone: {
                        actions: (0, $c8ePo.send)({
                            type: "OTP_CONFIRMED"
                        })
                    },
                    onError: {
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "OTP_ERROR"
                            })
                        ]
                    }
                },
                on: {
                    OTP_ERROR: "OTP_SUBMISSION",
                    OTP_CONFIRMED: "REGISTRATION_COMPLETED"
                }
            },
            ["REGISTRATION_COMPLETED"]: {
                type: "final"
            }
        }
    });

});

parcelRegister("4iy8M", function(module, exports) {

$parcel$export(module.exports, "RegisterOtpStep", function () { return $5fbcf57508298b71$export$6e3af1cac1df8442; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $ZE1cB = parcelRequire("ZE1cB");

var $22v9q = parcelRequire("22v9q");

var $8Mjlc = parcelRequire("8Mjlc");

var $kSLZ3 = parcelRequire("kSLZ3");
const $5fbcf57508298b71$export$6e3af1cac1df8442 = ({ onSubmit: onSubmit, errorMessage: errorMessage, phoneNumber: phoneNumber, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $kSLZ3.FormWithButtons), {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($5fbcf57508298b71$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($5fbcf57508298b71$var$Title, {
                    children: formatMessage("registerScreen.otpTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: onSubmit,
                    additionalText: formatMessage("registerScreen.otpLabel"),
                    phoneNumber: phoneNumber?.formatInternational() ?? undefined,
                    loading: loading,
                    errorMessage: errorMessage
                })
            ]
        })
    });
};
const $5fbcf57508298b71$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 30px;
`;
const $5fbcf57508298b71$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  text-align: center;
  font-size: 1.875rem;
  padding-bottom: 20px;
`;

});

parcelRegister("9usPr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d5c0a90c38d5269$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $glqzU = parcelRequire("glqzU");
var $8Ba1X = parcelRequire("8Ba1X");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $a5OyK = parcelRequire("a5OyK");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $ZE1cB = parcelRequire("ZE1cB");

var $1Ny0s = parcelRequire("1Ny0s");

var $22v9q = parcelRequire("22v9q");

var $kSLZ3 = parcelRequire("kSLZ3");
const $7d5c0a90c38d5269$var$PhoneNumberRegisterStep = ({ onSubmit: onSubmit, loading: loading, errorMessage: errorMessage, initialPhoneNumber: initialPhoneNumber })=>{
    const defaultCountry = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).defaultCountry);
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)(initialPhoneNumber?.country ?? defaultCountry);
    const [phoneNumber, setPhoneNumber] = (0, $6uYXW.useState)(initialPhoneNumber?.nationalNumber.toString() ?? "");
    const [error, setError] = (0, $6uYXW.useState)(null);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const editPhoneNumber = (phoneNumber)=>{
        const nationalNumber = "+" + (0, $a5OyK.countries)[countryCode].phoneCode;
        const internationalPhoneNumber = phoneNumber.startsWith(nationalNumber) ? phoneNumber : nationalNumber + phoneNumber;
        const formatted = new (0, $glqzU.AsYouType)().input(internationalPhoneNumber).substr(nationalNumber.length);
        setPhoneNumber(formatted);
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $kSLZ3.FormWithButtons), {
        onSubmit: ()=>{
            try {
                setError(null);
                const phoneNumberParsed = (0, $8Ba1X.parsePhoneNumberFromString)(phoneNumber, countryCode);
                if (!phoneNumberParsed) throw formatMessage("common.invalidPhoneNumber");
                onSubmit(phoneNumberParsed);
            } catch (e) {
                setError(e);
            }
        },
        errorMessage: error || errorMessage,
        loading: loading,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($7d5c0a90c38d5269$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($7d5c0a90c38d5269$var$StepTitle, {
                    children: formatMessage("registerScreen.firstStepTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($7d5c0a90c38d5269$var$StepSubtitle, {
                    children: formatMessage("registerScreen.firstStepSubtitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)((0, $1Ny0s.PhoneInput), {
                    onChangeCountryCode: setCountryCode,
                    onChangePhoneNumber: editPhoneNumber,
                    initialCountryCode: initialPhoneNumber?.country ?? defaultCountry,
                    initialPhone: initialPhoneNumber?.nationalNumber.toString() ?? ""
                })
            ]
        })
    });
};
var $7d5c0a90c38d5269$export$2e2bcd8739ae039 = $7d5c0a90c38d5269$var$PhoneNumberRegisterStep;
const $7d5c0a90c38d5269$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $7d5c0a90c38d5269$var$StepTitle = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  font-size: 2.5rem;
  line-height: 2.875rem;
  align-self: flex-start;
  margin-bottom: 24px;
`;
const $7d5c0a90c38d5269$var$StepSubtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  color: #b1b1b1;
  font-size: 0.9375rem;
  margin-bottom: 52px;
`;

});

parcelRegister("iacpk", function(module, exports) {

$parcel$export(module.exports, "RegisterPincodeStep", function () { return $be7dcfe66957df99$export$7830ea408e2277a4; });
$parcel$export(module.exports, "RegisterNewPincodeStep", function () { return $be7dcfe66957df99$export$48ada1b1cc1ff92c; });
$parcel$export(module.exports, "RegisterConfirmPincodeStep", function () { return $be7dcfe66957df99$export$c2d68ad74fd42c19; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $ZE1cB = parcelRequire("ZE1cB");

var $eyjPK = parcelRequire("eyjPK");

var $ePeIa = parcelRequire("ePeIa");

var $22v9q = parcelRequire("22v9q");

var $kSLZ3 = parcelRequire("kSLZ3");
const $be7dcfe66957df99$export$7830ea408e2277a4 = ({ onSubmit: onSubmit, onBackward: onBackward, errorMessage: errorMessage })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $kSLZ3.FormWithButtons), {
        onSubmit: onSubmit,
        errorMessage: errorMessage,
        onBackward: onBackward,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($be7dcfe66957df99$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$Title, {
                    children: formatMessage("registerScreen.pincodeStepTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$Label, {
                    children: formatMessage("registerScreen.message")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$Centering, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$RoundContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$LockImage, {})
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$WarningText, {
                    children: formatMessage("registerScreen.doNotForgetWarning")
                })
            ]
        })
    });
};
const $be7dcfe66957df99$export$48ada1b1cc1ff92c = ({ onSubmit: onSubmit, onBackward: onBackward, errorMessage: errorMessage, keyboard: keyboard, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $kSLZ3.FormWithButtons), {
        onBackward: onBackward,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($be7dcfe66957df99$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$Title, {
                    children: formatMessage("registerScreen.pincodeStepTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$StyledPincodeKeyboard, {
                    title: formatMessage("registerScreen.newCodeLabel"),
                    errorMessage: errorMessage ?? undefined,
                    keyboard: keyboard,
                    loadingKeyboard: loading,
                    onSubmit: onSubmit
                })
            ]
        })
    });
};
const $be7dcfe66957df99$export$c2d68ad74fd42c19 = ({ onSubmit: onSubmit, onBackward: onBackward, errorMessage: errorMessage, keyboard: keyboard })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $kSLZ3.FormWithButtons), {
        onBackward: onBackward,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($be7dcfe66957df99$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$Title, {
                    children: formatMessage("registerScreen.pincodeStepTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($be7dcfe66957df99$var$StyledPincodeKeyboard, {
                    title: formatMessage("registerScreen.newCodeConfirmationLabel"),
                    errorMessage: errorMessage ?? undefined,
                    keyboard: keyboard,
                    onSubmit: onSubmit
                })
            ]
        })
    });
};
const $be7dcfe66957df99$var$Container = (0, $jb8NR.default).div`
  flex: 1;
  max-width: 500px;
  display: flex;
  flex-direction: column;
`;
const $be7dcfe66957df99$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  text-align: center;
  font-size: 1.875rem;
`;
const $be7dcfe66957df99$var$Label = (0, $jb8NR.default).div`
  margin-top: 20px;
  color: #aaa;
  font-size: 0.875rem;
  ${(0, $22v9q.theme).text};
  text-align: center;
  margin-bottom: 40px;
`;
const $be7dcfe66957df99$var$Centering = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $be7dcfe66957df99$var$RoundContainer = (0, $jb8NR.default).div`
  display: flex;
  width: 160px;
  height: 160px;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 90px;
  ${(0, $22v9q.shadows).medium};
`;
const $be7dcfe66957df99$var$LockImage = (0, $jb8NR.default)((0, $ePeIa.PadlockLocked))`
  height: 70px;
  width: 70px;
  padding: 20px;
  border-radius: 50px;
  background-color: #000;
  fill: #fff;
`;
const $be7dcfe66957df99$var$WarningText = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  text-align: center;
  font-style: italic;
  font-size: 0.875rem;
  margin-bottom: 40px;
  margin-top: 40px;
`;
const $be7dcfe66957df99$var$StyledPincodeKeyboard = (0, $jb8NR.default)((0, $eyjPK.PincodeKeyboard))`
  margin-top: 40px;
`;

});


parcelRegister("1jH8u", function(module, exports) {

$parcel$export(module.exports, "UbbleCheckScreen", function () { return $18c4e5966cd5ce82$export$9f7aa278958b5e6e; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $fplBl = parcelRequire("fplBl");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");

var $31CeI = parcelRequire("31CeI");

var $7Zu6k = parcelRequire("7Zu6k");

var $cAn8H = parcelRequire("cAn8H");

var $i1jpl = parcelRequire("i1jpl");

var $dmWk7 = parcelRequire("dmWk7");

var $fXB35 = parcelRequire("fXB35");

var $c5JYB = parcelRequire("c5JYB");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $18c4e5966cd5ce82$var$STATUS_QUERY_PARAM = "status";
const $18c4e5966cd5ce82$var$UBBLE_ID_PARAMS = "ubble_identification_id";
function $18c4e5966cd5ce82$export$9f7aa278958b5e6e() {
    const status = (0, $31CeI.useQueryParam)($18c4e5966cd5ce82$var$STATUS_QUERY_PARAM);
    const ubbleId = (0, $31CeI.useQueryParam)($18c4e5966cd5ce82$var$UBBLE_ID_PARAMS);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const history = (0, $NQIVp.useHistory)();
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const { contactEmail: contactEmail, contactPhone: contactPhone } = configuration;
    const showSuccess = (0, $6uYXW.useMemo)(()=>status && ubbleId && (status === "processing" || status === "processed"), [
        status,
        ubbleId
    ]);
    const title = (0, $6uYXW.useMemo)(()=>formatMessage(showSuccess ? "ubbleCheckScreen.success.title" : "ubbleCheckScreen.fail.title"), [
        formatMessage,
        showSuccess
    ]);
    const subtitle = (0, $6uYXW.useMemo)(()=>formatMessage(showSuccess ? "ubbleCheckScreen.success.subtitle" : "ubbleCheckScreen.fail.subtitle"), [
        formatMessage,
        showSuccess
    ]);
    const message = (0, $6uYXW.useMemo)(()=>formatMessage(showSuccess ? "ubbleCheckScreen.success.message" : "ubbleCheckScreen.fail.message"), [
        formatMessage,
        showSuccess
    ]);
    const goToRoot = ()=>{
        history.replace((0, $4fYE4.Path).Root);
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$Page, {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($18c4e5966cd5ce82$var$Background, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$BackgroundImage, {}),
                /*#__PURE__*/ (0, $4m918.jsxs)($18c4e5966cd5ce82$var$MainContainer, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$Logo, {
                            src: (0, $fRvTz.StaticAssets).logo
                        }),
                        showSuccess ? /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$PhoneSuccess, {}) : /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$PhoneFail, {}),
                        /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$Title, {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$Subtitle, {
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$Message, {
                            children: message
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$Footer, {
                            children: showSuccess ? /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$SuccessButton, {
                                size: "M",
                                onClick: goToRoot,
                                children: formatMessage("ubbleCheckScreen.success.button")
                            }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                                children: [
                                    (0, $gDlNU.isDefined)(contactPhone) && /*#__PURE__*/ (0, $4m918.jsxs)($18c4e5966cd5ce82$var$Button, {
                                        type: "phone",
                                        href: (0, $fplBl.buildLinkPhoneTo)(contactPhone),
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$BackgroundIcon, {
                                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $dmWk7.ContactPhoneIcon), {})
                                            }),
                                            /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$ButtonLegend, {
                                                children: formatMessage("ubbleCheckScreen.fail.byPhone")
                                            })
                                        ]
                                    }),
                                    (0, $gDlNU.isDefined)(contactEmail) && /*#__PURE__*/ (0, $4m918.jsxs)($18c4e5966cd5ce82$var$Button, {
                                        type: "email",
                                        href: (0, $fplBl.buildLinkMailTo)(contactEmail),
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$BackgroundIcon, {
                                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $i1jpl.ContactEmailIcon), {})
                                            }),
                                            /*#__PURE__*/ (0, $4m918.jsx)($18c4e5966cd5ce82$var$ButtonLegend, {
                                                children: formatMessage("ubbleCheckScreen.fail.byEmail")
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $18c4e5966cd5ce82$var$Page = (0, $jb8NR.default)((0, $cAn8H.ResponsiveContainer))`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  padding: 0;
  margin: 0;
  flex: 1;
  align-items: stretch;
  justify-content: center;
  width: 100%;
`;
const $18c4e5966cd5ce82$var$Background = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const $18c4e5966cd5ce82$var$BackgroundImage = (0, $jb8NR.default).div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  mask: url(${{}});
  mask-size: cover;
  background-color: ${(0, $22v9q.theme).mainColor};
  width: 100%;
  height: 388px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    height: 343px;
  }

  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_EXTRA_LARGE_BREAKPOINT}px) {
    height: 564px;
  }

  z-index: -100;
`;
const $18c4e5966cd5ce82$var$MainContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: stretch;
  max-width: 536px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    padding-left: 35px;
    padding-right: 35px;
  }
  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_EXTRA_LARGE_BREAKPOINT}px) {
    max-width: 768px;
    padding-left: 50px;
    padding-right: 50px;
  }
`;
const $18c4e5966cd5ce82$var$Logo = (0, $jb8NR.default).img`
  width: 104px;
  height: 104px;
  object-fit: contain;
  border-radius: 13px;
  margin-top: 64px;
  margin-bottom: 70px;
  z-index: 2;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-top: 34px;
    margin-bottom: 74px;
  }
  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_EXTRA_LARGE_BREAKPOINT}px) {
    margin-top: 84px;
    margin-bottom: 124px;
    width: 138px;
    height: 138px;
  }
`;
const $18c4e5966cd5ce82$var$PhoneSuccess = (0, $jb8NR.default)((0, $c5JYB.PhoneSuccessImage))`
  width: 84px;
  height: 147px;
  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_EXTRA_LARGE_BREAKPOINT}px) {
    width: 116px;
    height: 203px;
  }
`;
const $18c4e5966cd5ce82$var$PhoneFail = (0, $jb8NR.default)((0, $fXB35.PhoneFailImage))`
  width: 84px;
  height: 147px;
  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_EXTRA_LARGE_BREAKPOINT}px) {
    width: 116px;
    height: 203px;
  }
`;
const $18c4e5966cd5ce82$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  text-align: center;
  font-size: 0.9375rem;
  letter-spacing: 1.82px;
  color: #b1b1b1;
  margin-top: 36px;
  margin-bottom: 20px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-top: 50px;
    margin-bottom: 0px;
  }
  @media (min-width: ${(0, $7XqbX.UIConstants).DESKTOP_EXTRA_LARGE_BREAKPOINT}px) {
    margin-top: 65px;
    margin-bottom: 20px;
  }
`;
const $18c4e5966cd5ce82$var$Subtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  font-size: 1.25rem;
  color: black;
  text-align: center;
  margin-bottom: 24px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-top: 20px;
    font-size: 1.5rem;
  }
`;
const $18c4e5966cd5ce82$var$Message = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 1.1875rem;
  text-align: center;
  line-height: 1.625rem;
  color: #b1b1b1;
  margin-bottom: 44px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    font-size: 1rem;
  }
`;
const $18c4e5966cd5ce82$var$Footer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 52px;
  margin-bottom: 20px;
`;
const $18c4e5966cd5ce82$var$SuccessButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 0px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-top: 12px;
  }
`;
const $18c4e5966cd5ce82$var$BackgroundIcon = (0, $jb8NR.default).div`
  display: flex;
  width: 42px;
  height: 42px;
  border-radius: 21px;
  background-color: #ececec;
  align-items: center;
  justify-content: center;
  margin: 9px;
`;
const $18c4e5966cd5ce82$var$Button = (0, $jb8NR.default).a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const $18c4e5966cd5ce82$var$ButtonLegend = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.9375rem;
  color: black;
  text-decoration: underline;
`;

});
parcelRegister("fXB35", function(module, exports) {

$parcel$export(module.exports, "PhoneFailImage", function () { return $89363723e8b8b088$export$d527a74e8e6d30ca; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $89363723e8b8b088$export$d527a74e8e6d30ca = (props)=>/*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "84",
        height: "147",
        viewBox: "0 0 84 147",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                fill: "#F4F4F4",
                d: "M82 125H1V22h81z"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M1 6a5 5 0 0 1 5-5h71a5 5 0 0 1 5 5v16H1V6zM82 141a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5v-19h81v19z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "81.5",
                height: "144.5",
                rx: "5.75",
                stroke: "#4D4D4D",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M31 14h22",
                stroke: "#4D4D4D",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "24",
                cy: "14",
                r: "1",
                fill: "#4D4D4D"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "41.5",
                cy: "132.5",
                r: "6.5",
                stroke: "#4D4D4D",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("mask", {
                id: "x09nh9hhla",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M67 72.5C67 86.583 55.583 98 41.5 98S16 86.583 16 72.5 27.417 47 41.5 47 67 58.417 67 72.5zm-48.129 0c0 12.497 10.132 22.629 22.629 22.629 12.497 0 22.629-10.132 22.629-22.629 0-12.497-10.132-22.629-22.629-22.629-12.497 0-22.628 10.132-22.628 22.629z"
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M67 72.5C67 86.583 55.583 98 41.5 98S16 86.583 16 72.5 27.417 47 41.5 47 67 58.417 67 72.5zm-48.129 0c0 12.497 10.132 22.629 22.629 22.629 12.497 0 22.629-10.132 22.629-22.629 0-12.497-10.132-22.629-22.629-22.629-12.497 0-22.628 10.132-22.628 22.629z",
                stroke: "#F24164",
                strokeWidth: "6",
                mask: "url(#x09nh9hhla)"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M50.517 63.839 32.839 81.516M50.517 81.517 32.839 63.839",
                stroke: "#F24164",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });

});

parcelRegister("c5JYB", function(module, exports) {

$parcel$export(module.exports, "PhoneSuccessImage", function () { return $0012ce229b44c258$export$722a165405202ef1; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $0012ce229b44c258$export$722a165405202ef1 = (props)=>/*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "84",
        height: "147",
        viewBox: "0 0 84 147",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                fill: "#F4F4F4",
                d: "M82 125H1V22h81z"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M1 6a5 5 0 0 1 5-5h71a5 5 0 0 1 5 5v16H1V6zM82 141a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5v-19h81v19z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "81.5",
                height: "144.5",
                rx: "5.75",
                stroke: "#4D4D4D",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "m28.5 67 13 12L63 54",
                stroke: "#72D362",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M31 14h22",
                stroke: "#4D4D4D",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "24",
                cy: "14",
                r: "1",
                fill: "#4D4D4D"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "41.5",
                cy: "132.5",
                r: "6.5",
                stroke: "#4D4D4D",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("mask", {
                id: "2n11v50m4a",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M65.25 63.218a25.5 25.5 0 1 1-9.465-11.841l-1.46 2.16a22.893 22.893 0 1 0 8.498 10.63l2.428-.95z"
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M65.25 63.218a25.5 25.5 0 1 1-9.465-11.841l-1.46 2.16a22.893 22.893 0 1 0 8.498 10.63l2.428-.95z",
                stroke: "#72D362",
                strokeWidth: "6",
                mask: "url(#2n11v50m4a)"
            })
        ]
    });

});


parcelRegister("csDxW", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", function () { return $fc877f5d5b6bac04$export$42f84e610f279c31; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $7Zu6k = parcelRequire("7Zu6k");

var $cAn8H = parcelRequire("cAn8H");

var $7DTkZ = parcelRequire("7DTkZ");

var $22v9q = parcelRequire("22v9q");
const $fc877f5d5b6bac04$export$42f84e610f279c31 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const handleBackToLogin = async ()=>{
        try {
            (0, $kqXxS.authExecutor).connect();
        } catch (error) {
            console.error("Retry failed:", error);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: /*#__PURE__*/ (0, $4m918.jsx)($fc877f5d5b6bac04$var$Page, {
            children: /*#__PURE__*/ (0, $4m918.jsxs)($fc877f5d5b6bac04$var$MainContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7DTkZ.ErrorIcon), {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($fc877f5d5b6bac04$var$Subtitle, {
                        children: formatMessage("errorScreen.subTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($fc877f5d5b6bac04$var$Title, {
                        children: formatMessage("errorScreen.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($fc877f5d5b6bac04$var$ErrorMessage, {
                        children: formatMessage("errorScreen.message")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($fc877f5d5b6bac04$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                            size: "M",
                            onClick: handleBackToLogin,
                            children: formatMessage("errorScreen.button")
                        })
                    })
                ]
            })
        })
    });
};

const $fc877f5d5b6bac04$var$Page = (0, $jb8NR.default)((0, $cAn8H.ResponsiveContainer))`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: url(${{}}) 100% 0 no-repeat;
  overflow: hidden;
  padding: 0;
  margin: 0;
  width: 100%;
`;
const $fc877f5d5b6bac04$var$MainContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const $fc877f5d5b6bac04$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText}
  font-size: 1.875rem;
  color: #000;
  margin: 0 0 20px;
`;
const $fc877f5d5b6bac04$var$Subtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  font-size: 1.125rem;
  color: #adadad;
  text-transform: uppercase;
  margin: 40px 0 20px;
  letter-spacing: 2px;
`;
const $fc877f5d5b6bac04$var$ErrorMessage = (0, $jb8NR.default).p`
  line-height: 18px;
  font-size: 1.125rem;
  white-space: pre-line;
`;
const $fc877f5d5b6bac04$var$ButtonContainer = (0, $jb8NR.default).div`
  margin-top: 40px;
`;

});
parcelRegister("7DTkZ", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", function () { return $299d5a0496b2770b$export$19bc16ee58e19b3d; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $299d5a0496b2770b$export$19bc16ee58e19b3d(props) {
    // The artwork used to hardcode its size and colour and drop every prop it was given.
    const color = props.stroke ?? "#FF9A03";
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "189",
        height: "189",
        viewBox: "0 0 189 189",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "94.5",
                cy: "94.5",
                r: "72.6075",
                stroke: color,
                strokeWidth: "6"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                cx: "94.5",
                cy: "94.5",
                r: "92.5",
                stroke: color,
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M89.3661 110.533L88.0553 54.0741H100.508L99.197 110.533H89.3661ZM94.6092 134.926C92.3518 134.926 90.4948 134.201 89.0384 132.75C87.6548 131.223 86.963 129.429 86.963 127.368C86.963 125.23 87.6548 123.436 89.0384 121.985C90.4948 120.458 92.3518 119.695 94.6092 119.695C96.7211 119.695 98.4688 120.458 99.8524 121.985C101.309 123.436 102.037 125.23 102.037 127.368C102.037 129.429 101.309 131.223 99.8524 132.75C98.4688 134.201 96.7211 134.926 94.6092 134.926Z",
                fill: color
            })
        ]
    });
}

});


parcelRegister("3L6c2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48261e7af3429715$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $gALIi = parcelRequire("gALIi");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5P656 = parcelRequire("5P656");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $75iyY = parcelRequire("75iyY");

var $ixrkn = parcelRequire("ixrkn");

var $93CAX = parcelRequire("93CAX");

var $4uih4 = parcelRequire("4uih4");

var $4RaAR = parcelRequire("4RaAR");

var $bs3kR = parcelRequire("bs3kR");

var $hmO0M = parcelRequire("hmO0M");

var $gNscs = parcelRequire("gNscs");

var $4P99o = parcelRequire("4P99o");

var $fZL4e = parcelRequire("fZL4e");

var $j1AiS = parcelRequire("j1AiS");

var $eHurR = parcelRequire("eHurR");

var $bQhUC = parcelRequire("bQhUC");

var $yYT9n = parcelRequire("yYT9n");

var $kIm2v = parcelRequire("kIm2v");

var $9puFP = parcelRequire("9puFP");

var $bkg9q = parcelRequire("bkg9q");

var $jn1mK = parcelRequire("jn1mK");

var $5Wai4 = parcelRequire("5Wai4");

var $8JW2B = parcelRequire("8JW2B");

var $k4kME = parcelRequire("k4kME");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $2XXLB = parcelRequire("2XXLB");

var $j1vsq = parcelRequire("j1vsq");

var $4Ihhj = parcelRequire("4Ihhj");

var $2PBDm = parcelRequire("2PBDm");

var $izvYx = parcelRequire("izvYx");

var $1jtIq = parcelRequire("1jtIq");

var $gugUl = parcelRequire("gugUl");

var $hX57i = parcelRequire("hX57i");
const $48261e7af3429715$var$getInitialSpending = (transaction)=>({
        category: null,
        subcategory: null,
        label: "",
        amount: new (0, $5P656.Amount)(Number(transaction?.amount?.value) / 100, transaction?.amount?.currency || "EUR"),
        additionalData: []
    });
function $48261e7af3429715$export$2e2bcd8739ae039(props) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { location: location, history: history } = props;
    const params = location.state;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const [attachmentError, setAttachmentError] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState("");
    const { canGetContent: canGetContent } = (0, $4P99o.useAttachmentLinks)();
    const { transaction: regularTransaction, refresh: refreshTransaction } = (0, $gNscs.useTransaction)(params.account.id, params.transaction.id);
    const [blankSpending, setBlankSpending] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState();
    const { data: authorizationHolds, refresh: pendingTransactionRefresh } = (0, $j1AiS.useAuthorizationHolds)({
        id: params.account.id
    });
    const authHold = authorizationHolds.find((authHold)=>authHold.id === params.transaction.id);
    const isPendingTransaction = params.transaction.objectType === (0, $ixrkn.AccountingTransactionType).AuthorizationHold;
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState({
        attachment: false,
        spending: false
    });
    const { canJustify: canJustify, canAddAttachment: canAddAttachment, canAddSpending: canAddSpending, isOutgoing: isOutgoing } = (0, $fZL4e.useTransactionLinks)();
    const transaction = isPendingTransaction ? authHold : regularTransaction;
    // The header names the expense the way the list and the details modal do. A pending hold carries
    // none of those fields, so the screen's own title stands in.
    const expense = transaction;
    const transactionDescription = expense?.shortDescription || expense?.detailedAccounting?.find((accounting)=>accounting.type === (0, $75iyY.AccountingEntryType).Transfer)?.description || expense?.type?.label || formatMessage("justifyScreen.title");
    const { spendings: spendings, refresh: refreshSpendings, loading: spendingsLoading } = (0, $hmO0M.useSpendings)(transaction);
    const { attachments: attachments, loading: documentsLoading } = (0, $bs3kR.useAttachments)(transaction);
    const handleFileChange = async (e)=>{
        const file = e.target.files[0];
        if (transaction && file) {
            const links = transaction.links;
            const fileConverter = new (0, $kIm2v.WebImagesConverter)();
            const convertedFile = await fileConverter.fileIntoBase64(file);
            setIsLoading({
                ...isLoading,
                attachment: true
            });
            try {
                setAttachmentError("");
                const url = (0, $eHurR.getUrlFromLink)(links, (0, $4RaAR.TransactionLinks).AddAttachment);
                await (0, $kqXxS.attachmentsManager).addAttachment(transaction.id, convertedFile.split(",")[1], "", url);
                isPendingTransaction ? pendingTransactionRefresh() : refreshTransaction();
            } catch (e) {
                console.log(e);
                setAttachmentError(e.response.data.error.message);
            } finally{
                setIsLoading({
                    ...isLoading,
                    attachment: false
                });
            }
        }
    };
    const handleOpenFile = async (attachment)=>{
        if (transaction && canGetContent(attachment)) {
            setIsLoading({
                ...isLoading,
                attachment: true
            });
            try {
                const url = (0, $eHurR.getUrlFromLink)(attachment.links, (0, $93CAX.AttachmentsLinks).GetContent);
                const attachmentData = await (0, $kqXxS.attachmentsManager).getContent(transaction.id, attachment.id, url);
                if (attachmentData) {
                    const file = new Blob([
                        attachmentData.content
                    ], {
                        type: attachmentData.contentType
                    });
                    // const extension = mime.extension(attachmentData.contentType);
                    const fileURL = URL.createObjectURL(file);
                    const link = document.createElement("a");
                    link.href = fileURL;
                    link.target = "_blank";
                    // link.download = `Attachment_${attachment.id}.${extension}`;
                    link.click();
                }
            } catch (e) {
                setAttachmentError(e.response.data.error.message);
                console.log(e);
            } finally{
                setIsLoading({
                    ...isLoading,
                    attachment: false
                });
            }
        }
    };
    const handleAddNewSpending = ()=>{
        setBlankSpending($48261e7af3429715$var$getInitialSpending(transaction));
    };
    const handleEditSpending = (spending)=>{
        setBlankSpending({
            ...(0, $gALIi.cloneDeep)(spending)
        });
    };
    const handleSpendingSuccess = ()=>{
        isPendingTransaction ? pendingTransactionRefresh() : refreshTransaction();
        refreshSpendings();
        (0, $5Wai4.Modal).dismiss((0, $bQhUC.ADD_OR_EDIT_SPENDING));
    };
    (0, $6uYXW.useEffect)(()=>{
        if (blankSpending && transaction) (0, $5Wai4.Modal).present((0, $bQhUC.ADD_OR_EDIT_SPENDING), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $j1vsq.AddSpendingModal), {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $gugUl.default), {
                    transaction: transaction,
                    spending: blankSpending,
                    onSuccess: handleSpendingSuccess
                })
            }), {});
    }, [
        blankSpending
    ]);
    const handleFileDelete = async (attachment)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.REMOVE_ATTACHMENT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $1jtIq.RemoveConfirmModal), {
                modalId: (0, $bQhUC.REMOVE_ATTACHMENT_MODAL_ID),
                labels: "justifyScreen.attachments.deletePrompt",
                onConfirm: ()=>handleConfirmFileDelete(attachment)
            }), {
            canBeDismissed: true
        });
    };
    const handleConfirmFileDelete = async (attachment)=>{
        if (transaction) {
            setIsLoading({
                ...isLoading,
                attachment: true
            });
            try {
                setAttachmentError("");
                const url = (0, $eHurR.getUrlFromLink)(attachment.links, (0, $93CAX.AttachmentsLinks).Delete);
                await (0, $kqXxS.attachmentsManager).deleteAttachment(transaction.id, attachment.id, url);
            } catch (e) {
                console.log(e);
                setAttachmentError(e.response.data.error.message);
            } finally{
                setIsLoading({
                    ...isLoading,
                    attachment: false
                });
            }
        }
    };
    const handleSpendingDelete = async (attachment)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.REMOVE_SPENDING_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $1jtIq.RemoveConfirmModal), {
                modalId: (0, $bQhUC.REMOVE_SPENDING_MODAL_ID),
                labels: "justifyScreen.spendings.deletePrompt",
                onConfirm: ()=>handleConfirmSpendingDelete(attachment)
            }), {
            canBeDismissed: true
        });
    };
    const handleConfirmSpendingDelete = async (spending)=>{
        if (transaction) {
            setIsLoading({
                ...isLoading,
                spending: true
            });
            try {
                setAttachmentError("");
                const url = (0, $eHurR.getUrlFromLink)(spending.links, (0, $4uih4.SpendingLinks).Delete);
                await (0, $kqXxS.spendingsManager).deleteSpendingDetails(transaction.id, spending.id, url);
            } catch (e) {
                console.log(e);
                setAttachmentError(e.response.data.error.message);
            } finally{
                setIsLoading({
                    ...isLoading,
                    spending: false
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($48261e7af3429715$var$PageWrapper, {
        isLoading: isLoading.attachment || isLoading.spending,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $8JW2B.PageBackLink), {
                onBack: ()=>history.goBack()
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($48261e7af3429715$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$Title, {
                        children: transactionDescription
                    }),
                    !!transaction && isOutgoing(transaction) && /*#__PURE__*/ (0, $4m918.jsxs)($48261e7af3429715$var$Tags, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $2XXLB.TransactionStateTag), {
                                label: formatMessage(transaction.justified ? "accountTransactions.tagJustified" : "accountTransactions.tagNotJustified"),
                                done: !!transaction.justified
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $2XXLB.TransactionStateTag), {
                                label: formatMessage(transaction.qualified ? "accountTransactions.tagQualified" : "accountTransactions.tagNotQualified"),
                                done: !!transaction.qualified
                            })
                        ]
                    })
                ]
            }),
            !!transaction?.id && /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$Reference, {
                children: formatMessage("accountingTransactionDetailsModal.transaction", {
                    id: transaction.id
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$SectionTitle, {
                children: formatMessage("justifyScreen.attachments.title")
            }),
            !!attachmentError && /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$StyledErrorMessage, {
                children: attachmentError
            }),
            isLoading.attachment && /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$StyledMainColorSpinner, {}),
            documentsLoading ? /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$StyledMainColorSpinner, {}) : !attachments.length ? transaction && canAddAttachment(transaction) && /*#__PURE__*/ (0, $4m918.jsx)((0, $2PBDm.default), {
                isDropZone: true,
                disabled: documentsLoading,
                onChange: handleFileChange,
                title: formatMessage("justifyScreen.attachments.sectionTitle"),
                subtitle: formatMessage("justifyScreen.attachments.sectionSubtitle"),
                icon: /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$ZoneIllustration, {
                    src: (0, $fRvTz.StaticAssets).justifyTransaction,
                    alt: ""
                })
            }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    attachments.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$List, {
                        children: attachments.map((attachment, index)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $izvYx.default), {
                                isRTL: isRTL,
                                onOpen: ()=>handleOpenFile(attachment),
                                onDelete: ()=>handleFileDelete(attachment),
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $4Ihhj.default), {
                                    attachment: attachment,
                                    transaction: transaction
                                })
                            }, index))
                    }),
                    transaction && canAddAttachment(transaction) && /*#__PURE__*/ (0, $4m918.jsx)((0, $9puFP.default), {
                        onChange: handleFileChange,
                        disabled: documentsLoading,
                        children: formatMessage(attachments.length === 0 ? "justifyScreen.attachments.addButtonLabel" : "justifyScreen.attachments.addOtherButtonLabel")
                    })
                ]
            }),
            (transaction?.locked && spendings.length > 0 || !transaction?.locked) && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$SectionTitle, {
                        children: formatMessage("justifyScreen.spendings.title")
                    }),
                    isLoading.spending && /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$StyledMainColorSpinner, {}),
                    spendingsLoading ? /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$StyledMainColorSpinner, {}) : !spendings.length && transaction && !transaction.locked && canJustify(transaction) && canAddSpending(transaction) ? /*#__PURE__*/ (0, $4m918.jsx)((0, $2PBDm.default), {
                        title: formatMessage("justifyScreen.spendings.sectionTitle"),
                        subtitle: formatMessage("justifyScreen.spendings.sectionSubtitle"),
                        disabled: spendingsLoading,
                        onClick: handleAddNewSpending,
                        icon: /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$ZoneIllustration, {
                            src: (0, $fRvTz.StaticAssets).qualifyTransaction,
                            alt: ""
                        })
                    }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            spendings.length > 0 && /*#__PURE__*/ (0, $4m918.jsx)($48261e7af3429715$var$List, {
                                children: spendings.map((spending, index)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $izvYx.default), {
                                        variant: "spending",
                                        isRTL: isRTL,
                                        onDelete: transaction?.locked ? undefined : ()=>handleSpendingDelete(spending),
                                        onOpen: transaction?.locked ? undefined : ()=>handleEditSpending(spending),
                                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $hX57i.default), {
                                            spending: spending
                                        })
                                    }, index))
                            }),
                            transaction && !transaction.locked && canJustify(transaction) && canAddSpending(transaction) && /*#__PURE__*/ (0, $4m918.jsx)((0, $bkg9q.default), {
                                disabled: spendingsLoading,
                                onClick: handleAddNewSpending,
                                children: formatMessage(attachments.length === 0 ? "justifyScreen.spendings.addButtonLabel" : "justifyScreen.spendings.addOtherButtonLabel")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $48261e7af3429715$var$PageWrapper = (0, $jb8NR.default).div`
  width: 100%;
  ${({ isLoading: isLoading })=>{
    if (isLoading) return `
				pointer-events: none;
				opacity: 0.5;
			`;
    return "";
}}
`;
/* The rows sit inside one panel, the way the reworked lists elsewhere are drawn. */ const $48261e7af3429715$var$List = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  overflow: hidden;
  margin-bottom: 16px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  background-color: #ffffff;
  ${(0, $22v9q.shadows).sm};
`;
const $48261e7af3429715$var$ZoneIllustration = (0, $jb8NR.default).img`
  width: 67px;
  height: 68px;
`;
const $48261e7af3429715$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;
const $48261e7af3429715$var$Title = (0, $jb8NR.default).h1`
  ${(0, $22v9q.theme).boldText};
  margin: 0;
  flex: 1 1 auto;

  /* A label carrying no space still has to give way, or it pushes the tags out. */
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $48261e7af3429715$var$Tags = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: 8px;
`;
const $48261e7af3429715$var$Reference = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  display: block;
  margin-top: 4px;
  font-size: 13px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[500]};
`;
const $48261e7af3429715$var$SectionTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 28px 0 12px;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $48261e7af3429715$var$StyledMainColorSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;
const $48261e7af3429715$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-bottom: 16px;
`;

});
parcelRegister("4uih4", function(module, exports) {

$parcel$export(module.exports, "SpendingLinks", function () { return $846a4b6b1db81dca$export$802873478e9bbebf; });
var $846a4b6b1db81dca$export$802873478e9bbebf = /*#__PURE__*/ function(SpendingLinks) {
    SpendingLinks["Update"] = "updateSpendingDetail";
    SpendingLinks["Delete"] = "deleteSpendingDetail";
    SpendingLinks["AddAnother"] = "addSpendingOnSameTransaction";
    return SpendingLinks;
}({});

});

parcelRegister("bs3kR", function(module, exports) {

$parcel$export(module.exports, "useAttachments", function () { return $898445c5e6ae6c6d$export$6a2bc6cba8dde126; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $eHurR = parcelRequire("eHurR");

var $fZL4e = parcelRequire("fZL4e");

var $4RaAR = parcelRequire("4RaAR");
const $898445c5e6ae6c6d$export$6a2bc6cba8dde126 = (transaction)=>{
    const attachments = (0, $3Ersk.useObservable)((0, $kqXxS.attachmentsManager).attachments);
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [error, setError] = (0, $6uYXW.useState)("");
    const { canGetAttachments: canGetAttachments } = (0, $fZL4e.useTransactionLinks)();
    const refresh = async (forceRefresh = false)=>{
        await (0, $kqXxS.attachmentsManager).clear();
        if (transaction && (canGetAttachments(transaction) || forceRefresh)) try {
            setError("");
            setLoading(true);
            const url = (0, $eHurR.getUrlFromLink)(transaction.links, (0, $4RaAR.TransactionLinks).GetAttachments);
            await (0, $kqXxS.attachmentsManager).refresh(transaction.id, url);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            setError(e.message);
            (0, $6JVVB.logger).debug("error fetching attachments", e);
        }
        else (0, $kqXxS.attachmentsManager).clear();
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await refresh();
    }, [
        transaction
    ]);
    return {
        attachments: attachments,
        refresh: refresh,
        loading: loading,
        error: error
    };
};

});

parcelRegister("gNscs", function(module, exports) {

$parcel$export(module.exports, "useTransaction", function () { return $240e8c3cf4d47f06$export$244eac3470cf24ad; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
function $240e8c3cf4d47f06$export$244eac3470cf24ad(accountId, transactionId, loadAtStartup = true) {
    const transaction = (0, $3Ersk.useObservable)((0, $kqXxS.transactionManager).transaction);
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [error, setError] = (0, $6uYXW.useState)("");
    const refresh = async ()=>{
        if (accountId && transactionId) {
            setLoading(true);
            try {
                await (0, $kqXxS.transactionManager).fetch(accountId, transactionId);
            } catch (e) {
                setError(e.response.data.error.message);
                (0, $6JVVB.logger).debug("error fetching spendings", e);
            } finally{
                setLoading(false);
            }
        }
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (loadAtStartup) await refresh();
    }, []);
    return {
        transaction: transaction,
        refresh: refresh,
        loading: loading,
        error: error
    };
}

});

parcelRegister("4P99o", function(module, exports) {

$parcel$export(module.exports, "useAttachmentLinks", function () { return $d6466374796bb049$export$3953d75fa4742289; });

var $93CAX = parcelRequire("93CAX");
const $d6466374796bb049$export$3953d75fa4742289 = ()=>{
    const canAddAnother = (attachment)=>{
        if (!attachment.links) return false;
        return attachment.links.findIndex((link)=>link.rel === (0, $93CAX.AttachmentsLinks).AddAnother) > -1;
    };
    const canDelete = (attachment)=>{
        if (!attachment.links) return false;
        return attachment.links.findIndex((link)=>link.rel === (0, $93CAX.AttachmentsLinks).Delete) > -1;
    };
    const canGetContent = (attachment)=>{
        if (!attachment.links) return false;
        return attachment.links.findIndex((link)=>link.rel === (0, $93CAX.AttachmentsLinks).GetContent) > -1;
    };
    return {
        canAddAnother: canAddAnother,
        canDelete: canDelete,
        canGetContent: canGetContent
    };
};

});

parcelRegister("j1AiS", function(module, exports) {

$parcel$export(module.exports, "useAuthorizationHolds", function () { return $5af1be3152d294a8$export$dcec6e710ec3497e; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
function $5af1be3152d294a8$export$dcec6e710ec3497e(account) {
    const accountId = account?.id;
    const loader = (0, $6uYXW.useMemo)(()=>{
        if (!accountId) return (0, $kqXxS.authorizationHoldManager).getDefaultLoader();
        return (0, $kqXxS.authorizationHoldManager).getTransactionsLoader(accountId);
    }, [
        accountId
    ]);
    const data = (0, $3Ersk.useObservable)(loader.data);
    const initializing = (0, $3Ersk.useObservable)(loader.initializing);
    const loading = (0, $3Ersk.useObservable)(loader.loading);
    const refreshing = (0, $3Ersk.useObservable)(loader.refreshing);
    const error = (0, $3Ersk.useObservable)(loader.error);
    const loadingMore = (0, $3Ersk.useObservable)(loader.loadingMore);
    const loadingMoreError = (0, $3Ersk.useObservable)(loader.loadingMoreError);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await loader.load();
    }, [
        loader
    ]);
    const refresh = (0, $6uYXW.useCallback)(async ()=>{
        await loader.refresh();
    }, [
        loader
    ]);
    const canLoadMore = (0, $6uYXW.useMemo)(()=>data.offset + data.limit < data.total, [
        data.offset,
        data.limit,
        data.total
    ]);
    const loadMore = (0, $6uYXW.useCallback)(async ()=>{
        await loader.loadMore();
    }, [
        loader
    ]);
    return {
        data: data.items,
        loading: initializing || loading,
        error: error,
        canLoadMore: canLoadMore,
        loadMore: loadMore,
        loadingMore: loadingMore,
        loadingMoreError: loadingMoreError,
        refresh: refresh,
        refreshing: refreshing
    };
}

});

parcelRegister("9puFP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf840a5f0a3d297e$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $bkg9q = parcelRequire("bkg9q");
function $cf840a5f0a3d297e$export$2e2bcd8739ae039(props) {
    const { accept: accept = "application/pdf,image/jpg,image/jpeg,image/png", onChange: onChange, disabled: disabled, children: children } = props;
    const uniqueId = window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36).substring(7);
    return /*#__PURE__*/ (0, $4m918.jsxs)("label", {
        htmlFor: uniqueId,
        style: {
            display: "block",
            position: "relative",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("input", {
                id: uniqueId,
                type: "file",
                onChange: onChange,
                accept: accept,
                style: {
                    opacity: 0,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer"
                }
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $bkg9q.default), {
                disabled: disabled,
                children: children
            })
        ]
    });
}

});
parcelRegister("bkg9q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a9eb06ab8e656b7$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");

var $bfYs4 = parcelRequire("bfYs4");
function $7a9eb06ab8e656b7$export$2e2bcd8739ae039(props) {
    const { type: type = "button", onClick: onClick, children: children, disabled: disabled } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($7a9eb06ab8e656b7$var$StyledButton, {
        type: type,
        onClick: onClick,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($7a9eb06ab8e656b7$var$PlusCircle, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bfYs4.PlusIconSmall), {})
            }),
            children
        ]
    });
}
/* A dashed outline, so the zone reads as a place to drop something into, not as a filled button. */ const $7a9eb06ab8e656b7$var$StyledButton = (0, $jb8NR.default).button`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 16px 20px;
  border: 1px dashed ${(0, $22v9q.theme).colors.blue[700]};
  border-radius: 8px;
  background-color: transparent;
  cursor: pointer;
  ${(0, $22v9q.theme).text};
  font-size: 16px;
  line-height: 22px;
  color: ${(0, $22v9q.theme).colors.blue[800]};

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover {
    background-color: ${(0, $22v9q.theme).colors.blue[100]};
  }
`;
const $7a9eb06ab8e656b7$var$PlusCircle = (0, $jb8NR.default).span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${(0, $22v9q.theme).colors.gray[100]};

  path {
    fill: ${(0, $22v9q.theme).colors.blue[700]};
  }
`;

});


parcelRegister("j1vsq", function(module, exports) {

$parcel$export(module.exports, "AddSpendingModal", function () { return $0de7df2030b8df83$export$aaa28a870511dc60; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $bQhUC = parcelRequire("bQhUC");

var $7xALQ = parcelRequire("7xALQ");
const $0de7df2030b8df83$export$aaa28a870511dc60 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($0de7df2030b8df83$var$ModalContainer, {
        closeButton: true,
        id: (0, $bQhUC.ADD_OR_EDIT_SPENDING),
        children: children
    });
};
const $0de7df2030b8df83$var$ModalContainer = (0, $jb8NR.default)((0, $7xALQ.WhiteModalContainer))`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 460px;
`;

});

parcelRegister("4Ihhj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d149d173ab200ae$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $kgvRN = parcelRequire("kgvRN");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $93CAX = parcelRequire("93CAX");

var $4P99o = parcelRequire("4P99o");

var $eHurR = parcelRequire("eHurR");

var $k4Ecv = parcelRequire("k4Ecv");

var $22v9q = parcelRequire("22v9q");
function $3d149d173ab200ae$export$2e2bcd8739ae039(props) {
    const { attachment: attachment, transaction: transaction } = props;
    const [content, setContent] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState();
    const { canGetContent: canGetContent } = (0, $4P99o.useAttachmentLinks)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (transaction && canGetContent(attachment)) try {
            const url = (0, $eHurR.getUrlFromLink)(attachment.links, (0, $93CAX.AttachmentsLinks).GetContent);
            const content = await (0, $kqXxS.attachmentsManager).getContent(transaction.id, attachment.id, url);
            if (content) setContent(content);
        } catch (e) {
            console.log(e);
        }
    }, [
        attachment
    ]);
    const contentType = content?.contentType;
    const fileType = contentType?.split("/")[0];
    const extention = contentType?.split("/")[1].split(";")[0] || "";
    const base64Img = content?.base64Img || "";
    return /*#__PURE__*/ (0, $4m918.jsxs)($3d149d173ab200ae$var$AttachmentContentStyled, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("span", {
                children: [
                    formatMessage("registerScreen.pictureInputFilled"),
                    " ",
                    fileType,
                    " ",
                    extention ? `(${extention})` : ""
                ]
            }),
            !!content && /*#__PURE__*/ (0, $4m918.jsx)($3d149d173ab200ae$var$AttachmentContentDescription, {
                children: (0, (/*@__PURE__*/$parcel$interopDefault($kgvRN)))(base64Img.length)
            })
        ]
    });
}
const $3d149d173ab200ae$var$AttachmentContentStyled = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  ${(0, $22v9q.theme).text};
  font-size: 15px;
  line-height: 20px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $3d149d173ab200ae$var$AttachmentContentDescription = (0, $jb8NR.default).span`
  color: ${(0, $22v9q.theme).colors.gray[500]};
  text-transform: uppercase;
  font-size: 12px;
`;

});

parcelRegister("2PBDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $689fa4dd5e399ae8$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
function $689fa4dd5e399ae8$var$DropZone(props) {
    const { children: children, accept: accept, onChange: onChange } = props;
    const [isDropping, setIsDropping] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(false);
    const uniqueId = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useMemo(()=>window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36).substring(7), []);
    return /*#__PURE__*/ (0, $4m918.jsxs)($689fa4dd5e399ae8$var$DropZoneLabel, {
        htmlFor: uniqueId,
        isDropping: isDropping,
        children: [
            children,
            /*#__PURE__*/ (0, $4m918.jsx)($689fa4dd5e399ae8$var$DropZoneInput, {
                onDragEnter: ()=>setIsDropping(true),
                onDragLeave: ()=>setIsDropping(false),
                id: uniqueId,
                accept: accept,
                onChange: (event)=>onChange?.(event),
                type: "file"
            })
        ]
    });
}
function $689fa4dd5e399ae8$export$2e2bcd8739ae039(props) {
    const { icon: icon, title: title, subtitle: subtitle, isDropZone: isDropZone, disabled: disabled, accept: accept = "application/pdf,image/jpg,image/jpeg,image/png", onChange: onChange, onClick: onClick } = props;
    const Content = /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            icon,
            /*#__PURE__*/ (0, $4m918.jsx)($689fa4dd5e399ae8$var$Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($689fa4dd5e399ae8$var$Subtitle, {
                children: subtitle
            })
        ]
    });
    return /*#__PURE__*/ (0, $4m918.jsx)($689fa4dd5e399ae8$var$ComponentWrapper, {
        disabled: disabled,
        children: isDropZone ? /*#__PURE__*/ (0, $4m918.jsx)($689fa4dd5e399ae8$var$DropZone, {
            accept: accept,
            onChange: (event)=>onChange?.(event),
            children: Content
        }) : /*#__PURE__*/ (0, $4m918.jsx)($689fa4dd5e399ae8$var$Box, {
            type: "button",
            disabled: disabled,
            onClick: ()=>onClick?.(),
            children: Content
        })
    });
}
const $689fa4dd5e399ae8$var$ComponentWrapper = (0, $jb8NR.default).div`
  width: 100%;
  ${({ disabled: disabled })=>disabled ? "opacity: 0.5;" : ""}
  ${({ disabled: disabled })=>disabled ? "point-event: none" : ""}
`;
/* The pale blue panel of the redesign: the invitation reads as an area to act in, not as a card. */ const $689fa4dd5e399ae8$var$WrapperStyle = `
cursor: pointer;
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding: 40px 30px;
border-radius: 12px;
background-color: #e8f2fd;
&:hover {
	background-color: ${(0, $22v9q.theme).colors.blue[200]};
}`;
const $689fa4dd5e399ae8$var$Box = (0, $jb8NR.default).button`
  border: 0;
  font: inherit;
  text-align: inherit;
  ${$689fa4dd5e399ae8$var$WrapperStyle}
`;
const $689fa4dd5e399ae8$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  margin-top: 16px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #741537;
`;
const $689fa4dd5e399ae8$var$Subtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 8px;
  max-width: 420px;
  text-align: center;
  font-size: 12px;
  line-height: 15px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $689fa4dd5e399ae8$var$DropZoneLabel = (0, $jb8NR.default).label`
  position: relative;
  display: block;
  width: 100%;
  border: dashed 2px transparent;
  ${$689fa4dd5e399ae8$var$WrapperStyle}
  ${(props)=>props.isDropping && `
		background-color: ${(0, $22v9q.theme).colors.blue[200]};
		border-color: ${(0, $22v9q.theme).colors.blue[700]};
		`}
`;
const $689fa4dd5e399ae8$var$DropZoneInput = (0, $jb8NR.default).input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
`;

});

parcelRegister("izvYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1560d10bd398b916$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $4nSeL = parcelRequire("4nSeL");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");
function $1560d10bd398b916$export$2e2bcd8739ae039(props) {
    const { children: children, variant: variant = "attachment", isRTL: isRTL, onClick: onClick, onOpen: onOpen, onDelete: onDelete } = props;
    const [openMenu, setOpenMenu] = (0, $6uYXW.useState)(false);
    const handleDelete = ()=>{
        setOpenMenu(false);
        onDelete?.();
    };
    const handleOpen = ()=>{
        setOpenMenu(false);
        onOpen?.();
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($1560d10bd398b916$var$Card, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($1560d10bd398b916$var$JustifiedIcon, {
                src: (0, $fRvTz.StaticAssets).justified,
                alt: ""
            }),
            children,
            /*#__PURE__*/ (0, $4m918.jsx)((0, $4nSeL.default), {
                alwaysOpened: false,
                isRTL: isRTL,
                onToggle: ()=>setOpenMenu(!openMenu),
                isOpen: openMenu,
                onOpen: onOpen ? handleOpen : undefined,
                onDelete: onDelete ? handleDelete : undefined
            })
        ]
    });
}
/* One row of the list, not a card of its own: the list around them carries the chrome. */ const $1560d10bd398b916$var$Card = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 14px 20px;
  border-top: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  background-color: #ffffff;

  &:first-of-type {
    border-top: 0;
  }

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: auto;
  }
`;
const $1560d10bd398b916$var$JustifiedIcon = (0, $jb8NR.default).img`
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
`;

});
parcelRegister("4nSeL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3238a3ee614a2d69$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $arOSR = parcelRequire("arOSR");
function $3238a3ee614a2d69$export$2e2bcd8739ae039(props) {
    const { isPaused: isPaused, isRTL: isRTL = true, alwaysOpened: alwaysOpened = false, isOpen: isOpen, enableEdit: enableEdit = true, enablePause: enablePause = true, enableDelete: enableDelete = true, enableCancel: enableCancel = true, enablePlay: enablePlay = true, onToggle: onToggle, onPause: onPause, onOpen: onOpen, onEdit: onEdit, onDelete: onDelete, onCancel: onCancel, onPlay: onPlay } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($3238a3ee614a2d69$var$MoreMenu, {
        $isRTL: isRTL,
        children: [
            !alwaysOpened && (!!onDelete || !!onEdit || !!onOpen || !!onCancel || !!onPlay) && /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.MoreButton), {
                active: isOpen,
                onClick: onToggle
            }),
            !!onDelete && enableDelete && /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.DeleteButton), {
                show: alwaysOpened || isOpen,
                onClick: onDelete
            }),
            !!onPause && enablePause && /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.PauseButton), {
                isPaused: isPaused,
                show: alwaysOpened || isOpen,
                onClick: onPause
            }),
            !!onEdit && enableEdit && /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.EditButton), {
                show: alwaysOpened || isOpen,
                onClick: onEdit
            }),
            !!onCancel && enableCancel && /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.CancelButton), {
                show: alwaysOpened || isOpen,
                onClick: onCancel
            }),
            !!onPlay && enablePlay && /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.PlayButton), {
                show: alwaysOpened || isOpen,
                onClick: onPlay
            }),
            !!onOpen && /*#__PURE__*/ (0, $4m918.jsx)((0, $arOSR.OpenButton), {
                show: alwaysOpened || isOpen,
                onClick: onOpen
            })
        ]
    });
}
const $3238a3ee614a2d69$var$MoreMenu = (0, $jb8NR.default).div`
  position: absolute;
  display: flex;
  flex-direction: ${(props)=>props.$isRTL ? "row" : "row-reverse"};
  align-items: center;
  right: ${(props)=>props.$isRTL ? "unset" : "25px"};
  left: ${(props)=>props.$isRTL ? "25px" : "unset"};
  top: 0px;
  bottom: 0px;
  z-index: 1;
`;

});


parcelRegister("1jtIq", function(module, exports) {

$parcel$export(module.exports, "RemoveConfirmModal", function () { return $1bd2c0d25cbdee96$export$19b1714d4f1dd11b; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $7xALQ = parcelRequire("7xALQ");

var $22v9q = parcelRequire("22v9q");
function $1bd2c0d25cbdee96$export$19b1714d4f1dd11b({ modalId: modalId, labels: labels, onConfirm: onConfirm }) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const closeModal = (0, $6uYXW.useCallback)(()=>(0, $5Wai4.Modal).dismiss(modalId), [
        modalId
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $7xALQ.WhiteModalContainer), {
        id: modalId,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($1bd2c0d25cbdee96$var$Title, {
                children: formatMessage(`${labels}.title`)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1bd2c0d25cbdee96$var$Message, {
                children: formatMessage(`${labels}.message`)
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($1bd2c0d25cbdee96$var$Buttons, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($1bd2c0d25cbdee96$var$ConfirmButton, {
                        size: "XS",
                        onClick: onConfirm,
                        children: formatMessage(`${labels}.confirmButton`)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($1bd2c0d25cbdee96$var$CancelButton, {
                        size: "XS",
                        onClick: closeModal,
                        children: formatMessage(`${labels}.cancelButton`)
                    })
                ]
            })
        ]
    });
}
const $1bd2c0d25cbdee96$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $1bd2c0d25cbdee96$var$Message = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).text};
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 19px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $1bd2c0d25cbdee96$var$Buttons = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;
const $1bd2c0d25cbdee96$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  width: 100%;
  padding: 13px;
  box-shadow: none;
`;
/* Outlined, not a plain white fill: DefaultButton clears the border, so it is set back here. */ const $1bd2c0d25cbdee96$var$CancelButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))`
  width: 100%;
  padding: 13px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  box-shadow: none;
  color: ${(0, $22v9q.theme).colors.blue[700]};

  &:focus,
  &:active,
  &:hover {
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }
`;

});

parcelRegister("gugUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aab222df9d3eed68$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $gALIi = parcelRequire("gALIi");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $4uih4 = parcelRequire("4uih4");

var $4RaAR = parcelRequire("4RaAR");

var $74ijb = parcelRequire("74ijb");

var $eHurR = parcelRequire("eHurR");

var $gDlNU = parcelRequire("gDlNU");

var $bkg9q = parcelRequire("bkg9q");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $5rJrd = parcelRequire("5rJrd");

var $k5s21 = parcelRequire("k5s21");

var $39jSd = parcelRequire("39jSd");

var $9mlIh = parcelRequire("9mlIh");

var $22v9q = parcelRequire("22v9q");
const $aab222df9d3eed68$var$emptyAdditionalData = {
    key: "",
    value: null
};
function $aab222df9d3eed68$export$2e2bcd8739ae039(props) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { transaction: transaction, spending: spending, onSuccess: onSuccess } = props;
    const [error, setError] = (0, $6uYXW.useState)("");
    const [isLoading, setIsLoading] = (0, $6uYXW.useState)(false);
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState({
        ...(0, $gALIi.cloneDeep)(spending),
        additionalData: spending?.additionalData && spending.additionalData.length ? [
            ...spending?.additionalData
        ] : [
            $aab222df9d3eed68$var$emptyAdditionalData
        ]
    });
    const { categories: categories, additionalData: additionalData } = (0, $74ijb.useCategorizations)();
    const subcategories = value.category ? categories?.find((category)=>category.id === value.category?.id)?.subCategories || [] : [];
    (0, $6uYXW.useEffect)(()=>{
        setValue({
            ...(0, $gALIi.cloneDeep)(spending),
            additionalData: spending?.additionalData && spending.additionalData.length ? [
                ...spending?.additionalData
            ] : [
                $aab222df9d3eed68$var$emptyAdditionalData
            ]
        });
    }, [
        spending
    ]);
    const isDataValid = ()=>{
        if (!(0, $gDlNU.isDefined)(value.category?.id) || !(0, $gDlNU.isDefined)(value.subcategory?.id) || !(0, $gDlNU.isDefined)(value.label)) return false;
        return true;
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (transaction) {
            setError("");
            setIsLoading(true);
            try {
                if (value.id) {
                    const dataValues = value.additionalData?.map((data)=>({
                            key: data.key,
                            value: data.value || null
                        })) || [];
                    const dataValueToDelete = spending.additionalData?.filter((data)=>!dataValues.some((value)=>value.key === data.key)).map((data)=>data.key);
                    if (dataValueToDelete && dataValueToDelete.length > 0) dataValueToDelete.forEach((key)=>{
                        dataValues.push({
                            key: key,
                            value: null
                        });
                    });
                    const url = (0, $eHurR.getUrlFromLink)(spending.links, (0, $4uih4.SpendingLinks).Update);
                    await (0, $kqXxS.spendingsManager).updateSpendingDetails(transaction.id, value.id, {
                        label: value.label != spending.label ? value.label : undefined,
                        categoryId: value.category?.id || undefined,
                        subcategoryId: value.subcategory?.id || undefined,
                        amount: value.amount !== spending.amount ? value.amount : undefined,
                        additionalData: dataValues.length > 0 ? dataValues.filter((d)=>!!d.key) : undefined
                    }, url);
                } else if (value.category?.id && value.subcategory?.id) {
                    const dataValues = value.additionalData?.filter((dataValue)=>dataValue.key.length > 0) || [];
                    if (!isDataValid()) return;
                    const url = (0, $eHurR.getUrlFromLink)(transaction.links, (0, $4RaAR.TransactionLinks).AddSpending);
                    await (0, $kqXxS.spendingsManager).addSpendingDetails(transaction.id, {
                        categoryId: value.category?.id,
                        subcategoryId: value.subcategory?.id,
                        label: value.label,
                        amount: value.amount,
                        additionalData: dataValues.length > 0 ? dataValues.filter((d)=>!!d.key) : undefined
                    }, url);
                }
                onSuccess();
            } catch (e) {
                setError(e);
            } finally{
                setIsLoading(false);
            }
        }
    };
    const handleChange = (e)=>{
        setValue({
            ...value,
            [e.target.id]: e.target.value
        });
    };
    const handleValueChange = (val, key)=>{
        setValue({
            ...value,
            [key]: val,
            ...key === "category" && {
                subcategory: null
            }
        });
    };
    const handleAddAdditionalData = ()=>{
        const additionalData = value.additionalData || [];
        setValue({
            ...value,
            additionalData: [
                ...additionalData,
                $aab222df9d3eed68$var$emptyAdditionalData
            ]
        });
    };
    const handleAdditionalDataChange = (val, index, key)=>{
        const additionalData = value.additionalData ? [
            ...value.additionalData
        ] : [];
        additionalData[index] = {
            ...additionalData[index],
            ...key === "value" && {
                value: val
            },
            ...key === "key" && {
                ...val
            }
        };
        setValue({
            ...value,
            additionalData: [
                ...additionalData
            ]
        });
    };
    const availableAdditionalData = (selectedAdditionalData)=>{
        const availableAdditionalData = additionalData?.filter((data)=>!value.additionalData?.some((val)=>val.key === data.key && val.key !== selectedAdditionalData?.key));
        return [
            {
                value: null,
                label: "-",
                key: ""
            },
            ...availableAdditionalData
        ];
    };
    const canAddAnotherAdditionalData = value.additionalData ? value.additionalData?.length < additionalData.length : true;
    const isLastAdditionalDataSet = value.additionalData && value.additionalData.length > 0 ? !!value.additionalData[value.additionalData.length - 1].key && !!value.additionalData[value.additionalData.length - 1].value : true;
    const addDisable = !isDataValid() || !isLastAdditionalDataSet || !canAddAnotherAdditionalData;
    return /*#__PURE__*/ (0, $4m918.jsxs)("form", {
        onSubmit: handleSubmit,
        style: {
            ...isLoading && {
                opacity: 0.5,
                pointerEvents: "none"
            }
        },
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$Title, {
                children: formatMessage(!value.id ? "justifyScreen.spendings.addModal.title" : "justifyScreen.spendings.addModal.editTitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$Message, {
                children: formatMessage("justifyScreen.spendings.addModal.message")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($aab222df9d3eed68$var$FormFieldWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        htmlFor: "label",
                        label: "justifyScreen.spendings.addForm.titleLabel",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        id: "label",
                        value: value.label,
                        required: true,
                        onChange: handleChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($aab222df9d3eed68$var$FormFieldWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        htmlFor: "amount",
                        label: "justifyScreen.spendings.addForm.amountLabel",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $5rJrd.AmountInput), {
                        variant: "big",
                        id: "amount",
                        value: value.amount,
                        onChange: (val)=>handleValueChange(val, "amount"),
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($aab222df9d3eed68$var$FormFieldWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        htmlFor: "category",
                        label: "justifyScreen.spendings.addForm.categoryLabel",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$CategorySelectInput, {
                        innerId: "category",
                        value: value.category,
                        options: [
                            {
                                id: null,
                                label: "-"
                            },
                            ...categories
                        ],
                        onChange: (val)=>handleValueChange(val, "category"),
                        itemRenderer: (v)=>v?.label ?? v?.id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($aab222df9d3eed68$var$FormFieldWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        htmlFor: "subcategory",
                        label: "justifyScreen.spendings.addForm.subcategoryLabel",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$CategorySelectInput, {
                        disabled: !value.category,
                        innerId: "subcategory",
                        value: value.subcategory,
                        options: [
                            {
                                id: null,
                                label: "-"
                            },
                            ...subcategories
                        ],
                        onChange: (val)=>handleValueChange(val, "subcategory"),
                        itemRenderer: (v)=>v?.label ?? v?.id
                    })
                ]
            }),
            !!value.category && !!value.subcategory && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    value.additionalData?.map((data, index)=>/*#__PURE__*/ (0, $4m918.jsxs)($aab222df9d3eed68$var$FormFieldWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                    htmlFor: `additional_data_key_${index}`,
                                    label: "justifyScreen.spendings.addForm.additionalDataLabel"
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$AdditionalDataStyledSelectInput, {
                                    innerId: `additional_data_key_${index}`,
                                    value: data,
                                    options: availableAdditionalData(data),
                                    onChange: (val)=>handleAdditionalDataChange(val, index, "key"),
                                    itemRenderer: (v)=>v?.label ?? v?.key
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$StyledAdditionalDataTextInput, {
                                    id: `additional_data_value_${index}`,
                                    value: data.value || "",
                                    onChange: (e)=>handleAdditionalDataChange(e.target.value, index, "value")
                                })
                            ]
                        }, index)),
                    /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$AddAdditionalDataButton, {
                        disabled: addDisable,
                        onClick: handleAddAdditionalData,
                        children: formatMessage("justifyScreen.spendings.addForm.addAdditionalDataButton")
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$StyledErrorMessage, {
                children: error
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($aab222df9d3eed68$var$SubmitButton, {
                disabled: !isDataValid(),
                size: "M",
                type: "submit",
                children: value.id ? formatMessage("justifyScreen.spendings.addModal.editButton") : formatMessage("justifyScreen.spendings.addModal.createButton")
            })
        ]
    });
}
const $aab222df9d3eed68$var$AddAdditionalDataButton = (0, $jb8NR.default)((0, $bkg9q.default))`
  margin-top: 16px;
`;
const $aab222df9d3eed68$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText};
  margin: 16px 0 0;
  text-align: left;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
/* Announces the block of fields, the way the sections of the justification screen do. */ const $aab222df9d3eed68$var$Message = (0, $jb8NR.default).h3`
  ${(0, $22v9q.theme).mediumText};
  margin: 28px 0 16px;
  text-align: left;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
/* The shared inputs keep their own look everywhere else; the panel outlines them here. */ const $aab222df9d3eed68$var$FormFieldWrapper = (0, $jb8NR.default).div`
  margin-bottom: 16px;

  label {
    ${(0, $22v9q.theme).text};
    font-size: 14px;
    line-height: 18px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }

  /* Each field brings its own padded box; only the outline and the full width are missing. */
  > div {
    width: 100%;
    border: 1px solid ${(0, $22v9q.theme).colors.gray[300]};
    border-radius: 8px;
    background-color: #ffffff;
  }

  input {
    ${(0, $22v9q.theme).text};
    font-size: 15px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }

  /* react-select draws a box of its own inside ours. */
  [class*="-control"] {
    border: 0;
    box-shadow: none;
  }
`;
const $aab222df9d3eed68$var$AdditionalDataStyledSelectInput = (0, $jb8NR.default)((0, $39jSd.SelectInput))`
  width: 100%;
`;
const $aab222df9d3eed68$var$CategorySelectInput = (0, $jb8NR.default)((0, $39jSd.SelectInput))`
  width: 100%;
`;
const $aab222df9d3eed68$var$StyledAdditionalDataTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  margin-top: 1rem;
`;
const $aab222df9d3eed68$var$SubmitButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  min-width: 250px;
  margin: 28px auto 0;
  padding: 13px 28px;
  box-shadow: none;
`;
const $aab222df9d3eed68$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 16px;
`;

});
parcelRegister("74ijb", function(module, exports) {

$parcel$export(module.exports, "useCategorizations", function () { return $da58f7beb47a1a0e$export$2428fb41a9d540fa; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $da58f7beb47a1a0e$export$2428fb41a9d540fa = (loadAtStartup = true)=>{
    const categories = (0, $3Ersk.useObservable)((0, $kqXxS.categorizationsManager).categories);
    const additionalData = (0, $3Ersk.useObservable)((0, $kqXxS.categorizationsManager).additionalData);
    const [loading, setLoading] = (0, $6uYXW.useState)(true);
    const [error, setError] = (0, $6uYXW.useState)("");
    const load = async (forceRefresh = false)=>{
        try {
            setError("");
            setLoading(true);
            await (0, $kqXxS.categorizationsManager).load(forceRefresh);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            setError(e);
            (0, $6JVVB.logger).debug("UseCategorization: error fetching catgorization", e);
        }
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (loadAtStartup) await load();
    }, []);
    return {
        categories: categories,
        additionalData: additionalData,
        load: load,
        loading: loading,
        error: error
    };
};

});


parcelRegister("hX57i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $069a5e3b6dcaf54e$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $bZlaH = parcelRequire("bZlaH");

var $22v9q = parcelRequire("22v9q");
function $069a5e3b6dcaf54e$export$2e2bcd8739ae039(props) {
    const { spending: spending } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($069a5e3b6dcaf54e$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($069a5e3b6dcaf54e$var$Title, {
                        children: spending.label
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($069a5e3b6dcaf54e$var$Category, {
                        children: [
                            spending.category.label || spending.category.id,
                            " - ",
                            spending.subcategory.label || spending.subcategory.id
                        ]
                    })
                ]
            }),
            !!spending.amount && /*#__PURE__*/ (0, $4m918.jsx)($069a5e3b6dcaf54e$var$StyledAmountText, {
                amount: spending.amount
            })
        ]
    });
}
/* The action buttons unfold over the row: the amount stops short of where they land. */ const $069a5e3b6dcaf54e$var$Wrapper = (0, $jb8NR.default).div`
  padding-right: 140px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const $069a5e3b6dcaf54e$var$Title = (0, $jb8NR.default).div`
  display: block;
`;
const $069a5e3b6dcaf54e$var$Category = (0, $jb8NR.default).div`
  display: block;
  color: ${(0, $22v9q.theme).colors.gray[500]};
  text-transform: uppercase;
  font-size: 12px;
`;
const $069a5e3b6dcaf54e$var$StyledAmountText = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).mediumText};
`;

});


parcelRegister("4RLfY", function(module, exports) {

$parcel$export(module.exports, "ExternalLoansScreen", function () { return $573db38317553728$export$a2e04f22823794d7; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");
const $573db38317553728$export$a2e04f22823794d7 = ()=>{
    const [uri, setUri] = (0, $6uYXW.useState)(undefined);
    (0, $6uYXW.useEffect)(()=>{
        if (!uri) (0, $kqXxS.authenticationManager).getAccessToken().then((accessToken)=>{
            const baseUri = (0, $dhPTb.Config).EXTERNAL_LOAN_URL;
            let loanUri = baseUri;
            if (baseUri.search("\\?") == -1) loanUri += "?";
            else loanUri += "&";
            loanUri += "noDecoration=1&";
            loanUri += "jwt=" + accessToken?.value;
            setUri(loanUri);
            (0, $6JVVB.logger).debug("URI set:", loanUri);
        }).catch((error)=>{
            (0, $6JVVB.logger).error(error);
        });
    }, []);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: uri ? /*#__PURE__*/ (0, $4m918.jsx)($573db38317553728$var$WebFrame, {
            src: uri
        }) : /*#__PURE__*/ (0, $4m918.jsx)($573db38317553728$var$Text, {
            children: "No uri"
        })
    });
};
const $573db38317553728$var$WebFrame = (0, $jb8NR.default).iframe`
  width: 100%;
  height: 860px;
  border: 0;
  border-radius: 10px;
`;
const $573db38317553728$var$Text = (0, $jb8NR.default).span``;

});

parcelRegister("je7Jr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fd92603c480b226$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");

var $ckge6 = parcelRequire("ckge6");

var $yYT9n = parcelRequire("yYT9n");

var $fHb7G = parcelRequire("fHb7G");

var $gfeLQ = parcelRequire("gfeLQ");

var $bXSbQ = parcelRequire("bXSbQ");

var $7Zu6k = parcelRequire("7Zu6k");

var $bkbe2 = parcelRequire("bkbe2");

var $39jSd = parcelRequire("39jSd");

var $gxFwH = parcelRequire("gxFwH");

var $iKBCx = parcelRequire("iKBCx");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

function $0fd92603c480b226$export$2e2bcd8739ae039() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const [ready, setReady] = (0, $6uYXW.useState)(false);
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const location = (0, $NQIVp.useLocation)();
    const hasBeenDisconnectedDueToInactivity = (0, $3Ersk.useObservable)((0, $kqXxS.authenticationManager).hasBeenDisconnectedDueToInactivity);
    const userLanguage = (0, $3Ersk.useObservable)((0, $kqXxS.i18NManager).localeTag);
    const configurationLanguages = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration).langs;
    const enrollmentEnabled = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration).enrollment;
    const history = (0, $NQIVp.useHistory)();
    const goToRegisterPage = ()=>{
        history.push(features.sdaCustomerOnboardingCreate ? (0, $4fYE4.Path).Onboarding : (0, $4fYE4.Path).Register);
    };
    // The credentials form lives on the authorization server, never here: connecting hands the
    // browser over to it and comes back through the OAuth redirect.
    const connect = ()=>{
        history.push((0, $4fYE4.Path).Root);
        (0, $kqXxS.authExecutor).connect();
    };
    (0, $6uYXW.useEffect)(()=>{
        if ((0, $kqXxS.authExecutor).withPhoneNumberAndPinCode()) history.push(`${(0, $4fYE4.Path).Connect}${location.search ? location.search : ""}`);
        else setReady(true);
    }, []);
    if (!ready) return /*#__PURE__*/ (0, $4m918.jsx)((0, $gfeLQ.BootSplash), {});
    return /*#__PURE__*/ (0, $4m918.jsxs)($0fd92603c480b226$var$Page, {
        $isRTL: isRTL,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $bXSbQ.BrandPanel), {
                children: /*#__PURE__*/ (0, $4m918.jsxs)($0fd92603c480b226$var$BrandFooter, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $bkbe2.ExternalSites), {}),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $gxFwH.StoreButtons), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($0fd92603c480b226$var$FormPanel, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($0fd92603c480b226$var$LanguageBar, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $iKBCx.GlobeIcon), {
                                width: 14,
                                height: 14
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($0fd92603c480b226$var$LanguageLabel, {
                                children: formatMessage("authScreen.languages")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                                style: {
                                    minWidth: "110px"
                                },
                                value: userLanguage,
                                innerId: "language",
                                options: configurationLanguages,
                                itemRenderer: (0, $fHb7G.getLanguageName),
                                disabledArrow: true,
                                withPointer: true,
                                onChange: (0, $ckge6.changeLanguage)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($0fd92603c480b226$var$FormCard, {
                        children: [
                            hasBeenDisconnectedDueToInactivity && /*#__PURE__*/ (0, $4m918.jsxs)($0fd92603c480b226$var$StyledAlert, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($0fd92603c480b226$var$WarningIconImage, {
                                        src: {},
                                        alt: ""
                                    }),
                                    formatMessage("authScreen.disconnectedDueToInactivity")
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($0fd92603c480b226$var$WelcomeTitle, {
                                children: formatMessage("authScreen.welcome")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($0fd92603c480b226$var$WelcomeSubtitle, {
                                children: formatMessage("authScreen.subtitle")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($0fd92603c480b226$var$Actions, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($0fd92603c480b226$var$LoginButton, {
                                        onClick: connect,
                                        size: "S",
                                        children: formatMessage("authScreen.login")
                                    }),
                                    enrollmentEnabled && /*#__PURE__*/ (0, $4m918.jsx)($0fd92603c480b226$var$CreateAccountButton, {
                                        onClick: goToRegisterPage,
                                        size: "S",
                                        children: formatMessage("authScreen.createAccount")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $0fd92603c480b226$var$Page = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: ${(props)=>props.$isRTL ? "row-reverse" : "row"};
  align-items: stretch;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
  }
`;
const $0fd92603c480b226$var$BrandFooter = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 40px;

  &:empty {
    display: none;
  }
`;
const $0fd92603c480b226$var$FormPanel = (0, $jb8NR.default).section`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 24px 32px 48px;
  background-color: #fbfbfb;
`;
const $0fd92603c480b226$var$LanguageBar = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  align-self: flex-end;
  color: ${(0, $22v9q.theme).colors.gray[700]};
`;
const $0fd92603c480b226$var$LanguageLabel = (0, $jb8NR.default).span`
  font-size: 0.8125rem;
`;
const $0fd92603c480b226$var$FormCard = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
`;
const $0fd92603c480b226$var$WelcomeTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText};
  margin: 0 0 8px;
  font-size: 32px;
  line-height: normal;
  text-align: center;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $0fd92603c480b226$var$WelcomeSubtitle = (0, $jb8NR.default).p`
  ${(0, $22v9q.theme).text};
  margin: 0 0 32px;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $0fd92603c480b226$var$Actions = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
`;
const $0fd92603c480b226$var$LoginButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  width: 100%;
`;
/* Outlined, not a plain white fill: DefaultButton clears the border, so it is set back here. */ const $0fd92603c480b226$var$CreateAccountButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))`
  width: 100%;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  box-shadow: none;
  color: ${(0, $22v9q.theme).colors.blue[700]};

  &:focus,
  &:active,
  &:hover {
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }
`;
const $0fd92603c480b226$var$StyledAlert = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).bodyGreyRegular};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  padding: 10px;
  border-radius: 10px;
  background-color: ${(0, $22v9q.theme).colors.warning[300]};
  color: ${(0, $22v9q.theme).colors.warning[500]};
  font-size: 0.875rem;
  text-align: center;
`;
const $0fd92603c480b226$var$WarningIconImage = (0, $jb8NR.default).img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

});
parcelRegister("ckge6", function(module, exports) {

$parcel$export(module.exports, "changeLanguage", function () { return $70b6edf66df5fe60$export$61465194746e7fd2; });

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");
const $70b6edf66df5fe60$export$61465194746e7fd2 = async (language)=>{
    const previousLocale = (0, $kqXxS.i18NManager).localeTag.get();
    const isAuthenticated = (0, $kqXxS.clientManager).client.get() !== null;
    try {
        await (0, $kqXxS.i18NManager).setLocale(language, true);
        if (isAuthenticated) await (0, $kqXxS.clientManager).setLanguage(language);
    } catch (e) {
        (0, $6JVVB.logger).debug("SettingsScreen", "Revert language change", e);
        await (0, $kqXxS.i18NManager).setLocale(previousLocale, true);
    }
};

});

parcelRegister("fHb7G", function(module, exports) {

$parcel$export(module.exports, "getLanguageName", function () { return $79533edc8c82e936$export$b2c54cc5f2ff61e9; });

var $kqXxS = parcelRequire("kqXxS");
const $79533edc8c82e936$export$b2c54cc5f2ff61e9 = (languageTag)=>(0, $kqXxS.i18NManager).formatMessage(`common.languages.${languageTag}`);

});

parcelRegister("gfeLQ", function(module, exports) {

$parcel$export(module.exports, "BootSplash", function () { return $6fbe8659f8b84d7e$export$7712a31b25c842dc; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");
function $6fbe8659f8b84d7e$export$7712a31b25c842dc() {
    return /*#__PURE__*/ (0, $4m918.jsx)($6fbe8659f8b84d7e$var$Screen, {
        children: /*#__PURE__*/ (0, $4m918.jsx)($6fbe8659f8b84d7e$var$SplashLogo, {
            src: (0, $fRvTz.StaticAssets).brandLogo,
            alt: ""
        })
    });
}
const $6fbe8659f8b84d7e$var$Screen = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  width: 100%;
  min-height: 100vh;
  background: ${(0, $22v9q.theme).brandGradient};
`;
const $6fbe8659f8b84d7e$var$SplashLogo = (0, $jb8NR.default).img`
  width: 280px;
  max-width: 60%;
  object-fit: contain;
`;

});

parcelRegister("iKBCx", function(module, exports) {

$parcel$export(module.exports, "GlobeIcon", function () { return $faee1b3d9e4cabfb$export$a70e2e549144f66; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $faee1b3d9e4cabfb$export$a70e2e549144f66(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            stroke: props.stroke ?? "currentColor",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                    cx: "8",
                    cy: "8",
                    r: "6.4"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M8 1.6c1.7 1.75 2.6 4.05 2.6 6.4S9.7 12.65 8 14.4"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M8 1.6C6.3 3.35 5.4 5.65 5.4 8s.9 4.65 2.6 6.4"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M2.1 5.9h11.8M2.1 10.1h11.8"
                })
            ]
        })
    });
}

});


parcelRegister("ePc1F", function(module, exports) {

$parcel$export(module.exports, "OAuthLoadingScreen", function () { return $4a1f480fef949a3a$export$71015d1d6f4bea06; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $4fYE4 = parcelRequire("4fYE4");

var $8Az26 = parcelRequire("8Az26");

var $k4kME = parcelRequire("k4kME");

var $jNOeu = parcelRequire("jNOeu");
const $4a1f480fef949a3a$export$71015d1d6f4bea06 = ()=>{
    const parsed = (0, $8Az26.useConnectFromRedirect)();
    const [redirectToLogin, setRedirectToLogin] = (0, $6uYXW.useState)(false);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return parsed.error ? redirectToLogin ? /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
        to: {
            pathname: (0, $4fYE4.Path).Root
        }
    }) : /*#__PURE__*/ (0, $4m918.jsx)("div", {
        style: {
            margin: "auto"
        },
        children: /*#__PURE__*/ (0, $4m918.jsx)($4a1f480fef949a3a$var$AuthenticationError, {
            type: "error",
            title: formatMessage("authScreen.authenticationFailure.title"),
            onConfirm: function() {
                setRedirectToLogin(true);
            }
        })
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
        size: "60px",
        style: {
            margin: "auto"
        }
    });
};
const $4a1f480fef949a3a$var$AuthenticationError = (0, $jb8NR.default)((0, $jNOeu.ResultView))``;

});
parcelRegister("8Az26", function(module, exports) {

$parcel$export(module.exports, "useConnectFromRedirect", function () { return $d6c905f492052bed$export$13b1164512f0f4c1; });

var $bmarz = parcelRequire("bmarz");

var $NQIVp = parcelRequire("NQIVp");

var $kqXxS = parcelRequire("kqXxS");

var $k4Ecv = parcelRequire("k4Ecv");
const $d6c905f492052bed$export$13b1164512f0f4c1 = ()=>{
    const location = (0, $NQIVp.useLocation)().search;
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($bmarz))).parse(location);
    const { code: code, state: state } = parsed;
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (typeof code === "string" && typeof state === "string") await (0, $kqXxS.authExecutor).authenticateFromRedirect(code, state);
    }, [
        code,
        state
    ]);
    return parsed;
};

});
parcelRegister("bmarz", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $8449d9ad24161eb4$export$f9380c9a627682d3; }, function (v) { return $8449d9ad24161eb4$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $8449d9ad24161eb4$export$98e6a39c04603d36; }, function (v) { return $8449d9ad24161eb4$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $8449d9ad24161eb4$export$fac44ee5b035f737; }, function (v) { return $8449d9ad24161eb4$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $8449d9ad24161eb4$export$7a5253c0f62e0150; }, function (v) { return $8449d9ad24161eb4$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $8449d9ad24161eb4$export$a8c1621ea79325d3; }, function (v) { return $8449d9ad24161eb4$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $8449d9ad24161eb4$export$357523c63a2253b9; }, function (v) { return $8449d9ad24161eb4$export$357523c63a2253b9 = v; });
$parcel$export(module.exports, "exclude", function () { return $8449d9ad24161eb4$export$44c361b8ec72ef7f; }, function (v) { return $8449d9ad24161eb4$export$44c361b8ec72ef7f = v; });
var $8449d9ad24161eb4$export$f9380c9a627682d3;
var $8449d9ad24161eb4$export$98e6a39c04603d36;
var $8449d9ad24161eb4$export$fac44ee5b035f737;
var $8449d9ad24161eb4$export$7a5253c0f62e0150;
var $8449d9ad24161eb4$export$a8c1621ea79325d3;
var $8449d9ad24161eb4$export$357523c63a2253b9;
var $8449d9ad24161eb4$export$44c361b8ec72ef7f;
'use strict';

var $ikIcu = parcelRequire("ikIcu");

var $jXfin = parcelRequire("jXfin");

var $8RYpW = parcelRequire("8RYpW");

var $1iDG9 = parcelRequire("1iDG9");
const $8449d9ad24161eb4$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $8449d9ad24161eb4$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $8449d9ad24161eb4$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $8449d9ad24161eb4$var$encode(key, options),
                            '[',
                            $8449d9ad24161eb4$var$encode(index, options),
                            ']=',
                            $8449d9ad24161eb4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $8449d9ad24161eb4$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $8449d9ad24161eb4$var$encode(key, options),
                            '[]=',
                            $8449d9ad24161eb4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $8449d9ad24161eb4$var$encode(key, options),
                            '=',
                            $8449d9ad24161eb4$var$encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            $8449d9ad24161eb4$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $8449d9ad24161eb4$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $8449d9ad24161eb4$var$encode(key, options),
                            '=',
                            $8449d9ad24161eb4$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $8449d9ad24161eb4$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $8449d9ad24161eb4$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $8449d9ad24161eb4$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$8449d9ad24161eb4$var$decode(item, options)) : value === null ? value : $8449d9ad24161eb4$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $8449d9ad24161eb4$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $8449d9ad24161eb4$var$encode(value, options) {
    if (options.encode) return options.strict ? $ikIcu(value) : encodeURIComponent(value);
    return value;
}
function $8449d9ad24161eb4$var$decode(value, options) {
    if (options.decode) return $jXfin(value);
    return value;
}
function $8449d9ad24161eb4$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $8449d9ad24161eb4$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $8449d9ad24161eb4$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $8449d9ad24161eb4$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $8449d9ad24161eb4$var$extract(input) {
    input = $8449d9ad24161eb4$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $8449d9ad24161eb4$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $8449d9ad24161eb4$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $8449d9ad24161eb4$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $8449d9ad24161eb4$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $8RYpW(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : $8449d9ad24161eb4$var$decode(value, options);
        formatter($8449d9ad24161eb4$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $8449d9ad24161eb4$var$parseValue(value[k], options);
        else ret[key] = $8449d9ad24161eb4$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $8449d9ad24161eb4$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$8449d9ad24161eb4$export$f9380c9a627682d3 = $8449d9ad24161eb4$var$extract;
$8449d9ad24161eb4$export$98e6a39c04603d36 = $8449d9ad24161eb4$var$parse;
$8449d9ad24161eb4$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $8449d9ad24161eb4$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $8449d9ad24161eb4$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $8449d9ad24161eb4$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $8449d9ad24161eb4$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return $8449d9ad24161eb4$var$encode(key, options) + '=' + $8449d9ad24161eb4$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$8449d9ad24161eb4$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $8RYpW(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $8449d9ad24161eb4$var$parse($8449d9ad24161eb4$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $8449d9ad24161eb4$var$decode(hash, options)
    } : {});
};
$8449d9ad24161eb4$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $8449d9ad24161eb4$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $8449d9ad24161eb4$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $8449d9ad24161eb4$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $8449d9ad24161eb4$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $8449d9ad24161eb4$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$8449d9ad24161eb4$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$8449d9ad24161eb4$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $8449d9ad24161eb4$export$7a5253c0f62e0150(input, options);
    return $8449d9ad24161eb4$export$a8c1621ea79325d3({
        url: url,
        query: $1iDG9(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$8449d9ad24161eb4$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $8449d9ad24161eb4$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("ikIcu", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("jXfin", function(module, exports) {
'use strict';
var $e86f645ce02a525a$var$token = '%[a-f0-9]{2}';
var $e86f645ce02a525a$var$singleMatcher = new RegExp('(' + $e86f645ce02a525a$var$token + ')|([^%]+?)', 'gi');
var $e86f645ce02a525a$var$multiMatcher = new RegExp('(' + $e86f645ce02a525a$var$token + ')+', 'gi');
function $e86f645ce02a525a$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $e86f645ce02a525a$var$decodeComponents(left), $e86f645ce02a525a$var$decodeComponents(right));
}
function $e86f645ce02a525a$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($e86f645ce02a525a$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $e86f645ce02a525a$var$decodeComponents(tokens, i).join('');
            tokens = input.match($e86f645ce02a525a$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e86f645ce02a525a$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $e86f645ce02a525a$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $e86f645ce02a525a$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e86f645ce02a525a$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $e86f645ce02a525a$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("8RYpW", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("1iDG9", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("3n4vt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dad0fc526d701cf1$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $hppbX = parcelRequire("hppbX");

var $4MCqd = parcelRequire("4MCqd");

var $3Ersk = parcelRequire("3Ersk");

var $bQhUC = parcelRequire("bQhUC");

var $yYT9n = parcelRequire("yYT9n");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $amCCH = parcelRequire("amCCH");

var $363yo = parcelRequire("363yo");

var $65fA6 = parcelRequire("65fA6");

var $bqp4F = parcelRequire("bqp4F");

var $1LXCJ = parcelRequire("1LXCJ");

var $d27e0 = parcelRequire("d27e0");
const $dad0fc526d701cf1$var$MandatesScreen = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { mandates: mandates, canLoadMore: canLoadMore, loadMore: loadMore, refresh: refresh } = (0, $4MCqd.default)((0, $kqXxS.mandatesManager));
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const mandateStatusSelection = (0, $3Ersk.useObservable)((0, $kqXxS.mandateFilterManager).statusSelection);
    const handleMandateOppose = (mandate)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.OPPOSE_MANDATE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $d27e0.OpposeMandateModal), {
                mandate: mandate,
                onConfirm: async ()=>{
                    await (0, $kqXxS.mandatesManager).opposeMandate(mandate.id);
                    refresh();
                }
            }), {
            canBeDismissed: true
        });
    };
    const handleMandateActivate = (mandate)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.ACTIVATE_MANDATE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $363yo.ActivateMandateModal), {
                mandate: mandate,
                onConfirm: async ()=>{
                    await (0, $kqXxS.mandatesManager).activateMandate(mandate.id);
                    refresh();
                }
            }), {
            canBeDismissed: true
        });
    };
    const handleMandateClick = (mandate)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.DETAIL_MANDATE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $65fA6.DetailMandateModal), {
                mandate: mandate
            }), {
            canBeDismissed: false
        });
    };
    const filteredMandates = ()=>{
        if (mandateStatusSelection === (0, $hppbX.MandateStatus).ALL) return mandates;
        else return mandates.filter((mandate)=>mandate.status === mandateStatusSelection);
    };
    const filteredMandatesList = filteredMandates();
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $amCCH.PageHeader), {
                title: formatMessage("mandatesSubmenu.mandates"),
                description: formatMessage("mandates.description")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $bqp4F.FilterBar), {
                isRTL: isRTL
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($dad0fc526d701cf1$var$MandatesWrapper, {
                children: filteredMandatesList.map((mandate)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $1LXCJ.MandateItem), {
                        mandate: mandate,
                        handleMandateOppose: handleMandateOppose,
                        handleMandateActivate: handleMandateActivate,
                        handleMandateDetail: ()=>handleMandateClick(mandate)
                    }, mandate.id))
            }),
            canLoadMore && /*#__PURE__*/ (0, $4m918.jsx)($dad0fc526d701cf1$var$LoadMore, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                    size: "S",
                    onClick: loadMore,
                    children: formatMessage("upcomingTransfers.loadMore")
                })
            })
        ]
    });
};
const $dad0fc526d701cf1$var$MandatesWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $dad0fc526d701cf1$var$LoadMore = (0, $jb8NR.default).div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
`;
var $dad0fc526d701cf1$export$2e2bcd8739ae039 = $dad0fc526d701cf1$var$MandatesScreen;

});
parcelRegister("4MCqd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b56483d2dc2c92$export$2e2bcd8739ae039; });

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $k4Ecv = parcelRequire("k4Ecv");
function $75b56483d2dc2c92$export$2e2bcd8739ae039(mandatesManager) {
    const paginatedMandates = (0, $hngyi.useObservablePaginated)(mandatesManager.paginatedMandates);
    const canLoadMore = (0, $3Ersk.useObservable)(mandatesManager.canLoadMore);
    const isLoading = (0, $3Ersk.useObservable)(mandatesManager.isLoading);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await mandatesManager.getMandates();
    }, []);
    return {
        mandates: paginatedMandates.items,
        canLoadMore: canLoadMore,
        isLoading: isLoading,
        refresh: async ()=>await mandatesManager.getMandates(),
        getMandates: async ()=>await mandatesManager.getMandates(),
        loadMore: async ()=>await mandatesManager.loadMore()
    };
}

});

parcelRegister("363yo", function(module, exports) {

$parcel$export(module.exports, "ActivateMandateModal", function () { return $9271c16819884f35$export$ccfe3bf54197fe83; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $bQhUC = parcelRequire("bQhUC");

var $3bC3z = parcelRequire("3bC3z");
const $9271c16819884f35$export$ccfe3bf54197fe83 = (props)=>{
    const { mandate: mandate, onConfirm: onConfirm } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $3bC3z.MandateModal), {
        mandate: mandate,
        onConfirm: onConfirm,
        modalId: (0, $bQhUC.ACTIVATE_MANDATE_MODAL_ID),
        textPrompt: "mandates.activatePrompt"
    });
};

});
parcelRegister("3bC3z", function(module, exports) {

$parcel$export(module.exports, "MandateModal", function () { return $87b356bac96d4e86$export$f9ec43dc0528ef12; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $22v9q = parcelRequire("22v9q");
const $87b356bac96d4e86$export$f9ec43dc0528ef12 = (props)=>{
    const { mandate: mandate, onConfirm: onConfirm, modalId: modalId, textPrompt: textPrompt } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const closeModal = ()=>{
        (0, $5Wai4.Modal).dismiss(modalId);
    };
    const handleConfirm = ()=>{
        onConfirm();
        closeModal();
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($87b356bac96d4e86$var$ModalContainer, {
        closeButton: true,
        id: modalId,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($87b356bac96d4e86$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsxs)($87b356bac96d4e86$var$Title, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)("span", {
                            children: formatMessage(textPrompt + ".title.first")
                        }),
                        " ",
                        formatMessage(textPrompt + ".title.second")
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($87b356bac96d4e86$var$Message, {
                    children: formatMessage(textPrompt + ".message", {
                        reference: mandate.reference,
                        creditorName: mandate.creditorName
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($87b356bac96d4e86$var$ConfirmButton, {
                    size: "M",
                    onClick: handleConfirm,
                    children: formatMessage("mandates.confirmButton")
                })
            ]
        })
    });
};
const $87b356bac96d4e86$var$ModalContainer = (0, $jb8NR.default)((0, $iy3Ex.RoundedModalContainer))``;
const $87b356bac96d4e86$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 56px;
`;
const $87b356bac96d4e86$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.fonts).bold}
  font-size: 1.5rem;
  color: #000000;
  span {
    color: ${(0, $22v9q.theme).colors.success[500]};
  }
`;
const $87b356bac96d4e86$var$Message = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  color: black;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  text-align: center;
  margin: 48px 10px 15px;
`;
const $87b356bac96d4e86$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 30px;
  margin-bottom: 30px;
`;

});


parcelRegister("65fA6", function(module, exports) {

$parcel$export(module.exports, "DetailMandateModal", function () { return $f89ddac70a5e1e03$export$a485f5a81a02e5f8; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $iy3Ex = parcelRequire("iy3Ex");

var $l7Adx = parcelRequire("l7Adx");

var $imHf4 = parcelRequire("imHf4");
const $f89ddac70a5e1e03$export$a485f5a81a02e5f8 = ({ mandate: mandate })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.DETAIL_MANDATE_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Container), {
            children: [
                /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Header), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Title), {
                            children: formatMessage("mandates.details.to") + " " + mandate?.creditorName
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Status), {
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $imHf4.MandateStatusPill), {
                                status: mandate?.status
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Section), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.SectionTitle), {
                            children: formatMessage("mandates.details.mandateDetails")
                        }),
                        mandate?.reference && /*#__PURE__*/ (0, $4m918.jsx)($f89ddac70a5e1e03$var$Field, {
                            label: formatMessage("mandates.details.reference"),
                            children: mandate.reference
                        }),
                        mandate?.id && /*#__PURE__*/ (0, $4m918.jsx)($f89ddac70a5e1e03$var$Field, {
                            label: formatMessage("mandates.details.id"),
                            children: mandate.id
                        }),
                        mandate?.signatureDate && /*#__PURE__*/ (0, $4m918.jsx)($f89ddac70a5e1e03$var$Field, {
                            label: formatMessage("mandates.details.signatureDate"),
                            children: formatDate(mandate.signatureDate, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Section), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.SectionTitle), {
                            children: formatMessage("mandates.details.creditorDetails")
                        }),
                        mandate?.creditorRef && /*#__PURE__*/ (0, $4m918.jsx)($f89ddac70a5e1e03$var$Field, {
                            label: formatMessage("mandates.details.creditorRef"),
                            children: mandate.creditorRef
                        })
                    ]
                }),
                mandate?.originalMandate && /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Section), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.SectionTitle), {
                            children: formatMessage("mandates.details.accountInformation")
                        }),
                        mandate?.originalMandate?.debtorIban && /*#__PURE__*/ (0, $4m918.jsx)($f89ddac70a5e1e03$var$Field, {
                            label: formatMessage("mandates.details.accountIban"),
                            children: mandate.originalMandate.debtorIban
                        }),
                        mandate?.originalMandate?.debtorBic && /*#__PURE__*/ (0, $4m918.jsx)($f89ddac70a5e1e03$var$Field, {
                            label: formatMessage("mandates.details.accountBic"),
                            children: mandate.originalMandate.debtorBic
                        })
                    ]
                })
            ]
        })
    });
};
const $f89ddac70a5e1e03$var$Field = ({ label: label, children: children, className: className })=>/*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.SectionContent), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Result), {
                children: children
            })
        ]
    });

});
parcelRegister("l7Adx", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $bd96c53c488a8f81$export$f99233281efd08a0; });
$parcel$export(module.exports, "Header", function () { return $bd96c53c488a8f81$export$8b251419efc915eb; });
$parcel$export(module.exports, "Status", function () { return $bd96c53c488a8f81$export$96e9906d6d93a972; });
$parcel$export(module.exports, "Section", function () { return $bd96c53c488a8f81$export$6e2c8f0811a474ce; });
$parcel$export(module.exports, "SectionTitle", function () { return $bd96c53c488a8f81$export$69bc41ee738923ec; });
$parcel$export(module.exports, "SectionContent", function () { return $bd96c53c488a8f81$export$51a9c37cab91cff6; });
$parcel$export(module.exports, "Label", function () { return $bd96c53c488a8f81$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Result", function () { return $bd96c53c488a8f81$export$8fdcabde73f49165; });
$parcel$export(module.exports, "Container", function () { return $bd96c53c488a8f81$export$42a852a2b6b56249; });

var $jb8NR = parcelRequire("jb8NR");
const $bd96c53c488a8f81$export$f99233281efd08a0 = (0, $jb8NR.default).h2`
  margin-bottom: 20px;
`;
const $bd96c53c488a8f81$export$8b251419efc915eb = (0, $jb8NR.default).section`
  display: flex;
  align-items: center;
`;
const $bd96c53c488a8f81$export$96e9906d6d93a972 = (0, $jb8NR.default).div`
  height: 25px;
  margin: 5px 0 0 10px;
`;
const $bd96c53c488a8f81$export$6e2c8f0811a474ce = (0, $jb8NR.default).div`
  margin-top: 30px;
`;
const $bd96c53c488a8f81$export$69bc41ee738923ec = (0, $jb8NR.default).h3`
  margin-bottom: 10px;
  font-size: 17px;
`;
const $bd96c53c488a8f81$export$51a9c37cab91cff6 = (0, $jb8NR.default).div`
  margin: 0 0 5px;
  line-height: 22px;
`;
const $bd96c53c488a8f81$export$b04be29aa201d4f5 = (0, $jb8NR.default).span`
  display: block;
  font-size: 14px;
  color: #adadad;
  font-weight: 700;
`;
const $bd96c53c488a8f81$export$8fdcabde73f49165 = (0, $jb8NR.default).span`
  font-size: 13px;
  display: block;
`;
const $bd96c53c488a8f81$export$42a852a2b6b56249 = (0, $jb8NR.default).section`
  padding: 10px 20px;
`;

});

parcelRegister("imHf4", function(module, exports) {

$parcel$export(module.exports, "MandateStatusPill", function () { return $b510be97507cf2ee$export$d26cf1b744d0ab20; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $hppbX = parcelRequire("hppbX");

var $gWF5T = parcelRequire("gWF5T");

var $22v9q = parcelRequire("22v9q");
const $b510be97507cf2ee$export$d26cf1b744d0ab20 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const matchingStatus = (0, $hppbX.MANDATES_STATUSES)[status];
    const style = matchingStatus?.color && (0, $gWF5T.getMandateStatusStyles)(matchingStatus?.color, (0, $22v9q.theme));
    return /*#__PURE__*/ (0, $4m918.jsx)($b510be97507cf2ee$var$StyledMandateStatusPill, {
        style: style,
        children: formatMessage(matchingStatus.label)
    });
};
const $b510be97507cf2ee$var$StyledMandateStatusPill = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText}
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 4px 10px 4px 7px;
  border-radius: 20px;
  &::before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
    background-color: currentColor;
  }
`;

});
parcelRegister("gWF5T", function(module, exports) {

$parcel$export(module.exports, "getMandateStatusStyles", function () { return $66bd26f20f503a05$export$86e649c0cddb7772; });

var $hppbX = parcelRequire("hppbX");
function $66bd26f20f503a05$export$86e649c0cddb7772(status, theme) {
    switch(status){
        case (0, $hppbX.MandateStatusColor).SUCCESS:
            return {
                color: theme.colors.success[500],
                backgroundColor: theme.colors.success[100]
            };
        case (0, $hppbX.MandateStatusColor).WARNING:
            return {
                color: theme.colors.warning[500],
                backgroundColor: theme.colors.warning[100]
            };
        case (0, $hppbX.MandateStatusColor).GRAY:
            return {
                color: theme.colors.gray[500],
                backgroundColor: theme.colors.gray[100]
            };
        default:
            return;
    }
}

});



parcelRegister("bqp4F", function(module, exports) {

$parcel$export(module.exports, "FilterBar", function () { return $c927f36543e6ea4e$export$56a20ec2552ffba2; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $7XqbX = parcelRequire("7XqbX");

var $eGj3r = parcelRequire("eGj3r");
const $c927f36543e6ea4e$export$56a20ec2552ffba2 = (props)=>{
    const { isRTL: isRTL } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($c927f36543e6ea4e$var$FilterBarContainer, {
        $isRTL: isRTL,
        children: /*#__PURE__*/ (0, $4m918.jsx)($c927f36543e6ea4e$var$StyledMandatesStatusFilter, {
            $isRTL: isRTL
        })
    });
};
const $c927f36543e6ea4e$var$StyledMandatesStatusFilter = (0, $jb8NR.default)((0, $eGj3r.MandatesStatusFilter))`
  margin-left: ${(props)=>props.$isRTL ? 10 : 0}px;
  margin-right: ${(props)=>props.$isRTL ? 0 : 10}px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-right: 0px;
    margin-left: 0px;
    margin-bottom: 10px;
  }
`;
const $c927f36543e6ea4e$var$FilterBarContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props)=>props.$isRTL ? 0 : 10}px;
  margin-right: ${(props)=>props.$isRTL ? 10 : 0}px;
  margin-top: 30px;
  margin-bottom: 10px;

  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
    margin-left: 0px;
    margin-right: 0px;
  }
  z-index: 5;
`;

});
parcelRegister("eGj3r", function(module, exports) {

$parcel$export(module.exports, "MandatesStatusFilter", function () { return $ae115c6120205a08$export$719333b48c811064; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $hppbX = parcelRequire("hppbX");

var $4LBh4 = parcelRequire("4LBh4");

var $3Ersk = parcelRequire("3Ersk");

var $k10cE = parcelRequire("k10cE");

var $dvzf7 = parcelRequire("dvzf7");

var $4O97W = parcelRequire("4O97W");
const $ae115c6120205a08$export$d21937a90300cd7a = (props)=>{
    const { children: children, onClick: onClick, active: active, ...rest } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($ae115c6120205a08$var$FilterButtonContainer, {
        ...rest,
        onClick: onClick,
        $active: active,
        children: [
            children,
            /*#__PURE__*/ (0, $4m918.jsx)($ae115c6120205a08$var$ChevronDownIcon, {})
        ]
    });
};
const $ae115c6120205a08$var$PressableRow = (0, $jb8NR.default).div`
  padding: 5px 10px 5px 10px;
  &:focus,
  &:active,
  &:hover {
    background-color: #e2e2e2;
    cursor: pointer;
  }
`;
const $ae115c6120205a08$export$719333b48c811064 = (props)=>{
    const [showDropdown, setShowDropdown] = (0, $6uYXW.useState)(false);
    const dropdownContentRef = (0, $6uYXW.useRef)(null);
    (0, $k10cE.useClickOutsideHandler)(dropdownContentRef, ()=>setShowDropdown(false));
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const currentStatus = (0, $3Ersk.useObservable)((0, $kqXxS.mandateFilterManager).statusSelection);
    return /*#__PURE__*/ (0, $4m918.jsxs)($ae115c6120205a08$export$d21937a90300cd7a, {
        ...props,
        onClick: (e)=>{
            if (e.target === e.currentTarget) setShowDropdown((show)=>!show);
        },
        active: true,
        children: [
            formatMessage((0, $4LBh4.mandateStatusLabels)[currentStatus]),
            /*#__PURE__*/ (0, $4m918.jsx)($ae115c6120205a08$var$DropdownContent, {
                ref: dropdownContentRef,
                onClick: (e)=>{
                    e.stopPropagation();
                },
                $isVisible: showDropdown,
                children: [
                    (0, $hppbX.MandateStatus).ALL,
                    (0, $hppbX.MandateStatus).ACTIVE,
                    (0, $hppbX.MandateStatus).CONSUMED,
                    (0, $hppbX.MandateStatus).CREDITOR_OPPOSED,
                    (0, $hppbX.MandateStatus).OBSOLETE,
                    (0, $hppbX.MandateStatus).OPPOSED,
                    (0, $hppbX.MandateStatus).REVOKED
                ].map((status)=>/*#__PURE__*/ (0, $4m918.jsx)($ae115c6120205a08$var$PressableRow, {
                        onClick: ()=>{
                            (0, $kqXxS.mandateFilterManager).setStatusSelection(status);
                            setShowDropdown(false);
                        },
                        children: formatMessage((0, $4LBh4.mandateStatusLabels)[status])
                    }, status))
            })
        ]
    });
};
const $ae115c6120205a08$var$DropdownContent = (0, $jb8NR.default).div`
  display: ${(props)=>props.$isVisible ? "block" : "none"};
  overflow: hidden;
  text-align: start;
  position: absolute;
  top: 120%;
  left: 0px;
  background-color: #f4f4f4;
  border-radius: 10px;
  z-index: 1;
  min-width: 100%;
  &:hover {
    cursor: auto;
  }
`;
const $ae115c6120205a08$var$FilterButtonContainer = (0, $jb8NR.default)((0, $dvzf7.TertiaryDiv))`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: ${(props)=>props.$active ? "#e4e4e4" : "#f4f4f4"};
  &:hover {
    cursor: pointer;
  }
`;
const $ae115c6120205a08$var$ChevronDownIcon = (0, $jb8NR.default)((0, $4O97W.ChevronDown))`
  margin-left: 6px;
  margin-right: 6px;
  pointer-events: none;
  width: 15px;
`;

});
parcelRegister("4LBh4", function(module, exports) {

$parcel$export(module.exports, "mandateStatusLabels", function () { return $3ad705b8d8790cb4$export$ab1f85d4a4d2426b; });

var $hppbX = parcelRequire("hppbX");
const $3ad705b8d8790cb4$export$ab1f85d4a4d2426b = {
    [(0, $hppbX.MandateStatus).ALL]: "mandates.status.all",
    [(0, $hppbX.MandateStatus).ACTIVE]: "mandates.status.active",
    [(0, $hppbX.MandateStatus).CONSUMED]: "mandates.status.consumed",
    [(0, $hppbX.MandateStatus).CREDITOR_OPPOSED]: "mandates.status.creditorOpposed",
    [(0, $hppbX.MandateStatus).OBSOLETE]: "mandates.status.obsolete",
    [(0, $hppbX.MandateStatus).OPPOSED]: "mandates.status.opposed",
    [(0, $hppbX.MandateStatus).REVOKED]: "mandates.status.revoked"
};

});



parcelRegister("1LXCJ", function(module, exports) {

$parcel$export(module.exports, "MandateItem", function () { return $99506f4c715e3c02$export$95c68b4de96a3690; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $hppbX = parcelRequire("hppbX");

var $3Ersk = parcelRequire("3Ersk");

var $4nSeL = parcelRequire("4nSeL");

var $22v9q = parcelRequire("22v9q");

var $imHf4 = parcelRequire("imHf4");
const $99506f4c715e3c02$export$95c68b4de96a3690 = ({ mandate: mandate, handleMandateOppose: handleMandateOppose, handleMandateActivate: handleMandateActivate, handleMandateDetail: handleMandateDetail })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $6uYXW.useState)(false);
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const handleToggleMenu = ()=>setIsMenuOpen((bool)=>!bool);
    const handleCancel = ()=>{
        handleMandateOppose(mandate);
        handleToggleMenu();
    };
    const handlePlay = ()=>{
        handleMandateActivate(mandate);
        handleToggleMenu();
    };
    const hasScopeAndStatus = features.mandateManagement && (mandate.status === (0, $hppbX.MandateStatus).ACTIVE || mandate.status === (0, $hppbX.MandateStatus).OPPOSED);
    return /*#__PURE__*/ (0, $4m918.jsxs)($99506f4c715e3c02$var$StyledMandates, {
        onClick: ()=>handleMandateDetail(mandate),
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($99506f4c715e3c02$var$BoldText, {
                        children: mandate.creditorName
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($99506f4c715e3c02$var$FrequencyText, {
                        children: mandate.reference
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($99506f4c715e3c02$var$StatusWrapper, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $imHf4.MandateStatusPill), {
                    status: mandate.status
                })
            }),
            hasScopeAndStatus && /*#__PURE__*/ (0, $4m918.jsx)((0, $4nSeL.default), {
                isRTL: false,
                isOpen: isMenuOpen,
                onToggle: handleToggleMenu,
                onCancel: handleCancel,
                onPlay: handlePlay,
                enableCancel: mandate.status === (0, $hppbX.MandateStatus).ACTIVE,
                enablePlay: mandate.status === (0, $hppbX.MandateStatus).OPPOSED
            })
        ]
    });
};
const $99506f4c715e3c02$var$BoldText = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).bodyBlackBold}
  font-size: 16px;
`;
const $99506f4c715e3c02$var$FrequencyText = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).bodySmallGreyRegular}
`;
const $99506f4c715e3c02$var$StatusWrapper = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $99506f4c715e3c02$var$StyledMandates = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 100px 20px 30px;
  border-radius: 13px;
  background-color: #ffffff;
  align-self: stretch;
  margin-top: 15px;
  cursor: pointer;
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.05);
  }
`;

});

parcelRegister("d27e0", function(module, exports) {

$parcel$export(module.exports, "OpposeMandateModal", function () { return $fa71274ce3fd2a16$export$58552cccf449bcc3; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $bQhUC = parcelRequire("bQhUC");

var $3bC3z = parcelRequire("3bC3z");
const $fa71274ce3fd2a16$export$58552cccf449bcc3 = (props)=>{
    const { mandate: mandate, onConfirm: onConfirm } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $3bC3z.MandateModal), {
        mandate: mandate,
        onConfirm: onConfirm,
        modalId: (0, $bQhUC.OPPOSE_MANDATE_MODAL_ID),
        textPrompt: "mandates.opposePrompt"
    });
};

});


parcelRegister("20t15", function(module, exports) {

$parcel$export(module.exports, "RechargeScreen", function () { return $7aa6c248743ac5de$export$8e263c080280e57f; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $52WG4 = parcelRequire("52WG4");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $bQhUC = parcelRequire("bQhUC");

var $4fYE4 = parcelRequire("4fYE4");

var $7N0kU = parcelRequire("7N0kU");

var $yYT9n = parcelRequire("yYT9n");

var $4nDe7 = parcelRequire("4nDe7");

var $5Wai4 = parcelRequire("5Wai4");

var $jEKif = parcelRequire("jEKif");

var $i04qV = parcelRequire("i04qV");

var $jFgdN = parcelRequire("jFgdN");

var $gtV8g = parcelRequire("gtV8g");
function $7aa6c248743ac5de$export$8e263c080280e57f() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const accounts = (0, $3Ersk.useObservable)((0, $kqXxS.accountManager).accounts);
    const currentAccounts = (0, $6uYXW.useMemo)(()=>accounts.filter((0, $52WG4.isRechargeable)), [
        accounts
    ]);
    const { client: client } = (0, $7N0kU.useClient)();
    const accountsLoading = (0, $3Ersk.useObservable)((0, $kqXxS.accountManager).loading);
    const { pathname: pathname } = (0, $NQIVp.useLocation)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await (0, $kqXxS.accountManager).load();
    }, []);
    (0, $6uYXW.useEffect)(()=>{
        if (pathname.includes((0, $4fYE4.Path).PspRedirect)) (0, $5Wai4.Modal).present((0, $bQhUC.RECHARGE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $gtV8g.RechargeModal), {
                completePspTransactionFlow: true
            }), {
            canBeDismissed: false
        });
    }, [
        pathname
    ]);
    if (pathname.includes((0, $4fYE4.Path).PspRedirect)) return /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
        to: {
            pathname: (0, $4fYE4.Path).Recharge
        }
    });
    return /*#__PURE__*/ (0, $4m918.jsxs)($7aa6c248743ac5de$var$Section, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($7aa6c248743ac5de$var$RechargeScreenHeader, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($7aa6c248743ac5de$var$SectionTitle, {
                        children: formatMessage("recharge.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($7aa6c248743ac5de$var$SectionDescription, {
                        children: formatMessage("recharge.description")
                    })
                ]
            }),
            !accountsLoading && currentAccounts.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jFgdN.NoAccountAvailableBlock), {}) : /*#__PURE__*/ (0, $4m918.jsx)((0, $4nDe7.AccountListGrid), {
                children: accountsLoading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $i04qV.SkeletonAccountTile), {
                    $isRTL: isRTL
                }) : currentAccounts.map((account)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $i04qV.RechargeableAccountTile), {
                        account: account,
                        owner: client,
                        onClick: ()=>{
                            (0, $5Wai4.Modal).present((0, $bQhUC.RECHARGE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $gtV8g.RechargeModal), {
                                    account: account
                                }), {
                                canBeDismissed: false
                            });
                        }
                    }, account.id))
            })
        ]
    });
}
const $7aa6c248743ac5de$var$Section = (0, $jb8NR.default).section`
  align-self: stretch;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $7aa6c248743ac5de$var$SectionTitle = (0, $jb8NR.default)((0, $jEKif.PageSectionTitle))``;
const $7aa6c248743ac5de$var$SectionDescription = (0, $jb8NR.default)((0, $jEKif.PageSectionDescription))``;
const $7aa6c248743ac5de$var$RechargeScreenHeader = (0, $jb8NR.default).div`
  flex-direction: column;
  margin-bottom: 30px;
`;

});
parcelRegister("52WG4", function(module, exports) {

$parcel$export(module.exports, "isRechargeable", function () { return $daa97c3b8775d838$export$dd810468806ad4e4; });

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $kGswT = parcelRequire("kGswT");
const $daa97c3b8775d838$export$dd810468806ad4e4 = (account)=>{
    if (account.type !== (0, $kGswT.AccountType).Current) return false;
    if ([
        (0, $kGswT.AccountStatus).Blocked,
        (0, $kGswT.AccountStatus).Closed,
        (0, $kGswT.AccountStatus).CreditBlocked
    ].includes(account.status)) return false;
    const features = (0, $kqXxS.featuresManager).features.get();
    if (features.walletRechargeByCard) return true;
    if (features.bankToWallet) return (0, $gDlNU.isDefined)(account.externalAccount);
    return false;
};

});

parcelRegister("jFgdN", function(module, exports) {

$parcel$export(module.exports, "NoAccountAvailableBlock", function () { return $a3d858447c9a69f6$export$d4ddf7f334f2cf13; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $ixBnh = parcelRequire("ixBnh");

var $22fDG = parcelRequire("22fDG");
const $a3d858447c9a69f6$export$d4ddf7f334f2cf13 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($a3d858447c9a69f6$var$GreyCard, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($a3d858447c9a69f6$var$IllustrationContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $22fDG.AccountPlaceholder), {})
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($a3d858447c9a69f6$var$ContentContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($a3d858447c9a69f6$var$Title, {
                        children: formatMessage("recharge.noAccountAvailable")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($a3d858447c9a69f6$var$Description, {
                        children: formatMessage("recharge.noAccountExplanation")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($a3d858447c9a69f6$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($a3d858447c9a69f6$var$ContactSupportButton, {
                    onClick: ()=>{
                        (0, $5Wai4.Modal).present((0, $bQhUC.CONTACT_SUPPORT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $ixBnh.ContactSupportModal), {
                                title: formatMessage("contactSupport.rechargeNotAvailableTitle"),
                                subtitle: formatMessage("contactSupport.rechargeNotAvailableMessage")
                            }), {
                            canBeDismissed: false
                        });
                    },
                    size: "S",
                    children: formatMessage("recharge.contactSupport")
                })
            })
        ]
    });
};
const $a3d858447c9a69f6$var$GreyCard = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  background-color: #f4f4f4;
  border-radius: 18px;
  padding: 40px;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    flex-direction: column;
  }
`;
const $a3d858447c9a69f6$var$ContentContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 26px;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    margin-left: 0px;
    margin-top: 26px;
    margin-bottom: 26px;
  }
`;
const $a3d858447c9a69f6$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 26px;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    margin-left: 0px;
  }
`;
const $a3d858447c9a69f6$var$IllustrationContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    align-items: center;
  }
`;
const $a3d858447c9a69f6$var$ContactSupportButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  min-width: 250px;
`;
const $a3d858447c9a69f6$var$Title = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  margin-bottom: 8px;
  ${(0, $22v9q.theme).boldText};
  color: #000000;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    text-align: center;
  }
`;
const $a3d858447c9a69f6$var$Description = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    text-align: center;
  }
`;

});
parcelRegister("ixBnh", function(module, exports) {

$parcel$export(module.exports, "ContactSupportModal", function () { return $ec8e757010ba719f$export$2f2760a55d7a498b; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $lrNCO = parcelRequire("lrNCO");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $fplBl = parcelRequire("fplBl");

var $bQhUC = parcelRequire("bQhUC");

var $ZE1cB = parcelRequire("ZE1cB");

var $7xALQ = parcelRequire("7xALQ");

var $i1jpl = parcelRequire("i1jpl");

var $dmWk7 = parcelRequire("dmWk7");

var $22v9q = parcelRequire("22v9q");
const $ec8e757010ba719f$export$2f2760a55d7a498b = (props)=>{
    const { title: title, subtitle: subtitle } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const contacts = (0, $kqXxS.contactService).getContacts();
    const phone = contacts.get((0, $lrNCO.ContactType).Phone);
    const email = contacts.get((0, $lrNCO.ContactType).Email);
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $7xALQ.WhiteModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CONTACT_SUPPORT_MODAL_ID),
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($ec8e757010ba719f$var$Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($ec8e757010ba719f$var$Subtitle, {
                children: subtitle
            }),
            (0, $gDlNU.isDefined)(phone) || (0, $gDlNU.isDefined)(email) ? /*#__PURE__*/ (0, $4m918.jsxs)($ec8e757010ba719f$var$Contacts, {
                children: [
                    (0, $gDlNU.isDefined)(phone) && /*#__PURE__*/ (0, $4m918.jsxs)($ec8e757010ba719f$var$ContactRow, {
                        href: (0, $fplBl.buildLinkPhoneTo)(phone),
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($ec8e757010ba719f$var$RowGlyph, {
                                as: (0, $dmWk7.ContactPhoneIcon),
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($ec8e757010ba719f$var$RowLabel, {
                                children: formatMessage("contactSupport.contactByPhone", {
                                    phoneNumber: phone
                                })
                            })
                        ]
                    }),
                    (0, $gDlNU.isDefined)(email) && /*#__PURE__*/ (0, $4m918.jsxs)($ec8e757010ba719f$var$ContactRow, {
                        href: (0, $fplBl.buildLinkMailTo)(email),
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($ec8e757010ba719f$var$RowGlyph, {
                                as: (0, $i1jpl.ContactEmailIcon),
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($ec8e757010ba719f$var$RowLabel, {
                                children: formatMessage("contactSupport.contactByEmail", {
                                    email: email
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $4m918.jsx)($ec8e757010ba719f$var$NoContact, {
                children: formatMessage("contactSupport.noContactAvailable")
            })
        ]
    });
};
const $ec8e757010ba719f$var$Title = (0, $jb8NR.default)((0, $ZE1cB.MarkdownText))`
  ${(0, $22v9q.theme).boldText};
  margin: 0;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $ec8e757010ba719f$var$Subtitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  margin: 8px 0 20px;
  font-size: 15px;
  line-height: 20px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $ec8e757010ba719f$var$Contacts = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
`;
const $ec8e757010ba719f$var$ContactRow = (0, $jb8NR.default).a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-top: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  color: inherit;

  &:first-of-type {
    border-top: 0;
  }

  &:hover {
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }
`;
const $ec8e757010ba719f$var$RowGlyph = (0, $jb8NR.default).svg`
  width: 26px;
  height: 26px;
  flex-shrink: 0;

  path {
    fill: ${(0, $22v9q.theme).colors.blue[700]};
  }
`;
const $ec8e757010ba719f$var$RowLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 15px;
  line-height: 20px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $ec8e757010ba719f$var$NoContact = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  padding: 20px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
  font-size: 14px;
  line-height: 19px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;

});

parcelRegister("22fDG", function(module, exports) {

$parcel$export(module.exports, "AccountPlaceholder", function () { return $4d8f05992a24c776$export$dc27c890a56618d5; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $4d8f05992a24c776$export$dc27c890a56618d5 = (props)=>/*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        ...props,
        width: "180",
        height: "107",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                        x: "-13.4%",
                        y: "-23%",
                        width: "126.7%",
                        height: "157.5%",
                        filterUnits: "objectBoundingBox",
                        id: "a",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                                stdDeviation: "6",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                        id: "b",
                        x: "0",
                        y: "0",
                        width: "149.674",
                        height: "69.521",
                        rx: "10.052"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        transform: "translate(29.935 .337)",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                                fillOpacity: ".04",
                                fill: "#000",
                                width: "149.674",
                                height: "69.521",
                                rx: "10.052"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                                d: "M133.542 8.247h2.055c1.85 0 2.655.22 3.424.63a4.288 4.288 0 0 1 1.784 1.784c.411.77.63 1.574.63 3.424v2.07c0 1.85-.219 2.654-.63 3.423a4.288 4.288 0 0 1-1.784 1.784c-.769.411-1.574.63-3.424.63h-2.055c-1.85 0-2.655-.219-3.424-.63a4.288 4.288 0 0 1-1.784-1.784c-.411-.769-.63-1.574-.63-3.424v-2.069c0-1.85.219-2.655.63-3.424a4.288 4.288 0 0 1 1.784-1.784c.769-.41 1.574-.63 3.424-.63z",
                                fill: "#B1B1B1",
                                opacity: ".241"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("ellipse", {
                                fillOpacity: ".179",
                                fill: "#000",
                                cx: "134.57",
                                cy: "15.12",
                                rx: "2.472",
                                ry: "2.474"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                                transform: "translate(16.63 22.34)",
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                                        fillOpacity: ".179",
                                        fill: "#000",
                                        width: "43.239",
                                        height: "5.714",
                                        rx: "2.857"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                                        fill: "#F4F4F4",
                                        y: "14.761",
                                        width: "100.258",
                                        height: "5.714",
                                        rx: "2.857"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        transform: "translate(0 37.479)",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#000",
                                filter: "url(#a)",
                                xlinkHref: "#b"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#FFF",
                                xlinkHref: "#b"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        transform: "translate(127.43 45.421)",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                                d: "M5.838 0h2.055c1.85 0 2.656.219 3.425.63A4.288 4.288 0 0 1 13.1 2.414c.412.77.63 1.574.63 3.424v2.069c0 1.85-.218 2.655-.63 3.424a4.288 4.288 0 0 1-1.783 1.784c-.77.411-1.574.63-3.425.63H5.838c-1.85 0-2.655-.219-3.424-.63A4.288 4.288 0 0 1 .63 11.33C.22 10.562 0 9.757 0 7.907V5.838c0-1.85.219-2.655.63-3.424A4.288 4.288 0 0 1 2.414.63C3.184.22 3.988 0 5.838 0z",
                                fill: "#F4F4F4"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("ellipse", {
                                fill: "#D5D5D5",
                                cx: "6.866",
                                cy: "6.873",
                                rx: "2.472",
                                ry: "2.474"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        transform: "translate(16.63 63.668)",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                                fill: "#D5D5D5",
                                width: "43.239",
                                height: "5.714",
                                rx: "2.857"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                                fill: "#F4F4F4",
                                y: "14.761",
                                width: "100.258",
                                height: "5.714",
                                rx: "2.857"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});


parcelRegister("gtV8g", function(module, exports) {

$parcel$export(module.exports, "RechargeModal", function () { return $31471e8c6c64b48e$export$7b7c11c3d86b012d; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $5hpYi = parcelRequire("5hpYi");

var $1YFGv = parcelRequire("1YFGv");

var $cG3cd = parcelRequire("cG3cd");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $40sjz = parcelRequire("40sjz");

var $fzf6B = parcelRequire("fzf6B");

var $eyjPK = parcelRequire("eyjPK");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $04aUg = parcelRequire("04aUg");

var $bN0y5 = parcelRequire("bN0y5");

var $keeMv = parcelRequire("keeMv");

var $cHBpO = parcelRequire("cHBpO");
const $31471e8c6c64b48e$var$loadingStates = [
    (0, $40sjz.PincodeState).FetchKeyboardAfterError,
    (0, $fzf6B.RechargeState).RequestingBankToWallet,
    (0, $fzf6B.RechargeState).Confirmation,
    (0, $40sjz.PincodeState).PincodeConfirmation,
    (0, $fzf6B.RechargeState).FetchingCardPspWebviewUrl,
    (0, $fzf6B.RechargeState).PspWebviewRedirection
];
const $31471e8c6c64b48e$export$7b7c11c3d86b012d = (props)=>{
    const { account: account, completePspTransactionFlow: completePspTransactionFlow } = props;
    const { client: client } = (0, $7N0kU.useClient)();
    const { state: state, context: context, selectRechargeMethod: selectRechargeMethod, selectAmount: selectAmount, submitPincode: submitPincode } = (0, $fzf6B.useRechargeMachine)(completePspTransactionFlow ? (0, $fzf6B.RechargeState).PspTransactionComplete : (0, $fzf6B.RechargeState).SelectingRechargeMethod);
    const errorMessage = !(0, $1YFGv.isAccountBlocked)(context.error) ? context.error : undefined;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { data: data } = (0, $cG3cd.useExternalAccounts)();
    const externalAccount = data?.[0];
    const externalAccountIBAN = externalAccount?.iban;
    const rechargeAccount = account;
    const renderInnerStep = ()=>{
        switch(state){
            case (0, $fzf6B.RechargeState).SelectingRechargeMethod:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $cHBpO.RechargeMethodSelection), {
                    selectMethod: (rechargeMethod)=>selectRechargeMethod(rechargeAccount, externalAccountIBAN, rechargeMethod)
                });
            case (0, $fzf6B.RechargeState).RequestingBankToWalletError:
            case (0, $fzf6B.RechargeState).RequestingBankToWallet:
            case (0, $40sjz.PincodeState).PincodeConfirmation:
            case (0, $fzf6B.RechargeState).ConfirmBankToWalletError:
            case (0, $fzf6B.RechargeState).SelectingBankToWalletAmount:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $bN0y5.SelectRechargeByBankAmount), {
                    account: rechargeAccount,
                    externalAccountIBAN: externalAccountIBAN,
                    submitAmount: selectAmount,
                    errorMessage: errorMessage,
                    loading: $31471e8c6c64b48e$var$loadingStates.includes(state)
                });
            case (0, $fzf6B.RechargeState).RequestingBankToWallet:
            case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
            case (0, $fzf6B.RechargeState).Confirmation:
            case (0, $40sjz.PincodeState).PromptingKeyboard:
                {
                    const keyboard = context.keyboard;
                    return /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                        keyboard: keyboard,
                        onSubmit: submitPincode,
                        title: formatMessage("pincodeConfirmation.label"),
                        errorMessage: errorMessage,
                        loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError
                    });
                }
            case (0, $fzf6B.RechargeState).SelectingCardAmount:
            case (0, $fzf6B.RechargeState).SelectingCardAmountError:
            case (0, $fzf6B.RechargeState).FetchingCardPspWebviewUrl:
            case (0, $fzf6B.RechargeState).PspWebviewRedirection:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $keeMv.SelectRechargeByCardAmount), {
                    account: rechargeAccount,
                    owner: client,
                    submitAmount: selectAmount,
                    errorMessage: errorMessage,
                    loading: $31471e8c6c64b48e$var$loadingStates.includes(state)
                });
            case (0, $fzf6B.RechargeState).PspTransactionComplete:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {});
            case (0, $fzf6B.RechargeState).Done:
                return context.rechargeMethod === (0, $fzf6B.RechargeMethod).BANK_TO_WALLET ? /*#__PURE__*/ (0, $4m918.jsx)((0, $04aUg.RechargeSummary), {
                    rechargeMethod: context.rechargeMethod,
                    accountId: context.account.id,
                    amount: context.amount,
                    onDone: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.RECHARGE_MODAL_ID))
                }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $04aUg.RechargeSummary), {
                    rechargeMethod: context.rechargeMethod,
                    accountId: context.completedPspTransaction.accountId,
                    amount: context.completedPspTransaction.amount,
                    onDone: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.RECHARGE_MODAL_ID))
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.RECHARGE_MODAL_ID),
        children: renderInnerStep()
    });
};

});
parcelRegister("fzf6B", function(module, exports) {

$parcel$export(module.exports, "RechargeMethod", function () { return $6df708a2561ad842$export$d03e7441880dbce9; });
$parcel$export(module.exports, "useRechargeMachine", function () { return $6df708a2561ad842$export$d447b0aad0884a40; });
$parcel$export(module.exports, "RechargeState", function () { return $6df708a2561ad842$export$ddde4070eb961066; });

var $lCuQx = parcelRequire("lCuQx");

var $6uYXW = parcelRequire("6uYXW");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");

var $8UJ8q = parcelRequire("8UJ8q");

var $40sjz = parcelRequire("40sjz");
var $6df708a2561ad842$export$d03e7441880dbce9 = /*#__PURE__*/ function(RechargeMethod) {
    RechargeMethod["BANK_TO_WALLET"] = "BANK_TO_WALLET";
    RechargeMethod["WITH_CARD"] = "WITH_CARD";
    return RechargeMethod;
}({});
const $6df708a2561ad842$export$d447b0aad0884a40 = (initialState = "PspTransactionComplete")=>{
    const rechargeMachine = (0, $6uYXW.useMemo)(()=>$6df708a2561ad842$var$registerMachineBuilder(initialState), [
        initialState
    ]);
    const [state, sendEvent] = (0, $lCuQx.useMachine)(rechargeMachine);
    const selectRechargeMethod = (account, externalAccountIBAN, method)=>{
        if (method === "BANK_TO_WALLET") sendEvent("RECHARGE_BANK_TO_WALLET", {
            account: account,
            externalAccountIBAN: externalAccountIBAN
        });
        else sendEvent("RECHARGE_WITH_CARD", {
            account: account
        });
    };
    const selectAmount = (amount)=>{
        sendEvent("SELECT_AMOUNT", {
            amount: amount
        });
    };
    const submitPincode = (submission)=>{
        sendEvent("SUBMIT_PINCODE", {
            pincodeSubmission: submission
        });
    };
    return {
        state: state.value,
        context: state.context,
        selectRechargeMethod: selectRechargeMethod,
        selectAmount: selectAmount,
        submitPincode: submitPincode
    };
};
var $6df708a2561ad842$export$ddde4070eb961066 = /*#__PURE__*/ function(RechargeState) {
    RechargeState["SelectingRechargeMethod"] = "SelectingRechargeMethod";
    RechargeState["SelectingBankToWalletAmount"] = "SelectingBankToWalletAmount";
    RechargeState["RequestingBankToWallet"] = "RequestingBankToWallet";
    RechargeState["RequestingBankToWalletError"] = "RequestingBankToWalletError";
    RechargeState["Confirmation"] = "Confirmation";
    RechargeState["ConfirmBankToWalletError"] = "ConfirmBankToWalletError";
    RechargeState["SelectingCardAmount"] = "SelectingCardAmount";
    RechargeState["SelectingCardAmountError"] = "SelectingCardAmountError";
    RechargeState["FetchingCardPspWebviewUrl"] = "FetchingRechargeByCardWebview";
    RechargeState["PspWebviewRedirection"] = "PspWebviewRedirection";
    RechargeState["PspTransactionComplete"] = "PspTransactionComplete";
    RechargeState["Done"] = "Done";
    return RechargeState;
}({});
var $6df708a2561ad842$var$RechargeInvokeName = /*#__PURE__*/ function(RechargeInvokeName) {
    RechargeInvokeName["StartRecharge"] = "StartRecharge";
    RechargeInvokeName["FetchKeyboard"] = "FetchKeyboard";
    RechargeInvokeName["ConfirmRecharge"] = "ConfirmRecharge";
    RechargeInvokeName["FetchCardPspWebviewUrl"] = "FetchCardPspWebviewUrl";
    RechargeInvokeName["RedirectToPspWebview"] = "RedirectToPspWebview";
    RechargeInvokeName["CompletePspTransaction"] = "CompletePspTransaction";
    return RechargeInvokeName;
}($6df708a2561ad842$var$RechargeInvokeName || {});
const $6df708a2561ad842$var$registerMachineBuilder = (initialState)=>(0, $TAle5.Machine)({
        id: "recharge",
        initial: initialState,
        states: {
            ["SelectingRechargeMethod"]: {
                on: {
                    RECHARGE_BANK_TO_WALLET: {
                        target: "SelectingBankToWalletAmount",
                        actions: [
                            (0, $c8ePo.assign)({
                                rechargeMethod: (_)=>"BANK_TO_WALLET",
                                account: (_, event)=>event.account,
                                externalAccountIBAN: (_, event)=>event.externalAccountIBAN
                            })
                        ]
                    },
                    RECHARGE_WITH_CARD: {
                        target: "SelectingCardAmount",
                        actions: [
                            (0, $c8ePo.assign)({
                                rechargeMethod: (_)=>"WITH_CARD",
                                account: (_, event)=>event.account
                            })
                        ]
                    }
                }
            },
            ["SelectingBankToWalletAmount"]: {
                on: {
                    SELECT_AMOUNT: {
                        target: "RequestingBankToWallet",
                        actions: [
                            (0, $c8ePo.assign)({
                                amount: (_, event)=>event.amount
                            })
                        ]
                    }
                }
            },
            ["RequestingBankToWallet"]: {
                invoke: {
                    id: "StartRecharge",
                    src: (context)=>(0, $kqXxS.bankToWalletManager).startBankToWallet(context.amount, context.account.id, context.externalAccountIBAN),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                rtpTransactionRequest: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)((context)=>context.rtpTransactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                    type: "PINCODE_CONFIRM"
                                } : {
                                    type: "CONFIRM"
                                })
                        ]
                    },
                    onError: {
                        target: "RequestingBankToWalletError",
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_, event)=>event.data
                            })
                        ]
                    }
                },
                on: {
                    PINCODE_CONFIRM: (0, $40sjz.PincodeState).PincodeConfirmation,
                    CONFIRM: "Confirmation"
                }
            },
            ["RequestingBankToWalletError"]: {
                exit: (0, $c8ePo.assign)({
                    error: undefined
                }),
                on: {
                    SELECT_AMOUNT: {
                        target: "RequestingBankToWallet",
                        actions: [
                            (0, $c8ePo.assign)({
                                amount: (_, event)=>event.amount
                            })
                        ]
                    }
                }
            },
            [(0, $40sjz.PincodeState).PincodeConfirmation]: {
                invoke: {
                    id: "FetchKeyboard",
                    src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                keyboard: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "PROMPT_KEYBOARD"
                            })
                        ]
                    }
                },
                on: {
                    PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
                }
            },
            [(0, $40sjz.PincodeState).PromptingKeyboard]: {
                on: {
                    SUBMIT_PINCODE: {
                        target: "Confirmation",
                        actions: (0, $c8ePo.assign)({
                            pincodeSubmission: (_, event)=>event.pincodeSubmission
                        })
                    }
                }
            },
            ["Confirmation"]: {
                invoke: {
                    id: "ConfirmRecharge",
                    src: (context)=>(0, $kqXxS.bankToWalletManager).confirmBankToWallet(context.rtpTransactionRequest.metadata.confirmationMode, context.amount, context.account.id, context.externalAccountIBAN, context.pincodeSubmission),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                transactionResult: (_, event)=>event.data,
                                error: undefined
                            }),
                            (0, $c8ePo.send)({
                                type: "RECHARGE_DONE"
                            })
                        ]
                    },
                    onError: {
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)((ctx)=>ctx.rtpTransactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                    type: "RECHARGE_CONFIRMATION_PINCODE_ERROR"
                                } : {
                                    type: "RECHARGE_CONFIRMATION_ERROR"
                                })
                        ]
                    }
                },
                on: {
                    RECHARGE_DONE: "Done",
                    RECHARGE_CONFIRMATION_PINCODE_ERROR: (0, $40sjz.PincodeState).FetchKeyboardAfterError,
                    RECHARGE_CONFIRMATION_ERROR: "ConfirmBankToWalletError"
                }
            },
            [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
                invoke: {
                    id: "FetchKeyboard",
                    src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                keyboard: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "PROMPT_KEYBOARD"
                            })
                        ]
                    }
                },
                on: {
                    PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
                }
            },
            ["ConfirmBankToWalletError"]: {
                exit: (0, $c8ePo.assign)({
                    error: undefined
                }),
                on: {
                    SELECT_AMOUNT: {
                        target: "RequestingBankToWallet",
                        actions: [
                            (0, $c8ePo.assign)({
                                amount: (_, event)=>event.amount
                            })
                        ]
                    }
                }
            },
            ["SelectingCardAmount"]: {
                on: {
                    SELECT_AMOUNT: {
                        target: "FetchingRechargeByCardWebview",
                        actions: [
                            (0, $c8ePo.assign)({
                                amount: (_, event)=>event.amount
                            })
                        ]
                    }
                }
            },
            ["FetchingRechargeByCardWebview"]: {
                invoke: {
                    id: "FetchCardPspWebviewUrl",
                    src: (context)=>(0, $kqXxS.bankToWalletManager).confirmRechargeByCard(context.amount, context.account.id),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                rechargeByCardResult: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "REDIRECT_TO_CARD_PSP"
                            })
                        ]
                    },
                    onError: {
                        target: "SelectingCardAmountError",
                        actions: [
                            (0, $c8ePo.assign)({
                                error: (_, event)=>event.data
                            })
                        ]
                    }
                },
                on: {
                    REDIRECT_TO_CARD_PSP: "PspWebviewRedirection"
                }
            },
            ["SelectingCardAmountError"]: {
                exit: (0, $c8ePo.assign)({
                    error: undefined
                }),
                on: {
                    SELECT_AMOUNT: {
                        target: "FetchingRechargeByCardWebview",
                        actions: [
                            (0, $c8ePo.assign)({
                                amount: (_, event)=>event.amount
                            })
                        ]
                    }
                }
            },
            ["PspWebviewRedirection"]: {
                invoke: {
                    id: "RedirectToPspWebview",
                    src: async (context)=>window.location.assign(context.rechargeByCardResult.data.webviewUrl)
                }
            },
            ["PspTransactionComplete"]: {
                invoke: {
                    id: "CompletePspTransaction",
                    src: ()=>(0, $kqXxS.bankToWalletManager).completePspTransaction(),
                    onDone: {
                        actions: [
                            (0, $c8ePo.assign)({
                                rechargeMethod: (_)=>"WITH_CARD",
                                completedPspTransaction: (_, event)=>event.data
                            }),
                            (0, $c8ePo.send)({
                                type: "RECHARGE_DONE"
                            })
                        ]
                    }
                },
                on: {
                    RECHARGE_DONE: "Done"
                }
            },
            ["Done"]: {
                type: "final"
            }
        }
    });

});

parcelRegister("04aUg", function(module, exports) {

$parcel$export(module.exports, "RechargeSummary", function () { return $26912ffe83c285d2$export$3904528037f651b8; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $fzf6B = parcelRequire("fzf6B");

var $bZlaH = parcelRequire("bZlaH");

var $7Zu6k = parcelRequire("7Zu6k");

var $8RlWY = parcelRequire("8RlWY");

var $22v9q = parcelRequire("22v9q");
const $26912ffe83c285d2$export$3904528037f651b8 = (props)=>{
    const { amount: amount, accountId: accountId, onDone: onDone, rechargeMethod: rechargeMethod } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const rechargeMethodLabel = rechargeMethod == (0, $fzf6B.RechargeMethod).BANK_TO_WALLET ? "rechargeSummary.bankToWalletMethod" : "rechargeSummary.cardMethod";
    return /*#__PURE__*/ (0, $4m918.jsxs)($26912ffe83c285d2$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$GreenCheckCircle, {}),
            /*#__PURE__*/ (0, $4m918.jsxs)($26912ffe83c285d2$var$Card, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$SuccessText, {
                        children: formatMessage("rechargeSummary.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($26912ffe83c285d2$var$Content, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($26912ffe83c285d2$var$Row, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$Label, {
                                        children: formatMessage("rechargeSummary.rechargedAccount")
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$Value, {
                                        children: accountId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($26912ffe83c285d2$var$Row, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$Label, {
                                        children: formatMessage("rechargeSummary.rechargeMethod")
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$Value, {
                                        children: formatMessage(rechargeMethodLabel)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($26912ffe83c285d2$var$Row, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$Label, {
                                        children: formatMessage("rechargeSummary.rechargeAmount")
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$Value, {
                                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bZlaH.AmountText), {
                                            amount: amount
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$Footer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($26912ffe83c285d2$var$DoneButton, {
                    size: "M",
                    onClick: onDone,
                    children: formatMessage("rechargeSummary.done")
                })
            })
        ]
    });
};
const $26912ffe83c285d2$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
const $26912ffe83c285d2$var$GreenCheckCircle = (0, $jb8NR.default)((0, $8RlWY.SuccessCircle))`
  margin-top: 28px;
`;
const $26912ffe83c285d2$var$SuccessText = (0, $jb8NR.default).div`
  font-size: 1.375rem;
  ${(0, $22v9q.theme).boldText};
  padding-bottom: 25px;
  padding-top: 12px;
  align-self: center;
`;
const $26912ffe83c285d2$var$Row = (0, $jb8NR.default).div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-self: stretch;
`;
const $26912ffe83c285d2$var$Label = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).mediumText};
  color: #aaaaaa;
  align-self: center;
  text-align: center;
`;
const $26912ffe83c285d2$var$Value = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.9375rem;
  color: #000000;
  white-space: pre-line;
`;
const $26912ffe83c285d2$var$DoneButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $26912ffe83c285d2$var$Content = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;
`;
const $26912ffe83c285d2$var$Card = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  background-color: #ffffff;
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  margin-bottom: 16px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 40px;
`;
const $26912ffe83c285d2$var$Footer = (0, $jb8NR.default).div`
  display: flex;
  margin-top: 20px;
  justify-content: center;
`;

});

parcelRegister("bN0y5", function(module, exports) {

$parcel$export(module.exports, "SelectRechargeByBankAmount", function () { return $6ac577ad30c7028c$export$e703f61ca5a5a48a; });

var $4m918 = parcelRequire("4m918");

var $a1iRj = parcelRequire("a1iRj");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5P656 = parcelRequire("5P656");

var $5hpYi = parcelRequire("5hpYi");

var $gDlNU = parcelRequire("gDlNU");

var $gbifg = parcelRequire("gbifg");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $5rJrd = parcelRequire("5rJrd");

var $gk2kn = parcelRequire("gk2kn");

var $22v9q = parcelRequire("22v9q");
const $6ac577ad30c7028c$export$e703f61ca5a5a48a = (props)=>{
    const { account: account, externalAccountIBAN: externalAccountIBAN, submitAmount: submitAmount, loading: loading, errorMessage: errorMessage } = props;
    const [amount, setAmount] = (0, $6uYXW.useState)(new (0, $5P656.Amount)(0, account.currencyAlpha));
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($6ac577ad30c7028c$var$ContentContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($6ac577ad30c7028c$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$HeaderLogo, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$IconContainer, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $gk2kn.BigBankToWalletIcon), {
                                fill: (0, $22v9q.theme).mainColor()
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($6ac577ad30c7028c$var$HeaderContentContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$Title, {
                                children: formatMessage("rechargeBankToWallet.title")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$Subtitle, {
                                children: formatMessage("rechargeBankToWallet.subtitle")
                            })
                        ]
                    })
                ]
            }),
            (0, $gDlNU.isDefined)(errorMessage) && /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$StyledErrorMessage, {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($6ac577ad30c7028c$var$Card, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$CardTitle, {
                        children: formatMessage("rechargeBankToWallet.accountWithdrawnTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$CardDescription, {
                        children: formatMessage("rechargeBankToWallet.accountWithdrawnMessage")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($6ac577ad30c7028c$var$IbanContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$TagContainer, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$Tag, {
                                    children: formatMessage("rechargeBankToWallet.iban")
                                })
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$Iban, {
                                children: (0, $gDlNU.isDefined)(externalAccountIBAN) ? (0, $gbifg.anonimyzeIban)((0, (/*@__PURE__*/$parcel$interopDefault($a1iRj))).printFormat(externalAccountIBAN)) : ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$CardTitle, {
                children: formatMessage("rechargeBankToWallet.amountToWithdraw")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$StyledAmountInput, {
                value: amount,
                onChange: setAmount
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($6ac577ad30c7028c$var$Footer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                    size: "S",
                    onClick: ()=>submitAmount(amount),
                    showSpinner: loading,
                    disabled: !(amount.value > 0),
                    children: formatMessage("rechargeBankToWallet.recharge")
                })
            })
        ]
    });
};
const $6ac577ad30c7028c$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  padding-left: 5px;
  padding-right: 5px;
  margin-top: 20px;
  margin-bottom: 40px;
`;
const $6ac577ad30c7028c$var$HeaderLogo = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
`;
const $6ac577ad30c7028c$var$HeaderContentContainer = (0, $jb8NR.default).div`
  flex-direction: column;
`;
const $6ac577ad30c7028c$var$IconContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: ${()=>(0, $22v9q.theme).mainColorLightBackground()};
`;
const $6ac577ad30c7028c$var$ContentContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  margin-right: 15px;
`;
const $6ac577ad30c7028c$var$Title = (0, $jb8NR.default).div`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText}
`;
const $6ac577ad30c7028c$var$Subtitle = (0, $jb8NR.default).div`
  font-size: 0.8125rem;
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
`;
const $6ac577ad30c7028c$var$Card = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  background-color: #ffffff;
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  margin-bottom: 16px;
`;
const $6ac577ad30c7028c$var$CardTitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.9375rem;
  margin-bottom: 5px;
`;
const $6ac577ad30c7028c$var$CardDescription = (0, $jb8NR.default).div`
  font-size: 0.75rem;
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
  margin-bottom: 15px;
`;
const $6ac577ad30c7028c$var$IbanContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
`;
const $6ac577ad30c7028c$var$TagContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  background-color: ${()=>(0, $22v9q.theme).mainColorLightBackground()};
  border-radius: 13px;
  height: 20px;
  align-items: center;
  align-self: flex-start;
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 10px;
`;
const $6ac577ad30c7028c$var$Tag = (0, $jb8NR.default).div`
  font-size: 0.625rem;
  ${(0, $22v9q.theme).boldText};
  color: ${(0, $22v9q.theme).mainColor};
`;
const $6ac577ad30c7028c$var$Iban = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
`;
const $6ac577ad30c7028c$var$StyledAmountInput = (0, $jb8NR.default)((0, $5rJrd.AmountInput))`
  margin-top: 15px;
`;
const $6ac577ad30c7028c$var$Footer = (0, $jb8NR.default).div`
  display: flex;
  margin-top: 50px;
  justify-content: center;
`;
const $6ac577ad30c7028c$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0px 10px 0px;
  text-align: center;
`;

});
parcelRegister("a1iRj", function(module, exports) {
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([
        'exports'
    ], factory);
    else if (typeof module.exports.nodeName !== 'string') // CommonJS
    factory(module.exports);
    else // Browser globals
    factory(root.IBAN = {});
})(module.exports, function(exports1) {
    // Array.prototype.map polyfill
    // code from https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/map
    if (!Array.prototype.map) Array.prototype.map = function(fun /*, thisArg */ ) {
        "use strict";
        if (this === void 0 || this === null) throw new TypeError();
        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== "function") throw new TypeError();
        var res = new Array(len);
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for(var i = 0; i < len; i++)// NOTE: Absolute correctness would demand Object.defineProperty
        //       be used.  But this method is fairly new, and failure is
        //       possible only if Object.prototype or Array.prototype
        //       has a property |i| (very unlikely), so use a less-correct
        //       but more portable alternative.
        if (i in t) res[i] = fun.call(thisArg, t[i], i, t);
        return res;
    };
    var A = 'A'.charCodeAt(0), Z = 'Z'.charCodeAt(0);
    /**
     * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
     * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
     *
     * @param {string} iban the IBAN
     * @returns {string} the prepared IBAN
     */ function iso13616Prepare(iban) {
        iban = iban.toUpperCase();
        iban = iban.substr(4) + iban.substr(0, 4);
        return iban.split('').map(function(n) {
            var code = n.charCodeAt(0);
            if (code >= A && code <= Z) // A = 10, B = 11, ... Z = 35
            return code - A + 10;
            else return n;
        }).join('');
    }
    /**
     * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
     *
     * @param iban
     * @returns {number}
     */ function iso7064Mod97_10(iban) {
        var remainder = iban, block;
        while(remainder.length > 2){
            block = remainder.slice(0, 9);
            remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
    }
    /**
     * Parse the BBAN structure used to configure each IBAN Specification and returns a matching regular expression.
     * A structure is composed of blocks of 3 characters (one letter and 2 digits). Each block represents
     * a logical group in the typical representation of the BBAN. For each group, the letter indicates which characters
     * are allowed in this group and the following 2-digits number tells the length of the group.
     *
     * @param {string} structure the structure to parse
     * @returns {RegExp}
     */ function parseStructure(structure) {
        // split in blocks of 3 chars
        var regex = structure.match(/(.{3})/g).map(function(block) {
            // parse each structure block (1-char + 2-digits)
            var format, pattern = block.slice(0, 1), repeats = parseInt(block.slice(1), 10);
            switch(pattern){
                case "A":
                    format = "0-9A-Za-z";
                    break;
                case "B":
                    format = "0-9A-Z";
                    break;
                case "C":
                    format = "A-Za-z";
                    break;
                case "F":
                    format = "0-9";
                    break;
                case "L":
                    format = "a-z";
                    break;
                case "U":
                    format = "A-Z";
                    break;
                case "W":
                    format = "0-9a-z";
                    break;
            }
            return '([' + format + ']{' + repeats + '})';
        });
        return new RegExp('^' + regex.join('') + '$');
    }
    /**
     *
     * @param iban
     * @returns {string}
     */ function electronicFormat(iban) {
        return iban.replace(NON_ALPHANUM, '').toUpperCase();
    }
    /**
     * Create a new Specification for a valid IBAN number.
     *
     * @param countryCode the code of the country
     * @param length the length of the IBAN
     * @param structure the structure of the underlying BBAN (for validation and formatting)
     * @param example an example valid IBAN
     * @constructor
     */ function Specification(countryCode, length, structure, example) {
        this.countryCode = countryCode;
        this.length = length;
        this.structure = structure;
        this.example = example;
    }
    /**
     * Lazy-loaded regex (parse the structure and construct the regular expression the first time we need it for validation)
     */ Specification.prototype._regex = function() {
        return this._cachedRegex || (this._cachedRegex = parseStructure(this.structure));
    };
    /**
     * Check if the passed iban is valid according to this specification.
     *
     * @param {String} iban the iban to validate
     * @returns {boolean} true if valid, false otherwise
     */ Specification.prototype.isValid = function(iban) {
        return this.length == iban.length && this.countryCode === iban.slice(0, 2) && this._regex().test(iban.slice(4)) && iso7064Mod97_10(iso13616Prepare(iban)) == 1;
    };
    /**
     * Convert the passed IBAN to a country-specific BBAN.
     *
     * @param iban the IBAN to convert
     * @param separator the separator to use between BBAN blocks
     * @returns {string} the BBAN
     */ Specification.prototype.toBBAN = function(iban, separator) {
        return this._regex().exec(iban.slice(4)).slice(1).join(separator);
    };
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @param bban the BBAN to convert to IBAN
     * @returns {string} the IBAN
     */ Specification.prototype.fromBBAN = function(bban) {
        if (!this.isValidBBAN(bban)) throw new Error('Invalid BBAN');
        var remainder = iso7064Mod97_10(iso13616Prepare(this.countryCode + '00' + bban)), checkDigit = ('0' + (98 - remainder)).slice(-2);
        return this.countryCode + checkDigit + bban;
    };
    /**
     * Check of the passed BBAN is valid.
     * This function only checks the format of the BBAN (length and matching the letetr/number specs) but does not
     * verify the check digit.
     *
     * @param bban the BBAN to validate
     * @returns {boolean} true if the passed bban is a valid BBAN according to this specification, false otherwise
     */ Specification.prototype.isValidBBAN = function(bban) {
        return this.length - 4 == bban.length && this._regex().test(bban);
    };
    var countries = {};
    function addSpecification(IBAN) {
        countries[IBAN.countryCode] = IBAN;
    }
    addSpecification(new Specification("AD", 24, "F04F04A12", "AD1200012030200359100100"));
    addSpecification(new Specification("AE", 23, "F03F16", "AE070331234567890123456"));
    addSpecification(new Specification("AL", 28, "F08A16", "AL47212110090000000235698741"));
    addSpecification(new Specification("AT", 20, "F05F11", "AT611904300234573201"));
    addSpecification(new Specification("AZ", 28, "U04A20", "AZ21NABZ00000000137010001944"));
    addSpecification(new Specification("BA", 20, "F03F03F08F02", "BA391290079401028494"));
    addSpecification(new Specification("BE", 16, "F03F07F02", "BE68539007547034"));
    addSpecification(new Specification("BG", 22, "U04F04F02A08", "BG80BNBG96611020345678"));
    addSpecification(new Specification("BH", 22, "U04A14", "BH67BMAG00001299123456"));
    addSpecification(new Specification("BR", 29, "F08F05F10U01A01", "BR9700360305000010009795493P1"));
    addSpecification(new Specification("BY", 28, "A04F04A16", "BY13NBRB3600900000002Z00AB00"));
    addSpecification(new Specification("CH", 21, "F05A12", "CH9300762011623852957"));
    addSpecification(new Specification("CR", 22, "F04F14", "CR72012300000171549015"));
    addSpecification(new Specification("CY", 28, "F03F05A16", "CY17002001280000001200527600"));
    addSpecification(new Specification("CZ", 24, "F04F06F10", "CZ6508000000192000145399"));
    addSpecification(new Specification("DE", 22, "F08F10", "DE89370400440532013000"));
    addSpecification(new Specification("DK", 18, "F04F09F01", "DK5000400440116243"));
    addSpecification(new Specification("DO", 28, "U04F20", "DO28BAGR00000001212453611324"));
    addSpecification(new Specification("EE", 20, "F02F02F11F01", "EE382200221020145685"));
    addSpecification(new Specification("ES", 24, "F04F04F01F01F10", "ES9121000418450200051332"));
    addSpecification(new Specification("FI", 18, "F06F07F01", "FI2112345600000785"));
    addSpecification(new Specification("FO", 18, "F04F09F01", "FO6264600001631634"));
    addSpecification(new Specification("FR", 27, "F05F05A11F02", "FR1420041010050500013M02606"));
    addSpecification(new Specification("GB", 22, "U04F06F08", "GB29NWBK60161331926819"));
    addSpecification(new Specification("GE", 22, "U02F16", "GE29NB0000000101904917"));
    addSpecification(new Specification("GI", 23, "U04A15", "GI75NWBK000000007099453"));
    addSpecification(new Specification("GL", 18, "F04F09F01", "GL8964710001000206"));
    addSpecification(new Specification("GR", 27, "F03F04A16", "GR1601101250000000012300695"));
    addSpecification(new Specification("GT", 28, "A04A20", "GT82TRAJ01020000001210029690"));
    addSpecification(new Specification("HR", 21, "F07F10", "HR1210010051863000160"));
    addSpecification(new Specification("HU", 28, "F03F04F01F15F01", "HU42117730161111101800000000"));
    addSpecification(new Specification("IE", 22, "U04F06F08", "IE29AIBK93115212345678"));
    addSpecification(new Specification("IL", 23, "F03F03F13", "IL620108000000099999999"));
    addSpecification(new Specification("IS", 26, "F04F02F06F10", "IS140159260076545510730339"));
    addSpecification(new Specification("IT", 27, "U01F05F05A12", "IT60X0542811101000000123456"));
    addSpecification(new Specification("IQ", 23, "U04F03A12", "IQ98NBIQ850123456789012"));
    addSpecification(new Specification("JO", 30, "A04F22", "JO15AAAA1234567890123456789012"));
    addSpecification(new Specification("KW", 30, "U04A22", "KW81CBKU0000000000001234560101"));
    addSpecification(new Specification("KZ", 20, "F03A13", "KZ86125KZT5004100100"));
    addSpecification(new Specification("LB", 28, "F04A20", "LB62099900000001001901229114"));
    addSpecification(new Specification("LC", 32, "U04F24", "LC07HEMM000100010012001200013015"));
    addSpecification(new Specification("LI", 21, "F05A12", "LI21088100002324013AA"));
    addSpecification(new Specification("LT", 20, "F05F11", "LT121000011101001000"));
    addSpecification(new Specification("LU", 20, "F03A13", "LU280019400644750000"));
    addSpecification(new Specification("LV", 21, "U04A13", "LV80BANK0000435195001"));
    addSpecification(new Specification("MC", 27, "F05F05A11F02", "MC5811222000010123456789030"));
    addSpecification(new Specification("MD", 24, "U02A18", "MD24AG000225100013104168"));
    addSpecification(new Specification("ME", 22, "F03F13F02", "ME25505000012345678951"));
    addSpecification(new Specification("MK", 19, "F03A10F02", "MK07250120000058984"));
    addSpecification(new Specification("MR", 27, "F05F05F11F02", "MR1300020001010000123456753"));
    addSpecification(new Specification("MT", 31, "U04F05A18", "MT84MALT011000012345MTLCAST001S"));
    addSpecification(new Specification("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR"));
    addSpecification(new Specification("NL", 18, "U04F10", "NL91ABNA0417164300"));
    addSpecification(new Specification("NO", 15, "F04F06F01", "NO9386011117947"));
    addSpecification(new Specification("PK", 24, "U04A16", "PK36SCBL0000001123456702"));
    addSpecification(new Specification("PL", 28, "F08F16", "PL61109010140000071219812874"));
    addSpecification(new Specification("PS", 29, "U04A21", "PS92PALS000000000400123456702"));
    addSpecification(new Specification("PT", 25, "F04F04F11F02", "PT50000201231234567890154"));
    addSpecification(new Specification("QA", 29, "U04A21", "QA30AAAA123456789012345678901"));
    addSpecification(new Specification("RO", 24, "U04A16", "RO49AAAA1B31007593840000"));
    addSpecification(new Specification("RS", 22, "F03F13F02", "RS35260005601001611379"));
    addSpecification(new Specification("SA", 24, "F02A18", "SA0380000000608010167519"));
    addSpecification(new Specification("SC", 31, "U04F04F16U03", "SC18SSCB11010000000000001497USD"));
    addSpecification(new Specification("SE", 24, "F03F16F01", "SE4550000000058398257466"));
    addSpecification(new Specification("SI", 19, "F05F08F02", "SI56263300012039086"));
    addSpecification(new Specification("SK", 24, "F04F06F10", "SK3112000000198742637541"));
    addSpecification(new Specification("SM", 27, "U01F05F05A12", "SM86U0322509800000000270100"));
    addSpecification(new Specification("ST", 25, "F08F11F02", "ST68000100010051845310112"));
    addSpecification(new Specification("SV", 28, "U04F20", "SV62CENR00000000000000700025"));
    addSpecification(new Specification("TL", 23, "F03F14F02", "TL380080012345678910157"));
    addSpecification(new Specification("TN", 24, "F02F03F13F02", "TN5910006035183598478831"));
    addSpecification(new Specification("TR", 26, "F05F01A16", "TR330006100519786457841326"));
    addSpecification(new Specification("UA", 29, "F25", "UA511234567890123456789012345"));
    addSpecification(new Specification("VA", 22, "F18", "VA59001123000012345678"));
    addSpecification(new Specification("VG", 24, "U04F16", "VG96VPVG0000012345678901"));
    addSpecification(new Specification("XK", 20, "F04F10F02", "XK051212012345678906"));
    // The following countries are not included in the official IBAN registry but use the IBAN specification
    // Angola
    addSpecification(new Specification("AO", 25, "F21", "AO69123456789012345678901"));
    // Burkina
    addSpecification(new Specification("BF", 27, "F23", "BF2312345678901234567890123"));
    // Burundi
    addSpecification(new Specification("BI", 16, "F12", "BI41123456789012"));
    // Benin
    addSpecification(new Specification("BJ", 28, "F24", "BJ39123456789012345678901234"));
    // Ivory
    addSpecification(new Specification("CI", 28, "U02F22", "CI70CI1234567890123456789012"));
    // Cameron
    addSpecification(new Specification("CM", 27, "F23", "CM9012345678901234567890123"));
    // Cape Verde
    addSpecification(new Specification("CV", 25, "F21", "CV30123456789012345678901"));
    // Algeria
    addSpecification(new Specification("DZ", 24, "F20", "DZ8612345678901234567890"));
    // Iran
    addSpecification(new Specification("IR", 26, "F22", "IR861234568790123456789012"));
    // Madagascar
    addSpecification(new Specification("MG", 27, "F23", "MG1812345678901234567890123"));
    // Mali
    addSpecification(new Specification("ML", 28, "U01F23", "ML15A12345678901234567890123"));
    // Mozambique
    addSpecification(new Specification("MZ", 25, "F21", "MZ25123456789012345678901"));
    // Senegal
    addSpecification(new Specification("SN", 28, "U01F23", "SN52A12345678901234567890123"));
    var NON_ALPHANUM = /[^a-zA-Z0-9]/g, EVERY_FOUR_CHARS = /(.{4})(?!$)/g;
    /**
     * Utility function to check if a variable is a String.
     *
     * @param v
     * @returns {boolean} true if the passed variable is a String, false otherwise.
     */ function isString(v) {
        return typeof v == 'string' || v instanceof String;
    }
    /**
     * Check if an IBAN is valid.
     *
     * @param {String} iban the IBAN to validate.
     * @returns {boolean} true if the passed IBAN is valid, false otherwise
     */ exports1.isValid = function(iban) {
        if (!isString(iban)) return false;
        iban = electronicFormat(iban);
        var countryStructure = countries[iban.slice(0, 2)];
        return !!countryStructure && countryStructure.isValid(iban);
    };
    /**
     * Convert an IBAN to a BBAN.
     *
     * @param iban
     * @param {String} [separator] the separator to use between the blocks of the BBAN, defaults to ' '
     * @returns {string|*}
     */ exports1.toBBAN = function(iban, separator) {
        if (typeof separator == 'undefined') separator = ' ';
        iban = electronicFormat(iban);
        var countryStructure = countries[iban.slice(0, 2)];
        if (!countryStructure) throw new Error('No country with code ' + iban.slice(0, 2));
        return countryStructure.toBBAN(iban, separator);
    };
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @param countryCode the country of the BBAN
     * @param bban the BBAN to convert to IBAN
     * @returns {string} the IBAN
     */ exports1.fromBBAN = function(countryCode, bban) {
        var countryStructure = countries[countryCode];
        if (!countryStructure) throw new Error('No country with code ' + countryCode);
        return countryStructure.fromBBAN(electronicFormat(bban));
    };
    /**
     * Check the validity of the passed BBAN.
     *
     * @param countryCode the country of the BBAN
     * @param bban the BBAN to check the validity of
     */ exports1.isValidBBAN = function(countryCode, bban) {
        if (!isString(bban)) return false;
        var countryStructure = countries[countryCode];
        return countryStructure && countryStructure.isValidBBAN(electronicFormat(bban));
    };
    /**
     *
     * @param iban
     * @param separator
     * @returns {string}
     */ exports1.printFormat = function(iban, separator) {
        if (typeof separator == 'undefined') separator = ' ';
        return electronicFormat(iban).replace(EVERY_FOUR_CHARS, "$1" + separator);
    };
    exports1.electronicFormat = electronicFormat;
    /**
     * An object containing all the known IBAN specifications.
     */ exports1.countries = countries;
});

});

parcelRegister("gk2kn", function(module, exports) {

$parcel$export(module.exports, "BigBankToWalletIcon", function () { return $db577cade2351cb5$export$3faef5e302b43f84; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $db577cade2351cb5$export$3faef5e302b43f84(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "24",
        height: "24",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("g", {
            fill: props.fill,
            fillRule: "nonzero",
            children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M16.388 12.386h1.875v4.489h-1.875zM12.838 12.386h1.875v4.489h-1.875zM9.287 12.386h1.875v4.489H9.287zM5.737 12.386h1.875v4.489H5.737zM18.888 10.98v-.47H5.112v.47c0 .258.21.468.469.468H18.42c.258 0 .468-.21.468-.469zM19.531 17.813H4.469A.469.469 0 0 0 4 18.28v1.25c0 .26.21.469.47.469H19.53c.259 0 .469-.21.469-.469v-1.25a.469.469 0 0 0-.469-.468zM4.469 9.573H19.53a.469.469 0 0 0 .246-.868L12.246 4.07a.469.469 0 0 0-.492 0L4.223 8.705a.469.469 0 0 0 .246.868zm7.212-2.816h.638a.469.469 0 1 1 0 .938h-.638a.469.469 0 1 1 0-.938z"
            })
        })
    });
}

});


parcelRegister("keeMv", function(module, exports) {

$parcel$export(module.exports, "SelectRechargeByCardAmount", function () { return $cce9c0863737e156$export$3de967ecf2edf834; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5P656 = parcelRequire("5P656");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $kZQT0 = parcelRequire("kZQT0");

var $2Rggt = parcelRequire("2Rggt");

var $2X4v0 = parcelRequire("2X4v0");

var $1TLtu = parcelRequire("1TLtu");

var $gDlNU = parcelRequire("gDlNU");

var $bZlaH = parcelRequire("bZlaH");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $5rJrd = parcelRequire("5rJrd");

var $baGfh = parcelRequire("baGfh");

var $22v9q = parcelRequire("22v9q");
const $cce9c0863737e156$export$3de967ecf2edf834 = (props)=>{
    const { account: account, errorMessage: errorMessage, loading: loading, owner: owner, submitAmount: submitAmount } = props;
    const { balance: balance } = (0, $kZQT0.useAccountBalance)(account);
    const [amount, setAmount] = (0, $6uYXW.useState)(new (0, $5P656.Amount)(0, account.currencyAlpha));
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const displayName = (0, $2Rggt.useClientDisplayName)(owner, true);
    const gender = owner?.gender ?? (0, $2X4v0.Gender).None;
    const accountDisplayName = (0, $6uYXW.useMemo)(()=>account.type === (0, $kGswT.AccountType).Dedicated && (0, $gDlNU.isDefined)(account.merchant) && account.merchant.length > 0 ? account.merchant : formatMessage((0, $1TLtu.nameWithGenderLabels)[gender], {
            name: displayName
        }), [
        account.type,
        account.merchant,
        displayName,
        gender,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($cce9c0863737e156$var$ContentContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($cce9c0863737e156$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$HeaderLogo, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$IconContainer, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $baGfh.RechargeCardIcon), {
                                width: 24,
                                height: 24,
                                fill: (0, $22v9q.theme).mainColor()
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($cce9c0863737e156$var$HeaderContentContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$Title, {
                                children: formatMessage("rechargeByCard.title")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$Subtitle, {
                                children: formatMessage("rechargeByCard.subtitle")
                            })
                        ]
                    })
                ]
            }),
            (0, $gDlNU.isDefined)(errorMessage) && /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$StyledErrorMessage, {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($cce9c0863737e156$var$Card, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$CardTitle, {
                        children: formatMessage("rechargeByCard.creditedAccountTitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($cce9c0863737e156$var$CardSection, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)($cce9c0863737e156$var$AccountDetails, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$AccountName, {
                                        children: accountDisplayName
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$AccountId, {
                                        children: formatMessage("rechargeByCard.accountId", {
                                            id: account.id
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$AccountBalance, {
                                amount: balance
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$CardTitle, {
                children: formatMessage("rechargeByCard.amountToCredit")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$StyledAmountInput, {
                value: amount,
                onChange: setAmount
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($cce9c0863737e156$var$Footer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                    size: "S",
                    onClick: ()=>submitAmount(amount),
                    showSpinner: loading,
                    disabled: !(amount.value > 0),
                    children: formatMessage("rechargeByCard.recharge")
                })
            })
        ]
    });
};
const $cce9c0863737e156$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  padding-left: 5px;
  padding-right: 5px;
  margin-top: 20px;
  margin-bottom: 40px;
`;
const $cce9c0863737e156$var$HeaderLogo = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
`;
const $cce9c0863737e156$var$HeaderContentContainer = (0, $jb8NR.default).div`
  flex-direction: column;
`;
const $cce9c0863737e156$var$IconContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: ${()=>(0, $22v9q.theme).mainColorLightBackground()};
`;
const $cce9c0863737e156$var$ContentContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  margin-right: 15px;
`;
const $cce9c0863737e156$var$Title = (0, $jb8NR.default).div`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText}
`;
const $cce9c0863737e156$var$Subtitle = (0, $jb8NR.default).div`
  font-size: 0.8125rem;
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
`;
const $cce9c0863737e156$var$Card = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  background-color: #ffffff;
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  margin-bottom: 16px;
`;
const $cce9c0863737e156$var$CardTitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.9375rem;
  margin-bottom: 5px;
`;
const $cce9c0863737e156$var$CardSection = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 5px;
`;
const $cce9c0863737e156$var$AccountDetails = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $cce9c0863737e156$var$AccountBalance = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  font-size: 1.25rem;
  ${(0, $22v9q.theme).boldText};
  text-align: start;
`;
const $cce9c0863737e156$var$AccountName = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
`;
const $cce9c0863737e156$var$AccountId = (0, $jb8NR.default).div`
  font-size: 0.8125rem;
  ${(0, $22v9q.theme).boldText};
  color: #b1b1b1;
`;
const $cce9c0863737e156$var$StyledAmountInput = (0, $jb8NR.default)((0, $5rJrd.AmountInput))`
  margin-top: 15px;
`;
const $cce9c0863737e156$var$Footer = (0, $jb8NR.default).div`
  display: flex;
  margin-top: 50px;
  justify-content: center;
`;
const $cce9c0863737e156$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0px 10px 0px;
  text-align: center;
`;

});
parcelRegister("kZQT0", function(module, exports) {

$parcel$export(module.exports, "useAccountBalance", function () { return $226e7737a2d29266$export$43dbd70fcc10516e; });

var $5P656 = parcelRequire("5P656");
function $226e7737a2d29266$export$43dbd70fcc10516e(account) {
    const balance = account.balances[0];
    return {
        balance: new (0, $5P656.Amount)(balance.value, balance.currency)
    };
}

});


parcelRegister("cHBpO", function(module, exports) {

$parcel$export(module.exports, "RechargeMethodSelection", function () { return $e0b53e9f579502ca$export$1f8f16a073e4d7d1; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $jGFoX = parcelRequire("jGFoX");

var $cG3cd = parcelRequire("cG3cd");

var $fzf6B = parcelRequire("fzf6B");

var $7iia7 = parcelRequire("7iia7");

var $aeCtF = parcelRequire("aeCtF");

var $baGfh = parcelRequire("baGfh");

var $9BpLd = parcelRequire("9BpLd");

var $22v9q = parcelRequire("22v9q");
const $e0b53e9f579502ca$export$1f8f16a073e4d7d1 = (props)=>{
    const { selectMethod: selectMethod } = props;
    const { data: data } = (0, $cG3cd.useExternalAccounts)();
    const externalAccount = data?.[0];
    const externalAccountIBAN = externalAccount?.iban;
    const { hasRechargeByCard: hasRechargeByCard, hasBankToWallet: hasBankToWallet } = (0, $jGFoX.getAvailableRechargeMethod)(externalAccountIBAN);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const externalBank = externalAccount?.bankName?.toUpperCase();
    return /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$ContentContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$Title, {
                        children: formatMessage("rechargeMethod.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$Subtitle, {
                        children: formatMessage("rechargeMethod.subtitle")
                    })
                ]
            }),
            hasRechargeByCard && /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$Card, {
                onClick: ()=>selectMethod((0, $fzf6B.RechargeMethod).WITH_CARD),
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$LeftColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$CardTitle, {
                                children: formatMessage("rechargeMethod.withCard.title")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$CardDescription, {
                                children: formatMessage("rechargeMethod.withCard.description")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$TagContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7iia7.FlashIcon), {
                                        fill: (0, $22v9q.theme).mainColor()
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$Tag, {
                                        children: formatMessage("rechargeMethod.withCard.instantTag")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$RightColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$IconContainer, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $baGfh.RechargeCardIcon), {
                                    fill: (0, $22v9q.theme).mainColor()
                                })
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $9BpLd.SmallChevronIcon), {})
                        ]
                    })
                ]
            }),
            hasBankToWallet && /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$Card, {
                onClick: ()=>selectMethod((0, $fzf6B.RechargeMethod).BANK_TO_WALLET),
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$LeftColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$CardTitle, {
                                children: formatMessage("rechargeMethod.bankDebit.title")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$CardDescription, {
                                children: externalBank ? formatMessage("rechargeMethod.bankDebit.description", {
                                    bankName: externalBank
                                }) : formatMessage("rechargeMethod.bankDebit.noBankDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($e0b53e9f579502ca$var$RightColumn, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($e0b53e9f579502ca$var$IconContainer, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $aeCtF.RechargeBankToWalletIcon), {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    fill: (0, $22v9q.theme).mainColor()
                                })
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $9BpLd.SmallChevronIcon), {})
                        ]
                    })
                ]
            })
        ]
    });
};
const $e0b53e9f579502ca$var$Header = (0, $jb8NR.default).div`
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
`;
const $e0b53e9f579502ca$var$ContentContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $e0b53e9f579502ca$var$Title = (0, $jb8NR.default).div`
  font-size: 1.375rem;
  ${(0, $22v9q.theme).boldText}
`;
const $e0b53e9f579502ca$var$Subtitle = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
  margin-bottom: 40px;
`;
const $e0b53e9f579502ca$var$Card = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  padding: 18px;
  background-color: #ffffff;
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  margin-bottom: 16px;
  &:hover {
    cursor: pointer;
  }
`;
const $e0b53e9f579502ca$var$CardTitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.9375rem;
  margin-bottom: 5px;
`;
const $e0b53e9f579502ca$var$CardDescription = (0, $jb8NR.default).div`
  font-size: 0.75rem;
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
  margin-bottom: 15px;
`;
const $e0b53e9f579502ca$var$LeftColumn = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding-right: 50px;
`;
const $e0b53e9f579502ca$var$RightColumn = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;
const $e0b53e9f579502ca$var$IconContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background-color: ${()=>(0, $22v9q.theme).mainColorLightBackground()};
`;
const $e0b53e9f579502ca$var$TagContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  background-color: ${()=>(0, $22v9q.theme).mainColorLightBackground()};
  border-radius: 13px;
  height: 20px;
  align-items: center;
  align-self: flex-start;
  padding-left: 5px;
  padding-right: 10px;
`;
const $e0b53e9f579502ca$var$Tag = (0, $jb8NR.default).div`
  font-size: 0.625rem;
  ${(0, $22v9q.theme).boldText}
  color: ${(0, $22v9q.theme).mainColor}
`;

});
parcelRegister("7iia7", function(module, exports) {

$parcel$export(module.exports, "FlashIcon", function () { return $ccf8fb0fdbecd0d2$export$e961de20d49c102f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $ccf8fb0fdbecd0d2$export$e961de20d49c102f(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "16",
        height: "17",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M10.445 7.466a.165.165 0 0 0-.146-.096H8.103l.368-3.16c.008-.088-.038-.17-.111-.2-.074-.028-.155.003-.198.076l-2.67 5.257a.209.209 0 0 0-.004.191c.03.06.086.096.146.096h2.164l-.292 3.166c-.006.087.041.167.115.194.073.028.154-.005.195-.078l2.627-5.257a.209.209 0 0 0 .002-.19z",
            fill: props.fill,
            fillRule: "nonzero"
        })
    });
}

});




parcelRegister("4SmBi", function(module, exports) {

$parcel$export(module.exports, "RecipientsScreen", function () { return $e0f86a0e5ab14187$export$a1e60ea5b5b5ca1a; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $42awV = parcelRequire("42awV");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $h6mRe = parcelRequire("h6mRe");

var $Y6t65 = parcelRequire("Y6t65");

var $3Ersk = parcelRequire("3Ersk");

var $gf0cb = parcelRequire("gf0cb");

var $bQhUC = parcelRequire("bQhUC");

var $yYT9n = parcelRequire("yYT9n");

var $finOR = parcelRequire("finOR");

var $5Wai4 = parcelRequire("5Wai4");

var $amCCH = parcelRequire("amCCH");

var $jEKif = parcelRequire("jEKif");

var $3yllK = parcelRequire("3yllK");

var $k4kME = parcelRequire("k4kME");

var $bfYs4 = parcelRequire("bfYs4");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $flGUg = parcelRequire("flGUg");

var $4f5zl = parcelRequire("4f5zl");

var $4ukWa = parcelRequire("4ukWa");

var $lQ83Z = parcelRequire("lQ83Z");

var $jHUm0 = parcelRequire("jHUm0");

var $kuv12 = parcelRequire("kuv12");

var $1MEJh = parcelRequire("1MEJh");
var $e0f86a0e5ab14187$export$8a464123678aad61 = /*#__PURE__*/ function(TransferDestination) {
    TransferDestination[TransferDestination["Beneficiaries"] = 0] = "Beneficiaries";
    TransferDestination[TransferDestination["ExternalAccounts"] = 1] = "ExternalAccounts";
    return TransferDestination;
}({});
function $e0f86a0e5ab14187$export$a1e60ea5b5b5ca1a() {
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const recipients = (0, $h6mRe.useBeneficiaries)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const [search, setSearch] = (0, $6uYXW.useState)(undefined);
    const loadMoreDebounce = (0, $Y6t65.useLoadMoreDebounce)();
    const [destination, setDestination] = (0, $6uYXW.useState)(features.beneficiariesManagement || features.beneficiariesUsage ? 0 : features.externalAccountsManagement || features.externalAccountsUsage ? 1 : undefined);
    const filteredRecipients = (0, $6uYXW.useMemo)(()=>search ? recipients.data.filter((r)=>(0, $gf0cb.caseInsensitiveIncludes)(r.name, search) || (0, $gf0cb.caseInsensitiveIncludes)(r.phone, search)) : recipients.data, [
        recipients.data,
        search
    ]);
    const loadMore = (0, $6uYXW.useCallback)(()=>loadMoreDebounce(recipients.loadMore, recipients.loading, recipients.canLoadMore), [
        loadMoreDebounce,
        recipients.canLoadMore,
        recipients.loadMore,
        recipients.loading
    ]);
    const openAddBeneficiaryModal = (name, forExternalAccount)=>(0, $5Wai4.Modal).present((0, $bQhUC.ADD_RECIPIENT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4f5zl.AddBeneficiaryModal), {
                initialName: name,
                forExternalAccount: forExternalAccount
            }), {
            canBeDismissed: false
        });
    const openEditBeneficiaryModal = (recipient, forExternalAccount)=>(0, $5Wai4.Modal).present((0, $bQhUC.EDIT_RECIPIENT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4ukWa.EditBeneficiaryModal), {
                recipient: recipient,
                forExternalAccount: forExternalAccount
            }), {
            canBeDismissed: false
        });
    const openRecipientDetailModal = (recipient)=>(0, $5Wai4.Modal).present((0, $bQhUC.TRANSFER_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $kuv12.RecipientDetailModal), {
                recipient: recipient
            }), {
            canBeDismissed: false
        });
    const hasRecipients = (0, $6uYXW.useMemo)(()=>destination === 0 ? recipients.data.length > 0 : false, [
        destination,
        recipients.data.length
    ]);
    const handleSetSearch = (value)=>{
        setSearch(value);
    };
    const handleSetDestination = (value)=>{
        handleSetSearch("");
        setDestination(value);
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$Title, {
                children: formatMessage("recipient.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$Subtitle, {
                children: formatMessage("recipient.subtitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($e0f86a0e5ab14187$var$RecipientHeader, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$SelectorContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $3yllK.Selector), {
                            size: "L",
                            options: [
                                {
                                    value: 0,
                                    text: formatMessage("recipient.selector.beneficiaries"),
                                    key: "recipients",
                                    disabled: !features.beneficiariesUsage
                                },
                                {
                                    value: 1,
                                    text: formatMessage("recipient.selector.externalAccounts"),
                                    key: "externalAccount",
                                    disabled: !features.externalAccountsUsage
                                }
                            ],
                            value: destination,
                            onChange: handleSetDestination
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$Spacer, {}),
                    (hasRecipients || destination === 1) && /*#__PURE__*/ (0, $4m918.jsx)((0, $finOR.SearchBar), {
                        value: search,
                        placeholder: formatMessage("recipient.searchInputPlaceholder"),
                        initialValue: search || "",
                        onChange: handleSetSearch
                    })
                ]
            }),
            destination === 0 && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    hasRecipients && features.beneficiariesManagement && features.recipientCreate && /*#__PURE__*/ (0, $4m918.jsxs)($e0f86a0e5ab14187$var$AddBeneficiaryContainer, {
                        onClick: (0, $flGUg.performTaskIfPossible)(openAddBeneficiaryModal),
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$RoundContainer, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bfYs4.PlusIcon), {
                                    width: 18,
                                    height: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$AddBeneficiaryLabel, {
                                children: formatMessage("recipient.addRecipientButton")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$RecipientSection, {
                        $isRTL: isRTL,
                        children: formatMessage("recipient.section")
                    }),
                    !hasRecipients ? recipients.loading ? /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$StyledMainColorSpinner, {}) : /*#__PURE__*/ (0, $4m918.jsx)((0, $lQ83Z.EmptyBlock), {
                        title: formatMessage("recipient.noRecipientsAvailable"),
                        message: formatMessage("recipient.noRecipientsMessage"),
                        button: formatMessage("recipient.addRecipientButton"),
                        onClick: features.beneficiariesManagement ? (0, $flGUg.performTaskIfPossible)(openAddBeneficiaryModal) : undefined
                    }) : /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$StyledInfiniteScroll, {
                        loadMore: loadMore,
                        hasMore: recipients.canLoadMore,
                        loader: /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$StyledMainColorSpinner, {}),
                        children: recipients.loading ? /*#__PURE__*/ (0, $4m918.jsx)($e0f86a0e5ab14187$var$StyledMainColorSpinner, {}) : filteredRecipients.map((recipient)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $1MEJh.RecipientRow), {
                                recipient: recipient,
                                onEdit: (0, $flGUg.performTaskIfPossible)(()=>openEditBeneficiaryModal(recipient)),
                                onClick: (0, $flGUg.performTaskIfPossible)(()=>openRecipientDetailModal(recipient)),
                                isRTL: isRTL,
                                readonly: !features.beneficiariesManagement
                            }, recipient.id))
                    }),
                    " "
                ]
            }),
            destination === 1 && /*#__PURE__*/ (0, $4m918.jsx)((0, $jHUm0.ExternalAccountsView), {
                search: search
            })
        ]
    });
}
const $e0f86a0e5ab14187$var$StyledInfiniteScroll = (0, $jb8NR.default)((0, (/*@__PURE__*/$parcel$interopDefault($42awV))))`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;
const $e0f86a0e5ab14187$var$StyledMainColorSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: 40px auto 0 auto;
`;
const $e0f86a0e5ab14187$var$RecipientSection = (0, $jb8NR.default)((0, $jEKif.PageSectionTitle))`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).mediumText};
  margin-left: ${(props)=>props.$isRTL ? 10 : 0}px;
  margin-right: ${(props)=>props.$isRTL ? 0 : 10}px;
`;
const $e0f86a0e5ab14187$var$Spacer = (0, $jb8NR.default).div`
  flex-grow: 1;
  flex-shrink: 1;
`;
const $e0f86a0e5ab14187$var$RecipientHeader = (0, $jb8NR.default)((0, $amCCH.PageHeader))`
  align-self: stretch;
  display: flex;
  justify-content: center;
`;
const $e0f86a0e5ab14187$var$Title = (0, $jb8NR.default).span`
  font-size: 1.5625rem;
  ${(0, $22v9q.theme).boldText};
  color: ${(0, $22v9q.theme).mainColor};
  white-space: pre;
`;
const $e0f86a0e5ab14187$var$Subtitle = (0, $jb8NR.default)($e0f86a0e5ab14187$var$Title)`
  margin-bottom: 40px;
  line-height: 32px;
  height: auto;
  flex-grow: 0;
  color: black;
  width: 330px;
  overflow-wrap: break-word;
  white-space: pre-line;
`;
const $e0f86a0e5ab14187$var$SelectorContainer = (0, $jb8NR.default).div`
  margin-top: 8px;
  margin-bottom: 8px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-bottom: 32px;
  }
`;
const $e0f86a0e5ab14187$var$AddBeneficiaryContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
  margin-top: 32px;
  margin-bottom: 32px;
  margin-left: 12px;
  margin-right: 12px;
  :hover {
    cursor: pointer;
  }
`;
const $e0f86a0e5ab14187$var$AddBeneficiaryLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.9375rem;
  text-align: left;
  margin-right: 16px;
  margin-left: 16px;
`;
const $e0f86a0e5ab14187$var$RoundContainer = (0, $jb8NR.default).div`
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background-color: #ececec;
  align-items: center;
  justify-content: center;
`;

});
parcelRegister("h6mRe", function(module, exports) {

$parcel$export(module.exports, "useBeneficiaries", function () { return $e9937010d4a26ccf$export$350d6415f7aa75f1; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
function $e9937010d4a26ccf$export$350d6415f7aa75f1() {
    const [refreshing, setRefreshing] = (0, $6uYXW.useState)(false);
    const rawData = (0, $3Ersk.useObservable)((0, $kqXxS.beneficiaryManager).recipients);
    const loading = (0, $3Ersk.useObservable)((0, $kqXxS.beneficiaryManager).loading);
    const error = (0, $3Ersk.useObservable)((0, $kqXxS.beneficiaryManager).error);
    const loadingMore = (0, $3Ersk.useObservable)((0, $kqXxS.beneficiaryManager).loadingMore);
    const loadingMoreError = (0, $3Ersk.useObservable)((0, $kqXxS.beneficiaryManager).loadingMoreError);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await (0, $kqXxS.beneficiaryManager).load();
    }, []);
    const refresh = (0, $6uYXW.useCallback)(async ()=>{
        setRefreshing(true);
        await (0, $kqXxS.beneficiaryManager).load(true);
        setRefreshing(false);
    }, []);
    const canLoadMore = rawData.offset + rawData.limit < rawData.total;
    const data = (0, $6uYXW.useMemo)(()=>rawData.items.filter((item)=>item.state === "opened"), [
        rawData.items
    ]);
    const loadMore = (0, $6uYXW.useCallback)(async ()=>{
        await (0, $kqXxS.beneficiaryManager).loadMore();
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        canLoadMore: canLoadMore,
        loadMore: loadMore,
        loadingMore: loadingMore,
        loadingMoreError: loadingMoreError,
        refresh: refresh,
        refreshing: refreshing
    };
}

});

parcelRegister("4f5zl", function(module, exports) {

$parcel$export(module.exports, "AddBeneficiaryModal", function () { return $48abaaebce63bf66$export$c92831e53f2825c; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $e4wja = parcelRequire("e4wja");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $40sjz = parcelRequire("40sjz");

var $lCkWa = parcelRequire("lCkWa");

var $eyjPK = parcelRequire("eyjPK");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $hxiRk = parcelRequire("hxiRk");

var $k4kME = parcelRequire("k4kME");

var $hvFeR = parcelRequire("hvFeR");

var $eVUP7 = parcelRequire("eVUP7");

var $9n8k8 = parcelRequire("9n8k8");

var $8Mjlc = parcelRequire("8Mjlc");
const $48abaaebce63bf66$var$notCancellableState = [
    (0, $lCkWa.RecipientState).RequestingRecipient,
    (0, $lCkWa.RecipientState).OTPConfirming,
    (0, $lCkWa.RecipientState).OTPRefreshing
];
const $48abaaebce63bf66$export$c92831e53f2825c = (props)=>{
    const { initialName: initialName, forExternalAccount: forExternalAccount } = props;
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const { state: state, context: context, createPhoneRecipient: createPhoneRecipient, confirmOtp: confirmOtp, cancelStrongAuthentication: cancelStrongAuthentication, submitPincode: submitPincode, createIbanRecipient: createIbanRecipient, createAccountRecipient: createAccountRecipient, searchBank: searchBank, updateBankName: updateBankName, sendOtpAgain: sendOtpAgain, dismissPollingSessionStateModal: dismissPollingSessionStateModal } = (0, $lCkWa.useRecipientMachine)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { client: client } = (0, $7N0kU.useClient)();
    const handleCloseModal = (0, $6uYXW.useCallback)(()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.ADD_RECIPIENT_MODAL_ID)), []);
    const handleCloseAndCancelStrongAuth = (0, $6uYXW.useCallback)(()=>{
        const recipient = context.recipientToAdd;
        if (recipient?.strongAuthentication?.strongAuthenticationToken) cancelStrongAuthentication();
        handleCloseModal();
    }, [
        context.recipientToAdd
    ]);
    const [formState, setFormState] = (0, $6uYXW.useState)({
        name: initialName || "",
        account: ""
    });
    const innerStepContent = (0, $6uYXW.useMemo)(()=>{
        const errorMessage = context.errorMessage;
        switch(state){
            case (0, $lCkWa.RecipientState).RequestingRecipient:
            case (0, $lCkWa.RecipientState).CreatingRecipient:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $eVUP7.AddBeneficiaryDetail), {
                    createPhoneRecipient: createPhoneRecipient,
                    createIbanRecipient: createIbanRecipient,
                    createAccountRecipient: createAccountRecipient,
                    searchBank: searchBank,
                    loading: state === (0, $lCkWa.RecipientState).RequestingRecipient,
                    errorMessage: errorMessage,
                    initialName: initialName,
                    forExternalAccount: forExternalAccount,
                    bankName: context.bankName,
                    bicCode: context.bicCode,
                    formState: formState,
                    setFormState: setFormState
                });
            case (0, $lCkWa.RecipientState).SearchBank:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $9n8k8.SearchBank), {
                    title: formatMessage("addRecipient.searchBank.title"),
                    onSelect: (bankName, bic)=>{
                        updateBankName(bankName, bic);
                    }
                });
            case (0, $lCkWa.RecipientState).OTPRefreshing:
            case (0, $lCkWa.RecipientState).OTPSubmission:
            case (0, $lCkWa.RecipientState).OTPConfirming:
                const additionalText = context.recipientToAdd?.bankName ? formatMessage("addRecipient.otpAdditionalTextWithBank", {
                    bankName: context.recipientToAdd?.bankName,
                    name: context.recipientToAdd.name
                }) : formatMessage("addRecipient.otpAdditionalText", {
                    name: context.recipientToAdd?.name
                });
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: confirmOtp,
                    sendOtpAgain: sendOtpAgain,
                    cancelOtp: handleCloseAndCancelStrongAuth,
                    onOtpBlocked: handleCloseAndCancelStrongAuth,
                    additionalText: additionalText,
                    errorMessage: errorMessage,
                    refreshingErrorMessage: context.refreshingErrorMessage,
                    phoneNumber: client ? (0, $e4wja.anonymizePhoneNumber)((0, $e4wja.formatPhoneNumber)(client.mobile), 2) : undefined,
                    loading: state === (0, $lCkWa.RecipientState).OTPConfirming,
                    refreshingOtp: state === (0, $lCkWa.RecipientState).OTPRefreshing
                });
            case (0, $40sjz.PincodeState).PincodeConfirmation:
            case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
            case (0, $40sjz.PincodeState).PromptingKeyboard:
                const keyboard = context.keyboard;
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                    keyboard: keyboard,
                    onSubmit: submitPincode,
                    title: formatMessage("pincodeConfirmation.label"),
                    errorMessage: errorMessage,
                    loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError
                });
            case (0, $40sjz.PincodeState).FetchKeyboardAfterErrorPincode:
            case (0, $40sjz.PincodeState).PromptingKeyboardPincode:
                {
                    const keyboardPincode = context.keyboard;
                    return /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                        keyboard: keyboardPincode,
                        onSubmit: submitPincode,
                        title: formatMessage("pincodeConfirmation.label"),
                        errorMessage: errorMessage,
                        loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterErrorPincode
                    });
                }
            case (0, $lCkWa.RecipientState).PollingSessionState:
                {
                    const recipientToAdd = context.recipientToAdd;
                    const strongAuthenticationToken = recipientToAdd?.strongAuthentication?.strongAuthenticationToken;
                    return /*#__PURE__*/ (0, $4m918.jsx)((0, $hxiRk.PollingSessionState), {
                        sessionToken: strongAuthenticationToken,
                        dismissPollingSessionStateModal: dismissPollingSessionStateModal
                    });
                }
            case (0, $lCkWa.RecipientState).PollingSessionStateDismiss:
                return (0, $5Wai4.Modal).dismiss((0, $bQhUC.ADD_RECIPIENT_MODAL_ID));
            case (0, $lCkWa.RecipientState).Done:
                const recipient = context.recipientToAdd;
                return !features.customerInstructionInitiation ? /*#__PURE__*/ (0, $4m918.jsx)((0, $hvFeR.TransferTransaction), {
                    showAvatar: true,
                    showTitle: true,
                    closeModal: handleCloseModal,
                    recipient: recipient
                }) : (0, $5Wai4.Modal).dismiss((0, $bQhUC.ADD_RECIPIENT_MODAL_ID));
            default:
                return /*#__PURE__*/ (0, $4m918.jsx)($48abaaebce63bf66$var$LoadingContainer, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                        size: "30px"
                    })
                });
        }
    }, [
        state,
        context,
        client,
        formState
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (state === (0, $lCkWa.RecipientState).PollingSessionStateDismiss || state === (0, $lCkWa.RecipientState).Done && features.customerInstructionInitiation) (0, $5Wai4.Modal).dismiss((0, $bQhUC.ADD_RECIPIENT_MODAL_ID));
    }, [
        state,
        features.customerInstructionInitiation
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeModal: handleCloseAndCancelStrongAuth,
        closeButton: !$48abaaebce63bf66$var$notCancellableState.includes(state),
        id: (0, $bQhUC.ADD_RECIPIENT_MODAL_ID),
        children: innerStepContent
    });
};
const $48abaaebce63bf66$var$LoadingContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
`;

});
parcelRegister("lCkWa", function(module, exports) {

$parcel$export(module.exports, "useRecipientMachine", function () { return $7de09e9ac9560d59$export$ef2a4310d79949a7; });
$parcel$export(module.exports, "RecipientState", function () { return $7de09e9ac9560d59$export$57d63b5981227ce; });

var $lCuQx = parcelRequire("lCuQx");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $dhPTb = parcelRequire("dhPTb");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $61WqT = parcelRequire("61WqT");

var $f1clM = parcelRequire("f1clM");

var $40sjz = parcelRequire("40sjz");
const $7de09e9ac9560d59$var$REFRESHED_OTP_DELAY = 3000; // 3s
const $7de09e9ac9560d59$export$ef2a4310d79949a7 = ()=>{
    const [state, sendEvent] = (0, $lCuQx.useMachine)($7de09e9ac9560d59$export$69d17264ced165ee);
    const createIbanRecipient = (name, iban, externalAccount)=>{
        sendEvent("CREATE_IBAN_RECIPIENT", {
            name: name,
            iban: iban,
            externalAccount: externalAccount
        });
    };
    const createPhoneRecipient = (name, phone)=>{
        sendEvent("CREATE_PHONE_RECIPIENT", {
            name: name,
            phone: phone
        });
    };
    const createAccountRecipient = (name, account, bic)=>{
        sendEvent("CREATE_ACCOUNT_RECIPIENT", {
            name: name,
            account: account,
            bic: bic
        });
    };
    const searchBank = ()=>{
        sendEvent("SEARCH_BANK");
    };
    const updateBankName = (bankName, bic)=>{
        sendEvent("UPDATE_BANK_NAME", {
            bankName: bankName,
            bic: bic
        });
    };
    const confirmOtp = (otp)=>{
        sendEvent("OTP_CONFIRM", {
            otp: otp
        });
    };
    const sendOtpAgain = ()=>{
        sendEvent("SEND_OTP_AGAIN");
    };
    const cancelStrongAuthentication = ()=>{
        sendEvent("CANCEL_STRONG_AUTH");
    };
    const submitPincode = (submission)=>{
        sendEvent("SUBMIT_PINCODE", {
            pincodeSubmission: submission
        });
    };
    const dismissPollingSessionStateModal = ()=>{
        setTimeout(()=>{
            sendEvent("POLLING_SESSION_STATE_DISMISS");
        }, 5000);
    };
    return {
        state: state.value,
        context: state.context,
        createIbanRecipient: createIbanRecipient,
        createPhoneRecipient: createPhoneRecipient,
        createAccountRecipient: createAccountRecipient,
        searchBank: searchBank,
        updateBankName: updateBankName,
        confirmOtp: confirmOtp,
        cancelStrongAuthentication: cancelStrongAuthentication,
        sendOtpAgain: sendOtpAgain,
        submitPincode: submitPincode,
        dismissPollingSessionStateModal: dismissPollingSessionStateModal
    };
};
var $7de09e9ac9560d59$export$57d63b5981227ce = /*#__PURE__*/ function(RecipientState) {
    RecipientState["CreatingRecipient"] = "CreatingRecipient";
    RecipientState["RequestingRecipient"] = "RequestingRecipient";
    RecipientState["SearchBank"] = "SearchBank";
    RecipientState["OTPSubmission"] = "OTPSubmission";
    RecipientState["OTPConfirming"] = "OTPConfirming";
    RecipientState["OTPRefreshing"] = "OTPRefreshing";
    RecipientState["StrongAuthCancelling"] = "StrongAuthCancelling";
    RecipientState["PincodeConfirming"] = "PincodeConfirming";
    RecipientState["PollingSessionState"] = "PollingSessionState";
    RecipientState["PollingSessionStateDismiss"] = "PollingSessionStateDismiss";
    RecipientState["PincodeOTPSubmission"] = "PincodeOTPSubmission";
    RecipientState["StrongAuthCancellingPincode"] = "StrongAuthCancellingPincode";
    RecipientState["PincodeOtpConfirming"] = "PincodeOtpConfirming";
    RecipientState["Done"] = "Done";
    return RecipientState;
}({});
const $7de09e9ac9560d59$export$69d17264ced165ee = (0, $TAle5.Machine)({
    id: "Recipient",
    initial: "CreatingRecipient",
    states: {
        ["CreatingRecipient"]: {
            on: {
                CREATE_PHONE_RECIPIENT: {
                    target: "RequestingRecipient",
                    actions: [
                        (0, $c8ePo.assign)({
                            name: (_, event)=>event.name,
                            recipientData: (_, event)=>({
                                    phone: event.phone
                                })
                        }),
                        (0, $c8ePo.send)({
                            type: "REQUEST_NEW_RECIPIENT"
                        })
                    ]
                },
                CREATE_IBAN_RECIPIENT: {
                    target: "RequestingRecipient",
                    actions: [
                        (0, $c8ePo.assign)({
                            name: (_, event)=>event.name,
                            recipientData: (_, event)=>({
                                    iban: event.iban
                                }),
                            externalAccount: (_, event)=>event.externalAccount
                        }),
                        (0, $c8ePo.send)({
                            type: "REQUEST_NEW_RECIPIENT"
                        })
                    ]
                },
                CREATE_ACCOUNT_RECIPIENT: {
                    target: "RequestingRecipient",
                    actions: [
                        (0, $c8ePo.assign)({
                            name: (_, event)=>event.name,
                            recipientData: (_, event)=>({
                                    accountReference: event.account,
                                    bic: event.bic
                                })
                        }),
                        (0, $c8ePo.send)({
                            type: "REQUEST_NEW_RECIPIENT"
                        })
                    ]
                },
                SEARCH_BANK: {
                    target: "SearchBank"
                }
            }
        },
        ["RequestingRecipient"]: {
            invoke: {
                id: "requestRecipient",
                src: async (context)=>{
                    try {
                        if (context.externalAccount) return (0, $kqXxS.externalAccountManager).requestNewRecipient(context.name, context.recipientData);
                        else {
                            const recipient = await (0, $kqXxS.beneficiaryManager).requestNewRecipient(context.name, context.recipientData);
                            const sessionToken = recipient?.strongAuthentication?.strongAuthenticationToken;
                            if (sessionToken) {
                                if (!(0, $kqXxS.partyAuthenticationManager)?.getSession) throw new Error("partyAuthenticationManager is undefined or missing getSession");
                                const session = await (0, $kqXxS.partyAuthenticationManager).getSession(sessionToken);
                                return {
                                    ...recipient,
                                    session: session
                                };
                            } else return recipient;
                        }
                    } catch (error) {
                        (0, $6JVVB.logger).error("Error requesting recipient:", error);
                        throw error;
                    }
                },
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            recipientToAdd: (_, event)=>event.data,
                            errorMessage: undefined
                        }),
                        (0, $c8ePo.send)((context)=>{
                            const recipient = context.recipientToAdd;
                            const sessionSCA = recipient?.session;
                            if (!sessionSCA) return {
                                type: "DONE"
                            };
                            const partyAuthenticationSessionState = new (0, $f1clM.PartyAuthenticationSessionState)(sessionSCA);
                            const secret = partyAuthenticationSessionState.canVerifyTrustedDevice();
                            const canVerifyTrustedDevice = (0, $dhPTb.Config).SCA_TRUSTED_DEVICE_ENABLED && partyAuthenticationSessionState.canVerifyTrustedDeviceAndPincode(secret);
                            if (canVerifyTrustedDevice) return {
                                type: "POLLING_SESSION_STATE"
                            };
                            if (partyAuthenticationSessionState.canVerifyPincodeAndSmsOtp()) return {
                                type: "PINCODE_SMS_OTP_SUBMISSION"
                            };
                            if (partyAuthenticationSessionState.canOnlyVerifyPincode()) return {
                                type: "PINCODE_SUBMISSION"
                            };
                            if (partyAuthenticationSessionState.canOnlyVerifySmsOtp()) return {
                                type: "OTP_SUBMISSION"
                            };
                            return {
                                type: "DONE"
                            };
                        })
                    ]
                },
                onError: {
                    target: "CreatingRecipient",
                    actions: (0, $c8ePo.assign)({
                        errorMessage: (_, event)=>event.data
                    })
                }
            },
            on: {
                OTP_SUBMISSION: "OTPSubmission",
                PINCODE_SUBMISSION: (0, $40sjz.PincodeState).PincodeConfirmation,
                POLLING_SESSION_STATE: "PollingSessionState",
                PINCODE_SMS_OTP_SUBMISSION: "PincodeOTPSubmission",
                DONE: "Done"
            }
        },
        ["SearchBank"]: {
            on: {
                UPDATE_BANK_NAME: {
                    target: "CreatingRecipient",
                    actions: [
                        (0, $c8ePo.assign)({
                            bankName: (_, event)=>event.bankName,
                            bicCode: (_, event)=>event.bic
                        })
                    ]
                }
            }
        },
        ["OTPRefreshing"]: {
            invoke: {
                id: "otpRefresh",
                src: (context)=>{
                    if (context.externalAccount) return (0, $kqXxS.externalAccountManager).requestNewRecipient(context.name, context.recipientData);
                    else {
                        const recipient = context.recipientToAdd;
                        if (recipient?.strongAuthentication?.strongAuthenticationToken) {
                            const token = recipient.strongAuthentication.strongAuthenticationToken;
                            return (0, $kqXxS.authenticationsSessionsManager).getAuthenticationSession(token);
                        } else throw new Error("Strong authentication token is missing");
                    }
                },
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            recipientToAdd: (_, event)=>event.data,
                            refreshingErrorMessage: undefined
                        }),
                        (0, $c8ePo.send)("OTP_REFRESHED", {
                            delay: $7de09e9ac9560d59$var$REFRESHED_OTP_DELAY
                        })
                    ]
                },
                onError: {
                    target: "OTPSubmission",
                    actions: (0, $c8ePo.assign)({
                        refreshingErrorMessage: (_, event)=>event.data
                    })
                }
            },
            on: {
                OTP_REFRESHED: "OTPSubmission"
            }
        },
        ["OTPSubmission"]: {
            invoke: {
                id: "sendSmsOtp",
                src: (context)=>{
                    const recipient = context.recipientToAdd;
                    if (!context.otpSmsSent) {
                        if (recipient?.strongAuthentication?.strongAuthenticationToken) {
                            const token = recipient.strongAuthentication.strongAuthenticationToken;
                            return (0, $kqXxS.authenticationsSessionsManager).getAuthenticationSession(token);
                        } else throw new Error("Strong authentication token is missing");
                    }
                    return Promise.resolve();
                }
            },
            on: {
                OTP_CONFIRM: {
                    target: "OTPConfirming",
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    actions: (0, $c8ePo.assign)({
                        otp: (_, event)=>event.otp,
                        errorMessage: undefined,
                        refreshingErrorMessage: undefined,
                        otpSmsSent: true
                    })
                },
                SEND_OTP_AGAIN: {
                    target: "OTPRefreshing",
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    actions: (0, $c8ePo.assign)({
                        errorMessage: undefined
                    })
                },
                CANCEL_STRONG_AUTH: {
                    target: "StrongAuthCancelling"
                }
            }
        },
        ["OTPConfirming"]: {
            invoke: {
                id: "confirmNewRecipient",
                src: (context)=>{
                    if (context.externalAccount) return (0, $kqXxS.externalAccountManager).confirmNewRecipient(context.name, context.recipientData, context.otp);
                    else {
                        const otp = context.otp;
                        const token = context.recipientToAdd?.strongAuthentication?.strongAuthenticationToken;
                        if (token && otp) return (0, $kqXxS.authenticationsSessionsManager).verifyAuthentication(token, otp, undefined, true);
                        throw new Error("Strong authentication token or OTP is missing");
                    }
                },
                onDone: {
                    target: "Done",
                    actions: [
                        (0, $c8ePo.assign)({
                            errorMessage: undefined
                        })
                    ]
                },
                onError: {
                    target: "OTPSubmission",
                    actions: (0, $c8ePo.assign)({
                        errorMessage: (_, event)=>event.data
                    })
                }
            }
        },
        ["StrongAuthCancelling"]: {
            invoke: {
                id: "cancelStrongAuth",
                src: (context)=>{
                    const recipient = context.recipientToAdd;
                    if (recipient?.strongAuthentication?.strongAuthenticationToken) {
                        const token = recipient.strongAuthentication.strongAuthenticationToken;
                        return (0, $kqXxS.authenticationsSessionsManager).cancelAuthentication(token);
                    }
                    throw new Error("Strong authentication token is missing");
                },
                onDone: {
                    target: "Done",
                    actions: (0, $c8ePo.assign)({
                        errorMessage: undefined
                    })
                },
                onError: {
                    target: "Done",
                    actions: (0, $c8ePo.assign)({
                        errorMessage: (_, event)=>event.data
                    })
                }
            }
        },
        [(0, $40sjz.PincodeState).PincodeConfirmation]: {
            invoke: {
                id: "fetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboard]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "PincodeConfirming",
                    actions: (0, $c8ePo.assign)({
                        pincodeSubmission: (_, event)=>event.pincodeSubmission
                    })
                },
                CANCEL_STRONG_AUTH: {
                    target: "StrongAuthCancelling"
                }
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
            invoke: {
                id: "fetch-keyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        ["PincodeConfirming"]: {
            invoke: {
                id: "confirmPincode",
                src: (context)=>{
                    const pincode = context.pincodeSubmission;
                    const token = context.recipientToAdd?.strongAuthentication?.strongAuthenticationToken;
                    if (token && pincode) return (0, $kqXxS.authenticationsSessionsManager).verifyAuthentication(token, pincode, (0, $61WqT.AuthenticationsMethod).PINCODE);
                    throw new Error("Strong authentication token or pincode is missing");
                },
                onDone: {
                    target: "Done",
                    actions: [
                        (0, $c8ePo.assign)({
                            errorMessage: undefined
                        })
                    ]
                },
                onError: {
                    target: (0, $40sjz.PincodeState).PincodeConfirmation,
                    actions: (0, $c8ePo.assign)({
                        errorMessage: (_, event)=>event.data
                    })
                }
            }
        },
        ["PollingSessionState"]: {
            on: {
                POLLING_SESSION_STATE_DISMISS: "PollingSessionStateDismiss",
                CANCEL_STRONG_AUTH: "StrongAuthCancelling"
            }
        },
        ["PincodeOTPSubmission"]: {
            invoke: {
                id: "fetchKeyboardForPincodeOtp",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD_PINCODE"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD_PINCODE: (0, $40sjz.PincodeState).PromptingKeyboardPincode
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboardPincode]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "PincodeOtpConfirming",
                    actions: (0, $c8ePo.assign)({
                        pincodeSubmission: (_, event)=>event.pincodeSubmission
                    })
                },
                CANCEL_STRONG_AUTH: {
                    target: "StrongAuthCancellingPincode"
                }
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterErrorPincode]: {
            invoke: {
                id: "fetch-keyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD_PINCODE"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD_PINCODE: (0, $40sjz.PincodeState).PromptingKeyboardPincode
            }
        },
        ["PincodeOtpConfirming"]: {
            invoke: {
                id: "confirmPincodeForOtp",
                src: (context)=>{
                    const token = context.recipientToAdd?.strongAuthentication?.strongAuthenticationToken;
                    const pincode = context.pincodeSubmission;
                    if (token && pincode) return (0, $kqXxS.authenticationsSessionsManager).verifyAuthentication(token, pincode, (0, $61WqT.AuthenticationsMethod).PINCODE, true);
                    throw new Error("Missing token or pincode for OTP flow");
                },
                onDone: {
                    target: "OTPSubmission",
                    actions: (0, $c8ePo.assign)({
                        errorMessage: undefined
                    })
                },
                onError: {
                    target: (0, $40sjz.PincodeState).FetchKeyboardAfterErrorPincode,
                    actions: (0, $c8ePo.assign)({
                        errorMessage: (_, event)=>event.data
                    })
                }
            }
        },
        ["StrongAuthCancellingPincode"]: {
            invoke: {
                src: "cancelStrongAuthentication",
                onDone: {
                    target: (0, $40sjz.PincodeState).PromptingKeyboardPincode
                },
                onError: {
                    target: (0, $40sjz.PincodeState).PromptingKeyboardPincode
                }
            }
        },
        ["PollingSessionStateDismiss"]: {
            on: {
                Done: "Done"
            }
        },
        ["Done"]: {
            type: "final",
            invoke: {
                src: ()=>(0, $kqXxS.beneficiaryManager).load(true)
            }
        }
    }
});

});

parcelRegister("hxiRk", function(module, exports) {

$parcel$export(module.exports, "PollingSessionState", function () { return $65f2fa064d0d4a42$export$af9ba8bd2afe603e; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $d0DGo = parcelRequire("d0DGo");

var $22v9q = parcelRequire("22v9q");

var $k0Hih = parcelRequire("k0Hih");

var $jn1mK = parcelRequire("jn1mK");

var $k4kME = parcelRequire("k4kME");

var $boqCQ = parcelRequire("boqCQ");

var $ec3qv = parcelRequire("ec3qv");
var $65f2fa064d0d4a42$export$e50006273435e7d4 = /*#__PURE__*/ function(STATUS) {
    STATUS["STARTED"] = "STARTED";
    STATUS["PENDING"] = "PENDING";
    STATUS["DONE"] = "DONE";
    STATUS["REFUSED"] = "REFUSED";
    STATUS["CANCELLED"] = "CANCELLED";
    STATUS["FAILED"] = "FAILED";
    return STATUS;
}({});
const $65f2fa064d0d4a42$export$af9ba8bd2afe603e = ({ sessionToken: sessionToken, dismissPollingSessionStateModal: dismissPollingSessionStateModal })=>{
    const { sessionPolling: sessionPolling, isDone: isDone, isExpired: isExpired, isPending: isPending, isStarted: isStarted, error: error } = (0, $ec3qv.usePollingStateSession)(sessionToken, dismissPollingSessionStateModal);
    const status = sessionPolling?.status;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [message, setMessage] = (0, $6uYXW.useState)("");
    const [isRefused, setIsRefused] = (0, $6uYXW.useState)(false);
    (0, $6uYXW.useEffect)(()=>{
        if (isExpired) setMessage(formatMessage("addRecipient.pollingModalSession.messageExpired"));
        else {
            if (status === "CANCELLED") setMessage(formatMessage("addRecipient.pollingModalSession.messageCancelled"));
            if (status === "FAILED") setMessage(formatMessage("addRecipient.pollingModalSession.messageFailed"));
            if (status === "REFUSED") {
                setIsRefused(true);
                setMessage(formatMessage("addRecipient.pollingModalSession.messageRefused"));
            }
            if (status === "DONE") setMessage(formatMessage("addRecipient.pollingModalSession.messageDone"));
            if (isPending) {
                const pendingMessage = /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        formatMessage("addRecipient.pollingModalSession.messagePending"),
                        /*#__PURE__*/ (0, $4m918.jsx)("br", {}),
                        formatMessage("addRecipient.pollingModalSession.messagePendingCheck")
                    ]
                });
                setMessage(pendingMessage);
            }
            if (status === "STARTED") setMessage(formatMessage("addRecipient.pollingModalSession.messageStarted"));
        }
    }, [
        status,
        isExpired
    ]);
    const getContentSpinnerByStatus = ()=>{
        let content;
        if (isExpired) content = /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$DivSpinner, {
            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $boqCQ.ExpirationIcon), {
                height: 50,
                width: 50
            })
        });
        else if (isDone) content = /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$DivSpinner, {
            children: /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$SuccessLogoImage, {
                src: (0, $d0DGo.circleSuccessIcon),
                alt: ""
            })
        });
        else if (isStarted || isPending) content = /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$DivSpinner, {
            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {
                color: "#dddddd",
                size: "50px"
            })
        });
        else content = /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$DivSpinner, {
            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k0Hih.ErrorCircle), {
                size: 50
            })
        });
        return content;
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($65f2fa064d0d4a42$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$Header, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$Title, {
                    children: formatMessage("addRecipient.pollingModalSession.title")
                })
            }),
            getContentSpinnerByStatus(),
            /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$Description, {
                isRefused: isRefused,
                children: message
            }),
            sessionPolling?.error && /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$StyledErrorMessage, {
                children: sessionPolling.error
            }),
            error && /*#__PURE__*/ (0, $4m918.jsx)($65f2fa064d0d4a42$var$StyledErrorMessage, {
                children: formatMessage("addRecipient.pollingModalSession.error")
            })
        ]
    });
};
const $65f2fa064d0d4a42$var$Container = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
`;
const $65f2fa064d0d4a42$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`;
const $65f2fa064d0d4a42$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  margin: 0;
  flex-shrink: 1;
  flex-grow: 1;
`;
const $65f2fa064d0d4a42$var$Description = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  ${({ isRefused: isRefused })=>`color: ${isRefused ? "#ff4242" : "#000000"}`};
  font-size: 0.9375rem;
  margin: 10px 0;
  align-self: center;
`;
const $65f2fa064d0d4a42$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 10px;
`;
const $65f2fa064d0d4a42$var$DivSpinner = (0, $jb8NR.default).div`
  align-self: center;
`;
const $65f2fa064d0d4a42$var$SuccessLogoImage = (0, $jb8NR.default).img`
  align-self: center;
  width: 200px;
  height: 200px;
`;

});
parcelRegister("boqCQ", function(module, exports) {

$parcel$export(module.exports, "ExpirationIcon", function () { return $022f2f45fbb96525$export$d1d6d353ac50dc0; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $022f2f45fbb96525$export$d1d6d353ac50dc0 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666zm3.758 11.666-.441.442a.425.425 0 0 1-.592 0l-3.333-3.333a.409.409 0 0 1-.125-.3V5.417c0-.23.186-.417.416-.417h.634c.23 0 .416.187.416.417V9.7l3.025 3.025a.425.425 0 0 1 0 .608z",
            fill: "#161616",
            fillRule: "evenodd"
        })
    });

});

parcelRegister("ec3qv", function(module, exports) {

$parcel$export(module.exports, "usePollingStateSession", function () { return $87cb1fe8fd0f0e37$export$2355d80223d29cf; });

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");
var $87cb1fe8fd0f0e37$export$e50006273435e7d4 = /*#__PURE__*/ function(STATUS) {
    STATUS["STARTED"] = "STARTED";
    STATUS["PENDING"] = "PENDING";
    STATUS["DONE"] = "DONE";
    STATUS["REFUSED"] = "REFUSED";
    STATUS["CANCELLED"] = "CANCELLED";
    STATUS["FAILED"] = "FAILED";
    return STATUS;
}({});
const $87cb1fe8fd0f0e37$export$2355d80223d29cf = (sessionToken, dismissPollingSessionStateModal)=>{
    const [sessionPolling, setSessionPolling] = (0, $6uYXW.useState)(null);
    const intervalRef = (0, $6uYXW.useRef)(null);
    const [hasSessionPolling, setHasSessionPolling] = (0, $6uYXW.useState)(false);
    const [isExpired, setIsExpired] = (0, $6uYXW.useState)(false);
    const expirationDateModal = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))().add(15, "minutes");
    const [error, setError] = (0, $6uYXW.useState)();
    const fetchSessionPolling = (0, $6uYXW.useCallback)(async ()=>{
        if (!sessionToken) return;
        try {
            const session = await (0, $kqXxS.partyAuthenticationManager).getSession(sessionToken);
            if (session) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))().isBefore(expirationDateModal)) actionsSessionByStatus(session);
                else {
                    setIsExpired(true);
                    clearPolling();
                }
            }
        } catch (e) {
            setError(new Error("Session does not exist"));
        }
    }, [
        sessionToken
    ]);
    const actionsSessionByStatus = (session)=>{
        // Check if it has been expired or not
        if (session.expiredAt || session.status === "STARTED" || session.status === "PENDING") checkDateSessionExpired(session);
        if (session.status === "REFUSED") clearPolling();
        if (session.status === "CANCELLED") clearPolling();
        if (session.status === "DONE") {
            clearPolling();
            dismissPollingSessionStateModal();
        }
    };
    const checkDateSessionExpired = (session)=>{
        const dateToCheck = new Date(session.expiredAt);
        const now = new Date();
        if (dateToCheck > now) {
            // Session is not expired
            setSessionPolling(session);
            if (session.status === "STARTED" || session.status === "PENDING") setHasSessionPolling(true);
            else setHasSessionPolling(false);
        } else // Session is expired
        setIsExpired(true);
    };
    const clearPolling = ()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    (0, $6uYXW.useEffect)(()=>{
        if (!sessionToken) return;
        // Start polling every 3 seconds
        intervalRef.current = setInterval(fetchSessionPolling, 3000);
        return ()=>{
            clearPolling(); // cleanup on unmount
        };
    }, []);
    return {
        sessionPolling: sessionPolling,
        hasSessionPolling: hasSessionPolling,
        isExpired: isExpired,
        isDone: sessionPolling?.status === "DONE",
        isStarted: sessionPolling?.status === "STARTED",
        isPending: sessionPolling === null || sessionPolling?.status === "PENDING",
        error: error
    };
};

});


parcelRegister("hvFeR", function(module, exports) {

$parcel$export(module.exports, "TransferTransaction", function () { return $5f7c131fbe43845e$export$9a66408f940edfe6; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $1YFGv = parcelRequire("1YFGv");

var $fQIdb = parcelRequire("fQIdb");

var $4fYE4 = parcelRequire("4fYE4");

var $7N0kU = parcelRequire("7N0kU");

var $40sjz = parcelRequire("40sjz");

var $hFNLo = parcelRequire("hFNLo");

var $jMdmu = parcelRequire("jMdmu");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $eyjPK = parcelRequire("eyjPK");

var $k4kME = parcelRequire("k4kME");

var $99Id8 = parcelRequire("99Id8");

var $22v9q = parcelRequire("22v9q");

var $8Mjlc = parcelRequire("8Mjlc");

var $lT9Op = parcelRequire("lT9Op");

var $gJJ1c = parcelRequire("gJJ1c");

const $5f7c131fbe43845e$var$loadingState = [
    (0, $hFNLo.TransferState).RequestingTransfer,
    (0, $40sjz.PincodeState).PincodeConfirmation
];
const $5f7c131fbe43845e$export$9a66408f940edfe6 = (props)=>{
    const { recipient: recipient, closeModal: closeModal } = props;
    const { context: context, state: state, submitOtp: submitOtp, cancelTransfer: cancelTransfer, selectAmount: selectAmount, submitPincode: submitPincode } = (0, $hFNLo.useTransferMachine)(false, props.isOpenLoop);
    const history = (0, $NQIVp.useHistory)();
    const { client: client } = (0, $7N0kU.useClient)();
    const [editingSourceAndDestination, setEditingSourceAndDestination] = (0, $6uYXW.useState)(null);
    const [SourceAndDestinationType, setSourceAndDestinationType] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(null);
    const [sourceAccount, setSourceAccount] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(null);
    const [destinationAccountOrRecipient, setDestinationAccountOrRecipient] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(null);
    const [needCreditorPhoneNumber, setNeedCreditorPhoneNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(false);
    const [needCreditorAccountNumber, setNeedCreditorAccountNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(false);
    const [needCreditorAddress, setNeedCreditorAddress] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(false);
    const [paymentNetwork, setPaymentNetwork] = (0, $6uYXW.useState)(null);
    const automaticRoutingEnabled = (0, $dhPTb.Config).SMART_ROUTING_SERVICE_LEVEL;
    (0, $6uYXW.useEffect)(()=>{
        if ((0, $kGswT.redirectionHandledOnAccountBlocked)(context.error, history.push)) closeModal?.();
    }, [
        context.error,
        history.push,
        closeModal
    ]);
    const handleSetSourceAccount = (account)=>{
        setSourceAccount(account);
        setSourceAndDestinationType(null);
    };
    const handleSetDestinationAccountOrRecipient = (accountOrRecipient)=>{
        setDestinationAccountOrRecipient(accountOrRecipient);
        setSourceAndDestinationType(null);
    };
    const handleConfirm = (otp)=>{
        submitOtp(otp);
    };
    const onChangePaymentNetwork = (paymentNetworkProd)=>{
        setPaymentNetwork(paymentNetworkProd);
    };
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const errorMessage = !(0, $1YFGv.isAccountBlocked)(context.error) ? context.error : undefined;
    switch(state){
        case (0, $hFNLo.TransferState).SelectingAmount:
        case (0, $hFNLo.TransferState).RequestingTransfer:
        case (0, $hFNLo.TransferState).ConfirmTransferError:
        case (0, $40sjz.PincodeState).PincodeConfirmation:
        case (0, $hFNLo.TransferState).CancelTransfer:
            return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($5f7c131fbe43845e$var$Centered, {
                        children: [
                            !!props.showAvatar && recipient ? /*#__PURE__*/ (0, $4m918.jsx)((0, $jMdmu.Avatar), {
                                size: 72,
                                name: recipient.name
                            }) : null,
                            !!props.showTitle && recipient ? /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$Title, {
                                children: formatMessage("recipient.transferTo", {
                                    name: recipient.name
                                })
                            }) : null,
                            errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$StyledErrorMessage, {
                                children: errorMessage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$StyledAmountSelection, {
                        automaticRouting: automaticRoutingEnabled,
                        sourceAccount: sourceAccount,
                        editingSourceAndDestination: editingSourceAndDestination,
                        destinationAccountOrRecipient: destinationAccountOrRecipient,
                        isOpenLoop: props.isOpenLoop,
                        recipient: recipient,
                        submitAmount: selectAmount,
                        loading: $5f7c131fbe43845e$var$loadingState.includes(state),
                        paymentNetwork: paymentNetwork,
                        onChangePaymentNetwork: onChangePaymentNetwork,
                        onClearDestinationAccountOrRecipientSelection: ()=>{
                            setDestinationAccountOrRecipient(null);
                            setSourceAndDestinationType(null);
                        },
                        onOpenSourceAccountSelection: ()=>{
                            setEditingSourceAndDestination((0, $lT9Op.SourceAndDestinationEnum).Source);
                            setSourceAndDestinationType((0, $lT9Op.SourceAndDestinationEnum).Source);
                        },
                        onOpenDestinationAccountOrRecipientSelection: (newNeedCreditorPhoneNumber, newNeedCreditorAccountNumber, newNeedCreditorAddress)=>{
                            setNeedCreditorPhoneNumber(newNeedCreditorPhoneNumber || false);
                            setNeedCreditorAccountNumber(newNeedCreditorAccountNumber || false);
                            setNeedCreditorAddress(newNeedCreditorAddress || false);
                            setEditingSourceAndDestination((0, $lT9Op.SourceAndDestinationEnum).Destination);
                            setSourceAndDestinationType((0, $lT9Op.SourceAndDestinationEnum).Destination);
                        },
                        children: props.isOpenLoop ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lT9Op.SourceAndDestination), {
                            needCreditorPhoneNumber: needCreditorPhoneNumber,
                            needCreditorAccountNumber: needCreditorAccountNumber,
                            needCreditorAddress: needCreditorAddress,
                            type: SourceAndDestinationType,
                            sourceAccount: sourceAccount,
                            onSourceAccountChange: handleSetSourceAccount,
                            onDestinationAccountOrRecipientChange: handleSetDestinationAccountOrRecipient,
                            paymentNetwork: paymentNetwork
                        }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {})
                    })
                ]
            });
        case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
        case (0, $40sjz.PincodeState).PromptingKeyboard:
            {
                const keyboard = context.keyboard;
                return /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$Container, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                        keyboard: keyboard,
                        onSubmit: submitPincode,
                        title: formatMessage("pincodeConfirmation.label"),
                        errorMessage: errorMessage,
                        loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError
                    })
                });
            }
        case (0, $hFNLo.TransferState).Done:
            {
                const transactionResult = context.transactionResult;
                const isRecurringTransfer = !!context.recurringTransferParams?.enabled;
                const handleDoneClick = ()=>{
                    if (isRecurringTransfer) history.push((0, $4fYE4.Path).UpcomingTransfers);
                    else closeModal?.();
                };
                return props.isOpenLoop ? /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$Container, {
                    children: /*#__PURE__*/ (0, $4m918.jsxs)($5f7c131fbe43845e$var$Centered, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$SuccessLogoImage, {
                                src: {},
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$SuccessMessage, {
                                children: isRecurringTransfer ? formatMessage("transferSummary.recurringTransferSuccessMessage", {
                                    id: transactionResult?.id,
                                    recipient: destinationAccountOrRecipient?.name
                                }) : formatMessage("transferSummary.customerInstructionSuccessMessage", {
                                    id: transactionResult?.id,
                                    recipient: destinationAccountOrRecipient?.name
                                })
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.WhitePrimaryButton), {
                                onClick: handleDoneClick,
                                size: "S",
                                children: formatMessage("transferSummary.done")
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$StyledTransferSummary, {
                    recipient: recipient,
                    title: formatMessage("transferSummary.summaryTitle"),
                    subtitle: context.transferMode === (0, $fQIdb.TransferMode).CashTransfer ? formatMessage("transferSummary.cashSummarySubtitle", {
                        recipient: recipient.name
                    }) : formatMessage("transferSummary.accountSummarySubtitle"),
                    middleStepLabel: formatMessage("transferSummary.summaryMiddleStep"),
                    transaction: transactionResult.metadata.transaction,
                    onDone: closeModal,
                    boldSubtitle: context.transferMode !== (0, $fQIdb.TransferMode).CashTransfer
                });
            }
        case (0, $hFNLo.TransferState).RequestingTransferError:
        case (0, $hFNLo.TransferState).StrongAuthentication:
            return /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$Container, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $8Mjlc.OtpConfirm), {
                    submitOtp: submitOtp,
                    phoneNumber: client?.contactphone,
                    onConfirm: handleConfirm,
                    onCancel: cancelTransfer,
                    errorMessage: errorMessage
                })
            });
        default:
            return /*#__PURE__*/ (0, $4m918.jsx)($5f7c131fbe43845e$var$LoadingContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "30px"
                })
            });
    }
};
const $5f7c131fbe43845e$var$Centered = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $5f7c131fbe43845e$var$Container = (0, $jb8NR.default).div`
  margin: 40px auto 0;
`;
const $5f7c131fbe43845e$var$Title = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
  text-align: center;
  margin-top: 20px;
`;
const $5f7c131fbe43845e$var$StyledAmountSelection = (0, $jb8NR.default)((0, $99Id8.AmountSelection))`
  margin-top: 20px;
`;
const $5f7c131fbe43845e$var$LoadingContainer = (0, $jb8NR.default).div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
`;
const $5f7c131fbe43845e$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 50px;
  text-align: center;
`;
const $5f7c131fbe43845e$var$StyledTransferSummary = (0, $jb8NR.default)((0, $gJJ1c.TransferSummary))`
  ${(0, $gJJ1c.Subtitle)} {
    ${(props)=>!props.boldSubtitle && (0, $22v9q.theme).text}
  }
`;
const $5f7c131fbe43845e$var$SuccessMessage = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.125rem;
  text-align: center;
  margin-bottom: 20px;
`;
const $5f7c131fbe43845e$var$SuccessLogoImage = (0, $jb8NR.default).img`
  align-self: center;
  width: 200px;
  height: 200px;
`;

});
parcelRegister("fQIdb", function(module, exports) {

$parcel$export(module.exports, "TransferMode", function () { return $bc4c0fb096ad935b$export$92926fa7be8ad686; });
$parcel$export(module.exports, "useAvailableTransferMode", function () { return $bc4c0fb096ad935b$export$7b967a36e182ddc4; });

var $6uYXW = parcelRequire("6uYXW");
var $bc4c0fb096ad935b$export$92926fa7be8ad686 = /*#__PURE__*/ function(TransferMode) {
    TransferMode["AccountTransfer"] = "account-transfer";
    TransferMode["CashTransfer"] = "cash-transfer";
    return TransferMode;
}({});
const $bc4c0fb096ad935b$export$7b967a36e182ddc4 = ({ features: features, recipient: recipient })=>{
    const [availableTypes, setAvailableTypes] = (0, $6uYXW.useState)([]);
    (0, $6uYXW.useEffect)(()=>{
        if (recipient?.iban || recipient?.accountReference) {
            setAvailableTypes([]);
            return;
        }
        const transferTypes = [];
        if (features.p2pTransfer) transferTypes.push("account-transfer");
        if (features.p2pCashTransfer) transferTypes.push("cash-transfer");
        setAvailableTypes(transferTypes);
    }, [
        recipient,
        features
    ]);
    return availableTypes;
};

});

parcelRegister("hFNLo", function(module, exports) {

$parcel$export(module.exports, "useTransferMachine", function () { return $91b2219413f92566$export$4a116be4c7da2e57; });
$parcel$export(module.exports, "TransferState", function () { return $91b2219413f92566$export$c729c00b3ba581f7; });

var $lCuQx = parcelRequire("lCuQx");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");

var $fQIdb = parcelRequire("fQIdb");

var $8UJ8q = parcelRequire("8UJ8q");

var $40sjz = parcelRequire("40sjz");
const $91b2219413f92566$export$4a116be4c7da2e57 = (isP2PSimpleTransfer = false, isOpenLoop = false)=>{
    const [state, sendEvent] = (0, $lCuQx.useMachine)($91b2219413f92566$export$fb31619566c3f18b);
    const selectAmount = (recipient, amount, sourceAccounts, description, sourceAccount, paymentNetwork, transferMode, creditorAddress, foreignAmount, recurringTransferParams, automaticRoutingConfig)=>{
        const srcAccount = sourceAccount || sourceAccounts.find((account)=>account.currencyAlpha === amount.currency);
        sendEvent(isOpenLoop ? "CREATE_CUSTOMER_INSTRUCTION" : "SELECT_AMOUNT", {
            recipient: recipient,
            amount: amount,
            sourceAccount: srcAccount,
            label: description,
            paymentNetwork: paymentNetwork,
            transferMode: transferMode,
            isP2PSimpleTransfer: isP2PSimpleTransfer,
            isOpenLoop: isOpenLoop,
            creditorAddress: creditorAddress,
            foreignAmount: foreignAmount,
            recurringTransferParams: recurringTransferParams,
            automaticRoutingConfig: automaticRoutingConfig
        });
    };
    const submitPincode = (submission)=>{
        sendEvent("SUBMIT_PINCODE", {
            pincodeSubmission: submission
        });
    };
    const submitOtp = (otp)=>{
        sendEvent("SUBMIT_OTP", {
            otp: otp
        });
    };
    const cancelTransfer = ()=>{
        sendEvent({
            type: "CANCEL_TRANSFER"
        });
    };
    return {
        state: state.value,
        context: state.context,
        selectAmount: selectAmount,
        submitPincode: submitPincode,
        submitOtp: submitOtp,
        cancelTransfer: cancelTransfer
    };
};
var $91b2219413f92566$export$c729c00b3ba581f7 = /*#__PURE__*/ function(TransferState) {
    TransferState["SelectingAmount"] = "SelectingAmount";
    TransferState["RequestingTransfer"] = "RequestingTransfer";
    TransferState["RequestingTransferError"] = "RequestingTransferError";
    TransferState["Confirmation"] = "Confirmation";
    TransferState["ConfirmTransferError"] = "ConfirmTransferError";
    TransferState["Done"] = "Done";
    TransferState["StrongAuthentication"] = "StrongAuthentication";
    TransferState["SubmitOtp"] = "SubmitOtp";
    TransferState["CancelTransfer"] = "CancelTransfer";
    return TransferState;
}({});
var $91b2219413f92566$var$TransferInvokeName = /*#__PURE__*/ function(TransferInvokeName) {
    TransferInvokeName["StartTransfer"] = "StartTransfer";
    TransferInvokeName["FetchKeyboard"] = "FetchKeyboard";
    TransferInvokeName["ConfirmTransfer"] = "ConfirmTransfer";
    TransferInvokeName["GetAuthenticationSession"] = "GetAuthenticationSession";
    TransferInvokeName["SendAuthenticationCode"] = "SendAuthenticationCode";
    return TransferInvokeName;
}($91b2219413f92566$var$TransferInvokeName || {});
var $91b2219413f92566$export$1b5eb083c754a86b = /*#__PURE__*/ function(TransferType) {
    TransferType["IBAN"] = "IBAN";
    TransferType["TRANSFER"] = "TRANSFER";
    return TransferType;
}({});
const $91b2219413f92566$export$fb31619566c3f18b = (0, $TAle5.createMachine)({
    predictableActionArguments: true,
    id: "transfer",
    initial: "SelectingAmount",
    states: {
        ["SelectingAmount"]: {
            on: {
                SELECT_AMOUNT: {
                    target: "RequestingTransfer",
                    actions: [
                        (0, $c8ePo.assign)({
                            recipient: (_, event)=>event.recipient,
                            amount: (_, event)=>event.amount,
                            label: (_, event)=>event.label,
                            sourceAccount: (_, event)=>event.sourceAccount,
                            transferType: (_, event)=>event.recipient.iban || event.recipient.accountReference ? "IBAN" : "TRANSFER",
                            paymentNetwork: (_, event)=>event.paymentNetwork,
                            transferMode: (_, event)=>event.transferMode,
                            isP2PSimpleTransfer: (_, event)=>event.isP2PSimpleTransfer,
                            isOpenLoop: (_, event)=>event.isOpenLoop
                        })
                    ]
                },
                CREATE_CUSTOMER_INSTRUCTION: {
                    target: (0, $40sjz.PincodeState).PincodeConfirmation,
                    actions: [
                        (0, $c8ePo.assign)({
                            recipient: (_, event)=>event.recipient,
                            amount: (_, event)=>event.amount,
                            label: (_, event)=>event.label,
                            sourceAccount: (_, event)=>event.sourceAccount,
                            transferType: (_, event)=>event.recipient.iban || event.recipient.accountReference ? "IBAN" : "TRANSFER",
                            paymentNetwork: (_, event)=>event.paymentNetwork,
                            transferMode: (_, event)=>event.transferMode,
                            isP2PSimpleTransfer: (_, event)=>event.isP2PSimpleTransfer,
                            isOpenLoop: (_, event)=>event.isOpenLoop,
                            creditorAddress: (_, event)=>event.creditorAddress,
                            foreignAmount: (_, event)=>event.foreignAmount,
                            recurringTransferParams: (_, event)=>event.recurringTransferParams,
                            automaticRoutingConfig: (_, event)=>event.automaticRoutingConfig
                        })
                    ]
                }
            }
        },
        ["RequestingTransfer"]: {
            invoke: {
                id: "StartTransfer",
                src: (context)=>context.isP2PSimpleTransfer ? (0, $kqXxS.transferManager).startSimpleTransfer(context.amount, context.recipient.phone, context.label) : context.transferType === "TRANSFER" ? context.transferMode === (0, $fQIdb.TransferMode).CashTransfer ? (0, $kqXxS.transferManager).startCashTransfer(context.recipient.id, context.amount, context.label) : (0, $kqXxS.transferManager).startTransfer(context.recipient.id, context.amount, context.label) : (0, $kqXxS.transferManager).startPayout(context.recipient.id, context.amount, context.sourceAccount.id, context.label),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionRequest: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)((context)=>{
                            if (context.transactionRequest?.metadata) return context.transactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "PINCODE_CONFIRM"
                            } : {
                                type: "CONFIRM"
                            };
                            return {
                                type: "ERROR"
                            };
                        })
                    ]
                },
                onError: {
                    target: "RequestingTransferError",
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        })
                    ]
                }
            },
            on: {
                PINCODE_CONFIRM: (0, $40sjz.PincodeState).PincodeConfirmation,
                CONFIRM: "Confirmation"
            }
        },
        ["RequestingTransferError"]: {
            exit: (0, $c8ePo.assign)({
                error: undefined
            }),
            on: {
                SELECT_AMOUNT: {
                    target: "RequestingTransfer",
                    actions: (0, $c8ePo.assign)({
                        recipient: (_, event)=>event.recipient,
                        amount: (_, event)=>event.amount,
                        label: (_, event)=>event.label,
                        sourceAccount: (_, event)=>event.sourceAccount,
                        paymentNetwork: (_, event)=>event.paymentNetwork,
                        transferType: (_, event)=>event.recipient.iban || event.recipient.accountReference ? "IBAN" : "TRANSFER",
                        transferMode: (_, event)=>event.transferMode
                    })
                },
                CREATE_CUSTOMER_INSTRUCTION: {
                    target: (0, $40sjz.PincodeState).PincodeConfirmation,
                    actions: [
                        (0, $c8ePo.assign)({
                            recipient: (_, event)=>event.recipient,
                            amount: (_, event)=>event.amount,
                            label: (_, event)=>event.label,
                            sourceAccount: (_, event)=>event.sourceAccount,
                            transferType: (_, event)=>event.recipient.iban || event.recipient.accountReference ? "IBAN" : "TRANSFER",
                            paymentNetwork: (_, event)=>event.paymentNetwork,
                            transferMode: (_, event)=>event.transferMode,
                            isP2PSimpleTransfer: (_, event)=>event.isP2PSimpleTransfer,
                            isOpenLoop: (_, event)=>event.isOpenLoop,
                            creditorAddress: (_, event)=>event.creditorAddress,
                            foreignAmount: (_, event)=>event.foreignAmount,
                            recurringTransferParams: (_, event)=>event.recurringTransferParams,
                            automaticRoutingConfig: (_, event)=>event.automaticRoutingConfig
                        })
                    ]
                },
                SUBMIT_OTP: {
                    target: "SubmitOtp",
                    actions: (0, $c8ePo.assign)({
                        otp: (_, event)=>event.otp
                    })
                },
                CANCEL_TRANSFER: "SelectingAmount"
            }
        },
        ["StrongAuthentication"]: {
            invoke: {
                id: "GetAuthenticationSession",
                src: (context)=>(0, $kqXxS.authenticationsSessionsManager).getAuthenticationSession(context.transactionResult.strongAuthenticationReference),
                onDone: {},
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "TRANSFER_ERROR"
                        })
                    ]
                }
            },
            on: {
                SUBMIT_OTP: {
                    target: "SubmitOtp",
                    actions: [
                        (0, $c8ePo.assign)({
                            otp: (_, event)=>event.otp
                        })
                    ]
                },
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard,
                TRANSFER_ERROR: "RequestingTransferError",
                CANCEL_TRANSFER: "SelectingAmount"
            }
        },
        ["SubmitOtp"]: {
            invoke: {
                id: "SendAuthenticationCode",
                src: async (context)=>{
                    const id = context.transactionResult.id;
                    const strongAuthenticationReference = context.transactionResult.strongAuthenticationReference;
                    if (!strongAuthenticationReference) throw new Error("Missing strongAuthenticationReference");
                    await (0, $kqXxS.authenticationsSessionsManager).verifyAuthentication(strongAuthenticationReference, context.otp);
                    return await (0, $kqXxS.transferManager).submitCustomerInstruction(strongAuthenticationReference, id);
                },
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionResult: (_, event)=>event.data,
                            error: undefined
                        }),
                        (0, $c8ePo.send)({
                            type: "TRANSFER_DONE"
                        })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "TRANSFER_ERROR"
                        })
                    ]
                }
            },
            on: {
                TRANSFER_DONE: "Done",
                TRANSFER_ERROR: "RequestingTransferError"
            }
        },
        [(0, $40sjz.PincodeState).PincodeConfirmation]: {
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboard]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "Confirmation",
                    actions: (0, $c8ePo.assign)({
                        pincodeSubmission: (_, event)=>event.pincodeSubmission
                    })
                }
            }
        },
        ["Confirmation"]: {
            invoke: {
                id: "ConfirmTransfer",
                src: (context)=>context.isOpenLoop ? (0, $kqXxS.transferManager).startCustomerInstruction(context.paymentNetwork, context.amount, context.sourceAccount, context.recipient, context.pincodeSubmission, context.label, context.creditorAddress, context.foreignAmount, context.recurringTransferParams, context.automaticRoutingConfig) : context.transferType === "TRANSFER" ? context.transferMode === (0, $fQIdb.TransferMode).CashTransfer ? (0, $kqXxS.transferManager).confirmCashTransfer(context.transactionRequest.metadata.confirmationMode, context.recipient.id, context.amount, context.label, context.pincodeSubmission) : context.isP2PSimpleTransfer ? (0, $kqXxS.transferManager).confirmSimpleTransfer(context.transactionRequest.metadata.confirmationMode, context.amount, context.recipient.phone, context.label, context.pincodeSubmission) : (0, $kqXxS.transferManager).confirmTransfer(context.transactionRequest.metadata.confirmationMode, context.recipient.id, context.amount, context.label, context.pincodeSubmission) : (0, $kqXxS.transferManager).confirmPayout(context.transactionRequest.metadata.confirmationMode, context.recipient.id, context.amount, context.sourceAccount.id, context.label, context.pincodeSubmission),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionResult: (_, event)=>event.data,
                            error: undefined
                        }),
                        (0, $c8ePo.send)((context)=>{
                            if (context.isOpenLoop && context.transactionResult.strongAuthenticationReference) return {
                                type: "STRONG_AUTHENTICATION"
                            };
                            else return {
                                type: "TRANSFER_DONE"
                            };
                        })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)((ctx)=>ctx.isOpenLoop ? {
                                type: "TRANSFER_CONFIRMATION_ERROR"
                            } : ctx.transactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "TRANSFER_CONFIRMATION_PINCODE_ERROR"
                            } : {
                                type: "TRANSFER_CONFIRMATION_ERROR"
                            })
                    ]
                }
            },
            on: {
                TRANSFER_DONE: "Done",
                STRONG_AUTHENTICATION: "StrongAuthentication",
                TRANSFER_ERROR: "RequestingTransferError",
                TRANSFER_CONFIRMATION_PINCODE_ERROR: (0, $40sjz.PincodeState).FetchKeyboardAfterError,
                TRANSFER_CONFIRMATION_ERROR: "ConfirmTransferError",
                CANCEL_TRANSFER: "SelectingAmount"
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        ["ConfirmTransferError"]: {
            exit: (0, $c8ePo.assign)({
                error: undefined
            }),
            on: {
                SELECT_AMOUNT: {
                    target: "RequestingTransfer",
                    actions: (0, $c8ePo.assign)({
                        recipient: (_, event)=>event.recipient,
                        amount: (_, event)=>event.amount,
                        label: (_, event)=>event.label,
                        sourceAccount: (_, event)=>event.sourceAccount,
                        paymentNetwork: (_, event)=>event.paymentNetwork,
                        transferType: (_, event)=>event.recipient.iban || event.recipient.accountReference ? "IBAN" : "TRANSFER",
                        transferMode: (_, event)=>event.transferMode
                    })
                },
                CREATE_CUSTOMER_INSTRUCTION: {
                    target: (0, $40sjz.PincodeState).PincodeConfirmation,
                    actions: [
                        (0, $c8ePo.assign)({
                            recipient: (_, event)=>event.recipient,
                            amount: (_, event)=>event.amount,
                            label: (_, event)=>event.label,
                            sourceAccount: (_, event)=>event.sourceAccount,
                            transferType: (_, event)=>event.recipient.iban || event.recipient.accountReference ? "IBAN" : "TRANSFER",
                            paymentNetwork: (_, event)=>event.paymentNetwork,
                            transferMode: (_, event)=>event.transferMode,
                            isP2PSimpleTransfer: (_, event)=>event.isP2PSimpleTransfer,
                            isOpenLoop: (_, event)=>event.isOpenLoop,
                            creditorAddress: (_, event)=>event.creditorAddress,
                            foreignAmount: (_, event)=>event.foreignAmount,
                            recurringTransferParams: (_, event)=>event.recurringTransferParams,
                            automaticRoutingConfig: (_, event)=>event.automaticRoutingConfig
                        })
                    ]
                },
                CANCEL_TRANSFER: "SelectingAmount"
            }
        },
        ["CancelTransfer"]: {
            invoke: {
                id: "cancelTransfer",
                src: (context)=>{
                    const transactionRequest = context.transactionRequest;
                    if (transactionRequest?.strongAuthenticationReference) return (0, $kqXxS.authenticationsSessionsManager).cancelAuthentication(transactionRequest.strongAuthenticationReference);
                    throw new Error("Strong authentication reference is missing in the transaction request");
                },
                onDone: {
                    target: "SelectingAmount",
                    actions: (0, $c8ePo.assign)({
                        errorMessage: (_, event)=>event.data
                    })
                },
                onError: {
                    target: "RequestingTransferError",
                    actions: (0, $c8ePo.assign)({
                        error: (_, event)=>event.data
                    })
                }
            }
        },
        ["Done"]: {
            type: "final"
        }
    }
});

});

parcelRegister("99Id8", function(module, exports) {

$parcel$export(module.exports, "AmountSelection", function () { return $22371f6be52e7fa3$export$20eeb2ab17d5afff; });

var $4m918 = parcelRequire("4m918");

var $gALIi = parcelRequire("gALIi");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $a5OyK = parcelRequire("a5OyK");

var $5P656 = parcelRequire("5P656");

var $8xKCH = parcelRequire("8xKCH");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $9mhzx = parcelRequire("9mhzx");

var $FyNgf = parcelRequire("FyNgf");

var $5ea1c = parcelRequire("5ea1c");

var $fQIdb = parcelRequire("fQIdb");

var $bx6cc = parcelRequire("bx6cc");

var $baz2A = parcelRequire("baz2A");

var $bGuuW = parcelRequire("bGuuW");

var $7Vlqd = parcelRequire("7Vlqd");

var $jPa7k = parcelRequire("jPa7k");

var $ctuln = parcelRequire("ctuln");

var $gDlNU = parcelRequire("gDlNU");

var $3BANn = parcelRequire("3BANn");

var $1prEj = parcelRequire("1prEj");

var $gbifg = parcelRequire("gbifg");

var $3Ersk = parcelRequire("3Ersk");

var $e4wja = parcelRequire("e4wja");

var $k4Ecv = parcelRequire("k4Ecv");

var $lT9Op = parcelRequire("lT9Op");

var $22v9q = parcelRequire("22v9q");

var $bZlaH = parcelRequire("bZlaH");

var $7Zu6k = parcelRequire("7Zu6k");

var $ajNEj = parcelRequire("ajNEj");

var $jn1mK = parcelRequire("jn1mK");

var $5rJrd = parcelRequire("5rJrd");

var $k5s21 = parcelRequire("k5s21");

var $39jSd = parcelRequire("39jSd");

var $9mlIh = parcelRequire("9mlIh");

var $3yllK = parcelRequire("3yllK");

var $51d3M = parcelRequire("51d3M");

var $avfE1 = parcelRequire("avfE1");

var $5tx5U = parcelRequire("5tx5U");

var $l1Fzw = parcelRequire("l1Fzw");
const $22371f6be52e7fa3$export$20eeb2ab17d5afff = (props)=>{
    const { automaticRouting: automaticRouting = false, acceptor: acceptor, children: children, className: className, destinationAccountOrRecipient: destinationAccountOrRecipient, editingSourceAndDestination: editingSourceAndDestination, isOpenLoop: isOpenLoop, isP2PSimpleTransfer: isP2PSimpleTransfer, loading: loading, paymentNetwork: paymentNetwork, recipient: recipient, sourceAccount: sourceAccount, onChangePaymentNetwork: onChangePaymentNetwork, onClearDestinationAccountOrRecipientSelection: onClearDestinationAccountOrRecipientSelection, onOpenDestinationAccountOrRecipientSelection: onOpenDestinationAccountOrRecipientSelection, onOpenSourceAccountSelection: onOpenSourceAccountSelection, submitAmount: submitAmount } = props;
    const accounts = (0, $9mhzx.useAccounts)();
    const selectableCurrencies = (0, $FyNgf.useSelectableCurrencies)(accounts);
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const defaultCountry = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).defaultCountry);
    const canMakeRecurringTransfer = isOpenLoop && (0, $kqXxS.featuresManager).features.get().paymentStandingOrderCreate;
    const [recurringTransferParams, setRecurringTransferParams] = (0, $6uYXW.useState)((0, $gALIi.cloneDeep)((0, $bGuuW.defaultRecurringTransferParams)));
    const { paymentNetworks: paymentNetworks, paymentNetworksOnConfig: paymentNetworksOnConfig, getPaymentNetworks: getPaymentNetworks, getPaymentNetworkProduct: getPaymentNetworkProduct, getPaymentNetworksOnConfig: getPaymentNetworksOnConfig, getPaymentNetworksByIban: getPaymentNetworksByIban } = (0, $7Vlqd.useCustomerInstruction)();
    const [selectedPaymentNetwork, setSelectedPaymentNetwork] = (0, $6uYXW.useState)(null);
    const { canDefineAddress: canDefineAddress, networkIdentificationModes: networkIdentificationModes, isAddressUnstructured: isAddressUnstructured, isAddressOptional: isAddressOptional } = (0, $jPa7k.default)(paymentNetworks, selectedPaymentNetwork, true);
    const [selectedCountry, setSelectedCountry] = (0, $6uYXW.useState)((0, $a5OyK.countriesArray)[0]);
    const [currency, setCurrency] = (0, $6uYXW.useState)(null);
    const [transferMode, setTransferMode] = (0, $6uYXW.useState)((0, $fQIdb.TransferMode).AccountTransfer);
    const [amount, setAmount] = (0, $6uYXW.useState)(null);
    const [foreignCurrency, setForeignCurrency] = (0, $6uYXW.useState)(null);
    const currencyToConvertIn = (0, $1prEj.getCurrencyToConvertIn)(isOpenLoop, foreignCurrency);
    const { canShowExchangeRate: canShowExchangeRate, convertedAmount: convertedAmount } = (0, $5ea1c.default)(amount, currencyToConvertIn);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [description, setDescription] = (0, $6uYXW.useState)("");
    const [recipientData, setRecipientData] = (0, $6uYXW.useState)(recipient ? {
        ...recipient
    } : null);
    const [creditorAddress, setCreditorAddress] = (0, $6uYXW.useState)({
        addressLines: "",
        structuredAddress: {
            buildingNumber: "",
            streetName: "",
            postCode: "",
            townName: ""
        },
        country: ""
    });
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)(defaultCountry);
    const [dataError, setDataError] = (0, $6uYXW.useState)(undefined);
    const hasError = (0, $gDlNU.isDefined)(dataError);
    const needCreditorPhoneNumber = isOpenLoop && networkIdentificationModes.includes((0, $bx6cc.PaymentIdentificationMode).PHONE) && networkIdentificationModes.length === 1;
    const needCreditorAccountNumber = isOpenLoop && networkIdentificationModes.includes((0, $bx6cc.PaymentIdentificationMode).ACCOUNT_NUMBER) && networkIdentificationModes.length === 1;
    const canEditForeignCurrency = destinationAccountOrRecipient && !destinationAccountOrRecipient?.currencyAlpha;
    const { forexConfiguration: { enabled: forexEnabled } = {
        enabled: false
    } } = paymentNetwork?.processing || {};
    const [amountError, setAmountError] = (0, $6uYXW.useState)(null);
    const [sctInstRetrieved, setSctInstRetrieved] = (0, $6uYXW.useState)(false);
    const [instantTransferToggleValue, setInstantTransferToggleValue] = (0, $6uYXW.useState)(true);
    const automaticRoutingConfig = {
        automaticRoutingEnabled: automaticRouting,
        instantTransfer: instantTransferToggleValue && sctInstRetrieved
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (!isOpenLoop) return;
        getPaymentNetworks();
    }, []);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        getPaymentNetworksOnConfig();
    }, []);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        setSctInstRetrieved(false);
        if ((0, $k4Ecv.isSctEnabled)(paymentNetworksOnConfig) && destinationAccountOrRecipient?.iban) {
            const res = await getPaymentNetworksByIban(destinationAccountOrRecipient.iban);
            const isSctEnabledByIban = (0, $k4Ecv.isSctEnabled)(res);
            if (isSctEnabledByIban) {
                setSctInstRetrieved(true);
                setInstantTransferToggleValue(true);
            }
        }
    }, [
        destinationAccountOrRecipient
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (instantTransferToggleValue) setRecurringTransferParams((0, $bGuuW.defaultRecurringTransferParams));
    }, [
        instantTransferToggleValue
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (!selectedPaymentNetwork && paymentNetworks.length > 0) setSelectedPaymentNetwork(paymentNetworks[0]);
    }, [
        paymentNetworks
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (isOpenLoop && selectedPaymentNetwork) onClearDestinationAccountOrRecipientSelection?.();
    }, [
        selectedPaymentNetwork
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (!isOpenLoop) {
            let initialCurrency = currency;
            if (accounts.length > 0 && !(0, $gDlNU.isDefined)(currency)) {
                initialCurrency = accounts[0]?.currencyAlpha;
                setCurrency(initialCurrency);
            }
            if (!(0, $gDlNU.isDefined)(amount) && (0, $gDlNU.isDefined)(initialCurrency)) setAmount(new (0, $5P656.Amount)(0, initialCurrency));
        }
    }, [
        accounts,
        currency,
        amount
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (sourceAccount) {
            const curr = sourceAccount.currencyAlpha;
            setCurrency(curr);
            setAmount(new (0, $5P656.Amount)(0, curr));
        }
    }, [
        sourceAccount
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (sourceAccount && !destinationAccountOrRecipient) setForeignCurrency(sourceAccount.currencyAlpha);
    }, [
        sourceAccount,
        destinationAccountOrRecipient
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (isOpenLoop && destinationAccountOrRecipient) {
            if (destinationAccountOrRecipient.currencyAlpha) setForeignCurrency(destinationAccountOrRecipient.currencyAlpha);
            else if (destinationAccountOrRecipient.iban) {
                const curr = (0, $gbifg.getCurrencyFromIban)(destinationAccountOrRecipient.iban);
                setForeignCurrency(curr);
            } else if (destinationAccountOrRecipient.bic) {
                const curr = (0, $gbifg.getCurrencyFromBic)(destinationAccountOrRecipient.bic);
                setForeignCurrency(curr);
            } else if (sourceAccount) setForeignCurrency(sourceAccount.currencyAlpha);
        }
    }, [
        sourceAccount,
        isOpenLoop,
        destinationAccountOrRecipient
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (!isOpenLoop && (0, $gDlNU.isDefined)(amount) && currency && currency !== amount.currency) setAmount((0, $5P656.switchCurrency)(amount, currency));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currency
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (configuration.countries) {
            const country = (0, $a5OyK.countriesArray).find((c)=>c["alpha-2"] === configuration.countries?.[0]);
            if (country) handleSetSelectedCountry(country);
        }
    }, [
        configuration.countries
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (selectedPaymentNetwork?.productId) {
            const product = await getPaymentNetworkProduct(selectedPaymentNetwork.productId);
            if (onChangePaymentNetwork) onChangePaymentNetwork(product);
            else console.error("onChangePaymentNetwork is not defined");
        }
    }, [
        selectedPaymentNetwork
    ]);
    (0, $6uYXW.useEffect)(()=>{
        (0, $3BANn.setCountryFromAccount)(destinationAccountOrRecipient, handleSetSelectedCountry);
    }, [
        destinationAccountOrRecipient?.iban,
        destinationAccountOrRecipient?.bic
    ]);
    const isStructuredAddressValid = (0, $6uYXW.useMemo)(()=>!!creditorAddress.structuredAddress?.buildingNumber && !!creditorAddress.structuredAddress?.streetName && !!creditorAddress.structuredAddress?.postCode && !!creditorAddress.structuredAddress?.townName, [
        creditorAddress
    ]);
    const isAddressValid = (0, $6uYXW.useMemo)(()=>(0, $ctuln.getIsAddressValid)(canDefineAddress, isAddressUnstructured, isAddressOptional, isStructuredAddressValid, creditorAddress), [
        creditorAddress,
        isAddressOptional,
        isStructuredAddressValid,
        canDefineAddress,
        isAddressUnstructured
    ]);
    const canSubmit = (0, $6uYXW.useMemo)(()=>{
        const isAmountValid = !!amount && amount.value > 0;
        if (isOpenLoop) return isAmountValid && isAddressValid && !!sourceAccount && !!destinationAccountOrRecipient && !!selectedPaymentNetwork;
        return isAmountValid;
    }, [
        sourceAccount,
        destinationAccountOrRecipient,
        amount,
        isOpenLoop,
        isAddressValid,
        selectedPaymentNetwork
    ]);
    const handleSubmit = (0, $6uYXW.useCallback)((e)=>{
        e.preventDefault();
        if ((0, $gDlNU.isDefined)(amount) && canSubmit) submitAmount(isOpenLoop ? destinationAccountOrRecipient : {
            ...recipientData,
            phone: (0, $a5OyK.countries)[countryCode].phoneCode + recipientData?.phone?.split(" ").join("")
        }, amount, accounts, description, isOpenLoop ? sourceAccount : undefined, selectedPaymentNetwork, transferMode ?? undefined, canDefineAddress ? creditorAddress : undefined, convertedAmount, canMakeRecurringTransfer ? recurringTransferParams : undefined, automaticRoutingConfig);
    }, [
        amount,
        selectedPaymentNetwork,
        transferMode,
        accounts,
        convertedAmount,
        creditorAddress,
        description,
        isOpenLoop,
        canDefineAddress,
        canMakeRecurringTransfer,
        canSubmit,
        recipientData,
        countryCode,
        sourceAccount,
        destinationAccountOrRecipient,
        recurringTransferParams,
        submitAmount,
        automaticRoutingConfig
    ]);
    const handleInstantTransferToggleValue = (value)=>{
        setInstantTransferToggleValue(value);
    };
    const editPhone = (phoneNumber)=>{
        const nationalNumber = "+" + (0, $a5OyK.countries)[countryCode].phoneCode;
        const internationalPhoneNumber = phoneNumber.startsWith(nationalNumber) ? phoneNumber : nationalNumber + phoneNumber;
        const formatted = (0, $e4wja.extractFormattedPhoneNumber)(internationalPhoneNumber, nationalNumber);
        setRecipientData({
            ...recipientData,
            phone: formatted
        });
    };
    const handleSetSelectedCountry = (country)=>{
        setSelectedCountry(country);
        setCreditorAddress({
            ...creditorAddress,
            country: country["iso-numeric"]
        });
    };
    const currencySelectOptions = paymentNetwork && sourceAccount ? (0, $baz2A.getCurrencySelectOptions)(paymentNetwork, sourceAccount) : [];
    (0, $6uYXW.useEffect)(()=>{
        if (amount && sourceAccount) {
            const accountBalance = (0, $kGswT.getAvailableBalance)(sourceAccount)?.value;
            if (accountBalance < amount.value) setAmountError(formatMessage("amountSelection.insufficient_balance"));
            else setAmountError(null);
        }
    }, [
        amount,
        sourceAccount,
        formatMessage
    ]);
    const uniqueServiceLevels = (0, $k4Ecv.getUniqueNetworksByServiceLevel)(paymentNetworks);
    return /*#__PURE__*/ (0, $4m918.jsxs)($22371f6be52e7fa3$var$Container, {
        className: className,
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($22371f6be52e7fa3$var$LeftColumn, {
                children: [
                    isP2PSimpleTransfer ? /*#__PURE__*/ (0, $4m918.jsx)((0, $avfE1.P2PSimpleTransfer), {
                        accounts: accounts,
                        sourceAccount: sourceAccount,
                        onOpenSourceAccountSelection: onOpenSourceAccountSelection,
                        editingSourceAndDestination: editingSourceAndDestination,
                        formatMessage: formatMessage,
                        recipient: recipient,
                        recipientData: recipientData,
                        setRecipientData: setRecipientData,
                        countryCode: countryCode,
                        setCountryCode: setCountryCode,
                        configuration: configuration,
                        countries: (0, $a5OyK.countries),
                        hasError: hasError,
                        setDataError: setDataError,
                        editPhone: editPhone
                    }) : isOpenLoop ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            !automaticRouting && (sctInstRetrieved ? !instantTransferToggleValue : true) && uniqueServiceLevels.length > 1 ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                        size: "normal",
                                        margin: "normal",
                                        label: "amountSelection.network",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                                        style: {
                                            width: "100%"
                                        },
                                        innerId: "payment-network",
                                        required: true,
                                        options: uniqueServiceLevels,
                                        value: selectedPaymentNetwork,
                                        onChange: (value)=>setSelectedPaymentNetwork(value),
                                        itemRenderer: (v)=>v?.name ?? "",
                                        hasError: hasError
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                size: "normal",
                                margin: "normal",
                                label: "amountSelection.since",
                                required: true
                            }),
                            sourceAccount ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lT9Op.AccountButton), {
                                account: sourceAccount,
                                onClick: onOpenSourceAccountSelection
                            }) : /*#__PURE__*/ (0, $4m918.jsxs)($22371f6be52e7fa3$var$SourceAndDestinationButton, {
                                type: "button",
                                $active: editingSourceAndDestination === (0, $lT9Op.SourceAndDestinationEnum).Source,
                                onClick: onOpenSourceAccountSelection,
                                children: [
                                    formatMessage("amountSelection.choose_source_account"),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $51d3M.ChevronIcon), {
                                        width: 18,
                                        height: 18,
                                        style: {}
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    isOpenLoop ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                size: "normal",
                                margin: "normal",
                                label: "amountSelection.to",
                                required: true
                            }),
                            destinationAccountOrRecipient ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lT9Op.AccountButton), {
                                account: destinationAccountOrRecipient,
                                onClick: ()=>onOpenDestinationAccountOrRecipientSelection?.(needCreditorPhoneNumber, needCreditorAccountNumber, canDefineAddress)
                            }) : /*#__PURE__*/ (0, $4m918.jsxs)($22371f6be52e7fa3$var$SourceAndDestinationButton, {
                                type: "button",
                                $active: editingSourceAndDestination === (0, $lT9Op.SourceAndDestinationEnum).Destination,
                                onClick: ()=>onOpenDestinationAccountOrRecipientSelection?.(needCreditorPhoneNumber, needCreditorAccountNumber, canDefineAddress),
                                children: [
                                    formatMessage("amountSelection.choose_destination_account"),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $51d3M.ChevronIcon), {
                                        width: 18,
                                        height: 18
                                    })
                                ]
                            }),
                            forexEnabled && canShowExchangeRate && /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$StyledForeignCurrencySelectInput, {
                                value: foreignCurrency ? (0, $8xKCH.Currencies)[foreignCurrency] : null,
                                options: currencySelectOptions,
                                placeholder: formatMessage("amountSelection.foreignCurrencyPlaceholder"),
                                itemRenderer: (curr)=>curr ? `${curr.name} (${curr.symbol})` : "-",
                                innerId: "foreign-currency",
                                onChange: (curr)=>setForeignCurrency(curr.iso_alpha),
                                disabled: !canEditForeignCurrency
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                size: "normal",
                                margin: "normal",
                                label: "amountSelection.currencyLabel"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $3yllK.Selector), {
                                options: Array.from(selectableCurrencies).map((curr)=>({
                                        value: curr,
                                        text: (0, $8xKCH.Currencies)[curr].symbol,
                                        key: curr.toString()
                                    })),
                                value: currency,
                                onChange: (c)=>setCurrency(c),
                                size: "S"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "amountSelection.amountLabel",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $5rJrd.AmountInput), {
                        disabled: !currency,
                        variant: "big",
                        value: amount,
                        onChange: setAmount
                    }),
                    forexEnabled && canShowExchangeRate && convertedAmount && /*#__PURE__*/ (0, $4m918.jsxs)($22371f6be52e7fa3$var$StyledConvertedAmount, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("span", {
                                children: formatMessage("amountSelection.convertedAmountLabel")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $bZlaH.AmountText), {
                                amount: convertedAmount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "amountSelection.descriptionLabel"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        value: description,
                        onChange: (event)=>setDescription(event.target.value)
                    }),
                    isOpenLoop ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                size: "normal",
                                margin: "normal",
                                label: canDefineAddress ? "amountSelection.creditorAddress.addressLabel" : "amountSelection.creditorAddress.countryLabel"
                            }),
                            canDefineAddress && (isAddressUnstructured ? /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$StyledAddressLine, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$AddressTextInput, {
                                    required: !isAddressOptional,
                                    value: creditorAddress.addressLines,
                                    onChange: (event)=>setCreditorAddress({
                                            ...creditorAddress,
                                            addressLines: event.target.value
                                        }),
                                    placeholder: formatMessage("amountSelection.creditorAddress.addressLabel")
                                })
                            }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsxs)($22371f6be52e7fa3$var$StyledAddressLine, {
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$AddressTextInputSmall, {
                                                required: true,
                                                value: creditorAddress.structuredAddress?.buildingNumber,
                                                onChange: (event)=>setCreditorAddress({
                                                        ...creditorAddress,
                                                        structuredAddress: {
                                                            ...creditorAddress.structuredAddress,
                                                            buildingNumber: event.target.value
                                                        }
                                                    }),
                                                placeholder: formatMessage("amountSelection.creditorAddress.buildingNumber")
                                            }),
                                            /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$AddressTextInput, {
                                                required: true,
                                                value: creditorAddress.structuredAddress?.streetName,
                                                onChange: (event)=>setCreditorAddress({
                                                        ...creditorAddress,
                                                        structuredAddress: {
                                                            ...creditorAddress.structuredAddress,
                                                            streetName: event.target.value
                                                        }
                                                    }),
                                                placeholder: formatMessage("amountSelection.creditorAddress.streetName")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$StyledAddressLine, {
                                        children: /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$AddressTextInput, {
                                            required: true,
                                            value: creditorAddress.structuredAddress?.postCode,
                                            onChange: (event)=>setCreditorAddress({
                                                    ...creditorAddress,
                                                    structuredAddress: {
                                                        ...creditorAddress.structuredAddress,
                                                        postCode: event.target.value
                                                    }
                                                }),
                                            placeholder: formatMessage("amountSelection.creditorAddress.postCode")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$StyledAddressLine, {
                                        children: /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$AddressTextInput, {
                                            required: true,
                                            value: creditorAddress.structuredAddress?.townName,
                                            onChange: (event)=>setCreditorAddress({
                                                    ...creditorAddress,
                                                    structuredAddress: {
                                                        ...creditorAddress.structuredAddress,
                                                        townName: event.target.value
                                                    }
                                                }),
                                            placeholder: formatMessage("amountSelection.creditorAddress.townName")
                                        })
                                    })
                                ]
                            })),
                            /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$StyledAddressLine, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                                    required: true,
                                    options: (0, $a5OyK.countriesArray),
                                    value: selectedCountry,
                                    itemRenderer: (v)=>v ? v.name : "-",
                                    innerId: "creditor-country",
                                    onChange: (country)=>handleSetSelectedCountry(country)
                                })
                            })
                        ]
                    }) : !acceptor && !isP2PSimpleTransfer && /*#__PURE__*/ (0, $4m918.jsx)((0, $l1Fzw.TransferModeSelection), {
                        recipient: recipient,
                        transferTypeSelected: setTransferMode
                    }),
                    sctInstRetrieved && /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$InstantTransferSwitchContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $ajNEj.SwitchContainer), {
                            value: instantTransferToggleValue,
                            labelPosition: "left",
                            onSwitch: handleInstantTransferToggleValue,
                            getSwitchLabel: ()=>formatMessage("amountSelection.instant_transfer_label")
                        })
                    }),
                    (automaticRouting ? !instantTransferToggleValue || !sctInstRetrieved : true) && sourceAccount?.currencyAlpha === foreignCurrency && canMakeRecurringTransfer && /*#__PURE__*/ (0, $4m918.jsx)((0, $5tx5U.default), {
                        value: recurringTransferParams,
                        onChange: setRecurringTransferParams
                    }),
                    amountError && /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$StyledErrorMessage, {
                        children: amountError
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$NextButton, {
                            size: "S",
                            disabled: !canSubmit,
                            showSpinner: loading,
                            children: /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$ButtonLabel, {
                                children: formatMessage("amountSelection.sendButton")
                            })
                        })
                    })
                ]
            }),
            children ? /*#__PURE__*/ (0, $4m918.jsx)($22371f6be52e7fa3$var$RightColumn, {
                children: children
            }) : null
        ]
    });
};
const $22371f6be52e7fa3$var$Container = (0, $jb8NR.default).form`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  gap: 30px;
`;
const $22371f6be52e7fa3$var$LeftColumn = (0, $jb8NR.default).div`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $22371f6be52e7fa3$var$RightColumn = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $22371f6be52e7fa3$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;
const $22371f6be52e7fa3$var$NextButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $22371f6be52e7fa3$var$ButtonLabel = (0, $jb8NR.default).span`
  color: ${(props)=>props.disabled ? "#b1b1b1" : "#ffffff"};
`;
const $22371f6be52e7fa3$var$SourceAndDestinationButton = (0, $jb8NR.default)("button")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  appearance: none;
  border: none;
  height: 48px;
  box-shadow: none;
  background-color: white;
  text-align: left;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;
  ${(0, $22v9q.theme).bodyBlackRegular};
  ${(props)=>props.$active && (0, $jb8NR.css)`
      color: ${(0, $22v9q.theme).mainColor()};
      svg {
        fill: ${(0, $22v9q.theme).mainColor()};
      }
    `}
  ${(props)=>props.disabled && (0, $jb8NR.css)`
      opacity: 0.5;
      &:hover {
        cursor: not-allowed;
      }
    `}
`;
const $22371f6be52e7fa3$var$StyledAddressLine = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-bottom: 15px;
`;
const $22371f6be52e7fa3$var$AddressTextInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  flex: 1;
`;
const $22371f6be52e7fa3$var$AddressTextInputSmall = (0, $jb8NR.default)($22371f6be52e7fa3$var$AddressTextInput)`
  max-width: 100px;
`;
const $22371f6be52e7fa3$var$StyledConvertedAmount = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).bodySmallGreyDarkMedium};
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 12px;
  background-color: ${(0, $22v9q.theme).colors.gray[300]};
  padding: 12px;
`;
const $22371f6be52e7fa3$var$StyledForeignCurrencySelectInput = (0, $jb8NR.default)((0, $39jSd.SelectInput))`
  margin-top: 15px;
`;
const $22371f6be52e7fa3$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0 5px;
`;
const $22371f6be52e7fa3$var$InstantTransferSwitchContainer = (0, $jb8NR.default).div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

});
parcelRegister("FyNgf", function(module, exports) {

$parcel$export(module.exports, "useSelectableCurrencies", function () { return $2af97b649f37fb6c$export$b4f4fee98158b67d; });

var $6uYXW = parcelRequire("6uYXW");
const $2af97b649f37fb6c$export$b4f4fee98158b67d = (accounts)=>{
    const getAllCurrencies = (accounts)=>{
        const res = [];
        accounts.map((a)=>a.balances.map((b)=>res.push(b.currencyAlpha)));
        return res;
    };
    const selectableCurrencies = (0, $6uYXW.useMemo)(()=>new Set(getAllCurrencies(accounts)), [
        accounts
    ]);
    return selectableCurrencies;
};

});

parcelRegister("baz2A", function(module, exports) {

$parcel$export(module.exports, "getCurrencySelectOptions", function () { return $a492d7871fc8e690$export$37daaaba7f854dee; });
$parcel$export(module.exports, "getDestinationAccounts", function () { return $a492d7871fc8e690$export$550346e13c5a0607; });

var $gALIi = parcelRequire("gALIi");

var $8xKCH = parcelRequire("8xKCH");

var $gX2SJ = parcelRequire("gX2SJ");
const $a492d7871fc8e690$export$37daaaba7f854dee = (paymentNetwork, sourceAccount)=>{
    const { forexConfiguration: { currencyCouples: currencyCouples } = {} } = paymentNetwork.processing;
    const targetCurrencies = (0, $gX2SJ.fetchTargetCurrencies)(sourceAccount, currencyCouples);
    const currencySelectOptions = (0, $gALIi.map)((0, $8xKCH.Currencies), (v)=>v).filter((curr)=>targetCurrencies?.includes(curr.iso_numeric));
    return currencySelectOptions;
};
const $a492d7871fc8e690$export$550346e13c5a0607 = (paymentNetwork, sourceAccount, accounts)=>{
    const { forexConfiguration: forexConfiguration } = paymentNetwork.processing;
    if (forexConfiguration?.enabled === true) {
        const targetCurrencies = (0, $gX2SJ.fetchTargetCurrencies)(sourceAccount, forexConfiguration.currencyCouples);
        const destinationAccounts = accounts.filter((account)=>account.id !== sourceAccount.id && targetCurrencies.includes(account.currency));
        return destinationAccounts;
    } else {
        const destinationAccounts = accounts.filter((account)=>account.id !== sourceAccount.id && account.currency === sourceAccount.currency);
        return destinationAccounts;
    }
};

});
parcelRegister("gX2SJ", function(module, exports) {

$parcel$export(module.exports, "fetchTargetCurrencies", function () { return $09fda63c91bc9c41$export$80ad3458f49accc5; });
const $09fda63c91bc9c41$export$80ad3458f49accc5 = (sourceAccount, currencyCouples)=>{
    const targetCurrencies = currencyCouples?.reduce((acc, cc)=>{
        if (cc.origin === sourceAccount.currency) acc.push(cc.target);
        return acc;
    }, [
        sourceAccount.currency
    ]);
    return targetCurrencies;
};

});


parcelRegister("bGuuW", function(module, exports) {

$parcel$export(module.exports, "RECURRING_TRANSFER_FREQUENCY_OPTIONS", function () { return $332d8516f89f38f2$export$1330da60e9399ebd; });
$parcel$export(module.exports, "defaultRecurringTransferParams", function () { return $332d8516f89f38f2$export$edd8159327e30a35; });

var $l1qT9 = parcelRequire("l1qT9");
var $332d8516f89f38f2$export$92a2743cdb6e2a37 = /*#__PURE__*/ function(RecurringTransferUnit) {
    RecurringTransferUnit["DAY"] = "day";
    RecurringTransferUnit["WEEK"] = "week";
    RecurringTransferUnit["MONTH"] = "month";
    return RecurringTransferUnit;
}({});
const $332d8516f89f38f2$export$1330da60e9399ebd = [
    {
        label: "recurringTransfer.optionLabel.daily",
        frequency: {
            unit: "day",
            interval: 1
        }
    },
    {
        label: "recurringTransfer.optionLabel.weekly",
        frequency: {
            unit: "week",
            interval: 1
        }
    },
    {
        label: "recurringTransfer.optionLabel.twiceAMonth",
        frequency: {
            unit: "week",
            interval: 2
        }
    },
    {
        label: "recurringTransfer.optionLabel.monthly",
        frequency: {
            unit: "month",
            interval: 1
        }
    }
];
const $332d8516f89f38f2$export$edd8159327e30a35 = {
    enabled: false,
    firstExecutionDate: (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))().add(1, "day").format("YYYY-MM-DD"),
    frequency: $332d8516f89f38f2$export$1330da60e9399ebd[0].frequency,
    endDate: ""
};

});

parcelRegister("7Vlqd", function(module, exports) {

$parcel$export(module.exports, "useCustomerInstruction", function () { return $4bc078e9414a43b2$export$55dd2c4fde025633; });

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");
const $4bc078e9414a43b2$export$55dd2c4fde025633 = ()=>{
    const paymentNetworks = (0, $3Ersk.useObservable)((0, $kqXxS.transferManager).paymentNetworks);
    const paymentNetworksByIban = (0, $3Ersk.useObservable)((0, $kqXxS.transferManager).paymentNetworksByIban);
    const paymentNetworksOnConfig = (0, $3Ersk.useObservable)((0, $kqXxS.transferManager).paymentNetworksOnConfig);
    const getPaymentNetworks = async ()=>(0, $kqXxS.transferManager).getPaymentNetworks();
    const getPaymentNetworkProduct = async (productId)=>(0, $kqXxS.transferManager).getPaymentNetworkProduct(productId);
    const getPaymentNetworksByIban = async (iban)=>(0, $kqXxS.transferManager).getPaymentNetworksByIban(iban);
    const getPaymentNetworksOnConfig = async ()=>(0, $kqXxS.transferManager).getPaymentNetworksOnConfig();
    return {
        paymentNetworks: paymentNetworks,
        paymentNetworksByIban: paymentNetworksByIban,
        paymentNetworksOnConfig: paymentNetworksOnConfig,
        getPaymentNetworks: getPaymentNetworks,
        getPaymentNetworkProduct: getPaymentNetworkProduct,
        getPaymentNetworksByIban: getPaymentNetworksByIban,
        getPaymentNetworksOnConfig: getPaymentNetworksOnConfig
    };
};

});

parcelRegister("jPa7k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a35352aa492c852$export$2e2bcd8739ae039; });

var $6uYXW = parcelRequire("6uYXW");

var $bx6cc = parcelRequire("bx6cc");
function $6a35352aa492c852$export$2e2bcd8739ae039(paymentNetworks, selectedPaymentNetwork, concatNetworksIdentificationModes = false) {
    const networkAcceptedAddresses = (0, $6uYXW.useMemo)(()=>selectedPaymentNetwork?.acceptedAddresses, [
        selectedPaymentNetwork
    ]);
    const canDefineAddress = (0, $6uYXW.useMemo)(()=>networkAcceptedAddresses ? (0, $bx6cc.NETWORK_ACCEPTED_ADDRESSES_NEEDED).includes(networkAcceptedAddresses) : false, [
        networkAcceptedAddresses
    ]);
    const networkIdentificationModes = (0, $6uYXW.useMemo)(()=>{
        if (concatNetworksIdentificationModes) {
            const identificationModes = [
                ...paymentNetworks
            ].reduce((prev, curr)=>prev.concat(curr.identificationMode || []), []);
            return [
                ...new Set(identificationModes)
            ];
        } else return selectedPaymentNetwork?.identificationMode || [];
    }, [
        paymentNetworks,
        concatNetworksIdentificationModes,
        selectedPaymentNetwork
    ]);
    const isAddressUnstructured = (0, $6uYXW.useMemo)(()=>canDefineAddress && networkAcceptedAddresses ? [
            (0, $bx6cc.PaymentAcceptedAddress).UNSTRUCTURED,
            (0, $bx6cc.PaymentAcceptedAddress).UNSTRUCTURED_OR_NULL,
            (0, $bx6cc.PaymentAcceptedAddress).BOTH
        ].includes(networkAcceptedAddresses) : false, [
        canDefineAddress,
        networkAcceptedAddresses
    ]);
    const isAddressOptional = (0, $6uYXW.useMemo)(()=>isAddressUnstructured && networkAcceptedAddresses === (0, $bx6cc.PaymentAcceptedAddress).UNSTRUCTURED_OR_NULL, [
        isAddressUnstructured,
        networkAcceptedAddresses
    ]);
    const needIbanIdentification = (0, $6uYXW.useMemo)(()=>selectedPaymentNetwork?.identificationMode.includes((0, $bx6cc.PaymentIdentificationMode).IBAN), [
        selectedPaymentNetwork
    ]);
    return {
        networkAcceptedAddresses: networkAcceptedAddresses,
        canDefineAddress: canDefineAddress,
        networkIdentificationModes: networkIdentificationModes,
        isAddressUnstructured: isAddressUnstructured,
        isAddressOptional: isAddressOptional,
        needIbanIdentification: needIbanIdentification
    };
}

});

parcelRegister("ctuln", function(module, exports) {

$parcel$export(module.exports, "getIsAddressValid", function () { return $857230ce6c8b3473$export$f4ea30b25e3598c6; });
const $857230ce6c8b3473$export$f4ea30b25e3598c6 = (canDefineAddress, isAddressUnstructured, isAddressOptional, isStructuredAddressValid, creditorAddress)=>{
    if (!creditorAddress.country) return false;
    if (!canDefineAddress) return true;
    if (isAddressUnstructured) return isAddressOptional || !!creditorAddress.addressLines && creditorAddress.addressLines.length > 0;
    return isStructuredAddressValid;
};

});

parcelRegister("1prEj", function(module, exports) {

$parcel$export(module.exports, "getCurrencyToConvertIn", function () { return $406a1ef4fbeeca71$export$dddcdba290d17d85; });

var $dhPTb = parcelRequire("dhPTb");
function $406a1ef4fbeeca71$export$dddcdba290d17d85(isOpenLoop, foreignCurrency) {
    if (isOpenLoop) return foreignCurrency;
    return (0, $dhPTb.Config).CURRENCY_TO_CONVERT_IN_EUR_ENABLED ? "EUR" : null;
}

});

parcelRegister("lT9Op", function(module, exports) {

$parcel$export(module.exports, "SourceAndDestinationEnum", function () { return $d45fd10cff607317$export$f3544710aa6a6255; });
$parcel$export(module.exports, "AccountButton", function () { return $d45fd10cff607317$export$6d6e8f8ac62271dd; });
$parcel$export(module.exports, "SourceAndDestination", function () { return $d45fd10cff607317$export$370aa195d94afd8f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $9mhzx = parcelRequire("9mhzx");

var $h6mRe = parcelRequire("h6mRe");

var $cG3cd = parcelRequire("cG3cd");

var $baz2A = parcelRequire("baz2A");

var $bZlaH = parcelRequire("bZlaH");

var $jMdmu = parcelRequire("jMdmu");

var $bewhU = parcelRequire("bewhU");

var $22v9q = parcelRequire("22v9q");
var $d45fd10cff607317$export$f3544710aa6a6255 = /*#__PURE__*/ function(SourceAndDestinationEnum) {
    SourceAndDestinationEnum["Source"] = "source";
    SourceAndDestinationEnum["Destination"] = "destination";
    return SourceAndDestinationEnum;
}({});
const $d45fd10cff607317$export$6d6e8f8ac62271dd = (props)=>{
    const { account: account, onClick: onClick, showAvatar: showAvatar = true } = props;
    return /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledButton, {
        justified: !!(0, $kGswT.getAvailableBalance)(account),
        onClick: onClick,
        children: !!account.name && !!(0, $kGswT.getAvailableBalance)(account) ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledButtonLeft, {
                            children: account.name
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledIban, {
                            children: account.iban
                        })
                    ]
                }),
                (0, $kGswT.getAvailableBalance)(account) ? /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledAmountText, {
                    amount: (0, $kGswT.getAvailableBalance)(account)
                }) : null
            ]
        }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
            children: [
                showAvatar && /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$AvatarWrapper, {
                    fontSize: "10px",
                    size: 24,
                    name: account.name
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$AccountNameWrapper, {
                            children: account.name
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledIban, {
                            children: account.iban || account.phone || account.accountReference
                        })
                    ]
                })
            ]
        })
    });
};
const $d45fd10cff607317$export$370aa195d94afd8f = (props)=>{
    const { needCreditorPhoneNumber: needCreditorPhoneNumber, needCreditorAccountNumber: needCreditorAccountNumber, needCreditorAddress: needCreditorAddress, paymentNetwork: paymentNetwork, sourceAccount: sourceAccount, accountTypeFilter: accountTypeFilter, type: type, onSourceAccountChange: onSourceAccountChange, onDestinationAccountOrRecipientChange: onDestinationAccountOrRecipientChange } = props;
    const allAccounts = (0, $9mhzx.useAccounts)();
    const accounts = accountTypeFilter ? allAccounts.filter((acc)=>acc.type === accountTypeFilter) : allAccounts;
    const { data: externalAccounts } = (0, $cG3cd.useExternalAccounts)();
    const { data: recipients, canLoadMore: canLoadMore, loadMore: loadMore } = (0, $h6mRe.useBeneficiaries)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const filteredExternalAccounts = needCreditorPhoneNumber ? externalAccounts?.filter((account)=>!!account.phone) : needCreditorAccountNumber ? externalAccounts?.filter((account)=>!!account.accountReference) : externalAccounts;
    const filteredRecipients = needCreditorPhoneNumber ? recipients.filter((recipient)=>!!recipient.phone) : needCreditorAccountNumber ? recipients.filter((recipient)=>!!recipient.accountReference) : recipients;
    const destinationAccounts = paymentNetwork && sourceAccount ? (0, $baz2A.getDestinationAccounts)(paymentNetwork, sourceAccount, accounts) : [];
    return type === "source" ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledLabel, {
                children: formatMessage("amountSelection.my_accounts")
            }),
            accounts.map((account, index)=>/*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$AccountButtonWrapper, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$export$6d6e8f8ac62271dd, {
                        account: account,
                        onClick: ()=>onSourceAccountChange?.(account)
                    })
                }, index))
        ]
    }) : type === "destination" ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            destinationAccounts.length > 0 ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledLabel, {
                        children: formatMessage("amountSelection.my_accounts")
                    }),
                    destinationAccounts.map((account, index)=>/*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$AccountButtonWrapper, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$export$6d6e8f8ac62271dd, {
                                account: account,
                                onClick: ()=>onDestinationAccountOrRecipientChange?.(account)
                            })
                        }, index))
                ]
            }) : null,
            filteredExternalAccounts?.length > 0 ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledLabel, {
                        children: formatMessage("amountSelection.my_external_account")
                    }),
                    filteredExternalAccounts.map((account, index)=>/*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$AccountButtonWrapper, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$export$6d6e8f8ac62271dd, {
                                account: account,
                                onClick: ()=>onDestinationAccountOrRecipientChange?.(account),
                                showAvatar: false
                            })
                        }, index))
                ]
            }) : null,
            filteredRecipients?.length > 0 ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$StyledLabel, {
                        children: formatMessage("amountSelection.my_recipients")
                    }),
                    filteredRecipients.map((account, index)=>/*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$var$AccountButtonWrapper, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)($d45fd10cff607317$export$6d6e8f8ac62271dd, {
                                account: account,
                                onClick: ()=>onDestinationAccountOrRecipientChange?.(account)
                            })
                        }, index)),
                    canLoadMore ? /*#__PURE__*/ (0, $4m918.jsx)((0, $bewhU.DefaultButton), {
                        onClick: loadMore,
                        children: formatMessage("amountSelection.load_more")
                    }) : null
                ]
            }) : null
        ]
    }) : null;
};
const $d45fd10cff607317$var$StyledButton = (0, $jb8NR.default)("div")`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  box-shadow: none;
  background-color: white;
  text-align: left;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;
  min-width: 0;
  ${(0, $22v9q.theme).bodyBlackRegular};
  ${(props)=>props.justified ? "justify-content: space-between;" : ""}
`;
const $d45fd10cff607317$var$AccountButtonWrapper = (0, $jb8NR.default).div`
  margin-bottom: 15px;
`;
const $d45fd10cff607317$var$StyledButtonLeft = (0, $jb8NR.default).span`
  white-space: wrap;
  margin-right: 10px;
`;
const $d45fd10cff607317$var$StyledAmountText = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  ${(0, $22v9q.theme).boldText};
`;
const $d45fd10cff607317$var$StyledLabel = (0, $jb8NR.default).p`
  margin: 30px 0 5px;
  ${(0, $22v9q.theme).mediumText};
`;
const $d45fd10cff607317$var$StyledIban = (0, $jb8NR.default).span`
  display: block;
  ${(0, $22v9q.theme).bodyGreyRegular};
  font-size: 12px;
`;
const $d45fd10cff607317$var$AvatarWrapper = (0, $jb8NR.default)((0, $jMdmu.Avatar))`
  margin-right: 10px;
`;
const $d45fd10cff607317$var$AccountNameWrapper = (0, $jb8NR.default).div`
  text-transform: capitalize;
`;

});

parcelRegister("avfE1", function(module, exports) {

$parcel$export(module.exports, "P2PSimpleTransfer", function () { return $d5aefa754fbe1761$export$6472a730514e6baa; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $etzj2 = parcelRequire("etzj2");

var $k5s21 = parcelRequire("k5s21");

var $cUa6O = parcelRequire("cUa6O");

var $dkEe7 = parcelRequire("dkEe7");

var $9mlIh = parcelRequire("9mlIh");

var $38fDu = parcelRequire("38fDu");
const $d5aefa754fbe1761$export$6472a730514e6baa = ({ accounts: accounts, sourceAccount: sourceAccount, onOpenSourceAccountSelection: onOpenSourceAccountSelection, editingSourceAndDestination: editingSourceAndDestination, formatMessage: formatMessage, recipient: recipient, recipientData: recipientData, setRecipientData: setRecipientData, countryCode: countryCode, setCountryCode: setCountryCode, configuration: configuration, countries: countries, hasError: hasError, setDataError: setDataError, editPhone: editPhone })=>{
    const recipientName = recipient?.name ?? recipientData?.name;
    const recipientPhone = recipient?.phone ?? recipientData?.phone;
    const selectedCountry = countries[countryCode];
    const handleNameChange = (event)=>{
        setRecipientData({
            ...recipientData,
            name: event.target.value
        });
    };
    const handlePhoneChange = (event)=>{
        if (hasError) setDataError(undefined);
        editPhone(event.target.value);
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            accounts.length > 1 && /*#__PURE__*/ (0, $4m918.jsx)((0, $38fDu.SourceAccountSelection), {
                sourceAccount: sourceAccount,
                onOpenSourceAccountSelection: onOpenSourceAccountSelection,
                editingSourceAndDestination: editingSourceAndDestination,
                formatMessage: formatMessage
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                size: "normal",
                margin: "normal",
                label: "amountSelection.simpleTransferNameLabel"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                value: recipientName,
                onChange: handleNameChange,
                placeholder: formatMessage("amountSelection.simpleTransferNamePlaceholder")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                size: "normal",
                margin: "normal",
                label: "amountSelection.simpleTransferPhoneLabel"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($d5aefa754fbe1761$var$CountrySelectInput, {
                onChange: setCountryCode,
                innerId: "country-select-field",
                options: configuration.countries,
                itemRenderer: (code)=>countries[code].englishName,
                value: countryCode,
                prefixElement: selectedCountry && /*#__PURE__*/ (0, $4m918.jsx)($d5aefa754fbe1761$var$FlagIcon, {
                    src: (0, $etzj2.flagUrl)(countryCode),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($d5aefa754fbe1761$var$PhoneInput, {
                placeholder: formatMessage("amountSelection.simpleTransferPhonePlaceholder"),
                prefixElement: /*#__PURE__*/ (0, $4m918.jsxs)($d5aefa754fbe1761$var$PhoneCode, {
                    children: [
                        "+",
                        selectedCountry?.phoneCode
                    ]
                }),
                type: "tel",
                value: recipientPhone,
                onChange: handlePhoneChange,
                hasError: hasError,
                errorMessage: formatMessage("common.invalidPhoneNumber")
            })
        ]
    });
};
const $d5aefa754fbe1761$var$FlagIcon = (0, $jb8NR.default).img`
  width: 14px;
  height: 14px;
  border-radius: 7px;
`;
const $d5aefa754fbe1761$var$PhoneInput = (0, $jb8NR.default)((0, $dkEe7.PrefixedTextInput))`
  ${(0, $dkEe7.PrefixContainer)} {
    width: 80px;
  }
`;
const $d5aefa754fbe1761$var$PhoneCode = (0, $jb8NR.default).span`
  font-size: 0.875rem;
`;
const $d5aefa754fbe1761$var$inputStyle = (0, $jb8NR.css)`
  width: 100%;
  margin-bottom: 25px;
`;
const $d5aefa754fbe1761$var$CountrySelectInput = (0, $jb8NR.default)((0, $cUa6O.PrefixedSelectInput))`
  ${$d5aefa754fbe1761$var$inputStyle};
`;

});
parcelRegister("38fDu", function(module, exports) {

$parcel$export(module.exports, "SourceAccountSelection", function () { return $9722a9729c29f6ed$export$d047c89362167a8d; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $lT9Op = parcelRequire("lT9Op");

var $22v9q = parcelRequire("22v9q");

var $k5s21 = parcelRequire("k5s21");

var $51d3M = parcelRequire("51d3M");
const $9722a9729c29f6ed$export$d047c89362167a8d = ({ sourceAccount: sourceAccount, onOpenSourceAccountSelection: onOpenSourceAccountSelection, editingSourceAndDestination: editingSourceAndDestination, formatMessage: formatMessage })=>/*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                size: "normal",
                margin: "normal",
                label: "amountSelection.since",
                required: true
            }),
            sourceAccount ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lT9Op.AccountButton), {
                account: sourceAccount,
                onClick: ()=>{
                    onOpenSourceAccountSelection?.();
                }
            }) : /*#__PURE__*/ (0, $4m918.jsxs)($9722a9729c29f6ed$var$SourceAndDestinationButton, {
                type: "button",
                $active: editingSourceAndDestination === (0, $lT9Op.SourceAndDestinationEnum).Source,
                onClick: ()=>{
                    onOpenSourceAccountSelection?.();
                },
                children: [
                    formatMessage("amountSelection.choose_source_account"),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $51d3M.ChevronIcon), {
                        width: 18,
                        height: 18,
                        style: {}
                    })
                ]
            })
        ]
    });
const $9722a9729c29f6ed$var$SourceAndDestinationButton = (0, $jb8NR.default)("button")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  appearance: none;
  border: none;
  height: 48px;
  box-shadow: none;
  background-color: white;
  text-align: left;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;
  ${(0, $22v9q.theme).bodyBlackRegular};
  ${(props)=>props.$active && (0, $jb8NR.css)`
      color: ${(0, $22v9q.theme).mainColor()};
      svg {
        fill: ${(0, $22v9q.theme).mainColor()};
      }
    `}
  ${(props)=>props.disabled && (0, $jb8NR.css)`
      opacity: 0.5;
      &:hover {
        cursor: not-allowed;
      }
    `}
`;

});


parcelRegister("5tx5U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5e9b829c4185ff$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bGuuW = parcelRequire("bGuuW");

var $ajNEj = parcelRequire("ajNEj");

var $k5s21 = parcelRequire("k5s21");

var $39jSd = parcelRequire("39jSd");

var $9mlIh = parcelRequire("9mlIh");
const $cf5e9b829c4185ff$var$RecurringTransferForm = (props)=>{
    const { value: value, onChange: onChange } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const handleChange = (val, key)=>{
        onChange({
            ...value,
            [key]: val
        });
    };
    const matchingFrequencyOption = (0, $6uYXW.useMemo)(()=>(0, $bGuuW.RECURRING_TRANSFER_FREQUENCY_OPTIONS).find((option)=>option.frequency.unit === value.frequency.unit && option.frequency.interval === value.frequency.interval) || null, [
        value.frequency.unit,
        value.frequency.interval
    ]);
    const minimumDates = (0, $6uYXW.useMemo)(()=>({
            firstExecutionDate: (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))().add(1, "day").format("YYYY-MM-DD"),
            endDate: (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(value.firstExecutionDate).add(1, "day").format("YYYY-MM-DD")
        }), [
        value.firstExecutionDate
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($cf5e9b829c4185ff$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $ajNEj.SwitchContainer), {
                value: value.enabled,
                labelPosition: "left",
                onSwitch: (checked)=>handleChange(checked, "enabled"),
                getSwitchLabel: ()=>formatMessage("recurringTransfer.switchLabel")
            }),
            value.enabled && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        label: "recurringTransfer.firstExecutionDateLabel",
                        size: "normal",
                        margin: "dense",
                        required: true,
                        htmlFor: "firstExecutionDate"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        id: "firstExecutionDate",
                        value: value.firstExecutionDate,
                        type: "date",
                        required: true,
                        min: minimumDates.firstExecutionDate,
                        onChange: (date)=>handleChange(date.target.value, "firstExecutionDate")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        label: "recurringTransfer.frequencyLabel",
                        size: "normal",
                        margin: "dense",
                        required: true,
                        htmlFor: "frequency"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                        innerId: "frequency",
                        value: matchingFrequencyOption,
                        options: (0, $bGuuW.RECURRING_TRANSFER_FREQUENCY_OPTIONS),
                        itemRenderer: (option)=>formatMessage(option.label),
                        required: true,
                        style: {
                            width: "100%"
                        },
                        onChange: (option)=>handleChange(option.frequency, "frequency")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        label: "recurringTransfer.endDateLabel",
                        size: "normal",
                        margin: "dense",
                        htmlFor: "endDate"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        id: "endDate",
                        value: value.endDate,
                        type: "date",
                        min: minimumDates.endDate,
                        onChange: (date)=>handleChange(date.target.value, "endDate")
                    })
                ]
            })
        ]
    });
};
var $cf5e9b829c4185ff$export$2e2bcd8739ae039 = $cf5e9b829c4185ff$var$RecurringTransferForm;
const $cf5e9b829c4185ff$var$Container = (0, $jb8NR.default).div`
  margin-top: 10px;
  padding: 10px 0;
`;

});

parcelRegister("l1Fzw", function(module, exports) {

$parcel$export(module.exports, "TransferModeSelection", function () { return $1e5870ba1d12207b$export$4c1db49c67ce1e14; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $fQIdb = parcelRequire("fQIdb");

var $3Ersk = parcelRequire("3Ersk");

var $22v9q = parcelRequire("22v9q");

var $jODj2 = parcelRequire("jODj2");
const $1e5870ba1d12207b$export$4c1db49c67ce1e14 = (props)=>{
    const { recipient: recipient, transferTypeSelected: transferTypeSelected } = props;
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const availableTypes = (0, $fQIdb.useAvailableTransferMode)({
        features: features,
        recipient: recipient
    });
    const [selectType, setSelectedType] = (0, $6uYXW.useState)((0, $fQIdb.TransferMode).AccountTransfer);
    (0, $6uYXW.useEffect)(()=>{
        if (availableTypes) setSelectedType(availableTypes[0]);
    }, [
        availableTypes
    ]);
    (0, $6uYXW.useEffect)(()=>{
        transferTypeSelected(selectType);
    }, [
        transferTypeSelected,
        selectType
    ]);
    if (!availableTypes || availableTypes.length < 2) return null;
    return /*#__PURE__*/ (0, $4m918.jsx)($1e5870ba1d12207b$var$TransferModeSelectionContent, {
        children: availableTypes.map((type, index)=>/*#__PURE__*/ (0, $4m918.jsx)($1e5870ba1d12207b$export$378f1142c6b6f13, {
                type: type,
                selected: selectType === type,
                onClick: ()=>setSelectedType(type)
            }, index))
    });
};
const $1e5870ba1d12207b$export$80d9738ef7f60085 = {
    [(0, $fQIdb.TransferMode).AccountTransfer]: "transferSummary.accountTransferMode",
    [(0, $fQIdb.TransferMode).CashTransfer]: "transferSummary.cashTransferMode"
};
const $1e5870ba1d12207b$export$491ab67af8bf8062 = {
    [(0, $fQIdb.TransferMode).AccountTransfer]: (selected)=>/*#__PURE__*/ (0, $4m918.jsx)($1e5870ba1d12207b$var$AccountIcon, {
            $selected: selected
        }),
    [(0, $fQIdb.TransferMode).CashTransfer]: (selected)=>/*#__PURE__*/ (0, $4m918.jsx)($1e5870ba1d12207b$var$CashIcon, {
            $selected: selected
        })
};
const $1e5870ba1d12207b$export$378f1142c6b6f13 = (props)=>{
    const { type: type, selected: selected, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($1e5870ba1d12207b$var$TransferModeContent, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($1e5870ba1d12207b$var$ToggleButton, {
                onClick: onClick,
                selected: selected,
                children: $1e5870ba1d12207b$export$491ab67af8bf8062[type](selected)
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1e5870ba1d12207b$var$TransferModeTitle, {
                children: formatMessage($1e5870ba1d12207b$export$80d9738ef7f60085[type])
            })
        ]
    });
};
const $1e5870ba1d12207b$var$TransferModeSelectionContent = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  margin-bottom: 40px;
`;
const $1e5870ba1d12207b$var$TransferModeContent = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $1e5870ba1d12207b$var$TransferModeTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  padding-top: 15px;
`;
const $1e5870ba1d12207b$var$ToggleButton = (0, $jb8NR.default).div`
  display: flex;
  width: 85px;
  height: 85px;
  cursor: pointer;
  border-radius: 11px;
  background-color: #ffffff;
  border: ${({ selected: selected })=>selected ? `1px solid ${(0, $22v9q.theme).mainColor}` : "1px solid #fff"};
  justify-content: center;
  align-items: center;
  ${(0, $22v9q.shadows).medium};
`;
const $1e5870ba1d12207b$var$CashIcon = (0, $jb8NR.default)((0, $jODj2.TransfertToCashIcon))`
  path {
    fill: ${({ $selected: $selected })=>$selected ? (0, $22v9q.theme).mainColor : "#808080"};
  }
`;
const $1e5870ba1d12207b$var$AccountIcon = (0, $jb8NR.default)((0, $jODj2.TransfertToAccountIcon))`
  path {
    fill: ${({ $selected: $selected })=>$selected ? (0, $22v9q.theme).mainColor : "#808080"};
  }
`;

});
parcelRegister("jODj2", function(module, exports) {

$parcel$export(module.exports, "TransfertToCashIcon", function () { return $a6da67459599ff40$export$35dc7045ff694ccb; });
$parcel$export(module.exports, "TransfertToAccountIcon", function () { return $a6da67459599ff40$export$ebe50f7cc33fc7bb; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $a6da67459599ff40$export$35dc7045ff694ccb(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "16",
        height: "26",
        viewBox: "0 0 16 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fill: "#000",
            fillRule: "nonzero",
            d: "M9.702 0c.867 0 1.574.701 1.574 1.574v8.587c.805.468 3.787 3.777 4.072 4 .702.55.67 1.486.582 1.995-.02.156-.072.301-.135.447-.39.903-1.054 6.852-1.226 8.452a.444.444 0 0 1-.441.394H9.322a.447.447 0 0 1-.446-.446v-.458c-1.476-1.542-2.01-3.771-2.01-3.771l-.479-4.11c-1.07-3.698.224-3.807.224-3.807.047-.005.088-.005.135-.005 1.709 0 2.01 3.371 2.01 3.371s.613 1.268 1.164 1.673V3.19a1.592 1.592 0 0 1-1.86-1.85H3.22a1.595 1.595 0 0 1-1.86 1.85v11.704a1.595 1.595 0 0 1 1.938 1.942h1.558l.125.11.145 1.236H1.593a1.573 1.573 0 0 1-1.574-1.574V1.574C.019.706.719 0 1.593 0zM5.645 5.745a3.456 3.456 0 0 1 2.363 5.974 2.658 2.658 0 0 0-1.532-.296c-.234.021-.925.156-1.434.9a2.445 2.445 0 0 0-.15.248A3.459 3.459 0 0 1 2.194 9.2a3.452 3.452 0 0 1 3.45-3.455z"
        })
    });
}
function $a6da67459599ff40$export$ebe50f7cc33fc7bb(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fill: "#81C241",
            d: "M16 1H8C6.343 1 5 2.343 5 4v16c0 1.657 1.343 3 3 3h8c1.657 0 3-1.343 3-3V4c0-1.657-1.343-3-3-3zm0 20H8c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1s1 .448 1 1 .448 1 1 1h4c.552 0 1-.448 1-1s.448-1 1-1 1 .448 1 1v16c0 .552-.448 1-1 1z",
            transform: "translate(-114 -589) translate(83 558) translate(31 31)"
        })
    });
}

});




parcelRegister("eVUP7", function(module, exports) {

$parcel$export(module.exports, "AddBeneficiaryDetail", function () { return $c443b100ab9f0ea3$export$b3c20daa0c5266d5; });

var $4m918 = parcelRequire("4m918");

var $a1iRj = parcelRequire("a1iRj");

var $glqzU = parcelRequire("glqzU");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $a5OyK = parcelRequire("a5OyK");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $e4wja = parcelRequire("e4wja");

var $etzj2 = parcelRequire("etzj2");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $cUa6O = parcelRequire("cUa6O");

var $dkEe7 = parcelRequire("dkEe7");

var $9mlIh = parcelRequire("9mlIh");

var $3yllK = parcelRequire("3yllK");

var $7hUVD = parcelRequire("7hUVD");

var $22v9q = parcelRequire("22v9q");
var $c443b100ab9f0ea3$var$RecipientType = /*#__PURE__*/ function(RecipientType) {
    RecipientType["IBAN"] = "IBAN";
    RecipientType["PHONE"] = "PHONE";
    RecipientType["ACCOUNT"] = "ACCOUNT";
    return RecipientType;
}($c443b100ab9f0ea3$var$RecipientType || {});
const $c443b100ab9f0ea3$export$b3c20daa0c5266d5 = (props)=>{
    const { createPhoneRecipient: createPhoneRecipient, createIbanRecipient: createIbanRecipient, createAccountRecipient: createAccountRecipient, searchBank: searchBank, loading: loading, errorMessage: errorMessage, initialName: initialName, forExternalAccount: forExternalAccount = false, bankName: bankName, bicCode: bicCode, formState: formState, setFormState: setFormState } = props;
    const intl = (0, $5hpYi.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const ibanOption = {
        value: "IBAN",
        key: "IBAN".toString(),
        text: formatMessage("addRecipient.selector.iban")
    };
    const phoneOption = {
        value: "PHONE",
        key: "PHONE".toString(),
        text: formatMessage("addRecipient.selector.phone")
    };
    const accountOption = {
        value: "ACCOUNT",
        key: "ACCOUNT".toString(),
        text: formatMessage("addRecipient.selector.account")
    };
    const recipientTypeOption = forExternalAccount ? [
        ibanOption
    ] : [
        ibanOption,
        phoneOption,
        accountOption
    ];
    const showRecipientsSelector = !forExternalAccount;
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    const defaultCountry = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).defaultCountry);
    const [recipientType, setRecipientType] = (0, $6uYXW.useState)(bankName ? "ACCOUNT" : "IBAN");
    const [countryCode, setCountryCode] = (0, $6uYXW.useState)(defaultCountry);
    const [phone, setPhone] = (0, $6uYXW.useState)("");
    const [iban, setIban] = (0, $6uYXW.useState)("");
    const [bic, setBic] = (0, $6uYXW.useState)(bicCode ?? "");
    const [dataError, setDataError] = (0, $6uYXW.useState)(undefined);
    const [isValid, setIsValid] = (0, $6uYXW.useState)(false);
    const hasError = (0, $gDlNU.isDefined)(dataError);
    const editPhone = (phoneNumber)=>{
        const nationalNumber = "+" + (0, $a5OyK.countries)[countryCode].phoneCode;
        const internationalPhoneNumber = phoneNumber.startsWith(nationalNumber) ? phoneNumber : nationalNumber + phoneNumber;
        const formatted = new (0, $glqzU.AsYouType)().input(internationalPhoneNumber).substr(nationalNumber.length);
        setPhone(formatted);
    };
    (0, $6uYXW.useEffect)(()=>{
        setDataError(undefined);
    }, [
        recipientType
    ]);
    (0, $6uYXW.useEffect)(()=>{
        let canValidate = false;
        if (formState.name) {
            if (recipientType === "PHONE") canValidate = !!phone;
            else if (recipientType === "IBAN") canValidate = !!iban;
            else canValidate = !!bic && !!formState.account;
        }
        setIsValid(canValidate);
    }, [
        recipientType,
        phone,
        iban,
        formState.account,
        formState.name,
        bic
    ]);
    const bicInput = (0, $6uYXW.useMemo)(()=>bankName ? `${bankName} (${bic})` : bic, [
        bankName,
        bic
    ]);
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($c443b100ab9f0ea3$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$Title, {
                children: formatMessage("addRecipient.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$Subtitle, {
                children: formatMessage(forExternalAccount ? "addRecipient.externalAccountSubtitle" : "addRecipient.subtitle")
            }),
            errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$StyledErrorMessage, {
                children: errorMessage
            }),
            showRecipientsSelector ? /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$RecipientTypeSelector, {
                options: recipientTypeOption,
                value: recipientType,
                onChange: (type)=>setRecipientType(type),
                size: "M"
            }) : null,
            /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$NameInput, {
                prefixElement: /*#__PURE__*/ (0, $4m918.jsx)((0, $7hUVD.UserIcon), {
                    height: 20,
                    width: 20,
                    color: "#000000"
                }),
                value: formState.name,
                name: "name",
                onChange: handleInputChange,
                placeholder: formatMessage("addRecipient.nameFieldPlaceholder")
            }),
            recipientType === "IBAN" ? /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$IbanInput, {
                placeholder: formatMessage("addRecipient.ibanFieldPlaceholder"),
                onChange: (event)=>{
                    if (hasError) setDataError(undefined);
                    setIban((0, (/*@__PURE__*/$parcel$interopDefault($a1iRj))).printFormat(event.target.value));
                },
                value: iban,
                hasError: hasError,
                errorMessage: formatMessage("formError.invalidIBAN"),
                dir: "ltr",
                bottomOffset: 16
            }) : recipientType === "ACCOUNT" ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$AccountInput, {
                        placeholder: formatMessage("addRecipient.accountFieldPlaceholder"),
                        onChange: handleInputChange,
                        value: formState.account,
                        name: "account",
                        dir: "ltr"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$BicInput, {
                        placeholder: formatMessage(features.bicReferential ? "addRecipient.bankFieldPlaceholder" : "addRecipient.bicFieldPlaceholder"),
                        value: bicInput,
                        onClick: features.bicReferential ? ()=>searchBank() : undefined,
                        onChange: (event)=>{
                            if (hasError) setDataError(undefined);
                            setBic(event.target.value);
                        },
                        dir: "ltr"
                    })
                ]
            }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$CountrySelectInput, {
                        onChange: (selectedCountryCode)=>setCountryCode(selectedCountryCode),
                        innerId: "country-select-field",
                        options: configuration.countries,
                        itemRenderer: (code)=>(0, $a5OyK.countries)[code].englishName,
                        value: countryCode,
                        prefixElement: (0, $a5OyK.countries)[countryCode] && /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$FlagIcon, {
                            src: (0, $etzj2.flagUrl)(countryCode),
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$PhoneInput, {
                        placeholder: formatMessage("addRecipient.phoneFieldPlaceholder"),
                        prefixElement: /*#__PURE__*/ (0, $4m918.jsxs)($c443b100ab9f0ea3$var$PhoneCode, {
                            children: [
                                "+",
                                (0, $a5OyK.countries)[countryCode].phoneCode
                            ]
                        }),
                        type: "tel",
                        value: phone,
                        onChange: (event)=>{
                            if (hasError) setDataError(undefined);
                            editPhone(event.target.value);
                        },
                        hasError: hasError,
                        errorMessage: formatMessage("common.invalidPhoneNumber"),
                        bottomOffset: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($c443b100ab9f0ea3$var$ConfirmButton, {
                size: "M",
                onClick: ()=>{
                    try {
                        if (recipientType === "PHONE") {
                            const phoneNumber = (0, $e4wja.validatePhoneNumber)(intl, phone, countryCode).substring(1);
                            createPhoneRecipient(formState.name, phoneNumber);
                        } else if (recipientType === "IBAN") createIbanRecipient(formState.name, iban, forExternalAccount);
                        else if (recipientType === "ACCOUNT") createAccountRecipient(formState.name, formState.account, bic);
                    } catch (e) {
                        (0, $6JVVB.logger).debug("AddBeneficiaryDetail: Confirm error", e);
                    }
                },
                disabled: !isValid,
                showSpinner: loading,
                children: formatMessage("addRecipient.createButton")
            })
        ]
    });
};
const $c443b100ab9f0ea3$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 56px;
`;
const $c443b100ab9f0ea3$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.fonts).bold}
  font-size: 1.5rem;
  color: ${(0, $22v9q.theme).mainColor};
`;
const $c443b100ab9f0ea3$var$Subtitle = (0, $jb8NR.default)($c443b100ab9f0ea3$var$Title)`
  color: black;
`;
const $c443b100ab9f0ea3$var$RecipientTypeSelector = (0, $jb8NR.default)((0, $3yllK.Selector))`
  margin-top: 40px;
`;
const $c443b100ab9f0ea3$var$inputStyle = (0, $jb8NR.css)`
  width: 100%;
  max-width: 360px;
  margin-bottom: 25px;
`;
const $c443b100ab9f0ea3$var$NameInput = (0, $jb8NR.default)((0, $dkEe7.PrefixedTextInput))`
  margin-top: 48px;
  ${$c443b100ab9f0ea3$var$inputStyle};
`;
const $c443b100ab9f0ea3$var$CountrySelectInput = (0, $jb8NR.default)((0, $cUa6O.PrefixedSelectInput))`
  ${$c443b100ab9f0ea3$var$inputStyle};
`;
const $c443b100ab9f0ea3$var$FlagIcon = (0, $jb8NR.default).img`
  width: 14px;
  height: 14px;
  border-radius: 7px;
`;
const $c443b100ab9f0ea3$var$PhoneInput = (0, $jb8NR.default)((0, $dkEe7.PrefixedTextInput))`
  ${$c443b100ab9f0ea3$var$inputStyle};

  ${(0, $dkEe7.PrefixContainer)} {
    width: 80px;
  }
`;
const $c443b100ab9f0ea3$var$IbanInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  ${$c443b100ab9f0ea3$var$inputStyle};
`;
const $c443b100ab9f0ea3$var$AccountInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  ${$c443b100ab9f0ea3$var$inputStyle};
`;
const $c443b100ab9f0ea3$var$BicInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  ${$c443b100ab9f0ea3$var$inputStyle};
`;
const $c443b100ab9f0ea3$var$PhoneCode = (0, $jb8NR.default).span`
  font-size: 0.875rem;
`;
const $c443b100ab9f0ea3$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 30px;
  margin-bottom: 30px;
`;
const $c443b100ab9f0ea3$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0 0 0;
  text-align: center;
`;

});
parcelRegister("7hUVD", function(module, exports) {

$parcel$export(module.exports, "UserIcon", function () { return $7bbc19626c2dd8db$export$4202723ba73439f5; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $7bbc19626c2dd8db$export$4202723ba73439f5 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M9 8.25a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM2.25 15.15c.291-3.58 3.196-5.4 6.738-5.4 3.59 0 6.54 1.72 6.76 5.4.01.147 0 .6-.563.6H2.795c-.187 0-.56-.406-.545-.6z",
            fill: props.color ?? "#8F8F94"
        })
    });

});


parcelRegister("9n8k8", function(module, exports) {

$parcel$export(module.exports, "SearchBank", function () { return $65f3f2490930826a$export$53ede1519849364a; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $agKwC = parcelRequire("agKwC");

var $a5VxL = parcelRequire("a5VxL");

var $Y6t65 = parcelRequire("Y6t65");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $finOR = parcelRequire("finOR");

var $knJqj = parcelRequire("knJqj");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");
const $65f3f2490930826a$var$PADDING = 10;
const $65f3f2490930826a$export$53ede1519849364a = (props)=>{
    const { className: className, title: title, onSelect: onSelect } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [bankSearch, setBankSearch] = (0, $6uYXW.useState)("");
    const bicReferential = (0, $a5VxL.useBicReferential)();
    const loadMoreDebounce = (0, $Y6t65.useLoadMoreDebounce)();
    const loadMore = (0, $6uYXW.useCallback)(()=>loadMoreDebounce(bicReferential.loadMore, bicReferential.loadingMore, bicReferential.canLoadMore), [
        bicReferential.canLoadMore,
        bicReferential.loadMore,
        bicReferential.loadingMore,
        loadMoreDebounce
    ]);
    const [error, setError] = (0, $6uYXW.useState)(null);
    const updateBankSearch = (0, $6uYXW.useCallback)((text)=>{
        setError(null);
        setBankSearch(text);
        if (bankSearch.length != text.length) bicReferential.reset(text.length < (0, $agKwC.MIN_SEARCH_CHARACTERS));
        if (text.length >= (0, $agKwC.MIN_SEARCH_CHARACTERS)) bicReferential.scheduleLoad(text);
    }, [
        bankSearch.length,
        bicReferential
    ]);
    (0, $6uYXW.useEffect)(()=>{
        setError(bicReferential.error);
    }, [
        bicReferential.error
    ]);
    const retry = (0, $6uYXW.useCallback)(()=>{
        setError(null);
        bicReferential.scheduleLoad(bankSearch);
    }, [
        bankSearch,
        bicReferential
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($65f3f2490930826a$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$Header, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$Title, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$SearchBarContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $finOR.SearchBar), {
                    placeholder: formatMessage("addRecipient.searchBank.bankPlaceholder", {
                        num: (0, $agKwC.MIN_SEARCH_CHARACTERS)
                    }),
                    initialValue: bankSearch,
                    onChange: (text)=>updateBankSearch(text),
                    withIcon: false,
                    widthSize: 350
                })
            }),
            bankSearch.length < (0, $agKwC.MIN_SEARCH_CHARACTERS) ? /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$EmptyContent, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$Message, {
                    children: formatMessage("addRecipient.searchBank.firstSearchMessage")
                })
            }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    bicReferential.loading ? /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$SpinnerContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                            size: "30px"
                        })
                    }) : null,
                    error ? /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
                        children: /*#__PURE__*/ (0, $4m918.jsxs)($65f3f2490930826a$var$ErrorContainer, {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)((0, $jn1mK.ErrorMessage), {
                                    style: {
                                        textAlign: "center",
                                        paddingTop: 30
                                    },
                                    children: formatMessage("addRecipient.searchBank.errorMessage")
                                }),
                                /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$ErrorButton, {
                                    size: "M",
                                    onClick: retry,
                                    children: formatMessage("addRecipient.searchBank.retryButton")
                                })
                            ]
                        })
                    }) : !bicReferential.loading && bicReferential.count == 0 ? /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$EmptyContent, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$Message, {
                            children: formatMessage("addRecipient.searchBank.noBankMessage")
                        })
                    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $knJqj.InfiniteScroll), {
                        fetchMore: loadMore,
                        hasMore: bicReferential.canLoadMore,
                        loading: bicReferential.loadingMore,
                        children: /*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$StyledInsideInfiniteScroll, {
                            children: bicReferential.data.map((bank, index)=>/*#__PURE__*/ (0, $4m918.jsx)($65f3f2490930826a$var$Bank, {
                                    onClick: ()=>onSelect(bank.institutionName, bank.ibanBic),
                                    children: `${bank.institutionName} (${bank.ibanBic})`
                                }, index))
                        })
                    })
                ]
            })
        ]
    });
};
const $65f3f2490930826a$var$SpinnerContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;
const $65f3f2490930826a$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 30px;
  width: 300px;
  text-align: center;
  position: relative;
`;
const $65f3f2490930826a$var$Title = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
`;
const $65f3f2490930826a$var$Container = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-left: ${$65f3f2490930826a$var$PADDING}px;
  padding-right: ${$65f3f2490930826a$var$PADDING}px;
  padding-bottom: ${$65f3f2490930826a$var$PADDING}px;
`;
const $65f3f2490930826a$var$SearchBarContainer = (0, $jb8NR.default).div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-right: 20px;
`;
const $65f3f2490930826a$var$StyledInsideInfiniteScroll = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  max-height: 400px;
  overflow-y: scroll;
`;
const $65f3f2490930826a$var$Bank = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.938rem;
  text-align: left;
  margin: 10px 0;
`;
const $65f3f2490930826a$var$EmptyContent = (0, $jb8NR.default).div`
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 120px 0;
  min-height: 300px;
`;
const $65f3f2490930826a$var$Message = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 0.85rem;
  color: #b1b1b1;
  text-align: center;
`;
const $65f3f2490930826a$var$ErrorContainer = (0, $jb8NR.default).div`
  flex-direction: column;
  display: flex;
  flex: 1;
  min-height: 300px;
  justify-content: center;
  padding: 30px;
`;
const $65f3f2490930826a$var$ErrorButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin: 40px;
`;

});
parcelRegister("a5VxL", function(module, exports) {

$parcel$export(module.exports, "useBicReferential", function () { return $c5aaaa5baee8be5a$export$e9daefc2493cc28f; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");
function $c5aaaa5baee8be5a$export$e9daefc2493cc28f() {
    const data = (0, $3Ersk.useObservable)((0, $kqXxS.bicReferentialManager).bics);
    const loading = (0, $3Ersk.useObservable)((0, $kqXxS.bicReferentialManager).loading);
    const error = (0, $3Ersk.useObservable)((0, $kqXxS.bicReferentialManager).error);
    const loadingMore = (0, $3Ersk.useObservable)((0, $kqXxS.bicReferentialManager).loadingMore);
    const loadingMoreError = (0, $3Ersk.useObservable)((0, $kqXxS.bicReferentialManager).loadingMoreError);
    const canLoadMore = (0, $3Ersk.useObservable)((0, $kqXxS.bicReferentialManager).canLoadMore);
    const scheduleLoad = (0, $6uYXW.useCallback)(async (search)=>{
        await (0, $kqXxS.bicReferentialManager).scheduleLoad(search);
    }, []);
    const loadMore = (0, $6uYXW.useCallback)(async ()=>{
        await (0, $kqXxS.bicReferentialManager).loadMore();
    }, []);
    const reset = (emptySet)=>(0, $kqXxS.bicReferentialManager).reset(emptySet);
    return {
        data: data.items,
        count: data.count,
        scheduleLoad: scheduleLoad,
        loading: loading,
        error: error,
        canLoadMore: canLoadMore,
        loadMore: loadMore,
        loadingMore: loadingMore,
        loadingMoreError: loadingMoreError,
        reset: reset
    };
}

});

parcelRegister("knJqj", function(module, exports) {

$parcel$export(module.exports, "InfiniteScroll", function () { return $47d18c1d6aa1703a$export$c5295390d6167a3e; });

var $4m918 = parcelRequire("4m918");

var $gALIi = parcelRequire("gALIi");

var $6uYXW = parcelRequire("6uYXW");
function $47d18c1d6aa1703a$export$c5295390d6167a3e({ fetchMore: fetchMore, loading: loading, hasMore: hasMore, scrollingElement: scrollingElement, children: children }) {
    const sentinelRef = (0, $6uYXW.useRef)(null);
    const checkScroll = (0, $6uYXW.useCallback)((loading, hasMore, fetchMore)=>{
        if (loading) return;
        const sentinel = sentinelRef.current;
        if (hasMore && sentinel && (sentinel.getBoundingClientRect().top <= window.innerHeight || sentinel.getBoundingClientRect().top - window.innerHeight < 1200)) fetchMore();
    }, []);
    const throttleCheckScroll = (0, $6uYXW.useMemo)(()=>(0, $gALIi.throttle)(checkScroll, 200, {
            leading: true,
            trailing: false
        }), [
        checkScroll
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (!loading && hasMore && sentinelRef.current && sentinelRef.current.getBoundingClientRect().top <= window.innerHeight) checkScroll(loading, hasMore, fetchMore);
    }, [
        checkScroll,
        fetchMore,
        hasMore,
        loading
    ]);
    (0, $6uYXW.useEffect)(()=>{
        const windowHandler = ()=>throttleCheckScroll(loading, hasMore, fetchMore);
        (scrollingElement ?? window).addEventListener("scroll", windowHandler, true);
        (scrollingElement ?? window).addEventListener("resize", windowHandler);
        return ()=>{
            (scrollingElement ?? window).removeEventListener("scroll", windowHandler, true);
            (scrollingElement ?? window).removeEventListener("resize", windowHandler);
        };
    }, [
        scrollingElement,
        checkScroll,
        fetchMore,
        loading,
        hasMore,
        throttleCheckScroll
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $6uYXW.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $4m918.jsx)("div", {
                id: "sentinel",
                ref: sentinelRef
            })
        ]
    });
}

});



parcelRegister("4ukWa", function(module, exports) {

$parcel$export(module.exports, "EditBeneficiaryModal", function () { return $af87cb2bb422b567$export$f5ebfb9e4ad45203; });

var $4m918 = parcelRequire("4m918");

var $a1iRj = parcelRequire("a1iRj");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $e4wja = parcelRequire("e4wja");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $dkEe7 = parcelRequire("dkEe7");

var $9mlIh = parcelRequire("9mlIh");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $7hUVD = parcelRequire("7hUVD");

var $22v9q = parcelRequire("22v9q");
const $af87cb2bb422b567$export$f5ebfb9e4ad45203 = (props)=>{
    const { recipient: recipient, forExternalAccount: forExternalAccount } = props;
    const intl = (0, $5hpYi.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $6uYXW.useState)(undefined);
    const [name, setName] = (0, $6uYXW.useState)(recipient?.name || "");
    const handleSave = async ()=>{
        setLoading(true);
        try {
            if (forExternalAccount) await (0, $kqXxS.externalAccountManager).updateRecipient(recipient.id, name);
            else await (0, $kqXxS.beneficiaryManager).updateRecipient(recipient.id, name);
        } catch (e) {
            (0, $6JVVB.logger).debug("AddBeneficiaryDetail: Confirm error", e);
            setErrorMessage(formatMessage("editRecipient.errorMessage"));
        } finally{
            (0, $5Wai4.Modal).dismiss((0, $bQhUC.EDIT_RECIPIENT_MODAL_ID));
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.EDIT_RECIPIENT_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)($af87cb2bb422b567$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$Title, {
                    children: formatMessage("editRecipient.title")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$Subtitle, {
                    children: formatMessage(forExternalAccount ? "editRecipient.externalAccountSubtitle" : "editRecipient.subtitle")
                }),
                errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$StyledErrorMessage, {
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$NameInput, {
                    prefixElement: /*#__PURE__*/ (0, $4m918.jsx)((0, $7hUVD.UserIcon), {
                        height: 20,
                        width: 20,
                        color: "#000000"
                    }),
                    value: name,
                    onChange: (event)=>setName(event.target.value),
                    placeholder: formatMessage("addRecipient.nameFieldPlaceholder")
                }),
                recipient?.iban && /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$IbanInput, {
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($a1iRj))).printFormat(recipient.iban),
                    dir: "ltr",
                    bottomOffset: 16,
                    onChange: ()=>null,
                    disabled: true
                }),
                recipient.accountReference && recipient.bic && /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$BicInput, {
                    value: recipient.bic,
                    dir: "ltr",
                    onChange: ()=>null,
                    bottomOffset: 16,
                    disabled: true
                }),
                recipient?.accountReference && /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$AccountReferenceInput, {
                    value: recipient.accountReference,
                    dir: "ltr",
                    onChange: ()=>null,
                    bottomOffset: 16,
                    disabled: true
                }),
                recipient?.phone && /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$PhoneInput, {
                    value: (0, $e4wja.formatPhoneNumber)(recipient.phone),
                    dir: "ltr",
                    onChange: ()=>null,
                    bottomOffset: 16,
                    disabled: true
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($af87cb2bb422b567$var$ConfirmButton, {
                    size: "M",
                    onClick: handleSave,
                    disabled: loading,
                    showSpinner: loading,
                    children: formatMessage("editRecipient.saveButton")
                })
            ]
        })
    });
};
const $af87cb2bb422b567$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 56px;
`;
const $af87cb2bb422b567$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.fonts).bold}
  font-size: 1.5rem;
  color: ${(0, $22v9q.theme).mainColor};
`;
const $af87cb2bb422b567$var$Subtitle = (0, $jb8NR.default)($af87cb2bb422b567$var$Title)`
  color: black;
`;
const $af87cb2bb422b567$var$inputStyle = (0, $jb8NR.css)`
  width: 100%;
  max-width: 360px;
  margin-bottom: 25px;
`;
const $af87cb2bb422b567$var$NameInput = (0, $jb8NR.default)((0, $dkEe7.PrefixedTextInput))`
  margin-top: 48px;
  ${$af87cb2bb422b567$var$inputStyle};
`;
const $af87cb2bb422b567$var$IbanInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  ${$af87cb2bb422b567$var$inputStyle};
`;
const $af87cb2bb422b567$var$BicInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  ${$af87cb2bb422b567$var$inputStyle};
`;
const $af87cb2bb422b567$var$AccountReferenceInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  ${$af87cb2bb422b567$var$inputStyle};
`;
const $af87cb2bb422b567$var$PhoneInput = (0, $jb8NR.default)((0, $9mlIh.TextInput))`
  ${$af87cb2bb422b567$var$inputStyle};
`;
const $af87cb2bb422b567$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 30px;
  margin-bottom: 30px;
`;
const $af87cb2bb422b567$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0 0;
  text-align: center;
`;

});

parcelRegister("lQ83Z", function(module, exports) {

$parcel$export(module.exports, "EmptyBlock", function () { return $4d06844f8a44c28b$export$1780f2a178bda818; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $7Zu6k = parcelRequire("7Zu6k");

var $aO0jN = parcelRequire("aO0jN");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $4d06844f8a44c28b$export$1780f2a178bda818 = (props)=>{
    const { illustration: illustration, title: title, message: message, button: button, onClick: onClick } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($4d06844f8a44c28b$var$GreyCard, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($4d06844f8a44c28b$var$IllustrationContainer, {
                children: illustration ?? /*#__PURE__*/ (0, $4m918.jsx)((0, $aO0jN.EmptyRowsPlaceholder), {})
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($4d06844f8a44c28b$var$ContentContainer, {
                $isRTL: isRTL,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($4d06844f8a44c28b$var$Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($4d06844f8a44c28b$var$Description, {
                        children: message
                    })
                ]
            }),
            onClick && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($4d06844f8a44c28b$var$Spacer, {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($4d06844f8a44c28b$var$AddBeneficiaryButton, {
                        size: "S",
                        onClick: onClick,
                        $isRTL: isRTL,
                        children: button
                    })
                ]
            })
        ]
    });
};
const $4d06844f8a44c28b$var$GreyCard = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  background-color: #f4f4f4;
  border-radius: 18px;
  padding: 40px;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    flex-direction: column;
  }
`;
const $4d06844f8a44c28b$var$ContentContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${(props)=>props.$isRTL ? 0 : 26}px;
  margin-right: ${(props)=>props.$isRTL ? 26 : 0}px;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    margin-right: 0px;
    margin-left: 0px;
    margin-top: 26px;
    margin-bottom: 26px;
  }
`;
const $4d06844f8a44c28b$var$IllustrationContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    align-items: center;
  }
`;
const $4d06844f8a44c28b$var$Title = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  margin-bottom: 8px;
  ${(0, $22v9q.theme).boldText};
  color: #000000;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    text-align: center;
  }
`;
const $4d06844f8a44c28b$var$Description = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
  color: #b1b1b1;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT}px) {
    text-align: center;
  }
`;
const $4d06844f8a44c28b$var$AddBeneficiaryButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-left: ${(props)=>props.$isRTL ? 0 : 20}px;
  margin-right: ${(props)=>props.$isRTL ? 20 : 0}px;
  flex-shrink: 0;
  height: 46px;
  align-self: center;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    margin-top: 20px;
    margin-left: 0px;
    margin-right: 0px;
  }
`;
const $4d06844f8a44c28b$var$Spacer = (0, $jb8NR.default).div`
  flex-grow: 1;
`;

});
parcelRegister("aO0jN", function(module, exports) {

$parcel$export(module.exports, "EmptyRowsPlaceholder", function () { return $d38aa6eb3689441d$export$6e98c2d88c07962; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $d38aa6eb3689441d$export$6e98c2d88c07962 = (props)=>/*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "176",
        height: "176",
        viewBox: "0 0 176 176",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                opacity: ".64",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.398 120.536a65.73 65.73 0 0 0 4.685 7.032c17.036 22.272 43.413 22.84 48.228 23.051 13.48.589 28.077-2.892 40.369-9.987l.009-.006c11.706-6.759 21.321-16.796 25.895-29.716 6.197-17.51.775-33.65-2.03-42-.773-2.298-2.81-7.999-6.707-14.753l-.033-.057c-5.691-9.846-15.327-21.912-30.726-28.92-2.213-1.006-5.013-2.28-8.736-3.185-13.305-3.234-30.243.232-45.125 8.808l-.114.066c-16.63 9.62-30.675 25.63-34.168 45.8-2.636 15.224 1.103 31.122 8.416 43.802l.037.065z",
                fill: "#EEE"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "40.435",
                y: "70.981",
                width: "123.189",
                height: "25.635",
                rx: "9.357",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "47.705",
                y: "78.3",
                width: "10.587",
                height: "10.678",
                rx: "4.392",
                fill: "#F4F4F4"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("ellipse", {
                cx: "52.999",
                cy: "83.638",
                rx: "1.906",
                ry: "1.922",
                fill: "#D5D5D5"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".637",
                x: "66.365",
                y: "77.715",
                width: "34.879",
                height: "4.439",
                rx: "2.219",
                fill: "#D5D5D5"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "66.365",
                y: "85.298",
                width: "20.245",
                height: "4.439",
                rx: "2.219",
                fill: "#F4F4F4"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "26.38",
                y: "40.385",
                width: "123.189",
                height: "25.635",
                rx: "9.357",
                fill: "#E8E8E8"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".174",
                x: "33.65",
                y: "47.703",
                width: "10.587",
                height: "10.678",
                rx: "4.392",
                fill: "#B1B1B1"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("ellipse", {
                cx: "38.944",
                cy: "53.042",
                rx: "1.906",
                ry: "1.922",
                fill: "#000",
                fillOpacity: ".077"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "52.309",
                y: "47.118",
                width: "34.879",
                height: "4.439",
                rx: "2.219",
                fill: "#000",
                fillOpacity: ".077"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".174",
                x: "52.309",
                y: "54.701",
                width: "20.245",
                height: "4.439",
                rx: "2.219",
                fill: "#B1B1B1"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "26.38",
                y: "101.578",
                width: "123.189",
                height: "25.635",
                rx: "9.357",
                fill: "#E8E8E8"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".174",
                x: "33.65",
                y: "108.896",
                width: "10.587",
                height: "10.678",
                rx: "4.392",
                fill: "#B1B1B1"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("ellipse", {
                cx: "38.944",
                cy: "114.235",
                rx: "1.906",
                ry: "1.922",
                fill: "#000",
                fillOpacity: ".077"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                x: "52.309",
                y: "108.311",
                width: "34.879",
                height: "4.439",
                rx: "2.219",
                fill: "#000",
                fillOpacity: ".077"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".174",
                x: "52.309",
                y: "115.894",
                width: "20.245",
                height: "4.439",
                rx: "2.219",
                fill: "#B1B1B1"
            })
        ]
    });

});


parcelRegister("jHUm0", function(module, exports) {

$parcel$export(module.exports, "ExternalAccountsView", function () { return $c29936a490f524ac$export$7e6523d0e8be2a79; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $2Rggt = parcelRequire("2Rggt");

var $kwKQQ = parcelRequire("kwKQQ");

var $cG3cd = parcelRequire("cG3cd");

var $3Ersk = parcelRequire("3Ersk");

var $gf0cb = parcelRequire("gf0cb");

var $bQhUC = parcelRequire("bQhUC");

var $7N0kU = parcelRequire("7N0kU");

var $yYT9n = parcelRequire("yYT9n");

var $5Wai4 = parcelRequire("5Wai4");

var $amCCH = parcelRequire("amCCH");

var $jEKif = parcelRequire("jEKif");

var $d1CTY = parcelRequire("d1CTY");

var $bfYs4 = parcelRequire("bfYs4");

var $22v9q = parcelRequire("22v9q");

var $flGUg = parcelRequire("flGUg");

var $4f5zl = parcelRequire("4f5zl");

var $4ukWa = parcelRequire("4ukWa");

var $lQ83Z = parcelRequire("lQ83Z");

var $4dYwb = parcelRequire("4dYwb");

var $kuv12 = parcelRequire("kuv12");
function $c29936a490f524ac$export$7e6523d0e8be2a79({ search: search }) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { client: client } = (0, $7N0kU.useClient)();
    const displayName = (0, $2Rggt.useClientDisplayName)(client, false);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const { data: externalAccounts, loading: loading } = (0, $cG3cd.useExternalAccounts)();
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const openAddExternalAccountModal = (name, forExternalAccount)=>(0, $5Wai4.Modal).present((0, $bQhUC.ADD_RECIPIENT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4f5zl.AddBeneficiaryModal), {
                initialName: name,
                forExternalAccount: forExternalAccount
            }), {
            canBeDismissed: false
        });
    const openRecipientDetailModal = (recipient)=>(0, $5Wai4.Modal).present((0, $bQhUC.TRANSFER_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $kuv12.RecipientDetailModal), {
                recipient: recipient
            }), {
            canBeDismissed: false
        });
    const filteredExternalAccounts = (0, $6uYXW.useMemo)(()=>search ? externalAccounts.filter((r)=>(0, $gf0cb.caseInsensitiveIncludes)(r.name, search) || (0, $gf0cb.caseInsensitiveIncludes)(r.phone, search)) : externalAccounts, [
        externalAccounts,
        search
    ]);
    const openEditBeneficiaryModal = (recipient, forExternalAccount)=>(0, $5Wai4.Modal).present((0, $bQhUC.EDIT_RECIPIENT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4ukWa.EditBeneficiaryModal), {
                recipient: recipient,
                forExternalAccount: forExternalAccount
            }), {
            canBeDismissed: false
        });
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            filteredExternalAccounts.length > 0 && features.externalAccountsManagement && /*#__PURE__*/ (0, $4m918.jsxs)($c29936a490f524ac$var$AddExternalAccountContainer, {
                onClick: (0, $flGUg.performTaskIfPossible)(()=>openAddExternalAccountModal(displayName, true)),
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($c29936a490f524ac$var$RoundContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bfYs4.PlusIcon), {
                            width: 18,
                            height: 18
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($c29936a490f524ac$var$AddExternalAccountLabel, {
                        children: formatMessage("recipient.externalAccounts.addButton")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($c29936a490f524ac$var$Header, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($c29936a490f524ac$var$Title, {
                    $isRTL: isRTL,
                    children: formatMessage("recipient.externalAccounts.title")
                })
            }),
            externalAccounts.length > 0 ? filteredExternalAccounts.map((externalAccount)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4dYwb.RecipientCard), {
                    externalAccount: externalAccount,
                    onEdit: (0, $flGUg.performTaskIfPossible)(()=>openEditBeneficiaryModal(externalAccount, true)),
                    onClick: (0, $flGUg.performTaskIfPossible)(()=>openRecipientDetailModal(externalAccount)),
                    isRTL: isRTL,
                    readonly: !features.externalAccountsManagement,
                    disabled: externalAccount.state === (0, $kwKQQ.RecipientStateEnum).PENDING
                }, externalAccount.id)) : !loading && /*#__PURE__*/ (0, $4m918.jsx)((0, $lQ83Z.EmptyBlock), {
                illustration: /*#__PURE__*/ (0, $4m918.jsx)((0, $d1CTY.ExternalAccountPlaceholder), {}),
                title: formatMessage("recipient.externalAccounts.noneAvailableTitle"),
                message: formatMessage("recipient.externalAccounts.noneAvailableMessage"),
                button: formatMessage("recipient.externalAccounts.addButton"),
                onClick: features.externalAccountsManagement ? (0, $flGUg.performTaskIfPossible)(()=>openAddExternalAccountModal(displayName, true)) : undefined
            })
        ]
    });
}
const $c29936a490f524ac$var$Title = (0, $jb8NR.default)((0, $jEKif.PageSectionTitle))`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).mediumText};
  margin-left: ${(props)=>props.$isRTL ? 10 : 0}px;
  margin-right: ${(props)=>props.$isRTL ? 0 : 10}px;
`;
const $c29936a490f524ac$var$Header = (0, $jb8NR.default)((0, $amCCH.PageHeader))`
  align-self: stretch;
`;
const $c29936a490f524ac$var$AddExternalAccountContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
  margin-top: 32px;
  margin-bottom: 32px;
  margin-left: 12px;
  margin-right: 12px;
  &:hover {
    cursor: pointer;
  }
`;
const $c29936a490f524ac$var$AddExternalAccountLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.9375rem;
  text-align: left;
  margin-right: 16px;
  margin-left: 16px;
`;
const $c29936a490f524ac$var$RoundContainer = (0, $jb8NR.default).div`
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background-color: #ececec;
  align-items: center;
  justify-content: center;
`;

});
parcelRegister("d1CTY", function(module, exports) {

$parcel$export(module.exports, "ExternalAccountPlaceholder", function () { return $7ee78f55b9c840e6$export$33db5ce465aeaecc; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $7ee78f55b9c840e6$export$33db5ce465aeaecc = (props)=>/*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "202",
        height: "126",
        viewBox: "0 0 202 126",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".34",
                x: "4",
                y: "38.609",
                width: "180",
                height: "88.941",
                rx: "6.882",
                transform: "rotate(-12.233 4 38.609)",
                fill: "#EAEAEA"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("mask", {
                id: "6bpfju3qua",
                maskUnits: "userSpaceOnUse",
                x: "11",
                y: "18",
                width: "181",
                height: "90",
                children: /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                    x: "11.379",
                    y: "18.529",
                    width: "180",
                    height: "88.941",
                    rx: "6.882",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                mask: "url(#6bpfju3qua)",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("g", {
                        filter: "url(#tqpf8ksidb)",
                        children: /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                            x: "11.379",
                            y: "18.529",
                            width: "180",
                            height: "88.941",
                            rx: "6.882",
                            fill: "#EDEDED"
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        cx: "43.144",
                        cy: "90.588",
                        r: "1.059",
                        fill: "#CCC"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        cx: "37.85",
                        cy: "90.588",
                        r: "1.059",
                        fill: "#CCC"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        cx: "32.556",
                        cy: "90.588",
                        r: "1.059",
                        fill: "#CCC"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        cx: "27.262",
                        cy: "90.588",
                        r: "1.059",
                        fill: "#CCC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                opacity: ".4",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                        x: "171.528",
                        y: "33.657",
                        width: "9.264",
                        height: "9.343",
                        rx: "3.843",
                        fill: "#C8C8C8"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("ellipse", {
                        cx: "176.159",
                        cy: "38.329",
                        rx: "1.667",
                        ry: "1.682",
                        fill: "#E8E8E8"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".3",
                x: "26.203",
                y: "47.235",
                width: "51.882",
                height: "4.235",
                rx: "2.118",
                fill: "#CCC"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("rect", {
                opacity: ".4",
                x: "26.203",
                y: "36",
                width: "84.177",
                height: "4.235",
                rx: "2.118",
                fill: "#C2C2C2"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("defs", {
                children: /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                    id: "tqpf8ksidb",
                    x: ".791",
                    y: "12.176",
                    width: "201.176",
                    height: "110.118",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                            dy: "4.235"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                            stdDeviation: "5.294"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.050672 0"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("feBlend", {
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_406_23864"
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_406_23864",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("4dYwb", function(module, exports) {

$parcel$export(module.exports, "RecipientCard", function () { return $0b23a68e402f337c$export$dee5ae0edd4318d7; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kwKQQ = parcelRequire("kwKQQ");

var $gbifg = parcelRequire("gbifg");

var $bQhUC = parcelRequire("bQhUC");

var $4nSeL = parcelRequire("4nSeL");

var $5Wai4 = parcelRequire("5Wai4");

var $gk2kn = parcelRequire("gk2kn");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $d9FEV = parcelRequire("d9FEV");

var $jM3f7 = parcelRequire("jM3f7");
const $0b23a68e402f337c$export$dee5ae0edd4318d7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { disabled: disabled, externalAccount: externalAccount, isRTL: isRTL, readonly: readonly, onClick: onClick, onEdit: onEdit } = props;
    const [openMenu, setOpenMenu] = (0, $6uYXW.useState)(false);
    const toggleMenu = ()=>setOpenMenu((bool)=>!bool);
    return /*#__PURE__*/ (0, $4m918.jsx)($0b23a68e402f337c$var$Card, {
        onClick: onClick,
        disabled: disabled,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($0b23a68e402f337c$var$CardContainer, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($0b23a68e402f337c$var$TopEndImage, {
                    $isRTL: isRTL,
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $gk2kn.BigBankToWalletIcon), {
                        fill: (0, $22v9q.theme).mainColor()
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($0b23a68e402f337c$var$NameAndBankContainer, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($0b23a68e402f337c$var$Name, {
                            $isRTL: isRTL,
                            children: externalAccount.name
                        }),
                        externalAccount.bankName && /*#__PURE__*/ (0, $4m918.jsx)($0b23a68e402f337c$var$Bank, {
                            $isRTL: isRTL,
                            children: externalAccount.bankName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($0b23a68e402f337c$var$BottomRow, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsxs)($0b23a68e402f337c$var$AccountNumber, {
                            children: [
                                externalAccount.accountReference ?? (0, $gbifg.anonimyzeIban)(externalAccount.iban ?? " "),
                                externalAccount.state === (0, $kwKQQ.RecipientStateEnum).PENDING && /*#__PURE__*/ (0, $4m918.jsx)($0b23a68e402f337c$var$StyledPendingColoredTagWrapper, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $d9FEV.PendingColoredTag), {
                                        label: formatMessage("recipient.externalAccounts.pendingExternalAccountMessage")
                                    })
                                })
                            ]
                        }),
                        !readonly && !disabled && /*#__PURE__*/ (0, $4m918.jsx)((0, $4nSeL.default), {
                            isRTL: isRTL,
                            isOpen: openMenu,
                            onToggle: toggleMenu,
                            onEdit: ()=>onEdit?.(),
                            onDelete: ()=>{
                                (0, $5Wai4.Modal).present((0, $bQhUC.REMOVE_RECIPIENT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $jM3f7.RemoveRecipientModal), {
                                        recipient: externalAccount,
                                        onConfirm: ()=>(0, $kqXxS.externalAccountManager).deleteRecipient(externalAccount.id)
                                    }), {
                                    canBeDismissed: false
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const $0b23a68e402f337c$var$Card = (0, $jb8NR.default).button`
  position: relative;
  height: 190px;
  width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_NOT_MOBILE}px;
  border-radius: 13px;
  border: none;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: white;
  overflow: hidden;
  transition: transform ease-out 0.2s;
  will-change: transform;
  @media (max-width: ${(0, $7XqbX.UIConstants).PHONE_BREAKPOINT}px) {
    width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_MOBILE}px;
  }
  margin-bottom: 10px;
  &:hover {
    cursor: pointer;
  }
`;
const $0b23a68e402f337c$var$NameAndBankContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 2px;
`;
const $0b23a68e402f337c$var$CardContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px;
  height: 100%;
  width: 100%;
  justify-content: space-between;
`;
const $0b23a68e402f337c$var$TopEndImage = (0, $jb8NR.default).div`
  position: absolute;
  top: 16px;
  right: ${(props)=>props.$isRTL ? "unset" : "24px"};
  left: ${(props)=>props.$isRTL ? "24px" : "unset"};
  width: 35px;
  height: 35px;
  background-color: ${(0, $22v9q.theme).mainColorLightBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
`;
const $0b23a68e402f337c$var$Name = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText}
  font-size: 1.125rem;
  text-align: ${(props)=>props.$isRTL ? "right" : "left"};
  white-space: nowrap;
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_NOT_MOBILE - 100}px;
  @media (max-width: ${(0, $7XqbX.UIConstants).PHONE_BREAKPOINT}px) {
    width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_MOBILE - 90}px;
  }
`;
const $0b23a68e402f337c$var$Bank = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: #b1b1b1;
  text-align: ${(props)=>props.$isRTL ? "right" : "left"};
  white-space: nowrap;
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_NOT_MOBILE - 60}px;
  @media (max-width: ${(0, $7XqbX.UIConstants).PHONE_BREAKPOINT}px) {
    width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_MOBILE - 60}px;
  }
`;
const $0b23a68e402f337c$var$BottomRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const $0b23a68e402f337c$var$AccountNumber = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.875rem;
  line-height: 1.5rem;
  text-align: left;
  color: #b1b1b1;
`;
const $0b23a68e402f337c$var$StyledPendingColoredTagWrapper = (0, $jb8NR.default).div`
  margin-top: 4px;
`;

});
parcelRegister("d9FEV", function(module, exports) {

$parcel$export(module.exports, "PendingColoredTag", function () { return $0b3e8052a37d667c$export$db9dc944373df8a6; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $gkCA4 = parcelRequire("gkCA4");

var $22v9q = parcelRequire("22v9q");
const $0b3e8052a37d667c$export$db9dc944373df8a6 = (props)=>{
    const { label: label } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($0b3e8052a37d667c$var$TagContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($0b3e8052a37d667c$var$StyledWaitingIcon, {
                color: (0, $22v9q.theme).mainColor()
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($0b3e8052a37d667c$var$TagText, {
                children: label
            })
        ]
    });
};
const $0b3e8052a37d667c$var$TagContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  height: 22px;
  border-radius: 13px;
  background-color: ${(0, $22v9q.theme).mainColorLightBackground};
  align-items: center;
  justify-content: center;
`;
const $0b3e8052a37d667c$var$TagText = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.625rem;
  color: ${(0, $22v9q.theme).mainColor};
  margin-left: 2px;
  margin-right: 10px;
`;
const $0b3e8052a37d667c$var$StyledWaitingIcon = (0, $jb8NR.default)((0, $gkCA4.WaitingIcon))`
  width: 14px;
  height: 14px;
  margin-left: 6px;
  margin-right: 2px;
`;

});
parcelRegister("gkCA4", function(module, exports) {

$parcel$export(module.exports, "WaitingIcon", function () { return $32a554126f40c4b6$export$a5b7e61a0348164a; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $32a554126f40c4b6$export$a5b7e61a0348164a = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "42",
        height: "42",
        viewBox: "0 0 42 42",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M36.75 21.752c-.043.089-.085.179-.13.266-.277.53-.781.754-1.198.71-.715-.077-1.02-.492-1.178-.97-.013-.038-.013-.081-.014-.122-.005-.391-.026-.784-.008-1.174a1.233 1.233 0 0 1 1.07-1.173 1.273 1.273 0 0 1 1.355.788c.033.084.069.167.103.25v1.425zM29.776 7.93c.297-.43.587-.854.881-1.276.07-.1.143-.203.23-.288.192-.183.406-.15.534.08.044.079.074.169.098.257.376 1.356.738 2.715 1.13 4.066.13.447-.114.967-.721 1.009-.622.043-1.242.117-1.864.171-.57.05-1.142.092-1.713.14-.091.007-.182.025-.274.032-.173.011-.348.032-.52.024-.3-.014-.424-.211-.31-.487.046-.113.12-.215.19-.317.286-.423.576-.845.877-1.283-.318-.196-.616-.395-.93-.567a13.017 13.017 0 0 0-3.842-1.407 13.22 13.22 0 0 0-2.008-.229c-.534-.02-1.066-.01-1.595.026-.6.041-1.195.142-1.785.272a13.05 13.05 0 0 0-4.64 2.022 13.177 13.177 0 0 0-3.14 3.066 13.118 13.118 0 0 0-2.556 7.994c.012.755.067 1.503.202 2.243.423 2.314 1.362 4.392 2.868 6.198a13.215 13.215 0 0 0 4.028 3.244c1.168.617 2.402 1.027 3.691 1.286.553.11.922.43 1.065.985.192.743-.389 1.515-1.132 1.555-.365.02-.71-.082-1.056-.16a15.265 15.265 0 0 1-5.435-2.415 15.935 15.935 0 0 1-3.531-3.373 15.704 15.704 0 0 1-2.64-5.26 17.29 17.29 0 0 1-.51-2.503 15.326 15.326 0 0 1-.106-2.561c.025-.699.104-1.394.223-2.086.151-.873.371-1.728.667-2.56.354-1 .81-1.954 1.35-2.87.6-1.017 1.326-1.93 2.126-2.791a15.306 15.306 0 0 1 3.721-2.91 15.376 15.376 0 0 1 3.277-1.364c.865-.253 1.745-.43 2.638-.54a14.582 14.582 0 0 1 2.823-.063c2.229.158 4.34.76 6.31 1.83.458.25.901.528 1.38.81z",
                    fill: props.color ?? "#81C241"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.247 16.243c0 1.456.004 2.911-.005 4.367 0 .192.058.288.227.376 1.72.887 3.435 1.784 5.152 2.678.917.478 1.834.957 2.752 1.433.314.163.546.39.635.75.13.523-.232 1.115-.758 1.232-.307.068-.583-.008-.853-.15-.807-.422-1.616-.842-2.424-1.263l-5.368-2.794c-.409-.213-.817-.428-1.228-.635-.124-.062-.202-.134-.178-.284.008-.05.002-.103.002-.154v-9.663c0-.103-.002-.207.004-.31.035-.582.493-1.033 1.03-1.015.575.019 1.01.472 1.011 1.066.003 1.455.001 2.91.001 4.366zM36.03 16.564a1.313 1.313 0 0 1-.852 1.185c-.581.213-1.142-.045-1.432-.416-.208-.266-.55-1.304-.568-1.644-.023-.437.347-1.04.895-1.198.608-.175 1.16.101 1.408.485.055.086.112.174.148.269.113.297.222.596.32.899.043.135.055.28.082.42zM34.537 27.581c-.897.014-1.466-.902-1.23-1.598.12-.35.226-.704.369-1.044.223-.53.725-.781 1.2-.747.655.046 1.016.434 1.169.935.072.237.064.49-.013.732-.094.293-.188.587-.296.875-.206.552-.722.874-1.199.847z",
                    fill: props.color ?? "#81C241"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("mask", {
                    id: "f1zog4fmla",
                    maskUnits: "userSpaceOnUse",
                    x: "22",
                    y: "34",
                    width: "4",
                    height: "3",
                    children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        d: "M22.35 34.013h3.415v2.737H22.35v-2.737z",
                        fill: "#fff"
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("g", {
                    mask: "url(#f1zog4fmla)",
                    children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M25.765 35.267c.001.522-.306 1.084-1.023 1.268-.287.073-.576.137-.866.192-.675.128-1.312-.294-1.488-.978-.162-.627.22-1.31.868-1.496.39-.111.793-.204 1.196-.236.581-.047 1.053.306 1.236.86.042.124.052.26.077.39z",
                        fill: props.color ?? "#81C241"
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30.753 30.597c0-.27.065-.518.224-.729.229-.303.462-.604.714-.887.363-.405.95-.452 1.387-.274.464.188.785.692.776 1.194a1.176 1.176 0 0 1-.222.694c-.221.296-.441.596-.695.863-.668.703-1.792.448-2.108-.47-.043-.125-.051-.26-.076-.391zM28.272 35.046c-.45.01-.98-.3-1.183-.772-.213-.49-.13-1.015.237-1.398.056-.06.114-.12.183-.164.302-.192.6-.392.913-.563.652-.355 1.473-.034 1.753.662.217.537.035 1.133-.347 1.427a8.028 8.028 0 0 1-1.01.64c-.163.09-.362.114-.546.168z",
                    fill: props.color ?? "#81C241"
                })
            ]
        })
    });

});


parcelRegister("jM3f7", function(module, exports) {

$parcel$export(module.exports, "RemoveRecipientModal", function () { return $2b5045d22a3ecdfc$export$2b4a7ed4db99dead; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $22v9q = parcelRequire("22v9q");
const $2b5045d22a3ecdfc$export$2b4a7ed4db99dead = (props)=>{
    const { recipient: recipient, onConfirm: onConfirm } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const closeModal = ()=>{
        (0, $5Wai4.Modal).dismiss((0, $bQhUC.REMOVE_RECIPIENT_MODAL_ID));
    };
    const handleConfirm = ()=>{
        onConfirm();
        closeModal();
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($2b5045d22a3ecdfc$var$ModalContainer, {
        closeButton: true,
        id: (0, $bQhUC.REMOVE_RECIPIENT_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)($2b5045d22a3ecdfc$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($2b5045d22a3ecdfc$var$Title, {
                    children: formatMessage("recipient.deletePrompt.title")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($2b5045d22a3ecdfc$var$Subtitle, {
                    children: recipient.counterparty ? formatMessage("recipient.deletePrompt.externalAccountTitle") : formatMessage("recipient.deletePrompt.recipient")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($2b5045d22a3ecdfc$var$Message, {
                    children: recipient.counterparty ? formatMessage("recipient.deletePrompt.externalAccountMessage") : formatMessage("recipient.deletePrompt.message", {
                        name: recipient.name
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($2b5045d22a3ecdfc$var$ConfirmButton, {
                    size: "M",
                    onClick: handleConfirm,
                    children: formatMessage("recipient.deletePrompt.confirmButton")
                })
            ]
        })
    });
};
const $2b5045d22a3ecdfc$var$ModalContainer = (0, $jb8NR.default)((0, $iy3Ex.RoundedModalContainer))``;
const $2b5045d22a3ecdfc$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 56px;
`;
const $2b5045d22a3ecdfc$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.fonts).bold}
  font-size: 1.5rem;
  color: ${(0, $22v9q.theme).mainColor};
`;
const $2b5045d22a3ecdfc$var$Subtitle = (0, $jb8NR.default)($2b5045d22a3ecdfc$var$Title)`
  color: black;
`;
const $2b5045d22a3ecdfc$var$Message = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  color: black;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  text-align: center;
  margin: 48px 10px 15px;
`;
const $2b5045d22a3ecdfc$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 30px;
  margin-bottom: 30px;
`;

});


parcelRegister("kuv12", function(module, exports) {

$parcel$export(module.exports, "RecipientDetailModal", function () { return $2fcd78b6532edcd2$export$89a834d0939db115; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $gDlNU = parcelRequire("gDlNU");

var $3Ersk = parcelRequire("3Ersk");

var $e4wja = parcelRequire("e4wja");

var $bQhUC = parcelRequire("bQhUC");

var $4fYE4 = parcelRequire("4fYE4");

var $jMdmu = parcelRequire("jMdmu");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $7J6Bs = parcelRequire("7J6Bs");

var $g2Yyw = parcelRequire("g2Yyw");

var $lFDz4 = parcelRequire("lFDz4");

var $22v9q = parcelRequire("22v9q");

var $8dqC7 = parcelRequire("8dqC7");

var $hvFeR = parcelRequire("hvFeR");
const $2fcd78b6532edcd2$export$89a834d0939db115 = (props)=>{
    const { recipient: recipient } = props;
    const [transferMode, setTransferMode] = (0, $6uYXW.useState)(false);
    const [dedicatedTransferMode, setDedicatedTransferMode] = (0, $6uYXW.useState)(false);
    const closeModal = (0, $6uYXW.useCallback)(()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.TRANSFER_MODAL_ID)), []);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.TRANSFER_MODAL_ID),
        children: transferMode ? /*#__PURE__*/ (0, $4m918.jsx)((0, $hvFeR.TransferTransaction), {
            showAvatar: true,
            showTitle: true,
            recipient: recipient,
            closeModal: closeModal
        }) : dedicatedTransferMode ? /*#__PURE__*/ (0, $4m918.jsx)((0, $8dqC7.DedicatedTransferTransaction), {
            recipient: recipient,
            closeModal: closeModal
        }) : /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$RecipientDetail, {
            recipient: recipient,
            startTransfer: ()=>setTransferMode(true),
            startDedicatedTransfer: ()=>setDedicatedTransferMode(true)
        })
    });
};
const $2fcd78b6532edcd2$var$RecipientDetail = (props)=>{
    const { recipient: recipient, startTransfer: startTransfer, startDedicatedTransfer: startDedicatedTransfer } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const hasAccountInformation = (0, $gDlNU.atLeastOneIsDefined)([
        recipient.iban,
        recipient.bankName,
        recipient.bic
    ]);
    const location = (0, $NQIVp.useLocation)();
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const canTransfer = location.pathname === (0, $4fYE4.Path).Transfer;
    const canDedicatedTransfer = features.p2pDedicatedTransfer;
    return /*#__PURE__*/ (0, $4m918.jsxs)($2fcd78b6532edcd2$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($2fcd78b6532edcd2$var$Centered, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $jMdmu.Avatar), {
                        size: 72,
                        name: recipient.name
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$RecipientName, {
                        children: recipient.name
                    }),
                    canTransfer && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$TransferMoneyButton, {
                                onClick: startTransfer,
                                size: "S",
                                children: formatMessage("recipientDetail.transferMoneyButton")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("div", {
                                style: {
                                    height: 20
                                }
                            }),
                            canDedicatedTransfer && /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                                size: "S",
                                onClick: startDedicatedTransfer,
                                children: formatMessage("recipientDetail.dedicatedTransferButton")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($2fcd78b6532edcd2$var$RecipientDetailContainer, {
                children: [
                    (0, $gDlNU.isDefined)(recipient.phone) && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$RecipientDetailTitle, {
                                children: formatMessage("recipientDetail.information")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$DetailRow, {
                                type: "phone",
                                label: (0, $e4wja.formatPhoneNumber)(recipient.phone)
                            })
                        ]
                    }),
                    hasAccountInformation && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$RecipientDetailTitle, {
                                children: formatMessage("recipientDetail.accountDetail")
                            }),
                            (0, $gDlNU.isDefined)(recipient.iban) && /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$DetailRow, {
                                type: "iban",
                                label: recipient.iban
                            }),
                            (0, $gDlNU.isDefined)(recipient.bic) && /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$DetailRow, {
                                type: "bic",
                                label: recipient.bic
                            }),
                            (0, $gDlNU.isDefined)(recipient.accountReference) && /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$DetailRow, {
                                type: "bic",
                                label: recipient.accountReference
                            }),
                            (0, $gDlNU.isDefined)(recipient.bankName) && /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$DetailRow, {
                                type: "bankName",
                                label: recipient.bankName
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $2fcd78b6532edcd2$var$Container = (0, $jb8NR.default).div``;
const $2fcd78b6532edcd2$var$Centered = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $2fcd78b6532edcd2$var$RecipientName = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const $2fcd78b6532edcd2$var$RecipientDetailTitle = (0, $jb8NR.default).div`
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
`;
const $2fcd78b6532edcd2$var$RecipientInformation = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.8125rem;
  color: #b1b1b1;
`;
const $2fcd78b6532edcd2$var$RecipientDetailContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 20px;
`;
const $2fcd78b6532edcd2$var$TransferMoneyButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $2fcd78b6532edcd2$var$iconProps = {
    fill: "#b1b1b1",
    width: 20,
    height: 20
};
const $2fcd78b6532edcd2$var$recipientInfoType = {
    phone: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $lFDz4.PhoneIcon), {
            ...$2fcd78b6532edcd2$var$iconProps
        })
    },
    iban: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $7J6Bs.DocumentIcon), {
            ...$2fcd78b6532edcd2$var$iconProps
        })
    },
    bic: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $7J6Bs.DocumentIcon), {
            ...$2fcd78b6532edcd2$var$iconProps
        })
    },
    accountRef: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $7J6Bs.DocumentIcon), {
            ...$2fcd78b6532edcd2$var$iconProps
        })
    },
    bankName: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $g2Yyw.HomeIcon), {
            ...$2fcd78b6532edcd2$var$iconProps
        })
    }
};
const $2fcd78b6532edcd2$var$DetailRow = (props)=>{
    const { type: type, label: label } = props;
    return /*#__PURE__*/ (0, $4m918.jsxs)($2fcd78b6532edcd2$var$Row, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$IconContainer, {
                children: $2fcd78b6532edcd2$var$recipientInfoType[type].icon
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($2fcd78b6532edcd2$var$RecipientInformation, {
                dir: "ltr",
                children: label
            })
        ]
    });
};
const $2fcd78b6532edcd2$var$Row = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;
const $2fcd78b6532edcd2$var$IconContainer = (0, $jb8NR.default).div`
  padding-right: 10px;
`;

});
parcelRegister("7J6Bs", function(module, exports) {

$parcel$export(module.exports, "DocumentIcon", function () { return $b9bf27b2bf303a5e$export$5068802198d106bd; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $b9bf27b2bf303a5e$export$5068802198d106bd(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M7.571 3.875h7.551c.34 0 .67.12.929.34l4.565 3.861c.323.273.509.675.509 1.098v12.03c0 1.717-.02 1.838-1.78 1.838H7.571c-1.76 0-1.78-.121-1.78-1.837V5.712c0-1.716.02-1.837 1.78-1.837zM8.667 12.5c-.53 0-.959.43-.959.958 0 .53.43.959.959.959h6.708c.53 0 .958-.43.958-.959 0-.529-.429-.958-.958-.958H8.667zm0 3.833c-.53 0-.959.43-.959.959 0 .529.43.958.959.958h2.875c.529 0 .958-.43.958-.958 0-.53-.43-.959-.958-.959H8.667z"
        })
    });
}

});

parcelRegister("g2Yyw", function(module, exports) {

$parcel$export(module.exports, "HomeIcon", function () { return $b83317c82539cc44$export$92c8767b874048d; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $b83317c82539cc44$export$92c8767b874048d(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        viewBox: "0 0 26 26",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "nonzero",
            d: "M15.2 17.484v2.993c0 .47.38.85.85.85h5.1c.47 0 .85-.38.85-.85v-7.514c0-.36-.143-.706-.398-.961L14.46 6.076c-.254-.255-.6-.398-.96-.398s-.706.143-.96.398l-7.142 5.926c-.255.255-.398.6-.398.961v7.514c0 .47.38.85.85.85h5.1c.225 0 .442-.09.601-.249.16-.16.249-.375.249-.6v-2.994c0-.939.761-1.7 1.7-1.7s1.7.761 1.7 1.7z"
        })
    });
}

});

parcelRegister("8dqC7", function(module, exports) {

$parcel$export(module.exports, "DedicatedTransferTransaction", function () { return $a1645fc47944cdab$export$82975d1209a7c8f0; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $1YFGv = parcelRequire("1YFGv");

var $bzlFf = parcelRequire("bzlFf");

var $40sjz = parcelRequire("40sjz");

var $jMdmu = parcelRequire("jMdmu");

var $jn1mK = parcelRequire("jn1mK");

var $eyjPK = parcelRequire("eyjPK");

var $k4kME = parcelRequire("k4kME");

var $99Id8 = parcelRequire("99Id8");

var $22v9q = parcelRequire("22v9q");

var $kmoug = parcelRequire("kmoug");

var $8u798 = parcelRequire("8u798");
const $a1645fc47944cdab$var$loadingState = [
    (0, $bzlFf.DedicatedTransferState).RequestingTransfer,
    (0, $40sjz.PincodeState).PincodeConfirmation
];
const $a1645fc47944cdab$export$82975d1209a7c8f0 = (props)=>{
    const { recipient: recipient, closeModal: closeModal } = props;
    const { context: context, state: state, selectAcceptorId: selectAcceptorId, selectAmount: selectAmount, submitPincode: submitPincode } = (0, $bzlFf.useDedicatedTransferMachine)();
    const [selectedAcceptor, setSelectedAcceptor] = (0, $6uYXW.useState)(undefined);
    const history = (0, $NQIVp.useHistory)();
    const submitAcceptor = (acceptor)=>{
        setSelectedAcceptor(acceptor);
        selectAcceptorId(acceptor.id);
    };
    (0, $6uYXW.useEffect)(()=>{
        if ((0, $kGswT.redirectionHandledOnAccountBlocked)(context.error, history.push)) closeModal();
    }, [
        context.error,
        history.push,
        closeModal
    ]);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const errorMessage = !(0, $1YFGv.isAccountBlocked)(context.error) ? context.error : undefined;
    switch(state){
        case (0, $bzlFf.DedicatedTransferState).EnterAcceptorId:
            return /*#__PURE__*/ (0, $4m918.jsx)((0, $kmoug.AcceptorSelection), {
                title: formatMessage("acceptorSelection.title"),
                onSubmit: submitAcceptor
            });
        case (0, $bzlFf.DedicatedTransferState).SelectingAmount:
        case (0, $bzlFf.DedicatedTransferState).RequestingTransfer:
        case (0, $bzlFf.DedicatedTransferState).RequestingTransferError:
        case (0, $40sjz.PincodeState).PincodeConfirmation:
        case (0, $bzlFf.DedicatedTransferState).ConfirmTransferError:
            return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($a1645fc47944cdab$var$Centered, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($a1645fc47944cdab$var$Title, {
                                children: formatMessage("dedicatedTransferAmount.title")
                            }),
                            selectedAcceptor && /*#__PURE__*/ (0, $4m918.jsx)($a1645fc47944cdab$var$SecondaryInfo, {
                                children: formatMessage("dedicatedTransferAmount.subtitle", {
                                    code: selectedAcceptor.code
                                })
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $jMdmu.Avatar), {
                                size: 36,
                                name: recipient.name
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($a1645fc47944cdab$var$SecondaryInfo, {
                                children: formatMessage("recipient.transferTo", {
                                    name: recipient.name
                                })
                            }),
                            errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($a1645fc47944cdab$var$StyledErrorMessage, {
                                children: errorMessage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($a1645fc47944cdab$var$StyledAmountSelection, {
                        recipient: recipient,
                        acceptor: selectedAcceptor,
                        submitAmount: selectAmount,
                        loading: $a1645fc47944cdab$var$loadingState.includes(state)
                    })
                ]
            });
        case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
        case (0, $40sjz.PincodeState).PromptingKeyboard:
            {
                const keyboard = context.keyboard;
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                    keyboard: keyboard,
                    onSubmit: submitPincode,
                    title: formatMessage("pincodeConfirmation.label"),
                    errorMessage: errorMessage,
                    loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError
                });
            }
        case (0, $bzlFf.DedicatedTransferState).Done:
            {
                const transactionResult = context.transactionResult;
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $8u798.DedicatedTransferSummary), {
                    recipient: recipient,
                    acceptor: selectedAcceptor,
                    title: formatMessage("transferSummary.summaryTitle"),
                    transaction: transactionResult.metadata.transaction,
                    sourceAccount: context.sourceAccount,
                    onDone: closeModal
                });
            }
        default:
            return /*#__PURE__*/ (0, $4m918.jsx)($a1645fc47944cdab$var$LoadingContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "30px"
                })
            });
    }
};
const $a1645fc47944cdab$var$Centered = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $a1645fc47944cdab$var$Title = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
  text-align: center;
  margin-top: 20px;
`;
const $a1645fc47944cdab$var$SecondaryInfo = (0, $jb8NR.default).span`
  font-size: 0.813rem;
  ${(0, $22v9q.theme).mediumText};
  color: #b1b1b1;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
`;
const $a1645fc47944cdab$var$StyledAmountSelection = (0, $jb8NR.default)((0, $99Id8.AmountSelection))`
  margin-top: 20px;
`;
const $a1645fc47944cdab$var$LoadingContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
`;
const $a1645fc47944cdab$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 50px;
  text-align: center;
`;

});
parcelRegister("bzlFf", function(module, exports) {

$parcel$export(module.exports, "useDedicatedTransferMachine", function () { return $bebab4239980c4a2$export$8b421f1d728faa60; });
$parcel$export(module.exports, "DedicatedTransferState", function () { return $bebab4239980c4a2$export$cd71e5bc8d1f6650; });

var $lCuQx = parcelRequire("lCuQx");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");

var $8UJ8q = parcelRequire("8UJ8q");

var $40sjz = parcelRequire("40sjz");
const $bebab4239980c4a2$export$8b421f1d728faa60 = ()=>{
    const [state, sendEvent] = (0, $lCuQx.useMachine)($bebab4239980c4a2$export$1c503c8380e97f4);
    const selectAcceptorId = (acceptorIdShortCode)=>{
        sendEvent("SELECT_ACCEPTOR_ID", {
            acceptorIdShortCode: acceptorIdShortCode
        });
    };
    const goBack = ()=>{
        sendEvent("GO_BACK");
    };
    const selectAmount = (recipient, amount, sourceAccounts, description)=>{
        const sourceAccount = sourceAccounts.find((account)=>account.currencyAlpha === amount.currency);
        sendEvent("SELECT_AMOUNT", {
            recipientId: recipient.id,
            amount: amount,
            sourceAccount: sourceAccount,
            label: description
        });
    };
    const submitPincode = (submission)=>{
        sendEvent("SUBMIT_PINCODE", {
            pincodeSubmission: submission
        });
    };
    return {
        state: state.value,
        context: state.context,
        selectAcceptorId: selectAcceptorId,
        goBack: goBack,
        selectAmount: selectAmount,
        submitPincode: submitPincode
    };
};
var $bebab4239980c4a2$export$cd71e5bc8d1f6650 = /*#__PURE__*/ function(DedicatedTransferState) {
    DedicatedTransferState["EnterAcceptorId"] = "EnterAcceptorId";
    DedicatedTransferState["SelectingAmount"] = "SelectingAmount";
    DedicatedTransferState["RequestingTransfer"] = "RequestingTransfer";
    DedicatedTransferState["RequestingTransferError"] = "RequestingTransferError";
    DedicatedTransferState["Confirmation"] = "Confirmation";
    DedicatedTransferState["ConfirmTransferError"] = "ConfirmTransferError";
    DedicatedTransferState["Done"] = "Done";
    return DedicatedTransferState;
}({});
var $bebab4239980c4a2$var$DedicatedTransferInvokeName = /*#__PURE__*/ function(DedicatedTransferInvokeName) {
    DedicatedTransferInvokeName["StartDedicatedTransfer"] = "StartTransfer";
    DedicatedTransferInvokeName["FetchDedicatedKeyboard"] = "FetchKeyboard";
    DedicatedTransferInvokeName["ConfirmDedicatedTransfer"] = "ConfirmDedicatedTransfer";
    return DedicatedTransferInvokeName;
}($bebab4239980c4a2$var$DedicatedTransferInvokeName || {});
const $bebab4239980c4a2$export$1c503c8380e97f4 = (0, $TAle5.createMachine)({
    predictableActionArguments: true,
    id: "dedicated-transfer",
    initial: "EnterAcceptorId",
    states: {
        ["EnterAcceptorId"]: {
            on: {
                SELECT_ACCEPTOR_ID: {
                    target: "SelectingAmount",
                    actions: [
                        (0, $c8ePo.assign)({
                            acceptorIdShortCode: (_, event)=>event.acceptorIdShortCode
                        })
                    ]
                }
            }
        },
        ["SelectingAmount"]: {
            on: {
                SELECT_AMOUNT: {
                    target: "RequestingTransfer",
                    actions: [
                        (0, $c8ePo.assign)({
                            recipientId: (_, event)=>event.recipientId,
                            amount: (_, event)=>event.amount,
                            sourceAccount: (_, event)=>event.sourceAccount,
                            label: (_, event)=>event.label
                        })
                    ]
                },
                GO_BACK: {
                    target: "EnterAcceptorId"
                }
            }
        },
        ["RequestingTransfer"]: {
            invoke: {
                id: "StartTransfer",
                src: (context)=>(0, $kqXxS.dedicatedTransferManager).startTransfer(context.recipientId, context.acceptorIdShortCode, context.amount, context.label),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionRequest: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)((context)=>context.transactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "PINCODE_CONFIRM"
                            } : {
                                type: "CONFIRM"
                            })
                    ]
                },
                onError: {
                    target: "RequestingTransferError",
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        })
                    ]
                }
            },
            on: {
                PINCODE_CONFIRM: (0, $40sjz.PincodeState).PincodeConfirmation,
                CONFIRM: "Confirmation"
            }
        },
        ["RequestingTransferError"]: {
            exit: (0, $c8ePo.assign)({
                error: undefined
            }),
            on: {
                SELECT_AMOUNT: {
                    target: "RequestingTransfer"
                }
            }
        },
        [(0, $40sjz.PincodeState).PincodeConfirmation]: {
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboard]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "Confirmation",
                    actions: (0, $c8ePo.assign)({
                        pincodeSubmission: (_, event)=>event.pincodeSubmission
                    })
                },
                GO_BACK: {
                    target: "SelectingAmount"
                }
            }
        },
        ["Confirmation"]: {
            invoke: {
                id: "ConfirmDedicatedTransfer",
                src: (context)=>(0, $kqXxS.dedicatedTransferManager).confirmSendDedicatedTransfer(context.transactionRequest.metadata.confirmationMode, {
                        date: Date.now().toString(),
                        amount: context.amount,
                        recipientId: context.recipientId,
                        acceptorId: context.acceptorIdShortCode,
                        label: context.label ?? ""
                    }, context.pincodeSubmission),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionResult: (_, event)=>event.data,
                            error: undefined
                        }),
                        (0, $c8ePo.send)({
                            type: "DEDICATED_TRANSFER_DONE"
                        })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)((ctx)=>ctx.transactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "TRANSFER_CONFIRMATION_PINCODE_ERROR"
                            } : {
                                type: "TRANSFER_CONFIRMATION_ERROR"
                            })
                    ]
                }
            },
            on: {
                DEDICATED_TRANSFER_DONE: "Done",
                DEDICATED_TRANSFER_CONFIRMATION_PINCODE_ERROR: (0, $40sjz.PincodeState).FetchKeyboardAfterError,
                DEDICATED_TRANSFER_CONFIRMATION_ERROR: "ConfirmTransferError"
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        ["ConfirmTransferError"]: {
            exit: (0, $c8ePo.assign)({
                error: undefined
            }),
            on: {
                SELECT_AMOUNT: {
                    target: "RequestingTransfer",
                    actions: (0, $c8ePo.assign)({
                        recipientId: (_, event)=>event.recipientId,
                        amount: (_, event)=>event.amount,
                        label: (_, event)=>event.label,
                        sourceAccount: (_, event)=>event.sourceAccount
                    })
                }
            }
        },
        ["Done"]: {
            type: "final"
        }
    }
});

});

parcelRegister("kmoug", function(module, exports) {

$parcel$export(module.exports, "AcceptorSelection", function () { return $67055789571daec5$export$e92b42e558033d1e; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $Q4N37 = parcelRequire("Q4N37");

var $Y6t65 = parcelRequire("Y6t65");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $jn1mK = parcelRequire("jn1mK");

var $knJqj = parcelRequire("knJqj");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $92dMg = parcelRequire("92dMg");
const $67055789571daec5$var$GRID_COLUMNS = 4;
const $67055789571daec5$var$GRID_ROWS = 4;
const $67055789571daec5$var$PADDING = 10;
const $67055789571daec5$var$SPACING = 10;
const $67055789571daec5$var$TOUCH_SIZE = 45;
const $67055789571daec5$export$e92b42e558033d1e = (props)=>{
    const { onSubmit: onSubmit, className: className, title: title, errorMessage: errorMessage } = props;
    const categories = (0, $3Ersk.useObservable)((0, $kqXxS.acceptorCategoriesManager).acceptorCategories);
    const acceptors = (0, $Q4N37.useAcceptors)();
    const loadMoreDebounce = (0, $Y6t65.useLoadMoreDebounce)();
    const loadMore = (0, $6uYXW.useCallback)(()=>loadMoreDebounce(acceptors.loadMore, acceptors.loadingMore, acceptors.canLoadMore), [
        acceptors.canLoadMore,
        acceptors.loadMore,
        acceptors.loadingMore,
        loadMoreDebounce
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (categories.length === 0) await (0, $kqXxS.acceptorCategoriesManager).refresh();
    }, [
        categories
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await acceptors.load(0, 0, true);
    }, []);
    return /*#__PURE__*/ (0, $4m918.jsxs)($67055789571daec5$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($67055789571daec5$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($67055789571daec5$var$Title, {
                        children: title
                    }),
                    errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($67055789571daec5$var$StyledErrorMessage, {
                        children: errorMessage
                    })
                ]
            }),
            acceptors.loading ? /*#__PURE__*/ (0, $4m918.jsx)($67055789571daec5$var$SpinnerContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {})
            }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $knJqj.InfiniteScroll), {
                fetchMore: loadMore,
                hasMore: acceptors.canLoadMore,
                loading: acceptors.loadingMore,
                children: /*#__PURE__*/ (0, $4m918.jsx)($67055789571daec5$var$StyledInsideInfiniteScroll, {
                    children: acceptors.data.map((acceptor, index)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $92dMg.AcceptorRow), {
                            acceptor: acceptor,
                            onClick: ()=>onSubmit(acceptor)
                        }, index))
                })
            })
        ]
    });
};
const $67055789571daec5$var$SpinnerContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${$67055789571daec5$var$GRID_ROWS * ($67055789571daec5$var$TOUCH_SIZE + $67055789571daec5$var$SPACING) - $67055789571daec5$var$SPACING}px;
  width: ${$67055789571daec5$var$GRID_COLUMNS * ($67055789571daec5$var$TOUCH_SIZE + $67055789571daec5$var$SPACING) - $67055789571daec5$var$SPACING + 2 * $67055789571daec5$var$PADDING}px;
`;
const $67055789571daec5$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 30px;
  width: 300px;
  text-align: center;
  position: relative;
`;
const $67055789571daec5$var$Title = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
`;
const $67055789571daec5$var$Container = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-left: ${$67055789571daec5$var$PADDING}px;
  padding-right: ${$67055789571daec5$var$PADDING}px;
  padding-bottom: ${$67055789571daec5$var$PADDING}px;
`;
const $67055789571daec5$var$StyledInsideInfiniteScroll = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  max-height: 400px;
  overflow-y: scroll;
`;
const $67055789571daec5$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 0px 10px 0px;
  text-align: center;
`;

});
parcelRegister("Q4N37", function(module, exports) {

$parcel$export(module.exports, "useAcceptors", function () { return $0d43e88e259f59c1$export$e206385e2b2fa759; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");
function $0d43e88e259f59c1$export$e206385e2b2fa759() {
    const data = (0, $3Ersk.useObservable)((0, $kqXxS.acceptorManager).acceptors);
    const loading = (0, $3Ersk.useObservable)((0, $kqXxS.acceptorManager).loading);
    const error = (0, $3Ersk.useObservable)((0, $kqXxS.acceptorManager).error);
    const loadingMore = (0, $3Ersk.useObservable)((0, $kqXxS.acceptorManager).loadingMore);
    const loadingMoreError = (0, $3Ersk.useObservable)((0, $kqXxS.acceptorManager).loadingMoreError);
    const canLoadMore = (0, $6uYXW.useMemo)(()=>data.offset + data.limit < data.total, [
        data.offset,
        data.limit,
        data.total
    ]);
    const load = (0, $6uYXW.useCallback)(async (latitude, longitude, supportDedicatedTransfers, limit, radius)=>{
        await (0, $kqXxS.acceptorManager).load(latitude, longitude, supportDedicatedTransfers, limit, radius);
    }, []);
    const loadMore = (0, $6uYXW.useCallback)(async ()=>{
        await (0, $kqXxS.acceptorManager).loadMore();
    }, []);
    return {
        data: data.items,
        load: load,
        loading: loading,
        error: error,
        canLoadMore: canLoadMore,
        loadMore: loadMore,
        loadingMore: loadingMore,
        loadingMoreError: loadingMoreError
    };
}

});

parcelRegister("92dMg", function(module, exports) {

$parcel$export(module.exports, "AcceptorRow", function () { return $397971fa709f2b92$export$2f0a2d6f5b74f28b; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $e4wja = parcelRequire("e4wja");

var $bYkia = parcelRequire("bYkia");

var $yYT9n = parcelRequire("yYT9n");

var $jMdmu = parcelRequire("jMdmu");

var $7Zu6k = parcelRequire("7Zu6k");

var $7J6Bs = parcelRequire("7J6Bs");

var $7wSRt = parcelRequire("7wSRt");

var $lFDz4 = parcelRequire("lFDz4");

var $22v9q = parcelRequire("22v9q");
const $397971fa709f2b92$export$2f0a2d6f5b74f28b = (props)=>{
    const { acceptor: acceptor, onClick: onClick } = props;
    const [showMoreDetails, setShowMoreDetails] = (0, $6uYXW.useState)(false);
    const { name: name, contactphone: contactphone, email: email } = acceptor;
    const category = (0, $bYkia.useAcceptorCategory)(acceptor);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($397971fa709f2b92$var$Card, {
        onClick: ()=>setShowMoreDetails((last)=>!last),
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($397971fa709f2b92$var$MainDetails, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($397971fa709f2b92$var$AcceptorWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $jMdmu.Avatar), {
                                size: 40,
                                name: name
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($397971fa709f2b92$var$AcceptorDetailContainer, {
                                $isRTL: isRTL,
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$AcceptorName, {
                                        children: name
                                    }),
                                    category && /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$AcceptorDetail, {
                                        children: category
                                    })
                                ]
                            })
                        ]
                    }),
                    !showMoreDetails && /*#__PURE__*/ (0, $4m918.jsxs)($397971fa709f2b92$var$ContactIcons, {
                        children: [
                            contactphone && /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$IconContainer, {
                                $isRTL: isRTL,
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $lFDz4.PhoneIcon), {})
                            }),
                            email && /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$IconContainer, {
                                $isRTL: isRTL,
                                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7wSRt.PenIcon), {})
                            })
                        ]
                    })
                ]
            }),
            showMoreDetails && /*#__PURE__*/ (0, $4m918.jsxs)($397971fa709f2b92$var$MoreDetailsContainer, {
                children: [
                    contactphone && /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$DetailRow, {
                        type: "phone",
                        label: (0, $e4wja.formatPhoneNumber)(contactphone)
                    }),
                    email && /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$DetailRow, {
                        type: "email",
                        label: email
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$SelectionButton, {
                        size: "XS",
                        onClick: onClick,
                        children: formatMessage("acceptorSelection.selectionButton")
                    })
                ]
            })
        ]
    });
};
const $397971fa709f2b92$var$Card = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 18px 0px;
  border-bottom: 1px solid #ededed;
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: auto;
  }
`;
const $397971fa709f2b92$var$MainDetails = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const $397971fa709f2b92$var$AcceptorWrapper = (0, $jb8NR.default).div`
  display: flex;
`;
const $397971fa709f2b92$var$AcceptorName = (0, $jb8NR.default).span`
  font-size: 1rem;
  ${(0, $22v9q.theme).boldText};
  color: #000000;
`;
const $397971fa709f2b92$var$AcceptorDetailContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-left: ${(props)=>props.$isRTL ? 0 : 15}px;
  margin-right: ${(props)=>props.$isRTL ? 15 : 0}px;
  justify-content: center;
`;
const $397971fa709f2b92$var$AcceptorDetail = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.8125rem;
  color: #aaaaaa;
`;
const $397971fa709f2b92$var$ContactIcons = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  svg {
    width: 20px;
    height: 20px;
  }
`;
const $397971fa709f2b92$var$IconContainer = (0, $jb8NR.default).div`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  margin: ${(props)=>props.$isRTL ? "1px 15px 0 0" : "1px 0 0 15px"};
  padding: 8px;
  background-color: #ededed;
`;
const $397971fa709f2b92$var$MoreDetailsContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin: 10px;
`;
const $397971fa709f2b92$var$SelectionButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 15px;
  align-self: center;
  padding: 10px 20px;
`;
const $397971fa709f2b92$var$iconProps = {
    fill: "#b1b1b1",
    width: 20,
    height: 20
};
const $397971fa709f2b92$var$acceptorInfoType = {
    phone: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $lFDz4.PhoneIcon), {
            ...$397971fa709f2b92$var$iconProps
        })
    },
    email: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $7J6Bs.DocumentIcon), {
            ...$397971fa709f2b92$var$iconProps
        })
    }
};
const $397971fa709f2b92$var$DetailRow = (props)=>{
    const { type: type, label: label } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($397971fa709f2b92$var$Row, {
        onClick: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$IconWrapper, {
                $isRTL: isRTL,
                children: $397971fa709f2b92$var$acceptorInfoType[type].icon
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($397971fa709f2b92$var$AcceptorInformation, {
                children: label
            })
        ]
    });
};
const $397971fa709f2b92$var$Row = (0, $jb8NR.default).div`
  cursor: text;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 35px;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;
const $397971fa709f2b92$var$IconWrapper = (0, $jb8NR.default).div`
  padding-right: ${(props)=>props.$isRTL ? 0 : 10}px;
  padding-left: ${(props)=>props.$isRTL ? 10 : 0}px;
`;
const $397971fa709f2b92$var$AcceptorInformation = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.8125rem;
  color: #b1b1b1;
  direction: ltr;
`;

});
parcelRegister("bYkia", function(module, exports) {

$parcel$export(module.exports, "useAcceptorCategory", function () { return $499a46df0c090baa$export$6346bfb22149755f; });

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $499a46df0c090baa$export$6346bfb22149755f = (acceptor)=>{
    const acceptorCategories = (0, $3Ersk.useObservable)((0, $kqXxS.acceptorCategoriesManager).acceptorCategories);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if (acceptorCategories.length === 0) await (0, $kqXxS.acceptorCategoriesManager).refresh();
    }, [
        acceptorCategories
    ]);
    const categoryLabel = (0, $6uYXW.useMemo)(()=>{
        if (!acceptor) return "";
        const category = acceptorCategories.find((c)=>c.id === acceptor.category);
        return category ? category.label : null;
    }, [
        acceptor,
        acceptorCategories
    ]);
    return categoryLabel;
};

});



parcelRegister("8u798", function(module, exports) {

$parcel$export(module.exports, "DedicatedTransferSummary", function () { return $ba12a8ba4ed3047f$export$92448ea0dd688a08; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $8RlWY = parcelRequire("8RlWY");

var $22v9q = parcelRequire("22v9q");
const $ba12a8ba4ed3047f$export$92448ea0dd688a08 = (props)=>{
    const { title: title, subtitle: subtitle, recipient: recipient, acceptor: acceptor, sourceAccount: sourceAccount, transaction: transaction, onDone: onDone, className: className } = props;
    const { formatMessage: formatMessage, formatAmount: formatAmount } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($ba12a8ba4ed3047f$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$GreenCheckCircle, {}),
            /*#__PURE__*/ (0, $4m918.jsxs)($ba12a8ba4ed3047f$var$Centered, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$SuccessText, {
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$Subtitle, {
                        children: subtitle
                    }),
                    sourceAccount && /*#__PURE__*/ (0, $4m918.jsxs)($ba12a8ba4ed3047f$var$InfoRow, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoLabel, {
                                children: formatMessage("dedicatedTransferSummary.account")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoValue, {
                                children: sourceAccount.id
                            })
                        ]
                    }),
                    recipient && /*#__PURE__*/ (0, $4m918.jsxs)($ba12a8ba4ed3047f$var$InfoRow, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoLabel, {
                                children: formatMessage("dedicatedTransferSummary.recepient")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoValue, {
                                children: recipient.name
                            })
                        ]
                    }),
                    transaction.amount && /*#__PURE__*/ (0, $4m918.jsxs)($ba12a8ba4ed3047f$var$InfoRow, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoLabel, {
                                children: formatMessage("dedicatedTransferSummary.amount")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoValue, {
                                children: formatAmount(transaction.amount)
                            })
                        ]
                    }),
                    acceptor?.code && /*#__PURE__*/ (0, $4m918.jsxs)($ba12a8ba4ed3047f$var$InfoRow, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoLabel, {
                                children: formatMessage("dedicatedTransferSummary.transactionPoint")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoValue, {
                                children: acceptor.code
                            })
                        ]
                    }),
                    transaction.date && /*#__PURE__*/ (0, $4m918.jsxs)($ba12a8ba4ed3047f$var$InfoRow, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoLabel, {
                                children: formatMessage("dedicatedTransferSummary.expirationDate")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$InfoValue, {
                                children: transaction.date
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($ba12a8ba4ed3047f$var$DoneButton, {
                size: "M",
                onClick: onDone,
                children: formatMessage("dedicatedTransferSummary.done")
            })
        ]
    });
};
const $ba12a8ba4ed3047f$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
const $ba12a8ba4ed3047f$var$InfoRow = (0, $jb8NR.default).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const $ba12a8ba4ed3047f$var$InfoLabel = (0, $jb8NR.default).span`
  font-size: 1rem;
  ${(0, $22v9q.theme).mediumText};
  color: #b1b1b1;
  margin-top: 10px;
`;
const $ba12a8ba4ed3047f$var$InfoValue = (0, $jb8NR.default).span`
  font-size: 1rem;
  ${(0, $22v9q.theme).mediumText};
`;
const $ba12a8ba4ed3047f$var$GreenCheckCircle = (0, $jb8NR.default)((0, $8RlWY.SuccessCircle))`
  margin-top: 28px;
`;
const $ba12a8ba4ed3047f$var$Centered = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin: 46px 17px 36px;
  padding: 33px 26px 40px;
  border-radius: 30px;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
`;
const $ba12a8ba4ed3047f$var$Subtitle = (0, $jb8NR.default).div`
  font-size: 1rem;
  ${(0, $22v9q.theme).boldText};
  align-self: center;
  padding-bottom: 25px;
  text-align: center;
`;
const $ba12a8ba4ed3047f$var$SuccessText = (0, $jb8NR.default).div`
  font-size: 1.375rem;
  ${(0, $22v9q.theme).boldText};
  padding-bottom: 25px;
  padding-top: 30px;
  align-self: center;
`;
const $ba12a8ba4ed3047f$var$DoneButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  align-self: center;
  padding: 10px 40px;
`;

});




parcelRegister("1MEJh", function(module, exports) {

$parcel$export(module.exports, "RecipientRow", function () { return $a5e5514cf64f6250$export$c3d58480ccff7682; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $e4wja = parcelRequire("e4wja");

var $bQhUC = parcelRequire("bQhUC");

var $jMdmu = parcelRequire("jMdmu");

var $4nSeL = parcelRequire("4nSeL");

var $5Wai4 = parcelRequire("5Wai4");

var $22v9q = parcelRequire("22v9q");

var $jM3f7 = parcelRequire("jM3f7");
const $a5e5514cf64f6250$export$c3d58480ccff7682 = (props)=>{
    const { recipient: recipient, onClick: onClick, onEdit: onEdit, readonly: readonly = true, isRTL: isRTL } = props;
    const [openMenu, setOpenMenu] = (0, $6uYXW.useState)(false);
    const toggleMenu = ()=>setOpenMenu((bool)=>!bool);
    const recipientDetail = recipient.phone ? (0, $e4wja.formatPhoneNumber)(recipient.phone) : recipient.iban ? recipient.iban : recipient.accountReference ? recipient.accountReference : "";
    return /*#__PURE__*/ (0, $4m918.jsxs)($a5e5514cf64f6250$var$Card, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $jMdmu.Avatar), {
                size: 40,
                name: recipient.name
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($a5e5514cf64f6250$var$RecipientDetailContainer, {
                $isRTL: isRTL,
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($a5e5514cf64f6250$var$RecipientName, {
                        children: recipient.name
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($a5e5514cf64f6250$var$RecipientDetail, {
                        children: recipientDetail
                    })
                ]
            }),
            !readonly && /*#__PURE__*/ (0, $4m918.jsx)((0, $4nSeL.default), {
                isRTL: isRTL,
                onToggle: toggleMenu,
                isOpen: openMenu,
                onEdit: ()=>onEdit?.(),
                onDelete: ()=>{
                    (0, $5Wai4.Modal).present((0, $bQhUC.REMOVE_RECIPIENT_MODAL_ID), // eslint-disable-next-line react/no-unstable-nested-components
                    ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $jM3f7.RemoveRecipientModal), {
                            recipient: recipient,
                            onConfirm: ()=>(0, $kqXxS.beneficiaryManager).deleteRecipient(recipient.id)
                        }), {
                        canBeDismissed: false
                    });
                }
            })
        ]
    });
};
const $a5e5514cf64f6250$var$Card = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  padding: 18px 27px 18px 15px;
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  background-color: #ffffff;
  align-self: stretch;
  &:not(:last-of-type) {
    margin-bottom: 15px;
  }
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: auto;
  }
`;
const $a5e5514cf64f6250$var$RecipientName = (0, $jb8NR.default).span`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).mediumText};
  color: #000000;
`;
const $a5e5514cf64f6250$var$RecipientDetail = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 0.8125rem;
  color: #b1b1b1;
  direction: ltr;
`;
const $a5e5514cf64f6250$var$RecipientDetailContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  margin-right: ${(props)=>props.$isRTL ? 15 : 0}px;
  margin-left: ${(props)=>props.$isRTL ? 0 : 15}px;
`;

});


parcelRegister("b6m5I", function(module, exports) {

$parcel$export(module.exports, "CreateSavingScreen", function () { return $298bdd7300eb54d5$export$5898da3d8ab53353; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $k4Ecv = parcelRequire("k4Ecv");

var $jn1mK = parcelRequire("jn1mK");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $5vhv3 = parcelRequire("5vhv3");
function $298bdd7300eb54d5$export$5898da3d8ab53353() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [fetchingData, setFetchingData] = (0, $6uYXW.useState)(false);
    const [apiSuccess, setApiSuccess] = (0, $6uYXW.useState)(false);
    const [apiError, setApiError] = (0, $6uYXW.useState)("");
    const handleSendRequest = async (contractReq)=>{
        setFetchingData(true);
        setApiSuccess(false);
        setApiError("");
        try {
            await (0, $kqXxS.savingsManager).createSavingsContract(contractReq);
            setApiSuccess(true);
        } catch (e) {
            setApiError(e.response?.data?.message);
        } finally{
            setFetchingData(false);
        }
    };
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        setFetchingData(true);
        /** Two APIs will be called sequentially to fetch list of all savings products
     *  Will be optimized in future, as of now proceeding for demo
     */ const res = await (0, $kqXxS.savingsService).getAllSavingsProduct("0");
        await (0, $kqXxS.savingsManager).getAllSavingsProduct(`${res.count}`);
        setFetchingData(false);
    }, []);
    return /*#__PURE__*/ (0, $4m918.jsxs)($298bdd7300eb54d5$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($298bdd7300eb54d5$var$Title, {
                children: formatMessage("createSavingsAccount.title")
            }),
            apiError && /*#__PURE__*/ (0, $4m918.jsx)($298bdd7300eb54d5$var$ApiErrorMessage, {
                children: apiError
            }),
            apiSuccess && /*#__PURE__*/ (0, $4m918.jsx)($298bdd7300eb54d5$var$ApiSuccessMessage, {
                children: formatMessage("createSavingsAccount.creationSuccessMessage")
            }),
            fetchingData ? /*#__PURE__*/ (0, $4m918.jsx)($298bdd7300eb54d5$var$LoadingContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "30px"
                })
            }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $5vhv3.CreateSavingModal), {
                handleSendRequest: handleSendRequest
            })
        ]
    });
}
const $298bdd7300eb54d5$var$Container = (0, $jb8NR.default).div`
  width: 100%;
`;
const $298bdd7300eb54d5$var$Title = (0, $jb8NR.default).span`
  font-size: 1.5625rem;
  margin-bottom: 12px;
  ${(0, $22v9q.theme).boldText};
  color: ${(0, $22v9q.theme).mainColor};
  white-space: pre;
`;
const $298bdd7300eb54d5$var$LoadingContainer = (0, $jb8NR.default).div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
`;
const $298bdd7300eb54d5$var$ApiErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 10px;
  font-size: 1rem;
`;
const $298bdd7300eb54d5$var$ApiSuccessMessage = (0, $jb8NR.default)($298bdd7300eb54d5$var$ApiErrorMessage)`
  color: #4bb543;
`;

});
parcelRegister("5vhv3", function(module, exports) {

$parcel$export(module.exports, "CreateSavingModal", function () { return $18b083852f885039$export$8cbb74d34d49a902; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $7W32u = parcelRequire("7W32u");

var $3Ersk = parcelRequire("3Ersk");

var $7Zu6k = parcelRequire("7Zu6k");

var $5rJrd = parcelRequire("5rJrd");

var $k5s21 = parcelRequire("k5s21");

var $39jSd = parcelRequire("39jSd");

var $9mlIh = parcelRequire("9mlIh");

var $51d3M = parcelRequire("51d3M");

var $22v9q = parcelRequire("22v9q");

var $lT9Op = parcelRequire("lT9Op");
const $18b083852f885039$export$8cbb74d34d49a902 = ({ handleSendRequest: handleSendRequest })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const allSavingsProduct = (0, $3Ersk.useObservable)((0, $kqXxS.savingsManager).allSavingsProduct);
    const selectedLang = (0, $3Ersk.useObservable)((0, $kqXxS.i18NManager).localeTag);
    const session = (0, $kqXxS.authenticationManager).session.get();
    /** Form values and handlers */ const [savingsAccountType, setSavingsAccountType] = (0, $6uYXW.useState)();
    const [amount, setAmount] = (0, $6uYXW.useState)({
        value: 0,
        currency: "EUR"
    });
    const [typeOfAccount, setTypeOfAccount] = (0, $6uYXW.useState)((0, $7W32u.ACCOUNT_TYPES_IE).INTERNAL);
    const [duration, setDuration] = (0, $6uYXW.useState)({
        value: "",
        type: (0, $7W32u.DURATION_CYCLE)[0]
    });
    const [accountToCollect, setAccountToCollect] = (0, $6uYXW.useState)(null);
    const [showAccounts, setShowAccounts] = (0, $6uYXW.useState)(false);
    (0, $6uYXW.useEffect)(()=>{
        if (savingsAccountType) {
            const initialDurationValue = savingsAccountType.duration.durationBoundaries.default ?? "";
            setAmount({
                ...amount,
                currency: savingsAccountType.currency
            });
            setDuration({
                value: initialDurationValue.toString(),
                type: savingsAccountType.duration.cycleFrequency
            });
        }
    }, [
        savingsAccountType
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (typeOfAccount === (0, $7W32u.ACCOUNT_TYPES_IE).EXTERNAL) setAccountToCollect(null);
    }, [
        typeOfAccount
    ]);
    const toggleAccountList = ()=>{
        setShowAccounts((prevVal)=>!prevVal);
    };
    const onSendRequest = ()=>{
        if (canSubmit) {
            const contract = {
                accountToCollectType: typeOfAccount,
                clientId: session.clientId,
                duration: {
                    cycleFrequency: duration.type,
                    value: parseInt(duration.value)
                },
                isTaxable: false,
                productCode: savingsAccountType.code,
                productType: savingsAccountType.type,
                taxProfileIds: []
            };
            if (typeOfAccount === (0, $7W32u.ACCOUNT_TYPES_IE).INTERNAL && accountToCollect) {
                contract.clientCurrentAccountNumber = accountToCollect.id;
                contract.initialAmount = {
                    amount: amount.value,
                    currency: amount.currency
                };
            } else if (typeOfAccount === (0, $7W32u.ACCOUNT_TYPES_IE).EXTERNAL) contract.minDepositAmount = {
                amount: amount.value,
                currency: amount.currency
            };
            handleSendRequest(contract);
        }
    };
    const durationChoices = savingsAccountType?.duration.durationBoundaries.choices ?? [];
    const canSubmit = savingsAccountType && (typeOfAccount === (0, $7W32u.ACCOUNT_TYPES_IE).INTERNAL ? accountToCollect : true) && amount.value > 0 && duration.value && duration.type;
    return /*#__PURE__*/ (0, $4m918.jsxs)($18b083852f885039$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($18b083852f885039$var$LeftColumn, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "createSavingsAccount.selectAccount"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                        style: {
                            width: "100%"
                        },
                        innerId: "savings-account-type",
                        options: allSavingsProduct.items,
                        value: savingsAccountType,
                        onChange: setSavingsAccountType,
                        itemRenderer: (v)=>v?.names?.[selectedLang] ?? v?.code
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "createSavingsAccount.initialDeposit"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $5rJrd.AmountInput), {
                        id: "initial-deposit-amount",
                        variant: "big",
                        value: amount,
                        onChange: setAmount
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "createSavingsAccount.selectAccountTypeLabel"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                        style: {
                            width: "100%"
                        },
                        innerId: "type-of-account",
                        options: (0, $7W32u.ACC_TYPE_IE_OPTIONS),
                        value: typeOfAccount,
                        onChange: setTypeOfAccount,
                        itemRenderer: (v)=>formatMessage(`createSavingsAccount.selectAccountType.${v}`)
                    }),
                    typeOfAccount === (0, $7W32u.ACCOUNT_TYPES_IE).INTERNAL && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                                size: "normal",
                                margin: "normal",
                                label: "createSavingsAccount.accountToCollect"
                            }),
                            accountToCollect ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lT9Op.AccountButton), {
                                account: accountToCollect,
                                onClick: toggleAccountList
                            }) : /*#__PURE__*/ (0, $4m918.jsxs)($18b083852f885039$var$SourceAndDestinationButton, {
                                type: "button",
                                $active: showAccounts,
                                onClick: toggleAccountList,
                                children: [
                                    formatMessage("amountSelection.choose_source_account"),
                                    /*#__PURE__*/ (0, $4m918.jsx)((0, $51d3M.ChevronIcon), {
                                        width: 18,
                                        height: 18
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "createSavingsAccount.duration"
                    }),
                    durationChoices.length ? /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                        style: {
                            width: "100%",
                            marginTop: 8
                        },
                        innerId: "duration-choice",
                        options: durationChoices.map(String),
                        value: duration.value,
                        onChange: (value)=>setDuration({
                                ...duration,
                                value: value
                            }),
                        itemRenderer: (v)=>v
                    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        id: "duration-value",
                        value: duration.value,
                        onChange: (event)=>setDuration({
                                ...duration,
                                value: event.target.value
                            }),
                        type: "number",
                        min: 1,
                        onWheel: (e)=>{
                            if (e.target instanceof HTMLElement) e.target.blur();
                        }
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                        style: {
                            width: "100%",
                            marginTop: 8
                        },
                        innerId: "duration-type",
                        options: (0, $7W32u.DURATION_CYCLE),
                        value: duration.type,
                        onChange: (value)=>setDuration({
                                ...duration,
                                type: value
                            }),
                        itemRenderer: (v)=>formatMessage(`accountDetails.monthsLabels.${v}`),
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($18b083852f885039$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                            size: "S",
                            onClick: onSendRequest,
                            disabled: !canSubmit,
                            children: formatMessage("createSavingsAccount.sendRequest")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($18b083852f885039$var$RightColumn, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $lT9Op.SourceAndDestination), {
                    type: showAccounts ? (0, $lT9Op.SourceAndDestinationEnum).Source : null,
                    sourceAccount: accountToCollect,
                    accountTypeFilter: (0, $kGswT.AccountType).Current,
                    onSourceAccountChange: (acc)=>{
                        setAccountToCollect(acc);
                        setShowAccounts(false);
                    }
                })
            })
        ]
    });
};
const $18b083852f885039$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  gap: 30px;
`;
const $18b083852f885039$var$LeftColumn = (0, $jb8NR.default).div`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $18b083852f885039$var$RightColumn = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $18b083852f885039$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;
const $18b083852f885039$var$SourceAndDestinationButton = (0, $jb8NR.default)("button")`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  appearance: none;
  border: none;
  height: 48px;
  box-shadow: none;
  background-color: white;
  text-align: left;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;
  ${(0, $22v9q.theme).bodyBlackRegular};
  ${(props)=>props.$active && (0, $jb8NR.css)`
      color: ${(0, $22v9q.theme).mainColor()};
      svg {
        fill: ${(0, $22v9q.theme).mainColor()};
      }
    `}
  ${(props)=>props.disabled && (0, $jb8NR.css)`
      opacity: 0.5;
      &:hover {
        cursor: not-allowed;
      }
    `}
`;

});
parcelRegister("7W32u", function(module, exports) {

$parcel$export(module.exports, "DURATION_CYCLE", function () { return $42728452783ce57d$export$ab259b523bf0b4f8; });
$parcel$export(module.exports, "ACCOUNT_TYPES_IE", function () { return $42728452783ce57d$export$ce698f7f26452849; });
$parcel$export(module.exports, "ACC_TYPE_IE_OPTIONS", function () { return $42728452783ce57d$export$7d630c7e19124cd3; });
const $42728452783ce57d$export$ab259b523bf0b4f8 = [
    "DAILY",
    "WEEKLY",
    "MONTHLY",
    "QUARTERLY",
    "SEMESTER",
    "ANNUALLY"
];
const $42728452783ce57d$export$ce698f7f26452849 = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL"
};
const $42728452783ce57d$export$7d630c7e19124cd3 = [
    $42728452783ce57d$export$ce698f7f26452849.INTERNAL,
    $42728452783ce57d$export$ce698f7f26452849.EXTERNAL
];

});



parcelRegister("1bqgL", function(module, exports) {

$parcel$export(module.exports, "MyProfileScreen", function () { return $1ccd4cb9623c086b$export$d10830b23ad10342; });

var $4m918 = parcelRequire("4m918");

var $cL9IJ = parcelRequire("cL9IJ");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $dhPTb = parcelRequire("dhPTb");

var $jO1Lj = parcelRequire("jO1Lj");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $4lOZ3 = parcelRequire("4lOZ3");

var $gXgQv = parcelRequire("gXgQv");

var $5hf1X = parcelRequire("5hf1X");

var $gDlNU = parcelRequire("gDlNU");

var $cNsCW = parcelRequire("cNsCW");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");

var $4fYE4 = parcelRequire("4fYE4");

var $7N0kU = parcelRequire("7N0kU");

var $bewhU = parcelRequire("bewhU");

var $7Zu6k = parcelRequire("7Zu6k");

var $j26Ew = parcelRequire("j26Ew");

var $16qxo = parcelRequire("16qxo");

var $jn1mK = parcelRequire("jn1mK");

var $8JW2B = parcelRequire("8JW2B");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $OY7Ij = parcelRequire("OY7Ij");

var $04UNA = parcelRequire("04UNA");

const $1ccd4cb9623c086b$export$d10830b23ad10342 = ()=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    const { client: client } = (0, $7N0kU.useClient)();
    const { push: push } = (0, $NQIVp.useHistory)();
    const emailRef = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useRef(null);
    const [isSubmitting, setIsSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(false);
    const [editingEmail, setEditingEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(false);
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const { updateEmailAddressLink: updateEmailAddressLink, canUpdateEmailAddress: canUpdateEmailAddress } = (0, $gXgQv.useClientLinks)();
    const [successMsg, setSuccessMsg] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState();
    const [userEmail, setUserEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState({
        type: (0, $jO1Lj.FormInputType).Email,
        id: "email",
        label: "Email",
        value: client?.email || ""
    });
    const clientRole = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).clientRole);
    const kycLabels = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).kycLabels);
    const kycDocuments = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).kycDocuments);
    const clientRoleLoading = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).clientRoleLoading);
    const kycDocumentsLoading = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).kycDocumentsLoading);
    const clientRoleError = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).clientRoleError);
    const kycDocumentsError = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).kycDocumentsError);
    const downloadKycError = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).downloadKycError);
    const kycLabelsError = (0, $3Ersk.useObservable)((0, $kqXxS.identityManager).kycLabelsError);
    const [clientKyc, setClientKyc] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState();
    const [viewKycDetails, setViewKycDetails] = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useState(false);
    const session = (0, $kqXxS.authenticationManager).session.get();
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if ((0, $dhPTb.Config).DISPLAY_KYC_DATA && features.identityView) await (0, $kqXxS.identityManager).fetchClientRole(session.clientId);
    }, []);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if ((0, $dhPTb.Config).DISPLAY_KYC_DATA && clientRole && features.additionalDataRead) await (0, $kqXxS.identityManager).fetchKycLabels(clientRole.profileId);
    }, [
        clientRole
    ]);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        if ((0, $dhPTb.Config).DISPLAY_KYC_DATA && features.identityDocumentView) await (0, $kqXxS.identityManager).fetchKycDocuments(session.clientId);
    }, [
        session
    ]);
    (0, $6uYXW.useEffect)(()=>{
        clientRole && setClientKyc((0, $k4Ecv.filterObjectKeys)(clientRole.kyc, (0, $5hf1X.KYC_EXCLUDES)));
    }, [
        clientRole
    ]);
    const handleEditEmail = ()=>{
        setEditingEmail(!editingEmail);
        setUserEmail({
            ...userEmail,
            value: client?.email || ""
        });
        setTimeout(()=>{
            if (emailRef.current) emailRef.current.focus();
        }, 100);
    };
    const handleSetUserEmail = (value)=>{
        setUserEmail({
            ...userEmail,
            value: value
        });
    };
    const handleSubmitNewEmail = async (e)=>{
        e.preventDefault();
        if (client && features?.sdaCustomerOnboardingActionsInitiate && userEmail.value !== client.email) {
            const url = updateEmailAddressLink(client);
            if (url) {
                setIsSubmitting(true);
                emailRef.current?.blur();
                try {
                    await (0, $kqXxS.customerActionService).makeCustomerAction(url, {
                        email: userEmail.value
                    });
                    setSuccessMsg(formatMessage("clientInformation.emailSuccess"));
                } catch (e) {
                    console.log("catch", e);
                } finally{
                    handleEditEmail();
                    setIsSubmitting(false);
                }
            }
        } else handleEditEmail();
    };
    const toggleKycDetails = ()=>{
        setViewKycDetails((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            !!successMsg && /*#__PURE__*/ (0, $4m918.jsxs)($1ccd4cb9623c086b$var$SuccessMsg, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)("img", {
                        src: {},
                        alt: ""
                    }),
                    successMsg,
                    /*#__PURE__*/ (0, $4m918.jsx)($1ccd4cb9623c086b$var$CloseButton, {
                        onClick: ()=>setSuccessMsg(null),
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $j26Ew.CloseIcon), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $8JW2B.PageBackLink), {
                onBack: ()=>push((0, $4fYE4.Path).ProfileMenu)
            }),
            (0, $gDlNU.isDefined)(client) && /*#__PURE__*/ (0, $4m918.jsxs)($1ccd4cb9623c086b$var$Panel, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($1ccd4cb9623c086b$var$PanelTitle, {
                        children: formatMessage("clientInformation.title")
                    }),
                    client.birthDate ? /*#__PURE__*/ (0, $4m918.jsx)((0, $04UNA.InformationSection), {
                        label: formatMessage("clientInformation.birthDateTitle"),
                        value: formatDate((0, $cNsCW.getLocaleDateFromUtcDateString)(client.birthDate), {
                            year: "numeric",
                            month: "long",
                            day: "2-digit"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $04UNA.InformationSection), {
                        label: formatMessage("clientInformation.birthPlaceTitle"),
                        value: client.birthPlace
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $04UNA.InformationSection), {
                        label: formatMessage("clientInformation.addressTitle"),
                        value: (0, $4lOZ3.formatAddress)(client.address)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $04UNA.InformationSection), {
                        label: formatMessage("clientInformation.phoneTitle"),
                        value: client.contactphone ? (0, $cL9IJ.parsePhoneNumberWithError)(`+${client.contactphone}`).formatInternational() : undefined,
                        isPhone: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $04UNA.InformationSection), {
                        label: formatMessage("clientInformation.emailTitle"),
                        value: client.email,
                        onEdit: canUpdateEmailAddress(client) && features?.sdaCustomerOnboardingActionsInitiate ? ()=>handleEditEmail() : undefined,
                        children: editingEmail ? /*#__PURE__*/ (0, $4m918.jsxs)($1ccd4cb9623c086b$var$EmailForm, {
                            $submitting: isSubmitting,
                            onSubmit: (e)=>canUpdateEmailAddress(client) ? handleSubmitNewEmail(e) : null,
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($1ccd4cb9623c086b$var$EmailFieldWrapper, {
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $16qxo.EmailField), {
                                        ref: emailRef,
                                        input: userEmail,
                                        onChange: handleSetUserEmail
                                    })
                                }),
                                /*#__PURE__*/ (0, $4m918.jsxs)($1ccd4cb9623c086b$var$StyledActionWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0, $4m918.jsx)($1ccd4cb9623c086b$var$CancelButton, {
                                            type: "button",
                                            size: "S",
                                            onClick: handleEditEmail,
                                            children: formatMessage("common.cancel")
                                        }),
                                        /*#__PURE__*/ (0, $4m918.jsx)($1ccd4cb9623c086b$var$SubmitButton, {
                                            disabled: isSubmitting,
                                            type: "submit",
                                            size: "S",
                                            children: formatMessage("common.validate")
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    }),
                    clientKyc && viewKycDetails && Object.keys(clientKyc).map((key)=>{
                        let value = clientKyc[key];
                        if ([
                            "gender",
                            "personal_gender"
                        ].includes(key)) value = formatMessage(`gender.${(0, $k4Ecv.getGenderByInt)(value)}`);
                        else if (typeof value === "boolean") value = String(value);
                        else if (typeof value === "object") value = value.label;
                        return /*#__PURE__*/ (0, $4m918.jsx)((0, $04UNA.InformationSection), {
                            label: kycLabels?.[key] || key,
                            value: value
                        }, key);
                    }),
                    clientRoleLoading && /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {}),
                    clientKyc && !(0, $k4Ecv.isObjectEmpty)(clientKyc) && /*#__PURE__*/ (0, $4m918.jsx)($1ccd4cb9623c086b$var$ViewMoreButton, {
                        type: "button",
                        onClick: (e)=>{
                            e.currentTarget.blur();
                            toggleKycDetails();
                        },
                        children: viewKycDetails ? formatMessage("clientInformation.viewLess") : formatMessage("clientInformation.viewMore")
                    })
                ]
            }),
            kycDocuments.length === 0 && kycDocumentsLoading && /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {}),
            kycDocuments.length > 0 && /*#__PURE__*/ (0, $4m918.jsxs)($1ccd4cb9623c086b$var$Panel, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($1ccd4cb9623c086b$var$PanelTitle, {
                        children: formatMessage("documents.title")
                    }),
                    kycDocumentsLoading && /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {
                        style: {
                            marginBottom: 10
                        }
                    }),
                    kycDocuments.map((document)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $OY7Ij.DownloadDocument), {
                            document: document
                        }, document.id))
                ]
            }),
            clientRoleError?.message && /*#__PURE__*/ (0, $4m918.jsx)((0, $jn1mK.ErrorMessage), {
                children: clientRoleError.message
            }),
            kycDocumentsError?.message && /*#__PURE__*/ (0, $4m918.jsx)((0, $jn1mK.ErrorMessage), {
                children: kycDocumentsError.message
            }),
            downloadKycError?.message && /*#__PURE__*/ (0, $4m918.jsx)((0, $jn1mK.ErrorMessage), {
                children: downloadKycError.message
            }),
            kycLabelsError?.message && /*#__PURE__*/ (0, $4m918.jsx)((0, $jn1mK.ErrorMessage), {
                children: kycLabelsError.message
            })
        ]
    });
};
/* One white surface holding the whole block, as the mockup draws it: a form the holder reads. */ const $1ccd4cb9623c086b$var$Panel = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-self: stretch;
  width: 100%;
  max-width: 560px;
  margin-top: 12px;
  margin-bottom: 20px;
  padding: 28px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 16px;
  background-color: #ffffff;
`;
const $1ccd4cb9623c086b$var$PanelTitle = (0, $jb8NR.default).h1`
  ${(0, $22v9q.theme).boldText};
  margin: 0;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $1ccd4cb9623c086b$var$EmailForm = (0, $jb8NR.default).form`
  display: flex;
  flex-direction: column;
  pointer-events: ${({ $submitting: $submitting })=>$submitting ? "none" : "auto"};
`;
/* The shared input keeps its own look everywhere else; the panel outlines it here. */ const $1ccd4cb9623c086b$var$EmailFieldWrapper = (0, $jb8NR.default).div`
  > div {
    width: 100%;
    border: 1px solid ${(0, $22v9q.theme).colors.gray[500]};
    border-radius: 8px;
    background-color: #ffffff;
  }

  input {
    ${(0, $22v9q.theme).text};
    font-size: 15px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }
`;
const $1ccd4cb9623c086b$var$StyledActionWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 12px;
  gap: 10px;
`;
const $1ccd4cb9623c086b$var$SubmitButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  padding: 8px 20px;
  box-shadow: none;
`;
const $1ccd4cb9623c086b$var$CancelButton = (0, $jb8NR.default)((0, $7Zu6k.WhitePrimaryButton))`
  padding: 8px 20px;
  border: 1px solid ${(0, $22v9q.theme).colors.blue[700]};
  box-shadow: none;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
const $1ccd4cb9623c086b$var$ViewMoreButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  ${(0, $22v9q.theme).text};
  align-self: flex-start;
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;
  color: ${(0, $22v9q.theme).colors.blue[700]};
`;
const $1ccd4cb9623c086b$var$SuccessMsg = (0, $jb8NR.default).div`
  display: flex;
  gap: 8px;
  align-items: center;
  align-self: stretch;
  max-width: 560px;
  margin-bottom: 20px;
  padding: 15px 20px;
  border-radius: 12px;
  background-color: ${(0, $22v9q.theme).colors.info[300]};
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.875rem;
  color: ${(0, $22v9q.theme).colors.info[500]};
`;
const $1ccd4cb9623c086b$var$CloseButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  margin-left: auto;
`;

});
parcelRegister("cL9IJ", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumberWithError", function () { return $94a16a206e602bb1$export$176bb591929cc9a8; });

var $bP4Vr = parcelRequire("bP4Vr");

var $l6EHW = parcelRequire("l6EHW");
function $94a16a206e602bb1$export$176bb591929cc9a8() {
    return (0, $bP4Vr.withMetadata)((0, $l6EHW.default), arguments);
}

});

parcelRegister("4lOZ3", function(module, exports) {

$parcel$export(module.exports, "formatAddress", function () { return $e5dd296be8e98319$export$9ab766ce7f4c1f3c; });

var $a5OyK = parcelRequire("a5OyK");

var $7NWoz = parcelRequire("7NWoz");
const $e5dd296be8e98319$export$9ab766ce7f4c1f3c = (address)=>{
    if (!address) return "";
    let country = address.country;
    if (country && (0, $7NWoz.hasKey)((0, $a5OyK.countries), country)) country = (0, $a5OyK.countries)[country].englishName;
    return [
        address.line1,
        address.line2,
        address.district,
        address.city,
        address.province,
        address.region,
        address.zipcode,
        country
    ].filter((x)=>typeof x === "string" && x.length > 0).join("\n");
};

});
parcelRegister("7NWoz", function(module, exports) {

$parcel$export(module.exports, "hasKey", function () { return $6f6e77528eeae5a4$export$94df19ecb868bc1a; });
const $6f6e77528eeae5a4$export$94df19ecb868bc1a = function(obj, key) {
    return key in obj;
};

});


parcelRegister("gXgQv", function(module, exports) {

$parcel$export(module.exports, "useClientLinks", function () { return $367b816edd0f603f$export$3a397a108d1f55e3; });

var $htyHe = parcelRequire("htyHe");
const $367b816edd0f603f$export$3a397a108d1f55e3 = ()=>{
    const canGetOnboardinFile = (client)=>{
        if (!client?.links) return false;
        return client.links.findIndex((link)=>link.rel === (0, $htyHe.ClientLinks).GetOngoingOnboardingFile) > -1;
    };
    const canUpdateEmailAddress = (client)=>{
        if (!client?.links) return false;
        return client.links.findIndex((link)=>link.rel === (0, $htyHe.ClientLinks).UpdateEmailAddress) > -1;
    };
    const updateEmailAddressLink = (client)=>{
        if (!client?.links) return "";
        const link = client.links.find((link)=>link.rel === (0, $htyHe.ClientLinks).UpdateEmailAddress);
        return link?.href || "";
    };
    return {
        updateEmailAddressLink: updateEmailAddressLink,
        canGetOnboardinFile: canGetOnboardinFile,
        canUpdateEmailAddress: canUpdateEmailAddress
    };
};

});
parcelRegister("htyHe", function(module, exports) {

$parcel$export(module.exports, "ClientLinks", function () { return $57596165edbee4b3$export$b69594276c41ae59; });
var $57596165edbee4b3$export$b69594276c41ae59 = /*#__PURE__*/ function(ClientLinks) {
    ClientLinks["GetOngoingOnboardingFile"] = "getOngoingOnboardingFile";
    ClientLinks["UpdateEmailAddress"] = "updateEmailAddress";
    return ClientLinks;
}({});

});


parcelRegister("5hf1X", function(module, exports) {

$parcel$export(module.exports, "KYC_EXCLUDES", function () { return $f15bb88e69cee767$export$7ef379db966ab1c; });
const $f15bb88e69cee767$export$7ef379db966ab1c = [
    "address",
    "contactphone",
    "country",
    "email",
    "firstName",
    "lastName"
];

});

parcelRegister("OY7Ij", function(module, exports) {

$parcel$export(module.exports, "DownloadDocument", function () { return $12ac08ad344dc5ed$export$e300206aaeb8f8cd; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $7RQw4 = parcelRequire("7RQw4");

var $k4kME = parcelRequire("k4kME");

var $4r738 = parcelRequire("4r738");

var $22v9q = parcelRequire("22v9q");
const $12ac08ad344dc5ed$export$e300206aaeb8f8cd = ({ document: document })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [isDownloading, setIsDownloading] = (0, $6uYXW.useState)(false);
    const handleDocumentDownload = async ()=>{
        setIsDownloading(true);
        try {
            await (0, $kqXxS.identityManager).downloadKycDocument(document.id);
        } finally{
            setIsDownloading(false);
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($12ac08ad344dc5ed$var$DownloadContainer, {
        children: [
            formatMessage(`documents.${[
                document.type
            ]}`),
            isDownloading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.Spinner), {}) : null,
            /*#__PURE__*/ (0, $4m918.jsx)($12ac08ad344dc5ed$var$DownloadIconContainer, {
                size: 34,
                onClick: handleDocumentDownload,
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $4r738.DownloadIcon), {})
            })
        ]
    });
};
const $12ac08ad344dc5ed$var$DownloadContainer = (0, $jb8NR.default).div`
  ${(0, $22v9q.shadows).medium};
  ${(0, $22v9q.theme).boldText};
  width: 100%;
  font-size: 0.9375rem;
  margin: 14px 0;
  padding: 10px 22px;
  border-radius: 13px;
  border: 0 none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
`;
const $12ac08ad344dc5ed$var$DownloadIconContainer = (0, $jb8NR.default)((0, $7RQw4.RoundedSquareButton))`
  background-color: #f4f4f4;
`;

});

parcelRegister("04UNA", function(module, exports) {

$parcel$export(module.exports, "InformationSection", function () { return $f26eb086d5bcd6a6$export$6ad34aa342b25021; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $gDlNU = parcelRequire("gDlNU");

var $yYT9n = parcelRequire("yYT9n");

var $bewhU = parcelRequire("bewhU");

var $7wSRt = parcelRequire("7wSRt");

var $22v9q = parcelRequire("22v9q");
const $f26eb086d5bcd6a6$export$6ad34aa342b25021 = (props)=>{
    const { children: children, label: label, value: value, isPhone: isPhone, onEdit: onEdit, ...rest } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    if (!(0, $gDlNU.isDefined)(value)) return null;
    return /*#__PURE__*/ (0, $4m918.jsxs)($f26eb086d5bcd6a6$var$InformationContainer, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($f26eb086d5bcd6a6$var$LabelRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($f26eb086d5bcd6a6$var$InformationLabel, {
                        children: label
                    }),
                    !!onEdit && /*#__PURE__*/ (0, $4m918.jsx)($f26eb086d5bcd6a6$var$EditButton, {
                        type: "button",
                        "aria-label": label,
                        onClick: onEdit,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7wSRt.PenIcon), {
                            width: 16,
                            height: 16,
                            fill: (0, $22v9q.theme).colors.blue[700]
                        })
                    })
                ]
            }),
            children ? children : /* What the holder may change reads in full; the rest is settled, and stays quiet. */ /*#__PURE__*/ (0, $4m918.jsx)($f26eb086d5bcd6a6$var$InformationValue, {
                $isRTL: isRTL,
                $isPhone: isPhone,
                $editable: !!onEdit,
                children: value
            })
        ]
    });
};
const $f26eb086d5bcd6a6$var$InformationContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $f26eb086d5bcd6a6$var$LabelRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
`;
const $f26eb086d5bcd6a6$var$InformationLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 14px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $f26eb086d5bcd6a6$var$EditButton = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  padding: 2px;
`;
const $f26eb086d5bcd6a6$var$InformationValue = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  padding: 12px 16px;
  border: 1px solid ${({ $editable: $editable })=>$editable ? (0, $22v9q.theme).colors.gray[500] : (0, $22v9q.theme).colors.gray[300]};
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 15px;
  line-height: 20px;
  text-align: ${(props)=>props.$isRTL ? "right" : "left"};
  color: ${({ $editable: $editable })=>$editable ? (0, $22v9q.theme).colors.blue[800] : (0, $22v9q.theme).colors.gray[500]};
  direction: ${(props)=>!props.$isPhone && props.$isRTL ? "rtl" : "ltr"};
  overflow-wrap: anywhere;
`;

});


parcelRegister("9TaaL", function(module, exports) {

$parcel$export(module.exports, "MySettingsScreen", function () { return $8f9c594d47649008$export$c16c26c498607652; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $bQhUC = parcelRequire("bQhUC");

var $4fYE4 = parcelRequire("4fYE4");

var $ckge6 = parcelRequire("ckge6");

var $fHb7G = parcelRequire("fHb7G");

var $izd7j = parcelRequire("izd7j");

var $39jSd = parcelRequire("39jSd");

var $5Wai4 = parcelRequire("5Wai4");

var $8JW2B = parcelRequire("8JW2B");

var $22v9q = parcelRequire("22v9q");

var $ahCyz = parcelRequire("ahCyz");

var $8HpZE = parcelRequire("8HpZE");
/* The select paints no border of its own; in a row it needs one to read as a field. */ const $8f9c594d47649008$var$LANGUAGE_SELECT_STYLE = {
    control: (provided)=>({
            ...provided,
            minHeight: "40px",
            border: `1px solid ${(0, $22v9q.theme).colors.gray[300]}`
        })
};
const $8f9c594d47649008$export$c16c26c498607652 = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { push: push } = (0, $NQIVp.useHistory)();
    const userLanguage = (0, $3Ersk.useObservable)((0, $kqXxS.i18NManager).localeTag);
    const configurationLanguages = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration).langs;
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $8JW2B.PageBackLink), {
                onBack: ()=>push((0, $4fYE4.Path).ProfileMenu)
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($8f9c594d47649008$var$Panel, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($8f9c594d47649008$var$PanelTitle, {
                        children: formatMessage("settings.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)((0, $izd7j.ActionRowList), {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                                label: formatMessage("settings.changePincodeTitle"),
                                subtitle: formatMessage("settings.changePincodeDescription"),
                                onClick: ()=>(0, $5Wai4.Modal).present((0, $bQhUC.PINCODE_MUST_BE_CHANGED_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $ahCyz.PincodeChangeModal), {
                                            type: "skip-explanation"
                                        }), {
                                        canBeDismissed: false
                                    })
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)($8f9c594d47649008$var$LanguageRow, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsxs)($8f9c594d47649008$var$Texts, {
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)($8f9c594d47649008$var$RowLabel, {
                                                children: formatMessage("settings.changeLanguageTitle")
                                            }),
                                            /*#__PURE__*/ (0, $4m918.jsx)($8f9c594d47649008$var$RowSubtitle, {
                                                children: formatMessage("settings.changeLanguageDescription")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($8f9c594d47649008$var$LanguageSelect, {
                                        value: userLanguage,
                                        innerId: "language",
                                        withPointer: true,
                                        options: configurationLanguages,
                                        itemRenderer: (0, $fHb7G.getLanguageName),
                                        selectStyle: $8f9c594d47649008$var$LANGUAGE_SELECT_STYLE,
                                        onChange: (language)=>(0, $ckge6.changeLanguage)(language)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                                label: formatMessage("settings.accountDeleteTitle"),
                                subtitle: formatMessage("settings.accountDeleteDescription"),
                                onClick: ()=>{
                                    (0, $5Wai4.Modal).present((0, $bQhUC.ACCOUNT_DELETE_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $8HpZE.AccountDeleteModal), {}), {
                                        canBeDismissed: false
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* One white surface holding the list, as the mockup draws it. */ const $8f9c594d47649008$var$Panel = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-self: stretch;
  width: 100%;
  max-width: 560px;
  margin-top: 12px;
  margin-bottom: 20px;
  padding: 28px;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 16px;
  background-color: #ffffff;
`;
const $8f9c594d47649008$var$PanelTitle = (0, $jb8NR.default).h1`
  ${(0, $22v9q.theme).boldText};
  margin: 0;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $8f9c594d47649008$var$LanguageRow = (0, $jb8NR.default).div`
  ${(0, $izd7j.actionRowStyle)};
  cursor: default;

  &:hover {
    background-color: transparent;
  }
`;
const $8f9c594d47649008$var$Texts = (0, $jb8NR.default).span`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const $8f9c594d47649008$var$RowLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 16px;
  line-height: 22px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $8f9c594d47649008$var$RowSubtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 2px;
  font-size: 12px;
  line-height: 15px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $8f9c594d47649008$var$LanguageSelect = (0, $jb8NR.default)((0, $39jSd.SelectInput))`
  flex-shrink: 0;
  width: 140px;
`;

});
parcelRegister("8HpZE", function(module, exports) {

$parcel$export(module.exports, "AccountDeleteModal", function () { return $a411a42ac76b5e6b$export$6bad5aa6bb3d0e8a; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $bQhUC = parcelRequire("bQhUC");

var $bewhU = parcelRequire("bewhU");

var $7Zu6k = parcelRequire("7Zu6k");

var $7QebT = parcelRequire("7QebT");

var $5Wai4 = parcelRequire("5Wai4");

var $7xALQ = parcelRequire("7xALQ");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $ixBnh = parcelRequire("ixBnh");

var $ahCyz = parcelRequire("ahCyz");

var $9IUae = parcelRequire("9IUae");
var $a411a42ac76b5e6b$var$DeletionStep = /*#__PURE__*/ function(DeletionStep) {
    DeletionStep[DeletionStep["Warning"] = 0] = "Warning";
    DeletionStep[DeletionStep["Confirm"] = 1] = "Confirm";
    return DeletionStep;
}($a411a42ac76b5e6b$var$DeletionStep || {});
const $a411a42ac76b5e6b$var$ModalContent = ({ step: step, formatMessage: formatMessage, goToContact: goToContact, dismissModal: dismissModal, setStep: setStep, reason: reason, setReason: setReason, handleDeleteAccount: handleDeleteAccount, feedback: feedback })=>{
    if (step === 0) return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$Title, {
                children: formatMessage("accountDeleteScreen.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$Subtitle, {
                children: formatMessage("accountDeleteScreen.subtitle")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($a411a42ac76b5e6b$var$OptionsList, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9IUae.OptionCard), {
                        title: formatMessage("accountDeleteScreen.options.changeProfile.title"),
                        subtitle: formatMessage("accountDeleteScreen.options.changeProfile.description"),
                        onClick: ()=>{
                            dismissModal();
                            (0, $5Wai4.Modal).present((0, $bQhUC.PINCODE_MUST_BE_CHANGED_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $ahCyz.PincodeChangeModal), {
                                    type: "skip-explanation"
                                }), {
                                canBeDismissed: false
                            });
                        },
                        children: /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$OptionIllustration, {
                            src: (0, $fRvTz.StaticAssets).settingsPincode,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9IUae.OptionCard), {
                        title: formatMessage("accountDeleteScreen.options.unHappy.title"),
                        subtitle: formatMessage("accountDeleteScreen.options.unHappy.description"),
                        onClick: goToContact,
                        children: /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$OptionIllustration, {
                            src: (0, $fRvTz.StaticAssets).settingsTalk,
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$DeleteLink, {
                type: "button",
                onClick: ()=>setStep(1),
                children: formatMessage("accountDeleteScreen.button")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$Explanation, {
                children: formatMessage("accountDeleteScreen.explanation")
            })
        ]
    });
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$StyledTitle, {
                children: formatMessage("accountDeleteScreen.confirm.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$ReasonField, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7QebT.TextField), {
                    input: reason,
                    placeholder: formatMessage("accountDeleteScreen.confirm.placeholder"),
                    onChange: (e)=>setReason({
                            ...reason,
                            value: e
                        }),
                    multiline: true
                })
            }),
            feedback.success || feedback.error ? /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$Feedback, {
                $failed: !feedback.success,
                children: feedback.success || feedback.error
            }) : /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$StyledSubtitle, {
                        children: formatMessage("accountDeleteScreen.confirm.subtitle")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$Warning, {
                        children: formatMessage("accountDeleteScreen.confirm.warning")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$StyledPrimaryButton, {
                size: "S",
                onClick: handleDeleteAccount,
                disabled: !reason.value,
                children: formatMessage("accountDeleteScreen.confirm.button")
            })
        ]
    });
};
const $a411a42ac76b5e6b$export$6bad5aa6bb3d0e8a = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const dismissModal = ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.ACCOUNT_DELETE_MODAL_ID));
    const [step, setStep] = (0, $6uYXW.useState)(0);
    const [feedback, setFeedback] = (0, $6uYXW.useState)({
        success: "",
        error: ""
    });
    const [reason, setReason] = (0, $6uYXW.useState)({
        id: "reason",
        value: ""
    });
    const goToContact = (0, $6uYXW.useCallback)(()=>{
        dismissModal();
        (0, $5Wai4.Modal).present((0, $bQhUC.CONTACT_SUPPORT_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $ixBnh.ContactSupportModal), {
                title: formatMessage("contactSupport.notHappyTitle"),
                subtitle: formatMessage("contactSupport.notHappyMessage")
            }), {
            canBeDismissed: true
        });
    }, [
        formatMessage
    ]);
    const handleDeleteAccount = (0, $6uYXW.useCallback)(()=>{
        const session = (0, $kqXxS.authenticationManager).session.get();
        setFeedback({
            success: "",
            error: ""
        });
        if (session.clientId && reason.value) (0, $kqXxS.accountDeleteService).deleteAccount(session.clientId, reason.value).then(()=>{
            setFeedback({
                success: formatMessage("accountDeleteScreen.confirm.success"),
                error: ""
            });
        }).catch((err)=>{
            setFeedback({
                success: "",
                error: err.message || "An error occurred"
            });
        });
    }, [
        reason,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$ModalContainer, {
        closeButton: true,
        id: (0, $bQhUC.ACCOUNT_DELETE_MODAL_ID),
        className: "delete-account-modal-container",
        children: /*#__PURE__*/ (0, $4m918.jsx)($a411a42ac76b5e6b$var$ModalContent, {
            step: step,
            formatMessage: formatMessage,
            goToContact: goToContact,
            dismissModal: dismissModal,
            setStep: setStep,
            reason: reason,
            setReason: setReason,
            handleDeleteAccount: handleDeleteAccount,
            feedback: feedback
        })
    });
};
const $a411a42ac76b5e6b$var$ModalContainer = (0, $jb8NR.default)((0, $7xALQ.WhiteModalContainer))`
  &.delete-account-modal-container {
    margin-top: 5vh;
  }

  display: flex;
  flex-direction: column;
  padding: 56px 28px 28px;
  min-width: 400px;
`;
const $a411a42ac76b5e6b$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText};
  margin: 0 0 8px;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $a411a42ac76b5e6b$var$Subtitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  margin: 0 0 20px;
  font-size: 15px;
  line-height: 20px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $a411a42ac76b5e6b$var$Warning = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText};
  margin: 8px 0 16px;
  font-size: 15px;
  line-height: 20px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
/* The way through reads as a link, not as a button: it is the outcome nobody should fall into. */ const $a411a42ac76b5e6b$var$DeleteLink = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  ${(0, $22v9q.theme).mediumText};
  align-self: flex-start;
  margin-top: 20px;
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;
  color: #741537;
`;
const $a411a42ac76b5e6b$var$Explanation = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  margin-top: 12px;
  font-size: 13px;
  line-height: 18px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $a411a42ac76b5e6b$var$OptionIllustration = (0, $jb8NR.default).img`
  width: 40px;
  height: 40px;
`;
const $a411a42ac76b5e6b$var$OptionsList = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  border-radius: 12px;
`;
/* The shared field brings its own padded box; only the outline and the full width are missing. */ const $a411a42ac76b5e6b$var$ReasonField = (0, $jb8NR.default).div`
  margin-bottom: 24px;

  > div {
    width: 100%;
    align-items: flex-start;
    border: 1px solid ${(0, $22v9q.theme).colors.gray[300]};
    border-radius: 8px;
  }

  textarea {
    width: 100%;
    min-height: 96px;
    resize: vertical;
    ${(0, $22v9q.theme).text};
    font-size: 15px;
    line-height: 20px;
    color: ${(0, $22v9q.theme).colors.blue[800]};
  }
`;
const $a411a42ac76b5e6b$var$Feedback = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  margin-top: 8px;
  font-size: 15px;
  line-height: 20px;
  color: ${({ $failed: $failed })=>$failed ? (0, $22v9q.theme).colors.error[500] : (0, $22v9q.theme).colors.success[500]};
`;
/* The modal's frame is not the box holding the content, so the width is set on the button. */ const $a411a42ac76b5e6b$var$StyledPrimaryButton = (0, $jb8NR.default)((0, $7Zu6k.BluePrimaryButton))`
  width: 100%;
  margin-top: 24px;
  padding: 13px;
  box-shadow: none;
`;
const $a411a42ac76b5e6b$var$StyledSubtitle = (0, $jb8NR.default)($a411a42ac76b5e6b$var$Subtitle)`
  margin-bottom: 8px;
`;
const $a411a42ac76b5e6b$var$StyledTitle = (0, $jb8NR.default)($a411a42ac76b5e6b$var$Title)`
  margin-bottom: 20px;
`;

});
parcelRegister("9IUae", function(module, exports) {

$parcel$export(module.exports, "OptionCard", function () { return $5cdf16baadb9b204$export$57787c74aad1300f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $51d3M = parcelRequire("51d3M");

var $22v9q = parcelRequire("22v9q");
function $5cdf16baadb9b204$export$57787c74aad1300f(props) {
    const { title: title, subtitle: subtitle, onClick: onClick, children: children } = props;
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($5cdf16baadb9b204$var$Card, {
        type: "button",
        $isRTL: isRTL,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($5cdf16baadb9b204$var$IconContainer, {
                children: children
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($5cdf16baadb9b204$var$MainContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($5cdf16baadb9b204$var$Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($5cdf16baadb9b204$var$Subtitle, {
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($5cdf16baadb9b204$var$ChevronContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $51d3M.ChevronIcon), {
                    width: "14",
                    height: "14",
                    fill: (0, $22v9q.theme).colors.blue[800],
                    style: {
                        transform: isRTL ? "rotate(180deg)" : "rotate(0deg)"
                    }
                })
            })
        ]
    });
}
/* One row of the list, not a card of its own: the list around them carries the chrome. */ const $5cdf16baadb9b204$var$Card = (0, $jb8NR.default).button`
  width: 100%;
  border: 0;
  font: inherit;
  text-align: inherit;
  color: inherit;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid ${(0, $22v9q.theme).colors.gray[100]};
  background-color: #ffffff;

  &:first-of-type {
    border-top: 0;
  }

  &:hover {
    cursor: pointer;
    background-color: ${(0, $22v9q.theme).colors.gray[50]};
  }
`;
const $5cdf16baadb9b204$var$IconContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  object-fit: contain;
`;
const $5cdf16baadb9b204$var$MainContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 16px;
`;
const $5cdf16baadb9b204$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  font-size: 16px;
  line-height: 22px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $5cdf16baadb9b204$var$Subtitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  margin-top: 2px;
  font-size: 12px;
  line-height: 15px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $5cdf16baadb9b204$var$ChevronContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-shrink: 0;
`;

});



parcelRegister("eVOlS", function(module, exports) {

$parcel$export(module.exports, "ProfileMenuScreen", function () { return $34b2f0bfffaf841f$export$6b508ccac4089899; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $4fYE4 = parcelRequire("4fYE4");

var $izd7j = parcelRequire("izd7j");

var $1VCpi = parcelRequire("1VCpi");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");
function $34b2f0bfffaf841f$export$6b508ccac4089899() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { push: push } = (0, $NQIVp.useHistory)();
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)((0, $1VCpi.PageHeaderBand), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderTitle), {
                        children: formatMessage("profileMenu.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderSubtitle), {
                        children: formatMessage("profileMenu.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($34b2f0bfffaf841f$var$SectionTitle, {
                children: formatMessage("profileMenu.generalSection")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)((0, $izd7j.ActionRowList), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                        iconSrc: (0, $fRvTz.StaticAssets).profileProfile,
                        label: formatMessage("profileMenu.profileTitle"),
                        subtitle: formatMessage("profileMenu.profileSubtitle"),
                        onClick: ()=>push((0, $4fYE4.Path).Profile)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $izd7j.ActionRow), {
                        iconSrc: (0, $fRvTz.StaticAssets).profileSettings,
                        label: formatMessage("profileMenu.settingsTitle"),
                        subtitle: formatMessage("profileMenu.settingsSubtitle"),
                        onClick: ()=>push((0, $4fYE4.Path).Settings)
                    })
                ]
            })
        ]
    });
}
const $34b2f0bfffaf841f$var$SectionTitle = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).mediumText};
  margin: 0 0 12px;
  font-size: 20px;
  line-height: 26px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;

});

parcelRegister("fy9od", function(module, exports) {

$parcel$export(module.exports, "TransactionCodesScreen", function () { return $b8762587ce135f9f$export$58e6e66986f6f2a3; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $yYT9n = parcelRequire("yYT9n");

var $kvf6T = parcelRequire("kvf6T");

var $4nDe7 = parcelRequire("4nDe7");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $jEKif = parcelRequire("jEKif");

var $7XqbX = parcelRequire("7XqbX");

var $i04qV = parcelRequire("i04qV");

var $lQ83Z = parcelRequire("lQ83Z");

var $4RAh5 = parcelRequire("4RAh5");

var $7qiiL = parcelRequire("7qiiL");
function $b8762587ce135f9f$export$58e6e66986f6f2a3() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { transactionCodes: transactionCodes, loading: loading } = (0, $kvf6T.useTransactionCodes)();
    const newTransactionCode = ()=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.TRANSACTION_CODE_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $7qiiL.TransactionCodeModal), {}), {
            canBeDismissed: false
        });
    };
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($b8762587ce135f9f$var$Section, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($b8762587ce135f9f$var$ScreenHeader, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($b8762587ce135f9f$var$ScreenTitleAndSubtitle, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $jEKif.PageSectionTitle), {
                                children: formatMessage("transactionCode.title")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $jEKif.PageSectionDescription), {
                                children: formatMessage("transactionCode.description")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($b8762587ce135f9f$var$NewCodeButton, {
                        onClick: newTransactionCode,
                        size: "S",
                        children: formatMessage("transactionCode.newCodeButton")
                    })
                ]
            }),
            !loading && transactionCodes.length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)((0, $lQ83Z.EmptyBlock), {
                title: formatMessage("transactionCode.noCodeAvailable"),
                message: formatMessage("transactionCode.noCodeAvailableExplanation")
            }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $4nDe7.AccountListGrid), {
                children: loading ? /*#__PURE__*/ (0, $4m918.jsx)((0, $i04qV.SkeletonAccountTile), {
                    $isRTL: isRTL
                }) : transactionCodes.map((code)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4RAh5.TransactionCodeCard), {
                        transactionCode: code
                    }, code.date))
            })
        ]
    });
}
const $b8762587ce135f9f$var$Section = (0, $jb8NR.default).section`
  display: flex;
  align-self: stretch;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: flex-start;
`;
const $b8762587ce135f9f$var$ScreenHeader = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    flex-direction: column;
    align-items: center;
  }
`;
const $b8762587ce135f9f$var$ScreenTitleAndSubtitle = (0, $jb8NR.default).div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
`;
const $b8762587ce135f9f$var$NewCodeButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  flex: 0 0 auto;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    margin-top: 20px;
  }
`;

});
parcelRegister("kvf6T", function(module, exports) {

$parcel$export(module.exports, "useTransactionCodes", function () { return $7d515a6629bb6f74$export$462b0bfc43bf85b2; });

var $6uYXW = parcelRequire("6uYXW");

var $6JVVB = parcelRequire("6JVVB");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $k4Ecv = parcelRequire("k4Ecv");
const $7d515a6629bb6f74$export$462b0bfc43bf85b2 = ()=>{
    const transactionCodes = (0, $3Ersk.useObservable)((0, $kqXxS.transactionCodeManager).transactionCodes);
    const [loading, setLoading] = (0, $6uYXW.useState)(true);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        try {
            setLoading(true);
            await (0, $kqXxS.transactionCodeManager).refresh();
        } catch (e) {
            (0, $6JVVB.logger).debug("client fetch error", e);
        } finally{
            setLoading(false);
        }
    }, [
        (0, $kqXxS.transactionCodeManager)
    ]);
    return {
        transactionCodes: transactionCodes,
        loading: loading
    };
};

});

parcelRegister("4RAh5", function(module, exports) {

$parcel$export(module.exports, "TransactionCodeCard", function () { return $6b3e6418d80b5ca6$export$f1f6a74cf9b4d2c0; });

var $4m918 = parcelRequire("4m918");

var $4wvTY = parcelRequire("4wvTY");

var $6uYXW = parcelRequire("6uYXW");

var $gL91i = parcelRequire("gL91i");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $cNi7u = parcelRequire("cNi7u");

var $05ceX = parcelRequire("05ceX");

var $9jdzG = parcelRequire("9jdzG");

var $bZlaH = parcelRequire("bZlaH");

var $7RQw4 = parcelRequire("7RQw4");

var $dX3Vc = parcelRequire("dX3Vc");

var $boqCQ = parcelRequire("boqCQ");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $6b3e6418d80b5ca6$export$f1f6a74cf9b4d2c0 = (props)=>{
    const { transactionCode: transactionCode } = props;
    const countdown = (0, $cNi7u.useCountdown)(transactionCode.date);
    const isTransactionExpired = new Date(transactionCode.date) <= new Date();
    const { elementRef: elementRef, showTooltip: showTooltip } = (0, $9jdzG.useTooltip)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [uid] = (0, $6uYXW.useState)((0, $05ceX.getRandomID)());
    const copyToClipboard = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($4wvTY)))(transactionCode.code);
        showTooltip();
    };
    return isTransactionExpired ? null : /*#__PURE__*/ (0, $4m918.jsxs)($6b3e6418d80b5ca6$var$Card, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($6b3e6418d80b5ca6$var$TopRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)($6b3e6418d80b5ca6$var$TransactionCodeDetailContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($6b3e6418d80b5ca6$var$Code, {
                                children: transactionCode.code
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($6b3e6418d80b5ca6$var$AcceptorName, {
                                children: transactionCode.acceptor?.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($6b3e6418d80b5ca6$var$CopyCode, {
                        "data-for": uid,
                        ref: elementRef,
                        size: 36,
                        "data-tip": formatMessage("accountDetails.clipboard", {
                            name: formatMessage("transactionCode.codeTooltip")
                        }),
                        onClick: copyToClipboard,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $dX3Vc.CopyToClipboardIcon), {})
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $gL91i.default), {
                        id: uid,
                        place: "top",
                        type: "dark",
                        effect: "solid",
                        event: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($6b3e6418d80b5ca6$var$BottomRow, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($6b3e6418d80b5ca6$var$Amount, {
                        amount: transactionCode.amount
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($6b3e6418d80b5ca6$var$ExpirationContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($6b3e6418d80b5ca6$var$StyledExpirationIcon, {}),
                            /*#__PURE__*/ (0, $4m918.jsxs)($6b3e6418d80b5ca6$var$ExpirationValueContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)($6b3e6418d80b5ca6$var$HiddenExpirationValue, {
                                        children: "00:00:00"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)($6b3e6418d80b5ca6$var$ExpirationValue, {
                                        children: countdown
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $6b3e6418d80b5ca6$var$Card = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_NOT_MOBILE}px;
  min-height: 188px;
  padding: 30px;
  border-radius: 13px;
  ${(0, $22v9q.shadows).medium};
  background-color: #ffffff;
  color: #000000;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_MOBILE}px;
    padding: 15px;
    min-height: 158px;
  }
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT - 1}px) {
    width: ${(0, $7XqbX.UIConstants).ACCOUNT_TILE_WIDTH_MOBILE}px;
  }
`;
const $6b3e6418d80b5ca6$var$TopRow = (0, $jb8NR.default).div`
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
`;
const $6b3e6418d80b5ca6$var$TransactionCodeDetailContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $6b3e6418d80b5ca6$var$Code = (0, $jb8NR.default).span`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).mediumText};
  color: #000000;
`;
const $6b3e6418d80b5ca6$var$AcceptorName = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 1.125rem;
  color: #b1b1b1;
`;
const $6b3e6418d80b5ca6$var$CopyCode = (0, $jb8NR.default)((0, $7RQw4.RoundedSquareButton))`
  background-color: #f4f4f4;
  border-radius: 12px;
`;
const $6b3e6418d80b5ca6$var$BottomRow = (0, $jb8NR.default).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const $6b3e6418d80b5ca6$var$Amount = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
  color: #000000;
`;
const $6b3e6418d80b5ca6$var$ExpirationContainer = (0, $jb8NR.default).div`
  display: flex;
  position: relative;
  align-items: center;
  background-color: #ececec;
  height: 28px;
  border-radius: 25px;
  padding: 4px 12px;
`;
const $6b3e6418d80b5ca6$var$ExpirationValueContainer = (0, $jb8NR.default).div`
  display: flex;
  position: relative;
  align-items: center;
`;
const $6b3e6418d80b5ca6$var$StyledExpirationIcon = (0, $jb8NR.default)((0, $boqCQ.ExpirationIcon))`
  margin-right: 4px;
`;
const $6b3e6418d80b5ca6$var$ExpirationValue = (0, $jb8NR.default).span`
  position: absolute;
  font-size: 1.125rem;
  ${(0, $22v9q.theme).mediumText};
  color: #000000;
  left: 0;
`;
const $6b3e6418d80b5ca6$var$HiddenExpirationValue = (0, $jb8NR.default).div`
  font-size: 1.125rem;
  visibility: hidden;
  left: 0;
`;

});
parcelRegister("cNi7u", function(module, exports) {

$parcel$export(module.exports, "useCountdown", function () { return $b51dd88c10c7bdee$export$8103f7eb37e19f7b; });

var $l1qT9 = parcelRequire("l1qT9");

var $6uYXW = parcelRequire("6uYXW");
function $b51dd88c10c7bdee$var$addZeroIfNeeded(n) {
    return n > 9 ? "" + n : "0" + n;
}
function $b51dd88c10c7bdee$export$8103f7eb37e19f7b(date) {
    const getValue = (0, $6uYXW.useCallback)(()=>{
        const expirationDate = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))(date);
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9)))();
        const duration = (0, (/*@__PURE__*/$parcel$interopDefault($l1qT9))).duration(expirationDate.diff(now));
        if (duration.milliseconds() < 0) return "00:00:00";
        return `${$b51dd88c10c7bdee$var$addZeroIfNeeded(duration.get("hours"))}:${$b51dd88c10c7bdee$var$addZeroIfNeeded(duration.get("minutes"))}:${$b51dd88c10c7bdee$var$addZeroIfNeeded(duration.get("seconds"))}`;
    }, [
        date
    ]);
    const [value, setValue] = (0, $6uYXW.useState)(getValue());
    (0, $6uYXW.useEffect)(()=>{
        const interval = setInterval(()=>setValue(getValue()), 1000);
        return ()=>clearInterval(interval);
    }, [
        date,
        getValue
    ]);
    return value;
}

});

parcelRegister("dX3Vc", function(module, exports) {

$parcel$export(module.exports, "CopyToClipboardIcon", function () { return $1b4ef44858ddf027$export$a5ed7a595a689f33; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $1b4ef44858ddf027$export$a5ed7a595a689f33 = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)("g", {
            fill: "#B1B1B1",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M8.91 17.578h5.418c1.283 0 2.323-1.09 2.323-2.433V8.039c1.005.051 1.549.669 1.549 1.765v7.627c0 1.147-.594 1.769-1.69 1.769h-5.913c-1.048 0-1.637-.57-1.687-1.622z"
                }),
                /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M7.59 4.9h5.913c1.096 0 1.69.622 1.69 1.77v7.626c0 1.147-.594 1.77-1.69 1.77H7.59c-1.096 0-1.69-.623-1.69-1.77V6.669c0-1.147.594-1.769 1.69-1.769z"
                })
            ]
        })
    });

});


parcelRegister("7qiiL", function(module, exports) {

$parcel$export(module.exports, "TransactionCodeModal", function () { return $45e34feb1034efb8$export$4cf9b0e0a9a14e1b; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $1YFGv = parcelRequire("1YFGv");

var $bQhUC = parcelRequire("bQhUC");

var $40sjz = parcelRequire("40sjz");

var $3s3Wf = parcelRequire("3s3Wf");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $1Zouu = parcelRequire("1Zouu");

var $44Ybm = parcelRequire("44Ybm");

var $4DUM5 = parcelRequire("4DUM5");

var $aRQe7 = parcelRequire("aRQe7");
const $45e34feb1034efb8$var$loadingStates = [
    (0, $3s3Wf.TransactionCodeState).Confirmation
];
const $45e34feb1034efb8$export$4cf9b0e0a9a14e1b = ()=>{
    const { state: state, context: context, selectAcceptorId: selectAcceptorId, goBack: goBack, selectAmount: selectAmount, submitPincode: submitPincode } = (0, $3s3Wf.useTransactionCodeMachine)();
    const errorMessage = !(0, $1YFGv.isAccountBlocked)(context.error) ? context.error : undefined;
    const renderInnerStep = ()=>{
        switch(state){
            case (0, $3s3Wf.TransactionCodeState).EnterAcceptorId:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $1Zouu.SelectAcceptor), {
                    selectMethod: selectAcceptorId
                });
            case (0, $3s3Wf.TransactionCodeState).SelectingAmount:
            case (0, $40sjz.PincodeState).PincodeConfirmation:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $44Ybm.SelectAmountLimit), {
                    acceptorId: context.acceptorIdShortCode,
                    backMethod: goBack,
                    selectMethod: selectAmount,
                    loading: state in $45e34feb1034efb8$var$loadingStates
                });
            case (0, $3s3Wf.TransactionCodeState).Confirmation:
            case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
            case (0, $40sjz.PincodeState).PromptingKeyboard:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $4DUM5.TransactionCodePincode), {
                    keyboard: context.keyboard,
                    backMethod: goBack,
                    submitMethod: submitPincode,
                    errorMessage: errorMessage,
                    loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError
                });
            case (0, $3s3Wf.TransactionCodeState).Done:
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $aRQe7.TransactionCodeSummary), {
                    transactionCode: context.transactionResult,
                    onDone: ()=>(0, $5Wai4.Modal).dismiss((0, $bQhUC.TRANSACTION_CODE_ID))
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.TRANSACTION_CODE_ID),
        children: renderInnerStep()
    });
};

});
parcelRegister("3s3Wf", function(module, exports) {

$parcel$export(module.exports, "useTransactionCodeMachine", function () { return $26fc2c1406627910$export$68a6497a72720971; });
$parcel$export(module.exports, "TransactionCodeState", function () { return $26fc2c1406627910$export$11d563889b54f217; });

var $lCuQx = parcelRequire("lCuQx");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");

var $40sjz = parcelRequire("40sjz");
const $26fc2c1406627910$export$68a6497a72720971 = ()=>{
    const [state, sendEvent] = (0, $lCuQx.useMachine)($26fc2c1406627910$export$3be610d44899184e);
    const selectAcceptorId = (acceptorIdShortCode)=>{
        sendEvent("SELECT_ACCEPTOR_ID", {
            acceptorIdShortCode: acceptorIdShortCode
        });
    };
    const goBack = ()=>{
        sendEvent("GO_BACK");
    };
    const selectAmount = (amount)=>{
        sendEvent("SELECT_AMOUNT", {
            amount: amount
        });
    };
    const submitPincode = (submission)=>{
        sendEvent("SUBMIT_PINCODE", {
            pincodeSubmission: submission
        });
    };
    return {
        state: state.value,
        context: state.context,
        selectAcceptorId: selectAcceptorId,
        goBack: goBack,
        selectAmount: selectAmount,
        submitPincode: submitPincode
    };
};
var $26fc2c1406627910$export$11d563889b54f217 = /*#__PURE__*/ function(TransactionCodeState) {
    TransactionCodeState["EnterAcceptorId"] = "EnterAcceptorId";
    TransactionCodeState["SelectingAmount"] = "SelectingAmount";
    TransactionCodeState["Confirmation"] = "Confirmation";
    TransactionCodeState["Done"] = "Done";
    return TransactionCodeState;
}({});
var $26fc2c1406627910$var$TransactionCodeInvokeName = /*#__PURE__*/ function(TransactionCodeInvokeName) {
    TransactionCodeInvokeName["FetchKeyboard"] = "FetchKeyboard";
    TransactionCodeInvokeName["ConfirmNewcode"] = "ConfirmNewcode";
    return TransactionCodeInvokeName;
}($26fc2c1406627910$var$TransactionCodeInvokeName || {});
const $26fc2c1406627910$export$3be610d44899184e = (0, $TAle5.Machine)({
    id: "transaction-code",
    initial: "EnterAcceptorId",
    states: {
        ["EnterAcceptorId"]: {
            on: {
                SELECT_ACCEPTOR_ID: {
                    target: "SelectingAmount",
                    actions: [
                        (0, $c8ePo.assign)({
                            acceptorIdShortCode: (_, event)=>event.acceptorIdShortCode
                        })
                    ]
                }
            }
        },
        ["SelectingAmount"]: {
            on: {
                SELECT_AMOUNT: {
                    target: (0, $40sjz.PincodeState).PincodeConfirmation,
                    actions: [
                        (0, $c8ePo.assign)({
                            amount: (_, event)=>event.amount
                        })
                    ]
                },
                GO_BACK: {
                    target: "EnterAcceptorId"
                }
            }
        },
        [(0, $40sjz.PincodeState).PincodeConfirmation]: {
            entry: (0, $c8ePo.assign)({
                error: undefined
            }),
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboard]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "Confirmation",
                    actions: (0, $c8ePo.assign)({
                        pincodeSubmission: (_, event)=>event.pincodeSubmission
                    })
                },
                GO_BACK: {
                    target: "SelectingAmount"
                }
            }
        },
        ["Confirmation"]: {
            invoke: {
                id: "ConfirmNewcode",
                src: (context)=>(0, $kqXxS.transactionCodeManager).createTransactionCode(context.amount, context.acceptorIdShortCode, context.pincodeSubmission),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionResult: (_, event)=>event.data,
                            error: undefined
                        }),
                        (0, $c8ePo.send)({
                            type: "TRANSACTION_CODE_CREATED"
                        })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "TRANSACTION_CODE_ERROR"
                        })
                    ]
                }
            },
            on: {
                TRANSACTION_CODE_CREATED: "Done",
                TRANSACTION_CODE_ERROR: (0, $40sjz.PincodeState).FetchKeyboardAfterError
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
            invoke: {
                id: "FetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        ["Done"]: {
            type: "final"
        }
    }
});

});

parcelRegister("1Zouu", function(module, exports) {

$parcel$export(module.exports, "SelectAcceptor", function () { return $f7ac366be1c97476$export$8924e1d6702fbc35; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $7Zu6k = parcelRequire("7Zu6k");

var $8L45G = parcelRequire("8L45G");

var $8QUik = parcelRequire("8QUik");

var $22v9q = parcelRequire("22v9q");
const $f7ac366be1c97476$var$ACCEPTOR_ID_LENGTH = 6;
const $f7ac366be1c97476$export$8924e1d6702fbc35 = (props)=>{
    const { className: className, selectMethod: selectMethod } = props;
    const [acceptorId, setAcceptorId] = (0, $6uYXW.useState)("");
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($f7ac366be1c97476$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($f7ac366be1c97476$var$AcceptorTitle, {
                children: formatMessage("transactionCode.selectAcceptor.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f7ac366be1c97476$var$IllustrationContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $8QUik.GBRDots), {
                    style: {
                        alignSelf: "center"
                    }
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f7ac366be1c97476$var$AcceptorDescription, {
                children: formatMessage("transactionCode.selectAcceptor.description")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $8L45G.OtpInput), {
                length: $f7ac366be1c97476$var$ACCEPTOR_ID_LENGTH,
                onOtpChange: setAcceptorId
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($f7ac366be1c97476$var$NextButton, {
                size: "M",
                disabled: acceptorId.length < $f7ac366be1c97476$var$ACCEPTOR_ID_LENGTH,
                onClick: ()=>selectMethod(acceptorId),
                children: formatMessage("transactionCode.selectAcceptor.next")
            })
        ]
    });
};
const $f7ac366be1c97476$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;
const $f7ac366be1c97476$var$AcceptorTitle = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  color: #000000;
  margin-top: 50px;
  margin-bottom: 45px;
`;
const $f7ac366be1c97476$var$AcceptorDescription = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.8125rem;
  color: #000000;
  margin-top: 45px;
  margin-bottom: 45px;
`;
const $f7ac366be1c97476$var$NextButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 63px;
  margin-bottom: 40px;
`;
const $f7ac366be1c97476$var$IllustrationContainer = (0, $jb8NR.default).div`
  display: flex;
  width: 95px;
  height: 35px;
`;

});
parcelRegister("8QUik", function(module, exports) {

$parcel$export(module.exports, "GBRDots", function () { return $725062b4c6eb5955$export$e11c1e590154c1a0; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $725062b4c6eb5955$export$e11c1e590154c1a0(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        ...props,
        width: "92",
        height: "34",
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                        x: "-114.3%",
                        y: "-100%",
                        width: "328.6%",
                        height: "328.6%",
                        filterUnits: "objectBoundingBox",
                        id: "a",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                                stdDeviation: "5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0.101960784 0 0 0 0 0.349019608 0 0 0 0 0.866666667 0 0 0 0.301628059 0",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                        x: "-89.3%",
                        y: "-75%",
                        width: "278.6%",
                        height: "278.6%",
                        filterUnits: "objectBoundingBox",
                        id: "c",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                                stdDeviation: "2.5",
                                in: "SourceAlpha",
                                result: "shadowBlurInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                                in: "shadowBlurInner1",
                                result: "shadowOffsetInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feComposite", {
                                in: "shadowOffsetInner1",
                                in2: "SourceAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1",
                                result: "shadowInnerInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0",
                                in: "shadowInnerInner1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                        x: "-114.3%",
                        y: "-100%",
                        width: "328.6%",
                        height: "328.6%",
                        filterUnits: "objectBoundingBox",
                        id: "d",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                                stdDeviation: "5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                                values: "0 0 0 0 1 0 0 0 0 0.529411765 0 0 0 0 0.529411765 0 0 0 0.304141171 0",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                        x: "-89.3%",
                        y: "-75%",
                        width: "278.6%",
                        height: "278.6%",
                        filterUnits: "objectBoundingBox",
                        id: "f",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                                stdDeviation: "2.5",
                                in: "SourceAlpha",
                                result: "shadowBlurInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                                in: "shadowBlurInner1",
                                result: "shadowOffsetInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feComposite", {
                                in: "shadowOffsetInner1",
                                in2: "SourceAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1",
                                result: "shadowInnerInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0",
                                in: "shadowInnerInner1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                        x: "-114.3%",
                        y: "-100%",
                        width: "328.6%",
                        height: "328.6%",
                        filterUnits: "objectBoundingBox",
                        id: "g",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                                stdDeviation: "5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0.474509804 0 0 0 0 1 0 0 0 0 0.466666667 0 0 0 0.297994974 0",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("filter", {
                        x: "-89.3%",
                        y: "-75%",
                        width: "278.6%",
                        height: "278.6%",
                        filterUnits: "objectBoundingBox",
                        id: "i",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("feGaussianBlur", {
                                stdDeviation: "2.5",
                                in: "SourceAlpha",
                                result: "shadowBlurInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feOffset", {
                                in: "shadowBlurInner1",
                                result: "shadowOffsetInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feComposite", {
                                in: "shadowOffsetInner1",
                                in2: "SourceAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1",
                                result: "shadowInnerInner1"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("feColorMatrix", {
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0",
                                in: "shadowInnerInner1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        id: "buniqid",
                        cx: "36",
                        cy: "7",
                        r: "7"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        id: "euniqid",
                        cx: "65",
                        cy: "7",
                        r: "7"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        id: "huniqid",
                        cx: "7",
                        cy: "7",
                        r: "7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        transform: "translate(10 8)",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#000",
                                filter: "url(#a)",
                                href: "#buniqid"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#1A59DD",
                                href: "#buniqid"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#000",
                                filter: "url(#c)",
                                href: "#buniqid"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        transform: "translate(10 8)",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#000",
                                filter: "url(#d)",
                                href: "#euniqid"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#FF4646",
                                href: "#euniqid"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#000",
                                filter: "url(#f)",
                                href: "#euniqid"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)("g", {
                        transform: "translate(10 8)",
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#000",
                                filter: "url(#g)",
                                href: "#huniqid"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#4DFF4A",
                                href: "#huniqid"
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)("use", {
                                fill: "#000",
                                filter: "url(#i)",
                                href: "#huniqid"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});


parcelRegister("44Ybm", function(module, exports) {

$parcel$export(module.exports, "SelectAmountLimit", function () { return $1b3bf495d65e75b8$export$ae3c655b1f0a5c2b; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5P656 = parcelRequire("5P656");

var $8xKCH = parcelRequire("8xKCH");

var $5hpYi = parcelRequire("5hpYi");

var $9mhzx = parcelRequire("9mhzx");

var $FyNgf = parcelRequire("FyNgf");

var $gDlNU = parcelRequire("gDlNU");

var $7Zu6k = parcelRequire("7Zu6k");

var $5rJrd = parcelRequire("5rJrd");

var $3yllK = parcelRequire("3yllK");

var $22v9q = parcelRequire("22v9q");

var $a0GLn = parcelRequire("a0GLn");
const $1b3bf495d65e75b8$export$ae3c655b1f0a5c2b = (props)=>{
    const { acceptorId: acceptorId, backMethod: backMethod, selectMethod: selectMethod } = props;
    const accounts = (0, $9mhzx.useAccounts)();
    const selectableCurrencies = (0, $FyNgf.useSelectableCurrencies)(accounts);
    const [currency, setCurrency] = (0, $6uYXW.useState)(accounts[0]?.currencyAlpha);
    const [amount, setAmount] = (0, $6uYXW.useState)(null);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    (0, $6uYXW.useEffect)(()=>{
        let initialCurrency = currency;
        if (accounts.length > 0 && !(0, $gDlNU.isDefined)(currency)) {
            initialCurrency = accounts[0]?.currencyAlpha;
            setCurrency(initialCurrency);
        }
        if (!(0, $gDlNU.isDefined)(amount) && (0, $gDlNU.isDefined)(initialCurrency)) setAmount(new (0, $5P656.Amount)(0, initialCurrency));
    }, [
        accounts,
        currency,
        amount
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if ((0, $gDlNU.isDefined)(amount) && currency !== amount.currency) setAmount((0, $5P656.switchCurrency)(amount, currency));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currency
    ]);
    return /*#__PURE__*/ (0, $4m918.jsxs)($1b3bf495d65e75b8$var$Container, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$TopLeft, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $a0GLn.ModalBackButton), {
                    onClick: backMethod
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$Title, {
                children: formatMessage("transactionCode.selectAmount.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$AcceptorId, {
                children: formatMessage("transactionCode.selectAmount.acceptorReminder", {
                    acceptorId: acceptorId
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($1b3bf495d65e75b8$var$Row, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$CurrencyLabel, {
                        children: formatMessage("transactionCode.selectAmount.currencyLabel")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $3yllK.Selector), {
                        options: Array.from(selectableCurrencies).map((curr)=>({
                                value: curr,
                                text: (0, $8xKCH.Currencies)[curr].symbol,
                                key: curr.toString()
                            })),
                        value: currency,
                        onChange: (c)=>setCurrency(c),
                        size: "S"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$Row, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$AmountLabel, {
                    children: formatMessage("transactionCode.selectAmount.amountLabel")
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$Row, {
                children: amount && /*#__PURE__*/ (0, $4m918.jsx)((0, $5rJrd.AmountInput), {
                    value: amount,
                    onChange: setAmount
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$Row, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$AmountInformation, {
                    children: formatMessage("transactionCode.selectAmount.amountInformationLabel")
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$NextButton, {
                    size: "S",
                    disabled: !(amount && amount?.value > 0),
                    onClick: ()=>{
                        (0, $gDlNU.isDefined)(amount) && selectMethod(amount);
                    },
                    showSpinner: props.loading,
                    children: /*#__PURE__*/ (0, $4m918.jsx)($1b3bf495d65e75b8$var$ButtonLabel, {
                        children: formatMessage("transactionCode.selectAmount.next")
                    })
                })
            })
        ]
    });
};
const $1b3bf495d65e75b8$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
`;
const $1b3bf495d65e75b8$var$TopLeft = (0, $jb8NR.default).div`
  display: flex;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 100;
`;
const $1b3bf495d65e75b8$var$Row = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;
const $1b3bf495d65e75b8$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  color: #000000;
  margin-top: 50px;
  margin-bottom: 12px;
`;
const $1b3bf495d65e75b8$var$AcceptorId = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.8125rem;
  color: #b1b1b1;
  margin-bottom: 40px;
`;
const $1b3bf495d65e75b8$var$CurrencyLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.9375rem;
  margin-right: 10px;
  flex: 1;
`;
const $1b3bf495d65e75b8$var$AmountLabel = (0, $jb8NR.default)($1b3bf495d65e75b8$var$CurrencyLabel)`
  margin-top: 10px;
`;
const $1b3bf495d65e75b8$var$AmountInformation = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText};
  font-size: 0.9375rem;
  color: #aaaaaa;
  margin-top: 5px;
`;
const $1b3bf495d65e75b8$var$ButtonContainer = (0, $jb8NR.default).div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
`;
const $1b3bf495d65e75b8$var$NextButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))``;
const $1b3bf495d65e75b8$var$ButtonLabel = (0, $jb8NR.default).span`
  color: ${(props)=>props.disabled ? "#b1b1b1" : "#ffffff"};
`;

});
parcelRegister("a0GLn", function(module, exports) {

$parcel$export(module.exports, "ModalBackButton", function () { return $0e810ffd0eb0e8b7$export$2f20de482eb0487f; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bewhU = parcelRequire("bewhU");

var $51d3M = parcelRequire("51d3M");

var $22v9q = parcelRequire("22v9q");
const $0e810ffd0eb0e8b7$export$2f20de482eb0487f = (props)=>{
    const { title: title } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsx)($0e810ffd0eb0e8b7$var$CloseButton, {
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsxs)($0e810ffd0eb0e8b7$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($0e810ffd0eb0e8b7$var$ArrowBack, {}),
                /*#__PURE__*/ (0, $4m918.jsx)($0e810ffd0eb0e8b7$var$Label, {
                    children: title ?? formatMessage("transactionCode.modalBackButton")
                })
            ]
        })
    });
};
const $0e810ffd0eb0e8b7$var$CloseButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  padding: 0px;
`;
const $0e810ffd0eb0e8b7$var$Container = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
`;
const $0e810ffd0eb0e8b7$var$ArrowBack = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  margin-right: 10px;
  width: 18px;
  height: 18px;
  transform: rotate(180deg);
`;
const $0e810ffd0eb0e8b7$var$Label = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 0.9375rem;
  color: #000000;
`;

});


parcelRegister("4DUM5", function(module, exports) {

$parcel$export(module.exports, "TransactionCodePincode", function () { return $ecc79170d3308a21$export$c2dcd9a28b9a5f84; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $eyjPK = parcelRequire("eyjPK");

var $22v9q = parcelRequire("22v9q");

var $a0GLn = parcelRequire("a0GLn");
const $ecc79170d3308a21$export$c2dcd9a28b9a5f84 = (props)=>{
    const { keyboard: keyboard, backMethod: backMethod, submitMethod: submitMethod, errorMessage: errorMessage, loadingKeyboard: loadingKeyboard } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($ecc79170d3308a21$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($ecc79170d3308a21$var$TopLeft, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $a0GLn.ModalBackButton), {
                    onClick: backMethod
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($ecc79170d3308a21$var$Title, {
                children: formatMessage("transactionCode.pincode.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                keyboard: keyboard,
                onSubmit: submitMethod,
                title: formatMessage("transactionCode.pincode.description"),
                errorMessage: errorMessage,
                loadingKeyboard: loadingKeyboard
            })
        ]
    });
};
const $ecc79170d3308a21$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  padding-bottom: 32px;
  position: relative;
`;
const $ecc79170d3308a21$var$TopLeft = (0, $jb8NR.default).div`
  display: flex;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 100;
`;
const $ecc79170d3308a21$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  color: #000000;
  margin-bottom: 13px;
  align-self: center;
`;

});

parcelRegister("aRQe7", function(module, exports) {

$parcel$export(module.exports, "TransactionCodeSummary", function () { return $0054d58d34b5408d$export$550cdfbace9813d9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bZlaH = parcelRequire("bZlaH");

var $7Zu6k = parcelRequire("7Zu6k");

var $iqXYI = parcelRequire("iqXYI");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");
const $0054d58d34b5408d$export$550cdfbace9813d9 = (props)=>{
    const { className: className, transactionCode: transactionCode, onDone: onDone } = props;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($0054d58d34b5408d$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$SuccessCircle, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $iqXYI.CheckIcon), {})
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($0054d58d34b5408d$var$Card, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Title, {
                        children: formatMessage("transactionCode.summary.title")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($0054d58d34b5408d$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Label, {
                                children: formatMessage("transactionCode.summary.transactionCode")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Value, {
                                children: transactionCode.code
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($0054d58d34b5408d$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Label, {
                                children: formatMessage("transactionCode.summary.transactionPoint")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Value, {
                                children: transactionCode.acceptor.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($0054d58d34b5408d$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Label, {
                                children: formatMessage("transactionCode.summary.maxAmount")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)((0, $bZlaH.AmountText), {
                                amount: transactionCode.amount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($0054d58d34b5408d$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Label, {
                                children: formatMessage("transactionCode.summary.expiryDate")
                            }),
                            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$Value, {
                                children: formatDate(transactionCode.date, {
                                    day: "numeric",
                                    month: "numeric",
                                    hour: "numeric",
                                    minute: "numeric"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($0054d58d34b5408d$var$DoneButton, {
                size: "M",
                onClick: ()=>onDone(),
                children: formatMessage("transactionCode.summary.done")
            })
        ]
    });
};
const $0054d58d34b5408d$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
`;
const $0054d58d34b5408d$var$SuccessCircle = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 146px;
  height: 146px;
  margin: 40px 0 56px 0;
  border-radius: 100px;
  box-shadow: 0 2px 44px 0 rgba(46, 215, 148, 0.87);
  background-color: #2ed794;
`;
const $0054d58d34b5408d$var$Card = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
  padding: 33px 26px 20px 26px;
  background-color: #ffffff;
  border-radius: 30px;
  ${(0, $22v9q.shadows).medium};
`;
const $0054d58d34b5408d$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  color: #000000;
  margin-bottom: 40px;
  align-self: center;
`;
const $0054d58d34b5408d$var$Row = (0, $jb8NR.default).div`
  display: flex;
  align-self: stretch;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  @media (max-width: ${(0, $7XqbX.UIConstants).TABLET_BREAKPOINT}px) {
    flex-direction: column;
  }
`;
const $0054d58d34b5408d$var$Label = (0, $jb8NR.default).div`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).mediumText};
  color: #aaaaaa;
  align-self: center;
  text-align: center;
`;
const $0054d58d34b5408d$var$Value = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.9375rem;
  color: #000000;
  white-space: pre-line;
`;
const $0054d58d34b5408d$var$DoneButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 36px;
  margin-bottom: 16px;
`;

});



parcelRegister("cGTzu", function(module, exports) {

$parcel$export(module.exports, "CashTransferScreen", function () { return $d74913db5c007cfa$export$ac996b4746908edc; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $42awV = parcelRequire("42awV");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kRR5N = parcelRequire("kRR5N");

var $lbTbw = parcelRequire("lbTbw");

var $bQhUC = parcelRequire("bQhUC");

var $bewhU = parcelRequire("bewhU");

var $jn1mK = parcelRequire("jn1mK");

var $5Wai4 = parcelRequire("5Wai4");

var $jEKif = parcelRequire("jEKif");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $loTnT = parcelRequire("loTnT");

var $kp8dC = parcelRequire("kp8dC");

var $flGUg = parcelRequire("flGUg");
const $d74913db5c007cfa$export$ac996b4746908edc = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [selectedType, setSelectedType] = (0, $6uYXW.useState)((0, $kRR5N.CashTransferType).Received);
    const { data: cashTransfers, loading: loading, error: error, redo: redo, redoLoading: redoLoading, hasMore: hasMore, fetchMore: fetchMore, moreError: moreError } = (0, $lbTbw.usePaginatedFetch)((pagination)=>(0, $kqXxS.cashTransferService).fetchCashTransfer(pagination));
    const groupedCashTransfers = (0, $6uYXW.useMemo)(()=>cashTransfers.reduce((groups, cashTransfer)=>{
            groups[cashTransfer.type].push(cashTransfer);
            return groups;
        }, {
            [(0, $kRR5N.CashTransferType).Received]: [],
            [(0, $kRR5N.CashTransferType).Sent]: []
        }), [
        cashTransfers
    ]);
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($d74913db5c007cfa$var$TransactionsSection, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)((0, $jEKif.PageSectionTitle), {
                    children: formatMessage("cashTransferScreen.title")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$Description, {
                    children: formatMessage("cashTransferScreen.subtitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)($d74913db5c007cfa$var$SelectorWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$SelectorButton, {
                            isSelected: selectedType === (0, $kRR5N.CashTransferType).Received,
                            onClick: ()=>setSelectedType((0, $kRR5N.CashTransferType).Received),
                            children: formatMessage("cashTransferScreen.receivedSelector")
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$SelectorButton, {
                            isSelected: selectedType === (0, $kRR5N.CashTransferType).Sent,
                            onClick: ()=>setSelectedType((0, $kRR5N.CashTransferType).Sent),
                            children: formatMessage("cashTransferScreen.sentSelector")
                        })
                    ]
                }),
                loading || redoLoading ? /*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$StyledBlueSpinner, {}, "spinner") : groupedCashTransfers[selectedType].length === 0 ? /*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$NoTransactionAvailable, {
                    children: formatMessage($d74913db5c007cfa$var$emptyListLabels[selectedType])
                }) : /*#__PURE__*/ (0, $4m918.jsxs)($d74913db5c007cfa$var$StyledInfiniteScroll, {
                    loadMore: fetchMore,
                    hasMore: cashTransfers.length > 0 && hasMore,
                    loader: /*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$StyledBlueSpinner, {}, "cash-transfer-loader"),
                    children: [
                        groupedCashTransfers[selectedType].map((cashTransfer)=>/*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$CashTransfertCard, {
                                transaction: cashTransfer.label ? cashTransfer : {
                                    ...cashTransfer,
                                    label: formatMessage((0, $kRR5N.defaultTransferTitles)[cashTransfer.type])
                                },
                                received: selectedType === (0, $kRR5N.CashTransferType).Received,
                                onClick: (0, $flGUg.performTaskIfPossible)(()=>(0, $5Wai4.Modal).present((0, $bQhUC.CASH_TRANSFER_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $kp8dC.CashTransferModal), {
                                            cashTransfer: cashTransfer,
                                            onComplete: redo
                                        }), {
                                        canBeDismissed: false
                                    }))
                            }, cashTransfer.id)),
                        (error || moreError) && /*#__PURE__*/ (0, $4m918.jsx)($d74913db5c007cfa$var$StyledErrorMessage, {
                            children: error || moreError
                        })
                    ]
                })
            ]
        })
    });
};
const $d74913db5c007cfa$var$emptyListLabels = {
    [(0, $kRR5N.CashTransferType).Received]: "cashTransferScreen.emptyReceivedList",
    [(0, $kRR5N.CashTransferType).Sent]: "cashTransferScreen.emptySentList"
};
const $d74913db5c007cfa$var$TransactionsSection = (0, $jb8NR.default).section`
  align-self: stretch;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const $d74913db5c007cfa$var$Description = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  font-size: 0.9375rem;
  color: #b1b1b1;
  margin-bottom: 40px;
`;
const $d74913db5c007cfa$var$NoAccountAvailable = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  margin-top: 20px;
  margin-bottom: 40px;
`;
const $d74913db5c007cfa$var$NoTransactionAvailable = (0, $jb8NR.default)($d74913db5c007cfa$var$NoAccountAvailable)``;
const $d74913db5c007cfa$var$StyledInfiniteScroll = (0, $jb8NR.default)((0, (/*@__PURE__*/$parcel$interopDefault($42awV))))`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $d74913db5c007cfa$var$StyledBlueSpinner = (0, $jb8NR.default)((0, $k4kME.MainColorSpinner))`
  margin: 40px auto 0 auto;
`;
const $d74913db5c007cfa$var$CashTransfertCard = (0, $jb8NR.default)((0, $loTnT.AccountTransactionCard))`
  cursor: ${(props)=>props.onClick ? "pointer" : null};
  align-self: stretch;
  &:not(:last-of-type) {
    margin-bottom: 25px;
  }
`;
const $d74913db5c007cfa$var$SelectorWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  align-self: stretch;
`;
const $d74913db5c007cfa$var$SelectorButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  font-size: 1rem;
  position: relative;
  ${(0, $22v9q.theme).boldText};

  :first-child {
    margin-right: 20px;
  }

  ::after {
    position: absolute;
    bottom: -4px;
    left: 0;
    right: 0;
    display: ${(props)=>props.isSelected ? null : "none"};
    content: "";
    margin-top: 2px;
    height: 2px;
    width: 100%;
    background-color: ${(0, $22v9q.theme).mainColor};
  }
`;
const $d74913db5c007cfa$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-top: 10px;
`;

});
parcelRegister("kp8dC", function(module, exports) {

$parcel$export(module.exports, "CashTransferModal", function () { return $813147d36f16f7e2$export$c486014bc6dfe87e; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $kGswT = parcelRequire("kGswT");

var $1YFGv = parcelRequire("1YFGv");

var $kRR5N = parcelRequire("kRR5N");

var $dNQob = parcelRequire("dNQob");

var $3Ersk = parcelRequire("3Ersk");

var $bQhUC = parcelRequire("bQhUC");

var $40sjz = parcelRequire("40sjz");

var $e8KQF = parcelRequire("e8KQF");

var $bZlaH = parcelRequire("bZlaH");

var $7Zu6k = parcelRequire("7Zu6k");

var $jn1mK = parcelRequire("jn1mK");

var $8L45G = parcelRequire("8L45G");

var $eyjPK = parcelRequire("eyjPK");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $k4kME = parcelRequire("k4kME");

var $22v9q = parcelRequire("22v9q");

var $gJJ1c = parcelRequire("gJJ1c");
const $813147d36f16f7e2$export$c486014bc6dfe87e = ({ cashTransfer: cashTransfer, onComplete: onComplete })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const closeModal = (0, $6uYXW.useCallback)(()=>{
        (0, $5Wai4.Modal).dismiss((0, $bQhUC.CASH_TRANSFER_MODAL_ID));
    }, []);
    const { state: state, context: context, error: error, start: start, submitCashCode: submitCashCode, submitPincode: submitPincode } = (0, $e8KQF.useRetrieveCashTransferMachine)();
    const history = (0, $NQIVp.useHistory)();
    (0, $6uYXW.useEffect)(()=>{
        if ((0, $kGswT.redirectionHandledOnAccountBlocked)(context.error, history.push)) closeModal();
    }, [
        context.error,
        history.push,
        closeModal
    ]);
    const errorMessage = (0, $1YFGv.isAccountBlocked)(error) ? undefined : (0, $dNQob.isCashTransferCodeNotFoundError)(error) ? formatMessage("cashTransferScreen.invalidCode") : error;
    const renderCashTransferState = ()=>{
        switch(state){
            case (0, $e8KQF.CashTransferState).WaitingToRetrieveOrCancel:
            case (0, $e8KQF.CashTransferState).RequestingOrCancellingTransfer:
            case (0, $40sjz.PincodeState).PincodeConfirmation:
            case (0, $e8KQF.CashTransferState).ConfirmTransferError:
                return context.cashCode ? /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$CashCode, {
                    onSubmit: submitCashCode,
                    errorMessage: errorMessage,
                    loading: state === (0, $e8KQF.CashTransferState).RequestingOrCancellingTransfer || state === (0, $40sjz.PincodeState).PincodeConfirmation
                }) : /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$CashTransferMainComponent, {
                    cashTransfer: cashTransfer,
                    start: start,
                    errorMessage: errorMessage,
                    loading: state === (0, $e8KQF.CashTransferState).RequestingOrCancellingTransfer || state === (0, $40sjz.PincodeState).PincodeConfirmation
                });
            case (0, $e8KQF.CashTransferState).EnteringCashCode:
                return /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$CashCode, {
                    onSubmit: submitCashCode,
                    errorMessage: errorMessage
                });
            case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
            case (0, $40sjz.PincodeState).PromptingKeyboard:
                {
                    const keyboard = context.keyboard;
                    return /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                        keyboard: keyboard,
                        onSubmit: submitPincode,
                        title: formatMessage("pincodeConfirmation.label"),
                        errorMessage: errorMessage,
                        loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError
                    });
                }
            case (0, $e8KQF.CashTransferState).Done:
                {
                    const transactionResult = context.transactionResult;
                    return /*#__PURE__*/ (0, $4m918.jsx)((0, $gJJ1c.TransferSummary), {
                        title: cashTransfer.type === (0, $kRR5N.CashTransferType).Received ? formatMessage("cashTransferScreen.summaryTitle.receivedCashTransfer") : formatMessage("cashTransferScreen.summaryTitle.sentCashTransfer"),
                        subtitle: "",
                        middleStepLabel: formatMessage("transferSummary.summaryMiddleStep"),
                        transaction: transactionResult.metadata.transaction,
                        toSelf: true,
                        sender: "",
                        onDone: ()=>{
                            onComplete?.();
                            closeModal();
                        }
                    });
                }
            default:
                return /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$LoadingContainer, {
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                        size: "30px"
                    })
                });
        }
    };
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.CASH_TRANSFER_MODAL_ID),
        children: renderCashTransferState()
    });
};
const $813147d36f16f7e2$var$CashCode = ({ onSubmit: onSubmit, errorMessage: errorMessage, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const [cashCode, setCashCode] = (0, $6uYXW.useState)("");
    const configuration = (0, $3Ersk.useObservable)((0, $kqXxS.configurationManager).configuration);
    return /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Container, {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($813147d36f16f7e2$var$Form, {
            onSubmit: (e)=>{
                e?.preventDefault();
                !loading && onSubmit(cashCode);
            },
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Description, {
                    children: formatMessage("cashTransferScreen.cashCodeTitle")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$StyledOtpInput, {
                    length: configuration.p2pCodeLength.maxLength,
                    onOtpChange: (otp)=>setCashCode(otp)
                }),
                errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$StyledErrorMessage, {
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Button, {
                    type: "submit",
                    disabled: !(cashCode && cashCode.length <= configuration.p2pCodeLength.maxLength && cashCode.length >= configuration.p2pCodeLength.minLength),
                    size: "S",
                    showSpinner: loading,
                    children: formatMessage("cashTransferScreen.nextButton")
                })
            ]
        })
    });
};
const $813147d36f16f7e2$var$CashTransferMainComponent = ({ cashTransfer: cashTransfer, start: start, errorMessage: errorMessage, loading: loading })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5hpYi.useIntl)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($813147d36f16f7e2$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Header, {
                children: /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Title, {
                    children: cashTransfer.label ? cashTransfer.label : formatMessage((0, $kRR5N.defaultTransferTitles)[cashTransfer.type])
                })
            }),
            cashTransfer.type === (0, $kRR5N.CashTransferType).Received ? !!cashTransfer.sender && /*#__PURE__*/ (0, $4m918.jsxs)($813147d36f16f7e2$var$DescriptionLabel, {
                children: [
                    formatMessage("cashTransferScreen.sender"),
                    /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$BoldDescription, {
                        children: cashTransfer.sender
                    })
                ]
            }) : !!cashTransfer.recipient && /*#__PURE__*/ (0, $4m918.jsxs)($813147d36f16f7e2$var$DescriptionLabel, {
                children: [
                    formatMessage("cashTransferScreen.recipient"),
                    /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$BoldDescription, {
                        children: cashTransfer.recipient
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($813147d36f16f7e2$var$DataContainer, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$DateLabel, {
                        children: formatDate(cashTransfer.date, {
                            month: "long",
                            day: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit"
                        })
                    }),
                    cashTransfer.amount && /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Amount, {
                        amount: cashTransfer.amount
                    })
                ]
            }),
            cashTransfer.code && /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Code, {
                children: formatMessage("cashTransferScreen.codeLabel", {
                    code: cashTransfer.code
                })
            }),
            errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$StyledErrorMessage, {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($813147d36f16f7e2$var$Button, {
                size: "S",
                showSpinner: loading,
                onClick: ()=>start(cashTransfer),
                children: formatMessage($813147d36f16f7e2$var$buttonTitles[cashTransfer.type])
            })
        ]
    });
};
const $813147d36f16f7e2$var$buttonTitles = {
    [(0, $kRR5N.CashTransferType).Received]: "cashTransferScreen.retrieveCashTransferButton",
    [(0, $kRR5N.CashTransferType).Sent]: "cashTransferScreen.cancelCashTransferButton"
};
const $813147d36f16f7e2$var$Container = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
`;
const $813147d36f16f7e2$var$Header = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`;
const $813147d36f16f7e2$var$Title = (0, $jb8NR.default).h2`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  margin: 0;
  flex-shrink: 1;
  flex-grow: 1;
`;
const $813147d36f16f7e2$var$DataContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 0;
`;
const $813147d36f16f7e2$var$DescriptionLabel = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text};
  font-size: 0.9375rem;
`;
const $813147d36f16f7e2$var$BoldDescription = (0, $jb8NR.default)($813147d36f16f7e2$var$DescriptionLabel)`
  ${(0, $22v9q.theme).boldText};
`;
const $813147d36f16f7e2$var$DateLabel = (0, $jb8NR.default).div`
  flex: 1;
  ${(0, $22v9q.theme).text};
  font-size: 0.9375rem;
`;
const $813147d36f16f7e2$var$Amount = (0, $jb8NR.default)((0, $bZlaH.AmountText))`
  font-size: 1.125rem;
  ${(0, $22v9q.theme).boldText};
`;
const $813147d36f16f7e2$var$Code = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  margin-bottom: 30px;
  font-size: 0.9375rem;
`;
const $813147d36f16f7e2$var$Button = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  align-self: center;
`;
const $813147d36f16f7e2$var$StyledOtpInput = (0, $jb8NR.default)((0, $8L45G.OtpInput))`
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const $813147d36f16f7e2$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin-bottom: 10px;
  text-align: center;
`;
const $813147d36f16f7e2$var$LoadingContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
`;
const $813147d36f16f7e2$var$Description = (0, $jb8NR.default).div`
  margin-top: 30px;
  ${(0, $22v9q.theme).text};
  font-size: 0.9375rem;
  text-align: center;
`;
const $813147d36f16f7e2$var$Form = (0, $jb8NR.default).form`
  display: flex;
  flex-direction: column;
  margin: 0;
`;

});
parcelRegister("e8KQF", function(module, exports) {

$parcel$export(module.exports, "useRetrieveCashTransferMachine", function () { return $9c09dab3e2dcfbd8$export$34c74463959121e2; });
$parcel$export(module.exports, "CashTransferState", function () { return $9c09dab3e2dcfbd8$export$756891b87640c2cf; });

var $lCuQx = parcelRequire("lCuQx");

var $c8ePo = parcelRequire("c8ePo");
var $TAle5 = parcelRequire("TAle5");

var $kqXxS = parcelRequire("kqXxS");

var $kRR5N = parcelRequire("kRR5N");

var $8UJ8q = parcelRequire("8UJ8q");

var $40sjz = parcelRequire("40sjz");
const $9c09dab3e2dcfbd8$export$34c74463959121e2 = ()=>{
    const [machine, sendEvent] = (0, $lCuQx.useMachine)($9c09dab3e2dcfbd8$export$fe1f2f05e5bbe5d0);
    const { value: state, context: context } = machine;
    const start = (cashTransfer)=>{
        sendEvent(cashTransfer.type === (0, $kRR5N.CashTransferType).Sent ? "CANCEL" : "RETRIEVE", {
            cashTransfer: cashTransfer
        });
    };
    const submitCashCode = (cashCode)=>{
        sendEvent("SUBMIT_CASH_CODE", {
            cashCode: cashCode
        });
    };
    const submitPincode = (submission)=>{
        sendEvent("SUBMIT_PINCODE", {
            pincodeSubmission: submission
        });
    };
    return {
        state: state,
        context: context,
        error: context.error,
        start: start,
        submitPincode: submitPincode,
        submitCashCode: submitCashCode
    };
};
var $9c09dab3e2dcfbd8$export$756891b87640c2cf = /*#__PURE__*/ function(CashTransferState) {
    CashTransferState["WaitingToRetrieveOrCancel"] = "WaitingToRetrieveOrCancel";
    CashTransferState["EnteringCashCode"] = "EnteringCashCode";
    CashTransferState["RequestingOrCancellingTransfer"] = "RequestingOrCancellingTransfer";
    CashTransferState["Confirmation"] = "Confirmation";
    CashTransferState["ConfirmTransferError"] = "ConfirmTransferError";
    CashTransferState["Done"] = "Done";
    return CashTransferState;
}({});
const $9c09dab3e2dcfbd8$export$fe1f2f05e5bbe5d0 = (0, $TAle5.Machine)({
    id: "cash-transfer",
    initial: "WaitingToRetrieveOrCancel",
    states: {
        ["WaitingToRetrieveOrCancel"]: {
            on: {
                CANCEL: {
                    target: "RequestingOrCancellingTransfer",
                    actions: (0, $c8ePo.assign)({
                        cashTransfer: (_, event)=>event.cashTransfer
                    })
                },
                RETRIEVE: {
                    target: "EnteringCashCode",
                    actions: (0, $c8ePo.assign)({
                        cashTransfer: (_, event)=>event.cashTransfer
                    })
                }
            }
        },
        ["EnteringCashCode"]: {
            on: {
                SUBMIT_CASH_CODE: {
                    target: "RequestingOrCancellingTransfer",
                    actions: (0, $c8ePo.assign)({
                        cashCode: (_, event)=>event.cashCode
                    })
                }
            }
        },
        ["RequestingOrCancellingTransfer"]: {
            invoke: {
                id: "requestOrCancelTransfert",
                src: (context)=>(0, $kqXxS.cashTransferManager).startRetrieveCashTransfer(context.cashCode || context.cashTransfer.code),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionRequest: (_, event)=>event.data,
                            error: (_)=>undefined
                        }),
                        (0, $c8ePo.send)((context)=>context.transactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "PINCODE_CONFIRM"
                            } : {
                                type: "CONFIRM"
                            })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)((ctx)=>ctx.cashCode ? {
                                type: "CASH_CODE_ERROR"
                            } : {
                                type: "RETRIEVE_CASH_ERROR"
                            })
                    ]
                }
            },
            on: {
                PINCODE_CONFIRM: (0, $40sjz.PincodeState).PincodeConfirmation,
                CONFIRM: "Confirmation",
                CASH_CODE_ERROR: "EnteringCashCode",
                RETRIEVE_CASH_ERROR: "WaitingToRetrieveOrCancel"
            }
        },
        [(0, $40sjz.PincodeState).PincodeConfirmation]: {
            invoke: {
                id: "fetchKeyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        [(0, $40sjz.PincodeState).PromptingKeyboard]: {
            on: {
                SUBMIT_PINCODE: {
                    target: "Confirmation",
                    actions: (0, $c8ePo.assign)({
                        pincodeSubmission: (_, event)=>event.pincodeSubmission
                    })
                }
            }
        },
        ["Confirmation"]: {
            invoke: {
                id: "confirm-transfer",
                src: (context)=>(0, $kqXxS.cashTransferManager).confirmRetrieveCashTransfer(context.transactionRequest.metadata.confirmationMode, context.cashCode || context.cashTransfer.code, context.pincodeSubmission),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            transactionResult: (_, event)=>event.data,
                            error: (_)=>undefined
                        }),
                        (0, $c8ePo.send)({
                            type: "TRANSFER_DONE"
                        })
                    ]
                },
                onError: {
                    actions: [
                        (0, $c8ePo.assign)({
                            error: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)((ctx)=>ctx.transactionRequest?.metadata.confirmationMode === (0, $8UJ8q.ConfirmationMode).PinCode ? {
                                type: "TRANSFER_CONFIRMATION_PINCODE_ERROR"
                            } : {
                                type: "TRANSFER_CONFIRMATION_ERROR"
                            })
                    ]
                }
            },
            on: {
                TRANSFER_DONE: "Done",
                TRANSFER_CONFIRMATION_PINCODE_ERROR: (0, $40sjz.PincodeState).FetchKeyboardAfterError,
                TRANSFER_CONFIRMATION_ERROR: "ConfirmTransferError"
            }
        },
        [(0, $40sjz.PincodeState).FetchKeyboardAfterError]: {
            invoke: {
                id: "fetch-keyboard",
                src: ()=>(0, $kqXxS.pincodeKeyboardService).fetchKeyboard((0, $40sjz.TOUCH_SIZE), undefined, (0, $40sjz.FONT_SIZE)),
                onDone: {
                    actions: [
                        (0, $c8ePo.assign)({
                            keyboard: (_, event)=>event.data
                        }),
                        (0, $c8ePo.send)({
                            type: "PROMPT_KEYBOARD"
                        })
                    ]
                }
            },
            on: {
                PROMPT_KEYBOARD: (0, $40sjz.PincodeState).PromptingKeyboard
            }
        },
        ["ConfirmTransferError"]: {
            exit: (0, $c8ePo.assign)({
                error: (_)=>undefined
            }),
            on: {
                CANCEL: {
                    target: "RequestingOrCancellingTransfer",
                    actions: (0, $c8ePo.assign)({
                        cashTransfer: (_, event)=>event.cashTransfer
                    })
                },
                RETRIEVE: {
                    target: "EnteringCashCode",
                    actions: (0, $c8ePo.assign)({
                        cashTransfer: (_, event)=>event.cashTransfer
                    })
                },
                SUBMIT_CASH_CODE: {
                    target: "RequestingOrCancellingTransfer",
                    actions: (0, $c8ePo.assign)({
                        cashCode: (_, event)=>event.cashCode
                    })
                }
            }
        },
        ["Done"]: {
            type: "final"
        }
    }
});

});



parcelRegister("lrkNK", function(module, exports) {

$parcel$export(module.exports, "SimpleTransferScreen", function () { return $9c3578e2deb149f1$export$834b0e82444731db; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $4fYE4 = parcelRequire("4fYE4");

var $22v9q = parcelRequire("22v9q");

var $3scQZ = parcelRequire("3scQZ");
var $9c3578e2deb149f1$export$8a464123678aad61 = /*#__PURE__*/ function(TransferDestination) {
    TransferDestination[TransferDestination["Beneficiaries"] = 0] = "Beneficiaries";
    TransferDestination[TransferDestination["ExternalAccounts"] = 1] = "ExternalAccounts";
    return TransferDestination;
}({});
function $9c3578e2deb149f1$export$834b0e82444731db() {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const history = (0, $NQIVp.useHistory)();
    return /*#__PURE__*/ (0, $4m918.jsxs)($9c3578e2deb149f1$var$Container, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($9c3578e2deb149f1$var$Title, {
                children: formatMessage("simpleTransfer.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $3scQZ.SimpleTransferModal), {
                closeModal: ()=>{
                    history.push(`${(0, $4fYE4.Path).AccountTransactions}`);
                }
            })
        ]
    });
}
const $9c3578e2deb149f1$var$Container = (0, $jb8NR.default).div`
  max-width: 500px;
  width: 100%;
`;
const $9c3578e2deb149f1$var$Title = (0, $jb8NR.default).span`
  font-size: 1.5625rem;
  margin-bottom: 12px;
  ${(0, $22v9q.theme).boldText};
  color: ${(0, $22v9q.theme).mainColor};
  white-space: pre;
`;

});
parcelRegister("3scQZ", function(module, exports) {

$parcel$export(module.exports, "SimpleTransferModal", function () { return $3c98ef1319172490$export$d1d78f397c399d07; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kGswT = parcelRequire("kGswT");

var $1YFGv = parcelRequire("1YFGv");

var $fQIdb = parcelRequire("fQIdb");

var $40sjz = parcelRequire("40sjz");

var $hFNLo = parcelRequire("hFNLo");

var $jn1mK = parcelRequire("jn1mK");

var $eyjPK = parcelRequire("eyjPK");

var $k4kME = parcelRequire("k4kME");

var $99Id8 = parcelRequire("99Id8");

var $22v9q = parcelRequire("22v9q");

var $lT9Op = parcelRequire("lT9Op");

var $gJJ1c = parcelRequire("gJJ1c");
const $3c98ef1319172490$var$loadingState = [
    (0, $hFNLo.TransferState).RequestingTransfer,
    (0, $40sjz.PincodeState).PincodeConfirmation
];
const $3c98ef1319172490$export$d1d78f397c399d07 = (props)=>{
    const { closeModal: closeModal } = props;
    const { context: context, state: state, selectAmount: selectAmount, submitPincode: submitPincode } = (0, $hFNLo.useTransferMachine)(true);
    const history = (0, $NQIVp.useHistory)();
    const [editingSourceAndDestination, setEditingSourceAndDestination] = (0, $6uYXW.useState)(null);
    const [sourceAccount, setSourceAccount] = (0, $6uYXW.useState)(null);
    (0, $6uYXW.useEffect)(()=>{
        if ((0, $kGswT.redirectionHandledOnAccountBlocked)(context.error, history.push)) closeModal?.();
    }, [
        context.error,
        history.push,
        closeModal
    ]);
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const errorPhoneMessage = formatMessage("simpleTransfer.invalidPhoneNumber");
    let errorMessage;
    if ((0, $1YFGv.isRecipientNotFoundByInvalidPhoneErrorResponse)(context.error)) errorMessage = errorPhoneMessage;
    else if (!(0, $1YFGv.isAccountBlocked)(context.error)) errorMessage = context.error;
    else errorMessage = undefined;
    const handleSetSourceAccount = (account)=>{
        setSourceAccount(account);
        setEditingSourceAndDestination(null);
    };
    const onOpenSourceAccountSelection = ()=>{
        setEditingSourceAndDestination((0, $lT9Op.SourceAndDestinationEnum).Source);
    };
    switch(state){
        case (0, $hFNLo.TransferState).SelectingAmount:
        case (0, $hFNLo.TransferState).RequestingTransfer:
        case (0, $hFNLo.TransferState).RequestingTransferError:
        case (0, $40sjz.PincodeState).PincodeConfirmation:
        case (0, $hFNLo.TransferState).ConfirmTransferError:
            return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($3c98ef1319172490$var$Centered, {
                        children: errorMessage && /*#__PURE__*/ (0, $4m918.jsx)($3c98ef1319172490$var$StyledErrorMessage, {
                            children: errorMessage
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($3c98ef1319172490$var$StyledAmountSelection, {
                        sourceAccount: sourceAccount,
                        isP2PSimpleTransfer: true,
                        submitAmount: selectAmount,
                        loading: $3c98ef1319172490$var$loadingState.includes(state),
                        editingSourceAndDestination: editingSourceAndDestination,
                        onOpenSourceAccountSelection: onOpenSourceAccountSelection,
                        children: editingSourceAndDestination === (0, $lT9Op.SourceAndDestinationEnum).Source && /*#__PURE__*/ (0, $4m918.jsx)((0, $lT9Op.SourceAndDestination), {
                            type: (0, $lT9Op.SourceAndDestinationEnum).Source,
                            sourceAccount: sourceAccount,
                            onSourceAccountChange: handleSetSourceAccount
                        })
                    })
                ]
            });
        case (0, $40sjz.PincodeState).FetchKeyboardAfterError:
        case (0, $40sjz.PincodeState).PromptingKeyboard:
            {
                const keyboard = context.keyboard;
                return /*#__PURE__*/ (0, $4m918.jsx)((0, $eyjPK.PincodeKeyboard), {
                    keyboard: keyboard,
                    onSubmit: submitPincode,
                    title: formatMessage("pincodeConfirmation.label"),
                    errorMessage: errorMessage,
                    loadingKeyboard: state === (0, $40sjz.PincodeState).FetchKeyboardAfterError
                });
            }
        case (0, $hFNLo.TransferState).Done:
            {
                const transactionResult = context.transactionResult;
                const recipient = {
                    ...context.recipient,
                    name: context.recipient?.name ?? ""
                };
                return /*#__PURE__*/ (0, $4m918.jsx)($3c98ef1319172490$var$StyledTransferSummary, {
                    recipient: recipient,
                    title: formatMessage("transferSummary.summaryTitle"),
                    subtitle: context.transferMode === (0, $fQIdb.TransferMode).CashTransfer ? formatMessage("transferSummary.cashSummarySubtitle", {
                        recipient: "recipient.name"
                    }) : formatMessage("transferSummary.accountSummarySubtitle"),
                    middleStepLabel: formatMessage("transferSummary.summaryMiddleStep"),
                    transaction: transactionResult.metadata.transaction,
                    onDone: closeModal,
                    boldSubtitle: context.transferMode !== (0, $fQIdb.TransferMode).CashTransfer
                });
            }
        default:
            return /*#__PURE__*/ (0, $4m918.jsx)($3c98ef1319172490$var$LoadingContainer, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $k4kME.MainColorSpinner), {
                    size: "30px"
                })
            });
    }
};
const $3c98ef1319172490$var$Centered = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $3c98ef1319172490$var$StyledAmountSelection = (0, $jb8NR.default)((0, $99Id8.AmountSelection))`
  margin-top: 20px;
`;
const $3c98ef1319172490$var$LoadingContainer = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
`;
const $3c98ef1319172490$var$StyledErrorMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  margin: 10px 50px;
  text-align: center;
`;
const $3c98ef1319172490$var$StyledTransferSummary = (0, $jb8NR.default)((0, $gJJ1c.TransferSummary))`
  ${(0, $gJJ1c.Subtitle)} {
    ${(props)=>!props.boldSubtitle && (0, $22v9q.theme).text}
  }
`;

});


parcelRegister("I09Mh", function(module, exports) {

$parcel$export(module.exports, "TransferScreen", function () { return $6f67ed1cdbea5cc8$export$bc19a681aba645c5; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");

var $22v9q = parcelRequire("22v9q");

var $4SmBi = parcelRequire("4SmBi");

var $hvFeR = parcelRequire("hvFeR");
var $6f67ed1cdbea5cc8$export$8a464123678aad61 = /*#__PURE__*/ function(TransferDestination) {
    TransferDestination[TransferDestination["Beneficiaries"] = 0] = "Beneficiaries";
    TransferDestination[TransferDestination["ExternalAccounts"] = 1] = "ExternalAccounts";
    return TransferDestination;
}({});
function $6f67ed1cdbea5cc8$export$bc19a681aba645c5() {
    const { push: push } = (0, $NQIVp.useHistory)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    return features.customerInstructionInitiation ? /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($6f67ed1cdbea5cc8$var$Title, {
                children: formatMessage("recipient.title")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $hvFeR.TransferTransaction), {
                isOpenLoop: true,
                recipient: {},
                closeModal: ()=>push((0, $4fYE4.Path).AccountTransactions)
            })
        ]
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $4SmBi.RecipientsScreen), {});
}
const $6f67ed1cdbea5cc8$var$Title = (0, $jb8NR.default).span`
  font-size: 1.5625rem;
  margin-bottom: 12px;
  ${(0, $22v9q.theme).boldText};
  color: ${(0, $22v9q.theme).mainColor};
  white-space: pre;
`;

});

parcelRegister("gAfhx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e9844fdc4355d12$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $9jV7u = parcelRequire("9jV7u");

var $69UHx = parcelRequire("69UHx");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $amCCH = parcelRequire("amCCH");

var $3LlI4 = parcelRequire("3LlI4");

var $jZUHD = parcelRequire("jZUHD");

var $l2MBn = parcelRequire("l2MBn");

var $4VMAf = parcelRequire("4VMAf");
const $4e9844fdc4355d12$var$UpcomingTransferScreen = ()=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { upcomingTransfers: upcomingTransfers, canLoadMore: canLoadMore, loadMore: loadMore, refresh: refresh } = (0, $69UHx.default)((0, $kqXxS.upcomingTransfersManager));
    const hasStandingOrderUpdateActivated = (0, $kqXxS.featuresManager).features.get().paymentStandingOrderUpdate;
    const hasStandingOrderDeleteActivated = (0, $kqXxS.featuresManager).features.get().paymentStandingOrderDelete;
    const handleUpcomingTransferStatus = async (transfer)=>{
        const updatedStatus = transfer.status === (0, $9jV7u.UpcomingTransferStatus).DEACTIVATED ? (0, $9jV7u.UpcomingTransferStatus).ACTIVATED : (0, $9jV7u.UpcomingTransferStatus).DEACTIVATED;
        await (0, $kqXxS.upcomingTransfersManager).updateStatusUpcomingTransfer(transfer.id, updatedStatus);
        refresh();
    };
    const handleUpcomingTransferDelete = (transfer)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.DELETE_UPCOMING_TRANSFER_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $3LlI4.DeleteUpcomingTransferModal), {
                transfer: transfer,
                onConfirm: async ()=>{
                    await (0, $kqXxS.upcomingTransfersManager).deleteUpcomingTransfer(transfer.id);
                    refresh();
                }
            }), {
            canBeDismissed: true
        });
    };
    const handleUpcomingTransferEdit = (transfer)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.EDIT_UPCOMING_TRANSFER_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $l2MBn.EditUpcomingTransferModal), {
                transfer: transfer,
                onConfirm: async (modifiedTransfer)=>{
                    await (0, $kqXxS.upcomingTransfersManager).editUpcomingTransfer(transfer.id, modifiedTransfer);
                    refresh();
                }
            }), {
            canBeDismissed: false
        });
    };
    const handleUpcomingTransferClick = (transfer)=>{
        (0, $5Wai4.Modal).present((0, $bQhUC.DETAIL_UPCOMING_TRANSFER_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $jZUHD.DetailUpcomingTransferModal), {
                transfer: transfer
            }), {
            canBeDismissed: false
        });
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $amCCH.PageHeader), {
                title: formatMessage("transfertsSubmenu.upcomingTransfers"),
                description: formatMessage("upcomingTransfers.description")
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($4e9844fdc4355d12$var$UpcomingTransfersWrapper, {
                children: upcomingTransfers.map((transfer)=>/*#__PURE__*/ (0, $4m918.jsx)((0, $4VMAf.UpcomingTransferItem), {
                        transfer: transfer,
                        hasStandingOrderUpdateActivated: hasStandingOrderUpdateActivated,
                        hasStandingOrderDeleteActivated: hasStandingOrderDeleteActivated,
                        handleUpcomingTransferDelete: handleUpcomingTransferDelete,
                        handleUpcomingTransferStatus: handleUpcomingTransferStatus,
                        handleUpcomingTransferEdit: handleUpcomingTransferEdit,
                        handleUpcomingTransferDetail: ()=>handleUpcomingTransferClick(transfer)
                    }, transfer.id))
            }),
            canLoadMore && /*#__PURE__*/ (0, $4m918.jsx)($4e9844fdc4355d12$var$LoadMore, {
                children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7Zu6k.PrimaryButton), {
                    size: "S",
                    onClick: loadMore,
                    children: formatMessage("upcomingTransfers.loadMore")
                })
            })
        ]
    });
};
const $4e9844fdc4355d12$var$UpcomingTransfersWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $4e9844fdc4355d12$var$LoadMore = (0, $jb8NR.default).div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
`;
var $4e9844fdc4355d12$export$2e2bcd8739ae039 = $4e9844fdc4355d12$var$UpcomingTransferScreen;

});
parcelRegister("9jV7u", function(module, exports) {

$parcel$export(module.exports, "UpcomingTransferStatus", function () { return $a1db4ff56f438e06$export$fca6dc2853ea4725; });
$parcel$export(module.exports, "UpcomingTransferStatusColor", function () { return $a1db4ff56f438e06$export$440932442a747efe; });
$parcel$export(module.exports, "UPCOMING_TRANSFER_STATUSES", function () { return $a1db4ff56f438e06$export$eaf720debda65c6d; });
var $a1db4ff56f438e06$export$fca6dc2853ea4725 = /*#__PURE__*/ function(UpcomingTransferStatus) {
    UpcomingTransferStatus["ACTIVATED"] = "ACTIVATED";
    UpcomingTransferStatus["DEACTIVATED"] = "DEACTIVATED";
    UpcomingTransferStatus["EXPIRED"] = "EXPIRED";
    UpcomingTransferStatus["DELETED"] = "DELETED";
    return UpcomingTransferStatus;
}({});
var $a1db4ff56f438e06$export$440932442a747efe = /*#__PURE__*/ function(UpcomingTransferStatusColor) {
    UpcomingTransferStatusColor["SUCCESS"] = "success";
    UpcomingTransferStatusColor["WARNING"] = "warning";
    UpcomingTransferStatusColor["ERROR"] = "error";
    UpcomingTransferStatusColor["INFO"] = "info";
    return UpcomingTransferStatusColor;
}({});
const $a1db4ff56f438e06$export$eaf720debda65c6d = {
    ["ACTIVATED"]: {
        label: "upcomingTransfers.status.activated",
        color: "success"
    },
    ["DEACTIVATED"]: {
        label: "upcomingTransfers.status.deactivated",
        color: "warning"
    },
    ["EXPIRED"]: {
        label: "upcomingTransfers.status.expired",
        color: "info"
    },
    ["DELETED"]: {
        label: "upcomingTransfers.status.deleted",
        color: "error"
    }
};

});

parcelRegister("69UHx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a348e2d8e42f6c33$export$2e2bcd8739ae039; });

var $3Ersk = parcelRequire("3Ersk");

var $hngyi = parcelRequire("hngyi");

var $k4Ecv = parcelRequire("k4Ecv");
function $a348e2d8e42f6c33$export$2e2bcd8739ae039(upcomingTransferManager) {
    const paginatedUpcomingTransfers = (0, $hngyi.useObservablePaginated)(upcomingTransferManager.paginatedUpcomingTransfers);
    const canLoadMore = (0, $3Ersk.useObservable)(upcomingTransferManager.canLoadMore);
    const isLoading = (0, $3Ersk.useObservable)(upcomingTransferManager.isLoading);
    (0, $k4Ecv.useAsyncEffect)(async ()=>{
        await upcomingTransferManager.getUpcomingTransfers();
    }, []);
    return {
        upcomingTransfers: paginatedUpcomingTransfers.items,
        canLoadMore: canLoadMore,
        isLoading: isLoading,
        refresh: async ()=>await upcomingTransferManager.getUpcomingTransfers(),
        getUpcomingTransfers: async ()=>await upcomingTransferManager.getUpcomingTransfers(),
        loadMore: async ()=>await upcomingTransferManager.loadMore()
    };
}

});

parcelRegister("3LlI4", function(module, exports) {

$parcel$export(module.exports, "DeleteUpcomingTransferModal", function () { return $7dd7d48df9c0705d$export$8663c419c77a96f1; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $22v9q = parcelRequire("22v9q");
const $7dd7d48df9c0705d$export$8663c419c77a96f1 = (props)=>{
    const { transfer: transfer, onConfirm: onConfirm } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const closeModal = ()=>{
        (0, $5Wai4.Modal).dismiss((0, $bQhUC.DELETE_UPCOMING_TRANSFER_MODAL_ID));
    };
    const handleConfirm = ()=>{
        onConfirm();
        closeModal();
    };
    return /*#__PURE__*/ (0, $4m918.jsx)($7dd7d48df9c0705d$var$ModalContainer, {
        closeButton: true,
        id: (0, $bQhUC.DELETE_UPCOMING_TRANSFER_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)($7dd7d48df9c0705d$var$Container, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($7dd7d48df9c0705d$var$Title, {
                    children: formatMessage("upcomingTransfers.deletePrompt.title")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($7dd7d48df9c0705d$var$Message, {
                    children: formatMessage("upcomingTransfers.deletePrompt.message", {
                        id: transfer.id
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($7dd7d48df9c0705d$var$ConfirmButton, {
                    size: "M",
                    onClick: handleConfirm,
                    children: formatMessage("upcomingTransfers.confirmButton")
                })
            ]
        })
    });
};
const $7dd7d48df9c0705d$var$ModalContainer = (0, $jb8NR.default)((0, $iy3Ex.RoundedModalContainer))``;
const $7dd7d48df9c0705d$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 56px;
`;
const $7dd7d48df9c0705d$var$Title = (0, $jb8NR.default).span`
  ${(0, $22v9q.fonts).bold}
  font-size: 1.5rem;
  color: ${(0, $22v9q.theme).mainColor};
`;
const $7dd7d48df9c0705d$var$Message = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  color: black;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  text-align: center;
  margin: 48px 10px 15px;
`;
const $7dd7d48df9c0705d$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 30px;
  margin-bottom: 30px;
`;

});

parcelRegister("jZUHD", function(module, exports) {

$parcel$export(module.exports, "DetailUpcomingTransferModal", function () { return $a91e587d2a7bb24f$export$d52c003654d3c6e9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $fuFCk = parcelRequire("fuFCk");

var $bQhUC = parcelRequire("bQhUC");

var $bZlaH = parcelRequire("bZlaH");

var $iy3Ex = parcelRequire("iy3Ex");

var $l7Adx = parcelRequire("l7Adx");

var $7vTNS = parcelRequire("7vTNS");
const $a91e587d2a7bb24f$export$d52c003654d3c6e9 = ({ transfer: transfer })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { paymentTransaction: paymentTransaction, frequency: frequency, nextExecutionDate: nextExecutionDate, customerInstructionOrderingParties: customerInstructionOrderingParties, endDate: endDate } = transfer;
    const frequencyLabel = frequency ? (0, $fuFCk.formatFrequency)(frequency.interval, frequency.unit, formatMessage) : "-";
    return /*#__PURE__*/ (0, $4m918.jsx)((0, $iy3Ex.RoundedModalContainer), {
        closeButton: true,
        id: (0, $bQhUC.DETAIL_UPCOMING_TRANSFER_MODAL_ID),
        children: /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Container), {
            children: [
                /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Header), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Title), {
                            children: formatMessage("recurringTransfer.recurringTransferTitleDetails", {
                                destinationAccount: paymentTransaction?.paymentTransactionParties?.creditor?.name
                            })
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Status), {
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $7vTNS.UpcomingTransferStatusPill), {
                                status: transfer.status
                            })
                        })
                    ]
                }),
                paymentTransaction?.paymentTransactionAmountInformation?.instructedAmount && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$AmountField, {
                    label: formatMessage("recurringTransfer.scheduledAmount"),
                    className: "amount-field",
                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bZlaH.AmountText), {
                        amount: paymentTransaction.paymentTransactionAmountInformation.instructedAmount
                    })
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Section), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.SectionTitle), {
                            children: formatMessage("recurringTransfer.beneficiaryDetails")
                        }),
                        paymentTransaction?.paymentTransactionParties?.creditor?.name && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$Field, {
                            label: formatMessage("recurringTransfer.beneficiaryAccount"),
                            children: paymentTransaction.paymentTransactionParties.creditor.name
                        }),
                        paymentTransaction?.paymentTransactionParties?.creditor?.bankId && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$Field, {
                            label: formatMessage("recurringTransfer.beneficiaryBIC"),
                            children: paymentTransaction.paymentTransactionParties.creditor.bankId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.Section), {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.SectionTitle), {
                            children: formatMessage("recurringTransfer.recurringTransferDetails")
                        }),
                        customerInstructionOrderingParties?.debtor?.accountId?.value && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$Field, {
                            label: formatMessage("recurringTransfer.sourceAccount"),
                            children: customerInstructionOrderingParties.debtor.accountId.value
                        }),
                        frequency?.interval && frequency?.unit && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$Field, {
                            label: formatMessage("recurringTransfer.frequency"),
                            children: frequencyLabel
                        }),
                        nextExecutionDate && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$Field, {
                            label: formatMessage("recurringTransfer.nextExecutionDate"),
                            children: formatDate(nextExecutionDate, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })
                        }),
                        endDate && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$Field, {
                            label: formatMessage("recurringTransfer.endDate"),
                            children: formatDate(endDate, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })
                        }),
                        paymentTransaction?.paymentTransactionDedicatedInformations?.remittanceInformation?.value && /*#__PURE__*/ (0, $4m918.jsx)($a91e587d2a7bb24f$var$Field, {
                            label: formatMessage("recurringTransfer.description"),
                            children: paymentTransaction.paymentTransactionDedicatedInformations.remittanceInformation.value
                        })
                    ]
                })
            ]
        })
    });
};
const $a91e587d2a7bb24f$var$Field = ({ label: label, children: children, className: className })=>/*#__PURE__*/ (0, $4m918.jsxs)((0, $l7Adx.SectionContent), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $l7Adx.Result), {
                children: children
            })
        ]
    });
const $a91e587d2a7bb24f$var$AmountField = (0, $jb8NR.default)($a91e587d2a7bb24f$var$Field)`
  text-align: center;
  font-weight: 700;

  &.amount-field {
    ${(0, $l7Adx.Label)} {
      font-size: 15px;
      margin-bottom: 5px;
    }

    ${(0, $l7Adx.Result)} {
      font-size: 32px;
      line-height: 32px;
    }
  }
`;

});
parcelRegister("fuFCk", function(module, exports) {

$parcel$export(module.exports, "formatFrequency", function () { return $41cf2aaceae90091$export$d7f1c7bd2822ffe3; });

var $bGuuW = parcelRequire("bGuuW");
const $41cf2aaceae90091$export$d7f1c7bd2822ffe3 = (interval, unit, formatMessage)=>{
    const frequencyOption = (0, $bGuuW.RECURRING_TRANSFER_FREQUENCY_OPTIONS).find((freqOpt)=>freqOpt.frequency.interval === interval && freqOpt.frequency.unit === unit);
    return frequencyOption ? formatMessage(frequencyOption.label) : "-";
};

});

parcelRegister("7vTNS", function(module, exports) {

$parcel$export(module.exports, "UpcomingTransferStatusPill", function () { return $1bdc4304ef660087$export$a973f95b4ea79f2; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $9jV7u = parcelRequire("9jV7u");

var $22v9q = parcelRequire("22v9q");
const $1bdc4304ef660087$var$UPCOMING_TRANSFER_STATUSES_STYLES = {
    [(0, $9jV7u.UpcomingTransferStatusColor).SUCCESS]: {
        color: (0, $22v9q.theme).colors.success[500],
        backgroundColor: (0, $22v9q.theme).colors.success[100]
    },
    [(0, $9jV7u.UpcomingTransferStatusColor).WARNING]: {
        color: (0, $22v9q.theme).colors.warning[500],
        backgroundColor: (0, $22v9q.theme).colors.warning[100]
    },
    [(0, $9jV7u.UpcomingTransferStatusColor).ERROR]: {
        color: (0, $22v9q.theme).colors.gray[500],
        backgroundColor: (0, $22v9q.theme).colors.gray[100]
    },
    [(0, $9jV7u.UpcomingTransferStatusColor).INFO]: {
        color: (0, $22v9q.theme).colors.info[500],
        backgroundColor: (0, $22v9q.theme).colors.info[100]
    }
};
const $1bdc4304ef660087$export$a973f95b4ea79f2 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const matchingStatus = (0, $9jV7u.UPCOMING_TRANSFER_STATUSES)[status];
    const style = matchingStatus?.color && $1bdc4304ef660087$var$UPCOMING_TRANSFER_STATUSES_STYLES[matchingStatus?.color] || $1bdc4304ef660087$var$UPCOMING_TRANSFER_STATUSES_STYLES[(0, $9jV7u.UpcomingTransferStatusColor).ERROR];
    return /*#__PURE__*/ (0, $4m918.jsx)($1bdc4304ef660087$var$StyledUpcomingTransferStatusPill, {
        style: style,
        children: formatMessage(matchingStatus.label)
    });
};
const $1bdc4304ef660087$var$StyledUpcomingTransferStatusPill = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText}
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 4px 10px 4px 7px;
  border-radius: 20px;
  &::before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
    background-color: currentColor;
  }
`;

});


parcelRegister("l2MBn", function(module, exports) {

$parcel$export(module.exports, "EditUpcomingTransferModal", function () { return $dcb50ff1900b9108$export$4e1ab6dd8065c670; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bGuuW = parcelRequire("bGuuW");

var $bQhUC = parcelRequire("bQhUC");

var $7Zu6k = parcelRequire("7Zu6k");

var $5rJrd = parcelRequire("5rJrd");

var $k5s21 = parcelRequire("k5s21");

var $39jSd = parcelRequire("39jSd");

var $9mlIh = parcelRequire("9mlIh");

var $5Wai4 = parcelRequire("5Wai4");

var $iy3Ex = parcelRequire("iy3Ex");

var $22v9q = parcelRequire("22v9q");
const $dcb50ff1900b9108$export$4e1ab6dd8065c670 = ({ transfer: transfer, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { paymentTransaction: { paymentTransactionAmountInformation: paymentTransactionAmountInformation, paymentTransactionDedicatedInformations: { remittanceInformation: remittanceInformation } = {} }, firstExecutionDate: firstExecutionDate, frequency: utFrequency, endDate: utEndDate } = transfer;
    const utFrequencyOption = (0, $bGuuW.RECURRING_TRANSFER_FREQUENCY_OPTIONS).find((freqOpt)=>freqOpt.frequency.interval === utFrequency.interval && freqOpt.frequency.unit === utFrequency.unit);
    /** Form field values and handlers */ const [amount, setAmount] = (0, $6uYXW.useState)(paymentTransactionAmountInformation.instructedAmount);
    const [message, setMessage] = (0, $6uYXW.useState)(remittanceInformation?.value ?? "");
    const [startDate, setStartDate] = (0, $6uYXW.useState)(firstExecutionDate);
    const [frequency, setFrequency] = (0, $6uYXW.useState)(utFrequencyOption);
    const [endDate, setEndDate] = (0, $6uYXW.useState)(utEndDate);
    const closeModal = ()=>{
        (0, $5Wai4.Modal).dismiss((0, $bQhUC.EDIT_UPCOMING_TRANSFER_MODAL_ID));
    };
    const handleConfirm = ()=>{
        const modifiedTransfer = {
            endDate: endDate,
            firstExecutionDate: startDate,
            frequency: frequency?.frequency,
            paymentTransaction: {
                paymentTransactionAmountInformation: {
                    instructedAmount: amount
                },
                paymentTransactionDedicatedInformations: {
                    remittanceInformation: {
                        value: message
                    }
                }
            }
        };
        onConfirm(modifiedTransfer);
        closeModal();
    };
    return /*#__PURE__*/ (0, $4m918.jsxs)($dcb50ff1900b9108$var$ModalContainer, {
        closeButton: true,
        id: (0, $bQhUC.EDIT_UPCOMING_TRANSFER_MODAL_ID),
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($dcb50ff1900b9108$var$Heading, {
                children: formatMessage("upcomingTransfers.editTransfer")
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($dcb50ff1900b9108$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "upcomingTransfers.scheduledAmount",
                        htmlFor: "scheduledAmount"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $5rJrd.AmountInput), {
                        variant: "big",
                        value: amount,
                        onChange: setAmount,
                        id: "scheduledAmount"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        size: "normal",
                        margin: "normal",
                        label: "upcomingTransfers.message",
                        htmlFor: "message"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        value: message,
                        onChange: (event)=>setMessage(event.target.value),
                        id: "message"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        label: "upcomingTransfers.startDate",
                        size: "normal",
                        margin: "normal",
                        htmlFor: "startDate"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        id: "startDate",
                        value: startDate,
                        type: "date",
                        onChange: (date)=>setStartDate(date.target.value),
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        label: "upcomingTransfers.frequency",
                        size: "normal",
                        margin: "normal",
                        htmlFor: "frequency"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $39jSd.SelectInput), {
                        innerId: "frequency",
                        value: frequency,
                        options: (0, $bGuuW.RECURRING_TRANSFER_FREQUENCY_OPTIONS),
                        itemRenderer: (v)=>formatMessage(v.label),
                        onChange: setFrequency,
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $k5s21.default), {
                        label: "upcomingTransfers.endDate",
                        size: "normal",
                        margin: "normal",
                        htmlFor: "endDate"
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $9mlIh.TextInput), {
                        id: "endDate",
                        value: endDate,
                        type: "date",
                        onChange: (date)=>setEndDate(date.target.value)
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($dcb50ff1900b9108$var$ConfirmButton, {
                        size: "M",
                        onClick: handleConfirm,
                        children: formatMessage("upcomingTransfers.confirmButton")
                    })
                ]
            })
        ]
    });
};
const $dcb50ff1900b9108$var$ModalContainer = (0, $jb8NR.default)((0, $iy3Ex.RoundedModalContainer))`
  margin-top: 5vh;
  padding: 20px 40px;
`;
const $dcb50ff1900b9108$var$Heading = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).boldText};
  font-size: 1.375rem;
  margin-top: 30px;
`;
const $dcb50ff1900b9108$var$Container = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $dcb50ff1900b9108$var$ConfirmButton = (0, $jb8NR.default)((0, $7Zu6k.PrimaryButton))`
  margin-top: 40px;
  margin-bottom: 30px;
  align-self: center;
`;

});

parcelRegister("4VMAf", function(module, exports) {

$parcel$export(module.exports, "UpcomingTransferItem", function () { return $673d68fc4e02bd0f$export$41596d3dad2e72fd; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $bGuuW = parcelRequire("bGuuW");

var $9jV7u = parcelRequire("9jV7u");

var $bZlaH = parcelRequire("bZlaH");

var $4nSeL = parcelRequire("4nSeL");

var $22v9q = parcelRequire("22v9q");

var $7vTNS = parcelRequire("7vTNS");
const $673d68fc4e02bd0f$export$41596d3dad2e72fd = ({ transfer: transfer, hasStandingOrderUpdateActivated: hasStandingOrderUpdateActivated, hasStandingOrderDeleteActivated: hasStandingOrderDeleteActivated, handleUpcomingTransferDelete: handleUpcomingTransferDelete, handleUpcomingTransferStatus: handleUpcomingTransferStatus, handleUpcomingTransferEdit: handleUpcomingTransferEdit, handleUpcomingTransferDetail: handleUpcomingTransferDetail })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $6uYXW.useState)(false);
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const handleToggleMenu = ()=>setIsMenuOpen((bool)=>!bool);
    const handleEdit = ()=>{
        handleUpcomingTransferEdit(transfer);
        handleToggleMenu();
    };
    const handlePause = ()=>{
        handleUpcomingTransferStatus(transfer);
        handleToggleMenu();
    };
    const handleDelete = ()=>{
        handleUpcomingTransferDelete(transfer);
        handleToggleMenu();
    };
    const matchingFrequency = (0, $bGuuW.RECURRING_TRANSFER_FREQUENCY_OPTIONS).find((option)=>option.frequency.unit === transfer.frequency.unit && option.frequency.interval === transfer.frequency.interval);
    const hasPauseEditEnabled = hasStandingOrderUpdateActivated && [
        (0, $9jV7u.UpcomingTransferStatus).ACTIVATED,
        (0, $9jV7u.UpcomingTransferStatus).DEACTIVATED
    ].includes(transfer.status);
    return /*#__PURE__*/ (0, $4m918.jsxs)($673d68fc4e02bd0f$var$StyledUpcomingTransfer, {
        onClick: ()=>handleUpcomingTransferDetail(transfer),
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($673d68fc4e02bd0f$var$BoldText, {
                        children: transfer.paymentTransaction.paymentTransactionParties.creditor.name
                    }),
                    /*#__PURE__*/ (0, $4m918.jsxs)($673d68fc4e02bd0f$var$FrequencyText, {
                        children: [
                            matchingFrequency && /*#__PURE__*/ (0, $4m918.jsx)("span", {
                                children: formatMessage(matchingFrequency.label)
                            }),
                            " -",
                            " ",
                            formatMessage("upcomingTransfers.nextOn"),
                            " ",
                            formatDate(transfer.nextExecutionDate, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($673d68fc4e02bd0f$var$StatusAndAmountWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $7vTNS.UpcomingTransferStatusPill), {
                        status: transfer.status
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($673d68fc4e02bd0f$var$StyledAmountText, {
                        disabled: isMenuOpen,
                        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bZlaH.AmountText), {
                            amount: transfer.paymentTransaction.paymentTransactionAmountInformation.instructedAmount
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $4nSeL.default), {
                isRTL: false,
                isOpen: isMenuOpen,
                isPaused: transfer.status === (0, $9jV7u.UpcomingTransferStatus).DEACTIVATED,
                onToggle: handleToggleMenu,
                onPause: handlePause,
                onEdit: handleEdit,
                onDelete: handleDelete,
                enableEdit: hasPauseEditEnabled,
                enablePause: hasPauseEditEnabled,
                enableDelete: hasStandingOrderDeleteActivated
            })
        ]
    });
};
const $673d68fc4e02bd0f$var$BoldText = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).bodyBlackBold}
  font-size: 16px;
`;
const $673d68fc4e02bd0f$var$FrequencyText = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).bodySmallGreyRegular}
`;
const $673d68fc4e02bd0f$var$StatusAndAmountWrapper = (0, $jb8NR.default).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $673d68fc4e02bd0f$var$StyledAmountText = (0, $jb8NR.default).div`
  display: flex;
  width: 120px;
  justify-content: flex-end;
  transition: opacity 0.3s;
  opacity: ${({ disabled: disabled })=>disabled ? 0 : 1};
  ${(0, $22v9q.theme).bodyBlackBold}
`;
const $673d68fc4e02bd0f$var$StyledUpcomingTransfer = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 100px 20px 30px;
  border-radius: 13px;
  background-color: #ffffff;
  align-self: stretch;
  margin-top: 15px;
  cursor: pointer;
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.05);
  }
`;

});


parcelRegister("dYYgR", function(module, exports) {

$parcel$export(module.exports, "AuthNavRoute", function () { return $968bcc55ffc86814$export$548a4ac9008b4aee; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $4cqR9 = parcelRequire("4cqR9");

var $4fYE4 = parcelRequire("4fYE4");
/** Screens that open with a title of their own, so the greeting band would double up. */ const $968bcc55ffc86814$var$PATHS_WITH_OWN_TITLE = [
    (0, $4fYE4.Path).MyAccount,
    (0, $4fYE4.Path).AccountStatements,
    (0, $4fYE4.Path).FeesStatements,
    (0, $4fYE4.Path).Cards,
    (0, $4fYE4.Path).AllCards,
    (0, $4fYE4.Path).AllTransactions,
    (0, $4fYE4.Path).ProfileMenu
];
const $968bcc55ffc86814$export$548a4ac9008b4aee = (props)=>{
    const isConnected = (0, $3Ersk.useObservable)((0, $kqXxS.authenticationManager).isConnected);
    const { path: path } = props;
    const isPathIncluded = (path)=>{
        const basePaths = [
            (0, $4fYE4.TRANSFER_BASE_PATH),
            (0, $4fYE4.SAVING_BASE_PATH)
        ];
        return basePaths.some((basePath)=>path.includes(basePath));
    };
    return isConnected ? /*#__PURE__*/ (0, $4m918.jsx)((0, $4cqR9.PageWithNav), {
        withTitle: isPathIncluded(path) ? false : path !== (0, $4fYE4.Path).JustifyTransaction && !$968bcc55ffc86814$var$PATHS_WITH_OWN_TITLE.includes(path),
        children: /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
            ...props
        })
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
        to: {
            pathname: (0, $4fYE4.Path).Root
        }
    });
};

});
parcelRegister("4cqR9", function(module, exports) {

$parcel$export(module.exports, "PageWithNav", function () { return $0710c21df6d16d02$export$2a53c1751c024a97; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $6JczY = parcelRequire("6JczY");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $2Rggt = parcelRequire("2Rggt");

var $3Ersk = parcelRequire("3Ersk");

var $2kPnn = parcelRequire("2kPnn");

var $bQhUC = parcelRequire("bQhUC");

var $4fYE4 = parcelRequire("4fYE4");

var $7N0kU = parcelRequire("7N0kU");

var $yYT9n = parcelRequire("yYT9n");

var $8AYV6 = parcelRequire("8AYV6");

var $h7PnF = parcelRequire("h7PnF");

var $ahCyz = parcelRequire("ahCyz");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $bewhU = parcelRequire("bewhU");

var $jn1mK = parcelRequire("jn1mK");

var $5Wai4 = parcelRequire("5Wai4");

var $gRdp9 = parcelRequire("gRdp9");

var $cAn8H = parcelRequire("cAn8H");

var $gf1iA = parcelRequire("gf1iA");

var $1VCpi = parcelRequire("1VCpi");
function $0710c21df6d16d02$export$2a53c1751c024a97(props) {
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { client: client, loading: loading } = (0, $7N0kU.useClient)();
    const location = (0, $NQIVp.useLocation)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const { withTitle: withTitle = true } = props;
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    (0, $2kPnn.usePromptPincodeChangeAfterAuthentication)();
    const displayName = (0, $2Rggt.useClientDisplayName)(client, true);
    // A screen may host the alerts itself by mounting a PageAlertsSlot; until one does, they stay
    // above the content, which is what every screen but the home does.
    const [alertsSlot, setAlertsSlot] = (0, $6uYXW.useState)(null);
    const registerAlertsSlot = (0, $6uYXW.useCallback)((node)=>setAlertsSlot(node), []);
    if (!loading && !client && features.clientInformationView) return /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
        to: {
            pathname: (0, $4fYE4.Path).Root
        }
    });
    const onOnboardingFilePage = location.pathname === (0, $4fYE4.Path).OnboardingFile;
    // The account and card pages carry their own content; the status cards belong to the home.
    const showAlerts = ![
        (0, $4fYE4.Path).MyAccount,
        (0, $4fYE4.Path).AccountStatements,
        (0, $4fYE4.Path).FeesStatements,
        (0, $4fYE4.Path).Cards,
        (0, $4fYE4.Path).AllCards,
        (0, $4fYE4.Path).AllTransactions,
        (0, $4fYE4.Path).JustifyTransaction,
        (0, $4fYE4.Path).ProfileMenu,
        (0, $4fYE4.Path).Profile,
        (0, $4fYE4.Path).Settings
    ].includes(location.pathname);
    const alerts = /*#__PURE__*/ (0, $4m918.jsxs)($0710c21df6d16d02$var$AlertContainer, {
        children: [
            client?.status === (0, $2Rggt.ClientStatus).Pending || client?.status === (0, $2Rggt.ClientStatus).Initiated ? /*#__PURE__*/ (0, $4m918.jsxs)($0710c21df6d16d02$var$PendingCard, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($0710c21df6d16d02$var$CardIconImage, {
                        src: (0, $fRvTz.StaticAssets).countdown,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("span", {
                        children: formatMessage("clientStatus.accountUnderReview")
                    })
                ]
            }) : null,
            client?.status === (0, $2Rggt.ClientStatus).Blocked || client?.status === (0, $2Rggt.ClientStatus).Iniblocked ? /*#__PURE__*/ (0, $4m918.jsxs)($0710c21df6d16d02$var$ErrorMessageWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $jn1mK.ErrorMessage), {
                        children: formatMessage("clientStatus.clientBlockedMessage")
                    }),
                    location.pathname !== (0, $4fYE4.Path).AccountBlocked && location.pathname !== (0, $4fYE4.Path).AccountBlockedAfterPincodeError && /*#__PURE__*/ (0, $4m918.jsx)($0710c21df6d16d02$var$MoreLink, {
                        to: (0, $4fYE4.Path).AccountBlocked,
                        $isRTL: isRTL,
                        children: formatMessage("clientStatus.clientBlockedLink")
                    })
                ]
            }) : null,
            client?.mustChangePincode ? /*#__PURE__*/ (0, $4m918.jsxs)($0710c21df6d16d02$var$InformationMessage, {
                children: [
                    formatMessage("pincodeChangeScreen.messageAfterAuthentication") + " ",
                    /*#__PURE__*/ (0, $4m918.jsx)($0710c21df6d16d02$var$InlineButton, {
                        onClick: ()=>(0, $5Wai4.Modal).present((0, $bQhUC.PINCODE_MUST_BE_CHANGED_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $ahCyz.PincodeChangeModal), {
                                    type: "after-authentication"
                                }), {
                                canBeDismissed: false
                            }),
                        children: formatMessage("pincodeChangeScreen.changePincodeButton")
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $4m918.jsx)((0, $8AYV6.OnboardingFileDelegateErrorStatusCard), {}),
            /*#__PURE__*/ (0, $4m918.jsx)((0, $h7PnF.OnboardingFileStatusCard), {})
        ]
    });
    return /*#__PURE__*/ (0, $4m918.jsx)($0710c21df6d16d02$var$Page, {
        children: /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
            children: [
                !onOnboardingFilePage && /*#__PURE__*/ (0, $4m918.jsx)((0, $gRdp9.Nav), {}),
                /*#__PURE__*/ (0, $4m918.jsx)($0710c21df6d16d02$var$Content, {
                    $withNav: !onOnboardingFilePage,
                    $isRTL: isRTL,
                    children: /*#__PURE__*/ (0, $4m918.jsxs)((0, $gf1iA.PageAlertsSlotContext).Provider, {
                        value: registerAlertsSlot,
                        children: [
                            !onOnboardingFilePage && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                                children: [
                                    withTitle && /*#__PURE__*/ (0, $4m918.jsxs)((0, $1VCpi.PageHeaderBand), {
                                        children: [
                                            /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderSubtitle), {
                                                children: formatMessage("connectedUserGreetings.hello")
                                            }),
                                            !!displayName && /*#__PURE__*/ (0, $4m918.jsx)((0, $1VCpi.PageHeaderTitle), {
                                                children: displayName
                                            })
                                        ]
                                    }),
                                    showAlerts && !alertsSlot && alerts
                                ]
                            }),
                            props.children,
                            showAlerts && !onOnboardingFilePage && alertsSlot && /*#__PURE__*/ (0, $6JczY.createPortal)(alerts, alertsSlot)
                        ]
                    })
                })
            ]
        })
    });
}
/* Stretching lets the content column paint its background down to the bottom of the window. */ const $0710c21df6d16d02$var$Page = (0, $jb8NR.default).div`
  display: flex;
  align-items: stretch;
  min-height: 100vh;
  width: 100%;
  background-color: #fbfbfb;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    flex-direction: column;
  }
`;
const $0710c21df6d16d02$var$Content = (0, $jb8NR.default)((0, $cAn8H.ResponsiveContainer))`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 15vh;
  background-color: #fbfbfb;
`;
const $0710c21df6d16d02$var$CardIconImage = (0, $jb8NR.default).img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 1px;
`;
const $0710c21df6d16d02$var$AlertContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const $0710c21df6d16d02$var$ErrorMessageWrapper = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  margin-top: -20px;
  margin-bottom: 40px;
`;
const $0710c21df6d16d02$var$MoreLink = (0, $jb8NR.default)((0, $bewhU.DefaultLink))`
  margin-left: ${(props)=>props.$isRTL ? 0 : 10}px;
  margin-right: ${(props)=>props.$isRTL ? 10 : 0}px;

  font-size: 0.875rem;
  ${(0, $22v9q.theme).mediumText};
  text-decoration: underline;
  color: #000;
`;
const $0710c21df6d16d02$var$InlineButton = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  display: inline-block;
  font-size: 0.875rem;
  ${(0, $22v9q.theme).mediumText};
  padding: 0;
  text-decoration: underline;
`;
/* A neutral card in the side column, not the inline warning it used to be above the content. */ const $0710c21df6d16d02$var$InformationMessage = (0, $jb8NR.default)((0, $jn1mK.ErrorMessage))`
  display: block;
  padding: 16px;
  border-radius: 13px;
  background-color: ${(0, $22v9q.theme).colors.gray[100]};
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $0710c21df6d16d02$var$PendingCard = (0, $jb8NR.default)($0710c21df6d16d02$var$InformationMessage)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  ${(0, $22v9q.theme).text};
  font-size: 14px;
  line-height: 19px;
  color: #000000;
`;

});
parcelRegister("2kPnn", function(module, exports) {

$parcel$export(module.exports, "usePromptPincodeChangeAfterAuthentication", function () { return $10ad2f8071040f15$export$d88acec222ec08b3; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $5Wai4 = parcelRequire("5Wai4");

var $ahCyz = parcelRequire("ahCyz");

var $bQhUC = parcelRequire("bQhUC");
const $10ad2f8071040f15$export$d88acec222ec08b3 = ()=>{
    const shouldPromptPincodeChange = (0, $3Ersk.useObservable)((0, $kqXxS.webAppStartManager).shouldPromptPincodeChange);
    (0, $6uYXW.useEffect)(()=>{
        if (shouldPromptPincodeChange) {
            (0, $5Wai4.Modal).present((0, $bQhUC.PINCODE_MUST_BE_CHANGED_MODAL_ID), ()=>/*#__PURE__*/ (0, $4m918.jsx)((0, $ahCyz.PincodeChangeModal), {
                    type: "after-authentication"
                }), {
                canBeDismissed: false
            });
            (0, $kqXxS.webAppStartManager).hasPromptPincodeChange();
        }
    }, [
        shouldPromptPincodeChange
    ]);
};

});

parcelRegister("8AYV6", function(module, exports) {

$parcel$export(module.exports, "OnboardingFileDelegateErrorStatusCard", function () { return $2033ee9681dd0e62$export$99e2d1d4ff8ae299; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $cKILb = parcelRequire("cKILb");

var $22v9q = parcelRequire("22v9q");

const $2033ee9681dd0e62$export$99e2d1d4ff8ae299 = ()=>{
    const { clientDelegateErrorDetected: clientDelegateErrorDetected } = (0, $cKILb.useOnboardingFile)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    return clientDelegateErrorDetected ? /*#__PURE__*/ (0, $4m918.jsx)($2033ee9681dd0e62$var$Container, {
        children: /*#__PURE__*/ (0, $4m918.jsxs)($2033ee9681dd0e62$var$TitleContainer, {
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($2033ee9681dd0e62$var$Title, {
                    children: formatMessage("onboardingDelegateErrorStatusCard.title")
                }),
                /*#__PURE__*/ (0, $4m918.jsx)($2033ee9681dd0e62$var$WarningIconImage, {
                    src: {},
                    alt: ""
                })
            ]
        })
    }) : null;
};
const $2033ee9681dd0e62$var$Container = (0, $jb8NR.default).div`
  flex: 1;
  background-color: #ffecd1;
  border-radius: 13px;
  padding: 16px;
`;
const $2033ee9681dd0e62$var$TitleContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;
const $2033ee9681dd0e62$var$Title = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).bodyBlackBold}
  color: #000000;
  flex-grow: 1;
  flex-shrink: 1;
  padding-right: 8px;
`;
const $2033ee9681dd0e62$var$WarningIconImage = (0, $jb8NR.default).img`
  width: 24px;
  height: 24px;
`;

});

parcelRegister("h7PnF", function(module, exports) {

$parcel$export(module.exports, "OnboardingFileStatusCard", function () { return $cdeed65ae288671e$export$748e04d18b806475; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $kqXxS = parcelRequire("kqXxS");

var $cPJq2 = parcelRequire("cPJq2");

var $cKILb = parcelRequire("cKILb");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");

var $bewhU = parcelRequire("bewhU");

var $51d3M = parcelRequire("51d3M");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");
const $cdeed65ae288671e$export$748e04d18b806475 = ()=>{
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const client = (0, $3Ersk.useObservable)((0, $kqXxS.clientManager).client);
    const { onboardingFile: onboardingFile } = (0, $cKILb.useOnboardingFile)();
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const history = (0, $NQIVp.useHistory)();
    const handleEditOnboardingFile = (0, $6uYXW.useCallback)(async ()=>{
        if (features.sdaCustomerOnboardingUpdate) history.push((0, $4fYE4.Path).OnboardingFile);
    }, []);
    const mustRetakeOnboarding = onboardingFile && (0, $cPJq2.MUST_RETAKE_ONBOARDING_FILE_STATUSES).includes(onboardingFile.status);
    // requiredActions is either a single object carrying a reason, or a list of KYC actions.
    const requiredActions = client?.requiredActions;
    const reason = requiredActions && !Array.isArray(requiredActions) ? requiredActions.reason : undefined;
    return mustRetakeOnboarding ? /*#__PURE__*/ (0, $4m918.jsxs)($cdeed65ae288671e$var$Container, {
        disabled: !features.sdaCustomerOnboardingUpdate,
        onClick: handleEditOnboardingFile,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($cdeed65ae288671e$var$CardIcon, {
                src: (0, $fRvTz.StaticAssets).warningCircle,
                alt: ""
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($cdeed65ae288671e$var$Texts, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($cdeed65ae288671e$var$Title, {
                        children: formatMessage("onboardingStatusCard.button")
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($cdeed65ae288671e$var$Subtitle, {
                        children: reason || formatMessage("onboardingStatusCard.title")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($cdeed65ae288671e$var$Chevron, {
                width: 14,
                height: 14
            })
        ]
    }) : null;
};
/* The whole card is the action now, so the underlined button it used to carry is gone. */ const $cdeed65ae288671e$var$Container = (0, $jb8NR.default)((0, $bewhU.UnstyledButton))`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  width: 100%;
  padding: 16px;
  border-radius: 13px;
  background-color: #eef4fc;
  text-align: left;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;
const $cdeed65ae288671e$var$CardIcon = (0, $jb8NR.default).img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
`;
const $cdeed65ae288671e$var$Texts = (0, $jb8NR.default).div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const $cdeed65ae288671e$var$Title = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).mediumText};
  font-size: 16px;
  line-height: 20px;
  color: ${(0, $22v9q.theme).colors.blue[800]};
`;
const $cdeed65ae288671e$var$Subtitle = (0, $jb8NR.default).div`
  ${(0, $22v9q.theme).text};
  margin-top: 4px;
  font-size: 14px;
  line-height: 19px;
  color: ${(0, $22v9q.theme).colors.gray[800]};
`;
const $cdeed65ae288671e$var$Chevron = (0, $jb8NR.default)((0, $51d3M.ChevronIcon))`
  flex-shrink: 0;
  margin-top: 3px;
  fill: ${(0, $22v9q.theme).colors.blue[800]};
`;

});

parcelRegister("gRdp9", function(module, exports) {

$parcel$export(module.exports, "Nav", function () { return $38b2535a3dc54aa1$export$39140c7d8b0ba7b3; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $b8ojz = parcelRequire("b8ojz");
var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $kqXxS = parcelRequire("kqXxS");

var $cPJq2 = parcelRequire("cPJq2");

var $cKILb = parcelRequire("cKILb");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");

var $7N0kU = parcelRequire("7N0kU");

var $yYT9n = parcelRequire("yYT9n");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $2JvJH = parcelRequire("2JvJH");

var $7nV9p = parcelRequire("7nV9p");

var $b0trd = parcelRequire("b0trd");

var $2lWSH = parcelRequire("2lWSH");
function $38b2535a3dc54aa1$var$Menu(props) {
    const { onItemClick: onItemClick } = props;
    const { pathname: pathname } = (0, $NQIVp.useLocation)();
    const features = (0, $3Ersk.useObservable)((0, $kqXxS.featuresManager).features);
    const { onboardingFile: onboardingFile } = (0, $cKILb.useOnboardingFile)();
    const { client: client } = (0, $7N0kU.useClient)();
    const [isMenuVisible, setIsMenuVisible] = (0, $6uYXW.useState)(false);
    const transfertSubItems = (0, $6uYXW.useMemo)(()=>{
        const subItems = [];
        if (features.p2pTransfer) subItems.push({
            title: "transfertsSubmenu.allTransfer",
            path: (0, $4fYE4.Path).Transfer
        });
        if ((0, $kqXxS.configurationManager).isSimplePayment() && features.p2pSimpleTransfer) subItems.push({
            title: "transfertsSubmenu.simpleTransfer",
            path: (0, $4fYE4.Path).SimpleTransfer
        });
        if (features.p2pCashTransfer) subItems.push({
            title: "transfertsSubmenu.cashTransfer",
            path: (0, $4fYE4.Path).CashTransfers
        });
        if (features.paymentStandingOrderView && features.customerInstructionInitiation) subItems.push({
            title: "transfertsSubmenu.upcomingTransfers",
            path: (0, $4fYE4.Path).UpcomingTransfers
        });
        if (features.bankToWallet || features.walletRechargeByCard) subItems.push({
            title: "transfertsSubmenu.recharge",
            path: (0, $4fYE4.Path).Recharge
        });
        if (features.transactionCode) subItems.push({
            title: "transfertsSubmenu.transactionCode",
            path: (0, $4fYE4.Path).TransactionCodes
        });
        if (features.externalAccountsManagement || features.beneficiariesManagement) subItems.push({
            title: "transfertsSubmenu.recipients",
            path: (0, $4fYE4.Path).Recipients
        });
        return subItems;
    }, [
        features
    ]);
    const savingsSubItems = (0, $6uYXW.useMemo)(()=>{
        const subItems = [];
        if (features.savProductRead && features.savContractWrite) subItems.push({
            title: "savingsSubmenu.createSavingsAccount",
            path: (0, $4fYE4.Path).CreateSavingAccount
        });
        return subItems;
    }, [
        features
    ]);
    const canShowTransferMenu = features.p2pTransfer || features.p2pCashTransfer || features.bankToWallet || features.walletRechargeByCard || features.transactionCode || features.externalAccountsManagement || features.beneficiariesManagement;
    const navigationItems = [
        {
            path: (0, $4fYE4.Path).AccountTransactions,
            type: "account",
            isEnabled: true
        },
        {
            path: (0, $4fYE4.Path).TransferMenu,
            type: "transfers",
            isEnabled: canShowTransferMenu,
            subItems: transfertSubItems
        },
        {
            path: (0, $4fYE4.Path).BillIssuers,
            type: "services",
            isEnabled: features.billPayment
        },
        {
            path: (0, $4fYE4.Path).Cards,
            type: "cards",
            isEnabled: features.cards
        },
        {
            path: (0, $4fYE4.Path).SavingMenu,
            type: "savings",
            isEnabled: features.savProductRead && features.savContractWrite,
            subItems: savingsSubItems
        },
        {
            path: (0, $4fYE4.Path).Loans,
            type: "loan",
            isEnabled: features.consultLoans
        },
        {
            path: (0, $4fYE4.Path).Mandates,
            type: "mandates",
            isEnabled: features.mandateView
        },
        {
            path: (0, $4fYE4.Path).ProfileMenu,
            type: "profile",
            isEnabled: true,
            matchPaths: [
                (0, $4fYE4.Path).Profile,
                (0, $4fYE4.Path).Settings
            ]
        }
    ];
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)((0, $2lWSH.default), {
                isMenuVisible: isMenuVisible,
                toggleMenu: ()=>setIsMenuVisible((prev)=>!prev)
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($38b2535a3dc54aa1$var$MenuContainer, {
                role: "menu",
                $isRTL: isRTL,
                $isVisible: isMenuVisible,
                "data-testid": "menu",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($38b2535a3dc54aa1$var$Logo, {
                        alt: "",
                        src: (0, $fRvTz.StaticAssets).brandLogo,
                        "data-testid": "logo"
                    }),
                    onboardingFile?.status !== (0, $cPJq2.OnboardingStatus).PENDING_VERIFICATION && /*#__PURE__*/ (0, $4m918.jsx)((0, $4m918.Fragment), {
                        children: navigationItems.map((item)=>{
                            const isActive = [
                                item.path,
                                ...item.matchPaths ?? []
                            ].some((path)=>pathname.startsWith(path));
                            return item.isEnabled ? item.subItems && item.subItems.length > 0 ? /*#__PURE__*/ (0, $4m918.jsx)((0, $7nV9p.SubMenu), {
                                items: item.subItems,
                                isActive: isActive,
                                onClick: ()=>onItemClick?.(),
                                children: /*#__PURE__*/ (0, $4m918.jsx)($38b2535a3dc54aa1$var$StyledNavButton, {
                                    linkType: item.type,
                                    isActive: isActive,
                                    withBackground: false
                                })
                            }, item.type) : /*#__PURE__*/ (0, $4m918.jsx)($38b2535a3dc54aa1$var$StyledLink, {
                                to: item.path,
                                onClick: ()=>onItemClick?.(),
                                children: /*#__PURE__*/ (0, $4m918.jsx)($38b2535a3dc54aa1$var$StyledNavButton, {
                                    linkType: item.type,
                                    isActive: isActive
                                })
                            }, item.type) : null;
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($38b2535a3dc54aa1$var$Spacer, {}),
                    /*#__PURE__*/ (0, $4m918.jsx)((0, $2JvJH.BottomNav), {
                        client: client,
                        onDisconnectClick: async ()=>{
                            await (0, $kqXxS.authenticationManager).logout();
                            await (0, $kqXxS.clientManager).clear();
                        },
                        onProfileClick: ()=>props.onItemClick?.()
                    })
                ]
            })
        ]
    });
}
function $38b2535a3dc54aa1$export$39140c7d8b0ba7b3() {
    return /*#__PURE__*/ (0, $4m918.jsx)($38b2535a3dc54aa1$var$Menu, {});
}
const $38b2535a3dc54aa1$var$MenuContainer = (0, $jb8NR.default).nav`
  flex: 0 0 auto;
  position: fixed;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: ${(props)=>props.$isRTL ? "unset" : `${(0, $7XqbX.UIConstants).NAV_LEFT_MARGIN_DESKTOP_SMALL}px`};
  right: ${(props)=>props.$isRTL ? `${(0, $7XqbX.UIConstants).NAV_LEFT_MARGIN_DESKTOP_SMALL}px` : "unset"};
  display: flex;
  flex-direction: column;
  padding: 19px 0 0 0;
  background: ${(0, $22v9q.theme).brandGradient};
  height: auto;
  min-width: ${(0, $7XqbX.UIConstants).NAV_WIDTH}px;

  /* Only the drawer's slide animates. A bare "transition: 0.5s" animated every property the band
     has, so a scrollbar appearing or a repaint swept the whole gradient across half a second. */
  transition:
    transform 0.5s,
    opacity 0.5s;

  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    padding-top: 80px;
    opacity: ${(props)=>props.$isVisible ? "1" : "0"};
    transform: ${(props)=>props.$isVisible ? "none" : "translateX(-100%)"};
    left: 0;
    bottom: 0;
  }
  ${(0, $22v9q.shadows).medium};
`;
const $38b2535a3dc54aa1$var$Logo = (0, $jb8NR.default).img`
  align-self: center;
  width: 150px;
  height: auto;
  object-fit: contain;
  margin: 12px 0 32px;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    margin-bottom: 10px;
    display: none;
  }
`;
const $38b2535a3dc54aa1$var$StyledNavButton = (0, $jb8NR.default)((0, $b0trd.NavButton))`
  &:not(:last-of-type) {
    margin-bottom: 2px;
  }
`;
const $38b2535a3dc54aa1$var$StyledLink = (0, $jb8NR.default)((0, $b8ojz.Link))`
  width: 100%;
  display: flex;
  justify-content: stretch;
  margin-bottom: 2px;
`;
const $38b2535a3dc54aa1$var$Spacer = (0, $jb8NR.default).div`
  flex: 1 1 auto;
`;

});
parcelRegister("2JvJH", function(module, exports) {

$parcel$export(module.exports, "BottomNav", function () { return $04cd35ea3681f2d2$export$b77dc13a7753f3ee; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $b8ojz = parcelRequire("b8ojz");

var $jb8NR = parcelRequire("jb8NR");

var $2Rggt = parcelRequire("2Rggt");

var $4fYE4 = parcelRequire("4fYE4");

var $22v9q = parcelRequire("22v9q");

var $i6C9P = parcelRequire("i6C9P");

var $f5HsK = parcelRequire("f5HsK");

var $bWqV3 = parcelRequire("bWqV3");

var $bOc9W = parcelRequire("bOc9W");
function $04cd35ea3681f2d2$export$b77dc13a7753f3ee(props) {
    const { onDisconnectClick: onDisconnectClick, onProfileClick: onProfileClick, client: client } = props;
    const displayName = (0, $2Rggt.useClientDisplayName)(client, true);
    const initials = [
        client?.firstName,
        client?.lastName
    ].map((part)=>part?.trim()?.[0]).filter(Boolean).join("").toUpperCase();
    return /*#__PURE__*/ (0, $4m918.jsxs)($04cd35ea3681f2d2$var$BottomContainer, {
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($04cd35ea3681f2d2$var$Separator, {}),
            /*#__PURE__*/ (0, $4m918.jsxs)($04cd35ea3681f2d2$var$BottomWrapper, {
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($04cd35ea3681f2d2$var$ProfileContainer, {
                        children: !!client && /*#__PURE__*/ (0, $4m918.jsxs)((0, $4m918.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4m918.jsx)($04cd35ea3681f2d2$var$UserButton, {
                                    to: (0, $4fYE4.Path).Profile,
                                    onClick: onProfileClick,
                                    children: /*#__PURE__*/ (0, $4m918.jsx)((0, $i6C9P.GlassAvatar), {
                                        initials: initials,
                                        size: 48
                                    })
                                }),
                                /*#__PURE__*/ (0, $4m918.jsxs)($04cd35ea3681f2d2$var$ProfileInfos, {
                                    children: [
                                        displayName && /*#__PURE__*/ (0, $4m918.jsx)($04cd35ea3681f2d2$var$Name, {
                                            children: displayName
                                        }),
                                        client?.email ? /*#__PURE__*/ (0, $4m918.jsx)($04cd35ea3681f2d2$var$Email, {
                                            children: client.email
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)($04cd35ea3681f2d2$var$DisconnectCircle, {
                        size: 35,
                        onClick: onDisconnectClick,
                        children: /*#__PURE__*/ (0, $4m918.jsx)($04cd35ea3681f2d2$var$DisconnectButton, {
                            size: 25,
                            children: /*#__PURE__*/ (0, $4m918.jsx)((0, $bWqV3.LogoutIcon), {})
                        })
                    })
                ]
            })
        ]
    });
}
const $04cd35ea3681f2d2$var$Email = (0, $jb8NR.default).span`
  margin-top: 2px;
  font-size: 0.75rem;
  color: ${(0, $bOc9W.sideBarColors).profile};
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $04cd35ea3681f2d2$var$BottomContainer = (0, $jb8NR.default).div`
  position: relative;
  bottom: 0;
  background-color: ${(0, $bOc9W.sideBarColors).bottomBackground};
  border-radius: 0 0 11px 11px;
  display: flex;
  flex-direction: column;
  flex: 0;
  height: auto;
  align-items: stretch;
`;
const $04cd35ea3681f2d2$var$Separator = (0, $jb8NR.default).div`
  margin: 0 16px;
  width: auto;
  height: 1px;
  align-self: center;
  background-color: ${(0, $bOc9W.sideBarColors).bottomSeparator};
`;
const $04cd35ea3681f2d2$var$BottomWrapper = (0, $jb8NR.default).div`
  background-color: ${(0, $bOc9W.sideBarColors).bottomBackground};
  border-radius: 0 0 11px 11px;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: auto;
  padding: 12px;
  align-items: center;
`;
const $04cd35ea3681f2d2$var$ProfileContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;
const $04cd35ea3681f2d2$var$UserButton = (0, $jb8NR.default)((0, $b8ojz.Link))`
  &:hover {
    cursor: pointer;
  }
`;
const $04cd35ea3681f2d2$var$DisconnectCircle = (0, $jb8NR.default)((0, $f5HsK.Circle))`
  border: solid 1px ${(0, $bOc9W.sideBarColors).disconnectCircle};
  margin: 10px;
  &:hover {
    cursor: pointer;
    border: solid 2px ${(0, $bOc9W.sideBarColors).disconnectCircle};
  }
`;
const $04cd35ea3681f2d2$var$DisconnectButton = (0, $jb8NR.default)((0, $f5HsK.Circle))`
  background-color: ${(0, $22v9q.theme).mainColor};
  &:hover {
    opacity: 0.8;
  }
`;
const $04cd35ea3681f2d2$var$ProfileInfos = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 8px;
  max-width: 140px;
  text-align: left;
`;
const $04cd35ea3681f2d2$var$Name = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).mediumText}
  font-size: 0.9375rem;
  color: ${(0, $bOc9W.sideBarColors).name};
  text-overflow: ellipsis;
  overflow: hidden;
`;

});
parcelRegister("i6C9P", function(module, exports) {

$parcel$export(module.exports, "GlassAvatar", function () { return $593a880ba50aa00b$export$234545e9d0bf9caf; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $22v9q = parcelRequire("22v9q");
const $593a880ba50aa00b$var$SPHERE_STROKE = 1.5;
/** Size of the mockup's initials, as a share of the sphere's diameter. */ const $593a880ba50aa00b$var$INITIALS_RATIO = 0.42;
function $593a880ba50aa00b$export$234545e9d0bf9caf({ initials: initials, size: size = 44, className: className }) {
    // Gradient ids live in the SVG document, so they are suffixed to survive two avatars on a page.
    const uid = (0, $6uYXW.useId)().replace(/[^a-zA-Z0-9]/g, "");
    const center = size / 2;
    return /*#__PURE__*/ (0, $4m918.jsxs)($593a880ba50aa00b$var$Container, {
        className: className,
        $size: size,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($593a880ba50aa00b$var$Sphere, {
                width: size,
                height: size,
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $4m918.jsxs)("linearGradient", {
                                id: `glassFill${uid}`,
                                x1: "0",
                                y1: "0",
                                x2: "1",
                                y2: "1",
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0.75",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0.24"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4m918.jsxs)("linearGradient", {
                                id: `glassRim${uid}`,
                                x1: "0",
                                y1: "0",
                                x2: "1",
                                y2: "1",
                                children: [
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0",
                                        stopColor: "#ffffff",
                                        stopOpacity: "1"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0.15",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0.9"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0.25",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0.15"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0.33",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0.04"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0.67",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0.04"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "0.8",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0.15"
                                    }),
                                    /*#__PURE__*/ (0, $4m918.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#ffffff",
                                        stopOpacity: "0.5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4m918.jsx)("circle", {
                        cx: center,
                        cy: center,
                        r: center - $593a880ba50aa00b$var$SPHERE_STROKE / 2,
                        fill: `url(#glassFill${uid})`,
                        stroke: `url(#glassRim${uid})`,
                        strokeWidth: $593a880ba50aa00b$var$SPHERE_STROKE
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($593a880ba50aa00b$var$Initials, {
                $fontSize: Math.round(size * $593a880ba50aa00b$var$INITIALS_RATIO),
                children: initials
            })
        ]
    });
}
const $593a880ba50aa00b$var$Container = (0, $jb8NR.default).div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${(props)=>props.$size}px;
  height: ${(props)=>props.$size}px;
`;
const $593a880ba50aa00b$var$Sphere = (0, $jb8NR.default).svg`
  position: absolute;
  inset: 0;
`;
const $593a880ba50aa00b$var$Initials = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).boldText};
  position: relative;
  font-size: ${(props)=>props.$fontSize}px;
  line-height: 1;
  color: #ffffff;
`;

});

parcelRegister("bWqV3", function(module, exports) {

$parcel$export(module.exports, "LogoutIcon", function () { return $98ab9f0921f9aca7$export$2c9e30524eeaa42e; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
const $98ab9f0921f9aca7$export$2c9e30524eeaa42e = (props)=>/*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M11.38 10.403a.879.879 0 1 1-1.76 0V4.246a.88.88 0 1 1 1.76 0v6.157zm-5.718 0a4.838 4.838 0 1 0 7.93-3.721.88.88 0 1 1 1.124-1.353 6.581 6.581 0 0 1 2.38 5.05c0 3.666-2.954 6.621-6.596 6.621s-6.597-2.955-6.597-6.621c0-2.015.928-3.84 2.38-5.05a.88.88 0 0 1 1.24.114c.286.374.259.928-.115 1.239a4.832 4.832 0 0 0-1.746 3.721z",
            fill: "#fff"
        })
    });

});

parcelRegister("bOc9W", function(module, exports) {

$parcel$export(module.exports, "sideBarColors", function () { return $38fc97a66211f21c$export$b845d387c031c746; });
// The sidebar sits on the brand gradient, so every value here reads against a dark blue.
const $38fc97a66211f21c$export$b845d387c031c746 = {
    background: "transparent",
    inactiveItem: "#ffffff",
    activeItem: "#ffffff",
    selectedBackground: "rgba(255, 255, 255, 0.12)",
    userCircle: "rgba(255, 255, 255, 0.16)",
    disconnectCircle: "rgba(255, 255, 255, 0.16)",
    bottomBackground: "transparent",
    bottomSeparator: "rgba(255, 255, 255, 0.16)",
    verticalLine: "rgba(255, 255, 255, 0.16)",
    name: "#ffffff",
    profile: "rgba(255, 255, 255, 0.7)",
    toolTipBackground: "#ffffff",
    toolTipText: "#0b293e"
};

});


parcelRegister("7nV9p", function(module, exports) {

$parcel$export(module.exports, "SubMenu", function () { return $187059d6eae806f8$export$a9c522a6d7beb830; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $5eMsz = parcelRequire("5eMsz");

var $b8ojz = parcelRequire("b8ojz");
var $NQIVp = parcelRequire("NQIVp");

var $jb8NR = parcelRequire("jb8NR");

var $yYT9n = parcelRequire("yYT9n");

var $9BpLd = parcelRequire("9BpLd");

var $b0trd = parcelRequire("b0trd");

var $bOc9W = parcelRequire("bOc9W");
const $187059d6eae806f8$export$a9c522a6d7beb830 = (props)=>{
    const { children: children, items: items, isActive: isActive, onClick: onClick } = props;
    const { pathname: pathname } = (0, $NQIVp.useLocation)();
    const [isOpen, setIsOpen] = (0, $6uYXW.useState)(false);
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5eMsz))), {
        onOutsideClick: ()=>{
            setIsOpen(false);
        },
        children: /*#__PURE__*/ (0, $4m918.jsxs)($187059d6eae806f8$var$SubMenuContainer, {
            role: "menu",
            children: [
                /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$SubItemsContainer, {
                    children: /*#__PURE__*/ (0, $4m918.jsxs)($187059d6eae806f8$var$SubItemsRow, {
                        onClick: ()=>setIsOpen((prev)=>!prev),
                        children: [
                            children,
                            /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$ChevronContainer, {
                                children: /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$Chevron, {
                                    color: isActive ? (0, $bOc9W.sideBarColors).activeItem : (0, $bOc9W.sideBarColors).inactiveItem,
                                    $isOpen: isOpen,
                                    $isRTL: isRTL
                                })
                            })
                        ]
                    })
                }),
                isOpen && /*#__PURE__*/ (0, $4m918.jsxs)($187059d6eae806f8$var$ExpandedSubMenu, {
                    children: [
                        /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$VerticalLine, {
                            $isRTL: isRTL
                        }),
                        /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$ExpandedItems, {
                            children: /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$SubMenuItems, {
                                items: items,
                                pathname: pathname,
                                onClick: onClick
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $187059d6eae806f8$var$SubMenuItems = (props)=>{
    const { items: items, pathname: pathname, onClick: onClick } = props;
    return items.map((subItem)=>{
        const isSubItemActive = pathname.startsWith(subItem.path);
        return /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$SubItemLink, {
            to: subItem.path,
            onClick: ()=>onClick?.(),
            children: /*#__PURE__*/ (0, $4m918.jsx)($187059d6eae806f8$var$StyledSubNavButton, {
                name: subItem.title,
                isActive: isSubItemActive
            })
        }, subItem.title);
    });
};
const $187059d6eae806f8$var$ChevronContainer = (0, $jb8NR.default).div`
  flex: 0;
  justify-content: center;
  align-items: center;
  margin: 12px;
  padding: 12px;
  &:hover {
    cursor: pointer;
  }
`;
const $187059d6eae806f8$var$Chevron = (0, $jb8NR.default)((0, $9BpLd.SmallChevronIcon))`
  width: 15px;
  height: 15px;
  transform: ${(props)=>props.$isOpen ? props.$isRTL ? "rotate(270deg)" : "rotate(-90deg)" : "rotate(90deg)"};
  transition: transform 0.3s ease-in;
`;
const $187059d6eae806f8$var$ExpandedSubMenu = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
`;
const $187059d6eae806f8$var$VerticalLine = (0, $jb8NR.default).div`
  margin: ${(props)=>props.$isRTL ? "0 40px 0 0" : "0 0 0 40px"};
  min-height: 100%;
  width: 1px;
  background-color: ${(0, $bOc9W.sideBarColors).verticalLine};
  z-index: 2;
`;
const $187059d6eae806f8$var$ExpandedItems = (0, $jb8NR.default).div`
  display: flex;
  margin-left: -40px;
  flex-direction: column;
`;
const $187059d6eae806f8$var$SubMenuContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $187059d6eae806f8$var$StyledSubNavButton = (0, $jb8NR.default)((0, $b0trd.SubNavButton))`
  &:not(:last-of-type) {
    margin-bottom: 2px;
  }
`;
const $187059d6eae806f8$var$SubItemLink = (0, $jb8NR.default)((0, $b8ojz.Link))``;
const $187059d6eae806f8$var$SubItemsContainer = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: column;
`;
const $187059d6eae806f8$var$SubItemsRow = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: stretch;
  align-items: center;
`;

});
parcelRegister("5eMsz", function(module, exports) {
// eslint-disable-next-line import/no-unresolved

module.exports = (parcelRequire("4csjl"));

});
parcelRegister("4csjl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $30ee3e615f57447d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6uYXW = parcelRequire("6uYXW");
var $30ee3e615f57447d$var$_react2 = $30ee3e615f57447d$var$_interopRequireDefault($6uYXW);

var $k8j0a = parcelRequire("k8j0a");
var $30ee3e615f57447d$var$_propTypes2 = $30ee3e615f57447d$var$_interopRequireDefault($k8j0a);

var $8HYn2 = parcelRequire("8HYn2");

var $fZ7WM = parcelRequire("fZ7WM");

var $2rzAd = parcelRequire("2rzAd");
var $30ee3e615f57447d$var$_object2 = $30ee3e615f57447d$var$_interopRequireDefault($2rzAd);

var $biMYV = parcelRequire("biMYV");
var $30ee3e615f57447d$var$_document2 = $30ee3e615f57447d$var$_interopRequireDefault($biMYV);
function $30ee3e615f57447d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $30ee3e615f57447d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $30ee3e615f57447d$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $30ee3e615f57447d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $30ee3e615f57447d$var$DISPLAY = {
    BLOCK: 'block',
    FLEX: 'flex',
    INLINE: 'inline',
    INLINE_BLOCK: 'inline-block',
    CONTENTS: 'contents'
};
var $30ee3e615f57447d$var$propTypes = (0, $8HYn2.forbidExtraProps)({
    children: $30ee3e615f57447d$var$_propTypes2['default'].node.isRequired,
    onOutsideClick: $30ee3e615f57447d$var$_propTypes2['default'].func.isRequired,
    disabled: $30ee3e615f57447d$var$_propTypes2['default'].bool,
    useCapture: $30ee3e615f57447d$var$_propTypes2['default'].bool,
    display: $30ee3e615f57447d$var$_propTypes2['default'].oneOf((0, $30ee3e615f57447d$var$_object2['default'])($30ee3e615f57447d$var$DISPLAY))
});
var $30ee3e615f57447d$var$defaultProps = {
    disabled: false,
    // `useCapture` is set to true by default so that a `stopPropagation` in the
    // children will not prevent all outside click handlers from firing - maja
    useCapture: true,
    display: $30ee3e615f57447d$var$DISPLAY.BLOCK
};
var $30ee3e615f57447d$var$OutsideClickHandler = function(_React$Component) {
    $30ee3e615f57447d$var$_inherits(OutsideClickHandler, _React$Component);
    function OutsideClickHandler() {
        var _ref;
        $30ee3e615f57447d$var$_classCallCheck(this, OutsideClickHandler);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var _this = $30ee3e615f57447d$var$_possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [
            this
        ].concat(args)));
        _this.onMouseDown = _this.onMouseDown.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
        return _this;
    }
    $30ee3e615f57447d$var$_createClass(OutsideClickHandler, [
        {
            key: 'componentDidMount',
            value: function() {
                function componentDidMount() {
                    var _props = this.props, disabled = _props.disabled, useCapture = _props.useCapture;
                    if (!disabled) this.addMouseDownEventListener(useCapture);
                }
                return componentDidMount;
            }()
        },
        {
            key: 'componentDidUpdate',
            value: function() {
                function componentDidUpdate(_ref2) {
                    var prevDisabled = _ref2.disabled;
                    var _props2 = this.props, disabled = _props2.disabled, useCapture = _props2.useCapture;
                    if (prevDisabled !== disabled) {
                        if (disabled) this.removeEventListeners();
                        else this.addMouseDownEventListener(useCapture);
                    }
                }
                return componentDidUpdate;
            }()
        },
        {
            key: 'componentWillUnmount',
            value: function() {
                function componentWillUnmount() {
                    this.removeEventListeners();
                }
                return componentWillUnmount;
            }()
        },
        {
            key: 'onMouseDown',
            value: function() {
                function onMouseDown(e) {
                    var useCapture = this.props.useCapture;
                    var isDescendantOfRoot = this.childNode && (0, $30ee3e615f57447d$var$_document2['default'])(this.childNode, e.target);
                    if (!isDescendantOfRoot) {
                        if (this.removeMouseUp) {
                            this.removeMouseUp();
                            this.removeMouseUp = null;
                        }
                        this.removeMouseUp = (0, $fZ7WM.addEventListener)(document, 'mouseup', this.onMouseUp, {
                            capture: useCapture
                        });
                    }
                }
                return onMouseDown;
            }()
        },
        {
            key: 'onMouseUp',
            value: function() {
                function onMouseUp(e) {
                    var onOutsideClick = this.props.onOutsideClick;
                    var isDescendantOfRoot = this.childNode && (0, $30ee3e615f57447d$var$_document2['default'])(this.childNode, e.target);
                    if (this.removeMouseUp) {
                        this.removeMouseUp();
                        this.removeMouseUp = null;
                    }
                    if (!isDescendantOfRoot) onOutsideClick(e);
                }
                return onMouseUp;
            }()
        },
        {
            key: 'setChildNodeRef',
            value: function() {
                function setChildNodeRef(ref) {
                    this.childNode = ref;
                }
                return setChildNodeRef;
            }()
        },
        {
            key: 'addMouseDownEventListener',
            value: function() {
                function addMouseDownEventListener(useCapture) {
                    this.removeMouseDown = (0, $fZ7WM.addEventListener)(document, 'mousedown', this.onMouseDown, {
                        capture: useCapture
                    });
                }
                return addMouseDownEventListener;
            }()
        },
        {
            key: 'removeEventListeners',
            value: function() {
                function removeEventListeners() {
                    if (this.removeMouseDown) this.removeMouseDown();
                    if (this.removeMouseUp) this.removeMouseUp();
                }
                return removeEventListeners;
            }()
        },
        {
            key: 'render',
            value: function() {
                function render() {
                    var _props3 = this.props, children = _props3.children, display = _props3.display;
                    return $30ee3e615f57447d$var$_react2['default'].createElement('div', {
                        ref: this.setChildNodeRef,
                        style: display !== $30ee3e615f57447d$var$DISPLAY.BLOCK && (0, $30ee3e615f57447d$var$_object2['default'])($30ee3e615f57447d$var$DISPLAY).includes(display) ? {
                            display: display
                        } : undefined
                    }, children);
                }
                return render;
            }()
        }
    ]);
    return OutsideClickHandler;
}($30ee3e615f57447d$var$_react2['default'].Component);
module.exports['default'] = $30ee3e615f57447d$var$OutsideClickHandler;
$30ee3e615f57447d$var$OutsideClickHandler.propTypes = $30ee3e615f57447d$var$propTypes;
$30ee3e615f57447d$var$OutsideClickHandler.defaultProps = $30ee3e615f57447d$var$defaultProps;

});
parcelRegister("8HYn2", function(module, exports) {

module.exports = (parcelRequire("hsxGc"));

});
parcelRegister("hsxGc", function(module, exports) {
"use strict";
function $cb5f2d494b362e60$var$noop() {
    return null;
}
$cb5f2d494b362e60$var$noop.isRequired = $cb5f2d494b362e60$var$noop;
function $cb5f2d494b362e60$var$noopThunk() {
    return $cb5f2d494b362e60$var$noop;
}
module.exports = {
    and: $cb5f2d494b362e60$var$noopThunk,
    between: $cb5f2d494b362e60$var$noopThunk,
    booleanSome: $cb5f2d494b362e60$var$noopThunk,
    childrenHavePropXorChildren: $cb5f2d494b362e60$var$noopThunk,
    childrenOf: $cb5f2d494b362e60$var$noopThunk,
    childrenOfType: $cb5f2d494b362e60$var$noopThunk,
    childrenSequenceOf: $cb5f2d494b362e60$var$noopThunk,
    componentWithName: $cb5f2d494b362e60$var$noopThunk,
    disallowedIf: $cb5f2d494b362e60$var$noopThunk,
    elementType: $cb5f2d494b362e60$var$noopThunk,
    empty: $cb5f2d494b362e60$var$noopThunk,
    explicitNull: $cb5f2d494b362e60$var$noopThunk,
    forbidExtraProps: Object,
    integer: $cb5f2d494b362e60$var$noopThunk,
    keysOf: $cb5f2d494b362e60$var$noopThunk,
    mutuallyExclusiveProps: $cb5f2d494b362e60$var$noopThunk,
    mutuallyExclusiveTrueProps: $cb5f2d494b362e60$var$noopThunk,
    nChildren: $cb5f2d494b362e60$var$noopThunk,
    nonNegativeInteger: $cb5f2d494b362e60$var$noop,
    nonNegativeNumber: $cb5f2d494b362e60$var$noopThunk,
    numericString: $cb5f2d494b362e60$var$noopThunk,
    object: $cb5f2d494b362e60$var$noopThunk,
    or: $cb5f2d494b362e60$var$noopThunk,
    predicate: $cb5f2d494b362e60$var$noopThunk,
    range: $cb5f2d494b362e60$var$noopThunk,
    ref: $cb5f2d494b362e60$var$noopThunk,
    requiredBy: $cb5f2d494b362e60$var$noopThunk,
    restrictedProp: $cb5f2d494b362e60$var$noopThunk,
    sequenceOf: $cb5f2d494b362e60$var$noopThunk,
    shape: $cb5f2d494b362e60$var$noopThunk,
    stringEndsWith: $cb5f2d494b362e60$var$noopThunk,
    stringStartsWith: $cb5f2d494b362e60$var$noopThunk,
    uniqueArray: $cb5f2d494b362e60$var$noopThunk,
    uniqueArrayOf: $cb5f2d494b362e60$var$noopThunk,
    valuesOf: $cb5f2d494b362e60$var$noopThunk,
    withShape: $cb5f2d494b362e60$var$noopThunk
};

});


parcelRegister("fZ7WM", function(module, exports) {

$parcel$export(module.exports, "addEventListener", function () { return $ba32b7a1866ebbd1$export$3f65cefe8380dbea; });
var $ba32b7a1866ebbd1$var$CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function $ba32b7a1866ebbd1$var$testPassiveEventListeners() {
    if (!$ba32b7a1866ebbd1$var$CAN_USE_DOM) return false;
    if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) return false;
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line getter-return
            get: function() {
                function get() {
                    supportsPassiveOption = true;
                }
                return get;
            }()
        });
        var noop = function noop() {};
        window.addEventListener('testPassiveEventSupport', noop, opts);
        window.removeEventListener('testPassiveEventSupport', noop, opts);
    } catch (e) {
    // do nothing
    }
    return supportsPassiveOption;
}
var $ba32b7a1866ebbd1$var$memoized = void 0;
function $ba32b7a1866ebbd1$var$canUsePassiveEventListeners() {
    if ($ba32b7a1866ebbd1$var$memoized === undefined) $ba32b7a1866ebbd1$var$memoized = $ba32b7a1866ebbd1$var$testPassiveEventListeners();
    return $ba32b7a1866ebbd1$var$memoized;
}
function $ba32b7a1866ebbd1$var$normalizeEventOptions(eventOptions) {
    if (!eventOptions) return undefined;
    if (!$ba32b7a1866ebbd1$var$canUsePassiveEventListeners()) // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
    return eventOptions;
}
/* eslint-disable no-bitwise */ /**
 * Generate a unique key for any set of event options
 */ function $ba32b7a1866ebbd1$var$eventOptionsKey(normalizedEventOptions) {
    if (!normalizedEventOptions) return 0;
    // If the browser does not support passive event listeners, the normalized
    // event options will be a boolean.
    if (normalizedEventOptions === true) return 100;
    // At this point, the browser supports passive event listeners, so we expect
    // the event options to be an object with possible properties of capture,
    // passive, and once.
    //
    // We want to consistently return the same value, regardless of the order of
    // these properties, so let's use binary maths to assign each property to a
    // bit, and then add those together (with an offset to account for the
    // booleans at the beginning of this function).
    var capture = normalizedEventOptions.capture << 0;
    var passive = normalizedEventOptions.passive << 1;
    var once = normalizedEventOptions.once << 2;
    return capture + passive + once;
}
function $ba32b7a1866ebbd1$var$ensureCanMutateNextEventHandlers(eventHandlers) {
    if (eventHandlers.handlers === eventHandlers.nextHandlers) // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
}
function $ba32b7a1866ebbd1$var$TargetEventHandlers(target) {
    this.target = target;
    this.events = {};
}
$ba32b7a1866ebbd1$var$TargetEventHandlers.prototype.getEventHandlers = function() {
    function getEventHandlers(eventName, options) {
        var key = String(eventName) + ' ' + String($ba32b7a1866ebbd1$var$eventOptionsKey(options));
        if (!this.events[key]) {
            this.events[key] = {
                handlers: [],
                handleEvent: undefined
            };
            this.events[key].nextHandlers = this.events[key].handlers;
        }
        return this.events[key];
    }
    return getEventHandlers;
}();
$ba32b7a1866ebbd1$var$TargetEventHandlers.prototype.handleEvent = function() {
    function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function(handler) {
            if (handler) // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
        });
    }
    return handleEvent;
}();
$ba32b7a1866ebbd1$var$TargetEventHandlers.prototype.add = function() {
    function add(eventName, listener, options) {
        var _this = this;
        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);
        $ba32b7a1866ebbd1$var$ensureCanMutateNextEventHandlers(eventHandlers);
        if (eventHandlers.nextHandlers.length === 0) {
            eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
            this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }
        eventHandlers.nextHandlers.push(listener);
        var isSubscribed = true;
        var unsubscribe = function() {
            function unsubscribe() {
                if (!isSubscribed) return;
                isSubscribed = false;
                $ba32b7a1866ebbd1$var$ensureCanMutateNextEventHandlers(eventHandlers);
                var index = eventHandlers.nextHandlers.indexOf(listener);
                eventHandlers.nextHandlers.splice(index, 1);
                if (eventHandlers.nextHandlers.length === 0) {
                    // All event handlers have been removed, so we want to remove the event
                    // listener from the target node.
                    if (_this.target) // There can be a race condition where the target may no longer exist
                    // when this function is called, e.g. when a React component is
                    // unmounting. Guarding against this prevents the following error:
                    //
                    //   Cannot read property 'removeEventListener' of undefined
                    _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
                    eventHandlers.handleEvent = undefined;
                }
            }
            return unsubscribe;
        }();
        return unsubscribe;
    }
    return add;
}();
var $ba32b7a1866ebbd1$var$EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
// eslint-disable-next-line import/prefer-default-export
function $ba32b7a1866ebbd1$export$3f65cefe8380dbea(target, eventName, listener, options) {
    if (!target[$ba32b7a1866ebbd1$var$EVENT_HANDLERS_KEY]) // eslint-disable-next-line no-param-reassign
    target[$ba32b7a1866ebbd1$var$EVENT_HANDLERS_KEY] = new $ba32b7a1866ebbd1$var$TargetEventHandlers(target);
    var normalizedEventOptions = $ba32b7a1866ebbd1$var$normalizeEventOptions(options);
    return target[$ba32b7a1866ebbd1$var$EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

});

parcelRegister("2rzAd", function(module, exports) {
'use strict';

var $j33Wi = parcelRequire("j33Wi");

var $cXVoz = parcelRequire("cXVoz");

var $kN9dW = parcelRequire("kN9dW");

var $cOYSM = parcelRequire("cOYSM");

var $1F9H3 = parcelRequire("1F9H3");
var $1c79b470330c87b4$var$polyfill = $cXVoz($cOYSM(), Object);
$j33Wi($1c79b470330c87b4$var$polyfill, {
    getPolyfill: $cOYSM,
    implementation: $kN9dW,
    shim: $1F9H3
});
module.exports = $1c79b470330c87b4$var$polyfill;

});
parcelRegister("j33Wi", function(module, exports) {
'use strict';

var $lAFXj = parcelRequire("lAFXj");
var $dde15a63ecf3f66c$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $dde15a63ecf3f66c$var$toStr = Object.prototype.toString;
var $dde15a63ecf3f66c$var$concat = Array.prototype.concat;

var $l5Lg9 = parcelRequire("l5Lg9");
var $dde15a63ecf3f66c$var$isFunction = function(fn) {
    return typeof fn === 'function' && $dde15a63ecf3f66c$var$toStr.call(fn) === '[object Function]';
};

var $dde15a63ecf3f66c$var$supportsDescriptors = (parcelRequire("jqyS7"))();
var $dde15a63ecf3f66c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$dde15a63ecf3f66c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($dde15a63ecf3f66c$var$supportsDescriptors) $l5Lg9(object, name, value, true);
    else $l5Lg9(object, name, value);
};
var $dde15a63ecf3f66c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $lAFXj(map);
    if ($dde15a63ecf3f66c$var$hasSymbols) props = $dde15a63ecf3f66c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$dde15a63ecf3f66c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$dde15a63ecf3f66c$var$defineProperties.supportsDescriptors = !!$dde15a63ecf3f66c$var$supportsDescriptors;
module.exports = $dde15a63ecf3f66c$var$defineProperties;

});
parcelRegister("lAFXj", function(module, exports) {
'use strict';
var $fb7d81448e4a683b$var$slice = Array.prototype.slice;

var $8Niv6 = parcelRequire("8Niv6");
var $fb7d81448e4a683b$var$origKeys = Object.keys;

var $fb7d81448e4a683b$var$keysShim = $fb7d81448e4a683b$var$origKeys ? function keys(o) {
    return $fb7d81448e4a683b$var$origKeys(o);
} : (parcelRequire("iwiX5"));
var $fb7d81448e4a683b$var$originalKeys = Object.keys;
$fb7d81448e4a683b$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($8Niv6(object)) return $fb7d81448e4a683b$var$originalKeys($fb7d81448e4a683b$var$slice.call(object));
            return $fb7d81448e4a683b$var$originalKeys(object);
        };
    } else Object.keys = $fb7d81448e4a683b$var$keysShim;
    return Object.keys || $fb7d81448e4a683b$var$keysShim;
};
module.exports = $fb7d81448e4a683b$var$keysShim;

});
parcelRegister("8Niv6", function(module, exports) {
'use strict';
var $6671402b8b979043$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6671402b8b979043$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6671402b8b979043$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("iwiX5", function(module, exports) {
'use strict';
var $d7b9ea9c55cfb1f0$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $d7b9ea9c55cfb1f0$var$has = Object.prototype.hasOwnProperty;
    var $d7b9ea9c55cfb1f0$var$toStr = Object.prototype.toString;
    var $d7b9ea9c55cfb1f0$var$isArgs = (parcelRequire("8Niv6")); // eslint-disable-line global-require
    var $d7b9ea9c55cfb1f0$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $d7b9ea9c55cfb1f0$var$hasDontEnumBug = !$d7b9ea9c55cfb1f0$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $d7b9ea9c55cfb1f0$var$hasProtoEnumBug = $d7b9ea9c55cfb1f0$var$isEnumerable.call(function() {}, 'prototype');
    var $d7b9ea9c55cfb1f0$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $d7b9ea9c55cfb1f0$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $d7b9ea9c55cfb1f0$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $d7b9ea9c55cfb1f0$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$d7b9ea9c55cfb1f0$var$excludedKeys['$' + k] && $d7b9ea9c55cfb1f0$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $d7b9ea9c55cfb1f0$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $d7b9ea9c55cfb1f0$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$d7b9ea9c55cfb1f0$var$hasAutomationEqualityBug) return $d7b9ea9c55cfb1f0$var$equalsConstructorPrototype(o);
        try {
            return $d7b9ea9c55cfb1f0$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $d7b9ea9c55cfb1f0$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $d7b9ea9c55cfb1f0$var$toStr.call(object) === '[object Function]';
        var isArguments = $d7b9ea9c55cfb1f0$var$isArgs(object);
        var isString = isObject && $d7b9ea9c55cfb1f0$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $d7b9ea9c55cfb1f0$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$d7b9ea9c55cfb1f0$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $d7b9ea9c55cfb1f0$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($d7b9ea9c55cfb1f0$var$hasDontEnumBug) {
            var skipConstructor = $d7b9ea9c55cfb1f0$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $d7b9ea9c55cfb1f0$var$dontEnums.length; ++k)if (!(skipConstructor && $d7b9ea9c55cfb1f0$var$dontEnums[k] === 'constructor') && $d7b9ea9c55cfb1f0$var$has.call(object, $d7b9ea9c55cfb1f0$var$dontEnums[k])) theKeys.push($d7b9ea9c55cfb1f0$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $d7b9ea9c55cfb1f0$var$keysShim;

});



parcelRegister("cXVoz", function(module, exports) {
'use strict';

var $9uzLU = parcelRequire("9uzLU");

var $FItZv = parcelRequire("FItZv");

var $L4DFZ = parcelRequire("L4DFZ");

var $dXcsU = parcelRequire("dXcsU");
var $9707843e2b81f446$var$$apply = $FItZv('%Function.prototype.apply%');
var $9707843e2b81f446$var$$call = $FItZv('%Function.prototype.call%');
var $9707843e2b81f446$var$$reflectApply = $FItZv('%Reflect.apply%', true) || $9uzLU.call($9707843e2b81f446$var$$call, $9707843e2b81f446$var$$apply);

var $9G34V = parcelRequire("9G34V");
var $9707843e2b81f446$var$$max = $FItZv('%Math.max%');
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== 'function') throw new $dXcsU('a function is required');
    var func = $9707843e2b81f446$var$$reflectApply($9uzLU, $9707843e2b81f446$var$$call, arguments);
    return $L4DFZ(func, 1 + $9707843e2b81f446$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9707843e2b81f446$var$applyBind = function applyBind() {
    return $9707843e2b81f446$var$$reflectApply($9uzLU, $9707843e2b81f446$var$$apply, arguments);
};
if ($9G34V) $9G34V(module.exports, 'apply', {
    value: $9707843e2b81f446$var$applyBind
});
else module.exports.apply = $9707843e2b81f446$var$applyBind;

});

parcelRegister("kN9dW", function(module, exports) {
'use strict';

var $kcqdx = parcelRequire("kcqdx");

var $iY5U9 = parcelRequire("iY5U9");
var $f22f89eb407fd8b9$var$$isEnumerable = $iY5U9('Object.prototype.propertyIsEnumerable');
var $f22f89eb407fd8b9$var$$push = $iY5U9('Array.prototype.push');
module.exports = function values(O) {
    var obj = $kcqdx(O);
    var vals = [];
    for(var key in obj)if ($f22f89eb407fd8b9$var$$isEnumerable(obj, key)) $f22f89eb407fd8b9$var$$push(vals, obj[key]);
    return vals;
};

});
parcelRegister("kcqdx", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j8sjj"));

});
parcelRegister("j8sjj", function(module, exports) {
'use strict';

var $dXcsU = parcelRequire("dXcsU");
/** @type {import('./RequireObjectCoercible')} */ module.exports = function RequireObjectCoercible(value) {
    if (value == null) throw new $dXcsU(arguments.length > 0 && arguments[1] || 'Cannot call method on ' + value);
    return value;
};

});


parcelRegister("iY5U9", function(module, exports) {
'use strict';

var $FItZv = parcelRequire("FItZv");

var $cXVoz = parcelRequire("cXVoz");
var $dcf2692806d7bd4a$var$$indexOf = $cXVoz($FItZv('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $FItZv(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $dcf2692806d7bd4a$var$$indexOf(name, '.prototype.') > -1) return $cXVoz(intrinsic);
    return intrinsic;
};

});


parcelRegister("cOYSM", function(module, exports) {
'use strict';

var $kN9dW = parcelRequire("kN9dW");
module.exports = function getPolyfill() {
    return typeof Object.values === 'function' ? Object.values : $kN9dW;
};

});

parcelRegister("1F9H3", function(module, exports) {
'use strict';

var $cOYSM = parcelRequire("cOYSM");

var $j33Wi = parcelRequire("j33Wi");
module.exports = function shimValues() {
    var polyfill = $cOYSM();
    $j33Wi(Object, {
        values: polyfill
    }, {
        values: function testValues() {
            return Object.values !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("biMYV", function(module, exports) {
'use strict';

var $j33Wi = parcelRequire("j33Wi");

var $6rSxj = parcelRequire("6rSxj");

var $a0990 = parcelRequire("a0990");
var $83a75ee392090d4c$var$polyfill = $a0990();

var $apcnx = parcelRequire("apcnx");
var $83a75ee392090d4c$var$boundContains = function contains(node, other) {
    return $83a75ee392090d4c$var$polyfill.apply(node, [
        other
    ]);
};
$j33Wi($83a75ee392090d4c$var$boundContains, {
    getPolyfill: $a0990,
    implementation: $6rSxj,
    shim: $apcnx
});
module.exports = $83a75ee392090d4c$var$boundContains;

});
parcelRegister("6rSxj", function(module, exports) {
'use strict';
module.exports = function contains(other) {
    if (arguments.length < 1) throw new TypeError('1 argument is required');
    if (typeof other !== 'object') throw new TypeError("Argument 1 (\u201Dother\u201C) to Node.contains must be an instance of Node");
    var node = other;
    do {
        if (this === node) return true;
        if (node) node = node.parentNode;
    }while (node);
    return false;
};

});

parcelRegister("a0990", function(module, exports) {
'use strict';

var $6rSxj = parcelRequire("6rSxj");
module.exports = function getPolyfill() {
    if (typeof document !== 'undefined') {
        if (document.contains) return document.contains;
        if (document.body && document.body.contains) try {
            if (typeof document.body.contains.call(document, '') === 'boolean') return document.body.contains;
        } catch (e) {}
    }
    return $6rSxj;
};

});

parcelRegister("apcnx", function(module, exports) {
'use strict';

var $j33Wi = parcelRequire("j33Wi");

var $a0990 = parcelRequire("a0990");
module.exports = function shimContains() {
    var polyfill = $a0990();
    if (typeof document !== 'undefined') {
        $j33Wi(document, {
            contains: polyfill
        }, {
            contains: function() {
                return document.contains !== polyfill;
            }
        });
        if (typeof Element !== 'undefined') $j33Wi(Element.prototype, {
            contains: polyfill
        }, {
            contains: function() {
                return Element.prototype.contains !== polyfill;
            }
        });
    }
    return polyfill;
};

});




parcelRegister("b0trd", function(module, exports) {

$parcel$export(module.exports, "NavButton", function () { return $664756b729bc36e3$export$3b0a9d598f613fa; });
$parcel$export(module.exports, "SubNavButton", function () { return $664756b729bc36e3$export$2306a5dce2caa7df; });

var $4m918 = parcelRequire("4m918");

var $6uYXW = parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $5hpYi = parcelRequire("5hpYi");

var $yYT9n = parcelRequire("yYT9n");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $bewhU = parcelRequire("bewhU");

var $874Dk = parcelRequire("874Dk");

var $gk2kn = parcelRequire("gk2kn");

var $7J6Bs = parcelRequire("7J6Bs");

var $5fjN5 = parcelRequire("5fjN5");

var $d8ise = parcelRequire("d8ise");

var $8vjLG = parcelRequire("8vjLG");

var $bOc9W = parcelRequire("bOc9W");
/** The new menu artwork ships as flat white SVG files, so it is rendered as an image. */ const $664756b729bc36e3$var$MenuIconImage = (0, $jb8NR.default).img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;
const $664756b729bc36e3$var$NavLink = {
    account: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$MenuIconImage, {
            src: (0, $fRvTz.StaticAssets).menuHouse,
            alt: ""
        }),
        labelKey: "navigationMenu.accountLink"
    },
    transfers: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $8vjLG.TransferIcon), {}),
        labelKey: "navigationMenu.transferLink"
    },
    services: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $d8ise.ServiceIcon), {}),
        labelKey: "navigationMenu.payBillLink"
    },
    cards: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$MenuIconImage, {
            src: (0, $fRvTz.StaticAssets).menuCard,
            alt: ""
        }),
        labelKey: "navigationMenu.cardsLink"
    },
    savings: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $gk2kn.BigBankToWalletIcon), {}),
        labelKey: "navigationMenu.savingsLink"
    },
    settings: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $874Dk.AccountIcon), {}),
        labelKey: "navigationMenu.settingsLink"
    },
    profile: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$MenuIconImage, {
            src: (0, $fRvTz.StaticAssets).menuProfile,
            alt: ""
        }),
        labelKey: "navigationMenu.profileLink"
    },
    loan: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $5fjN5.LoanIcon), {}),
        labelKey: "navigationMenu.loansLink"
    },
    mandates: {
        icon: /*#__PURE__*/ (0, $4m918.jsx)((0, $7J6Bs.DocumentIcon), {}),
        labelKey: "navigationMenu.mandatesLink"
    }
};
function $664756b729bc36e3$export$3b0a9d598f613fa(props) {
    const { linkType: linkType, isActive: isActive, withBackground: withBackground = true, onClick: onClick, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    const [toolTipVisible, setToolTipVisible] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $4m918.jsxs)($664756b729bc36e3$var$ButtonBackground, {
        $active: isActive,
        $withoutBackground: !withBackground,
        children: [
            /*#__PURE__*/ (0, $4m918.jsxs)($664756b729bc36e3$var$Button, {
                onMouseEnter: ()=>setToolTipVisible(true),
                onMouseLeave: ()=>setToolTipVisible(false),
                role: "menuitem",
                $active: isActive,
                onClick: (e)=>{
                    setToolTipVisible(false);
                    onClick?.(e);
                },
                $isRTL: isRTL,
                ...rest,
                children: [
                    $664756b729bc36e3$var$NavLink[linkType].icon,
                    /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$BaseLabel, {
                        $active: isActive,
                        $isRTL: isRTL,
                        children: formatMessage($664756b729bc36e3$var$NavLink[linkType].labelKey)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$Tooltip, {
                $isVisible: toolTipVisible,
                $isRTL: isRTL,
                children: formatMessage($664756b729bc36e3$var$NavLink[linkType].labelKey)
            })
        ]
    });
}
function $664756b729bc36e3$export$2306a5dce2caa7df(props) {
    const { isActive: isActive, name: name, onClick: onClick, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5hpYi.useIntl)();
    const { isRTL: isRTL } = (0, $yYT9n.useRTL)();
    return /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$SubButtonBackground, {
        $active: isActive,
        children: /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$Button, {
            role: "menuitem",
            $active: isActive,
            onClick: onClick,
            $isRTL: isRTL,
            ...rest,
            children: /*#__PURE__*/ (0, $4m918.jsx)($664756b729bc36e3$var$SubItemLabel, {
                $active: isActive,
                $isRTL: isRTL,
                children: formatMessage(name)
            })
        })
    });
}
const $664756b729bc36e3$var$ButtonBackground = (0, $jb8NR.default).div`
  display: flex;
  flex-direction: row;
  background-color: ${({ $active: $active, $withoutBackground: $withoutBackground })=>$active && !$withoutBackground ? (0, $bOc9W.sideBarColors).selectedBackground : (0, $bOc9W.sideBarColors).background};
  margin: 0 16px;
  padding: 12px;
  border-radius: 13px;
  flex: 1;
`;
const $664756b729bc36e3$var$SubButtonBackground = (0, $jb8NR.default)($664756b729bc36e3$var$ButtonBackground)`
  margin: 0 16px 0 48px;
  justify-content: flex-start;
`;
const $664756b729bc36e3$var$Button = (0, $jb8NR.default)((0, $bewhU.DefaultButton))`
  position: relative;
  align-items: flex-start;
  justify-content: flex-start;

  svg {
    width: 24px;
    height: 24px;
    fill: ${({ $active: $active })=>$active ? (0, $bOc9W.sideBarColors).activeItem : (0, $bOc9W.sideBarColors).inactiveItem};
  }
  &:disabled {
    opacity: 0.3;
  }
`;
const $664756b729bc36e3$var$BaseLabel = (0, $jb8NR.default).span`
  font-size: 0.9375rem;
  ${(0, $22v9q.theme).text};
  color: ${({ $active: $active })=>$active ? (0, $bOc9W.sideBarColors).activeItem : (0, $bOc9W.sideBarColors).inactiveItem};
  margin-left: ${(props)=>props.$isRTL ? 0 : 12}px;
  margin-right: ${(props)=>props.$isRTL ? 12 : 0}px;

  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 170px;
`;
const $664756b729bc36e3$var$SubItemLabel = (0, $jb8NR.default)($664756b729bc36e3$var$BaseLabel)`
  margin-left: ${(props)=>props.$isRTL ? 0 : 4}px;
  margin-right: ${(props)=>props.$isRTL ? 4 : 0}px;
  max-width: 100%;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    font-size: 0.875rem;
  }
`;
const $664756b729bc36e3$var$Tooltip = (0, $jb8NR.default).span`
  ${(0, $22v9q.theme).text}
  text-align: ${(props)=>props.$isRTL ? "right" : "left"};
  color: ${(0, $bOc9W.sideBarColors).toolTipText};
  font-size: 0.825rem;
  height: 23px;
  min-width: fit-content;
  width: intrinsic; /* Safari/WebKit use a non-standard name */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content; /* Chrome */

  padding: 3px 8px;
  border-radius: 8px;
  background-color: ${(0, $bOc9W.sideBarColors).toolTipBackground};
  position: absolute;
  margin-right: ${(props)=>props.$isRTL ? 60 : 0};
  margin-left: ${(props)=>props.$isRTL ? 0 : 60};
  opacity: ${(props)=>props.$isVisible ? 1 : 0};
  z-index: 10;
  transition: opacity 0.5s;
  display: none;
`;

});
parcelRegister("874Dk", function(module, exports) {

$parcel$export(module.exports, "AccountIcon", function () { return $160d29591ccf4799$export$eae3a3643c1615c9; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $160d29591ccf4799$export$eae3a3643c1615c9(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
            })
        ]
    });
}

});

parcelRegister("5fjN5", function(module, exports) {

$parcel$export(module.exports, "LoanIcon", function () { return $9bebecc8525a508b$export$7279ea9ed80dc4f5; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $9bebecc8525a508b$export$7279ea9ed80dc4f5(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            d: "M20.5 7.898c-.004.004-.01.008-.011.012-.138.43-.448.603-.897.602-5.061-.004-10.124-.003-15.185-.002-.25 0-.483-.036-.671-.223a.766.766 0 0 1 .154-1.219c.192-.107.398-.19.6-.28C6.848 5.726 9.208 4.667 11.565 3.6a.987.987 0 0 1 .873.003c2.508 1.136 5.02 2.264 7.53 3.39.254.114.434.279.51.55.002.009.014.015.021.023v.332zM4.102 20.48c-.022-.014-.042-.03-.066-.04-.375-.143-.583-.48-.527-.858.053-.359.36-.628.748-.657.044-.003.089-.002.133-.002l15.212-.001c.299 0 .56.075.74.326.066.092.106.201.158.302v.299c-.014.028-.03.056-.04.086a.78.78 0 0 1-.519.51c-.025.008-.048.023-.072.034H4.102zM11.988 18.476h-6.57c-.094 0-.189-.007-.282-.02a.761.761 0 0 1-.667-.794.77.77 0 0 1 .733-.738c.229-.003.229-.01.229-.247v-6.47c0-.045-.004-.09 0-.134.006-.074-.03-.093-.098-.094-.06 0-.12-.01-.18-.023a.365.365 0 0 1-.292-.353.366.366 0 0 1 .26-.377c.058-.018.12-.023.179-.03.033-.004.066 0 .1 0h13.207c.093 0 .19.008.278.033a.369.369 0 0 1 .253.385.375.375 0 0 1-.289.342 1.036 1.036 0 0 1-.113.022c-.165.021-.166.02-.166.177v6.587c0 .028.002.056 0 .083-.005.07.025.096.096.098.104.004.212.007.31.036a.767.767 0 0 1-.12 1.498 2.198 2.198 0 0 1-.281.018h-6.587zM10.84 13.44v3.4c-.002.053.018.084.076.08h2.073c.165 0 .166 0 .166-.16v-6.616c0-.163 0-.164-.162-.164h-1.99c-.18 0-.162-.006-.163.16V13.441zm6.175.019v-3.318c0-.167.017-.161-.162-.161h-1.99c-.156 0-.158.001-.158.152v6.635c0 .152.002.153.157.153h1.974c.194 0 .18.02.18-.177v-3.285zm-10.029-.001v3.25c0 .045.002.09 0 .134-.001.054.023.082.08.079.027-.002.054 0 .082 0h1.974c.163 0 .163-.001.164-.162v-6.585c0-.038-.002-.077 0-.116.002-.056-.025-.08-.08-.078H7.149c-.162 0-.162 0-.163.16v3.317z"
        })
    });
}

});

parcelRegister("d8ise", function(module, exports) {

$parcel$export(module.exports, "ServiceIcon", function () { return $7f0b92201bcffb2b$export$25435839742ff495; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $7f0b92201bcffb2b$export$25435839742ff495(props) {
    return /*#__PURE__*/ (0, $4m918.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.075 20.334a.398.398 0 0 0 .297.127h.245a.398.398 0 0 0 .296-.127l1.549-1.565a.431.431 0 0 1 .6 0l1.532 1.532a.398.398 0 0 0 .296.127h.245a.398.398 0 0 0 .296-.127l1.532-1.532a.432.432 0 0 1 .576 0l1.531 1.532a.398.398 0 0 0 .296.127h.245a.398.398 0 0 0 .297-.127l1.616-1.532a.846.846 0 0 0 .245-.592V4.384a.846.846 0 0 0-.846-.846H6.077a.846.846 0 0 0-.846.846v13.759c.003.224.09.439.245.6l1.6 1.591zm5.771-7.065c0 .234-.19.423-.423.423H9.04a.423.423 0 0 1-.424-.423v-.846c0-.234.19-.423.424-.423h3.384c.234 0 .423.19.423.423v.846zm2.116-2.961c.233 0 .423-.19.423-.423v-.847a.423.423 0 0 0-.423-.423H9.039a.423.423 0 0 0-.424.423v.847c0 .233.19.423.424.423h5.923z"
        })
    });
}

});

parcelRegister("8vjLG", function(module, exports) {

$parcel$export(module.exports, "TransferIcon", function () { return $0a48ef4b786a0161$export$83099edae52007d2; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");
function $0a48ef4b786a0161$export$83099edae52007d2(props) {
    return /*#__PURE__*/ (0, $4m918.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)("g", {
                clipPath: "url(#7x1b55l5ja)",
                children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                    d: "M4.478 15.461c.017.033.036.064.05.098.122.282.348.41.644.432.049.003.098 0 .147 0h11.903c-.048.052-.08.087-.114.12l-1.992 1.994c-.07.07-.138.141-.197.219a.685.685 0 0 0 .17.98c.297.192.652.144.909-.115.54-.544 1.085-1.086 1.627-1.628l1.733-1.733a.78.78 0 0 0 .21-.33.685.685 0 0 0-.14-.66c-.028-.034-.062-.063-.093-.095l-3.308-3.308-.063-.063c-.196-.195-.433-.24-.691-.17-.273.075-.427.274-.481.54a.643.643 0 0 0 .155.56c.038.045.081.085.123.127.685.686 1.37 1.371 2.057 2.056.034.035.072.065.135.12H5.24a.833.833 0 0 0-.358.06.677.677 0 0 0-.376.427c-.006.016-.02.03-.029.044v.325zM4.478 8.582c.01.01.024.018.026.03a.712.712 0 0 0 .194.323c1.132 1.13 2.264 2.259 3.392 3.394a.72.72 0 0 0 .823.146.685.685 0 0 0 .203-1.072c-.033-.037-.068-.07-.103-.105L6.946 9.23c-.034-.034-.066-.07-.113-.118h.194l11.81.001c.14 0 .269-.021.397-.083.324-.156.488-.628.255-.985-.135-.206-.332-.294-.567-.318-.048-.005-.098 0-.147 0H6.836l.087-.093L8.99 5.568c.028-.028.054-.057.084-.083.384-.343.242-1.002-.27-1.157-.016-.005-.03-.018-.045-.028h-.325c-.01.01-.017.024-.028.027a.705.705 0 0 0-.322.195L4.699 7.907a.924.924 0 0 0-.186.279c-.01.024-.024.047-.035.07v.326z"
                })
            }),
            /*#__PURE__*/ (0, $4m918.jsx)("defs", {
                children: /*#__PURE__*/ (0, $4m918.jsx)("clipPath", {
                    id: "7x1b55l5ja",
                    children: /*#__PURE__*/ (0, $4m918.jsx)("path", {
                        transform: "matrix(-1 0 0 1 19.6 4.3)",
                        d: "M0 0h15.122v15.121H0z"
                    })
                })
            })
        ]
    });
}

});



parcelRegister("2lWSH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8530ce8e5dde7a19$export$2e2bcd8739ae039; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $jb8NR = parcelRequire("jb8NR");

var $fRvTz = parcelRequire("fRvTz");

var $22v9q = parcelRequire("22v9q");

var $7XqbX = parcelRequire("7XqbX");

var $bOc9W = parcelRequire("bOc9W");
const $8530ce8e5dde7a19$var$NavToggleButton = ({ isMenuVisible: isMenuVisible, toggleMenu: toggleMenu })=>/*#__PURE__*/ (0, $4m918.jsxs)($8530ce8e5dde7a19$var$NavOnMobileContainer, {
        "data-testid": "nav-mobile-container",
        children: [
            /*#__PURE__*/ (0, $4m918.jsx)($8530ce8e5dde7a19$var$LogoOnMobile, {
                alt: "Skaleet",
                src: (0, $fRvTz.StaticAssets).logo
            }),
            /*#__PURE__*/ (0, $4m918.jsxs)($8530ce8e5dde7a19$var$ToggleButton, {
                "data-testid": "nav-toggle-button",
                "aria-pressed": isMenuVisible,
                onClick: toggleMenu,
                className: isMenuVisible ? "active" : "",
                children: [
                    /*#__PURE__*/ (0, $4m918.jsx)($8530ce8e5dde7a19$var$Line, {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($8530ce8e5dde7a19$var$Line, {}),
                    /*#__PURE__*/ (0, $4m918.jsx)($8530ce8e5dde7a19$var$Line, {})
                ]
            })
        ]
    });
var $8530ce8e5dde7a19$export$2e2bcd8739ae039 = $8530ce8e5dde7a19$var$NavToggleButton;
const $8530ce8e5dde7a19$var$NavOnMobileContainer = (0, $jb8NR.default).div`
  display: none;
  @media (max-width: ${(0, $7XqbX.UIConstants).DESKTOP_SMALL_BREAKPOINT - 1}px) {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background: ${(0, $bOc9W.sideBarColors).background};
    box-shadow: rgba(0, 0, 0, 0.08) 0 0 10px;
  }
`;
const $8530ce8e5dde7a19$var$LogoOnMobile = (0, $jb8NR.default).img`
  align-self: center;
  width: auto;
  height: 50px;
  line-height: 50px;
  object-fit: fill;
  border-radius: 13px;
`;
const $8530ce8e5dde7a19$var$Line = (0, $jb8NR.default).span`
  display: block;
  width: 100%;
  height: 2px;
  background-color: white;
  border-radius: 2px;
  transition: all 0.3s ease;
`;
const $8530ce8e5dde7a19$var$ToggleButton = (0, $jb8NR.default).button`
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background: ${(0, $22v9q.theme).mainColor};
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 16px 14px;
  box-sizing: border-box;

  &.active span:nth-child(1) {
    transform: translateY(5px) rotate(45deg);
  }

  &.active span:nth-child(2) {
    opacity: 0;
  }

  &.active span:nth-child(3) {
    transform: translateY(-5px) rotate(-45deg);
  }
`;

});




parcelRegister("3QpQZ", function(module, exports) {

$parcel$export(module.exports, "HomeRoute", function () { return $bd02971da7b5cf4d$export$48d3d184aade51b1; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");
const $bd02971da7b5cf4d$export$48d3d184aade51b1 = (props)=>{
    const isConnected = (0, $3Ersk.useObservable)((0, $kqXxS.authenticationManager).isConnected);
    return isConnected ? /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
        to: {
            pathname: (0, $4fYE4.Path).AccountTransactions
        }
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
        ...props
    });
};

});

parcelRegister("dE0SD", function(module, exports) {

$parcel$export(module.exports, "OAuthRedirectRoute", function () { return $8840dea3237cd499$export$59af51365cc105eb; });

var $4m918 = parcelRequire("4m918");
parcelRequire("6uYXW");

var $NQIVp = parcelRequire("NQIVp");

var $kqXxS = parcelRequire("kqXxS");

var $3Ersk = parcelRequire("3Ersk");

var $4fYE4 = parcelRequire("4fYE4");
const $8840dea3237cd499$export$59af51365cc105eb = (props)=>{
    const isConnected = (0, $3Ersk.useObservable)((0, $kqXxS.authenticationManager).isConnected);
    return isConnected ? /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Redirect), {
        to: {
            pathname: (0, $4fYE4.Path).AccountTransactions
        }
    }) : /*#__PURE__*/ (0, $4m918.jsx)((0, $NQIVp.Route), {
        ...props
    });
};

});



var $28420bb45aacebd0$exports = {};
$parcel$extendImportMap({
    "1Hukf": "html2canvas.4c2c26f4.js",
    "5yelA": "purify.4e1de0e4.js",
    "9Nfi1": "dist.565cf24d.js",
    "efEQa": "bin.b7c51bd8.png",
    "bVp6u": "download.c5f8d28f.png",
    "em42D": "green-check.064d5bb8.png",
    "ctdoF": "preview.487b5eb7.png",
    "7wyoa": "AD.b1c4a0f8.png",
    "fuHZd": "AE.79e22e5d.png",
    "eD6am": "AF.9d491aaf.png",
    "5M0g2": "AG.82ef6ccc.png",
    "bcW2X": "AI.1d61d497.png",
    "g8UDs": "AL.ad3f2004.png",
    "h3Jev": "AM.3976334a.png",
    "2kr9O": "AO.e9093971.png",
    "JrqI8": "AR.dface398.png",
    "iqlVB": "AS.c8519717.png",
    "rOvSD": "AT.6205ed19.png",
    "4B31H": "AU.679a4bc5.png",
    "04vKr": "AW.bdd5a22b.png",
    "bzbRK": "AX.5b9aa4f0.png",
    "4AuBQ": "AZ.5e5281f2.png",
    "jRZcn": "BA.20f66ddc.png",
    "epXNZ": "BB.6c790039.png",
    "h3ez8": "BD.1a74884e.png",
    "7vfkV": "BE.13e85572.png",
    "5rPfn": "BF.bb6d09d3.png",
    "37AjI": "BG.9dd2c582.png",
    "c8keQ": "BH.691ac8a5.png",
    "hqfWc": "BI.9fc07aad.png",
    "f55BJ": "BJ.a24f6bdd.png",
    "d89j5": "BL.db7c463d.png",
    "71ltY": "BM.a04ac5b9.png",
    "1ZZj9": "BN.d552acf6.png",
    "9if6v": "BO.5d59f0fd.png",
    "hBM7P": "BR.0a61f217.png",
    "kp1FA": "BS.fddc5d1e.png",
    "1KxNs": "BT.e7eadfa1.png",
    "kq4xi": "BV.71330d38.png",
    "lij3D": "BW.b6a92f5a.png",
    "8v2XQ": "BY.de42081c.png",
    "lezXv": "BZ.0d09f66c.png",
    "CAKKg": "CA.a1e2fb54.png",
    "1SIZZ": "CC.c9466f08.png",
    "lLgx7": "CD.57c752b5.png",
    "u3Q5O": "CF.655037c8.png",
    "97W1g": "CG.5bc32fdf.png",
    "eCLOU": "CH.2baf9a38.png",
    "kx8rb": "CI.a7767fcb.png",
    "fP6CQ": "CK.cb6419c4.png",
    "djNvN": "CL.1024341c.png",
    "9hMDE": "CM.5eddb31d.png",
    "cibmi": "CN.84ce2e4c.png",
    "aBVVw": "CO.f548e99a.png",
    "aVMBx": "CR.082e49d6.png",
    "eOem6": "CU.0702ffaf.png",
    "9VCIr": "CV.a2b2ac4f.png",
    "2dDQv": "CW.f402ff15.png",
    "9mAy5": "CX.8c9cecb5.png",
    "cR8yT": "CY.93629d8c.png",
    "iZFNL": "CZ.df968011.png",
    "buuqA": "DE.93b97455.png",
    "iSjyl": "DJ.41858f36.png",
    "gYaJl": "DK.6e28421e.png",
    "aB920": "DM.a2049f42.png",
    "jpXz2": "DO.ae0f9472.png",
    "eNi6e": "DZ.0e13f133.png",
    "aRWCu": "EC.fd312a30.png",
    "ll8tf": "EE.e4f0105e.png",
    "2Io43": "EG.07c488f2.png",
    "9DnWP": "ER.90ecdc85.png",
    "dpJB1": "ES.63da7b95.png",
    "cwiPI": "ET.e196c7df.png",
    "8iNME": "FI.d5838ea1.png",
    "eRdyz": "FJ.be252936.png",
    "fod34": "FK.1f466aca.png",
    "ktg4U": "FM.47e04b54.png",
    "dtsbF": "FO.f2969b37.png",
    "g3onM": "FR.528abdf5.png",
    "bRgkM": "GA.492735c0.png",
    "4qMYx": "GB.9c204e77.png",
    "fZWzX": "GD.2113edf2.png",
    "qeK68": "GE.a11507d3.png",
    "8YECr": "GF.4b7ea68e.png",
    "22Rkc": "GG.db5871e9.png",
    "inQwX": "GH.5eadfd23.png",
    "20d1T": "GI.05102607.png",
    "l0mDW": "GL.77c983be.png",
    "9j604": "GM.0aaf19ba.png",
    "kXgc5": "GN.60eb7cdf.png",
    "8S7hR": "GP.aa005431.png",
    "67Knh": "GQ.d30ce4a6.png",
    "6jlxQ": "GR.aae1fd33.png",
    "lnIFo": "GS.e967a846.png",
    "iFaAE": "GT.4e9e75c4.png",
    "klvky": "GU.9328e422.png",
    "fD7o0": "GW.291f526b.png",
    "cMnn7": "GY.00f41f52.png",
    "gPybQ": "HK.c153c011.png",
    "hAWb8": "HM.679a4bc5.png",
    "1VkYp": "HN.d3cdcfe4.png",
    "9bQfK": "HR.78e0c99e.png",
    "29yQv": "HT.b691e275.png",
    "4rGKe": "HU.7077c8b2.png",
    "ieQ0i": "ID.af0ee3d9.png",
    "9oVHP": "IE.5e17542f.png",
    "7qvVU": "IL.188e65a5.png",
    "h1kyH": "IM.2ae026b7.png",
    "9mWpC": "IN.f221d77d.png",
    "3wN7h": "IO.db197329.png",
    "lsjY7": "IQ.9eefe437.png",
    "2Bjym": "IR.f151774e.png",
    "hlOhF": "IS.246156b2.png",
    "aSsXd": "IT.54da190b.png",
    "hkdpj": "JE.976288e6.png",
    "5BNjf": "JM.23d68c91.png",
    "36iCf": "JO.5747cc65.png",
    "e2aTv": "JP.843b40b2.png",
    "dUKvn": "KE.7ebe649a.png",
    "ByKTB": "KG.a66d69d7.png",
    "6I7dG": "KH.4a84160c.png",
    "6pRsP": "KI.b8411ec2.png",
    "4iGfM": "KM.e886212f.png",
    "6c867": "KN.7c45d4d4.png",
    "2b8wd": "KP.27d07345.png",
    "esivD": "KR.6d55a388.png",
    "ks62H": "KW.0a0e78a6.png",
    "caJ6T": "KY.8559a191.png",
    "itlCD": "KZ.861219f4.png",
    "hP0q1": "LA.75034bed.png",
    "3umbv": "LB.dc7f4250.png",
    "6pRp1": "LC.ac114ac0.png",
    "hRZdT": "LI.fdbeca65.png",
    "9I6qs": "LK.e68cce44.png",
    "L0jQ7": "LR.6775d12d.png",
    "8Dy2I": "LS.992a05c6.png",
    "iscIN": "LT.2a5898dc.png",
    "N1mjR": "LU.6e631d47.png",
    "3TcxB": "LV.94317c54.png",
    "bDKI6": "LY.919347ac.png",
    "86ZCD": "MA.a01815f8.png",
    "aBIwn": "MC.6f73ef81.png",
    "igVPR": "MD.79dfe74d.png",
    "73bSe": "ME.c496cb0d.png",
    "6D1e0": "MF.528abdf5.png",
    "9Ql4j": "MG.b55ed075.png",
    "9G7fH": "MH.ed02d71d.png",
    "6lIzW": "MK.9e5e2e95.png",
    "8Bodz": "ML.1ade5e3a.png",
    "56EY7": "MM.d44f8f8e.png",
    "2AAVX": "MN.3e2b08d2.png",
    "ezVoH": "MO.3a267897.png",
    "jUaYe": "MP.b4d87aa4.png",
    "8e7Qm": "MQ.42df91e1.png",
    "gn89Z": "MR.3e48dea7.png",
    "2Gas0": "MS.ca73e819.png",
    "lfFT2": "MT.5f4098a9.png",
    "gHrei": "MU.e4fe6b73.png",
    "jRAQJ": "MV.e1015531.png",
    "9v13L": "MW.ac31b96a.png",
    "4O4c1": "MX.0baae8f1.png",
    "guaCh": "MY.29ed5a2e.png",
    "2E8lM": "MZ.c13f154b.png",
    "jiBf4": "NA.44a89807.png",
    "jE1mH": "NE.45670a98.png",
    "f0Lze": "NF.1dac66f1.png",
    "1V1VE": "NG.53788153.png",
    "gskQE": "NI.2e0b870d.png",
    "9dP3I": "NL.3f23b29d.png",
    "ldJqc": "NO.71330d38.png",
    "2LXnT": "NP.3809d228.png",
    "jxZwt": "NR.bac2eeca.png",
    "28Qox": "NU.cb716b3f.png",
    "7n942": "NZ.9e9145ca.png",
    "cIqTD": "OM.d996e31b.png",
    "falUL": "PA.1779943f.png",
    "bZ6PP": "PE.3dab8750.png",
    "jEixm": "PF.4ae181ae.png",
    "3qGOh": "PG.5d496fdd.png",
    "gb6k3": "PH.9e34818f.png",
    "6wRBG": "PK.76988a49.png",
    "5Ops4": "PL.6feac01e.png",
    "k9EiL": "PM.0565e181.png",
    "kebU8": "PN.e402b7db.png",
    "PlJ64": "PR.2c8a21e2.png",
    "48udl": "PS.f8d93b85.png",
    "g192A": "PT.3d245190.png",
    "4Zflc": "PW.c4402f9c.png",
    "emaIm": "PY.bdad551a.png",
    "bVig0": "QA.625f8f3a.png",
    "aXfSU": "RE.528abdf5.png",
    "9JMUW": "RO.718b325c.png",
    "ceZC3": "RS.46b84140.png",
    "kDOgw": "RU.88254a2f.png",
    "3gpFX": "RW.5cfb588c.png",
    "amWek": "SA.945a2e61.png",
    "3rOkD": "SB.a17c02bb.png",
    "e6Don": "SC.b0fe68f5.png",
    "4cHXl": "SD.6f9a5836.png",
    "9YXZX": "SE.c8c706c1.png",
    "hi4IO": "SG.68a62334.png",
    "4XLXk": "SH.c5a264dd.png",
    "e7Dwb": "SI.988478dc.png",
    "h8qCe": "SJ.71330d38.png",
    "e4EoP": "SK.31899a6a.png",
    "kMWH7": "SL.84a713ce.png",
    "ccR4g": "SM.ed7dc2ab.png",
    "cyYJI": "SN.dd3c3ff2.png",
    "8eOtJ": "SO.e1373c56.png",
    "fjfjN": "SR.721345a1.png",
    "6Wgpg": "ST.3d0f393d.png",
    "8jsLl": "SS.96783fcb.png",
    "7cf18": "SV.633a6ae3.png",
    "7n0q5": "SX.c4f5316e.png",
    "4VQys": "SY.eddee3dc.png",
    "l85V5": "SZ.3c6991ab.png",
    "kKydj": "TC.35c62102.png",
    "gHh1U": "TD.b9c6885c.png",
    "4Ascn": "TF.4aaa2fbe.png",
    "44SLT": "TG.48be9b91.png",
    "22bff": "TH.4f65ef83.png",
    "kpusj": "TJ.c87561f7.png",
    "hLuMT": "TK.d435174f.png",
    "20xx3": "TL.12fbdcc8.png",
    "7qF4L": "TM.695fb6de.png",
    "hvojs": "TN.ff69172d.png",
    "aeCnf": "TO.655a3239.png",
    "1Arpe": "TR.8a7a7878.png",
    "djMHu": "TT.3975202e.png",
    "7KQDn": "TV.d499a5de.png",
    "haVUR": "TW.05d5c964.png",
    "6RM3x": "TZ.d5301047.png",
    "it5Rc": "UA.e721c0ee.png",
    "6V68w": "UG.2db12c32.png",
    "gGN5R": "UM.f94d59b0.png",
    "daJle": "US.f94d59b0.png",
    "aKJrk": "UY.c7985e9b.png",
    "gzIy3": "UZ.faeb7fea.png",
    "4R6MR": "VA.e1c3488f.png",
    "jarfs": "VC.eabe1856.png",
    "82qsP": "VE.3bd6b95a.png",
    "krSeC": "VG.c3f4aef2.png",
    "gggyT": "VI.0bb0397d.png",
    "7Rkvc": "VN.20b0e5e2.png",
    "1U01U": "VU.f6ec6142.png",
    "i6g3X": "WF.528abdf5.png",
    "gAtFV": "WS.b5578e07.png",
    "7mpBA": "YE.fec088d8.png",
    "buJLm": "YT.4484171e.png",
    "6K339": "ZA.1d0ed95d.png",
    "aWOmG": "ZM.dcb44389.png",
    "hJoyQ": "ZW.504c648f.png",
    "8Cufh": "electricity.78896eb1.png",
    "8jMNf": "water.3784c846.png",
    "1h7Xs": "phone.af39ccfd.png",
    "cRAGd": "tv.abc0bac4.png",
    "jLNJe": "stack.3b5fc6db.png",
    "9BakF": "appstore_icon.c1c48b62.png",
    "9N7c7": "playstore_icon.cb5736e2.png",
    "iOcb5": "big-success.97bf5b23.svg",
    "9vYw3": "register-background.56127503.svg",
    "9m0rr": "connection-background.fcc0bc12.svg",
    "1zVMn": "warning.417cdcd5.svg",
    "kvoZK": "check-circle.c91f5128.svg"
});

/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $1f366887ac3d0e11$var$Reflect;
(function(Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function(factory) {
        var root = typeof $parcel$global === "object" ? $parcel$global : typeof self === "object" ? self : typeof this === "object" ? this : Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") root.Reflect = Reflect;
        else exporter = makeExporter(root.Reflect, exporter);
        factory(exporter);
        function makeExporter(target, previous) {
            return function(key, value) {
                if (typeof target[key] !== "function") Object.defineProperty(target, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                if (previous) previous(key, value);
            };
        }
    })(function(exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = ({
            __proto__: []
        }) instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate ? function() {
                return MakeDictionary(Object.create(null));
            } : supportsProto ? function() {
                return MakeDictionary({
                    __proto__: null
                });
            } : function() {
                return MakeDictionary({});
            },
            has: downLevel ? function(map, key) {
                return hasOwn.call(map, key);
            } : function(map, key) {
                return key in map;
            },
            get: downLevel ? function(map, key) {
                return hasOwn.call(map, key) ? map[key] : undefined;
            } : function(map, key) {
                return map[key];
            }
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = false;
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */ function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsObject(target)) throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes)) throw new TypeError();
                if (IsNull(attributes)) attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            } else {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsConstructor(target)) throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */ function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target)) throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey)) throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */ function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */ function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */ function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap)) return false;
            if (!metadataMap.delete(metadataKey)) return false;
            if (metadataMap.size > 0) return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0) return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated)) throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated)) throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create) return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create) return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null) return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0) return ownKeys;
            if (ownKeys.length <= 0) return parentKeys;
            var set = new _Set();
            var keys = [];
            for(var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++){
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for(var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++){
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while(true){
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                } catch (e) {
                    try {
                        IteratorClose(iterator);
                    } finally{
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null) return 1 /* Null */ ;
            switch(typeof x){
                case "undefined":
                    return 0 /* Undefined */ ;
                case "boolean":
                    return 2 /* Boolean */ ;
                case "string":
                    return 3 /* String */ ;
                case "symbol":
                    return 4 /* Symbol */ ;
                case "number":
                    return 5 /* Number */ ;
                case "object":
                    return x === null ? 1 /* Null */  : 6 /* Object */ ;
                default:
                    return 6 /* Object */ ;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch(Type(input)){
                case 0 /* Undefined */ :
                    return input;
                case 1 /* Null */ :
                    return input;
                case 2 /* Boolean */ :
                    return input;
                case 3 /* String */ :
                    return input;
                case 4 /* Symbol */ :
                    return input;
                case 5 /* Number */ :
                    return input;
            }
            var hint = PreferredType === 3 /* String */  ? "string" : PreferredType === 5 /* Number */  ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result)) throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result)) return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
            } else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result)) return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */ );
            if (IsSymbol(key)) return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch(Type(argument)){
                case 3 /* String */ :
                    return true;
                case 4 /* Symbol */ :
                    return true;
                default:
                    return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null) return undefined;
            if (!IsCallable(func)) throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method)) throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator)) throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f) f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype) return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype) return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype) return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function") return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O) return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ function() {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function() {
                    return this;
                };
                MapIterator.prototype[iteratorSymbol] = function() {
                    return this;
                };
                MapIterator.prototype.next = function() {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        } else this._index++;
                        return {
                            value: result,
                            done: false
                        };
                    }
                    return {
                        value: undefined,
                        done: true
                    };
                };
                MapIterator.prototype.throw = function(error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function(value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return {
                        value: value,
                        done: true
                    };
                };
                return MapIterator;
            }();
            return /** @class */ function() {
                function Map1() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map1.prototype, "size", {
                    get: function() {
                        return this._keys.length;
                    },
                    enumerable: true,
                    configurable: true
                });
                Map1.prototype.has = function(key) {
                    return this._find(key, /*insert*/ false) >= 0;
                };
                Map1.prototype.get = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map1.prototype.set = function(key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map1.prototype.delete = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for(var i = index + 1; i < size; i++){
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map1.prototype.clear = function() {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map1.prototype.keys = function() {
                    return new MapIterator(this._keys, this._values, getKey);
                };
                Map1.prototype.values = function() {
                    return new MapIterator(this._keys, this._values, getValue);
                };
                Map1.prototype.entries = function() {
                    return new MapIterator(this._keys, this._values, getEntry);
                };
                Map1.prototype["@@iterator"] = function() {
                    return this.entries();
                };
                Map1.prototype[iteratorSymbol] = function() {
                    return this.entries();
                };
                Map1.prototype._find = function(key, insert) {
                    if (this._cacheKey !== key) this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map1;
            }();
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [
                    key,
                    value
                ];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ function() {
                function Set1() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set1.prototype, "size", {
                    get: function() {
                        return this._map.size;
                    },
                    enumerable: true,
                    configurable: true
                });
                Set1.prototype.has = function(value) {
                    return this._map.has(value);
                };
                Set1.prototype.add = function(value) {
                    return this._map.set(value, value), this;
                };
                Set1.prototype.delete = function(value) {
                    return this._map.delete(value);
                };
                Set1.prototype.clear = function() {
                    this._map.clear();
                };
                Set1.prototype.keys = function() {
                    return this._map.keys();
                };
                Set1.prototype.values = function() {
                    return this._map.values();
                };
                Set1.prototype.entries = function() {
                    return this._map.entries();
                };
                Set1.prototype["@@iterator"] = function() {
                    return this.keys();
                };
                Set1.prototype[iteratorSymbol] = function() {
                    return this.keys();
                };
                return Set1;
            }();
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ function() {
                function WeakMap1() {
                    this._key = CreateUniqueKey();
                }
                WeakMap1.prototype.has = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap1.prototype.get = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap1.prototype.set = function(target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap1.prototype.delete = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap1.prototype.clear = function() {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap1;
            }();
            function CreateUniqueKey() {
                var key;
                do key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create) return undefined;
                    Object.defineProperty(target, rootKey, {
                        value: HashMap.create()
                    });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for(var i = 0; i < size; ++i)buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined") return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined") return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for(var offset = 0; offset < UUID_SIZE; ++offset){
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8) result += "-";
                    if (byte < 16) result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})($1f366887ac3d0e11$var$Reflect || ($1f366887ac3d0e11$var$Reflect = {}));



var $6uYXW = parcelRequire("6uYXW");
var $b77ba2fb0905f4fb$exports = {};
'use strict';
function $b77ba2fb0905f4fb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b77ba2fb0905f4fb$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b77ba2fb0905f4fb$var$checkDCE();

$b77ba2fb0905f4fb$exports = (parcelRequire("eVlbW"));



var $dhPTb = parcelRequire("dhPTb");
const $be2dedc2d933219e$var$rootElement = document.getElementById("main");

fetch("/static/config.json").then((response)=>{
    response.json().then((externalConfiguration)=>{
        (0, $dhPTb.setConfiguration)(externalConfiguration);
        document.title = externalConfiguration.WEB_CLIENT_TITLE ?? "M-Wallet";
        const root = (0, (/*@__PURE__*/$parcel$interopDefault($b77ba2fb0905f4fb$exports))).createRoot($be2dedc2d933219e$var$rootElement);
        root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((parcelRequire("im1V7")).App));
    });
}).catch((e)=>{
    console.error("Could not load config.json. App can't start", e);
});


//# sourceMappingURL=web.077c466f.js.map
